
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3RvBt", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $2cfed61cf8550ebb$export$6503ec6e8aabbaf; }, function (v) { return $2cfed61cf8550ebb$export$6503ec6e8aabbaf = v; });
var $2cfed61cf8550ebb$export$6503ec6e8aabbaf;
var $2cfed61cf8550ebb$export$f7ad0328861e2f03;
"use strict";
var $2cfed61cf8550ebb$var$mapping = new Map();
function $2cfed61cf8550ebb$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$2cfed61cf8550ebb$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $2cfed61cf8550ebb$var$resolve(id) {
    var resolved = $2cfed61cf8550ebb$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$2cfed61cf8550ebb$export$6503ec6e8aabbaf = $2cfed61cf8550ebb$var$register;
$2cfed61cf8550ebb$export$f7ad0328861e2f03 = $2cfed61cf8550ebb$var$resolve;

});

parcelRegister("jXVM0", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $e89057971be261ca$export$ffb0004e005737fa; }, function (v) { return $e89057971be261ca$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $e89057971be261ca$export$34b9dba7ce09269b; }, function (v) { return $e89057971be261ca$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $e89057971be261ca$export$25062201e9e25d76; }, function (v) { return $e89057971be261ca$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e89057971be261ca$export$ffb0004e005737fa;
var $e89057971be261ca$export$34b9dba7ce09269b;
var $e89057971be261ca$export$25062201e9e25d76;
'use strict';

var $i5lfL = parcelRequire("i5lfL");
var $e89057971be261ca$var$k = Symbol.for("react.element"), $e89057971be261ca$var$l = Symbol.for("react.fragment"), $e89057971be261ca$var$m = Object.prototype.hasOwnProperty, $e89057971be261ca$var$n = $i5lfL.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $e89057971be261ca$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e89057971be261ca$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$e89057971be261ca$var$m.call(a, b) && !$e89057971be261ca$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $e89057971be261ca$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $e89057971be261ca$var$n.current
    };
}
$e89057971be261ca$export$ffb0004e005737fa = $e89057971be261ca$var$l;
$e89057971be261ca$export$34b9dba7ce09269b = $e89057971be261ca$var$q;
$e89057971be261ca$export$25062201e9e25d76 = $e89057971be261ca$var$q;

});
parcelRegister("i5lfL", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aSNiV"));

});
parcelRegister("aSNiV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $7ec5315825622259$export$dca3b0875bd9a954; }, function (v) { return $7ec5315825622259$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $7ec5315825622259$export$16fa2f45be04daa8; }, function (v) { return $7ec5315825622259$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $7ec5315825622259$export$ffb0004e005737fa; }, function (v) { return $7ec5315825622259$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $7ec5315825622259$export$e2c29f18771995cb; }, function (v) { return $7ec5315825622259$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $7ec5315825622259$export$221d75b3f55bb0bd; }, function (v) { return $7ec5315825622259$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $7ec5315825622259$export$5f8d39834fd61797; }, function (v) { return $7ec5315825622259$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $7ec5315825622259$export$74bf444e3cd11ea5; }, function (v) { return $7ec5315825622259$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $7ec5315825622259$export$ae55be85d98224ed; }, function (v) { return $7ec5315825622259$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $7ec5315825622259$export$3ba232387fd5d6dd; }, function (v) { return $7ec5315825622259$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $7ec5315825622259$export$e530037191fcd5d7; }, function (v) { return $7ec5315825622259$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $7ec5315825622259$export$fd42f52fd3ae1109; }, function (v) { return $7ec5315825622259$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $7ec5315825622259$export$c8a8987d4410bf2d; }, function (v) { return $7ec5315825622259$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $7ec5315825622259$export$d38cd72104c1f0e9; }, function (v) { return $7ec5315825622259$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $7ec5315825622259$export$7d1e3a5e95ceca43; }, function (v) { return $7ec5315825622259$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $7ec5315825622259$export$257a8862b851cb5b; }, function (v) { return $7ec5315825622259$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $7ec5315825622259$export$a8257692ac88316c; }, function (v) { return $7ec5315825622259$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $7ec5315825622259$export$488013bae63b21da; }, function (v) { return $7ec5315825622259$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $7ec5315825622259$export$7c73462e0d25e514; }, function (v) { return $7ec5315825622259$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $7ec5315825622259$export$7568632d0d33d16d; }, function (v) { return $7ec5315825622259$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $7ec5315825622259$export$88948ce120ea2619; }, function (v) { return $7ec5315825622259$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $7ec5315825622259$export$35808ee640e87ca7; }, function (v) { return $7ec5315825622259$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $7ec5315825622259$export$fae74005e78b1a27; }, function (v) { return $7ec5315825622259$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $7ec5315825622259$export$dc8fbce3eb94dc1e; }, function (v) { return $7ec5315825622259$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $7ec5315825622259$export$6a7bc4e911dc01cf; }, function (v) { return $7ec5315825622259$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $7ec5315825622259$export$6d9c69b0de29b591; }, function (v) { return $7ec5315825622259$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $7ec5315825622259$export$f680877a34711e37; }, function (v) { return $7ec5315825622259$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $7ec5315825622259$export$d5a552a76deda3c2; }, function (v) { return $7ec5315825622259$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $7ec5315825622259$export$aaabe4eda9ed9969; }, function (v) { return $7ec5315825622259$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $7ec5315825622259$export$e5c5a5f917a5871c; }, function (v) { return $7ec5315825622259$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $7ec5315825622259$export$1538c33de8887b59; }, function (v) { return $7ec5315825622259$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $7ec5315825622259$export$13e3392192263954; }, function (v) { return $7ec5315825622259$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $7ec5315825622259$export$b8f5890fc79d6aca; }, function (v) { return $7ec5315825622259$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $7ec5315825622259$export$60241385465d0a34; }, function (v) { return $7ec5315825622259$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $7ec5315825622259$export$306c0aa65ff9ec16; }, function (v) { return $7ec5315825622259$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $7ec5315825622259$export$7b286972b8d8ccbf; }, function (v) { return $7ec5315825622259$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $7ec5315825622259$export$83d89fbfd8236492; }, function (v) { return $7ec5315825622259$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7ec5315825622259$export$dca3b0875bd9a954;
var $7ec5315825622259$export$16fa2f45be04daa8;
var $7ec5315825622259$export$ffb0004e005737fa;
var $7ec5315825622259$export$e2c29f18771995cb;
var $7ec5315825622259$export$221d75b3f55bb0bd;
var $7ec5315825622259$export$5f8d39834fd61797;
var $7ec5315825622259$export$74bf444e3cd11ea5;
var $7ec5315825622259$export$ae55be85d98224ed;
var $7ec5315825622259$export$3ba232387fd5d6dd;
var $7ec5315825622259$export$e530037191fcd5d7;
var $7ec5315825622259$export$fd42f52fd3ae1109;
var $7ec5315825622259$export$c8a8987d4410bf2d;
var $7ec5315825622259$export$d38cd72104c1f0e9;
var $7ec5315825622259$export$7d1e3a5e95ceca43;
var $7ec5315825622259$export$257a8862b851cb5b;
var $7ec5315825622259$export$a8257692ac88316c;
var $7ec5315825622259$export$488013bae63b21da;
var $7ec5315825622259$export$7c73462e0d25e514;
var $7ec5315825622259$export$7568632d0d33d16d;
var $7ec5315825622259$export$88948ce120ea2619;
var $7ec5315825622259$export$35808ee640e87ca7;
var $7ec5315825622259$export$fae74005e78b1a27;
var $7ec5315825622259$export$dc8fbce3eb94dc1e;
var $7ec5315825622259$export$6a7bc4e911dc01cf;
var $7ec5315825622259$export$6d9c69b0de29b591;
var $7ec5315825622259$export$f680877a34711e37;
var $7ec5315825622259$export$d5a552a76deda3c2;
var $7ec5315825622259$export$aaabe4eda9ed9969;
var $7ec5315825622259$export$e5c5a5f917a5871c;
var $7ec5315825622259$export$1538c33de8887b59;
var $7ec5315825622259$export$13e3392192263954;
var $7ec5315825622259$export$b8f5890fc79d6aca;
var $7ec5315825622259$export$60241385465d0a34;
var $7ec5315825622259$export$306c0aa65ff9ec16;
var $7ec5315825622259$export$7b286972b8d8ccbf;
var $7ec5315825622259$export$83d89fbfd8236492;
'use strict';
var $7ec5315825622259$var$l = Symbol.for("react.element"), $7ec5315825622259$var$n = Symbol.for("react.portal"), $7ec5315825622259$var$p = Symbol.for("react.fragment"), $7ec5315825622259$var$q = Symbol.for("react.strict_mode"), $7ec5315825622259$var$r = Symbol.for("react.profiler"), $7ec5315825622259$var$t = Symbol.for("react.provider"), $7ec5315825622259$var$u = Symbol.for("react.context"), $7ec5315825622259$var$v = Symbol.for("react.forward_ref"), $7ec5315825622259$var$w = Symbol.for("react.suspense"), $7ec5315825622259$var$x = Symbol.for("react.memo"), $7ec5315825622259$var$y = Symbol.for("react.lazy"), $7ec5315825622259$var$z = Symbol.iterator;
function $7ec5315825622259$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $7ec5315825622259$var$z && a[$7ec5315825622259$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $7ec5315825622259$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $7ec5315825622259$var$C = Object.assign, $7ec5315825622259$var$D = {};
function $7ec5315825622259$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7ec5315825622259$var$D;
    this.updater = e || $7ec5315825622259$var$B;
}
$7ec5315825622259$var$E.prototype.isReactComponent = {};
$7ec5315825622259$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$7ec5315825622259$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $7ec5315825622259$var$F() {}
$7ec5315825622259$var$F.prototype = $7ec5315825622259$var$E.prototype;
function $7ec5315825622259$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7ec5315825622259$var$D;
    this.updater = e || $7ec5315825622259$var$B;
}
var $7ec5315825622259$var$H = $7ec5315825622259$var$G.prototype = new $7ec5315825622259$var$F;
$7ec5315825622259$var$H.constructor = $7ec5315825622259$var$G;
$7ec5315825622259$var$C($7ec5315825622259$var$H, $7ec5315825622259$var$E.prototype);
$7ec5315825622259$var$H.isPureReactComponent = !0;
var $7ec5315825622259$var$I = Array.isArray, $7ec5315825622259$var$J = Object.prototype.hasOwnProperty, $7ec5315825622259$var$K = {
    current: null
}, $7ec5315825622259$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7ec5315825622259$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$7ec5315825622259$var$J.call(b, d) && !$7ec5315825622259$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $7ec5315825622259$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $7ec5315825622259$var$K.current
    };
}
function $7ec5315825622259$var$N(a, b) {
    return {
        $$typeof: $7ec5315825622259$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $7ec5315825622259$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7ec5315825622259$var$l;
}
function $7ec5315825622259$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $7ec5315825622259$var$P = /\/+/g;
function $7ec5315825622259$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $7ec5315825622259$var$escape("" + a.key) : b.toString(36);
}
function $7ec5315825622259$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $7ec5315825622259$var$l:
                case $7ec5315825622259$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $7ec5315825622259$var$Q(h, 0) : d, $7ec5315825622259$var$I(c) ? (e = "", null != a && (e = a.replace($7ec5315825622259$var$P, "$&/") + "/"), $7ec5315825622259$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($7ec5315825622259$var$O(c) && (c = $7ec5315825622259$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($7ec5315825622259$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($7ec5315825622259$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $7ec5315825622259$var$Q(k, g);
        h += $7ec5315825622259$var$R(k, b, e, f, c);
    }
    else if (f = $7ec5315825622259$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $7ec5315825622259$var$Q(k, g++), h += $7ec5315825622259$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $7ec5315825622259$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $7ec5315825622259$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $7ec5315825622259$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $7ec5315825622259$var$U = {
    current: null
}, $7ec5315825622259$var$V = {
    transition: null
}, $7ec5315825622259$var$W = {
    ReactCurrentDispatcher: $7ec5315825622259$var$U,
    ReactCurrentBatchConfig: $7ec5315825622259$var$V,
    ReactCurrentOwner: $7ec5315825622259$var$K
};
function $7ec5315825622259$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$7ec5315825622259$export$dca3b0875bd9a954 = {
    map: $7ec5315825622259$var$S,
    forEach: function(a, b, e) {
        $7ec5315825622259$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $7ec5315825622259$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $7ec5315825622259$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$7ec5315825622259$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$7ec5315825622259$export$16fa2f45be04daa8 = $7ec5315825622259$var$E;
$7ec5315825622259$export$ffb0004e005737fa = $7ec5315825622259$var$p;
$7ec5315825622259$export$e2c29f18771995cb = $7ec5315825622259$var$r;
$7ec5315825622259$export$221d75b3f55bb0bd = $7ec5315825622259$var$G;
$7ec5315825622259$export$5f8d39834fd61797 = $7ec5315825622259$var$q;
$7ec5315825622259$export$74bf444e3cd11ea5 = $7ec5315825622259$var$w;
$7ec5315825622259$export$ae55be85d98224ed = $7ec5315825622259$var$W;
$7ec5315825622259$export$3ba232387fd5d6dd = $7ec5315825622259$var$X;
$7ec5315825622259$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $7ec5315825622259$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $7ec5315825622259$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$7ec5315825622259$var$J.call(b, f) && !$7ec5315825622259$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $7ec5315825622259$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$7ec5315825622259$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $7ec5315825622259$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $7ec5315825622259$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$7ec5315825622259$export$c8a8987d4410bf2d = $7ec5315825622259$var$M;
$7ec5315825622259$export$d38cd72104c1f0e9 = function(a) {
    var b = $7ec5315825622259$var$M.bind(null, a);
    b.type = a;
    return b;
};
$7ec5315825622259$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$7ec5315825622259$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $7ec5315825622259$var$v,
        render: a
    };
};
$7ec5315825622259$export$a8257692ac88316c = $7ec5315825622259$var$O;
$7ec5315825622259$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $7ec5315825622259$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $7ec5315825622259$var$T
    };
};
$7ec5315825622259$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $7ec5315825622259$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$7ec5315825622259$export$7568632d0d33d16d = function(a) {
    var b = $7ec5315825622259$var$V.transition;
    $7ec5315825622259$var$V.transition = {};
    try {
        a();
    } finally{
        $7ec5315825622259$var$V.transition = b;
    }
};
$7ec5315825622259$export$88948ce120ea2619 = $7ec5315825622259$var$X;
$7ec5315825622259$export$35808ee640e87ca7 = function(a, b) {
    return $7ec5315825622259$var$U.current.useCallback(a, b);
};
$7ec5315825622259$export$fae74005e78b1a27 = function(a) {
    return $7ec5315825622259$var$U.current.useContext(a);
};
$7ec5315825622259$export$dc8fbce3eb94dc1e = function() {};
$7ec5315825622259$export$6a7bc4e911dc01cf = function(a) {
    return $7ec5315825622259$var$U.current.useDeferredValue(a);
};
$7ec5315825622259$export$6d9c69b0de29b591 = function(a, b) {
    return $7ec5315825622259$var$U.current.useEffect(a, b);
};
$7ec5315825622259$export$f680877a34711e37 = function() {
    return $7ec5315825622259$var$U.current.useId();
};
$7ec5315825622259$export$d5a552a76deda3c2 = function(a, b, e) {
    return $7ec5315825622259$var$U.current.useImperativeHandle(a, b, e);
};
$7ec5315825622259$export$aaabe4eda9ed9969 = function(a, b) {
    return $7ec5315825622259$var$U.current.useInsertionEffect(a, b);
};
$7ec5315825622259$export$e5c5a5f917a5871c = function(a, b) {
    return $7ec5315825622259$var$U.current.useLayoutEffect(a, b);
};
$7ec5315825622259$export$1538c33de8887b59 = function(a, b) {
    return $7ec5315825622259$var$U.current.useMemo(a, b);
};
$7ec5315825622259$export$13e3392192263954 = function(a, b, e) {
    return $7ec5315825622259$var$U.current.useReducer(a, b, e);
};
$7ec5315825622259$export$b8f5890fc79d6aca = function(a) {
    return $7ec5315825622259$var$U.current.useRef(a);
};
$7ec5315825622259$export$60241385465d0a34 = function(a) {
    return $7ec5315825622259$var$U.current.useState(a);
};
$7ec5315825622259$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $7ec5315825622259$var$U.current.useSyncExternalStore(a, b, e);
};
$7ec5315825622259$export$7b286972b8d8ccbf = function() {
    return $7ec5315825622259$var$U.current.useTransition();
};
$7ec5315825622259$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("cCkFt", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f910dc4e908871$export$ae55be85d98224ed; }, function (v) { return $92f910dc4e908871$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $92f910dc4e908871$export$d39a5bbd09211389; }, function (v) { return $92f910dc4e908871$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $92f910dc4e908871$export$882461b6382ed46c; }, function (v) { return $92f910dc4e908871$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $92f910dc4e908871$export$466bfc07425424d5; }, function (v) { return $92f910dc4e908871$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $92f910dc4e908871$export$cd75ccfd720a3cd4; }, function (v) { return $92f910dc4e908871$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $92f910dc4e908871$export$fa8d919ba61d84db; }, function (v) { return $92f910dc4e908871$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $92f910dc4e908871$export$757ceba2d55c277e; }, function (v) { return $92f910dc4e908871$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $92f910dc4e908871$export$b3890eb0ae9dca99; }, function (v) { return $92f910dc4e908871$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $92f910dc4e908871$export$502457920280e6be; }, function (v) { return $92f910dc4e908871$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $92f910dc4e908871$export$c78a37762a8d58e1; }, function (v) { return $92f910dc4e908871$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $92f910dc4e908871$export$dc54d992c10e8a18; }, function (v) { return $92f910dc4e908871$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $92f910dc4e908871$export$83d89fbfd8236492; }, function (v) { return $92f910dc4e908871$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $92f910dc4e908871$export$ae55be85d98224ed;
var $92f910dc4e908871$export$d39a5bbd09211389;
var $92f910dc4e908871$export$882461b6382ed46c;
var $92f910dc4e908871$export$466bfc07425424d5;
var $92f910dc4e908871$export$cd75ccfd720a3cd4;
var $92f910dc4e908871$export$fa8d919ba61d84db;
var $92f910dc4e908871$export$757ceba2d55c277e;
var $92f910dc4e908871$export$b3890eb0ae9dca99;
var $92f910dc4e908871$export$502457920280e6be;
var $92f910dc4e908871$export$c78a37762a8d58e1;
var $92f910dc4e908871$export$dc54d992c10e8a18;
var $92f910dc4e908871$export$83d89fbfd8236492;
'use strict';

var $i5lfL = parcelRequire("i5lfL");

var $lh787 = parcelRequire("lh787");
function $92f910dc4e908871$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $92f910dc4e908871$var$da = new Set, $92f910dc4e908871$var$ea = {};
function $92f910dc4e908871$var$fa(a, b) {
    $92f910dc4e908871$var$ha(a, b);
    $92f910dc4e908871$var$ha(a + "Capture", b);
}
function $92f910dc4e908871$var$ha(a, b) {
    $92f910dc4e908871$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$92f910dc4e908871$var$da.add(b[a]);
}
var $92f910dc4e908871$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $92f910dc4e908871$var$ja = Object.prototype.hasOwnProperty, $92f910dc4e908871$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $92f910dc4e908871$var$la = {}, $92f910dc4e908871$var$ma = {};
function $92f910dc4e908871$var$oa(a) {
    if ($92f910dc4e908871$var$ja.call($92f910dc4e908871$var$ma, a)) return !0;
    if ($92f910dc4e908871$var$ja.call($92f910dc4e908871$var$la, a)) return !1;
    if ($92f910dc4e908871$var$ka.test(a)) return $92f910dc4e908871$var$ma[a] = !0;
    $92f910dc4e908871$var$la[a] = !0;
    return !1;
}
function $92f910dc4e908871$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $92f910dc4e908871$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $92f910dc4e908871$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $92f910dc4e908871$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $92f910dc4e908871$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $92f910dc4e908871$var$z[a] = new $92f910dc4e908871$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $92f910dc4e908871$var$z[b] = new $92f910dc4e908871$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $92f910dc4e908871$var$z[a] = new $92f910dc4e908871$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $92f910dc4e908871$var$z[a] = new $92f910dc4e908871$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $92f910dc4e908871$var$z[a] = new $92f910dc4e908871$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $92f910dc4e908871$var$z[a] = new $92f910dc4e908871$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $92f910dc4e908871$var$z[a] = new $92f910dc4e908871$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $92f910dc4e908871$var$z[a] = new $92f910dc4e908871$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $92f910dc4e908871$var$z[a] = new $92f910dc4e908871$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $92f910dc4e908871$var$ra = /[\-:]([a-z])/g;
function $92f910dc4e908871$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($92f910dc4e908871$var$ra, $92f910dc4e908871$var$sa);
    $92f910dc4e908871$var$z[b] = new $92f910dc4e908871$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($92f910dc4e908871$var$ra, $92f910dc4e908871$var$sa);
    $92f910dc4e908871$var$z[b] = new $92f910dc4e908871$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($92f910dc4e908871$var$ra, $92f910dc4e908871$var$sa);
    $92f910dc4e908871$var$z[b] = new $92f910dc4e908871$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $92f910dc4e908871$var$z[a] = new $92f910dc4e908871$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$92f910dc4e908871$var$z.xlinkHref = new $92f910dc4e908871$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $92f910dc4e908871$var$z[a] = new $92f910dc4e908871$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $92f910dc4e908871$var$ta(a, b, c, d) {
    var e = $92f910dc4e908871$var$z.hasOwnProperty(b) ? $92f910dc4e908871$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $92f910dc4e908871$var$qa(b, c, e, d) && (c = null), d || null === e ? $92f910dc4e908871$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $92f910dc4e908871$var$ua = $i5lfL.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $92f910dc4e908871$var$va = Symbol.for("react.element"), $92f910dc4e908871$var$wa = Symbol.for("react.portal"), $92f910dc4e908871$var$ya = Symbol.for("react.fragment"), $92f910dc4e908871$var$za = Symbol.for("react.strict_mode"), $92f910dc4e908871$var$Aa = Symbol.for("react.profiler"), $92f910dc4e908871$var$Ba = Symbol.for("react.provider"), $92f910dc4e908871$var$Ca = Symbol.for("react.context"), $92f910dc4e908871$var$Da = Symbol.for("react.forward_ref"), $92f910dc4e908871$var$Ea = Symbol.for("react.suspense"), $92f910dc4e908871$var$Fa = Symbol.for("react.suspense_list"), $92f910dc4e908871$var$Ga = Symbol.for("react.memo"), $92f910dc4e908871$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $92f910dc4e908871$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $92f910dc4e908871$var$Ja = Symbol.iterator;
function $92f910dc4e908871$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f910dc4e908871$var$Ja && a[$92f910dc4e908871$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f910dc4e908871$var$A = Object.assign, $92f910dc4e908871$var$La;
function $92f910dc4e908871$var$Ma(a) {
    if (void 0 === $92f910dc4e908871$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $92f910dc4e908871$var$La = b && b[1] || "";
    }
    return "\n" + $92f910dc4e908871$var$La + a;
}
var $92f910dc4e908871$var$Na = !1;
function $92f910dc4e908871$var$Oa(a, b) {
    if (!a || $92f910dc4e908871$var$Na) return "";
    $92f910dc4e908871$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $92f910dc4e908871$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $92f910dc4e908871$var$Ma(a) : "";
}
function $92f910dc4e908871$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $92f910dc4e908871$var$Ma(a.type);
        case 16:
            return $92f910dc4e908871$var$Ma("Lazy");
        case 13:
            return $92f910dc4e908871$var$Ma("Suspense");
        case 19:
            return $92f910dc4e908871$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $92f910dc4e908871$var$Oa(a.type, !1), a;
        case 11:
            return a = $92f910dc4e908871$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $92f910dc4e908871$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $92f910dc4e908871$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $92f910dc4e908871$var$ya:
            return "Fragment";
        case $92f910dc4e908871$var$wa:
            return "Portal";
        case $92f910dc4e908871$var$Aa:
            return "Profiler";
        case $92f910dc4e908871$var$za:
            return "StrictMode";
        case $92f910dc4e908871$var$Ea:
            return "Suspense";
        case $92f910dc4e908871$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $92f910dc4e908871$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $92f910dc4e908871$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $92f910dc4e908871$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $92f910dc4e908871$var$Ga:
            return b = a.displayName || null, null !== b ? b : $92f910dc4e908871$var$Qa(a.type) || "Memo";
        case $92f910dc4e908871$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $92f910dc4e908871$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $92f910dc4e908871$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $92f910dc4e908871$var$Qa(b);
        case 8:
            return b === $92f910dc4e908871$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $92f910dc4e908871$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $92f910dc4e908871$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $92f910dc4e908871$var$Ua(a) {
    var b = $92f910dc4e908871$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $92f910dc4e908871$var$Va(a) {
    a._valueTracker || (a._valueTracker = $92f910dc4e908871$var$Ua(a));
}
function $92f910dc4e908871$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $92f910dc4e908871$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $92f910dc4e908871$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $92f910dc4e908871$var$Ya(a, b) {
    var c = b.checked;
    return $92f910dc4e908871$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $92f910dc4e908871$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $92f910dc4e908871$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $92f910dc4e908871$var$ab(a, b) {
    b = b.checked;
    null != b && $92f910dc4e908871$var$ta(a, "checked", b, !1);
}
function $92f910dc4e908871$var$bb(a, b) {
    $92f910dc4e908871$var$ab(a, b);
    var c = $92f910dc4e908871$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $92f910dc4e908871$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $92f910dc4e908871$var$cb(a, b.type, $92f910dc4e908871$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $92f910dc4e908871$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $92f910dc4e908871$var$cb(a, b, c) {
    if ("number" !== b || $92f910dc4e908871$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $92f910dc4e908871$var$eb = Array.isArray;
function $92f910dc4e908871$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $92f910dc4e908871$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $92f910dc4e908871$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($92f910dc4e908871$var$p(91));
    return $92f910dc4e908871$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $92f910dc4e908871$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($92f910dc4e908871$var$p(92));
            if ($92f910dc4e908871$var$eb(c)) {
                if (1 < c.length) throw Error($92f910dc4e908871$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $92f910dc4e908871$var$Sa(c)
    };
}
function $92f910dc4e908871$var$ib(a, b) {
    var c = $92f910dc4e908871$var$Sa(b.value), d = $92f910dc4e908871$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $92f910dc4e908871$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $92f910dc4e908871$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $92f910dc4e908871$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $92f910dc4e908871$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $92f910dc4e908871$var$mb, $92f910dc4e908871$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $92f910dc4e908871$var$mb = $92f910dc4e908871$var$mb || document.createElement("div");
        $92f910dc4e908871$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $92f910dc4e908871$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $92f910dc4e908871$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $92f910dc4e908871$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $92f910dc4e908871$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($92f910dc4e908871$var$pb).forEach(function(a) {
    $92f910dc4e908871$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $92f910dc4e908871$var$pb[b] = $92f910dc4e908871$var$pb[a];
    });
});
function $92f910dc4e908871$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $92f910dc4e908871$var$pb.hasOwnProperty(a) && $92f910dc4e908871$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $92f910dc4e908871$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $92f910dc4e908871$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $92f910dc4e908871$var$tb = $92f910dc4e908871$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $92f910dc4e908871$var$ub(a, b) {
    if (b) {
        if ($92f910dc4e908871$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($92f910dc4e908871$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($92f910dc4e908871$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($92f910dc4e908871$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($92f910dc4e908871$var$p(62));
    }
}
function $92f910dc4e908871$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $92f910dc4e908871$var$wb = null;
function $92f910dc4e908871$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $92f910dc4e908871$var$yb = null, $92f910dc4e908871$var$zb = null, $92f910dc4e908871$var$Ab = null;
function $92f910dc4e908871$var$Bb(a) {
    if (a = $92f910dc4e908871$var$Cb(a)) {
        if ("function" !== typeof $92f910dc4e908871$var$yb) throw Error($92f910dc4e908871$var$p(280));
        var b = a.stateNode;
        b && (b = $92f910dc4e908871$var$Db(b), $92f910dc4e908871$var$yb(a.stateNode, a.type, b));
    }
}
function $92f910dc4e908871$var$Eb(a) {
    $92f910dc4e908871$var$zb ? $92f910dc4e908871$var$Ab ? $92f910dc4e908871$var$Ab.push(a) : $92f910dc4e908871$var$Ab = [
        a
    ] : $92f910dc4e908871$var$zb = a;
}
function $92f910dc4e908871$var$Fb() {
    if ($92f910dc4e908871$var$zb) {
        var a = $92f910dc4e908871$var$zb, b = $92f910dc4e908871$var$Ab;
        $92f910dc4e908871$var$Ab = $92f910dc4e908871$var$zb = null;
        $92f910dc4e908871$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$92f910dc4e908871$var$Bb(b[a]);
    }
}
function $92f910dc4e908871$var$Gb(a, b) {
    return a(b);
}
function $92f910dc4e908871$var$Hb() {}
var $92f910dc4e908871$var$Ib = !1;
function $92f910dc4e908871$var$Jb(a, b, c) {
    if ($92f910dc4e908871$var$Ib) return a(b, c);
    $92f910dc4e908871$var$Ib = !0;
    try {
        return $92f910dc4e908871$var$Gb(a, b, c);
    } finally{
        if ($92f910dc4e908871$var$Ib = !1, null !== $92f910dc4e908871$var$zb || null !== $92f910dc4e908871$var$Ab) $92f910dc4e908871$var$Hb(), $92f910dc4e908871$var$Fb();
    }
}
function $92f910dc4e908871$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $92f910dc4e908871$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($92f910dc4e908871$var$p(231, b, typeof c));
    return c;
}
var $92f910dc4e908871$var$Lb = !1;
if ($92f910dc4e908871$var$ia) try {
    var $92f910dc4e908871$var$Mb = {};
    Object.defineProperty($92f910dc4e908871$var$Mb, "passive", {
        get: function() {
            $92f910dc4e908871$var$Lb = !0;
        }
    });
    window.addEventListener("test", $92f910dc4e908871$var$Mb, $92f910dc4e908871$var$Mb);
    window.removeEventListener("test", $92f910dc4e908871$var$Mb, $92f910dc4e908871$var$Mb);
} catch (a) {
    $92f910dc4e908871$var$Lb = !1;
}
function $92f910dc4e908871$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $92f910dc4e908871$var$Ob = !1, $92f910dc4e908871$var$Pb = null, $92f910dc4e908871$var$Qb = !1, $92f910dc4e908871$var$Rb = null, $92f910dc4e908871$var$Sb = {
    onError: function(a) {
        $92f910dc4e908871$var$Ob = !0;
        $92f910dc4e908871$var$Pb = a;
    }
};
function $92f910dc4e908871$var$Tb(a, b, c, d, e, f, g, h, k) {
    $92f910dc4e908871$var$Ob = !1;
    $92f910dc4e908871$var$Pb = null;
    $92f910dc4e908871$var$Nb.apply($92f910dc4e908871$var$Sb, arguments);
}
function $92f910dc4e908871$var$Ub(a, b, c, d, e, f, g, h, k) {
    $92f910dc4e908871$var$Tb.apply(this, arguments);
    if ($92f910dc4e908871$var$Ob) {
        if ($92f910dc4e908871$var$Ob) {
            var l = $92f910dc4e908871$var$Pb;
            $92f910dc4e908871$var$Ob = !1;
            $92f910dc4e908871$var$Pb = null;
        } else throw Error($92f910dc4e908871$var$p(198));
        $92f910dc4e908871$var$Qb || ($92f910dc4e908871$var$Qb = !0, $92f910dc4e908871$var$Rb = l);
    }
}
function $92f910dc4e908871$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $92f910dc4e908871$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $92f910dc4e908871$var$Xb(a) {
    if ($92f910dc4e908871$var$Vb(a) !== a) throw Error($92f910dc4e908871$var$p(188));
}
function $92f910dc4e908871$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $92f910dc4e908871$var$Vb(a);
        if (null === b) throw Error($92f910dc4e908871$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $92f910dc4e908871$var$Xb(e), a;
                if (f === d) return $92f910dc4e908871$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($92f910dc4e908871$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($92f910dc4e908871$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($92f910dc4e908871$var$p(190));
    }
    if (3 !== c.tag) throw Error($92f910dc4e908871$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $92f910dc4e908871$var$Zb(a) {
    a = $92f910dc4e908871$var$Yb(a);
    return null !== a ? $92f910dc4e908871$var$$b(a) : null;
}
function $92f910dc4e908871$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $92f910dc4e908871$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $92f910dc4e908871$var$ac = $lh787.unstable_scheduleCallback, $92f910dc4e908871$var$bc = $lh787.unstable_cancelCallback, $92f910dc4e908871$var$cc = $lh787.unstable_shouldYield, $92f910dc4e908871$var$dc = $lh787.unstable_requestPaint, $92f910dc4e908871$var$B = $lh787.unstable_now, $92f910dc4e908871$var$ec = $lh787.unstable_getCurrentPriorityLevel, $92f910dc4e908871$var$fc = $lh787.unstable_ImmediatePriority, $92f910dc4e908871$var$gc = $lh787.unstable_UserBlockingPriority, $92f910dc4e908871$var$hc = $lh787.unstable_NormalPriority, $92f910dc4e908871$var$ic = $lh787.unstable_LowPriority, $92f910dc4e908871$var$jc = $lh787.unstable_IdlePriority, $92f910dc4e908871$var$kc = null, $92f910dc4e908871$var$lc = null;
function $92f910dc4e908871$var$mc(a) {
    if ($92f910dc4e908871$var$lc && "function" === typeof $92f910dc4e908871$var$lc.onCommitFiberRoot) try {
        $92f910dc4e908871$var$lc.onCommitFiberRoot($92f910dc4e908871$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $92f910dc4e908871$var$oc = Math.clz32 ? Math.clz32 : $92f910dc4e908871$var$nc, $92f910dc4e908871$var$pc = Math.log, $92f910dc4e908871$var$qc = Math.LN2;
function $92f910dc4e908871$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($92f910dc4e908871$var$pc(a) / $92f910dc4e908871$var$qc | 0) | 0;
}
var $92f910dc4e908871$var$rc = 64, $92f910dc4e908871$var$sc = 4194304;
function $92f910dc4e908871$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $92f910dc4e908871$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $92f910dc4e908871$var$tc(h) : (f &= g, 0 !== f && (d = $92f910dc4e908871$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $92f910dc4e908871$var$tc(g) : 0 !== f && (d = $92f910dc4e908871$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $92f910dc4e908871$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $92f910dc4e908871$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $92f910dc4e908871$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $92f910dc4e908871$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $92f910dc4e908871$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $92f910dc4e908871$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $92f910dc4e908871$var$yc() {
    var a = $92f910dc4e908871$var$rc;
    $92f910dc4e908871$var$rc <<= 1;
    0 === ($92f910dc4e908871$var$rc & 4194240) && ($92f910dc4e908871$var$rc = 64);
    return a;
}
function $92f910dc4e908871$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $92f910dc4e908871$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $92f910dc4e908871$var$oc(b);
    a[b] = c;
}
function $92f910dc4e908871$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $92f910dc4e908871$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $92f910dc4e908871$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $92f910dc4e908871$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $92f910dc4e908871$var$C = 0;
function $92f910dc4e908871$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $92f910dc4e908871$var$Ec, $92f910dc4e908871$var$Fc, $92f910dc4e908871$var$Gc, $92f910dc4e908871$var$Hc, $92f910dc4e908871$var$Ic, $92f910dc4e908871$var$Jc = !1, $92f910dc4e908871$var$Kc = [], $92f910dc4e908871$var$Lc = null, $92f910dc4e908871$var$Mc = null, $92f910dc4e908871$var$Nc = null, $92f910dc4e908871$var$Oc = new Map, $92f910dc4e908871$var$Pc = new Map, $92f910dc4e908871$var$Qc = [], $92f910dc4e908871$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $92f910dc4e908871$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $92f910dc4e908871$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $92f910dc4e908871$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $92f910dc4e908871$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $92f910dc4e908871$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $92f910dc4e908871$var$Pc.delete(b.pointerId);
    }
}
function $92f910dc4e908871$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $92f910dc4e908871$var$Cb(b), null !== b && $92f910dc4e908871$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $92f910dc4e908871$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $92f910dc4e908871$var$Lc = $92f910dc4e908871$var$Tc($92f910dc4e908871$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $92f910dc4e908871$var$Mc = $92f910dc4e908871$var$Tc($92f910dc4e908871$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $92f910dc4e908871$var$Nc = $92f910dc4e908871$var$Tc($92f910dc4e908871$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $92f910dc4e908871$var$Oc.set(f, $92f910dc4e908871$var$Tc($92f910dc4e908871$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $92f910dc4e908871$var$Pc.set(f, $92f910dc4e908871$var$Tc($92f910dc4e908871$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $92f910dc4e908871$var$Vc(a) {
    var b = $92f910dc4e908871$var$Wc(a.target);
    if (null !== b) {
        var c = $92f910dc4e908871$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $92f910dc4e908871$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $92f910dc4e908871$var$Ic(a.priority, function() {
                        $92f910dc4e908871$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $92f910dc4e908871$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $92f910dc4e908871$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $92f910dc4e908871$var$wb = d;
            c.target.dispatchEvent(d);
            $92f910dc4e908871$var$wb = null;
        } else return b = $92f910dc4e908871$var$Cb(c), null !== b && $92f910dc4e908871$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $92f910dc4e908871$var$Zc(a, b, c) {
    $92f910dc4e908871$var$Xc(a) && c.delete(b);
}
function $92f910dc4e908871$var$$c() {
    $92f910dc4e908871$var$Jc = !1;
    null !== $92f910dc4e908871$var$Lc && $92f910dc4e908871$var$Xc($92f910dc4e908871$var$Lc) && ($92f910dc4e908871$var$Lc = null);
    null !== $92f910dc4e908871$var$Mc && $92f910dc4e908871$var$Xc($92f910dc4e908871$var$Mc) && ($92f910dc4e908871$var$Mc = null);
    null !== $92f910dc4e908871$var$Nc && $92f910dc4e908871$var$Xc($92f910dc4e908871$var$Nc) && ($92f910dc4e908871$var$Nc = null);
    $92f910dc4e908871$var$Oc.forEach($92f910dc4e908871$var$Zc);
    $92f910dc4e908871$var$Pc.forEach($92f910dc4e908871$var$Zc);
}
function $92f910dc4e908871$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $92f910dc4e908871$var$Jc || ($92f910dc4e908871$var$Jc = !0, $lh787.unstable_scheduleCallback($lh787.unstable_NormalPriority, $92f910dc4e908871$var$$c)));
}
function $92f910dc4e908871$var$bd(a) {
    function b(b) {
        return $92f910dc4e908871$var$ad(b, a);
    }
    if (0 < $92f910dc4e908871$var$Kc.length) {
        $92f910dc4e908871$var$ad($92f910dc4e908871$var$Kc[0], a);
        for(var c = 1; c < $92f910dc4e908871$var$Kc.length; c++){
            var d = $92f910dc4e908871$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $92f910dc4e908871$var$Lc && $92f910dc4e908871$var$ad($92f910dc4e908871$var$Lc, a);
    null !== $92f910dc4e908871$var$Mc && $92f910dc4e908871$var$ad($92f910dc4e908871$var$Mc, a);
    null !== $92f910dc4e908871$var$Nc && $92f910dc4e908871$var$ad($92f910dc4e908871$var$Nc, a);
    $92f910dc4e908871$var$Oc.forEach(b);
    $92f910dc4e908871$var$Pc.forEach(b);
    for(c = 0; c < $92f910dc4e908871$var$Qc.length; c++)d = $92f910dc4e908871$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $92f910dc4e908871$var$Qc.length && (c = $92f910dc4e908871$var$Qc[0], null === c.blockedOn);)$92f910dc4e908871$var$Vc(c), null === c.blockedOn && $92f910dc4e908871$var$Qc.shift();
}
var $92f910dc4e908871$var$cd = $92f910dc4e908871$var$ua.ReactCurrentBatchConfig, $92f910dc4e908871$var$dd = !0;
function $92f910dc4e908871$var$ed(a, b, c, d) {
    var e = $92f910dc4e908871$var$C, f = $92f910dc4e908871$var$cd.transition;
    $92f910dc4e908871$var$cd.transition = null;
    try {
        $92f910dc4e908871$var$C = 1, $92f910dc4e908871$var$fd(a, b, c, d);
    } finally{
        $92f910dc4e908871$var$C = e, $92f910dc4e908871$var$cd.transition = f;
    }
}
function $92f910dc4e908871$var$gd(a, b, c, d) {
    var e = $92f910dc4e908871$var$C, f = $92f910dc4e908871$var$cd.transition;
    $92f910dc4e908871$var$cd.transition = null;
    try {
        $92f910dc4e908871$var$C = 4, $92f910dc4e908871$var$fd(a, b, c, d);
    } finally{
        $92f910dc4e908871$var$C = e, $92f910dc4e908871$var$cd.transition = f;
    }
}
function $92f910dc4e908871$var$fd(a, b, c, d) {
    if ($92f910dc4e908871$var$dd) {
        var e = $92f910dc4e908871$var$Yc(a, b, c, d);
        if (null === e) $92f910dc4e908871$var$hd(a, b, d, $92f910dc4e908871$var$id, c), $92f910dc4e908871$var$Sc(a, d);
        else if ($92f910dc4e908871$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($92f910dc4e908871$var$Sc(a, d), b & 4 && -1 < $92f910dc4e908871$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $92f910dc4e908871$var$Cb(e);
                null !== f && $92f910dc4e908871$var$Ec(f);
                f = $92f910dc4e908871$var$Yc(a, b, c, d);
                null === f && $92f910dc4e908871$var$hd(a, b, d, $92f910dc4e908871$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $92f910dc4e908871$var$hd(a, b, d, null, c);
    }
}
var $92f910dc4e908871$var$id = null;
function $92f910dc4e908871$var$Yc(a, b, c, d) {
    $92f910dc4e908871$var$id = null;
    a = $92f910dc4e908871$var$xb(d);
    a = $92f910dc4e908871$var$Wc(a);
    if (null !== a) {
        if (b = $92f910dc4e908871$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $92f910dc4e908871$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $92f910dc4e908871$var$id = a;
    return null;
}
function $92f910dc4e908871$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($92f910dc4e908871$var$ec()){
                case $92f910dc4e908871$var$fc:
                    return 1;
                case $92f910dc4e908871$var$gc:
                    return 4;
                case $92f910dc4e908871$var$hc:
                case $92f910dc4e908871$var$ic:
                    return 16;
                case $92f910dc4e908871$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $92f910dc4e908871$var$kd = null, $92f910dc4e908871$var$ld = null, $92f910dc4e908871$var$md = null;
function $92f910dc4e908871$var$nd() {
    if ($92f910dc4e908871$var$md) return $92f910dc4e908871$var$md;
    var a, b = $92f910dc4e908871$var$ld, c = b.length, d, e = "value" in $92f910dc4e908871$var$kd ? $92f910dc4e908871$var$kd.value : $92f910dc4e908871$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $92f910dc4e908871$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $92f910dc4e908871$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $92f910dc4e908871$var$pd() {
    return !0;
}
function $92f910dc4e908871$var$qd() {
    return !1;
}
function $92f910dc4e908871$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $92f910dc4e908871$var$pd : $92f910dc4e908871$var$qd;
        this.isPropagationStopped = $92f910dc4e908871$var$qd;
        return this;
    }
    $92f910dc4e908871$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $92f910dc4e908871$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $92f910dc4e908871$var$pd);
        },
        persist: function() {},
        isPersistent: $92f910dc4e908871$var$pd
    });
    return b;
}
var $92f910dc4e908871$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $92f910dc4e908871$var$td = $92f910dc4e908871$var$rd($92f910dc4e908871$var$sd), $92f910dc4e908871$var$ud = $92f910dc4e908871$var$A({}, $92f910dc4e908871$var$sd, {
    view: 0,
    detail: 0
}), $92f910dc4e908871$var$vd = $92f910dc4e908871$var$rd($92f910dc4e908871$var$ud), $92f910dc4e908871$var$wd, $92f910dc4e908871$var$xd, $92f910dc4e908871$var$yd, $92f910dc4e908871$var$Ad = $92f910dc4e908871$var$A({}, $92f910dc4e908871$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $92f910dc4e908871$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $92f910dc4e908871$var$yd && ($92f910dc4e908871$var$yd && "mousemove" === a.type ? ($92f910dc4e908871$var$wd = a.screenX - $92f910dc4e908871$var$yd.screenX, $92f910dc4e908871$var$xd = a.screenY - $92f910dc4e908871$var$yd.screenY) : $92f910dc4e908871$var$xd = $92f910dc4e908871$var$wd = 0, $92f910dc4e908871$var$yd = a);
        return $92f910dc4e908871$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $92f910dc4e908871$var$xd;
    }
}), $92f910dc4e908871$var$Bd = $92f910dc4e908871$var$rd($92f910dc4e908871$var$Ad), $92f910dc4e908871$var$Cd = $92f910dc4e908871$var$A({}, $92f910dc4e908871$var$Ad, {
    dataTransfer: 0
}), $92f910dc4e908871$var$Dd = $92f910dc4e908871$var$rd($92f910dc4e908871$var$Cd), $92f910dc4e908871$var$Ed = $92f910dc4e908871$var$A({}, $92f910dc4e908871$var$ud, {
    relatedTarget: 0
}), $92f910dc4e908871$var$Fd = $92f910dc4e908871$var$rd($92f910dc4e908871$var$Ed), $92f910dc4e908871$var$Gd = $92f910dc4e908871$var$A({}, $92f910dc4e908871$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $92f910dc4e908871$var$Hd = $92f910dc4e908871$var$rd($92f910dc4e908871$var$Gd), $92f910dc4e908871$var$Id = $92f910dc4e908871$var$A({}, $92f910dc4e908871$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $92f910dc4e908871$var$Jd = $92f910dc4e908871$var$rd($92f910dc4e908871$var$Id), $92f910dc4e908871$var$Kd = $92f910dc4e908871$var$A({}, $92f910dc4e908871$var$sd, {
    data: 0
}), $92f910dc4e908871$var$Ld = $92f910dc4e908871$var$rd($92f910dc4e908871$var$Kd), $92f910dc4e908871$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $92f910dc4e908871$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $92f910dc4e908871$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $92f910dc4e908871$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $92f910dc4e908871$var$Od[a]) ? !!b[a] : !1;
}
function $92f910dc4e908871$var$zd() {
    return $92f910dc4e908871$var$Pd;
}
var $92f910dc4e908871$var$Qd = $92f910dc4e908871$var$A({}, $92f910dc4e908871$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $92f910dc4e908871$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $92f910dc4e908871$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $92f910dc4e908871$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $92f910dc4e908871$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $92f910dc4e908871$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $92f910dc4e908871$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $92f910dc4e908871$var$Rd = $92f910dc4e908871$var$rd($92f910dc4e908871$var$Qd), $92f910dc4e908871$var$Sd = $92f910dc4e908871$var$A({}, $92f910dc4e908871$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $92f910dc4e908871$var$Td = $92f910dc4e908871$var$rd($92f910dc4e908871$var$Sd), $92f910dc4e908871$var$Ud = $92f910dc4e908871$var$A({}, $92f910dc4e908871$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $92f910dc4e908871$var$zd
}), $92f910dc4e908871$var$Vd = $92f910dc4e908871$var$rd($92f910dc4e908871$var$Ud), $92f910dc4e908871$var$Wd = $92f910dc4e908871$var$A({}, $92f910dc4e908871$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $92f910dc4e908871$var$Xd = $92f910dc4e908871$var$rd($92f910dc4e908871$var$Wd), $92f910dc4e908871$var$Yd = $92f910dc4e908871$var$A({}, $92f910dc4e908871$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $92f910dc4e908871$var$Zd = $92f910dc4e908871$var$rd($92f910dc4e908871$var$Yd), $92f910dc4e908871$var$$d = [
    9,
    13,
    27,
    32
], $92f910dc4e908871$var$ae = $92f910dc4e908871$var$ia && "CompositionEvent" in window, $92f910dc4e908871$var$be = null;
$92f910dc4e908871$var$ia && "documentMode" in document && ($92f910dc4e908871$var$be = document.documentMode);
var $92f910dc4e908871$var$ce = $92f910dc4e908871$var$ia && "TextEvent" in window && !$92f910dc4e908871$var$be, $92f910dc4e908871$var$de = $92f910dc4e908871$var$ia && (!$92f910dc4e908871$var$ae || $92f910dc4e908871$var$be && 8 < $92f910dc4e908871$var$be && 11 >= $92f910dc4e908871$var$be), $92f910dc4e908871$var$ee = String.fromCharCode(32), $92f910dc4e908871$var$fe = !1;
function $92f910dc4e908871$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $92f910dc4e908871$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $92f910dc4e908871$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $92f910dc4e908871$var$ie = !1;
function $92f910dc4e908871$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $92f910dc4e908871$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $92f910dc4e908871$var$fe = !0;
            return $92f910dc4e908871$var$ee;
        case "textInput":
            return a = b.data, a === $92f910dc4e908871$var$ee && $92f910dc4e908871$var$fe ? null : a;
        default:
            return null;
    }
}
function $92f910dc4e908871$var$ke(a, b) {
    if ($92f910dc4e908871$var$ie) return "compositionend" === a || !$92f910dc4e908871$var$ae && $92f910dc4e908871$var$ge(a, b) ? (a = $92f910dc4e908871$var$nd(), $92f910dc4e908871$var$md = $92f910dc4e908871$var$ld = $92f910dc4e908871$var$kd = null, $92f910dc4e908871$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $92f910dc4e908871$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $92f910dc4e908871$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $92f910dc4e908871$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$92f910dc4e908871$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $92f910dc4e908871$var$ne(a, b, c, d) {
    $92f910dc4e908871$var$Eb(d);
    b = $92f910dc4e908871$var$oe(b, "onChange");
    0 < b.length && (c = new $92f910dc4e908871$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $92f910dc4e908871$var$pe = null, $92f910dc4e908871$var$qe = null;
function $92f910dc4e908871$var$re(a) {
    $92f910dc4e908871$var$se(a, 0);
}
function $92f910dc4e908871$var$te(a) {
    var b = $92f910dc4e908871$var$ue(a);
    if ($92f910dc4e908871$var$Wa(b)) return a;
}
function $92f910dc4e908871$var$ve(a, b) {
    if ("change" === a) return b;
}
var $92f910dc4e908871$var$we = !1;
if ($92f910dc4e908871$var$ia) {
    var $92f910dc4e908871$var$xe;
    if ($92f910dc4e908871$var$ia) {
        var $92f910dc4e908871$var$ye = "oninput" in document;
        if (!$92f910dc4e908871$var$ye) {
            var $92f910dc4e908871$var$ze = document.createElement("div");
            $92f910dc4e908871$var$ze.setAttribute("oninput", "return;");
            $92f910dc4e908871$var$ye = "function" === typeof $92f910dc4e908871$var$ze.oninput;
        }
        $92f910dc4e908871$var$xe = $92f910dc4e908871$var$ye;
    } else $92f910dc4e908871$var$xe = !1;
    $92f910dc4e908871$var$we = $92f910dc4e908871$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $92f910dc4e908871$var$Ae() {
    $92f910dc4e908871$var$pe && ($92f910dc4e908871$var$pe.detachEvent("onpropertychange", $92f910dc4e908871$var$Be), $92f910dc4e908871$var$qe = $92f910dc4e908871$var$pe = null);
}
function $92f910dc4e908871$var$Be(a) {
    if ("value" === a.propertyName && $92f910dc4e908871$var$te($92f910dc4e908871$var$qe)) {
        var b = [];
        $92f910dc4e908871$var$ne(b, $92f910dc4e908871$var$qe, a, $92f910dc4e908871$var$xb(a));
        $92f910dc4e908871$var$Jb($92f910dc4e908871$var$re, b);
    }
}
function $92f910dc4e908871$var$Ce(a, b, c) {
    "focusin" === a ? ($92f910dc4e908871$var$Ae(), $92f910dc4e908871$var$pe = b, $92f910dc4e908871$var$qe = c, $92f910dc4e908871$var$pe.attachEvent("onpropertychange", $92f910dc4e908871$var$Be)) : "focusout" === a && $92f910dc4e908871$var$Ae();
}
function $92f910dc4e908871$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $92f910dc4e908871$var$te($92f910dc4e908871$var$qe);
}
function $92f910dc4e908871$var$Ee(a, b) {
    if ("click" === a) return $92f910dc4e908871$var$te(b);
}
function $92f910dc4e908871$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $92f910dc4e908871$var$te(b);
}
function $92f910dc4e908871$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $92f910dc4e908871$var$He = "function" === typeof Object.is ? Object.is : $92f910dc4e908871$var$Ge;
function $92f910dc4e908871$var$Ie(a, b) {
    if ($92f910dc4e908871$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$92f910dc4e908871$var$ja.call(b, e) || !$92f910dc4e908871$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $92f910dc4e908871$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $92f910dc4e908871$var$Ke(a, b) {
    var c = $92f910dc4e908871$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $92f910dc4e908871$var$Je(c);
    }
}
function $92f910dc4e908871$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $92f910dc4e908871$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $92f910dc4e908871$var$Me() {
    for(var a = window, b = $92f910dc4e908871$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $92f910dc4e908871$var$Xa(a.document);
    }
    return b;
}
function $92f910dc4e908871$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $92f910dc4e908871$var$Oe(a) {
    var b = $92f910dc4e908871$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $92f910dc4e908871$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $92f910dc4e908871$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $92f910dc4e908871$var$Ke(c, f);
                var g = $92f910dc4e908871$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $92f910dc4e908871$var$Pe = $92f910dc4e908871$var$ia && "documentMode" in document && 11 >= document.documentMode, $92f910dc4e908871$var$Qe = null, $92f910dc4e908871$var$Re = null, $92f910dc4e908871$var$Se = null, $92f910dc4e908871$var$Te = !1;
function $92f910dc4e908871$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $92f910dc4e908871$var$Te || null == $92f910dc4e908871$var$Qe || $92f910dc4e908871$var$Qe !== $92f910dc4e908871$var$Xa(d) || (d = $92f910dc4e908871$var$Qe, "selectionStart" in d && $92f910dc4e908871$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $92f910dc4e908871$var$Se && $92f910dc4e908871$var$Ie($92f910dc4e908871$var$Se, d) || ($92f910dc4e908871$var$Se = d, d = $92f910dc4e908871$var$oe($92f910dc4e908871$var$Re, "onSelect"), 0 < d.length && (b = new $92f910dc4e908871$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $92f910dc4e908871$var$Qe)));
}
function $92f910dc4e908871$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $92f910dc4e908871$var$We = {
    animationend: $92f910dc4e908871$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $92f910dc4e908871$var$Ve("Animation", "AnimationIteration"),
    animationstart: $92f910dc4e908871$var$Ve("Animation", "AnimationStart"),
    transitionend: $92f910dc4e908871$var$Ve("Transition", "TransitionEnd")
}, $92f910dc4e908871$var$Xe = {}, $92f910dc4e908871$var$Ye = {};
$92f910dc4e908871$var$ia && ($92f910dc4e908871$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $92f910dc4e908871$var$We.animationend.animation, delete $92f910dc4e908871$var$We.animationiteration.animation, delete $92f910dc4e908871$var$We.animationstart.animation), "TransitionEvent" in window || delete $92f910dc4e908871$var$We.transitionend.transition);
function $92f910dc4e908871$var$Ze(a) {
    if ($92f910dc4e908871$var$Xe[a]) return $92f910dc4e908871$var$Xe[a];
    if (!$92f910dc4e908871$var$We[a]) return a;
    var b = $92f910dc4e908871$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $92f910dc4e908871$var$Ye) return $92f910dc4e908871$var$Xe[a] = b[c];
    return a;
}
var $92f910dc4e908871$var$$e = $92f910dc4e908871$var$Ze("animationend"), $92f910dc4e908871$var$af = $92f910dc4e908871$var$Ze("animationiteration"), $92f910dc4e908871$var$bf = $92f910dc4e908871$var$Ze("animationstart"), $92f910dc4e908871$var$cf = $92f910dc4e908871$var$Ze("transitionend"), $92f910dc4e908871$var$df = new Map, $92f910dc4e908871$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $92f910dc4e908871$var$ff(a, b) {
    $92f910dc4e908871$var$df.set(a, b);
    $92f910dc4e908871$var$fa(b, [
        a
    ]);
}
for(var $92f910dc4e908871$var$gf = 0; $92f910dc4e908871$var$gf < $92f910dc4e908871$var$ef.length; $92f910dc4e908871$var$gf++){
    var $92f910dc4e908871$var$hf = $92f910dc4e908871$var$ef[$92f910dc4e908871$var$gf], $92f910dc4e908871$var$jf = $92f910dc4e908871$var$hf.toLowerCase(), $92f910dc4e908871$var$kf = $92f910dc4e908871$var$hf[0].toUpperCase() + $92f910dc4e908871$var$hf.slice(1);
    $92f910dc4e908871$var$ff($92f910dc4e908871$var$jf, "on" + $92f910dc4e908871$var$kf);
}
$92f910dc4e908871$var$ff($92f910dc4e908871$var$$e, "onAnimationEnd");
$92f910dc4e908871$var$ff($92f910dc4e908871$var$af, "onAnimationIteration");
$92f910dc4e908871$var$ff($92f910dc4e908871$var$bf, "onAnimationStart");
$92f910dc4e908871$var$ff("dblclick", "onDoubleClick");
$92f910dc4e908871$var$ff("focusin", "onFocus");
$92f910dc4e908871$var$ff("focusout", "onBlur");
$92f910dc4e908871$var$ff($92f910dc4e908871$var$cf, "onTransitionEnd");
$92f910dc4e908871$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$92f910dc4e908871$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$92f910dc4e908871$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$92f910dc4e908871$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$92f910dc4e908871$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$92f910dc4e908871$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$92f910dc4e908871$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$92f910dc4e908871$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$92f910dc4e908871$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$92f910dc4e908871$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $92f910dc4e908871$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $92f910dc4e908871$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($92f910dc4e908871$var$lf));
function $92f910dc4e908871$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $92f910dc4e908871$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $92f910dc4e908871$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $92f910dc4e908871$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $92f910dc4e908871$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($92f910dc4e908871$var$Qb) throw a = $92f910dc4e908871$var$Rb, $92f910dc4e908871$var$Qb = !1, $92f910dc4e908871$var$Rb = null, a;
}
function $92f910dc4e908871$var$D(a, b) {
    var c = b[$92f910dc4e908871$var$of];
    void 0 === c && (c = b[$92f910dc4e908871$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($92f910dc4e908871$var$pf(b, a, 2, !1), c.add(d));
}
function $92f910dc4e908871$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $92f910dc4e908871$var$pf(c, a, d, b);
}
var $92f910dc4e908871$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $92f910dc4e908871$var$sf(a) {
    if (!a[$92f910dc4e908871$var$rf]) {
        a[$92f910dc4e908871$var$rf] = !0;
        $92f910dc4e908871$var$da.forEach(function(b) {
            "selectionchange" !== b && ($92f910dc4e908871$var$mf.has(b) || $92f910dc4e908871$var$qf(b, !1, a), $92f910dc4e908871$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$92f910dc4e908871$var$rf] || (b[$92f910dc4e908871$var$rf] = !0, $92f910dc4e908871$var$qf("selectionchange", !1, b));
    }
}
function $92f910dc4e908871$var$pf(a, b, c, d) {
    switch($92f910dc4e908871$var$jd(b)){
        case 1:
            var e = $92f910dc4e908871$var$ed;
            break;
        case 4:
            e = $92f910dc4e908871$var$gd;
            break;
        default:
            e = $92f910dc4e908871$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$92f910dc4e908871$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $92f910dc4e908871$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $92f910dc4e908871$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $92f910dc4e908871$var$Jb(function() {
        var d = f, e = $92f910dc4e908871$var$xb(c), g = [];
        a: {
            var h = $92f910dc4e908871$var$df.get(a);
            if (void 0 !== h) {
                var k = $92f910dc4e908871$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $92f910dc4e908871$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $92f910dc4e908871$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $92f910dc4e908871$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $92f910dc4e908871$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $92f910dc4e908871$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $92f910dc4e908871$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $92f910dc4e908871$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $92f910dc4e908871$var$Vd;
                        break;
                    case $92f910dc4e908871$var$$e:
                    case $92f910dc4e908871$var$af:
                    case $92f910dc4e908871$var$bf:
                        k = $92f910dc4e908871$var$Hd;
                        break;
                    case $92f910dc4e908871$var$cf:
                        k = $92f910dc4e908871$var$Xd;
                        break;
                    case "scroll":
                        k = $92f910dc4e908871$var$vd;
                        break;
                    case "wheel":
                        k = $92f910dc4e908871$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $92f910dc4e908871$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $92f910dc4e908871$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $92f910dc4e908871$var$Kb(w, x), null != F && t.push($92f910dc4e908871$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $92f910dc4e908871$var$wb && (n = c.relatedTarget || c.fromElement) && ($92f910dc4e908871$var$Wc(n) || n[$92f910dc4e908871$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $92f910dc4e908871$var$Wc(n) : null, null !== n && (J = $92f910dc4e908871$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $92f910dc4e908871$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $92f910dc4e908871$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $92f910dc4e908871$var$ue(k);
                        u = null == n ? h : $92f910dc4e908871$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $92f910dc4e908871$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $92f910dc4e908871$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $92f910dc4e908871$var$vf(F))u++;
                            for(; 0 < w - u;)t = $92f910dc4e908871$var$vf(t), w--;
                            for(; 0 < u - w;)x = $92f910dc4e908871$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $92f910dc4e908871$var$vf(t);
                                x = $92f910dc4e908871$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $92f910dc4e908871$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $92f910dc4e908871$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $92f910dc4e908871$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $92f910dc4e908871$var$ve;
                else if ($92f910dc4e908871$var$me(h)) {
                    if ($92f910dc4e908871$var$we) na = $92f910dc4e908871$var$Fe;
                    else {
                        na = $92f910dc4e908871$var$De;
                        var xa = $92f910dc4e908871$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $92f910dc4e908871$var$Ee);
                if (na && (na = na(a, d))) {
                    $92f910dc4e908871$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $92f910dc4e908871$var$cb(h, "number", h.value);
            }
            xa = d ? $92f910dc4e908871$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($92f910dc4e908871$var$me(xa) || "true" === xa.contentEditable) $92f910dc4e908871$var$Qe = xa, $92f910dc4e908871$var$Re = d, $92f910dc4e908871$var$Se = null;
                    break;
                case "focusout":
                    $92f910dc4e908871$var$Se = $92f910dc4e908871$var$Re = $92f910dc4e908871$var$Qe = null;
                    break;
                case "mousedown":
                    $92f910dc4e908871$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $92f910dc4e908871$var$Te = !1;
                    $92f910dc4e908871$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($92f910dc4e908871$var$Pe) break;
                case "keydown":
                case "keyup":
                    $92f910dc4e908871$var$Ue(g, c, e);
            }
            var $a;
            if ($92f910dc4e908871$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $92f910dc4e908871$var$ie ? $92f910dc4e908871$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($92f910dc4e908871$var$de && "ko" !== c.locale && ($92f910dc4e908871$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $92f910dc4e908871$var$ie && ($a = $92f910dc4e908871$var$nd()) : ($92f910dc4e908871$var$kd = e, $92f910dc4e908871$var$ld = "value" in $92f910dc4e908871$var$kd ? $92f910dc4e908871$var$kd.value : $92f910dc4e908871$var$kd.textContent, $92f910dc4e908871$var$ie = !0)), xa = $92f910dc4e908871$var$oe(d, ba), 0 < xa.length && (ba = new $92f910dc4e908871$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $92f910dc4e908871$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $92f910dc4e908871$var$ce ? $92f910dc4e908871$var$je(a, c) : $92f910dc4e908871$var$ke(a, c)) d = $92f910dc4e908871$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $92f910dc4e908871$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $92f910dc4e908871$var$se(g, b);
    });
}
function $92f910dc4e908871$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $92f910dc4e908871$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $92f910dc4e908871$var$Kb(a, c), null != f && d.unshift($92f910dc4e908871$var$tf(a, f, e)), f = $92f910dc4e908871$var$Kb(a, b), null != f && d.push($92f910dc4e908871$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $92f910dc4e908871$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $92f910dc4e908871$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $92f910dc4e908871$var$Kb(c, f), null != k && g.unshift($92f910dc4e908871$var$tf(c, k, h))) : e || (k = $92f910dc4e908871$var$Kb(c, f), null != k && g.push($92f910dc4e908871$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $92f910dc4e908871$var$xf = /\r\n?/g, $92f910dc4e908871$var$yf = /\u0000|\uFFFD/g;
function $92f910dc4e908871$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($92f910dc4e908871$var$xf, "\n").replace($92f910dc4e908871$var$yf, "");
}
function $92f910dc4e908871$var$Af(a, b, c) {
    b = $92f910dc4e908871$var$zf(b);
    if ($92f910dc4e908871$var$zf(a) !== b && c) throw Error($92f910dc4e908871$var$p(425));
}
function $92f910dc4e908871$var$Bf() {}
var $92f910dc4e908871$var$Cf = null, $92f910dc4e908871$var$Df = null;
function $92f910dc4e908871$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $92f910dc4e908871$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $92f910dc4e908871$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $92f910dc4e908871$var$Hf = "function" === typeof Promise ? Promise : void 0, $92f910dc4e908871$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $92f910dc4e908871$var$Hf ? function(a) {
    return $92f910dc4e908871$var$Hf.resolve(null).then(a).catch($92f910dc4e908871$var$If);
} : $92f910dc4e908871$var$Ff;
function $92f910dc4e908871$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $92f910dc4e908871$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $92f910dc4e908871$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $92f910dc4e908871$var$bd(b);
}
function $92f910dc4e908871$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $92f910dc4e908871$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $92f910dc4e908871$var$Nf = Math.random().toString(36).slice(2), $92f910dc4e908871$var$Of = "__reactFiber$" + $92f910dc4e908871$var$Nf, $92f910dc4e908871$var$Pf = "__reactProps$" + $92f910dc4e908871$var$Nf, $92f910dc4e908871$var$uf = "__reactContainer$" + $92f910dc4e908871$var$Nf, $92f910dc4e908871$var$of = "__reactEvents$" + $92f910dc4e908871$var$Nf, $92f910dc4e908871$var$Qf = "__reactListeners$" + $92f910dc4e908871$var$Nf, $92f910dc4e908871$var$Rf = "__reactHandles$" + $92f910dc4e908871$var$Nf;
function $92f910dc4e908871$var$Wc(a) {
    var b = a[$92f910dc4e908871$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$92f910dc4e908871$var$uf] || c[$92f910dc4e908871$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $92f910dc4e908871$var$Mf(a); null !== a;){
                if (c = a[$92f910dc4e908871$var$Of]) return c;
                a = $92f910dc4e908871$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $92f910dc4e908871$var$Cb(a) {
    a = a[$92f910dc4e908871$var$Of] || a[$92f910dc4e908871$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $92f910dc4e908871$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($92f910dc4e908871$var$p(33));
}
function $92f910dc4e908871$var$Db(a) {
    return a[$92f910dc4e908871$var$Pf] || null;
}
var $92f910dc4e908871$var$Sf = [], $92f910dc4e908871$var$Tf = -1;
function $92f910dc4e908871$var$Uf(a) {
    return {
        current: a
    };
}
function $92f910dc4e908871$var$E(a) {
    0 > $92f910dc4e908871$var$Tf || (a.current = $92f910dc4e908871$var$Sf[$92f910dc4e908871$var$Tf], $92f910dc4e908871$var$Sf[$92f910dc4e908871$var$Tf] = null, $92f910dc4e908871$var$Tf--);
}
function $92f910dc4e908871$var$G(a, b) {
    $92f910dc4e908871$var$Tf++;
    $92f910dc4e908871$var$Sf[$92f910dc4e908871$var$Tf] = a.current;
    a.current = b;
}
var $92f910dc4e908871$var$Vf = {}, $92f910dc4e908871$var$H = $92f910dc4e908871$var$Uf($92f910dc4e908871$var$Vf), $92f910dc4e908871$var$Wf = $92f910dc4e908871$var$Uf(!1), $92f910dc4e908871$var$Xf = $92f910dc4e908871$var$Vf;
function $92f910dc4e908871$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $92f910dc4e908871$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $92f910dc4e908871$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $92f910dc4e908871$var$$f() {
    $92f910dc4e908871$var$E($92f910dc4e908871$var$Wf);
    $92f910dc4e908871$var$E($92f910dc4e908871$var$H);
}
function $92f910dc4e908871$var$ag(a, b, c) {
    if ($92f910dc4e908871$var$H.current !== $92f910dc4e908871$var$Vf) throw Error($92f910dc4e908871$var$p(168));
    $92f910dc4e908871$var$G($92f910dc4e908871$var$H, b);
    $92f910dc4e908871$var$G($92f910dc4e908871$var$Wf, c);
}
function $92f910dc4e908871$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($92f910dc4e908871$var$p(108, $92f910dc4e908871$var$Ra(a) || "Unknown", e));
    return $92f910dc4e908871$var$A({}, c, d);
}
function $92f910dc4e908871$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $92f910dc4e908871$var$Vf;
    $92f910dc4e908871$var$Xf = $92f910dc4e908871$var$H.current;
    $92f910dc4e908871$var$G($92f910dc4e908871$var$H, a);
    $92f910dc4e908871$var$G($92f910dc4e908871$var$Wf, $92f910dc4e908871$var$Wf.current);
    return !0;
}
function $92f910dc4e908871$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($92f910dc4e908871$var$p(169));
    c ? (a = $92f910dc4e908871$var$bg(a, b, $92f910dc4e908871$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $92f910dc4e908871$var$E($92f910dc4e908871$var$Wf), $92f910dc4e908871$var$E($92f910dc4e908871$var$H), $92f910dc4e908871$var$G($92f910dc4e908871$var$H, a)) : $92f910dc4e908871$var$E($92f910dc4e908871$var$Wf);
    $92f910dc4e908871$var$G($92f910dc4e908871$var$Wf, c);
}
var $92f910dc4e908871$var$eg = null, $92f910dc4e908871$var$fg = !1, $92f910dc4e908871$var$gg = !1;
function $92f910dc4e908871$var$hg(a) {
    null === $92f910dc4e908871$var$eg ? $92f910dc4e908871$var$eg = [
        a
    ] : $92f910dc4e908871$var$eg.push(a);
}
function $92f910dc4e908871$var$ig(a) {
    $92f910dc4e908871$var$fg = !0;
    $92f910dc4e908871$var$hg(a);
}
function $92f910dc4e908871$var$jg() {
    if (!$92f910dc4e908871$var$gg && null !== $92f910dc4e908871$var$eg) {
        $92f910dc4e908871$var$gg = !0;
        var a = 0, b = $92f910dc4e908871$var$C;
        try {
            var c = $92f910dc4e908871$var$eg;
            for($92f910dc4e908871$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $92f910dc4e908871$var$eg = null;
            $92f910dc4e908871$var$fg = !1;
        } catch (e) {
            throw null !== $92f910dc4e908871$var$eg && ($92f910dc4e908871$var$eg = $92f910dc4e908871$var$eg.slice(a + 1)), $92f910dc4e908871$var$ac($92f910dc4e908871$var$fc, $92f910dc4e908871$var$jg), e;
        } finally{
            $92f910dc4e908871$var$C = b, $92f910dc4e908871$var$gg = !1;
        }
    }
    return null;
}
var $92f910dc4e908871$var$kg = [], $92f910dc4e908871$var$lg = 0, $92f910dc4e908871$var$mg = null, $92f910dc4e908871$var$ng = 0, $92f910dc4e908871$var$og = [], $92f910dc4e908871$var$pg = 0, $92f910dc4e908871$var$qg = null, $92f910dc4e908871$var$rg = 1, $92f910dc4e908871$var$sg = "";
function $92f910dc4e908871$var$tg(a, b) {
    $92f910dc4e908871$var$kg[$92f910dc4e908871$var$lg++] = $92f910dc4e908871$var$ng;
    $92f910dc4e908871$var$kg[$92f910dc4e908871$var$lg++] = $92f910dc4e908871$var$mg;
    $92f910dc4e908871$var$mg = a;
    $92f910dc4e908871$var$ng = b;
}
function $92f910dc4e908871$var$ug(a, b, c) {
    $92f910dc4e908871$var$og[$92f910dc4e908871$var$pg++] = $92f910dc4e908871$var$rg;
    $92f910dc4e908871$var$og[$92f910dc4e908871$var$pg++] = $92f910dc4e908871$var$sg;
    $92f910dc4e908871$var$og[$92f910dc4e908871$var$pg++] = $92f910dc4e908871$var$qg;
    $92f910dc4e908871$var$qg = a;
    var d = $92f910dc4e908871$var$rg;
    a = $92f910dc4e908871$var$sg;
    var e = 32 - $92f910dc4e908871$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $92f910dc4e908871$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $92f910dc4e908871$var$rg = 1 << 32 - $92f910dc4e908871$var$oc(b) + e | c << e | d;
        $92f910dc4e908871$var$sg = f + a;
    } else $92f910dc4e908871$var$rg = 1 << f | c << e | d, $92f910dc4e908871$var$sg = a;
}
function $92f910dc4e908871$var$vg(a) {
    null !== a.return && ($92f910dc4e908871$var$tg(a, 1), $92f910dc4e908871$var$ug(a, 1, 0));
}
function $92f910dc4e908871$var$wg(a) {
    for(; a === $92f910dc4e908871$var$mg;)$92f910dc4e908871$var$mg = $92f910dc4e908871$var$kg[--$92f910dc4e908871$var$lg], $92f910dc4e908871$var$kg[$92f910dc4e908871$var$lg] = null, $92f910dc4e908871$var$ng = $92f910dc4e908871$var$kg[--$92f910dc4e908871$var$lg], $92f910dc4e908871$var$kg[$92f910dc4e908871$var$lg] = null;
    for(; a === $92f910dc4e908871$var$qg;)$92f910dc4e908871$var$qg = $92f910dc4e908871$var$og[--$92f910dc4e908871$var$pg], $92f910dc4e908871$var$og[$92f910dc4e908871$var$pg] = null, $92f910dc4e908871$var$sg = $92f910dc4e908871$var$og[--$92f910dc4e908871$var$pg], $92f910dc4e908871$var$og[$92f910dc4e908871$var$pg] = null, $92f910dc4e908871$var$rg = $92f910dc4e908871$var$og[--$92f910dc4e908871$var$pg], $92f910dc4e908871$var$og[$92f910dc4e908871$var$pg] = null;
}
var $92f910dc4e908871$var$xg = null, $92f910dc4e908871$var$yg = null, $92f910dc4e908871$var$I = !1, $92f910dc4e908871$var$zg = null;
function $92f910dc4e908871$var$Ag(a, b) {
    var c = $92f910dc4e908871$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $92f910dc4e908871$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $92f910dc4e908871$var$xg = a, $92f910dc4e908871$var$yg = $92f910dc4e908871$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $92f910dc4e908871$var$xg = a, $92f910dc4e908871$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $92f910dc4e908871$var$qg ? {
                id: $92f910dc4e908871$var$rg,
                overflow: $92f910dc4e908871$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $92f910dc4e908871$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $92f910dc4e908871$var$xg = a, $92f910dc4e908871$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $92f910dc4e908871$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $92f910dc4e908871$var$Eg(a) {
    if ($92f910dc4e908871$var$I) {
        var b = $92f910dc4e908871$var$yg;
        if (b) {
            var c = b;
            if (!$92f910dc4e908871$var$Cg(a, b)) {
                if ($92f910dc4e908871$var$Dg(a)) throw Error($92f910dc4e908871$var$p(418));
                b = $92f910dc4e908871$var$Lf(c.nextSibling);
                var d = $92f910dc4e908871$var$xg;
                b && $92f910dc4e908871$var$Cg(a, b) ? $92f910dc4e908871$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $92f910dc4e908871$var$I = !1, $92f910dc4e908871$var$xg = a);
            }
        } else {
            if ($92f910dc4e908871$var$Dg(a)) throw Error($92f910dc4e908871$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $92f910dc4e908871$var$I = !1;
            $92f910dc4e908871$var$xg = a;
        }
    }
}
function $92f910dc4e908871$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $92f910dc4e908871$var$xg = a;
}
function $92f910dc4e908871$var$Gg(a) {
    if (a !== $92f910dc4e908871$var$xg) return !1;
    if (!$92f910dc4e908871$var$I) return $92f910dc4e908871$var$Fg(a), $92f910dc4e908871$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$92f910dc4e908871$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $92f910dc4e908871$var$yg)) {
        if ($92f910dc4e908871$var$Dg(a)) throw $92f910dc4e908871$var$Hg(), Error($92f910dc4e908871$var$p(418));
        for(; b;)$92f910dc4e908871$var$Ag(a, b), b = $92f910dc4e908871$var$Lf(b.nextSibling);
    }
    $92f910dc4e908871$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($92f910dc4e908871$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $92f910dc4e908871$var$yg = $92f910dc4e908871$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $92f910dc4e908871$var$yg = null;
        }
    } else $92f910dc4e908871$var$yg = $92f910dc4e908871$var$xg ? $92f910dc4e908871$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $92f910dc4e908871$var$Hg() {
    for(var a = $92f910dc4e908871$var$yg; a;)a = $92f910dc4e908871$var$Lf(a.nextSibling);
}
function $92f910dc4e908871$var$Ig() {
    $92f910dc4e908871$var$yg = $92f910dc4e908871$var$xg = null;
    $92f910dc4e908871$var$I = !1;
}
function $92f910dc4e908871$var$Jg(a) {
    null === $92f910dc4e908871$var$zg ? $92f910dc4e908871$var$zg = [
        a
    ] : $92f910dc4e908871$var$zg.push(a);
}
var $92f910dc4e908871$var$Kg = $92f910dc4e908871$var$ua.ReactCurrentBatchConfig;
function $92f910dc4e908871$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($92f910dc4e908871$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($92f910dc4e908871$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($92f910dc4e908871$var$p(284));
        if (!c._owner) throw Error($92f910dc4e908871$var$p(290, a));
    }
    return a;
}
function $92f910dc4e908871$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($92f910dc4e908871$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $92f910dc4e908871$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $92f910dc4e908871$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $92f910dc4e908871$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $92f910dc4e908871$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $92f910dc4e908871$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $92f910dc4e908871$var$Ha && $92f910dc4e908871$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $92f910dc4e908871$var$Lg(a, b, c), d.return = a, d;
        d = $92f910dc4e908871$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $92f910dc4e908871$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $92f910dc4e908871$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $92f910dc4e908871$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $92f910dc4e908871$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $92f910dc4e908871$var$va:
                    return c = $92f910dc4e908871$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $92f910dc4e908871$var$Lg(a, null, b), c.return = a, c;
                case $92f910dc4e908871$var$wa:
                    return b = $92f910dc4e908871$var$Sg(b, a.mode, c), b.return = a, b;
                case $92f910dc4e908871$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($92f910dc4e908871$var$eb(b) || $92f910dc4e908871$var$Ka(b)) return b = $92f910dc4e908871$var$Tg(b, a.mode, c, null), b.return = a, b;
            $92f910dc4e908871$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $92f910dc4e908871$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $92f910dc4e908871$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $92f910dc4e908871$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($92f910dc4e908871$var$eb(c) || $92f910dc4e908871$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $92f910dc4e908871$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $92f910dc4e908871$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $92f910dc4e908871$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $92f910dc4e908871$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($92f910dc4e908871$var$eb(d) || $92f910dc4e908871$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $92f910dc4e908871$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $92f910dc4e908871$var$I && $92f910dc4e908871$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $92f910dc4e908871$var$I && $92f910dc4e908871$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $92f910dc4e908871$var$I && $92f910dc4e908871$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $92f910dc4e908871$var$Ka(h);
        if ("function" !== typeof l) throw Error($92f910dc4e908871$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($92f910dc4e908871$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $92f910dc4e908871$var$I && $92f910dc4e908871$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $92f910dc4e908871$var$I && $92f910dc4e908871$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $92f910dc4e908871$var$I && $92f910dc4e908871$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $92f910dc4e908871$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $92f910dc4e908871$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $92f910dc4e908871$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $92f910dc4e908871$var$Ha && $92f910dc4e908871$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $92f910dc4e908871$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $92f910dc4e908871$var$ya ? (d = $92f910dc4e908871$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $92f910dc4e908871$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $92f910dc4e908871$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $92f910dc4e908871$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $92f910dc4e908871$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $92f910dc4e908871$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($92f910dc4e908871$var$eb(f)) return n(a, d, f, h);
            if ($92f910dc4e908871$var$Ka(f)) return t(a, d, f, h);
            $92f910dc4e908871$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $92f910dc4e908871$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $92f910dc4e908871$var$Ug = $92f910dc4e908871$var$Og(!0), $92f910dc4e908871$var$Vg = $92f910dc4e908871$var$Og(!1), $92f910dc4e908871$var$Wg = $92f910dc4e908871$var$Uf(null), $92f910dc4e908871$var$Xg = null, $92f910dc4e908871$var$Yg = null, $92f910dc4e908871$var$Zg = null;
function $92f910dc4e908871$var$$g() {
    $92f910dc4e908871$var$Zg = $92f910dc4e908871$var$Yg = $92f910dc4e908871$var$Xg = null;
}
function $92f910dc4e908871$var$ah(a) {
    var b = $92f910dc4e908871$var$Wg.current;
    $92f910dc4e908871$var$E($92f910dc4e908871$var$Wg);
    a._currentValue = b;
}
function $92f910dc4e908871$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $92f910dc4e908871$var$ch(a, b) {
    $92f910dc4e908871$var$Xg = a;
    $92f910dc4e908871$var$Zg = $92f910dc4e908871$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($92f910dc4e908871$var$dh = !0), a.firstContext = null);
}
function $92f910dc4e908871$var$eh(a) {
    var b = a._currentValue;
    if ($92f910dc4e908871$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $92f910dc4e908871$var$Yg) {
            if (null === $92f910dc4e908871$var$Xg) throw Error($92f910dc4e908871$var$p(308));
            $92f910dc4e908871$var$Yg = a;
            $92f910dc4e908871$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $92f910dc4e908871$var$Yg = $92f910dc4e908871$var$Yg.next = a;
    }
    return b;
}
var $92f910dc4e908871$var$fh = null;
function $92f910dc4e908871$var$gh(a) {
    null === $92f910dc4e908871$var$fh ? $92f910dc4e908871$var$fh = [
        a
    ] : $92f910dc4e908871$var$fh.push(a);
}
function $92f910dc4e908871$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $92f910dc4e908871$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $92f910dc4e908871$var$ih(a, d);
}
function $92f910dc4e908871$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $92f910dc4e908871$var$jh = !1;
function $92f910dc4e908871$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $92f910dc4e908871$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $92f910dc4e908871$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $92f910dc4e908871$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($92f910dc4e908871$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $92f910dc4e908871$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $92f910dc4e908871$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $92f910dc4e908871$var$ih(a, c);
}
function $92f910dc4e908871$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $92f910dc4e908871$var$Cc(a, c);
    }
}
function $92f910dc4e908871$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $92f910dc4e908871$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $92f910dc4e908871$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $92f910dc4e908871$var$A({}, q, r);
                            break a;
                        case 2:
                            $92f910dc4e908871$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $92f910dc4e908871$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $92f910dc4e908871$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($92f910dc4e908871$var$p(191, e));
            e.call(d);
        }
    }
}
var $92f910dc4e908871$var$th = {}, $92f910dc4e908871$var$uh = $92f910dc4e908871$var$Uf($92f910dc4e908871$var$th), $92f910dc4e908871$var$vh = $92f910dc4e908871$var$Uf($92f910dc4e908871$var$th), $92f910dc4e908871$var$wh = $92f910dc4e908871$var$Uf($92f910dc4e908871$var$th);
function $92f910dc4e908871$var$xh(a) {
    if (a === $92f910dc4e908871$var$th) throw Error($92f910dc4e908871$var$p(174));
    return a;
}
function $92f910dc4e908871$var$yh(a, b) {
    $92f910dc4e908871$var$G($92f910dc4e908871$var$wh, b);
    $92f910dc4e908871$var$G($92f910dc4e908871$var$vh, a);
    $92f910dc4e908871$var$G($92f910dc4e908871$var$uh, $92f910dc4e908871$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $92f910dc4e908871$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $92f910dc4e908871$var$lb(b, a);
    }
    $92f910dc4e908871$var$E($92f910dc4e908871$var$uh);
    $92f910dc4e908871$var$G($92f910dc4e908871$var$uh, b);
}
function $92f910dc4e908871$var$zh() {
    $92f910dc4e908871$var$E($92f910dc4e908871$var$uh);
    $92f910dc4e908871$var$E($92f910dc4e908871$var$vh);
    $92f910dc4e908871$var$E($92f910dc4e908871$var$wh);
}
function $92f910dc4e908871$var$Ah(a) {
    $92f910dc4e908871$var$xh($92f910dc4e908871$var$wh.current);
    var b = $92f910dc4e908871$var$xh($92f910dc4e908871$var$uh.current);
    var c = $92f910dc4e908871$var$lb(b, a.type);
    b !== c && ($92f910dc4e908871$var$G($92f910dc4e908871$var$vh, a), $92f910dc4e908871$var$G($92f910dc4e908871$var$uh, c));
}
function $92f910dc4e908871$var$Bh(a) {
    $92f910dc4e908871$var$vh.current === a && ($92f910dc4e908871$var$E($92f910dc4e908871$var$uh), $92f910dc4e908871$var$E($92f910dc4e908871$var$vh));
}
var $92f910dc4e908871$var$L = $92f910dc4e908871$var$Uf(0);
function $92f910dc4e908871$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $92f910dc4e908871$var$Dh = [];
function $92f910dc4e908871$var$Eh() {
    for(var a = 0; a < $92f910dc4e908871$var$Dh.length; a++)$92f910dc4e908871$var$Dh[a]._workInProgressVersionPrimary = null;
    $92f910dc4e908871$var$Dh.length = 0;
}
var $92f910dc4e908871$var$Fh = $92f910dc4e908871$var$ua.ReactCurrentDispatcher, $92f910dc4e908871$var$Gh = $92f910dc4e908871$var$ua.ReactCurrentBatchConfig, $92f910dc4e908871$var$Hh = 0, $92f910dc4e908871$var$M = null, $92f910dc4e908871$var$N = null, $92f910dc4e908871$var$O = null, $92f910dc4e908871$var$Ih = !1, $92f910dc4e908871$var$Jh = !1, $92f910dc4e908871$var$Kh = 0, $92f910dc4e908871$var$Lh = 0;
function $92f910dc4e908871$var$P() {
    throw Error($92f910dc4e908871$var$p(321));
}
function $92f910dc4e908871$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$92f910dc4e908871$var$He(a[c], b[c])) return !1;
    return !0;
}
function $92f910dc4e908871$var$Nh(a, b, c, d, e, f) {
    $92f910dc4e908871$var$Hh = f;
    $92f910dc4e908871$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $92f910dc4e908871$var$Fh.current = null === a || null === a.memoizedState ? $92f910dc4e908871$var$Oh : $92f910dc4e908871$var$Ph;
    a = c(d, e);
    if ($92f910dc4e908871$var$Jh) {
        f = 0;
        do {
            $92f910dc4e908871$var$Jh = !1;
            $92f910dc4e908871$var$Kh = 0;
            if (25 <= f) throw Error($92f910dc4e908871$var$p(301));
            f += 1;
            $92f910dc4e908871$var$O = $92f910dc4e908871$var$N = null;
            b.updateQueue = null;
            $92f910dc4e908871$var$Fh.current = $92f910dc4e908871$var$Qh;
            a = c(d, e);
        }while ($92f910dc4e908871$var$Jh);
    }
    $92f910dc4e908871$var$Fh.current = $92f910dc4e908871$var$Rh;
    b = null !== $92f910dc4e908871$var$N && null !== $92f910dc4e908871$var$N.next;
    $92f910dc4e908871$var$Hh = 0;
    $92f910dc4e908871$var$O = $92f910dc4e908871$var$N = $92f910dc4e908871$var$M = null;
    $92f910dc4e908871$var$Ih = !1;
    if (b) throw Error($92f910dc4e908871$var$p(300));
    return a;
}
function $92f910dc4e908871$var$Sh() {
    var a = 0 !== $92f910dc4e908871$var$Kh;
    $92f910dc4e908871$var$Kh = 0;
    return a;
}
function $92f910dc4e908871$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $92f910dc4e908871$var$O ? $92f910dc4e908871$var$M.memoizedState = $92f910dc4e908871$var$O = a : $92f910dc4e908871$var$O = $92f910dc4e908871$var$O.next = a;
    return $92f910dc4e908871$var$O;
}
function $92f910dc4e908871$var$Uh() {
    if (null === $92f910dc4e908871$var$N) {
        var a = $92f910dc4e908871$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $92f910dc4e908871$var$N.next;
    var b = null === $92f910dc4e908871$var$O ? $92f910dc4e908871$var$M.memoizedState : $92f910dc4e908871$var$O.next;
    if (null !== b) $92f910dc4e908871$var$O = b, $92f910dc4e908871$var$N = a;
    else {
        if (null === a) throw Error($92f910dc4e908871$var$p(310));
        $92f910dc4e908871$var$N = a;
        a = {
            memoizedState: $92f910dc4e908871$var$N.memoizedState,
            baseState: $92f910dc4e908871$var$N.baseState,
            baseQueue: $92f910dc4e908871$var$N.baseQueue,
            queue: $92f910dc4e908871$var$N.queue,
            next: null
        };
        null === $92f910dc4e908871$var$O ? $92f910dc4e908871$var$M.memoizedState = $92f910dc4e908871$var$O = a : $92f910dc4e908871$var$O = $92f910dc4e908871$var$O.next = a;
    }
    return $92f910dc4e908871$var$O;
}
function $92f910dc4e908871$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $92f910dc4e908871$var$Wh(a) {
    var b = $92f910dc4e908871$var$Uh(), c = b.queue;
    if (null === c) throw Error($92f910dc4e908871$var$p(311));
    c.lastRenderedReducer = a;
    var d = $92f910dc4e908871$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($92f910dc4e908871$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $92f910dc4e908871$var$M.lanes |= m;
                $92f910dc4e908871$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $92f910dc4e908871$var$He(d, b.memoizedState) || ($92f910dc4e908871$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $92f910dc4e908871$var$M.lanes |= f, $92f910dc4e908871$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $92f910dc4e908871$var$Xh(a) {
    var b = $92f910dc4e908871$var$Uh(), c = b.queue;
    if (null === c) throw Error($92f910dc4e908871$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $92f910dc4e908871$var$He(f, b.memoizedState) || ($92f910dc4e908871$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $92f910dc4e908871$var$Yh() {}
function $92f910dc4e908871$var$Zh(a, b) {
    var c = $92f910dc4e908871$var$M, d = $92f910dc4e908871$var$Uh(), e = b(), f = !$92f910dc4e908871$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $92f910dc4e908871$var$dh = !0);
    d = d.queue;
    $92f910dc4e908871$var$$h($92f910dc4e908871$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $92f910dc4e908871$var$O && $92f910dc4e908871$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $92f910dc4e908871$var$bi(9, $92f910dc4e908871$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $92f910dc4e908871$var$Q) throw Error($92f910dc4e908871$var$p(349));
        0 !== ($92f910dc4e908871$var$Hh & 30) || $92f910dc4e908871$var$di(c, b, e);
    }
    return e;
}
function $92f910dc4e908871$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $92f910dc4e908871$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $92f910dc4e908871$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $92f910dc4e908871$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $92f910dc4e908871$var$ei(b) && $92f910dc4e908871$var$fi(a);
}
function $92f910dc4e908871$var$ai(a, b, c) {
    return c(function() {
        $92f910dc4e908871$var$ei(b) && $92f910dc4e908871$var$fi(a);
    });
}
function $92f910dc4e908871$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$92f910dc4e908871$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $92f910dc4e908871$var$fi(a) {
    var b = $92f910dc4e908871$var$ih(a, 1);
    null !== b && $92f910dc4e908871$var$gi(b, a, 1, -1);
}
function $92f910dc4e908871$var$hi(a) {
    var b = $92f910dc4e908871$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $92f910dc4e908871$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $92f910dc4e908871$var$ii.bind(null, $92f910dc4e908871$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $92f910dc4e908871$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $92f910dc4e908871$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $92f910dc4e908871$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $92f910dc4e908871$var$ji() {
    return $92f910dc4e908871$var$Uh().memoizedState;
}
function $92f910dc4e908871$var$ki(a, b, c, d) {
    var e = $92f910dc4e908871$var$Th();
    $92f910dc4e908871$var$M.flags |= a;
    e.memoizedState = $92f910dc4e908871$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $92f910dc4e908871$var$li(a, b, c, d) {
    var e = $92f910dc4e908871$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $92f910dc4e908871$var$N) {
        var g = $92f910dc4e908871$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $92f910dc4e908871$var$Mh(d, g.deps)) {
            e.memoizedState = $92f910dc4e908871$var$bi(b, c, f, d);
            return;
        }
    }
    $92f910dc4e908871$var$M.flags |= a;
    e.memoizedState = $92f910dc4e908871$var$bi(1 | b, c, f, d);
}
function $92f910dc4e908871$var$mi(a, b) {
    return $92f910dc4e908871$var$ki(8390656, 8, a, b);
}
function $92f910dc4e908871$var$$h(a, b) {
    return $92f910dc4e908871$var$li(2048, 8, a, b);
}
function $92f910dc4e908871$var$ni(a, b) {
    return $92f910dc4e908871$var$li(4, 2, a, b);
}
function $92f910dc4e908871$var$oi(a, b) {
    return $92f910dc4e908871$var$li(4, 4, a, b);
}
function $92f910dc4e908871$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $92f910dc4e908871$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $92f910dc4e908871$var$li(4, 4, $92f910dc4e908871$var$pi.bind(null, b, a), c);
}
function $92f910dc4e908871$var$ri() {}
function $92f910dc4e908871$var$si(a, b) {
    var c = $92f910dc4e908871$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $92f910dc4e908871$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $92f910dc4e908871$var$ti(a, b) {
    var c = $92f910dc4e908871$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $92f910dc4e908871$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $92f910dc4e908871$var$ui(a, b, c) {
    if (0 === ($92f910dc4e908871$var$Hh & 21)) return a.baseState && (a.baseState = !1, $92f910dc4e908871$var$dh = !0), a.memoizedState = c;
    $92f910dc4e908871$var$He(c, b) || (c = $92f910dc4e908871$var$yc(), $92f910dc4e908871$var$M.lanes |= c, $92f910dc4e908871$var$rh |= c, a.baseState = !0);
    return b;
}
function $92f910dc4e908871$var$vi(a, b) {
    var c = $92f910dc4e908871$var$C;
    $92f910dc4e908871$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $92f910dc4e908871$var$Gh.transition;
    $92f910dc4e908871$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $92f910dc4e908871$var$C = c, $92f910dc4e908871$var$Gh.transition = d;
    }
}
function $92f910dc4e908871$var$wi() {
    return $92f910dc4e908871$var$Uh().memoizedState;
}
function $92f910dc4e908871$var$xi(a, b, c) {
    var d = $92f910dc4e908871$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($92f910dc4e908871$var$zi(a)) $92f910dc4e908871$var$Ai(b, c);
    else if (c = $92f910dc4e908871$var$hh(a, b, c, d), null !== c) {
        var e = $92f910dc4e908871$var$R();
        $92f910dc4e908871$var$gi(c, a, d, e);
        $92f910dc4e908871$var$Bi(c, b, d);
    }
}
function $92f910dc4e908871$var$ii(a, b, c) {
    var d = $92f910dc4e908871$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($92f910dc4e908871$var$zi(a)) $92f910dc4e908871$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($92f910dc4e908871$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $92f910dc4e908871$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $92f910dc4e908871$var$hh(a, b, e, d);
        null !== c && (e = $92f910dc4e908871$var$R(), $92f910dc4e908871$var$gi(c, a, d, e), $92f910dc4e908871$var$Bi(c, b, d));
    }
}
function $92f910dc4e908871$var$zi(a) {
    var b = a.alternate;
    return a === $92f910dc4e908871$var$M || null !== b && b === $92f910dc4e908871$var$M;
}
function $92f910dc4e908871$var$Ai(a, b) {
    $92f910dc4e908871$var$Jh = $92f910dc4e908871$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $92f910dc4e908871$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $92f910dc4e908871$var$Cc(a, c);
    }
}
var $92f910dc4e908871$var$Rh = {
    readContext: $92f910dc4e908871$var$eh,
    useCallback: $92f910dc4e908871$var$P,
    useContext: $92f910dc4e908871$var$P,
    useEffect: $92f910dc4e908871$var$P,
    useImperativeHandle: $92f910dc4e908871$var$P,
    useInsertionEffect: $92f910dc4e908871$var$P,
    useLayoutEffect: $92f910dc4e908871$var$P,
    useMemo: $92f910dc4e908871$var$P,
    useReducer: $92f910dc4e908871$var$P,
    useRef: $92f910dc4e908871$var$P,
    useState: $92f910dc4e908871$var$P,
    useDebugValue: $92f910dc4e908871$var$P,
    useDeferredValue: $92f910dc4e908871$var$P,
    useTransition: $92f910dc4e908871$var$P,
    useMutableSource: $92f910dc4e908871$var$P,
    useSyncExternalStore: $92f910dc4e908871$var$P,
    useId: $92f910dc4e908871$var$P,
    unstable_isNewReconciler: !1
}, $92f910dc4e908871$var$Oh = {
    readContext: $92f910dc4e908871$var$eh,
    useCallback: function(a, b) {
        $92f910dc4e908871$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $92f910dc4e908871$var$eh,
    useEffect: $92f910dc4e908871$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $92f910dc4e908871$var$ki(4194308, 4, $92f910dc4e908871$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $92f910dc4e908871$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $92f910dc4e908871$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $92f910dc4e908871$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $92f910dc4e908871$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $92f910dc4e908871$var$xi.bind(null, $92f910dc4e908871$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $92f910dc4e908871$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $92f910dc4e908871$var$hi,
    useDebugValue: $92f910dc4e908871$var$ri,
    useDeferredValue: function(a) {
        return $92f910dc4e908871$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $92f910dc4e908871$var$hi(!1), b = a[0];
        a = $92f910dc4e908871$var$vi.bind(null, a[1]);
        $92f910dc4e908871$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $92f910dc4e908871$var$M, e = $92f910dc4e908871$var$Th();
        if ($92f910dc4e908871$var$I) {
            if (void 0 === c) throw Error($92f910dc4e908871$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $92f910dc4e908871$var$Q) throw Error($92f910dc4e908871$var$p(349));
            0 !== ($92f910dc4e908871$var$Hh & 30) || $92f910dc4e908871$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $92f910dc4e908871$var$mi($92f910dc4e908871$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $92f910dc4e908871$var$bi(9, $92f910dc4e908871$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $92f910dc4e908871$var$Th(), b = $92f910dc4e908871$var$Q.identifierPrefix;
        if ($92f910dc4e908871$var$I) {
            var c = $92f910dc4e908871$var$sg;
            var d = $92f910dc4e908871$var$rg;
            c = (d & ~(1 << 32 - $92f910dc4e908871$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $92f910dc4e908871$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $92f910dc4e908871$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $92f910dc4e908871$var$Ph = {
    readContext: $92f910dc4e908871$var$eh,
    useCallback: $92f910dc4e908871$var$si,
    useContext: $92f910dc4e908871$var$eh,
    useEffect: $92f910dc4e908871$var$$h,
    useImperativeHandle: $92f910dc4e908871$var$qi,
    useInsertionEffect: $92f910dc4e908871$var$ni,
    useLayoutEffect: $92f910dc4e908871$var$oi,
    useMemo: $92f910dc4e908871$var$ti,
    useReducer: $92f910dc4e908871$var$Wh,
    useRef: $92f910dc4e908871$var$ji,
    useState: function() {
        return $92f910dc4e908871$var$Wh($92f910dc4e908871$var$Vh);
    },
    useDebugValue: $92f910dc4e908871$var$ri,
    useDeferredValue: function(a) {
        var b = $92f910dc4e908871$var$Uh();
        return $92f910dc4e908871$var$ui(b, $92f910dc4e908871$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $92f910dc4e908871$var$Wh($92f910dc4e908871$var$Vh)[0], b = $92f910dc4e908871$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $92f910dc4e908871$var$Yh,
    useSyncExternalStore: $92f910dc4e908871$var$Zh,
    useId: $92f910dc4e908871$var$wi,
    unstable_isNewReconciler: !1
}, $92f910dc4e908871$var$Qh = {
    readContext: $92f910dc4e908871$var$eh,
    useCallback: $92f910dc4e908871$var$si,
    useContext: $92f910dc4e908871$var$eh,
    useEffect: $92f910dc4e908871$var$$h,
    useImperativeHandle: $92f910dc4e908871$var$qi,
    useInsertionEffect: $92f910dc4e908871$var$ni,
    useLayoutEffect: $92f910dc4e908871$var$oi,
    useMemo: $92f910dc4e908871$var$ti,
    useReducer: $92f910dc4e908871$var$Xh,
    useRef: $92f910dc4e908871$var$ji,
    useState: function() {
        return $92f910dc4e908871$var$Xh($92f910dc4e908871$var$Vh);
    },
    useDebugValue: $92f910dc4e908871$var$ri,
    useDeferredValue: function(a) {
        var b = $92f910dc4e908871$var$Uh();
        return null === $92f910dc4e908871$var$N ? b.memoizedState = a : $92f910dc4e908871$var$ui(b, $92f910dc4e908871$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $92f910dc4e908871$var$Xh($92f910dc4e908871$var$Vh)[0], b = $92f910dc4e908871$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $92f910dc4e908871$var$Yh,
    useSyncExternalStore: $92f910dc4e908871$var$Zh,
    useId: $92f910dc4e908871$var$wi,
    unstable_isNewReconciler: !1
};
function $92f910dc4e908871$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $92f910dc4e908871$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $92f910dc4e908871$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $92f910dc4e908871$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $92f910dc4e908871$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $92f910dc4e908871$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $92f910dc4e908871$var$R(), e = $92f910dc4e908871$var$yi(a), f = $92f910dc4e908871$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $92f910dc4e908871$var$nh(a, f, e);
        null !== b && ($92f910dc4e908871$var$gi(b, a, e, d), $92f910dc4e908871$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $92f910dc4e908871$var$R(), e = $92f910dc4e908871$var$yi(a), f = $92f910dc4e908871$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $92f910dc4e908871$var$nh(a, f, e);
        null !== b && ($92f910dc4e908871$var$gi(b, a, e, d), $92f910dc4e908871$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $92f910dc4e908871$var$R(), d = $92f910dc4e908871$var$yi(a), e = $92f910dc4e908871$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $92f910dc4e908871$var$nh(a, e, d);
        null !== b && ($92f910dc4e908871$var$gi(b, a, d, c), $92f910dc4e908871$var$oh(b, a, d));
    }
};
function $92f910dc4e908871$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$92f910dc4e908871$var$Ie(c, d) || !$92f910dc4e908871$var$Ie(e, f) : !0;
}
function $92f910dc4e908871$var$Gi(a, b, c) {
    var d = !1, e = $92f910dc4e908871$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $92f910dc4e908871$var$eh(f) : (e = $92f910dc4e908871$var$Zf(b) ? $92f910dc4e908871$var$Xf : $92f910dc4e908871$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $92f910dc4e908871$var$Yf(a, e) : $92f910dc4e908871$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $92f910dc4e908871$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $92f910dc4e908871$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $92f910dc4e908871$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $92f910dc4e908871$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $92f910dc4e908871$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $92f910dc4e908871$var$eh(f) : (f = $92f910dc4e908871$var$Zf(b) ? $92f910dc4e908871$var$Xf : $92f910dc4e908871$var$H.current, e.context = $92f910dc4e908871$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($92f910dc4e908871$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $92f910dc4e908871$var$Ei.enqueueReplaceState(e, e.state, null), $92f910dc4e908871$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $92f910dc4e908871$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $92f910dc4e908871$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $92f910dc4e908871$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $92f910dc4e908871$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $92f910dc4e908871$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $92f910dc4e908871$var$Ni(a, b, c) {
    c = $92f910dc4e908871$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $92f910dc4e908871$var$Oi || ($92f910dc4e908871$var$Oi = !0, $92f910dc4e908871$var$Pi = d);
        $92f910dc4e908871$var$Li(a, b);
    };
    return c;
}
function $92f910dc4e908871$var$Qi(a, b, c) {
    c = $92f910dc4e908871$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $92f910dc4e908871$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $92f910dc4e908871$var$Li(a, b);
        "function" !== typeof d && (null === $92f910dc4e908871$var$Ri ? $92f910dc4e908871$var$Ri = new Set([
            this
        ]) : $92f910dc4e908871$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $92f910dc4e908871$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $92f910dc4e908871$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $92f910dc4e908871$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $92f910dc4e908871$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $92f910dc4e908871$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $92f910dc4e908871$var$mh(-1, 1), b.tag = 2, $92f910dc4e908871$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $92f910dc4e908871$var$Wi = $92f910dc4e908871$var$ua.ReactCurrentOwner, $92f910dc4e908871$var$dh = !1;
function $92f910dc4e908871$var$Xi(a, b, c, d) {
    b.child = null === a ? $92f910dc4e908871$var$Vg(b, null, c, d) : $92f910dc4e908871$var$Ug(b, a.child, c, d);
}
function $92f910dc4e908871$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $92f910dc4e908871$var$ch(b, e);
    d = $92f910dc4e908871$var$Nh(a, b, c, d, f, e);
    c = $92f910dc4e908871$var$Sh();
    if (null !== a && !$92f910dc4e908871$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $92f910dc4e908871$var$Zi(a, b, e);
    $92f910dc4e908871$var$I && c && $92f910dc4e908871$var$vg(b);
    b.flags |= 1;
    $92f910dc4e908871$var$Xi(a, b, d, e);
    return b.child;
}
function $92f910dc4e908871$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$92f910dc4e908871$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $92f910dc4e908871$var$bj(a, b, f, d, e);
        a = $92f910dc4e908871$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $92f910dc4e908871$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $92f910dc4e908871$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $92f910dc4e908871$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $92f910dc4e908871$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($92f910dc4e908871$var$Ie(f, d) && a.ref === b.ref) {
            if ($92f910dc4e908871$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($92f910dc4e908871$var$dh = !0);
            else return b.lanes = a.lanes, $92f910dc4e908871$var$Zi(a, b, e);
        }
    }
    return $92f910dc4e908871$var$cj(a, b, c, d, e);
}
function $92f910dc4e908871$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $92f910dc4e908871$var$G($92f910dc4e908871$var$ej, $92f910dc4e908871$var$fj), $92f910dc4e908871$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $92f910dc4e908871$var$G($92f910dc4e908871$var$ej, $92f910dc4e908871$var$fj), $92f910dc4e908871$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $92f910dc4e908871$var$G($92f910dc4e908871$var$ej, $92f910dc4e908871$var$fj);
            $92f910dc4e908871$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $92f910dc4e908871$var$G($92f910dc4e908871$var$ej, $92f910dc4e908871$var$fj), $92f910dc4e908871$var$fj |= d;
    $92f910dc4e908871$var$Xi(a, b, e, c);
    return b.child;
}
function $92f910dc4e908871$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $92f910dc4e908871$var$cj(a, b, c, d, e) {
    var f = $92f910dc4e908871$var$Zf(c) ? $92f910dc4e908871$var$Xf : $92f910dc4e908871$var$H.current;
    f = $92f910dc4e908871$var$Yf(b, f);
    $92f910dc4e908871$var$ch(b, e);
    c = $92f910dc4e908871$var$Nh(a, b, c, d, f, e);
    d = $92f910dc4e908871$var$Sh();
    if (null !== a && !$92f910dc4e908871$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $92f910dc4e908871$var$Zi(a, b, e);
    $92f910dc4e908871$var$I && d && $92f910dc4e908871$var$vg(b);
    b.flags |= 1;
    $92f910dc4e908871$var$Xi(a, b, c, e);
    return b.child;
}
function $92f910dc4e908871$var$hj(a, b, c, d, e) {
    if ($92f910dc4e908871$var$Zf(c)) {
        var f = !0;
        $92f910dc4e908871$var$cg(b);
    } else f = !1;
    $92f910dc4e908871$var$ch(b, e);
    if (null === b.stateNode) $92f910dc4e908871$var$ij(a, b), $92f910dc4e908871$var$Gi(b, c, d), $92f910dc4e908871$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $92f910dc4e908871$var$eh(l) : (l = $92f910dc4e908871$var$Zf(c) ? $92f910dc4e908871$var$Xf : $92f910dc4e908871$var$H.current, l = $92f910dc4e908871$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $92f910dc4e908871$var$Hi(b, g, d, l);
        $92f910dc4e908871$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $92f910dc4e908871$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $92f910dc4e908871$var$Wf.current || $92f910dc4e908871$var$jh ? ("function" === typeof m && ($92f910dc4e908871$var$Di(b, c, m, d), k = b.memoizedState), (h = $92f910dc4e908871$var$jh || $92f910dc4e908871$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $92f910dc4e908871$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $92f910dc4e908871$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $92f910dc4e908871$var$eh(k) : (k = $92f910dc4e908871$var$Zf(c) ? $92f910dc4e908871$var$Xf : $92f910dc4e908871$var$H.current, k = $92f910dc4e908871$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $92f910dc4e908871$var$Hi(b, g, d, k);
        $92f910dc4e908871$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $92f910dc4e908871$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $92f910dc4e908871$var$Wf.current || $92f910dc4e908871$var$jh ? ("function" === typeof y && ($92f910dc4e908871$var$Di(b, c, y, d), n = b.memoizedState), (l = $92f910dc4e908871$var$jh || $92f910dc4e908871$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $92f910dc4e908871$var$jj(a, b, c, d, f, e);
}
function $92f910dc4e908871$var$jj(a, b, c, d, e, f) {
    $92f910dc4e908871$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $92f910dc4e908871$var$dg(b, c, !1), $92f910dc4e908871$var$Zi(a, b, f);
    d = b.stateNode;
    $92f910dc4e908871$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $92f910dc4e908871$var$Ug(b, a.child, null, f), b.child = $92f910dc4e908871$var$Ug(b, null, h, f)) : $92f910dc4e908871$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $92f910dc4e908871$var$dg(b, c, !0);
    return b.child;
}
function $92f910dc4e908871$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $92f910dc4e908871$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $92f910dc4e908871$var$ag(a, b.context, !1);
    $92f910dc4e908871$var$yh(a, b.containerInfo);
}
function $92f910dc4e908871$var$lj(a, b, c, d, e) {
    $92f910dc4e908871$var$Ig();
    $92f910dc4e908871$var$Jg(e);
    b.flags |= 256;
    $92f910dc4e908871$var$Xi(a, b, c, d);
    return b.child;
}
var $92f910dc4e908871$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $92f910dc4e908871$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $92f910dc4e908871$var$oj(a, b, c) {
    var d = b.pendingProps, e = $92f910dc4e908871$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $92f910dc4e908871$var$G($92f910dc4e908871$var$L, e & 1);
    if (null === a) {
        $92f910dc4e908871$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $92f910dc4e908871$var$pj(g, d, 0, null), a = $92f910dc4e908871$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $92f910dc4e908871$var$nj(c), b.memoizedState = $92f910dc4e908871$var$mj, a) : $92f910dc4e908871$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $92f910dc4e908871$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $92f910dc4e908871$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $92f910dc4e908871$var$Pg(h, f) : (f = $92f910dc4e908871$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $92f910dc4e908871$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $92f910dc4e908871$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $92f910dc4e908871$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $92f910dc4e908871$var$qj(a, b) {
    b = $92f910dc4e908871$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $92f910dc4e908871$var$sj(a, b, c, d) {
    null !== d && $92f910dc4e908871$var$Jg(d);
    $92f910dc4e908871$var$Ug(b, a.child, null, c);
    a = $92f910dc4e908871$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $92f910dc4e908871$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $92f910dc4e908871$var$Ki(Error($92f910dc4e908871$var$p(422))), $92f910dc4e908871$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $92f910dc4e908871$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $92f910dc4e908871$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $92f910dc4e908871$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $92f910dc4e908871$var$nj(g);
        b.memoizedState = $92f910dc4e908871$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $92f910dc4e908871$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($92f910dc4e908871$var$p(419));
        d = $92f910dc4e908871$var$Ki(f, d, void 0);
        return $92f910dc4e908871$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($92f910dc4e908871$var$dh || h) {
        d = $92f910dc4e908871$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $92f910dc4e908871$var$ih(a, e), $92f910dc4e908871$var$gi(d, a, e, -1));
        }
        $92f910dc4e908871$var$tj();
        d = $92f910dc4e908871$var$Ki(Error($92f910dc4e908871$var$p(421)));
        return $92f910dc4e908871$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $92f910dc4e908871$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $92f910dc4e908871$var$yg = $92f910dc4e908871$var$Lf(e.nextSibling);
    $92f910dc4e908871$var$xg = b;
    $92f910dc4e908871$var$I = !0;
    $92f910dc4e908871$var$zg = null;
    null !== a && ($92f910dc4e908871$var$og[$92f910dc4e908871$var$pg++] = $92f910dc4e908871$var$rg, $92f910dc4e908871$var$og[$92f910dc4e908871$var$pg++] = $92f910dc4e908871$var$sg, $92f910dc4e908871$var$og[$92f910dc4e908871$var$pg++] = $92f910dc4e908871$var$qg, $92f910dc4e908871$var$rg = a.id, $92f910dc4e908871$var$sg = a.overflow, $92f910dc4e908871$var$qg = b);
    b = $92f910dc4e908871$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $92f910dc4e908871$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $92f910dc4e908871$var$bh(a.return, b, c);
}
function $92f910dc4e908871$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $92f910dc4e908871$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $92f910dc4e908871$var$Xi(a, b, d.children, c);
    d = $92f910dc4e908871$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $92f910dc4e908871$var$vj(a, c, b);
            else if (19 === a.tag) $92f910dc4e908871$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $92f910dc4e908871$var$G($92f910dc4e908871$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $92f910dc4e908871$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $92f910dc4e908871$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $92f910dc4e908871$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $92f910dc4e908871$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $92f910dc4e908871$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $92f910dc4e908871$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $92f910dc4e908871$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $92f910dc4e908871$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($92f910dc4e908871$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $92f910dc4e908871$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $92f910dc4e908871$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $92f910dc4e908871$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $92f910dc4e908871$var$kj(b);
            $92f910dc4e908871$var$Ig();
            break;
        case 5:
            $92f910dc4e908871$var$Ah(b);
            break;
        case 1:
            $92f910dc4e908871$var$Zf(b.type) && $92f910dc4e908871$var$cg(b);
            break;
        case 4:
            $92f910dc4e908871$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $92f910dc4e908871$var$G($92f910dc4e908871$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $92f910dc4e908871$var$G($92f910dc4e908871$var$L, $92f910dc4e908871$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $92f910dc4e908871$var$oj(a, b, c);
                $92f910dc4e908871$var$G($92f910dc4e908871$var$L, $92f910dc4e908871$var$L.current & 1);
                a = $92f910dc4e908871$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $92f910dc4e908871$var$G($92f910dc4e908871$var$L, $92f910dc4e908871$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $92f910dc4e908871$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $92f910dc4e908871$var$G($92f910dc4e908871$var$L, $92f910dc4e908871$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $92f910dc4e908871$var$dj(a, b, c);
    }
    return $92f910dc4e908871$var$Zi(a, b, c);
}
var $92f910dc4e908871$var$zj, $92f910dc4e908871$var$Aj, $92f910dc4e908871$var$Bj, $92f910dc4e908871$var$Cj;
$92f910dc4e908871$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$92f910dc4e908871$var$Aj = function() {};
$92f910dc4e908871$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $92f910dc4e908871$var$xh($92f910dc4e908871$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $92f910dc4e908871$var$Ya(a, e);
                d = $92f910dc4e908871$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $92f910dc4e908871$var$A({}, e, {
                    value: void 0
                });
                d = $92f910dc4e908871$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $92f910dc4e908871$var$gb(a, e);
                d = $92f910dc4e908871$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $92f910dc4e908871$var$Bf);
        }
        $92f910dc4e908871$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($92f910dc4e908871$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($92f910dc4e908871$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $92f910dc4e908871$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$92f910dc4e908871$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $92f910dc4e908871$var$Dj(a, b) {
    if (!$92f910dc4e908871$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $92f910dc4e908871$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $92f910dc4e908871$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $92f910dc4e908871$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $92f910dc4e908871$var$S(b), null;
        case 1:
            return $92f910dc4e908871$var$Zf(b.type) && $92f910dc4e908871$var$$f(), $92f910dc4e908871$var$S(b), null;
        case 3:
            d = b.stateNode;
            $92f910dc4e908871$var$zh();
            $92f910dc4e908871$var$E($92f910dc4e908871$var$Wf);
            $92f910dc4e908871$var$E($92f910dc4e908871$var$H);
            $92f910dc4e908871$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $92f910dc4e908871$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $92f910dc4e908871$var$zg && ($92f910dc4e908871$var$Fj($92f910dc4e908871$var$zg), $92f910dc4e908871$var$zg = null));
            $92f910dc4e908871$var$Aj(a, b);
            $92f910dc4e908871$var$S(b);
            return null;
        case 5:
            $92f910dc4e908871$var$Bh(b);
            var e = $92f910dc4e908871$var$xh($92f910dc4e908871$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $92f910dc4e908871$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($92f910dc4e908871$var$p(166));
                    $92f910dc4e908871$var$S(b);
                    return null;
                }
                a = $92f910dc4e908871$var$xh($92f910dc4e908871$var$uh.current);
                if ($92f910dc4e908871$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$92f910dc4e908871$var$Of] = b;
                    d[$92f910dc4e908871$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $92f910dc4e908871$var$D("cancel", d);
                            $92f910dc4e908871$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $92f910dc4e908871$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $92f910dc4e908871$var$lf.length; e++)$92f910dc4e908871$var$D($92f910dc4e908871$var$lf[e], d);
                            break;
                        case "source":
                            $92f910dc4e908871$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $92f910dc4e908871$var$D("error", d);
                            $92f910dc4e908871$var$D("load", d);
                            break;
                        case "details":
                            $92f910dc4e908871$var$D("toggle", d);
                            break;
                        case "input":
                            $92f910dc4e908871$var$Za(d, f);
                            $92f910dc4e908871$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $92f910dc4e908871$var$D("invalid", d);
                            break;
                        case "textarea":
                            $92f910dc4e908871$var$hb(d, f), $92f910dc4e908871$var$D("invalid", d);
                    }
                    $92f910dc4e908871$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $92f910dc4e908871$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $92f910dc4e908871$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $92f910dc4e908871$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $92f910dc4e908871$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $92f910dc4e908871$var$Va(d);
                            $92f910dc4e908871$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $92f910dc4e908871$var$Va(d);
                            $92f910dc4e908871$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $92f910dc4e908871$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $92f910dc4e908871$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$92f910dc4e908871$var$Of] = b;
                    a[$92f910dc4e908871$var$Pf] = d;
                    $92f910dc4e908871$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $92f910dc4e908871$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $92f910dc4e908871$var$D("cancel", a);
                                $92f910dc4e908871$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $92f910dc4e908871$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $92f910dc4e908871$var$lf.length; e++)$92f910dc4e908871$var$D($92f910dc4e908871$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $92f910dc4e908871$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $92f910dc4e908871$var$D("error", a);
                                $92f910dc4e908871$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $92f910dc4e908871$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $92f910dc4e908871$var$Za(a, d);
                                e = $92f910dc4e908871$var$Ya(a, d);
                                $92f910dc4e908871$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $92f910dc4e908871$var$A({}, d, {
                                    value: void 0
                                });
                                $92f910dc4e908871$var$D("invalid", a);
                                break;
                            case "textarea":
                                $92f910dc4e908871$var$hb(a, d);
                                e = $92f910dc4e908871$var$gb(a, d);
                                $92f910dc4e908871$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $92f910dc4e908871$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $92f910dc4e908871$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $92f910dc4e908871$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $92f910dc4e908871$var$ob(a, k) : "number" === typeof k && $92f910dc4e908871$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($92f910dc4e908871$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $92f910dc4e908871$var$D("scroll", a) : null != k && $92f910dc4e908871$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $92f910dc4e908871$var$Va(a);
                                $92f910dc4e908871$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $92f910dc4e908871$var$Va(a);
                                $92f910dc4e908871$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $92f910dc4e908871$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $92f910dc4e908871$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $92f910dc4e908871$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $92f910dc4e908871$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $92f910dc4e908871$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $92f910dc4e908871$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($92f910dc4e908871$var$p(166));
                c = $92f910dc4e908871$var$xh($92f910dc4e908871$var$wh.current);
                $92f910dc4e908871$var$xh($92f910dc4e908871$var$uh.current);
                if ($92f910dc4e908871$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$92f910dc4e908871$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $92f910dc4e908871$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $92f910dc4e908871$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $92f910dc4e908871$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$92f910dc4e908871$var$Of] = b, b.stateNode = d;
            }
            $92f910dc4e908871$var$S(b);
            return null;
        case 13:
            $92f910dc4e908871$var$E($92f910dc4e908871$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($92f910dc4e908871$var$I && null !== $92f910dc4e908871$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $92f910dc4e908871$var$Hg(), $92f910dc4e908871$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $92f910dc4e908871$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($92f910dc4e908871$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($92f910dc4e908871$var$p(317));
                        f[$92f910dc4e908871$var$Of] = b;
                    } else $92f910dc4e908871$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $92f910dc4e908871$var$S(b);
                    f = !1;
                } else null !== $92f910dc4e908871$var$zg && ($92f910dc4e908871$var$Fj($92f910dc4e908871$var$zg), $92f910dc4e908871$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($92f910dc4e908871$var$L.current & 1) ? 0 === $92f910dc4e908871$var$T && ($92f910dc4e908871$var$T = 3) : $92f910dc4e908871$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $92f910dc4e908871$var$S(b);
            return null;
        case 4:
            return $92f910dc4e908871$var$zh(), $92f910dc4e908871$var$Aj(a, b), null === a && $92f910dc4e908871$var$sf(b.stateNode.containerInfo), $92f910dc4e908871$var$S(b), null;
        case 10:
            return $92f910dc4e908871$var$ah(b.type._context), $92f910dc4e908871$var$S(b), null;
        case 17:
            return $92f910dc4e908871$var$Zf(b.type) && $92f910dc4e908871$var$$f(), $92f910dc4e908871$var$S(b), null;
        case 19:
            $92f910dc4e908871$var$E($92f910dc4e908871$var$L);
            f = b.memoizedState;
            if (null === f) return $92f910dc4e908871$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $92f910dc4e908871$var$Dj(f, !1);
                else {
                    if (0 !== $92f910dc4e908871$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $92f910dc4e908871$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $92f910dc4e908871$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $92f910dc4e908871$var$G($92f910dc4e908871$var$L, $92f910dc4e908871$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $92f910dc4e908871$var$B() > $92f910dc4e908871$var$Gj && (b.flags |= 128, d = !0, $92f910dc4e908871$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $92f910dc4e908871$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $92f910dc4e908871$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$92f910dc4e908871$var$I) return $92f910dc4e908871$var$S(b), null;
                    } else 2 * $92f910dc4e908871$var$B() - f.renderingStartTime > $92f910dc4e908871$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $92f910dc4e908871$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $92f910dc4e908871$var$B(), b.sibling = null, c = $92f910dc4e908871$var$L.current, $92f910dc4e908871$var$G($92f910dc4e908871$var$L, d ? c & 1 | 2 : c & 1), b;
            $92f910dc4e908871$var$S(b);
            return null;
        case 22:
        case 23:
            return $92f910dc4e908871$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($92f910dc4e908871$var$fj & 1073741824) && ($92f910dc4e908871$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $92f910dc4e908871$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($92f910dc4e908871$var$p(156, b.tag));
}
function $92f910dc4e908871$var$Ij(a, b) {
    $92f910dc4e908871$var$wg(b);
    switch(b.tag){
        case 1:
            return $92f910dc4e908871$var$Zf(b.type) && $92f910dc4e908871$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $92f910dc4e908871$var$zh(), $92f910dc4e908871$var$E($92f910dc4e908871$var$Wf), $92f910dc4e908871$var$E($92f910dc4e908871$var$H), $92f910dc4e908871$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $92f910dc4e908871$var$Bh(b), null;
        case 13:
            $92f910dc4e908871$var$E($92f910dc4e908871$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($92f910dc4e908871$var$p(340));
                $92f910dc4e908871$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $92f910dc4e908871$var$E($92f910dc4e908871$var$L), null;
        case 4:
            return $92f910dc4e908871$var$zh(), null;
        case 10:
            return $92f910dc4e908871$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $92f910dc4e908871$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $92f910dc4e908871$var$Jj = !1, $92f910dc4e908871$var$U = !1, $92f910dc4e908871$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $92f910dc4e908871$var$V = null;
function $92f910dc4e908871$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $92f910dc4e908871$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $92f910dc4e908871$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $92f910dc4e908871$var$W(a, b, d);
    }
}
var $92f910dc4e908871$var$Nj = !1;
function $92f910dc4e908871$var$Oj(a, b) {
    $92f910dc4e908871$var$Cf = $92f910dc4e908871$var$dd;
    a = $92f910dc4e908871$var$Me();
    if ($92f910dc4e908871$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $92f910dc4e908871$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $92f910dc4e908871$var$dd = !1;
    for($92f910dc4e908871$var$V = b; null !== $92f910dc4e908871$var$V;)if (b = $92f910dc4e908871$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $92f910dc4e908871$var$V = a;
    else for(; null !== $92f910dc4e908871$var$V;){
        b = $92f910dc4e908871$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $92f910dc4e908871$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($92f910dc4e908871$var$p(163));
            }
        } catch (F) {
            $92f910dc4e908871$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $92f910dc4e908871$var$V = a;
            break;
        }
        $92f910dc4e908871$var$V = b.return;
    }
    n = $92f910dc4e908871$var$Nj;
    $92f910dc4e908871$var$Nj = !1;
    return n;
}
function $92f910dc4e908871$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $92f910dc4e908871$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $92f910dc4e908871$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $92f910dc4e908871$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $92f910dc4e908871$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $92f910dc4e908871$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$92f910dc4e908871$var$Of], delete b[$92f910dc4e908871$var$Pf], delete b[$92f910dc4e908871$var$of], delete b[$92f910dc4e908871$var$Qf], delete b[$92f910dc4e908871$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $92f910dc4e908871$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $92f910dc4e908871$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $92f910dc4e908871$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $92f910dc4e908871$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $92f910dc4e908871$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($92f910dc4e908871$var$Vj(a, b, c), a = a.sibling; null !== a;)$92f910dc4e908871$var$Vj(a, b, c), a = a.sibling;
}
function $92f910dc4e908871$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($92f910dc4e908871$var$Wj(a, b, c), a = a.sibling; null !== a;)$92f910dc4e908871$var$Wj(a, b, c), a = a.sibling;
}
var $92f910dc4e908871$var$X = null, $92f910dc4e908871$var$Xj = !1;
function $92f910dc4e908871$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$92f910dc4e908871$var$Zj(a, b, c), c = c.sibling;
}
function $92f910dc4e908871$var$Zj(a, b, c) {
    if ($92f910dc4e908871$var$lc && "function" === typeof $92f910dc4e908871$var$lc.onCommitFiberUnmount) try {
        $92f910dc4e908871$var$lc.onCommitFiberUnmount($92f910dc4e908871$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $92f910dc4e908871$var$U || $92f910dc4e908871$var$Lj(c, b);
        case 6:
            var d = $92f910dc4e908871$var$X, e = $92f910dc4e908871$var$Xj;
            $92f910dc4e908871$var$X = null;
            $92f910dc4e908871$var$Yj(a, b, c);
            $92f910dc4e908871$var$X = d;
            $92f910dc4e908871$var$Xj = e;
            null !== $92f910dc4e908871$var$X && ($92f910dc4e908871$var$Xj ? (a = $92f910dc4e908871$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $92f910dc4e908871$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $92f910dc4e908871$var$X && ($92f910dc4e908871$var$Xj ? (a = $92f910dc4e908871$var$X, c = c.stateNode, 8 === a.nodeType ? $92f910dc4e908871$var$Kf(a.parentNode, c) : 1 === a.nodeType && $92f910dc4e908871$var$Kf(a, c), $92f910dc4e908871$var$bd(a)) : $92f910dc4e908871$var$Kf($92f910dc4e908871$var$X, c.stateNode));
            break;
        case 4:
            d = $92f910dc4e908871$var$X;
            e = $92f910dc4e908871$var$Xj;
            $92f910dc4e908871$var$X = c.stateNode.containerInfo;
            $92f910dc4e908871$var$Xj = !0;
            $92f910dc4e908871$var$Yj(a, b, c);
            $92f910dc4e908871$var$X = d;
            $92f910dc4e908871$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$92f910dc4e908871$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $92f910dc4e908871$var$Mj(c, b, g) : 0 !== (f & 4) && $92f910dc4e908871$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $92f910dc4e908871$var$Yj(a, b, c);
            break;
        case 1:
            if (!$92f910dc4e908871$var$U && ($92f910dc4e908871$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $92f910dc4e908871$var$W(c, b, h);
            }
            $92f910dc4e908871$var$Yj(a, b, c);
            break;
        case 21:
            $92f910dc4e908871$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($92f910dc4e908871$var$U = (d = $92f910dc4e908871$var$U) || null !== c.memoizedState, $92f910dc4e908871$var$Yj(a, b, c), $92f910dc4e908871$var$U = d) : $92f910dc4e908871$var$Yj(a, b, c);
            break;
        default:
            $92f910dc4e908871$var$Yj(a, b, c);
    }
}
function $92f910dc4e908871$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $92f910dc4e908871$var$Kj);
        b.forEach(function(b) {
            var d = $92f910dc4e908871$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $92f910dc4e908871$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $92f910dc4e908871$var$X = h.stateNode;
                        $92f910dc4e908871$var$Xj = !1;
                        break a;
                    case 3:
                        $92f910dc4e908871$var$X = h.stateNode.containerInfo;
                        $92f910dc4e908871$var$Xj = !0;
                        break a;
                    case 4:
                        $92f910dc4e908871$var$X = h.stateNode.containerInfo;
                        $92f910dc4e908871$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $92f910dc4e908871$var$X) throw Error($92f910dc4e908871$var$p(160));
            $92f910dc4e908871$var$Zj(f, g, e);
            $92f910dc4e908871$var$X = null;
            $92f910dc4e908871$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $92f910dc4e908871$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$92f910dc4e908871$var$dk(b, a), b = b.sibling;
}
function $92f910dc4e908871$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $92f910dc4e908871$var$ck(b, a);
            $92f910dc4e908871$var$ek(a);
            if (d & 4) {
                try {
                    $92f910dc4e908871$var$Pj(3, a, a.return), $92f910dc4e908871$var$Qj(3, a);
                } catch (t) {
                    $92f910dc4e908871$var$W(a, a.return, t);
                }
                try {
                    $92f910dc4e908871$var$Pj(5, a, a.return);
                } catch (t) {
                    $92f910dc4e908871$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $92f910dc4e908871$var$ck(b, a);
            $92f910dc4e908871$var$ek(a);
            d & 512 && null !== c && $92f910dc4e908871$var$Lj(c, c.return);
            break;
        case 5:
            $92f910dc4e908871$var$ck(b, a);
            $92f910dc4e908871$var$ek(a);
            d & 512 && null !== c && $92f910dc4e908871$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $92f910dc4e908871$var$ob(e, "");
                } catch (t) {
                    $92f910dc4e908871$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $92f910dc4e908871$var$ab(e, f);
                    $92f910dc4e908871$var$vb(h, g);
                    var l = $92f910dc4e908871$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $92f910dc4e908871$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $92f910dc4e908871$var$nb(e, q) : "children" === m ? $92f910dc4e908871$var$ob(e, q) : $92f910dc4e908871$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $92f910dc4e908871$var$bb(e, f);
                            break;
                        case "textarea":
                            $92f910dc4e908871$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $92f910dc4e908871$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $92f910dc4e908871$var$fb(e, !!f.multiple, f.defaultValue, !0) : $92f910dc4e908871$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$92f910dc4e908871$var$Pf] = f;
                } catch (t) {
                    $92f910dc4e908871$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $92f910dc4e908871$var$ck(b, a);
            $92f910dc4e908871$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($92f910dc4e908871$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $92f910dc4e908871$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $92f910dc4e908871$var$ck(b, a);
            $92f910dc4e908871$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $92f910dc4e908871$var$bd(b.containerInfo);
            } catch (t) {
                $92f910dc4e908871$var$W(a, a.return, t);
            }
            break;
        case 4:
            $92f910dc4e908871$var$ck(b, a);
            $92f910dc4e908871$var$ek(a);
            break;
        case 13:
            $92f910dc4e908871$var$ck(b, a);
            $92f910dc4e908871$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($92f910dc4e908871$var$fk = $92f910dc4e908871$var$B()));
            d & 4 && $92f910dc4e908871$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($92f910dc4e908871$var$U = (l = $92f910dc4e908871$var$U) || m, $92f910dc4e908871$var$ck(b, a), $92f910dc4e908871$var$U = l) : $92f910dc4e908871$var$ck(b, a);
            $92f910dc4e908871$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($92f910dc4e908871$var$V = a, m = a.child; null !== m;){
                    for(q = $92f910dc4e908871$var$V = m; null !== $92f910dc4e908871$var$V;){
                        r = $92f910dc4e908871$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $92f910dc4e908871$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $92f910dc4e908871$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $92f910dc4e908871$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $92f910dc4e908871$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $92f910dc4e908871$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $92f910dc4e908871$var$V = y) : $92f910dc4e908871$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $92f910dc4e908871$var$rb("display", g));
                            } catch (t) {
                                $92f910dc4e908871$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $92f910dc4e908871$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $92f910dc4e908871$var$ck(b, a);
            $92f910dc4e908871$var$ek(a);
            d & 4 && $92f910dc4e908871$var$ak(a);
            break;
        case 21:
            break;
        default:
            $92f910dc4e908871$var$ck(b, a), $92f910dc4e908871$var$ek(a);
    }
}
function $92f910dc4e908871$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($92f910dc4e908871$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($92f910dc4e908871$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($92f910dc4e908871$var$ob(e, ""), d.flags &= -33);
                    var f = $92f910dc4e908871$var$Uj(a);
                    $92f910dc4e908871$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $92f910dc4e908871$var$Uj(a);
                    $92f910dc4e908871$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($92f910dc4e908871$var$p(161));
            }
        } catch (k) {
            $92f910dc4e908871$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $92f910dc4e908871$var$hk(a, b, c) {
    $92f910dc4e908871$var$V = a;
    $92f910dc4e908871$var$ik(a, b, c);
}
function $92f910dc4e908871$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $92f910dc4e908871$var$V;){
        var e = $92f910dc4e908871$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $92f910dc4e908871$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $92f910dc4e908871$var$U;
                h = $92f910dc4e908871$var$Jj;
                var l = $92f910dc4e908871$var$U;
                $92f910dc4e908871$var$Jj = g;
                if (($92f910dc4e908871$var$U = k) && !l) for($92f910dc4e908871$var$V = e; null !== $92f910dc4e908871$var$V;)g = $92f910dc4e908871$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $92f910dc4e908871$var$jk(e) : null !== k ? (k.return = g, $92f910dc4e908871$var$V = k) : $92f910dc4e908871$var$jk(e);
                for(; null !== f;)$92f910dc4e908871$var$V = f, $92f910dc4e908871$var$ik(f, b, c), f = f.sibling;
                $92f910dc4e908871$var$V = e;
                $92f910dc4e908871$var$Jj = h;
                $92f910dc4e908871$var$U = l;
            }
            $92f910dc4e908871$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $92f910dc4e908871$var$V = f) : $92f910dc4e908871$var$kk(a, b, c);
    }
}
function $92f910dc4e908871$var$kk(a) {
    for(; null !== $92f910dc4e908871$var$V;){
        var b = $92f910dc4e908871$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $92f910dc4e908871$var$U || $92f910dc4e908871$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$92f910dc4e908871$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $92f910dc4e908871$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $92f910dc4e908871$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $92f910dc4e908871$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $92f910dc4e908871$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($92f910dc4e908871$var$p(163));
                }
                $92f910dc4e908871$var$U || b.flags & 512 && $92f910dc4e908871$var$Rj(b);
            } catch (r) {
                $92f910dc4e908871$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $92f910dc4e908871$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $92f910dc4e908871$var$V = c;
            break;
        }
        $92f910dc4e908871$var$V = b.return;
    }
}
function $92f910dc4e908871$var$gk(a) {
    for(; null !== $92f910dc4e908871$var$V;){
        var b = $92f910dc4e908871$var$V;
        if (b === a) {
            $92f910dc4e908871$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $92f910dc4e908871$var$V = c;
            break;
        }
        $92f910dc4e908871$var$V = b.return;
    }
}
function $92f910dc4e908871$var$jk(a) {
    for(; null !== $92f910dc4e908871$var$V;){
        var b = $92f910dc4e908871$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $92f910dc4e908871$var$Qj(4, b);
                    } catch (k) {
                        $92f910dc4e908871$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $92f910dc4e908871$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $92f910dc4e908871$var$Rj(b);
                    } catch (k) {
                        $92f910dc4e908871$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $92f910dc4e908871$var$Rj(b);
                    } catch (k) {
                        $92f910dc4e908871$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $92f910dc4e908871$var$W(b, b.return, k);
        }
        if (b === a) {
            $92f910dc4e908871$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $92f910dc4e908871$var$V = h;
            break;
        }
        $92f910dc4e908871$var$V = b.return;
    }
}
var $92f910dc4e908871$var$lk = Math.ceil, $92f910dc4e908871$var$mk = $92f910dc4e908871$var$ua.ReactCurrentDispatcher, $92f910dc4e908871$var$nk = $92f910dc4e908871$var$ua.ReactCurrentOwner, $92f910dc4e908871$var$ok = $92f910dc4e908871$var$ua.ReactCurrentBatchConfig, $92f910dc4e908871$var$K = 0, $92f910dc4e908871$var$Q = null, $92f910dc4e908871$var$Y = null, $92f910dc4e908871$var$Z = 0, $92f910dc4e908871$var$fj = 0, $92f910dc4e908871$var$ej = $92f910dc4e908871$var$Uf(0), $92f910dc4e908871$var$T = 0, $92f910dc4e908871$var$pk = null, $92f910dc4e908871$var$rh = 0, $92f910dc4e908871$var$qk = 0, $92f910dc4e908871$var$rk = 0, $92f910dc4e908871$var$sk = null, $92f910dc4e908871$var$tk = null, $92f910dc4e908871$var$fk = 0, $92f910dc4e908871$var$Gj = Infinity, $92f910dc4e908871$var$uk = null, $92f910dc4e908871$var$Oi = !1, $92f910dc4e908871$var$Pi = null, $92f910dc4e908871$var$Ri = null, $92f910dc4e908871$var$vk = !1, $92f910dc4e908871$var$wk = null, $92f910dc4e908871$var$xk = 0, $92f910dc4e908871$var$yk = 0, $92f910dc4e908871$var$zk = null, $92f910dc4e908871$var$Ak = -1, $92f910dc4e908871$var$Bk = 0;
function $92f910dc4e908871$var$R() {
    return 0 !== ($92f910dc4e908871$var$K & 6) ? $92f910dc4e908871$var$B() : -1 !== $92f910dc4e908871$var$Ak ? $92f910dc4e908871$var$Ak : $92f910dc4e908871$var$Ak = $92f910dc4e908871$var$B();
}
function $92f910dc4e908871$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($92f910dc4e908871$var$K & 2) && 0 !== $92f910dc4e908871$var$Z) return $92f910dc4e908871$var$Z & -$92f910dc4e908871$var$Z;
    if (null !== $92f910dc4e908871$var$Kg.transition) return 0 === $92f910dc4e908871$var$Bk && ($92f910dc4e908871$var$Bk = $92f910dc4e908871$var$yc()), $92f910dc4e908871$var$Bk;
    a = $92f910dc4e908871$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $92f910dc4e908871$var$jd(a.type);
    return a;
}
function $92f910dc4e908871$var$gi(a, b, c, d) {
    if (50 < $92f910dc4e908871$var$yk) throw $92f910dc4e908871$var$yk = 0, $92f910dc4e908871$var$zk = null, Error($92f910dc4e908871$var$p(185));
    $92f910dc4e908871$var$Ac(a, c, d);
    if (0 === ($92f910dc4e908871$var$K & 2) || a !== $92f910dc4e908871$var$Q) a === $92f910dc4e908871$var$Q && (0 === ($92f910dc4e908871$var$K & 2) && ($92f910dc4e908871$var$qk |= c), 4 === $92f910dc4e908871$var$T && $92f910dc4e908871$var$Ck(a, $92f910dc4e908871$var$Z)), $92f910dc4e908871$var$Dk(a, d), 1 === c && 0 === $92f910dc4e908871$var$K && 0 === (b.mode & 1) && ($92f910dc4e908871$var$Gj = $92f910dc4e908871$var$B() + 500, $92f910dc4e908871$var$fg && $92f910dc4e908871$var$jg());
}
function $92f910dc4e908871$var$Dk(a, b) {
    var c = a.callbackNode;
    $92f910dc4e908871$var$wc(a, b);
    var d = $92f910dc4e908871$var$uc(a, a === $92f910dc4e908871$var$Q ? $92f910dc4e908871$var$Z : 0);
    if (0 === d) null !== c && $92f910dc4e908871$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $92f910dc4e908871$var$bc(c);
        if (1 === b) 0 === a.tag ? $92f910dc4e908871$var$ig($92f910dc4e908871$var$Ek.bind(null, a)) : $92f910dc4e908871$var$hg($92f910dc4e908871$var$Ek.bind(null, a)), $92f910dc4e908871$var$Jf(function() {
            0 === ($92f910dc4e908871$var$K & 6) && $92f910dc4e908871$var$jg();
        }), c = null;
        else {
            switch($92f910dc4e908871$var$Dc(d)){
                case 1:
                    c = $92f910dc4e908871$var$fc;
                    break;
                case 4:
                    c = $92f910dc4e908871$var$gc;
                    break;
                case 16:
                    c = $92f910dc4e908871$var$hc;
                    break;
                case 536870912:
                    c = $92f910dc4e908871$var$jc;
                    break;
                default:
                    c = $92f910dc4e908871$var$hc;
            }
            c = $92f910dc4e908871$var$Fk(c, $92f910dc4e908871$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $92f910dc4e908871$var$Gk(a, b) {
    $92f910dc4e908871$var$Ak = -1;
    $92f910dc4e908871$var$Bk = 0;
    if (0 !== ($92f910dc4e908871$var$K & 6)) throw Error($92f910dc4e908871$var$p(327));
    var c = a.callbackNode;
    if ($92f910dc4e908871$var$Hk() && a.callbackNode !== c) return null;
    var d = $92f910dc4e908871$var$uc(a, a === $92f910dc4e908871$var$Q ? $92f910dc4e908871$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $92f910dc4e908871$var$Ik(a, d);
    else {
        b = d;
        var e = $92f910dc4e908871$var$K;
        $92f910dc4e908871$var$K |= 2;
        var f = $92f910dc4e908871$var$Jk();
        if ($92f910dc4e908871$var$Q !== a || $92f910dc4e908871$var$Z !== b) $92f910dc4e908871$var$uk = null, $92f910dc4e908871$var$Gj = $92f910dc4e908871$var$B() + 500, $92f910dc4e908871$var$Kk(a, b);
        for(;;)try {
            $92f910dc4e908871$var$Lk();
            break;
        } catch (h) {
            $92f910dc4e908871$var$Mk(a, h);
        }
        $92f910dc4e908871$var$$g();
        $92f910dc4e908871$var$mk.current = f;
        $92f910dc4e908871$var$K = e;
        null !== $92f910dc4e908871$var$Y ? b = 0 : ($92f910dc4e908871$var$Q = null, $92f910dc4e908871$var$Z = 0, b = $92f910dc4e908871$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $92f910dc4e908871$var$xc(a), 0 !== e && (d = e, b = $92f910dc4e908871$var$Nk(a, e)));
        if (1 === b) throw c = $92f910dc4e908871$var$pk, $92f910dc4e908871$var$Kk(a, 0), $92f910dc4e908871$var$Ck(a, d), $92f910dc4e908871$var$Dk(a, $92f910dc4e908871$var$B()), c;
        if (6 === b) $92f910dc4e908871$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$92f910dc4e908871$var$Ok(e) && (b = $92f910dc4e908871$var$Ik(a, d), 2 === b && (f = $92f910dc4e908871$var$xc(a), 0 !== f && (d = f, b = $92f910dc4e908871$var$Nk(a, f))), 1 === b)) throw c = $92f910dc4e908871$var$pk, $92f910dc4e908871$var$Kk(a, 0), $92f910dc4e908871$var$Ck(a, d), $92f910dc4e908871$var$Dk(a, $92f910dc4e908871$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($92f910dc4e908871$var$p(345));
                case 2:
                    $92f910dc4e908871$var$Pk(a, $92f910dc4e908871$var$tk, $92f910dc4e908871$var$uk);
                    break;
                case 3:
                    $92f910dc4e908871$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $92f910dc4e908871$var$fk + 500 - $92f910dc4e908871$var$B(), 10 < b)) {
                        if (0 !== $92f910dc4e908871$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $92f910dc4e908871$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $92f910dc4e908871$var$Ff($92f910dc4e908871$var$Pk.bind(null, a, $92f910dc4e908871$var$tk, $92f910dc4e908871$var$uk), b);
                        break;
                    }
                    $92f910dc4e908871$var$Pk(a, $92f910dc4e908871$var$tk, $92f910dc4e908871$var$uk);
                    break;
                case 4:
                    $92f910dc4e908871$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $92f910dc4e908871$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $92f910dc4e908871$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $92f910dc4e908871$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $92f910dc4e908871$var$Ff($92f910dc4e908871$var$Pk.bind(null, a, $92f910dc4e908871$var$tk, $92f910dc4e908871$var$uk), d);
                        break;
                    }
                    $92f910dc4e908871$var$Pk(a, $92f910dc4e908871$var$tk, $92f910dc4e908871$var$uk);
                    break;
                case 5:
                    $92f910dc4e908871$var$Pk(a, $92f910dc4e908871$var$tk, $92f910dc4e908871$var$uk);
                    break;
                default:
                    throw Error($92f910dc4e908871$var$p(329));
            }
        }
    }
    $92f910dc4e908871$var$Dk(a, $92f910dc4e908871$var$B());
    return a.callbackNode === c ? $92f910dc4e908871$var$Gk.bind(null, a) : null;
}
function $92f910dc4e908871$var$Nk(a, b) {
    var c = $92f910dc4e908871$var$sk;
    a.current.memoizedState.isDehydrated && ($92f910dc4e908871$var$Kk(a, b).flags |= 256);
    a = $92f910dc4e908871$var$Ik(a, b);
    2 !== a && (b = $92f910dc4e908871$var$tk, $92f910dc4e908871$var$tk = c, null !== b && $92f910dc4e908871$var$Fj(b));
    return a;
}
function $92f910dc4e908871$var$Fj(a) {
    null === $92f910dc4e908871$var$tk ? $92f910dc4e908871$var$tk = a : $92f910dc4e908871$var$tk.push.apply($92f910dc4e908871$var$tk, a);
}
function $92f910dc4e908871$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$92f910dc4e908871$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $92f910dc4e908871$var$Ck(a, b) {
    b &= ~$92f910dc4e908871$var$rk;
    b &= ~$92f910dc4e908871$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $92f910dc4e908871$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $92f910dc4e908871$var$Ek(a) {
    if (0 !== ($92f910dc4e908871$var$K & 6)) throw Error($92f910dc4e908871$var$p(327));
    $92f910dc4e908871$var$Hk();
    var b = $92f910dc4e908871$var$uc(a, 0);
    if (0 === (b & 1)) return $92f910dc4e908871$var$Dk(a, $92f910dc4e908871$var$B()), null;
    var c = $92f910dc4e908871$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $92f910dc4e908871$var$xc(a);
        0 !== d && (b = d, c = $92f910dc4e908871$var$Nk(a, d));
    }
    if (1 === c) throw c = $92f910dc4e908871$var$pk, $92f910dc4e908871$var$Kk(a, 0), $92f910dc4e908871$var$Ck(a, b), $92f910dc4e908871$var$Dk(a, $92f910dc4e908871$var$B()), c;
    if (6 === c) throw Error($92f910dc4e908871$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $92f910dc4e908871$var$Pk(a, $92f910dc4e908871$var$tk, $92f910dc4e908871$var$uk);
    $92f910dc4e908871$var$Dk(a, $92f910dc4e908871$var$B());
    return null;
}
function $92f910dc4e908871$var$Qk(a, b) {
    var c = $92f910dc4e908871$var$K;
    $92f910dc4e908871$var$K |= 1;
    try {
        return a(b);
    } finally{
        $92f910dc4e908871$var$K = c, 0 === $92f910dc4e908871$var$K && ($92f910dc4e908871$var$Gj = $92f910dc4e908871$var$B() + 500, $92f910dc4e908871$var$fg && $92f910dc4e908871$var$jg());
    }
}
function $92f910dc4e908871$var$Rk(a) {
    null !== $92f910dc4e908871$var$wk && 0 === $92f910dc4e908871$var$wk.tag && 0 === ($92f910dc4e908871$var$K & 6) && $92f910dc4e908871$var$Hk();
    var b = $92f910dc4e908871$var$K;
    $92f910dc4e908871$var$K |= 1;
    var c = $92f910dc4e908871$var$ok.transition, d = $92f910dc4e908871$var$C;
    try {
        if ($92f910dc4e908871$var$ok.transition = null, $92f910dc4e908871$var$C = 1, a) return a();
    } finally{
        $92f910dc4e908871$var$C = d, $92f910dc4e908871$var$ok.transition = c, $92f910dc4e908871$var$K = b, 0 === ($92f910dc4e908871$var$K & 6) && $92f910dc4e908871$var$jg();
    }
}
function $92f910dc4e908871$var$Hj() {
    $92f910dc4e908871$var$fj = $92f910dc4e908871$var$ej.current;
    $92f910dc4e908871$var$E($92f910dc4e908871$var$ej);
}
function $92f910dc4e908871$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $92f910dc4e908871$var$Gf(c));
    if (null !== $92f910dc4e908871$var$Y) for(c = $92f910dc4e908871$var$Y.return; null !== c;){
        var d = c;
        $92f910dc4e908871$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $92f910dc4e908871$var$$f();
                break;
            case 3:
                $92f910dc4e908871$var$zh();
                $92f910dc4e908871$var$E($92f910dc4e908871$var$Wf);
                $92f910dc4e908871$var$E($92f910dc4e908871$var$H);
                $92f910dc4e908871$var$Eh();
                break;
            case 5:
                $92f910dc4e908871$var$Bh(d);
                break;
            case 4:
                $92f910dc4e908871$var$zh();
                break;
            case 13:
                $92f910dc4e908871$var$E($92f910dc4e908871$var$L);
                break;
            case 19:
                $92f910dc4e908871$var$E($92f910dc4e908871$var$L);
                break;
            case 10:
                $92f910dc4e908871$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $92f910dc4e908871$var$Hj();
        }
        c = c.return;
    }
    $92f910dc4e908871$var$Q = a;
    $92f910dc4e908871$var$Y = a = $92f910dc4e908871$var$Pg(a.current, null);
    $92f910dc4e908871$var$Z = $92f910dc4e908871$var$fj = b;
    $92f910dc4e908871$var$T = 0;
    $92f910dc4e908871$var$pk = null;
    $92f910dc4e908871$var$rk = $92f910dc4e908871$var$qk = $92f910dc4e908871$var$rh = 0;
    $92f910dc4e908871$var$tk = $92f910dc4e908871$var$sk = null;
    if (null !== $92f910dc4e908871$var$fh) {
        for(b = 0; b < $92f910dc4e908871$var$fh.length; b++)if (c = $92f910dc4e908871$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $92f910dc4e908871$var$fh = null;
    }
    return a;
}
function $92f910dc4e908871$var$Mk(a, b) {
    do {
        var c = $92f910dc4e908871$var$Y;
        try {
            $92f910dc4e908871$var$$g();
            $92f910dc4e908871$var$Fh.current = $92f910dc4e908871$var$Rh;
            if ($92f910dc4e908871$var$Ih) {
                for(var d = $92f910dc4e908871$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $92f910dc4e908871$var$Ih = !1;
            }
            $92f910dc4e908871$var$Hh = 0;
            $92f910dc4e908871$var$O = $92f910dc4e908871$var$N = $92f910dc4e908871$var$M = null;
            $92f910dc4e908871$var$Jh = !1;
            $92f910dc4e908871$var$Kh = 0;
            $92f910dc4e908871$var$nk.current = null;
            if (null === c || null === c.return) {
                $92f910dc4e908871$var$T = 1;
                $92f910dc4e908871$var$pk = b;
                $92f910dc4e908871$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $92f910dc4e908871$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $92f910dc4e908871$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $92f910dc4e908871$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $92f910dc4e908871$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $92f910dc4e908871$var$Si(f, l, b);
                            $92f910dc4e908871$var$tj();
                            break a;
                        }
                        k = Error($92f910dc4e908871$var$p(426));
                    }
                } else if ($92f910dc4e908871$var$I && h.mode & 1) {
                    var J = $92f910dc4e908871$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $92f910dc4e908871$var$Vi(J, g, h, f, b);
                        $92f910dc4e908871$var$Jg($92f910dc4e908871$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $92f910dc4e908871$var$Ji(k, h);
                4 !== $92f910dc4e908871$var$T && ($92f910dc4e908871$var$T = 2);
                null === $92f910dc4e908871$var$sk ? $92f910dc4e908871$var$sk = [
                    f
                ] : $92f910dc4e908871$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $92f910dc4e908871$var$Ni(f, k, b);
                            $92f910dc4e908871$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $92f910dc4e908871$var$Ri || !$92f910dc4e908871$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $92f910dc4e908871$var$Qi(f, h, b);
                                $92f910dc4e908871$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $92f910dc4e908871$var$Sk(c);
        } catch (na) {
            b = na;
            $92f910dc4e908871$var$Y === c && null !== c && ($92f910dc4e908871$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $92f910dc4e908871$var$Jk() {
    var a = $92f910dc4e908871$var$mk.current;
    $92f910dc4e908871$var$mk.current = $92f910dc4e908871$var$Rh;
    return null === a ? $92f910dc4e908871$var$Rh : a;
}
function $92f910dc4e908871$var$tj() {
    if (0 === $92f910dc4e908871$var$T || 3 === $92f910dc4e908871$var$T || 2 === $92f910dc4e908871$var$T) $92f910dc4e908871$var$T = 4;
    null === $92f910dc4e908871$var$Q || 0 === ($92f910dc4e908871$var$rh & 268435455) && 0 === ($92f910dc4e908871$var$qk & 268435455) || $92f910dc4e908871$var$Ck($92f910dc4e908871$var$Q, $92f910dc4e908871$var$Z);
}
function $92f910dc4e908871$var$Ik(a, b) {
    var c = $92f910dc4e908871$var$K;
    $92f910dc4e908871$var$K |= 2;
    var d = $92f910dc4e908871$var$Jk();
    if ($92f910dc4e908871$var$Q !== a || $92f910dc4e908871$var$Z !== b) $92f910dc4e908871$var$uk = null, $92f910dc4e908871$var$Kk(a, b);
    for(;;)try {
        $92f910dc4e908871$var$Tk();
        break;
    } catch (e) {
        $92f910dc4e908871$var$Mk(a, e);
    }
    $92f910dc4e908871$var$$g();
    $92f910dc4e908871$var$K = c;
    $92f910dc4e908871$var$mk.current = d;
    if (null !== $92f910dc4e908871$var$Y) throw Error($92f910dc4e908871$var$p(261));
    $92f910dc4e908871$var$Q = null;
    $92f910dc4e908871$var$Z = 0;
    return $92f910dc4e908871$var$T;
}
function $92f910dc4e908871$var$Tk() {
    for(; null !== $92f910dc4e908871$var$Y;)$92f910dc4e908871$var$Uk($92f910dc4e908871$var$Y);
}
function $92f910dc4e908871$var$Lk() {
    for(; null !== $92f910dc4e908871$var$Y && !$92f910dc4e908871$var$cc();)$92f910dc4e908871$var$Uk($92f910dc4e908871$var$Y);
}
function $92f910dc4e908871$var$Uk(a) {
    var b = $92f910dc4e908871$var$Vk(a.alternate, a, $92f910dc4e908871$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $92f910dc4e908871$var$Sk(a) : $92f910dc4e908871$var$Y = b;
    $92f910dc4e908871$var$nk.current = null;
}
function $92f910dc4e908871$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $92f910dc4e908871$var$Ej(c, b, $92f910dc4e908871$var$fj), null !== c) {
                $92f910dc4e908871$var$Y = c;
                return;
            }
        } else {
            c = $92f910dc4e908871$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $92f910dc4e908871$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $92f910dc4e908871$var$T = 6;
                $92f910dc4e908871$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $92f910dc4e908871$var$Y = b;
            return;
        }
        $92f910dc4e908871$var$Y = b = a;
    }while (null !== b);
    0 === $92f910dc4e908871$var$T && ($92f910dc4e908871$var$T = 5);
}
function $92f910dc4e908871$var$Pk(a, b, c) {
    var d = $92f910dc4e908871$var$C, e = $92f910dc4e908871$var$ok.transition;
    try {
        $92f910dc4e908871$var$ok.transition = null, $92f910dc4e908871$var$C = 1, $92f910dc4e908871$var$Wk(a, b, c, d);
    } finally{
        $92f910dc4e908871$var$ok.transition = e, $92f910dc4e908871$var$C = d;
    }
    return null;
}
function $92f910dc4e908871$var$Wk(a, b, c, d) {
    do $92f910dc4e908871$var$Hk();
    while (null !== $92f910dc4e908871$var$wk);
    if (0 !== ($92f910dc4e908871$var$K & 6)) throw Error($92f910dc4e908871$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($92f910dc4e908871$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $92f910dc4e908871$var$Bc(a, f);
    a === $92f910dc4e908871$var$Q && ($92f910dc4e908871$var$Y = $92f910dc4e908871$var$Q = null, $92f910dc4e908871$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $92f910dc4e908871$var$vk || ($92f910dc4e908871$var$vk = !0, $92f910dc4e908871$var$Fk($92f910dc4e908871$var$hc, function() {
        $92f910dc4e908871$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $92f910dc4e908871$var$ok.transition;
        $92f910dc4e908871$var$ok.transition = null;
        var g = $92f910dc4e908871$var$C;
        $92f910dc4e908871$var$C = 1;
        var h = $92f910dc4e908871$var$K;
        $92f910dc4e908871$var$K |= 4;
        $92f910dc4e908871$var$nk.current = null;
        $92f910dc4e908871$var$Oj(a, c);
        $92f910dc4e908871$var$dk(c, a);
        $92f910dc4e908871$var$Oe($92f910dc4e908871$var$Df);
        $92f910dc4e908871$var$dd = !!$92f910dc4e908871$var$Cf;
        $92f910dc4e908871$var$Df = $92f910dc4e908871$var$Cf = null;
        a.current = c;
        $92f910dc4e908871$var$hk(c, a, e);
        $92f910dc4e908871$var$dc();
        $92f910dc4e908871$var$K = h;
        $92f910dc4e908871$var$C = g;
        $92f910dc4e908871$var$ok.transition = f;
    } else a.current = c;
    $92f910dc4e908871$var$vk && ($92f910dc4e908871$var$vk = !1, $92f910dc4e908871$var$wk = a, $92f910dc4e908871$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($92f910dc4e908871$var$Ri = null);
    $92f910dc4e908871$var$mc(c.stateNode, d);
    $92f910dc4e908871$var$Dk(a, $92f910dc4e908871$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($92f910dc4e908871$var$Oi) throw $92f910dc4e908871$var$Oi = !1, a = $92f910dc4e908871$var$Pi, $92f910dc4e908871$var$Pi = null, a;
    0 !== ($92f910dc4e908871$var$xk & 1) && 0 !== a.tag && $92f910dc4e908871$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $92f910dc4e908871$var$zk ? $92f910dc4e908871$var$yk++ : ($92f910dc4e908871$var$yk = 0, $92f910dc4e908871$var$zk = a) : $92f910dc4e908871$var$yk = 0;
    $92f910dc4e908871$var$jg();
    return null;
}
function $92f910dc4e908871$var$Hk() {
    if (null !== $92f910dc4e908871$var$wk) {
        var a = $92f910dc4e908871$var$Dc($92f910dc4e908871$var$xk), b = $92f910dc4e908871$var$ok.transition, c = $92f910dc4e908871$var$C;
        try {
            $92f910dc4e908871$var$ok.transition = null;
            $92f910dc4e908871$var$C = 16 > a ? 16 : a;
            if (null === $92f910dc4e908871$var$wk) var d = !1;
            else {
                a = $92f910dc4e908871$var$wk;
                $92f910dc4e908871$var$wk = null;
                $92f910dc4e908871$var$xk = 0;
                if (0 !== ($92f910dc4e908871$var$K & 6)) throw Error($92f910dc4e908871$var$p(331));
                var e = $92f910dc4e908871$var$K;
                $92f910dc4e908871$var$K |= 4;
                for($92f910dc4e908871$var$V = a.current; null !== $92f910dc4e908871$var$V;){
                    var f = $92f910dc4e908871$var$V, g = f.child;
                    if (0 !== ($92f910dc4e908871$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($92f910dc4e908871$var$V = l; null !== $92f910dc4e908871$var$V;){
                                    var m = $92f910dc4e908871$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $92f910dc4e908871$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $92f910dc4e908871$var$V = q;
                                    else for(; null !== $92f910dc4e908871$var$V;){
                                        m = $92f910dc4e908871$var$V;
                                        var r = m.sibling, y = m.return;
                                        $92f910dc4e908871$var$Sj(m);
                                        if (m === l) {
                                            $92f910dc4e908871$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $92f910dc4e908871$var$V = r;
                                            break;
                                        }
                                        $92f910dc4e908871$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $92f910dc4e908871$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $92f910dc4e908871$var$V = g;
                    else b: for(; null !== $92f910dc4e908871$var$V;){
                        f = $92f910dc4e908871$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $92f910dc4e908871$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $92f910dc4e908871$var$V = x;
                            break b;
                        }
                        $92f910dc4e908871$var$V = f.return;
                    }
                }
                var w = a.current;
                for($92f910dc4e908871$var$V = w; null !== $92f910dc4e908871$var$V;){
                    g = $92f910dc4e908871$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $92f910dc4e908871$var$V = u;
                    else b: for(g = w; null !== $92f910dc4e908871$var$V;){
                        h = $92f910dc4e908871$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $92f910dc4e908871$var$Qj(9, h);
                            }
                        } catch (na) {
                            $92f910dc4e908871$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $92f910dc4e908871$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $92f910dc4e908871$var$V = F;
                            break b;
                        }
                        $92f910dc4e908871$var$V = h.return;
                    }
                }
                $92f910dc4e908871$var$K = e;
                $92f910dc4e908871$var$jg();
                if ($92f910dc4e908871$var$lc && "function" === typeof $92f910dc4e908871$var$lc.onPostCommitFiberRoot) try {
                    $92f910dc4e908871$var$lc.onPostCommitFiberRoot($92f910dc4e908871$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $92f910dc4e908871$var$C = c, $92f910dc4e908871$var$ok.transition = b;
        }
    }
    return !1;
}
function $92f910dc4e908871$var$Xk(a, b, c) {
    b = $92f910dc4e908871$var$Ji(c, b);
    b = $92f910dc4e908871$var$Ni(a, b, 1);
    a = $92f910dc4e908871$var$nh(a, b, 1);
    b = $92f910dc4e908871$var$R();
    null !== a && ($92f910dc4e908871$var$Ac(a, 1, b), $92f910dc4e908871$var$Dk(a, b));
}
function $92f910dc4e908871$var$W(a, b, c) {
    if (3 === a.tag) $92f910dc4e908871$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $92f910dc4e908871$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $92f910dc4e908871$var$Ri || !$92f910dc4e908871$var$Ri.has(d))) {
                a = $92f910dc4e908871$var$Ji(c, a);
                a = $92f910dc4e908871$var$Qi(b, a, 1);
                b = $92f910dc4e908871$var$nh(b, a, 1);
                a = $92f910dc4e908871$var$R();
                null !== b && ($92f910dc4e908871$var$Ac(b, 1, a), $92f910dc4e908871$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $92f910dc4e908871$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $92f910dc4e908871$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $92f910dc4e908871$var$Q === a && ($92f910dc4e908871$var$Z & c) === c && (4 === $92f910dc4e908871$var$T || 3 === $92f910dc4e908871$var$T && ($92f910dc4e908871$var$Z & 130023424) === $92f910dc4e908871$var$Z && 500 > $92f910dc4e908871$var$B() - $92f910dc4e908871$var$fk ? $92f910dc4e908871$var$Kk(a, 0) : $92f910dc4e908871$var$rk |= c);
    $92f910dc4e908871$var$Dk(a, b);
}
function $92f910dc4e908871$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $92f910dc4e908871$var$sc, $92f910dc4e908871$var$sc <<= 1, 0 === ($92f910dc4e908871$var$sc & 130023424) && ($92f910dc4e908871$var$sc = 4194304)));
    var c = $92f910dc4e908871$var$R();
    a = $92f910dc4e908871$var$ih(a, b);
    null !== a && ($92f910dc4e908871$var$Ac(a, b, c), $92f910dc4e908871$var$Dk(a, c));
}
function $92f910dc4e908871$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $92f910dc4e908871$var$Yk(a, c);
}
function $92f910dc4e908871$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($92f910dc4e908871$var$p(314));
    }
    null !== d && d.delete(b);
    $92f910dc4e908871$var$Yk(a, c);
}
var $92f910dc4e908871$var$Vk;
$92f910dc4e908871$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $92f910dc4e908871$var$Wf.current) $92f910dc4e908871$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $92f910dc4e908871$var$dh = !1, $92f910dc4e908871$var$yj(a, b, c);
            $92f910dc4e908871$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $92f910dc4e908871$var$dh = !1, $92f910dc4e908871$var$I && 0 !== (b.flags & 1048576) && $92f910dc4e908871$var$ug(b, $92f910dc4e908871$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $92f910dc4e908871$var$ij(a, b);
            a = b.pendingProps;
            var e = $92f910dc4e908871$var$Yf(b, $92f910dc4e908871$var$H.current);
            $92f910dc4e908871$var$ch(b, c);
            e = $92f910dc4e908871$var$Nh(null, b, d, a, e, c);
            var f = $92f910dc4e908871$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $92f910dc4e908871$var$Zf(d) ? (f = !0, $92f910dc4e908871$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $92f910dc4e908871$var$kh(b), e.updater = $92f910dc4e908871$var$Ei, b.stateNode = e, e._reactInternals = b, $92f910dc4e908871$var$Ii(b, d, a, c), b = $92f910dc4e908871$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $92f910dc4e908871$var$I && f && $92f910dc4e908871$var$vg(b), $92f910dc4e908871$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $92f910dc4e908871$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $92f910dc4e908871$var$Zk(d);
                a = $92f910dc4e908871$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $92f910dc4e908871$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $92f910dc4e908871$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $92f910dc4e908871$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $92f910dc4e908871$var$$i(null, b, d, $92f910dc4e908871$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($92f910dc4e908871$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $92f910dc4e908871$var$Ci(d, e), $92f910dc4e908871$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $92f910dc4e908871$var$Ci(d, e), $92f910dc4e908871$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $92f910dc4e908871$var$kj(b);
                if (null === a) throw Error($92f910dc4e908871$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $92f910dc4e908871$var$lh(a, b);
                $92f910dc4e908871$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $92f910dc4e908871$var$Ji(Error($92f910dc4e908871$var$p(423)), b);
                        b = $92f910dc4e908871$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $92f910dc4e908871$var$Ji(Error($92f910dc4e908871$var$p(424)), b);
                        b = $92f910dc4e908871$var$lj(a, b, d, c, e);
                        break a;
                    } else for($92f910dc4e908871$var$yg = $92f910dc4e908871$var$Lf(b.stateNode.containerInfo.firstChild), $92f910dc4e908871$var$xg = b, $92f910dc4e908871$var$I = !0, $92f910dc4e908871$var$zg = null, c = $92f910dc4e908871$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $92f910dc4e908871$var$Ig();
                    if (d === e) {
                        b = $92f910dc4e908871$var$Zi(a, b, c);
                        break a;
                    }
                    $92f910dc4e908871$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $92f910dc4e908871$var$Ah(b), null === a && $92f910dc4e908871$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $92f910dc4e908871$var$Ef(d, e) ? g = null : null !== f && $92f910dc4e908871$var$Ef(d, f) && (b.flags |= 32), $92f910dc4e908871$var$gj(a, b), $92f910dc4e908871$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $92f910dc4e908871$var$Eg(b), null;
        case 13:
            return $92f910dc4e908871$var$oj(a, b, c);
        case 4:
            return $92f910dc4e908871$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $92f910dc4e908871$var$Ug(b, null, d, c) : $92f910dc4e908871$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $92f910dc4e908871$var$Ci(d, e), $92f910dc4e908871$var$Yi(a, b, d, e, c);
        case 7:
            return $92f910dc4e908871$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $92f910dc4e908871$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $92f910dc4e908871$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $92f910dc4e908871$var$G($92f910dc4e908871$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($92f910dc4e908871$var$He(f.value, g)) {
                        if (f.children === e.children && !$92f910dc4e908871$var$Wf.current) {
                            b = $92f910dc4e908871$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $92f910dc4e908871$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $92f910dc4e908871$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($92f910dc4e908871$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $92f910dc4e908871$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $92f910dc4e908871$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $92f910dc4e908871$var$ch(b, c), e = $92f910dc4e908871$var$eh(e), d = d(e), b.flags |= 1, $92f910dc4e908871$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $92f910dc4e908871$var$Ci(d, b.pendingProps), e = $92f910dc4e908871$var$Ci(d.type, e), $92f910dc4e908871$var$$i(a, b, d, e, c);
        case 15:
            return $92f910dc4e908871$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $92f910dc4e908871$var$Ci(d, e), $92f910dc4e908871$var$ij(a, b), b.tag = 1, $92f910dc4e908871$var$Zf(d) ? (a = !0, $92f910dc4e908871$var$cg(b)) : a = !1, $92f910dc4e908871$var$ch(b, c), $92f910dc4e908871$var$Gi(b, d, e), $92f910dc4e908871$var$Ii(b, d, e, c), $92f910dc4e908871$var$jj(null, b, d, !0, a, c);
        case 19:
            return $92f910dc4e908871$var$xj(a, b, c);
        case 22:
            return $92f910dc4e908871$var$dj(a, b, c);
    }
    throw Error($92f910dc4e908871$var$p(156, b.tag));
};
function $92f910dc4e908871$var$Fk(a, b) {
    return $92f910dc4e908871$var$ac(a, b);
}
function $92f910dc4e908871$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $92f910dc4e908871$var$Bg(a, b, c, d) {
    return new $92f910dc4e908871$var$$k(a, b, c, d);
}
function $92f910dc4e908871$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $92f910dc4e908871$var$Zk(a) {
    if ("function" === typeof a) return $92f910dc4e908871$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $92f910dc4e908871$var$Da) return 11;
        if (a === $92f910dc4e908871$var$Ga) return 14;
    }
    return 2;
}
function $92f910dc4e908871$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $92f910dc4e908871$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $92f910dc4e908871$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $92f910dc4e908871$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $92f910dc4e908871$var$ya:
            return $92f910dc4e908871$var$Tg(c.children, e, f, b);
        case $92f910dc4e908871$var$za:
            g = 8;
            e |= 8;
            break;
        case $92f910dc4e908871$var$Aa:
            return a = $92f910dc4e908871$var$Bg(12, c, b, e | 2), a.elementType = $92f910dc4e908871$var$Aa, a.lanes = f, a;
        case $92f910dc4e908871$var$Ea:
            return a = $92f910dc4e908871$var$Bg(13, c, b, e), a.elementType = $92f910dc4e908871$var$Ea, a.lanes = f, a;
        case $92f910dc4e908871$var$Fa:
            return a = $92f910dc4e908871$var$Bg(19, c, b, e), a.elementType = $92f910dc4e908871$var$Fa, a.lanes = f, a;
        case $92f910dc4e908871$var$Ia:
            return $92f910dc4e908871$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $92f910dc4e908871$var$Ba:
                    g = 10;
                    break a;
                case $92f910dc4e908871$var$Ca:
                    g = 9;
                    break a;
                case $92f910dc4e908871$var$Da:
                    g = 11;
                    break a;
                case $92f910dc4e908871$var$Ga:
                    g = 14;
                    break a;
                case $92f910dc4e908871$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($92f910dc4e908871$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $92f910dc4e908871$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $92f910dc4e908871$var$Tg(a, b, c, d) {
    a = $92f910dc4e908871$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $92f910dc4e908871$var$pj(a, b, c, d) {
    a = $92f910dc4e908871$var$Bg(22, a, d, b);
    a.elementType = $92f910dc4e908871$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $92f910dc4e908871$var$Qg(a, b, c) {
    a = $92f910dc4e908871$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $92f910dc4e908871$var$Sg(a, b, c) {
    b = $92f910dc4e908871$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $92f910dc4e908871$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $92f910dc4e908871$var$zc(0);
    this.expirationTimes = $92f910dc4e908871$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $92f910dc4e908871$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $92f910dc4e908871$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $92f910dc4e908871$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $92f910dc4e908871$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $92f910dc4e908871$var$kh(f);
    return a;
}
function $92f910dc4e908871$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $92f910dc4e908871$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $92f910dc4e908871$var$dl(a) {
    if (!a) return $92f910dc4e908871$var$Vf;
    a = a._reactInternals;
    a: {
        if ($92f910dc4e908871$var$Vb(a) !== a || 1 !== a.tag) throw Error($92f910dc4e908871$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($92f910dc4e908871$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($92f910dc4e908871$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($92f910dc4e908871$var$Zf(c)) return $92f910dc4e908871$var$bg(a, c, b);
    }
    return b;
}
function $92f910dc4e908871$var$el(a, b, c, d, e, f, g, h, k) {
    a = $92f910dc4e908871$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $92f910dc4e908871$var$dl(null);
    c = a.current;
    d = $92f910dc4e908871$var$R();
    e = $92f910dc4e908871$var$yi(c);
    f = $92f910dc4e908871$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $92f910dc4e908871$var$nh(c, f, e);
    a.current.lanes = e;
    $92f910dc4e908871$var$Ac(a, e, d);
    $92f910dc4e908871$var$Dk(a, d);
    return a;
}
function $92f910dc4e908871$var$fl(a, b, c, d) {
    var e = b.current, f = $92f910dc4e908871$var$R(), g = $92f910dc4e908871$var$yi(e);
    c = $92f910dc4e908871$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $92f910dc4e908871$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $92f910dc4e908871$var$nh(e, b, g);
    null !== a && ($92f910dc4e908871$var$gi(a, e, g, f), $92f910dc4e908871$var$oh(a, e, g));
    return g;
}
function $92f910dc4e908871$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $92f910dc4e908871$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $92f910dc4e908871$var$il(a, b) {
    $92f910dc4e908871$var$hl(a, b);
    (a = a.alternate) && $92f910dc4e908871$var$hl(a, b);
}
function $92f910dc4e908871$var$jl() {
    return null;
}
var $92f910dc4e908871$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $92f910dc4e908871$var$ll(a) {
    this._internalRoot = a;
}
$92f910dc4e908871$var$ml.prototype.render = $92f910dc4e908871$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($92f910dc4e908871$var$p(409));
    $92f910dc4e908871$var$fl(a, b, null, null);
};
$92f910dc4e908871$var$ml.prototype.unmount = $92f910dc4e908871$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $92f910dc4e908871$var$Rk(function() {
            $92f910dc4e908871$var$fl(null, a, null, null);
        });
        b[$92f910dc4e908871$var$uf] = null;
    }
};
function $92f910dc4e908871$var$ml(a) {
    this._internalRoot = a;
}
$92f910dc4e908871$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $92f910dc4e908871$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $92f910dc4e908871$var$Qc.length && 0 !== b && b < $92f910dc4e908871$var$Qc[c].priority; c++);
        $92f910dc4e908871$var$Qc.splice(c, 0, a);
        0 === c && $92f910dc4e908871$var$Vc(a);
    }
};
function $92f910dc4e908871$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $92f910dc4e908871$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $92f910dc4e908871$var$pl() {}
function $92f910dc4e908871$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $92f910dc4e908871$var$gl(g);
                f.call(a);
            };
        }
        var g = $92f910dc4e908871$var$el(b, d, a, 0, null, !1, !1, "", $92f910dc4e908871$var$pl);
        a._reactRootContainer = g;
        a[$92f910dc4e908871$var$uf] = g.current;
        $92f910dc4e908871$var$sf(8 === a.nodeType ? a.parentNode : a);
        $92f910dc4e908871$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $92f910dc4e908871$var$gl(k);
            h.call(a);
        };
    }
    var k = $92f910dc4e908871$var$bl(a, 0, !1, null, null, !1, !1, "", $92f910dc4e908871$var$pl);
    a._reactRootContainer = k;
    a[$92f910dc4e908871$var$uf] = k.current;
    $92f910dc4e908871$var$sf(8 === a.nodeType ? a.parentNode : a);
    $92f910dc4e908871$var$Rk(function() {
        $92f910dc4e908871$var$fl(b, k, c, d);
    });
    return k;
}
function $92f910dc4e908871$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $92f910dc4e908871$var$gl(g);
                h.call(a);
            };
        }
        $92f910dc4e908871$var$fl(b, g, a, e);
    } else g = $92f910dc4e908871$var$ql(c, b, a, e, d);
    return $92f910dc4e908871$var$gl(g);
}
$92f910dc4e908871$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $92f910dc4e908871$var$tc(b.pendingLanes);
                0 !== c && ($92f910dc4e908871$var$Cc(b, c | 1), $92f910dc4e908871$var$Dk(b, $92f910dc4e908871$var$B()), 0 === ($92f910dc4e908871$var$K & 6) && ($92f910dc4e908871$var$Gj = $92f910dc4e908871$var$B() + 500, $92f910dc4e908871$var$jg()));
            }
            break;
        case 13:
            $92f910dc4e908871$var$Rk(function() {
                var b = $92f910dc4e908871$var$ih(a, 1);
                if (null !== b) {
                    var c = $92f910dc4e908871$var$R();
                    $92f910dc4e908871$var$gi(b, a, 1, c);
                }
            }), $92f910dc4e908871$var$il(a, 1);
    }
};
$92f910dc4e908871$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $92f910dc4e908871$var$ih(a, 134217728);
        if (null !== b) {
            var c = $92f910dc4e908871$var$R();
            $92f910dc4e908871$var$gi(b, a, 134217728, c);
        }
        $92f910dc4e908871$var$il(a, 134217728);
    }
};
$92f910dc4e908871$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $92f910dc4e908871$var$yi(a), c = $92f910dc4e908871$var$ih(a, b);
        if (null !== c) {
            var d = $92f910dc4e908871$var$R();
            $92f910dc4e908871$var$gi(c, a, b, d);
        }
        $92f910dc4e908871$var$il(a, b);
    }
};
$92f910dc4e908871$var$Hc = function() {
    return $92f910dc4e908871$var$C;
};
$92f910dc4e908871$var$Ic = function(a, b) {
    var c = $92f910dc4e908871$var$C;
    try {
        return $92f910dc4e908871$var$C = a, b();
    } finally{
        $92f910dc4e908871$var$C = c;
    }
};
$92f910dc4e908871$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $92f910dc4e908871$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $92f910dc4e908871$var$Db(d);
                        if (!e) throw Error($92f910dc4e908871$var$p(90));
                        $92f910dc4e908871$var$Wa(d);
                        $92f910dc4e908871$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $92f910dc4e908871$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $92f910dc4e908871$var$fb(a, !!c.multiple, b, !1);
    }
};
$92f910dc4e908871$var$Gb = $92f910dc4e908871$var$Qk;
$92f910dc4e908871$var$Hb = $92f910dc4e908871$var$Rk;
var $92f910dc4e908871$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $92f910dc4e908871$var$Cb,
        $92f910dc4e908871$var$ue,
        $92f910dc4e908871$var$Db,
        $92f910dc4e908871$var$Eb,
        $92f910dc4e908871$var$Fb,
        $92f910dc4e908871$var$Qk
    ]
}, $92f910dc4e908871$var$tl = {
    findFiberByHostInstance: $92f910dc4e908871$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $92f910dc4e908871$var$ul = {
    bundleType: $92f910dc4e908871$var$tl.bundleType,
    version: $92f910dc4e908871$var$tl.version,
    rendererPackageName: $92f910dc4e908871$var$tl.rendererPackageName,
    rendererConfig: $92f910dc4e908871$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $92f910dc4e908871$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $92f910dc4e908871$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $92f910dc4e908871$var$tl.findFiberByHostInstance || $92f910dc4e908871$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $92f910dc4e908871$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$92f910dc4e908871$var$vl.isDisabled && $92f910dc4e908871$var$vl.supportsFiber) try {
        $92f910dc4e908871$var$kc = $92f910dc4e908871$var$vl.inject($92f910dc4e908871$var$ul), $92f910dc4e908871$var$lc = $92f910dc4e908871$var$vl;
    } catch (a) {}
}
$92f910dc4e908871$export$ae55be85d98224ed = $92f910dc4e908871$var$sl;
$92f910dc4e908871$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$92f910dc4e908871$var$nl(b)) throw Error($92f910dc4e908871$var$p(200));
    return $92f910dc4e908871$var$cl(a, b, null, c);
};
$92f910dc4e908871$export$882461b6382ed46c = function(a, b) {
    if (!$92f910dc4e908871$var$nl(a)) throw Error($92f910dc4e908871$var$p(299));
    var c = !1, d = "", e = $92f910dc4e908871$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $92f910dc4e908871$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$92f910dc4e908871$var$uf] = b.current;
    $92f910dc4e908871$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $92f910dc4e908871$var$ll(b);
};
$92f910dc4e908871$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($92f910dc4e908871$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($92f910dc4e908871$var$p(268, a));
    }
    a = $92f910dc4e908871$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$92f910dc4e908871$export$cd75ccfd720a3cd4 = function(a) {
    return $92f910dc4e908871$var$Rk(a);
};
$92f910dc4e908871$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$92f910dc4e908871$var$ol(b)) throw Error($92f910dc4e908871$var$p(200));
    return $92f910dc4e908871$var$rl(null, a, b, !0, c);
};
$92f910dc4e908871$export$757ceba2d55c277e = function(a, b, c) {
    if (!$92f910dc4e908871$var$nl(a)) throw Error($92f910dc4e908871$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $92f910dc4e908871$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $92f910dc4e908871$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$92f910dc4e908871$var$uf] = b.current;
    $92f910dc4e908871$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $92f910dc4e908871$var$ml(b);
};
$92f910dc4e908871$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$92f910dc4e908871$var$ol(b)) throw Error($92f910dc4e908871$var$p(200));
    return $92f910dc4e908871$var$rl(null, a, b, !1, c);
};
$92f910dc4e908871$export$502457920280e6be = function(a) {
    if (!$92f910dc4e908871$var$ol(a)) throw Error($92f910dc4e908871$var$p(40));
    return a._reactRootContainer ? ($92f910dc4e908871$var$Rk(function() {
        $92f910dc4e908871$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$92f910dc4e908871$var$uf] = null;
        });
    }), !0) : !1;
};
$92f910dc4e908871$export$c78a37762a8d58e1 = $92f910dc4e908871$var$Qk;
$92f910dc4e908871$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$92f910dc4e908871$var$ol(c)) throw Error($92f910dc4e908871$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($92f910dc4e908871$var$p(38));
    return $92f910dc4e908871$var$rl(a, b, c, !1, d);
};
$92f910dc4e908871$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("lh787", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eibZJ"));

});
parcelRegister("eibZJ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $a67c0d066bc38615$export$c4744153514ff05d; }, function (v) { return $a67c0d066bc38615$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $a67c0d066bc38615$export$3e506c1ccc9cc1a7; }, function (v) { return $a67c0d066bc38615$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $a67c0d066bc38615$export$e26fe2ed2fa76875; }, function (v) { return $a67c0d066bc38615$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $a67c0d066bc38615$export$502329bbf4b505b1; }, function (v) { return $a67c0d066bc38615$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $a67c0d066bc38615$export$6e3807111c4874c4; }, function (v) { return $a67c0d066bc38615$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $a67c0d066bc38615$export$c27134553091fb3a; }, function (v) { return $a67c0d066bc38615$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $a67c0d066bc38615$export$33ee1acdc04fd2a2; }, function (v) { return $a67c0d066bc38615$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $a67c0d066bc38615$export$b00a404bbd5edef2; }, function (v) { return $a67c0d066bc38615$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $a67c0d066bc38615$export$8352ce38b91d0c62; }, function (v) { return $a67c0d066bc38615$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $a67c0d066bc38615$export$d66a1c1c77bd778b; }, function (v) { return $a67c0d066bc38615$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $a67c0d066bc38615$export$d3dfb8e4810cb555; }, function (v) { return $a67c0d066bc38615$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $a67c0d066bc38615$export$839f9183b0465a69; }, function (v) { return $a67c0d066bc38615$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $a67c0d066bc38615$export$72fdf0e06517287b; }, function (v) { return $a67c0d066bc38615$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $a67c0d066bc38615$export$4b844e58a3e414b4; }, function (v) { return $a67c0d066bc38615$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $a67c0d066bc38615$export$816d2913ae6b83b1; }, function (v) { return $a67c0d066bc38615$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $a67c0d066bc38615$export$61bcfe829111a1d0; }, function (v) { return $a67c0d066bc38615$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $a67c0d066bc38615$export$7ee8c9beb337bc3f; }, function (v) { return $a67c0d066bc38615$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $a67c0d066bc38615$export$b5836b71941fa3ed; }, function (v) { return $a67c0d066bc38615$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $a67c0d066bc38615$export$cf845f2c119da08a; }, function (v) { return $a67c0d066bc38615$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a67c0d066bc38615$export$c4744153514ff05d;
var $a67c0d066bc38615$export$3e506c1ccc9cc1a7;
var $a67c0d066bc38615$export$e26fe2ed2fa76875;
var $a67c0d066bc38615$export$502329bbf4b505b1;
var $a67c0d066bc38615$export$6e3807111c4874c4;
var $a67c0d066bc38615$export$c27134553091fb3a;
var $a67c0d066bc38615$export$33ee1acdc04fd2a2;
var $a67c0d066bc38615$export$b00a404bbd5edef2;
var $a67c0d066bc38615$export$8352ce38b91d0c62;
var $a67c0d066bc38615$export$d66a1c1c77bd778b;
var $a67c0d066bc38615$export$d3dfb8e4810cb555;
var $a67c0d066bc38615$export$839f9183b0465a69;
var $a67c0d066bc38615$export$72fdf0e06517287b;
var $a67c0d066bc38615$export$4b844e58a3e414b4;
var $a67c0d066bc38615$export$816d2913ae6b83b1;
var $a67c0d066bc38615$export$61bcfe829111a1d0;
var $a67c0d066bc38615$export$7ee8c9beb337bc3f;
var $a67c0d066bc38615$export$b5836b71941fa3ed;
var $a67c0d066bc38615$export$cf845f2c119da08a;
'use strict';
function $a67c0d066bc38615$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a67c0d066bc38615$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a67c0d066bc38615$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a67c0d066bc38615$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a67c0d066bc38615$var$g(C, c)) n < e && 0 > $a67c0d066bc38615$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a67c0d066bc38615$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a67c0d066bc38615$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a67c0d066bc38615$var$l = performance;
    $a67c0d066bc38615$export$c4744153514ff05d = function() {
        return $a67c0d066bc38615$var$l.now();
    };
} else {
    var $a67c0d066bc38615$var$p = Date, $a67c0d066bc38615$var$q = $a67c0d066bc38615$var$p.now();
    $a67c0d066bc38615$export$c4744153514ff05d = function() {
        return $a67c0d066bc38615$var$p.now() - $a67c0d066bc38615$var$q;
    };
}
var $a67c0d066bc38615$var$r = [], $a67c0d066bc38615$var$t = [], $a67c0d066bc38615$var$u = 1, $a67c0d066bc38615$var$v = null, $a67c0d066bc38615$var$y = 3, $a67c0d066bc38615$var$z = !1, $a67c0d066bc38615$var$A = !1, $a67c0d066bc38615$var$B = !1, $a67c0d066bc38615$var$D = "function" === typeof setTimeout ? setTimeout : null, $a67c0d066bc38615$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a67c0d066bc38615$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a67c0d066bc38615$var$G(a) {
    for(var b = $a67c0d066bc38615$var$h($a67c0d066bc38615$var$t); null !== b;){
        if (null === b.callback) $a67c0d066bc38615$var$k($a67c0d066bc38615$var$t);
        else if (b.startTime <= a) $a67c0d066bc38615$var$k($a67c0d066bc38615$var$t), b.sortIndex = b.expirationTime, $a67c0d066bc38615$var$f($a67c0d066bc38615$var$r, b);
        else break;
        b = $a67c0d066bc38615$var$h($a67c0d066bc38615$var$t);
    }
}
function $a67c0d066bc38615$var$H(a) {
    $a67c0d066bc38615$var$B = !1;
    $a67c0d066bc38615$var$G(a);
    if (!$a67c0d066bc38615$var$A) {
        if (null !== $a67c0d066bc38615$var$h($a67c0d066bc38615$var$r)) $a67c0d066bc38615$var$A = !0, $a67c0d066bc38615$var$I($a67c0d066bc38615$var$J);
        else {
            var b = $a67c0d066bc38615$var$h($a67c0d066bc38615$var$t);
            null !== b && $a67c0d066bc38615$var$K($a67c0d066bc38615$var$H, b.startTime - a);
        }
    }
}
function $a67c0d066bc38615$var$J(a, b) {
    $a67c0d066bc38615$var$A = !1;
    $a67c0d066bc38615$var$B && ($a67c0d066bc38615$var$B = !1, $a67c0d066bc38615$var$E($a67c0d066bc38615$var$L), $a67c0d066bc38615$var$L = -1);
    $a67c0d066bc38615$var$z = !0;
    var c = $a67c0d066bc38615$var$y;
    try {
        $a67c0d066bc38615$var$G(b);
        for($a67c0d066bc38615$var$v = $a67c0d066bc38615$var$h($a67c0d066bc38615$var$r); null !== $a67c0d066bc38615$var$v && (!($a67c0d066bc38615$var$v.expirationTime > b) || a && !$a67c0d066bc38615$var$M());){
            var d = $a67c0d066bc38615$var$v.callback;
            if ("function" === typeof d) {
                $a67c0d066bc38615$var$v.callback = null;
                $a67c0d066bc38615$var$y = $a67c0d066bc38615$var$v.priorityLevel;
                var e = d($a67c0d066bc38615$var$v.expirationTime <= b);
                b = $a67c0d066bc38615$export$c4744153514ff05d();
                "function" === typeof e ? $a67c0d066bc38615$var$v.callback = e : $a67c0d066bc38615$var$v === $a67c0d066bc38615$var$h($a67c0d066bc38615$var$r) && $a67c0d066bc38615$var$k($a67c0d066bc38615$var$r);
                $a67c0d066bc38615$var$G(b);
            } else $a67c0d066bc38615$var$k($a67c0d066bc38615$var$r);
            $a67c0d066bc38615$var$v = $a67c0d066bc38615$var$h($a67c0d066bc38615$var$r);
        }
        if (null !== $a67c0d066bc38615$var$v) var w = !0;
        else {
            var m = $a67c0d066bc38615$var$h($a67c0d066bc38615$var$t);
            null !== m && $a67c0d066bc38615$var$K($a67c0d066bc38615$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a67c0d066bc38615$var$v = null, $a67c0d066bc38615$var$y = c, $a67c0d066bc38615$var$z = !1;
    }
}
var $a67c0d066bc38615$var$N = !1, $a67c0d066bc38615$var$O = null, $a67c0d066bc38615$var$L = -1, $a67c0d066bc38615$var$P = 5, $a67c0d066bc38615$var$Q = -1;
function $a67c0d066bc38615$var$M() {
    return $a67c0d066bc38615$export$c4744153514ff05d() - $a67c0d066bc38615$var$Q < $a67c0d066bc38615$var$P ? !1 : !0;
}
function $a67c0d066bc38615$var$R() {
    if (null !== $a67c0d066bc38615$var$O) {
        var a = $a67c0d066bc38615$export$c4744153514ff05d();
        $a67c0d066bc38615$var$Q = a;
        var b = !0;
        try {
            b = $a67c0d066bc38615$var$O(!0, a);
        } finally{
            b ? $a67c0d066bc38615$var$S() : ($a67c0d066bc38615$var$N = !1, $a67c0d066bc38615$var$O = null);
        }
    } else $a67c0d066bc38615$var$N = !1;
}
var $a67c0d066bc38615$var$S;
if ("function" === typeof $a67c0d066bc38615$var$F) $a67c0d066bc38615$var$S = function() {
    $a67c0d066bc38615$var$F($a67c0d066bc38615$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a67c0d066bc38615$var$T = new MessageChannel, $a67c0d066bc38615$var$U = $a67c0d066bc38615$var$T.port2;
    $a67c0d066bc38615$var$T.port1.onmessage = $a67c0d066bc38615$var$R;
    $a67c0d066bc38615$var$S = function() {
        $a67c0d066bc38615$var$U.postMessage(null);
    };
} else $a67c0d066bc38615$var$S = function() {
    $a67c0d066bc38615$var$D($a67c0d066bc38615$var$R, 0);
};
function $a67c0d066bc38615$var$I(a) {
    $a67c0d066bc38615$var$O = a;
    $a67c0d066bc38615$var$N || ($a67c0d066bc38615$var$N = !0, $a67c0d066bc38615$var$S());
}
function $a67c0d066bc38615$var$K(a, b) {
    $a67c0d066bc38615$var$L = $a67c0d066bc38615$var$D(function() {
        a($a67c0d066bc38615$export$c4744153514ff05d());
    }, b);
}
$a67c0d066bc38615$export$3e506c1ccc9cc1a7 = 5;
$a67c0d066bc38615$export$e26fe2ed2fa76875 = 1;
$a67c0d066bc38615$export$502329bbf4b505b1 = 4;
$a67c0d066bc38615$export$6e3807111c4874c4 = 3;
$a67c0d066bc38615$export$c27134553091fb3a = null;
$a67c0d066bc38615$export$33ee1acdc04fd2a2 = 2;
$a67c0d066bc38615$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a67c0d066bc38615$export$8352ce38b91d0c62 = function() {
    $a67c0d066bc38615$var$A || $a67c0d066bc38615$var$z || ($a67c0d066bc38615$var$A = !0, $a67c0d066bc38615$var$I($a67c0d066bc38615$var$J));
};
$a67c0d066bc38615$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a67c0d066bc38615$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a67c0d066bc38615$export$d3dfb8e4810cb555 = function() {
    return $a67c0d066bc38615$var$y;
};
$a67c0d066bc38615$export$839f9183b0465a69 = function() {
    return $a67c0d066bc38615$var$h($a67c0d066bc38615$var$r);
};
$a67c0d066bc38615$export$72fdf0e06517287b = function(a) {
    switch($a67c0d066bc38615$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a67c0d066bc38615$var$y;
    }
    var c = $a67c0d066bc38615$var$y;
    $a67c0d066bc38615$var$y = b;
    try {
        return a();
    } finally{
        $a67c0d066bc38615$var$y = c;
    }
};
$a67c0d066bc38615$export$4b844e58a3e414b4 = function() {};
$a67c0d066bc38615$export$816d2913ae6b83b1 = function() {};
$a67c0d066bc38615$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a67c0d066bc38615$var$y;
    $a67c0d066bc38615$var$y = a;
    try {
        return b();
    } finally{
        $a67c0d066bc38615$var$y = c;
    }
};
$a67c0d066bc38615$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a67c0d066bc38615$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a67c0d066bc38615$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a67c0d066bc38615$var$f($a67c0d066bc38615$var$t, a), null === $a67c0d066bc38615$var$h($a67c0d066bc38615$var$r) && a === $a67c0d066bc38615$var$h($a67c0d066bc38615$var$t) && ($a67c0d066bc38615$var$B ? ($a67c0d066bc38615$var$E($a67c0d066bc38615$var$L), $a67c0d066bc38615$var$L = -1) : $a67c0d066bc38615$var$B = !0, $a67c0d066bc38615$var$K($a67c0d066bc38615$var$H, c - d))) : (a.sortIndex = e, $a67c0d066bc38615$var$f($a67c0d066bc38615$var$r, a), $a67c0d066bc38615$var$A || $a67c0d066bc38615$var$z || ($a67c0d066bc38615$var$A = !0, $a67c0d066bc38615$var$I($a67c0d066bc38615$var$J)));
    return a;
};
$a67c0d066bc38615$export$b5836b71941fa3ed = $a67c0d066bc38615$var$M;
$a67c0d066bc38615$export$cf845f2c119da08a = function(a) {
    var b = $a67c0d066bc38615$var$y;
    return function() {
        var c = $a67c0d066bc38615$var$y;
        $a67c0d066bc38615$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a67c0d066bc38615$var$y = c;
        }
    };
};

});



parcelRegister("hgY9E", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $d1O9j = parcelRequire("d1O9j");
function $c93297c08d72d5d8$var$emptyFunction() {}
function $c93297c08d72d5d8$var$emptyFunctionWithReset() {}
$c93297c08d72d5d8$var$emptyFunctionWithReset.resetWarningCache = $c93297c08d72d5d8$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $d1O9j) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $c93297c08d72d5d8$var$emptyFunctionWithReset,
        resetWarningCache: $c93297c08d72d5d8$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("d1O9j", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $97c244f73c5bf347$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $97c244f73c5bf347$var$ReactPropTypesSecret;

});


parcelRegister("3rAPc", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $2820755adb51c38d$export$2b8d127b894957b9; }, function (v) { return $2820755adb51c38d$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $2820755adb51c38d$export$cea3a54a6425200c; }, function (v) { return $2820755adb51c38d$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $2820755adb51c38d$export$a7c73072b1a182ae; }, function (v) { return $2820755adb51c38d$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2820755adb51c38d$export$9f27bc3417b4524d; }, function (v) { return $2820755adb51c38d$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2820755adb51c38d$export$db77ccec0bb4ccac; }, function (v) { return $2820755adb51c38d$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2820755adb51c38d$export$8392c0c9d3dcbd35; }, function (v) { return $2820755adb51c38d$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2820755adb51c38d$export$ffb0004e005737fa; }, function (v) { return $2820755adb51c38d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2820755adb51c38d$export$b624eff549462981; }, function (v) { return $2820755adb51c38d$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2820755adb51c38d$export$7897aa7841a5380c; }, function (v) { return $2820755adb51c38d$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2820755adb51c38d$export$602eac185826482c; }, function (v) { return $2820755adb51c38d$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2820755adb51c38d$export$e2c29f18771995cb; }, function (v) { return $2820755adb51c38d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2820755adb51c38d$export$5f8d39834fd61797; }, function (v) { return $2820755adb51c38d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2820755adb51c38d$export$74bf444e3cd11ea5; }, function (v) { return $2820755adb51c38d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2820755adb51c38d$export$92387174baf9b227; }, function (v) { return $2820755adb51c38d$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2820755adb51c38d$export$ec112efeb987d9c6; }, function (v) { return $2820755adb51c38d$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2820755adb51c38d$export$b706b080d889d2c9; }, function (v) { return $2820755adb51c38d$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2820755adb51c38d$export$5be5a87408f70ddc; }, function (v) { return $2820755adb51c38d$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2820755adb51c38d$export$45a5e7f76e0caa8d; }, function (v) { return $2820755adb51c38d$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2820755adb51c38d$export$455c2e768291efa6; }, function (v) { return $2820755adb51c38d$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2820755adb51c38d$export$9522e17588c12572; }, function (v) { return $2820755adb51c38d$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2820755adb51c38d$export$2110ac352bb060b9; }, function (v) { return $2820755adb51c38d$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2820755adb51c38d$export$56885ab8b9c456ab; }, function (v) { return $2820755adb51c38d$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2820755adb51c38d$export$d927fcb6adf8f9de; }, function (v) { return $2820755adb51c38d$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2820755adb51c38d$export$b82d16f27459e05a; }, function (v) { return $2820755adb51c38d$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2820755adb51c38d$export$522c17b4f5e123e8; }, function (v) { return $2820755adb51c38d$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2820755adb51c38d$export$1aabd8a0274ecfd6; }, function (v) { return $2820755adb51c38d$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2820755adb51c38d$export$9b621391a187a31a; }, function (v) { return $2820755adb51c38d$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2820755adb51c38d$export$f5bbd400c2f4426f; }, function (v) { return $2820755adb51c38d$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2820755adb51c38d$export$2b8d127b894957b9;
var $2820755adb51c38d$export$cea3a54a6425200c;
var $2820755adb51c38d$export$a7c73072b1a182ae;
var $2820755adb51c38d$export$9f27bc3417b4524d;
var $2820755adb51c38d$export$db77ccec0bb4ccac;
var $2820755adb51c38d$export$8392c0c9d3dcbd35;
var $2820755adb51c38d$export$ffb0004e005737fa;
var $2820755adb51c38d$export$b624eff549462981;
var $2820755adb51c38d$export$7897aa7841a5380c;
var $2820755adb51c38d$export$602eac185826482c;
var $2820755adb51c38d$export$e2c29f18771995cb;
var $2820755adb51c38d$export$5f8d39834fd61797;
var $2820755adb51c38d$export$74bf444e3cd11ea5;
var $2820755adb51c38d$export$92387174baf9b227;
var $2820755adb51c38d$export$ec112efeb987d9c6;
var $2820755adb51c38d$export$b706b080d889d2c9;
var $2820755adb51c38d$export$5be5a87408f70ddc;
var $2820755adb51c38d$export$45a5e7f76e0caa8d;
var $2820755adb51c38d$export$455c2e768291efa6;
var $2820755adb51c38d$export$9522e17588c12572;
var $2820755adb51c38d$export$2110ac352bb060b9;
var $2820755adb51c38d$export$56885ab8b9c456ab;
var $2820755adb51c38d$export$d927fcb6adf8f9de;
var $2820755adb51c38d$export$b82d16f27459e05a;
var $2820755adb51c38d$export$522c17b4f5e123e8;
var $2820755adb51c38d$export$1aabd8a0274ecfd6;
var $2820755adb51c38d$export$9b621391a187a31a;
var $2820755adb51c38d$export$f5bbd400c2f4426f;
'use strict';
var $2820755adb51c38d$var$b = "function" === typeof Symbol && Symbol.for, $2820755adb51c38d$var$c = $2820755adb51c38d$var$b ? Symbol.for("react.element") : 60103, $2820755adb51c38d$var$d = $2820755adb51c38d$var$b ? Symbol.for("react.portal") : 60106, $2820755adb51c38d$var$e = $2820755adb51c38d$var$b ? Symbol.for("react.fragment") : 60107, $2820755adb51c38d$var$f = $2820755adb51c38d$var$b ? Symbol.for("react.strict_mode") : 60108, $2820755adb51c38d$var$g = $2820755adb51c38d$var$b ? Symbol.for("react.profiler") : 60114, $2820755adb51c38d$var$h = $2820755adb51c38d$var$b ? Symbol.for("react.provider") : 60109, $2820755adb51c38d$var$k = $2820755adb51c38d$var$b ? Symbol.for("react.context") : 60110, $2820755adb51c38d$var$l = $2820755adb51c38d$var$b ? Symbol.for("react.async_mode") : 60111, $2820755adb51c38d$var$m = $2820755adb51c38d$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2820755adb51c38d$var$n = $2820755adb51c38d$var$b ? Symbol.for("react.forward_ref") : 60112, $2820755adb51c38d$var$p = $2820755adb51c38d$var$b ? Symbol.for("react.suspense") : 60113, $2820755adb51c38d$var$q = $2820755adb51c38d$var$b ? Symbol.for("react.suspense_list") : 60120, $2820755adb51c38d$var$r = $2820755adb51c38d$var$b ? Symbol.for("react.memo") : 60115, $2820755adb51c38d$var$t = $2820755adb51c38d$var$b ? Symbol.for("react.lazy") : 60116, $2820755adb51c38d$var$v = $2820755adb51c38d$var$b ? Symbol.for("react.block") : 60121, $2820755adb51c38d$var$w = $2820755adb51c38d$var$b ? Symbol.for("react.fundamental") : 60117, $2820755adb51c38d$var$x = $2820755adb51c38d$var$b ? Symbol.for("react.responder") : 60118, $2820755adb51c38d$var$y = $2820755adb51c38d$var$b ? Symbol.for("react.scope") : 60119;
function $2820755adb51c38d$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2820755adb51c38d$var$c:
                switch(a = a.type, a){
                    case $2820755adb51c38d$var$l:
                    case $2820755adb51c38d$var$m:
                    case $2820755adb51c38d$var$e:
                    case $2820755adb51c38d$var$g:
                    case $2820755adb51c38d$var$f:
                    case $2820755adb51c38d$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2820755adb51c38d$var$k:
                            case $2820755adb51c38d$var$n:
                            case $2820755adb51c38d$var$t:
                            case $2820755adb51c38d$var$r:
                            case $2820755adb51c38d$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2820755adb51c38d$var$d:
                return u;
        }
    }
}
function $2820755adb51c38d$var$A(a) {
    return $2820755adb51c38d$var$z(a) === $2820755adb51c38d$var$m;
}
$2820755adb51c38d$export$2b8d127b894957b9 = $2820755adb51c38d$var$l;
$2820755adb51c38d$export$cea3a54a6425200c = $2820755adb51c38d$var$m;
$2820755adb51c38d$export$a7c73072b1a182ae = $2820755adb51c38d$var$k;
$2820755adb51c38d$export$9f27bc3417b4524d = $2820755adb51c38d$var$h;
$2820755adb51c38d$export$db77ccec0bb4ccac = $2820755adb51c38d$var$c;
$2820755adb51c38d$export$8392c0c9d3dcbd35 = $2820755adb51c38d$var$n;
$2820755adb51c38d$export$ffb0004e005737fa = $2820755adb51c38d$var$e;
$2820755adb51c38d$export$b624eff549462981 = $2820755adb51c38d$var$t;
$2820755adb51c38d$export$7897aa7841a5380c = $2820755adb51c38d$var$r;
$2820755adb51c38d$export$602eac185826482c = $2820755adb51c38d$var$d;
$2820755adb51c38d$export$e2c29f18771995cb = $2820755adb51c38d$var$g;
$2820755adb51c38d$export$5f8d39834fd61797 = $2820755adb51c38d$var$f;
$2820755adb51c38d$export$74bf444e3cd11ea5 = $2820755adb51c38d$var$p;
$2820755adb51c38d$export$92387174baf9b227 = function(a) {
    return $2820755adb51c38d$var$A(a) || $2820755adb51c38d$var$z(a) === $2820755adb51c38d$var$l;
};
$2820755adb51c38d$export$ec112efeb987d9c6 = $2820755adb51c38d$var$A;
$2820755adb51c38d$export$b706b080d889d2c9 = function(a) {
    return $2820755adb51c38d$var$z(a) === $2820755adb51c38d$var$k;
};
$2820755adb51c38d$export$5be5a87408f70ddc = function(a) {
    return $2820755adb51c38d$var$z(a) === $2820755adb51c38d$var$h;
};
$2820755adb51c38d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2820755adb51c38d$var$c;
};
$2820755adb51c38d$export$455c2e768291efa6 = function(a) {
    return $2820755adb51c38d$var$z(a) === $2820755adb51c38d$var$n;
};
$2820755adb51c38d$export$9522e17588c12572 = function(a) {
    return $2820755adb51c38d$var$z(a) === $2820755adb51c38d$var$e;
};
$2820755adb51c38d$export$2110ac352bb060b9 = function(a) {
    return $2820755adb51c38d$var$z(a) === $2820755adb51c38d$var$t;
};
$2820755adb51c38d$export$56885ab8b9c456ab = function(a) {
    return $2820755adb51c38d$var$z(a) === $2820755adb51c38d$var$r;
};
$2820755adb51c38d$export$d927fcb6adf8f9de = function(a) {
    return $2820755adb51c38d$var$z(a) === $2820755adb51c38d$var$d;
};
$2820755adb51c38d$export$b82d16f27459e05a = function(a) {
    return $2820755adb51c38d$var$z(a) === $2820755adb51c38d$var$g;
};
$2820755adb51c38d$export$522c17b4f5e123e8 = function(a) {
    return $2820755adb51c38d$var$z(a) === $2820755adb51c38d$var$f;
};
$2820755adb51c38d$export$1aabd8a0274ecfd6 = function(a) {
    return $2820755adb51c38d$var$z(a) === $2820755adb51c38d$var$p;
};
$2820755adb51c38d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2820755adb51c38d$var$e || a === $2820755adb51c38d$var$m || a === $2820755adb51c38d$var$g || a === $2820755adb51c38d$var$f || a === $2820755adb51c38d$var$p || a === $2820755adb51c38d$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2820755adb51c38d$var$t || a.$$typeof === $2820755adb51c38d$var$r || a.$$typeof === $2820755adb51c38d$var$h || a.$$typeof === $2820755adb51c38d$var$k || a.$$typeof === $2820755adb51c38d$var$n || a.$$typeof === $2820755adb51c38d$var$w || a.$$typeof === $2820755adb51c38d$var$x || a.$$typeof === $2820755adb51c38d$var$y || a.$$typeof === $2820755adb51c38d$var$v);
};
$2820755adb51c38d$export$f5bbd400c2f4426f = $2820755adb51c38d$var$z;

});

parcelRegister("1qXDD", function(module, exports) {
function $10b67b0c0126102e$var$_extends() {
    return module.exports = $10b67b0c0126102e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $10b67b0c0126102e$var$_extends.apply(null, arguments);
}
module.exports = $10b67b0c0126102e$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1x7bA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1SAXO")).default; });

var $1SAXO = parcelRequire("1SAXO");

});
parcelRegister("1SAXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15e781cada73a8c2$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $15e781cada73a8c2$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("37b6E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1qS3u")).default; });

var $1qS3u = parcelRequire("1qS3u");

});
parcelRegister("1qS3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10b226680b6e5fba$export$2e2bcd8739ae039; });
function $10b226680b6e5fba$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $10b226680b6e5fba$export$2e2bcd8739ae039 = $10b226680b6e5fba$var$clamp;

});


parcelRegister("5YThu", function(module, exports) {
function $45ad700ae7c7e23f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $45ad700ae7c7e23f$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cmrx1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8ffce54e942a6730$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $8ffce54e942a6730$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("5Vkbx")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("d8Gg3")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("d8Gg3")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("4a39B")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("7yrkh")).default; });
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $7XJ2i = parcelRequire("7XJ2i");

var $d8Gg3 = parcelRequire("d8Gg3");
var $5Vkbx = parcelRequire("5Vkbx");

var $4a39B = parcelRequire("4a39B");

var $7yrkh = parcelRequire("7yrkh");
'use client';
function $8ffce54e942a6730$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $7XJ2i.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $8ffce54e942a6730$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("7XJ2i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cc0fa5499a1c9b7$export$2e2bcd8739ae039; });

var $iGjsd = parcelRequire("iGjsd");
parcelRequire("1qXDD");
parcelRequire("i5lfL");
parcelRequire("g3mS0");

parcelRequire("hLA0o");
parcelRequire("kHp9Z");
parcelRequire("9WSKf");
var $5cc0fa5499a1c9b7$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $5cc0fa5499a1c9b7$export$2e2bcd8739ae039 = (0, $iGjsd.default).bind();
$5cc0fa5499a1c9b7$var$tags.forEach(function(tagName) {
    $5cc0fa5499a1c9b7$export$2e2bcd8739ae039[tagName] = $5cc0fa5499a1c9b7$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("iGjsd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d99b3d6694111957$export$2e2bcd8739ae039; });

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");

var $g3mS0 = parcelRequire("g3mS0");
parcelRequire("d8Gg3");
var $5Vkbx = parcelRequire("5Vkbx");

var $hLA0o = parcelRequire("hLA0o");

var $kHp9Z = parcelRequire("kHp9Z");

var $9WSKf = parcelRequire("9WSKf");
/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $d99b3d6694111957$var$testOmitPropsOnStringTag = (0, $g3mS0.default);
var $d99b3d6694111957$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $d99b3d6694111957$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $d99b3d6694111957$var$testOmitPropsOnStringTag : $d99b3d6694111957$var$testOmitPropsOnComponent;
};
var $d99b3d6694111957$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $d99b3d6694111957$var$isDevelopment = false;
var $d99b3d6694111957$var$isBrowser = typeof document !== 'undefined';
var $d99b3d6694111957$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $hLA0o.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $9WSKf.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $hLA0o.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$d99b3d6694111957$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $i5lfL.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $d99b3d6694111957$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $d99b3d6694111957$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $d99b3d6694111957$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $5Vkbx.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $i5lfL.useContext((0, $5Vkbx.T));
            }
            if (typeof props.className === 'string') className = (0, $hLA0o.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $kHp9Z.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $d99b3d6694111957$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $i5lfL.createElement($i5lfL.Fragment, null, /*#__PURE__*/ $i5lfL.createElement($d99b3d6694111957$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $i5lfL.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $d99b3d6694111957$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $1CWiu.default)({}, options, nextOptions, {
                shouldForwardProp: $d99b3d6694111957$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("1CWiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12f68faa667a9639$export$2e2bcd8739ae039; });
function $12f68faa667a9639$export$2e2bcd8739ae039() {
    return $12f68faa667a9639$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $12f68faa667a9639$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("g3mS0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bafeaaade2045be0$export$2e2bcd8739ae039; });

var $bnoTt = parcelRequire("bnoTt");
// eslint-disable-next-line no-undef
var $bafeaaade2045be0$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bafeaaade2045be0$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $bnoTt.default)(function(prop) {
    return $bafeaaade2045be0$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("bnoTt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8485271756157eb8$export$2e2bcd8739ae039; });
function $8485271756157eb8$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("d8Gg3", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $990ccd3f0a7986ba$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $990ccd3f0a7986ba$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $990ccd3f0a7986ba$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("5Vkbx")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("5Vkbx")).w; });

var $5Vkbx = parcelRequire("5Vkbx");

var $i5lfL = parcelRequire("i5lfL");

var $hLA0o = parcelRequire("hLA0o");

var $9WSKf = parcelRequire("9WSKf");

var $kHp9Z = parcelRequire("kHp9Z");
parcelRequire("budkK");
parcelRequire("1qXDD");
parcelRequire("jMD99");

parcelRequire("frqg1");
var $990ccd3f0a7986ba$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $5Vkbx.h).call(props, 'css')) return $i5lfL.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $5Vkbx.E);
    createElementArgArray[1] = (0, $5Vkbx.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $i5lfL.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $990ccd3f0a7986ba$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $5Vkbx.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $kHp9Z.serializeStyles)([
        styles
    ], undefined, $i5lfL.useContext((0, $5Vkbx.T)));
    if (!(0, $5Vkbx.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $i5lfL.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $i5lfL.useRef();
    (0, $9WSKf.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $9WSKf.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $hLA0o.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $990ccd3f0a7986ba$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $kHp9Z.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $990ccd3f0a7986ba$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $990ccd3f0a7986ba$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $990ccd3f0a7986ba$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $990ccd3f0a7986ba$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $hLA0o.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $990ccd3f0a7986ba$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $9WSKf.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $hLA0o.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $5Vkbx.i) && res !== undefined) rules += res;
        }
        if (!(0, $5Vkbx.i)) return rules;
    });
    if (!(0, $5Vkbx.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $i5lfL.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $990ccd3f0a7986ba$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $5Vkbx.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $5Vkbx.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $kHp9Z.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $hLA0o.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $5Vkbx.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $990ccd3f0a7986ba$var$merge(cache.registered, css, $990ccd3f0a7986ba$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $i5lfL.useContext((0, $5Vkbx.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $i5lfL.createElement($i5lfL.Fragment, null, /*#__PURE__*/ $i5lfL.createElement($990ccd3f0a7986ba$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("5Vkbx", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $4501eef094041bce$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $4501eef094041bce$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $4501eef094041bce$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $4501eef094041bce$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $4501eef094041bce$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $4501eef094041bce$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $4501eef094041bce$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $4501eef094041bce$export$a9c23c6ac3fc3eca; });

var $i5lfL = parcelRequire("i5lfL");

var $budkK = parcelRequire("budkK");

var $1CWiu = parcelRequire("1CWiu");

var $jMD99 = parcelRequire("jMD99");

var $916Xo = parcelRequire("916Xo");

var $hLA0o = parcelRequire("hLA0o");

var $kHp9Z = parcelRequire("kHp9Z");

var $9WSKf = parcelRequire("9WSKf");
var $4501eef094041bce$export$407448d2b89b1813 = false;
var $4501eef094041bce$export$23f2a1d2818174ef = typeof document !== 'undefined';
/* import { type EmotionCache } from '@emotion/utils' */ var $4501eef094041bce$var$EmotionCacheContext = /* #__PURE__ */ $i5lfL.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $budkK.default)({
    key: 'css'
}) : null);
var $4501eef094041bce$export$e7094788287c5e9b = $4501eef094041bce$var$EmotionCacheContext.Provider;
var $4501eef094041bce$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $i5lfL.useContext)($4501eef094041bce$var$EmotionCacheContext);
};
var $4501eef094041bce$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $i5lfL.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $i5lfL.useContext)($4501eef094041bce$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$4501eef094041bce$export$23f2a1d2818174ef) $4501eef094041bce$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $i5lfL.useContext)($4501eef094041bce$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $budkK.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $i5lfL.createElement($4501eef094041bce$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $4501eef094041bce$export$971d5caa766a69d7 = /* #__PURE__ */ $i5lfL.createContext({});
var $4501eef094041bce$export$3b14a55fb2447963 = function useTheme() {
    return $i5lfL.useContext($4501eef094041bce$export$971d5caa766a69d7);
};
var $4501eef094041bce$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $1CWiu.default)({}, outerTheme, theme);
};
var $4501eef094041bce$var$createCacheWithTheme = /* #__PURE__ */ (0, $jMD99.default)(function(outerTheme) {
    return (0, $jMD99.default)(function(theme) {
        return $4501eef094041bce$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $4501eef094041bce$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $i5lfL.useContext($4501eef094041bce$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4501eef094041bce$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $i5lfL.createElement($4501eef094041bce$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4501eef094041bce$export$4368d992c4eafac0(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $i5lfL.useContext($4501eef094041bce$export$971d5caa766a69d7);
        return /*#__PURE__*/ $i5lfL.createElement(Component, (0, $1CWiu.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $i5lfL.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $916Xo.default)(WithTheme, Component);
}
var $4501eef094041bce$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4501eef094041bce$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4501eef094041bce$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($4501eef094041bce$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$4501eef094041bce$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $4501eef094041bce$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $hLA0o.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $9WSKf.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $hLA0o.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$4501eef094041bce$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $i5lfL.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $4501eef094041bce$var$Emotion = /* #__PURE__ */ $4501eef094041bce$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4501eef094041bce$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $hLA0o.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $kHp9Z.serializeStyles)(registeredStyles, undefined, $i5lfL.useContext($4501eef094041bce$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($4501eef094041bce$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $4501eef094041bce$var$typePropName && !$4501eef094041bce$export$407448d2b89b1813) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $i5lfL.createElement($i5lfL.Fragment, null, /*#__PURE__*/ $i5lfL.createElement($4501eef094041bce$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $i5lfL.createElement(WrappedComponent, newProps));
});
var $4501eef094041bce$export$a9c23c6ac3fc3eca = $4501eef094041bce$var$Emotion;

});
parcelRegister("budkK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85ccd6da41b89b73$export$2e2bcd8739ae039; });

var $54M7y = parcelRequire("54M7y");

var $ky3zH = parcelRequire("ky3zH");

var $jMD99 = parcelRequire("jMD99");

var $bnoTt = parcelRequire("bnoTt");
var $85ccd6da41b89b73$var$isBrowser = typeof document !== 'undefined';
var $85ccd6da41b89b73$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $ky3zH.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $ky3zH.token)(character)) break;
        (0, $ky3zH.next)();
    }
    return (0, $ky3zH.slice)(begin, (0, $ky3zH.position));
};
var $85ccd6da41b89b73$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $ky3zH.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $ky3zH.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $85ccd6da41b89b73$var$identifierWithPointTracking((0, $ky3zH.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $ky3zH.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $ky3zH.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $ky3zH.from)(character);
    }
    while (character = (0, $ky3zH.next)());
    return parsed;
};
var $85ccd6da41b89b73$var$getRules = function getRules(value, points) {
    return (0, $ky3zH.dealloc)($85ccd6da41b89b73$var$toRules((0, $ky3zH.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $85ccd6da41b89b73$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $85ccd6da41b89b73$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$85ccd6da41b89b73$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $85ccd6da41b89b73$var$fixedElements.set(element, true);
    var points = [];
    var rules = $85ccd6da41b89b73$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $85ccd6da41b89b73$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $85ccd6da41b89b73$var$prefix(value, length) {
    switch((0, $ky3zH.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $ky3zH.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $ky3zH.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.MOZ) + value + (0, $ky3zH.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.MS) + value + value;
        // order
        case 6165:
            return (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.replace)(value, /(\w+).+(:[^]+)/, (0, $ky3zH.WEBKIT) + 'box-$1$2' + (0, $ky3zH.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.MS) + 'flex-item-' + (0, $ky3zH.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.MS) + 'flex-line-pack' + (0, $ky3zH.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.MS) + (0, $ky3zH.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.MS) + (0, $ky3zH.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $ky3zH.WEBKIT) + 'box-' + (0, $ky3zH.replace)(value, '-grow', '') + (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.MS) + (0, $ky3zH.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $ky3zH.WEBKIT) + (0, $ky3zH.replace)(value, /([^-])(transform)/g, '$1' + (0, $ky3zH.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $ky3zH.replace)((0, $ky3zH.replace)((0, $ky3zH.replace)(value, /(zoom-|grab)/, (0, $ky3zH.WEBKIT) + '$1'), /(image-set)/, (0, $ky3zH.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $ky3zH.replace)(value, /(image-set\([^]*)/, (0, $ky3zH.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $ky3zH.replace)((0, $ky3zH.replace)(value, /(.+:)(flex-)?(.*)/, (0, $ky3zH.WEBKIT) + 'box-pack:$3' + (0, $ky3zH.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $ky3zH.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $ky3zH.replace)(value, /(.+)-inline(.+)/, (0, $ky3zH.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $ky3zH.strlen)(value) - 1 - length > 6) switch((0, $ky3zH.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $ky3zH.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $ky3zH.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $ky3zH.WEBKIT) + '$2-$3' + '$1' + (0, $ky3zH.MOZ) + ((0, $ky3zH.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $ky3zH.indexof)(value, 'stretch') ? $85ccd6da41b89b73$var$prefix((0, $ky3zH.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $ky3zH.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $ky3zH.charat)(value, (0, $ky3zH.strlen)(value) - 3 - (~(0, $ky3zH.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $ky3zH.replace)(value, ':', ':' + (0, $ky3zH.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $ky3zH.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $ky3zH.WEBKIT) + ((0, $ky3zH.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $ky3zH.WEBKIT) + '$2$3' + '$1' + (0, $ky3zH.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $ky3zH.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.MS) + (0, $ky3zH.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.MS) + (0, $ky3zH.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.MS) + (0, $ky3zH.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $ky3zH.WEBKIT) + value + (0, $ky3zH.MS) + value + value;
    }
    return value;
}
var $85ccd6da41b89b73$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $ky3zH.DECLARATION:
                element["return"] = $85ccd6da41b89b73$var$prefix(element.value, element.length);
                break;
            case 0, $ky3zH.KEYFRAMES:
                return (0, $ky3zH.serialize)([
                    (0, $ky3zH.copy)(element, {
                        value: (0, $ky3zH.replace)(element.value, '@', '@' + (0, $ky3zH.WEBKIT))
                    })
                ], callback);
            case 0, $ky3zH.RULESET:
                if (element.length) return (0, $ky3zH.combine)(element.props, function(value) {
                    switch((0, $ky3zH.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $ky3zH.serialize)([
                                (0, $ky3zH.copy)(element, {
                                    props: [
                                        (0, $ky3zH.replace)(value, /:(read-\w+)/, ':' + (0, $ky3zH.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $ky3zH.serialize)([
                                (0, $ky3zH.copy)(element, {
                                    props: [
                                        (0, $ky3zH.replace)(value, /:(plac\w+)/, ':' + (0, $ky3zH.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $ky3zH.copy)(element, {
                                    props: [
                                        (0, $ky3zH.replace)(value, /:(plac\w+)/, ':' + (0, $ky3zH.MOZ) + '$1')
                                    ]
                                }),
                                (0, $ky3zH.copy)(element, {
                                    props: [
                                        (0, $ky3zH.replace)(value, /:(plac\w+)/, (0, $ky3zH.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var $85ccd6da41b89b73$var$getServerStylisCache = $85ccd6da41b89b73$var$isBrowser ? undefined : (0, $jMD99.default)(function() {
    return (0, $bnoTt.default)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var $85ccd6da41b89b73$var$defaultStylisPlugins = [
    $85ccd6da41b89b73$var$prefixer
];
var $85ccd6da41b89b73$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if ($85ccd6da41b89b73$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $85ccd6da41b89b73$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if ($85ccd6da41b89b73$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $85ccd6da41b89b73$var$compat,
        $85ccd6da41b89b73$var$removeLabel
    ];
    if ($85ccd6da41b89b73$var$isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $ky3zH.stringify),
            (0, $ky3zH.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $ky3zH.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $ky3zH.serialize)((0, $ky3zH.compile)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $ky3zH.stringify)
        ];
        var _serializer = (0, $ky3zH.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $ky3zH.serialize)((0, $ky3zH.compile)(styles), _serializer);
        };
        var serverStylisCache = $85ccd6da41b89b73$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $54M7y.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("54M7y", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $3b22a73fcd3d1538$export$9d753cd7ae895cce; });
var $3b22a73fcd3d1538$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $3b22a73fcd3d1538$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $3b22a73fcd3d1538$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $3b22a73fcd3d1538$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$3b22a73fcd3d1538$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3b22a73fcd3d1538$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $3b22a73fcd3d1538$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("ky3zH", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $7b02104de72354e1$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $7b02104de72354e1$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $7b02104de72354e1$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $7b02104de72354e1$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $7b02104de72354e1$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $7b02104de72354e1$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $7b02104de72354e1$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $7b02104de72354e1$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $7b02104de72354e1$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $7b02104de72354e1$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $7b02104de72354e1$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $7b02104de72354e1$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $7b02104de72354e1$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $7b02104de72354e1$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $7b02104de72354e1$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $7b02104de72354e1$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $7b02104de72354e1$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $7b02104de72354e1$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $7b02104de72354e1$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $7b02104de72354e1$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $7b02104de72354e1$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $7b02104de72354e1$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $7b02104de72354e1$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $7b02104de72354e1$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $7b02104de72354e1$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $7b02104de72354e1$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $7b02104de72354e1$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $7b02104de72354e1$export$38bcb760f1d4871c; });
var $7b02104de72354e1$export$71ad59f2e432cfe8 = "-ms-";
var $7b02104de72354e1$export$2c0f367103c8d01c = "-moz-";
var $7b02104de72354e1$export$39dfd62a25e0fe93 = "-webkit-";
var $7b02104de72354e1$export$a29989082612d0d9 = "comm";
var $7b02104de72354e1$export$aa3a2e812ca8570d = "rule";
var $7b02104de72354e1$export$527d108ccf083c2b = "decl";
var $7b02104de72354e1$export$d3d35020fa5b54f0 = "@page";
var $7b02104de72354e1$export$500415a86c544f73 = "@media";
var $7b02104de72354e1$export$a763edbf796b780a = "@import";
var $7b02104de72354e1$export$2790aeb8b4e5c826 = "@charset";
var $7b02104de72354e1$export$1cc683e23b84b133 = "@viewport";
var $7b02104de72354e1$export$9447a5efea57e862 = "@supports";
var $7b02104de72354e1$export$ef011b4e114b1fba = "@document";
var $7b02104de72354e1$export$6aad947bda0f3f46 = "@namespace";
var $7b02104de72354e1$export$b44a8529a35fcb60 = "@keyframes";
var $7b02104de72354e1$export$2c16de31893252e6 = "@font-face";
var $7b02104de72354e1$export$3d846dd52e150c6f = "@counter-style";
var $7b02104de72354e1$export$22314bfbb57653fe = "@font-feature-values";
var $7b02104de72354e1$export$d773506282b3cfe6 = "@layer";
var $7b02104de72354e1$export$2335f513bbd82c6d = Math.abs;
var $7b02104de72354e1$export$6788812c4e6611e6 = String.fromCharCode;
var $7b02104de72354e1$export$e6e34fd1f2686227 = Object.assign;
function $7b02104de72354e1$export$d6af199866bfb566(e, r) {
    return $7b02104de72354e1$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $7b02104de72354e1$export$a9db5e087081082d(e, 0)) << 2 ^ $7b02104de72354e1$export$a9db5e087081082d(e, 1)) << 2 ^ $7b02104de72354e1$export$a9db5e087081082d(e, 2)) << 2 ^ $7b02104de72354e1$export$a9db5e087081082d(e, 3) : 0;
}
function $7b02104de72354e1$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $7b02104de72354e1$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $7b02104de72354e1$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $7b02104de72354e1$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $7b02104de72354e1$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $7b02104de72354e1$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $7b02104de72354e1$export$36776f635604f274(e) {
    return e.length;
}
function $7b02104de72354e1$export$f9084667e487ed46(e) {
    return e.length;
}
function $7b02104de72354e1$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $7b02104de72354e1$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $7b02104de72354e1$export$53f1d5ea8de3d7c = 1;
var $7b02104de72354e1$export$4e0c71f277ca26b3 = 1;
var $7b02104de72354e1$export$f24224f1c91d8156 = 0;
var $7b02104de72354e1$export$5880b8b5730aff45 = 0;
var $7b02104de72354e1$export$c0306caf338ac095 = 0;
var $7b02104de72354e1$export$30a86d91af8ff6e6 = "";
function $7b02104de72354e1$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $7b02104de72354e1$export$53f1d5ea8de3d7c,
        column: $7b02104de72354e1$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $7b02104de72354e1$export$784d13d8ee351f07(e, r) {
    return $7b02104de72354e1$export$e6e34fd1f2686227($7b02104de72354e1$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $7b02104de72354e1$export$eba6f6f03b0a92e7() {
    return $7b02104de72354e1$export$c0306caf338ac095;
}
function $7b02104de72354e1$export$232faf9add678146() {
    $7b02104de72354e1$export$c0306caf338ac095 = $7b02104de72354e1$export$5880b8b5730aff45 > 0 ? $7b02104de72354e1$export$a9db5e087081082d($7b02104de72354e1$export$30a86d91af8ff6e6, --$7b02104de72354e1$export$5880b8b5730aff45) : 0;
    if ($7b02104de72354e1$export$4e0c71f277ca26b3--, $7b02104de72354e1$export$c0306caf338ac095 === 10) $7b02104de72354e1$export$4e0c71f277ca26b3 = 1, $7b02104de72354e1$export$53f1d5ea8de3d7c--;
    return $7b02104de72354e1$export$c0306caf338ac095;
}
function $7b02104de72354e1$export$48cfd1e771a65c4f() {
    $7b02104de72354e1$export$c0306caf338ac095 = $7b02104de72354e1$export$5880b8b5730aff45 < $7b02104de72354e1$export$f24224f1c91d8156 ? $7b02104de72354e1$export$a9db5e087081082d($7b02104de72354e1$export$30a86d91af8ff6e6, $7b02104de72354e1$export$5880b8b5730aff45++) : 0;
    if ($7b02104de72354e1$export$4e0c71f277ca26b3++, $7b02104de72354e1$export$c0306caf338ac095 === 10) $7b02104de72354e1$export$4e0c71f277ca26b3 = 1, $7b02104de72354e1$export$53f1d5ea8de3d7c++;
    return $7b02104de72354e1$export$c0306caf338ac095;
}
function $7b02104de72354e1$export$4d3fb11e950abb9e() {
    return $7b02104de72354e1$export$a9db5e087081082d($7b02104de72354e1$export$30a86d91af8ff6e6, $7b02104de72354e1$export$5880b8b5730aff45);
}
function $7b02104de72354e1$export$e88cb2efb12ae807() {
    return $7b02104de72354e1$export$5880b8b5730aff45;
}
function $7b02104de72354e1$export$58adb3bec8346d0f(e, r) {
    return $7b02104de72354e1$export$2f35ab04d2335697($7b02104de72354e1$export$30a86d91af8ff6e6, e, r);
}
function $7b02104de72354e1$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $7b02104de72354e1$export$2de70f21292aac9e(e) {
    return $7b02104de72354e1$export$53f1d5ea8de3d7c = $7b02104de72354e1$export$4e0c71f277ca26b3 = 1, $7b02104de72354e1$export$f24224f1c91d8156 = $7b02104de72354e1$export$36776f635604f274($7b02104de72354e1$export$30a86d91af8ff6e6 = e), $7b02104de72354e1$export$5880b8b5730aff45 = 0, [];
}
function $7b02104de72354e1$export$45918ac1574455b1(e) {
    return $7b02104de72354e1$export$30a86d91af8ff6e6 = "", e;
}
function $7b02104de72354e1$export$410ac95b9ec204b8(e) {
    return $7b02104de72354e1$export$87c2784dc9fc4ab($7b02104de72354e1$export$58adb3bec8346d0f($7b02104de72354e1$export$5880b8b5730aff45 - 1, $7b02104de72354e1$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $7b02104de72354e1$export$660b2ee2d4fb4eff(e) {
    return $7b02104de72354e1$export$45918ac1574455b1($7b02104de72354e1$export$5f8c09e3ae6f64e1($7b02104de72354e1$export$2de70f21292aac9e(e)));
}
function $7b02104de72354e1$export$7af1228ff777d175(e) {
    while($7b02104de72354e1$export$c0306caf338ac095 = $7b02104de72354e1$export$4d3fb11e950abb9e())if ($7b02104de72354e1$export$c0306caf338ac095 < 33) $7b02104de72354e1$export$48cfd1e771a65c4f();
    else break;
    return $7b02104de72354e1$export$9e1725a4cfeada27(e) > 2 || $7b02104de72354e1$export$9e1725a4cfeada27($7b02104de72354e1$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $7b02104de72354e1$export$5f8c09e3ae6f64e1(e) {
    while($7b02104de72354e1$export$48cfd1e771a65c4f())switch($7b02104de72354e1$export$9e1725a4cfeada27($7b02104de72354e1$export$c0306caf338ac095)){
        case 0:
            $7b02104de72354e1$export$10d8903dec122b9d($7b02104de72354e1$export$c2ab62c7bf24634($7b02104de72354e1$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $7b02104de72354e1$export$10d8903dec122b9d($7b02104de72354e1$export$410ac95b9ec204b8($7b02104de72354e1$export$c0306caf338ac095), e);
            break;
        default:
            $7b02104de72354e1$export$10d8903dec122b9d($7b02104de72354e1$export$6788812c4e6611e6($7b02104de72354e1$export$c0306caf338ac095), e);
    }
    return e;
}
function $7b02104de72354e1$export$955ba06d119e085e(e, r) {
    while(--r && $7b02104de72354e1$export$48cfd1e771a65c4f())if ($7b02104de72354e1$export$c0306caf338ac095 < 48 || $7b02104de72354e1$export$c0306caf338ac095 > 102 || $7b02104de72354e1$export$c0306caf338ac095 > 57 && $7b02104de72354e1$export$c0306caf338ac095 < 65 || $7b02104de72354e1$export$c0306caf338ac095 > 70 && $7b02104de72354e1$export$c0306caf338ac095 < 97) break;
    return $7b02104de72354e1$export$58adb3bec8346d0f(e, $7b02104de72354e1$export$e88cb2efb12ae807() + (r < 6 && $7b02104de72354e1$export$4d3fb11e950abb9e() == 32 && $7b02104de72354e1$export$48cfd1e771a65c4f() == 32));
}
function $7b02104de72354e1$export$c889f2fcc19dbf12(e) {
    while($7b02104de72354e1$export$48cfd1e771a65c4f())switch($7b02104de72354e1$export$c0306caf338ac095){
        case e:
            return $7b02104de72354e1$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $7b02104de72354e1$export$c889f2fcc19dbf12($7b02104de72354e1$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $7b02104de72354e1$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $7b02104de72354e1$export$48cfd1e771a65c4f();
            break;
    }
    return $7b02104de72354e1$export$5880b8b5730aff45;
}
function $7b02104de72354e1$export$4254d4e2b3745c4c(e, r) {
    while($7b02104de72354e1$export$48cfd1e771a65c4f())if (e + $7b02104de72354e1$export$c0306caf338ac095 === 57) break;
    else if (e + $7b02104de72354e1$export$c0306caf338ac095 === 84 && $7b02104de72354e1$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $7b02104de72354e1$export$58adb3bec8346d0f(r, $7b02104de72354e1$export$5880b8b5730aff45 - 1) + "*" + $7b02104de72354e1$export$6788812c4e6611e6(e === 47 ? e : $7b02104de72354e1$export$48cfd1e771a65c4f());
}
function $7b02104de72354e1$export$c2ab62c7bf24634(e) {
    while(!$7b02104de72354e1$export$9e1725a4cfeada27($7b02104de72354e1$export$4d3fb11e950abb9e()))$7b02104de72354e1$export$48cfd1e771a65c4f();
    return $7b02104de72354e1$export$58adb3bec8346d0f(e, $7b02104de72354e1$export$5880b8b5730aff45);
}
function $7b02104de72354e1$export$ef7acd7185315e22(e) {
    return $7b02104de72354e1$export$45918ac1574455b1($7b02104de72354e1$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $7b02104de72354e1$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $7b02104de72354e1$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $7b02104de72354e1$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $7b02104de72354e1$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($7b02104de72354e1$export$f8e21b1e77979a08(j += $7b02104de72354e1$export$77ad94ebf1c2b9ed($7b02104de72354e1$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $7b02104de72354e1$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $7b02104de72354e1$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $7b02104de72354e1$export$955ba06d119e085e($7b02104de72354e1$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($7b02104de72354e1$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $7b02104de72354e1$export$10d8903dec122b9d($7b02104de72354e1$export$4a34f930e789283c($7b02104de72354e1$export$4254d4e2b3745c4c($7b02104de72354e1$export$48cfd1e771a65c4f(), $7b02104de72354e1$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $7b02104de72354e1$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $7b02104de72354e1$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $7b02104de72354e1$export$36776f635604f274(j) - l) $7b02104de72354e1$export$10d8903dec122b9d(p > 32 ? $7b02104de72354e1$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $7b02104de72354e1$export$f8483753829ec8f3($7b02104de72354e1$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $7b02104de72354e1$export$10d8903dec122b9d(y = $7b02104de72354e1$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $7b02104de72354e1$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $7b02104de72354e1$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $7b02104de72354e1$export$98e6a39c04603d36(e, y, y, n && $7b02104de72354e1$export$10d8903dec122b9d($7b02104de72354e1$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $7b02104de72354e1$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $7b02104de72354e1$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $7b02104de72354e1$export$232faf9add678146() == 125) continue;
            }
            switch(j += $7b02104de72354e1$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($7b02104de72354e1$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($7b02104de72354e1$export$4d3fb11e950abb9e() === 45) j += $7b02104de72354e1$export$410ac95b9ec204b8($7b02104de72354e1$export$48cfd1e771a65c4f());
                    v = $7b02104de72354e1$export$4d3fb11e950abb9e(), o = l = $7b02104de72354e1$export$36776f635604f274(g = j += $7b02104de72354e1$export$c2ab62c7bf24634($7b02104de72354e1$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $7b02104de72354e1$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $7b02104de72354e1$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $7b02104de72354e1$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $7b02104de72354e1$export$2f35ab04d2335697(e, v + 1, v = $7b02104de72354e1$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $7b02104de72354e1$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $7b02104de72354e1$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $7b02104de72354e1$export$35059013cd4a06db(e, r, a, s === 0 ? $7b02104de72354e1$export$aa3a2e812ca8570d : i, f, o, l);
}
function $7b02104de72354e1$export$4a34f930e789283c(e, r, a) {
    return $7b02104de72354e1$export$35059013cd4a06db(e, r, a, $7b02104de72354e1$export$a29989082612d0d9, $7b02104de72354e1$export$6788812c4e6611e6($7b02104de72354e1$export$eba6f6f03b0a92e7()), $7b02104de72354e1$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $7b02104de72354e1$export$f8483753829ec8f3(e, r, a, n) {
    return $7b02104de72354e1$export$35059013cd4a06db(e, r, a, $7b02104de72354e1$export$527d108ccf083c2b, $7b02104de72354e1$export$2f35ab04d2335697(e, 0, n), $7b02104de72354e1$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $7b02104de72354e1$export$82e9f45cca5ba907(n, c, s) {
    switch($7b02104de72354e1$export$d6af199866bfb566(n, c)){
        case 5103:
            return $7b02104de72354e1$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $7b02104de72354e1$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $7b02104de72354e1$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $7b02104de72354e1$export$39dfd62a25e0fe93 + n + $7b02104de72354e1$export$2c0f367103c8d01c + n + $7b02104de72354e1$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($7b02104de72354e1$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $7b02104de72354e1$export$39dfd62a25e0fe93 + n + $7b02104de72354e1$export$71ad59f2e432cfe8 + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $7b02104de72354e1$export$39dfd62a25e0fe93 + n + $7b02104de72354e1$export$71ad59f2e432cfe8 + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $7b02104de72354e1$export$39dfd62a25e0fe93 + n + $7b02104de72354e1$export$71ad59f2e432cfe8 + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $7b02104de72354e1$export$39dfd62a25e0fe93 + n + $7b02104de72354e1$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $7b02104de72354e1$export$39dfd62a25e0fe93 + n + $7b02104de72354e1$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $7b02104de72354e1$export$39dfd62a25e0fe93 + n + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $7b02104de72354e1$export$39dfd62a25e0fe93 + "box-$1$2" + $7b02104de72354e1$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $7b02104de72354e1$export$39dfd62a25e0fe93 + n + $7b02104de72354e1$export$71ad59f2e432cfe8 + "flex-item-" + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$7b02104de72354e1$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $7b02104de72354e1$export$71ad59f2e432cfe8 + "grid-row-" + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $7b02104de72354e1$export$39dfd62a25e0fe93 + n + $7b02104de72354e1$export$71ad59f2e432cfe8 + "flex-line-pack" + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $7b02104de72354e1$export$39dfd62a25e0fe93 + n + $7b02104de72354e1$export$71ad59f2e432cfe8 + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $7b02104de72354e1$export$39dfd62a25e0fe93 + n + $7b02104de72354e1$export$71ad59f2e432cfe8 + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $7b02104de72354e1$export$39dfd62a25e0fe93 + "box-" + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, "-grow", "") + $7b02104de72354e1$export$39dfd62a25e0fe93 + n + $7b02104de72354e1$export$71ad59f2e432cfe8 + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $7b02104de72354e1$export$39dfd62a25e0fe93 + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $7b02104de72354e1$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $7b02104de72354e1$export$77ad94ebf1c2b9ed($7b02104de72354e1$export$77ad94ebf1c2b9ed($7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $7b02104de72354e1$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $7b02104de72354e1$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $7b02104de72354e1$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $7b02104de72354e1$export$77ad94ebf1c2b9ed($7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $7b02104de72354e1$export$39dfd62a25e0fe93 + "box-pack:$3" + $7b02104de72354e1$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $7b02104de72354e1$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$7b02104de72354e1$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $7b02104de72354e1$export$71ad59f2e432cfe8 + "grid-column-align" + $7b02104de72354e1$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $7b02104de72354e1$export$71ad59f2e432cfe8 + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $7b02104de72354e1$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$7b02104de72354e1$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $7b02104de72354e1$export$71ad59f2e432cfe8 + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $7b02104de72354e1$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$7b02104de72354e1$export$f8e21b1e77979a08(s, "span") ? $7b02104de72354e1$export$4659b591c19bdf3d(s, /\d+/) : +$7b02104de72354e1$export$4659b591c19bdf3d(s, /\d+/) - +$7b02104de72354e1$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $7b02104de72354e1$export$71ad59f2e432cfe8 + $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $7b02104de72354e1$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $7b02104de72354e1$export$71ad59f2e432cfe8 + $7b02104de72354e1$export$77ad94ebf1c2b9ed($7b02104de72354e1$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $7b02104de72354e1$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($7b02104de72354e1$export$36776f635604f274(n) - 1 - c > 6) switch($7b02104de72354e1$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($7b02104de72354e1$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $7b02104de72354e1$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $7b02104de72354e1$export$2c0f367103c8d01c + ($7b02104de72354e1$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$7b02104de72354e1$export$f8e21b1e77979a08(n, "stretch") ? $7b02104de72354e1$export$82e9f45cca5ba907($7b02104de72354e1$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $7b02104de72354e1$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $7b02104de72354e1$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($7b02104de72354e1$export$a9db5e087081082d(n, c + 6) === 121) return $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, ":", ":" + $7b02104de72354e1$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($7b02104de72354e1$export$a9db5e087081082d(n, $7b02104de72354e1$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $7b02104de72354e1$export$39dfd62a25e0fe93 + ($7b02104de72354e1$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $7b02104de72354e1$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $7b02104de72354e1$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, ":", ":" + $7b02104de72354e1$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $7b02104de72354e1$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $7b02104de72354e1$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $7b02104de72354e1$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $7b02104de72354e1$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $7b02104de72354e1$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $7b02104de72354e1$export$a763edbf796b780a:
        case $7b02104de72354e1$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $7b02104de72354e1$export$a29989082612d0d9:
            return "";
        case $7b02104de72354e1$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $7b02104de72354e1$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $7b02104de72354e1$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $7b02104de72354e1$export$36776f635604f274(a = $7b02104de72354e1$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $7b02104de72354e1$export$5a7767152ae0305f(e) {
    var r = $7b02104de72354e1$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $7b02104de72354e1$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $7b02104de72354e1$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $7b02104de72354e1$export$527d108ccf083c2b:
                n.return = $7b02104de72354e1$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $7b02104de72354e1$export$b44a8529a35fcb60:
                return $7b02104de72354e1$export$dfdc1655ccc5b9cb([
                    $7b02104de72354e1$export$784d13d8ee351f07(n, {
                        value: $7b02104de72354e1$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $7b02104de72354e1$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $7b02104de72354e1$export$aa3a2e812ca8570d:
                if (n.length) return $7b02104de72354e1$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($7b02104de72354e1$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $7b02104de72354e1$export$dfdc1655ccc5b9cb([
                                $7b02104de72354e1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $7b02104de72354e1$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $7b02104de72354e1$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $7b02104de72354e1$export$dfdc1655ccc5b9cb([
                                $7b02104de72354e1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $7b02104de72354e1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $7b02104de72354e1$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $7b02104de72354e1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $7b02104de72354e1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $7b02104de72354e1$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $7b02104de72354e1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $7b02104de72354e1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $7b02104de72354e1$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $7b02104de72354e1$export$76a88f7de6507443(e) {
    switch(e.type){
        case $7b02104de72354e1$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $7b02104de72354e1$export$1be1fc439b849fdf($7b02104de72354e1$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($7b02104de72354e1$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $7b02104de72354e1$export$2f35ab04d2335697(r, 1, $7b02104de72354e1$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $7b02104de72354e1$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $7b02104de72354e1$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $7b02104de72354e1$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("jMD99", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e670ddb6e7a47afc$export$2e2bcd8739ae039; });
var $e670ddb6e7a47afc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("916Xo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69099a90125bd677$export$2e2bcd8739ae039; });

var $frqg1 = parcelRequire("frqg1");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $69099a90125bd677$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($frqg1)))(targetComponent, sourceComponent);
};

});
parcelRegister("frqg1", function(module, exports) {
'use strict';

var $1yKn0 = parcelRequire("1yKn0");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $b3ddbed479ad0ce6$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $b3ddbed479ad0ce6$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $b3ddbed479ad0ce6$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $b3ddbed479ad0ce6$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $b3ddbed479ad0ce6$var$TYPE_STATICS = {};
$b3ddbed479ad0ce6$var$TYPE_STATICS[$1yKn0.ForwardRef] = $b3ddbed479ad0ce6$var$FORWARD_REF_STATICS;
$b3ddbed479ad0ce6$var$TYPE_STATICS[$1yKn0.Memo] = $b3ddbed479ad0ce6$var$MEMO_STATICS;
function $b3ddbed479ad0ce6$var$getStatics(component) {
    // React v16.11 and below
    if ($1yKn0.isMemo(component)) return $b3ddbed479ad0ce6$var$MEMO_STATICS;
     // React v16.12 and above
    return $b3ddbed479ad0ce6$var$TYPE_STATICS[component['$$typeof']] || $b3ddbed479ad0ce6$var$REACT_STATICS;
}
var $b3ddbed479ad0ce6$var$defineProperty = Object.defineProperty;
var $b3ddbed479ad0ce6$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $b3ddbed479ad0ce6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $b3ddbed479ad0ce6$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $b3ddbed479ad0ce6$var$getPrototypeOf = Object.getPrototypeOf;
var $b3ddbed479ad0ce6$var$objectPrototype = Object.prototype;
function $b3ddbed479ad0ce6$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($b3ddbed479ad0ce6$var$objectPrototype) {
            var inheritedComponent = $b3ddbed479ad0ce6$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $b3ddbed479ad0ce6$var$objectPrototype) $b3ddbed479ad0ce6$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $b3ddbed479ad0ce6$var$getOwnPropertyNames(sourceComponent);
        if ($b3ddbed479ad0ce6$var$getOwnPropertySymbols) keys = keys.concat($b3ddbed479ad0ce6$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $b3ddbed479ad0ce6$var$getStatics(targetComponent);
        var sourceStatics = $b3ddbed479ad0ce6$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$b3ddbed479ad0ce6$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $b3ddbed479ad0ce6$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $b3ddbed479ad0ce6$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $b3ddbed479ad0ce6$var$hoistNonReactStatics;

});
parcelRegister("1yKn0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3rAPc"));

});



parcelRegister("hLA0o", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $cef2c15cd33a28d4$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $cef2c15cd33a28d4$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $cef2c15cd33a28d4$export$6f077d94b33a01aa; });
var $cef2c15cd33a28d4$var$isBrowser = typeof document !== 'undefined';
function $cef2c15cd33a28d4$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $cef2c15cd33a28d4$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $cef2c15cd33a28d4$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $cef2c15cd33a28d4$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $cef2c15cd33a28d4$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$cef2c15cd33a28d4$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$cef2c15cd33a28d4$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("kHp9Z", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $f11b570f8b8ec918$export$6321afa313b251b5; });

var $6G41i = parcelRequire("6G41i");

var $iLd3w = parcelRequire("iLd3w");

var $bnoTt = parcelRequire("bnoTt");
var $f11b570f8b8ec918$var$isDevelopment = false;
var $f11b570f8b8ec918$var$hyphenateRegex = /[A-Z]|^ms/g;
var $f11b570f8b8ec918$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $f11b570f8b8ec918$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $f11b570f8b8ec918$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $f11b570f8b8ec918$var$processStyleName = /* #__PURE__ */ (0, $bnoTt.default)(function(styleName) {
    return $f11b570f8b8ec918$var$isCustomProperty(styleName) ? styleName : styleName.replace($f11b570f8b8ec918$var$hyphenateRegex, '-$&').toLowerCase();
});
var $f11b570f8b8ec918$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($f11b570f8b8ec918$var$animationRegex, function(match, p1, p2) {
                $f11b570f8b8ec918$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $f11b570f8b8ec918$var$cursor
                };
                return p1;
            });
    }
    if ((0, $iLd3w.default)[key] !== 1 && !$f11b570f8b8ec918$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $f11b570f8b8ec918$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $f11b570f8b8ec918$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $f11b570f8b8ec918$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $f11b570f8b8ec918$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $f11b570f8b8ec918$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $f11b570f8b8ec918$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $f11b570f8b8ec918$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $f11b570f8b8ec918$var$cursor;
                var result = interpolation(mergedProps);
                $f11b570f8b8ec918$var$cursor = previousCursor;
                return $f11b570f8b8ec918$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $f11b570f8b8ec918$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $f11b570f8b8ec918$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($f11b570f8b8ec918$var$isProcessableValue(asString)) string += $f11b570f8b8ec918$var$processStyleName(key) + ":" + $f11b570f8b8ec918$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $f11b570f8b8ec918$var$isDevelopment) throw new Error($f11b570f8b8ec918$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($f11b570f8b8ec918$var$isProcessableValue(value[_i])) string += $f11b570f8b8ec918$var$processStyleName(key) + ":" + $f11b570f8b8ec918$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $f11b570f8b8ec918$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $f11b570f8b8ec918$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $f11b570f8b8ec918$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $f11b570f8b8ec918$var$cursor;
function $f11b570f8b8ec918$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $f11b570f8b8ec918$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $f11b570f8b8ec918$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $f11b570f8b8ec918$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $f11b570f8b8ec918$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $f11b570f8b8ec918$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $6G41i.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $f11b570f8b8ec918$var$cursor
    };
}

});
parcelRegister("6G41i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4dc9c893f74a92c4$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $4dc9c893f74a92c4$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("iLd3w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da86be5ea3a64806$export$2e2bcd8739ae039; });
var $da86be5ea3a64806$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("9WSKf", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $73e3ff0a4b0969e5$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $73e3ff0a4b0969e5$export$811a713a7276cb9d; });

var $i5lfL = parcelRequire("i5lfL");
var $73e3ff0a4b0969e5$var$isBrowser = typeof document !== 'undefined';
var $73e3ff0a4b0969e5$var$syncFallback = function syncFallback(create) {
    return create();
};
var $73e3ff0a4b0969e5$var$useInsertionEffect = $i5lfL.useInsertionEffect ? $i5lfL.useInsertionEffect : false;
var $73e3ff0a4b0969e5$export$db21c7ffa21794e7 = !$73e3ff0a4b0969e5$var$isBrowser ? $73e3ff0a4b0969e5$var$syncFallback : $73e3ff0a4b0969e5$var$useInsertionEffect || $73e3ff0a4b0969e5$var$syncFallback;
var $73e3ff0a4b0969e5$export$811a713a7276cb9d = $73e3ff0a4b0969e5$var$useInsertionEffect || $i5lfL.useLayoutEffect;

});





parcelRegister("4a39B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $307a8ae8b98bc72e$export$2e2bcd8739ae039; });
parcelRequire("i5lfL");


var $5Vkbx = parcelRequire("5Vkbx");

var $budkK = parcelRequire("budkK");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
let $307a8ae8b98bc72e$var$cache;
if (typeof document === 'object') $307a8ae8b98bc72e$var$cache = (0, $budkK.default)({
    key: 'css',
    prepend: true
});
function $307a8ae8b98bc72e$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $307a8ae8b98bc72e$var$cache ? /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $5Vkbx.C), {
        value: $307a8ae8b98bc72e$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("bHJbJ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jXVM0"));

});


parcelRegister("7yrkh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5800e7ca258dee8d$export$2e2bcd8739ae039; });
parcelRequire("i5lfL");


var $d8Gg3 = parcelRequire("d8Gg3");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
function $5800e7ca258dee8d$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $5800e7ca258dee8d$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($5800e7ca258dee8d$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d8Gg3.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("lSLgv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8xMlt")).default; });

var $8xMlt = parcelRequire("8xMlt");

});
parcelRegister("8xMlt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6386e82d39149e26$export$2e2bcd8739ae039; });

var $1SAXO = parcelRequire("1SAXO");
function $6386e82d39149e26$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $1SAXO.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("3Z6GM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1i3qm")).default; });

var $1i3qm = parcelRequire("1i3qm");
$parcel$exportWildcard(module.exports, $1i3qm);

});
parcelRegister("1i3qm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $0f0a20d7a1119990$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $0f0a20d7a1119990$export$2e2bcd8739ae039; });

var $67Wr0 = parcelRequire("67Wr0");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $0f0a20d7a1119990$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $0f0a20d7a1119990$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($0f0a20d7a1119990$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $0f0a20d7a1119990$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $0f0a20d7a1119990$export$aad197c7121a6651(Component) || fallback;
}
function $0f0a20d7a1119990$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $0f0a20d7a1119990$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $0f0a20d7a1119990$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $0f0a20d7a1119990$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $67Wr0.ForwardRef:
            return $0f0a20d7a1119990$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $67Wr0.Memo:
            return $0f0a20d7a1119990$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("67Wr0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("k3y3z"));

});
parcelRegister("k3y3z", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $e99e8160736c314e$export$a7c73072b1a182ae; }, function (v) { return $e99e8160736c314e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $e99e8160736c314e$export$9f27bc3417b4524d; }, function (v) { return $e99e8160736c314e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $e99e8160736c314e$export$db77ccec0bb4ccac; }, function (v) { return $e99e8160736c314e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $e99e8160736c314e$export$8392c0c9d3dcbd35; }, function (v) { return $e99e8160736c314e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e99e8160736c314e$export$ffb0004e005737fa; }, function (v) { return $e99e8160736c314e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $e99e8160736c314e$export$b624eff549462981; }, function (v) { return $e99e8160736c314e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $e99e8160736c314e$export$7897aa7841a5380c; }, function (v) { return $e99e8160736c314e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $e99e8160736c314e$export$602eac185826482c; }, function (v) { return $e99e8160736c314e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $e99e8160736c314e$export$e2c29f18771995cb; }, function (v) { return $e99e8160736c314e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e99e8160736c314e$export$5f8d39834fd61797; }, function (v) { return $e99e8160736c314e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e99e8160736c314e$export$74bf444e3cd11ea5; }, function (v) { return $e99e8160736c314e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $e99e8160736c314e$export$998bcd577473dd93; }, function (v) { return $e99e8160736c314e$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $e99e8160736c314e$export$92387174baf9b227; }, function (v) { return $e99e8160736c314e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $e99e8160736c314e$export$ec112efeb987d9c6; }, function (v) { return $e99e8160736c314e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $e99e8160736c314e$export$b706b080d889d2c9; }, function (v) { return $e99e8160736c314e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $e99e8160736c314e$export$5be5a87408f70ddc; }, function (v) { return $e99e8160736c314e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $e99e8160736c314e$export$45a5e7f76e0caa8d; }, function (v) { return $e99e8160736c314e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $e99e8160736c314e$export$455c2e768291efa6; }, function (v) { return $e99e8160736c314e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $e99e8160736c314e$export$9522e17588c12572; }, function (v) { return $e99e8160736c314e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $e99e8160736c314e$export$2110ac352bb060b9; }, function (v) { return $e99e8160736c314e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $e99e8160736c314e$export$56885ab8b9c456ab; }, function (v) { return $e99e8160736c314e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $e99e8160736c314e$export$d927fcb6adf8f9de; }, function (v) { return $e99e8160736c314e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $e99e8160736c314e$export$b82d16f27459e05a; }, function (v) { return $e99e8160736c314e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $e99e8160736c314e$export$522c17b4f5e123e8; }, function (v) { return $e99e8160736c314e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $e99e8160736c314e$export$1aabd8a0274ecfd6; }, function (v) { return $e99e8160736c314e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $e99e8160736c314e$export$3d6c20d97e46b957; }, function (v) { return $e99e8160736c314e$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $e99e8160736c314e$export$9b621391a187a31a; }, function (v) { return $e99e8160736c314e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $e99e8160736c314e$export$f5bbd400c2f4426f; }, function (v) { return $e99e8160736c314e$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e99e8160736c314e$export$a7c73072b1a182ae;
var $e99e8160736c314e$export$9f27bc3417b4524d;
var $e99e8160736c314e$export$db77ccec0bb4ccac;
var $e99e8160736c314e$export$8392c0c9d3dcbd35;
var $e99e8160736c314e$export$ffb0004e005737fa;
var $e99e8160736c314e$export$b624eff549462981;
var $e99e8160736c314e$export$7897aa7841a5380c;
var $e99e8160736c314e$export$602eac185826482c;
var $e99e8160736c314e$export$e2c29f18771995cb;
var $e99e8160736c314e$export$5f8d39834fd61797;
var $e99e8160736c314e$export$74bf444e3cd11ea5;
var $e99e8160736c314e$export$998bcd577473dd93;
var $e99e8160736c314e$export$92387174baf9b227;
var $e99e8160736c314e$export$ec112efeb987d9c6;
var $e99e8160736c314e$export$b706b080d889d2c9;
var $e99e8160736c314e$export$5be5a87408f70ddc;
var $e99e8160736c314e$export$45a5e7f76e0caa8d;
var $e99e8160736c314e$export$455c2e768291efa6;
var $e99e8160736c314e$export$9522e17588c12572;
var $e99e8160736c314e$export$2110ac352bb060b9;
var $e99e8160736c314e$export$56885ab8b9c456ab;
var $e99e8160736c314e$export$d927fcb6adf8f9de;
var $e99e8160736c314e$export$b82d16f27459e05a;
var $e99e8160736c314e$export$522c17b4f5e123e8;
var $e99e8160736c314e$export$1aabd8a0274ecfd6;
var $e99e8160736c314e$export$3d6c20d97e46b957;
var $e99e8160736c314e$export$9b621391a187a31a;
var $e99e8160736c314e$export$f5bbd400c2f4426f;
'use strict';
var $e99e8160736c314e$var$b = Symbol.for("react.element"), $e99e8160736c314e$var$c = Symbol.for("react.portal"), $e99e8160736c314e$var$d = Symbol.for("react.fragment"), $e99e8160736c314e$var$e = Symbol.for("react.strict_mode"), $e99e8160736c314e$var$f = Symbol.for("react.profiler"), $e99e8160736c314e$var$g = Symbol.for("react.provider"), $e99e8160736c314e$var$h = Symbol.for("react.context"), $e99e8160736c314e$var$k = Symbol.for("react.server_context"), $e99e8160736c314e$var$l = Symbol.for("react.forward_ref"), $e99e8160736c314e$var$m = Symbol.for("react.suspense"), $e99e8160736c314e$var$n = Symbol.for("react.suspense_list"), $e99e8160736c314e$var$p = Symbol.for("react.memo"), $e99e8160736c314e$var$q = Symbol.for("react.lazy"), $e99e8160736c314e$var$t = Symbol.for("react.offscreen"), $e99e8160736c314e$var$u;
$e99e8160736c314e$var$u = Symbol.for("react.module.reference");
function $e99e8160736c314e$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $e99e8160736c314e$var$b:
                switch(a = a.type, a){
                    case $e99e8160736c314e$var$d:
                    case $e99e8160736c314e$var$f:
                    case $e99e8160736c314e$var$e:
                    case $e99e8160736c314e$var$m:
                    case $e99e8160736c314e$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $e99e8160736c314e$var$k:
                            case $e99e8160736c314e$var$h:
                            case $e99e8160736c314e$var$l:
                            case $e99e8160736c314e$var$q:
                            case $e99e8160736c314e$var$p:
                            case $e99e8160736c314e$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $e99e8160736c314e$var$c:
                return r;
        }
    }
}
$e99e8160736c314e$export$a7c73072b1a182ae = $e99e8160736c314e$var$h;
$e99e8160736c314e$export$9f27bc3417b4524d = $e99e8160736c314e$var$g;
$e99e8160736c314e$export$db77ccec0bb4ccac = $e99e8160736c314e$var$b;
$e99e8160736c314e$export$8392c0c9d3dcbd35 = $e99e8160736c314e$var$l;
$e99e8160736c314e$export$ffb0004e005737fa = $e99e8160736c314e$var$d;
$e99e8160736c314e$export$b624eff549462981 = $e99e8160736c314e$var$q;
$e99e8160736c314e$export$7897aa7841a5380c = $e99e8160736c314e$var$p;
$e99e8160736c314e$export$602eac185826482c = $e99e8160736c314e$var$c;
$e99e8160736c314e$export$e2c29f18771995cb = $e99e8160736c314e$var$f;
$e99e8160736c314e$export$5f8d39834fd61797 = $e99e8160736c314e$var$e;
$e99e8160736c314e$export$74bf444e3cd11ea5 = $e99e8160736c314e$var$m;
$e99e8160736c314e$export$998bcd577473dd93 = $e99e8160736c314e$var$n;
$e99e8160736c314e$export$92387174baf9b227 = function() {
    return !1;
};
$e99e8160736c314e$export$ec112efeb987d9c6 = function() {
    return !1;
};
$e99e8160736c314e$export$b706b080d889d2c9 = function(a) {
    return $e99e8160736c314e$var$v(a) === $e99e8160736c314e$var$h;
};
$e99e8160736c314e$export$5be5a87408f70ddc = function(a) {
    return $e99e8160736c314e$var$v(a) === $e99e8160736c314e$var$g;
};
$e99e8160736c314e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e99e8160736c314e$var$b;
};
$e99e8160736c314e$export$455c2e768291efa6 = function(a) {
    return $e99e8160736c314e$var$v(a) === $e99e8160736c314e$var$l;
};
$e99e8160736c314e$export$9522e17588c12572 = function(a) {
    return $e99e8160736c314e$var$v(a) === $e99e8160736c314e$var$d;
};
$e99e8160736c314e$export$2110ac352bb060b9 = function(a) {
    return $e99e8160736c314e$var$v(a) === $e99e8160736c314e$var$q;
};
$e99e8160736c314e$export$56885ab8b9c456ab = function(a) {
    return $e99e8160736c314e$var$v(a) === $e99e8160736c314e$var$p;
};
$e99e8160736c314e$export$d927fcb6adf8f9de = function(a) {
    return $e99e8160736c314e$var$v(a) === $e99e8160736c314e$var$c;
};
$e99e8160736c314e$export$b82d16f27459e05a = function(a) {
    return $e99e8160736c314e$var$v(a) === $e99e8160736c314e$var$f;
};
$e99e8160736c314e$export$522c17b4f5e123e8 = function(a) {
    return $e99e8160736c314e$var$v(a) === $e99e8160736c314e$var$e;
};
$e99e8160736c314e$export$1aabd8a0274ecfd6 = function(a) {
    return $e99e8160736c314e$var$v(a) === $e99e8160736c314e$var$m;
};
$e99e8160736c314e$export$3d6c20d97e46b957 = function(a) {
    return $e99e8160736c314e$var$v(a) === $e99e8160736c314e$var$n;
};
$e99e8160736c314e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $e99e8160736c314e$var$d || a === $e99e8160736c314e$var$f || a === $e99e8160736c314e$var$e || a === $e99e8160736c314e$var$m || a === $e99e8160736c314e$var$n || a === $e99e8160736c314e$var$t || "object" === typeof a && null !== a && (a.$$typeof === $e99e8160736c314e$var$q || a.$$typeof === $e99e8160736c314e$var$p || a.$$typeof === $e99e8160736c314e$var$g || a.$$typeof === $e99e8160736c314e$var$h || a.$$typeof === $e99e8160736c314e$var$l || a.$$typeof === $e99e8160736c314e$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$e99e8160736c314e$export$f5bbd400c2f4426f = $e99e8160736c314e$var$v;

});




parcelRegister("gNIU8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8mN0u")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("ipx4x")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("fYbRg")).default; });

var $8mN0u = parcelRequire("8mN0u");

var $ipx4x = parcelRequire("ipx4x");

var $fYbRg = parcelRequire("fYbRg");

});
parcelRegister("8mN0u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61766492b1dd0be2$export$2e2bcd8739ae039; });

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $FRCsQ = parcelRequire("FRCsQ");

var $ipx4x = parcelRequire("ipx4x");

var $3li47 = parcelRequire("3li47");

var $if2ex = parcelRequire("if2ex");

var $lwaO7 = parcelRequire("lwaO7");

var $aJI7D = parcelRequire("aJI7D");

var $fYbRg = parcelRequire("fYbRg");
const $61766492b1dd0be2$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $61766492b1dd0be2$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $7qXFD.default)(options, $61766492b1dd0be2$var$_excluded);
    const breakpoints = (0, $ipx4x.default)(breakpointsInput);
    const spacing = (0, $if2ex.default)(spacingInput);
    let muiTheme = (0, $FRCsQ.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $1CWiu.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $1CWiu.default)({}, (0, $3li47.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $fYbRg.default);
    muiTheme = args.reduce((acc, argument)=>(0, $FRCsQ.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $1CWiu.default)({}, (0, $aJI7D.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $lwaO7.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $61766492b1dd0be2$export$2e2bcd8739ae039 = $61766492b1dd0be2$var$createTheme;

});
parcelRegister("7qXFD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56993f72492b7638$export$2e2bcd8739ae039; });
function $56993f72492b7638$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("FRCsQ", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $07dd6c24ea2e687a$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $07dd6c24ea2e687a$export$2e2bcd8739ae039; });

var $1CWiu = parcelRequire("1CWiu");
function $07dd6c24ea2e687a$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $07dd6c24ea2e687a$var$deepClone(source) {
    if (!$07dd6c24ea2e687a$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $07dd6c24ea2e687a$var$deepClone(source[key]);
    });
    return output;
}
function $07dd6c24ea2e687a$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $1CWiu.default)({}, target) : target;
    if ($07dd6c24ea2e687a$export$53b83ca8eaab0383(target) && $07dd6c24ea2e687a$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($07dd6c24ea2e687a$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $07dd6c24ea2e687a$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $07dd6c24ea2e687a$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $07dd6c24ea2e687a$export$53b83ca8eaab0383(source[key]) ? $07dd6c24ea2e687a$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("ipx4x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d674373a1dece8e8$export$2e2bcd8739ae039; });

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");
const $d674373a1dece8e8$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $d674373a1dece8e8$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $d674373a1dece8e8$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $1CWiu.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $d674373a1dece8e8$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $7qXFD.default)(breakpoints, $d674373a1dece8e8$var$_excluded);
    const sortedValues = $d674373a1dece8e8$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $1CWiu.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("3li47", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26f158b13d3f6d92$export$2e2bcd8739ae039; });
const $26f158b13d3f6d92$var$shape = {
    borderRadius: 4
};
var $26f158b13d3f6d92$export$2e2bcd8739ae039 = $26f158b13d3f6d92$var$shape;

});

parcelRegister("if2ex", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d47b5c3e97430552$export$2e2bcd8739ae039; });

var $1XI54 = parcelRequire("1XI54");
function $d47b5c3e97430552$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $1XI54.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("1XI54", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $16dd7ea6a16b9604$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $16dd7ea6a16b9604$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $16dd7ea6a16b9604$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $16dd7ea6a16b9604$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $16dd7ea6a16b9604$export$6f98e8eaf0be1996; });


var $3IE2K = parcelRequire("3IE2K");

var $bvu3b = parcelRequire("bvu3b");

var $eZX2M = parcelRequire("eZX2M");

var $1IMBS = parcelRequire("1IMBS");
const $16dd7ea6a16b9604$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $16dd7ea6a16b9604$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $16dd7ea6a16b9604$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $16dd7ea6a16b9604$var$getCssProperties = (0, $1IMBS.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($16dd7ea6a16b9604$var$aliases[prop]) prop = $16dd7ea6a16b9604$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $16dd7ea6a16b9604$var$properties[a];
    const direction = $16dd7ea6a16b9604$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $16dd7ea6a16b9604$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $16dd7ea6a16b9604$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $16dd7ea6a16b9604$var$spacingKeys = [
    ...$16dd7ea6a16b9604$export$aab52a0dde05ad8a,
    ...$16dd7ea6a16b9604$export$f8397d44f03ab6ad
];
function $16dd7ea6a16b9604$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $bvu3b.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $16dd7ea6a16b9604$export$1def6f833384e3d1(theme) {
    return $16dd7ea6a16b9604$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $16dd7ea6a16b9604$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $16dd7ea6a16b9604$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $16dd7ea6a16b9604$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $16dd7ea6a16b9604$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $16dd7ea6a16b9604$var$getCssProperties(prop);
    const styleFromPropValue = $16dd7ea6a16b9604$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $3IE2K.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $16dd7ea6a16b9604$var$style(props, keys) {
    const transformer = $16dd7ea6a16b9604$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$16dd7ea6a16b9604$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $eZX2M.default), {});
}
function $16dd7ea6a16b9604$export$7ede87f9b603dd3c(props) {
    return $16dd7ea6a16b9604$var$style(props, $16dd7ea6a16b9604$export$aab52a0dde05ad8a);
}
$16dd7ea6a16b9604$export$7ede87f9b603dd3c.propTypes = {};
$16dd7ea6a16b9604$export$7ede87f9b603dd3c.filterProps = $16dd7ea6a16b9604$export$aab52a0dde05ad8a;
function $16dd7ea6a16b9604$export$6f98e8eaf0be1996(props) {
    return $16dd7ea6a16b9604$var$style(props, $16dd7ea6a16b9604$export$f8397d44f03ab6ad);
}
$16dd7ea6a16b9604$export$6f98e8eaf0be1996.propTypes = {};
$16dd7ea6a16b9604$export$6f98e8eaf0be1996.filterProps = $16dd7ea6a16b9604$export$f8397d44f03ab6ad;
function $16dd7ea6a16b9604$var$spacing(props) {
    return $16dd7ea6a16b9604$var$style(props, $16dd7ea6a16b9604$var$spacingKeys);
}
$16dd7ea6a16b9604$var$spacing.propTypes = {};
$16dd7ea6a16b9604$var$spacing.filterProps = $16dd7ea6a16b9604$var$spacingKeys;
var $16dd7ea6a16b9604$export$2e2bcd8739ae039 = $16dd7ea6a16b9604$var$spacing;

});
parcelRegister("3IE2K", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $2b548aeb1e8bab27$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $2b548aeb1e8bab27$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $2b548aeb1e8bab27$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $2b548aeb1e8bab27$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $2b548aeb1e8bab27$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $2b548aeb1e8bab27$export$980e6a259d807490; });

var $1CWiu = parcelRequire("1CWiu");


var $FRCsQ = parcelRequire("FRCsQ");

var $eZX2M = parcelRequire("eZX2M");
const $2b548aeb1e8bab27$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2b548aeb1e8bab27$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$2b548aeb1e8bab27$export$68c286be0e7e55b7[key]}px)`
};
function $2b548aeb1e8bab27$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2b548aeb1e8bab27$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $2b548aeb1e8bab27$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $2b548aeb1e8bab27$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2b548aeb1e8bab27$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2b548aeb1e8bab27$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $1CWiu.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $eZX2M.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2b548aeb1e8bab27$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2b548aeb1e8bab27$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2b548aeb1e8bab27$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2b548aeb1e8bab27$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $FRCsQ.default)(prev, next), {});
    return $2b548aeb1e8bab27$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $2b548aeb1e8bab27$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2b548aeb1e8bab27$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $2b548aeb1e8bab27$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $2b548aeb1e8bab27$export$2e2bcd8739ae039 = $2b548aeb1e8bab27$var$breakpoints;

});
parcelRegister("eZX2M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aeb49012c9b7537e$export$2e2bcd8739ae039; });

var $FRCsQ = parcelRequire("FRCsQ");
function $aeb49012c9b7537e$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $FRCsQ.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $aeb49012c9b7537e$export$2e2bcd8739ae039 = $aeb49012c9b7537e$var$merge;

});


parcelRegister("bvu3b", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $8609e65864d4856a$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $8609e65864d4856a$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $8609e65864d4856a$export$2e2bcd8739ae039; });

var $8xMlt = parcelRequire("8xMlt");


var $3IE2K = parcelRequire("3IE2K");
function $8609e65864d4856a$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $8609e65864d4856a$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $8609e65864d4856a$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $8609e65864d4856a$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $8609e65864d4856a$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $8609e65864d4856a$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $8609e65864d4856a$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $8xMlt.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3IE2K.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $8609e65864d4856a$export$2e2bcd8739ae039 = $8609e65864d4856a$var$style;

});

parcelRegister("1IMBS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $140f9b694370da82$export$2e2bcd8739ae039; });
function $140f9b694370da82$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("lwaO7", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $faa4f844ded55277$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $faa4f844ded55277$export$2e2bcd8739ae039; });

var $8xMlt = parcelRequire("8xMlt");

var $eZX2M = parcelRequire("eZX2M");

var $bvu3b = parcelRequire("bvu3b");

var $3IE2K = parcelRequire("3IE2K");

var $aJI7D = parcelRequire("aJI7D");
function $faa4f844ded55277$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $faa4f844ded55277$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $faa4f844ded55277$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $bvu3b.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $bvu3b.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $bvu3b.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $8xMlt.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $3IE2K.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $aJI7D.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $3IE2K.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $faa4f844ded55277$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $eZX2M.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $3IE2K.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($faa4f844ded55277$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $eZX2M.default)(css, breakpointsValues);
                        }
                    } else css = (0, $eZX2M.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $3IE2K.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $faa4f844ded55277$var$styleFunctionSx = $faa4f844ded55277$export$7d53d8bf2911e013();
$faa4f844ded55277$var$styleFunctionSx.filterProps = [
    'sx'
];
var $faa4f844ded55277$export$2e2bcd8739ae039 = $faa4f844ded55277$var$styleFunctionSx;

});
parcelRegister("aJI7D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d10551a75c69175$export$2e2bcd8739ae039; });

var $1XI54 = parcelRequire("1XI54");

var $hVg62 = parcelRequire("hVg62");

var $jc55C = parcelRequire("jc55C");

var $g7Ryi = parcelRequire("g7Ryi");

var $but9P = parcelRequire("but9P");
const $7d10551a75c69175$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $hVg62.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $hVg62.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $hVg62.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $hVg62.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $hVg62.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $hVg62.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $hVg62.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $g7Ryi.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $g7Ryi.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $g7Ryi.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $1XI54.padding)
    },
    pt: {
        style: (0, $1XI54.padding)
    },
    pr: {
        style: (0, $1XI54.padding)
    },
    pb: {
        style: (0, $1XI54.padding)
    },
    pl: {
        style: (0, $1XI54.padding)
    },
    px: {
        style: (0, $1XI54.padding)
    },
    py: {
        style: (0, $1XI54.padding)
    },
    padding: {
        style: (0, $1XI54.padding)
    },
    paddingTop: {
        style: (0, $1XI54.padding)
    },
    paddingRight: {
        style: (0, $1XI54.padding)
    },
    paddingBottom: {
        style: (0, $1XI54.padding)
    },
    paddingLeft: {
        style: (0, $1XI54.padding)
    },
    paddingX: {
        style: (0, $1XI54.padding)
    },
    paddingY: {
        style: (0, $1XI54.padding)
    },
    paddingInline: {
        style: (0, $1XI54.padding)
    },
    paddingInlineStart: {
        style: (0, $1XI54.padding)
    },
    paddingInlineEnd: {
        style: (0, $1XI54.padding)
    },
    paddingBlock: {
        style: (0, $1XI54.padding)
    },
    paddingBlockStart: {
        style: (0, $1XI54.padding)
    },
    paddingBlockEnd: {
        style: (0, $1XI54.padding)
    },
    m: {
        style: (0, $1XI54.margin)
    },
    mt: {
        style: (0, $1XI54.margin)
    },
    mr: {
        style: (0, $1XI54.margin)
    },
    mb: {
        style: (0, $1XI54.margin)
    },
    ml: {
        style: (0, $1XI54.margin)
    },
    mx: {
        style: (0, $1XI54.margin)
    },
    my: {
        style: (0, $1XI54.margin)
    },
    margin: {
        style: (0, $1XI54.margin)
    },
    marginTop: {
        style: (0, $1XI54.margin)
    },
    marginRight: {
        style: (0, $1XI54.margin)
    },
    marginBottom: {
        style: (0, $1XI54.margin)
    },
    marginLeft: {
        style: (0, $1XI54.margin)
    },
    marginX: {
        style: (0, $1XI54.margin)
    },
    marginY: {
        style: (0, $1XI54.margin)
    },
    marginInline: {
        style: (0, $1XI54.margin)
    },
    marginInlineStart: {
        style: (0, $1XI54.margin)
    },
    marginInlineEnd: {
        style: (0, $1XI54.margin)
    },
    marginBlock: {
        style: (0, $1XI54.margin)
    },
    marginBlockStart: {
        style: (0, $1XI54.margin)
    },
    marginBlockEnd: {
        style: (0, $1XI54.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $jc55C.gap)
    },
    rowGap: {
        style: (0, $jc55C.rowGap)
    },
    columnGap: {
        style: (0, $jc55C.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $but9P.sizingTransform)
    },
    maxWidth: {
        style: (0, $but9P.maxWidth)
    },
    minWidth: {
        transform: (0, $but9P.sizingTransform)
    },
    height: {
        transform: (0, $but9P.sizingTransform)
    },
    maxHeight: {
        transform: (0, $but9P.sizingTransform)
    },
    minHeight: {
        transform: (0, $but9P.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $7d10551a75c69175$export$2e2bcd8739ae039 = $7d10551a75c69175$var$defaultSxConfig;

});
parcelRegister("hVg62", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $d0c43ef4dd981efe$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $d0c43ef4dd981efe$export$7a57f79000377ca2; });


var $bvu3b = parcelRequire("bvu3b");

var $3aOEr = parcelRequire("3aOEr");

var $1XI54 = parcelRequire("1XI54");

var $3IE2K = parcelRequire("3IE2K");
function $d0c43ef4dd981efe$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $d0c43ef4dd981efe$var$createBorderStyle(prop, transform) {
    return (0, $bvu3b.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $d0c43ef4dd981efe$export$1edee58a52776cd9 = $d0c43ef4dd981efe$var$createBorderStyle('border', $d0c43ef4dd981efe$export$34e2febe53ae29cc);
const $d0c43ef4dd981efe$export$f9a7b6bd24892946 = $d0c43ef4dd981efe$var$createBorderStyle('borderTop', $d0c43ef4dd981efe$export$34e2febe53ae29cc);
const $d0c43ef4dd981efe$export$5abca33e6be905d2 = $d0c43ef4dd981efe$var$createBorderStyle('borderRight', $d0c43ef4dd981efe$export$34e2febe53ae29cc);
const $d0c43ef4dd981efe$export$e2ce9f12a980a822 = $d0c43ef4dd981efe$var$createBorderStyle('borderBottom', $d0c43ef4dd981efe$export$34e2febe53ae29cc);
const $d0c43ef4dd981efe$export$47658cca1a909427 = $d0c43ef4dd981efe$var$createBorderStyle('borderLeft', $d0c43ef4dd981efe$export$34e2febe53ae29cc);
const $d0c43ef4dd981efe$export$e7fb0694ba2404fc = $d0c43ef4dd981efe$var$createBorderStyle('borderColor');
const $d0c43ef4dd981efe$export$126a92c968acdb85 = $d0c43ef4dd981efe$var$createBorderStyle('borderTopColor');
const $d0c43ef4dd981efe$export$85cc51cb8fbb8c0e = $d0c43ef4dd981efe$var$createBorderStyle('borderRightColor');
const $d0c43ef4dd981efe$export$340b0327727f6d1a = $d0c43ef4dd981efe$var$createBorderStyle('borderBottomColor');
const $d0c43ef4dd981efe$export$60beef91a985b4bf = $d0c43ef4dd981efe$var$createBorderStyle('borderLeftColor');
const $d0c43ef4dd981efe$export$f9258c55612cbed7 = $d0c43ef4dd981efe$var$createBorderStyle('outline', $d0c43ef4dd981efe$export$34e2febe53ae29cc);
const $d0c43ef4dd981efe$export$621fe586efeb64b9 = $d0c43ef4dd981efe$var$createBorderStyle('outlineColor');
const $d0c43ef4dd981efe$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $1XI54.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $1XI54.getValue)(transformer, propValue)
            });
        return (0, $3IE2K.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$d0c43ef4dd981efe$export$7a57f79000377ca2.propTypes = {};
$d0c43ef4dd981efe$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $d0c43ef4dd981efe$var$borders = (0, $3aOEr.default)($d0c43ef4dd981efe$export$1edee58a52776cd9, $d0c43ef4dd981efe$export$f9a7b6bd24892946, $d0c43ef4dd981efe$export$5abca33e6be905d2, $d0c43ef4dd981efe$export$e2ce9f12a980a822, $d0c43ef4dd981efe$export$47658cca1a909427, $d0c43ef4dd981efe$export$e7fb0694ba2404fc, $d0c43ef4dd981efe$export$126a92c968acdb85, $d0c43ef4dd981efe$export$85cc51cb8fbb8c0e, $d0c43ef4dd981efe$export$340b0327727f6d1a, $d0c43ef4dd981efe$export$60beef91a985b4bf, $d0c43ef4dd981efe$export$7a57f79000377ca2, $d0c43ef4dd981efe$export$f9258c55612cbed7, $d0c43ef4dd981efe$export$621fe586efeb64b9);
var $d0c43ef4dd981efe$export$2e2bcd8739ae039 = $d0c43ef4dd981efe$var$borders;

});
parcelRegister("3aOEr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24f99889ec584551$export$2e2bcd8739ae039; });

var $eZX2M = parcelRequire("eZX2M");
function $24f99889ec584551$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $eZX2M.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $24f99889ec584551$export$2e2bcd8739ae039 = $24f99889ec584551$var$compose;

});


parcelRegister("jc55C", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $df9315fc46380fe7$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $df9315fc46380fe7$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $df9315fc46380fe7$export$8a833ffa5f5dbeda; });

var $bvu3b = parcelRequire("bvu3b");

var $3aOEr = parcelRequire("3aOEr");

var $1XI54 = parcelRequire("1XI54");

var $3IE2K = parcelRequire("3IE2K");

const $df9315fc46380fe7$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $1XI54.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $1XI54.getValue)(transformer, propValue)
            });
        return (0, $3IE2K.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$df9315fc46380fe7$export$5df9adcb0db95e1e.propTypes = {};
$df9315fc46380fe7$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $df9315fc46380fe7$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $1XI54.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $1XI54.getValue)(transformer, propValue)
            });
        return (0, $3IE2K.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$df9315fc46380fe7$export$ec60d70ff941a580.propTypes = {};
$df9315fc46380fe7$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $df9315fc46380fe7$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $1XI54.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $1XI54.getValue)(transformer, propValue)
            });
        return (0, $3IE2K.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$df9315fc46380fe7$export$8a833ffa5f5dbeda.propTypes = {};
$df9315fc46380fe7$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $df9315fc46380fe7$export$baf44164ca3a34e8 = (0, $bvu3b.default)({
    prop: 'gridColumn'
});
const $df9315fc46380fe7$export$8f7213a1cd01e832 = (0, $bvu3b.default)({
    prop: 'gridRow'
});
const $df9315fc46380fe7$export$b0e0abbc49ba668 = (0, $bvu3b.default)({
    prop: 'gridAutoFlow'
});
const $df9315fc46380fe7$export$bcd8b929d4b4142 = (0, $bvu3b.default)({
    prop: 'gridAutoColumns'
});
const $df9315fc46380fe7$export$e5039a674e14c828 = (0, $bvu3b.default)({
    prop: 'gridAutoRows'
});
const $df9315fc46380fe7$export$42bd9088661ffb03 = (0, $bvu3b.default)({
    prop: 'gridTemplateColumns'
});
const $df9315fc46380fe7$export$920682ae05b999bc = (0, $bvu3b.default)({
    prop: 'gridTemplateRows'
});
const $df9315fc46380fe7$export$1b88fbdd482fd33a = (0, $bvu3b.default)({
    prop: 'gridTemplateAreas'
});
const $df9315fc46380fe7$export$bdb486e40d52d26f = (0, $bvu3b.default)({
    prop: 'gridArea'
});
const $df9315fc46380fe7$var$grid = (0, $3aOEr.default)($df9315fc46380fe7$export$5df9adcb0db95e1e, $df9315fc46380fe7$export$ec60d70ff941a580, $df9315fc46380fe7$export$8a833ffa5f5dbeda, $df9315fc46380fe7$export$baf44164ca3a34e8, $df9315fc46380fe7$export$8f7213a1cd01e832, $df9315fc46380fe7$export$b0e0abbc49ba668, $df9315fc46380fe7$export$bcd8b929d4b4142, $df9315fc46380fe7$export$e5039a674e14c828, $df9315fc46380fe7$export$42bd9088661ffb03, $df9315fc46380fe7$export$920682ae05b999bc, $df9315fc46380fe7$export$1b88fbdd482fd33a, $df9315fc46380fe7$export$bdb486e40d52d26f);
var $df9315fc46380fe7$export$2e2bcd8739ae039 = $df9315fc46380fe7$var$grid;

});

parcelRegister("g7Ryi", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $bbd6d72376c4e88c$export$dbaffd4420ea0ac6; });

var $bvu3b = parcelRequire("bvu3b");

var $3aOEr = parcelRequire("3aOEr");
function $bbd6d72376c4e88c$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $bbd6d72376c4e88c$export$35e9368ef982300f = (0, $bvu3b.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $bbd6d72376c4e88c$export$dbaffd4420ea0ac6
});
const $bbd6d72376c4e88c$export$2506f56c10355b33 = (0, $bvu3b.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $bbd6d72376c4e88c$export$dbaffd4420ea0ac6
});
const $bbd6d72376c4e88c$export$8c5a050822fd698c = (0, $bvu3b.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $bbd6d72376c4e88c$export$dbaffd4420ea0ac6
});
const $bbd6d72376c4e88c$var$palette = (0, $3aOEr.default)($bbd6d72376c4e88c$export$35e9368ef982300f, $bbd6d72376c4e88c$export$2506f56c10355b33, $bbd6d72376c4e88c$export$8c5a050822fd698c);
var $bbd6d72376c4e88c$export$2e2bcd8739ae039 = $bbd6d72376c4e88c$var$palette;

});

parcelRegister("but9P", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $85d91d23a41405d5$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $85d91d23a41405d5$export$488fda99655ff65a; });

var $bvu3b = parcelRequire("bvu3b");

var $3aOEr = parcelRequire("3aOEr");

var $3IE2K = parcelRequire("3IE2K");
function $85d91d23a41405d5$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $85d91d23a41405d5$export$7e3df82ee760448c = (0, $bvu3b.default)({
    prop: 'width',
    transform: $85d91d23a41405d5$export$8afece71750ec241
});
const $85d91d23a41405d5$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $3IE2K.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $85d91d23a41405d5$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $3IE2K.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$85d91d23a41405d5$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $85d91d23a41405d5$export$ee148fbbe8357dd2 = (0, $bvu3b.default)({
    prop: 'minWidth',
    transform: $85d91d23a41405d5$export$8afece71750ec241
});
const $85d91d23a41405d5$export$ac607276a8fe9f0a = (0, $bvu3b.default)({
    prop: 'height',
    transform: $85d91d23a41405d5$export$8afece71750ec241
});
const $85d91d23a41405d5$export$dc0d8bd0b94f8570 = (0, $bvu3b.default)({
    prop: 'maxHeight',
    transform: $85d91d23a41405d5$export$8afece71750ec241
});
const $85d91d23a41405d5$export$a43cf604e12f3b17 = (0, $bvu3b.default)({
    prop: 'minHeight',
    transform: $85d91d23a41405d5$export$8afece71750ec241
});
const $85d91d23a41405d5$export$ffed9f14fb65e276 = (0, $bvu3b.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $85d91d23a41405d5$export$8afece71750ec241
});
const $85d91d23a41405d5$export$905076ed6620e671 = (0, $bvu3b.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $85d91d23a41405d5$export$8afece71750ec241
});
const $85d91d23a41405d5$export$6ccc93f785106a58 = (0, $bvu3b.default)({
    prop: 'boxSizing'
});
const $85d91d23a41405d5$var$sizing = (0, $3aOEr.default)($85d91d23a41405d5$export$7e3df82ee760448c, $85d91d23a41405d5$export$488fda99655ff65a, $85d91d23a41405d5$export$ee148fbbe8357dd2, $85d91d23a41405d5$export$ac607276a8fe9f0a, $85d91d23a41405d5$export$dc0d8bd0b94f8570, $85d91d23a41405d5$export$a43cf604e12f3b17, $85d91d23a41405d5$export$6ccc93f785106a58);
var $85d91d23a41405d5$export$2e2bcd8739ae039 = $85d91d23a41405d5$var$sizing;

});



parcelRegister("fYbRg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba05a863c738d045$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $ba05a863c738d045$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("i2D4h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("lwaO7")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("lwaO7")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("ggmG3")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("aJI7D")).default; });

var $lwaO7 = parcelRequire("lwaO7");

var $ggmG3 = parcelRequire("ggmG3");

var $aJI7D = parcelRequire("aJI7D");

});
parcelRegister("ggmG3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd6fbb327bbbb5b7$export$2e2bcd8739ae039; });

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $FRCsQ = parcelRequire("FRCsQ");

var $aJI7D = parcelRequire("aJI7D");
const $bd6fbb327bbbb5b7$var$_excluded = [
    "sx"
];
const $bd6fbb327bbbb5b7$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $aJI7D.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $bd6fbb327bbbb5b7$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $7qXFD.default)(props, $bd6fbb327bbbb5b7$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $bd6fbb327bbbb5b7$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $FRCsQ.isPlainObject)(result)) return systemProps;
        return (0, $1CWiu.default)({}, systemProps, result);
    };
    else finalSx = (0, $1CWiu.default)({}, systemProps, inSx);
    return (0, $1CWiu.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("jdqqT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dfd3bc311c71af76$var$assertString;
function $dfd3bc311c71af76$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dfd3bc311c71af76$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dfd3bc311c71af76$var$_typeof(o);
}
function $dfd3bc311c71af76$var$assertString(input) {
    var isString = typeof input === 'string' || input instanceof String;
    if (!isString) {
        var invalidType = $dfd3bc311c71af76$var$_typeof(input);
        if (input === null) invalidType = 'null';
        else if (invalidType === 'object') invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
    }
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("56jd8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3b6c6a26268c88c1$var$isByteLength;

var $3b6c6a26268c88c1$var$_assertString = $3b6c6a26268c88c1$var$_interopRequireDefault((parcelRequire("jdqqT")));
function $3b6c6a26268c88c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3b6c6a26268c88c1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3b6c6a26268c88c1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3b6c6a26268c88c1$var$_typeof(o);
}
/* eslint-disable prefer-rest-params */ function $3b6c6a26268c88c1$var$isByteLength(str, options) {
    (0, $3b6c6a26268c88c1$var$_assertString.default)(str);
    var min;
    var max;
    if ($3b6c6a26268c88c1$var$_typeof(options) === 'object') {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isByteLength(str, min [, max])
        min = arguments[1];
        max = arguments[2];
    }
    var len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ewfpe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a9200126d2f9ba40$var$isFQDN;

var $a9200126d2f9ba40$var$_assertString = $a9200126d2f9ba40$var$_interopRequireDefault((parcelRequire("jdqqT")));

var $a9200126d2f9ba40$var$_merge = $a9200126d2f9ba40$var$_interopRequireDefault((parcelRequire("IiP6O")));
function $a9200126d2f9ba40$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a9200126d2f9ba40$var$default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_numeric_tld: false,
    allow_wildcard: false,
    ignore_max_length: false
};
function $a9200126d2f9ba40$var$isFQDN(str, options) {
    (0, $a9200126d2f9ba40$var$_assertString.default)(str);
    options = (0, $a9200126d2f9ba40$var$_merge.default)(options, $a9200126d2f9ba40$var$default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */ if (options.allow_trailing_dot && str[str.length - 1] === '.') str = str.substring(0, str.length - 1);
    /* Remove the optional wildcard before checking validity */ if (options.allow_wildcard === true && str.indexOf('*.') === 0) str = str.substring(2);
    var parts = str.split('.');
    var tld = parts[parts.length - 1];
    if (options.require_tld) {
        // disallow fqdns without tld
        if (parts.length < 2) return false;
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) return false;
        // disallow spaces
        if (/\s/.test(tld)) return false;
    }
    // reject numeric TLDs
    if (!options.allow_numeric_tld && /^\d+$/.test(tld)) return false;
    return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) return false;
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) return false;
        // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) return false;
        // disallow parts starting or ending with hyphen
        if (/^-|-$/.test(part)) return false;
        if (!options.allow_underscores && /_/.test(part)) return false;
        return true;
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("IiP6O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0852b61934258dfd$var$merge;
function $0852b61934258dfd$var$merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;
    for(var key in defaults)if (typeof obj[key] === 'undefined') obj[key] = defaults[key];
    return obj;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("fKCMb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7793b01023a5c38$var$isIP;

var $b7793b01023a5c38$var$_assertString = $b7793b01023a5c38$var$_interopRequireDefault((parcelRequire("jdqqT")));
function $b7793b01023a5c38$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */ var $b7793b01023a5c38$var$IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
var $b7793b01023a5c38$var$IPv4AddressFormat = "(".concat($b7793b01023a5c38$var$IPv4SegmentFormat, "[.]){3}").concat($b7793b01023a5c38$var$IPv4SegmentFormat);
var $b7793b01023a5c38$var$IPv4AddressRegExp = new RegExp("^".concat($b7793b01023a5c38$var$IPv4AddressFormat, "$"));
var $b7793b01023a5c38$var$IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})';
var $b7793b01023a5c38$var$IPv6AddressRegExp = new RegExp('^(' + "(?:".concat($b7793b01023a5c38$var$IPv6SegmentFormat, ":){7}(?:").concat($b7793b01023a5c38$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($b7793b01023a5c38$var$IPv6SegmentFormat, ":){6}(?:").concat($b7793b01023a5c38$var$IPv4AddressFormat, "|:").concat($b7793b01023a5c38$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($b7793b01023a5c38$var$IPv6SegmentFormat, ":){5}(?::").concat($b7793b01023a5c38$var$IPv4AddressFormat, "|(:").concat($b7793b01023a5c38$var$IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat($b7793b01023a5c38$var$IPv6SegmentFormat, ":){4}(?:(:").concat($b7793b01023a5c38$var$IPv6SegmentFormat, "){0,1}:").concat($b7793b01023a5c38$var$IPv4AddressFormat, "|(:").concat($b7793b01023a5c38$var$IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat($b7793b01023a5c38$var$IPv6SegmentFormat, ":){3}(?:(:").concat($b7793b01023a5c38$var$IPv6SegmentFormat, "){0,2}:").concat($b7793b01023a5c38$var$IPv4AddressFormat, "|(:").concat($b7793b01023a5c38$var$IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat($b7793b01023a5c38$var$IPv6SegmentFormat, ":){2}(?:(:").concat($b7793b01023a5c38$var$IPv6SegmentFormat, "){0,3}:").concat($b7793b01023a5c38$var$IPv4AddressFormat, "|(:").concat($b7793b01023a5c38$var$IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat($b7793b01023a5c38$var$IPv6SegmentFormat, ":){1}(?:(:").concat($b7793b01023a5c38$var$IPv6SegmentFormat, "){0,4}:").concat($b7793b01023a5c38$var$IPv4AddressFormat, "|(:").concat($b7793b01023a5c38$var$IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat($b7793b01023a5c38$var$IPv6SegmentFormat, "){0,5}:").concat($b7793b01023a5c38$var$IPv4AddressFormat, "|(?::").concat($b7793b01023a5c38$var$IPv6SegmentFormat, "){1,7}|:))") + ')(%[0-9a-zA-Z-.:]{1,})?$');
function $b7793b01023a5c38$var$isIP(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (0, $b7793b01023a5c38$var$_assertString.default)(str);
    version = String(version);
    if (!version) return $b7793b01023a5c38$var$isIP(str, 4) || $b7793b01023a5c38$var$isIP(str, 6);
    if (version === '4') return $b7793b01023a5c38$var$IPv4AddressRegExp.test(str);
    if (version === '6') return $b7793b01023a5c38$var$IPv6AddressRegExp.test(str);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("bCY9l", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $gVCC4.default;
    }
});

var $gVCC4 = parcelRequire("gVCC4");

});
parcelRegister("gVCC4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c52febfaca72e55a$export$2e2bcd8739ae039; });

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");

var $7z273 = parcelRequire("7z273");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
function $c52febfaca72e55a$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $7z273.default), (0, $1CWiu.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $7z273.default).muiName;
    return /*#__PURE__*/ $i5lfL.memo(/*#__PURE__*/ $i5lfL.forwardRef(Component));
}

});
parcelRegister("7z273", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $581d70d234192b5d$export$2e2bcd8739ae039; });

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $VEXgj = parcelRequire("VEXgj");

var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $32uPo = parcelRequire("32uPo");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $581d70d234192b5d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $581d70d234192b5d$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $VEXgj.default)(color)}`,
            `fontSize${(0, $VEXgj.default)(fontSize)}`
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $32uPo.getSvgIconUtilityClass), classes);
};
const $581d70d234192b5d$var$SvgIconRoot = (0, $j7y1Z.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $VEXgj.default)(ownerState.color)}`],
            styles[`fontSize${(0, $VEXgj.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $581d70d234192b5d$var$SvgIcon = /*#__PURE__*/ $i5lfL.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $7qXFD.default)(props, $581d70d234192b5d$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $i5lfL.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $581d70d234192b5d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($581d70d234192b5d$var$SvgIconRoot, (0, $1CWiu.default)({
        as: component,
        className: (0, $kRbLW.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $bHJbJ.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$581d70d234192b5d$var$SvgIcon.muiName = 'SvgIcon';
var $581d70d234192b5d$export$2e2bcd8739ae039 = $581d70d234192b5d$var$SvgIcon;

});
parcelRegister("kRbLW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $373ef9126dad043c$export$2e2bcd8739ae039; });
function $373ef9126dad043c$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $373ef9126dad043c$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $373ef9126dad043c$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $373ef9126dad043c$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $373ef9126dad043c$export$2e2bcd8739ae039 = $373ef9126dad043c$export$4f5d2d50c9deca37;

});

parcelRegister("2ktY3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b24b1f51ad5b4b2$export$2e2bcd8739ae039; });
function $1b24b1f51ad5b4b2$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("VEXgj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ad517c3b098b9fa$export$2e2bcd8739ae039; });

var $8xMlt = parcelRequire("8xMlt");
var $0ad517c3b098b9fa$export$2e2bcd8739ae039 = (0, $8xMlt.default);

});

parcelRegister("kp44S", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $eda94e313ea4756a$export$2440da353cedad43; });

var $1CWiu = parcelRequire("1CWiu");
parcelRequire("i5lfL");


var $lHkUP = parcelRequire("lHkUP");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
function $eda94e313ea4756a$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $lHkUP.default), (0, $1CWiu.default)({}, props));
}
var $eda94e313ea4756a$export$2e2bcd8739ae039 = $eda94e313ea4756a$var$DefaultPropsProvider;
function $eda94e313ea4756a$export$2440da353cedad43(params) {
    return (0, $lHkUP.useDefaultProps)(params);
}

});
parcelRegister("lHkUP", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $fcbdd686823881d9$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $fcbdd686823881d9$export$2e2bcd8739ae039; });

var $i5lfL = parcelRequire("i5lfL");


var $dR0I7 = parcelRequire("dR0I7");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $fcbdd686823881d9$var$PropsContext = /*#__PURE__*/ $i5lfL.createContext(undefined);
function $fcbdd686823881d9$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($fcbdd686823881d9$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $fcbdd686823881d9$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $dR0I7.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $dR0I7.default)(config, props);
    return props;
}
function $fcbdd686823881d9$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $i5lfL.useContext($fcbdd686823881d9$var$PropsContext);
    return $fcbdd686823881d9$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $fcbdd686823881d9$export$2e2bcd8739ae039 = $fcbdd686823881d9$var$DefaultPropsProvider;

});
parcelRegister("dR0I7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a160c6b4d76bcadb$export$2e2bcd8739ae039; });

var $1CWiu = parcelRequire("1CWiu");
function $a160c6b4d76bcadb$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $1CWiu.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $1CWiu.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $1CWiu.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $a160c6b4d76bcadb$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("j7y1Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0397a151189b43d0$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("1FZvT")).default; });

var $ghx5I = parcelRequire("ghx5I");

var $4M4EV = parcelRequire("4M4EV");

var $5xV56 = parcelRequire("5xV56");

var $1FZvT = parcelRequire("1FZvT");

var $iYTvc = parcelRequire("iYTvc");
'use client';
const $0397a151189b43d0$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($ghx5I)))({
    themeId: (0, $5xV56.default),
    defaultTheme: $4M4EV.default,
    rootShouldForwardProp: $1FZvT.default
});
var $0397a151189b43d0$export$2e2bcd8739ae039 = $0397a151189b43d0$var$styled;

});
parcelRegister("ghx5I", function(module, exports) {
"use strict";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bda7e7162ee5b37d$var$createStyled;
module.exports.shouldForwardProp = $bda7e7162ee5b37d$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $bda7e7162ee5b37d$var$_extends2 = $gpjDn((parcelRequire("1qXDD")));

var $bda7e7162ee5b37d$var$_objectWithoutPropertiesLoose2 = $gpjDn((parcelRequire("5YThu")));

var $bda7e7162ee5b37d$var$_styledEngine = $bda7e7162ee5b37d$var$_interopRequireWildcard((parcelRequire("cmrx1")));

var $FRCsQ = parcelRequire("FRCsQ");

var $bda7e7162ee5b37d$var$_capitalize = $gpjDn((parcelRequire("lSLgv")));

var $bda7e7162ee5b37d$var$_getDisplayName = $gpjDn((parcelRequire("3Z6GM")));

var $bda7e7162ee5b37d$var$_createTheme = $gpjDn((parcelRequire("gNIU8")));

var $bda7e7162ee5b37d$var$_styleFunctionSx = $gpjDn((parcelRequire("i2D4h")));
const $bda7e7162ee5b37d$var$_excluded = [
    "ownerState"
], $bda7e7162ee5b37d$var$_excluded2 = [
    "variants"
], $bda7e7162ee5b37d$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $bda7e7162ee5b37d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bda7e7162ee5b37d$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $bda7e7162ee5b37d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $bda7e7162ee5b37d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $bda7e7162ee5b37d$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $bda7e7162ee5b37d$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $bda7e7162ee5b37d$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $bda7e7162ee5b37d$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $bda7e7162ee5b37d$var$_createTheme.default)();
const $bda7e7162ee5b37d$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $bda7e7162ee5b37d$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $bda7e7162ee5b37d$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $bda7e7162ee5b37d$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $bda7e7162ee5b37d$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $bda7e7162ee5b37d$var$_objectWithoutPropertiesLoose2.default)(_ref, $bda7e7162ee5b37d$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $bda7e7162ee5b37d$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$bda7e7162ee5b37d$var$processStyleArg(resolvedStyle, (0, $bda7e7162ee5b37d$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $bda7e7162ee5b37d$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $bda7e7162ee5b37d$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $bda7e7162ee5b37d$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $bda7e7162ee5b37d$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $bda7e7162ee5b37d$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $bda7e7162ee5b37d$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $bda7e7162ee5b37d$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $bda7e7162ee5b37d$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $bda7e7162ee5b37d$var$_styleFunctionSx.default)((0, $bda7e7162ee5b37d$var$_extends2.default)({}, props, {
            theme: $bda7e7162ee5b37d$var$resolveTheme((0, $bda7e7162ee5b37d$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $bda7e7162ee5b37d$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $bda7e7162ee5b37d$var$defaultOverridesResolver($bda7e7162ee5b37d$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $bda7e7162ee5b37d$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $bda7e7162ee5b37d$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $bda7e7162ee5b37d$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($bda7e7162ee5b37d$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $bda7e7162ee5b37d$var$_styledEngine.default)(tag, (0, $bda7e7162ee5b37d$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $FRCsQ.isPlainObject)(stylesArg)) return (props)=>$bda7e7162ee5b37d$var$processStyleArg(stylesArg, (0, $bda7e7162ee5b37d$var$_extends2.default)({}, props, {
                    theme: $bda7e7162ee5b37d$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $bda7e7162ee5b37d$var$resolveTheme((0, $bda7e7162ee5b37d$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $bda7e7162ee5b37d$var$processStyleArg(slotStyle, (0, $bda7e7162ee5b37d$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $bda7e7162ee5b37d$var$resolveTheme((0, $bda7e7162ee5b37d$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $bda7e7162ee5b37d$var$processStyleArg({
                    variants: themeVariants
                }, (0, $bda7e7162ee5b37d$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("gpjDn", function(module, exports) {
function $bf1e361261fd0220$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $bf1e361261fd0220$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4M4EV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $379f4253851a3f93$export$2e2bcd8739ae039; });

var $87pNb = parcelRequire("87pNb");
'use client';
const $379f4253851a3f93$var$defaultTheme = (0, $87pNb.default)();
var $379f4253851a3f93$export$2e2bcd8739ae039 = $379f4253851a3f93$var$defaultTheme;

});
parcelRegister("87pNb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e92fbff50f3974f$export$2e2bcd8739ae039; });

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $1SAXO = parcelRequire("1SAXO");

var $FRCsQ = parcelRequire("FRCsQ");

var $lwaO7 = parcelRequire("lwaO7");
var $aJI7D = parcelRequire("aJI7D");

var $8mN0u = parcelRequire("8mN0u");


var $dYGK7 = parcelRequire("dYGK7");

var $7GowI = parcelRequire("7GowI");

var $6pyeX = parcelRequire("6pyeX");

var $ihBRf = parcelRequire("ihBRf");

var $jwO09 = parcelRequire("jwO09");

var $fnlzq = parcelRequire("fnlzq");
const $5e92fbff50f3974f$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $5e92fbff50f3974f$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $7qXFD.default)(options, $5e92fbff50f3974f$var$_excluded);
    if (options.vars) throw new Error((0, $1SAXO.default)(18));
    const palette = (0, $7GowI.default)(paletteInput);
    const systemTheme = (0, $8mN0u.default)(options);
    let muiTheme = (0, $FRCsQ.default)(systemTheme, {
        mixins: (0, $dYGK7.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $ihBRf.default).slice(),
        typography: (0, $6pyeX.default)(palette, typographyInput),
        transitions: (0, $jwO09.default)(transitionsInput),
        zIndex: (0, $1CWiu.default)({}, (0, $fnlzq.default))
    });
    muiTheme = (0, $FRCsQ.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $FRCsQ.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $1CWiu.default)({}, (0, $aJI7D.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $lwaO7.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $5e92fbff50f3974f$var$warnedOnce = false;
function $5e92fbff50f3974f$export$c469355549431d9b(...args) {
    return $5e92fbff50f3974f$var$createTheme(...args);
}
var $5e92fbff50f3974f$export$2e2bcd8739ae039 = $5e92fbff50f3974f$var$createTheme;

});
parcelRegister("dYGK7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2d208cce495a854$export$2e2bcd8739ae039; });

var $1CWiu = parcelRequire("1CWiu");
function $a2d208cce495a854$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $1CWiu.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("7GowI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $597f7b1eaf7365f0$export$2e2bcd8739ae039; });

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $1SAXO = parcelRequire("1SAXO");

var $FRCsQ = parcelRequire("FRCsQ");

var $8AHNG = parcelRequire("8AHNG");

var $izfJZ = parcelRequire("izfJZ");

var $11GjT = parcelRequire("11GjT");

var $kLQWf = parcelRequire("kLQWf");

var $9P0AD = parcelRequire("9P0AD");

var $4PyhP = parcelRequire("4PyhP");

var $12pXh = parcelRequire("12pXh");

var $3vXXu = parcelRequire("3vXXu");

var $i42vc = parcelRequire("i42vc");
const $597f7b1eaf7365f0$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $597f7b1eaf7365f0$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $izfJZ.default).white,
        default: (0, $izfJZ.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $597f7b1eaf7365f0$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $izfJZ.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $izfJZ.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $597f7b1eaf7365f0$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $8AHNG.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $8AHNG.darken)(intent.main, tonalOffsetDark);
    }
}
function $597f7b1eaf7365f0$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $12pXh.default)[200],
        light: (0, $12pXh.default)[50],
        dark: (0, $12pXh.default)[400]
    };
    return {
        main: (0, $12pXh.default)[700],
        light: (0, $12pXh.default)[400],
        dark: (0, $12pXh.default)[800]
    };
}
function $597f7b1eaf7365f0$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $kLQWf.default)[200],
        light: (0, $kLQWf.default)[50],
        dark: (0, $kLQWf.default)[400]
    };
    return {
        main: (0, $kLQWf.default)[500],
        light: (0, $kLQWf.default)[300],
        dark: (0, $kLQWf.default)[700]
    };
}
function $597f7b1eaf7365f0$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9P0AD.default)[500],
        light: (0, $9P0AD.default)[300],
        dark: (0, $9P0AD.default)[700]
    };
    return {
        main: (0, $9P0AD.default)[700],
        light: (0, $9P0AD.default)[400],
        dark: (0, $9P0AD.default)[800]
    };
}
function $597f7b1eaf7365f0$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $3vXXu.default)[400],
        light: (0, $3vXXu.default)[300],
        dark: (0, $3vXXu.default)[700]
    };
    return {
        main: (0, $3vXXu.default)[700],
        light: (0, $3vXXu.default)[500],
        dark: (0, $3vXXu.default)[900]
    };
}
function $597f7b1eaf7365f0$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $i42vc.default)[400],
        light: (0, $i42vc.default)[300],
        dark: (0, $i42vc.default)[700]
    };
    return {
        main: (0, $i42vc.default)[800],
        light: (0, $i42vc.default)[500],
        dark: (0, $i42vc.default)[900]
    };
}
function $597f7b1eaf7365f0$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $4PyhP.default)[400],
        light: (0, $4PyhP.default)[300],
        dark: (0, $4PyhP.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $4PyhP.default)[500],
        dark: (0, $4PyhP.default)[900]
    };
}
function $597f7b1eaf7365f0$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $7qXFD.default)(palette, $597f7b1eaf7365f0$var$_excluded);
    const primary = palette.primary || $597f7b1eaf7365f0$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $597f7b1eaf7365f0$var$getDefaultSecondary(mode);
    const error = palette.error || $597f7b1eaf7365f0$var$getDefaultError(mode);
    const info = palette.info || $597f7b1eaf7365f0$var$getDefaultInfo(mode);
    const success = palette.success || $597f7b1eaf7365f0$var$getDefaultSuccess(mode);
    const warning = palette.warning || $597f7b1eaf7365f0$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $8AHNG.getContrastRatio)(background, $597f7b1eaf7365f0$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $597f7b1eaf7365f0$export$55ce6f3a06c59543.text.primary : $597f7b1eaf7365f0$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $1CWiu.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $1SAXO.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $1SAXO.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $597f7b1eaf7365f0$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $597f7b1eaf7365f0$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $597f7b1eaf7365f0$export$55ce6f3a06c59543,
        light: $597f7b1eaf7365f0$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $FRCsQ.default)((0, $1CWiu.default)({
        // A collection of common colors.
        common: (0, $1CWiu.default)({}, (0, $izfJZ.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $11GjT.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("8AHNG", function(module, exports) {
"use strict";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $6413a95e19ebc65a$var$alpha;
module.exports.blend = $6413a95e19ebc65a$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $6413a95e19ebc65a$var$darken;
module.exports.decomposeColor = $6413a95e19ebc65a$var$decomposeColor;
module.exports.emphasize = $6413a95e19ebc65a$var$emphasize;
module.exports.getContrastRatio = $6413a95e19ebc65a$var$getContrastRatio;
module.exports.getLuminance = $6413a95e19ebc65a$var$getLuminance;
module.exports.hexToRgb = $6413a95e19ebc65a$var$hexToRgb;
module.exports.hslToRgb = $6413a95e19ebc65a$var$hslToRgb;
module.exports.lighten = $6413a95e19ebc65a$var$lighten;
module.exports.private_safeAlpha = $6413a95e19ebc65a$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $6413a95e19ebc65a$var$private_safeDarken;
module.exports.private_safeEmphasize = $6413a95e19ebc65a$var$private_safeEmphasize;
module.exports.private_safeLighten = $6413a95e19ebc65a$var$private_safeLighten;
module.exports.recomposeColor = $6413a95e19ebc65a$var$recomposeColor;
module.exports.rgbToHex = $6413a95e19ebc65a$var$rgbToHex;

var $6413a95e19ebc65a$var$_formatMuiErrorMessage2 = $gpjDn((parcelRequire("1x7bA")));

var $6413a95e19ebc65a$var$_clamp = $gpjDn((parcelRequire("37b6E")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $6413a95e19ebc65a$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $6413a95e19ebc65a$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $6413a95e19ebc65a$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $6413a95e19ebc65a$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $6413a95e19ebc65a$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $6413a95e19ebc65a$var$decomposeColor($6413a95e19ebc65a$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $6413a95e19ebc65a$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $6413a95e19ebc65a$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $6413a95e19ebc65a$var$colorChannel = (color)=>{
    const decomposedColor = $6413a95e19ebc65a$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $6413a95e19ebc65a$var$colorChannel;
const $6413a95e19ebc65a$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $6413a95e19ebc65a$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $6413a95e19ebc65a$var$private_safeColorChannel;
function $6413a95e19ebc65a$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $6413a95e19ebc65a$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $6413a95e19ebc65a$var$decomposeColor(color);
    return `#${values.map((n, i)=>$6413a95e19ebc65a$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $6413a95e19ebc65a$var$hslToRgb(color) {
    color = $6413a95e19ebc65a$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $6413a95e19ebc65a$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $6413a95e19ebc65a$var$getLuminance(color) {
    color = $6413a95e19ebc65a$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $6413a95e19ebc65a$var$decomposeColor($6413a95e19ebc65a$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $6413a95e19ebc65a$var$getContrastRatio(foreground, background) {
    const lumA = $6413a95e19ebc65a$var$getLuminance(foreground);
    const lumB = $6413a95e19ebc65a$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6413a95e19ebc65a$var$alpha(color, value) {
    color = $6413a95e19ebc65a$var$decomposeColor(color);
    value = $6413a95e19ebc65a$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $6413a95e19ebc65a$var$recomposeColor(color);
}
function $6413a95e19ebc65a$var$private_safeAlpha(color, value, warning) {
    try {
        return $6413a95e19ebc65a$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6413a95e19ebc65a$var$darken(color, coefficient) {
    color = $6413a95e19ebc65a$var$decomposeColor(color);
    coefficient = $6413a95e19ebc65a$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $6413a95e19ebc65a$var$recomposeColor(color);
}
function $6413a95e19ebc65a$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $6413a95e19ebc65a$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6413a95e19ebc65a$var$lighten(color, coefficient) {
    color = $6413a95e19ebc65a$var$decomposeColor(color);
    coefficient = $6413a95e19ebc65a$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $6413a95e19ebc65a$var$recomposeColor(color);
}
function $6413a95e19ebc65a$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $6413a95e19ebc65a$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6413a95e19ebc65a$var$emphasize(color, coefficient = 0.15) {
    return $6413a95e19ebc65a$var$getLuminance(color) > 0.5 ? $6413a95e19ebc65a$var$darken(color, coefficient) : $6413a95e19ebc65a$var$lighten(color, coefficient);
}
function $6413a95e19ebc65a$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $6413a95e19ebc65a$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $6413a95e19ebc65a$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $6413a95e19ebc65a$var$decomposeColor(background);
    const overlayColor = $6413a95e19ebc65a$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $6413a95e19ebc65a$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("izfJZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d847b4a5a60c880f$export$2e2bcd8739ae039; });
const $d847b4a5a60c880f$var$common = {
    black: '#000',
    white: '#fff'
};
var $d847b4a5a60c880f$export$2e2bcd8739ae039 = $d847b4a5a60c880f$var$common;

});

parcelRegister("11GjT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bf6b641fe531d83$export$2e2bcd8739ae039; });
const $0bf6b641fe531d83$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $0bf6b641fe531d83$export$2e2bcd8739ae039 = $0bf6b641fe531d83$var$grey;

});

parcelRegister("kLQWf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1f142e5f9dded86$export$2e2bcd8739ae039; });
const $f1f142e5f9dded86$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $f1f142e5f9dded86$export$2e2bcd8739ae039 = $f1f142e5f9dded86$var$purple;

});

parcelRegister("9P0AD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7269559f54b5b313$export$2e2bcd8739ae039; });
const $7269559f54b5b313$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $7269559f54b5b313$export$2e2bcd8739ae039 = $7269559f54b5b313$var$red;

});

parcelRegister("4PyhP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3846856d18f93996$export$2e2bcd8739ae039; });
const $3846856d18f93996$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $3846856d18f93996$export$2e2bcd8739ae039 = $3846856d18f93996$var$orange;

});

parcelRegister("12pXh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c1a1c809ab0dc31$export$2e2bcd8739ae039; });
const $0c1a1c809ab0dc31$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $0c1a1c809ab0dc31$export$2e2bcd8739ae039 = $0c1a1c809ab0dc31$var$blue;

});

parcelRegister("3vXXu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28f2c6d9cc394606$export$2e2bcd8739ae039; });
const $28f2c6d9cc394606$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $28f2c6d9cc394606$export$2e2bcd8739ae039 = $28f2c6d9cc394606$var$lightBlue;

});

parcelRegister("i42vc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d26a8a9f62af614e$export$2e2bcd8739ae039; });
const $d26a8a9f62af614e$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $d26a8a9f62af614e$export$2e2bcd8739ae039 = $d26a8a9f62af614e$var$green;

});


parcelRegister("6pyeX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4aafa3481627068d$export$2e2bcd8739ae039; });

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $FRCsQ = parcelRequire("FRCsQ");
const $4aafa3481627068d$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $4aafa3481627068d$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $4aafa3481627068d$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $4aafa3481627068d$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4aafa3481627068d$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $4aafa3481627068d$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $7qXFD.default)(_ref, $4aafa3481627068d$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $1CWiu.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $4aafa3481627068d$var$defaultFontFamily ? {
            letterSpacing: `${$4aafa3481627068d$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $4aafa3481627068d$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $4aafa3481627068d$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $FRCsQ.default)((0, $1CWiu.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("ihBRf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4f72e4ac59596d2$export$2e2bcd8739ae039; });
const $d4f72e4ac59596d2$var$shadowKeyUmbraOpacity = 0.2;
const $d4f72e4ac59596d2$var$shadowKeyPenumbraOpacity = 0.14;
const $d4f72e4ac59596d2$var$shadowAmbientShadowOpacity = 0.12;
function $d4f72e4ac59596d2$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$d4f72e4ac59596d2$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$d4f72e4ac59596d2$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$d4f72e4ac59596d2$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $d4f72e4ac59596d2$var$shadows = [
    'none',
    $d4f72e4ac59596d2$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $d4f72e4ac59596d2$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $d4f72e4ac59596d2$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $d4f72e4ac59596d2$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $d4f72e4ac59596d2$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $d4f72e4ac59596d2$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $d4f72e4ac59596d2$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $d4f72e4ac59596d2$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $d4f72e4ac59596d2$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $d4f72e4ac59596d2$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $d4f72e4ac59596d2$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $d4f72e4ac59596d2$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $d4f72e4ac59596d2$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $d4f72e4ac59596d2$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $d4f72e4ac59596d2$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $d4f72e4ac59596d2$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $d4f72e4ac59596d2$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $d4f72e4ac59596d2$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $d4f72e4ac59596d2$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $d4f72e4ac59596d2$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $d4f72e4ac59596d2$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $d4f72e4ac59596d2$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $d4f72e4ac59596d2$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $d4f72e4ac59596d2$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $d4f72e4ac59596d2$export$2e2bcd8739ae039 = $d4f72e4ac59596d2$var$shadows;

});

parcelRegister("jwO09", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $e377cab895c302c7$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $e377cab895c302c7$export$2e2bcd8739ae039; });

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");
const $e377cab895c302c7$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $e377cab895c302c7$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $e377cab895c302c7$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $e377cab895c302c7$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $e377cab895c302c7$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $e377cab895c302c7$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $1CWiu.default)({}, $e377cab895c302c7$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $1CWiu.default)({}, $e377cab895c302c7$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $7qXFD.default)(options, $e377cab895c302c7$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $e377cab895c302c7$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $e377cab895c302c7$var$formatMs(delay)}`).join(',');
    };
    return (0, $1CWiu.default)({
        getAutoHeightDuration: $e377cab895c302c7$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("fnlzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b319bc6df4799b66$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $b319bc6df4799b66$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $b319bc6df4799b66$export$2e2bcd8739ae039 = $b319bc6df4799b66$var$zIndex;

});



parcelRegister("5xV56", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $409c4ffcd7593da0$export$2e2bcd8739ae039; });
var $409c4ffcd7593da0$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("1FZvT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13895615e3bdea87$export$2e2bcd8739ae039; });

var $iYTvc = parcelRequire("iYTvc");
const $13895615e3bdea87$var$rootShouldForwardProp = (prop)=>(0, $iYTvc.default)(prop) && prop !== 'classes';
var $13895615e3bdea87$export$2e2bcd8739ae039 = $13895615e3bdea87$var$rootShouldForwardProp;

});
parcelRegister("iYTvc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd18e23127002fdd$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $dd18e23127002fdd$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $dd18e23127002fdd$export$2e2bcd8739ae039 = $dd18e23127002fdd$var$slotShouldForwardProp;

});



parcelRegister("32uPo", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $236978c98723a33d$export$c7c50641356bdfa5; });

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $236978c98723a33d$export$c7c50641356bdfa5(slot) {
    return (0, $6bbZp.default)('MuiSvgIcon', slot);
}
const $236978c98723a33d$var$svgIconClasses = (0, $47i1c.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $236978c98723a33d$export$2e2bcd8739ae039 = $236978c98723a33d$var$svgIconClasses;

});
parcelRegister("47i1c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ff5caeb27218374$export$2e2bcd8739ae039; });

var $6bbZp = parcelRequire("6bbZp");
function $2ff5caeb27218374$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $6bbZp.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("6bbZp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47fd12068ee73dfa$export$2e2bcd8739ae039; });

var $dQFgv = parcelRequire("dQFgv");
const $47fd12068ee73dfa$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $47fd12068ee73dfa$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $47fd12068ee73dfa$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $dQFgv.default).generate(componentName)}-${slot}`;
}
function $47fd12068ee73dfa$export$34c0130b1f3e8ae3(slot) {
    return $47fd12068ee73dfa$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("dQFgv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a150241af656ffb6$export$2e2bcd8739ae039; });
const $a150241af656ffb6$var$defaultGenerator = (componentName)=>componentName;
const $a150241af656ffb6$var$createClassNameGenerator = ()=>{
    let generate = $a150241af656ffb6$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $a150241af656ffb6$var$defaultGenerator;
        }
    };
};
const $a150241af656ffb6$var$ClassNameGenerator = $a150241af656ffb6$var$createClassNameGenerator();
var $a150241af656ffb6$export$2e2bcd8739ae039 = $a150241af656ffb6$var$ClassNameGenerator;

});







parcelRegister("cUemu", function(module, exports) {
var global = typeof self !== 'undefined' ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: 'URLSearchParams' in self1,
            iterable: 'Symbol' in self1 && 'iterator' in Symbol,
            blob: 'FileReader' in self1 && 'Blob' in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in self1,
            arrayBuffer: 'ArrayBuffer' in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError('Invalid character in header field name');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = '';
                else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'POST',
            'PUT'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = 'statusText' in options ? options.statusText : 'OK';
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ''
            });
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException('Aborted', 'AbortError'));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr && support.blob) xhr.responseType = 'blob';
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("jHH2F", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $e5836bb80115ee7e$export$306c0aa65ff9ec16; }, function (v) { return $e5836bb80115ee7e$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e5836bb80115ee7e$export$306c0aa65ff9ec16;
'use strict';

var $i5lfL = parcelRequire("i5lfL");
function $e5836bb80115ee7e$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e5836bb80115ee7e$var$k = "function" === typeof Object.is ? Object.is : $e5836bb80115ee7e$var$h, $e5836bb80115ee7e$var$l = $i5lfL.useState, $e5836bb80115ee7e$var$m = $i5lfL.useEffect, $e5836bb80115ee7e$var$n = $i5lfL.useLayoutEffect, $e5836bb80115ee7e$var$p = $i5lfL.useDebugValue;
function $e5836bb80115ee7e$var$q(a, b) {
    var d = b(), f = $e5836bb80115ee7e$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $e5836bb80115ee7e$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $e5836bb80115ee7e$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $e5836bb80115ee7e$var$m(function() {
        $e5836bb80115ee7e$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $e5836bb80115ee7e$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $e5836bb80115ee7e$var$p(d);
    return d;
}
function $e5836bb80115ee7e$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$e5836bb80115ee7e$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $e5836bb80115ee7e$var$t(a, b) {
    return b();
}
var $e5836bb80115ee7e$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $e5836bb80115ee7e$var$t : $e5836bb80115ee7e$var$q;
$e5836bb80115ee7e$export$306c0aa65ff9ec16 = void 0 !== $i5lfL.useSyncExternalStore ? $i5lfL.useSyncExternalStore : $e5836bb80115ee7e$var$u;

});

parcelRegister("3HLSL", function(module, exports) {

$parcel$export(module.exports, "defaultRangeExtractor", function () { return defaultRangeExtractor; });
$parcel$export(module.exports, "observeElementRect", function () { return observeElementRect; });
$parcel$export(module.exports, "observeWindowRect", function () { return observeWindowRect; });
$parcel$export(module.exports, "observeElementOffset", function () { return observeElementOffset; });
$parcel$export(module.exports, "observeWindowOffset", function () { return observeWindowOffset; });
$parcel$export(module.exports, "windowScroll", function () { return windowScroll; });
$parcel$export(module.exports, "elementScroll", function () { return elementScroll; });
$parcel$export(module.exports, "Virtualizer", function () { return Virtualizer; });
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6y5yF = parcelRequire("6y5yF");

var $dcdyI = parcelRequire("dcdyI");
//
//
var defaultKeyExtractor = function defaultKeyExtractor(index) {
    return index;
};
var defaultRangeExtractor = function defaultRangeExtractor(range) {
    var start = Math.max(range.startIndex - range.overscan, 0);
    var end = Math.min(range.endIndex + range.overscan, range.count - 1);
    var arr = [];
    for(var _i = start; _i <= end; _i++)arr.push(_i);
    return arr;
};
var observeElementRect = function observeElementRect(instance, cb) {
    var element = instance.scrollElement;
    if (!element) return;
    var handler = function handler(rect) {
        var width = rect.width, height = rect.height;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    var observer = new ResizeObserver(function(entries) {
        var entry = entries[0];
        if (entry != null && entry.borderBoxSize) {
            var box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: 'border-box'
    });
    return function() {
        observer.unobserve(element);
    };
};
var observeWindowRect = function observeWindowRect(instance, cb) {
    var element = instance.scrollElement;
    if (!element) return;
    var handler = function handler() {
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener('resize', handler, {
        passive: true
    });
    return function() {
        element.removeEventListener('resize', handler);
    };
};
var observeElementOffset = function observeElementOffset(instance, cb) {
    var element = instance.scrollElement;
    if (!element) return;
    var handler = function handler() {
        cb(element[instance.options.horizontal ? 'scrollLeft' : 'scrollTop']);
    };
    handler();
    element.addEventListener('scroll', handler, {
        passive: true
    });
    return function() {
        element.removeEventListener('scroll', handler);
    };
};
var observeWindowOffset = function observeWindowOffset(instance, cb) {
    var element = instance.scrollElement;
    if (!element) return;
    var handler = function handler() {
        cb(element[instance.options.horizontal ? 'scrollX' : 'scrollY']);
    };
    handler();
    element.addEventListener('scroll', handler, {
        passive: true
    });
    return function() {
        element.removeEventListener('scroll', handler);
    };
};
var measureElement = function measureElement(element, entry, instance) {
    if (entry != null && entry.borderBoxSize) {
        var box = entry.borderBoxSize[0];
        if (box) {
            var size = Math.round(box[instance.options.horizontal ? 'inlineSize' : 'blockSize']);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? 'width' : 'height']);
};
var windowScroll = function windowScroll(offset, _ref, instance) {
    var _instance$scrollEleme, _instance$scrollEleme2;
    var _ref$adjustments = _ref.adjustments, adjustments = _ref$adjustments === void 0 ? 0 : _ref$adjustments, behavior = _ref.behavior;
    var toOffset = offset + adjustments;
    (_instance$scrollEleme = instance.scrollElement) == null || _instance$scrollEleme.scrollTo == null || _instance$scrollEleme.scrollTo((_instance$scrollEleme2 = {}, _instance$scrollEleme2[instance.options.horizontal ? 'left' : 'top'] = toOffset, _instance$scrollEleme2.behavior = behavior, _instance$scrollEleme2));
};
var elementScroll = function elementScroll(offset, _ref2, instance) {
    var _instance$scrollEleme3, _instance$scrollEleme4;
    var _ref2$adjustments = _ref2.adjustments, adjustments = _ref2$adjustments === void 0 ? 0 : _ref2$adjustments, behavior = _ref2.behavior;
    var toOffset = offset + adjustments;
    (_instance$scrollEleme3 = instance.scrollElement) == null || _instance$scrollEleme3.scrollTo == null || _instance$scrollEleme3.scrollTo((_instance$scrollEleme4 = {}, _instance$scrollEleme4[instance.options.horizontal ? 'left' : 'top'] = toOffset, _instance$scrollEleme4.behavior = behavior, _instance$scrollEleme4));
};
var Virtualizer = function Virtualizer(_opts) {
    var _this = this;
    this.unsubs = [];
    this.scrollElement = null;
    this.isScrolling = false;
    this.isScrollingTimeoutId = null;
    this.scrollToIndexTimeoutId = null;
    this.measurementsCache = [];
    this.itemSizeCache = new Map();
    this.pendingMeasuredCacheIndexes = [];
    this.scrollDirection = null;
    this.scrollAdjustments = 0;
    this.measureElementCache = new Map();
    this.observer = function() {
        var _ro = null;
        var get = function get() {
            if (_ro) return _ro;
            else if (typeof ResizeObserver !== 'undefined') return _ro = new ResizeObserver(function(entries) {
                entries.forEach(function(entry) {
                    _this._measureElement(entry.target, entry);
                });
            });
            else return null;
        };
        return {
            disconnect: function disconnect() {
                var _get;
                return (_get = get()) == null ? void 0 : _get.disconnect();
            },
            observe: function observe(target) {
                var _get2;
                return (_get2 = get()) == null ? void 0 : _get2.observe(target, {
                    box: 'border-box'
                });
            },
            unobserve: function unobserve(target) {
                var _get3;
                return (_get3 = get()) == null ? void 0 : _get3.unobserve(target);
            }
        };
    }();
    this.range = {
        startIndex: 0,
        endIndex: 0
    };
    this.setOptions = function(opts) {
        Object.entries(opts).forEach(function(_ref3) {
            var key = _ref3[0], value = _ref3[1];
            if (typeof value === 'undefined') delete opts[key];
        });
        _this.options = (0, $6y5yF.extends)({
            debug: false,
            initialOffset: 0,
            overscan: 1,
            paddingStart: 0,
            paddingEnd: 0,
            scrollPaddingStart: 0,
            scrollPaddingEnd: 0,
            horizontal: false,
            getItemKey: defaultKeyExtractor,
            rangeExtractor: defaultRangeExtractor,
            onChange: function onChange() {},
            measureElement: measureElement,
            initialRect: {
                width: 0,
                height: 0
            },
            scrollMargin: 0,
            scrollingDelay: 150,
            indexAttribute: 'data-index',
            initialMeasurementsCache: [],
            lanes: 1
        }, opts);
    };
    this.notify = function() {
        _this.options.onChange == null || _this.options.onChange(_this);
    };
    this.cleanup = function() {
        _this.unsubs.filter(Boolean).forEach(function(d) {
            return d();
        });
        _this.unsubs = [];
        _this.scrollElement = null;
    };
    this._didMount = function() {
        _this.measureElementCache.forEach(_this.observer.observe);
        return function() {
            _this.observer.disconnect();
            _this.cleanup();
        };
    };
    this._willUpdate = function() {
        var scrollElement = _this.options.getScrollElement();
        if (_this.scrollElement !== scrollElement) {
            _this.cleanup();
            _this.scrollElement = scrollElement;
            _this._scrollToOffset(_this.scrollOffset, {
                adjustments: undefined,
                behavior: undefined
            });
            _this.unsubs.push(_this.options.observeElementRect(_this, function(rect) {
                var prev = _this.scrollRect;
                _this.scrollRect = rect;
                if (_this.options.horizontal ? rect.width !== prev.width : rect.height !== prev.height) _this.maybeNotify();
            }));
            _this.unsubs.push(_this.options.observeElementOffset(_this, function(offset) {
                _this.scrollAdjustments = 0;
                if (_this.scrollOffset === offset) return;
                if (_this.isScrollingTimeoutId !== null) {
                    clearTimeout(_this.isScrollingTimeoutId);
                    _this.isScrollingTimeoutId = null;
                }
                _this.isScrolling = true;
                _this.scrollDirection = _this.scrollOffset < offset ? 'forward' : 'backward';
                _this.scrollOffset = offset;
                _this.maybeNotify();
                _this.isScrollingTimeoutId = setTimeout(function() {
                    _this.isScrollingTimeoutId = null;
                    _this.isScrolling = false;
                    _this.scrollDirection = null;
                    _this.maybeNotify();
                }, _this.options.scrollingDelay);
            }));
        }
    };
    this.getSize = function() {
        return _this.scrollRect[_this.options.horizontal ? 'width' : 'height'];
    };
    this.memoOptions = (0, $dcdyI.memo)(function() {
        return [
            _this.options.count,
            _this.options.paddingStart,
            _this.options.scrollMargin,
            _this.options.getItemKey
        ];
    }, function(count, paddingStart, scrollMargin, getItemKey) {
        _this.pendingMeasuredCacheIndexes = [];
        return {
            count: count,
            paddingStart: paddingStart,
            scrollMargin: scrollMargin,
            getItemKey: getItemKey
        };
    }, {
        key: false
    });
    this.getFurthestMeasurement = function(measurements, index) {
        var furthestMeasurementsFound = new Map();
        var furthestMeasurements = new Map();
        for(var m = index - 1; m >= 0; m--){
            var measurement = measurements[m];
            if (furthestMeasurementsFound.has(measurement.lane)) continue;
            var previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
            if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
            else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
            if (furthestMeasurementsFound.size === _this.options.lanes) break;
        }
        return furthestMeasurements.size === _this.options.lanes ? Array.from(furthestMeasurements.values()).sort(function(a, b) {
            return a.end - b.end;
        })[0] : undefined;
    };
    this.getMeasurements = (0, $dcdyI.memo)(function() {
        return [
            _this.memoOptions(),
            _this.itemSizeCache
        ];
    }, function(_ref4, itemSizeCache) {
        var count = _ref4.count, paddingStart = _ref4.paddingStart, scrollMargin = _ref4.scrollMargin, getItemKey = _ref4.getItemKey;
        var min = _this.pendingMeasuredCacheIndexes.length > 0 ? Math.min.apply(Math, _this.pendingMeasuredCacheIndexes) : 0;
        _this.pendingMeasuredCacheIndexes = [];
        var measurements = _this.measurementsCache.slice(0, min);
        for(var _i2 = min; _i2 < count; _i2++){
            var key = getItemKey(_i2);
            var furthestMeasurement = _this.options.lanes === 1 ? measurements[_i2 - 1] : _this.getFurthestMeasurement(measurements, _i2);
            var start = furthestMeasurement ? furthestMeasurement.end : paddingStart + scrollMargin;
            var measuredSize = itemSizeCache.get(key);
            var size = typeof measuredSize === 'number' ? measuredSize : _this.options.estimateSize(_i2);
            var end = start + size;
            var lane = furthestMeasurement ? furthestMeasurement.lane : _i2 % _this.options.lanes;
            measurements[_i2] = {
                index: _i2,
                start: start,
                size: size,
                end: end,
                key: key,
                lane: lane
            };
        }
        _this.measurementsCache = measurements;
        return measurements;
    }, {
        key: false,
        debug: function debug() {
            return _this.options.debug;
        }
    });
    this.calculateRange = (0, $dcdyI.memo)(function() {
        return [
            _this.getMeasurements(),
            _this.getSize(),
            _this.scrollOffset
        ];
    }, function(measurements, outerSize, scrollOffset) {
        return _this.range = calculateRange({
            measurements: measurements,
            outerSize: outerSize,
            scrollOffset: scrollOffset
        });
    }, {
        key: false,
        debug: function debug() {
            return _this.options.debug;
        }
    });
    this.maybeNotify = (0, $dcdyI.memo)(function() {
        var range = _this.calculateRange();
        return [
            range.startIndex,
            range.endIndex,
            _this.isScrolling
        ];
    }, function() {
        _this.notify();
    }, {
        key: false,
        debug: function debug() {
            return _this.options.debug;
        },
        initialDeps: [
            this.range.startIndex,
            this.range.endIndex,
            this.isScrolling
        ]
    });
    this.getIndexes = (0, $dcdyI.memo)(function() {
        return [
            _this.options.rangeExtractor,
            _this.calculateRange(),
            _this.options.overscan,
            _this.options.count
        ];
    }, function(rangeExtractor, range, overscan, count) {
        return rangeExtractor((0, $6y5yF.extends)({}, range, {
            overscan: overscan,
            count: count
        }));
    }, {
        key: false,
        debug: function debug() {
            return _this.options.debug;
        }
    });
    this.indexFromElement = function(node) {
        var attributeName = _this.options.indexAttribute;
        var indexStr = node.getAttribute(attributeName);
        if (!indexStr) {
            console.warn("Missing attribute name '" + attributeName + "={index}' on measured element.");
            return -1;
        }
        return parseInt(indexStr, 10);
    };
    this._measureElement = function(node, entry) {
        var _this$itemSizeCache$g;
        var index = _this.indexFromElement(node);
        var item = _this.measurementsCache[index];
        if (!item) return;
        var prevNode = _this.measureElementCache.get(item.key);
        if (!node.isConnected) {
            _this.observer.unobserve(node);
            if (node === prevNode) _this.measureElementCache["delete"](item.key);
            return;
        }
        if (prevNode !== node) {
            if (prevNode) _this.observer.unobserve(prevNode);
            _this.observer.observe(node);
            _this.measureElementCache.set(item.key, node);
        }
        var measuredItemSize = _this.options.measureElement(node, entry, _this);
        var itemSize = (_this$itemSizeCache$g = _this.itemSizeCache.get(item.key)) != null ? _this$itemSizeCache$g : item.size;
        var delta = measuredItemSize - itemSize;
        if (delta !== 0) {
            if (item.start < _this.scrollOffset) _this._scrollToOffset(_this.scrollOffset, {
                adjustments: _this.scrollAdjustments += delta,
                behavior: undefined
            });
            _this.pendingMeasuredCacheIndexes.push(index);
            _this.itemSizeCache = new Map(_this.itemSizeCache.set(item.key, measuredItemSize));
            _this.notify();
        }
    };
    this.measureElement = function(node) {
        if (!node) return;
        _this._measureElement(node, undefined);
    };
    this.getVirtualItems = (0, $dcdyI.memo)(function() {
        return [
            _this.getIndexes(),
            _this.getMeasurements()
        ];
    }, function(indexes, measurements) {
        var virtualItems = [];
        for(var k = 0, len = indexes.length; k < len; k++){
            var _i3 = indexes[k];
            var measurement = measurements[_i3];
            virtualItems.push(measurement);
        }
        return virtualItems;
    }, {
        key: false,
        debug: function debug() {
            return _this.options.debug;
        }
    });
    this.getVirtualItemForOffset = function(offset) {
        var measurements = _this.getMeasurements();
        return (0, $dcdyI.notUndefined)(measurements[findNearestBinarySearch(0, measurements.length - 1, function(index) {
            return (0, $dcdyI.notUndefined)(measurements[index]).start;
        }, offset)]);
    };
    this.getOffsetForAlignment = function(toOffset, align) {
        var size = _this.getSize();
        if (align === 'auto') {
            if (toOffset <= _this.scrollOffset) align = 'start';
            else if (toOffset >= _this.scrollOffset + size) align = 'end';
            else align = 'start';
        }
        if (align === 'start') toOffset;
        else if (align === 'end') toOffset = toOffset - size;
        else if (align === 'center') toOffset = toOffset - size / 2;
        var scrollSizeProp = _this.options.horizontal ? 'scrollWidth' : 'scrollHeight';
        var scrollSize = _this.scrollElement ? 'document' in _this.scrollElement ? _this.scrollElement.document.documentElement[scrollSizeProp] : _this.scrollElement[scrollSizeProp] : 0;
        var maxOffset = scrollSize - _this.getSize();
        return Math.max(Math.min(maxOffset, toOffset), 0);
    };
    this.getOffsetForIndex = function(index, align) {
        if (align === void 0) align = 'auto';
        index = Math.max(0, Math.min(index, _this.options.count - 1));
        var measurement = (0, $dcdyI.notUndefined)(_this.getMeasurements()[index]);
        if (align === 'auto') {
            if (measurement.end >= _this.scrollOffset + _this.getSize() - _this.options.scrollPaddingEnd) align = 'end';
            else if (measurement.start <= _this.scrollOffset + _this.options.scrollPaddingStart) align = 'start';
            else return [
                _this.scrollOffset,
                align
            ];
        }
        var toOffset = align === 'end' ? measurement.end + _this.options.scrollPaddingEnd : measurement.start - _this.options.scrollPaddingStart;
        return [
            _this.getOffsetForAlignment(toOffset, align),
            align
        ];
    };
    this.isDynamicMode = function() {
        return _this.measureElementCache.size > 0;
    };
    this.cancelScrollToIndex = function() {
        if (_this.scrollToIndexTimeoutId !== null) {
            clearTimeout(_this.scrollToIndexTimeoutId);
            _this.scrollToIndexTimeoutId = null;
        }
    };
    this.scrollToOffset = function(toOffset, _temp) {
        var _ref5 = _temp === void 0 ? {} : _temp, _ref5$align = _ref5.align, align = _ref5$align === void 0 ? 'start' : _ref5$align, behavior = _ref5.behavior;
        _this.cancelScrollToIndex();
        if (behavior === 'smooth' && _this.isDynamicMode()) console.warn('The `smooth` scroll behavior is not fully supported with dynamic size.');
        _this._scrollToOffset(_this.getOffsetForAlignment(toOffset, align), {
            adjustments: undefined,
            behavior: behavior
        });
    };
    this.scrollToIndex = function(index, _temp2) {
        var _ref6 = _temp2 === void 0 ? {} : _temp2, _ref6$align = _ref6.align, initialAlign = _ref6$align === void 0 ? 'auto' : _ref6$align, behavior = _ref6.behavior;
        index = Math.max(0, Math.min(index, _this.options.count - 1));
        _this.cancelScrollToIndex();
        if (behavior === 'smooth' && _this.isDynamicMode()) console.warn('The `smooth` scroll behavior is not fully supported with dynamic size.');
        var _this$getOffsetForInd = _this.getOffsetForIndex(index, initialAlign), toOffset = _this$getOffsetForInd[0], align = _this$getOffsetForInd[1];
        _this._scrollToOffset(toOffset, {
            adjustments: undefined,
            behavior: behavior
        });
        if (behavior !== 'smooth' && _this.isDynamicMode()) _this.scrollToIndexTimeoutId = setTimeout(function() {
            _this.scrollToIndexTimeoutId = null;
            var elementInDOM = _this.measureElementCache.has(_this.options.getItemKey(index));
            if (elementInDOM) {
                var _this$getOffsetForInd2 = _this.getOffsetForIndex(index, align), _toOffset = _this$getOffsetForInd2[0];
                if (!(0, $dcdyI.approxEqual)(_toOffset, _this.scrollOffset)) _this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            } else _this.scrollToIndex(index, {
                align: align,
                behavior: behavior
            });
        });
    };
    this.scrollBy = function(delta, _temp3) {
        var _ref7 = _temp3 === void 0 ? {} : _temp3, behavior = _ref7.behavior;
        _this.cancelScrollToIndex();
        if (behavior === 'smooth' && _this.isDynamicMode()) console.warn('The `smooth` scroll behavior is not fully supported with dynamic size.');
        _this._scrollToOffset(_this.scrollOffset + delta, {
            adjustments: undefined,
            behavior: behavior
        });
    };
    this.getTotalSize = function() {
        var _this$getMeasurements;
        return (((_this$getMeasurements = _this.getMeasurements()[_this.options.count - 1]) == null ? void 0 : _this$getMeasurements.end) || _this.options.paddingStart) - _this.options.scrollMargin + _this.options.paddingEnd;
    };
    this._scrollToOffset = function(offset, _ref8) {
        var adjustments = _ref8.adjustments, behavior = _ref8.behavior;
        _this.options.scrollToFn(offset, {
            behavior: behavior,
            adjustments: adjustments
        }, _this);
    };
    this.measure = function() {
        _this.itemSizeCache = new Map();
        _this.notify();
    };
    this.setOptions(_opts);
    this.scrollRect = this.options.initialRect;
    this.scrollOffset = this.options.initialOffset;
    this.measurementsCache = this.options.initialMeasurementsCache;
    this.measurementsCache.forEach(function(item) {
        _this.itemSizeCache.set(item.key, item.size);
    });
    this.maybeNotify();
};
var findNearestBinarySearch = function findNearestBinarySearch(low, high, getCurrentValue, value) {
    while(low <= high){
        var middle = (low + high) / 2 | 0;
        var currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function calculateRange(_ref9) {
    var measurements = _ref9.measurements, outerSize = _ref9.outerSize, scrollOffset = _ref9.scrollOffset;
    var count = measurements.length - 1;
    var getOffset = function getOffset(index) {
        return measurements[index].start;
    };
    var startIndex = findNearestBinarySearch(0, count, getOffset, scrollOffset);
    var endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("6y5yF", function(module, exports) {

$parcel$export(module.exports, "extends", function () { return $4c4a3ac4f2a1b354$export$e092ad3ec43b55ee; });
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $4c4a3ac4f2a1b354$export$e092ad3ec43b55ee() {
    $4c4a3ac4f2a1b354$export$e092ad3ec43b55ee = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4c4a3ac4f2a1b354$export$e092ad3ec43b55ee.apply(this, arguments);
}

});

parcelRegister("dcdyI", function(module, exports) {

$parcel$export(module.exports, "memo", function () { return $99b6e9e3ba625ebf$export$7c73462e0d25e514; });
$parcel$export(module.exports, "notUndefined", function () { return $99b6e9e3ba625ebf$export$9a1adf421b69c6a; });
$parcel$export(module.exports, "approxEqual", function () { return $99b6e9e3ba625ebf$export$8a4f1dcc58a69dbd; });
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $99b6e9e3ba625ebf$export$7c73462e0d25e514(getDeps, fn, opts) {
    var _opts$initialDeps;
    var deps = (_opts$initialDeps = opts.initialDeps) != null ? _opts$initialDeps : [];
    var result;
    return function() {
        var depTime;
        if (opts.key && opts.debug != null && opts.debug()) depTime = Date.now();
        var newDeps = getDeps();
        var depsChanged = newDeps.length !== deps.length || newDeps.some(function(dep, index) {
            return deps[index] !== dep;
        });
        if (!depsChanged) return result;
        deps = newDeps;
        var resultTime;
        if (opts.key && opts.debug != null && opts.debug()) resultTime = Date.now();
        result = fn.apply(void 0, newDeps);
        if (opts.key && opts.debug != null && opts.debug()) {
            var depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            var resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            var resultFpsPercentage = resultEndTime / 16;
            var pad = function pad(str, num) {
                str = String(str);
                while(str.length < num)str = ' ' + str;
                return str;
            };
            console.info("%c\u23F1 " + pad(resultEndTime, 5) + " /" + pad(depEndTime, 5) + " ms", "\n            font-size: .6rem;\n            font-weight: bold;\n            color: hsl(" + Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120)) + "deg 100% 31%);", opts == null ? void 0 : opts.key);
        }
        opts == null || opts.onChange == null || opts.onChange(result);
        return result;
    };
}
function $99b6e9e3ba625ebf$export$9a1adf421b69c6a(value, msg) {
    if (value === undefined) throw new Error("Unexpected undefined" + (msg ? ": " + msg : ''));
    else return value;
}
var $99b6e9e3ba625ebf$export$8a4f1dcc58a69dbd = function approxEqual(a, b) {
    return Math.abs(a - b) < 1;
};

});


parcelRegister("kx1Sf", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

});

parcelRegister("jifDs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e0bbd39a905b6f44$var$composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $e0bbd39a905b6f44$var$composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("2NceQ", function(module, exports) {
"use strict";

var $bd3f1 = parcelRequire("bd3f1");
var $2089a6a9b3d174f2$require$_interopRequireWildcard = $bd3f1.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2089a6a9b3d174f2$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2089a6a9b3d174f2$var$_generateUtilityClass.default;
    }
});

var $2089a6a9b3d174f2$var$_generateUtilityClass = $2089a6a9b3d174f2$require$_interopRequireWildcard((parcelRequire("ay6aw")));
Object.keys($2089a6a9b3d174f2$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2089a6a9b3d174f2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2089a6a9b3d174f2$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2089a6a9b3d174f2$var$_generateUtilityClass[key];
        }
    });
});

});
parcelRegister("bd3f1", function(module, exports) {

var $lCZfV = parcelRequire("lCZfV");
var $82936c3f53565e66$var$_typeof = $lCZfV.default;
function $82936c3f53565e66$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($82936c3f53565e66$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $82936c3f53565e66$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $82936c3f53565e66$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $82936c3f53565e66$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
module.exports = $82936c3f53565e66$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lCZfV", function(module, exports) {
function $fbeca9b3eb1d26d4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $fbeca9b3eb1d26d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $fbeca9b3eb1d26d4$var$_typeof(o);
}
module.exports = $fbeca9b3eb1d26d4$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("ay6aw", function(module, exports) {
"use strict";

var $kHfzc = parcelRequire("kHfzc");
var $7ae1dd557348cf44$require$_interopRequireDefault = $kHfzc.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ae1dd557348cf44$var$generateUtilityClass;
module.exports.globalStateClasses = void 0;
module.exports.isGlobalState = $7ae1dd557348cf44$var$isGlobalState;

var $7ae1dd557348cf44$var$_ClassNameGenerator = $7ae1dd557348cf44$require$_interopRequireDefault((parcelRequire("8Z3qL")));
const $7ae1dd557348cf44$var$globalStateClasses = module.exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $7ae1dd557348cf44$var$generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $7ae1dd557348cf44$var$globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${$7ae1dd557348cf44$var$_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function $7ae1dd557348cf44$var$isGlobalState(slot) {
    return $7ae1dd557348cf44$var$globalStateClasses[slot] !== undefined;
}

});
parcelRegister("kHfzc", function(module, exports) {
function $f113e60d6f03bb43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $f113e60d6f03bb43$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8Z3qL", function(module, exports) {
"use strict";

var $kHfzc = parcelRequire("kHfzc");
var $68a6ae82b3193820$require$_interopRequireDefault = $kHfzc.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68a6ae82b3193820$var$_ClassNameGenerator.default;
    }
});

var $68a6ae82b3193820$var$_ClassNameGenerator = $68a6ae82b3193820$require$_interopRequireDefault((parcelRequire("kAv1D")));

});
parcelRegister("kAv1D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $efcf3c6c36325b01$var$defaultGenerator = (componentName)=>componentName;
const $efcf3c6c36325b01$var$createClassNameGenerator = ()=>{
    let generate = $efcf3c6c36325b01$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $efcf3c6c36325b01$var$defaultGenerator;
        }
    };
};
const $efcf3c6c36325b01$var$ClassNameGenerator = $efcf3c6c36325b01$var$createClassNameGenerator();
var $efcf3c6c36325b01$var$_default = module.exports.default = $efcf3c6c36325b01$var$ClassNameGenerator;

});




parcelRegister("dep9Y", function(module, exports) {
"use strict";

var $kHfzc = parcelRequire("kHfzc");
var $9a20196428668e94$require$_interopRequireDefault = $kHfzc.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9a20196428668e94$var$generateUtilityClasses;

var $9a20196428668e94$var$_generateUtilityClass = $9a20196428668e94$require$_interopRequireDefault((parcelRequire("2NceQ")));
function $9a20196428668e94$var$generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $9a20196428668e94$var$_generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});

parcelRegister("1Zx8l", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $17353090f94d378d$var$ReactIs, $17353090f94d378d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hgY9E"))();

});

var $6d2585bcfa2310f0$exports = {};

(parcelRequire("3RvBt")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"b2YSB\",\"index.b6885eb2.js\",\"80GMJ\",\"AustGov_IA_inline_pos.80ba3614.svg\",\"kTdkn\",\"IA_GraphicDevice.8518657f.svg\",\"61v3s\",\"IA_Nani_footer.931ea74f.png\"]"));


var $bHJbJ = parcelRequire("bHJbJ");
parcelRequire("i5lfL");
var $c38f6f64706945e9$export$882461b6382ed46c;
var $c38f6f64706945e9$export$757ceba2d55c277e;
'use strict';
var $a3874087362a2bd1$exports = {};
'use strict';
function $a3874087362a2bd1$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a3874087362a2bd1$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a3874087362a2bd1$var$checkDCE();

$a3874087362a2bd1$exports = (parcelRequire("cCkFt"));


var $c38f6f64706945e9$var$i;
$c38f6f64706945e9$export$882461b6382ed46c = $a3874087362a2bd1$exports.createRoot;
$c38f6f64706945e9$export$757ceba2d55c277e = $a3874087362a2bd1$exports.hydrateRoot;



var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");
/**
 * React Router DOM v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i5lfL = parcelRequire("i5lfL");

/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $6a8d0cd0a294f147$var$_extends() {
    $6a8d0cd0a294f147$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a8d0cd0a294f147$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $6a8d0cd0a294f147$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($6a8d0cd0a294f147$export$e19cd5f9376f8cee || ($6a8d0cd0a294f147$export$e19cd5f9376f8cee = {}));
const $6a8d0cd0a294f147$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $6a8d0cd0a294f147$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $6a8d0cd0a294f147$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $6a8d0cd0a294f147$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $6a8d0cd0a294f147$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $6a8d0cd0a294f147$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $6a8d0cd0a294f147$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $6a8d0cd0a294f147$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $6a8d0cd0a294f147$export$fe53371bee54353d(to);
    }
    return $6a8d0cd0a294f147$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $6a8d0cd0a294f147$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $6a8d0cd0a294f147$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $6a8d0cd0a294f147$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $6a8d0cd0a294f147$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $6a8d0cd0a294f147$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $6a8d0cd0a294f147$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $6a8d0cd0a294f147$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $6a8d0cd0a294f147$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $6a8d0cd0a294f147$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $6a8d0cd0a294f147$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $6a8d0cd0a294f147$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $6a8d0cd0a294f147$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $6a8d0cd0a294f147$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $6a8d0cd0a294f147$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $6a8d0cd0a294f147$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $6a8d0cd0a294f147$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $6a8d0cd0a294f147$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($6a8d0cd0a294f147$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Push;
        let location = $6a8d0cd0a294f147$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $6a8d0cd0a294f147$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Replace;
        let location = $6a8d0cd0a294f147$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $6a8d0cd0a294f147$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $6a8d0cd0a294f147$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $6a8d0cd0a294f147$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($6a8d0cd0a294f147$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($6a8d0cd0a294f147$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $6a8d0cd0a294f147$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($6a8d0cd0a294f147$var$ResultType || ($6a8d0cd0a294f147$var$ResultType = {}));
const $6a8d0cd0a294f147$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $6a8d0cd0a294f147$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $6a8d0cd0a294f147$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $6a8d0cd0a294f147$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $6a8d0cd0a294f147$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($6a8d0cd0a294f147$var$isIndexRoute(route)) {
            let indexRoute = $6a8d0cd0a294f147$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $6a8d0cd0a294f147$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $6a8d0cd0a294f147$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $6a8d0cd0a294f147$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $6a8d0cd0a294f147$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $6a8d0cd0a294f147$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $6a8d0cd0a294f147$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $6a8d0cd0a294f147$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $6a8d0cd0a294f147$var$flattenRoutes(routes);
    $6a8d0cd0a294f147$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $6a8d0cd0a294f147$export$30d21fd6d7295f52(pathname);
        matches = $6a8d0cd0a294f147$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $6a8d0cd0a294f147$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $6a8d0cd0a294f147$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $6a8d0cd0a294f147$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $6a8d0cd0a294f147$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $6a8d0cd0a294f147$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $6a8d0cd0a294f147$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $6a8d0cd0a294f147$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $6a8d0cd0a294f147$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $6a8d0cd0a294f147$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $6a8d0cd0a294f147$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $6a8d0cd0a294f147$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $6a8d0cd0a294f147$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $6a8d0cd0a294f147$var$paramRe = /^:[\w-]+$/;
const $6a8d0cd0a294f147$var$dynamicSegmentValue = 3;
const $6a8d0cd0a294f147$var$indexRouteValue = 2;
const $6a8d0cd0a294f147$var$emptySegmentValue = 1;
const $6a8d0cd0a294f147$var$staticSegmentValue = 10;
const $6a8d0cd0a294f147$var$splatPenalty = -2;
const $6a8d0cd0a294f147$var$isSplat = (s)=>s === "*";
function $6a8d0cd0a294f147$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($6a8d0cd0a294f147$var$isSplat)) initialScore += $6a8d0cd0a294f147$var$splatPenalty;
    if (index) initialScore += $6a8d0cd0a294f147$var$indexRouteValue;
    return segments.filter((s)=>!$6a8d0cd0a294f147$var$isSplat(s)).reduce((score, segment)=>score + ($6a8d0cd0a294f147$var$paramRe.test(segment) ? $6a8d0cd0a294f147$var$dynamicSegmentValue : segment === "" ? $6a8d0cd0a294f147$var$emptySegmentValue : $6a8d0cd0a294f147$var$staticSegmentValue), initialScore);
}
function $6a8d0cd0a294f147$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $6a8d0cd0a294f147$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $6a8d0cd0a294f147$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $6a8d0cd0a294f147$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $6a8d0cd0a294f147$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $6a8d0cd0a294f147$export$a5c6d149b50c1d86($6a8d0cd0a294f147$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $6a8d0cd0a294f147$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $6a8d0cd0a294f147$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $6a8d0cd0a294f147$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $6a8d0cd0a294f147$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $6a8d0cd0a294f147$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $6a8d0cd0a294f147$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $6a8d0cd0a294f147$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $6a8d0cd0a294f147$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $6a8d0cd0a294f147$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $6a8d0cd0a294f147$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $6a8d0cd0a294f147$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $6a8d0cd0a294f147$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $6a8d0cd0a294f147$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $6a8d0cd0a294f147$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $6a8d0cd0a294f147$var$normalizeSearch(search),
        hash: $6a8d0cd0a294f147$var$normalizeHash(hash)
    };
}
function $6a8d0cd0a294f147$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $6a8d0cd0a294f147$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $6a8d0cd0a294f147$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $6a8d0cd0a294f147$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $6a8d0cd0a294f147$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $6a8d0cd0a294f147$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $6a8d0cd0a294f147$export$8ccf933b0513f8d0(toArg);
    else {
        to = $6a8d0cd0a294f147$var$_extends({}, toArg);
        $6a8d0cd0a294f147$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $6a8d0cd0a294f147$var$getInvalidPathError("?", "pathname", "search", to));
        $6a8d0cd0a294f147$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $6a8d0cd0a294f147$var$getInvalidPathError("#", "pathname", "hash", to));
        $6a8d0cd0a294f147$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $6a8d0cd0a294f147$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $6a8d0cd0a294f147$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $6a8d0cd0a294f147$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $6a8d0cd0a294f147$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $6a8d0cd0a294f147$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $6a8d0cd0a294f147$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $6a8d0cd0a294f147$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $6a8d0cd0a294f147$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $6a8d0cd0a294f147$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $6a8d0cd0a294f147$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $6a8d0cd0a294f147$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $6a8d0cd0a294f147$export$4051a07651545597(data, init) {
    return new $6a8d0cd0a294f147$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $6a8d0cd0a294f147$export$42a99a7a4bc0e76a extends Error {
}
class $6a8d0cd0a294f147$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $6a8d0cd0a294f147$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $6a8d0cd0a294f147$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $6a8d0cd0a294f147$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $6a8d0cd0a294f147$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $6a8d0cd0a294f147$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $6a8d0cd0a294f147$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $6a8d0cd0a294f147$var$unwrapTrackedPromise(value) {
    if (!$6a8d0cd0a294f147$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $6a8d0cd0a294f147$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $6a8d0cd0a294f147$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6a8d0cd0a294f147$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $6a8d0cd0a294f147$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6a8d0cd0a294f147$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $6a8d0cd0a294f147$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6a8d0cd0a294f147$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $6a8d0cd0a294f147$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $6a8d0cd0a294f147$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $6a8d0cd0a294f147$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $6a8d0cd0a294f147$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $6a8d0cd0a294f147$var$validMutationMethods = new Set($6a8d0cd0a294f147$var$validMutationMethodsArr);
const $6a8d0cd0a294f147$var$validRequestMethodsArr = [
    "get",
    ...$6a8d0cd0a294f147$var$validMutationMethodsArr
];
const $6a8d0cd0a294f147$var$validRequestMethods = new Set($6a8d0cd0a294f147$var$validRequestMethodsArr);
const $6a8d0cd0a294f147$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $6a8d0cd0a294f147$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $6a8d0cd0a294f147$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $6a8d0cd0a294f147$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $6a8d0cd0a294f147$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $6a8d0cd0a294f147$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $6a8d0cd0a294f147$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $6a8d0cd0a294f147$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $6a8d0cd0a294f147$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $6a8d0cd0a294f147$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $6a8d0cd0a294f147$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $6a8d0cd0a294f147$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $6a8d0cd0a294f147$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $6a8d0cd0a294f147$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $6a8d0cd0a294f147$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $6a8d0cd0a294f147$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $6a8d0cd0a294f147$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$6a8d0cd0a294f147$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$6a8d0cd0a294f147$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $6a8d0cd0a294f147$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $6a8d0cd0a294f147$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $6a8d0cd0a294f147$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $6a8d0cd0a294f147$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$6a8d0cd0a294f147$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($6a8d0cd0a294f147$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $6a8d0cd0a294f147$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $6a8d0cd0a294f147$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $6a8d0cd0a294f147$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $6a8d0cd0a294f147$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $6a8d0cd0a294f147$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($6a8d0cd0a294f147$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $6a8d0cd0a294f147$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $6a8d0cd0a294f147$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $6a8d0cd0a294f147$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $6a8d0cd0a294f147$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $6a8d0cd0a294f147$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $6a8d0cd0a294f147$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $6a8d0cd0a294f147$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $6a8d0cd0a294f147$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $6a8d0cd0a294f147$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $6a8d0cd0a294f147$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $6a8d0cd0a294f147$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $6a8d0cd0a294f147$var$findNearestBoundary(matches).route.id,
            {
                type: $6a8d0cd0a294f147$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $6a8d0cd0a294f147$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($6a8d0cd0a294f147$var$isErrorResult(result) && $6a8d0cd0a294f147$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $6a8d0cd0a294f147$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $6a8d0cd0a294f147$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $6a8d0cd0a294f147$var$_extends({
            matches: updatedMatches || matches
        }, $6a8d0cd0a294f147$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $6a8d0cd0a294f147$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $6a8d0cd0a294f147$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $6a8d0cd0a294f147$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $6a8d0cd0a294f147$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $6a8d0cd0a294f147$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $6a8d0cd0a294f147$var$ResultType.error,
            error: $6a8d0cd0a294f147$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($6a8d0cd0a294f147$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $6a8d0cd0a294f147$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($6a8d0cd0a294f147$var$isDeferredResult(result)) throw $6a8d0cd0a294f147$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($6a8d0cd0a294f147$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $6a8d0cd0a294f147$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $6a8d0cd0a294f147$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $6a8d0cd0a294f147$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($6a8d0cd0a294f147$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $6a8d0cd0a294f147$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $6a8d0cd0a294f147$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $6a8d0cd0a294f147$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $6a8d0cd0a294f147$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $6a8d0cd0a294f147$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $6a8d0cd0a294f147$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $6a8d0cd0a294f147$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $6a8d0cd0a294f147$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $6a8d0cd0a294f147$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $6a8d0cd0a294f147$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$6a8d0cd0a294f147$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $6a8d0cd0a294f147$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $6a8d0cd0a294f147$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $6a8d0cd0a294f147$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $6a8d0cd0a294f147$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $6a8d0cd0a294f147$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $6a8d0cd0a294f147$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $6a8d0cd0a294f147$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $6a8d0cd0a294f147$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6a8d0cd0a294f147$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $6a8d0cd0a294f147$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $6a8d0cd0a294f147$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $6a8d0cd0a294f147$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($6a8d0cd0a294f147$var$isRedirectResult(actionResult) || $6a8d0cd0a294f147$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $6a8d0cd0a294f147$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($6a8d0cd0a294f147$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $6a8d0cd0a294f147$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $6a8d0cd0a294f147$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($6a8d0cd0a294f147$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($6a8d0cd0a294f147$var$isDeferredResult(actionResult)) throw $6a8d0cd0a294f147$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $6a8d0cd0a294f147$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $6a8d0cd0a294f147$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $6a8d0cd0a294f147$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $6a8d0cd0a294f147$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $6a8d0cd0a294f147$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $6a8d0cd0a294f147$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $6a8d0cd0a294f147$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $6a8d0cd0a294f147$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $6a8d0cd0a294f147$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $6a8d0cd0a294f147$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $6a8d0cd0a294f147$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $6a8d0cd0a294f147$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6a8d0cd0a294f147$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $6a8d0cd0a294f147$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $6a8d0cd0a294f147$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $6a8d0cd0a294f147$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($6a8d0cd0a294f147$var$isDeferredResult(result)) result = await $6a8d0cd0a294f147$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $6a8d0cd0a294f147$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($6a8d0cd0a294f147$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $6a8d0cd0a294f147$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($6a8d0cd0a294f147$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $6a8d0cd0a294f147$export$3e9cee6b33872309(!$6a8d0cd0a294f147$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $6a8d0cd0a294f147$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $6a8d0cd0a294f147$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $6a8d0cd0a294f147$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $6a8d0cd0a294f147$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($6a8d0cd0a294f147$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $6a8d0cd0a294f147$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Replace : $6a8d0cd0a294f147$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $6a8d0cd0a294f147$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($6a8d0cd0a294f147$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $6a8d0cd0a294f147$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $6a8d0cd0a294f147$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $6a8d0cd0a294f147$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $6a8d0cd0a294f147$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $6a8d0cd0a294f147$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($6a8d0cd0a294f147$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $6a8d0cd0a294f147$var$ResultType.redirect,
                response: $6a8d0cd0a294f147$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $6a8d0cd0a294f147$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $6a8d0cd0a294f147$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $6a8d0cd0a294f147$var$ResultType.error,
                    error: $6a8d0cd0a294f147$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $6a8d0cd0a294f147$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $6a8d0cd0a294f147$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $6a8d0cd0a294f147$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $6a8d0cd0a294f147$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $6a8d0cd0a294f147$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $6a8d0cd0a294f147$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $6a8d0cd0a294f147$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $6a8d0cd0a294f147$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $6a8d0cd0a294f147$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $6a8d0cd0a294f147$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $6a8d0cd0a294f147$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $6a8d0cd0a294f147$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $6a8d0cd0a294f147$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $6a8d0cd0a294f147$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$6a8d0cd0a294f147$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $6a8d0cd0a294f147$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $6a8d0cd0a294f147$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $6a8d0cd0a294f147$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $6a8d0cd0a294f147$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $6a8d0cd0a294f147$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $6a8d0cd0a294f147$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $6a8d0cd0a294f147$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $6a8d0cd0a294f147$export$4d0306f8f6a4585b = Symbol("deferred");
function $6a8d0cd0a294f147$export$3336b097a6fbc59a(routes, opts) {
    $6a8d0cd0a294f147$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $6a8d0cd0a294f147$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $6a8d0cd0a294f147$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $6a8d0cd0a294f147$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $6a8d0cd0a294f147$var$createLocation("", $6a8d0cd0a294f147$export$fe53371bee54353d(url), null, "default");
        let matches = $6a8d0cd0a294f147$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$6a8d0cd0a294f147$var$isValidMethod(method) && method !== "HEAD") {
            let error = $6a8d0cd0a294f147$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $6a8d0cd0a294f147$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $6a8d0cd0a294f147$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $6a8d0cd0a294f147$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($6a8d0cd0a294f147$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $6a8d0cd0a294f147$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $6a8d0cd0a294f147$var$createLocation("", $6a8d0cd0a294f147$export$fe53371bee54353d(url), null, "default");
        let matches = $6a8d0cd0a294f147$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$6a8d0cd0a294f147$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $6a8d0cd0a294f147$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $6a8d0cd0a294f147$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $6a8d0cd0a294f147$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $6a8d0cd0a294f147$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $6a8d0cd0a294f147$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($6a8d0cd0a294f147$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$6a8d0cd0a294f147$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $6a8d0cd0a294f147$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($6a8d0cd0a294f147$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $6a8d0cd0a294f147$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $6a8d0cd0a294f147$var$isResponse(result) ? result : $6a8d0cd0a294f147$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($6a8d0cd0a294f147$var$isDataStrategyResult(e) && $6a8d0cd0a294f147$var$isResponse(e.result)) {
                if (e.type === $6a8d0cd0a294f147$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($6a8d0cd0a294f147$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $6a8d0cd0a294f147$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $6a8d0cd0a294f147$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $6a8d0cd0a294f147$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($6a8d0cd0a294f147$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($6a8d0cd0a294f147$var$isDeferredResult(result)) {
            let error = $6a8d0cd0a294f147$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $6a8d0cd0a294f147$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($6a8d0cd0a294f147$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($6a8d0cd0a294f147$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $6a8d0cd0a294f147$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $6a8d0cd0a294f147$var$_extends({}, context, {
                statusCode: $6a8d0cd0a294f147$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $6a8d0cd0a294f147$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $6a8d0cd0a294f147$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $6a8d0cd0a294f147$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $6a8d0cd0a294f147$var$isErrorResult(pendingActionResult[1]) ? $6a8d0cd0a294f147$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $6a8d0cd0a294f147$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $6a8d0cd0a294f147$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $6a8d0cd0a294f147$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $6a8d0cd0a294f147$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $6a8d0cd0a294f147$var$callDataStrategyImpl(dataStrategy || $6a8d0cd0a294f147$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($6a8d0cd0a294f147$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $6a8d0cd0a294f147$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($6a8d0cd0a294f147$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $6a8d0cd0a294f147$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $6a8d0cd0a294f147$export$fec11da027c70692(routes, context, error) {
    let newContext = $6a8d0cd0a294f147$var$_extends({}, context, {
        statusCode: $6a8d0cd0a294f147$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $6a8d0cd0a294f147$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $6a8d0cd0a294f147$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $6a8d0cd0a294f147$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $6a8d0cd0a294f147$export$cae722b0cc860f13(to ? to : ".", $6a8d0cd0a294f147$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $6a8d0cd0a294f147$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $6a8d0cd0a294f147$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $6a8d0cd0a294f147$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $6a8d0cd0a294f147$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $6a8d0cd0a294f147$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$6a8d0cd0a294f147$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$6a8d0cd0a294f147$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $6a8d0cd0a294f147$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $6a8d0cd0a294f147$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $6a8d0cd0a294f147$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$6a8d0cd0a294f147$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$6a8d0cd0a294f147$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $6a8d0cd0a294f147$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $6a8d0cd0a294f147$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $6a8d0cd0a294f147$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $6a8d0cd0a294f147$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $6a8d0cd0a294f147$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($6a8d0cd0a294f147$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $6a8d0cd0a294f147$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $6a8d0cd0a294f147$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $6a8d0cd0a294f147$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $6a8d0cd0a294f147$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $6a8d0cd0a294f147$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $6a8d0cd0a294f147$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $6a8d0cd0a294f147$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $6a8d0cd0a294f147$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $6a8d0cd0a294f147$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $6a8d0cd0a294f147$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($6a8d0cd0a294f147$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $6a8d0cd0a294f147$var$shouldRevalidateLoader(match, $6a8d0cd0a294f147$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $6a8d0cd0a294f147$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $6a8d0cd0a294f147$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $6a8d0cd0a294f147$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $6a8d0cd0a294f147$var$shouldRevalidateLoader(fetcherMatch, $6a8d0cd0a294f147$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $6a8d0cd0a294f147$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $6a8d0cd0a294f147$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $6a8d0cd0a294f147$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $6a8d0cd0a294f147$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $6a8d0cd0a294f147$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $6a8d0cd0a294f147$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$6a8d0cd0a294f147$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $6a8d0cd0a294f147$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $6a8d0cd0a294f147$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$6a8d0cd0a294f147$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $6a8d0cd0a294f147$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $6a8d0cd0a294f147$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $6a8d0cd0a294f147$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$6a8d0cd0a294f147$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $6a8d0cd0a294f147$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $6a8d0cd0a294f147$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $6a8d0cd0a294f147$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $6a8d0cd0a294f147$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $6a8d0cd0a294f147$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $6a8d0cd0a294f147$var$ResultType.data,
                result: undefined
            });
        };
        return $6a8d0cd0a294f147$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $6a8d0cd0a294f147$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $6a8d0cd0a294f147$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $6a8d0cd0a294f147$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $6a8d0cd0a294f147$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $6a8d0cd0a294f147$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $6a8d0cd0a294f147$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $6a8d0cd0a294f147$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($6a8d0cd0a294f147$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $6a8d0cd0a294f147$var$ResultType.error,
                error: e
            };
        }
        if (type === $6a8d0cd0a294f147$var$ResultType.error) return {
            type: $6a8d0cd0a294f147$var$ResultType.error,
            error: new $6a8d0cd0a294f147$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $6a8d0cd0a294f147$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $6a8d0cd0a294f147$var$ResultType.error) {
        if ($6a8d0cd0a294f147$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $6a8d0cd0a294f147$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $6a8d0cd0a294f147$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $6a8d0cd0a294f147$var$ResultType.error,
            error: result,
            statusCode: $6a8d0cd0a294f147$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($6a8d0cd0a294f147$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $6a8d0cd0a294f147$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($6a8d0cd0a294f147$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $6a8d0cd0a294f147$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $6a8d0cd0a294f147$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $6a8d0cd0a294f147$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $6a8d0cd0a294f147$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$6a8d0cd0a294f147$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $6a8d0cd0a294f147$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $6a8d0cd0a294f147$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($6a8d0cd0a294f147$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $6a8d0cd0a294f147$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $6a8d0cd0a294f147$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($6a8d0cd0a294f147$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $6a8d0cd0a294f147$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $6a8d0cd0a294f147$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $6a8d0cd0a294f147$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $6a8d0cd0a294f147$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $6a8d0cd0a294f147$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $6a8d0cd0a294f147$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $6a8d0cd0a294f147$export$3e9cee6b33872309(!$6a8d0cd0a294f147$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($6a8d0cd0a294f147$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $6a8d0cd0a294f147$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $6a8d0cd0a294f147$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($6a8d0cd0a294f147$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $6a8d0cd0a294f147$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $6a8d0cd0a294f147$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $6a8d0cd0a294f147$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($6a8d0cd0a294f147$var$isErrorResult(result)) {
            let boundaryMatch = $6a8d0cd0a294f147$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $6a8d0cd0a294f147$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($6a8d0cd0a294f147$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $6a8d0cd0a294f147$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($6a8d0cd0a294f147$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $6a8d0cd0a294f147$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $6a8d0cd0a294f147$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $6a8d0cd0a294f147$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $6a8d0cd0a294f147$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $6a8d0cd0a294f147$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $6a8d0cd0a294f147$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $6a8d0cd0a294f147$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $6a8d0cd0a294f147$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $6a8d0cd0a294f147$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $6a8d0cd0a294f147$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $6a8d0cd0a294f147$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($6a8d0cd0a294f147$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $6a8d0cd0a294f147$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $6a8d0cd0a294f147$export$8ccf933b0513f8d0(path) : path;
    return $6a8d0cd0a294f147$export$fe53371bee54353d($6a8d0cd0a294f147$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $6a8d0cd0a294f147$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $6a8d0cd0a294f147$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $6a8d0cd0a294f147$var$ResultType.data || result.type === $6a8d0cd0a294f147$var$ResultType.error);
}
function $6a8d0cd0a294f147$var$isRedirectDataStrategyResultResult(result) {
    return $6a8d0cd0a294f147$var$isResponse(result.result) && $6a8d0cd0a294f147$var$redirectStatusCodes.has(result.result.status);
}
function $6a8d0cd0a294f147$var$isDeferredResult(result) {
    return result.type === $6a8d0cd0a294f147$var$ResultType.deferred;
}
function $6a8d0cd0a294f147$var$isErrorResult(result) {
    return result.type === $6a8d0cd0a294f147$var$ResultType.error;
}
function $6a8d0cd0a294f147$var$isRedirectResult(result) {
    return (result && result.type) === $6a8d0cd0a294f147$var$ResultType.redirect;
}
function $6a8d0cd0a294f147$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $6a8d0cd0a294f147$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $6a8d0cd0a294f147$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $6a8d0cd0a294f147$var$isRedirectResponse(result) {
    if (!$6a8d0cd0a294f147$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $6a8d0cd0a294f147$var$isValidMethod(method) {
    return $6a8d0cd0a294f147$var$validRequestMethods.has(method.toLowerCase());
}
function $6a8d0cd0a294f147$var$isMutationMethod(method) {
    return $6a8d0cd0a294f147$var$validMutationMethods.has(method.toLowerCase());
}
async function $6a8d0cd0a294f147$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$6a8d0cd0a294f147$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($6a8d0cd0a294f147$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $6a8d0cd0a294f147$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $6a8d0cd0a294f147$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($6a8d0cd0a294f147$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $6a8d0cd0a294f147$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $6a8d0cd0a294f147$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $6a8d0cd0a294f147$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $6a8d0cd0a294f147$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $6a8d0cd0a294f147$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $6a8d0cd0a294f147$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $6a8d0cd0a294f147$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $6a8d0cd0a294f147$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $6a8d0cd0a294f147$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $6a8d0cd0a294f147$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $6a8d0cd0a294f147$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $6a8d0cd0a294f147$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $6a8d0cd0a294f147$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $6a8d0cd0a294f147$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $6a8d0cd0a294f147$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $6a8d0cd0a294f147$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $6a8d0cd0a294f147$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $6a8d0cd0a294f147$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($6a8d0cd0a294f147$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $6a8d0cd0a294f147$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($6a8d0cd0a294f147$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $6a8d0cd0a294f147$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i5lfL = parcelRequire("i5lfL");

function $63d2ce7e33220fc9$var$_extends() {
    $63d2ce7e33220fc9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63d2ce7e33220fc9$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $63d2ce7e33220fc9$export$3add0d5dce533e2e = /*#__PURE__*/ $i5lfL.createContext(null);
const $63d2ce7e33220fc9$export$145dfa71566a64dc = /*#__PURE__*/ $i5lfL.createContext(null);
const $63d2ce7e33220fc9$var$AwaitContext = /*#__PURE__*/ $i5lfL.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $63d2ce7e33220fc9$export$26749e8557646306 = /*#__PURE__*/ $i5lfL.createContext(null);
const $63d2ce7e33220fc9$export$c7914228fb69b0f5 = /*#__PURE__*/ $i5lfL.createContext(null);
const $63d2ce7e33220fc9$export$9072aa6dd1f93057 = /*#__PURE__*/ $i5lfL.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $63d2ce7e33220fc9$var$RouteErrorContext = /*#__PURE__*/ $i5lfL.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $63d2ce7e33220fc9$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$63d2ce7e33220fc9$export$9c954a9d03d32f4a() && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $i5lfL.useContext($63d2ce7e33220fc9$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $63d2ce7e33220fc9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $6a8d0cd0a294f147$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $63d2ce7e33220fc9$export$9c954a9d03d32f4a() {
    return $i5lfL.useContext($63d2ce7e33220fc9$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $63d2ce7e33220fc9$export$45d76561a5302f2b() {
    !$63d2ce7e33220fc9$export$9c954a9d03d32f4a() && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    return $i5lfL.useContext($63d2ce7e33220fc9$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $63d2ce7e33220fc9$export$1b3f31771c5d07c() {
    return $i5lfL.useContext($63d2ce7e33220fc9$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $63d2ce7e33220fc9$export$6c330e8992e8a295(pattern) {
    !$63d2ce7e33220fc9$export$9c954a9d03d32f4a() && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $63d2ce7e33220fc9$export$45d76561a5302f2b();
    return $i5lfL.useMemo(()=>(0, $6a8d0cd0a294f147$export$81336c211d5ff295)(pattern, (0, $6a8d0cd0a294f147$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $63d2ce7e33220fc9$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $63d2ce7e33220fc9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $i5lfL.useContext($63d2ce7e33220fc9$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $i5lfL.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $63d2ce7e33220fc9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $i5lfL.useContext($63d2ce7e33220fc9$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $63d2ce7e33220fc9$var$useNavigateStable() : $63d2ce7e33220fc9$var$useNavigateUnstable();
}
function $63d2ce7e33220fc9$var$useNavigateUnstable() {
    !$63d2ce7e33220fc9$export$9c954a9d03d32f4a() && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    let dataRouterContext = $i5lfL.useContext($63d2ce7e33220fc9$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $i5lfL.useContext($63d2ce7e33220fc9$export$26749e8557646306);
    let { matches: matches } = $i5lfL.useContext($63d2ce7e33220fc9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $63d2ce7e33220fc9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $6a8d0cd0a294f147$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $i5lfL.useRef(false);
    $63d2ce7e33220fc9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $i5lfL.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $6a8d0cd0a294f147$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $6a8d0cd0a294f147$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $63d2ce7e33220fc9$var$OutletContext = /*#__PURE__*/ $i5lfL.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $63d2ce7e33220fc9$export$4138103a3ae699cc() {
    return $i5lfL.useContext($63d2ce7e33220fc9$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $63d2ce7e33220fc9$export$a3be3530d8e40d0b(context) {
    let outlet = $i5lfL.useContext($63d2ce7e33220fc9$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $63d2ce7e33220fc9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $i5lfL.useContext($63d2ce7e33220fc9$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $63d2ce7e33220fc9$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $i5lfL.useContext($63d2ce7e33220fc9$export$26749e8557646306);
    let { matches: matches } = $i5lfL.useContext($63d2ce7e33220fc9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $63d2ce7e33220fc9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $6a8d0cd0a294f147$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $i5lfL.useMemo(()=>(0, $6a8d0cd0a294f147$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $63d2ce7e33220fc9$export$5d3fca4a98652595(routes, locationArg) {
    return $63d2ce7e33220fc9$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $63d2ce7e33220fc9$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$63d2ce7e33220fc9$export$9c954a9d03d32f4a() && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $i5lfL.useContext($63d2ce7e33220fc9$export$26749e8557646306);
    let { matches: parentMatches } = $i5lfL.useContext($63d2ce7e33220fc9$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $63d2ce7e33220fc9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $6a8d0cd0a294f147$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $6a8d0cd0a294f147$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $63d2ce7e33220fc9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $6a8d0cd0a294f147$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $6a8d0cd0a294f147$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $63d2ce7e33220fc9$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $6a8d0cd0a294f147$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $63d2ce7e33220fc9$var$DefaultErrorComponent() {
    let error = $63d2ce7e33220fc9$export$ed527bf60f6e05f2();
    let message = (0, $6a8d0cd0a294f147$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $i5lfL.createElement($i5lfL.Fragment, null, /*#__PURE__*/ $i5lfL.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $i5lfL.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $i5lfL.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $63d2ce7e33220fc9$var$defaultErrorElement = /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$var$DefaultErrorComponent, null);
class $63d2ce7e33220fc9$var$RenderErrorBoundary extends $i5lfL.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $63d2ce7e33220fc9$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $i5lfL.useContext($63d2ce7e33220fc9$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $63d2ce7e33220fc9$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $63d2ce7e33220fc9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $63d2ce7e33220fc9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $i5lfL.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $63d2ce7e33220fc9$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($63d2ce7e33220fc9$var$DataRouterHook || {});
var $63d2ce7e33220fc9$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($63d2ce7e33220fc9$var$DataRouterStateHook || {});
function $63d2ce7e33220fc9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $63d2ce7e33220fc9$var$useDataRouterContext(hookName) {
    let ctx = $i5lfL.useContext($63d2ce7e33220fc9$export$3add0d5dce533e2e);
    !ctx && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    return ctx;
}
function $63d2ce7e33220fc9$var$useDataRouterState(hookName) {
    let state = $i5lfL.useContext($63d2ce7e33220fc9$export$145dfa71566a64dc);
    !state && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    return state;
}
function $63d2ce7e33220fc9$var$useRouteContext(hookName) {
    let route = $i5lfL.useContext($63d2ce7e33220fc9$export$9072aa6dd1f93057);
    !route && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $63d2ce7e33220fc9$var$useCurrentRouteId(hookName) {
    let route = $63d2ce7e33220fc9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $63d2ce7e33220fc9$export$5fc8298006ad9e58() {
    return $63d2ce7e33220fc9$var$useCurrentRouteId($63d2ce7e33220fc9$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $63d2ce7e33220fc9$export$d0fd4b7106de2769() {
    let state = $63d2ce7e33220fc9$var$useDataRouterState($63d2ce7e33220fc9$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $63d2ce7e33220fc9$export$600dc272ed516c15() {
    let dataRouterContext = $63d2ce7e33220fc9$var$useDataRouterContext($63d2ce7e33220fc9$var$DataRouterHook.UseRevalidator);
    let state = $63d2ce7e33220fc9$var$useDataRouterState($63d2ce7e33220fc9$var$DataRouterStateHook.UseRevalidator);
    return $i5lfL.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $63d2ce7e33220fc9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $63d2ce7e33220fc9$var$useDataRouterState($63d2ce7e33220fc9$var$DataRouterStateHook.UseMatches);
    return $i5lfL.useMemo(()=>matches.map((m)=>(0, $6a8d0cd0a294f147$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $63d2ce7e33220fc9$export$1448a5050d252c4d() {
    let state = $63d2ce7e33220fc9$var$useDataRouterState($63d2ce7e33220fc9$var$DataRouterStateHook.UseLoaderData);
    let routeId = $63d2ce7e33220fc9$var$useCurrentRouteId($63d2ce7e33220fc9$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $63d2ce7e33220fc9$export$fd5d37484eab868d(routeId) {
    let state = $63d2ce7e33220fc9$var$useDataRouterState($63d2ce7e33220fc9$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $63d2ce7e33220fc9$export$fdc00f3f26066d5e() {
    let state = $63d2ce7e33220fc9$var$useDataRouterState($63d2ce7e33220fc9$var$DataRouterStateHook.UseActionData);
    let routeId = $63d2ce7e33220fc9$var$useCurrentRouteId($63d2ce7e33220fc9$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $63d2ce7e33220fc9$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $i5lfL.useContext($63d2ce7e33220fc9$var$RouteErrorContext);
    let state = $63d2ce7e33220fc9$var$useDataRouterState($63d2ce7e33220fc9$var$DataRouterStateHook.UseRouteError);
    let routeId = $63d2ce7e33220fc9$var$useCurrentRouteId($63d2ce7e33220fc9$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $63d2ce7e33220fc9$export$78a72ddb39bdd145() {
    let value = $i5lfL.useContext($63d2ce7e33220fc9$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $63d2ce7e33220fc9$export$17f53340677d5831() {
    let value = $i5lfL.useContext($63d2ce7e33220fc9$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $63d2ce7e33220fc9$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $63d2ce7e33220fc9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $63d2ce7e33220fc9$var$useDataRouterContext($63d2ce7e33220fc9$var$DataRouterHook.UseBlocker);
    let state = $63d2ce7e33220fc9$var$useDataRouterState($63d2ce7e33220fc9$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $i5lfL.useState("");
    let blockerFunction = $i5lfL.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $63d2ce7e33220fc9$var$_extends({}, currentLocation, {
                pathname: (0, $6a8d0cd0a294f147$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $63d2ce7e33220fc9$var$_extends({}, nextLocation, {
                pathname: (0, $6a8d0cd0a294f147$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $i5lfL.useEffect(()=>{
        let key = String(++$63d2ce7e33220fc9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $i5lfL.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $6a8d0cd0a294f147$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $63d2ce7e33220fc9$var$useNavigateStable() {
    let { router: router } = $63d2ce7e33220fc9$var$useDataRouterContext($63d2ce7e33220fc9$var$DataRouterHook.UseNavigateStable);
    let id = $63d2ce7e33220fc9$var$useCurrentRouteId($63d2ce7e33220fc9$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $i5lfL.useRef(false);
    $63d2ce7e33220fc9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $i5lfL.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $63d2ce7e33220fc9$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $63d2ce7e33220fc9$var$alreadyWarned$1 = {};
function $63d2ce7e33220fc9$var$warningOnce(key, cond, message) {
    if (!cond && !$63d2ce7e33220fc9$var$alreadyWarned$1[key]) $63d2ce7e33220fc9$var$alreadyWarned$1[key] = true;
}
const $63d2ce7e33220fc9$var$alreadyWarned = {};
function $63d2ce7e33220fc9$var$warnOnce(key, message) {
    if (!$63d2ce7e33220fc9$var$alreadyWarned[message]) {
        $63d2ce7e33220fc9$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $63d2ce7e33220fc9$var$logDeprecation = (flag, msg, link)=>$63d2ce7e33220fc9$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $63d2ce7e33220fc9$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $63d2ce7e33220fc9$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $63d2ce7e33220fc9$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $63d2ce7e33220fc9$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $63d2ce7e33220fc9$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $63d2ce7e33220fc9$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $63d2ce7e33220fc9$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $63d2ce7e33220fc9$var$START_TRANSITION = "startTransition";
const $63d2ce7e33220fc9$var$startTransitionImpl = $i5lfL[$63d2ce7e33220fc9$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $63d2ce7e33220fc9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $i5lfL.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $i5lfL.useCallback((newState)=>{
        if (v7_startTransition && $63d2ce7e33220fc9$var$startTransitionImpl) $63d2ce7e33220fc9$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $i5lfL.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $i5lfL.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $i5lfL.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $i5lfL.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $i5lfL.useEffect(()=>$63d2ce7e33220fc9$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $i5lfL.createElement($i5lfL.Fragment, null, /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $63d2ce7e33220fc9$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $63d2ce7e33220fc9$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $63d2ce7e33220fc9$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $i5lfL.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6a8d0cd0a294f147$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $i5lfL.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $i5lfL.useCallback((newState)=>{
        v7_startTransition && $63d2ce7e33220fc9$var$startTransitionImpl ? $63d2ce7e33220fc9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $i5lfL.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $i5lfL.useEffect(()=>$63d2ce7e33220fc9$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $63d2ce7e33220fc9$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$63d2ce7e33220fc9$export$9c954a9d03d32f4a() && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $i5lfL.useContext($63d2ce7e33220fc9$export$26749e8557646306);
    let { matches: matches } = $i5lfL.useContext($63d2ce7e33220fc9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $63d2ce7e33220fc9$export$45d76561a5302f2b();
    let navigate = $63d2ce7e33220fc9$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $6a8d0cd0a294f147$export$cae722b0cc860f13)(to, (0, $6a8d0cd0a294f147$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $i5lfL.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $63d2ce7e33220fc9$export$910ae8079b2c2852(props) {
    return $63d2ce7e33220fc9$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $63d2ce7e33220fc9$export$e7b0ac011bb776c6(_props) {
    (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $63d2ce7e33220fc9$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $6a8d0cd0a294f147$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$63d2ce7e33220fc9$export$9c954a9d03d32f4a() && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $i5lfL.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $63d2ce7e33220fc9$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $6a8d0cd0a294f147$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $i5lfL.useMemo(()=>{
        let trailingPathname = (0, $6a8d0cd0a294f147$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $63d2ce7e33220fc9$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $63d2ce7e33220fc9$export$5d3fca4a98652595($63d2ce7e33220fc9$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $63d2ce7e33220fc9$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$var$ResolveAwait, null, children));
}
var $63d2ce7e33220fc9$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($63d2ce7e33220fc9$var$AwaitRenderStatus || {});
const $63d2ce7e33220fc9$var$neverSettledPromise = new Promise(()=>{});
class $63d2ce7e33220fc9$var$AwaitErrorBoundary extends $i5lfL.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $63d2ce7e33220fc9$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $63d2ce7e33220fc9$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $63d2ce7e33220fc9$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $63d2ce7e33220fc9$var$AwaitRenderStatus.error : "_data" in promise ? $63d2ce7e33220fc9$var$AwaitRenderStatus.success : $63d2ce7e33220fc9$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $63d2ce7e33220fc9$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $63d2ce7e33220fc9$var$AwaitRenderStatus.error && promise._error instanceof (0, $6a8d0cd0a294f147$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $63d2ce7e33220fc9$var$neverSettledPromise;
        if (status === $63d2ce7e33220fc9$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $63d2ce7e33220fc9$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $63d2ce7e33220fc9$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $i5lfL.createElement($63d2ce7e33220fc9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $63d2ce7e33220fc9$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $63d2ce7e33220fc9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $i5lfL.createElement($i5lfL.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $63d2ce7e33220fc9$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $i5lfL.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $i5lfL.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $i5lfL.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $63d2ce7e33220fc9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $63d2ce7e33220fc9$export$e7b0ac011bb776c6) && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $63d2ce7e33220fc9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $63d2ce7e33220fc9$export$daf73786167a7f72(matches) {
    return $63d2ce7e33220fc9$var$_renderMatches(matches);
}
function $63d2ce7e33220fc9$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $i5lfL.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $i5lfL.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $i5lfL.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $63d2ce7e33220fc9$export$f30f7e456d254e83(routes, opts) {
    return (0, $6a8d0cd0a294f147$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $63d2ce7e33220fc9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $6a8d0cd0a294f147$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $63d2ce7e33220fc9$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $0def10581bd2a82b$var$_extends() {
    $0def10581bd2a82b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0def10581bd2a82b$var$_extends.apply(this, arguments);
}
function $0def10581bd2a82b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0def10581bd2a82b$var$defaultMethod = "get";
const $0def10581bd2a82b$var$defaultEncType = "application/x-www-form-urlencoded";
function $0def10581bd2a82b$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0def10581bd2a82b$var$isButtonElement(object) {
    return $0def10581bd2a82b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0def10581bd2a82b$var$isFormElement(object) {
    return $0def10581bd2a82b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0def10581bd2a82b$var$isInputElement(object) {
    return $0def10581bd2a82b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0def10581bd2a82b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0def10581bd2a82b$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0def10581bd2a82b$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0def10581bd2a82b$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0def10581bd2a82b$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0def10581bd2a82b$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0def10581bd2a82b$var$_formDataSupportsSubmitter = null;
function $0def10581bd2a82b$var$isFormDataSubmitterSupported() {
    if ($0def10581bd2a82b$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0def10581bd2a82b$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0def10581bd2a82b$var$_formDataSupportsSubmitter = true;
    }
    return $0def10581bd2a82b$var$_formDataSupportsSubmitter;
}
const $0def10581bd2a82b$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0def10581bd2a82b$var$getFormEncType(encType) {
    if (encType != null && !$0def10581bd2a82b$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0def10581bd2a82b$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0def10581bd2a82b$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $6a8d0cd0a294f147$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0def10581bd2a82b$var$defaultMethod;
        encType = $0def10581bd2a82b$var$getFormEncType(target.getAttribute("enctype")) || $0def10581bd2a82b$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0def10581bd2a82b$var$isButtonElement(target) || $0def10581bd2a82b$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $6a8d0cd0a294f147$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0def10581bd2a82b$var$defaultMethod;
        encType = $0def10581bd2a82b$var$getFormEncType(target.getAttribute("formenctype")) || $0def10581bd2a82b$var$getFormEncType(form.getAttribute("enctype")) || $0def10581bd2a82b$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0def10581bd2a82b$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0def10581bd2a82b$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0def10581bd2a82b$var$defaultMethod;
        action = null;
        encType = $0def10581bd2a82b$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0def10581bd2a82b$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $0def10581bd2a82b$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $0def10581bd2a82b$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0def10581bd2a82b$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0def10581bd2a82b$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0def10581bd2a82b$export$1f3f55432a00e06d(routes, opts) {
    return (0, $6a8d0cd0a294f147$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0def10581bd2a82b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $6a8d0cd0a294f147$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0def10581bd2a82b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $63d2ce7e33220fc9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0def10581bd2a82b$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $6a8d0cd0a294f147$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0def10581bd2a82b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $6a8d0cd0a294f147$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0def10581bd2a82b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $63d2ce7e33220fc9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0def10581bd2a82b$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0def10581bd2a82b$var$_extends({}, state, {
        errors: $0def10581bd2a82b$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0def10581bd2a82b$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $6a8d0cd0a294f147$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0def10581bd2a82b$export$7ad602f0e94e62d1 = /*#__PURE__*/ $i5lfL.createContext({
    isTransitioning: false
});
const $0def10581bd2a82b$export$148fd98d095596d4 = /*#__PURE__*/ $i5lfL.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0def10581bd2a82b$var$START_TRANSITION = "startTransition";
const $0def10581bd2a82b$var$startTransitionImpl = $i5lfL[$0def10581bd2a82b$var$START_TRANSITION];
const $0def10581bd2a82b$var$FLUSH_SYNC = "flushSync";
const $0def10581bd2a82b$var$flushSyncImpl = $a3874087362a2bd1$exports[$0def10581bd2a82b$var$FLUSH_SYNC];
const $0def10581bd2a82b$var$USE_ID = "useId";
const $0def10581bd2a82b$var$useIdImpl = $i5lfL[$0def10581bd2a82b$var$USE_ID];
function $0def10581bd2a82b$var$startTransitionSafe(cb) {
    if ($0def10581bd2a82b$var$startTransitionImpl) $0def10581bd2a82b$var$startTransitionImpl(cb);
    else cb();
}
function $0def10581bd2a82b$var$flushSyncSafe(cb) {
    if ($0def10581bd2a82b$var$flushSyncImpl) $0def10581bd2a82b$var$flushSyncImpl(cb);
    else cb();
}
class $0def10581bd2a82b$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0def10581bd2a82b$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $i5lfL.useState(router.state);
    let [pendingState, setPendingState] = $i5lfL.useState();
    let [vtContext, setVtContext] = $i5lfL.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $i5lfL.useState();
    let [transition, setTransition] = $i5lfL.useState();
    let [interruption, setInterruption] = $i5lfL.useState();
    let fetcherData = $i5lfL.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $i5lfL.useCallback((cb)=>{
        if (v7_startTransition) $0def10581bd2a82b$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $i5lfL.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0def10581bd2a82b$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0def10581bd2a82b$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0def10581bd2a82b$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0def10581bd2a82b$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0def10581bd2a82b$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $i5lfL.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $i5lfL.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0def10581bd2a82b$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $i5lfL.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $i5lfL.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $i5lfL.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $i5lfL.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $i5lfL.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $i5lfL.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $i5lfL.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $i5lfL.useEffect(()=>(0, $63d2ce7e33220fc9$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $i5lfL.createElement($i5lfL.Fragment, null, /*#__PURE__*/ $i5lfL.createElement((0, $63d2ce7e33220fc9$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $i5lfL.createElement((0, $63d2ce7e33220fc9$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $i5lfL.createElement($0def10581bd2a82b$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $i5lfL.createElement($0def10581bd2a82b$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $i5lfL.createElement((0, $63d2ce7e33220fc9$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $i5lfL.createElement($0def10581bd2a82b$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $0def10581bd2a82b$var$MemoizedDataRoutes = /*#__PURE__*/ $i5lfL.memo($0def10581bd2a82b$var$DataRoutes);
function $0def10581bd2a82b$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $63d2ce7e33220fc9$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0def10581bd2a82b$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $i5lfL.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6a8d0cd0a294f147$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $i5lfL.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $i5lfL.useCallback((newState)=>{
        v7_startTransition && $0def10581bd2a82b$var$startTransitionImpl ? $0def10581bd2a82b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $i5lfL.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $i5lfL.useEffect(()=>(0, $63d2ce7e33220fc9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $i5lfL.createElement((0, $63d2ce7e33220fc9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0def10581bd2a82b$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $i5lfL.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6a8d0cd0a294f147$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $i5lfL.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $i5lfL.useCallback((newState)=>{
        v7_startTransition && $0def10581bd2a82b$var$startTransitionImpl ? $0def10581bd2a82b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $i5lfL.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $i5lfL.useEffect(()=>(0, $63d2ce7e33220fc9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $i5lfL.createElement((0, $63d2ce7e33220fc9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0def10581bd2a82b$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $i5lfL.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $i5lfL.useCallback((newState)=>{
        v7_startTransition && $0def10581bd2a82b$var$startTransitionImpl ? $0def10581bd2a82b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $i5lfL.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $i5lfL.useEffect(()=>(0, $63d2ce7e33220fc9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $i5lfL.createElement((0, $63d2ce7e33220fc9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0def10581bd2a82b$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0def10581bd2a82b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0def10581bd2a82b$export$a6c7ac8248d6e38a = /*#__PURE__*/ $i5lfL.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $0def10581bd2a82b$var$_objectWithoutPropertiesLoose(_ref7, $0def10581bd2a82b$var$_excluded);
    let { basename: basename } = $i5lfL.useContext((0, $63d2ce7e33220fc9$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0def10581bd2a82b$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0def10581bd2a82b$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $6a8d0cd0a294f147$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $63d2ce7e33220fc9$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $0def10581bd2a82b$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $i5lfL.createElement("a", $0def10581bd2a82b$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0def10581bd2a82b$export$b0d92dbee9b5b60d = /*#__PURE__*/ $i5lfL.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $0def10581bd2a82b$var$_objectWithoutPropertiesLoose(_ref8, $0def10581bd2a82b$var$_excluded2);
    let path = (0, $63d2ce7e33220fc9$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $63d2ce7e33220fc9$export$45d76561a5302f2b)();
    let routerState = $i5lfL.useContext((0, $63d2ce7e33220fc9$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $i5lfL.useContext((0, $63d2ce7e33220fc9$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0def10581bd2a82b$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $6a8d0cd0a294f147$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $i5lfL.createElement($0def10581bd2a82b$export$a6c7ac8248d6e38a, $0def10581bd2a82b$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0def10581bd2a82b$export$a7fed597f4b8afd8 = /*#__PURE__*/ $i5lfL.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0def10581bd2a82b$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $0def10581bd2a82b$var$_objectWithoutPropertiesLoose(_ref9, $0def10581bd2a82b$var$_excluded3);
    let submit = $0def10581bd2a82b$export$47c85c6e3a081d3();
    let formAction = $0def10581bd2a82b$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $i5lfL.createElement("form", $0def10581bd2a82b$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0def10581bd2a82b$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0def10581bd2a82b$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0def10581bd2a82b$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0def10581bd2a82b$var$DataRouterHook || ($0def10581bd2a82b$var$DataRouterHook = {}));
var $0def10581bd2a82b$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0def10581bd2a82b$var$DataRouterStateHook || ($0def10581bd2a82b$var$DataRouterStateHook = {}));
// Internal hooks
function $0def10581bd2a82b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $0def10581bd2a82b$var$useDataRouterContext(hookName) {
    let ctx = $i5lfL.useContext((0, $63d2ce7e33220fc9$export$3add0d5dce533e2e));
    !ctx && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0def10581bd2a82b$var$useDataRouterState(hookName) {
    let state = $i5lfL.useContext((0, $63d2ce7e33220fc9$export$145dfa71566a64dc));
    !state && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0def10581bd2a82b$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $63d2ce7e33220fc9$export$9770f232ac06a008)();
    let location = (0, $63d2ce7e33220fc9$export$45d76561a5302f2b)();
    let path = (0, $63d2ce7e33220fc9$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $i5lfL.useCallback((event)=>{
        if ($0def10581bd2a82b$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $6a8d0cd0a294f147$export$fe53371bee54353d)(location) === (0, $6a8d0cd0a294f147$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0def10581bd2a82b$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $i5lfL.useRef($0def10581bd2a82b$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $i5lfL.useRef(false);
    let location = (0, $63d2ce7e33220fc9$export$45d76561a5302f2b)();
    let searchParams = $i5lfL.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0def10581bd2a82b$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $63d2ce7e33220fc9$export$9770f232ac06a008)();
    let setSearchParams = $i5lfL.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0def10581bd2a82b$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0def10581bd2a82b$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0def10581bd2a82b$var$fetcherId = 0;
let $0def10581bd2a82b$var$getUniqueFetcherId = ()=>"__" + String(++$0def10581bd2a82b$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0def10581bd2a82b$export$47c85c6e3a081d3() {
    let { router: router } = $0def10581bd2a82b$var$useDataRouterContext($0def10581bd2a82b$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $i5lfL.useContext((0, $63d2ce7e33220fc9$export$26749e8557646306));
    let currentRouteId = (0, $63d2ce7e33220fc9$export$5fc8298006ad9e58)();
    return $i5lfL.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0def10581bd2a82b$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0def10581bd2a82b$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0def10581bd2a82b$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0def10581bd2a82b$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $i5lfL.useContext((0, $63d2ce7e33220fc9$export$26749e8557646306));
    let routeContext = $i5lfL.useContext((0, $63d2ce7e33220fc9$export$9072aa6dd1f93057));
    !routeContext && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0def10581bd2a82b$var$_extends({}, (0, $63d2ce7e33220fc9$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $63d2ce7e33220fc9$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $6a8d0cd0a294f147$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $6a8d0cd0a294f147$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0def10581bd2a82b$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0def10581bd2a82b$var$useDataRouterContext($0def10581bd2a82b$var$DataRouterHook.UseFetcher);
    let state = $0def10581bd2a82b$var$useDataRouterState($0def10581bd2a82b$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $i5lfL.useContext($0def10581bd2a82b$export$148fd98d095596d4);
    let route = $i5lfL.useContext((0, $63d2ce7e33220fc9$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    !route && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0def10581bd2a82b$var$useIdImpl ? $0def10581bd2a82b$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $i5lfL.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0def10581bd2a82b$var$getUniqueFetcherId());
    // Registration/cleanup
    $i5lfL.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $i5lfL.useCallback((href, opts)=>{
        !routeId && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0def10581bd2a82b$export$47c85c6e3a081d3();
    let submit = $i5lfL.useCallback((target, opts)=>{
        submitImpl(target, $0def10581bd2a82b$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $i5lfL.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $i5lfL.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $i5lfL.createElement($0def10581bd2a82b$export$a7fed597f4b8afd8, $0def10581bd2a82b$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $6a8d0cd0a294f147$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $i5lfL.useMemo(()=>$0def10581bd2a82b$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0def10581bd2a82b$export$fa996778a3a31087() {
    let state = $0def10581bd2a82b$var$useDataRouterState($0def10581bd2a82b$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0def10581bd2a82b$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0def10581bd2a82b$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0def10581bd2a82b$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0def10581bd2a82b$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0def10581bd2a82b$var$useDataRouterContext($0def10581bd2a82b$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0def10581bd2a82b$var$useDataRouterState($0def10581bd2a82b$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $i5lfL.useContext((0, $63d2ce7e33220fc9$export$26749e8557646306));
    let location = (0, $63d2ce7e33220fc9$export$45d76561a5302f2b)();
    let matches = (0, $63d2ce7e33220fc9$export$2378eb7f5ff86053)();
    let navigation = (0, $63d2ce7e33220fc9$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $i5lfL.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0def10581bd2a82b$var$usePageHide($i5lfL.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0def10581bd2a82b$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0def10581bd2a82b$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0def10581bd2a82b$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $i5lfL.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0def10581bd2a82b$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0def10581bd2a82b$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $i5lfL.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0def10581bd2a82b$var$_extends({}, location, {
                    pathname: (0, $6a8d0cd0a294f147$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0def10581bd2a82b$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $i5lfL.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0def10581bd2a82b$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $i5lfL.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0def10581bd2a82b$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $i5lfL.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0def10581bd2a82b$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $63d2ce7e33220fc9$export$b273b3273281a049)(when);
    $i5lfL.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $i5lfL.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0def10581bd2a82b$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $i5lfL.useContext($0def10581bd2a82b$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $6a8d0cd0a294f147$export$3e9cee6b33872309)(false);
    let { basename: basename } = $0def10581bd2a82b$var$useDataRouterContext($0def10581bd2a82b$var$DataRouterHook.useViewTransitionState);
    let path = (0, $63d2ce7e33220fc9$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $6a8d0cd0a294f147$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $6a8d0cd0a294f147$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $6a8d0cd0a294f147$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $6a8d0cd0a294f147$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


// src/analytics.ts
const $eb92e6806ef5b566$var$GA_MEASUREMENT_ID = "G-S59Y1V5Q2Y";
function $eb92e6806ef5b566$export$92ab14d0aa42e41e(path) {
    if (typeof window.gtag !== "function") return;
    window.gtag("config", $eb92e6806ef5b566$var$GA_MEASUREMENT_ID, {
        page_path: path
    });
}



var $4a39B = parcelRequire("4a39B");
var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");
parcelRequire("i5lfL");


var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");



var $i5lfL = parcelRequire("i5lfL");
const $12be2c9b99774b08$var$ThemeContext = /*#__PURE__*/ $i5lfL.createContext(null);
var $12be2c9b99774b08$export$2e2bcd8739ae039 = $12be2c9b99774b08$var$ThemeContext;



var $i5lfL = parcelRequire("i5lfL");

function $019ad5402f2fef5e$export$2e2bcd8739ae039() {
    const theme = $i5lfL.useContext((0, $12be2c9b99774b08$export$2e2bcd8739ae039));
    return theme;
}


const $3c59a1314a1af1c5$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $3c59a1314a1af1c5$export$2e2bcd8739ae039 = $3c59a1314a1af1c5$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $bHJbJ = parcelRequire("bHJbJ");
function $9d03d22981f9199d$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $1CWiu.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $9d03d22981f9199d$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $019ad5402f2fef5e$export$2e2bcd8739ae039)();
    const theme = $i5lfL.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $9d03d22981f9199d$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $3c59a1314a1af1c5$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $12be2c9b99774b08$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $9d03d22981f9199d$export$2e2bcd8739ae039 = $9d03d22981f9199d$var$ThemeProvider;



parcelRequire("d8Gg3");
var $5Vkbx = parcelRequire("5Vkbx");

var $i5lfL = parcelRequire("i5lfL");
parcelRequire("d8Gg3");
var $5Vkbx = parcelRequire("5Vkbx");
'use client';
function $67100f958c8d60e0$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $67100f958c8d60e0$var$useTheme(defaultTheme = null) {
    const contextTheme = $i5lfL.useContext((0, $5Vkbx.T));
    return !contextTheme || $67100f958c8d60e0$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $67100f958c8d60e0$export$2e2bcd8739ae039 = $67100f958c8d60e0$var$useTheme;



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $bHJbJ = parcelRequire("bHJbJ");
const $dd848b3fb63e28ea$var$_excluded = [
    "value"
];
const $dd848b3fb63e28ea$var$RtlContext = /*#__PURE__*/ $i5lfL.createContext();
function $dd848b3fb63e28ea$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $7qXFD.default)(_ref, $dd848b3fb63e28ea$var$_excluded);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($dd848b3fb63e28ea$var$RtlContext.Provider, (0, $1CWiu.default)({
        value: value != null ? value : true
    }, props));
}
const $dd848b3fb63e28ea$export$b2dd014b6c321cb = ()=>{
    const value = $i5lfL.useContext($dd848b3fb63e28ea$var$RtlContext);
    return value != null ? value : false;
};
var $dd848b3fb63e28ea$export$2e2bcd8739ae039 = $dd848b3fb63e28ea$var$RtlProvider;



var $lHkUP = parcelRequire("lHkUP");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $bdcdc5db6f363c3b$var$EMPTY_THEME = {};
function $bdcdc5db6f363c3b$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $i5lfL.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $1CWiu.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $1CWiu.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $1CWiu.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $bdcdc5db6f363c3b$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $67100f958c8d60e0$export$2e2bcd8739ae039)($bdcdc5db6f363c3b$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $019ad5402f2fef5e$export$2e2bcd8739ae039)() || $bdcdc5db6f363c3b$var$EMPTY_THEME;
    const engineTheme = $bdcdc5db6f363c3b$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $bdcdc5db6f363c3b$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $9d03d22981f9199d$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $5Vkbx.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $dd848b3fb63e28ea$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $lHkUP.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $bdcdc5db6f363c3b$export$2e2bcd8739ae039 = $bdcdc5db6f363c3b$var$ThemeProvider;



var $5xV56 = parcelRequire("5xV56");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $75d54cca41f8f11d$var$_excluded = [
    "theme"
];
function $75d54cca41f8f11d$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $7qXFD.default)(_ref, $75d54cca41f8f11d$var$_excluded);
    const scopedTheme = themeInput[0, $5xV56.default];
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $bdcdc5db6f363c3b$export$2e2bcd8739ae039), (0, $1CWiu.default)({}, props, {
        themeId: scopedTheme ? (0, $5xV56.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ /*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $i5lfL = parcelRequire("i5lfL");
/*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $e6f7ad11e10d0573$export$a002182e51710d39 = {
    LIBRARY_NAME: "MSAL.JS",
    SKU: "msal.js.common",
    // Prefix for all library cache entries
    CACHE_PREFIX: "msal",
    // default authority
    DEFAULT_AUTHORITY: "https://login.microsoftonline.com/common/",
    DEFAULT_AUTHORITY_HOST: "login.microsoftonline.com",
    DEFAULT_COMMON_TENANT: "common",
    // ADFS String
    ADFS: "adfs",
    DSTS: "dstsv2",
    // Default AAD Instance Discovery Endpoint
    AAD_INSTANCE_DISCOVERY_ENDPT: "https://login.microsoftonline.com/common/discovery/instance?api-version=1.1&authorization_endpoint=",
    // CIAM URL
    CIAM_AUTH_URL: ".ciamlogin.com",
    AAD_TENANT_DOMAIN_SUFFIX: ".onmicrosoft.com",
    // Resource delimiter - used for certain cache entries
    RESOURCE_DELIM: "|",
    // Placeholder for non-existent account ids/objects
    NO_ACCOUNT: "NO_ACCOUNT",
    // Claims
    CLAIMS: "claims",
    // Consumer UTID
    CONSUMER_UTID: "9188040d-6c67-4c5b-b112-36a304b66dad",
    // Default scopes
    OPENID_SCOPE: "openid",
    PROFILE_SCOPE: "profile",
    OFFLINE_ACCESS_SCOPE: "offline_access",
    EMAIL_SCOPE: "email",
    // Default response type for authorization code flow
    CODE_RESPONSE_TYPE: "code",
    CODE_GRANT_TYPE: "authorization_code",
    RT_GRANT_TYPE: "refresh_token",
    FRAGMENT_RESPONSE_MODE: "fragment",
    S256_CODE_CHALLENGE_METHOD: "S256",
    URL_FORM_CONTENT_TYPE: "application/x-www-form-urlencoded;charset=utf-8",
    AUTHORIZATION_PENDING: "authorization_pending",
    NOT_DEFINED: "not_defined",
    EMPTY_STRING: "",
    NOT_APPLICABLE: "N/A",
    NOT_AVAILABLE: "Not Available",
    FORWARD_SLASH: "/",
    IMDS_ENDPOINT: "http://169.254.169.254/metadata/instance/compute/location",
    IMDS_VERSION: "2020-06-01",
    IMDS_TIMEOUT: 2000,
    AZURE_REGION_AUTO_DISCOVER_FLAG: "TryAutoDetect",
    REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX: "login.microsoft.com",
    KNOWN_PUBLIC_CLOUDS: [
        "login.microsoftonline.com",
        "login.windows.net",
        "login.microsoft.com",
        "sts.windows.net"
    ],
    TOKEN_RESPONSE_TYPE: "token",
    ID_TOKEN_RESPONSE_TYPE: "id_token",
    SHR_NONCE_VALIDITY: 240,
    INVALID_INSTANCE: "invalid_instance"
};
const $e6f7ad11e10d0573$export$2b71909294c66558 = {
    SUCCESS: 200,
    SUCCESS_RANGE_START: 200,
    SUCCESS_RANGE_END: 299,
    REDIRECT: 302,
    CLIENT_ERROR: 400,
    CLIENT_ERROR_RANGE_START: 400,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    REQUEST_TIMEOUT: 408,
    TOO_MANY_REQUESTS: 429,
    CLIENT_ERROR_RANGE_END: 499,
    SERVER_ERROR: 500,
    SERVER_ERROR_RANGE_START: 500,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
    SERVER_ERROR_RANGE_END: 599,
    MULTI_SIDED_ERROR: 600
};
const $e6f7ad11e10d0573$export$893b1b5b686d84ef = [
    $e6f7ad11e10d0573$export$a002182e51710d39.OPENID_SCOPE,
    $e6f7ad11e10d0573$export$a002182e51710d39.PROFILE_SCOPE,
    $e6f7ad11e10d0573$export$a002182e51710d39.OFFLINE_ACCESS_SCOPE
];
const $e6f7ad11e10d0573$export$268e88275f5afab2 = [
    ...$e6f7ad11e10d0573$export$893b1b5b686d84ef,
    $e6f7ad11e10d0573$export$a002182e51710d39.EMAIL_SCOPE
];
/**
 * Request header names
 */ const $e6f7ad11e10d0573$export$28d77f87efed1d88 = {
    CONTENT_TYPE: "Content-Type",
    CONTENT_LENGTH: "Content-Length",
    RETRY_AFTER: "Retry-After",
    CCS_HEADER: "X-AnchorMailbox",
    WWWAuthenticate: "WWW-Authenticate",
    AuthenticationInfo: "Authentication-Info",
    X_MS_REQUEST_ID: "x-ms-request-id",
    X_MS_HTTP_VERSION: "x-ms-httpver"
};
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ const $e6f7ad11e10d0573$export$81ab9ba9bd28255c = {
    ID_TOKEN: "idtoken",
    CLIENT_INFO: "client.info",
    ADAL_ID_TOKEN: "adal.idtoken",
    ERROR: "error",
    ERROR_DESC: "error.description",
    ACTIVE_ACCOUNT: "active-account",
    ACTIVE_ACCOUNT_FILTERS: "active-account-filters"
};
/**
 * String constants related to AAD Authority
 */ const $e6f7ad11e10d0573$export$e18ac120172ed505 = {
    COMMON: "common",
    ORGANIZATIONS: "organizations",
    CONSUMERS: "consumers"
};
/**
 * Claims request keys
 */ const $e6f7ad11e10d0573$export$c125cda26c71ef54 = {
    ACCESS_TOKEN: "access_token",
    XMS_CC: "xms_cc"
};
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ const $e6f7ad11e10d0573$export$49a06cbda5acaa5 = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * allowed values for codeVerifier
 */ const $e6f7ad11e10d0573$export$a1fe36237c1cc863 = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * allowed values for server response type
 */ const $e6f7ad11e10d0573$export$b34cb6fbea2adc44 = {
    QUERY: "query",
    FRAGMENT: "fragment"
};
/**
 * allowed values for response_mode
 */ const $e6f7ad11e10d0573$export$f990a5bae1260b8c = {
    ...$e6f7ad11e10d0573$export$b34cb6fbea2adc44,
    FORM_POST: "form_post"
};
/**
 * allowed grant_type
 */ const $e6f7ad11e10d0573$export$ce68f19b50b39c0b = {
    IMPLICIT_GRANT: "implicit",
    AUTHORIZATION_CODE_GRANT: "authorization_code",
    CLIENT_CREDENTIALS_GRANT: "client_credentials",
    RESOURCE_OWNER_PASSWORD_GRANT: "password",
    REFRESH_TOKEN_GRANT: "refresh_token",
    DEVICE_CODE_GRANT: "device_code",
    JWT_BEARER: "urn:ietf:params:oauth:grant-type:jwt-bearer"
};
/**
 * Account types in Cache
 */ const $e6f7ad11e10d0573$export$23244fafa2e7f55c = {
    MSSTS_ACCOUNT_TYPE: "MSSTS",
    ADFS_ACCOUNT_TYPE: "ADFS",
    MSAV1_ACCOUNT_TYPE: "MSA",
    GENERIC_ACCOUNT_TYPE: "Generic"
};
/**
 * Separators used in cache
 */ const $e6f7ad11e10d0573$export$520854da2ba5d734 = {
    CACHE_KEY_SEPARATOR: "-",
    CLIENT_INFO_SEPARATOR: "."
};
/**
 * Credential Type stored in the cache
 */ const $e6f7ad11e10d0573$export$eca2dc7e6e608a68 = {
    ID_TOKEN: "IdToken",
    ACCESS_TOKEN: "AccessToken",
    ACCESS_TOKEN_WITH_AUTH_SCHEME: "AccessToken_With_AuthScheme",
    REFRESH_TOKEN: "RefreshToken"
};
/**
 * Combine all cache types
 */ const $e6f7ad11e10d0573$export$ba193b555633db78 = {
    ADFS: 1001,
    MSA: 1002,
    MSSTS: 1003,
    GENERIC: 1004,
    ACCESS_TOKEN: 2001,
    REFRESH_TOKEN: 2002,
    ID_TOKEN: 2003,
    APP_METADATA: 3001,
    UNDEFINED: 9999
};
/**
 * More Cache related constants
 */ const $e6f7ad11e10d0573$export$7e1bea6dc1b6b32e = "appmetadata";
const $e6f7ad11e10d0573$export$476989d62bcb4c85 = "client_info";
const $e6f7ad11e10d0573$export$978fe7ab5e74b539 = "1";
const $e6f7ad11e10d0573$export$d483f966e66f4db5 = {
    CACHE_KEY: "authority-metadata",
    REFRESH_TIME_SECONDS: 86400
};
const $e6f7ad11e10d0573$export$5d365d77acfcb55d = {
    CONFIG: "config",
    CACHE: "cache",
    NETWORK: "network",
    HARDCODED_VALUES: "hardcoded_values"
};
const $e6f7ad11e10d0573$export$30fa4ad28fb9feeb = {
    SCHEMA_VERSION: 5,
    MAX_CUR_HEADER_BYTES: 80,
    MAX_LAST_HEADER_BYTES: 330,
    MAX_CACHED_ERRORS: 50,
    CACHE_KEY: "server-telemetry",
    CATEGORY_SEPARATOR: "|",
    VALUE_SEPARATOR: ",",
    OVERFLOW_TRUE: "1",
    OVERFLOW_FALSE: "0",
    UNKNOWN_ERROR: "unknown_error"
};
/**
 * Type of the authentication request
 */ const $e6f7ad11e10d0573$export$901491a717da2ba5 = {
    BEARER: "Bearer",
    POP: "pop",
    SSH: "ssh-cert"
};
/**
 * Constants related to throttling
 */ const $e6f7ad11e10d0573$export$a2330d6808e6d893 = {
    // Default time to throttle RequestThumbprint in seconds
    DEFAULT_THROTTLE_TIME_SECONDS: 60,
    // Default maximum time to throttle in seconds, overrides what the server sends back
    DEFAULT_MAX_THROTTLE_TIME_SECONDS: 3600,
    // Prefix for storing throttling entries
    THROTTLING_PREFIX: "throttling",
    // Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
    X_MS_LIB_CAPABILITY_VALUE: "retry-after, h429"
};
const $e6f7ad11e10d0573$export$b8e9cd941e8016ac = {
    INVALID_GRANT_ERROR: "invalid_grant",
    CLIENT_MISMATCH_ERROR: "client_mismatch"
};
/**
 * Password grant parameters
 */ const $e6f7ad11e10d0573$export$fa8b29062cab1da = {
    username: "username",
    password: "password"
};
/**
 * Response codes
 */ const $e6f7ad11e10d0573$export$20ba0879771a17be = {
    httpSuccess: 200,
    httpBadRequest: 400
};
/**
 * Region Discovery Sources
 */ const $e6f7ad11e10d0573$export$3d4a3e11df589b40 = {
    FAILED_AUTO_DETECTION: "1",
    INTERNAL_CACHE: "2",
    ENVIRONMENT_VARIABLE: "3",
    IMDS: "4"
};
/**
 * Region Discovery Outcomes
 */ const $e6f7ad11e10d0573$export$92a685f9218422bd = {
    CONFIGURED_MATCHES_DETECTED: "1",
    CONFIGURED_NO_AUTO_DETECTION: "2",
    CONFIGURED_NOT_DETECTED: "3",
    AUTO_DETECTION_REQUESTED_SUCCESSFUL: "4",
    AUTO_DETECTION_REQUESTED_FAILED: "5"
};
/**
 * Specifies the reason for fetching the access token from the identity provider
 */ const $e6f7ad11e10d0573$export$aa4af185ea049f6b = {
    // When a token is found in the cache or the cache is not supposed to be hit when making the request
    NOT_APPLICABLE: "0",
    // When the token request goes to the identity provider because force_refresh was set to true. Also occurs if claims were requested
    FORCE_REFRESH_OR_CLAIMS: "1",
    // When the token request goes to the identity provider because no cached access token exists
    NO_CACHED_ACCESS_TOKEN: "2",
    // When the token request goes to the identity provider because cached access token expired
    CACHED_ACCESS_TOKEN_EXPIRED: "3",
    // When the token request goes to the identity provider because refresh_in was used and the existing token needs to be refreshed
    PROACTIVELY_REFRESHED: "4"
};
const $e6f7ad11e10d0573$export$fe5c42ed17efe603 = {
    Jwt: "JWT",
    Jwk: "JWK",
    Pop: "pop"
};
const $e6f7ad11e10d0573$export$14c29d43b22a755f = 86400000;
// Token renewal offset default in seconds
const $e6f7ad11e10d0573$export$8d50f42618161d1a = 300;


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Constants
 */ const $e195f599725a9f25$export$a0a689e4294b9880 = {
    /**
     * Interaction in progress cache value
     */ INTERACTION_IN_PROGRESS_VALUE: "interaction_in_progress",
    /**
     * Invalid grant error code
     */ INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */ POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */ POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */ POPUP_NAME_PREFIX: "msal",
    /**
     * Default popup monitor poll interval in milliseconds
     */ DEFAULT_POLL_INTERVAL_MS: 30,
    /**
     * Msal-browser SKU
     */ MSAL_SKU: "msal.js.browser"
};
const $e195f599725a9f25$export$fec113838800867f = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS"
};
const $e195f599725a9f25$export$3536098be6c7dadb = {
    HandshakeRequest: "Handshake",
    HandshakeResponse: "HandshakeResponse",
    GetToken: "GetToken",
    Response: "Response"
};
const $e195f599725a9f25$export$573384e47a12d835 = {
    LocalStorage: "localStorage",
    SessionStorage: "sessionStorage",
    MemoryStorage: "memoryStorage"
};
/**
 * HTTP Request types supported by MSAL.
 */ const $e195f599725a9f25$export$c774c31b4c31da8 = {
    GET: "GET",
    POST: "POST"
};
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */ const $e195f599725a9f25$export$21d55bedf0d269fb = {
    AUTHORITY: "authority",
    ACQUIRE_TOKEN_ACCOUNT: "acquireToken.account",
    SESSION_STATE: "session.state",
    REQUEST_STATE: "request.state",
    NONCE_IDTOKEN: "nonce.id_token",
    ORIGIN_URI: "request.origin",
    RENEW_STATUS: "token.renew.status",
    URL_HASH: "urlHash",
    REQUEST_PARAMS: "request.params",
    SCOPES: "scopes",
    INTERACTION_STATUS_KEY: "interaction.status",
    CCS_CREDENTIAL: "ccs.credential",
    CORRELATION_ID: "request.correlationId",
    NATIVE_REQUEST: "request.native",
    REDIRECT_CONTEXT: "request.redirect.context"
};
const $e195f599725a9f25$export$f6ce23cce692699f = {
    ACCOUNT_KEYS: "msal.account.keys",
    TOKEN_KEYS: "msal.token.keys"
};
/**
 * Cache keys stored in-memory
 */ const $e195f599725a9f25$export$8f546f90896bcfa9 = {
    WRAPPER_SKU: "wrapper.sku",
    WRAPPER_VER: "wrapper.version"
};
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 */ const $e195f599725a9f25$export$192d74ad69b40705 = {
    acquireTokenRedirect: 861,
    acquireTokenPopup: 862,
    ssoSilent: 863,
    acquireTokenSilent_authCode: 864,
    handleRedirectPromise: 865,
    acquireTokenByCode: 866,
    acquireTokenSilent_silentFlow: 61,
    logout: 961,
    logoutPopup: 962
};
/*
 * Interaction type of the API - used for state and telemetry
 */ var $e195f599725a9f25$export$4ec29255e7e7f68f;
(function(InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})($e195f599725a9f25$export$4ec29255e7e7f68f || ($e195f599725a9f25$export$4ec29255e7e7f68f = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */ const $e195f599725a9f25$export$bec20eda0179362b = {
    /**
     * Initial status before interaction occurs
     */ Startup: "startup",
    /**
     * Status set when all login calls occuring
     */ Login: "login",
    /**
     * Status set when logout call occuring
     */ Logout: "logout",
    /**
     * Status set for acquireToken calls
     */ AcquireToken: "acquireToken",
    /**
     * Status set for ssoSilent calls
     */ SsoSilent: "ssoSilent",
    /**
     * Status set when handleRedirect in progress
     */ HandleRedirect: "handleRedirect",
    /**
     * Status set when interaction is complete
     */ None: "none"
};
const $e195f599725a9f25$export$7e12949cd6884193 = {
    scopes: (0, $e6f7ad11e10d0573$export$893b1b5b686d84ef)
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */ const $e195f599725a9f25$export$1294c3e3f84694cd = "jwk";
// Supported wrapper SKUs
const $e195f599725a9f25$export$8abb9de997bb4e44 = {
    React: "@azure/msal-react",
    Angular: "@azure/msal-angular"
};
// DatabaseStorage Constants
const $e195f599725a9f25$export$3c22ff8b64b8f565 = "msal.db";
const $e195f599725a9f25$export$6a9022b4c5fcea02 = 1;
const $e195f599725a9f25$export$9d785db034fb436f = `${$e195f599725a9f25$export$3c22ff8b64b8f565}.keys`;
const $e195f599725a9f25$export$4394baa7e922d42d = {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */ Default: 0,
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */ AccessToken: 1,
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */ AccessTokenAndRefreshToken: 2,
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */ RefreshToken: 3,
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */ RefreshTokenAndNetwork: 4,
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */ Skip: 5
};
const $e195f599725a9f25$export$736180706fb122ee = [
    $e195f599725a9f25$export$4394baa7e922d42d.Default,
    $e195f599725a9f25$export$4394baa7e922d42d.Skip,
    $e195f599725a9f25$export$4394baa7e922d42d.RefreshTokenAndNetwork
];
const $e195f599725a9f25$export$b28668d53eb57e63 = "msal.browser.log.level";
const $e195f599725a9f25$export$d9bc1c202a3825f1 = "msal.browser.log.pii";
const $e195f599725a9f25$export$54408f0b0cf727d4 = "msal.browser.performance.enabled";

/*! @azure/msal-common v14.16.0 2024-11-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Log message level.
 */ var $bf1c529f0722dfeb$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})($bf1c529f0722dfeb$export$243e62d78d3b544d || ($bf1c529f0722dfeb$export$243e62d78d3b544d = {}));
/**
 * Class which facilitates logging of messages to a specific place.
 */ class $bf1c529f0722dfeb$export$efa9a398d6368992 {
    constructor(loggerOptions, packageName, packageVersion){
        // Current log level, defaults to info.
        this.level = $bf1c529f0722dfeb$export$243e62d78d3b544d.Info;
        const defaultLoggerCallback = ()=>{
            return;
        };
        const setLoggerOptions = loggerOptions || $bf1c529f0722dfeb$export$efa9a398d6368992.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof setLoggerOptions.logLevel === "number" ? setLoggerOptions.logLevel : $bf1c529f0722dfeb$export$243e62d78d3b544d.Info;
        this.correlationId = setLoggerOptions.correlationId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        this.packageName = packageName || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        this.packageVersion = packageVersion || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
    }
    static createDefaultLoggerOptions() {
        return {
            loggerCallback: ()=>{
            // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: $bf1c529f0722dfeb$export$243e62d78d3b544d.Info
        };
    }
    /**
     * Create new Logger with existing configurations.
     */ clone(packageName, packageVersion, correlationId) {
        return new $bf1c529f0722dfeb$export$efa9a398d6368992({
            loggerCallback: this.localCallback,
            piiLoggingEnabled: this.piiLoggingEnabled,
            logLevel: this.level,
            correlationId: correlationId || this.correlationId
        }, packageName, packageVersion);
    }
    /**
     * Log message with required options.
     */ logMessage(logMessage, options) {
        if (options.logLevel > this.level || !this.piiLoggingEnabled && options.containsPii) return;
        const timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        const logHeader = `[${timestamp}] : [${options.correlationId || this.correlationId || ""}]`;
        const log = `${logHeader} : ${this.packageName}@${this.packageVersion} : ${$bf1c529f0722dfeb$export$243e62d78d3b544d[options.logLevel]} - ${logMessage}`;
        // debug(`msal:${LogLevel[options.logLevel]}${options.containsPii ? "-Pii": Constants.EMPTY_STRING}${options.context ? `:${options.context}` : Constants.EMPTY_STRING}`)(logMessage);
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    }
    /**
     * Execute callback with message.
     */ executeCallback(level, message, containsPii) {
        if (this.localCallback) this.localCallback(level, message, containsPii);
    }
    /**
     * Logs error messages.
     */ error(message, correlationId) {
        this.logMessage(message, {
            logLevel: $bf1c529f0722dfeb$export$243e62d78d3b544d.Error,
            containsPii: false,
            correlationId: correlationId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs error messages with PII.
     */ errorPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $bf1c529f0722dfeb$export$243e62d78d3b544d.Error,
            containsPii: true,
            correlationId: correlationId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs warning messages.
     */ warning(message, correlationId) {
        this.logMessage(message, {
            logLevel: $bf1c529f0722dfeb$export$243e62d78d3b544d.Warning,
            containsPii: false,
            correlationId: correlationId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs warning messages with PII.
     */ warningPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $bf1c529f0722dfeb$export$243e62d78d3b544d.Warning,
            containsPii: true,
            correlationId: correlationId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs info messages.
     */ info(message, correlationId) {
        this.logMessage(message, {
            logLevel: $bf1c529f0722dfeb$export$243e62d78d3b544d.Info,
            containsPii: false,
            correlationId: correlationId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs info messages with PII.
     */ infoPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $bf1c529f0722dfeb$export$243e62d78d3b544d.Info,
            containsPii: true,
            correlationId: correlationId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs verbose messages.
     */ verbose(message, correlationId) {
        this.logMessage(message, {
            logLevel: $bf1c529f0722dfeb$export$243e62d78d3b544d.Verbose,
            containsPii: false,
            correlationId: correlationId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs verbose messages with PII.
     */ verbosePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $bf1c529f0722dfeb$export$243e62d78d3b544d.Verbose,
            containsPii: true,
            correlationId: correlationId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs trace messages.
     */ trace(message, correlationId) {
        this.logMessage(message, {
            logLevel: $bf1c529f0722dfeb$export$243e62d78d3b544d.Trace,
            containsPii: false,
            correlationId: correlationId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs trace messages with PII.
     */ tracePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $bf1c529f0722dfeb$export$243e62d78d3b544d.Trace,
            containsPii: true,
            correlationId: correlationId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Returns whether PII Logging is enabled or not.
     */ isPiiLoggingEnabled() {
        return this.piiLoggingEnabled || false;
    }
}

/*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 
var $acfff9ca9e4267b8$exports = {};

$parcel$export($acfff9ca9e4267b8$exports, "unexpectedError", function () { return $acfff9ca9e4267b8$export$efbc88c27b0be04; });
$parcel$export($acfff9ca9e4267b8$exports, "postRequestFailed", function () { return $acfff9ca9e4267b8$export$7a1e28a7b60ca602; });
/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */ const $acfff9ca9e4267b8$export$efbc88c27b0be04 = "unexpected_error";
const $acfff9ca9e4267b8$export$7a1e28a7b60ca602 = "post_request_failed";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $40da14d5d49dd285$export$cd5f04206718d3a5 = {
    [(0, $acfff9ca9e4267b8$export$efbc88c27b0be04)]: "Unexpected error in authentication.",
    [(0, $acfff9ca9e4267b8$export$7a1e28a7b60ca602)]: "Post request failed from the network, could be a 4xx/5xx or a network unavailability. Please check the exact error code for details."
};
/**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use AuthErrorCodes instead
 */ const $40da14d5d49dd285$export$930cbd4733f218f0 = {
    unexpectedError: {
        code: (0, $acfff9ca9e4267b8$export$efbc88c27b0be04),
        desc: $40da14d5d49dd285$export$cd5f04206718d3a5[0, $acfff9ca9e4267b8$export$efbc88c27b0be04]
    },
    postRequestFailed: {
        code: (0, $acfff9ca9e4267b8$export$7a1e28a7b60ca602),
        desc: $40da14d5d49dd285$export$cd5f04206718d3a5[0, $acfff9ca9e4267b8$export$7a1e28a7b60ca602]
    }
};
/**
 * General error class thrown by the MSAL.js library.
 */ class $40da14d5d49dd285$export$145273558d58e0ac extends Error {
    constructor(errorCode, errorMessage, suberror){
        const errorString = errorMessage ? `${errorCode}: ${errorMessage}` : errorCode;
        super(errorString);
        Object.setPrototypeOf(this, $40da14d5d49dd285$export$145273558d58e0ac.prototype);
        this.errorCode = errorCode || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        this.errorMessage = errorMessage || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        this.subError = suberror || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        this.name = "AuthError";
    }
    setCorrelationId(correlationId) {
        this.correlationId = correlationId;
    }
}
function $40da14d5d49dd285$export$eb157f7636c79bd2(code, additionalMessage) {
    return new $40da14d5d49dd285$export$145273558d58e0ac(code, additionalMessage ? `${$40da14d5d49dd285$export$cd5f04206718d3a5[code]} ${additionalMessage}` : $40da14d5d49dd285$export$cd5f04206718d3a5[code]);
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $da4c47c78c7b210e$export$41d7a3d4e14d6113 = "storage_not_supported";
const $da4c47c78c7b210e$export$1377ea690fa0b6d8 = "stubbed_public_client_application_called";
const $da4c47c78c7b210e$export$37486e3b6bed61c6 = "in_mem_redirect_unavailable";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $4688392e2970a328$export$a14089932466e176 = {
    [(0, $da4c47c78c7b210e$export$41d7a3d4e14d6113)]: "Given storage configuration option was not supported.",
    [(0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)]: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors",
    [(0, $da4c47c78c7b210e$export$37486e3b6bed61c6)]: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
};
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use BrowserAuthErrorCodes instead
 */ const $4688392e2970a328$export$daccd9364f884077 = {
    storageNotSupportedError: {
        code: (0, $da4c47c78c7b210e$export$41d7a3d4e14d6113),
        desc: $4688392e2970a328$export$a14089932466e176[0, $da4c47c78c7b210e$export$41d7a3d4e14d6113]
    },
    stubPcaInstanceCalled: {
        code: (0, $da4c47c78c7b210e$export$1377ea690fa0b6d8),
        desc: $4688392e2970a328$export$a14089932466e176[0, $da4c47c78c7b210e$export$1377ea690fa0b6d8]
    },
    inMemRedirectUnavailable: {
        code: (0, $da4c47c78c7b210e$export$37486e3b6bed61c6),
        desc: $4688392e2970a328$export$a14089932466e176[0, $da4c47c78c7b210e$export$37486e3b6bed61c6]
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $4688392e2970a328$export$2eb7a1dfdc4c5fba extends (0, $40da14d5d49dd285$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(this, $4688392e2970a328$export$2eb7a1dfdc4c5fba.prototype);
    }
}
function $4688392e2970a328$export$176bd5050947ba0c(errorCode) {
    return new $4688392e2970a328$export$2eb7a1dfdc4c5fba(errorCode, $4688392e2970a328$export$a14089932466e176[errorCode]);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $ce103e412301a1c2$export$29650b96fd06034a = {
    initialize: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    acquireTokenPopup: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    acquireTokenRedirect: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    acquireTokenSilent: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    acquireTokenByCode: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    getAllAccounts: ()=>{
        return [];
    },
    getAccount: ()=>{
        return null;
    },
    getAccountByHomeId: ()=>{
        return null;
    },
    getAccountByUsername: ()=>{
        return null;
    },
    getAccountByLocalId: ()=>{
        return null;
    },
    handleRedirectPromise: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    loginPopup: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    loginRedirect: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    logout: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    logoutRedirect: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    logoutPopup: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    ssoSilent: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    addEventCallback: ()=>{
        return null;
    },
    removeEventCallback: ()=>{
        return;
    },
    addPerformanceCallback: ()=>{
        return "";
    },
    removePerformanceCallback: ()=>{
        return false;
    },
    enableAccountStorageEvents: ()=>{
        return;
    },
    disableAccountStorageEvents: ()=>{
        return;
    },
    getTokenCache: ()=>{
        throw (0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8));
    },
    getLogger: ()=>{
        throw (0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8));
    },
    setLogger: ()=>{
        return;
    },
    setActiveAccount: ()=>{
        return;
    },
    getActiveAccount: ()=>{
        return null;
    },
    initializeWrapperLibrary: ()=>{
        return;
    },
    setNavigationClient: ()=>{
        return;
    },
    getConfiguration: ()=>{
        throw (0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8));
    },
    hydrateCache: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    },
    clearCache: ()=>{
        return Promise.reject((0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$1377ea690fa0b6d8)));
    }
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*
 * Stubbed context implementation
 * Only used when there is no provider, which is an unsupported scenario
 */ const $42d52540351acc83$var$defaultMsalContext = {
    instance: (0, $ce103e412301a1c2$export$29650b96fd06034a),
    inProgress: (0, $e195f599725a9f25$export$bec20eda0179362b).None,
    accounts: [],
    logger: new (0, $bf1c529f0722dfeb$export$efa9a398d6368992)({})
};
const $42d52540351acc83$export$66324aeea97dd1e5 = $i5lfL.createContext($42d52540351acc83$var$defaultMsalContext);
const $42d52540351acc83$export$b74154d0810e24c1 = $42d52540351acc83$export$66324aeea97dd1e5.Consumer;


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $i5lfL = parcelRequire("i5lfL");
/*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-browser v3.27.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $77ca9fc57e3aa1cd$export$3d7865934588d77e = {
    INITIALIZE_START: "msal:initializeStart",
    INITIALIZE_END: "msal:initializeEnd",
    ACCOUNT_ADDED: "msal:accountAdded",
    ACCOUNT_REMOVED: "msal:accountRemoved",
    ACTIVE_ACCOUNT_CHANGED: "msal:activeAccountChanged",
    LOGIN_START: "msal:loginStart",
    LOGIN_SUCCESS: "msal:loginSuccess",
    LOGIN_FAILURE: "msal:loginFailure",
    ACQUIRE_TOKEN_START: "msal:acquireTokenStart",
    ACQUIRE_TOKEN_SUCCESS: "msal:acquireTokenSuccess",
    ACQUIRE_TOKEN_FAILURE: "msal:acquireTokenFailure",
    ACQUIRE_TOKEN_NETWORK_START: "msal:acquireTokenFromNetworkStart",
    SSO_SILENT_START: "msal:ssoSilentStart",
    SSO_SILENT_SUCCESS: "msal:ssoSilentSuccess",
    SSO_SILENT_FAILURE: "msal:ssoSilentFailure",
    ACQUIRE_TOKEN_BY_CODE_START: "msal:acquireTokenByCodeStart",
    ACQUIRE_TOKEN_BY_CODE_SUCCESS: "msal:acquireTokenByCodeSuccess",
    ACQUIRE_TOKEN_BY_CODE_FAILURE: "msal:acquireTokenByCodeFailure",
    HANDLE_REDIRECT_START: "msal:handleRedirectStart",
    HANDLE_REDIRECT_END: "msal:handleRedirectEnd",
    POPUP_OPENED: "msal:popupOpened",
    LOGOUT_START: "msal:logoutStart",
    LOGOUT_SUCCESS: "msal:logoutSuccess",
    LOGOUT_FAILURE: "msal:logoutFailure",
    LOGOUT_END: "msal:logoutEnd",
    RESTORE_FROM_BFCACHE: "msal:restoreFromBFCache"
};



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $3689080ec8d12231$export$ba9166e03da6599c {
    /**
     * Gets interaction status from event message
     * @param message
     * @param currentStatus
     */ static getInteractionStatusFromEvent(message, currentStatus) {
        switch(message.eventType){
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGIN_START:
                return (0, $e195f599725a9f25$export$bec20eda0179362b).Login;
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).SSO_SILENT_START:
                return (0, $e195f599725a9f25$export$bec20eda0179362b).SsoSilent;
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_START:
                if (message.interactionType === (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect || message.interactionType === (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup) return (0, $e195f599725a9f25$export$bec20eda0179362b).AcquireToken;
                break;
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).HANDLE_REDIRECT_START:
                return (0, $e195f599725a9f25$export$bec20eda0179362b).HandleRedirect;
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_START:
                return (0, $e195f599725a9f25$export$bec20eda0179362b).Logout;
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).SSO_SILENT_SUCCESS:
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).SSO_SILENT_FAILURE:
                if (currentStatus && currentStatus !== (0, $e195f599725a9f25$export$bec20eda0179362b).SsoSilent) break;
                return (0, $e195f599725a9f25$export$bec20eda0179362b).None;
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_END:
                if (currentStatus && currentStatus !== (0, $e195f599725a9f25$export$bec20eda0179362b).Logout) break;
                return (0, $e195f599725a9f25$export$bec20eda0179362b).None;
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).HANDLE_REDIRECT_END:
                if (currentStatus && currentStatus !== (0, $e195f599725a9f25$export$bec20eda0179362b).HandleRedirect) break;
                return (0, $e195f599725a9f25$export$bec20eda0179362b).None;
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGIN_SUCCESS:
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGIN_FAILURE:
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS:
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE:
            case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).RESTORE_FROM_BFCACHE:
                if (message.interactionType === (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect || message.interactionType === (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup) {
                    if (currentStatus && currentStatus !== (0, $e195f599725a9f25$export$bec20eda0179362b).Login && currentStatus !== (0, $e195f599725a9f25$export$bec20eda0179362b).AcquireToken) break;
                    return (0, $e195f599725a9f25$export$bec20eda0179362b).None;
                }
                break;
        }
        return null;
    }
}



/*! @azure/msal-react v2.2.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $6ff7d7464b194504$export$7a39d5906c5d6010(children, args) {
    if (typeof children === "function") return children(args);
    return children;
}
/**
 * Helper function to determine whether 2 arrays are equal
 * Used to avoid unnecessary state updates
 * @param arrayA
 * @param arrayB
 */ function $6ff7d7464b194504$export$601fd69958c01c8c(arrayA, arrayB) {
    if (arrayA.length !== arrayB.length) return false;
    const comparisonArray = [
        ...arrayB
    ];
    return arrayA.every((elementA)=>{
        const elementB = comparisonArray.shift();
        if (!elementA || !elementB) return false;
        return elementA.homeAccountId === elementB.homeAccountId && elementA.localAccountId === elementB.localAccountId && elementA.username === elementB.username;
    });
}
function $6ff7d7464b194504$export$fa581286d49c51db(allAccounts, accountIdentifiers) {
    if (allAccounts.length > 0 && (accountIdentifiers.homeAccountId || accountIdentifiers.localAccountId || accountIdentifiers.username)) {
        const matchedAccounts = allAccounts.filter((accountObj)=>{
            if (accountIdentifiers.username && accountIdentifiers.username.toLowerCase() !== accountObj.username.toLowerCase()) return false;
            if (accountIdentifiers.homeAccountId && accountIdentifiers.homeAccountId.toLowerCase() !== accountObj.homeAccountId.toLowerCase()) return false;
            if (accountIdentifiers.localAccountId && accountIdentifiers.localAccountId.toLowerCase() !== accountObj.localAccountId.toLowerCase()) return false;
            return true;
        });
        return matchedAccounts[0] || null;
    } else return null;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 'use strict';
/* eslint-disable header/header */ const $f5ea78e5f8daf8a3$export$a8ff84c12d48cfa6 = "@azure/msal-react";
const $f5ea78e5f8daf8a3$export$83d89fbfd8236492 = "2.2.0";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $521e8490c894046d$var$MsalProviderActionType = {
    UNBLOCK_INPROGRESS: "UNBLOCK_INPROGRESS",
    EVENT: "EVENT"
};
/**
 * Returns the next inProgress and accounts state based on event message
 * @param previousState
 * @param action
 */ const $521e8490c894046d$var$reducer = (previousState, action)=>{
    const { type: type, payload: payload } = action;
    let newInProgress = previousState.inProgress;
    switch(type){
        case $521e8490c894046d$var$MsalProviderActionType.UNBLOCK_INPROGRESS:
            if (previousState.inProgress === (0, $e195f599725a9f25$export$bec20eda0179362b).Startup) {
                newInProgress = (0, $e195f599725a9f25$export$bec20eda0179362b).None;
                payload.logger.info("MsalProvider - handleRedirectPromise resolved, setting inProgress to 'none'");
            }
            break;
        case $521e8490c894046d$var$MsalProviderActionType.EVENT:
            const message = payload.message;
            const status = (0, $3689080ec8d12231$export$ba9166e03da6599c).getInteractionStatusFromEvent(message, previousState.inProgress);
            if (status) {
                payload.logger.info(`MsalProvider - ${message.eventType} results in setting inProgress from ${previousState.inProgress} to ${status}`);
                newInProgress = status;
            }
            break;
        default:
            throw new Error(`Unknown action type: ${type}`);
    }
    const currentAccounts = payload.instance.getAllAccounts();
    if (newInProgress !== previousState.inProgress && !(0, $6ff7d7464b194504$export$601fd69958c01c8c)(currentAccounts, previousState.accounts)) // Both inProgress and accounts changed
    return {
        ...previousState,
        inProgress: newInProgress,
        accounts: currentAccounts
    };
    else if (newInProgress !== previousState.inProgress) // Only only inProgress changed
    return {
        ...previousState,
        inProgress: newInProgress
    };
    else if (!(0, $6ff7d7464b194504$export$601fd69958c01c8c)(currentAccounts, previousState.accounts)) // Only accounts changed
    return {
        ...previousState,
        accounts: currentAccounts
    };
    else // Nothing changed
    return previousState;
};
/**
 * MSAL context provider component. This must be rendered above any other components that use MSAL.
 */ function $521e8490c894046d$export$25bac41dc3d78d47({ instance: instance, children: children }) {
    (0, $i5lfL.useEffect)(()=>{
        instance.initializeWrapperLibrary((0, $e195f599725a9f25$export$8abb9de997bb4e44).React, (0, $f5ea78e5f8daf8a3$export$83d89fbfd8236492));
    }, [
        instance
    ]);
    // Create a logger instance for msal-react with the same options as PublicClientApplication
    const logger = (0, $i5lfL.useMemo)(()=>{
        return instance.getLogger().clone((0, $f5ea78e5f8daf8a3$export$a8ff84c12d48cfa6), (0, $f5ea78e5f8daf8a3$export$83d89fbfd8236492));
    }, [
        instance
    ]);
    const [state, updateState] = (0, $i5lfL.useReducer)($521e8490c894046d$var$reducer, undefined, ()=>{
        // Lazy initialization of the initial state
        return {
            inProgress: (0, $e195f599725a9f25$export$bec20eda0179362b).Startup,
            accounts: instance.getAllAccounts()
        };
    });
    (0, $i5lfL.useEffect)(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            updateState({
                payload: {
                    instance: instance,
                    logger: logger,
                    message: message
                },
                type: $521e8490c894046d$var$MsalProviderActionType.EVENT
            });
        });
        logger.verbose(`MsalProvider - Registered event callback with id: ${callbackId}`);
        instance.initialize().then(()=>{
            instance.handleRedirectPromise().catch(()=>{
                // Errors should be handled by listening to the LOGIN_FAILURE event
                return;
            }).finally(()=>{
                /*
                 * If handleRedirectPromise returns a cached promise the necessary events may not be fired
                 * This is a fallback to prevent inProgress from getting stuck in 'startup'
                 */ updateState({
                    payload: {
                        instance: instance,
                        logger: logger
                    },
                    type: $521e8490c894046d$var$MsalProviderActionType.UNBLOCK_INPROGRESS
                });
            });
        }).catch(()=>{
            // Errors should be handled by listening to the LOGIN_FAILURE event
            return;
        });
        return ()=>{
            // Remove callback when component unmounts or accounts change
            if (callbackId) {
                logger.verbose(`MsalProvider - Removing event callback ${callbackId}`);
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    const contextValue = {
        instance: instance,
        inProgress: state.inProgress,
        accounts: state.accounts,
        logger: logger
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement((0, $42d52540351acc83$export$66324aeea97dd1e5).Provider, {
        value: contextValue
    }, children);
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $i5lfL = parcelRequire("i5lfL");

/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $i5lfL = parcelRequire("i5lfL");

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns Msal Context values
 */ const $3f0c670b43f101ac$export$f41558044a1dd55 = ()=>(0, $i5lfL.useContext)((0, $42d52540351acc83$export$66324aeea97dd1e5));


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $i5lfL = parcelRequire("i5lfL");



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $91b77ab8667707a4$var$isAuthenticated(allAccounts, matchAccount) {
    if (matchAccount && (matchAccount.username || matchAccount.homeAccountId || matchAccount.localAccountId)) return !!(0, $6ff7d7464b194504$export$fa581286d49c51db)(allAccounts, matchAccount);
    return allAccounts.length > 0;
}
/**
 * Returns whether or not a user is currently signed-in. Optionally provide 1 or more accountIdentifiers to determine if a specific user is signed-in
 * @param matchAccount
 */ function $91b77ab8667707a4$export$7e9c60d6d1836c84(matchAccount) {
    const { accounts: allAccounts, inProgress: inProgress } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const isUserAuthenticated = (0, $i5lfL.useMemo)(()=>{
        if (inProgress === (0, $e195f599725a9f25$export$bec20eda0179362b).Startup) return false;
        return $91b77ab8667707a4$var$isAuthenticated(allAccounts, matchAccount);
    }, [
        allAccounts,
        inProgress,
        matchAccount
    ]);
    return isUserAuthenticated;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is authenticated
 * @param props
 */ function $e4400acf80ba3bb9$export$3f7734c901feade6({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const accountIdentifier = (0, $i5lfL.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = (0, $91b77ab8667707a4$export$7e9c60d6d1836c84)(accountIdentifier);
    if (isAuthenticated && context.inProgress !== (0, $e195f599725a9f25$export$bec20eda0179362b).Startup) return (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).Fragment, null, (0, $6ff7d7464b194504$export$7a39d5906c5d6010)(children, context));
    return null;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $i5lfL = parcelRequire("i5lfL");




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is unauthenticated
 * @param props
 */ function $c566e1b6d61241ec$export$8285a35799c5812b({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const accountIdentifier = (0, $i5lfL.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = (0, $91b77ab8667707a4$export$7e9c60d6d1836c84)(accountIdentifier);
    if (!isAuthenticated && context.inProgress !== (0, $e195f599725a9f25$export$bec20eda0179362b).Startup && context.inProgress !== (0, $e195f599725a9f25$export$bec20eda0179362b).HandleRedirect) return (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).Fragment, null, (0, $6ff7d7464b194504$export$7a39d5906c5d6010)(children, context));
    return null;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $i5lfL = parcelRequire("i5lfL");


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $i5lfL = parcelRequire("i5lfL");
/*! @azure/msal-common v14.16.0 2024-11-05 */ 

var $0da9c4dbbd48f7df$exports = {};

$parcel$export($0da9c4dbbd48f7df$exports, "noTokensFound", function () { return $0da9c4dbbd48f7df$export$e408b083cd212696; });
$parcel$export($0da9c4dbbd48f7df$exports, "nativeAccountUnavailable", function () { return $0da9c4dbbd48f7df$export$3bf2eb3358f5f570; });
$parcel$export($0da9c4dbbd48f7df$exports, "refreshTokenExpired", function () { return $0da9c4dbbd48f7df$export$a90e8b9c10991b49; });
$parcel$export($0da9c4dbbd48f7df$exports, "interactionRequired", function () { return $0da9c4dbbd48f7df$export$cdb77bf88e749c31; });
$parcel$export($0da9c4dbbd48f7df$exports, "consentRequired", function () { return $0da9c4dbbd48f7df$export$ca4e8d96d12fe4c5; });
$parcel$export($0da9c4dbbd48f7df$exports, "loginRequired", function () { return $0da9c4dbbd48f7df$export$402ebc0f96d7decb; });
$parcel$export($0da9c4dbbd48f7df$exports, "badToken", function () { return $0da9c4dbbd48f7df$export$2e3666c77d45a4da; });
/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Codes defined by MSAL
const $0da9c4dbbd48f7df$export$e408b083cd212696 = "no_tokens_found";
const $0da9c4dbbd48f7df$export$3bf2eb3358f5f570 = "native_account_unavailable";
const $0da9c4dbbd48f7df$export$a90e8b9c10991b49 = "refresh_token_expired";
// Codes potentially returned by server
const $0da9c4dbbd48f7df$export$cdb77bf88e749c31 = "interaction_required";
const $0da9c4dbbd48f7df$export$ca4e8d96d12fe4c5 = "consent_required";
const $0da9c4dbbd48f7df$export$402ebc0f96d7decb = "login_required";
const $0da9c4dbbd48f7df$export$2e3666c77d45a4da = "bad_token";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */ const $b3acdb9c5805a543$export$e16d6a6c677acec5 = [
    (0, $0da9c4dbbd48f7df$export$cdb77bf88e749c31),
    (0, $0da9c4dbbd48f7df$export$ca4e8d96d12fe4c5),
    (0, $0da9c4dbbd48f7df$export$402ebc0f96d7decb),
    (0, $0da9c4dbbd48f7df$export$2e3666c77d45a4da)
];
const $b3acdb9c5805a543$export$9689959ec6716811 = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required",
    "bad_token"
];
const $b3acdb9c5805a543$var$InteractionRequiredAuthErrorMessages = {
    [(0, $0da9c4dbbd48f7df$export$e408b083cd212696)]: "No refresh token found in the cache. Please sign-in.",
    [(0, $0da9c4dbbd48f7df$export$3bf2eb3358f5f570)]: "The requested account is not available in the native broker. It may have been deleted or logged out. Please sign-in again using an interactive API.",
    [(0, $0da9c4dbbd48f7df$export$a90e8b9c10991b49)]: "Refresh token has expired.",
    [(0, $0da9c4dbbd48f7df$export$2e3666c77d45a4da)]: "Identity provider returned bad_token due to an expired or invalid refresh token. Please invoke an interactive API to resolve."
};
/**
 * Interaction required errors defined by the SDK
 * @deprecated Use InteractionRequiredAuthErrorCodes instead
 */ const $b3acdb9c5805a543$export$d44d3b7b7a580eb6 = {
    noTokensFoundError: {
        code: (0, $0da9c4dbbd48f7df$export$e408b083cd212696),
        desc: $b3acdb9c5805a543$var$InteractionRequiredAuthErrorMessages[0, $0da9c4dbbd48f7df$export$e408b083cd212696]
    },
    native_account_unavailable: {
        code: (0, $0da9c4dbbd48f7df$export$3bf2eb3358f5f570),
        desc: $b3acdb9c5805a543$var$InteractionRequiredAuthErrorMessages[0, $0da9c4dbbd48f7df$export$3bf2eb3358f5f570]
    },
    bad_token: {
        code: (0, $0da9c4dbbd48f7df$export$2e3666c77d45a4da),
        desc: $b3acdb9c5805a543$var$InteractionRequiredAuthErrorMessages[0, $0da9c4dbbd48f7df$export$2e3666c77d45a4da]
    }
};
/**
 * Error thrown when user interaction is required.
 */ class $b3acdb9c5805a543$export$6ba3e818c6bc76ba extends (0, $40da14d5d49dd285$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage, subError, timestamp, traceId, correlationId, claims, errorNo){
        super(errorCode, errorMessage, subError);
        Object.setPrototypeOf(this, $b3acdb9c5805a543$export$6ba3e818c6bc76ba.prototype);
        this.timestamp = timestamp || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        this.traceId = traceId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        this.correlationId = correlationId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        this.claims = claims || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        this.name = "InteractionRequiredAuthError";
        this.errorNo = errorNo;
    }
}
/**
 * Helper function used to determine if an error thrown by the server requires interaction to resolve
 * @param errorCode
 * @param errorString
 * @param subError
 */ function $b3acdb9c5805a543$export$376c3c4c19cb933a(errorCode, errorString, subError) {
    const isInteractionRequiredErrorCode = !!errorCode && $b3acdb9c5805a543$export$e16d6a6c677acec5.indexOf(errorCode) > -1;
    const isInteractionRequiredSubError = !!subError && $b3acdb9c5805a543$export$9689959ec6716811.indexOf(subError) > -1;
    const isInteractionRequiredErrorDesc = !!errorString && $b3acdb9c5805a543$export$e16d6a6c677acec5.some((irErrorCode)=>{
        return errorString.indexOf(irErrorCode) > -1;
    });
    return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
}
/**
 * Creates an InteractionRequiredAuthError
 */ function $b3acdb9c5805a543$export$8f7a741750c16535(errorCode) {
    return new $b3acdb9c5805a543$export$6ba3e818c6bc76ba(errorCode, $b3acdb9c5805a543$var$InteractionRequiredAuthErrorMessages[errorCode]);
}




/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $i5lfL = parcelRequire("i5lfL");
/*! @azure/msal-common v14.16.0 2024-11-05 */ 
/*! @azure/msal-common v14.16.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 
var $e3d0d7a1f8aeb2d2$exports = {};

$parcel$export($e3d0d7a1f8aeb2d2$exports, "clientInfoDecodingError", function () { return $e3d0d7a1f8aeb2d2$export$ccdf48c387c47b82; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "clientInfoEmptyError", function () { return $e3d0d7a1f8aeb2d2$export$12315251e24e0181; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "tokenParsingError", function () { return $e3d0d7a1f8aeb2d2$export$ad362b2e3a260143; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "nullOrEmptyToken", function () { return $e3d0d7a1f8aeb2d2$export$78d01e29cb494be2; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "endpointResolutionError", function () { return $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "networkError", function () { return $e3d0d7a1f8aeb2d2$export$4358cbadf08aa73; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "openIdConfigError", function () { return $e3d0d7a1f8aeb2d2$export$73566da29bc073eb; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "hashNotDeserialized", function () { return $e3d0d7a1f8aeb2d2$export$14c4d54a8414667f; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "invalidState", function () { return $e3d0d7a1f8aeb2d2$export$72a77317632c052b; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "stateMismatch", function () { return $e3d0d7a1f8aeb2d2$export$6a56d8f882843cd8; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "stateNotFound", function () { return $e3d0d7a1f8aeb2d2$export$ef9214cfa5960fc; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "nonceMismatch", function () { return $e3d0d7a1f8aeb2d2$export$edd0491c2c280be7; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "authTimeNotFound", function () { return $e3d0d7a1f8aeb2d2$export$43356944266c945e; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "maxAgeTranspired", function () { return $e3d0d7a1f8aeb2d2$export$f95fb86904f89749; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "multipleMatchingTokens", function () { return $e3d0d7a1f8aeb2d2$export$47c50a2451614107; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "multipleMatchingAccounts", function () { return $e3d0d7a1f8aeb2d2$export$2804a8b1b4c3be8b; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "multipleMatchingAppMetadata", function () { return $e3d0d7a1f8aeb2d2$export$575bb2924bcd0084; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "requestCannotBeMade", function () { return $e3d0d7a1f8aeb2d2$export$4ac9fb1f531eded7; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "cannotRemoveEmptyScope", function () { return $e3d0d7a1f8aeb2d2$export$f7a276c01beb068a; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "cannotAppendScopeSet", function () { return $e3d0d7a1f8aeb2d2$export$93883786cf4a4a27; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "emptyInputScopeSet", function () { return $e3d0d7a1f8aeb2d2$export$41e2ce5958c42c83; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "deviceCodePollingCancelled", function () { return $e3d0d7a1f8aeb2d2$export$e3af42f9856ab2a; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "deviceCodeExpired", function () { return $e3d0d7a1f8aeb2d2$export$c0ef55deeb5e30d5; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "deviceCodeUnknownError", function () { return $e3d0d7a1f8aeb2d2$export$4a9e9cce395ba70c; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "noAccountInSilentRequest", function () { return $e3d0d7a1f8aeb2d2$export$5a3c7d1c90ac9220; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "invalidCacheRecord", function () { return $e3d0d7a1f8aeb2d2$export$d396103576f879cc; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "invalidCacheEnvironment", function () { return $e3d0d7a1f8aeb2d2$export$dedc648643245fa1; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "noAccountFound", function () { return $e3d0d7a1f8aeb2d2$export$b98ebfe073f0162f; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "noCryptoObject", function () { return $e3d0d7a1f8aeb2d2$export$c39e501a22cba395; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "unexpectedCredentialType", function () { return $e3d0d7a1f8aeb2d2$export$21fdd1f95350cd6d; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "invalidAssertion", function () { return $e3d0d7a1f8aeb2d2$export$e168896c692fb06b; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "invalidClientCredential", function () { return $e3d0d7a1f8aeb2d2$export$c483ba88a47982b1; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "tokenRefreshRequired", function () { return $e3d0d7a1f8aeb2d2$export$e23b692cce0c7779; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "userTimeoutReached", function () { return $e3d0d7a1f8aeb2d2$export$afbb99ff17e87b86; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "tokenClaimsCnfRequiredForSignedJwt", function () { return $e3d0d7a1f8aeb2d2$export$6f89b8a7d491b526; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "authorizationCodeMissingFromServerResponse", function () { return $e3d0d7a1f8aeb2d2$export$93625fc864d26bba; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "bindingKeyNotRemoved", function () { return $e3d0d7a1f8aeb2d2$export$5765db5d84418d29; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "endSessionEndpointNotSupported", function () { return $e3d0d7a1f8aeb2d2$export$c3bd741c16a889f3; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "keyIdMissing", function () { return $e3d0d7a1f8aeb2d2$export$3c9338a50e294d1; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "noNetworkConnectivity", function () { return $e3d0d7a1f8aeb2d2$export$31ae862f18c3b2b7; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "userCanceled", function () { return $e3d0d7a1f8aeb2d2$export$8ee329e65a880ec7; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "missingTenantIdError", function () { return $e3d0d7a1f8aeb2d2$export$8c321d057617a458; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "methodNotImplemented", function () { return $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22; });
$parcel$export($e3d0d7a1f8aeb2d2$exports, "nestedAppAuthBridgeDisabled", function () { return $e3d0d7a1f8aeb2d2$export$3078b0202fe7eea3; });
/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $e3d0d7a1f8aeb2d2$export$ccdf48c387c47b82 = "client_info_decoding_error";
const $e3d0d7a1f8aeb2d2$export$12315251e24e0181 = "client_info_empty_error";
const $e3d0d7a1f8aeb2d2$export$ad362b2e3a260143 = "token_parsing_error";
const $e3d0d7a1f8aeb2d2$export$78d01e29cb494be2 = "null_or_empty_token";
const $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3 = "endpoints_resolution_error";
const $e3d0d7a1f8aeb2d2$export$4358cbadf08aa73 = "network_error";
const $e3d0d7a1f8aeb2d2$export$73566da29bc073eb = "openid_config_error";
const $e3d0d7a1f8aeb2d2$export$14c4d54a8414667f = "hash_not_deserialized";
const $e3d0d7a1f8aeb2d2$export$72a77317632c052b = "invalid_state";
const $e3d0d7a1f8aeb2d2$export$6a56d8f882843cd8 = "state_mismatch";
const $e3d0d7a1f8aeb2d2$export$ef9214cfa5960fc = "state_not_found";
const $e3d0d7a1f8aeb2d2$export$edd0491c2c280be7 = "nonce_mismatch";
const $e3d0d7a1f8aeb2d2$export$43356944266c945e = "auth_time_not_found";
const $e3d0d7a1f8aeb2d2$export$f95fb86904f89749 = "max_age_transpired";
const $e3d0d7a1f8aeb2d2$export$47c50a2451614107 = "multiple_matching_tokens";
const $e3d0d7a1f8aeb2d2$export$2804a8b1b4c3be8b = "multiple_matching_accounts";
const $e3d0d7a1f8aeb2d2$export$575bb2924bcd0084 = "multiple_matching_appMetadata";
const $e3d0d7a1f8aeb2d2$export$4ac9fb1f531eded7 = "request_cannot_be_made";
const $e3d0d7a1f8aeb2d2$export$f7a276c01beb068a = "cannot_remove_empty_scope";
const $e3d0d7a1f8aeb2d2$export$93883786cf4a4a27 = "cannot_append_scopeset";
const $e3d0d7a1f8aeb2d2$export$41e2ce5958c42c83 = "empty_input_scopeset";
const $e3d0d7a1f8aeb2d2$export$e3af42f9856ab2a = "device_code_polling_cancelled";
const $e3d0d7a1f8aeb2d2$export$c0ef55deeb5e30d5 = "device_code_expired";
const $e3d0d7a1f8aeb2d2$export$4a9e9cce395ba70c = "device_code_unknown_error";
const $e3d0d7a1f8aeb2d2$export$5a3c7d1c90ac9220 = "no_account_in_silent_request";
const $e3d0d7a1f8aeb2d2$export$d396103576f879cc = "invalid_cache_record";
const $e3d0d7a1f8aeb2d2$export$dedc648643245fa1 = "invalid_cache_environment";
const $e3d0d7a1f8aeb2d2$export$b98ebfe073f0162f = "no_account_found";
const $e3d0d7a1f8aeb2d2$export$c39e501a22cba395 = "no_crypto_object";
const $e3d0d7a1f8aeb2d2$export$21fdd1f95350cd6d = "unexpected_credential_type";
const $e3d0d7a1f8aeb2d2$export$e168896c692fb06b = "invalid_assertion";
const $e3d0d7a1f8aeb2d2$export$c483ba88a47982b1 = "invalid_client_credential";
const $e3d0d7a1f8aeb2d2$export$e23b692cce0c7779 = "token_refresh_required";
const $e3d0d7a1f8aeb2d2$export$afbb99ff17e87b86 = "user_timeout_reached";
const $e3d0d7a1f8aeb2d2$export$6f89b8a7d491b526 = "token_claims_cnf_required_for_signedjwt";
const $e3d0d7a1f8aeb2d2$export$93625fc864d26bba = "authorization_code_missing_from_server_response";
const $e3d0d7a1f8aeb2d2$export$5765db5d84418d29 = "binding_key_not_removed";
const $e3d0d7a1f8aeb2d2$export$c3bd741c16a889f3 = "end_session_endpoint_not_supported";
const $e3d0d7a1f8aeb2d2$export$3c9338a50e294d1 = "key_id_missing";
const $e3d0d7a1f8aeb2d2$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $e3d0d7a1f8aeb2d2$export$8ee329e65a880ec7 = "user_canceled";
const $e3d0d7a1f8aeb2d2$export$8c321d057617a458 = "missing_tenant_id_error";
const $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22 = "method_not_implemented";
const $e3d0d7a1f8aeb2d2$export$3078b0202fe7eea3 = "nested_app_auth_bridge_disabled";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $054a0a060cbfdbdc$export$8190ec70cbf7ec08 = {
    [(0, $e3d0d7a1f8aeb2d2$export$ccdf48c387c47b82)]: "The client info could not be parsed/decoded correctly",
    [(0, $e3d0d7a1f8aeb2d2$export$12315251e24e0181)]: "The client info was empty",
    [(0, $e3d0d7a1f8aeb2d2$export$ad362b2e3a260143)]: "Token cannot be parsed",
    [(0, $e3d0d7a1f8aeb2d2$export$78d01e29cb494be2)]: "The token is null or empty",
    [(0, $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3)]: "Endpoints cannot be resolved",
    [(0, $e3d0d7a1f8aeb2d2$export$4358cbadf08aa73)]: "Network request failed",
    [(0, $e3d0d7a1f8aeb2d2$export$73566da29bc073eb)]: "Could not retrieve endpoints. Check your authority and verify the .well-known/openid-configuration endpoint returns the required endpoints.",
    [(0, $e3d0d7a1f8aeb2d2$export$14c4d54a8414667f)]: "The hash parameters could not be deserialized",
    [(0, $e3d0d7a1f8aeb2d2$export$72a77317632c052b)]: "State was not the expected format",
    [(0, $e3d0d7a1f8aeb2d2$export$6a56d8f882843cd8)]: "State mismatch error",
    [(0, $e3d0d7a1f8aeb2d2$export$ef9214cfa5960fc)]: "State not found",
    [(0, $e3d0d7a1f8aeb2d2$export$edd0491c2c280be7)]: "Nonce mismatch error",
    [(0, $e3d0d7a1f8aeb2d2$export$43356944266c945e)]: "Max Age was requested and the ID token is missing the auth_time variable. auth_time is an optional claim and is not enabled by default - it must be enabled. See https://aka.ms/msaljs/optional-claims for more information.",
    [(0, $e3d0d7a1f8aeb2d2$export$f95fb86904f89749)]: "Max Age is set to 0, or too much time has elapsed since the last end-user authentication.",
    [(0, $e3d0d7a1f8aeb2d2$export$47c50a2451614107)]: "The cache contains multiple tokens satisfying the requirements. Call AcquireToken again providing more requirements such as authority or account.",
    [(0, $e3d0d7a1f8aeb2d2$export$2804a8b1b4c3be8b)]: "The cache contains multiple accounts satisfying the given parameters. Please pass more info to obtain the correct account",
    [(0, $e3d0d7a1f8aeb2d2$export$575bb2924bcd0084)]: "The cache contains multiple appMetadata satisfying the given parameters. Please pass more info to obtain the correct appMetadata",
    [(0, $e3d0d7a1f8aeb2d2$export$4ac9fb1f531eded7)]: "Token request cannot be made without authorization code or refresh token.",
    [(0, $e3d0d7a1f8aeb2d2$export$f7a276c01beb068a)]: "Cannot remove null or empty scope from ScopeSet",
    [(0, $e3d0d7a1f8aeb2d2$export$93883786cf4a4a27)]: "Cannot append ScopeSet",
    [(0, $e3d0d7a1f8aeb2d2$export$41e2ce5958c42c83)]: "Empty input ScopeSet cannot be processed",
    [(0, $e3d0d7a1f8aeb2d2$export$e3af42f9856ab2a)]: "Caller has cancelled token endpoint polling during device code flow by setting DeviceCodeRequest.cancel = true.",
    [(0, $e3d0d7a1f8aeb2d2$export$c0ef55deeb5e30d5)]: "Device code is expired.",
    [(0, $e3d0d7a1f8aeb2d2$export$4a9e9cce395ba70c)]: "Device code stopped polling for unknown reasons.",
    [(0, $e3d0d7a1f8aeb2d2$export$5a3c7d1c90ac9220)]: "Please pass an account object, silent flow is not supported without account information",
    [(0, $e3d0d7a1f8aeb2d2$export$d396103576f879cc)]: "Cache record object was null or undefined.",
    [(0, $e3d0d7a1f8aeb2d2$export$dedc648643245fa1)]: "Invalid environment when attempting to create cache entry",
    [(0, $e3d0d7a1f8aeb2d2$export$b98ebfe073f0162f)]: "No account found in cache for given key.",
    [(0, $e3d0d7a1f8aeb2d2$export$c39e501a22cba395)]: "No crypto object detected.",
    [(0, $e3d0d7a1f8aeb2d2$export$21fdd1f95350cd6d)]: "Unexpected credential type.",
    [(0, $e3d0d7a1f8aeb2d2$export$e168896c692fb06b)]: "Client assertion must meet requirements described in https://tools.ietf.org/html/rfc7515",
    [(0, $e3d0d7a1f8aeb2d2$export$c483ba88a47982b1)]: "Client credential (secret, certificate, or assertion) must not be empty when creating a confidential client. An application should at most have one credential",
    [(0, $e3d0d7a1f8aeb2d2$export$e23b692cce0c7779)]: "Cannot return token from cache because it must be refreshed. This may be due to one of the following reasons: forceRefresh parameter is set to true, claims have been requested, there is no cached access token or it is expired.",
    [(0, $e3d0d7a1f8aeb2d2$export$afbb99ff17e87b86)]: "User defined timeout for device code polling reached",
    [(0, $e3d0d7a1f8aeb2d2$export$6f89b8a7d491b526)]: "Cannot generate a POP jwt if the token_claims are not populated",
    [(0, $e3d0d7a1f8aeb2d2$export$93625fc864d26bba)]: "Server response does not contain an authorization code to proceed",
    [(0, $e3d0d7a1f8aeb2d2$export$5765db5d84418d29)]: "Could not remove the credential's binding key from storage.",
    [(0, $e3d0d7a1f8aeb2d2$export$c3bd741c16a889f3)]: "The provided authority does not support logout",
    [(0, $e3d0d7a1f8aeb2d2$export$3c9338a50e294d1)]: "A keyId value is missing from the requested bound token's cache record and is required to match the token to it's stored binding key.",
    [(0, $e3d0d7a1f8aeb2d2$export$31ae862f18c3b2b7)]: "No network connectivity. Check your internet connection.",
    [(0, $e3d0d7a1f8aeb2d2$export$8ee329e65a880ec7)]: "User cancelled the flow.",
    [(0, $e3d0d7a1f8aeb2d2$export$8c321d057617a458)]: "A tenant id - not common, organizations, or consumers - must be specified when using the client_credentials flow.",
    [(0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22)]: "This method has not been implemented",
    [(0, $e3d0d7a1f8aeb2d2$export$3078b0202fe7eea3)]: "The nested app auth bridge is disabled"
};
/**
 * String constants used by error codes and messages.
 * @deprecated Use ClientAuthErrorCodes instead
 */ const $054a0a060cbfdbdc$export$51eee17394e135b = {
    clientInfoDecodingError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$ccdf48c387c47b82),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$ccdf48c387c47b82]
    },
    clientInfoEmptyError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$12315251e24e0181),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$12315251e24e0181]
    },
    tokenParsingError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$ad362b2e3a260143),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$ad362b2e3a260143]
    },
    nullOrEmptyToken: {
        code: (0, $e3d0d7a1f8aeb2d2$export$78d01e29cb494be2),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$78d01e29cb494be2]
    },
    endpointResolutionError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3]
    },
    networkError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$4358cbadf08aa73),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$4358cbadf08aa73]
    },
    unableToGetOpenidConfigError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$73566da29bc073eb),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$73566da29bc073eb]
    },
    hashNotDeserialized: {
        code: (0, $e3d0d7a1f8aeb2d2$export$14c4d54a8414667f),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$14c4d54a8414667f]
    },
    invalidStateError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$72a77317632c052b),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$72a77317632c052b]
    },
    stateMismatchError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$6a56d8f882843cd8),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$6a56d8f882843cd8]
    },
    stateNotFoundError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$ef9214cfa5960fc),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$ef9214cfa5960fc]
    },
    nonceMismatchError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$edd0491c2c280be7),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$edd0491c2c280be7]
    },
    authTimeNotFoundError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$43356944266c945e),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$43356944266c945e]
    },
    maxAgeTranspired: {
        code: (0, $e3d0d7a1f8aeb2d2$export$f95fb86904f89749),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$f95fb86904f89749]
    },
    multipleMatchingTokens: {
        code: (0, $e3d0d7a1f8aeb2d2$export$47c50a2451614107),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$47c50a2451614107]
    },
    multipleMatchingAccounts: {
        code: (0, $e3d0d7a1f8aeb2d2$export$2804a8b1b4c3be8b),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$2804a8b1b4c3be8b]
    },
    multipleMatchingAppMetadata: {
        code: (0, $e3d0d7a1f8aeb2d2$export$575bb2924bcd0084),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$575bb2924bcd0084]
    },
    tokenRequestCannotBeMade: {
        code: (0, $e3d0d7a1f8aeb2d2$export$4ac9fb1f531eded7),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$4ac9fb1f531eded7]
    },
    removeEmptyScopeError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$f7a276c01beb068a),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$f7a276c01beb068a]
    },
    appendScopeSetError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$93883786cf4a4a27),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$93883786cf4a4a27]
    },
    emptyInputScopeSetError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$41e2ce5958c42c83),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$41e2ce5958c42c83]
    },
    DeviceCodePollingCancelled: {
        code: (0, $e3d0d7a1f8aeb2d2$export$e3af42f9856ab2a),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$e3af42f9856ab2a]
    },
    DeviceCodeExpired: {
        code: (0, $e3d0d7a1f8aeb2d2$export$c0ef55deeb5e30d5),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$c0ef55deeb5e30d5]
    },
    DeviceCodeUnknownError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$4a9e9cce395ba70c),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$4a9e9cce395ba70c]
    },
    NoAccountInSilentRequest: {
        code: (0, $e3d0d7a1f8aeb2d2$export$5a3c7d1c90ac9220),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$5a3c7d1c90ac9220]
    },
    invalidCacheRecord: {
        code: (0, $e3d0d7a1f8aeb2d2$export$d396103576f879cc),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$d396103576f879cc]
    },
    invalidCacheEnvironment: {
        code: (0, $e3d0d7a1f8aeb2d2$export$dedc648643245fa1),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$dedc648643245fa1]
    },
    noAccountFound: {
        code: (0, $e3d0d7a1f8aeb2d2$export$b98ebfe073f0162f),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$b98ebfe073f0162f]
    },
    noCryptoObj: {
        code: (0, $e3d0d7a1f8aeb2d2$export$c39e501a22cba395),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$c39e501a22cba395]
    },
    unexpectedCredentialType: {
        code: (0, $e3d0d7a1f8aeb2d2$export$21fdd1f95350cd6d),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$21fdd1f95350cd6d]
    },
    invalidAssertion: {
        code: (0, $e3d0d7a1f8aeb2d2$export$e168896c692fb06b),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$e168896c692fb06b]
    },
    invalidClientCredential: {
        code: (0, $e3d0d7a1f8aeb2d2$export$c483ba88a47982b1),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$c483ba88a47982b1]
    },
    tokenRefreshRequired: {
        code: (0, $e3d0d7a1f8aeb2d2$export$e23b692cce0c7779),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$e23b692cce0c7779]
    },
    userTimeoutReached: {
        code: (0, $e3d0d7a1f8aeb2d2$export$afbb99ff17e87b86),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$afbb99ff17e87b86]
    },
    tokenClaimsRequired: {
        code: (0, $e3d0d7a1f8aeb2d2$export$6f89b8a7d491b526),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$6f89b8a7d491b526]
    },
    noAuthorizationCodeFromServer: {
        code: (0, $e3d0d7a1f8aeb2d2$export$93625fc864d26bba),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$93625fc864d26bba]
    },
    bindingKeyNotRemovedError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$5765db5d84418d29),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$5765db5d84418d29]
    },
    logoutNotSupported: {
        code: (0, $e3d0d7a1f8aeb2d2$export$c3bd741c16a889f3),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$c3bd741c16a889f3]
    },
    keyIdMissing: {
        code: (0, $e3d0d7a1f8aeb2d2$export$3c9338a50e294d1),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$3c9338a50e294d1]
    },
    noNetworkConnectivity: {
        code: (0, $e3d0d7a1f8aeb2d2$export$31ae862f18c3b2b7),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$31ae862f18c3b2b7]
    },
    userCanceledError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$8ee329e65a880ec7),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$8ee329e65a880ec7]
    },
    missingTenantIdError: {
        code: (0, $e3d0d7a1f8aeb2d2$export$8c321d057617a458),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$8c321d057617a458]
    },
    nestedAppAuthBridgeDisabled: {
        code: (0, $e3d0d7a1f8aeb2d2$export$3078b0202fe7eea3),
        desc: $054a0a060cbfdbdc$export$8190ec70cbf7ec08[0, $e3d0d7a1f8aeb2d2$export$3078b0202fe7eea3]
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $054a0a060cbfdbdc$export$a839ff85a7957561 extends (0, $40da14d5d49dd285$export$145273558d58e0ac) {
    constructor(errorCode, additionalMessage){
        super(errorCode, additionalMessage ? `${$054a0a060cbfdbdc$export$8190ec70cbf7ec08[errorCode]}: ${additionalMessage}` : $054a0a060cbfdbdc$export$8190ec70cbf7ec08[errorCode]);
        this.name = "ClientAuthError";
        Object.setPrototypeOf(this, $054a0a060cbfdbdc$export$a839ff85a7957561.prototype);
    }
}
function $054a0a060cbfdbdc$export$ea892ce48f5bb4f3(errorCode, additionalMessage) {
    return new $054a0a060cbfdbdc$export$a839ff85a7957561(errorCode, additionalMessage);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */ function $40ea3b2fe13bb092$export$575e1419cfbab7f8(rawClientInfo, base64Decode) {
    if (!rawClientInfo) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$12315251e24e0181));
    try {
        const decodedClientInfo = base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    } catch (e) {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$ccdf48c387c47b82));
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */ function $40ea3b2fe13bb092$export$63508a6d6b7dbe07(homeAccountId) {
    if (!homeAccountId) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$ccdf48c387c47b82));
    const clientInfoParts = homeAccountId.split((0, $e6f7ad11e10d0573$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR, 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING : clientInfoParts[1]
    };
}


/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns true if tenantId matches the utid portion of homeAccountId
 * @param tenantId
 * @param homeAccountId
 * @returns
 */ function $11db744279a82a57$export$bc62fd222eddc2d7(tenantId, homeAccountId) {
    return !!tenantId && !!homeAccountId && tenantId === homeAccountId.split(".")[1];
}
/**
 * Build tenant profile
 * @param homeAccountId - Home account identifier for this account object
 * @param localAccountId - Local account identifer for this account object
 * @param tenantId - Full tenant or organizational id that this account belongs to
 * @param idTokenClaims - Claims from the ID token
 * @returns
 */ function $11db744279a82a57$export$924857724cb21ba4(homeAccountId, localAccountId, tenantId, idTokenClaims) {
    if (idTokenClaims) {
        const { oid: oid, sub: sub, tid: tid, name: name, tfp: tfp, acr: acr } = idTokenClaims;
        /**
         * Since there is no way to determine if the authority is AAD or B2C, we exhaust all the possible claims that can serve as tenant ID with the following precedence:
         * tid - TenantID claim that identifies the tenant that issued the token in AAD. Expected in all AAD ID tokens, not present in B2C ID Tokens.
         * tfp - Trust Framework Policy claim that identifies the policy that was used to authenticate the user. Functions as tenant for B2C scenarios.
         * acr - Authentication Context Class Reference claim used only with older B2C policies. Fallback in case tfp is not present, but likely won't be present anyway.
         */ const tenantId = tid || tfp || acr || "";
        return {
            tenantId: tenantId,
            localAccountId: oid || sub || "",
            name: name,
            isHomeTenant: $11db744279a82a57$export$bc62fd222eddc2d7(tenantId, homeAccountId)
        };
    } else return {
        tenantId: tenantId,
        localAccountId: localAccountId,
        isHomeTenant: $11db744279a82a57$export$bc62fd222eddc2d7(tenantId, homeAccountId)
    };
}
/**
 * Replaces account info that varies by tenant profile sourced from the ID token claims passed in with the tenant-specific account info
 * @param baseAccountInfo
 * @param idTokenClaims
 * @returns
 */ function $11db744279a82a57$export$452a054c78b83dad(baseAccountInfo, tenantProfile, idTokenClaims, idTokenSecret) {
    let updatedAccountInfo = baseAccountInfo;
    // Tenant Profile overrides passed in account info
    if (tenantProfile) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...tenantProfileOverride } = tenantProfile;
        updatedAccountInfo = {
            ...baseAccountInfo,
            ...tenantProfileOverride
        };
    }
    // ID token claims override passed in account info and tenant profile
    if (idTokenClaims) {
        // Ignore isHomeTenant, loginHint, and sid which are part of tenant profile but not base account info
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...claimsSourcedTenantProfile } = $11db744279a82a57$export$924857724cb21ba4(baseAccountInfo.homeAccountId, baseAccountInfo.localAccountId, baseAccountInfo.tenantId, idTokenClaims);
        updatedAccountInfo = {
            ...updatedAccountInfo,
            ...claimsSourcedTenantProfile,
            idTokenClaims: idTokenClaims,
            idToken: idTokenSecret
        };
        return updatedAccountInfo;
    }
    return updatedAccountInfo;
}



/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Authority types supported by MSAL.
 */ const $1075494641e42ac7$export$cd82032b224a3839 = {
    Default: 0,
    Adfs: 1,
    Dsts: 2,
    Ciam: 3
};


/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Gets tenantId from available ID token claims to set as credential realm with the following precedence:
 * 1. tid - if the token is acquired from an Azure AD tenant tid will be present
 * 2. tfp - if the token is acquired from a modern B2C tenant tfp should be present
 * 3. acr - if the token is acquired from a legacy B2C tenant acr should be present
 * Downcased to match the realm case-insensitive comparison requirements
 * @param idTokenClaims
 * @returns
 */ function $01ccbb432865d121$export$8e1decb9a5e2932(idTokenClaims) {
    if (idTokenClaims) {
        const tenantId = idTokenClaims.tid || idTokenClaims.tfp || idTokenClaims.acr;
        return tenantId || null;
    }
    return null;
}


/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Protocol modes supported by MSAL.
 */ const $340831fc14c31b77$export$73a3e3dedd37150d = {
    AAD: "AAD",
    OIDC: "OIDC"
};



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Type that defines required and optional parameters for an Account field (based on universal cache schema implemented by all MSALs).
 *
 * Key : Value Schema
 *
 * Key: <home_account_id>-<environment>-<realm*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      localAccountId: Original tenant-specific accountID, usually used for legacy cases
 *      username: primary username that represents the user, usually corresponds to preferred_username in the v2 endpt
 *      authorityType: Accounts authority type as a string
 *      name: Full name for the account, including given name and family name,
 *      lastModificationTime: last time this entity was modified in the cache
 *      lastModificationApp:
 *      nativeAccountId: Account identifier on the native device
 *      tenantProfiles: Array of tenant profile objects for each tenant that the account has authenticated with in the browser
 * }
 * @internal
 */ class $cdcf39a9eb0ff797$export$680160523e6bfa6a {
    /**
     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
     */ generateAccountId() {
        const accountId = [
            this.homeAccountId,
            this.environment
        ];
        return accountId.join((0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    }
    /**
     * Generate Account Cache Key as per the schema: <home_account_id>-<environment>-<realm*>
     */ generateAccountKey() {
        return $cdcf39a9eb0ff797$export$680160523e6bfa6a.generateAccountCacheKey({
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId
        });
    }
    /**
     * Returns the AccountInfo interface for this account.
     */ getAccountInfo() {
        return {
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId,
            name: this.name,
            nativeAccountId: this.nativeAccountId,
            authorityType: this.authorityType,
            // Deserialize tenant profiles array into a Map
            tenantProfiles: new Map((this.tenantProfiles || []).map((tenantProfile)=>{
                return [
                    tenantProfile.tenantId,
                    tenantProfile
                ];
            }))
        };
    }
    /**
     * Returns true if the account entity is in single tenant format (outdated), false otherwise
     */ isSingleTenant() {
        return !this.tenantProfiles;
    }
    /**
     * Generates account key from interface
     * @param accountInterface
     */ static generateAccountCacheKey(accountInterface) {
        const homeTenantId = accountInterface.homeAccountId.split(".")[1];
        const accountKey = [
            accountInterface.homeAccountId,
            accountInterface.environment || "",
            homeTenantId || accountInterface.tenantId || ""
        ];
        return accountKey.join((0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    }
    /**
     * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
     * @param accountDetails
     */ static createAccount(accountDetails, authority, base64Decode) {
        const account = new $cdcf39a9eb0ff797$export$680160523e6bfa6a();
        if (authority.authorityType === (0, $1075494641e42ac7$export$cd82032b224a3839).Adfs) account.authorityType = (0, $e6f7ad11e10d0573$export$23244fafa2e7f55c).ADFS_ACCOUNT_TYPE;
        else if (authority.protocolMode === (0, $340831fc14c31b77$export$73a3e3dedd37150d).AAD) account.authorityType = (0, $e6f7ad11e10d0573$export$23244fafa2e7f55c).MSSTS_ACCOUNT_TYPE;
        else account.authorityType = (0, $e6f7ad11e10d0573$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        let clientInfo;
        if (accountDetails.clientInfo && base64Decode) clientInfo = (0, $40ea3b2fe13bb092$export$575e1419cfbab7f8)(accountDetails.clientInfo, base64Decode);
        account.clientInfo = accountDetails.clientInfo;
        account.homeAccountId = accountDetails.homeAccountId;
        account.nativeAccountId = accountDetails.nativeAccountId;
        const env = accountDetails.environment || authority && authority.getPreferredCache();
        if (!env) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$dedc648643245fa1));
        account.environment = env;
        // non AAD scenarios can have empty realm
        account.realm = clientInfo?.utid || (0, $01ccbb432865d121$export$8e1decb9a5e2932)(accountDetails.idTokenClaims) || "";
        // How do you account for MSA CID here?
        account.localAccountId = clientInfo?.uid || accountDetails.idTokenClaims?.oid || accountDetails.idTokenClaims?.sub || "";
        /*
         * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
         * In most cases it will contain a single email. This field should not be relied upon if a custom
         * policy is configured to return more than 1 email.
         */ const preferredUsername = accountDetails.idTokenClaims?.preferred_username || accountDetails.idTokenClaims?.upn;
        const email = accountDetails.idTokenClaims?.emails ? accountDetails.idTokenClaims.emails[0] : null;
        account.username = preferredUsername || email || "";
        account.name = accountDetails.idTokenClaims?.name || "";
        account.cloudGraphHostName = accountDetails.cloudGraphHostName;
        account.msGraphHost = accountDetails.msGraphHost;
        if (accountDetails.tenantProfiles) account.tenantProfiles = accountDetails.tenantProfiles;
        else {
            const tenantProfile = (0, $11db744279a82a57$export$924857724cb21ba4)(accountDetails.homeAccountId, account.localAccountId, account.realm, accountDetails.idTokenClaims);
            account.tenantProfiles = [
                tenantProfile
            ];
        }
        return account;
    }
    /**
     * Creates an AccountEntity object from AccountInfo
     * @param accountInfo
     * @param cloudGraphHostName
     * @param msGraphHost
     * @returns
     */ static createFromAccountInfo(accountInfo, cloudGraphHostName, msGraphHost) {
        const account = new $cdcf39a9eb0ff797$export$680160523e6bfa6a();
        account.authorityType = accountInfo.authorityType || (0, $e6f7ad11e10d0573$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        account.homeAccountId = accountInfo.homeAccountId;
        account.localAccountId = accountInfo.localAccountId;
        account.nativeAccountId = accountInfo.nativeAccountId;
        account.realm = accountInfo.tenantId;
        account.environment = accountInfo.environment;
        account.username = accountInfo.username;
        account.name = accountInfo.name;
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        // Serialize tenant profiles map into an array
        account.tenantProfiles = Array.from(accountInfo.tenantProfiles?.values() || []);
        return account;
    }
    /**
     * Generate HomeAccountId from server response
     * @param serverClientInfo
     * @param authType
     */ static generateHomeAccountId(serverClientInfo, authType, logger, cryptoObj, idTokenClaims) {
        // since ADFS/DSTS do not have tid and does not set client_info
        if (!(authType === (0, $1075494641e42ac7$export$cd82032b224a3839).Adfs || authType === (0, $1075494641e42ac7$export$cd82032b224a3839).Dsts)) {
            // for cases where there is clientInfo
            if (serverClientInfo) try {
                const clientInfo = (0, $40ea3b2fe13bb092$export$575e1419cfbab7f8)(serverClientInfo, cryptoObj.base64Decode);
                if (clientInfo.uid && clientInfo.utid) return `${clientInfo.uid}.${clientInfo.utid}`;
            } catch (e) {}
            logger.warning("No client info in response");
        }
        // default to "sub" claim
        return idTokenClaims?.sub || "";
    }
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ static isAccountEntity(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("localAccountId") && entity.hasOwnProperty("username") && entity.hasOwnProperty("authorityType");
    }
    /**
     * Helper function to determine whether 2 accountInfo objects represent the same account
     * @param accountA
     * @param accountB
     * @param compareClaims - If set to true idTokenClaims will also be compared to determine account equality
     */ static accountInfoIsEqual(accountA, accountB, compareClaims) {
        if (!accountA || !accountB) return false;
        let claimsMatch = true; // default to true so as to not fail comparison below if compareClaims: false
        if (compareClaims) {
            const accountAClaims = accountA.idTokenClaims || {};
            const accountBClaims = accountB.idTokenClaims || {};
            // issued at timestamp and nonce are expected to change each time a new id token is acquired
            claimsMatch = accountAClaims.iat === accountBClaims.iat && accountAClaims.nonce === accountBClaims.nonce;
        }
        return accountA.homeAccountId === accountB.homeAccountId && accountA.localAccountId === accountB.localAccountId && accountA.username === accountB.username && accountA.tenantId === accountB.tenantId && accountA.environment === accountB.environment && accountA.nativeAccountId === accountB.nativeAccountId && claimsMatch;
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $2fcd86b89cf5522a$var$getAccount(instance, accountIdentifiers) {
    if (!accountIdentifiers || !accountIdentifiers.homeAccountId && !accountIdentifiers.localAccountId && !accountIdentifiers.username) // If no account identifiers are provided, return active account
    return instance.getActiveAccount();
    return (0, $6ff7d7464b194504$export$fa581286d49c51db)(instance.getAllAccounts(), accountIdentifiers);
}
/**
 * Given 1 or more accountIdentifiers, returns the Account object if the user is signed-in
 * @param accountIdentifiers
 */ function $2fcd86b89cf5522a$export$83a8e409853da004(accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const [account, setAccount] = (0, $i5lfL.useState)(()=>$2fcd86b89cf5522a$var$getAccount(instance, accountIdentifiers));
    (0, $i5lfL.useEffect)(()=>{
        setAccount((currentAccount)=>{
            const nextAccount = $2fcd86b89cf5522a$var$getAccount(instance, accountIdentifiers);
            if (!(0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).accountInfoIsEqual(currentAccount, nextAccount, true)) {
                logger.info("useAccount - Updating account");
                return nextAccount;
            }
            return currentAccount;
        });
    }, [
        inProgress,
        accountIdentifiers,
        instance,
        logger
    ]);
    return account;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $1190bfdc50d03d11$export$a77ea62d722c2a73 = {
    invalidInteractionType: {
        code: "invalid_interaction_type",
        desc: "The provided interaction type is invalid."
    },
    unableToFallbackToInteraction: {
        code: "unable_to_fallback_to_interaction",
        desc: "Interaction is required but another interaction is already in progress. Please try again when the current interaction is complete."
    }
};
class $1190bfdc50d03d11$export$2aa0f0a55de712e6 extends (0, $40da14d5d49dd285$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        Object.setPrototypeOf(this, $1190bfdc50d03d11$export$2aa0f0a55de712e6.prototype);
        this.name = "ReactAuthError";
    }
    static createInvalidInteractionTypeError() {
        return new $1190bfdc50d03d11$export$2aa0f0a55de712e6($1190bfdc50d03d11$export$a77ea62d722c2a73.invalidInteractionType.code, $1190bfdc50d03d11$export$a77ea62d722c2a73.invalidInteractionType.desc);
    }
    static createUnableToFallbackToInteractionError() {
        return new $1190bfdc50d03d11$export$2aa0f0a55de712e6($1190bfdc50d03d11$export$a77ea62d722c2a73.unableToFallbackToInteraction.code, $1190bfdc50d03d11$export$a77ea62d722c2a73.unableToFallbackToInteraction.desc);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * If a user is not currently signed in this hook invokes a login. Failed logins can be retried using the login callback returned.
 * If a user is currently signed in this hook attempts to acquire a token. Subsequent token requests can use the acquireToken callback returned.
 * Optionally provide a request object to be used in the login/acquireToken call.
 * Optionally provide a specific user that should be logged in.
 * @param interactionType
 * @param authenticationRequest
 * @param accountIdentifiers
 */ function $486a5ac61cde2333$export$d130d543558e611f(interactionType, authenticationRequest, accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const isAuthenticated = (0, $91b77ab8667707a4$export$7e9c60d6d1836c84)(accountIdentifiers);
    const account = (0, $2fcd86b89cf5522a$export$83a8e409853da004)(accountIdentifiers);
    const [[result, error], setResponse] = (0, $i5lfL.useState)([
        null,
        null
    ]);
    // Used to prevent state updates after unmount
    const mounted = (0, $i5lfL.useRef)(true);
    (0, $i5lfL.useEffect)(()=>{
        return ()=>{
            mounted.current = false;
        };
    }, []);
    // Boolean used to check if interaction is in progress in acquireTokenSilent fallback. Use Ref instead of state to prevent acquireToken function from being regenerated on each change to interactionInProgress value
    const interactionInProgress = (0, $i5lfL.useRef)(inProgress !== (0, $e195f599725a9f25$export$bec20eda0179362b).None);
    (0, $i5lfL.useEffect)(()=>{
        interactionInProgress.current = inProgress !== (0, $e195f599725a9f25$export$bec20eda0179362b).None;
    }, [
        inProgress
    ]);
    // Flag used to control when the hook calls login/acquireToken
    const shouldAcquireToken = (0, $i5lfL.useRef)(true);
    (0, $i5lfL.useEffect)(()=>{
        if (!!error) {
            // Errors should be handled by consuming component
            shouldAcquireToken.current = false;
            return;
        }
        if (!!result) {
            // Token has already been acquired, consuming component/application is responsible for renewing
            shouldAcquireToken.current = false;
            return;
        }
    }, [
        error,
        result
    ]);
    const login = (0, $i5lfL.useCallback)(async (callbackInteractionType, callbackRequest)=>{
        const loginType = callbackInteractionType || interactionType;
        const loginRequest = callbackRequest || authenticationRequest;
        switch(loginType){
            case (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup:
                logger.verbose("useMsalAuthentication - Calling loginPopup");
                return instance.loginPopup(loginRequest);
            case (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect:
                // This promise is not expected to resolve due to full frame redirect
                logger.verbose("useMsalAuthentication - Calling loginRedirect");
                return instance.loginRedirect(loginRequest).then(null);
            case (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent:
                logger.verbose("useMsalAuthentication - Calling ssoSilent");
                return instance.ssoSilent(loginRequest);
            default:
                throw (0, $1190bfdc50d03d11$export$2aa0f0a55de712e6).createInvalidInteractionTypeError();
        }
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger
    ]);
    const acquireToken = (0, $i5lfL.useCallback)(async (callbackInteractionType, callbackRequest)=>{
        const fallbackInteractionType = callbackInteractionType || interactionType;
        let tokenRequest;
        if (callbackRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the callback");
            tokenRequest = {
                ...callbackRequest
            };
        } else if (authenticationRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the hook");
            tokenRequest = {
                ...authenticationRequest,
                scopes: authenticationRequest.scopes || (0, $e6f7ad11e10d0573$export$893b1b5b686d84ef)
            };
        } else {
            logger.trace("useMsalAuthentication - acquireToken - No request object provided, using default request.");
            tokenRequest = {
                scopes: (0, $e6f7ad11e10d0573$export$893b1b5b686d84ef)
            };
        }
        if (!tokenRequest.account && account) {
            logger.trace("useMsalAuthentication - acquireToken - Attaching account to request");
            tokenRequest.account = account;
        }
        const getToken = async ()=>{
            logger.verbose("useMsalAuthentication - Calling acquireTokenSilent");
            return instance.acquireTokenSilent(tokenRequest).catch(async (e)=>{
                if (e instanceof (0, $b3acdb9c5805a543$export$6ba3e818c6bc76ba)) {
                    if (!interactionInProgress.current) {
                        logger.error("useMsalAuthentication - Interaction required, falling back to interaction");
                        return login(fallbackInteractionType, tokenRequest);
                    } else {
                        logger.error("useMsalAuthentication - Interaction required but is already in progress. Please try again, if needed, after interaction completes.");
                        throw (0, $1190bfdc50d03d11$export$2aa0f0a55de712e6).createUnableToFallbackToInteractionError();
                    }
                }
                throw e;
            });
        };
        return getToken().then((response)=>{
            if (mounted.current) setResponse([
                response,
                null
            ]);
            return response;
        }).catch((e)=>{
            if (mounted.current) setResponse([
                null,
                e
            ]);
            throw e;
        });
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger,
        account,
        login
    ]);
    (0, $i5lfL.useEffect)(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            switch(message.eventType){
                case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGIN_SUCCESS:
                case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).SSO_SILENT_SUCCESS:
                    if (message.payload) setResponse([
                        message.payload,
                        null
                    ]);
                    break;
                case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGIN_FAILURE:
                case (0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).SSO_SILENT_FAILURE:
                    if (message.error) setResponse([
                        null,
                        message.error
                    ]);
                    break;
            }
        });
        logger.verbose(`useMsalAuthentication - Registered event callback with id: ${callbackId}`);
        return ()=>{
            if (callbackId) {
                logger.verbose(`useMsalAuthentication - Removing event callback ${callbackId}`);
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (shouldAcquireToken.current && inProgress === (0, $e195f599725a9f25$export$bec20eda0179362b).None) {
            shouldAcquireToken.current = false;
            if (!isAuthenticated) {
                logger.info("useMsalAuthentication - No user is authenticated, attempting to login");
                login().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            } else if (account) {
                logger.info("useMsalAuthentication - User is authenticated, attempting to acquire token");
                acquireToken().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            }
        }
    }, [
        isAuthenticated,
        account,
        inProgress,
        login,
        acquireToken,
        logger
    ]);
    return {
        login: login,
        acquireToken: acquireToken,
        result: result,
        error: error
    };
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Attempts to authenticate user if not already authenticated, then renders child components
 * @param props
 */ function $8ce7dc5b515616d3$export$c9cd7a02d4bd7707({ interactionType: interactionType, username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, authenticationRequest: authenticationRequest, loadingComponent: LoadingComponent, errorComponent: ErrorComponent, children: children }) {
    const accountIdentifier = (0, $i5lfL.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const context = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const msalAuthResult = (0, $486a5ac61cde2333$export$d130d543558e611f)(interactionType, authenticationRequest, accountIdentifier);
    const isAuthenticated = (0, $91b77ab8667707a4$export$7e9c60d6d1836c84)(accountIdentifier);
    if (msalAuthResult.error && context.inProgress === (0, $e195f599725a9f25$export$bec20eda0179362b).None) {
        if (!!ErrorComponent) return (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement(ErrorComponent, {
            ...msalAuthResult
        });
        throw msalAuthResult.error;
    }
    if (isAuthenticated) return (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).Fragment, null, (0, $6ff7d7464b194504$export$7a39d5906c5d6010)(children, msalAuthResult));
    if (!!LoadingComponent && context.inProgress !== (0, $e195f599725a9f25$export$bec20eda0179362b).None) return (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement(LoadingComponent, {
        ...context
    });
    return null;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $i5lfL = parcelRequire("i5lfL");

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Higher order component wraps provided component with msal by injecting msal context values into the component's props
 * @param Component
 */ const $fc823e8e7bcda0a8$export$8dea26c30ebc61cd = (Component)=>{
    const ComponentWithMsal = (props)=>{
        const msal = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement(Component, {
            ...props,
            msalContext: msal
        });
    };
    const componentName = Component.displayName || Component.name || "Component";
    ComponentWithMsal.displayName = `withMsal(${componentName})`;
    return ComponentWithMsal;
};







'use strict';



var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kp44S = parcelRequire("kp44S");

var $1CWiu = parcelRequire("1CWiu");
parcelRequire("i5lfL");

parcelRequire("i5lfL");


var $7yrkh = parcelRequire("7yrkh");

var $8mN0u = parcelRequire("8mN0u");

'use client';
const $99d6713ec469aabd$export$35e57303dbd8a66 = (0, $8mN0u.default)();
function $99d6713ec469aabd$var$useTheme(defaultTheme = $99d6713ec469aabd$export$35e57303dbd8a66) {
    return (0, $67100f958c8d60e0$export$2e2bcd8739ae039)(defaultTheme);
}
var $99d6713ec469aabd$export$2e2bcd8739ae039 = $99d6713ec469aabd$var$useTheme;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
function $4e3bc59806b80da1$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $99d6713ec469aabd$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $7yrkh.default), {
        styles: globalStyles
    });
}
var $4e3bc59806b80da1$export$2e2bcd8739ae039 = $4e3bc59806b80da1$var$GlobalStyles;



var $4M4EV = parcelRequire("4M4EV");

var $5xV56 = parcelRequire("5xV56");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
function $9583ec3111a78f3f$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $4e3bc59806b80da1$export$2e2bcd8739ae039), (0, $1CWiu.default)({}, props, {
        defaultTheme: (0, $4M4EV.default),
        themeId: (0, $5xV56.default)
    }));
}
var $9583ec3111a78f3f$export$2e2bcd8739ae039 = $9583ec3111a78f3f$var$GlobalStyles;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $1b9724080349944a$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $1CWiu.default)({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%'
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $1b9724080349944a$export$32180ef41b15b513 = (theme)=>(0, $1CWiu.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $1b9724080349944a$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, '')] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $1CWiu.default)({
        html: $1b9724080349944a$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $1CWiu.default)({
            margin: 0
        }, $1b9724080349944a$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $1b9724080349944a$var$CssBaseline(inProps) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $9583ec3111a78f3f$export$2e2bcd8739ae039), {
                styles: (theme)=>$1b9724080349944a$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $1b9724080349944a$export$2e2bcd8739ae039 = $1b9724080349944a$var$CssBaseline;


/*
 * Copyright (c) 2023. RoZetta Technology Pty Ltd. All rights reserved.
 */ 
var $bHJbJ = parcelRequire("bHJbJ");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $dR0I7 = parcelRequire("dR0I7");

var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");

var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $kp44S = parcelRequire("kp44S");

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");



var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $i5lfL = parcelRequire("i5lfL");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $ef4fd0edd5f8d0dd$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $2a4bb72baa6497d0$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $i5lfL.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $ef4fd0edd5f8d0dd$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $62d6b27df8327466$export$2e2bcd8739ae039 = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039);



var $i5lfL = parcelRequire("i5lfL");

var $i5lfL = parcelRequire("i5lfL");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $5e41edb128c5ed2a$var$useEnhancedEffect = typeof window !== 'undefined' ? $i5lfL.useLayoutEffect : $i5lfL.useEffect;
var $5e41edb128c5ed2a$export$2e2bcd8739ae039 = $5e41edb128c5ed2a$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $49175dc6d5053977$var$useEventCallback(fn) {
    const ref = $i5lfL.useRef(fn);
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $i5lfL.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $49175dc6d5053977$export$2e2bcd8739ae039 = $49175dc6d5053977$var$useEventCallback;


'use client';
var $91b1a2d3fafb0346$export$2e2bcd8739ae039 = (0, $49175dc6d5053977$export$2e2bcd8739ae039);



var $i5lfL = parcelRequire("i5lfL");

var $i5lfL = parcelRequire("i5lfL");
'use client';
const $1538ae8a8c443638$var$UNINITIALIZED = {};
function $1538ae8a8c443638$export$2e2bcd8739ae039(init, initArg) {
    const ref = $i5lfL.useRef($1538ae8a8c443638$var$UNINITIALIZED);
    if (ref.current === $1538ae8a8c443638$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $i5lfL = parcelRequire("i5lfL");
'use client';
const $28e4ccf3bdbf8973$var$EMPTY = [];
function $28e4ccf3bdbf8973$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $i5lfL.useEffect(fn, $28e4ccf3bdbf8973$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $fa9c2cea1dcc0b6d$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $fa9c2cea1dcc0b6d$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $fa9c2cea1dcc0b6d$export$2e2bcd8739ae039() {
    const timeout = (0, $1538ae8a8c443638$export$2e2bcd8739ae039)($fa9c2cea1dcc0b6d$export$786b4da70f00938b.create).current;
    (0, $28e4ccf3bdbf8973$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $df37cafd1971519c$var$hadKeyboardEvent = true;
let $df37cafd1971519c$var$hadFocusVisibleRecently = false;
const $df37cafd1971519c$var$hadFocusVisibleRecentlyTimeout = new (0, $fa9c2cea1dcc0b6d$export$786b4da70f00938b)();
const $df37cafd1971519c$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $df37cafd1971519c$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $df37cafd1971519c$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $df37cafd1971519c$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $df37cafd1971519c$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $df37cafd1971519c$var$handlePointerDown() {
    $df37cafd1971519c$var$hadKeyboardEvent = false;
}
function $df37cafd1971519c$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($df37cafd1971519c$var$hadFocusVisibleRecently) $df37cafd1971519c$var$hadKeyboardEvent = true;
    }
}
function $df37cafd1971519c$var$prepare(doc) {
    doc.addEventListener('keydown', $df37cafd1971519c$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $df37cafd1971519c$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $df37cafd1971519c$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $df37cafd1971519c$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $df37cafd1971519c$var$handleVisibilityChange, true);
}
function $df37cafd1971519c$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $df37cafd1971519c$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $df37cafd1971519c$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $df37cafd1971519c$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $df37cafd1971519c$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $df37cafd1971519c$var$handleVisibilityChange, true);
}
function $df37cafd1971519c$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $df37cafd1971519c$var$hadKeyboardEvent || $df37cafd1971519c$var$focusTriggersKeyboardModality(target);
}
function $df37cafd1971519c$export$2e2bcd8739ae039() {
    const ref = $i5lfL.useCallback((node)=>{
        if (node != null) $df37cafd1971519c$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $i5lfL.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $df37cafd1971519c$var$hadFocusVisibleRecently = true;
            $df37cafd1971519c$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $df37cafd1971519c$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($df37cafd1971519c$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $f5d997b9d8ee988c$export$2e2bcd8739ae039 = (0, $df37cafd1971519c$export$2e2bcd8739ae039);



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");
function $ec90aedb1ebccc90$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $6bd5f7c0edda265b$export$2e2bcd8739ae039(t, e) {
    return $6bd5f7c0edda265b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $6bd5f7c0edda265b$export$2e2bcd8739ae039(t, e);
}


function $25ad3ce036029841$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $6bd5f7c0edda265b$export$2e2bcd8739ae039)(t, o);
}




var $i5lfL = parcelRequire("i5lfL");

var $i5lfL = parcelRequire("i5lfL");
var $4b4b5e0feab4d50b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createContext(null);



var $i5lfL = parcelRequire("i5lfL");
function $ad0c7eba903a03af$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $i5lfL.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $i5lfL.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $ad0c7eba903a03af$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $ad0c7eba903a03af$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $ad0c7eba903a03af$export$fa71e2345c31d7a2(props, onExited) {
    return $ad0c7eba903a03af$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $i5lfL.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $ad0c7eba903a03af$var$getProp(child, 'appear', props),
            enter: $ad0c7eba903a03af$var$getProp(child, 'enter', props),
            exit: $ad0c7eba903a03af$var$getProp(child, 'exit', props)
        });
    });
}
function $ad0c7eba903a03af$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $ad0c7eba903a03af$export$bbc8a025727ea824(nextProps.children);
    var children = $ad0c7eba903a03af$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $i5lfL.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $i5lfL.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $i5lfL.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $ad0c7eba903a03af$var$getProp(child, 'exit', nextProps),
            enter: $ad0c7eba903a03af$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $i5lfL.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $i5lfL.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $i5lfL.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $ad0c7eba903a03af$var$getProp(child, 'exit', nextProps),
            enter: $ad0c7eba903a03af$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $a25659da27a85057$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $a25659da27a85057$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $a25659da27a85057$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $25ad3ce036029841$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $ec90aedb1ebccc90$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $ad0c7eba903a03af$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $ad0c7eba903a03af$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $ad0c7eba903a03af$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $1CWiu.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $7qXFD.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $a25659da27a85057$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement((0, $4b4b5e0feab4d50b$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement((0, $4b4b5e0feab4d50b$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).Component);
$a25659da27a85057$var$TransitionGroup.propTypes = {};
$a25659da27a85057$var$TransitionGroup.defaultProps = $a25659da27a85057$var$defaultProps;
var $a25659da27a85057$export$2e2bcd8739ae039 = $a25659da27a85057$var$TransitionGroup;



var $kRbLW = parcelRequire("kRbLW");

var $d8Gg3 = parcelRequire("d8Gg3");


var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
function $d0d6238bccae0651$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $i5lfL.useState(false);
    const rippleClassName = (0, $kRbLW.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $kRbLW.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $i5lfL.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
            className: childClassName
        })
    });
}
var $d0d6238bccae0651$export$2e2bcd8739ae039 = $d0d6238bccae0651$var$Ripple;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $df51962d0fe445c9$export$b464606f735ab902(slot) {
    return (0, $6bbZp.default)('MuiTouchRipple', slot);
}
const $df51962d0fe445c9$var$touchRippleClasses = (0, $47i1c.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $df51962d0fe445c9$export$2e2bcd8739ae039 = $df51962d0fe445c9$var$touchRippleClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $c87b508610289377$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $c87b508610289377$var$_ = (t)=>t, $c87b508610289377$var$_t, $c87b508610289377$var$_t2, $c87b508610289377$var$_t3, $c87b508610289377$var$_t4;
const $c87b508610289377$var$DURATION = 550;
const $c87b508610289377$export$95d0c9356b2231a3 = 80;
const $c87b508610289377$var$enterKeyframe = (0, $d8Gg3.keyframes)($c87b508610289377$var$_t || ($c87b508610289377$var$_t = $c87b508610289377$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $c87b508610289377$var$exitKeyframe = (0, $d8Gg3.keyframes)($c87b508610289377$var$_t2 || ($c87b508610289377$var$_t2 = $c87b508610289377$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $c87b508610289377$var$pulsateKeyframe = (0, $d8Gg3.keyframes)($c87b508610289377$var$_t3 || ($c87b508610289377$var$_t3 = $c87b508610289377$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $c87b508610289377$export$f6b7418508c72c25 = (0, $j7y1Z.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $c87b508610289377$export$676cfe7b12693c4b = (0, $j7y1Z.default)((0, $d0d6238bccae0651$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($c87b508610289377$var$_t4 || ($c87b508610289377$var$_t4 = $c87b508610289377$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $df51962d0fe445c9$export$2e2bcd8739ae039).rippleVisible, $c87b508610289377$var$enterKeyframe, $c87b508610289377$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $df51962d0fe445c9$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $df51962d0fe445c9$export$2e2bcd8739ae039).child, (0, $df51962d0fe445c9$export$2e2bcd8739ae039).childLeaving, $c87b508610289377$var$exitKeyframe, $c87b508610289377$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $df51962d0fe445c9$export$2e2bcd8739ae039).childPulsate, $c87b508610289377$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $c87b508610289377$var$TouchRipple = /*#__PURE__*/ $i5lfL.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $7qXFD.default)(props, $c87b508610289377$var$_excluded);
    const [ripples, setRipples] = $i5lfL.useState([]);
    const nextKey = $i5lfL.useRef(0);
    const rippleCallback = $i5lfL.useRef(null);
    $i5lfL.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $i5lfL.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $fa9c2cea1dcc0b6d$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $i5lfL.useRef(null);
    const container = $i5lfL.useRef(null);
    const startCommit = $i5lfL.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $bHJbJ.jsx)($c87b508610289377$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $kRbLW.default)(classes.ripple, (0, $df51962d0fe445c9$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $kRbLW.default)(classes.rippleVisible, (0, $df51962d0fe445c9$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $kRbLW.default)(classes.ripplePulsate, (0, $df51962d0fe445c9$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $kRbLW.default)(classes.child, (0, $df51962d0fe445c9$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $kRbLW.default)(classes.childLeaving, (0, $df51962d0fe445c9$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $kRbLW.default)(classes.childPulsate, (0, $df51962d0fe445c9$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $c87b508610289377$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $i5lfL.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($c87b508610289377$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $i5lfL.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $i5lfL.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $i5lfL.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($c87b508610289377$export$f6b7418508c72c25, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)((0, $df51962d0fe445c9$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a25659da27a85057$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $c87b508610289377$export$2e2bcd8739ae039 = $c87b508610289377$var$TouchRipple;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $1edb18dd620e5a1a$export$fccb0498dcd99783(slot) {
    return (0, $6bbZp.default)('MuiButtonBase', slot);
}
const $1edb18dd620e5a1a$var$buttonBaseClasses = (0, $47i1c.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $1edb18dd620e5a1a$export$2e2bcd8739ae039 = $1edb18dd620e5a1a$var$buttonBaseClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $07a3ed667acb77f6$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $07a3ed667acb77f6$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $2ktY3.default)(slots, (0, $1edb18dd620e5a1a$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $07a3ed667acb77f6$export$7ec0dcc5e3cdcd36 = (0, $j7y1Z.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $1edb18dd620e5a1a$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $07a3ed667acb77f6$var$ButtonBase = /*#__PURE__*/ $i5lfL.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $7qXFD.default)(props, $07a3ed667acb77f6$var$_excluded);
    const buttonRef = $i5lfL.useRef(null);
    const rippleRef = $i5lfL.useRef(null);
    const handleRippleRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $f5d997b9d8ee988c$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $i5lfL.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $i5lfL.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $i5lfL.useState(false);
    $i5lfL.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $i5lfL.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $91b1a2d3fafb0346$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $91b1a2d3fafb0346$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $i5lfL.useRef(false);
    const handleKeyDown = (0, $91b1a2d3fafb0346$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $91b1a2d3fafb0346$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $1CWiu.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $07a3ed667acb77f6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($07a3ed667acb77f6$export$7ec0dcc5e3cdcd36, (0, $1CWiu.default)({
        as: ComponentProp,
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $bHJbJ.jsx)((0, $c87b508610289377$export$2e2bcd8739ae039), (0, $1CWiu.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $07a3ed667acb77f6$export$2e2bcd8739ae039 = $07a3ed667acb77f6$var$ButtonBase;



var $VEXgj = parcelRequire("VEXgj");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $1241ebc12095535a$export$5a6f9035944c8119(slot) {
    return (0, $6bbZp.default)('MuiButton', slot);
}
const $1241ebc12095535a$var$buttonClasses = (0, $47i1c.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $1241ebc12095535a$export$2e2bcd8739ae039 = $1241ebc12095535a$var$buttonClasses;



var $i5lfL = parcelRequire("i5lfL");
/**
 * @ignore - internal component.
 */ const $60b0bdfd58c2f3dc$var$ButtonGroupContext = /*#__PURE__*/ $i5lfL.createContext({});
var $60b0bdfd58c2f3dc$export$2e2bcd8739ae039 = $60b0bdfd58c2f3dc$var$ButtonGroupContext;



var $i5lfL = parcelRequire("i5lfL");
/**
 * @ignore - internal component.
 */ const $faffb436712427a2$var$ButtonGroupButtonContext = /*#__PURE__*/ $i5lfL.createContext(undefined);
var $faffb436712427a2$export$2e2bcd8739ae039 = $faffb436712427a2$var$ButtonGroupButtonContext;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $304ed6cd037ae0e7$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $304ed6cd037ae0e7$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $VEXgj.default)(color)}`,
            `size${(0, $VEXgj.default)(size)}`,
            `${variant}Size${(0, $VEXgj.default)(size)}`,
            `color${(0, $VEXgj.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $VEXgj.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $VEXgj.default)(size)}`
        ]
    };
    const composedClasses = (0, $2ktY3.default)(slots, (0, $1241ebc12095535a$export$5a6f9035944c8119), classes);
    return (0, $1CWiu.default)({}, classes, composedClasses);
};
const $304ed6cd037ae0e7$var$commonIconStyles = (ownerState)=>(0, $1CWiu.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $304ed6cd037ae0e7$var$ButtonRoot = (0, $j7y1Z.default)((0, $07a3ed667acb77f6$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1FZvT.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $VEXgj.default)(ownerState.color)}`],
            styles[`size${(0, $VEXgj.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $VEXgj.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $1CWiu.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $1CWiu.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8AHNG.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8AHNG.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8AHNG.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $1CWiu.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $1241ebc12095535a$export$2e2bcd8739ae039).focusVisible}`]: (0, $1CWiu.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $1241ebc12095535a$export$2e2bcd8739ae039).disabled}`]: (0, $1CWiu.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $8AHNG.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $1241ebc12095535a$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $1241ebc12095535a$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $304ed6cd037ae0e7$var$ButtonStartIcon = (0, $j7y1Z.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $VEXgj.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $304ed6cd037ae0e7$var$commonIconStyles(ownerState)));
const $304ed6cd037ae0e7$var$ButtonEndIcon = (0, $j7y1Z.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $VEXgj.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $304ed6cd037ae0e7$var$commonIconStyles(ownerState)));
const $304ed6cd037ae0e7$var$Button = /*#__PURE__*/ $i5lfL.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $i5lfL.useContext((0, $60b0bdfd58c2f3dc$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $i5lfL.useContext((0, $faffb436712427a2$export$2e2bcd8739ae039));
    const resolvedProps = (0, $dR0I7.default)(contextProps, inProps);
    const props = (0, $kp44S.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $7qXFD.default)(props, $304ed6cd037ae0e7$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $304ed6cd037ae0e7$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $bHJbJ.jsx)($304ed6cd037ae0e7$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $bHJbJ.jsx)($304ed6cd037ae0e7$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($304ed6cd037ae0e7$var$ButtonRoot, (0, $1CWiu.default)({
        ownerState: ownerState,
        className: (0, $kRbLW.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $kRbLW.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $304ed6cd037ae0e7$export$2e2bcd8739ae039 = $304ed6cd037ae0e7$var$Button;


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $3IE2K = parcelRequire("3IE2K");

var $ggmG3 = parcelRequire("ggmG3");

var $2ktY3 = parcelRequire("2ktY3");


var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");
parcelRequire("i5lfL");


var $4M4EV = parcelRequire("4M4EV");

var $5xV56 = parcelRequire("5xV56");
'use client';
function $d3f129e8e622d35c$export$2e2bcd8739ae039() {
    const theme = (0, $99d6713ec469aabd$export$2e2bcd8739ae039)((0, $4M4EV.default));
    return theme[0, $5xV56.default] || theme;
}



var $i5lfL = parcelRequire("i5lfL");
'use client';
/**
 * @ignore - internal component.
 */ const $dc071cfa7e9e77ac$var$GridContext = /*#__PURE__*/ $i5lfL.createContext();
var $dc071cfa7e9e77ac$export$2e2bcd8739ae039 = $dc071cfa7e9e77ac$var$GridContext;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $4fc10846a2bfa4a1$export$9973ac5fd0181f33(slot) {
    return (0, $6bbZp.default)('MuiGrid', slot);
}
const $4fc10846a2bfa4a1$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $4fc10846a2bfa4a1$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $4fc10846a2bfa4a1$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $4fc10846a2bfa4a1$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $4fc10846a2bfa4a1$var$gridClasses = (0, $47i1c.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$4fc10846a2bfa4a1$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$4fc10846a2bfa4a1$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$4fc10846a2bfa4a1$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$4fc10846a2bfa4a1$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$4fc10846a2bfa4a1$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$4fc10846a2bfa4a1$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$4fc10846a2bfa4a1$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$4fc10846a2bfa4a1$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $4fc10846a2bfa4a1$export$2e2bcd8739ae039 = $4fc10846a2bfa4a1$var$gridClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $b9012d0e7442d60a$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $b9012d0e7442d60a$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $b9012d0e7442d60a$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $3IE2K.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$b9012d0e7442d60a$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $1CWiu.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $b9012d0e7442d60a$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $3IE2K.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $3IE2K.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $4fc10846a2bfa4a1$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $b9012d0e7442d60a$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $b9012d0e7442d60a$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $3IE2K.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $b9012d0e7442d60a$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $3IE2K.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$b9012d0e7442d60a$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $4fc10846a2bfa4a1$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $b9012d0e7442d60a$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $4fc10846a2bfa4a1$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $b9012d0e7442d60a$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $3IE2K.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $b9012d0e7442d60a$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $3IE2K.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$b9012d0e7442d60a$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$b9012d0e7442d60a$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $4fc10846a2bfa4a1$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $b9012d0e7442d60a$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $4fc10846a2bfa4a1$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $b9012d0e7442d60a$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $b9012d0e7442d60a$var$GridRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $b9012d0e7442d60a$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $b9012d0e7442d60a$export$71d4225eeb1bc13e, $b9012d0e7442d60a$export$380604d7c79f9e8f, $b9012d0e7442d60a$export$4315fba5128fb4a1, $b9012d0e7442d60a$export$ca2a698f6020fda);
function $b9012d0e7442d60a$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $b9012d0e7442d60a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $b9012d0e7442d60a$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $4fc10846a2bfa4a1$export$9973ac5fd0181f33), classes);
};
const $b9012d0e7442d60a$var$Grid = /*#__PURE__*/ $i5lfL.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const props = (0, $ggmG3.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $7qXFD.default)(props, $b9012d0e7442d60a$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $i5lfL.useContext((0, $dc071cfa7e9e77ac$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $1CWiu.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $1CWiu.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $b9012d0e7442d60a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $dc071cfa7e9e77ac$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($b9012d0e7442d60a$var$GridRoot, (0, $1CWiu.default)({
            ownerState: ownerState,
            className: (0, $kRbLW.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $b9012d0e7442d60a$export$2e2bcd8739ae039 = $b9012d0e7442d60a$var$Grid;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $FRCsQ = parcelRequire("FRCsQ");

var $6bbZp = parcelRequire("6bbZp");

var $2ktY3 = parcelRequire("2ktY3");

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $cmrx1 = parcelRequire("cmrx1");

var $FRCsQ = parcelRequire("FRCsQ");



var $8mN0u = parcelRequire("8mN0u");

var $lwaO7 = parcelRequire("lwaO7");
const $0326c3b789cd6e41$var$_excluded = [
    "ownerState"
], $0326c3b789cd6e41$var$_excluded2 = [
    "variants"
], $0326c3b789cd6e41$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $0326c3b789cd6e41$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $0326c3b789cd6e41$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $0326c3b789cd6e41$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $0326c3b789cd6e41$export$35e57303dbd8a66 = (0, $8mN0u.default)();
const $0326c3b789cd6e41$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $0326c3b789cd6e41$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $0326c3b789cd6e41$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $0326c3b789cd6e41$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $0326c3b789cd6e41$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $7qXFD.default)(_ref, $0326c3b789cd6e41$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $1CWiu.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$0326c3b789cd6e41$var$processStyleArg(resolvedStyle, (0, $1CWiu.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $7qXFD.default)(resolvedStylesArg, $0326c3b789cd6e41$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $1CWiu.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $1CWiu.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $0326c3b789cd6e41$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $0326c3b789cd6e41$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $0326c3b789cd6e41$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $0326c3b789cd6e41$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $lwaO7.default)((0, $1CWiu.default)({}, props, {
            theme: $0326c3b789cd6e41$var$resolveTheme((0, $1CWiu.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $cmrx1.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $0326c3b789cd6e41$var$defaultOverridesResolver($0326c3b789cd6e41$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $7qXFD.default)(inputOptions, $0326c3b789cd6e41$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $0326c3b789cd6e41$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($0326c3b789cd6e41$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $cmrx1.default)(tag, (0, $1CWiu.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $FRCsQ.isPlainObject)(stylesArg)) return (props)=>$0326c3b789cd6e41$var$processStyleArg(stylesArg, (0, $1CWiu.default)({}, props, {
                    theme: $0326c3b789cd6e41$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0326c3b789cd6e41$var$resolveTheme((0, $1CWiu.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $0326c3b789cd6e41$var$processStyleArg(slotStyle, (0, $1CWiu.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $0326c3b789cd6e41$var$resolveTheme((0, $1CWiu.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $0326c3b789cd6e41$var$processStyleArg({
                    variants: themeVariants
                }, (0, $1CWiu.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $ccab80b5e2b94807$var$styled = (0, $0326c3b789cd6e41$export$2e2bcd8739ae039)();
var $ccab80b5e2b94807$export$2e2bcd8739ae039 = $ccab80b5e2b94807$var$styled;



var $dR0I7 = parcelRequire("dR0I7");
function $23488ce219ef4fef$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $dR0I7.default)(theme.components[name].defaultProps, props);
}



'use client';
function $cbcd67e9ee8b881a$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $99d6713ec469aabd$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $23488ce219ef4fef$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $ggmG3 = parcelRequire("ggmG3");

var $8mN0u = parcelRequire("8mN0u");

var $3IE2K = parcelRequire("3IE2K");

var $1XI54 = parcelRequire("1XI54");

var $bHJbJ = parcelRequire("bHJbJ");
const $12869dc79804ca92$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $12869dc79804ca92$var$defaultTheme = (0, $8mN0u.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $12869dc79804ca92$var$defaultCreateStyledComponent = (0, $ccab80b5e2b94807$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $12869dc79804ca92$var$useThemePropsDefault(props) {
    return (0, $cbcd67e9ee8b881a$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $12869dc79804ca92$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $12869dc79804ca92$var$joinChildren(children, separator) {
    const childrenArray = $i5lfL.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $i5lfL.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $12869dc79804ca92$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $12869dc79804ca92$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $1CWiu.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $3IE2K.handleBreakpoints)({
        theme: theme
    }, (0, $3IE2K.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $1XI54.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $3IE2K.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $3IE2K.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $1XI54.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$12869dc79804ca92$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $1XI54.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $FRCsQ.default)(styles, (0, $3IE2K.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $3IE2K.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $12869dc79804ca92$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $12869dc79804ca92$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $12869dc79804ca92$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $2ktY3.default)(slots, (slot)=>(0, $6bbZp.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($12869dc79804ca92$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $i5lfL.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $ggmG3.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $7qXFD.default)(props, $12869dc79804ca92$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $bHJbJ.jsx)(StackRoot, (0, $1CWiu.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $kRbLW.default)(classes.root, className)
        }, other, {
            children: divider ? $12869dc79804ca92$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");
'use client';
const $94fa2bcc16896cac$var$Stack = (0, $12869dc79804ca92$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $j7y1Z.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $kp44S.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $94fa2bcc16896cac$export$2e2bcd8739ae039 = $94fa2bcc16896cac$var$Stack;


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $ggmG3 = parcelRequire("ggmG3");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $VEXgj = parcelRequire("VEXgj");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $abd77a183335c198$export$24c1f8f60cbac79e(slot) {
    return (0, $6bbZp.default)('MuiTypography', slot);
}
const $abd77a183335c198$var$typographyClasses = (0, $47i1c.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $abd77a183335c198$export$2e2bcd8739ae039 = $abd77a183335c198$var$typographyClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $652f32fce481a679$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $652f32fce481a679$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $VEXgj.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $abd77a183335c198$export$24c1f8f60cbac79e), classes);
};
const $652f32fce481a679$export$140e2f5526d3cad8 = (0, $j7y1Z.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $VEXgj.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $652f32fce481a679$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $652f32fce481a679$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $652f32fce481a679$var$transformDeprecatedColors = (color)=>{
    return $652f32fce481a679$var$colorTransformations[color] || color;
};
const $652f32fce481a679$var$Typography = /*#__PURE__*/ $i5lfL.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $652f32fce481a679$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $ggmG3.default)((0, $1CWiu.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $652f32fce481a679$var$defaultVariantMapping } = props, other = (0, $7qXFD.default)(props, $652f32fce481a679$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $652f32fce481a679$var$defaultVariantMapping[variant]) || 'span';
    const classes = $652f32fce481a679$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($652f32fce481a679$export$140e2f5526d3cad8, (0, $1CWiu.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $kRbLW.default)(classes.root, className)
    }, other));
});
var $652f32fce481a679$export$2e2bcd8739ae039 = $652f32fce481a679$var$Typography;


parcelRequire("i5lfL");


const $d29d6d1034e01aa1$export$e34a37457e5428fb = `
Welcome to the Infrastructure Australia Market Capacity Data Portal, an interactive platform designed to assist government in making better-informed infrastructure investment decisions
`;
const $d29d6d1034e01aa1$export$f75b2c3dd207e4d9 = `
Access to the Infrastructure Australia Market Capacity Data Portal is reserved for eligible government stakeholders only
`;
const $d29d6d1034e01aa1$export$b9c6040cf5f3c72d = `
Please fill in all the fields, taking care to quote your government email address. Personal/other email addresses will not be accepted
`;
const $d29d6d1034e01aa1$export$63bd130e3dfd0f44 = `
Welcome to the Infrastructure Australia data portal`;
const $d29d6d1034e01aa1$export$fb9dee3634f56d8e = `
`;
const $d29d6d1034e01aa1$export$3191e2ef03e5caa5 = `
A combined view of all current state and territory infrastructure pipelines`;
const $d29d6d1034e01aa1$export$e589381a487d929e = `
Upload your new baseline data and view your current state or territory pipeline`;
const $d29d6d1034e01aa1$export$f68e326d679cfc85 = `
Baseline pipeline based on data collected as of Q3 2025. Next data refresh: Q2 2026`;
const $d29d6d1034e01aa1$export$f5e719fcdee8e25e = `
Create and run a new or saved scenarios`;
const $d29d6d1034e01aa1$export$f464c3b736cce140 = `
Explore state and national pipeline on an interactive map`;
const $d29d6d1034e01aa1$export$33d7376ee10414e3 = `
Scenario Description`;
const $d29d6d1034e01aa1$export$c5207a560bbcb1de = `
You can assign project phase assumptions by project type here and they will be applied to scenario model result only. Please make sure numbers add up to 100% and be aware that the model can take longer to run post adjustment.`;
const $d29d6d1034e01aa1$export$44e44024e31d74b = `
You can adjust the escalation rate used in your pipeline. Please give a delta escalation rate* in below box and it will be applied in the scenario result. The delta escalation will only be applied to your own pipeline and not impacting data from other sources. After the adjustment the model can take longer to refresh than normal.`;
const $d29d6d1034e01aa1$export$b1dd8533582027e5 = `
* For example if your pipeline already considers a 3% escalation and new escalation is 5%, please enter 2% in below box`;
const $d29d6d1034e01aa1$export$de196134d038efd2 = `Baseline pipeline based on data collected as of Q3 2025 excl unknown SA4 projects. Next data refresh: Q2 2026`;
const $d29d6d1034e01aa1$export$a8f1b1ece045a3c4 = `Baseline pipeline based on data collected as of Q3 2025. Next data refresh: Q2 2026`;
const $d29d6d1034e01aa1$export$257faa611f4a6c22 = `Labour demand includes infrastructure projects only (all pipelines excluding private buildings). Data excludes unknown SA4\u{2019}s. Project level filters don\u{2019}t apply on this chart.`;


const $104bbaa82939068f$var$styles = {
    button: {
        color: "#000000"
    }
};
function $104bbaa82939068f$export$2e2bcd8739ae039() {
    const { instance: instance } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const initializeSignIn = ()=>{
        instance.loginRedirect();
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $bHJbJ.Fragment), {
        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
            container: true,
            spacing: 10,
            display: "flex",
            justifyContent: "center",
            sx: {
                pt: "10%"
            },
            children: [
                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 4,
                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                        variant: "h2",
                        component: "div",
                        children: (0, $d29d6d1034e01aa1$export$e34a37457e5428fb)
                    })
                }),
                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 3,
                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
                        spacing: 10,
                        sx: {
                            pt: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                style: $104bbaa82939068f$var$styles.button,
                                variant: "outlined",
                                onClick: initializeSignIn,
                                children: "Sign-in"
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                style: $104bbaa82939068f$var$styles.button,
                                variant: "outlined",
                                component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                to: "/request-access",
                                children: "Request Access"
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/*
 * Copyright (c) 2023. RoZetta Technology Pty Ltd. All rights reserved.
 */ 
var $bHJbJ = parcelRequire("bHJbJ");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");


var $1CWiu = parcelRequire("1CWiu");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $d7066316d4f9103f$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $d7066316d4f9103f$export$2e2bcd8739ae039 = $d7066316d4f9103f$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $9140f0be1e87249a$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $d7066316d4f9103f$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $1CWiu.default)({}, otherProps, {
        ownerState: (0, $1CWiu.default)({}, otherProps.ownerState, ownerState)
    });
}
var $9140f0be1e87249a$export$2e2bcd8739ae039 = $9140f0be1e87249a$var$appendOwnerState;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $e73eaf7c7a0e56f3$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $e73eaf7c7a0e56f3$export$2e2bcd8739ae039 = $e73eaf7c7a0e56f3$var$resolveComponentProps;



var $1CWiu = parcelRequire("1CWiu");

var $kRbLW = parcelRequire("kRbLW");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $d3a9833af65b6699$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $d3a9833af65b6699$export$2e2bcd8739ae039 = $d3a9833af65b6699$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $56bf8f711bd9b4fd$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $56bf8f711bd9b4fd$export$2e2bcd8739ae039 = $56bf8f711bd9b4fd$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $eeda6a30c1262506$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $kRbLW.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $1CWiu.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $1CWiu.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $d3a9833af65b6699$export$2e2bcd8739ae039)((0, $1CWiu.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $56bf8f711bd9b4fd$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $56bf8f711bd9b4fd$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $kRbLW.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $1CWiu.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $1CWiu.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $eeda6a30c1262506$export$2e2bcd8739ae039 = $eeda6a30c1262506$var$mergeSlotProps;


'use client';
const $8782b9214add240b$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $8782b9214add240b$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $8782b9214add240b$var$_excluded3 = [
    "component"
];
function $8782b9214add240b$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $7qXFD.default)(parameters, $8782b9214add240b$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $7qXFD.default)(externalForwardedProps, $8782b9214add240b$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $e73eaf7c7a0e56f3$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $eeda6a30c1262506$export$2e2bcd8739ae039)((0, $1CWiu.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $7qXFD.default)(_mergeSlotProps.props, $8782b9214add240b$var$_excluded3);
    const ref = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $1CWiu.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $9140f0be1e87249a$export$2e2bcd8739ae039)(elementType, (0, $1CWiu.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $VEXgj = parcelRequire("VEXgj");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");



var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");

var $j7y1Z = parcelRequire("j7y1Z");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $f3f7aa9002f130ab$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $f3f7aa9002f130ab$export$2e2bcd8739ae039 = $f3f7aa9002f130ab$var$getOverlayAlpha;



var $kp44S = parcelRequire("kp44S");


var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $217789b38c4c6331$export$29cdb466b9b6f20b(slot) {
    return (0, $6bbZp.default)('MuiPaper', slot);
}
const $217789b38c4c6331$var$paperClasses = (0, $47i1c.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $217789b38c4c6331$export$2e2bcd8739ae039 = $217789b38c4c6331$var$paperClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $fa105ed17f31a2c8$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $fa105ed17f31a2c8$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $217789b38c4c6331$export$29cdb466b9b6f20b), classes);
};
const $fa105ed17f31a2c8$var$PaperRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $1CWiu.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $1CWiu.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $8AHNG.alpha)('#fff', (0, $f3f7aa9002f130ab$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $8AHNG.alpha)('#fff', (0, $f3f7aa9002f130ab$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $fa105ed17f31a2c8$var$Paper = /*#__PURE__*/ $i5lfL.forwardRef(function Paper(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $7qXFD.default)(props, $fa105ed17f31a2c8$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $fa105ed17f31a2c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($fa105ed17f31a2c8$var$PaperRoot, (0, $1CWiu.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $kRbLW.default)(classes.root, className),
        ref: ref
    }, other));
});
var $fa105ed17f31a2c8$export$2e2bcd8739ae039 = $fa105ed17f31a2c8$var$Paper;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $316ccdb9dab9b1fc$export$69aecd24bc2cf7e3(slot) {
    return (0, $6bbZp.default)('MuiAlert', slot);
}
const $316ccdb9dab9b1fc$var$alertClasses = (0, $47i1c.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $316ccdb9dab9b1fc$export$2e2bcd8739ae039 = $316ccdb9dab9b1fc$var$alertClasses;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");


var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");


var $VEXgj = parcelRequire("VEXgj");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $be1be01f9bd46343$export$5e8702d71474f093(slot) {
    return (0, $6bbZp.default)('MuiIconButton', slot);
}
const $be1be01f9bd46343$var$iconButtonClasses = (0, $47i1c.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $be1be01f9bd46343$export$2e2bcd8739ae039 = $be1be01f9bd46343$var$iconButtonClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $600c8be2a4008660$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $600c8be2a4008660$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $VEXgj.default)(color)}`,
            edge && `edge${(0, $VEXgj.default)(edge)}`,
            `size${(0, $VEXgj.default)(size)}`
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $be1be01f9bd46343$export$5e8702d71474f093), classes);
};
const $600c8be2a4008660$var$IconButtonRoot = (0, $j7y1Z.default)((0, $07a3ed667acb77f6$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $VEXgj.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $VEXgj.default)(ownerState.edge)}`],
            styles[`size${(0, $VEXgj.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8AHNG.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $1CWiu.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $1CWiu.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $1CWiu.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8AHNG.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $be1be01f9bd46343$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $600c8be2a4008660$var$IconButton = /*#__PURE__*/ $i5lfL.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $7qXFD.default)(props, $600c8be2a4008660$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $600c8be2a4008660$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($600c8be2a4008660$var$IconButtonRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $600c8be2a4008660$export$2e2bcd8739ae039 = $600c8be2a4008660$var$IconButton;


parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $16892882c4293da5$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $21cdbad01d2b3897$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $3b5912257c2e82ce$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $c921a1b768686d8a$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');


parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $6f3bd929a1460eea$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $097160938072b98e$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $097160938072b98e$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $VEXgj.default)(color || severity)}`,
            `${variant}${(0, $VEXgj.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $316ccdb9dab9b1fc$export$69aecd24bc2cf7e3), classes);
};
const $097160938072b98e$var$AlertRoot = (0, $j7y1Z.default)((0, $fa105ed17f31a2c8$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $VEXgj.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $8AHNG.darken) : (0, $8AHNG.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $8AHNG.lighten) : (0, $8AHNG.darken);
    return (0, $1CWiu.default)({}, theme.typography.body2, {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $316ccdb9dab9b1fc$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $316ccdb9dab9b1fc$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: (0, $1CWiu.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $097160938072b98e$var$AlertIcon = (0, $j7y1Z.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $097160938072b98e$var$AlertMessage = (0, $j7y1Z.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $097160938072b98e$var$AlertAction = (0, $j7y1Z.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $097160938072b98e$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $16892882c4293da5$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $21cdbad01d2b3897$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3b5912257c2e82ce$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $c921a1b768686d8a$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $097160938072b98e$var$Alert = /*#__PURE__*/ $i5lfL.forwardRef(function Alert(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $097160938072b98e$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard' } = props, other = (0, $7qXFD.default)(props, $097160938072b98e$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $097160938072b98e$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $1CWiu.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $1CWiu.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $8782b9214add240b$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $600c8be2a4008660$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $8782b9214add240b$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $6f3bd929a1460eea$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($097160938072b98e$var$AlertRoot, (0, $1CWiu.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $kRbLW.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $bHJbJ.jsx)($097160938072b98e$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $097160938072b98e$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $bHJbJ.jsx)($097160938072b98e$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $bHJbJ.jsx)($097160938072b98e$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $bHJbJ.jsx)($097160938072b98e$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)(CloseButtonSlot, (0, $1CWiu.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)(CloseIconSlot, (0, $1CWiu.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $097160938072b98e$export$2e2bcd8739ae039 = $097160938072b98e$var$Alert;


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $i5lfL = parcelRequire("i5lfL");
'use client';
let $f3f83812f7a42248$var$globalId = 0;
function $f3f83812f7a42248$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $i5lfL.useState(idOverride);
    const id = idOverride || defaultId;
    $i5lfL.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $f3f83812f7a42248$var$globalId += 1;
            setDefaultId(`mui-${$f3f83812f7a42248$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $f3f83812f7a42248$var$maybeReactUseId = $i5lfL['useId'.toString()];
function $f3f83812f7a42248$export$2e2bcd8739ae039(idOverride) {
    if ($f3f83812f7a42248$var$maybeReactUseId !== undefined) {
        const reactId = $f3f83812f7a42248$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $f3f83812f7a42248$var$useGlobalId(idOverride);
}



var $VEXgj = parcelRequire("VEXgj");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");



var $2ktY3 = parcelRequire("2ktY3");

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");




'use client';
const $03a468e0efc9278b$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $03a468e0efc9278b$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $7qXFD.default)(parameters, $03a468e0efc9278b$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $e73eaf7c7a0e56f3$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $eeda6a30c1262506$export$2e2bcd8739ae039)((0, $1CWiu.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $9140f0be1e87249a$export$2e2bcd8739ae039)(elementType, (0, $1CWiu.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $03a468e0efc9278b$export$2e2bcd8739ae039 = $03a468e0efc9278b$var$useSlotProps;



var $i5lfL = parcelRequire("i5lfL");

function $1d4cd2ae762f70cd$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $2ce9c86cd6d02e69$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $2ce9c86cd6d02e69$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $2ce9c86cd6d02e69$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $2ce9c86cd6d02e69$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $2ce9c86cd6d02e69$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $2ce9c86cd6d02e69$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($2ce9c86cd6d02e69$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $2ce9c86cd6d02e69$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$2ce9c86cd6d02e69$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $2ce9c86cd6d02e69$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $2ce9c86cd6d02e69$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $2ce9c86cd6d02e69$var$defaultGetTabbable, isEnabled: isEnabled = $2ce9c86cd6d02e69$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $i5lfL.useRef(false);
    const sentinelStart = $i5lfL.useRef(null);
    const sentinelEnd = $i5lfL.useRef(null);
    const nodeToRestore = $i5lfL.useRef(null);
    const reactFocusEventTarget = $i5lfL.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $i5lfL.useRef(false);
    const rootRef = $i5lfL.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $i5lfL.useRef(null);
    $i5lfL.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $i5lfL.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $i5lfL.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $i5lfL.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $2ce9c86cd6d02e69$export$2e2bcd8739ae039 = $2ce9c86cd6d02e69$var$FocusTrap;



var $i5lfL = parcelRequire("i5lfL");




var $bHJbJ = parcelRequire("bHJbJ");
'use client';
function $4550da58a5c16130$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $4550da58a5c16130$var$Portal = /*#__PURE__*/ $i5lfL.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $i5lfL.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(/*#__PURE__*/ $i5lfL.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($4550da58a5c16130$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $ef4fd0edd5f8d0dd$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $ef4fd0edd5f8d0dd$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $i5lfL.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $i5lfL.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $bHJbJ.jsx)($i5lfL.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($i5lfL.Fragment, {
        children: mountNode ? /*#__PURE__*/ $a3874087362a2bd1$exports.createPortal(children, mountNode) : mountNode
    });
});
var $4550da58a5c16130$export$2e2bcd8739ae039 = $4550da58a5c16130$var$Portal;



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $7qXFD = parcelRequire("7qXFD");



var $i5lfL = parcelRequire("i5lfL");

var $9ef20640420cdccf$export$2e2bcd8739ae039 = {
    disabled: false
};




var $ede516df8a9d81b6$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $3011cc386e359a11$export$bb38bb9a1161268 = 'unmounted';
var $3011cc386e359a11$export$84cbff306f539230 = 'exited';
var $3011cc386e359a11$export$df38205c966be359 = 'entering';
var $3011cc386e359a11$export$78e9e6e3e014d60a = 'entered';
var $3011cc386e359a11$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $3011cc386e359a11$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $25ad3ce036029841$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $3011cc386e359a11$export$84cbff306f539230;
                _this.appearStatus = $3011cc386e359a11$export$df38205c966be359;
            } else initialStatus = $3011cc386e359a11$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $3011cc386e359a11$export$bb38bb9a1161268;
        else initialStatus = $3011cc386e359a11$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $3011cc386e359a11$export$bb38bb9a1161268) return {
            status: $3011cc386e359a11$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $3011cc386e359a11$export$df38205c966be359 && status !== $3011cc386e359a11$export$78e9e6e3e014d60a) nextStatus = $3011cc386e359a11$export$df38205c966be359;
            } else if (status === $3011cc386e359a11$export$df38205c966be359 || status === $3011cc386e359a11$export$78e9e6e3e014d60a) nextStatus = $3011cc386e359a11$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $3011cc386e359a11$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($a3874087362a2bd1$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $ede516df8a9d81b6$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $3011cc386e359a11$export$84cbff306f539230) this.setState({
            status: $3011cc386e359a11$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($a3874087362a2bd1$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9ef20640420cdccf$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $3011cc386e359a11$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $3011cc386e359a11$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $3011cc386e359a11$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($a3874087362a2bd1$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9ef20640420cdccf$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $3011cc386e359a11$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $3011cc386e359a11$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $3011cc386e359a11$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($a3874087362a2bd1$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $3011cc386e359a11$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $7qXFD.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement((0, $4b4b5e0feab4d50b$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).Component);
$3011cc386e359a11$var$Transition.contextType = (0, $4b4b5e0feab4d50b$export$2e2bcd8739ae039);
$3011cc386e359a11$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $3011cc386e359a11$var$noop() {}
$3011cc386e359a11$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $3011cc386e359a11$var$noop,
    onEntering: $3011cc386e359a11$var$noop,
    onEntered: $3011cc386e359a11$var$noop,
    onExit: $3011cc386e359a11$var$noop,
    onExiting: $3011cc386e359a11$var$noop,
    onExited: $3011cc386e359a11$var$noop
};
$3011cc386e359a11$var$Transition.UNMOUNTED = $3011cc386e359a11$export$bb38bb9a1161268;
$3011cc386e359a11$var$Transition.EXITED = $3011cc386e359a11$export$84cbff306f539230;
$3011cc386e359a11$var$Transition.ENTERING = $3011cc386e359a11$export$df38205c966be359;
$3011cc386e359a11$var$Transition.ENTERED = $3011cc386e359a11$export$78e9e6e3e014d60a;
$3011cc386e359a11$var$Transition.EXITING = $3011cc386e359a11$export$4aacc83d4d59139f;
var $3011cc386e359a11$export$2e2bcd8739ae039 = $3011cc386e359a11$var$Transition;




const $de1e3dddb137b7cc$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $de1e3dddb137b7cc$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $eb1f4c060c8a68ab$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $eb1f4c060c8a68ab$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $eb1f4c060c8a68ab$var$Fade = /*#__PURE__*/ $i5lfL.forwardRef(function Fade(props, ref) {
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $3011cc386e359a11$export$2e2bcd8739ae039) } = props, other = (0, $7qXFD.default)(props, $eb1f4c060c8a68ab$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $i5lfL.useRef(null);
    const handleRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $de1e3dddb137b7cc$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $de1e3dddb137b7cc$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $de1e3dddb137b7cc$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsx)(TransitionComponent, (0, $1CWiu.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $i5lfL.cloneElement(children, (0, $1CWiu.default)({
                style: (0, $1CWiu.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $eb1f4c060c8a68ab$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $eb1f4c060c8a68ab$export$2e2bcd8739ae039 = $eb1f4c060c8a68ab$var$Fade;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $ff72ea963c3eaf3a$export$9927a91fd93152bd(slot) {
    return (0, $6bbZp.default)('MuiBackdrop', slot);
}
const $ff72ea963c3eaf3a$var$backdropClasses = (0, $47i1c.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $ff72ea963c3eaf3a$export$2e2bcd8739ae039 = $ff72ea963c3eaf3a$var$backdropClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $8c96d491af6dc902$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $8c96d491af6dc902$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $ff72ea963c3eaf3a$export$9927a91fd93152bd), classes);
};
const $8c96d491af6dc902$var$BackdropRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $8c96d491af6dc902$var$Backdrop = /*#__PURE__*/ $i5lfL.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $eb1f4c060c8a68ab$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $7qXFD.default)(props, $8c96d491af6dc902$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $8c96d491af6dc902$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)(TransitionComponent, (0, $1CWiu.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($8c96d491af6dc902$var$BackdropRoot, (0, $1CWiu.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $kRbLW.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $1CWiu.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $8c96d491af6dc902$export$2e2bcd8739ae039 = $8c96d491af6dc902$var$Backdrop;



var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $3621b9a955ea67a6$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $6654636ca7f78387$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


function $ca776b19cb3fc829$export$2e2bcd8739ae039(node) {
    const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $4abe68436f26bf28$var$isOverflowing(container) {
    const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $ca776b19cb3fc829$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $4abe68436f26bf28$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $4abe68436f26bf28$var$getPaddingRight(element) {
    return parseInt((0, $ca776b19cb3fc829$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $4abe68436f26bf28$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $4abe68436f26bf28$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$4abe68436f26bf28$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $4abe68436f26bf28$export$e1bd0c6150f13d96(element, show);
    });
}
function $4abe68436f26bf28$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $4abe68436f26bf28$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($4abe68436f26bf28$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $6654636ca7f78387$export$2e2bcd8739ae039)((0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$4abe68436f26bf28$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$4abe68436f26bf28$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $ca776b19cb3fc829$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $4abe68436f26bf28$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $4abe68436f26bf28$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $4abe68436f26bf28$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $4abe68436f26bf28$var$getHiddenSiblings(container);
        $4abe68436f26bf28$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $4abe68436f26bf28$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $4abe68436f26bf28$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $4abe68436f26bf28$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $4abe68436f26bf28$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $4abe68436f26bf28$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $4abe68436f26bf28$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $4abe68436f26bf28$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $bdc20b4d8195b19b$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $bdc20b4d8195b19b$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $bdc20b4d8195b19b$var$defaultManager = new (0, $4abe68436f26bf28$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $bdc20b4d8195b19b$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $bdc20b4d8195b19b$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $i5lfL.useRef({});
    const mountNodeRef = $i5lfL.useRef(null);
    const modalRef = $i5lfL.useRef(null);
    const handleRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $i5lfL.useState(!open);
    const hasTransition = $bdc20b4d8195b19b$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $49175dc6d5053977$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $bdc20b4d8195b19b$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $i5lfL.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $4abe68436f26bf28$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $i5lfL.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $i5lfL.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $i5lfL.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $d3a9833af65b6699$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $1CWiu.default)({}, propsEventHandlers, otherHandlers);
        return (0, $1CWiu.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $1CWiu.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $3621b9a955ea67a6$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $3621b9a955ea67a6$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $bdc20b4d8195b19b$export$2e2bcd8739ae039 = $bdc20b4d8195b19b$var$useModal;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $de97b839d1555677$export$67960e22b12a638d(slot) {
    return (0, $6bbZp.default)('MuiModal', slot);
}
const $de97b839d1555677$var$modalClasses = (0, $47i1c.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $de97b839d1555677$export$2e2bcd8739ae039 = $de97b839d1555677$var$modalClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $a442c1b1e4af20c7$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $a442c1b1e4af20c7$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $de97b839d1555677$export$67960e22b12a638d), classes);
};
const $a442c1b1e4af20c7$var$ModalRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $a442c1b1e4af20c7$var$ModalBackdrop = (0, $j7y1Z.default)((0, $8c96d491af6dc902$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $a442c1b1e4af20c7$var$Modal = /*#__PURE__*/ $i5lfL.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $kp44S.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $a442c1b1e4af20c7$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $7qXFD.default)(props, $a442c1b1e4af20c7$var$_excluded);
    const propsWithDefaults = (0, $1CWiu.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $bdc20b4d8195b19b$export$2e2bcd8739ae039)((0, $1CWiu.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $1CWiu.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $a442c1b1e4af20c7$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $a442c1b1e4af20c7$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $kRbLW.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $1CWiu.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $kRbLW.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $4550da58a5c16130$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)(RootSlot, (0, $1CWiu.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $bHJbJ.jsx)(BackdropSlot, (0, $1CWiu.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $2ce9c86cd6d02e69$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $i5lfL.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $a442c1b1e4af20c7$export$2e2bcd8739ae039 = $a442c1b1e4af20c7$var$Modal;





var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $5af9140f95ca5973$export$2177af0aa15c34c2(slot) {
    return (0, $6bbZp.default)('MuiDialog', slot);
}
const $5af9140f95ca5973$var$dialogClasses = (0, $47i1c.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $5af9140f95ca5973$export$2e2bcd8739ae039 = $5af9140f95ca5973$var$dialogClasses;



var $i5lfL = parcelRequire("i5lfL");
const $2338fd766b12f1fd$var$DialogContext = /*#__PURE__*/ $i5lfL.createContext({});
var $2338fd766b12f1fd$export$2e2bcd8739ae039 = $2338fd766b12f1fd$var$DialogContext;





var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $9bb0dd9cdb8ee136$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $9bb0dd9cdb8ee136$var$DialogBackdrop = (0, $j7y1Z.default)((0, $8c96d491af6dc902$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $9bb0dd9cdb8ee136$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $VEXgj.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $VEXgj.default)(scroll)}`,
            `paperWidth${(0, $VEXgj.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $5af9140f95ca5973$export$2177af0aa15c34c2), classes);
};
const $9bb0dd9cdb8ee136$var$DialogRoot = (0, $j7y1Z.default)((0, $a442c1b1e4af20c7$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $9bb0dd9cdb8ee136$var$DialogContainer = (0, $j7y1Z.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $VEXgj.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $9bb0dd9cdb8ee136$var$DialogPaper = (0, $j7y1Z.default)((0, $fa105ed17f31a2c8$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $VEXgj.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $VEXgj.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $5af9140f95ca5973$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $5af9140f95ca5973$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $5af9140f95ca5973$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $9bb0dd9cdb8ee136$var$Dialog = /*#__PURE__*/ $i5lfL.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $fa105ed17f31a2c8$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $eb1f4c060c8a68ab$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $7qXFD.default)(props, $9bb0dd9cdb8ee136$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $9bb0dd9cdb8ee136$var$useUtilityClasses(ownerState);
    const backdropClick = $i5lfL.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $f3f83812f7a42248$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $i5lfL.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($9bb0dd9cdb8ee136$var$DialogRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $9bb0dd9cdb8ee136$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $1CWiu.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)(TransitionComponent, (0, $1CWiu.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $bHJbJ.jsx)($9bb0dd9cdb8ee136$var$DialogContainer, {
                className: (0, $kRbLW.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)($9bb0dd9cdb8ee136$var$DialogPaper, (0, $1CWiu.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $kRbLW.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $2338fd766b12f1fd$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $9bb0dd9cdb8ee136$export$2e2bcd8739ae039 = $9bb0dd9cdb8ee136$var$Dialog;


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $b6ceb8dca1e987e1$export$5e57a444791c63be(slot) {
    return (0, $6bbZp.default)('MuiDialogActions', slot);
}
const $b6ceb8dca1e987e1$var$dialogActionsClasses = (0, $47i1c.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $b6ceb8dca1e987e1$export$2e2bcd8739ae039 = $b6ceb8dca1e987e1$var$dialogActionsClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $0d4f9b05ed57077c$var$_excluded = [
    "className",
    "disableSpacing"
];
const $0d4f9b05ed57077c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $b6ceb8dca1e987e1$export$5e57a444791c63be), classes);
};
const $0d4f9b05ed57077c$var$DialogActionsRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $0d4f9b05ed57077c$var$DialogActions = /*#__PURE__*/ $i5lfL.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $7qXFD.default)(props, $0d4f9b05ed57077c$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $0d4f9b05ed57077c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($0d4f9b05ed57077c$var$DialogActionsRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $0d4f9b05ed57077c$export$2e2bcd8739ae039 = $0d4f9b05ed57077c$var$DialogActions;


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $d82c1044510b6b7c$export$61b0ee1f05fb344e(slot) {
    return (0, $6bbZp.default)('MuiDialogContent', slot);
}
const $d82c1044510b6b7c$var$dialogContentClasses = (0, $47i1c.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $d82c1044510b6b7c$export$2e2bcd8739ae039 = $d82c1044510b6b7c$var$dialogContentClasses;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $ab6c46e722e59280$export$f5d2ec7e4c47e088(slot) {
    return (0, $6bbZp.default)('MuiDialogTitle', slot);
}
const $ab6c46e722e59280$var$dialogTitleClasses = (0, $47i1c.default)('MuiDialogTitle', [
    'root'
]);
var $ab6c46e722e59280$export$2e2bcd8739ae039 = $ab6c46e722e59280$var$dialogTitleClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $422502a3833a93e2$var$_excluded = [
    "className",
    "dividers"
];
const $422502a3833a93e2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $d82c1044510b6b7c$export$61b0ee1f05fb344e), classes);
};
const $422502a3833a93e2$var$DialogContentRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $ab6c46e722e59280$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $422502a3833a93e2$var$DialogContent = /*#__PURE__*/ $i5lfL.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $7qXFD.default)(props, $422502a3833a93e2$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        dividers: dividers
    });
    const classes = $422502a3833a93e2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($422502a3833a93e2$var$DialogContentRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $422502a3833a93e2$export$2e2bcd8739ae039 = $422502a3833a93e2$var$DialogContent;


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $kp44S = parcelRequire("kp44S");


var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $c5deecbc778f54d3$export$d9c6dc45f75b0e4f(slot) {
    return (0, $6bbZp.default)('MuiDialogContentText', slot);
}
const $c5deecbc778f54d3$var$dialogContentTextClasses = (0, $47i1c.default)('MuiDialogContentText', [
    'root'
]);
var $c5deecbc778f54d3$export$2e2bcd8739ae039 = $c5deecbc778f54d3$var$dialogContentTextClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $a63770281394464a$var$_excluded = [
    "children",
    "className"
];
const $a63770281394464a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $2ktY3.default)(slots, (0, $c5deecbc778f54d3$export$d9c6dc45f75b0e4f), classes);
    return (0, $1CWiu.default)({}, classes, composedClasses);
};
const $a63770281394464a$var$DialogContentTextRoot = (0, $j7y1Z.default)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1FZvT.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $a63770281394464a$var$DialogContentText = /*#__PURE__*/ $i5lfL.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { className: className } = props, ownerState = (0, $7qXFD.default)(props, $a63770281394464a$var$_excluded);
    const classes = $a63770281394464a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($a63770281394464a$var$DialogContentTextRoot, (0, $1CWiu.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $kRbLW.default)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
var $a63770281394464a$export$2e2bcd8739ae039 = $a63770281394464a$var$DialogContentText;


var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");


var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $48d8f4c3325a9037$var$_excluded = [
    "className",
    "id"
];
const $48d8f4c3325a9037$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $ab6c46e722e59280$export$f5d2ec7e4c47e088), classes);
};
const $48d8f4c3325a9037$var$DialogTitleRoot = (0, $j7y1Z.default)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $48d8f4c3325a9037$var$DialogTitle = /*#__PURE__*/ $i5lfL.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $7qXFD.default)(props, $48d8f4c3325a9037$var$_excluded);
    const ownerState = props;
    const classes = $48d8f4c3325a9037$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $i5lfL.useContext((0, $2338fd766b12f1fd$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($48d8f4c3325a9037$var$DialogTitleRoot, (0, $1CWiu.default)({
        component: "h2",
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $48d8f4c3325a9037$export$2e2bcd8739ae039 = $48d8f4c3325a9037$var$DialogTitle;


var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $2ktY3 = parcelRequire("2ktY3");

var $FRCsQ = parcelRequire("FRCsQ");


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $1SAXO = parcelRequire("1SAXO");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");



var $2ktY3 = parcelRequire("2ktY3");


var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $d215165998bf3530$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $4f27d7c06086bfa8$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $4f27d7c06086bfa8$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $4f27d7c06086bfa8$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $4f27d7c06086bfa8$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $4f27d7c06086bfa8$var$TextareaAutosize = /*#__PURE__*/ $i5lfL.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $7qXFD.default)(props, $4f27d7c06086bfa8$var$_excluded);
    const { current: isControlled } = $i5lfL.useRef(value != null);
    const inputRef = $i5lfL.useRef(null);
    const handleRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const heightRef = $i5lfL.useRef(null);
    const shadowRef = $i5lfL.useRef(null);
    const calculateTextareaStyles = $i5lfL.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $ca776b19cb3fc829$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $4f27d7c06086bfa8$var$getStyleValue(computedStyle.paddingBottom) + $4f27d7c06086bfa8$var$getStyleValue(computedStyle.paddingTop);
        const border = $4f27d7c06086bfa8$var$getStyleValue(computedStyle.borderBottomWidth) + $4f27d7c06086bfa8$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $i5lfL.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($4f27d7c06086bfa8$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        const input = inputRef.current;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            input.style.height = `${outerHeightStyle}px`;
        }
        input.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $d215165998bf3530$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $ca776b19cb3fc829$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener('resize', debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener('resize', debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)("textarea", (0, $1CWiu.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $1CWiu.default)({}, $4f27d7c06086bfa8$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $4f27d7c06086bfa8$export$2e2bcd8739ae039 = $4f27d7c06086bfa8$var$TextareaAutosize;


function $0c562896955434b6$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $i5lfL = parcelRequire("i5lfL");
/**
 * @ignore - internal component.
 */ const $9f1ff024a5549c12$var$FormControlContext = /*#__PURE__*/ $i5lfL.createContext(undefined);
var $9f1ff024a5549c12$export$2e2bcd8739ae039 = $9f1ff024a5549c12$var$FormControlContext;



var $i5lfL = parcelRequire("i5lfL");

'use client';
function $01f467cf0a9ed9ad$export$2e2bcd8739ae039() {
    return $i5lfL.useContext((0, $9f1ff024a5549c12$export$2e2bcd8739ae039));
}



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $VEXgj = parcelRequire("VEXgj");


'use client';
var $946b6dd96ae69a8b$export$2e2bcd8739ae039 = (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039);



// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1becf3f0467ed23a$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $1becf3f0467ed23a$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($1becf3f0467ed23a$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $1becf3f0467ed23a$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $1becf3f0467ed23a$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $08e5d2b1a59391fa$export$ef57d5c8ca2278f6(slot) {
    return (0, $6bbZp.default)('MuiInputBase', slot);
}
const $08e5d2b1a59391fa$var$inputBaseClasses = (0, $47i1c.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $08e5d2b1a59391fa$export$2e2bcd8739ae039 = $08e5d2b1a59391fa$var$inputBaseClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $3ea17bf47e0c8482$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $3ea17bf47e0c8482$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $VEXgj.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $3ea17bf47e0c8482$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $3ea17bf47e0c8482$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $VEXgj.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $VEXgj.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $08e5d2b1a59391fa$export$ef57d5c8ca2278f6), classes);
};
const $3ea17bf47e0c8482$export$298a043133d72a38 = (0, $j7y1Z.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $3ea17bf47e0c8482$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $08e5d2b1a59391fa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $1CWiu.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $3ea17bf47e0c8482$export$a1ad29c901026019 = (0, $j7y1Z.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $3ea17bf47e0c8482$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $1CWiu.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $1CWiu.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $08e5d2b1a59391fa$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $08e5d2b1a59391fa$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $3ea17bf47e0c8482$var$inputGlobalStyles = /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $9583ec3111a78f3f$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $3ea17bf47e0c8482$var$InputBase = /*#__PURE__*/ $i5lfL.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $7qXFD.default)(props, $3ea17bf47e0c8482$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $i5lfL.useRef(value != null);
    const inputRef = $i5lfL.useRef();
    const handleInputRefWarning = $i5lfL.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $i5lfL.useState(false);
    const muiFormControl = (0, $01f467cf0a9ed9ad$export$2e2bcd8739ae039)();
    const fcs = (0, $0c562896955434b6$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $i5lfL.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $i5lfL.useCallback((obj)=>{
        if ((0, $1becf3f0467ed23a$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $946b6dd96ae69a8b$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $1SAXO.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $i5lfL.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $1CWiu.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $1CWiu.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $4f27d7c06086bfa8$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $i5lfL.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $3ea17bf47e0c8482$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $3ea17bf47e0c8482$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $3ea17bf47e0c8482$export$a1ad29c901026019;
    inputProps = (0, $1CWiu.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $3ea17bf47e0c8482$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $bHJbJ.jsxs)(Root, (0, $1CWiu.default)({}, rootProps, !(0, $d7066316d4f9103f$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $1CWiu.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $kRbLW.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $9f1ff024a5549c12$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)(Input, (0, $1CWiu.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $d7066316d4f9103f$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $1CWiu.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $kRbLW.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $1CWiu.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $3ea17bf47e0c8482$export$2e2bcd8739ae039 = $3ea17bf47e0c8482$var$InputBase;



var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $kp44S = parcelRequire("kp44S");

var $1CWiu = parcelRequire("1CWiu");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");

function $7d1bb401b461f079$export$cdb270390122322b(slot) {
    return (0, $6bbZp.default)('MuiInput', slot);
}
const $7d1bb401b461f079$var$inputClasses = (0, $1CWiu.default)({}, (0, $08e5d2b1a59391fa$export$2e2bcd8739ae039), (0, $47i1c.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $7d1bb401b461f079$export$2e2bcd8739ae039 = $7d1bb401b461f079$var$inputClasses;




var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $a94b451b352b13ae$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $a94b451b352b13ae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $2ktY3.default)(slots, (0, $7d1bb401b461f079$export$cdb270390122322b), classes);
    return (0, $1CWiu.default)({}, classes, composedClasses);
};
const $a94b451b352b13ae$var$InputRoot = (0, $j7y1Z.default)((0, $3ea17bf47e0c8482$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $1FZvT.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $3ea17bf47e0c8482$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $1CWiu.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $7d1bb401b461f079$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $7d1bb401b461f079$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $7d1bb401b461f079$export$2e2bcd8739ae039).disabled}, .${(0, $7d1bb401b461f079$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $7d1bb401b461f079$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $a94b451b352b13ae$var$InputInput = (0, $j7y1Z.default)((0, $3ea17bf47e0c8482$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $3ea17bf47e0c8482$export$cf507b112810e72d)
})({});
const $a94b451b352b13ae$var$Input = /*#__PURE__*/ $i5lfL.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $7qXFD.default)(props, $a94b451b352b13ae$var$_excluded);
    const classes = $a94b451b352b13ae$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $FRCsQ.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $a94b451b352b13ae$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $a94b451b352b13ae$var$InputInput;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3ea17bf47e0c8482$export$2e2bcd8739ae039), (0, $1CWiu.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$a94b451b352b13ae$var$Input.muiName = 'Input';
var $a94b451b352b13ae$export$2e2bcd8739ae039 = $a94b451b352b13ae$var$Input;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");

var $FRCsQ = parcelRequire("FRCsQ");



var $2ktY3 = parcelRequire("2ktY3");


var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $kp44S = parcelRequire("kp44S");

var $1CWiu = parcelRequire("1CWiu");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");

function $562388fc2770680b$export$3331e419f1a48437(slot) {
    return (0, $6bbZp.default)('MuiFilledInput', slot);
}
const $562388fc2770680b$var$filledInputClasses = (0, $1CWiu.default)({}, (0, $08e5d2b1a59391fa$export$2e2bcd8739ae039), (0, $47i1c.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $562388fc2770680b$export$2e2bcd8739ae039 = $562388fc2770680b$var$filledInputClasses;




var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $98a677f1a5555eb1$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $98a677f1a5555eb1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $2ktY3.default)(slots, (0, $562388fc2770680b$export$3331e419f1a48437), classes);
    return (0, $1CWiu.default)({}, classes, composedClasses);
};
const $98a677f1a5555eb1$var$FilledInputRoot = (0, $j7y1Z.default)((0, $3ea17bf47e0c8482$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $1FZvT.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $3ea17bf47e0c8482$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $1CWiu.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $562388fc2770680b$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $562388fc2770680b$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $562388fc2770680b$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $562388fc2770680b$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $562388fc2770680b$export$2e2bcd8739ae039).disabled}, .${(0, $562388fc2770680b$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $562388fc2770680b$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $1CWiu.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $98a677f1a5555eb1$var$FilledInputInput = (0, $j7y1Z.default)((0, $3ea17bf47e0c8482$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $3ea17bf47e0c8482$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $98a677f1a5555eb1$var$FilledInput = /*#__PURE__*/ $i5lfL.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $7qXFD.default)(props, $98a677f1a5555eb1$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $98a677f1a5555eb1$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $FRCsQ.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $98a677f1a5555eb1$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $98a677f1a5555eb1$var$FilledInputInput;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3ea17bf47e0c8482$export$2e2bcd8739ae039), (0, $1CWiu.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$98a677f1a5555eb1$var$FilledInput.muiName = 'Input';
var $98a677f1a5555eb1$export$2e2bcd8739ae039 = $98a677f1a5555eb1$var$FilledInput;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");



var $2ktY3 = parcelRequire("2ktY3");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");
parcelRequire("i5lfL");


var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $834e3746f0818354$var$_span;
const $834e3746f0818354$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $834e3746f0818354$var$NotchedOutlineRoot = (0, $j7y1Z.default)('fieldset', {
    shouldForwardProp: (0, $1FZvT.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $834e3746f0818354$var$NotchedOutlineLegend = (0, $j7y1Z.default)('legend', {
    shouldForwardProp: (0, $1FZvT.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $1CWiu.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $1CWiu.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $834e3746f0818354$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $7qXFD.default)(props, $834e3746f0818354$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $1CWiu.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($834e3746f0818354$var$NotchedOutlineRoot, (0, $1CWiu.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($834e3746f0818354$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
                children: label
            }) : $834e3746f0818354$var$_span || ($834e3746f0818354$var$_span = /*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $1CWiu = parcelRequire("1CWiu");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");

function $d294eda8fa953b30$export$89922944c7227687(slot) {
    return (0, $6bbZp.default)('MuiOutlinedInput', slot);
}
const $d294eda8fa953b30$var$outlinedInputClasses = (0, $1CWiu.default)({}, (0, $08e5d2b1a59391fa$export$2e2bcd8739ae039), (0, $47i1c.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $d294eda8fa953b30$export$2e2bcd8739ae039 = $d294eda8fa953b30$var$outlinedInputClasses;




var $kp44S = parcelRequire("kp44S");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $290872056b429acf$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $290872056b429acf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $2ktY3.default)(slots, (0, $d294eda8fa953b30$export$89922944c7227687), classes);
    return (0, $1CWiu.default)({}, classes, composedClasses);
};
const $290872056b429acf$var$OutlinedInputRoot = (0, $j7y1Z.default)((0, $3ea17bf47e0c8482$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $1FZvT.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $3ea17bf47e0c8482$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $1CWiu.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $d294eda8fa953b30$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $d294eda8fa953b30$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $d294eda8fa953b30$export$2e2bcd8739ae039).focused} .${(0, $d294eda8fa953b30$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $d294eda8fa953b30$export$2e2bcd8739ae039).error} .${(0, $d294eda8fa953b30$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $d294eda8fa953b30$export$2e2bcd8739ae039).disabled} .${(0, $d294eda8fa953b30$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $1CWiu.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $290872056b429acf$var$NotchedOutlineRoot = (0, $j7y1Z.default)((0, $834e3746f0818354$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $290872056b429acf$var$OutlinedInputInput = (0, $j7y1Z.default)((0, $3ea17bf47e0c8482$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $3ea17bf47e0c8482$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $290872056b429acf$var$OutlinedInput = /*#__PURE__*/ $i5lfL.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $7qXFD.default)(props, $290872056b429acf$var$_excluded);
    const classes = $290872056b429acf$var$useUtilityClasses(props);
    const muiFormControl = (0, $01f467cf0a9ed9ad$export$2e2bcd8739ae039)();
    const fcs = (0, $0c562896955434b6$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $290872056b429acf$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $290872056b429acf$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3ea17bf47e0c8482$export$2e2bcd8739ae039), (0, $1CWiu.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $bHJbJ.jsx)($290872056b429acf$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $1CWiu.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$290872056b429acf$var$OutlinedInput.muiName = 'Input';
var $290872056b429acf$export$2e2bcd8739ae039 = $290872056b429acf$var$OutlinedInput;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $2ktY3 = parcelRequire("2ktY3");

var $kRbLW = parcelRequire("kRbLW");



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");



var $VEXgj = parcelRequire("VEXgj");

var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $6af15d82d4f2f4af$export$f7d501e40371cd17(slot) {
    return (0, $6bbZp.default)('MuiFormLabel', slot);
}
const $6af15d82d4f2f4af$var$formLabelClasses = (0, $47i1c.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $6af15d82d4f2f4af$export$2e2bcd8739ae039 = $6af15d82d4f2f4af$var$formLabelClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $0019b05b31139609$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $0019b05b31139609$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $VEXgj.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $6af15d82d4f2f4af$export$f7d501e40371cd17), classes);
};
const $0019b05b31139609$export$aa5bc7f8a4705b27 = (0, $j7y1Z.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $1CWiu.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $6af15d82d4f2f4af$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $6af15d82d4f2f4af$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $6af15d82d4f2f4af$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $0019b05b31139609$var$AsteriskComponent = (0, $j7y1Z.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $6af15d82d4f2f4af$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $0019b05b31139609$var$FormLabel = /*#__PURE__*/ $i5lfL.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $7qXFD.default)(props, $0019b05b31139609$var$_excluded);
    const muiFormControl = (0, $01f467cf0a9ed9ad$export$2e2bcd8739ae039)();
    const fcs = (0, $0c562896955434b6$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $0019b05b31139609$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($0019b05b31139609$export$aa5bc7f8a4705b27, (0, $1CWiu.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $kRbLW.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $bHJbJ.jsxs)($0019b05b31139609$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $0019b05b31139609$export$2e2bcd8739ae039 = $0019b05b31139609$var$FormLabel;



var $kp44S = parcelRequire("kp44S");

var $VEXgj = parcelRequire("VEXgj");

var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $66ac31c76ac3f714$export$c1c4b4545ad2ea5f(slot) {
    return (0, $6bbZp.default)('MuiInputLabel', slot);
}
const $66ac31c76ac3f714$var$inputLabelClasses = (0, $47i1c.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $66ac31c76ac3f714$export$2e2bcd8739ae039 = $66ac31c76ac3f714$var$inputLabelClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $1e5dd5d1f3980790$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $1e5dd5d1f3980790$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $VEXgj.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $2ktY3.default)(slots, (0, $66ac31c76ac3f714$export$c1c4b4545ad2ea5f), classes);
    return (0, $1CWiu.default)({}, classes, composedClasses);
};
const $1e5dd5d1f3980790$var$InputLabelRoot = (0, $j7y1Z.default)((0, $0019b05b31139609$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1FZvT.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $6af15d82d4f2f4af$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $1CWiu.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $1CWiu.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $1CWiu.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $1e5dd5d1f3980790$var$InputLabel = /*#__PURE__*/ $i5lfL.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $7qXFD.default)(props, $1e5dd5d1f3980790$var$_excluded);
    const muiFormControl = (0, $01f467cf0a9ed9ad$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $0c562896955434b6$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $1CWiu.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $1e5dd5d1f3980790$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($1e5dd5d1f3980790$var$InputLabelRoot, (0, $1CWiu.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $kRbLW.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $1e5dd5d1f3980790$export$2e2bcd8739ae039 = $1e5dd5d1f3980790$var$InputLabel;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");


var $VEXgj = parcelRequire("VEXgj");

var $i5lfL = parcelRequire("i5lfL");
function $df0b14e686ced797$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $i5lfL.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $20589bf20977e1b2$export$2e2bcd8739ae039 = (0, $df0b14e686ced797$export$2e2bcd8739ae039);




var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $7055a76e9e9985bb$export$149c8b8bab2289d1(slot) {
    return (0, $6bbZp.default)('MuiFormControl', slot);
}
const $7055a76e9e9985bb$var$formControlClasses = (0, $47i1c.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $7055a76e9e9985bb$export$2e2bcd8739ae039 = $7055a76e9e9985bb$var$formControlClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $3b3376bc3ccaa047$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $3b3376bc3ccaa047$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $VEXgj.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $7055a76e9e9985bb$export$149c8b8bab2289d1), classes);
};
const $3b3376bc3ccaa047$var$FormControlRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $1CWiu.default)({}, styles.root, styles[`margin${(0, $VEXgj.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $3b3376bc3ccaa047$var$FormControl = /*#__PURE__*/ $i5lfL.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $7qXFD.default)(props, $3b3376bc3ccaa047$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $3b3376bc3ccaa047$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $i5lfL.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $i5lfL.Children.forEach(children, (child)=>{
            if (!(0, $20589bf20977e1b2$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $20589bf20977e1b2$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $1becf3f0467ed23a$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $i5lfL.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $i5lfL.Children.forEach(children, (child)=>{
            if (!(0, $20589bf20977e1b2$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $1becf3f0467ed23a$export$d652b828d7fdeff8)(child.props, true) || (0, $1becf3f0467ed23a$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $i5lfL.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $i5lfL.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $9f1ff024a5549c12$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($3b3376bc3ccaa047$var$FormControlRoot, (0, $1CWiu.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $kRbLW.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $3b3376bc3ccaa047$export$2e2bcd8739ae039 = $3b3376bc3ccaa047$var$FormControl;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");



var $j7y1Z = parcelRequire("j7y1Z");

var $VEXgj = parcelRequire("VEXgj");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $0fd6e47f8d161e37$export$a394fa61b1d583a9(slot) {
    return (0, $6bbZp.default)('MuiFormHelperText', slot);
}
const $0fd6e47f8d161e37$var$formHelperTextClasses = (0, $47i1c.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $0fd6e47f8d161e37$export$2e2bcd8739ae039 = $0fd6e47f8d161e37$var$formHelperTextClasses;



var $kp44S = parcelRequire("kp44S");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $768d8f0163d595a3$var$_span;
const $768d8f0163d595a3$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $768d8f0163d595a3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $VEXgj.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $0fd6e47f8d161e37$export$a394fa61b1d583a9), classes);
};
const $768d8f0163d595a3$var$FormHelperTextRoot = (0, $j7y1Z.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $VEXgj.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $0fd6e47f8d161e37$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $0fd6e47f8d161e37$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $768d8f0163d595a3$var$FormHelperText = /*#__PURE__*/ $i5lfL.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $7qXFD.default)(props, $768d8f0163d595a3$var$_excluded);
    const muiFormControl = (0, $01f467cf0a9ed9ad$export$2e2bcd8739ae039)();
    const fcs = (0, $0c562896955434b6$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $768d8f0163d595a3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($768d8f0163d595a3$var$FormHelperTextRoot, (0, $1CWiu.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $kRbLW.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $768d8f0163d595a3$var$_span || ($768d8f0163d595a3$var$_span = /*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $768d8f0163d595a3$export$2e2bcd8739ae039 = $768d8f0163d595a3$var$FormHelperText;



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $FRCsQ = parcelRequire("FRCsQ");

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $1SAXO = parcelRequire("1SAXO");

var $i5lfL = parcelRequire("i5lfL");
parcelRequire("67Wr0");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");



var $46552687c83b186a$export$2e2bcd8739ae039 = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039);



var $VEXgj = parcelRequire("VEXgj");

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");
parcelRequire("67Wr0");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");




var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");
parcelRequire("67Wr0");



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $i5lfL = parcelRequire("i5lfL");
'use client';
/**
 * @ignore - internal component.
 */ const $5f2cac3e7c0585d2$var$ListContext = /*#__PURE__*/ $i5lfL.createContext({});
var $5f2cac3e7c0585d2$export$2e2bcd8739ae039 = $5f2cac3e7c0585d2$var$ListContext;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $c9cf1a4abf1d4136$export$c6bd6795ed6e3203(slot) {
    return (0, $6bbZp.default)('MuiList', slot);
}
const $c9cf1a4abf1d4136$var$listClasses = (0, $47i1c.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $c9cf1a4abf1d4136$export$2e2bcd8739ae039 = $c9cf1a4abf1d4136$var$listClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $2d146a5b562efa19$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $2d146a5b562efa19$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $c9cf1a4abf1d4136$export$c6bd6795ed6e3203), classes);
};
const $2d146a5b562efa19$var$ListRoot = (0, $j7y1Z.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $2d146a5b562efa19$var$List = /*#__PURE__*/ $i5lfL.forwardRef(function List(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $7qXFD.default)(props, $2d146a5b562efa19$var$_excluded);
    const context = $i5lfL.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $2d146a5b562efa19$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $5f2cac3e7c0585d2$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)($2d146a5b562efa19$var$ListRoot, (0, $1CWiu.default)({
            as: component,
            className: (0, $kRbLW.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $2d146a5b562efa19$export$2e2bcd8739ae039 = $2d146a5b562efa19$var$List;



var $648e3936594a0283$export$2e2bcd8739ae039 = (0, $6654636ca7f78387$export$2e2bcd8739ae039);





var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $540650fae75a11e0$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $540650fae75a11e0$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $540650fae75a11e0$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $540650fae75a11e0$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $540650fae75a11e0$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$540650fae75a11e0$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $540650fae75a11e0$var$MenuList = /*#__PURE__*/ $i5lfL.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $7qXFD.default)(props, $540650fae75a11e0$var$_excluded);
    const listRef = $i5lfL.useRef(null);
    const textCriteriaRef = $i5lfL.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $946b6dd96ae69a8b$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $i5lfL.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $648e3936594a0283$export$2e2bcd8739ae039)((0, $46552687c83b186a$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $46552687c83b186a$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $540650fae75a11e0$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $540650fae75a11e0$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $540650fae75a11e0$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $540650fae75a11e0$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $540650fae75a11e0$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $540650fae75a11e0$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $540650fae75a11e0$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $540650fae75a11e0$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $540650fae75a11e0$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $540650fae75a11e0$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $540650fae75a11e0$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $i5lfL.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $i5lfL.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $i5lfL.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $i5lfL.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $2d146a5b562efa19$export$2e2bcd8739ae039), (0, $1CWiu.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $540650fae75a11e0$export$2e2bcd8739ae039 = $540650fae75a11e0$var$MenuList;



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");








var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $35800e9c430cfaca$export$2e2bcd8739ae039 = (0, $d215165998bf3530$export$2e2bcd8739ae039);




var $1f9da73f8999125a$export$2e2bcd8739ae039 = (0, $ca776b19cb3fc829$export$2e2bcd8739ae039);




var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");








var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $66de9c04029c8d70$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $66de9c04029c8d70$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $66de9c04029c8d70$var$styles = {
    entering: {
        opacity: 1,
        transform: $66de9c04029c8d70$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $66de9c04029c8d70$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $66de9c04029c8d70$var$Grow = /*#__PURE__*/ $i5lfL.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $3011cc386e359a11$export$2e2bcd8739ae039) } = props, other = (0, $7qXFD.default)(props, $66de9c04029c8d70$var$_excluded);
    const timer = (0, $fa9c2cea1dcc0b6d$export$2e2bcd8739ae039)();
    const autoTimeout = $i5lfL.useRef();
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const nodeRef = $i5lfL.useRef(null);
    const handleRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $de1e3dddb137b7cc$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $de1e3dddb137b7cc$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $66de9c04029c8d70$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $de1e3dddb137b7cc$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $66de9c04029c8d70$var$isWebKit154 ? duration : duration * 0.666,
                delay: $66de9c04029c8d70$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $66de9c04029c8d70$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsx)(TransitionComponent, (0, $1CWiu.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $i5lfL.cloneElement(children, (0, $1CWiu.default)({
                style: (0, $1CWiu.default)({
                    opacity: 0,
                    transform: $66de9c04029c8d70$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $66de9c04029c8d70$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$66de9c04029c8d70$var$Grow.muiSupportAuto = true;
var $66de9c04029c8d70$export$2e2bcd8739ae039 = $66de9c04029c8d70$var$Grow;





var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $bfc416b851cbb768$export$88f455dd56c95edb(slot) {
    return (0, $6bbZp.default)('MuiPopover', slot);
}
const $bfc416b851cbb768$var$popoverClasses = (0, $47i1c.default)('MuiPopover', [
    'root',
    'paper'
]);
var $bfc416b851cbb768$export$2e2bcd8739ae039 = $bfc416b851cbb768$var$popoverClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $41cb516457a8981d$var$_excluded = [
    "onEntering"
], $41cb516457a8981d$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $41cb516457a8981d$var$_excluded3 = [
    "slotProps"
];
function $41cb516457a8981d$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $41cb516457a8981d$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $41cb516457a8981d$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $41cb516457a8981d$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $41cb516457a8981d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $bfc416b851cbb768$export$88f455dd56c95edb), classes);
};
const $41cb516457a8981d$export$bcce13685275fc99 = (0, $j7y1Z.default)((0, $a442c1b1e4af20c7$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $41cb516457a8981d$export$821346c38a2d9390 = (0, $j7y1Z.default)((0, $fa105ed17f31a2c8$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $41cb516457a8981d$var$Popover = /*#__PURE__*/ $i5lfL.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $66de9c04029c8d70$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $7qXFD.default)(props.TransitionProps, $41cb516457a8981d$var$_excluded), other = (0, $7qXFD.default)(props, $41cb516457a8981d$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $i5lfL.useRef();
    const handlePaperRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $1CWiu.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $41cb516457a8981d$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $i5lfL.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $41cb516457a8981d$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $46552687c83b186a$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $41cb516457a8981d$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $41cb516457a8981d$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $i5lfL.useCallback((elemRect)=>{
        return {
            vertical: $41cb516457a8981d$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $41cb516457a8981d$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $i5lfL.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $41cb516457a8981d$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $1f9da73f8999125a$export$2e2bcd8739ae039)($41cb516457a8981d$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $41cb516457a8981d$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $i5lfL.useState(open);
    const setPositioningStyles = $i5lfL.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $i5lfL.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $i5lfL.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $i5lfL.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $i5lfL.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $35800e9c430cfaca$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $1f9da73f8999125a$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $46552687c83b186a$export$2e2bcd8739ae039)($41cb516457a8981d$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $41cb516457a8981d$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $41cb516457a8981d$export$821346c38a2d9390;
    const paperProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $1CWiu.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $1CWiu.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $kRbLW.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $kRbLW.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $7qXFD.default)(_useSlotProps, $41cb516457a8981d$var$_excluded3);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)(RootSlot, (0, $1CWiu.default)({}, rootProps, !(0, $d7066316d4f9103f$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)(TransitionComponent, (0, $1CWiu.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $bHJbJ.jsx)(PaperSlot, (0, $1CWiu.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $41cb516457a8981d$export$2e2bcd8739ae039 = $41cb516457a8981d$var$Popover;



var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $kp44S = parcelRequire("kp44S");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $f558c3142efc8300$export$2cf86a63a84fe23d(slot) {
    return (0, $6bbZp.default)('MuiMenu', slot);
}
const $f558c3142efc8300$var$menuClasses = (0, $47i1c.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $f558c3142efc8300$export$2e2bcd8739ae039 = $f558c3142efc8300$var$menuClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $6e1d5d5a1ad3ef09$var$_excluded = [
    "onEntering"
], $6e1d5d5a1ad3ef09$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $6e1d5d5a1ad3ef09$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $6e1d5d5a1ad3ef09$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $6e1d5d5a1ad3ef09$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $f558c3142efc8300$export$2cf86a63a84fe23d), classes);
};
const $6e1d5d5a1ad3ef09$var$MenuRoot = (0, $j7y1Z.default)((0, $41cb516457a8981d$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1FZvT.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $6e1d5d5a1ad3ef09$export$4f7c51a5920c9f33 = (0, $j7y1Z.default)((0, $41cb516457a8981d$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $6e1d5d5a1ad3ef09$var$MenuMenuList = (0, $j7y1Z.default)((0, $540650fae75a11e0$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $6e1d5d5a1ad3ef09$var$Menu = /*#__PURE__*/ $i5lfL.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $7qXFD.default)(props.TransitionProps, $6e1d5d5a1ad3ef09$var$_excluded), other = (0, $7qXFD.default)(props, $6e1d5d5a1ad3ef09$var$_excluded2);
    const isRtl = (0, $dd848b3fb63e28ea$export$b2dd014b6c321cb)();
    const ownerState = (0, $1CWiu.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $6e1d5d5a1ad3ef09$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $i5lfL.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $i5lfL.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $i5lfL.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $6e1d5d5a1ad3ef09$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($6e1d5d5a1ad3ef09$var$MenuRoot, (0, $1CWiu.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $6e1d5d5a1ad3ef09$var$RTL_ORIGIN : $6e1d5d5a1ad3ef09$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $1CWiu.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($6e1d5d5a1ad3ef09$var$MenuMenuList, (0, $1CWiu.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $kRbLW.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $6e1d5d5a1ad3ef09$export$2e2bcd8739ae039 = $6e1d5d5a1ad3ef09$var$Menu;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");


var $2ktY3 = parcelRequire("2ktY3");

var $VEXgj = parcelRequire("VEXgj");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $d80f40095733daee$export$1ee13051fd9e2ab5(slot) {
    return (0, $6bbZp.default)('MuiNativeSelect', slot);
}
const $d80f40095733daee$var$nativeSelectClasses = (0, $47i1c.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $d80f40095733daee$export$2e2bcd8739ae039 = $d80f40095733daee$var$nativeSelectClasses;



var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $99a23db82e446eac$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $99a23db82e446eac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $VEXgj.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $d80f40095733daee$export$1ee13051fd9e2ab5), classes);
};
const $99a23db82e446eac$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $1CWiu.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $1CWiu.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $d80f40095733daee$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $99a23db82e446eac$var$NativeSelectSelect = (0, $j7y1Z.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $1FZvT.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $d80f40095733daee$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($99a23db82e446eac$export$c1eccd1617458c87);
const $99a23db82e446eac$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $1CWiu.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $d80f40095733daee$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $99a23db82e446eac$var$NativeSelectIcon = (0, $j7y1Z.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $VEXgj.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($99a23db82e446eac$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $99a23db82e446eac$var$NativeSelectInput = /*#__PURE__*/ $i5lfL.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $7qXFD.default)(props, $99a23db82e446eac$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $99a23db82e446eac$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)($99a23db82e446eac$var$NativeSelectSelect, (0, $1CWiu.default)({
                ownerState: ownerState,
                className: (0, $kRbLW.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $bHJbJ.jsx)($99a23db82e446eac$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $99a23db82e446eac$export$2e2bcd8739ae039 = $99a23db82e446eac$var$NativeSelectInput;




var $j7y1Z = parcelRequire("j7y1Z");
var $iYTvc = parcelRequire("iYTvc");


var $i5lfL = parcelRequire("i5lfL");
'use client';
function $50778d58d10a200e$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $i5lfL.useRef(controlled !== undefined);
    const [valueState, setValue] = $i5lfL.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $i5lfL.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $84df25be484a0877$export$2e2bcd8739ae039 = (0, $50778d58d10a200e$export$2e2bcd8739ae039);



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $7701b10da0f575ad$export$2c0c1ee5a3392e(slot) {
    return (0, $6bbZp.default)('MuiSelect', slot);
}
const $7701b10da0f575ad$var$selectClasses = (0, $47i1c.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $7701b10da0f575ad$export$2e2bcd8739ae039 = $7701b10da0f575ad$var$selectClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $97e7def069444a6b$var$_span;
const $97e7def069444a6b$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $97e7def069444a6b$var$SelectSelect = (0, $j7y1Z.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $7701b10da0f575ad$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $7701b10da0f575ad$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $7701b10da0f575ad$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $7701b10da0f575ad$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $99a23db82e446eac$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $7701b10da0f575ad$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $97e7def069444a6b$var$SelectIcon = (0, $j7y1Z.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $VEXgj.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $99a23db82e446eac$export$e7a817afd12a40d0));
const $97e7def069444a6b$var$SelectNativeInput = (0, $j7y1Z.default)('input', {
    shouldForwardProp: (prop)=>(0, $iYTvc.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $97e7def069444a6b$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $97e7def069444a6b$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $97e7def069444a6b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $VEXgj.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $7701b10da0f575ad$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $97e7def069444a6b$var$SelectInput = /*#__PURE__*/ $i5lfL.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $7qXFD.default)(props, $97e7def069444a6b$var$_excluded);
    const [value, setValueState] = (0, $84df25be484a0877$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $84df25be484a0877$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $i5lfL.useRef(null);
    const displayRef = $i5lfL.useRef(null);
    const [displayNode, setDisplayNode] = $i5lfL.useState(null);
    const { current: isOpenControlled } = $i5lfL.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $i5lfL.useState();
    const handleRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $i5lfL.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $i5lfL.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $i5lfL.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $i5lfL.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $i5lfL.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $46552687c83b186a$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $i5lfL.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $1becf3f0467ed23a$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $i5lfL.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $1SAXO.default)(2));
            selected = value.some((v)=>$97e7def069444a6b$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $97e7def069444a6b$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $i5lfL.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $1CWiu.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $97e7def069444a6b$var$useUtilityClasses(ownerState);
    const paperProps = (0, $1CWiu.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $f3f83812f7a42248$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)($97e7def069444a6b$var$SelectSelect, (0, $1CWiu.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $kRbLW.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $97e7def069444a6b$var$isEmpty(display) ? $97e7def069444a6b$var$_span || ($97e7def069444a6b$var$_span = /*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $bHJbJ.jsx)($97e7def069444a6b$var$SelectNativeInput, (0, $1CWiu.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $bHJbJ.jsx)($97e7def069444a6b$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $6e1d5d5a1ad3ef09$export$2e2bcd8739ae039), (0, $1CWiu.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $1CWiu.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $1CWiu.default)({}, MenuProps.slotProps, {
                    paper: (0, $1CWiu.default)({}, paperProps, {
                        style: (0, $1CWiu.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $97e7def069444a6b$export$2e2bcd8739ae039 = $97e7def069444a6b$var$SelectInput;




parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $3b3cb2829f4f8827$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');







var $kp44S = parcelRequire("kp44S");


var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $f25919672eb20630$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $f25919672eb20630$var$_excluded2 = [
    "root"
];
const $f25919672eb20630$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $f25919672eb20630$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $1FZvT.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $f25919672eb20630$var$StyledInput = (0, $j7y1Z.default)((0, $a94b451b352b13ae$export$2e2bcd8739ae039), $f25919672eb20630$var$styledRootConfig)('');
const $f25919672eb20630$var$StyledOutlinedInput = (0, $j7y1Z.default)((0, $290872056b429acf$export$2e2bcd8739ae039), $f25919672eb20630$var$styledRootConfig)('');
const $f25919672eb20630$var$StyledFilledInput = (0, $j7y1Z.default)((0, $98a677f1a5555eb1$export$2e2bcd8739ae039), $f25919672eb20630$var$styledRootConfig)('');
const $f25919672eb20630$var$Select = /*#__PURE__*/ $i5lfL.forwardRef(function Select(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $3b3cb2829f4f8827$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $7qXFD.default)(props, $f25919672eb20630$var$_excluded);
    const inputComponent = native ? (0, $99a23db82e446eac$export$2e2bcd8739ae039) : (0, $97e7def069444a6b$export$2e2bcd8739ae039);
    const muiFormControl = (0, $01f467cf0a9ed9ad$export$2e2bcd8739ae039)();
    const fcs = (0, $0c562896955434b6$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $1CWiu.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $f25919672eb20630$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $7qXFD.default)(classes, $f25919672eb20630$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $bHJbJ.jsx)($f25919672eb20630$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $bHJbJ.jsx)($f25919672eb20630$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $bHJbJ.jsx)($f25919672eb20630$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($i5lfL.Fragment, {
        children: /*#__PURE__*/ $i5lfL.cloneElement(InputComponent, (0, $1CWiu.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $1CWiu.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $1CWiu.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $FRCsQ.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $kRbLW.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$f25919672eb20630$var$Select.muiName = 'Select';
var $f25919672eb20630$export$2e2bcd8739ae039 = $f25919672eb20630$var$Select;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $80da73f7999b8cc6$export$c1bdcbaf0596aeda(slot) {
    return (0, $6bbZp.default)('MuiTextField', slot);
}
const $80da73f7999b8cc6$var$textFieldClasses = (0, $47i1c.default)('MuiTextField', [
    'root'
]);
var $80da73f7999b8cc6$export$2e2bcd8739ae039 = $80da73f7999b8cc6$var$textFieldClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $1817a2bcf8f12485$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $1817a2bcf8f12485$var$variantComponent = {
    standard: (0, $a94b451b352b13ae$export$2e2bcd8739ae039),
    filled: (0, $98a677f1a5555eb1$export$2e2bcd8739ae039),
    outlined: (0, $290872056b429acf$export$2e2bcd8739ae039)
};
const $1817a2bcf8f12485$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $80da73f7999b8cc6$export$c1bdcbaf0596aeda), classes);
};
const $1817a2bcf8f12485$var$TextFieldRoot = (0, $j7y1Z.default)((0, $3b3376bc3ccaa047$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $1817a2bcf8f12485$var$TextField = /*#__PURE__*/ $i5lfL.forwardRef(function TextField(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $7qXFD.default)(props, $1817a2bcf8f12485$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $1817a2bcf8f12485$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $f3f83812f7a42248$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $1817a2bcf8f12485$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $bHJbJ.jsx)(InputComponent, (0, $1CWiu.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($1817a2bcf8f12485$var$TextFieldRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1e5dd5d1f3980790$export$2e2bcd8739ae039), (0, $1CWiu.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $f25919672eb20630$export$2e2bcd8739ae039), (0, $1CWiu.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $768d8f0163d595a3$export$2e2bcd8739ae039), (0, $1CWiu.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $1817a2bcf8f12485$export$2e2bcd8739ae039 = $1817a2bcf8f12485$var$TextField;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");

var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $kp44S = parcelRequire("kp44S");





var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $f3f8af719fb6ce1f$export$46f01d01378ec5a2(slot) {
    return (0, $6bbZp.default)('MuiDivider', slot);
}
const $f3f8af719fb6ce1f$var$dividerClasses = (0, $47i1c.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $f3f8af719fb6ce1f$export$2e2bcd8739ae039 = $f3f8af719fb6ce1f$var$dividerClasses;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $2df420ef9599b05a$export$81478e24460c57f2(slot) {
    return (0, $6bbZp.default)('MuiListItemIcon', slot);
}
const $2df420ef9599b05a$var$listItemIconClasses = (0, $47i1c.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $2df420ef9599b05a$export$2e2bcd8739ae039 = $2df420ef9599b05a$var$listItemIconClasses;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $3ac3cbf64e1fe003$export$1061006a0db3aeb5(slot) {
    return (0, $6bbZp.default)('MuiListItemText', slot);
}
const $3ac3cbf64e1fe003$var$listItemTextClasses = (0, $47i1c.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $3ac3cbf64e1fe003$export$2e2bcd8739ae039 = $3ac3cbf64e1fe003$var$listItemTextClasses;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $90f2b445f9b86e7e$export$515f8c67b5305377(slot) {
    return (0, $6bbZp.default)('MuiMenuItem', slot);
}
const $90f2b445f9b86e7e$var$menuItemClasses = (0, $47i1c.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $90f2b445f9b86e7e$export$2e2bcd8739ae039 = $90f2b445f9b86e7e$var$menuItemClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $233ec4675cd9b906$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $233ec4675cd9b906$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $233ec4675cd9b906$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $2ktY3.default)(slots, (0, $90f2b445f9b86e7e$export$515f8c67b5305377), classes);
    return (0, $1CWiu.default)({}, classes, composedClasses);
};
const $233ec4675cd9b906$var$MenuItemRoot = (0, $j7y1Z.default)((0, $07a3ed667acb77f6$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1FZvT.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $233ec4675cd9b906$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $90f2b445f9b86e7e$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8AHNG.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $90f2b445f9b86e7e$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8AHNG.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $90f2b445f9b86e7e$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8AHNG.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8AHNG.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $90f2b445f9b86e7e$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $90f2b445f9b86e7e$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $f3f8af719fb6ce1f$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $f3f8af719fb6ce1f$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $3ac3cbf64e1fe003$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $3ac3cbf64e1fe003$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $2df420ef9599b05a$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $1CWiu.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $2df420ef9599b05a$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $233ec4675cd9b906$var$MenuItem = /*#__PURE__*/ $i5lfL.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $7qXFD.default)(props, $233ec4675cd9b906$var$_excluded);
    const context = $i5lfL.useContext((0, $5f2cac3e7c0585d2$export$2e2bcd8739ae039));
    const childContext = $i5lfL.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $i5lfL.useRef(null);
    (0, $946b6dd96ae69a8b$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $1CWiu.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $233ec4675cd9b906$var$useUtilityClasses(props);
    const handleRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $5f2cac3e7c0585d2$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($233ec4675cd9b906$var$MenuItemRoot, (0, $1CWiu.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $kRbLW.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $kRbLW.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $233ec4675cd9b906$export$2e2bcd8739ae039 = $233ec4675cd9b906$var$MenuItem;




var $j7y1Z = parcelRequire("j7y1Z");

var $i5lfL = parcelRequire("i5lfL");


/* API endpoint URL */ const $24846570078166ea$export$d9391cfe998c8118 = "https://ia-mcp-data-api-builder-dev.australiaeast.azurecontainer.io/graphql";
const $24846570078166ea$export$bba4b5af5378a4a1 = "https://ia-mcp-sm-dev-email-api-function-app.azurewebsites.net/api/HttpTrigger?code=MwHOJfnlII3r2Y6SmMP-Lc-0DGtBvm_nS6a9gUnj0KK-AzFuTtarcg==";
const $24846570078166ea$export$a9064eafcaf8348e = "https://mcpgeoserver-cbdhcjhjawe6h7hy.australiaeast-01.azurewebsites.net/gwc/service/tms/1.0.0/mcp%3ASA4_2021_GCCSA_MERGED_3857@EPSG%3A900913@pbf/{z}/{x}/{-y}.pbf";
const $24846570078166ea$export$4a4279851f111273 = "https://mcpgeoserver-cbdhcjhjawe6h7hy.australiaeast-01.azurewebsites.net/gwc/service/tms/1.0.0/mcp:STE_2021_AUST_3857@EPSG:900913@pbf/{z}/{x}/{-y}.pbf";


var $fce7f459a03976d5$exports = {};
!function(t, e) {
    $fce7f459a03976d5$exports = e();
}($fce7f459a03976d5$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


const $243a1246ea7835d9$export$5dbac6ca1d81f28 = {
    ProjID: "",
    SourceID: "",
    ProjectName: "",
    State: "",
    LocationID: "",
    Source: "",
    Investment: 0,
    RawProjectType: "",
    ProjectStage: "",
    StartDateConstruction: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))().toISOString(),
    EndDateConstruction: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))().toISOString(),
    PeriodStartYear: "",
    PeriodEndYear: "",
    FundingMode: "",
    km: 0,
    MW: 0,
    M2: 0,
    // @ts-ignore
    ScenarioProjID: null,
    // @ts-ignore
    ScenarioID: null,
    EditedProject: 1,
    removedProject: 0,
    ProcessingPath: 1
};
const $243a1246ea7835d9$export$b29a7c763ae8219 = {
    Source: "VIC",
    ProjectID: "12345",
    ProjectName: "Sample Project",
    State: "VIC",
    typeCast: "TypeA",
    Investment: 84000000,
    MW: 100,
    KM: 50,
    M2: 2000,
    ProjectStage: "StageA",
    DeliveryAgency: "Agency Name",
    ContractingModel: "Model Type",
    StartDateConstruction: "01/01/2023",
    EndDateConstruction: "01/01/2024",
    project_location: "Melbourne",
    Latitude: -37.8136,
    Longitude: 144.9631,
    FundingMode: "Public",
    sa4_code: "206",
    sa4_name: "Melbourne - Inner",
    CommonwealthFunding: 50000000,
    ProjectStatus: "Ongoing",
    PeriodStartYear: "01/01/2023",
    PeriodEndYear: "01/01/2024"
};
const $243a1246ea7835d9$export$8fb4476a9336a497 = {
    RawProjectType: "Baseline",
    PlanningTimePercentage: 15,
    ConstructionTimePercentage: 80,
    CommissioningTimePercentage: 5,
    PlanningCostPercentage: 31,
    ConstructionCostPercentage: 59,
    CommissioningCostPercentage: 10
};
const $243a1246ea7835d9$export$429689afd7ea514a = {
    RawProjectType: "",
    PlanningTimePercentage: 0,
    ConstructionTimePercentage: 0,
    CommissioningTimePercentage: 0,
    PlanningCostPercentage: 0,
    ConstructionCostPercentage: 0,
    CommissioningCostPercentage: 0
};
var $243a1246ea7835d9$export$46c5b3cb582b4b18 = /*#__PURE__*/ function(CreationMode) {
    CreationMode["New"] = "new";
    CreationMode["Saved"] = "saved";
    return CreationMode;
}({});
const $243a1246ea7835d9$export$38a702d7fc9d394a = {
    name: "",
    email: "",
    title: "",
    org: "",
    juri: ""
};
const $243a1246ea7835d9$export$14085c2a147de944 = [
    {
        value: "Private",
        text: "Private"
    },
    {
        value: "Public",
        text: "Public"
    },
    {
        value: "Portfolio",
        text: "Portfolio"
    },
    {
        value: "Public/Private",
        text: "Public/Private"
    }
];
const $243a1246ea7835d9$export$2425b41e18ec8805 = [
    {
        value: "Pre-construction",
        text: "Pre-construction"
    },
    {
        value: "Under construction",
        text: "Under construction"
    },
    {
        value: "Completed",
        text: "Completed"
    }
];
const $243a1246ea7835d9$export$68acbc4d2f93adde = {
    SourceID: "Original Project ID",
    ScenarioID: "Scenario ID",
    ProjectName: "ProjectName",
    State: "State",
    Source: "Source",
    Investment: "Investment ($Million)",
    RawProjectType: "Project Type",
    ProjectStage: "Project Latest Status",
    StartDateConstruction: "Construction Start Date",
    EndDateConstruction: "Construction End Date",
    FundingMode: "Funding Mode",
    LocationID: "Location",
    MW: "MW",
    km: "KM",
    M2: "M2",
    PeriodStartYear: "Period Start Year",
    PeriodEndYear: "Period End Year",
    EditedProject: "Edited Project",
    RemoveProjectFromModel: "Removed Project",
    ScenarioProjID: "Scenario Project ID",
    ProjID: "Project ID",
    ProjectTypeID: "Project Type",
    TimePlanning: "Planning Time Allocation",
    TimeConstruction: "Construction Time Allocation",
    TimeCommissioning: "Commission Time Allocation",
    InvestmentPlanning: "Planning Investment Allocation",
    InvestmentConstruction: "Construction Investment Allocation",
    InvestmentCommissioning: "Commission Investment Allocation",
    ProcessingPath: "Processing Path",
    OperateStatus: "Operate Status",
    Forecast: "Forecast",
    Ongoing: "Ongoing",
    Errors: "Errors"
};
const $243a1246ea7835d9$export$685bf383464b857b = {
    LastUploadedDate: "Last Uploaded Date",
    Source: "Source",
    ProjectID: "Project ID",
    ProjectName: "Project Name",
    Investment: "Investment ($)",
    State: "State",
    typeCast: "Project Type",
    MW: "MW",
    KM: "KM",
    M2: "M2",
    ProjectStage: "Project Stage",
    DeliveryAgency: "Delivery Agency",
    ContractingModel: "Contracting Model",
    StartDateConstruction: "Construction Start Date",
    EndDateConstruction: "Construction End Date",
    project_location: "Location",
    Latitude: "Latitude",
    Longitude: "Longitude",
    FundingMode: "Funding Mode",
    sa4_code: "SA4 Code",
    sa4_name: "SA4 Name",
    CommonwealthFunding: "Commonwealth Funding",
    ProjectStatus: "Project Status",
    PeriodStartYear: "Period Start Year",
    PeriodEndYear: "Period End Year"
};
const $243a1246ea7835d9$export$87edd524e90cb499 = [
    "Not all projects are included in the pipeline.",
    "Non-construction projects, projects missing information, or projects found duplicate in other sources might be removed.",
    "Please update existing projects, delete projects needs dropped, and add new projects into below list.",
    "PLEASE DO NOT CHANGE THE COLUMN ORDER, AND KEEP HEADER ON ROW 5."
];
const $243a1246ea7835d9$export$83b379386136b34b = [
    "Column R to T are for internal use only.",
    "Please use  the drop down list select project type and location and use dd/mm/yyyy format for dates.",
    "PLEASE DO NOT CHANGE THE COLUMN ORDER, AND KEEP HEADER ON ROW 4."
];
const $243a1246ea7835d9$export$ad98f2e8c6fd720d = [
    "Coal",
    "Gas and Liquids",
    "Hydro",
    "Wind",
    "Utility Solar",
    "Pumped Hydro"
];
const $243a1246ea7835d9$export$5be856edc6a7f539 = [
    "Transmission (other)",
    "Transmission Line: Double Circuit",
    "Transmission Line: Single Circuit"
];
const $243a1246ea7835d9$export$9bcd006cd4d2d851 = [
    "Semi-detached Residential - Forecast",
    "Detached Residential - Forecast"
];
const $243a1246ea7835d9$export$714a25c0e9cde501 = {
    "1": (preProjectType, currentProjectType)=>{
        if ([
            ...$243a1246ea7835d9$export$ad98f2e8c6fd720d,
            ...$243a1246ea7835d9$export$5be856edc6a7f539
        ].indexOf(currentProjectType) === -1) return [
            true,
            ""
        ];
        else return [
            false,
            "Please select a non energy/transmission project type"
        ];
    },
    "2": (preProjectType, currentProjectType)=>{
        if ($243a1246ea7835d9$export$ad98f2e8c6fd720d.indexOf(currentProjectType) > -1) return [
            true,
            ""
        ];
        else return [
            false,
            "Please select an energy generation project type"
        ];
    },
    "3": (preProjectType, currentProjectType)=>{
        if ($243a1246ea7835d9$export$ad98f2e8c6fd720d.indexOf(currentProjectType) > -1) return [
            true,
            ""
        ];
        else return [
            false,
            "Please select an energy generation project type"
        ];
    },
    "4": (preProjectType, currentProjectType)=>{
        if ([
            $243a1246ea7835d9$export$5be856edc6a7f539[1],
            $243a1246ea7835d9$export$5be856edc6a7f539[2]
        ].indexOf(currentProjectType) === -1 && [
            $243a1246ea7835d9$export$5be856edc6a7f539[1],
            $243a1246ea7835d9$export$5be856edc6a7f539[2]
        ].indexOf(preProjectType) !== -1) return [
            false,
            "Please select a transmission line project type"
        ];
        if ($243a1246ea7835d9$export$9bcd006cd4d2d851.indexOf(preProjectType) !== -1 && $243a1246ea7835d9$export$9bcd006cd4d2d851.indexOf(currentProjectType) === -1) return [
            false,
            "Please select a residential project type"
        ];
        return [
            true,
            ""
        ];
    },
    "5": (preProjectType, currentProjectType)=>{
        if ($243a1246ea7835d9$export$5be856edc6a7f539[0] === currentProjectType) return [
            true,
            ""
        ];
        else return [
            false,
            "Please select Transmission other as the project type"
        ];
    },
    "7": (preProjectType, currentProjectType)=>{
        if ([
            ...$243a1246ea7835d9$export$ad98f2e8c6fd720d,
            ...$243a1246ea7835d9$export$5be856edc6a7f539
        ].indexOf(currentProjectType) === -1) return [
            true,
            ""
        ];
        else return [
            false,
            "Please select an non energy/transmission project type"
        ];
    }
};
const $243a1246ea7835d9$export$64b7d035b35e2190 = [
    "#253746",
    "#7e2d40",
    "#73b469",
    "#e7b78a",
    "#c6264c",
    "#376d5f",
    "#ece81a",
    "#857874",
    "#ce6c45",
    "#8c4799",
    "#e2a78f",
    "#1f6899",
    "#abc7ca",
    "#8c7091",
    "#FFFF00",
    "#8c4799",
    "#edaf00",
    "#117a80",
    "#031e7f",
    "#c85f73",
    "#3a5a35",
    "#000000",
    "#edaf00",
    "#b2818c",
    "#87a79f",
    "#009245",
    "#EBD56E",
    "#376d5f",
    "#e25220",
    "#73b469",
    "#8c7091",
    "#8e0909",
    "#407e2d",
    "#2d407e",
    "#7e6b2d",
    "#700056",
    "#10c8ff",
    "#75B13B",
    "#4BA798",
    "#E54050",
    "#FDEF0A",
    "#62668F",
    "#C22932",
    "#F6A414",
    "#4B1279",
    "#9CA0AD",
    "#BAE356",
    "#88DDCD",
    "#CC47F4",
    "#6C9CE2",
    "#F8CB11",
    "#87A381",
    "#1C3847",
    "#fa6544",
    "#768584",
    "#E1BAB1",
    "#08D2B4",
    "#F79816",
    "#431E1E",
    "#B5B676",
    "#5E87F5",
    "#e7619e",
    "#97bd3d",
    "#ac3a4b",
    "#633149",
    "#cbe0e3",
    "#d71700",
    "#7d8098",
    "#c8af4a",
    "#504668",
    "#0eb676",
    "#70237f"
];
const $243a1246ea7835d9$export$5b013b72cff28011 = [
    3,
    4,
    5
];
const $243a1246ea7835d9$export$741e1112e38a63ea = 99999;
const $243a1246ea7835d9$export$e14144b8dabac519 = "WAITING TO RUN";
const $243a1246ea7835d9$export$26b866ce2249164d = "CALCULATING PIPELINE SIMULATION";


var $e7d90c09e211f052$exports = {};
"use strict";
Object.defineProperty($e7d90c09e211f052$exports, "__esModule", {
    value: true
});
$e7d90c09e211f052$exports.default = $e7d90c09e211f052$var$isEmail;

var $e7d90c09e211f052$var$_assertString = $e7d90c09e211f052$var$_interopRequireDefault((parcelRequire("jdqqT")));

var $e7d90c09e211f052$var$_isByteLength = $e7d90c09e211f052$var$_interopRequireDefault((parcelRequire("56jd8")));

var $e7d90c09e211f052$var$_isFQDN = $e7d90c09e211f052$var$_interopRequireDefault((parcelRequire("ewfpe")));

var $e7d90c09e211f052$var$_isIP = $e7d90c09e211f052$var$_interopRequireDefault((parcelRequire("fKCMb")));

var $e7d90c09e211f052$var$_merge = $e7d90c09e211f052$var$_interopRequireDefault((parcelRequire("IiP6O")));
function $e7d90c09e211f052$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e7d90c09e211f052$var$default_email_options = {
    allow_display_name: false,
    allow_underscores: false,
    require_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true,
    blacklisted_chars: '',
    ignore_max_length: false,
    host_blacklist: [],
    host_whitelist: []
};
/* eslint-disable max-len */ /* eslint-disable no-control-regex */ var $e7d90c09e211f052$var$splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var $e7d90c09e211f052$var$emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var $e7d90c09e211f052$var$gmailUserPart = /^[a-z\d]+$/;
var $e7d90c09e211f052$var$quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var $e7d90c09e211f052$var$emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var $e7d90c09e211f052$var$quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var $e7d90c09e211f052$var$defaultMaxEmailLength = 254;
/* eslint-enable max-len */ /* eslint-enable no-control-regex */ /**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */ function $e7d90c09e211f052$var$validateDisplayName(display_name) {
    var display_name_without_quotes = display_name.replace(/^"(.+)"$/, '$1');
    // display name with only spaces is not valid
    if (!display_name_without_quotes.trim()) return false;
    // check whether display name contains illegal character
    var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
    if (contains_illegal) {
        // if contains illegal characters,
        // must to be enclosed in double-quotes, otherwise it's not a valid display name
        if (display_name_without_quotes === display_name) return false;
        // the quotes in display name must start with character symbol \
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) return false;
    }
    return true;
}
function $e7d90c09e211f052$var$isEmail(str, options) {
    (0, $e7d90c09e211f052$var$_assertString.default)(str);
    options = (0, $e7d90c09e211f052$var$_merge.default)(options, $e7d90c09e211f052$var$default_email_options);
    if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match($e7d90c09e211f052$var$splitNameAddress);
        if (display_email) {
            var display_name = display_email[1];
            // Remove display name and angle brackets to get email address
            // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)
            str = str.replace(display_name, '').replace(/(^<|>$)/g, '');
            // sometimes need to trim the last space to get the display name
            // because there may be a space between display name and email address
            // eg. myname <address@gmail.com>
            // the display name is `myname` instead of `myname `, so need to trim the last space
            if (display_name.endsWith(' ')) display_name = display_name.slice(0, -1);
            if (!$e7d90c09e211f052$var$validateDisplayName(display_name)) return false;
        } else if (options.require_display_name) return false;
    }
    if (!options.ignore_max_length && str.length > $e7d90c09e211f052$var$defaultMaxEmailLength) return false;
    var parts = str.split('@');
    var domain = parts.pop();
    var lower_domain = domain.toLowerCase();
    if (options.host_blacklist.includes(lower_domain)) return false;
    if (options.host_whitelist.length > 0 && !options.host_whitelist.includes(lower_domain)) return false;
    var user = parts.join('@');
    if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
        /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */ user = user.toLowerCase();
        // Removing sub-address from username before gmail validation
        var username = user.split('+')[0];
        // Dots are not included in gmail length restriction
        if (!(0, $e7d90c09e211f052$var$_isByteLength.default)(username.replace(/\./g, ''), {
            min: 6,
            max: 30
        })) return false;
        var _user_parts = username.split('.');
        for(var i = 0; i < _user_parts.length; i++){
            if (!$e7d90c09e211f052$var$gmailUserPart.test(_user_parts[i])) return false;
        }
    }
    if (options.ignore_max_length === false && (!(0, $e7d90c09e211f052$var$_isByteLength.default)(user, {
        max: 64
    }) || !(0, $e7d90c09e211f052$var$_isByteLength.default)(domain, {
        max: 254
    }))) return false;
    if (!(0, $e7d90c09e211f052$var$_isFQDN.default)(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length,
        allow_underscores: options.allow_underscores
    })) {
        if (!options.allow_ip_domain) return false;
        if (!(0, $e7d90c09e211f052$var$_isIP.default)(domain)) {
            if (!domain.startsWith('[') || !domain.endsWith(']')) return false;
            var noBracketdomain = domain.slice(1, -1);
            if (noBracketdomain.length === 0 || !(0, $e7d90c09e211f052$var$_isIP.default)(noBracketdomain)) return false;
        }
    }
    if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? $e7d90c09e211f052$var$quotedEmailUserUtf8.test(user) : $e7d90c09e211f052$var$quotedEmailUser.test(user);
    }
    var pattern = options.allow_utf8_local_part ? $e7d90c09e211f052$var$emailUserUtf8Part : $e7d90c09e211f052$var$emailUserPart;
    var user_parts = user.split('.');
    for(var _i = 0; _i < user_parts.length; _i++){
        if (!pattern.test(user_parts[_i])) return false;
    }
    if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
    }
    return true;
}
$e7d90c09e211f052$exports = $e7d90c09e211f052$exports.default;
$e7d90c09e211f052$exports.default = $e7d90c09e211f052$exports.default;


const $6fcac87cfa7b43de$var$Item = (0, $j7y1Z.default)((0, $fa105ed17f31a2c8$export$2e2bcd8739ae039))(({ theme: theme })=>({
        backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: "center"
    }));
const $6fcac87cfa7b43de$var$jurisdiction = [
    {
        value: "IA",
        label: "IA"
    },
    {
        value: "FED",
        label: "FED"
    },
    {
        value: "NSW",
        label: "NSW"
    },
    {
        value: "VIC",
        label: "VIC"
    },
    {
        value: "ACT",
        label: "ACT"
    },
    {
        value: "NT",
        label: "NT"
    },
    {
        value: "WA",
        label: "WA"
    },
    {
        value: "QLD",
        label: "QLD"
    },
    {
        value: "TAS",
        label: "TAS"
    },
    {
        value: "SA",
        label: "SA"
    }
];
function $6fcac87cfa7b43de$export$2e2bcd8739ae039() {
    const [open, setOpen] = $i5lfL.useState(false);
    const [errorMessage, seterrorMessage] = $i5lfL.useState("");
    const [requestForm, setRequestForm] = $i5lfL.useState((0, $243a1246ea7835d9$export$38a702d7fc9d394a));
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($e7d90c09e211f052$exports)))(requestForm.email)) {
            await fetch((0, $24846570078166ea$export$bba4b5af5378a4a1), {
                method: "POST",
                body: JSON.stringify(requestForm)
            });
            setOpen(true);
            setRequestForm((0, $243a1246ea7835d9$export$38a702d7fc9d394a));
        } else seterrorMessage("Invalid email address");
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    const history = (0, $63d2ce7e33220fc9$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
        container: true,
        spacing: 5,
        sx: {
            height: "80%",
            pt: "5%"
        },
        justifyContent: "center",
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                item: true,
                xs: 4,
                children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                    variant: "h2",
                    component: "div",
                    children: [
                        (0, $d29d6d1034e01aa1$export$f75b2c3dd207e4d9),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        (0, $d29d6d1034e01aa1$export$b9c6040cf5f3c72d)
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                item: true,
                xs: 3,
                children: [
                    errorMessage && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $097160938072b98e$export$2e2bcd8739ae039), {
                        severity: "error",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("form", {
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                    required: true,
                                    id: "access-name",
                                    label: "Name",
                                    variant: "outlined",
                                    onChange: (e)=>{
                                        setRequestForm({
                                            ...requestForm,
                                            ["name"]: e.target.value
                                        });
                                    },
                                    value: requestForm.name
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                    required: true,
                                    id: "access-email",
                                    label: "Email",
                                    variant: "outlined",
                                    error: requestForm.email != "" && !(0, (/*@__PURE__*/$parcel$interopDefault($e7d90c09e211f052$exports)))(requestForm.email),
                                    onChange: (e)=>{
                                        seterrorMessage("");
                                        setRequestForm({
                                            ...requestForm,
                                            ["email"]: e.target.value
                                        });
                                    },
                                    value: requestForm.email
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                    id: "access-job",
                                    label: "Job Title",
                                    variant: "outlined",
                                    onChange: (e)=>{
                                        setRequestForm({
                                            ...requestForm,
                                            ["title"]: e.target.value
                                        });
                                    },
                                    value: requestForm.title
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                    required: true,
                                    id: "access-org",
                                    label: "Organisation",
                                    variant: "outlined",
                                    onChange: (e)=>{
                                        setRequestForm({
                                            ...requestForm,
                                            ["org"]: e.target.value
                                        });
                                    },
                                    value: requestForm.org
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                    required: true,
                                    id: "access-jur",
                                    select: true,
                                    label: "Jurisdiction",
                                    variant: "outlined",
                                    onChange: (e)=>{
                                        setRequestForm({
                                            ...requestForm,
                                            ["juri"]: e.target.value
                                        });
                                    },
                                    value: requestForm.juri,
                                    children: $6fcac87cfa7b43de$var$jurisdiction.map((option)=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                            value: option.value,
                                            children: option.label
                                        }, option.value))
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)($6fcac87cfa7b43de$var$Item, {
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 6,
                                                children: [
                                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                                        variant: "contained",
                                                        type: "submit",
                                                        children: "Submit"
                                                    }),
                                                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039), {
                                                        open: open,
                                                        onClose: handleClose,
                                                        children: [
                                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $48d8f4c3325a9037$export$2e2bcd8739ae039), {
                                                                children: "Access Request"
                                                            }),
                                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $422502a3833a93e2$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $a63770281394464a$export$2e2bcd8739ae039), {
                                                                    children: [
                                                                        "Thank you for requesting access to the Infrastructure Australia Scenario Modelling Tool. An acknowledgment email has been sent to your inbox.",
                                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                                                                        "Your request will be reviewed by a team member and you will be notified of the outcome."
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $0d4f9b05ed57077c$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                                                    onClick: handleClose,
                                                                    children: "Cancel"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                                item: true,
                                                xs: 6,
                                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                                    onClick: ()=>history(-1),
                                                    variant: "contained",
                                                    children: "cancel"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}



var $bHJbJ = parcelRequire("bHJbJ");

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");


var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");


var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $f0cfae2c38b327d4$export$f3b76d2cce458caa(slot) {
    return (0, $6bbZp.default)('MuiCard', slot);
}
const $f0cfae2c38b327d4$var$cardClasses = (0, $47i1c.default)('MuiCard', [
    'root'
]);
var $f0cfae2c38b327d4$export$2e2bcd8739ae039 = $f0cfae2c38b327d4$var$cardClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $27c7c1513d19fa89$var$_excluded = [
    "className",
    "raised"
];
const $27c7c1513d19fa89$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $f0cfae2c38b327d4$export$f3b76d2cce458caa), classes);
};
const $27c7c1513d19fa89$var$CardRoot = (0, $j7y1Z.default)((0, $fa105ed17f31a2c8$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $27c7c1513d19fa89$var$Card = /*#__PURE__*/ $i5lfL.forwardRef(function Card(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $7qXFD.default)(props, $27c7c1513d19fa89$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        raised: raised
    });
    const classes = $27c7c1513d19fa89$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($27c7c1513d19fa89$var$CardRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $27c7c1513d19fa89$export$2e2bcd8739ae039 = $27c7c1513d19fa89$var$Card;


var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $b2e1590276b0468f$export$ee5828fb8c43a48e(slot) {
    return (0, $6bbZp.default)('MuiCardActionArea', slot);
}
const $b2e1590276b0468f$var$cardActionAreaClasses = (0, $47i1c.default)('MuiCardActionArea', [
    'root',
    'focusVisible',
    'focusHighlight'
]);
var $b2e1590276b0468f$export$2e2bcd8739ae039 = $b2e1590276b0468f$var$cardActionAreaClasses;




var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $6cca4565917bea90$var$_excluded = [
    "children",
    "className",
    "focusVisibleClassName"
];
const $6cca4565917bea90$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        focusHighlight: [
            'focusHighlight'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $b2e1590276b0468f$export$ee5828fb8c43a48e), classes);
};
const $6cca4565917bea90$var$CardActionAreaRoot = (0, $j7y1Z.default)((0, $07a3ed667acb77f6$export$2e2bcd8739ae039), {
    name: 'MuiCardActionArea',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'block',
        textAlign: 'inherit',
        borderRadius: 'inherit',
        // for Safari to work https://github.com/mui/material-ui/issues/36285.
        width: '100%',
        [`&:hover .${(0, $b2e1590276b0468f$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.hoverOpacity,
            '@media (hover: none)': {
                opacity: 0
            }
        },
        [`&.${(0, $b2e1590276b0468f$export$2e2bcd8739ae039).focusVisible} .${(0, $b2e1590276b0468f$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.focusOpacity
        }
    }));
const $6cca4565917bea90$var$CardActionAreaFocusHighlight = (0, $j7y1Z.default)('span', {
    name: 'MuiCardActionArea',
    slot: 'FocusHighlight',
    overridesResolver: (props, styles)=>styles.focusHighlight
})(({ theme: theme })=>({
        overflow: 'hidden',
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: 'inherit',
        opacity: 0,
        backgroundColor: 'currentcolor',
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.short
        })
    }));
const $6cca4565917bea90$var$CardActionArea = /*#__PURE__*/ $i5lfL.forwardRef(function CardActionArea(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiCardActionArea'
    });
    const { children: children, className: className, focusVisibleClassName: focusVisibleClassName } = props, other = (0, $7qXFD.default)(props, $6cca4565917bea90$var$_excluded);
    const ownerState = props;
    const classes = $6cca4565917bea90$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($6cca4565917bea90$var$CardActionAreaRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        focusVisibleClassName: (0, $kRbLW.default)(focusVisibleClassName, classes.focusVisible),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            children,
            /*#__PURE__*/ (0, $bHJbJ.jsx)($6cca4565917bea90$var$CardActionAreaFocusHighlight, {
                className: classes.focusHighlight,
                ownerState: ownerState
            })
        ]
    }));
});
var $6cca4565917bea90$export$2e2bcd8739ae039 = $6cca4565917bea90$var$CardActionArea;


var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $702772a33fd10621$export$964336739a8c7119(slot) {
    return (0, $6bbZp.default)('MuiCardContent', slot);
}
const $702772a33fd10621$var$cardContentClasses = (0, $47i1c.default)('MuiCardContent', [
    'root'
]);
var $702772a33fd10621$export$2e2bcd8739ae039 = $702772a33fd10621$var$cardContentClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $536545aa618f9a80$var$_excluded = [
    "className",
    "component"
];
const $536545aa618f9a80$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $702772a33fd10621$export$964336739a8c7119), classes);
};
const $536545aa618f9a80$var$CardContentRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        '&:last-child': {
            paddingBottom: 24
        }
    };
});
const $536545aa618f9a80$var$CardContent = /*#__PURE__*/ $i5lfL.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $7qXFD.default)(props, $536545aa618f9a80$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component
    });
    const classes = $536545aa618f9a80$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($536545aa618f9a80$var$CardContentRoot, (0, $1CWiu.default)({
        as: component,
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $536545aa618f9a80$export$2e2bcd8739ae039 = $536545aa618f9a80$var$CardContent;


parcelRequire("i5lfL");


const $e65131909847bbe5$var$style = {
    card: {
        width: "calc(70% + 50px)",
        height: "calc(100% + 50px)",
        "&:hover": {
            backgroundColor: "#005670",
            color: "white"
        },
        p: 1
    },
    cardAction: {
        width: "calc(100%)",
        height: "calc(100%)",
        p: 1
    }
};
function $e65131909847bbe5$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $bHJbJ.Fragment), {
        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
            container: true,
            direction: "row",
            alignItems: "flex-start",
            spacing: 1,
            sx: {
                p: "2%"
            },
            children: [
                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 7,
                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                        variant: "h2",
                        sx: {
                            p: 2
                        },
                        children: [
                            (0, $d29d6d1034e01aa1$export$63bd130e3dfd0f44),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    container: true,
                    justifyContent: "flex-start",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 3,
                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $27c7c1513d19fa89$export$2e2bcd8739ae039), {
                                sx: $e65131909847bbe5$var$style.card,
                                variant: "outlined",
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $6cca4565917bea90$export$2e2bcd8739ae039), {
                                    sx: $e65131909847bbe5$var$style.cardAction,
                                    component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                    to: "/national-modelling",
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $536545aa618f9a80$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                component: "div",
                                                sx: {
                                                    pt: 4,
                                                    pb: 2,
                                                    textDecoration: "underline"
                                                },
                                                children: "National Pipeline"
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                                variant: "h4",
                                                component: "div",
                                                children: (0, $d29d6d1034e01aa1$export$3191e2ef03e5caa5)
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            container: true,
                            item: true,
                            xs: 3,
                            direction: "row",
                            alignItems: "center",
                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $27c7c1513d19fa89$export$2e2bcd8739ae039), {
                                sx: $e65131909847bbe5$var$style.card,
                                variant: "outlined",
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $6cca4565917bea90$export$2e2bcd8739ae039), {
                                    sx: $e65131909847bbe5$var$style.cardAction,
                                    component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                    to: "/state-modelling",
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $536545aa618f9a80$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                component: "div",
                                                sx: {
                                                    pt: 4,
                                                    pb: 2,
                                                    textDecoration: "underline"
                                                },
                                                children: "State Pipeline"
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                                variant: "h4",
                                                component: "div",
                                                children: (0, $d29d6d1034e01aa1$export$e589381a487d929e)
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            container: true,
                            item: true,
                            xs: 3,
                            direction: "row",
                            alignItems: "center",
                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $27c7c1513d19fa89$export$2e2bcd8739ae039), {
                                sx: $e65131909847bbe5$var$style.card,
                                variant: "outlined",
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $6cca4565917bea90$export$2e2bcd8739ae039), {
                                    sx: $e65131909847bbe5$var$style.cardAction,
                                    component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                    to: "/scenario-modelling",
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $536545aa618f9a80$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                component: "div",
                                                sx: {
                                                    pt: 4,
                                                    pb: 2,
                                                    textDecoration: "underline"
                                                },
                                                children: "Pipeline Simulator"
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                                variant: "h4",
                                                component: "div",
                                                children: (0, $d29d6d1034e01aa1$export$f5e719fcdee8e25e)
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            container: true,
                            item: true,
                            xs: 3,
                            direction: "row",
                            alignItems: "center",
                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $27c7c1513d19fa89$export$2e2bcd8739ae039), {
                                sx: $e65131909847bbe5$var$style.card,
                                variant: "outlined",
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $6cca4565917bea90$export$2e2bcd8739ae039), {
                                    sx: $e65131909847bbe5$var$style.cardAction,
                                    component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                    to: "/national-map",
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $536545aa618f9a80$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                component: "div",
                                                sx: {
                                                    pt: 4,
                                                    pb: 2,
                                                    textDecoration: "underline"
                                                },
                                                children: "Market Capacity Map"
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                                variant: "h4",
                                                component: "div",
                                                children: (0, $d29d6d1034e01aa1$export$f464c3b736cce140)
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}



var $bHJbJ = parcelRequire("bHJbJ");


var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");

var $kRbLW = parcelRequire("kRbLW");

var $cmrx1 = parcelRequire("cmrx1");

var $lwaO7 = parcelRequire("lwaO7");
var $ggmG3 = parcelRequire("ggmG3");


var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $4eb440c61c723f7a$var$_excluded = [
    "className",
    "component"
];
function $4eb440c61c723f7a$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $cmrx1.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $lwaO7.default));
    const Box = /*#__PURE__*/ $i5lfL.forwardRef(function Box(inProps, ref) {
        const theme = (0, $99d6713ec469aabd$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $ggmG3.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $7qXFD.default)(_extendSxProp, $4eb440c61c723f7a$var$_excluded);
        return /*#__PURE__*/ (0, $bHJbJ.jsx)(BoxRoot, (0, $1CWiu.default)({
            as: component,
            ref: ref,
            className: (0, $kRbLW.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $dQFgv = parcelRequire("dQFgv");

var $87pNb = parcelRequire("87pNb");

var $5xV56 = parcelRequire("5xV56");

var $47i1c = parcelRequire("47i1c");
const $22d83c4c32fdcd74$var$boxClasses = (0, $47i1c.default)('MuiBox', [
    'root'
]);
var $22d83c4c32fdcd74$export$2e2bcd8739ae039 = $22d83c4c32fdcd74$var$boxClasses;


'use client';
const $af701d274f0d01b0$var$defaultTheme = (0, $87pNb.default)();
const $af701d274f0d01b0$var$Box = (0, $4eb440c61c723f7a$export$2e2bcd8739ae039)({
    themeId: (0, $5xV56.default),
    defaultTheme: $af701d274f0d01b0$var$defaultTheme,
    defaultClassName: (0, $22d83c4c32fdcd74$export$2e2bcd8739ae039).root,
    generateClassName: (0, $dQFgv.default).generate
});
var $af701d274f0d01b0$export$2e2bcd8739ae039 = $af701d274f0d01b0$var$Box;



var $i5lfL = parcelRequire("i5lfL");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $2ktY3 = parcelRequire("2ktY3");


var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


'use client';
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $b341c3c8a1e85e7f$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $fa9c2cea1dcc0b6d$export$2e2bcd8739ae039)();
    $i5lfL.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $i5lfL.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $i5lfL.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $i5lfL.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $1CWiu.default)({}, (0, $d3a9833af65b6699$export$2e2bcd8739ae039)(parameters), (0, $d3a9833af65b6699$export$2e2bcd8739ae039)(externalProps));
        return (0, $1CWiu.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation'
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $b341c3c8a1e85e7f$export$2e2bcd8739ae039 = $b341c3c8a1e85e7f$var$useSnackbar;



var $i5lfL = parcelRequire("i5lfL");



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
function $e258c560ce63acd1$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $e258c560ce63acd1$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $e258c560ce63acd1$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $i5lfL.useRef(false);
    const nodeRef = $i5lfL.useRef(null);
    const activatedRef = $i5lfL.useRef(false);
    const syntheticEventRef = $i5lfL.useRef(false);
    $i5lfL.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $e258c560ce63acd1$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $i5lfL.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $e258c560ce63acd1$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $i5lfL.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $e258c560ce63acd1$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($i5lfL.Fragment, {
        children: /*#__PURE__*/ $i5lfL.cloneElement(children, childrenProps)
    });
}



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $VEXgj = parcelRequire("VEXgj");


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");


var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $7f77df594c8fa4f2$export$def81488db1a3216(slot) {
    return (0, $6bbZp.default)('MuiSnackbarContent', slot);
}
const $7f77df594c8fa4f2$var$snackbarContentClasses = (0, $47i1c.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $7f77df594c8fa4f2$export$2e2bcd8739ae039 = $7f77df594c8fa4f2$var$snackbarContentClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $efbce399754a073f$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $efbce399754a073f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $7f77df594c8fa4f2$export$def81488db1a3216), classes);
};
const $efbce399754a073f$var$SnackbarContentRoot = (0, $j7y1Z.default)((0, $fa105ed17f31a2c8$export$2e2bcd8739ae039), {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    const backgroundColor = (0, $8AHNG.emphasize)(theme.palette.background.default, emphasis);
    return (0, $1CWiu.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    });
});
const $efbce399754a073f$var$SnackbarContentMessage = (0, $j7y1Z.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0'
});
const $efbce399754a073f$var$SnackbarContentAction = (0, $j7y1Z.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $efbce399754a073f$var$SnackbarContent = /*#__PURE__*/ $i5lfL.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert' } = props, other = (0, $7qXFD.default)(props, $efbce399754a073f$var$_excluded);
    const ownerState = props;
    const classes = $efbce399754a073f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($efbce399754a073f$var$SnackbarContentRoot, (0, $1CWiu.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)($efbce399754a073f$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $bHJbJ.jsx)($efbce399754a073f$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $efbce399754a073f$export$2e2bcd8739ae039 = $efbce399754a073f$var$SnackbarContent;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $417a76582dd122ed$export$6cb096457f5926f4(slot) {
    return (0, $6bbZp.default)('MuiSnackbar', slot);
}
const $417a76582dd122ed$var$snackbarClasses = (0, $47i1c.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $417a76582dd122ed$export$2e2bcd8739ae039 = $417a76582dd122ed$var$snackbarClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $2b36172c0c84cfd5$var$_excluded = [
    "onEnter",
    "onExited"
], $2b36172c0c84cfd5$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $2b36172c0c84cfd5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $VEXgj.default)(anchorOrigin.vertical)}${(0, $VEXgj.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $417a76582dd122ed$export$6cb096457f5926f4), classes);
};
const $2b36172c0c84cfd5$var$SnackbarRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $VEXgj.default)(ownerState.anchorOrigin.vertical)}${(0, $VEXgj.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
    };
    return (0, $1CWiu.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.anchorOrigin.vertical === 'top' ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === 'left' && {
        justifyContent: 'flex-start'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
        justifyContent: 'flex-end'
    }, {
        [theme.breakpoints.up('sm')]: (0, $1CWiu.default)({}, ownerState.anchorOrigin.vertical === 'top' ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
            left: 24,
            right: 'auto'
        }, ownerState.anchorOrigin.horizontal === 'right' && {
            right: 24,
            left: 'auto'
        })
    });
});
const $2b36172c0c84cfd5$var$Snackbar = /*#__PURE__*/ $i5lfL.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $66de9c04029c8d70$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $7qXFD.default)(props.TransitionProps, $2b36172c0c84cfd5$var$_excluded), other = (0, $7qXFD.default)(props, $2b36172c0c84cfd5$var$_excluded2);
    const ownerState = (0, $1CWiu.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $2b36172c0c84cfd5$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $b341c3c8a1e85e7f$export$2e2bcd8739ae039)((0, $1CWiu.default)({}, ownerState));
    const [exited, setExited] = $i5lfL.useState(true);
    const rootProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: $2b36172c0c84cfd5$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $e258c560ce63acd1$export$58385c17fee43f89), (0, $1CWiu.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($2b36172c0c84cfd5$var$SnackbarRoot, (0, $1CWiu.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $bHJbJ.jsx)(TransitionComponent, (0, $1CWiu.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === 'top' ? 'down' : 'up',
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $efbce399754a073f$export$2e2bcd8739ae039), (0, $1CWiu.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $2b36172c0c84cfd5$export$2e2bcd8739ae039 = $2b36172c0c84cfd5$var$Snackbar;



var $96c82ddda143b076$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($96c82ddda143b076$exports, "__esModule", {
    value: true
});
$96c82ddda143b076$exports.default = void 0;

var $96c82ddda143b076$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $96c82ddda143b076$var$_default = $96c82ddda143b076$exports.default = (0, $96c82ddda143b076$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $VEXgj = parcelRequire("VEXgj");


var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $aac0f25b4b1015de$export$47a2da616e55e8e9(slot) {
    return (0, $6bbZp.default)('MuiAppBar', slot);
}
const $aac0f25b4b1015de$var$appBarClasses = (0, $47i1c.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $aac0f25b4b1015de$export$2e2bcd8739ae039 = $aac0f25b4b1015de$var$appBarClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $a30aea8b0c911d63$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $a30aea8b0c911d63$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $VEXgj.default)(color)}`,
            `position${(0, $VEXgj.default)(position)}`
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $aac0f25b4b1015de$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $a30aea8b0c911d63$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(')', '')}, ${var2})` : var2;
const $a30aea8b0c911d63$var$AppBarRoot = (0, $j7y1Z.default)((0, $fa105ed17f31a2c8$export$2e2bcd8739ae039), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $VEXgj.default)(ownerState.position)}`],
            styles[`color${(0, $VEXgj.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $1CWiu.default)({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === 'fixed' && {
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0,
        '@media print': {
            // Prevent the app bar to be visible on each printed page.
            position: 'absolute'
        }
    }, ownerState.position === 'absolute' && {
        position: 'absolute',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'sticky' && {
        // ⚠️ sticky is not supported by IE11.
        position: 'sticky',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'static' && {
        position: 'static'
    }, ownerState.position === 'relative' && {
        position: 'relative'
    }, !theme.vars && (0, $1CWiu.default)({}, ownerState.color === 'default' && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === 'transparent' && (0, $1CWiu.default)({
        backgroundColor: 'transparent',
        color: 'inherit'
    }, theme.palette.mode === 'dark' && {
        backgroundImage: 'none'
    })), theme.vars && (0, $1CWiu.default)({}, ownerState.color === 'default' && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $a30aea8b0c911d63$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $a30aea8b0c911d63$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $a30aea8b0c911d63$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $a30aea8b0c911d63$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, ![
        'inherit',
        'transparent'
    ].includes(ownerState.color) && {
        backgroundColor: 'var(--AppBar-background)'
    }, {
        color: ownerState.color === 'inherit' ? 'inherit' : 'var(--AppBar-color)'
    }, ownerState.color === 'transparent' && {
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        color: 'inherit'
    }));
});
const $a30aea8b0c911d63$var$AppBar = /*#__PURE__*/ $i5lfL.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed' } = props, other = (0, $7qXFD.default)(props, $a30aea8b0c911d63$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $a30aea8b0c911d63$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($a30aea8b0c911d63$var$AppBarRoot, (0, $1CWiu.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $kRbLW.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
var $a30aea8b0c911d63$export$2e2bcd8739ae039 = $a30aea8b0c911d63$var$AppBar;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $947c27f1c41ac2d8$export$b12cb262231eef32(slot) {
    return (0, $6bbZp.default)('MuiToolbar', slot);
}
const $947c27f1c41ac2d8$var$toolbarClasses = (0, $47i1c.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $947c27f1c41ac2d8$export$2e2bcd8739ae039 = $947c27f1c41ac2d8$var$toolbarClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $7e3df3c636b0fe42$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $7e3df3c636b0fe42$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $947c27f1c41ac2d8$export$b12cb262231eef32), classes);
};
const $7e3df3c636b0fe42$var$ToolbarRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $7e3df3c636b0fe42$var$Toolbar = /*#__PURE__*/ $i5lfL.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $7qXFD.default)(props, $7e3df3c636b0fe42$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $7e3df3c636b0fe42$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($7e3df3c636b0fe42$var$ToolbarRoot, (0, $1CWiu.default)({
        as: component,
        className: (0, $kRbLW.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $7e3df3c636b0fe42$export$2e2bcd8739ae039 = $7e3df3c636b0fe42$var$Toolbar;


var $4b8ebea637ae5e32$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($4b8ebea637ae5e32$exports, "__esModule", {
    value: true
});
$4b8ebea637ae5e32$exports.default = void 0;

var $4b8ebea637ae5e32$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $4b8ebea637ae5e32$var$_default = $4b8ebea637ae5e32$exports.default = (0, $4b8ebea637ae5e32$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M7.35 18.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5s-3.34-.56-4.65-1.5m10.79-1.38C16.45 15.8 14.32 15 12 15s-4.45.8-6.14 2.12C4.7 15.73 4 13.95 4 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.95-.7 3.73-1.86 5.12"
    }, "0"),
    /*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
        d: "M12 6c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6m0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11"
    }, "1")
], 'AccountCircleOutlined');




var $51dfc26db5e92d35$exports = {};
$51dfc26db5e92d35$exports = new URL("AustGov_IA_inline_pos.80ba3614.svg", import.meta.url).toString();


var $7fe579e91cddcecf$exports = {};
$7fe579e91cddcecf$exports = new URL("IA_GraphicDevice.8518657f.svg", import.meta.url).toString();


const $3c6d0e989d4264c8$var$styles = {
    button: {
        fontSize: "20px"
    }
};
function $3c6d0e989d4264c8$export$2e2bcd8739ae039() {
    const [anchorEl, setAnchorEl] = $i5lfL.useState(null);
    const [ppath, setPpath] = $i5lfL.useState("");
    const location = (0, $63d2ce7e33220fc9$export$45d76561a5302f2b)();
    $i5lfL.useEffect(()=>{
        setPpath(window.location.pathname);
    }, [
        location
    ]);
    const handleMenu = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const logoutRedirect = ()=>{
        instance.logoutRedirect();
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a30aea8b0c911d63$export$2e2bcd8739ae039), {
        color: "transparent",
        elevation: 0,
        sx: {
            zIndex: "100",
            position: "relative"
        },
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $7e3df3c636b0fe42$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 3,
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                            to: "/",
                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                component: "img",
                                sx: {
                                    height: "150%",
                                    maxHeight: 50,
                                    pt: 1
                                },
                                alt: "Logo",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($51dfc26db5e92d35$exports)))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 8,
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $e4400acf80ba3bb9$export$3f7734c901feade6), {
                            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                container: true,
                                spacing: 2,
                                justifyContent: "flex-end",
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                            variant: ppath === "/national-modelling" ? "contained" : "text",
                                            style: $3c6d0e989d4264c8$var$styles.button,
                                            sx: {
                                                ":hover": {
                                                    //                                                 bgcolor: "white",
                                                    textDecoration: "underline"
                                                }
                                            },
                                            component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                            to: "/national-modelling",
                                            children: "NATIONAL PIPELINE"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                            variant: ppath === "/state-modelling" ? "contained" : "text",
                                            style: $3c6d0e989d4264c8$var$styles.button,
                                            sx: {
                                                ":hover": {
                                                    //                                                 bgcolor: "white",
                                                    textDecoration: "underline"
                                                }
                                            },
                                            component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                            to: "/state-modelling",
                                            children: "STATE PIPELINE"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                            variant: ppath === "/scenario-modelling" ? "contained" : "text",
                                            component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                            to: "/scenario-modelling",
                                            style: $3c6d0e989d4264c8$var$styles.button,
                                            sx: {
                                                ":hover": {
                                                    //                                                 bgcolor: "white",
                                                    textDecoration: "underline"
                                                }
                                            },
                                            children: "PIPELINE SIMULATOR"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                            variant: ppath === "/national-map" ? "contained" : "text",
                                            sx: {
                                                ":hover": {
                                                    //                                               bgcolor: "white",
                                                    textDecoration: "underline"
                                                }
                                            },
                                            component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                            to: "/national-map",
                                            style: $3c6d0e989d4264c8$var$styles.button,
                                            children: "NATIONAL MAP"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                            variant: ppath === "/glossary" ? "contained" : "text",
                                            sx: {
                                                ":hover": {
                                                    //                                               bgcolor: "white",
                                                    textDecoration: "underline"
                                                }
                                            },
                                            component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                            to: "/glossary",
                                            style: $3c6d0e989d4264c8$var$styles.button,
                                            children: "GLOSSARY"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                            variant: ppath === "/FAQ" ? "contained" : "text",
                                            sx: {
                                                ":hover": {
                                                    //                                               bgcolor: "white",
                                                    textDecoration: "underline"
                                                }
                                            },
                                            component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                            to: "/FAQ",
                                            style: $3c6d0e989d4264c8$var$styles.button,
                                            children: "FAQ"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                                                size: "large",
                                                "aria-label": "account of current user",
                                                "aria-controls": "menu-appbar",
                                                "aria-haspopup": "true",
                                                onClick: handleMenu,
                                                color: "inherit",
                                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4b8ebea637ae5e32$exports))), {})
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $6e1d5d5a1ad3ef09$export$2e2bcd8739ae039), {
                                                id: "menu-appbar",
                                                anchorEl: anchorEl,
                                                anchorOrigin: {
                                                    vertical: "top",
                                                    horizontal: "right"
                                                },
                                                keepMounted: true,
                                                transformOrigin: {
                                                    vertical: "top",
                                                    horizontal: "right"
                                                },
                                                open: Boolean(anchorEl),
                                                onClose: handleClose,
                                                children: [
                                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                        onClick: handleClose,
                                                        children: accounts[0] ? accounts[0].username : ""
                                                    }),
                                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                        onClick: handleClose,
                                                        children: accounts[0] ? accounts[0].name : ""
                                                    }),
                                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                        onClick: logoutRedirect,
                                                        children: "Logout"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        component: "img",
                        sx: {
                            height: "300%",
                            maxHeight: 200,
                            display: "flex",
                            zIndex: "0",
                            position: "fixed",
                            top: 0,
                            right: 0
                        },
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7fe579e91cddcecf$exports)))
                    })
                ]
            })
        })
    });
}



var $bHJbJ = parcelRequire("bHJbJ");
parcelRequire("i5lfL");
var $45a23e9604166590$exports = {};
$45a23e9604166590$exports = new URL("IA_Nani_footer.931ea74f.png", import.meta.url).toString();



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");


var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $361ca82faf3bbe4f$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $361ca82faf3bbe4f$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $f3f8af719fb6ce1f$export$46f01d01378ec5a2), classes);
};
const $361ca82faf3bbe4f$var$DividerRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $8AHNG.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $1CWiu.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: 'inherit'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: 'inherit'
        }
    }), ({ ownerState: ownerState })=>(0, $1CWiu.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $361ca82faf3bbe4f$var$DividerWrapper = (0, $j7y1Z.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $361ca82faf3bbe4f$var$Divider = /*#__PURE__*/ $i5lfL.forwardRef(function Divider(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $7qXFD.default)(props, $361ca82faf3bbe4f$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $361ca82faf3bbe4f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($361ca82faf3bbe4f$var$DividerRoot, (0, $1CWiu.default)({
        as: component,
        className: (0, $kRbLW.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $bHJbJ.jsx)($361ca82faf3bbe4f$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $361ca82faf3bbe4f$var$Divider.muiSkipListHighlight = true;
var $361ca82faf3bbe4f$export$2e2bcd8739ae039 = $361ca82faf3bbe4f$var$Divider;



const $df7ce8a7d370bf29$var$styles = {
    paperContainer: {
        backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($45a23e9604166590$exports)))})`,
        backgroundSize: "cover"
    },
    FooterButton: {
        fontFamily: "ProximaNova-Bold",
        color: "#000000"
    }
};
function $df7ce8a7d370bf29$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        style: $df7ce8a7d370bf29$var$styles.paperContainer,
        sx: {
            zIndex: "0"
        },
        display: "flex",
        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 5,
                    children: [
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                            variant: "subtitle1",
                            sx: {
                                pl: 6
                            },
                            children: "Acknowledgement of Country"
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                            variant: "subtitle2",
                            sx: {
                                pl: 6
                            },
                            children: " Infrastructure Australia acknowledges the Traditional Owners of Country throughout Australia and recognises the continuing connection to lands, waters and communities. We pay our respect to Aboriginal and Torres Strait Islander cultures; and to Elders past and present."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        bgcolor: "#DEE0DF",
                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 1,
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                        style: $df7ce8a7d370bf29$var$styles.FooterButton,
                                        component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                        to: "https://www.infrastructureaustralia.gov.au/copyright-statement",
                                        children: "COPYRIGHT"
                                    })
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $361ca82faf3bbe4f$export$2e2bcd8739ae039), {
                                    orientation: "vertical",
                                    variant: "middle",
                                    flexItem: true,
                                    sx: {
                                        pl: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                        style: $df7ce8a7d370bf29$var$styles.FooterButton,
                                        component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                        to: "https://www.infrastructureaustralia.gov.au/disclaimer",
                                        children: "DISCLAIMER"
                                    })
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $361ca82faf3bbe4f$export$2e2bcd8739ae039), {
                                    orientation: "vertical",
                                    variant: "middle",
                                    flexItem: true,
                                    sx: {
                                        pl: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                        style: $df7ce8a7d370bf29$var$styles.FooterButton,
                                        component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                        to: "https://www.infrastructureaustralia.gov.au/freedom-information",
                                        children: "FOI"
                                    })
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $361ca82faf3bbe4f$export$2e2bcd8739ae039), {
                                    orientation: "vertical",
                                    variant: "middle",
                                    flexItem: true,
                                    sx: {
                                        pl: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                        style: $df7ce8a7d370bf29$var$styles.FooterButton,
                                        component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                        to: "https://www.infrastructureaustralia.gov.au/privacy-statement",
                                        children: "PRIVACY"
                                    })
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $361ca82faf3bbe4f$export$2e2bcd8739ae039), {
                                    orientation: "vertical",
                                    variant: "middle",
                                    flexItem: true,
                                    sx: {
                                        pl: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                        style: $df7ce8a7d370bf29$var$styles.FooterButton,
                                        component: (0, $0def10581bd2a82b$export$a6c7ac8248d6e38a),
                                        to: "mailto:scenario.modelling@infrastructureaustralia.gov.au",
                                        children: "CONTACTS"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}


var $e9ab2d34d0380c8f$exports = {};
"use strict";
var $e9ab2d34d0380c8f$var$__createBinding = $e9ab2d34d0380c8f$exports && $e9ab2d34d0380c8f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e9ab2d34d0380c8f$var$__setModuleDefault = $e9ab2d34d0380c8f$exports && $e9ab2d34d0380c8f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e9ab2d34d0380c8f$var$__importStar = $e9ab2d34d0380c8f$exports && $e9ab2d34d0380c8f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e9ab2d34d0380c8f$var$__createBinding(result, mod, k);
    }
    $e9ab2d34d0380c8f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e9ab2d34d0380c8f$exports, "__esModule", {
    value: true
});
$e9ab2d34d0380c8f$exports.request = $e9ab2d34d0380c8f$exports.rawRequest = $e9ab2d34d0380c8f$exports.GraphQLClient = $e9ab2d34d0380c8f$exports.ClientError = $e9ab2d34d0380c8f$exports.batchRequests = $e9ab2d34d0380c8f$exports.resolveRequestDocument = $e9ab2d34d0380c8f$exports.GraphQLWebSocketClient = $e9ab2d34d0380c8f$exports.gql = void 0;
var $5eab6868c5a09ac5$exports = {};
"use strict";
Object.defineProperty($5eab6868c5a09ac5$exports, "__esModule", {
    value: true
});
$5eab6868c5a09ac5$exports.defaultJsonSerializer = void 0;
$5eab6868c5a09ac5$exports.defaultJsonSerializer = JSON;


var $3a304f557554d0cb$exports = {};
"use strict";
Object.defineProperty($3a304f557554d0cb$exports, "__esModule", {
    value: true
});
$3a304f557554d0cb$exports.HeadersInstanceToPlainObject = $3a304f557554d0cb$exports.uppercase = void 0;
const $3a304f557554d0cb$var$uppercase = (str)=>str.toUpperCase();
$3a304f557554d0cb$exports.uppercase = $3a304f557554d0cb$var$uppercase;
/**
 * Convert Headers instance into regular object
 */ const $3a304f557554d0cb$var$HeadersInstanceToPlainObject = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};
$3a304f557554d0cb$exports.HeadersInstanceToPlainObject = $3a304f557554d0cb$var$HeadersInstanceToPlainObject;


var $8ec2785da8853547$exports = {};
"use strict";
Object.defineProperty($8ec2785da8853547$exports, "__esModule", {
    value: true
});
$8ec2785da8853547$exports.parseRawRequestExtendedArgs = $8ec2785da8853547$exports.parseRequestExtendedArgs = $8ec2785da8853547$exports.parseBatchRequestArgs = $8ec2785da8853547$exports.parseRawRequestArgs = $8ec2785da8853547$exports.parseRequestArgs = void 0;
const $8ec2785da8853547$var$parseRequestArgs = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$8ec2785da8853547$exports.parseRequestArgs = $8ec2785da8853547$var$parseRequestArgs;
const $8ec2785da8853547$var$parseRawRequestArgs = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$8ec2785da8853547$exports.parseRawRequestArgs = $8ec2785da8853547$var$parseRawRequestArgs;
const $8ec2785da8853547$var$parseBatchRequestArgs = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$8ec2785da8853547$exports.parseBatchRequestArgs = $8ec2785da8853547$var$parseBatchRequestArgs;
const $8ec2785da8853547$var$parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$8ec2785da8853547$exports.parseRequestExtendedArgs = $8ec2785da8853547$var$parseRequestExtendedArgs;
const $8ec2785da8853547$var$parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$8ec2785da8853547$exports.parseRawRequestExtendedArgs = $8ec2785da8853547$var$parseRawRequestExtendedArgs;


var $05816512abbcc559$exports = {};
"use strict";
Object.defineProperty($05816512abbcc559$exports, "__esModule", {
    value: true
});
$05816512abbcc559$exports.resolveRequestDocument = void 0;
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $fedfde7dfd048d51$export$c10d0b04eaa80a43(value) {
    return typeof value == 'object' && value !== null;
}


function $fcd94eb5c32661c3$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}


const $04013484aaac2013$var$LineRegExp = /\r\n|[\n\r]/g;
function $04013484aaac2013$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($04013484aaac2013$var$LineRegExp)){
        typeof match.index === 'number' || (0, $fcd94eb5c32661c3$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $60ac860335c570a5$export$96a9681e539deed(location) {
    return $60ac860335c570a5$export$867940333fd9f869(location.source, (0, $04013484aaac2013$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $60ac860335c570a5$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = ''.padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $60ac860335c570a5$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    '|',
                    subLine
                ]),
            [
                '|',
                '^'.padStart(subLineColumnNum)
            ],
            [
                '|',
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $60ac860335c570a5$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            '|',
            '^'.padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $60ac860335c570a5$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? ' ' + line : '')).join('\n');
}


function $1dd42d983ba549ad$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $1dd42d983ba549ad$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $1dd42d983ba549ad$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = 'GraphQLError';
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $1dd42d983ba549ad$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $1dd42d983ba549ad$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $04013484aaac2013$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $04013484aaac2013$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $fedfde7dfd048d51$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, 'stack', {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $1dd42d983ba549ad$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return 'GraphQLError';
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += '\n\n' + (0, $60ac860335c570a5$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += '\n\n' + (0, $60ac860335c570a5$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $1dd42d983ba549ad$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $1dd42d983ba549ad$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $1dd42d983ba549ad$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $10ce613970f2e7b7$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $1dd42d983ba549ad$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $aad516a724cab4ca$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $aad516a724cab4ca$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $aad516a724cab4ca$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
const $aad516a724cab4ca$var$kindValues = new Set(Object.keys($aad516a724cab4ca$export$4fcd777a40ccf407));
function $aad516a724cab4ca$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $aad516a724cab4ca$var$kindValues.has(maybeKind);
}
/** Name */ var $aad516a724cab4ca$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($aad516a724cab4ca$export$f58c50edb4aef9d4 || ($aad516a724cab4ca$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed directive location values.
 */ var $6d3ffc06aba975e8$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation['QUERY'] = 'QUERY';
    DirectiveLocation['MUTATION'] = 'MUTATION';
    DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
    DirectiveLocation['FIELD'] = 'FIELD';
    DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
    DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
    DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
    DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
    DirectiveLocation['SCHEMA'] = 'SCHEMA';
    DirectiveLocation['SCALAR'] = 'SCALAR';
    DirectiveLocation['OBJECT'] = 'OBJECT';
    DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
    DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
    DirectiveLocation['INTERFACE'] = 'INTERFACE';
    DirectiveLocation['UNION'] = 'UNION';
    DirectiveLocation['ENUM'] = 'ENUM';
    DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
    DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
    DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})($6d3ffc06aba975e8$export$b45ffd2948484c41 || ($6d3ffc06aba975e8$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 

/**
 * The set of allowed kind values for AST nodes.
 */ var $026f804cda7f6687$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})($026f804cda7f6687$export$a84bdc57c5122798 || ($026f804cda7f6687$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $1fe278901c76e1e3$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $1fe278901c76e1e3$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $1fe278901c76e1e3$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $1fe278901c76e1e3$export$45a677ea7cb6d5c8(code) {
    return $1fe278901c76e1e3$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $1fe278901c76e1e3$export$d3f406ff46035894(code) {
    return $1fe278901c76e1e3$export$79c5d5217943d6a7(code) || $1fe278901c76e1e3$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $af2cc9b626cfc780$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $af2cc9b626cfc780$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $af2cc9b626cfc780$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $1fe278901c76e1e3$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $af2cc9b626cfc780$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $af2cc9b626cfc780$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $1fe278901c76e1e3$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $1fe278901c76e1e3$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}



/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $bbb2cdcd2907f1c5$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind['SOF'] = '<SOF>';
    TokenKind['EOF'] = '<EOF>';
    TokenKind['BANG'] = '!';
    TokenKind['DOLLAR'] = '$';
    TokenKind['AMP'] = '&';
    TokenKind['PAREN_L'] = '(';
    TokenKind['PAREN_R'] = ')';
    TokenKind['SPREAD'] = '...';
    TokenKind['COLON'] = ':';
    TokenKind['EQUALS'] = '=';
    TokenKind['AT'] = '@';
    TokenKind['BRACKET_L'] = '[';
    TokenKind['BRACKET_R'] = ']';
    TokenKind['BRACE_L'] = '{';
    TokenKind['PIPE'] = '|';
    TokenKind['BRACE_R'] = '}';
    TokenKind['NAME'] = 'Name';
    TokenKind['INT'] = 'Int';
    TokenKind['FLOAT'] = 'Float';
    TokenKind['STRING'] = 'String';
    TokenKind['BLOCK_STRING'] = 'BlockString';
    TokenKind['COMMENT'] = 'Comment';
})($bbb2cdcd2907f1c5$export$8b9d26ab11394711 || ($bbb2cdcd2907f1c5$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $ea66dcf81a3e8fb3$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $aad516a724cab4ca$export$50792b0e93539fde)((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return 'Lexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $ea66dcf81a3e8fb3$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $ea66dcf81a3e8fb3$export$59ac0f4da287406a(kind) {
    return kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BANG || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).DOLLAR || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).AMP || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PAREN_L || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PAREN_R || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).SPREAD || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).COLON || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EQUALS || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).AT || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACKET_L || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACKET_R || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PIPE || kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $ea66dcf81a3e8fb3$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $ea66dcf81a3e8fb3$var$isSupplementaryCodePoint(body, location) {
    return $ea66dcf81a3e8fb3$var$isLeadingSurrogate(body.charCodeAt(location)) && $ea66dcf81a3e8fb3$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $ea66dcf81a3e8fb3$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $ea66dcf81a3e8fb3$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $ea66dcf81a3e8fb3$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */ function $ea66dcf81a3e8fb3$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $aad516a724cab4ca$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $ea66dcf81a3e8fb3$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $ea66dcf81a3e8fb3$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $ea66dcf81a3e8fb3$var$readBlockString(lexer, position);
                return $ea66dcf81a3e8fb3$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $1fe278901c76e1e3$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $ea66dcf81a3e8fb3$var$readNumber(lexer, position, code);
         // Name
        if ((0, $1fe278901c76e1e3$export$45a677ea7cb6d5c8)(code)) return $ea66dcf81a3e8fb3$var$readName(lexer, position);
        throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?' : $ea66dcf81a3e8fb3$var$isUnicodeScalarValue(code) || $ea66dcf81a3e8fb3$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$ea66dcf81a3e8fb3$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$ea66dcf81a3e8fb3$var$printCodePointAt(lexer, position)}.`);
    }
    return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $ea66dcf81a3e8fb3$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($ea66dcf81a3e8fb3$var$isUnicodeScalarValue(code)) ++position;
        else if ($ea66dcf81a3e8fb3$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $ea66dcf81a3e8fb3$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $1fe278901c76e1e3$export$727d9dbc4fbb948f)(code)) throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$ea66dcf81a3e8fb3$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $ea66dcf81a3e8fb3$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $ea66dcf81a3e8fb3$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $ea66dcf81a3e8fb3$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $1fe278901c76e1e3$export$45a677ea7cb6d5c8)(code)) throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$ea66dcf81a3e8fb3$var$printCodePointAt(lexer, position)}.`);
    return $ea66dcf81a3e8fb3$var$createToken(lexer, isFloat ? (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).FLOAT : (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $ea66dcf81a3e8fb3$var$readDigits(lexer, start, firstCode) {
    if (!(0, $1fe278901c76e1e3$export$727d9dbc4fbb948f)(firstCode)) throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$ea66dcf81a3e8fb3$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $1fe278901c76e1e3$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $ea66dcf81a3e8fb3$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = '';
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $ea66dcf81a3e8fb3$var$readEscapedUnicodeVariableWidth(lexer, position) : $ea66dcf81a3e8fb3$var$readEscapedUnicodeFixedWidth(lexer, position) : $ea66dcf81a3e8fb3$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($ea66dcf81a3e8fb3$var$isUnicodeScalarValue(code)) ++position;
        else if ($ea66dcf81a3e8fb3$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$ea66dcf81a3e8fb3$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.
function $ea66dcf81a3e8fb3$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$ea66dcf81a3e8fb3$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $ea66dcf81a3e8fb3$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $ea66dcf81a3e8fb3$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $ea66dcf81a3e8fb3$var$read16BitHexCode(body, position + 2);
    if ($ea66dcf81a3e8fb3$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($ea66dcf81a3e8fb3$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $ea66dcf81a3e8fb3$var$read16BitHexCode(body, position + 8);
            if ($ea66dcf81a3e8fb3$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $ea66dcf81a3e8fb3$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $ea66dcf81a3e8fb3$var$readHexDigit(body.charCodeAt(position)) << 12 | $ea66dcf81a3e8fb3$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $ea66dcf81a3e8fb3$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $ea66dcf81a3e8fb3$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $ea66dcf81a3e8fb3$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $ea66dcf81a3e8fb3$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '\u0022',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: '\u005c',
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: '\u002f',
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: '\u0008',
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: '\u000c',
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: '\u000a',
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: '\u000d',
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: '\u0009',
                size: 2
            };
    }
    throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $ea66dcf81a3e8fb3$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = '';
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $af2cc9b626cfc780$export$d5ee19b441e8d2ae)(blockLines).join('\n'));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = '';
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($ea66dcf81a3e8fb3$var$isUnicodeScalarValue(code)) ++position;
        else if ($ea66dcf81a3e8fb3$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$ea66dcf81a3e8fb3$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $ea66dcf81a3e8fb3$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $1fe278901c76e1e3$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $ea66dcf81a3e8fb3$var$createToken(lexer, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}


function $3424992c263c7f13$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $a6e24ec96032a10e$var$MAX_ARRAY_LENGTH = 10;
const $a6e24ec96032a10e$var$MAX_RECURSIVE_DEPTH = 2;
function $a6e24ec96032a10e$export$9dec5d1b3b6a130d(value) {
    return $a6e24ec96032a10e$var$formatValue(value, []);
}
function $a6e24ec96032a10e$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $a6e24ec96032a10e$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $a6e24ec96032a10e$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($a6e24ec96032a10e$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $a6e24ec96032a10e$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $a6e24ec96032a10e$var$formatArray(value, seenValues);
    return $a6e24ec96032a10e$var$formatObject(value, seenValues);
}
function $a6e24ec96032a10e$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $a6e24ec96032a10e$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $a6e24ec96032a10e$var$MAX_RECURSIVE_DEPTH) return '[' + $a6e24ec96032a10e$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $a6e24ec96032a10e$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $a6e24ec96032a10e$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $a6e24ec96032a10e$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($a6e24ec96032a10e$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($a6e24ec96032a10e$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $a6e24ec96032a10e$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}



/* c8 ignore next 3 */ const $35b4a3f1c242cc02$var$isProduction = globalThis.process && // eslint-disable-next-line no-undef
true;
const $35b4a3f1c242cc02$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
$35b4a3f1c242cc02$var$isProduction ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === 'object' && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $a6e24ec96032a10e$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $144e334857a3ea8b$export$1d2df86270c81ecb {
    constructor(body, name = 'GraphQL request', locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === 'string' || (0, $3424992c263c7f13$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $a6e24ec96032a10e$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $3424992c263c7f13$export$b6cb5906f04696c8)(false, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $3424992c263c7f13$export$b6cb5906f04696c8)(false, 'column in locationOffset is 1-indexed and must be positive.');
    }
    get [Symbol.toStringTag]() {
        return 'Source';
    }
}
function $144e334857a3ea8b$export$75135ee9ed6e435b(source) {
    return (0, $35b4a3f1c242cc02$export$ca03416d6c9e029e)(source, $144e334857a3ea8b$export$1d2df86270c81ecb);
}



function $719729a190b8652d$export$98e6a39c04603d36(source, options) {
    const parser = new $719729a190b8652d$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $719729a190b8652d$export$5303528d1070ff6f(source, options) {
    const parser = new $719729a190b8652d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EOF);
    return value;
}
function $719729a190b8652d$export$e14c466bd0916f7a(source, options) {
    const parser = new $719729a190b8652d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EOF);
    return value;
}
function $719729a190b8652d$export$28b8f402ccc88182(source, options) {
    const parser = new $719729a190b8652d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EOF);
    return type;
}
class $719729a190b8652d$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $144e334857a3ea8b$export$75135ee9ed6e435b)(source) ? source : new (0, $144e334857a3ea8b$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $ea66dcf81a3e8fb3$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case 'schema':
                    return this.parseSchemaDefinition();
                case 'scalar':
                    return this.parseScalarTypeDefinition();
                case 'type':
                    return this.parseObjectTypeDefinition();
                case 'interface':
                    return this.parseInterfaceTypeDefinition();
                case 'union':
                    return this.parseUnionTypeDefinition();
                case 'enum':
                    return this.parseEnumTypeDefinition();
                case 'input':
                    return this.parseInputObjectTypeDefinition();
                case 'directive':
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, descriptions are supported only on type definitions.');
            switch(keywordToken.value){
                case 'query':
                case 'mutation':
                case 'subscription':
                    return this.parseOperationDefinition();
                case 'fragment':
                    return this.parseFragmentDefinition();
                case 'extend':
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $aad516a724cab4ca$export$f58c50edb4aef9d4).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return (0, $aad516a724cab4ca$export$f58c50edb4aef9d4).QUERY;
            case 'mutation':
                return (0, $aad516a724cab4ca$export$f58c50edb4aef9d4).MUTATION;
            case 'subscription':
                return (0, $aad516a724cab4ca$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PAREN_L, item, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).STRING:
            case (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case 'true':
                        return this.node(token, {
                            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case 'false':
                        return this.node(token, {
                            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case 'null':
                        return this.node(token, {
                            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).LIST,
            values: this.any((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACKET_L, item, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L, item, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).STRING) || this.peek((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword('implements') ? this.delimitedMany((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === 'true' || this._lexer.token.value === 'false' || this._lexer.token.value === 'null') throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$719729a190b8652d$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $026f804cda7f6687$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $6d3ffc06aba975e8$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $aad516a724cab4ca$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$719729a190b8652d$var$getTokenKindDesc(kind)}, found ${$719729a190b8652d$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$719729a190b8652d$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$719729a190b8652d$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $bbb2cdcd2907f1c5$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $10ce613970f2e7b7$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $719729a190b8652d$var$getTokenDesc(token) {
    const value = token.value;
    return $719729a190b8652d$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $719729a190b8652d$var$getTokenKindDesc(kind) {
    return (0, $ea66dcf81a3e8fb3$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $6bf7edbaf5db437c$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($6bf7edbaf5db437c$var$escapedRegExp, $6bf7edbaf5db437c$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $6bf7edbaf5db437c$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $6bf7edbaf5db437c$var$escapedReplacer(str) {
    return $6bf7edbaf5db437c$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $6bf7edbaf5db437c$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];






const $a2447da659f1862e$export$a89c95c098ac2a58 = Object.freeze({});
function $a2447da659f1862e$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $aad516a724cab4ca$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $026f804cda7f6687$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $a2447da659f1862e$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $aad516a724cab4ca$export$8ee0fc9ee280b4ee)(node) || (0, $3424992c263c7f13$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $a6e24ec96032a10e$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $a2447da659f1862e$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $aad516a724cab4ca$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $a2447da659f1862e$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $026f804cda7f6687$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $a2447da659f1862e$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $a2447da659f1862e$export$a89c95c098ac2a58) skipping[i] = $a2447da659f1862e$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $a2447da659f1862e$export$a89c95c098ac2a58) skipping[i] = $a2447da659f1862e$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $a2447da659f1862e$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $a2447da659f1862e$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $a2447da659f1862e$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $03e8b6b7360bdf1b$export$c2d084dc44961371(ast) {
    return (0, $a2447da659f1862e$export$bf638b60ea8b89b7)(ast, $03e8b6b7360bdf1b$var$printDocASTReducer);
}
const $03e8b6b7360bdf1b$var$MAX_LINE_LENGTH = 80;
const $03e8b6b7360bdf1b$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$03e8b6b7360bdf1b$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $03e8b6b7360bdf1b$var$wrap('(', $03e8b6b7360bdf1b$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $03e8b6b7360bdf1b$var$join([
                node.operation,
                $03e8b6b7360bdf1b$var$join([
                    node.name,
                    varDefs
                ]),
                $03e8b6b7360bdf1b$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ': ' + type + $03e8b6b7360bdf1b$var$wrap(' = ', defaultValue) + $03e8b6b7360bdf1b$var$wrap(' ', $03e8b6b7360bdf1b$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$03e8b6b7360bdf1b$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $03e8b6b7360bdf1b$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $03e8b6b7360bdf1b$var$wrap('(', $03e8b6b7360bdf1b$var$join(args, ', '), ')');
            if (argsLine.length > $03e8b6b7360bdf1b$var$MAX_LINE_LENGTH) argsLine = prefix + $03e8b6b7360bdf1b$var$wrap('(\n', $03e8b6b7360bdf1b$var$indent($03e8b6b7360bdf1b$var$join(args, '\n')), '\n)');
            return $03e8b6b7360bdf1b$var$join([
                argsLine,
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $03e8b6b7360bdf1b$var$wrap(' ', $03e8b6b7360bdf1b$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$03e8b6b7360bdf1b$var$join([
                '...',
                $03e8b6b7360bdf1b$var$wrap('on ', typeCondition),
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$03e8b6b7360bdf1b$var$wrap('(', $03e8b6b7360bdf1b$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$03e8b6b7360bdf1b$var$wrap('', $03e8b6b7360bdf1b$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $af2cc9b626cfc780$export$adb6ca997eeb1f45)(value) : (0, $6bf7edbaf5db437c$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $03e8b6b7360bdf1b$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $03e8b6b7360bdf1b$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $03e8b6b7360bdf1b$var$wrap('(', $03e8b6b7360bdf1b$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$03e8b6b7360bdf1b$var$wrap('', description, '\n') + $03e8b6b7360bdf1b$var$join([
                'schema',
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                $03e8b6b7360bdf1b$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$03e8b6b7360bdf1b$var$wrap('', description, '\n') + $03e8b6b7360bdf1b$var$join([
                'scalar',
                name,
                $03e8b6b7360bdf1b$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$03e8b6b7360bdf1b$var$wrap('', description, '\n') + $03e8b6b7360bdf1b$var$join([
                'type',
                name,
                $03e8b6b7360bdf1b$var$wrap('implements ', $03e8b6b7360bdf1b$var$join(interfaces, ' & ')),
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                $03e8b6b7360bdf1b$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$03e8b6b7360bdf1b$var$wrap('', description, '\n') + name + ($03e8b6b7360bdf1b$var$hasMultilineItems(args) ? $03e8b6b7360bdf1b$var$wrap('(\n', $03e8b6b7360bdf1b$var$indent($03e8b6b7360bdf1b$var$join(args, '\n')), '\n)') : $03e8b6b7360bdf1b$var$wrap('(', $03e8b6b7360bdf1b$var$join(args, ', '), ')')) + ': ' + type + $03e8b6b7360bdf1b$var$wrap(' ', $03e8b6b7360bdf1b$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$03e8b6b7360bdf1b$var$wrap('', description, '\n') + $03e8b6b7360bdf1b$var$join([
                name + ': ' + type,
                $03e8b6b7360bdf1b$var$wrap('= ', defaultValue),
                $03e8b6b7360bdf1b$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$03e8b6b7360bdf1b$var$wrap('', description, '\n') + $03e8b6b7360bdf1b$var$join([
                'interface',
                name,
                $03e8b6b7360bdf1b$var$wrap('implements ', $03e8b6b7360bdf1b$var$join(interfaces, ' & ')),
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                $03e8b6b7360bdf1b$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$03e8b6b7360bdf1b$var$wrap('', description, '\n') + $03e8b6b7360bdf1b$var$join([
                'union',
                name,
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                $03e8b6b7360bdf1b$var$wrap('= ', $03e8b6b7360bdf1b$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$03e8b6b7360bdf1b$var$wrap('', description, '\n') + $03e8b6b7360bdf1b$var$join([
                'enum',
                name,
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                $03e8b6b7360bdf1b$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$03e8b6b7360bdf1b$var$wrap('', description, '\n') + $03e8b6b7360bdf1b$var$join([
                name,
                $03e8b6b7360bdf1b$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$03e8b6b7360bdf1b$var$wrap('', description, '\n') + $03e8b6b7360bdf1b$var$join([
                'input',
                name,
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                $03e8b6b7360bdf1b$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$03e8b6b7360bdf1b$var$wrap('', description, '\n') + 'directive @' + name + ($03e8b6b7360bdf1b$var$hasMultilineItems(args) ? $03e8b6b7360bdf1b$var$wrap('(\n', $03e8b6b7360bdf1b$var$indent($03e8b6b7360bdf1b$var$join(args, '\n')), '\n)') : $03e8b6b7360bdf1b$var$wrap('(', $03e8b6b7360bdf1b$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $03e8b6b7360bdf1b$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$03e8b6b7360bdf1b$var$join([
                'extend schema',
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                $03e8b6b7360bdf1b$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$03e8b6b7360bdf1b$var$join([
                'extend scalar',
                name,
                $03e8b6b7360bdf1b$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$03e8b6b7360bdf1b$var$join([
                'extend type',
                name,
                $03e8b6b7360bdf1b$var$wrap('implements ', $03e8b6b7360bdf1b$var$join(interfaces, ' & ')),
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                $03e8b6b7360bdf1b$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$03e8b6b7360bdf1b$var$join([
                'extend interface',
                name,
                $03e8b6b7360bdf1b$var$wrap('implements ', $03e8b6b7360bdf1b$var$join(interfaces, ' & ')),
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                $03e8b6b7360bdf1b$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$03e8b6b7360bdf1b$var$join([
                'extend union',
                name,
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                $03e8b6b7360bdf1b$var$wrap('= ', $03e8b6b7360bdf1b$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$03e8b6b7360bdf1b$var$join([
                'extend enum',
                name,
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                $03e8b6b7360bdf1b$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$03e8b6b7360bdf1b$var$join([
                'extend input',
                name,
                $03e8b6b7360bdf1b$var$join(directives, ' '),
                $03e8b6b7360bdf1b$var$block(fields)
            ], ' ')
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $03e8b6b7360bdf1b$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $03e8b6b7360bdf1b$var$block(array) {
    return $03e8b6b7360bdf1b$var$wrap('{\n', $03e8b6b7360bdf1b$var$indent($03e8b6b7360bdf1b$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $03e8b6b7360bdf1b$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $03e8b6b7360bdf1b$var$indent(str) {
    return $03e8b6b7360bdf1b$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $03e8b6b7360bdf1b$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}


/**
 * helpers
 */ const $05816512abbcc559$var$extractOperationName = (document)=>{
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = operationDefinitions[0]?.name?.value;
    return operationName;
};
const $05816512abbcc559$var$resolveRequestDocument = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $719729a190b8652d$export$98e6a39c04603d36)(document);
            operationName = $05816512abbcc559$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $05816512abbcc559$var$extractOperationName(document);
    return {
        query: (0, $03e8b6b7360bdf1b$export$c2d084dc44961371)(document),
        operationName: operationName
    };
};
$05816512abbcc559$exports.resolveRequestDocument = $05816512abbcc559$var$resolveRequestDocument;


var $85b3a016db8d5545$exports = {};
"use strict";
Object.defineProperty($85b3a016db8d5545$exports, "__esModule", {
    value: true
});
$85b3a016db8d5545$exports.ClientError = void 0;
class $85b3a016db8d5545$var$ClientError extends Error {
    constructor(response, request){
        const message = `${$85b3a016db8d5545$var$ClientError.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $85b3a016db8d5545$var$ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $85b3a016db8d5545$var$ClientError);
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}
$85b3a016db8d5545$exports.ClientError = $85b3a016db8d5545$var$ClientError;


Object.defineProperty($e9ab2d34d0380c8f$exports, "ClientError", {
    enumerable: true,
    get: function() {
        return $85b3a016db8d5545$exports.ClientError;
    }
});

const $e9ab2d34d0380c8f$var$cross_fetch_1 = $e9ab2d34d0380c8f$var$__importStar((parcelRequire("cUemu"))), $e9ab2d34d0380c8f$var$CrossFetch = $e9ab2d34d0380c8f$var$cross_fetch_1;
/**
 * Convert the given headers configuration into a plain object.
 */ const $e9ab2d34d0380c8f$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $e9ab2d34d0380c8f$var$CrossFetch && $e9ab2d34d0380c8f$var$CrossFetch.Headers && headers instanceof $e9ab2d34d0380c8f$var$CrossFetch.Headers) oHeaders = (0, $3a304f557554d0cb$exports.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $e9ab2d34d0380c8f$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $e9ab2d34d0380c8f$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($e9ab2d34d0380c8f$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $e9ab2d34d0380c8f$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $e9ab2d34d0380c8f$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = {
            ...params.headers
        };
        let queryParams = ``;
        let body = undefined;
        if (method === `POST`) {
            body = $e9ab2d34d0380c8f$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $e9ab2d34d0380c8f$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? $5eab6868c5a09ac5$exports.defaultJsonSerializer
        });
        const init = {
            method: method,
            headers: headers,
            body: body,
            ...fetchOptions
        };
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware({
                ...init,
                url: url,
                operationName: operationName,
                variables: variables
            }));
            const { url: urlNew, ...initNew } = result;
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $e9ab2d34d0380c8f$var$GraphQLClient {
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $8ec2785da8853547$exports.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers: headers, fetch: fetch = $e9ab2d34d0380c8f$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $05816512abbcc559$exports.resolveRequestDocument)(rawRequestOptions.query);
            return $e9ab2d34d0380c8f$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...$e9ab2d34d0380c8f$var$resolveHeaders($e9ab2d34d0380c8f$var$callOrIdentity(headers)),
                    ...$e9ab2d34d0380c8f$var$resolveHeaders(rawRequestOptions.requestHeaders)
                },
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $8ec2785da8853547$exports.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers: headers, fetch: fetch = $e9ab2d34d0380c8f$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $05816512abbcc559$exports.resolveRequestDocument)(requestOptions.document);
        return $e9ab2d34d0380c8f$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: {
                ...$e9ab2d34d0380c8f$var$resolveHeaders($e9ab2d34d0380c8f$var$callOrIdentity(headers)),
                ...$e9ab2d34d0380c8f$var$resolveHeaders(requestOptions.requestHeaders)
            },
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $8ec2785da8853547$exports.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers: headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $05816512abbcc559$exports.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        return $e9ab2d34d0380c8f$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...$e9ab2d34d0380c8f$var$resolveHeaders($e9ab2d34d0380c8f$var$callOrIdentity(headers)),
                ...$e9ab2d34d0380c8f$var$resolveHeaders(batchRequestOptions.requestHeaders)
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? $e9ab2d34d0380c8f$var$cross_fetch_1.default,
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
}
$e9ab2d34d0380c8f$exports.GraphQLClient = $e9ab2d34d0380c8f$var$GraphQLClient;
const $e9ab2d34d0380c8f$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    const fetcher = $e9ab2d34d0380c8f$var$createHttpMethodFetcher((0, $3a304f557554d0cb$exports.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await $e9ab2d34d0380c8f$var$getResult(response, fetchOptions.jsonSerializer ?? $5eab6868c5a09ac5$exports.defaultJsonSerializer);
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status
        };
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new $85b3a016db8d5545$exports.ClientError(// @ts-expect-error TODO
        {
            ...errorResult,
            status: response.status,
            headers: response.headers
        }, {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $e9ab2d34d0380c8f$var$rawRequest = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $8ec2785da8853547$exports.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $e9ab2d34d0380c8f$var$GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions
    });
};
$e9ab2d34d0380c8f$exports.rawRequest = $e9ab2d34d0380c8f$var$rawRequest;
// prettier-ignore
// eslint-disable-next-line
async function $e9ab2d34d0380c8f$var$request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $8ec2785da8853547$exports.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $e9ab2d34d0380c8f$var$GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions
    });
}
$e9ab2d34d0380c8f$exports.request = $e9ab2d34d0380c8f$var$request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $e9ab2d34d0380c8f$var$batchRequests = async (...args)=>{
    const params = $e9ab2d34d0380c8f$var$parseBatchRequestsArgsExtended(args);
    const client = new $e9ab2d34d0380c8f$var$GraphQLClient(params.url);
    return client.batchRequests(params);
};
$e9ab2d34d0380c8f$exports.batchRequests = $e9ab2d34d0380c8f$var$batchRequests;
const $e9ab2d34d0380c8f$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $e9ab2d34d0380c8f$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer ?? $5eab6868c5a09ac5$exports.defaultJsonSerializer;
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $e9ab2d34d0380c8f$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $e9ab2d34d0380c8f$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 * ```
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */ const $e9ab2d34d0380c8f$var$gql = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
$e9ab2d34d0380c8f$exports.gql = $e9ab2d34d0380c8f$var$gql;
var $fc12d7d22b6a112a$exports = {};
"use strict";
Object.defineProperty($fc12d7d22b6a112a$exports, "__esModule", {
    value: true
});
$fc12d7d22b6a112a$exports.GraphQLWebSocketClient = void 0;


// import type WebSocket from 'ws'
const $fc12d7d22b6a112a$var$CONNECTION_INIT = `connection_init`;
const $fc12d7d22b6a112a$var$CONNECTION_ACK = `connection_ack`;
const $fc12d7d22b6a112a$var$PING = `ping`;
const $fc12d7d22b6a112a$var$PONG = `pong`;
const $fc12d7d22b6a112a$var$SUBSCRIBE = `subscribe`;
const $fc12d7d22b6a112a$var$NEXT = `next`;
const $fc12d7d22b6a112a$var$ERROR = `error`;
const $fc12d7d22b6a112a$var$COMPLETE = `complete`;
class $fc12d7d22b6a112a$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $fc12d7d22b6a112a$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class $fc12d7d22b6a112a$var$GraphQLWebSocketClient {
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($fc12d7d22b6a112a$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $fc12d7d22b6a112a$var$parseMessage(e.data);
                switch(message.type){
                    case $fc12d7d22b6a112a$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $fc12d7d22b6a112a$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($fc12d7d22b6a112a$var$Pong(r).text));
                        else socket.send($fc12d7d22b6a112a$var$Pong(null).text);
                        return;
                    case $fc12d7d22b6a112a$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $fc12d7d22b6a112a$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new $85b3a016db8d5545$exports.ClientError({
                            ...message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $fc12d7d22b6a112a$var$ERROR:
                        subscriber.error && subscriber.error(new $85b3a016db8d5545$exports.ClientError({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $fc12d7d22b6a112a$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($fc12d7d22b6a112a$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($fc12d7d22b6a112a$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $05816512abbcc559$exports.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($fc12d7d22b6a112a$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
$fc12d7d22b6a112a$var$GraphQLWebSocketClient.PROTOCOL = `graphql-transport-ws`;
$fc12d7d22b6a112a$exports.GraphQLWebSocketClient = $fc12d7d22b6a112a$var$GraphQLWebSocketClient;
// Helper functions
function $fc12d7d22b6a112a$var$parseMessage(data, f = (a)=>a) {
    const m = $fc12d7d22b6a112a$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $fc12d7d22b6a112a$var$ConnectionInit(payload) {
    return new $fc12d7d22b6a112a$var$GraphQLWebSocketMessage($fc12d7d22b6a112a$var$CONNECTION_INIT, payload);
}
function $fc12d7d22b6a112a$var$Ping(payload) {
    return new $fc12d7d22b6a112a$var$GraphQLWebSocketMessage($fc12d7d22b6a112a$var$PING, payload, undefined);
}
function $fc12d7d22b6a112a$var$Pong(payload) {
    return new $fc12d7d22b6a112a$var$GraphQLWebSocketMessage($fc12d7d22b6a112a$var$PONG, payload, undefined);
}
function $fc12d7d22b6a112a$var$Subscribe(id, payload) {
    return new $fc12d7d22b6a112a$var$GraphQLWebSocketMessage($fc12d7d22b6a112a$var$SUBSCRIBE, payload, id);
}
function $fc12d7d22b6a112a$var$Complete(id) {
    return new $fc12d7d22b6a112a$var$GraphQLWebSocketMessage($fc12d7d22b6a112a$var$COMPLETE, undefined, id);
}


Object.defineProperty($e9ab2d34d0380c8f$exports, "GraphQLWebSocketClient", {
    enumerable: true,
    get: function() {
        return $fc12d7d22b6a112a$exports.GraphQLWebSocketClient;
    }
});

Object.defineProperty($e9ab2d34d0380c8f$exports, "resolveRequestDocument", {
    enumerable: true,
    get: function() {
        return $05816512abbcc559$exports.resolveRequestDocument;
    }
});
$e9ab2d34d0380c8f$exports.default = $e9ab2d34d0380c8f$var$request;


const $1edc7fce5f5909fe$export$eac3cf4e9287eeee = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteUpdateUserConsent($inConsent: Boolean!, $inUserSID: UUID!) {
        executeUpdateUserConsent(inUserSID: $inUserSID, inConsent: $inConsent) {
            UserSID
            Consent
        }
    }
`;
const $1edc7fce5f5909fe$export$3ffbfad93dfcf6b0 = (0, $e9ab2d34d0380c8f$exports.gql)`
    query ExecuteGetUser($inUserSID: UUID!) {
        executeGetUser(inUserSID: $inUserSID) {
            UserSID
            DateCreated
            UserName
            UserSID
            Jurisdiction
            Consent
        }
    }
`;



/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 
const $6489b9c55d9230bc$export$9860f5c9e20a307b = {
    names: {
        signUpSignIn: "B2C_1_MS_SIGN_UP_IN"
    },
    authorities: {
        signUpSignIn: {
            authority: "https://login.microsoftonline.com/f0d162a2-a074-489d-b6f6-961c4947c7a1/"
        }
    },
    authorityDomain: "iamcpsmdatadev.b2clogin.com"
};
const $6489b9c55d9230bc$export$f6d610d2730cbf1a = {
    auth: {
        // clientId: "2d2c3723-8a3b-4cec-97d2-fa0ff1728e9c", // B2C Application (client) ID
        // clientId: "1603fa39-9323-402c-a6b7-fc484de55e6f", // B2B Application (client) ID
        clientId: "1d54d0f5-57dc-434e-be58-129f0b7f0b68",
        // clientId: "1790d7b2-7398-4ca1-944c-9bcca681f895", // B2B Application (client) ID - server principal
        authority: $6489b9c55d9230bc$export$9860f5c9e20a307b.authorities.signUpSignIn.authority,
        redirectUri: "https://dev.data.infrastructureaustralia.gov.au/",
        // knownAuthorities: [b2cPolicies.authorityDomain],
        postLogoutRedirectUri: "https://dev.data.infrastructureaustralia.gov.au/"
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            logLevel: (0, $bf1c529f0722dfeb$export$243e62d78d3b544d).Warning,
            loggerCallback: (level, message, containsPii)=>{
                if (containsPii) return;
                switch(level){
                    case (0, $bf1c529f0722dfeb$export$243e62d78d3b544d).Error:
                        console.error(message);
                        return;
                    case (0, $bf1c529f0722dfeb$export$243e62d78d3b544d).Info:
                        console.info(message);
                        return;
                    case (0, $bf1c529f0722dfeb$export$243e62d78d3b544d).Verbose:
                        console.debug(message);
                        return;
                    case (0, $bf1c529f0722dfeb$export$243e62d78d3b544d).Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};
const $6489b9c55d9230bc$export$be6c432b2463c5eb = {
    scopes: [
        "openid",
        "profile",
        "api://data_api_builder_dev/Endpoint.Access"
    ]
};
const $6489b9c55d9230bc$export$4965d3e40bbf5ccb = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};



async function $5d270fced5bbffdf$export$52e83573e7782585(props) {
    const { query: query, variables: variables, instance: instance, accounts: accounts } = props;
    if (!accounts[0]) await instance.loginRedirect();
    const response = await instance.acquireTokenSilent({
        ...(0, $6489b9c55d9230bc$export$be6c432b2463c5eb),
        account: accounts[0]
    });
    const requestHeader = new Headers();
    const bearer = `Bearer ${response?.accessToken}`;
    requestHeader.append("Authorization", bearer);
    if (bearer) {
        requestHeader.append("X-MS-CLIENT-PRINCIPAL", btoa(JSON.stringify({
            "identityProvider": "AAD",
            "userRoles": [
                "authenticated"
            ]
        })));
        requestHeader.append("X-MS-API-ROLE", "authenticated");
    }
    return (0, $e9ab2d34d0380c8f$exports.request)((0, $24846570078166ea$export$d9391cfe998c8118), query, {
        ...variables,
        "inUserSID": accounts[0].localAccountId
    }, requestHeader);
}



var $i5lfL = parcelRequire("i5lfL");
const $8630c9f98862ab2d$export$1cf3d545f2d4635c = console;


// TYPES
// UTILS
const $1d7761b76a987a77$export$6acf61af03e62db = typeof window === 'undefined' || 'Deno' in window;
function $1d7761b76a987a77$export$8793edee2d425525() {
    return undefined;
}
function $1d7761b76a987a77$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $1d7761b76a987a77$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $1d7761b76a987a77$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $1d7761b76a987a77$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $1d7761b76a987a77$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $1d7761b76a987a77$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$1d7761b76a987a77$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $1d7761b76a987a77$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($1d7761b76a987a77$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === 'function') return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $1d7761b76a987a77$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $1d7761b76a987a77$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $1d7761b76a987a77$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $1d7761b76a987a77$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $1d7761b76a987a77$export$c5d1efe363797780(filters, query) {
    const { type: type = 'all', exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($1d7761b76a987a77$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $1d7761b76a987a77$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$1d7761b76a987a77$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== 'all') {
        const isActive = query.isActive();
        if (type === 'active' && !isActive) return false;
        if (type === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $1d7761b76a987a77$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($1d7761b76a987a77$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($1d7761b76a987a77$export$5fcb678681417b54(mutation.options.mutationKey) !== $1d7761b76a987a77$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$1d7761b76a987a77$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $1d7761b76a987a77$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $1d7761b76a987a77$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $1d7761b76a987a77$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$1d7761b76a987a77$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $1d7761b76a987a77$export$2f07189bb9fa26a7(a, b) {
    return $1d7761b76a987a77$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $1d7761b76a987a77$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some((key)=>!$1d7761b76a987a77$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $1d7761b76a987a77$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $1d7761b76a987a77$export$7a8558113332b71e(a) && $1d7761b76a987a77$export$7a8558113332b71e(b);
    if (array || $1d7761b76a987a77$export$53b83ca8eaab0383(a) && $1d7761b76a987a77$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $1d7761b76a987a77$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $1d7761b76a987a77$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $1d7761b76a987a77$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $1d7761b76a987a77$export$53b83ca8eaab0383(o) {
    if (!$1d7761b76a987a77$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$1d7761b76a987a77$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $1d7761b76a987a77$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $1d7761b76a987a77$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $1d7761b76a987a77$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $1d7761b76a987a77$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $1d7761b76a987a77$export$4304cb76768ca134(callback) {
    $1d7761b76a987a77$export$e772c8ff12451969(0).then(callback);
}
function $1d7761b76a987a77$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
    return;
}
function $1d7761b76a987a77$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === 'function') return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $1d7761b76a987a77$export$77a71fc411098696(prevData, data);
    return data;
}


function $fe9d89aed3961bcc$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $1d7761b76a987a77$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $1d7761b76a987a77$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $fe9d89aed3961bcc$export$520687f44db6e1ab = $fe9d89aed3961bcc$export$316a8efd03cd1458();



class $fb5c76ea4d5e5718$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $1d7761b76a987a77$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $1d7761b76a987a77$export$6acf61af03e62db) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}


class $eb937378799990eb$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}



class $6a3ffe6fec644043$export$86f1af424b2ca4de extends (0, $eb937378799990eb$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $1d7761b76a987a77$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === 'boolean') this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    }
}
const $6a3ffe6fec644043$export$6bf54661be5b02cf = new $6a3ffe6fec644043$export$86f1af424b2ca4de();




const $6dfc6da5bc5d426c$var$onlineEvents = [
    'online',
    'offline'
];
class $6dfc6da5bc5d426c$export$58774fb55d5ff7fc extends (0, $eb937378799990eb$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $1d7761b76a987a77$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $6dfc6da5bc5d426c$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $6dfc6da5bc5d426c$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === 'boolean') this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    }
}
const $6dfc6da5bc5d426c$export$b113e788b2dd3fdc = new $6dfc6da5bc5d426c$export$58774fb55d5ff7fc();



function $29b83148ec7584f6$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $29b83148ec7584f6$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : 'online') === 'online' ? (0, $6dfc6da5bc5d426c$export$b113e788b2dd3fdc).isOnline() : true;
}
class $29b83148ec7584f6$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $29b83148ec7584f6$export$986cc6445c1d323(value) {
    return value instanceof $29b83148ec7584f6$export$a8430ed4188f35a9;
}
function $29b83148ec7584f6$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $29b83148ec7584f6$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $6a3ffe6fec644043$export$6bf54661be5b02cf).isFocused() || config.networkMode !== 'always' && !(0, $6dfc6da5bc5d426c$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $29b83148ec7584f6$var$defaultRetryDelay;
            const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $1d7761b76a987a77$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($29b83148ec7584f6$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}


// CLASS
class $df5a92fb88dabce5$export$17b8b19c814bcf56 extends (0, $fb5c76ea4d5e5718$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $8630c9f98862ab2d$export$1cf3d545f2d4635c);
        this.observers = [];
        this.state = config.state || $df5a92fb88dabce5$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: 'observerAdded',
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: 'observerRemoved',
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === 'loading') this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $29b83148ec7584f6$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject('No mutationFn found');
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: 'failed',
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: 'pause'
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: 'continue'
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === 'loading';
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: 'loading',
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: 'error',
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        isPaused: true
                    };
                case 'continue':
                    return {
                        ...state,
                        isPaused: false
                    };
                case 'loading':
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $29b83148ec7584f6$export$61b92f63f30245cf)(this.options.networkMode),
                        status: 'loading',
                        variables: action.variables
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: 'success',
                        isPaused: false
                    };
                case 'error':
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: 'error'
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: 'updated',
                action: action
            });
        });
    }
}
function $df5a92fb88dabce5$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}





// CLASS
class $1710fdc8b5fd62b2$export$d3c1860ee66f291a extends (0, $eb937378799990eb$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, $1d7761b76a987a77$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: 'observerOptionsUpdated',
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, $df5a92fb88dabce5$export$a1659b54bac3252a)();
        const result = {
            ...state,
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
        });
    }
}


var $acdfb89a0a28f186$exports = {};
'use strict';

$acdfb89a0a28f186$exports = (parcelRequire("jHH2F"));


'use client';
const $9c1b0241fd6f0568$export$306c0aa65ff9ec16 = (0, $acdfb89a0a28f186$exports.useSyncExternalStore);



var $i5lfL = parcelRequire("i5lfL");
'use client';
const $09a29e98c9dccb10$export$2fba198b5b2e37fa = /*#__PURE__*/ $i5lfL.createContext(undefined);
const $09a29e98c9dccb10$var$QueryClientSharingContext = /*#__PURE__*/ $i5lfL.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $09a29e98c9dccb10$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $09a29e98c9dccb10$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $09a29e98c9dccb10$export$2fba198b5b2e37fa;
}
const $09a29e98c9dccb10$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $i5lfL.useContext($09a29e98c9dccb10$var$getQueryClientContext(context, $i5lfL.useContext($09a29e98c9dccb10$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
const $09a29e98c9dccb10$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $i5lfL.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $09a29e98c9dccb10$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $i5lfL.createElement($09a29e98c9dccb10$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $i5lfL.createElement(Context.Provider, {
        value: client
    }, children));
};


function $7cf790b1ac707dbc$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}


'use client';
function $d5a0a75b5a6b57e1$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $1d7761b76a987a77$export$b646c531ea475334)(arg1, arg2, arg3);
    const queryClient = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)({
        context: options.context
    });
    const [observer] = $i5lfL.useState(()=>new (0, $1710fdc8b5fd62b2$export$d3c1860ee66f291a)(queryClient, options));
    $i5lfL.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, $9c1b0241fd6f0568$export$306c0aa65ff9ec16)($i5lfL.useCallback((onStoreChange)=>observer.subscribe((0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $i5lfL.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($d5a0a75b5a6b57e1$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $7cf790b1ac707dbc$export$2072f68e6c3507cf)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $d5a0a75b5a6b57e1$var$noop() {}




var $bHJbJ = parcelRequire("bHJbJ");
parcelRequire("i5lfL");
const $1e45bbc546fcc05f$export$e57f4d7077011a2 = ()=>{
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)("div", {
        style: {
            textAlign: 'left',
            overflowY: 'auto',
            padding: '1rem'
        },
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)("h3", {
                children: "1. Terms of use"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "Access to, and use of, the Infrastructure Australia Data Platform is subject to these terms of use. These terms of use may change over time. The terms of use current at a given time are those published on this page at that time."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "By accessing or using the Infrastructure Australia Data Platform, you agree to be bound by these terms of use current at that time."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "You are responsible for the security and use of your Market Capacity user account. You must comply with all security requirements and instructions provided by Infrastructure Australia about your use of the Market Capacity Platform."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "a) You are responsible for the security and use of your Infrastructure Australia Data Platform user account. Your access to the Infrastructure Australia Data Platform occurs through and depends on: "
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "your employment with the agency or department you are engaged by and the Microsoft work account allocated to you; "
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "use of multi-factor authentication that has been allocated to you;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "you complying with all security requirements and instructions provided by Infrastructure Australia about your use of the Infrastructure Australia Data Platform."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)("p", {
                children: [
                    "b) In the event that your User Account is inactive for over 45 days your access will automatically be disabled. To reactivate your account please contact IA via: ",
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("a", {
                        href: "mailto:scenario.modelling@infrastructureaustralia.gov.au",
                        style: {
                            color: '#005670'
                        },
                        children: "scenario.modelling@infrastructureaustralia.gov.au"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "c) You must:"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "provide information that is true, accurate, current and complete to create your Infrastructure Australia Data Platform account and verify your identity; "
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "not use your Credentials for any unlawful or improper purpose;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "not disclose your Credentials to any other person;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "contact Infrastructure Australia if you believe the security of your Infrastructure Australia Data Platform account or Credentials have been compromised."
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                        children: " The Glossary below has more information about some terms used in this document."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("hr", {}),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("h3", {
                children: "2. Infrastructure Australia Data Platform provided as is"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "The Infrastructure Australia Data Platform is a national database of infrastructure projects and includes, but is not limited to,  the Market Capacity Database; the Market Capacity Pipeline Simulator; and the National Market Capacity Map and the software that underpins these tools."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "The Infrastructure Australia Data Platform works optimally using the Microsoft Edge Browser and must be accessed via a valid Microsoft work account.  Infrastructure Australia makes no guarantee that the Infrastructure Australia Data Platform will function outside supported platforms."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "To the extent permitted by law, Infrastructure Australia:"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "provides each of those elements of the Infrastructure Australia Data Platform \u2018as is\u2019 and without charge"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "gives no express or implied warranties or makes any representation (and to the full extent permitted by law excludes all statutory warranties) for each of those elements (including its availability, security, performance or fitness for a particular purpose)"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "will not be liable for any loss or damage (including special, indirect or consequential) arising from or in connection with any of those elements of the Infrastructure Australia Data Platform or its availability, use or performance either directly or through a third-party provider."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "To the extent that Infrastructure Australia's liability for the Infrastructure Australia Data Platform (or any part of it) cannot be excluded, it is limited to the resupply of the relevant goods or services, or the cost of such resupply, at Infrastructure Australia's option, or otherwise limited to the minimum amount permitted by law."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("hr", {}),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("h3", {
                children: "3. Use of Infrastructure Australia Data Platform"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "Infrastructure Australia, in line with terms of collaboration deeds in place with each jurisdiction, has developed the Infrastructure Australia Data Platform from information provided by each jurisdiction to:"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "construct and maintain diagnostic tools;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "develop reporting and analysis for the Australian Government and published reports,"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "Confidential information is aggregated or de-identified to ensure the confidential information cannot be identified and/or derived from the data."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "Infrastructure Australia makes the Infrastructure Australia Data Platform available to you to use in Australia, in unaltered form, solely for use in accordance with these terms."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "You must not:"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "access the Infrastructure Australia Data Platform and material held within it other than through the means approved by Infrastructure Australia; "
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "decompile, reverse engineer, disassemble or attempt to derive the source code for the Infrastructure Australia Data Platform;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "create derivative works based on the Infrastructure Australia Data Platform or modify it in any way;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "distribute copies of the software/ Infrastructure Australia Data Platform or versions of it;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "use the Infrastructure Australia Data Platform for compliance or regulatory purposes  ;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "attempt to identify particular projects or organisations to which the Aggregated Data relates;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "disclose to anyone (other than Infrastructure Australia) any instance where you may have identified a particular project or organisation from the Aggregated Data;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "make an attempt to match, with or without using identifiers, the Aggregated Data with any other list, database or repository of information;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "attempt to avoid, override or otherwise circumvent the controls put in place by Infrastructure Australia around the procedures and mode of access, including clearance of output, which are designed to prevent any deliberate or inadvertent breach of these terms;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "disclose the Aggregated Data to anyone without the approval of Infrastructure Australia or an authorised delegate and will immediately report to Infrastructure Australia any possible unauthorised disclosure that may have occurred ."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "You must comply with any other requirements notified by Infrastructure Australia, from time to time, regarding access to and use of the Infrastructure Australia Data Platform."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "You must ensure your use of the Infrastructure Australia Data Platform complies with all applicable conditions of use, including third-party software licensing conditions of use, relevant laws, including local laws in any relevant state or territory."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "The Platform uses third-party software Tableau and Microsoft under licence."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("hr", {}),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("h3", {
                children: "4. Infrastructure Australia Data Platform availability"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "You can access and use the Infrastructure Australia Data Platform through your User Account. While Infrastructure Australia will use reasonable efforts to rectify any issues with the Infrastructure Australia Data Platform that it is aware of:"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "Infrastructure Australia makes no guarantees that the Infrastructure Australia Data Platform, and your access to it (and your Infrastructure Australia user account), will be continuously available, uninterrupted, and fault or error free;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "your access to the Infrastructure Australia Data Platform (and your User Account) is contingent on telecommunication services and other factors beyond Infrastructure Australia\u2019s control; and"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "Infrastructure Australia may suspend or terminate access to the Infrastructure Australia Data Platform through some or all products or to some or all users at any time."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "You should take appropriate and adequate precautions to ensure that the information obtained from the Infrastructure Australia Data Platform is free of viruses or other contamination that may interfere with or damage your systems, devices or data."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)("p", {
                children: [
                    "You can email us for information about our Infrastructure Australia Data Platform at ",
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("a", {
                        href: "mailto:scenario.modelling@infrastructureaustralia.gov.au",
                        style: {
                            color: '#005670'
                        },
                        children: "scenario.modelling@infrastructureaustralia.gov.au"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("hr", {}),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("h3", {
                children: "5. Infrastructure Australia credentials"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "You are responsible for all transactions and communications carried out using your Credentials, and for the security and use of your User Account and the work device on which it is stored or work device used to authenticate."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "You are responsible for all transactions and communications carried out using your Market Capacity Platform credential, and for the security and use of your user account and the device on which it is stored or device used to authenticate."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "You must:"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "not use your Credentials for any unlawful or improper purpose;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "not disclose your User Account or Credentials to any other person;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "not store your Credentials in a place which any other person has access, or otherwise allow, grant, permit or enable any other person to use your Credentials;"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "not undertake any screen capture, sharing or like activities that might compromise the security of your User Account or Credentials; and"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                        children: "contact Infrastructure Australia as soon as you suspect or become aware that the security of your User Account or Credentials have been compromised."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("hr", {}),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("h3", {
                children: "6. General"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "Infrastructure Australia will collect, use, store and share your personal and sensitive information as detailed in the Privacy Policy.  Infrastructure Australia will disclose your personal information to third parties if you have provided your express consent to do so, or if authorised or required by law."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)("p", {
                children: [
                    "You acknowledge that Infrastructure Australia may suspend, cancel or revoke your Credentials if you breach these terms or are no longer eligible to hold a User Account. If you no longer wish to use the Infrastructure Australia Data Platform, you may contact Infrastructure Australia via ",
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("a", {
                        href: "mailto:scenario.modelling@infrastructureaustralia.gov.au",
                        style: {
                            color: '#005670'
                        },
                        children: "scenario.modelling@infrastructureaustralia.gov.au"
                    }),
                    " and request to be disconnected from the Infrastructure Australia Data Platform."
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "Any disputes between you and any third-party provider of the Infrastructure Australia Data Platform, must be resolved between you and that party."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("p", {
                children: "These terms of use constitute the entire agreement between you and Infrastructure Australia as administrator of the Infrastructure Australia Data Platform. They supersede all prior communications, representations, agreements or understanding about these terms."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("hr", {}),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                children: "Term and Definition Table"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)("table", {
                style: {
                    width: '100%',
                    borderCollapse: 'collapse',
                    marginTop: '1rem'
                },
                border: 1,
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)("th", {
                                    style: {
                                        padding: '8px'
                                    },
                                    children: "Term"
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)("th", {
                                    style: {
                                        padding: '8px'
                                    },
                                    children: "Definition"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)("td", {
                                        style: {
                                            padding: '8px'
                                        },
                                        children: "Aggregated Data"
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)("td", {
                                        style: {
                                            padding: '8px'
                                        },
                                        children: "Data held in the Infrastructure Australia Data Platform is aggregated by collecting up individual project submissions from states and territories."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)("td", {
                                        style: {
                                            padding: '8px'
                                        },
                                        children: "Credentials"
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsxs)("td", {
                                        style: {
                                            padding: '8px'
                                        },
                                        children: [
                                            "To access the Infrastructure Australia Data Platform the following information is required for each user:",
                                            /*#__PURE__*/ (0, $bHJbJ.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                                                        children: "a distinguishable name to identify an individual user;"
                                                    }),
                                                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                                                        children: "password that complies with agency security requirements; and"
                                                    }),
                                                    /*#__PURE__*/ (0, $bHJbJ.jsx)("li", {
                                                        children: "Multi-Factor Authentication (MFA), Microsoft Authenticator App or MFA Number matching"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)("td", {
                                        style: {
                                            padding: '8px'
                                        },
                                        children: "Infrastructure Australia Data Platform"
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)("td", {
                                        style: {
                                            padding: '8px'
                                        },
                                        children: "Is a national database of infrastructure projects which includes, but is not limited to, the Market Capacity Database; the Market Capacity Pipeline Simulator; and the National Market Capacity Map and the software that underpins these tools."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)("td", {
                                        style: {
                                            padding: '8px'
                                        },
                                        children: "User Account"
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)("td", {
                                        style: {
                                            padding: '8px'
                                        },
                                        children: "Individual user account linked to a Microsoft work account issued by a participating commonwealth, state or territory department or agency accessed via Credentials to the Infrastructure Australia Data Platform."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)("hr", {}),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)("p", {
                children: [
                    "If you have any questions and concerns about the Terms of Use please contact ",
                    /*#__PURE__*/ (0, $bHJbJ.jsx)("a", {
                        href: "mailto:scenario.modelling@infrastructureaustralia.gov.au",
                        style: {
                            color: '#005670'
                        },
                        children: "scenario.modelling@infrastructureaustralia.gov.au"
                    })
                ]
            })
        ]
    });
};









class $5dc61692b1aef9b8$export$a06cf8c0066f0d4c extends (0, $eb937378799990eb$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($5dc61692b1aef9b8$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $5dc61692b1aef9b8$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $5dc61692b1aef9b8$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $1d7761b76a987a77$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: 'observerOptionsUpdated',
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $5dc61692b1aef9b8$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($5dc61692b1aef9b8$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $1d7761b76a987a77$export$8793edee2d425525));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $1d7761b76a987a77$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $1d7761b76a987a77$export$e539f754e934e270)(this.options.staleTime)) return;
        const time = (0, $1d7761b76a987a77$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $1d7761b76a987a77$export$6acf61af03e62db) || this.options.enabled === false || !(0, $1d7761b76a987a77$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $6a3ffe6fec644043$export$6bf54661be5b02cf).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $5dc61692b1aef9b8$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $5dc61692b1aef9b8$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $29b83148ec7584f6$export$61b92f63f30245cf)(query.options.networkMode) ? 'fetching' : 'paused';
                if (!dataUpdatedAt) status = 'loading';
            }
            if (options._optimisticResults === 'isRestoring') fetchStatus = 'idle';
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $1d7761b76a987a77$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = (0, $1d7761b76a987a77$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        const isFetching = fetchStatus === 'fetching';
        const isLoading = status === 'loading';
        const isError = status === 'error';
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === 'success',
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === 'paused',
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $5dc61692b1aef9b8$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $1d7761b76a987a77$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === 'function' ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === 'all' || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add('error');
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = !action.manual;
        else if (action.type === 'error' && !(0, $29b83148ec7584f6$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    }
}
function $5dc61692b1aef9b8$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $5dc61692b1aef9b8$var$shouldFetchOnMount(query, options) {
    return $5dc61692b1aef9b8$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $5dc61692b1aef9b8$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $5dc61692b1aef9b8$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $5dc61692b1aef9b8$var$isStale(query, options);
    }
    return false;
}
function $5dc61692b1aef9b8$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $5dc61692b1aef9b8$var$isStale(query, options);
}
function $5dc61692b1aef9b8$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $5dc61692b1aef9b8$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $1d7761b76a987a77$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}



var $i5lfL = parcelRequire("i5lfL");



var $i5lfL = parcelRequire("i5lfL");
'use client';
function $ebd4fbc1979b097e$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $ebd4fbc1979b097e$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $i5lfL.createContext($ebd4fbc1979b097e$var$createValue()); // HOOK
const $ebd4fbc1979b097e$export$50dfac555130cafd = ()=>$i5lfL.useContext($ebd4fbc1979b097e$var$QueryErrorResetBoundaryContext); // COMPONENT
const $ebd4fbc1979b097e$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $i5lfL.useState(()=>$ebd4fbc1979b097e$var$createValue());
    return /*#__PURE__*/ $i5lfL.createElement($ebd4fbc1979b097e$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};




var $i5lfL = parcelRequire("i5lfL");
'use client';
const $21835ad9f83c11df$var$IsRestoringContext = /*#__PURE__*/ $i5lfL.createContext(false);
const $21835ad9f83c11df$export$4da0178d6b5f553 = ()=>$i5lfL.useContext($21835ad9f83c11df$var$IsRestoringContext);
const $21835ad9f83c11df$export$593807d4e94f9621 = $21835ad9f83c11df$var$IsRestoringContext.Provider;



var $i5lfL = parcelRequire("i5lfL");

'use client';
const $c022f1e2e8f8d707$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $c022f1e2e8f8d707$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $i5lfL.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $c022f1e2e8f8d707$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $7cf790b1ac707dbc$export$2072f68e6c3507cf)(useErrorBoundary, [
        result.error,
        query
    ]);
};


const $05953841d4ac4e5c$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
    }
};
const $05953841d4ac4e5c$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $05953841d4ac4e5c$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $05953841d4ac4e5c$export$e0a3f29513afe430(result, isRestoring);
const $05953841d4ac4e5c$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });


'use client';
function $0c94f9ed6d06da58$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)({
        context: options.context
    });
    const isRestoring = (0, $21835ad9f83c11df$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $ebd4fbc1979b097e$export$50dfac555130cafd)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    (0, $05953841d4ac4e5c$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $c022f1e2e8f8d707$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $c022f1e2e8f8d707$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $i5lfL.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $9c1b0241fd6f0568$export$306c0aa65ff9ec16)($i5lfL.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $i5lfL.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $05953841d4ac4e5c$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $05953841d4ac4e5c$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $c022f1e2e8f8d707$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


'use client';
function $45631327982d6a29$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $1d7761b76a987a77$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $0c94f9ed6d06da58$export$fff0865807e996c5)(parsedOptions, (0, $5dc61692b1aef9b8$export$a06cf8c0066f0d4c));
}



function $8aac0537827a6bae$export$801fe16824f675f7() {
    const client = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)();
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const isAuthenticated = (0, $91b77ab8667707a4$export$7e9c60d6d1836c84)();
    return (0, $45631327982d6a29$export$dd0a697e1782aedd)([
        "getUserInfo"
    ], {
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $1edc7fce5f5909fe$export$3ffbfad93dfcf6b0),
                instance: instance,
                accounts: accounts
            });
        },
        enabled: isAuthenticated,
        onSuccess: (data)=>{
            client.invalidateQueries([
                "Lists"
            ]);
            client.invalidateQueries([
                "stateResult"
            ]);
        }
    });
}


function $f7b695d16b75ee9b$export$2e2bcd8739ae039(props) {
    const client = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)();
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const { children: children } = props;
    const isAuthenticated = (0, $91b77ab8667707a4$export$7e9c60d6d1836c84)();
    const [consent, setConsent] = $i5lfL.useState(false);
    const [alertOpen, setAlertOpen] = $i5lfL.useState(false);
    const { mutate: updateConsent } = (0, $d5a0a75b5a6b57e1$export$609860bf8b0084c)([
        "updateConsent"
    ], {
        mutationFn: (variables)=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $1edc7fce5f5909fe$export$eac3cf4e9287eeee),
                variables: variables,
                instance: instance,
                accounts: accounts
            });
        },
        onSuccess: ()=>{
            client.invalidateQueries([
                "getUserInfo"
            ]);
        }
    });
    const { data: userInfo } = (0, $8aac0537827a6bae$export$801fe16824f675f7)();
    const handleClose = (event, reason)=>{
        if (reason === 'clickaway') return;
        setAlertOpen(false);
    };
    const action = /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                color: "secondary",
                size: "small",
                onClick: handleClose,
                children: "UNDO"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                size: "small",
                "aria-label": "close",
                color: "inherit",
                onClick: handleClose,
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96c82ddda143b076$exports))), {
                    fontSize: "small"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        sx: {
            height: "100%",
            width: "100%"
        },
        display: "flex",
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            height: "10vh"
                        },
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3c6d0e989d4264c8$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            minHeight: "79vh",
                            zIndex: "400",
                            p: ".5%",
                            pr: "6%"
                        },
                        children: children
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            height: "10vh"
                        },
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $df7ce8a7d370bf29$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039), {
                // @ts-ignore
                open: !consent && isAuthenticated,
                fullWidth: true,
                maxWidth: "md",
                sx: {
                    "& .MuiDialog-paper": {
                        width: "80%",
                        maxWidth: "80%",
                        height: "80vh",
                        maxHeight: "80vh"
                    }
                },
                children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $422502a3833a93e2$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        height: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a63770281394464a$export$2e2bcd8739ae039), {
                            component: "div",
                            sx: {
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%"
                                },
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1e45bbc546fcc05f$export$e57f4d7077011a2), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                mt: 2
                            },
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                    variant: "contained",
                                    onClick: ()=>{
                                        setConsent(true);
                                        updateConsent({
                                            inConsent: true
                                        });
                                    },
                                    // @ts-ignore
                                    disabled: !userInfo?.executeGetUser[0]?.Jurisdiction,
                                    children: "Consent"
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        setConsent(false);
                                        updateConsent({
                                            inConsent: false
                                        });
                                        setAlertOpen(true);
                                    },
                                    children: "No"
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $2b36172c0c84cfd5$export$2e2bcd8739ae039), {
                                    open: alertOpen,
                                    autoHideDuration: 3000,
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'center'
                                    },
                                    onClose: handleClose,
                                    action: action,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $097160938072b98e$export$2e2bcd8739ae039), {
                                        onClose: handleClose,
                                        severity: "warning",
                                        variant: "filled",
                                        sx: {
                                            width: '100%'
                                        },
                                        children: "Please consent to the TOU to proceed"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/*
 * Copyright (c) 2023. RoZetta Technology Pty Ltd. All rights reserved.
 */ 
var $87pNb = parcelRequire("87pNb");
/*
 * Copyright (c) 2023. RoZetta Technology Pty Ltd. All rights reserved.
 */ const $e92a7a02eb84a957$var$basicThemePalette = {
    text: {
        primary: "#111111",
        disabled: "#5B5E68"
    },
    primary: {
        main: "#005670"
    },
    secondary: {
        main: "#ABC7CA",
        // @ts-ignore
        secondary: "#34657F" // underlines, activated borders, , submit/confirmation buttons
    },
    success: {
        main: "#BCD546"
    },
    info: {
        main: "#1D2155"
    },
    background: {
        // By default there is a very light background (250, 250, 250)
        default: "#ffffff"
    }
};
var $e92a7a02eb84a957$export$2e2bcd8739ae039 = $e92a7a02eb84a957$var$basicThemePalette;


const $f78e542a41fde46b$export$f059f1ef676bf70 = {
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "left"
    }
};
const $f78e542a41fde46b$var$IATheme = (0, $87pNb.default)({
    palette: (0, $e92a7a02eb84a957$export$2e2bcd8739ae039),
    typography: {
        fontFamily: "ProximaNova",
        h1: {
            fontFamily: "ProximaNova-Bold",
            fontSize: 30
        },
        h2: {
            fontFamily: "ProximaNova",
            fontSize: 30
        },
        h3: {
            fontFamily: "ProximaNova-Bold",
            fontSize: 17
        },
        h4: {
            fontSize: 17
        },
        h5: {
            fontFamily: "ProximaNova-Bold",
            fontSize: 25
        },
        h6: {
            fontFamily: "ProximaNova-Bold",
            fontSize: 14
        },
        subtitle1: {
            fontFamily: "ProximaNova-Bold",
            fontSize: 14
        },
        subtitle2: {
            fontSize: 10
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
        @font-face {
          font-family: 'ProximaNova';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `
        },
        MuiToolbar: {
            styleOverrides: {
                regular: {
                    minHeight: 48,
                    "@media (min-width: 600px)": {
                        minHeight: 48
                    }
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: 14
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                outlined: {
                    backgroundColor: (0, $e92a7a02eb84a957$export$2e2bcd8739ae039).background?.default ?? "#131e29",
                    paddingLeft: 2,
                    paddingRight: 2
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                SelectProps: {
                    MenuProps: $f78e542a41fde46b$export$f059f1ef676bf70
                }
            }
        },
        MuiSelect: {
            defaultProps: {
                MenuProps: $f78e542a41fde46b$export$f059f1ef676bf70
            }
        }
    }
});
var $f78e542a41fde46b$export$2e2bcd8739ae039 = $f78e542a41fde46b$var$IATheme;


/*
 * Copyright (c) 2023. RoZetta Technology Pty Ltd. All rights reserved.
 */ 
var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");


var $VEXgj = parcelRequire("VEXgj");

var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");


var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $47cccd7b2dba7e40$export$72aef224d6115253(slot) {
    return (0, $6bbZp.default)('MuiTab', slot);
}
const $47cccd7b2dba7e40$var$tabClasses = (0, $47i1c.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
var $47cccd7b2dba7e40$export$2e2bcd8739ae039 = $47cccd7b2dba7e40$var$tabClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $d4b11b3a23282916$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $d4b11b3a23282916$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $VEXgj.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $47cccd7b2dba7e40$export$72aef224d6115253), classes);
};
const $d4b11b3a23282916$var$TabRoot = (0, $j7y1Z.default)((0, $07a3ed667acb77f6$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $VEXgj.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $47cccd7b2dba7e40$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            }
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $47cccd7b2dba7e40$export$2e2bcd8739ae039).iconWrapper}`]: (0, $1CWiu.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $47cccd7b2dba7e40$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $47cccd7b2dba7e40$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $47cccd7b2dba7e40$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $47cccd7b2dba7e40$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $47cccd7b2dba7e40$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $47cccd7b2dba7e40$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $d4b11b3a23282916$var$Tab = /*#__PURE__*/ $i5lfL.forwardRef(function Tab(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $7qXFD.default)(props, $d4b11b3a23282916$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $d4b11b3a23282916$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $i5lfL.isValidElement(iconProp) ? /*#__PURE__*/ $i5lfL.cloneElement(iconProp, {
        className: (0, $kRbLW.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($d4b11b3a23282916$var$TabRoot, (0, $1CWiu.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $kRbLW.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $d4b11b3a23282916$export$2e2bcd8739ae039 = $d4b11b3a23282916$var$Tab;


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");
parcelRequire("67Wr0");


var $kRbLW = parcelRequire("kRbLW");


var $2ktY3 = parcelRequire("2ktY3");



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $a1245530fea59ef4$var$cachedType;
function $a1245530fea59ef4$export$a10970ffb6510128() {
    if ($a1245530fea59ef4$var$cachedType) return $a1245530fea59ef4$var$cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $a1245530fea59ef4$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $a1245530fea59ef4$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $a1245530fea59ef4$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $a1245530fea59ef4$var$cachedType;
}
function $a1245530fea59ef4$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = $a1245530fea59ef4$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $0476d28454df863a$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $0476d28454df863a$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $0476d28454df863a$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");




var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $83b8cdc072cea6f9$var$_excluded = [
    "onChange"
];
const $83b8cdc072cea6f9$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $83b8cdc072cea6f9$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $7qXFD.default)(props, $83b8cdc072cea6f9$var$_excluded);
    const scrollbarHeight = $i5lfL.useRef();
    const nodeRef = $i5lfL.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $946b6dd96ae69a8b$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $35800e9c430cfaca$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $1f9da73f8999125a$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $i5lfL.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)("div", (0, $1CWiu.default)({
        style: $83b8cdc072cea6f9$var$styles,
        ref: nodeRef
    }, other));
}



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");


parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $af26105860e4706a$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $fa9fbff4fa708c9e$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');




var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $848f59dfff18f737$export$34861783d3c2eef8(slot) {
    return (0, $6bbZp.default)('MuiTabScrollButton', slot);
}
const $848f59dfff18f737$var$tabScrollButtonClasses = (0, $47i1c.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $848f59dfff18f737$export$2e2bcd8739ae039 = $848f59dfff18f737$var$tabScrollButtonClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $68ed3926d4314a49$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $68ed3926d4314a49$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $848f59dfff18f737$export$34861783d3c2eef8), classes);
};
const $68ed3926d4314a49$var$TabScrollButtonRoot = (0, $j7y1Z.default)((0, $07a3ed667acb77f6$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $848f59dfff18f737$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $68ed3926d4314a49$var$TabScrollButton = /*#__PURE__*/ $i5lfL.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $7qXFD.default)(props, $68ed3926d4314a49$var$_excluded);
    const isRtl = (0, $dd848b3fb63e28ea$export$b2dd014b6c321cb)();
    const ownerState = (0, $1CWiu.default)({
        isRtl: isRtl
    }, props);
    const classes = $68ed3926d4314a49$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $af26105860e4706a$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $fa9fbff4fa708c9e$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($68ed3926d4314a49$var$TabScrollButtonRoot, (0, $1CWiu.default)({
        component: "div",
        className: (0, $kRbLW.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, $bHJbJ.jsx)(StartButtonIcon, (0, $1CWiu.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $bHJbJ.jsx)(EndButtonIcon, (0, $1CWiu.default)({}, endButtonIconProps))
    }));
});
var $68ed3926d4314a49$export$2e2bcd8739ae039 = $68ed3926d4314a49$var$TabScrollButton;




var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $1efac0730c3d8091$export$cdd93bd054dec359(slot) {
    return (0, $6bbZp.default)('MuiTabs', slot);
}
const $1efac0730c3d8091$var$tabsClasses = (0, $47i1c.default)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $1efac0730c3d8091$export$2e2bcd8739ae039 = $1efac0730c3d8091$var$tabsClasses;





var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $bd3cee31033a2ffb$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $bd3cee31033a2ffb$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $bd3cee31033a2ffb$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $bd3cee31033a2ffb$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $bd3cee31033a2ffb$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $1efac0730c3d8091$export$cdd93bd054dec359), classes);
};
const $bd3cee31033a2ffb$var$TabsRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $1efac0730c3d8091$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $1efac0730c3d8091$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $1CWiu.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $1efac0730c3d8091$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const $bd3cee31033a2ffb$var$TabsScroller = (0, $j7y1Z.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const $bd3cee31033a2ffb$var$FlexContainer = (0, $j7y1Z.default)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const $bd3cee31033a2ffb$var$TabsIndicator = (0, $j7y1Z.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $1CWiu.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const $bd3cee31033a2ffb$var$TabsScrollbarSize = (0, $j7y1Z.default)((0, $83b8cdc072cea6f9$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $bd3cee31033a2ffb$var$defaultIndicatorStyle = {};
let $bd3cee31033a2ffb$var$warnedOnceTabPresent = false;
const $bd3cee31033a2ffb$var$Tabs = /*#__PURE__*/ $i5lfL.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const isRtl = (0, $dd848b3fb63e28ea$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent = (0, $68ed3926d4314a49$export$2e2bcd8739ae039), scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $7qXFD.default)(props, $bd3cee31033a2ffb$var$_excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $bd3cee31033a2ffb$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $i5lfL.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $i5lfL.useState($bd3cee31033a2ffb$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $i5lfL.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $i5lfL.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $i5lfL.useState(false);
    const [scrollerStyle, setScrollerStyle] = $i5lfL.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $i5lfL.useRef(null);
    const tabListRef = $i5lfL.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $a1245530fea59ef4$export$3c615b88e5d7e4f6)(tabsNode, isRtl ? 'rtl' : 'ltr'),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $91b1a2d3fafb0346$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $0476d28454df863a$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $a1245530fea59ef4$export$a10970ffb6510128)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $i5lfL.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $bHJbJ.jsx)($bd3cee31033a2ffb$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $kRbLW.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $bHJbJ.jsx)(ScrollButtonComponent, (0, $1CWiu.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $kRbLW.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $bHJbJ.jsx)(ScrollButtonComponent, (0, $1CWiu.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $kRbLW.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $91b1a2d3fafb0346$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $91b1a2d3fafb0346$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $i5lfL.useEffect(()=>{
        const handleResize = (0, $35800e9c430cfaca$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $1f9da73f8999125a$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $i5lfL.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $i5lfL.useEffect(()=>{
        setMounted(true);
    }, []);
    $i5lfL.useEffect(()=>{
        updateIndicatorState();
    });
    $i5lfL.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($bd3cee31033a2ffb$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $i5lfL.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $bHJbJ.jsx)($bd3cee31033a2ffb$var$TabsIndicator, (0, $1CWiu.default)({}, TabIndicatorProps, {
        className: (0, $kRbLW.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $1CWiu.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $i5lfL.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $i5lfL.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $i5lfL.cloneElement(child, (0, $1CWiu.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $46552687c83b186a$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $bd3cee31033a2ffb$var$moveFocus(list, currentFocus, $bd3cee31033a2ffb$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $bd3cee31033a2ffb$var$moveFocus(list, currentFocus, $bd3cee31033a2ffb$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $bd3cee31033a2ffb$var$moveFocus(list, null, $bd3cee31033a2ffb$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $bd3cee31033a2ffb$var$moveFocus(list, null, $bd3cee31033a2ffb$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($bd3cee31033a2ffb$var$TabsRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $bHJbJ.jsxs)($bd3cee31033a2ffb$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)($bd3cee31033a2ffb$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $bd3cee31033a2ffb$export$2e2bcd8739ae039 = $bd3cee31033a2ffb$var$Tabs;



// noinspection GraphQLUnresolvedReference

var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");

var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");
/**
 * table-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function $34de474a8ff218be$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $34de474a8ff218be$export$8793edee2d425525() {
//
}
function $34de474a8ff218be$export$2b5605d8069324bd(key, instance) {
    return (updater)=>{
        instance.setState((old)=>{
            return {
                ...old,
                [key]: $34de474a8ff218be$export$7f095f455ad5af3f(updater, old[key])
            };
        });
    };
}
function $34de474a8ff218be$export$f6e2535fb5126e54(d) {
    return d instanceof Function;
}
function $34de474a8ff218be$export$5cd576d1827d40c8(d) {
    return Array.isArray(d) && d.every((val)=>typeof val === 'number');
}
function $34de474a8ff218be$export$bf4548421d1b2c8(arr, getChildren) {
    const flat = [];
    const recurse = (subArr)=>{
        subArr.forEach((item)=>{
            flat.push(item);
            const children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function $34de474a8ff218be$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = [];
    let result;
    return ()=>{
        let depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn(...newDeps);
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = ' ' + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function $34de474a8ff218be$export$1bfa986e9c92c0b5(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    const defaultColumn = table._getDefaultColumnDef();
    const resolvedColumnDef = {
        ...defaultColumn,
        ...columnDef
    };
    const accessorKey = resolvedColumnDef.accessorKey;
    let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? accessorKey.replace('.', '_') : undefined) != null ? _ref : typeof resolvedColumnDef.header === 'string' ? resolvedColumnDef.header : undefined;
    let accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes('.')) accessorFn = (originalRow)=>{
            let result = originalRow;
            for (const key of accessorKey.split('.')){
                var _result;
                result = (_result = result) == null ? void 0 : _result[key];
            }
            return result;
        };
        else accessorFn = (originalRow)=>originalRow[resolvedColumnDef.accessorKey];
    }
    if (!id) throw new Error();
    let column = {
        id: `${String(id)}`,
        accessorFn: accessorFn,
        parent: parent,
        depth: depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                true
            ], ()=>{
            var _column$columns;
            return [
                column,
                ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d)=>d.getFlatColumns())
            ];
        }, {
            key: 'column.getFlatColumns',
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugColumns;
            }
        }),
        getLeafColumns: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table._getOrderColumnsFn()
            ], (orderColumns)=>{
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                let leafColumns = column.columns.flatMap((column)=>column.getLeafColumns());
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, {
            key: 'column.getLeafColumns',
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugColumns;
            }
        })
    };
    column = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.createColumn == null ? void 0 : feature.createColumn(column, table));
    }, column);
    // Yes, we have to convert table to uknown, because we know more than the compiler here.
    return column;
}
//
function $34de474a8ff218be$var$createHeader(table, column, options) {
    var _options$id;
    const id = (_options$id = options.id) != null ? _options$id : column.id;
    let header = {
        id: id,
        column: column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: ()=>{
            const leafHeaders = [];
            const recurseHeader = (h)=>{
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: ()=>({
                table: table,
                header: header,
                column: column
            })
    };
    table._features.forEach((feature)=>{
        Object.assign(header, feature.createHeader == null ? void 0 : feature.createHeader(header, table));
    });
    return header;
}
const $34de474a8ff218be$export$79b704688b15c0f4 = {
    createTable: (table)=>{
        return {
            // Header Groups
            getHeaderGroups: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getAllColumns(),
                    table.getVisibleLeafColumns(),
                    table.getState().columnPinning.left,
                    table.getState().columnPinning.right
                ], (allColumns, leafColumns, left, right)=>{
                var _left$map$filter, _right$map$filter;
                const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
                const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
                const centerColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
                const headerGroups = $34de474a8ff218be$export$d8c3a8af36458fc3(allColumns, [
                    ...leftColumns,
                    ...centerColumns,
                    ...rightColumns
                ], table);
                return headerGroups;
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA;
                    return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugHeaders;
                }
            }),
            getCenterHeaderGroups: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getAllColumns(),
                    table.getVisibleLeafColumns(),
                    table.getState().columnPinning.left,
                    table.getState().columnPinning.right
                ], (allColumns, leafColumns, left, right)=>{
                leafColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
                return $34de474a8ff218be$export$d8c3a8af36458fc3(allColumns, leafColumns, table, 'center');
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA2;
                    return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugHeaders;
                }
            }),
            getLeftHeaderGroups: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getAllColumns(),
                    table.getVisibleLeafColumns(),
                    table.getState().columnPinning.left
                ], (allColumns, leafColumns, left)=>{
                var _left$map$filter2;
                const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
                return $34de474a8ff218be$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, 'left');
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA3;
                    return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugHeaders;
                }
            }),
            getRightHeaderGroups: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getAllColumns(),
                    table.getVisibleLeafColumns(),
                    table.getState().columnPinning.right
                ], (allColumns, leafColumns, right)=>{
                var _right$map$filter2;
                const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
                return $34de474a8ff218be$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, 'right');
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA4;
                    return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugHeaders;
                }
            }),
            // Footer Groups
            getFooterGroups: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getHeaderGroups()
                ], (headerGroups)=>{
                return [
                    ...headerGroups
                ].reverse();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA5;
                    return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugHeaders;
                }
            }),
            getLeftFooterGroups: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getLeftHeaderGroups()
                ], (headerGroups)=>{
                return [
                    ...headerGroups
                ].reverse();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA6;
                    return (_table$options$debugA6 = table.options.debugAll) != null ? _table$options$debugA6 : table.options.debugHeaders;
                }
            }),
            getCenterFooterGroups: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getCenterHeaderGroups()
                ], (headerGroups)=>{
                return [
                    ...headerGroups
                ].reverse();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA7;
                    return (_table$options$debugA7 = table.options.debugAll) != null ? _table$options$debugA7 : table.options.debugHeaders;
                }
            }),
            getRightFooterGroups: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getRightHeaderGroups()
                ], (headerGroups)=>{
                return [
                    ...headerGroups
                ].reverse();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA8;
                    return (_table$options$debugA8 = table.options.debugAll) != null ? _table$options$debugA8 : table.options.debugHeaders;
                }
            }),
            // Flat Headers
            getFlatHeaders: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getHeaderGroups()
                ], (headerGroups)=>{
                return headerGroups.map((headerGroup)=>{
                    return headerGroup.headers;
                }).flat();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA9;
                    return (_table$options$debugA9 = table.options.debugAll) != null ? _table$options$debugA9 : table.options.debugHeaders;
                }
            }),
            getLeftFlatHeaders: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getLeftHeaderGroups()
                ], (left)=>{
                return left.map((headerGroup)=>{
                    return headerGroup.headers;
                }).flat();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA10;
                    return (_table$options$debugA10 = table.options.debugAll) != null ? _table$options$debugA10 : table.options.debugHeaders;
                }
            }),
            getCenterFlatHeaders: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getCenterHeaderGroups()
                ], (left)=>{
                return left.map((headerGroup)=>{
                    return headerGroup.headers;
                }).flat();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA11;
                    return (_table$options$debugA11 = table.options.debugAll) != null ? _table$options$debugA11 : table.options.debugHeaders;
                }
            }),
            getRightFlatHeaders: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getRightHeaderGroups()
                ], (left)=>{
                return left.map((headerGroup)=>{
                    return headerGroup.headers;
                }).flat();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA12;
                    return (_table$options$debugA12 = table.options.debugAll) != null ? _table$options$debugA12 : table.options.debugHeaders;
                }
            }),
            // Leaf Headers
            getCenterLeafHeaders: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getCenterFlatHeaders()
                ], (flatHeaders)=>{
                return flatHeaders.filter((header)=>{
                    var _header$subHeaders;
                    return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
                });
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA13;
                    return (_table$options$debugA13 = table.options.debugAll) != null ? _table$options$debugA13 : table.options.debugHeaders;
                }
            }),
            getLeftLeafHeaders: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getLeftFlatHeaders()
                ], (flatHeaders)=>{
                return flatHeaders.filter((header)=>{
                    var _header$subHeaders2;
                    return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
                });
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA14;
                    return (_table$options$debugA14 = table.options.debugAll) != null ? _table$options$debugA14 : table.options.debugHeaders;
                }
            }),
            getRightLeafHeaders: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getRightFlatHeaders()
                ], (flatHeaders)=>{
                return flatHeaders.filter((header)=>{
                    var _header$subHeaders3;
                    return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
                });
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA15;
                    return (_table$options$debugA15 = table.options.debugAll) != null ? _table$options$debugA15 : table.options.debugHeaders;
                }
            }),
            getLeafHeaders: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getLeftHeaderGroups(),
                    table.getCenterHeaderGroups(),
                    table.getRightHeaderGroups()
                ], (left, center, right)=>{
                var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
                return [
                    ...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [],
                    ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [],
                    ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []
                ].map((header)=>{
                    return header.getLeafHeaders();
                }).flat();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA16;
                    return (_table$options$debugA16 = table.options.debugAll) != null ? _table$options$debugA16 : table.options.debugHeaders;
                }
            })
        };
    }
};
function $34de474a8ff218be$export$d8c3a8af36458fc3(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    let maxDepth = 0;
    const findMaxDepth = function(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter((column)=>column.getIsVisible()).forEach((column)=>{
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    let headerGroups = [];
    const createHeaderGroup = (headersToGroup, depth)=>{
        // The header group we are creating
        const headerGroup = {
            depth: depth,
            id: [
                headerFamily,
                `${depth}`
            ].filter(Boolean).join('_'),
            headers: []
        };
        // The parent columns we're going to scan next
        const pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach((headerToGroup)=>{
            // What is the latest (last) parent column?
            const latestPendingParentHeader = [
                ...pendingParentHeaders
            ].reverse()[0];
            const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            let column;
            let isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                const header = $34de474a8ff218be$var$createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join('_'),
                    isPlaceholder: isPlaceholder,
                    placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d)=>d.column === column).length}` : undefined,
                    depth: depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    const bottomHeaders = columnsToGroup.map((column, index)=>$34de474a8ff218be$var$createHeader(table, column, {
            depth: maxDepth,
            index: index
        }));
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    const recurseHeadersForSpans = (headers)=>{
        const filteredHeaders = headers.filter((header)=>header.column.getIsVisible());
        return filteredHeaders.map((header)=>{
            let colSpan = 0;
            let rowSpan = 0;
            let childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach((_ref)=>{
                    let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            const minChildRowSpan = Math.min(...childRowSpans);
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan: colSpan,
                rowSpan: rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
//
//
const $34de474a8ff218be$export$2f660993f4eb1f29 = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
const $34de474a8ff218be$var$getDefaultColumnSizingInfoState = ()=>({
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    });
const $34de474a8ff218be$export$9916c85814812d4a = {
    getDefaultColumnDef: ()=>{
        return $34de474a8ff218be$export$2f660993f4eb1f29;
    },
    getInitialState: (state)=>{
        return {
            columnSizing: {},
            columnSizingInfo: $34de474a8ff218be$var$getDefaultColumnSizingInfoState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            columnResizeMode: 'onEnd',
            onColumnSizingChange: $34de474a8ff218be$export$2b5605d8069324bd('columnSizing', table),
            onColumnSizingInfoChange: $34de474a8ff218be$export$2b5605d8069324bd('columnSizingInfo', table)
        };
    },
    createColumn: (column, table)=>{
        return {
            getSize: ()=>{
                var _column$columnDef$min, _ref, _column$columnDef$max;
                const columnSize = table.getState().columnSizing[column.id];
                return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : $34de474a8ff218be$export$2f660993f4eb1f29.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : $34de474a8ff218be$export$2f660993f4eb1f29.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : $34de474a8ff218be$export$2f660993f4eb1f29.maxSize);
            },
            getStart: (position)=>{
                const columns = !position ? table.getVisibleLeafColumns() : position === 'left' ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
                const index = columns.findIndex((d)=>d.id === column.id);
                if (index > 0) {
                    const prevSiblingColumn = columns[index - 1];
                    return prevSiblingColumn.getStart(position) + prevSiblingColumn.getSize();
                }
                return 0;
            },
            resetSize: ()=>{
                table.setColumnSizing((_ref2)=>{
                    let { [column.id]: _, ...rest } = _ref2;
                    return rest;
                });
            },
            getCanResize: ()=>{
                var _column$columnDef$ena, _table$options$enable;
                return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
            },
            getIsResizing: ()=>{
                return table.getState().columnSizingInfo.isResizingColumn === column.id;
            }
        };
    },
    createHeader: (header, table)=>{
        return {
            getSize: ()=>{
                let sum = 0;
                const recurse = (header)=>{
                    if (header.subHeaders.length) header.subHeaders.forEach(recurse);
                    else {
                        var _header$column$getSiz;
                        sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
                    }
                };
                recurse(header);
                return sum;
            },
            getStart: ()=>{
                if (header.index > 0) {
                    const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
                    return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
                }
                return 0;
            },
            getResizeHandler: ()=>{
                const column = table.getColumn(header.column.id);
                const canResize = column == null ? void 0 : column.getCanResize();
                return (e)=>{
                    if (!column || !canResize) return;
                    e.persist == null || e.persist();
                    if ($34de474a8ff218be$var$isTouchStartEvent(e)) {
                        // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                        if (e.touches && e.touches.length > 1) return;
                    }
                    const startSize = header.getSize();
                    const columnSizingStart = header ? header.getLeafHeaders().map((d)=>[
                            d.column.id,
                            d.column.getSize()
                        ]) : [
                        [
                            column.id,
                            column.getSize()
                        ]
                    ];
                    const clientX = $34de474a8ff218be$var$isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
                    const newColumnSizing = {};
                    const updateOffset = (eventType, clientXPos)=>{
                        if (typeof clientXPos !== 'number') return;
                        table.setColumnSizingInfo((old)=>{
                            var _old$startOffset, _old$startSize;
                            const deltaOffset = clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0);
                            const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                            old.columnSizingStart.forEach((_ref3)=>{
                                let [columnId, headerSize] = _ref3;
                                newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                            });
                            return {
                                ...old,
                                deltaOffset: deltaOffset,
                                deltaPercentage: deltaPercentage
                            };
                        });
                        if (table.options.columnResizeMode === 'onChange' || eventType === 'end') table.setColumnSizing((old)=>({
                                ...old,
                                ...newColumnSizing
                            }));
                    };
                    const onMove = (clientXPos)=>updateOffset('move', clientXPos);
                    const onEnd = (clientXPos)=>{
                        updateOffset('end', clientXPos);
                        table.setColumnSizingInfo((old)=>({
                                ...old,
                                isResizingColumn: false,
                                startOffset: null,
                                startSize: null,
                                deltaOffset: null,
                                deltaPercentage: null,
                                columnSizingStart: []
                            }));
                    };
                    const mouseEvents = {
                        moveHandler: (e)=>onMove(e.clientX),
                        upHandler: (e)=>{
                            document.removeEventListener('mousemove', mouseEvents.moveHandler);
                            document.removeEventListener('mouseup', mouseEvents.upHandler);
                            onEnd(e.clientX);
                        }
                    };
                    const touchEvents = {
                        moveHandler: (e)=>{
                            if (e.cancelable) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                            onMove(e.touches[0].clientX);
                            return false;
                        },
                        upHandler: (e)=>{
                            var _e$touches$;
                            document.removeEventListener('touchmove', touchEvents.moveHandler);
                            document.removeEventListener('touchend', touchEvents.upHandler);
                            if (e.cancelable) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                            onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                        }
                    };
                    const passiveIfSupported = $34de474a8ff218be$export$4927b5943c7c0b4() ? {
                        passive: false
                    } : false;
                    if ($34de474a8ff218be$var$isTouchStartEvent(e)) {
                        document.addEventListener('touchmove', touchEvents.moveHandler, passiveIfSupported);
                        document.addEventListener('touchend', touchEvents.upHandler, passiveIfSupported);
                    } else {
                        document.addEventListener('mousemove', mouseEvents.moveHandler, passiveIfSupported);
                        document.addEventListener('mouseup', mouseEvents.upHandler, passiveIfSupported);
                    }
                    table.setColumnSizingInfo((old)=>({
                            ...old,
                            startOffset: clientX,
                            startSize: startSize,
                            deltaOffset: 0,
                            deltaPercentage: 0,
                            columnSizingStart: columnSizingStart,
                            isResizingColumn: column.id
                        }));
                };
            }
        };
    },
    createTable: (table)=>{
        return {
            setColumnSizing: (updater)=>table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater),
            setColumnSizingInfo: (updater)=>table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater),
            resetColumnSizing: (defaultState)=>{
                var _table$initialState$c;
                table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
            },
            resetHeaderSizeInfo: (defaultState)=>{
                var _table$initialState$c2;
                table.setColumnSizingInfo(defaultState ? $34de474a8ff218be$var$getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : $34de474a8ff218be$var$getDefaultColumnSizingInfoState());
            },
            getTotalSize: ()=>{
                var _table$getHeaderGroup, _table$getHeaderGroup2;
                return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header)=>{
                    return sum + header.getSize();
                }, 0)) != null ? _table$getHeaderGroup : 0;
            },
            getLeftTotalSize: ()=>{
                var _table$getLeftHeaderG, _table$getLeftHeaderG2;
                return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header)=>{
                    return sum + header.getSize();
                }, 0)) != null ? _table$getLeftHeaderG : 0;
            },
            getCenterTotalSize: ()=>{
                var _table$getCenterHeade, _table$getCenterHeade2;
                return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header)=>{
                    return sum + header.getSize();
                }, 0)) != null ? _table$getCenterHeade : 0;
            },
            getRightTotalSize: ()=>{
                var _table$getRightHeader, _table$getRightHeader2;
                return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header)=>{
                    return sum + header.getSize();
                }, 0)) != null ? _table$getRightHeader : 0;
            }
        };
    }
};
let $34de474a8ff218be$var$passiveSupported = null;
function $34de474a8ff218be$export$4927b5943c7c0b4() {
    if (typeof $34de474a8ff218be$var$passiveSupported === 'boolean') return $34de474a8ff218be$var$passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        const noop = ()=>{};
        window.addEventListener('test', noop, options);
        window.removeEventListener('test', noop);
    } catch (err) {
        supported = false;
    }
    $34de474a8ff218be$var$passiveSupported = supported;
    return $34de474a8ff218be$var$passiveSupported;
}
function $34de474a8ff218be$var$isTouchStartEvent(e) {
    return e.type === 'touchstart';
}
//
const $34de474a8ff218be$export$c9bad30efcce6e0c = {
    getInitialState: (state)=>{
        return {
            expanded: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onExpandedChange: $34de474a8ff218be$export$2b5605d8069324bd('expanded', table),
            paginateExpandedRows: true
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        return {
            _autoResetExpanded: ()=>{
                var _ref, _table$options$autoRe;
                if (!registered) {
                    table._queue(()=>{
                        registered = true;
                    });
                    return;
                }
                if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                    if (queued) return;
                    queued = true;
                    table._queue(()=>{
                        table.resetExpanded();
                        queued = false;
                    });
                }
            },
            setExpanded: (updater)=>table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater),
            toggleAllRowsExpanded: (expanded)=>{
                if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
                else table.setExpanded({});
            },
            resetExpanded: (defaultState)=>{
                var _table$initialState$e, _table$initialState;
                table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
            },
            getCanSomeRowsExpand: ()=>{
                return table.getPrePaginationRowModel().flatRows.some((row)=>row.getCanExpand());
            },
            getToggleAllRowsExpandedHandler: ()=>{
                return (e)=>{
                    e.persist == null || e.persist();
                    table.toggleAllRowsExpanded();
                };
            },
            getIsSomeRowsExpanded: ()=>{
                const expanded = table.getState().expanded;
                return expanded === true || Object.values(expanded).some(Boolean);
            },
            getIsAllRowsExpanded: ()=>{
                const expanded = table.getState().expanded;
                // If expanded is true, save some cycles and return true
                if (typeof expanded === 'boolean') return expanded === true;
                if (!Object.keys(expanded).length) return false;
                // If any row is not expanded, return false
                if (table.getRowModel().flatRows.some((row)=>!row.getIsExpanded())) return false;
                // They must all be expanded :shrug:
                return true;
            },
            getExpandedDepth: ()=>{
                let maxDepth = 0;
                const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
                rowIds.forEach((id)=>{
                    const splitId = id.split('.');
                    maxDepth = Math.max(maxDepth, splitId.length);
                });
                return maxDepth;
            },
            getPreExpandedRowModel: ()=>table.getSortedRowModel(),
            getExpandedRowModel: ()=>{
                if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
                if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
                return table._getExpandedRowModel();
            }
        };
    },
    createRow: (row, table)=>{
        return {
            toggleExpanded: (expanded)=>{
                table.setExpanded((old)=>{
                    var _expanded;
                    const exists = old === true ? true : !!(old != null && old[row.id]);
                    let oldExpanded = {};
                    if (old === true) Object.keys(table.getRowModel().rowsById).forEach((rowId)=>{
                        oldExpanded[rowId] = true;
                    });
                    else oldExpanded = old;
                    expanded = (_expanded = expanded) != null ? _expanded : !exists;
                    if (!exists && expanded) return {
                        ...oldExpanded,
                        [row.id]: true
                    };
                    if (exists && !expanded) {
                        const { [row.id]: _, ...rest } = oldExpanded;
                        return rest;
                    }
                    return old;
                });
            },
            getIsExpanded: ()=>{
                var _table$options$getIsR;
                const expanded = table.getState().expanded;
                return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
            },
            getCanExpand: ()=>{
                var _table$options$getRow, _table$options$enable, _row$subRows;
                return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
            },
            getToggleExpandedHandler: ()=>{
                const canExpand = row.getCanExpand();
                return ()=>{
                    if (!canExpand) return;
                    row.toggleExpanded();
                };
            }
        };
    }
};
const $34de474a8ff218be$var$includesString = (row, columnId, filterValue)=>{
    var _row$getValue, _row$getValue$toStrin, _row$getValue$toStrin2;
    const search = filterValue.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null ? void 0 : (_row$getValue$toStrin = _row$getValue.toString()) == null ? void 0 : (_row$getValue$toStrin2 = _row$getValue$toStrin.toLowerCase()) == null ? void 0 : _row$getValue$toStrin2.includes(search));
};
$34de474a8ff218be$var$includesString.autoRemove = (val)=>$34de474a8ff218be$var$testFalsey(val);
const $34de474a8ff218be$var$includesStringSensitive = (row, columnId, filterValue)=>{
    var _row$getValue2, _row$getValue2$toStri;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null ? void 0 : (_row$getValue2$toStri = _row$getValue2.toString()) == null ? void 0 : _row$getValue2$toStri.includes(filterValue));
};
$34de474a8ff218be$var$includesStringSensitive.autoRemove = (val)=>$34de474a8ff218be$var$testFalsey(val);
const $34de474a8ff218be$var$equalsString = (row, columnId, filterValue)=>{
    var _row$getValue3, _row$getValue3$toStri;
    return ((_row$getValue3 = row.getValue(columnId)) == null ? void 0 : (_row$getValue3$toStri = _row$getValue3.toString()) == null ? void 0 : _row$getValue3$toStri.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
$34de474a8ff218be$var$equalsString.autoRemove = (val)=>$34de474a8ff218be$var$testFalsey(val);
const $34de474a8ff218be$var$arrIncludes = (row, columnId, filterValue)=>{
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
$34de474a8ff218be$var$arrIncludes.autoRemove = (val)=>$34de474a8ff218be$var$testFalsey(val) || !(val != null && val.length);
const $34de474a8ff218be$var$arrIncludesAll = (row, columnId, filterValue)=>{
    return !filterValue.some((val)=>{
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
$34de474a8ff218be$var$arrIncludesAll.autoRemove = (val)=>$34de474a8ff218be$var$testFalsey(val) || !(val != null && val.length);
const $34de474a8ff218be$var$arrIncludesSome = (row, columnId, filterValue)=>{
    return filterValue.some((val)=>{
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
$34de474a8ff218be$var$arrIncludesSome.autoRemove = (val)=>$34de474a8ff218be$var$testFalsey(val) || !(val != null && val.length);
const $34de474a8ff218be$var$equals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) === filterValue;
};
$34de474a8ff218be$var$equals.autoRemove = (val)=>$34de474a8ff218be$var$testFalsey(val);
const $34de474a8ff218be$var$weakEquals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) == filterValue;
};
$34de474a8ff218be$var$weakEquals.autoRemove = (val)=>$34de474a8ff218be$var$testFalsey(val);
const $34de474a8ff218be$var$inNumberRange = (row, columnId, filterValue)=>{
    let [min, max] = filterValue;
    const rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
$34de474a8ff218be$var$inNumberRange.resolveFilterValue = (val)=>{
    let [unsafeMin, unsafeMax] = val;
    let parsedMin = typeof unsafeMin !== 'number' ? parseFloat(unsafeMin) : unsafeMin;
    let parsedMax = typeof unsafeMax !== 'number' ? parseFloat(unsafeMax) : unsafeMax;
    let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        const temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
$34de474a8ff218be$var$inNumberRange.autoRemove = (val)=>$34de474a8ff218be$var$testFalsey(val) || $34de474a8ff218be$var$testFalsey(val[0]) && $34de474a8ff218be$var$testFalsey(val[1]);
// Export
const $34de474a8ff218be$export$6ad8312e296ec316 = {
    includesString: $34de474a8ff218be$var$includesString,
    includesStringSensitive: $34de474a8ff218be$var$includesStringSensitive,
    equalsString: $34de474a8ff218be$var$equalsString,
    arrIncludes: $34de474a8ff218be$var$arrIncludes,
    arrIncludesAll: $34de474a8ff218be$var$arrIncludesAll,
    arrIncludesSome: $34de474a8ff218be$var$arrIncludesSome,
    equals: $34de474a8ff218be$var$equals,
    weakEquals: $34de474a8ff218be$var$weakEquals,
    inNumberRange: $34de474a8ff218be$var$inNumberRange
};
// Utils
function $34de474a8ff218be$var$testFalsey(val) {
    return val === undefined || val === null || val === '';
}
//
const $34de474a8ff218be$export$92a576f896a9bf72 = {
    getDefaultColumnDef: ()=>{
        return {
            filterFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            columnFilters: [],
            globalFilter: undefined,
            // filtersProgress: 1,
            // facetProgress: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnFiltersChange: $34de474a8ff218be$export$2b5605d8069324bd('columnFilters', table),
            onGlobalFilterChange: $34de474a8ff218be$export$2b5605d8069324bd('globalFilter', table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100,
            globalFilterFn: 'auto',
            getColumnCanGlobalFilter: (column)=>{
                var _table$getCoreRowMode, _table$getCoreRowMode2;
                const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null ? void 0 : (_table$getCoreRowMode2 = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode2.getValue();
                return typeof value === 'string' || typeof value === 'number';
            }
        };
    },
    createColumn: (column, table)=>{
        return {
            getAutoFilterFn: ()=>{
                const firstRow = table.getCoreRowModel().flatRows[0];
                const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
                if (typeof value === 'string') return $34de474a8ff218be$export$6ad8312e296ec316.includesString;
                if (typeof value === 'number') return $34de474a8ff218be$export$6ad8312e296ec316.inNumberRange;
                if (typeof value === 'boolean') return $34de474a8ff218be$export$6ad8312e296ec316.equals;
                if (value !== null && typeof value === 'object') return $34de474a8ff218be$export$6ad8312e296ec316.equals;
                if (Array.isArray(value)) return $34de474a8ff218be$export$6ad8312e296ec316.arrIncludes;
                return $34de474a8ff218be$export$6ad8312e296ec316.weakEquals;
            },
            getFilterFn: ()=>{
                var _table$options$filter, _table$options$filter2;
                return $34de474a8ff218be$export$f6e2535fb5126e54(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === 'auto' ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : $34de474a8ff218be$export$6ad8312e296ec316[column.columnDef.filterFn];
            },
            getCanFilter: ()=>{
                var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
                return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
            },
            getCanGlobalFilter: ()=>{
                var _column$columnDef$ena2, _table$options$enable3, _table$options$enable4, _table$options$getCol;
                return ((_column$columnDef$ena2 = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena2 : true) && ((_table$options$enable3 = table.options.enableGlobalFilter) != null ? _table$options$enable3 : true) && ((_table$options$enable4 = table.options.enableFilters) != null ? _table$options$enable4 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
            },
            getIsFiltered: ()=>column.getFilterIndex() > -1,
            getFilterValue: ()=>{
                var _table$getState$colum, _table$getState$colum2;
                return (_table$getState$colum = table.getState().columnFilters) == null ? void 0 : (_table$getState$colum2 = _table$getState$colum.find((d)=>d.id === column.id)) == null ? void 0 : _table$getState$colum2.value;
            },
            getFilterIndex: ()=>{
                var _table$getState$colum3, _table$getState$colum4;
                return (_table$getState$colum3 = (_table$getState$colum4 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum4.findIndex((d)=>d.id === column.id)) != null ? _table$getState$colum3 : -1;
            },
            setFilterValue: (value)=>{
                table.setColumnFilters((old)=>{
                    const filterFn = column.getFilterFn();
                    const previousfilter = old == null ? void 0 : old.find((d)=>d.id === column.id);
                    const newFilter = $34de474a8ff218be$export$7f095f455ad5af3f(value, previousfilter ? previousfilter.value : undefined);
                    //
                    if ($34de474a8ff218be$export$5b01eb94d7ce58a8(filterFn, newFilter, column)) {
                        var _old$filter;
                        return (_old$filter = old == null ? void 0 : old.filter((d)=>d.id !== column.id)) != null ? _old$filter : [];
                    }
                    const newFilterObj = {
                        id: column.id,
                        value: newFilter
                    };
                    if (previousfilter) {
                        var _old$map;
                        return (_old$map = old == null ? void 0 : old.map((d)=>{
                            if (d.id === column.id) return newFilterObj;
                            return d;
                        })) != null ? _old$map : [];
                    }
                    if (old != null && old.length) return [
                        ...old,
                        newFilterObj
                    ];
                    return [
                        newFilterObj
                    ];
                });
            },
            _getFacetedRowModel: table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id),
            getFacetedRowModel: ()=>{
                if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
                return column._getFacetedRowModel();
            },
            _getFacetedUniqueValues: table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id),
            getFacetedUniqueValues: ()=>{
                if (!column._getFacetedUniqueValues) return new Map();
                return column._getFacetedUniqueValues();
            },
            _getFacetedMinMaxValues: table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id),
            getFacetedMinMaxValues: ()=>{
                if (!column._getFacetedMinMaxValues) return undefined;
                return column._getFacetedMinMaxValues();
            }
        };
    },
    createRow: (row, table)=>{
        return {
            columnFilters: {},
            columnFiltersMeta: {}
        };
    },
    createTable: (table)=>{
        return {
            getGlobalAutoFilterFn: ()=>{
                return $34de474a8ff218be$export$6ad8312e296ec316.includesString;
            },
            getGlobalFilterFn: ()=>{
                var _table$options$filter3, _table$options$filter4;
                const { globalFilterFn: globalFilterFn } = table.options;
                return $34de474a8ff218be$export$f6e2535fb5126e54(globalFilterFn) ? globalFilterFn : globalFilterFn === 'auto' ? table.getGlobalAutoFilterFn() : (_table$options$filter3 = (_table$options$filter4 = table.options.filterFns) == null ? void 0 : _table$options$filter4[globalFilterFn]) != null ? _table$options$filter3 : $34de474a8ff218be$export$6ad8312e296ec316[globalFilterFn];
            },
            setColumnFilters: (updater)=>{
                const leafColumns = table.getAllLeafColumns();
                const updateFn = (old)=>{
                    var _functionalUpdate;
                    return (_functionalUpdate = $34de474a8ff218be$export$7f095f455ad5af3f(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter)=>{
                        const column = leafColumns.find((d)=>d.id === filter.id);
                        if (column) {
                            const filterFn = column.getFilterFn();
                            if ($34de474a8ff218be$export$5b01eb94d7ce58a8(filterFn, filter.value, column)) return false;
                        }
                        return true;
                    });
                };
                table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
            },
            setGlobalFilter: (updater)=>{
                table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
            },
            resetGlobalFilter: (defaultState)=>{
                table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
            },
            resetColumnFilters: (defaultState)=>{
                var _table$initialState$c, _table$initialState;
                table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
            },
            getPreFilteredRowModel: ()=>table.getCoreRowModel(),
            getFilteredRowModel: ()=>{
                if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
                if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
                return table._getFilteredRowModel();
            },
            _getGlobalFacetedRowModel: table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, '__global__'),
            getGlobalFacetedRowModel: ()=>{
                if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
                return table._getGlobalFacetedRowModel();
            },
            _getGlobalFacetedUniqueValues: table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, '__global__'),
            getGlobalFacetedUniqueValues: ()=>{
                if (!table._getGlobalFacetedUniqueValues) return new Map();
                return table._getGlobalFacetedUniqueValues();
            },
            _getGlobalFacetedMinMaxValues: table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, '__global__'),
            getGlobalFacetedMinMaxValues: ()=>{
                if (!table._getGlobalFacetedMinMaxValues) return;
                return table._getGlobalFacetedMinMaxValues();
            }
        };
    }
};
function $34de474a8ff218be$export$5b01eb94d7ce58a8(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === 'undefined' || typeof value === 'string' && !value;
}
const $34de474a8ff218be$var$sum = (columnId, _leafRows, childRows)=>{
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce((sum, next)=>{
        const nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === 'number' ? nextValue : 0);
    }, 0);
};
const $34de474a8ff218be$var$min = (columnId, _leafRows, childRows)=>{
    let min;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
const $34de474a8ff218be$var$max = (columnId, _leafRows, childRows)=>{
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
const $34de474a8ff218be$var$extent = (columnId, _leafRows, childRows)=>{
    let min;
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
const $34de474a8ff218be$var$mean = (columnId, leafRows)=>{
    let count = 0;
    let sum = 0;
    leafRows.forEach((row)=>{
        let value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
const $34de474a8ff218be$var$median = (columnId, leafRows)=>{
    if (!leafRows.length) return;
    const values = leafRows.map((row)=>row.getValue(columnId));
    if (!$34de474a8ff218be$export$5cd576d1827d40c8(values)) return;
    if (values.length === 1) return values[0];
    const mid = Math.floor(values.length / 2);
    const nums = values.sort((a, b)=>a - b);
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const $34de474a8ff218be$var$unique = (columnId, leafRows)=>{
    return Array.from(new Set(leafRows.map((d)=>d.getValue(columnId))).values());
};
const $34de474a8ff218be$var$uniqueCount = (columnId, leafRows)=>{
    return new Set(leafRows.map((d)=>d.getValue(columnId))).size;
};
const $34de474a8ff218be$var$count = (_columnId, leafRows)=>{
    return leafRows.length;
};
const $34de474a8ff218be$export$3aa4339120b8b25b = {
    sum: $34de474a8ff218be$var$sum,
    min: $34de474a8ff218be$var$min,
    max: $34de474a8ff218be$var$max,
    extent: $34de474a8ff218be$var$extent,
    mean: $34de474a8ff218be$var$mean,
    median: $34de474a8ff218be$var$median,
    unique: $34de474a8ff218be$var$unique,
    uniqueCount: $34de474a8ff218be$var$uniqueCount,
    count: $34de474a8ff218be$var$count
};
//
const $34de474a8ff218be$export$3885c0af90651e94 = {
    getDefaultColumnDef: ()=>{
        return {
            aggregatedCell: (props)=>{
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null ? void 0 : _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: 'auto'
        };
    },
    getInitialState: (state)=>{
        return {
            grouping: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGroupingChange: $34de474a8ff218be$export$2b5605d8069324bd('grouping', table),
            groupedColumnMode: 'reorder'
        };
    },
    createColumn: (column, table)=>{
        return {
            toggleGrouping: ()=>{
                table.setGrouping((old)=>{
                    // Find any existing grouping for this column
                    if (old != null && old.includes(column.id)) return old.filter((d)=>d !== column.id);
                    return [
                        ...old != null ? old : [],
                        column.id
                    ];
                });
            },
            getCanGroup: ()=>{
                var _ref, _ref2, _ref3, _column$columnDef$ena;
                return (_ref = (_ref2 = (_ref3 = (_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) != null ? _ref3 : table.options.enableGrouping) != null ? _ref2 : true) != null ? _ref : !!column.accessorFn;
            },
            getIsGrouped: ()=>{
                var _table$getState$group;
                return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
            },
            getGroupedIndex: ()=>{
                var _table$getState$group2;
                return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
            },
            getToggleGroupingHandler: ()=>{
                const canGroup = column.getCanGroup();
                return ()=>{
                    if (!canGroup) return;
                    column.toggleGrouping();
                };
            },
            getAutoAggregationFn: ()=>{
                const firstRow = table.getCoreRowModel().flatRows[0];
                const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
                if (typeof value === 'number') return $34de474a8ff218be$export$3aa4339120b8b25b.sum;
                if (Object.prototype.toString.call(value) === '[object Date]') return $34de474a8ff218be$export$3aa4339120b8b25b.extent;
            },
            getAggregationFn: ()=>{
                var _table$options$aggreg, _table$options$aggreg2;
                if (!column) throw new Error();
                return $34de474a8ff218be$export$f6e2535fb5126e54(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === 'auto' ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : $34de474a8ff218be$export$3aa4339120b8b25b[column.columnDef.aggregationFn];
            }
        };
    },
    createTable: (table)=>{
        return {
            setGrouping: (updater)=>table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater),
            resetGrouping: (defaultState)=>{
                var _table$initialState$g, _table$initialState;
                table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
            },
            getPreGroupedRowModel: ()=>table.getFilteredRowModel(),
            getGroupedRowModel: ()=>{
                if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
                if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
                return table._getGroupedRowModel();
            }
        };
    },
    createRow: (row, table)=>{
        return {
            getIsGrouped: ()=>!!row.groupingColumnId,
            getGroupingValue: (columnId)=>{
                if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                const column = table.getColumn(columnId);
                if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
                row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
                return row._groupingValuesCache[columnId];
            },
            _groupingValuesCache: {}
        };
    },
    createCell: (cell, column, row, table)=>{
        return {
            getIsGrouped: ()=>column.getIsGrouped() && column.id === row.groupingColumnId,
            getIsPlaceholder: ()=>!cell.getIsGrouped() && column.getIsGrouped(),
            getIsAggregated: ()=>{
                var _row$subRows;
                return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
            }
        };
    }
};
function $34de474a8ff218be$export$ac763d2b0470e663(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    const nonGroupingColumns = leafColumns.filter((col)=>!grouping.includes(col.id));
    if (groupedColumnMode === 'remove') return nonGroupingColumns;
    const groupingColumns = grouping.map((g)=>leafColumns.find((col)=>col.id === g)).filter(Boolean);
    return [
        ...groupingColumns,
        ...nonGroupingColumns
    ];
}
//
const $34de474a8ff218be$export$549aff5da5ccfd97 = {
    getInitialState: (state)=>{
        return {
            columnOrder: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnOrderChange: $34de474a8ff218be$export$2b5605d8069324bd('columnOrder', table)
        };
    },
    createTable: (table)=>{
        return {
            setColumnOrder: (updater)=>table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater),
            resetColumnOrder: (defaultState)=>{
                var _table$initialState$c;
                table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
            },
            _getOrderColumnsFn: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getState().columnOrder,
                    table.getState().grouping,
                    table.options.groupedColumnMode
                ], (columnOrder, grouping, groupedColumnMode)=>(columns)=>{
                    // Sort grouped columns to the start of the column list
                    // before the headers are built
                    let orderedColumns = [];
                    // If there is no order, return the normal columns
                    if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                    else {
                        const columnOrderCopy = [
                            ...columnOrder
                        ];
                        // If there is an order, make a copy of the columns
                        const columnsCopy = [
                            ...columns
                        ];
                        // And make a new ordered array of the columns
                        // Loop over the columns and place them in order into the new array
                        while(columnsCopy.length && columnOrderCopy.length){
                            const targetColumnId = columnOrderCopy.shift();
                            const foundIndex = columnsCopy.findIndex((d)=>d.id === targetColumnId);
                            if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                        }
                        // If there are any columns left, add them to the end
                        orderedColumns = [
                            ...orderedColumns,
                            ...columnsCopy
                        ];
                    }
                    return $34de474a8ff218be$export$ac763d2b0470e663(orderedColumns, grouping, groupedColumnMode);
                }, {
                key: false
            })
        };
    }
};
//
const $34de474a8ff218be$var$defaultPageIndex = 0;
const $34de474a8ff218be$var$defaultPageSize = 10;
const $34de474a8ff218be$var$getDefaultPaginationState = ()=>({
        pageIndex: $34de474a8ff218be$var$defaultPageIndex,
        pageSize: $34de474a8ff218be$var$defaultPageSize
    });
const $34de474a8ff218be$export$68f5e1453c188a82 = {
    getInitialState: (state)=>{
        return {
            ...state,
            pagination: {
                ...$34de474a8ff218be$var$getDefaultPaginationState(),
                ...state == null ? void 0 : state.pagination
            }
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onPaginationChange: $34de474a8ff218be$export$2b5605d8069324bd('pagination', table)
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        return {
            _autoResetPageIndex: ()=>{
                var _ref, _table$options$autoRe;
                if (!registered) {
                    table._queue(()=>{
                        registered = true;
                    });
                    return;
                }
                if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                    if (queued) return;
                    queued = true;
                    table._queue(()=>{
                        table.resetPageIndex();
                        queued = false;
                    });
                }
            },
            setPagination: (updater)=>{
                const safeUpdater = (old)=>{
                    let newState = $34de474a8ff218be$export$7f095f455ad5af3f(updater, old);
                    return newState;
                };
                return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
            },
            resetPagination: (defaultState)=>{
                var _table$initialState$p;
                table.setPagination(defaultState ? $34de474a8ff218be$var$getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : $34de474a8ff218be$var$getDefaultPaginationState());
            },
            setPageIndex: (updater)=>{
                table.setPagination((old)=>{
                    let pageIndex = $34de474a8ff218be$export$7f095f455ad5af3f(updater, old.pageIndex);
                    const maxPageIndex = typeof table.options.pageCount === 'undefined' || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                    pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                    return {
                        ...old,
                        pageIndex: pageIndex
                    };
                });
            },
            resetPageIndex: (defaultState)=>{
                var _table$initialState$p2, _table$initialState, _table$initialState$p3;
                table.setPageIndex(defaultState ? $34de474a8ff218be$var$defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null ? void 0 : (_table$initialState$p3 = _table$initialState.pagination) == null ? void 0 : _table$initialState$p3.pageIndex) != null ? _table$initialState$p2 : $34de474a8ff218be$var$defaultPageIndex);
            },
            resetPageSize: (defaultState)=>{
                var _table$initialState$p4, _table$initialState2, _table$initialState2$;
                table.setPageSize(defaultState ? $34de474a8ff218be$var$defaultPageSize : (_table$initialState$p4 = (_table$initialState2 = table.initialState) == null ? void 0 : (_table$initialState2$ = _table$initialState2.pagination) == null ? void 0 : _table$initialState2$.pageSize) != null ? _table$initialState$p4 : $34de474a8ff218be$var$defaultPageSize);
            },
            setPageSize: (updater)=>{
                table.setPagination((old)=>{
                    const pageSize = Math.max(1, $34de474a8ff218be$export$7f095f455ad5af3f(updater, old.pageSize));
                    const topRowIndex = old.pageSize * old.pageIndex;
                    const pageIndex = Math.floor(topRowIndex / pageSize);
                    return {
                        ...old,
                        pageIndex: pageIndex,
                        pageSize: pageSize
                    };
                });
            },
            setPageCount: (updater)=>table.setPagination((old)=>{
                    var _table$options$pageCo;
                    let newPageCount = $34de474a8ff218be$export$7f095f455ad5af3f(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                    if (typeof newPageCount === 'number') newPageCount = Math.max(-1, newPageCount);
                    return {
                        ...old,
                        pageCount: newPageCount
                    };
                }),
            getPageOptions: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getPageCount()
                ], (pageCount)=>{
                let pageOptions = [];
                if (pageCount && pageCount > 0) pageOptions = [
                    ...new Array(pageCount)
                ].fill(null).map((_, i)=>i);
                return pageOptions;
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA;
                    return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
                }
            }),
            getCanPreviousPage: ()=>table.getState().pagination.pageIndex > 0,
            getCanNextPage: ()=>{
                const { pageIndex: pageIndex } = table.getState().pagination;
                const pageCount = table.getPageCount();
                if (pageCount === -1) return true;
                if (pageCount === 0) return false;
                return pageIndex < pageCount - 1;
            },
            previousPage: ()=>{
                return table.setPageIndex((old)=>old - 1);
            },
            nextPage: ()=>{
                return table.setPageIndex((old)=>{
                    return old + 1;
                });
            },
            getPrePaginationRowModel: ()=>table.getExpandedRowModel(),
            getPaginationRowModel: ()=>{
                if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
                if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
                return table._getPaginationRowModel();
            },
            getPageCount: ()=>{
                var _table$options$pageCo2;
                return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getPrePaginationRowModel().rows.length / table.getState().pagination.pageSize);
            }
        };
    }
};
//
const $34de474a8ff218be$var$getDefaultPinningState = ()=>({
        left: [],
        right: []
    });
const $34de474a8ff218be$export$5289f180505593b3 = {
    getInitialState: (state)=>{
        return {
            columnPinning: $34de474a8ff218be$var$getDefaultPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnPinningChange: $34de474a8ff218be$export$2b5605d8069324bd('columnPinning', table)
        };
    },
    createColumn: (column, table)=>{
        return {
            pin: (position)=>{
                const columnIds = column.getLeafColumns().map((d)=>d.id).filter(Boolean);
                table.setColumnPinning((old)=>{
                    var _old$left3, _old$right3;
                    if (position === 'right') {
                        var _old$left, _old$right;
                        return {
                            left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            right: [
                                ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                                ...columnIds
                            ]
                        };
                    }
                    if (position === 'left') {
                        var _old$left2, _old$right2;
                        return {
                            left: [
                                ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                                ...columnIds
                            ],
                            right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                        };
                    }
                    return {
                        left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                        right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                    };
                });
            },
            getCanPin: ()=>{
                const leafColumns = column.getLeafColumns();
                return leafColumns.some((d)=>{
                    var _d$columnDef$enablePi, _table$options$enable;
                    return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_table$options$enable = table.options.enablePinning) != null ? _table$options$enable : true);
                });
            },
            getIsPinned: ()=>{
                const leafColumnIds = column.getLeafColumns().map((d)=>d.id);
                const { left: left, right: right } = table.getState().columnPinning;
                const isLeft = leafColumnIds.some((d)=>left == null ? void 0 : left.includes(d));
                const isRight = leafColumnIds.some((d)=>right == null ? void 0 : right.includes(d));
                return isLeft ? 'left' : isRight ? 'right' : false;
            },
            getPinnedIndex: ()=>{
                var _table$getState$colum, _table$getState$colum2, _table$getState$colum3;
                const position = column.getIsPinned();
                return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null ? void 0 : (_table$getState$colum3 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum3.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
            }
        };
    },
    createRow: (row, table)=>{
        return {
            getCenterVisibleCells: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    row._getAllVisibleCells(),
                    table.getState().columnPinning.left,
                    table.getState().columnPinning.right
                ], (allCells, left, right)=>{
                const leftAndRight = [
                    ...left != null ? left : [],
                    ...right != null ? right : []
                ];
                return allCells.filter((d)=>!leftAndRight.includes(d.column.id));
            }, {
                key: 'row.getCenterVisibleCells',
                debug: ()=>{
                    var _table$options$debugA;
                    return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
                }
            }),
            getLeftVisibleCells: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    row._getAllVisibleCells(),
                    table.getState().columnPinning.left,
                    , 
                ], (allCells, left)=>{
                const cells = (left != null ? left : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                        ...d,
                        position: 'left'
                    }));
                return cells;
            }, {
                key: 'row.getLeftVisibleCells',
                debug: ()=>{
                    var _table$options$debugA2;
                    return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
                }
            }),
            getRightVisibleCells: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    row._getAllVisibleCells(),
                    table.getState().columnPinning.right
                ], (allCells, right)=>{
                const cells = (right != null ? right : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                        ...d,
                        position: 'right'
                    }));
                return cells;
            }, {
                key: 'row.getRightVisibleCells',
                debug: ()=>{
                    var _table$options$debugA3;
                    return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugRows;
                }
            })
        };
    },
    createTable: (table)=>{
        return {
            setColumnPinning: (updater)=>table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater),
            resetColumnPinning: (defaultState)=>{
                var _table$initialState$c, _table$initialState;
                return table.setColumnPinning(defaultState ? $34de474a8ff218be$var$getDefaultPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : $34de474a8ff218be$var$getDefaultPinningState());
            },
            getIsSomeColumnsPinned: (position)=>{
                var _pinningState$positio;
                const pinningState = table.getState().columnPinning;
                if (!position) {
                    var _pinningState$left, _pinningState$right;
                    return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
                }
                return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
            },
            getLeftLeafColumns: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getAllLeafColumns(),
                    table.getState().columnPinning.left
                ], (allColumns, left)=>{
                return (left != null ? left : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA4;
                    return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugColumns;
                }
            }),
            getRightLeafColumns: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getAllLeafColumns(),
                    table.getState().columnPinning.right
                ], (allColumns, right)=>{
                return (right != null ? right : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA5;
                    return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugColumns;
                }
            }),
            getCenterLeafColumns: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getAllLeafColumns(),
                    table.getState().columnPinning.left,
                    table.getState().columnPinning.right
                ], (allColumns, left, right)=>{
                const leftAndRight = [
                    ...left != null ? left : [],
                    ...right != null ? right : []
                ];
                return allColumns.filter((d)=>!leftAndRight.includes(d.id));
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA6;
                    return (_table$options$debugA6 = table.options.debugAll) != null ? _table$options$debugA6 : table.options.debugColumns;
                }
            })
        };
    }
};
//
const $34de474a8ff218be$export$e8905133e7bf3121 = {
    getInitialState: (state)=>{
        return {
            rowSelection: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowSelectionChange: $34de474a8ff218be$export$2b5605d8069324bd('rowSelection', table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: (table)=>{
        return {
            setRowSelection: (updater)=>table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater),
            resetRowSelection: (defaultState)=>{
                var _table$initialState$r;
                return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
            },
            toggleAllRowsSelected: (value)=>{
                table.setRowSelection((old)=>{
                    value = typeof value !== 'undefined' ? value : !table.getIsAllRowsSelected();
                    const rowSelection = {
                        ...old
                    };
                    const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                    // We don't use `mutateRowIsSelected` here for performance reasons.
                    // All of the rows are flat already, so it wouldn't be worth it
                    if (value) preGroupedFlatRows.forEach((row)=>{
                        if (!row.getCanSelect()) return;
                        rowSelection[row.id] = true;
                    });
                    else preGroupedFlatRows.forEach((row)=>{
                        delete rowSelection[row.id];
                    });
                    return rowSelection;
                });
            },
            toggleAllPageRowsSelected: (value)=>table.setRowSelection((old)=>{
                    const resolvedValue = typeof value !== 'undefined' ? value : !table.getIsAllPageRowsSelected();
                    const rowSelection = {
                        ...old
                    };
                    table.getRowModel().rows.forEach((row)=>{
                        $34de474a8ff218be$var$mutateRowIsSelected(rowSelection, row.id, resolvedValue, table);
                    });
                    return rowSelection;
                }),
            // addRowSelectionRange: rowId => {
            //   const {
            //     rows,
            //     rowsById,
            //     options: { selectGroupingRows, selectSubRows },
            //   } = table
            //   const findSelectedRow = (rows: Row[]) => {
            //     let found
            //     rows.find(d => {
            //       if (d.getIsSelected()) {
            //         found = d
            //         return true
            //       }
            //       const subFound = findSelectedRow(d.subRows || [])
            //       if (subFound) {
            //         found = subFound
            //         return true
            //       }
            //       return false
            //     })
            //     return found
            //   }
            //   const firstRow = findSelectedRow(rows) || rows[0]
            //   const lastRow = rowsById[rowId]
            //   let include = false
            //   const selectedRowIds = {}
            //   const addRow = (row: Row) => {
            //     mutateRowIsSelected(selectedRowIds, row.id, true, {
            //       rowsById,
            //       selectGroupingRows: selectGroupingRows!,
            //       selectSubRows: selectSubRows!,
            //     })
            //   }
            //   table.rows.forEach(row => {
            //     const isFirstRow = row.id === firstRow.id
            //     const isLastRow = row.id === lastRow.id
            //     if (isFirstRow || isLastRow) {
            //       if (!include) {
            //         include = true
            //       } else if (include) {
            //         addRow(row)
            //         include = false
            //       }
            //     }
            //     if (include) {
            //       addRow(row)
            //     }
            //   })
            //   table.setRowSelection(selectedRowIds)
            // },
            getPreSelectedRowModel: ()=>table.getCoreRowModel(),
            getSelectedRowModel: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getState().rowSelection,
                    table.getCoreRowModel()
                ], (rowSelection, rowModel)=>{
                if (!Object.keys(rowSelection).length) return {
                    rows: [],
                    flatRows: [],
                    rowsById: {}
                };
                return $34de474a8ff218be$export$f150e72530556b0b(table, rowModel);
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA;
                    return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
                }
            }),
            getFilteredSelectedRowModel: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getState().rowSelection,
                    table.getFilteredRowModel()
                ], (rowSelection, rowModel)=>{
                if (!Object.keys(rowSelection).length) return {
                    rows: [],
                    flatRows: [],
                    rowsById: {}
                };
                return $34de474a8ff218be$export$f150e72530556b0b(table, rowModel);
            }, {
                key: 'getFilteredSelectedRowModel',
                debug: ()=>{
                    var _table$options$debugA2;
                    return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugTable;
                }
            }),
            getGroupedSelectedRowModel: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    table.getState().rowSelection,
                    table.getSortedRowModel()
                ], (rowSelection, rowModel)=>{
                if (!Object.keys(rowSelection).length) return {
                    rows: [],
                    flatRows: [],
                    rowsById: {}
                };
                return $34de474a8ff218be$export$f150e72530556b0b(table, rowModel);
            }, {
                key: 'getGroupedSelectedRowModel',
                debug: ()=>{
                    var _table$options$debugA3;
                    return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugTable;
                }
            }),
            ///
            // getGroupingRowCanSelect: rowId => {
            //   const row = table.getRow(rowId)
            //   if (!row) {
            //     throw new Error()
            //   }
            //   if (typeof table.options.enableGroupingRowSelection === 'function') {
            //     return table.options.enableGroupingRowSelection(row)
            //   }
            //   return table.options.enableGroupingRowSelection ?? false
            // },
            getIsAllRowsSelected: ()=>{
                const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
                const { rowSelection: rowSelection } = table.getState();
                let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
                if (isAllRowsSelected) {
                    if (preGroupedFlatRows.some((row)=>row.getCanSelect() && !rowSelection[row.id])) isAllRowsSelected = false;
                }
                return isAllRowsSelected;
            },
            getIsAllPageRowsSelected: ()=>{
                const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row)=>row.getCanSelect());
                const { rowSelection: rowSelection } = table.getState();
                let isAllPageRowsSelected = !!paginationFlatRows.length;
                if (isAllPageRowsSelected && paginationFlatRows.some((row)=>!rowSelection[row.id])) isAllPageRowsSelected = false;
                return isAllPageRowsSelected;
            },
            getIsSomeRowsSelected: ()=>{
                var _table$getState$rowSe;
                const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
                return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
            },
            getIsSomePageRowsSelected: ()=>{
                const paginationFlatRows = table.getPaginationRowModel().flatRows;
                return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row)=>row.getCanSelect()).some((d)=>d.getIsSelected() || d.getIsSomeSelected());
            },
            getToggleAllRowsSelectedHandler: ()=>{
                return (e)=>{
                    table.toggleAllRowsSelected(e.target.checked);
                };
            },
            getToggleAllPageRowsSelectedHandler: ()=>{
                return (e)=>{
                    table.toggleAllPageRowsSelected(e.target.checked);
                };
            }
        };
    },
    createRow: (row, table)=>{
        return {
            toggleSelected: (value)=>{
                const isSelected = row.getIsSelected();
                table.setRowSelection((old)=>{
                    value = typeof value !== 'undefined' ? value : !isSelected;
                    if (isSelected === value) return old;
                    const selectedRowIds = {
                        ...old
                    };
                    $34de474a8ff218be$var$mutateRowIsSelected(selectedRowIds, row.id, value, table);
                    return selectedRowIds;
                });
            },
            getIsSelected: ()=>{
                const { rowSelection: rowSelection } = table.getState();
                return $34de474a8ff218be$export$710e11cf672b86c(row, rowSelection);
            },
            getIsSomeSelected: ()=>{
                const { rowSelection: rowSelection } = table.getState();
                return $34de474a8ff218be$export$8f4c46e5d7907334(row, rowSelection) === 'some';
            },
            getIsAllSubRowsSelected: ()=>{
                const { rowSelection: rowSelection } = table.getState();
                return $34de474a8ff218be$export$8f4c46e5d7907334(row, rowSelection) === 'all';
            },
            getCanSelect: ()=>{
                var _table$options$enable;
                if (typeof table.options.enableRowSelection === 'function') return table.options.enableRowSelection(row);
                return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
            },
            getCanSelectSubRows: ()=>{
                var _table$options$enable2;
                if (typeof table.options.enableSubRowSelection === 'function') return table.options.enableSubRowSelection(row);
                return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
            },
            getCanMultiSelect: ()=>{
                var _table$options$enable3;
                if (typeof table.options.enableMultiRowSelection === 'function') return table.options.enableMultiRowSelection(row);
                return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
            },
            getToggleSelectedHandler: ()=>{
                const canSelect = row.getCanSelect();
                return (e)=>{
                    var _target;
                    if (!canSelect) return;
                    row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
                };
            }
        };
    }
};
const $34de474a8ff218be$var$mutateRowIsSelected = (selectedRowIds, id, value, table)=>{
    var _row$subRows;
    const row = table.getRow(id);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach((key)=>delete selectedRowIds[key]);
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach((row)=>$34de474a8ff218be$var$mutateRowIsSelected(selectedRowIds, row.id, value, table));
};
function $34de474a8ff218be$export$f150e72530556b0b(table, rowModel) {
    const rowSelection = table.getState().rowSelection;
    const newSelectedFlatRows = [];
    const newSelectedRowsById = {};
    // Filters top level and nested rows
    const recurseRows = function(rows, depth) {
        return rows.map((row)=>{
            var _row$subRows2;
            const isSelected = $34de474a8ff218be$export$710e11cf672b86c(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = {
                ...row,
                subRows: recurseRows(row.subRows)
            };
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function $34de474a8ff218be$export$710e11cf672b86c(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function $34de474a8ff218be$export$8f4c46e5d7907334(row, selection, table) {
    if (row.subRows && row.subRows.length) {
        let allChildrenSelected = true;
        let someSelected = false;
        row.subRows.forEach((subRow)=>{
            // Bail out early if we know both of these
            if (someSelected && !allChildrenSelected) return;
            if ($34de474a8ff218be$export$710e11cf672b86c(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        });
        return allChildrenSelected ? 'all' : someSelected ? 'some' : false;
    }
    return false;
}
const $34de474a8ff218be$export$8758689f50bddb9f = /([0-9]+)/gm;
const $34de474a8ff218be$var$alphanumeric = (rowA, rowB, columnId)=>{
    return $34de474a8ff218be$var$compareAlphanumeric($34de474a8ff218be$var$toString(rowA.getValue(columnId)).toLowerCase(), $34de474a8ff218be$var$toString(rowB.getValue(columnId)).toLowerCase());
};
const $34de474a8ff218be$var$alphanumericCaseSensitive = (rowA, rowB, columnId)=>{
    return $34de474a8ff218be$var$compareAlphanumeric($34de474a8ff218be$var$toString(rowA.getValue(columnId)), $34de474a8ff218be$var$toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
const $34de474a8ff218be$var$text = (rowA, rowB, columnId)=>{
    return $34de474a8ff218be$var$compareBasic($34de474a8ff218be$var$toString(rowA.getValue(columnId)).toLowerCase(), $34de474a8ff218be$var$toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
const $34de474a8ff218be$var$textCaseSensitive = (rowA, rowB, columnId)=>{
    return $34de474a8ff218be$var$compareBasic($34de474a8ff218be$var$toString(rowA.getValue(columnId)), $34de474a8ff218be$var$toString(rowB.getValue(columnId)));
};
const $34de474a8ff218be$var$datetime = (rowA, rowB, columnId)=>{
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
const $34de474a8ff218be$var$basic = (rowA, rowB, columnId)=>{
    return $34de474a8ff218be$var$compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function $34de474a8ff218be$var$compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function $34de474a8ff218be$var$toString(a) {
    if (typeof a === 'number') {
        if (isNaN(a) || a === Infinity || a === -Infinity) return '';
        return String(a);
    }
    if (typeof a === 'string') return a;
    return '';
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function $34de474a8ff218be$var$compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = aStr.split($34de474a8ff218be$export$8758689f50bddb9f).filter(Boolean);
    const b = bStr.split($34de474a8ff218be$export$8758689f50bddb9f).filter(Boolean);
    // While
    while(a.length && b.length){
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
const $34de474a8ff218be$export$47423a4cd813a815 = {
    alphanumeric: $34de474a8ff218be$var$alphanumeric,
    alphanumericCaseSensitive: $34de474a8ff218be$var$alphanumericCaseSensitive,
    text: $34de474a8ff218be$var$text,
    textCaseSensitive: $34de474a8ff218be$var$textCaseSensitive,
    datetime: $34de474a8ff218be$var$datetime,
    basic: $34de474a8ff218be$var$basic
};
//
const $34de474a8ff218be$export$9707dace2bc98438 = {
    getInitialState: (state)=>{
        return {
            sorting: [],
            ...state
        };
    },
    getDefaultColumnDef: ()=>{
        return {
            sortingFn: 'auto'
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onSortingChange: $34de474a8ff218be$export$2b5605d8069324bd('sorting', table),
            isMultiSortEvent: (e)=>{
                return e.shiftKey;
            }
        };
    },
    createColumn: (column, table)=>{
        return {
            getAutoSortingFn: ()=>{
                const firstRows = table.getFilteredRowModel().flatRows.slice(10);
                let isString = false;
                for (const row of firstRows){
                    const value = row == null ? void 0 : row.getValue(column.id);
                    if (Object.prototype.toString.call(value) === '[object Date]') return $34de474a8ff218be$export$47423a4cd813a815.datetime;
                    if (typeof value === 'string') {
                        isString = true;
                        if (value.split($34de474a8ff218be$export$8758689f50bddb9f).length > 1) return $34de474a8ff218be$export$47423a4cd813a815.alphanumeric;
                    }
                }
                if (isString) return $34de474a8ff218be$export$47423a4cd813a815.text;
                return $34de474a8ff218be$export$47423a4cd813a815.basic;
            },
            getAutoSortDir: ()=>{
                const firstRow = table.getFilteredRowModel().flatRows[0];
                const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
                if (typeof value === 'string') return 'asc';
                return 'desc';
            },
            getSortingFn: ()=>{
                var _table$options$sortin, _table$options$sortin2;
                if (!column) throw new Error();
                return $34de474a8ff218be$export$f6e2535fb5126e54(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === 'auto' ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : $34de474a8ff218be$export$47423a4cd813a815[column.columnDef.sortingFn];
            },
            toggleSorting: (desc, multi)=>{
                // if (column.columns.length) {
                //   column.columns.forEach((c, i) => {
                //     if (c.id) {
                //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
                //     }
                //   })
                //   return
                // }
                // this needs to be outside of table.setSorting to be in sync with rerender
                const nextSortingOrder = column.getNextSortingOrder();
                const hasManualValue = typeof desc !== 'undefined' && desc !== null;
                table.setSorting((old)=>{
                    // Find any existing sorting for this column
                    const existingSorting = old == null ? void 0 : old.find((d)=>d.id === column.id);
                    const existingIndex = old == null ? void 0 : old.findIndex((d)=>d.id === column.id);
                    let newSorting = [];
                    // What should we do with this sort action?
                    let sortAction;
                    let nextDesc = hasManualValue ? desc : nextSortingOrder === 'desc';
                    // Multi-mode
                    if (old != null && old.length && column.getCanMultiSort() && multi) {
                        if (existingSorting) sortAction = 'toggle';
                        else sortAction = 'add';
                    } else {
                        // Normal mode
                        if (old != null && old.length && existingIndex !== old.length - 1) sortAction = 'replace';
                        else if (existingSorting) sortAction = 'toggle';
                        else sortAction = 'replace';
                    }
                    // Handle toggle states that will remove the sorting
                    if (sortAction === 'toggle') {
                        // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                        if (!hasManualValue) // Is our intention to remove?
                        {
                            if (!nextSortingOrder) sortAction = 'remove';
                        }
                    }
                    if (sortAction === 'add') {
                        var _table$options$maxMul;
                        newSorting = [
                            ...old,
                            {
                                id: column.id,
                                desc: nextDesc
                            }
                        ];
                        // Take latest n columns
                        newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                    } else if (sortAction === 'toggle') // This flips (or sets) the
                    newSorting = old.map((d)=>{
                        if (d.id === column.id) return {
                            ...d,
                            desc: nextDesc
                        };
                        return d;
                    });
                    else if (sortAction === 'remove') newSorting = old.filter((d)=>d.id !== column.id);
                    else newSorting = [
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ];
                    return newSorting;
                });
            },
            getFirstSortDir: ()=>{
                var _ref, _column$columnDef$sor;
                const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === 'desc';
                return sortDescFirst ? 'desc' : 'asc';
            },
            getNextSortingOrder: (multi)=>{
                var _table$options$enable, _table$options$enable2;
                const firstSortDirection = column.getFirstSortDir();
                const isSorted = column.getIsSorted();
                if (!isSorted) return firstSortDirection;
                if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
                (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
                )) return false;
                return isSorted === 'desc' ? 'asc' : 'desc';
            },
            getCanSort: ()=>{
                var _column$columnDef$ena, _table$options$enable3;
                return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
            },
            getCanMultiSort: ()=>{
                var _ref2, _column$columnDef$ena2;
                return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
            },
            getIsSorted: ()=>{
                var _table$getState$sorti;
                const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d)=>d.id === column.id);
                return !columnSort ? false : columnSort.desc ? 'desc' : 'asc';
            },
            getSortIndex: ()=>{
                var _table$getState$sorti2, _table$getState$sorti3;
                return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$sorti2 : -1;
            },
            clearSorting: ()=>{
                //clear sorting for just 1 column
                table.setSorting((old)=>old != null && old.length ? old.filter((d)=>d.id !== column.id) : []);
            },
            getToggleSortingHandler: ()=>{
                const canSort = column.getCanSort();
                return (e)=>{
                    if (!canSort) return;
                    e.persist == null || e.persist();
                    column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
                };
            }
        };
    },
    createTable: (table)=>{
        return {
            setSorting: (updater)=>table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater),
            resetSorting: (defaultState)=>{
                var _table$initialState$s, _table$initialState;
                table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
            },
            getPreSortedRowModel: ()=>table.getGroupedRowModel(),
            getSortedRowModel: ()=>{
                if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
                if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
                return table._getSortedRowModel();
            }
        };
    }
};
//
const $34de474a8ff218be$export$5afe92775e3e701d = {
    getInitialState: (state)=>{
        return {
            columnVisibility: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnVisibilityChange: $34de474a8ff218be$export$2b5605d8069324bd('columnVisibility', table)
        };
    },
    createColumn: (column, table)=>{
        return {
            toggleVisibility: (value)=>{
                if (column.getCanHide()) table.setColumnVisibility((old)=>({
                        ...old,
                        [column.id]: value != null ? value : !column.getIsVisible()
                    }));
            },
            getIsVisible: ()=>{
                var _table$getState$colum, _table$getState$colum2;
                return (_table$getState$colum = (_table$getState$colum2 = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum2[column.id]) != null ? _table$getState$colum : true;
            },
            getCanHide: ()=>{
                var _column$columnDef$ena, _table$options$enable;
                return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
            },
            getToggleVisibilityHandler: ()=>{
                return (e)=>{
                    column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
                };
            }
        };
    },
    createRow: (row, table)=>{
        return {
            _getAllVisibleCells: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    row.getAllCells(),
                    table.getState().columnVisibility
                ], (cells)=>{
                return cells.filter((cell)=>cell.column.getIsVisible());
            }, {
                key: 'row._getAllVisibleCells',
                debug: ()=>{
                    var _table$options$debugA;
                    return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
                }
            }),
            getVisibleCells: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    row.getLeftVisibleCells(),
                    row.getCenterVisibleCells(),
                    row.getRightVisibleCells()
                ], (left, center, right)=>[
                    ...left,
                    ...center,
                    ...right
                ], {
                key: false,
                debug: ()=>{
                    var _table$options$debugA2;
                    return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
                }
            })
        };
    },
    createTable: (table)=>{
        const makeVisibleColumnsMethod = (key, getColumns)=>{
            return $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                    getColumns(),
                    getColumns().filter((d)=>d.getIsVisible()).map((d)=>d.id).join('_')
                ], (columns)=>{
                return columns.filter((d)=>d.getIsVisible == null ? void 0 : d.getIsVisible());
            }, {
                key: key,
                debug: ()=>{
                    var _table$options$debugA3;
                    return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugColumns;
                }
            });
        };
        return {
            getVisibleFlatColumns: makeVisibleColumnsMethod('getVisibleFlatColumns', ()=>table.getAllFlatColumns()),
            getVisibleLeafColumns: makeVisibleColumnsMethod('getVisibleLeafColumns', ()=>table.getAllLeafColumns()),
            getLeftVisibleLeafColumns: makeVisibleColumnsMethod('getLeftVisibleLeafColumns', ()=>table.getLeftLeafColumns()),
            getRightVisibleLeafColumns: makeVisibleColumnsMethod('getRightVisibleLeafColumns', ()=>table.getRightLeafColumns()),
            getCenterVisibleLeafColumns: makeVisibleColumnsMethod('getCenterVisibleLeafColumns', ()=>table.getCenterLeafColumns()),
            setColumnVisibility: (updater)=>table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater),
            resetColumnVisibility: (defaultState)=>{
                var _table$initialState$c;
                table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
            },
            toggleAllColumnsVisible: (value)=>{
                var _value;
                value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
                table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column)=>({
                        ...obj,
                        [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
                    }), {}));
            },
            getIsAllColumnsVisible: ()=>!table.getAllLeafColumns().some((column)=>!(column.getIsVisible != null && column.getIsVisible())),
            getIsSomeColumnsVisible: ()=>table.getAllLeafColumns().some((column)=>column.getIsVisible == null ? void 0 : column.getIsVisible()),
            getToggleAllColumnsVisibilityHandler: ()=>{
                return (e)=>{
                    var _target;
                    table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
                };
            }
        };
    }
};
const $34de474a8ff218be$var$features = [
    $34de474a8ff218be$export$79b704688b15c0f4,
    $34de474a8ff218be$export$5afe92775e3e701d,
    $34de474a8ff218be$export$549aff5da5ccfd97,
    $34de474a8ff218be$export$5289f180505593b3,
    $34de474a8ff218be$export$92a576f896a9bf72,
    $34de474a8ff218be$export$9707dace2bc98438,
    $34de474a8ff218be$export$3885c0af90651e94,
    $34de474a8ff218be$export$c9bad30efcce6e0c,
    $34de474a8ff218be$export$68f5e1453c188a82,
    $34de474a8ff218be$export$e8905133e7bf3121,
    $34de474a8ff218be$export$9916c85814812d4a
];
//
function $34de474a8ff218be$export$33bbb3ec7652e187(options) {
    var _options$initialState;
    if (options.debugAll || options.debugTable) console.info('Creating Table Instance...');
    let table = {
        _features: $34de474a8ff218be$var$features
    };
    const defaultOptions = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    const mergeOptions = (options)=>{
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return {
            ...defaultOptions,
            ...options
        };
    };
    const coreInitialState = {};
    let initialState = {
        ...coreInitialState,
        ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
    };
    table._features.forEach((feature)=>{
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    const queued = [];
    let queuedTimeout = false;
    const coreInstance = {
        _features: $34de474a8ff218be$var$features,
        options: {
            ...defaultOptions,
            ...options
        },
        initialState: initialState,
        _queue: (cb)=>{
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(()=>{
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch((error)=>setTimeout(()=>{
                        throw error;
                    }));
            }
        },
        reset: ()=>{
            table.setState(table.initialState);
        },
        setOptions: (updater)=>{
            const newOptions = $34de474a8ff218be$export$7f095f455ad5af3f(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: ()=>{
            return table.options.state;
        },
        setState: (updater)=>{
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: (row, index, parent)=>{
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : `${parent ? [
                parent.id,
                index
            ].join('.') : index}`;
        },
        getCoreRowModel: ()=>{
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: ()=>{
            return table.getPaginationRowModel();
        },
        getRow: (id)=>{
            const row = table.getRowModel().rowsById[id];
            if (!row) throw new Error();
            return row;
        },
        _getDefaultColumnDef: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table.options.defaultColumn
            ], (defaultColumn)=>{
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return {
                header: (props)=>{
                    const resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: (props)=>{
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null ? void 0 : _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                },
                ...table._features.reduce((obj, feature)=>{
                    return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
                }, {}),
                ...defaultColumn
            };
        }, {
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugColumns;
            },
            key: false
        }),
        _getColumnDefs: ()=>table.options.columns,
        getAllColumns: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table._getColumnDefs()
            ], (columnDefs)=>{
            const recurseColumns = function(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map((columnDef)=>{
                    const column = $34de474a8ff218be$export$1bfa986e9c92c0b5(table, columnDef, depth, parent);
                    const groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugColumns;
            }
        }),
        getAllFlatColumns: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table.getAllColumns()
            ], (allColumns)=>{
            return allColumns.flatMap((column)=>{
                return column.getFlatColumns();
            });
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA3;
                return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugColumns;
            }
        }),
        _getAllFlatColumnsById: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table.getAllFlatColumns()
            ], (flatColumns)=>{
            return flatColumns.reduce((acc, column)=>{
                acc[column.id] = column;
                return acc;
            }, {});
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA4;
                return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugColumns;
            }
        }),
        getAllLeafColumns: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ], (allColumns, orderColumns)=>{
            let leafColumns = allColumns.flatMap((column)=>column.getLeafColumns());
            return orderColumns(leafColumns);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA5;
                return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugColumns;
            }
        }),
        getColumn: (columnId)=>{
            const column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    table._features.forEach((feature)=>{
        return Object.assign(table, feature.createTable == null ? void 0 : feature.createTable(table));
    });
    return table;
}
function $34de474a8ff218be$export$3cb21b6b1233300e(table, row, column, columnId) {
    const getRenderValue = ()=>{
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    const cell = {
        id: `${row.id}_${column.id}`,
        row: row,
        column: column,
        getValue: ()=>row.getValue(columnId),
        renderValue: getRenderValue,
        getContext: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table,
                column,
                row,
                cell
            ], (table, column, row, cell)=>({
                table: table,
                column: column,
                row: row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            }), {
            key: false,
            debug: ()=>table.options.debugAll
        })
    };
    table._features.forEach((feature)=>{
        Object.assign(cell, feature.createCell == null ? void 0 : feature.createCell(cell, column, row, table));
    }, {});
    return cell;
}
const $34de474a8ff218be$export$3442c5d213434705 = (table, id, original, rowIndex, depth, subRows, parentId)=>{
    let row = {
        id: id,
        index: rowIndex,
        original: original,
        depth: depth,
        parentId: parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: (columnId)=>{
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: (columnId)=>{
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: (columnId)=>{
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: ()=>$34de474a8ff218be$export$bf4548421d1b2c8(row.subRows, (d)=>d.subRows),
        getParentRow: ()=>row.parentId ? table.getRow(row.parentId) : undefined,
        getParentRows: ()=>{
            let parentRows = [];
            let currentRow = row;
            while(true){
                const parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns()
            ], (leafColumns)=>{
            return leafColumns.map((column)=>{
                return $34de474a8ff218be$export$3cb21b6b1233300e(table, row, column, column.id);
            });
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
            }
        }),
        _getAllCellsByColumnId: $34de474a8ff218be$export$7c73462e0d25e514(()=>[
                row.getAllCells()
            ], (allCells)=>{
            return allCells.reduce((acc, cell)=>{
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, {
            key: 'row.getAllCellsByColumnId',
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
            }
        })
    };
    for(let i = 0; i < table._features.length; i++){
        const feature = table._features[i];
        Object.assign(row, feature == null ? void 0 : feature.createRow == null ? void 0 : feature.createRow(row, table));
    }
    return row;
};
// type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
function $34de474a8ff218be$export$4b44a5cb9651fe5e() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === 'function' ? {
                ...column,
                accessorFn: accessor
            } : {
                ...column,
                accessorKey: accessor
            };
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
function $34de474a8ff218be$export$32d0bc001e828250() {
    return (table)=>$34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table.options.data
            ], (data)=>{
            const rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            const accessRows = function(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                const rows = [];
                for(let i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    const row = $34de474a8ff218be$export$3442c5d213434705(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{
                table._autoResetPageIndex();
            }
        });
}
function $34de474a8ff218be$var$filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return $34de474a8ff218be$var$filterRowModelFromLeafs(rows, filterRowImpl, table);
    return $34de474a8ff218be$var$filterRowModelFromRoot(rows, filterRowImpl, table);
}
function $34de474a8ff218be$var$filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        const rows = [];
        // Filter from children up first
        for(let i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            let row = rowsToFilter[i];
            const newRow = $34de474a8ff218be$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredRowsById[i] = row;
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredRowsById[i] = row;
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredRowsById[i] = row;
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $34de474a8ff218be$var$filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        const rows = [];
        // Apply the filter to any subRows
        for(let i = 0; i < rowsToFilter.length; i++){
            let row = rowsToFilter[i];
            const pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    const newRow = $34de474a8ff218be$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $34de474a8ff218be$export$26f255a2756e1638() {
    return (table)=>$34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ], (rowModel, columnFilters, globalFilter)=>{
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(let i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            const resolvedColumnFilters = [];
            const resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach((d)=>{
                var _filterFn$resolveFilt;
                const column = table.getColumn(d.id);
                if (!column) return;
                const filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn: filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            const filterableIds = columnFilters.map((d)=>d.id);
            const globalFilterFn = table.getGlobalFilterFn();
            const globallyFilterableColumns = table.getAllLeafColumns().filter((column)=>column.getCanGlobalFilter());
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push('__global__');
                globallyFilterableColumns.forEach((column)=>{
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            let currentColumnFilter;
            let currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(let j = 0; j < rowModel.flatRows.length; j++){
                const row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(let i = 0; i < resolvedColumnFilters.length; i++){
                    currentColumnFilter = resolvedColumnFilters[i];
                    const id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, (filterMeta)=>{
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                }
                if (resolvedGlobalFilters.length) {
                    for(let i = 0; i < resolvedGlobalFilters.length; i++){
                        currentGlobalFilter = resolvedGlobalFilters[i];
                        const id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, (filterMeta)=>{
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            break;
                        }
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            }
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return $34de474a8ff218be$var$filterRows(rowModel.rows, filterRowsImpl, table);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{
                table._autoResetPageIndex();
            }
        });
}
function $34de474a8ff218be$export$3519aa0e35dc33b4() {
    return (table, columnId)=>$34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ], (preRowModel, columnFilters, globalFilter)=>{
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            const filterableIds = [
                ...columnFilters.map((d)=>d.id).filter((d)=>d !== columnId),
                globalFilter ? '__global__' : undefined
            ].filter(Boolean);
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return $34de474a8ff218be$var$filterRows(preRowModel.rows, filterRowsImpl, table);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{}
        });
}
function $34de474a8ff218be$export$1fb5d0c1edc37de2() {
    return (table, columnId)=>$34de474a8ff218be$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return new Map();
            let facetedUniqueValues = new Map();
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{}
        });
}
function $34de474a8ff218be$export$d17dd32c9eab9fc7() {
    return (table, columnId)=>$34de474a8ff218be$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            var _facetedRowModel$flat;
            if (!facetedRowModel) return undefined;
            const firstValue = (_facetedRowModel$flat = facetedRowModel.flatRows[0]) == null ? void 0 : _facetedRowModel$flat.getUniqueValues(columnId);
            if (typeof firstValue === 'undefined') return undefined;
            let facetedMinMaxValues = [
                firstValue,
                firstValue
            ];
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (value < facetedMinMaxValues[0]) facetedMinMaxValues[0] = value;
                    else if (value > facetedMinMaxValues[1]) facetedMinMaxValues[1] = value;
                }
            }
            return facetedMinMaxValues;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{}
        });
}
function $34de474a8ff218be$export$4ca93ca80835d8c1() {
    return (table)=>$34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table.getState().sorting,
                table.getPreSortedRowModel()
            ], (sorting, rowModel)=>{
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            const sortingState = table.getState().sorting;
            const sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            const availableSorting = sortingState.filter((sort)=>{
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            const columnInfoById = {};
            availableSorting.forEach((sortEntry)=>{
                const column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            const sortData = (rows)=>{
                // This will also perform a stable sorting using the row index
                // if needed.
                const sortedData = [
                    ...rows
                ];
                sortedData.sort((rowA, rowB)=>{
                    for(let i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        const sortEntry = availableSorting[i];
                        const columnInfo = columnInfoById[sortEntry.id];
                        const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        if (columnInfo.sortUndefined) {
                            const aValue = rowA.getValue(sortEntry.id);
                            const bValue = rowB.getValue(sortEntry.id);
                            const aUndefined = typeof aValue === 'undefined';
                            const bUndefined = typeof bValue === 'undefined';
                            if (aUndefined || bUndefined) {
                                let undefinedSort = aUndefined && bUndefined ? 0 : aUndefined ? columnInfo.sortUndefined : -columnInfo.sortUndefined;
                                if (isDesc && undefinedSort !== 0) undefinedSort *= -1;
                                return undefinedSort;
                            }
                        }
                        // This function should always return in ascending order
                        let sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach((row)=>{
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{
                table._autoResetPageIndex();
            }
        });
}
function $34de474a8ff218be$export$2b7f4b57ce71b81() {
    return (table)=>$34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            if (!rowModel.rows.length || !grouping.length) return rowModel;
            // Filter the grouping list down to columns that exist
            const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
            const groupedFlatRows = [];
            const groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            const groupUpRecursively = function(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map((row)=>{
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                const columnId = existingGrouping[depth];
                // Group the rows together for this level
                const rowGroupsMap = $34de474a8ff218be$var$groupBy(rows, columnId);
                // Peform aggregations for each group
                const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index)=>{
                    let [groupingValue, groupedRows] = _ref;
                    let id = `${columnId}:${groupingValue}`;
                    id = parentId ? `${parentId}>${id}` : id;
                    // First, Recurse to group sub rows before aggregation
                    const subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    // Flatten the leaf rows of the rows in this group
                    const leafRows = depth ? $34de474a8ff218be$export$bf4548421d1b2c8(groupedRows, (row)=>row.subRows) : groupedRows;
                    const row = $34de474a8ff218be$export$3442c5d213434705(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue: groupingValue,
                        subRows: subRows,
                        leafRows: leafRows,
                        getValue: (columnId)=>{
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            const column = table.getColumn(columnId);
                            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach((subRow)=>{
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            const groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach((subRow)=>{
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{
                table._queue(()=>{
                    table._autoResetExpanded();
                    table._autoResetPageIndex();
                });
            }
        });
}
function $34de474a8ff218be$var$groupBy(rows, columnId) {
    const groupMap = new Map();
    return rows.reduce((map, row)=>{
        const resKey = `${row.getGroupingValue(columnId)}`;
        const previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function $34de474a8ff218be$export$53cfec7b1b8d1fcd() {
    return (table)=>$34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ], (expanded, rowModel, paginateExpandedRows)=>{
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return $34de474a8ff218be$export$1293f966cdb38633(rowModel);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            }
        });
}
function $34de474a8ff218be$export$1293f966cdb38633(rowModel) {
    const expandedRows = [];
    const handleRow = (row)=>{
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function $34de474a8ff218be$export$ddfd3662e196c265(opts) {
    return (table)=>$34de474a8ff218be$export$7c73462e0d25e514(()=>[
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ], (pagination, rowModel)=>{
            if (!rowModel.rows.length) return rowModel;
            const { pageSize: pageSize, pageIndex: pageIndex } = pagination;
            let { rows: rows, flatRows: flatRows, rowsById: rowsById } = rowModel;
            const pageStart = pageSize * pageIndex;
            const pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            let paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = $34de474a8ff218be$export$1293f966cdb38633({
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            });
            else paginatedRowModel = {
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            };
            paginatedRowModel.flatRows = [];
            const handleRow = (row)=>{
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            }
        });
}

/**
 * react-table
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i5lfL = parcelRequire("i5lfL");

//
function $eb7cf81af64cc0c8$export$f2385bb6e3ac4b4f(Comp, props) {
    return !Comp ? null : $eb7cf81af64cc0c8$var$isReactComponent(Comp) ? /*#__PURE__*/ $i5lfL.createElement(Comp, props) : Comp;
}
function $eb7cf81af64cc0c8$var$isReactComponent(component) {
    return $eb7cf81af64cc0c8$var$isClassComponent(component) || typeof component === 'function' || $eb7cf81af64cc0c8$var$isExoticComponent(component);
}
function $eb7cf81af64cc0c8$var$isClassComponent(component) {
    return typeof component === 'function' && (()=>{
        const proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    })();
}
function $eb7cf81af64cc0c8$var$isExoticComponent(component) {
    return typeof component === 'object' && typeof component.$$typeof === 'symbol' && [
        'react.memo',
        'react.forward_ref'
    ].includes(component.$$typeof.description);
}
function $eb7cf81af64cc0c8$export$25eaeb3743e6b31f(options) {
    // Compose in the generic options to the user options
    const resolvedOptions = {
        state: {},
        // Dummy state
        onStateChange: ()=>{},
        // noop
        renderFallbackValue: null,
        ...options
    };
    // Create a new table and store it in state
    const [tableRef] = $i5lfL.useState(()=>({
            current: (0, $34de474a8ff218be$export$33bbb3ec7652e187)(resolvedOptions)
        }));
    // By default, manage table state here using the table's initial state
    const [state, setState] = $i5lfL.useState(()=>tableRef.current.initialState);
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions((prev)=>({
            ...prev,
            ...options,
            state: {
                ...state,
                ...options.state
            },
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: (updater)=>{
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        }));
    return tableRef.current;
}


/**
 * match-sorter-utils
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ const $c48a0afd06479119$var$characterMap = {
    "\xc0": 'A',
    "\xc1": 'A',
    "\xc2": 'A',
    "\xc3": 'A',
    "\xc4": 'A',
    "\xc5": 'A',
    \u1EA4: 'A',
    \u1EAE: 'A',
    \u1EB2: 'A',
    \u1EB4: 'A',
    \u1EB6: 'A',
    "\xc6": 'AE',
    \u1EA6: 'A',
    \u1EB0: 'A',
    \u0202: 'A',
    "\xc7": 'C',
    \u1E08: 'C',
    "\xc8": 'E',
    "\xc9": 'E',
    "\xca": 'E',
    "\xcb": 'E',
    \u1EBE: 'E',
    \u1E16: 'E',
    \u1EC0: 'E',
    \u1E14: 'E',
    \u1E1C: 'E',
    \u0206: 'E',
    "\xcc": 'I',
    "\xcd": 'I',
    "\xce": 'I',
    "\xcf": 'I',
    \u1E2E: 'I',
    \u020A: 'I',
    "\xd0": 'D',
    "\xd1": 'N',
    "\xd2": 'O',
    "\xd3": 'O',
    "\xd4": 'O',
    "\xd5": 'O',
    "\xd6": 'O',
    "\xd8": 'O',
    \u1ED0: 'O',
    \u1E4C: 'O',
    \u1E52: 'O',
    \u020E: 'O',
    "\xd9": 'U',
    "\xda": 'U',
    "\xdb": 'U',
    "\xdc": 'U',
    "\xdd": 'Y',
    "\xe0": 'a',
    "\xe1": 'a',
    "\xe2": 'a',
    "\xe3": 'a',
    "\xe4": 'a',
    "\xe5": 'a',
    \u1EA5: 'a',
    \u1EAF: 'a',
    \u1EB3: 'a',
    \u1EB5: 'a',
    \u1EB7: 'a',
    "\xe6": 'ae',
    \u1EA7: 'a',
    \u1EB1: 'a',
    \u0203: 'a',
    "\xe7": 'c',
    \u1E09: 'c',
    "\xe8": 'e',
    "\xe9": 'e',
    "\xea": 'e',
    "\xeb": 'e',
    \u1EBF: 'e',
    \u1E17: 'e',
    \u1EC1: 'e',
    \u1E15: 'e',
    \u1E1D: 'e',
    \u0207: 'e',
    "\xec": 'i',
    "\xed": 'i',
    "\xee": 'i',
    "\xef": 'i',
    \u1E2F: 'i',
    \u020B: 'i',
    "\xf0": 'd',
    "\xf1": 'n',
    "\xf2": 'o',
    "\xf3": 'o',
    "\xf4": 'o',
    "\xf5": 'o',
    "\xf6": 'o',
    "\xf8": 'o',
    \u1ED1: 'o',
    \u1E4D: 'o',
    \u1E53: 'o',
    \u020F: 'o',
    "\xf9": 'u',
    "\xfa": 'u',
    "\xfb": 'u',
    "\xfc": 'u',
    "\xfd": 'y',
    "\xff": 'y',
    \u0100: 'A',
    \u0101: 'a',
    \u0102: 'A',
    \u0103: 'a',
    \u0104: 'A',
    \u0105: 'a',
    \u0106: 'C',
    \u0107: 'c',
    \u0108: 'C',
    \u0109: 'c',
    \u010A: 'C',
    \u010B: 'c',
    \u010C: 'C',
    \u010D: 'c',
    C\u0306: 'C',
    c\u0306: 'c',
    \u010E: 'D',
    \u010F: 'd',
    \u0110: 'D',
    \u0111: 'd',
    \u0112: 'E',
    \u0113: 'e',
    \u0114: 'E',
    \u0115: 'e',
    \u0116: 'E',
    \u0117: 'e',
    \u0118: 'E',
    \u0119: 'e',
    \u011A: 'E',
    \u011B: 'e',
    \u011C: 'G',
    \u01F4: 'G',
    \u011D: 'g',
    \u01F5: 'g',
    \u011E: 'G',
    \u011F: 'g',
    \u0120: 'G',
    \u0121: 'g',
    \u0122: 'G',
    \u0123: 'g',
    \u0124: 'H',
    \u0125: 'h',
    \u0126: 'H',
    \u0127: 'h',
    \u1E2A: 'H',
    \u1E2B: 'h',
    \u0128: 'I',
    \u0129: 'i',
    \u012A: 'I',
    \u012B: 'i',
    \u012C: 'I',
    \u012D: 'i',
    \u012E: 'I',
    \u012F: 'i',
    \u0130: 'I',
    \u0131: 'i',
    \u0132: 'IJ',
    \u0133: 'ij',
    \u0134: 'J',
    \u0135: 'j',
    \u0136: 'K',
    \u0137: 'k',
    \u1E30: 'K',
    \u1E31: 'k',
    K\u0306: 'K',
    k\u0306: 'k',
    \u0139: 'L',
    \u013A: 'l',
    \u013B: 'L',
    \u013C: 'l',
    \u013D: 'L',
    \u013E: 'l',
    \u013F: 'L',
    \u0140: 'l',
    \u0141: 'l',
    \u0142: 'l',
    \u1E3E: 'M',
    \u1E3F: 'm',
    M\u0306: 'M',
    m\u0306: 'm',
    \u0143: 'N',
    \u0144: 'n',
    \u0145: 'N',
    \u0146: 'n',
    \u0147: 'N',
    \u0148: 'n',
    \u0149: 'n',
    N\u0306: 'N',
    n\u0306: 'n',
    \u014C: 'O',
    \u014D: 'o',
    \u014E: 'O',
    \u014F: 'o',
    \u0150: 'O',
    \u0151: 'o',
    \u0152: 'OE',
    \u0153: 'oe',
    P\u0306: 'P',
    p\u0306: 'p',
    \u0154: 'R',
    \u0155: 'r',
    \u0156: 'R',
    \u0157: 'r',
    \u0158: 'R',
    \u0159: 'r',
    R\u0306: 'R',
    r\u0306: 'r',
    \u0212: 'R',
    \u0213: 'r',
    \u015A: 'S',
    \u015B: 's',
    \u015C: 'S',
    \u015D: 's',
    \u015E: 'S',
    \u0218: 'S',
    \u0219: 's',
    \u015F: 's',
    \u0160: 'S',
    \u0161: 's',
    \u0162: 'T',
    \u0163: 't',
    \u021B: 't',
    \u021A: 'T',
    \u0164: 'T',
    \u0165: 't',
    \u0166: 'T',
    \u0167: 't',
    T\u0306: 'T',
    t\u0306: 't',
    \u0168: 'U',
    \u0169: 'u',
    \u016A: 'U',
    \u016B: 'u',
    \u016C: 'U',
    \u016D: 'u',
    \u016E: 'U',
    \u016F: 'u',
    \u0170: 'U',
    \u0171: 'u',
    \u0172: 'U',
    \u0173: 'u',
    \u0216: 'U',
    \u0217: 'u',
    V\u0306: 'V',
    v\u0306: 'v',
    \u0174: 'W',
    \u0175: 'w',
    \u1E82: 'W',
    \u1E83: 'w',
    X\u0306: 'X',
    x\u0306: 'x',
    \u0176: 'Y',
    \u0177: 'y',
    \u0178: 'Y',
    Y\u0306: 'Y',
    y\u0306: 'y',
    \u0179: 'Z',
    \u017A: 'z',
    \u017B: 'Z',
    \u017C: 'z',
    \u017D: 'Z',
    \u017E: 'z',
    \u017F: 's',
    \u0192: 'f',
    \u01A0: 'O',
    \u01A1: 'o',
    \u01AF: 'U',
    \u01B0: 'u',
    \u01CD: 'A',
    \u01CE: 'a',
    \u01CF: 'I',
    \u01D0: 'i',
    \u01D1: 'O',
    \u01D2: 'o',
    \u01D3: 'U',
    \u01D4: 'u',
    \u01D5: 'U',
    \u01D6: 'u',
    \u01D7: 'U',
    \u01D8: 'u',
    \u01D9: 'U',
    \u01DA: 'u',
    \u01DB: 'U',
    \u01DC: 'u',
    \u1EE8: 'U',
    \u1EE9: 'u',
    \u1E78: 'U',
    \u1E79: 'u',
    \u01FA: 'A',
    \u01FB: 'a',
    \u01FC: 'AE',
    \u01FD: 'ae',
    \u01FE: 'O',
    \u01FF: 'o',
    "\xde": 'TH',
    "\xfe": 'th',
    \u1E54: 'P',
    \u1E55: 'p',
    \u1E64: 'S',
    \u1E65: 's',
    X\u0301: 'X',
    x\u0301: 'x',
    \u0403: "\u0413",
    \u0453: "\u0433",
    \u040C: "\u041A",
    \u045C: "\u043A",
    A\u030B: 'A',
    a\u030B: 'a',
    E\u030B: 'E',
    e\u030B: 'e',
    I\u030B: 'I',
    i\u030B: 'i',
    \u01F8: 'N',
    \u01F9: 'n',
    \u1ED2: 'O',
    \u1ED3: 'o',
    \u1E50: 'O',
    \u1E51: 'o',
    \u1EEA: 'U',
    \u1EEB: 'u',
    \u1E80: 'W',
    \u1E81: 'w',
    \u1EF2: 'Y',
    \u1EF3: 'y',
    \u0200: 'A',
    \u0201: 'a',
    \u0204: 'E',
    \u0205: 'e',
    \u0208: 'I',
    \u0209: 'i',
    \u020C: 'O',
    \u020D: 'o',
    \u0210: 'R',
    \u0211: 'r',
    \u0214: 'U',
    \u0215: 'u',
    B\u030C: 'B',
    b\u030C: 'b',
    \u010C\u0323: 'C',
    \u010D\u0323: 'c',
    "\xca\u030C": 'E',
    "\xea\u030C": 'e',
    F\u030C: 'F',
    f\u030C: 'f',
    \u01E6: 'G',
    \u01E7: 'g',
    \u021E: 'H',
    \u021F: 'h',
    J\u030C: 'J',
    \u01F0: 'j',
    \u01E8: 'K',
    \u01E9: 'k',
    M\u030C: 'M',
    m\u030C: 'm',
    P\u030C: 'P',
    p\u030C: 'p',
    Q\u030C: 'Q',
    q\u030C: 'q',
    \u0158\u0329: 'R',
    \u0159\u0329: 'r',
    \u1E66: 'S',
    \u1E67: 's',
    V\u030C: 'V',
    v\u030C: 'v',
    W\u030C: 'W',
    w\u030C: 'w',
    X\u030C: 'X',
    x\u030C: 'x',
    Y\u030C: 'Y',
    y\u030C: 'y',
    A\u0327: 'A',
    a\u0327: 'a',
    B\u0327: 'B',
    b\u0327: 'b',
    \u1E10: 'D',
    \u1E11: 'd',
    \u0228: 'E',
    \u0229: 'e',
    \u0190\u0327: 'E',
    \u025B\u0327: 'e',
    \u1E28: 'H',
    \u1E29: 'h',
    I\u0327: 'I',
    i\u0327: 'i',
    \u0197\u0327: 'I',
    \u0268\u0327: 'i',
    M\u0327: 'M',
    m\u0327: 'm',
    O\u0327: 'O',
    o\u0327: 'o',
    Q\u0327: 'Q',
    q\u0327: 'q',
    U\u0327: 'U',
    u\u0327: 'u',
    X\u0327: 'X',
    x\u0327: 'x',
    Z\u0327: 'Z',
    z\u0327: 'z'
};
const $c48a0afd06479119$var$chars = Object.keys($c48a0afd06479119$var$characterMap).join('|');
const $c48a0afd06479119$var$allAccents = new RegExp($c48a0afd06479119$var$chars, 'g');
function $c48a0afd06479119$var$removeAccents(str) {
    return str.replace($c48a0afd06479119$var$allAccents, (match)=>{
        return $c48a0afd06479119$var$characterMap[match];
    });
}
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2099 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */ const $c48a0afd06479119$export$809b0b82a3f0b8b5 = {
    CASE_SENSITIVE_EQUAL: 7,
    EQUAL: 6,
    STARTS_WITH: 5,
    WORD_STARTS_WITH: 4,
    CONTAINS: 3,
    ACRONYM: 2,
    MATCHES: 1,
    NO_MATCH: 0
};
/**
 * Gets the highest ranking for value for the given item based on its values for the given keys
 * @param {*} item - the item to rank
 * @param {Array} keys - the keys to get values from the item for the ranking
 * @param {String} value - the value to rank against
 * @param {Object} options - options to control the ranking
 * @return {{rank: Number, accessorIndex: Number, accessorThreshold: Number}} - the highest ranking
 */ function $c48a0afd06479119$export$2bf9c99d6a293bc8(item, value, options) {
    var _options$threshold;
    options = options || {};
    options.threshold = (_options$threshold = options.threshold) != null ? _options$threshold : $c48a0afd06479119$export$809b0b82a3f0b8b5.MATCHES;
    if (!options.accessors) {
        // if keys is not specified, then we assume the item given is ready to be matched
        const rank = $c48a0afd06479119$var$getMatchRanking(item, value, options);
        return {
            // ends up being duplicate of 'item' in matches but consistent
            rankedValue: item,
            rank: rank,
            accessorIndex: -1,
            accessorThreshold: options.threshold,
            passed: rank >= options.threshold
        };
    }
    const valuesToRank = $c48a0afd06479119$var$getAllValuesToRank(item, options.accessors);
    const rankingInfo = {
        rankedValue: item,
        rank: $c48a0afd06479119$export$809b0b82a3f0b8b5.NO_MATCH,
        accessorIndex: -1,
        accessorThreshold: options.threshold,
        passed: false
    };
    for(let i = 0; i < valuesToRank.length; i++){
        const rankValue = valuesToRank[i];
        let newRank = $c48a0afd06479119$var$getMatchRanking(rankValue.itemValue, value, options);
        const { minRanking: minRanking, maxRanking: maxRanking, threshold: threshold = options.threshold } = rankValue.attributes;
        if (newRank < minRanking && newRank >= $c48a0afd06479119$export$809b0b82a3f0b8b5.MATCHES) newRank = minRanking;
        else if (newRank > maxRanking) newRank = maxRanking;
        newRank = Math.min(newRank, maxRanking);
        if (newRank >= threshold && newRank > rankingInfo.rank) {
            rankingInfo.rank = newRank;
            rankingInfo.passed = true;
            rankingInfo.accessorIndex = i;
            rankingInfo.accessorThreshold = threshold;
            rankingInfo.rankedValue = rankValue.itemValue;
        }
    }
    return rankingInfo;
}
/**
 * Gives a rankings score based on how well the two strings match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Object} options - options for the match (like keepDiacritics for comparison)
 * @returns {Number} the ranking for how well stringToRank matches testString
 */ function $c48a0afd06479119$var$getMatchRanking(testString, stringToRank, options) {
    testString = $c48a0afd06479119$var$prepareValueForComparison(testString, options);
    stringToRank = $c48a0afd06479119$var$prepareValueForComparison(stringToRank, options);
    // too long
    if (stringToRank.length > testString.length) return $c48a0afd06479119$export$809b0b82a3f0b8b5.NO_MATCH;
    // case sensitive equals
    if (testString === stringToRank) return $c48a0afd06479119$export$809b0b82a3f0b8b5.CASE_SENSITIVE_EQUAL;
    // Lower casing before further comparison
    testString = testString.toLowerCase();
    stringToRank = stringToRank.toLowerCase();
    // case insensitive equals
    if (testString === stringToRank) return $c48a0afd06479119$export$809b0b82a3f0b8b5.EQUAL;
    // starts with
    if (testString.startsWith(stringToRank)) return $c48a0afd06479119$export$809b0b82a3f0b8b5.STARTS_WITH;
    // word starts with
    if (testString.includes(` ${stringToRank}`)) return $c48a0afd06479119$export$809b0b82a3f0b8b5.WORD_STARTS_WITH;
    // contains
    if (testString.includes(stringToRank)) return $c48a0afd06479119$export$809b0b82a3f0b8b5.CONTAINS;
    else if (stringToRank.length === 1) // If the only character in the given stringToRank
    //   isn't even contained in the testString, then
    //   it's definitely not a match.
    return $c48a0afd06479119$export$809b0b82a3f0b8b5.NO_MATCH;
    // acronym
    if ($c48a0afd06479119$var$getAcronym(testString).includes(stringToRank)) return $c48a0afd06479119$export$809b0b82a3f0b8b5.ACRONYM;
    // will return a number between rankings.MATCHES and
    // rankings.MATCHES + 1 depending  on how close of a match it is.
    return $c48a0afd06479119$var$getClosenessRanking(testString, stringToRank);
}
/**
 * Generates an acronym for a string.
 *
 * @param {String} string the string for which to produce the acronym
 * @returns {String} the acronym
 */ function $c48a0afd06479119$var$getAcronym(string) {
    let acronym = '';
    const wordsInString = string.split(' ');
    wordsInString.forEach((wordInString)=>{
        const splitByHyphenWords = wordInString.split('-');
        splitByHyphenWords.forEach((splitByHyphenWord)=>{
            acronym += splitByHyphenWord.substr(0, 1);
        });
    });
    return acronym;
}
/**
 * Returns a score based on how spread apart the
 * characters from the stringToRank are within the testString.
 * A number close to rankings.MATCHES represents a loose match. A number close
 * to rankings.MATCHES + 1 represents a tighter match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @returns {Number} the number between rankings.MATCHES and
 * rankings.MATCHES + 1 for how well stringToRank matches testString
 */ function $c48a0afd06479119$var$getClosenessRanking(testString, stringToRank) {
    let matchingInOrderCharCount = 0;
    let charNumber = 0;
    function findMatchingCharacter(matchChar, string, index) {
        for(let j = index, J = string.length; j < J; j++){
            const stringChar = string[j];
            if (stringChar === matchChar) {
                matchingInOrderCharCount += 1;
                return j + 1;
            }
        }
        return -1;
    }
    function getRanking(spread) {
        const spreadPercentage = 1 / spread;
        const inOrderPercentage = matchingInOrderCharCount / stringToRank.length;
        const ranking = $c48a0afd06479119$export$809b0b82a3f0b8b5.MATCHES + inOrderPercentage * spreadPercentage;
        return ranking;
    }
    const firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);
    if (firstIndex < 0) return $c48a0afd06479119$export$809b0b82a3f0b8b5.NO_MATCH;
    charNumber = firstIndex;
    for(let i = 1, I = stringToRank.length; i < I; i++){
        const matchChar = stringToRank[i];
        charNumber = findMatchingCharacter(matchChar, testString, charNumber);
        const found = charNumber > -1;
        if (!found) return $c48a0afd06479119$export$809b0b82a3f0b8b5.NO_MATCH;
    }
    const spread = charNumber - firstIndex;
    return getRanking(spread);
}
/**
 * Sorts items that have a rank, index, and accessorIndex
 * @param {Object} a - the first item to sort
 * @param {Object} b - the second item to sort
 * @return {Number} -1 if a should come first, 1 if b should come first, 0 if equal
 */ function $c48a0afd06479119$export$b0c6b3a142decb5a(a, b) {
    return a.rank === b.rank ? 0 : a.rank > b.rank ? -1 : 1;
}
/**
 * Prepares value for comparison by stringifying it, removing diacritics (if specified)
 * @param {String} value - the value to clean
 * @param {Object} options - {keepDiacritics: whether to remove diacritics}
 * @return {String} the prepared value
 */ function $c48a0afd06479119$var$prepareValueForComparison(value, _ref) {
    let { keepDiacritics: keepDiacritics } = _ref;
    // value might not actually be a string at this point (we don't get to choose)
    // so part of preparing the value for comparison is ensure that it is a string
    value = `${value}`; // toString
    if (!keepDiacritics) value = $c48a0afd06479119$var$removeAccents(value);
    return value;
}
/**
 * Gets value for key in item at arbitrarily nested keypath
 * @param {Object} item - the item
 * @param {Object|Function} key - the potentially nested keypath or property callback
 * @return {Array} - an array containing the value(s) at the nested keypath
 */ function $c48a0afd06479119$var$getItemValues(item, accessor) {
    let accessorFn = accessor;
    if (typeof accessor === 'object') accessorFn = accessor.accessor;
    const value = accessorFn(item);
    // because `value` can also be undefined
    if (value == null) return [];
    if (Array.isArray(value)) return value;
    return [
        String(value)
    ];
}
/**
 * Gets all the values for the given keys in the given item and returns an array of those values
 * @param item - the item from which the values will be retrieved
 * @param keys - the keys to use to retrieve the values
 * @return objects with {itemValue, attributes}
 */ function $c48a0afd06479119$var$getAllValuesToRank(item, accessors) {
    const allValues = [];
    for(let j = 0, J = accessors.length; j < J; j++){
        const accessor = accessors[j];
        const attributes = $c48a0afd06479119$var$getAccessorAttributes(accessor);
        const itemValues = $c48a0afd06479119$var$getItemValues(item, accessor);
        for(let i = 0, I = itemValues.length; i < I; i++)allValues.push({
            itemValue: itemValues[i],
            attributes: attributes
        });
    }
    return allValues;
}
const $c48a0afd06479119$var$defaultKeyAttributes = {
    maxRanking: Infinity,
    minRanking: -Infinity
};
/**
 * Gets all the attributes for the given accessor
 * @param accessor - the accessor from which the attributes will be retrieved
 * @return object containing the accessor's attributes
 */ function $c48a0afd06479119$var$getAccessorAttributes(accessor) {
    if (typeof accessor === 'function') return $c48a0afd06479119$var$defaultKeyAttributes;
    return {
        ...$c48a0afd06479119$var$defaultKeyAttributes,
        ...accessor
    };
}



var $1SAXO = parcelRequire("1SAXO");

var $1qS3u = parcelRequire("1qS3u");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $bb6d55b5db31c7f7$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $1qS3u.default)(value, min, max);
}
function $bb6d55b5db31c7f7$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $bb6d55b5db31c7f7$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $bb6d55b5db31c7f7$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $bb6d55b5db31c7f7$export$677b39864803984e($bb6d55b5db31c7f7$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $1SAXO.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $1SAXO.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $bb6d55b5db31c7f7$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $bb6d55b5db31c7f7$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $bb6d55b5db31c7f7$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $bb6d55b5db31c7f7$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $bb6d55b5db31c7f7$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $bb6d55b5db31c7f7$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $bb6d55b5db31c7f7$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$bb6d55b5db31c7f7$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $bb6d55b5db31c7f7$export$29fb7152bd3f781a(color) {
    color = $bb6d55b5db31c7f7$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $bb6d55b5db31c7f7$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $bb6d55b5db31c7f7$export$c852d90bf7403b62(color) {
    color = $bb6d55b5db31c7f7$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $bb6d55b5db31c7f7$export$677b39864803984e($bb6d55b5db31c7f7$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $bb6d55b5db31c7f7$export$d061e26956a60b0a(foreground, background) {
    const lumA = $bb6d55b5db31c7f7$export$c852d90bf7403b62(foreground);
    const lumB = $bb6d55b5db31c7f7$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $bb6d55b5db31c7f7$export$58f0f39f63f3cf42(color, value) {
    color = $bb6d55b5db31c7f7$export$677b39864803984e(color);
    value = $bb6d55b5db31c7f7$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $bb6d55b5db31c7f7$export$211a73f2b8c10ce4(color);
}
function $bb6d55b5db31c7f7$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $bb6d55b5db31c7f7$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $bb6d55b5db31c7f7$export$4b073707ff63303(color, coefficient) {
    color = $bb6d55b5db31c7f7$export$677b39864803984e(color);
    coefficient = $bb6d55b5db31c7f7$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $bb6d55b5db31c7f7$export$211a73f2b8c10ce4(color);
}
function $bb6d55b5db31c7f7$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $bb6d55b5db31c7f7$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $bb6d55b5db31c7f7$export$c0816ed86df316af(color, coefficient) {
    color = $bb6d55b5db31c7f7$export$677b39864803984e(color);
    coefficient = $bb6d55b5db31c7f7$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $bb6d55b5db31c7f7$export$211a73f2b8c10ce4(color);
}
function $bb6d55b5db31c7f7$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $bb6d55b5db31c7f7$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $bb6d55b5db31c7f7$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $bb6d55b5db31c7f7$export$c852d90bf7403b62(color) > 0.5 ? $bb6d55b5db31c7f7$export$4b073707ff63303(color, coefficient) : $bb6d55b5db31c7f7$export$c0816ed86df316af(color, coefficient);
}
function $bb6d55b5db31c7f7$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $bb6d55b5db31c7f7$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $bb6d55b5db31c7f7$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $bb6d55b5db31c7f7$export$677b39864803984e(background);
    const overlayColor = $bb6d55b5db31c7f7$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $bb6d55b5db31c7f7$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


var $360b945a377b2693$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($360b945a377b2693$exports, "__esModule", {
    value: true
});
$360b945a377b2693$exports.default = void 0;

var $360b945a377b2693$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $360b945a377b2693$var$_default = $360b945a377b2693$exports.default = (0, $360b945a377b2693$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z"
}), 'ArrowDownward');


var $ac96b5c7f6335d4d$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($ac96b5c7f6335d4d$exports, "__esModule", {
    value: true
});
$ac96b5c7f6335d4d$exports.default = void 0;

var $ac96b5c7f6335d4d$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $ac96b5c7f6335d4d$var$_default = $ac96b5c7f6335d4d$exports.default = (0, $ac96b5c7f6335d4d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "m10 17 5-5-5-5z"
}), 'ArrowRight');


var $4d4c13816d1d34ff$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($4d4c13816d1d34ff$exports, "__esModule", {
    value: true
});
$4d4c13816d1d34ff$exports.default = void 0;

var $4d4c13816d1d34ff$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $4d4c13816d1d34ff$var$_default = $4d4c13816d1d34ff$exports.default = (0, $4d4c13816d1d34ff$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Cancel');


var $1ed6d9bfed453ee5$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($1ed6d9bfed453ee5$exports, "__esModule", {
    value: true
});
$1ed6d9bfed453ee5$exports.default = void 0;

var $1ed6d9bfed453ee5$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $1ed6d9bfed453ee5$var$_default = $1ed6d9bfed453ee5$exports.default = (0, $1ed6d9bfed453ee5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M5 13h14v-2H5zm-2 4h14v-2H3zM7 7v2h14V7z"
}), 'ClearAll');



var $6849aa5219f1cc2d$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($6849aa5219f1cc2d$exports, "__esModule", {
    value: true
});
$6849aa5219f1cc2d$exports.default = void 0;

var $6849aa5219f1cc2d$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $6849aa5219f1cc2d$var$_default = $6849aa5219f1cc2d$exports.default = (0, $6849aa5219f1cc2d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M3 3h18v2H3zm0 16h18v2H3z"
}), 'DensityLarge');


var $92401a7502845fad$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($92401a7502845fad$exports, "__esModule", {
    value: true
});
$92401a7502845fad$exports.default = void 0;

var $92401a7502845fad$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $92401a7502845fad$var$_default = $92401a7502845fad$exports.default = (0, $92401a7502845fad$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M3 3h18v2H3zm0 16h18v2H3zm0-8h18v2H3z"
}), 'DensityMedium');


var $42478d5474d3e7b2$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($42478d5474d3e7b2$exports, "__esModule", {
    value: true
});
$42478d5474d3e7b2$exports.default = void 0;

var $42478d5474d3e7b2$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $42478d5474d3e7b2$var$_default = $42478d5474d3e7b2$exports.default = (0, $42478d5474d3e7b2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M3 2h18v2H3zm0 18h18v2H3zm0-6h18v2H3zm0-6h18v2H3z"
}), 'DensitySmall');


var $52ecdc291bd78787$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($52ecdc291bd78787$exports, "__esModule", {
    value: true
});
$52ecdc291bd78787$exports.default = void 0;

var $52ecdc291bd78787$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $52ecdc291bd78787$var$_default = $52ecdc291bd78787$exports.default = (0, $52ecdc291bd78787$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M20 9H4v2h16zM4 15h16v-2H4z"
}), 'DragHandle');


var $6233d432df560262$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($6233d432df560262$exports, "__esModule", {
    value: true
});
$6233d432df560262$exports.default = void 0;

var $6233d432df560262$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $6233d432df560262$var$_default = $6233d432df560262$exports.default = (0, $6233d432df560262$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
        d: "M8 8H6v7c0 1.1.9 2 2 2h9v-2H8z"
    }, "0"),
    /*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
        d: "M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 8h-8V7h8zM4 12H2v7c0 1.1.9 2 2 2h9v-2H4z"
    }, "1")
], 'DynamicFeed');


var $da94f4c5a02c6653$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($da94f4c5a02c6653$exports, "__esModule", {
    value: true
});
$da94f4c5a02c6653$exports.default = void 0;

var $da94f4c5a02c6653$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $da94f4c5a02c6653$var$_default = $da94f4c5a02c6653$exports.default = (0, $da94f4c5a02c6653$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');


var $38a631335a5e3e4d$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($38a631335a5e3e4d$exports, "__esModule", {
    value: true
});
$38a631335a5e3e4d$exports.default = void 0;

var $38a631335a5e3e4d$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $38a631335a5e3e4d$var$_default = $38a631335a5e3e4d$exports.default = (0, $38a631335a5e3e4d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');


var $20cfda2d8034ba61$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($20cfda2d8034ba61$exports, "__esModule", {
    value: true
});
$20cfda2d8034ba61$exports.default = void 0;

var $20cfda2d8034ba61$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $20cfda2d8034ba61$var$_default = $20cfda2d8034ba61$exports.default = (0, $20cfda2d8034ba61$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61"
}), 'FilterAlt');


var $904710f7e231e15a$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($904710f7e231e15a$exports, "__esModule", {
    value: true
});
$904710f7e231e15a$exports.default = void 0;

var $904710f7e231e15a$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $904710f7e231e15a$var$_default = $904710f7e231e15a$exports.default = (0, $904710f7e231e15a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M10 18h4v-2h-4zM3 6v2h18V6zm3 7h12v-2H6z"
}), 'FilterList');


var $8c2d7c2cbd278ba9$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($8c2d7c2cbd278ba9$exports, "__esModule", {
    value: true
});
$8c2d7c2cbd278ba9$exports.default = void 0;

var $8c2d7c2cbd278ba9$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $8c2d7c2cbd278ba9$var$_default = $8c2d7c2cbd278ba9$exports.default = (0, $8c2d7c2cbd278ba9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M10.83 8H21V6H8.83zm5 5H18v-2h-4.17zM14 16.83V18h-4v-2h3.17l-3-3H6v-2h2.17l-3-3H3V6h.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41z"
}), 'FilterListOff');


var $393558b0ba6f17f2$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($393558b0ba6f17f2$exports, "__esModule", {
    value: true
});
$393558b0ba6f17f2$exports.default = void 0;

var $393558b0ba6f17f2$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $393558b0ba6f17f2$var$_default = $393558b0ba6f17f2$exports.default = (0, $393558b0ba6f17f2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"
}), 'FullscreenExit');


var $197c206fdf9ce5b9$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($197c206fdf9ce5b9$exports, "__esModule", {
    value: true
});
$197c206fdf9ce5b9$exports.default = void 0;

var $197c206fdf9ce5b9$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $197c206fdf9ce5b9$var$_default = $197c206fdf9ce5b9$exports.default = (0, $197c206fdf9ce5b9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M7 14H5v5h5v-2H7zm-2-4h2V7h3V5H5zm12 7h-3v2h5v-5h-2zM14 5v2h3v3h2V5z"
}), 'Fullscreen');


var $562a6e41336f6c14$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($562a6e41336f6c14$exports, "__esModule", {
    value: true
});
$562a6e41336f6c14$exports.default = void 0;

var $562a6e41336f6c14$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $562a6e41336f6c14$var$_default = $562a6e41336f6c14$exports.default = (0, $562a6e41336f6c14$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
        d: "M18 6.41 16.59 5 12 9.58 7.41 5 6 6.41l6 6z"
    }, "0"),
    /*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
        d: "m18 13-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"
    }, "1")
], 'KeyboardDoubleArrowDown');


var $8a9dbc61eb72bd89$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($8a9dbc61eb72bd89$exports, "__esModule", {
    value: true
});
$8a9dbc61eb72bd89$exports.default = void 0;

var $8a9dbc61eb72bd89$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $8a9dbc61eb72bd89$var$_default = $8a9dbc61eb72bd89$exports.default = (0, $8a9dbc61eb72bd89$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'MoreHoriz');


var $2a3745f754b07b9d$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($2a3745f754b07b9d$exports, "__esModule", {
    value: true
});
$2a3745f754b07b9d$exports.default = void 0;

var $2a3745f754b07b9d$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $2a3745f754b07b9d$var$_default = $2a3745f754b07b9d$exports.default = (0, $2a3745f754b07b9d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'MoreVert');


var $f33540c66946258e$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($f33540c66946258e$exports, "__esModule", {
    value: true
});
$f33540c66946258e$exports.default = void 0;

var $f33540c66946258e$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $f33540c66946258e$var$_default = $f33540c66946258e$exports.default = (0, $f33540c66946258e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    fillRule: "evenodd",
    d: "M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3"
}), 'PushPin');


var $c7559abc67ce699c$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($c7559abc67ce699c$exports, "__esModule", {
    value: true
});
$c7559abc67ce699c$exports.default = void 0;

var $c7559abc67ce699c$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $c7559abc67ce699c$var$_default = $c7559abc67ce699c$exports.default = (0, $c7559abc67ce699c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M12 5V2L8 6l4 4V7c3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93 0-4.42-3.58-8-8-8m-6 8c0-1.65.67-3.15 1.76-4.24L6.34 7.34C4.9 8.79 4 10.79 4 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91"
}), 'RestartAlt');


var $37e0d9ec460a6a3e$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($37e0d9ec460a6a3e$exports, "__esModule", {
    value: true
});
$37e0d9ec460a6a3e$exports.default = void 0;

var $37e0d9ec460a6a3e$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $37e0d9ec460a6a3e$var$_default = $37e0d9ec460a6a3e$exports.default = (0, $37e0d9ec460a6a3e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3-10H5V5h10z"
}), 'Save');


var $cd8e186c945e01b2$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($cd8e186c945e01b2$exports, "__esModule", {
    value: true
});
$cd8e186c945e01b2$exports.default = void 0;

var $cd8e186c945e01b2$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $cd8e186c945e01b2$var$_default = $cd8e186c945e01b2$exports.default = (0, $cd8e186c945e01b2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');


var $15bb2397189258c2$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($15bb2397189258c2$exports, "__esModule", {
    value: true
});
$15bb2397189258c2$exports.default = void 0;

var $15bb2397189258c2$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $15bb2397189258c2$var$_default = $15bb2397189258c2$exports.default = (0, $15bb2397189258c2$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3 6.08 3 3.28 5.64 3.03 9h2.02C5.3 6.75 7.18 5 9.5 5 11.99 5 14 7.01 14 9.5S11.99 14 9.5 14c-.17 0-.33-.03-.5-.05v2.02c.17.02.33.03.5.03 1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19z"
    }, "0"),
    /*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
        d: "M6.47 10.82 4 13.29l-2.47-2.47-.71.71L3.29 14 .82 16.47l.71.71L4 14.71l2.47 2.47.71-.71L4.71 14l2.47-2.47z"
    }, "1")
], 'SearchOff');


var $3212fd072e017778$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($3212fd072e017778$exports, "__esModule", {
    value: true
});
$3212fd072e017778$exports.default = void 0;

var $3212fd072e017778$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $3212fd072e017778$var$_default = $3212fd072e017778$exports.default = (0, $3212fd072e017778$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M3 18h6v-2H3zM3 6v2h18V6zm0 7h12v-2H3z"
}), 'Sort');


var $3a517130db63a3a4$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($3a517130db63a3a4$exports, "__esModule", {
    value: true
});
$3a517130db63a3a4$exports.default = void 0;

var $3a517130db63a3a4$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $3a517130db63a3a4$var$_default = $3a517130db63a3a4$exports.default = (0, $3a517130db63a3a4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M14.67 5v14H9.33V5zm1 14H21V5h-5.33zm-7.34 0V5H3v14z"
}), 'ViewColumn');


var $93de1ac22cf54d75$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($93de1ac22cf54d75$exports, "__esModule", {
    value: true
});
$93de1ac22cf54d75$exports.default = void 0;

var $93de1ac22cf54d75$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $93de1ac22cf54d75$var$_default = $93de1ac22cf54d75$exports.default = (0, $93de1ac22cf54d75$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), 'VisibilityOff');







var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");



var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $VEXgj = parcelRequire("VEXgj");


var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");
var $f2c77d3ea497802c$exports = {};
"use strict";
'use client';
Object.defineProperty($f2c77d3ea497802c$exports, "__esModule", {
    value: true
});
$f2c77d3ea497802c$exports.default = void 0;

var $f2c77d3ea497802c$var$React = $f2c77d3ea497802c$var$_interopRequireWildcard((parcelRequire("i5lfL")));
parcelRequire("d8Gg3");
var $5Vkbx = parcelRequire("5Vkbx");
function $f2c77d3ea497802c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($f2c77d3ea497802c$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $f2c77d3ea497802c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $f2c77d3ea497802c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $f2c77d3ea497802c$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $f2c77d3ea497802c$var$useTheme(defaultTheme = null) {
    const contextTheme = $f2c77d3ea497802c$var$React.useContext($5Vkbx.T);
    return !contextTheme || $f2c77d3ea497802c$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $f2c77d3ea497802c$var$_default = $f2c77d3ea497802c$exports.default = $f2c77d3ea497802c$var$useTheme;






var $i5lfL = parcelRequire("i5lfL");

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");

function $580b268a290beb65$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $80d68b4b97dd288a$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $580b268a290beb65$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $80d68b4b97dd288a$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $580b268a290beb65$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $80d68b4b97dd288a$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $580b268a290beb65$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $90e1750ecde8cbaf$export$8960430cfd85939f = Math.max;
var $90e1750ecde8cbaf$export$96ec731ed4dcb222 = Math.min;
var $90e1750ecde8cbaf$export$2077e0241d6afd3c = Math.round;



function $2bbe95c3b0b6058c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $06befd380de0db7a$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $2bbe95c3b0b6058c$export$2e2bcd8739ae039)());
}


function $c5dd0050bb9233df$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $80d68b4b97dd288a$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $90e1750ecde8cbaf$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $90e1750ecde8cbaf$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $80d68b4b97dd288a$export$45a5e7f76e0caa8d)(element) ? (0, $580b268a290beb65$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $06befd380de0db7a$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $0d46e644932ced95$export$2e2bcd8739ae039(node) {
    var win = (0, $580b268a290beb65$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $9754d81d7819b2d3$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $43b6c7bbf6ade005$export$2e2bcd8739ae039(node) {
    if (node === (0, $580b268a290beb65$export$2e2bcd8739ae039)(node) || !(0, $80d68b4b97dd288a$export$1b3bfaa9684536aa)(node)) return (0, $0d46e644932ced95$export$2e2bcd8739ae039)(node);
    else return (0, $9754d81d7819b2d3$export$2e2bcd8739ae039)(node);
}


function $6e52ad9531d70016$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $84c6cb76c6ceaef7$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $80d68b4b97dd288a$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e50a361993699bab$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $c5dd0050bb9233df$export$2e2bcd8739ae039)((0, $84c6cb76c6ceaef7$export$2e2bcd8739ae039)(element)).left + (0, $0d46e644932ced95$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $9a151c691d24ce84$export$2e2bcd8739ae039(element) {
    return (0, $580b268a290beb65$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $a6777c5adce16f81$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $9a151c691d24ce84$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $9162e680a0b13405$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $90e1750ecde8cbaf$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $90e1750ecde8cbaf$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $9162e680a0b13405$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $80d68b4b97dd288a$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $80d68b4b97dd288a$export$1b3bfaa9684536aa)(offsetParent) && $9162e680a0b13405$var$isElementScaled(offsetParent);
    var documentElement = (0, $84c6cb76c6ceaef7$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $c5dd0050bb9233df$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6e52ad9531d70016$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $a6777c5adce16f81$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $43b6c7bbf6ade005$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $80d68b4b97dd288a$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $c5dd0050bb9233df$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e50a361993699bab$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $c1b1fc7aa02ba622$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $c5dd0050bb9233df$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $6764b91ed37c3bbe$export$2e2bcd8739ae039(element) {
    if ((0, $6e52ad9531d70016$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $80d68b4b97dd288a$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $84c6cb76c6ceaef7$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $bc3cdd9e31ea7ca6$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $6e52ad9531d70016$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $80d68b4b97dd288a$export$1b3bfaa9684536aa)(node) && (0, $a6777c5adce16f81$export$2e2bcd8739ae039)(node)) return node;
    return $bc3cdd9e31ea7ca6$export$2e2bcd8739ae039((0, $6764b91ed37c3bbe$export$2e2bcd8739ae039)(node));
}





function $e772e11ca89f40f0$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $bc3cdd9e31ea7ca6$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $580b268a290beb65$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $a6777c5adce16f81$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($e772e11ca89f40f0$export$2e2bcd8739ae039((0, $6764b91ed37c3bbe$export$2e2bcd8739ae039)(target)));
}







function $843bc6d4e0e5e6dd$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $6e52ad9531d70016$export$2e2bcd8739ae039)(element)) >= 0;
}




function $9a8d8ed7c2669a0b$var$getTrueOffsetParent(element) {
    if (!(0, $80d68b4b97dd288a$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $9a151c691d24ce84$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $9a8d8ed7c2669a0b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $2bbe95c3b0b6058c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $2bbe95c3b0b6058c$export$2e2bcd8739ae039)());
    if (isIE && (0, $80d68b4b97dd288a$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $9a151c691d24ce84$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6764b91ed37c3bbe$export$2e2bcd8739ae039)(element);
    if ((0, $80d68b4b97dd288a$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $80d68b4b97dd288a$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $6e52ad9531d70016$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $9a151c691d24ce84$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $9a8d8ed7c2669a0b$export$2e2bcd8739ae039(element) {
    var window = (0, $580b268a290beb65$export$2e2bcd8739ae039)(element);
    var offsetParent = $9a8d8ed7c2669a0b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $843bc6d4e0e5e6dd$export$2e2bcd8739ae039)(offsetParent) && (0, $9a151c691d24ce84$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $9a8d8ed7c2669a0b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6e52ad9531d70016$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $6e52ad9531d70016$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $9a151c691d24ce84$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $9a8d8ed7c2669a0b$var$getContainingBlock(element) || window;
}


var $115ae90cf858c4c0$export$1e95b668f3b82d = 'top';
var $115ae90cf858c4c0$export$40e543e69a8b3fbb = 'bottom';
var $115ae90cf858c4c0$export$79ffe56a765070d2 = 'right';
var $115ae90cf858c4c0$export$eabcd2c8791e7bf4 = 'left';
var $115ae90cf858c4c0$export$dfb5619354ba860 = 'auto';
var $115ae90cf858c4c0$export$aec2ce47c367b8c3 = [
    $115ae90cf858c4c0$export$1e95b668f3b82d,
    $115ae90cf858c4c0$export$40e543e69a8b3fbb,
    $115ae90cf858c4c0$export$79ffe56a765070d2,
    $115ae90cf858c4c0$export$eabcd2c8791e7bf4
];
var $115ae90cf858c4c0$export$b3571188c770cc5a = 'start';
var $115ae90cf858c4c0$export$bd5df0f255a350f8 = 'end';
var $115ae90cf858c4c0$export$390fd549c5303b4d = 'clippingParents';
var $115ae90cf858c4c0$export$d7b7311ec04a3e8f = 'viewport';
var $115ae90cf858c4c0$export$ae5ab1c730825774 = 'popper';
var $115ae90cf858c4c0$export$ca50aac9f3ba507f = 'reference';
var $115ae90cf858c4c0$export$368f9a87e87fa4e1 = /*#__PURE__*/ $115ae90cf858c4c0$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $115ae90cf858c4c0$export$b3571188c770cc5a,
        placement + "-" + $115ae90cf858c4c0$export$bd5df0f255a350f8
    ]);
}, []);
var $115ae90cf858c4c0$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($115ae90cf858c4c0$export$aec2ce47c367b8c3, [
    $115ae90cf858c4c0$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $115ae90cf858c4c0$export$b3571188c770cc5a,
        placement + "-" + $115ae90cf858c4c0$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $115ae90cf858c4c0$export$421679a7c3d56e = 'beforeRead';
var $115ae90cf858c4c0$export$aafa59e2e03f2942 = 'read';
var $115ae90cf858c4c0$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $115ae90cf858c4c0$export$c65e99957a05207c = 'beforeMain';
var $115ae90cf858c4c0$export$f22da7240b7add18 = 'main';
var $115ae90cf858c4c0$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $115ae90cf858c4c0$export$8d4d2d70e7d46032 = 'beforeWrite';
var $115ae90cf858c4c0$export$68d8715fc104d294 = 'write';
var $115ae90cf858c4c0$export$70a6e5159acce2e6 = 'afterWrite';
var $115ae90cf858c4c0$export$d087d3878fdf71d5 = [
    $115ae90cf858c4c0$export$421679a7c3d56e,
    $115ae90cf858c4c0$export$aafa59e2e03f2942,
    $115ae90cf858c4c0$export$6964f6c886723980,
    $115ae90cf858c4c0$export$c65e99957a05207c,
    $115ae90cf858c4c0$export$f22da7240b7add18,
    $115ae90cf858c4c0$export$bab79516f2d662fe,
    $115ae90cf858c4c0$export$8d4d2d70e7d46032,
    $115ae90cf858c4c0$export$68d8715fc104d294,
    $115ae90cf858c4c0$export$70a6e5159acce2e6
];


function $07b8d7e64ac9edd8$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $07b8d7e64ac9edd8$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $07b8d7e64ac9edd8$var$order(modifiers); // order based on phase
    return (0, $115ae90cf858c4c0$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $91690d803178c6d9$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $46a43ac8b90788b4$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $0698c72db475e039$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $0698c72db475e039$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $0698c72db475e039$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $0698c72db475e039$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $0698c72db475e039$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $80d68b4b97dd288a$export$45a5e7f76e0caa8d)(reference) ? (0, $e772e11ca89f40f0$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $e772e11ca89f40f0$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $e772e11ca89f40f0$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $07b8d7e64ac9edd8$export$2e2bcd8739ae039)((0, $46a43ac8b90788b4$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$0698c72db475e039$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $9162e680a0b13405$export$2e2bcd8739ae039)(reference, (0, $9a8d8ed7c2669a0b$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $c1b1fc7aa02ba622$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $91690d803178c6d9$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$0698c72db475e039$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $0698c72db475e039$export$8f7491d57c8f97a9 = /*#__PURE__*/ $0698c72db475e039$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $1913286924aac509$var$passive = {
    passive: true
};
function $1913286924aac509$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $580b268a290beb65$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1913286924aac509$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1913286924aac509$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1913286924aac509$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1913286924aac509$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1913286924aac509$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1913286924aac509$var$effect,
    data: {}
};



function $8dec7f17aaddc2be$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $a38e39707ae6e52f$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $2c8d76f03c0145b4$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $5bc382f779acee34$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $8dec7f17aaddc2be$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $a38e39707ae6e52f$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $115ae90cf858c4c0$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $115ae90cf858c4c0$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $115ae90cf858c4c0$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $2c8d76f03c0145b4$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $115ae90cf858c4c0$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $115ae90cf858c4c0$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $81402a27f9452b65$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5bc382f779acee34$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $81402a27f9452b65$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $81402a27f9452b65$var$popperOffsets,
    data: {}
};










var $c19bc276a063e7e7$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c19bc276a063e7e7$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $90e1750ecde8cbaf$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $90e1750ecde8cbaf$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c19bc276a063e7e7$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4);
    var sideY = (0, $115ae90cf858c4c0$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $9a8d8ed7c2669a0b$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $580b268a290beb65$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $84c6cb76c6ceaef7$export$2e2bcd8739ae039)(popper);
            if ((0, $9a151c691d24ce84$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $115ae90cf858c4c0$export$1e95b668f3b82d) || (placement === (0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4) || placement === (0, $115ae90cf858c4c0$export$79ffe56a765070d2)) && variation === (0, $115ae90cf858c4c0$export$bd5df0f255a350f8)) {
            sideY = (0, $115ae90cf858c4c0$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4) || (placement === (0, $115ae90cf858c4c0$export$1e95b668f3b82d) || placement === (0, $115ae90cf858c4c0$export$40e543e69a8b3fbb)) && variation === (0, $115ae90cf858c4c0$export$bd5df0f255a350f8)) {
            sideX = (0, $115ae90cf858c4c0$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c19bc276a063e7e7$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c19bc276a063e7e7$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $580b268a290beb65$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $c19bc276a063e7e7$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $8dec7f17aaddc2be$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $a38e39707ae6e52f$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c19bc276a063e7e7$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c19bc276a063e7e7$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c19bc276a063e7e7$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $c19bc276a063e7e7$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $aaf4fdb8a553cec4$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $80d68b4b97dd288a$export$1b3bfaa9684536aa)(element) || !(0, $6e52ad9531d70016$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $aaf4fdb8a553cec4$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $80d68b4b97dd288a$export$1b3bfaa9684536aa)(element) || !(0, $6e52ad9531d70016$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $aaf4fdb8a553cec4$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $aaf4fdb8a553cec4$var$applyStyles,
    effect: $aaf4fdb8a553cec4$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $ce2722dd736a45c5$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $8dec7f17aaddc2be$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4),
        (0, $115ae90cf858c4c0$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4),
        (0, $115ae90cf858c4c0$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ce2722dd736a45c5$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $115ae90cf858c4c0$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ce2722dd736a45c5$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ce2722dd736a45c5$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ce2722dd736a45c5$var$offset
};


var $54de92340f57eb04$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $54de92340f57eb04$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $54de92340f57eb04$var$hash[matched];
    });
}



var $83ef65171548603f$var$hash = {
    start: 'end',
    end: 'start'
};
function $83ef65171548603f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $83ef65171548603f$var$hash[matched];
    });
}







function $f0d7540b9f7dcb6c$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $580b268a290beb65$export$2e2bcd8739ae039)(element);
    var html = (0, $84c6cb76c6ceaef7$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $06befd380de0db7a$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e50a361993699bab$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $73f32f84fe6f11be$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $84c6cb76c6ceaef7$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0d46e644932ced95$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $90e1750ecde8cbaf$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $90e1750ecde8cbaf$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e50a361993699bab$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $9a151c691d24ce84$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $90e1750ecde8cbaf$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $aa3c7fe1c79a12ca$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $80d68b4b97dd288a$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $c7075ed9a0d17af6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $69a96951b9ac41d9$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $c5dd0050bb9233df$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $69a96951b9ac41d9$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $115ae90cf858c4c0$export$d7b7311ec04a3e8f) ? (0, $c7075ed9a0d17af6$export$2e2bcd8739ae039)((0, $f0d7540b9f7dcb6c$export$2e2bcd8739ae039)(element, strategy)) : (0, $80d68b4b97dd288a$export$45a5e7f76e0caa8d)(clippingParent) ? $69a96951b9ac41d9$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $c7075ed9a0d17af6$export$2e2bcd8739ae039)((0, $73f32f84fe6f11be$export$2e2bcd8739ae039)((0, $84c6cb76c6ceaef7$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $69a96951b9ac41d9$var$getClippingParents(element) {
    var clippingParents = (0, $e772e11ca89f40f0$export$2e2bcd8739ae039)((0, $6764b91ed37c3bbe$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $9a151c691d24ce84$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $80d68b4b97dd288a$export$1b3bfaa9684536aa)(element) ? (0, $9a8d8ed7c2669a0b$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $80d68b4b97dd288a$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $80d68b4b97dd288a$export$45a5e7f76e0caa8d)(clippingParent) && (0, $aa3c7fe1c79a12ca$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $6e52ad9531d70016$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $69a96951b9ac41d9$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $69a96951b9ac41d9$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $69a96951b9ac41d9$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $90e1750ecde8cbaf$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $90e1750ecde8cbaf$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $90e1750ecde8cbaf$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $90e1750ecde8cbaf$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $69a96951b9ac41d9$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $7b169c9360dfdfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $d5de218cd9ea22d6$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $7b169c9360dfdfe5$export$2e2bcd8739ae039)(), paddingObject);
}


function $89c668f13f28a8b6$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $8313627ee5d2c2b2$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $115ae90cf858c4c0$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $115ae90cf858c4c0$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $115ae90cf858c4c0$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $d5de218cd9ea22d6$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $89c668f13f28a8b6$export$2e2bcd8739ae039)(padding, (0, $115ae90cf858c4c0$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $115ae90cf858c4c0$export$ae5ab1c730825774) ? (0, $115ae90cf858c4c0$export$ca50aac9f3ba507f) : (0, $115ae90cf858c4c0$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $69a96951b9ac41d9$export$2e2bcd8739ae039)((0, $80d68b4b97dd288a$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $84c6cb76c6ceaef7$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $c5dd0050bb9233df$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $5bc382f779acee34$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $c7075ed9a0d17af6$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $115ae90cf858c4c0$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $115ae90cf858c4c0$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $115ae90cf858c4c0$export$79ffe56a765070d2),
                (0, $115ae90cf858c4c0$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $115ae90cf858c4c0$export$1e95b668f3b82d),
                (0, $115ae90cf858c4c0$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $3bbed438d4eeb287$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $115ae90cf858c4c0$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $a38e39707ae6e52f$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $115ae90cf858c4c0$export$368f9a87e87fa4e1) : (0, $115ae90cf858c4c0$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $a38e39707ae6e52f$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $115ae90cf858c4c0$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $8313627ee5d2c2b2$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $8dec7f17aaddc2be$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $805d901fd43f1d2c$var$getExpandedFallbackPlacements(placement) {
    if ((0, $8dec7f17aaddc2be$export$2e2bcd8739ae039)(placement) === (0, $115ae90cf858c4c0$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $54de92340f57eb04$export$2e2bcd8739ae039)(placement);
    return [
        (0, $83ef65171548603f$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $83ef65171548603f$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $805d901fd43f1d2c$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $8dec7f17aaddc2be$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $54de92340f57eb04$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $805d901fd43f1d2c$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $8dec7f17aaddc2be$export$2e2bcd8739ae039)(placement) === (0, $115ae90cf858c4c0$export$dfb5619354ba860) ? (0, $3bbed438d4eeb287$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $8dec7f17aaddc2be$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $a38e39707ae6e52f$export$2e2bcd8739ae039)(placement) === (0, $115ae90cf858c4c0$export$b3571188c770cc5a);
        var isVertical = [
            (0, $115ae90cf858c4c0$export$1e95b668f3b82d),
            (0, $115ae90cf858c4c0$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $8313627ee5d2c2b2$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $115ae90cf858c4c0$export$79ffe56a765070d2) : (0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $115ae90cf858c4c0$export$40e543e69a8b3fbb) : (0, $115ae90cf858c4c0$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $54de92340f57eb04$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $54de92340f57eb04$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $805d901fd43f1d2c$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $805d901fd43f1d2c$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $39a2193deede9b18$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $1d9ecb0ecd01da04$export$f28d906d67a997f3(min, value, max) {
    return (0, $90e1750ecde8cbaf$export$8960430cfd85939f)(min, (0, $90e1750ecde8cbaf$export$96ec731ed4dcb222)(value, max));
}
function $1d9ecb0ecd01da04$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $1d9ecb0ecd01da04$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $4a6dc8cbc8ffb722$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $8313627ee5d2c2b2$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $8dec7f17aaddc2be$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $a38e39707ae6e52f$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $2c8d76f03c0145b4$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $39a2193deede9b18$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $115ae90cf858c4c0$export$1e95b668f3b82d) : (0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $115ae90cf858c4c0$export$40e543e69a8b3fbb) : (0, $115ae90cf858c4c0$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $115ae90cf858c4c0$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $115ae90cf858c4c0$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $c1b1fc7aa02ba622$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $7b169c9360dfdfe5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1d9ecb0ecd01da04$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $9a8d8ed7c2669a0b$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1d9ecb0ecd01da04$export$f28d906d67a997f3)(tether ? (0, $90e1750ecde8cbaf$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $90e1750ecde8cbaf$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $115ae90cf858c4c0$export$1e95b668f3b82d) : (0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $115ae90cf858c4c0$export$40e543e69a8b3fbb) : (0, $115ae90cf858c4c0$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $115ae90cf858c4c0$export$1e95b668f3b82d),
            (0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1d9ecb0ecd01da04$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $1d9ecb0ecd01da04$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4a6dc8cbc8ffb722$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4a6dc8cbc8ffb722$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $e60ca64ecc7cf32c$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $d5de218cd9ea22d6$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $89c668f13f28a8b6$export$2e2bcd8739ae039)(padding, (0, $115ae90cf858c4c0$export$aec2ce47c367b8c3)));
};
function $e60ca64ecc7cf32c$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $8dec7f17aaddc2be$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $2c8d76f03c0145b4$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4),
        (0, $115ae90cf858c4c0$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e60ca64ecc7cf32c$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $c1b1fc7aa02ba622$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $115ae90cf858c4c0$export$1e95b668f3b82d) : (0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $115ae90cf858c4c0$export$40e543e69a8b3fbb) : (0, $115ae90cf858c4c0$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $9a8d8ed7c2669a0b$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1d9ecb0ecd01da04$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e60ca64ecc7cf32c$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $aa3c7fe1c79a12ca$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e60ca64ecc7cf32c$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $e60ca64ecc7cf32c$var$arrow,
    effect: $e60ca64ecc7cf32c$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $e9d866601e9927fb$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $e9d866601e9927fb$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $115ae90cf858c4c0$export$1e95b668f3b82d),
        (0, $115ae90cf858c4c0$export$79ffe56a765070d2),
        (0, $115ae90cf858c4c0$export$40e543e69a8b3fbb),
        (0, $115ae90cf858c4c0$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $e9d866601e9927fb$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $8313627ee5d2c2b2$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $8313627ee5d2c2b2$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $e9d866601e9927fb$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $e9d866601e9927fb$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $e9d866601e9927fb$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $e9d866601e9927fb$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $e9d866601e9927fb$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $e9d866601e9927fb$var$hide
};




var $f2ddcd3d53cd9e6d$export$d34966752335dd47 = [
    (0, $1913286924aac509$export$2e2bcd8739ae039),
    (0, $81402a27f9452b65$export$2e2bcd8739ae039),
    (0, $c19bc276a063e7e7$export$2e2bcd8739ae039),
    (0, $aaf4fdb8a553cec4$export$2e2bcd8739ae039),
    (0, $ce2722dd736a45c5$export$2e2bcd8739ae039),
    (0, $805d901fd43f1d2c$export$2e2bcd8739ae039),
    (0, $4a6dc8cbc8ffb722$export$2e2bcd8739ae039),
    (0, $e60ca64ecc7cf32c$export$2e2bcd8739ae039),
    (0, $e9d866601e9927fb$export$2e2bcd8739ae039)
];
var $f2ddcd3d53cd9e6d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $0698c72db475e039$export$ed5e13716264f202)({
    defaultModifiers: $f2ddcd3d53cd9e6d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $2ktY3 = parcelRequire("2ktY3");



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $650e194f06b20ad1$export$1b69b6cd0fa638a1(slot) {
    return (0, $6bbZp.default)('MuiPopper', slot);
}
const $650e194f06b20ad1$var$popperClasses = (0, $47i1c.default)('MuiPopper', [
    'root'
]);
var $650e194f06b20ad1$export$2e2bcd8739ae039 = $650e194f06b20ad1$var$popperClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $e271b96e2721018e$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $e271b96e2721018e$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $e271b96e2721018e$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $e271b96e2721018e$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $e271b96e2721018e$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $e271b96e2721018e$var$isVirtualElement(element) {
    return !$e271b96e2721018e$var$isHTMLElement(element);
}
const $e271b96e2721018e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $650e194f06b20ad1$export$1b69b6cd0fa638a1), classes);
};
const $e271b96e2721018e$var$defaultPopperOptions = {};
const $e271b96e2721018e$var$PopperTooltip = /*#__PURE__*/ $i5lfL.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $7qXFD.default)(props, $e271b96e2721018e$var$_excluded);
    const tooltipRef = $i5lfL.useRef(null);
    const ownRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $i5lfL.useRef(null);
    const handlePopperRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $i5lfL.useRef(handlePopperRef);
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $i5lfL.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $e271b96e2721018e$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $i5lfL.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $i5lfL.useState($e271b96e2721018e$var$resolveAnchorEl(anchorEl));
    $i5lfL.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $i5lfL.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($e271b96e2721018e$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $f2ddcd3d53cd9e6d$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $1CWiu.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $e271b96e2721018e$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsx)(Root, (0, $1CWiu.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $e271b96e2721018e$var$Popper = /*#__PURE__*/ $i5lfL.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $e271b96e2721018e$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $7qXFD.default)(props, $e271b96e2721018e$var$_excluded2);
    const [exited, setExited] = $i5lfL.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $e271b96e2721018e$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $e271b96e2721018e$var$isHTMLElement(resolvedAnchorEl) ? (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $4550da58a5c16130$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($e271b96e2721018e$var$PopperTooltip, (0, $1CWiu.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $1CWiu.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $e271b96e2721018e$export$2e2bcd8739ae039 = $e271b96e2721018e$var$Popper;



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $2a097690b61d558e$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $2a097690b61d558e$var$PopperRoot = (0, $j7y1Z.default)((0, $e271b96e2721018e$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $2a097690b61d558e$var$Popper = /*#__PURE__*/ $i5lfL.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($f2c77d3ea497802c$exports)))();
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $7qXFD.default)(props, $2a097690b61d558e$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $1CWiu.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($2a097690b61d558e$var$PopperRoot, (0, $1CWiu.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $2a097690b61d558e$export$2e2bcd8739ae039 = $2a097690b61d558e$var$Popper;





'use client';
var $f1c50420bced90af$export$2e2bcd8739ae039 = (0, $f3f83812f7a42248$export$2e2bcd8739ae039);





var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $83c635c22b7e9d3a$export$837848f5f6cee923(slot) {
    return (0, $6bbZp.default)('MuiTooltip', slot);
}
const $83c635c22b7e9d3a$var$tooltipClasses = (0, $47i1c.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $83c635c22b7e9d3a$export$2e2bcd8739ae039 = $83c635c22b7e9d3a$var$tooltipClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $1b3e290cec22a366$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $1b3e290cec22a366$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $1b3e290cec22a366$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $VEXgj.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $83c635c22b7e9d3a$export$837848f5f6cee923), classes);
};
const $1b3e290cec22a366$var$TooltipPopper = (0, $j7y1Z.default)((0, $2a097690b61d558e$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $1CWiu.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $83c635c22b7e9d3a$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $83c635c22b7e9d3a$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $83c635c22b7e9d3a$export$2e2bcd8739ae039).arrow}`]: (0, $1CWiu.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $83c635c22b7e9d3a$export$2e2bcd8739ae039).arrow}`]: (0, $1CWiu.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $1b3e290cec22a366$var$TooltipTooltip = (0, $j7y1Z.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $VEXgj.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $8AHNG.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$1b3e290cec22a366$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $83c635c22b7e9d3a$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $1CWiu.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $1CWiu.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $1CWiu.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $83c635c22b7e9d3a$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $1CWiu.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $1CWiu.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $1CWiu.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $83c635c22b7e9d3a$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $1CWiu.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $83c635c22b7e9d3a$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $1CWiu.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $1b3e290cec22a366$var$TooltipArrow = (0, $j7y1Z.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $8AHNG.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $1b3e290cec22a366$var$hystersisOpen = false;
const $1b3e290cec22a366$var$hystersisTimer = new (0, $fa9c2cea1dcc0b6d$export$786b4da70f00938b)();
let $1b3e290cec22a366$var$cursorPosition = {
    x: 0,
    y: 0
};
function $1b3e290cec22a366$export$b9ee5a7ace0541f8() {
    $1b3e290cec22a366$var$hystersisOpen = false;
    $1b3e290cec22a366$var$hystersisTimer.clear();
}
function $1b3e290cec22a366$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $1b3e290cec22a366$var$Tooltip = /*#__PURE__*/ $i5lfL.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $66de9c04029c8d70$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $7qXFD.default)(props, $1b3e290cec22a366$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $i5lfL.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const isRtl = (0, $dd848b3fb63e28ea$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $i5lfL.useState();
    const [arrowRef, setArrowRef] = $i5lfL.useState(null);
    const ignoreNonTouchEvents = $i5lfL.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $fa9c2cea1dcc0b6d$export$2e2bcd8739ae039)();
    const enterTimer = (0, $fa9c2cea1dcc0b6d$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $fa9c2cea1dcc0b6d$export$2e2bcd8739ae039)();
    const touchTimer = (0, $fa9c2cea1dcc0b6d$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $84df25be484a0877$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $f1c50420bced90af$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $i5lfL.useRef();
    const stopTouchInteraction = (0, $91b1a2d3fafb0346$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $i5lfL.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $1b3e290cec22a366$var$hystersisTimer.clear();
        $1b3e290cec22a366$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $91b1a2d3fafb0346$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $1b3e290cec22a366$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $1b3e290cec22a366$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $1b3e290cec22a366$var$hystersisOpen && enterNextDelay) enterTimer.start($1b3e290cec22a366$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $f5d997b9d8ee988c$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $i5lfL.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $i5lfL.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $i5lfL.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $1b3e290cec22a366$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $1CWiu.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $kRbLW.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $1b3e290cec22a366$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $1b3e290cec22a366$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $1b3e290cec22a366$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $1b3e290cec22a366$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $i5lfL.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $1CWiu.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $1CWiu.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $1b3e290cec22a366$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $1b3e290cec22a366$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $66de9c04029c8d70$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $1b3e290cec22a366$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $1b3e290cec22a366$var$TooltipArrow;
    const popperProps = (0, $9140f0be1e87249a$export$2e2bcd8739ae039)(PopperComponent, (0, $1CWiu.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $kRbLW.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $9140f0be1e87249a$export$2e2bcd8739ae039)(TransitionComponent, (0, $1CWiu.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $9140f0be1e87249a$export$2e2bcd8739ae039)(TooltipComponent, (0, $1CWiu.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $kRbLW.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $9140f0be1e87249a$export$2e2bcd8739ae039)(ArrowComponent, (0, $1CWiu.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $kRbLW.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
        children: [
            /*#__PURE__*/ $i5lfL.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $bHJbJ.jsx)(PopperComponent, (0, $1CWiu.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $2a097690b61d558e$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $1b3e290cec22a366$var$cursorPosition.y,
                            left: $1b3e290cec22a366$var$cursorPosition.x,
                            right: $1b3e290cec22a366$var$cursorPosition.x,
                            bottom: $1b3e290cec22a366$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $bHJbJ.jsx)(TransitionComponent, (0, $1CWiu.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)(TooltipComponent, (0, $1CWiu.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $bHJbJ.jsx)(ArrowComponent, (0, $1CWiu.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $1b3e290cec22a366$export$2e2bcd8739ae039 = $1b3e290cec22a366$var$Tooltip;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $285566490a7f0efe$var$_excluded = [
    "className"
];
const $285566490a7f0efe$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $2df420ef9599b05a$export$81478e24460c57f2), classes);
};
const $285566490a7f0efe$var$ListItemIconRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $285566490a7f0efe$var$ListItemIcon = /*#__PURE__*/ $i5lfL.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className } = props, other = (0, $7qXFD.default)(props, $285566490a7f0efe$var$_excluded);
    const context = $i5lfL.useContext((0, $5f2cac3e7c0585d2$export$2e2bcd8739ae039));
    const ownerState = (0, $1CWiu.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $285566490a7f0efe$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($285566490a7f0efe$var$ListItemIconRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $285566490a7f0efe$export$2e2bcd8739ae039 = $285566490a7f0efe$var$ListItemIcon;






var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");


var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");


var $2ktY3 = parcelRequire("2ktY3");

var $VEXgj = parcelRequire("VEXgj");

var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");




var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $4938d5d051460d71$export$baa0faa0c7ad8085(slot) {
    return (0, $6bbZp.default)('PrivateSwitchBase', slot);
}
const $4938d5d051460d71$var$switchBaseClasses = (0, $47i1c.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $4938d5d051460d71$export$2e2bcd8739ae039 = $4938d5d051460d71$var$switchBaseClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $53d0c4ba2c30c501$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $53d0c4ba2c30c501$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $VEXgj.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $4938d5d051460d71$export$baa0faa0c7ad8085), classes);
};
const $53d0c4ba2c30c501$var$SwitchBaseRoot = (0, $j7y1Z.default)((0, $07a3ed667acb77f6$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $53d0c4ba2c30c501$var$SwitchBaseInput = (0, $j7y1Z.default)('input', {
    shouldForwardProp: (0, $1FZvT.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $53d0c4ba2c30c501$var$SwitchBase = /*#__PURE__*/ $i5lfL.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $7qXFD.default)(props, $53d0c4ba2c30c501$var$_excluded);
    const [checked, setCheckedState] = (0, $84df25be484a0877$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $01f467cf0a9ed9ad$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $1CWiu.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $53d0c4ba2c30c501$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($53d0c4ba2c30c501$var$SwitchBaseRoot, (0, $1CWiu.default)({
        component: "span",
        className: (0, $kRbLW.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)($53d0c4ba2c30c501$var$SwitchBaseInput, (0, $1CWiu.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $53d0c4ba2c30c501$export$2e2bcd8739ae039 = $53d0c4ba2c30c501$var$SwitchBase;


parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $ec8eaafaea4594e8$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $a44f1cdb9bbf7078$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $0950497d1fb892f2$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');



var $VEXgj = parcelRequire("VEXgj");

var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $ccf7eaac2f9b6097$export$6c57c6e16b4063b(slot) {
    return (0, $6bbZp.default)('MuiCheckbox', slot);
}
const $ccf7eaac2f9b6097$var$checkboxClasses = (0, $47i1c.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $ccf7eaac2f9b6097$export$2e2bcd8739ae039 = $ccf7eaac2f9b6097$var$checkboxClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $842f67eebadd25d0$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $842f67eebadd25d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $VEXgj.default)(color)}`,
            `size${(0, $VEXgj.default)(size)}`
        ]
    };
    const composedClasses = (0, $2ktY3.default)(slots, (0, $ccf7eaac2f9b6097$export$6c57c6e16b4063b), classes);
    return (0, $1CWiu.default)({}, classes, composedClasses);
};
const $842f67eebadd25d0$var$CheckboxRoot = (0, $j7y1Z.default)((0, $53d0c4ba2c30c501$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1FZvT.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $VEXgj.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $VEXgj.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8AHNG.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $ccf7eaac2f9b6097$export$2e2bcd8739ae039).checked}, &.${(0, $ccf7eaac2f9b6097$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $ccf7eaac2f9b6097$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $842f67eebadd25d0$var$defaultCheckedIcon = /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a44f1cdb9bbf7078$export$2e2bcd8739ae039), {});
const $842f67eebadd25d0$var$defaultIcon = /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $ec8eaafaea4594e8$export$2e2bcd8739ae039), {});
const $842f67eebadd25d0$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $0950497d1fb892f2$export$2e2bcd8739ae039), {});
const $842f67eebadd25d0$var$Checkbox = /*#__PURE__*/ $i5lfL.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $842f67eebadd25d0$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $842f67eebadd25d0$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $842f67eebadd25d0$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', className: className } = props, other = (0, $7qXFD.default)(props, $842f67eebadd25d0$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $842f67eebadd25d0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($842f67eebadd25d0$var$CheckboxRoot, (0, $1CWiu.default)({
        type: "checkbox",
        inputProps: (0, $1CWiu.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $i5lfL.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $i5lfL.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $kRbLW.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $842f67eebadd25d0$export$2e2bcd8739ae039 = $842f67eebadd25d0$var$Checkbox;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");


var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");


var $kp44S = parcelRequire("kp44S");

var $1CWiu = parcelRequire("1CWiu");
parcelRequire("i5lfL");

parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $1181198bdae98d10$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');


parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $6aff0ddea968bdaf$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');



var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $abd6016129710baf$var$RadioButtonIconRoot = (0, $j7y1Z.default)('span', {
    shouldForwardProp: (0, $1FZvT.default)
})({
    position: 'relative',
    display: 'flex'
});
const $abd6016129710baf$var$RadioButtonIconBackground = (0, $j7y1Z.default)((0, $1181198bdae98d10$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $abd6016129710baf$var$RadioButtonIconDot = (0, $j7y1Z.default)((0, $6aff0ddea968bdaf$export$2e2bcd8739ae039))(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $abd6016129710baf$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $1CWiu.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($abd6016129710baf$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)($abd6016129710baf$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)($abd6016129710baf$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $abd6016129710baf$export$2e2bcd8739ae039 = $abd6016129710baf$var$RadioButtonIcon;



var $VEXgj = parcelRequire("VEXgj");

var $3ed70eafd100ec90$export$2e2bcd8739ae039 = (0, $3621b9a955ea67a6$export$2e2bcd8739ae039);



var $i5lfL = parcelRequire("i5lfL");

var $i5lfL = parcelRequire("i5lfL");
/**
 * @ignore - internal component.
 */ const $4ddb04741c6e7346$var$RadioGroupContext = /*#__PURE__*/ $i5lfL.createContext(undefined);
var $4ddb04741c6e7346$export$2e2bcd8739ae039 = $4ddb04741c6e7346$var$RadioGroupContext;


'use client';
function $d87534ba6cf61d84$export$2e2bcd8739ae039() {
    return $i5lfL.useContext((0, $4ddb04741c6e7346$export$2e2bcd8739ae039));
}



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $426750ab96afc74e$export$192f7b2363c77155(slot) {
    return (0, $6bbZp.default)('MuiRadio', slot);
}
const $426750ab96afc74e$var$radioClasses = (0, $47i1c.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $426750ab96afc74e$export$2e2bcd8739ae039 = $426750ab96afc74e$var$radioClasses;



var $j7y1Z = parcelRequire("j7y1Z");
var $1FZvT = parcelRequire("1FZvT");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $74fd16a7f0f411f6$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $74fd16a7f0f411f6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $VEXgj.default)(color)}`,
            size !== 'medium' && `size${(0, $VEXgj.default)(size)}`
        ]
    };
    return (0, $1CWiu.default)({}, classes, (0, $2ktY3.default)(slots, (0, $426750ab96afc74e$export$192f7b2363c77155), classes));
};
const $74fd16a7f0f411f6$var$RadioRoot = (0, $j7y1Z.default)((0, $53d0c4ba2c30c501$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $1FZvT.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $VEXgj.default)(ownerState.size)}`],
            styles[`color${(0, $VEXgj.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8AHNG.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $426750ab96afc74e$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $426750ab96afc74e$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $74fd16a7f0f411f6$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $74fd16a7f0f411f6$var$defaultCheckedIcon = /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $abd6016129710baf$export$2e2bcd8739ae039), {
    checked: true
});
const $74fd16a7f0f411f6$var$defaultIcon = /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $abd6016129710baf$export$2e2bcd8739ae039), {});
const $74fd16a7f0f411f6$var$Radio = /*#__PURE__*/ $i5lfL.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $74fd16a7f0f411f6$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $74fd16a7f0f411f6$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className } = props, other = (0, $7qXFD.default)(props, $74fd16a7f0f411f6$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $74fd16a7f0f411f6$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $d87534ba6cf61d84$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $3ed70eafd100ec90$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $74fd16a7f0f411f6$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($74fd16a7f0f411f6$var$RadioRoot, (0, $1CWiu.default)({
        type: "radio",
        icon: /*#__PURE__*/ $i5lfL.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $74fd16a7f0f411f6$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $i5lfL.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $74fd16a7f0f411f6$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $kRbLW.default)(classes.root, className)
    }, other));
});
var $74fd16a7f0f411f6$export$2e2bcd8739ae039 = $74fd16a7f0f411f6$var$Radio;





var $i5lfL = parcelRequire("i5lfL");



'use client';
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $2605abdc8746194d$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $i5lfL.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $2605abdc8746194d$var$maybeReactUseSyncExternalStore = $i5lfL.useSyncExternalStore;
function $2605abdc8746194d$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $i5lfL.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $i5lfL.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $i5lfL.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $2605abdc8746194d$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $2605abdc8746194d$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $67100f958c8d60e0$export$2e2bcd8739ae039)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $23488ce219ef4fef$export$2e2bcd8739ae039)({
        name: 'MuiUseMediaQuery',
        props: options,
        theme: theme
    });
    let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $2605abdc8746194d$var$maybeReactUseSyncExternalStore !== undefined ? $2605abdc8746194d$var$useMediaQueryNew : $2605abdc8746194d$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");

var $kRbLW = parcelRequire("kRbLW");





var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $jwO09 = parcelRequire("jwO09");




var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $0d30d498e961cc2a$export$5162da8f798e0959(slot) {
    return (0, $6bbZp.default)('MuiCollapse', slot);
}
const $0d30d498e961cc2a$var$collapseClasses = (0, $47i1c.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $0d30d498e961cc2a$export$2e2bcd8739ae039 = $0d30d498e961cc2a$var$collapseClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $8d561c5085503182$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $8d561c5085503182$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $0d30d498e961cc2a$export$5162da8f798e0959), classes);
};
const $8d561c5085503182$var$CollapseRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, $1CWiu.default)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const $8d561c5085503182$var$CollapseWrapper = (0, $j7y1Z.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const $8d561c5085503182$var$CollapseWrapperInner = (0, $j7y1Z.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $8d561c5085503182$var$Collapse = /*#__PURE__*/ $i5lfL.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $jwO09.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $3011cc386e359a11$export$2e2bcd8739ae039) } = props, other = (0, $7qXFD.default)(props, $8d561c5085503182$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $8d561c5085503182$var$useUtilityClasses(ownerState);
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const timer = (0, $fa9c2cea1dcc0b6d$export$2e2bcd8739ae039)();
    const wrapperRef = $i5lfL.useRef(null);
    const autoTransitionDuration = $i5lfL.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $i5lfL.useRef(null);
    const handleRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $de1e3dddb137b7cc$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $de1e3dddb137b7cc$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsx)(TransitionComponent, (0, $1CWiu.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $bHJbJ.jsx)($8d561c5085503182$var$CollapseRoot, (0, $1CWiu.default)({
                as: component,
                className: (0, $kRbLW.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, $1CWiu.default)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $1CWiu.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)($8d561c5085503182$var$CollapseWrapper, {
                    ownerState: (0, $1CWiu.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)($8d561c5085503182$var$CollapseWrapperInner, {
                        ownerState: (0, $1CWiu.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$8d561c5085503182$var$Collapse.muiSupportAuto = true;
var $8d561c5085503182$export$2e2bcd8739ae039 = $8d561c5085503182$var$Collapse;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $VEXgj = parcelRequire("VEXgj");




var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $3fa2296f40254f0e$export$4b135a4b3a6c4550(slot) {
    return (0, $6bbZp.default)('MuiInputAdornment', slot);
}
const $3fa2296f40254f0e$var$inputAdornmentClasses = (0, $47i1c.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $3fa2296f40254f0e$export$2e2bcd8739ae039 = $3fa2296f40254f0e$var$inputAdornmentClasses;



var $kp44S = parcelRequire("kp44S");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $b99dc77e886c5558$var$_span;
const $b99dc77e886c5558$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $b99dc77e886c5558$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $VEXgj.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $b99dc77e886c5558$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $VEXgj.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $VEXgj.default)(size)}`
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $3fa2296f40254f0e$export$4b135a4b3a6c4550), classes);
};
const $b99dc77e886c5558$var$InputAdornmentRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $b99dc77e886c5558$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $3fa2296f40254f0e$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $3fa2296f40254f0e$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $b99dc77e886c5558$var$InputAdornment = /*#__PURE__*/ $i5lfL.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $7qXFD.default)(props, $b99dc77e886c5558$var$_excluded);
    const muiFormControl = (0, $01f467cf0a9ed9ad$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $1CWiu.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $b99dc77e886c5558$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $9f1ff024a5549c12$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($b99dc77e886c5558$var$InputAdornmentRoot, (0, $1CWiu.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $kRbLW.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $b99dc77e886c5558$var$_span || ($b99dc77e886c5558$var$_span = /*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $b99dc77e886c5558$export$2e2bcd8739ae039 = $b99dc77e886c5558$var$InputAdornment;





var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $d8Gg3 = parcelRequire("d8Gg3");

var $8AHNG = parcelRequire("8AHNG");


var $VEXgj = parcelRequire("VEXgj");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $adc22810a61f3d13$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $6bbZp.default)('MuiLinearProgress', slot);
}
const $adc22810a61f3d13$var$linearProgressClasses = (0, $47i1c.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $adc22810a61f3d13$export$2e2bcd8739ae039 = $adc22810a61f3d13$var$linearProgressClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $2fce601e44012509$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $2fce601e44012509$var$_ = (t)=>t, $2fce601e44012509$var$_t, $2fce601e44012509$var$_t2, $2fce601e44012509$var$_t3, $2fce601e44012509$var$_t4, $2fce601e44012509$var$_t5, $2fce601e44012509$var$_t6;
const $2fce601e44012509$var$TRANSITION_DURATION = 4; // seconds
const $2fce601e44012509$var$indeterminate1Keyframe = (0, $d8Gg3.keyframes)($2fce601e44012509$var$_t || ($2fce601e44012509$var$_t = $2fce601e44012509$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const $2fce601e44012509$var$indeterminate2Keyframe = (0, $d8Gg3.keyframes)($2fce601e44012509$var$_t2 || ($2fce601e44012509$var$_t2 = $2fce601e44012509$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const $2fce601e44012509$var$bufferKeyframe = (0, $d8Gg3.keyframes)($2fce601e44012509$var$_t3 || ($2fce601e44012509$var$_t3 = $2fce601e44012509$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const $2fce601e44012509$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $VEXgj.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $VEXgj.default)(color)}`
        ],
        bar1: [
            'bar',
            `barColor${(0, $VEXgj.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            variant !== 'buffer' && `barColor${(0, $VEXgj.default)(color)}`,
            variant === 'buffer' && `color${(0, $VEXgj.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $adc22810a61f3d13$export$bc8a6ea1eb17d7c6), classes);
};
const $2fce601e44012509$var$getColorShade = (theme, color)=>{
    if (color === 'inherit') return 'currentColor';
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? (0, $8AHNG.lighten)(theme.palette[color].main, 0.62) : (0, $8AHNG.darken)(theme.palette[color].main, 0.5);
};
const $2fce601e44012509$var$LinearProgressRoot = (0, $j7y1Z.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $VEXgj.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $1CWiu.default)({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        '@media print': {
            colorAdjust: 'exact'
        },
        backgroundColor: $2fce601e44012509$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
        backgroundColor: 'none',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'currentColor',
            opacity: 0.3
        }
    }, ownerState.variant === 'buffer' && {
        backgroundColor: 'transparent'
    }, ownerState.variant === 'query' && {
        transform: 'rotate(180deg)'
    }));
const $2fce601e44012509$var$LinearProgressDashed = (0, $j7y1Z.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $VEXgj.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const backgroundColor = $2fce601e44012509$var$getColorShade(theme, ownerState.color);
    return (0, $1CWiu.default)({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%'
    }, ownerState.color === 'inherit' && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px'
    });
}, (0, $d8Gg3.css)($2fce601e44012509$var$_t4 || ($2fce601e44012509$var$_t4 = $2fce601e44012509$var$_`
    animation: ${0} 3s infinite linear;
  `), $2fce601e44012509$var$bufferKeyframe));
const $2fce601e44012509$var$LinearProgressBar1 = (0, $j7y1Z.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $VEXgj.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $1CWiu.default)({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'determinate' && {
        transition: `transform .${$2fce601e44012509$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === 'buffer' && {
        zIndex: 1,
        transition: `transform .${$2fce601e44012509$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, $d8Gg3.css)($2fce601e44012509$var$_t5 || ($2fce601e44012509$var$_t5 = $2fce601e44012509$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), $2fce601e44012509$var$indeterminate1Keyframe));
const $2fce601e44012509$var$LinearProgressBar2 = (0, $j7y1Z.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $VEXgj.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $1CWiu.default)({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left'
    }, ownerState.variant !== 'buffer' && {
        backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        opacity: 0.3
    }, ownerState.variant === 'buffer' && {
        backgroundColor: $2fce601e44012509$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$2fce601e44012509$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, $d8Gg3.css)($2fce601e44012509$var$_t6 || ($2fce601e44012509$var$_t6 = $2fce601e44012509$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), $2fce601e44012509$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $2fce601e44012509$var$LinearProgress = /*#__PURE__*/ $i5lfL.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate' } = props, other = (0, $7qXFD.default)(props, $2fce601e44012509$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $2fce601e44012509$var$useUtilityClasses(ownerState);
    const isRtl = (0, $dd848b3fb63e28ea$export$b2dd014b6c321cb)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($2fce601e44012509$var$LinearProgressRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $bHJbJ.jsx)($2fce601e44012509$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $bHJbJ.jsx)($2fce601e44012509$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $bHJbJ.jsx)($2fce601e44012509$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
var $2fce601e44012509$export$2e2bcd8739ae039 = $2fce601e44012509$var$LinearProgress;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");



var $2ktY3 = parcelRequire("2ktY3");


var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");




var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");

var $VEXgj = parcelRequire("VEXgj");

var $i5lfL = parcelRequire("i5lfL");
'use client';
/**
 * @ignore - internal component.
 */ const $b994a4ef0fca40ed$var$TableContext = /*#__PURE__*/ $i5lfL.createContext();
var $b994a4ef0fca40ed$export$2e2bcd8739ae039 = $b994a4ef0fca40ed$var$TableContext;



var $i5lfL = parcelRequire("i5lfL");
/**
 * @ignore - internal component.
 */ const $943e9b1017ddcf04$var$Tablelvl2Context = /*#__PURE__*/ $i5lfL.createContext();
var $943e9b1017ddcf04$export$2e2bcd8739ae039 = $943e9b1017ddcf04$var$Tablelvl2Context;



var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $719bef05e30c721c$export$33a0f07a16a10b1b(slot) {
    return (0, $6bbZp.default)('MuiTableCell', slot);
}
const $719bef05e30c721c$var$tableCellClasses = (0, $47i1c.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $719bef05e30c721c$export$2e2bcd8739ae039 = $719bef05e30c721c$var$tableCellClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $6bc4ed7a1f524e0e$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $6bc4ed7a1f524e0e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $VEXgj.default)(align)}`,
            padding !== 'normal' && `padding${(0, $VEXgj.default)(padding)}`,
            `size${(0, $VEXgj.default)(size)}`
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $719bef05e30c721c$export$33a0f07a16a10b1b), classes);
};
const $6bc4ed7a1f524e0e$var$TableCellRoot = (0, $j7y1Z.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $VEXgj.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $VEXgj.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $VEXgj.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $8AHNG.lighten)((0, $8AHNG.alpha)(theme.palette.divider, 1), 0.88) : (0, $8AHNG.darken)((0, $8AHNG.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $719bef05e30c721c$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $6bc4ed7a1f524e0e$var$TableCell = /*#__PURE__*/ $i5lfL.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $7qXFD.default)(props, $6bc4ed7a1f524e0e$var$_excluded);
    const table = $i5lfL.useContext((0, $b994a4ef0fca40ed$export$2e2bcd8739ae039));
    const tablelvl2 = $i5lfL.useContext((0, $943e9b1017ddcf04$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $1CWiu.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $6bc4ed7a1f524e0e$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($6bc4ed7a1f524e0e$var$TableCellRoot, (0, $1CWiu.default)({
        as: component,
        ref: ref,
        className: (0, $kRbLW.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $6bc4ed7a1f524e0e$export$2e2bcd8739ae039 = $6bc4ed7a1f524e0e$var$TableCell;




var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");





parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $6e650fc3018e966f$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');


parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $ad561003ffd4e896$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $177f87877116aeb8$var$_excluded = [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
];
const $177f87877116aeb8$var$TablePaginationActions = /*#__PURE__*/ $i5lfL.forwardRef(function TablePaginationActions(props, ref) {
    var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $7qXFD.default)(props, $177f87877116aeb8$var$_excluded);
    const isRtl = (0, $dd848b3fb63e28ea$export$b2dd014b6c321cb)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : (0, $600c8be2a4008660$export$2e2bcd8739ae039);
    const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : (0, $600c8be2a4008660$export$2e2bcd8739ae039);
    const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : (0, $600c8be2a4008660$export$2e2bcd8739ae039);
    const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : (0, $600c8be2a4008660$export$2e2bcd8739ae039);
    const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : (0, $ad561003ffd4e896$export$2e2bcd8739ae039);
    const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : (0, $6e650fc3018e966f$export$2e2bcd8739ae039);
    const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : (0, $fa9fbff4fa708c9e$export$2e2bcd8739ae039);
    const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : (0, $af26105860e4706a$export$2e2bcd8739ae039);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)("div", (0, $1CWiu.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, $bHJbJ.jsx)(FirstButtonSlot, (0, $1CWiu.default)({
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page)
            }, firstButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $bHJbJ.jsx)(LastButtonIcon, (0, $1CWiu.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/ (0, $bHJbJ.jsx)(FirstButtonIcon, (0, $1CWiu.default)({}, slotProps.firstButtonIcon))
            })),
            /*#__PURE__*/ (0, $bHJbJ.jsx)(PreviousButtonSlot, (0, $1CWiu.default)({
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page)
            }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $bHJbJ.jsx)(NextButtonIcon, (0, $1CWiu.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/ (0, $bHJbJ.jsx)(PreviousButtonIcon, (0, $1CWiu.default)({}, slotProps.previousButtonIcon))
            })),
            /*#__PURE__*/ (0, $bHJbJ.jsx)(NextButtonSlot, (0, $1CWiu.default)({
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page)
            }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $bHJbJ.jsx)(PreviousButtonIcon, (0, $1CWiu.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/ (0, $bHJbJ.jsx)(NextButtonIcon, (0, $1CWiu.default)({}, slotProps.nextButtonIcon))
            })),
            showLastButton && /*#__PURE__*/ (0, $bHJbJ.jsx)(LastButtonSlot, (0, $1CWiu.default)({
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page)
            }, lastButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $bHJbJ.jsx)(FirstButtonIcon, (0, $1CWiu.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/ (0, $bHJbJ.jsx)(LastButtonIcon, (0, $1CWiu.default)({}, slotProps.lastButtonIcon))
            }))
        ]
    }));
});
var $177f87877116aeb8$export$2e2bcd8739ae039 = $177f87877116aeb8$var$TablePaginationActions;




var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $8c2d94085d6cc339$export$909e637b22246f4c(slot) {
    return (0, $6bbZp.default)('MuiTablePagination', slot);
}
const $8c2d94085d6cc339$var$tablePaginationClasses = (0, $47i1c.default)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $8c2d94085d6cc339$export$2e2bcd8739ae039 = $8c2d94085d6cc339$var$tablePaginationClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $76f94921d9955c2e$var$_InputBase;
const $76f94921d9955c2e$var$_excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
];
const $76f94921d9955c2e$var$TablePaginationRoot = (0, $j7y1Z.default)((0, $6bc4ed7a1f524e0e$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    }));
const $76f94921d9955c2e$var$TablePaginationToolbar = (0, $j7y1Z.default)((0, $7e3df3c636b0fe42$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>(0, $1CWiu.default)({
            [`& .${(0, $8c2d94085d6cc339$export$2e2bcd8739ae039).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $8c2d94085d6cc339$export$2e2bcd8739ae039).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const $76f94921d9955c2e$var$TablePaginationSpacer = (0, $j7y1Z.default)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: '1 1 100%'
});
const $76f94921d9955c2e$var$TablePaginationSelectLabel = (0, $j7y1Z.default)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel',
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme: theme })=>(0, $1CWiu.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const $76f94921d9955c2e$var$TablePaginationSelect = (0, $j7y1Z.default)((0, $f25919672eb20630$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>(0, $1CWiu.default)({
            [`& .${(0, $8c2d94085d6cc339$export$2e2bcd8739ae039).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $8c2d94085d6cc339$export$2e2bcd8739ae039).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $8c2d94085d6cc339$export$2e2bcd8739ae039).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $76f94921d9955c2e$var$TablePaginationMenuItem = (0, $j7y1Z.default)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'MenuItem',
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $76f94921d9955c2e$var$TablePaginationDisplayedRows = (0, $j7y1Z.default)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows',
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme: theme })=>(0, $1CWiu.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function $76f94921d9955c2e$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $76f94921d9955c2e$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $76f94921d9955c2e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $8c2d94085d6cc339$export$909e637b22246f4c), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $76f94921d9955c2e$var$TablePagination = /*#__PURE__*/ $i5lfL.forwardRef(function TablePagination(inProps, ref) {
    var _slotProps$select;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = (0, $177f87877116aeb8$export$2e2bcd8739ae039), backIconButtonProps: backIconButtonProps, className: className, colSpan: colSpanProp, component: component = (0, $6bc4ed7a1f524e0e$export$2e2bcd8739ae039), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $76f94921d9955c2e$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $76f94921d9955c2e$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $7qXFD.default)(props, $76f94921d9955c2e$var$_excluded);
    const ownerState = props;
    const classes = $76f94921d9955c2e$var$useUtilityClasses(ownerState);
    const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $76f94921d9955c2e$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $6bc4ed7a1f524e0e$export$2e2bcd8739ae039) || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $f1c50420bced90af$export$2e2bcd8739ae039)(selectProps.id);
    const labelId = (0, $f1c50420bced90af$export$2e2bcd8739ae039)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($76f94921d9955c2e$var$TablePaginationRoot, (0, $1CWiu.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, $kRbLW.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)($76f94921d9955c2e$var$TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, $bHJbJ.jsx)($76f94921d9955c2e$var$TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $bHJbJ.jsx)($76f94921d9955c2e$var$TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $bHJbJ.jsx)($76f94921d9955c2e$var$TablePaginationSelect, (0, $1CWiu.default)({
                    variant: "standard"
                }, !selectProps.variant && {
                    input: $76f94921d9955c2e$var$_InputBase || ($76f94921d9955c2e$var$_InputBase = /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3ea17bf47e0c8482$export$2e2bcd8739ae039), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, selectProps, {
                    classes: (0, $1CWiu.default)({}, selectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, $kRbLW.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $kRbLW.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $kRbLW.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    }),
                    disabled: disabled,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $i5lfL.createElement)(MenuItemComponent, (0, $1CWiu.default)({}, !(0, $d7066316d4f9103f$export$2e2bcd8739ae039)(MenuItemComponent) && {
                            ownerState: ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, $bHJbJ.jsx)($76f94921d9955c2e$var$TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $bHJbJ.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    }));
});
var $76f94921d9955c2e$export$2e2bcd8739ae039 = $76f94921d9955c2e$var$TablePagination;




var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");


var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $a813b0c8f4895d93$export$5269a5bce2c2f987(slot) {
    return (0, $6bbZp.default)('MuiAlertTitle', slot);
}
const $a813b0c8f4895d93$var$alertTitleClasses = (0, $47i1c.default)('MuiAlertTitle', [
    'root'
]);
var $a813b0c8f4895d93$export$2e2bcd8739ae039 = $a813b0c8f4895d93$var$alertTitleClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $56526f3260167a91$var$_excluded = [
    "className"
];
const $56526f3260167a91$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $a813b0c8f4895d93$export$5269a5bce2c2f987), classes);
};
const $56526f3260167a91$var$AlertTitleRoot = (0, $j7y1Z.default)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
    name: 'MuiAlertTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $56526f3260167a91$var$AlertTitle = /*#__PURE__*/ $i5lfL.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiAlertTitle'
    });
    const { className: className } = props, other = (0, $7qXFD.default)(props, $56526f3260167a91$var$_excluded);
    const ownerState = props;
    const classes = $56526f3260167a91$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($56526f3260167a91$var$AlertTitleRoot, (0, $1CWiu.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $kRbLW.default)(classes.root, className)
    }, other));
});
var $56526f3260167a91$export$2e2bcd8739ae039 = $56526f3260167a91$var$AlertTitle;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");
parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $c2f69f6d245cd399$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');





var $VEXgj = parcelRequire("VEXgj");


var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $daf799e3a8cc7b50$export$31444911e4ee6fdd(slot) {
    return (0, $6bbZp.default)('MuiChip', slot);
}
const $daf799e3a8cc7b50$var$chipClasses = (0, $47i1c.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $daf799e3a8cc7b50$export$2e2bcd8739ae039 = $daf799e3a8cc7b50$var$chipClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $8a1b9da49508a793$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $8a1b9da49508a793$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $VEXgj.default)(size)}`,
            `color${(0, $VEXgj.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $VEXgj.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $VEXgj.default)(color)}`,
            `${variant}${(0, $VEXgj.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $VEXgj.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $VEXgj.default)(size)}`,
            `avatarColor${(0, $VEXgj.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $VEXgj.default)(size)}`,
            `iconColor${(0, $VEXgj.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $VEXgj.default)(size)}`,
            `deleteIconColor${(0, $VEXgj.default)(color)}`,
            `deleteIcon${(0, $VEXgj.default)(variant)}Color${(0, $VEXgj.default)(color)}`
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $daf799e3a8cc7b50$export$31444911e4ee6fdd), classes);
};
const $8a1b9da49508a793$var$ChipRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $VEXgj.default)(size)}`]
            },
            {
                [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $VEXgj.default)(color)}`]
            },
            {
                [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $VEXgj.default)(size)}`]
            },
            {
                [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $VEXgj.default)(iconColor)}`]
            },
            {
                [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $VEXgj.default)(size)}`]
            },
            {
                [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $VEXgj.default)(color)}`]
            },
            {
                [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $VEXgj.default)(variant)}Color${(0, $VEXgj.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $VEXgj.default)(size)}`],
            styles[`color${(0, $VEXgj.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $VEXgj.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $VEXgj.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $VEXgj.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $1CWiu.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).icon}`]: (0, $1CWiu.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $1CWiu.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).deleteIcon}`]: (0, $1CWiu.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $8AHNG.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $8AHNG.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $8AHNG.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8AHNG.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8AHNG.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8AHNG.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $8AHNG.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8AHNG.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $8AHNG.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $daf799e3a8cc7b50$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $8AHNG.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $8a1b9da49508a793$var$ChipLabel = (0, $j7y1Z.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $VEXgj.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $8a1b9da49508a793$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $8a1b9da49508a793$var$Chip = /*#__PURE__*/ $i5lfL.forwardRef(function Chip(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $7qXFD.default)(props, $8a1b9da49508a793$var$_excluded);
    const chipRef = $i5lfL.useRef(null);
    const handleRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $8a1b9da49508a793$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $8a1b9da49508a793$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $07a3ed667acb77f6$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $i5lfL.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $8a1b9da49508a793$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $07a3ed667acb77f6$export$2e2bcd8739ae039) ? (0, $1CWiu.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $i5lfL.isValidElement(deleteIconProp) ? /*#__PURE__*/ $i5lfL.cloneElement(deleteIconProp, {
        className: (0, $kRbLW.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $c2f69f6d245cd399$export$2e2bcd8739ae039), {
        className: (0, $kRbLW.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $i5lfL.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $i5lfL.cloneElement(avatarProp, {
        className: (0, $kRbLW.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $i5lfL.isValidElement(iconProp)) icon = /*#__PURE__*/ $i5lfL.cloneElement(iconProp, {
        className: (0, $kRbLW.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($8a1b9da49508a793$var$ChipRoot, (0, $1CWiu.default)({
        as: component,
        className: (0, $kRbLW.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $bHJbJ.jsx)($8a1b9da49508a793$var$ChipLabel, {
                className: (0, $kRbLW.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $8a1b9da49508a793$export$2e2bcd8739ae039 = $8a1b9da49508a793$var$Chip;




var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");


var $2ktY3 = parcelRequire("2ktY3");




var $VEXgj = parcelRequire("VEXgj");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $2328c88d852415b5$export$717666c39ec07e12(slot) {
    return (0, $6bbZp.default)('MuiFormControlLabel', slot);
}
const $2328c88d852415b5$var$formControlLabelClasses = (0, $47i1c.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $2328c88d852415b5$export$2e2bcd8739ae039 = $2328c88d852415b5$var$formControlLabelClasses;




var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $3da2083f6f3ac88d$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $3da2083f6f3ac88d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $VEXgj.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $2328c88d852415b5$export$717666c39ec07e12), classes);
};
const $3da2083f6f3ac88d$export$1b479270917a5676 = (0, $j7y1Z.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $2328c88d852415b5$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $VEXgj.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $2328c88d852415b5$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $2328c88d852415b5$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $2328c88d852415b5$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $3da2083f6f3ac88d$var$AsteriskComponent = (0, $j7y1Z.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $2328c88d852415b5$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $3da2083f6f3ac88d$var$FormControlLabel = /*#__PURE__*/ $i5lfL.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $7qXFD.default)(props, $3da2083f6f3ac88d$var$_excluded);
    const muiFormControl = (0, $01f467cf0a9ed9ad$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $0c562896955434b6$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $1CWiu.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $3da2083f6f3ac88d$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $652f32fce481a679$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), (0, $1CWiu.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $kRbLW.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($3da2083f6f3ac88d$export$1b479270917a5676, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $i5lfL.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)($3da2083f6f3ac88d$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $3da2083f6f3ac88d$export$2e2bcd8739ae039 = $3da2083f6f3ac88d$var$FormControlLabel;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");


var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");

var $VEXgj = parcelRequire("VEXgj");


var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $6ab480e31efe6e51$export$39f6debbec19b3ba(slot) {
    return (0, $6bbZp.default)('MuiSwitch', slot);
}
const $6ab480e31efe6e51$var$switchClasses = (0, $47i1c.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $6ab480e31efe6e51$export$2e2bcd8739ae039 = $6ab480e31efe6e51$var$switchClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $e9f0cd073f9086e4$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $e9f0cd073f9086e4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $VEXgj.default)(edge)}`,
            `size${(0, $VEXgj.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $VEXgj.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $2ktY3.default)(slots, (0, $6ab480e31efe6e51$export$39f6debbec19b3ba), classes);
    return (0, $1CWiu.default)({}, classes, composedClasses);
};
const $e9f0cd073f9086e4$var$SwitchRoot = (0, $j7y1Z.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $VEXgj.default)(ownerState.edge)}`],
            styles[`size${(0, $VEXgj.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $e9f0cd073f9086e4$var$SwitchSwitchBase = (0, $j7y1Z.default)((0, $53d0c4ba2c30c501$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $VEXgj.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).checked} + .${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).disabled} + .${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    }), ({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8AHNG.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8AHNG.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $8AHNG.lighten)(theme.palette[color].main, 0.62) : (0, $8AHNG.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).checked} + .${(0, $6ab480e31efe6e51$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $e9f0cd073f9086e4$var$SwitchTrack = (0, $j7y1Z.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    }));
const $e9f0cd073f9086e4$var$SwitchThumb = (0, $j7y1Z.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    }));
const $e9f0cd073f9086e4$var$Switch = /*#__PURE__*/ $i5lfL.forwardRef(function Switch(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx } = props, other = (0, $7qXFD.default)(props, $e9f0cd073f9086e4$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $e9f0cd073f9086e4$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $bHJbJ.jsx)($e9f0cd073f9086e4$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($e9f0cd073f9086e4$var$SwitchRoot, {
        className: (0, $kRbLW.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)($e9f0cd073f9086e4$var$SwitchSwitchBase, (0, $1CWiu.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $1CWiu.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $bHJbJ.jsx)($e9f0cd073f9086e4$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $e9f0cd073f9086e4$export$2e2bcd8739ae039 = $e9f0cd073f9086e4$var$Switch;





var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $a7de24779fc2b276$export$eed427986a7abdf9(slot) {
    return (0, $6bbZp.default)('MuiTableContainer', slot);
}
const $a7de24779fc2b276$var$tableContainerClasses = (0, $47i1c.default)('MuiTableContainer', [
    'root'
]);
var $a7de24779fc2b276$export$2e2bcd8739ae039 = $a7de24779fc2b276$var$tableContainerClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $b7119d3fe107b52e$var$_excluded = [
    "className",
    "component"
];
const $b7119d3fe107b52e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $a7de24779fc2b276$export$eed427986a7abdf9), classes);
};
const $b7119d3fe107b52e$var$TableContainerRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: '100%',
    overflowX: 'auto'
});
const $b7119d3fe107b52e$var$TableContainer = /*#__PURE__*/ $i5lfL.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $7qXFD.default)(props, $b7119d3fe107b52e$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component
    });
    const classes = $b7119d3fe107b52e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($b7119d3fe107b52e$var$TableContainerRoot, (0, $1CWiu.default)({
        ref: ref,
        as: component,
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
var $b7119d3fe107b52e$export$2e2bcd8739ae039 = $b7119d3fe107b52e$var$TableContainer;



var $3HLSL = parcelRequire("3HLSL");/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $a27fdca2714462fa$export$e092ad3ec43b55ee() {
    $a27fdca2714462fa$export$e092ad3ec43b55ee = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a27fdca2714462fa$export$e092ad3ec43b55ee.apply(this, arguments);
}



var $i5lfL = parcelRequire("i5lfL");

var $3HLSL = parcelRequire("3HLSL");
//
var $0b5021d9e7331420$var$useIsomorphicLayoutEffect = typeof document !== 'undefined' ? $i5lfL.useLayoutEffect : $i5lfL.useEffect;
function $0b5021d9e7331420$var$useVirtualizerBase(options) {
    var rerender = $i5lfL.useReducer(function() {
        return {};
    }, {})[1];
    var resolvedOptions = (0, $a27fdca2714462fa$export$e092ad3ec43b55ee)({}, options, {
        onChange: function onChange(instance) {
            rerender();
            options.onChange == null || options.onChange(instance);
        }
    });
    var _React$useState = $i5lfL.useState(function() {
        return new (0, $3HLSL.Virtualizer)(resolvedOptions);
    }), instance = _React$useState[0];
    instance.setOptions(resolvedOptions);
    $i5lfL.useEffect(function() {
        return instance._didMount();
    }, []);
    $0b5021d9e7331420$var$useIsomorphicLayoutEffect(function() {
        return instance._willUpdate();
    });
    return instance;
}
function $0b5021d9e7331420$export$dd6d526d88b5a137(options) {
    return $0b5021d9e7331420$var$useVirtualizerBase((0, $a27fdca2714462fa$export$e092ad3ec43b55ee)({
        observeElementRect: (0, $3HLSL.observeElementRect),
        observeElementOffset: (0, $3HLSL.observeElementOffset),
        scrollToFn: (0, $3HLSL.elementScroll)
    }, options));
}
function $0b5021d9e7331420$export$645722dcac657cb9(options) {
    return $0b5021d9e7331420$var$useVirtualizerBase((0, $a27fdca2714462fa$export$e092ad3ec43b55ee)({
        getScrollElement: function getScrollElement() {
            return typeof document !== 'undefined' ? window : null;
        },
        observeElementRect: (0, $3HLSL.observeWindowRect),
        observeElementOffset: (0, $3HLSL.observeWindowOffset),
        scrollToFn: (0, $3HLSL.windowScroll)
    }, options));
}



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");


var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $d5ec56c6d44907b7$export$315cb19215f77ce0(slot) {
    return (0, $6bbZp.default)('MuiTable', slot);
}
const $d5ec56c6d44907b7$var$tableClasses = (0, $47i1c.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $d5ec56c6d44907b7$export$2e2bcd8739ae039 = $d5ec56c6d44907b7$var$tableClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $db43f7cb09503259$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $db43f7cb09503259$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $d5ec56c6d44907b7$export$315cb19215f77ce0), classes);
};
const $db43f7cb09503259$var$TableRoot = (0, $j7y1Z.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, $1CWiu.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const $db43f7cb09503259$var$defaultComponent = 'table';
const $db43f7cb09503259$var$Table = /*#__PURE__*/ $i5lfL.forwardRef(function Table(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $db43f7cb09503259$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false } = props, other = (0, $7qXFD.default)(props, $db43f7cb09503259$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $db43f7cb09503259$var$useUtilityClasses(ownerState);
    const table = $i5lfL.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b994a4ef0fca40ed$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($db43f7cb09503259$var$TableRoot, (0, $1CWiu.default)({
            as: component,
            role: component === $db43f7cb09503259$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $kRbLW.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $db43f7cb09503259$export$2e2bcd8739ae039 = $db43f7cb09503259$var$Table;



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");


var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $dc26e25a1efc31f9$export$2e731cea2d1c2392(slot) {
    return (0, $6bbZp.default)('MuiTableHead', slot);
}
const $dc26e25a1efc31f9$var$tableHeadClasses = (0, $47i1c.default)('MuiTableHead', [
    'root'
]);
var $dc26e25a1efc31f9$export$2e2bcd8739ae039 = $dc26e25a1efc31f9$var$tableHeadClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $6784374d2f05d85c$var$_excluded = [
    "className",
    "component"
];
const $6784374d2f05d85c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $dc26e25a1efc31f9$export$2e731cea2d1c2392), classes);
};
const $6784374d2f05d85c$var$TableHeadRoot = (0, $j7y1Z.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $6784374d2f05d85c$var$tablelvl2 = {
    variant: 'head'
};
const $6784374d2f05d85c$var$defaultComponent = 'thead';
const $6784374d2f05d85c$var$TableHead = /*#__PURE__*/ $i5lfL.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $6784374d2f05d85c$var$defaultComponent } = props, other = (0, $7qXFD.default)(props, $6784374d2f05d85c$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component
    });
    const classes = $6784374d2f05d85c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $943e9b1017ddcf04$export$2e2bcd8739ae039).Provider, {
        value: $6784374d2f05d85c$var$tablelvl2,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($6784374d2f05d85c$var$TableHeadRoot, (0, $1CWiu.default)({
            as: component,
            className: (0, $kRbLW.default)(classes.root, className),
            ref: ref,
            role: component === $6784374d2f05d85c$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $6784374d2f05d85c$export$2e2bcd8739ae039 = $6784374d2f05d85c$var$TableHead;



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");


var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $ab47beb71654539e$export$ba0a6d6c28940107(slot) {
    return (0, $6bbZp.default)('MuiTableRow', slot);
}
const $ab47beb71654539e$var$tableRowClasses = (0, $47i1c.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $ab47beb71654539e$export$2e2bcd8739ae039 = $ab47beb71654539e$var$tableRowClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $4f773c2e391f97b5$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $4f773c2e391f97b5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $ab47beb71654539e$export$ba0a6d6c28940107), classes);
};
const $4f773c2e391f97b5$var$TableRowRoot = (0, $j7y1Z.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $ab47beb71654539e$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $ab47beb71654539e$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8AHNG.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8AHNG.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $4f773c2e391f97b5$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $4f773c2e391f97b5$var$TableRow = /*#__PURE__*/ $i5lfL.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $4f773c2e391f97b5$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $7qXFD.default)(props, $4f773c2e391f97b5$var$_excluded);
    const tablelvl2 = $i5lfL.useContext((0, $943e9b1017ddcf04$export$2e2bcd8739ae039));
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = $4f773c2e391f97b5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($4f773c2e391f97b5$var$TableRowRoot, (0, $1CWiu.default)({
        as: component,
        ref: ref,
        className: (0, $kRbLW.default)(classes.root, className),
        role: component === $4f773c2e391f97b5$var$defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
var $4f773c2e391f97b5$export$2e2bcd8739ae039 = $4f773c2e391f97b5$var$TableRow;




var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");


var $2ktY3 = parcelRequire("2ktY3");

var $8AHNG = parcelRequire("8AHNG");




var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");

var $1qS3u = parcelRequire("1qS3u");const $ca5e39ec1cc9539b$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $ca5e39ec1cc9539b$export$2e2bcd8739ae039 = $ca5e39ec1cc9539b$var$visuallyHidden;



function $ffa5896192a32ad4$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $ffa5896192a32ad4$export$2e2bcd8739ae039 = $ffa5896192a32ad4$var$areArraysEqual;


'use client';
const $e6d7879a4f632a49$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $e6d7879a4f632a49$var$asc(a, b) {
    return a - b;
}
function $e6d7879a4f632a49$var$findClosest(values, currentValue) {
    var _values$reduce;
    const { index: closestIndex } = (_values$reduce = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null)) != null ? _values$reduce : {};
    return closestIndex;
}
function $e6d7879a4f632a49$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $e6d7879a4f632a49$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $e6d7879a4f632a49$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $e6d7879a4f632a49$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $e6d7879a4f632a49$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($e6d7879a4f632a49$var$getDecimalPrecision(step)));
}
function $e6d7879a4f632a49$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($e6d7879a4f632a49$var$asc);
}
function $e6d7879a4f632a49$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    var _sliderRef$current, _doc$activeElement;
    const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(sliderRef.current);
    if (!((_sliderRef$current = sliderRef.current) != null && _sliderRef$current.contains(doc.activeElement)) || Number(doc == null || (_doc$activeElement = doc.activeElement) == null ? void 0 : _doc$activeElement.getAttribute('data-index')) !== activeIndex) {
        var _sliderRef$current2;
        (_sliderRef$current2 = sliderRef.current) == null || _sliderRef$current2.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    }
    if (setActive) setActive(activeIndex);
}
function $e6d7879a4f632a49$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $ffa5896192a32ad4$export$2e2bcd8739ae039)(newValue, oldValue);
    return false;
}
const $e6d7879a4f632a49$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $e6d7879a4f632a49$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $e6d7879a4f632a49$var$cachedSupportsTouchActionNone;
function $e6d7879a4f632a49$var$doesSupportTouchActionNone() {
    if ($e6d7879a4f632a49$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $e6d7879a4f632a49$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $e6d7879a4f632a49$var$cachedSupportsTouchActionNone = true;
    }
    return $e6d7879a4f632a49$var$cachedSupportsTouchActionNone;
}
function $e6d7879a4f632a49$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $e6d7879a4f632a49$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $i5lfL.useRef();
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $i5lfL.useState(-1);
    const [open, setOpen] = $i5lfL.useState(-1);
    const [dragging, setDragging] = $i5lfL.useState(false);
    const moveCount = $i5lfL.useRef(0);
    const [valueDerived, setValueState] = (0, $50778d58d10a200e$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($e6d7879a4f632a49$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $1qS3u.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $df37cafd1971519c$export$2e2bcd8739ae039)();
    const [focusedThumbIndex, setFocusedThumbIndex] = $i5lfL.useState(-1);
    const sliderRef = $i5lfL.useRef();
    const handleFocusRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(focusVisibleRef, sliderRef);
    const handleRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(ref, handleFocusRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers$onFocu;
            const index = Number(event.currentTarget.getAttribute('data-index'));
            handleFocusVisible(event);
            if (isFocusVisibleRef.current === true) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers == null || (_otherHandlers$onFocu = otherHandlers.onFocus) == null || _otherHandlers$onFocu.call(otherHandlers, event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur;
            handleBlurVisible(event);
            if (isFocusVisibleRef.current === false) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers == null || (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue > maxMarksValue) newValue = maxMarksValue;
            else if (newValue < marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $1qS3u.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $1qS3u.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $e6d7879a4f632a49$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $e6d7879a4f632a49$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$e6d7879a4f632a49$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            // The Shift + Up/Down keyboard shortcuts for moving the slider makes sense to be supported
            // only if the step is defined. If the step is null, this means tha the marks are used for specifying the valid values.
            if (step !== null) {
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                if ((event.key === 'ArrowLeft' || event.key === 'ArrowDown') && event.shiftKey || event.key === 'PageDown') newValue = Math.max(value - shiftStep, min);
                else if ((event.key === 'ArrowRight' || event.key === 'ArrowUp') && event.shiftKey || event.key === 'PageUp') newValue = Math.min(value + shiftStep, max);
                if (newValue !== null) {
                    changeValue(event, newValue);
                    event.preventDefault();
                }
            }
            otherHandlers == null || (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
        };
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) {
            var _document$activeEleme;
            // This is necessary because Firefox and Safari will keep focus
            // on a disabled element:
            // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
            // @ts-ignore
            (_document$activeEleme = document.activeElement) == null || _document$activeEleme.blur();
        }
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            var _otherHandlers$onChan;
            (_otherHandlers$onChan = otherHandlers.onChange) == null || _otherHandlers$onChan.call(otherHandlers, event);
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $i5lfL.useRef();
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.indexOf('vertical') === 0) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.indexOf('-reverse') !== -1) percent = 1 - percent;
        let newValue;
        newValue = $e6d7879a4f632a49$var$percentToValue(percent, min, max);
        if (step) newValue = $e6d7879a4f632a49$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $e6d7879a4f632a49$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $1qS3u.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $e6d7879a4f632a49$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $1qS3u.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $e6d7879a4f632a49$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $e6d7879a4f632a49$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $e6d7879a4f632a49$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $e6d7879a4f632a49$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$e6d7879a4f632a49$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $e6d7879a4f632a49$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$e6d7879a4f632a49$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $e6d7879a4f632a49$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $e6d7879a4f632a49$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$e6d7879a4f632a49$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $i5lfL.useCallback(()=>{
        const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $i5lfL.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $e6d7879a4f632a49$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $i5lfL.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous;
            (_otherHandlers$onMous = otherHandlers.onMouseDown) == null || _otherHandlers$onMous.call(otherHandlers, event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $e6d7879a4f632a49$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $e6d7879a4f632a49$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$e6d7879a4f632a49$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $e6d7879a4f632a49$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $e6d7879a4f632a49$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $d3a9833af65b6699$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $1CWiu.default)({}, externalHandlers, ownEventHandlers);
        return (0, $1CWiu.default)({}, externalProps, {
            ref: handleRef
        }, mergedEventHandlers);
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous2;
            (_otherHandlers$onMous2 = otherHandlers.onMouseOver) == null || _otherHandlers$onMous2.call(otherHandlers, event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous3;
            (_otherHandlers$onMous3 = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous3.call(otherHandlers, event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $d3a9833af65b6699$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return (0, $1CWiu.default)({}, externalProps, externalHandlers, ownEventHandlers);
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    const getHiddenInputProps = (externalProps = {})=>{
        var _parameters$step;
        const externalHandlers = (0, $d3a9833af65b6699$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $1CWiu.default)({}, externalHandlers, ownEventHandlers);
        return (0, $1CWiu.default)({
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : (_parameters$step = parameters.step) != null ? _parameters$step : undefined,
            disabled: disabled
        }, externalProps, mergedEventHandlers, {
            style: (0, $1CWiu.default)({}, (0, $ca5e39ec1cc9539b$export$2e2bcd8739ae039), {
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%'
            })
        });
    };
    return {
        active: active,
        axis: axis,
        axisProps: $e6d7879a4f632a49$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $iYTvc = parcelRequire("iYTvc");

const $454fb1dde57bf996$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $d7066316d4f9103f$export$2e2bcd8739ae039)(Slot);
};
var $454fb1dde57bf996$export$2e2bcd8739ae039 = $454fb1dde57bf996$var$shouldSpreadAdditionalProps;



var $VEXgj = parcelRequire("VEXgj");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $ee5fde32db621d66$export$9f59f2622d5cbc2a(slot) {
    return (0, $6bbZp.default)('MuiSlider', slot);
}
const $ee5fde32db621d66$var$sliderClasses = (0, $47i1c.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $ee5fde32db621d66$export$2e2bcd8739ae039 = $ee5fde32db621d66$var$sliderClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $bbb037fe825f162e$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $kRbLW.default)(open && (0, $ee5fde32db621d66$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $ee5fde32db621d66$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $ee5fde32db621d66$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $bbb037fe825f162e$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $bbb037fe825f162e$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $i5lfL.cloneElement(children, {
        className: (0, $kRbLW.default)(children.props.className)
    }, /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
                className: (0, $kRbLW.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}




var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $36fe94807ea896b0$var$_excluded = [
    "aria-label",
    "aria-valuetext",
    "aria-labelledby",
    "component",
    "components",
    "componentsProps",
    "color",
    "classes",
    "className",
    "disableSwap",
    "disabled",
    "getAriaLabel",
    "getAriaValueText",
    "marks",
    "max",
    "min",
    "name",
    "onChange",
    "onChangeCommitted",
    "orientation",
    "shiftStep",
    "size",
    "step",
    "scale",
    "slotProps",
    "slots",
    "tabIndex",
    "track",
    "value",
    "valueLabelDisplay",
    "valueLabelFormat"
];
function $36fe94807ea896b0$var$Identity(x) {
    return x;
}
const $36fe94807ea896b0$export$c1a21b3b4da66aa1 = (0, $j7y1Z.default)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $VEXgj.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $VEXgj.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $ee5fde32db621d66$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $ee5fde32db621d66$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $ee5fde32db621d66$export$2e2bcd8739ae039).thumb}, & .${(0, $ee5fde32db621d66$export$2e2bcd8739ae039).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    };
});
const $36fe94807ea896b0$export$b02fde61a3559c2 = (0, $j7y1Z.default)('span', {
    name: 'MuiSlider',
    slot: 'Rail',
    overridesResolver: (props, styles)=>styles.rail
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $36fe94807ea896b0$export$105594979f116971 = (0, $j7y1Z.default)('span', {
    name: 'MuiSlider',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>{
    var _theme$vars3;
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.keys(((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette).filter((key)=>{
                var _theme$vars4;
                return ((_theme$vars4 = theme.vars) != null ? _theme$vars4 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: (0, $1CWiu.default)({}, theme.vars ? {
                        backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                        borderColor: theme.vars.palette.Slider[`${color}Track`]
                    } : (0, $1CWiu.default)({
                        backgroundColor: (0, $8AHNG.lighten)(theme.palette[color].main, 0.62),
                        borderColor: (0, $8AHNG.lighten)(theme.palette[color].main, 0.62)
                    }, theme.applyStyles('dark', {
                        backgroundColor: (0, $8AHNG.darken)(theme.palette[color].main, 0.5)
                    }), theme.applyStyles('dark', {
                        borderColor: (0, $8AHNG.darken)(theme.palette[color].main, 0.5)
                    })))
                }))
        ]
    };
});
const $36fe94807ea896b0$export$2c1b491743890dec = (0, $j7y1Z.default)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $VEXgj.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $VEXgj.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars5;
    return {
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $ee5fde32db621d66$export$2e2bcd8739ae039).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.keys(((_theme$vars5 = theme.vars) != null ? _theme$vars5 : theme).palette).filter((key)=>{
                var _theme$vars6;
                return ((_theme$vars6 = theme.vars) != null ? _theme$vars6 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $ee5fde32db621d66$export$2e2bcd8739ae039).focusVisible}`]: (0, $1CWiu.default)({}, theme.vars ? {
                            boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                        } : {
                            boxShadow: `0px 0px 0px 8px ${(0, $8AHNG.alpha)(theme.palette[color].main, 0.16)}`
                        }, {
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        }),
                        [`&.${(0, $ee5fde32db621d66$export$2e2bcd8739ae039).active}`]: (0, $1CWiu.default)({}, theme.vars ? {
                            boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                        } : {
                            boxShadow: `0px 0px 0px 14px ${(0, $8AHNG.alpha)(theme.palette[color].main, 0.16)}`
                        })
                    }
                }))
        ]
    };
});
const $36fe94807ea896b0$export$6453176f504d54f0 = (0, $j7y1Z.default)((0, $bbb037fe825f162e$export$2e2bcd8739ae039), {
    name: 'MuiSlider',
    slot: 'ValueLabel',
    overridesResolver: (props, styles)=>styles.valueLabel
})(({ theme: theme })=>(0, $1CWiu.default)({
        zIndex: 1,
        whiteSpace: 'nowrap'
    }, theme.typography.body2, {
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $ee5fde32db621d66$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $ee5fde32db621d66$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    }));
const $36fe94807ea896b0$export$6f85f6a3c5da6f62 = (0, $j7y1Z.default)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $iYTvc.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    }));
const $36fe94807ea896b0$export$e6cd369965e5aa95 = (0, $j7y1Z.default)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $iYTvc.default)(prop) && prop !== 'markLabelActive',
    overridesResolver: (props, styles)=>styles.markLabel
})(({ theme: theme })=>(0, $1CWiu.default)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    }));
const $36fe94807ea896b0$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $VEXgj.default)(color)}`,
            size && `size${(0, $VEXgj.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $VEXgj.default)(size)}`,
            color && `thumbColor${(0, $VEXgj.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $ee5fde32db621d66$export$9f59f2622d5cbc2a), classes);
};
const $36fe94807ea896b0$var$Forward = ({ children: children })=>children;
const $36fe94807ea896b0$var$Slider = /*#__PURE__*/ $i5lfL.forwardRef(function Slider(inputProps, ref) {
    var _ref, _slots$root, _ref2, _slots$rail, _ref3, _slots$track, _ref4, _slots$thumb, _ref5, _slots$valueLabel, _ref6, _slots$mark, _ref7, _slots$markLabel, _ref8, _slots$input, _slotProps$root, _slotProps$rail, _slotProps$track, _slotProps$thumb, _slotProps$valueLabel, _slotProps$mark, _slotProps$markLabel, _slotProps$input;
    const props = (0, $kp44S.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $dd848b3fb63e28ea$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $36fe94807ea896b0$var$Identity, slotProps: slotProps, slots: slots, track: track = 'normal', valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $36fe94807ea896b0$var$Identity } = props, other = (0, $7qXFD.default)(props, $36fe94807ea896b0$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    });
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $e6d7879a4f632a49$export$56b2c08e277f365)((0, $1CWiu.default)({}, ownerState, {
        rootRef: ref
    }));
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $36fe94807ea896b0$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $36fe94807ea896b0$export$c1a21b3b4da66aa1;
    const RailSlot = (_ref2 = (_slots$rail = slots == null ? void 0 : slots.rail) != null ? _slots$rail : components.Rail) != null ? _ref2 : $36fe94807ea896b0$export$b02fde61a3559c2;
    const TrackSlot = (_ref3 = (_slots$track = slots == null ? void 0 : slots.track) != null ? _slots$track : components.Track) != null ? _ref3 : $36fe94807ea896b0$export$105594979f116971;
    const ThumbSlot = (_ref4 = (_slots$thumb = slots == null ? void 0 : slots.thumb) != null ? _slots$thumb : components.Thumb) != null ? _ref4 : $36fe94807ea896b0$export$2c1b491743890dec;
    const ValueLabelSlot = (_ref5 = (_slots$valueLabel = slots == null ? void 0 : slots.valueLabel) != null ? _slots$valueLabel : components.ValueLabel) != null ? _ref5 : $36fe94807ea896b0$export$6453176f504d54f0;
    const MarkSlot = (_ref6 = (_slots$mark = slots == null ? void 0 : slots.mark) != null ? _slots$mark : components.Mark) != null ? _ref6 : $36fe94807ea896b0$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = (_ref7 = (_slots$markLabel = slots == null ? void 0 : slots.markLabel) != null ? _slots$markLabel : components.MarkLabel) != null ? _ref7 : $36fe94807ea896b0$export$e6cd369965e5aa95;
    const InputSlot = (_ref8 = (_slots$input = slots == null ? void 0 : slots.input) != null ? _slots$input : components.Input) != null ? _ref8 : 'input';
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const railSlotProps = (_slotProps$rail = slotProps == null ? void 0 : slotProps.rail) != null ? _slotProps$rail : componentsProps.rail;
    const trackSlotProps = (_slotProps$track = slotProps == null ? void 0 : slotProps.track) != null ? _slotProps$track : componentsProps.track;
    const thumbSlotProps = (_slotProps$thumb = slotProps == null ? void 0 : slotProps.thumb) != null ? _slotProps$thumb : componentsProps.thumb;
    const valueLabelSlotProps = (_slotProps$valueLabel = slotProps == null ? void 0 : slotProps.valueLabel) != null ? _slotProps$valueLabel : componentsProps.valueLabel;
    const markSlotProps = (_slotProps$mark = slotProps == null ? void 0 : slotProps.mark) != null ? _slotProps$mark : componentsProps.mark;
    const markLabelSlotProps = (_slotProps$markLabel = slotProps == null ? void 0 : slotProps.markLabel) != null ? _slotProps$markLabel : componentsProps.markLabel;
    const inputSlotProps = (_slotProps$input = slotProps == null ? void 0 : slotProps.input) != null ? _slotProps$input : componentsProps.input;
    const rootProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: (0, $1CWiu.default)({}, (0, $454fb1dde57bf996$export$2e2bcd8739ae039)(RootSlot) && {
            as: component
        }),
        ownerState: (0, $1CWiu.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: (0, $1CWiu.default)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap))
        },
        ownerState: (0, $1CWiu.default)({}, ownerState, trackSlotProps == null ? void 0 : trackSlotProps.ownerState),
        className: classes.track
    });
    const thumbProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: (0, $1CWiu.default)({}, ownerState, thumbSlotProps == null ? void 0 : thumbSlotProps.ownerState),
        className: classes.thumb
    });
    const valueLabelProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: (0, $1CWiu.default)({}, ownerState, valueLabelSlotProps == null ? void 0 : valueLabelSlotProps.ownerState),
        className: classes.valueLabel
    });
    const markProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)(RootSlot, (0, $1CWiu.default)({}, rootProps, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)(RailSlot, (0, $1CWiu.default)({}, railProps)),
            /*#__PURE__*/ (0, $bHJbJ.jsx)(TrackSlot, (0, $1CWiu.default)({}, trackProps)),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $e6d7879a4f632a49$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.indexOf(mark.value) !== -1;
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $bHJbJ.jsx)(MarkSlot, (0, $1CWiu.default)({
                            "data-index": index
                        }, markProps, !(0, $d7066316d4f9103f$export$2e2bcd8739ae039)(MarkSlot) && {
                            markActive: markActive
                        }, {
                            style: (0, $1CWiu.default)({}, style, markProps.style),
                            className: (0, $kRbLW.default)(markProps.className, markActive && classes.markActive)
                        })),
                        mark.label != null ? /*#__PURE__*/ (0, $bHJbJ.jsx)(MarkLabelSlot, (0, $1CWiu.default)({
                            "aria-hidden": true,
                            "data-index": index
                        }, markLabelProps, !(0, $d7066316d4f9103f$export$2e2bcd8739ae039)(MarkLabelSlot) && {
                            markLabelActive: markActive
                        }, {
                            style: (0, $1CWiu.default)({}, style, markLabelProps.style),
                            className: (0, $kRbLW.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        })) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $e6d7879a4f632a49$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $36fe94807ea896b0$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $bHJbJ.jsx)(ValueLabelComponent, (0, $1CWiu.default)({}, !(0, $d7066316d4f9103f$export$2e2bcd8739ae039)(ValueLabelComponent) && {
                    valueLabelFormat: valueLabelFormat,
                    valueLabelDisplay: valueLabelDisplay,
                    value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                    index: index,
                    open: open === index || active === index || valueLabelDisplay === 'on',
                    disabled: disabled
                }, valueLabelProps, {
                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)(ThumbSlot, (0, $1CWiu.default)({
                        "data-index": index
                    }, thumbProps, {
                        className: (0, $kRbLW.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: (0, $1CWiu.default)({}, style, getThumbStyle(index), thumbProps.style),
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)(InputSlot, (0, $1CWiu.default)({
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index]
                        }, inputSliderProps))
                    }))
                }), index);
            })
        ]
    }));
});
var $36fe94807ea896b0$export$2e2bcd8739ae039 = $36fe94807ea896b0$var$Slider;





var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $i5lfL = parcelRequire("i5lfL");
'use client';
const $685202d054b3f1aa$var$usePreviousProps = (value)=>{
    const ref = $i5lfL.useRef({});
    $i5lfL.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $685202d054b3f1aa$export$2e2bcd8739ae039 = $685202d054b3f1aa$var$usePreviousProps;



var $2ktY3 = parcelRequire("2ktY3");


'use client';
/**
 *
 * Demos:
 *
 * - [Badge](https://next.mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://next.mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */ function $2fbc63b8d47d79c1$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $685202d054b3f1aa$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $2fbc63b8d47d79c1$export$2e2bcd8739ae039 = $2fbc63b8d47d79c1$var$useBadge;



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $VEXgj = parcelRequire("VEXgj");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $ba07c7e233bb58a2$export$aaccef17e6dab084(slot) {
    return (0, $6bbZp.default)('MuiBadge', slot);
}
const $ba07c7e233bb58a2$var$badgeClasses = (0, $47i1c.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $ba07c7e233bb58a2$export$2e2bcd8739ae039 = $ba07c7e233bb58a2$var$badgeClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $7a1b6bf7a109b0f7$var$_excluded = [
    "anchorOrigin",
    "className",
    "classes",
    "component",
    "components",
    "componentsProps",
    "children",
    "overlap",
    "color",
    "invisible",
    "max",
    "badgeContent",
    "slots",
    "slotProps",
    "showZero",
    "variant"
];
const $7a1b6bf7a109b0f7$var$RADIUS_STANDARD = 10;
const $7a1b6bf7a109b0f7$var$RADIUS_DOT = 4;
const $7a1b6bf7a109b0f7$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $VEXgj.default)(anchorOrigin.vertical)}${(0, $VEXgj.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $VEXgj.default)(anchorOrigin.vertical)}${(0, $VEXgj.default)(anchorOrigin.horizontal)}${(0, $VEXgj.default)(overlap)}`,
            `overlap${(0, $VEXgj.default)(overlap)}`,
            color !== 'default' && `color${(0, $VEXgj.default)(color)}`
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $ba07c7e233bb58a2$export$aaccef17e6dab084), classes);
};
const $7a1b6bf7a109b0f7$var$BadgeRoot = (0, $j7y1Z.default)('span', {
    name: 'MuiBadge',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $7a1b6bf7a109b0f7$var$BadgeBadge = (0, $j7y1Z.default)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $VEXgj.default)(ownerState.anchorOrigin.vertical)}${(0, $VEXgj.default)(ownerState.anchorOrigin.horizontal)}${(0, $VEXgj.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $VEXgj.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $7a1b6bf7a109b0f7$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $7a1b6bf7a109b0f7$var$RADIUS_STANDARD * 2,
        borderRadius: $7a1b6bf7a109b0f7$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2, _theme$vars3;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main && ((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette[key].contrastText;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $7a1b6bf7a109b0f7$var$RADIUS_DOT,
                    height: $7a1b6bf7a109b0f7$var$RADIUS_DOT * 2,
                    minWidth: $7a1b6bf7a109b0f7$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $ba07c7e233bb58a2$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $ba07c7e233bb58a2$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $ba07c7e233bb58a2$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $ba07c7e233bb58a2$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $ba07c7e233bb58a2$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $ba07c7e233bb58a2$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $ba07c7e233bb58a2$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $ba07c7e233bb58a2$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    };
});
const $7a1b6bf7a109b0f7$var$Badge = /*#__PURE__*/ $i5lfL.forwardRef(function Badge(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: 'top',
        horizontal: 'right'
    }, className: className, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard' } = props, other = (0, $7qXFD.default)(props, $7a1b6bf7a109b0f7$var$_excluded);
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $2fbc63b8d47d79c1$export$2e2bcd8739ae039)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $685202d054b3f1aa$export$2e2bcd8739ae039)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOrigin = anchorOriginProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = (0, $1CWiu.default)({}, props, {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    });
    const classes = $7a1b6bf7a109b0f7$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $7a1b6bf7a109b0f7$var$BadgeRoot;
    const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : $7a1b6bf7a109b0f7$var$BadgeBadge;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
    const rootProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $kRbLW.default)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, $03a468e0efc9278b$export$2e2bcd8739ae039)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $kRbLW.default)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)(RootSlot, (0, $1CWiu.default)({}, rootProps, {
        children: [
            children,
            /*#__PURE__*/ (0, $bHJbJ.jsx)(BadgeSlot, (0, $1CWiu.default)({}, badgeProps, {
                children: displayValue
            }))
        ]
    }));
});
var $7a1b6bf7a109b0f7$export$2e2bcd8739ae039 = $7a1b6bf7a109b0f7$var$Badge;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $2ktY3 = parcelRequire("2ktY3");

var $kRbLW = parcelRequire("kRbLW");


var $i5lfL = parcelRequire("i5lfL");

parcelRequire("i5lfL");

var $gVCC4 = parcelRequire("gVCC4");

var $bHJbJ = parcelRequire("bHJbJ");
'use client';
var $0d9ab764287d34fe$export$2e2bcd8739ae039 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $VEXgj = parcelRequire("VEXgj");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $47ab5807429c27dc$export$645d356c89a51794(slot) {
    return (0, $6bbZp.default)('MuiTableSortLabel', slot);
}
const $47ab5807429c27dc$var$tableSortLabelClasses = (0, $47i1c.default)('MuiTableSortLabel', [
    'root',
    'active',
    'icon',
    'iconDirectionDesc',
    'iconDirectionAsc'
]);
var $47ab5807429c27dc$export$2e2bcd8739ae039 = $47ab5807429c27dc$var$tableSortLabelClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $192837ff1481542b$var$_excluded = [
    "active",
    "children",
    "className",
    "direction",
    "hideSortIcon",
    "IconComponent"
];
const $192837ff1481542b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction, active: active } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active'
        ],
        icon: [
            'icon',
            `iconDirection${(0, $VEXgj.default)(direction)}`
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $47ab5807429c27dc$export$645d356c89a51794), classes);
};
const $192837ff1481542b$var$TableSortLabelRoot = (0, $j7y1Z.default)((0, $07a3ed667acb77f6$export$2e2bcd8739ae039), {
    name: 'MuiTableSortLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})(({ theme: theme })=>({
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: (theme.vars || theme).palette.text.secondary
        },
        '&:hover': {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${(0, $47ab5807429c27dc$export$2e2bcd8739ae039).icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${(0, $47ab5807429c27dc$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${(0, $47ab5807429c27dc$export$2e2bcd8739ae039).icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    }));
const $192837ff1481542b$var$TableSortLabelIcon = (0, $j7y1Z.default)('span', {
    name: 'MuiTableSortLabel',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, $VEXgj.default)(ownerState.direction)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            'opacity',
            'transform'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: 'none'
    }, ownerState.direction === 'desc' && {
        transform: 'rotate(0deg)'
    }, ownerState.direction === 'asc' && {
        transform: 'rotate(180deg)'
    }));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const $192837ff1481542b$var$TableSortLabel = /*#__PURE__*/ $i5lfL.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTableSortLabel'
    });
    const { active: active = false, children: children, className: className, direction: direction = 'asc', hideSortIcon: hideSortIcon = false, IconComponent: IconComponent = (0, $0d9ab764287d34fe$export$2e2bcd8739ae039) } = props, other = (0, $7qXFD.default)(props, $192837ff1481542b$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    });
    const classes = $192837ff1481542b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($192837ff1481542b$var$TableSortLabelRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        component: "span",
        disableRipple: true,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, $bHJbJ.jsx)($192837ff1481542b$var$TableSortLabelIcon, {
                as: IconComponent,
                className: (0, $kRbLW.default)(classes.icon),
                ownerState: ownerState
            })
        ]
    }));
});
var $192837ff1481542b$export$2e2bcd8739ae039 = $192837ff1481542b$var$TableSortLabel;



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");


var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $df586f7e4a19c339$export$98bd2a9b566ec665(slot) {
    return (0, $6bbZp.default)('MuiTableBody', slot);
}
const $df586f7e4a19c339$var$tableBodyClasses = (0, $47i1c.default)('MuiTableBody', [
    'root'
]);
var $df586f7e4a19c339$export$2e2bcd8739ae039 = $df586f7e4a19c339$var$tableBodyClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $323c5c8d1793d033$var$_excluded = [
    "className",
    "component"
];
const $323c5c8d1793d033$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $df586f7e4a19c339$export$98bd2a9b566ec665), classes);
};
const $323c5c8d1793d033$var$TableBodyRoot = (0, $j7y1Z.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $323c5c8d1793d033$var$tablelvl2 = {
    variant: 'body'
};
const $323c5c8d1793d033$var$defaultComponent = 'tbody';
const $323c5c8d1793d033$var$TableBody = /*#__PURE__*/ $i5lfL.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $323c5c8d1793d033$var$defaultComponent } = props, other = (0, $7qXFD.default)(props, $323c5c8d1793d033$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component
    });
    const classes = $323c5c8d1793d033$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $943e9b1017ddcf04$export$2e2bcd8739ae039).Provider, {
        value: $323c5c8d1793d033$var$tablelvl2,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($323c5c8d1793d033$var$TableBodyRoot, (0, $1CWiu.default)({
            className: (0, $kRbLW.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $323c5c8d1793d033$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $323c5c8d1793d033$export$2e2bcd8739ae039 = $323c5c8d1793d033$var$TableBody;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");

var $kRbLW = parcelRequire("kRbLW");


var $d8Gg3 = parcelRequire("d8Gg3");

var $2ktY3 = parcelRequire("2ktY3");
function $7c012831fc1bbafd$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $7c012831fc1bbafd$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $7c012831fc1bbafd$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $7c012831fc1bbafd$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $7c012831fc1bbafd$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $7c012831fc1bbafd$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $7c012831fc1bbafd$export$8af1d214c6c2f0f1(length) * $7c012831fc1bbafd$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $7c012831fc1bbafd$export$8af1d214c6c2f0f1(length) * $7c012831fc1bbafd$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $7c012831fc1bbafd$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $7c012831fc1bbafd$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $7c012831fc1bbafd$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $7c012831fc1bbafd$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $7c012831fc1bbafd$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $b8e2a0fd4f8d9d23$export$c987db9fc844f86(slot) {
    return (0, $6bbZp.default)('MuiSkeleton', slot);
}
const $b8e2a0fd4f8d9d23$var$skeletonClasses = (0, $47i1c.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $b8e2a0fd4f8d9d23$export$2e2bcd8739ae039 = $b8e2a0fd4f8d9d23$var$skeletonClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $7b73eaf87a610891$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $7b73eaf87a610891$var$_ = (t)=>t, $7b73eaf87a610891$var$_t, $7b73eaf87a610891$var$_t2, $7b73eaf87a610891$var$_t3, $7b73eaf87a610891$var$_t4;
const $7b73eaf87a610891$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $b8e2a0fd4f8d9d23$export$c987db9fc844f86), classes);
};
const $7b73eaf87a610891$var$pulseKeyframe = (0, $d8Gg3.keyframes)($7b73eaf87a610891$var$_t || ($7b73eaf87a610891$var$_t = $7b73eaf87a610891$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $7b73eaf87a610891$var$waveKeyframe = (0, $d8Gg3.keyframes)($7b73eaf87a610891$var$_t2 || ($7b73eaf87a610891$var$_t2 = $7b73eaf87a610891$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $7b73eaf87a610891$var$SkeletonRoot = (0, $j7y1Z.default)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $7c012831fc1bbafd$export$65f2564e9a9b9222)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $7c012831fc1bbafd$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $1CWiu.default)({
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em'
    }, ownerState.variant === 'text' && {
        marginTop: 0,
        marginBottom: 0,
        height: 'auto',
        transformOrigin: '0 55%',
        transform: 'scale(1, 0.60)',
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        '&:empty:before': {
            content: '"\\00a0"'
        }
    }, ownerState.variant === 'circular' && {
        borderRadius: '50%'
    }, ownerState.variant === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        '& > *': {
            visibility: 'hidden'
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: 'fit-content'
    }, ownerState.hasChildren && !ownerState.height && {
        height: 'auto'
    });
}, ({ ownerState: ownerState })=>ownerState.animation === 'pulse' && (0, $d8Gg3.css)($7b73eaf87a610891$var$_t3 || ($7b73eaf87a610891$var$_t3 = $7b73eaf87a610891$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), $7b73eaf87a610891$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === 'wave' && (0, $d8Gg3.css)($7b73eaf87a610891$var$_t4 || ($7b73eaf87a610891$var$_t4 = $7b73eaf87a610891$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $7b73eaf87a610891$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $7b73eaf87a610891$var$Skeleton = /*#__PURE__*/ $i5lfL.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width } = props, other = (0, $7qXFD.default)(props, $7b73eaf87a610891$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $7b73eaf87a610891$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($7b73eaf87a610891$var$SkeletonRoot, (0, $1CWiu.default)({
        as: component,
        ref: ref,
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $1CWiu.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $7b73eaf87a610891$export$2e2bcd8739ae039 = $7b73eaf87a610891$var$Skeleton;


let $d472912aa0717344$var$IDX = 36;
let $d472912aa0717344$var$HEX = "";
while($d472912aa0717344$var$IDX--)$d472912aa0717344$var$HEX += $d472912aa0717344$var$IDX.toString(36);
function $d472912aa0717344$var$uid(len = 11) {
    let str = "";
    let num = len;
    while(num--)str += $d472912aa0717344$var$HEX[Math.random() * 36 | 0];
    return str;
}
const $d472912aa0717344$var$escapeRegexp = (term)=>term.replace(/[|\\{}()[\]^$+*?.-]/g, (char)=>`\\${char}`);
const $d472912aa0717344$var$termsToRegExpString = (terms)=>terms.replace(/\s{2,}/g, " ").split(" ").join("|");
const $d472912aa0717344$var$regexpQuery = ({ terms: terms, matchExactly: matchExactly = false })=>{
    if (typeof terms !== "string") throw new TypeError("Expected a string");
    const escapedTerms = $d472912aa0717344$var$escapeRegexp(terms.trim());
    return `(${matchExactly ? escapedTerms : $d472912aa0717344$var$termsToRegExpString(escapedTerms)})`;
};
const $d472912aa0717344$var$buildRegexp = ({ terms: terms, matchExactly: matchExactly = false })=>{
    try {
        const fromString = /^([/~@;%#'])(.*?)\1([gimsuy]*)$/.exec(terms);
        if (fromString) return new RegExp(fromString[2], fromString[3]);
        return new RegExp($d472912aa0717344$var$regexpQuery({
            terms: terms,
            matchExactly: matchExactly
        }), "ig");
    } catch (e) {
        throw new TypeError("Expected terms to be either a string or a RegExp!");
    }
};
const $d472912aa0717344$var$hasProp = (prop)=>(obj)=>obj !== null && typeof obj === "object" && prop in obj;
const $d472912aa0717344$var$hasMatch = $d472912aa0717344$var$hasProp("match");
const $d472912aa0717344$var$chunkExists = (chunk)=>typeof chunk !== "undefined";
function $d472912aa0717344$var$clip({ curr: curr, next: next, prev: prev, clipBy: clipBy = 3 }) {
    const words = curr.text.split(" ");
    const len = words.length;
    if (curr.match || clipBy >= len) return curr.text;
    const ellipsis = "...";
    if ($d472912aa0717344$var$chunkExists(next) && $d472912aa0717344$var$chunkExists(prev) && $d472912aa0717344$var$hasMatch(prev) && $d472912aa0717344$var$hasMatch(next)) {
        if (len > clipBy * 2) return [
            ...words.slice(0, clipBy),
            ellipsis,
            ...words.slice(-clipBy)
        ].join(" ");
        return curr.text;
    }
    if ($d472912aa0717344$var$chunkExists(next) && $d472912aa0717344$var$hasMatch(next)) return [
        ellipsis,
        ...words.slice(-clipBy)
    ].join(" ");
    if ($d472912aa0717344$var$chunkExists(prev) && $d472912aa0717344$var$hasMatch(prev)) return [
        ...words.slice(0, clipBy),
        ellipsis
    ].join(" ");
    return curr.text;
}
var $d472912aa0717344$var$__defProp = Object.defineProperty;
var $d472912aa0717344$var$__defProps = Object.defineProperties;
var $d472912aa0717344$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d472912aa0717344$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d472912aa0717344$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d472912aa0717344$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d472912aa0717344$var$__defNormalProp = (obj, key, value)=>key in obj ? $d472912aa0717344$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d472912aa0717344$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d472912aa0717344$var$__hasOwnProp.call(b, prop)) $d472912aa0717344$var$__defNormalProp(a, prop, b[prop]);
    if ($d472912aa0717344$var$__getOwnPropSymbols) {
        for (var prop of $d472912aa0717344$var$__getOwnPropSymbols(b))if ($d472912aa0717344$var$__propIsEnum.call(b, prop)) $d472912aa0717344$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d472912aa0717344$var$__spreadProps = (a, b)=>$d472912aa0717344$var$__defProps(a, $d472912aa0717344$var$__getOwnPropDescs(b));
const $d472912aa0717344$var$hasLength = (str)=>str.length > 0;
const $d472912aa0717344$export$2e2bcd8739ae039 = ({ text: text, query: query, clipBy: clipBy, matchExactly: matchExactly = false })=>{
    const safeQuery = typeof query === "string" ? query.trim() : query;
    if (safeQuery === "") return [
        {
            key: $d472912aa0717344$var$uid(),
            text: text,
            match: false
        }
    ];
    const searchRegexp = $d472912aa0717344$var$buildRegexp({
        terms: query,
        matchExactly: matchExactly
    });
    return text.split(searchRegexp).filter($d472912aa0717344$var$hasLength).map((str)=>({
            // Compose the object for a match
            key: $d472912aa0717344$var$uid(),
            text: str,
            match: matchExactly ? str.toLowerCase() === safeQuery.toLowerCase() : searchRegexp.test(str)
        })).map((chunk, index, chunks)=>$d472912aa0717344$var$__spreadValues($d472912aa0717344$var$__spreadValues({}, chunk), typeof clipBy === "number" && {
            // We only overwrite the text if there is a clip
            text: $d472912aa0717344$var$clip($d472912aa0717344$var$__spreadProps($d472912aa0717344$var$__spreadValues($d472912aa0717344$var$__spreadValues({
                curr: chunk
            }, index < chunks.length - 1 && {
                next: chunks[index + 1]
            }), index > 0 && {
                prev: chunks[index - 1]
            }), {
                clipBy: // If this wasn't the first chunk, set the previous chunk
                clipBy
            }))
        }));
};



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");


var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $f01b6b11a9829d1a$export$abec0e5519905f2c(slot) {
    return (0, $6bbZp.default)('MuiTableFooter', slot);
}
const $f01b6b11a9829d1a$var$tableFooterClasses = (0, $47i1c.default)('MuiTableFooter', [
    'root'
]);
var $f01b6b11a9829d1a$export$2e2bcd8739ae039 = $f01b6b11a9829d1a$var$tableFooterClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $76e24f2e3b62794c$var$_excluded = [
    "className",
    "component"
];
const $76e24f2e3b62794c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $f01b6b11a9829d1a$export$abec0e5519905f2c), classes);
};
const $76e24f2e3b62794c$var$TableFooterRoot = (0, $j7y1Z.default)('tfoot', {
    name: 'MuiTableFooter',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-footer-group'
});
const $76e24f2e3b62794c$var$tablelvl2 = {
    variant: 'footer'
};
const $76e24f2e3b62794c$var$defaultComponent = 'tfoot';
const $76e24f2e3b62794c$var$TableFooter = /*#__PURE__*/ $i5lfL.forwardRef(function TableFooter(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiTableFooter'
    });
    const { className: className, component: component = $76e24f2e3b62794c$var$defaultComponent } = props, other = (0, $7qXFD.default)(props, $76e24f2e3b62794c$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        component: component
    });
    const classes = $76e24f2e3b62794c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $943e9b1017ddcf04$export$2e2bcd8739ae039).Provider, {
        value: $76e24f2e3b62794c$var$tablelvl2,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($76e24f2e3b62794c$var$TableFooterRoot, (0, $1CWiu.default)({
            as: component,
            className: (0, $kRbLW.default)(classes.root, className),
            ref: ref,
            role: component === $76e24f2e3b62794c$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $76e24f2e3b62794c$export$2e2bcd8739ae039 = $76e24f2e3b62794c$var$TableFooter;





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $30615b8e57e39efe$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
const $30615b8e57e39efe$export$b560094588c4318 = Object.assign({}, (0, $34de474a8ff218be$export$3aa4339120b8b25b));
const $30615b8e57e39efe$var$fuzzy$1 = (row, columnId, filterValue, addMeta)=>{
    const itemRank = (0, $c48a0afd06479119$export$2bf9c99d6a293bc8)(row.getValue(columnId), filterValue, {
        threshold: (0, $c48a0afd06479119$export$809b0b82a3f0b8b5).MATCHES
    });
    addMeta(itemRank);
    return itemRank.passed;
};
$30615b8e57e39efe$var$fuzzy$1.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$contains = (row, id, filterValue)=>row.getValue(id).toString().toLowerCase().trim().includes(filterValue.toString().toLowerCase().trim());
$30615b8e57e39efe$var$contains.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$startsWith = (row, id, filterValue)=>row.getValue(id).toString().toLowerCase().trim().startsWith(filterValue.toString().toLowerCase().trim());
$30615b8e57e39efe$var$startsWith.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$endsWith = (row, id, filterValue)=>row.getValue(id).toString().toLowerCase().trim().endsWith(filterValue.toString().toLowerCase().trim());
$30615b8e57e39efe$var$endsWith.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$equals = (row, id, filterValue)=>row.getValue(id).toString().toLowerCase().trim() === filterValue.toString().toLowerCase().trim();
$30615b8e57e39efe$var$equals.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$notEquals = (row, id, filterValue)=>row.getValue(id).toString().toLowerCase().trim() !== filterValue.toString().toLowerCase().trim();
$30615b8e57e39efe$var$notEquals.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$greaterThan = (row, id, filterValue)=>!isNaN(+filterValue) && !isNaN(+row.getValue(id)) ? +row.getValue(id) > +filterValue : row.getValue(id).toString().toLowerCase().trim() > filterValue.toString().toLowerCase().trim();
$30615b8e57e39efe$var$greaterThan.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$greaterThanOrEqualTo = (row, id, filterValue)=>$30615b8e57e39efe$var$equals(row, id, filterValue) || $30615b8e57e39efe$var$greaterThan(row, id, filterValue);
$30615b8e57e39efe$var$greaterThanOrEqualTo.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$lessThan = (row, id, filterValue)=>!isNaN(+filterValue) && !isNaN(+row.getValue(id)) ? +row.getValue(id) < +filterValue : row.getValue(id).toString().toLowerCase().trim() < filterValue.toString().toLowerCase().trim();
$30615b8e57e39efe$var$lessThan.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$lessThanOrEqualTo = (row, id, filterValue)=>$30615b8e57e39efe$var$equals(row, id, filterValue) || $30615b8e57e39efe$var$lessThan(row, id, filterValue);
$30615b8e57e39efe$var$lessThanOrEqualTo.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$between = (row, id, filterValues)=>([
        '',
        undefined
    ].includes(filterValues[0]) || $30615b8e57e39efe$var$greaterThan(row, id, filterValues[0])) && (!isNaN(+filterValues[0]) && !isNaN(+filterValues[1]) && +filterValues[0] > +filterValues[1] || [
        '',
        undefined
    ].includes(filterValues[1]) || $30615b8e57e39efe$var$lessThan(row, id, filterValues[1]));
$30615b8e57e39efe$var$between.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$betweenInclusive = (row, id, filterValues)=>([
        '',
        undefined
    ].includes(filterValues[0]) || $30615b8e57e39efe$var$greaterThanOrEqualTo(row, id, filterValues[0])) && (!isNaN(+filterValues[0]) && !isNaN(+filterValues[1]) && +filterValues[0] > +filterValues[1] || [
        '',
        undefined
    ].includes(filterValues[1]) || $30615b8e57e39efe$var$lessThanOrEqualTo(row, id, filterValues[1]));
$30615b8e57e39efe$var$betweenInclusive.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$empty = (row, id, _filterValue)=>!row.getValue(id).toString().trim();
$30615b8e57e39efe$var$empty.autoRemove = (val)=>!val;
const $30615b8e57e39efe$var$notEmpty = (row, id, _filterValue)=>!!row.getValue(id).toString().trim();
$30615b8e57e39efe$var$notEmpty.autoRemove = (val)=>!val;
const $30615b8e57e39efe$export$81754f428e3b4fc7 = Object.assign(Object.assign({}, (0, $34de474a8ff218be$export$6ad8312e296ec316)), {
    between: $30615b8e57e39efe$var$between,
    betweenInclusive: $30615b8e57e39efe$var$betweenInclusive,
    contains: $30615b8e57e39efe$var$contains,
    empty: $30615b8e57e39efe$var$empty,
    endsWith: $30615b8e57e39efe$var$endsWith,
    equals: $30615b8e57e39efe$var$equals,
    fuzzy: $30615b8e57e39efe$var$fuzzy$1,
    greaterThan: $30615b8e57e39efe$var$greaterThan,
    greaterThanOrEqualTo: $30615b8e57e39efe$var$greaterThanOrEqualTo,
    lessThan: $30615b8e57e39efe$var$lessThan,
    lessThanOrEqualTo: $30615b8e57e39efe$var$lessThanOrEqualTo,
    notEmpty: $30615b8e57e39efe$var$notEmpty,
    notEquals: $30615b8e57e39efe$var$notEquals,
    startsWith: $30615b8e57e39efe$var$startsWith
});
const $30615b8e57e39efe$var$fuzzy = (rowA, rowB, columnId)=>{
    let dir = 0;
    if (rowA.columnFiltersMeta[columnId]) dir = (0, $c48a0afd06479119$export$b0c6b3a142decb5a)(rowA.columnFiltersMeta[columnId], rowB.columnFiltersMeta[columnId]);
    // Provide a fallback for when the item ranks are equal
    return dir === 0 ? (0, $34de474a8ff218be$export$47423a4cd813a815).alphanumeric(rowA, rowB, columnId) : dir;
};
const $30615b8e57e39efe$export$cfca3685708ab5fc = Object.assign(Object.assign({}, (0, $34de474a8ff218be$export$47423a4cd813a815)), {
    fuzzy: $30615b8e57e39efe$var$fuzzy
});
const $30615b8e57e39efe$var$rankGlobalFuzzy = (rowA, rowB)=>Math.max(...Object.values(rowB.columnFiltersMeta).map((v)=>v.rank)) - Math.max(...Object.values(rowA.columnFiltersMeta).map((v)=>v.rank));
const $30615b8e57e39efe$var$getColumnId = (columnDef)=>{
    var _a, _b, _c, _d;
    return (_d = (_a = columnDef.id) !== null && _a !== void 0 ? _a : (_c = (_b = columnDef.accessorKey) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : columnDef.header;
};
const $30615b8e57e39efe$var$getAllLeafColumnDefs = (columns)=>{
    const allLeafColumnDefs = [];
    const getLeafColumns = (cols)=>{
        cols.forEach((col)=>{
            if (col.columns) getLeafColumns(col.columns);
            else allLeafColumnDefs.push(col);
        });
    };
    getLeafColumns(columns);
    return allLeafColumnDefs;
};
const $30615b8e57e39efe$var$prepareColumns = ({ aggregationFns: aggregationFns, columnDefs: columnDefs, columnFilterFns: columnFilterFns, defaultDisplayColumn: defaultDisplayColumn, filterFns: filterFns, sortingFns: sortingFns })=>columnDefs.map((columnDef)=>{
        var _a, _b;
        //assign columnId
        if (!columnDef.id) columnDef.id = $30615b8e57e39efe$var$getColumnId(columnDef);
        //assign columnDefType
        if (!columnDef.columnDefType) columnDef.columnDefType = 'data';
        if ((_a = columnDef.columns) === null || _a === void 0 ? void 0 : _a.length) {
            columnDef.columnDefType = 'group';
            //recursively prepare columns if this is a group column
            columnDef.columns = $30615b8e57e39efe$var$prepareColumns({
                aggregationFns: aggregationFns,
                columnDefs: columnDef.columns,
                columnFilterFns: columnFilterFns,
                defaultDisplayColumn: defaultDisplayColumn,
                filterFns: filterFns,
                sortingFns: sortingFns
            });
        } else if (columnDef.columnDefType === 'data') {
            //assign aggregationFns if multiple aggregationFns are provided
            if (Array.isArray(columnDef.aggregationFn)) {
                const aggFns = columnDef.aggregationFn;
                columnDef.aggregationFn = (columnId, leafRows, childRows)=>aggFns.map((fn)=>{
                        var _a;
                        return (_a = aggregationFns[fn]) === null || _a === void 0 ? void 0 : _a.call(aggregationFns, columnId, leafRows, childRows);
                    });
            }
            //assign filterFns
            if (Object.keys(filterFns).includes(columnFilterFns[columnDef.id])) {
                columnDef.filterFn = (_b = filterFns[columnFilterFns[columnDef.id]]) !== null && _b !== void 0 ? _b : filterFns.fuzzy;
                columnDef._filterFn = columnFilterFns[columnDef.id];
            }
            //assign sortingFns
            if (Object.keys(sortingFns).includes(columnDef.sortingFn)) // @ts-ignore
            columnDef.sortingFn = sortingFns[columnDef.sortingFn];
        } else if (columnDef.columnDefType === 'display') columnDef = Object.assign(Object.assign({}, defaultDisplayColumn), columnDef);
        return columnDef;
    });
const $30615b8e57e39efe$var$reorderColumn = (draggedColumn, targetColumn, columnOrder)=>{
    if (draggedColumn.getCanPin()) draggedColumn.pin(targetColumn.getIsPinned());
    const newColumnOrder = [
        ...columnOrder
    ];
    newColumnOrder.splice(newColumnOrder.indexOf(targetColumn.id), 0, newColumnOrder.splice(newColumnOrder.indexOf(draggedColumn.id), 1)[0]);
    return newColumnOrder;
};
const $30615b8e57e39efe$var$showExpandColumn = (props, grouping)=>!!(props.enableExpanding || props.enableGrouping && (grouping === undefined || (grouping === null || grouping === void 0 ? void 0 : grouping.length)) || props.renderDetailPanel);
const $30615b8e57e39efe$var$getLeadingDisplayColumnIds = (props)=>{
    var _a;
    return [
        (props.enableRowDragging || props.enableRowOrdering) && 'mrt-row-drag',
        props.positionActionsColumn === 'first' && (props.enableRowActions || props.enableEditing && [
            'row',
            'modal'
        ].includes((_a = props.editingMode) !== null && _a !== void 0 ? _a : '')) && 'mrt-row-actions',
        props.positionExpandColumn === 'first' && $30615b8e57e39efe$var$showExpandColumn(props) && 'mrt-row-expand',
        props.enableRowSelection && 'mrt-row-select',
        props.enableRowNumbers && 'mrt-row-numbers'
    ].filter(Boolean);
};
const $30615b8e57e39efe$var$getTrailingDisplayColumnIds = (props)=>{
    var _a;
    return [
        props.positionActionsColumn === 'last' && (props.enableRowActions || props.enableEditing && [
            'row',
            'modal'
        ].includes((_a = props.editingMode) !== null && _a !== void 0 ? _a : '')) && 'mrt-row-actions',
        props.positionExpandColumn === 'last' && $30615b8e57e39efe$var$showExpandColumn(props) && 'mrt-row-expand'
    ].filter(Boolean);
};
const $30615b8e57e39efe$var$getDefaultColumnOrderIds = (props)=>{
    const leadingDisplayCols = $30615b8e57e39efe$var$getLeadingDisplayColumnIds(props);
    const trailingDisplayCols = $30615b8e57e39efe$var$getTrailingDisplayColumnIds(props);
    const allLeafColumnDefs = $30615b8e57e39efe$var$getAllLeafColumnDefs(props.columns).map((columnDef)=>$30615b8e57e39efe$var$getColumnId(columnDef)).filter((columnId)=>!leadingDisplayCols.includes(columnId) && !trailingDisplayCols.includes(columnId));
    return [
        ...leadingDisplayCols,
        ...allLeafColumnDefs,
        ...trailingDisplayCols
    ];
};
const $30615b8e57e39efe$var$getDefaultColumnFilterFn = (columnDef)=>{
    if (columnDef.filterVariant === 'multi-select') return 'arrIncludesSome';
    if (columnDef.filterVariant === 'range' || columnDef.filterVariant === 'range-slider') return 'betweenInclusive';
    if (columnDef.filterVariant === 'select' || columnDef.filterVariant === 'checkbox') return 'equals';
    return 'fuzzy';
};
const $30615b8e57e39efe$var$getIsFirstColumn = (column, table)=>{
    return table.getVisibleLeafColumns()[0].id === column.id;
};
const $30615b8e57e39efe$var$getIsLastColumn = (column, table)=>{
    const columns = table.getVisibleLeafColumns();
    return columns[columns.length - 1].id === column.id;
};
const $30615b8e57e39efe$var$getIsLastLeftPinnedColumn = (table, column)=>{
    return column.getIsPinned() === 'left' && table.getLeftLeafHeaders().length - 1 === column.getPinnedIndex();
};
const $30615b8e57e39efe$var$getIsFirstRightPinnedColumn = (column)=>{
    return column.getIsPinned() === 'right' && column.getPinnedIndex() === 0;
};
const $30615b8e57e39efe$var$getTotalRight = (table, column)=>{
    return table.getRightLeafHeaders().slice(column.getPinnedIndex() + 1).reduce((acc, col)=>acc + col.getSize(), 0);
};
const $30615b8e57e39efe$var$getCommonCellStyles = ({ column: column, header: header, table: table, tableCellProps: tableCellProps, theme: theme })=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const widthStyles = {
        minWidth: `max(calc(var(--${header ? 'header' : 'col'}-${$30615b8e57e39efe$var$parseCSSVarId((_a = header === null || header === void 0 ? void 0 : header.id) !== null && _a !== void 0 ? _a : column.id)}-size) * 1px), ${(_b = column.columnDef.minSize) !== null && _b !== void 0 ? _b : 30}px)`,
        width: `calc(var(--${header ? 'header' : 'col'}-${$30615b8e57e39efe$var$parseCSSVarId((_c = header === null || header === void 0 ? void 0 : header.id) !== null && _c !== void 0 ? _c : column.id)}-size) * 1px)`
    };
    return Object.assign(Object.assign(Object.assign({
        backgroundColor: column.getIsPinned() && column.columnDef.columnDefType !== 'group' ? (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)((0, $bb6d55b5db31c7f7$export$c0816ed86df316af)(theme.palette.background.default, 0.04), 0.97) : 'inherit',
        backgroundImage: 'inherit',
        boxShadow: $30615b8e57e39efe$var$getIsLastLeftPinnedColumn(table, column) ? `-4px 0 8px -6px ${(0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.2)} inset` : $30615b8e57e39efe$var$getIsFirstRightPinnedColumn(column) ? `4px 0 8px -6px ${(0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.2)} inset` : undefined,
        display: table.options.layoutMode === 'grid' ? 'flex' : 'table-cell',
        flex: table.options.layoutMode === 'grid' ? `var(--${header ? 'header' : 'col'}-${$30615b8e57e39efe$var$parseCSSVarId((_d = header === null || header === void 0 ? void 0 : header.id) !== null && _d !== void 0 ? _d : column.id)}-size) 0 auto` : undefined,
        left: column.getIsPinned() === 'left' ? `${column.getStart('left')}px` : undefined,
        ml: table.options.enableColumnVirtualization && column.getIsPinned() === 'left' && column.getPinnedIndex() === 0 ? `-${column.getSize() * ((_f = (_e = table.getState().columnPinning.left) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 1)}px` : undefined,
        mr: table.options.enableColumnVirtualization && column.getIsPinned() === 'right' && column.getPinnedIndex() === table.getVisibleLeafColumns().length - 1 ? `-${column.getSize() * ((_h = (_g = table.getState().columnPinning.right) === null || _g === void 0 ? void 0 : _g.length) !== null && _h !== void 0 ? _h : 1) * 1.2}px` : undefined,
        opacity: ((_j = table.getState().draggingColumn) === null || _j === void 0 ? void 0 : _j.id) === column.id || ((_k = table.getState().hoveredColumn) === null || _k === void 0 ? void 0 : _k.id) === column.id ? 0.5 : 1,
        position: column.getIsPinned() && column.columnDef.columnDefType !== 'group' ? 'sticky' : undefined,
        right: column.getIsPinned() === 'right' ? `${$30615b8e57e39efe$var$getTotalRight(table, column)}px` : undefined,
        transition: table.options.enableColumnVirtualization ? 'none' : `padding 150ms ease-in-out`
    }, !table.options.enableColumnResizing && widthStyles), (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.sx) instanceof Function ? tableCellProps.sx(theme) : tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.sx), table.options.enableColumnResizing && widthStyles);
};
const $30615b8e57e39efe$var$MRT_DefaultColumn = {
    filterVariant: 'text',
    minSize: 40,
    maxSize: 1000,
    size: 180
};
const $30615b8e57e39efe$var$MRT_DefaultDisplayColumn = {
    columnDefType: 'display',
    enableClickToCopy: false,
    enableColumnActions: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableEditing: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    enableSorting: false
};
const $30615b8e57e39efe$var$parseCSSVarId = (id)=>id.replace(/[^a-zA-Z0-9]/g, '_');
const $30615b8e57e39efe$var$MRT_Default_Icons = {
    ArrowDownwardIcon: (/*@__PURE__*/$parcel$interopDefault($360b945a377b2693$exports)),
    ArrowRightIcon: (/*@__PURE__*/$parcel$interopDefault($ac96b5c7f6335d4d$exports)),
    CancelIcon: (/*@__PURE__*/$parcel$interopDefault($4d4c13816d1d34ff$exports)),
    ClearAllIcon: (/*@__PURE__*/$parcel$interopDefault($1ed6d9bfed453ee5$exports)),
    CloseIcon: (/*@__PURE__*/$parcel$interopDefault($96c82ddda143b076$exports)),
    DensityLargeIcon: (/*@__PURE__*/$parcel$interopDefault($6849aa5219f1cc2d$exports)),
    DensityMediumIcon: (/*@__PURE__*/$parcel$interopDefault($92401a7502845fad$exports)),
    DensitySmallIcon: (/*@__PURE__*/$parcel$interopDefault($42478d5474d3e7b2$exports)),
    DragHandleIcon: (/*@__PURE__*/$parcel$interopDefault($52ecdc291bd78787$exports)),
    DynamicFeedIcon: (/*@__PURE__*/$parcel$interopDefault($6233d432df560262$exports)),
    EditIcon: (/*@__PURE__*/$parcel$interopDefault($da94f4c5a02c6653$exports)),
    ExpandMoreIcon: (/*@__PURE__*/$parcel$interopDefault($38a631335a5e3e4d$exports)),
    FilterAltIcon: (/*@__PURE__*/$parcel$interopDefault($20cfda2d8034ba61$exports)),
    FilterListIcon: (/*@__PURE__*/$parcel$interopDefault($904710f7e231e15a$exports)),
    FilterListOffIcon: (/*@__PURE__*/$parcel$interopDefault($8c2d7c2cbd278ba9$exports)),
    FullscreenExitIcon: (/*@__PURE__*/$parcel$interopDefault($393558b0ba6f17f2$exports)),
    FullscreenIcon: (/*@__PURE__*/$parcel$interopDefault($197c206fdf9ce5b9$exports)),
    KeyboardDoubleArrowDownIcon: (/*@__PURE__*/$parcel$interopDefault($562a6e41336f6c14$exports)),
    MoreHorizIcon: (/*@__PURE__*/$parcel$interopDefault($8a9dbc61eb72bd89$exports)),
    MoreVertIcon: (/*@__PURE__*/$parcel$interopDefault($2a3745f754b07b9d$exports)),
    PushPinIcon: (/*@__PURE__*/$parcel$interopDefault($f33540c66946258e$exports)),
    RestartAltIcon: (/*@__PURE__*/$parcel$interopDefault($c7559abc67ce699c$exports)),
    SaveIcon: (/*@__PURE__*/$parcel$interopDefault($37e0d9ec460a6a3e$exports)),
    SearchIcon: (/*@__PURE__*/$parcel$interopDefault($cd8e186c945e01b2$exports)),
    SearchOffIcon: (/*@__PURE__*/$parcel$interopDefault($15bb2397189258c2$exports)),
    SortIcon: (/*@__PURE__*/$parcel$interopDefault($3212fd072e017778$exports)),
    ViewColumnIcon: (/*@__PURE__*/$parcel$interopDefault($3a517130db63a3a4$exports)),
    VisibilityOffIcon: (/*@__PURE__*/$parcel$interopDefault($93de1ac22cf54d75$exports))
};
const $30615b8e57e39efe$var$MRT_Localization_EN = {
    actions: 'Actions',
    and: 'and',
    cancel: 'Cancel',
    changeFilterMode: 'Change filter mode',
    changeSearchMode: 'Change search mode',
    clearFilter: 'Clear filter',
    clearSearch: 'Clear search',
    clearSort: 'Clear sort',
    clickToCopy: 'Click to copy',
    collapse: 'Collapse',
    collapseAll: 'Collapse all',
    columnActions: 'Column Actions',
    copiedToClipboard: 'Copied to clipboard',
    dropToGroupBy: 'Drop to group by {column}',
    edit: 'Edit',
    expand: 'Expand',
    expandAll: 'Expand all',
    filterArrIncludes: 'Includes',
    filterArrIncludesAll: 'Includes all',
    filterArrIncludesSome: 'Includes',
    filterBetween: 'Between',
    filterBetweenInclusive: 'Between Inclusive',
    filterByColumn: 'Filter by {column}',
    filterContains: 'Contains',
    filterEmpty: 'Empty',
    filterEndsWith: 'Ends With',
    filterEquals: 'Equals',
    filterEqualsString: 'Equals',
    filterFuzzy: 'Fuzzy',
    filterGreaterThan: 'Greater Than',
    filterGreaterThanOrEqualTo: 'Greater Than Or Equal To',
    filterInNumberRange: 'Between',
    filterIncludesString: 'Contains',
    filterIncludesStringSensitive: 'Contains',
    filterLessThan: 'Less Than',
    filterLessThanOrEqualTo: 'Less Than Or Equal To',
    filterMode: 'Filter Mode: {filterType}',
    filterNotEmpty: 'Not Empty',
    filterNotEquals: 'Not Equals',
    filterStartsWith: 'Starts With',
    filterWeakEquals: 'Equals',
    filteringByColumn: 'Filtering by {column} - {filterType} {filterValue}',
    goToFirstPage: 'Go to first page',
    goToLastPage: 'Go to last page',
    goToNextPage: 'Go to next page',
    goToPreviousPage: 'Go to previous page',
    grab: 'Grab',
    groupByColumn: 'Group by {column}',
    groupedBy: 'Grouped by ',
    hideAll: 'Hide all',
    hideColumn: 'Hide {column} column',
    max: 'Max',
    min: 'Min',
    move: 'Move',
    noRecordsToDisplay: 'No records to display',
    noResultsFound: 'No results found',
    of: 'of',
    or: 'or',
    pinToLeft: 'Pin to left',
    pinToRight: 'Pin to right',
    resetColumnSize: 'Reset column size',
    resetOrder: 'Reset order',
    rowActions: 'Row Actions',
    rowNumber: '#',
    rowNumbers: 'Row Numbers',
    rowsPerPage: 'Rows per page',
    save: 'Save',
    search: 'Search',
    selectedCountOfRowCountRowsSelected: '{selectedCount} of {rowCount} row(s) selected',
    select: 'Select',
    showAll: 'Show all',
    showAllColumns: 'Show all columns',
    showHideColumns: 'Show/Hide columns',
    showHideFilters: 'Show/Hide filters',
    showHideSearch: 'Show/Hide search',
    sortByColumnAsc: 'Sort by {column} ascending',
    sortByColumnDesc: 'Sort by {column} descending',
    sortedByColumnAsc: 'Sorted by {column} ascending',
    sortedByColumnDesc: 'Sorted by {column} descending',
    thenBy: ', then by ',
    toggleDensity: 'Toggle density',
    toggleFullScreen: 'Toggle full screen',
    toggleSelectAll: 'Toggle select all',
    toggleSelectRow: 'Toggle select row',
    toggleVisibility: 'Toggle visibility',
    ungroupByColumn: 'Ungroup by {column}',
    unpin: 'Unpin',
    unpinAll: 'Unpin all',
    unsorted: 'Unsorted'
};
const $30615b8e57e39efe$var$MRT_ExpandAllButton = ({ table: table })=>{
    var _a, _b;
    const { getIsAllRowsExpanded: getIsAllRowsExpanded, getIsSomeRowsExpanded: getIsSomeRowsExpanded, getCanSomeRowsExpand: getCanSomeRowsExpand, getState: getState, options: { icons: { KeyboardDoubleArrowDownIcon: KeyboardDoubleArrowDownIcon }, localization: localization, muiExpandAllButtonProps: muiExpandAllButtonProps, renderDetailPanel: renderDetailPanel }, toggleAllRowsExpanded: toggleAllRowsExpanded } = table;
    const { density: density, isLoading: isLoading } = getState();
    const iconButtonProps = muiExpandAllButtonProps instanceof Function ? muiExpandAllButtonProps({
        table: table
    }) : muiExpandAllButtonProps;
    const isAllRowsExpanded = getIsAllRowsExpanded();
    return (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
        arrow: true,
        enterDelay: 1000,
        enterNextDelay: 1000,
        title: ((_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.title) !== null && _a !== void 0 ? _a : isAllRowsExpanded) ? localization.collapseAll : localization.expandAll,
        children: (0, $bHJbJ.jsx)("span", {
            children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), Object.assign({
                "aria-label": localization.expandAll,
                disabled: isLoading || !renderDetailPanel && !getCanSomeRowsExpand(),
                onClick: ()=>toggleAllRowsExpanded(!isAllRowsExpanded)
            }, iconButtonProps, {
                sx: (theme)=>Object.assign({
                        height: density === 'compact' ? '1.75rem' : '2.25rem',
                        width: density === 'compact' ? '1.75rem' : '2.25rem',
                        mt: density !== 'compact' ? '-0.25rem' : undefined
                    }, (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx) instanceof Function ? iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx(theme) : iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx),
                title: undefined,
                children: (_b = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.children) !== null && _b !== void 0 ? _b : (0, $bHJbJ.jsx)(KeyboardDoubleArrowDownIcon, {
                    style: {
                        transform: `rotate(${isAllRowsExpanded ? -180 : getIsSomeRowsExpanded() ? -90 : 0}deg)`,
                        transition: 'transform 150ms'
                    }
                })
            }))
        })
    });
};
const $30615b8e57e39efe$export$25237f0a7e0a5aea = ({ row: row, table: table })=>{
    var _a, _b;
    const { getState: getState, options: { icons: { ExpandMoreIcon: ExpandMoreIcon }, localization: localization, muiExpandButtonProps: muiExpandButtonProps, renderDetailPanel: renderDetailPanel } } = table;
    const { density: density } = getState();
    const iconButtonProps = muiExpandButtonProps instanceof Function ? muiExpandButtonProps({
        table: table,
        row: row
    }) : muiExpandButtonProps;
    const canExpand = row.getCanExpand();
    const isExpanded = row.getIsExpanded();
    const handleToggleExpand = (event)=>{
        var _a;
        event.stopPropagation();
        row.toggleExpanded();
        (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onClick) === null || _a === void 0 || _a.call(iconButtonProps, event);
    };
    return (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
        arrow: true,
        disableHoverListener: !canExpand && !renderDetailPanel,
        enterDelay: 1000,
        enterNextDelay: 1000,
        title: ((_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.title) !== null && _a !== void 0 ? _a : isExpanded) ? localization.collapse : localization.expand,
        children: (0, $bHJbJ.jsx)("span", {
            children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), Object.assign({
                "aria-label": localization.expand,
                disabled: !canExpand && !renderDetailPanel
            }, iconButtonProps, {
                onClick: handleToggleExpand,
                sx: (theme)=>Object.assign({
                        height: density === 'compact' ? '1.75rem' : '2.25rem',
                        width: density === 'compact' ? '1.75rem' : '2.25rem'
                    }, (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx) instanceof Function ? iconButtonProps.sx(theme) : iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx),
                title: undefined,
                children: (_b = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.children) !== null && _b !== void 0 ? _b : (0, $bHJbJ.jsx)(ExpandMoreIcon, {
                    style: {
                        transform: `rotate(${!canExpand && !renderDetailPanel ? -90 : isExpanded ? -180 : 0}deg)`,
                        transition: 'transform 150ms'
                    }
                })
            }))
        })
    });
};
const $30615b8e57e39efe$var$mrtFilterOptions = (localization)=>[
        {
            option: 'fuzzy',
            symbol: "\u2248",
            label: localization.filterFuzzy,
            divider: false
        },
        {
            option: 'contains',
            symbol: '*',
            label: localization.filterContains,
            divider: false
        },
        {
            option: 'startsWith',
            symbol: 'a',
            label: localization.filterStartsWith,
            divider: false
        },
        {
            option: 'endsWith',
            symbol: 'z',
            label: localization.filterEndsWith,
            divider: true
        },
        {
            option: 'equals',
            symbol: '=',
            label: localization.filterEquals,
            divider: false
        },
        {
            option: 'notEquals',
            symbol: "\u2260",
            label: localization.filterNotEquals,
            divider: true
        },
        {
            option: 'between',
            symbol: "\u21FF",
            label: localization.filterBetween,
            divider: false
        },
        {
            option: 'betweenInclusive',
            symbol: "\u2B0C",
            label: localization.filterBetweenInclusive,
            divider: true
        },
        {
            option: 'greaterThan',
            symbol: '>',
            label: localization.filterGreaterThan,
            divider: false
        },
        {
            option: 'greaterThanOrEqualTo',
            symbol: "\u2265",
            label: localization.filterGreaterThanOrEqualTo,
            divider: false
        },
        {
            option: 'lessThan',
            symbol: '<',
            label: localization.filterLessThan,
            divider: false
        },
        {
            option: 'lessThanOrEqualTo',
            symbol: "\u2264",
            label: localization.filterLessThanOrEqualTo,
            divider: true
        },
        {
            option: 'empty',
            symbol: "\u2205",
            label: localization.filterEmpty,
            divider: false
        },
        {
            option: 'notEmpty',
            symbol: "!\u2205",
            label: localization.filterNotEmpty,
            divider: false
        }
    ];
const $30615b8e57e39efe$var$rangeModes = [
    'between',
    'betweenInclusive',
    'inNumberRange'
];
const $30615b8e57e39efe$var$emptyModes = [
    'empty',
    'notEmpty'
];
const $30615b8e57e39efe$var$arrModes = [
    'arrIncludesSome',
    'arrIncludesAll',
    'arrIncludes'
];
const $30615b8e57e39efe$export$18f00246d050b1b5 = ({ anchorEl: anchorEl, header: header, onSelect: onSelect, setAnchorEl: setAnchorEl, setFilterValue: setFilterValue, table: table })=>{
    var _a, _b, _c, _d;
    const { getState: getState, options: { columnFilterModeOptions: columnFilterModeOptions, globalFilterModeOptions: globalFilterModeOptions, localization: localization, renderColumnFilterModeMenuItems: renderColumnFilterModeMenuItems, renderGlobalFilterModeMenuItems: renderGlobalFilterModeMenuItems }, setColumnFilterFns: setColumnFilterFns, setGlobalFilterFn: setGlobalFilterFn } = table;
    const { globalFilterFn: globalFilterFn, density: density } = getState();
    const { column: column } = header !== null && header !== void 0 ? header : {};
    const { columnDef: columnDef } = column !== null && column !== void 0 ? column : {};
    const currentFilterValue = column === null || column === void 0 ? void 0 : column.getFilterValue();
    let allowedColumnFilterOptions = (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef.columnFilterModeOptions) !== null && _a !== void 0 ? _a : columnFilterModeOptions;
    if ((columnDef === null || columnDef === void 0 ? void 0 : columnDef.filterVariant) === 'range-slider') allowedColumnFilterOptions = [
        ...$30615b8e57e39efe$var$rangeModes,
        ...allowedColumnFilterOptions !== null && allowedColumnFilterOptions !== void 0 ? allowedColumnFilterOptions : []
    ].filter((option)=>$30615b8e57e39efe$var$rangeModes.includes(option));
    const internalFilterOptions = (0, $i5lfL.useMemo)(()=>$30615b8e57e39efe$var$mrtFilterOptions(localization).filter((filterOption)=>columnDef ? allowedColumnFilterOptions === undefined || (allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions.includes(filterOption.option)) : (!globalFilterModeOptions || globalFilterModeOptions.includes(filterOption.option)) && [
                'fuzzy',
                'contains',
                'startsWith'
            ].includes(filterOption.option)), []);
    const handleSelectFilterMode = (option)=>{
        var _a;
        const prevFilterMode = (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef._filterFn) !== null && _a !== void 0 ? _a : '';
        if (!header || !column) // global filter mode
        setGlobalFilterFn(option);
        else if (option !== prevFilterMode) {
            // column filter mode
            setColumnFilterFns((prev)=>Object.assign(Object.assign({}, prev), {
                    [header.id]: option
                }));
            // reset filter value and/or perform new filter render
            if ($30615b8e57e39efe$var$emptyModes.includes(option)) {
                // will now be empty/notEmpty filter mode
                if (currentFilterValue !== ' ' && !$30615b8e57e39efe$var$emptyModes.includes(prevFilterMode)) column.setFilterValue(' ');
                else if (currentFilterValue) column.setFilterValue(currentFilterValue); // perform new filter render
            } else if ((columnDef === null || columnDef === void 0 ? void 0 : columnDef.filterVariant) === 'multi-select' || $30615b8e57e39efe$var$arrModes.includes(option)) {
                // will now be array filter mode
                if (currentFilterValue instanceof String || (currentFilterValue === null || currentFilterValue === void 0 ? void 0 : currentFilterValue.length)) {
                    column.setFilterValue([]);
                    setFilterValue === null || setFilterValue === void 0 || setFilterValue([]);
                } else if (currentFilterValue) column.setFilterValue(currentFilterValue); // perform new filter render
            } else if ((columnDef === null || columnDef === void 0 ? void 0 : columnDef.filterVariant) === 'range' || $30615b8e57e39efe$var$rangeModes.includes(option)) {
                // will now be range filter mode
                if (!Array.isArray(currentFilterValue) || !(currentFilterValue === null || currentFilterValue === void 0 ? void 0 : currentFilterValue.every((v)=>v === '')) && !$30615b8e57e39efe$var$rangeModes.includes(prevFilterMode)) {
                    column.setFilterValue([
                        '',
                        ''
                    ]);
                    setFilterValue === null || setFilterValue === void 0 || setFilterValue('');
                } else column.setFilterValue(currentFilterValue); // perform new filter render
            } else // will now be single value filter mode
            if (Array.isArray(currentFilterValue)) {
                column.setFilterValue('');
                setFilterValue === null || setFilterValue === void 0 || setFilterValue('');
            } else column.setFilterValue(currentFilterValue); // perform new filter render
        }
        setAnchorEl(null);
        onSelect === null || onSelect === void 0 || onSelect();
    };
    const filterOption = !!header && columnDef ? columnDef._filterFn : globalFilterFn;
    return (0, $bHJbJ.jsx)((0, $6e1d5d5a1ad3ef09$export$2e2bcd8739ae039), {
        anchorEl: anchorEl,
        anchorOrigin: {
            vertical: 'center',
            horizontal: 'right'
        },
        onClose: ()=>setAnchorEl(null),
        open: !!anchorEl,
        MenuListProps: {
            dense: density === 'compact'
        },
        children: (_d = header && column && columnDef ? (_c = (_b = columnDef.renderColumnFilterModeMenuItems) === null || _b === void 0 ? void 0 : _b.call(columnDef, {
            column: column,
            internalFilterOptions: internalFilterOptions,
            onSelectFilterMode: handleSelectFilterMode,
            table: table
        })) !== null && _c !== void 0 ? _c : renderColumnFilterModeMenuItems === null || renderColumnFilterModeMenuItems === void 0 ? void 0 : renderColumnFilterModeMenuItems({
            column: column,
            internalFilterOptions: internalFilterOptions,
            onSelectFilterMode: handleSelectFilterMode,
            table: table
        }) : renderGlobalFilterModeMenuItems === null || renderGlobalFilterModeMenuItems === void 0 ? void 0 : renderGlobalFilterModeMenuItems({
            internalFilterOptions: internalFilterOptions,
            onSelectFilterMode: handleSelectFilterMode,
            table: table
        })) !== null && _d !== void 0 ? _d : internalFilterOptions.map(({ option: option, label: label, divider: divider, symbol: symbol }, index)=>(0, $bHJbJ.jsxs)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                divider: divider,
                onClick: ()=>handleSelectFilterMode(option),
                selected: option === filterOption,
                sx: {
                    alignItems: 'center',
                    display: 'flex',
                    gap: '2ch',
                    my: 0,
                    py: '6px'
                },
                value: option,
                children: [
                    (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            fontSize: '1.25rem',
                            width: '2ch'
                        },
                        children: symbol
                    }),
                    label
                ]
            }, index))
    });
};
const $30615b8e57e39efe$var$commonMenuItemStyles = {
    py: '6px',
    my: 0,
    justifyContent: 'space-between',
    alignItems: 'center'
};
const $30615b8e57e39efe$var$commonListItemStyles = {
    display: 'flex',
    alignItems: 'center'
};
const $30615b8e57e39efe$var$MRT_ColumnActionMenu = ({ anchorEl: anchorEl, header: header, setAnchorEl: setAnchorEl, table: table })=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { getState: getState, toggleAllColumnsVisible: toggleAllColumnsVisible, setColumnOrder: setColumnOrder, options: { columnFilterModeOptions: columnFilterModeOptions, enableColumnFilterModes: enableColumnFilterModes, enableColumnFilters: enableColumnFilters, enableColumnResizing: enableColumnResizing, enableGrouping: enableGrouping, enableHiding: enableHiding, enablePinning: enablePinning, enableSorting: enableSorting, enableSortingRemoval: enableSortingRemoval, icons: { ArrowRightIcon: ArrowRightIcon, ClearAllIcon: ClearAllIcon, ViewColumnIcon: ViewColumnIcon, DynamicFeedIcon: DynamicFeedIcon, FilterListIcon: FilterListIcon, FilterListOffIcon: FilterListOffIcon, PushPinIcon: PushPinIcon, SortIcon: SortIcon, RestartAltIcon: RestartAltIcon, VisibilityOffIcon: VisibilityOffIcon }, localization: localization, renderColumnActionsMenuItems: renderColumnActionsMenuItems }, refs: { filterInputRefs: filterInputRefs }, setColumnSizingInfo: setColumnSizingInfo, setShowColumnFilters: setShowColumnFilters } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const { columnSizing: columnSizing, columnVisibility: columnVisibility, density: density, showColumnFilters: showColumnFilters } = getState();
    const columnFilterValue = column.getFilterValue();
    const [filterMenuAnchorEl, setFilterMenuAnchorEl] = (0, $i5lfL.useState)(null);
    const handleClearSort = ()=>{
        column.clearSorting();
        setAnchorEl(null);
    };
    const handleSortAsc = ()=>{
        column.toggleSorting(false);
        setAnchorEl(null);
    };
    const handleSortDesc = ()=>{
        column.toggleSorting(true);
        setAnchorEl(null);
    };
    const handleResetColumnSize = ()=>{
        setColumnSizingInfo((old)=>Object.assign(Object.assign({}, old), {
                isResizingColumn: false
            }));
        column.resetSize();
        setAnchorEl(null);
    };
    const handleHideColumn = ()=>{
        column.toggleVisibility(false);
        setAnchorEl(null);
    };
    const handlePinColumn = (pinDirection)=>{
        column.pin(pinDirection);
        setAnchorEl(null);
    };
    const handleGroupByColumn = ()=>{
        column.toggleGrouping();
        setColumnOrder((old)=>[
                'mrt-row-expand',
                ...old
            ]);
        setAnchorEl(null);
    };
    const handleClearFilter = ()=>{
        column.setFilterValue('');
        setAnchorEl(null);
    };
    const handleFilterByColumn = ()=>{
        setShowColumnFilters(true);
        queueMicrotask(()=>{
            var _a;
            return (_a = filterInputRefs.current[`${column.id}-0`]) === null || _a === void 0 ? void 0 : _a.focus();
        });
        setAnchorEl(null);
    };
    const handleShowAllColumns = ()=>{
        toggleAllColumnsVisible(true);
        setAnchorEl(null);
    };
    const handleOpenFilterModeMenu = (event)=>{
        event.stopPropagation();
        setFilterMenuAnchorEl(event.currentTarget);
    };
    const isSelectFilter = !!columnDef.filterSelectOptions;
    const allowedColumnFilterOptions = (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef.columnFilterModeOptions) !== null && _a !== void 0 ? _a : columnFilterModeOptions;
    const showFilterModeSubMenu = enableColumnFilterModes && columnDef.enableColumnFilterModes !== false && !isSelectFilter && (allowedColumnFilterOptions === undefined || !!(allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions.length));
    const internalColumnMenuItems = [
        ...enableSorting && column.getCanSort() ? [
            enableSortingRemoval !== false && (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                disabled: !column.getIsSorted(),
                onClick: handleClearSort,
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: $30615b8e57e39efe$var$commonListItemStyles,
                    children: [
                        (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                            children: (0, $bHJbJ.jsx)(ClearAllIcon, {})
                        }),
                        localization.clearSort
                    ]
                })
            }, 0),
            (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                disabled: column.getIsSorted() === 'asc',
                onClick: handleSortAsc,
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: $30615b8e57e39efe$var$commonListItemStyles,
                    children: [
                        (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                            children: (0, $bHJbJ.jsx)(SortIcon, {
                                style: {
                                    transform: 'rotate(180deg) scaleX(-1)'
                                }
                            })
                        }),
                        (_b = localization.sortByColumnAsc) === null || _b === void 0 ? void 0 : _b.replace('{column}', String(columnDef.header))
                    ]
                })
            }, 1),
            (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                divider: enableColumnFilters || enableGrouping || enableHiding,
                disabled: column.getIsSorted() === 'desc',
                onClick: handleSortDesc,
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: $30615b8e57e39efe$var$commonListItemStyles,
                    children: [
                        (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                            children: (0, $bHJbJ.jsx)(SortIcon, {})
                        }),
                        (_c = localization.sortByColumnDesc) === null || _c === void 0 ? void 0 : _c.replace('{column}', String(columnDef.header))
                    ]
                })
            }, 2)
        ] : [],
        ...enableColumnFilters && column.getCanFilter() ? [
            (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                disabled: !columnFilterValue || Array.isArray(columnFilterValue) && !columnFilterValue.filter((value)=>value).length,
                onClick: handleClearFilter,
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: $30615b8e57e39efe$var$commonListItemStyles,
                    children: [
                        (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                            children: (0, $bHJbJ.jsx)(FilterListOffIcon, {})
                        }),
                        localization.clearFilter
                    ]
                })
            }, 3),
            (0, $bHJbJ.jsxs)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                disabled: showColumnFilters && !enableColumnFilterModes,
                divider: enableGrouping || enableHiding,
                onClick: showColumnFilters ? handleOpenFilterModeMenu : handleFilterByColumn,
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: [
                    (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: $30615b8e57e39efe$var$commonListItemStyles,
                        children: [
                            (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                                children: (0, $bHJbJ.jsx)(FilterListIcon, {})
                            }),
                            (_d = localization.filterByColumn) === null || _d === void 0 ? void 0 : _d.replace('{column}', String(columnDef.header))
                        ]
                    }),
                    showFilterModeSubMenu && (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                        onClick: handleOpenFilterModeMenu,
                        onMouseEnter: handleOpenFilterModeMenu,
                        size: "small",
                        sx: {
                            p: 0
                        },
                        children: (0, $bHJbJ.jsx)(ArrowRightIcon, {})
                    })
                ]
            }, 4),
            showFilterModeSubMenu && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$18f00246d050b1b5, {
                anchorEl: filterMenuAnchorEl,
                header: header,
                onSelect: handleFilterByColumn,
                setAnchorEl: setFilterMenuAnchorEl,
                table: table
            }, 5)
        ] : [],
        ...enableGrouping && column.getCanGroup() ? [
            (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                divider: enablePinning,
                onClick: handleGroupByColumn,
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: $30615b8e57e39efe$var$commonListItemStyles,
                    children: [
                        (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                            children: (0, $bHJbJ.jsx)(DynamicFeedIcon, {})
                        }),
                        (_e = localization[column.getIsGrouped() ? 'ungroupByColumn' : 'groupByColumn']) === null || _e === void 0 ? void 0 : _e.replace('{column}', String(columnDef.header))
                    ]
                })
            }, 6)
        ] : [],
        ...enablePinning && column.getCanPin() ? [
            (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                disabled: column.getIsPinned() === 'left' || !column.getCanPin(),
                onClick: ()=>handlePinColumn('left'),
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: $30615b8e57e39efe$var$commonListItemStyles,
                    children: [
                        (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                            children: (0, $bHJbJ.jsx)(PushPinIcon, {
                                style: {
                                    transform: 'rotate(90deg)'
                                }
                            })
                        }),
                        localization.pinToLeft
                    ]
                })
            }, 7),
            (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                disabled: column.getIsPinned() === 'right' || !column.getCanPin(),
                onClick: ()=>handlePinColumn('right'),
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: $30615b8e57e39efe$var$commonListItemStyles,
                    children: [
                        (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                            children: (0, $bHJbJ.jsx)(PushPinIcon, {
                                style: {
                                    transform: 'rotate(-90deg)'
                                }
                            })
                        }),
                        localization.pinToRight
                    ]
                })
            }, 8),
            (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                disabled: !column.getIsPinned(),
                divider: enableHiding,
                onClick: ()=>handlePinColumn(false),
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: $30615b8e57e39efe$var$commonListItemStyles,
                    children: [
                        (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                            children: (0, $bHJbJ.jsx)(PushPinIcon, {})
                        }),
                        localization.unpin
                    ]
                })
            }, 9)
        ] : [],
        ...enableColumnResizing && column.getCanResize() ? [
            (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                disabled: !columnSizing[column.id],
                onClick: handleResetColumnSize,
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: $30615b8e57e39efe$var$commonListItemStyles,
                    children: [
                        (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                            children: (0, $bHJbJ.jsx)(RestartAltIcon, {})
                        }),
                        localization.resetColumnSize
                    ]
                })
            }, 10)
        ] : [],
        ...enableHiding ? [
            (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                disabled: !column.getCanHide(),
                onClick: handleHideColumn,
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: $30615b8e57e39efe$var$commonListItemStyles,
                    children: [
                        (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                            children: (0, $bHJbJ.jsx)(VisibilityOffIcon, {})
                        }),
                        (_f = localization.hideColumn) === null || _f === void 0 ? void 0 : _f.replace('{column}', String(columnDef.header))
                    ]
                })
            }, 11),
            (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                disabled: !Object.values(columnVisibility).filter((visible)=>!visible).length,
                onClick: handleShowAllColumns,
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: $30615b8e57e39efe$var$commonListItemStyles,
                    children: [
                        (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                            children: (0, $bHJbJ.jsx)(ViewColumnIcon, {})
                        }),
                        (_g = localization.showAllColumns) === null || _g === void 0 ? void 0 : _g.replace('{column}', String(columnDef.header))
                    ]
                })
            }, 12)
        ] : []
    ].filter(Boolean);
    return (0, $bHJbJ.jsx)((0, $6e1d5d5a1ad3ef09$export$2e2bcd8739ae039), {
        anchorEl: anchorEl,
        open: !!anchorEl,
        onClose: ()=>setAnchorEl(null),
        MenuListProps: {
            dense: density === 'compact'
        },
        children: (_k = (_j = (_h = columnDef.renderColumnActionsMenuItems) === null || _h === void 0 ? void 0 : _h.call(columnDef, {
            closeMenu: ()=>setAnchorEl(null),
            column: column,
            internalColumnMenuItems: internalColumnMenuItems,
            table: table
        })) !== null && _j !== void 0 ? _j : renderColumnActionsMenuItems === null || renderColumnActionsMenuItems === void 0 ? void 0 : renderColumnActionsMenuItems({
            closeMenu: ()=>setAnchorEl(null),
            column: column,
            internalColumnMenuItems: internalColumnMenuItems,
            table: table
        })) !== null && _k !== void 0 ? _k : internalColumnMenuItems
    });
};
const $30615b8e57e39efe$var$MRT_RowActionMenu = ({ anchorEl: anchorEl, handleEdit: handleEdit, row: row, setAnchorEl: setAnchorEl, table: table })=>{
    const { getState: getState, options: { icons: { EditIcon: EditIcon }, enableEditing: enableEditing, localization: localization, renderRowActionMenuItems: renderRowActionMenuItems } } = table;
    const { density: density } = getState();
    return (0, $bHJbJ.jsxs)((0, $6e1d5d5a1ad3ef09$export$2e2bcd8739ae039), {
        anchorEl: anchorEl,
        open: !!anchorEl,
        onClick: (event)=>event.stopPropagation(),
        onClose: ()=>setAnchorEl(null),
        MenuListProps: {
            dense: density === 'compact'
        },
        children: [
            enableEditing instanceof Function ? enableEditing(row) : enableEditing && (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                onClick: handleEdit,
                sx: $30615b8e57e39efe$var$commonMenuItemStyles,
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: $30615b8e57e39efe$var$commonListItemStyles,
                    children: [
                        (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                            children: (0, $bHJbJ.jsx)(EditIcon, {})
                        }),
                        localization.edit
                    ]
                })
            }),
            renderRowActionMenuItems === null || renderRowActionMenuItems === void 0 ? void 0 : renderRowActionMenuItems({
                row: row,
                table: table,
                closeMenu: ()=>setAnchorEl(null)
            })
        ]
    });
};
const $30615b8e57e39efe$export$e9ac3fa68bee6831 = ({ row: row, table: table, variant: variant = 'icon' })=>{
    const { getState: getState, options: { icons: { CancelIcon: CancelIcon, SaveIcon: SaveIcon }, localization: localization, onEditingRowSave: onEditingRowSave, onEditingRowCancel: onEditingRowCancel }, refs: { editInputRefs: editInputRefs }, setEditingRow: setEditingRow } = table;
    const { editingRow: editingRow } = getState();
    const handleCancel = ()=>{
        onEditingRowCancel === null || onEditingRowCancel === void 0 || onEditingRowCancel({
            row: row,
            table: table
        });
        setEditingRow(null);
    };
    const handleSave = ()=>{
        var _a, _b;
        //look for auto-filled input values
        (_a = Object.values(editInputRefs === null || editInputRefs === void 0 ? void 0 : editInputRefs.current)) === null || _a === void 0 || _a.forEach((input)=>{
            if (input.value !== undefined && Object.hasOwn(editingRow === null || editingRow === void 0 ? void 0 : editingRow._valuesCache, input.name)) // @ts-ignore
            editingRow._valuesCache[input.name] = input.value;
        });
        onEditingRowSave === null || onEditingRowSave === void 0 || onEditingRowSave({
            exitEditingMode: ()=>setEditingRow(null),
            row: editingRow !== null && editingRow !== void 0 ? editingRow : row,
            table: table,
            values: (_b = editingRow === null || editingRow === void 0 ? void 0 : editingRow._valuesCache) !== null && _b !== void 0 ? _b : Object.assign({}, row.original)
        });
    };
    return (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        onClick: (e)=>e.stopPropagation(),
        sx: {
            display: 'flex',
            gap: '0.75rem'
        },
        children: variant === 'icon' ? (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
            children: [
                (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                    arrow: true,
                    title: localization.cancel,
                    children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                        "aria-label": localization.cancel,
                        onClick: handleCancel,
                        children: (0, $bHJbJ.jsx)(CancelIcon, {})
                    })
                }),
                (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                    arrow: true,
                    title: localization.save,
                    children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                        "aria-label": localization.save,
                        color: "info",
                        onClick: handleSave,
                        children: (0, $bHJbJ.jsx)(SaveIcon, {})
                    })
                })
            ]
        }) : (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
            children: [
                (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                    onClick: handleCancel,
                    children: localization.cancel
                }),
                (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                    onClick: handleSave,
                    variant: "contained",
                    children: localization.save
                })
            ]
        })
    });
};
const $30615b8e57e39efe$var$commonIconButtonStyles = {
    height: '2rem',
    ml: '10px',
    opacity: 0.5,
    transition: 'opacity 150ms',
    width: '2rem',
    '&:hover': {
        opacity: 1
    }
};
const $30615b8e57e39efe$export$d1d7822219c6bc0 = ({ cell: cell, row: row, table: table })=>{
    const { getState: getState, options: { editingMode: editingMode, enableEditing: enableEditing, icons: { EditIcon: EditIcon, MoreHorizIcon: MoreHorizIcon }, localization: localization, renderRowActionMenuItems: renderRowActionMenuItems, renderRowActions: renderRowActions }, setEditingRow: setEditingRow } = table;
    const { editingRow: editingRow } = getState();
    const [anchorEl, setAnchorEl] = (0, $i5lfL.useState)(null);
    const handleOpenRowActionMenu = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    const handleStartEditMode = (event)=>{
        event.stopPropagation();
        setEditingRow(Object.assign({}, row));
        setAnchorEl(null);
    };
    return (0, $bHJbJ.jsx)((0, $bHJbJ.Fragment), {
        children: renderRowActions ? renderRowActions({
            cell: cell,
            row: row,
            table: table
        }) : row.id === (editingRow === null || editingRow === void 0 ? void 0 : editingRow.id) && editingMode === 'row' ? (0, $bHJbJ.jsx)($30615b8e57e39efe$export$e9ac3fa68bee6831, {
            row: row,
            table: table
        }) : !renderRowActionMenuItems && (enableEditing instanceof Function ? enableEditing(row) : enableEditing) ? (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
            placement: "right",
            arrow: true,
            title: localization.edit,
            children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                "aria-label": localization.edit,
                sx: $30615b8e57e39efe$var$commonIconButtonStyles,
                onClick: handleStartEditMode,
                children: (0, $bHJbJ.jsx)(EditIcon, {})
            })
        }) : renderRowActionMenuItems ? (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
            children: [
                (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                    arrow: true,
                    enterDelay: 1000,
                    enterNextDelay: 1000,
                    title: localization.rowActions,
                    children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                        "aria-label": localization.rowActions,
                        onClick: handleOpenRowActionMenu,
                        size: "small",
                        sx: $30615b8e57e39efe$var$commonIconButtonStyles,
                        children: (0, $bHJbJ.jsx)(MoreHorizIcon, {})
                    })
                }),
                (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_RowActionMenu, {
                    anchorEl: anchorEl,
                    handleEdit: handleStartEditMode,
                    row: row,
                    setAnchorEl: setAnchorEl,
                    table: table
                })
            ]
        }) : null
    });
};
const $30615b8e57e39efe$var$MRT_SelectCheckbox = ({ row: row, selectAll: selectAll, table: table })=>{
    var _a;
    const { getState: getState, options: { localization: localization, enableMultiRowSelection: enableMultiRowSelection, muiSelectCheckboxProps: muiSelectCheckboxProps, muiSelectAllCheckboxProps: muiSelectAllCheckboxProps, selectAllMode: selectAllMode } } = table;
    const { density: density, isLoading: isLoading } = getState();
    const checkboxProps = !row ? muiSelectAllCheckboxProps instanceof Function ? muiSelectAllCheckboxProps({
        table: table
    }) : muiSelectAllCheckboxProps : muiSelectCheckboxProps instanceof Function ? muiSelectCheckboxProps({
        row: row,
        table: table
    }) : muiSelectCheckboxProps;
    const allRowsSelected = selectAll ? selectAllMode === 'page' ? table.getIsAllPageRowsSelected() : table.getIsAllRowsSelected() : undefined;
    const commonProps = Object.assign(Object.assign({
        checked: selectAll ? allRowsSelected : row === null || row === void 0 ? void 0 : row.getIsSelected(),
        disabled: isLoading || row && !row.getCanSelect(),
        inputProps: {
            'aria-label': selectAll ? localization.toggleSelectAll : localization.toggleSelectRow
        },
        onChange: row ? row.getToggleSelectedHandler() : selectAllMode === 'all' ? table.getToggleAllRowsSelectedHandler() : table.getToggleAllPageRowsSelectedHandler(),
        size: density === 'compact' ? 'small' : 'medium'
    }, checkboxProps), {
        onClick: (e)=>{
            var _a;
            e.stopPropagation();
            (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onClick) === null || _a === void 0 || _a.call(checkboxProps, e);
        },
        sx: (theme)=>Object.assign({
                height: density === 'compact' ? '1.75rem' : '2.5rem',
                width: density === 'compact' ? '1.75rem' : '2.5rem',
                m: density !== 'compact' ? '-0.4rem' : undefined
            }, (checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.sx) instanceof Function ? checkboxProps.sx(theme) : checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.sx),
        title: undefined
    });
    return (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
        arrow: true,
        enterDelay: 1000,
        enterNextDelay: 1000,
        title: (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.title) !== null && _a !== void 0 ? _a : selectAll ? localization.toggleSelectAll : localization.toggleSelectRow,
        children: enableMultiRowSelection === false ? (0, $bHJbJ.jsx)((0, $74fd16a7f0f411f6$export$2e2bcd8739ae039), Object.assign({}, commonProps)) : (0, $bHJbJ.jsx)((0, $842f67eebadd25d0$export$2e2bcd8739ae039), Object.assign({
            indeterminate: selectAll ? table.getIsSomeRowsSelected() && !allRowsSelected : row === null || row === void 0 ? void 0 : row.getIsSomeSelected()
        }, commonProps))
    });
};
const $30615b8e57e39efe$export$d802562b525f204b = ({ table: table })=>{
    var _a;
    const { getState: getState, setGlobalFilter: setGlobalFilter, options: { enableGlobalFilterModes: enableGlobalFilterModes, icons: { SearchIcon: SearchIcon, CloseIcon: CloseIcon }, localization: localization, manualFiltering: manualFiltering, muiSearchTextFieldProps: muiSearchTextFieldProps }, refs: { searchInputRef: searchInputRef } } = table;
    const { globalFilter: globalFilter, showGlobalFilter: showGlobalFilter } = getState();
    const textFieldProps = muiSearchTextFieldProps instanceof Function ? muiSearchTextFieldProps({
        table: table
    }) : muiSearchTextFieldProps;
    const isMounted = (0, $i5lfL.useRef)(false);
    const [anchorEl, setAnchorEl] = (0, $i5lfL.useState)(null);
    const [searchValue, setSearchValue] = (0, $i5lfL.useState)(globalFilter !== null && globalFilter !== void 0 ? globalFilter : '');
    const handleChangeDebounced = (0, $i5lfL.useCallback)((0, $35800e9c430cfaca$export$2e2bcd8739ae039)((event)=>{
        var _a;
        setGlobalFilter((_a = event.target.value) !== null && _a !== void 0 ? _a : undefined);
    }, manualFiltering ? 500 : 250), []);
    const handleChange = (event)=>{
        setSearchValue(event.target.value);
        handleChangeDebounced(event);
    };
    const handleGlobalFilterMenuOpen = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClear = ()=>{
        setSearchValue('');
        setGlobalFilter(undefined);
    };
    (0, $i5lfL.useEffect)(()=>{
        if (isMounted.current) {
            if (globalFilter === undefined) handleClear();
            else setSearchValue(globalFilter);
        }
        isMounted.current = true;
    }, [
        globalFilter
    ]);
    return (0, $bHJbJ.jsxs)((0, $8d561c5085503182$export$2e2bcd8739ae039), {
        in: showGlobalFilter,
        orientation: "horizontal",
        unmountOnExit: true,
        mountOnEnter: true,
        children: [
            (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), Object.assign({
                placeholder: localization.search,
                onChange: handleChange,
                value: searchValue !== null && searchValue !== void 0 ? searchValue : '',
                variant: "standard",
                InputProps: {
                    startAdornment: enableGlobalFilterModes ? (0, $bHJbJ.jsx)((0, $b99dc77e886c5558$export$2e2bcd8739ae039), {
                        position: "start",
                        children: (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                            arrow: true,
                            title: localization.changeSearchMode,
                            children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                                "aria-label": localization.changeSearchMode,
                                onClick: handleGlobalFilterMenuOpen,
                                size: "small",
                                sx: {
                                    height: '1.75rem',
                                    width: '1.75rem'
                                },
                                children: (0, $bHJbJ.jsx)(SearchIcon, {})
                            })
                        })
                    }) : (0, $bHJbJ.jsx)(SearchIcon, {
                        style: {
                            marginRight: '4px'
                        }
                    }),
                    endAdornment: (0, $bHJbJ.jsx)((0, $b99dc77e886c5558$export$2e2bcd8739ae039), {
                        position: "end",
                        children: (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                            arrow: true,
                            title: (_a = localization.clearSearch) !== null && _a !== void 0 ? _a : '',
                            children: (0, $bHJbJ.jsx)("span", {
                                children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                                    "aria-label": localization.clearSearch,
                                    disabled: !(searchValue === null || searchValue === void 0 ? void 0 : searchValue.length),
                                    onClick: handleClear,
                                    size: "small",
                                    children: (0, $bHJbJ.jsx)(CloseIcon, {})
                                })
                            })
                        })
                    })
                }
            }, textFieldProps, {
                inputRef: (inputRef)=>{
                    searchInputRef.current = inputRef;
                    if (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.inputRef) textFieldProps.inputRef = inputRef;
                }
            })),
            (0, $bHJbJ.jsx)($30615b8e57e39efe$export$18f00246d050b1b5, {
                anchorEl: anchorEl,
                setAnchorEl: setAnchorEl,
                table: table,
                onSelect: handleClear
            })
        ]
    });
};
const $30615b8e57e39efe$var$MRT_LinearProgressBar = ({ isTopToolbar: isTopToolbar, table: table })=>{
    const { options: { muiLinearProgressProps: muiLinearProgressProps }, getState: getState } = table;
    const { isLoading: isLoading, showProgressBars: showProgressBars } = getState();
    const linearProgressProps = muiLinearProgressProps instanceof Function ? muiLinearProgressProps({
        isTopToolbar: isTopToolbar,
        table: table
    }) : muiLinearProgressProps;
    return (0, $bHJbJ.jsx)((0, $8d561c5085503182$export$2e2bcd8739ae039), {
        in: isLoading || showProgressBars,
        mountOnEnter: true,
        unmountOnExit: true,
        sx: {
            bottom: isTopToolbar ? 0 : undefined,
            position: 'absolute',
            top: !isTopToolbar ? 0 : undefined,
            width: '100%'
        },
        children: (0, $bHJbJ.jsx)((0, $2fce601e44012509$export$2e2bcd8739ae039), Object.assign({
            "aria-label": "Loading",
            "aria-busy": "true",
            sx: {
                position: 'relative'
            }
        }, linearProgressProps))
    });
};
const $30615b8e57e39efe$export$bd75343f17999fc0 = ({ table: table, position: position = 'bottom' })=>{
    const { getPrePaginationRowModel: getPrePaginationRowModel, getState: getState, setPageIndex: setPageIndex, setPageSize: setPageSize, options: { muiTablePaginationProps: muiTablePaginationProps, enableToolbarInternalActions: enableToolbarInternalActions, localization: localization, rowCount: rowCount } } = table;
    const { pagination: { pageSize: pageSize = 10, pageIndex: pageIndex = 0 }, showGlobalFilter: showGlobalFilter } = getState();
    const totalRowCount = rowCount !== null && rowCount !== void 0 ? rowCount : getPrePaginationRowModel().rows.length;
    const showFirstLastPageButtons = totalRowCount / pageSize > 2;
    const tablePaginationProps = muiTablePaginationProps instanceof Function ? muiTablePaginationProps({
        table: table
    }) : muiTablePaginationProps;
    const handleChangeRowsPerPage = (event)=>{
        setPageSize(+event.target.value);
    };
    return (0, $bHJbJ.jsx)((0, $76f94921d9955c2e$export$2e2bcd8739ae039), Object.assign({
        component: "div",
        count: totalRowCount,
        getItemAriaLabel: (type)=>type === 'first' ? localization.goToFirstPage : type === 'last' ? localization.goToLastPage : type === 'next' ? localization.goToNextPage : localization.goToPreviousPage,
        labelDisplayedRows: ({ from: from, to: to, count: count })=>`${from}-${to} ${localization.of} ${count}`,
        labelRowsPerPage: localization.rowsPerPage,
        onPageChange: (_, newPage)=>setPageIndex(newPage),
        onRowsPerPageChange: handleChangeRowsPerPage,
        page: Math.max(Math.min(pageIndex, Math.ceil(totalRowCount / pageSize) - 1), 0),
        rowsPerPage: pageSize,
        rowsPerPageOptions: [
            5,
            10,
            15,
            20,
            25,
            30,
            50,
            100
        ],
        showFirstButton: showFirstLastPageButtons,
        showLastButton: showFirstLastPageButtons
    }, tablePaginationProps, {
        SelectProps: Object.assign({
            sx: {
                m: '0 1rem 0 1ch'
            },
            MenuProps: {
                MenuListProps: {
                    disablePadding: true
                },
                sx: {
                    m: 0
                }
            }
        }, tablePaginationProps === null || tablePaginationProps === void 0 ? void 0 : tablePaginationProps.SelectProps),
        sx: (theme)=>Object.assign({
                '& .MuiTablePagination-toolbar': {
                    display: 'flex',
                    alignItems: 'center'
                },
                '& .MuiTablePagination-selectLabel': {
                    m: '0 -1px'
                },
                '&. MuiInputBase-root': {
                    m: '0 1px'
                },
                '& . MuiTablePagination-select': {
                    m: '0 1px'
                },
                '& .MuiTablePagination-displayedRows': {
                    m: '0 1px'
                },
                '& .MuiTablePagination-actions': {
                    m: '0 1px'
                },
                mt: position === 'top' && enableToolbarInternalActions && !showGlobalFilter ? '3.5rem' : undefined,
                position: 'relative',
                zIndex: 2
            }, (tablePaginationProps === null || tablePaginationProps === void 0 ? void 0 : tablePaginationProps.sx) instanceof Function ? tablePaginationProps.sx(theme) : tablePaginationProps === null || tablePaginationProps === void 0 ? void 0 : tablePaginationProps.sx)
    }));
};
const $30615b8e57e39efe$export$182b9e76a987279b = ({ stackAlertBanner: stackAlertBanner, table: table })=>{
    var _a, _b;
    const { getPrePaginationRowModel: getPrePaginationRowModel, getSelectedRowModel: getSelectedRowModel, getState: getState, options: { localization: localization, muiToolbarAlertBannerProps: muiToolbarAlertBannerProps, muiToolbarAlertBannerChipProps: muiToolbarAlertBannerChipProps, positionToolbarAlertBanner: positionToolbarAlertBanner, rowCount: rowCount } } = table;
    const { grouping: grouping, showAlertBanner: showAlertBanner } = getState();
    const alertProps = muiToolbarAlertBannerProps instanceof Function ? muiToolbarAlertBannerProps({
        table: table
    }) : muiToolbarAlertBannerProps;
    const chipProps = muiToolbarAlertBannerChipProps instanceof Function ? muiToolbarAlertBannerChipProps({
        table: table
    }) : muiToolbarAlertBannerChipProps;
    const selectMessage = getSelectedRowModel().rows.length > 0 ? (_b = (_a = localization.selectedCountOfRowCountRowsSelected) === null || _a === void 0 ? void 0 : _a.replace('{selectedCount}', getSelectedRowModel().rows.length.toString())) === null || _b === void 0 ? void 0 : _b.replace('{rowCount}', (rowCount !== null && rowCount !== void 0 ? rowCount : getPrePaginationRowModel().rows.length).toString()) : null;
    const groupedByMessage = grouping.length > 0 ? (0, $bHJbJ.jsxs)("span", {
        children: [
            localization.groupedBy,
            ' ',
            grouping.map((columnId, index)=>(0, $bHJbJ.jsxs)((0, $i5lfL.Fragment), {
                    children: [
                        index > 0 ? localization.thenBy : '',
                        (0, $bHJbJ.jsx)((0, $8a1b9da49508a793$export$2e2bcd8739ae039), Object.assign({
                            label: table.getColumn(columnId).columnDef.header,
                            onDelete: ()=>table.getColumn(columnId).toggleGrouping()
                        }, chipProps))
                    ]
                }, `${index}-${columnId}`))
        ]
    }) : null;
    return (0, $bHJbJ.jsx)((0, $8d561c5085503182$export$2e2bcd8739ae039), {
        in: showAlertBanner || !!selectMessage || !!groupedByMessage,
        timeout: stackAlertBanner ? 200 : 0,
        children: (0, $bHJbJ.jsxs)((0, $097160938072b98e$export$2e2bcd8739ae039), Object.assign({
            color: "info",
            icon: false
        }, alertProps, {
            sx: (theme)=>Object.assign({
                    borderRadius: 0,
                    fontSize: '1rem',
                    left: 0,
                    p: 0,
                    position: 'relative',
                    mb: stackAlertBanner ? 0 : positionToolbarAlertBanner === 'bottom' ? '-1rem' : undefined,
                    right: 0,
                    top: 0,
                    width: '100%',
                    zIndex: 2
                }, (alertProps === null || alertProps === void 0 ? void 0 : alertProps.sx) instanceof Function ? alertProps.sx(theme) : alertProps === null || alertProps === void 0 ? void 0 : alertProps.sx),
            children: [
                (alertProps === null || alertProps === void 0 ? void 0 : alertProps.title) && (0, $bHJbJ.jsx)((0, $56526f3260167a91$export$2e2bcd8739ae039), {
                    children: alertProps.title
                }),
                (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        p: '0.5rem 1rem'
                    },
                    children: [
                        alertProps === null || alertProps === void 0 ? void 0 : alertProps.children,
                        (alertProps === null || alertProps === void 0 ? void 0 : alertProps.children) && (selectMessage || groupedByMessage) && (0, $bHJbJ.jsx)("br", {}),
                        selectMessage,
                        selectMessage && groupedByMessage && (0, $bHJbJ.jsx)("br", {}),
                        groupedByMessage
                    ]
                })
            ]
        }))
    });
};
const $30615b8e57e39efe$export$292cb709c1b05af0 = (_a)=>{
    var _b;
    var { table: table } = _a, rest = $30615b8e57e39efe$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { icons: { FullscreenExitIcon: FullscreenExitIcon, FullscreenIcon: FullscreenIcon }, localization: localization }, setIsFullScreen: setIsFullScreen } = table;
    const { isFullScreen: isFullScreen } = getState();
    const handleToggleFullScreen = ()=>{
        setIsFullScreen(!isFullScreen);
    };
    return (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
        arrow: true,
        title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.toggleFullScreen,
        children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), Object.assign({
            "aria-label": localization.showHideFilters,
            onClick: handleToggleFullScreen
        }, rest, {
            title: undefined,
            children: isFullScreen ? (0, $bHJbJ.jsx)(FullscreenExitIcon, {}) : (0, $bHJbJ.jsx)(FullscreenIcon, {})
        }))
    });
};
const $30615b8e57e39efe$var$MRT_ColumnPinningButtons = ({ column: column, table: table })=>{
    const { options: { icons: { PushPinIcon: PushPinIcon }, localization: localization } } = table;
    const handlePinColumn = (pinDirection)=>{
        column.pin(pinDirection);
    };
    return (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        sx: {
            minWidth: '70px',
            textAlign: 'center'
        },
        children: column.getIsPinned() ? (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
            arrow: true,
            title: localization.unpin,
            children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                onClick: ()=>handlePinColumn(false),
                size: "small",
                children: (0, $bHJbJ.jsx)(PushPinIcon, {})
            })
        }) : (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
            children: [
                (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                    arrow: true,
                    title: localization.pinToLeft,
                    children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                        onClick: ()=>handlePinColumn('left'),
                        size: "small",
                        children: (0, $bHJbJ.jsx)(PushPinIcon, {
                            style: {
                                transform: 'rotate(90deg)'
                            }
                        })
                    })
                }),
                (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                    arrow: true,
                    title: localization.pinToRight,
                    children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                        onClick: ()=>handlePinColumn('right'),
                        size: "small",
                        children: (0, $bHJbJ.jsx)(PushPinIcon, {
                            style: {
                                transform: 'rotate(-90deg)'
                            }
                        })
                    })
                })
            ]
        })
    });
};
const $30615b8e57e39efe$export$84d0ca45a1213a16 = ({ iconButtonProps: iconButtonProps, onDragEnd: onDragEnd, onDragStart: onDragStart, table: table })=>{
    var _a;
    const { options: { icons: { DragHandleIcon: DragHandleIcon }, localization: localization } } = table;
    return (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
        arrow: true,
        enterDelay: 1000,
        enterNextDelay: 1000,
        placement: "top",
        title: (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.title) !== null && _a !== void 0 ? _a : localization.move,
        children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), Object.assign({
            disableRipple: true,
            draggable: "true",
            size: "small"
        }, iconButtonProps, {
            onClick: (e)=>{
                var _a;
                e.stopPropagation();
                (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onClick) === null || _a === void 0 || _a.call(iconButtonProps, e);
            },
            onDragStart: onDragStart,
            onDragEnd: onDragEnd,
            sx: (theme)=>Object.assign({
                    cursor: 'grab',
                    m: '0 -0.1rem',
                    opacity: 0.5,
                    p: '2px',
                    transition: 'all 150ms ease-in-out',
                    '&:hover': {
                        backgroundColor: 'transparent',
                        opacity: 1
                    },
                    '&:active': {
                        cursor: 'grabbing'
                    }
                }, (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx) instanceof Function ? iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx(theme) : iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx),
            title: undefined,
            children: (0, $bHJbJ.jsx)(DragHandleIcon, {})
        }))
    });
};
const $30615b8e57e39efe$var$MRT_ShowHideColumnsMenuItems = ({ allColumns: allColumns, hoveredColumn: hoveredColumn, setHoveredColumn: setHoveredColumn, column: column, table: table })=>{
    var _a;
    const { getState: getState, options: { enableColumnOrdering: enableColumnOrdering, enableHiding: enableHiding, enablePinning: enablePinning, localization: localization }, setColumnOrder: setColumnOrder } = table;
    const { columnOrder: columnOrder } = getState();
    const { columnDef: columnDef } = column;
    const { columnDefType: columnDefType } = columnDef;
    const switchChecked = columnDefType !== 'group' && column.getIsVisible() || columnDefType === 'group' && column.getLeafColumns().some((col)=>col.getIsVisible());
    const handleToggleColumnHidden = (column)=>{
        var _a, _b;
        if (columnDefType === 'group') (_b = (_a = column === null || column === void 0 ? void 0 : column.columns) === null || _a === void 0 ? void 0 : _a.forEach) === null || _b === void 0 || _b.call(_a, (childColumn)=>{
            childColumn.toggleVisibility(!switchChecked);
        });
        else column.toggleVisibility();
    };
    const menuItemRef = (0, $i5lfL.useRef)(null);
    const [isDragging, setIsDragging] = (0, $i5lfL.useState)(false);
    const handleDragStart = (e)=>{
        setIsDragging(true);
        e.dataTransfer.setDragImage(menuItemRef.current, 0, 0);
    };
    const handleDragEnd = (_e)=>{
        setIsDragging(false);
        setHoveredColumn(null);
        if (hoveredColumn) setColumnOrder($30615b8e57e39efe$var$reorderColumn(column, hoveredColumn, columnOrder));
    };
    const handleDragEnter = (_e)=>{
        if (!isDragging && columnDef.enableColumnOrdering !== false) setHoveredColumn(column);
    };
    return (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
        children: [
            (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                disableRipple: true,
                ref: menuItemRef,
                onDragEnter: handleDragEnter,
                sx: (theme)=>({
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        my: 0,
                        opacity: isDragging ? 0.5 : 1,
                        outlineOffset: '-2px',
                        outline: isDragging ? `2px dashed ${theme.palette.divider}` : (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === column.id ? `2px dashed ${theme.palette.primary.main}` : 'none',
                        pl: `${(column.depth + 0.5) * 2}rem`,
                        py: '6px'
                    }),
                children: (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        flexWrap: 'nowrap',
                        gap: '8px'
                    },
                    children: [
                        columnDefType !== 'group' && enableColumnOrdering && !allColumns.some((col)=>col.columnDef.columnDefType === 'group') && (columnDef.enableColumnOrdering !== false ? (0, $bHJbJ.jsx)($30615b8e57e39efe$export$84d0ca45a1213a16, {
                            onDragEnd: handleDragEnd,
                            onDragStart: handleDragStart,
                            table: table
                        }) : (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                width: '28px'
                            }
                        })),
                        enablePinning && (column.getCanPin() ? (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_ColumnPinningButtons, {
                            column: column,
                            table: table
                        }) : (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                width: '70px'
                            }
                        })),
                        enableHiding ? (0, $bHJbJ.jsx)((0, $3da2083f6f3ac88d$export$2e2bcd8739ae039), {
                            componentsProps: {
                                typography: {
                                    sx: {
                                        mb: 0,
                                        opacity: columnDefType !== 'display' ? 1 : 0.5
                                    }
                                }
                            },
                            checked: switchChecked,
                            control: (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                                arrow: true,
                                enterDelay: 1000,
                                enterNextDelay: 1000,
                                title: localization.toggleVisibility,
                                children: (0, $bHJbJ.jsx)((0, $e9f0cd073f9086e4$export$2e2bcd8739ae039), {})
                            }),
                            disabled: !column.getCanHide(),
                            label: columnDef.header,
                            onChange: ()=>handleToggleColumnHidden(column)
                        }) : (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                            sx: {
                                alignSelf: 'center'
                            },
                            children: columnDef.header
                        })
                    ]
                })
            }),
            (_a = column.columns) === null || _a === void 0 ? void 0 : _a.map((c, i)=>(0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_ShowHideColumnsMenuItems, {
                    allColumns: allColumns,
                    column: c,
                    hoveredColumn: hoveredColumn,
                    setHoveredColumn: setHoveredColumn,
                    table: table
                }, `${i}-${c.id}`))
        ]
    });
};
const $30615b8e57e39efe$var$MRT_ShowHideColumnsMenu = ({ anchorEl: anchorEl, setAnchorEl: setAnchorEl, table: table })=>{
    const { getAllColumns: getAllColumns, getAllLeafColumns: getAllLeafColumns, getCenterLeafColumns: getCenterLeafColumns, getIsAllColumnsVisible: getIsAllColumnsVisible, getIsSomeColumnsPinned: getIsSomeColumnsPinned, getIsSomeColumnsVisible: getIsSomeColumnsVisible, getLeftLeafColumns: getLeftLeafColumns, getRightLeafColumns: getRightLeafColumns, getState: getState, toggleAllColumnsVisible: toggleAllColumnsVisible, options: { enableColumnOrdering: enableColumnOrdering, enableHiding: enableHiding, enablePinning: enablePinning, localization: localization } } = table;
    const { density: density, columnOrder: columnOrder, columnPinning: columnPinning } = getState();
    const hideAllColumns = ()=>{
        getAllLeafColumns().filter((col)=>col.columnDef.enableHiding !== false).forEach((col)=>col.toggleVisibility(false));
    };
    const allColumns = (0, $i5lfL.useMemo)(()=>{
        const columns = getAllColumns();
        if (columnOrder.length > 0 && !columns.some((col)=>col.columnDef.columnDefType === 'group')) return [
            ...getLeftLeafColumns(),
            ...Array.from(new Set(columnOrder)).map((colId)=>getCenterLeafColumns().find((col)=>(col === null || col === void 0 ? void 0 : col.id) === colId)),
            ...getRightLeafColumns()
        ].filter(Boolean);
        return columns;
    }, [
        columnOrder,
        columnPinning,
        getAllColumns(),
        getCenterLeafColumns(),
        getLeftLeafColumns(),
        getRightLeafColumns()
    ]);
    const [hoveredColumn, setHoveredColumn] = (0, $i5lfL.useState)(null);
    return (0, $bHJbJ.jsxs)((0, $6e1d5d5a1ad3ef09$export$2e2bcd8739ae039), {
        anchorEl: anchorEl,
        open: !!anchorEl,
        onClose: ()=>setAnchorEl(null),
        MenuListProps: {
            dense: density === 'compact'
        },
        children: [
            (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    p: '0.5rem',
                    pt: 0
                },
                children: [
                    enableHiding && (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                        disabled: !getIsSomeColumnsVisible(),
                        onClick: hideAllColumns,
                        children: localization.hideAll
                    }),
                    enableColumnOrdering && (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                        onClick: ()=>table.setColumnOrder($30615b8e57e39efe$var$getDefaultColumnOrderIds(table.options)),
                        children: localization.resetOrder
                    }),
                    enablePinning && (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                        disabled: !getIsSomeColumnsPinned(),
                        onClick: ()=>table.resetColumnPinning(true),
                        children: localization.unpinAll
                    }),
                    enableHiding && (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                        disabled: getIsAllColumnsVisible(),
                        onClick: ()=>toggleAllColumnsVisible(true),
                        children: localization.showAll
                    })
                ]
            }),
            (0, $bHJbJ.jsx)((0, $361ca82faf3bbe4f$export$2e2bcd8739ae039), {}),
            allColumns.map((column, index)=>(0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_ShowHideColumnsMenuItems, {
                    allColumns: allColumns,
                    column: column,
                    hoveredColumn: hoveredColumn,
                    setHoveredColumn: setHoveredColumn,
                    table: table
                }, `${index}-${column.id}`))
        ]
    });
};
const $30615b8e57e39efe$export$d9eac406b7d9b19a = (_a)=>{
    var _b;
    var { table: table } = _a, rest = $30615b8e57e39efe$var$__rest(_a, [
        "table"
    ]);
    const { options: { icons: { ViewColumnIcon: ViewColumnIcon }, localization: localization } } = table;
    const [anchorEl, setAnchorEl] = (0, $i5lfL.useState)(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    return (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
        children: [
            (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                arrow: true,
                title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.showHideColumns,
                children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), Object.assign({
                    "aria-label": localization.showHideColumns,
                    onClick: handleClick
                }, rest, {
                    title: undefined,
                    children: (0, $bHJbJ.jsx)(ViewColumnIcon, {})
                }))
            }),
            anchorEl && (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_ShowHideColumnsMenu, {
                anchorEl: anchorEl,
                setAnchorEl: setAnchorEl,
                table: table
            })
        ]
    });
};
const $30615b8e57e39efe$export$64e24d27f9334b87 = (_a)=>{
    var _b;
    var { table: table } = _a, rest = $30615b8e57e39efe$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { icons: { DensityLargeIcon: DensityLargeIcon, DensityMediumIcon: DensityMediumIcon, DensitySmallIcon: DensitySmallIcon }, localization: localization }, setDensity: setDensity } = table;
    const { density: density } = getState();
    const handleToggleDensePadding = ()=>{
        const nextDensity = density === 'comfortable' ? 'compact' : density === 'compact' ? 'spacious' : 'comfortable';
        setDensity(nextDensity);
    };
    return (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
        arrow: true,
        title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.toggleDensity,
        children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), Object.assign({
            "aria-label": localization.toggleDensity,
            onClick: handleToggleDensePadding
        }, rest, {
            title: undefined,
            children: density === 'compact' ? (0, $bHJbJ.jsx)(DensitySmallIcon, {}) : density === 'comfortable' ? (0, $bHJbJ.jsx)(DensityMediumIcon, {}) : (0, $bHJbJ.jsx)(DensityLargeIcon, {})
        }))
    });
};
const $30615b8e57e39efe$export$df5f5becfc7dc5e7 = (_a)=>{
    var _b;
    var { table: table } = _a, rest = $30615b8e57e39efe$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { icons: { FilterListIcon: FilterListIcon, FilterListOffIcon: FilterListOffIcon }, localization: localization }, setShowColumnFilters: setShowColumnFilters } = table;
    const { showColumnFilters: showColumnFilters } = getState();
    const handleToggleShowFilters = ()=>{
        setShowColumnFilters(!showColumnFilters);
    };
    return (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
        arrow: true,
        title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.showHideFilters,
        children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), Object.assign({
            "aria-label": localization.showHideFilters,
            onClick: handleToggleShowFilters
        }, rest, {
            title: undefined,
            children: showColumnFilters ? (0, $bHJbJ.jsx)(FilterListOffIcon, {}) : (0, $bHJbJ.jsx)(FilterListIcon, {})
        }))
    });
};
const $30615b8e57e39efe$export$aa2cd24532d76e1e = (_a)=>{
    var _b, _c;
    var { table: table } = _a, rest = $30615b8e57e39efe$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { icons: { SearchIcon: SearchIcon, SearchOffIcon: SearchOffIcon }, localization: localization }, refs: { searchInputRef: searchInputRef }, setShowGlobalFilter: setShowGlobalFilter } = table;
    const { globalFilter: globalFilter, showGlobalFilter: showGlobalFilter } = getState();
    const handleToggleSearch = ()=>{
        setShowGlobalFilter(!showGlobalFilter);
        queueMicrotask(()=>{
            var _a;
            return (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        });
    };
    return (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
        arrow: true,
        title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.showHideSearch,
        children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), Object.assign({
            "aria-label": (_c = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _c !== void 0 ? _c : localization.showHideSearch,
            disabled: !!globalFilter,
            onClick: handleToggleSearch
        }, rest, {
            title: undefined,
            children: showGlobalFilter ? (0, $bHJbJ.jsx)(SearchOffIcon, {}) : (0, $bHJbJ.jsx)(SearchIcon, {})
        }))
    });
};
const $30615b8e57e39efe$export$34667439d21f6b05 = ({ table: table })=>{
    var _a;
    const { options: { enableColumnFilters: enableColumnFilters, enableColumnOrdering: enableColumnOrdering, enableDensityToggle: enableDensityToggle, enableFilters: enableFilters, enableFullScreenToggle: enableFullScreenToggle, enableGlobalFilter: enableGlobalFilter, enableHiding: enableHiding, enablePinning: enablePinning, initialState: initialState, renderToolbarInternalActions: renderToolbarInternalActions } } = table;
    return (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        sx: {
            alignItems: 'center',
            display: 'flex',
            zIndex: 3
        },
        children: (_a = renderToolbarInternalActions === null || renderToolbarInternalActions === void 0 ? void 0 : renderToolbarInternalActions({
            table: table
        })) !== null && _a !== void 0 ? _a : (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
            children: [
                enableFilters && enableGlobalFilter && !(initialState === null || initialState === void 0 ? void 0 : initialState.showGlobalFilter) && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$aa2cd24532d76e1e, {
                    table: table
                }),
                enableFilters && enableColumnFilters && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$df5f5becfc7dc5e7, {
                    table: table
                }),
                (enableHiding || enableColumnOrdering || enablePinning) && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$d9eac406b7d9b19a, {
                    table: table
                }),
                enableDensityToggle && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$64e24d27f9334b87, {
                    table: table
                }),
                enableFullScreenToggle && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$292cb709c1b05af0, {
                    table: table
                })
            ]
        })
    });
};
const $30615b8e57e39efe$export$23b863b2e258a060 = ({ table: table })=>{
    var _a, _b;
    const { getState: getState, options: { enableGrouping: enableGrouping, localization: localization }, setHoveredColumn: setHoveredColumn, setShowToolbarDropZone: setShowToolbarDropZone } = table;
    const { draggingColumn: draggingColumn, hoveredColumn: hoveredColumn, grouping: grouping, showToolbarDropZone: showToolbarDropZone } = getState();
    const handleDragEnter = (_event)=>{
        setHoveredColumn({
            id: 'drop-zone'
        });
    };
    (0, $i5lfL.useEffect)(()=>{
        var _a;
        if (((_a = table.options.state) === null || _a === void 0 ? void 0 : _a.showToolbarDropZone) !== undefined) setShowToolbarDropZone(!!enableGrouping && !!draggingColumn && draggingColumn.columnDef.enableGrouping !== false && !grouping.includes(draggingColumn.id));
    }, [
        enableGrouping,
        draggingColumn,
        grouping
    ]);
    return (0, $bHJbJ.jsx)((0, $eb1f4c060c8a68ab$export$2e2bcd8739ae039), {
        in: showToolbarDropZone,
        children: (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
            className: "Mui-ToolbarDropZone",
            sx: (theme)=>({
                    alignItems: 'center',
                    backgroundColor: (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.info.main, (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === 'drop-zone' ? 0.2 : 0.1),
                    backdropFilter: 'blur(4px)',
                    boxSizing: 'border-box',
                    border: `dashed ${theme.palette.info.main} 2px`,
                    display: 'flex',
                    justifyContent: 'center',
                    height: '100%',
                    position: 'absolute',
                    width: '100%',
                    zIndex: 4
                }),
            onDragEnter: handleDragEnter,
            children: (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                fontStyle: "italic",
                children: localization.dropToGroupBy.replace('{column}', (_b = (_a = draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.columnDef) === null || _a === void 0 ? void 0 : _a.header) !== null && _b !== void 0 ? _b : '')
            })
        })
    });
};
const $30615b8e57e39efe$var$commonToolbarStyles = ({ theme: theme })=>({
        alignItems: 'flex-start',
        backgroundColor: (0, $bb6d55b5db31c7f7$export$c0816ed86df316af)(theme.palette.background.default, 0.04),
        backgroundImage: 'none',
        display: 'grid',
        flexWrap: 'wrap-reverse',
        minHeight: '3.5rem',
        overflow: 'hidden',
        p: '0 !important',
        transition: 'all 150ms ease-in-out',
        zIndex: 1
    });
const $30615b8e57e39efe$export$833ce02671e611ef = ({ table: table })=>{
    var _a;
    const { getState: getState, options: { enableGlobalFilter: enableGlobalFilter, enablePagination: enablePagination, enableToolbarInternalActions: enableToolbarInternalActions, muiTopToolbarProps: muiTopToolbarProps, positionGlobalFilter: positionGlobalFilter, positionPagination: positionPagination, positionToolbarAlertBanner: positionToolbarAlertBanner, positionToolbarDropZone: positionToolbarDropZone, renderTopToolbarCustomActions: renderTopToolbarCustomActions }, refs: { topToolbarRef: topToolbarRef } } = table;
    const { isFullScreen: isFullScreen, showGlobalFilter: showGlobalFilter } = getState();
    const isMobile = (0, $2605abdc8746194d$export$2e2bcd8739ae039)('(max-width:720px)');
    const toolbarProps = muiTopToolbarProps instanceof Function ? muiTopToolbarProps({
        table: table
    }) : muiTopToolbarProps;
    const stackAlertBanner = isMobile || !!renderTopToolbarCustomActions || showGlobalFilter;
    return (0, $bHJbJ.jsxs)((0, $7e3df3c636b0fe42$export$2e2bcd8739ae039), Object.assign({
        variant: "dense"
    }, toolbarProps, {
        ref: (ref)=>{
            topToolbarRef.current = ref;
            if (toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.ref) // @ts-ignore
            toolbarProps.ref.current = ref;
        },
        sx: (theme)=>Object.assign(Object.assign({
                position: isFullScreen ? 'sticky' : undefined,
                top: isFullScreen ? '0' : undefined
            }, $30615b8e57e39efe$var$commonToolbarStyles({
                theme: theme
            })), (toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.sx) instanceof Function ? toolbarProps.sx(theme) : toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.sx),
        children: [
            positionToolbarAlertBanner === 'top' && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$182b9e76a987279b, {
                stackAlertBanner: stackAlertBanner,
                table: table
            }),
            [
                'both',
                'top'
            ].includes(positionToolbarDropZone !== null && positionToolbarDropZone !== void 0 ? positionToolbarDropZone : '') && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$23b863b2e258a060, {
                table: table
            }),
            (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                sx: {
                    alignItems: 'flex-start',
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'space-between',
                    p: '0.5rem',
                    position: stackAlertBanner ? 'relative' : 'absolute',
                    right: 0,
                    top: 0,
                    width: '100%'
                },
                children: [
                    enableGlobalFilter && positionGlobalFilter === 'left' && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$d802562b525f204b, {
                        table: table
                    }),
                    (_a = renderTopToolbarCustomActions === null || renderTopToolbarCustomActions === void 0 ? void 0 : renderTopToolbarCustomActions({
                        table: table
                    })) !== null && _a !== void 0 ? _a : (0, $bHJbJ.jsx)("span", {}),
                    enableToolbarInternalActions ? (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            flexWrap: 'wrap-reverse',
                            justifyContent: 'flex-end'
                        },
                        children: [
                            enableGlobalFilter && positionGlobalFilter === 'right' && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$d802562b525f204b, {
                                table: table
                            }),
                            (0, $bHJbJ.jsx)($30615b8e57e39efe$export$34667439d21f6b05, {
                                table: table
                            })
                        ]
                    }) : enableGlobalFilter && positionGlobalFilter === 'right' && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$d802562b525f204b, {
                        table: table
                    })
                ]
            }),
            enablePagination && [
                'top',
                'both'
            ].includes(positionPagination !== null && positionPagination !== void 0 ? positionPagination : '') && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$bd75343f17999fc0, {
                table: table,
                position: "top"
            }),
            (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_LinearProgressBar, {
                isTopToolbar: true,
                table: table
            })
        ]
    }));
};
const $30615b8e57e39efe$export$802d7d5e9270e154 = ({ table: table })=>{
    const { getState: getState, options: { enablePagination: enablePagination, muiBottomToolbarProps: muiBottomToolbarProps, positionPagination: positionPagination, positionToolbarAlertBanner: positionToolbarAlertBanner, positionToolbarDropZone: positionToolbarDropZone, renderBottomToolbarCustomActions: renderBottomToolbarCustomActions }, refs: { bottomToolbarRef: bottomToolbarRef } } = table;
    const { isFullScreen: isFullScreen } = getState();
    const isMobile = (0, $2605abdc8746194d$export$2e2bcd8739ae039)('(max-width:720px)');
    const toolbarProps = muiBottomToolbarProps instanceof Function ? muiBottomToolbarProps({
        table: table
    }) : muiBottomToolbarProps;
    const stackAlertBanner = isMobile || !!renderBottomToolbarCustomActions;
    return (0, $bHJbJ.jsxs)((0, $7e3df3c636b0fe42$export$2e2bcd8739ae039), Object.assign({
        variant: "dense"
    }, toolbarProps, {
        ref: (node)=>{
            if (node) {
                bottomToolbarRef.current = node;
                if (toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.ref) // @ts-ignore
                toolbarProps.ref.current = node;
            }
        },
        sx: (theme)=>Object.assign(Object.assign(Object.assign({}, $30615b8e57e39efe$var$commonToolbarStyles({
                theme: theme
            })), {
                bottom: isFullScreen ? '0' : undefined,
                boxShadow: `0 1px 2px -1px ${(0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.1)} inset`,
                left: 0,
                position: isFullScreen ? 'fixed' : 'relative',
                right: 0
            }), (toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.sx) instanceof Function ? toolbarProps.sx(theme) : toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.sx),
        children: [
            (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_LinearProgressBar, {
                isTopToolbar: false,
                table: table
            }),
            positionToolbarAlertBanner === 'bottom' && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$182b9e76a987279b, {
                stackAlertBanner: stackAlertBanner,
                table: table
            }),
            [
                'both',
                'bottom'
            ].includes(positionToolbarDropZone !== null && positionToolbarDropZone !== void 0 ? positionToolbarDropZone : '') && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$23b863b2e258a060, {
                table: table
            }),
            (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                sx: {
                    alignItems: 'center',
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'space-between',
                    p: '0.5rem',
                    width: '100%'
                },
                children: [
                    renderBottomToolbarCustomActions ? renderBottomToolbarCustomActions({
                        table: table
                    }) : (0, $bHJbJ.jsx)("span", {}),
                    (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            justifyContent: 'flex-end',
                            position: stackAlertBanner ? 'relative' : 'absolute',
                            right: 0,
                            top: 0
                        },
                        children: enablePagination && [
                            'bottom',
                            'both'
                        ].includes(positionPagination !== null && positionPagination !== void 0 ? positionPagination : '') && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$bd75343f17999fc0, {
                            table: table,
                            position: "bottom"
                        })
                    })
                ]
            })
        ]
    }));
};
const $30615b8e57e39efe$var$MRT_TableHeadCellColumnActionsButton = ({ header: header, table: table })=>{
    var _a;
    const { options: { icons: { MoreVertIcon: MoreVertIcon }, localization: localization, muiTableHeadCellColumnActionsButtonProps: muiTableHeadCellColumnActionsButtonProps } } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const [anchorEl, setAnchorEl] = (0, $i5lfL.useState)(null);
    const handleClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    const mTableHeadCellColumnActionsButtonProps = muiTableHeadCellColumnActionsButtonProps instanceof Function ? muiTableHeadCellColumnActionsButtonProps({
        column: column,
        table: table
    }) : muiTableHeadCellColumnActionsButtonProps;
    const mcTableHeadCellColumnActionsButtonProps = columnDef.muiTableHeadCellColumnActionsButtonProps instanceof Function ? columnDef.muiTableHeadCellColumnActionsButtonProps({
        column: column,
        table: table
    }) : columnDef.muiTableHeadCellColumnActionsButtonProps;
    const iconButtonProps = Object.assign(Object.assign({}, mTableHeadCellColumnActionsButtonProps), mcTableHeadCellColumnActionsButtonProps);
    return (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
        children: [
            (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                arrow: true,
                enterDelay: 1000,
                enterNextDelay: 1000,
                placement: "top",
                title: (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.title) !== null && _a !== void 0 ? _a : localization.columnActions,
                children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), Object.assign({
                    "aria-label": localization.columnActions,
                    onClick: handleClick,
                    size: "small"
                }, iconButtonProps, {
                    sx: (theme)=>Object.assign({
                            height: '2rem',
                            m: '-8px -4px',
                            opacity: 0.5,
                            transform: 'scale(0.85) translateX(-4px)',
                            transition: 'opacity 150ms',
                            width: '2rem',
                            '&:hover': {
                                opacity: 1
                            }
                        }, (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx) instanceof Function ? iconButtonProps.sx(theme) : iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx),
                    title: undefined,
                    children: (0, $bHJbJ.jsx)(MoreVertIcon, {})
                }))
            }),
            anchorEl && (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_ColumnActionMenu, {
                anchorEl: anchorEl,
                header: header,
                setAnchorEl: setAnchorEl,
                table: table
            })
        ]
    });
};
const $30615b8e57e39efe$var$MRT_FilterTextField = ({ header: header, rangeFilterIndex: rangeFilterIndex, table: table })=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { options: { enableColumnFilterModes: enableColumnFilterModes, columnFilterModeOptions: columnFilterModeOptions, icons: { FilterListIcon: FilterListIcon, CloseIcon: CloseIcon }, localization: localization, manualFiltering: manualFiltering, muiTableHeadCellFilterTextFieldProps: muiTableHeadCellFilterTextFieldProps }, refs: { filterInputRefs: filterInputRefs }, setColumnFilterFns: setColumnFilterFns } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const mTableHeadCellFilterTextFieldProps = muiTableHeadCellFilterTextFieldProps instanceof Function ? muiTableHeadCellFilterTextFieldProps({
        column: column,
        table: table,
        rangeFilterIndex: rangeFilterIndex
    }) : muiTableHeadCellFilterTextFieldProps;
    const mcTableHeadCellFilterTextFieldProps = columnDef.muiTableHeadCellFilterTextFieldProps instanceof Function ? columnDef.muiTableHeadCellFilterTextFieldProps({
        column: column,
        table: table,
        rangeFilterIndex: rangeFilterIndex
    }) : columnDef.muiTableHeadCellFilterTextFieldProps;
    const textFieldProps = Object.assign(Object.assign({}, mTableHeadCellFilterTextFieldProps), mcTableHeadCellFilterTextFieldProps);
    const isRangeFilter = columnDef.filterVariant === 'range' || rangeFilterIndex !== undefined;
    const isSelectFilter = columnDef.filterVariant === 'select';
    const isMultiSelectFilter = columnDef.filterVariant === 'multi-select';
    const isTextboxFilter = columnDef.filterVariant === 'text' || !isSelectFilter && !isMultiSelectFilter;
    const currentFilterOption = columnDef._filterFn;
    const filterChipLabel = [
        'empty',
        'notEmpty'
    ].includes(currentFilterOption) ? localization[`filter${((_b = (_a = currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.charAt) === null || _a === void 0 ? void 0 : _a.call(currentFilterOption, 0)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) + (currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.slice(1))}`] : '';
    const filterPlaceholder = !isRangeFilter ? (_c = textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.placeholder) !== null && _c !== void 0 ? _c : (_d = localization.filterByColumn) === null || _d === void 0 ? void 0 : _d.replace('{column}', String(columnDef.header)) : rangeFilterIndex === 0 ? localization.min : rangeFilterIndex === 1 ? localization.max : '';
    const allowedColumnFilterOptions = (_e = columnDef === null || columnDef === void 0 ? void 0 : columnDef.columnFilterModeOptions) !== null && _e !== void 0 ? _e : columnFilterModeOptions;
    const showChangeModeButton = enableColumnFilterModes && columnDef.enableColumnFilterModes !== false && !rangeFilterIndex && (allowedColumnFilterOptions === undefined || !!(allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions.length));
    const facetedUniqueValues = column.getFacetedUniqueValues();
    const filterSelectOptions = (0, $i5lfL.useMemo)(()=>{
        var _a;
        return (_a = columnDef.filterSelectOptions) !== null && _a !== void 0 ? _a : (isSelectFilter || isMultiSelectFilter) && facetedUniqueValues ? Array.from(facetedUniqueValues.keys()).sort((a, b)=>a.localeCompare(b)) : undefined;
    }, [
        columnDef.filterSelectOptions,
        facetedUniqueValues,
        isMultiSelectFilter,
        isSelectFilter
    ]);
    const [anchorEl, setAnchorEl] = (0, $i5lfL.useState)(null);
    const [filterValue, setFilterValue] = (0, $i5lfL.useState)(()=>{
        var _a, _b;
        return isMultiSelectFilter ? column.getFilterValue() || [] : isRangeFilter ? ((_a = column.getFilterValue()) === null || _a === void 0 ? void 0 : _a[rangeFilterIndex]) || [] : (_b = column.getFilterValue()) !== null && _b !== void 0 ? _b : '';
    });
    const handleChangeDebounced = (0, $i5lfL.useCallback)((0, $35800e9c430cfaca$export$2e2bcd8739ae039)((event)=>{
        const value = textFieldProps.type === 'date' ? event.target.valueAsDate : textFieldProps.type === 'number' ? event.target.valueAsNumber : event.target.value;
        if (isRangeFilter) column.setFilterValue((old)=>{
            const newFilterValues = old !== null && old !== void 0 ? old : [
                '',
                ''
            ];
            newFilterValues[rangeFilterIndex] = value;
            return newFilterValues;
        });
        else column.setFilterValue(value !== null && value !== void 0 ? value : undefined);
    }, isTextboxFilter ? manualFiltering ? 400 : 200 : 1), []);
    const handleChange = (event)=>{
        setFilterValue(event.target.value);
        handleChangeDebounced(event);
    };
    const handleClear = ()=>{
        if (isMultiSelectFilter) {
            setFilterValue([]);
            column.setFilterValue([]);
        } else if (isRangeFilter) {
            setFilterValue('');
            column.setFilterValue((old)=>{
                const newFilterValues = Array.isArray(old) && old || [
                    '',
                    ''
                ];
                newFilterValues[rangeFilterIndex] = undefined;
                return newFilterValues;
            });
        } else {
            setFilterValue('');
            column.setFilterValue(undefined);
        }
    };
    const handleClearEmptyFilterChip = ()=>{
        setFilterValue('');
        column.setFilterValue(undefined);
        setColumnFilterFns((prev)=>{
            var _a;
            return Object.assign(Object.assign({}, prev), {
                [header.id]: (_a = allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions[0]) !== null && _a !== void 0 ? _a : 'fuzzy'
            });
        });
    };
    const handleFilterMenuOpen = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const isMounted = (0, $i5lfL.useRef)(false);
    (0, $i5lfL.useEffect)(()=>{
        if (isMounted.current) {
            const filterValue = column.getFilterValue();
            if (filterValue === undefined) handleClear();
            else if (isRangeFilter && rangeFilterIndex !== undefined) setFilterValue(filterValue[rangeFilterIndex]);
            else setFilterValue(filterValue);
        }
        isMounted.current = true;
    }, [
        column.getFilterValue()
    ]);
    if (columnDef.Filter) return (0, $bHJbJ.jsx)((0, $bHJbJ.Fragment), {
        children: (_f = columnDef.Filter) === null || _f === void 0 ? void 0 : _f.call(columnDef, {
            column: column,
            header: header,
            rangeFilterIndex: rangeFilterIndex,
            table: table
        })
    });
    return (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
        children: [
            (0, $bHJbJ.jsxs)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), Object.assign({
                fullWidth: true,
                inputProps: {
                    disabled: !!filterChipLabel,
                    sx: {
                        textOverflow: 'ellipsis',
                        width: filterChipLabel ? 0 : undefined
                    },
                    title: filterPlaceholder
                },
                helperText: showChangeModeButton ? (0, $bHJbJ.jsx)("label", {
                    children: localization.filterMode.replace('{filterType}', // @ts-ignore
                    localization[`filter${((_g = currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.charAt(0)) === null || _g === void 0 ? void 0 : _g.toUpperCase()) + (currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.slice(1))}`])
                }) : null,
                FormHelperTextProps: {
                    sx: {
                        fontSize: '0.75rem',
                        lineHeight: '0.8rem',
                        whiteSpace: 'nowrap'
                    }
                },
                margin: "none",
                placeholder: filterChipLabel || isSelectFilter || isMultiSelectFilter ? undefined : filterPlaceholder,
                onChange: handleChange,
                onClick: (e)=>e.stopPropagation(),
                select: isSelectFilter || isMultiSelectFilter,
                value: filterValue !== null && filterValue !== void 0 ? filterValue : '',
                variant: "standard",
                InputProps: {
                    startAdornment: showChangeModeButton ? (0, $bHJbJ.jsxs)((0, $b99dc77e886c5558$export$2e2bcd8739ae039), {
                        position: "start",
                        children: [
                            (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                                arrow: true,
                                title: localization.changeFilterMode,
                                children: (0, $bHJbJ.jsx)("span", {
                                    children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                                        "aria-label": localization.changeFilterMode,
                                        onClick: handleFilterMenuOpen,
                                        size: "small",
                                        sx: {
                                            height: '1.75rem',
                                            width: '1.75rem'
                                        },
                                        children: (0, $bHJbJ.jsx)(FilterListIcon, {})
                                    })
                                })
                            }),
                            filterChipLabel && (0, $bHJbJ.jsx)((0, $8a1b9da49508a793$export$2e2bcd8739ae039), {
                                onDelete: handleClearEmptyFilterChip,
                                label: filterChipLabel
                            })
                        ]
                    }) : null,
                    endAdornment: !filterChipLabel && (0, $bHJbJ.jsx)((0, $b99dc77e886c5558$export$2e2bcd8739ae039), {
                        position: "end",
                        children: (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                            arrow: true,
                            placement: "right",
                            title: (_h = localization.clearFilter) !== null && _h !== void 0 ? _h : '',
                            children: (0, $bHJbJ.jsx)("span", {
                                children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                                    "aria-label": localization.clearFilter,
                                    disabled: !((_j = filterValue === null || filterValue === void 0 ? void 0 : filterValue.toString()) === null || _j === void 0 ? void 0 : _j.length),
                                    onClick: handleClear,
                                    size: "small",
                                    sx: {
                                        height: '1.75rem',
                                        width: '1.75rem'
                                    },
                                    children: (0, $bHJbJ.jsx)(CloseIcon, {})
                                })
                            })
                        })
                    })
                },
                SelectProps: {
                    displayEmpty: true,
                    multiple: isMultiSelectFilter,
                    renderValue: isMultiSelectFilter ? (selected)=>!(selected === null || selected === void 0 ? void 0 : selected.length) ? (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                opacity: 0.5
                            },
                            children: filterPlaceholder
                        }) : (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '2px'
                            },
                            children: selected === null || selected === void 0 ? void 0 : selected.map((value)=>{
                                const selectedValue = filterSelectOptions === null || filterSelectOptions === void 0 ? void 0 : filterSelectOptions.find((option)=>option instanceof Object ? option.value === value : option === value);
                                return (0, $bHJbJ.jsx)((0, $8a1b9da49508a793$export$2e2bcd8739ae039), {
                                    label: selectedValue instanceof Object ? selectedValue.text : selectedValue
                                }, value);
                            })
                        }) : undefined
                }
            }, textFieldProps, {
                inputRef: (inputRef)=>{
                    filterInputRefs.current[`${column.id}-${rangeFilterIndex !== null && rangeFilterIndex !== void 0 ? rangeFilterIndex : 0}`] = inputRef;
                    if (textFieldProps.inputRef) textFieldProps.inputRef = inputRef;
                },
                sx: (theme)=>Object.assign({
                        p: 0,
                        minWidth: isRangeFilter ? '100px' : !filterChipLabel ? '120px' : 'auto',
                        width: 'calc(100% + 4px)',
                        mx: '-2px',
                        '& .MuiSelect-icon': {
                            mr: '1.5rem'
                        }
                    }, (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.sx) instanceof Function ? textFieldProps.sx(theme) : textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.sx),
                children: [
                    (isSelectFilter || isMultiSelectFilter) && (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                        divider: true,
                        disabled: true,
                        hidden: true,
                        value: "",
                        children: (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                opacity: 0.5
                            },
                            children: filterPlaceholder
                        })
                    }),
                    (_k = textFieldProps.children) !== null && _k !== void 0 ? _k : filterSelectOptions === null || filterSelectOptions === void 0 ? void 0 : filterSelectOptions.map((option)=>{
                        var _a;
                        if (!option) return '';
                        let value;
                        let text;
                        if (typeof option !== 'object') {
                            value = option;
                            text = option;
                        } else {
                            value = option.value;
                            text = option.text;
                        }
                        return (0, $bHJbJ.jsxs)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                m: 0,
                                alignItems: 'center',
                                gap: '0.5rem'
                            },
                            value: value,
                            children: [
                                isMultiSelectFilter && (0, $bHJbJ.jsx)((0, $842f67eebadd25d0$export$2e2bcd8739ae039), {
                                    checked: ((_a = column.getFilterValue()) !== null && _a !== void 0 ? _a : []).includes(value),
                                    sx: {
                                        mr: '0.5rem'
                                    }
                                }),
                                text,
                                ' ',
                                !columnDef.filterSelectOptions && `(${facetedUniqueValues.get(value)})`
                            ]
                        }, value);
                    })
                ]
            })),
            (0, $bHJbJ.jsx)($30615b8e57e39efe$export$18f00246d050b1b5, {
                anchorEl: anchorEl,
                header: header,
                setAnchorEl: setAnchorEl,
                table: table,
                setFilterValue: setFilterValue
            })
        ]
    });
};
const $30615b8e57e39efe$var$MRT_FilterRangeFields = ({ header: header, table: table })=>{
    return (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        sx: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '1rem'
        },
        children: [
            (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_FilterTextField, {
                header: header,
                rangeFilterIndex: 0,
                table: table
            }),
            (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_FilterTextField, {
                header: header,
                rangeFilterIndex: 1,
                table: table
            })
        ]
    });
};
const $30615b8e57e39efe$var$MRT_FilterCheckbox = ({ column: column, table: table })=>{
    var _a, _b, _c;
    const { getState: getState, options: { localization: localization, muiTableHeadCellFilterCheckboxProps: muiTableHeadCellFilterCheckboxProps } } = table;
    const { density: density } = getState();
    const { columnDef: columnDef } = column;
    const mTableHeadCellFilterCheckboxProps = muiTableHeadCellFilterCheckboxProps instanceof Function ? muiTableHeadCellFilterCheckboxProps({
        column: column,
        table: table
    }) : muiTableHeadCellFilterCheckboxProps;
    const mcTableHeadCellFilterCheckboxProps = columnDef.muiTableHeadCellFilterCheckboxProps instanceof Function ? columnDef.muiTableHeadCellFilterCheckboxProps({
        column: column,
        table: table
    }) : columnDef.muiTableHeadCellFilterCheckboxProps;
    const checkboxProps = Object.assign(Object.assign({}, mTableHeadCellFilterCheckboxProps), mcTableHeadCellFilterCheckboxProps);
    const filterLabel = (_a = localization.filterByColumn) === null || _a === void 0 ? void 0 : _a.replace('{column}', columnDef.header);
    return (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
        arrow: true,
        enterDelay: 1000,
        enterNextDelay: 1000,
        title: (_b = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.title) !== null && _b !== void 0 ? _b : filterLabel,
        children: (0, $bHJbJ.jsx)((0, $3da2083f6f3ac88d$export$2e2bcd8739ae039), {
            control: (0, $bHJbJ.jsx)((0, $842f67eebadd25d0$export$2e2bcd8739ae039), Object.assign({
                checked: column.getFilterValue() === 'true',
                indeterminate: column.getFilterValue() === undefined,
                color: column.getFilterValue() === undefined ? 'default' : 'primary',
                size: density === 'compact' ? 'small' : 'medium'
            }, checkboxProps, {
                onClick: (e)=>{
                    var _a;
                    e.stopPropagation();
                    (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onClick) === null || _a === void 0 || _a.call(checkboxProps, e);
                },
                onChange: (e, checked)=>{
                    var _a;
                    column.setFilterValue(column.getFilterValue() === undefined ? 'true' : column.getFilterValue() === 'true' ? 'false' : undefined);
                    (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onChange) === null || _a === void 0 || _a.call(checkboxProps, e, checked);
                },
                sx: (theme)=>Object.assign({
                        height: '2.5rem',
                        width: '2.5rem'
                    }, (checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.sx) instanceof Function ? checkboxProps.sx(theme) : checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.sx)
            })),
            disableTypography: true,
            label: (_c = checkboxProps.title) !== null && _c !== void 0 ? _c : filterLabel,
            sx: {
                color: 'text.secondary',
                mt: '-4px',
                fontWeight: 'normal'
            },
            title: undefined
        })
    });
};
const $30615b8e57e39efe$var$MRT_FilterRangeSlider = ({ header: header, table: table })=>{
    var _a, _b;
    const { options: { localization: localization, muiTableHeadCellFilterSliderProps: muiTableHeadCellFilterSliderProps, enableColumnFilterModes: enableColumnFilterModes }, refs: { filterInputRefs: filterInputRefs } } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const currentFilterOption = columnDef._filterFn;
    const showChangeModeButton = enableColumnFilterModes && columnDef.enableColumnFilterModes !== false;
    const mTableHeadCellFilterTextFieldProps = muiTableHeadCellFilterSliderProps instanceof Function ? muiTableHeadCellFilterSliderProps({
        column: column,
        table: table
    }) : muiTableHeadCellFilterSliderProps;
    const mcTableHeadCellFilterTextFieldProps = columnDef.muiTableHeadCellFilterSliderProps instanceof Function ? columnDef.muiTableHeadCellFilterSliderProps({
        column: column,
        table: table
    }) : columnDef.muiTableHeadCellFilterSliderProps;
    const sliderProps = Object.assign(Object.assign({}, mTableHeadCellFilterTextFieldProps), mcTableHeadCellFilterTextFieldProps);
    let [min, max] = sliderProps.min !== undefined && sliderProps.max !== undefined ? [
        sliderProps.min,
        sliderProps.max
    ] : (_a = column.getFacetedMinMaxValues()) !== null && _a !== void 0 ? _a : [
        0,
        1
    ];
    //fix potential TanStack Table bugs where min or max is an array
    if (Array.isArray(min)) min = min[0];
    if (Array.isArray(max)) max = max[0];
    if (min === null) min = 0;
    if (max === null) max = 1;
    const [filterValues, setFilterValues] = (0, $i5lfL.useState)([
        min,
        max
    ]);
    const columnFilterValue = column.getFilterValue();
    const isMounted = (0, $i5lfL.useRef)(false);
    (0, $i5lfL.useEffect)(()=>{
        if (isMounted.current) {
            if (columnFilterValue === undefined) setFilterValues([
                min,
                max
            ]);
            else if (Array.isArray(columnFilterValue)) setFilterValues(columnFilterValue);
        }
        isMounted.current = true;
    }, [
        columnFilterValue,
        min,
        max
    ]);
    return (0, $bHJbJ.jsxs)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
        children: [
            (0, $bHJbJ.jsx)((0, $36fe94807ea896b0$export$2e2bcd8739ae039), Object.assign({
                disableSwap: true,
                min: min,
                max: max,
                onChange: (_event, values)=>{
                    setFilterValues(values);
                },
                onChangeCommitted: (_event, value)=>{
                    if (Array.isArray(value)) {
                        if (value[0] <= min && value[1] >= max) //if the user has selected the entire range, remove the filter
                        column.setFilterValue(undefined);
                        else column.setFilterValue(value);
                    }
                },
                value: filterValues,
                valueLabelDisplay: "auto"
            }, sliderProps, {
                slotProps: {
                    input: {
                        ref: (node)=>{
                            var _a, _b;
                            if (node) {
                                filterInputRefs.current[`${column.id}-0`] = node;
                                // @ts-ignore
                                if ((_b = (_a = sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.slotProps) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.ref) //@ts-ignore
                                sliderProps.slotProps.input.ref = node;
                            }
                        }
                    }
                },
                sx: (theme)=>Object.assign({
                        m: 'auto',
                        mt: !showChangeModeButton ? '10px' : '6px',
                        px: '4px',
                        width: 'calc(100% - 8px)'
                    }, (sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.sx) instanceof Function ? sliderProps.sx(theme) : sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.sx)
            })),
            showChangeModeButton ? (0, $bHJbJ.jsx)((0, $768d8f0163d595a3$export$2e2bcd8739ae039), {
                sx: {
                    m: '-3px -6px',
                    fontSize: '0.75rem',
                    lineHeight: '0.8rem',
                    whiteSpace: 'nowrap'
                },
                children: localization.filterMode.replace('{filterType}', // @ts-ignore
                localization[`filter${((_b = currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.charAt(0)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) + (currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.slice(1))}`])
            }) : null
        ]
    });
};
const $30615b8e57e39efe$export$3ae86ee4cf52373f = ({ header: header, table: table })=>{
    const { getState: getState } = table;
    const { showColumnFilters: showColumnFilters } = getState();
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    return (0, $bHJbJ.jsx)((0, $8d561c5085503182$export$2e2bcd8739ae039), {
        in: showColumnFilters,
        mountOnEnter: true,
        unmountOnExit: true,
        children: columnDef.filterVariant === 'checkbox' ? (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_FilterCheckbox, {
            column: column,
            table: table
        }) : columnDef.filterVariant === 'range-slider' ? (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_FilterRangeSlider, {
            header: header,
            table: table
        }) : columnDef.filterVariant === 'range' || [
            'between',
            'betweenInclusive',
            'inNumberRange'
        ].includes(columnDef._filterFn) ? (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_FilterRangeFields, {
            header: header,
            table: table
        }) : (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_FilterTextField, {
            header: header,
            table: table
        })
    });
};
const $30615b8e57e39efe$var$MRT_TableHeadCellFilterLabel = ({ header: header, table: table })=>{
    var _a, _b, _c, _d;
    const { options: { icons: { FilterAltIcon: FilterAltIcon }, localization: localization }, refs: { filterInputRefs: filterInputRefs }, setShowColumnFilters: setShowColumnFilters } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const isRangeFilter = [
        'range',
        'ranger-slider'
    ].includes((_a = columnDef.filterVariant) !== null && _a !== void 0 ? _a : '') || [
        'between',
        'betweenInclusive',
        'inNumberRange'
    ].includes(columnDef._filterFn);
    const currentFilterOption = columnDef._filterFn;
    const filterTooltip = localization.filteringByColumn.replace('{column}', String(columnDef.header)).replace('{filterType}', // @ts-ignore
    localization[`filter${((_b = currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.charAt(0)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) + (currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.slice(1))}`]).replace('{filterValue}', `"${Array.isArray(column.getFilterValue()) ? column.getFilterValue().join(`" ${isRangeFilter ? localization.and : localization.or} "`) : column.getFilterValue()}"`).replace('" "', '');
    return (0, $bHJbJ.jsx)((0, $66de9c04029c8d70$export$2e2bcd8739ae039), {
        unmountOnExit: true,
        in: !!column.getFilterValue() && !isRangeFilter || isRangeFilter && // @ts-ignore
        (!!((_c = column.getFilterValue()) === null || _c === void 0 ? void 0 : _c[0]) || !!((_d = column.getFilterValue()) === null || _d === void 0 ? void 0 : _d[1])),
        children: (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
            component: "span",
            sx: {
                flex: '0 0'
            },
            children: (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                arrow: true,
                placement: "top",
                title: filterTooltip,
                children: (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                    disableRipple: true,
                    onClick: (event)=>{
                        setShowColumnFilters(true);
                        queueMicrotask(()=>{
                            var _a, _b;
                            (_a = filterInputRefs.current[`${column.id}-0`]) === null || _a === void 0 || _a.focus();
                            (_b = filterInputRefs.current[`${column.id}-0`]) === null || _b === void 0 || _b.select();
                        });
                        event.stopPropagation();
                    },
                    size: "small",
                    sx: {
                        height: '12px',
                        m: 0,
                        opacity: 0.8,
                        p: '2px',
                        transform: 'scale(0.66)',
                        width: '12px'
                    },
                    children: (0, $bHJbJ.jsx)(FilterAltIcon, {})
                })
            })
        })
    });
};
const $30615b8e57e39efe$var$MRT_TableHeadCellGrabHandle = ({ column: column, table: table, tableHeadCellRef: tableHeadCellRef })=>{
    const { getState: getState, options: { enableColumnOrdering: enableColumnOrdering, muiTableHeadCellDragHandleProps: muiTableHeadCellDragHandleProps }, setColumnOrder: setColumnOrder, setDraggingColumn: setDraggingColumn, setHoveredColumn: setHoveredColumn } = table;
    const { columnDef: columnDef } = column;
    const { hoveredColumn: hoveredColumn, draggingColumn: draggingColumn, columnOrder: columnOrder } = getState();
    const mIconButtonProps = muiTableHeadCellDragHandleProps instanceof Function ? muiTableHeadCellDragHandleProps({
        column: column,
        table: table
    }) : muiTableHeadCellDragHandleProps;
    const mcIconButtonProps = columnDef.muiTableHeadCellDragHandleProps instanceof Function ? columnDef.muiTableHeadCellDragHandleProps({
        column: column,
        table: table
    }) : columnDef.muiTableHeadCellDragHandleProps;
    const iconButtonProps = Object.assign(Object.assign({}, mIconButtonProps), mcIconButtonProps);
    const handleDragStart = (event)=>{
        var _a;
        (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onDragStart) === null || _a === void 0 || _a.call(iconButtonProps, event);
        setDraggingColumn(column);
        event.dataTransfer.setDragImage(tableHeadCellRef.current, 0, 0);
    };
    const handleDragEnd = (event)=>{
        var _a;
        (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onDragEnd) === null || _a === void 0 || _a.call(iconButtonProps, event);
        if ((hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === 'drop-zone') column.toggleGrouping();
        else if (enableColumnOrdering && hoveredColumn && (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) !== (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id)) setColumnOrder($30615b8e57e39efe$var$reorderColumn(column, hoveredColumn, columnOrder));
        setDraggingColumn(null);
        setHoveredColumn(null);
    };
    return (0, $bHJbJ.jsx)($30615b8e57e39efe$export$84d0ca45a1213a16, {
        iconButtonProps: iconButtonProps,
        onDragStart: handleDragStart,
        onDragEnd: handleDragEnd,
        table: table
    });
};
const $30615b8e57e39efe$var$MRT_TableHeadCellResizeHandle = ({ header: header, table: table })=>{
    var _a;
    const { getState: getState, options: { columnResizeMode: columnResizeMode }, setColumnSizingInfo: setColumnSizingInfo } = table;
    const { density: density } = getState();
    const { column: column } = header;
    return (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        className: "Mui-TableHeadCell-ResizeHandle-Wrapper",
        onDoubleClick: ()=>{
            setColumnSizingInfo((old)=>Object.assign(Object.assign({}, old), {
                    isResizingColumn: false
                }));
            column.resetSize();
        },
        onMouseDown: header.getResizeHandler(),
        onTouchStart: header.getResizeHandler(),
        sx: (theme)=>({
                cursor: 'col-resize',
                mr: density === 'compact' ? '-0.75rem' : '-1rem',
                position: 'absolute',
                right: '4px',
                px: '4px',
                '&:active > hr': {
                    backgroundColor: theme.palette.info.main,
                    opacity: 1
                }
            }),
        style: {
            transform: column.getIsResizing() && columnResizeMode === 'onEnd' ? `translateX(${(_a = getState().columnSizingInfo.deltaOffset) !== null && _a !== void 0 ? _a : 0}px)` : undefined
        },
        children: (0, $bHJbJ.jsx)((0, $361ca82faf3bbe4f$export$2e2bcd8739ae039), {
            className: "Mui-TableHeadCell-ResizeHandle-Divider",
            flexItem: true,
            orientation: "vertical",
            sx: {
                borderRadius: '2px',
                borderWidth: '2px',
                height: '24px',
                touchAction: 'none',
                transition: column.getIsResizing() ? undefined : 'all 150ms ease-in-out',
                userSelect: 'none',
                zIndex: 4
            }
        })
    });
};
const $30615b8e57e39efe$var$MRT_TableHeadCellSortLabel = ({ header: header, table: table, tableCellProps: tableCellProps })=>{
    const { getState: getState, options: { icons: { ArrowDownwardIcon: ArrowDownwardIcon }, localization: localization } } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const { sorting: sorting } = getState();
    const sortTooltip = column.getIsSorted() ? column.getIsSorted() === 'desc' ? localization.sortedByColumnDesc.replace('{column}', columnDef.header) : localization.sortedByColumnAsc.replace('{column}', columnDef.header) : localization.unsorted;
    return (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
        arrow: true,
        placement: "top",
        title: sortTooltip,
        children: (0, $bHJbJ.jsx)((0, $7a1b6bf7a109b0f7$export$2e2bcd8739ae039), {
            badgeContent: sorting.length > 1 ? column.getSortIndex() + 1 : 0,
            overlap: "circular",
            children: (0, $bHJbJ.jsx)((0, $192837ff1481542b$export$2e2bcd8739ae039), {
                "aria-label": sortTooltip,
                active: !!column.getIsSorted(),
                direction: column.getIsSorted() ? column.getIsSorted() : undefined,
                sx: {
                    flex: '0 0',
                    width: '2.4ch',
                    transform: (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) !== 'right' ? 'translateX(-0.5ch)' : undefined
                },
                IconComponent: ArrowDownwardIcon,
                onClick: (e)=>{
                    var _a;
                    e.stopPropagation();
                    (_a = header.column.getToggleSortingHandler()) === null || _a === void 0 || _a(e);
                }
            })
        })
    });
};
const $30615b8e57e39efe$var$MRT_TableHeadCell = ({ header: header, table: table })=>{
    var _a, _b, _c, _d, _f, _g;
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const { getState: getState, options: { enableColumnActions: enableColumnActions, enableColumnDragging: enableColumnDragging, enableColumnOrdering: enableColumnOrdering, enableGrouping: enableGrouping, enableMultiSort: enableMultiSort, layoutMode: layoutMode, muiTableHeadCellProps: muiTableHeadCellProps }, refs: { tableHeadCellRefs: tableHeadCellRefs }, setHoveredColumn: setHoveredColumn } = table;
    const { density: density, draggingColumn: draggingColumn, grouping: grouping, hoveredColumn: hoveredColumn, showColumnFilters: showColumnFilters } = getState();
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const { columnDefType: columnDefType } = columnDef;
    const mTableHeadCellProps = muiTableHeadCellProps instanceof Function ? muiTableHeadCellProps({
        column: column,
        table: table
    }) : muiTableHeadCellProps;
    const mcTableHeadCellProps = columnDef.muiTableHeadCellProps instanceof Function ? columnDef.muiTableHeadCellProps({
        column: column,
        table: table
    }) : columnDef.muiTableHeadCellProps;
    const tableCellProps = Object.assign(Object.assign({}, mTableHeadCellProps), mcTableHeadCellProps);
    const showColumnActions = (enableColumnActions || columnDef.enableColumnActions) && columnDef.enableColumnActions !== false;
    const showDragHandle = enableColumnDragging !== false && columnDef.enableColumnDragging !== false && (enableColumnDragging || enableColumnOrdering && columnDef.enableColumnOrdering !== false || enableGrouping && columnDef.enableGrouping !== false && !grouping.includes(column.id));
    const headerPL = (0, $i5lfL.useMemo)(()=>{
        let pl = 0;
        if (column.getCanSort()) pl++;
        if (showColumnActions) pl += 1.75;
        if (showDragHandle) pl += 1.25;
        return pl;
    }, [
        showColumnActions,
        showDragHandle
    ]);
    const draggingBorder = (0, $i5lfL.useMemo)(()=>(draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id) === column.id ? `1px dashed ${theme.palette.text.secondary}` : (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === column.id ? `2px dashed ${theme.palette.primary.main}` : undefined, [
        draggingColumn,
        hoveredColumn
    ]);
    const draggingBorders = draggingBorder ? {
        borderLeft: draggingBorder,
        borderRight: draggingBorder,
        borderTop: draggingBorder
    } : undefined;
    const handleDragEnter = (_e)=>{
        if (enableGrouping && (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === 'drop-zone') setHoveredColumn(null);
        if (enableColumnOrdering && draggingColumn && columnDefType !== 'group') setHoveredColumn(columnDef.enableColumnOrdering !== false ? column : null);
    };
    const headerElement = (columnDef === null || columnDef === void 0 ? void 0 : columnDef.Header) instanceof Function ? (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef.Header) === null || _a === void 0 ? void 0 : _a.call(columnDef, {
        column: column,
        header: header,
        table: table
    }) : (_b = columnDef === null || columnDef === void 0 ? void 0 : columnDef.Header) !== null && _b !== void 0 ? _b : columnDef.header;
    return (0, $bHJbJ.jsxs)((0, $6bc4ed7a1f524e0e$export$2e2bcd8739ae039), Object.assign({
        align: columnDefType === 'group' ? 'center' : 'left',
        colSpan: header.colSpan,
        onDragEnter: handleDragEnter,
        ref: (node)=>{
            if (node) tableHeadCellRefs.current[column.id] = node;
        }
    }, tableCellProps, {
        sx: (theme)=>Object.assign(Object.assign({
                flexDirection: layoutMode === 'grid' ? 'column' : undefined,
                fontWeight: 'bold',
                overflow: 'visible',
                p: density === 'compact' ? '0.5rem' : density === 'comfortable' ? columnDefType === 'display' ? '0.75rem' : '1rem' : columnDefType === 'display' ? '1rem 1.25rem' : '1.5rem',
                pb: columnDefType === 'display' ? 0 : showColumnFilters || density === 'compact' ? '0.4rem' : '0.6rem',
                pt: columnDefType === 'group' || density === 'compact' ? '0.25rem' : density === 'comfortable' ? '.75rem' : '1.25rem',
                userSelect: enableMultiSort && column.getCanSort() ? 'none' : undefined,
                verticalAlign: 'top',
                zIndex: column.getIsResizing() || (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id) === column.id ? 3 : column.getIsPinned() && columnDefType !== 'group' ? 2 : 1
            }, $30615b8e57e39efe$var$getCommonCellStyles({
                column: column,
                header: header,
                table: table,
                tableCellProps: tableCellProps,
                theme: theme
            })), draggingBorders),
        children: [
            header.isPlaceholder ? null : (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                className: "Mui-TableHeadCell-Content",
                sx: {
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) === 'right' ? 'row-reverse' : 'row',
                    justifyContent: columnDefType === 'group' || (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) === 'center' ? 'center' : column.getCanResize() ? 'space-between' : 'flex-start',
                    position: 'relative',
                    width: '100%'
                },
                children: [
                    (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        className: "Mui-TableHeadCell-Content-Labels",
                        onClick: column.getToggleSortingHandler(),
                        sx: {
                            alignItems: 'center',
                            cursor: column.getCanSort() && columnDefType !== 'group' ? 'pointer' : undefined,
                            display: 'flex',
                            flexDirection: (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) === 'right' ? 'row-reverse' : 'row',
                            overflow: columnDefType === 'data' ? 'hidden' : undefined,
                            pl: (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) === 'center' ? `${headerPL}rem` : undefined
                        },
                        children: [
                            (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                className: "Mui-TableHeadCell-Content-Wrapper",
                                sx: {
                                    minWidth: `${Math.min((_d = (_c = columnDef.header) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0, 5)}ch`,
                                    overflow: columnDefType === 'data' ? 'hidden' : undefined,
                                    textOverflow: 'ellipsis',
                                    whiteSpace: ((_g = (_f = columnDef.header) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0) < 20 ? 'nowrap' : 'normal',
                                    '&:hover': {
                                        textOverflow: 'clip'
                                    }
                                },
                                title: columnDefType === 'data' ? columnDef.header : undefined,
                                children: headerElement
                            }),
                            column.getCanSort() && (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableHeadCellSortLabel, {
                                header: header,
                                table: table,
                                tableCellProps: tableCellProps
                            }),
                            column.getCanFilter() && (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableHeadCellFilterLabel, {
                                header: header,
                                table: table
                            })
                        ]
                    }),
                    columnDefType !== 'group' && (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        className: "Mui-TableHeadCell-Content-Actions",
                        sx: {
                            whiteSpace: 'nowrap'
                        },
                        children: [
                            showDragHandle && (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableHeadCellGrabHandle, {
                                column: column,
                                table: table,
                                tableHeadCellRef: {
                                    current: tableHeadCellRefs.current[column.id]
                                }
                            }),
                            showColumnActions && (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableHeadCellColumnActionsButton, {
                                header: header,
                                table: table
                            })
                        ]
                    }),
                    column.getCanResize() && (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableHeadCellResizeHandle, {
                        header: header,
                        table: table
                    })
                ]
            }),
            column.getCanFilter() && (0, $bHJbJ.jsx)($30615b8e57e39efe$export$3ae86ee4cf52373f, {
                header: header,
                table: table
            })
        ]
    }));
};
const $30615b8e57e39efe$var$MRT_TableHeadRow = ({ headerGroup: headerGroup, table: table, virtualColumns: virtualColumns, virtualPaddingLeft: virtualPaddingLeft, virtualPaddingRight: virtualPaddingRight })=>{
    const { options: { layoutMode: layoutMode, muiTableHeadRowProps: muiTableHeadRowProps } } = table;
    const tableRowProps = muiTableHeadRowProps instanceof Function ? muiTableHeadRowProps({
        headerGroup: headerGroup,
        table: table
    }) : muiTableHeadRowProps;
    return (0, $bHJbJ.jsxs)((0, $4f773c2e391f97b5$export$2e2bcd8739ae039), Object.assign({}, tableRowProps, {
        sx: (theme)=>Object.assign({
                backgroundColor: (0, $bb6d55b5db31c7f7$export$c0816ed86df316af)(theme.palette.background.default, 0.04),
                boxShadow: `4px 0 8px ${(0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.1)}`,
                display: layoutMode === 'grid' ? 'flex' : 'table-row',
                top: 0
            }, (tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx) instanceof Function ? tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx(theme) : tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx),
        children: [
            virtualPaddingLeft ? (0, $bHJbJ.jsx)("th", {
                style: {
                    display: 'flex',
                    width: virtualPaddingLeft
                }
            }) : null,
            (virtualColumns !== null && virtualColumns !== void 0 ? virtualColumns : headerGroup.headers).map((headerOrVirtualHeader)=>{
                const header = virtualColumns ? headerGroup.headers[headerOrVirtualHeader.index] : headerOrVirtualHeader;
                return (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableHeadCell, {
                    header: header,
                    table: table
                }, header.id);
            }),
            virtualPaddingRight ? (0, $bHJbJ.jsx)("th", {
                style: {
                    display: 'flex',
                    width: virtualPaddingRight
                }
            }) : null
        ]
    }));
};
const $30615b8e57e39efe$var$MRT_TableHead = ({ table: table, virtualColumns: virtualColumns, virtualPaddingLeft: virtualPaddingLeft, virtualPaddingRight: virtualPaddingRight })=>{
    const { getHeaderGroups: getHeaderGroups, getState: getState, options: { enableStickyHeader: enableStickyHeader, layoutMode: layoutMode, muiTableHeadProps: muiTableHeadProps } } = table;
    const { isFullScreen: isFullScreen } = getState();
    const tableHeadProps = muiTableHeadProps instanceof Function ? muiTableHeadProps({
        table: table
    }) : muiTableHeadProps;
    const stickyHeader = enableStickyHeader || isFullScreen;
    return (0, $bHJbJ.jsx)((0, $6784374d2f05d85c$export$2e2bcd8739ae039), Object.assign({}, tableHeadProps, {
        sx: (theme)=>Object.assign({
                display: layoutMode === 'grid' ? 'grid' : 'table-row-group',
                opacity: 0.97,
                position: stickyHeader ? 'sticky' : 'relative',
                top: stickyHeader && layoutMode === 'grid' ? 0 : undefined,
                zIndex: stickyHeader ? 2 : undefined
            }, (tableHeadProps === null || tableHeadProps === void 0 ? void 0 : tableHeadProps.sx) instanceof Function ? tableHeadProps === null || tableHeadProps === void 0 ? void 0 : tableHeadProps.sx(theme) : tableHeadProps === null || tableHeadProps === void 0 ? void 0 : tableHeadProps.sx),
        children: getHeaderGroups().map((headerGroup)=>(0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableHeadRow, {
                headerGroup: headerGroup,
                table: table,
                virtualColumns: virtualColumns,
                virtualPaddingLeft: virtualPaddingLeft,
                virtualPaddingRight: virtualPaddingRight
            }, headerGroup.id))
    }));
};
const $30615b8e57e39efe$var$MRT_EditCellTextField = ({ cell: cell, showLabel: showLabel, table: table })=>{
    var _a, _b, _c;
    const { getState: getState, options: { muiTableBodyCellEditTextFieldProps: muiTableBodyCellEditTextFieldProps }, refs: { editInputRefs: editInputRefs }, setEditingCell: setEditingCell, setEditingRow: setEditingRow } = table;
    const { column: column, row: row } = cell;
    const { columnDef: columnDef } = column;
    const { editingRow: editingRow } = getState();
    const [value, setValue] = (0, $i5lfL.useState)(()=>cell.getValue());
    const mTableBodyCellEditTextFieldProps = muiTableBodyCellEditTextFieldProps instanceof Function ? muiTableBodyCellEditTextFieldProps({
        cell: cell,
        column: column,
        row: row,
        table: table
    }) : muiTableBodyCellEditTextFieldProps;
    const mcTableBodyCellEditTextFieldProps = columnDef.muiTableBodyCellEditTextFieldProps instanceof Function ? columnDef.muiTableBodyCellEditTextFieldProps({
        cell: cell,
        column: column,
        row: row,
        table: table
    }) : columnDef.muiTableBodyCellEditTextFieldProps;
    const textFieldProps = Object.assign(Object.assign({}, mTableBodyCellEditTextFieldProps), mcTableBodyCellEditTextFieldProps);
    const isSelectEdit = columnDef.editVariant === 'select';
    const saveRow = (newValue)=>{
        if (editingRow) setEditingRow(Object.assign(Object.assign({}, editingRow), {
            _valuesCache: Object.assign(Object.assign({}, editingRow._valuesCache), {
                [column.id]: newValue
            })
        }));
    };
    const handleChange = (event)=>{
        var _a;
        (_a = textFieldProps.onChange) === null || _a === void 0 || _a.call(textFieldProps, event);
        setValue(event.target.value);
        if (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.select) saveRow(event.target.value);
    };
    const handleBlur = (event)=>{
        var _a;
        (_a = textFieldProps.onBlur) === null || _a === void 0 || _a.call(textFieldProps, event);
        saveRow(value);
        setEditingCell(null);
    };
    const handleEnterKeyDown = (event)=>{
        var _a, _b;
        (_a = textFieldProps.onKeyDown) === null || _a === void 0 || _a.call(textFieldProps, event);
        if (event.key === 'Enter') (_b = editInputRefs.current[column.id]) === null || _b === void 0 || _b.blur();
    };
    if (columnDef.Edit) return (0, $bHJbJ.jsx)((0, $bHJbJ.Fragment), {
        children: (_a = columnDef.Edit) === null || _a === void 0 ? void 0 : _a.call(columnDef, {
            cell: cell,
            column: column,
            row: row,
            table: table
        })
    });
    return (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), Object.assign({
        disabled: (columnDef.enableEditing instanceof Function ? columnDef.enableEditing(row) : columnDef.enableEditing) === false,
        fullWidth: true,
        inputRef: (inputRef)=>{
            if (inputRef) {
                editInputRefs.current[column.id] = inputRef;
                if (textFieldProps.inputRef) textFieldProps.inputRef = inputRef;
            }
        },
        label: showLabel ? column.columnDef.header : undefined,
        margin: "none",
        name: column.id,
        placeholder: columnDef.header,
        select: isSelectEdit,
        value: value,
        variant: "standard"
    }, textFieldProps, {
        onClick: (e)=>{
            var _a;
            e.stopPropagation();
            (_a = textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.onClick) === null || _a === void 0 || _a.call(textFieldProps, e);
        },
        onBlur: handleBlur,
        onChange: handleChange,
        onKeyDown: handleEnterKeyDown,
        children: (_b = textFieldProps.children) !== null && _b !== void 0 ? _b : (_c = columnDef === null || columnDef === void 0 ? void 0 : columnDef.editSelectOptions) === null || _c === void 0 ? void 0 : _c.map((option)=>{
            let value;
            let text;
            if (typeof option !== 'object') {
                value = option;
                text = option;
            } else {
                value = option.value;
                text = option.text;
            }
            return (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    m: 0,
                    alignItems: 'center',
                    gap: '0.5rem'
                },
                value: value,
                children: text
            }, value);
        })
    }));
};
const $30615b8e57e39efe$export$28f116906b3d657e = ({ cell: cell, children: children, table: table })=>{
    var _a;
    const { options: { localization: localization, muiTableBodyCellCopyButtonProps: muiTableBodyCellCopyButtonProps } } = table;
    const { column: column, row: row } = cell;
    const { columnDef: columnDef } = column;
    const [copied, setCopied] = (0, $i5lfL.useState)(false);
    const handleCopy = (event, text)=>{
        event.stopPropagation();
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(()=>setCopied(false), 4000);
    };
    const mTableBodyCellCopyButtonProps = muiTableBodyCellCopyButtonProps instanceof Function ? muiTableBodyCellCopyButtonProps({
        cell: cell,
        column: column,
        row: row,
        table: table
    }) : muiTableBodyCellCopyButtonProps;
    const mcTableBodyCellCopyButtonProps = columnDef.muiTableBodyCellCopyButtonProps instanceof Function ? columnDef.muiTableBodyCellCopyButtonProps({
        cell: cell,
        column: column,
        row: row,
        table: table
    }) : columnDef.muiTableBodyCellCopyButtonProps;
    const buttonProps = Object.assign(Object.assign({}, mTableBodyCellCopyButtonProps), mcTableBodyCellCopyButtonProps);
    return (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
        arrow: true,
        enterDelay: 1000,
        enterNextDelay: 1000,
        placement: "top",
        title: (_a = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.title) !== null && _a !== void 0 ? _a : copied ? localization.copiedToClipboard : localization.clickToCopy,
        children: (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), Object.assign({
            onClick: (e)=>handleCopy(e, cell.getValue()),
            size: "small",
            type: "button",
            variant: "text"
        }, buttonProps, {
            sx: (theme)=>Object.assign({
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: 'inherit',
                    cursor: 'copy',
                    fontFamily: 'inherit',
                    fontSize: 'inherit',
                    letterSpacing: 'inherit',
                    m: '-0.25rem',
                    minWidth: 'unset',
                    textAlign: 'inherit',
                    textTransform: 'inherit'
                }, (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.sx) instanceof Function ? buttonProps.sx(theme) : buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.sx),
            title: undefined,
            children: children
        }))
    });
};
const $30615b8e57e39efe$var$MRT_TableBodyRowGrabHandle = ({ cell: cell, rowRef: rowRef, table: table })=>{
    const { options: { muiTableBodyRowDragHandleProps: muiTableBodyRowDragHandleProps } } = table;
    const { row: row } = cell;
    const iconButtonProps = muiTableBodyRowDragHandleProps instanceof Function ? muiTableBodyRowDragHandleProps({
        row: row,
        table: table
    }) : muiTableBodyRowDragHandleProps;
    const handleDragStart = (event)=>{
        var _a;
        (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onDragStart) === null || _a === void 0 || _a.call(iconButtonProps, event);
        event.dataTransfer.setDragImage(rowRef.current, 0, 0);
        table.setDraggingRow(row);
    };
    const handleDragEnd = (event)=>{
        var _a;
        (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onDragEnd) === null || _a === void 0 || _a.call(iconButtonProps, event);
        table.setDraggingRow(null);
        table.setHoveredRow(null);
    };
    return (0, $bHJbJ.jsx)($30615b8e57e39efe$export$84d0ca45a1213a16, {
        iconButtonProps: iconButtonProps,
        onDragStart: handleDragStart,
        onDragEnd: handleDragEnd,
        table: table
    });
};
const $30615b8e57e39efe$var$allowedTypes = [
    'string',
    'number'
];
const $30615b8e57e39efe$var$MRT_TableBodyCellValue = ({ cell: cell, table: table })=>{
    var _a, _b, _c;
    const { getState: getState, options: { enableFilterMatchHighlighting: enableFilterMatchHighlighting } } = table;
    const { column: column, row: row } = cell;
    const { columnDef: columnDef } = column;
    const { globalFilter: globalFilter, globalFilterFn: globalFilterFn } = getState();
    const filterValue = column.getFilterValue();
    let renderedCellValue = cell.getIsAggregated() && columnDef.AggregatedCell ? columnDef.AggregatedCell({
        cell: cell,
        column: column,
        row: row,
        table: table
    }) : row.getIsGrouped() && !cell.getIsGrouped() ? null : cell.getIsGrouped() && columnDef.GroupedCell ? columnDef.GroupedCell({
        cell: cell,
        column: column,
        row: row,
        table: table
    }) : undefined;
    const isGroupedValue = renderedCellValue !== undefined;
    if (!isGroupedValue) renderedCellValue = cell.renderValue();
    if (enableFilterMatchHighlighting && columnDef.enableFilterMatchHighlighting !== false && renderedCellValue && $30615b8e57e39efe$var$allowedTypes.includes(typeof renderedCellValue) && (filterValue && $30615b8e57e39efe$var$allowedTypes.includes(typeof filterValue) && columnDef.filterVariant === 'text' || globalFilter && $30615b8e57e39efe$var$allowedTypes.includes(typeof globalFilter) && column.getCanGlobalFilter())) {
        const chunks = (0, $d472912aa0717344$export$2e2bcd8739ae039) === null || (0, $d472912aa0717344$export$2e2bcd8739ae039) === void 0 ? void 0 : (0, $d472912aa0717344$export$2e2bcd8739ae039)({
            text: renderedCellValue === null || renderedCellValue === void 0 ? void 0 : renderedCellValue.toString(),
            query: ((_a = filterValue !== null && filterValue !== void 0 ? filterValue : globalFilter) !== null && _a !== void 0 ? _a : '').toString(),
            matchExactly: (filterValue ? columnDef._filterFn : globalFilterFn) !== 'fuzzy'
        });
        if ((chunks === null || chunks === void 0 ? void 0 : chunks.length) > 1 || ((_b = chunks === null || chunks === void 0 ? void 0 : chunks[0]) === null || _b === void 0 ? void 0 : _b.match)) renderedCellValue = (0, $bHJbJ.jsx)("span", {
            "aria-label": renderedCellValue,
            role: "note",
            children: (_c = chunks === null || chunks === void 0 ? void 0 : chunks.map(({ key: key, match: match, text: text })=>(0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    "aria-hidden": "true",
                    component: "span",
                    sx: match ? {
                        backgroundColor: (theme)=>theme.palette.mode === 'dark' ? (0, $bb6d55b5db31c7f7$export$4b073707ff63303)(theme.palette.warning.dark, 0.25) : (0, $bb6d55b5db31c7f7$export$c0816ed86df316af)(theme.palette.warning.light, 0.5),
                        borderRadius: '2px',
                        color: (theme)=>theme.palette.mode === 'dark' ? 'white' : 'black',
                        padding: '2px 1px'
                    } : undefined,
                    children: text
                }, key))) !== null && _c !== void 0 ? _c : renderedCellValue
        });
    }
    if (columnDef.Cell && !isGroupedValue) renderedCellValue = columnDef.Cell({
        cell: cell,
        renderedCellValue: renderedCellValue,
        column: column,
        row: row,
        table: table
    });
    return (0, $bHJbJ.jsx)((0, $bHJbJ.Fragment), {
        children: renderedCellValue
    });
};
const $30615b8e57e39efe$var$MRT_TableBodyCell = ({ cell: cell, measureElement: measureElement, numRows: numRows, rowIndex: rowIndex, rowRef: rowRef, table: table, virtualCell: virtualCell })=>{
    var _a, _b, _c, _d;
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const { getState: getState, options: { editingMode: editingMode, enableClickToCopy: enableClickToCopy, enableColumnOrdering: enableColumnOrdering, enableEditing: enableEditing, enableGrouping: enableGrouping, enableRowNumbers: enableRowNumbers, layoutMode: layoutMode, muiTableBodyCellProps: muiTableBodyCellProps, muiTableBodyCellSkeletonProps: muiTableBodyCellSkeletonProps, rowNumberMode: rowNumberMode }, refs: { editInputRefs: editInputRefs }, setEditingCell: setEditingCell, setHoveredColumn: setHoveredColumn } = table;
    const { draggingColumn: draggingColumn, draggingRow: draggingRow, editingCell: editingCell, editingRow: editingRow, hoveredColumn: hoveredColumn, hoveredRow: hoveredRow, density: density, isLoading: isLoading, showSkeletons: showSkeletons } = getState();
    const { column: column, row: row } = cell;
    const { columnDef: columnDef } = column;
    const { columnDefType: columnDefType } = columnDef;
    const mTableCellBodyProps = muiTableBodyCellProps instanceof Function ? muiTableBodyCellProps({
        cell: cell,
        column: column,
        row: row,
        table: table
    }) : muiTableBodyCellProps;
    const mcTableCellBodyProps = columnDef.muiTableBodyCellProps instanceof Function ? columnDef.muiTableBodyCellProps({
        cell: cell,
        column: column,
        row: row,
        table: table
    }) : columnDef.muiTableBodyCellProps;
    const tableCellProps = Object.assign(Object.assign({}, mTableCellBodyProps), mcTableCellBodyProps);
    const skeletonProps = muiTableBodyCellSkeletonProps instanceof Function ? muiTableBodyCellSkeletonProps({
        cell: cell,
        column: column,
        row: row,
        table: table
    }) : muiTableBodyCellSkeletonProps;
    const [skeletonWidth, setSkeletonWidth] = (0, $i5lfL.useState)(0);
    (0, $i5lfL.useEffect)(()=>setSkeletonWidth(isLoading || showSkeletons ? columnDefType === 'display' ? column.getSize() / 2 : Math.round(Math.random() * (column.getSize() - column.getSize() / 3) + column.getSize() / 3) : 100), []);
    const draggingBorders = (0, $i5lfL.useMemo)(()=>{
        const isDraggingColumn = (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id) === column.id;
        const isHoveredColumn = (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === column.id;
        const isDraggingRow = (draggingRow === null || draggingRow === void 0 ? void 0 : draggingRow.id) === row.id;
        const isHoveredRow = (hoveredRow === null || hoveredRow === void 0 ? void 0 : hoveredRow.id) === row.id;
        const isFirstColumn = $30615b8e57e39efe$var$getIsFirstColumn(column, table);
        const isLastColumn = $30615b8e57e39efe$var$getIsLastColumn(column, table);
        const isLastRow = rowIndex === numRows - 1;
        const borderStyle = isDraggingColumn || isDraggingRow ? `1px dashed ${theme.palette.text.secondary} !important` : isHoveredColumn || isHoveredRow ? `2px dashed ${theme.palette.primary.main} !important` : undefined;
        return borderStyle ? {
            borderLeft: isDraggingColumn || isHoveredColumn || (isDraggingRow || isHoveredRow) && isFirstColumn ? borderStyle : undefined,
            borderRight: isDraggingColumn || isHoveredColumn || (isDraggingRow || isHoveredRow) && isLastColumn ? borderStyle : undefined,
            borderBottom: isDraggingRow || isHoveredRow || isLastRow ? borderStyle : undefined,
            borderTop: isDraggingRow || isHoveredRow ? borderStyle : undefined
        } : undefined;
    }, [
        draggingColumn,
        draggingRow,
        hoveredColumn,
        hoveredRow,
        rowIndex
    ]);
    const isEditable = (enableEditing instanceof Function ? enableEditing(row) : enableEditing) && (columnDef.enableEditing instanceof Function ? columnDef.enableEditing(row) : columnDef.enableEditing) !== false;
    const isEditing = isEditable && editingMode !== 'modal' && (editingMode === 'table' || (editingRow === null || editingRow === void 0 ? void 0 : editingRow.id) === row.id || (editingCell === null || editingCell === void 0 ? void 0 : editingCell.id) === cell.id) && !row.getIsGrouped();
    const handleDoubleClick = (event)=>{
        var _a;
        (_a = tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.onDoubleClick) === null || _a === void 0 || _a.call(tableCellProps, event);
        if (isEditable && editingMode === 'cell') {
            setEditingCell(cell);
            queueMicrotask(()=>{
                var _a;
                const textField = editInputRefs.current[column.id];
                if (textField) {
                    textField.focus();
                    (_a = textField.select) === null || _a === void 0 || _a.call(textField);
                }
            });
        }
    };
    const handleDragEnter = (e)=>{
        var _a;
        (_a = tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.onDragEnter) === null || _a === void 0 || _a.call(tableCellProps, e);
        if (enableGrouping && (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === 'drop-zone') setHoveredColumn(null);
        if (enableColumnOrdering && draggingColumn) setHoveredColumn(columnDef.enableColumnOrdering !== false ? column : null);
    };
    return (0, $bHJbJ.jsx)((0, $6bc4ed7a1f524e0e$export$2e2bcd8739ae039), Object.assign({
        "data-index": virtualCell === null || virtualCell === void 0 ? void 0 : virtualCell.index,
        ref: (node)=>{
            if (node) measureElement === null || measureElement === void 0 || measureElement(node);
        }
    }, tableCellProps, {
        onDragEnter: handleDragEnter,
        onDoubleClick: handleDoubleClick,
        sx: (theme)=>Object.assign(Object.assign({
                alignItems: layoutMode === 'grid' ? 'center' : undefined,
                cursor: isEditable && editingMode === 'cell' ? 'pointer' : 'inherit',
                justifyContent: layoutMode === 'grid' ? tableCellProps.align : undefined,
                overflow: 'hidden',
                p: density === 'compact' ? columnDefType === 'display' ? '0 0.5rem' : '0.5rem' : density === 'comfortable' ? columnDefType === 'display' ? '0.5rem 0.75rem' : '1rem' : columnDefType === 'display' ? '1rem 1.25rem' : '1.5rem',
                pl: column.id === 'mrt-row-expand' ? `${row.depth + (density === 'compact' ? 0.5 : density === 'comfortable' ? 0.75 : 1.25)}rem` : undefined,
                textOverflow: columnDefType !== 'display' ? 'ellipsis' : undefined,
                whiteSpace: density === 'compact' ? 'nowrap' : 'normal',
                zIndex: (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id) === column.id ? 2 : column.getIsPinned() ? 1 : 0,
                '&:hover': {
                    outline: [
                        'table',
                        'cell'
                    ].includes(editingMode !== null && editingMode !== void 0 ? editingMode : '') ? `1px solid ${theme.palette.text.secondary}` : undefined,
                    outlineOffset: '-1px',
                    textOverflow: 'clip'
                }
            }, $30615b8e57e39efe$var$getCommonCellStyles({
                column: column,
                table: table,
                theme: theme,
                tableCellProps: tableCellProps
            })), draggingBorders),
        children: (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
            children: [
                cell.getIsPlaceholder() ? (_b = (_a = columnDef.PlaceholderCell) === null || _a === void 0 ? void 0 : _a.call(columnDef, {
                    cell: cell,
                    column: column,
                    row: row,
                    table: table
                })) !== null && _b !== void 0 ? _b : null : isLoading || showSkeletons ? (0, $bHJbJ.jsx)((0, $7b73eaf87a610891$export$2e2bcd8739ae039), Object.assign({
                    animation: "wave",
                    height: 20,
                    width: skeletonWidth
                }, skeletonProps)) : enableRowNumbers && rowNumberMode === 'static' && column.id === 'mrt-row-numbers' ? rowIndex + 1 : column.id === 'mrt-row-drag' ? (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableBodyRowGrabHandle, {
                    cell: cell,
                    rowRef: rowRef,
                    table: table
                }) : columnDefType === 'display' && (column.id === 'mrt-row-select' || column.id === 'mrt-row-expand' || !row.getIsGrouped()) ? (_c = columnDef.Cell) === null || _c === void 0 ? void 0 : _c.call(columnDef, {
                    cell: cell,
                    renderedCellValue: cell.renderValue(),
                    column: column,
                    row: row,
                    table: table
                }) : isEditing ? (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_EditCellTextField, {
                    cell: cell,
                    table: table
                }) : (enableClickToCopy || columnDef.enableClickToCopy) && columnDef.enableClickToCopy !== false ? (0, $bHJbJ.jsx)($30615b8e57e39efe$export$28f116906b3d657e, {
                    cell: cell,
                    table: table,
                    children: (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableBodyCellValue, {
                        cell: cell,
                        table: table
                    })
                }) : (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableBodyCellValue, {
                    cell: cell,
                    table: table
                }),
                cell.getIsGrouped() && !columnDef.GroupedCell && (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
                    children: [
                        " (",
                        (_d = row.subRows) === null || _d === void 0 ? void 0 : _d.length,
                        ")"
                    ]
                })
            ]
        })
    }));
};
const $30615b8e57e39efe$var$Memo_MRT_TableBodyCell = (0, $i5lfL.memo)($30615b8e57e39efe$var$MRT_TableBodyCell, (prev, next)=>next.cell === prev.cell);
const $30615b8e57e39efe$var$MRT_TableDetailPanel = ({ parentRowRef: parentRowRef, row: row, rowIndex: rowIndex, table: table, virtualRow: virtualRow })=>{
    const { getVisibleLeafColumns: getVisibleLeafColumns, getState: getState, options: { layoutMode: layoutMode, muiTableBodyRowProps: muiTableBodyRowProps, muiTableDetailPanelProps: muiTableDetailPanelProps, renderDetailPanel: renderDetailPanel } } = table;
    const { isLoading: isLoading } = getState();
    const tableRowProps = muiTableBodyRowProps instanceof Function ? muiTableBodyRowProps({
        isDetailPanel: true,
        row: row,
        staticRowIndex: rowIndex,
        table: table
    }) : muiTableBodyRowProps;
    const tableCellProps = muiTableDetailPanelProps instanceof Function ? muiTableDetailPanelProps({
        row: row,
        table: table
    }) : muiTableDetailPanelProps;
    return (0, $bHJbJ.jsx)((0, $4f773c2e391f97b5$export$2e2bcd8739ae039), Object.assign({
        className: "Mui-TableBodyCell-DetailPanel"
    }, tableRowProps, {
        sx: (theme)=>{
            var _a, _b;
            return Object.assign({
                display: layoutMode === 'grid' ? 'flex' : 'table-row',
                position: virtualRow ? 'absolute' : undefined,
                top: virtualRow ? `${(_b = (_a = parentRowRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.height}px` : undefined,
                transform: virtualRow ? `translateY(${virtualRow === null || virtualRow === void 0 ? void 0 : virtualRow.start}px)` : undefined,
                width: '100%',
                zIndex: virtualRow ? 2 : undefined
            }, (tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx) instanceof Function ? tableRowProps.sx(theme) : tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx);
        },
        children: (0, $bHJbJ.jsx)((0, $6bc4ed7a1f524e0e$export$2e2bcd8739ae039), Object.assign({
            className: "Mui-TableBodyCell-DetailPanel",
            colSpan: getVisibleLeafColumns().length
        }, tableCellProps, {
            sx: (theme)=>Object.assign({
                    backgroundColor: virtualRow ? (0, $bb6d55b5db31c7f7$export$c0816ed86df316af)(theme.palette.background.default, 0.06) : undefined,
                    borderBottom: !row.getIsExpanded() ? 'none' : undefined,
                    display: layoutMode === 'grid' ? 'flex' : 'table-cell',
                    pb: row.getIsExpanded() ? '1rem' : 0,
                    pt: row.getIsExpanded() ? '1rem' : 0,
                    transition: 'all 150ms ease-in-out',
                    width: `${table.getTotalSize()}px`
                }, (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.sx) instanceof Function ? tableCellProps.sx(theme) : tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.sx),
            children: renderDetailPanel && (0, $bHJbJ.jsx)((0, $8d561c5085503182$export$2e2bcd8739ae039), {
                in: row.getIsExpanded(),
                mountOnEnter: true,
                unmountOnExit: true,
                children: !isLoading && renderDetailPanel({
                    row: row,
                    table: table
                })
            })
        }))
    }));
};
const $30615b8e57e39efe$var$MRT_TableBodyRow = ({ columnVirtualizer: columnVirtualizer, measureElement: measureElement, numRows: numRows, row: row, rowIndex: rowIndex, table: table, virtualColumns: virtualColumns, virtualPaddingLeft: virtualPaddingLeft, virtualPaddingRight: virtualPaddingRight, virtualRow: virtualRow })=>{
    const { getState: getState, options: { enableRowOrdering: enableRowOrdering, layoutMode: layoutMode, memoMode: memoMode, muiTableBodyRowProps: muiTableBodyRowProps, renderDetailPanel: renderDetailPanel }, setHoveredRow: setHoveredRow } = table;
    const { draggingColumn: draggingColumn, draggingRow: draggingRow, editingCell: editingCell, editingRow: editingRow, hoveredRow: hoveredRow } = getState();
    const tableRowProps = muiTableBodyRowProps instanceof Function ? muiTableBodyRowProps({
        row: row,
        staticRowIndex: rowIndex,
        table: table
    }) : muiTableBodyRowProps;
    const handleDragEnter = (_e)=>{
        if (enableRowOrdering && draggingRow) setHoveredRow(row);
    };
    const rowRef = (0, $i5lfL.useRef)(null);
    return (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
        children: [
            (0, $bHJbJ.jsxs)((0, $4f773c2e391f97b5$export$2e2bcd8739ae039), Object.assign({
                "data-index": virtualRow === null || virtualRow === void 0 ? void 0 : virtualRow.index,
                onDragEnter: handleDragEnter,
                selected: row.getIsSelected(),
                ref: (node)=>{
                    if (node) {
                        rowRef.current = node;
                        measureElement === null || measureElement === void 0 || measureElement(node);
                    }
                }
            }, tableRowProps, {
                sx: (theme)=>Object.assign({
                        backgroundColor: (0, $bb6d55b5db31c7f7$export$c0816ed86df316af)(theme.palette.background.default, 0.06),
                        boxSizing: 'border-box',
                        display: layoutMode === 'grid' ? 'flex' : 'table-row',
                        opacity: (draggingRow === null || draggingRow === void 0 ? void 0 : draggingRow.id) === row.id || (hoveredRow === null || hoveredRow === void 0 ? void 0 : hoveredRow.id) === row.id ? 0.5 : 1,
                        position: virtualRow ? 'absolute' : undefined,
                        transition: virtualRow ? 'none' : 'all 150ms ease-in-out',
                        top: virtualRow ? 0 : undefined,
                        width: '100%',
                        '&:hover td': {
                            backgroundColor: (tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.hover) !== false ? row.getIsSelected() ? `${(0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.primary.main, 0.2)}` : theme.palette.mode === 'dark' ? `${(0, $bb6d55b5db31c7f7$export$c0816ed86df316af)(theme.palette.background.default, 0.12)}` : `${(0, $bb6d55b5db31c7f7$export$4b073707ff63303)(theme.palette.background.default, 0.05)}` : undefined
                        }
                    }, (tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx) instanceof Function ? tableRowProps.sx(theme) : tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx),
                style: Object.assign({
                    transform: virtualRow ? `translateY(${virtualRow === null || virtualRow === void 0 ? void 0 : virtualRow.start}px)` : undefined
                }, tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.style),
                children: [
                    virtualPaddingLeft ? (0, $bHJbJ.jsx)("td", {
                        style: {
                            display: 'flex',
                            width: virtualPaddingLeft
                        }
                    }) : null,
                    (virtualColumns !== null && virtualColumns !== void 0 ? virtualColumns : row.getVisibleCells()).map((cellOrVirtualCell)=>{
                        const cell = columnVirtualizer ? row.getVisibleCells()[cellOrVirtualCell.index] : cellOrVirtualCell;
                        const props = {
                            cell: cell,
                            measureElement: columnVirtualizer === null || columnVirtualizer === void 0 ? void 0 : columnVirtualizer.measureElement,
                            numRows: numRows,
                            rowIndex: rowIndex,
                            rowRef: rowRef,
                            table: table,
                            virtualCell: columnVirtualizer ? cellOrVirtualCell : undefined
                        };
                        return memoMode === 'cells' && cell.column.columnDef.columnDefType === 'data' && !draggingColumn && !draggingRow && (editingCell === null || editingCell === void 0 ? void 0 : editingCell.id) !== cell.id && (editingRow === null || editingRow === void 0 ? void 0 : editingRow.id) !== row.id ? (0, $bHJbJ.jsx)($30615b8e57e39efe$var$Memo_MRT_TableBodyCell, Object.assign({}, props), cell.id) : (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableBodyCell, Object.assign({}, props), cell.id);
                    }),
                    virtualPaddingRight ? (0, $bHJbJ.jsx)("td", {
                        style: {
                            display: 'flex',
                            width: virtualPaddingRight
                        }
                    }) : null
                ]
            })),
            renderDetailPanel && !row.getIsGrouped() && (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableDetailPanel, {
                parentRowRef: rowRef,
                row: row,
                rowIndex: rowIndex,
                table: table,
                virtualRow: virtualRow
            })
        ]
    });
};
const $30615b8e57e39efe$var$Memo_MRT_TableBodyRow = (0, $i5lfL.memo)($30615b8e57e39efe$var$MRT_TableBodyRow, (prev, next)=>prev.row === next.row && prev.rowIndex === next.rowIndex);
const $30615b8e57e39efe$var$MRT_TableBody = ({ columnVirtualizer: columnVirtualizer, table: table, virtualColumns: virtualColumns, virtualPaddingLeft: virtualPaddingLeft, virtualPaddingRight: virtualPaddingRight })=>{
    var _a, _b, _c, _d;
    const { getRowModel: getRowModel, getPrePaginationRowModel: getPrePaginationRowModel, getState: getState, options: { enableGlobalFilterRankedResults: enableGlobalFilterRankedResults, enablePagination: enablePagination, enableRowVirtualization: enableRowVirtualization, layoutMode: layoutMode, localization: localization, manualExpanding: manualExpanding, manualFiltering: manualFiltering, manualGrouping: manualGrouping, manualPagination: manualPagination, manualSorting: manualSorting, memoMode: memoMode, muiTableBodyProps: muiTableBodyProps, renderEmptyRowsFallback: renderEmptyRowsFallback, rowVirtualizerInstanceRef: rowVirtualizerInstanceRef, rowVirtualizerProps: rowVirtualizerProps, virtualizerInstanceRef: virtualizerInstanceRef, virtualizerProps: virtualizerProps }, refs: { tableContainerRef: tableContainerRef, tablePaperRef: tablePaperRef } } = table;
    const { columnFilters: columnFilters, density: density, expanded: expanded, globalFilter: globalFilter, globalFilterFn: globalFilterFn, pagination: pagination, sorting: sorting } = getState();
    const tableBodyProps = muiTableBodyProps instanceof Function ? muiTableBodyProps({
        table: table
    }) : muiTableBodyProps;
    const vProps_old = virtualizerProps instanceof Function ? virtualizerProps({
        table: table
    }) : virtualizerProps;
    const vProps = rowVirtualizerProps instanceof Function ? rowVirtualizerProps({
        table: table
    }) : rowVirtualizerProps;
    const shouldRankResults = (0, $i5lfL.useMemo)(()=>!manualExpanding && !manualFiltering && !manualGrouping && !manualSorting && enableGlobalFilterRankedResults && globalFilter && globalFilterFn === 'fuzzy' && expanded !== true && !Object.values(sorting).some(Boolean) && !Object.values(expanded).some(Boolean), [
        enableGlobalFilterRankedResults,
        expanded,
        globalFilter,
        manualExpanding,
        manualFiltering,
        manualGrouping,
        manualSorting,
        sorting
    ]);
    const rows = (0, $i5lfL.useMemo)(()=>{
        if (!shouldRankResults) return getRowModel().rows;
        const rankedRows = getPrePaginationRowModel().rows.sort((a, b)=>$30615b8e57e39efe$var$rankGlobalFuzzy(a, b));
        if (enablePagination && !manualPagination) {
            const start = pagination.pageIndex * pagination.pageSize;
            return rankedRows.slice(start, start + pagination.pageSize);
        }
        return rankedRows;
    }, [
        shouldRankResults,
        shouldRankResults ? getPrePaginationRowModel().rows : getRowModel().rows,
        pagination.pageIndex,
        pagination.pageSize
    ]);
    const rowVirtualizer = enableRowVirtualization ? (0, $0b5021d9e7331420$export$dd6d526d88b5a137)(Object.assign(Object.assign({
        count: rows.length,
        estimateSize: ()=>density === 'compact' ? 37 : density === 'comfortable' ? 58 : 73,
        getScrollElement: ()=>tableContainerRef.current,
        measureElement: typeof window !== 'undefined' && navigator.userAgent.indexOf('Firefox') === -1 ? (element)=>element === null || element === void 0 ? void 0 : element.getBoundingClientRect().height : undefined,
        overscan: 4
    }, vProps_old), vProps)) : undefined;
    if (rowVirtualizerInstanceRef && rowVirtualizer) rowVirtualizerInstanceRef.current = rowVirtualizer;
    //deprecated
    if (virtualizerInstanceRef && rowVirtualizer) virtualizerInstanceRef.current = rowVirtualizer;
    const virtualRows = rowVirtualizer ? rowVirtualizer.getVirtualItems() : undefined;
    return (0, $bHJbJ.jsx)((0, $323c5c8d1793d033$export$2e2bcd8739ae039), Object.assign({}, tableBodyProps, {
        sx: (theme)=>Object.assign({
                display: layoutMode === 'grid' ? 'grid' : 'table-row-group',
                height: rowVirtualizer ? `${rowVirtualizer.getTotalSize()}px` : 'inherit',
                minHeight: !rows.length ? '100px' : undefined,
                position: 'relative'
            }, (tableBodyProps === null || tableBodyProps === void 0 ? void 0 : tableBodyProps.sx) instanceof Function ? tableBodyProps === null || tableBodyProps === void 0 ? void 0 : tableBodyProps.sx(theme) : tableBodyProps === null || tableBodyProps === void 0 ? void 0 : tableBodyProps.sx),
        children: (_a = tableBodyProps === null || tableBodyProps === void 0 ? void 0 : tableBodyProps.children) !== null && _a !== void 0 ? _a : !rows.length ? (0, $bHJbJ.jsx)("tr", {
            style: {
                display: layoutMode === 'grid' ? 'grid' : 'table-row'
            },
            children: (0, $bHJbJ.jsx)("td", {
                colSpan: table.getVisibleLeafColumns().length,
                style: {
                    display: layoutMode === 'grid' ? 'grid' : 'table-cell'
                },
                children: (_b = renderEmptyRowsFallback === null || renderEmptyRowsFallback === void 0 ? void 0 : renderEmptyRowsFallback({
                    table: table
                })) !== null && _b !== void 0 ? _b : (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                    sx: {
                        color: 'text.secondary',
                        fontStyle: 'italic',
                        maxWidth: `min(100vw, ${(_d = (_c = tablePaperRef.current) === null || _c === void 0 ? void 0 : _c.clientWidth) !== null && _d !== void 0 ? _d : 360}px)`,
                        py: '2rem',
                        textAlign: 'center',
                        width: '100%'
                    },
                    children: globalFilter || columnFilters.length ? localization.noResultsFound : localization.noRecordsToDisplay
                })
            })
        }) : (0, $bHJbJ.jsx)((0, $bHJbJ.Fragment), {
            children: (virtualRows !== null && virtualRows !== void 0 ? virtualRows : rows).map((rowOrVirtualRow, rowIndex)=>{
                const row = rowVirtualizer ? rows[rowOrVirtualRow.index] : rowOrVirtualRow;
                const props = {
                    columnVirtualizer: columnVirtualizer,
                    measureElement: rowVirtualizer === null || rowVirtualizer === void 0 ? void 0 : rowVirtualizer.measureElement,
                    numRows: rows.length,
                    row: row,
                    rowIndex: rowVirtualizer ? rowOrVirtualRow.index : rowIndex,
                    table: table,
                    virtualColumns: virtualColumns,
                    virtualPaddingLeft: virtualPaddingLeft,
                    virtualPaddingRight: virtualPaddingRight,
                    virtualRow: rowVirtualizer ? rowOrVirtualRow : undefined
                };
                return memoMode === 'rows' ? (0, $bHJbJ.jsx)($30615b8e57e39efe$var$Memo_MRT_TableBodyRow, Object.assign({}, props), row.id) : (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableBodyRow, Object.assign({}, props), row.id);
            })
        })
    }));
};
const $30615b8e57e39efe$var$Memo_MRT_TableBody = (0, $i5lfL.memo)($30615b8e57e39efe$var$MRT_TableBody, (prev, next)=>prev.table.options.data === next.table.options.data);
const $30615b8e57e39efe$var$MRT_TableFooterCell = ({ footer: footer, table: table })=>{
    var _a, _b, _c;
    const { getState: getState, options: { layoutMode: layoutMode, muiTableFooterCellProps: muiTableFooterCellProps } } = table;
    const { density: density } = getState();
    const { column: column } = footer;
    const { columnDef: columnDef } = column;
    const { columnDefType: columnDefType } = columnDef;
    const mTableFooterCellProps = muiTableFooterCellProps instanceof Function ? muiTableFooterCellProps({
        column: column,
        table: table
    }) : muiTableFooterCellProps;
    const mcTableFooterCellProps = columnDef.muiTableFooterCellProps instanceof Function ? columnDef.muiTableFooterCellProps({
        column: column,
        table: table
    }) : columnDef.muiTableFooterCellProps;
    const tableCellProps = Object.assign(Object.assign({}, mTableFooterCellProps), mcTableFooterCellProps);
    return (0, $bHJbJ.jsx)((0, $6bc4ed7a1f524e0e$export$2e2bcd8739ae039), Object.assign({
        align: columnDefType === 'group' ? 'center' : 'left',
        colSpan: footer.colSpan,
        variant: "head"
    }, tableCellProps, {
        sx: (theme)=>Object.assign({
                display: layoutMode === 'grid' ? 'grid' : 'table-cell',
                fontWeight: 'bold',
                justifyContent: columnDefType === 'group' ? 'center' : undefined,
                p: density === 'compact' ? '0.5rem' : density === 'comfortable' ? '1rem' : '1.5rem',
                verticalAlign: 'top',
                zIndex: column.getIsPinned() && columnDefType !== 'group' ? 2 : 1
            }, $30615b8e57e39efe$var$getCommonCellStyles({
                column: column,
                table: table,
                theme: theme,
                tableCellProps: tableCellProps
            })),
        children: (0, $bHJbJ.jsx)((0, $bHJbJ.Fragment), {
            children: footer.isPlaceholder ? null : (_c = (_b = columnDef.Footer instanceof Function ? (_a = columnDef.Footer) === null || _a === void 0 ? void 0 : _a.call(columnDef, {
                column: column,
                footer: footer,
                table: table
            }) : columnDef.Footer) !== null && _b !== void 0 ? _b : columnDef.footer) !== null && _c !== void 0 ? _c : null
        })
    }));
};
const $30615b8e57e39efe$var$MRT_TableFooterRow = ({ footerGroup: footerGroup, table: table, virtualColumns: virtualColumns, virtualPaddingLeft: virtualPaddingLeft, virtualPaddingRight: virtualPaddingRight })=>{
    var _a;
    const { options: { layoutMode: layoutMode, muiTableFooterRowProps: muiTableFooterRowProps } } = table;
    // if no content in row, skip row
    if (!((_a = footerGroup.headers) === null || _a === void 0 ? void 0 : _a.some((header)=>typeof header.column.columnDef.footer === 'string' && !!header.column.columnDef.footer || header.column.columnDef.Footer))) return null;
    const tableRowProps = muiTableFooterRowProps instanceof Function ? muiTableFooterRowProps({
        footerGroup: footerGroup,
        table: table
    }) : muiTableFooterRowProps;
    return (0, $bHJbJ.jsxs)((0, $4f773c2e391f97b5$export$2e2bcd8739ae039), Object.assign({}, tableRowProps, {
        sx: (theme)=>Object.assign({
                backgroundColor: (0, $bb6d55b5db31c7f7$export$c0816ed86df316af)(theme.palette.background.default, 0.04),
                display: layoutMode === 'grid' ? 'flex' : 'table-row',
                width: '100%'
            }, (tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx) instanceof Function ? tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx(theme) : tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx),
        children: [
            virtualPaddingLeft ? (0, $bHJbJ.jsx)("th", {
                style: {
                    display: 'flex',
                    width: virtualPaddingLeft
                }
            }) : null,
            (virtualColumns !== null && virtualColumns !== void 0 ? virtualColumns : footerGroup.headers).map((footerOrVirtualFooter)=>{
                const footer = virtualColumns ? footerGroup.headers[footerOrVirtualFooter.index] : footerOrVirtualFooter;
                return (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableFooterCell, {
                    footer: footer,
                    table: table
                }, footer.id);
            }),
            virtualPaddingRight ? (0, $bHJbJ.jsx)("th", {
                style: {
                    display: 'flex',
                    width: virtualPaddingRight
                }
            }) : null
        ]
    }));
};
const $30615b8e57e39efe$var$MRT_TableFooter = ({ table: table, virtualColumns: virtualColumns, virtualPaddingLeft: virtualPaddingLeft, virtualPaddingRight: virtualPaddingRight })=>{
    const { getFooterGroups: getFooterGroups, getState: getState, options: { enableStickyFooter: enableStickyFooter, layoutMode: layoutMode, muiTableFooterProps: muiTableFooterProps } } = table;
    const { isFullScreen: isFullScreen } = getState();
    const tableFooterProps = muiTableFooterProps instanceof Function ? muiTableFooterProps({
        table: table
    }) : muiTableFooterProps;
    const stickFooter = (isFullScreen || enableStickyFooter) && enableStickyFooter !== false;
    return (0, $bHJbJ.jsx)((0, $76e24f2e3b62794c$export$2e2bcd8739ae039), Object.assign({}, tableFooterProps, {
        sx: (theme)=>Object.assign({
                bottom: stickFooter ? 0 : undefined,
                display: layoutMode === 'grid' ? 'grid' : 'table-row-group',
                opacity: stickFooter ? 0.97 : undefined,
                outline: stickFooter ? theme.palette.mode === 'light' ? `1px solid ${theme.palette.grey[300]}` : `1px solid ${theme.palette.grey[700]}` : undefined,
                position: stickFooter ? 'sticky' : undefined,
                zIndex: stickFooter ? 1 : undefined
            }, (tableFooterProps === null || tableFooterProps === void 0 ? void 0 : tableFooterProps.sx) instanceof Function ? tableFooterProps === null || tableFooterProps === void 0 ? void 0 : tableFooterProps.sx(theme) : tableFooterProps === null || tableFooterProps === void 0 ? void 0 : tableFooterProps.sx),
        children: getFooterGroups().map((footerGroup)=>(0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableFooterRow, {
                footerGroup: footerGroup,
                table: table,
                virtualColumns: virtualColumns,
                virtualPaddingLeft: virtualPaddingLeft,
                virtualPaddingRight: virtualPaddingRight
            }, footerGroup.id))
    }));
};
const $30615b8e57e39efe$var$MRT_Table = ({ table: table })=>{
    var _a, _b, _c, _d;
    const { getFlatHeaders: getFlatHeaders, getState: getState, options: { columns: columns, columnVirtualizerInstanceRef: columnVirtualizerInstanceRef, columnVirtualizerProps: columnVirtualizerProps, enableColumnResizing: enableColumnResizing, enableColumnVirtualization: enableColumnVirtualization, enablePinning: enablePinning, enableStickyHeader: enableStickyHeader, enableTableFooter: enableTableFooter, enableTableHead: enableTableHead, layoutMode: layoutMode, memoMode: memoMode, muiTableProps: muiTableProps }, refs: { tableContainerRef: tableContainerRef } } = table;
    const { columnPinning: columnPinning, columnSizing: columnSizing, columnSizingInfo: columnSizingInfo, columnVisibility: columnVisibility, isFullScreen: isFullScreen } = getState();
    const tableProps = muiTableProps instanceof Function ? muiTableProps({
        table: table
    }) : muiTableProps;
    const vProps = columnVirtualizerProps instanceof Function ? columnVirtualizerProps({
        table: table
    }) : columnVirtualizerProps;
    const columnSizeVars = (0, $i5lfL.useMemo)(()=>{
        const headers = getFlatHeaders();
        const colSizes = {};
        for(let i = 0; i < headers.length; i++){
            const header = headers[i];
            const colSize = header.getSize();
            colSizes[`--header-${$30615b8e57e39efe$var$parseCSSVarId(header.id)}-size`] = colSize;
            colSizes[`--col-${$30615b8e57e39efe$var$parseCSSVarId(header.column.id)}-size`] = colSize;
        }
        return colSizes;
    }, [
        columns,
        columnSizing,
        columnSizingInfo,
        columnVisibility
    ]);
    //get first 16 column widths and average them
    const averageColumnWidth = (0, $i5lfL.useMemo)(()=>{
        var _a, _b, _c, _d;
        if (!enableColumnVirtualization) return 0;
        const columnsWidths = (_d = (_c = (_b = (_a = table.getRowModel().rows[0]) === null || _a === void 0 ? void 0 : _a.getCenterVisibleCells()) === null || _b === void 0 ? void 0 : _b.slice(0, 16)) === null || _c === void 0 ? void 0 : _c.map((cell)=>cell.column.getSize() * 1.2)) !== null && _d !== void 0 ? _d : [];
        return columnsWidths.reduce((a, b)=>a + b, 0) / columnsWidths.length;
    }, [
        table.getRowModel().rows,
        columnPinning,
        columnVisibility
    ]);
    const [leftPinnedIndexes, rightPinnedIndexes] = (0, $i5lfL.useMemo)(()=>enableColumnVirtualization && enablePinning ? [
            table.getLeftLeafColumns().map((c)=>c.getPinnedIndex()),
            table.getRightLeafColumns().map((c)=>table.getVisibleLeafColumns().length - c.getPinnedIndex() - 1)
        ] : [
            [],
            []
        ], [
        columnPinning,
        enableColumnVirtualization,
        enablePinning
    ]);
    const columnVirtualizer = enableColumnVirtualization ? (0, $0b5021d9e7331420$export$dd6d526d88b5a137)(Object.assign({
        count: table.getVisibleLeafColumns().length,
        estimateSize: ()=>averageColumnWidth,
        getScrollElement: ()=>tableContainerRef.current,
        horizontal: true,
        overscan: 3,
        rangeExtractor: (0, $i5lfL.useCallback)((range)=>[
                ...new Set([
                    ...leftPinnedIndexes,
                    ...(0, $3HLSL.defaultRangeExtractor)(range),
                    ...rightPinnedIndexes
                ])
            ], [
            leftPinnedIndexes,
            rightPinnedIndexes
        ])
    }, vProps)) : undefined;
    if (columnVirtualizerInstanceRef && columnVirtualizer) columnVirtualizerInstanceRef.current = columnVirtualizer;
    const virtualColumns = columnVirtualizer ? columnVirtualizer.getVirtualItems() : undefined;
    let virtualPaddingLeft;
    let virtualPaddingRight;
    if (columnVirtualizer && (virtualColumns === null || virtualColumns === void 0 ? void 0 : virtualColumns.length)) {
        virtualPaddingLeft = (_b = (_a = virtualColumns[leftPinnedIndexes.length]) === null || _a === void 0 ? void 0 : _a.start) !== null && _b !== void 0 ? _b : 0;
        virtualPaddingRight = columnVirtualizer.getTotalSize() - ((_d = (_c = virtualColumns[virtualColumns.length - 1 - rightPinnedIndexes.length]) === null || _c === void 0 ? void 0 : _c.end) !== null && _d !== void 0 ? _d : 0);
    }
    const props = {
        table: table,
        virtualColumns: virtualColumns,
        virtualPaddingLeft: virtualPaddingLeft,
        virtualPaddingRight: virtualPaddingRight
    };
    return (0, $bHJbJ.jsxs)((0, $db43f7cb09503259$export$2e2bcd8739ae039), Object.assign({
        stickyHeader: enableStickyHeader || isFullScreen
    }, tableProps, {
        sx: (theme)=>Object.assign({
                borderCollapse: 'separate',
                display: layoutMode === 'grid' ? 'grid' : 'table',
                tableLayout: layoutMode !== 'grid' && enableColumnResizing ? 'fixed' : undefined
            }, (tableProps === null || tableProps === void 0 ? void 0 : tableProps.sx) instanceof Function ? tableProps.sx(theme) : tableProps === null || tableProps === void 0 ? void 0 : tableProps.sx),
        style: Object.assign(Object.assign({}, columnSizeVars), tableProps === null || tableProps === void 0 ? void 0 : tableProps.style),
        children: [
            enableTableHead && (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableHead, Object.assign({}, props)),
            memoMode === 'table-body' || columnSizingInfo.isResizingColumn ? (0, $bHJbJ.jsx)($30615b8e57e39efe$var$Memo_MRT_TableBody, Object.assign({
                columnVirtualizer: columnVirtualizer
            }, props)) : (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableBody, Object.assign({
                columnVirtualizer: columnVirtualizer
            }, props)),
            enableTableFooter && (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableFooter, Object.assign({}, props))
        ]
    }));
};
const $30615b8e57e39efe$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, $i5lfL.useLayoutEffect) : (0, $i5lfL.useEffect);
const $30615b8e57e39efe$var$MRT_TableContainer = ({ table: table })=>{
    const { getState: getState, options: { enableStickyHeader: enableStickyHeader, muiTableContainerProps: muiTableContainerProps }, refs: { tableContainerRef: tableContainerRef, bottomToolbarRef: bottomToolbarRef, topToolbarRef: topToolbarRef } } = table;
    const { isFullScreen: isFullScreen } = getState();
    const [totalToolbarHeight, setTotalToolbarHeight] = (0, $i5lfL.useState)(0);
    const tableContainerProps = muiTableContainerProps instanceof Function ? muiTableContainerProps({
        table: table
    }) : muiTableContainerProps;
    $30615b8e57e39efe$var$useIsomorphicLayoutEffect(()=>{
        var _a, _b, _c, _d;
        const topToolbarHeight = typeof document !== 'undefined' ? (_b = (_a = topToolbarRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0 : 0;
        const bottomToolbarHeight = typeof document !== 'undefined' ? (_d = (_c = bottomToolbarRef === null || bottomToolbarRef === void 0 ? void 0 : bottomToolbarRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0 : 0;
        setTotalToolbarHeight(topToolbarHeight + bottomToolbarHeight);
    });
    return (0, $bHJbJ.jsx)((0, $b7119d3fe107b52e$export$2e2bcd8739ae039), Object.assign({}, tableContainerProps, {
        ref: (node)=>{
            if (node) {
                tableContainerRef.current = node;
                if (tableContainerProps === null || tableContainerProps === void 0 ? void 0 : tableContainerProps.ref) //@ts-ignore
                tableContainerProps.ref.current = node;
            }
        },
        sx: (theme)=>Object.assign({
                maxWidth: '100%',
                maxHeight: enableStickyHeader ? `clamp(350px, calc(100vh - ${totalToolbarHeight}px), 9999px)` : undefined,
                overflow: 'auto'
            }, (tableContainerProps === null || tableContainerProps === void 0 ? void 0 : tableContainerProps.sx) instanceof Function ? tableContainerProps.sx(theme) : tableContainerProps === null || tableContainerProps === void 0 ? void 0 : tableContainerProps.sx),
        style: Object.assign({
            maxHeight: isFullScreen ? `calc(100vh - ${totalToolbarHeight}px)` : undefined
        }, tableContainerProps === null || tableContainerProps === void 0 ? void 0 : tableContainerProps.style),
        children: (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_Table, {
            table: table
        })
    }));
};
const $30615b8e57e39efe$var$MRT_TablePaper = ({ table: table })=>{
    const { getState: getState, options: { enableBottomToolbar: enableBottomToolbar, enableTopToolbar: enableTopToolbar, muiTablePaperProps: muiTablePaperProps, renderBottomToolbar: renderBottomToolbar, renderTopToolbar: renderTopToolbar }, refs: { tablePaperRef: tablePaperRef } } = table;
    const { isFullScreen: isFullScreen } = getState();
    const tablePaperProps = muiTablePaperProps instanceof Function ? muiTablePaperProps({
        table: table
    }) : muiTablePaperProps;
    return (0, $bHJbJ.jsxs)((0, $fa105ed17f31a2c8$export$2e2bcd8739ae039), Object.assign({
        elevation: 2
    }, tablePaperProps, {
        ref: (ref)=>{
            tablePaperRef.current = ref;
            if (tablePaperProps === null || tablePaperProps === void 0 ? void 0 : tablePaperProps.ref) //@ts-ignore
            tablePaperProps.ref.current = ref;
        },
        sx: (theme)=>Object.assign({
                transition: 'all 150ms ease-in-out'
            }, (tablePaperProps === null || tablePaperProps === void 0 ? void 0 : tablePaperProps.sx) instanceof Function ? tablePaperProps === null || tablePaperProps === void 0 ? void 0 : tablePaperProps.sx(theme) : tablePaperProps === null || tablePaperProps === void 0 ? void 0 : tablePaperProps.sx),
        style: Object.assign(Object.assign({}, tablePaperProps === null || tablePaperProps === void 0 ? void 0 : tablePaperProps.style), isFullScreen ? {
            height: '100vh',
            margin: 0,
            maxHeight: '100vh',
            maxWidth: '100vw',
            padding: 0,
            width: '100vw'
        } : {}),
        children: [
            enableTopToolbar && (renderTopToolbar instanceof Function ? renderTopToolbar({
                table: table
            }) : renderTopToolbar !== null && renderTopToolbar !== void 0 ? renderTopToolbar : (0, $bHJbJ.jsx)($30615b8e57e39efe$export$833ce02671e611ef, {
                table: table
            })),
            (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableContainer, {
                table: table
            }),
            enableBottomToolbar && (renderBottomToolbar instanceof Function ? renderBottomToolbar({
                table: table
            }) : renderBottomToolbar !== null && renderBottomToolbar !== void 0 ? renderBottomToolbar : (0, $bHJbJ.jsx)($30615b8e57e39efe$export$802d7d5e9270e154, {
                table: table
            }))
        ]
    }));
};
const $30615b8e57e39efe$var$MRT_EditRowModal = ({ open: open, row: row, table: table })=>{
    const { options: { localization: localization } } = table;
    return (0, $bHJbJ.jsxs)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039), {
        open: open,
        children: [
            (0, $bHJbJ.jsx)((0, $48d8f4c3325a9037$export$2e2bcd8739ae039), {
                textAlign: "center",
                children: localization.edit
            }),
            (0, $bHJbJ.jsx)((0, $422502a3833a93e2$export$2e2bcd8739ae039), {
                children: (0, $bHJbJ.jsx)("form", {
                    onSubmit: (e)=>e.preventDefault(),
                    children: (0, $bHJbJ.jsx)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
                        sx: {
                            gap: '1.5rem',
                            minWidth: {
                                xs: '300px',
                                sm: '360px',
                                md: '400px'
                            },
                            pt: '1rem',
                            width: '100%'
                        },
                        children: row.getAllCells().filter((cell)=>cell.column.columnDef.columnDefType === 'data').map((cell)=>(0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_EditCellTextField, {
                                cell: cell,
                                showLabel: true,
                                table: table
                            }, cell.id))
                    })
                })
            }),
            (0, $bHJbJ.jsx)((0, $0d4f9b05ed57077c$export$2e2bcd8739ae039), {
                sx: {
                    p: '1.25rem'
                },
                children: (0, $bHJbJ.jsx)($30615b8e57e39efe$export$e9ac3fa68bee6831, {
                    row: row,
                    table: table,
                    variant: "text"
                })
            })
        ]
    });
};
const $30615b8e57e39efe$var$MRT_TableRoot = (props)=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13;
    const bottomToolbarRef = (0, $i5lfL.useRef)(null);
    const editInputRefs = (0, $i5lfL.useRef)({});
    const filterInputRefs = (0, $i5lfL.useRef)({});
    const searchInputRef = (0, $i5lfL.useRef)(null);
    const tableContainerRef = (0, $i5lfL.useRef)(null);
    const tableHeadCellRefs = (0, $i5lfL.useRef)({});
    const tablePaperRef = (0, $i5lfL.useRef)(null);
    const topToolbarRef = (0, $i5lfL.useRef)(null);
    const initialState = (0, $i5lfL.useMemo)(()=>{
        var _a, _b, _c;
        const initState = (_a = props.initialState) !== null && _a !== void 0 ? _a : {};
        initState.columnOrder = (_b = initState.columnOrder) !== null && _b !== void 0 ? _b : $30615b8e57e39efe$var$getDefaultColumnOrderIds(props);
        initState.globalFilterFn = (_c = props.globalFilterFn) !== null && _c !== void 0 ? _c : 'fuzzy';
        return initState;
    }, []);
    const [columnFilterFns, setColumnFilterFns] = (0, $i5lfL.useState)(()=>Object.assign({}, ...$30615b8e57e39efe$var$getAllLeafColumnDefs(props.columns).map((col)=>{
            var _a, _b, _c, _d;
            return {
                [$30615b8e57e39efe$var$getColumnId(col)]: col.filterFn instanceof Function ? (_a = col.filterFn.name) !== null && _a !== void 0 ? _a : 'custom' : (_d = (_b = col.filterFn) !== null && _b !== void 0 ? _b : (_c = initialState === null || initialState === void 0 ? void 0 : initialState.columnFilterFns) === null || _c === void 0 ? void 0 : _c[$30615b8e57e39efe$var$getColumnId(col)]) !== null && _d !== void 0 ? _d : $30615b8e57e39efe$var$getDefaultColumnFilterFn(col)
            };
        })));
    const [columnOrder, setColumnOrder] = (0, $i5lfL.useState)((_a = initialState.columnOrder) !== null && _a !== void 0 ? _a : []);
    const [density, setDensity] = (0, $i5lfL.useState)((_b = initialState === null || initialState === void 0 ? void 0 : initialState.density) !== null && _b !== void 0 ? _b : 'comfortable');
    const [draggingColumn, setDraggingColumn] = (0, $i5lfL.useState)((_c = initialState.draggingColumn) !== null && _c !== void 0 ? _c : null);
    const [draggingRow, setDraggingRow] = (0, $i5lfL.useState)((_d = initialState.draggingRow) !== null && _d !== void 0 ? _d : null);
    const [editingCell, setEditingCell] = (0, $i5lfL.useState)((_e = initialState.editingCell) !== null && _e !== void 0 ? _e : null);
    const [editingRow, setEditingRow] = (0, $i5lfL.useState)((_f = initialState.editingRow) !== null && _f !== void 0 ? _f : null);
    const [globalFilterFn, setGlobalFilterFn] = (0, $i5lfL.useState)((_g = initialState.globalFilterFn) !== null && _g !== void 0 ? _g : 'fuzzy');
    const [grouping, setGrouping] = (0, $i5lfL.useState)((_h = initialState.grouping) !== null && _h !== void 0 ? _h : []);
    const [hoveredColumn, setHoveredColumn] = (0, $i5lfL.useState)((_j = initialState.hoveredColumn) !== null && _j !== void 0 ? _j : null);
    const [hoveredRow, setHoveredRow] = (0, $i5lfL.useState)((_k = initialState.hoveredRow) !== null && _k !== void 0 ? _k : null);
    const [isFullScreen, setIsFullScreen] = (0, $i5lfL.useState)((_l = initialState === null || initialState === void 0 ? void 0 : initialState.isFullScreen) !== null && _l !== void 0 ? _l : false);
    const [showAlertBanner, setShowAlertBanner] = (0, $i5lfL.useState)((_o = (_m = props.initialState) === null || _m === void 0 ? void 0 : _m.showAlertBanner) !== null && _o !== void 0 ? _o : false);
    const [showColumnFilters, setShowColumnFilters] = (0, $i5lfL.useState)((_p = initialState === null || initialState === void 0 ? void 0 : initialState.showColumnFilters) !== null && _p !== void 0 ? _p : false);
    const [showGlobalFilter, setShowGlobalFilter] = (0, $i5lfL.useState)((_q = initialState === null || initialState === void 0 ? void 0 : initialState.showGlobalFilter) !== null && _q !== void 0 ? _q : false);
    const [showToolbarDropZone, setShowToolbarDropZone] = (0, $i5lfL.useState)((_r = initialState === null || initialState === void 0 ? void 0 : initialState.showToolbarDropZone) !== null && _r !== void 0 ? _r : false);
    const displayColumns = (0, $i5lfL.useMemo)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        return [
            ((_b = (_a = props.state) === null || _a === void 0 ? void 0 : _a.columnOrder) !== null && _b !== void 0 ? _b : columnOrder).includes('mrt-row-drag') && Object.assign(Object.assign(Object.assign({
                header: props.localization.move,
                size: 60
            }, props.defaultDisplayColumn), (_c = props.displayColumnDefOptions) === null || _c === void 0 ? void 0 : _c['mrt-row-drag']), {
                id: 'mrt-row-drag'
            }),
            ((_e = (_d = props.state) === null || _d === void 0 ? void 0 : _d.columnOrder) !== null && _e !== void 0 ? _e : columnOrder).includes('mrt-row-actions') && Object.assign(Object.assign(Object.assign({
                Cell: ({ cell: cell, row: row })=>(0, $bHJbJ.jsx)($30615b8e57e39efe$export$d1d7822219c6bc0, {
                        cell: cell,
                        row: row,
                        table: table
                    }),
                header: props.localization.actions,
                size: 70
            }, props.defaultDisplayColumn), (_f = props.displayColumnDefOptions) === null || _f === void 0 ? void 0 : _f['mrt-row-actions']), {
                id: 'mrt-row-actions'
            }),
            ((_h = (_g = props.state) === null || _g === void 0 ? void 0 : _g.columnOrder) !== null && _h !== void 0 ? _h : columnOrder).includes('mrt-row-expand') && $30615b8e57e39efe$var$showExpandColumn(props, (_k = (_j = props.state) === null || _j === void 0 ? void 0 : _j.grouping) !== null && _k !== void 0 ? _k : grouping) && Object.assign(Object.assign(Object.assign({
                Cell: ({ row: row })=>(0, $bHJbJ.jsx)($30615b8e57e39efe$export$25237f0a7e0a5aea, {
                        row: row,
                        table: table
                    }),
                Header: props.enableExpandAll ? ()=>(0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_ExpandAllButton, {
                        table: table
                    }) : null,
                header: props.localization.expand,
                size: 60
            }, props.defaultDisplayColumn), (_l = props.displayColumnDefOptions) === null || _l === void 0 ? void 0 : _l['mrt-row-expand']), {
                id: 'mrt-row-expand'
            }),
            ((_o = (_m = props.state) === null || _m === void 0 ? void 0 : _m.columnOrder) !== null && _o !== void 0 ? _o : columnOrder).includes('mrt-row-select') && Object.assign(Object.assign(Object.assign({
                Cell: ({ row: row })=>(0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_SelectCheckbox, {
                        row: row,
                        table: table
                    }),
                Header: props.enableSelectAll && props.enableMultiRowSelection ? ()=>(0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_SelectCheckbox, {
                        selectAll: true,
                        table: table
                    }) : null,
                header: props.localization.select,
                size: 60
            }, props.defaultDisplayColumn), (_p = props.displayColumnDefOptions) === null || _p === void 0 ? void 0 : _p['mrt-row-select']), {
                id: 'mrt-row-select'
            }),
            ((_r = (_q = props.state) === null || _q === void 0 ? void 0 : _q.columnOrder) !== null && _r !== void 0 ? _r : columnOrder).includes('mrt-row-numbers') && Object.assign(Object.assign(Object.assign({
                Cell: ({ row: row })=>row.index + 1,
                Header: ()=>props.localization.rowNumber,
                header: props.localization.rowNumbers,
                size: 60
            }, props.defaultDisplayColumn), (_s = props.displayColumnDefOptions) === null || _s === void 0 ? void 0 : _s['mrt-row-numbers']), {
                id: 'mrt-row-numbers'
            })
        ].filter(Boolean);
    }, [
        columnOrder,
        grouping,
        props.displayColumnDefOptions,
        props.editingMode,
        props.enableColumnDragging,
        props.enableColumnFilterModes,
        props.enableColumnOrdering,
        props.enableEditing,
        props.enableExpandAll,
        props.enableExpanding,
        props.enableGrouping,
        props.enableRowActions,
        props.enableRowDragging,
        props.enableRowNumbers,
        props.enableRowOrdering,
        props.enableRowSelection,
        props.enableSelectAll,
        props.localization,
        props.positionActionsColumn,
        props.renderDetailPanel,
        props.renderRowActionMenuItems,
        props.renderRowActions,
        (_s = props.state) === null || _s === void 0 ? void 0 : _s.columnOrder,
        (_t = props.state) === null || _t === void 0 ? void 0 : _t.grouping
    ]);
    const columnDefs = (0, $i5lfL.useMemo)(()=>{
        var _a, _b, _c;
        return $30615b8e57e39efe$var$prepareColumns({
            aggregationFns: props.aggregationFns,
            columnDefs: [
                ...displayColumns,
                ...props.columns
            ],
            columnFilterFns: (_b = (_a = props.state) === null || _a === void 0 ? void 0 : _a.columnFilterFns) !== null && _b !== void 0 ? _b : columnFilterFns,
            defaultDisplayColumn: (_c = props.defaultDisplayColumn) !== null && _c !== void 0 ? _c : {},
            filterFns: props.filterFns,
            sortingFns: props.sortingFns
        });
    }, [
        columnFilterFns,
        displayColumns,
        props.columns,
        (_u = props.state) === null || _u === void 0 ? void 0 : _u.columnFilterFns
    ]);
    const data = (0, $i5lfL.useMemo)(()=>{
        var _a, _b, _c, _d, _e;
        return (((_a = props.state) === null || _a === void 0 ? void 0 : _a.isLoading) || ((_b = props.state) === null || _b === void 0 ? void 0 : _b.showSkeletons)) && !props.data.length ? [
            ...Array(((_d = (_c = props.state) === null || _c === void 0 ? void 0 : _c.pagination) === null || _d === void 0 ? void 0 : _d.pageSize) || ((_e = initialState === null || initialState === void 0 ? void 0 : initialState.pagination) === null || _e === void 0 ? void 0 : _e.pageSize) || 10).fill(null)
        ].map(()=>Object.assign({}, ...$30615b8e57e39efe$var$getAllLeafColumnDefs(props.columns).map((col)=>({
                    [$30615b8e57e39efe$var$getColumnId(col)]: null
                })))) : props.data;
    }, [
        props.data,
        (_v = props.state) === null || _v === void 0 ? void 0 : _v.isLoading,
        (_w = props.state) === null || _w === void 0 ? void 0 : _w.showSkeletons
    ]);
    //@ts-ignore
    const table = Object.assign(Object.assign({}, (0, $eb7cf81af64cc0c8$export$25eaeb3743e6b31f)(Object.assign(Object.assign({
        getCoreRowModel: (0, $34de474a8ff218be$export$32d0bc001e828250)(),
        getExpandedRowModel: props.enableExpanding || props.enableGrouping ? (0, $34de474a8ff218be$export$53cfec7b1b8d1fcd)() : undefined,
        getFacetedMinMaxValues: props.enableFacetedValues ? (0, $34de474a8ff218be$export$d17dd32c9eab9fc7)() : undefined,
        getFacetedRowModel: props.enableFacetedValues ? (0, $34de474a8ff218be$export$3519aa0e35dc33b4)() : undefined,
        getFacetedUniqueValues: props.enableFacetedValues ? (0, $34de474a8ff218be$export$1fb5d0c1edc37de2)() : undefined,
        getFilteredRowModel: props.enableColumnFilters || props.enableGlobalFilter || props.enableFilters ? (0, $34de474a8ff218be$export$26f255a2756e1638)() : undefined,
        getGroupedRowModel: props.enableGrouping ? (0, $34de474a8ff218be$export$2b7f4b57ce71b81)() : undefined,
        getPaginationRowModel: props.enablePagination ? (0, $34de474a8ff218be$export$ddfd3662e196c265)() : undefined,
        getSortedRowModel: props.enableSorting ? (0, $34de474a8ff218be$export$4ca93ca80835d8c1)() : undefined,
        onColumnOrderChange: setColumnOrder,
        onGroupingChange: setGrouping,
        getSubRows: (row)=>row === null || row === void 0 ? void 0 : row.subRows
    }, props), {
        //@ts-ignore
        columns: columnDefs,
        data: data,
        globalFilterFn: (_y = (_x = props.filterFns) === null || _x === void 0 ? void 0 : _x[globalFilterFn]) !== null && _y !== void 0 ? _y : (_z = props.filterFns) === null || _z === void 0 ? void 0 : _z.fuzzy,
        initialState: initialState,
        state: Object.assign({
            columnFilterFns: columnFilterFns,
            columnOrder: columnOrder,
            density: density,
            draggingColumn: draggingColumn,
            draggingRow: draggingRow,
            editingCell: editingCell,
            editingRow: editingRow,
            globalFilterFn: globalFilterFn,
            grouping: grouping,
            hoveredColumn: hoveredColumn,
            hoveredRow: hoveredRow,
            isFullScreen: isFullScreen,
            showAlertBanner: showAlertBanner,
            showColumnFilters: showColumnFilters,
            showGlobalFilter: showGlobalFilter,
            showToolbarDropZone: showToolbarDropZone
        }, props.state)
    }))), {
        refs: {
            bottomToolbarRef: bottomToolbarRef,
            editInputRefs: editInputRefs,
            filterInputRefs: filterInputRefs,
            searchInputRef: searchInputRef,
            tableContainerRef: tableContainerRef,
            tableHeadCellRefs: tableHeadCellRefs,
            tablePaperRef: tablePaperRef,
            topToolbarRef: topToolbarRef
        },
        setColumnFilterFns: (_0 = props.onColumnFilterFnsChange) !== null && _0 !== void 0 ? _0 : setColumnFilterFns,
        setDensity: (_1 = props.onDensityChange) !== null && _1 !== void 0 ? _1 : setDensity,
        setDraggingColumn: (_2 = props.onDraggingColumnChange) !== null && _2 !== void 0 ? _2 : setDraggingColumn,
        setDraggingRow: (_3 = props.onDraggingRowChange) !== null && _3 !== void 0 ? _3 : setDraggingRow,
        setEditingCell: (_4 = props.onEditingCellChange) !== null && _4 !== void 0 ? _4 : setEditingCell,
        setEditingRow: (_5 = props.onEditingRowChange) !== null && _5 !== void 0 ? _5 : setEditingRow,
        setGlobalFilterFn: (_6 = props.onGlobalFilterFnChange) !== null && _6 !== void 0 ? _6 : setGlobalFilterFn,
        setHoveredColumn: (_7 = props.onHoveredColumnChange) !== null && _7 !== void 0 ? _7 : setHoveredColumn,
        setHoveredRow: (_8 = props.onHoveredRowChange) !== null && _8 !== void 0 ? _8 : setHoveredRow,
        setIsFullScreen: (_9 = props.onIsFullScreenChange) !== null && _9 !== void 0 ? _9 : setIsFullScreen,
        setShowAlertBanner: (_10 = props.onShowAlertBannerChange) !== null && _10 !== void 0 ? _10 : setShowAlertBanner,
        setShowColumnFilters: (_11 = props.onShowColumnFiltersChange) !== null && _11 !== void 0 ? _11 : setShowColumnFilters,
        setShowGlobalFilter: (_12 = props.onShowGlobalFilterChange) !== null && _12 !== void 0 ? _12 : setShowGlobalFilter,
        setShowToolbarDropZone: (_13 = props.onShowToolbarDropZoneChange) !== null && _13 !== void 0 ? _13 : setShowToolbarDropZone
    });
    if (props.tableFeatures) props.tableFeatures.forEach((feature)=>{
        Object.assign(table, feature(table));
    });
    if (props.tableInstanceRef) props.tableInstanceRef.current = table;
    const initialBodyHeight = (0, $i5lfL.useRef)();
    (0, $i5lfL.useEffect)(()=>{
        if (typeof window !== 'undefined') initialBodyHeight.current = document.body.style.height;
    }, []);
    (0, $i5lfL.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            if (table.getState().isFullScreen) document.body.style.height = '100vh';
            else document.body.style.height = initialBodyHeight.current;
        }
    }, [
        table.getState().isFullScreen
    ]);
    //if page index is out of bounds, set it to the last page
    (0, $i5lfL.useEffect)(()=>{
        var _a;
        const { pageIndex: pageIndex, pageSize: pageSize } = table.getState().pagination;
        const totalRowCount = (_a = props.rowCount) !== null && _a !== void 0 ? _a : table.getPrePaginationRowModel().rows.length;
        const firstVisibleRowIndex = pageIndex * pageSize;
        if (firstVisibleRowIndex > totalRowCount) table.setPageIndex(Math.floor(totalRowCount / pageSize));
    }, [
        props.rowCount,
        table.getPrePaginationRowModel().rows.length
    ]);
    return (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
        children: [
            (0, $bHJbJ.jsx)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039), {
                PaperComponent: (0, $af701d274f0d01b0$export$2e2bcd8739ae039),
                TransitionComponent: !props.enableRowVirtualization ? (0, $66de9c04029c8d70$export$2e2bcd8739ae039) : undefined,
                disablePortal: true,
                fullScreen: true,
                keepMounted: false,
                onClose: ()=>table.setIsFullScreen(false),
                open: table.getState().isFullScreen,
                transitionDuration: 400,
                children: (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TablePaper, {
                    table: table
                })
            }),
            !table.getState().isFullScreen && (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TablePaper, {
                table: table
            }),
            editingRow && props.editingMode === 'modal' && (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_EditRowModal, {
                row: editingRow,
                table: table,
                open: true
            })
        ]
    });
};
const $30615b8e57e39efe$export$2506d3bf41f97512 = (_a)=>{
    var _b;
    var { aggregationFns: aggregationFns, autoResetExpanded: autoResetExpanded = false, columnResizeMode: columnResizeMode = 'onChange', defaultColumn: defaultColumn, defaultDisplayColumn: defaultDisplayColumn, editingMode: editingMode = 'modal', enableBottomToolbar: enableBottomToolbar = true, enableColumnActions: enableColumnActions = true, enableColumnFilters: enableColumnFilters = true, enableColumnOrdering: enableColumnOrdering = false, enableColumnResizing: enableColumnResizing = false, enableDensityToggle: enableDensityToggle = true, enableExpandAll: enableExpandAll = true, enableExpanding: enableExpanding, enableFilterMatchHighlighting: enableFilterMatchHighlighting = true, enableFilters: enableFilters = true, enableFullScreenToggle: enableFullScreenToggle = true, enableGlobalFilter: enableGlobalFilter = true, enableGlobalFilterRankedResults: enableGlobalFilterRankedResults = true, enableGrouping: enableGrouping = false, enableHiding: enableHiding = true, enableMultiRowSelection: enableMultiRowSelection = true, enableMultiSort: enableMultiSort = true, enablePagination: enablePagination = true, enablePinning: enablePinning = false, enableRowSelection: enableRowSelection = false, enableSelectAll: enableSelectAll = true, enableSorting: enableSorting = true, enableStickyHeader: enableStickyHeader = false, enableTableFooter: enableTableFooter = true, enableTableHead: enableTableHead = true, enableToolbarInternalActions: enableToolbarInternalActions = true, enableTopToolbar: enableTopToolbar = true, filterFns: filterFns, icons: icons, layoutMode: layoutMode = 'semantic', localization: localization, manualFiltering: manualFiltering, manualGrouping: manualGrouping, manualPagination: manualPagination, manualSorting: manualSorting, positionActionsColumn: positionActionsColumn = 'first', positionExpandColumn: positionExpandColumn = 'first', positionGlobalFilter: positionGlobalFilter = 'right', positionPagination: positionPagination = 'bottom', positionToolbarAlertBanner: positionToolbarAlertBanner = 'top', positionToolbarDropZone: positionToolbarDropZone = 'top', rowNumberMode: rowNumberMode = 'original', selectAllMode: selectAllMode = 'page', sortingFns: sortingFns } = _a, rest = $30615b8e57e39efe$var$__rest(_a, [
        "aggregationFns",
        "autoResetExpanded",
        "columnResizeMode",
        "defaultColumn",
        "defaultDisplayColumn",
        "editingMode",
        "enableBottomToolbar",
        "enableColumnActions",
        "enableColumnFilters",
        "enableColumnOrdering",
        "enableColumnResizing",
        "enableDensityToggle",
        "enableExpandAll",
        "enableExpanding",
        "enableFilterMatchHighlighting",
        "enableFilters",
        "enableFullScreenToggle",
        "enableGlobalFilter",
        "enableGlobalFilterRankedResults",
        "enableGrouping",
        "enableHiding",
        "enableMultiRowSelection",
        "enableMultiSort",
        "enablePagination",
        "enablePinning",
        "enableRowSelection",
        "enableSelectAll",
        "enableSorting",
        "enableStickyHeader",
        "enableTableFooter",
        "enableTableHead",
        "enableToolbarInternalActions",
        "enableTopToolbar",
        "filterFns",
        "icons",
        "layoutMode",
        "localization",
        "manualFiltering",
        "manualGrouping",
        "manualPagination",
        "manualSorting",
        "positionActionsColumn",
        "positionExpandColumn",
        "positionGlobalFilter",
        "positionPagination",
        "positionToolbarAlertBanner",
        "positionToolbarDropZone",
        "rowNumberMode",
        "selectAllMode",
        "sortingFns"
    ]);
    const _icons = (0, $i5lfL.useMemo)(()=>Object.assign(Object.assign({}, $30615b8e57e39efe$var$MRT_Default_Icons), icons), [
        icons
    ]);
    const _localization = (0, $i5lfL.useMemo)(()=>Object.assign(Object.assign({}, $30615b8e57e39efe$var$MRT_Localization_EN), localization), [
        localization
    ]);
    const _aggregationFns = (0, $i5lfL.useMemo)(()=>Object.assign(Object.assign({}, $30615b8e57e39efe$export$b560094588c4318), aggregationFns), []);
    const _filterFns = (0, $i5lfL.useMemo)(()=>Object.assign(Object.assign({}, $30615b8e57e39efe$export$81754f428e3b4fc7), filterFns), []);
    const _sortingFns = (0, $i5lfL.useMemo)(()=>Object.assign(Object.assign({}, $30615b8e57e39efe$export$cfca3685708ab5fc), sortingFns), []);
    const _defaultColumn = (0, $i5lfL.useMemo)(()=>Object.assign(Object.assign({}, $30615b8e57e39efe$var$MRT_DefaultColumn), defaultColumn), [
        defaultColumn
    ]);
    const _defaultDisplayColumn = (0, $i5lfL.useMemo)(()=>Object.assign(Object.assign({}, $30615b8e57e39efe$var$MRT_DefaultDisplayColumn), defaultDisplayColumn), [
        defaultDisplayColumn
    ]);
    if (rest.enableRowVirtualization || rest.enableColumnVirtualization) layoutMode = 'grid';
    if (rest.enableRowVirtualization) enableStickyHeader = true;
    if (enablePagination === false && manualPagination === undefined) manualPagination = true;
    if (!((_b = rest.data) === null || _b === void 0 ? void 0 : _b.length)) {
        manualFiltering = true;
        manualGrouping = true;
        manualPagination = true;
        manualSorting = true;
    }
    return (0, $bHJbJ.jsx)($30615b8e57e39efe$var$MRT_TableRoot, Object.assign({
        aggregationFns: _aggregationFns,
        autoResetExpanded: autoResetExpanded,
        columnResizeMode: columnResizeMode,
        defaultColumn: _defaultColumn,
        defaultDisplayColumn: _defaultDisplayColumn,
        editingMode: editingMode,
        enableBottomToolbar: enableBottomToolbar,
        enableColumnActions: enableColumnActions,
        enableColumnFilters: enableColumnFilters,
        enableColumnOrdering: enableColumnOrdering,
        enableColumnResizing: enableColumnResizing,
        enableDensityToggle: enableDensityToggle,
        enableExpandAll: enableExpandAll,
        enableExpanding: enableExpanding,
        enableFilterMatchHighlighting: enableFilterMatchHighlighting,
        enableFilters: enableFilters,
        enableFullScreenToggle: enableFullScreenToggle,
        enableGlobalFilter: enableGlobalFilter,
        enableGlobalFilterRankedResults: enableGlobalFilterRankedResults,
        enableGrouping: enableGrouping,
        enableHiding: enableHiding,
        enableMultiRowSelection: enableMultiRowSelection,
        enableMultiSort: enableMultiSort,
        enablePagination: enablePagination,
        enablePinning: enablePinning,
        enableRowSelection: enableRowSelection,
        enableSelectAll: enableSelectAll,
        enableSorting: enableSorting,
        enableStickyHeader: enableStickyHeader,
        enableTableFooter: enableTableFooter,
        enableTableHead: enableTableHead,
        enableToolbarInternalActions: enableToolbarInternalActions,
        enableTopToolbar: enableTopToolbar,
        filterFns: _filterFns,
        icons: _icons,
        layoutMode: layoutMode,
        localization: _localization,
        manualFiltering: manualFiltering,
        manualGrouping: manualGrouping,
        manualPagination: manualPagination,
        manualSorting: manualSorting,
        positionActionsColumn: positionActionsColumn,
        positionExpandColumn: positionExpandColumn,
        positionGlobalFilter: positionGlobalFilter,
        positionPagination: positionPagination,
        positionToolbarAlertBanner: positionToolbarAlertBanner,
        positionToolbarDropZone: positionToolbarDropZone,
        rowNumberMode: rowNumberMode,
        selectAllMode: selectAllMode,
        sortingFns: _sortingFns
    }, rest));
};



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $ca21ad05de6e5b6e$export$d72d4cbdc30b331f(slot) {
    return (0, $6bbZp.default)('MuiFormGroup', slot);
}
const $ca21ad05de6e5b6e$var$formGroupClasses = (0, $47i1c.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $ca21ad05de6e5b6e$export$2e2bcd8739ae039 = $ca21ad05de6e5b6e$var$formGroupClasses;





var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $0f9e95a89ff695aa$var$_excluded = [
    "className",
    "row"
];
const $0f9e95a89ff695aa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $ca21ad05de6e5b6e$export$d72d4cbdc30b331f), classes);
};
const $0f9e95a89ff695aa$var$FormGroupRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap'
    }, ownerState.row && {
        flexDirection: 'row'
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $0f9e95a89ff695aa$var$FormGroup = /*#__PURE__*/ $i5lfL.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false } = props, other = (0, $7qXFD.default)(props, $0f9e95a89ff695aa$var$_excluded);
    const muiFormControl = (0, $01f467cf0a9ed9ad$export$2e2bcd8739ae039)();
    const fcs = (0, $0c562896955434b6$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $1CWiu.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $0f9e95a89ff695aa$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($0f9e95a89ff695aa$var$FormGroupRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $0f9e95a89ff695aa$export$2e2bcd8739ae039 = $0f9e95a89ff695aa$var$FormGroup;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $b57dc1956899020f$export$c4cff3a43f7cabb6(slot) {
    return (0, $6bbZp.default)('MuiRadioGroup', slot);
}
const $b57dc1956899020f$var$radioGroupClasses = (0, $47i1c.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $b57dc1956899020f$export$2e2bcd8739ae039 = $b57dc1956899020f$var$radioGroupClasses;







var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $dab743c5571d374a$var$_excluded = [
    "actions",
    "children",
    "className",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $dab743c5571d374a$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $b57dc1956899020f$export$c4cff3a43f7cabb6), classes);
};
const $dab743c5571d374a$var$RadioGroup = /*#__PURE__*/ $i5lfL.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $7qXFD.default)(props, $dab743c5571d374a$var$_excluded);
    const rootRef = $i5lfL.useRef(null);
    const classes = $dab743c5571d374a$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $84df25be484a0877$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $i5lfL.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(ref, rootRef);
    const name = (0, $f1c50420bced90af$export$2e2bcd8739ae039)(nameProp);
    const contextValue = $i5lfL.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $4ddb04741c6e7346$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $0f9e95a89ff695aa$export$2e2bcd8739ae039), (0, $1CWiu.default)({
            role: "radiogroup",
            ref: handleRef,
            className: (0, $kRbLW.default)(classes.root, className)
        }, other, {
            children: children
        }))
    });
});
var $dab743c5571d374a$export$2e2bcd8739ae039 = $dab743c5571d374a$var$RadioGroup;


var $1de6233d4497eab4$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($1de6233d4497eab4$exports, "__esModule", {
    value: true
});
$1de6233d4497eab4$exports.default = void 0;

var $1de6233d4497eab4$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $1de6233d4497eab4$var$_default = $1de6233d4497eab4$exports.default = (0, $1de6233d4497eab4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteOutlineOutlined');


var $f3840938b52fc195$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($f3840938b52fc195$exports, "__esModule", {
    value: true
});
$f3840938b52fc195$exports.default = void 0;

var $f3840938b52fc195$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $f3840938b52fc195$var$_default = $f3840938b52fc195$exports.default = (0, $f3840938b52fc195$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');







// noinspection GraphQLUnresolvedReference

const $3d952ec70ff3acd2$export$58d4da7c184a9942 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetScenarioList($inOwner: String!, $inUserSID: UUID!) {
        executeGetScenarioList(inOwner: $inOwner, inUserSID: $inUserSID) {
            ScenarioID
            ScenarioOwner
            ScenarioTitle
            BaseLineID
            PrivateFlag
            DateCreated
            ScenarioDescription
            Jurisdiction
            ScenarioEditable
        }
    }
`;
const $3d952ec70ff3acd2$export$726212a28c977994 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteCreateScenario($owner: String!, $title: String!, $desc: String!, $juri: String!, $inUserSID: UUID! ) {
        executeCreateScenario(
            inScenarioOwner: $owner
            inScenarioTitle: $title
            inScenarioDescription: $desc
            inJurisdiction: $juri
            inUserSID: $inUserSID
        ) {
            ScenarioID
        }
    }
`;
const $3d952ec70ff3acd2$export$25ca06144a45ac53 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteCreateScenario($base: String!, $title: String!, $desc: String!) {
        executeCreateBaseOnScenario(
            inScenarioID: $base
            inNewScenarioTitle: $title
            inNewScenarioDescription: $desc
        ) {
            ScenarioID
        }
    }
`;
const $3d952ec70ff3acd2$export$d0eccde1378805f6 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteDeleteScenario($inScenarioID: UUID!) {
        executeDeleteScenario(inScenarioID: $inScenarioID) {
            result
        }
    }
`;
const $3d952ec70ff3acd2$export$76260284c78e0f4d = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteUploadScenarioProjects(
       $inScenarioID: UUID!
       $inProjectJSON: String!
    ) {
        executeUploadScenarioProjects(
          inScenarioID: $inScenarioID
          inProjectJSON: $inProjectJSON
        ) {
            result
        }
    }
`;



function $1405e9d2372e4666$export$2e2bcd8739ae039(props) {
    const [baseScenario, setBaseScenario] = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).useState("1");
    const [scenarioName, setScenarioName] = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).useState("");
    const [scenarioDesc, setScenarioDesc] = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).useState("");
    const [creationMode, setCreationMode] = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).useState((0, $243a1246ea7835d9$export$46c5b3cb582b4b18).New);
    const { setTabIndex: setTabIndex, setScenarioID: setScenarioID } = props;
    const tableInstanceRef = (0, $i5lfL.useRef)(null);
    const client = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)();
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const { data: userInfo } = (0, $8aac0537827a6bae$export$801fe16824f675f7)();
    console.log("userInfo", userInfo);
    const [rowSelection, setRowSelection] = (0, $i5lfL.useState)({});
    const { data: data, isLoading: isLoading, isFetching: isFetching } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "scenarioList"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $3d952ec70ff3acd2$export$58d4da7c184a9942),
                variables: {
                    inOwner: accounts[0].username
                },
                instance: instance,
                accounts: accounts
            });
        },
        cacheTime: Infinity
    });
    const { mutate: createScenario } = (0, $d5a0a75b5a6b57e1$export$609860bf8b0084c)([
        "createScenario"
    ], {
        mutationFn: (variables)=>{
            if (variables["base"] == "1") return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $3d952ec70ff3acd2$export$726212a28c977994),
                variables: variables,
                instance: instance,
                accounts: accounts
            });
            else return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $3d952ec70ff3acd2$export$25ca06144a45ac53),
                variables: variables,
                instance: instance,
                accounts: accounts
            });
        },
        onSuccess: (data)=>{
            client.invalidateQueries([
                "scenarioList"
            ]);
            // @ts-ignore
            setScenarioID(data.executeCreateScenario ? // @ts-ignore
            data.executeCreateScenario[0].ScenarioID : // @ts-ignore
            data.executeCreateBaseOnScenario[0].ScenarioID);
            client.invalidateQueries([
                "projectList"
            ]);
            setTabIndex(1);
        }
    });
    const deleteScenario = (0, $d5a0a75b5a6b57e1$export$609860bf8b0084c)({
        mutationFn: (inScenarioID)=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $3d952ec70ff3acd2$export$d0eccde1378805f6),
                variables: {
                    inScenarioID: inScenarioID
                },
                instance: instance,
                accounts: accounts
            });
        },
        onSuccess: ()=>{
            client.invalidateQueries([
                "scenarioList"
            ]);
        }
    });
    const handleBaseModelChange = (event)=>{
        setBaseScenario(event.target.value);
    };
    const handleCreationModeChange = (event)=>{
        // @ts-ignore
        setCreationMode(event.target.value);
    };
    const handleDeleteRow = (0, $i5lfL.useCallback)((row)=>{
        if (!confirm(`Are you sure you want to delete ${row.getValue("ScenarioTitle")}`)) return;
        //send api delete request here, then refetch or update local table data for re-render
        deleteScenario.mutate(row.getValue("ScenarioID"));
    }, [
        deleteScenario
    ]);
    const handleSubmit = (event)=>{
        event.preventDefault();
        // @ts-ignore
        if (!data?.executeGetScenarioList?.map((item)=>item.ScenarioTitle).includes(scenarioName)) createScenario({
            owner: accounts[0].username,
            title: scenarioName,
            desc: scenarioDesc,
            base: baseScenario,
            // @ts-ignore
            juri: userInfo?.executeGetUser[0]?.Jurisdiction ?? ""
        });
        else alert("Scenario Name need to be unique");
    };
    const columns = (0, $i5lfL.useMemo)(()=>[
            {
                accessorKey: "ScenarioID",
                header: "Scenario ID"
            },
            {
                accessorKey: "ScenarioTitle",
                header: "Scenario name",
                minSize: 500,
                maxSize: 600
            },
            {
                accessorFn: (row)=>new Date(row.DateCreated),
                header: "Creation Date",
                Cell: ({ cell: cell })=>cell.getValue()?.toLocaleDateString(),
                maxSize: 50
            },
            {
                accessorKey: "ScenarioDescription",
                header: "Description"
            }
        ], []);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        sx: {
            zIndex: "1000",
            position: "relative"
        },
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)("form", {
            onSubmit: handleSubmit,
            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                container: true,
                justifyContent: "space-between",
                sx: {
                    height: "100%"
                },
                className: "CreateScenarioGrid",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 3,
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                backgroundColor: "#E0E7EC",
                                p: 2
                            },
                            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                container: true,
                                spacing: 2,
                                direction: "column",
                                justifyContent: "space-around",
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 2,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                            variant: "h3",
                                            children: "Create a scenario"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 2,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3b3376bc3ccaa047$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $dab743c5571d374a$export$2e2bcd8739ae039), {
                                                row: true,
                                                defaultValue: "new",
                                                name: "radio-buttons-group",
                                                onChange: handleCreationModeChange,
                                                children: [
                                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3da2083f6f3ac88d$export$2e2bcd8739ae039), {
                                                        value: (0, $243a1246ea7835d9$export$46c5b3cb582b4b18).New,
                                                        control: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $74fd16a7f0f411f6$export$2e2bcd8739ae039), {}),
                                                        label: "New"
                                                    }),
                                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3da2083f6f3ac88d$export$2e2bcd8739ae039), {
                                                        value: (0, $243a1246ea7835d9$export$46c5b3cb582b4b18).Saved,
                                                        control: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $74fd16a7f0f411f6$export$2e2bcd8739ae039), {}),
                                                        label: "Based on a saved scenario"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 2,
                                        children: creationMode == (0, $243a1246ea7835d9$export$46c5b3cb582b4b18).Saved && /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            value: baseScenario,
                                            onChange: handleBaseModelChange,
                                            label: "Choose saved scenario",
                                            sx: {
                                                width: "100%",
                                                backgroundColor: "#ffffff"
                                            },
                                            select: true,
                                            required: true,
                                            helperText: "Scenario In Current Baseline",
                                            children: [
                                                // @ts-ignore
                                                data?.executeGetScenarioList?.filter((i)=>i.ScenarioEditable > 0).map((item)=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                        value: item.ScenarioID,
                                                        children: item.ScenarioTitle
                                                    }, item.ScenarioID)),
                                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                    value: 1,
                                                    children: "Baseline Plan"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 2,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: "100%",
                                                backgroundColor: "#ffffff"
                                            },
                                            error: scenarioName.length >= 40,
                                            helperText: scenarioName.length >= 40 ? "Scenario names should be 40 characters or less" : "",
                                            label: "Name your new scenario",
                                            value: scenarioName,
                                            onChange: (event)=>setScenarioName(event.target.value),
                                            inputProps: {
                                                maxLength: 40
                                            },
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 2,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            sx: {
                                                width: "100%",
                                                backgroundColor: "#ffffff"
                                            },
                                            multiline: true,
                                            value: scenarioDesc,
                                            rows: 5,
                                            placeholder: (0, $d29d6d1034e01aa1$export$33d7376ee10414e3),
                                            onChange: (event)=>setScenarioDesc(event.target.value)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 2,
                                        sx: {
                                            display: "flex",
                                            justifyContent: "flex-end"
                                        },
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                            variant: "contained",
                                            type: "submit",
                                            children: "Create"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 9,
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                p: 2,
                                backgroundColor: "#E0E7EC",
                                height: "1"
                            },
                            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                container: true,
                                spacing: 2,
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 1,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                            variant: "h3",
                                            children: "Saved scenarios"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 10,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30615b8e57e39efe$export$2506d3bf41f97512), {
                                            columns: columns,
                                            data: // @ts-ignore
                                            data?.executeGetScenarioList ?? [],
                                            enableMultiRowSelection: false,
                                            enableRowSelection: true,
                                            onRowSelectionChange: setRowSelection,
                                            enableRowActions: true,
                                            muiTableContainerProps: {
                                                sx: {
                                                    maxHeight: "40vh"
                                                }
                                            },
                                            positionActionsColumn: "last",
                                            renderRowActions: ({ row: row })=>/*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        display: "flex",
                                                        gap: "1rem"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                                                            arrow: true,
                                                            title: row.original.ScenarioDescription,
                                                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f3840938b52fc195$exports))), {})
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                                                            arrow: true,
                                                            placement: "right",
                                                            title: "Delete",
                                                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                                                                color: "error",
                                                                onClick: ()=>handleDeleteRow(row),
                                                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1de6233d4497eab4$exports))), {})
                                                            })
                                                        })
                                                    ]
                                                }),
                                            displayColumnDefOptions: {
                                                "mrt-row-actions": {
                                                    size: 5
                                                }
                                            },
                                            enableColumnFilters: false,
                                            enablePagination: false,
                                            enableBottomToolbar: false,
                                            enableTopToolbar: false,
                                            enableTableHead: false,
                                            initialState: {
                                                density: "compact",
                                                columnVisibility: {
                                                    ScenarioID: false,
                                                    ScenarioDescription: false
                                                }
                                            },
                                            state: {
                                                isLoading: isLoading,
                                                showProgressBars: isFetching,
                                                rowSelection: rowSelection
                                            },
                                            tableInstanceRef: tableInstanceRef
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 1,
                                        sx: {
                                            display: "flex",
                                            justifyContent: "flex-end"
                                        },
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                            variant: "contained",
                                            onClick: ()=>{
                                                setTabIndex(1);
                                                // @ts-ignore
                                                setScenarioID(tableInstanceRef?.current?.getSelectedRowModel().flatRows[0].original.ScenarioID);
                                            },
                                            disabled: Object.keys(rowSelection).length === 0,
                                            children: "Open"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}



var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $dR0I7 = parcelRequire("dR0I7");

var $2ktY3 = parcelRequire("2ktY3");



var $VEXgj = parcelRequire("VEXgj");

var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $b1fa1d2af17fef28$export$21f89b560b65a301(slot) {
    return (0, $6bbZp.default)('MuiToggleButton', slot);
}
const $b1fa1d2af17fef28$var$toggleButtonClasses = (0, $47i1c.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $b1fa1d2af17fef28$export$2e2bcd8739ae039 = $b1fa1d2af17fef28$var$toggleButtonClasses;



var $i5lfL = parcelRequire("i5lfL");
/**
 * @ignore - internal component.
 */ const $87808ffcf22768ba$var$ToggleButtonGroupContext = /*#__PURE__*/ $i5lfL.createContext({});
var $87808ffcf22768ba$export$2e2bcd8739ae039 = $87808ffcf22768ba$var$ToggleButtonGroupContext;



var $i5lfL = parcelRequire("i5lfL");
/**
 * @ignore - internal component.
 */ const $45e06139ebe0b0d9$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $i5lfL.createContext(undefined);
var $45e06139ebe0b0d9$export$2e2bcd8739ae039 = $45e06139ebe0b0d9$var$ToggleButtonGroupButtonContext;


// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $c7395d41a85832e6$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.indexOf(value) >= 0;
    return value === candidate;
}



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $4956857b2b444fde$var$_excluded = [
    "value"
], $4956857b2b444fde$var$_excluded2 = [
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "onChange",
    "onClick",
    "selected",
    "size",
    "value"
];
const $4956857b2b444fde$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $VEXgj.default)(size)}`,
            color
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $b1fa1d2af17fef28$export$21f89b560b65a301), classes);
};
const $4956857b2b444fde$var$ToggleButtonRoot = (0, $j7y1Z.default)((0, $07a3ed667acb77f6$export$2e2bcd8739ae039), {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $VEXgj.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    let selectedColor = ownerState.color === 'standard' ? theme.palette.text.primary : theme.palette[ownerState.color].main;
    let selectedColorChannel;
    if (theme.vars) {
        selectedColor = ownerState.color === 'standard' ? theme.vars.palette.text.primary : theme.vars.palette[ownerState.color].main;
        selectedColorChannel = ownerState.color === 'standard' ? theme.vars.palette.text.primaryChannel : theme.vars.palette[ownerState.color].mainChannel;
    }
    return (0, $1CWiu.default)({}, theme.typography.button, {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`&.${(0, $b1fa1d2af17fef28$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $b1fa1d2af17fef28$export$2e2bcd8739ae039).selected}`]: {
            color: selectedColor,
            backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(selectedColor, theme.palette.action.selectedOpacity)
                }
            }
        }
    }, ownerState.size === 'small' && {
        padding: 7,
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && {
        padding: 15,
        fontSize: theme.typography.pxToRem(15)
    });
});
const $4956857b2b444fde$var$ToggleButton = /*#__PURE__*/ $i5lfL.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const _React$useContext = $i5lfL.useContext((0, $87808ffcf22768ba$export$2e2bcd8739ae039)), { value: contextValue } = _React$useContext, contextProps = (0, $7qXFD.default)(_React$useContext, $4956857b2b444fde$var$_excluded);
    const toggleButtonGroupButtonContextPositionClassName = $i5lfL.useContext((0, $45e06139ebe0b0d9$export$2e2bcd8739ae039));
    const resolvedProps = (0, $dR0I7.default)((0, $1CWiu.default)({}, contextProps, {
        selected: (0, $c7395d41a85832e6$export$2e2bcd8739ae039)(inProps.value, contextValue)
    }), inProps);
    const props = (0, $kp44S.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value } = props, other = (0, $7qXFD.default)(props, $4956857b2b444fde$var$_excluded2);
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    });
    const classes = $4956857b2b444fde$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($4956857b2b444fde$var$ToggleButtonRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected
    }, other, {
        children: children
    }));
});
var $4956857b2b444fde$export$2e2bcd8739ae039 = $4956857b2b444fde$var$ToggleButton;


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");
parcelRequire("67Wr0");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $i5lfL = parcelRequire("i5lfL");
function $ef4db73905d4f229$export$2e2bcd8739ae039(children) {
    return $i5lfL.Children.toArray(children).filter((child)=>/*#__PURE__*/ $i5lfL.isValidElement(child));
}



var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $VEXgj = parcelRequire("VEXgj");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $6ca8aca627575b7e$export$44aa3ae5b353cef1(slot) {
    return (0, $6bbZp.default)('MuiToggleButtonGroup', slot);
}
const $6ca8aca627575b7e$var$toggleButtonGroupClasses = (0, $47i1c.default)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'horizontal',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var $6ca8aca627575b7e$export$2e2bcd8739ae039 = $6ca8aca627575b7e$var$toggleButtonGroupClasses;






var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $5a88d895317a42d5$var$_excluded = [
    "children",
    "className",
    "color",
    "disabled",
    "exclusive",
    "fullWidth",
    "onChange",
    "orientation",
    "size",
    "value"
];
const $5a88d895317a42d5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation === 'vertical' && 'vertical',
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $VEXgj.default)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $6ca8aca627575b7e$export$44aa3ae5b353cef1), classes);
};
const $5a88d895317a42d5$var$ToggleButtonGroupRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $VEXgj.default)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $1CWiu.default)({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).grouped}`]: (0, $1CWiu.default)({}, ownerState.orientation === 'horizontal' ? {
            [`&.${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).selected} + .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).grouped}.${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).selected}`]: {
                borderLeft: 0,
                marginLeft: 0
            }
        } : {
            [`&.${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).selected} + .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).grouped}.${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).selected}`]: {
                borderTop: 0,
                marginTop: 0
            }
        })
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).firstButton},& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).middleButton}`]: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).lastButton},& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).middleButton}`]: {
            marginLeft: -1,
            borderLeft: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }
    } : {
        [`& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).firstButton},& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).middleButton}`]: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).lastButton},& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).middleButton}`]: {
            marginTop: -1,
            borderTop: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).lastButton}.${(0, $b1fa1d2af17fef28$export$2e2bcd8739ae039).disabled},& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).middleButton}.${(0, $b1fa1d2af17fef28$export$2e2bcd8739ae039).disabled}`]: {
            borderLeft: '1px solid transparent'
        }
    } : {
        [`& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).lastButton}.${(0, $b1fa1d2af17fef28$export$2e2bcd8739ae039).disabled},& .${(0, $6ca8aca627575b7e$export$2e2bcd8739ae039).middleButton}.${(0, $b1fa1d2af17fef28$export$2e2bcd8739ae039).disabled}`]: {
            borderTop: '1px solid transparent'
        }
    }));
const $5a88d895317a42d5$var$ToggleButtonGroup = /*#__PURE__*/ $i5lfL.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = 'horizontal', size: size = 'medium', value: value } = props, other = (0, $7qXFD.default)(props, $5a88d895317a42d5$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    });
    const classes = $5a88d895317a42d5$var$useUtilityClasses(ownerState);
    const handleChange = $i5lfL.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $i5lfL.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $i5lfL.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $ef4db73905d4f229$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($5a88d895317a42d5$var$ToggleButtonGroupRoot, (0, $1CWiu.default)({
        role: "group",
        className: (0, $kRbLW.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $87808ffcf22768ba$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $45e06139ebe0b0d9$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $5a88d895317a42d5$export$2e2bcd8739ae039 = $5a88d895317a42d5$var$ToggleButtonGroup;


var $78e40c7d7e50d5ff$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($78e40c7d7e50d5ff$exports, "__esModule", {
    value: true
});
$78e40c7d7e50d5ff$exports.default = void 0;

var $78e40c7d7e50d5ff$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $78e40c7d7e50d5ff$var$_default = $78e40c7d7e50d5ff$exports.default = (0, $78e40c7d7e50d5ff$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
}), 'FileUpload');



var $ca6909be4938645f$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($ca6909be4938645f$exports, "__esModule", {
    value: true
});
$ca6909be4938645f$exports.default = void 0;

var $ca6909be4938645f$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $ca6909be4938645f$var$_default = $ca6909be4938645f$exports.default = (0, $ca6909be4938645f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zm3.17-6.41a.9959.9959 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L12 12.59l1.41-1.41c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41L13.41 14l1.41 1.41c.39.39.39 1.02 0 1.41s-1.02.39-1.41 0L12 15.41l-1.41 1.41c-.39.39-1.02.39-1.41 0a.9959.9959 0 0 1 0-1.41L10.59 14zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1"
}), 'DeleteForeverRounded');


var $c3532d91f35b9323$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($c3532d91f35b9323$exports, "__esModule", {
    value: true
});
$c3532d91f35b9323$exports.default = void 0;

var $c3532d91f35b9323$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $c3532d91f35b9323$var$_default = $c3532d91f35b9323$exports.default = (0, $c3532d91f35b9323$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M12 5V2.21c0-.45-.54-.67-.85-.35l-3.8 3.79c-.2.2-.2.51 0 .71l3.79 3.79c.32.31.86.09.86-.36V7c3.73 0 6.68 3.42 5.86 7.29-.47 2.27-2.31 4.1-4.57 4.57-3.57.75-6.75-1.7-7.23-5.01-.07-.48-.49-.85-.98-.85-.6 0-1.08.53-1 1.13.62 4.39 4.8 7.64 9.53 6.72 3.12-.61 5.63-3.12 6.24-6.24C20.84 9.48 16.94 5 12 5"
}), 'ReplayRounded');


var $f7454d0d2ff8e9f6$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($f7454d0d2ff8e9f6$exports, "__esModule", {
    value: true
});
$f7454d0d2ff8e9f6$exports.default = void 0;

var $f7454d0d2ff8e9f6$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $f7454d0d2ff8e9f6$var$_default = $f7454d0d2ff8e9f6$exports.default = (0, $f7454d0d2ff8e9f6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');


var $f156b218576f4e73$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($f156b218576f4e73$exports, "__esModule", {
    value: true
});
$f156b218576f4e73$exports.default = void 0;

var $f156b218576f4e73$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $f156b218576f4e73$var$_default = $f156b218576f4e73$exports.default = (0, $f156b218576f4e73$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');





var $188d7627f9b29063$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($188d7627f9b29063$exports, "__esModule", {
    value: true
});
$188d7627f9b29063$exports.default = void 0;

var $188d7627f9b29063$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $188d7627f9b29063$var$_default = $188d7627f9b29063$exports.default = (0, $188d7627f9b29063$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');



var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");



var $1CWiu = parcelRequire("1CWiu");

var $8d9ddcc2276db3d6$exports = {};
!function(e, t) {
    $8d9ddcc2276db3d6$exports = t();
}($8d9ddcc2276db3d6$exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});



var $kx1Sf = parcelRequire("kx1Sf");
var $a036f20b7ab42e01$exports = {};
!function(e, t) {
    $a036f20b7ab42e01$exports = t();
}($a036f20b7ab42e01$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});


var $3a1a44d977ff00cf$exports = {};
!function(e, i) {
    $3a1a44d977ff00cf$exports = i();
}($3a1a44d977ff00cf$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


const $2ae5630d39e1af29$export$be61413ca3629f52 = (message)=>{
    let alreadyWarned = false;
    var deprecatedProps;
    return ()=>{};
};
const $2ae5630d39e1af29$export$baf331755d84b871 = (message, gravity = 'warning')=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if (gravity === 'error') console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};


(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($kx1Sf))));
(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($a036f20b7ab42e01$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($3a1a44d977ff00cf$exports))));
const $4ed4d5da8fc9d26b$var$localeNotFoundWarning = (0, $2ae5630d39e1af29$export$baf331755d84b871)([
    'Your locale has not been found.',
    'Either the locale key is not a supported one. Locales supported by dayjs are available here: https://github.com/iamkun/dayjs/tree/dev/src/locale',
    "Or you forget to import the locale with `require('dayjs/locale/{localeUsed}')`",
    'fallback on English locale'
]);
const $4ed4d5da8fc9d26b$var$formatTokenMap = {
    // Year
    YY: 'year',
    YYYY: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    D: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    DD: 'day',
    Do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    d: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 2
    },
    dd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    dddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    A: 'meridiem',
    a: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const $4ed4d5da8fc9d26b$var$defaultFormats = {
    year: 'YYYY',
    month: 'MMMM',
    monthShort: 'MMM',
    dayOfMonth: 'D',
    weekday: 'dddd',
    weekdayShort: 'ddd',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'A',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'll',
    fullDateWithWeekday: 'dddd, LL',
    keyboardDate: 'L',
    shortDate: 'MMM D',
    normalDate: 'D MMMM',
    normalDateWithWeekday: 'ddd, MMM D',
    monthAndYear: 'MMMM YYYY',
    monthAndDate: 'MMMM D',
    fullTime: 'LT',
    fullTime12h: 'hh:mm A',
    fullTime24h: 'HH:mm',
    fullDateTime: 'lll',
    fullDateTime12h: 'll hh:mm A',
    fullDateTime24h: 'll HH:mm',
    keyboardDateTime: 'L LT',
    keyboardDateTime12h: 'L hh:mm A',
    keyboardDateTime24h: 'L HH:mm'
};
const $4ed4d5da8fc9d26b$var$MISSING_UTC_PLUGIN = [
    'Missing UTC plugin',
    'To be able to use UTC or timezones, you have to enable the `utc` plugin',
    'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc'
].join('\n');
const $4ed4d5da8fc9d26b$var$MISSING_TIMEZONE_PLUGIN = [
    'Missing timezone plugin',
    'To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin',
    'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone'
].join('\n');
const $4ed4d5da8fc9d26b$var$withLocale = (dayjs, locale)=>!locale ? dayjs : (...args)=>dayjs(...args).locale(locale);
class $4ed4d5da8fc9d26b$export$33545c6a80bae043 {
    constructor({ locale: _locale, formats: formats, instance: instance } = {}){
        var _this$rawDayJsInstanc;
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = true;
        this.lib = 'dayjs';
        this.rawDayJsInstance = void 0;
        this.dayjs = void 0;
        this.locale = void 0;
        this.formats = void 0;
        this.escapedCharacters = {
            start: '[',
            end: ']'
        };
        this.formatTokenMap = $4ed4d5da8fc9d26b$var$formatTokenMap;
        this.setLocaleToValue = (value)=>{
            const expectedLocale = this.getCurrentLocaleCode();
            if (expectedLocale === value.locale()) return value;
            return value.locale(expectedLocale);
        };
        this.hasUTCPlugin = ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).utc !== 'undefined';
        this.hasTimezonePlugin = ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).tz !== 'undefined';
        this.isSame = (value, comparing, comparisonTemplate)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.format(comparisonTemplate) === comparingInValueTimezone.format(comparisonTemplate);
        };
        /**
     * Replace "default" by undefined before passing it to `dayjs
     */ this.cleanTimezone = (timezone)=>timezone === 'default' ? undefined : timezone;
        this.createSystemDate = (value)=>{
            // TODO v7: Stop using `this.rawDayJsInstance` (drop the `instance` param on the adapters)
            /* istanbul ignore next */ if (this.rawDayJsInstance) return this.rawDayJsInstance(value);
            if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
                const timezone = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).tz.guess();
                // We can't change the system timezone in the tests
                /* istanbul ignore next */ if (timezone !== 'UTC') return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).tz(value, timezone);
                return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(value);
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(value);
        };
        this.createUTCDate = (value)=>{
            /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($4ed4d5da8fc9d26b$var$MISSING_UTC_PLUGIN);
            return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).utc(value);
        };
        this.createTZDate = (value, timezone)=>{
            /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($4ed4d5da8fc9d26b$var$MISSING_UTC_PLUGIN);
            /* istanbul ignore next */ if (!this.hasTimezonePlugin()) throw new Error($4ed4d5da8fc9d26b$var$MISSING_TIMEZONE_PLUGIN);
            const keepLocalTime = value !== undefined && !value.endsWith('Z');
            return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(value).tz(this.cleanTimezone(timezone), keepLocalTime);
        };
        this.getLocaleFormats = ()=>{
            const locales = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).Ls;
            const locale = this.locale || 'en';
            let localeObject = locales[locale];
            if (localeObject === undefined) {
                $4ed4d5da8fc9d26b$var$localeNotFoundWarning();
                localeObject = locales.en;
            }
            return localeObject.formats;
        };
        this.date = (value)=>{
            if (value === null) return null;
            return this.dayjs(value);
        };
        this.dateWithTimezone = (value, timezone)=>{
            if (value === null) return null;
            let parsedValue;
            if (timezone === 'UTC') parsedValue = this.createUTCDate(value);
            else if (timezone === 'system' || timezone === 'default' && !this.hasTimezonePlugin()) parsedValue = this.createSystemDate(value);
            else parsedValue = this.createTZDate(value, timezone);
            if (this.locale === undefined) return parsedValue;
            return parsedValue.locale(this.locale);
        };
        this.getTimezone = (value)=>{
            if (this.hasUTCPlugin() && value.isUTC()) return 'UTC';
            if (this.hasTimezonePlugin()) {
                var _value$$x;
                // @ts-ignore
                const zone = (_value$$x = value.$x) == null ? void 0 : _value$$x.$timezone;
                return zone != null ? zone : 'system';
            }
            return 'system';
        };
        this.setTimezone = (value, timezone)=>{
            if (this.getTimezone(value) === timezone) return value;
            if (timezone === 'UTC') {
                /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($4ed4d5da8fc9d26b$var$MISSING_UTC_PLUGIN);
                return value.utc();
            }
            // We know that we have the UTC plugin.
            // Otherwise, the value timezone would always equal "system".
            // And it would be caught by the first "if" of this method.
            if (timezone === 'system') return value.local();
            if (!this.hasTimezonePlugin()) {
                if (timezone === 'default') return value;
                /* istanbul ignore next */ throw new Error($4ed4d5da8fc9d26b$var$MISSING_TIMEZONE_PLUGIN);
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).tz(value, this.cleanTimezone(timezone));
        };
        this.toJsDate = (value)=>{
            return value.toDate();
        };
        this.parseISO = (isoString)=>{
            return this.dayjs(isoString);
        };
        this.toISO = (value)=>{
            return value.toISOString();
        };
        this.parse = (value, format)=>{
            if (value === '') return null;
            return this.dayjs(value, format, this.locale, true);
        };
        this.getCurrentLocaleCode = ()=>{
            return this.locale || 'en';
        };
        this.is12HourCycleInCurrentLocale = ()=>{
            /* istanbul ignore next */ return /A|a/.test(this.getLocaleFormats().LT || '');
        };
        this.expandFormat = (format)=>{
            const localeFormats = this.getLocaleFormats();
            // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js
            const t = (formatBis)=>formatBis.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (_, a, b)=>a || b.slice(1));
            return format.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (_, a, b)=>{
                const B = b && b.toUpperCase();
                return a || localeFormats[b] || t(localeFormats[B]);
            });
        };
        this.getFormatHelperText = (format)=>{
            return this.expandFormat(format).replace(/a/gi, '(a|p)m').toLocaleLowerCase();
        };
        this.isNull = (value)=>{
            return value === null;
        };
        this.isValid = (value)=>{
            return this.dayjs(value).isValid();
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, formatString)=>{
            return this.dayjs(value).format(formatString);
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getDiff = (value, comparing, unit)=>{
            return value.diff(comparing, unit);
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            return this.dayjs(value).toDate().getTime() === this.dayjs(comparing).toDate().getTime();
        };
        this.isSameYear = (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY');
        };
        this.isSameMonth = (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY-MM');
        };
        this.isSameDay = (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY-MM-DD');
        };
        this.isSameHour = (value, comparing)=>{
            return value.isSame(comparing, 'hour');
        };
        this.isAfter = (value, comparing)=>{
            return value > comparing;
        };
        this.isAfterYear = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'year');
            return !this.isSameYear(value, comparing) && value.utc() > comparing.utc();
        };
        this.isAfterDay = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'day');
            return !this.isSameDay(value, comparing) && value.utc() > comparing.utc();
        };
        this.isBefore = (value, comparing)=>{
            return value < comparing;
        };
        this.isBeforeYear = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'year');
            return !this.isSameYear(value, comparing) && value.utc() < comparing.utc();
        };
        this.isBeforeDay = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'day');
            return !this.isSameDay(value, comparing) && value.utc() < comparing.utc();
        };
        this.isWithinRange = (value, [start, end])=>{
            return value >= start && value <= end;
        };
        this.startOfYear = (value)=>{
            return value.startOf('year');
        };
        this.startOfMonth = (value)=>{
            return value.startOf('month');
        };
        this.startOfWeek = (value)=>{
            return value.startOf('week');
        };
        this.startOfDay = (value)=>{
            return value.startOf('day');
        };
        this.endOfYear = (value)=>{
            return value.endOf('year');
        };
        this.endOfMonth = (value)=>{
            return value.endOf('month');
        };
        this.endOfWeek = (value)=>{
            return value.endOf('week');
        };
        this.endOfDay = (value)=>{
            return value.endOf('day');
        };
        this.addYears = (value, amount)=>{
            return amount < 0 ? value.subtract(Math.abs(amount), 'year') : value.add(amount, 'year');
        };
        this.addMonths = (value, amount)=>{
            return amount < 0 ? value.subtract(Math.abs(amount), 'month') : value.add(amount, 'month');
        };
        this.addWeeks = (value, amount)=>{
            return amount < 0 ? value.subtract(Math.abs(amount), 'week') : value.add(amount, 'week');
        };
        this.addDays = (value, amount)=>{
            return amount < 0 ? value.subtract(Math.abs(amount), 'day') : value.add(amount, 'day');
        };
        this.addHours = (value, amount)=>{
            return amount < 0 ? value.subtract(Math.abs(amount), 'hour') : value.add(amount, 'hour');
        };
        this.addMinutes = (value, amount)=>{
            return amount < 0 ? value.subtract(Math.abs(amount), 'minute') : value.add(amount, 'minute');
        };
        this.addSeconds = (value, amount)=>{
            return amount < 0 ? value.subtract(Math.abs(amount), 'second') : value.add(amount, 'second');
        };
        this.getYear = (value)=>{
            return value.year();
        };
        this.getMonth = (value)=>{
            return value.month();
        };
        this.getDate = (value)=>{
            return value.date();
        };
        this.getHours = (value)=>{
            return value.hour();
        };
        this.getMinutes = (value)=>{
            return value.minute();
        };
        this.getSeconds = (value)=>{
            return value.second();
        };
        this.getMilliseconds = (value)=>{
            return value.millisecond();
        };
        this.setYear = (value, year)=>{
            return value.set('year', year);
        };
        this.setMonth = (value, month)=>{
            return value.set('month', month);
        };
        this.setDate = (value, date)=>{
            return value.set('date', date);
        };
        this.setHours = (value, hours)=>{
            return value.set('hour', hours);
        };
        this.setMinutes = (value, minutes)=>{
            return value.set('minute', minutes);
        };
        this.setSeconds = (value, seconds)=>{
            return value.set('second', seconds);
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return value.set('millisecond', milliseconds);
        };
        this.getDaysInMonth = (value)=>{
            return value.daysInMonth();
        };
        this.getNextMonth = (value)=>{
            return value.add(1, 'month');
        };
        this.getPreviousMonth = (value)=>{
            return value.subtract(1, 'month');
        };
        this.getMonthArray = (value)=>{
            const firstMonth = value.startOf('year');
            const monthArray = [
                firstMonth
            ];
            while(monthArray.length < 12){
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.addMonths(prevMonth, 1));
            }
            return monthArray;
        };
        this.mergeDateAndTime = (dateParam, timeParam)=>{
            return dateParam.hour(timeParam.hour()).minute(timeParam.minute()).second(timeParam.second());
        };
        this.getWeekdays = ()=>{
            const start = this.dayjs().startOf('week');
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map((diff)=>this.formatByString(start.add(diff, 'day'), 'dd'));
        };
        this.getWeekArray = (value)=>{
            const timezone = this.getTimezone(value);
            const cleanValue = this.setLocaleToValue(value);
            const start = cleanValue.startOf('month').startOf('week');
            const end = cleanValue.endOf('month').endOf('week');
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while(current < end){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = current.add(1, 'day');
                // If the new day does not have the same offset as the old one (when switching to summer day time for example),
                // Then dayjs will not automatically adjust the offset (moment does)
                // We have to parse again the value to make sure the `fixOffset` method is applied
                // See https://github.com/iamkun/dayjs/blob/b3624de619d6e734cd0ffdbbd3502185041c1b60/src/plugin/timezone/index.js#L72
                if (this.hasTimezonePlugin() && timezone !== 'UTC' && timezone !== 'system') current = current.tz(this.cleanTimezone(timezone), true);
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (value)=>{
            return value.week();
        };
        this.getYearRange = (start, end)=>{
            const startDate = start.startOf('year');
            const endDate = end.endOf('year');
            const years = [];
            let current = startDate;
            while(current < endDate){
                years.push(current);
                current = current.add(1, 'year');
            }
            return years;
        };
        this.getMeridiemText = (ampm)=>{
            return ampm === 'am' ? 'AM' : 'PM';
        };
        this.rawDayJsInstance = instance;
        this.dayjs = $4ed4d5da8fc9d26b$var$withLocale((_this$rawDayJsInstanc = this.rawDayJsInstance) != null ? _this$rawDayJsInstanc : (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))), _locale);
        this.locale = _locale;
        this.formats = (0, $1CWiu.default)({}, $4ed4d5da8fc9d26b$var$defaultFormats, formats);
        (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($8d9ddcc2276db3d6$exports))));
    }
}



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");



var $4M4EV = parcelRequire("4M4EV");

var $5xV56 = parcelRequire("5xV56");
'use client';
function $ff0701065e7e2ab2$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $cbcd67e9ee8b881a$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $4M4EV.default,
        themeId: (0, $5xV56.default)
    });
}



var $bHJbJ = parcelRequire("bHJbJ");
const $295315439c6d861c$var$_excluded = [
    "localeText"
];
const $295315439c6d861c$export$544976378534cf9 = /*#__PURE__*/ $i5lfL.createContext(null);
const $295315439c6d861c$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    var _React$useContext;
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $7qXFD.default)(inProps, $295315439c6d861c$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = (_React$useContext = $i5lfL.useContext($295315439c6d861c$export$544976378534cf9)) != null ? _React$useContext : {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $i5lfL.useMemo(()=>(0, $1CWiu.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $i5lfL.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            'MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation'
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $i5lfL.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date('1900-01-01T00:00:00.000'),
            maxDate: utils.date('2099-12-31T00:00:00.000')
        };
    }, [
        utils
    ]);
    const contextValue = $i5lfL.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($295315439c6d861c$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
};



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");




var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");

var $1Zx8l = parcelRequire("1Zx8l");
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $075cbe52c7034614$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}



var $7qXFD = parcelRequire("7qXFD");
const $1a05f09c2879c911$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $1a05f09c2879c911$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views != null ? views : defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI: The `views` prop must contain at least one view');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $276f3a2cf1f0c279$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils, timezone: timezone })=>{
    const today = utils.startOfDay(utils.dateWithTimezone(undefined, timezone));
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $276f3a2cf1f0c279$export$36ca889e039badd5 = (utils, value)=>value == null || !utils.isValid(value) ? null : value;
const $276f3a2cf1f0c279$export$eb73579ccade48fd = (utils, value, defaultValue)=>{
    if (value == null || !utils.isValid(value)) return defaultValue;
    return value;
};
const $276f3a2cf1f0c279$export$8fabf9a4cbada414 = (utils, a, b)=>{
    if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) return true;
    return utils.isEqual(a, b);
};
const $276f3a2cf1f0c279$export$62591b96a734eacd = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const $276f3a2cf1f0c279$export$a98b123b8f29e004 = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    return mergedDate;
};
const $276f3a2cf1f0c279$export$1118e4272ea1e258 = (utils, timezone, valueType)=>valueType === 'date' ? utils.startOfDay(utils.dateWithTimezone(undefined, timezone)) : utils.dateWithTimezone(undefined, timezone);
const $276f3a2cf1f0c279$var$dateViews = [
    'year',
    'month',
    'day'
];
const $276f3a2cf1f0c279$export$b32dfef9f07dea64 = (view)=>$276f3a2cf1f0c279$var$dateViews.includes(view);
const $276f3a2cf1f0c279$export$bb1c921f313ec928 = (utils, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $1a05f09c2879c911$export$f07872cd524bec98)(views, [
        'year'
    ])) return formats.year;
    if ((0, $1a05f09c2879c911$export$f07872cd524bec98)(views, [
        'month'
    ])) return formats.month;
    if ((0, $1a05f09c2879c911$export$f07872cd524bec98)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, $1a05f09c2879c911$export$f07872cd524bec98)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $1a05f09c2879c911$export$f07872cd524bec98)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};



const $6cccea7bd094fe8c$var$timeViews = [
    'hours',
    'minutes',
    'seconds'
];
const $6cccea7bd094fe8c$export$8f04d380cefd5a0d = (view)=>$6cccea7bd094fe8c$var$timeViews.includes(view);
const $6cccea7bd094fe8c$export$a3328136ac50623d = (view)=>$6cccea7bd094fe8c$var$timeViews.includes(view) || view === 'meridiem';
const $6cccea7bd094fe8c$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const $6cccea7bd094fe8c$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const $6cccea7bd094fe8c$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $6cccea7bd094fe8c$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $6cccea7bd094fe8c$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $6cccea7bd094fe8c$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $6cccea7bd094fe8c$export$888a1ce13aa61986(dateLeft, utils) > $6cccea7bd094fe8c$export$888a1ce13aa61986(dateRight, utils);
    };
const $6cccea7bd094fe8c$export$3a6776b3863772fe = (utils, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $1a05f09c2879c911$export$f07872cd524bec98)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $1a05f09c2879c911$export$f07872cd524bec98)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, $1a05f09c2879c911$export$f07872cd524bec98)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, $1a05f09c2879c911$export$f07872cd524bec98)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $1a05f09c2879c911$export$f07872cd524bec98)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};



const $12ddf67933ed7c3a$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $12ddf67933ed7c3a$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>{
        var _SECTION_TYPE_GRANULA;
        return (_SECTION_TYPE_GRANULA = $12ddf67933ed7c3a$export$8f74e8f4ed8ae0ac[section.type]) != null ? _SECTION_TYPE_GRANULA : 1;
    }));
const $12ddf67933ed7c3a$export$e7c8ae702868847 = (views)=>Math.max(...views.map((view)=>{
        var _SECTION_TYPE_GRANULA2;
        return (_SECTION_TYPE_GRANULA2 = $12ddf67933ed7c3a$export$8f74e8f4ed8ae0ac[view]) != null ? _SECTION_TYPE_GRANULA2 : 1;
    }));
const $12ddf67933ed7c3a$var$roundDate = (utils, granularity, date)=>{
    if (granularity === $12ddf67933ed7c3a$export$8f74e8f4ed8ae0ac.year) return utils.startOfYear(date);
    if (granularity === $12ddf67933ed7c3a$export$8f74e8f4ed8ae0ac.month) return utils.startOfMonth(date);
    if (granularity === $12ddf67933ed7c3a$export$8f74e8f4ed8ae0ac.day) return utils.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $12ddf67933ed7c3a$export$8f74e8f4ed8ae0ac.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < $12ddf67933ed7c3a$export$8f74e8f4ed8ae0ac.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < $12ddf67933ed7c3a$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $12ddf67933ed7c3a$export$6a31d56794238e4e = ({ props: props, utils: utils, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    var _props$disableIgnorin;
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $12ddf67933ed7c3a$var$roundDate(utils, granularity, (0, $276f3a2cf1f0c279$export$1118e4272ea1e258)(utils, timezone));
    if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = $12ddf67933ed7c3a$var$roundDate(utils, granularity, props.minDate);
    if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $12ddf67933ed7c3a$var$roundDate(utils, granularity, props.maxDate);
    const isAfter = (0, $6cccea7bd094fe8c$export$fb87c80b35a46b89)((_props$disableIgnorin = props.disableIgnoringDatePartForTimeValidation) != null ? _props$disableIgnorin : false, utils);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $12ddf67933ed7c3a$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $276f3a2cf1f0c279$export$a98b123b8f29e004)(utils, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $12ddf67933ed7c3a$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $276f3a2cf1f0c279$export$a98b123b8f29e004)(utils, referenceDate, props.maxTime));
    return referenceDate;
};



var $1CWiu = parcelRequire("1CWiu");

const $a5f3825a9de04fb0$export$2f3c5fac7a2a65f6 = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $a5f3825a9de04fb0$var$getDeltaFromKeyCode = (keyCode)=>{
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
};
const $a5f3825a9de04fb0$export$c65c7173f879039f = (utils, timezone, format)=>{
    const elements = [];
    const now = utils.dateWithTimezone(undefined, timezone);
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const $a5f3825a9de04fb0$export$3ee1e7e19c2b047a = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, $276f3a2cf1f0c279$export$62591b96a734eacd)(utils, utils.dateWithTimezone(undefined, timezone)).map((month)=>utils.formatByString(month, format));
        case 'weekDay':
            return $a5f3825a9de04fb0$export$c65c7173f879039f(utils, timezone, format);
        case 'meridiem':
            {
                const now = utils.dateWithTimezone(undefined, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $a5f3825a9de04fb0$export$713c6d756c12fc27 = (utils, valueStr, size)=>{
    let cleanValueStr = valueStr;
    // Remove the leading zeros
    cleanValueStr = Number(cleanValueStr).toString();
    // Add enough leading zeros to fill the section
    while(cleanValueStr.length < size)cleanValueStr = `0${cleanValueStr}`;
    return cleanValueStr;
};
const $a5f3825a9de04fb0$export$ef88db4bceade9fd = (utils, timezone, value, sectionBoundaries, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    const valueStr = value.toString();
    if (section.hasLeadingZerosInInput) return $a5f3825a9de04fb0$export$713c6d756c12fc27(utils, valueStr, section.maxLength);
    return valueStr;
};
const $a5f3825a9de04fb0$export$5ed0f22513e58fe3 = (utils, timezone, section, keyCode, sectionsValueBoundaries, activeDate, stepsAttribues)=>{
    const delta = $a5f3825a9de04fb0$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>$a5f3825a9de04fb0$export$ef88db4bceade9fd(utils, timezone, value, sectionBoundaries, section);
        const step = section.type === 'minutes' && stepsAttribues != null && stepsAttribues.minutesStep ? stepsAttribues.minutesStep : 1;
        const currentSectionValue = parseInt(section.value, 10);
        let newSectionValueNumber = currentSectionValue + delta * step;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return utils.formatByString(utils.dateWithTimezone(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = $a5f3825a9de04fb0$export$3ee1e7e19c2b047a(utils, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + options.length + delta) % options.length;
        return options[newOptionIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
};
const $a5f3825a9de04fb0$export$85daa91f6c6e875f = (section, target)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number(value).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
const $a5f3825a9de04fb0$export$cb0bbc88c7f09596 = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const $a5f3825a9de04fb0$export$8bb5d1c9951d10ca = (sections, isRTL)=>{
    let position = 0;
    let positionInInput = isRTL ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = $a5f3825a9de04fb0$export$85daa91f6c6e875f(section, isRTL ? 'input-rtl' : 'input-ltr');
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $a5f3825a9de04fb0$export$cb0bbc88c7f09596(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $a5f3825a9de04fb0$export$cb0bbc88c7f09596(renderedValue);
        const startInInput = positionInInput + renderedValue.indexOf(cleanedValue[0]) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $1CWiu.default)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $a5f3825a9de04fb0$var$getSectionPlaceholder = (utils, timezone, localeText, sectionConfig, currentTokenValue)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.dateWithTimezone(undefined, timezone), currentTokenValue).length
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType
            });
        case 'day':
            return localeText.fieldDayPlaceholder();
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder();
        case 'minutes':
            return localeText.fieldMinutesPlaceholder();
        case 'seconds':
            return localeText.fieldSecondsPlaceholder();
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder();
        default:
            return currentTokenValue;
    }
};
const $a5f3825a9de04fb0$export$2816862a602354ce = (utils, valueStr, currentFormat, newFormat)=>{
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const $a5f3825a9de04fb0$var$isFourDigitYearFormat = (utils, timezone, format)=>utils.formatByString(utils.dateWithTimezone(undefined, timezone), format).length === 4;
const $a5f3825a9de04fb0$export$78b5830e2dd2de49 = (utils, timezone, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = utils.dateWithTimezone(undefined, timezone);
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            {
                if ($a5f3825a9de04fb0$var$isFourDigitYearFormat(utils, timezone, format)) {
                    const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
                    return formatted0001 === '0001';
                }
                const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
                return formatted2001 === '01';
            }
        case 'month':
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case 'day':
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case 'hours':
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case 'minutes':
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
const $a5f3825a9de04fb0$var$getEscapedPartsFromFormat = (utils, format)=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(format))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $a5f3825a9de04fb0$export$fd71d82fe42bada1 = (utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)=>{
    let startSeparator = '';
    const sections = [];
    const now = utils.date();
    const commitToken = (token)=>{
        if (token === '') return null;
        const sectionConfig = $a5f3825a9de04fb0$export$2f3c5fac7a2a65f6(utils, token);
        const hasLeadingZerosInFormat = $a5f3825a9de04fb0$export$78b5830e2dd2de49(utils, timezone, sectionConfig.contentType, sectionConfig.type, token);
        const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
        const isValidDate = date != null && utils.isValid(date);
        let sectionValue = isValidDate ? utils.formatByString(date, token) : '';
        let maxLength = null;
        if (hasLeadingZerosInInput) {
            if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? utils.formatByString(now, token).length : sectionValue.length;
            else {
                if (sectionConfig.maxLength == null) throw new Error(`MUI: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
                maxLength = sectionConfig.maxLength;
                if (isValidDate) sectionValue = $a5f3825a9de04fb0$export$713c6d756c12fc27(utils, sectionValue, maxLength);
            }
        }
        sections.push((0, $1CWiu.default)({}, sectionConfig, {
            format: token,
            maxLength: maxLength,
            value: sectionValue,
            placeholder: $a5f3825a9de04fb0$var$getSectionPlaceholder(utils, timezone, localeText, sectionConfig, token),
            hasLeadingZeros: hasLeadingZerosInFormat,
            hasLeadingZerosInFormat: hasLeadingZerosInFormat,
            hasLeadingZerosInInput: hasLeadingZerosInInput,
            startSeparator: sections.length === 0 ? startSeparator : '',
            endSeparator: '',
            modified: false
        }));
        return null;
    };
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component');
    }
    const expandedFormat = nextFormat;
    // Get start/end indexes of escaped sections
    const escapedParts = $a5f3825a9de04fb0$var$getEscapedPartsFromFormat(utils, expandedFormat);
    // This RegExp test if the beginning of a string correspond to a supported token
    const isTokenStartRegExp = new RegExp(`^(${Object.keys(utils.formatTokenMap).join('|')})`);
    let currentTokenValue = '';
    for(let i = 0; i < expandedFormat.length; i += 1){
        const escapedPartOfCurrentChar = escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
        const char = expandedFormat[i];
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const potentialToken = `${currentTokenValue}${expandedFormat.slice(i)}`;
        if (!isEscapedChar && char.match(/([A-Za-z]+)/) && isTokenStartRegExp.test(potentialToken)) currentTokenValue += char;
        else {
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.start) === i || (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.end) === i;
            if (!isEscapeBoundary) {
                commitToken(currentTokenValue);
                currentTokenValue = '';
                if (sections.length === 0) startSeparator += char;
                else sections[sections.length - 1].endSeparator += char;
            }
        }
    }
    commitToken(currentTokenValue);
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRTL && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $a5f3825a9de04fb0$export$b0c1bfd065bfe742 = (utils, sections)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($a5f3825a9de04fb0$export$85daa91f6c6e875f(section, 'non-input'));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $a5f3825a9de04fb0$export$e990c4332a617e3d = (sections, isRTL)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $a5f3825a9de04fb0$export$85daa91f6c6e875f(section, isRTL ? 'input-rtl' : 'input-ltr');
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRTL) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $a5f3825a9de04fb0$export$360600f456ea7d5f = (utils, timezone)=>{
    const today = utils.dateWithTimezone(undefined, timezone);
    const endOfYear = utils.endOfYear(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $276f3a2cf1f0c279$export$62591b96a734eacd)(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $a5f3825a9de04fb0$var$isFourDigitYearFormat(utils, timezone, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = $a5f3825a9de04fb0$export$c65c7173f879039f(utils, timezone, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = utils.getHours(endOfYear);
            const hasMeridiem = utils.formatByString(utils.endOfDay(today), format) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number(utils.formatByString(utils.startOfDay(today), format))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: utils.getMinutes(endOfYear)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: utils.getSeconds(endOfYear)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $a5f3825a9de04fb0$var$warnedOnceInvalidSection = false;
const $a5f3825a9de04fb0$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $a5f3825a9de04fb0$var$transferDateSectionValue = (utils, timezone, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case 'month':
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                const formattedDaysInWeek = $a5f3825a9de04fb0$export$c65c7173f879039f(utils, timezone, section.format);
                const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case 'minutes':
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case 'seconds':
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $a5f3825a9de04fb0$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8
};
const $a5f3825a9de04fb0$export$6c6df982c77f60a9 = (utils, timezone, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$a5f3825a9de04fb0$var$reliableSectionModificationOrder[a.type] - $a5f3825a9de04fb0$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $a5f3825a9de04fb0$var$transferDateSectionValue(utils, timezone, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $a5f3825a9de04fb0$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().indexOf('android') > -1;
const $a5f3825a9de04fb0$export$c7a10a3e9bfc3786 = (utils, timezone, sections, sectionsValueBoundaries)=>{
    // We can only clamp the day value if:
    // 1. if all the sections are filled (except the week day section which can be empty)
    // 2. there is a day section
    const canClamp = sections.every((section)=>section.type === 'weekDay' || section.value !== '') && sections.some((section)=>section.type === 'day');
    if (!canClamp) return null;
    // We try to generate a valid date representing the start of the month of the invalid date typed by the user.
    const sectionsForStartOfMonth = sections.map((section)=>{
        if (section.type !== 'day') return section;
        const dayBoundaries = sectionsValueBoundaries.day({
            currentDate: null,
            format: section.format,
            contentType: section.contentType
        });
        return (0, $1CWiu.default)({}, section, {
            value: $a5f3825a9de04fb0$export$ef88db4bceade9fd(utils, timezone, dayBoundaries.minimum, dayBoundaries, section)
        });
    });
    const startOfMonth = $a5f3825a9de04fb0$export$b0c1bfd065bfe742(utils, sectionsForStartOfMonth);
    // Even the start of the month is invalid, we probably have other invalid sections, the clamping failed.
    if (startOfMonth == null || !utils.isValid(startOfMonth)) return null;
    // The only invalid section was the day of the month, we replace its value with the maximum boundary for the correct month.
    return sections.map((section)=>{
        if (section.type !== 'day') return section;
        const dayBoundaries = sectionsValueBoundaries.day({
            currentDate: startOfMonth,
            format: section.format,
            contentType: section.contentType
        });
        if (Number(section.value) <= dayBoundaries.maximum) return section;
        return (0, $1CWiu.default)({}, section, {
            value: dayBoundaries.maximum.toString()
        });
    });
};
const $a5f3825a9de04fb0$export$7725fd6fe0a2aadf = (sections, isRTL)=>{
    const neighbors = {};
    if (!isRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>{
            var _section$endSeparator;
            return index >= groupedSectionsStart && ((_section$endSeparator = section.endSeparator) == null ? void 0 : _section$endSeparator.includes(' ')) && // Special case where the spaces were not there in the initial input
            section.endSeparator !== ' / ';
        });
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};


const $2fdbcdc4da212b5f$var$_excluded = [
    "value",
    "referenceDate"
];
const $2fdbcdc4da212b5f$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $276f3a2cf1f0c279$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $7qXFD.default)(_ref, $2fdbcdc4da212b5f$var$_excluded);
        if (value != null && params.utils.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $12ddf67933ed7c3a$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $276f3a2cf1f0c279$export$36ca889e039badd5),
    areValuesEqual: (0, $276f3a2cf1f0c279$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (utils, value)=>value == null ? null : utils.getTimezone(value),
    setTimezone: (utils, timezone, value)=>value == null ? null : utils.setTimezone(value, timezone)
};
const $2fdbcdc4da212b5f$export$b602c94f557316b4 = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>value == null || !utils.isValid(value) ? prevReferenceValue : value,
    getSectionsFromValue: (utils, date, prevSections, isRTL, getSectionsFromDate)=>{
        const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
        if (shouldReUsePrevDateSections) return prevSections;
        return (0, $a5f3825a9de04fb0$export$8bb5d1c9951d10ca)(getSectionsFromDate(date), isRTL);
    },
    getValueStrFromSections: (0, $a5f3825a9de04fb0$export$e990c4332a617e3d),
    getActiveDateManager: (utils, state)=>({
            date: state.value,
            referenceDate: state.referenceValue,
            getSections: (sections)=>sections,
            getNewValuesFromNewActiveDate: (newActiveDate)=>({
                    value: newActiveDate,
                    referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
                })
        }),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue)
};



var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $1CWiu = parcelRequire("1CWiu");
const $1a6ca777b711e387$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $1CWiu.default)({}, pickersTranslations)
                }
            }
        }
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $9ebab87743598067$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'open previous view',
    openNextView: 'open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange placeholders
    start: 'Start',
    end: 'End',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Select ${view}. ${time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose date, selected date is ${utils.format(value, 'fullDate')}` : 'Choose date',
    openTimePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose time, selected time is ${utils.format(value, 'fullTime')}` : 'Choose time',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa'
};
const $9ebab87743598067$export$1af4c7e47ad72f44 = $9ebab87743598067$var$enUSPickers;
const $9ebab87743598067$export$137380d9ce54f7f = (0, $1a6ca777b711e387$export$67c96d35a1b010b3)($9ebab87743598067$var$enUSPickers);


const $c90bc5ca414ce17d$export$4b5a24245de9f7f9 = ()=>{
    const localization = $i5lfL.useContext((0, $295315439c6d861c$export$544976378534cf9));
    if (localization === null) throw new Error([
        'MUI: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.utils === null) throw new Error([
        'MUI: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = $i5lfL.useMemo(()=>(0, $1CWiu.default)({}, (0, $9ebab87743598067$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $i5lfL.useMemo(()=>(0, $1CWiu.default)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $c90bc5ca414ce17d$export$1163b47e39508a46 = ()=>$c90bc5ca414ce17d$export$4b5a24245de9f7f9().utils;
const $c90bc5ca414ce17d$export$7c38da3a2e90fa83 = ()=>$c90bc5ca414ce17d$export$4b5a24245de9f7f9().defaultDates;
const $c90bc5ca414ce17d$export$24fdeaa0f591a73e = ()=>$c90bc5ca414ce17d$export$4b5a24245de9f7f9().localeText;
const $c90bc5ca414ce17d$export$3a404aece3dff2fa = (timezone)=>{
    const utils = $c90bc5ca414ce17d$export$1163b47e39508a46();
    const now = $i5lfL.useRef();
    if (now.current === undefined) now.current = utils.dateWithTimezone(undefined, timezone);
    return now.current;
};





var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");



var $j7y1Z = parcelRequire("j7y1Z");

var $2ktY3 = parcelRequire("2ktY3");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");
function $35903a0217fe2785$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $35903a0217fe2785$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $35903a0217fe2785$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $35903a0217fe2785$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $35903a0217fe2785$export$2e2bcd8739ae039 = $35903a0217fe2785$export$4f5d2d50c9deca37;





var $j7y1Z = parcelRequire("j7y1Z");

var $2ktY3 = parcelRequire("2ktY3");

var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
function $955cbc73ae25da20$export$b109c489973c3d80(slot) {
    return (0, $6bbZp.default)('MuiPickersToolbar', slot);
}
const $955cbc73ae25da20$export$59f09e5e2b3d9913 = (0, $47i1c.default)('MuiPickersToolbar', [
    'root',
    'content'
]);



var $bHJbJ = parcelRequire("bHJbJ");
const $5a614a16cbde1ceb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        content: [
            'content'
        ],
        penIconButton: [
            'penIconButton',
            isLandscape && 'penIconButtonLandscape'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $955cbc73ae25da20$export$b109c489973c3d80), classes);
};
const $5a614a16cbde1ceb$var$PickersToolbarRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3)
    }, ownerState.isLandscape && {
        height: 'auto',
        maxWidth: 160,
        padding: 16,
        justifyContent: 'flex-start',
        flexWrap: 'wrap'
    }));
const $5a614a16cbde1ceb$var$PickersToolbarContent = (0, $j7y1Z.default)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        flex: 1
    }, !ownerState.isLandscape && {
        alignItems: 'center'
    }));
const $5a614a16cbde1ceb$export$eb3c4d84783d6feb = /*#__PURE__*/ $i5lfL.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children: children, className: className, isLandscape: isLandscape, landscapeDirection: landscapeDirection = 'column', toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId } = props;
    const ownerState = props;
    const classes = $5a614a16cbde1ceb$var$useUtilityClasses(ownerState);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($5a614a16cbde1ceb$var$PickersToolbarRoot, {
        ref: ref,
        className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)($5a614a16cbde1ceb$var$PickersToolbarContent, {
                container: true,
                justifyContent: isLandscape ? 'flex-start' : 'space-between',
                className: classes.content,
                ownerState: ownerState,
                direction: isLandscape ? landscapeDirection : 'row',
                alignItems: isLandscape ? 'flex-start' : 'flex-end',
                children: children
            })
        ]
    });
});




var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
function $8e6089cea9e89df6$export$a1c3879af2c3b694(slot) {
    return (0, $6bbZp.default)('MuiDatePickerToolbar', slot);
}
const $8e6089cea9e89df6$export$2e35fa7d24ef4179 = (0, $47i1c.default)('MuiDatePickerToolbar', [
    'root',
    'title'
]);




var $bHJbJ = parcelRequire("bHJbJ");
const $dbe55dbb5849546a$var$_excluded = [
    "value",
    "isLandscape",
    "onChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views"
];
const $dbe55dbb5849546a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $8e6089cea9e89df6$export$a1c3879af2c3b694), classes);
};
const $dbe55dbb5849546a$var$DatePickerToolbarRoot = (0, $j7y1Z.default)((0, $5a614a16cbde1ceb$export$eb3c4d84783d6feb), {
    name: 'MuiDatePickerToolbar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
/**
 * @ignore - do not document.
 */ const $dbe55dbb5849546a$var$DatePickerToolbarTitle = (0, $j7y1Z.default)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
    name: 'MuiDatePickerToolbar',
    slot: 'Title',
    overridesResolver: (_, styles)=>styles.title
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({}, ownerState.isLandscape && {
        margin: 'auto 16px auto auto'
    }));
const $dbe55dbb5849546a$export$21b7f8ea763109eb = /*#__PURE__*/ $i5lfL.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { value: value, isLandscape: isLandscape, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", views: views } = props, other = (0, $7qXFD.default)(props, $dbe55dbb5849546a$var$_excluded);
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const localeText = (0, $c90bc5ca414ce17d$export$24fdeaa0f591a73e)();
    const classes = $dbe55dbb5849546a$var$useUtilityClasses(props);
    const dateText = $i5lfL.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        const formatFromViews = (0, $276f3a2cf1f0c279$export$bb1c921f313ec928)(utils, {
            format: toolbarFormat,
            views: views
        }, true);
        return utils.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($dbe55dbb5849546a$var$DatePickerToolbarRoot, (0, $1CWiu.default)({
        ref: ref,
        toolbarTitle: localeText.datePickerToolbarTitle,
        isLandscape: isLandscape,
        className: classes.root
    }, other, {
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($dbe55dbb5849546a$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});



var $1CWiu = parcelRequire("1CWiu");
const $920c17a093fe7370$export$ee17bc394843b249 = (capitalizedObject)=>{
    if (capitalizedObject === undefined) return undefined;
    return Object.keys(capitalizedObject).reduce((acc, key)=>(0, $1CWiu.default)({}, acc, {
            [`${key.slice(0, 1).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
        }), {});
};


function $fc4c0e27265f19c0$export$a552c17ed3587731(props, name) {
    var _themeProps$slots, _themeProps$disableFu, _themeProps$disablePa, _themeProps$slotProps;
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const defaultDates = (0, $c90bc5ca414ce17d$export$7c38da3a2e90fa83)();
    const themeProps = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const localeText = $i5lfL.useMemo(()=>{
        var _themeProps$localeTex;
        if (((_themeProps$localeTex = themeProps.localeText) == null ? void 0 : _themeProps$localeTex.toolbarTitle) == null) return themeProps.localeText;
        return (0, $1CWiu.default)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const slots = (_themeProps$slots = themeProps.slots) != null ? _themeProps$slots : (0, $920c17a093fe7370$export$ee17bc394843b249)(themeProps.components);
    return (0, $1CWiu.default)({}, themeProps, {
        localeText: localeText
    }, (0, $1a05f09c2879c911$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        minDate: (0, $276f3a2cf1f0c279$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $276f3a2cf1f0c279$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate),
        slots: (0, $1CWiu.default)({
            toolbar: (0, $dbe55dbb5849546a$export$21b7f8ea763109eb)
        }, slots),
        slotProps: (_themeProps$slotProps = themeProps.slotProps) != null ? _themeProps$slotProps : themeProps.componentsProps
    });
}



const $704b91a9b8a06a25$export$ffb3d0046ef3a2 = ({ props: props, value: value, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture, timezone: timezone } = props;
    const now = adapter.utils.dateWithTimezone(undefined, timezone);
    const minDate = (0, $276f3a2cf1f0c279$export$eb73579ccade48fd)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $276f3a2cf1f0c279$export$eb73579ccade48fd)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");

var $i5lfL = parcelRequire("i5lfL");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c6e0d4b70c5d27e7$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $ae8c38aa2140e497$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $i5lfL.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $c6e0d4b70c5d27e7$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $249e02fdeca42255$export$e28348cc2430497(element) {
    return typeof element === 'string';
}


function $4dc89f5e6024925d$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $249e02fdeca42255$export$e28348cc2430497)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}



var $kRbLW = parcelRequire("kRbLW");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $046fe2a80bd08077$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $ae7d5566d1b99e8a$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $03bd2b534f7809eb$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $kRbLW.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $046fe2a80bd08077$export$24d5698b57eff81c)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $ae7d5566d1b99e8a$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $ae7d5566d1b99e8a$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $kRbLW.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}



'use client';
function $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...rest } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $075cbe52c7034614$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $03bd2b534f7809eb$export$b01d1e419b049226)({
        ...rest,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $ae8c38aa2140e497$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $4dc89f5e6024925d$export$b089efb01a7bdf50)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}







var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");






var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
function $b8312f923488c081$export$5519b4d4bf80ce6f(slot) {
    return (0, $6bbZp.default)('MuiPickersPopper', slot);
}
const $b8312f923488c081$export$46e9184c9b1af0ce = (0, $47i1c.default)('MuiPickersPopper', [
    'root',
    'paper'
]);


/* Use it instead of .includes method for IE support */ function $e4fe91f37783b274$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $e4fe91f37783b274$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $e4fe91f37783b274$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $e4fe91f37783b274$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $e4fe91f37783b274$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
const $e4fe91f37783b274$export$9ae5b19305db48ce = '@media (pointer: fine)';



var $bHJbJ = parcelRequire("bHJbJ");
const $802cc071c0b5a230$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $b8312f923488c081$export$5519b4d4bf80ce6f), classes);
};
const $802cc071c0b5a230$var$PickersPopperRoot = (0, $j7y1Z.default)((0, $2a097690b61d558e$export$2e2bcd8739ae039), {
    name: 'MuiPickersPopper',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $802cc071c0b5a230$var$PickersPopperPaper = (0, $j7y1Z.default)((0, $fa105ed17f31a2c8$export$2e2bcd8739ae039), {
    name: 'MuiPickersPopper',
    slot: 'Paper',
    overridesResolver: (_, styles)=>styles.paper
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        transformOrigin: 'top center',
        outline: 0
    }, ownerState.placement === 'top' && {
        transformOrigin: 'bottom center'
    }));
function $802cc071c0b5a230$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $802cc071c0b5a230$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $i5lfL.useRef(false);
    const syntheticEventRef = $i5lfL.useRef(false);
    const nodeRef = $i5lfL.useRef(null);
    const activatedRef = $i5lfL.useRef(false);
    $i5lfL.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && $802cc071c0b5a230$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $i5lfL.useEffect(()=>{
        if (active) {
            const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $i5lfL.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (e.g. setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $1d4cd2ae762f70cd$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
function $802cc071c0b5a230$export$96ce8482474de8a5(inProps) {
    var _slots$desktopTransit, _slots$desktopTrapFoc, _slots$desktopPaper, _slots$popper;
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersPopper'
    });
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, shouldRestoreFocus: shouldRestoreFocus, onBlur: onBlur, onDismiss: onDismiss, open: open, role: role, placement: placement, slots: slots, slotProps: slotProps } = props;
    $i5lfL.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Blink?) use 'Esc'
            if (open && (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc')) onDismiss();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        onDismiss,
        open
    ]);
    const lastFocusedElementRef = $i5lfL.useRef(null);
    $i5lfL.useEffect(()=>{
        if (role === 'tooltip' || shouldRestoreFocus && !shouldRestoreFocus()) return;
        if (open) lastFocusedElementRef.current = (0, $e4fe91f37783b274$export$cd4e5573fbe2b576)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role,
        shouldRestoreFocus
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $802cc071c0b5a230$var$useClickAwayListener(open, onBlur != null ? onBlur : onDismiss);
    const paperRef = $i5lfL.useRef(null);
    const handleRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(paperRef, containerRef);
    const handlePaperRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = $802cc071c0b5a230$var$useUtilityClasses(ownerState);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onDismiss();
        }
    };
    const Transition = (_slots$desktopTransit = slots == null ? void 0 : slots.desktopTransition) != null ? _slots$desktopTransit : (0, $66de9c04029c8d70$export$2e2bcd8739ae039);
    const TrapFocus = (_slots$desktopTrapFoc = slots == null ? void 0 : slots.desktopTrapFocus) != null ? _slots$desktopTrapFoc : (0, $2ce9c86cd6d02e69$export$2e2bcd8739ae039);
    const Paper = (_slots$desktopPaper = slots == null ? void 0 : slots.desktopPaper) != null ? _slots$desktopPaper : $802cc071c0b5a230$var$PickersPopperPaper;
    const paperProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: Paper,
        externalSlotProps: slotProps == null ? void 0 : slotProps.desktopPaper,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: handlePaperRef
        },
        className: classes.paper,
        ownerState: {} // Is overridden below to use `placement
    });
    const Popper = (_slots$popper = slots == null ? void 0 : slots.popper) != null ? _slots$popper : $802cc071c0b5a230$var$PickersPopperRoot;
    const popperProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: Popper,
        externalSlotProps: slotProps == null ? void 0 : slotProps.popper,
        additionalProps: {
            transition: true,
            role: role,
            open: open,
            anchorEl: anchorEl,
            placement: placement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: props
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsx)(Popper, (0, $1CWiu.default)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps, placement: popperPlacement })=>/*#__PURE__*/ (0, $bHJbJ.jsx)(TrapFocus, (0, $1CWiu.default)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: role === 'tooltip',
                isEnabled: ()=>true
            }, slotProps == null ? void 0 : slotProps.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)(Transition, (0, $1CWiu.default)({}, TransitionProps, slotProps == null ? void 0 : slotProps.desktopTransition, {
                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)(Paper, (0, $1CWiu.default)({}, paperProps, {
                        onClick: (event)=>{
                            var _paperProps$onClick;
                            onPaperClick(event);
                            (_paperProps$onClick = paperProps.onClick) == null || _paperProps$onClick.call(paperProps, event);
                        },
                        onTouchStart: (event)=>{
                            var _paperProps$onTouchSt;
                            onPaperTouchStart(event);
                            (_paperProps$onTouchSt = paperProps.onTouchStart) == null || _paperProps$onTouchSt.call(paperProps, event);
                        },
                        ownerState: (0, $1CWiu.default)({}, ownerState, {
                            placement: popperPlacement
                        }),
                        children: children
                    }))
                }))
            }))
    }));
}




var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");



var $i5lfL = parcelRequire("i5lfL");
const $bd92b3453ff8b421$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $i5lfL.useRef(typeof open === 'boolean').current;
    const [openState, setIsOpenState] = $i5lfL.useState(false);
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)
    $i5lfL.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== 'boolean') throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $i5lfL.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};




var $i5lfL = parcelRequire("i5lfL");

function $e06ee6eac83d7a77$export$87fe492f99f25a20(props, validate, isSameError, defaultErrorState) {
    const { value: value, onError: onError } = props;
    const adapter = (0, $c90bc5ca414ce17d$export$4b5a24245de9f7f9)();
    const previousValidationErrorRef = $i5lfL.useRef(defaultErrorState);
    const validationError = validate({
        adapter: adapter,
        value: value,
        props: props
    });
    $i5lfL.useEffect(()=>{
        if (onError && !isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        isSameError,
        onError,
        previousValidationErrorRef,
        validationError,
        value
    ]);
    return validationError;
}



var $i5lfL = parcelRequire("i5lfL");



const $a7ba2c812e4f48ce$export$c7e050e908c1b2bc = ({ timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChange, valueManager: valueManager })=>{
    var _ref, _ref2;
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const firstDefaultValue = $i5lfL.useRef(defaultValue);
    const inputValue = (_ref = valueProp != null ? valueProp : firstDefaultValue.current) != null ? _ref : valueManager.emptyValue;
    const inputTimezone = $i5lfL.useMemo(()=>valueManager.getTimezone(utils, inputValue), [
        utils,
        valueManager,
        inputValue
    ]);
    const setInputTimezone = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    const timezoneToRender = (_ref2 = timezoneProp != null ? timezoneProp : inputTimezone) != null ? _ref2 : 'default';
    const valueWithTimezoneToRender = $i5lfL.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, inputValue), [
        valueManager,
        utils,
        timezoneToRender,
        inputValue
    ]);
    const handleValueChange = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        onChange == null || onChange(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
const $a7ba2c812e4f48ce$export$174d749f3b4c0f49 = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, valueManager: valueManager })=>{
    const [valueWithInputTimezone, setValue] = (0, $50778d58d10a200e$export$2e2bcd8739ae039)({
        name: name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : valueManager.emptyValue
    });
    const onChange = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        setValue(newValue);
        onChangeProp == null || onChangeProp(newValue, ...otherParams);
    });
    return $a7ba2c812e4f48ce$export$c7e050e908c1b2bc({
        timezone: timezoneProp,
        value: valueWithInputTimezone,
        defaultValue: undefined,
        onChange: onChange,
        valueManager: valueManager
    });
};


/**
 * Decide if the new value should be published
 * The published value will be passed to `onChange` if defined.
 */ const $eda9673cfde850e1$var$shouldPublishValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    // The field is responsible for only calling `onChange` when needed.
    if (action.name === 'setValueFromField') return true;
    if (action.name === 'setValueFromAction') {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to publish the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === 'setValueFromView' && action.selectionState !== 'shallow') {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === 'setValueFromShortcut' && action.changeImportance === 'accept') {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    return false;
};
/**
 * Decide if the new value should be committed.
 * The committed value will be passed to `onAccept` if defined.
 * It will also be used as a reset target when calling the `cancel` picker action (when clicking on the "Cancel" button).
 */ const $eda9673cfde850e1$var$shouldCommitValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled, closeOnSelect: closeOnSelect } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if (action.name === 'setValueFromAction') {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to commit the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === 'setValueFromView' && action.selectionState === 'finish' && closeOnSelect) {
        // On picker where the 1st view is also the last view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onAccept`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === 'setValueFromShortcut') return action.changeImportance === 'accept' && hasChanged(dateState.lastCommittedValue);
    return false;
};
/**
 * Decide if the picker should be closed after the value is updated.
 */ const $eda9673cfde850e1$var$shouldClosePicker = (params)=>{
    const { action: action, closeOnSelect: closeOnSelect } = params;
    if (action.name === 'setValueFromAction') return true;
    if (action.name === 'setValueFromView') return action.selectionState === 'finish' && closeOnSelect;
    if (action.name === 'setValueFromShortcut') return action.changeImportance === 'accept';
    return false;
};
const $eda9673cfde850e1$export$799b22a7b7fffaa3 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, validator: validator })=>{
    const { onAccept: onAccept, onChange: onChange, value: inValue, defaultValue: inDefaultValue, closeOnSelect: closeOnSelect = wrapperVariant === 'desktop', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezoneProp } = props;
    const { current: defaultValue } = $i5lfL.useRef(inDefaultValue);
    const { current: isControlled } = $i5lfL.useRef(inValue !== undefined);
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const adapter = (0, $c90bc5ca414ce17d$export$4b5a24245de9f7f9)();
    const [selectedSections, setSelectedSections] = (0, $50778d58d10a200e$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'usePickerValue',
        state: 'selectedSections'
    });
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $bd92b3453ff8b421$export$7d3a09d5141ab1f4)(props);
    const [dateState, setDateState] = $i5lfL.useState(()=>{
        let initialValue;
        if (inValue !== undefined) initialValue = inValue;
        else if (defaultValue !== undefined) initialValue = defaultValue;
        else initialValue = valueManager.emptyValue;
        return {
            draft: initialValue,
            lastPublishedValue: initialValue,
            lastCommittedValue: initialValue,
            lastControlledValue: inValue,
            hasBeenModifiedSinceMount: false
        };
    });
    const { timezone: timezone, handleValueChange: handleValueChange } = (0, $a7ba2c812e4f48ce$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: inValue,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    (0, $e06ee6eac83d7a77$export$87fe492f99f25a20)((0, $1CWiu.default)({}, props, {
        value: dateState.draft,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const updateDate = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((action)=>{
        const updaterParams = {
            action: action,
            dateState: dateState,
            hasChanged: (comparison)=>!valueManager.areValuesEqual(utils, action.value, comparison),
            isControlled: isControlled,
            closeOnSelect: closeOnSelect
        };
        const shouldPublish = $eda9673cfde850e1$var$shouldPublishValue(updaterParams);
        const shouldCommit = $eda9673cfde850e1$var$shouldCommitValue(updaterParams);
        const shouldClose = $eda9673cfde850e1$var$shouldClosePicker(updaterParams);
        setDateState((prev)=>(0, $1CWiu.default)({}, prev, {
                draft: action.value,
                lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
                lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        if (shouldPublish) {
            const validationError = action.name === 'setValueFromField' ? action.context.validationError : validator({
                adapter: adapter,
                value: action.value,
                props: (0, $1CWiu.default)({}, props, {
                    value: action.value,
                    timezone: timezone
                })
            });
            const context = {
                validationError: validationError
            };
            handleValueChange(action.value, context);
        }
        if (shouldCommit && onAccept) onAccept(action.value);
        if (shouldClose) setIsOpen(false);
    });
    if (inValue !== undefined && (dateState.lastControlledValue === undefined || !valueManager.areValuesEqual(utils, dateState.lastControlledValue, inValue))) {
        const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValue);
        setDateState((prev)=>(0, $1CWiu.default)({}, prev, {
                lastControlledValue: inValue
            }, isUpdateComingFromPicker ? {} : {
                lastCommittedValue: inValue,
                lastPublishedValue: inValue,
                draft: inValue,
                hasBeenModifiedSinceMount: true
            }));
    }
    const handleClear = (0, $49175dc6d5053977$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.emptyValue,
            name: 'setValueFromAction',
            pickerAction: 'clear'
        });
    });
    const handleAccept = (0, $49175dc6d5053977$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'accept'
        });
    });
    const handleDismiss = (0, $49175dc6d5053977$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'dismiss'
        });
    });
    const handleCancel = (0, $49175dc6d5053977$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastCommittedValue,
            name: 'setValueFromAction',
            pickerAction: 'cancel'
        });
    });
    const handleSetToday = (0, $49175dc6d5053977$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.getTodayValue(utils, timezone, valueType),
            name: 'setValueFromAction',
            pickerAction: 'today'
        });
    });
    const handleOpen = (0, $49175dc6d5053977$export$2e2bcd8739ae039)(()=>setIsOpen(true));
    const handleClose = (0, $49175dc6d5053977$export$2e2bcd8739ae039)(()=>setIsOpen(false));
    const handleChange = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newValue, selectionState = 'partial')=>updateDate({
            name: 'setValueFromView',
            value: newValue,
            selectionState: selectionState
        }));
    const handleSelectShortcut = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newValue, changeImportance)=>updateDate({
            name: 'setValueFromShortcut',
            value: newValue,
            changeImportance: changeImportance != null ? changeImportance : 'accept'
        }));
    const handleChangeFromField = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newValue, context)=>updateDate({
            name: 'setValueFromField',
            value: newValue,
            context: context
        }));
    const handleFieldSelectedSectionsChange = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newSelectedSections)=>{
        setSelectedSections(newSelectedSections);
        onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
    });
    const actions = {
        onClear: handleClear,
        onAccept: handleAccept,
        onDismiss: handleDismiss,
        onCancel: handleCancel,
        onSetToday: handleSetToday,
        onOpen: handleOpen,
        onClose: handleClose
    };
    const fieldResponse = {
        value: dateState.draft,
        onChange: handleChangeFromField,
        selectedSections: selectedSections,
        onSelectedSectionsChange: handleFieldSelectedSectionsChange
    };
    const viewValue = $i5lfL.useMemo(()=>valueManager.cleanValue(utils, dateState.draft), [
        utils,
        valueManager,
        dateState.draft
    ]);
    const viewResponse = {
        value: viewValue,
        onChange: handleChange,
        onClose: handleClose,
        open: isOpen,
        onSelectedSectionsChange: handleFieldSelectedSectionsChange
    };
    const isValid = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            props: (0, $1CWiu.default)({}, props, {
                value: testedValue,
                timezone: timezone
            })
        });
        return !valueManager.hasError(error);
    };
    const layoutResponse = (0, $1CWiu.default)({}, actions, {
        value: viewValue,
        onChange: handleChange,
        onSelectShortcut: handleSelectShortcut,
        isValid: isValid
    });
    return {
        open: isOpen,
        fieldProps: fieldResponse,
        viewProps: viewResponse,
        layoutProps: layoutResponse,
        actions: actions
    };
};



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");



var $i5lfL = parcelRequire("i5lfL");


let $da4e6a1f0a700ae4$var$warnedOnceNotValidView = false;
function $da4e6a1f0a700ae4$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange }) {
    var _views, _views2;
    const previousOpenTo = $i5lfL.useRef(openTo);
    const previousViews = $i5lfL.useRef(views);
    const defaultView = $i5lfL.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $50778d58d10a200e$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $i5lfL.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $50778d58d10a200e$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    $i5lfL.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = (_views = views[viewIndex - 1]) != null ? _views : null;
    const nextView = (_views2 = views[viewIndex + 1]) != null ? _views2 : null;
    const handleFocusedViewChange = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange == null || onFocusedViewChange(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newView)=>{
        if (newView === view) return;
        setView(newView);
        handleFocusedViewChange(newView, true);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $49175dc6d5053977$export$2e2bcd8739ae039)(()=>{
        if (nextView) handleChangeView(nextView);
        handleFocusedViewChange(nextView, true);
    });
    const setValueAndGoToNextView = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but we it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState);
        if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    const setValueAndGoToView = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((value, newView, selectedView)=>{
        onChange(value, newView ? 'partial' : 'finish', selectedView);
        if (newView) {
            handleChangeView(newView);
            handleFocusedViewChange(newView, true);
        }
    });
    return {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        defaultView: defaultView.current,
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView,
        setValueAndGoToView: setValueAndGoToView
    };
}



const $3267987ae58b71b9$var$_excluded = [
    "className",
    "sx"
];
const $3267987ae58b71b9$export$c0a71b697a2df210 = ({ props: props, propsFromPickerValue: propsFromPickerValue, additionalViewProps: additionalViewProps, inputRef: inputRef, autoFocusView: autoFocusView })=>{
    const { onChange: onChange, open: open, onSelectedSectionsChange: onSelectedSectionsChange, onClose: onClose } = propsFromPickerValue;
    const { views: views, openTo: openTo, onViewChange: onViewChange, disableOpenPicker: disableOpenPicker, viewRenderers: viewRenderers, timezone: timezone } = props;
    const propsToForwardToView = (0, $7qXFD.default)(props, $3267987ae58b71b9$var$_excluded);
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $da4e6a1f0a700ae4$export$9b46cba8f8ccd954)({
        view: undefined,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange,
        autoFocus: autoFocusView
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup } = $i5lfL.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            let viewMode;
            if (disableOpenPicker) viewMode = 'field';
            else if (viewRenderers[viewForReduce] != null) viewMode = 'UI';
            else viewMode = 'field';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') acc.hasUIView = true;
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {}
        }), [
        disableOpenPicker,
        viewRenderers,
        views
    ]);
    const timeViewsCount = $i5lfL.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            if (viewRenderers[viewForReduce] != null && (0, $6cccea7bd094fe8c$export$8f04d380cefd5a0d)(viewForReduce)) return acc + 1;
            return acc;
        }, 0), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const shouldRestoreFocus = (0, $49175dc6d5053977$export$2e2bcd8739ae039)(()=>currentViewMode === 'UI');
    const [popperView, setPopperView] = $i5lfL.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        // Handle case of `DateTimePicker` without time renderers
        if (currentViewMode === 'field' && open) {
            onClose();
            setTimeout(()=>{
                // focusing the input before the range selection is done
                // calling `onSelectedSectionsChange` outside of timeout results in an inconsistent behavior between Safari And Chrome
                inputRef == null || inputRef.current.focus();
                onSelectedSectionsChange(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        if (!open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const layoutProps = {
        views: views,
        view: popperView,
        onViewChange: setView
    };
    return {
        hasUIView: hasUIView,
        shouldRestoreFocus: shouldRestoreFocus,
        layoutProps: layoutProps,
        renderCurrentView: ()=>{
            if (popperView == null) return null;
            const renderer = viewRenderers[popperView];
            if (renderer == null) return null;
            return renderer((0, $1CWiu.default)({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
                views: views,
                timezone: timezone,
                onChange: setValueAndGoToNextView,
                view: popperView,
                onViewChange: setView,
                focusedView: focusedView,
                onFocusedViewChange: setFocusedView,
                showViewSwitcher: timeViewsCount > 1,
                timeViewsCount: timeViewsCount
            }));
        }
    };
};



var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


function $8bef62095c9cf8ff$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
const $8bef62095c9cf8ff$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $i5lfL.useState($8bef62095c9cf8ff$var$getOrientation);
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        const eventHandler = ()=>{
            setOrientation($8bef62095c9cf8ff$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $e4fe91f37783b274$export$22012a5c726bef55)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
};


const $89520527954c0483$export$4e5139e5825b7b27 = ({ props: props, propsFromPickerValue: propsFromPickerValue, propsFromPickerViews: propsFromPickerViews, wrapperVariant: wrapperVariant })=>{
    const { orientation: orientation } = props;
    const isLandscape = (0, $8bef62095c9cf8ff$export$6f60b24e37af6448)(propsFromPickerViews.views, orientation);
    const layoutProps = (0, $1CWiu.default)({}, propsFromPickerViews, propsFromPickerValue, {
        isLandscape: isLandscape,
        wrapperVariant: wrapperVariant,
        disabled: props.disabled,
        readOnly: props.readOnly
    });
    return {
        layoutProps: layoutProps
    };
};



const $a2e4a41b6580a3be$var$warnRenderInputIsDefined = (0, $2ae5630d39e1af29$export$baf331755d84b871)([
    'The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.',
    'You can replace it with the `textField` component slot in most cases.',
    'For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5).'
]);
const $a2e4a41b6580a3be$export$fc3313977ac596c4 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, inputRef: inputRef, additionalViewProps: additionalViewProps, validator: validator, autoFocusView: autoFocusView })=>{
    const pickerValueResponse = (0, $eda9673cfde850e1$export$799b22a7b7fffaa3)({
        props: props,
        valueManager: valueManager,
        valueType: valueType,
        wrapperVariant: wrapperVariant,
        validator: validator
    });
    const pickerViewsResponse = (0, $3267987ae58b71b9$export$c0a71b697a2df210)({
        props: props,
        inputRef: inputRef,
        additionalViewProps: additionalViewProps,
        autoFocusView: autoFocusView,
        propsFromPickerValue: pickerValueResponse.viewProps
    });
    const pickerLayoutResponse = (0, $89520527954c0483$export$4e5139e5825b7b27)({
        props: props,
        wrapperVariant: wrapperVariant,
        propsFromPickerValue: pickerValueResponse.layoutProps,
        propsFromPickerViews: pickerViewsResponse.layoutProps
    });
    return {
        // Picker value
        open: pickerValueResponse.open,
        actions: pickerValueResponse.actions,
        fieldProps: pickerValueResponse.fieldProps,
        // Picker views
        renderCurrentView: pickerViewsResponse.renderCurrentView,
        hasUIView: pickerViewsResponse.hasUIView,
        shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
        // Picker layout
        layoutProps: pickerLayoutResponse.layoutProps
    };
};




var $i5lfL = parcelRequire("i5lfL");

var $1Zx8l = parcelRequire("1Zx8l");


var $j7y1Z = parcelRequire("j7y1Z");

var $2ktY3 = parcelRequire("2ktY3");

var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
function $2c7838e2246a0935$export$1671c31de798d429(slot) {
    return (0, $6bbZp.default)('MuiPickersLayout', slot);
}
const $2c7838e2246a0935$export$7a6dac186703fe4c = (0, $47i1c.default)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'shortcuts'
]);



var $1CWiu = parcelRequire("1CWiu");
parcelRequire("i5lfL");


var $2ktY3 = parcelRequire("2ktY3");

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");
parcelRequire("i5lfL");





var $bHJbJ = parcelRequire("bHJbJ");
const $781a4fb649a34167$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
function $781a4fb649a34167$export$72ffda3bb7ecf665(props) {
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $7qXFD.default)(props, $781a4fb649a34167$var$_excluded);
    const localeText = (0, $c90bc5ca414ce17d$export$24fdeaa0f591a73e)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions == null ? void 0 : actions.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                    onClick: onClear,
                    children: localeText.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    children: localeText.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                    onClick: onAccept,
                    children: localeText.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                    onClick: onSetToday,
                    children: localeText.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $0d4f9b05ed57077c$export$2e2bcd8739ae039), (0, $1CWiu.default)({}, other, {
        children: buttons
    }));
}




var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");
parcelRequire("i5lfL");



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");



var $8AHNG = parcelRequire("8AHNG");


var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");






var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $4df6e7f87d31b18a$export$5682c366c0c669d9(slot) {
    return (0, $6bbZp.default)('MuiListItem', slot);
}
const $4df6e7f87d31b18a$var$listItemClasses = (0, $47i1c.default)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
var $4df6e7f87d31b18a$export$2e2bcd8739ae039 = $4df6e7f87d31b18a$var$listItemClasses;



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $242c11e4b3c25771$export$c09531d8563c67a5(slot) {
    return (0, $6bbZp.default)('MuiListItemButton', slot);
}
const $242c11e4b3c25771$var$listItemButtonClasses = (0, $47i1c.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $242c11e4b3c25771$export$2e2bcd8739ae039 = $242c11e4b3c25771$var$listItemButtonClasses;



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");


var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $73b08811191c7412$export$ccdb26aeba48a86e(slot) {
    return (0, $6bbZp.default)('MuiListItemSecondaryAction', slot);
}
const $73b08811191c7412$var$listItemSecondaryActionClasses = (0, $47i1c.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $73b08811191c7412$export$2e2bcd8739ae039 = $73b08811191c7412$var$listItemSecondaryActionClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $0c334ed92c05ffcd$var$_excluded = [
    "className"
];
const $0c334ed92c05ffcd$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $73b08811191c7412$export$ccdb26aeba48a86e), classes);
};
const $0c334ed92c05ffcd$var$ListItemSecondaryActionRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $0c334ed92c05ffcd$var$ListItemSecondaryAction = /*#__PURE__*/ $i5lfL.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $7qXFD.default)(props, $0c334ed92c05ffcd$var$_excluded);
    const context = $i5lfL.useContext((0, $5f2cac3e7c0585d2$export$2e2bcd8739ae039));
    const ownerState = (0, $1CWiu.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $0c334ed92c05ffcd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($0c334ed92c05ffcd$var$ListItemSecondaryActionRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$0c334ed92c05ffcd$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $0c334ed92c05ffcd$export$2e2bcd8739ae039 = $0c334ed92c05ffcd$var$ListItemSecondaryAction;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $e13b20064d865a4f$var$_excluded = [
    "className"
], $e13b20064d865a4f$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $e13b20064d865a4f$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $e13b20064d865a4f$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $4df6e7f87d31b18a$export$5682c366c0c669d9), classes);
};
const $e13b20064d865a4f$export$aed538f7519abe89 = (0, $j7y1Z.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $e13b20064d865a4f$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, $1CWiu.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $242c11e4b3c25771$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $4df6e7f87d31b18a$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $4df6e7f87d31b18a$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8AHNG.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $4df6e7f87d31b18a$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8AHNG.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $4df6e7f87d31b18a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $4df6e7f87d31b18a$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8AHNG.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8AHNG.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $e13b20064d865a4f$var$ListItemContainer = (0, $j7y1Z.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $e13b20064d865a4f$var$ListItem = /*#__PURE__*/ $i5lfL.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $7qXFD.default)(props.ContainerProps, $e13b20064d865a4f$var$_excluded), other = (0, $7qXFD.default)(props, $e13b20064d865a4f$var$_excluded2);
    const context = $i5lfL.useContext((0, $5f2cac3e7c0585d2$export$2e2bcd8739ae039));
    const childContext = $i5lfL.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $i5lfL.useRef(null);
    (0, $946b6dd96ae69a8b$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $i5lfL.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $20589bf20977e1b2$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $1CWiu.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $e13b20064d865a4f$var$useUtilityClasses(ownerState);
    const handleRef = (0, $62d6b27df8327466$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $e13b20064d865a4f$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $kRbLW.default)((0, $4df6e7f87d31b18a$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $07a3ed667acb77f6$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $5f2cac3e7c0585d2$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)($e13b20064d865a4f$var$ListItemContainer, (0, $1CWiu.default)({
                as: ContainerComponent,
                className: (0, $kRbLW.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)(Root, (0, $1CWiu.default)({}, rootProps, !(0, $d7066316d4f9103f$export$2e2bcd8739ae039)(Root) && {
                        as: Component,
                        ownerState: (0, $1CWiu.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $5f2cac3e7c0585d2$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)(Root, (0, $1CWiu.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $d7066316d4f9103f$export$2e2bcd8739ae039)(Root) && {
            ownerState: (0, $1CWiu.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $0c334ed92c05ffcd$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $e13b20064d865a4f$export$2e2bcd8739ae039 = $e13b20064d865a4f$var$ListItem;



const $12b5e0d6cb728eae$export$3f0060ce4cc8f4d0 = 36;
const $12b5e0d6cb728eae$export$dde58b009b497666 = 2;
const $12b5e0d6cb728eae$export$ee46b8a74d6c94d3 = 320;
const $12b5e0d6cb728eae$export$f2fef360e2df0cb7 = 358;
const $12b5e0d6cb728eae$export$1c2eabda4acea0e4 = 232;
const $12b5e0d6cb728eae$export$a462ceb9cfdb5d71 = 48;



var $bHJbJ = parcelRequire("bHJbJ");
const $53b9a2163e659c62$var$_excluded = [
    "items",
    "changeImportance",
    "isLandscape",
    "onChange",
    "isValid"
];
function $53b9a2163e659c62$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance, onChange: onChange, isValid: isValid } = props, other = (0, $7qXFD.default)(props, $53b9a2163e659c62$var$_excluded);
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((item)=>{
        const newValue = item.getValue({
            isValid: isValid
        });
        return {
            label: item.label,
            onClick: ()=>{
                onChange(newValue, changeImportance);
            },
            disabled: !isValid(newValue)
        };
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $2d146a5b562efa19$export$2e2bcd8739ae039), (0, $1CWiu.default)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $12b5e0d6cb728eae$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $e13b20064d865a4f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $8a1b9da49508a793$export$2e2bcd8739ae039), (0, $1CWiu.default)({}, item))
            }, item.label);
        })
    }));
}




var $bHJbJ = parcelRequire("bHJbJ");
function $1c2717d5fd4811ee$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $1c2717d5fd4811ee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $2c7838e2246a0935$export$1671c31de798d429), classes);
};
const $1c2717d5fd4811ee$var$usePickerLayout = (props)=>{
    var _slots$actionBar, _slots$shortcuts;
    const { wrapperVariant: wrapperVariant, onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, view: view, views: views, onViewChange: onViewChange, value: value, onChange: onChange, onSelectShortcut: onSelectShortcut, isValid: isValid, isLandscape: isLandscape, disabled: disabled, readOnly: readOnly, children: children, components: components, componentsProps: componentsProps, slots: innerSlots, slotProps: innerSlotProps } = props;
    const slots = innerSlots != null ? innerSlots : (0, $920c17a093fe7370$export$ee17bc394843b249)(components);
    const slotProps = innerSlotProps != null ? innerSlotProps : componentsProps;
    const classes = $1c2717d5fd4811ee$var$useUtilityClasses(props);
    // Action bar
    const ActionBar = (_slots$actionBar = slots == null ? void 0 : slots.actionBar) != null ? _slots$actionBar : (0, $781a4fb649a34167$export$72ffda3bb7ecf665);
    const actionBarProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: ActionBar,
        externalSlotProps: slotProps == null ? void 0 : slotProps.actionBar,
        additionalProps: {
            onAccept: onAccept,
            onClear: onClear,
            onCancel: onCancel,
            onSetToday: onSetToday,
            actions: wrapperVariant === 'desktop' ? [] : [
                'cancel',
                'accept'
            ],
            className: classes.actionBar
        },
        ownerState: (0, $1CWiu.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const actionBar = /*#__PURE__*/ (0, $bHJbJ.jsx)(ActionBar, (0, $1CWiu.default)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots == null ? void 0 : slots.toolbar;
    const toolbarProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: Toolbar,
        externalSlotProps: slotProps == null ? void 0 : slotProps.toolbar,
        additionalProps: {
            isLandscape: isLandscape,
            onChange: onChange,
            value: value,
            view: view,
            onViewChange: onViewChange,
            views: views,
            disabled: disabled,
            readOnly: readOnly,
            className: classes.toolbar
        },
        ownerState: (0, $1CWiu.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const toolbar = $1c2717d5fd4811ee$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $bHJbJ.jsx)(Toolbar, (0, $1CWiu.default)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots == null ? void 0 : slots.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $bHJbJ.jsx)(Tabs, (0, $1CWiu.default)({
        view: view,
        onViewChange: onViewChange
    }, slotProps == null ? void 0 : slotProps.tabs)) : null;
    // Shortcuts
    const Shortcuts = (_slots$shortcuts = slots == null ? void 0 : slots.shortcuts) != null ? _slots$shortcuts : (0, $53b9a2163e659c62$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: Shortcuts,
        externalSlotProps: slotProps == null ? void 0 : slotProps.shortcuts,
        additionalProps: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts
        },
        ownerState: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts,
            wrapperVariant: wrapperVariant
        }
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $bHJbJ.jsx)(Shortcuts, (0, $1CWiu.default)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts
    };
};
var $1c2717d5fd4811ee$export$2e2bcd8739ae039 = $1c2717d5fd4811ee$var$usePickerLayout;



var $bHJbJ = parcelRequire("bHJbJ");
const $928eedb2774e969a$var$useUtilityClasses = (ownerState)=>{
    const { isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $2c7838e2246a0935$export$1671c31de798d429), classes);
};
const $928eedb2774e969a$export$9a9363506c13836 = (0, $j7y1Z.default)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>({
        display: 'grid',
        gridAutoColumns: 'max-content auto max-content',
        gridAutoRows: 'max-content auto max-content',
        [`& .${(0, $2c7838e2246a0935$export$7a6dac186703fe4c).toolbar}`]: ownerState.isLandscape ? {
            gridColumn: theme.direction === 'rtl' ? 3 : 1,
            gridRow: '2 / 3'
        } : {
            gridColumn: '2 / 4',
            gridRow: 1
        },
        [`.${(0, $2c7838e2246a0935$export$7a6dac186703fe4c).shortcuts}`]: ownerState.isLandscape ? {
            gridColumn: '2 / 4',
            gridRow: 1
        } : {
            gridColumn: theme.direction === 'rtl' ? 3 : 1,
            gridRow: '2 / 3'
        },
        [`& .${(0, $2c7838e2246a0935$export$7a6dac186703fe4c).actionBar}`]: {
            gridColumn: '1 / 4',
            gridRow: 3
        }
    }));
$928eedb2774e969a$export$9a9363506c13836.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).shape({
        isLandscape: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool.isRequired
    }).isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object
    ])
};
const $928eedb2774e969a$export$bc1494d918129235 = (0, $j7y1Z.default)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper',
    overridesResolver: (props, styles)=>styles.contentWrapper
})({
    gridColumn: 2,
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
const $928eedb2774e969a$export$647f604ea2397c05 = function PickersLayout(inProps) {
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts } = (0, $1c2717d5fd4811ee$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, ref: ref, wrapperVariant: wrapperVariant } = props;
    const ownerState = props;
    const classes = $928eedb2774e969a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($928eedb2774e969a$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(className, classes.root),
        ownerState: ownerState,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $bHJbJ.jsx)($928eedb2774e969a$export$bc1494d918129235, {
                className: classes.contentWrapper,
                children: wrapperVariant === 'desktop' ? /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
};



var $bHJbJ = parcelRequire("bHJbJ");
const $46abdec7cdeae39b$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
], $46abdec7cdeae39b$var$_excluded2 = [
    "ownerState"
], $46abdec7cdeae39b$var$_excluded3 = [
    "ownerState"
];
const $46abdec7cdeae39b$export$b1b70bc56ac5be0e = (_ref)=>{
    var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$inputAdornment, _slots$openPickerButt, _slots$layout;
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $7qXFD.default)(_ref, $46abdec7cdeae39b$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, timezone: timezone, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, localeText: localeText } = props;
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const internalInputRef = $i5lfL.useRef(null);
    const containerRef = $i5lfL.useRef(null);
    const labelId = (0, $f3f83812f7a42248$export$2e2bcd8739ae039)();
    const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null ? void 0 : (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
    const { open: open, actions: actions, hasUIView: hasUIView, layoutProps: layoutProps, renderCurrentView: renderCurrentView, shouldRestoreFocus: shouldRestoreFocus, fieldProps: pickerFieldProps } = (0, $a2e4a41b6580a3be$export$fc3313977ac596c4)((0, $1CWiu.default)({}, pickerParams, {
        props: props,
        inputRef: internalInputRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'desktop'
    }));
    const InputAdornment = (_slots$inputAdornment = slots.inputAdornment) != null ? _slots$inputAdornment : (0, $b99dc77e886c5558$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: InputAdornment,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.inputAdornment,
        additionalProps: {
            position: 'end'
        },
        ownerState: props
    }), inputAdornmentProps = (0, $7qXFD.default)(_useSlotProps, $46abdec7cdeae39b$var$_excluded2);
    const OpenPickerButton = (_slots$openPickerButt = slots.openPickerButton) != null ? _slots$openPickerButt : (0, $600c8be2a4008660$export$2e2bcd8739ae039);
    const _useSlotProps2 = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: OpenPickerButton,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.openPickerButton,
        additionalProps: {
            disabled: disabled || readOnly,
            onClick: actions.onOpen,
            'aria-label': getOpenDialogAriaText(pickerFieldProps.value, utils),
            edge: inputAdornmentProps.position
        },
        ownerState: props
    }), openPickerButtonProps = (0, $7qXFD.default)(_useSlotProps2, $46abdec7cdeae39b$var$_excluded3);
    const OpenPickerIcon = slots.openPickerIcon;
    const Field = slots.field;
    const fieldProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: Field,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
        additionalProps: (0, $1CWiu.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, {
            readOnly: readOnly,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            timezone: timezone,
            label: label,
            autoFocus: autoFocus && !props.open,
            focused: open ? true : undefined
        }),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    if (hasUIView) fieldProps.InputProps = (0, $1CWiu.default)({}, fieldProps.InputProps, {
        ref: containerRef,
        [`${inputAdornmentProps.position}Adornment`]: /*#__PURE__*/ (0, $bHJbJ.jsx)(InputAdornment, (0, $1CWiu.default)({}, inputAdornmentProps, {
            children: /*#__PURE__*/ (0, $bHJbJ.jsx)(OpenPickerButton, (0, $1CWiu.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)(OpenPickerIcon, (0, $1CWiu.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.openPickerIcon))
            }))
        }))
    });
    const slotsForField = (0, $1CWiu.default)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : (0, $928eedb2774e969a$export$647f604ea2397c05);
    const handleInputRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(internalInputRef, fieldProps.inputRef, inputRef);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $1CWiu.default)({}, innerSlotProps, {
        toolbar: (0, $1CWiu.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        popper: (0, $1CWiu.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps == null ? void 0 : innerSlotProps.popper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $295315439c6d861c$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $bHJbJ.jsx)(Field, (0, $1CWiu.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    inputRef: handleInputRef
                })),
                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $802cc071c0b5a230$export$96ce8482474de8a5), (0, $1CWiu.default)({
                    role: "dialog",
                    placement: "bottom-start",
                    anchorEl: containerRef.current
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)(Layout, (0, $1CWiu.default)({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};



var $gVCC4 = parcelRequire("gVCC4");

var $i5lfL = parcelRequire("i5lfL");

var $bHJbJ = parcelRequire("bHJbJ");
const $1732d580053861dc$export$ed0fe318cc298673 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const $1732d580053861dc$export$8afed21ef5c2afa5 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const $1732d580053861dc$export$9ca09caa9c849d9c = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const $1732d580053861dc$export$5fda1783bb83f57b = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
const $1732d580053861dc$export$8099ab97743c966c = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
    children: [
        /*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const $1732d580053861dc$export$90a8eab2a2411720 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const $1732d580053861dc$export$7e95adcf912503e3 = (0, $gVCC4.default)(/*#__PURE__*/ (0, $bHJbJ.jsxs)($i5lfL.Fragment, {
    children: [
        /*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");





var $1CWiu = parcelRequire("1CWiu");


var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");








var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");






const $af92db3580b781fa$export$4e8d6353e50062e7 = (params)=>{
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const localeText = (0, $c90bc5ca414ce17d$export$24fdeaa0f591a73e)();
    const adapter = (0, $c90bc5ca414ce17d$export$4b5a24245de9f7f9)();
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const { valueManager: valueManager, fieldValueManager: fieldValueManager, valueType: valueType, validator: validator, internalProps: internalProps, internalProps: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp } } = params;
    const { timezone: timezone, value: valueFromTheOutside, handleValueChange: handleValueChange } = (0, $a7ba2c812e4f48ce$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    const sectionsValueBoundaries = $i5lfL.useMemo(()=>(0, $a5f3825a9de04fb0$export$360600f456ea7d5f)(utils, timezone), [
        utils,
        timezone
    ]);
    const getSectionsFromValue = $i5lfL.useCallback((value, fallbackSections = null)=>fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, isRTL, (date)=>(0, $a5f3825a9de04fb0$export$fd71d82fe42bada1)(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)), [
        fieldValueManager,
        format,
        localeText,
        isRTL,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        timezone
    ]);
    const placeholder = $i5lfL.useMemo(()=>fieldValueManager.getValueStrFromSections(getSectionsFromValue(valueManager.emptyValue), isRTL), [
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        isRTL
    ]);
    const [state, setState] = $i5lfL.useState(()=>{
        const sections = getSectionsFromValue(valueFromTheOutside);
        (0, $a5f3825a9de04fb0$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            value: valueFromTheOutside,
            referenceValue: valueManager.emptyValue,
            tempValueStrAndroid: null
        };
        const granularity = (0, $12ddf67933ed7c3a$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: valueFromTheOutside,
            utils: utils,
            props: internalProps,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $1CWiu.default)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $50778d58d10a200e$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSectionIndexes'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
        setState((prevState)=>(0, $1CWiu.default)({}, prevState, {
                selectedSectionQuery: null
            }));
    };
    const selectedSectionIndexes = $i5lfL.useMemo(()=>{
        if (selectedSections == null) return null;
        if (selectedSections === 'all') return {
            startIndex: 0,
            endIndex: state.sections.length - 1,
            shouldSelectBoundarySelectors: true
        };
        if (typeof selectedSections === 'number') return {
            startIndex: selectedSections,
            endIndex: selectedSections
        };
        if (typeof selectedSections === 'string') {
            const selectedSectionIndex = state.sections.findIndex((section)=>section.type === selectedSections);
            return {
                startIndex: selectedSectionIndex,
                endIndex: selectedSectionIndex
            };
        }
        return selectedSections;
    }, [
        selectedSections,
        state.sections
    ]);
    const publishValue = ({ value: value, referenceValue: referenceValue, sections: sections })=>{
        setState((prevState)=>(0, $1CWiu.default)({}, prevState, {
                sections: sections,
                value: value,
                referenceValue: referenceValue,
                tempValueStrAndroid: null
            }));
        const context = {
            validationError: validator({
                adapter: adapter,
                value: value,
                props: (0, $1CWiu.default)({}, internalProps, {
                    value: value,
                    timezone: timezone
                })
            })
        };
        handleValueChange(value, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $1CWiu.default)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return (0, $a5f3825a9de04fb0$export$8bb5d1c9951d10ca)(newSections, isRTL);
    };
    const clearValue = ()=>{
        if (valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue)) return;
        publishValue({
            value: valueManager.emptyValue,
            referenceValue: state.referenceValue,
            sections: getSectionsFromValue(valueManager.emptyValue)
        });
    };
    const clearActiveSection = ()=>{
        if (selectedSectionIndexes == null) return;
        const activeSection = state.sections[selectedSectionIndexes.startIndex];
        if (activeSection.value === '') return;
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section)=>section.value !== '').length;
        const isTheOnlyNonEmptySection = nonEmptySectionCountBefore === 1;
        const newSections = setSectionValue(selectedSectionIndexes.startIndex, '');
        const newActiveDate = isTheOnlyNonEmptySection ? null : utils.date(new Date(''));
        const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
        if ((newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date))) publishValue((0, $1CWiu.default)({}, newValues, {
            sections: newSections
        }));
        else setState((prevState)=>(0, $1CWiu.default)({}, prevState, newValues, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (date == null || !utils.isValid(date)) return null;
            const sections = (0, $a5f3825a9de04fb0$export$fd71d82fe42bada1)(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL);
            return (0, $a5f3825a9de04fb0$export$6c6df982c77f60a9)(utils, timezone, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
        publishValue({
            value: newValue,
            referenceValue: newReferenceValue,
            sections: getSectionsFromValue(newValue, state.sections)
        });
    };
    const updateSectionValue = ({ activeSection: activeSection, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        /**
     * 1. Decide which section should be focused
     */ if (shouldGoToNextSection && selectedSectionIndexes && selectedSectionIndexes.startIndex < state.sections.length - 1) setSelectedSections(selectedSectionIndexes.startIndex + 1);
        else if (selectedSectionIndexes && selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.startIndex);
        /**
     * 2. Try to build a valid date from the new section value
     */ const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSections = setSectionValue(selectedSectionIndexes.startIndex, newSectionValue);
        const newActiveDateSections = activeDateManager.getSections(newSections);
        let newActiveDate = (0, $a5f3825a9de04fb0$export$b0c1bfd065bfe742)(utils, newActiveDateSections);
        let shouldRegenSections = false;
        /**
     * If the date is invalid,
     * Then we can try to clamp the day section to see if that produces a valid date.
     * This can be useful if the month has fewer days than the day value currently provided.
     */ if (!utils.isValid(newActiveDate)) {
            const clampedSections = (0, $a5f3825a9de04fb0$export$c7a10a3e9bfc3786)(utils, timezone, newActiveDateSections, sectionsValueBoundaries);
            if (clampedSections != null) {
                shouldRegenSections = true;
                newActiveDate = (0, $a5f3825a9de04fb0$export$b0c1bfd065bfe742)(utils, clampedSections);
            }
        }
        let values;
        let shouldPublish;
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (newActiveDate != null && utils.isValid(newActiveDate)) {
            const mergedDate = (0, $a5f3825a9de04fb0$export$6c6df982c77f60a9)(utils, timezone, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
            values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
            shouldPublish = true;
        } else {
            values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
            shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
        }
        /**
     * If the value has been modified (to clamp the day).
     * Then we need to re-generate the sections to make sure they also have this change.
     */ const sections = shouldRegenSections ? getSectionsFromValue(values.value, state.sections) : newSections;
        /**
     * Publish or update the internal state with the new value and sections.
     */ if (shouldPublish) return publishValue((0, $1CWiu.default)({}, values, {
            sections: sections
        }));
        return setState((prevState)=>(0, $1CWiu.default)({}, prevState, values, {
                sections: sections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prev)=>(0, $1CWiu.default)({}, prev, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    $i5lfL.useEffect(()=>{
        let shouldUpdate = false;
        if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) shouldUpdate = true;
        else shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
        if (shouldUpdate) setState((prevState)=>(0, $1CWiu.default)({}, prevState, {
                value: valueFromTheOutside,
                referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
                sections: getSectionsFromValue(valueFromTheOutside)
            }));
    }, [
        valueFromTheOutside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $i5lfL.useEffect(()=>{
        const sections = getSectionsFromValue(state.value);
        (0, $a5f3825a9de04fb0$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $1CWiu.default)({}, prevState, {
                sections: sections
            }));
    }, [
        format,
        utils.locale
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        state: state,
        selectedSectionIndexes: selectedSectionIndexes,
        setSelectedSections: setSelectedSections,
        clearValue: clearValue,
        clearActiveSection: clearActiveSection,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        setTempAndroidValueStr: setTempAndroidValueStr,
        sectionsValueBoundaries: sectionsValueBoundaries,
        placeholder: placeholder,
        timezone: timezone
    };
};



var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");



/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ const $e816f7bd49439400$var$QUERY_LIFE_DURATION_MS = 5000;
const $e816f7bd49439400$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $e816f7bd49439400$export$66d00048b8bb82f6 = ({ sections: sections, updateSectionValue: updateSectionValue, sectionsValueBoundaries: sectionsValueBoundaries, setTempAndroidValueStr: setTempAndroidValueStr, timezone: timezone })=>{
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const [query, setQuery] = $i5lfL.useState(null);
    const resetQuery = (0, $49175dc6d5053977$export$2e2bcd8739ae039)(()=>setQuery(null));
    $i5lfL.useEffect(()=>{
        var _sections$query$secti;
        if (query != null && ((_sections$query$secti = sections[query.sectionIndex]) == null ? void 0 : _sections$query$secti.type) !== query.sectionType) resetQuery();
    }, [
        sections,
        query,
        resetQuery
    ]);
    $i5lfL.useEffect(()=>{
        if (query != null) {
            const timeout = setTimeout(()=>resetQuery(), $e816f7bd49439400$var$QUERY_LIFE_DURATION_MS);
            return ()=>{
                window.clearTimeout(timeout);
            };
        }
        return ()=>{};
    }, [
        query,
        resetQuery
    ]);
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenated value
        if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$e816f7bd49439400$var$isQueryResponseWithoutValue(queryResponse)) {
                setQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($e816f7bd49439400$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            resetQuery();
            return null;
        }
        setQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($e816f7bd49439400$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $a5f3825a9de04fb0$export$3ee1e7e19c2b047a)(utils, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $a5f3825a9de04fb0$export$2f3c5fac7a2a65f6)(utils, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($e816f7bd49439400$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $1CWiu.default)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $a5f3825a9de04fb0$export$2816862a602354ce)(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = (queryValue, section)=>{
            const queryValueNumber = Number(`${queryValue}`);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = Number(`${queryValue}0`) > sectionBoundaries.maximum || queryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $a5f3825a9de04fb0$export$ef88db4bceade9fd)(utils, timezone, queryValueNumber, sectionBoundaries, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue(queryValue, activeSection);
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, $a5f3825a9de04fb0$export$78b5830e2dd2de49)(utils, timezone, 'digit', 'month', 'MM');
                const response = getNewSectionValue(queryValue, {
                    type: activeSection.type,
                    format: 'MM',
                    hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                    hasLeadingZerosInInput: true,
                    contentType: 'digit',
                    maxLength: 2
                });
                if ($e816f7bd49439400$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $a5f3825a9de04fb0$export$2816862a602354ce)(utils, response.sectionValue, 'MM', activeSection.format);
                return (0, $1CWiu.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue(queryValue, activeSection);
                if ($e816f7bd49439400$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $a5f3825a9de04fb0$export$c65c7173f879039f)(utils, timezone, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $1CWiu.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>!Number.isNaN(Number(queryValue)));
    };
    const applyCharacterEditing = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((params)=>{
        const activeSection = sections[params.sectionIndex];
        const isNumericEditing = !Number.isNaN(Number(params.keyPressed));
        const response = isNumericEditing ? applyNumericEditing(params) : applyLetterEditing(params);
        if (response == null) setTempAndroidValueStr(null);
        else updateSectionValue({
            activeSection: activeSection,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
    return {
        applyCharacterEditing: applyCharacterEditing,
        resetCharacterQuery: resetQuery
    };
};



const $466b1e1857f4aad9$var$_excluded = [
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onMouseUp",
    "onPaste",
    "error"
];
const $466b1e1857f4aad9$export$294aa081a6c6f55d = (params)=>{
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const { state: state, selectedSectionIndexes: selectedSectionIndexes, setSelectedSections: setSelectedSections, clearValue: clearValue, clearActiveSection: clearActiveSection, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, setTempAndroidValueStr: setTempAndroidValueStr, sectionsValueBoundaries: sectionsValueBoundaries, placeholder: placeholder, timezone: timezone } = (0, $af92db3580b781fa$export$4e8d6353e50062e7)(params);
    const { inputRef: inputRefProp, internalProps: internalProps, internalProps: { readOnly: readOnly = false, unstableFieldRef: unstableFieldRef, minutesStep: minutesStep }, forwardedProps: { onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onMouseUp: onMouseUp, onPaste: onPaste, error: error }, fieldValueManager: fieldValueManager, valueManager: valueManager, validator: validator } = params, otherForwardedProps = (0, $7qXFD.default)(params.forwardedProps, $466b1e1857f4aad9$var$_excluded);
    const { applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery } = (0, $e816f7bd49439400$export$66d00048b8bb82f6)({
        sections: state.sections,
        updateSectionValue: updateSectionValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        setTempAndroidValueStr: setTempAndroidValueStr,
        timezone: timezone
    });
    const inputRef = $i5lfL.useRef(null);
    const handleRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(inputRefProp, inputRef);
    const focusTimeoutRef = $i5lfL.useRef(undefined);
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const sectionOrder = $i5lfL.useMemo(()=>(0, $a5f3825a9de04fb0$export$7725fd6fe0a2aadf)(state.sections, isRTL), [
        state.sections,
        isRTL
    ]);
    const syncSelectionFromDOM = ()=>{
        var _selectionStart;
        if (readOnly) {
            setSelectedSections(null);
            return;
        }
        const browserStartIndex = (_selectionStart = inputRef.current.selectionStart) != null ? _selectionStart : 0;
        let nextSectionIndex;
        if (browserStartIndex <= state.sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= state.sections[state.sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = state.sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    };
    const handleInputClick = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((...args)=>{
        onClick == null || onClick(...args);
        syncSelectionFromDOM();
    });
    const handleInputMouseUp = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event)=>{
        onMouseUp == null || onMouseUp(event);
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handleInputFocus = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((...args)=>{
        onFocus == null || onFocus(...args);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        window.clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (selectedSectionIndexes != null || readOnly) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputBlur = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((...args)=>{
        onBlur == null || onBlur(...args);
        setSelectedSections(null);
    });
    const handleInputPaste = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event)=>{
        onPaste == null || onPaste(event);
        if (readOnly) {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        if (selectedSectionIndexes && selectedSectionIndexes.startIndex === selectedSectionIndexes.endIndex) {
            const activeSection = state.sections[selectedSectionIndexes.startIndex];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
            if (isValidPastedValue) // Early return to let the paste update section, value
            return;
            if (lettersOnly || digitsOnly) {
                // The pasted value correspond to a single section but not the expected type
                // skip the modification
                event.preventDefault();
                return;
            }
        }
        event.preventDefault();
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleInputChange = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event)=>{
        if (readOnly) return;
        const valueStr = event.target.value;
        const cleanValueStr = (0, $a5f3825a9de04fb0$export$cb0bbc88c7f09596)(valueStr);
        // If no section is selected, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (selectedSectionIndexes == null) {
            updateValueFromValueStr(cleanValueStr);
            return;
        }
        let keyPressed;
        if (selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1 && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = (0, $a5f3825a9de04fb0$export$cb0bbc88c7f09596)(fieldValueManager.getValueStrFromSections(state.sections, isRTL));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = state.sections[selectedSectionIndexes.startIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - (0, $a5f3825a9de04fb0$export$cb0bbc88c7f09596)(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + (0, $a5f3825a9de04fb0$export$cb0bbc88c7f09596)(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if ((0, $a5f3825a9de04fb0$export$a11b0059900ceec8)() && keyPressed.length === 0) {
            setTempAndroidValueStr(valueStr);
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: selectedSectionIndexes.startIndex
        });
    });
    const handleInputKeyDown = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event)=>{
        onKeyDown == null || onKeyDown(event);
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case event.key === 'a' && (event.ctrlKey || event.metaKey):
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (selectedSectionIndexes == null) setSelectedSections(sectionOrder.startIndex);
                else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (selectedSectionIndexes == null) setSelectedSections(sectionOrder.endIndex);
                else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case [
                'Backspace',
                'Delete'
            ].includes(event.key):
                event.preventDefault();
                if (readOnly) break;
                if (selectedSectionIndexes == null || selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1) clearValue();
                else clearActiveSection();
                resetCharacterQuery();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || selectedSectionIndexes == null) break;
                    const activeSection = state.sections[selectedSectionIndexes.startIndex];
                    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
                    const newSectionValue = (0, $a5f3825a9de04fb0$export$5ed0f22513e58fe3)(utils, timezone, activeSection, event.key, sectionsValueBoundaries, activeDateManager.date, {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        activeSection: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        if (!inputRef.current) return;
        if (selectedSectionIndexes == null) {
            if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
            // setting selection range to 0 causes issues in Safari.
            // https://bugs.webkit.org/show_bug.cgi?id=224425
            inputRef.current.scrollLeft = 0;
            return;
        }
        const firstSelectedSection = state.sections[selectedSectionIndexes.startIndex];
        const lastSelectedSection = state.sections[selectedSectionIndexes.endIndex];
        let selectionStart = firstSelectedSection.startInInput;
        let selectionEnd = lastSelectedSection.endInInput;
        if (selectedSectionIndexes.shouldSelectBoundarySelectors) {
            selectionStart -= firstSelectedSection.startSeparator.length;
            selectionEnd += lastSelectedSection.endSeparator.length;
        }
        if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
            // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
            const currentScrollTop = inputRef.current.scrollTop;
            // On multi input range pickers we want to update selection range only for the active input
            // This helps avoiding the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
            // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
            if (inputRef.current === (0, $e4fe91f37783b274$export$cd4e5573fbe2b576)(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
            // Even reading this variable seems to do the trick, but also setting it just to make use of it
            inputRef.current.scrollTop = currentScrollTop;
        }
    });
    const validationError = (0, $e06ee6eac83d7a77$export$87fe492f99f25a20)((0, $1CWiu.default)({}, internalProps, {
        value: state.value,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const inputError = $i5lfL.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (error !== undefined) return error;
        return valueManager.hasError(validationError);
    }, [
        valueManager,
        validationError,
        error
    ]);
    $i5lfL.useEffect(()=>{
        if (!inputError && !selectedSectionIndexes) resetCharacterQuery();
    }, [
        state.referenceValue,
        selectedSectionIndexes,
        inputError
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $i5lfL.useEffect(()=>{
        // Select the right section when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === document.activeElement) setSelectedSections('all');
        return ()=>window.clearTimeout(focusTimeoutRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // If `state.tempValueStrAndroid` is still defined when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $i5lfL.useEffect(()=>{
        if (state.tempValueStrAndroid != null && selectedSectionIndexes != null) {
            resetCharacterQuery();
            clearActiveSection();
        }
    }, [
        state.tempValueStrAndroid
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const valueStr = $i5lfL.useMemo(()=>{
        var _state$tempValueStrAn;
        return (_state$tempValueStrAn = state.tempValueStrAndroid) != null ? _state$tempValueStrAn : fieldValueManager.getValueStrFromSections(state.sections, isRTL);
    }, [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        isRTL
    ]);
    const inputMode = $i5lfL.useMemo(()=>{
        if (selectedSectionIndexes == null) return 'text';
        if (state.sections[selectedSectionIndexes.startIndex].contentType === 'letter') return 'text';
        return 'tel';
    }, [
        selectedSectionIndexes,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $e4fe91f37783b274$export$cd4e5573fbe2b576)(document);
    const shouldShowPlaceholder = !inputHasFocus && valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
    $i5lfL.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>{
                var _selectionStart2, _selectionEnd;
                const browserStartIndex = (_selectionStart2 = inputRef.current.selectionStart) != null ? _selectionStart2 : 0;
                const browserEndIndex = (_selectionEnd = inputRef.current.selectionEnd) != null ? _selectionEnd : 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= state.sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : state.sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
            },
            setSelectedSections: (activeSectionIndex)=>setSelectedSections(activeSectionIndex)
        }));
    return (0, $1CWiu.default)({
        placeholder: placeholder,
        autoComplete: 'off'
    }, otherForwardedProps, {
        value: shouldShowPlaceholder ? '' : valueStr,
        inputMode: inputMode,
        readOnly: readOnly,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onBlur: handleInputBlur,
        onPaste: handleInputPaste,
        onChange: handleInputChange,
        onKeyDown: handleInputKeyDown,
        onMouseUp: handleInputMouseUp,
        error: inputError,
        ref: handleRef
    });
};






var $1CWiu = parcelRequire("1CWiu");
const $23413e35a3547781$export$430d9fc64cf058d6 = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const $23413e35a3547781$export$fd5e0f8b4115a8c7 = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableClock',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const $23413e35a3547781$export$1df62d3ba2121371 = [
    'minDateTime',
    'maxDateTime'
];
const $23413e35a3547781$var$VALIDATION_PROP_NAMES = [
    ...$23413e35a3547781$export$430d9fc64cf058d6,
    ...$23413e35a3547781$export$fd5e0f8b4115a8c7,
    ...$23413e35a3547781$export$1df62d3ba2121371
];
const $23413e35a3547781$export$5890f750904acddb = (props)=>$23413e35a3547781$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});


const $abd7ce156b45c907$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'readOnly',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef'
];
const $abd7ce156b45c907$export$cdde224d2939fd84 = (props, valueType)=>{
    const forwardedProps = (0, $1CWiu.default)({}, props);
    const internalProps = {};
    const extractProp = (propName)=>{
        if (forwardedProps.hasOwnProperty(propName)) {
            // @ts-ignore
            internalProps[propName] = forwardedProps[propName];
            delete forwardedProps[propName];
        }
    };
    $abd7ce156b45c907$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
    if (valueType === 'date') (0, $23413e35a3547781$export$430d9fc64cf058d6).forEach(extractProp);
    else if (valueType === 'time') (0, $23413e35a3547781$export$fd5e0f8b4115a8c7).forEach(extractProp);
    else if (valueType === 'date-time') {
        (0, $23413e35a3547781$export$430d9fc64cf058d6).forEach(extractProp);
        (0, $23413e35a3547781$export$fd5e0f8b4115a8c7).forEach(extractProp);
        (0, $23413e35a3547781$export$1df62d3ba2121371).forEach(extractProp);
    }
    return {
        forwardedProps: forwardedProps,
        internalProps: internalProps
    };
};


const $88a1f875fc8d5e08$var$useDefaultizedDateField = (props)=>{
    var _props$disablePast, _props$disableFuture, _props$format;
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const defaultDates = (0, $c90bc5ca414ce17d$export$7c38da3a2e90fa83)();
    return (0, $1CWiu.default)({}, props, {
        disablePast: (_props$disablePast = props.disablePast) != null ? _props$disablePast : false,
        disableFuture: (_props$disableFuture = props.disableFuture) != null ? _props$disableFuture : false,
        format: (_props$format = props.format) != null ? _props$format : utils.formats.keyboardDate,
        minDate: (0, $276f3a2cf1f0c279$export$eb73579ccade48fd)(utils, props.minDate, defaultDates.minDate),
        maxDate: (0, $276f3a2cf1f0c279$export$eb73579ccade48fd)(utils, props.maxDate, defaultDates.maxDate)
    });
};
const $88a1f875fc8d5e08$export$5591b0b878c1a989 = ({ props: inProps, inputRef: inputRef })=>{
    const props = $88a1f875fc8d5e08$var$useDefaultizedDateField(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $abd7ce156b45c907$export$cdde224d2939fd84)(props, 'date');
    return (0, $466b1e1857f4aad9$export$294aa081a6c6f55d)({
        inputRef: inputRef,
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $2fdbcdc4da212b5f$export$2764b246aa3b75ba),
        fieldValueManager: (0, $2fdbcdc4da212b5f$export$b602c94f557316b4),
        validator: (0, $704b91a9b8a06a25$export$ffb3d0046ef3a2),
        valueType: 'date'
    });
};



var $bHJbJ = parcelRequire("bHJbJ");
const $1c952b2a21596c3d$var$_excluded = [
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
], $1c952b2a21596c3d$var$_excluded2 = [
    "inputRef"
], $1c952b2a21596c3d$var$_excluded3 = [
    "ref",
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly"
];
const $1c952b2a21596c3d$export$d9781c7894a82487 = /*#__PURE__*/ $i5lfL.forwardRef(function DateField(inProps, ref) {
    var _ref, _slots$textField, _slotProps$textField;
    const themeProps = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDateField'
    });
    const { components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $7qXFD.default)(themeProps, $1c952b2a21596c3d$var$_excluded);
    const ownerState = themeProps;
    const TextField = (_ref = (_slots$textField = slots == null ? void 0 : slots.textField) != null ? _slots$textField : components == null ? void 0 : components.TextField) != null ? _ref : (0, $1817a2bcf8f12485$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: TextField,
        externalSlotProps: (_slotProps$textField = slotProps == null ? void 0 : slotProps.textField) != null ? _slotProps$textField : componentsProps == null ? void 0 : componentsProps.textField,
        externalForwardedProps: other,
        ownerState: ownerState
    }), { inputRef: externalInputRef } = _useSlotProps, textFieldProps = (0, $7qXFD.default)(_useSlotProps, $1c952b2a21596c3d$var$_excluded2);
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $1CWiu.default)({}, textFieldProps.inputProps, inputProps);
    textFieldProps.InputProps = (0, $1CWiu.default)({}, textFieldProps.InputProps, InputProps);
    const _useDateField = (0, $88a1f875fc8d5e08$export$5591b0b878c1a989)({
        props: textFieldProps,
        inputRef: externalInputRef
    }), { ref: inputRef, onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly } = _useDateField, fieldProps = (0, $7qXFD.default)(_useDateField, $1c952b2a21596c3d$var$_excluded3);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)(TextField, (0, $1CWiu.default)({
        ref: ref
    }, fieldProps, {
        InputProps: (0, $1CWiu.default)({}, fieldProps.InputProps, {
            readOnly: readOnly
        }),
        inputProps: (0, $1CWiu.default)({}, fieldProps.inputProps, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    }));
});



parcelRequire("i5lfL");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");



var $j7y1Z = parcelRequire("j7y1Z");

var $2ktY3 = parcelRequire("2ktY3");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $i5lfL = parcelRequire("i5lfL");


const $89abaff0dbdf0a9f$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $c90bc5ca414ce17d$export$4b5a24245de9f7f9)();
    return $i5lfL.useCallback((day)=>(0, $704b91a9b8a06a25$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast,
                timezone: timezone
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};





const $3dc53182873c50e4$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case 'changeMonth':
                return (0, $1CWiu.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case 'finishMonthSwitchingAnimation':
                return (0, $1CWiu.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case 'changeFocusedDay':
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $1CWiu.default)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
                    });
                }
            default:
                throw new Error('missing support');
        }
    };
const $3dc53182873c50e4$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, defaultCalendarMonth: defaultCalendarMonth, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone } = params;
    const now = (0, $c90bc5ca414ce17d$export$3a404aece3dff2fa)(timezone);
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const reducerFn = $i5lfL.useRef($3dc53182873c50e4$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const referenceDate = $i5lfL.useMemo(()=>{
        let externalReferenceDate = null;
        if (referenceDateProp) externalReferenceDate = referenceDateProp;
        else if (defaultCalendarMonth) // For `defaultCalendarMonth`, we just want to keep the month and the year to avoid a behavior change.
        externalReferenceDate = utils.startOfMonth(defaultCalendarMonth);
        return (0, $2fdbcdc4da212b5f$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            timezone: timezone,
            props: params,
            referenceDate: externalReferenceDate,
            granularity: (0, $12ddf67933ed7c3a$export$8f74e8f4ed8ae0ac).day
        });
    }, [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const [calendarState, dispatch] = $i5lfL.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: value || now,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: 'left'
    });
    const handleChangeMonth = $i5lfL.useCallback((payload)=>{
        dispatch((0, $1CWiu.default)({
            type: 'changeMonth'
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $i5lfL.useCallback((newDate)=>{
        const newDateRequested = newDate;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        utils
    ]);
    const isDateDisabled = (0, $89abaff0dbdf0a9f$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    const onMonthSwitchingAnimationEnd = $i5lfL.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    const changeFocusedDay = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: 'changeFocusedDay',
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    });
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};



parcelRequire("i5lfL");



var $j7y1Z = parcelRequire("j7y1Z");

var $2ktY3 = parcelRequire("2ktY3");


var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
const $51d71ebc1d292d57$export$5b0bb0174eb448ca = (slot)=>(0, $6bbZp.default)('MuiPickersFadeTransitionGroup', slot);
const $51d71ebc1d292d57$export$1461f245817ac559 = (0, $47i1c.default)('MuiPickersFadeTransitionGroup', [
    'root'
]);



var $bHJbJ = parcelRequire("bHJbJ");
const $c8e1faeb5fae48d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $51d71ebc1d292d57$export$5b0bb0174eb448ca), classes);
};
const $c8e1faeb5fae48d7$var$animationDuration = 500;
const $c8e1faeb5fae48d7$var$PickersFadeTransitionGroupRoot = (0, $j7y1Z.default)((0, $a25659da27a85057$export$2e2bcd8739ae039), {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'block',
    position: 'relative'
});
function $c8e1faeb5fae48d7$export$5262185daf493fee(inProps) {
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $c8e1faeb5fae48d7$var$useUtilityClasses(props);
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($c8e1faeb5fae48d7$var$PickersFadeTransitionGroupRoot, {
        className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(classes.root, className),
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $eb1f4c060c8a68ab$export$2e2bcd8739ae039), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: $c8e1faeb5fae48d7$var$animationDuration,
                enter: $c8e1faeb5fae48d7$var$animationDuration / 2,
                exit: 0
            },
            children: children
        }, transKey)
    });
}



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");




var $j7y1Z = parcelRequire("j7y1Z");

var $2ktY3 = parcelRequire("2ktY3");


var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");




var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");



var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
function $e909378dae2fbe01$export$4b25deb0350d3e53(slot) {
    return (0, $6bbZp.default)('MuiPickersDay', slot);
}
const $e909378dae2fbe01$export$68b221ad3c35e288 = (0, $47i1c.default)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);



var $bHJbJ = parcelRequire("bHJbJ");
const $bfb92354195d2465$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $bfb92354195d2465$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            selected && !isHiddenDaySpacingFiller && 'selected',
            disabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && today && 'today',
            outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $e909378dae2fbe01$export$4b25deb0350d3e53), classes);
};
const $bfb92354195d2465$var$styleArg = ({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({}, theme.typography.caption, {
        width: (0, $12b5e0d6cb728eae$export$3f0060ce4cc8f4d0),
        height: (0, $12b5e0d6cb728eae$export$3f0060ce4cc8f4d0),
        borderRadius: '50%',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $e909378dae2fbe01$export$68b221ad3c35e288).selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $e909378dae2fbe01$export$68b221ad3c35e288).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.short
            }),
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $e909378dae2fbe01$export$68b221ad3c35e288).disabled}:not(.${(0, $e909378dae2fbe01$export$68b221ad3c35e288).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $e909378dae2fbe01$export$68b221ad3c35e288).disabled}&.${(0, $e909378dae2fbe01$export$68b221ad3c35e288).selected}`]: {
            opacity: 0.6
        }
    }, !ownerState.disableMargin && {
        margin: `0 ${0, $12b5e0d6cb728eae$export$dde58b009b497666}px`
    }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableHighlightToday && ownerState.today && {
        [`&:not(.${(0, $e909378dae2fbe01$export$68b221ad3c35e288).selected})`]: {
            border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
        }
    });
const $bfb92354195d2465$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $bfb92354195d2465$var$PickersDayRoot = (0, $j7y1Z.default)((0, $07a3ed667acb77f6$export$2e2bcd8739ae039), {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $bfb92354195d2465$var$overridesResolver
})($bfb92354195d2465$var$styleArg);
const $bfb92354195d2465$var$PickersDayFiller = (0, $j7y1Z.default)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $bfb92354195d2465$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $1CWiu.default)({}, $bfb92354195d2465$var$styleArg({
        theme: theme,
        ownerState: ownerState
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const $bfb92354195d2465$var$noop = ()=>{};
const $bfb92354195d2465$var$PickersDayRaw = /*#__PURE__*/ $i5lfL.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $bfb92354195d2465$var$noop, onBlur: onBlur = $bfb92354195d2465$var$noop, onKeyDown: onKeyDown = $bfb92354195d2465$var$noop, onMouseDown: onMouseDown = $bfb92354195d2465$var$noop, onMouseEnter: onMouseEnter = $bfb92354195d2465$var$noop, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $7qXFD.default)(props, $bfb92354195d2465$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $bfb92354195d2465$var$useUtilityClasses(ownerState);
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const ref = $i5lfL.useRef(null);
    const handleRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For day outside of current month, move focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $bHJbJ.jsx)($bfb92354195d2465$var$PickersDayFiller, {
        className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($bfb92354195d2465$var$PickersDayRoot, (0, $1CWiu.default)({
        className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: !children ? utils.format(day, 'dayOfMonth') : children
    }));
});
const $bfb92354195d2465$export$d7378e6e864346fa = /*#__PURE__*/ $i5lfL.memo($bfb92354195d2465$var$PickersDayRaw);





var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $j7y1Z = parcelRequire("j7y1Z");

var $2ktY3 = parcelRequire("2ktY3");

var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $c47fbb79743c5e1f$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $8fb01b208f3a1b1c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $c47fbb79743c5e1f$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $4383b1ff1315e4e2$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $4383b1ff1315e4e2$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $4383b1ff1315e4e2$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $4383b1ff1315e4e2$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $i5lfL = parcelRequire("i5lfL");



var $7c29585abad5bdf6$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $8fb01b208f3a1b1c$export$2e2bcd8739ae039)(node, c);
    });
};
var $7c29585abad5bdf6$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $4383b1ff1315e4e2$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $7c29585abad5bdf6$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $25ad3ce036029841$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $ede516df8a9d81b6$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $7c29585abad5bdf6$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $7c29585abad5bdf6$var$removeClass(node, baseClassName);
        if (activeClassName) $7c29585abad5bdf6$var$removeClass(node, activeClassName);
        if (doneClassName) $7c29585abad5bdf6$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $7qXFD.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement((0, $3011cc386e359a11$export$2e2bcd8739ae039), (0, $1CWiu.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).Component);
$7c29585abad5bdf6$var$CSSTransition.defaultProps = {
    classNames: ''
};
$7c29585abad5bdf6$var$CSSTransition.propTypes = {};
var $7c29585abad5bdf6$export$2e2bcd8739ae039 = $7c29585abad5bdf6$var$CSSTransition;



var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
const $9af78cf14ed0072c$export$e98c1b6c3bbc3c59 = (slot)=>(0, $6bbZp.default)('MuiPickersSlideTransition', slot);
const $9af78cf14ed0072c$export$d251a58673156a67 = (0, $47i1c.default)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);



var $bHJbJ = parcelRequire("bHJbJ");
const $6b881e942c40b95b$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $6b881e942c40b95b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $9af78cf14ed0072c$export$e98c1b6c3bbc3c59), classes);
};
const $6b881e942c40b95b$export$ee7cc8ee8a5215ec = 350;
const $6b881e942c40b95b$var$PickersSlideTransitionRoot = (0, $j7y1Z.default)((0, $a25659da27a85057$export$2e2bcd8739ae039), {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $9af78cf14ed0072c$export$d251a58673156a67)['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${(0, $9af78cf14ed0072c$export$d251a58673156a67)['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${(0, $9af78cf14ed0072c$export$d251a58673156a67).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $9af78cf14ed0072c$export$d251a58673156a67).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $9af78cf14ed0072c$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${(0, $9af78cf14ed0072c$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: $6b881e942c40b95b$export$ee7cc8ee8a5215ec,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $9af78cf14ed0072c$export$d251a58673156a67)['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${(0, $9af78cf14ed0072c$export$d251a58673156a67)['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${(0, $9af78cf14ed0072c$export$d251a58673156a67).slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${(0, $9af78cf14ed0072c$export$d251a58673156a67).slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${(0, $9af78cf14ed0072c$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $9af78cf14ed0072c$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $6b881e942c40b95b$export$e868fcc7557d3a06(inProps) {
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props, other = (0, $7qXFD.default)(props, $6b881e942c40b95b$var$_excluded);
    const classes = $6b881e942c40b95b$var$useUtilityClasses(props);
    if (reduceAnimations) return /*#__PURE__*/ (0, $bHJbJ.jsx)("div", {
        className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($6b881e942c40b95b$var$PickersSlideTransitionRoot, {
        className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $i5lfL.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $7c29585abad5bdf6$export$2e2bcd8739ae039), (0, $1CWiu.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: $6b881e942c40b95b$export$ee7cc8ee8a5215ec,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}





var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
const $2068a10952a803af$export$fbe827982a69894a = (slot)=>(0, $6bbZp.default)('MuiDayCalendar', slot);
const $2068a10952a803af$export$e0770f35b28ac552 = (0, $47i1c.default)('MuiDayCalendar', [
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);



var $bHJbJ = parcelRequire("bHJbJ");
const $d525a0a91f479108$var$_excluded = [
    "parentProps",
    "day",
    "focusableDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $d525a0a91f479108$var$_excluded2 = [
    "ownerState"
];
const $d525a0a91f479108$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $2068a10952a803af$export$fbe827982a69894a), classes);
};
const $d525a0a91f479108$var$defaultDayOfWeekFormatter = (day)=>day.charAt(0).toUpperCase();
const $d525a0a91f479108$var$weeksContainerHeight = ((0, $12b5e0d6cb728eae$export$3f0060ce4cc8f4d0) + (0, $12b5e0d6cb728eae$export$dde58b009b497666) * 2) * 6;
const $d525a0a91f479108$var$PickersCalendarDayHeader = (0, $j7y1Z.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header',
    overridesResolver: (_, styles)=>styles.header
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $d525a0a91f479108$var$PickersCalendarWeekDayLabel = (0, $j7y1Z.default)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel',
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const $d525a0a91f479108$var$PickersCalendarWeekNumberLabel = (0, $j7y1Z.default)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
    name: 'MuiDayPicker',
    slot: 'WeekNumberLabel',
    overridesResolver: (_, styles)=>styles.weekNumberLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.text.disabled
    }));
const $d525a0a91f479108$var$PickersCalendarWeekNumber = (0, $j7y1Z.default)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
    name: 'MuiDayPicker',
    slot: 'WeekNumber',
    overridesResolver: (_, styles)=>styles.weekNumber
})(({ theme: theme })=>(0, $1CWiu.default)({}, theme.typography.caption, {
        width: (0, $12b5e0d6cb728eae$export$3f0060ce4cc8f4d0),
        height: (0, $12b5e0d6cb728eae$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $12b5e0d6cb728eae$export$dde58b009b497666)}px`,
        color: theme.palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const $d525a0a91f479108$var$PickersCalendarLoadingContainer = (0, $j7y1Z.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer',
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $d525a0a91f479108$var$weeksContainerHeight
});
const $d525a0a91f479108$var$PickersCalendarSlideTransition = (0, $j7y1Z.default)((0, $6b881e942c40b95b$export$e868fcc7557d3a06), {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition',
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $d525a0a91f479108$var$weeksContainerHeight
});
const $d525a0a91f479108$var$PickersCalendarWeekContainer = (0, $j7y1Z.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer',
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: 'hidden'
});
const $d525a0a91f479108$var$PickersCalendarWeek = (0, $j7y1Z.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer',
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $12b5e0d6cb728eae$export$dde58b009b497666)}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function $d525a0a91f479108$var$WrappedDay(_ref) {
    var _ref2, _slots$day, _slotProps$day;
    let { parentProps: parentProps, day: day, focusableDay: focusableDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $7qXFD.default)(_ref, $d525a0a91f479108$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const now = (0, $c90bc5ca414ce17d$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const Day = (_ref2 = (_slots$day = slots == null ? void 0 : slots.day) != null ? _slots$day : components == null ? void 0 : components.Day) != null ? _ref2 : (0, $bfb92354195d2465$export$d7378e6e864346fa);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: Day,
        externalSlotProps: (_slotProps$day = slotProps == null ? void 0 : slotProps.day) != null ? _slotProps$day : componentsProps == null ? void 0 : componentsProps.day,
        additionalProps: (0, $1CWiu.default)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': utils.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $1CWiu.default)({}, parentProps, {
            day: day,
            selected: isSelected
        })
    }), dayProps = (0, $7qXFD.default)(_useSlotProps, $d525a0a91f479108$var$_excluded2);
    const isDisabled = $i5lfL.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const outsideCurrentMonth = $i5lfL.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const isFirstVisibleCell = $i5lfL.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = $i5lfL.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)(Day, (0, $1CWiu.default)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: isViewFocused && isFocusableDay,
        today: isToday,
        outsideCurrentMonth: outsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
function $d525a0a91f479108$export$8fb56b32a5df6314(inProps) {
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = $d525a0a91f479108$var$defaultDayOfWeekFormatter, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, autoFocus: autoFocus, timezone: timezone } = props;
    const now = (0, $c90bc5ca414ce17d$export$3a404aece3dff2fa)(timezone);
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const classes = $d525a0a91f479108$var$useUtilityClasses(props);
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const isDateDisabled = (0, $89abaff0dbdf0a9f$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const localeText = (0, $c90bc5ca414ce17d$export$24fdeaa0f591a73e)();
    const [internalHasFocus, setInternalHasFocus] = (0, $50778d58d10a200e$export$2e2bcd8739ae039)({
        name: 'DayCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const [internalFocusedDay, setInternalFocusedDay] = $i5lfL.useState(()=>focusedDay || now);
    const handleDaySelect = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            onFocusedViewChange == null || onFocusedViewChange(true);
            setInternalHasFocus(true);
        }
    };
    const handleKeyDown = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? 1 : -1);
                    const closestDayToFocus = (0, $276f3a2cf1f0c279$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRTL ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? -1 : 1);
                    const closestDayToFocus = (0, $276f3a2cf1f0c279$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRTL ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event, day)=>focusDay(day));
    const handleBlur = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event, day)=>{
        if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) onFocusedViewChange == null || onFocusedViewChange(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const validSelectedDays = $i5lfL.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = currentMonthNumber;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $i5lfL.useMemo(()=>/*#__PURE__*/ $i5lfL.createRef(), [
        transitionKey
    ]);
    const startOfCurrentWeek = utils.startOfWeek(now);
    const focusableDay = $i5lfL.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $276f3a2cf1f0c279$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils,
        timezone
    ]);
    const weeksToDisplay = $i5lfL.useMemo(()=>{
        const currentMonthWithTimezone = utils.setTimezone(currentMonth, timezone);
        const toDisplay = utils.getWeekArray(currentMonthWithTimezone);
        let nextMonth = utils.addMonths(currentMonthWithTimezone, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils,
        timezone
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)("div", {
        role: "grid",
        "aria-labelledby": gridLabelId,
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsxs)($d525a0a91f479108$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $bHJbJ.jsx)($d525a0a91f479108$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": localeText.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: localeText.calendarWeekNumberHeaderText
                    }),
                    utils.getWeekdays().map((day, i)=>{
                        var _dayOfWeekFormatter;
                        return /*#__PURE__*/ (0, $bHJbJ.jsx)($d525a0a91f479108$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), 'weekday'),
                            className: classes.weekDayLabel,
                            children: (_dayOfWeekFormatter = dayOfWeekFormatter == null ? void 0 : dayOfWeekFormatter(day)) != null ? _dayOfWeekFormatter : day
                        }, day + i.toString());
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $bHJbJ.jsx)($d525a0a91f479108$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $bHJbJ.jsx)($d525a0a91f479108$var$PickersCalendarSlideTransition, (0, $1CWiu.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)($d525a0a91f479108$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $bHJbJ.jsxs)($d525a0a91f479108$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $bHJbJ.jsx)($d525a0a91f479108$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": localeText.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: localeText.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $bHJbJ.jsx)($d525a0a91f479108$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        focusableDay: focusableDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        isViewFocused: internalHasFocus,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");




var $j7y1Z = parcelRequire("j7y1Z");

var $2ktY3 = parcelRequire("2ktY3");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");

var $j7y1Z = parcelRequire("j7y1Z");

var $2ktY3 = parcelRequire("2ktY3");

var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
function $b434db01c25b98ca$export$db90a620ac957a73(slot) {
    return (0, $6bbZp.default)('MuiPickersMonth', slot);
}
const $b434db01c25b98ca$export$911e3973fa70a12b = (0, $47i1c.default)('MuiPickersMonth', [
    'root',
    'monthButton',
    'disabled',
    'selected'
]);



var $bHJbJ = parcelRequire("bHJbJ");
const $1f11ee70fdbd4456$var$_excluded = [
    "autoFocus",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "monthsPerRow"
];
const $1f11ee70fdbd4456$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        monthButton: [
            'monthButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $b434db01c25b98ca$export$db90a620ac957a73), classes);
};
const $1f11ee70fdbd4456$var$PickersMonthRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiPickersMonth',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})(({ ownerState: ownerState })=>({
        flexBasis: ownerState.monthsPerRow === 3 ? '33.3%' : '25%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }));
const $1f11ee70fdbd4456$var$PickersMonthButton = (0, $j7y1Z.default)('button', {
    name: 'MuiPickersMonth',
    slot: 'MonthButton',
    overridesResolver: (_, styles)=>[
            styles.monthButton,
            {
                [`&.${(0, $b434db01c25b98ca$export$911e3973fa70a12b).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $b434db01c25b98ca$export$911e3973fa70a12b).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $1CWiu.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $b434db01c25b98ca$export$911e3973fa70a12b).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $b434db01c25b98ca$export$911e3973fa70a12b).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $1f11ee70fdbd4456$export$bc52fdb7f02f591a = /*#__PURE__*/ $i5lfL.memo(function PickersMonth(inProps) {
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersMonth'
    });
    const { autoFocus: autoFocus, children: children, disabled: disabled, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, 'aria-current': ariaCurrent } = props, other = (0, $7qXFD.default)(props, $1f11ee70fdbd4456$var$_excluded);
    const ref = $i5lfL.useRef(null);
    const classes = $1f11ee70fdbd4456$var$useUtilityClasses(props);
    (0, $5e41edb128c5ed2a$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            var _ref$current;
            (_ref$current = ref.current) == null || _ref$current.focus();
        }
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($1f11ee70fdbd4456$var$PickersMonthRoot, (0, $1CWiu.default)({
        className: classes.root,
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($1f11ee70fdbd4456$var$PickersMonthButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.monthButton,
            ownerState: props,
            children: children
        })
    }));
});




var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
function $300adc7efaa784b0$export$da0c97315339ebd9(slot) {
    return (0, $6bbZp.default)('MuiMonthCalendar', slot);
}
const $300adc7efaa784b0$export$edf77d5566c7007c = (0, $47i1c.default)('MuiMonthCalendar', [
    'root'
]);







var $bHJbJ = parcelRequire("bHJbJ");
const $031f5ef8008b2e2e$var$_excluded = [
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone"
];
const $031f5ef8008b2e2e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $300adc7efaa784b0$export$da0c97315339ebd9), classes);
};
function $031f5ef8008b2e2e$export$5b6e066572408095(props, name) {
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const defaultDates = (0, $c90bc5ca414ce17d$export$7c38da3a2e90fa83)();
    const themeProps = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $1CWiu.default)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $276f3a2cf1f0c279$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $276f3a2cf1f0c279$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $031f5ef8008b2e2e$var$MonthCalendarRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch',
    padding: '0 4px',
    width: 320
});
const $031f5ef8008b2e2e$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $i5lfL.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $031f5ef8008b2e2e$export$5b6e066572408095(inProps, 'MuiMonthCalendar');
    const { className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, disableHighlightToday: disableHighlightToday, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow = 3, timezone: timezoneProp } = props, other = (0, $7qXFD.default)(props, $031f5ef8008b2e2e$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $a7ba2c812e4f48ce$export$174d749f3b4c0f49)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $2fdbcdc4da212b5f$export$2764b246aa3b75ba)
    });
    const now = (0, $c90bc5ca414ce17d$export$3a404aece3dff2fa)(timezone);
    const theme = (0, $99d6713ec469aabd$export$2e2bcd8739ae039)();
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const referenceDate = $i5lfL.useMemo(()=>(0, $2fdbcdc4da212b5f$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $12ddf67933ed7c3a$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $031f5ef8008b2e2e$var$useUtilityClasses(ownerState);
    const todayMonth = $i5lfL.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = $i5lfL.useMemo(()=>{
        if (value != null) return utils.getMonth(value);
        if (disableHighlightToday) return null;
        return utils.getMonth(referenceDate);
    }, [
        value,
        utils,
        disableHighlightToday,
        referenceDate
    ]);
    const [focusedMonth, setFocusedMonth] = $i5lfL.useState(()=>selectedMonth || todayMonth);
    const [internalHasFocus, setInternalHasFocus] = (0, $50778d58d10a200e$export$2e2bcd8739ae039)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const changeHasFocus = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $i5lfL.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value != null ? value : referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((month)=>{
        if (!isMonthDisabled(utils.setMonth(value != null ? value : referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $i5lfL.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (theme.direction === 'ltr' ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (theme.direction === 'ltr' ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($031f5ef8008b2e2e$var$MonthCalendarRoot, (0, $1CWiu.default)({
        ref: ref,
        className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: (0, $276f3a2cf1f0c279$export$62591b96a734eacd)(utils, value != null ? value : referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, 'monthShort');
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1f11ee70fdbd4456$export$bc52fdb7f02f591a), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? 'date' : undefined,
                monthsPerRow: monthsPerRow,
                children: monthText
            }, monthText);
        })
    }));
});



var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");




var $j7y1Z = parcelRequire("j7y1Z");

var $2ktY3 = parcelRequire("2ktY3");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
function $0dc4b01aea155324$export$183c9f339a61cd79(slot) {
    return (0, $6bbZp.default)('MuiPickersYear', slot);
}
const $0dc4b01aea155324$export$4ef58a3d9c6f4296 = (0, $47i1c.default)('MuiPickersYear', [
    'root',
    'yearButton',
    'selected',
    'disabled'
]);



var $bHJbJ = parcelRequire("bHJbJ");
const $f2dfc736d53712e5$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "yearsPerRow"
];
const $f2dfc736d53712e5$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        yearButton: [
            'yearButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $0dc4b01aea155324$export$183c9f339a61cd79), classes);
};
const $f2dfc736d53712e5$var$PickersYearRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiPickersYear',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})(({ ownerState: ownerState })=>({
        flexBasis: ownerState.yearsPerRow === 3 ? '33.3%' : '25%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }));
const $f2dfc736d53712e5$var$PickersYearButton = (0, $j7y1Z.default)('button', {
    name: 'MuiPickersYear',
    slot: 'YearButton',
    overridesResolver: (_, styles)=>[
            styles.yearButton,
            {
                [`&.${(0, $0dc4b01aea155324$export$4ef58a3d9c6f4296).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $0dc4b01aea155324$export$4ef58a3d9c6f4296).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $1CWiu.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $bb6d55b5db31c7f7$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $0dc4b01aea155324$export$4ef58a3d9c6f4296).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $0dc4b01aea155324$export$4ef58a3d9c6f4296).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $f2dfc736d53712e5$export$261f3fbd5fd5814d = /*#__PURE__*/ $i5lfL.memo(function PickersYear(inProps) {
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersYear'
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, 'aria-current': ariaCurrent } = props, other = (0, $7qXFD.default)(props, $f2dfc736d53712e5$var$_excluded);
    const ref = $i5lfL.useRef(null);
    const classes = $f2dfc736d53712e5$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    $i5lfL.useEffect(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($f2dfc736d53712e5$var$PickersYearRoot, (0, $1CWiu.default)({
        className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($f2dfc736d53712e5$var$PickersYearButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.yearButton,
            ownerState: props,
            children: children
        })
    }));
});




var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
function $c78d4c530c645c19$export$4477acc520094dec(slot) {
    return (0, $6bbZp.default)('MuiYearCalendar', slot);
}
const $c78d4c530c645c19$export$e42d427cd9fe5fd7 = (0, $47i1c.default)('MuiYearCalendar', [
    'root'
]);







var $bHJbJ = parcelRequire("bHJbJ");
const $9fe6ffe7d677b052$var$_excluded = [
    "autoFocus",
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsPerRow",
    "timezone"
];
const $9fe6ffe7d677b052$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $c78d4c530c645c19$export$4477acc520094dec), classes);
};
function $9fe6ffe7d677b052$var$useYearCalendarDefaultizedProps(props, name) {
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const defaultDates = (0, $c90bc5ca414ce17d$export$7c38da3a2e90fa83)();
    const themeProps = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $1CWiu.default)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        minDate: (0, $276f3a2cf1f0c279$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $276f3a2cf1f0c279$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $9fe6ffe7d677b052$var$YearCalendarRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'auto',
    height: '100%',
    padding: '0 4px',
    width: 320,
    maxHeight: 304
});
const $9fe6ffe7d677b052$export$657f9200591b2b71 = /*#__PURE__*/ $i5lfL.forwardRef(function YearCalendar(inProps, ref) {
    const props = $9fe6ffe7d677b052$var$useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus: autoFocus, className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, disableHighlightToday: disableHighlightToday, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsPerRow: yearsPerRow = 3, timezone: timezoneProp } = props, other = (0, $7qXFD.default)(props, $9fe6ffe7d677b052$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $a7ba2c812e4f48ce$export$174d749f3b4c0f49)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $2fdbcdc4da212b5f$export$2764b246aa3b75ba)
    });
    const now = (0, $c90bc5ca414ce17d$export$3a404aece3dff2fa)(timezone);
    const theme = (0, $99d6713ec469aabd$export$2e2bcd8739ae039)();
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const referenceDate = $i5lfL.useMemo(()=>(0, $2fdbcdc4da212b5f$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $12ddf67933ed7c3a$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $9fe6ffe7d677b052$var$useUtilityClasses(ownerState);
    const todayYear = $i5lfL.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = $i5lfL.useMemo(()=>{
        if (value != null) return utils.getYear(value);
        if (disableHighlightToday) return null;
        return utils.getYear(referenceDate);
    }, [
        value,
        utils,
        disableHighlightToday,
        referenceDate
    ]);
    const [focusedYear, setFocusedYear] = $i5lfL.useState(()=>selectedYear || todayYear);
    const [internalHasFocus, setInternalHasFocus] = (0, $50778d58d10a200e$export$2e2bcd8739ae039)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const changeHasFocus = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $i5lfL.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value != null ? value : referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((year)=>{
        if (!isYearDisabled(utils.setYear(value != null ? value : referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus == null || onYearFocus(year);
        }
    });
    $i5lfL.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const handleKeyDown = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - yearsPerRow);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + yearsPerRow);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year + (theme.direction === 'ltr' ? -1 : 1));
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + (theme.direction === 'ltr' ? 1 : -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $i5lfL.useRef(null);
    const handleRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(ref, scrollerRef);
    $i5lfL.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($9fe6ffe7d677b052$var$YearCalendarRoot, (0, $1CWiu.default)({
        ref: handleRef,
        className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: utils.getYearRange(minDate, maxDate).map((year)=>{
            const yearNumber = utils.getYear(year);
            const isSelected = yearNumber === selectedYear;
            const isDisabled = disabled || isYearDisabled(year);
            return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $f2dfc736d53712e5$export$261f3fbd5fd5814d), {
                selected: isSelected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                disabled: isDisabled,
                tabIndex: yearNumber === focusedYear ? 0 : -1,
                onFocus: handleYearFocus,
                onBlur: handleYearBlur,
                "aria-current": todayYear === yearNumber ? 'date' : undefined,
                yearsPerRow: yearsPerRow,
                children: utils.format(year, 'year')
            }, utils.format(year, 'year'));
        })
    }));
});




var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");
parcelRequire("i5lfL");


var $j7y1Z = parcelRequire("j7y1Z");


var $2ktY3 = parcelRequire("2ktY3");





var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");



var $j7y1Z = parcelRequire("j7y1Z");

var $2ktY3 = parcelRequire("2ktY3");




var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
function $f74b520cedef1c5b$export$cef978c25740de90(slot) {
    return (0, $6bbZp.default)('MuiPickersArrowSwitcher', slot);
}
const $f74b520cedef1c5b$export$f8819209558cd362 = (0, $47i1c.default)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button'
]);



var $bHJbJ = parcelRequire("bHJbJ");
const $6833b025791e8fc0$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel"
], $6833b025791e8fc0$var$_excluded2 = [
    "ownerState"
], $6833b025791e8fc0$var$_excluded3 = [
    "ownerState"
];
const $6833b025791e8fc0$var$PickersArrowSwitcherRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex'
});
const $6833b025791e8fc0$var$PickersArrowSwitcherSpacer = (0, $j7y1Z.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $6833b025791e8fc0$var$PickersArrowSwitcherButton = (0, $j7y1Z.default)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button',
    overridesResolver: (props, styles)=>styles.button
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({}, ownerState.hidden && {
        visibility: 'hidden'
    }));
const $6833b025791e8fc0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $f74b520cedef1c5b$export$cef978c25740de90), classes);
};
const $6833b025791e8fc0$export$597b7cbdb7b2a24c = /*#__PURE__*/ $i5lfL.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    var _slots$previousIconBu, _slots$nextIconButton, _slots$leftArrowIcon, _slots$rightArrowIcon;
    const theme = (0, $d3f129e8e622d35c$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === 'rtl';
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel } = props, other = (0, $7qXFD.default)(props, $6833b025791e8fc0$var$_excluded);
    const ownerState = props;
    const classes = $6833b025791e8fc0$var$useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const [leftProps, rightProps] = isRTL ? [
        nextProps,
        previousProps
    ] : [
        previousProps,
        nextProps
    ];
    const PreviousIconButton = (_slots$previousIconBu = slots == null ? void 0 : slots.previousIconButton) != null ? _slots$previousIconBu : $6833b025791e8fc0$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: leftProps.label,
            'aria-label': leftProps.label,
            disabled: leftProps.isDisabled,
            edge: 'end',
            onClick: leftProps.goTo
        },
        ownerState: (0, $1CWiu.default)({}, ownerState, {
            hidden: leftProps.isHidden
        }),
        className: classes.button
    });
    const NextIconButton = (_slots$nextIconButton = slots == null ? void 0 : slots.nextIconButton) != null ? _slots$nextIconButton : $6833b025791e8fc0$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: NextIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: rightProps.label,
            'aria-label': rightProps.label,
            disabled: rightProps.isDisabled,
            edge: 'start',
            onClick: rightProps.goTo
        },
        ownerState: (0, $1CWiu.default)({}, ownerState, {
            hidden: rightProps.isHidden
        }),
        className: classes.button
    });
    const LeftArrowIcon = (_slots$leftArrowIcon = slots == null ? void 0 : slots.leftArrowIcon) != null ? _slots$leftArrowIcon : (0, $1732d580053861dc$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: undefined
    }), leftArrowIconProps = (0, $7qXFD.default)(_useSlotProps, $6833b025791e8fc0$var$_excluded2);
    const RightArrowIcon = (_slots$rightArrowIcon = slots == null ? void 0 : slots.rightArrowIcon) != null ? _slots$rightArrowIcon : (0, $1732d580053861dc$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: undefined
    }), rightArrowIconProps = (0, $7qXFD.default)(_useSlotProps2, $6833b025791e8fc0$var$_excluded3);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($6833b025791e8fc0$var$PickersArrowSwitcherRoot, (0, $1CWiu.default)({
        ref: ref,
        className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)(PreviousIconButton, (0, $1CWiu.default)({}, previousIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $bHJbJ.jsx)(RightArrowIcon, (0, $1CWiu.default)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $bHJbJ.jsx)(LeftArrowIcon, (0, $1CWiu.default)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, $bHJbJ.jsx)($6833b025791e8fc0$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)(NextIconButton, (0, $1CWiu.default)({}, nextIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $bHJbJ.jsx)(LeftArrowIcon, (0, $1CWiu.default)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $bHJbJ.jsx)(RightArrowIcon, (0, $1CWiu.default)({}, rightArrowIconProps))
            }))
        ]
    }));
});



var $i5lfL = parcelRequire("i5lfL");


function $b07f2909d7c5602f$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    return $i5lfL.useMemo(()=>{
        const now = utils.dateWithTimezone(undefined, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function $b07f2909d7c5602f$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    return $i5lfL.useMemo(()=>{
        const now = utils.dateWithTimezone(undefined, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function $b07f2909d7c5602f$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const meridiemMode = (0, $6cccea7bd094fe8c$export$c3352ead7b032236)(date, utils);
    const handleMeridiemChange = $i5lfL.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $6cccea7bd094fe8c$export$c368d4ff66779998)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState != null ? selectionState : 'partial');
    }, [
        ampm,
        date,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}



var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
const $acb5d67f08a3c1a9$export$457ac4d3a1ad92b4 = (slot)=>(0, $6bbZp.default)('MuiPickersCalendarHeader', slot);
const $acb5d67f08a3c1a9$export$63db7afb9247cb91 = (0, $47i1c.default)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);



var $bHJbJ = parcelRequire("bHJbJ");
const $3e8ebb54e1a61e33$var$_excluded = [
    "ownerState"
];
const $3e8ebb54e1a61e33$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $acb5d67f08a3c1a9$export$457ac4d3a1ad92b4), classes);
};
const $3e8ebb54e1a61e33$var$PickersCalendarHeaderRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 8,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 30,
    minHeight: 30
});
const $3e8ebb54e1a61e33$var$PickersCalendarHeaderLabelContainer = (0, $j7y1Z.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer',
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $1CWiu.default)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $3e8ebb54e1a61e33$var$PickersCalendarHeaderLabel = (0, $j7y1Z.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label',
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $3e8ebb54e1a61e33$var$PickersCalendarHeaderSwitchViewButton = (0, $j7y1Z.default)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton',
    overridesResolver: (_, styles)=>styles.switchViewButton
})(({ ownerState: ownerState })=>(0, $1CWiu.default)({
        marginRight: 'auto'
    }, ownerState.view === 'year' && {
        [`.${(0, $acb5d67f08a3c1a9$export$63db7afb9247cb91).switchViewIcon}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $3e8ebb54e1a61e33$var$PickersCalendarHeaderSwitchViewIcon = (0, $j7y1Z.default)((0, $1732d580053861dc$export$ed0fe318cc298673), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon',
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
function $3e8ebb54e1a61e33$export$6801ffebb353f473(inProps) {
    var _slots$switchViewButt, _slots$switchViewIcon;
    const localeText = (0, $c90bc5ca414ce17d$export$24fdeaa0f591a73e)();
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, timezone: timezone } = props;
    const ownerState = props;
    const classes = $3e8ebb54e1a61e33$var$useUtilityClasses(props);
    const SwitchViewButton = (_slots$switchViewButt = slots == null ? void 0 : slots.switchViewButton) != null ? _slots$switchViewButt : $3e8ebb54e1a61e33$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': localeText.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = (_slots$switchViewIcon = slots == null ? void 0 : slots.switchViewIcon) != null ? _slots$switchViewIcon : $3e8ebb54e1a61e33$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewIcon,
        ownerState: undefined,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $7qXFD.default)(_useSlotProps, $3e8ebb54e1a61e33$var$_excluded);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1), 'left');
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1), 'right');
    const isNextMonthDisabled = (0, $b07f2909d7c5602f$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $b07f2909d7c5602f$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($3e8ebb54e1a61e33$var$PickersCalendarHeaderRoot, {
        ownerState: ownerState,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsxs)($3e8ebb54e1a61e33$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $c8e1faeb5fae48d7$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: utils.format(month, 'monthAndYear'),
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($3e8ebb54e1a61e33$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: utils.format(month, 'monthAndYear')
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $bHJbJ.jsx)(SwitchViewButton, (0, $1CWiu.default)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)(SwitchViewIcon, (0, $1CWiu.default)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $eb1f4c060c8a68ab$export$2e2bcd8739ae039), {
                in: view === 'day',
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $6833b025791e8fc0$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: localeText.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: localeText.nextMonth
                })
            })
        ]
    });
}




var $j7y1Z = parcelRequire("j7y1Z");

const $0c6ee9c2824786f2$export$512b066b8abdfde4 = (0, $j7y1Z.default)('div')({
    overflow: 'hidden',
    width: (0, $12b5e0d6cb728eae$export$ee46b8a74d6c94d3),
    maxHeight: (0, $12b5e0d6cb728eae$export$f2fef360e2df0cb7),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});


const $ba11eabc1196e98b$export$96ab2969580bcdae = typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent);



var $6bbZp = parcelRequire("6bbZp");
var $47i1c = parcelRequire("47i1c");
const $f8ee4dfcaaf1d5fc$export$da8c2318897a6672 = (slot)=>(0, $6bbZp.default)('MuiDateCalendar', slot);
const $f8ee4dfcaaf1d5fc$export$d0237e2bb9598e8d = (0, $47i1c.default)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);





var $bHJbJ = parcelRequire("bHJbJ");
const $58de4a05eedce0a6$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "defaultCalendarMonth",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $58de4a05eedce0a6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $f8ee4dfcaaf1d5fc$export$da8c2318897a6672), classes);
};
function $58de4a05eedce0a6$var$useDateCalendarDefaultizedProps(props, name) {
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const defaultDates = (0, $c90bc5ca414ce17d$export$7c38da3a2e90fa83)();
    const themeProps = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $1CWiu.default)({
        loading: false,
        disablePast: false,
        disableFuture: false,
        openTo: 'day',
        views: [
            'year',
            'day'
        ],
        reduceAnimations: (0, $ba11eabc1196e98b$export$96ab2969580bcdae),
        renderLoading: ()=>/*#__PURE__*/ (0, $bHJbJ.jsx)("span", {
                children: "..."
            })
    }, themeProps, {
        minDate: (0, $276f3a2cf1f0c279$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $276f3a2cf1f0c279$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $58de4a05eedce0a6$var$DateCalendarRoot = (0, $j7y1Z.default)((0, $0c6ee9c2824786f2$export$512b066b8abdfde4), {
    name: 'MuiDateCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column'
});
const $58de4a05eedce0a6$var$DateCalendarViewTransitionContainer = (0, $j7y1Z.default)((0, $c8e1faeb5fae48d7$export$5262185daf493fee), {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer',
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $58de4a05eedce0a6$export$68078fe5d2bf8909 = /*#__PURE__*/ $i5lfL.forwardRef(function DateCalendar(inProps, ref) {
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const id = (0, $f3f83812f7a42248$export$2e2bcd8739ae039)();
    const props = $58de4a05eedce0a6$var$useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, defaultCalendarMonth: defaultCalendarMonth, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $7qXFD.default)(props, $58de4a05eedce0a6$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $a7ba2c812e4f48ce$export$174d749f3b4c0f49)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $2fdbcdc4da212b5f$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $da4e6a1f0a700ae4$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $3dc53182873c50e4$export$6d095e787d2b5e1f)({
        value: value,
        defaultCalendarMonth: defaultCalendarMonth,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const handleDateMonthChange = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $276f3a2cf1f0c279$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onMonthChange == null || onMonthChange(startOfMonth);
        } else {
            goToNextView();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleDateYearChange = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $276f3a2cf1f0c279$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onYearChange == null || onYearChange(closestEnabledDate);
        } else {
            goToNextView();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleSelectedDayChange = (0, $49175dc6d5053977$export$2e2bcd8739ae039)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $276f3a2cf1f0c279$export$a98b123b8f29e004)(utils, day, value != null ? value : referenceDate), 'finish');
        return handleValueChange(day, 'finish');
    });
    $i5lfL.useEffect(()=>{
        if (value != null && utils.isValid(value)) changeMonth(value);
    }, [
        value
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $58de4a05eedce0a6$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone
    };
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const prevOpenViewRef = $i5lfL.useRef(view);
    $i5lfL.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $i5lfL.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($58de4a05eedce0a6$var$DateCalendarRoot, (0, $1CWiu.default)({
        ref: ref,
        className: (0, $35903a0217fe2785$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3e8ebb54e1a61e33$export$6801ffebb353f473), {
                views: views,
                view: view,
                currentMonth: calendarState.currentMonth,
                onViewChange: setView,
                onMonthChange: (newMonth, direction)=>handleChangeMonth({
                        newMonth: newMonth,
                        direction: direction
                    }),
                minDate: minDateWithDisabled,
                maxDate: maxDateWithDisabled,
                disabled: disabled,
                disablePast: disablePast,
                disableFuture: disableFuture,
                reduceAnimations: reduceAnimations,
                labelId: gridLabelId,
                slots: slots,
                slotProps: slotProps,
                timezone: timezone
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)($58de4a05eedce0a6$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $bHJbJ.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $9fe6ffe7d677b052$export$657f9200591b2b71), (0, $1CWiu.default)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $031f5ef8008b2e2e$export$d7a7c85c0f5afc4a), (0, $1CWiu.default)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d525a0a91f479108$export$8fb56b32a5df6314), (0, $1CWiu.default)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            gridLabelId: gridLabelId,
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            components: components,
                            componentsProps: componentsProps,
                            slots: slots,
                            slotProps: slotProps,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




var $bHJbJ = parcelRequire("bHJbJ");
const $9fd4824af84aa498$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsPerRow: yearsPerRow, defaultCalendarMonth: defaultCalendarMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $58de4a05eedce0a6$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $276f3a2cf1f0c279$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $276f3a2cf1f0c279$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsPerRow: yearsPerRow,
        defaultCalendarMonth: defaultCalendarMonth,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });



const $f7932b606c7f5c23$export$5a73641f0156e1e4 = /*#__PURE__*/ $i5lfL.forwardRef(function DesktopDatePicker(inProps, ref) {
    var _defaultizedProps$yea, _defaultizedProps$slo2;
    const localeText = (0, $c90bc5ca414ce17d$export$24fdeaa0f591a73e)();
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $fc4c0e27265f19c0$export$a552c17ed3587731)(inProps, 'MuiDesktopDatePicker');
    const viewRenderers = (0, $1CWiu.default)({
        day: (0, $9fd4824af84aa498$export$69888ffe06193e5e),
        month: (0, $9fd4824af84aa498$export$69888ffe06193e5e),
        year: (0, $9fd4824af84aa498$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the desktop variant
    const props = (0, $1CWiu.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $276f3a2cf1f0c279$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        yearsPerRow: (_defaultizedProps$yea = defaultizedProps.yearsPerRow) != null ? _defaultizedProps$yea : 4,
        slots: (0, $1CWiu.default)({
            openPickerIcon: (0, $1732d580053861dc$export$5fda1783bb83f57b),
            field: (0, $1c952b2a21596c3d$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $1CWiu.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $1CWiu.default)({}, (0, $075cbe52c7034614$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $23413e35a3547781$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $1CWiu.default)({
                hidden: true
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $46abdec7cdeae39b$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $2fdbcdc4da212b5f$export$2764b246aa3b75ba),
        valueType: 'date',
        getOpenDialogAriaText: localeText.openDatePickerDialogue,
        validator: (0, $704b91a9b8a06a25$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$f7932b606c7f5c23$export$5a73641f0156e1e4.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object
        })
    ]),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).any,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        3,
        4
    ]),
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
            'all',
            'day',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).number.isRequired
        })
    ]),
    /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        3,
        4
    ])
};



var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");

var $1Zx8l = parcelRequire("1Zx8l");


var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");




var $1CWiu = parcelRequire("1CWiu");
parcelRequire("i5lfL");




var $j7y1Z = parcelRequire("j7y1Z");


var $bHJbJ = parcelRequire("bHJbJ");
const $dcaa67e142892559$var$PickersModalDialogRoot = (0, $j7y1Z.default)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039))({
    [`& .${(0, $5af9140f95ca5973$export$2e2bcd8739ae039).container}`]: {
        outline: 0
    },
    [`& .${(0, $5af9140f95ca5973$export$2e2bcd8739ae039).paper}`]: {
        outline: 0,
        minWidth: (0, $12b5e0d6cb728eae$export$ee46b8a74d6c94d3)
    }
});
const $dcaa67e142892559$var$PickersModalDialogContent = (0, $j7y1Z.default)((0, $422502a3833a93e2$export$2e2bcd8739ae039))({
    '&:first-of-type': {
        padding: 0
    }
});
function $dcaa67e142892559$export$99f83c99e1491f77(props) {
    var _slots$dialog, _slots$mobileTransiti;
    const { children: children, onDismiss: onDismiss, open: open, slots: slots, slotProps: slotProps } = props;
    const Dialog = (_slots$dialog = slots == null ? void 0 : slots.dialog) != null ? _slots$dialog : $dcaa67e142892559$var$PickersModalDialogRoot;
    const Transition = (_slots$mobileTransiti = slots == null ? void 0 : slots.mobileTransition) != null ? _slots$mobileTransiti : (0, $eb1f4c060c8a68ab$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)(Dialog, (0, $1CWiu.default)({
        open: open,
        onClose: onDismiss
    }, slotProps == null ? void 0 : slotProps.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps == null ? void 0 : slotProps.mobileTransition,
        PaperComponent: slots == null ? void 0 : slots.mobilePaper,
        PaperProps: slotProps == null ? void 0 : slotProps.mobilePaper,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($dcaa67e142892559$var$PickersModalDialogContent, {
            children: children
        })
    }));
}








var $bHJbJ = parcelRequire("bHJbJ");
const $8c9990f632b6a583$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
];
const $8c9990f632b6a583$export$5ca0153a626a7dd7 = (_ref)=>{
    var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$layout;
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $7qXFD.default)(_ref, $8c9990f632b6a583$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, timezone: timezone, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, localeText: localeText } = props;
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    const internalInputRef = $i5lfL.useRef(null);
    const labelId = (0, $f3f83812f7a42248$export$2e2bcd8739ae039)();
    const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null ? void 0 : (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps } = (0, $a2e4a41b6580a3be$export$fc3313977ac596c4)((0, $1CWiu.default)({}, pickerParams, {
        props: props,
        inputRef: internalInputRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'mobile'
    }));
    const Field = slots.field;
    const fieldProps = (0, $07ea8771cb5a6bee$export$1e5c9e6e4e15efe3)({
        elementType: Field,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
        additionalProps: (0, $1CWiu.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, !(disabled || readOnly) && {
            onClick: actions.onOpen,
            onKeyDown: (0, $e4fe91f37783b274$export$4467fe8634707c85)(actions.onOpen)
        }, {
            readOnly: readOnly != null ? readOnly : true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            timezone: timezone,
            label: label
        }),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    fieldProps.inputProps = (0, $1CWiu.default)({}, fieldProps.inputProps, {
        'aria-label': getOpenDialogAriaText(pickerFieldProps.value, utils)
    });
    const slotsForField = (0, $1CWiu.default)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : (0, $928eedb2774e969a$export$647f604ea2397c05);
    const handleInputRef = (0, $2a4bb72baa6497d0$export$2e2bcd8739ae039)(internalInputRef, fieldProps.inputRef, inputRef);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $1CWiu.default)({}, innerSlotProps, {
        toolbar: (0, $1CWiu.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $1CWiu.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps == null ? void 0 : innerSlotProps.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $295315439c6d861c$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $bHJbJ.jsx)(Field, (0, $1CWiu.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    inputRef: handleInputRef
                })),
                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $dcaa67e142892559$export$99f83c99e1491f77), (0, $1CWiu.default)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)(Layout, (0, $1CWiu.default)({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};









const $4e89a3cf298c7508$export$97b476d7a92fee62 = /*#__PURE__*/ $i5lfL.forwardRef(function MobileDatePicker(inProps, ref) {
    var _defaultizedProps$slo2;
    const localeText = (0, $c90bc5ca414ce17d$export$24fdeaa0f591a73e)();
    const utils = (0, $c90bc5ca414ce17d$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $fc4c0e27265f19c0$export$a552c17ed3587731)(inProps, 'MuiMobileDatePicker');
    const viewRenderers = (0, $1CWiu.default)({
        day: (0, $9fd4824af84aa498$export$69888ffe06193e5e),
        month: (0, $9fd4824af84aa498$export$69888ffe06193e5e),
        year: (0, $9fd4824af84aa498$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, $1CWiu.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $276f3a2cf1f0c279$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        slots: (0, $1CWiu.default)({
            field: (0, $1c952b2a21596c3d$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $1CWiu.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $1CWiu.default)({}, (0, $075cbe52c7034614$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $23413e35a3547781$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $1CWiu.default)({
                hidden: false
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $8c9990f632b6a583$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $2fdbcdc4da212b5f$export$2764b246aa3b75ba),
        valueType: 'date',
        getOpenDialogAriaText: localeText.openDatePickerDialogue,
        validator: (0, $704b91a9b8a06a25$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$4e89a3cf298c7508$export$97b476d7a92fee62.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object
        })
    ]),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).any,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        3,
        4
    ]),
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
            'all',
            'day',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).number.isRequired
        })
    ]),
    /**
   * Disable specific date.
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($1Zx8l))).oneOf([
        3,
        4
    ])
};




var $bHJbJ = parcelRequire("bHJbJ");
const $a27ecd42a8eaf0a0$var$_excluded = [
    "desktopModeMediaQuery"
];
const $a27ecd42a8eaf0a0$export$5109c6dd95d8fb00 = /*#__PURE__*/ $i5lfL.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $e4fe91f37783b274$export$9ae5b19305db48ce) } = props, other = (0, $7qXFD.default)(props, $a27ecd42a8eaf0a0$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $2605abdc8746194d$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $f7932b606c7f5c23$export$5a73641f0156e1e4), (0, $1CWiu.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $4e89a3cf298c7508$export$97b476d7a92fee62), (0, $1CWiu.default)({
        ref: ref
    }, other));
});




function $61689dee2f6ff4fb$export$afc921ba20c7eb49(priorYearProjectList) {
    return priorYearProjectList?.executeGetRawProjectTypes?.map((type)=>{
        return type.RawProjectType;
    }) ?? [];
}
function $61689dee2f6ff4fb$export$c07c686062478869(priorYearProjectList) {
    return priorYearProjectList?.executeGetLocationList?.map((location)=>{
        return {
            state: location.State,
            locationName: location.LocationName
        };
    }) ?? [];
}
function $61689dee2f6ff4fb$export$35029cc0a320e78a(priorYearProjectList) {
    return priorYearProjectList?.executeGetState.map((location)=>{
        return location.State;
    }) ?? [];
}
function $61689dee2f6ff4fb$export$dd2b6e807fb37ba3(priorYearProjectList) {
    return priorYearProjectList?.executeGetSourceList.map((source)=>{
        return source.Source;
    }) ?? [];
}
function $61689dee2f6ff4fb$export$bb3c376502d994d1(statusList) {
    return statusList?.map((status)=>{
        return status.value;
    });
}
function $61689dee2f6ff4fb$export$af91cc7b93ecc074(fundingList) {
    return fundingList?.map((funding)=>{
        return funding.value;
    });
}
function $61689dee2f6ff4fb$export$960c8c4fe218647d(locations, states) {
    // Group locations by state
    const locationsByState = {};
    locations.forEach(({ locationName: locationName, state: state })=>{
        if (!locationsByState[state]) locationsByState[state] = [];
        locationsByState[state].push(locationName);
    });
    // Sort and filter states
    const sortedLocationsByState = states.reduce((acc, state)=>{
        if (locationsByState[state]) acc[state] = locationsByState[state];
        return acc;
    }, {});
    return sortedLocationsByState;
}
function $61689dee2f6ff4fb$export$c1e906046b5de973(processingPath) {
    if ([
        3,
        4,
        5
    ].indexOf(processingPath) > -1) return "yes";
    else return "no";
}
function $61689dee2f6ff4fb$export$6a6007f0d011e292(processingPath) {
    if ([
        7
    ].indexOf(processingPath) > -1) return "yes";
    else return "no";
}
const $61689dee2f6ff4fb$export$c8f03a4db3d99335 = (forecast, ongoing, values)=>{
    // default path
    if (forecast == "no" && ongoing == "no") {
        // processing path 1
        if ([
            ...(0, $243a1246ea7835d9$export$5be856edc6a7f539),
            ...(0, $243a1246ea7835d9$export$ad98f2e8c6fd720d)
        ].indexOf(values.RawProjectType) === -1) return 1;
        // processing 2
        if ((0, $243a1246ea7835d9$export$ad98f2e8c6fd720d).indexOf(values.RawProjectType) > -1) return 2;
    }
    if (forecast == "yes" && [
        ...(0, $243a1246ea7835d9$export$5be856edc6a7f539),
        ...(0, $243a1246ea7835d9$export$ad98f2e8c6fd720d),
        ...(0, $243a1246ea7835d9$export$9bcd006cd4d2d851)
    ].indexOf(values.RawProjectType) > -1) {
        // processing path 3
        if ((0, $243a1246ea7835d9$export$ad98f2e8c6fd720d).indexOf(values.RawProjectType) > -1) return 3;
        // processing path 4
        if ([
            (0, $243a1246ea7835d9$export$5be856edc6a7f539)[1],
            (0, $243a1246ea7835d9$export$5be856edc6a7f539)[2]
        ].indexOf(values.RawProjectType) > -1 || (0, $243a1246ea7835d9$export$9bcd006cd4d2d851).indexOf(values.RawProjectType) > -1) return 4;
        //processing path 5
        if ([
            (0, $243a1246ea7835d9$export$5be856edc6a7f539)[0]
        ].indexOf(values.RawProjectType) > -1) return 5;
    }
    //processing path 7
    if (forecast === "no" && ongoing == "yes" && [
        ...(0, $243a1246ea7835d9$export$5be856edc6a7f539),
        ...(0, $243a1246ea7835d9$export$ad98f2e8c6fd720d)
    ].indexOf(values.RawProjectType) === -1) return 7;
    return 1;
};


const $416e4400d63bb0bb$export$a5a5f67a7efd7c08 = ({ open: open, onClose: onClose, onSubmit: onSubmit, AllLists: AllLists, Juri: Juri, projectList: projectList })=>{
    const source = Juri == "FED" ? "Federal" : Juri;
    const currentYear = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))().year();
    const today = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))().toISOString();
    const [values, setValues] = (0, $i5lfL.useState)({
        ...(0, $243a1246ea7835d9$export$5dbac6ca1d81f28),
        ["Source"]: source
    });
    const [forecast, setForecast] = (0, $i5lfL.useState)("no");
    const [ongoing, setOngoing] = (0, $i5lfL.useState)("no");
    const investmentRequired = (values)=>{
        // processing path 3  and 4
        if (forecast === "yes" && [
            ...(0, $243a1246ea7835d9$export$ad98f2e8c6fd720d),
            ...(0, $243a1246ea7835d9$export$9bcd006cd4d2d851),
            (0, $243a1246ea7835d9$export$5be856edc6a7f539)[1],
            (0, $243a1246ea7835d9$export$5be856edc6a7f539)[2]
        ].indexOf(values.RawProjectType) !== -1) return false;
        // processing path 2
        if (forecast === "no" && ongoing === "no" && (0, $243a1246ea7835d9$export$ad98f2e8c6fd720d).indexOf(values.RawProjectType) !== -1) return false;
        return true;
    };
    const handleSubmit = (event)=>{
        //put your validation logic here
        event.preventDefault();
        if (!$416e4400d63bb0bb$export$4d09d4ac8ba225dd(values, projectList, forecast)) {
            // calculate processing path based on forecast, ongoing and project type
            const processingPath = (0, $61689dee2f6ff4fb$export$c8f03a4db3d99335)(forecast, ongoing, values);
            onSubmit({
                ...values,
                ["ProcessingPath"]: processingPath
            });
            // reset create project when model is closed
            setValues({
                ...(0, $243a1246ea7835d9$export$5dbac6ca1d81f28),
                ["Source"]: source
            });
            setForecast("no");
            setOngoing("no");
            onClose();
        }
    };
    const minConstructionDate = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))('2015', 'YYYY');
    const maxConstructionDate = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))('2040', 'YYYY');
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039), {
        open: open,
        fullWidth: true,
        maxWidth: "lg",
        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $48d8f4c3325a9037$export$2e2bcd8739ae039), {
                    id: "create-dialog-title",
                    children: "Scenario project creation"
                }),
                /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $422502a3833a93e2$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            p: 2
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            p: 2,
                            display: "flex",
                            className: "hide-asterisk",
                            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                container: true,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 5.6,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Original project ID",
                                            name: "SourceID",
                                            value: values.SourceID,
                                            onChange: (e)=>setValues({
                                                    ...values,
                                                    [e.target.name]: e.target.value
                                                }),
                                            required: true
                                        }, "SourceID")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 5.6,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "State",
                                            name: "State",
                                            value: values.State,
                                            onChange: (e)=>setValues({
                                                    ...values,
                                                    [e.target.name]: e.target.value,
                                                    ["LocationID"]: ""
                                                }),
                                            select: true,
                                            required: true,
                                            children: AllLists?.executeGetState.map((option)=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                    value: option.State,
                                                    children: option.State
                                                }, option.State))
                                        }, "State")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 5.6,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Project name",
                                            name: "ProjectName",
                                            value: values.ProjectName,
                                            onChange: (e)=>setValues({
                                                    ...values,
                                                    [e.target.name]: e.target.value
                                                }),
                                            required: true
                                        }, "ProjectName")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 5.6,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Source",
                                            name: "Source",
                                            value: values.Source,
                                            disabled: true
                                        }, "Source")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 5.6,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Location",
                                            name: "LocationID",
                                            select: true,
                                            value: values.LocationID,
                                            onChange: (e)=>setValues({
                                                    ...values,
                                                    [e.target.name]: e.target.value
                                                }),
                                            required: values.State != 'AUS',
                                            children: AllLists?.executeGetLocationList.filter((item)=>item.State == values.State || values.State == '' || values.State == 'AUS').map((option)=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                    value: option.LocationID,
                                                    children: option.LocationName
                                                }, option.LocationID))
                                        }, "LocationID")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 5.6,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Project type",
                                            name: "RawProjectType",
                                            select: true,
                                            value: values.RawProjectType,
                                            onChange: (e)=>// clear display unit when select different project types
                                                setValues({
                                                    ...values,
                                                    [e.target.name]: e.target.value,
                                                    ["MW"]: 0,
                                                    ["km"]: 0
                                                }),
                                            required: true,
                                            children: AllLists?.executeGetRawProjectTypes.map((option)=>{
                                                if (forecast === "yes" && [
                                                    ...(0, $243a1246ea7835d9$export$5be856edc6a7f539),
                                                    ...(0, $243a1246ea7835d9$export$ad98f2e8c6fd720d),
                                                    ...(0, $243a1246ea7835d9$export$9bcd006cd4d2d851)
                                                ].indexOf(option.RawProjectType) !== -1) return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                    value: option.RawProjectType,
                                                    children: option.RawProjectType
                                                }, option.RawProjectType);
                                                if (forecast === "no" && ongoing === "yes" && [
                                                    ...(0, $243a1246ea7835d9$export$5be856edc6a7f539),
                                                    ...(0, $243a1246ea7835d9$export$ad98f2e8c6fd720d),
                                                    ...(0, $243a1246ea7835d9$export$9bcd006cd4d2d851)
                                                ].indexOf(option.RawProjectType) === -1) return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                    value: option.RawProjectType,
                                                    children: option.RawProjectType
                                                }, option.RawProjectType);
                                                if (forecast === "no" && ongoing === "no" && [
                                                    ...(0, $243a1246ea7835d9$export$5be856edc6a7f539),
                                                    ...(0, $243a1246ea7835d9$export$9bcd006cd4d2d851)
                                                ].indexOf(option.RawProjectType) === -1) return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                    value: option.RawProjectType,
                                                    children: option.RawProjectType
                                                }, option.RawProjectType);
                                            })
                                        }, "RawProjectType")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 5.6,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Investment ($millions)",
                                            name: "Investment",
                                            value: values.Investment,
                                            inputProps: {
                                                inputMode: "decimal",
                                                pattern: "[0-9]*.[0-9]*"
                                            },
                                            onChange: (e)=>setValues({
                                                    ...values,
                                                    [e.target.name]: e.target.value
                                                }),
                                            error: isNaN(values.Investment),
                                            required: investmentRequired(values)
                                        }, "Investment")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 5.6,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Funding mode",
                                            name: "FundingMode",
                                            value: values.FundingMode,
                                            onChange: (e)=>setValues({
                                                    ...values,
                                                    [e.target.name]: e.target.value
                                                }),
                                            select: true,
                                            disabled: forecast === "yes" ? true : false,
                                            required: true,
                                            children: (0, $243a1246ea7835d9$export$14085c2a147de944).map((option)=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                    value: option.text,
                                                    children: option.text
                                                }, option.value))
                                        }, "FundingMode")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 5.6,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Project latest status",
                                            name: "ProjectStage",
                                            select: true,
                                            value: values.ProjectStage,
                                            onChange: (e)=>setValues({
                                                    ...values,
                                                    [e.target.name]: e.target.value
                                                }),
                                            required: forecast === "yes" ? false : true,
                                            children: (0, $243a1246ea7835d9$export$2425b41e18ec8805).map((option)=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                    value: option.value,
                                                    children: option.text
                                                }, option.value))
                                        }, "ProjectStage")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 5.6,
                                        children: [
                                            (0, $243a1246ea7835d9$export$ad98f2e8c6fd720d).indexOf(values.RawProjectType) > -1 && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                                fullWidth: true,
                                                label: "Megawatts",
                                                name: "MW",
                                                value: values.MW,
                                                error: isNaN(values.MW) || values.MW <= 0,
                                                inputProps: {
                                                    inputMode: "decimal",
                                                    pattern: "[0-9]*.[0-9]*"
                                                },
                                                onChange: (e)=>setValues({
                                                        ...values,
                                                        [e.target.name]: e.target.value
                                                    }),
                                                required: true
                                            }, "MW"),
                                            [
                                                "Transmission Line: Double Circuit",
                                                "Transmission Line: Single Circuit"
                                            ].indexOf(values.RawProjectType) > -1 && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                                fullWidth: true,
                                                label: "Kilometers",
                                                name: "km",
                                                value: values.km,
                                                error: isNaN(values.km) || values.km <= 0,
                                                inputProps: {
                                                    inputMode: "decimal",
                                                    pattern: "[0-9]*.[0-9]*"
                                                },
                                                onChange: (e)=>setValues({
                                                        ...values,
                                                        [e.target.name]: e.target.value
                                                    }),
                                                required: true
                                            }, "KM"),
                                            (0, $243a1246ea7835d9$export$9bcd006cd4d2d851).indexOf(values.RawProjectType) > -1 && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                                fullWidth: true,
                                                label: "Metre square",
                                                name: "M2",
                                                value: values.M2,
                                                error: isNaN(values.M2) || values.M2 <= 0,
                                                inputProps: {
                                                    inputMode: "decimal",
                                                    pattern: "[0-9]*.[0-9]*"
                                                },
                                                onChange: (e)=>setValues({
                                                        ...values,
                                                        [e.target.name]: e.target.value
                                                    }),
                                                required: true
                                            }, "M2")
                                        ]
                                    }),
                                    (0, $243a1246ea7835d9$export$ad98f2e8c6fd720d).indexOf(values.RawProjectType) > -1,
                                    (0, $243a1246ea7835d9$export$ad98f2e8c6fd720d).indexOf(values.RawProjectType) > -1
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            p: 2,
                            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                container: true,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 5.6,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $295315439c6d861c$export$dc45bdc734ce6f1e), {
                                            dateAdapter: (0, $4ed4d5da8fc9d26b$export$33545c6a80bae043),
                                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a27ecd42a8eaf0a0$export$5109c6dd95d8fb00), {
                                                label: "Construction start date",
                                                onChange: (date)=>{
                                                    // Check if date is not null before accessing its format method
                                                    if (date) setValues({
                                                        ...values,
                                                        "StartDateConstruction": (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(date).toISOString()
                                                    });
                                                },
                                                timezone: "UTC",
                                                value: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.StartDateConstruction),
                                                slotProps: {
                                                    textField: {
                                                        helperText: "Select a date",
                                                        fullWidth: true,
                                                        error: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.EndDateConstruction).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.StartDateConstruction))
                                                    }
                                                },
                                                format: "DD/MM/YYYY",
                                                minDate: minConstructionDate,
                                                maxDate: maxConstructionDate
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 5.6,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $295315439c6d861c$export$dc45bdc734ce6f1e), {
                                            dateAdapter: (0, $4ed4d5da8fc9d26b$export$33545c6a80bae043),
                                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a27ecd42a8eaf0a0$export$5109c6dd95d8fb00), {
                                                label: "Construction end date",
                                                onChange: (date)=>{
                                                    // Check if date is not null before accessing its format method
                                                    if (date) setValues({
                                                        ...values,
                                                        "EndDateConstruction": (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(date).toISOString()
                                                    });
                                                },
                                                timezone: "UTC",
                                                value: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.EndDateConstruction),
                                                slotProps: {
                                                    textField: {
                                                        helperText: "Select a date",
                                                        fullWidth: true,
                                                        error: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.EndDateConstruction).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.StartDateConstruction))
                                                    }
                                                },
                                                format: "DD/MM/YYYY",
                                                minDate: minConstructionDate,
                                                maxDate: maxConstructionDate
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        $416e4400d63bb0bb$export$4d09d4ac8ba225dd(values, projectList, forecast) && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $097160938072b98e$export$2e2bcd8739ae039), {
                            severity: "error",
                            children: $416e4400d63bb0bb$export$4d09d4ac8ba225dd(values, projectList, forecast)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $0d4f9b05ed57077c$export$2e2bcd8739ae039), {
                    sx: {
                        p: "1.25rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                onClose();
                                setValues({
                                    ...(0, $243a1246ea7835d9$export$5dbac6ca1d81f28),
                                    ["Source"]: source
                                });
                                setForecast("no"); // set to default
                                setOngoing("no"); // set to default
                            },
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                            color: "secondary",
                            variant: "contained",
                            type: "submit",
                            children: "Create"
                        })
                    ]
                })
            ]
        })
    });
};
function $416e4400d63bb0bb$export$4d09d4ac8ba225dd(values, projectList, forecast) {
    if (projectList?.executeGetScenarioProjectList.filter((item)=>item['ProjectName'] == values.ProjectName).length > 0) return "Project name already exists. Please provide an unique name.";
    if (values.ProjectName.length > 255) return "Project name needs to be less than 255 characters.";
    if (isNaN(values.Investment)) return "Please provide a valid non-zero investment amount.";
    if ((isNaN(values.MW) || values.MW <= 0) && (0, $243a1246ea7835d9$export$ad98f2e8c6fd720d).indexOf(values.RawProjectType) > -1) return "Please provide a valid non-zero Megawatts amount.";
    if (isNaN(values.M2) || values.M2 <= 0 && (0, $243a1246ea7835d9$export$9bcd006cd4d2d851).indexOf(values.RawProjectType) > -1) return "Please provide a valid non-zero Metre square amount.";
    if ((isNaN(values.km) || values.km <= 0) && [
        "Transmission Line: Double Circuit",
        "Transmission Line: Single Circuit"
    ].indexOf(values.RawProjectType) > -1) return "Please provide a valid non-zero Kilometers amount.";
    if ((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.EndDateConstruction).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.StartDateConstruction))) return "Invalid construction date range, Construction start date should be before Construction end date.";
    if (forecast === "yes" && (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.StartDateConstruction)?.month() !== 7 && (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.StartDateConstruction)?.date() !== 2) return "Construction start date should be the start of the financial year.";
    if (forecast === "yes" && (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.EndDateConstruction)?.month() !== 6 && (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.EndDateConstruction)?.date() !== 1) return "Construction end date should be the end of the financial year.";
    return "";
}


var $9bc9c4f93103a0b3$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($9bc9c4f93103a0b3$exports, "__esModule", {
    value: true
});
$9bc9c4f93103a0b3$exports.default = void 0;

var $9bc9c4f93103a0b3$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $9bc9c4f93103a0b3$var$_default = $9bc9c4f93103a0b3$exports.default = (0, $9bc9c4f93103a0b3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z"
}), 'FileDownload');


var $1cb7ac08e18fc2ca$exports = {};
/*! ExcelJS 19-10-2023 */ !function(e) {
    $1cb7ac08e18fc2ca$exports = e();
}(function() {
    return (function e(t, r, n) {
        function i(o, a) {
            if (!r[o]) {
                if (!t[o]) {
                    var l = undefined;
                    if (!a && l) return l(o, !0);
                    if (s) return s(o, !0);
                    var c = new Error("Cannot find module '" + o + "'");
                    throw c.code = "MODULE_NOT_FOUND", c;
                }
                var u = r[o] = {
                    exports: {}
                };
                t[o][0].call(u.exports, function(_e) {
                    return i(t[o][1][_e] || _e);
                }, u, u.exports, e, t, r, n);
            }
            return r[o].exports;
        }
        for(var s = undefined, o = 0; o < n.length; o++)i(n[o]);
        return i;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                const n = e("fs"), i = e("fast-csv"), s = e("dayjs/plugin/customParseFormat"), o = e("dayjs/plugin/utc"), a = e("dayjs").extend(s).extend(o), l = e("../utils/stream-buf"), { fs: { exists: c } } = e("../utils/utils"), u = {
                    true: !0,
                    false: !1,
                    "#N/A": {
                        error: "#N/A"
                    },
                    "#REF!": {
                        error: "#REF!"
                    },
                    "#NAME?": {
                        error: "#NAME?"
                    },
                    "#DIV/0!": {
                        error: "#DIV/0!"
                    },
                    "#NULL!": {
                        error: "#NULL!"
                    },
                    "#VALUE!": {
                        error: "#VALUE!"
                    },
                    "#NUM!": {
                        error: "#NUM!"
                    }
                };
                t.exports = class {
                    constructor(e){
                        this.workbook = e, this.worksheet = null;
                    }
                    async readFile(e, t) {
                        if (t = t || {}, !await c(e)) throw new Error("File not found: " + e);
                        const r = n.createReadStream(e), i = await this.read(r, t);
                        return r.close(), i;
                    }
                    read(e, t) {
                        return t = t || {}, new Promise((r, n)=>{
                            const s = this.workbook.addWorksheet(t.sheetName), o = t.dateFormats || [
                                "YYYY-MM-DD[T]HH:mm:ssZ",
                                "YYYY-MM-DD[T]HH:mm:ss",
                                "MM-DD-YYYY",
                                "YYYY-MM-DD"
                            ], l = t.map || function(e) {
                                if ("" === e) return null;
                                const t = Number(e);
                                if (!Number.isNaN(t) && t !== 1 / 0) return t;
                                const r = o.reduce((t, r)=>{
                                    if (t) return t;
                                    const n = a(e, r, !0);
                                    return n.isValid() ? n : null;
                                }, null);
                                if (r) return new Date(r.valueOf());
                                const n = u[e];
                                return void 0 !== n ? n : e;
                            }, c = i.parse(t.parserOptions).on("data", (e)=>{
                                s.addRow(e.map(l));
                            }).on("end", ()=>{
                                c.emit("worksheet", s);
                            });
                            c.on("worksheet", r).on("error", n), e.pipe(c);
                        });
                    }
                    createInputStream() {
                        throw new Error("`CSV#createInputStream` is deprecated. You should use `CSV#read` instead. This method will be removed in version 5.0. Please follow upgrade instruction: https://github.com/exceljs/exceljs/blob/master/UPGRADE-4.0.md");
                    }
                    write(e, t) {
                        return new Promise((r, n)=>{
                            t = t || {};
                            const s = this.workbook.getWorksheet(t.sheetName || t.sheetId), o = i.format(t.formatterOptions);
                            e.on("finish", ()=>{
                                r();
                            }), o.on("error", n), o.pipe(e);
                            const { dateFormat: l, dateUTC: c } = t, u = t.map || ((e)=>{
                                if (e) {
                                    if (e.text || e.hyperlink) return e.hyperlink || e.text || "";
                                    if (e.formula || e.result) return e.result || "";
                                    if (e instanceof Date) return l ? c ? a.utc(e).format(l) : a(e).format(l) : c ? a.utc(e).format() : a(e).format();
                                    if (e.error) return e.error;
                                    if ("object" == typeof e) return JSON.stringify(e);
                                }
                                return e;
                            }), h = void 0 === t.includeEmptyRows || t.includeEmptyRows;
                            let f = 1;
                            s && s.eachRow((e, t)=>{
                                if (h) for(; f++ < t - 1;)o.write([]);
                                const { values: r } = e;
                                r.shift(), o.write(r.map(u)), f = t;
                            }), o.end();
                        });
                    }
                    writeFile(e, t) {
                        const r = {
                            encoding: (t = t || {}).encoding || "utf8"
                        }, i = n.createWriteStream(e, r);
                        return this.write(i, t);
                    }
                    async writeBuffer(e) {
                        const t = new l;
                        return await this.write(t, e), t.read();
                    }
                };
            },
            {
                "../utils/stream-buf": 24,
                "../utils/utils": 27,
                dayjs: 391,
                "dayjs/plugin/customParseFormat": 392,
                "dayjs/plugin/utc": 393,
                "fast-csv": 424,
                fs: 216
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(e, t){
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                        if (this.worksheet = e, t) {
                            if ("string" == typeof t) {
                                const e = n.decodeAddress(t);
                                this.nativeCol = e.col + r, this.nativeColOff = 0, this.nativeRow = e.row + r, this.nativeRowOff = 0;
                            } else void 0 !== t.nativeCol ? (this.nativeCol = t.nativeCol || 0, this.nativeColOff = t.nativeColOff || 0, this.nativeRow = t.nativeRow || 0, this.nativeRowOff = t.nativeRowOff || 0) : void 0 !== t.col ? (this.col = t.col + r, this.row = t.row + r) : (this.nativeCol = 0, this.nativeColOff = 0, this.nativeRow = 0, this.nativeRowOff = 0);
                        } else this.nativeCol = 0, this.nativeColOff = 0, this.nativeRow = 0, this.nativeRowOff = 0;
                    }
                    static asInstance(e) {
                        return e instanceof i || null == e ? e : new i(e);
                    }
                    get col() {
                        return this.nativeCol + Math.min(this.colWidth - 1, this.nativeColOff) / this.colWidth;
                    }
                    set col(e) {
                        this.nativeCol = Math.floor(e), this.nativeColOff = Math.floor((e - this.nativeCol) * this.colWidth);
                    }
                    get row() {
                        return this.nativeRow + Math.min(this.rowHeight - 1, this.nativeRowOff) / this.rowHeight;
                    }
                    set row(e) {
                        this.nativeRow = Math.floor(e), this.nativeRowOff = Math.floor((e - this.nativeRow) * this.rowHeight);
                    }
                    get colWidth() {
                        return this.worksheet && this.worksheet.getColumn(this.nativeCol + 1) && this.worksheet.getColumn(this.nativeCol + 1).isCustomWidth ? Math.floor(1e4 * this.worksheet.getColumn(this.nativeCol + 1).width) : 64e4;
                    }
                    get rowHeight() {
                        return this.worksheet && this.worksheet.getRow(this.nativeRow + 1) && this.worksheet.getRow(this.nativeRow + 1).height ? Math.floor(1e4 * this.worksheet.getRow(this.nativeRow + 1).height) : 18e4;
                    }
                    get model() {
                        return {
                            nativeCol: this.nativeCol,
                            nativeColOff: this.nativeColOff,
                            nativeRow: this.nativeRow,
                            nativeRowOff: this.nativeRowOff
                        };
                    }
                    set model(e) {
                        this.nativeCol = e.nativeCol, this.nativeColOff = e.nativeColOff, this.nativeRow = e.nativeRow, this.nativeRowOff = e.nativeRowOff;
                    }
                }
                t.exports = i;
            },
            {
                "../utils/col-cache": 19
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache"), i = e("../utils/under-dash"), s = e("./enums"), { slideFormula: o } = e("../utils/shared-formula"), a = e("./note");
                class l {
                    constructor(e, t, r){
                        if (!e || !t) throw new Error("A Cell needs a Row");
                        this._row = e, this._column = t, n.validateAddress(r), this._address = r, this._value = c.create(l.Types.Null, this), this.style = this._mergeStyle(e.style, t.style, {}), this._mergeCount = 0;
                    }
                    get worksheet() {
                        return this._row.worksheet;
                    }
                    get workbook() {
                        return this._row.worksheet.workbook;
                    }
                    destroy() {
                        delete this.style, delete this._value, delete this._row, delete this._column, delete this._address;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this.style.numFmt = e;
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this.style.font = e;
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this.style.alignment = e;
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this.style.border = e;
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this.style.fill = e;
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this.style.protection = e;
                    }
                    _mergeStyle(e, t, r) {
                        const n = e && e.numFmt || t && t.numFmt;
                        n && (r.numFmt = n);
                        const i = e && e.font || t && t.font;
                        i && (r.font = i);
                        const s = e && e.alignment || t && t.alignment;
                        s && (r.alignment = s);
                        const o = e && e.border || t && t.border;
                        o && (r.border = o);
                        const a = e && e.fill || t && t.fill;
                        a && (r.fill = a);
                        const l = e && e.protection || t && t.protection;
                        return l && (r.protection = l), r;
                    }
                    get address() {
                        return this._address;
                    }
                    get row() {
                        return this._row.number;
                    }
                    get col() {
                        return this._column.number;
                    }
                    get $col$row() {
                        return `$${this._column.letter}$${this.row}`;
                    }
                    get type() {
                        return this._value.type;
                    }
                    get effectiveType() {
                        return this._value.effectiveType;
                    }
                    toCsvString() {
                        return this._value.toCsvString();
                    }
                    addMergeRef() {
                        this._mergeCount++;
                    }
                    releaseMergeRef() {
                        this._mergeCount--;
                    }
                    get isMerged() {
                        return this._mergeCount > 0 || this.type === l.Types.Merge;
                    }
                    merge(e, t) {
                        this._value.release(), this._value = c.create(l.Types.Merge, this, e), t || (this.style = e.style);
                    }
                    unmerge() {
                        this.type === l.Types.Merge && (this._value.release(), this._value = c.create(l.Types.Null, this), this.style = this._mergeStyle(this._row.style, this._column.style, {}));
                    }
                    isMergedTo(e) {
                        return this._value.type === l.Types.Merge && this._value.isMergedTo(e);
                    }
                    get master() {
                        return this.type === l.Types.Merge ? this._value.master : this;
                    }
                    get isHyperlink() {
                        return this._value.type === l.Types.Hyperlink;
                    }
                    get hyperlink() {
                        return this._value.hyperlink;
                    }
                    get value() {
                        return this._value.value;
                    }
                    set value(e) {
                        this.type !== l.Types.Merge ? (this._value.release(), this._value = c.create(c.getType(e), this, e)) : this._value.master.value = e;
                    }
                    get note() {
                        return this._comment && this._comment.note;
                    }
                    set note(e) {
                        this._comment = new a(e);
                    }
                    get text() {
                        return this._value.toString();
                    }
                    get html() {
                        return i.escapeHtml(this.text);
                    }
                    toString() {
                        return this.text;
                    }
                    _upgradeToHyperlink(e) {
                        this.type === l.Types.String && (this._value = c.create(l.Types.Hyperlink, this, {
                            text: this._value.value,
                            hyperlink: e
                        }));
                    }
                    get formula() {
                        return this._value.formula;
                    }
                    get result() {
                        return this._value.result;
                    }
                    get formulaType() {
                        return this._value.formulaType;
                    }
                    get fullAddress() {
                        const { worksheet: e } = this._row;
                        return {
                            sheetName: e.name,
                            address: this.address,
                            row: this.row,
                            col: this.col
                        };
                    }
                    get name() {
                        return this.names[0];
                    }
                    set name(e) {
                        this.names = [
                            e
                        ];
                    }
                    get names() {
                        return this.workbook.definedNames.getNamesEx(this.fullAddress);
                    }
                    set names(e) {
                        const { definedNames: t } = this.workbook;
                        t.removeAllNames(this.fullAddress), e.forEach((e)=>{
                            t.addEx(this.fullAddress, e);
                        });
                    }
                    addName(e) {
                        this.workbook.definedNames.addEx(this.fullAddress, e);
                    }
                    removeName(e) {
                        this.workbook.definedNames.removeEx(this.fullAddress, e);
                    }
                    removeAllNames() {
                        this.workbook.definedNames.removeAllNames(this.fullAddress);
                    }
                    get _dataValidations() {
                        return this.worksheet.dataValidations;
                    }
                    get dataValidation() {
                        return this._dataValidations.find(this.address);
                    }
                    set dataValidation(e) {
                        this._dataValidations.add(this.address, e);
                    }
                    get model() {
                        const { model: e } = this._value;
                        return e.style = this.style, this._comment && (e.comment = this._comment.model), e;
                    }
                    set model(e) {
                        if (this._value.release(), this._value = c.create(e.type, this), this._value.model = e, e.comment) switch(e.comment.type){
                            case "note":
                                this._comment = a.fromModel(e.comment);
                        }
                        e.style ? this.style = e.style : this.style = {};
                    }
                }
                l.Types = s.ValueType;
                const c = {
                    getType: (e)=>null == e ? l.Types.Null : e instanceof String || "string" == typeof e ? l.Types.String : "number" == typeof e ? l.Types.Number : "boolean" == typeof e ? l.Types.Boolean : e instanceof Date ? l.Types.Date : e.text && e.hyperlink ? l.Types.Hyperlink : e.formula || e.sharedFormula ? l.Types.Formula : e.richText ? l.Types.RichText : e.sharedString ? l.Types.SharedString : e.error ? l.Types.Error : l.Types.JSON,
                    types: [
                        {
                            t: l.Types.Null,
                            f: class {
                                constructor(e){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Null
                                    };
                                }
                                get value() {
                                    return null;
                                }
                                set value(e) {}
                                get type() {
                                    return l.Types.Null;
                                }
                                get effectiveType() {
                                    return l.Types.Null;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return "";
                                }
                                release() {}
                                toString() {
                                    return "";
                                }
                            }
                        },
                        {
                            t: l.Types.Number,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Number,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Number;
                                }
                                get effectiveType() {
                                    return l.Types.Number;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.String,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.String;
                                }
                                get effectiveType() {
                                    return l.Types.String;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return `"${this.model.value.replace(/"/g, '""')}"`;
                                }
                                release() {}
                                toString() {
                                    return this.model.value;
                                }
                            }
                        },
                        {
                            t: l.Types.Date,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Date,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Date;
                                }
                                get effectiveType() {
                                    return l.Types.Date;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toISOString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.Hyperlink,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Hyperlink,
                                        text: t ? t.text : void 0,
                                        hyperlink: t ? t.hyperlink : void 0
                                    }, t && t.tooltip && (this.model.tooltip = t.tooltip);
                                }
                                get value() {
                                    const e = {
                                        text: this.model.text,
                                        hyperlink: this.model.hyperlink
                                    };
                                    return this.model.tooltip && (e.tooltip = this.model.tooltip), e;
                                }
                                set value(e) {
                                    this.model = {
                                        text: e.text,
                                        hyperlink: e.hyperlink
                                    }, e.tooltip && (this.model.tooltip = e.tooltip);
                                }
                                get text() {
                                    return this.model.text;
                                }
                                set text(e) {
                                    this.model.text = e;
                                }
                                get hyperlink() {
                                    return this.model.hyperlink;
                                }
                                set hyperlink(e) {
                                    this.model.hyperlink = e;
                                }
                                get type() {
                                    return l.Types.Hyperlink;
                                }
                                get effectiveType() {
                                    return l.Types.Hyperlink;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.hyperlink;
                                }
                                release() {}
                                toString() {
                                    return this.model.text;
                                }
                            }
                        },
                        {
                            t: l.Types.Formula,
                            f: class {
                                constructor(e, t){
                                    this.cell = e, this.model = {
                                        address: e.address,
                                        type: l.Types.Formula,
                                        shareType: t ? t.shareType : void 0,
                                        ref: t ? t.ref : void 0,
                                        formula: t ? t.formula : void 0,
                                        sharedFormula: t ? t.sharedFormula : void 0,
                                        result: t ? t.result : void 0
                                    };
                                }
                                _copyModel(e) {
                                    const t = {}, r = (r)=>{
                                        const n = e[r];
                                        n && (t[r] = n);
                                    };
                                    return r("formula"), r("result"), r("ref"), r("shareType"), r("sharedFormula"), t;
                                }
                                get value() {
                                    return this._copyModel(this.model);
                                }
                                set value(e) {
                                    this.model = this._copyModel(e);
                                }
                                validate(e) {
                                    switch(c.getType(e)){
                                        case l.Types.Null:
                                        case l.Types.String:
                                        case l.Types.Number:
                                        case l.Types.Date:
                                            break;
                                        case l.Types.Hyperlink:
                                        case l.Types.Formula:
                                        default:
                                            throw new Error("Cannot process that type of result value");
                                    }
                                }
                                get dependencies() {
                                    return {
                                        ranges: this.formula.match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}:[A-Z]{1,3}\d{1,4}/g),
                                        cells: this.formula.replace(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}:[A-Z]{1,3}\d{1,4}/g, "").match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}/g)
                                    };
                                }
                                get formula() {
                                    return this.model.formula || this._getTranslatedFormula();
                                }
                                set formula(e) {
                                    this.model.formula = e;
                                }
                                get formulaType() {
                                    return this.model.formula ? s.FormulaType.Master : this.model.sharedFormula ? s.FormulaType.Shared : s.FormulaType.None;
                                }
                                get result() {
                                    return this.model.result;
                                }
                                set result(e) {
                                    this.model.result = e;
                                }
                                get type() {
                                    return l.Types.Formula;
                                }
                                get effectiveType() {
                                    const e = this.model.result;
                                    return null == e ? s.ValueType.Null : e instanceof String || "string" == typeof e ? s.ValueType.String : "number" == typeof e ? s.ValueType.Number : e instanceof Date ? s.ValueType.Date : e.text && e.hyperlink ? s.ValueType.Hyperlink : e.formula ? s.ValueType.Formula : s.ValueType.Null;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                _getTranslatedFormula() {
                                    if (!this._translatedFormula && this.model.sharedFormula) {
                                        const { worksheet: e } = this.cell, t = e.findCell(this.model.sharedFormula);
                                        this._translatedFormula = t && o(t.formula, t.address, this.model.address);
                                    }
                                    return this._translatedFormula;
                                }
                                toCsvString() {
                                    return "" + (this.model.result || "");
                                }
                                release() {}
                                toString() {
                                    return this.model.result ? this.model.result.toString() : "";
                                }
                            }
                        },
                        {
                            t: l.Types.Merge,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Merge,
                                        master: t ? t.address : void 0
                                    }, this._master = t, t && t.addMergeRef();
                                }
                                get value() {
                                    return this._master.value;
                                }
                                set value(e) {
                                    e instanceof l ? (this._master && this._master.releaseMergeRef(), e.addMergeRef(), this._master = e) : this._master.value = e;
                                }
                                isMergedTo(e) {
                                    return e === this._master;
                                }
                                get master() {
                                    return this._master;
                                }
                                get type() {
                                    return l.Types.Merge;
                                }
                                get effectiveType() {
                                    return this._master.effectiveType;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return "";
                                }
                                release() {
                                    this._master.releaseMergeRef();
                                }
                                toString() {
                                    return this.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.JSON,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: JSON.stringify(t),
                                        rawValue: t
                                    };
                                }
                                get value() {
                                    return this.model.rawValue;
                                }
                                set value(e) {
                                    this.model.rawValue = e, this.model.value = JSON.stringify(e);
                                }
                                get type() {
                                    return l.Types.String;
                                }
                                get effectiveType() {
                                    return l.Types.String;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value;
                                }
                                release() {}
                                toString() {
                                    return this.model.value;
                                }
                            }
                        },
                        {
                            t: l.Types.SharedString,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.SharedString,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.SharedString;
                                }
                                get effectiveType() {
                                    return l.Types.SharedString;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.RichText,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                toString() {
                                    return this.model.value.richText.map((e)=>e.text).join("");
                                }
                                get type() {
                                    return l.Types.RichText;
                                }
                                get effectiveType() {
                                    return l.Types.RichText;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return `"${this.text.replace(/"/g, '""')}"`;
                                }
                                release() {}
                            }
                        },
                        {
                            t: l.Types.Boolean,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Boolean,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Boolean;
                                }
                                get effectiveType() {
                                    return l.Types.Boolean;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value ? 1 : 0;
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.Error,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Error,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Error;
                                }
                                get effectiveType() {
                                    return l.Types.Error;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.error.toString();
                                }
                            }
                        }
                    ].reduce((e, t)=>(e[t.t] = t.f, e), []),
                    create (e, t, r) {
                        const n = this.types[e];
                        if (!n) throw new Error("Could not create Value of type " + e);
                        return new n(t, r);
                    }
                };
                t.exports = l;
            },
            {
                "../utils/col-cache": 19,
                "../utils/shared-formula": 23,
                "../utils/under-dash": 26,
                "./enums": 7,
                "./note": 9
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("./enums"), s = e("../utils/col-cache");
                class o {
                    constructor(e, t, r){
                        this._worksheet = e, this._number = t, !1 !== r && (this.defn = r);
                    }
                    get number() {
                        return this._number;
                    }
                    get worksheet() {
                        return this._worksheet;
                    }
                    get letter() {
                        return s.n2l(this._number);
                    }
                    get isCustomWidth() {
                        return void 0 !== this.width && 9 !== this.width;
                    }
                    get defn() {
                        return {
                            header: this._header,
                            key: this.key,
                            width: this.width,
                            style: this.style,
                            hidden: this.hidden,
                            outlineLevel: this.outlineLevel
                        };
                    }
                    set defn(e) {
                        e ? (this.key = e.key, this.width = void 0 !== e.width ? e.width : 9, this.outlineLevel = e.outlineLevel, e.style ? this.style = e.style : this.style = {}, this.header = e.header, this._hidden = !!e.hidden) : (delete this._header, delete this._key, delete this.width, this.style = {}, this.outlineLevel = 0);
                    }
                    get headers() {
                        return this._header && this._header instanceof Array ? this._header : [
                            this._header
                        ];
                    }
                    get header() {
                        return this._header;
                    }
                    set header(e) {
                        void 0 !== e ? (this._header = e, this.headers.forEach((e, t)=>{
                            this._worksheet.getCell(t + 1, this.number).value = e;
                        })) : this._header = void 0;
                    }
                    get key() {
                        return this._key;
                    }
                    set key(e) {
                        (this._key && this._worksheet.getColumnKey(this._key)) === this && this._worksheet.deleteColumnKey(this._key), this._key = e, e && this._worksheet.setColumnKey(this._key, this);
                    }
                    get hidden() {
                        return !!this._hidden;
                    }
                    set hidden(e) {
                        this._hidden = e;
                    }
                    get outlineLevel() {
                        return this._outlineLevel || 0;
                    }
                    set outlineLevel(e) {
                        this._outlineLevel = e;
                    }
                    get collapsed() {
                        return !!(this._outlineLevel && this._outlineLevel >= this._worksheet.properties.outlineLevelCol);
                    }
                    toString() {
                        return JSON.stringify({
                            key: this.key,
                            width: this.width,
                            headers: this.headers.length ? this.headers : void 0
                        });
                    }
                    equivalentTo(e) {
                        return this.width === e.width && this.hidden === e.hidden && this.outlineLevel === e.outlineLevel && n.isEqual(this.style, e.style);
                    }
                    get isDefault() {
                        if (this.isCustomWidth) return !1;
                        if (this.hidden) return !1;
                        if (this.outlineLevel) return !1;
                        const e = this.style;
                        return !e || !(e.font || e.numFmt || e.alignment || e.border || e.fill || e.protection);
                    }
                    get headerCount() {
                        return this.headers.length;
                    }
                    eachCell(e, t) {
                        const r = this.number;
                        t || (t = e, e = null), this._worksheet.eachRow(e, (e, n)=>{
                            t(e.getCell(r), n);
                        });
                    }
                    get values() {
                        const e = [];
                        return this.eachCell((t, r)=>{
                            t && t.type !== i.ValueType.Null && (e[r] = t.value);
                        }), e;
                    }
                    set values(e) {
                        if (!e) return;
                        const t = this.number;
                        let r = 0;
                        e.hasOwnProperty("0") && (r = 1), e.forEach((e, n)=>{
                            this._worksheet.getCell(n + r, t).value = e;
                        });
                    }
                    _applyStyle(e, t) {
                        return this.style[e] = t, this.eachCell((r)=>{
                            r[e] = t;
                        }), t;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this._applyStyle("numFmt", e);
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this._applyStyle("font", e);
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this._applyStyle("alignment", e);
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this._applyStyle("protection", e);
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this._applyStyle("border", e);
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this._applyStyle("fill", e);
                    }
                    static toModel(e) {
                        const t = [];
                        let r = null;
                        return e && e.forEach((e, n)=>{
                            e.isDefault ? r && (r = null) : r && e.equivalentTo(r) ? r.max = n + 1 : (r = {
                                min: n + 1,
                                max: n + 1,
                                width: void 0 !== e.width ? e.width : 9,
                                style: e.style,
                                isCustomWidth: e.isCustomWidth,
                                hidden: e.hidden,
                                outlineLevel: e.outlineLevel,
                                collapsed: e.collapsed
                            }, t.push(r));
                        }), t.length ? t : void 0;
                    }
                    static fromModel(e, t) {
                        const r = [];
                        let n = 1, i = 0;
                        for(t = (t = t || []).sort(function(e, t) {
                            return e.min - t.min;
                        }); i < t.length;){
                            const s = t[i++];
                            for(; n < s.min;)r.push(new o(e, n++));
                            for(; n <= s.max;)r.push(new o(e, n++, s));
                        }
                        return r.length ? r : null;
                    }
                }
                t.exports = o;
            },
            {
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./enums": 7
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                t.exports = class {
                    constructor(e){
                        this.model = e || {};
                    }
                    add(e, t) {
                        return this.model[e] = t;
                    }
                    find(e) {
                        return this.model[e];
                    }
                    remove(e) {
                        this.model[e] = void 0;
                    }
                };
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("../utils/col-cache"), s = e("../utils/cell-matrix"), o = e("./range"), a = /[$](\w+)[$](\d+)(:[$](\w+)[$](\d+))?/;
                t.exports = class {
                    constructor(){
                        this.matrixMap = {};
                    }
                    getMatrix(e) {
                        return this.matrixMap[e] || (this.matrixMap[e] = new s);
                    }
                    add(e, t) {
                        const r = i.decodeEx(e);
                        this.addEx(r, t);
                    }
                    addEx(e, t) {
                        const r = this.getMatrix(t);
                        if (e.top) for(let t = e.left; t <= e.right; t++)for(let n = e.top; n <= e.bottom; n++){
                            const s = {
                                sheetName: e.sheetName,
                                address: i.n2l(t) + n,
                                row: n,
                                col: t
                            };
                            r.addCellEx(s);
                        }
                        else r.addCellEx(e);
                    }
                    remove(e, t) {
                        const r = i.decodeEx(e);
                        this.removeEx(r, t);
                    }
                    removeEx(e, t) {
                        this.getMatrix(t).removeCellEx(e);
                    }
                    removeAllNames(e) {
                        n.each(this.matrixMap, (t)=>{
                            t.removeCellEx(e);
                        });
                    }
                    forEach(e) {
                        n.each(this.matrixMap, (t, r)=>{
                            t.forEach((t)=>{
                                e(r, t);
                            });
                        });
                    }
                    getNames(e) {
                        return this.getNamesEx(i.decodeEx(e));
                    }
                    getNamesEx(e) {
                        return n.map(this.matrixMap, (t, r)=>t.findCellEx(e) && r).filter(Boolean);
                    }
                    _explore(e, t) {
                        t.mark = !1;
                        const { sheetName: r } = t, n = new o(t.row, t.col, t.row, t.col, r);
                        let i, s;
                        function a(i, s) {
                            const o = e.findCellAt(r, i, t.col);
                            return !(!o || !o.mark) && (n[s] = i, o.mark = !1, !0);
                        }
                        for(s = t.row - 1; a(s, "top"); s--);
                        for(s = t.row + 1; a(s, "bottom"); s++);
                        function l(t, i) {
                            const o = [];
                            for(s = n.top; s <= n.bottom; s++){
                                const n = e.findCellAt(r, s, t);
                                if (!n || !n.mark) return !1;
                                o.push(n);
                            }
                            n[i] = t;
                            for(let e = 0; e < o.length; e++)o[e].mark = !1;
                            return !0;
                        }
                        for(i = t.col - 1; l(i, "left"); i--);
                        for(i = t.col + 1; l(i, "right"); i++);
                        return n;
                    }
                    getRanges(e, t) {
                        if (!(t = t || this.matrixMap[e])) return {
                            name: e,
                            ranges: []
                        };
                        t.forEach((e)=>{
                            e.mark = !0;
                        });
                        return {
                            name: e,
                            ranges: t.map((e)=>e.mark && this._explore(t, e)).filter(Boolean).map((e)=>e.$shortRange)
                        };
                    }
                    normaliseMatrix(e, t) {
                        e.forEachInSheet(t, (e, t, r)=>{
                            e && (e.row === t && e.col === r || (e.row = t, e.col = r, e.address = i.n2l(r) + t));
                        });
                    }
                    spliceRows(e, t, r, i) {
                        n.each(this.matrixMap, (n)=>{
                            n.spliceRows(e, t, r, i), this.normaliseMatrix(n, e);
                        });
                    }
                    spliceColumns(e, t, r, i) {
                        n.each(this.matrixMap, (n)=>{
                            n.spliceColumns(e, t, r, i), this.normaliseMatrix(n, e);
                        });
                    }
                    get model() {
                        return n.map(this.matrixMap, (e, t)=>this.getRanges(t, e)).filter((e)=>e.ranges.length);
                    }
                    set model(e) {
                        const t = this.matrixMap = {};
                        e.forEach((e)=>{
                            const r = t[e.name] = new s;
                            e.ranges.forEach((e)=>{
                                a.test(e.split("!").pop() || "") && r.addCell(e);
                            });
                        });
                    }
                };
            },
            {
                "../utils/cell-matrix": 18,
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./range": 10
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    ValueType: {
                        Null: 0,
                        Merge: 1,
                        Number: 2,
                        String: 3,
                        Date: 4,
                        Hyperlink: 5,
                        Formula: 6,
                        SharedString: 7,
                        RichText: 8,
                        Boolean: 9,
                        Error: 10
                    },
                    FormulaType: {
                        None: 0,
                        Master: 1,
                        Shared: 2
                    },
                    RelationshipType: {
                        None: 0,
                        OfficeDocument: 1,
                        Worksheet: 2,
                        CalcChain: 3,
                        SharedStrings: 4,
                        Styles: 5,
                        Theme: 6,
                        Hyperlink: 7
                    },
                    DocumentType: {
                        Xlsx: 1
                    },
                    ReadingOrder: {
                        LeftToRight: 1,
                        RightToLeft: 2
                    },
                    ErrorValue: {
                        NotApplicable: "#N/A",
                        Ref: "#REF!",
                        Name: "#NAME?",
                        DivZero: "#DIV/0!",
                        Null: "#NULL!",
                        Value: "#VALUE!",
                        Num: "#NUM!"
                    }
                };
            },
            {}
        ],
        8: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache"), i = e("./anchor");
                t.exports = class {
                    constructor(e, t){
                        this.worksheet = e, this.model = t;
                    }
                    get model() {
                        switch(this.type){
                            case "background":
                                return {
                                    type: this.type,
                                    imageId: this.imageId
                                };
                            case "image":
                                return {
                                    type: this.type,
                                    imageId: this.imageId,
                                    hyperlinks: this.range.hyperlinks,
                                    range: {
                                        tl: this.range.tl.model,
                                        br: this.range.br && this.range.br.model,
                                        ext: this.range.ext,
                                        editAs: this.range.editAs
                                    }
                                };
                            default:
                                throw new Error("Invalid Image Type");
                        }
                    }
                    set model(e) {
                        let { type: t, imageId: r, range: s, hyperlinks: o } = e;
                        if (this.type = t, this.imageId = r, "image" === t) {
                            if ("string" == typeof s) {
                                const e = n.decode(s);
                                this.range = {
                                    tl: new i(this.worksheet, {
                                        col: e.left,
                                        row: e.top
                                    }, -1),
                                    br: new i(this.worksheet, {
                                        col: e.right,
                                        row: e.bottom
                                    }, 0),
                                    editAs: "oneCell"
                                };
                            } else this.range = {
                                tl: new i(this.worksheet, s.tl, 0),
                                br: s.br && new i(this.worksheet, s.br, 0),
                                ext: s.ext,
                                editAs: s.editAs,
                                hyperlinks: o || s.hyperlinks
                            };
                        }
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "./anchor": 2
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash");
                class i {
                    constructor(e){
                        this.note = e;
                    }
                    get model() {
                        let e = null;
                        switch(typeof this.note){
                            case "string":
                                e = {
                                    type: "note",
                                    note: {
                                        texts: [
                                            {
                                                text: this.note
                                            }
                                        ]
                                    }
                                };
                                break;
                            default:
                                e = {
                                    type: "note",
                                    note: this.note
                                };
                        }
                        return n.deepMerge({}, i.DEFAULT_CONFIGS, e);
                    }
                    set model(e) {
                        const { note: t } = e, { texts: r } = t;
                        1 === r.length && 1 === Object.keys(r[0]).length ? this.note = r[0].text : this.note = t;
                    }
                    static fromModel(e) {
                        const t = new i;
                        return t.model = e, t;
                    }
                }
                i.DEFAULT_CONFIGS = {
                    note: {
                        margins: {
                            insetmode: "auto",
                            inset: [
                                .13,
                                .13,
                                .25,
                                .25
                            ]
                        },
                        protection: {
                            locked: "True",
                            lockText: "True"
                        },
                        editAs: "absolute"
                    }
                }, t.exports = i;
            },
            {
                "../utils/under-dash": 26
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(){
                        this.decode(arguments);
                    }
                    setTLBR(e, t, r, i, s) {
                        if (arguments.length < 4) {
                            const i = n.decodeAddress(e), o = n.decodeAddress(t);
                            this.model = {
                                top: Math.min(i.row, o.row),
                                left: Math.min(i.col, o.col),
                                bottom: Math.max(i.row, o.row),
                                right: Math.max(i.col, o.col),
                                sheetName: r
                            }, this.setTLBR(i.row, i.col, o.row, o.col, s);
                        } else this.model = {
                            top: Math.min(e, r),
                            left: Math.min(t, i),
                            bottom: Math.max(e, r),
                            right: Math.max(t, i),
                            sheetName: s
                        };
                    }
                    decode(e) {
                        switch(e.length){
                            case 5:
                                this.setTLBR(e[0], e[1], e[2], e[3], e[4]);
                                break;
                            case 4:
                                this.setTLBR(e[0], e[1], e[2], e[3]);
                                break;
                            case 3:
                                this.setTLBR(e[0], e[1], e[2]);
                                break;
                            case 2:
                                this.setTLBR(e[0], e[1]);
                                break;
                            case 1:
                                {
                                    const t = e[0];
                                    if (t instanceof i) this.model = {
                                        top: t.model.top,
                                        left: t.model.left,
                                        bottom: t.model.bottom,
                                        right: t.model.right,
                                        sheetName: t.sheetName
                                    };
                                    else if (t instanceof Array) this.decode(t);
                                    else if (t.top && t.left && t.bottom && t.right) this.model = {
                                        top: t.top,
                                        left: t.left,
                                        bottom: t.bottom,
                                        right: t.right,
                                        sheetName: t.sheetName
                                    };
                                    else {
                                        const e = n.decodeEx(t);
                                        e.top ? this.model = {
                                            top: e.top,
                                            left: e.left,
                                            bottom: e.bottom,
                                            right: e.right,
                                            sheetName: e.sheetName
                                        } : this.model = {
                                            top: e.row,
                                            left: e.col,
                                            bottom: e.row,
                                            right: e.col,
                                            sheetName: e.sheetName
                                        };
                                    }
                                    break;
                                }
                            case 0:
                                this.model = {
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0
                                };
                                break;
                            default:
                                throw new Error("Invalid number of arguments to _getDimensions() - " + e.length);
                        }
                    }
                    get top() {
                        return this.model.top || 1;
                    }
                    set top(e) {
                        this.model.top = e;
                    }
                    get left() {
                        return this.model.left || 1;
                    }
                    set left(e) {
                        this.model.left = e;
                    }
                    get bottom() {
                        return this.model.bottom || 1;
                    }
                    set bottom(e) {
                        this.model.bottom = e;
                    }
                    get right() {
                        return this.model.right || 1;
                    }
                    set right(e) {
                        this.model.right = e;
                    }
                    get sheetName() {
                        return this.model.sheetName;
                    }
                    set sheetName(e) {
                        this.model.sheetName = e;
                    }
                    get _serialisedSheetName() {
                        const { sheetName: e } = this.model;
                        return e ? /^[a-zA-Z0-9]*$/.test(e) ? e + "!" : `'${e}'!` : "";
                    }
                    expand(e, t, r, n) {
                        (!this.model.top || e < this.top) && (this.top = e), (!this.model.left || t < this.left) && (this.left = t), (!this.model.bottom || r > this.bottom) && (this.bottom = r), (!this.model.right || n > this.right) && (this.right = n);
                    }
                    expandRow(e) {
                        if (e) {
                            const { dimensions: t, number: r } = e;
                            t && this.expand(r, t.min, r, t.max);
                        }
                    }
                    expandToAddress(e) {
                        const t = n.decodeEx(e);
                        this.expand(t.row, t.col, t.row, t.col);
                    }
                    get tl() {
                        return n.n2l(this.left) + this.top;
                    }
                    get $t$l() {
                        return `$${n.n2l(this.left)}$${this.top}`;
                    }
                    get br() {
                        return n.n2l(this.right) + this.bottom;
                    }
                    get $b$r() {
                        return `$${n.n2l(this.right)}$${this.bottom}`;
                    }
                    get range() {
                        return `${this._serialisedSheetName + this.tl}:${this.br}`;
                    }
                    get $range() {
                        return `${this._serialisedSheetName + this.$t$l}:${this.$b$r}`;
                    }
                    get shortRange() {
                        return this.count > 1 ? this.range : this._serialisedSheetName + this.tl;
                    }
                    get $shortRange() {
                        return this.count > 1 ? this.$range : this._serialisedSheetName + this.$t$l;
                    }
                    get count() {
                        return (1 + this.bottom - this.top) * (1 + this.right - this.left);
                    }
                    toString() {
                        return this.range;
                    }
                    intersects(e) {
                        return (!e.sheetName || !this.sheetName || e.sheetName === this.sheetName) && !(e.bottom < this.top) && !(e.top > this.bottom) && !(e.right < this.left) && !(e.left > this.right);
                    }
                    contains(e) {
                        const t = n.decodeEx(e);
                        return this.containsEx(t);
                    }
                    containsEx(e) {
                        return (!e.sheetName || !this.sheetName || e.sheetName === this.sheetName) && e.row >= this.top && e.row <= this.bottom && e.col >= this.left && e.col <= this.right;
                    }
                    forEachAddress(e) {
                        for(let t = this.left; t <= this.right; t++)for(let r = this.top; r <= this.bottom; r++)e(n.encodeAddress(r, t), r, t);
                    }
                }
                t.exports = i;
            },
            {
                "../utils/col-cache": 19
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("./enums"), s = e("../utils/col-cache"), o = e("./cell");
                t.exports = class {
                    constructor(e, t){
                        this._worksheet = e, this._number = t, this._cells = [], this.style = {}, this.outlineLevel = 0;
                    }
                    get number() {
                        return this._number;
                    }
                    get worksheet() {
                        return this._worksheet;
                    }
                    commit() {
                        this._worksheet._commitRow(this);
                    }
                    destroy() {
                        delete this._worksheet, delete this._cells, delete this.style;
                    }
                    findCell(e) {
                        return this._cells[e - 1];
                    }
                    getCellEx(e) {
                        let t = this._cells[e.col - 1];
                        if (!t) {
                            const r = this._worksheet.getColumn(e.col);
                            t = new o(this, r, e.address), this._cells[e.col - 1] = t;
                        }
                        return t;
                    }
                    getCell(e) {
                        if ("string" == typeof e) {
                            const t = this._worksheet.getColumnKey(e);
                            e = t ? t.number : s.l2n(e);
                        }
                        return this._cells[e - 1] || this.getCellEx({
                            address: s.encodeAddress(this._number, e),
                            row: this._number,
                            col: e
                        });
                    }
                    splice(e, t) {
                        const r = e + t;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        const o = i.length - t, a = this._cells.length;
                        let l, c, u;
                        if (o < 0) for(l = e + i.length; l <= a; l++)u = this._cells[l - 1], c = this._cells[l - o - 1], c ? (u = this.getCell(l), u.value = c.value, u.style = c.style, u._comment = c._comment) : u && (u.value = null, u.style = {}, u._comment = void 0);
                        else if (o > 0) for(l = a; l >= r; l--)c = this._cells[l - 1], c ? (u = this.getCell(l + o), u.value = c.value, u.style = c.style, u._comment = c._comment) : this._cells[l + o - 1] = void 0;
                        for(l = 0; l < i.length; l++)u = this.getCell(e + l), u.value = i[l], u.style = {}, u._comment = void 0;
                    }
                    eachCell(e, t) {
                        if (t || (t = e, e = null), e && e.includeEmpty) {
                            const e = this._cells.length;
                            for(let r = 1; r <= e; r++)t(this.getCell(r), r);
                        } else this._cells.forEach((e, r)=>{
                            e && e.type !== i.ValueType.Null && t(e, r + 1);
                        });
                    }
                    addPageBreak(e, t) {
                        const r = this._worksheet, n = Math.max(0, e - 1) || 0, i = Math.max(0, t - 1) || 16838, s = {
                            id: this._number,
                            max: i,
                            man: 1
                        };
                        n && (s.min = n), r.rowBreaks.push(s);
                    }
                    get values() {
                        const e = [];
                        return this._cells.forEach((t)=>{
                            t && t.type !== i.ValueType.Null && (e[t.col] = t.value);
                        }), e;
                    }
                    set values(e) {
                        if (this._cells = [], e) {
                            if (e instanceof Array) {
                                let t = 0;
                                e.hasOwnProperty("0") && (t = 1), e.forEach((e, r)=>{
                                    void 0 !== e && (this.getCellEx({
                                        address: s.encodeAddress(this._number, r + t),
                                        row: this._number,
                                        col: r + t
                                    }).value = e);
                                });
                            } else this._worksheet.eachColumnKey((t, r)=>{
                                void 0 !== e[r] && (this.getCellEx({
                                    address: s.encodeAddress(this._number, t.number),
                                    row: this._number,
                                    col: t.number
                                }).value = e[r]);
                            });
                        } else ;
                    }
                    get hasValues() {
                        return n.some(this._cells, (e)=>e && e.type !== i.ValueType.Null);
                    }
                    get cellCount() {
                        return this._cells.length;
                    }
                    get actualCellCount() {
                        let e = 0;
                        return this.eachCell(()=>{
                            e++;
                        }), e;
                    }
                    get dimensions() {
                        let e = 0, t = 0;
                        return this._cells.forEach((r)=>{
                            r && r.type !== i.ValueType.Null && ((!e || e > r.col) && (e = r.col), t < r.col && (t = r.col));
                        }), e > 0 ? {
                            min: e,
                            max: t
                        } : null;
                    }
                    _applyStyle(e, t) {
                        return this.style[e] = t, this._cells.forEach((r)=>{
                            r && (r[e] = t);
                        }), t;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this._applyStyle("numFmt", e);
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this._applyStyle("font", e);
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this._applyStyle("alignment", e);
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this._applyStyle("protection", e);
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this._applyStyle("border", e);
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this._applyStyle("fill", e);
                    }
                    get hidden() {
                        return !!this._hidden;
                    }
                    set hidden(e) {
                        this._hidden = e;
                    }
                    get outlineLevel() {
                        return this._outlineLevel || 0;
                    }
                    set outlineLevel(e) {
                        this._outlineLevel = e;
                    }
                    get collapsed() {
                        return !!(this._outlineLevel && this._outlineLevel >= this._worksheet.properties.outlineLevelRow);
                    }
                    get model() {
                        const e = [];
                        let t = 0, r = 0;
                        return this._cells.forEach((n)=>{
                            if (n) {
                                const i = n.model;
                                i && ((!t || t > n.col) && (t = n.col), r < n.col && (r = n.col), e.push(i));
                            }
                        }), this.height || e.length ? {
                            cells: e,
                            number: this.number,
                            min: t,
                            max: r,
                            height: this.height,
                            style: this.style,
                            hidden: this.hidden,
                            outlineLevel: this.outlineLevel,
                            collapsed: this.collapsed
                        } : null;
                    }
                    set model(e) {
                        if (e.number !== this._number) throw new Error("Invalid row number in model");
                        let t;
                        this._cells = [], e.cells.forEach((e)=>{
                            switch(e.type){
                                case o.Types.Merge:
                                    break;
                                default:
                                    {
                                        let r;
                                        if (e.address) r = s.decodeAddress(e.address);
                                        else if (t) {
                                            const { row: e } = t, n = t.col + 1;
                                            r = {
                                                row: e,
                                                col: n,
                                                address: s.encodeAddress(e, n),
                                                $col$row: `$${s.n2l(n)}$${e}`
                                            };
                                        }
                                        t = r;
                                        this.getCellEx(r).model = e;
                                        break;
                                    }
                            }
                        }), e.height ? this.height = e.height : delete this.height, this.hidden = e.hidden, this.outlineLevel = e.outlineLevel || 0, this.style = e.style && JSON.parse(JSON.stringify(e.style)) || {};
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./cell": 3,
                "./enums": 7
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(e, t, r){
                        this.table = e, this.column = t, this.index = r;
                    }
                    _set(e, t) {
                        this.table.cacheState(), this.column[e] = t;
                    }
                    get name() {
                        return this.column.name;
                    }
                    set name(e) {
                        this._set("name", e);
                    }
                    get filterButton() {
                        return this.column.filterButton;
                    }
                    set filterButton(e) {
                        this.column.filterButton = e;
                    }
                    get style() {
                        return this.column.style;
                    }
                    set style(e) {
                        this.column.style = e;
                    }
                    get totalsRowLabel() {
                        return this.column.totalsRowLabel;
                    }
                    set totalsRowLabel(e) {
                        this._set("totalsRowLabel", e);
                    }
                    get totalsRowFunction() {
                        return this.column.totalsRowFunction;
                    }
                    set totalsRowFunction(e) {
                        this._set("totalsRowFunction", e);
                    }
                    get totalsRowResult() {
                        return this.column.totalsRowResult;
                    }
                    set totalsRowResult(e) {
                        this._set("totalsRowResult", e);
                    }
                    get totalsRowFormula() {
                        return this.column.totalsRowFormula;
                    }
                    set totalsRowFormula(e) {
                        this._set("totalsRowFormula", e);
                    }
                }
                t.exports = class {
                    constructor(e, t){
                        this.worksheet = e, t && (this.table = t, this.validate(), this.store());
                    }
                    getFormula(e) {
                        switch(e.totalsRowFunction){
                            case "none":
                                return null;
                            case "average":
                                return `SUBTOTAL(101,${this.table.name}[${e.name}])`;
                            case "countNums":
                                return `SUBTOTAL(102,${this.table.name}[${e.name}])`;
                            case "count":
                                return `SUBTOTAL(103,${this.table.name}[${e.name}])`;
                            case "max":
                                return `SUBTOTAL(104,${this.table.name}[${e.name}])`;
                            case "min":
                                return `SUBTOTAL(105,${this.table.name}[${e.name}])`;
                            case "stdDev":
                                return `SUBTOTAL(106,${this.table.name}[${e.name}])`;
                            case "var":
                                return `SUBTOTAL(107,${this.table.name}[${e.name}])`;
                            case "sum":
                                return `SUBTOTAL(109,${this.table.name}[${e.name}])`;
                            case "custom":
                                return e.totalsRowFormula;
                            default:
                                throw new Error("Invalid Totals Row Function: " + e.totalsRowFunction);
                        }
                    }
                    get width() {
                        return this.table.columns.length;
                    }
                    get height() {
                        return this.table.rows.length;
                    }
                    get filterHeight() {
                        return this.height + (this.table.headerRow ? 1 : 0);
                    }
                    get tableHeight() {
                        return this.filterHeight + (this.table.totalsRow ? 1 : 0);
                    }
                    validate() {
                        const { table: e } = this, t = (e, t, r)=>{
                            void 0 === e[t] && (e[t] = r);
                        };
                        t(e, "headerRow", !0), t(e, "totalsRow", !1), t(e, "style", {}), t(e.style, "theme", "TableStyleMedium2"), t(e.style, "showFirstColumn", !1), t(e.style, "showLastColumn", !1), t(e.style, "showRowStripes", !1), t(e.style, "showColumnStripes", !1);
                        const r = (e, t)=>{
                            if (!e) throw new Error(t);
                        };
                        r(e.ref, "Table must have ref"), r(e.columns, "Table must have column definitions"), r(e.rows, "Table must have row definitions"), e.tl = n.decodeAddress(e.ref);
                        const { row: i, col: s } = e.tl;
                        r(i > 0, "Table must be on valid row"), r(s > 0, "Table must be on valid col");
                        const { width: o, filterHeight: a, tableHeight: l } = this;
                        e.autoFilterRef = n.encode(i, s, i + a - 1, s + o - 1), e.tableRef = n.encode(i, s, i + l - 1, s + o - 1), e.columns.forEach((e, n)=>{
                            r(e.name, `Column ${n} must have a name`), 0 === n ? t(e, "totalsRowLabel", "Total") : (t(e, "totalsRowFunction", "none"), e.totalsRowFormula = this.getFormula(e));
                        });
                    }
                    store() {
                        const e = (e, t)=>{
                            t && Object.keys(t).forEach((r)=>{
                                e[r] = t[r];
                            });
                        }, { worksheet: t, table: r } = this, { row: n, col: i } = r.tl;
                        let s = 0;
                        if (r.headerRow) {
                            const o = t.getRow(n + s++);
                            r.columns.forEach((t, r)=>{
                                const { style: n, name: s } = t, a = o.getCell(i + r);
                                a.value = s, e(a, n);
                            });
                        }
                        if (r.rows.forEach((o)=>{
                            const a = t.getRow(n + s++);
                            o.forEach((t, n)=>{
                                const s = a.getCell(i + n);
                                s.value = t, e(s, r.columns[n].style);
                            });
                        }), r.totalsRow) {
                            const o = t.getRow(n + s++);
                            r.columns.forEach((t, r)=>{
                                const n = o.getCell(i + r);
                                if (0 === r) n.value = t.totalsRowLabel;
                                else {
                                    const e = this.getFormula(t);
                                    n.value = e ? {
                                        formula: t.totalsRowFormula,
                                        result: t.totalsRowResult
                                    } : null;
                                }
                                e(n, t.style);
                            });
                        }
                    }
                    load(e) {
                        const { table: t } = this, { row: r, col: n } = t.tl;
                        let i = 0;
                        if (t.headerRow) {
                            const s = e.getRow(r + i++);
                            t.columns.forEach((e, t)=>{
                                s.getCell(n + t).value = e.name;
                            });
                        }
                        if (t.rows.forEach((t)=>{
                            const s = e.getRow(r + i++);
                            t.forEach((e, t)=>{
                                s.getCell(n + t).value = e;
                            });
                        }), t.totalsRow) {
                            const s = e.getRow(r + i++);
                            t.columns.forEach((e, t)=>{
                                const r = s.getCell(n + t);
                                if (0 === t) r.value = e.totalsRowLabel;
                                else this.getFormula(e) && (r.value = {
                                    formula: e.totalsRowFormula,
                                    result: e.totalsRowResult
                                });
                            });
                        }
                    }
                    get model() {
                        return this.table;
                    }
                    set model(e) {
                        this.table = e;
                    }
                    cacheState() {
                        this._cache || (this._cache = {
                            ref: this.ref,
                            width: this.width,
                            tableHeight: this.tableHeight
                        });
                    }
                    commit() {
                        if (!this._cache) return;
                        this.validate();
                        const e = n.decodeAddress(this._cache.ref);
                        if (this.ref !== this._cache.ref) for(let t = 0; t < this._cache.tableHeight; t++){
                            const r = this.worksheet.getRow(e.row + t);
                            for(let t = 0; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                        }
                        else {
                            for(let t = this.tableHeight; t < this._cache.tableHeight; t++){
                                const r = this.worksheet.getRow(e.row + t);
                                for(let t = 0; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                            }
                            for(let t = 0; t < this.tableHeight; t++){
                                const r = this.worksheet.getRow(e.row + t);
                                for(let t = this.width; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                            }
                        }
                        this.store();
                    }
                    addRow(e, t) {
                        this.cacheState(), void 0 === t ? this.table.rows.push(e) : this.table.rows.splice(t, 0, e);
                    }
                    removeRows(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                        this.cacheState(), this.table.rows.splice(e, t);
                    }
                    getColumn(e) {
                        const t = this.table.columns[e];
                        return new i(this, t, e);
                    }
                    addColumn(e, t, r) {
                        this.cacheState(), void 0 === r ? (this.table.columns.push(e), this.table.rows.forEach((e, r)=>{
                            e.push(t[r]);
                        })) : (this.table.columns.splice(r, 0, e), this.table.rows.forEach((e, n)=>{
                            e.splice(r, 0, t[n]);
                        }));
                    }
                    removeColumns(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                        this.cacheState(), this.table.columns.splice(e, t), this.table.rows.forEach((r)=>{
                            r.splice(e, t);
                        });
                    }
                    _assign(e, t, r) {
                        this.cacheState(), e[t] = r;
                    }
                    get ref() {
                        return this.table.ref;
                    }
                    set ref(e) {
                        this._assign(this.table, "ref", e);
                    }
                    get name() {
                        return this.table.name;
                    }
                    set name(e) {
                        this.table.name = e;
                    }
                    get displayName() {
                        return this.table.displyName || this.table.name;
                    }
                    set displayNamename(e) {
                        this.table.displayName = e;
                    }
                    get headerRow() {
                        return this.table.headerRow;
                    }
                    set headerRow(e) {
                        this._assign(this.table, "headerRow", e);
                    }
                    get totalsRow() {
                        return this.table.totalsRow;
                    }
                    set totalsRow(e) {
                        this._assign(this.table, "totalsRow", e);
                    }
                    get theme() {
                        return this.table.style.name;
                    }
                    set theme(e) {
                        this.table.style.name = e;
                    }
                    get showFirstColumn() {
                        return this.table.style.showFirstColumn;
                    }
                    set showFirstColumn(e) {
                        this.table.style.showFirstColumn = e;
                    }
                    get showLastColumn() {
                        return this.table.style.showLastColumn;
                    }
                    set showLastColumn(e) {
                        this.table.style.showLastColumn = e;
                    }
                    get showRowStripes() {
                        return this.table.style.showRowStripes;
                    }
                    set showRowStripes(e) {
                        this.table.style.showRowStripes = e;
                    }
                    get showColumnStripes() {
                        return this.table.style.showColumnStripes;
                    }
                    set showColumnStripes(e) {
                        this.table.style.showColumnStripes = e;
                    }
                };
            },
            {
                "../utils/col-cache": 19
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                const n = e("./worksheet"), i = e("./defined-names"), s = e("../xlsx/xlsx"), o = e("../csv/csv");
                t.exports = class {
                    constructor(){
                        this.category = "", this.company = "", this.created = new Date, this.description = "", this.keywords = "", this.manager = "", this.modified = this.created, this.properties = {}, this.calcProperties = {}, this._worksheets = [], this.subject = "", this.title = "", this.views = [], this.media = [], this._definedNames = new i;
                    }
                    get xlsx() {
                        return this._xlsx || (this._xlsx = new s(this)), this._xlsx;
                    }
                    get csv() {
                        return this._csv || (this._csv = new o(this)), this._csv;
                    }
                    get nextId() {
                        for(let e = 1; e < this._worksheets.length; e++)if (!this._worksheets[e]) return e;
                        return this._worksheets.length || 1;
                    }
                    addWorksheet(e, t) {
                        const r = this.nextId;
                        t && ("string" == typeof t ? (console.trace('tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { argb: "rbg value" } }'), t = {
                            properties: {
                                tabColor: {
                                    argb: t
                                }
                            }
                        }) : (t.argb || t.theme || t.indexed) && (console.trace("tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { ... } }"), t = {
                            properties: {
                                tabColor: t
                            }
                        }));
                        const i = this._worksheets.reduce((e, t)=>(t && t.orderNo) > e ? t.orderNo : e, 0), s = Object.assign({}, t, {
                            id: r,
                            name: e,
                            orderNo: i + 1,
                            workbook: this
                        }), o = new n(s);
                        return this._worksheets[r] = o, o;
                    }
                    removeWorksheetEx(e) {
                        delete this._worksheets[e.id];
                    }
                    removeWorksheet(e) {
                        const t = this.getWorksheet(e);
                        t && t.destroy();
                    }
                    getWorksheet(e) {
                        return void 0 === e ? this._worksheets.find(Boolean) : "number" == typeof e ? this._worksheets[e] : "string" == typeof e ? this._worksheets.find((t)=>t && t.name === e) : void 0;
                    }
                    get worksheets() {
                        return this._worksheets.slice(1).sort((e, t)=>e.orderNo - t.orderNo).filter(Boolean);
                    }
                    eachSheet(e) {
                        this.worksheets.forEach((t)=>{
                            e(t, t.id);
                        });
                    }
                    get definedNames() {
                        return this._definedNames;
                    }
                    clearThemes() {
                        this._themes = void 0;
                    }
                    addImage(e) {
                        const t = this.media.length;
                        return this.media.push(Object.assign({}, e, {
                            type: "image"
                        })), t;
                    }
                    getImage(e) {
                        return this.media[e];
                    }
                    get model() {
                        return {
                            creator: this.creator || "Unknown",
                            lastModifiedBy: this.lastModifiedBy || "Unknown",
                            lastPrinted: this.lastPrinted,
                            created: this.created,
                            modified: this.modified,
                            properties: this.properties,
                            worksheets: this.worksheets.map((e)=>e.model),
                            sheets: this.worksheets.map((e)=>e.model).filter(Boolean),
                            definedNames: this._definedNames.model,
                            views: this.views,
                            company: this.company,
                            manager: this.manager,
                            title: this.title,
                            subject: this.subject,
                            keywords: this.keywords,
                            category: this.category,
                            description: this.description,
                            language: this.language,
                            revision: this.revision,
                            contentStatus: this.contentStatus,
                            themes: this._themes,
                            media: this.media,
                            calcProperties: this.calcProperties
                        };
                    }
                    set model(e) {
                        this.creator = e.creator, this.lastModifiedBy = e.lastModifiedBy, this.lastPrinted = e.lastPrinted, this.created = e.created, this.modified = e.modified, this.company = e.company, this.manager = e.manager, this.title = e.title, this.subject = e.subject, this.keywords = e.keywords, this.category = e.category, this.description = e.description, this.language = e.language, this.revision = e.revision, this.contentStatus = e.contentStatus, this.properties = e.properties, this.calcProperties = e.calcProperties, this._worksheets = [], e.worksheets.forEach((t)=>{
                            const { id: r, name: i, state: s } = t, o = e.sheets && e.sheets.findIndex((e)=>e.id === r);
                            (this._worksheets[r] = new n({
                                id: r,
                                name: i,
                                orderNo: o,
                                state: s,
                                workbook: this
                            })).model = t;
                        }), this._definedNames.model = e.definedNames, this.views = e.views, this._themes = e.themes, this.media = e.media || [];
                    }
                };
            },
            {
                "../csv/csv": 1,
                "../xlsx/xlsx": 144,
                "./defined-names": 6,
                "./worksheet": 14
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("../utils/col-cache"), s = e("./range"), o = e("./row"), a = e("./column"), l = e("./enums"), c = e("./image"), u = e("./table"), h = e("./data-validations"), f = e("../utils/encryptor"), { copyStyle: d } = e("../utils/copy-style");
                t.exports = class {
                    constructor(e){
                        e = e || {}, this._workbook = e.workbook, this.id = e.id, this.orderNo = e.orderNo, this.name = e.name, this.state = e.state || "visible", this._rows = [], this._columns = null, this._keys = {}, this._merges = {}, this.rowBreaks = [], this.properties = Object.assign({}, {
                            defaultRowHeight: 15,
                            dyDescent: 55,
                            outlineLevelCol: 0,
                            outlineLevelRow: 0
                        }, e.properties), this.pageSetup = Object.assign({}, {
                            margins: {
                                left: .7,
                                right: .7,
                                top: .75,
                                bottom: .75,
                                header: .3,
                                footer: .3
                            },
                            orientation: "portrait",
                            horizontalDpi: 4294967295,
                            verticalDpi: 4294967295,
                            fitToPage: !(!e.pageSetup || !e.pageSetup.fitToWidth && !e.pageSetup.fitToHeight || e.pageSetup.scale),
                            pageOrder: "downThenOver",
                            blackAndWhite: !1,
                            draft: !1,
                            cellComments: "None",
                            errors: "displayed",
                            scale: 100,
                            fitToWidth: 1,
                            fitToHeight: 1,
                            paperSize: void 0,
                            showRowColHeaders: !1,
                            showGridLines: !1,
                            firstPageNumber: void 0,
                            horizontalCentered: !1,
                            verticalCentered: !1,
                            rowBreaks: null,
                            colBreaks: null
                        }, e.pageSetup), this.headerFooter = Object.assign({}, {
                            differentFirst: !1,
                            differentOddEven: !1,
                            oddHeader: null,
                            oddFooter: null,
                            evenHeader: null,
                            evenFooter: null,
                            firstHeader: null,
                            firstFooter: null
                        }, e.headerFooter), this.dataValidations = new h, this.views = e.views || [], this.autoFilter = e.autoFilter || null, this._media = [], this.sheetProtection = null, this.tables = {}, this.conditionalFormattings = [];
                    }
                    get name() {
                        return this._name;
                    }
                    set name(e) {
                        if (void 0 === e && (e = "sheet" + this.id), this._name !== e) {
                            if ("string" != typeof e) throw new Error("The name has to be a string.");
                            if ("" === e) throw new Error("The name can't be empty.");
                            if ("History" === e) throw new Error('The name "History" is protected. Please use a different name.');
                            if (/[*?:/\\[\]]/.test(e)) throw new Error(`Worksheet name ${e} cannot include any of the following characters: * ? : \\ / [ ]`);
                            if (/(^')|('$)/.test(e)) throw new Error("The first or last character of worksheet name cannot be a single quotation mark: " + e);
                            if (e && e.length > 31 && (console.warn(`Worksheet name ${e} exceeds 31 chars. This will be truncated`), e = e.substring(0, 31)), this._workbook._worksheets.find((t)=>t && t.name.toLowerCase() === e.toLowerCase())) throw new Error("Worksheet name already exists: " + e);
                            this._name = e;
                        }
                    }
                    get workbook() {
                        return this._workbook;
                    }
                    destroy() {
                        this._workbook.removeWorksheetEx(this);
                    }
                    get dimensions() {
                        const e = new s;
                        return this._rows.forEach((t)=>{
                            if (t) {
                                const r = t.dimensions;
                                r && e.expand(t.number, r.min, t.number, r.max);
                            }
                        }), e;
                    }
                    get columns() {
                        return this._columns;
                    }
                    set columns(e) {
                        this._headerRowCount = e.reduce((e, t)=>{
                            const r = (t.header ? 1 : t.headers && t.headers.length) || 0;
                            return Math.max(e, r);
                        }, 0);
                        let t = 1;
                        const r = this._columns = [];
                        e.forEach((e)=>{
                            const n = new a(this, t++, !1);
                            r.push(n), n.defn = e;
                        });
                    }
                    getColumnKey(e) {
                        return this._keys[e];
                    }
                    setColumnKey(e, t) {
                        this._keys[e] = t;
                    }
                    deleteColumnKey(e) {
                        delete this._keys[e];
                    }
                    eachColumnKey(e) {
                        n.each(this._keys, e);
                    }
                    getColumn(e) {
                        if ("string" == typeof e) {
                            const t = this._keys[e];
                            if (t) return t;
                            e = i.l2n(e);
                        }
                        if (this._columns || (this._columns = []), e > this._columns.length) {
                            let t = this._columns.length + 1;
                            for(; t <= e;)this._columns.push(new a(this, t++));
                        }
                        return this._columns[e - 1];
                    }
                    spliceColumns(e, t) {
                        const r = this._rows.length;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        if (i.length > 0) for(let n = 0; n < r; n++){
                            const r = [
                                e,
                                t
                            ];
                            i.forEach((e)=>{
                                r.push(e[n] || null);
                            });
                            const s = this.getRow(n + 1);
                            s.splice.apply(s, r);
                        }
                        else this._rows.forEach((r)=>{
                            r && r.splice(e, t);
                        });
                        const o = i.length - t, a = e + t, l = this._columns.length;
                        if (o < 0) for(let t = e + i.length; t <= l; t++)this.getColumn(t).defn = this.getColumn(t - o).defn;
                        else if (o > 0) for(let e = l; e >= a; e--)this.getColumn(e + o).defn = this.getColumn(e).defn;
                        for(let t = e; t < e + i.length; t++)this.getColumn(t).defn = null;
                        this.workbook.definedNames.spliceColumns(this.name, e, t, i.length);
                    }
                    get lastColumn() {
                        return this.getColumn(this.columnCount);
                    }
                    get columnCount() {
                        let e = 0;
                        return this.eachRow((t)=>{
                            e = Math.max(e, t.cellCount);
                        }), e;
                    }
                    get actualColumnCount() {
                        const e = [];
                        let t = 0;
                        return this.eachRow((r)=>{
                            r.eachCell((r)=>{
                                let { col: n } = r;
                                e[n] || (e[n] = !0, t++);
                            });
                        }), t;
                    }
                    _commitRow() {}
                    get _lastRowNumber() {
                        const e = this._rows;
                        let t = e.length;
                        for(; t > 0 && void 0 === e[t - 1];)t--;
                        return t;
                    }
                    get _nextRow() {
                        return this._lastRowNumber + 1;
                    }
                    get lastRow() {
                        if (this._rows.length) return this._rows[this._rows.length - 1];
                    }
                    findRow(e) {
                        return this._rows[e - 1];
                    }
                    findRows(e, t) {
                        return this._rows.slice(e - 1, e - 1 + t);
                    }
                    get rowCount() {
                        return this._lastRowNumber;
                    }
                    get actualRowCount() {
                        let e = 0;
                        return this.eachRow(()=>{
                            e++;
                        }), e;
                    }
                    getRow(e) {
                        let t = this._rows[e - 1];
                        return t || (t = this._rows[e - 1] = new o(this, e)), t;
                    }
                    getRows(e, t) {
                        if (t < 1) return;
                        const r = [];
                        for(let n = e; n < e + t; n++)r.push(this.getRow(n));
                        return r;
                    }
                    addRow(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        const r = this._nextRow, n = this.getRow(r);
                        return n.values = e, this._setStyleOption(r, "i" === t[0] ? t : "n"), n;
                    }
                    addRows(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        const r = [];
                        return e.forEach((e)=>{
                            r.push(this.addRow(e, t));
                        }), r;
                    }
                    insertRow(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "n";
                        return this.spliceRows(e, 0, t), this._setStyleOption(e, r), this.getRow(e);
                    }
                    insertRows(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "n";
                        if (this.spliceRows(e, 0, ...t), "n" !== r) for(let n = 0; n < t.length; n++)"o" === r[0] && void 0 !== this.findRow(t.length + e + n) ? this._copyStyle(t.length + e + n, e + n, "+" === r[1]) : "i" === r[0] && void 0 !== this.findRow(e - 1) && this._copyStyle(e - 1, e + n, "+" === r[1]);
                        return this.getRows(e, t.length);
                    }
                    _setStyleOption(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        "o" === t[0] && void 0 !== this.findRow(e + 1) ? this._copyStyle(e + 1, e, "+" === t[1]) : "i" === t[0] && void 0 !== this.findRow(e - 1) && this._copyStyle(e - 1, e, "+" === t[1]);
                    }
                    _copyStyle(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const n = this.getRow(e), i = this.getRow(t);
                        i.style = d(n.style), n.eachCell({
                            includeEmpty: r
                        }, (e, t)=>{
                            i.getCell(t).style = d(e.style);
                        }), i.height = n.height;
                    }
                    duplicateRow(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const n = this._rows[e - 1], i = new Array(t).fill(n.values);
                        this.spliceRows(e + 1, r ? 0 : t, ...i);
                        for(let r = 0; r < t; r++){
                            const t = this._rows[e + r];
                            t.style = n.style, t.height = n.height, n.eachCell({
                                includeEmpty: !0
                            }, (e, r)=>{
                                t.getCell(r).style = e.style;
                            });
                        }
                    }
                    spliceRows(e, t) {
                        const r = e + t;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        const o = i.length, a = o - t, l = this._rows.length;
                        let c, u;
                        if (a < 0) for(e === l && (this._rows[l - 1] = void 0), c = r; c <= l; c++)if (u = this._rows[c - 1], u) {
                            const e = this.getRow(c + a);
                            e.values = u.values, e.style = u.style, e.height = u.height, u.eachCell({
                                includeEmpty: !0
                            }, (t, r)=>{
                                e.getCell(r).style = t.style;
                            }), this._rows[c - 1] = void 0;
                        } else this._rows[c + a - 1] = void 0;
                        else if (a > 0) for(c = l; c >= r; c--)if (u = this._rows[c - 1], u) {
                            const e = this.getRow(c + a);
                            e.values = u.values, e.style = u.style, e.height = u.height, u.eachCell({
                                includeEmpty: !0
                            }, (t, r)=>{
                                if (e.getCell(r).style = t.style, "MergeValue" === t._value.constructor.name) {
                                    const e = this.getRow(t._row._number + o).getCell(r), n = t._value._master, i = this.getRow(n._row._number + o).getCell(n._column._number);
                                    e.merge(i);
                                }
                            });
                        } else this._rows[c + a - 1] = void 0;
                        for(c = 0; c < o; c++){
                            const t = this.getRow(e + c);
                            t.style = {}, t.values = i[c];
                        }
                        this.workbook.definedNames.spliceRows(this.name, e, t, o);
                    }
                    eachRow(e, t) {
                        if (t || (t = e, e = void 0), e && e.includeEmpty) {
                            const e = this._rows.length;
                            for(let r = 1; r <= e; r++)t(this.getRow(r), r);
                        } else this._rows.forEach((e)=>{
                            e && e.hasValues && t(e, e.number);
                        });
                    }
                    getSheetValues() {
                        const e = [];
                        return this._rows.forEach((t)=>{
                            t && (e[t.number] = t.values);
                        }), e;
                    }
                    findCell(e, t) {
                        const r = i.getAddress(e, t), n = this._rows[r.row - 1];
                        return n ? n.findCell(r.col) : void 0;
                    }
                    getCell(e, t) {
                        const r = i.getAddress(e, t);
                        return this.getRow(r.row).getCellEx(r);
                    }
                    mergeCells() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        this._mergeCellsInternal(n);
                    }
                    mergeCellsWithoutStyle() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        this._mergeCellsInternal(n, !0);
                    }
                    _mergeCellsInternal(e, t) {
                        n.each(this._merges, (t)=>{
                            if (t.intersects(e)) throw new Error("Cannot merge already merged cells");
                        });
                        const r = this.getCell(e.top, e.left);
                        for(let n = e.top; n <= e.bottom; n++)for(let i = e.left; i <= e.right; i++)(n > e.top || i > e.left) && this.getCell(n, i).merge(r, t);
                        this._merges[r.address] = e;
                    }
                    _unMergeMaster(e) {
                        const t = this._merges[e.address];
                        if (t) {
                            for(let e = t.top; e <= t.bottom; e++)for(let r = t.left; r <= t.right; r++)this.getCell(e, r).unmerge();
                            delete this._merges[e.address];
                        }
                    }
                    get hasMerges() {
                        return n.some(this._merges, Boolean);
                    }
                    unMergeCells() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        for(let e = n.top; e <= n.bottom; e++)for(let t = n.left; t <= n.right; t++){
                            const r = this.findCell(e, t);
                            r && (r.type === l.ValueType.Merge ? this._unMergeMaster(r.master) : this._merges[r.address] && this._unMergeMaster(r));
                        }
                    }
                    fillFormula(e, t, r) {
                        let n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "shared";
                        const s = i.decode(e), { top: o, left: a, bottom: l, right: c } = s, u = c - a + 1, h = i.encodeAddress(o, a), f = "shared" === n;
                        let d;
                        d = "function" == typeof r ? r : Array.isArray(r) ? Array.isArray(r[0]) ? (e, t)=>r[e - o][t - a] : (e, t)=>r[(e - o) * u + (t - a)] : ()=>{};
                        let p = !0;
                        for(let r = o; r <= l; r++)for(let i = a; i <= c; i++)p ? (this.getCell(r, i).value = {
                            shareType: n,
                            formula: t,
                            ref: e,
                            result: d(r, i)
                        }, p = !1) : this.getCell(r, i).value = f ? {
                            sharedFormula: h,
                            result: d(r, i)
                        } : d(r, i);
                    }
                    addImage(e, t) {
                        const r = {
                            type: "image",
                            imageId: e,
                            range: t
                        };
                        this._media.push(new c(this, r));
                    }
                    getImages() {
                        return this._media.filter((e)=>"image" === e.type);
                    }
                    addBackgroundImage(e) {
                        const t = {
                            type: "background",
                            imageId: e
                        };
                        this._media.push(new c(this, t));
                    }
                    getBackgroundImageId() {
                        const e = this._media.find((e)=>"background" === e.type);
                        return e && e.imageId;
                    }
                    protect(e, t) {
                        return new Promise((r)=>{
                            this.sheetProtection = {
                                sheet: !0
                            }, t && "spinCount" in t && (t.spinCount = Number.isFinite(t.spinCount) ? Math.round(Math.max(0, t.spinCount)) : 1e5), e && (this.sheetProtection.algorithmName = "SHA-512", this.sheetProtection.saltValue = f.randomBytes(16).toString("base64"), this.sheetProtection.spinCount = t && "spinCount" in t ? t.spinCount : 1e5, this.sheetProtection.hashValue = f.convertPasswordToHash(e, "SHA512", this.sheetProtection.saltValue, this.sheetProtection.spinCount)), t && (this.sheetProtection = Object.assign(this.sheetProtection, t), !e && "spinCount" in t && delete this.sheetProtection.spinCount), r();
                        });
                    }
                    unprotect() {
                        this.sheetProtection = null;
                    }
                    addTable(e) {
                        const t = new u(this, e);
                        return this.tables[e.name] = t, t;
                    }
                    getTable(e) {
                        return this.tables[e];
                    }
                    removeTable(e) {
                        delete this.tables[e];
                    }
                    getTables() {
                        return Object.values(this.tables);
                    }
                    addConditionalFormatting(e) {
                        this.conditionalFormattings.push(e);
                    }
                    removeConditionalFormatting(e) {
                        "number" == typeof e ? this.conditionalFormattings.splice(e, 1) : this.conditionalFormattings = e instanceof Function ? this.conditionalFormattings.filter(e) : [];
                    }
                    get tabColor() {
                        return console.trace("worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor"), this.properties.tabColor;
                    }
                    set tabColor(e) {
                        console.trace("worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor"), this.properties.tabColor = e;
                    }
                    get model() {
                        const e = {
                            id: this.id,
                            name: this.name,
                            dataValidations: this.dataValidations.model,
                            properties: this.properties,
                            state: this.state,
                            pageSetup: this.pageSetup,
                            headerFooter: this.headerFooter,
                            rowBreaks: this.rowBreaks,
                            views: this.views,
                            autoFilter: this.autoFilter,
                            media: this._media.map((e)=>e.model),
                            sheetProtection: this.sheetProtection,
                            tables: Object.values(this.tables).map((e)=>e.model),
                            conditionalFormattings: this.conditionalFormattings
                        };
                        e.cols = a.toModel(this.columns);
                        const t = e.rows = [], r = e.dimensions = new s;
                        return this._rows.forEach((e)=>{
                            const n = e && e.model;
                            n && (r.expand(n.number, n.min, n.number, n.max), t.push(n));
                        }), e.merges = [], n.each(this._merges, (t)=>{
                            e.merges.push(t.range);
                        }), e;
                    }
                    _parseRows(e) {
                        this._rows = [], e.rows.forEach((e)=>{
                            const t = new o(this, e.number);
                            this._rows[t.number - 1] = t, t.model = e;
                        });
                    }
                    _parseMergeCells(e) {
                        n.each(e.mergeCells, (e)=>{
                            this.mergeCellsWithoutStyle(e);
                        });
                    }
                    set model(e) {
                        this.name = e.name, this._columns = a.fromModel(this, e.cols), this._parseRows(e), this._parseMergeCells(e), this.dataValidations = new h(e.dataValidations), this.properties = e.properties, this.pageSetup = e.pageSetup, this.headerFooter = e.headerFooter, this.views = e.views, this.autoFilter = e.autoFilter, this._media = e.media.map((e)=>new c(this, e)), this.sheetProtection = e.sheetProtection, this.tables = e.tables.reduce((e, t)=>{
                            const r = new u;
                            return r.model = t, e[t.name] = r, e;
                        }, {}), this.conditionalFormattings = e.conditionalFormattings;
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "../utils/copy-style": 20,
                "../utils/encryptor": 21,
                "../utils/under-dash": 26,
                "./column": 4,
                "./data-validations": 5,
                "./enums": 7,
                "./image": 8,
                "./range": 10,
                "./row": 11,
                "./table": 12
            }
        ],
        15: [
            function(e, t, r) {
                "use strict";
                e("core-js/modules/es.promise"), e("core-js/modules/es.promise.finally"), e("core-js/modules/es.object.assign"), e("core-js/modules/es.object.keys"), e("core-js/modules/es.object.values"), e("core-js/modules/es.symbol"), e("core-js/modules/es.symbol.async-iterator"), e("core-js/modules/es.array.iterator"), e("core-js/modules/es.array.includes"), e("core-js/modules/es.array.find-index"), e("core-js/modules/es.array.find"), e("core-js/modules/es.string.from-code-point"), e("core-js/modules/es.string.includes"), e("core-js/modules/es.number.is-nan"), e("regenerator-runtime/runtime");
                const n = {
                    Workbook: e("./doc/workbook")
                }, i = e("./doc/enums");
                Object.keys(i).forEach((e)=>{
                    n[e] = i[e];
                }), t.exports = n;
            },
            {
                "./doc/enums": 7,
                "./doc/workbook": 13,
                "core-js/modules/es.array.find": 359,
                "core-js/modules/es.array.find-index": 358,
                "core-js/modules/es.array.includes": 360,
                "core-js/modules/es.array.iterator": 361,
                "core-js/modules/es.number.is-nan": 363,
                "core-js/modules/es.object.assign": 364,
                "core-js/modules/es.object.keys": 366,
                "core-js/modules/es.object.values": 367,
                "core-js/modules/es.promise": 372,
                "core-js/modules/es.promise.finally": 371,
                "core-js/modules/es.string.from-code-point": 376,
                "core-js/modules/es.string.includes": 377,
                "core-js/modules/es.symbol": 381,
                "core-js/modules/es.symbol.async-iterator": 378,
                "regenerator-runtime/runtime": 492
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                const n = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
                r.bufferToString = function(e) {
                    return "string" == typeof e ? e : n ? n.decode(e) : e.toString();
                };
            },
            {}
        ],
        17: [
            function(e, t, r) {
                "use strict";
                const n = "undefined" == typeof TextEncoder ? null : new TextEncoder("utf-8"), { Buffer: i } = e("buffer");
                r.stringToBuffer = function(e) {
                    return "string" != typeof e ? e : n ? i.from(n.encode(e).buffer) : i.from(e);
                };
            },
            {
                buffer: 220
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                const n = e("./under-dash"), i = e("./col-cache");
                t.exports = class {
                    constructor(e){
                        this.template = e, this.sheets = {};
                    }
                    addCell(e) {
                        this.addCellEx(i.decodeEx(e));
                    }
                    getCell(e) {
                        return this.findCellEx(i.decodeEx(e), !0);
                    }
                    findCell(e) {
                        return this.findCellEx(i.decodeEx(e), !1);
                    }
                    findCellAt(e, t, r) {
                        const n = this.sheets[e], i = n && n[t];
                        return i && i[r];
                    }
                    addCellEx(e) {
                        if (e.top) for(let t = e.top; t <= e.bottom; t++)for(let r = e.left; r <= e.right; r++)this.getCellAt(e.sheetName, t, r);
                        else this.findCellEx(e, !0);
                    }
                    getCellEx(e) {
                        return this.findCellEx(e, !0);
                    }
                    findCellEx(e, t) {
                        const r = this.findSheet(e, t), n = this.findSheetRow(r, e, t);
                        return this.findRowCell(n, e, t);
                    }
                    getCellAt(e, t, r) {
                        const n = this.sheets[e] || (this.sheets[e] = []), s = n[t] || (n[t] = []);
                        return s[r] || (s[r] = {
                            sheetName: e,
                            address: i.n2l(r) + t,
                            row: t,
                            col: r
                        });
                    }
                    removeCellEx(e) {
                        const t = this.findSheet(e);
                        if (!t) return;
                        const r = this.findSheetRow(t, e);
                        r && delete r[e.col];
                    }
                    forEachInSheet(e, t) {
                        const r = this.sheets[e];
                        r && r.forEach((e, r)=>{
                            e && e.forEach((e, n)=>{
                                e && t(e, r, n);
                            });
                        });
                    }
                    forEach(e) {
                        n.each(this.sheets, (t, r)=>{
                            this.forEachInSheet(r, e);
                        });
                    }
                    map(e) {
                        const t = [];
                        return this.forEach((r)=>{
                            t.push(e(r));
                        }), t;
                    }
                    findSheet(e, t) {
                        const r = e.sheetName;
                        return this.sheets[r] ? this.sheets[r] : t ? this.sheets[r] = [] : void 0;
                    }
                    findSheetRow(e, t, r) {
                        const { row: n } = t;
                        return e && e[n] ? e[n] : r ? e[n] = [] : void 0;
                    }
                    findRowCell(e, t, r) {
                        const { col: n } = t;
                        return e && e[n] ? e[n] : r ? e[n] = this.template ? Object.assign(t, JSON.parse(JSON.stringify(this.template))) : t : void 0;
                    }
                    spliceRows(e, t, r, n) {
                        const i = this.sheets[e];
                        if (i) {
                            const e = [];
                            for(let t = 0; t < n; t++)e.push([]);
                            i.splice(t, r, ...e);
                        }
                    }
                    spliceColumns(e, t, r, i) {
                        const s = this.sheets[e];
                        if (s) {
                            const e = [];
                            for(let t = 0; t < i; t++)e.push(null);
                            n.each(s, (n)=>{
                                n.splice(t, r, ...e);
                            });
                        }
                    }
                };
            },
            {
                "./col-cache": 19,
                "./under-dash": 26
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                const n = /^[A-Z]+\d+$/, i = {
                    _dictionary: [
                        "A",
                        "B",
                        "C",
                        "D",
                        "E",
                        "F",
                        "G",
                        "H",
                        "I",
                        "J",
                        "K",
                        "L",
                        "M",
                        "N",
                        "O",
                        "P",
                        "Q",
                        "R",
                        "S",
                        "T",
                        "U",
                        "V",
                        "W",
                        "X",
                        "Y",
                        "Z"
                    ],
                    _l2nFill: 0,
                    _l2n: {},
                    _n2l: [],
                    _level: (e)=>e <= 26 ? 1 : e <= 676 ? 2 : 3,
                    _fill (e) {
                        let t, r, n, i, s, o = 1;
                        if (e >= 4) throw new Error("Out of bounds. Excel supports columns from 1 to 16384");
                        if (this._l2nFill < 1 && e >= 1) {
                            for(; o <= 26;)t = this._dictionary[o - 1], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 1;
                        }
                        if (this._l2nFill < 2 && e >= 2) {
                            for(o = 27; o <= 702;)r = o - 27, n = r % 26, i = Math.floor(r / 26), t = this._dictionary[i] + this._dictionary[n], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 2;
                        }
                        if (this._l2nFill < 3 && e >= 3) {
                            for(o = 703; o <= 16384;)r = o - 703, n = r % 26, i = Math.floor(r / 26) % 26, s = Math.floor(r / 676), t = this._dictionary[s] + this._dictionary[i] + this._dictionary[n], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 3;
                        }
                    },
                    l2n (e) {
                        if (this._l2n[e] || this._fill(e.length), !this._l2n[e]) throw new Error("Out of bounds. Invalid column letter: " + e);
                        return this._l2n[e];
                    },
                    n2l (e) {
                        if (e < 1 || e > 16384) throw new Error(e + " is out of bounds. Excel supports columns from 1 to 16384");
                        return this._n2l[e] || this._fill(this._level(e)), this._n2l[e];
                    },
                    _hash: {},
                    validateAddress (e) {
                        if (!n.test(e)) throw new Error("Invalid Address: " + e);
                        return !0;
                    },
                    decodeAddress (e) {
                        const t = e.length < 5 && this._hash[e];
                        if (t) return t;
                        let r = !1, n = "", i = 0, s = !1, o = "", a = 0;
                        for(let t, l = 0; l < e.length; l++)if (t = e.charCodeAt(l), !s && t >= 65 && t <= 90) r = !0, n += e[l], i = 26 * i + t - 64;
                        else if (t >= 48 && t <= 57) s = !0, o += e[l], a = 10 * a + t - 48;
                        else if (s && r && 36 !== t) break;
                        if (r) {
                            if (i > 16384) throw new Error("Out of bounds. Invalid column letter: " + n);
                        } else i = void 0;
                        s || (a = void 0);
                        const l = {
                            address: e = n + o,
                            col: i,
                            row: a,
                            $col$row: `$${n}$${o}`
                        };
                        return i <= 100 && a <= 100 && (this._hash[e] = l, this._hash[l.$col$row] = l), l;
                    },
                    getAddress (e, t) {
                        if (t) {
                            const r = this.n2l(t) + e;
                            return this.decodeAddress(r);
                        }
                        return this.decodeAddress(e);
                    },
                    decode (e) {
                        const t = e.split(":");
                        if (2 === t.length) {
                            const e = this.decodeAddress(t[0]), r = this.decodeAddress(t[1]), n = {
                                top: Math.min(e.row, r.row),
                                left: Math.min(e.col, r.col),
                                bottom: Math.max(e.row, r.row),
                                right: Math.max(e.col, r.col)
                            };
                            return n.tl = this.n2l(n.left) + n.top, n.br = this.n2l(n.right) + n.bottom, n.dimensions = `${n.tl}:${n.br}`, n;
                        }
                        return this.decodeAddress(e);
                    },
                    decodeEx (e) {
                        const t = e.match(/(?:(?:(?:'((?:[^']|'')*)')|([^'^ !]*))!)?(.*)/), r = t[1] || t[2], n = t[3], i = n.split(":");
                        if (i.length > 1) {
                            let e = this.decodeAddress(i[0]), t = this.decodeAddress(i[1]);
                            const n = Math.min(e.row, t.row), s = Math.min(e.col, t.col), o = Math.max(e.row, t.row), a = Math.max(e.col, t.col);
                            return e = this.n2l(s) + n, t = this.n2l(a) + o, {
                                top: n,
                                left: s,
                                bottom: o,
                                right: a,
                                sheetName: r,
                                tl: {
                                    address: e,
                                    col: s,
                                    row: n,
                                    $col$row: `$${this.n2l(s)}$${n}`,
                                    sheetName: r
                                },
                                br: {
                                    address: t,
                                    col: a,
                                    row: o,
                                    $col$row: `$${this.n2l(a)}$${o}`,
                                    sheetName: r
                                },
                                dimensions: `${e}:${t}`
                            };
                        }
                        if (n.startsWith("#")) return r ? {
                            sheetName: r,
                            error: n
                        } : {
                            error: n
                        };
                        const s = this.decodeAddress(n);
                        return r ? {
                            sheetName: r,
                            ...s
                        } : s;
                    },
                    encodeAddress: (e, t)=>i.n2l(t) + e,
                    encode () {
                        switch(arguments.length){
                            case 2:
                                return i.encodeAddress(arguments[0], arguments[1]);
                            case 4:
                                return `${i.encodeAddress(arguments[0], arguments[1])}:${i.encodeAddress(arguments[2], arguments[3])}`;
                            default:
                                throw new Error("Can only encode with 2 or 4 arguments");
                        }
                    },
                    inRange (e, t) {
                        const [r, n, , i, s] = e, [o, a] = t;
                        return o >= r && o <= i && a >= n && a <= s;
                    }
                };
                t.exports = i;
            },
            {}
        ],
        20: [
            function(e, t, r) {
                "use strict";
                const n = (e, t)=>({
                        ...e,
                        ...t.reduce((t, r)=>(e[r] && (t[r] = {
                                ...e[r]
                            }), t), {})
                    }), i = function(e, t, r) {
                    let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
                    e[r] && (t[r] = n(e[r], i));
                };
                r.copyStyle = (e)=>{
                    if (!e) return e;
                    if (t = e, 0 === Object.keys(t).length) return {};
                    var t;
                    const r = {
                        ...e
                    };
                    return i(e, r, "font", [
                        "color"
                    ]), i(e, r, "alignment"), i(e, r, "protection"), e.border && (i(e, r, "border"), i(e.border, r.border, "top", [
                        "color"
                    ]), i(e.border, r.border, "left", [
                        "color"
                    ]), i(e.border, r.border, "bottom", [
                        "color"
                    ]), i(e.border, r.border, "right", [
                        "color"
                    ]), i(e.border, r.border, "diagonal", [
                        "color"
                    ])), e.fill && (i(e, r, "fill", [
                        "fgColor",
                        "bgColor",
                        "center"
                    ]), e.fill.stops && (r.fill.stops = e.fill.stops.map((e)=>n(e, [
                            "color"
                        ])))), r;
                };
            },
            {}
        ],
        21: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        const n = e("crypto"), i = {
                            hash (e) {
                                const t = n.createHash(e);
                                for(var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++)s[o - 1] = arguments[o];
                                return t.update(r.concat(s)), t.digest();
                            },
                            convertPasswordToHash (e, t, i, s) {
                                t = t.toLowerCase();
                                if (n.getHashes().indexOf(t) < 0) throw new Error(`Hash algorithm '${t}' not supported!`);
                                const o = r.from(e, "utf16le");
                                let a = this.hash(t, r.from(i, "base64"), o);
                                for(let e = 0; e < s; e++){
                                    const n = r.alloc(4);
                                    n.writeUInt32LE(e, 0), a = this.hash(t, a, n);
                                }
                                return a.toString("base64");
                            },
                            randomBytes: (e)=>n.randomBytes(e)
                        };
                        t.exports = i;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220,
                crypto: 390
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                const { SaxesParser: n } = e("saxes"), { PassThrough: i } = e("readable-stream"), { bufferToString: s } = e("./browser-buffer-decode");
                t.exports = async function*(e) {
                    e.pipe && !e[Symbol.asyncIterator] && (e = e.pipe(new i));
                    const t = new n;
                    let r;
                    t.on("error", (e)=>{
                        r = e;
                    });
                    let o = [];
                    t.on("opentag", (e)=>o.push({
                            eventType: "opentag",
                            value: e
                        })), t.on("text", (e)=>o.push({
                            eventType: "text",
                            value: e
                        })), t.on("closetag", (e)=>o.push({
                            eventType: "closetag",
                            value: e
                        }));
                    for await (const n of e){
                        if (t.write(s(n)), r) throw r;
                        yield o, o = [];
                    }
                };
            },
            {
                "./browser-buffer-decode": 16,
                "readable-stream": 491,
                saxes: 496
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                const n = e("./col-cache"), i = /(([a-z_\-0-9]*)!)?([a-z0-9_$]{2,})([(])?/gi, s = /^([$])?([a-z]+)([$])?([1-9][0-9]*)$/i;
                t.exports = {
                    slideFormula: function(e, t, r) {
                        const o = n.decode(t), a = n.decode(r);
                        return e.replace(i, (e, t, r, i, l)=>{
                            if (l) return e;
                            const c = s.exec(i);
                            if (c) {
                                const r = c[1], i = c[2].toUpperCase(), s = c[3], l = c[4];
                                if (i.length > 3 || 3 === i.length && i > "XFD") return e;
                                let u = n.l2n(i), h = parseInt(l, 10);
                                r || (u += a.col - o.col), s || (h += a.row - o.row);
                                return (t || "") + (r || "") + n.n2l(u) + (s || "") + h;
                            }
                            return e;
                        });
                    }
                };
            },
            {
                "./col-cache": 19
            }
        ],
        24: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("readable-stream"), s = e("./utils"), o = e("./string-buf");
                        class a {
                            constructor(e, t){
                                this._data = e, this._encoding = t;
                            }
                            get length() {
                                return this.toBuffer().length;
                            }
                            copy(e, t, r, n) {
                                return this.toBuffer().copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._buffer || (this._buffer = n.from(this._data, this._encoding)), this._buffer;
                            }
                        }
                        class l {
                            constructor(e){
                                this._data = e;
                            }
                            get length() {
                                return this._data.length;
                            }
                            copy(e, t, r, n) {
                                return this._data._buf.copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._data.toBuffer();
                            }
                        }
                        class c {
                            constructor(e){
                                this._data = e;
                            }
                            get length() {
                                return this._data.length;
                            }
                            copy(e, t, r, n) {
                                this._data.copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._data;
                            }
                        }
                        class u {
                            constructor(e){
                                this.size = e, this.buffer = n.alloc(e), this.iRead = 0, this.iWrite = 0;
                            }
                            toBuffer() {
                                if (0 === this.iRead && this.iWrite === this.size) return this.buffer;
                                const e = n.alloc(this.iWrite - this.iRead);
                                return this.buffer.copy(e, 0, this.iRead, this.iWrite), e;
                            }
                            get length() {
                                return this.iWrite - this.iRead;
                            }
                            get eod() {
                                return this.iRead === this.iWrite;
                            }
                            get full() {
                                return this.iWrite === this.size;
                            }
                            read(e) {
                                let t;
                                return 0 === e ? null : void 0 === e || e >= this.length ? (t = this.toBuffer(), this.iRead = this.iWrite, t) : (t = n.alloc(e), this.buffer.copy(t, 0, this.iRead, e), this.iRead += e, t);
                            }
                            write(e, t, r) {
                                const n = Math.min(r, this.size - this.iWrite);
                                return e.copy(this.buffer, this.iWrite, t, t + n), this.iWrite += n, n;
                            }
                        }
                        const h = function(e) {
                            e = e || {}, this.bufSize = e.bufSize || 1048576, this.buffers = [], this.batch = e.batch || !1, this.corked = !1, this.inPos = 0, this.outPos = 0, this.pipes = [], this.paused = !1, this.encoding = null;
                        };
                        s.inherits(h, i.Duplex, {
                            toBuffer () {
                                switch(this.buffers.length){
                                    case 0:
                                        return null;
                                    case 1:
                                        return this.buffers[0].toBuffer();
                                    default:
                                        return n.concat(this.buffers.map((e)=>e.toBuffer()));
                                }
                            },
                            _getWritableBuffer () {
                                if (this.buffers.length) {
                                    const e = this.buffers[this.buffers.length - 1];
                                    if (!e.full) return e;
                                }
                                const e = new u(this.bufSize);
                                return this.buffers.push(e), e;
                            },
                            async _pipe (e) {
                                await Promise.all(this.pipes.map(function(t) {
                                    return new Promise((r)=>{
                                        t.write(e.toBuffer(), ()=>{
                                            r();
                                        });
                                    });
                                }));
                            },
                            _writeToBuffers (e) {
                                let t = 0;
                                const r = e.length;
                                for(; t < r;)t += this._getWritableBuffer().write(e, t, r - t);
                            },
                            async write (e, t, i) {
                                let u;
                                if (t instanceof Function && (i = t, t = "utf8"), i = i || s.nop, e instanceof o) u = new l(e);
                                else if (e instanceof n) u = new c(e);
                                else {
                                    if (!("string" == typeof e || e instanceof String || e instanceof ArrayBuffer)) throw new Error("Chunk must be one of type String, Buffer or StringBuf.");
                                    u = new a(e, t);
                                }
                                if (this.pipes.length) {
                                    if (this.batch) for(this._writeToBuffers(u); !this.corked && this.buffers.length > 1;)this._pipe(this.buffers.shift());
                                    else this.corked ? (this._writeToBuffers(u), r.nextTick(i)) : (await this._pipe(u), i());
                                } else this.paused || this.emit("data", u.toBuffer()), this._writeToBuffers(u), this.emit("readable");
                                return !0;
                            },
                            cork () {
                                this.corked = !0;
                            },
                            _flush () {
                                if (this.pipes.length) for(; this.buffers.length;)this._pipe(this.buffers.shift());
                            },
                            uncork () {
                                this.corked = !1, this._flush();
                            },
                            end (e, t, r) {
                                const n = (e)=>{
                                    e ? r(e) : (this._flush(), this.pipes.forEach((e)=>{
                                        e.end();
                                    }), this.emit("finish"));
                                };
                                e ? this.write(e, t, n) : n();
                            },
                            read (e) {
                                let t;
                                if (e) {
                                    for(t = []; e && this.buffers.length && !this.buffers[0].eod;){
                                        const r = this.buffers[0], n = r.read(e);
                                        e -= n.length, t.push(n), r.eod && r.full && this.buffers.shift();
                                    }
                                    return n.concat(t);
                                }
                                return t = this.buffers.map((e)=>e.toBuffer()).filter(Boolean), this.buffers = [], n.concat(t);
                            },
                            setEncoding (e) {
                                this.encoding = e;
                            },
                            pause () {
                                this.paused = !0;
                            },
                            resume () {
                                this.paused = !1;
                            },
                            isPaused () {
                                return !!this.paused;
                            },
                            pipe (e) {
                                this.pipes.push(e), !this.paused && this.buffers.length && this.end();
                            },
                            unpipe (e) {
                                this.pipes = this.pipes.filter((t)=>t !== e);
                            },
                            unshift () {
                                throw new Error("Not Implemented");
                            },
                            wrap () {
                                throw new Error("Not Implemented");
                            }
                        }), t.exports = h;
                    }).call(this);
                }).call(this, e("_process"), e("buffer").Buffer);
            },
            {
                "./string-buf": 25,
                "./utils": 27,
                _process: 467,
                buffer: 220,
                "readable-stream": 491
            }
        ],
        25: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        t.exports = class {
                            constructor(t){
                                this._buf = e.alloc(t && t.size || 16384), this._encoding = t && t.encoding || "utf8", this._inPos = 0, this._buffer = void 0;
                            }
                            get length() {
                                return this._inPos;
                            }
                            get capacity() {
                                return this._buf.length;
                            }
                            get buffer() {
                                return this._buf;
                            }
                            toBuffer() {
                                return this._buffer || (this._buffer = e.alloc(this.length), this._buf.copy(this._buffer, 0, 0, this.length)), this._buffer;
                            }
                            reset(e) {
                                e = e || 0, this._buffer = void 0, this._inPos = e;
                            }
                            _grow(t) {
                                let r = 2 * this._buf.length;
                                for(; r < t;)r *= 2;
                                const n = e.alloc(r);
                                this._buf.copy(n, 0), this._buf = n;
                            }
                            addText(e) {
                                this._buffer = void 0;
                                let t = this._inPos + this._buf.write(e, this._inPos, this._encoding);
                                for(; t >= this._buf.length - 4;)this._grow(this._inPos + e.length), t = this._inPos + this._buf.write(e, this._inPos, this._encoding);
                                this._inPos = t;
                            }
                            addStringBuf(e) {
                                e.length && (this._buffer = void 0, this.length + e.length > this.capacity && this._grow(this.length + e.length), e._buf.copy(this._buf, this._inPos, 0, e.length), this._inPos += e.length);
                            }
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                const { toString: n } = Object.prototype, i = /["&<>]/, s = {
                    each: function(e, t) {
                        e && (Array.isArray(e) ? e.forEach(t) : Object.keys(e).forEach((r)=>{
                            t(e[r], r);
                        }));
                    },
                    some: function(e, t) {
                        return !!e && (Array.isArray(e) ? e.some(t) : Object.keys(e).some((r)=>t(e[r], r)));
                    },
                    every: function(e, t) {
                        return !e || (Array.isArray(e) ? e.every(t) : Object.keys(e).every((r)=>t(e[r], r)));
                    },
                    map: function(e, t) {
                        return e ? Array.isArray(e) ? e.map(t) : Object.keys(e).map((r)=>t(e[r], r)) : [];
                    },
                    keyBy: (e, t)=>e.reduce((e, r)=>(e[r[t]] = r, e), {}),
                    isEqual: function(e, t) {
                        const r = typeof e, n = typeof t, i = Array.isArray(e), o = Array.isArray(t);
                        let a;
                        if (r !== n) return !1;
                        switch(typeof e){
                            case "object":
                                if (i || o) return !(!i || !o) && e.length === t.length && e.every((e, r)=>{
                                    const n = t[r];
                                    return s.isEqual(e, n);
                                });
                                if (null === e || null === t) return e === t;
                                if (a = Object.keys(e), Object.keys(t).length !== a.length) return !1;
                                for (const e of a)if (!t.hasOwnProperty(e)) return !1;
                                return s.every(e, (e, r)=>{
                                    const n = t[r];
                                    return s.isEqual(e, n);
                                });
                            default:
                                return e === t;
                        }
                    },
                    escapeHtml (e) {
                        const t = i.exec(e);
                        if (!t) return e;
                        let r = "", n = "", s = 0, o = t.index;
                        for(; o < e.length; o++){
                            switch(e.charAt(o)){
                                case '"':
                                    n = "&quot;";
                                    break;
                                case "&":
                                    n = "&amp;";
                                    break;
                                case "'":
                                    n = "&apos;";
                                    break;
                                case "<":
                                    n = "&lt;";
                                    break;
                                case ">":
                                    n = "&gt;";
                                    break;
                                default:
                                    continue;
                            }
                            s !== o && (r += e.substring(s, o)), s = o + 1, r += n;
                        }
                        return s !== o ? r + e.substring(s, o) : r;
                    },
                    strcmp: (e, t)=>e < t ? -1 : e > t ? 1 : 0,
                    isUndefined: (e)=>"[object Undefined]" === n.call(e),
                    isObject: (e)=>"[object Object]" === n.call(e),
                    deepMerge () {
                        const e = arguments[0] || {}, { length: t } = arguments;
                        let r, n, i;
                        function o(t, o) {
                            r = e[o], i = Array.isArray(t), s.isObject(t) || i ? (i ? (i = !1, n = r && Array.isArray(r) ? r : []) : n = r && s.isObject(r) ? r : {}, e[o] = s.deepMerge(n, t)) : s.isUndefined(t) || (e[o] = t);
                        }
                        for(let e = 0; e < t; e++)s.each(arguments[e], o);
                        return e;
                    }
                };
                t.exports = s;
            },
            {}
        ],
        27: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("fs"), s = /[<>&'"\x7F\x00-\x08\x0B-\x0C\x0E-\x1F]/, o = {
                            nop () {},
                            promiseImmediate: (e)=>new Promise((t)=>{
                                    r.setImmediate ? n(()=>{
                                        t(e);
                                    }) : setTimeout(()=>{
                                        t(e);
                                    }, 1);
                                }),
                            inherits: function(e, t, r, n) {
                                e.super_ = t, n || (n = r, r = null), r && Object.keys(r).forEach((t)=>{
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                                const i = {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !1,
                                        configurable: !0
                                    }
                                };
                                n && Object.keys(n).forEach((e)=>{
                                    i[e] = Object.getOwnPropertyDescriptor(n, e);
                                }), e.prototype = Object.create(t.prototype, i);
                            },
                            dateToExcel: (e, t)=>25569 + e.getTime() / 864e5 - (t ? 1462 : 0),
                            excelToDate (e, t) {
                                const r = Math.round(24 * (e - 25569 + (t ? 1462 : 0)) * 3600000);
                                return new Date(r);
                            },
                            parsePath (e) {
                                const t = e.lastIndexOf("/");
                                return {
                                    path: e.substring(0, t),
                                    name: e.substring(t + 1)
                                };
                            },
                            getRelsPath (e) {
                                const t = o.parsePath(e);
                                return `${t.path}/_rels/${t.name}.rels`;
                            },
                            xmlEncode (e) {
                                const t = s.exec(e);
                                if (!t) return e;
                                let r = "", n = "", i = 0, o = t.index;
                                for(; o < e.length; o++){
                                    const t = e.charCodeAt(o);
                                    switch(t){
                                        case 34:
                                            n = "&quot;";
                                            break;
                                        case 38:
                                            n = "&amp;";
                                            break;
                                        case 39:
                                            n = "&apos;";
                                            break;
                                        case 60:
                                            n = "&lt;";
                                            break;
                                        case 62:
                                            n = "&gt;";
                                            break;
                                        case 127:
                                            n = "";
                                            break;
                                        default:
                                            if (t <= 31 && (t <= 8 || t >= 11 && 13 !== t)) {
                                                n = "";
                                                break;
                                            }
                                            continue;
                                    }
                                    i !== o && (r += e.substring(i, o)), i = o + 1, n && (r += n);
                                }
                                return i !== o ? r + e.substring(i, o) : r;
                            },
                            xmlDecode: (e)=>e.replace(/&([a-z]*);/g, (e)=>{
                                    switch(e){
                                        case "&lt;":
                                            return "<";
                                        case "&gt;":
                                            return ">";
                                        case "&amp;":
                                            return "&";
                                        case "&apos;":
                                            return "'";
                                        case "&quot;":
                                            return '"';
                                        default:
                                            return e;
                                    }
                                }),
                            validInt (e) {
                                const t = parseInt(e, 10);
                                return Number.isNaN(t) ? 0 : t;
                            },
                            isDateFmt (e) {
                                if (!e) return !1;
                                return null !== (e = (e = e.replace(/\[[^\]]*]/g, "")).replace(/"[^"]*"/g, "")).match(/[ymdhMsb]+/);
                            },
                            fs: {
                                exists: (e)=>new Promise((t)=>{
                                        i.access(e, i.constants.F_OK, (e)=>{
                                            t(!e);
                                        });
                                    })
                            },
                            toIsoDateString: (e)=>e.toIsoString().subsstr(0, 10),
                            parseBoolean: (e)=>!0 === e || "true" === e || 1 === e || "1" === e
                        };
                        t.exports = o;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
            },
            {
                fs: 216,
                timers: 523
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                const n = e("./under-dash"), i = e("./utils");
                function s(e, t, r) {
                    e.push(` ${t}="${i.xmlEncode(r.toString())}"`);
                }
                function o(e, t) {
                    if (t) {
                        const r = [];
                        n.each(t, (e, t)=>{
                            void 0 !== e && s(r, t, e);
                        }), e.push(r.join(""));
                    }
                }
                class a {
                    constructor(){
                        this._xml = [], this._stack = [], this._rollbacks = [];
                    }
                    get tos() {
                        return this._stack.length ? this._stack[this._stack.length - 1] : void 0;
                    }
                    get cursor() {
                        return this._xml.length;
                    }
                    openXml(e) {
                        const t = this._xml;
                        t.push("<?xml"), o(t, e), t.push("?>\n");
                    }
                    openNode(e, t) {
                        const r = this.tos, n = this._xml;
                        r && this.open && n.push(">"), this._stack.push(e), n.push("<"), n.push(e), o(n, t), this.leaf = !0, this.open = !0;
                    }
                    addAttribute(e, t) {
                        if (!this.open) throw new Error("Cannot write attributes to node if it is not open");
                        void 0 !== t && s(this._xml, e, t);
                    }
                    addAttributes(e) {
                        if (!this.open) throw new Error("Cannot write attributes to node if it is not open");
                        o(this._xml, e);
                    }
                    writeText(e) {
                        const t = this._xml;
                        this.open && (t.push(">"), this.open = !1), this.leaf = !1, t.push(i.xmlEncode(e.toString()));
                    }
                    writeXml(e) {
                        this.open && (this._xml.push(">"), this.open = !1), this.leaf = !1, this._xml.push(e);
                    }
                    closeNode() {
                        const e = this._stack.pop(), t = this._xml;
                        this.leaf ? t.push("/>") : (t.push("</"), t.push(e), t.push(">")), this.open = !1, this.leaf = !1;
                    }
                    leafNode(e, t, r) {
                        this.openNode(e, t), void 0 !== r && this.writeText(r), this.closeNode();
                    }
                    closeAll() {
                        for(; this._stack.length;)this.closeNode();
                    }
                    addRollback() {
                        return this._rollbacks.push({
                            xml: this._xml.length,
                            stack: this._stack.length,
                            leaf: this.leaf,
                            open: this.open
                        }), this.cursor;
                    }
                    commit() {
                        this._rollbacks.pop();
                    }
                    rollback() {
                        const e = this._rollbacks.pop();
                        this._xml.length > e.xml && this._xml.splice(e.xml, this._xml.length - e.xml), this._stack.length > e.stack && this._stack.splice(e.stack, this._stack.length - e.stack), this.leaf = e.leaf, this.open = e.open;
                    }
                    get xml() {
                        return this.closeAll(), this._xml.join("");
                    }
                }
                a.StdDocAttributes = {
                    version: "1.0",
                    encoding: "UTF-8",
                    standalone: "yes"
                }, t.exports = a;
            },
            {
                "./under-dash": 26,
                "./utils": 27
            }
        ],
        29: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        const n = e("events"), i = e("jszip"), s = e("./stream-buf"), { stringToBuffer: o } = e("./browser-buffer-encode");
                        class a extends n.EventEmitter {
                            constructor(e){
                                super(), this.options = Object.assign({
                                    type: "nodebuffer",
                                    compression: "DEFLATE"
                                }, e), this.zip = new i, this.stream = new s;
                            }
                            append(e, t) {
                                t.hasOwnProperty("base64") && t.base64 ? this.zip.file(t.name, e, {
                                    base64: !0
                                }) : (r.browser && "string" == typeof e && (e = o(e)), this.zip.file(t.name, e));
                            }
                            async finalize() {
                                const e = await this.zip.generateAsync(this.options);
                                this.stream.end(e), this.emit("finish");
                            }
                            read(e) {
                                return this.stream.read(e);
                            }
                            setEncoding(e) {
                                return this.stream.setEncoding(e);
                            }
                            pause() {
                                return this.stream.pause();
                            }
                            resume() {
                                return this.stream.resume();
                            }
                            isPaused() {
                                return this.stream.isPaused();
                            }
                            pipe(e, t) {
                                return this.stream.pipe(e, t);
                            }
                            unpipe(e) {
                                return this.stream.unpipe(e);
                            }
                            unshift(e) {
                                return this.stream.unshift(e);
                            }
                            wrap(e) {
                                return this.stream.wrap(e);
                            }
                        }
                        t.exports = {
                            ZipWriter: a
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./browser-buffer-encode": 17,
                "./stream-buf": 24,
                _process: 467,
                events: 422,
                jszip: 441
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    0: {
                        f: "General"
                    },
                    1: {
                        f: "0"
                    },
                    2: {
                        f: "0.00"
                    },
                    3: {
                        f: "#,##0"
                    },
                    4: {
                        f: "#,##0.00"
                    },
                    9: {
                        f: "0%"
                    },
                    10: {
                        f: "0.00%"
                    },
                    11: {
                        f: "0.00E+00"
                    },
                    12: {
                        f: "# ?/?"
                    },
                    13: {
                        f: "# ??/??"
                    },
                    14: {
                        f: "mm-dd-yy"
                    },
                    15: {
                        f: "d-mmm-yy"
                    },
                    16: {
                        f: "d-mmm"
                    },
                    17: {
                        f: "mmm-yy"
                    },
                    18: {
                        f: "h:mm AM/PM"
                    },
                    19: {
                        f: "h:mm:ss AM/PM"
                    },
                    20: {
                        f: "h:mm"
                    },
                    21: {
                        f: "h:mm:ss"
                    },
                    22: {
                        f: 'm/d/yy "h":mm'
                    },
                    27: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    28: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    29: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    30: {
                        "zh-tw": "m/d/yy ",
                        "zh-cn": "m-d-yy",
                        "ja-jp": "m/d/yy",
                        "ko-kr": "mm-dd-yy"
                    },
                    31: {
                        "zh-tw": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": 'yyyy"\ub144" mm"\uc6d4" dd"\uc77c"'
                    },
                    32: {
                        "zh-tw": 'hh"\u6642"mm"\u5206"',
                        "zh-cn": 'h"\u65f6"mm"\u5206"',
                        "ja-jp": 'h"\u6642"mm"\u5206"',
                        "ko-kr": 'h"\uc2dc" mm"\ubd84"'
                    },
                    33: {
                        "zh-tw": 'hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": 'h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'h"\u6642"mm"\u5206"ss"\u79d2"',
                        "ko-kr": 'h"\uc2dc" mm"\ubd84" ss"\ucd08"'
                    },
                    34: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    35: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    36: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    37: {
                        f: "#,##0 ;(#,##0)"
                    },
                    38: {
                        f: "#,##0 ;[Red](#,##0)"
                    },
                    39: {
                        f: "#,##0.00 ;(#,##0.00)"
                    },
                    40: {
                        f: "#,##0.00 ;[Red](#,##0.00)"
                    },
                    45: {
                        f: "mm:ss"
                    },
                    46: {
                        f: "[h]:mm:ss"
                    },
                    47: {
                        f: "mmss.0"
                    },
                    48: {
                        f: "##0.0E+0"
                    },
                    49: {
                        f: "@"
                    },
                    50: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    51: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    52: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    53: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    54: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    55: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    56: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    57: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    58: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    59: {
                        "th-th": "t0"
                    },
                    60: {
                        "th-th": "t0.00"
                    },
                    61: {
                        "th-th": "t#,##0"
                    },
                    62: {
                        "th-th": "t#,##0.00"
                    },
                    67: {
                        "th-th": "t0%"
                    },
                    68: {
                        "th-th": "t0.00%"
                    },
                    69: {
                        "th-th": "t# ?/?"
                    },
                    70: {
                        "th-th": "t# ??/??"
                    },
                    81: {
                        "th-th": "d/m/bb"
                    }
                };
            },
            {}
        ],
        31: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    OfficeDocument: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
                    Worksheet: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
                    CalcChain: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/calcChain",
                    SharedStrings: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
                    Styles: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
                    Theme: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
                    Hyperlink: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
                    Image: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                    CoreProperties: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
                    ExtenderProperties: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
                    Comments: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
                    VmlDrawing: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
                    Table: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/table"
                };
            },
            {}
        ],
        32: [
            function(e, t, r) {
                "use strict";
                const n = e("../../utils/parse-sax"), i = e("../../utils/xml-stream");
                class s {
                    prepare() {}
                    render() {}
                    parseOpen(e) {}
                    parseText(e) {}
                    parseClose(e) {}
                    reconcile(e, t) {}
                    reset() {
                        this.model = null, this.map && Object.values(this.map).forEach((e)=>{
                            e instanceof s ? e.reset() : e.xform && e.xform.reset();
                        });
                    }
                    mergeModel(e) {
                        this.model = Object.assign(this.model || {}, e);
                    }
                    async parse(e) {
                        for await (const t of e)for (const { eventType: e, value: r } of t)if ("opentag" === e) this.parseOpen(r);
                        else if ("text" === e) this.parseText(r);
                        else if ("closetag" === e && !this.parseClose(r.name)) return this.model;
                        return this.model;
                    }
                    async parseStream(e) {
                        return this.parse(n(e));
                    }
                    get xml() {
                        return this.toXml(this.model);
                    }
                    toXml(e) {
                        const t = new i;
                        return this.render(t, e), t.xml;
                    }
                    static toAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if (void 0 === e) {
                            if (r) return t;
                        } else if (r || e !== t) return e.toString();
                    }
                    static toStringAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toStringValue(e, t) {
                        return void 0 === e ? t : e;
                    }
                    static toBoolAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if (void 0 === e) {
                            if (r) return t;
                        } else if (r || e !== t) return e ? "1" : "0";
                    }
                    static toBoolValue(e, t) {
                        return void 0 === e ? t : "1" === e;
                    }
                    static toIntAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toIntValue(e, t) {
                        return void 0 === e ? t : parseInt(e, 10);
                    }
                    static toFloatAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toFloatValue(e, t) {
                        return void 0 === e ? t : parseFloat(e);
                    }
                }
                t.exports = s;
            },
            {
                "../../utils/parse-sax": 22,
                "../../utils/xml-stream": 28
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/col-cache");
                function s(e) {
                    try {
                        return i.decodeEx(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function o(e) {
                    const t = [];
                    let r = !1, n = "";
                    return e.split(",").forEach((e)=>{
                        if (!e) return;
                        const i = (e.match(/'/g) || []).length;
                        if (!i) return void (r ? n += e + "," : s(e) && t.push(e));
                        const o = i % 2 == 0;
                        !r && o && s(e) ? t.push(e) : r && !o ? (r = !1, s(n + e) && t.push(n + e), n = "") : (r = !0, n += e + ",");
                    }), t;
                }
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("definedName", {
                            name: t.name,
                            localSheetId: t.localSheetId
                        }), e.writeText(t.ranges.join(",")), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "definedName":
                                return this._parsedName = e.attributes.name, this._parsedLocalSheetId = e.attributes.localSheetId, this._parsedText = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._parsedText.push(e);
                    }
                    parseClose() {
                        return this.model = {
                            name: this._parsedName,
                            ranges: o(this._parsedText.join(""))
                        }, void 0 !== this._parsedLocalSheetId && (this.model.localSheetId = parseInt(this._parsedLocalSheetId, 10)), !1;
                    }
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform");
                t.exports = class extends i {
                    render(e, t) {
                        e.leafNode("sheet", {
                            sheetId: t.id,
                            name: t.name,
                            state: t.state,
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        return "sheet" === e.name && (this.model = {
                            name: n.xmlDecode(e.attributes.name),
                            id: parseInt(e.attributes.sheetId, 10),
                            state: e.attributes.state,
                            rId: e.attributes["r:id"]
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("calcPr", {
                            calcId: 171027,
                            fullCalcOnLoad: t.fullCalcOnLoad ? 1 : void 0
                        });
                    }
                    parseOpen(e) {
                        return "calcPr" === e.name && (this.model = {}, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        36: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("workbookPr", {
                            date1904: t.date1904 ? 1 : void 0,
                            defaultThemeVersion: 164011,
                            filterPrivacy: 1
                        });
                    }
                    parseOpen(e) {
                        return "workbookPr" === e.name && (this.model = {
                            date1904: "1" === e.attributes.date1904
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        37: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        const r = {
                            xWindow: t.x || 0,
                            yWindow: t.y || 0,
                            windowWidth: t.width || 12e3,
                            windowHeight: t.height || 24e3,
                            firstSheet: t.firstSheet,
                            activeTab: t.activeTab
                        };
                        t.visibility && "visible" !== t.visibility && (r.visibility = t.visibility), e.leafNode("workbookView", r);
                    }
                    parseOpen(e) {
                        if ("workbookView" === e.name) {
                            const t = this.model = {}, r = function(e, r, n) {
                                const i = void 0 !== r ? t[e] = r : n;
                                void 0 !== i && (t[e] = i);
                            }, n = function(e, r, n) {
                                const i = void 0 !== r ? t[e] = parseInt(r, 10) : n;
                                void 0 !== i && (t[e] = i);
                            };
                            return n("x", e.attributes.xWindow, 0), n("y", e.attributes.yWindow, 0), n("width", e.attributes.windowWidth, 25e3), n("height", e.attributes.windowHeight, 1e4), r("visibility", e.attributes.visibility, "visible"), n("activeTab", e.attributes.activeTab, void 0), n("firstSheet", e.attributes.firstSheet, void 0), !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/col-cache"), s = e("../../../utils/xml-stream"), o = e("../base-xform"), a = e("../static-xform"), l = e("../list-xform"), c = e("./defined-name-xform"), u = e("./sheet-xform"), h = e("./workbook-view-xform"), f = e("./workbook-properties-xform"), d = e("./workbook-calc-properties-xform");
                class p extends o {
                    constructor(){
                        super(), this.map = {
                            fileVersion: p.STATIC_XFORMS.fileVersion,
                            workbookPr: new f,
                            bookViews: new l({
                                tag: "bookViews",
                                count: !1,
                                childXform: new h
                            }),
                            sheets: new l({
                                tag: "sheets",
                                count: !1,
                                childXform: new u
                            }),
                            definedNames: new l({
                                tag: "definedNames",
                                count: !1,
                                childXform: new c
                            }),
                            calcPr: new d
                        };
                    }
                    prepare(e) {
                        e.sheets = e.worksheets;
                        const t = [];
                        let r = 0;
                        e.sheets.forEach((e)=>{
                            if (e.pageSetup && e.pageSetup.printArea && e.pageSetup.printArea.split("&&").forEach((n)=>{
                                const i = n.split(":"), s = {
                                    name: "_xlnm.Print_Area",
                                    ranges: [
                                        `'${e.name}'!$${i[0]}:$${i[1]}`
                                    ],
                                    localSheetId: r
                                };
                                t.push(s);
                            }), e.pageSetup && (e.pageSetup.printTitlesRow || e.pageSetup.printTitlesColumn)) {
                                const n = [];
                                if (e.pageSetup.printTitlesColumn) {
                                    const t = e.pageSetup.printTitlesColumn.split(":");
                                    n.push(`'${e.name}'!$${t[0]}:$${t[1]}`);
                                }
                                if (e.pageSetup.printTitlesRow) {
                                    const t = e.pageSetup.printTitlesRow.split(":");
                                    n.push(`'${e.name}'!$${t[0]}:$${t[1]}`);
                                }
                                const i = {
                                    name: "_xlnm.Print_Titles",
                                    ranges: n,
                                    localSheetId: r
                                };
                                t.push(i);
                            }
                            r++;
                        }), t.length && (e.definedNames = e.definedNames.concat(t)), (e.media || []).forEach((e, t)=>{
                            e.name = e.type + (t + 1);
                        });
                    }
                    render(e, t) {
                        e.openXml(s.StdDocAttributes), e.openNode("workbook", p.WORKBOOK_ATTRIBUTES), this.map.fileVersion.render(e), this.map.workbookPr.render(e, t.properties), this.map.bookViews.render(e, t.views), this.map.sheets.render(e, t.sheets), this.map.definedNames.render(e, t.definedNames), this.map.calcPr.render(e, t.calcProperties), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "workbook":
                                return !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "workbook":
                                return this.model = {
                                    sheets: this.map.sheets.model,
                                    properties: this.map.workbookPr.model || {},
                                    views: this.map.bookViews.model,
                                    calcProperties: {}
                                }, this.map.definedNames.model && (this.model.definedNames = this.map.definedNames.model), !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e) {
                        const t = (e.workbookRels || []).reduce((e, t)=>(e[t.Id] = t, e), {}), r = [];
                        let s, o = 0;
                        (e.sheets || []).forEach((n)=>{
                            const i = t[n.rId];
                            i && (s = e.worksheetHash["xl/" + i.Target.replace(/^(\s|\/xl\/)+/, "")], s && (s.name = n.name, s.id = n.id, s.state = n.state, r[o++] = s));
                        });
                        const a = [];
                        n.each(e.definedNames, (e)=>{
                            if ("_xlnm.Print_Area" === e.name) {
                                if (s = r[e.localSheetId], s) {
                                    s.pageSetup || (s.pageSetup = {});
                                    const t = i.decodeEx(e.ranges[0]);
                                    s.pageSetup.printArea = s.pageSetup.printArea ? `${s.pageSetup.printArea}&&${t.dimensions}` : t.dimensions;
                                }
                            } else if ("_xlnm.Print_Titles" === e.name) {
                                if (s = r[e.localSheetId], s) {
                                    s.pageSetup || (s.pageSetup = {});
                                    const t = e.ranges.join(","), r = /\$/g, n = /\$\d+:\$\d+/, i = t.match(n);
                                    if (i && i.length) {
                                        const e = i[0];
                                        s.pageSetup.printTitlesRow = e.replace(r, "");
                                    }
                                    const o = /\$[A-Z]+:\$[A-Z]+/, a = t.match(o);
                                    if (a && a.length) {
                                        const e = a[0];
                                        s.pageSetup.printTitlesColumn = e.replace(r, "");
                                    }
                                }
                            } else a.push(e);
                        }), e.definedNames = a, e.media.forEach((e, t)=>{
                            e.index = t;
                        });
                    }
                }
                p.WORKBOOK_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x15",
                    "xmlns:x15": "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"
                }, p.STATIC_XFORMS = {
                    fileVersion: new a({
                        tag: "fileVersion",
                        $: {
                            appName: "xl",
                            lastEdited: 5,
                            lowestEdited: 5,
                            rupBuild: 9303
                        }
                    })
                }, t.exports = p;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "../static-xform": 120,
                "./defined-name-xform": 33,
                "./sheet-xform": 34,
                "./workbook-calc-properties-xform": 35,
                "./workbook-properties-xform": 36,
                "./workbook-view-xform": 37
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                const n = e("../strings/rich-text-xform"), i = e("../../../utils/utils"), s = e("../base-xform"), o = t.exports = function(e) {
                    this.model = e;
                };
                i.inherits(o, s, {
                    get tag () {
                        return "r";
                    },
                    get richTextXform () {
                        return this._richTextXform || (this._richTextXform = new n), this._richTextXform;
                    },
                    render (e, t) {
                        t = t || this.model, e.openNode("comment", {
                            ref: t.ref,
                            authorId: 0
                        }), e.openNode("text"), t && t.note && t.note.texts && t.note.texts.forEach((t)=>{
                            this.richTextXform.render(e, t);
                        }), e.closeNode(), e.closeNode();
                    },
                    parseOpen (e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "comment":
                                return this.model = {
                                    type: "note",
                                    note: {
                                        texts: []
                                    },
                                    ...e.attributes
                                }, !0;
                            case "r":
                                return this.parser = this.richTextXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    },
                    parseText (e) {
                        this.parser && this.parser.parseText(e);
                    },
                    parseClose (e) {
                        switch(e){
                            case "comment":
                                return !1;
                            case "r":
                                return this.model.note.texts.push(this.parser.model), this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                });
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "../strings/rich-text-xform": 122
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../../../utils/utils"), s = e("../base-xform"), o = e("./comment-xform"), a = t.exports = function() {
                    this.map = {
                        comment: new o
                    };
                };
                i.inherits(a, s, {
                    COMMENTS_ATTRIBUTES: {
                        xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                    }
                }, {
                    render (e, t) {
                        t = t || this.model, e.openXml(n.StdDocAttributes), e.openNode("comments", a.COMMENTS_ATTRIBUTES), e.openNode("authors"), e.leafNode("author", null, "Author"), e.closeNode(), e.openNode("commentList"), t.comments.forEach((t)=>{
                            this.map.comment.render(e, t);
                        }), e.closeNode(), e.closeNode();
                    },
                    parseOpen (e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "commentList":
                                return this.model = {
                                    comments: []
                                }, !0;
                            case "comment":
                                return this.parser = this.map.comment, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    },
                    parseText (e) {
                        this.parser && this.parser.parseText(e);
                    },
                    parseClose (e) {
                        switch(e){
                            case "commentList":
                                return !1;
                            case "comment":
                                return this.model.comments.push(this.parser.model), this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                });
            },
            {
                "../../../utils/utils": 27,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./comment-xform": 39
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    get tag() {
                        return this._model && this._model.tag;
                    }
                    render(e, t, r) {
                        (t === r[2] || "x:SizeWithCells" === this.tag && t === r[1]) && e.leafNode(this.tag);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {}, this.model[this.tag] = !0, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        42: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    get tag() {
                        return this._model && this._model.tag;
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.text = "", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.text = e;
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "x:Anchor";
                    }
                    getAnchorRect(e) {
                        const t = Math.floor(e.left), r = Math.floor(68 * (e.left - t)), n = Math.floor(e.top), i = Math.floor(18 * (e.top - n)), s = Math.floor(e.right), o = Math.floor(68 * (e.right - s)), a = Math.floor(e.bottom);
                        return [
                            t,
                            r,
                            n,
                            i,
                            s,
                            o,
                            a,
                            Math.floor(18 * (e.bottom - a))
                        ];
                    }
                    getDefaultRect(e) {
                        const t = e.col, r = Math.max(e.row - 2, 0);
                        return [
                            t,
                            6,
                            r,
                            14,
                            t + 2,
                            2,
                            r + 4,
                            16
                        ];
                    }
                    render(e, t) {
                        const r = t.anchor ? this.getAnchorRect(t.anchor) : this.getDefaultRect(t.refAddress);
                        e.leafNode("x:Anchor", null, r.join(", "));
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.text = "", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.text = e;
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        44: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./vml-anchor-xform"), s = e("./style/vml-protection-xform"), o = e("./style/vml-position-xform"), a = [
                    "twoCells",
                    "oneCells",
                    "absolute"
                ];
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "x:Anchor": new i,
                            "x:Locked": new s({
                                tag: "x:Locked"
                            }),
                            "x:LockText": new s({
                                tag: "x:LockText"
                            }),
                            "x:SizeWithCells": new o({
                                tag: "x:SizeWithCells"
                            }),
                            "x:MoveWithCells": new o({
                                tag: "x:MoveWithCells"
                            })
                        };
                    }
                    get tag() {
                        return "x:ClientData";
                    }
                    render(e, t) {
                        const { protection: r, editAs: n } = t.note;
                        e.openNode(this.tag, {
                            ObjectType: "Note"
                        }), this.map["x:MoveWithCells"].render(e, n, a), this.map["x:SizeWithCells"].render(e, n, a), this.map["x:Anchor"].render(e, t), this.map["x:Locked"].render(e, r.locked), e.leafNode("x:AutoFill", null, "False"), this.map["x:LockText"].render(e, r.lockText), e.leafNode("x:Row", null, t.refAddress.row - 1), e.leafNode("x:Column", null, t.refAddress.col - 1), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    anchor: [],
                                    protection: {},
                                    editAs: ""
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.normalizeModel(), !1;
                            default:
                                return !0;
                        }
                    }
                    normalizeModel() {
                        const e = Object.assign({}, this.map["x:MoveWithCells"].model, this.map["x:SizeWithCells"].model), t = Object.keys(e).length;
                        this.model.editAs = a[t], this.model.anchor = this.map["x:Anchor"].text, this.model.protection.locked = this.map["x:Locked"].text, this.model.protection.lockText = this.map["x:LockText"].text;
                    }
                };
            },
            {
                "../base-xform": 32,
                "./style/vml-position-xform": 41,
                "./style/vml-protection-xform": 42,
                "./vml-anchor-xform": 43
            }
        ],
        45: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./vml-shape-xform");
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            "v:shape": new s
                        };
                    }
                    get tag() {
                        return "xml";
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode(this.tag, o.DRAWING_ATTRIBUTES), e.openNode("o:shapelayout", {
                            "v:ext": "edit"
                        }), e.leafNode("o:idmap", {
                            "v:ext": "edit",
                            data: 1
                        }), e.closeNode(), e.openNode("v:shapetype", {
                            id: "_x0000_t202",
                            coordsize: "21600,21600",
                            "o:spt": 202,
                            path: "m,l,21600r21600,l21600,xe"
                        }), e.leafNode("v:stroke", {
                            joinstyle: "miter"
                        }), e.leafNode("v:path", {
                            gradientshapeok: "t",
                            "o:connecttype": "rect"
                        }), e.closeNode(), t.comments.forEach((t, r)=>{
                            this.map["v:shape"].render(e, t, r);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    comments: []
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.comments.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.anchors.forEach((e)=>{
                            e.br ? this.map["xdr:twoCellAnchor"].reconcile(e, t) : this.map["xdr:oneCellAnchor"].reconcile(e, t);
                        });
                    }
                }
                o.DRAWING_ATTRIBUTES = {
                    "xmlns:v": "urn:schemas-microsoft-com:vml",
                    "xmlns:o": "urn:schemas-microsoft-com:office:office",
                    "xmlns:x": "urn:schemas-microsoft-com:office:excel"
                }, t.exports = o;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./vml-shape-xform": 46
            }
        ],
        46: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./vml-textbox-xform"), s = e("./vml-client-data-xform");
                class o extends n {
                    constructor(){
                        super(), this.map = {
                            "v:textbox": new i,
                            "x:ClientData": new s
                        };
                    }
                    get tag() {
                        return "v:shape";
                    }
                    render(e, t, r) {
                        e.openNode("v:shape", o.V_SHAPE_ATTRIBUTES(t, r)), e.leafNode("v:fill", {
                            color2: "infoBackground [80]"
                        }), e.leafNode("v:shadow", {
                            color: "none [81]",
                            obscured: "t"
                        }), e.leafNode("v:path", {
                            "o:connecttype": "none"
                        }), this.map["v:textbox"].render(e, t), this.map["x:ClientData"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    margins: {
                                        insetmode: e.attributes["o:insetmode"]
                                    },
                                    anchor: "",
                                    editAs: "",
                                    protection: {}
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.margins.inset = this.map["v:textbox"].model && this.map["v:textbox"].model.inset, this.model.protection = this.map["x:ClientData"].model && this.map["x:ClientData"].model.protection, this.model.anchor = this.map["x:ClientData"].model && this.map["x:ClientData"].model.anchor, this.model.editAs = this.map["x:ClientData"].model && this.map["x:ClientData"].model.editAs, !1;
                            default:
                                return !0;
                        }
                    }
                }
                o.V_SHAPE_ATTRIBUTES = (e, t)=>({
                        id: "_x0000_s" + (1025 + t),
                        type: "#_x0000_t202",
                        style: "position:absolute; margin-left:105.3pt;margin-top:10.5pt;width:97.8pt;height:59.1pt;z-index:1;visibility:hidden",
                        fillcolor: "infoBackground [80]",
                        strokecolor: "none [81]",
                        "o:insetmode": e.note.margins && e.note.margins.insetmode
                    }), t.exports = o;
            },
            {
                "../base-xform": 32,
                "./vml-client-data-xform": 44,
                "./vml-textbox-xform": 47
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "v:textbox";
                    }
                    conversionUnit(e, t, r) {
                        return `${parseFloat(e) * t.toFixed(2)}${r}`;
                    }
                    reverseConversionUnit(e) {
                        return (e || "").split(",").map((e)=>Number(parseFloat(this.conversionUnit(parseFloat(e), .1, "")).toFixed(2)));
                    }
                    render(e, t) {
                        const r = {
                            style: "mso-direction-alt:auto"
                        };
                        if (t && t.note) {
                            let { inset: e } = t.note && t.note.margins;
                            Array.isArray(e) && (e = e.map((e)=>this.conversionUnit(e, 10, "mm")).join(",")), e && (r.inset = e);
                        }
                        e.openNode("v:textbox", r), e.leafNode("div", {
                            style: "text-align:left"
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    inset: this.reverseConversionUnit(e.attributes.inset)
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        48: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform");
                t.exports = class extends n {
                    createNewModel(e) {
                        return {};
                    }
                    parseOpen(e) {
                        return this.parser = this.parser || this.map[e.name], this.parser ? (this.parser.parseOpen(e), !0) : e.name === this.tag && (this.model = this.createNewModel(e), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    onParserClose(e, t) {
                        this.model[e] = t.model;
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.onParserClose(e, this.parser), this.parser = void 0), !0) : e !== this.tag;
                    }
                };
            },
            {
                "./base-xform": 32
            }
        ],
        49: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("HeadingPairs"), e.openNode("vt:vector", {
                            size: 2,
                            baseType: "variant"
                        }), e.openNode("vt:variant"), e.leafNode("vt:lpstr", void 0, "Worksheets"), e.closeNode(), e.openNode("vt:variant"), e.leafNode("vt:i4", void 0, t.length), e.closeNode(), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        return "HeadingPairs" === e.name;
                    }
                    parseText() {}
                    parseClose(e) {
                        return "HeadingPairs" !== e;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("TitlesOfParts"), e.openNode("vt:vector", {
                            size: t.length,
                            baseType: "lpstr"
                        }), t.forEach((t)=>{
                            e.leafNode("vt:lpstr", void 0, t.name);
                        }), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        return "TitlesOfParts" === e.name;
                    }
                    parseText() {}
                    parseClose(e) {
                        return "TitlesOfParts" !== e;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../simple/string-xform"), o = e("./app-heading-pairs-xform"), a = e("./app-titles-of-parts-xform");
                class l extends i {
                    constructor(){
                        super(), this.map = {
                            Company: new s({
                                tag: "Company"
                            }),
                            Manager: new s({
                                tag: "Manager"
                            }),
                            HeadingPairs: new o,
                            TitleOfParts: new a
                        };
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("Properties", l.PROPERTY_ATTRIBUTES), e.leafNode("Application", void 0, "Microsoft Excel"), e.leafNode("DocSecurity", void 0, "0"), e.leafNode("ScaleCrop", void 0, "false"), this.map.HeadingPairs.render(e, t.worksheets), this.map.TitleOfParts.render(e, t.worksheets), this.map.Company.render(e, t.company || ""), this.map.Manager.render(e, t.manager), e.leafNode("LinksUpToDate", void 0, "false"), e.leafNode("SharedDoc", void 0, "false"), e.leafNode("HyperlinksChanged", void 0, "false"), e.leafNode("AppVersion", void 0, "16.0300"), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "Properties":
                                return !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "Properties":
                                return this.model = {
                                    worksheets: this.map.TitleOfParts.model,
                                    company: this.map.Company.model,
                                    manager: this.map.Manager.model
                                }, !1;
                            default:
                                return !0;
                        }
                    }
                }
                l.DateFormat = function(e) {
                    return e.toISOString().replace(/[.]\d{3,6}/, "");
                }, l.DateAttrs = {
                    "xsi:type": "dcterms:W3CDTF"
                }, l.PROPERTY_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
                    "xmlns:vt": "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
                }, t.exports = l;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../simple/string-xform": 119,
                "./app-heading-pairs-xform": 49,
                "./app-titles-of-parts-xform": 50
            }
        ],
        52: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform");
                class s extends i {
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("Types", s.PROPERTY_ATTRIBUTES);
                        const r = {};
                        (t.media || []).forEach((t)=>{
                            if ("image" === t.type) {
                                const n = t.extension;
                                r[n] || (r[n] = !0, e.leafNode("Default", {
                                    Extension: n,
                                    ContentType: "image/" + n
                                }));
                            }
                        }), e.leafNode("Default", {
                            Extension: "rels",
                            ContentType: "application/vnd.openxmlformats-package.relationships+xml"
                        }), e.leafNode("Default", {
                            Extension: "xml",
                            ContentType: "application/xml"
                        }), e.leafNode("Override", {
                            PartName: "/xl/workbook.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"
                        }), t.worksheets.forEach((t)=>{
                            const r = `/xl/worksheets/sheet${t.id}.xml`;
                            e.leafNode("Override", {
                                PartName: r,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"
                            });
                        }), e.leafNode("Override", {
                            PartName: "/xl/theme/theme1.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.theme+xml"
                        }), e.leafNode("Override", {
                            PartName: "/xl/styles.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"
                        });
                        t.sharedStrings && t.sharedStrings.count && e.leafNode("Override", {
                            PartName: "/xl/sharedStrings.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"
                        }), t.tables && t.tables.forEach((t)=>{
                            e.leafNode("Override", {
                                PartName: "/xl/tables/" + t.target,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml"
                            });
                        }), t.drawings && t.drawings.forEach((t)=>{
                            e.leafNode("Override", {
                                PartName: `/xl/drawings/${t.name}.xml`,
                                ContentType: "application/vnd.openxmlformats-officedocument.drawing+xml"
                            });
                        }), t.commentRefs && (e.leafNode("Default", {
                            Extension: "vml",
                            ContentType: "application/vnd.openxmlformats-officedocument.vmlDrawing"
                        }), t.commentRefs.forEach((t)=>{
                            let { commentName: r } = t;
                            e.leafNode("Override", {
                                PartName: `/xl/${r}.xml`,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml"
                            });
                        })), e.leafNode("Override", {
                            PartName: "/docProps/core.xml",
                            ContentType: "application/vnd.openxmlformats-package.core-properties+xml"
                        }), e.leafNode("Override", {
                            PartName: "/docProps/app.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.extended-properties+xml"
                        }), e.closeNode();
                    }
                    parseOpen() {
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                s.PROPERTY_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
                }, t.exports = s;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../simple/date-xform"), o = e("../simple/string-xform"), a = e("../simple/integer-xform");
                class l extends i {
                    constructor(){
                        super(), this.map = {
                            "dc:creator": new o({
                                tag: "dc:creator"
                            }),
                            "dc:title": new o({
                                tag: "dc:title"
                            }),
                            "dc:subject": new o({
                                tag: "dc:subject"
                            }),
                            "dc:description": new o({
                                tag: "dc:description"
                            }),
                            "dc:identifier": new o({
                                tag: "dc:identifier"
                            }),
                            "dc:language": new o({
                                tag: "dc:language"
                            }),
                            "cp:keywords": new o({
                                tag: "cp:keywords"
                            }),
                            "cp:category": new o({
                                tag: "cp:category"
                            }),
                            "cp:lastModifiedBy": new o({
                                tag: "cp:lastModifiedBy"
                            }),
                            "cp:lastPrinted": new s({
                                tag: "cp:lastPrinted",
                                format: l.DateFormat
                            }),
                            "cp:revision": new a({
                                tag: "cp:revision"
                            }),
                            "cp:version": new o({
                                tag: "cp:version"
                            }),
                            "cp:contentStatus": new o({
                                tag: "cp:contentStatus"
                            }),
                            "cp:contentType": new o({
                                tag: "cp:contentType"
                            }),
                            "dcterms:created": new s({
                                tag: "dcterms:created",
                                attrs: l.DateAttrs,
                                format: l.DateFormat
                            }),
                            "dcterms:modified": new s({
                                tag: "dcterms:modified",
                                attrs: l.DateAttrs,
                                format: l.DateFormat
                            })
                        };
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("cp:coreProperties", l.CORE_PROPERTY_ATTRIBUTES), this.map["dc:creator"].render(e, t.creator), this.map["dc:title"].render(e, t.title), this.map["dc:subject"].render(e, t.subject), this.map["dc:description"].render(e, t.description), this.map["dc:identifier"].render(e, t.identifier), this.map["dc:language"].render(e, t.language), this.map["cp:keywords"].render(e, t.keywords), this.map["cp:category"].render(e, t.category), this.map["cp:lastModifiedBy"].render(e, t.lastModifiedBy), this.map["cp:lastPrinted"].render(e, t.lastPrinted), this.map["cp:revision"].render(e, t.revision), this.map["cp:version"].render(e, t.version), this.map["cp:contentStatus"].render(e, t.contentStatus), this.map["cp:contentType"].render(e, t.contentType), this.map["dcterms:created"].render(e, t.created), this.map["dcterms:modified"].render(e, t.modified), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "cp:coreProperties":
                            case "coreProperties":
                                return !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parser.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "cp:coreProperties":
                            case "coreProperties":
                                return this.model = {
                                    creator: this.map["dc:creator"].model,
                                    title: this.map["dc:title"].model,
                                    subject: this.map["dc:subject"].model,
                                    description: this.map["dc:description"].model,
                                    identifier: this.map["dc:identifier"].model,
                                    language: this.map["dc:language"].model,
                                    keywords: this.map["cp:keywords"].model,
                                    category: this.map["cp:category"].model,
                                    lastModifiedBy: this.map["cp:lastModifiedBy"].model,
                                    lastPrinted: this.map["cp:lastPrinted"].model,
                                    revision: this.map["cp:revision"].model,
                                    contentStatus: this.map["cp:contentStatus"].model,
                                    contentType: this.map["cp:contentType"].model,
                                    created: this.map["dcterms:created"].model,
                                    modified: this.map["dcterms:modified"].model
                                }, !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                }
                l.DateFormat = function(e) {
                    return e.toISOString().replace(/[.]\d{3}/, "");
                }, l.DateAttrs = {
                    "xsi:type": "dcterms:W3CDTF"
                }, l.CORE_PROPERTY_ATTRIBUTES = {
                    "xmlns:cp": "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
                    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
                    "xmlns:dcterms": "http://purl.org/dc/terms/",
                    "xmlns:dcmitype": "http://purl.org/dc/dcmitype/",
                    "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance"
                }, t.exports = l;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../simple/date-xform": 117,
                "../simple/integer-xform": 118,
                "../simple/string-xform": 119
            }
        ],
        54: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("Relationship", t);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "Relationship":
                                return this.model = e.attributes, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        55: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./relationship-xform");
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            Relationship: new s
                        };
                    }
                    render(e, t) {
                        t = t || this._values, e.openXml(n.StdDocAttributes), e.openNode("Relationships", o.RELATIONSHIPS_ATTRIBUTES), t.forEach((t)=>{
                            this.map.Relationship.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "Relationships":
                                return this.model = [], !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parser.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case "Relationships":
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                }
                o.RELATIONSHIPS_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
                }, t.exports = o;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./relationship-xform": 54
            }
        ],
        56: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    range: {
                                        editAs: e.attributes.editAs || "oneCell"
                                    }
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    reconcilePicture(e, t) {
                        if (e && e.rId) {
                            const r = t.rels[e.rId].Target.match(/.*\/media\/(.+[.][a-zA-Z]{3,4})/);
                            if (r) {
                                const e = r[1], n = t.mediaIndex[e];
                                return t.media[n];
                            }
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        57: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./blip-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "a:blip": new i
                        };
                    }
                    get tag() {
                        return "xdr:blipFill";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["a:blip"].render(e, t), e.openNode("a:stretch"), e.leafNode("a:fillRect"), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["a:blip"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./blip-xform": 58
            }
        ],
        58: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:blip";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                            "r:embed": t.rId,
                            cstate: "print"
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:embed"]
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        59: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xdr:cNvPicPr";
                    }
                    render(e) {
                        e.openNode(this.tag), e.leafNode("a:picLocks", {
                            noChangeAspect: "1"
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        60: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./hlink-click-xform"), s = e("./ext-lst-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "a:hlinkClick": new i,
                            "a:extLst": new s
                        };
                    }
                    get tag() {
                        return "xdr:cNvPr";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            id: t.index,
                            name: "Picture " + t.index
                        }), this.map["a:hlinkClick"].render(e, t), this.map["a:extLst"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["a:hlinkClick"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./ext-lst-xform": 63,
                "./hlink-click-xform": 65
            }
        ],
        61: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../simple/integer-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.map = {
                            "xdr:col": new i({
                                tag: "xdr:col",
                                zero: !0
                            }),
                            "xdr:colOff": new i({
                                tag: "xdr:colOff",
                                zero: !0
                            }),
                            "xdr:row": new i({
                                tag: "xdr:row",
                                zero: !0
                            }),
                            "xdr:rowOff": new i({
                                tag: "xdr:rowOff",
                                zero: !0
                            })
                        };
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:col"].render(e, t.nativeCol), this.map["xdr:colOff"].render(e, t.nativeColOff), this.map["xdr:row"].render(e, t.nativeRow), this.map["xdr:rowOff"].render(e, t.nativeRowOff), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = {
                                    nativeCol: this.map["xdr:col"].model,
                                    nativeColOff: this.map["xdr:colOff"].model,
                                    nativeRow: this.map["xdr:row"].model,
                                    nativeRowOff: this.map["xdr:rowOff"].model
                                }, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../simple/integer-xform": 118
            }
        ],
        62: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../../../utils/xml-stream"), s = e("../base-xform"), o = e("./two-cell-anchor-xform"), a = e("./one-cell-anchor-xform");
                class l extends s {
                    constructor(){
                        super(), this.map = {
                            "xdr:twoCellAnchor": new o,
                            "xdr:oneCellAnchor": new a
                        };
                    }
                    prepare(e) {
                        e.anchors.forEach((e, t)=>{
                            e.anchorType = function(e) {
                                return ("string" == typeof e.range ? n.decode(e.range) : e.range).br ? "xdr:twoCellAnchor" : "xdr:oneCellAnchor";
                            }(e);
                            this.map[e.anchorType].prepare(e, {
                                index: t
                            });
                        });
                    }
                    get tag() {
                        return "xdr:wsDr";
                    }
                    render(e, t) {
                        e.openXml(i.StdDocAttributes), e.openNode(this.tag, l.DRAWING_ATTRIBUTES), t.anchors.forEach((t)=>{
                            this.map[t.anchorType].render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    anchors: []
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.anchors.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.anchors.forEach((e)=>{
                            e.br ? this.map["xdr:twoCellAnchor"].reconcile(e, t) : this.map["xdr:oneCellAnchor"].reconcile(e, t);
                        });
                    }
                }
                l.DRAWING_ATTRIBUTES = {
                    "xmlns:xdr": "http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing",
                    "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main"
                }, t.exports = l;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./one-cell-anchor-xform": 67,
                "./two-cell-anchor-xform": 70
            }
        ],
        63: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:extLst";
                    }
                    render(e) {
                        e.openNode(this.tag), e.openNode("a:ext", {
                            uri: "{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}"
                        }), e.leafNode("a16:creationId", {
                            "xmlns:a16": "http://schemas.microsoft.com/office/drawing/2014/main",
                            id: "{00000000-0008-0000-0000-000002000000}"
                        }), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        64: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.map = {};
                    }
                    render(e, t) {
                        e.openNode(this.tag);
                        const r = Math.floor(9525 * t.width), n = Math.floor(9525 * t.height);
                        e.addAttribute("cx", r), e.addAttribute("cy", n), e.closeNode();
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            width: parseInt(e.attributes.cx || "0", 10) / 9525,
                            height: parseInt(e.attributes.cy || "0", 10) / 9525
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        65: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:hlinkClick";
                    }
                    render(e, t) {
                        t.hyperlinks && t.hyperlinks.rId && e.leafNode(this.tag, {
                            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                            "r:id": t.hyperlinks.rId,
                            tooltip: t.hyperlinks.tooltip
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    hyperlinks: {
                                        rId: e.attributes["r:id"],
                                        tooltip: e.attributes.tooltip
                                    }
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        66: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./c-nv-pr-xform"), s = e("./c-nv-pic-pr-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:cNvPr": new i,
                            "xdr:cNvPicPr": new s
                        };
                    }
                    get tag() {
                        return "xdr:nvPicPr";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:cNvPr"].render(e, t), this.map["xdr:cNvPicPr"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["xdr:cNvPr"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./c-nv-pic-pr-xform": 59,
                "./c-nv-pr-xform": 60
            }
        ],
        67: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-cell-anchor-xform"), i = e("../static-xform"), s = e("./cell-position-xform"), o = e("./ext-xform"), a = e("./pic-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:from": new s({
                                tag: "xdr:from"
                            }),
                            "xdr:ext": new o({
                                tag: "xdr:ext"
                            }),
                            "xdr:pic": new a,
                            "xdr:clientData": new i({
                                tag: "xdr:clientData"
                            })
                        };
                    }
                    get tag() {
                        return "xdr:oneCellAnchor";
                    }
                    prepare(e, t) {
                        this.map["xdr:pic"].prepare(e.picture, t);
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            editAs: t.range.editAs || "oneCell"
                        }), this.map["xdr:from"].render(e, t.range.tl), this.map["xdr:ext"].render(e, t.range.ext), this.map["xdr:pic"].render(e, t.picture), this.map["xdr:clientData"].render(e, {}), e.closeNode();
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.range.tl = this.map["xdr:from"].model, this.model.range.ext = this.map["xdr:ext"].model, this.model.picture = this.map["xdr:pic"].model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.medium = this.reconcilePicture(e.picture, t);
                    }
                };
            },
            {
                "../static-xform": 120,
                "./base-cell-anchor-xform": 56,
                "./cell-position-xform": 61,
                "./ext-xform": 64,
                "./pic-xform": 68
            }
        ],
        68: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../static-xform"), s = e("./blip-fill-xform"), o = e("./nv-pic-pr-xform"), a = e("./sp-pr");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:nvPicPr": new o,
                            "xdr:blipFill": new s,
                            "xdr:spPr": new i(a)
                        };
                    }
                    get tag() {
                        return "xdr:pic";
                    }
                    prepare(e, t) {
                        e.index = t.index + 1;
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:nvPicPr"].render(e, t), this.map["xdr:blipFill"].render(e, t), this.map["xdr:spPr"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.mergeModel(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../static-xform": 120,
                "./blip-fill-xform": 57,
                "./nv-pic-pr-xform": 66,
                "./sp-pr": 69
            }
        ],
        69: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    tag: "xdr:spPr",
                    c: [
                        {
                            tag: "a:xfrm",
                            c: [
                                {
                                    tag: "a:off",
                                    $: {
                                        x: "0",
                                        y: "0"
                                    }
                                },
                                {
                                    tag: "a:ext",
                                    $: {
                                        cx: "0",
                                        cy: "0"
                                    }
                                }
                            ]
                        },
                        {
                            tag: "a:prstGeom",
                            $: {
                                prst: "rect"
                            },
                            c: [
                                {
                                    tag: "a:avLst"
                                }
                            ]
                        }
                    ]
                };
            },
            {}
        ],
        70: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-cell-anchor-xform"), i = e("../static-xform"), s = e("./cell-position-xform"), o = e("./pic-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:from": new s({
                                tag: "xdr:from"
                            }),
                            "xdr:to": new s({
                                tag: "xdr:to"
                            }),
                            "xdr:pic": new o,
                            "xdr:clientData": new i({
                                tag: "xdr:clientData"
                            })
                        };
                    }
                    get tag() {
                        return "xdr:twoCellAnchor";
                    }
                    prepare(e, t) {
                        this.map["xdr:pic"].prepare(e.picture, t);
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            editAs: t.range.editAs || "oneCell"
                        }), this.map["xdr:from"].render(e, t.range.tl), this.map["xdr:to"].render(e, t.range.br), this.map["xdr:pic"].render(e, t.picture), this.map["xdr:clientData"].render(e, {}), e.closeNode();
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.range.tl = this.map["xdr:from"].model, this.model.range.br = this.map["xdr:to"].model, this.model.picture = this.map["xdr:pic"].model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.medium = this.reconcilePicture(e.picture, t);
                    }
                };
            },
            {
                "../static-xform": 120,
                "./base-cell-anchor-xform": 56,
                "./cell-position-xform": 61,
                "./pic-xform": 68
            }
        ],
        71: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.always = !!e.always, this.count = e.count, this.empty = e.empty, this.$count = e.$count || "count", this.$ = e.$, this.childXform = e.childXform, this.maxItems = e.maxItems;
                    }
                    prepare(e, t) {
                        const { childXform: r } = this;
                        e && e.forEach((e, n)=>{
                            t.index = n, r.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        if (this.always || t && t.length) {
                            e.openNode(this.tag, this.$), this.count && e.addAttribute(this.$count, t && t.length || 0);
                            const { childXform: r } = this;
                            (t || []).forEach((t, n)=>{
                                r.render(e, t, n);
                            }), e.closeNode();
                        } else this.empty && e.leafNode(this.tag);
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.model = [], !0;
                            default:
                                return !!this.childXform.parseOpen(e) && (this.parser = this.childXform, !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e) && (this.model.push(this.parser.model), this.parser = void 0, this.maxItems && this.model.length > this.maxItems)) throw new Error(`Max ${this.childXform.tag} count (${this.maxItems}) exceeded`);
                            return !0;
                        }
                        return !1;
                    }
                    reconcile(e, t) {
                        if (e) {
                            const { childXform: r } = this;
                            e.forEach((e)=>{
                                r.reconcile(e, t);
                            });
                        }
                    }
                };
            },
            {
                "./base-xform": 32
            }
        ],
        72: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "autoFilter";
                    }
                    render(e, t) {
                        if (t) {
                            if ("string" == typeof t) e.leafNode("autoFilter", {
                                ref: t
                            });
                            else {
                                const r = function(e) {
                                    return "string" == typeof e ? e : n.getAddress(e.row, e.column).address;
                                }, i = r(t.from), s = r(t.to);
                                i && s && e.leafNode("autoFilter", {
                                    ref: `${i}:${s}`
                                });
                            }
                        }
                    }
                    parseOpen(e) {
                        "autoFilter" === e.name && (this.model = e.attributes.ref);
                    }
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        73: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform"), s = e("../../../doc/range"), o = e("../../../doc/enums"), a = e("../strings/rich-text-xform");
                function l(e) {
                    if (null == e) return o.ValueType.Null;
                    if (e instanceof String || "string" == typeof e) return o.ValueType.String;
                    if ("number" == typeof e) return o.ValueType.Number;
                    if ("boolean" == typeof e) return o.ValueType.Boolean;
                    if (e instanceof Date) return o.ValueType.Date;
                    if (e.text && e.hyperlink) return o.ValueType.Hyperlink;
                    if (e.formula) return o.ValueType.Formula;
                    if (e.error) return o.ValueType.Error;
                    throw new Error("I could not understand type of value");
                }
                t.exports = class extends i {
                    constructor(){
                        super(), this.richTextXForm = new a;
                    }
                    get tag() {
                        return "c";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style || {}, function(e) {
                            switch(e.type){
                                case o.ValueType.Formula:
                                    return l(e.result);
                                default:
                                    return e.type;
                            }
                        }(e));
                        switch(r && (e.styleId = r), e.comment && t.comments.push({
                            ...e.comment,
                            ref: e.address
                        }), e.type){
                            case o.ValueType.String:
                            case o.ValueType.RichText:
                                t.sharedStrings && (e.ssId = t.sharedStrings.add(e.value));
                                break;
                            case o.ValueType.Date:
                                t.date1904 && (e.date1904 = !0);
                                break;
                            case o.ValueType.Hyperlink:
                                t.sharedStrings && void 0 !== e.text && null !== e.text && (e.ssId = t.sharedStrings.add(e.text)), t.hyperlinks.push({
                                    address: e.address,
                                    target: e.hyperlink,
                                    tooltip: e.tooltip
                                });
                                break;
                            case o.ValueType.Merge:
                                t.merges.add(e);
                                break;
                            case o.ValueType.Formula:
                                if (t.date1904 && (e.date1904 = !0), "shared" === e.shareType && (e.si = t.siFormulae++), e.formula) t.formulae[e.address] = e;
                                else if (e.sharedFormula) {
                                    const r = t.formulae[e.sharedFormula];
                                    if (!r) throw new Error("Shared Formula master must exist above and or left of clone for cell " + e.address);
                                    void 0 === r.si ? (r.shareType = "shared", r.si = t.siFormulae++, r.range = new s(r.address, e.address)) : r.range && r.range.expandToAddress(e.address), e.si = r.si;
                                }
                        }
                    }
                    renderFormula(e, t) {
                        let r = null;
                        switch(t.shareType){
                            case "shared":
                                r = {
                                    t: "shared",
                                    ref: t.ref || t.range.range,
                                    si: t.si
                                };
                                break;
                            case "array":
                                r = {
                                    t: "array",
                                    ref: t.ref
                                };
                                break;
                            default:
                                void 0 !== t.si && (r = {
                                    t: "shared",
                                    si: t.si
                                });
                        }
                        switch(l(t.result)){
                            case o.ValueType.Null:
                                e.leafNode("f", r, t.formula);
                                break;
                            case o.ValueType.String:
                                e.addAttribute("t", "str"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result);
                                break;
                            case o.ValueType.Number:
                                e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result);
                                break;
                            case o.ValueType.Boolean:
                                e.addAttribute("t", "b"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result ? 1 : 0);
                                break;
                            case o.ValueType.Error:
                                e.addAttribute("t", "e"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result.error);
                                break;
                            case o.ValueType.Date:
                                e.leafNode("f", r, t.formula), e.leafNode("v", null, n.dateToExcel(t.result, t.date1904));
                                break;
                            default:
                                throw new Error("I could not understand type of value");
                        }
                    }
                    render(e, t) {
                        if (t.type !== o.ValueType.Null || t.styleId) {
                            switch(e.openNode("c"), e.addAttribute("r", t.address), t.styleId && e.addAttribute("s", t.styleId), t.type){
                                case o.ValueType.Null:
                                    break;
                                case o.ValueType.Number:
                                    e.leafNode("v", null, t.value);
                                    break;
                                case o.ValueType.Boolean:
                                    e.addAttribute("t", "b"), e.leafNode("v", null, t.value ? "1" : "0");
                                    break;
                                case o.ValueType.Error:
                                    e.addAttribute("t", "e"), e.leafNode("v", null, t.value.error);
                                    break;
                                case o.ValueType.String:
                                case o.ValueType.RichText:
                                    void 0 !== t.ssId ? (e.addAttribute("t", "s"), e.leafNode("v", null, t.ssId)) : t.value && t.value.richText ? (e.addAttribute("t", "inlineStr"), e.openNode("is"), t.value.richText.forEach((t)=>{
                                        this.richTextXForm.render(e, t);
                                    }), e.closeNode("is")) : (e.addAttribute("t", "str"), e.leafNode("v", null, t.value));
                                    break;
                                case o.ValueType.Date:
                                    e.leafNode("v", null, n.dateToExcel(t.value, t.date1904));
                                    break;
                                case o.ValueType.Hyperlink:
                                    void 0 !== t.ssId ? (e.addAttribute("t", "s"), e.leafNode("v", null, t.ssId)) : (e.addAttribute("t", "str"), e.leafNode("v", null, t.text));
                                    break;
                                case o.ValueType.Formula:
                                    this.renderFormula(e, t);
                                    break;
                                case o.ValueType.Merge:
                            }
                            e.closeNode();
                        }
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "c":
                                return this.model = {
                                    address: e.attributes.r
                                }, this.t = e.attributes.t, e.attributes.s && (this.model.styleId = parseInt(e.attributes.s, 10)), !0;
                            case "f":
                                return this.currentNode = "f", this.model.si = e.attributes.si, this.model.shareType = e.attributes.t, this.model.ref = e.attributes.ref, !0;
                            case "v":
                                return this.currentNode = "v", !0;
                            case "t":
                                return this.currentNode = "t", !0;
                            case "r":
                                return this.parser = this.richTextXForm, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        if (this.parser) this.parser.parseText(e);
                        else switch(this.currentNode){
                            case "f":
                                this.model.formula = this.model.formula ? this.model.formula + e : e;
                                break;
                            case "v":
                            case "t":
                                this.model.value && this.model.value.richText ? this.model.value.richText.text = this.model.value.richText.text ? this.model.value.richText.text + e : e : this.model.value = this.model.value ? this.model.value + e : e;
                        }
                    }
                    parseClose(e) {
                        switch(e){
                            case "c":
                                {
                                    const { model: e } = this;
                                    if (e.formula || e.shareType) e.type = o.ValueType.Formula, e.value && ("str" === this.t ? e.result = n.xmlDecode(e.value) : "b" === this.t ? e.result = 0 !== parseInt(e.value, 10) : "e" === this.t ? e.result = {
                                        error: e.value
                                    } : e.result = parseFloat(e.value), e.value = void 0);
                                    else if (void 0 !== e.value) switch(this.t){
                                        case "s":
                                            e.type = o.ValueType.String, e.value = parseInt(e.value, 10);
                                            break;
                                        case "str":
                                            e.type = o.ValueType.String, e.value = n.xmlDecode(e.value);
                                            break;
                                        case "inlineStr":
                                            e.type = o.ValueType.String;
                                            break;
                                        case "b":
                                            e.type = o.ValueType.Boolean, e.value = 0 !== parseInt(e.value, 10);
                                            break;
                                        case "e":
                                            e.type = o.ValueType.Error, e.value = {
                                                error: e.value
                                            };
                                            break;
                                        default:
                                            e.type = o.ValueType.Number, e.value = parseFloat(e.value);
                                    }
                                    else e.styleId ? e.type = o.ValueType.Null : e.type = o.ValueType.Merge;
                                    return !1;
                                }
                            case "f":
                            case "v":
                            case "is":
                                return this.currentNode = void 0, !0;
                            case "t":
                                return this.parser ? (this.parser.parseClose(e), !0) : (this.currentNode = void 0, !0);
                            case "r":
                                return this.model.value = this.model.value || {}, this.model.value.richText = this.model.value.richText || [], this.model.value.richText.push(this.parser.model), this.parser = void 0, this.currentNode = void 0, !0;
                            default:
                                return !!this.parser && (this.parser.parseClose(e), !0);
                        }
                    }
                    reconcile(e, t) {
                        const r = e.styleId && t.styles && t.styles.getStyleModel(e.styleId);
                        switch(r && (e.style = r), void 0 !== e.styleId && (e.styleId = void 0), e.type){
                            case o.ValueType.String:
                                "number" == typeof e.value && t.sharedStrings && (e.value = t.sharedStrings.getString(e.value)), e.value.richText && (e.type = o.ValueType.RichText);
                                break;
                            case o.ValueType.Number:
                                r && n.isDateFmt(r.numFmt) && (e.type = o.ValueType.Date, e.value = n.excelToDate(e.value, t.date1904));
                                break;
                            case o.ValueType.Formula:
                                void 0 !== e.result && r && n.isDateFmt(r.numFmt) && (e.result = n.excelToDate(e.result, t.date1904)), "shared" === e.shareType && (e.ref ? t.formulae[e.si] = e.address : (e.sharedFormula = t.formulae[e.si], delete e.shareType), delete e.si);
                        }
                        const i = t.hyperlinkMap[e.address];
                        i && (e.type === o.ValueType.Formula ? (e.text = e.result, e.result = void 0) : (e.text = e.value, e.value = void 0), e.type = o.ValueType.Hyperlink, e.hyperlink = i);
                        const s = t.commentsMap && t.commentsMap[e.address];
                        s && (e.comment = s);
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../doc/range": 10,
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "../strings/rich-text-xform": 122
            }
        ],
        74: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "x14:cfIcon";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            iconSet: t.iconSet,
                            iconId: t.iconId
                        });
                    }
                    parseOpen(e) {
                        let { attributes: t } = e;
                        this.model = {
                            iconSet: t.iconSet,
                            iconId: n.toIntValue(t.iconId)
                        };
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        75: [
            function(e, t, r) {
                "use strict";
                const { v4: n } = e("uuid"), i = e("../../base-xform"), s = e("../../composite-xform"), o = e("./databar-ext-xform"), a = e("./icon-set-ext-xform"), l = {
                    "3Triangles": !0,
                    "3Stars": !0,
                    "5Boxes": !0
                };
                class c extends s {
                    constructor(){
                        super(), this.map = {
                            "x14:dataBar": this.databarXform = new o,
                            "x14:iconSet": this.iconSetXform = new a
                        };
                    }
                    get tag() {
                        return "x14:cfRule";
                    }
                    static isExt(e) {
                        return "dataBar" === e.type ? o.isExt(e) : !("iconSet" !== e.type || !e.custom && !l[e.iconSet]);
                    }
                    prepare(e) {
                        c.isExt(e) && (e.x14Id = `{${n()}}`.toUpperCase());
                    }
                    render(e, t) {
                        if (c.isExt(t)) switch(t.type){
                            case "dataBar":
                                this.renderDataBar(e, t);
                                break;
                            case "iconSet":
                                this.renderIconSet(e, t);
                        }
                    }
                    renderDataBar(e, t) {
                        e.openNode(this.tag, {
                            type: "dataBar",
                            id: t.x14Id
                        }), this.databarXform.render(e, t), e.closeNode();
                    }
                    renderIconSet(e, t) {
                        e.openNode(this.tag, {
                            type: "iconSet",
                            priority: t.priority,
                            id: t.x14Id || `{${n()}}`
                        }), this.iconSetXform.render(e, t), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            type: t.type,
                            x14Id: t.id,
                            priority: i.toIntValue(t.priority)
                        };
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                }
                t.exports = c;
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./databar-ext-xform": 79,
                "./icon-set-ext-xform": 81,
                uuid: 528
            }
        ],
        76: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./f-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xm:f": this.fExtXform = new i
                        };
                    }
                    get tag() {
                        return "x14:cfvo";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            type: t.type
                        }), void 0 !== t.value && this.fExtXform.render(e, t.value), e.closeNode();
                    }
                    createNewModel(e) {
                        return {
                            type: e.attributes.type
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "xm:f":
                                this.model.value = t.model ? parseFloat(t.model) : 0;
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./f-ext-xform": 80
            }
        ],
        77: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./sqref-ext-xform"), s = e("./cf-rule-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xm:sqref": this.sqRef = new i,
                            "x14:cfRule": this.cfRule = new s
                        };
                    }
                    get tag() {
                        return "x14:conditionalFormatting";
                    }
                    prepare(e, t) {
                        e.rules.forEach((e)=>{
                            this.cfRule.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        t.rules.some(s.isExt) && (e.openNode(this.tag, {
                            "xmlns:xm": "http://schemas.microsoft.com/office/excel/2006/main"
                        }), t.rules.filter(s.isExt).forEach((t)=>this.cfRule.render(e, t)), this.sqRef.render(e, t.ref), e.closeNode());
                    }
                    createNewModel() {
                        return {
                            rules: []
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "xm:sqref":
                                this.model.ref = t.model;
                                break;
                            case "x14:cfRule":
                                this.model.rules.push(t.model);
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-ext-xform": 75,
                "./sqref-ext-xform": 82
            }
        ],
        78: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./cf-rule-ext-xform"), s = e("./conditional-formatting-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "x14:conditionalFormatting": this.cfXform = new s
                        };
                    }
                    get tag() {
                        return "x14:conditionalFormattings";
                    }
                    hasContent(e) {
                        return void 0 === e.hasExtContent && (e.hasExtContent = e.some((e)=>e.rules.some(i.isExt))), e.hasExtContent;
                    }
                    prepare(e, t) {
                        e.forEach((e)=>{
                            this.cfXform.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        this.hasContent(t) && (e.openNode(this.tag), t.forEach((t)=>this.cfXform.render(e, t)), e.closeNode());
                    }
                    createNewModel() {
                        return [];
                    }
                    onParserClose(e, t) {
                        this.model.push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-ext-xform": 75,
                "./conditional-formatting-ext-xform": 77
            }
        ],
        79: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("../../style/color-xform"), o = e("./cfvo-ext-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:cfvo": this.cfvoXform = new o,
                            "x14:borderColor": this.borderColorXform = new s("x14:borderColor"),
                            "x14:negativeBorderColor": this.negativeBorderColorXform = new s("x14:negativeBorderColor"),
                            "x14:negativeFillColor": this.negativeFillColorXform = new s("x14:negativeFillColor"),
                            "x14:axisColor": this.axisColorXform = new s("x14:axisColor")
                        };
                    }
                    static isExt(e) {
                        return !e.gradient;
                    }
                    get tag() {
                        return "x14:dataBar";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            minLength: n.toIntAttribute(t.minLength, 0, !0),
                            maxLength: n.toIntAttribute(t.maxLength, 100, !0),
                            border: n.toBoolAttribute(t.border, !1),
                            gradient: n.toBoolAttribute(t.gradient, !0),
                            negativeBarColorSameAsPositive: n.toBoolAttribute(t.negativeBarColorSameAsPositive, !0),
                            negativeBarBorderColorSameAsPositive: n.toBoolAttribute(t.negativeBarBorderColorSameAsPositive, !0),
                            axisPosition: n.toAttribute(t.axisPosition, "auto"),
                            direction: n.toAttribute(t.direction, "leftToRight")
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), this.borderColorXform.render(e, t.borderColor), this.negativeBorderColorXform.render(e, t.negativeBorderColor), this.negativeFillColorXform.render(e, t.negativeFillColor), this.axisColorXform.render(e, t.axisColor), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            cfvo: [],
                            minLength: n.toIntValue(t.minLength, 0),
                            maxLength: n.toIntValue(t.maxLength, 100),
                            border: n.toBoolValue(t.border, !1),
                            gradient: n.toBoolValue(t.gradient, !0),
                            negativeBarColorSameAsPositive: n.toBoolValue(t.negativeBarColorSameAsPositive, !0),
                            negativeBarBorderColorSameAsPositive: n.toBoolValue(t.negativeBarBorderColorSameAsPositive, !0),
                            axisPosition: n.toStringValue(t.axisPosition, "auto"),
                            direction: n.toStringValue(t.direction, "leftToRight")
                        };
                    }
                    onParserClose(e, t) {
                        const [, r] = e.split(":");
                        switch(r){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            default:
                                this.model[r] = t.model;
                        }
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-ext-xform": 76
            }
        ],
        80: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xm:f";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        81: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("./cfvo-ext-xform"), o = e("./cf-icon-ext-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:cfvo": this.cfvoXform = new s,
                            "x14:cfIcon": this.cfIconXform = new o
                        };
                    }
                    get tag() {
                        return "x14:iconSet";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            iconSet: n.toStringAttribute(t.iconSet),
                            reverse: n.toBoolAttribute(t.reverse, !1),
                            showValue: n.toBoolAttribute(t.showValue, !0),
                            custom: n.toBoolAttribute(t.icons, !1)
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), t.icons && t.icons.forEach((t, r)=>{
                            t.iconId = r, this.cfIconXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            cfvo: [],
                            iconSet: n.toStringValue(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolValue(t.reverse, !1),
                            showValue: n.toBoolValue(t.showValue, !0)
                        };
                    }
                    onParserClose(e, t) {
                        const [, r] = e.split(":");
                        switch(r){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            case "cfIcon":
                                this.model.icons || (this.model.icons = []), this.model.icons.push(t.model);
                                break;
                            default:
                                this.model[r] = t.model;
                        }
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./cf-icon-ext-xform": 74,
                "./cfvo-ext-xform": 76
            }
        ],
        82: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xm:sqref";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        83: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("../../../../doc/range"), o = e("./databar-xform"), a = e("./ext-lst-ref-xform"), l = e("./formula-xform"), c = e("./color-scale-xform"), u = e("./icon-set-xform"), h = {
                    "3Triangles": !0,
                    "3Stars": !0,
                    "5Boxes": !0
                }, f = (e)=>{
                    const { type: t, operator: r } = e;
                    switch(t){
                        case "containsText":
                        case "containsBlanks":
                        case "notContainsBlanks":
                        case "containsErrors":
                        case "notContainsErrors":
                            return {
                                type: "containsText",
                                operator: t
                            };
                        default:
                            return {
                                type: t,
                                operator: r
                            };
                    }
                };
                class d extends i {
                    constructor(){
                        super(), this.map = {
                            dataBar: this.databarXform = new o,
                            extLst: this.extLstRefXform = new a,
                            formula: this.formulaXform = new l,
                            colorScale: this.colorScaleXform = new c,
                            iconSet: this.iconSetXform = new u
                        };
                    }
                    get tag() {
                        return "cfRule";
                    }
                    static isPrimitive(e) {
                        return "iconSet" !== e.type || !e.custom && !h[e.iconSet];
                    }
                    render(e, t) {
                        switch(t.type){
                            case "expression":
                                this.renderExpression(e, t);
                                break;
                            case "cellIs":
                                this.renderCellIs(e, t);
                                break;
                            case "top10":
                                this.renderTop10(e, t);
                                break;
                            case "aboveAverage":
                                this.renderAboveAverage(e, t);
                                break;
                            case "dataBar":
                                this.renderDataBar(e, t);
                                break;
                            case "colorScale":
                                this.renderColorScale(e, t);
                                break;
                            case "iconSet":
                                this.renderIconSet(e, t);
                                break;
                            case "containsText":
                                this.renderText(e, t);
                                break;
                            case "timePeriod":
                                this.renderTimePeriod(e, t);
                        }
                    }
                    renderExpression(e, t) {
                        e.openNode(this.tag, {
                            type: "expression",
                            dxfId: t.dxfId,
                            priority: t.priority
                        }), this.formulaXform.render(e, t.formulae[0]), e.closeNode();
                    }
                    renderCellIs(e, t) {
                        e.openNode(this.tag, {
                            type: "cellIs",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            operator: t.operator
                        }), t.formulae.forEach((t)=>{
                            this.formulaXform.render(e, t);
                        }), e.closeNode();
                    }
                    renderTop10(e, t) {
                        e.leafNode(this.tag, {
                            type: "top10",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            percent: n.toBoolAttribute(t.percent, !1),
                            bottom: n.toBoolAttribute(t.bottom, !1),
                            rank: n.toIntValue(t.rank, 10, !0)
                        });
                    }
                    renderAboveAverage(e, t) {
                        e.leafNode(this.tag, {
                            type: "aboveAverage",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            aboveAverage: n.toBoolAttribute(t.aboveAverage, !0)
                        });
                    }
                    renderDataBar(e, t) {
                        e.openNode(this.tag, {
                            type: "dataBar",
                            priority: t.priority
                        }), this.databarXform.render(e, t), this.extLstRefXform.render(e, t), e.closeNode();
                    }
                    renderColorScale(e, t) {
                        e.openNode(this.tag, {
                            type: "colorScale",
                            priority: t.priority
                        }), this.colorScaleXform.render(e, t), e.closeNode();
                    }
                    renderIconSet(e, t) {
                        d.isPrimitive(t) && (e.openNode(this.tag, {
                            type: "iconSet",
                            priority: t.priority
                        }), this.iconSetXform.render(e, t), e.closeNode());
                    }
                    renderText(e, t) {
                        e.openNode(this.tag, {
                            type: t.operator,
                            dxfId: t.dxfId,
                            priority: t.priority,
                            operator: n.toStringAttribute(t.operator, "containsText")
                        });
                        const r = ((e)=>{
                            if (e.formulae && e.formulae[0]) return e.formulae[0];
                            const t = new s(e.ref), { tl: r } = t;
                            switch(e.operator){
                                case "containsText":
                                    return `NOT(ISERROR(SEARCH("${e.text}",${r})))`;
                                case "containsBlanks":
                                    return `LEN(TRIM(${r}))=0`;
                                case "notContainsBlanks":
                                    return `LEN(TRIM(${r}))>0`;
                                case "containsErrors":
                                    return `ISERROR(${r})`;
                                case "notContainsErrors":
                                    return `NOT(ISERROR(${r}))`;
                                default:
                                    return;
                            }
                        })(t);
                        r && this.formulaXform.render(e, r), e.closeNode();
                    }
                    renderTimePeriod(e, t) {
                        e.openNode(this.tag, {
                            type: "timePeriod",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            timePeriod: t.timePeriod
                        });
                        const r = ((e)=>{
                            if (e.formulae && e.formulae[0]) return e.formulae[0];
                            const t = new s(e.ref), { tl: r } = t;
                            switch(e.timePeriod){
                                case "thisWeek":
                                    return `AND(TODAY()-ROUNDDOWN(${r},0)<=WEEKDAY(TODAY())-1,ROUNDDOWN(${r},0)-TODAY()<=7-WEEKDAY(TODAY()))`;
                                case "lastWeek":
                                    return `AND(TODAY()-ROUNDDOWN(${r},0)>=(WEEKDAY(TODAY())),TODAY()-ROUNDDOWN(${r},0)<(WEEKDAY(TODAY())+7))`;
                                case "nextWeek":
                                    return `AND(ROUNDDOWN(${r},0)-TODAY()>(7-WEEKDAY(TODAY())),ROUNDDOWN(${r},0)-TODAY()<(15-WEEKDAY(TODAY())))`;
                                case "yesterday":
                                    return `FLOOR(${r},1)=TODAY()-1`;
                                case "today":
                                    return `FLOOR(${r},1)=TODAY()`;
                                case "tomorrow":
                                    return `FLOOR(${r},1)=TODAY()+1`;
                                case "last7Days":
                                    return `AND(TODAY()-FLOOR(${r},1)<=6,FLOOR(${r},1)<=TODAY())`;
                                case "lastMonth":
                                    return `AND(MONTH(${r})=MONTH(EDATE(TODAY(),0-1)),YEAR(${r})=YEAR(EDATE(TODAY(),0-1)))`;
                                case "thisMonth":
                                    return `AND(MONTH(${r})=MONTH(TODAY()),YEAR(${r})=YEAR(TODAY()))`;
                                case "nextMonth":
                                    return `AND(MONTH(${r})=MONTH(EDATE(TODAY(),0+1)),YEAR(${r})=YEAR(EDATE(TODAY(),0+1)))`;
                                default:
                                    return;
                            }
                        })(t);
                        r && this.formulaXform.render(e, r), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            ...f(t),
                            dxfId: n.toIntValue(t.dxfId),
                            priority: n.toIntValue(t.priority),
                            timePeriod: t.timePeriod,
                            percent: n.toBoolValue(t.percent),
                            bottom: n.toBoolValue(t.bottom),
                            rank: n.toIntValue(t.rank),
                            aboveAverage: n.toBoolValue(t.aboveAverage)
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "dataBar":
                            case "extLst":
                            case "colorScale":
                            case "iconSet":
                                Object.assign(this.model, t.model);
                                break;
                            case "formula":
                                this.model.formulae = this.model.formulae || [], this.model.formulae.push(t.model);
                        }
                    }
                }
                t.exports = d;
            },
            {
                "../../../../doc/range": 10,
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./color-scale-xform": 85,
                "./databar-xform": 88,
                "./ext-lst-ref-xform": 89,
                "./formula-xform": 90,
                "./icon-set-xform": 91
            }
        ],
        84: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "cfvo";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            type: t.type,
                            val: t.value
                        });
                    }
                    parseOpen(e) {
                        this.model = {
                            type: e.attributes.type,
                            value: n.toFloatValue(e.attributes.val)
                        };
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        85: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("../../style/color-xform"), s = e("./cfvo-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s,
                            color: this.colorXform = new i
                        };
                    }
                    get tag() {
                        return "colorScale";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), t.color.forEach((t)=>{
                            this.colorXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        return {
                            cfvo: [],
                            color: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model[e].push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-xform": 84
            }
        ],
        86: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./cf-rule-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfRule: new i
                        };
                    }
                    get tag() {
                        return "conditionalFormatting";
                    }
                    render(e, t) {
                        t.rules.some(i.isPrimitive) && (e.openNode(this.tag, {
                            sqref: t.ref
                        }), t.rules.forEach((r)=>{
                            i.isPrimitive(r) && (r.ref = t.ref, this.map.cfRule.render(e, r));
                        }), e.closeNode());
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            ref: t.sqref,
                            rules: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model.rules.push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-xform": 83
            }
        ],
        87: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("./conditional-formatting-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.cfXform = new i;
                    }
                    get tag() {
                        return "conditionalFormatting";
                    }
                    reset() {
                        this.model = [];
                    }
                    prepare(e, t) {
                        let r = e.reduce((e, t)=>Math.max(e, ...t.rules.map((e)=>e.priority || 0)), 1);
                        e.forEach((e)=>{
                            e.rules.forEach((e)=>{
                                e.priority || (e.priority = r++), e.style && (e.dxfId = t.styles.addDxfStyle(e.style));
                            });
                        });
                    }
                    render(e, t) {
                        t.forEach((t)=>{
                            this.cfXform.render(e, t);
                        });
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "conditionalFormatting":
                                return this.parser = this.cfXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (!!this.parser.parseClose(e) || (this.model.push(this.parser.model), this.parser = void 0, !1));
                    }
                    reconcile(e, t) {
                        e.forEach((e)=>{
                            e.rules.forEach((e)=>{
                                void 0 !== e.dxfId && (e.style = t.styles.getDxfStyle(e.dxfId), delete e.dxfId);
                            });
                        });
                    }
                };
            },
            {
                "../../base-xform": 32,
                "./conditional-formatting-xform": 86
            }
        ],
        88: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("../../style/color-xform"), s = e("./cfvo-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s,
                            color: this.colorXform = new i
                        };
                    }
                    get tag() {
                        return "dataBar";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), this.colorXform.render(e, t.color), e.closeNode();
                    }
                    createNewModel() {
                        return {
                            cfvo: []
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            case "color":
                                this.model.color = t.model;
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-xform": 84
            }
        ],
        89: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform");
                class s extends n {
                    get tag() {
                        return "x14:id";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                }
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:id": this.idXform = new s
                        };
                    }
                    get tag() {
                        return "ext";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            uri: "{B025F937-C7B1-47D3-B67F-A62EFF666E3E}",
                            "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                        }), this.idXform.render(e, t.x14Id), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        this.model.x14Id = t.model;
                    }
                }
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            ext: new o
                        };
                    }
                    get tag() {
                        return "extLst";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map.ext.render(e, t), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48
            }
        ],
        90: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "formula";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        91: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("./cfvo-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s
                        };
                    }
                    get tag() {
                        return "iconSet";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            iconSet: n.toStringAttribute(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolAttribute(t.reverse, !1),
                            showValue: n.toBoolAttribute(t.showValue, !0)
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            iconSet: n.toStringValue(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolValue(t.reverse),
                            showValue: n.toBoolValue(t.showValue),
                            cfvo: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model[e].push(t.model);
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./cfvo-xform": 84
            }
        ],
        92: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "col";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style || {});
                        r && (e.styleId = r);
                    }
                    render(e, t) {
                        e.openNode("col"), e.addAttribute("min", t.min), e.addAttribute("max", t.max), t.width && e.addAttribute("width", t.width), t.styleId && e.addAttribute("style", t.styleId), t.hidden && e.addAttribute("hidden", "1"), t.bestFit && e.addAttribute("bestFit", "1"), t.outlineLevel && e.addAttribute("outlineLevel", t.outlineLevel), t.collapsed && e.addAttribute("collapsed", "1"), e.addAttribute("customWidth", "1"), e.closeNode();
                    }
                    parseOpen(e) {
                        if ("col" === e.name) {
                            const t = this.model = {
                                min: parseInt(e.attributes.min || "0", 10),
                                max: parseInt(e.attributes.max || "0", 10),
                                width: void 0 === e.attributes.width ? void 0 : parseFloat(e.attributes.width || "0")
                            };
                            return e.attributes.style && (t.styleId = parseInt(e.attributes.style, 10)), n.parseBoolean(e.attributes.hidden) && (t.hidden = !0), n.parseBoolean(e.attributes.bestFit) && (t.bestFit = !0), e.attributes.outlineLevel && (t.outlineLevel = parseInt(e.attributes.outlineLevel, 10)), n.parseBoolean(e.attributes.collapsed) && (t.collapsed = !0), !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                    reconcile(e, t) {
                        e.styleId && (e.style = t.styles.getStyleModel(e.styleId));
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        93: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/utils"), s = e("../../../utils/col-cache"), o = e("../base-xform"), a = e("../../../doc/range");
                function l(e, t, r, n) {
                    const i = t[r];
                    void 0 !== i ? e[r] = i : void 0 !== n && (e[r] = n);
                }
                function c(e, t, r, n) {
                    const s = t[r];
                    void 0 !== s ? e[r] = i.parseBoolean(s) : void 0 !== n && (e[r] = n);
                }
                t.exports = class extends o {
                    get tag() {
                        return "dataValidations";
                    }
                    render(e, t) {
                        const r = function(e) {
                            const t = n.map(e, (e, t)=>({
                                    address: t,
                                    dataValidation: e,
                                    marked: !1
                                })).sort((e, t)=>n.strcmp(e.address, t.address)), r = n.keyBy(t, "address"), i = (t, r, i)=>{
                                for(let o = 0; o < r; o++){
                                    const r = s.encodeAddress(t.row + o, i);
                                    if (!e[r] || !n.isEqual(e[t.address], e[r])) return !1;
                                }
                                return !0;
                            };
                            return t.map((t)=>{
                                if (!t.marked) {
                                    const o = s.decodeEx(t.address);
                                    if (o.dimensions) return r[o.dimensions].marked = !0, {
                                        ...t.dataValidation,
                                        sqref: t.address
                                    };
                                    let a = 1, l = s.encodeAddress(o.row + a, o.col);
                                    for(; e[l] && n.isEqual(t.dataValidation, e[l]);)a++, l = s.encodeAddress(o.row + a, o.col);
                                    let c = 1;
                                    for(; i(o, a, o.col + c);)c++;
                                    for(let e = 0; e < a; e++)for(let t = 0; t < c; t++)l = s.encodeAddress(o.row + e, o.col + t), r[l].marked = !0;
                                    if (a > 1 || c > 1) {
                                        const e = o.row + (a - 1), r = o.col + (c - 1);
                                        return {
                                            ...t.dataValidation,
                                            sqref: `${t.address}:${s.encodeAddress(e, r)}`
                                        };
                                    }
                                    return {
                                        ...t.dataValidation,
                                        sqref: t.address
                                    };
                                }
                                return null;
                            }).filter(Boolean);
                        }(t);
                        r.length && (e.openNode("dataValidations", {
                            count: r.length
                        }), r.forEach((t)=>{
                            e.openNode("dataValidation"), "any" !== t.type && (e.addAttribute("type", t.type), t.operator && "list" !== t.type && "between" !== t.operator && e.addAttribute("operator", t.operator), t.allowBlank && e.addAttribute("allowBlank", "1")), t.showInputMessage && e.addAttribute("showInputMessage", "1"), t.promptTitle && e.addAttribute("promptTitle", t.promptTitle), t.prompt && e.addAttribute("prompt", t.prompt), t.showErrorMessage && e.addAttribute("showErrorMessage", "1"), t.errorStyle && e.addAttribute("errorStyle", t.errorStyle), t.errorTitle && e.addAttribute("errorTitle", t.errorTitle), t.error && e.addAttribute("error", t.error), e.addAttribute("sqref", t.sqref), (t.formulae || []).forEach((r, n)=>{
                                e.openNode("formula" + (n + 1)), "date" === t.type ? e.writeText(i.dateToExcel(new Date(r))) : e.writeText(r), e.closeNode();
                            }), e.closeNode();
                        }), e.closeNode());
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "dataValidations":
                                return this.model = {}, !0;
                            case "dataValidation":
                                {
                                    this._address = e.attributes.sqref;
                                    const t = {
                                        type: e.attributes.type || "any",
                                        formulae: []
                                    };
                                    switch(e.attributes.type && c(t, e.attributes, "allowBlank"), c(t, e.attributes, "showInputMessage"), c(t, e.attributes, "showErrorMessage"), t.type){
                                        case "any":
                                        case "list":
                                        case "custom":
                                            break;
                                        default:
                                            l(t, e.attributes, "operator", "between");
                                    }
                                    return l(t, e.attributes, "promptTitle"), l(t, e.attributes, "prompt"), l(t, e.attributes, "errorStyle"), l(t, e.attributes, "errorTitle"), l(t, e.attributes, "error"), this._dataValidation = t, !0;
                                }
                            case "formula1":
                            case "formula2":
                                return this._formula = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._formula && this._formula.push(e);
                    }
                    parseClose(e) {
                        switch(e){
                            case "dataValidations":
                                return !1;
                            case "dataValidation":
                                this._dataValidation.formulae && this._dataValidation.formulae.length || (delete this._dataValidation.formulae, delete this._dataValidation.operator);
                                return (this._address.split(/\s+/g) || []).forEach((e)=>{
                                    if (e.includes(":")) new a(e).forEachAddress((e)=>{
                                        this.model[e] = this._dataValidation;
                                    });
                                    else this.model[e] = this._dataValidation;
                                }), !0;
                            case "formula1":
                            case "formula2":
                                {
                                    let e = this._formula.join("");
                                    switch(this._dataValidation.type){
                                        case "whole":
                                        case "textLength":
                                            e = parseInt(e, 10);
                                            break;
                                        case "decimal":
                                            e = parseFloat(e);
                                            break;
                                        case "date":
                                            e = i.excelToDate(parseFloat(e));
                                    }
                                    return this._dataValidation.formulae.push(e), this._formula = void 0, !0;
                                }
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../../../doc/range": 10,
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        94: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "dimension";
                    }
                    render(e, t) {
                        t && e.leafNode("dimension", {
                            ref: t
                        });
                    }
                    parseOpen(e) {
                        return "dimension" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        95: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "drawing";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        96: [
            function(e, t, r) {
                "use strict";
                const n = e("../composite-xform"), i = e("./cf-ext/conditional-formattings-ext-xform");
                class s extends n {
                    constructor(){
                        super(), this.map = {
                            "x14:conditionalFormattings": this.conditionalFormattings = new i
                        };
                    }
                    get tag() {
                        return "ext";
                    }
                    hasContent(e) {
                        return this.conditionalFormattings.hasContent(e.conditionalFormattings);
                    }
                    prepare(e, t) {
                        this.conditionalFormattings.prepare(e.conditionalFormattings, t);
                    }
                    render(e, t) {
                        e.openNode("ext", {
                            uri: "{78C0D931-6437-407d-A8EE-F0AAD7539E65}",
                            "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                        }), this.conditionalFormattings.render(e, t.conditionalFormattings), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        this.model[e] = t.model;
                    }
                }
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            ext: this.ext = new s
                        };
                    }
                    get tag() {
                        return "extLst";
                    }
                    prepare(e, t) {
                        this.ext.prepare(e, t);
                    }
                    hasContent(e) {
                        return this.ext.hasContent(e);
                    }
                    render(e, t) {
                        this.hasContent(t) && (e.openNode("extLst"), this.ext.render(e, t), e.closeNode());
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                };
            },
            {
                "../composite-xform": 48,
                "./cf-ext/conditional-formattings-ext-xform": 78
            }
        ],
        97: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "headerFooter";
                    }
                    render(e, t) {
                        if (t) {
                            e.addRollback();
                            let r = !1;
                            e.openNode("headerFooter"), t.differentFirst && (e.addAttribute("differentFirst", "1"), r = !0), t.differentOddEven && (e.addAttribute("differentOddEven", "1"), r = !0), t.oddHeader && "string" == typeof t.oddHeader && (e.leafNode("oddHeader", null, t.oddHeader), r = !0), t.oddFooter && "string" == typeof t.oddFooter && (e.leafNode("oddFooter", null, t.oddFooter), r = !0), t.evenHeader && "string" == typeof t.evenHeader && (e.leafNode("evenHeader", null, t.evenHeader), r = !0), t.evenFooter && "string" == typeof t.evenFooter && (e.leafNode("evenFooter", null, t.evenFooter), r = !0), t.firstHeader && "string" == typeof t.firstHeader && (e.leafNode("firstHeader", null, t.firstHeader), r = !0), t.firstFooter && "string" == typeof t.firstFooter && (e.leafNode("firstFooter", null, t.firstFooter), r = !0), r ? (e.closeNode(), e.commit()) : e.rollback();
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "headerFooter":
                                return this.model = {}, e.attributes.differentFirst && (this.model.differentFirst = 1 === parseInt(e.attributes.differentFirst, 0)), e.attributes.differentOddEven && (this.model.differentOddEven = 1 === parseInt(e.attributes.differentOddEven, 0)), !0;
                            case "oddHeader":
                                return this.currentNode = "oddHeader", !0;
                            case "oddFooter":
                                return this.currentNode = "oddFooter", !0;
                            case "evenHeader":
                                return this.currentNode = "evenHeader", !0;
                            case "evenFooter":
                                return this.currentNode = "evenFooter", !0;
                            case "firstHeader":
                                return this.currentNode = "firstHeader", !0;
                            case "firstFooter":
                                return this.currentNode = "firstFooter", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        switch(this.currentNode){
                            case "oddHeader":
                                this.model.oddHeader = e;
                                break;
                            case "oddFooter":
                                this.model.oddFooter = e;
                                break;
                            case "evenHeader":
                                this.model.evenHeader = e;
                                break;
                            case "evenFooter":
                                this.model.evenFooter = e;
                                break;
                            case "firstHeader":
                                this.model.firstHeader = e;
                                break;
                            case "firstFooter":
                                this.model.firstFooter = e;
                        }
                    }
                    parseClose() {
                        switch(this.currentNode){
                            case "oddHeader":
                            case "oddFooter":
                            case "evenHeader":
                            case "evenFooter":
                            case "firstHeader":
                            case "firstFooter":
                                return this.currentNode = void 0, !0;
                            default:
                                return !1;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        98: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "hyperlink";
                    }
                    render(e, t) {
                        this.isInternalLink(t) ? e.leafNode("hyperlink", {
                            ref: t.address,
                            "r:id": t.rId,
                            tooltip: t.tooltip,
                            location: t.target
                        }) : e.leafNode("hyperlink", {
                            ref: t.address,
                            "r:id": t.rId,
                            tooltip: t.tooltip
                        });
                    }
                    parseOpen(e) {
                        return "hyperlink" === e.name && (this.model = {
                            address: e.attributes.ref,
                            rId: e.attributes["r:id"],
                            tooltip: e.attributes.tooltip
                        }, e.attributes.location && (this.model.target = e.attributes.location), !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                    isInternalLink(e) {
                        return e.target && /^[^!]+![a-zA-Z]+[\d]+$/.test(e.target);
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        99: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "mergeCell";
                    }
                    render(e, t) {
                        e.leafNode("mergeCell", {
                            ref: t
                        });
                    }
                    parseOpen(e) {
                        return "mergeCell" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        100: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../doc/range"), s = e("../../../utils/col-cache"), o = e("../../../doc/enums");
                t.exports = class {
                    constructor(){
                        this.merges = {};
                    }
                    add(e) {
                        if (this.merges[e.master]) this.merges[e.master].expandToAddress(e.address);
                        else {
                            const t = `${e.master}:${e.address}`;
                            this.merges[e.master] = new i(t);
                        }
                    }
                    get mergeCells() {
                        return n.map(this.merges, (e)=>e.range);
                    }
                    reconcile(e, t) {
                        n.each(e, (e)=>{
                            const r = s.decode(e);
                            for(let e = r.top; e <= r.bottom; e++){
                                const n = t[e - 1];
                                for(let t = r.left; t <= r.right; t++){
                                    const i = n.cells[t - 1];
                                    i ? i.type === o.ValueType.Merge && (i.master = r.tl) : n.cells[t] = {
                                        type: o.ValueType.Null,
                                        address: s.encodeAddress(e, t)
                                    };
                                }
                            }
                        });
                    }
                    getMasterAddress(e) {
                        const t = this.hash[e];
                        return t && t.tl;
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../doc/range": 10,
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26
            }
        ],
        101: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = (e)=>void 0 !== e;
                t.exports = class extends n {
                    get tag() {
                        return "outlinePr";
                    }
                    render(e, t) {
                        return !(!t || !i(t.summaryBelow) && !i(t.summaryRight)) && (e.leafNode(this.tag, {
                            summaryBelow: i(t.summaryBelow) ? Number(t.summaryBelow) : void 0,
                            summaryRight: i(t.summaryRight) ? Number(t.summaryRight) : void 0
                        }), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            summaryBelow: i(e.attributes.summaryBelow) ? Boolean(Number(e.attributes.summaryBelow)) : void 0,
                            summaryRight: i(e.attributes.summaryRight) ? Boolean(Number(e.attributes.summaryRight)) : void 0
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        102: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "brk";
                    }
                    render(e, t) {
                        e.leafNode("brk", t);
                    }
                    parseOpen(e) {
                        return "brk" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        103: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "pageMargins";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                left: t.left,
                                right: t.right,
                                top: t.top,
                                bottom: t.bottom,
                                header: t.header,
                                footer: t.footer
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    left: parseFloat(e.attributes.left || .7),
                                    right: parseFloat(e.attributes.right || .7),
                                    top: parseFloat(e.attributes.top || .75),
                                    bottom: parseFloat(e.attributes.bottom || .75),
                                    header: parseFloat(e.attributes.header || .3),
                                    footer: parseFloat(e.attributes.footer || .3)
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        104: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "pageSetUpPr";
                    }
                    render(e, t) {
                        return !(!t || !t.fitToPage) && (e.leafNode(this.tag, {
                            fitToPage: t.fitToPage ? "1" : void 0
                        }), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            fitToPage: "1" === e.attributes.fitToPage
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        105: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e) {
                    return e ? "1" : void 0;
                }
                function o(e) {
                    switch(e){
                        case "overThenDown":
                            return e;
                        default:
                            return;
                    }
                }
                function a(e) {
                    switch(e){
                        case "atEnd":
                        case "asDisplyed":
                            return e;
                        default:
                            return;
                    }
                }
                function l(e) {
                    switch(e){
                        case "dash":
                        case "blank":
                        case "NA":
                            return e;
                        default:
                            return;
                    }
                }
                t.exports = class extends i {
                    get tag() {
                        return "pageSetup";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                paperSize: t.paperSize,
                                orientation: t.orientation,
                                horizontalDpi: t.horizontalDpi,
                                verticalDpi: t.verticalDpi,
                                pageOrder: o(t.pageOrder),
                                blackAndWhite: s(t.blackAndWhite),
                                draft: s(t.draft),
                                cellComments: a(t.cellComments),
                                errors: l(t.errors),
                                scale: t.scale,
                                fitToWidth: t.fitToWidth,
                                fitToHeight: t.fitToHeight,
                                firstPageNumber: t.firstPageNumber,
                                useFirstPageNumber: s(t.firstPageNumber),
                                usePrinterDefaults: s(t.usePrinterDefaults),
                                copies: t.copies
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    paperSize: (t = e.attributes.paperSize, void 0 !== t ? parseInt(t, 10) : void 0),
                                    orientation: e.attributes.orientation || "portrait",
                                    horizontalDpi: parseInt(e.attributes.horizontalDpi || "4294967295", 10),
                                    verticalDpi: parseInt(e.attributes.verticalDpi || "4294967295", 10),
                                    pageOrder: e.attributes.pageOrder || "downThenOver",
                                    blackAndWhite: "1" === e.attributes.blackAndWhite,
                                    draft: "1" === e.attributes.draft,
                                    cellComments: e.attributes.cellComments || "None",
                                    errors: e.attributes.errors || "displayed",
                                    scale: parseInt(e.attributes.scale || "100", 10),
                                    fitToWidth: parseInt(e.attributes.fitToWidth || "1", 10),
                                    fitToHeight: parseInt(e.attributes.fitToHeight || "1", 10),
                                    firstPageNumber: parseInt(e.attributes.firstPageNumber || "1", 10),
                                    useFirstPageNumber: "1" === e.attributes.useFirstPageNumber,
                                    usePrinterDefaults: "1" === e.attributes.usePrinterDefaults,
                                    copies: parseInt(e.attributes.copies || "1", 10)
                                }, !0;
                            default:
                                return !1;
                        }
                        var t;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        106: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "picture";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        107: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e) {
                    return e ? "1" : void 0;
                }
                t.exports = class extends i {
                    get tag() {
                        return "printOptions";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                headings: s(t.showRowColHeaders),
                                gridLines: s(t.showGridLines),
                                horizontalCentered: s(t.horizontalCentered),
                                verticalCentered: s(t.verticalCentered)
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    showRowColHeaders: "1" === e.attributes.headings,
                                    showGridLines: "1" === e.attributes.gridLines,
                                    horizontalCentered: "1" === e.attributes.horizontalCentered,
                                    verticalCentered: "1" === e.attributes.verticalCentered
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        108: [
            function(e, t, r) {
                "use strict";
                const n = e("./page-breaks-xform"), i = e("../list-xform");
                t.exports = class extends i {
                    constructor(){
                        super({
                            tag: "rowBreaks",
                            count: !0,
                            childXform: new n
                        });
                    }
                    render(e, t) {
                        if (t && t.length) {
                            e.openNode(this.tag, this.$), this.count && (e.addAttribute(this.$count, t.length), e.addAttribute("manualBreakCount", t.length));
                            const { childXform: r } = this;
                            t.forEach((t)=>{
                                r.render(e, t);
                            }), e.closeNode();
                        } else this.empty && e.leafNode(this.tag);
                    }
                };
            },
            {
                "../list-xform": 71,
                "./page-breaks-xform": 102
            }
        ],
        109: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/utils"), s = e("./cell-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.maxItems = e && e.maxItems, this.map = {
                            c: new s
                        };
                    }
                    get tag() {
                        return "row";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style);
                        r && (e.styleId = r);
                        const n = this.map.c;
                        e.cells.forEach((e)=>{
                            n.prepare(e, t);
                        });
                    }
                    render(e, t, r) {
                        e.openNode("row"), e.addAttribute("r", t.number), t.height && (e.addAttribute("ht", t.height), e.addAttribute("customHeight", "1")), t.hidden && e.addAttribute("hidden", "1"), t.min > 0 && t.max > 0 && t.min <= t.max && e.addAttribute("spans", `${t.min}:${t.max}`), t.styleId && (e.addAttribute("s", t.styleId), e.addAttribute("customFormat", "1")), e.addAttribute("x14ac:dyDescent", "0.25"), t.outlineLevel && e.addAttribute("outlineLevel", t.outlineLevel), t.collapsed && e.addAttribute("collapsed", "1");
                        const n = this.map.c;
                        t.cells.forEach((t)=>{
                            n.render(e, t, r);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        if ("row" === e.name) {
                            this.numRowsSeen += 1;
                            const t = e.attributes.spans ? e.attributes.spans.split(":").map((e)=>parseInt(e, 10)) : [
                                void 0,
                                void 0
                            ], r = this.model = {
                                number: parseInt(e.attributes.r, 10),
                                min: t[0],
                                max: t[1],
                                cells: []
                            };
                            return e.attributes.s && (r.styleId = parseInt(e.attributes.s, 10)), i.parseBoolean(e.attributes.hidden) && (r.hidden = !0), i.parseBoolean(e.attributes.bestFit) && (r.bestFit = !0), e.attributes.ht && (r.height = parseFloat(e.attributes.ht)), e.attributes.outlineLevel && (r.outlineLevel = parseInt(e.attributes.outlineLevel, 10)), i.parseBoolean(e.attributes.collapsed) && (r.collapsed = !0), !0;
                        }
                        return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                if (this.model.cells.push(this.parser.model), this.maxItems && this.model.cells.length > this.maxItems) throw new Error(`Max column count (${this.maxItems}) exceeded`);
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        return !1;
                    }
                    reconcile(e, t) {
                        e.style = e.styleId ? t.styles.getStyleModel(e.styleId) : {}, void 0 !== e.styleId && (e.styleId = void 0);
                        const r = this.map.c;
                        e.cells.forEach((e)=>{
                            r.reconcile(e, t);
                        });
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "./cell-xform": 73
            }
        ],
        110: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "sheetFormatPr";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                defaultRowHeight: t.defaultRowHeight,
                                outlineLevelRow: t.outlineLevelRow,
                                outlineLevelCol: t.outlineLevelCol,
                                "x14ac:dyDescent": t.dyDescent
                            };
                            t.defaultColWidth && (r.defaultColWidth = t.defaultColWidth), t.defaultRowHeight && 15 === t.defaultRowHeight || (r.customHeight = "1"), n.some(r, (e)=>void 0 !== e) && e.leafNode("sheetFormatPr", r);
                        }
                    }
                    parseOpen(e) {
                        return "sheetFormatPr" === e.name && (this.model = {
                            defaultRowHeight: parseFloat(e.attributes.defaultRowHeight || "0"),
                            dyDescent: parseFloat(e.attributes["x14ac:dyDescent"] || "0"),
                            outlineLevelRow: parseInt(e.attributes.outlineLevelRow || "0", 10),
                            outlineLevelCol: parseInt(e.attributes.outlineLevelCol || "0", 10)
                        }, e.attributes.defaultColWidth && (this.model.defaultColWidth = parseFloat(e.attributes.defaultColWidth)), !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        111: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../style/color-xform"), s = e("./page-setup-properties-xform"), o = e("./outline-properties-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            tabColor: new i("tabColor"),
                            pageSetUpPr: new s,
                            outlinePr: new o
                        };
                    }
                    get tag() {
                        return "sheetPr";
                    }
                    render(e, t) {
                        if (t) {
                            e.addRollback(), e.openNode("sheetPr");
                            let r = !1;
                            r = this.map.tabColor.render(e, t.tabColor) || r, r = this.map.pageSetUpPr.render(e, t.pageSetup) || r, r = this.map.outlinePr.render(e, t.outlineProperties) || r, r ? (e.closeNode(), e.commit()) : e.rollback();
                        }
                    }
                    parseOpen(e) {
                        return this.parser ? (this.parser.parseOpen(e), !0) : e.name === this.tag ? (this.reset(), !0) : !!this.map[e.name] && (this.parser = this.map[e.name], this.parser.parseOpen(e), !0);
                    }
                    parseText(e) {
                        return !!this.parser && (this.parser.parseText(e), !0);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : (this.map.tabColor.model || this.map.pageSetUpPr.model || this.map.outlinePr.model ? (this.model = {}, this.map.tabColor.model && (this.model.tabColor = this.map.tabColor.model), this.map.pageSetUpPr.model && (this.model.pageSetup = this.map.pageSetUpPr.model), this.map.outlinePr.model && (this.model.outlineProperties = this.map.outlinePr.model)) : this.model = null, !1);
                    }
                };
            },
            {
                "../base-xform": 32,
                "../style/color-xform": 128,
                "./outline-properties-xform": 101,
                "./page-setup-properties-xform": 104
            }
        ],
        112: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e, t) {
                    return e ? t : void 0;
                }
                function o(e, t) {
                    return e === t || void 0;
                }
                t.exports = class extends i {
                    get tag() {
                        return "sheetProtection";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                sheet: s(t.sheet, "1"),
                                selectLockedCells: !1 === t.selectLockedCells ? "1" : void 0,
                                selectUnlockedCells: !1 === t.selectUnlockedCells ? "1" : void 0,
                                formatCells: s(t.formatCells, "0"),
                                formatColumns: s(t.formatColumns, "0"),
                                formatRows: s(t.formatRows, "0"),
                                insertColumns: s(t.insertColumns, "0"),
                                insertRows: s(t.insertRows, "0"),
                                insertHyperlinks: s(t.insertHyperlinks, "0"),
                                deleteColumns: s(t.deleteColumns, "0"),
                                deleteRows: s(t.deleteRows, "0"),
                                sort: s(t.sort, "0"),
                                autoFilter: s(t.autoFilter, "0"),
                                pivotTables: s(t.pivotTables, "0")
                            };
                            t.sheet && (r.algorithmName = t.algorithmName, r.hashValue = t.hashValue, r.saltValue = t.saltValue, r.spinCount = t.spinCount, r.objects = s(!1 === t.objects, "1"), r.scenarios = s(!1 === t.scenarios, "1")), n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    sheet: o(e.attributes.sheet, "1"),
                                    objects: "1" !== e.attributes.objects && void 0,
                                    scenarios: "1" !== e.attributes.scenarios && void 0,
                                    selectLockedCells: "1" !== e.attributes.selectLockedCells && void 0,
                                    selectUnlockedCells: "1" !== e.attributes.selectUnlockedCells && void 0,
                                    formatCells: o(e.attributes.formatCells, "0"),
                                    formatColumns: o(e.attributes.formatColumns, "0"),
                                    formatRows: o(e.attributes.formatRows, "0"),
                                    insertColumns: o(e.attributes.insertColumns, "0"),
                                    insertRows: o(e.attributes.insertRows, "0"),
                                    insertHyperlinks: o(e.attributes.insertHyperlinks, "0"),
                                    deleteColumns: o(e.attributes.deleteColumns, "0"),
                                    deleteRows: o(e.attributes.deleteRows, "0"),
                                    sort: o(e.attributes.sort, "0"),
                                    autoFilter: o(e.attributes.autoFilter, "0"),
                                    pivotTables: o(e.attributes.pivotTables, "0")
                                }, e.attributes.algorithmName && (this.model.algorithmName = e.attributes.algorithmName, this.model.hashValue = e.attributes.hashValue, this.model.saltValue = e.attributes.saltValue, this.model.spinCount = parseInt(e.attributes.spinCount, 10)), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        113: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../base-xform"), s = {
                    frozen: "frozen",
                    frozenSplit: "frozen",
                    split: "split"
                };
                t.exports = class extends i {
                    get tag() {
                        return "sheetView";
                    }
                    prepare(e) {
                        switch(e.state){
                            case "frozen":
                            case "split":
                                break;
                            default:
                                e.state = "normal";
                        }
                    }
                    render(e, t) {
                        e.openNode("sheetView", {
                            workbookViewId: t.workbookViewId || 0
                        });
                        const r = function(t, r, n) {
                            n && e.addAttribute(t, r);
                        };
                        let i, s, o, a;
                        switch(r("rightToLeft", "1", !0 === t.rightToLeft), r("tabSelected", "1", t.tabSelected), r("showRuler", "0", !1 === t.showRuler), r("showRowColHeaders", "0", !1 === t.showRowColHeaders), r("showGridLines", "0", !1 === t.showGridLines), r("zoomScale", t.zoomScale, t.zoomScale), r("zoomScaleNormal", t.zoomScaleNormal, t.zoomScaleNormal), r("view", t.style, t.style), t.state){
                            case "frozen":
                                s = t.xSplit || 0, o = t.ySplit || 0, i = t.topLeftCell || n.getAddress(o + 1, s + 1).address, a = (t.xSplit && t.ySplit ? "bottomRight" : t.xSplit && "topRight") || "bottomLeft", e.leafNode("pane", {
                                    xSplit: t.xSplit || void 0,
                                    ySplit: t.ySplit || void 0,
                                    topLeftCell: i,
                                    activePane: a,
                                    state: "frozen"
                                }), e.leafNode("selection", {
                                    pane: a,
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                                break;
                            case "split":
                                "topLeft" === t.activePane && (t.activePane = void 0), e.leafNode("pane", {
                                    xSplit: t.xSplit || void 0,
                                    ySplit: t.ySplit || void 0,
                                    topLeftCell: t.topLeftCell,
                                    activePane: t.activePane
                                }), e.leafNode("selection", {
                                    pane: t.activePane,
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                                break;
                            case "normal":
                                t.activeCell && e.leafNode("selection", {
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                        }
                        e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "sheetView":
                                return this.sheetView = {
                                    workbookViewId: parseInt(e.attributes.workbookViewId, 10),
                                    rightToLeft: "1" === e.attributes.rightToLeft,
                                    tabSelected: "1" === e.attributes.tabSelected,
                                    showRuler: !("0" === e.attributes.showRuler),
                                    showRowColHeaders: !("0" === e.attributes.showRowColHeaders),
                                    showGridLines: !("0" === e.attributes.showGridLines),
                                    zoomScale: parseInt(e.attributes.zoomScale || "100", 10),
                                    zoomScaleNormal: parseInt(e.attributes.zoomScaleNormal || "100", 10),
                                    style: e.attributes.view
                                }, this.pane = void 0, this.selections = {}, !0;
                            case "pane":
                                return this.pane = {
                                    xSplit: parseInt(e.attributes.xSplit || "0", 10),
                                    ySplit: parseInt(e.attributes.ySplit || "0", 10),
                                    topLeftCell: e.attributes.topLeftCell,
                                    activePane: e.attributes.activePane || "topLeft",
                                    state: e.attributes.state
                                }, !0;
                            case "selection":
                                {
                                    const t = e.attributes.pane || "topLeft";
                                    return this.selections[t] = {
                                        pane: t,
                                        activeCell: e.attributes.activeCell
                                    }, !0;
                                }
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        let t, r;
                        switch(e){
                            case "sheetView":
                                return this.sheetView && this.pane ? (t = this.model = {
                                    workbookViewId: this.sheetView.workbookViewId,
                                    rightToLeft: this.sheetView.rightToLeft,
                                    state: s[this.pane.state] || "split",
                                    xSplit: this.pane.xSplit,
                                    ySplit: this.pane.ySplit,
                                    topLeftCell: this.pane.topLeftCell,
                                    showRuler: this.sheetView.showRuler,
                                    showRowColHeaders: this.sheetView.showRowColHeaders,
                                    showGridLines: this.sheetView.showGridLines,
                                    zoomScale: this.sheetView.zoomScale,
                                    zoomScaleNormal: this.sheetView.zoomScaleNormal
                                }, "split" === this.model.state && (t.activePane = this.pane.activePane), r = this.selections[this.pane.activePane], r && r.activeCell && (t.activeCell = r.activeCell), this.sheetView.style && (t.style = this.sheetView.style)) : (t = this.model = {
                                    workbookViewId: this.sheetView.workbookViewId,
                                    rightToLeft: this.sheetView.rightToLeft,
                                    state: "normal",
                                    showRuler: this.sheetView.showRuler,
                                    showRowColHeaders: this.sheetView.showRowColHeaders,
                                    showGridLines: this.sheetView.showGridLines,
                                    zoomScale: this.sheetView.zoomScale,
                                    zoomScaleNormal: this.sheetView.zoomScaleNormal
                                }, r = this.selections.topLeft, r && r.activeCell && (t.activeCell = r.activeCell), this.sheetView.style && (t.style = this.sheetView.style)), !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile() {}
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        114: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tablePart";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        115: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/col-cache"), s = e("../../../utils/xml-stream"), o = e("../../rel-type"), a = e("./merges"), l = e("../base-xform"), c = e("../list-xform"), u = e("./row-xform"), h = e("./col-xform"), f = e("./dimension-xform"), d = e("./hyperlink-xform"), p = e("./merge-cell-xform"), m = e("./data-validations-xform"), b = e("./sheet-properties-xform"), g = e("./sheet-format-properties-xform"), y = e("./sheet-view-xform"), v = e("./sheet-protection-xform"), w = e("./page-margins-xform"), _ = e("./page-setup-xform"), x = e("./print-options-xform"), k = e("./auto-filter-xform"), S = e("./picture-xform"), M = e("./drawing-xform"), C = e("./table-part-xform"), T = e("./row-breaks-xform"), E = e("./header-footer-xform"), A = e("./cf/conditional-formattings-xform"), R = e("./ext-lst-xform"), O = (e, t)=>{
                    if (!t || !t.length) return e;
                    if (!e || !e.length) return t;
                    const r = {}, n = {};
                    return e.forEach((e)=>{
                        r[e.ref] = e, e.rules.forEach((e)=>{
                            const { x14Id: t } = e;
                            t && (n[t] = e);
                        });
                    }), t.forEach((t)=>{
                        t.rules.forEach((i)=>{
                            const s = n[i.x14Id];
                            s ? ((e, t)=>{
                                Object.keys(t).forEach((r)=>{
                                    const n = e[r], i = t[r];
                                    void 0 === n && void 0 !== i && (e[r] = i);
                                });
                            })(s, i) : r[t.ref] ? r[t.ref].rules.push(i) : e.push({
                                ref: t.ref,
                                rules: [
                                    i
                                ]
                            });
                        });
                    }), e;
                };
                class j extends l {
                    constructor(e){
                        super();
                        const { maxRows: t, maxCols: r, ignoreNodes: n } = e || {};
                        this.ignoreNodes = n || [], this.map = {
                            sheetPr: new b,
                            dimension: new f,
                            sheetViews: new c({
                                tag: "sheetViews",
                                count: !1,
                                childXform: new y
                            }),
                            sheetFormatPr: new g,
                            cols: new c({
                                tag: "cols",
                                count: !1,
                                childXform: new h
                            }),
                            sheetData: new c({
                                tag: "sheetData",
                                count: !1,
                                empty: !0,
                                childXform: new u({
                                    maxItems: r
                                }),
                                maxItems: t
                            }),
                            autoFilter: new k,
                            mergeCells: new c({
                                tag: "mergeCells",
                                count: !0,
                                childXform: new p
                            }),
                            rowBreaks: new T,
                            hyperlinks: new c({
                                tag: "hyperlinks",
                                count: !1,
                                childXform: new d
                            }),
                            pageMargins: new w,
                            dataValidations: new m,
                            pageSetup: new _,
                            headerFooter: new E,
                            printOptions: new x,
                            picture: new S,
                            drawing: new M,
                            sheetProtection: new v,
                            tableParts: new c({
                                tag: "tableParts",
                                count: !0,
                                childXform: new C
                            }),
                            conditionalFormatting: new A,
                            extLst: new R
                        };
                    }
                    prepare(e, t) {
                        t.merges = new a, e.hyperlinks = t.hyperlinks = [], e.comments = t.comments = [], t.formulae = {}, t.siFormulae = 0, this.map.cols.prepare(e.cols, t), this.map.sheetData.prepare(e.rows, t), this.map.conditionalFormatting.prepare(e.conditionalFormattings, t), e.mergeCells = t.merges.mergeCells;
                        const r = e.rels = [];
                        function n(e) {
                            return "rId" + (e.length + 1);
                        }
                        if (e.hyperlinks.forEach((e)=>{
                            const t = n(r);
                            e.rId = t, r.push({
                                Id: t,
                                Type: o.Hyperlink,
                                Target: e.target,
                                TargetMode: "External"
                            });
                        }), e.comments.length > 0) {
                            const s = {
                                Id: n(r),
                                Type: o.Comments,
                                Target: `../comments${e.id}.xml`
                            };
                            r.push(s);
                            const a = {
                                Id: n(r),
                                Type: o.VmlDrawing,
                                Target: `../drawings/vmlDrawing${e.id}.vml`
                            };
                            r.push(a), e.comments.forEach((e)=>{
                                e.refAddress = i.decodeAddress(e.ref);
                            }), t.commentRefs.push({
                                commentName: "comments" + e.id,
                                vmlDrawing: "vmlDrawing" + e.id
                            });
                        }
                        const s = [];
                        let l;
                        e.media.forEach((i)=>{
                            if ("background" === i.type) {
                                const s = n(r);
                                l = t.media[i.imageId], r.push({
                                    Id: s,
                                    Type: o.Image,
                                    Target: `../media/${l.name}.${l.extension}`
                                }), e.background = {
                                    rId: s
                                }, e.image = t.media[i.imageId];
                            } else if ("image" === i.type) {
                                let { drawing: a } = e;
                                l = t.media[i.imageId], a || (a = e.drawing = {
                                    rId: n(r),
                                    name: "drawing" + ++t.drawingsCount,
                                    anchors: [],
                                    rels: []
                                }, t.drawings.push(a), r.push({
                                    Id: a.rId,
                                    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
                                    Target: `../drawings/${a.name}.xml`
                                }));
                                let c = this.preImageId === i.imageId ? s[i.imageId] : s[a.rels.length];
                                c || (c = n(a.rels), s[a.rels.length] = c, a.rels.push({
                                    Id: c,
                                    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                                    Target: `../media/${l.name}.${l.extension}`
                                }));
                                const u = {
                                    picture: {
                                        rId: c
                                    },
                                    range: i.range
                                };
                                if (i.hyperlinks && i.hyperlinks.hyperlink) {
                                    const e = n(a.rels);
                                    s[a.rels.length] = e, u.picture.hyperlinks = {
                                        tooltip: i.hyperlinks.tooltip,
                                        rId: e
                                    }, a.rels.push({
                                        Id: e,
                                        Type: o.Hyperlink,
                                        Target: i.hyperlinks.hyperlink,
                                        TargetMode: "External"
                                    });
                                }
                                this.preImageId = i.imageId, a.anchors.push(u);
                            }
                        }), e.tables.forEach((e)=>{
                            const i = n(r);
                            e.rId = i, r.push({
                                Id: i,
                                Type: o.Table,
                                Target: "../tables/" + e.target
                            }), e.columns.forEach((e)=>{
                                const { style: r } = e;
                                r && (e.dxfId = t.styles.addDxfStyle(r));
                            });
                        }), this.map.extLst.prepare(e, t);
                    }
                    render(e, t) {
                        e.openXml(s.StdDocAttributes), e.openNode("worksheet", j.WORKSHEET_ATTRIBUTES);
                        const r = t.properties ? {
                            defaultRowHeight: t.properties.defaultRowHeight,
                            dyDescent: t.properties.dyDescent,
                            outlineLevelCol: t.properties.outlineLevelCol,
                            outlineLevelRow: t.properties.outlineLevelRow
                        } : void 0;
                        t.properties && t.properties.defaultColWidth && (r.defaultColWidth = t.properties.defaultColWidth);
                        const n = {
                            outlineProperties: t.properties && t.properties.outlineProperties,
                            tabColor: t.properties && t.properties.tabColor,
                            pageSetup: t.pageSetup && t.pageSetup.fitToPage ? {
                                fitToPage: t.pageSetup.fitToPage
                            } : void 0
                        }, i = t.pageSetup && t.pageSetup.margins, a = {
                            showRowColHeaders: t.pageSetup && t.pageSetup.showRowColHeaders,
                            showGridLines: t.pageSetup && t.pageSetup.showGridLines,
                            horizontalCentered: t.pageSetup && t.pageSetup.horizontalCentered,
                            verticalCentered: t.pageSetup && t.pageSetup.verticalCentered
                        }, l = t.sheetProtection;
                        this.map.sheetPr.render(e, n), this.map.dimension.render(e, t.dimensions), this.map.sheetViews.render(e, t.views), this.map.sheetFormatPr.render(e, r), this.map.cols.render(e, t.cols), this.map.sheetData.render(e, t.rows), this.map.sheetProtection.render(e, l), this.map.autoFilter.render(e, t.autoFilter), this.map.mergeCells.render(e, t.mergeCells), this.map.conditionalFormatting.render(e, t.conditionalFormattings), this.map.dataValidations.render(e, t.dataValidations), this.map.hyperlinks.render(e, t.hyperlinks), this.map.printOptions.render(e, a), this.map.pageMargins.render(e, i), this.map.pageSetup.render(e, t.pageSetup), this.map.headerFooter.render(e, t.headerFooter), this.map.rowBreaks.render(e, t.rowBreaks), this.map.drawing.render(e, t.drawing), this.map.picture.render(e, t.background), this.map.tableParts.render(e, t.tables), this.map.extLst.render(e, t), t.rels && t.rels.forEach((t)=>{
                            t.Type === o.VmlDrawing && e.leafNode("legacyDrawing", {
                                "r:id": t.Id
                            });
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        return this.parser ? (this.parser.parseOpen(e), !0) : "worksheet" === e.name ? (n.each(this.map, (e)=>{
                            e.reset();
                        }), !0) : (this.map[e.name] && !this.ignoreNodes.includes(e.name) && (this.parser = this.map[e.name], this.parser.parseOpen(e)), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "worksheet":
                                {
                                    const e = this.map.sheetFormatPr.model || {};
                                    this.map.sheetPr.model && this.map.sheetPr.model.tabColor && (e.tabColor = this.map.sheetPr.model.tabColor), this.map.sheetPr.model && this.map.sheetPr.model.outlineProperties && (e.outlineProperties = this.map.sheetPr.model.outlineProperties);
                                    const t = {
                                        fitToPage: this.map.sheetPr.model && this.map.sheetPr.model.pageSetup && this.map.sheetPr.model.pageSetup.fitToPage || !1,
                                        margins: this.map.pageMargins.model
                                    }, r = Object.assign(t, this.map.pageSetup.model, this.map.printOptions.model), n = O(this.map.conditionalFormatting.model, this.map.extLst.model && this.map.extLst.model["x14:conditionalFormattings"]);
                                    return this.model = {
                                        dimensions: this.map.dimension.model,
                                        cols: this.map.cols.model,
                                        rows: this.map.sheetData.model,
                                        mergeCells: this.map.mergeCells.model,
                                        hyperlinks: this.map.hyperlinks.model,
                                        dataValidations: this.map.dataValidations.model,
                                        properties: e,
                                        views: this.map.sheetViews.model,
                                        pageSetup: r,
                                        headerFooter: this.map.headerFooter.model,
                                        background: this.map.picture.model,
                                        drawing: this.map.drawing.model,
                                        tables: this.map.tableParts.model,
                                        conditionalFormattings: n
                                    }, this.map.autoFilter.model && (this.model.autoFilter = this.map.autoFilter.model), this.map.sheetProtection.model && (this.model.sheetProtection = this.map.sheetProtection.model), !1;
                                }
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        const r = (e.relationships || []).reduce((r, n)=>{
                            if (r[n.Id] = n, n.Type === o.Comments && (e.comments = t.comments[n.Target].comments), n.Type === o.VmlDrawing && e.comments && e.comments.length) {
                                const r = t.vmlDrawings[n.Target].comments;
                                e.comments.forEach((e, t)=>{
                                    e.note = Object.assign({}, e.note, r[t]);
                                });
                            }
                            return r;
                        }, {});
                        if (t.commentsMap = (e.comments || []).reduce((e, t)=>(t.ref && (e[t.ref] = t), e), {}), t.hyperlinkMap = (e.hyperlinks || []).reduce((e, t)=>(t.rId && (e[t.address] = r[t.rId].Target), e), {}), t.formulae = {}, e.rows = e.rows && e.rows.filter(Boolean) || [], e.rows.forEach((e)=>{
                            e.cells = e.cells && e.cells.filter(Boolean) || [];
                        }), this.map.cols.reconcile(e.cols, t), this.map.sheetData.reconcile(e.rows, t), this.map.conditionalFormatting.reconcile(e.conditionalFormattings, t), e.media = [], e.drawing) {
                            const n = r[e.drawing.rId].Target.match(/\/drawings\/([a-zA-Z0-9]+)[.][a-zA-Z]{3,4}$/);
                            if (n) {
                                const r = n[1];
                                t.drawings[r].anchors.forEach((t)=>{
                                    if (t.medium) {
                                        const r = {
                                            type: "image",
                                            imageId: t.medium.index,
                                            range: t.range,
                                            hyperlinks: t.picture.hyperlinks
                                        };
                                        e.media.push(r);
                                    }
                                });
                            }
                        }
                        const n = e.background && r[e.background.rId];
                        if (n) {
                            const r = n.Target.split("/media/")[1], i = t.mediaIndex && t.mediaIndex[r];
                            void 0 !== i && e.media.push({
                                type: "background",
                                imageId: i
                            });
                        }
                        e.tables = (e.tables || []).map((e)=>{
                            const n = r[e.rId];
                            return t.tables[n.Target];
                        }), delete e.relationships, delete e.hyperlinks, delete e.comments;
                    }
                }
                j.WORKSHEET_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x14ac",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac"
                }, t.exports = j;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/xml-stream": 28,
                "../../rel-type": 31,
                "../base-xform": 32,
                "../list-xform": 71,
                "./auto-filter-xform": 72,
                "./cf/conditional-formattings-xform": 87,
                "./col-xform": 92,
                "./data-validations-xform": 93,
                "./dimension-xform": 94,
                "./drawing-xform": 95,
                "./ext-lst-xform": 96,
                "./header-footer-xform": 97,
                "./hyperlink-xform": 98,
                "./merge-cell-xform": 99,
                "./merges": 100,
                "./page-margins-xform": 103,
                "./page-setup-xform": 105,
                "./picture-xform": 106,
                "./print-options-xform": 107,
                "./row-breaks-xform": 108,
                "./row-xform": 109,
                "./sheet-format-properties-xform": 110,
                "./sheet-properties-xform": 111,
                "./sheet-protection-xform": 112,
                "./sheet-view-xform": 113,
                "./table-part-xform": 114
            }
        ],
        116: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr;
                    }
                    render(e, t) {
                        t && (e.openNode(this.tag), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.model = !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        117: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs, this._format = e.format || function(e) {
                            try {
                                return Number.isNaN(e.getTime()) ? "" : e.toISOString();
                            } catch (e) {
                                return "";
                            }
                        }, this._parse = e.parse || function(e) {
                            return new Date(e);
                        };
                    }
                    render(e, t) {
                        t && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, this._format(t)) : e.writeText(this._format(t)), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.attr ? this.model = this._parse(e.attributes[this.attr]) : this.text = []);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = this._parse(this.text.join(""))), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        118: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs, this.zero = e.zero;
                    }
                    render(e, t) {
                        (t || this.zero) && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, t) : e.writeText(t), e.closeNode());
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.attr ? this.model = parseInt(e.attributes[this.attr], 10) : this.text = [], !0);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = parseInt(this.text.join("") || 0, 10)), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        119: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs;
                    }
                    render(e, t) {
                        void 0 !== t && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, t) : e.writeText(t), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.attr ? this.model = e.attributes[this.attr] : this.text = []);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = this.text.join("")), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        120: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform"), i = e("../../utils/xml-stream");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    render(e) {
                        if (!this._xml) {
                            const e = new i;
                            !function e(t, r) {
                                t.openNode(r.tag, r.$), r.c && r.c.forEach((r)=>{
                                    e(t, r);
                                }), r.t && t.writeText(r.t), t.closeNode();
                            }(e, this._model), this._xml = e.xml;
                        }
                        e.writeXml(this._xml);
                    }
                    parseOpen() {
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this._model.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../../utils/xml-stream": 28,
                "./base-xform": 32
            }
        ],
        121: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("./rich-text-xform"), s = e("../base-xform");
                t.exports = class extends s {
                    constructor(){
                        super(), this.map = {
                            r: new i,
                            t: new n
                        };
                    }
                    get tag() {
                        return "rPh";
                    }
                    render(e, t) {
                        if (e.openNode(this.tag, {
                            sb: t.sb || 0,
                            eb: t.eb || 0
                        }), t && t.hasOwnProperty("richText") && t.richText) {
                            const { r: r } = this.map;
                            t.richText.forEach((t)=>{
                                r.render(e, t);
                            });
                        } else t && this.map.t.render(e, t.text);
                        e.closeNode();
                    }
                    parseOpen(e) {
                        const { name: t } = e;
                        return this.parser ? (this.parser.parseOpen(e), !0) : t === this.tag ? (this.model = {
                            sb: parseInt(e.attributes.sb, 10),
                            eb: parseInt(e.attributes.eb, 10)
                        }, !0) : (this.parser = this.map[t], !!this.parser && (this.parser.parseOpen(e), !0));
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                switch(e){
                                    case "r":
                                        {
                                            let e = this.model.richText;
                                            e || (e = this.model.richText = []), e.push(this.parser.model);
                                            break;
                                        }
                                    case "t":
                                        this.model.text = this.parser.model;
                                }
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./rich-text-xform": 122,
                "./text-xform": 125
            }
        ],
        122: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("../style/font-xform"), s = e("../base-xform");
                class o extends s {
                    constructor(e){
                        super(), this.model = e;
                    }
                    get tag() {
                        return "r";
                    }
                    get textXform() {
                        return this._textXform || (this._textXform = new n);
                    }
                    get fontXform() {
                        return this._fontXform || (this._fontXform = new i(o.FONT_OPTIONS));
                    }
                    render(e, t) {
                        t = t || this.model, e.openNode("r"), t.font && this.fontXform.render(e, t.font), this.textXform.render(e, t.text), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "r":
                                return this.model = {}, !0;
                            case "t":
                                return this.parser = this.textXform, this.parser.parseOpen(e), !0;
                            case "rPr":
                                return this.parser = this.fontXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        switch(e){
                            case "r":
                                return !1;
                            case "t":
                                return this.model.text = this.parser.model, this.parser = void 0, !0;
                            case "rPr":
                                return this.model.font = this.parser.model, this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                }
                o.FONT_OPTIONS = {
                    tagName: "rPr",
                    fontNameTag: "rFont"
                }, t.exports = o;
            },
            {
                "../base-xform": 32,
                "../style/font-xform": 131,
                "./text-xform": 125
            }
        ],
        123: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("./rich-text-xform"), s = e("./phonetic-text-xform"), o = e("../base-xform");
                t.exports = class extends o {
                    constructor(e){
                        super(), this.model = e, this.map = {
                            r: new i,
                            t: new n,
                            rPh: new s
                        };
                    }
                    get tag() {
                        return "si";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t && t.hasOwnProperty("richText") && t.richText ? t.richText.length ? t.richText.forEach((t)=>{
                            this.map.r.render(e, t);
                        }) : this.map.t.render(e, "") : null != t && this.map.t.render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        const { name: t } = e;
                        return this.parser ? (this.parser.parseOpen(e), !0) : t === this.tag ? (this.model = {}, !0) : (this.parser = this.map[t], !!this.parser && (this.parser.parseOpen(e), !0));
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                switch(e){
                                    case "r":
                                        {
                                            let e = this.model.richText;
                                            e || (e = this.model.richText = []), e.push(this.parser.model);
                                            break;
                                        }
                                    case "t":
                                        this.model = this.parser.model;
                                }
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./phonetic-text-xform": 121,
                "./rich-text-xform": 122,
                "./text-xform": 125
            }
        ],
        124: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./shared-string-xform");
                t.exports = class extends i {
                    constructor(e){
                        super(), this.model = e || {
                            values: [],
                            count: 0
                        }, this.hash = Object.create(null), this.rich = Object.create(null);
                    }
                    get sharedStringXform() {
                        return this._sharedStringXform || (this._sharedStringXform = new s);
                    }
                    get values() {
                        return this.model.values;
                    }
                    get uniqueCount() {
                        return this.model.values.length;
                    }
                    get count() {
                        return this.model.count;
                    }
                    getString(e) {
                        return this.model.values[e];
                    }
                    add(e) {
                        return e.richText ? this.addRichText(e) : this.addText(e);
                    }
                    addText(e) {
                        let t = this.hash[e];
                        return void 0 === t && (t = this.hash[e] = this.model.values.length, this.model.values.push(e)), this.model.count++, t;
                    }
                    addRichText(e) {
                        const t = this.sharedStringXform.toXml(e);
                        let r = this.rich[t];
                        return void 0 === r && (r = this.rich[t] = this.model.values.length, this.model.values.push(e)), this.model.count++, r;
                    }
                    render(e, t) {
                        t = t || this._values, e.openXml(n.StdDocAttributes), e.openNode("sst", {
                            xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                            count: t.count,
                            uniqueCount: t.values.length
                        });
                        const r = this.sharedStringXform;
                        t.values.forEach((t)=>{
                            r.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "sst":
                                return !0;
                            case "si":
                                return this.parser = this.sharedStringXform, this.parser.parseOpen(e), !0;
                            default:
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.values.push(this.parser.model), this.model.count++, this.parser = void 0), !0;
                        switch(e){
                            case "sst":
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                };
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./shared-string-xform": 123
            }
        ],
        125: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "t";
                    }
                    render(e, t) {
                        e.openNode("t"), /^\s|\n|\s$/.test(t) && e.addAttribute("xml:space", "preserve"), e.writeText(t), e.closeNode();
                    }
                    get model() {
                        return this._text.join("").replace(/_x([0-9A-F]{4})_/g, (e, t)=>String.fromCharCode(parseInt(t, 16)));
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "t":
                                return this._text = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._text.push(e);
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        126: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../doc/enums"), i = e("../../../utils/utils"), s = e("../base-xform"), o = {
                    horizontalValues: [
                        "left",
                        "center",
                        "right",
                        "fill",
                        "centerContinuous",
                        "distributed",
                        "justify"
                    ].reduce((e, t)=>(e[t] = !0, e), {}),
                    horizontal (e) {
                        return this.horizontalValues[e] ? e : void 0;
                    },
                    verticalValues: [
                        "top",
                        "middle",
                        "bottom",
                        "distributed",
                        "justify"
                    ].reduce((e, t)=>(e[t] = !0, e), {}),
                    vertical (e) {
                        return "middle" === e ? "center" : this.verticalValues[e] ? e : void 0;
                    },
                    wrapText: (e)=>!!e || void 0,
                    shrinkToFit: (e)=>!!e || void 0,
                    textRotation (e) {
                        switch(e){
                            case "vertical":
                                return e;
                            default:
                                return (e = i.validInt(e)) >= -90 && e <= 90 ? e : void 0;
                        }
                    },
                    indent: (e)=>(e = i.validInt(e), Math.max(0, e)),
                    readingOrder (e) {
                        switch(e){
                            case "ltr":
                                return n.ReadingOrder.LeftToRight;
                            case "rtl":
                                return n.ReadingOrder.RightToLeft;
                            default:
                                return;
                        }
                    }
                }, a = {
                    toXml (e) {
                        if (e = o.textRotation(e)) {
                            if ("vertical" === e) return 255;
                            const t = Math.round(e);
                            if (t >= 0 && t <= 90) return t;
                            if (t < 0 && t >= -90) return 90 - t;
                        }
                    },
                    toModel (e) {
                        const t = i.validInt(e);
                        if (void 0 !== t) {
                            if (255 === t) return "vertical";
                            if (t >= 0 && t <= 90) return t;
                            if (t > 90 && t <= 180) return 90 - t;
                        }
                    }
                };
                t.exports = class extends s {
                    get tag() {
                        return "alignment";
                    }
                    render(e, t) {
                        e.addRollback(), e.openNode("alignment");
                        let r = !1;
                        function n(t, n) {
                            n && (e.addAttribute(t, n), r = !0);
                        }
                        n("horizontal", o.horizontal(t.horizontal)), n("vertical", o.vertical(t.vertical)), n("wrapText", !!o.wrapText(t.wrapText) && "1"), n("shrinkToFit", !!o.shrinkToFit(t.shrinkToFit) && "1"), n("indent", o.indent(t.indent)), n("textRotation", a.toXml(t.textRotation)), n("readingOrder", o.readingOrder(t.readingOrder)), e.closeNode(), r ? e.commit() : e.rollback();
                    }
                    parseOpen(e) {
                        const t = {};
                        let r = !1;
                        function n(e, n, i) {
                            e && (t[n] = i, r = !0);
                        }
                        n(e.attributes.horizontal, "horizontal", e.attributes.horizontal), n(e.attributes.vertical, "vertical", "center" === e.attributes.vertical ? "middle" : e.attributes.vertical), n(e.attributes.wrapText, "wrapText", i.parseBoolean(e.attributes.wrapText)), n(e.attributes.shrinkToFit, "shrinkToFit", i.parseBoolean(e.attributes.shrinkToFit)), n(e.attributes.indent, "indent", parseInt(e.attributes.indent, 10)), n(e.attributes.textRotation, "textRotation", a.toModel(e.attributes.textRotation)), n(e.attributes.readingOrder, "readingOrder", "2" === e.attributes.readingOrder ? "rtl" : "ltr"), this.model = r ? t : null;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        127: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/utils"), s = e("./color-xform");
                class o extends n {
                    constructor(e){
                        super(), this.name = e, this.map = {
                            color: new s
                        };
                    }
                    get tag() {
                        return this.name;
                    }
                    render(e, t, r) {
                        const n = t && t.color || r || this.defaultColor;
                        e.openNode(this.name), t && t.style && (e.addAttribute("style", t.style), n && this.map.color.render(e, n)), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.name:
                                {
                                    const { style: t } = e.attributes;
                                    return this.model = t ? {
                                        style: t
                                    } : void 0, !0;
                                }
                            case "color":
                                return this.parser = this.map.color, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : (e === this.name && this.map.color.model && (this.model || (this.model = {}), this.model.color = this.map.color.model), !1);
                    }
                    validStyle(e) {
                        return o.validStyleValues[e];
                    }
                }
                o.validStyleValues = [
                    "thin",
                    "dashed",
                    "dotted",
                    "dashDot",
                    "hair",
                    "dashDotDot",
                    "slantDashDot",
                    "mediumDashed",
                    "mediumDashDotDot",
                    "mediumDashDot",
                    "medium",
                    "double",
                    "thick"
                ].reduce((e, t)=>(e[t] = !0, e), {});
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            top: new o("top"),
                            left: new o("left"),
                            bottom: new o("bottom"),
                            right: new o("right"),
                            diagonal: new o("diagonal")
                        };
                    }
                    render(e, t) {
                        const { color: r } = t;
                        function n(n, i) {
                            n && !n.color && t.color && (n = {
                                ...n,
                                color: t.color
                            }), i.render(e, n, r);
                        }
                        e.openNode("border"), t.diagonal && t.diagonal.style && (t.diagonal.up && e.addAttribute("diagonalUp", "1"), t.diagonal.down && e.addAttribute("diagonalDown", "1")), n(t.left, this.map.left), n(t.right, this.map.right), n(t.top, this.map.top), n(t.bottom, this.map.bottom), n(t.diagonal, this.map.diagonal), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "border":
                                return this.reset(), this.diagonalUp = i.parseBoolean(e.attributes.diagonalUp), this.diagonalDown = i.parseBoolean(e.attributes.diagonalDown), !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        if ("border" === e) {
                            const e = this.model = {}, t = function(t, r, n) {
                                r && (n && Object.assign(r, n), e[t] = r);
                            };
                            t("left", this.map.left.model), t("right", this.map.right.model), t("top", this.map.top.model), t("bottom", this.map.bottom.model), t("diagonal", this.map.diagonal.model, {
                                up: this.diagonalUp,
                                down: this.diagonalDown
                            });
                        }
                        return !1;
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "./color-xform": 128
            }
        ],
        128: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.name = e || "color";
                    }
                    get tag() {
                        return this.name;
                    }
                    render(e, t) {
                        return !!t && (e.openNode(this.name), t.argb ? e.addAttribute("rgb", t.argb) : void 0 !== t.theme ? (e.addAttribute("theme", t.theme), void 0 !== t.tint && e.addAttribute("tint", t.tint)) : void 0 !== t.indexed ? e.addAttribute("indexed", t.indexed) : e.addAttribute("auto", "1"), e.closeNode(), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.name && (e.attributes.rgb ? this.model = {
                            argb: e.attributes.rgb
                        } : e.attributes.theme ? (this.model = {
                            theme: parseInt(e.attributes.theme, 10)
                        }, e.attributes.tint && (this.model.tint = parseFloat(e.attributes.tint))) : e.attributes.indexed ? this.model = {
                            indexed: parseInt(e.attributes.indexed, 10)
                        } : this.model = void 0, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        129: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./alignment-xform"), s = e("./border-xform"), o = e("./fill-xform"), a = e("./font-xform"), l = e("./numfmt-xform"), c = e("./protection-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            alignment: new i,
                            border: new s,
                            fill: new o,
                            font: new a,
                            numFmt: new l,
                            protection: new c
                        };
                    }
                    get tag() {
                        return "dxf";
                    }
                    render(e, t) {
                        if (e.openNode(this.tag), t.font && this.map.font.render(e, t.font), t.numFmt && t.numFmtId) {
                            const r = {
                                id: t.numFmtId,
                                formatCode: t.numFmt
                            };
                            this.map.numFmt.render(e, r);
                        }
                        t.fill && this.map.fill.render(e, t.fill), t.alignment && this.map.alignment.render(e, t.alignment), t.border && this.map.border.render(e, t.border), t.protection && this.map.protection.render(e, t.protection), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.reset(), !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : e !== this.tag || (this.model = {
                            alignment: this.map.alignment.model,
                            border: this.map.border.model,
                            fill: this.map.fill.model,
                            font: this.map.font.model,
                            numFmt: this.map.numFmt.model,
                            protection: this.map.protection.model
                        }, !1);
                    }
                };
            },
            {
                "../base-xform": 32,
                "./alignment-xform": 126,
                "./border-xform": 127,
                "./fill-xform": 130,
                "./font-xform": 131,
                "./numfmt-xform": 132,
                "./protection-xform": 133
            }
        ],
        130: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./color-xform");
                class s extends n {
                    constructor(){
                        super(), this.map = {
                            color: new i
                        };
                    }
                    get tag() {
                        return "stop";
                    }
                    render(e, t) {
                        e.openNode("stop"), e.addAttribute("position", t.position), this.map.color.render(e, t.color), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "stop":
                                return this.model = {
                                    position: parseFloat(e.attributes.position)
                                }, !0;
                            case "color":
                                return this.parser = this.map.color, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model.color = this.parser.model, this.parser = void 0), !0);
                    }
                }
                class o extends n {
                    constructor(){
                        super(), this.map = {
                            fgColor: new i("fgColor"),
                            bgColor: new i("bgColor")
                        };
                    }
                    get name() {
                        return "pattern";
                    }
                    get tag() {
                        return "patternFill";
                    }
                    render(e, t) {
                        e.openNode("patternFill"), e.addAttribute("patternType", t.pattern), t.fgColor && this.map.fgColor.render(e, t.fgColor), t.bgColor && this.map.bgColor.render(e, t.bgColor), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "patternFill":
                                return this.model = {
                                    type: "pattern",
                                    pattern: e.attributes.patternType
                                }, !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.parser.model && (this.model[e] = this.parser.model), this.parser = void 0), !0);
                    }
                }
                class a extends n {
                    constructor(){
                        super(), this.map = {
                            stop: new s
                        };
                    }
                    get name() {
                        return "gradient";
                    }
                    get tag() {
                        return "gradientFill";
                    }
                    render(e, t) {
                        switch(e.openNode("gradientFill"), t.gradient){
                            case "angle":
                                e.addAttribute("degree", t.degree);
                                break;
                            case "path":
                                e.addAttribute("type", "path"), t.center.left && (e.addAttribute("left", t.center.left), void 0 === t.center.right && e.addAttribute("right", t.center.left)), t.center.right && e.addAttribute("right", t.center.right), t.center.top && (e.addAttribute("top", t.center.top), void 0 === t.center.bottom && e.addAttribute("bottom", t.center.top)), t.center.bottom && e.addAttribute("bottom", t.center.bottom);
                        }
                        const r = this.map.stop;
                        t.stops.forEach((t)=>{
                            r.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "gradientFill":
                                {
                                    const t = this.model = {
                                        stops: []
                                    };
                                    return e.attributes.degree ? (t.gradient = "angle", t.degree = parseInt(e.attributes.degree, 10)) : "path" === e.attributes.type && (t.gradient = "path", t.center = {
                                        left: e.attributes.left ? parseFloat(e.attributes.left) : 0,
                                        top: e.attributes.top ? parseFloat(e.attributes.top) : 0
                                    }, e.attributes.right !== e.attributes.left && (t.center.right = e.attributes.right ? parseFloat(e.attributes.right) : 0), e.attributes.bottom !== e.attributes.top && (t.center.bottom = e.attributes.bottom ? parseFloat(e.attributes.bottom) : 0)), !0;
                                }
                            case "stop":
                                return this.parser = this.map.stop, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model.stops.push(this.parser.model), this.parser = void 0), !0);
                    }
                }
                class l extends n {
                    constructor(){
                        super(), this.map = {
                            patternFill: new o,
                            gradientFill: new a
                        };
                    }
                    get tag() {
                        return "fill";
                    }
                    render(e, t) {
                        switch(e.addRollback(), e.openNode("fill"), t.type){
                            case "pattern":
                                this.map.patternFill.render(e, t);
                                break;
                            case "gradient":
                                this.map.gradientFill.render(e, t);
                                break;
                            default:
                                return void e.rollback();
                        }
                        e.closeNode(), e.commit();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "fill":
                                return this.model = {}, !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model = this.parser.model, this.model.type = this.parser.name, this.parser = void 0), !0);
                    }
                    validStyle(e) {
                        return l.validPatternValues[e];
                    }
                }
                l.validPatternValues = [
                    "none",
                    "solid",
                    "darkVertical",
                    "darkGray",
                    "mediumGray",
                    "lightGray",
                    "gray125",
                    "gray0625",
                    "darkHorizontal",
                    "darkVertical",
                    "darkDown",
                    "darkUp",
                    "darkGrid",
                    "darkTrellis",
                    "lightHorizontal",
                    "lightVertical",
                    "lightDown",
                    "lightUp",
                    "lightGrid",
                    "lightTrellis",
                    "lightGrid"
                ].reduce((e, t)=>(e[t] = !0, e), {}), l.StopXform = s, l.PatternFillXform = o, l.GradientFillXform = a, t.exports = l;
            },
            {
                "../base-xform": 32,
                "./color-xform": 128
            }
        ],
        131: [
            function(e, t, r) {
                "use strict";
                const n = e("./color-xform"), i = e("../simple/boolean-xform"), s = e("../simple/integer-xform"), o = e("../simple/string-xform"), a = e("./underline-xform"), l = e("../../../utils/under-dash"), c = e("../base-xform");
                class u extends c {
                    constructor(e){
                        super(), this.options = e || u.OPTIONS, this.map = {
                            b: {
                                prop: "bold",
                                xform: new i({
                                    tag: "b",
                                    attr: "val"
                                })
                            },
                            i: {
                                prop: "italic",
                                xform: new i({
                                    tag: "i",
                                    attr: "val"
                                })
                            },
                            u: {
                                prop: "underline",
                                xform: new a
                            },
                            charset: {
                                prop: "charset",
                                xform: new s({
                                    tag: "charset",
                                    attr: "val"
                                })
                            },
                            color: {
                                prop: "color",
                                xform: new n
                            },
                            condense: {
                                prop: "condense",
                                xform: new i({
                                    tag: "condense",
                                    attr: "val"
                                })
                            },
                            extend: {
                                prop: "extend",
                                xform: new i({
                                    tag: "extend",
                                    attr: "val"
                                })
                            },
                            family: {
                                prop: "family",
                                xform: new s({
                                    tag: "family",
                                    attr: "val"
                                })
                            },
                            outline: {
                                prop: "outline",
                                xform: new i({
                                    tag: "outline",
                                    attr: "val"
                                })
                            },
                            vertAlign: {
                                prop: "vertAlign",
                                xform: new o({
                                    tag: "vertAlign",
                                    attr: "val"
                                })
                            },
                            scheme: {
                                prop: "scheme",
                                xform: new o({
                                    tag: "scheme",
                                    attr: "val"
                                })
                            },
                            shadow: {
                                prop: "shadow",
                                xform: new i({
                                    tag: "shadow",
                                    attr: "val"
                                })
                            },
                            strike: {
                                prop: "strike",
                                xform: new i({
                                    tag: "strike",
                                    attr: "val"
                                })
                            },
                            sz: {
                                prop: "size",
                                xform: new s({
                                    tag: "sz",
                                    attr: "val"
                                })
                            }
                        }, this.map[this.options.fontNameTag] = {
                            prop: "name",
                            xform: new o({
                                tag: this.options.fontNameTag,
                                attr: "val"
                            })
                        };
                    }
                    get tag() {
                        return this.options.tagName;
                    }
                    render(e, t) {
                        const { map: r } = this;
                        e.openNode(this.options.tagName), l.each(this.map, (n, i)=>{
                            r[i].xform.render(e, t[n.prop]);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        if (this.map[e.name]) return this.parser = this.map[e.name].xform, this.parser.parseOpen(e);
                        switch(e.name){
                            case this.options.tagName:
                                return this.model = {}, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser && !this.parser.parseClose(e)) {
                            const t = this.map[e];
                            return this.parser.model && (this.model[t.prop] = this.parser.model), this.parser = void 0, !0;
                        }
                        switch(e){
                            case this.options.tagName:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                }
                u.OPTIONS = {
                    tagName: "font",
                    fontNameTag: "name"
                }, t.exports = u;
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32,
                "../simple/boolean-xform": 116,
                "../simple/integer-xform": 118,
                "../simple/string-xform": 119,
                "./color-xform": 128,
                "./underline-xform": 136
            }
        ],
        132: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../defaultnumformats"), s = e("../base-xform");
                const o = function() {
                    const e = {};
                    return n.each(i, (t, r)=>{
                        t.f && (e[t.f] = parseInt(r, 10));
                    }), e;
                }();
                class a extends s {
                    constructor(e, t){
                        super(), this.id = e, this.formatCode = t;
                    }
                    get tag() {
                        return "numFmt";
                    }
                    render(e, t) {
                        e.leafNode("numFmt", {
                            numFmtId: t.id,
                            formatCode: t.formatCode
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "numFmt":
                                return this.model = {
                                    id: parseInt(e.attributes.numFmtId, 10),
                                    formatCode: e.attributes.formatCode.replace(/[\\](.)/g, "$1")
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                a.getDefaultFmtId = function(e) {
                    return o[e];
                }, a.getDefaultFmtCode = function(e) {
                    return i[e] && i[e].f;
                }, t.exports = a;
            },
            {
                "../../../utils/under-dash": 26,
                "../../defaultnumformats": 30,
                "../base-xform": 32
            }
        ],
        133: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = {
                    boolean: (e, t)=>void 0 === e ? t : e
                };
                t.exports = class extends n {
                    get tag() {
                        return "protection";
                    }
                    render(e, t) {
                        e.addRollback(), e.openNode("protection");
                        let r = !1;
                        function n(t, n) {
                            void 0 !== n && (e.addAttribute(t, n), r = !0);
                        }
                        n("locked", i.boolean(t.locked, !0) ? void 0 : "0"), n("hidden", i.boolean(t.hidden, !1) ? "1" : void 0), e.closeNode(), r ? e.commit() : e.rollback();
                    }
                    parseOpen(e) {
                        const t = {
                            locked: !("0" === e.attributes.locked),
                            hidden: "1" === e.attributes.hidden
                        }, r = !t.locked || t.hidden;
                        this.model = r ? t : null;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        134: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./alignment-xform"), s = e("./protection-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.xfId = !(!e || !e.xfId), this.map = {
                            alignment: new i,
                            protection: new s
                        };
                    }
                    get tag() {
                        return "xf";
                    }
                    render(e, t) {
                        e.openNode("xf", {
                            numFmtId: t.numFmtId || 0,
                            fontId: t.fontId || 0,
                            fillId: t.fillId || 0,
                            borderId: t.borderId || 0
                        }), this.xfId && e.addAttribute("xfId", t.xfId || 0), t.numFmtId && e.addAttribute("applyNumberFormat", "1"), t.fontId && e.addAttribute("applyFont", "1"), t.fillId && e.addAttribute("applyFill", "1"), t.borderId && e.addAttribute("applyBorder", "1"), t.alignment && e.addAttribute("applyAlignment", "1"), t.protection && e.addAttribute("applyProtection", "1"), t.alignment && this.map.alignment.render(e, t.alignment), t.protection && this.map.protection.render(e, t.protection), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "xf":
                                return this.model = {
                                    numFmtId: parseInt(e.attributes.numFmtId, 10),
                                    fontId: parseInt(e.attributes.fontId, 10),
                                    fillId: parseInt(e.attributes.fillId, 10),
                                    borderId: parseInt(e.attributes.borderId, 10)
                                }, this.xfId && (this.model.xfId = parseInt(e.attributes.xfId, 10)), !0;
                            case "alignment":
                                return this.parser = this.map.alignment, this.parser.parseOpen(e), !0;
                            case "protection":
                                return this.parser = this.map.protection, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.map.protection === this.parser ? this.model.protection = this.parser.model : this.model.alignment = this.parser.model, this.parser = void 0), !0) : "xf" !== e;
                    }
                };
            },
            {
                "../base-xform": 32,
                "./alignment-xform": 126,
                "./protection-xform": 133
            }
        ],
        135: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../doc/enums"), i = e("../../../utils/xml-stream"), s = e("../base-xform"), o = e("../static-xform"), a = e("../list-xform"), l = e("./font-xform"), c = e("./fill-xform"), u = e("./border-xform"), h = e("./numfmt-xform"), f = e("./style-xform"), d = e("./dxf-xform");
                class p extends s {
                    constructor(e){
                        super(), this.map = {
                            numFmts: new a({
                                tag: "numFmts",
                                count: !0,
                                childXform: new h
                            }),
                            fonts: new a({
                                tag: "fonts",
                                count: !0,
                                childXform: new l,
                                $: {
                                    "x14ac:knownFonts": 1
                                }
                            }),
                            fills: new a({
                                tag: "fills",
                                count: !0,
                                childXform: new c
                            }),
                            borders: new a({
                                tag: "borders",
                                count: !0,
                                childXform: new u
                            }),
                            cellStyleXfs: new a({
                                tag: "cellStyleXfs",
                                count: !0,
                                childXform: new f
                            }),
                            cellXfs: new a({
                                tag: "cellXfs",
                                count: !0,
                                childXform: new f({
                                    xfId: !0
                                })
                            }),
                            dxfs: new a({
                                tag: "dxfs",
                                always: !0,
                                count: !0,
                                childXform: new d
                            }),
                            numFmt: new h,
                            font: new l,
                            fill: new c,
                            border: new u,
                            style: new f({
                                xfId: !0
                            }),
                            cellStyles: p.STATIC_XFORMS.cellStyles,
                            tableStyles: p.STATIC_XFORMS.tableStyles,
                            extLst: p.STATIC_XFORMS.extLst
                        }, e && this.init();
                    }
                    initIndex() {
                        this.index = {
                            style: {},
                            numFmt: {},
                            numFmtNextId: 164,
                            font: {},
                            border: {},
                            fill: {}
                        };
                    }
                    init() {
                        this.model = {
                            styles: [],
                            numFmts: [],
                            fonts: [],
                            borders: [],
                            fills: [],
                            dxfs: []
                        }, this.initIndex(), this._addBorder({}), this._addStyle({
                            numFmtId: 0,
                            fontId: 0,
                            fillId: 0,
                            borderId: 0,
                            xfId: 0
                        }), this._addFill({
                            type: "pattern",
                            pattern: "none"
                        }), this._addFill({
                            type: "pattern",
                            pattern: "gray125"
                        }), this.weakMap = new WeakMap;
                    }
                    render(e, t) {
                        t = t || this.model, e.openXml(i.StdDocAttributes), e.openNode("styleSheet", p.STYLESHEET_ATTRIBUTES), this.index ? (t.numFmts && t.numFmts.length && (e.openNode("numFmts", {
                            count: t.numFmts.length
                        }), t.numFmts.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode()), t.fonts.length || this._addFont({
                            size: 11,
                            color: {
                                theme: 1
                            },
                            name: "Calibri",
                            family: 2,
                            scheme: "minor"
                        }), e.openNode("fonts", {
                            count: t.fonts.length,
                            "x14ac:knownFonts": 1
                        }), t.fonts.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), e.openNode("fills", {
                            count: t.fills.length
                        }), t.fills.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), e.openNode("borders", {
                            count: t.borders.length
                        }), t.borders.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), this.map.cellStyleXfs.render(e, [
                            {
                                numFmtId: 0,
                                fontId: 0,
                                fillId: 0,
                                borderId: 0,
                                xfId: 0
                            }
                        ]), e.openNode("cellXfs", {
                            count: t.styles.length
                        }), t.styles.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode()) : (this.map.numFmts.render(e, t.numFmts), this.map.fonts.render(e, t.fonts), this.map.fills.render(e, t.fills), this.map.borders.render(e, t.borders), this.map.cellStyleXfs.render(e, [
                            {
                                numFmtId: 0,
                                fontId: 0,
                                fillId: 0,
                                borderId: 0,
                                xfId: 0
                            }
                        ]), this.map.cellXfs.render(e, t.styles)), p.STATIC_XFORMS.cellStyles.render(e), this.map.dxfs.render(e, t.dxfs), p.STATIC_XFORMS.tableStyles.render(e), p.STATIC_XFORMS.extLst.render(e), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "styleSheet":
                                return this.initIndex(), !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "styleSheet":
                                {
                                    this.model = {};
                                    const e = (e, t)=>{
                                        t.model && t.model.length && (this.model[e] = t.model);
                                    };
                                    if (e("numFmts", this.map.numFmts), e("fonts", this.map.fonts), e("fills", this.map.fills), e("borders", this.map.borders), e("styles", this.map.cellXfs), e("dxfs", this.map.dxfs), this.index = {
                                        model: [],
                                        numFmt: []
                                    }, this.model.numFmts) {
                                        const e = this.index.numFmt;
                                        this.model.numFmts.forEach((t)=>{
                                            e[t.id] = t.formatCode;
                                        });
                                    }
                                    return !1;
                                }
                            default:
                                return !0;
                        }
                    }
                    addStyleModel(e, t) {
                        if (!e) return 0;
                        if (this.model.fonts.length || this._addFont({
                            size: 11,
                            color: {
                                theme: 1
                            },
                            name: "Calibri",
                            family: 2,
                            scheme: "minor"
                        }), this.weakMap && this.weakMap.has(e)) return this.weakMap.get(e);
                        const r = {};
                        if (t = t || n.ValueType.Number, e.numFmt) r.numFmtId = this._addNumFmtStr(e.numFmt);
                        else switch(t){
                            case n.ValueType.Number:
                                r.numFmtId = this._addNumFmtStr("General");
                                break;
                            case n.ValueType.Date:
                                r.numFmtId = this._addNumFmtStr("mm-dd-yy");
                        }
                        e.font && (r.fontId = this._addFont(e.font)), e.border && (r.borderId = this._addBorder(e.border)), e.fill && (r.fillId = this._addFill(e.fill)), e.alignment && (r.alignment = e.alignment), e.protection && (r.protection = e.protection);
                        const i = this._addStyle(r);
                        return this.weakMap && this.weakMap.set(e, i), i;
                    }
                    getStyleModel(e) {
                        const t = this.model.styles[e];
                        if (!t) return null;
                        let r = this.index.model[e];
                        if (r) return r;
                        if (r = this.index.model[e] = {}, t.numFmtId) {
                            const e = this.index.numFmt[t.numFmtId] || h.getDefaultFmtCode(t.numFmtId);
                            e && (r.numFmt = e);
                        }
                        function n(e, t, n) {
                            if (n || 0 === n) {
                                const i = t[n];
                                i && (r[e] = i);
                            }
                        }
                        return n("font", this.model.fonts, t.fontId), n("border", this.model.borders, t.borderId), n("fill", this.model.fills, t.fillId), t.alignment && (r.alignment = t.alignment), t.protection && (r.protection = t.protection), r;
                    }
                    addDxfStyle(e) {
                        return e.numFmt && (e.numFmtId = this._addNumFmtStr(e.numFmt)), this.model.dxfs.push(e), this.model.dxfs.length - 1;
                    }
                    getDxfStyle(e) {
                        return this.model.dxfs[e];
                    }
                    _addStyle(e) {
                        const t = this.map.style.toXml(e);
                        let r = this.index.style[t];
                        return void 0 === r && (r = this.index.style[t] = this.model.styles.length, this.model.styles.push(t)), r;
                    }
                    _addNumFmtStr(e) {
                        let t = h.getDefaultFmtId(e);
                        if (void 0 !== t) return t;
                        if (t = this.index.numFmt[e], void 0 !== t) return t;
                        t = this.index.numFmt[e] = 164 + this.model.numFmts.length;
                        const r = this.map.numFmt.toXml({
                            id: t,
                            formatCode: e
                        });
                        return this.model.numFmts.push(r), t;
                    }
                    _addFont(e) {
                        const t = this.map.font.toXml(e);
                        let r = this.index.font[t];
                        return void 0 === r && (r = this.index.font[t] = this.model.fonts.length, this.model.fonts.push(t)), r;
                    }
                    _addBorder(e) {
                        const t = this.map.border.toXml(e);
                        let r = this.index.border[t];
                        return void 0 === r && (r = this.index.border[t] = this.model.borders.length, this.model.borders.push(t)), r;
                    }
                    _addFill(e) {
                        const t = this.map.fill.toXml(e);
                        let r = this.index.fill[t];
                        return void 0 === r && (r = this.index.fill[t] = this.model.fills.length, this.model.fills.push(t)), r;
                    }
                }
                p.STYLESHEET_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x14ac x16r2",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac",
                    "xmlns:x16r2": "http://schemas.microsoft.com/office/spreadsheetml/2015/02/main"
                }, p.STATIC_XFORMS = {
                    cellStyles: new o({
                        tag: "cellStyles",
                        $: {
                            count: 1
                        },
                        c: [
                            {
                                tag: "cellStyle",
                                $: {
                                    name: "Normal",
                                    xfId: 0,
                                    builtinId: 0
                                }
                            }
                        ]
                    }),
                    dxfs: new o({
                        tag: "dxfs",
                        $: {
                            count: 0
                        }
                    }),
                    tableStyles: new o({
                        tag: "tableStyles",
                        $: {
                            count: 0,
                            defaultTableStyle: "TableStyleMedium2",
                            defaultPivotStyle: "PivotStyleLight16"
                        }
                    }),
                    extLst: new o({
                        tag: "extLst",
                        c: [
                            {
                                tag: "ext",
                                $: {
                                    uri: "{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}",
                                    "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                                },
                                c: [
                                    {
                                        tag: "x14:slicerStyles",
                                        $: {
                                            defaultSlicerStyle: "SlicerStyleLight1"
                                        }
                                    }
                                ]
                            },
                            {
                                tag: "ext",
                                $: {
                                    uri: "{9260A510-F301-46a8-8635-F512D64BE5F5}",
                                    "xmlns:x15": "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"
                                },
                                c: [
                                    {
                                        tag: "x15:timelineStyles",
                                        $: {
                                            defaultTimelineStyle: "TimeSlicerStyleLight1"
                                        }
                                    }
                                ]
                            }
                        ]
                    })
                };
                p.Mock = class extends p {
                    constructor(){
                        super(), this.model = {
                            styles: [
                                {
                                    numFmtId: 0,
                                    fontId: 0,
                                    fillId: 0,
                                    borderId: 0,
                                    xfId: 0
                                }
                            ],
                            numFmts: [],
                            fonts: [
                                {
                                    size: 11,
                                    color: {
                                        theme: 1
                                    },
                                    name: "Calibri",
                                    family: 2,
                                    scheme: "minor"
                                }
                            ],
                            borders: [
                                {}
                            ],
                            fills: [
                                {
                                    type: "pattern",
                                    pattern: "none"
                                },
                                {
                                    type: "pattern",
                                    pattern: "gray125"
                                }
                            ]
                        };
                    }
                    parseStream(e) {
                        return e.autodrain(), Promise.resolve();
                    }
                    addStyleModel(e, t) {
                        switch(t){
                            case n.ValueType.Date:
                                return this.dateStyleId;
                            default:
                                return 0;
                        }
                    }
                    get dateStyleId() {
                        if (!this._dateStyleId) {
                            const e = {
                                numFmtId: h.getDefaultFmtId("mm-dd-yy")
                            };
                            this._dateStyleId = this.model.styles.length, this.model.styles.push(e);
                        }
                        return this._dateStyleId;
                    }
                    getStyleModel() {
                        return {};
                    }
                }, t.exports = p;
            },
            {
                "../../../doc/enums": 7,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "../static-xform": 120,
                "./border-xform": 127,
                "./dxf-xform": 129,
                "./fill-xform": 130,
                "./font-xform": 131,
                "./numfmt-xform": 132,
                "./style-xform": 134
            }
        ],
        136: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                class i extends n {
                    constructor(e){
                        super(), this.model = e;
                    }
                    get tag() {
                        return "u";
                    }
                    render(e, t) {
                        if (!0 === (t = t || this.model)) e.leafNode("u");
                        else {
                            const r = i.Attributes[t];
                            r && e.leafNode("u", r);
                        }
                    }
                    parseOpen(e) {
                        "u" === e.name && (this.model = e.attributes.val || !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                i.Attributes = {
                    single: {},
                    double: {
                        val: "double"
                    },
                    singleAccounting: {
                        val: "singleAccounting"
                    },
                    doubleAccounting: {
                        val: "doubleAccounting"
                    }
                }, t.exports = i;
            },
            {
                "../base-xform": 32
            }
        ],
        137: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./filter-column-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            filterColumn: new i
                        };
                    }
                    get tag() {
                        return "autoFilter";
                    }
                    prepare(e) {
                        e.columns.forEach((e, t)=>{
                            this.map.filterColumn.prepare(e, {
                                index: t
                            });
                        });
                    }
                    render(e, t) {
                        return e.openNode(this.tag, {
                            ref: t.autoFilterRef
                        }), t.columns.forEach((t)=>{
                            this.map.filterColumn.render(e, t);
                        }), e.closeNode(), !0;
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    autoFilterRef: e.attributes.ref,
                                    columns: []
                                }, !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.columns.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./filter-column-xform": 139
            }
        ],
        138: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "customFilter";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            val: t.val,
                            operator: t.operator
                        });
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            val: e.attributes.val,
                            operator: e.attributes.operator
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        139: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../list-xform"), s = e("./custom-filter-xform"), o = e("./filter-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            customFilters: new i({
                                tag: "customFilters",
                                count: !1,
                                empty: !0,
                                childXform: new s
                            }),
                            filters: new i({
                                tag: "filters",
                                count: !1,
                                empty: !0,
                                childXform: new o
                            })
                        };
                    }
                    get tag() {
                        return "filterColumn";
                    }
                    prepare(e, t) {
                        e.colId = t.index.toString();
                    }
                    render(e, t) {
                        return t.customFilters ? (e.openNode(this.tag, {
                            colId: t.colId,
                            hiddenButton: t.filterButton ? "0" : "1"
                        }), this.map.customFilters.render(e, t.customFilters), e.closeNode(), !0) : (e.leafNode(this.tag, {
                            colId: t.colId,
                            hiddenButton: t.filterButton ? "0" : "1"
                        }), !0);
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        const { attributes: t } = e;
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    filterButton: "0" === t.hiddenButton
                                }, !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.customFilters = this.map.customFilters.model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../list-xform": 71,
                "./custom-filter-xform": 138,
                "./filter-xform": 140
            }
        ],
        140: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "filter";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            val: t.val
                        });
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            val: e.attributes.val
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        141: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tableColumn";
                    }
                    prepare(e, t) {
                        e.id = t.index + 1;
                    }
                    render(e, t) {
                        return e.leafNode(this.tag, {
                            id: t.id.toString(),
                            name: t.name,
                            totalsRowLabel: t.totalsRowLabel,
                            totalsRowFunction: t.totalsRowFunction,
                            dxfId: t.dxfId
                        }), !0;
                    }
                    parseOpen(e) {
                        if (e.name === this.tag) {
                            const { attributes: t } = e;
                            return this.model = {
                                name: t.name,
                                totalsRowLabel: t.totalsRowLabel,
                                totalsRowFunction: t.totalsRowFunction,
                                dxfId: t.dxfId
                            }, !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        142: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tableStyleInfo";
                    }
                    render(e, t) {
                        return e.leafNode(this.tag, {
                            name: t.theme ? t.theme : void 0,
                            showFirstColumn: t.showFirstColumn ? "1" : "0",
                            showLastColumn: t.showLastColumn ? "1" : "0",
                            showRowStripes: t.showRowStripes ? "1" : "0",
                            showColumnStripes: t.showColumnStripes ? "1" : "0"
                        }), !0;
                    }
                    parseOpen(e) {
                        if (e.name === this.tag) {
                            const { attributes: t } = e;
                            return this.model = {
                                theme: t.name ? t.name : null,
                                showFirstColumn: "1" === t.showFirstColumn,
                                showLastColumn: "1" === t.showLastColumn,
                                showRowStripes: "1" === t.showRowStripes,
                                showColumnStripes: "1" === t.showColumnStripes
                            }, !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        143: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../list-xform"), o = e("./auto-filter-xform"), a = e("./table-column-xform"), l = e("./table-style-info-xform");
                class c extends i {
                    constructor(){
                        super(), this.map = {
                            autoFilter: new o,
                            tableColumns: new s({
                                tag: "tableColumns",
                                count: !0,
                                empty: !0,
                                childXform: new a
                            }),
                            tableStyleInfo: new l
                        };
                    }
                    prepare(e, t) {
                        this.map.autoFilter.prepare(e), this.map.tableColumns.prepare(e.columns, t);
                    }
                    get tag() {
                        return "table";
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode(this.tag, {
                            ...c.TABLE_ATTRIBUTES,
                            id: t.id,
                            name: t.name,
                            displayName: t.displayName || t.name,
                            ref: t.tableRef,
                            totalsRowCount: t.totalsRow ? "1" : void 0,
                            totalsRowShown: t.totalsRow ? void 0 : "1",
                            headerRowCount: t.headerRow ? "1" : "0"
                        }), this.map.autoFilter.render(e, t), this.map.tableColumns.render(e, t.columns), this.map.tableStyleInfo.render(e, t.style), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        const { name: t, attributes: r } = e;
                        switch(t){
                            case this.tag:
                                this.reset(), this.model = {
                                    name: r.name,
                                    displayName: r.displayName || r.name,
                                    tableRef: r.ref,
                                    totalsRow: "1" === r.totalsRowCount,
                                    headerRow: "1" === r.headerRowCount
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.columns = this.map.tableColumns.model, this.map.autoFilter.model && (this.model.autoFilterRef = this.map.autoFilter.model.autoFilterRef, this.map.autoFilter.model.columns.forEach((e, t)=>{
                                    this.model.columns[t].filterButton = e.filterButton;
                                })), this.model.style = this.map.tableStyleInfo.model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.columns.forEach((e)=>{
                            void 0 !== e.dxfId && (e.style = t.styles.getDxfStyle(e.dxfId));
                        });
                    }
                }
                c.TABLE_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "xr xr3",
                    "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision",
                    "xmlns:xr3": "http://schemas.microsoft.com/office/spreadsheetml/2016/revision3"
                }, t.exports = c;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "./auto-filter-xform": 137,
                "./table-column-xform": 141,
                "./table-style-info-xform": 142
            }
        ],
        144: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("fs"), s = e("jszip"), { PassThrough: o } = e("readable-stream"), a = e("../utils/zip-stream"), l = e("../utils/stream-buf"), c = e("../utils/utils"), u = e("../utils/xml-stream"), { bufferToString: h } = e("../utils/browser-buffer-decode"), f = e("./xform/style/styles-xform"), d = e("./xform/core/core-xform"), p = e("./xform/strings/shared-strings-xform"), m = e("./xform/core/relationships-xform"), b = e("./xform/core/content-types-xform"), g = e("./xform/core/app-xform"), y = e("./xform/book/workbook-xform"), v = e("./xform/sheet/worksheet-xform"), w = e("./xform/drawing/drawing-xform"), _ = e("./xform/table/table-xform"), x = e("./xform/comment/comments-xform"), k = e("./xform/comment/vml-notes-xform"), S = e("./xml/theme1");
                        class M {
                            constructor(e){
                                this.workbook = e;
                            }
                            async readFile(e, t) {
                                if (!await c.fs.exists(e)) throw new Error("File not found: " + e);
                                const r = i.createReadStream(e);
                                try {
                                    const e = await this.read(r, t);
                                    return r.close(), e;
                                } catch (e) {
                                    throw r.close(), e;
                                }
                            }
                            parseRels(e) {
                                return (new m).parseStream(e);
                            }
                            parseWorkbook(e) {
                                return (new y).parseStream(e);
                            }
                            parseSharedStrings(e) {
                                return (new p).parseStream(e);
                            }
                            reconcile(e, t) {
                                const r = new y, n = new v(t), i = new w, s = new _;
                                r.reconcile(e);
                                const o = {
                                    media: e.media,
                                    mediaIndex: e.mediaIndex
                                };
                                Object.keys(e.drawings).forEach((t)=>{
                                    const r = e.drawings[t], n = e.drawingRels[t];
                                    n && (o.rels = n.reduce((e, t)=>(e[t.Id] = t, e), {}), (r.anchors || []).forEach((e)=>{
                                        const t = e.picture && e.picture.hyperlinks;
                                        t && o.rels[t.rId] && (t.hyperlink = o.rels[t.rId].Target, delete t.rId);
                                    }), i.reconcile(r, o));
                                });
                                const a = {
                                    styles: e.styles
                                };
                                Object.values(e.tables).forEach((e)=>{
                                    s.reconcile(e, a);
                                });
                                const l = {
                                    styles: e.styles,
                                    sharedStrings: e.sharedStrings,
                                    media: e.media,
                                    mediaIndex: e.mediaIndex,
                                    date1904: e.properties && e.properties.date1904,
                                    drawings: e.drawings,
                                    comments: e.comments,
                                    tables: e.tables,
                                    vmlDrawings: e.vmlDrawings
                                };
                                e.worksheets.forEach((t)=>{
                                    t.relationships = e.worksheetRels[t.sheetNo], n.reconcile(t, l);
                                }), delete e.worksheetHash, delete e.worksheetRels, delete e.globalRels, delete e.sharedStrings, delete e.workbookRels, delete e.sheetDefs, delete e.styles, delete e.mediaIndex, delete e.drawings, delete e.drawingRels, delete e.vmlDrawings;
                            }
                            async _processWorksheetEntry(e, t, r, n, i) {
                                const s = new v(n), o = await s.parseStream(e);
                                o.sheetNo = r, t.worksheetHash[i] = o, t.worksheets.push(o);
                            }
                            async _processCommentEntry(e, t, r) {
                                const n = new x, i = await n.parseStream(e);
                                t.comments[`../${r}.xml`] = i;
                            }
                            async _processTableEntry(e, t, r) {
                                const n = new _, i = await n.parseStream(e);
                                t.tables[`../tables/${r}.xml`] = i;
                            }
                            async _processWorksheetRelsEntry(e, t, r) {
                                const n = new m, i = await n.parseStream(e);
                                t.worksheetRels[r] = i;
                            }
                            async _processMediaEntry(e, t, r) {
                                const n = r.lastIndexOf(".");
                                if (n >= 1) {
                                    const i = r.substr(n + 1), s = r.substr(0, n);
                                    await new Promise((n, o)=>{
                                        const a = new l;
                                        a.on("finish", ()=>{
                                            t.mediaIndex[r] = t.media.length, t.mediaIndex[s] = t.media.length;
                                            const e = {
                                                type: "image",
                                                name: s,
                                                extension: i,
                                                buffer: a.toBuffer()
                                            };
                                            t.media.push(e), n();
                                        }), e.on("error", (e)=>{
                                            o(e);
                                        }), e.pipe(a);
                                    });
                                }
                            }
                            async _processDrawingEntry(e, t, r) {
                                const n = new w, i = await n.parseStream(e);
                                t.drawings[r] = i;
                            }
                            async _processDrawingRelsEntry(e, t, r) {
                                const n = new m, i = await n.parseStream(e);
                                t.drawingRels[r] = i;
                            }
                            async _processVmlDrawingEntry(e, t, r) {
                                const n = new k, i = await n.parseStream(e);
                                t.vmlDrawings[`../drawings/${r}.vml`] = i;
                            }
                            async _processThemeEntry(e, t, r) {
                                await new Promise((n, i)=>{
                                    const s = new l;
                                    e.on("error", i), s.on("error", i), s.on("finish", ()=>{
                                        t.themes[r] = s.read().toString(), n();
                                    }), e.pipe(s);
                                });
                            }
                            createInputStream() {
                                throw new Error("`XLSX#createInputStream` is deprecated. You should use `XLSX#read` instead. This method will be removed in version 5.0. Please follow upgrade instruction: https://github.com/exceljs/exceljs/blob/master/UPGRADE-4.0.md");
                            }
                            async read(e, t) {
                                !e[Symbol.asyncIterator] && e.pipe && (e = e.pipe(new o));
                                const r = [];
                                for await (const t of e)r.push(t);
                                return this.load(n.concat(r), t);
                            }
                            async load(e, t) {
                                let i;
                                i = t && t.base64 ? n.from(e.toString(), "base64") : e;
                                const a = {
                                    worksheets: [],
                                    worksheetHash: {},
                                    worksheetRels: [],
                                    themes: {},
                                    media: [],
                                    mediaIndex: {},
                                    drawings: {},
                                    drawingRels: {},
                                    comments: {},
                                    tables: {},
                                    vmlDrawings: {}
                                }, l = await s.loadAsync(i);
                                for (const e of Object.values(l.files))if (!e.dir) {
                                    let n, i = e.name;
                                    if ("/" === i[0] && (i = i.substr(1)), i.match(/xl\/media\//) || i.match(/xl\/theme\/([a-zA-Z0-9]+)[.]xml/)) n = new o, n.write(await e.async("nodebuffer"));
                                    else {
                                        let t;
                                        n = new o({
                                            writableObjectMode: !0,
                                            readableObjectMode: !0
                                        }), t = r.browser ? h(await e.async("nodebuffer")) : await e.async("string");
                                        const i = 16384;
                                        for(let e = 0; e < t.length; e += i)n.write(t.substring(e, e + i));
                                    }
                                    switch(n.end(), i){
                                        case "_rels/.rels":
                                            a.globalRels = await this.parseRels(n);
                                            break;
                                        case "xl/workbook.xml":
                                            {
                                                const e = await this.parseWorkbook(n);
                                                a.sheets = e.sheets, a.definedNames = e.definedNames, a.views = e.views, a.properties = e.properties, a.calcProperties = e.calcProperties;
                                                break;
                                            }
                                        case "xl/_rels/workbook.xml.rels":
                                            a.workbookRels = await this.parseRels(n);
                                            break;
                                        case "xl/sharedStrings.xml":
                                            a.sharedStrings = new p, await a.sharedStrings.parseStream(n);
                                            break;
                                        case "xl/styles.xml":
                                            a.styles = new f, await a.styles.parseStream(n);
                                            break;
                                        case "docProps/app.xml":
                                            {
                                                const e = new g, t = await e.parseStream(n);
                                                a.company = t.company, a.manager = t.manager;
                                                break;
                                            }
                                        case "docProps/core.xml":
                                            {
                                                const e = new d, t = await e.parseStream(n);
                                                Object.assign(a, t);
                                                break;
                                            }
                                        default:
                                            {
                                                let e = i.match(/xl\/worksheets\/sheet(\d+)[.]xml/);
                                                if (e) {
                                                    await this._processWorksheetEntry(n, a, e[1], t, i);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/worksheets\/_rels\/sheet(\d+)[.]xml.rels/), e) {
                                                    await this._processWorksheetRelsEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/theme\/([a-zA-Z0-9]+)[.]xml/), e) {
                                                    await this._processThemeEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/media\/([a-zA-Z0-9]+[.][a-zA-Z0-9]{3,4})$/), e) {
                                                    await this._processMediaEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/([a-zA-Z0-9]+)[.]xml/), e) {
                                                    await this._processDrawingEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/(comments\d+)[.]xml/), e) {
                                                    await this._processCommentEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/tables\/(table\d+)[.]xml/), e) {
                                                    await this._processTableEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/_rels\/([a-zA-Z0-9]+)[.]xml[.]rels/), e) {
                                                    await this._processDrawingRelsEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/(vmlDrawing\d+)[.]vml/), e) {
                                                    await this._processVmlDrawingEntry(n, a, e[1]);
                                                    break;
                                                }
                                            }
                                    }
                                }
                                return this.reconcile(a, t), this.workbook.model = a, this.workbook;
                            }
                            async addMedia(e, t) {
                                await Promise.all(t.media.map(async (t)=>{
                                    if ("image" === t.type) {
                                        const r = `xl/media/${t.name}.${t.extension}`;
                                        if (t.filename) {
                                            const n = await function(e, t) {
                                                return new Promise((r, n)=>{
                                                    i.readFile(e, t, (e, t)=>{
                                                        e ? n(e) : r(t);
                                                    });
                                                });
                                            }(t.filename);
                                            return e.append(n, {
                                                name: r
                                            });
                                        }
                                        if (t.buffer) return e.append(t.buffer, {
                                            name: r
                                        });
                                        if (t.base64) {
                                            const n = t.base64, i = n.substring(n.indexOf(",") + 1);
                                            return e.append(i, {
                                                name: r,
                                                base64: !0
                                            });
                                        }
                                    }
                                    throw new Error("Unsupported media");
                                }));
                            }
                            addDrawings(e, t) {
                                const r = new w, n = new m;
                                t.worksheets.forEach((t)=>{
                                    const { drawing: i } = t;
                                    if (i) {
                                        r.prepare(i, {});
                                        let t = r.toXml(i);
                                        e.append(t, {
                                            name: `xl/drawings/${i.name}.xml`
                                        }), t = n.toXml(i.rels), e.append(t, {
                                            name: `xl/drawings/_rels/${i.name}.xml.rels`
                                        });
                                    }
                                });
                            }
                            addTables(e, t) {
                                const r = new _;
                                t.worksheets.forEach((t)=>{
                                    const { tables: n } = t;
                                    n.forEach((t)=>{
                                        r.prepare(t, {});
                                        const n = r.toXml(t);
                                        e.append(n, {
                                            name: "xl/tables/" + t.target
                                        });
                                    });
                                });
                            }
                            async addContentTypes(e, t) {
                                const r = (new b).toXml(t);
                                e.append(r, {
                                    name: "[Content_Types].xml"
                                });
                            }
                            async addApp(e, t) {
                                const r = (new g).toXml(t);
                                e.append(r, {
                                    name: "docProps/app.xml"
                                });
                            }
                            async addCore(e, t) {
                                const r = new d;
                                e.append(r.toXml(t), {
                                    name: "docProps/core.xml"
                                });
                            }
                            async addThemes(e, t) {
                                const r = t.themes || {
                                    theme1: S
                                };
                                Object.keys(r).forEach((t)=>{
                                    const n = r[t], i = `xl/theme/${t}.xml`;
                                    e.append(n, {
                                        name: i
                                    });
                                });
                            }
                            async addOfficeRels(e) {
                                const t = (new m).toXml([
                                    {
                                        Id: "rId1",
                                        Type: M.RelType.OfficeDocument,
                                        Target: "xl/workbook.xml"
                                    },
                                    {
                                        Id: "rId2",
                                        Type: M.RelType.CoreProperties,
                                        Target: "docProps/core.xml"
                                    },
                                    {
                                        Id: "rId3",
                                        Type: M.RelType.ExtenderProperties,
                                        Target: "docProps/app.xml"
                                    }
                                ]);
                                e.append(t, {
                                    name: "_rels/.rels"
                                });
                            }
                            async addWorkbookRels(e, t) {
                                let r = 1;
                                const n = [
                                    {
                                        Id: "rId" + r++,
                                        Type: M.RelType.Styles,
                                        Target: "styles.xml"
                                    },
                                    {
                                        Id: "rId" + r++,
                                        Type: M.RelType.Theme,
                                        Target: "theme/theme1.xml"
                                    }
                                ];
                                t.sharedStrings.count && n.push({
                                    Id: "rId" + r++,
                                    Type: M.RelType.SharedStrings,
                                    Target: "sharedStrings.xml"
                                }), t.worksheets.forEach((e)=>{
                                    e.rId = "rId" + r++, n.push({
                                        Id: e.rId,
                                        Type: M.RelType.Worksheet,
                                        Target: `worksheets/sheet${e.id}.xml`
                                    });
                                });
                                const i = (new m).toXml(n);
                                e.append(i, {
                                    name: "xl/_rels/workbook.xml.rels"
                                });
                            }
                            async addSharedStrings(e, t) {
                                t.sharedStrings && t.sharedStrings.count && e.append(t.sharedStrings.xml, {
                                    name: "xl/sharedStrings.xml"
                                });
                            }
                            async addStyles(e, t) {
                                const { xml: r } = t.styles;
                                r && e.append(r, {
                                    name: "xl/styles.xml"
                                });
                            }
                            async addWorkbook(e, t) {
                                const r = new y;
                                e.append(r.toXml(t), {
                                    name: "xl/workbook.xml"
                                });
                            }
                            async addWorksheets(e, t) {
                                const r = new v, n = new m, i = new x, s = new k;
                                t.worksheets.forEach((t)=>{
                                    let o = new u;
                                    r.render(o, t), e.append(o.xml, {
                                        name: `xl/worksheets/sheet${t.id}.xml`
                                    }), t.rels && t.rels.length && (o = new u, n.render(o, t.rels), e.append(o.xml, {
                                        name: `xl/worksheets/_rels/sheet${t.id}.xml.rels`
                                    })), t.comments.length > 0 && (o = new u, i.render(o, t), e.append(o.xml, {
                                        name: `xl/comments${t.id}.xml`
                                    }), o = new u, s.render(o, t), e.append(o.xml, {
                                        name: `xl/drawings/vmlDrawing${t.id}.vml`
                                    }));
                                });
                            }
                            _finalize(e) {
                                return new Promise((t, r)=>{
                                    e.on("finish", ()=>{
                                        t(this);
                                    }), e.on("error", r), e.finalize();
                                });
                            }
                            prepareModel(e, t) {
                                e.creator = e.creator || "ExcelJS", e.lastModifiedBy = e.lastModifiedBy || "ExcelJS", e.created = e.created || new Date, e.modified = e.modified || new Date, e.useSharedStrings = void 0 === t.useSharedStrings || t.useSharedStrings, e.useStyles = void 0 === t.useStyles || t.useStyles, e.sharedStrings = new p, e.styles = e.useStyles ? new f(!0) : new f.Mock;
                                const r = new y, n = new v;
                                r.prepare(e);
                                const i = {
                                    sharedStrings: e.sharedStrings,
                                    styles: e.styles,
                                    date1904: e.properties.date1904,
                                    drawingsCount: 0,
                                    media: e.media
                                };
                                i.drawings = e.drawings = [], i.commentRefs = e.commentRefs = [];
                                let s = 0;
                                e.tables = [], e.worksheets.forEach((t)=>{
                                    t.tables.forEach((t)=>{
                                        s++, t.target = `table${s}.xml`, t.id = s, e.tables.push(t);
                                    }), n.prepare(t, i);
                                });
                            }
                            async write(e, t) {
                                t = t || {};
                                const { model: r } = this.workbook, n = new a.ZipWriter(t.zip);
                                return n.pipe(e), this.prepareModel(r, t), await this.addContentTypes(n, r), await this.addOfficeRels(n, r), await this.addWorkbookRels(n, r), await this.addWorksheets(n, r), await this.addSharedStrings(n, r), await this.addDrawings(n, r), await this.addTables(n, r), await Promise.all([
                                    this.addThemes(n, r),
                                    this.addStyles(n, r)
                                ]), await this.addMedia(n, r), await Promise.all([
                                    this.addApp(n, r),
                                    this.addCore(n, r)
                                ]), await this.addWorkbook(n, r), this._finalize(n);
                            }
                            writeFile(e, t) {
                                const r = i.createWriteStream(e);
                                return new Promise((e, n)=>{
                                    r.on("finish", ()=>{
                                        e();
                                    }), r.on("error", (e)=>{
                                        n(e);
                                    }), this.write(r, t).then(()=>{
                                        r.end();
                                    }).catch((e)=>{
                                        n(e);
                                    });
                                });
                            }
                            async writeBuffer(e) {
                                const t = new l;
                                return await this.write(t, e), t.read();
                            }
                        }
                        M.RelType = e("./rel-type"), t.exports = M;
                    }).call(this);
                }).call(this, e("_process"), e("buffer").Buffer);
            },
            {
                "../utils/browser-buffer-decode": 16,
                "../utils/stream-buf": 24,
                "../utils/utils": 27,
                "../utils/xml-stream": 28,
                "../utils/zip-stream": 29,
                "./rel-type": 31,
                "./xform/book/workbook-xform": 38,
                "./xform/comment/comments-xform": 40,
                "./xform/comment/vml-notes-xform": 45,
                "./xform/core/app-xform": 51,
                "./xform/core/content-types-xform": 52,
                "./xform/core/core-xform": 53,
                "./xform/core/relationships-xform": 55,
                "./xform/drawing/drawing-xform": 62,
                "./xform/sheet/worksheet-xform": 115,
                "./xform/strings/shared-strings-xform": 124,
                "./xform/style/styles-xform": 135,
                "./xform/table/table-xform": 143,
                "./xml/theme1": 145,
                _process: 467,
                buffer: 220,
                fs: 216,
                jszip: 441,
                "readable-stream": 491
            }
        ],
        145: [
            function(e, t, r) {
                "use strict";
                t.exports = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme"> <a:themeElements> <a:clrScheme name="Office"> <a:dk1> <a:sysClr val="windowText" lastClr="000000"/> </a:dk1> <a:lt1> <a:sysClr val="window" lastClr="FFFFFF"/> </a:lt1> <a:dk2> <a:srgbClr val="1F497D"/> </a:dk2> <a:lt2> <a:srgbClr val="EEECE1"/> </a:lt2> <a:accent1> <a:srgbClr val="4F81BD"/> </a:accent1> <a:accent2> <a:srgbClr val="C0504D"/> </a:accent2> <a:accent3> <a:srgbClr val="9BBB59"/> </a:accent3> <a:accent4> <a:srgbClr val="8064A2"/> </a:accent4> <a:accent5> <a:srgbClr val="4BACC6"/> </a:accent5> <a:accent6> <a:srgbClr val="F79646"/> </a:accent6> <a:hlink> <a:srgbClr val="0000FF"/> </a:hlink> <a:folHlink> <a:srgbClr val="800080"/> </a:folHlink> </a:clrScheme> <a:fontScheme name="Office"> <a:majorFont> <a:latin typeface="Cambria"/> <a:ea typeface=""/> <a:cs typeface=""/> <a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/> <a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/> <a:font script="Hans" typeface="\u5b8b\u4f53"/> <a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/> <a:font script="Arab" typeface="Times New Roman"/> <a:font script="Hebr" typeface="Times New Roman"/> <a:font script="Thai" typeface="Tahoma"/> <a:font script="Ethi" typeface="Nyala"/> <a:font script="Beng" typeface="Vrinda"/> <a:font script="Gujr" typeface="Shruti"/> <a:font script="Khmr" typeface="MoolBoran"/> <a:font script="Knda" typeface="Tunga"/> <a:font script="Guru" typeface="Raavi"/> <a:font script="Cans" typeface="Euphemia"/> <a:font script="Cher" typeface="Plantagenet Cherokee"/> <a:font script="Yiii" typeface="Microsoft Yi Baiti"/> <a:font script="Tibt" typeface="Microsoft Himalaya"/> <a:font script="Thaa" typeface="MV Boli"/> <a:font script="Deva" typeface="Mangal"/> <a:font script="Telu" typeface="Gautami"/> <a:font script="Taml" typeface="Latha"/> <a:font script="Syrc" typeface="Estrangelo Edessa"/> <a:font script="Orya" typeface="Kalinga"/> <a:font script="Mlym" typeface="Kartika"/> <a:font script="Laoo" typeface="DokChampa"/> <a:font script="Sinh" typeface="Iskoola Pota"/> <a:font script="Mong" typeface="Mongolian Baiti"/> <a:font script="Viet" typeface="Times New Roman"/> <a:font script="Uigh" typeface="Microsoft Uighur"/> <a:font script="Geor" typeface="Sylfaen"/> </a:majorFont> <a:minorFont> <a:latin typeface="Calibri"/> <a:ea typeface=""/> <a:cs typeface=""/> <a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/> <a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/> <a:font script="Hans" typeface="\u5b8b\u4f53"/> <a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/> <a:font script="Arab" typeface="Arial"/> <a:font script="Hebr" typeface="Arial"/> <a:font script="Thai" typeface="Tahoma"/> <a:font script="Ethi" typeface="Nyala"/> <a:font script="Beng" typeface="Vrinda"/> <a:font script="Gujr" typeface="Shruti"/> <a:font script="Khmr" typeface="DaunPenh"/> <a:font script="Knda" typeface="Tunga"/> <a:font script="Guru" typeface="Raavi"/> <a:font script="Cans" typeface="Euphemia"/> <a:font script="Cher" typeface="Plantagenet Cherokee"/> <a:font script="Yiii" typeface="Microsoft Yi Baiti"/> <a:font script="Tibt" typeface="Microsoft Himalaya"/> <a:font script="Thaa" typeface="MV Boli"/> <a:font script="Deva" typeface="Mangal"/> <a:font script="Telu" typeface="Gautami"/> <a:font script="Taml" typeface="Latha"/> <a:font script="Syrc" typeface="Estrangelo Edessa"/> <a:font script="Orya" typeface="Kalinga"/> <a:font script="Mlym" typeface="Kartika"/> <a:font script="Laoo" typeface="DokChampa"/> <a:font script="Sinh" typeface="Iskoola Pota"/> <a:font script="Mong" typeface="Mongolian Baiti"/> <a:font script="Viet" typeface="Arial"/> <a:font script="Uigh" typeface="Microsoft Uighur"/> <a:font script="Geor" typeface="Sylfaen"/> </a:minorFont> </a:fontScheme> <a:fmtScheme name="Office"> <a:fillStyleLst> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="50000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="35000"> <a:schemeClr val="phClr"> <a:tint val="37000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:tint val="15000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang="16200000" scaled="1"/> </a:gradFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="100000"/> <a:shade val="100000"/> <a:satMod val="130000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:tint val="50000"/> <a:shade val="100000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang="16200000" scaled="0"/> </a:gradFill> </a:fillStyleLst> <a:lnStyleLst> <a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"> <a:shade val="95000"/> <a:satMod val="105000"/> </a:schemeClr> </a:solidFill> <a:prstDash val="solid"/> </a:ln> <a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:prstDash val="solid"/> </a:ln> <a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:prstDash val="solid"/> </a:ln> </a:lnStyleLst> <a:effectStyleLst> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="38000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="35000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="35000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> <a:scene3d> <a:camera prst="orthographicFront"> <a:rot lat="0" lon="0" rev="0"/> </a:camera> <a:lightRig rig="threePt" dir="t"> <a:rot lat="0" lon="0" rev="1200000"/> </a:lightRig> </a:scene3d> <a:sp3d> <a:bevelT w="63500" h="25400"/> </a:sp3d> </a:effectStyle> </a:effectStyleLst> <a:bgFillStyleLst> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="40000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> <a:gs pos="40000"> <a:schemeClr val="phClr"> <a:tint val="45000"/> <a:shade val="99000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:shade val="20000"/> <a:satMod val="255000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path="circle"> <a:fillToRect l="50000" t="-80000" r="50000" b="180000"/> </a:path> </a:gradFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="80000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:shade val="30000"/> <a:satMod val="200000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path="circle"> <a:fillToRect l="50000" t="50000" r="50000" b="50000"/> </a:path> </a:gradFill> </a:bgFillStyleLst> </a:fmtScheme> </a:themeElements> <a:objectDefaults> <a:spDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx="1"> <a:schemeClr val="accent1"/> </a:lnRef> <a:fillRef idx="3"> <a:schemeClr val="accent1"/> </a:fillRef> <a:effectRef idx="2"> <a:schemeClr val="accent1"/> </a:effectRef> <a:fontRef idx="minor"> <a:schemeClr val="lt1"/> </a:fontRef> </a:style> </a:spDef> <a:lnDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx="2"> <a:schemeClr val="accent1"/> </a:lnRef> <a:fillRef idx="0"> <a:schemeClr val="accent1"/> </a:fillRef> <a:effectRef idx="1"> <a:schemeClr val="accent1"/> </a:effectRef> <a:fontRef idx="minor"> <a:schemeClr val="tx1"/> </a:fontRef> </a:style> </a:lnDef> </a:objectDefaults> <a:extraClrSchemeLst/> </a:theme>';
            },
            {}
        ],
        146: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.CsvFormatterStream = void 0;
                        const n = e("stream"), i = e("./formatter");
                        class s extends n.Transform {
                            constructor(e){
                                super({
                                    writableObjectMode: e.objectMode
                                }), this.hasWrittenBOM = !1, this.formatterOptions = e, this.rowFormatter = new i.RowFormatter(e), this.hasWrittenBOM = !e.writeBOM;
                            }
                            transform(e) {
                                return this.rowFormatter.rowTransform = e, this;
                            }
                            _transform(e, r, n) {
                                let i = !1;
                                try {
                                    this.hasWrittenBOM || (this.push(this.formatterOptions.BOM), this.hasWrittenBOM = !0), this.rowFormatter.format(e, (e, r)=>e ? (i = !0, n(e)) : (r && r.forEach((e)=>{
                                            this.push(t.from(e, "utf8"));
                                        }), i = !0, n()));
                                } catch (e) {
                                    if (i) throw e;
                                    n(e);
                                }
                            }
                            _flush(e) {
                                this.rowFormatter.finish((r, n)=>r ? e(r) : (n && n.forEach((e)=>{
                                        this.push(t.from(e, "utf8"));
                                    }), e()));
                            }
                        }
                        r.CsvFormatterStream = s;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./formatter": 150,
                buffer: 220,
                stream: 505
            }
        ],
        147: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FormatterOptions = void 0;
                r.FormatterOptions = class {
                    constructor(){
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        var t;
                        this.objectMode = !0, this.delimiter = ",", this.rowDelimiter = "\n", this.quote = '"', this.escape = this.quote, this.quoteColumns = !1, this.quoteHeaders = this.quoteColumns, this.headers = null, this.includeEndRowDelimiter = !1, this.writeBOM = !1, this.BOM = "\ufeff", this.alwaysWriteHeaders = !1, Object.assign(this, e || {}), void 0 === (null == e ? void 0 : e.quoteHeaders) && (this.quoteHeaders = this.quoteColumns), !0 === (null == e ? void 0 : e.quote) ? this.quote = '"' : !1 === (null == e ? void 0 : e.quote) && (this.quote = ""), "string" != typeof (null == e ? void 0 : e.escape) && (this.escape = this.quote), this.shouldWriteHeaders = !!this.headers && (null === (t = e.writeHeaders) || void 0 === t || t), this.headers = Array.isArray(this.headers) ? this.headers : null, this.escapedQuote = `${this.escape}${this.quote}`;
                    }
                };
            },
            {}
        ],
        148: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FieldFormatter = void 0;
                const i = n(e("lodash.isboolean")), s = n(e("lodash.isnil")), o = n(e("lodash.escaperegexp"));
                r.FieldFormatter = class {
                    constructor(e){
                        this._headers = null, this.formatterOptions = e, null !== e.headers && (this.headers = e.headers), this.REPLACE_REGEXP = new RegExp(e.quote, "g");
                        const t = `[${e.delimiter}${o.default(e.rowDelimiter)}|\r|\n]`;
                        this.ESCAPE_REGEXP = new RegExp(t);
                    }
                    set headers(e) {
                        this._headers = e;
                    }
                    shouldQuote(e, t) {
                        const r = t ? this.formatterOptions.quoteHeaders : this.formatterOptions.quoteColumns;
                        return i.default(r) ? r : Array.isArray(r) ? r[e] : null !== this._headers && r[this._headers[e]];
                    }
                    format(e, t, r) {
                        const n = ("" + (s.default(e) ? "" : e)).replace(/\0/g, ""), { formatterOptions: i } = this;
                        if ("" !== i.quote) {
                            if (-1 !== n.indexOf(i.quote)) return this.quoteField(n.replace(this.REPLACE_REGEXP, i.escapedQuote));
                        }
                        return -1 !== n.search(this.ESCAPE_REGEXP) || this.shouldQuote(t, r) ? this.quoteField(n) : n;
                    }
                    quoteField(e) {
                        const { quote: t } = this.formatterOptions;
                        return `${t}${e}${t}`;
                    }
                };
            },
            {
                "lodash.escaperegexp": 442,
                "lodash.isboolean": 444,
                "lodash.isnil": 447
            }
        ],
        149: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowFormatter = void 0;
                const i = n(e("lodash.isfunction")), s = n(e("lodash.isequal")), o = e("./FieldFormatter"), a = e("../types");
                class l {
                    constructor(e){
                        this.rowCount = 0, this.formatterOptions = e, this.fieldFormatter = new o.FieldFormatter(e), this.headers = e.headers, this.shouldWriteHeaders = e.shouldWriteHeaders, this.hasWrittenHeaders = !1, null !== this.headers && (this.fieldFormatter.headers = this.headers), e.transform && (this.rowTransform = e.transform);
                    }
                    static isRowHashArray(e) {
                        return !!Array.isArray(e) && Array.isArray(e[0]) && 2 === e[0].length;
                    }
                    static isRowArray(e) {
                        return Array.isArray(e) && !this.isRowHashArray(e);
                    }
                    static gatherHeaders(e) {
                        return l.isRowHashArray(e) ? e.map((e)=>e[0]) : Array.isArray(e) ? e : Object.keys(e);
                    }
                    static createTransform(e) {
                        return a.isSyncTransform(e) ? (t, r)=>{
                            let n = null;
                            try {
                                n = e(t);
                            } catch (e) {
                                return r(e);
                            }
                            return r(null, n);
                        } : (t, r)=>{
                            e(t, r);
                        };
                    }
                    set rowTransform(e) {
                        if (!i.default(e)) throw new TypeError("The transform should be a function");
                        this._rowTransform = l.createTransform(e);
                    }
                    format(e, t) {
                        this.callTransformer(e, (r, n)=>{
                            if (r) return t(r);
                            if (!e) return t(null);
                            const i = [];
                            if (n) {
                                const { shouldFormatColumns: e, headers: t } = this.checkHeaders(n);
                                if (this.shouldWriteHeaders && t && !this.hasWrittenHeaders && (i.push(this.formatColumns(t, !0)), this.hasWrittenHeaders = !0), e) {
                                    const e = this.gatherColumns(n);
                                    i.push(this.formatColumns(e, !1));
                                }
                            }
                            return t(null, i);
                        });
                    }
                    finish(e) {
                        const t = [];
                        if (this.formatterOptions.alwaysWriteHeaders && 0 === this.rowCount) {
                            if (!this.headers) return e(new Error("`alwaysWriteHeaders` option is set to true but `headers` option not provided."));
                            t.push(this.formatColumns(this.headers, !0));
                        }
                        return this.formatterOptions.includeEndRowDelimiter && t.push(this.formatterOptions.rowDelimiter), e(null, t);
                    }
                    checkHeaders(e) {
                        if (this.headers) return {
                            shouldFormatColumns: !0,
                            headers: this.headers
                        };
                        const t = l.gatherHeaders(e);
                        return this.headers = t, this.fieldFormatter.headers = t, this.shouldWriteHeaders ? {
                            shouldFormatColumns: !s.default(t, e),
                            headers: t
                        } : {
                            shouldFormatColumns: !0,
                            headers: null
                        };
                    }
                    gatherColumns(e) {
                        if (null === this.headers) throw new Error("Headers is currently null");
                        return Array.isArray(e) ? l.isRowHashArray(e) ? this.headers.map((t, r)=>{
                            const n = e[r];
                            return n ? n[1] : "";
                        }) : l.isRowArray(e) && !this.shouldWriteHeaders ? e : this.headers.map((t, r)=>e[r]) : this.headers.map((t)=>e[t]);
                    }
                    callTransformer(e, t) {
                        return this._rowTransform ? this._rowTransform(e, t) : t(null, e);
                    }
                    formatColumns(e, t) {
                        const r = e.map((e, r)=>this.fieldFormatter.format(e, r, t)).join(this.formatterOptions.delimiter), { rowCount: n } = this;
                        return this.rowCount += 1, n ? [
                            this.formatterOptions.rowDelimiter,
                            r
                        ].join("") : r;
                    }
                }
                r.RowFormatter = l;
            },
            {
                "../types": 152,
                "./FieldFormatter": 148,
                "lodash.isequal": 445,
                "lodash.isfunction": 446
            }
        ],
        150: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FieldFormatter = r.RowFormatter = void 0;
                var n = e("./RowFormatter");
                Object.defineProperty(r, "RowFormatter", {
                    enumerable: !0,
                    get: function() {
                        return n.RowFormatter;
                    }
                });
                var i = e("./FieldFormatter");
                Object.defineProperty(r, "FieldFormatter", {
                    enumerable: !0,
                    get: function() {
                        return i.FieldFormatter;
                    }
                });
            },
            {
                "./FieldFormatter": 148,
                "./RowFormatter": 149
            }
        ],
        151: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = Object.create ? function(e, t, r, n) {
                            void 0 === n && (n = r), Object.defineProperty(e, n, {
                                enumerable: !0,
                                get: function() {
                                    return t[r];
                                }
                            });
                        } : function(e, t, r, n) {
                            void 0 === n && (n = r), e[n] = t[r];
                        }, i = Object.create ? function(e, t) {
                            Object.defineProperty(e, "default", {
                                enumerable: !0,
                                value: t
                            });
                        } : function(e, t) {
                            e.default = t;
                        }, s = function(e) {
                            if (e && e.__esModule) return e;
                            var t = {};
                            if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                            return i(t, e), t;
                        }, o = function(e, t) {
                            for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                        };
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.writeToPath = r.writeToString = r.writeToBuffer = r.writeToStream = r.write = r.format = r.FormatterOptions = r.CsvFormatterStream = void 0;
                        const a = e("util"), l = e("stream"), c = s(e("fs")), u = e("./FormatterOptions"), h = e("./CsvFormatterStream");
                        o(e("./types"), r);
                        var f = e("./CsvFormatterStream");
                        Object.defineProperty(r, "CsvFormatterStream", {
                            enumerable: !0,
                            get: function() {
                                return f.CsvFormatterStream;
                            }
                        });
                        var d = e("./FormatterOptions");
                        Object.defineProperty(r, "FormatterOptions", {
                            enumerable: !0,
                            get: function() {
                                return d.FormatterOptions;
                            }
                        }), r.format = (e)=>new h.CsvFormatterStream(new u.FormatterOptions(e)), r.write = (e, t)=>{
                            const n = r.format(t), i = a.promisify((e, t)=>{
                                n.write(e, void 0, t);
                            });
                            return e.reduce((e, t)=>e.then(()=>i(t)), Promise.resolve()).then(()=>n.end()).catch((e)=>{
                                n.emit("error", e);
                            }), n;
                        }, r.writeToStream = (e, t, n)=>r.write(t, n).pipe(e), r.writeToBuffer = function(e) {
                            let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            const i = [], s = new l.Writable({
                                write (e, t, r) {
                                    i.push(e), r();
                                }
                            });
                            return new Promise((o, a)=>{
                                s.on("error", a).on("finish", ()=>o(t.concat(i))), r.write(e, n).pipe(s);
                            });
                        }, r.writeToString = (e, t)=>r.writeToBuffer(e, t).then((e)=>e.toString()), r.writeToPath = (e, t, n)=>{
                            const i = c.createWriteStream(e, {
                                encoding: "utf8"
                            });
                            return r.write(t, n).pipe(i);
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./CsvFormatterStream": 146,
                "./FormatterOptions": 147,
                "./types": 152,
                buffer: 220,
                fs: 216,
                stream: 505,
                util: 527
            }
        ],
        152: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.isSyncTransform = void 0, r.isSyncTransform = (e)=>1 === e.length;
            },
            {}
        ],
        153: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.CsvParserStream = void 0;
                        const n = e("string_decoder"), i = e("stream"), s = e("./transforms"), o = e("./parser");
                        class a extends i.Transform {
                            constructor(e){
                                super({
                                    objectMode: e.objectMode
                                }), this.lines = "", this.rowCount = 0, this.parsedRowCount = 0, this.parsedLineCount = 0, this.endEmitted = !1, this.headersEmitted = !1, this.parserOptions = e, this.parser = new o.Parser(e), this.headerTransformer = new s.HeaderTransformer(e), this.decoder = new n.StringDecoder(e.encoding), this.rowTransformerValidator = new s.RowTransformerValidator;
                            }
                            get hasHitRowLimit() {
                                return this.parserOptions.limitRows && this.rowCount >= this.parserOptions.maxRows;
                            }
                            get shouldEmitRows() {
                                return this.parsedRowCount > this.parserOptions.skipRows;
                            }
                            get shouldSkipLine() {
                                return this.parsedLineCount <= this.parserOptions.skipLines;
                            }
                            transform(e) {
                                return this.rowTransformerValidator.rowTransform = e, this;
                            }
                            validate(e) {
                                return this.rowTransformerValidator.rowValidator = e, this;
                            }
                            emit(e) {
                                if ("end" === e) return this.endEmitted || (this.endEmitted = !0, super.emit("end", this.rowCount)), !1;
                                for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                                return super.emit(e, ...r);
                            }
                            _transform(e, t, r) {
                                if (this.hasHitRowLimit) return r();
                                const n = a.wrapDoneCallback(r);
                                try {
                                    const { lines: t } = this, r = t + this.decoder.write(e), i = this.parse(r, !0);
                                    return this.processRows(i, n);
                                } catch (e) {
                                    return n(e);
                                }
                            }
                            _flush(e) {
                                const t = a.wrapDoneCallback(e);
                                if (this.hasHitRowLimit) return t();
                                try {
                                    const e = this.lines + this.decoder.end(), r = this.parse(e, !1);
                                    return this.processRows(r, t);
                                } catch (e) {
                                    return t(e);
                                }
                            }
                            parse(e, t) {
                                if (!e) return [];
                                const { line: r, rows: n } = this.parser.parse(e, t);
                                return this.lines = r, n;
                            }
                            processRows(e, r) {
                                const n = e.length, i = (s)=>{
                                    const o = (e)=>e ? r(e) : s % 100 != 0 ? i(s + 1) : void t(()=>i(s + 1));
                                    if (this.checkAndEmitHeaders(), s >= n || this.hasHitRowLimit) return r();
                                    if (this.parsedLineCount += 1, this.shouldSkipLine) return o();
                                    const a = e[s];
                                    this.rowCount += 1, this.parsedRowCount += 1;
                                    const l = this.rowCount;
                                    return this.transformRow(a, (e, t)=>{
                                        if (e) return this.rowCount -= 1, o(e);
                                        if (!t) return o(new Error("expected transform result"));
                                        if (t.isValid) {
                                            if (t.row) return this.pushRow(t.row, o);
                                        } else this.emit("data-invalid", t.row, l, t.reason);
                                        return o();
                                    });
                                };
                                i(0);
                            }
                            transformRow(e, t) {
                                try {
                                    this.headerTransformer.transform(e, (r, n)=>r ? t(r) : n ? n.isValid ? n.row ? this.shouldEmitRows ? this.rowTransformerValidator.transformAndValidate(n.row, t) : this.skipRow(t) : (this.rowCount -= 1, this.parsedRowCount -= 1, t(null, {
                                            row: null,
                                            isValid: !0
                                        })) : this.shouldEmitRows ? t(null, {
                                            isValid: !1,
                                            row: e
                                        }) : this.skipRow(t) : t(new Error("Expected result from header transform")));
                                } catch (e) {
                                    t(e);
                                }
                            }
                            checkAndEmitHeaders() {
                                !this.headersEmitted && this.headerTransformer.headers && (this.headersEmitted = !0, this.emit("headers", this.headerTransformer.headers));
                            }
                            skipRow(e) {
                                return this.rowCount -= 1, e(null, {
                                    row: null,
                                    isValid: !0
                                });
                            }
                            pushRow(e, t) {
                                try {
                                    this.parserOptions.objectMode ? this.push(e) : this.push(JSON.stringify(e)), t();
                                } catch (e) {
                                    t(e);
                                }
                            }
                            static wrapDoneCallback(e) {
                                let t = !1;
                                return function(r) {
                                    if (r) {
                                        if (t) throw r;
                                        return t = !0, void e(r);
                                    }
                                    for(var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)i[s - 1] = arguments[s];
                                    e(...i);
                                };
                            }
                        }
                        r.CsvParserStream = a;
                    }).call(this);
                }).call(this, e("timers").setImmediate);
            },
            {
                "./parser": 165,
                "./transforms": 168,
                stream: 505,
                string_decoder: 218,
                timers: 523
            }
        ],
        154: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ParserOptions = void 0;
                const i = n(e("lodash.escaperegexp")), s = n(e("lodash.isnil"));
                r.ParserOptions = class {
                    constructor(e){
                        var t;
                        if (this.objectMode = !0, this.delimiter = ",", this.ignoreEmpty = !1, this.quote = '"', this.escape = null, this.escapeChar = this.quote, this.comment = null, this.supportsComments = !1, this.ltrim = !1, this.rtrim = !1, this.trim = !1, this.headers = null, this.renameHeaders = !1, this.strictColumnHandling = !1, this.discardUnmappedColumns = !1, this.carriageReturn = "\r", this.encoding = "utf8", this.limitRows = !1, this.maxRows = 0, this.skipLines = 0, this.skipRows = 0, Object.assign(this, e || {}), this.delimiter.length > 1) throw new Error("delimiter option must be one character long");
                        this.escapedDelimiter = i.default(this.delimiter), this.escapeChar = null !== (t = this.escape) && void 0 !== t ? t : this.quote, this.supportsComments = !s.default(this.comment), this.NEXT_TOKEN_REGEXP = new RegExp(`([^\\s]|\\r\\n|\\n|\\r|${this.escapedDelimiter})`), this.maxRows > 0 && (this.limitRows = !0);
                    }
                };
            },
            {
                "lodash.escaperegexp": 442,
                "lodash.isnil": 447
            }
        ],
        155: [
            function(e, t, r) {
                "use strict";
                var n = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r), Object.defineProperty(e, n, {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    });
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }, i = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }, s = function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, o = function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.parseString = r.parseFile = r.parseStream = r.parse = r.ParserOptions = r.CsvParserStream = void 0;
                const a = s(e("fs")), l = e("stream"), c = e("./ParserOptions"), u = e("./CsvParserStream");
                o(e("./types"), r);
                var h = e("./CsvParserStream");
                Object.defineProperty(r, "CsvParserStream", {
                    enumerable: !0,
                    get: function() {
                        return h.CsvParserStream;
                    }
                });
                var f = e("./ParserOptions");
                Object.defineProperty(r, "ParserOptions", {
                    enumerable: !0,
                    get: function() {
                        return f.ParserOptions;
                    }
                }), r.parse = (e)=>new u.CsvParserStream(new c.ParserOptions(e)), r.parseStream = (e, t)=>e.pipe(new u.CsvParserStream(new c.ParserOptions(t))), r.parseFile = function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return a.createReadStream(e).pipe(new u.CsvParserStream(new c.ParserOptions(t)));
                }, r.parseString = (e, t)=>{
                    const r = new l.Readable;
                    return r.push(e), r.push(null), r.pipe(new u.CsvParserStream(new c.ParserOptions(t)));
                };
            },
            {
                "./CsvParserStream": 153,
                "./ParserOptions": 154,
                "./types": 169,
                fs: 216,
                stream: 505
            }
        ],
        156: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Parser = void 0;
                const n = e("./Scanner"), i = e("./RowParser"), s = e("./Token");
                class o {
                    constructor(e){
                        this.parserOptions = e, this.rowParser = new i.RowParser(this.parserOptions);
                    }
                    static removeBOM(e) {
                        return e && 65279 === e.charCodeAt(0) ? e.slice(1) : e;
                    }
                    parse(e, t) {
                        const r = new n.Scanner({
                            line: o.removeBOM(e),
                            parserOptions: this.parserOptions,
                            hasMoreData: t
                        });
                        return this.parserOptions.supportsComments ? this.parseWithComments(r) : this.parseWithoutComments(r);
                    }
                    parseWithoutComments(e) {
                        const t = [];
                        let r = !0;
                        for(; r;)r = this.parseRow(e, t);
                        return {
                            line: e.line,
                            rows: t
                        };
                    }
                    parseWithComments(e) {
                        const { parserOptions: t } = this, r = [];
                        for(let n = e.nextCharacterToken; null !== n; n = e.nextCharacterToken)if (s.Token.isTokenComment(n, t)) {
                            if (null === e.advancePastLine()) return {
                                line: e.lineFromCursor,
                                rows: r
                            };
                            if (!e.hasMoreCharacters) return {
                                line: e.lineFromCursor,
                                rows: r
                            };
                            e.truncateToCursor();
                        } else if (!this.parseRow(e, r)) break;
                        return {
                            line: e.line,
                            rows: r
                        };
                    }
                    parseRow(e, t) {
                        if (!e.nextNonSpaceToken) return !1;
                        const r = this.rowParser.parse(e);
                        return null !== r && (this.parserOptions.ignoreEmpty && i.RowParser.isEmptyRow(r) || t.push(r), !0);
                    }
                }
                r.Parser = o;
            },
            {
                "./RowParser": 157,
                "./Scanner": 158,
                "./Token": 159
            }
        ],
        157: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowParser = void 0;
                const n = e("./column"), i = e("./Token");
                r.RowParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnParser = new n.ColumnParser(e);
                    }
                    static isEmptyRow(e) {
                        return "" === e.join("").replace(/\s+/g, "");
                    }
                    parse(e) {
                        const { parserOptions: t } = this, { hasMoreData: r } = e, n = e, s = [];
                        let o = this.getStartToken(n, s);
                        for(; o;){
                            if (i.Token.isTokenRowDelimiter(o)) return n.advancePastToken(o), !n.hasMoreCharacters && i.Token.isTokenCarriageReturn(o, t) && r ? null : (n.truncateToCursor(), s);
                            if (!this.shouldSkipColumnParse(n, o, s)) {
                                const e = this.columnParser.parse(n);
                                if (null === e) return null;
                                s.push(e);
                            }
                            o = n.nextNonSpaceToken;
                        }
                        return r ? null : (n.truncateToCursor(), s);
                    }
                    getStartToken(e, t) {
                        const r = e.nextNonSpaceToken;
                        return null !== r && i.Token.isTokenDelimiter(r, this.parserOptions) ? (t.push(""), e.nextNonSpaceToken) : r;
                    }
                    shouldSkipColumnParse(e, t, r) {
                        const { parserOptions: n } = this;
                        if (i.Token.isTokenDelimiter(t, n)) {
                            e.advancePastToken(t);
                            const s = e.nextCharacterToken;
                            if (!e.hasMoreCharacters || null !== s && i.Token.isTokenRowDelimiter(s)) return r.push(""), !0;
                            if (null !== s && i.Token.isTokenDelimiter(s, n)) return r.push(""), !0;
                        }
                        return !1;
                    }
                };
            },
            {
                "./Token": 159,
                "./column": 164
            }
        ],
        158: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Scanner = void 0;
                const n = e("./Token"), i = /((?:\r\n)|\n|\r)/;
                r.Scanner = class {
                    constructor(e){
                        this.cursor = 0, this.line = e.line, this.lineLength = this.line.length, this.parserOptions = e.parserOptions, this.hasMoreData = e.hasMoreData, this.cursor = e.cursor || 0;
                    }
                    get hasMoreCharacters() {
                        return this.lineLength > this.cursor;
                    }
                    get nextNonSpaceToken() {
                        const { lineFromCursor: e } = this, t = this.parserOptions.NEXT_TOKEN_REGEXP;
                        if (-1 === e.search(t)) return null;
                        const r = t.exec(e);
                        if (null == r) return null;
                        const i = r[1], s = this.cursor + (r.index || 0);
                        return new n.Token({
                            token: i,
                            startCursor: s,
                            endCursor: s + i.length - 1
                        });
                    }
                    get nextCharacterToken() {
                        const { cursor: e, lineLength: t } = this;
                        return t <= e ? null : new n.Token({
                            token: this.line[e],
                            startCursor: e,
                            endCursor: e
                        });
                    }
                    get lineFromCursor() {
                        return this.line.substr(this.cursor);
                    }
                    advancePastLine() {
                        const e = i.exec(this.lineFromCursor);
                        return e ? (this.cursor += (e.index || 0) + e[0].length, this) : this.hasMoreData ? null : (this.cursor = this.lineLength, this);
                    }
                    advanceTo(e) {
                        return this.cursor = e, this;
                    }
                    advanceToToken(e) {
                        return this.cursor = e.startCursor, this;
                    }
                    advancePastToken(e) {
                        return this.cursor = e.endCursor + 1, this;
                    }
                    truncateToCursor() {
                        return this.line = this.lineFromCursor, this.lineLength = this.line.length, this.cursor = 0, this;
                    }
                };
            },
            {
                "./Token": 159
            }
        ],
        159: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Token = void 0;
                r.Token = class {
                    constructor(e){
                        this.token = e.token, this.startCursor = e.startCursor, this.endCursor = e.endCursor;
                    }
                    static isTokenRowDelimiter(e) {
                        const t = e.token;
                        return "\r" === t || "\n" === t || "\r\n" === t;
                    }
                    static isTokenCarriageReturn(e, t) {
                        return e.token === t.carriageReturn;
                    }
                    static isTokenComment(e, t) {
                        return t.supportsComments && !!e && e.token === t.comment;
                    }
                    static isTokenEscapeCharacter(e, t) {
                        return e.token === t.escapeChar;
                    }
                    static isTokenQuote(e, t) {
                        return e.token === t.quote;
                    }
                    static isTokenDelimiter(e, t) {
                        return e.token === t.delimiter;
                    }
                };
            },
            {}
        ],
        160: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnFormatter = void 0;
                r.ColumnFormatter = class {
                    constructor(e){
                        e.trim ? this.format = (e)=>e.trim() : e.ltrim ? this.format = (e)=>e.trimLeft() : e.rtrim ? this.format = (e)=>e.trimRight() : this.format = (e)=>e;
                    }
                };
            },
            {}
        ],
        161: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnParser = void 0;
                const n = e("./NonQuotedColumnParser"), i = e("./QuotedColumnParser"), s = e("../Token");
                r.ColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.quotedColumnParser = new i.QuotedColumnParser(e), this.nonQuotedColumnParser = new n.NonQuotedColumnParser(e);
                    }
                    parse(e) {
                        const { nextNonSpaceToken: t } = e;
                        return null !== t && s.Token.isTokenQuote(t, this.parserOptions) ? (e.advanceToToken(t), this.quotedColumnParser.parse(e)) : this.nonQuotedColumnParser.parse(e);
                    }
                };
            },
            {
                "../Token": 159,
                "./NonQuotedColumnParser": 162,
                "./QuotedColumnParser": 163
            }
        ],
        162: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.NonQuotedColumnParser = void 0;
                const n = e("./ColumnFormatter"), i = e("../Token");
                r.NonQuotedColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnFormatter = new n.ColumnFormatter(e);
                    }
                    parse(e) {
                        if (!e.hasMoreCharacters) return null;
                        const { parserOptions: t } = this, r = [];
                        let n = e.nextCharacterToken;
                        for(; n && !i.Token.isTokenDelimiter(n, t) && !i.Token.isTokenRowDelimiter(n); n = e.nextCharacterToken)r.push(n.token), e.advancePastToken(n);
                        return this.columnFormatter.format(r.join(""));
                    }
                };
            },
            {
                "../Token": 159,
                "./ColumnFormatter": 160
            }
        ],
        163: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QuotedColumnParser = void 0;
                const n = e("./ColumnFormatter"), i = e("../Token");
                r.QuotedColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnFormatter = new n.ColumnFormatter(e);
                    }
                    parse(e) {
                        if (!e.hasMoreCharacters) return null;
                        const t = e.cursor, { foundClosingQuote: r, col: n } = this.gatherDataBetweenQuotes(e);
                        if (!r) {
                            if (e.advanceTo(t), !e.hasMoreData) throw new Error(`Parse Error: missing closing: '${this.parserOptions.quote || ""}' in line: at '${e.lineFromCursor.replace(/[\r\n]/g, "\\n'")}'`);
                            return null;
                        }
                        return this.checkForMalformedColumn(e), n;
                    }
                    gatherDataBetweenQuotes(e) {
                        const { parserOptions: t } = this;
                        let r = !1, n = !1;
                        const s = [];
                        let o = e.nextCharacterToken;
                        for(; !n && null !== o; o = e.nextCharacterToken){
                            const a = i.Token.isTokenQuote(o, t);
                            if (!r && a) r = !0;
                            else if (r) {
                                if (i.Token.isTokenEscapeCharacter(o, t)) {
                                    e.advancePastToken(o);
                                    const r = e.nextCharacterToken;
                                    null !== r && (i.Token.isTokenQuote(r, t) || i.Token.isTokenEscapeCharacter(r, t)) ? (s.push(r.token), o = r) : a ? n = !0 : s.push(o.token);
                                } else a ? n = !0 : s.push(o.token);
                            }
                            e.advancePastToken(o);
                        }
                        return {
                            col: this.columnFormatter.format(s.join("")),
                            foundClosingQuote: n
                        };
                    }
                    checkForMalformedColumn(e) {
                        const { parserOptions: t } = this, { nextNonSpaceToken: r } = e;
                        if (r) {
                            const n = i.Token.isTokenDelimiter(r, t), s = i.Token.isTokenRowDelimiter(r);
                            if (!n && !s) {
                                const n = e.lineFromCursor.substr(0, 10).replace(/[\r\n]/g, "\\n'");
                                throw new Error(`Parse Error: expected: '${t.escapedDelimiter}' OR new line got: '${r.token}'. at '${n}`);
                            }
                            e.advanceToToken(r);
                        } else e.hasMoreData || e.advancePastLine();
                    }
                };
            },
            {
                "../Token": 159,
                "./ColumnFormatter": 160
            }
        ],
        164: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnFormatter = r.QuotedColumnParser = r.NonQuotedColumnParser = r.ColumnParser = void 0;
                var n = e("./ColumnParser");
                Object.defineProperty(r, "ColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return n.ColumnParser;
                    }
                });
                var i = e("./NonQuotedColumnParser");
                Object.defineProperty(r, "NonQuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return i.NonQuotedColumnParser;
                    }
                });
                var s = e("./QuotedColumnParser");
                Object.defineProperty(r, "QuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return s.QuotedColumnParser;
                    }
                });
                var o = e("./ColumnFormatter");
                Object.defineProperty(r, "ColumnFormatter", {
                    enumerable: !0,
                    get: function() {
                        return o.ColumnFormatter;
                    }
                });
            },
            {
                "./ColumnFormatter": 160,
                "./ColumnParser": 161,
                "./NonQuotedColumnParser": 162,
                "./QuotedColumnParser": 163
            }
        ],
        165: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QuotedColumnParser = r.NonQuotedColumnParser = r.ColumnParser = r.Token = r.Scanner = r.RowParser = r.Parser = void 0;
                var n = e("./Parser");
                Object.defineProperty(r, "Parser", {
                    enumerable: !0,
                    get: function() {
                        return n.Parser;
                    }
                });
                var i = e("./RowParser");
                Object.defineProperty(r, "RowParser", {
                    enumerable: !0,
                    get: function() {
                        return i.RowParser;
                    }
                });
                var s = e("./Scanner");
                Object.defineProperty(r, "Scanner", {
                    enumerable: !0,
                    get: function() {
                        return s.Scanner;
                    }
                });
                var o = e("./Token");
                Object.defineProperty(r, "Token", {
                    enumerable: !0,
                    get: function() {
                        return o.Token;
                    }
                });
                var a = e("./column");
                Object.defineProperty(r, "ColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.ColumnParser;
                    }
                }), Object.defineProperty(r, "NonQuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.NonQuotedColumnParser;
                    }
                }), Object.defineProperty(r, "QuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.QuotedColumnParser;
                    }
                });
            },
            {
                "./Parser": 156,
                "./RowParser": 157,
                "./Scanner": 158,
                "./Token": 159,
                "./column": 164
            }
        ],
        166: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.HeaderTransformer = void 0;
                const i = n(e("lodash.isundefined")), s = n(e("lodash.isfunction")), o = n(e("lodash.uniq")), a = n(e("lodash.groupby"));
                r.HeaderTransformer = class {
                    constructor(e){
                        this.headers = null, this.receivedHeaders = !1, this.shouldUseFirstRow = !1, this.processedFirstRow = !1, this.headersLength = 0, this.parserOptions = e, !0 === e.headers ? this.shouldUseFirstRow = !0 : Array.isArray(e.headers) ? this.setHeaders(e.headers) : s.default(e.headers) && (this.headersTransform = e.headers);
                    }
                    transform(e, t) {
                        return this.shouldMapRow(e) ? t(null, this.processRow(e)) : t(null, {
                            row: null,
                            isValid: !0
                        });
                    }
                    shouldMapRow(e) {
                        const { parserOptions: t } = this;
                        if (!this.headersTransform && t.renameHeaders && !this.processedFirstRow) {
                            if (!this.receivedHeaders) throw new Error("Error renaming headers: new headers must be provided in an array");
                            return this.processedFirstRow = !0, !1;
                        }
                        if (!this.receivedHeaders && Array.isArray(e)) {
                            if (this.headersTransform) this.setHeaders(this.headersTransform(e));
                            else {
                                if (!this.shouldUseFirstRow) return !0;
                                this.setHeaders(e);
                            }
                            return !1;
                        }
                        return !0;
                    }
                    processRow(e) {
                        if (!this.headers) return {
                            row: e,
                            isValid: !0
                        };
                        const { parserOptions: t } = this;
                        if (!t.discardUnmappedColumns && e.length > this.headersLength) {
                            if (!t.strictColumnHandling) throw new Error(`Unexpected Error: column header mismatch expected: ${this.headersLength} columns got: ${e.length}`);
                            return {
                                row: e,
                                isValid: !1,
                                reason: `Column header mismatch expected: ${this.headersLength} columns got: ${e.length}`
                            };
                        }
                        return t.strictColumnHandling && e.length < this.headersLength ? {
                            row: e,
                            isValid: !1,
                            reason: `Column header mismatch expected: ${this.headersLength} columns got: ${e.length}`
                        } : {
                            row: this.mapHeaders(e),
                            isValid: !0
                        };
                    }
                    mapHeaders(e) {
                        const t = {}, { headers: r, headersLength: n } = this;
                        for(let s = 0; s < n; s += 1){
                            const n = r[s];
                            if (!i.default(n)) {
                                const r = e[s];
                                i.default(r) ? t[n] = "" : t[n] = r;
                            }
                        }
                        return t;
                    }
                    setHeaders(e) {
                        var t;
                        const r = e.filter((e)=>!!e);
                        if (o.default(r).length !== r.length) {
                            const e = a.default(r), t = Object.keys(e).filter((t)=>e[t].length > 1);
                            throw new Error("Duplicate headers found " + JSON.stringify(t));
                        }
                        this.headers = e, this.receivedHeaders = !0, this.headersLength = (null === (t = this.headers) || void 0 === t ? void 0 : t.length) || 0;
                    }
                };
            },
            {
                "lodash.groupby": 443,
                "lodash.isfunction": 446,
                "lodash.isundefined": 448,
                "lodash.uniq": 449
            }
        ],
        167: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowTransformerValidator = void 0;
                const i = n(e("lodash.isfunction")), s = e("../types");
                class o {
                    constructor(){
                        this._rowTransform = null, this._rowValidator = null;
                    }
                    static createTransform(e) {
                        return s.isSyncTransform(e) ? (t, r)=>{
                            let n = null;
                            try {
                                n = e(t);
                            } catch (e) {
                                return r(e);
                            }
                            return r(null, n);
                        } : e;
                    }
                    static createValidator(e) {
                        return s.isSyncValidate(e) ? (t, r)=>{
                            r(null, {
                                row: t,
                                isValid: e(t)
                            });
                        } : (t, r)=>{
                            e(t, (e, n, i)=>e ? r(e) : r(null, n ? {
                                    row: t,
                                    isValid: n,
                                    reason: i
                                } : {
                                    row: t,
                                    isValid: !1,
                                    reason: i
                                }));
                        };
                    }
                    set rowTransform(e) {
                        if (!i.default(e)) throw new TypeError("The transform should be a function");
                        this._rowTransform = o.createTransform(e);
                    }
                    set rowValidator(e) {
                        if (!i.default(e)) throw new TypeError("The validate should be a function");
                        this._rowValidator = o.createValidator(e);
                    }
                    transformAndValidate(e, t) {
                        return this.callTransformer(e, (e, r)=>e ? t(e) : r ? this.callValidator(r, (e, n)=>e ? t(e) : n && !n.isValid ? t(null, {
                                    row: r,
                                    isValid: !1,
                                    reason: n.reason
                                }) : t(null, {
                                    row: r,
                                    isValid: !0
                                })) : t(null, {
                                row: null,
                                isValid: !0
                            }));
                    }
                    callTransformer(e, t) {
                        return this._rowTransform ? this._rowTransform(e, t) : t(null, e);
                    }
                    callValidator(e, t) {
                        return this._rowValidator ? this._rowValidator(e, t) : t(null, {
                            row: e,
                            isValid: !0
                        });
                    }
                }
                r.RowTransformerValidator = o;
            },
            {
                "../types": 169,
                "lodash.isfunction": 446
            }
        ],
        168: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.HeaderTransformer = r.RowTransformerValidator = void 0;
                var n = e("./RowTransformerValidator");
                Object.defineProperty(r, "RowTransformerValidator", {
                    enumerable: !0,
                    get: function() {
                        return n.RowTransformerValidator;
                    }
                });
                var i = e("./HeaderTransformer");
                Object.defineProperty(r, "HeaderTransformer", {
                    enumerable: !0,
                    get: function() {
                        return i.HeaderTransformer;
                    }
                });
            },
            {
                "./HeaderTransformer": 166,
                "./RowTransformerValidator": 167
            }
        ],
        169: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.isSyncValidate = r.isSyncTransform = void 0, r.isSyncTransform = (e)=>1 === e.length, r.isSyncValidate = (e)=>1 === e.length;
            },
            {}
        ],
        170: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.bignum = e("bn.js"), n.define = e("./asn1/api").define, n.base = e("./asn1/base"), n.constants = e("./asn1/constants"), n.decoders = e("./asn1/decoders"), n.encoders = e("./asn1/encoders");
            },
            {
                "./asn1/api": 171,
                "./asn1/base": 173,
                "./asn1/constants": 177,
                "./asn1/decoders": 179,
                "./asn1/encoders": 182,
                "bn.js": 184
            }
        ],
        171: [
            function(e, t, r) {
                "use strict";
                const n = e("./encoders"), i = e("./decoders"), s = e("inherits");
                function o(e, t) {
                    this.name = e, this.body = t, this.decoders = {}, this.encoders = {};
                }
                r.define = function(e, t) {
                    return new o(e, t);
                }, o.prototype._createNamed = function(e) {
                    const t = this.name;
                    function r(e) {
                        this._initNamed(e, t);
                    }
                    return s(r, e), r.prototype._initNamed = function(t, r) {
                        e.call(this, t, r);
                    }, new r(this);
                }, o.prototype._getDecoder = function(e) {
                    return e = e || "der", this.decoders.hasOwnProperty(e) || (this.decoders[e] = this._createNamed(i[e])), this.decoders[e];
                }, o.prototype.decode = function(e, t, r) {
                    return this._getDecoder(t).decode(e, r);
                }, o.prototype._getEncoder = function(e) {
                    return e = e || "der", this.encoders.hasOwnProperty(e) || (this.encoders[e] = this._createNamed(n[e])), this.encoders[e];
                }, o.prototype.encode = function(e, t, r) {
                    return this._getEncoder(t).encode(e, r);
                };
            },
            {
                "./decoders": 179,
                "./encoders": 182,
                inherits: 440
            }
        ],
        172: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("../base/reporter").Reporter, s = e("safer-buffer").Buffer;
                function o(e, t) {
                    i.call(this, t), s.isBuffer(e) ? (this.base = e, this.offset = 0, this.length = e.length) : this.error("Input not Buffer");
                }
                function a(e, t) {
                    if (Array.isArray(e)) this.length = 0, this.value = e.map(function(e) {
                        return a.isEncoderBuffer(e) || (e = new a(e, t)), this.length += e.length, e;
                    }, this);
                    else if ("number" == typeof e) {
                        if (!(0 <= e && e <= 255)) return t.error("non-byte EncoderBuffer value");
                        this.value = e, this.length = 1;
                    } else if ("string" == typeof e) this.value = e, this.length = s.byteLength(e);
                    else {
                        if (!s.isBuffer(e)) return t.error("Unsupported type: " + typeof e);
                        this.value = e, this.length = e.length;
                    }
                }
                n(o, i), r.DecoderBuffer = o, o.isDecoderBuffer = function(e) {
                    if (e instanceof o) return !0;
                    return "object" == typeof e && s.isBuffer(e.base) && "DecoderBuffer" === e.constructor.name && "number" == typeof e.offset && "number" == typeof e.length && "function" == typeof e.save && "function" == typeof e.restore && "function" == typeof e.isEmpty && "function" == typeof e.readUInt8 && "function" == typeof e.skip && "function" == typeof e.raw;
                }, o.prototype.save = function() {
                    return {
                        offset: this.offset,
                        reporter: i.prototype.save.call(this)
                    };
                }, o.prototype.restore = function(e) {
                    const t = new o(this.base);
                    return t.offset = e.offset, t.length = this.offset, this.offset = e.offset, i.prototype.restore.call(this, e.reporter), t;
                }, o.prototype.isEmpty = function() {
                    return this.offset === this.length;
                }, o.prototype.readUInt8 = function(e) {
                    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(e || "DecoderBuffer overrun");
                }, o.prototype.skip = function(e, t) {
                    if (!(this.offset + e <= this.length)) return this.error(t || "DecoderBuffer overrun");
                    const r = new o(this.base);
                    return r._reporterState = this._reporterState, r.offset = this.offset, r.length = this.offset + e, this.offset += e, r;
                }, o.prototype.raw = function(e) {
                    return this.base.slice(e ? e.offset : this.offset, this.length);
                }, r.EncoderBuffer = a, a.isEncoderBuffer = function(e) {
                    if (e instanceof a) return !0;
                    return "object" == typeof e && "EncoderBuffer" === e.constructor.name && "number" == typeof e.length && "function" == typeof e.join;
                }, a.prototype.join = function(e, t) {
                    return e || (e = s.alloc(this.length)), t || (t = 0), 0 === this.length || (Array.isArray(this.value) ? this.value.forEach(function(r) {
                        r.join(e, t), t += r.length;
                    }) : ("number" == typeof this.value ? e[t] = this.value : "string" == typeof this.value ? e.write(this.value, t) : s.isBuffer(this.value) && this.value.copy(e, t), t += this.length)), e;
                };
            },
            {
                "../base/reporter": 175,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        173: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.Reporter = e("./reporter").Reporter, n.DecoderBuffer = e("./buffer").DecoderBuffer, n.EncoderBuffer = e("./buffer").EncoderBuffer, n.Node = e("./node");
            },
            {
                "./buffer": 172,
                "./node": 174,
                "./reporter": 175
            }
        ],
        174: [
            function(e, t, r) {
                "use strict";
                const n = e("../base/reporter").Reporter, i = e("../base/buffer").EncoderBuffer, s = e("../base/buffer").DecoderBuffer, o = e("minimalistic-assert"), a = [
                    "seq",
                    "seqof",
                    "set",
                    "setof",
                    "objid",
                    "bool",
                    "gentime",
                    "utctime",
                    "null_",
                    "enum",
                    "int",
                    "objDesc",
                    "bitstr",
                    "bmpstr",
                    "charstr",
                    "genstr",
                    "graphstr",
                    "ia5str",
                    "iso646str",
                    "numstr",
                    "octstr",
                    "printstr",
                    "t61str",
                    "unistr",
                    "utf8str",
                    "videostr"
                ], l = [
                    "key",
                    "obj",
                    "use",
                    "optional",
                    "explicit",
                    "implicit",
                    "def",
                    "choice",
                    "any",
                    "contains"
                ].concat(a);
                function c(e, t, r) {
                    const n = {};
                    this._baseState = n, n.name = r, n.enc = e, n.parent = t || null, n.children = null, n.tag = null, n.args = null, n.reverseArgs = null, n.choice = null, n.optional = !1, n.any = !1, n.obj = !1, n.use = null, n.useDecoder = null, n.key = null, n.default = null, n.explicit = null, n.implicit = null, n.contains = null, n.parent || (n.children = [], this._wrap());
                }
                t.exports = c;
                const u = [
                    "enc",
                    "parent",
                    "children",
                    "tag",
                    "args",
                    "reverseArgs",
                    "choice",
                    "optional",
                    "any",
                    "obj",
                    "use",
                    "alteredUse",
                    "key",
                    "default",
                    "explicit",
                    "implicit",
                    "contains"
                ];
                c.prototype.clone = function() {
                    const e = this._baseState, t = {};
                    u.forEach(function(r) {
                        t[r] = e[r];
                    });
                    const r = new this.constructor(t.parent);
                    return r._baseState = t, r;
                }, c.prototype._wrap = function() {
                    const e = this._baseState;
                    l.forEach(function(t) {
                        this[t] = function() {
                            const r = new this.constructor(this);
                            return e.children.push(r), r[t].apply(r, arguments);
                        };
                    }, this);
                }, c.prototype._init = function(e) {
                    const t = this._baseState;
                    o(null === t.parent), e.call(this), t.children = t.children.filter(function(e) {
                        return e._baseState.parent === this;
                    }, this), o.equal(t.children.length, 1, "Root node can have only one child");
                }, c.prototype._useArgs = function(e) {
                    const t = this._baseState, r = e.filter(function(e) {
                        return e instanceof this.constructor;
                    }, this);
                    e = e.filter(function(e) {
                        return !(e instanceof this.constructor);
                    }, this), 0 !== r.length && (o(null === t.children), t.children = r, r.forEach(function(e) {
                        e._baseState.parent = this;
                    }, this)), 0 !== e.length && (o(null === t.args), t.args = e, t.reverseArgs = e.map(function(e) {
                        if ("object" != typeof e || e.constructor !== Object) return e;
                        const t = {};
                        return Object.keys(e).forEach(function(r) {
                            r == (0 | r) && (r |= 0);
                            const n = e[r];
                            t[n] = r;
                        }), t;
                    }));
                }, [
                    "_peekTag",
                    "_decodeTag",
                    "_use",
                    "_decodeStr",
                    "_decodeObjid",
                    "_decodeTime",
                    "_decodeNull",
                    "_decodeInt",
                    "_decodeBool",
                    "_decodeList",
                    "_encodeComposite",
                    "_encodeStr",
                    "_encodeObjid",
                    "_encodeTime",
                    "_encodeNull",
                    "_encodeInt",
                    "_encodeBool"
                ].forEach(function(e) {
                    c.prototype[e] = function() {
                        const t = this._baseState;
                        throw new Error(e + " not implemented for encoding: " + t.enc);
                    };
                }), a.forEach(function(e) {
                    c.prototype[e] = function() {
                        const t = this._baseState, r = Array.prototype.slice.call(arguments);
                        return o(null === t.tag), t.tag = e, this._useArgs(r), this;
                    };
                }), c.prototype.use = function(e) {
                    o(e);
                    const t = this._baseState;
                    return o(null === t.use), t.use = e, this;
                }, c.prototype.optional = function() {
                    return this._baseState.optional = !0, this;
                }, c.prototype.def = function(e) {
                    const t = this._baseState;
                    return o(null === t.default), t.default = e, t.optional = !0, this;
                }, c.prototype.explicit = function(e) {
                    const t = this._baseState;
                    return o(null === t.explicit && null === t.implicit), t.explicit = e, this;
                }, c.prototype.implicit = function(e) {
                    const t = this._baseState;
                    return o(null === t.explicit && null === t.implicit), t.implicit = e, this;
                }, c.prototype.obj = function() {
                    const e = this._baseState, t = Array.prototype.slice.call(arguments);
                    return e.obj = !0, 0 !== t.length && this._useArgs(t), this;
                }, c.prototype.key = function(e) {
                    const t = this._baseState;
                    return o(null === t.key), t.key = e, this;
                }, c.prototype.any = function() {
                    return this._baseState.any = !0, this;
                }, c.prototype.choice = function(e) {
                    const t = this._baseState;
                    return o(null === t.choice), t.choice = e, this._useArgs(Object.keys(e).map(function(t) {
                        return e[t];
                    })), this;
                }, c.prototype.contains = function(e) {
                    const t = this._baseState;
                    return o(null === t.use), t.contains = e, this;
                }, c.prototype._decode = function(e, t) {
                    const r = this._baseState;
                    if (null === r.parent) return e.wrapResult(r.children[0]._decode(e, t));
                    let n, i = r.default, o = !0, a = null;
                    if (null !== r.key && (a = e.enterKey(r.key)), r.optional) {
                        let n = null;
                        if (null !== r.explicit ? n = r.explicit : null !== r.implicit ? n = r.implicit : null !== r.tag && (n = r.tag), null !== n || r.any) {
                            if (o = this._peekTag(e, n, r.any), e.isError(o)) return o;
                        } else {
                            const n = e.save();
                            try {
                                null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t), o = !0;
                            } catch (e) {
                                o = !1;
                            }
                            e.restore(n);
                        }
                    }
                    if (r.obj && o && (n = e.enterObject()), o) {
                        if (null !== r.explicit) {
                            const t = this._decodeTag(e, r.explicit);
                            if (e.isError(t)) return t;
                            e = t;
                        }
                        const n = e.offset;
                        if (null === r.use && null === r.choice) {
                            let t;
                            r.any && (t = e.save());
                            const n = this._decodeTag(e, null !== r.implicit ? r.implicit : r.tag, r.any);
                            if (e.isError(n)) return n;
                            r.any ? i = e.raw(t) : e = n;
                        }
                        if (t && t.track && null !== r.tag && t.track(e.path(), n, e.length, "tagged"), t && t.track && null !== r.tag && t.track(e.path(), e.offset, e.length, "content"), r.any || (i = null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t)), e.isError(i)) return i;
                        if (r.any || null !== r.choice || null === r.children || r.children.forEach(function(r) {
                            r._decode(e, t);
                        }), r.contains && ("octstr" === r.tag || "bitstr" === r.tag)) {
                            const n = new s(i);
                            i = this._getUse(r.contains, e._reporterState.obj)._decode(n, t);
                        }
                    }
                    return r.obj && o && (i = e.leaveObject(n)), null === r.key || null === i && !0 !== o ? null !== a && e.exitKey(a) : e.leaveKey(a, r.key, i), i;
                }, c.prototype._decodeGeneric = function(e, t, r) {
                    const n = this._baseState;
                    return "seq" === e || "set" === e ? null : "seqof" === e || "setof" === e ? this._decodeList(t, e, n.args[0], r) : /str$/.test(e) ? this._decodeStr(t, e, r) : "objid" === e && n.args ? this._decodeObjid(t, n.args[0], n.args[1], r) : "objid" === e ? this._decodeObjid(t, null, null, r) : "gentime" === e || "utctime" === e ? this._decodeTime(t, e, r) : "null_" === e ? this._decodeNull(t, r) : "bool" === e ? this._decodeBool(t, r) : "objDesc" === e ? this._decodeStr(t, e, r) : "int" === e || "enum" === e ? this._decodeInt(t, n.args && n.args[0], r) : null !== n.use ? this._getUse(n.use, t._reporterState.obj)._decode(t, r) : t.error("unknown tag: " + e);
                }, c.prototype._getUse = function(e, t) {
                    const r = this._baseState;
                    return r.useDecoder = this._use(e, t), o(null === r.useDecoder._baseState.parent), r.useDecoder = r.useDecoder._baseState.children[0], r.implicit !== r.useDecoder._baseState.implicit && (r.useDecoder = r.useDecoder.clone(), r.useDecoder._baseState.implicit = r.implicit), r.useDecoder;
                }, c.prototype._decodeChoice = function(e, t) {
                    const r = this._baseState;
                    let n = null, i = !1;
                    return Object.keys(r.choice).some(function(s) {
                        const o = e.save(), a = r.choice[s];
                        try {
                            const r = a._decode(e, t);
                            if (e.isError(r)) return !1;
                            n = {
                                type: s,
                                value: r
                            }, i = !0;
                        } catch (t) {
                            return e.restore(o), !1;
                        }
                        return !0;
                    }, this), i ? n : e.error("Choice not matched");
                }, c.prototype._createEncoderBuffer = function(e) {
                    return new i(e, this.reporter);
                }, c.prototype._encode = function(e, t, r) {
                    const n = this._baseState;
                    if (null !== n.default && n.default === e) return;
                    const i = this._encodeValue(e, t, r);
                    return void 0 === i || this._skipDefault(i, t, r) ? void 0 : i;
                }, c.prototype._encodeValue = function(e, t, r) {
                    const i = this._baseState;
                    if (null === i.parent) return i.children[0]._encode(e, t || new n);
                    let s = null;
                    if (this.reporter = t, i.optional && void 0 === e) {
                        if (null === i.default) return;
                        e = i.default;
                    }
                    let o = null, a = !1;
                    if (i.any) s = this._createEncoderBuffer(e);
                    else if (i.choice) s = this._encodeChoice(e, t);
                    else if (i.contains) o = this._getUse(i.contains, r)._encode(e, t), a = !0;
                    else if (i.children) o = i.children.map(function(r) {
                        if ("null_" === r._baseState.tag) return r._encode(null, t, e);
                        if (null === r._baseState.key) return t.error("Child should have a key");
                        const n = t.enterKey(r._baseState.key);
                        if ("object" != typeof e) return t.error("Child expected, but input is not object");
                        const i = r._encode(e[r._baseState.key], t, e);
                        return t.leaveKey(n), i;
                    }, this).filter(function(e) {
                        return e;
                    }), o = this._createEncoderBuffer(o);
                    else if ("seqof" === i.tag || "setof" === i.tag) {
                        if (!i.args || 1 !== i.args.length) return t.error("Too many args for : " + i.tag);
                        if (!Array.isArray(e)) return t.error("seqof/setof, but data is not Array");
                        const r = this.clone();
                        r._baseState.implicit = null, o = this._createEncoderBuffer(e.map(function(r) {
                            const n = this._baseState;
                            return this._getUse(n.args[0], e)._encode(r, t);
                        }, r));
                    } else null !== i.use ? s = this._getUse(i.use, r)._encode(e, t) : (o = this._encodePrimitive(i.tag, e), a = !0);
                    if (!i.any && null === i.choice) {
                        const e = null !== i.implicit ? i.implicit : i.tag, r = null === i.implicit ? "universal" : "context";
                        null === e ? null === i.use && t.error("Tag could be omitted only for .use()") : null === i.use && (s = this._encodeComposite(e, a, r, o));
                    }
                    return null !== i.explicit && (s = this._encodeComposite(i.explicit, !1, "context", s)), s;
                }, c.prototype._encodeChoice = function(e, t) {
                    const r = this._baseState, n = r.choice[e.type];
                    return n || o(!1, e.type + " not found in " + JSON.stringify(Object.keys(r.choice))), n._encode(e.value, t);
                }, c.prototype._encodePrimitive = function(e, t) {
                    const r = this._baseState;
                    if (/str$/.test(e)) return this._encodeStr(t, e);
                    if ("objid" === e && r.args) return this._encodeObjid(t, r.reverseArgs[0], r.args[1]);
                    if ("objid" === e) return this._encodeObjid(t, null, null);
                    if ("gentime" === e || "utctime" === e) return this._encodeTime(t, e);
                    if ("null_" === e) return this._encodeNull();
                    if ("int" === e || "enum" === e) return this._encodeInt(t, r.args && r.reverseArgs[0]);
                    if ("bool" === e) return this._encodeBool(t);
                    if ("objDesc" === e) return this._encodeStr(t, e);
                    throw new Error("Unsupported tag: " + e);
                }, c.prototype._isNumstr = function(e) {
                    return /^[0-9 ]*$/.test(e);
                }, c.prototype._isPrintstr = function(e) {
                    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(e);
                };
            },
            {
                "../base/buffer": 172,
                "../base/reporter": 175,
                "minimalistic-assert": 453
            }
        ],
        175: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits");
                function i(e) {
                    this._reporterState = {
                        obj: null,
                        path: [],
                        options: e || {},
                        errors: []
                    };
                }
                function s(e, t) {
                    this.path = e, this.rethrow(t);
                }
                r.Reporter = i, i.prototype.isError = function(e) {
                    return e instanceof s;
                }, i.prototype.save = function() {
                    const e = this._reporterState;
                    return {
                        obj: e.obj,
                        pathLen: e.path.length
                    };
                }, i.prototype.restore = function(e) {
                    const t = this._reporterState;
                    t.obj = e.obj, t.path = t.path.slice(0, e.pathLen);
                }, i.prototype.enterKey = function(e) {
                    return this._reporterState.path.push(e);
                }, i.prototype.exitKey = function(e) {
                    const t = this._reporterState;
                    t.path = t.path.slice(0, e - 1);
                }, i.prototype.leaveKey = function(e, t, r) {
                    const n = this._reporterState;
                    this.exitKey(e), null !== n.obj && (n.obj[t] = r);
                }, i.prototype.path = function() {
                    return this._reporterState.path.join("/");
                }, i.prototype.enterObject = function() {
                    const e = this._reporterState, t = e.obj;
                    return e.obj = {}, t;
                }, i.prototype.leaveObject = function(e) {
                    const t = this._reporterState, r = t.obj;
                    return t.obj = e, r;
                }, i.prototype.error = function(e) {
                    let t;
                    const r = this._reporterState, n = e instanceof s;
                    if (t = n ? e : new s(r.path.map(function(e) {
                        return "[" + JSON.stringify(e) + "]";
                    }).join(""), e.message || e, e.stack), !r.options.partial) throw t;
                    return n || r.errors.push(t), t;
                }, i.prototype.wrapResult = function(e) {
                    const t = this._reporterState;
                    return t.options.partial ? {
                        result: this.isError(e) ? null : e,
                        errors: t.errors
                    } : e;
                }, n(s, Error), s.prototype.rethrow = function(e) {
                    if (this.message = e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, s), !this.stack) try {
                        throw new Error(this.message);
                    } catch (e) {
                        this.stack = e.stack;
                    }
                    return this;
                };
            },
            {
                inherits: 440
            }
        ],
        176: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    const t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        const n = e[r];
                        t[n] = r;
                    }), t;
                }
                r.tagClass = {
                    0: "universal",
                    1: "application",
                    2: "context",
                    3: "private"
                }, r.tagClassByName = n(r.tagClass), r.tag = {
                    0: "end",
                    1: "bool",
                    2: "int",
                    3: "bitstr",
                    4: "octstr",
                    5: "null_",
                    6: "objid",
                    7: "objDesc",
                    8: "external",
                    9: "real",
                    10: "enum",
                    11: "embed",
                    12: "utf8str",
                    13: "relativeOid",
                    16: "seq",
                    17: "set",
                    18: "numstr",
                    19: "printstr",
                    20: "t61str",
                    21: "videostr",
                    22: "ia5str",
                    23: "utctime",
                    24: "gentime",
                    25: "graphstr",
                    26: "iso646str",
                    27: "genstr",
                    28: "unistr",
                    29: "charstr",
                    30: "bmpstr"
                }, r.tagByName = n(r.tag);
            },
            {}
        ],
        177: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n._reverse = function(e) {
                    const t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        const n = e[r];
                        t[n] = r;
                    }), t;
                }, n.der = e("./der");
            },
            {
                "./der": 176
            }
        ],
        178: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("bn.js"), s = e("../base/buffer").DecoderBuffer, o = e("../base/node"), a = e("../constants/der");
                function l(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new c, this.tree._init(e.body);
                }
                function c(e) {
                    o.call(this, "der", e);
                }
                function u(e, t) {
                    let r = e.readUInt8(t);
                    if (e.isError(r)) return r;
                    const n = a.tagClass[r >> 6], i = 0 == (32 & r);
                    if (31 == (31 & r)) {
                        let n = r;
                        for(r = 0; 128 == (128 & n);){
                            if (n = e.readUInt8(t), e.isError(n)) return n;
                            r <<= 7, r |= 127 & n;
                        }
                    } else r &= 31;
                    return {
                        cls: n,
                        primitive: i,
                        tag: r,
                        tagStr: a.tag[r]
                    };
                }
                function h(e, t, r) {
                    let n = e.readUInt8(r);
                    if (e.isError(n)) return n;
                    if (!t && 128 === n) return null;
                    if (0 == (128 & n)) return n;
                    const i = 127 & n;
                    if (i > 4) return e.error("length octect is too long");
                    n = 0;
                    for(let t = 0; t < i; t++){
                        n <<= 8;
                        const t = e.readUInt8(r);
                        if (e.isError(t)) return t;
                        n |= t;
                    }
                    return n;
                }
                t.exports = l, l.prototype.decode = function(e, t) {
                    return s.isDecoderBuffer(e) || (e = new s(e, t)), this.tree._decode(e, t);
                }, n(c, o), c.prototype._peekTag = function(e, t, r) {
                    if (e.isEmpty()) return !1;
                    const n = e.save(), i = u(e, 'Failed to peek tag: "' + t + '"');
                    return e.isError(i) ? i : (e.restore(n), i.tag === t || i.tagStr === t || i.tagStr + "of" === t || r);
                }, c.prototype._decodeTag = function(e, t, r) {
                    const n = u(e, 'Failed to decode tag of "' + t + '"');
                    if (e.isError(n)) return n;
                    let i = h(e, n.primitive, 'Failed to get length of "' + t + '"');
                    if (e.isError(i)) return i;
                    if (!r && n.tag !== t && n.tagStr !== t && n.tagStr + "of" !== t) return e.error('Failed to match tag: "' + t + '"');
                    if (n.primitive || null !== i) return e.skip(i, 'Failed to match body of: "' + t + '"');
                    const s = e.save(), o = this._skipUntilEnd(e, 'Failed to skip indefinite length body: "' + this.tag + '"');
                    return e.isError(o) ? o : (i = e.offset - s.offset, e.restore(s), e.skip(i, 'Failed to match body of: "' + t + '"'));
                }, c.prototype._skipUntilEnd = function(e, t) {
                    for(;;){
                        const r = u(e, t);
                        if (e.isError(r)) return r;
                        const n = h(e, r.primitive, t);
                        if (e.isError(n)) return n;
                        let i;
                        if (i = r.primitive || null !== n ? e.skip(n) : this._skipUntilEnd(e, t), e.isError(i)) return i;
                        if ("end" === r.tagStr) break;
                    }
                }, c.prototype._decodeList = function(e, t, r, n) {
                    const i = [];
                    for(; !e.isEmpty();){
                        const t = this._peekTag(e, "end");
                        if (e.isError(t)) return t;
                        const s = r.decode(e, "der", n);
                        if (e.isError(s) && t) break;
                        i.push(s);
                    }
                    return i;
                }, c.prototype._decodeStr = function(e, t) {
                    if ("bitstr" === t) {
                        const t = e.readUInt8();
                        return e.isError(t) ? t : {
                            unused: t,
                            data: e.raw()
                        };
                    }
                    if ("bmpstr" === t) {
                        const t = e.raw();
                        if (t.length % 2 == 1) return e.error("Decoding of string type: bmpstr length mismatch");
                        let r = "";
                        for(let e = 0; e < t.length / 2; e++)r += String.fromCharCode(t.readUInt16BE(2 * e));
                        return r;
                    }
                    if ("numstr" === t) {
                        const t = e.raw().toString("ascii");
                        return this._isNumstr(t) ? t : e.error("Decoding of string type: numstr unsupported characters");
                    }
                    if ("octstr" === t) return e.raw();
                    if ("objDesc" === t) return e.raw();
                    if ("printstr" === t) {
                        const t = e.raw().toString("ascii");
                        return this._isPrintstr(t) ? t : e.error("Decoding of string type: printstr unsupported characters");
                    }
                    return /str$/.test(t) ? e.raw().toString() : e.error("Decoding of string type: " + t + " unsupported");
                }, c.prototype._decodeObjid = function(e, t, r) {
                    let n;
                    const i = [];
                    let s = 0, o = 0;
                    for(; !e.isEmpty();)o = e.readUInt8(), s <<= 7, s |= 127 & o, 0 == (128 & o) && (i.push(s), s = 0);
                    128 & o && i.push(s);
                    const a = i[0] / 40 | 0, l = i[0] % 40;
                    if (n = r ? i : [
                        a,
                        l
                    ].concat(i.slice(1)), t) {
                        let e = t[n.join(" ")];
                        void 0 === e && (e = t[n.join(".")]), void 0 !== e && (n = e);
                    }
                    return n;
                }, c.prototype._decodeTime = function(e, t) {
                    const r = e.raw().toString();
                    let n, i, s, o, a, l;
                    if ("gentime" === t) n = 0 | r.slice(0, 4), i = 0 | r.slice(4, 6), s = 0 | r.slice(6, 8), o = 0 | r.slice(8, 10), a = 0 | r.slice(10, 12), l = 0 | r.slice(12, 14);
                    else {
                        if ("utctime" !== t) return e.error("Decoding " + t + " time is not supported yet");
                        n = 0 | r.slice(0, 2), i = 0 | r.slice(2, 4), s = 0 | r.slice(4, 6), o = 0 | r.slice(6, 8), a = 0 | r.slice(8, 10), l = 0 | r.slice(10, 12), n = n < 70 ? 2e3 + n : 1900 + n;
                    }
                    return Date.UTC(n, i - 1, s, o, a, l, 0);
                }, c.prototype._decodeNull = function() {
                    return null;
                }, c.prototype._decodeBool = function(e) {
                    const t = e.readUInt8();
                    return e.isError(t) ? t : 0 !== t;
                }, c.prototype._decodeInt = function(e, t) {
                    const r = e.raw();
                    let n = new i(r);
                    return t && (n = t[n.toString(10)] || n), n;
                }, c.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getDecoder("der").tree;
                };
            },
            {
                "../base/buffer": 172,
                "../base/node": 174,
                "../constants/der": 176,
                "bn.js": 184,
                inherits: 440
            }
        ],
        179: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.der = e("./der"), n.pem = e("./pem");
            },
            {
                "./der": 178,
                "./pem": 180
            }
        ],
        180: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("safer-buffer").Buffer, s = e("./der");
                function o(e) {
                    s.call(this, e), this.enc = "pem";
                }
                n(o, s), t.exports = o, o.prototype.decode = function(e, t) {
                    const r = e.toString().split(/[\r\n]+/g), n = t.label.toUpperCase(), o = /^-----(BEGIN|END) ([^-]+)-----$/;
                    let a = -1, l = -1;
                    for(let e = 0; e < r.length; e++){
                        const t = r[e].match(o);
                        if (null !== t && t[2] === n) {
                            if (-1 !== a) {
                                if ("END" !== t[1]) break;
                                l = e;
                                break;
                            }
                            if ("BEGIN" !== t[1]) break;
                            a = e;
                        }
                    }
                    if (-1 === a || -1 === l) throw new Error("PEM section not found for: " + n);
                    const c = r.slice(a + 1, l).join("");
                    c.replace(/[^a-z0-9+/=]+/gi, "");
                    const u = i.from(c, "base64");
                    return s.prototype.decode.call(this, u, t);
                };
            },
            {
                "./der": 178,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        181: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("safer-buffer").Buffer, s = e("../base/node"), o = e("../constants/der");
                function a(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new l, this.tree._init(e.body);
                }
                function l(e) {
                    s.call(this, "der", e);
                }
                function c(e) {
                    return e < 10 ? "0" + e : e;
                }
                t.exports = a, a.prototype.encode = function(e, t) {
                    return this.tree._encode(e, t).join();
                }, n(l, s), l.prototype._encodeComposite = function(e, t, r, n) {
                    const s = function(e, t, r, n) {
                        let i;
                        "seqof" === e ? e = "seq" : "setof" === e && (e = "set");
                        if (o.tagByName.hasOwnProperty(e)) i = o.tagByName[e];
                        else {
                            if ("number" != typeof e || (0 | e) !== e) return n.error("Unknown tag: " + e);
                            i = e;
                        }
                        if (i >= 31) return n.error("Multi-octet tag encoding unsupported");
                        t || (i |= 32);
                        return i |= o.tagClassByName[r || "universal"] << 6, i;
                    }(e, t, r, this.reporter);
                    if (n.length < 128) {
                        const e = i.alloc(2);
                        return e[0] = s, e[1] = n.length, this._createEncoderBuffer([
                            e,
                            n
                        ]);
                    }
                    let a = 1;
                    for(let e = n.length; e >= 256; e >>= 8)a++;
                    const l = i.alloc(2 + a);
                    l[0] = s, l[1] = 128 | a;
                    for(let e = 1 + a, t = n.length; t > 0; e--, t >>= 8)l[e] = 255 & t;
                    return this._createEncoderBuffer([
                        l,
                        n
                    ]);
                }, l.prototype._encodeStr = function(e, t) {
                    if ("bitstr" === t) return this._createEncoderBuffer([
                        0 | e.unused,
                        e.data
                    ]);
                    if ("bmpstr" === t) {
                        const t = i.alloc(2 * e.length);
                        for(let r = 0; r < e.length; r++)t.writeUInt16BE(e.charCodeAt(r), 2 * r);
                        return this._createEncoderBuffer(t);
                    }
                    return "numstr" === t ? this._isNumstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : "printstr" === t ? this._isPrintstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(t) || "objDesc" === t ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: " + t + " unsupported");
                }, l.prototype._encodeObjid = function(e, t, r) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("string objid given, but no values map found");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("objid not found in values map");
                        e = t[e].split(/[\s.]+/g);
                        for(let t = 0; t < e.length; t++)e[t] |= 0;
                    } else if (Array.isArray(e)) {
                        e = e.slice();
                        for(let t = 0; t < e.length; t++)e[t] |= 0;
                    }
                    if (!Array.isArray(e)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(e));
                    if (!r) {
                        if (e[1] >= 40) return this.reporter.error("Second objid identifier OOB");
                        e.splice(0, 2, 40 * e[0] + e[1]);
                    }
                    let n = 0;
                    for(let t = 0; t < e.length; t++){
                        let r = e[t];
                        for(n++; r >= 128; r >>= 7)n++;
                    }
                    const s = i.alloc(n);
                    let o = s.length - 1;
                    for(let t = e.length - 1; t >= 0; t--){
                        let r = e[t];
                        for(s[o--] = 127 & r; (r >>= 7) > 0;)s[o--] = 128 | 127 & r;
                    }
                    return this._createEncoderBuffer(s);
                }, l.prototype._encodeTime = function(e, t) {
                    let r;
                    const n = new Date(e);
                    return "gentime" === t ? r = [
                        c(n.getUTCFullYear()),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : "utctime" === t ? r = [
                        c(n.getUTCFullYear() % 100),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : this.reporter.error("Encoding " + t + " time is not supported yet"), this._encodeStr(r, "octstr");
                }, l.prototype._encodeNull = function() {
                    return this._createEncoderBuffer("");
                }, l.prototype._encodeInt = function(e, t) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("String int or enum given, but no values map");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(e));
                        e = t[e];
                    }
                    if ("number" != typeof e && !i.isBuffer(e)) {
                        const t = e.toArray();
                        !e.sign && 128 & t[0] && t.unshift(0), e = i.from(t);
                    }
                    if (i.isBuffer(e)) {
                        let t = e.length;
                        0 === e.length && t++;
                        const r = i.alloc(t);
                        return e.copy(r), 0 === e.length && (r[0] = 0), this._createEncoderBuffer(r);
                    }
                    if (e < 128) return this._createEncoderBuffer(e);
                    if (e < 256) return this._createEncoderBuffer([
                        0,
                        e
                    ]);
                    let r = 1;
                    for(let t = e; t >= 256; t >>= 8)r++;
                    const n = new Array(r);
                    for(let t = n.length - 1; t >= 0; t--)n[t] = 255 & e, e >>= 8;
                    return 128 & n[0] && n.unshift(0), this._createEncoderBuffer(i.from(n));
                }, l.prototype._encodeBool = function(e) {
                    return this._createEncoderBuffer(e ? 255 : 0);
                }, l.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getEncoder("der").tree;
                }, l.prototype._skipDefault = function(e, t, r) {
                    const n = this._baseState;
                    let i;
                    if (null === n.default) return !1;
                    const s = e.join();
                    if (void 0 === n.defaultBuffer && (n.defaultBuffer = this._encodeValue(n.default, t, r).join()), s.length !== n.defaultBuffer.length) return !1;
                    for(i = 0; i < s.length; i++)if (s[i] !== n.defaultBuffer[i]) return !1;
                    return !0;
                };
            },
            {
                "../base/node": 174,
                "../constants/der": 176,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        182: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.der = e("./der"), n.pem = e("./pem");
            },
            {
                "./der": 181,
                "./pem": 183
            }
        ],
        183: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("./der");
                function s(e) {
                    i.call(this, e), this.enc = "pem";
                }
                n(s, i), t.exports = s, s.prototype.encode = function(e, t) {
                    const r = i.prototype.encode.call(this, e).toString("base64"), n = [
                        "-----BEGIN " + t.label + "-----"
                    ];
                    for(let e = 0; e < r.length; e += 64)n.push(r.slice(e, e + 64));
                    return n.push("-----END " + t.label + "-----"), n.join("\n");
                };
            },
            {
                "./der": 181,
                inherits: 440
            }
        ],
        184: [
            function(e, t, r) {
                "use strict";
                !function(t, r) {
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function s(e, t, r) {
                        if (s.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var o;
                    "object" == typeof t ? t.exports = s : (void 0).BN = s, s.BN = s, s.wordSize = 26;
                    try {
                        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : e("buffer").Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : r - 48 & 15;
                    }
                    function l(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, n) {
                        for(var i = 0, s = Math.min(e.length, r), o = t; o < s; o++){
                            var a = e.charCodeAt(o) - 48;
                            i *= n, i += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
                        }
                        return i;
                    }
                    s.isBN = function(e) {
                        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
                    }, s.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, s.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, s.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, s.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, s.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var s, o, a = 0;
                        if ("be" === r) for(i = e.length - 1, s = 0; i >= 0; i -= 3)o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        else if ("le" === r) for(i = 0, s = 0; i < e.length; i += 3)o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        return this.strip();
                    }, s.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, s = 0, o = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        this.strip();
                    }, s.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, l = 0, u = r; u < a; u += n)l = c(e, u, u + n, t), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        if (0 !== o) {
                            var h = 1;
                            for(l = c(e, u, e.length, t), u = 0; u < o; u++)h *= t;
                            this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        }
                        this.strip();
                    }, s.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, s.prototype.clone = function() {
                        var e = new s(null);
                        return this.copy(e), e;
                    }, s.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, s.prototype.strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, s.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, s.prototype.inspect = function() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    };
                    var u = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], h = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], f = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    function d(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], s = 0 | t.words[0], o = i * s, a = 67108863 & o, l = o / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, t.length - 1), d = Math.max(0, c - e.length + 1); d <= f; d++){
                                var p = c - d | 0;
                                u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[d]) + h) / 67108864 | 0, h = 67108863 & o;
                            }
                            r.words[c] = 0 | h, l = 0 | u;
                        }
                        return 0 !== l ? r.words[c] = 0 | l : r.length--, r.strip();
                    }
                    s.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, s = 0, o = 0; o < this.length; o++){
                                var a = this.words[o], l = (16777215 & (a << i | s)).toString(16);
                                r = 0 !== (s = a >>> 24 - i & 16777215) || o !== this.length - 1 ? u[6 - l.length] + l + r : l + r, (i += 2) >= 26 && (i -= 26, o--);
                            }
                            for(0 !== s && (r = s.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = h[e], d = f[e];
                            r = "";
                            var p = this.clone();
                            for(p.negative = 0; !p.isZero();){
                                var m = p.modn(d).toString(e);
                                r = (p = p.idivn(d)).isZero() ? m + r : u[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, s.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, s.prototype.toJSON = function() {
                        return this.toString(16);
                    }, s.prototype.toBuffer = function(e, t) {
                        return n(void 0 !== o), this.toArrayLike(o, e, t);
                    }, s.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    }, s.prototype.toArrayLike = function(e, t, r) {
                        var i = this.byteLength(), s = r || Math.max(1, i);
                        n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0"), this.strip();
                        var o, a, l = "le" === t, c = new e(s), u = this.clone();
                        if (l) {
                            for(a = 0; !u.isZero(); a++)o = u.andln(255), u.iushrn(8), c[a] = o;
                            for(; a < s; a++)c[a] = 0;
                        } else {
                            for(a = 0; a < s - i; a++)c[a] = 0;
                            for(a = 0; !u.isZero(); a++)o = u.andln(255), u.iushrn(8), c[s - a - 1] = o;
                        }
                        return c;
                    }, Math.clz32 ? s.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : s.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, s.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, s.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, s.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, s.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, s.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, s.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, s.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, s.prototype.neg = function() {
                        return this.clone().ineg();
                    }, s.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, s.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this.strip();
                    }, s.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, s.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, s.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, s.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this.strip();
                    }, s.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, s.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, s.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, s.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this.strip();
                    }, s.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, s.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, s.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, s.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
                    }, s.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, s.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
                    }, s.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, s = 0; s < n.length; s++)t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && s < r.length; s++)t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this;
                    }, s.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, s.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var s = 0, o = 0; o < n.length; o++)s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        for(; 0 !== s && o < r.length; o++)s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        if (0 === s && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this.strip();
                    }, s.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var p = function(e, t, r) {
                        var n, i, s, o = e.words, a = t.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, d = 0 | o[1], p = 8191 & d, m = d >>> 13, b = 0 | o[2], g = 8191 & b, y = b >>> 13, v = 0 | o[3], w = 8191 & v, _ = v >>> 13, x = 0 | o[4], k = 8191 & x, S = x >>> 13, M = 0 | o[5], C = 8191 & M, T = M >>> 13, E = 0 | o[6], A = 8191 & E, R = E >>> 13, O = 0 | o[7], j = 8191 & O, I = O >>> 13, N = 0 | o[8], P = 8191 & N, B = N >>> 13, D = 0 | o[9], F = 8191 & D, L = D >>> 13, z = 0 | a[0], U = 8191 & z, $ = z >>> 13, H = 0 | a[1], V = 8191 & H, q = H >>> 13, W = 0 | a[2], X = 8191 & W, K = W >>> 13, Y = 0 | a[3], Z = 8191 & Y, G = Y >>> 13, J = 0 | a[4], Q = 8191 & J, ee = J >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], se = 8191 & ie, oe = ie >>> 13, ae = 0 | a[7], le = 8191 & ae, ce = ae >>> 13, ue = 0 | a[8], he = 8191 & ue, fe = ue >>> 13, de = 0 | a[9], pe = 8191 & de, me = de >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var be = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, $)) + Math.imul(f, U) | 0)) << 13) | 0;
                        c = ((s = Math.imul(f, $)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, $)) + Math.imul(m, U) | 0, s = Math.imul(m, $);
                        var ge = (c + (n = n + Math.imul(h, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, q) | 0) + Math.imul(f, V) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, q) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, U), i = (i = Math.imul(g, $)) + Math.imul(y, U) | 0, s = Math.imul(y, $), n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, V) | 0, s = s + Math.imul(m, q) | 0;
                        var ye = (c + (n = n + Math.imul(h, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(w, U), i = (i = Math.imul(w, $)) + Math.imul(_, U) | 0, s = Math.imul(_, $), n = n + Math.imul(g, V) | 0, i = (i = i + Math.imul(g, q) | 0) + Math.imul(y, V) | 0, s = s + Math.imul(y, q) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, X) | 0, s = s + Math.imul(m, K) | 0;
                        var ve = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(k, U), i = (i = Math.imul(k, $)) + Math.imul(S, U) | 0, s = Math.imul(S, $), n = n + Math.imul(w, V) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(_, V) | 0, s = s + Math.imul(_, q) | 0, n = n + Math.imul(g, X) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(y, X) | 0, s = s + Math.imul(y, K) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(m, Z) | 0, s = s + Math.imul(m, G) | 0;
                        var we = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, $)) + Math.imul(T, U) | 0, s = Math.imul(T, $), n = n + Math.imul(k, V) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(S, V) | 0, s = s + Math.imul(S, q) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(_, X) | 0, s = s + Math.imul(_, K) | 0, n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, G) | 0) + Math.imul(y, Z) | 0, s = s + Math.imul(y, G) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, s = s + Math.imul(m, ee) | 0;
                        var _e = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(f, re) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ne) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, $)) + Math.imul(R, U) | 0, s = Math.imul(R, $), n = n + Math.imul(C, V) | 0, i = (i = i + Math.imul(C, q) | 0) + Math.imul(T, V) | 0, s = s + Math.imul(T, q) | 0, n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(S, X) | 0, s = s + Math.imul(S, K) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, G) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(y, Q) | 0, s = s + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, s = s + Math.imul(m, ne) | 0;
                        var xe = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, oe) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(j, U), i = (i = Math.imul(j, $)) + Math.imul(I, U) | 0, s = Math.imul(I, $), n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, q) | 0) + Math.imul(R, V) | 0, s = s + Math.imul(R, q) | 0, n = n + Math.imul(C, X) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, X) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, G) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(_, Q) | 0, s = s + Math.imul(_, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(y, re) | 0, s = s + Math.imul(y, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(m, se) | 0, s = s + Math.imul(m, oe) | 0;
                        var ke = (c + (n = n + Math.imul(h, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(f, le) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, $)) + Math.imul(B, U) | 0, s = Math.imul(B, $), n = n + Math.imul(j, V) | 0, i = (i = i + Math.imul(j, q) | 0) + Math.imul(I, V) | 0, s = s + Math.imul(I, q) | 0, n = n + Math.imul(A, X) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(R, X) | 0, s = s + Math.imul(R, K) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, G) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(_, re) | 0, s = s + Math.imul(_, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(y, se) | 0, s = s + Math.imul(y, oe) | 0, n = n + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, le) | 0, s = s + Math.imul(m, ce) | 0;
                        var Se = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, fe) | 0) + Math.imul(f, he) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(F, U), i = (i = Math.imul(F, $)) + Math.imul(L, U) | 0, s = Math.imul(L, $), n = n + Math.imul(P, V) | 0, i = (i = i + Math.imul(P, q) | 0) + Math.imul(B, V) | 0, s = s + Math.imul(B, q) | 0, n = n + Math.imul(j, X) | 0, i = (i = i + Math.imul(j, K) | 0) + Math.imul(I, X) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(R, Z) | 0, s = s + Math.imul(R, G) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(S, re) | 0, s = s + Math.imul(S, ne) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, oe) | 0) + Math.imul(_, se) | 0, s = s + Math.imul(_, oe) | 0, n = n + Math.imul(g, le) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(y, le) | 0, s = s + Math.imul(y, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, he) | 0, s = s + Math.imul(m, fe) | 0;
                        var Me = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(F, V), i = (i = Math.imul(F, q)) + Math.imul(L, V) | 0, s = Math.imul(L, q), n = n + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, K) | 0) + Math.imul(B, X) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, G) | 0, n = n + Math.imul(A, Q) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(R, Q) | 0, s = s + Math.imul(R, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, n = n + Math.imul(w, le) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(_, le) | 0, s = s + Math.imul(_, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(y, he) | 0, s = s + Math.imul(y, fe) | 0;
                        var Ce = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(F, X), i = (i = Math.imul(F, K)) + Math.imul(L, X) | 0, s = Math.imul(L, K), n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, G) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(R, re) | 0, s = s + Math.imul(R, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(S, le) | 0, s = s + Math.imul(S, ce) | 0, n = n + Math.imul(w, he) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(_, he) | 0, s = s + Math.imul(_, fe) | 0;
                        var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(F, Z), i = (i = Math.imul(F, G)) + Math.imul(L, Z) | 0, s = Math.imul(L, G), n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(A, se) | 0, i = (i = i + Math.imul(A, oe) | 0) + Math.imul(R, se) | 0, s = s + Math.imul(R, oe) | 0, n = n + Math.imul(C, le) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(T, le) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(k, he) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(S, he) | 0, s = s + Math.imul(S, fe) | 0;
                        var Ee = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(_, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(_, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(F, Q), i = (i = Math.imul(F, ee)) + Math.imul(L, Q) | 0, s = Math.imul(L, ee), n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(j, se) | 0, i = (i = i + Math.imul(j, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(A, le) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(R, le) | 0, s = s + Math.imul(R, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, fe) | 0;
                        var Ae = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(F, re), i = (i = Math.imul(F, ne)) + Math.imul(L, re) | 0, s = Math.imul(L, ne), n = n + Math.imul(P, se) | 0, i = (i = i + Math.imul(P, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(j, le) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(I, le) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(A, he) | 0, i = (i = i + Math.imul(A, fe) | 0) + Math.imul(R, he) | 0, s = s + Math.imul(R, fe) | 0;
                        var Re = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(F, se), i = (i = Math.imul(F, oe)) + Math.imul(L, se) | 0, s = Math.imul(L, oe), n = n + Math.imul(P, le) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(B, le) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(j, he) | 0, i = (i = i + Math.imul(j, fe) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, fe) | 0;
                        var Oe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, me) | 0) + Math.imul(R, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(R, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(F, le), i = (i = Math.imul(F, ce)) + Math.imul(L, le) | 0, s = Math.imul(L, ce), n = n + Math.imul(P, he) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, fe) | 0;
                        var je = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(F, he), i = (i = Math.imul(F, fe)) + Math.imul(L, he) | 0, s = Math.imul(L, fe);
                        var Ie = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(B, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                        var Ne = (c + (n = Math.imul(F, pe)) | 0) + ((8191 & (i = (i = Math.imul(F, me)) + Math.imul(L, pe) | 0)) << 13) | 0;
                        return c = ((s = Math.imul(L, me)) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l[0] = be, l[1] = ge, l[2] = ye, l[3] = ve, l[4] = we, l[5] = _e, l[6] = xe, l[7] = ke, l[8] = Se, l[9] = Me, l[10] = Ce, l[11] = Te, l[12] = Ee, l[13] = Ae, l[14] = Re, l[15] = Oe, l[16] = je, l[17] = Ie, l[18] = Ne, 0 !== c && (l[19] = c, r.length++), r;
                    };
                    function m(e, t, r) {
                        return (new b).mulp(e, t, r);
                    }
                    function b(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (p = d), s.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? p(this, e, t) : r < 63 ? d(this, e, t) : r < 1024 ? function(e, t, r) {
                            r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                            for(var n = 0, i = 0, s = 0; s < r.length - 1; s++){
                                var o = i;
                                i = 0;
                                for(var a = 67108863 & n, l = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= l; c++){
                                    var u = s - c, h = (0 | e.words[u]) * (0 | t.words[c]), f = 67108863 & h;
                                    a = 67108863 & (f = f + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                                }
                                r.words[s] = a, n = o, o = i;
                            }
                            return 0 !== n ? r.words[s] = n : r.length--, r.strip();
                        }(this, e, t) : m(this, e, t);
                    }, b.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, b.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, b.prototype.permute = function(e, t, r, n, i, s) {
                        for(var o = 0; o < s; o++)n[o] = t[e[o]], i[o] = r[e[o]];
                    }, b.prototype.transform = function(e, t, r, n, i, s) {
                        this.permute(s, e, t, r, n, i);
                        for(var o = 1; o < i; o <<= 1)for(var a = o << 1, l = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a)for(var h = l, f = c, d = 0; d < o; d++){
                            var p = r[u + d], m = n[u + d], b = r[u + d + o], g = n[u + d + o], y = h * b - f * g;
                            g = h * g + f * b, b = y, r[u + d] = p + b, n[u + d] = m + g, r[u + d + o] = p - b, n[u + d + o] = m - g, d !== a && (y = l * h - c * f, f = l * f + c * h, h = y);
                        }
                    }, b.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, b.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, b.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, b.prototype.convert13b = function(e, t, r, i) {
                        for(var s = 0, o = 0; o < t; o++)s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
                        for(o = 2 * t; o < i; ++o)r[o] = 0;
                        n(0 === s), n(0 == (-8192 & s));
                    }, b.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, b.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), s = this.stub(n), o = new Array(n), a = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                        f.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, l, n, i), this.transform(c, s, u, h, n, i);
                        for(var d = 0; d < n; d++){
                            var p = a[d] * u[d] - l[d] * h[d];
                            l[d] = a[d] * h[d] + l[d] * u[d], a[d] = p;
                        }
                        return this.conjugate(a, l, n), this.transform(a, l, f, s, n, i), this.conjugate(f, s, n), this.normalize13b(f, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r.strip();
                    }, s.prototype.mul = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, s.prototype.mulf = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), m(this, e, t);
                    }, s.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, s.prototype.imuln = function(e) {
                        n("number" == typeof e), n(e < 67108864);
                        for(var t = 0, r = 0; r < this.length; r++){
                            var i = (0 | this.words[r]) * e, s = (67108863 & i) + (67108863 & t);
                            t >>= 26, t += i / 67108864 | 0, t += s >>> 26, this.words[r] = 67108863 & s;
                        }
                        return 0 !== t && (this.words[r] = t, this.length++), this;
                    }, s.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, s.prototype.sqr = function() {
                        return this.mul(this);
                    }, s.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, s.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = (e.words[n] & 1 << i) >>> i;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new s(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, s.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, s = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var o = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & s, l = (0 | this.words[t]) - a << r;
                                this.words[t] = l | o, o = a >>> 26 - r;
                            }
                            o && (this.words[t] = o, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this.strip();
                    }, s.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, s.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var s = e % 26, o = Math.min((e - s) / 26, this.length), a = 67108863 ^ 67108863 >>> s << s, l = r;
                        if (i -= o, i = Math.max(0, i), l) {
                            for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                            l.length = o;
                        }
                        if (0 === o) ;
                        else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                        else this.words[0] = 0, this.length = 1;
                        var u = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                            var h = 0 | this.words[c];
                            this.words[c] = u << 26 - s | h >>> s, u = h & a;
                        }
                        return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
                    }, s.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, s.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, s.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, s.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, s.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, s.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r) && !!(this.words[r] & i);
                    }, s.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this.strip();
                    }, s.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, s.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, s.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, s.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this.strip();
                    }, s.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, s.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, s.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, s.prototype.abs = function() {
                        return this.clone().iabs();
                    }, s.prototype._ishlnsubmul = function(e, t, r) {
                        var i, s, o = e.length + r;
                        this._expand(o);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            s = (0 | this.words[i + r]) + a;
                            var l = (0 | e.words[i]) * t;
                            a = ((s -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & s;
                        }
                        for(; i < this.length - r; i++)a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
                        if (0 === a) return this.strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
                        return this.negative = 1, this.strip();
                    }, s.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var a, l = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new s(null)).length = l + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var u = n.clone()._ishlnsubmul(i, 1, l);
                        0 === u.negative && (n = u, a && (a.words[l] = 1));
                        for(var h = l - 1; h >= 0; h--){
                            var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                            for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                            a && (a.words[h] = f);
                        }
                        return a && a.strip(), n.strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, s.prototype.divmod = function(e, t, r) {
                        var i, o, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new s(0),
                            mod: new s(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: i,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: a.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new s(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new s(this.modn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new s(this.modn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, s.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, s.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, s.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, s.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), s = r.cmp(n);
                        return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, s.prototype.modn = function(e) {
                        n(e <= 67108863);
                        for(var t = 67108864 % e, r = 0, i = this.length - 1; i >= 0; i--)r = (t * r + (0 | this.words[i])) % e;
                        return r;
                    }, s.prototype.idivn = function(e) {
                        n(e <= 67108863);
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var i = (0 | this.words[r]) + 67108864 * t;
                            this.words[r] = i / e | 0, t = i % e;
                        }
                        return this.strip();
                    }, s.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, s.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new s(1), o = new s(0), a = new s(0), l = new s(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var u = r.clone(), h = t.clone(); !t.isZero();){
                            for(var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1);
                            if (f > 0) for(t.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || l.isOdd()) && (a.iadd(u), l.isub(h)), a.iushrn(1), l.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(l)) : (r.isub(t), a.isub(i), l.isub(o));
                        }
                        return {
                            a: a,
                            b: l,
                            gcd: r.iushln(c)
                        };
                    }, s.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, o = new s(1), a = new s(0), l = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                            for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(r.iushrn(h); h-- > 0;)a.isOdd() && a.iadd(l), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
                        }
                        return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, s.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var s = t;
                                t = r, r = s;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, s.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, s.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, s.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, s.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, s.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var s = i, o = r; 0 !== s && o < this.length; o++){
                            var a = 0 | this.words[o];
                            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
                        }
                        return 0 !== s && (this.words[o] = s, this.length++), this;
                    }, s.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, s.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this.strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, s.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, s.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, s.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, s.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, s.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, s.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, s.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, s.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, s.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, s.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, s.red = function(e) {
                        return new k(e);
                    }, s.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, s.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, s.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, s.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, s.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, s.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, s.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, s.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, s.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, s.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, s.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, s.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, s.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, s.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, s.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, s.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, s.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var g = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function y(e, t) {
                        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function v() {
                        y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function w() {
                        y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function _() {
                        y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function x() {
                        y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function k(e) {
                        if ("string" == typeof e) {
                            var t = s._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function S(e) {
                        k.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    y.prototype._tmp = function() {
                        var e = new s(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, y.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, y.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, y.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(v, y), v.prototype.split = function(e, t) {
                        for(var r = Math.min(e.length, 9), n = 0; n < r; n++)t.words[n] = e.words[n];
                        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var i = e.words[9];
                        for(t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++){
                            var s = 0 | e.words[n];
                            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
                        }
                        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, v.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(w, y), i(_, y), i(x, y), x.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, s._prime = function(e) {
                        if (g[e]) return g[e];
                        var t;
                        if ("k256" === e) t = new v;
                        else if ("p224" === e) t = new w;
                        else if ("p192" === e) t = new _;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new x;
                        }
                        return g[e] = t, t;
                    }, k.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, k.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, k.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
                    }, k.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, k.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, k.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, k.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, k.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, k.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, k.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, k.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, k.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, k.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, k.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new s(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new s(1).toRed(this), l = a.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                        for(u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                        for(var h = this.pow(u, i), f = this.pow(e, i.addn(1).iushrn(1)), d = this.pow(e, i), p = o; 0 !== d.cmp(a);){
                            for(var m = d, b = 0; 0 !== m.cmp(a); b++)m = m.redSqr();
                            n(b < p);
                            var g = this.pow(h, new s(1).iushln(p - b - 1));
                            f = f.redMul(g), h = g.redSqr(), d = d.redMul(h), p = b;
                        }
                        return f;
                    }, k.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, k.prototype.pow = function(e, t) {
                        if (t.isZero()) return new s(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new s(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, a = 0, l = t.bitLength() % 26;
                        for(0 === l && (l = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], u = l - 1; u >= 0; u--){
                                var h = c >> u & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
                            }
                            l = 26;
                        }
                        return i;
                    }, k.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, k.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, s.mont = function(e) {
                        return new S(e);
                    }, i(S, k), S.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, S.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, S.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, S.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, S.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(void 0 === t || t);
            },
            {
                buffer: 188
            }
        ],
        185: [
            function(e, t, r) {
                "use strict";
                r.byteLength = function(e) {
                    var t = c(e), r = t[0], n = t[1];
                    return 3 * (r + n) / 4 - n;
                }, r.toByteArray = function(e) {
                    var t, r, n = c(e), o = n[0], a = n[1], l = new s(function(e, t, r) {
                        return 3 * (t + r) / 4 - r;
                    }(0, o, a)), u = 0, h = a > 0 ? o - 4 : o;
                    for(r = 0; r < h; r += 4)t = i[e.charCodeAt(r)] << 18 | i[e.charCodeAt(r + 1)] << 12 | i[e.charCodeAt(r + 2)] << 6 | i[e.charCodeAt(r + 3)], l[u++] = t >> 16 & 255, l[u++] = t >> 8 & 255, l[u++] = 255 & t;
                    2 === a && (t = i[e.charCodeAt(r)] << 2 | i[e.charCodeAt(r + 1)] >> 4, l[u++] = 255 & t);
                    1 === a && (t = i[e.charCodeAt(r)] << 10 | i[e.charCodeAt(r + 1)] << 4 | i[e.charCodeAt(r + 2)] >> 2, l[u++] = t >> 8 & 255, l[u++] = 255 & t);
                    return l;
                }, r.fromByteArray = function(e) {
                    for(var t, r = e.length, i = r % 3, s = [], o = 0, a = r - i; o < a; o += 16383)s.push(u(e, o, o + 16383 > a ? a : o + 16383));
                    1 === i ? (t = e[r - 1], s.push(n[t >> 2] + n[t << 4 & 63] + "==")) : 2 === i && (t = (e[r - 2] << 8) + e[r - 1], s.push(n[t >> 10] + n[t >> 4 & 63] + n[t << 2 & 63] + "="));
                    return s.join("");
                };
                for(var n = [], i = [], s = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, l = o.length; a < l; ++a)n[a] = o[a], i[o.charCodeAt(a)] = a;
                function c(e) {
                    var t = e.length;
                    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    var r = e.indexOf("=");
                    return -1 === r && (r = t), [
                        r,
                        r === t ? 0 : 4 - r % 4
                    ];
                }
                function u(e, t, r) {
                    for(var i, s, o = [], a = t; a < r; a += 3)i = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), o.push(n[(s = i) >> 18 & 63] + n[s >> 12 & 63] + n[s >> 6 & 63] + n[63 & s]);
                    return o.join("");
                }
                i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
            },
            {}
        ],
        186: [
            function(e, t, r) {
                "use strict";
                !function(t, r) {
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function s(e, t, r) {
                        if (s.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var o;
                    "object" == typeof t ? t.exports = s : (void 0).BN = s, s.BN = s, s.wordSize = 26;
                    try {
                        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : e("buffer").Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : void n(!1, "Invalid character in " + e);
                    }
                    function l(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, i) {
                        for(var s = 0, o = 0, a = Math.min(e.length, r), l = t; l < a; l++){
                            var c = e.charCodeAt(l) - 48;
                            s *= i, o = c >= 49 ? c - 49 + 10 : c >= 17 ? c - 17 + 10 : c, n(c >= 0 && o < i, "Invalid character"), s += o;
                        }
                        return s;
                    }
                    function u(e, t) {
                        e.words = t.words, e.length = t.length, e.negative = t.negative, e.red = t.red;
                    }
                    if (s.isBN = function(e) {
                        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
                    }, s.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, s.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, s.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, s.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, s.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var s, o, a = 0;
                        if ("be" === r) for(i = e.length - 1, s = 0; i >= 0; i -= 3)o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        else if ("le" === r) for(i = 0, s = 0; i < e.length; i += 3)o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        return this._strip();
                    }, s.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, s = 0, o = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        this._strip();
                    }, s.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, l = 0, u = r; u < a; u += n)l = c(e, u, u + n, t), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        if (0 !== o) {
                            var h = 1;
                            for(l = c(e, u, e.length, t), u = 0; u < o; u++)h *= t;
                            this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        }
                        this._strip();
                    }, s.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, s.prototype._move = function(e) {
                        u(e, this);
                    }, s.prototype.clone = function() {
                        var e = new s(null);
                        return this.copy(e), e;
                    }, s.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, s.prototype._strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, s.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, "undefined" != typeof Symbol && "function" == typeof Symbol.for) try {
                        s.prototype[Symbol.for("nodejs.util.inspect.custom")] = h;
                    } catch (e) {
                        s.prototype.inspect = h;
                    }
                    else s.prototype.inspect = h;
                    function h() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    }
                    var f = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], d = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], p = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    s.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, s = 0, o = 0; o < this.length; o++){
                                var a = this.words[o], l = (16777215 & (a << i | s)).toString(16);
                                s = a >>> 24 - i & 16777215, (i += 2) >= 26 && (i -= 26, o--), r = 0 !== s || o !== this.length - 1 ? f[6 - l.length] + l + r : l + r;
                            }
                            for(0 !== s && (r = s.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = d[e], u = p[e];
                            r = "";
                            var h = this.clone();
                            for(h.negative = 0; !h.isZero();){
                                var m = h.modrn(u).toString(e);
                                r = (h = h.idivn(u)).isZero() ? m + r : f[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, s.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, s.prototype.toJSON = function() {
                        return this.toString(16, 2);
                    }, o && (s.prototype.toBuffer = function(e, t) {
                        return this.toArrayLike(o, e, t);
                    }), s.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    };
                    function m(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], s = 0 | t.words[0], o = i * s, a = 67108863 & o, l = o / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, t.length - 1), d = Math.max(0, c - e.length + 1); d <= f; d++){
                                var p = c - d | 0;
                                u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[d]) + h) / 67108864 | 0, h = 67108863 & o;
                            }
                            r.words[c] = 0 | h, l = 0 | u;
                        }
                        return 0 !== l ? r.words[c] = 0 | l : r.length--, r._strip();
                    }
                    s.prototype.toArrayLike = function(e, t, r) {
                        this._strip();
                        var i = this.byteLength(), s = r || Math.max(1, i);
                        n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0");
                        var o = function(e, t) {
                            return e.allocUnsafe ? e.allocUnsafe(t) : new e(t);
                        }(e, s);
                        return this["_toArrayLike" + ("le" === t ? "LE" : "BE")](o, i), o;
                    }, s.prototype._toArrayLikeLE = function(e, t) {
                        for(var r = 0, n = 0, i = 0, s = 0; i < this.length; i++){
                            var o = this.words[i] << s | n;
                            e[r++] = 255 & o, r < e.length && (e[r++] = o >> 8 & 255), r < e.length && (e[r++] = o >> 16 & 255), 6 === s ? (r < e.length && (e[r++] = o >> 24 & 255), n = 0, s = 0) : (n = o >>> 24, s += 2);
                        }
                        if (r < e.length) for(e[r++] = n; r < e.length;)e[r++] = 0;
                    }, s.prototype._toArrayLikeBE = function(e, t) {
                        for(var r = e.length - 1, n = 0, i = 0, s = 0; i < this.length; i++){
                            var o = this.words[i] << s | n;
                            e[r--] = 255 & o, r >= 0 && (e[r--] = o >> 8 & 255), r >= 0 && (e[r--] = o >> 16 & 255), 6 === s ? (r >= 0 && (e[r--] = o >> 24 & 255), n = 0, s = 0) : (n = o >>> 24, s += 2);
                        }
                        if (r >= 0) for(e[r--] = n; r >= 0;)e[r--] = 0;
                    }, Math.clz32 ? s.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : s.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, s.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, s.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, s.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, s.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, s.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, s.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, s.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, s.prototype.neg = function() {
                        return this.clone().ineg();
                    }, s.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, s.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this._strip();
                    }, s.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, s.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, s.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, s.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this._strip();
                    }, s.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, s.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, s.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, s.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this._strip();
                    }, s.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, s.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, s.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, s.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this._strip();
                    }, s.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, s.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this._strip();
                    }, s.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, s = 0; s < n.length; s++)t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && s < r.length; s++)t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this;
                    }, s.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, s.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var s = 0, o = 0; o < n.length; o++)s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        for(; 0 !== s && o < r.length; o++)s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        if (0 === s && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this._strip();
                    }, s.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var b = function(e, t, r) {
                        var n, i, s, o = e.words, a = t.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, d = 0 | o[1], p = 8191 & d, m = d >>> 13, b = 0 | o[2], g = 8191 & b, y = b >>> 13, v = 0 | o[3], w = 8191 & v, _ = v >>> 13, x = 0 | o[4], k = 8191 & x, S = x >>> 13, M = 0 | o[5], C = 8191 & M, T = M >>> 13, E = 0 | o[6], A = 8191 & E, R = E >>> 13, O = 0 | o[7], j = 8191 & O, I = O >>> 13, N = 0 | o[8], P = 8191 & N, B = N >>> 13, D = 0 | o[9], F = 8191 & D, L = D >>> 13, z = 0 | a[0], U = 8191 & z, $ = z >>> 13, H = 0 | a[1], V = 8191 & H, q = H >>> 13, W = 0 | a[2], X = 8191 & W, K = W >>> 13, Y = 0 | a[3], Z = 8191 & Y, G = Y >>> 13, J = 0 | a[4], Q = 8191 & J, ee = J >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], se = 8191 & ie, oe = ie >>> 13, ae = 0 | a[7], le = 8191 & ae, ce = ae >>> 13, ue = 0 | a[8], he = 8191 & ue, fe = ue >>> 13, de = 0 | a[9], pe = 8191 & de, me = de >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var be = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, $)) + Math.imul(f, U) | 0)) << 13) | 0;
                        c = ((s = Math.imul(f, $)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, $)) + Math.imul(m, U) | 0, s = Math.imul(m, $);
                        var ge = (c + (n = n + Math.imul(h, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, q) | 0) + Math.imul(f, V) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, q) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, U), i = (i = Math.imul(g, $)) + Math.imul(y, U) | 0, s = Math.imul(y, $), n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, V) | 0, s = s + Math.imul(m, q) | 0;
                        var ye = (c + (n = n + Math.imul(h, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(w, U), i = (i = Math.imul(w, $)) + Math.imul(_, U) | 0, s = Math.imul(_, $), n = n + Math.imul(g, V) | 0, i = (i = i + Math.imul(g, q) | 0) + Math.imul(y, V) | 0, s = s + Math.imul(y, q) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, X) | 0, s = s + Math.imul(m, K) | 0;
                        var ve = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(k, U), i = (i = Math.imul(k, $)) + Math.imul(S, U) | 0, s = Math.imul(S, $), n = n + Math.imul(w, V) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(_, V) | 0, s = s + Math.imul(_, q) | 0, n = n + Math.imul(g, X) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(y, X) | 0, s = s + Math.imul(y, K) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(m, Z) | 0, s = s + Math.imul(m, G) | 0;
                        var we = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, $)) + Math.imul(T, U) | 0, s = Math.imul(T, $), n = n + Math.imul(k, V) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(S, V) | 0, s = s + Math.imul(S, q) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(_, X) | 0, s = s + Math.imul(_, K) | 0, n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, G) | 0) + Math.imul(y, Z) | 0, s = s + Math.imul(y, G) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, s = s + Math.imul(m, ee) | 0;
                        var _e = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(f, re) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ne) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, $)) + Math.imul(R, U) | 0, s = Math.imul(R, $), n = n + Math.imul(C, V) | 0, i = (i = i + Math.imul(C, q) | 0) + Math.imul(T, V) | 0, s = s + Math.imul(T, q) | 0, n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(S, X) | 0, s = s + Math.imul(S, K) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, G) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(y, Q) | 0, s = s + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, s = s + Math.imul(m, ne) | 0;
                        var xe = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, oe) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(j, U), i = (i = Math.imul(j, $)) + Math.imul(I, U) | 0, s = Math.imul(I, $), n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, q) | 0) + Math.imul(R, V) | 0, s = s + Math.imul(R, q) | 0, n = n + Math.imul(C, X) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, X) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, G) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(_, Q) | 0, s = s + Math.imul(_, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(y, re) | 0, s = s + Math.imul(y, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(m, se) | 0, s = s + Math.imul(m, oe) | 0;
                        var ke = (c + (n = n + Math.imul(h, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(f, le) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, $)) + Math.imul(B, U) | 0, s = Math.imul(B, $), n = n + Math.imul(j, V) | 0, i = (i = i + Math.imul(j, q) | 0) + Math.imul(I, V) | 0, s = s + Math.imul(I, q) | 0, n = n + Math.imul(A, X) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(R, X) | 0, s = s + Math.imul(R, K) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, G) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(_, re) | 0, s = s + Math.imul(_, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(y, se) | 0, s = s + Math.imul(y, oe) | 0, n = n + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, le) | 0, s = s + Math.imul(m, ce) | 0;
                        var Se = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, fe) | 0) + Math.imul(f, he) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(F, U), i = (i = Math.imul(F, $)) + Math.imul(L, U) | 0, s = Math.imul(L, $), n = n + Math.imul(P, V) | 0, i = (i = i + Math.imul(P, q) | 0) + Math.imul(B, V) | 0, s = s + Math.imul(B, q) | 0, n = n + Math.imul(j, X) | 0, i = (i = i + Math.imul(j, K) | 0) + Math.imul(I, X) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(R, Z) | 0, s = s + Math.imul(R, G) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(S, re) | 0, s = s + Math.imul(S, ne) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, oe) | 0) + Math.imul(_, se) | 0, s = s + Math.imul(_, oe) | 0, n = n + Math.imul(g, le) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(y, le) | 0, s = s + Math.imul(y, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, he) | 0, s = s + Math.imul(m, fe) | 0;
                        var Me = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(F, V), i = (i = Math.imul(F, q)) + Math.imul(L, V) | 0, s = Math.imul(L, q), n = n + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, K) | 0) + Math.imul(B, X) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, G) | 0, n = n + Math.imul(A, Q) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(R, Q) | 0, s = s + Math.imul(R, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, n = n + Math.imul(w, le) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(_, le) | 0, s = s + Math.imul(_, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(y, he) | 0, s = s + Math.imul(y, fe) | 0;
                        var Ce = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(F, X), i = (i = Math.imul(F, K)) + Math.imul(L, X) | 0, s = Math.imul(L, K), n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, G) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(R, re) | 0, s = s + Math.imul(R, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(S, le) | 0, s = s + Math.imul(S, ce) | 0, n = n + Math.imul(w, he) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(_, he) | 0, s = s + Math.imul(_, fe) | 0;
                        var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(F, Z), i = (i = Math.imul(F, G)) + Math.imul(L, Z) | 0, s = Math.imul(L, G), n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(A, se) | 0, i = (i = i + Math.imul(A, oe) | 0) + Math.imul(R, se) | 0, s = s + Math.imul(R, oe) | 0, n = n + Math.imul(C, le) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(T, le) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(k, he) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(S, he) | 0, s = s + Math.imul(S, fe) | 0;
                        var Ee = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(_, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(_, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(F, Q), i = (i = Math.imul(F, ee)) + Math.imul(L, Q) | 0, s = Math.imul(L, ee), n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(j, se) | 0, i = (i = i + Math.imul(j, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(A, le) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(R, le) | 0, s = s + Math.imul(R, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, fe) | 0;
                        var Ae = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(F, re), i = (i = Math.imul(F, ne)) + Math.imul(L, re) | 0, s = Math.imul(L, ne), n = n + Math.imul(P, se) | 0, i = (i = i + Math.imul(P, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(j, le) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(I, le) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(A, he) | 0, i = (i = i + Math.imul(A, fe) | 0) + Math.imul(R, he) | 0, s = s + Math.imul(R, fe) | 0;
                        var Re = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(F, se), i = (i = Math.imul(F, oe)) + Math.imul(L, se) | 0, s = Math.imul(L, oe), n = n + Math.imul(P, le) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(B, le) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(j, he) | 0, i = (i = i + Math.imul(j, fe) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, fe) | 0;
                        var Oe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, me) | 0) + Math.imul(R, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(R, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(F, le), i = (i = Math.imul(F, ce)) + Math.imul(L, le) | 0, s = Math.imul(L, ce), n = n + Math.imul(P, he) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, fe) | 0;
                        var je = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(F, he), i = (i = Math.imul(F, fe)) + Math.imul(L, he) | 0, s = Math.imul(L, fe);
                        var Ie = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(B, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                        var Ne = (c + (n = Math.imul(F, pe)) | 0) + ((8191 & (i = (i = Math.imul(F, me)) + Math.imul(L, pe) | 0)) << 13) | 0;
                        return c = ((s = Math.imul(L, me)) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l[0] = be, l[1] = ge, l[2] = ye, l[3] = ve, l[4] = we, l[5] = _e, l[6] = xe, l[7] = ke, l[8] = Se, l[9] = Me, l[10] = Ce, l[11] = Te, l[12] = Ee, l[13] = Ae, l[14] = Re, l[15] = Oe, l[16] = je, l[17] = Ie, l[18] = Ne, 0 !== c && (l[19] = c, r.length++), r;
                    };
                    function g(e, t, r) {
                        r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                        for(var n = 0, i = 0, s = 0; s < r.length - 1; s++){
                            var o = i;
                            i = 0;
                            for(var a = 67108863 & n, l = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= l; c++){
                                var u = s - c, h = (0 | e.words[u]) * (0 | t.words[c]), f = 67108863 & h;
                                a = 67108863 & (f = f + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                            }
                            r.words[s] = a, n = o, o = i;
                        }
                        return 0 !== n ? r.words[s] = n : r.length--, r._strip();
                    }
                    function y(e, t, r) {
                        return g(e, t, r);
                    }
                    function v(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (b = m), s.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? b(this, e, t) : r < 63 ? m(this, e, t) : r < 1024 ? g(this, e, t) : y(this, e, t);
                    }, v.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, v.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, v.prototype.permute = function(e, t, r, n, i, s) {
                        for(var o = 0; o < s; o++)n[o] = t[e[o]], i[o] = r[e[o]];
                    }, v.prototype.transform = function(e, t, r, n, i, s) {
                        this.permute(s, e, t, r, n, i);
                        for(var o = 1; o < i; o <<= 1)for(var a = o << 1, l = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a)for(var h = l, f = c, d = 0; d < o; d++){
                            var p = r[u + d], m = n[u + d], b = r[u + d + o], g = n[u + d + o], y = h * b - f * g;
                            g = h * g + f * b, b = y, r[u + d] = p + b, n[u + d] = m + g, r[u + d + o] = p - b, n[u + d + o] = m - g, d !== a && (y = l * h - c * f, f = l * f + c * h, h = y);
                        }
                    }, v.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, v.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, v.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, v.prototype.convert13b = function(e, t, r, i) {
                        for(var s = 0, o = 0; o < t; o++)s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
                        for(o = 2 * t; o < i; ++o)r[o] = 0;
                        n(0 === s), n(0 == (-8192 & s));
                    }, v.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, v.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), s = this.stub(n), o = new Array(n), a = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                        f.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, l, n, i), this.transform(c, s, u, h, n, i);
                        for(var d = 0; d < n; d++){
                            var p = a[d] * u[d] - l[d] * h[d];
                            l[d] = a[d] * h[d] + l[d] * u[d], a[d] = p;
                        }
                        return this.conjugate(a, l, n), this.transform(a, l, f, s, n, i), this.conjugate(f, s, n), this.normalize13b(f, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r._strip();
                    }, s.prototype.mul = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, s.prototype.mulf = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), y(this, e, t);
                    }, s.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, s.prototype.imuln = function(e) {
                        var t = e < 0;
                        t && (e = -e), n("number" == typeof e), n(e < 67108864);
                        for(var r = 0, i = 0; i < this.length; i++){
                            var s = (0 | this.words[i]) * e, o = (67108863 & s) + (67108863 & r);
                            r >>= 26, r += s / 67108864 | 0, r += o >>> 26, this.words[i] = 67108863 & o;
                        }
                        return 0 !== r && (this.words[i] = r, this.length++), t ? this.ineg() : this;
                    }, s.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, s.prototype.sqr = function() {
                        return this.mul(this);
                    }, s.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, s.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = e.words[n] >>> i & 1;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new s(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, s.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, s = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var o = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & s, l = (0 | this.words[t]) - a << r;
                                this.words[t] = l | o, o = a >>> 26 - r;
                            }
                            o && (this.words[t] = o, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this._strip();
                    }, s.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, s.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var s = e % 26, o = Math.min((e - s) / 26, this.length), a = 67108863 ^ 67108863 >>> s << s, l = r;
                        if (i -= o, i = Math.max(0, i), l) {
                            for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                            l.length = o;
                        }
                        if (0 === o) ;
                        else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                        else this.words[0] = 0, this.length = 1;
                        var u = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                            var h = 0 | this.words[c];
                            this.words[c] = u << 26 - s | h >>> s, u = h & a;
                        }
                        return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this._strip();
                    }, s.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, s.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, s.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, s.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, s.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, s.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r) && !!(this.words[r] & i);
                    }, s.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this._strip();
                    }, s.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, s.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) <= e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, s.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, s.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this._strip();
                    }, s.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, s.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, s.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, s.prototype.abs = function() {
                        return this.clone().iabs();
                    }, s.prototype._ishlnsubmul = function(e, t, r) {
                        var i, s, o = e.length + r;
                        this._expand(o);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            s = (0 | this.words[i + r]) + a;
                            var l = (0 | e.words[i]) * t;
                            a = ((s -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & s;
                        }
                        for(; i < this.length - r; i++)a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
                        if (0 === a) return this._strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
                        return this.negative = 1, this._strip();
                    }, s.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var a, l = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new s(null)).length = l + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var u = n.clone()._ishlnsubmul(i, 1, l);
                        0 === u.negative && (n = u, a && (a.words[l] = 1));
                        for(var h = l - 1; h >= 0; h--){
                            var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                            for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                            a && (a.words[h] = f);
                        }
                        return a && a._strip(), n._strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, s.prototype.divmod = function(e, t, r) {
                        var i, o, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new s(0),
                            mod: new s(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: i,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: a.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new s(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new s(this.modrn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new s(this.modrn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, s.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, s.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, s.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, s.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), s = r.cmp(n);
                        return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, s.prototype.modrn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 67108864 % e, i = 0, s = this.length - 1; s >= 0; s--)i = (r * i + (0 | this.words[s])) % e;
                        return t ? -i : i;
                    }, s.prototype.modn = function(e) {
                        return this.modrn(e);
                    }, s.prototype.idivn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 0, i = this.length - 1; i >= 0; i--){
                            var s = (0 | this.words[i]) + 67108864 * r;
                            this.words[i] = s / e | 0, r = s % e;
                        }
                        return this._strip(), t ? this.ineg() : this;
                    }, s.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, s.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new s(1), o = new s(0), a = new s(0), l = new s(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var u = r.clone(), h = t.clone(); !t.isZero();){
                            for(var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1);
                            if (f > 0) for(t.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || l.isOdd()) && (a.iadd(u), l.isub(h)), a.iushrn(1), l.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(l)) : (r.isub(t), a.isub(i), l.isub(o));
                        }
                        return {
                            a: a,
                            b: l,
                            gcd: r.iushln(c)
                        };
                    }, s.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, o = new s(1), a = new s(0), l = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                            for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(r.iushrn(h); h-- > 0;)a.isOdd() && a.iadd(l), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
                        }
                        return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, s.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var s = t;
                                t = r, r = s;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, s.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, s.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, s.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, s.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, s.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var s = i, o = r; 0 !== s && o < this.length; o++){
                            var a = 0 | this.words[o];
                            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
                        }
                        return 0 !== s && (this.words[o] = s, this.length++), this;
                    }, s.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, s.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this._strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, s.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, s.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, s.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, s.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, s.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, s.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, s.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, s.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, s.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, s.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, s.red = function(e) {
                        return new C(e);
                    }, s.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, s.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, s.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, s.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, s.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, s.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, s.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, s.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, s.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, s.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, s.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, s.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, s.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, s.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, s.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, s.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, s.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var w = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function _(e, t) {
                        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function x() {
                        _.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function k() {
                        _.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function S() {
                        _.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function M() {
                        _.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function C(e) {
                        if ("string" == typeof e) {
                            var t = s._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function T(e) {
                        C.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    _.prototype._tmp = function() {
                        var e = new s(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, _.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, _.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, _.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(x, _), x.prototype.split = function(e, t) {
                        for(var r = Math.min(e.length, 9), n = 0; n < r; n++)t.words[n] = e.words[n];
                        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var i = e.words[9];
                        for(t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++){
                            var s = 0 | e.words[n];
                            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
                        }
                        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, x.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(k, _), i(S, _), i(M, _), M.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, s._prime = function(e) {
                        if (w[e]) return w[e];
                        var t;
                        if ("k256" === e) t = new x;
                        else if ("p224" === e) t = new k;
                        else if ("p192" === e) t = new S;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new M;
                        }
                        return w[e] = t, t;
                    }, C.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, C.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, C.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : (u(e, e.umod(this.m)._forceRed(this)), e);
                    }, C.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, C.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, C.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, C.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, C.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, C.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, C.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, C.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, C.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, C.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, C.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new s(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new s(1).toRed(this), l = a.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                        for(u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                        for(var h = this.pow(u, i), f = this.pow(e, i.addn(1).iushrn(1)), d = this.pow(e, i), p = o; 0 !== d.cmp(a);){
                            for(var m = d, b = 0; 0 !== m.cmp(a); b++)m = m.redSqr();
                            n(b < p);
                            var g = this.pow(h, new s(1).iushln(p - b - 1));
                            f = f.redMul(g), h = g.redSqr(), d = d.redMul(h), p = b;
                        }
                        return f;
                    }, C.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, C.prototype.pow = function(e, t) {
                        if (t.isZero()) return new s(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new s(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, a = 0, l = t.bitLength() % 26;
                        for(0 === l && (l = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], u = l - 1; u >= 0; u--){
                                var h = c >> u & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
                            }
                            l = 26;
                        }
                        return i;
                    }, C.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, C.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, s.mont = function(e) {
                        return new T(e);
                    }, i(T, C), T.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, T.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, T.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, T.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, T.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(void 0 === t || t);
            },
            {
                buffer: 188
            }
        ],
        187: [
            function(e, t, r) {
                "use strict";
                var n;
                function i(e) {
                    this.rand = e;
                }
                if (t.exports = function(e) {
                    return n || (n = new i(null)), n.generate(e);
                }, t.exports.Rand = i, i.prototype.generate = function(e) {
                    return this._rand(e);
                }, i.prototype._rand = function(e) {
                    if (this.rand.getBytes) return this.rand.getBytes(e);
                    for(var t = new Uint8Array(e), r = 0; r < t.length; r++)t[r] = this.rand.getByte();
                    return t;
                }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.crypto.getRandomValues(t), t;
                } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.msCrypto.getRandomValues(t), t;
                } : "object" == typeof window && (i.prototype._rand = function() {
                    throw new Error("Not implemented yet");
                });
                else try {
                    var s = e("crypto");
                    if ("function" != typeof s.randomBytes) throw new Error("Not supported");
                    i.prototype._rand = function(e) {
                        return s.randomBytes(e);
                    };
                } catch (e) {}
            },
            {
                crypto: 188
            }
        ],
        188: [
            function(e, t, r) {},
            {}
        ],
        189: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e) {
                    n.isBuffer(e) || (e = n.from(e));
                    for(var t = e.length / 4 | 0, r = new Array(t), i = 0; i < t; i++)r[i] = e.readUInt32BE(4 * i);
                    return r;
                }
                function s(e) {
                    for(; 0 < e.length; e++)e[0] = 0;
                }
                function o(e, t, r, n, i) {
                    for(var s, o, a, l, c = r[0], u = r[1], h = r[2], f = r[3], d = e[0] ^ t[0], p = e[1] ^ t[1], m = e[2] ^ t[2], b = e[3] ^ t[3], g = 4, y = 1; y < i; y++)s = c[d >>> 24] ^ u[p >>> 16 & 255] ^ h[m >>> 8 & 255] ^ f[255 & b] ^ t[g++], o = c[p >>> 24] ^ u[m >>> 16 & 255] ^ h[b >>> 8 & 255] ^ f[255 & d] ^ t[g++], a = c[m >>> 24] ^ u[b >>> 16 & 255] ^ h[d >>> 8 & 255] ^ f[255 & p] ^ t[g++], l = c[b >>> 24] ^ u[d >>> 16 & 255] ^ h[p >>> 8 & 255] ^ f[255 & m] ^ t[g++], d = s, p = o, m = a, b = l;
                    return s = (n[d >>> 24] << 24 | n[p >>> 16 & 255] << 16 | n[m >>> 8 & 255] << 8 | n[255 & b]) ^ t[g++], o = (n[p >>> 24] << 24 | n[m >>> 16 & 255] << 16 | n[b >>> 8 & 255] << 8 | n[255 & d]) ^ t[g++], a = (n[m >>> 24] << 24 | n[b >>> 16 & 255] << 16 | n[d >>> 8 & 255] << 8 | n[255 & p]) ^ t[g++], l = (n[b >>> 24] << 24 | n[d >>> 16 & 255] << 16 | n[p >>> 8 & 255] << 8 | n[255 & m]) ^ t[g++], [
                        s >>>= 0,
                        o >>>= 0,
                        a >>>= 0,
                        l >>>= 0
                    ];
                }
                var a = [
                    0,
                    1,
                    2,
                    4,
                    8,
                    16,
                    32,
                    64,
                    128,
                    27,
                    54
                ], l = function() {
                    for(var e = new Array(256), t = 0; t < 256; t++)e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
                    for(var r = [], n = [], i = [
                        [],
                        [],
                        [],
                        []
                    ], s = [
                        [],
                        [],
                        [],
                        []
                    ], o = 0, a = 0, l = 0; l < 256; ++l){
                        var c = a ^ a << 1 ^ a << 2 ^ a << 3 ^ a << 4;
                        c = c >>> 8 ^ 255 & c ^ 99, r[o] = c, n[c] = o;
                        var u = e[o], h = e[u], f = e[h], d = 257 * e[c] ^ 16843008 * c;
                        i[0][o] = d << 24 | d >>> 8, i[1][o] = d << 16 | d >>> 16, i[2][o] = d << 8 | d >>> 24, i[3][o] = d, d = 16843009 * f ^ 65537 * h ^ 257 * u ^ 16843008 * o, s[0][c] = d << 24 | d >>> 8, s[1][c] = d << 16 | d >>> 16, s[2][c] = d << 8 | d >>> 24, s[3][c] = d, 0 === o ? o = a = 1 : (o = u ^ e[e[e[f ^ u]]], a ^= e[e[a]]);
                    }
                    return {
                        SBOX: r,
                        INV_SBOX: n,
                        SUB_MIX: i,
                        INV_SUB_MIX: s
                    };
                }();
                function c(e) {
                    this._key = i(e), this._reset();
                }
                c.blockSize = 16, c.keySize = 32, c.prototype.blockSize = c.blockSize, c.prototype.keySize = c.keySize, c.prototype._reset = function() {
                    for(var e = this._key, t = e.length, r = t + 6, n = 4 * (r + 1), i = [], s = 0; s < t; s++)i[s] = e[s];
                    for(s = t; s < n; s++){
                        var o = i[s - 1];
                        s % t == 0 ? (o = o << 8 | o >>> 24, o = l.SBOX[o >>> 24] << 24 | l.SBOX[o >>> 16 & 255] << 16 | l.SBOX[o >>> 8 & 255] << 8 | l.SBOX[255 & o], o ^= a[s / t | 0] << 24) : t > 6 && s % t == 4 && (o = l.SBOX[o >>> 24] << 24 | l.SBOX[o >>> 16 & 255] << 16 | l.SBOX[o >>> 8 & 255] << 8 | l.SBOX[255 & o]), i[s] = i[s - t] ^ o;
                    }
                    for(var c = [], u = 0; u < n; u++){
                        var h = n - u, f = i[h - (u % 4 ? 0 : 4)];
                        c[u] = u < 4 || h <= 4 ? f : l.INV_SUB_MIX[0][l.SBOX[f >>> 24]] ^ l.INV_SUB_MIX[1][l.SBOX[f >>> 16 & 255]] ^ l.INV_SUB_MIX[2][l.SBOX[f >>> 8 & 255]] ^ l.INV_SUB_MIX[3][l.SBOX[255 & f]];
                    }
                    this._nRounds = r, this._keySchedule = i, this._invKeySchedule = c;
                }, c.prototype.encryptBlockRaw = function(e) {
                    return o(e = i(e), this._keySchedule, l.SUB_MIX, l.SBOX, this._nRounds);
                }, c.prototype.encryptBlock = function(e) {
                    var t = this.encryptBlockRaw(e), r = n.allocUnsafe(16);
                    return r.writeUInt32BE(t[0], 0), r.writeUInt32BE(t[1], 4), r.writeUInt32BE(t[2], 8), r.writeUInt32BE(t[3], 12), r;
                }, c.prototype.decryptBlock = function(e) {
                    var t = (e = i(e))[1];
                    e[1] = e[3], e[3] = t;
                    var r = o(e, this._invKeySchedule, l.INV_SUB_MIX, l.INV_SBOX, this._nRounds), s = n.allocUnsafe(16);
                    return s.writeUInt32BE(r[0], 0), s.writeUInt32BE(r[3], 4), s.writeUInt32BE(r[2], 8), s.writeUInt32BE(r[1], 12), s;
                }, c.prototype.scrub = function() {
                    s(this._keySchedule), s(this._invKeySchedule), s(this._key);
                }, t.exports.AES = c;
            },
            {
                "safe-buffer": 494
            }
        ],
        190: [
            function(e, t, r) {
                "use strict";
                var n = e("./aes"), i = e("safe-buffer").Buffer, s = e("cipher-base"), o = e("inherits"), a = e("./ghash"), l = e("buffer-xor"), c = e("./incr32");
                function u(e, t, r, o) {
                    s.call(this);
                    var l = i.alloc(4, 0);
                    this._cipher = new n.AES(t);
                    var u = this._cipher.encryptBlock(l);
                    this._ghash = new a(u), r = function(e, t, r) {
                        if (12 === t.length) return e._finID = i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                1
                            ])
                        ]), i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                2
                            ])
                        ]);
                        var n = new a(r), s = t.length, o = s % 16;
                        n.update(t), o && (o = 16 - o, n.update(i.alloc(o, 0))), n.update(i.alloc(8, 0));
                        var l = 8 * s, u = i.alloc(8);
                        u.writeUIntBE(l, 0, 8), n.update(u), e._finID = n.state;
                        var h = i.from(e._finID);
                        return c(h), h;
                    }(this, r, u), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._alen = 0, this._len = 0, this._mode = e, this._authTag = null, this._called = !1;
                }
                o(u, s), u.prototype._update = function(e) {
                    if (!this._called && this._alen) {
                        var t = 16 - this._alen % 16;
                        t < 16 && (t = i.alloc(t, 0), this._ghash.update(t));
                    }
                    this._called = !0;
                    var r = this._mode.encrypt(this, e);
                    return this._decrypt ? this._ghash.update(e) : this._ghash.update(r), this._len += e.length, r;
                }, u.prototype._final = function() {
                    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
                    var e = l(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
                    if (this._decrypt && function(e, t) {
                        var r = 0;
                        e.length !== t.length && r++;
                        for(var n = Math.min(e.length, t.length), i = 0; i < n; ++i)r += e[i] ^ t[i];
                        return r;
                    }(e, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
                    this._authTag = e, this._cipher.scrub();
                }, u.prototype.getAuthTag = function() {
                    if (this._decrypt || !i.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
                    return this._authTag;
                }, u.prototype.setAuthTag = function(e) {
                    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
                    this._authTag = e;
                }, u.prototype.setAAD = function(e) {
                    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
                    this._ghash.update(e), this._alen += e.length;
                }, t.exports = u;
            },
            {
                "./aes": 189,
                "./ghash": 194,
                "./incr32": 195,
                "buffer-xor": 219,
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        191: [
            function(e, t, r) {
                "use strict";
                var n = e("./encrypter"), i = e("./decrypter"), s = e("./modes/list.json");
                r.createCipher = r.Cipher = n.createCipher, r.createCipheriv = r.Cipheriv = n.createCipheriv, r.createDecipher = r.Decipher = i.createDecipher, r.createDecipheriv = r.Decipheriv = i.createDecipheriv, r.listCiphers = r.getCiphers = function() {
                    return Object.keys(s);
                };
            },
            {
                "./decrypter": 192,
                "./encrypter": 193,
                "./modes/list.json": 203
            }
        ],
        192: [
            function(e, t, r) {
                "use strict";
                var n = e("./authCipher"), i = e("safe-buffer").Buffer, s = e("./modes"), o = e("./streamCipher"), a = e("cipher-base"), l = e("./aes"), c = e("evp_bytestokey");
                function u(e, t, r) {
                    a.call(this), this._cache = new h, this._last = void 0, this._cipher = new l.AES(t), this._prev = i.from(r), this._mode = e, this._autopadding = !0;
                }
                function h() {
                    this.cache = i.allocUnsafe(0);
                }
                function f(e, t, r) {
                    var a = s[e.toLowerCase()];
                    if (!a) throw new TypeError("invalid suite type");
                    if ("string" == typeof r && (r = i.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
                    if ("string" == typeof t && (t = i.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
                    return "stream" === a.type ? new o(a.module, t, r, !0) : "auth" === a.type ? new n(a.module, t, r, !0) : new u(a.module, t, r);
                }
                e("inherits")(u, a), u.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get(this._autopadding);)r = this._mode.decrypt(this, t), n.push(r);
                    return i.concat(n);
                }, u.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return function(e) {
                        var t = e[15];
                        if (t < 1 || t > 16) throw new Error("unable to decrypt data");
                        var r = -1;
                        for(; ++r < t;)if (e[r + (16 - t)] !== t) throw new Error("unable to decrypt data");
                        if (16 === t) return;
                        return e.slice(0, 16 - t);
                    }(this._mode.decrypt(this, e));
                    if (e) throw new Error("data not multiple of block length");
                }, u.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, h.prototype.add = function(e) {
                    this.cache = i.concat([
                        this.cache,
                        e
                    ]);
                }, h.prototype.get = function(e) {
                    var t;
                    if (e) {
                        if (this.cache.length > 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    } else if (this.cache.length >= 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    return null;
                }, h.prototype.flush = function() {
                    if (this.cache.length) return this.cache;
                }, r.createDecipher = function(e, t) {
                    var r = s[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var n = c(t, !1, r.key, r.iv);
                    return f(e, n.key, n.iv);
                }, r.createDecipheriv = f;
            },
            {
                "./aes": 189,
                "./authCipher": 190,
                "./modes": 202,
                "./streamCipher": 205,
                "cipher-base": 221,
                evp_bytestokey: 423,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        193: [
            function(e, t, r) {
                "use strict";
                var n = e("./modes"), i = e("./authCipher"), s = e("safe-buffer").Buffer, o = e("./streamCipher"), a = e("cipher-base"), l = e("./aes"), c = e("evp_bytestokey");
                function u(e, t, r) {
                    a.call(this), this._cache = new f, this._cipher = new l.AES(t), this._prev = s.from(r), this._mode = e, this._autopadding = !0;
                }
                e("inherits")(u, a), u.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get();)r = this._mode.encrypt(this, t), n.push(r);
                    return s.concat(n);
                };
                var h = s.alloc(16, 16);
                function f() {
                    this.cache = s.allocUnsafe(0);
                }
                function d(e, t, r) {
                    var a = n[e.toLowerCase()];
                    if (!a) throw new TypeError("invalid suite type");
                    if ("string" == typeof t && (t = s.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
                    if ("string" == typeof r && (r = s.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
                    return "stream" === a.type ? new o(a.module, t, r) : "auth" === a.type ? new i(a.module, t, r) : new u(a.module, t, r);
                }
                u.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return e = this._mode.encrypt(this, e), this._cipher.scrub(), e;
                    if (!e.equals(h)) throw this._cipher.scrub(), new Error("data not multiple of block length");
                }, u.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, f.prototype.add = function(e) {
                    this.cache = s.concat([
                        this.cache,
                        e
                    ]);
                }, f.prototype.get = function() {
                    if (this.cache.length > 15) {
                        var e = this.cache.slice(0, 16);
                        return this.cache = this.cache.slice(16), e;
                    }
                    return null;
                }, f.prototype.flush = function() {
                    for(var e = 16 - this.cache.length, t = s.allocUnsafe(e), r = -1; ++r < e;)t.writeUInt8(e, r);
                    return s.concat([
                        this.cache,
                        t
                    ]);
                }, r.createCipheriv = d, r.createCipher = function(e, t) {
                    var r = n[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var i = c(t, !1, r.key, r.iv);
                    return d(e, i.key, i.iv);
                };
            },
            {
                "./aes": 189,
                "./authCipher": 190,
                "./modes": 202,
                "./streamCipher": 205,
                "cipher-base": 221,
                evp_bytestokey: 423,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        194: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = n.alloc(16, 0);
                function s(e) {
                    var t = n.allocUnsafe(16);
                    return t.writeUInt32BE(e[0] >>> 0, 0), t.writeUInt32BE(e[1] >>> 0, 4), t.writeUInt32BE(e[2] >>> 0, 8), t.writeUInt32BE(e[3] >>> 0, 12), t;
                }
                function o(e) {
                    this.h = e, this.state = n.alloc(16, 0), this.cache = n.allocUnsafe(0);
                }
                o.prototype.ghash = function(e) {
                    for(var t = -1; ++t < e.length;)this.state[t] ^= e[t];
                    this._multiply();
                }, o.prototype._multiply = function() {
                    for(var e, t, r, n = [
                        (e = this.h).readUInt32BE(0),
                        e.readUInt32BE(4),
                        e.readUInt32BE(8),
                        e.readUInt32BE(12)
                    ], i = [
                        0,
                        0,
                        0,
                        0
                    ], o = -1; ++o < 128;){
                        for(0 != (this.state[~~(o / 8)] & 1 << 7 - o % 8) && (i[0] ^= n[0], i[1] ^= n[1], i[2] ^= n[2], i[3] ^= n[3]), r = 0 != (1 & n[3]), t = 3; t > 0; t--)n[t] = n[t] >>> 1 | (1 & n[t - 1]) << 31;
                        n[0] = n[0] >>> 1, r && (n[0] = n[0] ^ -520093696);
                    }
                    this.state = s(i);
                }, o.prototype.update = function(e) {
                    var t;
                    for(this.cache = n.concat([
                        this.cache,
                        e
                    ]); this.cache.length >= 16;)t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(t);
                }, o.prototype.final = function(e, t) {
                    return this.cache.length && this.ghash(n.concat([
                        this.cache,
                        i
                    ], 16)), this.ghash(s([
                        0,
                        e,
                        0,
                        t
                    ])), this.state;
                }, t.exports = o;
            },
            {
                "safe-buffer": 494
            }
        ],
        195: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    for(var t, r = e.length; r--;){
                        if (255 !== (t = e.readUInt8(r))) {
                            t++, e.writeUInt8(t, r);
                            break;
                        }
                        e.writeUInt8(0, r);
                    }
                };
            },
            {}
        ],
        196: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer-xor");
                r.encrypt = function(e, t) {
                    var r = n(t, e._prev);
                    return e._prev = e._cipher.encryptBlock(r), e._prev;
                }, r.decrypt = function(e, t) {
                    var r = e._prev;
                    e._prev = t;
                    var i = e._cipher.decryptBlock(t);
                    return n(i, r);
                };
            },
            {
                "buffer-xor": 219
            }
        ],
        197: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("buffer-xor");
                function s(e, t, r) {
                    var s = t.length, o = i(t, e._cache);
                    return e._cache = e._cache.slice(s), e._prev = n.concat([
                        e._prev,
                        r ? t : o
                    ]), o;
                }
                r.encrypt = function(e, t, r) {
                    for(var i, o = n.allocUnsafe(0); t.length;){
                        if (0 === e._cache.length && (e._cache = e._cipher.encryptBlock(e._prev), e._prev = n.allocUnsafe(0)), !(e._cache.length <= t.length)) {
                            o = n.concat([
                                o,
                                s(e, t, r)
                            ]);
                            break;
                        }
                        i = e._cache.length, o = n.concat([
                            o,
                            s(e, t.slice(0, i), r)
                        ]), t = t.slice(i);
                    }
                    return o;
                };
            },
            {
                "buffer-xor": 219,
                "safe-buffer": 494
            }
        ],
        198: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t, r) {
                    for(var n, i, o = -1, a = 0; ++o < 8;)n = t & 1 << 7 - o ? 128 : 0, a += (128 & (i = e._cipher.encryptBlock(e._prev)[0] ^ n)) >> o % 8, e._prev = s(e._prev, r ? n : i);
                    return a;
                }
                function s(e, t) {
                    var r = e.length, i = -1, s = n.allocUnsafe(e.length);
                    for(e = n.concat([
                        e,
                        n.from([
                            t
                        ])
                    ]); ++i < r;)s[i] = e[i] << 1 | e[i + 1] >> 7;
                    return s;
                }
                r.encrypt = function(e, t, r) {
                    for(var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;)o[a] = i(e, t[a], r);
                    return o;
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        199: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t, r) {
                    var i = e._cipher.encryptBlock(e._prev)[0] ^ t;
                    return e._prev = n.concat([
                        e._prev.slice(1),
                        n.from([
                            r ? t : i
                        ])
                    ]), i;
                }
                r.encrypt = function(e, t, r) {
                    for(var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;)o[a] = i(e, t[a], r);
                    return o;
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        200: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer-xor"), i = e("safe-buffer").Buffer, s = e("../incr32");
                function o(e) {
                    var t = e._cipher.encryptBlockRaw(e._prev);
                    return s(e._prev), t;
                }
                r.encrypt = function(e, t) {
                    var r = Math.ceil(t.length / 16), s = e._cache.length;
                    e._cache = i.concat([
                        e._cache,
                        i.allocUnsafe(16 * r)
                    ]);
                    for(var a = 0; a < r; a++){
                        var l = o(e), c = s + 16 * a;
                        e._cache.writeUInt32BE(l[0], c + 0), e._cache.writeUInt32BE(l[1], c + 4), e._cache.writeUInt32BE(l[2], c + 8), e._cache.writeUInt32BE(l[3], c + 12);
                    }
                    var u = e._cache.slice(0, t.length);
                    return e._cache = e._cache.slice(t.length), n(t, u);
                };
            },
            {
                "../incr32": 195,
                "buffer-xor": 219,
                "safe-buffer": 494
            }
        ],
        201: [
            function(e, t, r) {
                "use strict";
                r.encrypt = function(e, t) {
                    return e._cipher.encryptBlock(t);
                }, r.decrypt = function(e, t) {
                    return e._cipher.decryptBlock(t);
                };
            },
            {}
        ],
        202: [
            function(e, t, r) {
                "use strict";
                var n = {
                    ECB: e("./ecb"),
                    CBC: e("./cbc"),
                    CFB: e("./cfb"),
                    CFB8: e("./cfb8"),
                    CFB1: e("./cfb1"),
                    OFB: e("./ofb"),
                    CTR: e("./ctr"),
                    GCM: e("./ctr")
                }, i = e("./list.json");
                for(var s in i)i[s].module = n[i[s].mode];
                t.exports = i;
            },
            {
                "./cbc": 196,
                "./cfb": 197,
                "./cfb1": 198,
                "./cfb8": 199,
                "./ctr": 200,
                "./ecb": 201,
                "./list.json": 203,
                "./ofb": 204
            }
        ],
        203: [
            function(e, t, r) {
                t.exports = {
                    "aes-128-ecb": {
                        cipher: "AES",
                        key: 128,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-192-ecb": {
                        cipher: "AES",
                        key: 192,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-256-ecb": {
                        cipher: "AES",
                        key: 256,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-128-cbc": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-192-cbc": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-256-cbc": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes128: {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes192: {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes256: {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-128-cfb": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-192-cfb": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-256-cfb": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-128-cfb8": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-192-cfb8": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-256-cfb8": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-128-cfb1": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-192-cfb1": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-256-cfb1": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-128-ofb": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-192-ofb": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-256-ofb": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-128-ctr": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-192-ctr": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-256-ctr": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-128-gcm": {
                        cipher: "AES",
                        key: 128,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    },
                    "aes-192-gcm": {
                        cipher: "AES",
                        key: 192,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    },
                    "aes-256-gcm": {
                        cipher: "AES",
                        key: 256,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    }
                };
            },
            {}
        ],
        204: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = e("buffer-xor");
                        function i(e) {
                            return e._prev = e._cipher.encryptBlock(e._prev), e._prev;
                        }
                        r.encrypt = function(e, r) {
                            for(; e._cache.length < r.length;)e._cache = t.concat([
                                e._cache,
                                i(e)
                            ]);
                            var s = e._cache.slice(0, r.length);
                            return e._cache = e._cache.slice(r.length), n(r, s);
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220,
                "buffer-xor": 219
            }
        ],
        205: [
            function(e, t, r) {
                "use strict";
                var n = e("./aes"), i = e("safe-buffer").Buffer, s = e("cipher-base");
                function o(e, t, r, o) {
                    s.call(this), this._cipher = new n.AES(t), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._mode = e;
                }
                e("inherits")(o, s), o.prototype._update = function(e) {
                    return this._mode.encrypt(this, e, this._decrypt);
                }, o.prototype._final = function() {
                    this._cipher.scrub();
                }, t.exports = o;
            },
            {
                "./aes": 189,
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        206: [
            function(e, t, r) {
                "use strict";
                var n = e("browserify-des"), i = e("browserify-aes/browser"), s = e("browserify-aes/modes"), o = e("browserify-des/modes"), a = e("evp_bytestokey");
                function l(e, t, r) {
                    if (e = e.toLowerCase(), s[e]) return i.createCipheriv(e, t, r);
                    if (o[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e
                    });
                    throw new TypeError("invalid suite type");
                }
                function c(e, t, r) {
                    if (e = e.toLowerCase(), s[e]) return i.createDecipheriv(e, t, r);
                    if (o[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e,
                        decrypt: !0
                    });
                    throw new TypeError("invalid suite type");
                }
                r.createCipher = r.Cipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), s[e]) r = s[e].key, n = s[e].iv;
                    else {
                        if (!o[e]) throw new TypeError("invalid suite type");
                        r = 8 * o[e].key, n = o[e].iv;
                    }
                    var i = a(t, !1, r, n);
                    return l(e, i.key, i.iv);
                }, r.createCipheriv = r.Cipheriv = l, r.createDecipher = r.Decipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), s[e]) r = s[e].key, n = s[e].iv;
                    else {
                        if (!o[e]) throw new TypeError("invalid suite type");
                        r = 8 * o[e].key, n = o[e].iv;
                    }
                    var i = a(t, !1, r, n);
                    return c(e, i.key, i.iv);
                }, r.createDecipheriv = r.Decipheriv = c, r.listCiphers = r.getCiphers = function() {
                    return Object.keys(o).concat(i.getCiphers());
                };
            },
            {
                "browserify-aes/browser": 191,
                "browserify-aes/modes": 202,
                "browserify-des": 207,
                "browserify-des/modes": 208,
                evp_bytestokey: 423
            }
        ],
        207: [
            function(e, t, r) {
                "use strict";
                var n = e("cipher-base"), i = e("des.js"), s = e("inherits"), o = e("safe-buffer").Buffer, a = {
                    "des-ede3-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede3": i.EDE,
                    "des-ede-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede": i.EDE,
                    "des-cbc": i.CBC.instantiate(i.DES),
                    "des-ecb": i.DES
                };
                function l(e) {
                    n.call(this);
                    var t, r = e.mode.toLowerCase(), i = a[r];
                    t = e.decrypt ? "decrypt" : "encrypt";
                    var s = e.key;
                    o.isBuffer(s) || (s = o.from(s)), "des-ede" !== r && "des-ede-cbc" !== r || (s = o.concat([
                        s,
                        s.slice(0, 8)
                    ]));
                    var l = e.iv;
                    o.isBuffer(l) || (l = o.from(l)), this._des = i.create({
                        key: s,
                        iv: l,
                        type: t
                    });
                }
                a.des = a["des-cbc"], a.des3 = a["des-ede3-cbc"], t.exports = l, s(l, n), l.prototype._update = function(e) {
                    return o.from(this._des.update(e));
                }, l.prototype._final = function() {
                    return o.from(this._des.final());
                };
            },
            {
                "cipher-base": 221,
                "des.js": 394,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        208: [
            function(e, t, r) {
                "use strict";
                r["des-ecb"] = {
                    key: 8,
                    iv: 0
                }, r["des-cbc"] = r.des = {
                    key: 8,
                    iv: 8
                }, r["des-ede3-cbc"] = r.des3 = {
                    key: 24,
                    iv: 8
                }, r["des-ede3"] = {
                    key: 24,
                    iv: 0
                }, r["des-ede-cbc"] = {
                    key: 16,
                    iv: 8
                }, r["des-ede"] = {
                    key: 16,
                    iv: 0
                };
            },
            {}
        ],
        209: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("bn.js"), i = e("randombytes");
                        function s(e) {
                            var t, r = e.modulus.byteLength();
                            do t = new n(i(r));
                            while (t.cmp(e.modulus) >= 0 || !t.umod(e.prime1) || !t.umod(e.prime2));
                            return t;
                        }
                        function o(e, t) {
                            var i = function(e) {
                                var t = s(e);
                                return {
                                    blinder: t.toRed(n.mont(e.modulus)).redPow(new n(e.publicExponent)).fromRed(),
                                    unblinder: t.invm(e.modulus)
                                };
                            }(t), o = t.modulus.byteLength(), a = new n(e).mul(i.blinder).umod(t.modulus), l = a.toRed(n.mont(t.prime1)), c = a.toRed(n.mont(t.prime2)), u = t.coefficient, h = t.prime1, f = t.prime2, d = l.redPow(t.exponent1).fromRed(), p = c.redPow(t.exponent2).fromRed(), m = d.isub(p).imul(u).umod(h).imul(f);
                            return p.iadd(m).imul(i.unblinder).umod(t.modulus).toArrayLike(r, "be", o);
                        }
                        o.getr = s, t.exports = o;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "bn.js": 186,
                buffer: 220,
                randombytes: 475
            }
        ],
        210: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./browser/algorithms.json");
            },
            {
                "./browser/algorithms.json": 211
            }
        ],
        211: [
            function(e, t, r) {
                t.exports = {
                    sha224WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha224",
                        id: "302d300d06096086480165030402040500041c"
                    },
                    "RSA-SHA224": {
                        sign: "ecdsa/rsa",
                        hash: "sha224",
                        id: "302d300d06096086480165030402040500041c"
                    },
                    sha256WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha256",
                        id: "3031300d060960864801650304020105000420"
                    },
                    "RSA-SHA256": {
                        sign: "ecdsa/rsa",
                        hash: "sha256",
                        id: "3031300d060960864801650304020105000420"
                    },
                    sha384WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha384",
                        id: "3041300d060960864801650304020205000430"
                    },
                    "RSA-SHA384": {
                        sign: "ecdsa/rsa",
                        hash: "sha384",
                        id: "3041300d060960864801650304020205000430"
                    },
                    sha512WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha512",
                        id: "3051300d060960864801650304020305000440"
                    },
                    "RSA-SHA512": {
                        sign: "ecdsa/rsa",
                        hash: "sha512",
                        id: "3051300d060960864801650304020305000440"
                    },
                    "RSA-SHA1": {
                        sign: "rsa",
                        hash: "sha1",
                        id: "3021300906052b0e03021a05000414"
                    },
                    "ecdsa-with-SHA1": {
                        sign: "ecdsa",
                        hash: "sha1",
                        id: ""
                    },
                    sha256: {
                        sign: "ecdsa",
                        hash: "sha256",
                        id: ""
                    },
                    sha224: {
                        sign: "ecdsa",
                        hash: "sha224",
                        id: ""
                    },
                    sha384: {
                        sign: "ecdsa",
                        hash: "sha384",
                        id: ""
                    },
                    sha512: {
                        sign: "ecdsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-SHA": {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    "DSA-SHA1": {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    DSA: {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    "DSA-WITH-SHA224": {
                        sign: "dsa",
                        hash: "sha224",
                        id: ""
                    },
                    "DSA-SHA224": {
                        sign: "dsa",
                        hash: "sha224",
                        id: ""
                    },
                    "DSA-WITH-SHA256": {
                        sign: "dsa",
                        hash: "sha256",
                        id: ""
                    },
                    "DSA-SHA256": {
                        sign: "dsa",
                        hash: "sha256",
                        id: ""
                    },
                    "DSA-WITH-SHA384": {
                        sign: "dsa",
                        hash: "sha384",
                        id: ""
                    },
                    "DSA-SHA384": {
                        sign: "dsa",
                        hash: "sha384",
                        id: ""
                    },
                    "DSA-WITH-SHA512": {
                        sign: "dsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-SHA512": {
                        sign: "dsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-RIPEMD160": {
                        sign: "dsa",
                        hash: "rmd160",
                        id: ""
                    },
                    ripemd160WithRSA: {
                        sign: "rsa",
                        hash: "rmd160",
                        id: "3021300906052b2403020105000414"
                    },
                    "RSA-RIPEMD160": {
                        sign: "rsa",
                        hash: "rmd160",
                        id: "3021300906052b2403020105000414"
                    },
                    md5WithRSAEncryption: {
                        sign: "rsa",
                        hash: "md5",
                        id: "3020300c06082a864886f70d020505000410"
                    },
                    "RSA-MD5": {
                        sign: "rsa",
                        hash: "md5",
                        id: "3020300c06082a864886f70d020505000410"
                    }
                };
            },
            {}
        ],
        212: [
            function(e, t, r) {
                t.exports = {
                    "1.3.132.0.10": "secp256k1",
                    "1.3.132.0.33": "p224",
                    "1.2.840.10045.3.1.1": "p192",
                    "1.2.840.10045.3.1.7": "p256",
                    "1.3.132.0.34": "p384",
                    "1.3.132.0.35": "p521"
                };
            },
            {}
        ],
        213: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("create-hash"), s = e("readable-stream"), o = e("inherits"), a = e("./sign"), l = e("./verify"), c = e("./algorithms.json");
                function u(e) {
                    s.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hashType = t.hash, this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function h(e) {
                    s.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function f(e) {
                    return new u(e);
                }
                function d(e) {
                    return new h(e);
                }
                Object.keys(c).forEach(function(e) {
                    c[e].id = n.from(c[e].id, "hex"), c[e.toLowerCase()] = c[e];
                }), o(u, s.Writable), u.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, u.prototype.update = function(e, t) {
                    return "string" == typeof e && (e = n.from(e, t)), this._hash.update(e), this;
                }, u.prototype.sign = function(e, t) {
                    this.end();
                    var r = this._hash.digest(), n = a(r, e, this._hashType, this._signType, this._tag);
                    return t ? n.toString(t) : n;
                }, o(h, s.Writable), h.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, h.prototype.update = function(e, t) {
                    return "string" == typeof e && (e = n.from(e, t)), this._hash.update(e), this;
                }, h.prototype.verify = function(e, t, r) {
                    "string" == typeof t && (t = n.from(t, r)), this.end();
                    var i = this._hash.digest();
                    return l(t, i, e, this._signType, this._tag);
                }, t.exports = {
                    Sign: f,
                    Verify: d,
                    createSign: f,
                    createVerify: d
                };
            },
            {
                "./algorithms.json": 211,
                "./sign": 214,
                "./verify": 215,
                "create-hash": 386,
                inherits: 440,
                "readable-stream": 491,
                "safe-buffer": 494
            }
        ],
        214: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("create-hmac"), s = e("browserify-rsa"), o = e("elliptic").ec, a = e("bn.js"), l = e("parse-asn1"), c = e("./curves.json");
                function u(e, t, r, s) {
                    if ((e = n.from(e.toArray())).length < t.byteLength()) {
                        var o = n.alloc(t.byteLength() - e.length);
                        e = n.concat([
                            o,
                            e
                        ]);
                    }
                    var a = r.length, l = function(e, t) {
                        e = (e = h(e, t)).mod(t);
                        var r = n.from(e.toArray());
                        if (r.length < t.byteLength()) {
                            var i = n.alloc(t.byteLength() - r.length);
                            r = n.concat([
                                i,
                                r
                            ]);
                        }
                        return r;
                    }(r, t), c = n.alloc(a);
                    c.fill(1);
                    var u = n.alloc(a);
                    return u = i(s, u).update(c).update(n.from([
                        0
                    ])).update(e).update(l).digest(), c = i(s, u).update(c).digest(), {
                        k: u = i(s, u).update(c).update(n.from([
                            1
                        ])).update(e).update(l).digest(),
                        v: c = i(s, u).update(c).digest()
                    };
                }
                function h(e, t) {
                    var r = new a(e), n = (e.length << 3) - t.bitLength();
                    return n > 0 && r.ishrn(n), r;
                }
                function f(e, t, r) {
                    var s, o;
                    do {
                        for(s = n.alloc(0); 8 * s.length < e.bitLength();)t.v = i(r, t.k).update(t.v).digest(), s = n.concat([
                            s,
                            t.v
                        ]);
                        o = h(s, e), t.k = i(r, t.k).update(t.v).update(n.from([
                            0
                        ])).digest(), t.v = i(r, t.k).update(t.v).digest();
                    }while (-1 !== o.cmp(e));
                    return o;
                }
                function d(e, t, r, n) {
                    return e.toRed(a.mont(r)).redPow(t).fromRed().mod(n);
                }
                t.exports = function(e, t, r, i, p) {
                    var m = l(t);
                    if (m.curve) {
                        if ("ecdsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                        return function(e, t) {
                            var r = c[t.curve.join(".")];
                            if (!r) throw new Error("unknown curve " + t.curve.join("."));
                            var i = new o(r).keyFromPrivate(t.privateKey).sign(e);
                            return n.from(i.toDER());
                        }(e, m);
                    }
                    if ("dsa" === m.type) {
                        if ("dsa" !== i) throw new Error("wrong private key type");
                        return function(e, t, r) {
                            var i, s = t.params.priv_key, o = t.params.p, l = t.params.q, c = t.params.g, p = new a(0), m = h(e, l).mod(l), b = !1, g = u(s, l, e, r);
                            for(; !1 === b;)i = f(l, g, r), p = d(c, i, o, l), 0 === (b = i.invm(l).imul(m.add(s.mul(p))).mod(l)).cmpn(0) && (b = !1, p = new a(0));
                            return function(e, t) {
                                e = e.toArray(), t = t.toArray(), 128 & e[0] && (e = [
                                    0
                                ].concat(e));
                                128 & t[0] && (t = [
                                    0
                                ].concat(t));
                                var r = [
                                    48,
                                    e.length + t.length + 4,
                                    2,
                                    e.length
                                ];
                                return r = r.concat(e, [
                                    2,
                                    t.length
                                ], t), n.from(r);
                            }(p, b);
                        }(e, m, r);
                    }
                    if ("rsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                    e = n.concat([
                        p,
                        e
                    ]);
                    for(var b = m.modulus.byteLength(), g = [
                        0,
                        1
                    ]; e.length + g.length + 1 < b;)g.push(255);
                    g.push(0);
                    for(var y = -1; ++y < e.length;)g.push(e[y]);
                    return s(g, m);
                }, t.exports.getKey = u, t.exports.makeKey = f;
            },
            {
                "./curves.json": 212,
                "bn.js": 186,
                "browserify-rsa": 209,
                "create-hmac": 388,
                elliptic: 405,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        215: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("bn.js"), s = e("elliptic").ec, o = e("parse-asn1"), a = e("./curves.json");
                function l(e, t) {
                    if (e.cmpn(0) <= 0) throw new Error("invalid sig");
                    if (e.cmp(t) >= t) throw new Error("invalid sig");
                }
                t.exports = function(e, t, r, c, u) {
                    var h = o(r);
                    if ("ec" === h.type) {
                        if ("ecdsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = a[r.data.algorithm.curve.join(".")];
                            if (!n) throw new Error("unknown curve " + r.data.algorithm.curve.join("."));
                            var i = new s(n), o = r.data.subjectPrivateKey.data;
                            return i.verify(t, e, o);
                        }(e, t, h);
                    }
                    if ("dsa" === h.type) {
                        if ("dsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = r.data.p, s = r.data.q, a = r.data.g, c = r.data.pub_key, u = o.signature.decode(e, "der"), h = u.s, f = u.r;
                            l(h, s), l(f, s);
                            var d = i.mont(n), p = h.invm(s);
                            return 0 === a.toRed(d).redPow(new i(t).mul(p).mod(s)).fromRed().mul(c.toRed(d).redPow(f.mul(p).mod(s)).fromRed()).mod(n).mod(s).cmp(f);
                        }(e, t, h);
                    }
                    if ("rsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                    t = n.concat([
                        u,
                        t
                    ]);
                    for(var f = h.modulus.byteLength(), d = [
                        1
                    ], p = 0; t.length + d.length + 2 < f;)d.push(255), p++;
                    d.push(0);
                    for(var m = -1; ++m < t.length;)d.push(t[m]);
                    d = n.from(d);
                    var b = i.mont(h.modulus);
                    e = (e = new i(e).toRed(b)).redPow(new i(h.publicExponent)), e = n.from(e.fromRed().toArray());
                    var g = p < 8 ? 1 : 0;
                    for(f = Math.min(e.length, d.length), e.length !== d.length && (g = 1), m = -1; ++m < f;)g |= e[m] ^ d[m];
                    return 0 === g;
                };
            },
            {
                "./curves.json": 212,
                "bn.js": 186,
                elliptic: 405,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        216: [
            function(e, t, r) {},
            {}
        ],
        217: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer"), i = n.Buffer;
                function s(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function o(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (s(n, r), r.Buffer = o), s(i, o), o.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, o.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, o.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, o.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            {
                buffer: 220
            }
        ],
        218: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = n.isEncoding || function(e) {
                    switch((e = "" + e) && e.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return !0;
                        default:
                            return !1;
                    }
                };
                function s(e) {
                    var t;
                    switch(this.encoding = function(e) {
                        var t = function(e) {
                            if (!e) return "utf8";
                            for(var t;;)switch(e){
                                case "utf8":
                                case "utf-8":
                                    return "utf8";
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return "utf16le";
                                case "latin1":
                                case "binary":
                                    return "latin1";
                                case "base64":
                                case "ascii":
                                case "hex":
                                    return e;
                                default:
                                    if (t) return;
                                    e = ("" + e).toLowerCase(), t = !0;
                            }
                        }(e);
                        if ("string" != typeof t && (n.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
                        return t || e;
                    }(e), this.encoding){
                        case "utf16le":
                            this.text = l, this.end = c, t = 4;
                            break;
                        case "utf8":
                            this.fillLast = a, t = 4;
                            break;
                        case "base64":
                            this.text = u, this.end = h, t = 3;
                            break;
                        default:
                            return this.write = f, void (this.end = d);
                    }
                    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t);
                }
                function o(e) {
                    return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
                }
                function a(e) {
                    var t = this.lastTotal - this.lastNeed, r = function(e, t, r) {
                        if (128 != (192 & t[0])) return e.lastNeed = 0, "\ufffd";
                        if (e.lastNeed > 1 && t.length > 1) {
                            if (128 != (192 & t[1])) return e.lastNeed = 1, "\ufffd";
                            if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "\ufffd";
                        }
                    }(this, e);
                    return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
                }
                function l(e, t) {
                    if ((e.length - t) % 2 == 0) {
                        var r = e.toString("utf16le", t);
                        if (r) {
                            var n = r.charCodeAt(r.length - 1);
                            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
                        }
                        return r;
                    }
                    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
                }
                function c(e) {
                    var t = e && e.length ? this.write(e) : "";
                    if (this.lastNeed) {
                        var r = this.lastTotal - this.lastNeed;
                        return t + this.lastChar.toString("utf16le", 0, r);
                    }
                    return t;
                }
                function u(e, t) {
                    var r = (e.length - t) % 3;
                    return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
                }
                function h(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
                }
                function f(e) {
                    return e.toString(this.encoding);
                }
                function d(e) {
                    return e && e.length ? this.write(e) : "";
                }
                r.StringDecoder = s, s.prototype.write = function(e) {
                    if (0 === e.length) return "";
                    var t, r;
                    if (this.lastNeed) {
                        if (void 0 === (t = this.fillLast(e))) return "";
                        r = this.lastNeed, this.lastNeed = 0;
                    } else r = 0;
                    return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
                }, s.prototype.end = function(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + "\ufffd" : t;
                }, s.prototype.text = function(e, t) {
                    var r = function(e, t, r) {
                        var n = t.length - 1;
                        if (n < r) return 0;
                        var i = o(t[n]);
                        if (i >= 0) return i > 0 && (e.lastNeed = i - 1), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(t[n])) >= 0) return i > 0 && (e.lastNeed = i - 2), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(t[n])) >= 0) return i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i;
                        return 0;
                    }(this, e, t);
                    if (!this.lastNeed) return e.toString("utf8", t);
                    this.lastTotal = r;
                    var n = e.length - (r - this.lastNeed);
                    return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
                }, s.prototype.fillLast = function(e) {
                    if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
                };
            },
            {
                "safe-buffer": 217
            }
        ],
        219: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        t.exports = function(t, r) {
                            for(var n = Math.min(t.length, r.length), i = new e(n), s = 0; s < n; ++s)i[s] = t[s] ^ r[s];
                            return i;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220
            }
        ],
        220: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ "use strict";
                        var t = e("base64-js"), n = e("ieee754");
                        r.Buffer = s, r.SlowBuffer = function(e) {
                            +e != e && (e = 0);
                            return s.alloc(+e);
                        }, r.INSPECT_MAX_BYTES = 50;
                        function i(e) {
                            if (e > 2147483647) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var t = new Uint8Array(e);
                            return t.__proto__ = s.prototype, t;
                        }
                        function s(e, t, r) {
                            if ("number" == typeof e) {
                                if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                                return l(e);
                            }
                            return o(e, t, r);
                        }
                        function o(e, t, r) {
                            if ("string" == typeof e) return function(e, t) {
                                "string" == typeof t && "" !== t || (t = "utf8");
                                if (!s.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
                                var r = 0 | h(e, t), n = i(r), o = n.write(e, t);
                                o !== r && (n = n.slice(0, o));
                                return n;
                            }(e, t);
                            if (ArrayBuffer.isView(e)) return c(e);
                            if (null == e) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            if (F(e, ArrayBuffer) || e && F(e.buffer, ArrayBuffer)) return function(e, t, r) {
                                if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
                                if (e.byteLength < t + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                var n;
                                n = void 0 === t && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, t) : new Uint8Array(e, t, r);
                                return n.__proto__ = s.prototype, n;
                            }(e, t, r);
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
                            var n = e.valueOf && e.valueOf();
                            if (null != n && n !== e) return s.from(n, t, r);
                            var o = function(e) {
                                if (s.isBuffer(e)) {
                                    var t = 0 | u(e.length), r = i(t);
                                    return 0 === r.length || e.copy(r, 0, 0, t), r;
                                }
                                if (void 0 !== e.length) return "number" != typeof e.length || L(e.length) ? i(0) : c(e);
                                if ("Buffer" === e.type && Array.isArray(e.data)) return c(e.data);
                            }(e);
                            if (o) return o;
                            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return s.from(e[Symbol.toPrimitive]("string"), t, r);
                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                        }
                        function a(e) {
                            if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
                            if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                        }
                        function l(e) {
                            return a(e), i(e < 0 ? 0 : 0 | u(e));
                        }
                        function c(e) {
                            for(var t = e.length < 0 ? 0 : 0 | u(e.length), r = i(t), n = 0; n < t; n += 1)r[n] = 255 & e[n];
                            return r;
                        }
                        function u(e) {
                            if (e >= 2147483647) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + 2147483647..toString(16) + " bytes");
                            return 0 | e;
                        }
                        function h(e, t) {
                            if (s.isBuffer(e)) return e.length;
                            if (ArrayBuffer.isView(e) || F(e, ArrayBuffer)) return e.byteLength;
                            if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
                            var r = e.length, n = arguments.length > 2 && !0 === arguments[2];
                            if (!n && 0 === r) return 0;
                            for(var i = !1;;)switch(t){
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return r;
                                case "utf8":
                                case "utf-8":
                                    return P(e).length;
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return 2 * r;
                                case "hex":
                                    return r >>> 1;
                                case "base64":
                                    return B(e).length;
                                default:
                                    if (i) return n ? -1 : P(e).length;
                                    t = ("" + t).toLowerCase(), i = !0;
                            }
                        }
                        function f(e, t, r) {
                            var n = !1;
                            if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
                            if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                            if ((r >>>= 0) <= (t >>>= 0)) return "";
                            for(e || (e = "utf8");;)switch(e){
                                case "hex":
                                    return C(this, t, r);
                                case "utf8":
                                case "utf-8":
                                    return k(this, t, r);
                                case "ascii":
                                    return S(this, t, r);
                                case "latin1":
                                case "binary":
                                    return M(this, t, r);
                                case "base64":
                                    return x(this, t, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return T(this, t, r);
                                default:
                                    if (n) throw new TypeError("Unknown encoding: " + e);
                                    e = (e + "").toLowerCase(), n = !0;
                            }
                        }
                        function d(e, t, r) {
                            var n = e[t];
                            e[t] = e[r], e[r] = n;
                        }
                        function p(e, t, r, n, i) {
                            if (0 === e.length) return -1;
                            if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), L(r = +r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                                if (i) return -1;
                                r = e.length - 1;
                            } else if (r < 0) {
                                if (!i) return -1;
                                r = 0;
                            }
                            if ("string" == typeof t && (t = s.from(t, n)), s.isBuffer(t)) return 0 === t.length ? -1 : m(e, t, r, n, i);
                            if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : m(e, [
                                t
                            ], r, n, i);
                            throw new TypeError("val must be string, number or Buffer");
                        }
                        function m(e, t, r, n, i) {
                            var s, o = 1, a = e.length, l = t.length;
                            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                                if (e.length < 2 || t.length < 2) return -1;
                                o = 2, a /= 2, l /= 2, r /= 2;
                            }
                            function c(e, t) {
                                return 1 === o ? e[t] : e.readUInt16BE(t * o);
                            }
                            if (i) {
                                var u = -1;
                                for(s = r; s < a; s++)if (c(e, s) === c(t, -1 === u ? 0 : s - u)) {
                                    if (-1 === u && (u = s), s - u + 1 === l) return u * o;
                                } else -1 !== u && (s -= s - u), u = -1;
                            } else for(r + l > a && (r = a - l), s = r; s >= 0; s--){
                                for(var h = !0, f = 0; f < l; f++)if (c(e, s + f) !== c(t, f)) {
                                    h = !1;
                                    break;
                                }
                                if (h) return s;
                            }
                            return -1;
                        }
                        function b(e, t, r, n) {
                            r = Number(r) || 0;
                            var i = e.length - r;
                            n ? (n = Number(n)) > i && (n = i) : n = i;
                            var s = t.length;
                            n > s / 2 && (n = s / 2);
                            for(var o = 0; o < n; ++o){
                                var a = parseInt(t.substr(2 * o, 2), 16);
                                if (L(a)) return o;
                                e[r + o] = a;
                            }
                            return o;
                        }
                        function g(e, t, r, n) {
                            return D(P(t, e.length - r), e, r, n);
                        }
                        function y(e, t, r, n) {
                            return D(function(e) {
                                for(var t = [], r = 0; r < e.length; ++r)t.push(255 & e.charCodeAt(r));
                                return t;
                            }(t), e, r, n);
                        }
                        function v(e, t, r, n) {
                            return y(e, t, r, n);
                        }
                        function w(e, t, r, n) {
                            return D(B(t), e, r, n);
                        }
                        function _(e, t, r, n) {
                            return D(function(e, t) {
                                for(var r, n, i, s = [], o = 0; o < e.length && !((t -= 2) < 0); ++o)r = e.charCodeAt(o), n = r >> 8, i = r % 256, s.push(i), s.push(n);
                                return s;
                            }(t, e.length - r), e, r, n);
                        }
                        function x(e, r, n) {
                            return 0 === r && n === e.length ? t.fromByteArray(e) : t.fromByteArray(e.slice(r, n));
                        }
                        function k(e, t, r) {
                            r = Math.min(e.length, r);
                            for(var n = [], i = t; i < r;){
                                var s, o, a, l, c = e[i], u = null, h = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
                                if (i + h <= r) switch(h){
                                    case 1:
                                        c < 128 && (u = c);
                                        break;
                                    case 2:
                                        128 == (192 & (s = e[i + 1])) && (l = (31 & c) << 6 | 63 & s) > 127 && (u = l);
                                        break;
                                    case 3:
                                        s = e[i + 1], o = e[i + 2], 128 == (192 & s) && 128 == (192 & o) && (l = (15 & c) << 12 | (63 & s) << 6 | 63 & o) > 2047 && (l < 55296 || l > 57343) && (u = l);
                                        break;
                                    case 4:
                                        s = e[i + 1], o = e[i + 2], a = e[i + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && (l = (15 & c) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a) > 65535 && l < 1114112 && (u = l);
                                }
                                null === u ? (u = 65533, h = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += h;
                            }
                            return function(e) {
                                var t = e.length;
                                if (t <= 4096) return String.fromCharCode.apply(String, e);
                                var r = "", n = 0;
                                for(; n < t;)r += String.fromCharCode.apply(String, e.slice(n, n += 4096));
                                return r;
                            }(n);
                        }
                        r.kMaxLength = 2147483647, s.TYPED_ARRAY_SUPPORT = function() {
                            try {
                                var e = new Uint8Array(1);
                                return e.__proto__ = {
                                    __proto__: Uint8Array.prototype,
                                    foo: function() {
                                        return 42;
                                    }
                                }, 42 === e.foo();
                            } catch (e) {
                                return !1;
                            }
                        }(), s.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(s.prototype, "parent", {
                            enumerable: !0,
                            get: function() {
                                if (s.isBuffer(this)) return this.buffer;
                            }
                        }), Object.defineProperty(s.prototype, "offset", {
                            enumerable: !0,
                            get: function() {
                                if (s.isBuffer(this)) return this.byteOffset;
                            }
                        }), "undefined" != typeof Symbol && null != Symbol.species && s[Symbol.species] === s && Object.defineProperty(s, Symbol.species, {
                            value: null,
                            configurable: !0,
                            enumerable: !1,
                            writable: !1
                        }), s.poolSize = 8192, s.from = function(e, t, r) {
                            return o(e, t, r);
                        }, s.prototype.__proto__ = Uint8Array.prototype, s.__proto__ = Uint8Array, s.alloc = function(e, t, r) {
                            return function(e, t, r) {
                                return a(e), e <= 0 ? i(e) : void 0 !== t ? "string" == typeof r ? i(e).fill(t, r) : i(e).fill(t) : i(e);
                            }(e, t, r);
                        }, s.allocUnsafe = function(e) {
                            return l(e);
                        }, s.allocUnsafeSlow = function(e) {
                            return l(e);
                        }, s.isBuffer = function(e) {
                            return null != e && !0 === e._isBuffer && e !== s.prototype;
                        }, s.compare = function(e, t) {
                            if (F(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), F(t, Uint8Array) && (t = s.from(t, t.offset, t.byteLength)), !s.isBuffer(e) || !s.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                            if (e === t) return 0;
                            for(var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i)if (e[i] !== t[i]) {
                                r = e[i], n = t[i];
                                break;
                            }
                            return r < n ? -1 : n < r ? 1 : 0;
                        }, s.isEncoding = function(e) {
                            switch(String(e).toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "latin1":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }, s.concat = function(e, t) {
                            if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (0 === e.length) return s.alloc(0);
                            var r;
                            if (void 0 === t) for(t = 0, r = 0; r < e.length; ++r)t += e[r].length;
                            var n = s.allocUnsafe(t), i = 0;
                            for(r = 0; r < e.length; ++r){
                                var o = e[r];
                                if (F(o, Uint8Array) && (o = s.from(o)), !s.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
                                o.copy(n, i), i += o.length;
                            }
                            return n;
                        }, s.byteLength = h, s.prototype._isBuffer = !0, s.prototype.swap16 = function() {
                            var e = this.length;
                            if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                            for(var t = 0; t < e; t += 2)d(this, t, t + 1);
                            return this;
                        }, s.prototype.swap32 = function() {
                            var e = this.length;
                            if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                            for(var t = 0; t < e; t += 4)d(this, t, t + 3), d(this, t + 1, t + 2);
                            return this;
                        }, s.prototype.swap64 = function() {
                            var e = this.length;
                            if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                            for(var t = 0; t < e; t += 8)d(this, t, t + 7), d(this, t + 1, t + 6), d(this, t + 2, t + 5), d(this, t + 3, t + 4);
                            return this;
                        }, s.prototype.toString = function() {
                            var e = this.length;
                            return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : f.apply(this, arguments);
                        }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(e) {
                            if (!s.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                            return this === e || 0 === s.compare(this, e);
                        }, s.prototype.inspect = function() {
                            var e = "", t = r.INSPECT_MAX_BYTES;
                            return e = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim(), this.length > t && (e += " ... "), "<Buffer " + e + ">";
                        }, s.prototype.compare = function(e, t, r, n, i) {
                            if (F(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), !s.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
                            if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                            if (n >= i && t >= r) return 0;
                            if (n >= i) return -1;
                            if (t >= r) return 1;
                            if (this === e) return 0;
                            for(var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0), l = Math.min(o, a), c = this.slice(n, i), u = e.slice(t, r), h = 0; h < l; ++h)if (c[h] !== u[h]) {
                                o = c[h], a = u[h];
                                break;
                            }
                            return o < a ? -1 : a < o ? 1 : 0;
                        }, s.prototype.includes = function(e, t, r) {
                            return -1 !== this.indexOf(e, t, r);
                        }, s.prototype.indexOf = function(e, t, r) {
                            return p(this, e, t, r, !0);
                        }, s.prototype.lastIndexOf = function(e, t, r) {
                            return p(this, e, t, r, !1);
                        }, s.prototype.write = function(e, t, r, n) {
                            if (void 0 === t) n = "utf8", r = this.length, t = 0;
                            else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;
                            else {
                                if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                            }
                            var i = this.length - t;
                            if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                            n || (n = "utf8");
                            for(var s = !1;;)switch(n){
                                case "hex":
                                    return b(this, e, t, r);
                                case "utf8":
                                case "utf-8":
                                    return g(this, e, t, r);
                                case "ascii":
                                    return y(this, e, t, r);
                                case "latin1":
                                case "binary":
                                    return v(this, e, t, r);
                                case "base64":
                                    return w(this, e, t, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return _(this, e, t, r);
                                default:
                                    if (s) throw new TypeError("Unknown encoding: " + n);
                                    n = ("" + n).toLowerCase(), s = !0;
                            }
                        }, s.prototype.toJSON = function() {
                            return {
                                type: "Buffer",
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        };
                        function S(e, t, r) {
                            var n = "";
                            r = Math.min(e.length, r);
                            for(var i = t; i < r; ++i)n += String.fromCharCode(127 & e[i]);
                            return n;
                        }
                        function M(e, t, r) {
                            var n = "";
                            r = Math.min(e.length, r);
                            for(var i = t; i < r; ++i)n += String.fromCharCode(e[i]);
                            return n;
                        }
                        function C(e, t, r) {
                            var n = e.length;
                            (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
                            for(var i = "", s = t; s < r; ++s)i += N(e[s]);
                            return i;
                        }
                        function T(e, t, r) {
                            for(var n = e.slice(t, r), i = "", s = 0; s < n.length; s += 2)i += String.fromCharCode(n[s] + 256 * n[s + 1]);
                            return i;
                        }
                        function E(e, t, r) {
                            if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
                            if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
                        }
                        function A(e, t, r, n, i, o) {
                            if (!s.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
                            if (r + n > e.length) throw new RangeError("Index out of range");
                        }
                        function R(e, t, r, n, i, s) {
                            if (r + n > e.length) throw new RangeError("Index out of range");
                            if (r < 0) throw new RangeError("Index out of range");
                        }
                        function O(e, t, r, i, s) {
                            return t = +t, r >>>= 0, s || R(e, 0, r, 4), n.write(e, t, r, i, 23, 4), r + 4;
                        }
                        function j(e, t, r, i, s) {
                            return t = +t, r >>>= 0, s || R(e, 0, r, 8), n.write(e, t, r, i, 52, 8), r + 8;
                        }
                        s.prototype.slice = function(e, t) {
                            var r = this.length;
                            (e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e);
                            var n = this.subarray(e, t);
                            return n.__proto__ = s.prototype, n;
                        }, s.prototype.readUIntLE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);)n += this[e + s] * i;
                            return n;
                        }, s.prototype.readUIntBE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e + --t], i = 1; t > 0 && (i *= 256);)n += this[e + --t] * i;
                            return n;
                        }, s.prototype.readUInt8 = function(e, t) {
                            return e >>>= 0, t || E(e, 1, this.length), this[e];
                        }, s.prototype.readUInt16LE = function(e, t) {
                            return e >>>= 0, t || E(e, 2, this.length), this[e] | this[e + 1] << 8;
                        }, s.prototype.readUInt16BE = function(e, t) {
                            return e >>>= 0, t || E(e, 2, this.length), this[e] << 8 | this[e + 1];
                        }, s.prototype.readUInt32LE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                        }, s.prototype.readUInt32BE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                        }, s.prototype.readIntLE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);)n += this[e + s] * i;
                            return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
                        }, s.prototype.readIntBE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = t, i = 1, s = this[e + --n]; n > 0 && (i *= 256);)s += this[e + --n] * i;
                            return s >= (i *= 128) && (s -= Math.pow(2, 8 * t)), s;
                        }, s.prototype.readInt8 = function(e, t) {
                            return e >>>= 0, t || E(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                        }, s.prototype.readInt16LE = function(e, t) {
                            e >>>= 0, t || E(e, 2, this.length);
                            var r = this[e] | this[e + 1] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, s.prototype.readInt16BE = function(e, t) {
                            e >>>= 0, t || E(e, 2, this.length);
                            var r = this[e + 1] | this[e] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, s.prototype.readInt32LE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                        }, s.prototype.readInt32BE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                        }, s.prototype.readFloatLE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), n.read(this, e, !0, 23, 4);
                        }, s.prototype.readFloatBE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), n.read(this, e, !1, 23, 4);
                        }, s.prototype.readDoubleLE = function(e, t) {
                            return e >>>= 0, t || E(e, 8, this.length), n.read(this, e, !0, 52, 8);
                        }, s.prototype.readDoubleBE = function(e, t) {
                            return e >>>= 0, t || E(e, 8, this.length), n.read(this, e, !1, 52, 8);
                        }, s.prototype.writeUIntLE = function(e, t, r, n) {
                            (e = +e, t >>>= 0, r >>>= 0, n) || A(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = 1, s = 0;
                            for(this[t] = 255 & e; ++s < r && (i *= 256);)this[t + s] = e / i & 255;
                            return t + r;
                        }, s.prototype.writeUIntBE = function(e, t, r, n) {
                            (e = +e, t >>>= 0, r >>>= 0, n) || A(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = r - 1, s = 1;
                            for(this[t + i] = 255 & e; --i >= 0 && (s *= 256);)this[t + i] = e / s & 255;
                            return t + r;
                        }, s.prototype.writeUInt8 = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeUInt16LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeUInt16BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeUInt32LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
                        }, s.prototype.writeUInt32BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeIntLE = function(e, t, r, n) {
                            if (e = +e, t >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                A(this, e, t, r, i - 1, -i);
                            }
                            var s = 0, o = 1, a = 0;
                            for(this[t] = 255 & e; ++s < r && (o *= 256);)e < 0 && 0 === a && 0 !== this[t + s - 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
                            return t + r;
                        }, s.prototype.writeIntBE = function(e, t, r, n) {
                            if (e = +e, t >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                A(this, e, t, r, i - 1, -i);
                            }
                            var s = r - 1, o = 1, a = 0;
                            for(this[t + s] = 255 & e; --s >= 0 && (o *= 256);)e < 0 && 0 === a && 0 !== this[t + s + 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
                            return t + r;
                        }, s.prototype.writeInt8 = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeInt16LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeInt16BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeInt32LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
                        }, s.prototype.writeInt32BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeFloatLE = function(e, t, r) {
                            return O(this, e, t, !0, r);
                        }, s.prototype.writeFloatBE = function(e, t, r) {
                            return O(this, e, t, !1, r);
                        }, s.prototype.writeDoubleLE = function(e, t, r) {
                            return j(this, e, t, !0, r);
                        }, s.prototype.writeDoubleBE = function(e, t, r) {
                            return j(this, e, t, !1, r);
                        }, s.prototype.copy = function(e, t, r, n) {
                            if (!s.isBuffer(e)) throw new TypeError("argument should be a Buffer");
                            if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
                            if (0 === e.length || 0 === this.length) return 0;
                            if (t < 0) throw new RangeError("targetStart out of bounds");
                            if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                            if (n < 0) throw new RangeError("sourceEnd out of bounds");
                            n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
                            var i = n - r;
                            if (this === e && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t, r, n);
                            else if (this === e && r < t && t < n) for(var o = i - 1; o >= 0; --o)e[o + t] = this[o + r];
                            else Uint8Array.prototype.set.call(e, this.subarray(r, n), t);
                            return i;
                        }, s.prototype.fill = function(e, t, r, n) {
                            if ("string" == typeof e) {
                                if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                                if ("string" == typeof n && !s.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                                if (1 === e.length) {
                                    var i = e.charCodeAt(0);
                                    ("utf8" === n && i < 128 || "latin1" === n) && (e = i);
                                }
                            } else "number" == typeof e && (e &= 255);
                            if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                            if (r <= t) return this;
                            var o;
                            if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for(o = t; o < r; ++o)this[o] = e;
                            else {
                                var a = s.isBuffer(e) ? e : s.from(e, n), l = a.length;
                                if (0 === l) throw new TypeError('The value "' + e + '" is invalid for argument "value"');
                                for(o = 0; o < r - t; ++o)this[o + t] = a[o % l];
                            }
                            return this;
                        };
                        var I = /[^+/0-9A-Za-z-_]/g;
                        function N(e) {
                            return e < 16 ? "0" + e.toString(16) : e.toString(16);
                        }
                        function P(e, t) {
                            var r;
                            t = t || 1 / 0;
                            for(var n = e.length, i = null, s = [], o = 0; o < n; ++o){
                                if ((r = e.charCodeAt(o)) > 55295 && r < 57344) {
                                    if (!i) {
                                        if (r > 56319) {
                                            (t -= 3) > -1 && s.push(239, 191, 189);
                                            continue;
                                        }
                                        if (o + 1 === n) {
                                            (t -= 3) > -1 && s.push(239, 191, 189);
                                            continue;
                                        }
                                        i = r;
                                        continue;
                                    }
                                    if (r < 56320) {
                                        (t -= 3) > -1 && s.push(239, 191, 189), i = r;
                                        continue;
                                    }
                                    r = 65536 + (i - 55296 << 10 | r - 56320);
                                } else i && (t -= 3) > -1 && s.push(239, 191, 189);
                                if (i = null, r < 128) {
                                    if ((t -= 1) < 0) break;
                                    s.push(r);
                                } else if (r < 2048) {
                                    if ((t -= 2) < 0) break;
                                    s.push(r >> 6 | 192, 63 & r | 128);
                                } else if (r < 65536) {
                                    if ((t -= 3) < 0) break;
                                    s.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                                } else {
                                    if (!(r < 1114112)) throw new Error("Invalid code point");
                                    if ((t -= 4) < 0) break;
                                    s.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                                }
                            }
                            return s;
                        }
                        function B(e) {
                            return t.toByteArray(function(e) {
                                if ((e = (e = e.split("=")[0]).trim().replace(I, "")).length < 2) return "";
                                for(; e.length % 4 != 0;)e += "=";
                                return e;
                            }(e));
                        }
                        function D(e, t, r, n) {
                            for(var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i)t[i + r] = e[i];
                            return i;
                        }
                        function F(e, t) {
                            return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
                        }
                        function L(e) {
                            return e != e;
                        }
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "base64-js": 185,
                buffer: 220,
                ieee754: 439
            }
        ],
        221: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("stream").Transform, s = e("string_decoder").StringDecoder;
                function o(e) {
                    i.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
                }
                e("inherits")(o, i), o.prototype.update = function(e, t, r) {
                    "string" == typeof e && (e = n.from(e, t));
                    var i = this._update(e);
                    return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
                }, o.prototype.setAutoPadding = function() {}, o.prototype.getAuthTag = function() {
                    throw new Error("trying to get auth tag in unsupported state");
                }, o.prototype.setAuthTag = function() {
                    throw new Error("trying to set auth tag in unsupported state");
                }, o.prototype.setAAD = function() {
                    throw new Error("trying to set aad in unsupported state");
                }, o.prototype._transform = function(e, t, r) {
                    var n;
                    try {
                        this.hashMode ? this._update(e) : this.push(this._update(e));
                    } catch (e) {
                        n = e;
                    } finally{
                        r(n);
                    }
                }, o.prototype._flush = function(e) {
                    var t;
                    try {
                        this.push(this.__final());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, o.prototype._finalOrDigest = function(e) {
                    var t = this.__final() || n.alloc(0);
                    return e && (t = this._toString(t, e, !0)), t;
                }, o.prototype._toString = function(e, t, r) {
                    if (this._decoder || (this._decoder = new s(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");
                    var n = this._decoder.write(e);
                    return r && (n += this._decoder.end()), n;
                }, t.exports = o;
            },
            {
                inherits: 440,
                "safe-buffer": 494,
                stream: 505,
                string_decoder: 218
            }
        ],
        222: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/try-to-string"), s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not a function");
                };
            },
            {
                "../internals/is-callable": 285,
                "../internals/try-to-string": 349
            }
        ],
        223: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-constructor"), i = e("../internals/try-to-string"), s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not a constructor");
                };
            },
            {
                "../internals/is-constructor": 286,
                "../internals/try-to-string": 349
            }
        ],
        224: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = String, s = TypeError;
                t.exports = function(e) {
                    if ("object" == typeof e || n(e)) return e;
                    throw new s("Can't set " + i(e) + " as a prototype");
                };
            },
            {
                "../internals/is-callable": 285
            }
        ],
        225: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol"), i = e("../internals/object-create"), s = e("../internals/object-define-property").f, o = n("unscopables"), a = Array.prototype;
                void 0 === a[o] && s(a, o, {
                    configurable: !0,
                    value: i(null)
                }), t.exports = function(e) {
                    a[o][e] = !0;
                };
            },
            {
                "../internals/object-create": 306,
                "../internals/object-define-property": 308,
                "../internals/well-known-symbol": 357
            }
        ],
        226: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-is-prototype-of"), i = TypeError;
                t.exports = function(e, t) {
                    if (n(t, e)) return e;
                    throw new i("Incorrect invocation");
                };
            },
            {
                "../internals/object-is-prototype-of": 314
            }
        ],
        227: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-object"), i = String, s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not an object");
                };
            },
            {
                "../internals/is-object": 289
            }
        ],
        228: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-indexed-object"), i = e("../internals/to-absolute-index"), s = e("../internals/length-of-array-like"), o = function(e) {
                    return function(t, r, o) {
                        var a, l = n(t), c = s(l), u = i(o, c);
                        if (e && r != r) {
                            for(; c > u;)if ((a = l[u++]) != a) return !0;
                        } else for(; c > u; u++)if ((e || u in l) && l[u] === r) return e || u || 0;
                        return !e && -1;
                    };
                };
                t.exports = {
                    includes: o(!0),
                    indexOf: o(!1)
                };
            },
            {
                "../internals/length-of-array-like": 299,
                "../internals/to-absolute-index": 340,
                "../internals/to-indexed-object": 341
            }
        ],
        229: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-context"), i = e("../internals/function-uncurry-this"), s = e("../internals/indexed-object"), o = e("../internals/to-object"), a = e("../internals/length-of-array-like"), l = e("../internals/array-species-create"), c = i([].push), u = function(e) {
                    var t = 1 === e, r = 2 === e, i = 3 === e, u = 4 === e, h = 6 === e, f = 7 === e, d = 5 === e || h;
                    return function(p, m, b, g) {
                        for(var y, v, w = o(p), _ = s(w), x = n(m, b), k = a(_), S = 0, M = g || l, C = t ? M(p, k) : r || f ? M(p, 0) : void 0; k > S; S++)if ((d || S in _) && (v = x(y = _[S], S, w), e)) {
                            if (t) C[S] = v;
                            else if (v) switch(e){
                                case 3:
                                    return !0;
                                case 5:
                                    return y;
                                case 6:
                                    return S;
                                case 2:
                                    c(C, y);
                            }
                            else switch(e){
                                case 4:
                                    return !1;
                                case 7:
                                    c(C, y);
                            }
                        }
                        return h ? -1 : i || u ? u : C;
                    };
                };
                t.exports = {
                    forEach: u(0),
                    map: u(1),
                    filter: u(2),
                    some: u(3),
                    every: u(4),
                    find: u(5),
                    findIndex: u(6),
                    filterReject: u(7)
                };
            },
            {
                "../internals/array-species-create": 233,
                "../internals/function-bind-context": 262,
                "../internals/function-uncurry-this": 268,
                "../internals/indexed-object": 280,
                "../internals/length-of-array-like": 299,
                "../internals/to-object": 344
            }
        ],
        230: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-absolute-index"), i = e("../internals/length-of-array-like"), s = e("../internals/create-property"), o = Array, a = Math.max;
                t.exports = function(e, t, r) {
                    for(var l = i(e), c = n(t, l), u = n(void 0 === r ? l : r, l), h = o(a(u - c, 0)), f = 0; c < u; c++, f++)s(h, f, e[c]);
                    return h.length = f, h;
                };
            },
            {
                "../internals/create-property": 243,
                "../internals/length-of-array-like": 299,
                "../internals/to-absolute-index": 340
            }
        ],
        231: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this");
                t.exports = n([].slice);
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        232: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-array"), i = e("../internals/is-constructor"), s = e("../internals/is-object"), o = e("../internals/well-known-symbol")("species"), a = Array;
                t.exports = function(e) {
                    var t;
                    return n(e) && (t = e.constructor, (i(t) && (t === a || n(t.prototype)) || s(t) && null === (t = t[o])) && (t = void 0)), void 0 === t ? a : t;
                };
            },
            {
                "../internals/is-array": 284,
                "../internals/is-constructor": 286,
                "../internals/is-object": 289,
                "../internals/well-known-symbol": 357
            }
        ],
        233: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/array-species-constructor");
                t.exports = function(e, t) {
                    return new (n(e))(0 === t ? 0 : t);
                };
            },
            {
                "../internals/array-species-constructor": 232
            }
        ],
        234: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol")("iterator"), i = !1;
                try {
                    var s = 0, o = {
                        next: function() {
                            return {
                                done: !!s++
                            };
                        },
                        return: function() {
                            i = !0;
                        }
                    };
                    o[n] = function() {
                        return this;
                    }, Array.from(o, function() {
                        throw 2;
                    });
                } catch (e) {}
                t.exports = function(e, t) {
                    try {
                        if (!t && !i) return !1;
                    } catch (e) {
                        return !1;
                    }
                    var r = !1;
                    try {
                        var s = {};
                        s[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: r = !0
                                    };
                                }
                            };
                        }, e(s);
                    } catch (e) {}
                    return r;
                };
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        235: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = n({}.toString), s = n("".slice);
                t.exports = function(e) {
                    return s(i(e), 8, -1);
                };
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        236: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-string-tag-support"), i = e("../internals/is-callable"), s = e("../internals/classof-raw"), o = e("../internals/well-known-symbol")("toStringTag"), a = Object, l = "Arguments" === s(function() {
                    return arguments;
                }());
                t.exports = n ? s : function(e) {
                    var t, r, n;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = a(e), o)) ? r : l ? s(t) : "Object" === (n = s(t)) && i(t.callee) ? "Arguments" : n;
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/is-callable": 285,
                "../internals/to-string-tag-support": 347,
                "../internals/well-known-symbol": 357
            }
        ],
        237: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/has-own-property"), i = e("../internals/own-keys"), s = e("../internals/object-get-own-property-descriptor"), o = e("../internals/object-define-property");
                t.exports = function(e, t, r) {
                    for(var a = i(t), l = o.f, c = s.f, u = 0; u < a.length; u++){
                        var h = a[u];
                        n(e, h) || r && n(r, h) || l(e, h, c(t, h));
                    }
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/own-keys": 321
            }
        ],
        238: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol")("match");
                t.exports = function(e) {
                    var t = /./;
                    try {
                        "/./"[e](t);
                    } catch (r) {
                        try {
                            return t[n] = !1, "/./"[e](t);
                        } catch (e) {}
                    }
                    return !1;
                };
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        239: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    function e() {}
                    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        240: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    return {
                        value: e,
                        done: t
                    };
                };
            },
            {}
        ],
        241: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/object-define-property"), s = e("../internals/create-property-descriptor");
                t.exports = n ? function(e, t, r) {
                    return i.f(e, t, s(1, r));
                } : function(e, t, r) {
                    return e[t] = r, e;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/descriptors": 247,
                "../internals/object-define-property": 308
            }
        ],
        242: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            {}
        ],
        243: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-property-key"), i = e("../internals/object-define-property"), s = e("../internals/create-property-descriptor");
                t.exports = function(e, t, r) {
                    var o = n(t);
                    o in e ? i.f(e, o, s(0, r)) : e[o] = r;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/object-define-property": 308,
                "../internals/to-property-key": 346
            }
        ],
        244: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/make-built-in"), i = e("../internals/object-define-property");
                t.exports = function(e, t, r) {
                    return r.get && n(r.get, t, {
                        getter: !0
                    }), r.set && n(r.set, t, {
                        setter: !0
                    }), i.f(e, t, r);
                };
            },
            {
                "../internals/make-built-in": 300,
                "../internals/object-define-property": 308
            }
        ],
        245: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/object-define-property"), s = e("../internals/make-built-in"), o = e("../internals/define-global-property");
                t.exports = function(e, t, r, a) {
                    a || (a = {});
                    var l = a.enumerable, c = void 0 !== a.name ? a.name : t;
                    if (n(r) && s(r, c, a), a.global) l ? e[t] = r : o(t, r);
                    else {
                        try {
                            a.unsafe ? e[t] && (l = !0) : delete e[t];
                        } catch (e) {}
                        l ? e[t] = r : i.f(e, t, {
                            value: r,
                            enumerable: !1,
                            configurable: !a.nonConfigurable,
                            writable: !a.nonWritable
                        });
                    }
                    return e;
                };
            },
            {
                "../internals/define-global-property": 246,
                "../internals/is-callable": 285,
                "../internals/make-built-in": 300,
                "../internals/object-define-property": 308
            }
        ],
        246: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = Object.defineProperty;
                t.exports = function(e, t) {
                    try {
                        i(n, e, {
                            value: t,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (r) {
                        n[e] = t;
                    }
                    return t;
                };
            },
            {
                "../internals/global": 274
            }
        ],
        247: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    return 7 !== Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        248: [
            function(e, t, r) {
                "use strict";
                var n = "object" == typeof document && document.all, i = void 0 === n && void 0 !== n;
                t.exports = {
                    all: n,
                    IS_HTMLDDA: i
                };
            },
            {}
        ],
        249: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-object"), s = n.document, o = i(s) && i(s.createElement);
                t.exports = function(e) {
                    return o ? s.createElement(e) : {};
                };
            },
            {
                "../internals/global": 274,
                "../internals/is-object": 289
            }
        ],
        250: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-is-deno"), i = e("../internals/engine-is-node");
                t.exports = !n && !i && "object" == typeof window && "object" == typeof document;
            },
            {
                "../internals/engine-is-deno": 251,
                "../internals/engine-is-node": 254
            }
        ],
        251: [
            function(e, t, r) {
                "use strict";
                t.exports = "object" == typeof Deno && Deno && "object" == typeof Deno.version;
            },
            {}
        ],
        252: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /ipad|iphone|ipod/i.test(n) && "undefined" != typeof Pebble;
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        253: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(n);
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        254: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/classof-raw");
                t.exports = "process" === i(n.process);
            },
            {
                "../internals/classof-raw": 235,
                "../internals/global": 274
            }
        ],
        255: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /web0s(?!.*chrome)/i.test(n);
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        256: [
            function(e, t, r) {
                "use strict";
                t.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
            },
            {}
        ],
        257: [
            function(e, t, r) {
                "use strict";
                var n, i, s = e("../internals/global"), o = e("../internals/engine-user-agent"), a = s.process, l = s.Deno, c = a && a.versions || l && l.version, u = c && c.v8;
                u && (i = (n = u.split("."))[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1])), !i && o && (!(n = o.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = o.match(/Chrome\/(\d+)/)) && (i = +n[1]), t.exports = i;
            },
            {
                "../internals/engine-user-agent": 256,
                "../internals/global": 274
            }
        ],
        258: [
            function(e, t, r) {
                "use strict";
                t.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            {}
        ],
        259: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/object-get-own-property-descriptor").f, s = e("../internals/create-non-enumerable-property"), o = e("../internals/define-built-in"), a = e("../internals/define-global-property"), l = e("../internals/copy-constructor-properties"), c = e("../internals/is-forced");
                t.exports = function(e, t) {
                    var r, u, h, f, d, p = e.target, m = e.global, b = e.stat;
                    if (r = m ? n : b ? n[p] || a(p, {}) : (n[p] || {}).prototype) for(u in t){
                        if (f = t[u], h = e.dontCallGetSet ? (d = i(r, u)) && d.value : r[u], !c(m ? u : p + (b ? "." : "#") + u, e.forced) && void 0 !== h) {
                            if (typeof f == typeof h) continue;
                            l(f, h);
                        }
                        (e.sham || h && h.sham) && s(f, "sham", !0), o(r, u, f, e);
                    }
                };
            },
            {
                "../internals/copy-constructor-properties": 237,
                "../internals/create-non-enumerable-property": 241,
                "../internals/define-built-in": 245,
                "../internals/define-global-property": 246,
                "../internals/global": 274,
                "../internals/is-forced": 287,
                "../internals/object-get-own-property-descriptor": 309
            }
        ],
        260: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            {}
        ],
        261: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype, s = i.apply, o = i.call;
                t.exports = "object" == typeof Reflect && Reflect.apply || (n ? o.bind(s) : function() {
                    return o.apply(s, arguments);
                });
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        262: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this-clause"), i = e("../internals/a-callable"), s = e("../internals/function-bind-native"), o = n(n.bind);
                t.exports = function(e, t) {
                    return i(e), void 0 === t ? e : s ? o(e, t) : function() {
                        return e.apply(t, arguments);
                    };
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/function-bind-native": 263,
                "../internals/function-uncurry-this-clause": 267
            }
        ],
        263: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    var e = (function() {}).bind();
                    return "function" != typeof e || e.hasOwnProperty("prototype");
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        264: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype.call;
                t.exports = n ? i.bind(i) : function() {
                    return i.apply(i, arguments);
                };
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        265: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/has-own-property"), s = Function.prototype, o = n && Object.getOwnPropertyDescriptor, a = i(s, "name"), l = a && "something" === (function() {}).name, c = a && (!n || n && o(s, "name").configurable);
                t.exports = {
                    EXISTS: a,
                    PROPER: l,
                    CONFIGURABLE: c
                };
            },
            {
                "../internals/descriptors": 247,
                "../internals/has-own-property": 275
            }
        ],
        266: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/a-callable");
                t.exports = function(e, t, r) {
                    try {
                        return n(i(Object.getOwnPropertyDescriptor(e, t)[r]));
                    } catch (e) {}
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/function-uncurry-this": 268
            }
        ],
        267: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw"), i = e("../internals/function-uncurry-this");
                t.exports = function(e) {
                    if ("Function" === n(e)) return i(e);
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/function-uncurry-this": 268
            }
        ],
        268: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype, s = i.call, o = n && i.bind.bind(s, s);
                t.exports = n ? o : function(e) {
                    return function() {
                        return s.apply(e, arguments);
                    };
                };
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        269: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-callable"), s = function(e) {
                    return i(e) ? e : void 0;
                };
                t.exports = function(e, t) {
                    return arguments.length < 2 ? s(n[e]) : n[e] && n[e][t];
                };
            },
            {
                "../internals/global": 274,
                "../internals/is-callable": 285
            }
        ],
        270: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof"), i = e("../internals/get-method"), s = e("../internals/is-null-or-undefined"), o = e("../internals/iterators"), a = e("../internals/well-known-symbol")("iterator");
                t.exports = function(e) {
                    if (!s(e)) return i(e, a) || i(e, "@@iterator") || o[n(e)];
                };
            },
            {
                "../internals/classof": 236,
                "../internals/get-method": 273,
                "../internals/is-null-or-undefined": 288,
                "../internals/iterators": 298,
                "../internals/well-known-symbol": 357
            }
        ],
        271: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/a-callable"), s = e("../internals/an-object"), o = e("../internals/try-to-string"), a = e("../internals/get-iterator-method"), l = TypeError;
                t.exports = function(e, t) {
                    var r = arguments.length < 2 ? a(e) : t;
                    if (i(r)) return s(n(r, e));
                    throw new l(o(e) + " is not iterable");
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/an-object": 227,
                "../internals/function-call": 264,
                "../internals/get-iterator-method": 270,
                "../internals/try-to-string": 349
            }
        ],
        272: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/is-array"), s = e("../internals/is-callable"), o = e("../internals/classof-raw"), a = e("../internals/to-string"), l = n([].push);
                t.exports = function(e) {
                    if (s(e)) return e;
                    if (i(e)) {
                        for(var t = e.length, r = [], n = 0; n < t; n++){
                            var c = e[n];
                            "string" == typeof c ? l(r, c) : "number" != typeof c && "Number" !== o(c) && "String" !== o(c) || l(r, a(c));
                        }
                        var u = r.length, h = !0;
                        return function(e, t) {
                            if (h) return h = !1, t;
                            if (i(this)) return t;
                            for(var n = 0; n < u; n++)if (r[n] === e) return t;
                        };
                    }
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/function-uncurry-this": 268,
                "../internals/is-array": 284,
                "../internals/is-callable": 285,
                "../internals/to-string": 348
            }
        ],
        273: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/a-callable"), i = e("../internals/is-null-or-undefined");
                t.exports = function(e, t) {
                    var r = e[t];
                    return i(r) ? void 0 : n(r);
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/is-null-or-undefined": 288
            }
        ],
        274: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = function(e) {
                            return e && e.Math === Math && e;
                        };
                        t.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof e && e) || function() {
                            return this;
                        }() || this || Function("return this")();
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        275: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/to-object"), s = n({}.hasOwnProperty);
                t.exports = Object.hasOwn || function(e, t) {
                    return s(i(e), t);
                };
            },
            {
                "../internals/function-uncurry-this": 268,
                "../internals/to-object": 344
            }
        ],
        276: [
            function(e, t, r) {
                "use strict";
                t.exports = {};
            },
            {}
        ],
        277: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    try {
                        1 === arguments.length ? console.error(e) : console.error(e, t);
                    } catch (e) {}
                };
            },
            {}
        ],
        278: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in");
                t.exports = n("document", "documentElement");
            },
            {
                "../internals/get-built-in": 269
            }
        ],
        279: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails"), s = e("../internals/document-create-element");
                t.exports = !n && !i(function() {
                    return 7 !== Object.defineProperty(s("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            {
                "../internals/descriptors": 247,
                "../internals/document-create-element": 249,
                "../internals/fails": 260
            }
        ],
        280: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/classof-raw"), o = Object, a = n("".split);
                t.exports = i(function() {
                    return !o("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" === s(e) ? a(e, "") : o(e);
                } : o;
            },
            {
                "../internals/classof-raw": 235,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268
            }
        ],
        281: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/is-callable"), s = e("../internals/shared-store"), o = n(Function.toString);
                i(s.inspectSource) || (s.inspectSource = function(e) {
                    return o(e);
                }), t.exports = s.inspectSource;
            },
            {
                "../internals/function-uncurry-this": 268,
                "../internals/is-callable": 285,
                "../internals/shared-store": 333
            }
        ],
        282: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/weak-map-basic-detection"), a = e("../internals/global"), l = e("../internals/is-object"), c = e("../internals/create-non-enumerable-property"), u = e("../internals/has-own-property"), h = e("../internals/shared-store"), f = e("../internals/shared-key"), d = e("../internals/hidden-keys"), p = a.TypeError, m = a.WeakMap;
                if (o || h.state) {
                    var b = h.state || (h.state = new m);
                    b.get = b.get, b.has = b.has, b.set = b.set, n = function(e, t) {
                        if (b.has(e)) throw new p("Object already initialized");
                        return t.facade = e, b.set(e, t), t;
                    }, i = function(e) {
                        return b.get(e) || {};
                    }, s = function(e) {
                        return b.has(e);
                    };
                } else {
                    var g = f("state");
                    d[g] = !0, n = function(e, t) {
                        if (u(e, g)) throw new p("Object already initialized");
                        return t.facade = e, c(e, g, t), t;
                    }, i = function(e) {
                        return u(e, g) ? e[g] : {};
                    }, s = function(e) {
                        return u(e, g);
                    };
                }
                t.exports = {
                    set: n,
                    get: i,
                    has: s,
                    enforce: function(e) {
                        return s(e) ? i(e) : n(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var r;
                            if (!l(t) || (r = i(t)).type !== e) throw new p("Incompatible receiver, " + e + " required");
                            return r;
                        };
                    }
                };
            },
            {
                "../internals/create-non-enumerable-property": 241,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/is-object": 289,
                "../internals/shared-key": 332,
                "../internals/shared-store": 333,
                "../internals/weak-map-basic-detection": 354
            }
        ],
        283: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol"), i = e("../internals/iterators"), s = n("iterator"), o = Array.prototype;
                t.exports = function(e) {
                    return void 0 !== e && (i.Array === e || o[s] === e);
                };
            },
            {
                "../internals/iterators": 298,
                "../internals/well-known-symbol": 357
            }
        ],
        284: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw");
                t.exports = Array.isArray || function(e) {
                    return "Array" === n(e);
                };
            },
            {
                "../internals/classof-raw": 235
            }
        ],
        285: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/document-all"), i = n.all;
                t.exports = n.IS_HTMLDDA ? function(e) {
                    return "function" == typeof e || e === i;
                } : function(e) {
                    return "function" == typeof e;
                };
            },
            {
                "../internals/document-all": 248
            }
        ],
        286: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/is-callable"), o = e("../internals/classof"), a = e("../internals/get-built-in"), l = e("../internals/inspect-source"), c = function() {}, u = [], h = a("Reflect", "construct"), f = /^\s*(?:class|function)\b/, d = n(f.exec), p = !f.test(c), m = function(e) {
                    if (!s(e)) return !1;
                    try {
                        return h(c, u, e), !0;
                    } catch (e) {
                        return !1;
                    }
                }, b = function(e) {
                    if (!s(e)) return !1;
                    switch(o(e)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return !1;
                    }
                    try {
                        return p || !!d(f, l(e));
                    } catch (e) {
                        return !0;
                    }
                };
                b.sham = !0, t.exports = !h || i(function() {
                    var e;
                    return m(m.call) || !m(Object) || !m(function() {
                        e = !0;
                    }) || e;
                }) ? b : m;
            },
            {
                "../internals/classof": 236,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/inspect-source": 281,
                "../internals/is-callable": 285
            }
        ],
        287: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails"), i = e("../internals/is-callable"), s = /#|\.prototype\./, o = function(e, t) {
                    var r = l[a(e)];
                    return r === u || r !== c && (i(t) ? n(t) : !!t);
                }, a = o.normalize = function(e) {
                    return String(e).replace(s, ".").toLowerCase();
                }, l = o.data = {}, c = o.NATIVE = "N", u = o.POLYFILL = "P";
                t.exports = o;
            },
            {
                "../internals/fails": 260,
                "../internals/is-callable": 285
            }
        ],
        288: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return null == e;
                };
            },
            {}
        ],
        289: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/document-all"), s = i.all;
                t.exports = i.IS_HTMLDDA ? function(e) {
                    return "object" == typeof e ? null !== e : n(e) || e === s;
                } : function(e) {
                    return "object" == typeof e ? null !== e : n(e);
                };
            },
            {
                "../internals/document-all": 248,
                "../internals/is-callable": 285
            }
        ],
        290: [
            function(e, t, r) {
                "use strict";
                t.exports = !1;
            },
            {}
        ],
        291: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-object"), i = e("../internals/classof-raw"), s = e("../internals/well-known-symbol")("match");
                t.exports = function(e) {
                    var t;
                    return n(e) && (void 0 !== (t = e[s]) ? !!t : "RegExp" === i(e));
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/is-object": 289,
                "../internals/well-known-symbol": 357
            }
        ],
        292: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/is-callable"), s = e("../internals/object-is-prototype-of"), o = e("../internals/use-symbol-as-uid"), a = Object;
                t.exports = o ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    var t = n("Symbol");
                    return i(t) && s(t.prototype, a(e));
                };
            },
            {
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/object-is-prototype-of": 314,
                "../internals/use-symbol-as-uid": 351
            }
        ],
        293: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-context"), i = e("../internals/function-call"), s = e("../internals/an-object"), o = e("../internals/try-to-string"), a = e("../internals/is-array-iterator-method"), l = e("../internals/length-of-array-like"), c = e("../internals/object-is-prototype-of"), u = e("../internals/get-iterator"), h = e("../internals/get-iterator-method"), f = e("../internals/iterator-close"), d = TypeError, p = function(e, t) {
                    this.stopped = e, this.result = t;
                }, m = p.prototype;
                t.exports = function(e, t, r) {
                    var b, g, y, v, w, _, x, k = r && r.that, S = !(!r || !r.AS_ENTRIES), M = !(!r || !r.IS_RECORD), C = !(!r || !r.IS_ITERATOR), T = !(!r || !r.INTERRUPTED), E = n(t, k), A = function(e) {
                        return b && f(b, "normal", e), new p(!0, e);
                    }, R = function(e) {
                        return S ? (s(e), T ? E(e[0], e[1], A) : E(e[0], e[1])) : T ? E(e, A) : E(e);
                    };
                    if (M) b = e.iterator;
                    else if (C) b = e;
                    else {
                        if (!(g = h(e))) throw new d(o(e) + " is not iterable");
                        if (a(g)) {
                            for(y = 0, v = l(e); v > y; y++)if ((w = R(e[y])) && c(m, w)) return w;
                            return new p(!1);
                        }
                        b = u(e, g);
                    }
                    for(_ = M ? e.next : b.next; !(x = i(_, b)).done;){
                        try {
                            w = R(x.value);
                        } catch (e) {
                            f(b, "throw", e);
                        }
                        if ("object" == typeof w && w && c(m, w)) return w;
                    }
                    return new p(!1);
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-bind-context": 262,
                "../internals/function-call": 264,
                "../internals/get-iterator": 271,
                "../internals/get-iterator-method": 270,
                "../internals/is-array-iterator-method": 283,
                "../internals/iterator-close": 294,
                "../internals/length-of-array-like": 299,
                "../internals/object-is-prototype-of": 314,
                "../internals/try-to-string": 349
            }
        ],
        294: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/an-object"), s = e("../internals/get-method");
                t.exports = function(e, t, r) {
                    var o, a;
                    i(e);
                    try {
                        if (!(o = s(e, "return"))) {
                            if ("throw" === t) throw r;
                            return r;
                        }
                        o = n(o, e);
                    } catch (e) {
                        a = !0, o = e;
                    }
                    if ("throw" === t) throw r;
                    if (a) throw o;
                    return i(o), r;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-call": 264,
                "../internals/get-method": 273
            }
        ],
        295: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/iterators-core").IteratorPrototype, i = e("../internals/object-create"), s = e("../internals/create-property-descriptor"), o = e("../internals/set-to-string-tag"), a = e("../internals/iterators"), l = function() {
                    return this;
                };
                t.exports = function(e, t, r, c) {
                    var u = t + " Iterator";
                    return e.prototype = i(n, {
                        next: s(+!c, r)
                    }), o(e, u, !1, !0), a[u] = l, e;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/iterators": 298,
                "../internals/iterators-core": 297,
                "../internals/object-create": 306,
                "../internals/set-to-string-tag": 331
            }
        ],
        296: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/is-pure"), o = e("../internals/function-name"), a = e("../internals/is-callable"), l = e("../internals/iterator-create-constructor"), c = e("../internals/object-get-prototype-of"), u = e("../internals/object-set-prototype-of"), h = e("../internals/set-to-string-tag"), f = e("../internals/create-non-enumerable-property"), d = e("../internals/define-built-in"), p = e("../internals/well-known-symbol"), m = e("../internals/iterators"), b = e("../internals/iterators-core"), g = o.PROPER, y = o.CONFIGURABLE, v = b.IteratorPrototype, w = b.BUGGY_SAFARI_ITERATORS, _ = p("iterator"), x = function() {
                    return this;
                };
                t.exports = function(e, t, r, o, p, b, k) {
                    l(r, t, o);
                    var S, M, C, T = function(e) {
                        if (e === p && j) return j;
                        if (!w && e && e in R) return R[e];
                        switch(e){
                            case "keys":
                            case "values":
                            case "entries":
                                return function() {
                                    return new r(this, e);
                                };
                        }
                        return function() {
                            return new r(this);
                        };
                    }, E = t + " Iterator", A = !1, R = e.prototype, O = R[_] || R["@@iterator"] || p && R[p], j = !w && O || T(p), I = "Array" === t && R.entries || O;
                    if (I && (S = c(I.call(new e))) !== Object.prototype && S.next && (s || c(S) === v || (u ? u(S, v) : a(S[_]) || d(S, _, x)), h(S, E, !0, !0), s && (m[E] = x)), g && "values" === p && O && "values" !== O.name && (!s && y ? f(R, "name", "values") : (A = !0, j = function() {
                        return i(O, this);
                    })), p) {
                        if (M = {
                            values: T("values"),
                            keys: b ? j : T("keys"),
                            entries: T("entries")
                        }, k) for(C in M)(w || A || !(C in R)) && d(R, C, M[C]);
                        else n({
                            target: t,
                            proto: !0,
                            forced: w || A
                        }, M);
                    }
                    return s && !k || R[_] === j || d(R, _, j, {
                        name: p
                    }), m[t] = j, M;
                };
            },
            {
                "../internals/create-non-enumerable-property": 241,
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/function-name": 265,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/iterator-create-constructor": 295,
                "../internals/iterators": 298,
                "../internals/iterators-core": 297,
                "../internals/object-get-prototype-of": 313,
                "../internals/object-set-prototype-of": 318,
                "../internals/set-to-string-tag": 331,
                "../internals/well-known-symbol": 357
            }
        ],
        297: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/fails"), a = e("../internals/is-callable"), l = e("../internals/is-object"), c = e("../internals/object-create"), u = e("../internals/object-get-prototype-of"), h = e("../internals/define-built-in"), f = e("../internals/well-known-symbol"), d = e("../internals/is-pure"), p = f("iterator"), m = !1;
                [].keys && ("next" in (s = [].keys()) ? (i = u(u(s))) !== Object.prototype && (n = i) : m = !0), !l(n) || o(function() {
                    var e = {};
                    return n[p].call(e) !== e;
                }) ? n = {} : d && (n = c(n)), a(n[p]) || h(n, p, function() {
                    return this;
                }), t.exports = {
                    IteratorPrototype: n,
                    BUGGY_SAFARI_ITERATORS: m
                };
            },
            {
                "../internals/define-built-in": 245,
                "../internals/fails": 260,
                "../internals/is-callable": 285,
                "../internals/is-object": 289,
                "../internals/is-pure": 290,
                "../internals/object-create": 306,
                "../internals/object-get-prototype-of": 313,
                "../internals/well-known-symbol": 357
            }
        ],
        298: [
            function(e, t, r) {
                arguments[4][276][0].apply(r, arguments);
            },
            {
                dup: 276
            }
        ],
        299: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-length");
                t.exports = function(e) {
                    return n(e.length);
                };
            },
            {
                "../internals/to-length": 343
            }
        ],
        300: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/is-callable"), o = e("../internals/has-own-property"), a = e("../internals/descriptors"), l = e("../internals/function-name").CONFIGURABLE, c = e("../internals/inspect-source"), u = e("../internals/internal-state"), h = u.enforce, f = u.get, d = String, p = Object.defineProperty, m = n("".slice), b = n("".replace), g = n([].join), y = a && !i(function() {
                    return 8 !== p(function() {}, "length", {
                        value: 8
                    }).length;
                }), v = String(String).split("String"), w = t.exports = function(e, t, r) {
                    "Symbol(" === m(d(t), 0, 7) && (t = "[" + b(d(t), /^Symbol\(([^)]*)\)/, "$1") + "]"), r && r.getter && (t = "get " + t), r && r.setter && (t = "set " + t), (!o(e, "name") || l && e.name !== t) && (a ? p(e, "name", {
                        value: t,
                        configurable: !0
                    }) : e.name = t), y && r && o(r, "arity") && e.length !== r.arity && p(e, "length", {
                        value: r.arity
                    });
                    try {
                        r && o(r, "constructor") && r.constructor ? a && p(e, "prototype", {
                            writable: !1
                        }) : e.prototype && (e.prototype = void 0);
                    } catch (e) {}
                    var n = h(e);
                    return o(n, "source") || (n.source = g(v, "string" == typeof t ? t : "")), e;
                };
                Function.prototype.toString = w(function() {
                    return s(this) && f(this).source || c(this);
                }, "toString");
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-name": 265,
                "../internals/function-uncurry-this": 268,
                "../internals/has-own-property": 275,
                "../internals/inspect-source": 281,
                "../internals/internal-state": 282,
                "../internals/is-callable": 285
            }
        ],
        301: [
            function(e, t, r) {
                "use strict";
                var n = Math.ceil, i = Math.floor;
                t.exports = Math.trunc || function(e) {
                    var t = +e;
                    return (t > 0 ? i : n)(t);
                };
            },
            {}
        ],
        302: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o, a, l = e("../internals/global"), c = e("../internals/function-bind-context"), u = e("../internals/object-get-own-property-descriptor").f, h = e("../internals/task").set, f = e("../internals/queue"), d = e("../internals/engine-is-ios"), p = e("../internals/engine-is-ios-pebble"), m = e("../internals/engine-is-webos-webkit"), b = e("../internals/engine-is-node"), g = l.MutationObserver || l.WebKitMutationObserver, y = l.document, v = l.process, w = l.Promise, _ = u(l, "queueMicrotask"), x = _ && _.value;
                if (!x) {
                    var k = new f, S = function() {
                        var e, t;
                        for(b && (e = v.domain) && e.exit(); t = k.get();)try {
                            t();
                        } catch (e) {
                            throw k.head && n(), e;
                        }
                        e && e.enter();
                    };
                    d || b || m || !g || !y ? !p && w && w.resolve ? ((o = w.resolve(void 0)).constructor = w, a = c(o.then, o), n = function() {
                        a(S);
                    }) : b ? n = function() {
                        v.nextTick(S);
                    } : (h = c(h, l), n = function() {
                        h(S);
                    }) : (i = !0, s = y.createTextNode(""), new g(S).observe(s, {
                        characterData: !0
                    }), n = function() {
                        s.data = i = !i;
                    }), x = function(e) {
                        k.head || n(), k.add(e);
                    };
                }
                t.exports = x;
            },
            {
                "../internals/engine-is-ios": 253,
                "../internals/engine-is-ios-pebble": 252,
                "../internals/engine-is-node": 254,
                "../internals/engine-is-webos-webkit": 255,
                "../internals/function-bind-context": 262,
                "../internals/global": 274,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/queue": 328,
                "../internals/task": 339
            }
        ],
        303: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/a-callable"), i = TypeError, s = function(e) {
                    var t, r;
                    this.promise = new e(function(e, n) {
                        if (void 0 !== t || void 0 !== r) throw new i("Bad Promise constructor");
                        t = e, r = n;
                    }), this.resolve = n(t), this.reject = n(r);
                };
                t.exports.f = function(e) {
                    return new s(e);
                };
            },
            {
                "../internals/a-callable": 222
            }
        ],
        304: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-regexp"), i = TypeError;
                t.exports = function(e) {
                    if (n(e)) throw new i("The method doesn't accept regular expressions");
                    return e;
                };
            },
            {
                "../internals/is-regexp": 291
            }
        ],
        305: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/function-uncurry-this"), s = e("../internals/function-call"), o = e("../internals/fails"), a = e("../internals/object-keys"), l = e("../internals/object-get-own-property-symbols"), c = e("../internals/object-property-is-enumerable"), u = e("../internals/to-object"), h = e("../internals/indexed-object"), f = Object.assign, d = Object.defineProperty, p = i([].concat);
                t.exports = !f || o(function() {
                    if (n && 1 !== f({
                        b: 1
                    }, f(d({}, "a", {
                        enumerable: !0,
                        get: function() {
                            d(this, "b", {
                                value: 3,
                                enumerable: !1
                            });
                        }
                    }), {
                        b: 2
                    })).b) return !0;
                    var e = {}, t = {}, r = Symbol("assign detection");
                    return e[r] = 7, "abcdefghijklmnopqrst".split("").forEach(function(e) {
                        t[e] = e;
                    }), 7 !== f({}, e)[r] || "abcdefghijklmnopqrst" !== a(f({}, t)).join("");
                }) ? function(e, t) {
                    for(var r = u(e), i = arguments.length, o = 1, f = l.f, d = c.f; i > o;)for(var m, b = h(arguments[o++]), g = f ? p(a(b), f(b)) : a(b), y = g.length, v = 0; y > v;)m = g[v++], n && !s(d, b, m) || (r[m] = b[m]);
                    return r;
                } : f;
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/indexed-object": 280,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-object": 344
            }
        ],
        306: [
            function(e, t, r) {
                "use strict";
                var n, i = e("../internals/an-object"), s = e("../internals/object-define-properties"), o = e("../internals/enum-bug-keys"), a = e("../internals/hidden-keys"), l = e("../internals/html"), c = e("../internals/document-create-element"), u = e("../internals/shared-key"), h = u("IE_PROTO"), f = function() {}, d = function(e) {
                    return "<script>" + e + "<\/script>";
                }, p = function(e) {
                    e.write(d("")), e.close();
                    var t = e.parentWindow.Object;
                    return e = null, t;
                }, m = function() {
                    try {
                        n = new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t;
                    m = "undefined" != typeof document ? document.domain && n ? p(n) : ((t = c("iframe")).style.display = "none", l.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(d("document.F=Object")), e.close(), e.F) : p(n);
                    for(var r = o.length; r--;)delete m.prototype[o[r]];
                    return m();
                };
                a[h] = !0, t.exports = Object.create || function(e, t) {
                    var r;
                    return null !== e ? (f.prototype = i(e), r = new f, f.prototype = null, r[h] = e) : r = m(), void 0 === t ? r : s.f(r, t);
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/document-create-element": 249,
                "../internals/enum-bug-keys": 258,
                "../internals/hidden-keys": 276,
                "../internals/html": 278,
                "../internals/object-define-properties": 307,
                "../internals/shared-key": 332
            }
        ],
        307: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/v8-prototype-define-bug"), s = e("../internals/object-define-property"), o = e("../internals/an-object"), a = e("../internals/to-indexed-object"), l = e("../internals/object-keys");
                r.f = n && !i ? Object.defineProperties : function(e, t) {
                    o(e);
                    for(var r, n = a(t), i = l(t), c = i.length, u = 0; c > u;)s.f(e, r = i[u++], n[r]);
                    return e;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/descriptors": 247,
                "../internals/object-define-property": 308,
                "../internals/object-keys": 316,
                "../internals/to-indexed-object": 341,
                "../internals/v8-prototype-define-bug": 352
            }
        ],
        308: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/ie8-dom-define"), s = e("../internals/v8-prototype-define-bug"), o = e("../internals/an-object"), a = e("../internals/to-property-key"), l = TypeError, c = Object.defineProperty, u = Object.getOwnPropertyDescriptor;
                r.f = n ? s ? function(e, t, r) {
                    if (o(e), t = a(t), o(r), "function" == typeof e && "prototype" === t && "value" in r && "writable" in r && !r.writable) {
                        var n = u(e, t);
                        n && n.writable && (e[t] = r.value, r = {
                            configurable: "configurable" in r ? r.configurable : n.configurable,
                            enumerable: "enumerable" in r ? r.enumerable : n.enumerable,
                            writable: !1
                        });
                    }
                    return c(e, t, r);
                } : c : function(e, t, r) {
                    if (o(e), t = a(t), o(r), i) try {
                        return c(e, t, r);
                    } catch (e) {}
                    if ("get" in r || "set" in r) throw new l("Accessors not supported");
                    return "value" in r && (e[t] = r.value), e;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/descriptors": 247,
                "../internals/ie8-dom-define": 279,
                "../internals/to-property-key": 346,
                "../internals/v8-prototype-define-bug": 352
            }
        ],
        309: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/function-call"), s = e("../internals/object-property-is-enumerable"), o = e("../internals/create-property-descriptor"), a = e("../internals/to-indexed-object"), l = e("../internals/to-property-key"), c = e("../internals/has-own-property"), u = e("../internals/ie8-dom-define"), h = Object.getOwnPropertyDescriptor;
                r.f = n ? h : function(e, t) {
                    if (e = a(e), t = l(t), u) try {
                        return h(e, t);
                    } catch (e) {}
                    if (c(e, t)) return o(!i(s.f, e, t), e[t]);
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/descriptors": 247,
                "../internals/function-call": 264,
                "../internals/has-own-property": 275,
                "../internals/ie8-dom-define": 279,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-indexed-object": 341,
                "../internals/to-property-key": 346
            }
        ],
        310: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw"), i = e("../internals/to-indexed-object"), s = e("../internals/object-get-own-property-names").f, o = e("../internals/array-slice-simple"), a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                t.exports.f = function(e) {
                    return a && "Window" === n(e) ? function(e) {
                        try {
                            return s(e);
                        } catch (e) {
                            return o(a);
                        }
                    }(e) : s(i(e));
                };
            },
            {
                "../internals/array-slice-simple": 230,
                "../internals/classof-raw": 235,
                "../internals/object-get-own-property-names": 311,
                "../internals/to-indexed-object": 341
            }
        ],
        311: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-keys-internal"), i = e("../internals/enum-bug-keys").concat("length", "prototype");
                r.f = Object.getOwnPropertyNames || function(e) {
                    return n(e, i);
                };
            },
            {
                "../internals/enum-bug-keys": 258,
                "../internals/object-keys-internal": 315
            }
        ],
        312: [
            function(e, t, r) {
                "use strict";
                r.f = Object.getOwnPropertySymbols;
            },
            {}
        ],
        313: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/has-own-property"), i = e("../internals/is-callable"), s = e("../internals/to-object"), o = e("../internals/shared-key"), a = e("../internals/correct-prototype-getter"), l = o("IE_PROTO"), c = Object, u = c.prototype;
                t.exports = a ? c.getPrototypeOf : function(e) {
                    var t = s(e);
                    if (n(t, l)) return t[l];
                    var r = t.constructor;
                    return i(r) && t instanceof r ? r.prototype : t instanceof c ? u : null;
                };
            },
            {
                "../internals/correct-prototype-getter": 239,
                "../internals/has-own-property": 275,
                "../internals/is-callable": 285,
                "../internals/shared-key": 332,
                "../internals/to-object": 344
            }
        ],
        314: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this");
                t.exports = n({}.isPrototypeOf);
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        315: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/has-own-property"), s = e("../internals/to-indexed-object"), o = e("../internals/array-includes").indexOf, a = e("../internals/hidden-keys"), l = n([].push);
                t.exports = function(e, t) {
                    var r, n = s(e), c = 0, u = [];
                    for(r in n)!i(a, r) && i(n, r) && l(u, r);
                    for(; t.length > c;)i(n, r = t[c++]) && (~o(u, r) || l(u, r));
                    return u;
                };
            },
            {
                "../internals/array-includes": 228,
                "../internals/function-uncurry-this": 268,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/to-indexed-object": 341
            }
        ],
        316: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-keys-internal"), i = e("../internals/enum-bug-keys");
                t.exports = Object.keys || function(e) {
                    return n(e, i);
                };
            },
            {
                "../internals/enum-bug-keys": 258,
                "../internals/object-keys-internal": 315
            }
        ],
        317: [
            function(e, t, r) {
                "use strict";
                var n = {}.propertyIsEnumerable, i = Object.getOwnPropertyDescriptor, s = i && !n.call({
                    1: 2
                }, 1);
                r.f = s ? function(e) {
                    var t = i(this, e);
                    return !!t && t.enumerable;
                } : n;
            },
            {}
        ],
        318: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this-accessor"), i = e("../internals/an-object"), s = e("../internals/a-possible-prototype");
                t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var e, t = !1, r = {};
                    try {
                        (e = n(Object.prototype, "__proto__", "set"))(r, []), t = r instanceof Array;
                    } catch (e) {}
                    return function(r, n) {
                        return i(r), s(n), t ? e(r, n) : r.__proto__ = n, r;
                    };
                }() : void 0);
            },
            {
                "../internals/a-possible-prototype": 224,
                "../internals/an-object": 227,
                "../internals/function-uncurry-this-accessor": 266
            }
        ],
        319: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails"), s = e("../internals/function-uncurry-this"), o = e("../internals/object-get-prototype-of"), a = e("../internals/object-keys"), l = e("../internals/to-indexed-object"), c = s(e("../internals/object-property-is-enumerable").f), u = s([].push), h = n && i(function() {
                    var e = Object.create(null);
                    return e[2] = 2, !c(e, 2);
                }), f = function(e) {
                    return function(t) {
                        for(var r, i = l(t), s = a(i), f = h && null === o(i), d = s.length, p = 0, m = []; d > p;)r = s[p++], n && !(f ? r in i : c(i, r)) || u(m, e ? [
                            r,
                            i[r]
                        ] : i[r]);
                        return m;
                    };
                };
                t.exports = {
                    entries: f(!0),
                    values: f(!1)
                };
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268,
                "../internals/object-get-prototype-of": 313,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-indexed-object": 341
            }
        ],
        320: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/is-callable"), s = e("../internals/is-object"), o = TypeError;
                t.exports = function(e, t) {
                    var r, a;
                    if ("string" === t && i(r = e.toString) && !s(a = n(r, e))) return a;
                    if (i(r = e.valueOf) && !s(a = n(r, e))) return a;
                    if ("string" !== t && i(r = e.toString) && !s(a = n(r, e))) return a;
                    throw new o("Can't convert object to primitive value");
                };
            },
            {
                "../internals/function-call": 264,
                "../internals/is-callable": 285,
                "../internals/is-object": 289
            }
        ],
        321: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/function-uncurry-this"), s = e("../internals/object-get-own-property-names"), o = e("../internals/object-get-own-property-symbols"), a = e("../internals/an-object"), l = i([].concat);
                t.exports = n("Reflect", "ownKeys") || function(e) {
                    var t = s.f(a(e)), r = o.f;
                    return r ? l(t, r(e)) : t;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/object-get-own-property-names": 311,
                "../internals/object-get-own-property-symbols": 312
            }
        ],
        322: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global");
                t.exports = n;
            },
            {
                "../internals/global": 274
            }
        ],
        323: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    try {
                        return {
                            error: !1,
                            value: e()
                        };
                    } catch (e) {
                        return {
                            error: !0,
                            value: e
                        };
                    }
                };
            },
            {}
        ],
        324: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/promise-native-constructor"), s = e("../internals/is-callable"), o = e("../internals/is-forced"), a = e("../internals/inspect-source"), l = e("../internals/well-known-symbol"), c = e("../internals/engine-is-browser"), u = e("../internals/engine-is-deno"), h = e("../internals/is-pure"), f = e("../internals/engine-v8-version"), d = i && i.prototype, p = l("species"), m = !1, b = s(n.PromiseRejectionEvent), g = o("Promise", function() {
                    var e = a(i), t = e !== String(i);
                    if (!t && 66 === f) return !0;
                    if (h && (!d.catch || !d.finally)) return !0;
                    if (!f || f < 51 || !/native code/.test(e)) {
                        var r = new i(function(e) {
                            e(1);
                        }), n = function(e) {
                            e(function() {}, function() {});
                        };
                        if ((r.constructor = {})[p] = n, !(m = r.then(function() {}) instanceof n)) return !0;
                    }
                    return !t && (c || u) && !b;
                });
                t.exports = {
                    CONSTRUCTOR: g,
                    REJECTION_EVENT: b,
                    SUBCLASSING: m
                };
            },
            {
                "../internals/engine-is-browser": 250,
                "../internals/engine-is-deno": 251,
                "../internals/engine-v8-version": 257,
                "../internals/global": 274,
                "../internals/inspect-source": 281,
                "../internals/is-callable": 285,
                "../internals/is-forced": 287,
                "../internals/is-pure": 290,
                "../internals/promise-native-constructor": 325,
                "../internals/well-known-symbol": 357
            }
        ],
        325: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global");
                t.exports = n.Promise;
            },
            {
                "../internals/global": 274
            }
        ],
        326: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/an-object"), i = e("../internals/is-object"), s = e("../internals/new-promise-capability");
                t.exports = function(e, t) {
                    if (n(e), i(t) && t.constructor === e) return t;
                    var r = s.f(e);
                    return (0, r.resolve)(t), r.promise;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/is-object": 289,
                "../internals/new-promise-capability": 303
            }
        ],
        327: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/promise-native-constructor"), i = e("../internals/check-correctness-of-iteration"), s = e("../internals/promise-constructor-detection").CONSTRUCTOR;
                t.exports = s || !i(function(e) {
                    n.all(e).then(void 0, function() {});
                });
            },
            {
                "../internals/check-correctness-of-iteration": 234,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325
            }
        ],
        328: [
            function(e, t, r) {
                "use strict";
                var n = function() {
                    this.head = null, this.tail = null;
                };
                n.prototype = {
                    add: function(e) {
                        var t = {
                            item: e,
                            next: null
                        }, r = this.tail;
                        r ? r.next = t : this.head = t, this.tail = t;
                    },
                    get: function() {
                        var e = this.head;
                        if (e) return null === (this.head = e.next) && (this.tail = null), e.item;
                    }
                }, t.exports = n;
            },
            {}
        ],
        329: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-null-or-undefined"), i = TypeError;
                t.exports = function(e) {
                    if (n(e)) throw new i("Can't call method on " + e);
                    return e;
                };
            },
            {
                "../internals/is-null-or-undefined": 288
            }
        ],
        330: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/define-built-in-accessor"), s = e("../internals/well-known-symbol"), o = e("../internals/descriptors"), a = s("species");
                t.exports = function(e) {
                    var t = n(e);
                    o && t && !t[a] && i(t, a, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            {
                "../internals/define-built-in-accessor": 244,
                "../internals/descriptors": 247,
                "../internals/get-built-in": 269,
                "../internals/well-known-symbol": 357
            }
        ],
        331: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-define-property").f, i = e("../internals/has-own-property"), s = e("../internals/well-known-symbol")("toStringTag");
                t.exports = function(e, t, r) {
                    e && !r && (e = e.prototype), e && !i(e, s) && n(e, s, {
                        configurable: !0,
                        value: t
                    });
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/well-known-symbol": 357
            }
        ],
        332: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/shared"), i = e("../internals/uid"), s = n("keys");
                t.exports = function(e) {
                    return s[e] || (s[e] = i(e));
                };
            },
            {
                "../internals/shared": 334,
                "../internals/uid": 350
            }
        ],
        333: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/define-global-property"), s = n["__core-js_shared__"] || i("__core-js_shared__", {});
                t.exports = s;
            },
            {
                "../internals/define-global-property": 246,
                "../internals/global": 274
            }
        ],
        334: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-pure"), i = e("../internals/shared-store");
                (t.exports = function(e, t) {
                    return i[e] || (i[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.33.0",
                    mode: n ? "pure" : "global",
                    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
                    license: "https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            {
                "../internals/is-pure": 290,
                "../internals/shared-store": 333
            }
        ],
        335: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/an-object"), i = e("../internals/a-constructor"), s = e("../internals/is-null-or-undefined"), o = e("../internals/well-known-symbol")("species");
                t.exports = function(e, t) {
                    var r, a = n(e).constructor;
                    return void 0 === a || s(r = n(a)[o]) ? t : i(r);
                };
            },
            {
                "../internals/a-constructor": 223,
                "../internals/an-object": 227,
                "../internals/is-null-or-undefined": 288,
                "../internals/well-known-symbol": 357
            }
        ],
        336: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-v8-version"), i = e("../internals/fails"), s = e("../internals/global").String;
                t.exports = !!Object.getOwnPropertySymbols && !i(function() {
                    var e = Symbol("symbol detection");
                    return !s(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
                });
            },
            {
                "../internals/engine-v8-version": 257,
                "../internals/fails": 260,
                "../internals/global": 274
            }
        ],
        337: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/get-built-in"), s = e("../internals/well-known-symbol"), o = e("../internals/define-built-in");
                t.exports = function() {
                    var e = i("Symbol"), t = e && e.prototype, r = t && t.valueOf, a = s("toPrimitive");
                    t && !t[a] && o(t, a, function(e) {
                        return n(r, this);
                    }, {
                        arity: 1
                    });
                };
            },
            {
                "../internals/define-built-in": 245,
                "../internals/function-call": 264,
                "../internals/get-built-in": 269,
                "../internals/well-known-symbol": 357
            }
        ],
        338: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/symbol-constructor-detection");
                t.exports = n && !!Symbol.for && !!Symbol.keyFor;
            },
            {
                "../internals/symbol-constructor-detection": 336
            }
        ],
        339: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o, a = e("../internals/global"), l = e("../internals/function-apply"), c = e("../internals/function-bind-context"), u = e("../internals/is-callable"), h = e("../internals/has-own-property"), f = e("../internals/fails"), d = e("../internals/html"), p = e("../internals/array-slice"), m = e("../internals/document-create-element"), b = e("../internals/validate-arguments-length"), g = e("../internals/engine-is-ios"), y = e("../internals/engine-is-node"), v = a.setImmediate, w = a.clearImmediate, _ = a.process, x = a.Dispatch, k = a.Function, S = a.MessageChannel, M = a.String, C = 0, T = {};
                f(function() {
                    n = a.location;
                });
                var E = function(e) {
                    if (h(T, e)) {
                        var t = T[e];
                        delete T[e], t();
                    }
                }, A = function(e) {
                    return function() {
                        E(e);
                    };
                }, R = function(e) {
                    E(e.data);
                }, O = function(e) {
                    a.postMessage(M(e), n.protocol + "//" + n.host);
                };
                v && w || (v = function(e) {
                    b(arguments.length, 1);
                    var t = u(e) ? e : k(e), r = p(arguments, 1);
                    return T[++C] = function() {
                        l(t, void 0, r);
                    }, i(C), C;
                }, w = function(e) {
                    delete T[e];
                }, y ? i = function(e) {
                    _.nextTick(A(e));
                } : x && x.now ? i = function(e) {
                    x.now(A(e));
                } : S && !g ? (o = (s = new S).port2, s.port1.onmessage = R, i = c(o.postMessage, o)) : a.addEventListener && u(a.postMessage) && !a.importScripts && n && "file:" !== n.protocol && !f(O) ? (i = O, a.addEventListener("message", R, !1)) : i = "onreadystatechange" in m("script") ? function(e) {
                    d.appendChild(m("script")).onreadystatechange = function() {
                        d.removeChild(this), E(e);
                    };
                } : function(e) {
                    setTimeout(A(e), 0);
                }), t.exports = {
                    set: v,
                    clear: w
                };
            },
            {
                "../internals/array-slice": 231,
                "../internals/document-create-element": 249,
                "../internals/engine-is-ios": 253,
                "../internals/engine-is-node": 254,
                "../internals/fails": 260,
                "../internals/function-apply": 261,
                "../internals/function-bind-context": 262,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/html": 278,
                "../internals/is-callable": 285,
                "../internals/validate-arguments-length": 353
            }
        ],
        340: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-integer-or-infinity"), i = Math.max, s = Math.min;
                t.exports = function(e, t) {
                    var r = n(e);
                    return r < 0 ? i(r + t, 0) : s(r, t);
                };
            },
            {
                "../internals/to-integer-or-infinity": 342
            }
        ],
        341: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/indexed-object"), i = e("../internals/require-object-coercible");
                t.exports = function(e) {
                    return n(i(e));
                };
            },
            {
                "../internals/indexed-object": 280,
                "../internals/require-object-coercible": 329
            }
        ],
        342: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/math-trunc");
                t.exports = function(e) {
                    var t = +e;
                    return t != t || 0 === t ? 0 : n(t);
                };
            },
            {
                "../internals/math-trunc": 301
            }
        ],
        343: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-integer-or-infinity"), i = Math.min;
                t.exports = function(e) {
                    return e > 0 ? i(n(e), 9007199254740991) : 0;
                };
            },
            {
                "../internals/to-integer-or-infinity": 342
            }
        ],
        344: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/require-object-coercible"), i = Object;
                t.exports = function(e) {
                    return i(n(e));
                };
            },
            {
                "../internals/require-object-coercible": 329
            }
        ],
        345: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/is-object"), s = e("../internals/is-symbol"), o = e("../internals/get-method"), a = e("../internals/ordinary-to-primitive"), l = e("../internals/well-known-symbol"), c = TypeError, u = l("toPrimitive");
                t.exports = function(e, t) {
                    if (!i(e) || s(e)) return e;
                    var r, l = o(e, u);
                    if (l) {
                        if (void 0 === t && (t = "default"), r = n(l, e, t), !i(r) || s(r)) return r;
                        throw new c("Can't convert object to primitive value");
                    }
                    return void 0 === t && (t = "number"), a(e, t);
                };
            },
            {
                "../internals/function-call": 264,
                "../internals/get-method": 273,
                "../internals/is-object": 289,
                "../internals/is-symbol": 292,
                "../internals/ordinary-to-primitive": 320,
                "../internals/well-known-symbol": 357
            }
        ],
        346: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-primitive"), i = e("../internals/is-symbol");
                t.exports = function(e) {
                    var t = n(e, "string");
                    return i(t) ? t : t + "";
                };
            },
            {
                "../internals/is-symbol": 292,
                "../internals/to-primitive": 345
            }
        ],
        347: [
            function(e, t, r) {
                "use strict";
                var n = {};
                n[e("../internals/well-known-symbol")("toStringTag")] = "z", t.exports = "[object z]" === String(n);
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        348: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof"), i = String;
                t.exports = function(e) {
                    if ("Symbol" === n(e)) throw new TypeError("Cannot convert a Symbol value to a string");
                    return i(e);
                };
            },
            {
                "../internals/classof": 236
            }
        ],
        349: [
            function(e, t, r) {
                "use strict";
                var n = String;
                t.exports = function(e) {
                    try {
                        return n(e);
                    } catch (e) {
                        return "Object";
                    }
                };
            },
            {}
        ],
        350: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = 0, s = Math.random(), o = n(1..toString);
                t.exports = function(e) {
                    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + o(++i + s, 36);
                };
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        351: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/symbol-constructor-detection");
                t.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            {
                "../internals/symbol-constructor-detection": 336
            }
        ],
        352: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails");
                t.exports = n && i(function() {
                    return 42 !== Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260
            }
        ],
        353: [
            function(e, t, r) {
                "use strict";
                var n = TypeError;
                t.exports = function(e, t) {
                    if (e < t) throw new n("Not enough arguments");
                    return e;
                };
            },
            {}
        ],
        354: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-callable"), s = n.WeakMap;
                t.exports = i(s) && /native code/.test(String(s));
            },
            {
                "../internals/global": 274,
                "../internals/is-callable": 285
            }
        ],
        355: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/path"), i = e("../internals/has-own-property"), s = e("../internals/well-known-symbol-wrapped"), o = e("../internals/object-define-property").f;
                t.exports = function(e) {
                    var t = n.Symbol || (n.Symbol = {});
                    i(t, e) || o(t, e, {
                        value: s.f(e)
                    });
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/path": 322,
                "../internals/well-known-symbol-wrapped": 356
            }
        ],
        356: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol");
                r.f = n;
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        357: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/shared"), s = e("../internals/has-own-property"), o = e("../internals/uid"), a = e("../internals/symbol-constructor-detection"), l = e("../internals/use-symbol-as-uid"), c = n.Symbol, u = i("wks"), h = l ? c.for || c : c && c.withoutSetter || o;
                t.exports = function(e) {
                    return s(u, e) || (u[e] = a && s(c, e) ? c[e] : h("Symbol." + e)), u[e];
                };
            },
            {
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/shared": 334,
                "../internals/symbol-constructor-detection": 336,
                "../internals/uid": 350,
                "../internals/use-symbol-as-uid": 351
            }
        ],
        358: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-iteration").findIndex, s = e("../internals/add-to-unscopables"), o = !0;
                "findIndex" in [] && Array(1).findIndex(function() {
                    o = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: o
                }, {
                    findIndex: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), s("findIndex");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-iteration": 229,
                "../internals/export": 259
            }
        ],
        359: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-iteration").find, s = e("../internals/add-to-unscopables"), o = !0;
                "find" in [] && Array(1).find(function() {
                    o = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: o
                }, {
                    find: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), s("find");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-iteration": 229,
                "../internals/export": 259
            }
        ],
        360: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-includes").includes, s = e("../internals/fails"), o = e("../internals/add-to-unscopables");
                n({
                    target: "Array",
                    proto: !0,
                    forced: s(function() {
                        return !Array(1).includes();
                    })
                }, {
                    includes: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), o("includes");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-includes": 228,
                "../internals/export": 259,
                "../internals/fails": 260
            }
        ],
        361: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-indexed-object"), i = e("../internals/add-to-unscopables"), s = e("../internals/iterators"), o = e("../internals/internal-state"), a = e("../internals/object-define-property").f, l = e("../internals/iterator-define"), c = e("../internals/create-iter-result-object"), u = e("../internals/is-pure"), h = e("../internals/descriptors"), f = o.set, d = o.getterFor("Array Iterator");
                t.exports = l(Array, "Array", function(e, t) {
                    f(this, {
                        type: "Array Iterator",
                        target: n(e),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e = d(this), t = e.target, r = e.kind, n = e.index++;
                    if (!t || n >= t.length) return e.target = void 0, c(void 0, !0);
                    switch(r){
                        case "keys":
                            return c(n, !1);
                        case "values":
                            return c(t[n], !1);
                    }
                    return c([
                        n,
                        t[n]
                    ], !1);
                }, "values");
                var p = s.Arguments = s.Array;
                if (i("keys"), i("values"), i("entries"), !u && h && "values" !== p.name) try {
                    a(p, "name", {
                        value: "values"
                    });
                } catch (e) {}
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/create-iter-result-object": 240,
                "../internals/descriptors": 247,
                "../internals/internal-state": 282,
                "../internals/is-pure": 290,
                "../internals/iterator-define": 296,
                "../internals/iterators": 298,
                "../internals/object-define-property": 308,
                "../internals/to-indexed-object": 341
            }
        ],
        362: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/function-apply"), o = e("../internals/function-call"), a = e("../internals/function-uncurry-this"), l = e("../internals/fails"), c = e("../internals/is-callable"), u = e("../internals/is-symbol"), h = e("../internals/array-slice"), f = e("../internals/get-json-replacer-function"), d = e("../internals/symbol-constructor-detection"), p = String, m = i("JSON", "stringify"), b = a(/./.exec), g = a("".charAt), y = a("".charCodeAt), v = a("".replace), w = a(1..toString), _ = /[\uD800-\uDFFF]/g, x = /^[\uD800-\uDBFF]$/, k = /^[\uDC00-\uDFFF]$/, S = !d || l(function() {
                    var e = i("Symbol")("stringify detection");
                    return "[null]" !== m([
                        e
                    ]) || "{}" !== m({
                        a: e
                    }) || "{}" !== m(Object(e));
                }), M = l(function() {
                    return '"\\udf06\\ud834"' !== m("\udf06\ud834") || '"\\udead"' !== m("\udead");
                }), C = function(e, t) {
                    var r = h(arguments), n = f(t);
                    if (c(n) || void 0 !== e && !u(e)) return r[1] = function(e, t) {
                        if (c(n) && (t = o(n, this, p(e), t)), !u(t)) return t;
                    }, s(m, null, r);
                }, T = function(e, t, r) {
                    var n = g(r, t - 1), i = g(r, t + 1);
                    return b(x, e) && !b(k, i) || b(k, e) && !b(x, n) ? "\\u" + w(y(e, 0), 16) : e;
                };
                m && n({
                    target: "JSON",
                    stat: !0,
                    arity: 3,
                    forced: S || M
                }, {
                    stringify: function(e, t, r) {
                        var n = h(arguments), i = s(S ? C : m, null, n);
                        return M && "string" == typeof i ? v(i, _, T) : i;
                    }
                });
            },
            {
                "../internals/array-slice": 231,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/function-apply": 261,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/get-json-replacer-function": 272,
                "../internals/is-callable": 285,
                "../internals/is-symbol": 292,
                "../internals/symbol-constructor-detection": 336
            }
        ],
        363: [
            function(e, t, r) {
                "use strict";
                e("../internals/export")({
                    target: "Number",
                    stat: !0
                }, {
                    isNaN: function(e) {
                        return e != e;
                    }
                });
            },
            {
                "../internals/export": 259
            }
        ],
        364: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/object-assign");
                n({
                    target: "Object",
                    stat: !0,
                    arity: 2,
                    forced: Object.assign !== i
                }, {
                    assign: i
                });
            },
            {
                "../internals/export": 259,
                "../internals/object-assign": 305
            }
        ],
        365: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/symbol-constructor-detection"), s = e("../internals/fails"), o = e("../internals/object-get-own-property-symbols"), a = e("../internals/to-object");
                n({
                    target: "Object",
                    stat: !0,
                    forced: !i || s(function() {
                        o.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(e) {
                        var t = o.f;
                        return t ? t(a(e)) : [];
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/symbol-constructor-detection": 336,
                "../internals/to-object": 344
            }
        ],
        366: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/to-object"), s = e("../internals/object-keys");
                n({
                    target: "Object",
                    stat: !0,
                    forced: e("../internals/fails")(function() {
                        s(1);
                    })
                }, {
                    keys: function(e) {
                        return s(i(e));
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/object-keys": 316,
                "../internals/to-object": 344
            }
        ],
        367: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/object-to-array").values;
                n({
                    target: "Object",
                    stat: !0
                }, {
                    values: function(e) {
                        return i(e);
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/object-to-array": 319
            }
        ],
        368: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/a-callable"), o = e("../internals/new-promise-capability"), a = e("../internals/perform"), l = e("../internals/iterate");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-statics-incorrect-iteration")
                }, {
                    all: function(e) {
                        var t = this, r = o.f(t), n = r.resolve, c = r.reject, u = a(function() {
                            var r = s(t.resolve), o = [], a = 0, u = 1;
                            l(e, function(e) {
                                var s = a++, l = !1;
                                u++, i(r, t, e).then(function(e) {
                                    l || (l = !0, o[s] = e, --u || n(o));
                                }, c);
                            }), --u || n(o);
                        });
                        return u.error && c(u.value), r.promise;
                    }
                });
            },
            {
                "../internals/a-callable": 222,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/iterate": 293,
                "../internals/new-promise-capability": 303,
                "../internals/perform": 323,
                "../internals/promise-statics-incorrect-iteration": 327
            }
        ],
        369: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/is-pure"), s = e("../internals/promise-constructor-detection").CONSTRUCTOR, o = e("../internals/promise-native-constructor"), a = e("../internals/get-built-in"), l = e("../internals/is-callable"), c = e("../internals/define-built-in"), u = o && o.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    forced: s,
                    real: !0
                }, {
                    catch: function(e) {
                        return this.then(void 0, e);
                    }
                }), !i && l(o)) {
                    var h = a("Promise").prototype.catch;
                    u.catch !== h && c(u, "catch", h, {
                        unsafe: !0
                    });
                }
            },
            {
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325
            }
        ],
        370: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/export"), a = e("../internals/is-pure"), l = e("../internals/engine-is-node"), c = e("../internals/global"), u = e("../internals/function-call"), h = e("../internals/define-built-in"), f = e("../internals/object-set-prototype-of"), d = e("../internals/set-to-string-tag"), p = e("../internals/set-species"), m = e("../internals/a-callable"), b = e("../internals/is-callable"), g = e("../internals/is-object"), y = e("../internals/an-instance"), v = e("../internals/species-constructor"), w = e("../internals/task").set, _ = e("../internals/microtask"), x = e("../internals/host-report-errors"), k = e("../internals/perform"), S = e("../internals/queue"), M = e("../internals/internal-state"), C = e("../internals/promise-native-constructor"), T = e("../internals/promise-constructor-detection"), E = e("../internals/new-promise-capability"), A = T.CONSTRUCTOR, R = T.REJECTION_EVENT, O = T.SUBCLASSING, j = M.getterFor("Promise"), I = M.set, N = C && C.prototype, P = C, B = N, D = c.TypeError, F = c.document, L = c.process, z = E.f, U = z, $ = !!(F && F.createEvent && c.dispatchEvent), H = function(e) {
                    var t;
                    return !(!g(e) || !b(t = e.then)) && t;
                }, V = function(e, t) {
                    var r, n, i, s = t.value, o = 1 === t.state, a = o ? e.ok : e.fail, l = e.resolve, c = e.reject, h = e.domain;
                    try {
                        a ? (o || (2 === t.rejection && Y(t), t.rejection = 1), !0 === a ? r = s : (h && h.enter(), r = a(s), h && (h.exit(), i = !0)), r === e.promise ? c(new D("Promise-chain cycle")) : (n = H(r)) ? u(n, r, l, c) : l(r)) : c(s);
                    } catch (e) {
                        h && !i && h.exit(), c(e);
                    }
                }, q = function(e, t) {
                    e.notified || (e.notified = !0, _(function() {
                        for(var r, n = e.reactions; r = n.get();)V(r, e);
                        e.notified = !1, t && !e.rejection && X(e);
                    }));
                }, W = function(e, t, r) {
                    var n, i;
                    $ ? ((n = F.createEvent("Event")).promise = t, n.reason = r, n.initEvent(e, !1, !0), c.dispatchEvent(n)) : n = {
                        promise: t,
                        reason: r
                    }, !R && (i = c["on" + e]) ? i(n) : "unhandledrejection" === e && x("Unhandled promise rejection", r);
                }, X = function(e) {
                    u(w, c, function() {
                        var t, r = e.facade, n = e.value;
                        if (K(e) && (t = k(function() {
                            l ? L.emit("unhandledRejection", n, r) : W("unhandledrejection", r, n);
                        }), e.rejection = l || K(e) ? 2 : 1, t.error)) throw t.value;
                    });
                }, K = function(e) {
                    return 1 !== e.rejection && !e.parent;
                }, Y = function(e) {
                    u(w, c, function() {
                        var t = e.facade;
                        l ? L.emit("rejectionHandled", t) : W("rejectionhandled", t, e.value);
                    });
                }, Z = function(e, t, r) {
                    return function(n) {
                        e(t, n, r);
                    };
                }, G = function(e, t, r) {
                    e.done || (e.done = !0, r && (e = r), e.value = t, e.state = 2, q(e, !0));
                }, J = function(e, t, r) {
                    if (!e.done) {
                        e.done = !0, r && (e = r);
                        try {
                            if (e.facade === t) throw new D("Promise can't be resolved itself");
                            var n = H(t);
                            n ? _(function() {
                                var r = {
                                    done: !1
                                };
                                try {
                                    u(n, t, Z(J, r, e), Z(G, r, e));
                                } catch (t) {
                                    G(r, t, e);
                                }
                            }) : (e.value = t, e.state = 1, q(e, !1));
                        } catch (t) {
                            G({
                                done: !1
                            }, t, e);
                        }
                    }
                };
                if (A && (B = (P = function(e) {
                    y(this, B), m(e), u(n, this);
                    var t = j(this);
                    try {
                        e(Z(J, t), Z(G, t));
                    } catch (e) {
                        G(t, e);
                    }
                }).prototype, (n = function(e) {
                    I(this, {
                        type: "Promise",
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: new S,
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = h(B, "then", function(e, t) {
                    var r = j(this), n = z(v(this, P));
                    return r.parent = !0, n.ok = !b(e) || e, n.fail = b(t) && t, n.domain = l ? L.domain : void 0, 0 === r.state ? r.reactions.add(n) : _(function() {
                        V(n, r);
                    }), n.promise;
                }), i = function() {
                    var e = new n, t = j(e);
                    this.promise = e, this.resolve = Z(J, t), this.reject = Z(G, t);
                }, E.f = z = function(e) {
                    return e === P || void 0 === e ? new i(e) : U(e);
                }, !a && b(C) && N !== Object.prototype)) {
                    s = N.then, O || h(N, "then", function(e, t) {
                        var r = this;
                        return new P(function(e, t) {
                            u(s, r, e, t);
                        }).then(e, t);
                    }, {
                        unsafe: !0
                    });
                    try {
                        delete N.constructor;
                    } catch (e) {}
                    f && f(N, B);
                }
                o({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: A
                }, {
                    Promise: P
                }), d(P, "Promise", !1, !0), p("Promise");
            },
            {
                "../internals/a-callable": 222,
                "../internals/an-instance": 226,
                "../internals/define-built-in": 245,
                "../internals/engine-is-node": 254,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/global": 274,
                "../internals/host-report-errors": 277,
                "../internals/internal-state": 282,
                "../internals/is-callable": 285,
                "../internals/is-object": 289,
                "../internals/is-pure": 290,
                "../internals/microtask": 302,
                "../internals/new-promise-capability": 303,
                "../internals/object-set-prototype-of": 318,
                "../internals/perform": 323,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325,
                "../internals/queue": 328,
                "../internals/set-species": 330,
                "../internals/set-to-string-tag": 331,
                "../internals/species-constructor": 335,
                "../internals/task": 339
            }
        ],
        371: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/is-pure"), s = e("../internals/promise-native-constructor"), o = e("../internals/fails"), a = e("../internals/get-built-in"), l = e("../internals/is-callable"), c = e("../internals/species-constructor"), u = e("../internals/promise-resolve"), h = e("../internals/define-built-in"), f = s && s.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    real: !0,
                    forced: !!s && o(function() {
                        f.finally.call({
                            then: function() {}
                        }, function() {});
                    })
                }, {
                    finally: function(e) {
                        var t = c(this, a("Promise")), r = l(e);
                        return this.then(r ? function(r) {
                            return u(t, e()).then(function() {
                                return r;
                            });
                        } : e, r ? function(r) {
                            return u(t, e()).then(function() {
                                throw r;
                            });
                        } : e);
                    }
                }), !i && l(s)) {
                    var d = a("Promise").prototype.finally;
                    f.finally !== d && h(f, "finally", d, {
                        unsafe: !0
                    });
                }
            },
            {
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/promise-native-constructor": 325,
                "../internals/promise-resolve": 326,
                "../internals/species-constructor": 335
            }
        ],
        372: [
            function(e, t, r) {
                "use strict";
                e("../modules/es.promise.constructor"), e("../modules/es.promise.all"), e("../modules/es.promise.catch"), e("../modules/es.promise.race"), e("../modules/es.promise.reject"), e("../modules/es.promise.resolve");
            },
            {
                "../modules/es.promise.all": 368,
                "../modules/es.promise.catch": 369,
                "../modules/es.promise.constructor": 370,
                "../modules/es.promise.race": 373,
                "../modules/es.promise.reject": 374,
                "../modules/es.promise.resolve": 375
            }
        ],
        373: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/a-callable"), o = e("../internals/new-promise-capability"), a = e("../internals/perform"), l = e("../internals/iterate");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-statics-incorrect-iteration")
                }, {
                    race: function(e) {
                        var t = this, r = o.f(t), n = r.reject, c = a(function() {
                            var o = s(t.resolve);
                            l(e, function(e) {
                                i(o, t, e).then(r.resolve, n);
                            });
                        });
                        return c.error && n(c.value), r.promise;
                    }
                });
            },
            {
                "../internals/a-callable": 222,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/iterate": 293,
                "../internals/new-promise-capability": 303,
                "../internals/perform": 323,
                "../internals/promise-statics-incorrect-iteration": 327
            }
        ],
        374: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/new-promise-capability");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-constructor-detection").CONSTRUCTOR
                }, {
                    reject: function(e) {
                        var t = s.f(this);
                        return i(t.reject, void 0, e), t.promise;
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/new-promise-capability": 303,
                "../internals/promise-constructor-detection": 324
            }
        ],
        375: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/is-pure"), o = e("../internals/promise-native-constructor"), a = e("../internals/promise-constructor-detection").CONSTRUCTOR, l = e("../internals/promise-resolve"), c = i("Promise"), u = s && !a;
                n({
                    target: "Promise",
                    stat: !0,
                    forced: s || a
                }, {
                    resolve: function(e) {
                        return l(u && this === c ? o : this, e);
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/is-pure": 290,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325,
                "../internals/promise-resolve": 326
            }
        ],
        376: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-uncurry-this"), s = e("../internals/to-absolute-index"), o = RangeError, a = String.fromCharCode, l = String.fromCodePoint, c = i([].join);
                n({
                    target: "String",
                    stat: !0,
                    arity: 1,
                    forced: !!l && 1 !== l.length
                }, {
                    fromCodePoint: function(e) {
                        for(var t, r = [], n = arguments.length, i = 0; n > i;){
                            if (t = +arguments[i++], s(t, 1114111) !== t) throw new o(t + " is not a valid code point");
                            r[i] = t < 65536 ? a(t) : a(55296 + ((t -= 65536) >> 10), t % 1024 + 56320);
                        }
                        return c(r, "");
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/function-uncurry-this": 268,
                "../internals/to-absolute-index": 340
            }
        ],
        377: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-uncurry-this"), s = e("../internals/not-a-regexp"), o = e("../internals/require-object-coercible"), a = e("../internals/to-string"), l = e("../internals/correct-is-regexp-logic"), c = i("".indexOf);
                n({
                    target: "String",
                    proto: !0,
                    forced: !l("includes")
                }, {
                    includes: function(e) {
                        return !!~c(a(o(this)), a(s(e)), arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 238,
                "../internals/export": 259,
                "../internals/function-uncurry-this": 268,
                "../internals/not-a-regexp": 304,
                "../internals/require-object-coercible": 329,
                "../internals/to-string": 348
            }
        ],
        378: [
            function(e, t, r) {
                "use strict";
                e("../internals/well-known-symbol-define")("asyncIterator");
            },
            {
                "../internals/well-known-symbol-define": 355
            }
        ],
        379: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/global"), s = e("../internals/function-call"), o = e("../internals/function-uncurry-this"), a = e("../internals/is-pure"), l = e("../internals/descriptors"), c = e("../internals/symbol-constructor-detection"), u = e("../internals/fails"), h = e("../internals/has-own-property"), f = e("../internals/object-is-prototype-of"), d = e("../internals/an-object"), p = e("../internals/to-indexed-object"), m = e("../internals/to-property-key"), b = e("../internals/to-string"), g = e("../internals/create-property-descriptor"), y = e("../internals/object-create"), v = e("../internals/object-keys"), w = e("../internals/object-get-own-property-names"), _ = e("../internals/object-get-own-property-names-external"), x = e("../internals/object-get-own-property-symbols"), k = e("../internals/object-get-own-property-descriptor"), S = e("../internals/object-define-property"), M = e("../internals/object-define-properties"), C = e("../internals/object-property-is-enumerable"), T = e("../internals/define-built-in"), E = e("../internals/define-built-in-accessor"), A = e("../internals/shared"), R = e("../internals/shared-key"), O = e("../internals/hidden-keys"), j = e("../internals/uid"), I = e("../internals/well-known-symbol"), N = e("../internals/well-known-symbol-wrapped"), P = e("../internals/well-known-symbol-define"), B = e("../internals/symbol-define-to-primitive"), D = e("../internals/set-to-string-tag"), F = e("../internals/internal-state"), L = e("../internals/array-iteration").forEach, z = R("hidden"), U = F.set, $ = F.getterFor("Symbol"), H = Object.prototype, V = i.Symbol, q = V && V.prototype, W = i.RangeError, X = i.TypeError, K = i.QObject, Y = k.f, Z = S.f, G = _.f, J = C.f, Q = o([].push), ee = A("symbols"), te = A("op-symbols"), re = A("wks"), ne = !K || !K.prototype || !K.prototype.findChild, ie = function(e, t, r) {
                    var n = Y(H, t);
                    n && delete H[t], Z(e, t, r), n && e !== H && Z(H, t, n);
                }, se = l && u(function() {
                    return 7 !== y(Z({}, "a", {
                        get: function() {
                            return Z(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? ie : Z, oe = function(e, t) {
                    var r = ee[e] = y(q);
                    return U(r, {
                        type: "Symbol",
                        tag: e,
                        description: t
                    }), l || (r.description = t), r;
                }, ae = function(e, t, r) {
                    e === H && ae(te, t, r), d(e);
                    var n = m(t);
                    return d(r), h(ee, n) ? (r.enumerable ? (h(e, z) && e[z][n] && (e[z][n] = !1), r = y(r, {
                        enumerable: g(0, !1)
                    })) : (h(e, z) || Z(e, z, g(1, {})), e[z][n] = !0), se(e, n, r)) : Z(e, n, r);
                }, le = function(e, t) {
                    d(e);
                    var r = p(t), n = v(r).concat(fe(r));
                    return L(n, function(t) {
                        l && !s(ce, r, t) || ae(e, t, r[t]);
                    }), e;
                }, ce = function(e) {
                    var t = m(e), r = s(J, this, t);
                    return !(this === H && h(ee, t) && !h(te, t)) && (!(r || !h(this, t) || !h(ee, t) || h(this, z) && this[z][t]) || r);
                }, ue = function(e, t) {
                    var r = p(e), n = m(t);
                    if (r !== H || !h(ee, n) || h(te, n)) {
                        var i = Y(r, n);
                        return !i || !h(ee, n) || h(r, z) && r[z][n] || (i.enumerable = !0), i;
                    }
                }, he = function(e) {
                    var t = G(p(e)), r = [];
                    return L(t, function(e) {
                        h(ee, e) || h(O, e) || Q(r, e);
                    }), r;
                }, fe = function(e) {
                    var t = e === H, r = G(t ? te : p(e)), n = [];
                    return L(r, function(e) {
                        !h(ee, e) || t && !h(H, e) || Q(n, ee[e]);
                    }), n;
                };
                c || (T(q = (V = function() {
                    if (f(q, this)) throw new X("Symbol is not a constructor");
                    var e = arguments.length && void 0 !== arguments[0] ? b(arguments[0]) : void 0, t = j(e), r = function(e) {
                        this === H && s(r, te, e), h(this, z) && h(this[z], t) && (this[z][t] = !1);
                        var n = g(1, e);
                        try {
                            se(this, t, n);
                        } catch (e) {
                            if (!(e instanceof W)) throw e;
                            ie(this, t, n);
                        }
                    };
                    return l && ne && se(H, t, {
                        configurable: !0,
                        set: r
                    }), oe(t, e);
                }).prototype, "toString", function() {
                    return $(this).tag;
                }), T(V, "withoutSetter", function(e) {
                    return oe(j(e), e);
                }), C.f = ce, S.f = ae, M.f = le, k.f = ue, w.f = _.f = he, x.f = fe, N.f = function(e) {
                    return oe(I(e), e);
                }, l && (E(q, "description", {
                    configurable: !0,
                    get: function() {
                        return $(this).description;
                    }
                }), a || T(H, "propertyIsEnumerable", ce, {
                    unsafe: !0
                }))), n({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: !c,
                    sham: !c
                }, {
                    Symbol: V
                }), L(v(re), function(e) {
                    P(e);
                }), n({
                    target: "Symbol",
                    stat: !0,
                    forced: !c
                }, {
                    useSetter: function() {
                        ne = !0;
                    },
                    useSimple: function() {
                        ne = !1;
                    }
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c,
                    sham: !l
                }, {
                    create: function(e, t) {
                        return void 0 === t ? y(e) : le(y(e), t);
                    },
                    defineProperty: ae,
                    defineProperties: le,
                    getOwnPropertyDescriptor: ue
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c
                }, {
                    getOwnPropertyNames: he
                }), B(), D(V, "Symbol"), O[z] = !0;
            },
            {
                "../internals/an-object": 227,
                "../internals/array-iteration": 229,
                "../internals/create-property-descriptor": 242,
                "../internals/define-built-in": 245,
                "../internals/define-built-in-accessor": 244,
                "../internals/descriptors": 247,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/internal-state": 282,
                "../internals/is-pure": 290,
                "../internals/object-create": 306,
                "../internals/object-define-properties": 307,
                "../internals/object-define-property": 308,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/object-get-own-property-names": 311,
                "../internals/object-get-own-property-names-external": 310,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/object-is-prototype-of": 314,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/set-to-string-tag": 331,
                "../internals/shared": 334,
                "../internals/shared-key": 332,
                "../internals/symbol-constructor-detection": 336,
                "../internals/symbol-define-to-primitive": 337,
                "../internals/to-indexed-object": 341,
                "../internals/to-property-key": 346,
                "../internals/to-string": 348,
                "../internals/uid": 350,
                "../internals/well-known-symbol": 357,
                "../internals/well-known-symbol-define": 355,
                "../internals/well-known-symbol-wrapped": 356
            }
        ],
        380: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/has-own-property"), o = e("../internals/to-string"), a = e("../internals/shared"), l = e("../internals/symbol-registry-detection"), c = a("string-to-symbol-registry"), u = a("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    for: function(e) {
                        var t = o(e);
                        if (s(c, t)) return c[t];
                        var r = i("Symbol")(t);
                        return c[t] = r, u[r] = t, r;
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/has-own-property": 275,
                "../internals/shared": 334,
                "../internals/symbol-registry-detection": 338,
                "../internals/to-string": 348
            }
        ],
        381: [
            function(e, t, r) {
                "use strict";
                e("../modules/es.symbol.constructor"), e("../modules/es.symbol.for"), e("../modules/es.symbol.key-for"), e("../modules/es.json.stringify"), e("../modules/es.object.get-own-property-symbols");
            },
            {
                "../modules/es.json.stringify": 362,
                "../modules/es.object.get-own-property-symbols": 365,
                "../modules/es.symbol.constructor": 379,
                "../modules/es.symbol.for": 380,
                "../modules/es.symbol.key-for": 382
            }
        ],
        382: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/has-own-property"), s = e("../internals/is-symbol"), o = e("../internals/try-to-string"), a = e("../internals/shared"), l = e("../internals/symbol-registry-detection"), c = a("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    keyFor: function(e) {
                        if (!s(e)) throw new TypeError(o(e) + " is not a symbol");
                        if (i(c, e)) return c[e];
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/has-own-property": 275,
                "../internals/is-symbol": 292,
                "../internals/shared": 334,
                "../internals/symbol-registry-detection": 338,
                "../internals/try-to-string": 349
            }
        ],
        383: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    return Object.prototype.toString.call(e);
                }
                r.isArray = function(e) {
                    return Array.isArray ? Array.isArray(e) : "[object Array]" === n(e);
                }, r.isBoolean = function(e) {
                    return "boolean" == typeof e;
                }, r.isNull = function(e) {
                    return null === e;
                }, r.isNullOrUndefined = function(e) {
                    return null == e;
                }, r.isNumber = function(e) {
                    return "number" == typeof e;
                }, r.isString = function(e) {
                    return "string" == typeof e;
                }, r.isSymbol = function(e) {
                    return "symbol" == typeof e;
                }, r.isUndefined = function(e) {
                    return void 0 === e;
                }, r.isRegExp = function(e) {
                    return "[object RegExp]" === n(e);
                }, r.isObject = function(e) {
                    return "object" == typeof e && null !== e;
                }, r.isDate = function(e) {
                    return "[object Date]" === n(e);
                }, r.isError = function(e) {
                    return "[object Error]" === n(e) || e instanceof Error;
                }, r.isFunction = function(e) {
                    return "function" == typeof e;
                }, r.isPrimitive = function(e) {
                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                }, r.isBuffer = e("buffer").Buffer.isBuffer;
            },
            {
                buffer: 220
            }
        ],
        384: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("elliptic"), i = e("bn.js");
                        t.exports = function(e) {
                            return new o(e);
                        };
                        var s = {
                            secp256k1: {
                                name: "secp256k1",
                                byteLength: 32
                            },
                            secp224r1: {
                                name: "p224",
                                byteLength: 28
                            },
                            prime256v1: {
                                name: "p256",
                                byteLength: 32
                            },
                            prime192v1: {
                                name: "p192",
                                byteLength: 24
                            },
                            ed25519: {
                                name: "ed25519",
                                byteLength: 32
                            },
                            secp384r1: {
                                name: "p384",
                                byteLength: 48
                            },
                            secp521r1: {
                                name: "p521",
                                byteLength: 66
                            }
                        };
                        function o(e) {
                            this.curveType = s[e], this.curveType || (this.curveType = {
                                name: e
                            }), this.curve = new n.ec(this.curveType.name), this.keys = void 0;
                        }
                        function a(e, t, n) {
                            Array.isArray(e) || (e = e.toArray());
                            var i = new r(e);
                            if (n && i.length < n) {
                                var s = new r(n - i.length);
                                s.fill(0), i = r.concat([
                                    s,
                                    i
                                ]);
                            }
                            return t ? i.toString(t) : i;
                        }
                        s.p224 = s.secp224r1, s.p256 = s.secp256r1 = s.prime256v1, s.p192 = s.secp192r1 = s.prime192v1, s.p384 = s.secp384r1, s.p521 = s.secp521r1, o.prototype.generateKeys = function(e, t) {
                            return this.keys = this.curve.genKeyPair(), this.getPublicKey(e, t);
                        }, o.prototype.computeSecret = function(e, t, n) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), a(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(), n, this.curveType.byteLength);
                        }, o.prototype.getPublicKey = function(e, t) {
                            var r = this.keys.getPublic("compressed" === t, !0);
                            return "hybrid" === t && (r[r.length - 1] % 2 ? r[0] = 7 : r[0] = 6), a(r, e);
                        }, o.prototype.getPrivateKey = function(e) {
                            return a(this.keys.getPrivate(), e);
                        }, o.prototype.setPublicKey = function(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this.keys._importPublic(e), this;
                        }, o.prototype.setPrivateKey = function(e, t) {
                            t = t || "utf8", r.isBuffer(e) || (e = new r(e, t));
                            var n = new i(e);
                            return n = n.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(n), this;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "bn.js": 385,
                buffer: 220,
                elliptic: 405
            }
        ],
        385: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        386: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("md5.js"), s = e("ripemd160"), o = e("sha.js"), a = e("cipher-base");
                function l(e) {
                    a.call(this, "digest"), this._hash = e;
                }
                n(l, a), l.prototype._update = function(e) {
                    this._hash.update(e);
                }, l.prototype._final = function() {
                    return this._hash.digest();
                }, t.exports = function(e) {
                    return "md5" === (e = e.toLowerCase()) ? new i : "rmd160" === e || "ripemd160" === e ? new s : new l(o(e));
                };
            },
            {
                "cipher-base": 221,
                inherits: 440,
                "md5.js": 450,
                ripemd160: 493,
                "sha.js": 498
            }
        ],
        387: [
            function(e, t, r) {
                "use strict";
                var n = e("md5.js");
                t.exports = function(e) {
                    return (new n).update(e).digest();
                };
            },
            {
                "md5.js": 450
            }
        ],
        388: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./legacy"), s = e("cipher-base"), o = e("safe-buffer").Buffer, a = e("create-hash/md5"), l = e("ripemd160"), c = e("sha.js"), u = o.alloc(128);
                function h(e, t) {
                    s.call(this, "digest"), "string" == typeof t && (t = o.from(t));
                    var r = "sha512" === e || "sha384" === e ? 128 : 64;
                    (this._alg = e, this._key = t, t.length > r) ? t = ("rmd160" === e ? new l : c(e)).update(t).digest() : t.length < r && (t = o.concat([
                        t,
                        u
                    ], r));
                    for(var n = this._ipad = o.allocUnsafe(r), i = this._opad = o.allocUnsafe(r), a = 0; a < r; a++)n[a] = 54 ^ t[a], i[a] = 92 ^ t[a];
                    this._hash = "rmd160" === e ? new l : c(e), this._hash.update(n);
                }
                n(h, s), h.prototype._update = function(e) {
                    this._hash.update(e);
                }, h.prototype._final = function() {
                    var e = this._hash.digest();
                    return ("rmd160" === this._alg ? new l : c(this._alg)).update(this._opad).update(e).digest();
                }, t.exports = function(e, t) {
                    return "rmd160" === (e = e.toLowerCase()) || "ripemd160" === e ? new h("rmd160", t) : "md5" === e ? new i(a, t) : new h(e, t);
                };
            },
            {
                "./legacy": 389,
                "cipher-base": 221,
                "create-hash/md5": 387,
                inherits: 440,
                ripemd160: 493,
                "safe-buffer": 494,
                "sha.js": 498
            }
        ],
        389: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("safe-buffer").Buffer, s = e("cipher-base"), o = i.alloc(128);
                function a(e, t) {
                    s.call(this, "digest"), "string" == typeof t && (t = i.from(t)), this._alg = e, this._key = t, t.length > 64 ? t = e(t) : t.length < 64 && (t = i.concat([
                        t,
                        o
                    ], 64));
                    for(var r = this._ipad = i.allocUnsafe(64), n = this._opad = i.allocUnsafe(64), a = 0; a < 64; a++)r[a] = 54 ^ t[a], n[a] = 92 ^ t[a];
                    this._hash = [
                        r
                    ];
                }
                n(a, s), a.prototype._update = function(e) {
                    this._hash.push(e);
                }, a.prototype._final = function() {
                    var e = this._alg(i.concat(this._hash));
                    return this._alg(i.concat([
                        this._opad,
                        e
                    ]));
                }, t.exports = a;
            },
            {
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        390: [
            function(e, t, r) {
                "use strict";
                r.randomBytes = r.rng = r.pseudoRandomBytes = r.prng = e("randombytes"), r.createHash = r.Hash = e("create-hash"), r.createHmac = r.Hmac = e("create-hmac");
                var n = e("browserify-sign/algos"), i = Object.keys(n), s = [
                    "sha1",
                    "sha224",
                    "sha256",
                    "sha384",
                    "sha512",
                    "md5",
                    "rmd160"
                ].concat(i);
                r.getHashes = function() {
                    return s;
                };
                var o = e("pbkdf2");
                r.pbkdf2 = o.pbkdf2, r.pbkdf2Sync = o.pbkdf2Sync;
                var a = e("browserify-cipher");
                r.Cipher = a.Cipher, r.createCipher = a.createCipher, r.Cipheriv = a.Cipheriv, r.createCipheriv = a.createCipheriv, r.Decipher = a.Decipher, r.createDecipher = a.createDecipher, r.Decipheriv = a.Decipheriv, r.createDecipheriv = a.createDecipheriv, r.getCiphers = a.getCiphers, r.listCiphers = a.listCiphers;
                var l = e("diffie-hellman");
                r.DiffieHellmanGroup = l.DiffieHellmanGroup, r.createDiffieHellmanGroup = l.createDiffieHellmanGroup, r.getDiffieHellman = l.getDiffieHellman, r.createDiffieHellman = l.createDiffieHellman, r.DiffieHellman = l.DiffieHellman;
                var c = e("browserify-sign");
                r.createSign = c.createSign, r.Sign = c.Sign, r.createVerify = c.createVerify, r.Verify = c.Verify, r.createECDH = e("create-ecdh");
                var u = e("public-encrypt");
                r.publicEncrypt = u.publicEncrypt, r.privateEncrypt = u.privateEncrypt, r.publicDecrypt = u.publicDecrypt, r.privateDecrypt = u.privateDecrypt;
                var h = e("randomfill");
                r.randomFill = h.randomFill, r.randomFillSync = h.randomFillSync, r.createCredentials = function() {
                    throw new Error([
                        "sorry, createCredentials is not implemented yet",
                        "we accept pull requests",
                        "https://github.com/crypto-browserify/crypto-browserify"
                    ].join("\n"));
                }, r.constants = {
                    DH_CHECK_P_NOT_SAFE_PRIME: 2,
                    DH_CHECK_P_NOT_PRIME: 1,
                    DH_UNABLE_TO_CHECK_GENERATOR: 4,
                    DH_NOT_SUITABLE_GENERATOR: 8,
                    NPN_ENABLED: 1,
                    ALPN_ENABLED: 1,
                    RSA_PKCS1_PADDING: 1,
                    RSA_SSLV23_PADDING: 2,
                    RSA_NO_PADDING: 3,
                    RSA_PKCS1_OAEP_PADDING: 4,
                    RSA_X931_PADDING: 5,
                    RSA_PKCS1_PSS_PADDING: 6,
                    POINT_CONVERSION_COMPRESSED: 2,
                    POINT_CONVERSION_UNCOMPRESSED: 4,
                    POINT_CONVERSION_HYBRID: 6
                };
            },
            {
                "browserify-cipher": 206,
                "browserify-sign": 213,
                "browserify-sign/algos": 210,
                "create-ecdh": 384,
                "create-hash": 386,
                "create-hmac": 388,
                "diffie-hellman": 400,
                pbkdf2: 460,
                "public-encrypt": 468,
                randombytes: 475,
                randomfill: 476
            }
        ],
        391: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs = n();
                }(void 0, function() {
                    var e = 6e4, t = 36e5, r = "millisecond", n = "second", i = "minute", s = "hour", o = "day", a = "week", l = "month", c = "quarter", u = "year", h = "date", f = "Invalid Date", d = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, p = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, m = {
                        name: "en",
                        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
                        ordinal: function(e) {
                            var t = [
                                "th",
                                "st",
                                "nd",
                                "rd"
                            ], r = e % 100;
                            return "[" + e + (t[(r - 20) % 10] || t[r] || t[0]) + "]";
                        }
                    }, b = function(e, t, r) {
                        var n = String(e);
                        return !n || n.length >= t ? e : "" + Array(t + 1 - n.length).join(r) + e;
                    }, g = {
                        s: b,
                        z: function(e) {
                            var t = -e.utcOffset(), r = Math.abs(t), n = Math.floor(r / 60), i = r % 60;
                            return (t <= 0 ? "+" : "-") + b(n, 2, "0") + ":" + b(i, 2, "0");
                        },
                        m: function e(t, r) {
                            if (t.date() < r.date()) return -e(r, t);
                            var n = 12 * (r.year() - t.year()) + (r.month() - t.month()), i = t.clone().add(n, l), s = r - i < 0, o = t.clone().add(n + (s ? -1 : 1), l);
                            return +(-(n + (r - i) / (s ? i - o : o - i)) || 0);
                        },
                        a: function(e) {
                            return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
                        },
                        p: function(e) {
                            return ({
                                M: l,
                                y: u,
                                w: a,
                                d: o,
                                D: h,
                                h: s,
                                m: i,
                                s: n,
                                ms: r,
                                Q: c
                            })[e] || String(e || "").toLowerCase().replace(/s$/, "");
                        },
                        u: function(e) {
                            return void 0 === e;
                        }
                    }, y = "en", v = {};
                    v[y] = m;
                    var w = "$isDayjsObject", _ = function(e) {
                        return e instanceof M || !(!e || !e[w]);
                    }, x = function e(t, r, n) {
                        var i;
                        if (!t) return y;
                        if ("string" == typeof t) {
                            var s = t.toLowerCase();
                            v[s] && (i = s), r && (v[s] = r, i = s);
                            var o = t.split("-");
                            if (!i && o.length > 1) return e(o[0]);
                        } else {
                            var a = t.name;
                            v[a] = t, i = a;
                        }
                        return !n && i && (y = i), i || !n && y;
                    }, k = function(e, t) {
                        if (_(e)) return e.clone();
                        var r = "object" == typeof t ? t : {};
                        return r.date = e, r.args = arguments, new M(r);
                    }, S = g;
                    S.l = x, S.i = _, S.w = function(e, t) {
                        return k(e, {
                            locale: t.$L,
                            utc: t.$u,
                            x: t.$x,
                            $offset: t.$offset
                        });
                    };
                    var M = function() {
                        function m(e) {
                            this.$L = x(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[w] = !0;
                        }
                        var b = m.prototype;
                        return b.parse = function(e) {
                            this.$d = function(e) {
                                var t = e.date, r = e.utc;
                                if (null === t) return new Date(NaN);
                                if (S.u(t)) return new Date;
                                if (t instanceof Date) return new Date(t);
                                if ("string" == typeof t && !/Z$/i.test(t)) {
                                    var n = t.match(d);
                                    if (n) {
                                        var i = n[2] - 1 || 0, s = (n[7] || "0").substring(0, 3);
                                        return r ? new Date(Date.UTC(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s)) : new Date(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s);
                                    }
                                }
                                return new Date(t);
                            }(e), this.init();
                        }, b.init = function() {
                            var e = this.$d;
                            this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
                        }, b.$utils = function() {
                            return S;
                        }, b.isValid = function() {
                            return !(this.$d.toString() === f);
                        }, b.isSame = function(e, t) {
                            var r = k(e);
                            return this.startOf(t) <= r && r <= this.endOf(t);
                        }, b.isAfter = function(e, t) {
                            return k(e) < this.startOf(t);
                        }, b.isBefore = function(e, t) {
                            return this.endOf(t) < k(e);
                        }, b.$g = function(e, t, r) {
                            return S.u(e) ? this[t] : this.set(r, e);
                        }, b.unix = function() {
                            return Math.floor(this.valueOf() / 1e3);
                        }, b.valueOf = function() {
                            return this.$d.getTime();
                        }, b.startOf = function(e, t) {
                            var r = this, c = !!S.u(t) || t, f = S.p(e), d = function(e, t) {
                                var n = S.w(r.$u ? Date.UTC(r.$y, t, e) : new Date(r.$y, t, e), r);
                                return c ? n : n.endOf(o);
                            }, p = function(e, t) {
                                return S.w(r.toDate()[e].apply(r.toDate("s"), (c ? [
                                    0,
                                    0,
                                    0,
                                    0
                                ] : [
                                    23,
                                    59,
                                    59,
                                    999
                                ]).slice(t)), r);
                            }, m = this.$W, b = this.$M, g = this.$D, y = "set" + (this.$u ? "UTC" : "");
                            switch(f){
                                case u:
                                    return c ? d(1, 0) : d(31, 11);
                                case l:
                                    return c ? d(1, b) : d(0, b + 1);
                                case a:
                                    var v = this.$locale().weekStart || 0, w = (m < v ? m + 7 : m) - v;
                                    return d(c ? g - w : g + (6 - w), b);
                                case o:
                                case h:
                                    return p(y + "Hours", 0);
                                case s:
                                    return p(y + "Minutes", 1);
                                case i:
                                    return p(y + "Seconds", 2);
                                case n:
                                    return p(y + "Milliseconds", 3);
                                default:
                                    return this.clone();
                            }
                        }, b.endOf = function(e) {
                            return this.startOf(e, !1);
                        }, b.$set = function(e, t) {
                            var a, c = S.p(e), f = "set" + (this.$u ? "UTC" : ""), d = (a = {}, a[o] = f + "Date", a[h] = f + "Date", a[l] = f + "Month", a[u] = f + "FullYear", a[s] = f + "Hours", a[i] = f + "Minutes", a[n] = f + "Seconds", a[r] = f + "Milliseconds", a)[c], p = c === o ? this.$D + (t - this.$W) : t;
                            if (c === l || c === u) {
                                var m = this.clone().set(h, 1);
                                m.$d[d](p), m.init(), this.$d = m.set(h, Math.min(this.$D, m.daysInMonth())).$d;
                            } else d && this.$d[d](p);
                            return this.init(), this;
                        }, b.set = function(e, t) {
                            return this.clone().$set(e, t);
                        }, b.get = function(e) {
                            return this[S.p(e)]();
                        }, b.add = function(r, c) {
                            var h, f = this;
                            r = Number(r);
                            var d = S.p(c), p = function(e) {
                                var t = k(f);
                                return S.w(t.date(t.date() + Math.round(e * r)), f);
                            };
                            if (d === l) return this.set(l, this.$M + r);
                            if (d === u) return this.set(u, this.$y + r);
                            if (d === o) return p(1);
                            if (d === a) return p(7);
                            var m = (h = {}, h[i] = e, h[s] = t, h[n] = 1e3, h)[d] || 1, b = this.$d.getTime() + r * m;
                            return S.w(b, this);
                        }, b.subtract = function(e, t) {
                            return this.add(-1 * e, t);
                        }, b.format = function(e) {
                            var t = this, r = this.$locale();
                            if (!this.isValid()) return r.invalidDate || f;
                            var n = e || "YYYY-MM-DDTHH:mm:ssZ", i = S.z(this), s = this.$H, o = this.$m, a = this.$M, l = r.weekdays, c = r.months, u = r.meridiem, h = function(e, r, i, s) {
                                return e && (e[r] || e(t, n)) || i[r].slice(0, s);
                            }, d = function(e) {
                                return S.s(s % 12 || 12, e, "0");
                            }, m = u || function(e, t, r) {
                                var n = e < 12 ? "AM" : "PM";
                                return r ? n.toLowerCase() : n;
                            };
                            return n.replace(p, function(e, n) {
                                return n || function(e) {
                                    switch(e){
                                        case "YY":
                                            return String(t.$y).slice(-2);
                                        case "YYYY":
                                            return S.s(t.$y, 4, "0");
                                        case "M":
                                            return a + 1;
                                        case "MM":
                                            return S.s(a + 1, 2, "0");
                                        case "MMM":
                                            return h(r.monthsShort, a, c, 3);
                                        case "MMMM":
                                            return h(c, a);
                                        case "D":
                                            return t.$D;
                                        case "DD":
                                            return S.s(t.$D, 2, "0");
                                        case "d":
                                            return String(t.$W);
                                        case "dd":
                                            return h(r.weekdaysMin, t.$W, l, 2);
                                        case "ddd":
                                            return h(r.weekdaysShort, t.$W, l, 3);
                                        case "dddd":
                                            return l[t.$W];
                                        case "H":
                                            return String(s);
                                        case "HH":
                                            return S.s(s, 2, "0");
                                        case "h":
                                            return d(1);
                                        case "hh":
                                            return d(2);
                                        case "a":
                                            return m(s, o, !0);
                                        case "A":
                                            return m(s, o, !1);
                                        case "m":
                                            return String(o);
                                        case "mm":
                                            return S.s(o, 2, "0");
                                        case "s":
                                            return String(t.$s);
                                        case "ss":
                                            return S.s(t.$s, 2, "0");
                                        case "SSS":
                                            return S.s(t.$ms, 3, "0");
                                        case "Z":
                                            return i;
                                    }
                                    return null;
                                }(e) || i.replace(":", "");
                            });
                        }, b.utcOffset = function() {
                            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
                        }, b.diff = function(r, h, f) {
                            var d, p = this, m = S.p(h), b = k(r), g = (b.utcOffset() - this.utcOffset()) * e, y = this - b, v = function() {
                                return S.m(p, b);
                            };
                            switch(m){
                                case u:
                                    d = v() / 12;
                                    break;
                                case l:
                                    d = v();
                                    break;
                                case c:
                                    d = v() / 3;
                                    break;
                                case a:
                                    d = (y - g) / 6048e5;
                                    break;
                                case o:
                                    d = (y - g) / 864e5;
                                    break;
                                case s:
                                    d = y / t;
                                    break;
                                case i:
                                    d = y / e;
                                    break;
                                case n:
                                    d = y / 1e3;
                                    break;
                                default:
                                    d = y;
                            }
                            return f ? d : S.a(d);
                        }, b.daysInMonth = function() {
                            return this.endOf(l).$D;
                        }, b.$locale = function() {
                            return v[this.$L];
                        }, b.locale = function(e, t) {
                            if (!e) return this.$L;
                            var r = this.clone(), n = x(e, t, !0);
                            return n && (r.$L = n), r;
                        }, b.clone = function() {
                            return S.w(this.$d, this);
                        }, b.toDate = function() {
                            return new Date(this.valueOf());
                        }, b.toJSON = function() {
                            return this.isValid() ? this.toISOString() : null;
                        }, b.toISOString = function() {
                            return this.$d.toISOString();
                        }, b.toString = function() {
                            return this.$d.toUTCString();
                        }, m;
                    }(), C = M.prototype;
                    return k.prototype = C, [
                        [
                            "$ms",
                            r
                        ],
                        [
                            "$s",
                            n
                        ],
                        [
                            "$m",
                            i
                        ],
                        [
                            "$H",
                            s
                        ],
                        [
                            "$W",
                            o
                        ],
                        [
                            "$M",
                            l
                        ],
                        [
                            "$y",
                            u
                        ],
                        [
                            "$D",
                            h
                        ]
                    ].forEach(function(e) {
                        C[e[1]] = function(t) {
                            return this.$g(t, e[0], e[1]);
                        };
                    }), k.extend = function(e, t) {
                        return e.$i || (e(t, M, k), e.$i = !0), k;
                    }, k.locale = x, k.isDayjs = _, k.unix = function(e) {
                        return k(1e3 * e);
                    }, k.en = v[y], k.Ls = v, k.p = {}, k;
                });
            },
            {}
        ],
        392: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_customParseFormat = n();
                }(void 0, function() {
                    var e = {
                        LTS: "h:mm:ss A",
                        LT: "h:mm A",
                        L: "MM/DD/YYYY",
                        LL: "MMMM D, YYYY",
                        LLL: "MMMM D, YYYY h:mm A",
                        LLLL: "dddd, MMMM D, YYYY h:mm A"
                    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, r = /\d\d/, n = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, s = {}, o = function(e) {
                        return (e = +e) + (e > 68 ? 1900 : 2e3);
                    }, a = function(e) {
                        return function(t) {
                            this[e] = +t;
                        };
                    }, l = [
                        /[+-]\d\d:?(\d\d)?|Z/,
                        function(e) {
                            (this.zone || (this.zone = {})).offset = function(e) {
                                if (!e) return 0;
                                if ("Z" === e) return 0;
                                var t = e.match(/([+-]|\d\d)/g), r = 60 * t[1] + (+t[2] || 0);
                                return 0 === r ? 0 : "+" === t[0] ? -r : r;
                            }(e);
                        }
                    ], c = function(e) {
                        var t = s[e];
                        return t && (t.indexOf ? t : t.s.concat(t.f));
                    }, u = function(e, t) {
                        var r, n = s.meridiem;
                        if (n) {
                            for(var i = 1; i <= 24; i += 1)if (e.indexOf(n(i, 0, t)) > -1) {
                                r = i > 12;
                                break;
                            }
                        } else r = e === (t ? "pm" : "PM");
                        return r;
                    }, h = {
                        A: [
                            i,
                            function(e) {
                                this.afternoon = u(e, !1);
                            }
                        ],
                        a: [
                            i,
                            function(e) {
                                this.afternoon = u(e, !0);
                            }
                        ],
                        S: [
                            /\d/,
                            function(e) {
                                this.milliseconds = 100 * +e;
                            }
                        ],
                        SS: [
                            r,
                            function(e) {
                                this.milliseconds = 10 * +e;
                            }
                        ],
                        SSS: [
                            /\d{3}/,
                            function(e) {
                                this.milliseconds = +e;
                            }
                        ],
                        s: [
                            n,
                            a("seconds")
                        ],
                        ss: [
                            n,
                            a("seconds")
                        ],
                        m: [
                            n,
                            a("minutes")
                        ],
                        mm: [
                            n,
                            a("minutes")
                        ],
                        H: [
                            n,
                            a("hours")
                        ],
                        h: [
                            n,
                            a("hours")
                        ],
                        HH: [
                            n,
                            a("hours")
                        ],
                        hh: [
                            n,
                            a("hours")
                        ],
                        D: [
                            n,
                            a("day")
                        ],
                        DD: [
                            r,
                            a("day")
                        ],
                        Do: [
                            i,
                            function(e) {
                                var t = s.ordinal, r = e.match(/\d+/);
                                if (this.day = r[0], t) for(var n = 1; n <= 31; n += 1)t(n).replace(/\[|\]/g, "") === e && (this.day = n);
                            }
                        ],
                        M: [
                            n,
                            a("month")
                        ],
                        MM: [
                            r,
                            a("month")
                        ],
                        MMM: [
                            i,
                            function(e) {
                                var t = c("months"), r = (c("monthsShort") || t.map(function(e) {
                                    return e.slice(0, 3);
                                })).indexOf(e) + 1;
                                if (r < 1) throw new Error;
                                this.month = r % 12 || r;
                            }
                        ],
                        MMMM: [
                            i,
                            function(e) {
                                var t = c("months").indexOf(e) + 1;
                                if (t < 1) throw new Error;
                                this.month = t % 12 || t;
                            }
                        ],
                        Y: [
                            /[+-]?\d+/,
                            a("year")
                        ],
                        YY: [
                            r,
                            function(e) {
                                this.year = o(e);
                            }
                        ],
                        YYYY: [
                            /\d{4}/,
                            a("year")
                        ],
                        Z: l,
                        ZZ: l
                    };
                    function f(r) {
                        var n, i;
                        n = r, i = s && s.formats;
                        for(var o = (r = n.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, r, n) {
                            var s = n && n.toUpperCase();
                            return r || i[n] || e[n] || i[s].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, r) {
                                return t || r.slice(1);
                            });
                        })).match(t), a = o.length, l = 0; l < a; l += 1){
                            var c = o[l], u = h[c], f = u && u[0], d = u && u[1];
                            o[l] = d ? {
                                regex: f,
                                parser: d
                            } : c.replace(/^\[|\]$/g, "");
                        }
                        return function(e) {
                            for(var t = {}, r = 0, n = 0; r < a; r += 1){
                                var i = o[r];
                                if ("string" == typeof i) n += i.length;
                                else {
                                    var s = i.regex, l = i.parser, c = e.slice(n), u = s.exec(c)[0];
                                    l.call(t, u), e = e.replace(u, "");
                                }
                            }
                            return function(e) {
                                var t = e.afternoon;
                                if (void 0 !== t) {
                                    var r = e.hours;
                                    t ? r < 12 && (e.hours += 12) : 12 === r && (e.hours = 0), delete e.afternoon;
                                }
                            }(t), t;
                        };
                    }
                    return function(e, t, r) {
                        r.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
                        var n = t.prototype, i = n.parse;
                        n.parse = function(e) {
                            var t = e.date, n = e.utc, o = e.args;
                            this.$u = n;
                            var a = o[1];
                            if ("string" == typeof a) {
                                var l = !0 === o[2], c = !0 === o[3], u = l || c, h = o[2];
                                c && (h = o[2]), s = this.$locale(), !l && h && (s = r.Ls[h]), this.$d = function(e, t, r) {
                                    try {
                                        if ([
                                            "x",
                                            "X"
                                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                                        var n = f(t)(e), i = n.year, s = n.month, o = n.day, a = n.hours, l = n.minutes, c = n.seconds, u = n.milliseconds, h = n.zone, d = new Date, p = o || (i || s ? 1 : d.getDate()), m = i || d.getFullYear(), b = 0;
                                        i && !s || (b = s > 0 ? s - 1 : d.getMonth());
                                        var g = a || 0, y = l || 0, v = c || 0, w = u || 0;
                                        return h ? new Date(Date.UTC(m, b, p, g, y, v, w + 60 * h.offset * 1e3)) : r ? new Date(Date.UTC(m, b, p, g, y, v, w)) : new Date(m, b, p, g, y, v, w);
                                    } catch (e) {
                                        return new Date("");
                                    }
                                }(t, a, n), this.init(), h && !0 !== h && (this.$L = this.locale(h).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
                            } else if (a instanceof Array) for(var d = a.length, p = 1; p <= d; p += 1){
                                o[1] = a[p - 1];
                                var m = r.apply(this, o);
                                if (m.isValid()) {
                                    this.$d = m.$d, this.$L = m.$L, this.init();
                                    break;
                                }
                                p === d && (this.$d = new Date(""));
                            }
                            else i.call(this, e);
                        };
                    };
                });
            },
            {}
        ],
        393: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_utc = n();
                }(void 0, function() {
                    var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
                    return function(n, i, s) {
                        var o = i.prototype;
                        s.utc = function(e) {
                            var t = {
                                date: e,
                                utc: !0,
                                args: arguments
                            };
                            return new i(t);
                        }, o.utc = function(t) {
                            var r = s(this.toDate(), {
                                locale: this.$L,
                                utc: !0
                            });
                            return t ? r.add(this.utcOffset(), e) : r;
                        }, o.local = function() {
                            return s(this.toDate(), {
                                locale: this.$L,
                                utc: !1
                            });
                        };
                        var a = o.parse;
                        o.parse = function(e) {
                            e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), a.call(this, e);
                        };
                        var l = o.init;
                        o.init = function() {
                            if (this.$u) {
                                var e = this.$d;
                                this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
                            } else l.call(this);
                        };
                        var c = o.utcOffset;
                        o.utcOffset = function(n, i) {
                            var s = this.$utils().u;
                            if (s(n)) return this.$u ? 0 : s(this.$offset) ? c.call(this) : this.$offset;
                            if ("string" == typeof n && null === (n = function(e) {
                                void 0 === e && (e = "");
                                var n = e.match(t);
                                if (!n) return null;
                                var i = ("" + n[0]).match(r) || [
                                    "-",
                                    0,
                                    0
                                ], s = i[0], o = 60 * +i[1] + +i[2];
                                return 0 === o ? 0 : "+" === s ? o : -o;
                            }(n))) return this;
                            var o = Math.abs(n) <= 16 ? 60 * n : n, a = this;
                            if (i) return a.$offset = o, a.$u = 0 === n, a;
                            if (0 !== n) {
                                var l = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                                (a = this.local().add(o + l, e)).$offset = o, a.$x.$localOffset = l;
                            } else a = this.utc();
                            return a;
                        };
                        var u = o.format;
                        o.format = function(e) {
                            var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
                            return u.call(this, t);
                        }, o.valueOf = function() {
                            var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
                            return this.$d.valueOf() - 6e4 * e;
                        }, o.isUTC = function() {
                            return !!this.$u;
                        }, o.toISOString = function() {
                            return this.toDate().toISOString();
                        }, o.toString = function() {
                            return this.toDate().toUTCString();
                        };
                        var h = o.toDate;
                        o.toDate = function(e) {
                            return "s" === e && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : h.call(this);
                        };
                        var f = o.diff;
                        o.diff = function(e, t, r) {
                            if (e && this.$u === e.$u) return f.call(this, e, t, r);
                            var n = this.local(), i = s(e).local();
                            return f.call(n, i, t, r);
                        };
                    };
                });
            },
            {}
        ],
        394: [
            function(e, t, r) {
                "use strict";
                r.utils = e("./des/utils"), r.Cipher = e("./des/cipher"), r.DES = e("./des/des"), r.CBC = e("./des/cbc"), r.EDE = e("./des/ede");
            },
            {
                "./des/cbc": 395,
                "./des/cipher": 396,
                "./des/des": 397,
                "./des/ede": 398,
                "./des/utils": 399
            }
        ],
        395: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = {};
                function o(e) {
                    n.equal(e.length, 8, "Invalid IV length"), this.iv = new Array(8);
                    for(var t = 0; t < this.iv.length; t++)this.iv[t] = e[t];
                }
                r.instantiate = function(e) {
                    function t(t) {
                        e.call(this, t), this._cbcInit();
                    }
                    i(t, e);
                    for(var r = Object.keys(s), n = 0; n < r.length; n++){
                        var o = r[n];
                        t.prototype[o] = s[o];
                    }
                    return t.create = function(e) {
                        return new t(e);
                    }, t;
                }, s._cbcInit = function() {
                    var e = new o(this.options.iv);
                    this._cbcState = e;
                }, s._update = function(e, t, r, n) {
                    var i = this._cbcState, s = this.constructor.super_.prototype, o = i.iv;
                    if ("encrypt" === this.type) {
                        for(var a = 0; a < this.blockSize; a++)o[a] ^= e[t + a];
                        s._update.call(this, o, 0, r, n);
                        for(a = 0; a < this.blockSize; a++)o[a] = r[n + a];
                    } else {
                        s._update.call(this, e, t, r, n);
                        for(a = 0; a < this.blockSize; a++)r[n + a] ^= o[a];
                        for(a = 0; a < this.blockSize; a++)o[a] = e[t + a];
                    }
                };
            },
            {
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        396: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert");
                function i(e) {
                    this.options = e, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = !1 !== e.padding;
                }
                t.exports = i, i.prototype._init = function() {}, i.prototype.update = function(e) {
                    return 0 === e.length ? [] : "decrypt" === this.type ? this._updateDecrypt(e) : this._updateEncrypt(e);
                }, i.prototype._buffer = function(e, t) {
                    for(var r = Math.min(this.buffer.length - this.bufferOff, e.length - t), n = 0; n < r; n++)this.buffer[this.bufferOff + n] = e[t + n];
                    return this.bufferOff += r, r;
                }, i.prototype._flushBuffer = function(e, t) {
                    return this._update(this.buffer, 0, e, t), this.bufferOff = 0, this.blockSize;
                }, i.prototype._updateEncrypt = function(e) {
                    var t = 0, r = 0, n = (this.bufferOff + e.length) / this.blockSize | 0, i = new Array(n * this.blockSize);
                    0 !== this.bufferOff && (t += this._buffer(e, t), this.bufferOff === this.buffer.length && (r += this._flushBuffer(i, r)));
                    for(var s = e.length - (e.length - t) % this.blockSize; t < s; t += this.blockSize)this._update(e, t, i, r), r += this.blockSize;
                    for(; t < e.length; t++, this.bufferOff++)this.buffer[this.bufferOff] = e[t];
                    return i;
                }, i.prototype._updateDecrypt = function(e) {
                    for(var t = 0, r = 0, n = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1, i = new Array(n * this.blockSize); n > 0; n--)t += this._buffer(e, t), r += this._flushBuffer(i, r);
                    return t += this._buffer(e, t), i;
                }, i.prototype.final = function(e) {
                    var t, r;
                    return e && (t = this.update(e)), r = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), t ? t.concat(r) : r;
                }, i.prototype._pad = function(e, t) {
                    if (0 === t) return !1;
                    for(; t < e.length;)e[t++] = 0;
                    return !0;
                }, i.prototype._finalEncrypt = function() {
                    if (!this._pad(this.buffer, this.bufferOff)) return [];
                    var e = new Array(this.blockSize);
                    return this._update(this.buffer, 0, e, 0), e;
                }, i.prototype._unpad = function(e) {
                    return e;
                }, i.prototype._finalDecrypt = function() {
                    n.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
                    var e = new Array(this.blockSize);
                    return this._flushBuffer(e, 0), this._unpad(e);
                };
            },
            {
                "minimalistic-assert": 453
            }
        ],
        397: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = e("./utils"), o = e("./cipher");
                function a() {
                    this.tmp = new Array(2), this.keys = null;
                }
                function l(e) {
                    o.call(this, e);
                    var t = new a;
                    this._desState = t, this.deriveKeys(t, e.key);
                }
                i(l, o), t.exports = l, l.create = function(e) {
                    return new l(e);
                };
                var c = [
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1
                ];
                l.prototype.deriveKeys = function(e, t) {
                    e.keys = new Array(32), n.equal(t.length, this.blockSize, "Invalid key length");
                    var r = s.readUInt32BE(t, 0), i = s.readUInt32BE(t, 4);
                    s.pc1(r, i, e.tmp, 0), r = e.tmp[0], i = e.tmp[1];
                    for(var o = 0; o < e.keys.length; o += 2){
                        var a = c[o >>> 1];
                        r = s.r28shl(r, a), i = s.r28shl(i, a), s.pc2(r, i, e.keys, o);
                    }
                }, l.prototype._update = function(e, t, r, n) {
                    var i = this._desState, o = s.readUInt32BE(e, t), a = s.readUInt32BE(e, t + 4);
                    s.ip(o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], "encrypt" === this.type ? this._encrypt(i, o, a, i.tmp, 0) : this._decrypt(i, o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], s.writeUInt32BE(r, o, n), s.writeUInt32BE(r, a, n + 4);
                }, l.prototype._pad = function(e, t) {
                    if (!1 === this.padding) return !1;
                    for(var r = e.length - t, n = t; n < e.length; n++)e[n] = r;
                    return !0;
                }, l.prototype._unpad = function(e) {
                    if (!1 === this.padding) return e;
                    for(var t = e[e.length - 1], r = e.length - t; r < e.length; r++)n.equal(e[r], t);
                    return e.slice(0, e.length - t);
                }, l.prototype._encrypt = function(e, t, r, n, i) {
                    for(var o = t, a = r, l = 0; l < e.keys.length; l += 2){
                        var c = e.keys[l], u = e.keys[l + 1];
                        s.expand(a, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
                        var h = s.substitute(c, u), f = a;
                        a = (o ^ s.permute(h)) >>> 0, o = f;
                    }
                    s.rip(a, o, n, i);
                }, l.prototype._decrypt = function(e, t, r, n, i) {
                    for(var o = r, a = t, l = e.keys.length - 2; l >= 0; l -= 2){
                        var c = e.keys[l], u = e.keys[l + 1];
                        s.expand(o, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
                        var h = s.substitute(c, u), f = o;
                        o = (a ^ s.permute(h)) >>> 0, a = f;
                    }
                    s.rip(o, a, n, i);
                };
            },
            {
                "./cipher": 396,
                "./utils": 399,
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        398: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = e("./cipher"), o = e("./des");
                function a(e, t) {
                    n.equal(t.length, 24, "Invalid key length");
                    var r = t.slice(0, 8), i = t.slice(8, 16), s = t.slice(16, 24);
                    this.ciphers = "encrypt" === e ? [
                        o.create({
                            type: "encrypt",
                            key: r
                        }),
                        o.create({
                            type: "decrypt",
                            key: i
                        }),
                        o.create({
                            type: "encrypt",
                            key: s
                        })
                    ] : [
                        o.create({
                            type: "decrypt",
                            key: s
                        }),
                        o.create({
                            type: "encrypt",
                            key: i
                        }),
                        o.create({
                            type: "decrypt",
                            key: r
                        })
                    ];
                }
                function l(e) {
                    s.call(this, e);
                    var t = new a(this.type, this.options.key);
                    this._edeState = t;
                }
                i(l, s), t.exports = l, l.create = function(e) {
                    return new l(e);
                }, l.prototype._update = function(e, t, r, n) {
                    var i = this._edeState;
                    i.ciphers[0]._update(e, t, r, n), i.ciphers[1]._update(r, n, r, n), i.ciphers[2]._update(r, n, r, n);
                }, l.prototype._pad = o.prototype._pad, l.prototype._unpad = o.prototype._unpad;
            },
            {
                "./cipher": 396,
                "./des": 397,
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        399: [
            function(e, t, r) {
                "use strict";
                r.readUInt32BE = function(e, t) {
                    return (e[0 + t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t]) >>> 0;
                }, r.writeUInt32BE = function(e, t, r) {
                    e[0 + r] = t >>> 24, e[1 + r] = t >>> 16 & 255, e[2 + r] = t >>> 8 & 255, e[3 + r] = 255 & t;
                }, r.ip = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 6; o >= 0; o -= 2){
                        for(var a = 0; a <= 24; a += 8)i <<= 1, i |= t >>> a + o & 1;
                        for(a = 0; a <= 24; a += 8)i <<= 1, i |= e >>> a + o & 1;
                    }
                    for(o = 6; o >= 0; o -= 2){
                        for(a = 1; a <= 25; a += 8)s <<= 1, s |= t >>> a + o & 1;
                        for(a = 1; a <= 25; a += 8)s <<= 1, s |= e >>> a + o & 1;
                    }
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.rip = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 0; o < 4; o++)for(var a = 24; a >= 0; a -= 8)i <<= 1, i |= t >>> a + o & 1, i <<= 1, i |= e >>> a + o & 1;
                    for(o = 4; o < 8; o++)for(a = 24; a >= 0; a -= 8)s <<= 1, s |= t >>> a + o & 1, s <<= 1, s |= e >>> a + o & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.pc1 = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 7; o >= 5; o--){
                        for(var a = 0; a <= 24; a += 8)i <<= 1, i |= t >> a + o & 1;
                        for(a = 0; a <= 24; a += 8)i <<= 1, i |= e >> a + o & 1;
                    }
                    for(a = 0; a <= 24; a += 8)i <<= 1, i |= t >> a + o & 1;
                    for(o = 1; o <= 3; o++){
                        for(a = 0; a <= 24; a += 8)s <<= 1, s |= t >> a + o & 1;
                        for(a = 0; a <= 24; a += 8)s <<= 1, s |= e >> a + o & 1;
                    }
                    for(a = 0; a <= 24; a += 8)s <<= 1, s |= e >> a + o & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.r28shl = function(e, t) {
                    return e << t & 268435455 | e >>> 28 - t;
                };
                var n = [
                    14,
                    11,
                    17,
                    4,
                    27,
                    23,
                    25,
                    0,
                    13,
                    22,
                    7,
                    18,
                    5,
                    9,
                    16,
                    24,
                    2,
                    20,
                    12,
                    21,
                    1,
                    8,
                    15,
                    26,
                    15,
                    4,
                    25,
                    19,
                    9,
                    1,
                    26,
                    16,
                    5,
                    11,
                    23,
                    8,
                    12,
                    7,
                    17,
                    0,
                    22,
                    3,
                    10,
                    14,
                    6,
                    20,
                    27,
                    24
                ];
                r.pc2 = function(e, t, r, i) {
                    for(var s = 0, o = 0, a = n.length >>> 1, l = 0; l < a; l++)s <<= 1, s |= e >>> n[l] & 1;
                    for(l = a; l < n.length; l++)o <<= 1, o |= t >>> n[l] & 1;
                    r[i + 0] = s >>> 0, r[i + 1] = o >>> 0;
                }, r.expand = function(e, t, r) {
                    var n = 0, i = 0;
                    n = (1 & e) << 5 | e >>> 27;
                    for(var s = 23; s >= 15; s -= 4)n <<= 6, n |= e >>> s & 63;
                    for(s = 11; s >= 3; s -= 4)i |= e >>> s & 63, i <<= 6;
                    i |= (31 & e) << 1 | e >>> 31, t[r + 0] = n >>> 0, t[r + 1] = i >>> 0;
                };
                var i = [
                    14,
                    0,
                    4,
                    15,
                    13,
                    7,
                    1,
                    4,
                    2,
                    14,
                    15,
                    2,
                    11,
                    13,
                    8,
                    1,
                    3,
                    10,
                    10,
                    6,
                    6,
                    12,
                    12,
                    11,
                    5,
                    9,
                    9,
                    5,
                    0,
                    3,
                    7,
                    8,
                    4,
                    15,
                    1,
                    12,
                    14,
                    8,
                    8,
                    2,
                    13,
                    4,
                    6,
                    9,
                    2,
                    1,
                    11,
                    7,
                    15,
                    5,
                    12,
                    11,
                    9,
                    3,
                    7,
                    14,
                    3,
                    10,
                    10,
                    0,
                    5,
                    6,
                    0,
                    13,
                    15,
                    3,
                    1,
                    13,
                    8,
                    4,
                    14,
                    7,
                    6,
                    15,
                    11,
                    2,
                    3,
                    8,
                    4,
                    14,
                    9,
                    12,
                    7,
                    0,
                    2,
                    1,
                    13,
                    10,
                    12,
                    6,
                    0,
                    9,
                    5,
                    11,
                    10,
                    5,
                    0,
                    13,
                    14,
                    8,
                    7,
                    10,
                    11,
                    1,
                    10,
                    3,
                    4,
                    15,
                    13,
                    4,
                    1,
                    2,
                    5,
                    11,
                    8,
                    6,
                    12,
                    7,
                    6,
                    12,
                    9,
                    0,
                    3,
                    5,
                    2,
                    14,
                    15,
                    9,
                    10,
                    13,
                    0,
                    7,
                    9,
                    0,
                    14,
                    9,
                    6,
                    3,
                    3,
                    4,
                    15,
                    6,
                    5,
                    10,
                    1,
                    2,
                    13,
                    8,
                    12,
                    5,
                    7,
                    14,
                    11,
                    12,
                    4,
                    11,
                    2,
                    15,
                    8,
                    1,
                    13,
                    1,
                    6,
                    10,
                    4,
                    13,
                    9,
                    0,
                    8,
                    6,
                    15,
                    9,
                    3,
                    8,
                    0,
                    7,
                    11,
                    4,
                    1,
                    15,
                    2,
                    14,
                    12,
                    3,
                    5,
                    11,
                    10,
                    5,
                    14,
                    2,
                    7,
                    12,
                    7,
                    13,
                    13,
                    8,
                    14,
                    11,
                    3,
                    5,
                    0,
                    6,
                    6,
                    15,
                    9,
                    0,
                    10,
                    3,
                    1,
                    4,
                    2,
                    7,
                    8,
                    2,
                    5,
                    12,
                    11,
                    1,
                    12,
                    10,
                    4,
                    14,
                    15,
                    9,
                    10,
                    3,
                    6,
                    15,
                    9,
                    0,
                    0,
                    6,
                    12,
                    10,
                    11,
                    1,
                    7,
                    13,
                    13,
                    8,
                    15,
                    9,
                    1,
                    4,
                    3,
                    5,
                    14,
                    11,
                    5,
                    12,
                    2,
                    7,
                    8,
                    2,
                    4,
                    14,
                    2,
                    14,
                    12,
                    11,
                    4,
                    2,
                    1,
                    12,
                    7,
                    4,
                    10,
                    7,
                    11,
                    13,
                    6,
                    1,
                    8,
                    5,
                    5,
                    0,
                    3,
                    15,
                    15,
                    10,
                    13,
                    3,
                    0,
                    9,
                    14,
                    8,
                    9,
                    6,
                    4,
                    11,
                    2,
                    8,
                    1,
                    12,
                    11,
                    7,
                    10,
                    1,
                    13,
                    14,
                    7,
                    2,
                    8,
                    13,
                    15,
                    6,
                    9,
                    15,
                    12,
                    0,
                    5,
                    9,
                    6,
                    10,
                    3,
                    4,
                    0,
                    5,
                    14,
                    3,
                    12,
                    10,
                    1,
                    15,
                    10,
                    4,
                    15,
                    2,
                    9,
                    7,
                    2,
                    12,
                    6,
                    9,
                    8,
                    5,
                    0,
                    6,
                    13,
                    1,
                    3,
                    13,
                    4,
                    14,
                    14,
                    0,
                    7,
                    11,
                    5,
                    3,
                    11,
                    8,
                    9,
                    4,
                    14,
                    3,
                    15,
                    2,
                    5,
                    12,
                    2,
                    9,
                    8,
                    5,
                    12,
                    15,
                    3,
                    10,
                    7,
                    11,
                    0,
                    14,
                    4,
                    1,
                    10,
                    7,
                    1,
                    6,
                    13,
                    0,
                    11,
                    8,
                    6,
                    13,
                    4,
                    13,
                    11,
                    0,
                    2,
                    11,
                    14,
                    7,
                    15,
                    4,
                    0,
                    9,
                    8,
                    1,
                    13,
                    10,
                    3,
                    14,
                    12,
                    3,
                    9,
                    5,
                    7,
                    12,
                    5,
                    2,
                    10,
                    15,
                    6,
                    8,
                    1,
                    6,
                    1,
                    6,
                    4,
                    11,
                    11,
                    13,
                    13,
                    8,
                    12,
                    1,
                    3,
                    4,
                    7,
                    10,
                    14,
                    7,
                    10,
                    9,
                    15,
                    5,
                    6,
                    0,
                    8,
                    15,
                    0,
                    14,
                    5,
                    2,
                    9,
                    3,
                    2,
                    12,
                    13,
                    1,
                    2,
                    15,
                    8,
                    13,
                    4,
                    8,
                    6,
                    10,
                    15,
                    3,
                    11,
                    7,
                    1,
                    4,
                    10,
                    12,
                    9,
                    5,
                    3,
                    6,
                    14,
                    11,
                    5,
                    0,
                    0,
                    14,
                    12,
                    9,
                    7,
                    2,
                    7,
                    2,
                    11,
                    1,
                    4,
                    14,
                    1,
                    7,
                    9,
                    4,
                    12,
                    10,
                    14,
                    8,
                    2,
                    13,
                    0,
                    15,
                    6,
                    12,
                    10,
                    9,
                    13,
                    0,
                    15,
                    3,
                    3,
                    5,
                    5,
                    6,
                    8,
                    11
                ];
                r.substitute = function(e, t) {
                    for(var r = 0, n = 0; n < 4; n++)r <<= 4, r |= i[64 * n + (e >>> 18 - 6 * n & 63)];
                    for(n = 0; n < 4; n++)r <<= 4, r |= i[256 + 64 * n + (t >>> 18 - 6 * n & 63)];
                    return r >>> 0;
                };
                var s = [
                    16,
                    25,
                    12,
                    11,
                    3,
                    20,
                    4,
                    15,
                    31,
                    17,
                    9,
                    6,
                    27,
                    14,
                    1,
                    22,
                    30,
                    24,
                    8,
                    18,
                    0,
                    5,
                    29,
                    23,
                    13,
                    19,
                    2,
                    26,
                    10,
                    21,
                    28,
                    7
                ];
                r.permute = function(e) {
                    for(var t = 0, r = 0; r < s.length; r++)t <<= 1, t |= e >>> s[r] & 1;
                    return t >>> 0;
                }, r.padSplit = function(e, t, r) {
                    for(var n = e.toString(2); n.length < t;)n = "0" + n;
                    for(var i = [], s = 0; s < t; s += r)i.push(n.slice(s, s + r));
                    return i.join(" ");
                };
            },
            {}
        ],
        400: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = e("./lib/generatePrime"), i = e("./lib/primes.json"), s = e("./lib/dh");
                        var o = {
                            binary: !0,
                            hex: !0,
                            base64: !0
                        };
                        r.DiffieHellmanGroup = r.createDiffieHellmanGroup = r.getDiffieHellman = function(e) {
                            var r = new t(i[e].prime, "hex"), n = new t(i[e].gen, "hex");
                            return new s(r, n);
                        }, r.createDiffieHellman = r.DiffieHellman = function e(r, i, a, l) {
                            return t.isBuffer(i) || void 0 === o[i] ? e(r, "binary", i, a) : (i = i || "binary", l = l || "binary", a = a || new t([
                                2
                            ]), t.isBuffer(a) || (a = new t(a, l)), "number" == typeof r ? new s(n(r, a), a, !0) : (t.isBuffer(r) || (r = new t(r, i)), new s(r, a, !0)));
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./lib/dh": 401,
                "./lib/generatePrime": 402,
                "./lib/primes.json": 403,
                buffer: 220
            }
        ],
        401: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("bn.js"), i = new (e("miller-rabin")), s = new n(24), o = new n(11), a = new n(10), l = new n(3), c = new n(7), u = e("./generatePrime"), h = e("randombytes");
                        function f(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this._pub = new n(e), this;
                        }
                        function d(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this._priv = new n(e), this;
                        }
                        t.exports = m;
                        var p = {};
                        function m(e, t, r) {
                            this.setGenerator(t), this.__prime = new n(e), this._prime = n.mont(this.__prime), this._primeLen = e.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, r ? (this.setPublicKey = f, this.setPrivateKey = d) : this._primeCode = 8;
                        }
                        function b(e, t) {
                            var n = new r(e.toArray());
                            return t ? n.toString(t) : n;
                        }
                        Object.defineProperty(m.prototype, "verifyError", {
                            enumerable: !0,
                            get: function() {
                                return "number" != typeof this._primeCode && (this._primeCode = function(e, t) {
                                    var r = t.toString("hex"), n = [
                                        r,
                                        e.toString(16)
                                    ].join("_");
                                    if (n in p) return p[n];
                                    var h, f = 0;
                                    if (e.isEven() || !u.simpleSieve || !u.fermatTest(e) || !i.test(e)) return f += 1, f += "02" === r || "05" === r ? 8 : 4, p[n] = f, f;
                                    switch(i.test(e.shrn(1)) || (f += 2), r){
                                        case "02":
                                            e.mod(s).cmp(o) && (f += 8);
                                            break;
                                        case "05":
                                            (h = e.mod(a)).cmp(l) && h.cmp(c) && (f += 8);
                                            break;
                                        default:
                                            f += 4;
                                    }
                                    return p[n] = f, f;
                                }(this.__prime, this.__gen)), this._primeCode;
                            }
                        }), m.prototype.generateKeys = function() {
                            return this._priv || (this._priv = new n(h(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
                        }, m.prototype.computeSecret = function(e) {
                            var t = (e = (e = new n(e)).toRed(this._prime)).redPow(this._priv).fromRed(), i = new r(t.toArray()), s = this.getPrime();
                            if (i.length < s.length) {
                                var o = new r(s.length - i.length);
                                o.fill(0), i = r.concat([
                                    o,
                                    i
                                ]);
                            }
                            return i;
                        }, m.prototype.getPublicKey = function(e) {
                            return b(this._pub, e);
                        }, m.prototype.getPrivateKey = function(e) {
                            return b(this._priv, e);
                        }, m.prototype.getPrime = function(e) {
                            return b(this.__prime, e);
                        }, m.prototype.getGenerator = function(e) {
                            return b(this._gen, e);
                        }, m.prototype.setGenerator = function(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this.__gen = e, this._gen = new n(e), this;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./generatePrime": 402,
                "bn.js": 404,
                buffer: 220,
                "miller-rabin": 451,
                randombytes: 475
            }
        ],
        402: [
            function(e, t, r) {
                "use strict";
                var n = e("randombytes");
                t.exports = y, y.simpleSieve = b, y.fermatTest = g;
                var i = e("bn.js"), s = new i(24), o = new (e("miller-rabin")), a = new i(1), l = new i(2), c = new i(5), u = (new i(16), new i(8), new i(10)), h = new i(3), f = (new i(7), new i(11)), d = new i(4), p = (new i(12), null);
                function m() {
                    if (null !== p) return p;
                    var e = [];
                    e[0] = 2;
                    for(var t = 1, r = 3; r < 1048576; r += 2){
                        for(var n = Math.ceil(Math.sqrt(r)), i = 0; i < t && e[i] <= n && r % e[i] != 0; i++);
                        t !== i && e[i] <= n || (e[t++] = r);
                    }
                    return p = e, e;
                }
                function b(e) {
                    for(var t = m(), r = 0; r < t.length; r++)if (0 === e.modn(t[r])) return 0 === e.cmpn(t[r]);
                    return !0;
                }
                function g(e) {
                    var t = i.mont(e);
                    return 0 === l.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1);
                }
                function y(e, t) {
                    if (e < 16) return new i(2 === t || 5 === t ? [
                        140,
                        123
                    ] : [
                        140,
                        39
                    ]);
                    var r, p;
                    for(t = new i(t);;){
                        for(r = new i(n(Math.ceil(e / 8))); r.bitLength() > e;)r.ishrn(1);
                        if (r.isEven() && r.iadd(a), r.testn(1) || r.iadd(l), t.cmp(l)) {
                            if (!t.cmp(c)) for(; r.mod(u).cmp(h);)r.iadd(d);
                        } else for(; r.mod(s).cmp(f);)r.iadd(d);
                        if (b(p = r.shrn(1)) && b(r) && g(p) && g(r) && o.test(p) && o.test(r)) return r;
                    }
                }
            },
            {
                "bn.js": 404,
                "miller-rabin": 451,
                randombytes: 475
            }
        ],
        403: [
            function(e, t, r) {
                t.exports = {
                    modp1: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
                    },
                    modp2: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
                    },
                    modp5: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
                    },
                    modp14: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
                    },
                    modp15: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
                    },
                    modp16: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
                    },
                    modp17: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
                    },
                    modp18: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"
                    }
                };
            },
            {}
        ],
        404: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        405: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.version = e("../package.json").version, n.utils = e("./elliptic/utils"), n.rand = e("brorand"), n.curve = e("./elliptic/curve"), n.curves = e("./elliptic/curves"), n.ec = e("./elliptic/ec"), n.eddsa = e("./elliptic/eddsa");
            },
            {
                "../package.json": 421,
                "./elliptic/curve": 408,
                "./elliptic/curves": 411,
                "./elliptic/ec": 412,
                "./elliptic/eddsa": 415,
                "./elliptic/utils": 419,
                brorand: 187
            }
        ],
        406: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.getNAF, o = i.getJSF, a = i.assert;
                function l(e, t) {
                    this.type = e, this.p = new n(t.p, 16), this.red = t.prime ? n.red(t.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = t.n && new n(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
                    var r = this.n && this.p.div(this.n);
                    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
                }
                function c(e, t) {
                    this.curve = e, this.type = t, this.precomputed = null;
                }
                t.exports = l, l.prototype.point = function() {
                    throw new Error("Not implemented");
                }, l.prototype.validate = function() {
                    throw new Error("Not implemented");
                }, l.prototype._fixedNafMul = function(e, t) {
                    a(e.precomputed);
                    var r = e._getDoubles(), n = s(t, 1, this._bitLength), i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);
                    i /= 3;
                    var o, l, c = [];
                    for(o = 0; o < n.length; o += r.step){
                        l = 0;
                        for(var u = o + r.step - 1; u >= o; u--)l = (l << 1) + n[u];
                        c.push(l);
                    }
                    for(var h = this.jpoint(null, null, null), f = this.jpoint(null, null, null), d = i; d > 0; d--){
                        for(o = 0; o < c.length; o++)(l = c[o]) === d ? f = f.mixedAdd(r.points[o]) : l === -d && (f = f.mixedAdd(r.points[o].neg()));
                        h = h.add(f);
                    }
                    return h.toP();
                }, l.prototype._wnafMul = function(e, t) {
                    var r = 4, n = e._getNAFPoints(r);
                    r = n.wnd;
                    for(var i = n.points, o = s(t, r, this._bitLength), l = this.jpoint(null, null, null), c = o.length - 1; c >= 0; c--){
                        for(var u = 0; c >= 0 && 0 === o[c]; c--)u++;
                        if (c >= 0 && u++, l = l.dblp(u), c < 0) break;
                        var h = o[c];
                        a(0 !== h), l = "affine" === e.type ? h > 0 ? l.mixedAdd(i[h - 1 >> 1]) : l.mixedAdd(i[-h - 1 >> 1].neg()) : h > 0 ? l.add(i[h - 1 >> 1]) : l.add(i[-h - 1 >> 1].neg());
                    }
                    return "affine" === e.type ? l.toP() : l;
                }, l.prototype._wnafMulAdd = function(e, t, r, n, i) {
                    var a, l, c, u = this._wnafT1, h = this._wnafT2, f = this._wnafT3, d = 0;
                    for(a = 0; a < n; a++){
                        var p = (c = t[a])._getNAFPoints(e);
                        u[a] = p.wnd, h[a] = p.points;
                    }
                    for(a = n - 1; a >= 1; a -= 2){
                        var m = a - 1, b = a;
                        if (1 === u[m] && 1 === u[b]) {
                            var g = [
                                t[m],
                                null,
                                null,
                                t[b]
                            ];
                            0 === t[m].y.cmp(t[b].y) ? (g[1] = t[m].add(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg())) : 0 === t[m].y.cmp(t[b].y.redNeg()) ? (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].add(t[b].neg())) : (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg()));
                            var y = [
                                -3,
                                -1,
                                -5,
                                -7,
                                0,
                                7,
                                5,
                                1,
                                3
                            ], v = o(r[m], r[b]);
                            for(d = Math.max(v[0].length, d), f[m] = new Array(d), f[b] = new Array(d), l = 0; l < d; l++){
                                var w = 0 | v[0][l], _ = 0 | v[1][l];
                                f[m][l] = y[3 * (w + 1) + (_ + 1)], f[b][l] = 0, h[m] = g;
                            }
                        } else f[m] = s(r[m], u[m], this._bitLength), f[b] = s(r[b], u[b], this._bitLength), d = Math.max(f[m].length, d), d = Math.max(f[b].length, d);
                    }
                    var x = this.jpoint(null, null, null), k = this._wnafT4;
                    for(a = d; a >= 0; a--){
                        for(var S = 0; a >= 0;){
                            var M = !0;
                            for(l = 0; l < n; l++)k[l] = 0 | f[l][a], 0 !== k[l] && (M = !1);
                            if (!M) break;
                            S++, a--;
                        }
                        if (a >= 0 && S++, x = x.dblp(S), a < 0) break;
                        for(l = 0; l < n; l++){
                            var C = k[l];
                            0 !== C && (C > 0 ? c = h[l][C - 1 >> 1] : C < 0 && (c = h[l][-C - 1 >> 1].neg()), x = "affine" === c.type ? x.mixedAdd(c) : x.add(c));
                        }
                    }
                    for(a = 0; a < n; a++)h[a] = null;
                    return i ? x : x.toP();
                }, l.BasePoint = c, c.prototype.eq = function() {
                    throw new Error("Not implemented");
                }, c.prototype.validate = function() {
                    return this.curve.validate(this);
                }, l.prototype.decodePoint = function(e, t) {
                    e = i.toArray(e, t);
                    var r = this.p.byteLength();
                    if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? a(e[e.length - 1] % 2 == 0) : 7 === e[0] && a(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
                    if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
                    throw new Error("Unknown point format");
                }, c.prototype.encodeCompressed = function(e) {
                    return this.encode(e, !0);
                }, c.prototype._encode = function(e) {
                    var t = this.curve.p.byteLength(), r = this.getX().toArray("be", t);
                    return e ? [
                        this.getY().isEven() ? 2 : 3
                    ].concat(r) : [
                        4
                    ].concat(r, this.getY().toArray("be", t));
                }, c.prototype.encode = function(e, t) {
                    return i.encode(this._encode(t), e);
                }, c.prototype.precompute = function(e) {
                    if (this.precomputed) return this;
                    var t = {
                        doubles: null,
                        naf: null,
                        beta: null
                    };
                    return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
                }, c.prototype._hasDoubles = function(e) {
                    if (!this.precomputed) return !1;
                    var t = this.precomputed.doubles;
                    return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
                }, c.prototype._getDoubles = function(e, t) {
                    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
                    for(var r = [
                        this
                    ], n = this, i = 0; i < t; i += e){
                        for(var s = 0; s < e; s++)n = n.dbl();
                        r.push(n);
                    }
                    return {
                        step: e,
                        points: r
                    };
                }, c.prototype._getNAFPoints = function(e) {
                    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
                    for(var t = [
                        this
                    ], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++)t[i] = t[i - 1].add(n);
                    return {
                        wnd: e,
                        points: t
                    };
                }, c.prototype._getBeta = function() {
                    return null;
                }, c.prototype.dblp = function(e) {
                    for(var t = this, r = 0; r < e; r++)t = t.dbl();
                    return t;
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        407: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("bn.js"), s = e("inherits"), o = e("./base"), a = n.assert;
                function l(e) {
                    this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, o.call(this, "edwards", e), this.a = new i(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new i(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new i(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), a(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
                }
                function c(e, t, r, n, s) {
                    o.BasePoint.call(this, e, "projective"), null === t && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = n ? new i(n, 16) : this.curve.one, this.t = s && new i(s, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
                }
                s(l, o), t.exports = l, l.prototype._mulA = function(e) {
                    return this.mOneA ? e.redNeg() : this.a.redMul(e);
                }, l.prototype._mulC = function(e) {
                    return this.oneC ? e : this.c.redMul(e);
                }, l.prototype.jpoint = function(e, t, r, n) {
                    return this.point(e, t, r, n);
                }, l.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = this.c2.redSub(this.a.redMul(r)), s = this.one.redSub(this.c2.redMul(this.d).redMul(r)), o = n.redMul(s.redInvm()), a = o.redSqrt();
                    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
                    var l = a.fromRed().isOdd();
                    return (t && !l || !t && l) && (a = a.redNeg()), this.point(e, a);
                }, l.prototype.pointFromY = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = r.redSub(this.c2), s = r.redMul(this.d).redMul(this.c2).redSub(this.a), o = n.redMul(s.redInvm());
                    if (0 === o.cmp(this.zero)) {
                        if (t) throw new Error("invalid point");
                        return this.point(this.zero, e);
                    }
                    var a = o.redSqrt();
                    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
                    return a.fromRed().isOdd() !== t && (a = a.redNeg()), this.point(a, e);
                }, l.prototype.validate = function(e) {
                    if (e.isInfinity()) return !0;
                    e.normalize();
                    var t = e.x.redSqr(), r = e.y.redSqr(), n = t.redMul(this.a).redAdd(r), i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
                    return 0 === n.cmp(i);
                }, s(c, o.BasePoint), l.prototype.pointFromJSON = function(e) {
                    return c.fromJSON(this, e);
                }, l.prototype.point = function(e, t, r, n) {
                    return new c(this, e, t, r, n);
                }, c.fromJSON = function(e, t) {
                    return new c(e, t[0], t[1], t[2]);
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
                }, c.prototype._extDbl = function() {
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr();
                    r = r.redIAdd(r);
                    var n = this.curve._mulA(e), i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t), s = n.redAdd(t), o = s.redSub(r), a = n.redSub(t), l = i.redMul(o), c = s.redMul(a), u = i.redMul(a), h = o.redMul(s);
                    return this.curve.point(l, c, h, u);
                }, c.prototype._projDbl = function() {
                    var e, t, r, n, i, s, o = this.x.redAdd(this.y).redSqr(), a = this.x.redSqr(), l = this.y.redSqr();
                    if (this.curve.twisted) {
                        var c = (n = this.curve._mulA(a)).redAdd(l);
                        this.zOne ? (e = o.redSub(a).redSub(l).redMul(c.redSub(this.curve.two)), t = c.redMul(n.redSub(l)), r = c.redSqr().redSub(c).redSub(c)) : (i = this.z.redSqr(), s = c.redSub(i).redISub(i), e = o.redSub(a).redISub(l).redMul(s), t = c.redMul(n.redSub(l)), r = c.redMul(s));
                    } else n = a.redAdd(l), i = this.curve._mulC(this.z).redSqr(), s = n.redSub(i).redSub(i), e = this.curve._mulC(o.redISub(n)).redMul(s), t = this.curve._mulC(n).redMul(a.redISub(l)), r = n.redMul(s);
                    return this.curve.point(e, t, r);
                }, c.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
                }, c.prototype._extAdd = function(e) {
                    var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)), r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)), n = this.t.redMul(this.curve.dd).redMul(e.t), i = this.z.redMul(e.z.redAdd(e.z)), s = r.redSub(t), o = i.redSub(n), a = i.redAdd(n), l = r.redAdd(t), c = s.redMul(o), u = a.redMul(l), h = s.redMul(l), f = o.redMul(a);
                    return this.curve.point(c, u, f, h);
                }, c.prototype._projAdd = function(e) {
                    var t, r, n = this.z.redMul(e.z), i = n.redSqr(), s = this.x.redMul(e.x), o = this.y.redMul(e.y), a = this.curve.d.redMul(s).redMul(o), l = i.redSub(a), c = i.redAdd(a), u = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(s).redISub(o), h = n.redMul(l).redMul(u);
                    return this.curve.twisted ? (t = n.redMul(c).redMul(o.redSub(this.curve._mulA(s))), r = l.redMul(c)) : (t = n.redMul(c).redMul(o.redSub(s)), r = this.curve._mulC(l).redMul(c)), this.curve.point(h, t, r);
                }, c.prototype.add = function(e) {
                    return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
                }, c.prototype.mul = function(e) {
                    return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !1);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !0);
                }, c.prototype.normalize = function() {
                    if (this.zOne) return this;
                    var e = this.z.redInvm();
                    return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
                }, c.prototype.neg = function() {
                    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
                }, c.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.normalize(), this.y.fromRed();
                }, c.prototype.eq = function(e) {
                    return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
                }, c.prototype.eqXToP = function(e) {
                    var t = e.toRed(this.curve.red).redMul(this.z);
                    if (0 === this.x.cmp(t)) return !0;
                    for(var r = e.clone(), n = this.curve.redN.redMul(this.z);;){
                        if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
                        if (t.redIAdd(n), 0 === this.x.cmp(t)) return !0;
                    }
                }, c.prototype.toP = c.prototype.normalize, c.prototype.mixedAdd = c.prototype.add;
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        408: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.base = e("./base"), n.short = e("./short"), n.mont = e("./mont"), n.edwards = e("./edwards");
            },
            {
                "./base": 406,
                "./edwards": 407,
                "./mont": 409,
                "./short": 410
            }
        ],
        409: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("inherits"), s = e("./base"), o = e("../utils");
                function a(e) {
                    s.call(this, "mont", e), this.a = new n(e.a, 16).toRed(this.red), this.b = new n(e.b, 16).toRed(this.red), this.i4 = new n(4).toRed(this.red).redInvm(), this.two = new n(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
                }
                function l(e, t, r) {
                    s.BasePoint.call(this, e, "projective"), null === t && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new n(t, 16), this.z = new n(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
                }
                i(a, s), t.exports = a, a.prototype.validate = function(e) {
                    var t = e.normalize().x, r = t.redSqr(), n = r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);
                    return 0 === n.redSqrt().redSqr().cmp(n);
                }, i(l, s.BasePoint), a.prototype.decodePoint = function(e, t) {
                    return this.point(o.toArray(e, t), 1);
                }, a.prototype.point = function(e, t) {
                    return new l(this, e, t);
                }, a.prototype.pointFromJSON = function(e) {
                    return l.fromJSON(this, e);
                }, l.prototype.precompute = function() {}, l.prototype._encode = function() {
                    return this.getX().toArray("be", this.curve.p.byteLength());
                }, l.fromJSON = function(e, t) {
                    return new l(e, t[0], t[1] || e.one);
                }, l.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, l.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                }, l.prototype.dbl = function() {
                    var e = this.x.redAdd(this.z).redSqr(), t = this.x.redSub(this.z).redSqr(), r = e.redSub(t), n = e.redMul(t), i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
                    return this.curve.point(n, i);
                }, l.prototype.add = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.diffAdd = function(e, t) {
                    var r = this.x.redAdd(this.z), n = this.x.redSub(this.z), i = e.x.redAdd(e.z), s = e.x.redSub(e.z).redMul(r), o = i.redMul(n), a = t.z.redMul(s.redAdd(o).redSqr()), l = t.x.redMul(s.redISub(o).redSqr());
                    return this.curve.point(a, l);
                }, l.prototype.mul = function(e) {
                    for(var t = e.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1))i.push(t.andln(1));
                    for(var s = i.length - 1; s >= 0; s--)0 === i[s] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
                    return n;
                }, l.prototype.mulAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.jumlAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.eq = function(e) {
                    return 0 === this.getX().cmp(e.getX());
                }, l.prototype.normalize = function() {
                    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
                }, l.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                };
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        410: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("bn.js"), s = e("inherits"), o = e("./base"), a = n.assert;
                function l(e) {
                    o.call(this, "short", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
                }
                function c(e, t, r, n) {
                    o.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
                }
                function u(e, t, r, n) {
                    o.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new i(0)) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = new i(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
                }
                s(l, o), t.exports = l, l.prototype._getEndomorphism = function(e) {
                    if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
                        var t, r;
                        if (e.beta) t = new i(e.beta, 16).toRed(this.red);
                        else {
                            var n = this._getEndoRoots(this.p);
                            t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
                        }
                        if (e.lambda) r = new i(e.lambda, 16);
                        else {
                            var s = this._getEndoRoots(this.n);
                            0 === this.g.mul(s[0]).x.cmp(this.g.x.redMul(t)) ? r = s[0] : (r = s[1], a(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
                        }
                        return {
                            beta: t,
                            lambda: r,
                            basis: e.basis ? e.basis.map(function(e) {
                                return {
                                    a: new i(e.a, 16),
                                    b: new i(e.b, 16)
                                };
                            }) : this._getEndoBasis(r)
                        };
                    }
                }, l.prototype._getEndoRoots = function(e) {
                    var t = e === this.p ? this.red : i.mont(e), r = new i(2).toRed(t).redInvm(), n = r.redNeg(), s = new i(3).toRed(t).redNeg().redSqrt().redMul(r);
                    return [
                        n.redAdd(s).fromRed(),
                        n.redSub(s).fromRed()
                    ];
                }, l.prototype._getEndoBasis = function(e) {
                    for(var t, r, n, s, o, a, l, c, u, h = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), f = e, d = this.n.clone(), p = new i(1), m = new i(0), b = new i(0), g = new i(1), y = 0; 0 !== f.cmpn(0);){
                        var v = d.div(f);
                        c = d.sub(v.mul(f)), u = b.sub(v.mul(p));
                        var w = g.sub(v.mul(m));
                        if (!n && c.cmp(h) < 0) t = l.neg(), r = p, n = c.neg(), s = u;
                        else if (n && 2 == ++y) break;
                        l = c, d = f, f = c, b = p, p = u, g = m, m = w;
                    }
                    o = c.neg(), a = u;
                    var _ = n.sqr().add(s.sqr());
                    return o.sqr().add(a.sqr()).cmp(_) >= 0 && (o = t, a = r), n.negative && (n = n.neg(), s = s.neg()), o.negative && (o = o.neg(), a = a.neg()), [
                        {
                            a: n,
                            b: s
                        },
                        {
                            a: o,
                            b: a
                        }
                    ];
                }, l.prototype._endoSplit = function(e) {
                    var t = this.endo.basis, r = t[0], n = t[1], i = n.b.mul(e).divRound(this.n), s = r.b.neg().mul(e).divRound(this.n), o = i.mul(r.a), a = s.mul(n.a), l = i.mul(r.b), c = s.mul(n.b);
                    return {
                        k1: e.sub(o).sub(a),
                        k2: l.add(c).neg()
                    };
                }, l.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b), n = r.redSqrt();
                    if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
                    var s = n.fromRed().isOdd();
                    return (t && !s || !t && s) && (n = n.redNeg()), this.point(e, n);
                }, l.prototype.validate = function(e) {
                    if (e.inf) return !0;
                    var t = e.x, r = e.y, n = this.a.redMul(t), i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
                    return 0 === r.redSqr().redISub(i).cmpn(0);
                }, l.prototype._endoWnafMulAdd = function(e, t, r) {
                    for(var n = this._endoWnafT1, i = this._endoWnafT2, s = 0; s < e.length; s++){
                        var o = this._endoSplit(t[s]), a = e[s], l = a._getBeta();
                        o.k1.negative && (o.k1.ineg(), a = a.neg(!0)), o.k2.negative && (o.k2.ineg(), l = l.neg(!0)), n[2 * s] = a, n[2 * s + 1] = l, i[2 * s] = o.k1, i[2 * s + 1] = o.k2;
                    }
                    for(var c = this._wnafMulAdd(1, n, i, 2 * s, r), u = 0; u < 2 * s; u++)n[u] = null, i[u] = null;
                    return c;
                }, s(c, o.BasePoint), l.prototype.point = function(e, t, r) {
                    return new c(this, e, t, r);
                }, l.prototype.pointFromJSON = function(e, t) {
                    return c.fromJSON(this, e, t);
                }, c.prototype._getBeta = function() {
                    if (this.curve.endo) {
                        var e = this.precomputed;
                        if (e && e.beta) return e.beta;
                        var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
                        if (e) {
                            var r = this.curve, n = function(e) {
                                return r.point(e.x.redMul(r.endo.beta), e.y);
                            };
                            e.beta = t, t.precomputed = {
                                beta: null,
                                naf: e.naf && {
                                    wnd: e.naf.wnd,
                                    points: e.naf.points.map(n)
                                },
                                doubles: e.doubles && {
                                    step: e.doubles.step,
                                    points: e.doubles.points.map(n)
                                }
                            };
                        }
                        return t;
                    }
                }, c.prototype.toJSON = function() {
                    return this.precomputed ? [
                        this.x,
                        this.y,
                        this.precomputed && {
                            doubles: this.precomputed.doubles && {
                                step: this.precomputed.doubles.step,
                                points: this.precomputed.doubles.points.slice(1)
                            },
                            naf: this.precomputed.naf && {
                                wnd: this.precomputed.naf.wnd,
                                points: this.precomputed.naf.points.slice(1)
                            }
                        }
                    ] : [
                        this.x,
                        this.y
                    ];
                }, c.fromJSON = function(e, t, r) {
                    "string" == typeof t && (t = JSON.parse(t));
                    var n = e.point(t[0], t[1], r);
                    if (!t[2]) return n;
                    function i(t) {
                        return e.point(t[0], t[1], r);
                    }
                    var s = t[2];
                    return n.precomputed = {
                        beta: null,
                        doubles: s.doubles && {
                            step: s.doubles.step,
                            points: [
                                n
                            ].concat(s.doubles.points.map(i))
                        },
                        naf: s.naf && {
                            wnd: s.naf.wnd,
                            points: [
                                n
                            ].concat(s.naf.points.map(i))
                        }
                    }, n;
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return this.inf;
                }, c.prototype.add = function(e) {
                    if (this.inf) return e;
                    if (e.inf) return this;
                    if (this.eq(e)) return this.dbl();
                    if (this.neg().eq(e)) return this.curve.point(null, null);
                    if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
                    var t = this.y.redSub(e.y);
                    0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
                    var r = t.redSqr().redISub(this.x).redISub(e.x), n = t.redMul(this.x.redSub(r)).redISub(this.y);
                    return this.curve.point(r, n);
                }, c.prototype.dbl = function() {
                    if (this.inf) return this;
                    var e = this.y.redAdd(this.y);
                    if (0 === e.cmpn(0)) return this.curve.point(null, null);
                    var t = this.curve.a, r = this.x.redSqr(), n = e.redInvm(), i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n), s = i.redSqr().redISub(this.x.redAdd(this.x)), o = i.redMul(this.x.redSub(s)).redISub(this.y);
                    return this.curve.point(s, o);
                }, c.prototype.getX = function() {
                    return this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.y.fromRed();
                }, c.prototype.mul = function(e) {
                    return e = new i(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([
                        this
                    ], [
                        e
                    ]) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
                }, c.prototype.eq = function(e) {
                    return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
                }, c.prototype.neg = function(e) {
                    if (this.inf) return this;
                    var t = this.curve.point(this.x, this.y.redNeg());
                    if (e && this.precomputed) {
                        var r = this.precomputed, n = function(e) {
                            return e.neg();
                        };
                        t.precomputed = {
                            naf: r.naf && {
                                wnd: r.naf.wnd,
                                points: r.naf.points.map(n)
                            },
                            doubles: r.doubles && {
                                step: r.doubles.step,
                                points: r.doubles.points.map(n)
                            }
                        };
                    }
                    return t;
                }, c.prototype.toJ = function() {
                    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
                }, s(u, o.BasePoint), l.prototype.jpoint = function(e, t, r) {
                    return new u(this, e, t, r);
                }, u.prototype.toP = function() {
                    if (this.isInfinity()) return this.curve.point(null, null);
                    var e = this.z.redInvm(), t = e.redSqr(), r = this.x.redMul(t), n = this.y.redMul(t).redMul(e);
                    return this.curve.point(r, n);
                }, u.prototype.neg = function() {
                    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
                }, u.prototype.add = function(e) {
                    if (this.isInfinity()) return e;
                    if (e.isInfinity()) return this;
                    var t = e.z.redSqr(), r = this.z.redSqr(), n = this.x.redMul(t), i = e.x.redMul(r), s = this.y.redMul(t.redMul(e.z)), o = e.y.redMul(r.redMul(this.z)), a = n.redSub(i), l = s.redSub(o);
                    if (0 === a.cmpn(0)) return 0 !== l.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var c = a.redSqr(), u = c.redMul(a), h = n.redMul(c), f = l.redSqr().redIAdd(u).redISub(h).redISub(h), d = l.redMul(h.redISub(f)).redISub(s.redMul(u)), p = this.z.redMul(e.z).redMul(a);
                    return this.curve.jpoint(f, d, p);
                }, u.prototype.mixedAdd = function(e) {
                    if (this.isInfinity()) return e.toJ();
                    if (e.isInfinity()) return this;
                    var t = this.z.redSqr(), r = this.x, n = e.x.redMul(t), i = this.y, s = e.y.redMul(t).redMul(this.z), o = r.redSub(n), a = i.redSub(s);
                    if (0 === o.cmpn(0)) return 0 !== a.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var l = o.redSqr(), c = l.redMul(o), u = r.redMul(l), h = a.redSqr().redIAdd(c).redISub(u).redISub(u), f = a.redMul(u.redISub(h)).redISub(i.redMul(c)), d = this.z.redMul(o);
                    return this.curve.jpoint(h, f, d);
                }, u.prototype.dblp = function(e) {
                    if (0 === e) return this;
                    if (this.isInfinity()) return this;
                    if (!e) return this.dbl();
                    var t;
                    if (this.curve.zeroA || this.curve.threeA) {
                        var r = this;
                        for(t = 0; t < e; t++)r = r.dbl();
                        return r;
                    }
                    var n = this.curve.a, i = this.curve.tinv, s = this.x, o = this.y, a = this.z, l = a.redSqr().redSqr(), c = o.redAdd(o);
                    for(t = 0; t < e; t++){
                        var u = s.redSqr(), h = c.redSqr(), f = h.redSqr(), d = u.redAdd(u).redIAdd(u).redIAdd(n.redMul(l)), p = s.redMul(h), m = d.redSqr().redISub(p.redAdd(p)), b = p.redISub(m), g = d.redMul(b);
                        g = g.redIAdd(g).redISub(f);
                        var y = c.redMul(a);
                        t + 1 < e && (l = l.redMul(f)), s = m, a = y, c = g;
                    }
                    return this.curve.jpoint(s, c.redMul(i), a);
                }, u.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
                }, u.prototype._zeroDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), s = i.redSqr(), o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
                        o = o.redIAdd(o);
                        var a = n.redAdd(n).redIAdd(n), l = a.redSqr().redISub(o).redISub(o), c = s.redIAdd(s);
                        c = (c = c.redIAdd(c)).redIAdd(c), e = l, t = a.redMul(o.redISub(l)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var u = this.x.redSqr(), h = this.y.redSqr(), f = h.redSqr(), d = this.x.redAdd(h).redSqr().redISub(u).redISub(f);
                        d = d.redIAdd(d);
                        var p = u.redAdd(u).redIAdd(u), m = p.redSqr(), b = f.redIAdd(f);
                        b = (b = b.redIAdd(b)).redIAdd(b), e = m.redISub(d).redISub(d), t = p.redMul(d.redISub(e)).redISub(b), r = (r = this.y.redMul(this.z)).redIAdd(r);
                    }
                    return this.curve.jpoint(e, t, r);
                }, u.prototype._threeDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), s = i.redSqr(), o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
                        o = o.redIAdd(o);
                        var a = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), l = a.redSqr().redISub(o).redISub(o);
                        e = l;
                        var c = s.redIAdd(s);
                        c = (c = c.redIAdd(c)).redIAdd(c), t = a.redMul(o.redISub(l)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var u = this.z.redSqr(), h = this.y.redSqr(), f = this.x.redMul(h), d = this.x.redSub(u).redMul(this.x.redAdd(u));
                        d = d.redAdd(d).redIAdd(d);
                        var p = f.redIAdd(f), m = (p = p.redIAdd(p)).redAdd(p);
                        e = d.redSqr().redISub(m), r = this.y.redAdd(this.z).redSqr().redISub(h).redISub(u);
                        var b = h.redSqr();
                        b = (b = (b = b.redIAdd(b)).redIAdd(b)).redIAdd(b), t = d.redMul(p.redISub(e)).redISub(b);
                    }
                    return this.curve.jpoint(e, t, r);
                }, u.prototype._dbl = function() {
                    var e = this.curve.a, t = this.x, r = this.y, n = this.z, i = n.redSqr().redSqr(), s = t.redSqr(), o = r.redSqr(), a = s.redAdd(s).redIAdd(s).redIAdd(e.redMul(i)), l = t.redAdd(t), c = (l = l.redIAdd(l)).redMul(o), u = a.redSqr().redISub(c.redAdd(c)), h = c.redISub(u), f = o.redSqr();
                    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                    var d = a.redMul(h).redISub(f), p = r.redAdd(r).redMul(n);
                    return this.curve.jpoint(u, d, p);
                }, u.prototype.trpl = function() {
                    if (!this.curve.zeroA) return this.dbl().add(this);
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr(), n = t.redSqr(), i = e.redAdd(e).redIAdd(e), s = i.redSqr(), o = this.x.redAdd(t).redSqr().redISub(e).redISub(n), a = (o = (o = (o = o.redIAdd(o)).redAdd(o).redIAdd(o)).redISub(s)).redSqr(), l = n.redIAdd(n);
                    l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
                    var c = i.redIAdd(o).redSqr().redISub(s).redISub(a).redISub(l), u = t.redMul(c);
                    u = (u = u.redIAdd(u)).redIAdd(u);
                    var h = this.x.redMul(a).redISub(u);
                    h = (h = h.redIAdd(h)).redIAdd(h);
                    var f = this.y.redMul(c.redMul(l.redISub(c)).redISub(o.redMul(a)));
                    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                    var d = this.z.redAdd(o).redSqr().redISub(r).redISub(a);
                    return this.curve.jpoint(h, f, d);
                }, u.prototype.mul = function(e, t) {
                    return e = new i(e, t), this.curve._wnafMul(this, e);
                }, u.prototype.eq = function(e) {
                    if ("affine" === e.type) return this.eq(e.toJ());
                    if (this === e) return !0;
                    var t = this.z.redSqr(), r = e.z.redSqr();
                    if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
                    var n = t.redMul(this.z), i = r.redMul(e.z);
                    return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
                }, u.prototype.eqXToP = function(e) {
                    var t = this.z.redSqr(), r = e.toRed(this.curve.red).redMul(t);
                    if (0 === this.x.cmp(r)) return !0;
                    for(var n = e.clone(), i = this.curve.redN.redMul(t);;){
                        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
                        if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
                    }
                }, u.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
                }, u.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                };
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        411: [
            function(e, t, r) {
                "use strict";
                var n, i = r, s = e("hash.js"), o = e("./curve"), a = e("./utils").assert;
                function l(e) {
                    "short" === e.type ? this.curve = new o.short(e) : "edwards" === e.type ? this.curve = new o.edwards(e) : this.curve = new o.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, a(this.g.validate(), "Invalid curve"), a(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
                }
                function c(e, t) {
                    Object.defineProperty(i, e, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            var r = new l(t);
                            return Object.defineProperty(i, e, {
                                configurable: !0,
                                enumerable: !0,
                                value: r
                            }), r;
                        }
                    });
                }
                i.PresetCurve = l, c("p192", {
                    type: "short",
                    prime: "p192",
                    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
                    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
                    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
                        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
                    ]
                }), c("p224", {
                    type: "short",
                    prime: "p224",
                    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
                    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
                    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
                        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
                    ]
                }), c("p256", {
                    type: "short",
                    prime: null,
                    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
                    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
                    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
                    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
                        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
                    ]
                }), c("p384", {
                    type: "short",
                    prime: null,
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
                    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
                    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
                    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
                    hash: s.sha384,
                    gRed: !1,
                    g: [
                        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
                        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
                    ]
                }), c("p521", {
                    type: "short",
                    prime: null,
                    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
                    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
                    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
                    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
                    hash: s.sha512,
                    gRed: !1,
                    g: [
                        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
                        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
                    ]
                }), c("curve25519", {
                    type: "mont",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "76d06",
                    b: "1",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "9"
                    ]
                }), c("ed25519", {
                    type: "edwards",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "-1",
                    c: "1",
                    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
                        "6666666666666666666666666666666666666666666666666666666666666658"
                    ]
                });
                try {
                    n = e("./precomputed/secp256k1");
                } catch (e) {
                    n = void 0;
                }
                c("secp256k1", {
                    type: "short",
                    prime: "k256",
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
                    a: "0",
                    b: "7",
                    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
                    h: "1",
                    hash: s.sha256,
                    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
                    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
                    basis: [
                        {
                            a: "3086d221a7d46bcde86c90e49284eb15",
                            b: "-e4437ed6010e88286f547fa90abfe4c3"
                        },
                        {
                            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                            b: "3086d221a7d46bcde86c90e49284eb15"
                        }
                    ],
                    gRed: !1,
                    g: [
                        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
                        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
                        n
                    ]
                });
            },
            {
                "./curve": 408,
                "./precomputed/secp256k1": 418,
                "./utils": 419,
                "hash.js": 426
            }
        ],
        412: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("hmac-drbg"), s = e("../utils"), o = e("../curves"), a = e("brorand"), l = s.assert, c = e("./key"), u = e("./signature");
                function h(e) {
                    if (!(this instanceof h)) return new h(e);
                    "string" == typeof e && (l(Object.prototype.hasOwnProperty.call(o, e), "Unknown curve " + e), e = o[e]), e instanceof o.PresetCurve && (e = {
                        curve: e
                    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
                }
                t.exports = h, h.prototype.keyPair = function(e) {
                    return new c(this, e);
                }, h.prototype.keyFromPrivate = function(e, t) {
                    return c.fromPrivate(this, e, t);
                }, h.prototype.keyFromPublic = function(e, t) {
                    return c.fromPublic(this, e, t);
                }, h.prototype.genKeyPair = function(e) {
                    e || (e = {});
                    for(var t = new i({
                        hash: this.hash,
                        pers: e.pers,
                        persEnc: e.persEnc || "utf8",
                        entropy: e.entropy || a(this.hash.hmacStrength),
                        entropyEnc: e.entropy && e.entropyEnc || "utf8",
                        nonce: this.n.toArray()
                    }), r = this.n.byteLength(), s = this.n.sub(new n(2));;){
                        var o = new n(t.generate(r));
                        if (!(o.cmp(s) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
                    }
                }, h.prototype._truncateToN = function(e, t) {
                    var r = 8 * e.byteLength() - this.n.bitLength();
                    return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
                }, h.prototype.sign = function(e, t, r, s) {
                    "object" == typeof r && (s = r, r = null), s || (s = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new n(e, 16));
                    for(var o = this.n.byteLength(), a = t.getPrivate().toArray("be", o), l = e.toArray("be", o), c = new i({
                        hash: this.hash,
                        entropy: a,
                        nonce: l,
                        pers: s.pers,
                        persEnc: s.persEnc || "utf8"
                    }), h = this.n.sub(new n(1)), f = 0;; f++){
                        var d = s.k ? s.k(f) : new n(c.generate(this.n.byteLength()));
                        if (!((d = this._truncateToN(d, !0)).cmpn(1) <= 0 || d.cmp(h) >= 0)) {
                            var p = this.g.mul(d);
                            if (!p.isInfinity()) {
                                var m = p.getX(), b = m.umod(this.n);
                                if (0 !== b.cmpn(0)) {
                                    var g = d.invm(this.n).mul(b.mul(t.getPrivate()).iadd(e));
                                    if (0 !== (g = g.umod(this.n)).cmpn(0)) {
                                        var y = (p.getY().isOdd() ? 1 : 0) | (0 !== m.cmp(b) ? 2 : 0);
                                        return s.canonical && g.cmp(this.nh) > 0 && (g = this.n.sub(g), y ^= 1), new u({
                                            r: b,
                                            s: g,
                                            recoveryParam: y
                                        });
                                    }
                                }
                            }
                        }
                    }
                }, h.prototype.verify = function(e, t, r, i) {
                    e = this._truncateToN(new n(e, 16)), r = this.keyFromPublic(r, i);
                    var s = (t = new u(t, "hex")).r, o = t.s;
                    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return !1;
                    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
                    var a, l = o.invm(this.n), c = l.mul(e).umod(this.n), h = l.mul(s).umod(this.n);
                    return this.curve._maxwellTrick ? !(a = this.g.jmulAdd(c, r.getPublic(), h)).isInfinity() && a.eqXToP(s) : !(a = this.g.mulAdd(c, r.getPublic(), h)).isInfinity() && 0 === a.getX().umod(this.n).cmp(s);
                }, h.prototype.recoverPubKey = function(e, t, r, i) {
                    l((3 & r) === r, "The recovery param is more than two bits"), t = new u(t, i);
                    var s = this.n, o = new n(e), a = t.r, c = t.s, h = 1 & r, f = r >> 1;
                    if (a.cmp(this.curve.p.umod(this.curve.n)) >= 0 && f) throw new Error("Unable to find sencond key candinate");
                    a = f ? this.curve.pointFromX(a.add(this.curve.n), h) : this.curve.pointFromX(a, h);
                    var d = t.r.invm(s), p = s.sub(o).mul(d).umod(s), m = c.mul(d).umod(s);
                    return this.g.mulAdd(p, a, m);
                }, h.prototype.getKeyRecoveryParam = function(e, t, r, n) {
                    if (null !== (t = new u(t, n)).recoveryParam) return t.recoveryParam;
                    for(var i = 0; i < 4; i++){
                        var s;
                        try {
                            s = this.recoverPubKey(e, t, i);
                        } catch (e) {
                            continue;
                        }
                        if (s.eq(r)) return i;
                    }
                    throw new Error("Unable to find valid recovery factor");
                };
            },
            {
                "../curves": 411,
                "../utils": 419,
                "./key": 413,
                "./signature": 414,
                "bn.js": 420,
                brorand: 187,
                "hmac-drbg": 438
            }
        ],
        413: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils").assert;
                function s(e, t) {
                    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
                }
                t.exports = s, s.fromPublic = function(e, t, r) {
                    return t instanceof s ? t : new s(e, {
                        pub: t,
                        pubEnc: r
                    });
                }, s.fromPrivate = function(e, t, r) {
                    return t instanceof s ? t : new s(e, {
                        priv: t,
                        privEnc: r
                    });
                }, s.prototype.validate = function() {
                    var e = this.getPublic();
                    return e.isInfinity() ? {
                        result: !1,
                        reason: "Invalid public key"
                    } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
                        result: !0,
                        reason: null
                    } : {
                        result: !1,
                        reason: "Public key * N != O"
                    } : {
                        result: !1,
                        reason: "Public key is not a point"
                    };
                }, s.prototype.getPublic = function(e, t) {
                    return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
                }, s.prototype.getPrivate = function(e) {
                    return "hex" === e ? this.priv.toString(16, 2) : this.priv;
                }, s.prototype._importPrivate = function(e, t) {
                    this.priv = new n(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
                }, s.prototype._importPublic = function(e, t) {
                    if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
                    this.pub = this.ec.curve.decodePoint(e, t);
                }, s.prototype.derive = function(e) {
                    return e.validate() || i(e.validate(), "public point not validated"), e.mul(this.priv).getX();
                }, s.prototype.sign = function(e, t, r) {
                    return this.ec.sign(e, this, t, r);
                }, s.prototype.verify = function(e, t) {
                    return this.ec.verify(e, t, this);
                }, s.prototype.inspect = function() {
                    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        414: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.assert;
                function o(e, t) {
                    if (e instanceof o) return e;
                    this._importDER(e, t) || (s(e.r && e.s, "Signature without r or s"), this.r = new n(e.r, 16), this.s = new n(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
                }
                function a() {
                    this.place = 0;
                }
                function l(e, t) {
                    var r = e[t.place++];
                    if (!(128 & r)) return r;
                    var n = 15 & r;
                    if (0 === n || n > 4) return !1;
                    for(var i = 0, s = 0, o = t.place; s < n; s++, o++)i <<= 8, i |= e[o], i >>>= 0;
                    return !(i <= 127) && (t.place = o, i);
                }
                function c(e) {
                    for(var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;)t++;
                    return 0 === t ? e : e.slice(t);
                }
                function u(e, t) {
                    if (t < 128) e.push(t);
                    else {
                        var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
                        for(e.push(128 | r); --r;)e.push(t >>> (r << 3) & 255);
                        e.push(t);
                    }
                }
                t.exports = o, o.prototype._importDER = function(e, t) {
                    e = i.toArray(e, t);
                    var r = new a;
                    if (48 !== e[r.place++]) return !1;
                    var s = l(e, r);
                    if (!1 === s) return !1;
                    if (s + r.place !== e.length) return !1;
                    if (2 !== e[r.place++]) return !1;
                    var o = l(e, r);
                    if (!1 === o) return !1;
                    var c = e.slice(r.place, o + r.place);
                    if (r.place += o, 2 !== e[r.place++]) return !1;
                    var u = l(e, r);
                    if (!1 === u) return !1;
                    if (e.length !== u + r.place) return !1;
                    var h = e.slice(r.place, u + r.place);
                    if (0 === c[0]) {
                        if (!(128 & c[1])) return !1;
                        c = c.slice(1);
                    }
                    if (0 === h[0]) {
                        if (!(128 & h[1])) return !1;
                        h = h.slice(1);
                    }
                    return this.r = new n(c), this.s = new n(h), this.recoveryParam = null, !0;
                }, o.prototype.toDER = function(e) {
                    var t = this.r.toArray(), r = this.s.toArray();
                    for(128 & t[0] && (t = [
                        0
                    ].concat(t)), 128 & r[0] && (r = [
                        0
                    ].concat(r)), t = c(t), r = c(r); !(r[0] || 128 & r[1]);)r = r.slice(1);
                    var n = [
                        2
                    ];
                    u(n, t.length), (n = n.concat(t)).push(2), u(n, r.length);
                    var s = n.concat(r), o = [
                        48
                    ];
                    return u(o, s.length), o = o.concat(s), i.encode(o, e);
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        415: [
            function(e, t, r) {
                "use strict";
                var n = e("hash.js"), i = e("../curves"), s = e("../utils"), o = s.assert, a = s.parseBytes, l = e("./key"), c = e("./signature");
                function u(e) {
                    if (o("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof u)) return new u(e);
                    e = i[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = n.sha512;
                }
                t.exports = u, u.prototype.sign = function(e, t) {
                    e = a(e);
                    var r = this.keyFromSecret(t), n = this.hashInt(r.messagePrefix(), e), i = this.g.mul(n), s = this.encodePoint(i), o = this.hashInt(s, r.pubBytes(), e).mul(r.priv()), l = n.add(o).umod(this.curve.n);
                    return this.makeSignature({
                        R: i,
                        S: l,
                        Rencoded: s
                    });
                }, u.prototype.verify = function(e, t, r) {
                    e = a(e), t = this.makeSignature(t);
                    var n = this.keyFromPublic(r), i = this.hashInt(t.Rencoded(), n.pubBytes(), e), s = this.g.mul(t.S());
                    return t.R().add(n.pub().mul(i)).eq(s);
                }, u.prototype.hashInt = function() {
                    for(var e = this.hash(), t = 0; t < arguments.length; t++)e.update(arguments[t]);
                    return s.intFromLE(e.digest()).umod(this.curve.n);
                }, u.prototype.keyFromPublic = function(e) {
                    return l.fromPublic(this, e);
                }, u.prototype.keyFromSecret = function(e) {
                    return l.fromSecret(this, e);
                }, u.prototype.makeSignature = function(e) {
                    return e instanceof c ? e : new c(this, e);
                }, u.prototype.encodePoint = function(e) {
                    var t = e.getY().toArray("le", this.encodingLength);
                    return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
                }, u.prototype.decodePoint = function(e) {
                    var t = (e = s.parseBytes(e)).length - 1, r = e.slice(0, t).concat(-129 & e[t]), n = 0 != (128 & e[t]), i = s.intFromLE(r);
                    return this.curve.pointFromY(i, n);
                }, u.prototype.encodeInt = function(e) {
                    return e.toArray("le", this.encodingLength);
                }, u.prototype.decodeInt = function(e) {
                    return s.intFromLE(e);
                }, u.prototype.isPoint = function(e) {
                    return e instanceof this.pointClass;
                };
            },
            {
                "../curves": 411,
                "../utils": 419,
                "./key": 416,
                "./signature": 417,
                "hash.js": 426
            }
        ],
        416: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = n.assert, s = n.parseBytes, o = n.cachedProperty;
                function a(e, t) {
                    this.eddsa = e, this._secret = s(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = s(t.pub);
                }
                a.fromPublic = function(e, t) {
                    return t instanceof a ? t : new a(e, {
                        pub: t
                    });
                }, a.fromSecret = function(e, t) {
                    return t instanceof a ? t : new a(e, {
                        secret: t
                    });
                }, a.prototype.secret = function() {
                    return this._secret;
                }, o(a, "pubBytes", function() {
                    return this.eddsa.encodePoint(this.pub());
                }), o(a, "pub", function() {
                    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
                }), o(a, "privBytes", function() {
                    var e = this.eddsa, t = this.hash(), r = e.encodingLength - 1, n = t.slice(0, e.encodingLength);
                    return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
                }), o(a, "priv", function() {
                    return this.eddsa.decodeInt(this.privBytes());
                }), o(a, "hash", function() {
                    return this.eddsa.hash().update(this.secret()).digest();
                }), o(a, "messagePrefix", function() {
                    return this.hash().slice(this.eddsa.encodingLength);
                }), a.prototype.sign = function(e) {
                    return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
                }, a.prototype.verify = function(e, t) {
                    return this.eddsa.verify(e, t, this);
                }, a.prototype.getSecret = function(e) {
                    return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), e);
                }, a.prototype.getPublic = function(e) {
                    return n.encode(this.pubBytes(), e);
                }, t.exports = a;
            },
            {
                "../utils": 419
            }
        ],
        417: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.assert, o = i.cachedProperty, a = i.parseBytes;
                function l(e, t) {
                    this.eddsa = e, "object" != typeof t && (t = a(t)), Array.isArray(t) && (t = {
                        R: t.slice(0, e.encodingLength),
                        S: t.slice(e.encodingLength)
                    }), s(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof n && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
                }
                o(l, "S", function() {
                    return this.eddsa.decodeInt(this.Sencoded());
                }), o(l, "R", function() {
                    return this.eddsa.decodePoint(this.Rencoded());
                }), o(l, "Rencoded", function() {
                    return this.eddsa.encodePoint(this.R());
                }), o(l, "Sencoded", function() {
                    return this.eddsa.encodeInt(this.S());
                }), l.prototype.toBytes = function() {
                    return this.Rencoded().concat(this.Sencoded());
                }, l.prototype.toHex = function() {
                    return i.encode(this.toBytes(), "hex").toUpperCase();
                }, t.exports = l;
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        418: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    doubles: {
                        step: 4,
                        points: [
                            [
                                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
                            ],
                            [
                                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
                            ],
                            [
                                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
                            ],
                            [
                                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
                            ],
                            [
                                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
                            ],
                            [
                                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
                            ],
                            [
                                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
                            ],
                            [
                                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
                            ],
                            [
                                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
                            ],
                            [
                                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
                            ],
                            [
                                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
                            ],
                            [
                                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
                            ],
                            [
                                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
                            ],
                            [
                                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
                            ],
                            [
                                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
                            ],
                            [
                                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
                            ],
                            [
                                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
                            ],
                            [
                                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
                            ],
                            [
                                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
                            ],
                            [
                                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
                            ],
                            [
                                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
                            ],
                            [
                                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
                            ],
                            [
                                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
                            ],
                            [
                                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
                            ],
                            [
                                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
                            ],
                            [
                                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
                            ],
                            [
                                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
                            ],
                            [
                                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
                            ],
                            [
                                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
                            ],
                            [
                                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
                            ],
                            [
                                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
                            ],
                            [
                                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
                            ],
                            [
                                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
                            ],
                            [
                                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
                            ],
                            [
                                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
                            ],
                            [
                                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
                            ],
                            [
                                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
                            ],
                            [
                                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
                            ],
                            [
                                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
                            ],
                            [
                                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
                            ],
                            [
                                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
                            ],
                            [
                                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
                            ],
                            [
                                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
                            ],
                            [
                                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
                            ],
                            [
                                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
                            ],
                            [
                                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
                            ],
                            [
                                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
                            ],
                            [
                                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
                            ],
                            [
                                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
                            ],
                            [
                                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
                            ],
                            [
                                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
                            ],
                            [
                                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
                            ],
                            [
                                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
                            ],
                            [
                                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
                            ],
                            [
                                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
                            ],
                            [
                                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
                            ],
                            [
                                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
                            ],
                            [
                                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
                            ],
                            [
                                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
                            ],
                            [
                                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
                            ],
                            [
                                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
                            ],
                            [
                                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
                            ],
                            [
                                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
                            ],
                            [
                                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
                            ],
                            [
                                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
                            ]
                        ]
                    },
                    naf: {
                        wnd: 7,
                        points: [
                            [
                                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
                            ],
                            [
                                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
                            ],
                            [
                                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
                            ],
                            [
                                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
                            ],
                            [
                                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
                            ],
                            [
                                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
                            ],
                            [
                                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
                            ],
                            [
                                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
                            ],
                            [
                                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
                            ],
                            [
                                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
                            ],
                            [
                                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
                            ],
                            [
                                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
                            ],
                            [
                                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
                            ],
                            [
                                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
                            ],
                            [
                                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
                            ],
                            [
                                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
                            ],
                            [
                                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
                            ],
                            [
                                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
                            ],
                            [
                                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
                            ],
                            [
                                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
                            ],
                            [
                                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
                            ],
                            [
                                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
                            ],
                            [
                                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
                            ],
                            [
                                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
                            ],
                            [
                                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
                            ],
                            [
                                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
                            ],
                            [
                                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
                            ],
                            [
                                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
                            ],
                            [
                                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
                            ],
                            [
                                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
                            ],
                            [
                                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
                            ],
                            [
                                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
                            ],
                            [
                                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
                            ],
                            [
                                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
                            ],
                            [
                                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
                            ],
                            [
                                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
                            ],
                            [
                                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
                            ],
                            [
                                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
                            ],
                            [
                                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
                            ],
                            [
                                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
                            ],
                            [
                                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
                            ],
                            [
                                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
                            ],
                            [
                                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
                            ],
                            [
                                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
                            ],
                            [
                                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
                            ],
                            [
                                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
                            ],
                            [
                                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
                            ],
                            [
                                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
                            ],
                            [
                                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
                            ],
                            [
                                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
                            ],
                            [
                                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
                            ],
                            [
                                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
                            ],
                            [
                                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
                            ],
                            [
                                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
                            ],
                            [
                                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
                            ],
                            [
                                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
                            ],
                            [
                                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
                            ],
                            [
                                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
                            ],
                            [
                                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
                            ],
                            [
                                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
                            ],
                            [
                                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
                            ],
                            [
                                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
                            ],
                            [
                                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
                            ],
                            [
                                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
                            ],
                            [
                                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
                            ],
                            [
                                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
                            ],
                            [
                                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
                            ],
                            [
                                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
                            ],
                            [
                                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
                            ],
                            [
                                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
                            ],
                            [
                                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
                            ],
                            [
                                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
                            ],
                            [
                                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
                            ],
                            [
                                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
                            ],
                            [
                                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
                            ],
                            [
                                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
                            ],
                            [
                                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
                            ],
                            [
                                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
                            ],
                            [
                                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
                            ],
                            [
                                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
                            ],
                            [
                                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
                            ],
                            [
                                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
                            ],
                            [
                                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
                            ],
                            [
                                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
                            ],
                            [
                                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
                            ],
                            [
                                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
                            ],
                            [
                                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
                            ],
                            [
                                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
                            ],
                            [
                                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
                            ],
                            [
                                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
                            ],
                            [
                                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
                            ],
                            [
                                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
                            ],
                            [
                                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
                            ],
                            [
                                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
                            ],
                            [
                                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
                            ],
                            [
                                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
                            ],
                            [
                                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
                            ],
                            [
                                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
                            ],
                            [
                                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
                            ],
                            [
                                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
                            ],
                            [
                                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
                            ],
                            [
                                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
                            ],
                            [
                                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
                            ],
                            [
                                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
                            ],
                            [
                                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
                            ],
                            [
                                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
                            ],
                            [
                                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
                            ],
                            [
                                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
                            ],
                            [
                                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
                            ],
                            [
                                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
                            ],
                            [
                                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
                            ],
                            [
                                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
                            ],
                            [
                                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
                            ],
                            [
                                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
                            ],
                            [
                                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
                            ],
                            [
                                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
                            ],
                            [
                                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
                            ],
                            [
                                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
                            ],
                            [
                                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
                            ],
                            [
                                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
                            ],
                            [
                                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
                            ],
                            [
                                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
                            ],
                            [
                                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
                            ],
                            [
                                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
                            ],
                            [
                                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
                            ],
                            [
                                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
                            ],
                            [
                                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
                            ]
                        ]
                    }
                };
            },
            {}
        ],
        419: [
            function(e, t, r) {
                "use strict";
                var n = r, i = e("bn.js"), s = e("minimalistic-assert"), o = e("minimalistic-crypto-utils");
                n.assert = s, n.toArray = o.toArray, n.zero2 = o.zero2, n.toHex = o.toHex, n.encode = o.encode, n.getNAF = function(e, t, r) {
                    var n = new Array(Math.max(e.bitLength(), r) + 1);
                    n.fill(0);
                    for(var i = 1 << t + 1, s = e.clone(), o = 0; o < n.length; o++){
                        var a, l = s.andln(i - 1);
                        s.isOdd() ? (a = l > (i >> 1) - 1 ? (i >> 1) - l : l, s.isubn(a)) : a = 0, n[o] = a, s.iushrn(1);
                    }
                    return n;
                }, n.getJSF = function(e, t) {
                    var r = [
                        [],
                        []
                    ];
                    e = e.clone(), t = t.clone();
                    for(var n, i = 0, s = 0; e.cmpn(-i) > 0 || t.cmpn(-s) > 0;){
                        var o, a, l = e.andln(3) + i & 3, c = t.andln(3) + s & 3;
                        3 === l && (l = -1), 3 === c && (c = -1), o = 0 == (1 & l) ? 0 : 3 !== (n = e.andln(7) + i & 7) && 5 !== n || 2 !== c ? l : -l, r[0].push(o), a = 0 == (1 & c) ? 0 : 3 !== (n = t.andln(7) + s & 7) && 5 !== n || 2 !== l ? c : -c, r[1].push(a), 2 * i === o + 1 && (i = 1 - i), 2 * s === a + 1 && (s = 1 - s), e.iushrn(1), t.iushrn(1);
                    }
                    return r;
                }, n.cachedProperty = function(e, t, r) {
                    var n = "_" + t;
                    e.prototype[t] = function() {
                        return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
                    };
                }, n.parseBytes = function(e) {
                    return "string" == typeof e ? n.toArray(e, "hex") : e;
                }, n.intFromLE = function(e) {
                    return new i(e, "hex", "le");
                };
            },
            {
                "bn.js": 420,
                "minimalistic-assert": 453,
                "minimalistic-crypto-utils": 454
            }
        ],
        420: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        421: [
            function(e, t, r) {
                t.exports = {
                    name: "elliptic",
                    version: "6.5.4",
                    description: "EC cryptography",
                    main: "lib/elliptic.js",
                    files: [
                        "lib"
                    ],
                    scripts: {
                        lint: "eslint lib test",
                        "lint:fix": "npm run lint -- --fix",
                        unit: "istanbul test _mocha --reporter=spec test/index.js",
                        test: "npm run lint && npm run unit",
                        version: "grunt dist && git add dist/"
                    },
                    repository: {
                        type: "git",
                        url: "git@github.com:indutny/elliptic"
                    },
                    keywords: [
                        "EC",
                        "Elliptic",
                        "curve",
                        "Cryptography"
                    ],
                    author: "Fedor Indutny <fedor@indutny.com>",
                    license: "MIT",
                    bugs: {
                        url: "https://github.com/indutny/elliptic/issues"
                    },
                    homepage: "https://github.com/indutny/elliptic",
                    devDependencies: {
                        brfs: "^2.0.2",
                        coveralls: "^3.1.0",
                        eslint: "^7.6.0",
                        grunt: "^1.2.1",
                        "grunt-browserify": "^5.3.0",
                        "grunt-cli": "^1.3.2",
                        "grunt-contrib-connect": "^3.0.0",
                        "grunt-contrib-copy": "^1.0.0",
                        "grunt-contrib-uglify": "^5.0.0",
                        "grunt-mocha-istanbul": "^5.0.2",
                        "grunt-saucelabs": "^9.0.1",
                        istanbul: "^0.4.5",
                        mocha: "^8.0.1"
                    },
                    dependencies: {
                        "bn.js": "^4.11.9",
                        brorand: "^1.1.0",
                        "hash.js": "^1.0.0",
                        "hmac-drbg": "^1.0.1",
                        inherits: "^2.0.4",
                        "minimalistic-assert": "^1.0.1",
                        "minimalistic-crypto-utils": "^1.0.1"
                    }
                };
            },
            {}
        ],
        422: [
            function(e, t, r) {
                "use strict";
                var n = Object.create || function(e) {
                    var t = function() {};
                    return t.prototype = e, new t;
                }, i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.push(r);
                    return r;
                }, s = Function.prototype.bind || function(e) {
                    var t = this;
                    return function() {
                        return t.apply(e, arguments);
                    };
                };
                function o() {
                    this._events && Object.prototype.hasOwnProperty.call(this, "_events") || (this._events = n(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }
                t.exports = o, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._maxListeners = void 0;
                var a, l = 10;
                try {
                    var c = {};
                    Object.defineProperty && Object.defineProperty(c, "x", {
                        value: 0
                    }), a = 0 === c.x;
                } catch (e) {
                    a = !1;
                }
                function u(e) {
                    return void 0 === e._maxListeners ? o.defaultMaxListeners : e._maxListeners;
                }
                function h(e, t, r) {
                    if (t) e.call(r);
                    else for(var n = e.length, i = _(e, n), s = 0; s < n; ++s)i[s].call(r);
                }
                function f(e, t, r, n) {
                    if (t) e.call(r, n);
                    else for(var i = e.length, s = _(e, i), o = 0; o < i; ++o)s[o].call(r, n);
                }
                function d(e, t, r, n, i) {
                    if (t) e.call(r, n, i);
                    else for(var s = e.length, o = _(e, s), a = 0; a < s; ++a)o[a].call(r, n, i);
                }
                function p(e, t, r, n, i, s) {
                    if (t) e.call(r, n, i, s);
                    else for(var o = e.length, a = _(e, o), l = 0; l < o; ++l)a[l].call(r, n, i, s);
                }
                function m(e, t, r, n) {
                    if (t) e.apply(r, n);
                    else for(var i = e.length, s = _(e, i), o = 0; o < i; ++o)s[o].apply(r, n);
                }
                function b(e, t, r, i) {
                    var s, o, a;
                    if ("function" != typeof r) throw new TypeError('"listener" argument must be a function');
                    if ((o = e._events) ? (o.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), o = e._events), a = o[t]) : (o = e._events = n(null), e._eventsCount = 0), a) {
                        if ("function" == typeof a ? a = o[t] = i ? [
                            r,
                            a
                        ] : [
                            a,
                            r
                        ] : i ? a.unshift(r) : a.push(r), !a.warned && (s = u(e)) && s > 0 && a.length > s) {
                            a.warned = !0;
                            var l = new Error("Possible EventEmitter memory leak detected. " + a.length + ' "' + String(t) + '" listeners added. Use emitter.setMaxListeners() to increase limit.');
                            l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = t, l.count = a.length, "object" == typeof console && console.warn && console.warn("%s: %s", l.name, l.message);
                        }
                    } else a = o[t] = r, ++e._eventsCount;
                    return e;
                }
                function g() {
                    if (!this.fired) switch(this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length){
                        case 0:
                            return this.listener.call(this.target);
                        case 1:
                            return this.listener.call(this.target, arguments[0]);
                        case 2:
                            return this.listener.call(this.target, arguments[0], arguments[1]);
                        case 3:
                            return this.listener.call(this.target, arguments[0], arguments[1], arguments[2]);
                        default:
                            for(var e = new Array(arguments.length), t = 0; t < e.length; ++t)e[t] = arguments[t];
                            this.listener.apply(this.target, e);
                    }
                }
                function y(e, t, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: r
                    }, i = s.call(g, n);
                    return i.listener = r, n.wrapFn = i, i;
                }
                function v(e, t, r) {
                    var n = e._events;
                    if (!n) return [];
                    var i = n[t];
                    return i ? "function" == typeof i ? r ? [
                        i.listener || i
                    ] : [
                        i
                    ] : r ? function(e) {
                        for(var t = new Array(e.length), r = 0; r < t.length; ++r)t[r] = e[r].listener || e[r];
                        return t;
                    }(i) : _(i, i.length) : [];
                }
                function w(e) {
                    var t = this._events;
                    if (t) {
                        var r = t[e];
                        if ("function" == typeof r) return 1;
                        if (r) return r.length;
                    }
                    return 0;
                }
                function _(e, t) {
                    for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e[n];
                    return r;
                }
                a ? Object.defineProperty(o, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return l;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || e != e) throw new TypeError('"defaultMaxListeners" must be a positive number');
                        l = e;
                    }
                }) : o.defaultMaxListeners = l, o.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
                    return this._maxListeners = e, this;
                }, o.prototype.getMaxListeners = function() {
                    return u(this);
                }, o.prototype.emit = function(e) {
                    var t, r, n, i, s, o, a = "error" === e;
                    if (o = this._events) a = a && null == o.error;
                    else if (!a) return !1;
                    if (a) {
                        if (arguments.length > 1 && (t = arguments[1]), t instanceof Error) throw t;
                        var l = new Error('Unhandled "error" event. (' + t + ")");
                        throw l.context = t, l;
                    }
                    if (!(r = o[e])) return !1;
                    var c = "function" == typeof r;
                    switch(n = arguments.length){
                        case 1:
                            h(r, c, this);
                            break;
                        case 2:
                            f(r, c, this, arguments[1]);
                            break;
                        case 3:
                            d(r, c, this, arguments[1], arguments[2]);
                            break;
                        case 4:
                            p(r, c, this, arguments[1], arguments[2], arguments[3]);
                            break;
                        default:
                            for(i = new Array(n - 1), s = 1; s < n; s++)i[s - 1] = arguments[s];
                            m(r, c, this, i);
                    }
                    return !0;
                }, o.prototype.addListener = function(e, t) {
                    return b(this, e, t, !1);
                }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(e, t) {
                    return b(this, e, t, !0);
                }, o.prototype.once = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.on(e, y(this, e, t)), this;
                }, o.prototype.prependOnceListener = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.prependListener(e, y(this, e, t)), this;
                }, o.prototype.removeListener = function(e, t) {
                    var r, i, s, o, a;
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    if (!(i = this._events)) return this;
                    if (!(r = i[e])) return this;
                    if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = n(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, r.listener || t));
                    else if ("function" != typeof r) {
                        for(s = -1, o = r.length - 1; o >= 0; o--)if (r[o] === t || r[o].listener === t) {
                            a = r[o].listener, s = o;
                            break;
                        }
                        if (s < 0) return this;
                        0 === s ? r.shift() : function(e, t) {
                            for(var r = t, n = r + 1, i = e.length; n < i; r += 1, n += 1)e[r] = e[n];
                            e.pop();
                        }(r, s), 1 === r.length && (i[e] = r[0]), i.removeListener && this.emit("removeListener", e, a || t);
                    }
                    return this;
                }, o.prototype.removeAllListeners = function(e) {
                    var t, r, s;
                    if (!(r = this._events)) return this;
                    if (!r.removeListener) return 0 === arguments.length ? (this._events = n(null), this._eventsCount = 0) : r[e] && (0 == --this._eventsCount ? this._events = n(null) : delete r[e]), this;
                    if (0 === arguments.length) {
                        var o, a = i(r);
                        for(s = 0; s < a.length; ++s)"removeListener" !== (o = a[s]) && this.removeAllListeners(o);
                        return this.removeAllListeners("removeListener"), this._events = n(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = r[e])) this.removeListener(e, t);
                    else if (t) for(s = t.length - 1; s >= 0; s--)this.removeListener(e, t[s]);
                    return this;
                }, o.prototype.listeners = function(e) {
                    return v(this, e, !0);
                }, o.prototype.rawListeners = function(e) {
                    return v(this, e, !1);
                }, o.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : w.call(e, t);
                }, o.prototype.listenerCount = w, o.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
                };
            },
            {}
        ],
        423: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("md5.js");
                t.exports = function(e, t, r, s) {
                    if (n.isBuffer(e) || (e = n.from(e, "binary")), t && (n.isBuffer(t) || (t = n.from(t, "binary")), 8 !== t.length)) throw new RangeError("salt should be Buffer with 8 byte length");
                    for(var o = r / 8, a = n.alloc(o), l = n.alloc(s || 0), c = n.alloc(0); o > 0 || s > 0;){
                        var u = new i;
                        u.update(c), u.update(e), t && u.update(t), c = u.digest();
                        var h = 0;
                        if (o > 0) {
                            var f = a.length - o;
                            h = Math.min(o, c.length), c.copy(a, f, 0, h), o -= h;
                        }
                        if (h < c.length && s > 0) {
                            var d = l.length - s, p = Math.min(s, c.length - h);
                            c.copy(l, d, h, h + p), s -= p;
                        }
                    }
                    return c.fill(0), {
                        key: a,
                        iv: l
                    };
                };
            },
            {
                "md5.js": 450,
                "safe-buffer": 494
            }
        ],
        424: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CsvParserStream = r.ParserOptions = r.parseFile = r.parseStream = r.parseString = r.parse = r.FormatterOptions = r.CsvFormatterStream = r.writeToPath = r.writeToString = r.writeToBuffer = r.writeToStream = r.write = r.format = void 0;
                var n = e("@fast-csv/format");
                Object.defineProperty(r, "format", {
                    enumerable: !0,
                    get: function() {
                        return n.format;
                    }
                }), Object.defineProperty(r, "write", {
                    enumerable: !0,
                    get: function() {
                        return n.write;
                    }
                }), Object.defineProperty(r, "writeToStream", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToStream;
                    }
                }), Object.defineProperty(r, "writeToBuffer", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToBuffer;
                    }
                }), Object.defineProperty(r, "writeToString", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToString;
                    }
                }), Object.defineProperty(r, "writeToPath", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToPath;
                    }
                }), Object.defineProperty(r, "CsvFormatterStream", {
                    enumerable: !0,
                    get: function() {
                        return n.CsvFormatterStream;
                    }
                }), Object.defineProperty(r, "FormatterOptions", {
                    enumerable: !0,
                    get: function() {
                        return n.FormatterOptions;
                    }
                });
                var i = e("@fast-csv/parse");
                Object.defineProperty(r, "parse", {
                    enumerable: !0,
                    get: function() {
                        return i.parse;
                    }
                }), Object.defineProperty(r, "parseString", {
                    enumerable: !0,
                    get: function() {
                        return i.parseString;
                    }
                }), Object.defineProperty(r, "parseStream", {
                    enumerable: !0,
                    get: function() {
                        return i.parseStream;
                    }
                }), Object.defineProperty(r, "parseFile", {
                    enumerable: !0,
                    get: function() {
                        return i.parseFile;
                    }
                }), Object.defineProperty(r, "ParserOptions", {
                    enumerable: !0,
                    get: function() {
                        return i.ParserOptions;
                    }
                }), Object.defineProperty(r, "CsvParserStream", {
                    enumerable: !0,
                    get: function() {
                        return i.CsvParserStream;
                    }
                });
            },
            {
                "@fast-csv/format": 151,
                "@fast-csv/parse": 155
            }
        ],
        425: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("readable-stream").Transform;
                function s(e) {
                    i.call(this), this._block = n.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [
                        0,
                        0,
                        0,
                        0
                    ], this._finalized = !1;
                }
                e("inherits")(s, i), s.prototype._transform = function(e, t, r) {
                    var n = null;
                    try {
                        this.update(e, t);
                    } catch (e) {
                        n = e;
                    }
                    r(n);
                }, s.prototype._flush = function(e) {
                    var t = null;
                    try {
                        this.push(this.digest());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, s.prototype.update = function(e, t) {
                    if (function(e, t) {
                        if (!n.isBuffer(e) && "string" != typeof e) throw new TypeError(t + " must be a string or a buffer");
                    }(e, "Data"), this._finalized) throw new Error("Digest already called");
                    n.isBuffer(e) || (e = n.from(e, t));
                    for(var r = this._block, i = 0; this._blockOffset + e.length - i >= this._blockSize;){
                        for(var s = this._blockOffset; s < this._blockSize;)r[s++] = e[i++];
                        this._update(), this._blockOffset = 0;
                    }
                    for(; i < e.length;)r[this._blockOffset++] = e[i++];
                    for(var o = 0, a = 8 * e.length; a > 0; ++o)this._length[o] += a, (a = this._length[o] / 4294967296 | 0) > 0 && (this._length[o] -= 4294967296 * a);
                    return this;
                }, s.prototype._update = function() {
                    throw new Error("_update is not implemented");
                }, s.prototype.digest = function(e) {
                    if (this._finalized) throw new Error("Digest already called");
                    this._finalized = !0;
                    var t = this._digest();
                    void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;
                    for(var r = 0; r < 4; ++r)this._length[r] = 0;
                    return t;
                }, s.prototype._digest = function() {
                    throw new Error("_digest is not implemented");
                }, t.exports = s;
            },
            {
                inherits: 440,
                "readable-stream": 491,
                "safe-buffer": 494
            }
        ],
        426: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.utils = e("./hash/utils"), n.common = e("./hash/common"), n.sha = e("./hash/sha"), n.ripemd = e("./hash/ripemd"), n.hmac = e("./hash/hmac"), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
            },
            {
                "./hash/common": 427,
                "./hash/hmac": 428,
                "./hash/ripemd": 429,
                "./hash/sha": 430,
                "./hash/utils": 437
            }
        ],
        427: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("minimalistic-assert");
                function s() {
                    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
                }
                r.BlockHash = s, s.prototype.update = function(e, t) {
                    if (e = n.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
                        var r = (e = this.pending).length % this._delta8;
                        this.pending = e.slice(e.length - r, e.length), 0 === this.pending.length && (this.pending = null), e = n.join32(e, 0, e.length - r, this.endian);
                        for(var i = 0; i < e.length; i += this._delta32)this._update(e, i, i + this._delta32);
                    }
                    return this;
                }, s.prototype.digest = function(e) {
                    return this.update(this._pad()), i(null === this.pending), this._digest(e);
                }, s.prototype._pad = function() {
                    var e = this.pendingTotal, t = this._delta8, r = t - (e + this.padLength) % t, n = new Array(r + this.padLength);
                    n[0] = 128;
                    for(var i = 1; i < r; i++)n[i] = 0;
                    if (e <<= 3, "big" === this.endian) {
                        for(var s = 8; s < this.padLength; s++)n[i++] = 0;
                        n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = e >>> 24 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 8 & 255, n[i++] = 255 & e;
                    } else for(n[i++] = 255 & e, n[i++] = e >>> 8 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, s = 8; s < this.padLength; s++)n[i++] = 0;
                    return n;
                };
            },
            {
                "./utils": 437,
                "minimalistic-assert": 453
            }
        ],
        428: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("minimalistic-assert");
                function s(e, t, r) {
                    if (!(this instanceof s)) return new s(e, t, r);
                    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(t, r));
                }
                t.exports = s, s.prototype._init = function(e) {
                    e.length > this.blockSize && (e = (new this.Hash).update(e).digest()), i(e.length <= this.blockSize);
                    for(var t = e.length; t < this.blockSize; t++)e.push(0);
                    for(t = 0; t < e.length; t++)e[t] ^= 54;
                    for(this.inner = (new this.Hash).update(e), t = 0; t < e.length; t++)e[t] ^= 106;
                    this.outer = (new this.Hash).update(e);
                }, s.prototype.update = function(e, t) {
                    return this.inner.update(e, t), this;
                }, s.prototype.digest = function(e) {
                    return this.outer.update(this.inner.digest()), this.outer.digest(e);
                };
            },
            {
                "./utils": 437,
                "minimalistic-assert": 453
            }
        ],
        429: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("./common"), s = n.rotl32, o = n.sum32, a = n.sum32_3, l = n.sum32_4, c = i.BlockHash;
                function u() {
                    if (!(this instanceof u)) return new u;
                    c.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.endian = "little";
                }
                function h(e, t, r, n) {
                    return e <= 15 ? t ^ r ^ n : e <= 31 ? t & r | ~t & n : e <= 47 ? (t | ~r) ^ n : e <= 63 ? t & n | r & ~n : t ^ (r | ~n);
                }
                function f(e) {
                    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
                }
                function d(e) {
                    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
                }
                n.inherits(u, c), r.ripemd160 = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 192, u.padLength = 64, u.prototype._update = function(e, t) {
                    for(var r = this.h[0], n = this.h[1], i = this.h[2], c = this.h[3], u = this.h[4], y = r, v = n, w = i, _ = c, x = u, k = 0; k < 80; k++){
                        var S = o(s(l(r, h(k, n, i, c), e[p[k] + t], f(k)), b[k]), u);
                        r = u, u = c, c = s(i, 10), i = n, n = S, S = o(s(l(y, h(79 - k, v, w, _), e[m[k] + t], d(k)), g[k]), x), y = x, x = _, _ = s(w, 10), w = v, v = S;
                    }
                    S = a(this.h[1], i, _), this.h[1] = a(this.h[2], c, x), this.h[2] = a(this.h[3], u, y), this.h[3] = a(this.h[4], r, v), this.h[4] = a(this.h[0], n, w), this.h[0] = S;
                }, u.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
                };
                var p = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], m = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], b = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], g = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ];
            },
            {
                "./common": 427,
                "./utils": 437
            }
        ],
        430: [
            function(e, t, r) {
                "use strict";
                r.sha1 = e("./sha/1"), r.sha224 = e("./sha/224"), r.sha256 = e("./sha/256"), r.sha384 = e("./sha/384"), r.sha512 = e("./sha/512");
            },
            {
                "./sha/1": 431,
                "./sha/224": 432,
                "./sha/256": 433,
                "./sha/384": 434,
                "./sha/512": 435
            }
        ],
        431: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("./common"), o = n.rotl32, a = n.sum32, l = n.sum32_5, c = s.ft_1, u = i.BlockHash, h = [
                    1518500249,
                    1859775393,
                    2400959708,
                    3395469782
                ];
                function f() {
                    if (!(this instanceof f)) return new f;
                    u.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.W = new Array(80);
                }
                n.inherits(f, u), t.exports = f, f.blockSize = 512, f.outSize = 160, f.hmacStrength = 80, f.padLength = 64, f.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = o(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
                    var i = this.h[0], s = this.h[1], u = this.h[2], f = this.h[3], d = this.h[4];
                    for(n = 0; n < r.length; n++){
                        var p = ~~(n / 20), m = l(o(i, 5), c(p, s, u, f), d, r[n], h[p]);
                        d = f, f = u, u = o(s, 30), s = i, i = m;
                    }
                    this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], u), this.h[3] = a(this.h[3], f), this.h[4] = a(this.h[4], d);
                }, f.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "./common": 436
            }
        ],
        432: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./256");
                function s() {
                    if (!(this instanceof s)) return new s;
                    i.call(this), this.h = [
                        3238371032,
                        914150663,
                        812702999,
                        4144912697,
                        4290775857,
                        1750603025,
                        1694076839,
                        3204075428
                    ];
                }
                n.inherits(s, i), t.exports = s, s.blockSize = 512, s.outSize = 224, s.hmacStrength = 192, s.padLength = 64, s.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
                };
            },
            {
                "../utils": 437,
                "./256": 433
            }
        ],
        433: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("./common"), o = e("minimalistic-assert"), a = n.sum32, l = n.sum32_4, c = n.sum32_5, u = s.ch32, h = s.maj32, f = s.s0_256, d = s.s1_256, p = s.g0_256, m = s.g1_256, b = i.BlockHash, g = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ];
                function y() {
                    if (!(this instanceof y)) return new y;
                    b.call(this), this.h = [
                        1779033703,
                        3144134277,
                        1013904242,
                        2773480762,
                        1359893119,
                        2600822924,
                        528734635,
                        1541459225
                    ], this.k = g, this.W = new Array(64);
                }
                n.inherits(y, b), t.exports = y, y.blockSize = 512, y.outSize = 256, y.hmacStrength = 192, y.padLength = 64, y.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = l(m(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
                    var i = this.h[0], s = this.h[1], b = this.h[2], g = this.h[3], y = this.h[4], v = this.h[5], w = this.h[6], _ = this.h[7];
                    for(o(this.k.length === r.length), n = 0; n < r.length; n++){
                        var x = c(_, d(y), u(y, v, w), this.k[n], r[n]), k = a(f(i), h(i, s, b));
                        _ = w, w = v, v = y, y = a(g, x), g = b, b = s, s = i, i = a(x, k);
                    }
                    this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], b), this.h[3] = a(this.h[3], g), this.h[4] = a(this.h[4], y), this.h[5] = a(this.h[5], v), this.h[6] = a(this.h[6], w), this.h[7] = a(this.h[7], _);
                }, y.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "./common": 436,
                "minimalistic-assert": 453
            }
        ],
        434: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./512");
                function s() {
                    if (!(this instanceof s)) return new s;
                    i.call(this), this.h = [
                        3418070365,
                        3238371032,
                        1654270250,
                        914150663,
                        2438529370,
                        812702999,
                        355462360,
                        4144912697,
                        1731405415,
                        4290775857,
                        2394180231,
                        1750603025,
                        3675008525,
                        1694076839,
                        1203062813,
                        3204075428
                    ];
                }
                n.inherits(s, i), t.exports = s, s.blockSize = 1024, s.outSize = 384, s.hmacStrength = 192, s.padLength = 128, s.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
                };
            },
            {
                "../utils": 437,
                "./512": 435
            }
        ],
        435: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("minimalistic-assert"), o = n.rotr64_hi, a = n.rotr64_lo, l = n.shr64_hi, c = n.shr64_lo, u = n.sum64, h = n.sum64_hi, f = n.sum64_lo, d = n.sum64_4_hi, p = n.sum64_4_lo, m = n.sum64_5_hi, b = n.sum64_5_lo, g = i.BlockHash, y = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ];
                function v() {
                    if (!(this instanceof v)) return new v;
                    g.call(this), this.h = [
                        1779033703,
                        4089235720,
                        3144134277,
                        2227873595,
                        1013904242,
                        4271175723,
                        2773480762,
                        1595750129,
                        1359893119,
                        2917565137,
                        2600822924,
                        725511199,
                        528734635,
                        4215389547,
                        1541459225,
                        327033209
                    ], this.k = y, this.W = new Array(160);
                }
                function w(e, t, r, n, i) {
                    var s = e & r ^ ~e & i;
                    return s < 0 && (s += 4294967296), s;
                }
                function _(e, t, r, n, i, s) {
                    var o = t & n ^ ~t & s;
                    return o < 0 && (o += 4294967296), o;
                }
                function x(e, t, r, n, i) {
                    var s = e & r ^ e & i ^ r & i;
                    return s < 0 && (s += 4294967296), s;
                }
                function k(e, t, r, n, i, s) {
                    var o = t & n ^ t & s ^ n & s;
                    return o < 0 && (o += 4294967296), o;
                }
                function S(e, t) {
                    var r = o(e, t, 28) ^ o(t, e, 2) ^ o(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function M(e, t) {
                    var r = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function C(e, t) {
                    var r = o(e, t, 14) ^ o(e, t, 18) ^ o(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function T(e, t) {
                    var r = a(e, t, 14) ^ a(e, t, 18) ^ a(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function E(e, t) {
                    var r = o(e, t, 1) ^ o(e, t, 8) ^ l(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function A(e, t) {
                    var r = a(e, t, 1) ^ a(e, t, 8) ^ c(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function R(e, t) {
                    var r = o(e, t, 19) ^ o(t, e, 29) ^ l(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                function O(e, t) {
                    var r = a(e, t, 19) ^ a(t, e, 29) ^ c(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                n.inherits(v, g), t.exports = v, v.blockSize = 1024, v.outSize = 512, v.hmacStrength = 192, v.padLength = 128, v.prototype._prepareBlock = function(e, t) {
                    for(var r = this.W, n = 0; n < 32; n++)r[n] = e[t + n];
                    for(; n < r.length; n += 2){
                        var i = R(r[n - 4], r[n - 3]), s = O(r[n - 4], r[n - 3]), o = r[n - 14], a = r[n - 13], l = E(r[n - 30], r[n - 29]), c = A(r[n - 30], r[n - 29]), u = r[n - 32], h = r[n - 31];
                        r[n] = d(i, s, o, a, l, c, u, h), r[n + 1] = p(i, s, o, a, l, c, u, h);
                    }
                }, v.prototype._update = function(e, t) {
                    this._prepareBlock(e, t);
                    var r = this.W, n = this.h[0], i = this.h[1], o = this.h[2], a = this.h[3], l = this.h[4], c = this.h[5], d = this.h[6], p = this.h[7], g = this.h[8], y = this.h[9], v = this.h[10], E = this.h[11], A = this.h[12], R = this.h[13], O = this.h[14], j = this.h[15];
                    s(this.k.length === r.length);
                    for(var I = 0; I < r.length; I += 2){
                        var N = O, P = j, B = C(g, y), D = T(g, y), F = w(g, y, v, E, A), L = _(g, y, v, E, A, R), z = this.k[I], U = this.k[I + 1], $ = r[I], H = r[I + 1], V = m(N, P, B, D, F, L, z, U, $, H), q = b(N, P, B, D, F, L, z, U, $, H);
                        N = S(n, i), P = M(n, i), B = x(n, i, o, a, l), D = k(n, i, o, a, l, c);
                        var W = h(N, P, B, D), X = f(N, P, B, D);
                        O = A, j = R, A = v, R = E, v = g, E = y, g = h(d, p, V, q), y = f(p, p, V, q), d = l, p = c, l = o, c = a, o = n, a = i, n = h(V, q, W, X), i = f(V, q, W, X);
                    }
                    u(this.h, 0, n, i), u(this.h, 2, o, a), u(this.h, 4, l, c), u(this.h, 6, d, p), u(this.h, 8, g, y), u(this.h, 10, v, E), u(this.h, 12, A, R), u(this.h, 14, O, j);
                }, v.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "minimalistic-assert": 453
            }
        ],
        436: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils").rotr32;
                function i(e, t, r) {
                    return e & t ^ ~e & r;
                }
                function s(e, t, r) {
                    return e & t ^ e & r ^ t & r;
                }
                function o(e, t, r) {
                    return e ^ t ^ r;
                }
                r.ft_1 = function(e, t, r, n) {
                    return 0 === e ? i(t, r, n) : 1 === e || 3 === e ? o(t, r, n) : 2 === e ? s(t, r, n) : void 0;
                }, r.ch32 = i, r.maj32 = s, r.p32 = o, r.s0_256 = function(e) {
                    return n(e, 2) ^ n(e, 13) ^ n(e, 22);
                }, r.s1_256 = function(e) {
                    return n(e, 6) ^ n(e, 11) ^ n(e, 25);
                }, r.g0_256 = function(e) {
                    return n(e, 7) ^ n(e, 18) ^ e >>> 3;
                }, r.g1_256 = function(e) {
                    return n(e, 17) ^ n(e, 19) ^ e >>> 10;
                };
            },
            {
                "../utils": 437
            }
        ],
        437: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits");
                function s(e, t) {
                    return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
                }
                function o(e) {
                    return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
                }
                function a(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function l(e) {
                    return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
                }
                r.inherits = i, r.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" == typeof e) {
                        if (t) {
                            if ("hex" === t) for((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2)r.push(parseInt(e[i] + e[i + 1], 16));
                        } else for(var n = 0, i = 0; i < e.length; i++){
                            var o = e.charCodeAt(i);
                            o < 128 ? r[n++] = o : o < 2048 ? (r[n++] = o >> 6 | 192, r[n++] = 63 & o | 128) : s(e, i) ? (o = 65536 + ((1023 & o) << 10) + (1023 & e.charCodeAt(++i)), r[n++] = o >> 18 | 240, r[n++] = o >> 12 & 63 | 128, r[n++] = o >> 6 & 63 | 128, r[n++] = 63 & o | 128) : (r[n++] = o >> 12 | 224, r[n++] = o >> 6 & 63 | 128, r[n++] = 63 & o | 128);
                        }
                    } else for(i = 0; i < e.length; i++)r[i] = 0 | e[i];
                    return r;
                }, r.toHex = function(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += a(e[r].toString(16));
                    return t;
                }, r.htonl = o, r.toHex32 = function(e, t) {
                    for(var r = "", n = 0; n < e.length; n++){
                        var i = e[n];
                        "little" === t && (i = o(i)), r += l(i.toString(16));
                    }
                    return r;
                }, r.zero2 = a, r.zero8 = l, r.join32 = function(e, t, r, i) {
                    var s = r - t;
                    n(s % 4 == 0);
                    for(var o = new Array(s / 4), a = 0, l = t; a < o.length; a++, l += 4){
                        var c;
                        c = "big" === i ? e[l] << 24 | e[l + 1] << 16 | e[l + 2] << 8 | e[l + 3] : e[l + 3] << 24 | e[l + 2] << 16 | e[l + 1] << 8 | e[l], o[a] = c >>> 0;
                    }
                    return o;
                }, r.split32 = function(e, t) {
                    for(var r = new Array(4 * e.length), n = 0, i = 0; n < e.length; n++, i += 4){
                        var s = e[n];
                        "big" === t ? (r[i] = s >>> 24, r[i + 1] = s >>> 16 & 255, r[i + 2] = s >>> 8 & 255, r[i + 3] = 255 & s) : (r[i + 3] = s >>> 24, r[i + 2] = s >>> 16 & 255, r[i + 1] = s >>> 8 & 255, r[i] = 255 & s);
                    }
                    return r;
                }, r.rotr32 = function(e, t) {
                    return e >>> t | e << 32 - t;
                }, r.rotl32 = function(e, t) {
                    return e << t | e >>> 32 - t;
                }, r.sum32 = function(e, t) {
                    return e + t >>> 0;
                }, r.sum32_3 = function(e, t, r) {
                    return e + t + r >>> 0;
                }, r.sum32_4 = function(e, t, r, n) {
                    return e + t + r + n >>> 0;
                }, r.sum32_5 = function(e, t, r, n, i) {
                    return e + t + r + n + i >>> 0;
                }, r.sum64 = function(e, t, r, n) {
                    var i = e[t], s = n + e[t + 1] >>> 0, o = (s < n ? 1 : 0) + r + i;
                    e[t] = o >>> 0, e[t + 1] = s;
                }, r.sum64_hi = function(e, t, r, n) {
                    return (t + n >>> 0 < t ? 1 : 0) + e + r >>> 0;
                }, r.sum64_lo = function(e, t, r, n) {
                    return t + n >>> 0;
                }, r.sum64_4_hi = function(e, t, r, n, i, s, o, a) {
                    var l = 0, c = t;
                    return l += (c = c + n >>> 0) < t ? 1 : 0, l += (c = c + s >>> 0) < s ? 1 : 0, e + r + i + o + (l += (c = c + a >>> 0) < a ? 1 : 0) >>> 0;
                }, r.sum64_4_lo = function(e, t, r, n, i, s, o, a) {
                    return t + n + s + a >>> 0;
                }, r.sum64_5_hi = function(e, t, r, n, i, s, o, a, l, c) {
                    var u = 0, h = t;
                    return u += (h = h + n >>> 0) < t ? 1 : 0, u += (h = h + s >>> 0) < s ? 1 : 0, u += (h = h + a >>> 0) < a ? 1 : 0, e + r + i + o + l + (u += (h = h + c >>> 0) < c ? 1 : 0) >>> 0;
                }, r.sum64_5_lo = function(e, t, r, n, i, s, o, a, l, c) {
                    return t + n + s + a + c >>> 0;
                }, r.rotr64_hi = function(e, t, r) {
                    return (t << 32 - r | e >>> r) >>> 0;
                }, r.rotr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                }, r.shr64_hi = function(e, t, r) {
                    return e >>> r;
                }, r.shr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                };
            },
            {
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        438: [
            function(e, t, r) {
                "use strict";
                var n = e("hash.js"), i = e("minimalistic-crypto-utils"), s = e("minimalistic-assert");
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
                    var t = i.toArray(e.entropy, e.entropyEnc || "hex"), r = i.toArray(e.nonce, e.nonceEnc || "hex"), n = i.toArray(e.pers, e.persEnc || "hex");
                    s(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
                }
                t.exports = o, o.prototype._init = function(e, t, r) {
                    var n = e.concat(t).concat(r);
                    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
                    for(var i = 0; i < this.V.length; i++)this.K[i] = 0, this.V[i] = 1;
                    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
                }, o.prototype._hmac = function() {
                    return new n.hmac(this.hash, this.K);
                }, o.prototype._update = function(e) {
                    var t = this._hmac().update(this.V).update([
                        0
                    ]);
                    e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([
                        1
                    ]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
                }, o.prototype.reseed = function(e, t, r, n) {
                    "string" != typeof t && (n = r, r = t, t = null), e = i.toArray(e, t), r = i.toArray(r, n), s(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
                }, o.prototype.generate = function(e, t, r, n) {
                    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
                    "string" != typeof t && (n = r, r = t, t = null), r && (r = i.toArray(r, n || "hex"), this._update(r));
                    for(var s = []; s.length < e;)this.V = this._hmac().update(this.V).digest(), s = s.concat(this.V);
                    var o = s.slice(0, e);
                    return this._update(r), this._reseed++, i.encode(o, t);
                };
            },
            {
                "hash.js": 426,
                "minimalistic-assert": 453,
                "minimalistic-crypto-utils": 454
            }
        ],
        439: [
            function(e, t, r) {
                "use strict";
                /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ r.read = function(e, t, r, n, i) {
                    var s, o, a = 8 * i - n - 1, l = (1 << a) - 1, c = l >> 1, u = -7, h = r ? i - 1 : 0, f = r ? -1 : 1, d = e[t + h];
                    for(h += f, s = d & (1 << -u) - 1, d >>= -u, u += a; u > 0; s = 256 * s + e[t + h], h += f, u -= 8);
                    for(o = s & (1 << -u) - 1, s >>= -u, u += n; u > 0; o = 256 * o + e[t + h], h += f, u -= 8);
                    if (0 === s) s = 1 - c;
                    else {
                        if (s === l) return o ? NaN : 1 / 0 * (d ? -1 : 1);
                        o += Math.pow(2, n), s -= c;
                    }
                    return (d ? -1 : 1) * o * Math.pow(2, s - n);
                }, r.write = function(e, t, r, n, i, s) {
                    var o, a, l, c = 8 * s - i - 1, u = (1 << c) - 1, h = u >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : s - 1, p = n ? 1 : -1, m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (t += o + h >= 1 ? f / l : f * Math.pow(2, 1 - h)) * l >= 2 && (o++, l /= 2), o + h >= u ? (a = 0, o = u) : o + h >= 1 ? (a = (t * l - 1) * Math.pow(2, i), o += h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; e[r + d] = 255 & a, d += p, a /= 256, i -= 8);
                    for(o = o << i | a, c += i; c > 0; e[r + d] = 255 & o, d += p, o /= 256, c -= 8);
                    e[r + d - p] |= 128 * m;
                };
            },
            {}
        ],
        440: [
            function(e, t, r) {
                "use strict";
                "function" == typeof Object.create ? t.exports = function(e, t) {
                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : t.exports = function(e, t) {
                    if (t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                };
            },
            {}
        ],
        441: [
            function(e, t, r) {
                (function(n, i, s, o, a, l, c, u) {
                    (function() {
                        "use strict";
                        /*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ !function(e) {
                            "object" == typeof r && void 0 !== t ? t.exports = e() : ("undefined" != typeof window ? window : void 0 !== i ? i : "undefined" != typeof self ? self : this).JSZip = e();
                        }(function() {
                            return (function t(r, n, i) {
                                function s(a, l) {
                                    if (!n[a]) {
                                        if (!r[a]) {
                                            var c = "function" == typeof e && e;
                                            if (!l && c) return c(a, !0);
                                            if (o) return o(a, !0);
                                            var u = new Error("Cannot find module '" + a + "'");
                                            throw u.code = "MODULE_NOT_FOUND", u;
                                        }
                                        var h = n[a] = {
                                            exports: {}
                                        };
                                        r[a][0].call(h.exports, function(e) {
                                            return s(r[a][1][e] || e);
                                        }, h, h.exports, t, r, n, i);
                                    }
                                    return n[a].exports;
                                }
                                for(var o = "function" == typeof e && e, a = 0; a < i.length; a++)s(i[a]);
                                return s;
                            })({
                                1: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = e("./support"), s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                                        r.encode = function(e) {
                                            for(var t, r, i, o, a, l, c, u = [], h = 0, f = e.length, d = f, p = "string" !== n.getTypeOf(e); h < e.length;)d = f - h, i = p ? (t = e[h++], r = h < f ? e[h++] : 0, h < f ? e[h++] : 0) : (t = e.charCodeAt(h++), r = h < f ? e.charCodeAt(h++) : 0, h < f ? e.charCodeAt(h++) : 0), o = t >> 2, a = (3 & t) << 4 | r >> 4, l = 1 < d ? (15 & r) << 2 | i >> 6 : 64, c = 2 < d ? 63 & i : 64, u.push(s.charAt(o) + s.charAt(a) + s.charAt(l) + s.charAt(c));
                                            return u.join("");
                                        }, r.decode = function(e) {
                                            var t, r, n, o, a, l, c = 0, u = 0, h = "data:";
                                            if (e.substr(0, h.length) === h) throw new Error("Invalid base64 input, it looks like a data url.");
                                            var f, d = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                                            if (e.charAt(e.length - 1) === s.charAt(64) && d--, e.charAt(e.length - 2) === s.charAt(64) && d--, d % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                                            for(f = i.uint8array ? new Uint8Array(0 | d) : new Array(0 | d); c < e.length;)t = s.indexOf(e.charAt(c++)) << 2 | (o = s.indexOf(e.charAt(c++))) >> 4, r = (15 & o) << 4 | (a = s.indexOf(e.charAt(c++))) >> 2, n = (3 & a) << 6 | (l = s.indexOf(e.charAt(c++))), f[u++] = t, 64 !== a && (f[u++] = r), 64 !== l && (f[u++] = n);
                                            return f;
                                        };
                                    },
                                    {
                                        "./support": 30,
                                        "./utils": 32
                                    }
                                ],
                                2: [
                                    function(e, t, r) {
                                        var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), o = e("./stream/DataLengthProbe");
                                        function a(e, t, r, n, i) {
                                            this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                                        }
                                        a.prototype = {
                                            getContentWorker: function() {
                                                var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new o("data_length")), t = this;
                                                return e.on("end", function() {
                                                    if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                                                }), e;
                                            },
                                            getCompressedWorker: function() {
                                                return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                                            }
                                        }, a.createWorkerFrom = function(e, t, r) {
                                            return e.pipe(new s).pipe(new o("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new o("compressedSize")).withStreamInfo("compression", t);
                                        }, t.exports = a;
                                    },
                                    {
                                        "./external": 6,
                                        "./stream/Crc32Probe": 25,
                                        "./stream/DataLengthProbe": 26,
                                        "./stream/DataWorker": 27
                                    }
                                ],
                                3: [
                                    function(e, t, r) {
                                        var n = e("./stream/GenericWorker");
                                        r.STORE = {
                                            magic: "\0\0",
                                            compressWorker: function() {
                                                return new n("STORE compression");
                                            },
                                            uncompressWorker: function() {
                                                return new n("STORE decompression");
                                            }
                                        }, r.DEFLATE = e("./flate");
                                    },
                                    {
                                        "./flate": 7,
                                        "./stream/GenericWorker": 28
                                    }
                                ],
                                4: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = function() {
                                            for(var e, t = [], r = 0; r < 256; r++){
                                                e = r;
                                                for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                t[r] = e;
                                            }
                                            return t;
                                        }();
                                        t.exports = function(e, t) {
                                            return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                                                var s = i, o = 0 + r;
                                                e ^= -1;
                                                for(var a = 0; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t[a])];
                                                return -1 ^ e;
                                            }(0 | t, e, e.length) : function(e, t, r, n) {
                                                var s = i, o = 0 + r;
                                                e ^= -1;
                                                for(var a = 0; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t.charCodeAt(a))];
                                                return -1 ^ e;
                                            }(0 | t, e, e.length) : 0;
                                        };
                                    },
                                    {
                                        "./utils": 32
                                    }
                                ],
                                5: [
                                    function(e, t, r) {
                                        r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
                                    },
                                    {}
                                ],
                                6: [
                                    function(e, t, r) {
                                        var n;
                                        n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                                            Promise: n
                                        };
                                    },
                                    {
                                        lie: 37
                                    }
                                ],
                                7: [
                                    function(e, t, r) {
                                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), o = e("./stream/GenericWorker"), a = n ? "uint8array" : "array";
                                        function l(e, t) {
                                            o.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                                        }
                                        r.magic = "\b\0", s.inherits(l, o), l.prototype.processChunk = function(e) {
                                            this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(a, e.data), !1);
                                        }, l.prototype.flush = function() {
                                            o.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                                        }, l.prototype.cleanUp = function() {
                                            o.prototype.cleanUp.call(this), this._pako = null;
                                        }, l.prototype._createPako = function() {
                                            this._pako = new i[this._pakoAction]({
                                                raw: !0,
                                                level: this._pakoOptions.level || -1
                                            });
                                            var e = this;
                                            this._pako.onData = function(t) {
                                                e.push({
                                                    data: t,
                                                    meta: e.meta
                                                });
                                            };
                                        }, r.compressWorker = function(e) {
                                            return new l("Deflate", e);
                                        }, r.uncompressWorker = function() {
                                            return new l("Inflate", {});
                                        };
                                    },
                                    {
                                        "./stream/GenericWorker": 28,
                                        "./utils": 32,
                                        pako: 38
                                    }
                                ],
                                8: [
                                    function(e, t, r) {
                                        function n(e, t) {
                                            var r, n = "";
                                            for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                                            return n;
                                        }
                                        function i(e, t, r, i, o, u) {
                                            var h, f, d = e.file, p = e.compression, m = u !== a.utf8encode, b = s.transformTo("string", u(d.name)), g = s.transformTo("string", a.utf8encode(d.name)), y = d.comment, v = s.transformTo("string", u(y)), w = s.transformTo("string", a.utf8encode(y)), _ = g.length !== d.name.length, x = w.length !== y.length, k = "", S = "", M = "", C = d.dir, T = d.date, E = {
                                                crc32: 0,
                                                compressedSize: 0,
                                                uncompressedSize: 0
                                            };
                                            t && !r || (E.crc32 = e.crc32, E.compressedSize = e.compressedSize, E.uncompressedSize = e.uncompressedSize);
                                            var A = 0;
                                            t && (A |= 8), m || !_ && !x || (A |= 2048);
                                            var R = 0, O = 0;
                                            C && (R |= 16), "UNIX" === o ? (O = 798, R |= function(e, t) {
                                                var r = e;
                                                return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                                            }(d.unixPermissions, C)) : (O = 20, R |= function(e) {
                                                return 63 & (e || 0);
                                            }(d.dosPermissions)), h = T.getUTCHours(), h <<= 6, h |= T.getUTCMinutes(), h <<= 5, h |= T.getUTCSeconds() / 2, f = T.getUTCFullYear() - 1980, f <<= 4, f |= T.getUTCMonth() + 1, f <<= 5, f |= T.getUTCDate(), _ && (S = n(1, 1) + n(l(b), 4) + g, k += "up" + n(S.length, 2) + S), x && (M = n(1, 1) + n(l(v), 4) + w, k += "uc" + n(M.length, 2) + M);
                                            var j = "";
                                            return j += "\n\0", j += n(A, 2), j += p.magic, j += n(h, 2), j += n(f, 2), j += n(E.crc32, 4), j += n(E.compressedSize, 4), j += n(E.uncompressedSize, 4), j += n(b.length, 2), j += n(k.length, 2), {
                                                fileRecord: c.LOCAL_FILE_HEADER + j + b + k,
                                                dirRecord: c.CENTRAL_FILE_HEADER + n(O, 2) + j + n(v.length, 2) + "\0\0\0\0" + n(R, 4) + n(i, 4) + b + k + v
                                            };
                                        }
                                        var s = e("../utils"), o = e("../stream/GenericWorker"), a = e("../utf8"), l = e("../crc32"), c = e("../signature");
                                        function u(e, t, r, n) {
                                            o.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                                        }
                                        s.inherits(u, o), u.prototype.push = function(e) {
                                            var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                                            this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, o.prototype.push.call(this, {
                                                data: e.data,
                                                meta: {
                                                    currentFile: this.currentFile,
                                                    percent: r ? (t + 100 * (r - n - 1)) / r : 100
                                                }
                                            }));
                                        }, u.prototype.openedSource = function(e) {
                                            this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                                            var t = this.streamFiles && !e.file.dir;
                                            if (t) {
                                                var r = i(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                                this.push({
                                                    data: r.fileRecord,
                                                    meta: {
                                                        percent: 0
                                                    }
                                                });
                                            } else this.accumulate = !0;
                                        }, u.prototype.closedSource = function(e) {
                                            this.accumulate = !1;
                                            var t = this.streamFiles && !e.file.dir, r = i(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                            if (this.dirRecords.push(r.dirRecord), t) this.push({
                                                data: function(e) {
                                                    return c.DATA_DESCRIPTOR + n(e.crc32, 4) + n(e.compressedSize, 4) + n(e.uncompressedSize, 4);
                                                }(e),
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                            else for(this.push({
                                                data: r.fileRecord,
                                                meta: {
                                                    percent: 0
                                                }
                                            }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                                            this.currentFile = null;
                                        }, u.prototype.flush = function() {
                                            for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                                                data: this.dirRecords[t],
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                            var r = this.bytesWritten - e, i = function(e, t, r, i, o) {
                                                var a = s.transformTo("string", o(i));
                                                return c.CENTRAL_DIRECTORY_END + "\0\0\0\0" + n(e, 2) + n(e, 2) + n(t, 4) + n(r, 4) + n(a.length, 2) + a;
                                            }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                                            this.push({
                                                data: i,
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                        }, u.prototype.prepareNextSource = function() {
                                            this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                                        }, u.prototype.registerPrevious = function(e) {
                                            this._sources.push(e);
                                            var t = this;
                                            return e.on("data", function(e) {
                                                t.processChunk(e);
                                            }), e.on("end", function() {
                                                t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                                            }), e.on("error", function(e) {
                                                t.error(e);
                                            }), this;
                                        }, u.prototype.resume = function() {
                                            return !!o.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                                        }, u.prototype.error = function(e) {
                                            var t = this._sources;
                                            if (!o.prototype.error.call(this, e)) return !1;
                                            for(var r = 0; r < t.length; r++)try {
                                                t[r].error(e);
                                            } catch (e) {}
                                            return !0;
                                        }, u.prototype.lock = function() {
                                            o.prototype.lock.call(this);
                                            for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                                        }, t.exports = u;
                                    },
                                    {
                                        "../crc32": 4,
                                        "../signature": 23,
                                        "../stream/GenericWorker": 28,
                                        "../utf8": 31,
                                        "../utils": 32
                                    }
                                ],
                                9: [
                                    function(e, t, r) {
                                        var n = e("../compressions"), i = e("./ZipFileWorker");
                                        r.generateWorker = function(e, t, r) {
                                            var s = new i(t.streamFiles, r, t.platform, t.encodeFileName), o = 0;
                                            try {
                                                e.forEach(function(e, r) {
                                                    o++;
                                                    var i = function(e, t) {
                                                        var r = e || t, i = n[r];
                                                        if (!i) throw new Error(r + " is not a valid compression method !");
                                                        return i;
                                                    }(r.options.compression, t.compression), a = r.options.compressionOptions || t.compressionOptions || {}, l = r.dir, c = r.date;
                                                    r._compressWorker(i, a).withStreamInfo("file", {
                                                        name: e,
                                                        dir: l,
                                                        date: c,
                                                        comment: r.comment || "",
                                                        unixPermissions: r.unixPermissions,
                                                        dosPermissions: r.dosPermissions
                                                    }).pipe(s);
                                                }), s.entriesCount = o;
                                            } catch (e) {
                                                s.error(e);
                                            }
                                            return s;
                                        };
                                    },
                                    {
                                        "../compressions": 3,
                                        "./ZipFileWorker": 8
                                    }
                                ],
                                10: [
                                    function(e, t, r) {
                                        function n() {
                                            if (!(this instanceof n)) return new n;
                                            if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                                            this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                                                var e = new n;
                                                for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                                                return e;
                                            };
                                        }
                                        (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                                            return (new n).loadAsync(e, t);
                                        }, n.external = e("./external"), t.exports = n;
                                    },
                                    {
                                        "./defaults": 5,
                                        "./external": 6,
                                        "./load": 11,
                                        "./object": 15,
                                        "./support": 30
                                    }
                                ],
                                11: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = e("./external"), s = e("./utf8"), o = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                                        function c(e) {
                                            return new i.Promise(function(t, r) {
                                                var n = e.decompressed.getContentWorker().pipe(new a);
                                                n.on("error", function(e) {
                                                    r(e);
                                                }).on("end", function() {
                                                    n.streamInfo.crc32 !== e.decompressed.crc32 ? r(new Error("Corrupted zip : CRC32 mismatch")) : t();
                                                }).resume();
                                            });
                                        }
                                        t.exports = function(e, t) {
                                            var r = this;
                                            return t = n.extend(t || {}, {
                                                base64: !1,
                                                checkCRC32: !1,
                                                optimizedBinaryString: !1,
                                                createFolders: !1,
                                                decodeFileName: s.utf8decode
                                            }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : n.prepareContent("the loaded zip file", e, !0, t.optimizedBinaryString, t.base64).then(function(e) {
                                                var r = new o(t);
                                                return r.load(e), r;
                                            }).then(function(e) {
                                                var r = [
                                                    i.Promise.resolve(e)
                                                ], n = e.files;
                                                if (t.checkCRC32) for(var s = 0; s < n.length; s++)r.push(c(n[s]));
                                                return i.Promise.all(r);
                                            }).then(function(e) {
                                                for(var i = e.shift(), s = i.files, o = 0; o < s.length; o++){
                                                    var a = s[o], l = a.fileNameStr, c = n.resolve(a.fileNameStr);
                                                    r.file(c, a.decompressed, {
                                                        binary: !0,
                                                        optimizedBinaryString: !0,
                                                        date: a.date,
                                                        dir: a.dir,
                                                        comment: a.fileCommentStr.length ? a.fileCommentStr : null,
                                                        unixPermissions: a.unixPermissions,
                                                        dosPermissions: a.dosPermissions,
                                                        createFolders: t.createFolders
                                                    }), a.dir || (r.file(c).unsafeOriginalName = l);
                                                }
                                                return i.zipComment.length && (r.comment = i.zipComment), r;
                                            });
                                        };
                                    },
                                    {
                                        "./external": 6,
                                        "./nodejsUtils": 14,
                                        "./stream/Crc32Probe": 25,
                                        "./utf8": 31,
                                        "./utils": 32,
                                        "./zipEntries": 33
                                    }
                                ],
                                12: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("../stream/GenericWorker");
                                        function s(e, t) {
                                            i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                                        }
                                        n.inherits(s, i), s.prototype._bindStream = function(e) {
                                            var t = this;
                                            (this._stream = e).pause(), e.on("data", function(e) {
                                                t.push({
                                                    data: e,
                                                    meta: {
                                                        percent: 0
                                                    }
                                                });
                                            }).on("error", function(e) {
                                                t.isPaused ? this.generatedError = e : t.error(e);
                                            }).on("end", function() {
                                                t.isPaused ? t._upstreamEnded = !0 : t.end();
                                            });
                                        }, s.prototype.pause = function() {
                                            return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                                        }, s.prototype.resume = function() {
                                            return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../stream/GenericWorker": 28,
                                        "../utils": 32
                                    }
                                ],
                                13: [
                                    function(e, t, r) {
                                        var n = e("readable-stream").Readable;
                                        function i(e, t, r) {
                                            n.call(this, t), this._helper = e;
                                            var i = this;
                                            e.on("data", function(e, t) {
                                                i.push(e) || i._helper.pause(), r && r(t);
                                            }).on("error", function(e) {
                                                i.emit("error", e);
                                            }).on("end", function() {
                                                i.push(null);
                                            });
                                        }
                                        e("../utils").inherits(i, n), i.prototype._read = function() {
                                            this._helper.resume();
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "readable-stream": 16
                                    }
                                ],
                                14: [
                                    function(e, t, r) {
                                        t.exports = {
                                            isNode: void 0 !== s,
                                            newBufferFrom: function(e, t) {
                                                if (s.from && s.from !== Uint8Array.from) return s.from(e, t);
                                                if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                                                return new s(e, t);
                                            },
                                            allocBuffer: function(e) {
                                                if (s.alloc) return s.alloc(e);
                                                var t = new s(e);
                                                return t.fill(0), t;
                                            },
                                            isBuffer: function(e) {
                                                return s.isBuffer(e);
                                            },
                                            isStream: function(e) {
                                                return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                                            }
                                        };
                                    },
                                    {}
                                ],
                                15: [
                                    function(e, t, r) {
                                        function n(e, t, r) {
                                            var n, i = s.getTypeOf(t), a = s.extend(r || {}, l);
                                            a.date = a.date || new Date, null !== a.compression && (a.compression = a.compression.toUpperCase()), "string" == typeof a.unixPermissions && (a.unixPermissions = parseInt(a.unixPermissions, 8)), a.unixPermissions && 16384 & a.unixPermissions && (a.dir = !0), a.dosPermissions && 16 & a.dosPermissions && (a.dir = !0), a.dir && (e = m(e)), a.createFolders && (n = p(e)) && b.call(this, n, !0);
                                            var h = "string" === i && !1 === a.binary && !1 === a.base64;
                                            r && void 0 !== r.binary || (a.binary = !h), (t instanceof c && 0 === t.uncompressedSize || a.dir || !t || 0 === t.length) && (a.base64 = !1, a.binary = !0, t = "", a.compression = "STORE", i = "string");
                                            var g;
                                            g = t instanceof c || t instanceof o ? t : f.isNode && f.isStream(t) ? new d(e, t) : s.prepareContent(e, t, a.binary, a.optimizedBinaryString, a.base64);
                                            var y = new u(e, g, a);
                                            this.files[e] = y;
                                        }
                                        var i = e("./utf8"), s = e("./utils"), o = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), l = e("./defaults"), c = e("./compressedObject"), u = e("./zipObject"), h = e("./generate"), f = e("./nodejsUtils"), d = e("./nodejs/NodejsStreamInputAdapter"), p = function(e) {
                                            "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                                            var t = e.lastIndexOf("/");
                                            return 0 < t ? e.substring(0, t) : "";
                                        }, m = function(e) {
                                            return "/" !== e.slice(-1) && (e += "/"), e;
                                        }, b = function(e, t) {
                                            return t = void 0 !== t ? t : l.createFolders, e = m(e), this.files[e] || n.call(this, e, null, {
                                                dir: !0,
                                                createFolders: t
                                            }), this.files[e];
                                        };
                                        function g(e) {
                                            return "[object RegExp]" === Object.prototype.toString.call(e);
                                        }
                                        var y = {
                                            load: function() {
                                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                            },
                                            forEach: function(e) {
                                                var t, r, n;
                                                for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                                            },
                                            filter: function(e) {
                                                var t = [];
                                                return this.forEach(function(r, n) {
                                                    e(r, n) && t.push(n);
                                                }), t;
                                            },
                                            file: function(e, t, r) {
                                                if (1 !== arguments.length) return e = this.root + e, n.call(this, e, t, r), this;
                                                if (g(e)) {
                                                    var i = e;
                                                    return this.filter(function(e, t) {
                                                        return !t.dir && i.test(e);
                                                    });
                                                }
                                                var s = this.files[this.root + e];
                                                return s && !s.dir ? s : null;
                                            },
                                            folder: function(e) {
                                                if (!e) return this;
                                                if (g(e)) return this.filter(function(t, r) {
                                                    return r.dir && e.test(t);
                                                });
                                                var t = this.root + e, r = b.call(this, t), n = this.clone();
                                                return n.root = r.name, n;
                                            },
                                            remove: function(e) {
                                                e = this.root + e;
                                                var t = this.files[e];
                                                if (t || ("/" !== e.slice(-1) && (e += "/"), t = this.files[e]), t && !t.dir) delete this.files[e];
                                                else for(var r = this.filter(function(t, r) {
                                                    return r.name.slice(0, e.length) === e;
                                                }), n = 0; n < r.length; n++)delete this.files[r[n].name];
                                                return this;
                                            },
                                            generate: function() {
                                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                            },
                                            generateInternalStream: function(e) {
                                                var t, r = {};
                                                try {
                                                    if ((r = s.extend(e || {}, {
                                                        streamFiles: !1,
                                                        compression: "STORE",
                                                        compressionOptions: null,
                                                        type: "",
                                                        platform: "DOS",
                                                        comment: null,
                                                        mimeType: "application/zip",
                                                        encodeFileName: i.utf8encode
                                                    })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                                                    s.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                                                    var n = r.comment || this.comment || "";
                                                    t = h.generateWorker(this, r, n);
                                                } catch (e) {
                                                    (t = new o("error")).error(e);
                                                }
                                                return new a(t, r.type || "string", r.mimeType);
                                            },
                                            generateAsync: function(e, t) {
                                                return this.generateInternalStream(e).accumulate(t);
                                            },
                                            generateNodeStream: function(e, t) {
                                                return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                                            }
                                        };
                                        t.exports = y;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./defaults": 5,
                                        "./generate": 9,
                                        "./nodejs/NodejsStreamInputAdapter": 12,
                                        "./nodejsUtils": 14,
                                        "./stream/GenericWorker": 28,
                                        "./stream/StreamHelper": 29,
                                        "./utf8": 31,
                                        "./utils": 32,
                                        "./zipObject": 35
                                    }
                                ],
                                16: [
                                    function(e, t, r) {
                                        t.exports = e("stream");
                                    },
                                    {
                                        stream: void 0
                                    }
                                ],
                                17: [
                                    function(e, t, r) {
                                        var n = e("./DataReader");
                                        function i(e) {
                                            n.call(this, e);
                                            for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                                        }
                                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                                            return this.data[this.zero + e];
                                        }, i.prototype.lastIndexOfSignature = function(e) {
                                            for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                                            return -1;
                                        }, i.prototype.readAndCheckSignature = function(e) {
                                            var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                                            return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                                        }, i.prototype.readData = function(e) {
                                            if (this.checkOffset(e), 0 === e) return [];
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./DataReader": 18
                                    }
                                ],
                                18: [
                                    function(e, t, r) {
                                        var n = e("../utils");
                                        function i(e) {
                                            this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                                        }
                                        i.prototype = {
                                            checkOffset: function(e) {
                                                this.checkIndex(this.index + e);
                                            },
                                            checkIndex: function(e) {
                                                if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                                            },
                                            setIndex: function(e) {
                                                this.checkIndex(e), this.index = e;
                                            },
                                            skip: function(e) {
                                                this.setIndex(this.index + e);
                                            },
                                            byteAt: function() {},
                                            readInt: function(e) {
                                                var t, r = 0;
                                                for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                                                return this.index += e, r;
                                            },
                                            readString: function(e) {
                                                return n.transformTo("string", this.readData(e));
                                            },
                                            readData: function() {},
                                            lastIndexOfSignature: function() {},
                                            readAndCheckSignature: function() {},
                                            readDate: function() {
                                                var e = this.readInt(4);
                                                return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                                            }
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32
                                    }
                                ],
                                19: [
                                    function(e, t, r) {
                                        var n = e("./Uint8ArrayReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                                            this.checkOffset(e);
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./Uint8ArrayReader": 21
                                    }
                                ],
                                20: [
                                    function(e, t, r) {
                                        var n = e("./DataReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                                            return this.data.charCodeAt(this.zero + e);
                                        }, i.prototype.lastIndexOfSignature = function(e) {
                                            return this.data.lastIndexOf(e) - this.zero;
                                        }, i.prototype.readAndCheckSignature = function(e) {
                                            return e === this.readData(4);
                                        }, i.prototype.readData = function(e) {
                                            this.checkOffset(e);
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./DataReader": 18
                                    }
                                ],
                                21: [
                                    function(e, t, r) {
                                        var n = e("./ArrayReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                                            if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                                            var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./ArrayReader": 17
                                    }
                                ],
                                22: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), o = e("./StringReader"), a = e("./NodeBufferReader"), l = e("./Uint8ArrayReader");
                                        t.exports = function(e) {
                                            var t = n.getTypeOf(e);
                                            return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new a(e) : i.uint8array ? new l(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new o(e);
                                        };
                                    },
                                    {
                                        "../support": 30,
                                        "../utils": 32,
                                        "./ArrayReader": 17,
                                        "./NodeBufferReader": 19,
                                        "./StringReader": 20,
                                        "./Uint8ArrayReader": 21
                                    }
                                ],
                                23: [
                                    function(e, t, r) {
                                        r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
                                    },
                                    {}
                                ],
                                24: [
                                    function(e, t, r) {
                                        var n = e("./GenericWorker"), i = e("../utils");
                                        function s(e) {
                                            n.call(this, "ConvertWorker to " + e), this.destType = e;
                                        }
                                        i.inherits(s, n), s.prototype.processChunk = function(e) {
                                            this.push({
                                                data: i.transformTo(this.destType, e.data),
                                                meta: e.meta
                                            });
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                25: [
                                    function(e, t, r) {
                                        var n = e("./GenericWorker"), i = e("../crc32");
                                        function s() {
                                            n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                                        }
                                        e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                                            this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../crc32": 4,
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                26: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./GenericWorker");
                                        function s(e) {
                                            i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                                        }
                                        n.inherits(s, i), s.prototype.processChunk = function(e) {
                                            if (e) {
                                                var t = this.streamInfo[this.propName] || 0;
                                                this.streamInfo[this.propName] = t + e.data.length;
                                            }
                                            i.prototype.processChunk.call(this, e);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                27: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./GenericWorker");
                                        function s(e) {
                                            i.call(this, "DataWorker");
                                            var t = this;
                                            this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                                                t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                                            }, function(e) {
                                                t.error(e);
                                            });
                                        }
                                        n.inherits(s, i), s.prototype.cleanUp = function() {
                                            i.prototype.cleanUp.call(this), this.data = null;
                                        }, s.prototype.resume = function() {
                                            return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                                        }, s.prototype._tickAndRepeat = function() {
                                            this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                                        }, s.prototype._tick = function() {
                                            if (this.isPaused || this.isFinished) return !1;
                                            var e = null, t = Math.min(this.max, this.index + 16384);
                                            if (this.index >= this.max) return this.end();
                                            switch(this.type){
                                                case "string":
                                                    e = this.data.substring(this.index, t);
                                                    break;
                                                case "uint8array":
                                                    e = this.data.subarray(this.index, t);
                                                    break;
                                                case "array":
                                                case "nodebuffer":
                                                    e = this.data.slice(this.index, t);
                                            }
                                            return this.index = t, this.push({
                                                data: e,
                                                meta: {
                                                    percent: this.max ? this.index / this.max * 100 : 0
                                                }
                                            });
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                28: [
                                    function(e, t, r) {
                                        function n(e) {
                                            this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                                                data: [],
                                                end: [],
                                                error: []
                                            }, this.previous = null;
                                        }
                                        n.prototype = {
                                            push: function(e) {
                                                this.emit("data", e);
                                            },
                                            end: function() {
                                                if (this.isFinished) return !1;
                                                this.flush();
                                                try {
                                                    this.emit("end"), this.cleanUp(), this.isFinished = !0;
                                                } catch (e) {
                                                    this.emit("error", e);
                                                }
                                                return !0;
                                            },
                                            error: function(e) {
                                                return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                                            },
                                            on: function(e, t) {
                                                return this._listeners[e].push(t), this;
                                            },
                                            cleanUp: function() {
                                                this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                                            },
                                            emit: function(e, t) {
                                                if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                                            },
                                            pipe: function(e) {
                                                return e.registerPrevious(this);
                                            },
                                            registerPrevious: function(e) {
                                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                                                var t = this;
                                                return e.on("data", function(e) {
                                                    t.processChunk(e);
                                                }), e.on("end", function() {
                                                    t.end();
                                                }), e.on("error", function(e) {
                                                    t.error(e);
                                                }), this;
                                            },
                                            pause: function() {
                                                return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                                            },
                                            resume: function() {
                                                if (!this.isPaused || this.isFinished) return !1;
                                                var e = this.isPaused = !1;
                                                return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                                            },
                                            flush: function() {},
                                            processChunk: function(e) {
                                                this.push(e);
                                            },
                                            withStreamInfo: function(e, t) {
                                                return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                                            },
                                            mergeStreamInfo: function() {
                                                for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                                            },
                                            lock: function() {
                                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                this.isLocked = !0, this.previous && this.previous.lock();
                                            },
                                            toString: function() {
                                                var e = "Worker " + this.name;
                                                return this.previous ? this.previous + " -> " + e : e;
                                            }
                                        }, t.exports = n;
                                    },
                                    {}
                                ],
                                29: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./ConvertWorker"), o = e("./GenericWorker"), a = e("../base64"), l = e("../support"), c = e("../external"), u = null;
                                        if (l.nodestream) try {
                                            u = e("../nodejs/NodejsStreamOutputAdapter");
                                        } catch (e) {}
                                        function h(e, t, r) {
                                            var s = t;
                                            switch(t){
                                                case "blob":
                                                case "arraybuffer":
                                                    s = "uint8array";
                                                    break;
                                                case "base64":
                                                    s = "string";
                                            }
                                            try {
                                                this._internalType = s, this._outputType = t, this._mimeType = r, n.checkSupport(s), this._worker = e.pipe(new i(s)), e.lock();
                                            } catch (e) {
                                                this._worker = new o("error"), this._worker.error(e);
                                            }
                                        }
                                        h.prototype = {
                                            accumulate: function(e) {
                                                return function(e, t) {
                                                    return new c.Promise(function(r, i) {
                                                        var o = [], l = e._internalType, c = e._outputType, u = e._mimeType;
                                                        e.on("data", function(e, r) {
                                                            o.push(e), t && t(r);
                                                        }).on("error", function(e) {
                                                            o = [], i(e);
                                                        }).on("end", function() {
                                                            try {
                                                                var e = function(e, t, r) {
                                                                    switch(e){
                                                                        case "blob":
                                                                            return n.newBlob(n.transformTo("arraybuffer", t), r);
                                                                        case "base64":
                                                                            return a.encode(t);
                                                                        default:
                                                                            return n.transformTo(e, t);
                                                                    }
                                                                }(c, function(e, t) {
                                                                    var r, n = 0, i = null, o = 0;
                                                                    for(r = 0; r < t.length; r++)o += t[r].length;
                                                                    switch(e){
                                                                        case "string":
                                                                            return t.join("");
                                                                        case "array":
                                                                            return Array.prototype.concat.apply([], t);
                                                                        case "uint8array":
                                                                            for(i = new Uint8Array(o), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                                                            return i;
                                                                        case "nodebuffer":
                                                                            return s.concat(t);
                                                                        default:
                                                                            throw new Error("concat : unsupported type '" + e + "'");
                                                                    }
                                                                }(l, o), u);
                                                                r(e);
                                                            } catch (e) {
                                                                i(e);
                                                            }
                                                            o = [];
                                                        }).resume();
                                                    });
                                                }(this, e);
                                            },
                                            on: function(e, t) {
                                                var r = this;
                                                return "data" === e ? this._worker.on(e, function(e) {
                                                    t.call(r, e.data, e.meta);
                                                }) : this._worker.on(e, function() {
                                                    n.delay(t, arguments, r);
                                                }), this;
                                            },
                                            resume: function() {
                                                return n.delay(this._worker.resume, [], this._worker), this;
                                            },
                                            pause: function() {
                                                return this._worker.pause(), this;
                                            },
                                            toNodejsStream: function(e) {
                                                if (n.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                                                return new u(this, {
                                                    objectMode: "nodebuffer" !== this._outputType
                                                }, e);
                                            }
                                        }, t.exports = h;
                                    },
                                    {
                                        "../base64": 1,
                                        "../external": 6,
                                        "../nodejs/NodejsStreamOutputAdapter": 13,
                                        "../support": 30,
                                        "../utils": 32,
                                        "./ConvertWorker": 24,
                                        "./GenericWorker": 28
                                    }
                                ],
                                30: [
                                    function(e, t, r) {
                                        if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = void 0 !== s, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                                        else {
                                            var n = new ArrayBuffer(0);
                                            try {
                                                r.blob = 0 === new Blob([
                                                    n
                                                ], {
                                                    type: "application/zip"
                                                }).size;
                                            } catch (e) {
                                                try {
                                                    var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                                    i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                                                } catch (e) {
                                                    r.blob = !1;
                                                }
                                            }
                                        }
                                        try {
                                            r.nodestream = !!e("readable-stream").Readable;
                                        } catch (e) {
                                            r.nodestream = !1;
                                        }
                                    },
                                    {
                                        "readable-stream": 16
                                    }
                                ],
                                31: [
                                    function(e, t, r) {
                                        for(var n = e("./utils"), i = e("./support"), s = e("./nodejsUtils"), o = e("./stream/GenericWorker"), a = new Array(256), l = 0; l < 256; l++)a[l] = 252 <= l ? 6 : 248 <= l ? 5 : 240 <= l ? 4 : 224 <= l ? 3 : 192 <= l ? 2 : 1;
                                        function c() {
                                            o.call(this, "utf-8 decode"), this.leftOver = null;
                                        }
                                        function u() {
                                            o.call(this, "utf-8 encode");
                                        }
                                        a[254] = a[254] = 1, r.utf8encode = function(e) {
                                            return i.nodebuffer ? s.newBufferFrom(e, "utf-8") : function(e) {
                                                var t, r, n, s, o, a = e.length, l = 0;
                                                for(s = 0; s < a; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (n = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), s++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                                                for(t = i.uint8array ? new Uint8Array(l) : new Array(l), s = o = 0; o < l; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (n = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), s++), r < 128 ? t[o++] = r : (r < 2048 ? t[o++] = 192 | r >>> 6 : (r < 65536 ? t[o++] = 224 | r >>> 12 : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63), t[o++] = 128 | r >>> 6 & 63), t[o++] = 128 | 63 & r);
                                                return t;
                                            }(e);
                                        }, r.utf8decode = function(e) {
                                            return i.nodebuffer ? n.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                                                var t, r, i, s, o = e.length, l = new Array(2 * o);
                                                for(t = r = 0; t < o;)if ((i = e[t++]) < 128) l[r++] = i;
                                                else if (4 < (s = a[i])) l[r++] = 65533, t += s - 1;
                                                else {
                                                    for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && t < o;)i = i << 6 | 63 & e[t++], s--;
                                                    1 < s ? l[r++] = 65533 : i < 65536 ? l[r++] = i : (i -= 65536, l[r++] = 55296 | i >> 10 & 1023, l[r++] = 56320 | 1023 & i);
                                                }
                                                return l.length !== r && (l.subarray ? l = l.subarray(0, r) : l.length = r), n.applyFromCharCode(l);
                                            }(e = n.transformTo(i.uint8array ? "uint8array" : "array", e));
                                        }, n.inherits(c, o), c.prototype.processChunk = function(e) {
                                            var t = n.transformTo(i.uint8array ? "uint8array" : "array", e.data);
                                            if (this.leftOver && this.leftOver.length) {
                                                if (i.uint8array) {
                                                    var s = t;
                                                    (t = new Uint8Array(s.length + this.leftOver.length)).set(this.leftOver, 0), t.set(s, this.leftOver.length);
                                                } else t = this.leftOver.concat(t);
                                                this.leftOver = null;
                                            }
                                            var o = function(e, t) {
                                                var r;
                                                for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                                                return r < 0 || 0 === r ? t : r + a[e[r]] > t ? r : t;
                                            }(t), l = t;
                                            o !== t.length && (i.uint8array ? (l = t.subarray(0, o), this.leftOver = t.subarray(o, t.length)) : (l = t.slice(0, o), this.leftOver = t.slice(o, t.length))), this.push({
                                                data: r.utf8decode(l),
                                                meta: e.meta
                                            });
                                        }, c.prototype.flush = function() {
                                            this.leftOver && this.leftOver.length && (this.push({
                                                data: r.utf8decode(this.leftOver),
                                                meta: {}
                                            }), this.leftOver = null);
                                        }, r.Utf8DecodeWorker = c, n.inherits(u, o), u.prototype.processChunk = function(e) {
                                            this.push({
                                                data: r.utf8encode(e.data),
                                                meta: e.meta
                                            });
                                        }, r.Utf8EncodeWorker = u;
                                    },
                                    {
                                        "./nodejsUtils": 14,
                                        "./stream/GenericWorker": 28,
                                        "./support": 30,
                                        "./utils": 32
                                    }
                                ],
                                32: [
                                    function(e, t, r) {
                                        var n = e("./support"), i = e("./base64"), s = e("./nodejsUtils"), o = e("./external");
                                        function a(e) {
                                            return e;
                                        }
                                        function l(e, t) {
                                            for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                                            return t;
                                        }
                                        e("setimmediate"), r.newBlob = function(e, t) {
                                            r.checkSupport("blob");
                                            try {
                                                return new Blob([
                                                    e
                                                ], {
                                                    type: t
                                                });
                                            } catch (r) {
                                                try {
                                                    var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                                    return n.append(e), n.getBlob(t);
                                                } catch (e) {
                                                    throw new Error("Bug : can't construct the Blob.");
                                                }
                                            }
                                        };
                                        var c = {
                                            stringifyByChunk: function(e, t, r) {
                                                var n = [], i = 0, s = e.length;
                                                if (s <= r) return String.fromCharCode.apply(null, e);
                                                for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                                                return n.join("");
                                            },
                                            stringifyByChar: function(e) {
                                                for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                                                return t;
                                            },
                                            applyCanBeUsed: {
                                                uint8array: function() {
                                                    try {
                                                        return n.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }(),
                                                nodebuffer: function() {
                                                    try {
                                                        return n.nodebuffer && 1 === String.fromCharCode.apply(null, s.allocBuffer(1)).length;
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }()
                                            }
                                        };
                                        function h(e) {
                                            var t = 65536, n = r.getTypeOf(e), i = !0;
                                            if ("uint8array" === n ? i = c.applyCanBeUsed.uint8array : "nodebuffer" === n && (i = c.applyCanBeUsed.nodebuffer), i) for(; 1 < t;)try {
                                                return c.stringifyByChunk(e, n, t);
                                            } catch (e) {
                                                t = Math.floor(t / 2);
                                            }
                                            return c.stringifyByChar(e);
                                        }
                                        function f(e, t) {
                                            for(var r = 0; r < e.length; r++)t[r] = e[r];
                                            return t;
                                        }
                                        r.applyFromCharCode = h;
                                        var d = {};
                                        d.string = {
                                            string: a,
                                            array: function(e) {
                                                return l(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return d.string.uint8array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return l(e, new Uint8Array(e.length));
                                            },
                                            nodebuffer: function(e) {
                                                return l(e, s.allocBuffer(e.length));
                                            }
                                        }, d.array = {
                                            string: h,
                                            array: a,
                                            arraybuffer: function(e) {
                                                return new Uint8Array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return new Uint8Array(e);
                                            },
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(e);
                                            }
                                        }, d.arraybuffer = {
                                            string: function(e) {
                                                return h(new Uint8Array(e));
                                            },
                                            array: function(e) {
                                                return f(new Uint8Array(e), new Array(e.byteLength));
                                            },
                                            arraybuffer: a,
                                            uint8array: function(e) {
                                                return new Uint8Array(e);
                                            },
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(new Uint8Array(e));
                                            }
                                        }, d.uint8array = {
                                            string: h,
                                            array: function(e) {
                                                return f(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return e.buffer;
                                            },
                                            uint8array: a,
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(e);
                                            }
                                        }, d.nodebuffer = {
                                            string: h,
                                            array: function(e) {
                                                return f(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return d.nodebuffer.uint8array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return f(e, new Uint8Array(e.length));
                                            },
                                            nodebuffer: a
                                        }, r.transformTo = function(e, t) {
                                            if (t = t || "", !e) return t;
                                            r.checkSupport(e);
                                            var n = r.getTypeOf(t);
                                            return d[n][e](t);
                                        }, r.resolve = function(e) {
                                            for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                                                var i = t[n];
                                                "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                                            }
                                            return r.join("/");
                                        }, r.getTypeOf = function(e) {
                                            return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : n.nodebuffer && s.isBuffer(e) ? "nodebuffer" : n.uint8array && e instanceof Uint8Array ? "uint8array" : n.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                                        }, r.checkSupport = function(e) {
                                            if (!n[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                                        }, r.MAX_VALUE_16BITS = 65535, r.MAX_VALUE_32BITS = -1, r.pretty = function(e) {
                                            var t, r, n = "";
                                            for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                                            return n;
                                        }, r.delay = function(e, t, r) {
                                            u(function() {
                                                e.apply(r || null, t || []);
                                            });
                                        }, r.inherits = function(e, t) {
                                            function r() {}
                                            r.prototype = t.prototype, e.prototype = new r;
                                        }, r.extend = function() {
                                            var e, t, r = {};
                                            for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                                            return r;
                                        }, r.prepareContent = function(e, t, s, a, c) {
                                            return o.Promise.resolve(t).then(function(e) {
                                                return n.blob && (e instanceof Blob || -1 !== [
                                                    "[object File]",
                                                    "[object Blob]"
                                                ].indexOf(Object.prototype.toString.call(e))) && "undefined" != typeof FileReader ? new o.Promise(function(t, r) {
                                                    var n = new FileReader;
                                                    n.onload = function(e) {
                                                        t(e.target.result);
                                                    }, n.onerror = function(e) {
                                                        r(e.target.error);
                                                    }, n.readAsArrayBuffer(e);
                                                }) : e;
                                            }).then(function(t) {
                                                var u = r.getTypeOf(t);
                                                return u ? ("arraybuffer" === u ? t = r.transformTo("uint8array", t) : "string" === u && (c ? t = i.decode(t) : s && !0 !== a && (t = function(e) {
                                                    return l(e, n.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                                                }(t))), t) : o.Promise.reject(new Error("Can't read the data of '" + e + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                                            });
                                        };
                                    },
                                    {
                                        "./base64": 1,
                                        "./external": 6,
                                        "./nodejsUtils": 14,
                                        "./support": 30,
                                        setimmediate: 54
                                    }
                                ],
                                33: [
                                    function(e, t, r) {
                                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), o = e("./zipEntry"), a = e("./support");
                                        function l(e) {
                                            this.files = [], this.loadOptions = e;
                                        }
                                        l.prototype = {
                                            checkSignature: function(e) {
                                                if (!this.reader.readAndCheckSignature(e)) {
                                                    this.reader.index -= 4;
                                                    var t = this.reader.readString(4);
                                                    throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                                                }
                                            },
                                            isSignature: function(e, t) {
                                                var r = this.reader.index;
                                                this.reader.setIndex(e);
                                                var n = this.reader.readString(4) === t;
                                                return this.reader.setIndex(r), n;
                                            },
                                            readBlockEndOfCentral: function() {
                                                this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                                                var e = this.reader.readData(this.zipCommentLength), t = a.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                                                this.zipComment = this.loadOptions.decodeFileName(r);
                                            },
                                            readBlockZip64EndOfCentral: function() {
                                                this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                                                for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                                                    id: e,
                                                    length: t,
                                                    value: r
                                                };
                                            },
                                            readBlockZip64EndOfCentralLocator: function() {
                                                if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                                            },
                                            readLocalFiles: function() {
                                                var e, t;
                                                for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                                            },
                                            readCentralDir: function() {
                                                var e;
                                                for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new o({
                                                    zip64: this.zip64
                                                }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                                                if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                                            },
                                            readEndOfCentral: function() {
                                                var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                                                if (e < 0) throw this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
                                                this.reader.setIndex(e);
                                                var t = e;
                                                if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                                                    if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                                                    if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                                                    this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                                                }
                                                var r = this.centralDirOffset + this.centralDirSize;
                                                this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                                                var n = t - r;
                                                if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                                                else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                                            },
                                            prepareReader: function(e) {
                                                this.reader = n(e);
                                            },
                                            load: function(e) {
                                                this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                                            }
                                        }, t.exports = l;
                                    },
                                    {
                                        "./reader/readerFor": 22,
                                        "./signature": 23,
                                        "./support": 30,
                                        "./utils": 32,
                                        "./zipEntry": 34
                                    }
                                ],
                                34: [
                                    function(e, t, r) {
                                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./compressedObject"), o = e("./crc32"), a = e("./utf8"), l = e("./compressions"), c = e("./support");
                                        function u(e, t) {
                                            this.options = e, this.loadOptions = t;
                                        }
                                        u.prototype = {
                                            isEncrypted: function() {
                                                return 1 == (1 & this.bitFlag);
                                            },
                                            useUTF8: function() {
                                                return 2048 == (2048 & this.bitFlag);
                                            },
                                            readLocalPart: function(e) {
                                                var t, r;
                                                if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                                                if (null === (t = function(e) {
                                                    for(var t in l)if (Object.prototype.hasOwnProperty.call(l, t) && l[t].magic === e) return l[t];
                                                    return null;
                                                }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + i.pretty(this.compressionMethod) + " unknown (inner file : " + i.transformTo("string", this.fileName) + ")");
                                                this.decompressed = new s(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                                            },
                                            readCentralPart: function(e) {
                                                this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                                                var t = e.readInt(2);
                                                if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                                                e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                                            },
                                            processAttributes: function() {
                                                this.unixPermissions = null, this.dosPermissions = null;
                                                var e = this.versionMadeBy >> 8;
                                                this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                                            },
                                            parseZIP64ExtraField: function() {
                                                if (this.extraFields[1]) {
                                                    var e = n(this.extraFields[1].value);
                                                    this.uncompressedSize === i.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === i.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === i.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === i.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                                                }
                                            },
                                            readExtraFields: function(e) {
                                                var t, r, n, i = e.index + this.extraFieldsLength;
                                                for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                                                    id: t,
                                                    length: r,
                                                    value: n
                                                };
                                                e.setIndex(i);
                                            },
                                            handleUTF8: function() {
                                                var e = c.uint8array ? "uint8array" : "array";
                                                if (this.useUTF8()) this.fileNameStr = a.utf8decode(this.fileName), this.fileCommentStr = a.utf8decode(this.fileComment);
                                                else {
                                                    var t = this.findExtraFieldUnicodePath();
                                                    if (null !== t) this.fileNameStr = t;
                                                    else {
                                                        var r = i.transformTo(e, this.fileName);
                                                        this.fileNameStr = this.loadOptions.decodeFileName(r);
                                                    }
                                                    var n = this.findExtraFieldUnicodeComment();
                                                    if (null !== n) this.fileCommentStr = n;
                                                    else {
                                                        var s = i.transformTo(e, this.fileComment);
                                                        this.fileCommentStr = this.loadOptions.decodeFileName(s);
                                                    }
                                                }
                                            },
                                            findExtraFieldUnicodePath: function() {
                                                var e = this.extraFields[28789];
                                                if (e) {
                                                    var t = n(e.value);
                                                    return 1 !== t.readInt(1) || o(this.fileName) !== t.readInt(4) ? null : a.utf8decode(t.readData(e.length - 5));
                                                }
                                                return null;
                                            },
                                            findExtraFieldUnicodeComment: function() {
                                                var e = this.extraFields[25461];
                                                if (e) {
                                                    var t = n(e.value);
                                                    return 1 !== t.readInt(1) || o(this.fileComment) !== t.readInt(4) ? null : a.utf8decode(t.readData(e.length - 5));
                                                }
                                                return null;
                                            }
                                        }, t.exports = u;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./compressions": 3,
                                        "./crc32": 4,
                                        "./reader/readerFor": 22,
                                        "./support": 30,
                                        "./utf8": 31,
                                        "./utils": 32
                                    }
                                ],
                                35: [
                                    function(e, t, r) {
                                        function n(e, t, r) {
                                            this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                                                compression: r.compression,
                                                compressionOptions: r.compressionOptions
                                            };
                                        }
                                        var i = e("./stream/StreamHelper"), s = e("./stream/DataWorker"), o = e("./utf8"), a = e("./compressedObject"), l = e("./stream/GenericWorker");
                                        n.prototype = {
                                            internalStream: function(e) {
                                                var t = null, r = "string";
                                                try {
                                                    if (!e) throw new Error("No output type specified.");
                                                    var n = "string" === (r = e.toLowerCase()) || "text" === r;
                                                    "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                                                    var s = !this._dataBinary;
                                                    s && !n && (t = t.pipe(new o.Utf8EncodeWorker)), !s && n && (t = t.pipe(new o.Utf8DecodeWorker));
                                                } catch (e) {
                                                    (t = new l("error")).error(e);
                                                }
                                                return new i(t, r, "");
                                            },
                                            async: function(e, t) {
                                                return this.internalStream(e).accumulate(t);
                                            },
                                            nodeStream: function(e, t) {
                                                return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                                            },
                                            _compressWorker: function(e, t) {
                                                if (this._data instanceof a && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                                                var r = this._decompressWorker();
                                                return this._dataBinary || (r = r.pipe(new o.Utf8EncodeWorker)), a.createWorkerFrom(r, e, t);
                                            },
                                            _decompressWorker: function() {
                                                return this._data instanceof a ? this._data.getContentWorker() : this._data instanceof l ? this._data : new s(this._data);
                                            }
                                        };
                                        for(var c = [
                                            "asText",
                                            "asBinary",
                                            "asNodeBuffer",
                                            "asUint8Array",
                                            "asArrayBuffer"
                                        ], u = function() {
                                            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                        }, h = 0; h < c.length; h++)n.prototype[c[h]] = u;
                                        t.exports = n;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./stream/DataWorker": 27,
                                        "./stream/GenericWorker": 28,
                                        "./stream/StreamHelper": 29,
                                        "./utf8": 31
                                    }
                                ],
                                36: [
                                    function(e, t, r) {
                                        (function(e) {
                                            var r, n, i = e.MutationObserver || e.WebKitMutationObserver;
                                            if (i) {
                                                var s = 0, o = new i(u), a = e.document.createTextNode("");
                                                o.observe(a, {
                                                    characterData: !0
                                                }), r = function() {
                                                    a.data = s = ++s % 2;
                                                };
                                            } else if (e.setImmediate || void 0 === e.MessageChannel) r = "document" in e && "onreadystatechange" in e.document.createElement("script") ? function() {
                                                var t = e.document.createElement("script");
                                                t.onreadystatechange = function() {
                                                    u(), t.onreadystatechange = null, t.parentNode.removeChild(t), t = null;
                                                }, e.document.documentElement.appendChild(t);
                                            } : function() {
                                                setTimeout(u, 0);
                                            };
                                            else {
                                                var l = new e.MessageChannel;
                                                l.port1.onmessage = u, r = function() {
                                                    l.port2.postMessage(0);
                                                };
                                            }
                                            var c = [];
                                            function u() {
                                                var e, t;
                                                n = !0;
                                                for(var r = c.length; r;){
                                                    for(t = c, c = [], e = -1; ++e < r;)t[e]();
                                                    r = c.length;
                                                }
                                                n = !1;
                                            }
                                            t.exports = function(e) {
                                                1 !== c.push(e) || n || r();
                                            };
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ],
                                37: [
                                    function(e, t, r) {
                                        var n = e("immediate");
                                        function i() {}
                                        var s = {}, o = [
                                            "REJECTED"
                                        ], a = [
                                            "FULFILLED"
                                        ], l = [
                                            "PENDING"
                                        ];
                                        function c(e) {
                                            if ("function" != typeof e) throw new TypeError("resolver must be a function");
                                            this.state = l, this.queue = [], this.outcome = void 0, e !== i && d(this, e);
                                        }
                                        function u(e, t, r) {
                                            this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                                        }
                                        function h(e, t, r) {
                                            n(function() {
                                                var n;
                                                try {
                                                    n = t(r);
                                                } catch (n) {
                                                    return s.reject(e, n);
                                                }
                                                n === e ? s.reject(e, new TypeError("Cannot resolve promise with itself")) : s.resolve(e, n);
                                            });
                                        }
                                        function f(e) {
                                            var t = e && e.then;
                                            if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                                                t.apply(e, arguments);
                                            };
                                        }
                                        function d(e, t) {
                                            var r = !1;
                                            function n(t) {
                                                r || (r = !0, s.reject(e, t));
                                            }
                                            function i(t) {
                                                r || (r = !0, s.resolve(e, t));
                                            }
                                            var o = p(function() {
                                                t(i, n);
                                            });
                                            "error" === o.status && n(o.value);
                                        }
                                        function p(e, t) {
                                            var r = {};
                                            try {
                                                r.value = e(t), r.status = "success";
                                            } catch (e) {
                                                r.status = "error", r.value = e;
                                            }
                                            return r;
                                        }
                                        (t.exports = c).prototype.finally = function(e) {
                                            if ("function" != typeof e) return this;
                                            var t = this.constructor;
                                            return this.then(function(r) {
                                                return t.resolve(e()).then(function() {
                                                    return r;
                                                });
                                            }, function(r) {
                                                return t.resolve(e()).then(function() {
                                                    throw r;
                                                });
                                            });
                                        }, c.prototype.catch = function(e) {
                                            return this.then(null, e);
                                        }, c.prototype.then = function(e, t) {
                                            if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === o) return this;
                                            var r = new this.constructor(i);
                                            return this.state !== l ? h(r, this.state === a ? e : t, this.outcome) : this.queue.push(new u(r, e, t)), r;
                                        }, u.prototype.callFulfilled = function(e) {
                                            s.resolve(this.promise, e);
                                        }, u.prototype.otherCallFulfilled = function(e) {
                                            h(this.promise, this.onFulfilled, e);
                                        }, u.prototype.callRejected = function(e) {
                                            s.reject(this.promise, e);
                                        }, u.prototype.otherCallRejected = function(e) {
                                            h(this.promise, this.onRejected, e);
                                        }, s.resolve = function(e, t) {
                                            var r = p(f, t);
                                            if ("error" === r.status) return s.reject(e, r.value);
                                            var n = r.value;
                                            if (n) d(e, n);
                                            else {
                                                e.state = a, e.outcome = t;
                                                for(var i = -1, o = e.queue.length; ++i < o;)e.queue[i].callFulfilled(t);
                                            }
                                            return e;
                                        }, s.reject = function(e, t) {
                                            e.state = o, e.outcome = t;
                                            for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                                            return e;
                                        }, c.resolve = function(e) {
                                            return e instanceof this ? e : s.resolve(new this(i), e);
                                        }, c.reject = function(e) {
                                            var t = new this(i);
                                            return s.reject(t, e);
                                        }, c.all = function(e) {
                                            var t = this;
                                            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                            var r = e.length, n = !1;
                                            if (!r) return this.resolve([]);
                                            for(var o = new Array(r), a = 0, l = -1, c = new this(i); ++l < r;)u(e[l], l);
                                            return c;
                                            function u(e, i) {
                                                t.resolve(e).then(function(e) {
                                                    o[i] = e, ++a !== r || n || (n = !0, s.resolve(c, o));
                                                }, function(e) {
                                                    n || (n = !0, s.reject(c, e));
                                                });
                                            }
                                        }, c.race = function(e) {
                                            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                            var t = e.length, r = !1;
                                            if (!t) return this.resolve([]);
                                            for(var n, o = -1, a = new this(i); ++o < t;)n = e[o], this.resolve(n).then(function(e) {
                                                r || (r = !0, s.resolve(a, e));
                                            }, function(e) {
                                                r || (r = !0, s.reject(a, e));
                                            });
                                            return a;
                                        };
                                    },
                                    {
                                        immediate: 36
                                    }
                                ],
                                38: [
                                    function(e, t, r) {
                                        var n = {};
                                        (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
                                    },
                                    {
                                        "./lib/deflate": 39,
                                        "./lib/inflate": 40,
                                        "./lib/utils/common": 41,
                                        "./lib/zlib/constants": 44
                                    }
                                ],
                                39: [
                                    function(e, t, r) {
                                        var n = e("./zlib/deflate"), i = e("./utils/common"), s = e("./utils/strings"), o = e("./zlib/messages"), a = e("./zlib/zstream"), l = Object.prototype.toString;
                                        function c(e) {
                                            if (!(this instanceof c)) return new c(e);
                                            this.options = i.assign({
                                                level: -1,
                                                method: 8,
                                                chunkSize: 16384,
                                                windowBits: 15,
                                                memLevel: 8,
                                                strategy: 0,
                                                to: ""
                                            }, e || {});
                                            var t = this.options;
                                            t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new a, this.strm.avail_out = 0;
                                            var r = n.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                                            if (0 !== r) throw new Error(o[r]);
                                            if (t.header && n.deflateSetHeader(this.strm, t.header), t.dictionary) {
                                                var u;
                                                if (u = "string" == typeof t.dictionary ? s.string2buf(t.dictionary) : "[object ArrayBuffer]" === l.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, 0 !== (r = n.deflateSetDictionary(this.strm, u))) throw new Error(o[r]);
                                                this._dict_set = !0;
                                            }
                                        }
                                        function u(e, t) {
                                            var r = new c(t);
                                            if (r.push(e, !0), r.err) throw r.msg || o[r.err];
                                            return r.result;
                                        }
                                        c.prototype.push = function(e, t) {
                                            var r, o, a = this.strm, c = this.options.chunkSize;
                                            if (this.ended) return !1;
                                            o = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? a.input = s.string2buf(e) : "[object ArrayBuffer]" === l.call(e) ? a.input = new Uint8Array(e) : a.input = e, a.next_in = 0, a.avail_in = a.input.length;
                                            do {
                                                if (0 === a.avail_out && (a.output = new i.Buf8(c), a.next_out = 0, a.avail_out = c), 1 !== (r = n.deflate(a, o)) && 0 !== r) return this.onEnd(r), this.ended = !0, false;
                                                0 !== a.avail_out && (0 !== a.avail_in || 4 !== o && 2 !== o) || ("string" === this.options.to ? this.onData(s.buf2binstring(i.shrinkBuf(a.output, a.next_out))) : this.onData(i.shrinkBuf(a.output, a.next_out)));
                                            }while ((0 < a.avail_in || 0 === a.avail_out) && 1 !== r);
                                            return 4 === o ? (r = n.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, 0 === r) : 2 !== o || (this.onEnd(0), a.avail_out = 0, true);
                                        }, c.prototype.onData = function(e) {
                                            this.chunks.push(e);
                                        }, c.prototype.onEnd = function(e) {
                                            0 === e && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                        }, r.Deflate = c, r.deflate = u, r.deflateRaw = function(e, t) {
                                            return (t = t || {}).raw = !0, u(e, t);
                                        }, r.gzip = function(e, t) {
                                            return (t = t || {}).gzip = !0, u(e, t);
                                        };
                                    },
                                    {
                                        "./utils/common": 41,
                                        "./utils/strings": 42,
                                        "./zlib/deflate": 46,
                                        "./zlib/messages": 51,
                                        "./zlib/zstream": 53
                                    }
                                ],
                                40: [
                                    function(e, t, r) {
                                        var n = e("./zlib/inflate"), i = e("./utils/common"), s = e("./utils/strings"), o = e("./zlib/constants"), a = e("./zlib/messages"), l = e("./zlib/zstream"), c = e("./zlib/gzheader"), u = Object.prototype.toString;
                                        function h(e) {
                                            if (!(this instanceof h)) return new h(e);
                                            this.options = i.assign({
                                                chunkSize: 16384,
                                                windowBits: 0,
                                                to: ""
                                            }, e || {});
                                            var t = this.options;
                                            t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new l, this.strm.avail_out = 0;
                                            var r = n.inflateInit2(this.strm, t.windowBits);
                                            if (r !== o.Z_OK) throw new Error(a[r]);
                                            this.header = new c, n.inflateGetHeader(this.strm, this.header);
                                        }
                                        function f(e, t) {
                                            var r = new h(t);
                                            if (r.push(e, !0), r.err) throw r.msg || a[r.err];
                                            return r.result;
                                        }
                                        h.prototype.push = function(e, t) {
                                            var r, a, l, c, h, f, d = this.strm, p = this.options.chunkSize, m = this.options.dictionary, b = !1;
                                            if (this.ended) return !1;
                                            a = t === ~~t ? t : !0 === t ? o.Z_FINISH : o.Z_NO_FLUSH, "string" == typeof e ? d.input = s.binstring2buf(e) : "[object ArrayBuffer]" === u.call(e) ? d.input = new Uint8Array(e) : d.input = e, d.next_in = 0, d.avail_in = d.input.length;
                                            do {
                                                if (0 === d.avail_out && (d.output = new i.Buf8(p), d.next_out = 0, d.avail_out = p), (r = n.inflate(d, o.Z_NO_FLUSH)) === o.Z_NEED_DICT && m && (f = "string" == typeof m ? s.string2buf(m) : "[object ArrayBuffer]" === u.call(m) ? new Uint8Array(m) : m, r = n.inflateSetDictionary(this.strm, f)), r === o.Z_BUF_ERROR && !0 === b && (r = o.Z_OK, b = !1), r !== o.Z_STREAM_END && r !== o.Z_OK) return this.onEnd(r), this.ended = !0, false;
                                                d.next_out && (0 !== d.avail_out && r !== o.Z_STREAM_END && (0 !== d.avail_in || a !== o.Z_FINISH && a !== o.Z_SYNC_FLUSH) || ("string" === this.options.to ? (l = s.utf8border(d.output, d.next_out), c = d.next_out - l, h = s.buf2string(d.output, l), d.next_out = c, d.avail_out = p - c, c && i.arraySet(d.output, d.output, l, c, 0), this.onData(h)) : this.onData(i.shrinkBuf(d.output, d.next_out)))), 0 === d.avail_in && 0 === d.avail_out && (b = !0);
                                            }while ((0 < d.avail_in || 0 === d.avail_out) && r !== o.Z_STREAM_END);
                                            return r === o.Z_STREAM_END && (a = o.Z_FINISH), a === o.Z_FINISH ? (r = n.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === o.Z_OK) : a !== o.Z_SYNC_FLUSH || (this.onEnd(o.Z_OK), d.avail_out = 0, true);
                                        }, h.prototype.onData = function(e) {
                                            this.chunks.push(e);
                                        }, h.prototype.onEnd = function(e) {
                                            e === o.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                        }, r.Inflate = h, r.inflate = f, r.inflateRaw = function(e, t) {
                                            return (t = t || {}).raw = !0, f(e, t);
                                        }, r.ungzip = f;
                                    },
                                    {
                                        "./utils/common": 41,
                                        "./utils/strings": 42,
                                        "./zlib/constants": 44,
                                        "./zlib/gzheader": 47,
                                        "./zlib/inflate": 49,
                                        "./zlib/messages": 51,
                                        "./zlib/zstream": 53
                                    }
                                ],
                                41: [
                                    function(e, t, r) {
                                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                                        r.assign = function(e) {
                                            for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                                                var r = t.shift();
                                                if (r) {
                                                    if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                                                    for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                                                }
                                            }
                                            return e;
                                        }, r.shrinkBuf = function(e, t) {
                                            return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                                        };
                                        var i = {
                                            arraySet: function(e, t, r, n, i) {
                                                if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                                                else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                                            },
                                            flattenChunks: function(e) {
                                                var t, r, n, i, s, o;
                                                for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                                                for(o = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], o.set(s, i), i += s.length;
                                                return o;
                                            }
                                        }, s = {
                                            arraySet: function(e, t, r, n, i) {
                                                for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                                            },
                                            flattenChunks: function(e) {
                                                return [].concat.apply([], e);
                                            }
                                        };
                                        r.setTyped = function(e) {
                                            e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                                        }, r.setTyped(n);
                                    },
                                    {}
                                ],
                                42: [
                                    function(e, t, r) {
                                        var n = e("./common"), i = !0, s = !0;
                                        try {
                                            String.fromCharCode.apply(null, [
                                                0
                                            ]);
                                        } catch (e) {
                                            i = !1;
                                        }
                                        try {
                                            String.fromCharCode.apply(null, new Uint8Array(1));
                                        } catch (e) {
                                            s = !1;
                                        }
                                        for(var o = new n.Buf8(256), a = 0; a < 256; a++)o[a] = 252 <= a ? 6 : 248 <= a ? 5 : 240 <= a ? 4 : 224 <= a ? 3 : 192 <= a ? 2 : 1;
                                        function l(e, t) {
                                            if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, n.shrinkBuf(e, t));
                                            for(var r = "", o = 0; o < t; o++)r += String.fromCharCode(e[o]);
                                            return r;
                                        }
                                        o[254] = o[254] = 1, r.string2buf = function(e) {
                                            var t, r, i, s, o, a = e.length, l = 0;
                                            for(s = 0; s < a; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (i = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), s++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                                            for(t = new n.Buf8(l), s = o = 0; o < l; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (i = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), s++), r < 128 ? t[o++] = r : (r < 2048 ? t[o++] = 192 | r >>> 6 : (r < 65536 ? t[o++] = 224 | r >>> 12 : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63), t[o++] = 128 | r >>> 6 & 63), t[o++] = 128 | 63 & r);
                                            return t;
                                        }, r.buf2binstring = function(e) {
                                            return l(e, e.length);
                                        }, r.binstring2buf = function(e) {
                                            for(var t = new n.Buf8(e.length), r = 0, i = t.length; r < i; r++)t[r] = e.charCodeAt(r);
                                            return t;
                                        }, r.buf2string = function(e, t) {
                                            var r, n, i, s, a = t || e.length, c = new Array(2 * a);
                                            for(r = n = 0; r < a;)if ((i = e[r++]) < 128) c[n++] = i;
                                            else if (4 < (s = o[i])) c[n++] = 65533, r += s - 1;
                                            else {
                                                for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                                                1 < s ? c[n++] = 65533 : i < 65536 ? c[n++] = i : (i -= 65536, c[n++] = 55296 | i >> 10 & 1023, c[n++] = 56320 | 1023 & i);
                                            }
                                            return l(c, n);
                                        }, r.utf8border = function(e, t) {
                                            var r;
                                            for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                                            return r < 0 || 0 === r ? t : r + o[e[r]] > t ? r : t;
                                        };
                                    },
                                    {
                                        "./common": 41
                                    }
                                ],
                                43: [
                                    function(e, t, r) {
                                        t.exports = function(e, t, r, n) {
                                            for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, o = 0; 0 !== r;){
                                                for(r -= o = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --o;);
                                                i %= 65521, s %= 65521;
                                            }
                                            return i | s << 16 | 0;
                                        };
                                    },
                                    {}
                                ],
                                44: [
                                    function(e, t, r) {
                                        t.exports = {
                                            Z_NO_FLUSH: 0,
                                            Z_PARTIAL_FLUSH: 1,
                                            Z_SYNC_FLUSH: 2,
                                            Z_FULL_FLUSH: 3,
                                            Z_FINISH: 4,
                                            Z_BLOCK: 5,
                                            Z_TREES: 6,
                                            Z_OK: 0,
                                            Z_STREAM_END: 1,
                                            Z_NEED_DICT: 2,
                                            Z_ERRNO: -1,
                                            Z_STREAM_ERROR: -2,
                                            Z_DATA_ERROR: -3,
                                            Z_BUF_ERROR: -5,
                                            Z_NO_COMPRESSION: 0,
                                            Z_BEST_SPEED: 1,
                                            Z_BEST_COMPRESSION: 9,
                                            Z_DEFAULT_COMPRESSION: -1,
                                            Z_FILTERED: 1,
                                            Z_HUFFMAN_ONLY: 2,
                                            Z_RLE: 3,
                                            Z_FIXED: 4,
                                            Z_DEFAULT_STRATEGY: 0,
                                            Z_BINARY: 0,
                                            Z_TEXT: 1,
                                            Z_UNKNOWN: 2,
                                            Z_DEFLATED: 8
                                        };
                                    },
                                    {}
                                ],
                                45: [
                                    function(e, t, r) {
                                        var n = function() {
                                            for(var e, t = [], r = 0; r < 256; r++){
                                                e = r;
                                                for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                t[r] = e;
                                            }
                                            return t;
                                        }();
                                        t.exports = function(e, t, r, i) {
                                            var s = n, o = i + r;
                                            e ^= -1;
                                            for(var a = i; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t[a])];
                                            return -1 ^ e;
                                        };
                                    },
                                    {}
                                ],
                                46: [
                                    function(e, t, r) {
                                        var n, i = e("../utils/common"), s = e("./trees"), o = e("./adler32"), a = e("./crc32"), l = e("./messages"), c = -2, u = 258, h = 262, f = 113;
                                        function d(e, t) {
                                            return e.msg = l[t], t;
                                        }
                                        function p(e) {
                                            return (e << 1) - (4 < e ? 9 : 0);
                                        }
                                        function m(e) {
                                            for(var t = e.length; 0 <= --t;)e[t] = 0;
                                        }
                                        function b(e) {
                                            var t = e.state, r = t.pending;
                                            r > e.avail_out && (r = e.avail_out), 0 !== r && (i.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                                        }
                                        function g(e, t) {
                                            s._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, b(e.strm);
                                        }
                                        function y(e, t) {
                                            e.pending_buf[e.pending++] = t;
                                        }
                                        function v(e, t) {
                                            e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                                        }
                                        function w(e, t) {
                                            var r, n, i = e.max_chain_length, s = e.strstart, o = e.prev_length, a = e.nice_match, l = e.strstart > e.w_size - h ? e.strstart - (e.w_size - h) : 0, c = e.window, f = e.w_mask, d = e.prev, p = e.strstart + u, m = c[s + o - 1], b = c[s + o];
                                            e.prev_length >= e.good_match && (i >>= 2), a > e.lookahead && (a = e.lookahead);
                                            do if (c[(r = t) + o] === b && c[r + o - 1] === m && c[r] === c[s] && c[++r] === c[s + 1]) {
                                                s += 2, r++;
                                                do ;
                                                while (c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && s < p);
                                                if (n = u - (p - s), s = p - u, o < n) {
                                                    if (e.match_start = t, a <= (o = n)) break;
                                                    m = c[s + o - 1], b = c[s + o];
                                                }
                                            }
                                            while ((t = d[t & f]) > l && 0 != --i);
                                            return o <= e.lookahead ? o : e.lookahead;
                                        }
                                        function _(e) {
                                            var t, r, n, s, l, c, u, f, d, p, m = e.w_size;
                                            do {
                                                if (s = e.window_size - e.lookahead - e.strstart, e.strstart >= m + (m - h)) {
                                                    for(i.arraySet(e.window, e.window, m, m, 0), e.match_start -= m, e.strstart -= m, e.block_start -= m, t = r = e.hash_size; n = e.head[--t], e.head[t] = m <= n ? n - m : 0, --r;);
                                                    for(t = r = m; n = e.prev[--t], e.prev[t] = m <= n ? n - m : 0, --r;);
                                                    s += m;
                                                }
                                                if (0 === e.strm.avail_in) break;
                                                if (c = e.strm, u = e.window, f = e.strstart + e.lookahead, p = void 0, (d = s) < (p = c.avail_in) && (p = d), r = 0 === p ? 0 : (c.avail_in -= p, i.arraySet(u, c.input, c.next_in, p, f), 1 === c.state.wrap ? c.adler = o(c.adler, u, p, f) : 2 === c.state.wrap && (c.adler = a(c.adler, u, p, f)), c.next_in += p, c.total_in += p, p), e.lookahead += r, e.lookahead + e.insert >= 3) for(l = e.strstart - e.insert, e.ins_h = e.window[l], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 3 - 1]) & e.hash_mask, e.prev[l & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = l, l++, e.insert--, !(e.lookahead + e.insert < 3)););
                                            }while (e.lookahead < h && 0 !== e.strm.avail_in);
                                        }
                                        function x(e, t) {
                                            for(var r, n;;){
                                                if (e.lookahead < h) {
                                                    if (_(e), e.lookahead < h && 0 === t) return 1;
                                                    if (0 === e.lookahead) break;
                                                }
                                                if (r = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - h && (e.match_length = w(e, r)), e.match_length >= 3) {
                                                    if (n = s._tr_tally(e, e.strstart - e.match_start, e.match_length - 3), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= 3) {
                                                        for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                                        e.strstart++;
                                                    } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                                                } else n = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                                                if (n && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                            }
                                            return e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                        }
                                        function k(e, t) {
                                            for(var r, n, i;;){
                                                if (e.lookahead < h) {
                                                    if (_(e), e.lookahead < h && 0 === t) return 1;
                                                    if (0 === e.lookahead) break;
                                                }
                                                if (r = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = 2, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - h && (e.match_length = w(e, r), e.match_length <= 5 && (1 === e.strategy || 3 === e.match_length && 4096 < e.strstart - e.match_start) && (e.match_length = 2)), e.prev_length >= 3 && e.match_length <= e.prev_length) {
                                                    for(i = e.strstart + e.lookahead - 3, n = s._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - 3), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                                                    if (e.match_available = 0, e.match_length = 2, e.strstart++, n && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                } else if (e.match_available) {
                                                    if ((n = s._tr_tally(e, 0, e.window[e.strstart - 1])) && g(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return 1;
                                                } else e.match_available = 1, e.strstart++, e.lookahead--;
                                            }
                                            return e.match_available && (n = s._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                        }
                                        function S(e, t, r, n, i) {
                                            this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                                        }
                                        function M() {
                                            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = 8, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(1146), this.dyn_dtree = new i.Buf16(122), this.bl_tree = new i.Buf16(78), m(this.dyn_ltree), m(this.dyn_dtree), m(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(16), this.heap = new i.Buf16(573), m(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(573), m(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                                        }
                                        function C(e) {
                                            var t;
                                            return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = 2, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? 42 : f, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = 0, s._tr_init(t), 0) : d(e, c);
                                        }
                                        function T(e) {
                                            var t = C(e);
                                            return 0 === t && function(e) {
                                                e.window_size = 2 * e.w_size, m(e.head), e.max_lazy_match = n[e.level].max_lazy, e.good_match = n[e.level].good_length, e.nice_match = n[e.level].nice_length, e.max_chain_length = n[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = 2, e.match_available = 0, e.ins_h = 0;
                                            }(e.state), t;
                                        }
                                        function E(e, t, r, n, s, o) {
                                            if (!e) return c;
                                            var a = 1;
                                            if (-1 === t && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), s < 1 || 9 < s || 8 !== r || n < 8 || 15 < n || t < 0 || 9 < t || o < 0 || 4 < o) return d(e, c);
                                            8 === n && (n = 9);
                                            var l = new M;
                                            return (e.state = l).strm = e, l.wrap = a, l.gzhead = null, l.w_bits = n, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = s + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + 3 - 1) / 3), l.window = new i.Buf8(2 * l.w_size), l.head = new i.Buf16(l.hash_size), l.prev = new i.Buf16(l.w_size), l.lit_bufsize = 1 << s + 6, l.pending_buf_size = 4 * l.lit_bufsize, l.pending_buf = new i.Buf8(l.pending_buf_size), l.d_buf = 1 * l.lit_bufsize, l.l_buf = 3 * l.lit_bufsize, l.level = t, l.strategy = o, l.method = r, T(e);
                                        }
                                        n = [
                                            new S(0, 0, 0, 0, function(e, t) {
                                                var r = 65535;
                                                for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                                                    if (e.lookahead <= 1) {
                                                        if (_(e), 0 === e.lookahead && 0 === t) return 1;
                                                        if (0 === e.lookahead) break;
                                                    }
                                                    e.strstart += e.lookahead, e.lookahead = 0;
                                                    var n = e.block_start + r;
                                                    if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    if (e.strstart - e.block_start >= e.w_size - h && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                }
                                                return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : (e.strstart > e.block_start && (g(e, !1), e.strm.avail_out), 1);
                                            }),
                                            new S(4, 4, 8, 4, x),
                                            new S(4, 5, 16, 8, x),
                                            new S(4, 6, 32, 32, x),
                                            new S(4, 4, 16, 16, k),
                                            new S(8, 16, 32, 32, k),
                                            new S(8, 16, 128, 128, k),
                                            new S(8, 32, 128, 256, k),
                                            new S(32, 128, 258, 1024, k),
                                            new S(32, 258, 258, 4096, k)
                                        ], r.deflateInit = function(e, t) {
                                            return E(e, t, 8, 15, 8, 0);
                                        }, r.deflateInit2 = E, r.deflateReset = T, r.deflateResetKeep = C, r.deflateSetHeader = function(e, t) {
                                            return e && e.state ? 2 !== e.state.wrap ? c : (e.state.gzhead = t, 0) : c;
                                        }, r.deflate = function(e, t) {
                                            var r, i, o, l;
                                            if (!e || !e.state || 5 < t || t < 0) return e ? d(e, c) : c;
                                            if (i = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === i.status && 4 !== t) return d(e, 0 === e.avail_out ? -5 : c);
                                            if (i.strm = e, r = i.last_flush, i.last_flush = t, 42 === i.status) {
                                                if (2 === i.wrap) e.adler = 0, y(i, 31), y(i, 139), y(i, 8), i.gzhead ? (y(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), y(i, 255 & i.gzhead.time), y(i, i.gzhead.time >> 8 & 255), y(i, i.gzhead.time >> 16 & 255), y(i, i.gzhead.time >> 24 & 255), y(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), y(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (y(i, 255 & i.gzhead.extra.length), y(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = a(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69) : (y(i, 0), y(i, 0), y(i, 0), y(i, 0), y(i, 0), y(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), y(i, 3), i.status = f);
                                                else {
                                                    var h = 8 + (i.w_bits - 8 << 4) << 8;
                                                    h |= (2 <= i.strategy || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3) << 6, 0 !== i.strstart && (h |= 32), h += 31 - h % 31, i.status = f, v(i, h), 0 !== i.strstart && (v(i, e.adler >>> 16), v(i, 65535 & e.adler)), e.adler = 1;
                                                }
                                            }
                                            if (69 === i.status) {
                                                if (i.gzhead.extra) {
                                                    for(o = i.pending; i.gzindex < (65535 & i.gzhead.extra.length) && (i.pending !== i.pending_buf_size || (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending !== i.pending_buf_size));)y(i, 255 & i.gzhead.extra[i.gzindex]), i.gzindex++;
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = 73);
                                                } else i.status = 73;
                                            }
                                            if (73 === i.status) {
                                                if (i.gzhead.name) {
                                                    o = i.pending;
                                                    do {
                                                        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending === i.pending_buf_size)) {
                                                            l = 1;
                                                            break;
                                                        }
                                                        l = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, y(i, l);
                                                    }while (0 !== l);
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === l && (i.gzindex = 0, i.status = 91);
                                                } else i.status = 91;
                                            }
                                            if (91 === i.status) {
                                                if (i.gzhead.comment) {
                                                    o = i.pending;
                                                    do {
                                                        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending === i.pending_buf_size)) {
                                                            l = 1;
                                                            break;
                                                        }
                                                        l = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, y(i, l);
                                                    }while (0 !== l);
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === l && (i.status = 103);
                                                } else i.status = 103;
                                            }
                                            if (103 === i.status && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && b(e), i.pending + 2 <= i.pending_buf_size && (y(i, 255 & e.adler), y(i, e.adler >> 8 & 255), e.adler = 0, i.status = f)) : i.status = f), 0 !== i.pending) {
                                                if (b(e), 0 === e.avail_out) return i.last_flush = -1, 0;
                                            } else if (0 === e.avail_in && p(t) <= p(r) && 4 !== t) return d(e, -5);
                                            if (666 === i.status && 0 !== e.avail_in) return d(e, -5);
                                            if (0 !== e.avail_in || 0 !== i.lookahead || 0 !== t && 666 !== i.status) {
                                                var w = 2 === i.strategy ? function(e, t) {
                                                    for(var r;;){
                                                        if (0 === e.lookahead && (_(e), 0 === e.lookahead)) {
                                                            if (0 === t) return 1;
                                                            break;
                                                        }
                                                        if (e.match_length = 0, r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    }
                                                    return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                }(i, t) : 3 === i.strategy ? function(e, t) {
                                                    for(var r, n, i, o, a = e.window;;){
                                                        if (e.lookahead <= u) {
                                                            if (_(e), e.lookahead <= u && 0 === t) return 1;
                                                            if (0 === e.lookahead) break;
                                                        }
                                                        if (e.match_length = 0, e.lookahead >= 3 && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                                            o = e.strstart + u;
                                                            do ;
                                                            while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < o);
                                                            e.match_length = u - (o - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                                        }
                                                        if (e.match_length >= 3 ? (r = s._tr_tally(e, 1, e.match_length - 3), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    }
                                                    return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                }(i, t) : n[i.level].func(i, t);
                                                if (3 !== w && 4 !== w || (i.status = 666), 1 === w || 3 === w) return 0 === e.avail_out && (i.last_flush = -1), 0;
                                                if (2 === w && (1 === t ? s._tr_align(i) : 5 !== t && (s._tr_stored_block(i, 0, 0, !1), 3 === t && (m(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), b(e), 0 === e.avail_out)) return i.last_flush = -1, 0;
                                            }
                                            return 4 !== t ? 0 : i.wrap <= 0 ? 1 : (2 === i.wrap ? (y(i, 255 & e.adler), y(i, e.adler >> 8 & 255), y(i, e.adler >> 16 & 255), y(i, e.adler >> 24 & 255), y(i, 255 & e.total_in), y(i, e.total_in >> 8 & 255), y(i, e.total_in >> 16 & 255), y(i, e.total_in >> 24 & 255)) : (v(i, e.adler >>> 16), v(i, 65535 & e.adler)), b(e), 0 < i.wrap && (i.wrap = -i.wrap), 0 !== i.pending ? 0 : 1);
                                        }, r.deflateEnd = function(e) {
                                            var t;
                                            return e && e.state ? 42 !== (t = e.state.status) && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== f && 666 !== t ? d(e, c) : (e.state = null, t === f ? d(e, -3) : 0) : c;
                                        }, r.deflateSetDictionary = function(e, t) {
                                            var r, n, s, a, l, u, h, f, d = t.length;
                                            if (!e || !e.state) return c;
                                            if (2 === (a = (r = e.state).wrap) || 1 === a && 42 !== r.status || r.lookahead) return c;
                                            for(1 === a && (e.adler = o(e.adler, t, d, 0)), r.wrap = 0, d >= r.w_size && (0 === a && (m(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), f = new i.Buf8(r.w_size), i.arraySet(f, t, d - r.w_size, r.w_size, 0), t = f, d = r.w_size), l = e.avail_in, u = e.next_in, h = e.input, e.avail_in = d, e.next_in = 0, e.input = t, _(r); r.lookahead >= 3;){
                                                for(n = r.strstart, s = r.lookahead - 2; r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + 3 - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --s;);
                                                r.strstart = n, r.lookahead = 2, _(r);
                                            }
                                            return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = 2, r.match_available = 0, e.next_in = u, e.input = h, e.avail_in = l, r.wrap = a, 0;
                                        }, r.deflateInfo = "pako deflate (from Nodeca project)";
                                    },
                                    {
                                        "../utils/common": 41,
                                        "./adler32": 43,
                                        "./crc32": 45,
                                        "./messages": 51,
                                        "./trees": 52
                                    }
                                ],
                                47: [
                                    function(e, t, r) {
                                        t.exports = function() {
                                            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                                        };
                                    },
                                    {}
                                ],
                                48: [
                                    function(e, t, r) {
                                        t.exports = function(e, t) {
                                            var r, n, i, s, o, a, l, c, u, h, f, d, p, m, b, g, y, v, w, _, x, k, S, M, C;
                                            r = e.state, n = e.next_in, M = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, o = s - (t - e.avail_out), a = s + (e.avail_out - 257), l = r.dmax, c = r.wsize, u = r.whave, h = r.wnext, f = r.window, d = r.hold, p = r.bits, m = r.lencode, b = r.distcode, g = (1 << r.lenbits) - 1, y = (1 << r.distbits) - 1;
                                            e: do {
                                                p < 15 && (d += M[n++] << p, p += 8, d += M[n++] << p, p += 8), v = m[d & g];
                                                t: for(;;){
                                                    if (d >>>= w = v >>> 24, p -= w, 0 == (w = v >>> 16 & 255)) C[s++] = 65535 & v;
                                                    else {
                                                        if (!(16 & w)) {
                                                            if (0 == (64 & w)) {
                                                                v = m[(65535 & v) + (d & (1 << w) - 1)];
                                                                continue t;
                                                            }
                                                            if (32 & w) {
                                                                r.mode = 12;
                                                                break e;
                                                            }
                                                            e.msg = "invalid literal/length code", r.mode = 30;
                                                            break e;
                                                        }
                                                        _ = 65535 & v, (w &= 15) && (p < w && (d += M[n++] << p, p += 8), _ += d & (1 << w) - 1, d >>>= w, p -= w), p < 15 && (d += M[n++] << p, p += 8, d += M[n++] << p, p += 8), v = b[d & y];
                                                        r: for(;;){
                                                            if (d >>>= w = v >>> 24, p -= w, !(16 & (w = v >>> 16 & 255))) {
                                                                if (0 == (64 & w)) {
                                                                    v = b[(65535 & v) + (d & (1 << w) - 1)];
                                                                    continue r;
                                                                }
                                                                e.msg = "invalid distance code", r.mode = 30;
                                                                break e;
                                                            }
                                                            if (x = 65535 & v, p < (w &= 15) && (d += M[n++] << p, (p += 8) < w && (d += M[n++] << p, p += 8)), l < (x += d & (1 << w) - 1)) {
                                                                e.msg = "invalid distance too far back", r.mode = 30;
                                                                break e;
                                                            }
                                                            if (d >>>= w, p -= w, (w = s - o) < x) {
                                                                if (u < (w = x - w) && r.sane) {
                                                                    e.msg = "invalid distance too far back", r.mode = 30;
                                                                    break e;
                                                                }
                                                                if (S = f, (k = 0) === h) {
                                                                    if (k += c - w, w < _) {
                                                                        for(_ -= w; C[s++] = f[k++], --w;);
                                                                        k = s - x, S = C;
                                                                    }
                                                                } else if (h < w) {
                                                                    if (k += c + h - w, (w -= h) < _) {
                                                                        for(_ -= w; C[s++] = f[k++], --w;);
                                                                        if (k = 0, h < _) {
                                                                            for(_ -= w = h; C[s++] = f[k++], --w;);
                                                                            k = s - x, S = C;
                                                                        }
                                                                    }
                                                                } else if (k += h - w, w < _) {
                                                                    for(_ -= w; C[s++] = f[k++], --w;);
                                                                    k = s - x, S = C;
                                                                }
                                                                for(; 2 < _;)C[s++] = S[k++], C[s++] = S[k++], C[s++] = S[k++], _ -= 3;
                                                                _ && (C[s++] = S[k++], 1 < _ && (C[s++] = S[k++]));
                                                            } else {
                                                                for(k = s - x; C[s++] = C[k++], C[s++] = C[k++], C[s++] = C[k++], 2 < (_ -= 3););
                                                                _ && (C[s++] = C[k++], 1 < _ && (C[s++] = C[k++]));
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    break;
                                                }
                                            }while (n < i && s < a);
                                            n -= _ = p >> 3, d &= (1 << (p -= _ << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < a ? a - s + 257 : 257 - (s - a), r.hold = d, r.bits = p;
                                        };
                                    },
                                    {}
                                ],
                                49: [
                                    function(e, t, r) {
                                        var n = e("../utils/common"), i = e("./adler32"), s = e("./crc32"), o = e("./inffast"), a = e("./inftrees"), l = -2;
                                        function c(e) {
                                            return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                                        }
                                        function u() {
                                            this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                                        }
                                        function h(e) {
                                            var t;
                                            return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = 1, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new n.Buf32(852), t.distcode = t.distdyn = new n.Buf32(592), t.sane = 1, t.back = -1, 0) : l;
                                        }
                                        function f(e) {
                                            var t;
                                            return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, h(e)) : l;
                                        }
                                        function d(e, t) {
                                            var r, n;
                                            return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? l : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, f(e))) : l;
                                        }
                                        function p(e, t) {
                                            var r, n;
                                            return e ? (n = new u, (e.state = n).window = null, 0 !== (r = d(e, t)) && (e.state = null), r) : l;
                                        }
                                        var m, b, g = !0;
                                        function y(e) {
                                            if (g) {
                                                var t;
                                                for(m = new n.Buf32(512), b = new n.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                                                for(; t < 256;)e.lens[t++] = 9;
                                                for(; t < 280;)e.lens[t++] = 7;
                                                for(; t < 288;)e.lens[t++] = 8;
                                                for(a(1, e.lens, 0, 288, m, 0, e.work, {
                                                    bits: 9
                                                }), t = 0; t < 32;)e.lens[t++] = 5;
                                                a(2, e.lens, 0, 32, b, 0, e.work, {
                                                    bits: 5
                                                }), g = !1;
                                            }
                                            e.lencode = m, e.lenbits = 9, e.distcode = b, e.distbits = 5;
                                        }
                                        function v(e, t, r, i) {
                                            var s, o = e.state;
                                            return null === o.window && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new n.Buf8(o.wsize)), i >= o.wsize ? (n.arraySet(o.window, t, r - o.wsize, o.wsize, 0), o.wnext = 0, o.whave = o.wsize) : (i < (s = o.wsize - o.wnext) && (s = i), n.arraySet(o.window, t, r - i, s, o.wnext), (i -= s) ? (n.arraySet(o.window, t, r - i, i, 0), o.wnext = i, o.whave = o.wsize) : (o.wnext += s, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += s))), 0;
                                        }
                                        r.inflateReset = f, r.inflateReset2 = d, r.inflateResetKeep = h, r.inflateInit = function(e) {
                                            return p(e, 15);
                                        }, r.inflateInit2 = p, r.inflate = function(e, t) {
                                            var r, u, h, f, d, p, m, b, g, w, _, x, k, S, M, C, T, E, A, R, O, j, I, N, P = 0, B = new n.Buf8(4), D = [
                                                16,
                                                17,
                                                18,
                                                0,
                                                8,
                                                7,
                                                9,
                                                6,
                                                10,
                                                5,
                                                11,
                                                4,
                                                12,
                                                3,
                                                13,
                                                2,
                                                14,
                                                1,
                                                15
                                            ];
                                            if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return l;
                                            12 === (r = e.state).mode && (r.mode = 13), d = e.next_out, h = e.output, m = e.avail_out, f = e.next_in, u = e.input, p = e.avail_in, b = r.hold, g = r.bits, w = p, _ = m, j = 0;
                                            e: for(;;)switch(r.mode){
                                                case 1:
                                                    if (0 === r.wrap) {
                                                        r.mode = 13;
                                                        break;
                                                    }
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (2 & r.wrap && 35615 === b) {
                                                        B[r.check = 0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0), g = b = 0, r.mode = 2;
                                                        break;
                                                    }
                                                    if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & b) << 8) + (b >> 8)) % 31) {
                                                        e.msg = "incorrect header check", r.mode = 30;
                                                        break;
                                                    }
                                                    if (8 != (15 & b)) {
                                                        e.msg = "unknown compression method", r.mode = 30;
                                                        break;
                                                    }
                                                    if (g -= 4, O = 8 + (15 & (b >>>= 4)), 0 === r.wbits) r.wbits = O;
                                                    else if (O > r.wbits) {
                                                        e.msg = "invalid window size", r.mode = 30;
                                                        break;
                                                    }
                                                    r.dmax = 1 << O, e.adler = r.check = 1, r.mode = 512 & b ? 10 : 12, g = b = 0;
                                                    break;
                                                case 2:
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (r.flags = b, 8 != (255 & r.flags)) {
                                                        e.msg = "unknown compression method", r.mode = 30;
                                                        break;
                                                    }
                                                    if (57344 & r.flags) {
                                                        e.msg = "unknown header flags set", r.mode = 30;
                                                        break;
                                                    }
                                                    r.head && (r.head.text = b >> 8 & 1), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0, r.mode = 3;
                                                case 3:
                                                    for(; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    r.head && (r.head.time = b), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, B[2] = b >>> 16 & 255, B[3] = b >>> 24 & 255, r.check = s(r.check, B, 4, 0)), g = b = 0, r.mode = 4;
                                                case 4:
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    r.head && (r.head.xflags = 255 & b, r.head.os = b >> 8), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0, r.mode = 5;
                                                case 5:
                                                    if (1024 & r.flags) {
                                                        for(; g < 16;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.length = b, r.head && (r.head.extra_len = b), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0;
                                                    } else r.head && (r.head.extra = null);
                                                    r.mode = 6;
                                                case 6:
                                                    if (1024 & r.flags && (p < (x = r.length) && (x = p), x && (r.head && (O = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, u, f, x, O)), 512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, r.length -= x), r.length)) break e;
                                                    r.length = 0, r.mode = 7;
                                                case 7:
                                                    if (2048 & r.flags) {
                                                        if (0 === p) break e;
                                                        for(x = 0; O = u[f + x++], r.head && O && r.length < 65536 && (r.head.name += String.fromCharCode(O)), O && x < p;);
                                                        if (512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, O) break e;
                                                    } else r.head && (r.head.name = null);
                                                    r.length = 0, r.mode = 8;
                                                case 8:
                                                    if (4096 & r.flags) {
                                                        if (0 === p) break e;
                                                        for(x = 0; O = u[f + x++], r.head && O && r.length < 65536 && (r.head.comment += String.fromCharCode(O)), O && x < p;);
                                                        if (512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, O) break e;
                                                    } else r.head && (r.head.comment = null);
                                                    r.mode = 9;
                                                case 9:
                                                    if (512 & r.flags) {
                                                        for(; g < 16;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (b !== (65535 & r.check)) {
                                                            e.msg = "header crc mismatch", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                                                    break;
                                                case 10:
                                                    for(; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    e.adler = r.check = c(b), g = b = 0, r.mode = 11;
                                                case 11:
                                                    if (0 === r.havedict) return e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, 2;
                                                    e.adler = r.check = 1, r.mode = 12;
                                                case 12:
                                                    if (5 === t || 6 === t) break e;
                                                case 13:
                                                    if (r.last) {
                                                        b >>>= 7 & g, g -= 7 & g, r.mode = 27;
                                                        break;
                                                    }
                                                    for(; g < 3;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    switch(r.last = 1 & b, g -= 1, 3 & (b >>>= 1)){
                                                        case 0:
                                                            r.mode = 14;
                                                            break;
                                                        case 1:
                                                            if (y(r), r.mode = 20, 6 !== t) break;
                                                            b >>>= 2, g -= 2;
                                                            break e;
                                                        case 2:
                                                            r.mode = 17;
                                                            break;
                                                        case 3:
                                                            e.msg = "invalid block type", r.mode = 30;
                                                    }
                                                    b >>>= 2, g -= 2;
                                                    break;
                                                case 14:
                                                    for(b >>>= 7 & g, g -= 7 & g; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if ((65535 & b) != (b >>> 16 ^ 65535)) {
                                                        e.msg = "invalid stored block lengths", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.length = 65535 & b, g = b = 0, r.mode = 15, 6 === t) break e;
                                                case 15:
                                                    r.mode = 16;
                                                case 16:
                                                    if (x = r.length) {
                                                        if (p < x && (x = p), m < x && (x = m), 0 === x) break e;
                                                        n.arraySet(h, u, f, x, d), p -= x, f += x, m -= x, d += x, r.length -= x;
                                                        break;
                                                    }
                                                    r.mode = 12;
                                                    break;
                                                case 17:
                                                    for(; g < 14;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (r.nlen = 257 + (31 & b), b >>>= 5, g -= 5, r.ndist = 1 + (31 & b), b >>>= 5, g -= 5, r.ncode = 4 + (15 & b), b >>>= 4, g -= 4, 286 < r.nlen || 30 < r.ndist) {
                                                        e.msg = "too many length or distance symbols", r.mode = 30;
                                                        break;
                                                    }
                                                    r.have = 0, r.mode = 18;
                                                case 18:
                                                    for(; r.have < r.ncode;){
                                                        for(; g < 3;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.lens[D[r.have++]] = 7 & b, b >>>= 3, g -= 3;
                                                    }
                                                    for(; r.have < 19;)r.lens[D[r.have++]] = 0;
                                                    if (r.lencode = r.lendyn, r.lenbits = 7, I = {
                                                        bits: r.lenbits
                                                    }, j = a(0, r.lens, 0, 19, r.lencode, 0, r.work, I), r.lenbits = I.bits, j) {
                                                        e.msg = "invalid code lengths set", r.mode = 30;
                                                        break;
                                                    }
                                                    r.have = 0, r.mode = 19;
                                                case 19:
                                                    for(; r.have < r.nlen + r.ndist;){
                                                        for(; C = (P = r.lencode[b & (1 << r.lenbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (T < 16) b >>>= M, g -= M, r.lens[r.have++] = T;
                                                        else {
                                                            if (16 === T) {
                                                                for(N = M + 2; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                if (b >>>= M, g -= M, 0 === r.have) {
                                                                    e.msg = "invalid bit length repeat", r.mode = 30;
                                                                    break;
                                                                }
                                                                O = r.lens[r.have - 1], x = 3 + (3 & b), b >>>= 2, g -= 2;
                                                            } else if (17 === T) {
                                                                for(N = M + 3; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                g -= M, O = 0, x = 3 + (7 & (b >>>= M)), b >>>= 3, g -= 3;
                                                            } else {
                                                                for(N = M + 7; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                g -= M, O = 0, x = 11 + (127 & (b >>>= M)), b >>>= 7, g -= 7;
                                                            }
                                                            if (r.have + x > r.nlen + r.ndist) {
                                                                e.msg = "invalid bit length repeat", r.mode = 30;
                                                                break;
                                                            }
                                                            for(; x--;)r.lens[r.have++] = O;
                                                        }
                                                    }
                                                    if (30 === r.mode) break;
                                                    if (0 === r.lens[256]) {
                                                        e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.lenbits = 9, I = {
                                                        bits: r.lenbits
                                                    }, j = a(1, r.lens, 0, r.nlen, r.lencode, 0, r.work, I), r.lenbits = I.bits, j) {
                                                        e.msg = "invalid literal/lengths set", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.distbits = 6, r.distcode = r.distdyn, I = {
                                                        bits: r.distbits
                                                    }, j = a(2, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, I), r.distbits = I.bits, j) {
                                                        e.msg = "invalid distances set", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.mode = 20, 6 === t) break e;
                                                case 20:
                                                    r.mode = 21;
                                                case 21:
                                                    if (6 <= p && 258 <= m) {
                                                        e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, o(e, _), d = e.next_out, h = e.output, m = e.avail_out, f = e.next_in, u = e.input, p = e.avail_in, b = r.hold, g = r.bits, 12 === r.mode && (r.back = -1);
                                                        break;
                                                    }
                                                    for(r.back = 0; C = (P = r.lencode[b & (1 << r.lenbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (C && 0 == (240 & C)) {
                                                        for(E = M, A = C, R = T; C = (P = r.lencode[R + ((b & (1 << E + A) - 1) >> E)]) >>> 16 & 255, T = 65535 & P, !(E + (M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        b >>>= E, g -= E, r.back += E;
                                                    }
                                                    if (b >>>= M, g -= M, r.back += M, r.length = T, 0 === C) {
                                                        r.mode = 26;
                                                        break;
                                                    }
                                                    if (32 & C) {
                                                        r.back = -1, r.mode = 12;
                                                        break;
                                                    }
                                                    if (64 & C) {
                                                        e.msg = "invalid literal/length code", r.mode = 30;
                                                        break;
                                                    }
                                                    r.extra = 15 & C, r.mode = 22;
                                                case 22:
                                                    if (r.extra) {
                                                        for(N = r.extra; g < N;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.length += b & (1 << r.extra) - 1, b >>>= r.extra, g -= r.extra, r.back += r.extra;
                                                    }
                                                    r.was = r.length, r.mode = 23;
                                                case 23:
                                                    for(; C = (P = r.distcode[b & (1 << r.distbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (0 == (240 & C)) {
                                                        for(E = M, A = C, R = T; C = (P = r.distcode[R + ((b & (1 << E + A) - 1) >> E)]) >>> 16 & 255, T = 65535 & P, !(E + (M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        b >>>= E, g -= E, r.back += E;
                                                    }
                                                    if (b >>>= M, g -= M, r.back += M, 64 & C) {
                                                        e.msg = "invalid distance code", r.mode = 30;
                                                        break;
                                                    }
                                                    r.offset = T, r.extra = 15 & C, r.mode = 24;
                                                case 24:
                                                    if (r.extra) {
                                                        for(N = r.extra; g < N;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.offset += b & (1 << r.extra) - 1, b >>>= r.extra, g -= r.extra, r.back += r.extra;
                                                    }
                                                    if (r.offset > r.dmax) {
                                                        e.msg = "invalid distance too far back", r.mode = 30;
                                                        break;
                                                    }
                                                    r.mode = 25;
                                                case 25:
                                                    if (0 === m) break e;
                                                    if (x = _ - m, r.offset > x) {
                                                        if ((x = r.offset - x) > r.whave && r.sane) {
                                                            e.msg = "invalid distance too far back", r.mode = 30;
                                                            break;
                                                        }
                                                        k = x > r.wnext ? (x -= r.wnext, r.wsize - x) : r.wnext - x, x > r.length && (x = r.length), S = r.window;
                                                    } else S = h, k = d - r.offset, x = r.length;
                                                    for(m < x && (x = m), m -= x, r.length -= x; h[d++] = S[k++], --x;);
                                                    0 === r.length && (r.mode = 21);
                                                    break;
                                                case 26:
                                                    if (0 === m) break e;
                                                    h[d++] = r.length, m--, r.mode = 21;
                                                    break;
                                                case 27:
                                                    if (r.wrap) {
                                                        for(; g < 32;){
                                                            if (0 === p) break e;
                                                            p--, b |= u[f++] << g, g += 8;
                                                        }
                                                        if (_ -= m, e.total_out += _, r.total += _, _ && (e.adler = r.check = r.flags ? s(r.check, h, _, d - _) : i(r.check, h, _, d - _)), _ = m, (r.flags ? b : c(b)) !== r.check) {
                                                            e.msg = "incorrect data check", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.mode = 28;
                                                case 28:
                                                    if (r.wrap && r.flags) {
                                                        for(; g < 32;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (b !== (4294967295 & r.total)) {
                                                            e.msg = "incorrect length check", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.mode = 29;
                                                case 29:
                                                    j = 1;
                                                    break e;
                                                case 30:
                                                    j = -3;
                                                    break e;
                                                case 31:
                                                    return -4;
                                                case 32:
                                                default:
                                                    return l;
                                            }
                                            return e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, (r.wsize || _ !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && v(e, e.output, e.next_out, _ - e.avail_out) ? (r.mode = 31, -4) : (w -= e.avail_in, _ -= e.avail_out, e.total_in += w, e.total_out += _, r.total += _, r.wrap && _ && (e.adler = r.check = r.flags ? s(r.check, h, _, e.next_out - _) : i(r.check, h, _, e.next_out - _)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == w && 0 === _ || 4 === t) && 0 === j && (j = -5), j);
                                        }, r.inflateEnd = function(e) {
                                            if (!e || !e.state) return l;
                                            var t = e.state;
                                            return t.window && (t.window = null), e.state = null, 0;
                                        }, r.inflateGetHeader = function(e, t) {
                                            var r;
                                            return e && e.state ? 0 == (2 & (r = e.state).wrap) ? l : ((r.head = t).done = !1, 0) : l;
                                        }, r.inflateSetDictionary = function(e, t) {
                                            var r, n = t.length;
                                            return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? l : 11 === r.mode && i(1, t, n, 0) !== r.check ? -3 : v(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, 0) : l;
                                        }, r.inflateInfo = "pako inflate (from Nodeca project)";
                                    },
                                    {
                                        "../utils/common": 41,
                                        "./adler32": 43,
                                        "./crc32": 45,
                                        "./inffast": 48,
                                        "./inftrees": 50
                                    }
                                ],
                                50: [
                                    function(e, t, r) {
                                        var n = e("../utils/common"), i = [
                                            3,
                                            4,
                                            5,
                                            6,
                                            7,
                                            8,
                                            9,
                                            10,
                                            11,
                                            13,
                                            15,
                                            17,
                                            19,
                                            23,
                                            27,
                                            31,
                                            35,
                                            43,
                                            51,
                                            59,
                                            67,
                                            83,
                                            99,
                                            115,
                                            131,
                                            163,
                                            195,
                                            227,
                                            258,
                                            0,
                                            0
                                        ], s = [
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            17,
                                            17,
                                            17,
                                            17,
                                            18,
                                            18,
                                            18,
                                            18,
                                            19,
                                            19,
                                            19,
                                            19,
                                            20,
                                            20,
                                            20,
                                            20,
                                            21,
                                            21,
                                            21,
                                            21,
                                            16,
                                            72,
                                            78
                                        ], o = [
                                            1,
                                            2,
                                            3,
                                            4,
                                            5,
                                            7,
                                            9,
                                            13,
                                            17,
                                            25,
                                            33,
                                            49,
                                            65,
                                            97,
                                            129,
                                            193,
                                            257,
                                            385,
                                            513,
                                            769,
                                            1025,
                                            1537,
                                            2049,
                                            3073,
                                            4097,
                                            6145,
                                            8193,
                                            12289,
                                            16385,
                                            24577,
                                            0,
                                            0
                                        ], a = [
                                            16,
                                            16,
                                            16,
                                            16,
                                            17,
                                            17,
                                            18,
                                            18,
                                            19,
                                            19,
                                            20,
                                            20,
                                            21,
                                            21,
                                            22,
                                            22,
                                            23,
                                            23,
                                            24,
                                            24,
                                            25,
                                            25,
                                            26,
                                            26,
                                            27,
                                            27,
                                            28,
                                            28,
                                            29,
                                            29,
                                            64,
                                            64
                                        ];
                                        t.exports = function(e, t, r, l, c, u, h, f) {
                                            var d, p, m, b, g, y, v, w, _, x = f.bits, k = 0, S = 0, M = 0, C = 0, T = 0, E = 0, A = 0, R = 0, O = 0, j = 0, I = null, N = 0, P = new n.Buf16(16), B = new n.Buf16(16), D = null, F = 0;
                                            for(k = 0; k <= 15; k++)P[k] = 0;
                                            for(S = 0; S < l; S++)P[t[r + S]]++;
                                            for(T = x, C = 15; 1 <= C && 0 === P[C]; C--);
                                            if (C < T && (T = C), 0 === C) return c[u++] = 20971520, c[u++] = 20971520, f.bits = 1, 0;
                                            for(M = 1; M < C && 0 === P[M]; M++);
                                            for(T < M && (T = M), k = R = 1; k <= 15; k++)if (R <<= 1, (R -= P[k]) < 0) return -1;
                                            if (0 < R && (0 === e || 1 !== C)) return -1;
                                            for(B[1] = 0, k = 1; k < 15; k++)B[k + 1] = B[k] + P[k];
                                            for(S = 0; S < l; S++)0 !== t[r + S] && (h[B[t[r + S]]++] = S);
                                            if (y = 0 === e ? (I = D = h, 19) : 1 === e ? (I = i, N -= 257, D = s, F -= 257, 256) : (I = o, D = a, -1), k = M, g = u, A = S = j = 0, m = -1, b = (O = 1 << (E = T)) - 1, 1 === e && 852 < O || 2 === e && 592 < O) return 1;
                                            for(;;){
                                                for(v = k - A, _ = h[S] < y ? (w = 0, h[S]) : h[S] > y ? (w = D[F + h[S]], I[N + h[S]]) : (w = 96, 0), d = 1 << k - A, M = p = 1 << E; c[g + (j >> A) + (p -= d)] = v << 24 | w << 16 | _ | 0, 0 !== p;);
                                                for(d = 1 << k - 1; j & d;)d >>= 1;
                                                if (0 !== d ? (j &= d - 1, j += d) : j = 0, S++, 0 == --P[k]) {
                                                    if (k === C) break;
                                                    k = t[r + h[S]];
                                                }
                                                if (T < k && (j & b) !== m) {
                                                    for(0 === A && (A = T), g += M, R = 1 << (E = k - A); E + A < C && !((R -= P[E + A]) <= 0);)E++, R <<= 1;
                                                    if (O += 1 << E, 1 === e && 852 < O || 2 === e && 592 < O) return 1;
                                                    c[m = j & b] = T << 24 | E << 16 | g - u | 0;
                                                }
                                            }
                                            return 0 !== j && (c[g + j] = k - A << 24 | 4194304), f.bits = T, 0;
                                        };
                                    },
                                    {
                                        "../utils/common": 41
                                    }
                                ],
                                51: [
                                    function(e, t, r) {
                                        t.exports = {
                                            2: "need dictionary",
                                            1: "stream end",
                                            0: "",
                                            "-1": "file error",
                                            "-2": "stream error",
                                            "-3": "data error",
                                            "-4": "insufficient memory",
                                            "-5": "buffer error",
                                            "-6": "incompatible version"
                                        };
                                    },
                                    {}
                                ],
                                52: [
                                    function(e, t, r) {
                                        var n = e("../utils/common");
                                        function i(e) {
                                            for(var t = e.length; 0 <= --t;)e[t] = 0;
                                        }
                                        var s = 256, o = 286, a = 30, l = 15, c = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            1,
                                            1,
                                            1,
                                            2,
                                            2,
                                            2,
                                            2,
                                            3,
                                            3,
                                            3,
                                            3,
                                            4,
                                            4,
                                            4,
                                            4,
                                            5,
                                            5,
                                            5,
                                            5,
                                            0
                                        ], u = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            1,
                                            2,
                                            2,
                                            3,
                                            3,
                                            4,
                                            4,
                                            5,
                                            5,
                                            6,
                                            6,
                                            7,
                                            7,
                                            8,
                                            8,
                                            9,
                                            9,
                                            10,
                                            10,
                                            11,
                                            11,
                                            12,
                                            12,
                                            13,
                                            13
                                        ], h = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            2,
                                            3,
                                            7
                                        ], f = [
                                            16,
                                            17,
                                            18,
                                            0,
                                            8,
                                            7,
                                            9,
                                            6,
                                            10,
                                            5,
                                            11,
                                            4,
                                            12,
                                            3,
                                            13,
                                            2,
                                            14,
                                            1,
                                            15
                                        ], d = new Array(576);
                                        i(d);
                                        var p = new Array(60);
                                        i(p);
                                        var m = new Array(512);
                                        i(m);
                                        var b = new Array(256);
                                        i(b);
                                        var g = new Array(29);
                                        i(g);
                                        var y, v, w, _ = new Array(a);
                                        function x(e, t, r, n, i) {
                                            this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                                        }
                                        function k(e, t) {
                                            this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                                        }
                                        function S(e) {
                                            return e < 256 ? m[e] : m[256 + (e >>> 7)];
                                        }
                                        function M(e, t) {
                                            e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                                        }
                                        function C(e, t, r) {
                                            e.bi_valid > 16 - r ? (e.bi_buf |= t << e.bi_valid & 65535, M(e, e.bi_buf), e.bi_buf = t >> 16 - e.bi_valid, e.bi_valid += r - 16) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                                        }
                                        function T(e, t, r) {
                                            C(e, r[2 * t], r[2 * t + 1]);
                                        }
                                        function E(e, t) {
                                            for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                                            return r >>> 1;
                                        }
                                        function A(e, t, r) {
                                            var n, i, s = new Array(16), o = 0;
                                            for(n = 1; n <= l; n++)s[n] = o = o + r[n - 1] << 1;
                                            for(i = 0; i <= t; i++){
                                                var a = e[2 * i + 1];
                                                0 !== a && (e[2 * i] = E(s[a]++, a));
                                            }
                                        }
                                        function R(e) {
                                            var t;
                                            for(t = 0; t < o; t++)e.dyn_ltree[2 * t] = 0;
                                            for(t = 0; t < a; t++)e.dyn_dtree[2 * t] = 0;
                                            for(t = 0; t < 19; t++)e.bl_tree[2 * t] = 0;
                                            e.dyn_ltree[512] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                                        }
                                        function O(e) {
                                            8 < e.bi_valid ? M(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                                        }
                                        function j(e, t, r, n) {
                                            var i = 2 * t, s = 2 * r;
                                            return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                                        }
                                        function I(e, t, r) {
                                            for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && j(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !j(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                                            e.heap[r] = n;
                                        }
                                        function N(e, t, r) {
                                            var n, i, o, a, l = 0;
                                            if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * l] << 8 | e.pending_buf[e.d_buf + 2 * l + 1], i = e.pending_buf[e.l_buf + l], l++, 0 === n ? T(e, i, t) : (T(e, (o = b[i]) + s + 1, t), 0 !== (a = c[o]) && C(e, i -= g[o], a), T(e, o = S(--n), r), 0 !== (a = u[o]) && C(e, n -= _[o], a)), l < e.last_lit;);
                                            T(e, 256, t);
                                        }
                                        function P(e, t) {
                                            var r, n, i, s = t.dyn_tree, o = t.stat_desc.static_tree, a = t.stat_desc.has_stree, c = t.stat_desc.elems, u = -1;
                                            for(e.heap_len = 0, e.heap_max = 573, r = 0; r < c; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                                            for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, a && (e.static_len -= o[2 * i + 1]);
                                            for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)I(e, s, r);
                                            for(i = c; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], I(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, I(e, s, 1), 2 <= e.heap_len;);
                                            e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                                                var r, n, i, s, o, a, c = t.dyn_tree, u = t.max_code, h = t.stat_desc.static_tree, f = t.stat_desc.has_stree, d = t.stat_desc.extra_bits, p = t.stat_desc.extra_base, m = t.stat_desc.max_length, b = 0;
                                                for(s = 0; s <= l; s++)e.bl_count[s] = 0;
                                                for(c[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < 573; r++)m < (s = c[2 * c[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = m, b++), c[2 * n + 1] = s, u < n || (e.bl_count[s]++, o = 0, p <= n && (o = d[n - p]), a = c[2 * n], e.opt_len += a * (s + o), f && (e.static_len += a * (h[2 * n + 1] + o)));
                                                if (0 !== b) {
                                                    do {
                                                        for(s = m - 1; 0 === e.bl_count[s];)s--;
                                                        e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[m]--, b -= 2;
                                                    }while (0 < b);
                                                    for(s = m; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (c[2 * i + 1] !== s && (e.opt_len += (s - c[2 * i + 1]) * c[2 * i], c[2 * i + 1] = s), n--);
                                                }
                                            }(e, t), A(s, u, e.bl_count);
                                        }
                                        function B(e, t, r) {
                                            var n, i, s = -1, o = t[1], a = 0, l = 7, c = 4;
                                            for(0 === o && (l = 138, c = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = o, o = t[2 * (n + 1) + 1], ++a < l && i === o || (a < c ? e.bl_tree[2 * i] += a : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[32]++) : a <= 10 ? e.bl_tree[34]++ : e.bl_tree[36]++, s = i, c = (a = 0) === o ? (l = 138, 3) : i === o ? (l = 6, 3) : (l = 7, 4));
                                        }
                                        function D(e, t, r) {
                                            var n, i, s = -1, o = t[1], a = 0, l = 7, c = 4;
                                            for(0 === o && (l = 138, c = 3), n = 0; n <= r; n++)if (i = o, o = t[2 * (n + 1) + 1], !(++a < l && i === o)) {
                                                if (a < c) for(; T(e, i, e.bl_tree), 0 != --a;);
                                                else 0 !== i ? (i !== s && (T(e, i, e.bl_tree), a--), T(e, 16, e.bl_tree), C(e, a - 3, 2)) : a <= 10 ? (T(e, 17, e.bl_tree), C(e, a - 3, 3)) : (T(e, 18, e.bl_tree), C(e, a - 11, 7));
                                                s = i, c = (a = 0) === o ? (l = 138, 3) : i === o ? (l = 6, 3) : (l = 7, 4);
                                            }
                                        }
                                        i(_);
                                        var F = !1;
                                        function L(e, t, r, i) {
                                            C(e, 0 + (i ? 1 : 0), 3), function(e, t, r, i) {
                                                O(e), M(e, r), M(e, ~r), n.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                                            }(e, t, r);
                                        }
                                        r._tr_init = function(e) {
                                            F || (function() {
                                                var e, t, r, n, i, s = new Array(16);
                                                for(n = r = 0; n < 28; n++)for(g[n] = r, e = 0; e < 1 << c[n]; e++)b[r++] = n;
                                                for(b[r - 1] = n, n = i = 0; n < 16; n++)for(_[n] = i, e = 0; e < 1 << u[n]; e++)m[i++] = n;
                                                for(i >>= 7; n < a; n++)for(_[n] = i << 7, e = 0; e < 1 << u[n] - 7; e++)m[256 + i++] = n;
                                                for(t = 0; t <= l; t++)s[t] = 0;
                                                for(e = 0; e <= 143;)d[2 * e + 1] = 8, e++, s[8]++;
                                                for(; e <= 255;)d[2 * e + 1] = 9, e++, s[9]++;
                                                for(; e <= 279;)d[2 * e + 1] = 7, e++, s[7]++;
                                                for(; e <= 287;)d[2 * e + 1] = 8, e++, s[8]++;
                                                for(A(d, 287, s), e = 0; e < a; e++)p[2 * e + 1] = 5, p[2 * e] = E(e, 5);
                                                y = new x(d, c, 257, o, l), v = new x(p, u, 0, a, l), w = new x(new Array(0), h, 0, 19, 7);
                                            }(), F = !0), e.l_desc = new k(e.dyn_ltree, y), e.d_desc = new k(e.dyn_dtree, v), e.bl_desc = new k(e.bl_tree, w), e.bi_buf = 0, e.bi_valid = 0, R(e);
                                        }, r._tr_stored_block = L, r._tr_flush_block = function(e, t, r, n) {
                                            var i, o, a = 0;
                                            0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                                                var t, r = 4093624447;
                                                for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return 0;
                                                if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;
                                                for(t = 32; t < s; t++)if (0 !== e.dyn_ltree[2 * t]) return 1;
                                                return 0;
                                            }(e)), P(e, e.l_desc), P(e, e.d_desc), a = function(e) {
                                                var t;
                                                for(B(e, e.dyn_ltree, e.l_desc.max_code), B(e, e.dyn_dtree, e.d_desc.max_code), P(e, e.bl_desc), t = 18; 3 <= t && 0 === e.bl_tree[2 * f[t] + 1]; t--);
                                                return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                                            }(e), i = e.opt_len + 3 + 7 >>> 3, (o = e.static_len + 3 + 7 >>> 3) <= i && (i = o)) : i = o = r + 5, r + 4 <= i && -1 !== t ? L(e, t, r, n) : 4 === e.strategy || o === i ? (C(e, 2 + (n ? 1 : 0), 3), N(e, d, p)) : (C(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                                                var i;
                                                for(C(e, t - 257, 5), C(e, r - 1, 5), C(e, n - 4, 4), i = 0; i < n; i++)C(e, e.bl_tree[2 * f[i] + 1], 3);
                                                D(e, e.dyn_ltree, t - 1), D(e, e.dyn_dtree, r - 1);
                                            }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), N(e, e.dyn_ltree, e.dyn_dtree)), R(e), n && O(e);
                                        }, r._tr_tally = function(e, t, r) {
                                            return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (b[r] + s + 1)]++, e.dyn_dtree[2 * S(t)]++), e.last_lit === e.lit_bufsize - 1;
                                        }, r._tr_align = function(e) {
                                            C(e, 2, 3), T(e, 256, d), function(e) {
                                                16 === e.bi_valid ? (M(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                                            }(e);
                                        };
                                    },
                                    {
                                        "../utils/common": 41
                                    }
                                ],
                                53: [
                                    function(e, t, r) {
                                        t.exports = function() {
                                            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                                        };
                                    },
                                    {}
                                ],
                                54: [
                                    function(e, t, r) {
                                        (function(e) {
                                            !function(e, t) {
                                                if (!e.setImmediate) {
                                                    var r, i, s, o, a = 1, l = {}, c = !1, u = e.document, h = Object.getPrototypeOf && Object.getPrototypeOf(e);
                                                    h = h && h.setTimeout ? h : e, r = "[object process]" === ({}).toString.call(e.process) ? function(e) {
                                                        n.nextTick(function() {
                                                            d(e);
                                                        });
                                                    } : function() {
                                                        if (e.postMessage && !e.importScripts) {
                                                            var t = !0, r = e.onmessage;
                                                            return e.onmessage = function() {
                                                                t = !1;
                                                            }, e.postMessage("", "*"), e.onmessage = r, t;
                                                        }
                                                    }() ? (o = "setImmediate$" + Math.random() + "$", e.addEventListener ? e.addEventListener("message", p, !1) : e.attachEvent("onmessage", p), function(t) {
                                                        e.postMessage(o + t, "*");
                                                    }) : e.MessageChannel ? ((s = new MessageChannel).port1.onmessage = function(e) {
                                                        d(e.data);
                                                    }, function(e) {
                                                        s.port2.postMessage(e);
                                                    }) : u && "onreadystatechange" in u.createElement("script") ? (i = u.documentElement, function(e) {
                                                        var t = u.createElement("script");
                                                        t.onreadystatechange = function() {
                                                            d(e), t.onreadystatechange = null, i.removeChild(t), t = null;
                                                        }, i.appendChild(t);
                                                    }) : function(e) {
                                                        setTimeout(d, 0, e);
                                                    }, h.setImmediate = function(e) {
                                                        "function" != typeof e && (e = new Function("" + e));
                                                        for(var t = new Array(arguments.length - 1), n = 0; n < t.length; n++)t[n] = arguments[n + 1];
                                                        var i = {
                                                            callback: e,
                                                            args: t
                                                        };
                                                        return l[a] = i, r(a), a++;
                                                    }, h.clearImmediate = f;
                                                }
                                                function f(e) {
                                                    delete l[e];
                                                }
                                                function d(e) {
                                                    if (c) setTimeout(d, 0, e);
                                                    else {
                                                        var t = l[e];
                                                        if (t) {
                                                            c = !0;
                                                            try {
                                                                !function(e) {
                                                                    var t = e.callback, r = e.args;
                                                                    switch(r.length){
                                                                        case 0:
                                                                            t();
                                                                            break;
                                                                        case 1:
                                                                            t(r[0]);
                                                                            break;
                                                                        case 2:
                                                                            t(r[0], r[1]);
                                                                            break;
                                                                        case 3:
                                                                            t(r[0], r[1], r[2]);
                                                                            break;
                                                                        default:
                                                                            t.apply(void 0, r);
                                                                    }
                                                                }(t);
                                                            } finally{
                                                                f(e), c = !1;
                                                            }
                                                        }
                                                    }
                                                }
                                                function p(t) {
                                                    t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(o) && d(+t.data.slice(o.length));
                                                }
                                            }("undefined" == typeof self ? void 0 === e ? this : e : self);
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ]
                            }, {}, [
                                10
                            ])(10);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], e("timers").setImmediate);
            },
            {
                _process: 467,
                buffer: 220,
                timers: 523
            }
        ],
        442: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = /[\\^$.*+?()[\]{}|]/g, n = RegExp(r.source), i = "object" == typeof e && e && e.Object === Object && e, s = "object" == typeof self && self && self.Object === Object && self, o = i || s || Function("return this")(), a = Object.prototype.toString, l = o.Symbol, c = l ? l.prototype : void 0, u = c ? c.toString : void 0;
                        function h(e) {
                            if ("string" == typeof e) return e;
                            if (function(e) {
                                return "symbol" == typeof e || function(e) {
                                    return !!e && "object" == typeof e;
                                }(e) && "[object Symbol]" == a.call(e);
                            }(e)) return u ? u.call(e) : "";
                            var t = e + "";
                            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                        }
                        t.exports = function(e) {
                            var t;
                            return (e = null == (t = e) ? "" : h(t)) && n.test(e) ? e.replace(r, "\\$&") : e;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        443: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var n = "[object Arguments]", i = "[object Map]", s = "[object Object]", o = "[object Set]", a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, l = /^\w*$/, c = /^\./, u = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, h = /\\(\\)?/g, f = /^\[object .+?Constructor\]$/, d = /^(?:0|[1-9]\d*)$/, p = {};
                        p["[object Float32Array]"] = p["[object Float64Array]"] = p["[object Int8Array]"] = p["[object Int16Array]"] = p["[object Int32Array]"] = p["[object Uint8Array]"] = p["[object Uint8ClampedArray]"] = p["[object Uint16Array]"] = p["[object Uint32Array]"] = !0, p[n] = p["[object Array]"] = p["[object ArrayBuffer]"] = p["[object Boolean]"] = p["[object DataView]"] = p["[object Date]"] = p["[object Error]"] = p["[object Function]"] = p[i] = p["[object Number]"] = p[s] = p["[object RegExp]"] = p[o] = p["[object String]"] = p["[object WeakMap]"] = !1;
                        var m = "object" == typeof e && e && e.Object === Object && e, b = "object" == typeof self && self && self.Object === Object && self, g = m || b || Function("return this")(), y = "object" == typeof r && r && !r.nodeType && r, v = y && "object" == typeof t && t && !t.nodeType && t, w = v && v.exports === y && m.process, _ = function() {
                            try {
                                return w && w.binding("util");
                            } catch (e) {}
                        }(), x = _ && _.isTypedArray;
                        function k(e, t, r, n) {
                            for(var i = -1, s = e ? e.length : 0; ++i < s;){
                                var o = e[i];
                                t(n, o, r(o), e);
                            }
                            return n;
                        }
                        function S(e, t) {
                            for(var r = -1, n = e ? e.length : 0; ++r < n;)if (t(e[r], r, e)) return !0;
                            return !1;
                        }
                        function M(e) {
                            var t = !1;
                            if (null != e && "function" != typeof e.toString) try {
                                t = !!(e + "");
                            } catch (e) {}
                            return t;
                        }
                        function C(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e, n) {
                                r[++t] = [
                                    n,
                                    e
                                ];
                            }), r;
                        }
                        function T(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var E, A, R, O = Array.prototype, j = Function.prototype, I = Object.prototype, N = g["__core-js_shared__"], P = (E = /[^.]+$/.exec(N && N.keys && N.keys.IE_PROTO || "")) ? "Symbol(src)_1." + E : "", B = j.toString, D = I.hasOwnProperty, F = I.toString, L = RegExp("^" + B.call(D).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), z = g.Symbol, U = g.Uint8Array, $ = I.propertyIsEnumerable, H = O.splice, V = (A = Object.keys, R = Object, function(e) {
                            return A(R(e));
                        }), q = Ce(g, "DataView"), W = Ce(g, "Map"), X = Ce(g, "Promise"), K = Ce(g, "Set"), Y = Ce(g, "WeakMap"), Z = Ce(Object, "create"), G = Ne(q), J = Ne(W), Q = Ne(X), ee = Ne(K), te = Ne(Y), re = z ? z.prototype : void 0, ne = re ? re.valueOf : void 0, ie = re ? re.toString : void 0;
                        function se(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function oe(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ae(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function le(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.__data__ = new ae; ++t < r;)this.add(e[t]);
                        }
                        function ce(e) {
                            this.__data__ = new oe(e);
                        }
                        function ue(e, t) {
                            var r = Ue(e) || ze(e) ? function(e, t) {
                                for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                                return n;
                            }(e.length, String) : [], n = r.length, i = !!n;
                            for(var s in e)!t && !D.call(e, s) || i && ("length" == s || Ee(s, n)) || r.push(s);
                            return r;
                        }
                        function he(e, t) {
                            for(var r = e.length; r--;)if (Le(e[r][0], t)) return r;
                            return -1;
                        }
                        function fe(e, t, r, n) {
                            return me(e, function(e, i, s) {
                                t(n, e, r(e), s);
                            }), n;
                        }
                        se.prototype.clear = function() {
                            this.__data__ = Z ? Z(null) : {};
                        }, se.prototype.delete = function(e) {
                            return this.has(e) && delete this.__data__[e];
                        }, se.prototype.get = function(e) {
                            var t = this.__data__;
                            if (Z) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return D.call(t, e) ? t[e] : void 0;
                        }, se.prototype.has = function(e) {
                            var t = this.__data__;
                            return Z ? void 0 !== t[e] : D.call(t, e);
                        }, se.prototype.set = function(e, t) {
                            return this.__data__[e] = Z && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, oe.prototype.clear = function() {
                            this.__data__ = [];
                        }, oe.prototype.delete = function(e) {
                            var t = this.__data__, r = he(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : H.call(t, r, 1), !0);
                        }, oe.prototype.get = function(e) {
                            var t = this.__data__, r = he(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, oe.prototype.has = function(e) {
                            return he(this.__data__, e) > -1;
                        }, oe.prototype.set = function(e, t) {
                            var r = this.__data__, n = he(r, e);
                            return n < 0 ? r.push([
                                e,
                                t
                            ]) : r[n][1] = t, this;
                        }, ae.prototype.clear = function() {
                            this.__data__ = {
                                hash: new se,
                                map: new (W || oe),
                                string: new se
                            };
                        }, ae.prototype.delete = function(e) {
                            return Me(this, e).delete(e);
                        }, ae.prototype.get = function(e) {
                            return Me(this, e).get(e);
                        }, ae.prototype.has = function(e) {
                            return Me(this, e).has(e);
                        }, ae.prototype.set = function(e, t) {
                            return Me(this, e).set(e, t), this;
                        }, le.prototype.add = le.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, le.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, ce.prototype.clear = function() {
                            this.__data__ = new oe;
                        }, ce.prototype.delete = function(e) {
                            return this.__data__.delete(e);
                        }, ce.prototype.get = function(e) {
                            return this.__data__.get(e);
                        }, ce.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, ce.prototype.set = function(e, t) {
                            var r = this.__data__;
                            if (r instanceof oe) {
                                var n = r.__data__;
                                if (!W || n.length < 199) return n.push([
                                    e,
                                    t
                                ]), this;
                                r = this.__data__ = new ae(n);
                            }
                            return r.set(e, t), this;
                        };
                        var de, pe, me = (de = function(e, t) {
                            return e && be(e, t, Ye);
                        }, function(e, t) {
                            if (null == e) return e;
                            if (!$e(e)) return de(e, t);
                            for(var r = e.length, n = pe ? r : -1, i = Object(e); (pe ? n-- : ++n < r) && !1 !== t(i[n], n, i););
                            return e;
                        }), be = function(e) {
                            return function(t, r, n) {
                                for(var i = -1, s = Object(t), o = n(t), a = o.length; a--;){
                                    var l = o[e ? a : ++i];
                                    if (!1 === r(s[l], l, s)) break;
                                }
                                return t;
                            };
                        }();
                        function ge(e, t) {
                            for(var r = 0, n = (t = Ae(t, e) ? [
                                t
                            ] : ke(t)).length; null != e && r < n;)e = e[Ie(t[r++])];
                            return r && r == n ? e : void 0;
                        }
                        function ye(e, t) {
                            return null != e && t in Object(e);
                        }
                        function ve(e, t, r, a, l) {
                            return e === t || (null == e || null == t || !qe(e) && !We(t) ? e != e && t != t : function(e, t, r, a, l, c) {
                                var u = Ue(e), h = Ue(t), f = "[object Array]", d = "[object Array]";
                                u || (f = (f = Te(e)) == n ? s : f);
                                h || (d = (d = Te(t)) == n ? s : d);
                                var p = f == s && !M(e), m = d == s && !M(t), b = f == d;
                                if (b && !p) return c || (c = new ce), u || Ke(e) ? Se(e, t, r, a, l, c) : function(e, t, r, n, s, a, l) {
                                    switch(r){
                                        case "[object DataView]":
                                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                            e = e.buffer, t = t.buffer;
                                        case "[object ArrayBuffer]":
                                            return !(e.byteLength != t.byteLength || !n(new U(e), new U(t)));
                                        case "[object Boolean]":
                                        case "[object Date]":
                                        case "[object Number]":
                                            return Le(+e, +t);
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                        case i:
                                            var c = C;
                                        case o:
                                            var u = 2 & a;
                                            if (c || (c = T), e.size != t.size && !u) return !1;
                                            var h = l.get(e);
                                            if (h) return h == t;
                                            a |= 1, l.set(e, t);
                                            var f = Se(c(e), c(t), n, s, a, l);
                                            return l.delete(e), f;
                                        case "[object Symbol]":
                                            if (ne) return ne.call(e) == ne.call(t);
                                    }
                                    return !1;
                                }(e, t, f, r, a, l, c);
                                if (!(2 & l)) {
                                    var g = p && D.call(e, "__wrapped__"), y = m && D.call(t, "__wrapped__");
                                    if (g || y) {
                                        var v = g ? e.value() : e, w = y ? t.value() : t;
                                        return c || (c = new ce), r(v, w, a, l, c);
                                    }
                                }
                                if (!b) return !1;
                                return c || (c = new ce), function(e, t, r, n, i, s) {
                                    var o = 2 & i, a = Ye(e), l = a.length, c = Ye(t).length;
                                    if (l != c && !o) return !1;
                                    var u = l;
                                    for(; u--;){
                                        var h = a[u];
                                        if (!(o ? h in t : D.call(t, h))) return !1;
                                    }
                                    var f = s.get(e);
                                    if (f && s.get(t)) return f == t;
                                    var d = !0;
                                    s.set(e, t), s.set(t, e);
                                    var p = o;
                                    for(; ++u < l;){
                                        h = a[u];
                                        var m = e[h], b = t[h];
                                        if (n) var g = o ? n(b, m, h, t, e, s) : n(m, b, h, e, t, s);
                                        if (!(void 0 === g ? m === b || r(m, b, n, i, s) : g)) {
                                            d = !1;
                                            break;
                                        }
                                        p || (p = "constructor" == h);
                                    }
                                    if (d && !p) {
                                        var y = e.constructor, v = t.constructor;
                                        y == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v || (d = !1);
                                    }
                                    return s.delete(e), s.delete(t), d;
                                }(e, t, r, a, l, c);
                            }(e, t, ve, r, a, l));
                        }
                        function we(e) {
                            return !(!qe(e) || function(e) {
                                return !!P && P in e;
                            }(e)) && (He(e) || M(e) ? L : f).test(Ne(e));
                        }
                        function _e(e) {
                            var t, r;
                            return "function" == typeof e ? e : null == e ? Ze : "object" == typeof e ? Ue(e) ? function(e, t) {
                                if (Ae(e) && Re(t)) return Oe(Ie(e), t);
                                return function(r) {
                                    var n = function(e, t, r) {
                                        var n = null == e ? void 0 : ge(e, t);
                                        return void 0 === n ? r : n;
                                    }(r, e);
                                    return void 0 === n && n === t ? function(e, t) {
                                        return null != e && function(e, t, r) {
                                            t = Ae(t, e) ? [
                                                t
                                            ] : ke(t);
                                            var n, i = -1, s = t.length;
                                            for(; ++i < s;){
                                                var o = Ie(t[i]);
                                                if (!(n = null != e && r(e, o))) break;
                                                e = e[o];
                                            }
                                            if (n) return n;
                                            return !!(s = e ? e.length : 0) && Ve(s) && Ee(o, s) && (Ue(e) || ze(e));
                                        }(e, t, ye);
                                    }(r, e) : ve(t, n, void 0, 3);
                                };
                            }(e[0], e[1]) : function(e) {
                                var t = function(e) {
                                    var t = Ye(e), r = t.length;
                                    for(; r--;){
                                        var n = t[r], i = e[n];
                                        t[r] = [
                                            n,
                                            i,
                                            Re(i)
                                        ];
                                    }
                                    return t;
                                }(e);
                                if (1 == t.length && t[0][2]) return Oe(t[0][0], t[0][1]);
                                return function(r) {
                                    return r === e || function(e, t, r, n) {
                                        var i = r.length, s = i, o = !n;
                                        if (null == e) return !s;
                                        for(e = Object(e); i--;){
                                            var a = r[i];
                                            if (o && a[2] ? a[1] !== e[a[0]] : !(a[0] in e)) return !1;
                                        }
                                        for(; ++i < s;){
                                            var l = (a = r[i])[0], c = e[l], u = a[1];
                                            if (o && a[2]) {
                                                if (void 0 === c && !(l in e)) return !1;
                                            } else {
                                                var h = new ce;
                                                if (n) var f = n(c, u, l, e, t, h);
                                                if (!(void 0 === f ? ve(u, c, n, 3, h) : f)) return !1;
                                            }
                                        }
                                        return !0;
                                    }(r, e, t);
                                };
                            }(e) : Ae(t = e) ? (r = Ie(t), function(e) {
                                return null == e ? void 0 : e[r];
                            }) : function(e) {
                                return function(t) {
                                    return ge(t, e);
                                };
                            }(t);
                        }
                        function xe(e) {
                            if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || I, t !== n) return V(e);
                            var t, r, n, i = [];
                            for(var s in Object(e))D.call(e, s) && "constructor" != s && i.push(s);
                            return i;
                        }
                        function ke(e) {
                            return Ue(e) ? e : je(e);
                        }
                        function Se(e, t, r, n, i, s) {
                            var o = 2 & i, a = e.length, l = t.length;
                            if (a != l && !(o && l > a)) return !1;
                            var c = s.get(e);
                            if (c && s.get(t)) return c == t;
                            var u = -1, h = !0, f = 1 & i ? new le : void 0;
                            for(s.set(e, t), s.set(t, e); ++u < a;){
                                var d = e[u], p = t[u];
                                if (n) var m = o ? n(p, d, u, t, e, s) : n(d, p, u, e, t, s);
                                if (void 0 !== m) {
                                    if (m) continue;
                                    h = !1;
                                    break;
                                }
                                if (f) {
                                    if (!S(t, function(e, t) {
                                        if (!f.has(t) && (d === e || r(d, e, n, i, s))) return f.add(t);
                                    })) {
                                        h = !1;
                                        break;
                                    }
                                } else if (d !== p && !r(d, p, n, i, s)) {
                                    h = !1;
                                    break;
                                }
                            }
                            return s.delete(e), s.delete(t), h;
                        }
                        function Me(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function Ce(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return we(r) ? r : void 0;
                        }
                        var Te = function(e) {
                            return F.call(e);
                        };
                        function Ee(e, t) {
                            return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || d.test(e)) && e > -1 && e % 1 == 0 && e < t;
                        }
                        function Ae(e, t) {
                            if (Ue(e)) return !1;
                            var r = typeof e;
                            return !("number" != r && "symbol" != r && "boolean" != r && null != e && !Xe(e)) || l.test(e) || !a.test(e) || null != t && e in Object(t);
                        }
                        function Re(e) {
                            return e == e && !qe(e);
                        }
                        function Oe(e, t) {
                            return function(r) {
                                return null != r && r[e] === t && (void 0 !== t || e in Object(r));
                            };
                        }
                        (q && "[object DataView]" != Te(new q(new ArrayBuffer(1))) || W && Te(new W) != i || X && "[object Promise]" != Te(X.resolve()) || K && Te(new K) != o || Y && "[object WeakMap]" != Te(new Y)) && (Te = function(e) {
                            var t = F.call(e), r = t == s ? e.constructor : void 0, n = r ? Ne(r) : void 0;
                            if (n) switch(n){
                                case G:
                                    return "[object DataView]";
                                case J:
                                    return i;
                                case Q:
                                    return "[object Promise]";
                                case ee:
                                    return o;
                                case te:
                                    return "[object WeakMap]";
                            }
                            return t;
                        });
                        var je = Fe(function(e) {
                            var t;
                            e = null == (t = e) ? "" : function(e) {
                                if ("string" == typeof e) return e;
                                if (Xe(e)) return ie ? ie.call(e) : "";
                                var t = e + "";
                                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                            }(t);
                            var r = [];
                            return c.test(e) && r.push(""), e.replace(u, function(e, t, n, i) {
                                r.push(n ? i.replace(h, "$1") : t || e);
                            }), r;
                        });
                        function Ie(e) {
                            if ("string" == typeof e || Xe(e)) return e;
                            var t = e + "";
                            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                        }
                        function Ne(e) {
                            if (null != e) {
                                try {
                                    return B.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        }
                        var Pe, Be, De = (Pe = function(e, t, r) {
                            D.call(e, r) ? e[r].push(t) : e[r] = [
                                t
                            ];
                        }, function(e, t) {
                            var r = Ue(e) ? k : fe, n = Be ? Be() : {};
                            return r(e, Pe, _e(t), n);
                        });
                        function Fe(e, t) {
                            if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");
                            var r = function() {
                                var n = arguments, i = t ? t.apply(this, n) : n[0], s = r.cache;
                                if (s.has(i)) return s.get(i);
                                var o = e.apply(this, n);
                                return r.cache = s.set(i, o), o;
                            };
                            return r.cache = new (Fe.Cache || ae), r;
                        }
                        function Le(e, t) {
                            return e === t || e != e && t != t;
                        }
                        function ze(e) {
                            return function(e) {
                                return We(e) && $e(e);
                            }(e) && D.call(e, "callee") && (!$.call(e, "callee") || F.call(e) == n);
                        }
                        Fe.Cache = ae;
                        var Ue = Array.isArray;
                        function $e(e) {
                            return null != e && Ve(e.length) && !He(e);
                        }
                        function He(e) {
                            var t = qe(e) ? F.call(e) : "";
                            return "[object Function]" == t || "[object GeneratorFunction]" == t;
                        }
                        function Ve(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                        }
                        function qe(e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                        }
                        function We(e) {
                            return !!e && "object" == typeof e;
                        }
                        function Xe(e) {
                            return "symbol" == typeof e || We(e) && "[object Symbol]" == F.call(e);
                        }
                        var Ke = x ? function(e) {
                            return function(t) {
                                return e(t);
                            };
                        }(x) : function(e) {
                            return We(e) && Ve(e.length) && !!p[F.call(e)];
                        };
                        function Ye(e) {
                            return $e(e) ? ue(e) : xe(e);
                        }
                        function Ze(e) {
                            return e;
                        }
                        t.exports = De;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        444: [
            function(e, t, r) {
                "use strict";
                var n = Object.prototype.toString;
                t.exports = function(e) {
                    return !0 === e || !1 === e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Boolean]" == n.call(e);
                };
            },
            {}
        ],
        445: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var n = "[object Arguments]", i = "[object Map]", s = "[object Object]", o = "[object Set]", a = /^\[object .+?Constructor\]$/, l = /^(?:0|[1-9]\d*)$/, c = {};
                        c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c[n] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c["[object Function]"] = c[i] = c["[object Number]"] = c[s] = c["[object RegExp]"] = c[o] = c["[object String]"] = c["[object WeakMap]"] = !1;
                        var u = "object" == typeof e && e && e.Object === Object && e, h = "object" == typeof self && self && self.Object === Object && self, f = u || h || Function("return this")(), d = "object" == typeof r && r && !r.nodeType && r, p = d && "object" == typeof t && t && !t.nodeType && t, m = p && p.exports === d, b = m && u.process, g = function() {
                            try {
                                return b && b.binding && b.binding("util");
                            } catch (e) {}
                        }(), y = g && g.isTypedArray;
                        function v(e, t) {
                            for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (t(e[r], r, e)) return !0;
                            return !1;
                        }
                        function w(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e, n) {
                                r[++t] = [
                                    n,
                                    e
                                ];
                            }), r;
                        }
                        function _(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var x, k, S, M = Array.prototype, C = Function.prototype, T = Object.prototype, E = f["__core-js_shared__"], A = C.toString, R = T.hasOwnProperty, O = (x = /[^.]+$/.exec(E && E.keys && E.keys.IE_PROTO || "")) ? "Symbol(src)_1." + x : "", j = T.toString, I = RegExp("^" + A.call(R).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), N = m ? f.Buffer : void 0, P = f.Symbol, B = f.Uint8Array, D = T.propertyIsEnumerable, F = M.splice, L = P ? P.toStringTag : void 0, z = Object.getOwnPropertySymbols, U = N ? N.isBuffer : void 0, $ = (k = Object.keys, S = Object, function(e) {
                            return k(S(e));
                        }), H = ge(f, "DataView"), V = ge(f, "Map"), q = ge(f, "Promise"), W = ge(f, "Set"), X = ge(f, "WeakMap"), K = ge(Object, "create"), Y = _e(H), Z = _e(V), G = _e(q), J = _e(W), Q = _e(X), ee = P ? P.prototype : void 0, te = ee ? ee.valueOf : void 0;
                        function re(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ne(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ie(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function se(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.__data__ = new ie; ++t < r;)this.add(e[t]);
                        }
                        function oe(e) {
                            var t = this.__data__ = new ne(e);
                            this.size = t.size;
                        }
                        function ae(e, t) {
                            var r = Se(e), n = !r && ke(e), i = !r && !n && Me(e), s = !r && !n && !i && Re(e), o = r || n || i || s, a = o ? function(e, t) {
                                for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                                return n;
                            }(e.length, String) : [], l = a.length;
                            for(var c in e)!t && !R.call(e, c) || o && ("length" == c || i && ("offset" == c || "parent" == c) || s && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || we(c, l)) || a.push(c);
                            return a;
                        }
                        function le(e, t) {
                            for(var r = e.length; r--;)if (xe(e[r][0], t)) return r;
                            return -1;
                        }
                        function ce(e) {
                            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : L && L in Object(e) ? function(e) {
                                var t = R.call(e, L), r = e[L];
                                try {
                                    e[L] = void 0;
                                    var n = !0;
                                } catch (e) {}
                                var i = j.call(e);
                                n && (t ? e[L] = r : delete e[L]);
                                return i;
                            }(e) : function(e) {
                                return j.call(e);
                            }(e);
                        }
                        function ue(e) {
                            return Ae(e) && ce(e) == n;
                        }
                        function he(e, t, r, a, l) {
                            return e === t || (null == e || null == t || !Ae(e) && !Ae(t) ? e != e && t != t : function(e, t, r, a, l, c) {
                                var u = Se(e), h = Se(t), f = u ? "[object Array]" : ve(e), d = h ? "[object Array]" : ve(t), p = (f = f == n ? s : f) == s, m = (d = d == n ? s : d) == s, b = f == d;
                                if (b && Me(e)) {
                                    if (!Me(t)) return !1;
                                    u = !0, p = !1;
                                }
                                if (b && !p) return c || (c = new oe), u || Re(e) ? pe(e, t, r, a, l, c) : function(e, t, r, n, s, a, l) {
                                    switch(r){
                                        case "[object DataView]":
                                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                            e = e.buffer, t = t.buffer;
                                        case "[object ArrayBuffer]":
                                            return !(e.byteLength != t.byteLength || !a(new B(e), new B(t)));
                                        case "[object Boolean]":
                                        case "[object Date]":
                                        case "[object Number]":
                                            return xe(+e, +t);
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                        case i:
                                            var c = w;
                                        case o:
                                            var u = 1 & n;
                                            if (c || (c = _), e.size != t.size && !u) return !1;
                                            var h = l.get(e);
                                            if (h) return h == t;
                                            n |= 2, l.set(e, t);
                                            var f = pe(c(e), c(t), n, s, a, l);
                                            return l.delete(e), f;
                                        case "[object Symbol]":
                                            if (te) return te.call(e) == te.call(t);
                                    }
                                    return !1;
                                }(e, t, f, r, a, l, c);
                                if (!(1 & r)) {
                                    var g = p && R.call(e, "__wrapped__"), y = m && R.call(t, "__wrapped__");
                                    if (g || y) {
                                        var v = g ? e.value() : e, x = y ? t.value() : t;
                                        return c || (c = new oe), l(v, x, r, a, c);
                                    }
                                }
                                if (!b) return !1;
                                return c || (c = new oe), function(e, t, r, n, i, s) {
                                    var o = 1 & r, a = me(e), l = a.length, c = me(t).length;
                                    if (l != c && !o) return !1;
                                    var u = l;
                                    for(; u--;){
                                        var h = a[u];
                                        if (!(o ? h in t : R.call(t, h))) return !1;
                                    }
                                    var f = s.get(e);
                                    if (f && s.get(t)) return f == t;
                                    var d = !0;
                                    s.set(e, t), s.set(t, e);
                                    var p = o;
                                    for(; ++u < l;){
                                        h = a[u];
                                        var m = e[h], b = t[h];
                                        if (n) var g = o ? n(b, m, h, t, e, s) : n(m, b, h, e, t, s);
                                        if (!(void 0 === g ? m === b || i(m, b, r, n, s) : g)) {
                                            d = !1;
                                            break;
                                        }
                                        p || (p = "constructor" == h);
                                    }
                                    if (d && !p) {
                                        var y = e.constructor, v = t.constructor;
                                        y == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v || (d = !1);
                                    }
                                    return s.delete(e), s.delete(t), d;
                                }(e, t, r, a, l, c);
                            }(e, t, r, a, he, l));
                        }
                        function fe(e) {
                            return !(!Ee(e) || function(e) {
                                return !!O && O in e;
                            }(e)) && (Ce(e) ? I : a).test(_e(e));
                        }
                        function de(e) {
                            if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || T, t !== n) return $(e);
                            var t, r, n, i = [];
                            for(var s in Object(e))R.call(e, s) && "constructor" != s && i.push(s);
                            return i;
                        }
                        function pe(e, t, r, n, i, s) {
                            var o = 1 & r, a = e.length, l = t.length;
                            if (a != l && !(o && l > a)) return !1;
                            var c = s.get(e);
                            if (c && s.get(t)) return c == t;
                            var u = -1, h = !0, f = 2 & r ? new se : void 0;
                            for(s.set(e, t), s.set(t, e); ++u < a;){
                                var d = e[u], p = t[u];
                                if (n) var m = o ? n(p, d, u, t, e, s) : n(d, p, u, e, t, s);
                                if (void 0 !== m) {
                                    if (m) continue;
                                    h = !1;
                                    break;
                                }
                                if (f) {
                                    if (!v(t, function(e, t) {
                                        if (o = t, !f.has(o) && (d === e || i(d, e, r, n, s))) return f.push(t);
                                        var o;
                                    })) {
                                        h = !1;
                                        break;
                                    }
                                } else if (d !== p && !i(d, p, r, n, s)) {
                                    h = !1;
                                    break;
                                }
                            }
                            return s.delete(e), s.delete(t), h;
                        }
                        function me(e) {
                            return function(e, t, r) {
                                var n = t(e);
                                return Se(e) ? n : function(e, t) {
                                    for(var r = -1, n = t.length, i = e.length; ++r < n;)e[i + r] = t[r];
                                    return e;
                                }(n, r(e));
                            }(e, Oe, ye);
                        }
                        function be(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function ge(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return fe(r) ? r : void 0;
                        }
                        re.prototype.clear = function() {
                            this.__data__ = K ? K(null) : {}, this.size = 0;
                        }, re.prototype.delete = function(e) {
                            var t = this.has(e) && delete this.__data__[e];
                            return this.size -= t ? 1 : 0, t;
                        }, re.prototype.get = function(e) {
                            var t = this.__data__;
                            if (K) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return R.call(t, e) ? t[e] : void 0;
                        }, re.prototype.has = function(e) {
                            var t = this.__data__;
                            return K ? void 0 !== t[e] : R.call(t, e);
                        }, re.prototype.set = function(e, t) {
                            var r = this.__data__;
                            return this.size += this.has(e) ? 0 : 1, r[e] = K && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, ne.prototype.clear = function() {
                            this.__data__ = [], this.size = 0;
                        }, ne.prototype.delete = function(e) {
                            var t = this.__data__, r = le(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : F.call(t, r, 1), --this.size, !0);
                        }, ne.prototype.get = function(e) {
                            var t = this.__data__, r = le(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, ne.prototype.has = function(e) {
                            return le(this.__data__, e) > -1;
                        }, ne.prototype.set = function(e, t) {
                            var r = this.__data__, n = le(r, e);
                            return n < 0 ? (++this.size, r.push([
                                e,
                                t
                            ])) : r[n][1] = t, this;
                        }, ie.prototype.clear = function() {
                            this.size = 0, this.__data__ = {
                                hash: new re,
                                map: new (V || ne),
                                string: new re
                            };
                        }, ie.prototype.delete = function(e) {
                            var t = be(this, e).delete(e);
                            return this.size -= t ? 1 : 0, t;
                        }, ie.prototype.get = function(e) {
                            return be(this, e).get(e);
                        }, ie.prototype.has = function(e) {
                            return be(this, e).has(e);
                        }, ie.prototype.set = function(e, t) {
                            var r = be(this, e), n = r.size;
                            return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
                        }, se.prototype.add = se.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, se.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, oe.prototype.clear = function() {
                            this.__data__ = new ne, this.size = 0;
                        }, oe.prototype.delete = function(e) {
                            var t = this.__data__, r = t.delete(e);
                            return this.size = t.size, r;
                        }, oe.prototype.get = function(e) {
                            return this.__data__.get(e);
                        }, oe.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, oe.prototype.set = function(e, t) {
                            var r = this.__data__;
                            if (r instanceof ne) {
                                var n = r.__data__;
                                if (!V || n.length < 199) return n.push([
                                    e,
                                    t
                                ]), this.size = ++r.size, this;
                                r = this.__data__ = new ie(n);
                            }
                            return r.set(e, t), this.size = r.size, this;
                        };
                        var ye = z ? function(e) {
                            return null == e ? [] : (e = Object(e), function(e, t) {
                                for(var r = -1, n = null == e ? 0 : e.length, i = 0, s = []; ++r < n;){
                                    var o = e[r];
                                    t(o, r, e) && (s[i++] = o);
                                }
                                return s;
                            }(z(e), function(t) {
                                return D.call(e, t);
                            }));
                        } : function() {
                            return [];
                        }, ve = ce;
                        function we(e, t) {
                            return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || l.test(e)) && e > -1 && e % 1 == 0 && e < t;
                        }
                        function _e(e) {
                            if (null != e) {
                                try {
                                    return A.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        }
                        function xe(e, t) {
                            return e === t || e != e && t != t;
                        }
                        (H && "[object DataView]" != ve(new H(new ArrayBuffer(1))) || V && ve(new V) != i || q && "[object Promise]" != ve(q.resolve()) || W && ve(new W) != o || X && "[object WeakMap]" != ve(new X)) && (ve = function(e) {
                            var t = ce(e), r = t == s ? e.constructor : void 0, n = r ? _e(r) : "";
                            if (n) switch(n){
                                case Y:
                                    return "[object DataView]";
                                case Z:
                                    return i;
                                case G:
                                    return "[object Promise]";
                                case J:
                                    return o;
                                case Q:
                                    return "[object WeakMap]";
                            }
                            return t;
                        });
                        var ke = ue(function() {
                            return arguments;
                        }()) ? ue : function(e) {
                            return Ae(e) && R.call(e, "callee") && !D.call(e, "callee");
                        }, Se = Array.isArray;
                        var Me = U || function() {
                            return !1;
                        };
                        function Ce(e) {
                            if (!Ee(e)) return !1;
                            var t = ce(e);
                            return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                        }
                        function Te(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                        }
                        function Ee(e) {
                            var t = typeof e;
                            return null != e && ("object" == t || "function" == t);
                        }
                        function Ae(e) {
                            return null != e && "object" == typeof e;
                        }
                        var Re = y ? function(e) {
                            return function(t) {
                                return e(t);
                            };
                        }(y) : function(e) {
                            return Ae(e) && Te(e.length) && !!c[ce(e)];
                        };
                        function Oe(e) {
                            var t;
                            return null != (t = e) && Te(t.length) && !Ce(t) ? ae(e) : de(e);
                        }
                        t.exports = function(e, t) {
                            return he(e, t);
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        446: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = "object" == typeof e && e && e.Object === Object && e, n = "object" == typeof self && self && self.Object === Object && self, i = r || n || Function("return this")(), s = Object.prototype, o = s.hasOwnProperty, a = s.toString, l = i.Symbol, c = l ? l.toStringTag : void 0;
                        function u(e) {
                            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : c && c in Object(e) ? function(e) {
                                var t = o.call(e, c), r = e[c];
                                try {
                                    e[c] = void 0;
                                    var n = !0;
                                } catch (e) {}
                                var i = a.call(e);
                                n && (t ? e[c] = r : delete e[c]);
                                return i;
                            }(e) : function(e) {
                                return a.call(e);
                            }(e);
                        }
                        t.exports = function(e) {
                            if (!function(e) {
                                var t = typeof e;
                                return null != e && ("object" == t || "function" == t);
                            }(e)) return !1;
                            var t = u(e);
                            return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        447: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return null == e;
                };
            },
            {}
        ],
        448: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return void 0 === e;
                };
            },
            {}
        ],
        449: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = /^\[object .+?Constructor\]$/, n = "object" == typeof e && e && e.Object === Object && e, i = "object" == typeof self && self && self.Object === Object && self, s = n || i || Function("return this")();
                        function o(e, t) {
                            return !!(e ? e.length : 0) && function(e, t, r) {
                                if (t != t) return function(e, t, r, n) {
                                    var i = e.length, s = r + (n ? 1 : -1);
                                    for(; n ? s-- : ++s < i;)if (t(e[s], s, e)) return s;
                                    return -1;
                                }(e, l, r);
                                var n = r - 1, i = e.length;
                                for(; ++n < i;)if (e[n] === t) return n;
                                return -1;
                            }(e, t, 0) > -1;
                        }
                        function a(e, t, r) {
                            for(var n = -1, i = e ? e.length : 0; ++n < i;)if (r(t, e[n])) return !0;
                            return !1;
                        }
                        function l(e) {
                            return e != e;
                        }
                        function c(e, t) {
                            return e.has(t);
                        }
                        function u(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var h, f = Array.prototype, d = Function.prototype, p = Object.prototype, m = s["__core-js_shared__"], b = (h = /[^.]+$/.exec(m && m.keys && m.keys.IE_PROTO || "")) ? "Symbol(src)_1." + h : "", g = d.toString, y = p.hasOwnProperty, v = p.toString, w = RegExp("^" + g.call(y).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), _ = f.splice, x = I(s, "Map"), k = I(s, "Set"), S = I(Object, "create");
                        function M(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function C(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function T(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function E(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.__data__ = new T; ++t < r;)this.add(e[t]);
                        }
                        function A(e, t) {
                            for(var r, n, i = e.length; i--;)if ((r = e[i][0]) === (n = t) || r != r && n != n) return i;
                            return -1;
                        }
                        function R(e) {
                            var t;
                            return !(!N(e) || (t = e, b && b in t)) && ((function(e) {
                                var t = N(e) ? v.call(e) : "";
                                return "[object Function]" == t || "[object GeneratorFunction]" == t;
                            })(e) || function(e) {
                                var t = !1;
                                if (null != e && "function" != typeof e.toString) try {
                                    t = !!(e + "");
                                } catch (e) {}
                                return t;
                            }(e) ? w : r).test(function(e) {
                                if (null != e) {
                                    try {
                                        return g.call(e);
                                    } catch (e) {}
                                    try {
                                        return e + "";
                                    } catch (e) {}
                                }
                                return "";
                            }(e));
                        }
                        M.prototype.clear = function() {
                            this.__data__ = S ? S(null) : {};
                        }, M.prototype.delete = function(e) {
                            return this.has(e) && delete this.__data__[e];
                        }, M.prototype.get = function(e) {
                            var t = this.__data__;
                            if (S) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return y.call(t, e) ? t[e] : void 0;
                        }, M.prototype.has = function(e) {
                            var t = this.__data__;
                            return S ? void 0 !== t[e] : y.call(t, e);
                        }, M.prototype.set = function(e, t) {
                            return this.__data__[e] = S && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, C.prototype.clear = function() {
                            this.__data__ = [];
                        }, C.prototype.delete = function(e) {
                            var t = this.__data__, r = A(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : _.call(t, r, 1), !0);
                        }, C.prototype.get = function(e) {
                            var t = this.__data__, r = A(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, C.prototype.has = function(e) {
                            return A(this.__data__, e) > -1;
                        }, C.prototype.set = function(e, t) {
                            var r = this.__data__, n = A(r, e);
                            return n < 0 ? r.push([
                                e,
                                t
                            ]) : r[n][1] = t, this;
                        }, T.prototype.clear = function() {
                            this.__data__ = {
                                hash: new M,
                                map: new (x || C),
                                string: new M
                            };
                        }, T.prototype.delete = function(e) {
                            return j(this, e).delete(e);
                        }, T.prototype.get = function(e) {
                            return j(this, e).get(e);
                        }, T.prototype.has = function(e) {
                            return j(this, e).has(e);
                        }, T.prototype.set = function(e, t) {
                            return j(this, e).set(e, t), this;
                        }, E.prototype.add = E.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, E.prototype.has = function(e) {
                            return this.__data__.has(e);
                        };
                        var O = k && 1 / u(new k([
                            ,
                            -0
                        ]))[1] == 1 / 0 ? function(e) {
                            return new k(e);
                        } : function() {};
                        function j(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function I(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return R(r) ? r : void 0;
                        }
                        function N(e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                        }
                        t.exports = function(e) {
                            return e && e.length ? function(e, t, r) {
                                var n = -1, i = o, s = e.length, l = !0, h = [], f = h;
                                if (r) l = !1, i = a;
                                else if (s >= 200) {
                                    var d = t ? null : O(e);
                                    if (d) return u(d);
                                    l = !1, i = c, f = new E;
                                } else f = t ? [] : h;
                                e: for(; ++n < s;){
                                    var p = e[n], m = t ? t(p) : p;
                                    if (p = r || 0 !== p ? p : 0, l && m == m) {
                                        for(var b = f.length; b--;)if (f[b] === m) continue e;
                                        t && f.push(m), h.push(p);
                                    } else i(f, m, r) || (f !== h && f.push(m), h.push(p));
                                }
                                return h;
                            }(e) : [];
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        450: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("hash-base"), s = e("safe-buffer").Buffer, o = new Array(16);
                function a() {
                    i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
                }
                function l(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function c(e, t, r, n, i, s, o) {
                    return l(e + (t & r | ~t & n) + i + s | 0, o) + t | 0;
                }
                function u(e, t, r, n, i, s, o) {
                    return l(e + (t & n | r & ~n) + i + s | 0, o) + t | 0;
                }
                function h(e, t, r, n, i, s, o) {
                    return l(e + (t ^ r ^ n) + i + s | 0, o) + t | 0;
                }
                function f(e, t, r, n, i, s, o) {
                    return l(e + (r ^ (t | ~n)) + i + s | 0, o) + t | 0;
                }
                n(a, i), a.prototype._update = function() {
                    for(var e = o, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    var r = this._a, n = this._b, i = this._c, s = this._d;
                    r = c(r, n, i, s, e[0], 3614090360, 7), s = c(s, r, n, i, e[1], 3905402710, 12), i = c(i, s, r, n, e[2], 606105819, 17), n = c(n, i, s, r, e[3], 3250441966, 22), r = c(r, n, i, s, e[4], 4118548399, 7), s = c(s, r, n, i, e[5], 1200080426, 12), i = c(i, s, r, n, e[6], 2821735955, 17), n = c(n, i, s, r, e[7], 4249261313, 22), r = c(r, n, i, s, e[8], 1770035416, 7), s = c(s, r, n, i, e[9], 2336552879, 12), i = c(i, s, r, n, e[10], 4294925233, 17), n = c(n, i, s, r, e[11], 2304563134, 22), r = c(r, n, i, s, e[12], 1804603682, 7), s = c(s, r, n, i, e[13], 4254626195, 12), i = c(i, s, r, n, e[14], 2792965006, 17), r = u(r, n = c(n, i, s, r, e[15], 1236535329, 22), i, s, e[1], 4129170786, 5), s = u(s, r, n, i, e[6], 3225465664, 9), i = u(i, s, r, n, e[11], 643717713, 14), n = u(n, i, s, r, e[0], 3921069994, 20), r = u(r, n, i, s, e[5], 3593408605, 5), s = u(s, r, n, i, e[10], 38016083, 9), i = u(i, s, r, n, e[15], 3634488961, 14), n = u(n, i, s, r, e[4], 3889429448, 20), r = u(r, n, i, s, e[9], 568446438, 5), s = u(s, r, n, i, e[14], 3275163606, 9), i = u(i, s, r, n, e[3], 4107603335, 14), n = u(n, i, s, r, e[8], 1163531501, 20), r = u(r, n, i, s, e[13], 2850285829, 5), s = u(s, r, n, i, e[2], 4243563512, 9), i = u(i, s, r, n, e[7], 1735328473, 14), r = h(r, n = u(n, i, s, r, e[12], 2368359562, 20), i, s, e[5], 4294588738, 4), s = h(s, r, n, i, e[8], 2272392833, 11), i = h(i, s, r, n, e[11], 1839030562, 16), n = h(n, i, s, r, e[14], 4259657740, 23), r = h(r, n, i, s, e[1], 2763975236, 4), s = h(s, r, n, i, e[4], 1272893353, 11), i = h(i, s, r, n, e[7], 4139469664, 16), n = h(n, i, s, r, e[10], 3200236656, 23), r = h(r, n, i, s, e[13], 681279174, 4), s = h(s, r, n, i, e[0], 3936430074, 11), i = h(i, s, r, n, e[3], 3572445317, 16), n = h(n, i, s, r, e[6], 76029189, 23), r = h(r, n, i, s, e[9], 3654602809, 4), s = h(s, r, n, i, e[12], 3873151461, 11), i = h(i, s, r, n, e[15], 530742520, 16), r = f(r, n = h(n, i, s, r, e[2], 3299628645, 23), i, s, e[0], 4096336452, 6), s = f(s, r, n, i, e[7], 1126891415, 10), i = f(i, s, r, n, e[14], 2878612391, 15), n = f(n, i, s, r, e[5], 4237533241, 21), r = f(r, n, i, s, e[12], 1700485571, 6), s = f(s, r, n, i, e[3], 2399980690, 10), i = f(i, s, r, n, e[10], 4293915773, 15), n = f(n, i, s, r, e[1], 2240044497, 21), r = f(r, n, i, s, e[8], 1873313359, 6), s = f(s, r, n, i, e[15], 4264355552, 10), i = f(i, s, r, n, e[6], 2734768916, 15), n = f(n, i, s, r, e[13], 1309151649, 21), r = f(r, n, i, s, e[4], 4149444226, 6), s = f(s, r, n, i, e[11], 3174756917, 10), i = f(i, s, r, n, e[2], 718787259, 15), n = f(n, i, s, r, e[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + s | 0;
                }, a.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = s.allocUnsafe(16);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
                }, t.exports = a;
            },
            {
                "hash-base": 425,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        451: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("brorand");
                function s(e) {
                    this.rand = e || new i.Rand;
                }
                t.exports = s, s.create = function(e) {
                    return new s(e);
                }, s.prototype._randbelow = function(e) {
                    var t = e.bitLength(), r = Math.ceil(t / 8);
                    do var i = new n(this.rand.generate(r));
                    while (i.cmp(e) >= 0);
                    return i;
                }, s.prototype._randrange = function(e, t) {
                    var r = t.sub(e);
                    return e.add(this._randbelow(r));
                }, s.prototype.test = function(e, t, r) {
                    var i = e.bitLength(), s = n.mont(e), o = new n(1).toRed(s);
                    t || (t = Math.max(1, i / 48 | 0));
                    for(var a = e.subn(1), l = 0; !a.testn(l); l++);
                    for(var c = e.shrn(l), u = a.toRed(s); t > 0; t--){
                        var h = this._randrange(new n(2), a);
                        r && r(h);
                        var f = h.toRed(s).redPow(c);
                        if (0 !== f.cmp(o) && 0 !== f.cmp(u)) {
                            for(var d = 1; d < l; d++){
                                if (0 === (f = f.redSqr()).cmp(o)) return !1;
                                if (0 === f.cmp(u)) break;
                            }
                            if (d === l) return !1;
                        }
                    }
                    return !0;
                }, s.prototype.getDivisor = function(e, t) {
                    var r = e.bitLength(), i = n.mont(e), s = new n(1).toRed(i);
                    t || (t = Math.max(1, r / 48 | 0));
                    for(var o = e.subn(1), a = 0; !o.testn(a); a++);
                    for(var l = e.shrn(a), c = o.toRed(i); t > 0; t--){
                        var u = this._randrange(new n(2), o), h = e.gcd(u);
                        if (0 !== h.cmpn(1)) return h;
                        var f = u.toRed(i).redPow(l);
                        if (0 !== f.cmp(s) && 0 !== f.cmp(c)) {
                            for(var d = 1; d < a; d++){
                                if (0 === (f = f.redSqr()).cmp(s)) return f.fromRed().subn(1).gcd(e);
                                if (0 === f.cmp(c)) break;
                            }
                            if (d === a) return (f = f.redSqr()).fromRed().subn(1).gcd(e);
                        }
                    }
                    return !1;
                };
            },
            {
                "bn.js": 452,
                brorand: 187
            }
        ],
        452: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        453: [
            function(e, t, r) {
                "use strict";
                function n(e, t) {
                    if (!e) throw new Error(t || "Assertion failed");
                }
                t.exports = n, n.equal = function(e, t, r) {
                    if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
                };
            },
            {}
        ],
        454: [
            function(e, t, r) {
                "use strict";
                var n = r;
                function i(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function s(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += i(e[r].toString(16));
                    return t;
                }
                n.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" != typeof e) {
                        for(var n = 0; n < e.length; n++)r[n] = 0 | e[n];
                        return r;
                    }
                    if ("hex" === t) {
                        (e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e);
                        for(n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
                    } else for(n = 0; n < e.length; n++){
                        var i = e.charCodeAt(n), s = i >> 8, o = 255 & i;
                        s ? r.push(s, o) : r.push(o);
                    }
                    return r;
                }, n.zero2 = i, n.toHex = s, n.encode = function(e, t) {
                    return "hex" === t ? s(e) : e;
                };
            },
            {}
        ],
        455: [
            function(e, t, r) {
                t.exports = {
                    "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
                    "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
                    "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
                    "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
                    "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
                    "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
                    "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
                    "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
                    "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
                    "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
                    "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
                    "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
                };
            },
            {}
        ],
        456: [
            function(e, t, r) {
                "use strict";
                var n = e("asn1.js");
                r.certificate = e("./certificate");
                var i = n.define("RSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
                });
                r.RSAPrivateKey = i;
                var s = n.define("RSAPublicKey", function() {
                    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
                });
                r.RSAPublicKey = s;
                var o = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(a), this.key("subjectPublicKey").bitstr());
                });
                r.PublicKey = o;
                var a = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
                }), l = n.define("PrivateKeyInfo", function() {
                    this.seq().obj(this.key("version").int(), this.key("algorithm").use(a), this.key("subjectPrivateKey").octstr());
                });
                r.PrivateKey = l;
                var c = n.define("EncryptedPrivateKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
                });
                r.EncryptedPrivateKey = c;
                var u = n.define("DSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
                });
                r.DSAPrivateKey = u, r.DSAparam = n.define("DSAparam", function() {
                    this.int();
                });
                var h = n.define("ECPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(f), this.key("publicKey").optional().explicit(1).bitstr());
                });
                r.ECPrivateKey = h;
                var f = n.define("ECParameters", function() {
                    this.choice({
                        namedCurve: this.objid()
                    });
                });
                r.signature = n.define("signature", function() {
                    this.seq().obj(this.key("r").int(), this.key("s").int());
                });
            },
            {
                "./certificate": 457,
                "asn1.js": 170
            }
        ],
        457: [
            function(e, t, r) {
                "use strict";
                var n = e("asn1.js"), i = n.define("Time", function() {
                    this.choice({
                        utcTime: this.utctime(),
                        generalTime: this.gentime()
                    });
                }), s = n.define("AttributeTypeValue", function() {
                    this.seq().obj(this.key("type").objid(), this.key("value").any());
                }), o = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
                }), a = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(o), this.key("subjectPublicKey").bitstr());
                }), l = n.define("RelativeDistinguishedName", function() {
                    this.setof(s);
                }), c = n.define("RDNSequence", function() {
                    this.seqof(l);
                }), u = n.define("Name", function() {
                    this.choice({
                        rdnSequence: this.use(c)
                    });
                }), h = n.define("Validity", function() {
                    this.seq().obj(this.key("notBefore").use(i), this.key("notAfter").use(i));
                }), f = n.define("Extension", function() {
                    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(!1), this.key("extnValue").octstr());
                }), d = n.define("TBSCertificate", function() {
                    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use(o), this.key("issuer").use(u), this.key("validity").use(h), this.key("subject").use(u), this.key("subjectPublicKeyInfo").use(a), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(f).optional());
                }), p = n.define("X509Certificate", function() {
                    this.seq().obj(this.key("tbsCertificate").use(d), this.key("signatureAlgorithm").use(o), this.key("signatureValue").bitstr());
                });
                t.exports = p;
            },
            {
                "asn1.js": 170
            }
        ],
        458: [
            function(e, t, r) {
                "use strict";
                var n = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, i = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, s = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, o = e("evp_bytestokey"), a = e("browserify-aes"), l = e("safe-buffer").Buffer;
                t.exports = function(e, t) {
                    var r, c = e.toString(), u = c.match(n);
                    if (u) {
                        var h = "aes" + u[1], f = l.from(u[2], "hex"), d = l.from(u[3].replace(/[\r\n]/g, ""), "base64"), p = o(t, f.slice(0, 8), parseInt(u[1], 10)).key, m = [], b = a.createDecipheriv(h, p, f);
                        m.push(b.update(d)), m.push(b.final()), r = l.concat(m);
                    } else {
                        var g = c.match(s);
                        r = l.from(g[2].replace(/[\r\n]/g, ""), "base64");
                    }
                    return {
                        tag: c.match(i)[1],
                        data: r
                    };
                };
            },
            {
                "browserify-aes": 191,
                evp_bytestokey: 423,
                "safe-buffer": 494
            }
        ],
        459: [
            function(e, t, r) {
                "use strict";
                var n = e("./asn1"), i = e("./aesid.json"), s = e("./fixProc"), o = e("browserify-aes"), a = e("pbkdf2"), l = e("safe-buffer").Buffer;
                function c(e) {
                    var t;
                    "object" != typeof e || l.isBuffer(e) || (t = e.passphrase, e = e.key), "string" == typeof e && (e = l.from(e));
                    var r, c, u = s(e, t), h = u.tag, f = u.data;
                    switch(h){
                        case "CERTIFICATE":
                            c = n.certificate.decode(f, "der").tbsCertificate.subjectPublicKeyInfo;
                        case "PUBLIC KEY":
                            switch(c || (c = n.PublicKey.decode(f, "der")), r = c.algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return n.RSAPublicKey.decode(c.subjectPublicKey.data, "der");
                                case "1.2.840.10045.2.1":
                                    return c.subjectPrivateKey = c.subjectPublicKey, {
                                        type: "ec",
                                        data: c
                                    };
                                case "1.2.840.10040.4.1":
                                    return c.algorithm.params.pub_key = n.DSAparam.decode(c.subjectPublicKey.data, "der"), {
                                        type: "dsa",
                                        data: c.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "ENCRYPTED PRIVATE KEY":
                            f = function(e, t) {
                                var r = e.algorithm.decrypt.kde.kdeparams.salt, n = parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), s = i[e.algorithm.decrypt.cipher.algo.join(".")], c = e.algorithm.decrypt.cipher.iv, u = e.subjectPrivateKey, h = parseInt(s.split("-")[1], 10) / 8, f = a.pbkdf2Sync(t, r, n, h, "sha1"), d = o.createDecipheriv(s, f, c), p = [];
                                return p.push(d.update(u)), p.push(d.final()), l.concat(p);
                            }(f = n.EncryptedPrivateKey.decode(f, "der"), t);
                        case "PRIVATE KEY":
                            switch(r = (c = n.PrivateKey.decode(f, "der")).algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return n.RSAPrivateKey.decode(c.subjectPrivateKey, "der");
                                case "1.2.840.10045.2.1":
                                    return {
                                        curve: c.algorithm.curve,
                                        privateKey: n.ECPrivateKey.decode(c.subjectPrivateKey, "der").privateKey
                                    };
                                case "1.2.840.10040.4.1":
                                    return c.algorithm.params.priv_key = n.DSAparam.decode(c.subjectPrivateKey, "der"), {
                                        type: "dsa",
                                        params: c.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "RSA PUBLIC KEY":
                            return n.RSAPublicKey.decode(f, "der");
                        case "RSA PRIVATE KEY":
                            return n.RSAPrivateKey.decode(f, "der");
                        case "DSA PRIVATE KEY":
                            return {
                                type: "dsa",
                                params: n.DSAPrivateKey.decode(f, "der")
                            };
                        case "EC PRIVATE KEY":
                            return {
                                curve: (f = n.ECPrivateKey.decode(f, "der")).parameters.value,
                                privateKey: f.privateKey
                            };
                        default:
                            throw new Error("unknown key type " + h);
                    }
                }
                t.exports = c, c.signature = n.signature;
            },
            {
                "./aesid.json": 455,
                "./asn1": 456,
                "./fixProc": 458,
                "browserify-aes": 191,
                pbkdf2: 460,
                "safe-buffer": 494
            }
        ],
        460: [
            function(e, t, r) {
                "use strict";
                r.pbkdf2 = e("./lib/async"), r.pbkdf2Sync = e("./lib/sync");
            },
            {
                "./lib/async": 461,
                "./lib/sync": 464
            }
        ],
        461: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i, s = e("safe-buffer").Buffer, o = e("./precondition"), a = e("./default-encoding"), l = e("./sync"), c = e("./to-buffer"), u = r.crypto && r.crypto.subtle, h = {
                            sha: "SHA-1",
                            "sha-1": "SHA-1",
                            sha1: "SHA-1",
                            sha256: "SHA-256",
                            "sha-256": "SHA-256",
                            sha384: "SHA-384",
                            "sha-384": "SHA-384",
                            "sha-512": "SHA-512",
                            sha512: "SHA-512"
                        }, f = [];
                        function d() {
                            return i || (i = r.process && r.process.nextTick ? r.process.nextTick : r.queueMicrotask ? r.queueMicrotask : r.setImmediate ? r.setImmediate : r.setTimeout);
                        }
                        function p(e, t, r, n, i) {
                            return u.importKey("raw", e, {
                                name: "PBKDF2"
                            }, !1, [
                                "deriveBits"
                            ]).then(function(e) {
                                return u.deriveBits({
                                    name: "PBKDF2",
                                    salt: t,
                                    iterations: r,
                                    hash: {
                                        name: i
                                    }
                                }, e, n << 3);
                            }).then(function(e) {
                                return s.from(e);
                            });
                        }
                        t.exports = function(e, t, i, m, b, g) {
                            "function" == typeof b && (g = b, b = void 0);
                            var y = h[(b = b || "sha1").toLowerCase()];
                            if (y && "function" == typeof r.Promise) {
                                if (o(i, m), e = c(e, a, "Password"), t = c(t, a, "Salt"), "function" != typeof g) throw new Error("No callback provided to pbkdf2");
                                !function(e, t) {
                                    e.then(function(e) {
                                        d()(function() {
                                            t(null, e);
                                        });
                                    }, function(e) {
                                        d()(function() {
                                            t(e);
                                        });
                                    });
                                }((function(e) {
                                    if (r.process && !r.process.browser) return Promise.resolve(!1);
                                    if (!u || !u.importKey || !u.deriveBits) return Promise.resolve(!1);
                                    if (void 0 !== f[e]) return f[e];
                                    var t = p(n = n || s.alloc(8), n, 10, 128, e).then(function() {
                                        return !0;
                                    }).catch(function() {
                                        return !1;
                                    });
                                    return f[e] = t, t;
                                })(y).then(function(r) {
                                    return r ? p(e, t, i, m, y) : l(e, t, i, m, b);
                                }), g);
                            } else d()(function() {
                                var r;
                                try {
                                    r = l(e, t, i, m, b);
                                } catch (e) {
                                    return g(e);
                                }
                                g(null, r);
                            });
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./default-encoding": 462,
                "./precondition": 463,
                "./sync": 464,
                "./to-buffer": 465,
                "safe-buffer": 494
            }
        ],
        462: [
            function(e, t, r) {
                (function(e, r) {
                    (function() {
                        "use strict";
                        var n;
                        if (r.process && r.process.browser) n = "utf-8";
                        else if (r.process && r.process.version) n = parseInt(e.version.split(".")[0].slice(1), 10) >= 6 ? "utf-8" : "binary";
                        else n = "utf-8";
                        t.exports = n;
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467
            }
        ],
        463: [
            function(e, t, r) {
                "use strict";
                var n = Math.pow(2, 30) - 1;
                t.exports = function(e, t) {
                    if ("number" != typeof e) throw new TypeError("Iterations not a number");
                    if (e < 0) throw new TypeError("Bad iterations");
                    if ("number" != typeof t) throw new TypeError("Key length not a number");
                    if (t < 0 || t > n || t != t) throw new TypeError("Bad key length");
                };
            },
            {}
        ],
        464: [
            function(e, t, r) {
                "use strict";
                var n = e("create-hash/md5"), i = e("ripemd160"), s = e("sha.js"), o = e("safe-buffer").Buffer, a = e("./precondition"), l = e("./default-encoding"), c = e("./to-buffer"), u = o.alloc(128), h = {
                    md5: 16,
                    sha1: 20,
                    sha224: 28,
                    sha256: 32,
                    sha384: 48,
                    sha512: 64,
                    rmd160: 20,
                    ripemd160: 20
                };
                function f(e, t, r) {
                    var a = function(e) {
                        function t(t) {
                            return s(e).update(t).digest();
                        }
                        return "rmd160" === e || "ripemd160" === e ? function(e) {
                            return (new i).update(e).digest();
                        } : "md5" === e ? n : t;
                    }(e), l = "sha512" === e || "sha384" === e ? 128 : 64;
                    t.length > l ? t = a(t) : t.length < l && (t = o.concat([
                        t,
                        u
                    ], l));
                    for(var c = o.allocUnsafe(l + h[e]), f = o.allocUnsafe(l + h[e]), d = 0; d < l; d++)c[d] = 54 ^ t[d], f[d] = 92 ^ t[d];
                    var p = o.allocUnsafe(l + r + 4);
                    c.copy(p, 0, 0, l), this.ipad1 = p, this.ipad2 = c, this.opad = f, this.alg = e, this.blocksize = l, this.hash = a, this.size = h[e];
                }
                f.prototype.run = function(e, t) {
                    return e.copy(t, this.blocksize), this.hash(t).copy(this.opad, this.blocksize), this.hash(this.opad);
                }, t.exports = function(e, t, r, n, i) {
                    a(r, n);
                    var s = new f(i = i || "sha1", e = c(e, l, "Password"), (t = c(t, l, "Salt")).length), u = o.allocUnsafe(n), d = o.allocUnsafe(t.length + 4);
                    t.copy(d, 0, 0, t.length);
                    for(var p = 0, m = h[i], b = Math.ceil(n / m), g = 1; g <= b; g++){
                        d.writeUInt32BE(g, t.length);
                        for(var y = s.run(d, s.ipad1), v = y, w = 1; w < r; w++){
                            v = s.run(v, s.ipad2);
                            for(var _ = 0; _ < m; _++)y[_] ^= v[_];
                        }
                        y.copy(u, p), p += m;
                    }
                    return u;
                };
            },
            {
                "./default-encoding": 462,
                "./precondition": 463,
                "./to-buffer": 465,
                "create-hash/md5": 387,
                ripemd160: 493,
                "safe-buffer": 494,
                "sha.js": 498
            }
        ],
        465: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    if (n.isBuffer(e)) return e;
                    if ("string" == typeof e) return n.from(e, t);
                    if (ArrayBuffer.isView(e)) return n.from(e.buffer);
                    throw new TypeError(r + " must be a string, a Buffer, a typed array or a DataView");
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        466: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        void 0 === e || !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
                            nextTick: function(t, r, n, i) {
                                if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
                                var s, o, a = arguments.length;
                                switch(a){
                                    case 0:
                                    case 1:
                                        return e.nextTick(t);
                                    case 2:
                                        return e.nextTick(function() {
                                            t.call(null, r);
                                        });
                                    case 3:
                                        return e.nextTick(function() {
                                            t.call(null, r, n);
                                        });
                                    case 4:
                                        return e.nextTick(function() {
                                            t.call(null, r, n, i);
                                        });
                                    default:
                                        for(s = new Array(a - 1), o = 0; o < s.length;)s[o++] = arguments[o];
                                        return e.nextTick(function() {
                                            t.apply(null, s);
                                        });
                                }
                            }
                        } : t.exports = e;
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467
            }
        ],
        467: [
            function(e, t, r) {
                "use strict";
                var n, i, s = t.exports = {};
                function o() {
                    throw new Error("setTimeout has not been defined");
                }
                function a() {
                    throw new Error("clearTimeout has not been defined");
                }
                function l(e) {
                    if (n === setTimeout) return setTimeout(e, 0);
                    if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
                    try {
                        return n(e, 0);
                    } catch (t) {
                        try {
                            return n.call(null, e, 0);
                        } catch (t) {
                            return n.call(this, e, 0);
                        }
                    }
                }
                !function() {
                    try {
                        n = "function" == typeof setTimeout ? setTimeout : o;
                    } catch (e) {
                        n = o;
                    }
                    try {
                        i = "function" == typeof clearTimeout ? clearTimeout : a;
                    } catch (e) {
                        i = a;
                    }
                }();
                var c, u = [], h = !1, f = -1;
                function d() {
                    h && c && (h = !1, c.length ? u = c.concat(u) : f = -1, u.length && p());
                }
                function p() {
                    if (!h) {
                        var e = l(d);
                        h = !0;
                        for(var t = u.length; t;){
                            for(c = u, u = []; ++f < t;)c && c[f].run();
                            f = -1, t = u.length;
                        }
                        c = null, h = !1, function(e) {
                            if (i === clearTimeout) return clearTimeout(e);
                            if ((i === a || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);
                            try {
                                i(e);
                            } catch (t) {
                                try {
                                    return i.call(null, e);
                                } catch (t) {
                                    return i.call(this, e);
                                }
                            }
                        }(e);
                    }
                }
                function m(e, t) {
                    this.fun = e, this.array = t;
                }
                function b() {}
                s.nextTick = function(e) {
                    var t = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    u.push(new m(e, t)), 1 !== u.length || h || l(p);
                }, m.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, s.title = "browser", s.browser = !0, s.env = {}, s.argv = [], s.version = "", s.versions = {}, s.on = b, s.addListener = b, s.once = b, s.off = b, s.removeListener = b, s.removeAllListeners = b, s.emit = b, s.prependListener = b, s.prependOnceListener = b, s.listeners = function(e) {
                    return [];
                }, s.binding = function(e) {
                    throw new Error("process.binding is not supported");
                }, s.cwd = function() {
                    return "/";
                }, s.chdir = function(e) {
                    throw new Error("process.chdir is not supported");
                }, s.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        468: [
            function(e, t, r) {
                "use strict";
                r.publicEncrypt = e("./publicEncrypt"), r.privateDecrypt = e("./privateDecrypt"), r.privateEncrypt = function(e, t) {
                    return r.publicEncrypt(e, t, !0);
                }, r.publicDecrypt = function(e, t) {
                    return r.privateDecrypt(e, t, !0);
                };
            },
            {
                "./privateDecrypt": 471,
                "./publicEncrypt": 472
            }
        ],
        469: [
            function(e, t, r) {
                "use strict";
                var n = e("create-hash"), i = e("safe-buffer").Buffer;
                function s(e) {
                    var t = i.allocUnsafe(4);
                    return t.writeUInt32BE(e, 0), t;
                }
                t.exports = function(e, t) {
                    for(var r, o = i.alloc(0), a = 0; o.length < t;)r = s(a++), o = i.concat([
                        o,
                        n("sha1").update(e).update(r).digest()
                    ]);
                    return o.slice(0, t);
                };
            },
            {
                "create-hash": 386,
                "safe-buffer": 494
            }
        ],
        470: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        471: [
            function(e, t, r) {
                "use strict";
                var n = e("parse-asn1"), i = e("./mgf"), s = e("./xor"), o = e("bn.js"), a = e("browserify-rsa"), l = e("create-hash"), c = e("./withPublic"), u = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    var h;
                    h = e.padding ? e.padding : r ? 1 : 4;
                    var f, d = n(e), p = d.modulus.byteLength();
                    if (t.length > p || new o(t).cmp(d.modulus) >= 0) throw new Error("decryption error");
                    f = r ? c(new o(t), d) : a(t, d);
                    var m = u.alloc(p - f.length);
                    if (f = u.concat([
                        m,
                        f
                    ], p), 4 === h) return function(e, t) {
                        var r = e.modulus.byteLength(), n = l("sha1").update(u.alloc(0)).digest(), o = n.length;
                        if (0 !== t[0]) throw new Error("decryption error");
                        var a = t.slice(1, o + 1), c = t.slice(o + 1), h = s(a, i(c, o)), f = s(c, i(h, r - o - 1));
                        if (function(e, t) {
                            e = u.from(e), t = u.from(t);
                            var r = 0, n = e.length;
                            e.length !== t.length && (r++, n = Math.min(e.length, t.length));
                            var i = -1;
                            for(; ++i < n;)r += e[i] ^ t[i];
                            return r;
                        }(n, f.slice(0, o))) throw new Error("decryption error");
                        var d = o;
                        for(; 0 === f[d];)d++;
                        if (1 !== f[d++]) throw new Error("decryption error");
                        return f.slice(d);
                    }(d, f);
                    if (1 === h) return function(e, t, r) {
                        var n = t.slice(0, 2), i = 2, s = 0;
                        for(; 0 !== t[i++];)if (i >= t.length) {
                            s++;
                            break;
                        }
                        var o = t.slice(2, i - 1);
                        ("0002" !== n.toString("hex") && !r || "0001" !== n.toString("hex") && r) && s++;
                        o.length < 8 && s++;
                        if (s) throw new Error("decryption error");
                        return t.slice(i);
                    }(0, f, r);
                    if (3 === h) return f;
                    throw new Error("unknown padding");
                };
            },
            {
                "./mgf": 469,
                "./withPublic": 473,
                "./xor": 474,
                "bn.js": 470,
                "browserify-rsa": 209,
                "create-hash": 386,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        472: [
            function(e, t, r) {
                "use strict";
                var n = e("parse-asn1"), i = e("randombytes"), s = e("create-hash"), o = e("./mgf"), a = e("./xor"), l = e("bn.js"), c = e("./withPublic"), u = e("browserify-rsa"), h = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    var f;
                    f = e.padding ? e.padding : r ? 1 : 4;
                    var d, p = n(e);
                    if (4 === f) d = function(e, t) {
                        var r = e.modulus.byteLength(), n = t.length, c = s("sha1").update(h.alloc(0)).digest(), u = c.length, f = 2 * u;
                        if (n > r - f - 2) throw new Error("message too long");
                        var d = h.alloc(r - n - f - 2), p = r - u - 1, m = i(u), b = a(h.concat([
                            c,
                            d,
                            h.alloc(1, 1),
                            t
                        ], p), o(m, p)), g = a(m, o(b, u));
                        return new l(h.concat([
                            h.alloc(1),
                            g,
                            b
                        ], r));
                    }(p, t);
                    else if (1 === f) d = function(e, t, r) {
                        var n, s = t.length, o = e.modulus.byteLength();
                        if (s > o - 11) throw new Error("message too long");
                        n = r ? h.alloc(o - s - 3, 255) : function(e) {
                            var t, r = h.allocUnsafe(e), n = 0, s = i(2 * e), o = 0;
                            for(; n < e;)o === s.length && (s = i(2 * e), o = 0), (t = s[o++]) && (r[n++] = t);
                            return r;
                        }(o - s - 3);
                        return new l(h.concat([
                            h.from([
                                0,
                                r ? 1 : 2
                            ]),
                            n,
                            h.alloc(1),
                            t
                        ], o));
                    }(p, t, r);
                    else {
                        if (3 !== f) throw new Error("unknown padding");
                        if ((d = new l(t)).cmp(p.modulus) >= 0) throw new Error("data too long for modulus");
                    }
                    return r ? u(d, p) : c(d, p);
                };
            },
            {
                "./mgf": 469,
                "./withPublic": 473,
                "./xor": 474,
                "bn.js": 470,
                "browserify-rsa": 209,
                "create-hash": 386,
                "parse-asn1": 459,
                randombytes: 475,
                "safe-buffer": 494
            }
        ],
        473: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("safe-buffer").Buffer;
                t.exports = function(e, t) {
                    return i.from(e.toRed(n.mont(t.modulus)).redPow(new n(t.publicExponent)).fromRed().toArray());
                };
            },
            {
                "bn.js": 470,
                "safe-buffer": 494
            }
        ],
        474: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    for(var r = e.length, n = -1; ++n < r;)e[n] ^= t[n];
                    return e;
                };
            },
            {}
        ],
        475: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i = e("safe-buffer").Buffer, s = n.crypto || n.msCrypto;
                        s && s.getRandomValues ? t.exports = function(e, t) {
                            if (e > 4294967295) throw new RangeError("requested too many random bytes");
                            var n = i.allocUnsafe(e);
                            if (e > 0) {
                                if (e > 65536) for(var o = 0; o < e; o += 65536)s.getRandomValues(n.slice(o, o + 65536));
                                else s.getRandomValues(n);
                            }
                            if ("function" == typeof t) return r.nextTick(function() {
                                t(null, n);
                            });
                            return n;
                        } : t.exports = function() {
                            throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467,
                "safe-buffer": 494
            }
        ],
        476: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        function i() {
                            throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
                        }
                        var s = e("safe-buffer"), o = e("randombytes"), a = s.Buffer, l = s.kMaxLength, c = n.crypto || n.msCrypto, u = Math.pow(2, 32) - 1;
                        function h(e, t) {
                            if ("number" != typeof e || e != e) throw new TypeError("offset must be a number");
                            if (e > u || e < 0) throw new TypeError("offset must be a uint32");
                            if (e > l || e > t) throw new RangeError("offset out of range");
                        }
                        function f(e, t, r) {
                            if ("number" != typeof e || e != e) throw new TypeError("size must be a number");
                            if (e > u || e < 0) throw new TypeError("size must be a uint32");
                            if (e + t > r || e > l) throw new RangeError("buffer too small");
                        }
                        function d(e, r, n, i) {
                            if (t.browser) {
                                var s = e.buffer, a = new Uint8Array(s, r, n);
                                return c.getRandomValues(a), i ? void t.nextTick(function() {
                                    i(null, e);
                                }) : e;
                            }
                            if (!i) return o(n).copy(e, r), e;
                            o(n, function(t, n) {
                                if (t) return i(t);
                                n.copy(e, r), i(null, e);
                            });
                        }
                        c && c.getRandomValues || !t.browser ? (r.randomFill = function(e, t, r, i) {
                            if (!(a.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                            if ("function" == typeof t) i = t, t = 0, r = e.length;
                            else if ("function" == typeof r) i = r, r = e.length - t;
                            else if ("function" != typeof i) throw new TypeError('"cb" argument must be a function');
                            return h(t, e.length), f(r, t, e.length), d(e, t, r, i);
                        }, r.randomFillSync = function(e, t, r) {
                            void 0 === t && (t = 0);
                            if (!(a.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                            h(t, e.length), void 0 === r && (r = e.length - t);
                            return f(r, t, e.length), d(e, t, r);
                        }) : (r.randomFill = i, r.randomFillSync = i);
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467,
                randombytes: 475,
                "safe-buffer": 494
            }
        ],
        477: [
            function(e, t, r) {
                "use strict";
                var n = {};
                function i(e, t, r) {
                    r || (r = Error);
                    var i = function(e) {
                        var r, n;
                        function i(r, n, i) {
                            return e.call(this, function(e, r, n) {
                                return "string" == typeof t ? t : t(e, r, n);
                            }(r, n, i)) || this;
                        }
                        return n = e, (r = i).prototype = Object.create(n.prototype), r.prototype.constructor = r, r.__proto__ = n, i;
                    }(r);
                    i.prototype.name = r.name, i.prototype.code = e, n[e] = i;
                }
                function s(e, t) {
                    if (Array.isArray(e)) {
                        var r = e.length;
                        return e = e.map(function(e) {
                            return String(e);
                        }), r > 2 ? "one of ".concat(t, " ").concat(e.slice(0, r - 1).join(", "), ", or ") + e[r - 1] : 2 === r ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
                    }
                    return "of ".concat(t, " ").concat(String(e));
                }
                i("ERR_INVALID_OPT_VALUE", function(e, t) {
                    return 'The value "' + t + '" is invalid for option "' + e + '"';
                }, TypeError), i("ERR_INVALID_ARG_TYPE", function(e, t, r) {
                    var n, i, o, a;
                    if ("string" == typeof t && (i = "not ", t.substr(!o || o < 0 ? 0 : +o, i.length) === i) ? (n = "must not be", t = t.replace(/^not /, "")) : n = "must be", function(e, t, r) {
                        return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
                    }(e, " argument")) a = "The ".concat(e, " ").concat(n, " ").concat(s(t, "type"));
                    else {
                        var l = function(e, t, r) {
                            return "number" != typeof r && (r = 0), !(r + t.length > e.length) && -1 !== e.indexOf(t, r);
                        }(e, ".") ? "property" : "argument";
                        a = 'The "'.concat(e, '" ').concat(l, " ").concat(n, " ").concat(s(t, "type"));
                    }
                    return a += ". Received type ".concat(typeof r);
                }, TypeError), i("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), i("ERR_METHOD_NOT_IMPLEMENTED", function(e) {
                    return "The " + e + " method is not implemented";
                }), i("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), i("ERR_STREAM_DESTROYED", function(e) {
                    return "Cannot call " + e + " after a stream was destroyed";
                }), i("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), i("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), i("ERR_STREAM_WRITE_AFTER_END", "write after end"), i("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), i("ERR_UNKNOWN_ENCODING", function(e) {
                    return "Unknown encoding: " + e;
                }, TypeError), i("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), t.exports.codes = n;
            },
            {}
        ],
        478: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = Object.keys || function(e) {
                            var t = [];
                            for(var r in e)t.push(r);
                            return t;
                        };
                        t.exports = c;
                        var i = e("./_stream_readable"), s = e("./_stream_writable");
                        e("inherits")(c, i);
                        for(var o = n(s.prototype), a = 0; a < o.length; a++){
                            var l = o[a];
                            c.prototype[l] || (c.prototype[l] = s.prototype[l]);
                        }
                        function c(e) {
                            if (!(this instanceof c)) return new c(e);
                            i.call(this, e), s.call(this, e), this.allowHalfOpen = !0, e && (!1 === e.readable && (this.readable = !1), !1 === e.writable && (this.writable = !1), !1 === e.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", u)));
                        }
                        function u() {
                            this._writableState.ended || r.nextTick(h, this);
                        }
                        function h(e) {
                            e.end();
                        }
                        Object.defineProperty(c.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), Object.defineProperty(c.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(c.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(c.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                            },
                            set: function(e) {
                                void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                            }
                        });
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./_stream_readable": 480,
                "./_stream_writable": 482,
                _process: 467,
                inherits: 440
            }
        ],
        479: [
            function(e, t, r) {
                "use strict";
                t.exports = i;
                var n = e("./_stream_transform");
                function i(e) {
                    if (!(this instanceof i)) return new i(e);
                    n.call(this, e);
                }
                e("inherits")(i, n), i.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            {
                "./_stream_transform": 481,
                inherits: 440
            }
        ],
        480: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i;
                        t.exports = M, M.ReadableState = S;
                        e("events").EventEmitter;
                        var s = function(e, t) {
                            return e.listeners(t).length;
                        }, o = e("./internal/streams/stream"), a = e("buffer").Buffer, l = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var c, u = e("util");
                        c = u && u.debuglog ? u.debuglog("stream") : function() {};
                        var h, f, d, p = e("./internal/streams/buffer_list"), m = e("./internal/streams/destroy"), b = e("./internal/streams/state").getHighWaterMark, g = e("../errors").codes, y = g.ERR_INVALID_ARG_TYPE, v = g.ERR_STREAM_PUSH_AFTER_EOF, w = g.ERR_METHOD_NOT_IMPLEMENTED, _ = g.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                        e("inherits")(M, o);
                        var x = m.errorOrDestroy, k = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function S(t, r, n) {
                            i = i || e("./_stream_duplex"), t = t || {}, "boolean" != typeof n && (n = r instanceof i), this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode), this.highWaterMark = b(this, t, "readableHighWaterMark", n), this.buffer = new p, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (h || (h = e("string_decoder/").StringDecoder), this.decoder = new h(t.encoding), this.encoding = t.encoding);
                        }
                        function M(t) {
                            if (i = i || e("./_stream_duplex"), !(this instanceof M)) return new M(t);
                            var r = this instanceof i;
                            this._readableState = new S(t, this, r), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), o.call(this);
                        }
                        function C(e, t, r, n, i) {
                            c("readableAddChunk", t);
                            var s, o = e._readableState;
                            if (null === t) o.reading = !1, function(e, t) {
                                if (c("onEofChunk"), t.ended) return;
                                if (t.decoder) {
                                    var r = t.decoder.end();
                                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                                }
                                t.ended = !0, t.sync ? A(e) : (t.needReadable = !1, t.emittedReadable || (t.emittedReadable = !0, R(e)));
                            }(e, o);
                            else if (i || (s = function(e, t) {
                                var r;
                                n = t, a.isBuffer(n) || n instanceof l || "string" == typeof t || void 0 === t || e.objectMode || (r = new y("chunk", [
                                    "string",
                                    "Buffer",
                                    "Uint8Array"
                                ], t));
                                var n;
                                return r;
                            }(o, t)), s) x(e, s);
                            else if (o.objectMode || t && t.length > 0) {
                                if ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === a.prototype || (t = function(e) {
                                    return a.from(e);
                                }(t)), n) o.endEmitted ? x(e, new _) : T(e, o, t, !0);
                                else if (o.ended) x(e, new v);
                                else {
                                    if (o.destroyed) return !1;
                                    o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? T(e, o, t, !1) : O(e, o)) : T(e, o, t, !1);
                                }
                            } else n || (o.reading = !1, O(e, o));
                            return !o.ended && (o.length < o.highWaterMark || 0 === o.length);
                        }
                        function T(e, t, r, n) {
                            t.flowing && 0 === t.length && !t.sync ? (t.awaitDrain = 0, e.emit("data", r)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && A(e)), O(e, t);
                        }
                        Object.defineProperty(M.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), M.prototype.destroy = m.destroy, M.prototype._undestroy = m.undestroy, M.prototype._destroy = function(e, t) {
                            t(e);
                        }, M.prototype.push = function(e, t) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = a.from(e, t), t = ""), r = !0), C(this, e, t, !1, r);
                        }, M.prototype.unshift = function(e) {
                            return C(this, e, null, !0, !1);
                        }, M.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, M.prototype.setEncoding = function(t) {
                            h || (h = e("string_decoder/").StringDecoder);
                            var r = new h(t);
                            this._readableState.decoder = r, this._readableState.encoding = this._readableState.decoder.encoding;
                            for(var n = this._readableState.buffer.head, i = ""; null !== n;)i += r.write(n.data), n = n.next;
                            return this._readableState.buffer.clear(), "" !== i && this._readableState.buffer.push(i), this._readableState.length = i.length, this;
                        };
                        function E(e, t) {
                            return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                return e >= 1073741824 ? e = 1073741824 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                            }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                        }
                        function A(e) {
                            var t = e._readableState;
                            c("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (c("emitReadable", t.flowing), t.emittedReadable = !0, r.nextTick(R, e));
                        }
                        function R(e) {
                            var t = e._readableState;
                            c("emitReadable_", t.destroyed, t.length, t.ended), t.destroyed || !t.length && !t.ended || (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, B(e);
                        }
                        function O(e, t) {
                            t.readingMore || (t.readingMore = !0, r.nextTick(j, e, t));
                        }
                        function j(e, t) {
                            for(; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && 0 === t.length);){
                                var r = t.length;
                                if (c("maybeReadMore read 0"), e.read(0), r === t.length) break;
                            }
                            t.readingMore = !1;
                        }
                        function I(e) {
                            var t = e._readableState;
                            t.readableListening = e.listenerCount("readable") > 0, t.resumeScheduled && !t.paused ? t.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
                        }
                        function N(e) {
                            c("readable nexttick read 0"), e.read(0);
                        }
                        function P(e, t) {
                            c("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), B(e), t.flowing && !t.reading && e.read(0);
                        }
                        function B(e) {
                            var t = e._readableState;
                            for(c("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function D(e, t) {
                            var r;
                            return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.first() : t.buffer.concat(t.length), t.buffer.clear()) : r = t.buffer.consume(e, t.decoder), r);
                        }
                        function F(e) {
                            var t = e._readableState;
                            c("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, r.nextTick(L, t, e));
                        }
                        function L(e, t) {
                            if (c("endReadableNT", e.endEmitted, e.length), !e.endEmitted && 0 === e.length && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
                                var r = t._writableState;
                                (!r || r.autoDestroy && r.finished) && t.destroy();
                            }
                        }
                        function z(e, t) {
                            for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                            return -1;
                        }
                        M.prototype.read = function(e) {
                            c("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && ((0 !== t.highWaterMark ? t.length >= t.highWaterMark : t.length > 0) || t.ended)) return c("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? F(this) : A(this), null;
                            if (0 === (e = E(e, t)) && t.ended) return 0 === t.length && F(this), null;
                            var n, i = t.needReadable;
                            return c("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && c("length less than watermark", i = !0), t.ended || t.reading ? c("reading or ended", i = !1) : i && (c("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = E(r, t))), null === (n = e > 0 ? D(e, t) : null) ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && F(this)), null !== n && this.emit("data", n), n;
                        }, M.prototype._read = function(e) {
                            x(this, new w("_read()"));
                        }, M.prototype.pipe = function(e, t) {
                            var n = this, i = this._readableState;
                            switch(i.pipesCount){
                                case 0:
                                    i.pipes = e;
                                    break;
                                case 1:
                                    i.pipes = [
                                        i.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    i.pipes.push(e);
                            }
                            i.pipesCount += 1, c("pipe count=%d opts=%j", i.pipesCount, t);
                            var o = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? l : b;
                            function a(t, r) {
                                c("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, c("cleanup"), e.removeListener("close", p), e.removeListener("finish", m), e.removeListener("drain", u), e.removeListener("error", d), e.removeListener("unpipe", a), n.removeListener("end", l), n.removeListener("end", b), n.removeListener("data", f), h = !0, !i.awaitDrain || e._writableState && !e._writableState.needDrain || u());
                            }
                            function l() {
                                c("onend"), e.end();
                            }
                            i.endEmitted ? r.nextTick(o) : n.once("end", o), e.on("unpipe", a);
                            var u = function(e) {
                                return function() {
                                    var t = e._readableState;
                                    c("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && s(e, "data") && (t.flowing = !0, B(e));
                                };
                            }(n);
                            e.on("drain", u);
                            var h = !1;
                            function f(t) {
                                c("ondata");
                                var r = e.write(t);
                                c("dest.write", r), !1 === r && ((1 === i.pipesCount && i.pipes === e || i.pipesCount > 1 && -1 !== z(i.pipes, e)) && !h && (c("false write response, pause", i.awaitDrain), i.awaitDrain++), n.pause());
                            }
                            function d(t) {
                                c("onerror", t), b(), e.removeListener("error", d), 0 === s(e, "error") && x(e, t);
                            }
                            function p() {
                                e.removeListener("finish", m), b();
                            }
                            function m() {
                                c("onfinish"), e.removeListener("close", p), b();
                            }
                            function b() {
                                c("unpipe"), n.unpipe(e);
                            }
                            return n.on("data", f), function(e, t, r) {
                                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                                e._events && e._events[t] ? Array.isArray(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                                    r,
                                    e._events[t]
                                ] : e.on(t, r);
                            }(e, "error", d), e.once("close", p), e.once("finish", m), e.emit("pipe", n), i.flowing || (c("pipe resume"), n.resume()), e;
                        }, M.prototype.unpipe = function(e) {
                            var t = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                            if (!e) {
                                var n = t.pipes, i = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var s = 0; s < i; s++)n[s].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = z(t.pipes, e);
                            return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                        }, M.prototype.on = function(e, t) {
                            var n = o.prototype.on.call(this, e, t), i = this._readableState;
                            return "data" === e ? (i.readableListening = this.listenerCount("readable") > 0, !1 !== i.flowing && this.resume()) : "readable" === e && (i.endEmitted || i.readableListening || (i.readableListening = i.needReadable = !0, i.flowing = !1, i.emittedReadable = !1, c("on readable", i.length, i.reading), i.length ? A(this) : i.reading || r.nextTick(N, this))), n;
                        }, M.prototype.addListener = M.prototype.on, M.prototype.removeListener = function(e, t) {
                            var n = o.prototype.removeListener.call(this, e, t);
                            return "readable" === e && r.nextTick(I, this), n;
                        }, M.prototype.removeAllListeners = function(e) {
                            var t = o.prototype.removeAllListeners.apply(this, arguments);
                            return "readable" !== e && void 0 !== e || r.nextTick(I, this), t;
                        }, M.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (c("resume"), e.flowing = !e.readableListening, function(e, t) {
                                t.resumeScheduled || (t.resumeScheduled = !0, r.nextTick(P, e, t));
                            }(this, e)), e.paused = !1, this;
                        }, M.prototype.pause = function() {
                            return c("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (c("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
                        }, M.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, n = !1;
                            for(var i in e.on("end", function() {
                                if (c("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(i) {
                                (c("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                            }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(i));
                            for(var s = 0; s < k.length; s++)e.on(k[s], this.emit.bind(this, k[s]));
                            return this._read = function(t) {
                                c("wrapped _read", t), n && (n = !1, e.resume());
                            }, this;
                        }, "function" == typeof Symbol && (M.prototype[Symbol.asyncIterator] = function() {
                            return void 0 === f && (f = e("./internal/streams/async_iterator")), f(this);
                        }), Object.defineProperty(M.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), Object.defineProperty(M.prototype, "readableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState && this._readableState.buffer;
                            }
                        }), Object.defineProperty(M.prototype, "readableFlowing", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.flowing;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.flowing = e);
                            }
                        }), M._fromList = D, Object.defineProperty(M.prototype, "readableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.length;
                            }
                        }), "function" == typeof Symbol && (M.from = function(t, r) {
                            return void 0 === d && (d = e("./internal/streams/from")), d(M, t, r);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                "./internal/streams/async_iterator": 483,
                "./internal/streams/buffer_list": 484,
                "./internal/streams/destroy": 485,
                "./internal/streams/from": 487,
                "./internal/streams/state": 489,
                "./internal/streams/stream": 490,
                _process: 467,
                buffer: 220,
                events: 422,
                inherits: 440,
                "string_decoder/": 522,
                util: 188
            }
        ],
        481: [
            function(e, t, r) {
                "use strict";
                t.exports = u;
                var n = e("../errors").codes, i = n.ERR_METHOD_NOT_IMPLEMENTED, s = n.ERR_MULTIPLE_CALLBACK, o = n.ERR_TRANSFORM_ALREADY_TRANSFORMING, a = n.ERR_TRANSFORM_WITH_LENGTH_0, l = e("./_stream_duplex");
                function c(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (null === n) return this.emit("error", new s);
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function u(e) {
                    if (!(this instanceof u)) return new u(e);
                    l.call(this, e), this._transformState = {
                        afterTransform: c.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", h);
                }
                function h() {
                    var e = this;
                    "function" != typeof this._flush || this._readableState.destroyed ? f(this, null, null) : this._flush(function(t, r) {
                        f(e, t, r);
                    });
                }
                function f(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new a;
                    if (e._transformState.transforming) throw new o;
                    return e.push(null);
                }
                e("inherits")(u, l), u.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, l.prototype.push.call(this, e, t);
                }, u.prototype._transform = function(e, t, r) {
                    r(new i("_transform()"));
                }, u.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, u.prototype._read = function(e) {
                    var t = this._transformState;
                    null === t.writechunk || t.transforming ? t.needTransform = !0 : (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform));
                }, u.prototype._destroy = function(e, t) {
                    l.prototype._destroy.call(this, e, function(e) {
                        t(e);
                    });
                };
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                inherits: 440
            }
        ],
        482: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        function i(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(e, t, r) {
                                    var n = e.entry;
                                    e.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        t.pendingcb--, i(r), n = n.next;
                                    }
                                    t.corkedRequestsFree.next = e;
                                }(t, e);
                            };
                        }
                        var s;
                        t.exports = M, M.WritableState = S;
                        var o = {
                            deprecate: e("util-deprecate")
                        }, a = e("./internal/streams/stream"), l = e("buffer").Buffer, c = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var u, h = e("./internal/streams/destroy"), f = e("./internal/streams/state").getHighWaterMark, d = e("../errors").codes, p = d.ERR_INVALID_ARG_TYPE, m = d.ERR_METHOD_NOT_IMPLEMENTED, b = d.ERR_MULTIPLE_CALLBACK, g = d.ERR_STREAM_CANNOT_PIPE, y = d.ERR_STREAM_DESTROYED, v = d.ERR_STREAM_NULL_VALUES, w = d.ERR_STREAM_WRITE_AFTER_END, _ = d.ERR_UNKNOWN_ENCODING, x = h.errorOrDestroy;
                        function k() {}
                        function S(t, n, o) {
                            s = s || e("./_stream_duplex"), t = t || {}, "boolean" != typeof o && (o = n instanceof s), this.objectMode = !!t.objectMode, o && (this.objectMode = this.objectMode || !!t.writableObjectMode), this.highWaterMark = f(this, t, "writableHighWaterMark", o), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var a = !1 === t.decodeStrings;
                            this.decodeStrings = !a, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                !function(e, t) {
                                    var n = e._writableState, i = n.sync, s = n.writecb;
                                    if ("function" != typeof s) throw new b;
                                    if (function(e) {
                                        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                    }(n), t) !function(e, t, n, i, s) {
                                        --t.pendingcb, n ? (r.nextTick(s, i), r.nextTick(O, e, t), e._writableState.errorEmitted = !0, x(e, i)) : (s(i), e._writableState.errorEmitted = !0, x(e, i), O(e, t));
                                    }(e, n, i, t, s);
                                    else {
                                        var o = A(n) || e.destroyed;
                                        o || n.corked || n.bufferProcessing || !n.bufferedRequest || E(e, n), i ? r.nextTick(T, e, n, o, s) : T(e, n, o, s);
                                    }
                                }(n, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new i(this);
                        }
                        function M(t) {
                            var r = this instanceof (s = s || e("./_stream_duplex"));
                            if (!r && !u.call(M, this)) return new M(t);
                            this._writableState = new S(t, this, r), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), a.call(this);
                        }
                        function C(e, t, r, n, i, s, o) {
                            t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new y("write")) : r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
                        }
                        function T(e, t, r, n) {
                            r || function(e, t) {
                                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                            }(e, t), t.pendingcb--, n(), O(e, t);
                        }
                        function E(e, t) {
                            t.bufferProcessing = !0;
                            var r = t.bufferedRequest;
                            if (e._writev && r && r.next) {
                                var n = t.bufferedRequestCount, s = new Array(n), o = t.corkedRequestsFree;
                                o.entry = r;
                                for(var a = 0, l = !0; r;)s[a] = r, r.isBuf || (l = !1), r = r.next, a += 1;
                                s.allBuffers = l, C(e, t, !0, t.length, s, "", o.finish), t.pendingcb++, t.lastBufferedRequest = null, o.next ? (t.corkedRequestsFree = o.next, o.next = null) : t.corkedRequestsFree = new i(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, h = r.callback;
                                    if (C(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === r && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = r, t.bufferProcessing = !1;
                        }
                        function A(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function R(e, t) {
                            e._final(function(r) {
                                t.pendingcb--, r && x(e, r), t.prefinished = !0, e.emit("prefinish"), O(e, t);
                            });
                        }
                        function O(e, t) {
                            var n = A(t);
                            if (n && (function(e, t) {
                                t.prefinished || t.finalCalled || ("function" != typeof e._final || t.destroyed ? (t.prefinished = !0, e.emit("prefinish")) : (t.pendingcb++, t.finalCalled = !0, r.nextTick(R, e, t)));
                            }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
                                var i = e._readableState;
                                (!i || i.autoDestroy && i.endEmitted) && e.destroy();
                            }
                            return n;
                        }
                        e("inherits")(M, a), S.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(S.prototype, "buffer", {
                                    get: o.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (u = Function.prototype[Symbol.hasInstance], Object.defineProperty(M, Symbol.hasInstance, {
                            value: function(e) {
                                return !!u.call(this, e) || this === M && e && e._writableState instanceof S;
                            }
                        })) : u = function(e) {
                            return e instanceof this;
                        }, M.prototype.pipe = function() {
                            x(this, new g);
                        }, M.prototype.write = function(e, t, n) {
                            var i, s = this._writableState, o = !1, a = !s.objectMode && (i = e, l.isBuffer(i) || i instanceof c);
                            return a && !l.isBuffer(e) && (e = function(e) {
                                return l.from(e);
                            }(e)), "function" == typeof t && (n = t, t = null), a ? t = "buffer" : t || (t = s.defaultEncoding), "function" != typeof n && (n = k), s.ending ? function(e, t) {
                                var n = new w;
                                x(e, n), r.nextTick(t, n);
                            }(this, n) : (a || function(e, t, n, i) {
                                var s;
                                return null === n ? s = new v : "string" == typeof n || t.objectMode || (s = new p("chunk", [
                                    "string",
                                    "Buffer"
                                ], n)), !s || (x(e, s), r.nextTick(i, s), !1);
                            }(this, s, e, n)) && (s.pendingcb++, o = function(e, t, r, n, i, s) {
                                if (!r) {
                                    var o = function(e, t, r) {
                                        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = l.from(t, r));
                                        return t;
                                    }(t, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var a = t.objectMode ? 1 : n.length;
                                t.length += a;
                                var c = t.length < t.highWaterMark;
                                c || (t.needDrain = !0);
                                if (t.writing || t.corked) {
                                    var u = t.lastBufferedRequest;
                                    t.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: s,
                                        next: null
                                    }, u ? u.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                } else C(e, t, !1, a, n, i, s);
                                return c;
                            }(this, s, a, e, t, n)), o;
                        }, M.prototype.cork = function() {
                            this._writableState.corked++;
                        }, M.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || E(this, e));
                        }, M.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()) > -1)) throw new _(e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(M.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(M.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), M.prototype._write = function(e, t, r) {
                            r(new m("_write()"));
                        }, M.prototype._writev = null, M.prototype.end = function(e, t, n) {
                            var i = this._writableState;
                            return "function" == typeof e ? (n = e, e = null, t = null) : "function" == typeof t && (n = t, t = null), null != e && this.write(e, t), i.corked && (i.corked = 1, this.uncork()), i.ending || function(e, t, n) {
                                t.ending = !0, O(e, t), n && (t.finished ? r.nextTick(n) : e.once("finish", n));
                                t.ended = !0, e.writable = !1;
                            }(this, i, n), this;
                        }, Object.defineProperty(M.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(M.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), M.prototype.destroy = h.destroy, M.prototype._undestroy = h.undestroy, M.prototype._destroy = function(e, t) {
                            t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                "./internal/streams/destroy": 485,
                "./internal/streams/state": 489,
                "./internal/streams/stream": 490,
                _process: 467,
                buffer: 220,
                inherits: 440,
                "util-deprecate": 524
            }
        ],
        483: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n;
                        function i(e, t, r) {
                            return (t = function(e) {
                                var t = function(e, t) {
                                    if ("object" != typeof e || null === e) return e;
                                    var r = e[Symbol.toPrimitive];
                                    if (void 0 !== r) {
                                        var n = r.call(e, t || "default");
                                        if ("object" != typeof n) return n;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return ("string" === t ? String : Number)(e);
                                }(e, "string");
                                return "symbol" == typeof t ? t : String(t);
                            }(t)) in e ? Object.defineProperty(e, t, {
                                value: r,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : e[t] = r, e;
                        }
                        var s = e("./end-of-stream"), o = Symbol("lastResolve"), a = Symbol("lastReject"), l = Symbol("error"), c = Symbol("ended"), u = Symbol("lastPromise"), h = Symbol("handlePromise"), f = Symbol("stream");
                        function d(e, t) {
                            return {
                                value: e,
                                done: t
                            };
                        }
                        function p(e) {
                            var t = e[o];
                            if (null !== t) {
                                var r = e[f].read();
                                null !== r && (e[u] = null, e[o] = null, e[a] = null, t(d(r, !1)));
                            }
                        }
                        function m(e) {
                            r.nextTick(p, e);
                        }
                        var b = Object.getPrototypeOf(function() {}), g = Object.setPrototypeOf((i(n = {
                            get stream () {
                                return this[f];
                            },
                            next: function() {
                                var e = this, t = this[l];
                                if (null !== t) return Promise.reject(t);
                                if (this[c]) return Promise.resolve(d(void 0, !0));
                                if (this[f].destroyed) return new Promise(function(t, n) {
                                    r.nextTick(function() {
                                        e[l] ? n(e[l]) : t(d(void 0, !0));
                                    });
                                });
                                var n, i = this[u];
                                if (i) n = new Promise(function(e, t) {
                                    return function(r, n) {
                                        e.then(function() {
                                            t[c] ? r(d(void 0, !0)) : t[h](r, n);
                                        }, n);
                                    };
                                }(i, this));
                                else {
                                    var s = this[f].read();
                                    if (null !== s) return Promise.resolve(d(s, !1));
                                    n = new Promise(this[h]);
                                }
                                return this[u] = n, n;
                            }
                        }, Symbol.asyncIterator, function() {
                            return this;
                        }), i(n, "return", function() {
                            var e = this;
                            return new Promise(function(t, r) {
                                e[f].destroy(null, function(e) {
                                    e ? r(e) : t(d(void 0, !0));
                                });
                            });
                        }), n), b);
                        t.exports = function(e) {
                            var t, r = Object.create(g, (i(t = {}, f, {
                                value: e,
                                writable: !0
                            }), i(t, o, {
                                value: null,
                                writable: !0
                            }), i(t, a, {
                                value: null,
                                writable: !0
                            }), i(t, l, {
                                value: null,
                                writable: !0
                            }), i(t, c, {
                                value: e._readableState.endEmitted,
                                writable: !0
                            }), i(t, h, {
                                value: function(e, t) {
                                    var n = r[f].read();
                                    n ? (r[u] = null, r[o] = null, r[a] = null, e(d(n, !1))) : (r[o] = e, r[a] = t);
                                },
                                writable: !0
                            }), t));
                            return r[u] = null, s(e, function(e) {
                                if (e && "ERR_STREAM_PREMATURE_CLOSE" !== e.code) {
                                    var t = r[a];
                                    return null !== t && (r[u] = null, r[o] = null, r[a] = null, t(e)), void (r[l] = e);
                                }
                                var n = r[o];
                                null !== n && (r[u] = null, r[o] = null, r[a] = null, n(d(void 0, !0))), r[c] = !0;
                            }), e.on("readable", m.bind(null, r)), r;
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./end-of-stream": 486,
                _process: 467
            }
        ],
        484: [
            function(e, t, r) {
                "use strict";
                function n(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function i(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? n(Object(r), !0).forEach(function(t) {
                            s(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function s(e, t, r) {
                    return (t = a(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function o(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, a(n.key), n);
                    }
                }
                function a(e) {
                    var t = function(e, t) {
                        if ("object" != typeof e || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == typeof t ? t : String(t);
                }
                var l = e("buffer").Buffer, c = e("util").inspect, u = c && c.custom || "inspect";
                t.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    var t, r, n;
                    return t = e, r = [
                        {
                            key: "push",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: null
                                };
                                this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: this.head
                                };
                                0 === this.length && (this.tail = t), this.head = t, ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function() {
                                if (0 !== this.length) {
                                    var e = this.head.data;
                                    return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.head = this.tail = null, this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function(e) {
                                if (0 === this.length) return "";
                                for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                                return r;
                            }
                        },
                        {
                            key: "concat",
                            value: function(e) {
                                if (0 === this.length) return l.alloc(0);
                                for(var t, r, n, i = l.allocUnsafe(e >>> 0), s = this.head, o = 0; s;)t = s.data, r = i, n = o, l.prototype.copy.call(t, r, n), o += s.data.length, s = s.next;
                                return i;
                            }
                        },
                        {
                            key: "consume",
                            value: function(e, t) {
                                var r;
                                return e < this.head.data.length ? (r = this.head.data.slice(0, e), this.head.data = this.head.data.slice(e)) : r = e === this.head.data.length ? this.shift() : t ? this._getString(e) : this._getBuffer(e), r;
                            }
                        },
                        {
                            key: "first",
                            value: function() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function(e) {
                                var t = this.head, r = 1, n = t.data;
                                for(e -= n.length; t = t.next;){
                                    var i = t.data, s = e > i.length ? i.length : e;
                                    if (s === i.length ? n += i : n += i.slice(0, e), 0 == (e -= s)) {
                                        s === i.length ? (++r, t.next ? this.head = t.next : this.head = this.tail = null) : (this.head = t, t.data = i.slice(s));
                                        break;
                                    }
                                    ++r;
                                }
                                return this.length -= r, n;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function(e) {
                                var t = l.allocUnsafe(e), r = this.head, n = 1;
                                for(r.data.copy(t), e -= r.data.length; r = r.next;){
                                    var i = r.data, s = e > i.length ? i.length : e;
                                    if (i.copy(t, t.length - e, 0, s), 0 == (e -= s)) {
                                        s === i.length ? (++n, r.next ? this.head = r.next : this.head = this.tail = null) : (this.head = r, r.data = i.slice(s));
                                        break;
                                    }
                                    ++n;
                                }
                                return this.length -= n, t;
                            }
                        },
                        {
                            key: u,
                            value: function(e, t) {
                                return c(this, i(i({}, t), {}, {
                                    depth: 0,
                                    customInspect: !1
                                }));
                            }
                        }
                    ], o(t.prototype, r), n && o(t, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
            },
            {
                buffer: 220,
                util: 188
            }
        ],
        485: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        function r(e, t) {
                            i(e, t), n(e);
                        }
                        function n(e) {
                            e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
                        }
                        function i(e, t) {
                            e.emit("error", t);
                        }
                        t.exports = {
                            destroy: function(t, s) {
                                var o = this, a = this._readableState && this._readableState.destroyed, l = this._writableState && this._writableState.destroyed;
                                return a || l ? (s ? s(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, e.nextTick(i, this, t)) : e.nextTick(i, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(t) {
                                    !s && t ? o._writableState ? o._writableState.errorEmitted ? e.nextTick(n, o) : (o._writableState.errorEmitted = !0, e.nextTick(r, o, t)) : e.nextTick(r, o, t) : s ? (e.nextTick(n, o), s(t)) : e.nextTick(n, o);
                                }), this);
                            },
                            undestroy: function() {
                                this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                            },
                            errorOrDestroy: function(e, t) {
                                var r = e._readableState, n = e._writableState;
                                r && r.autoDestroy || n && n.autoDestroy ? e.destroy(t) : e.emit("error", t);
                            }
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467
            }
        ],
        486: [
            function(e, t, r) {
                "use strict";
                var n = e("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
                function i() {}
                t.exports = function e(t, r, s) {
                    if ("function" == typeof r) return e(t, null, r);
                    r || (r = {}), s = function(e) {
                        var t = !1;
                        return function() {
                            if (!t) {
                                t = !0;
                                for(var r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
                                e.apply(this, n);
                            }
                        };
                    }(s || i);
                    var o = r.readable || !1 !== r.readable && t.readable, a = r.writable || !1 !== r.writable && t.writable, l = function() {
                        t.writable || u();
                    }, c = t._writableState && t._writableState.finished, u = function() {
                        a = !1, c = !0, o || s.call(t);
                    }, h = t._readableState && t._readableState.endEmitted, f = function() {
                        o = !1, h = !0, a || s.call(t);
                    }, d = function(e) {
                        s.call(t, e);
                    }, p = function() {
                        var e;
                        return o && !h ? (t._readableState && t._readableState.ended || (e = new n), s.call(t, e)) : a && !c ? (t._writableState && t._writableState.ended || (e = new n), s.call(t, e)) : void 0;
                    }, m = function() {
                        t.req.on("finish", u);
                    };
                    return !function(_e1) {
                        return _e1.setHeader && "function" == typeof _e1.abort;
                    }(t) ? a && !t._writableState && (t.on("end", l), t.on("close", l)) : (t.on("complete", u), t.on("abort", p), t.req ? m() : t.on("request", m)), t.on("end", f), t.on("finish", u), !1 !== r.error && t.on("error", d), t.on("close", p), function() {
                        t.removeListener("complete", u), t.removeListener("abort", p), t.removeListener("request", m), t.req && t.req.removeListener("finish", u), t.removeListener("end", l), t.removeListener("close", l), t.removeListener("finish", u), t.removeListener("end", f), t.removeListener("error", d), t.removeListener("close", p);
                    };
                };
            },
            {
                "../../../errors": 477
            }
        ],
        487: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            {}
        ],
        488: [
            function(e, t, r) {
                "use strict";
                var n;
                var i = e("../../../errors").codes, s = i.ERR_MISSING_ARGS, o = i.ERR_STREAM_DESTROYED;
                function a(e) {
                    if (e) throw e;
                }
                function l(t, r, i, s) {
                    s = function(e) {
                        var t = !1;
                        return function() {
                            t || (t = !0, e.apply(void 0, arguments));
                        };
                    }(s);
                    var a = !1;
                    t.on("close", function() {
                        a = !0;
                    }), void 0 === n && (n = e("./end-of-stream")), n(t, {
                        readable: r,
                        writable: i
                    }, function(e) {
                        if (e) return s(e);
                        a = !0, s();
                    });
                    var l = !1;
                    return function(e) {
                        if (!a && !l) return l = !0, function(e) {
                            return e.setHeader && "function" == typeof e.abort;
                        }(t) ? t.abort() : "function" == typeof t.destroy ? t.destroy() : void s(e || new o("pipe"));
                    };
                }
                function c(e) {
                    e();
                }
                function u(e, t) {
                    return e.pipe(t);
                }
                function h(e) {
                    return e.length ? "function" != typeof e[e.length - 1] ? a : e.pop() : a;
                }
                t.exports = function() {
                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                    var n, i = h(t);
                    if (Array.isArray(t[0]) && (t = t[0]), t.length < 2) throw new s("streams");
                    var o = t.map(function(e, r) {
                        var s = r < t.length - 1;
                        return l(e, s, r > 0, function(e) {
                            n || (n = e), e && o.forEach(c), s || (o.forEach(c), i(n));
                        });
                    });
                    return t.reduce(u);
                };
            },
            {
                "../../../errors": 477,
                "./end-of-stream": 486
            }
        ],
        489: [
            function(e, t, r) {
                "use strict";
                var n = e("../../../errors").codes.ERR_INVALID_OPT_VALUE;
                t.exports = {
                    getHighWaterMark: function(e, t, r, i) {
                        var s = function(e, t, r) {
                            return null != e.highWaterMark ? e.highWaterMark : t ? e[r] : null;
                        }(t, i, r);
                        if (null != s) {
                            if (!isFinite(s) || Math.floor(s) !== s || s < 0) throw new n(i ? r : "highWaterMark", s);
                            return Math.floor(s);
                        }
                        return e.objectMode ? 16 : 16384;
                    }
                };
            },
            {
                "../../../errors": 477
            }
        ],
        490: [
            function(e, t, r) {
                "use strict";
                t.exports = e("events").EventEmitter;
            },
            {
                events: 422
            }
        ],
        491: [
            function(e, t, r) {
                "use strict";
                (r = t.exports = e("./lib/_stream_readable.js")).Stream = r, r.Readable = r, r.Writable = e("./lib/_stream_writable.js"), r.Duplex = e("./lib/_stream_duplex.js"), r.Transform = e("./lib/_stream_transform.js"), r.PassThrough = e("./lib/_stream_passthrough.js"), r.finished = e("./lib/internal/streams/end-of-stream.js"), r.pipeline = e("./lib/internal/streams/pipeline.js");
            },
            {
                "./lib/_stream_duplex.js": 478,
                "./lib/_stream_passthrough.js": 479,
                "./lib/_stream_readable.js": 480,
                "./lib/_stream_transform.js": 481,
                "./lib/_stream_writable.js": 482,
                "./lib/internal/streams/end-of-stream.js": 486,
                "./lib/internal/streams/pipeline.js": 488
            }
        ],
        492: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    var t = Object.prototype, r = t.hasOwnProperty, n = Object.defineProperty || function(e, t, r) {
                        e[t] = r.value;
                    }, i = "function" == typeof Symbol ? Symbol : {}, s = i.iterator || "@@iterator", o = i.asyncIterator || "@@asyncIterator", a = i.toStringTag || "@@toStringTag";
                    function l(e, t, r) {
                        return Object.defineProperty(e, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t];
                    }
                    try {
                        l({}, "");
                    } catch (e) {
                        l = function(e, t, r) {
                            return e[t] = r;
                        };
                    }
                    function c(e, t, r, i) {
                        var s = t && t.prototype instanceof f ? t : f, o = Object.create(s.prototype), a = new M(i || []);
                        return n(o, "_invoke", {
                            value: _(e, r, a)
                        }), o;
                    }
                    function u(e, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, r)
                            };
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            };
                        }
                    }
                    e.wrap = c;
                    var h = {};
                    function f() {}
                    function d() {}
                    function p() {}
                    var m = {};
                    l(m, s, function() {
                        return this;
                    });
                    var b = Object.getPrototypeOf, g = b && b(b(C([])));
                    g && g !== t && r.call(g, s) && (m = g);
                    var y = p.prototype = f.prototype = Object.create(m);
                    function v(e) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            l(e, t, function(e) {
                                return this._invoke(t, e);
                            });
                        });
                    }
                    function w(e, t) {
                        var i;
                        n(this, "_invoke", {
                            value: function(n, s) {
                                function o() {
                                    return new t(function(i, o) {
                                        !function n(i, s, o, a) {
                                            var l = u(e[i], e, s);
                                            if ("throw" !== l.type) {
                                                var c = l.arg, h = c.value;
                                                return h && "object" == typeof h && r.call(h, "__await") ? t.resolve(h.__await).then(function(e) {
                                                    n("next", e, o, a);
                                                }, function(e) {
                                                    n("throw", e, o, a);
                                                }) : t.resolve(h).then(function(e) {
                                                    c.value = e, o(c);
                                                }, function(e) {
                                                    return n("throw", e, o, a);
                                                });
                                            }
                                            a(l.arg);
                                        }(n, s, i, o);
                                    });
                                }
                                return i = i ? i.then(o, o) : o();
                            }
                        });
                    }
                    function _(e, t, r) {
                        var n = "suspendedStart";
                        return function(i, s) {
                            if ("executing" === n) throw new Error("Generator is already running");
                            if ("completed" === n) {
                                if ("throw" === i) throw s;
                                return T();
                            }
                            for(r.method = i, r.arg = s;;){
                                var o = r.delegate;
                                if (o) {
                                    var a = x(o, r);
                                    if (a) {
                                        if (a === h) continue;
                                        return a;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if ("suspendedStart" === n) throw n = "completed", r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                n = "executing";
                                var l = u(e, t, r);
                                if ("normal" === l.type) {
                                    if (n = r.done ? "completed" : "suspendedYield", l.arg === h) continue;
                                    return {
                                        value: l.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === l.type && (n = "completed", r.method = "throw", r.arg = l.arg);
                            }
                        };
                    }
                    function x(e, t) {
                        var r = t.method, n = e.iterator[r];
                        if (void 0 === n) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = void 0, x(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), h;
                        var i = u(n, e.iterator, t.arg);
                        if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, h;
                        var s = i.arg;
                        return s ? s.done ? (t[e.resultName] = s.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : s : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
                    }
                    function k(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
                    }
                    function S(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t;
                    }
                    function M(e) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e.forEach(k, this), this.reset(!0);
                    }
                    function C(e) {
                        if (e) {
                            var t = e[s];
                            if (t) return t.call(e);
                            if ("function" == typeof e.next) return e;
                            if (!isNaN(e.length)) {
                                var n = -1, i = function t() {
                                    for(; ++n < e.length;)if (r.call(e, n)) return t.value = e[n], t.done = !1, t;
                                    return t.value = void 0, t.done = !0, t;
                                };
                                return i.next = i;
                            }
                        }
                        return {
                            next: T
                        };
                    }
                    function T() {
                        return {
                            value: void 0,
                            done: !0
                        };
                    }
                    return d.prototype = p, n(y, "constructor", {
                        value: p,
                        configurable: !0
                    }), n(p, "constructor", {
                        value: d,
                        configurable: !0
                    }), d.displayName = l(p, a, "GeneratorFunction"), e.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === d || "GeneratorFunction" === (t.displayName || t.name));
                    }, e.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, p) : (e.__proto__ = p, l(e, a, "GeneratorFunction")), e.prototype = Object.create(y), e;
                    }, e.awrap = function(e) {
                        return {
                            __await: e
                        };
                    }, v(w.prototype), l(w.prototype, o, function() {
                        return this;
                    }), e.AsyncIterator = w, e.async = function(t, r, n, i, s) {
                        void 0 === s && (s = Promise);
                        var o = new w(c(t, r, n, i), s);
                        return e.isGeneratorFunction(r) ? o : o.next().then(function(e) {
                            return e.done ? e.value : o.next();
                        });
                    }, v(y), l(y, a, "Generator"), l(y, s, function() {
                        return this;
                    }), l(y, "toString", function() {
                        return "[object Generator]";
                    }), e.keys = function(e) {
                        var t = Object(e), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e.value = n, e.done = !1, e;
                            }
                            return e.done = !0, e;
                        };
                    }, e.values = C, M.prototype = {
                        constructor: M,
                        reset: function(e) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(S), !e) for(var t in this)"t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval;
                        },
                        dispatchException: function(e) {
                            if (this.done) throw e;
                            var t = this;
                            function n(r, n) {
                                return o.type = "throw", o.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                            }
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var s = this.tryEntries[i], o = s.completion;
                                if ("root" === s.tryLoc) return n("end");
                                if (s.tryLoc <= this.prev) {
                                    var a = r.call(s, "catchLoc"), l = r.call(s, "finallyLoc");
                                    if (a && l) {
                                        if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                                        if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                                    } else if (a) {
                                        if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                                    } else {
                                        if (!l) throw new Error("try statement without catch or finally");
                                        if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var i = this.tryEntries[n];
                                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var s = i;
                                    break;
                                }
                            }
                            s && ("break" === e || "continue" === e) && s.tryLoc <= t && t <= s.finallyLoc && (s = null);
                            var o = s ? s.completion : {};
                            return o.type = e, o.arg = t, s ? (this.method = "next", this.next = s.finallyLoc, h) : this.complete(o);
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
                        },
                        finish: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), S(r), h;
                            }
                        },
                        catch: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        S(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e, t, r) {
                            return this.delegate = {
                                iterator: C(e),
                                resultName: t,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = void 0), h;
                        }
                    }, e;
                }("object" == typeof t ? t.exports : {});
                try {
                    regeneratorRuntime = n;
                } catch (e) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
                }
            },
            {}
        ],
        493: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer").Buffer, i = e("inherits"), s = e("hash-base"), o = new Array(16), a = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], l = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], c = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], u = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ], h = [
                    0,
                    1518500249,
                    1859775393,
                    2400959708,
                    2840853838
                ], f = [
                    1352829926,
                    1548603684,
                    1836072691,
                    2053994217,
                    0
                ];
                function d() {
                    s.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
                }
                function p(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function m(e, t, r, n, i, s, o, a) {
                    return p(e + (t ^ r ^ n) + s + o | 0, a) + i | 0;
                }
                function b(e, t, r, n, i, s, o, a) {
                    return p(e + (t & r | ~t & n) + s + o | 0, a) + i | 0;
                }
                function g(e, t, r, n, i, s, o, a) {
                    return p(e + ((t | ~r) ^ n) + s + o | 0, a) + i | 0;
                }
                function y(e, t, r, n, i, s, o, a) {
                    return p(e + (t & n | r & ~n) + s + o | 0, a) + i | 0;
                }
                function v(e, t, r, n, i, s, o, a) {
                    return p(e + (t ^ (r | ~n)) + s + o | 0, a) + i | 0;
                }
                i(d, s), d.prototype._update = function() {
                    for(var e = o, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    for(var r = 0 | this._a, n = 0 | this._b, i = 0 | this._c, s = 0 | this._d, d = 0 | this._e, w = 0 | this._a, _ = 0 | this._b, x = 0 | this._c, k = 0 | this._d, S = 0 | this._e, M = 0; M < 80; M += 1){
                        var C, T;
                        M < 16 ? (C = m(r, n, i, s, d, e[a[M]], h[0], c[M]), T = v(w, _, x, k, S, e[l[M]], f[0], u[M])) : M < 32 ? (C = b(r, n, i, s, d, e[a[M]], h[1], c[M]), T = y(w, _, x, k, S, e[l[M]], f[1], u[M])) : M < 48 ? (C = g(r, n, i, s, d, e[a[M]], h[2], c[M]), T = g(w, _, x, k, S, e[l[M]], f[2], u[M])) : M < 64 ? (C = y(r, n, i, s, d, e[a[M]], h[3], c[M]), T = b(w, _, x, k, S, e[l[M]], f[3], u[M])) : (C = v(r, n, i, s, d, e[a[M]], h[4], c[M]), T = m(w, _, x, k, S, e[l[M]], f[4], u[M])), r = d, d = s, s = p(i, 10), i = n, n = C, w = S, S = k, k = p(x, 10), x = _, _ = T;
                    }
                    var E = this._b + i + k | 0;
                    this._b = this._c + s + S | 0, this._c = this._d + d + w | 0, this._d = this._e + r + _ | 0, this._e = this._a + n + x | 0, this._a = E;
                }, d.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = n.alloc ? n.alloc(20) : new n(20);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
                }, t.exports = d;
            },
            {
                buffer: 220,
                "hash-base": 425,
                inherits: 440
            }
        ],
        494: [
            function(e, t, r) {
                "use strict";
                /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ var n = e("buffer"), i = n.Buffer;
                function s(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function o(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (s(n, r), r.Buffer = o), o.prototype = Object.create(i.prototype), s(i, o), o.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, o.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, o.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, o.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            {
                buffer: 220
            }
        ],
        495: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i = e("buffer"), s = i.Buffer, o = {};
                        for(n in i)i.hasOwnProperty(n) && "SlowBuffer" !== n && "Buffer" !== n && (o[n] = i[n]);
                        var a = o.Buffer = {};
                        for(n in s)s.hasOwnProperty(n) && "allocUnsafe" !== n && "allocUnsafeSlow" !== n && (a[n] = s[n]);
                        if (o.Buffer.prototype = s.prototype, a.from && a.from !== Uint8Array.from || (a.from = function(e, t, r) {
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof e);
                            if (e && void 0 === e.length) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            return s(e, t, r);
                        }), a.alloc || (a.alloc = function(e, t, r) {
                            if ("number" != typeof e) throw new TypeError('The "size" argument must be of type number. Received type ' + typeof e);
                            if (e < 0 || e >= 2 * 1073741824) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var n = s(e);
                            return t && 0 !== t.length ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                        }), !o.kStringMaxLength) try {
                            o.kStringMaxLength = r.binding("buffer").kStringMaxLength;
                        } catch (e) {}
                        o.constants || (o.constants = {
                            MAX_LENGTH: o.kMaxLength
                        }, o.kStringMaxLength && (o.constants.MAX_STRING_LENGTH = o.kStringMaxLength)), t.exports = o;
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467,
                buffer: 220
            }
        ],
        496: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
                const n = e("xmlchars/xml/1.0/ed5"), i = e("xmlchars/xml/1.1/ed2"), s = e("xmlchars/xmlns/1.0/ed3");
                var o = n.isS, a = n.isChar, l = n.isNameStartChar, c = n.isNameChar, u = n.S_LIST, h = n.NAME_RE, f = i.isChar, d = s.isNCNameStartChar, p = s.isNCNameChar, m = s.NC_NAME_RE;
                const b = "http://www.w3.org/XML/1998/namespace", g = "http://www.w3.org/2000/xmlns/", y = {
                    __proto__: null,
                    xml: b,
                    xmlns: g
                }, v = {
                    __proto__: null,
                    amp: "&",
                    gt: ">",
                    lt: "<",
                    quot: '"',
                    apos: "'"
                }, w = (e)=>34 === e || 39 === e, _ = [
                    34,
                    39
                ], x = [
                    ..._,
                    91,
                    62
                ], k = [
                    ..._,
                    60,
                    93
                ], S = [
                    61,
                    63,
                    ...u
                ], M = [
                    ...u,
                    62,
                    38,
                    60
                ];
                function C(e, t, r) {
                    switch(t){
                        case "xml":
                            r !== b && e.fail(`xml prefix must be bound to ${b}.`);
                            break;
                        case "xmlns":
                            r !== g && e.fail(`xmlns prefix must be bound to ${g}.`);
                    }
                    switch(r){
                        case g:
                            e.fail("" === t ? `the default namespace may not be set to ${r}.` : `may not assign a prefix (even "xmlns") to the URI ${g}.`);
                            break;
                        case b:
                            switch(t){
                                case "xml":
                                    break;
                                case "":
                                    e.fail(`the default namespace may not be set to ${r}.`);
                                    break;
                                default:
                                    e.fail("may not assign the xml namespace to another prefix.");
                            }
                    }
                }
                const T = (e)=>m.test(e), E = (e)=>h.test(e);
                r.EVENTS = [
                    "xmldecl",
                    "text",
                    "processinginstruction",
                    "doctype",
                    "comment",
                    "opentagstart",
                    "attribute",
                    "opentag",
                    "closetag",
                    "cdata",
                    "error",
                    "end",
                    "ready"
                ];
                const A = {
                    xmldecl: "xmldeclHandler",
                    text: "textHandler",
                    processinginstruction: "piHandler",
                    doctype: "doctypeHandler",
                    comment: "commentHandler",
                    opentagstart: "openTagStartHandler",
                    attribute: "attributeHandler",
                    opentag: "openTagHandler",
                    closetag: "closeTagHandler",
                    cdata: "cdataHandler",
                    error: "errorHandler",
                    end: "endHandler",
                    ready: "readyHandler"
                };
                r.SaxesParser = class {
                    constructor(e){
                        this.opt = null != e ? e : {}, this.fragmentOpt = !!this.opt.fragment;
                        const t = this.xmlnsOpt = !!this.opt.xmlns;
                        if (this.trackPosition = !1 !== this.opt.position, this.fileName = this.opt.fileName, t) {
                            this.nameStartCheck = d, this.nameCheck = p, this.isName = T, this.processAttribs = this.processAttribsNS, this.pushAttrib = this.pushAttribNS, this.ns = Object.assign({
                                __proto__: null
                            }, y);
                            const e = this.opt.additionalNamespaces;
                            null != e && (!function(e, t) {
                                for (const r of Object.keys(t))C(e, r, t[r]);
                            }(this, e), Object.assign(this.ns, e));
                        } else this.nameStartCheck = l, this.nameCheck = c, this.isName = E, this.processAttribs = this.processAttribsPlain, this.pushAttrib = this.pushAttribPlain;
                        this.stateTable = [
                            this.sBegin,
                            this.sBeginWhitespace,
                            this.sDoctype,
                            this.sDoctypeQuote,
                            this.sDTD,
                            this.sDTDQuoted,
                            this.sDTDOpenWaka,
                            this.sDTDOpenWakaBang,
                            this.sDTDComment,
                            this.sDTDCommentEnding,
                            this.sDTDCommentEnded,
                            this.sDTDPI,
                            this.sDTDPIEnding,
                            this.sText,
                            this.sEntity,
                            this.sOpenWaka,
                            this.sOpenWakaBang,
                            this.sComment,
                            this.sCommentEnding,
                            this.sCommentEnded,
                            this.sCData,
                            this.sCDataEnding,
                            this.sCDataEnding2,
                            this.sPIFirstChar,
                            this.sPIRest,
                            this.sPIBody,
                            this.sPIEnding,
                            this.sXMLDeclNameStart,
                            this.sXMLDeclName,
                            this.sXMLDeclEq,
                            this.sXMLDeclValueStart,
                            this.sXMLDeclValue,
                            this.sXMLDeclSeparator,
                            this.sXMLDeclEnding,
                            this.sOpenTag,
                            this.sOpenTagSlash,
                            this.sAttrib,
                            this.sAttribName,
                            this.sAttribNameSawWhite,
                            this.sAttribValue,
                            this.sAttribValueQuoted,
                            this.sAttribValueClosed,
                            this.sAttribValueUnquoted,
                            this.sCloseTag,
                            this.sCloseTagSawWhite
                        ], this._init();
                    }
                    get closed() {
                        return this._closed;
                    }
                    _init() {
                        var e;
                        this.openWakaBang = "", this.text = "", this.name = "", this.piTarget = "", this.entity = "", this.q = null, this.tags = [], this.tag = null, this.topNS = null, this.chunk = "", this.chunkPosition = 0, this.i = 0, this.prevI = 0, this.carriedFromPrevious = void 0, this.forbiddenState = 0, this.attribList = [];
                        const { fragmentOpt: t } = this;
                        this.state = t ? 13 : 0, this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = t, this.xmlDeclPossible = !t, this.xmlDeclExpects = [
                            "version"
                        ], this.entityReturnState = void 0;
                        let { defaultXMLVersion: r } = this.opt;
                        if (void 0 === r) {
                            if (!0 === this.opt.forceXMLVersion) throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
                            r = "1.0";
                        }
                        this.setXMLVersion(r), this.positionAtNewLine = 0, this.doctype = !1, this._closed = !1, this.xmlDecl = {
                            version: void 0,
                            encoding: void 0,
                            standalone: void 0
                        }, this.line = 1, this.column = 0, this.ENTITIES = Object.create(v), null === (e = this.readyHandler) || void 0 === e || e.call(this);
                    }
                    get position() {
                        return this.chunkPosition + this.i;
                    }
                    get columnIndex() {
                        return this.position - this.positionAtNewLine;
                    }
                    on(e, t) {
                        this[A[e]] = t;
                    }
                    off(e) {
                        this[A[e]] = void 0;
                    }
                    makeError(e) {
                        var t;
                        let r = null !== (t = this.fileName) && void 0 !== t ? t : "";
                        return this.trackPosition && (r.length > 0 && (r += ":"), r += `${this.line}:${this.column}`), r.length > 0 && (r += ": "), new Error(r + e);
                    }
                    fail(e) {
                        const t = this.makeError(e), r = this.errorHandler;
                        if (void 0 === r) throw t;
                        return r(t), this;
                    }
                    write(e) {
                        if (this.closed) return this.fail("cannot write after close; assign an onready handler.");
                        let t = !1;
                        null === e ? (t = !0, e = "") : "object" == typeof e && (e = e.toString()), void 0 !== this.carriedFromPrevious && (e = `${this.carriedFromPrevious}${e}`, this.carriedFromPrevious = void 0);
                        let r = e.length;
                        const n = e.charCodeAt(r - 1);
                        !t && (13 === n || n >= 55296 && n <= 56319) && (this.carriedFromPrevious = e[r - 1], r--, e = e.slice(0, r));
                        const { stateTable: i } = this;
                        for(this.chunk = e, this.i = 0; this.i < r;)i[this.state].call(this);
                        return this.chunkPosition += r, t ? this.end() : this;
                    }
                    close() {
                        return this.write(null);
                    }
                    getCode10() {
                        const { chunk: e, i: t } = this;
                        if (this.prevI = t, this.i = t + 1, t >= e.length) return -1;
                        const r = e.charCodeAt(t);
                        if (this.column++, r < 55296) {
                            if (r >= 32 || 9 === r) return r;
                            switch(r){
                                case 10:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, 10;
                                case 13:
                                    return 10 === e.charCodeAt(t + 1) && (this.i = t + 2), this.line++, this.column = 0, this.positionAtNewLine = this.position, -2;
                                default:
                                    return this.fail("disallowed character."), r;
                            }
                        }
                        if (r > 56319) return r >= 57344 && r <= 65533 || this.fail("disallowed character."), r;
                        const n = 65536 + 1024 * (r - 55296) + (e.charCodeAt(t + 1) - 56320);
                        return this.i = t + 2, n > 1114111 && this.fail("disallowed character."), n;
                    }
                    getCode11() {
                        const { chunk: e, i: t } = this;
                        if (this.prevI = t, this.i = t + 1, t >= e.length) return -1;
                        const r = e.charCodeAt(t);
                        if (this.column++, r < 55296) {
                            if (r > 31 && r < 127 || r > 159 && 8232 !== r || 9 === r) return r;
                            switch(r){
                                case 10:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, 10;
                                case 13:
                                    {
                                        const r = e.charCodeAt(t + 1);
                                        10 !== r && 133 !== r || (this.i = t + 2);
                                    }
                                case 133:
                                case 8232:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, -2;
                                default:
                                    return this.fail("disallowed character."), r;
                            }
                        }
                        if (r > 56319) return r >= 57344 && r <= 65533 || this.fail("disallowed character."), r;
                        const n = 65536 + 1024 * (r - 55296) + (e.charCodeAt(t + 1) - 56320);
                        return this.i = t + 2, n > 1114111 && this.fail("disallowed character."), n;
                    }
                    getCodeNorm() {
                        const e = this.getCode();
                        return -2 === e ? 10 : e;
                    }
                    unget() {
                        this.i = this.prevI, this.column--;
                    }
                    captureTo(e) {
                        let { i: t } = this;
                        const { chunk: r } = this;
                        for(;;){
                            const n = this.getCode(), i = -2 === n, s = i ? 10 : n;
                            if (-1 === s || e.includes(s)) return this.text += r.slice(t, this.prevI), s;
                            i && (this.text += r.slice(t, this.prevI) + "\n", t = this.i);
                        }
                    }
                    captureToChar(e) {
                        let { i: t } = this;
                        const { chunk: r } = this;
                        for(;;){
                            let n = this.getCode();
                            switch(n){
                                case -2:
                                    this.text += r.slice(t, this.prevI) + "\n", t = this.i, n = 10;
                                    break;
                                case -1:
                                    return this.text += r.slice(t), !1;
                            }
                            if (n === e) return this.text += r.slice(t, this.prevI), !0;
                        }
                    }
                    captureNameChars() {
                        const { chunk: e, i: t } = this;
                        for(;;){
                            const r = this.getCode();
                            if (-1 === r) return this.name += e.slice(t), -1;
                            if (!c(r)) return this.name += e.slice(t, this.prevI), -2 === r ? 10 : r;
                        }
                    }
                    skipSpaces() {
                        for(;;){
                            const e = this.getCodeNorm();
                            if (-1 === e || !o(e)) return e;
                        }
                    }
                    setXMLVersion(e) {
                        this.currentXMLVersion = e, "1.0" === e ? (this.isChar = a, this.getCode = this.getCode10) : (this.isChar = f, this.getCode = this.getCode11);
                    }
                    sBegin() {
                        65279 === this.chunk.charCodeAt(0) && (this.i++, this.column++), this.state = 1;
                    }
                    sBeginWhitespace() {
                        const e = this.i, t = this.skipSpaces();
                        switch(this.prevI !== e && (this.xmlDeclPossible = !1), t){
                            case 60:
                                if (this.state = 15, 0 !== this.text.length) throw new Error("no-empty text at start");
                                break;
                            case -1:
                                break;
                            default:
                                this.unget(), this.state = 13, this.xmlDeclPossible = !1;
                        }
                    }
                    sDoctype() {
                        var e;
                        const t = this.captureTo(x);
                        switch(t){
                            case 62:
                                null === (e = this.doctypeHandler) || void 0 === e || e.call(this, this.text), this.text = "", this.state = 13, this.doctype = !0;
                                break;
                            case -1:
                                break;
                            default:
                                this.text += String.fromCodePoint(t), 91 === t ? this.state = 4 : w(t) && (this.state = 3, this.q = t);
                        }
                    }
                    sDoctypeQuote() {
                        const e = this.q;
                        this.captureToChar(e) && (this.text += String.fromCodePoint(e), this.q = null, this.state = 2);
                    }
                    sDTD() {
                        const e = this.captureTo(k);
                        -1 !== e && (this.text += String.fromCodePoint(e), 93 === e ? this.state = 2 : 60 === e ? this.state = 6 : w(e) && (this.state = 5, this.q = e));
                    }
                    sDTDQuoted() {
                        const e = this.q;
                        this.captureToChar(e) && (this.text += String.fromCodePoint(e), this.state = 4, this.q = null);
                    }
                    sDTDOpenWaka() {
                        const e = this.getCodeNorm();
                        switch(this.text += String.fromCodePoint(e), e){
                            case 33:
                                this.state = 7, this.openWakaBang = "";
                                break;
                            case 63:
                                this.state = 11;
                                break;
                            default:
                                this.state = 4;
                        }
                    }
                    sDTDOpenWakaBang() {
                        const e = String.fromCodePoint(this.getCodeNorm()), t = this.openWakaBang += e;
                        this.text += e, "-" !== t && (this.state = "--" === t ? 8 : 4, this.openWakaBang = "");
                    }
                    sDTDComment() {
                        this.captureToChar(45) && (this.text += "-", this.state = 9);
                    }
                    sDTDCommentEnding() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), this.state = 45 === e ? 10 : 8;
                    }
                    sDTDCommentEnded() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), 62 === e ? this.state = 4 : (this.fail("malformed comment."), this.state = 8);
                    }
                    sDTDPI() {
                        this.captureToChar(63) && (this.text += "?", this.state = 12);
                    }
                    sDTDPIEnding() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), 62 === e && (this.state = 4);
                    }
                    sText() {
                        0 !== this.tags.length ? this.handleTextInRoot() : this.handleTextOutsideRoot();
                    }
                    sEntity() {
                        let { i: e } = this;
                        const { chunk: t } = this;
                        e: for(;;)switch(this.getCode()){
                            case -2:
                                this.entity += t.slice(e, this.prevI) + "\n", e = this.i;
                                break;
                            case 59:
                                {
                                    const { entityReturnState: r } = this, n = this.entity + t.slice(e, this.prevI);
                                    let i;
                                    this.state = r, "" === n ? (this.fail("empty entity name."), i = "&;") : (i = this.parseEntity(n), this.entity = ""), 13 === r && void 0 === this.textHandler || (this.text += i);
                                    break e;
                                }
                            case -1:
                                this.entity += t.slice(e);
                                break e;
                        }
                    }
                    sOpenWaka() {
                        const e = this.getCode();
                        if (l(e)) this.state = 34, this.unget(), this.xmlDeclPossible = !1;
                        else switch(e){
                            case 47:
                                this.state = 43, this.xmlDeclPossible = !1;
                                break;
                            case 33:
                                this.state = 16, this.openWakaBang = "", this.xmlDeclPossible = !1;
                                break;
                            case 63:
                                this.state = 23;
                                break;
                            default:
                                this.fail("disallowed character in tag name"), this.state = 13, this.xmlDeclPossible = !1;
                        }
                    }
                    sOpenWakaBang() {
                        switch(this.openWakaBang += String.fromCodePoint(this.getCodeNorm()), this.openWakaBang){
                            case "[CDATA[":
                                this.sawRoot || this.reportedTextBeforeRoot || (this.fail("text data outside of root node."), this.reportedTextBeforeRoot = !0), this.closedRoot && !this.reportedTextAfterRoot && (this.fail("text data outside of root node."), this.reportedTextAfterRoot = !0), this.state = 20, this.openWakaBang = "";
                                break;
                            case "--":
                                this.state = 17, this.openWakaBang = "";
                                break;
                            case "DOCTYPE":
                                this.state = 2, (this.doctype || this.sawRoot) && this.fail("inappropriately located doctype declaration."), this.openWakaBang = "";
                                break;
                            default:
                                this.openWakaBang.length >= 7 && this.fail("incorrect syntax.");
                        }
                    }
                    sComment() {
                        this.captureToChar(45) && (this.state = 18);
                    }
                    sCommentEnding() {
                        var e;
                        const t = this.getCodeNorm();
                        45 === t ? (this.state = 19, null === (e = this.commentHandler) || void 0 === e || e.call(this, this.text), this.text = "") : (this.text += "-" + String.fromCodePoint(t), this.state = 17);
                    }
                    sCommentEnded() {
                        const e = this.getCodeNorm();
                        62 !== e ? (this.fail("malformed comment."), this.text += "--" + String.fromCodePoint(e), this.state = 17) : this.state = 13;
                    }
                    sCData() {
                        this.captureToChar(93) && (this.state = 21);
                    }
                    sCDataEnding() {
                        const e = this.getCodeNorm();
                        93 === e ? this.state = 22 : (this.text += "]" + String.fromCodePoint(e), this.state = 20);
                    }
                    sCDataEnding2() {
                        var e;
                        const t = this.getCodeNorm();
                        switch(t){
                            case 62:
                                null === (e = this.cdataHandler) || void 0 === e || e.call(this, this.text), this.text = "", this.state = 13;
                                break;
                            case 93:
                                this.text += "]";
                                break;
                            default:
                                this.text += "]]" + String.fromCodePoint(t), this.state = 20;
                        }
                    }
                    sPIFirstChar() {
                        const e = this.getCodeNorm();
                        this.nameStartCheck(e) ? (this.piTarget += String.fromCodePoint(e), this.state = 24) : 63 === e || o(e) ? (this.fail("processing instruction without a target."), this.state = 63 === e ? 26 : 25) : (this.fail("disallowed character in processing instruction name."), this.piTarget += String.fromCodePoint(e), this.state = 24);
                    }
                    sPIRest() {
                        const { chunk: e, i: t } = this;
                        for(;;){
                            const r = this.getCodeNorm();
                            if (-1 === r) return void (this.piTarget += e.slice(t));
                            if (!this.nameCheck(r)) {
                                this.piTarget += e.slice(t, this.prevI);
                                const n = 63 === r;
                                n || o(r) ? "xml" === this.piTarget ? (this.xmlDeclPossible || this.fail("an XML declaration must be at the start of the document."), this.state = n ? 33 : 27) : this.state = n ? 26 : 25 : (this.fail("disallowed character in processing instruction name."), this.piTarget += String.fromCodePoint(r));
                                break;
                            }
                        }
                    }
                    sPIBody() {
                        if (0 === this.text.length) {
                            const e = this.getCodeNorm();
                            63 === e ? this.state = 26 : o(e) || (this.text = String.fromCodePoint(e));
                        } else this.captureToChar(63) && (this.state = 26);
                    }
                    sPIEnding() {
                        var e;
                        const t = this.getCodeNorm();
                        if (62 === t) {
                            const { piTarget: t } = this;
                            "xml" === t.toLowerCase() && this.fail("the XML declaration must appear at the start of the document."), null === (e = this.piHandler) || void 0 === e || e.call(this, {
                                target: t,
                                body: this.text
                            }), this.piTarget = this.text = "", this.state = 13;
                        } else 63 === t ? this.text += "?" : (this.text += "?" + String.fromCodePoint(t), this.state = 25);
                        this.xmlDeclPossible = !1;
                    }
                    sXMLDeclNameStart() {
                        const e = this.skipSpaces();
                        63 !== e ? -1 !== e && (this.state = 28, this.name = String.fromCodePoint(e)) : this.state = 33;
                    }
                    sXMLDeclName() {
                        const e = this.captureTo(S);
                        if (63 === e) return this.state = 33, this.name += this.text, this.text = "", void this.fail("XML declaration is incomplete.");
                        if (o(e) || 61 === e) {
                            if (this.name += this.text, this.text = "", !this.xmlDeclExpects.includes(this.name)) switch(this.name.length){
                                case 0:
                                    this.fail("did not expect any more name/value pairs.");
                                    break;
                                case 1:
                                    this.fail(`expected the name ${this.xmlDeclExpects[0]}.`);
                                    break;
                                default:
                                    this.fail("expected one of " + this.xmlDeclExpects.join(", "));
                            }
                            this.state = 61 === e ? 30 : 29;
                        }
                    }
                    sXMLDeclEq() {
                        const e = this.getCodeNorm();
                        if (63 === e) return this.state = 33, void this.fail("XML declaration is incomplete.");
                        o(e) || (61 !== e && this.fail("value required."), this.state = 30);
                    }
                    sXMLDeclValueStart() {
                        const e = this.getCodeNorm();
                        if (63 === e) return this.state = 33, void this.fail("XML declaration is incomplete.");
                        o(e) || (w(e) ? this.q = e : (this.fail("value must be quoted."), this.q = 32), this.state = 31);
                    }
                    sXMLDeclValue() {
                        const e = this.captureTo([
                            this.q,
                            63
                        ]);
                        if (63 === e) return this.state = 33, this.text = "", void this.fail("XML declaration is incomplete.");
                        if (-1 === e) return;
                        const t = this.text;
                        switch(this.text = "", this.name){
                            case "version":
                                {
                                    this.xmlDeclExpects = [
                                        "encoding",
                                        "standalone"
                                    ];
                                    const e = t;
                                    this.xmlDecl.version = e, /^1\.[0-9]+$/.test(e) ? this.opt.forceXMLVersion || this.setXMLVersion(e) : this.fail("version number must match /^1\\.[0-9]+$/.");
                                    break;
                                }
                            case "encoding":
                                /^[A-Za-z][A-Za-z0-9._-]*$/.test(t) || this.fail("encoding value must match /^[A-Za-z0-9][A-Za-z0-9._-]*$/."), this.xmlDeclExpects = [
                                    "standalone"
                                ], this.xmlDecl.encoding = t;
                                break;
                            case "standalone":
                                "yes" !== t && "no" !== t && this.fail('standalone value must match "yes" or "no".'), this.xmlDeclExpects = [], this.xmlDecl.standalone = t;
                        }
                        this.name = "", this.state = 32;
                    }
                    sXMLDeclSeparator() {
                        const e = this.getCodeNorm();
                        63 !== e ? (o(e) || (this.fail("whitespace required."), this.unget()), this.state = 27) : this.state = 33;
                    }
                    sXMLDeclEnding() {
                        var e;
                        62 === this.getCodeNorm() ? ("xml" !== this.piTarget ? this.fail("processing instructions are not allowed before root.") : "version" !== this.name && this.xmlDeclExpects.includes("version") && this.fail("XML declaration must contain a version."), null === (e = this.xmldeclHandler) || void 0 === e || e.call(this, this.xmlDecl), this.name = "", this.piTarget = this.text = "", this.state = 13) : this.fail("The character ? is disallowed anywhere in XML declarations."), this.xmlDeclPossible = !1;
                    }
                    sOpenTag() {
                        var e;
                        const t = this.captureNameChars();
                        if (-1 === t) return;
                        const r = this.tag = {
                            name: this.name,
                            attributes: Object.create(null)
                        };
                        switch(this.name = "", this.xmlnsOpt && (this.topNS = r.ns = Object.create(null)), null === (e = this.openTagStartHandler) || void 0 === e || e.call(this, r), this.sawRoot = !0, !this.fragmentOpt && this.closedRoot && this.fail("documents may contain only one root."), t){
                            case 62:
                                this.openTag();
                                break;
                            case 47:
                                this.state = 35;
                                break;
                            default:
                                o(t) || this.fail("disallowed character in tag name."), this.state = 36;
                        }
                    }
                    sOpenTagSlash() {
                        62 === this.getCode() ? this.openSelfClosingTag() : (this.fail("forward-slash in opening tag not followed by >."), this.state = 36);
                    }
                    sAttrib() {
                        const e = this.skipSpaces();
                        -1 !== e && (l(e) ? (this.unget(), this.state = 37) : 62 === e ? this.openTag() : 47 === e ? this.state = 35 : this.fail("disallowed character in attribute name."));
                    }
                    sAttribName() {
                        const e = this.captureNameChars();
                        61 === e ? this.state = 39 : o(e) ? this.state = 38 : 62 === e ? (this.fail("attribute without value."), this.pushAttrib(this.name, this.name), this.name = this.text = "", this.openTag()) : -1 !== e && this.fail("disallowed character in attribute name.");
                    }
                    sAttribNameSawWhite() {
                        const e = this.skipSpaces();
                        switch(e){
                            case -1:
                                return;
                            case 61:
                                this.state = 39;
                                break;
                            default:
                                this.fail("attribute without value."), this.text = "", this.name = "", 62 === e ? this.openTag() : l(e) ? (this.unget(), this.state = 37) : (this.fail("disallowed character in attribute name."), this.state = 36);
                        }
                    }
                    sAttribValue() {
                        const e = this.getCodeNorm();
                        w(e) ? (this.q = e, this.state = 40) : o(e) || (this.fail("unquoted attribute value."), this.state = 42, this.unget());
                    }
                    sAttribValueQuoted() {
                        const { q: e, chunk: t } = this;
                        let { i: r } = this;
                        for(;;)switch(this.getCode()){
                            case e:
                                return this.pushAttrib(this.name, this.text + t.slice(r, this.prevI)), this.name = this.text = "", this.q = null, void (this.state = 41);
                            case 38:
                                return this.text += t.slice(r, this.prevI), this.state = 14, void (this.entityReturnState = 40);
                            case 10:
                            case -2:
                            case 9:
                                this.text += t.slice(r, this.prevI) + " ", r = this.i;
                                break;
                            case 60:
                                return this.text += t.slice(r, this.prevI), void this.fail("disallowed character.");
                            case -1:
                                return void (this.text += t.slice(r));
                        }
                    }
                    sAttribValueClosed() {
                        const e = this.getCodeNorm();
                        o(e) ? this.state = 36 : 62 === e ? this.openTag() : 47 === e ? this.state = 35 : l(e) ? (this.fail("no whitespace between attributes."), this.unget(), this.state = 37) : this.fail("disallowed character in attribute name.");
                    }
                    sAttribValueUnquoted() {
                        const e = this.captureTo(M);
                        switch(e){
                            case 38:
                                this.state = 14, this.entityReturnState = 42;
                                break;
                            case 60:
                                this.fail("disallowed character.");
                                break;
                            case -1:
                                break;
                            default:
                                this.text.includes("]]>") && this.fail('the string "]]>" is disallowed in char data.'), this.pushAttrib(this.name, this.text), this.name = this.text = "", 62 === e ? this.openTag() : this.state = 36;
                        }
                    }
                    sCloseTag() {
                        const e = this.captureNameChars();
                        62 === e ? this.closeTag() : o(e) ? this.state = 44 : -1 !== e && this.fail("disallowed character in closing tag.");
                    }
                    sCloseTagSawWhite() {
                        switch(this.skipSpaces()){
                            case 62:
                                this.closeTag();
                                break;
                            case -1:
                                break;
                            default:
                                this.fail("disallowed character in closing tag.");
                        }
                    }
                    handleTextInRoot() {
                        let { i: e, forbiddenState: t } = this;
                        const { chunk: r, textHandler: n } = this;
                        e: for(;;)switch(this.getCode()){
                            case 60:
                                if (this.state = 15, void 0 !== n) {
                                    const { text: t } = this, i = r.slice(e, this.prevI);
                                    0 !== t.length ? (n(t + i), this.text = "") : 0 !== i.length && n(i);
                                }
                                t = 0;
                                break e;
                            case 38:
                                this.state = 14, this.entityReturnState = 13, void 0 !== n && (this.text += r.slice(e, this.prevI)), t = 0;
                                break e;
                            case 93:
                                switch(t){
                                    case 0:
                                        t = 1;
                                        break;
                                    case 1:
                                        t = 2;
                                        break;
                                    case 2:
                                        break;
                                    default:
                                        throw new Error("impossible state");
                                }
                                break;
                            case 62:
                                2 === t && this.fail('the string "]]>" is disallowed in char data.'), t = 0;
                                break;
                            case -2:
                                void 0 !== n && (this.text += r.slice(e, this.prevI) + "\n"), e = this.i, t = 0;
                                break;
                            case -1:
                                void 0 !== n && (this.text += r.slice(e));
                                break e;
                            default:
                                t = 0;
                        }
                        this.forbiddenState = t;
                    }
                    handleTextOutsideRoot() {
                        let { i: e } = this;
                        const { chunk: t, textHandler: r } = this;
                        let n = !1;
                        e: for(;;){
                            const i = this.getCode();
                            switch(i){
                                case 60:
                                    if (this.state = 15, void 0 !== r) {
                                        const { text: n } = this, i = t.slice(e, this.prevI);
                                        0 !== n.length ? (r(n + i), this.text = "") : 0 !== i.length && r(i);
                                    }
                                    break e;
                                case 38:
                                    this.state = 14, this.entityReturnState = 13, void 0 !== r && (this.text += t.slice(e, this.prevI)), n = !0;
                                    break e;
                                case -2:
                                    void 0 !== r && (this.text += t.slice(e, this.prevI) + "\n"), e = this.i;
                                    break;
                                case -1:
                                    void 0 !== r && (this.text += t.slice(e));
                                    break e;
                                default:
                                    o(i) || (n = !0);
                            }
                        }
                        n && (this.sawRoot || this.reportedTextBeforeRoot || (this.fail("text data outside of root node."), this.reportedTextBeforeRoot = !0), this.closedRoot && !this.reportedTextAfterRoot && (this.fail("text data outside of root node."), this.reportedTextAfterRoot = !0));
                    }
                    pushAttribNS(e, t) {
                        var r;
                        const { prefix: n, local: i } = this.qname(e), s = {
                            name: e,
                            prefix: n,
                            local: i,
                            value: t
                        };
                        if (this.attribList.push(s), null === (r = this.attributeHandler) || void 0 === r || r.call(this, s), "xmlns" === n) {
                            const e = t.trim();
                            "1.0" === this.currentXMLVersion && "" === e && this.fail("invalid attempt to undefine prefix in XML 1.0"), this.topNS[i] = e, C(this, i, e);
                        } else if ("xmlns" === e) {
                            const e = t.trim();
                            this.topNS[""] = e, C(this, "", e);
                        }
                    }
                    pushAttribPlain(e, t) {
                        var r;
                        const n = {
                            name: e,
                            value: t
                        };
                        this.attribList.push(n), null === (r = this.attributeHandler) || void 0 === r || r.call(this, n);
                    }
                    end() {
                        var e, t;
                        this.sawRoot || this.fail("document must contain a root element.");
                        const { tags: r } = this;
                        for(; r.length > 0;){
                            const e = r.pop();
                            this.fail("unclosed tag: " + e.name);
                        }
                        0 !== this.state && 13 !== this.state && this.fail("unexpected end.");
                        const { text: n } = this;
                        return 0 !== n.length && (null === (e = this.textHandler) || void 0 === e || e.call(this, n), this.text = ""), this._closed = !0, null === (t = this.endHandler) || void 0 === t || t.call(this), this._init(), this;
                    }
                    resolve(e) {
                        var t, r;
                        let n = this.topNS[e];
                        if (void 0 !== n) return n;
                        const { tags: i } = this;
                        for(let t = i.length - 1; t >= 0; t--)if (n = i[t].ns[e], void 0 !== n) return n;
                        return n = this.ns[e], void 0 !== n ? n : null === (r = (t = this.opt).resolvePrefix) || void 0 === r ? void 0 : r.call(t, e);
                    }
                    qname(e) {
                        const t = e.indexOf(":");
                        if (-1 === t) return {
                            prefix: "",
                            local: e
                        };
                        const r = e.slice(t + 1), n = e.slice(0, t);
                        return ("" === n || "" === r || r.includes(":")) && this.fail(`malformed name: ${e}.`), {
                            prefix: n,
                            local: r
                        };
                    }
                    processAttribsNS() {
                        var e;
                        const { attribList: t } = this, r = this.tag;
                        {
                            const { prefix: t, local: n } = this.qname(r.name);
                            r.prefix = t, r.local = n;
                            const i = r.uri = null !== (e = this.resolve(t)) && void 0 !== e ? e : "";
                            "" !== t && ("xmlns" === t && this.fail('tags may not have "xmlns" as prefix.'), "" === i && (this.fail(`unbound namespace prefix: ${JSON.stringify(t)}.`), r.uri = t));
                        }
                        if (0 === t.length) return;
                        const { attributes: n } = r, i = new Set;
                        for (const e of t){
                            const { name: t, prefix: r, local: s } = e;
                            let o, a;
                            "" === r ? (o = "xmlns" === t ? g : "", a = t) : (o = this.resolve(r), void 0 === o && (this.fail(`unbound namespace prefix: ${JSON.stringify(r)}.`), o = r), a = `{${o}}${s}`), i.has(a) && this.fail(`duplicate attribute: ${a}.`), i.add(a), e.uri = o, n[t] = e;
                        }
                        this.attribList = [];
                    }
                    processAttribsPlain() {
                        const { attribList: e } = this, t = this.tag.attributes;
                        for (const { name: r, value: n } of e)void 0 !== t[r] && this.fail(`duplicate attribute: ${r}.`), t[r] = n;
                        this.attribList = [];
                    }
                    openTag() {
                        var e;
                        this.processAttribs();
                        const { tags: t } = this, r = this.tag;
                        r.isSelfClosing = !1, null === (e = this.openTagHandler) || void 0 === e || e.call(this, r), t.push(r), this.state = 13, this.name = "";
                    }
                    openSelfClosingTag() {
                        var e, t, r;
                        this.processAttribs();
                        const { tags: n } = this, i = this.tag;
                        i.isSelfClosing = !0, null === (e = this.openTagHandler) || void 0 === e || e.call(this, i), null === (t = this.closeTagHandler) || void 0 === t || t.call(this, i);
                        null === (this.tag = null !== (r = n[n.length - 1]) && void 0 !== r ? r : null) && (this.closedRoot = !0), this.state = 13, this.name = "";
                    }
                    closeTag() {
                        const { tags: e, name: t } = this;
                        if (this.state = 13, this.name = "", "" === t) return this.fail("weird empty close tag."), void (this.text += "</>");
                        const r = this.closeTagHandler;
                        let n = e.length;
                        for(; n-- > 0;){
                            const n = this.tag = e.pop();
                            if (this.topNS = n.ns, null == r || r(n), n.name === t) break;
                            this.fail("unexpected close tag.");
                        }
                        0 === n ? this.closedRoot = !0 : n < 0 && (this.fail(`unmatched closing tag: ${t}.`), this.text += `</${t}>`);
                    }
                    parseEntity(e) {
                        if ("#" !== e[0]) {
                            const t = this.ENTITIES[e];
                            return void 0 !== t ? t : (this.fail(this.isName(e) ? "undefined entity." : "disallowed character in entity name."), `&${e};`);
                        }
                        let t = NaN;
                        return "x" === e[1] && /^#x[0-9a-f]+$/i.test(e) ? t = parseInt(e.slice(2), 16) : /^#[0-9]+$/.test(e) && (t = parseInt(e.slice(1), 10)), this.isChar(t) ? String.fromCodePoint(t) : (this.fail("malformed character entity."), `&${e};`);
                    }
                };
            },
            {
                "xmlchars/xml/1.0/ed5": 543,
                "xmlchars/xml/1.1/ed2": 544,
                "xmlchars/xmlns/1.0/ed3": 545
            }
        ],
        497: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t) {
                    this._block = n.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
                }
                i.prototype.update = function(e, t) {
                    "string" == typeof e && (t = t || "utf8", e = n.from(e, t));
                    for(var r = this._block, i = this._blockSize, s = e.length, o = this._len, a = 0; a < s;){
                        for(var l = o % i, c = Math.min(s - a, i - l), u = 0; u < c; u++)r[l + u] = e[a + u];
                        a += c, (o += c) % i == 0 && this._update(r);
                    }
                    return this._len += s, this;
                }, i.prototype.digest = function(e) {
                    var t = this._len % this._blockSize;
                    this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
                    var r = 8 * this._len;
                    if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);
                    else {
                        var n = (4294967295 & r) >>> 0, i = (r - n) / 4294967296;
                        this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
                    }
                    this._update(this._block);
                    var s = this._hash();
                    return e ? s.toString(e) : s;
                }, i.prototype._update = function() {
                    throw new Error("_update must be implemented by subclass");
                }, t.exports = i;
            },
            {
                "safe-buffer": 494
            }
        ],
        498: [
            function(e, t, r) {
                "use strict";
                var n = t.exports = function(e) {
                    e = e.toLowerCase();
                    var t = n[e];
                    if (!t) throw new Error(e + " is not supported (we accept pull requests)");
                    return new t;
                };
                n.sha = e("./sha"), n.sha1 = e("./sha1"), n.sha224 = e("./sha224"), n.sha256 = e("./sha256"), n.sha384 = e("./sha384"), n.sha512 = e("./sha512");
            },
            {
                "./sha": 499,
                "./sha1": 500,
                "./sha224": 501,
                "./sha256": 502,
                "./sha384": 503,
                "./sha512": 504
            }
        ],
        499: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], a = new Array(80);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 30 | e >>> 2;
                }
                function u(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, h = 0; h < 16; ++h)r[h] = e.readInt32BE(4 * h);
                    for(; h < 80; ++h)r[h] = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16];
                    for(var f = 0; f < 80; ++f){
                        var d = ~~(f / 20), p = 0 | ((t = n) << 5 | t >>> 27) + u(d, i, s, a) + l + r[f] + o[d];
                        l = a, a = s, s = c(i), i = n, n = p;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        500: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], a = new Array(80);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 5 | e >>> 27;
                }
                function u(e) {
                    return e << 30 | e >>> 2;
                }
                function h(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, f = 0; f < 16; ++f)r[f] = e.readInt32BE(4 * f);
                    for(; f < 80; ++f)r[f] = (t = r[f - 3] ^ r[f - 8] ^ r[f - 14] ^ r[f - 16]) << 1 | t >>> 31;
                    for(var d = 0; d < 80; ++d){
                        var p = ~~(d / 20), m = c(n) + h(p, i, s, a) + l + r[d] + o[p] | 0;
                        l = a, a = s, s = u(i), i = n, n = m;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        501: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./sha256"), s = e("./hash"), o = e("safe-buffer").Buffer, a = new Array(64);
                function l() {
                    this.init(), this._w = a, s.call(this, 64, 56);
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
                }, l.prototype._hash = function() {
                    var e = o.allocUnsafe(28);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                "./sha256": 502,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        502: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ], a = new Array(64);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function u(e, t, r) {
                    return e & t | r & (e | t);
                }
                function h(e) {
                    return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
                }
                function f(e) {
                    return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                }
                function d(e) {
                    return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, p = 0 | this._f, m = 0 | this._g, b = 0 | this._h, g = 0; g < 16; ++g)r[g] = e.readInt32BE(4 * g);
                    for(; g < 64; ++g)r[g] = 0 | (((t = r[g - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + r[g - 7] + d(r[g - 15]) + r[g - 16];
                    for(var y = 0; y < 64; ++y){
                        var v = b + f(l) + c(l, p, m) + o[y] + r[y] | 0, w = h(n) + u(n, i, s) | 0;
                        b = m, m = p, p = l, l = a + v | 0, a = s, s = i, i = n, n = v + w | 0;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0, this._f = p + this._f | 0, this._g = m + this._g | 0, this._h = b + this._h | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(32);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        503: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./sha512"), s = e("./hash"), o = e("safe-buffer").Buffer, a = new Array(160);
                function l() {
                    this.init(), this._w = a, s.call(this, 128, 112);
                }
                n(l, i), l.prototype.init = function() {
                    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
                }, l.prototype._hash = function() {
                    var e = o.allocUnsafe(48);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                "./sha512": 504,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        504: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ], a = new Array(160);
                function l() {
                    this.init(), this._w = a, i.call(this, 128, 112);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function u(e, t, r) {
                    return e & t | r & (e | t);
                }
                function h(e, t) {
                    return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
                }
                function f(e, t) {
                    return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
                }
                function d(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
                }
                function p(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
                }
                function m(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
                }
                function b(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
                }
                function g(e, t) {
                    return e >>> 0 < t >>> 0 ? 1 : 0;
                }
                n(l, i), l.prototype.init = function() {
                    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
                }, l.prototype._update = function(e) {
                    for(var t = this._w, r = 0 | this._ah, n = 0 | this._bh, i = 0 | this._ch, s = 0 | this._dh, a = 0 | this._eh, l = 0 | this._fh, y = 0 | this._gh, v = 0 | this._hh, w = 0 | this._al, _ = 0 | this._bl, x = 0 | this._cl, k = 0 | this._dl, S = 0 | this._el, M = 0 | this._fl, C = 0 | this._gl, T = 0 | this._hl, E = 0; E < 32; E += 2)t[E] = e.readInt32BE(4 * E), t[E + 1] = e.readInt32BE(4 * E + 4);
                    for(; E < 160; E += 2){
                        var A = t[E - 30], R = t[E - 30 + 1], O = d(A, R), j = p(R, A), I = m(A = t[E - 4], R = t[E - 4 + 1]), N = b(R, A), P = t[E - 14], B = t[E - 14 + 1], D = t[E - 32], F = t[E - 32 + 1], L = j + B | 0, z = O + P + g(L, j) | 0;
                        z = (z = z + I + g(L = L + N | 0, N) | 0) + D + g(L = L + F | 0, F) | 0, t[E] = z, t[E + 1] = L;
                    }
                    for(var U = 0; U < 160; U += 2){
                        z = t[U], L = t[U + 1];
                        var $ = u(r, n, i), H = u(w, _, x), V = h(r, w), q = h(w, r), W = f(a, S), X = f(S, a), K = o[U], Y = o[U + 1], Z = c(a, l, y), G = c(S, M, C), J = T + X | 0, Q = v + W + g(J, T) | 0;
                        Q = (Q = (Q = Q + Z + g(J = J + G | 0, G) | 0) + K + g(J = J + Y | 0, Y) | 0) + z + g(J = J + L | 0, L) | 0;
                        var ee = q + H | 0, te = V + $ + g(ee, q) | 0;
                        v = y, T = C, y = l, C = M, l = a, M = S, a = s + Q + g(S = k + J | 0, k) | 0, s = i, k = x, i = n, x = _, n = r, _ = w, r = Q + te + g(w = J + ee | 0, J) | 0;
                    }
                    this._al = this._al + w | 0, this._bl = this._bl + _ | 0, this._cl = this._cl + x | 0, this._dl = this._dl + k | 0, this._el = this._el + S | 0, this._fl = this._fl + M | 0, this._gl = this._gl + C | 0, this._hl = this._hl + T | 0, this._ah = this._ah + r + g(this._al, w) | 0, this._bh = this._bh + n + g(this._bl, _) | 0, this._ch = this._ch + i + g(this._cl, x) | 0, this._dh = this._dh + s + g(this._dl, k) | 0, this._eh = this._eh + a + g(this._el, S) | 0, this._fh = this._fh + l + g(this._fl, M) | 0, this._gh = this._gh + y + g(this._gl, C) | 0, this._hh = this._hh + v + g(this._hl, T) | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(64);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        505: [
            function(e, t, r) {
                "use strict";
                t.exports = i;
                var n = e("events").EventEmitter;
                function i() {
                    n.call(this);
                }
                e("inherits")(i, n), i.Readable = e("readable-stream/readable.js"), i.Writable = e("readable-stream/writable.js"), i.Duplex = e("readable-stream/duplex.js"), i.Transform = e("readable-stream/transform.js"), i.PassThrough = e("readable-stream/passthrough.js"), i.Stream = i, i.prototype.pipe = function(e, t) {
                    var r = this;
                    function i(t) {
                        e.writable && !1 === e.write(t) && r.pause && r.pause();
                    }
                    function s() {
                        r.readable && r.resume && r.resume();
                    }
                    r.on("data", i), e.on("drain", s), e._isStdio || t && !1 === t.end || (r.on("end", a), r.on("close", l));
                    var o = !1;
                    function a() {
                        o || (o = !0, e.end());
                    }
                    function l() {
                        o || (o = !0, "function" == typeof e.destroy && e.destroy());
                    }
                    function c(e) {
                        if (u(), 0 === n.listenerCount(this, "error")) throw e;
                    }
                    function u() {
                        r.removeListener("data", i), e.removeListener("drain", s), r.removeListener("end", a), r.removeListener("close", l), r.removeListener("error", c), e.removeListener("error", c), r.removeListener("end", u), r.removeListener("close", u), e.removeListener("close", u);
                    }
                    return r.on("error", c), e.on("error", c), r.on("end", u), r.on("close", u), e.on("close", u), e.emit("pipe", r), e;
                };
            },
            {
                events: 422,
                inherits: 440,
                "readable-stream/duplex.js": 507,
                "readable-stream/passthrough.js": 516,
                "readable-stream/readable.js": 517,
                "readable-stream/transform.js": 518,
                "readable-stream/writable.js": 519
            }
        ],
        506: [
            function(e, t, r) {
                "use strict";
                var n = {}.toString;
                t.exports = Array.isArray || function(e) {
                    return "[object Array]" == n.call(e);
                };
            },
            {}
        ],
        507: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./lib/_stream_duplex.js");
            },
            {
                "./lib/_stream_duplex.js": 508
            }
        ],
        508: [
            function(e, t, r) {
                "use strict";
                var n = e("process-nextick-args"), i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)t.push(r);
                    return t;
                };
                t.exports = h;
                var s = Object.create(e("core-util-is"));
                s.inherits = e("inherits");
                var o = e("./_stream_readable"), a = e("./_stream_writable");
                s.inherits(h, o);
                for(var l = i(a.prototype), c = 0; c < l.length; c++){
                    var u = l[c];
                    h.prototype[u] || (h.prototype[u] = a.prototype[u]);
                }
                function h(e) {
                    if (!(this instanceof h)) return new h(e);
                    o.call(this, e), a.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", f);
                }
                function f() {
                    this.allowHalfOpen || this._writableState.ended || n.nextTick(d, this);
                }
                function d(e) {
                    e.end();
                }
                Object.defineProperty(h.prototype, "writableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.highWaterMark;
                    }
                }), Object.defineProperty(h.prototype, "destroyed", {
                    get: function() {
                        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                    },
                    set: function(e) {
                        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                    }
                }), h.prototype._destroy = function(e, t) {
                    this.push(null), this.end(), n.nextTick(t, e);
                };
            },
            {
                "./_stream_readable": 510,
                "./_stream_writable": 512,
                "core-util-is": 383,
                inherits: 440,
                "process-nextick-args": 466
            }
        ],
        509: [
            function(e, t, r) {
                "use strict";
                t.exports = s;
                var n = e("./_stream_transform"), i = Object.create(e("core-util-is"));
                function s(e) {
                    if (!(this instanceof s)) return new s(e);
                    n.call(this, e);
                }
                i.inherits = e("inherits"), i.inherits(s, n), s.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            {
                "./_stream_transform": 511,
                "core-util-is": 383,
                inherits: 440
            }
        ],
        510: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i = e("process-nextick-args");
                        t.exports = v;
                        var s, o = e("isarray");
                        v.ReadableState = y;
                        e("events").EventEmitter;
                        var a = function(e, t) {
                            return e.listeners(t).length;
                        }, l = e("./internal/streams/stream"), c = e("safe-buffer").Buffer, u = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var h = Object.create(e("core-util-is"));
                        h.inherits = e("inherits");
                        var f = e("util"), d = void 0;
                        d = f && f.debuglog ? f.debuglog("stream") : function() {};
                        var p, m = e("./internal/streams/BufferList"), b = e("./internal/streams/destroy");
                        h.inherits(v, l);
                        var g = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function y(t, r) {
                            t = t || {};
                            var n = r instanceof (s = s || e("./_stream_duplex"));
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
                            var i = t.highWaterMark, o = t.readableHighWaterMark, a = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (o || 0 === o) ? o : a, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new m, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (p || (p = e("string_decoder/").StringDecoder), this.decoder = new p(t.encoding), this.encoding = t.encoding);
                        }
                        function v(t) {
                            if (s = s || e("./_stream_duplex"), !(this instanceof v)) return new v(t);
                            this._readableState = new y(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), l.call(this);
                        }
                        function w(e, t, r, n, i) {
                            var s, o = e._readableState;
                            null === t ? (o.reading = !1, function(e, t) {
                                if (t.ended) return;
                                if (t.decoder) {
                                    var r = t.decoder.end();
                                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                                }
                                t.ended = !0, k(e);
                            }(e, o)) : (i || (s = function(e, t) {
                                var r;
                                n = t, c.isBuffer(n) || n instanceof u || "string" == typeof t || void 0 === t || e.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
                                var n;
                                return r;
                            }(o, t)), s ? e.emit("error", s) : o.objectMode || t && t.length > 0 ? ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === c.prototype || (t = function(e) {
                                return c.from(e);
                            }(t)), n ? o.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : _(e, o, t, !0) : o.ended ? e.emit("error", new Error("stream.push() after EOF")) : (o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? _(e, o, t, !1) : M(e, o)) : _(e, o, t, !1))) : n || (o.reading = !1));
                            return function(e) {
                                return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
                            }(o);
                        }
                        function _(e, t, r, n) {
                            t.flowing && 0 === t.length && !t.sync ? (e.emit("data", r), e.read(0)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && k(e)), M(e, t);
                        }
                        Object.defineProperty(v.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), v.prototype.destroy = b.destroy, v.prototype._undestroy = b.undestroy, v.prototype._destroy = function(e, t) {
                            this.push(null), t(e);
                        }, v.prototype.push = function(e, t) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = c.from(e, t), t = ""), r = !0), w(this, e, t, !1, r);
                        }, v.prototype.unshift = function(e) {
                            return w(this, e, null, !0, !1);
                        }, v.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, v.prototype.setEncoding = function(t) {
                            return p || (p = e("string_decoder/").StringDecoder), this._readableState.decoder = new p(t), this._readableState.encoding = t, this;
                        };
                        function x(e, t) {
                            return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                return e >= 8388608 ? e = 8388608 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                            }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                        }
                        function k(e) {
                            var t = e._readableState;
                            t.needReadable = !1, t.emittedReadable || (d("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? i.nextTick(S, e) : S(e));
                        }
                        function S(e) {
                            d("emit readable"), e.emit("readable"), A(e);
                        }
                        function M(e, t) {
                            t.readingMore || (t.readingMore = !0, i.nextTick(C, e, t));
                        }
                        function C(e, t) {
                            for(var r = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (d("maybeReadMore read 0"), e.read(0), r !== t.length);)r = t.length;
                            t.readingMore = !1;
                        }
                        function T(e) {
                            d("readable nexttick read 0"), e.read(0);
                        }
                        function E(e, t) {
                            t.reading || (d("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), A(e), t.flowing && !t.reading && e.read(0);
                        }
                        function A(e) {
                            var t = e._readableState;
                            for(d("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function R(e, t) {
                            var r;
                            return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : r = function(e, t, r) {
                                var n;
                                e < t.head.data.length ? (n = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : n = e === t.head.data.length ? t.shift() : r ? function(e, t) {
                                    var r = t.head, n = 1, i = r.data;
                                    e -= i.length;
                                    for(; r = r.next;){
                                        var s = r.data, o = e > s.length ? s.length : e;
                                        if (o === s.length ? i += s : i += s.slice(0, e), 0 === (e -= o)) {
                                            o === s.length ? (++n, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = s.slice(o));
                                            break;
                                        }
                                        ++n;
                                    }
                                    return t.length -= n, i;
                                }(e, t) : function(e, t) {
                                    var r = c.allocUnsafe(e), n = t.head, i = 1;
                                    n.data.copy(r), e -= n.data.length;
                                    for(; n = n.next;){
                                        var s = n.data, o = e > s.length ? s.length : e;
                                        if (s.copy(r, r.length - e, 0, o), 0 === (e -= o)) {
                                            o === s.length ? (++i, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = s.slice(o));
                                            break;
                                        }
                                        ++i;
                                    }
                                    return t.length -= i, r;
                                }(e, t);
                                return n;
                            }(e, t.buffer, t.decoder), r);
                        }
                        function O(e) {
                            var t = e._readableState;
                            if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
                            t.endEmitted || (t.ended = !0, i.nextTick(j, t, e));
                        }
                        function j(e, t) {
                            e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
                        }
                        function I(e, t) {
                            for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                            return -1;
                        }
                        v.prototype.read = function(e) {
                            d("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return d("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? O(this) : k(this), null;
                            if (0 === (e = x(e, t)) && t.ended) return 0 === t.length && O(this), null;
                            var n, i = t.needReadable;
                            return d("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && d("length less than watermark", i = !0), t.ended || t.reading ? d("reading or ended", i = !1) : i && (d("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = x(r, t))), null === (n = e > 0 ? R(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && O(this)), null !== n && this.emit("data", n), n;
                        }, v.prototype._read = function(e) {
                            this.emit("error", new Error("_read() is not implemented"));
                        }, v.prototype.pipe = function(e, t) {
                            var n = this, s = this._readableState;
                            switch(s.pipesCount){
                                case 0:
                                    s.pipes = e;
                                    break;
                                case 1:
                                    s.pipes = [
                                        s.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    s.pipes.push(e);
                            }
                            s.pipesCount += 1, d("pipe count=%d opts=%j", s.pipesCount, t);
                            var l = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? u : v;
                            function c(t, r) {
                                d("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, d("cleanup"), e.removeListener("close", g), e.removeListener("finish", y), e.removeListener("drain", h), e.removeListener("error", b), e.removeListener("unpipe", c), n.removeListener("end", u), n.removeListener("end", v), n.removeListener("data", m), f = !0, !s.awaitDrain || e._writableState && !e._writableState.needDrain || h());
                            }
                            function u() {
                                d("onend"), e.end();
                            }
                            s.endEmitted ? i.nextTick(l) : n.once("end", l), e.on("unpipe", c);
                            var h = function(e) {
                                return function() {
                                    var t = e._readableState;
                                    d("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && a(e, "data") && (t.flowing = !0, A(e));
                                };
                            }(n);
                            e.on("drain", h);
                            var f = !1;
                            var p = !1;
                            function m(t) {
                                d("ondata"), p = !1, !1 !== e.write(t) || p || ((1 === s.pipesCount && s.pipes === e || s.pipesCount > 1 && -1 !== I(s.pipes, e)) && !f && (d("false write response, pause", s.awaitDrain), s.awaitDrain++, p = !0), n.pause());
                            }
                            function b(t) {
                                d("onerror", t), v(), e.removeListener("error", b), 0 === a(e, "error") && e.emit("error", t);
                            }
                            function g() {
                                e.removeListener("finish", y), v();
                            }
                            function y() {
                                d("onfinish"), e.removeListener("close", g), v();
                            }
                            function v() {
                                d("unpipe"), n.unpipe(e);
                            }
                            return n.on("data", m), function(e, t, r) {
                                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                                e._events && e._events[t] ? o(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                                    r,
                                    e._events[t]
                                ] : e.on(t, r);
                            }(e, "error", b), e.once("close", g), e.once("finish", y), e.emit("pipe", n), s.flowing || (d("pipe resume"), n.resume()), e;
                        }, v.prototype.unpipe = function(e) {
                            var t = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                            if (!e) {
                                var n = t.pipes, i = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var s = 0; s < i; s++)n[s].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = I(t.pipes, e);
                            return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                        }, v.prototype.on = function(e, t) {
                            var r = l.prototype.on.call(this, e, t);
                            if ("data" === e) !1 !== this._readableState.flowing && this.resume();
                            else if ("readable" === e) {
                                var n = this._readableState;
                                n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && k(this) : i.nextTick(T, this));
                            }
                            return r;
                        }, v.prototype.addListener = v.prototype.on, v.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (d("resume"), e.flowing = !0, function(e, t) {
                                t.resumeScheduled || (t.resumeScheduled = !0, i.nextTick(E, e, t));
                            }(this, e)), this;
                        }, v.prototype.pause = function() {
                            return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
                        }, v.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, n = !1;
                            for(var i in e.on("end", function() {
                                if (d("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(i) {
                                (d("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                            }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(i));
                            for(var s = 0; s < g.length; s++)e.on(g[s], this.emit.bind(this, g[s]));
                            return this._read = function(t) {
                                d("wrapped _read", t), n && (n = !1, e.resume());
                            }, this;
                        }, Object.defineProperty(v.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), v._fromList = R;
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./_stream_duplex": 508,
                "./internal/streams/BufferList": 513,
                "./internal/streams/destroy": 514,
                "./internal/streams/stream": 515,
                _process: 467,
                "core-util-is": 383,
                events: 422,
                inherits: 440,
                isarray: 506,
                "process-nextick-args": 466,
                "safe-buffer": 520,
                "string_decoder/": 521,
                util: 188
            }
        ],
        511: [
            function(e, t, r) {
                "use strict";
                t.exports = o;
                var n = e("./_stream_duplex"), i = Object.create(e("core-util-is"));
                function s(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (!n) return this.emit("error", new Error("write callback called multiple times"));
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    n.call(this, e), this._transformState = {
                        afterTransform: s.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", a);
                }
                function a() {
                    var e = this;
                    "function" == typeof this._flush ? this._flush(function(t, r) {
                        l(e, t, r);
                    }) : l(this, null, null);
                }
                function l(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
                    if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
                    return e.push(null);
                }
                i.inherits = e("inherits"), i.inherits(o, n), o.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, n.prototype.push.call(this, e, t);
                }, o.prototype._transform = function(e, t, r) {
                    throw new Error("_transform() is not implemented");
                }, o.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, o.prototype._read = function(e) {
                    var t = this._transformState;
                    null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
                }, o.prototype._destroy = function(e, t) {
                    var r = this;
                    n.prototype._destroy.call(this, e, function(e) {
                        t(e), r.emit("close");
                    });
                };
            },
            {
                "./_stream_duplex": 508,
                "core-util-is": 383,
                inherits: 440
            }
        ],
        512: [
            function(e, t, r) {
                (function(r, n, i) {
                    (function() {
                        "use strict";
                        var s = e("process-nextick-args");
                        function o(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(e, t, r) {
                                    var n = e.entry;
                                    e.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        t.pendingcb--, i(r), n = n.next;
                                    }
                                    t.corkedRequestsFree.next = e;
                                }(t, e);
                            };
                        }
                        t.exports = y;
                        var a, l = !r.browser && [
                            "v0.10",
                            "v0.9."
                        ].indexOf(r.version.slice(0, 5)) > -1 ? i : s.nextTick;
                        y.WritableState = g;
                        var c = Object.create(e("core-util-is"));
                        c.inherits = e("inherits");
                        var u = {
                            deprecate: e("util-deprecate")
                        }, h = e("./internal/streams/stream"), f = e("safe-buffer").Buffer, d = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var p, m = e("./internal/streams/destroy");
                        function b() {}
                        function g(t, r) {
                            a = a || e("./_stream_duplex"), t = t || {};
                            var n = r instanceof a;
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
                            var i = t.highWaterMark, c = t.writableHighWaterMark, u = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (c || 0 === c) ? c : u, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var h = !1 === t.decodeStrings;
                            this.decodeStrings = !h, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                !function(e, t) {
                                    var r = e._writableState, n = r.sync, i = r.writecb;
                                    if (function(e) {
                                        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                    }(r), t) !function(e, t, r, n, i) {
                                        --t.pendingcb, r ? (s.nextTick(i, n), s.nextTick(S, e, t), e._writableState.errorEmitted = !0, e.emit("error", n)) : (i(n), e._writableState.errorEmitted = !0, e.emit("error", n), S(e, t));
                                    }(e, r, n, t, i);
                                    else {
                                        var o = x(r);
                                        o || r.corked || r.bufferProcessing || !r.bufferedRequest || _(e, r), n ? l(w, e, r, o, i) : w(e, r, o, i);
                                    }
                                }(r, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new o(this);
                        }
                        function y(t) {
                            if (a = a || e("./_stream_duplex"), !(p.call(y, this) || this instanceof a)) return new y(t);
                            this._writableState = new g(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), h.call(this);
                        }
                        function v(e, t, r, n, i, s, o) {
                            t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
                        }
                        function w(e, t, r, n) {
                            r || function(e, t) {
                                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                            }(e, t), t.pendingcb--, n(), S(e, t);
                        }
                        function _(e, t) {
                            t.bufferProcessing = !0;
                            var r = t.bufferedRequest;
                            if (e._writev && r && r.next) {
                                var n = t.bufferedRequestCount, i = new Array(n), s = t.corkedRequestsFree;
                                s.entry = r;
                                for(var a = 0, l = !0; r;)i[a] = r, r.isBuf || (l = !1), r = r.next, a += 1;
                                i.allBuffers = l, v(e, t, !0, t.length, i, "", s.finish), t.pendingcb++, t.lastBufferedRequest = null, s.next ? (t.corkedRequestsFree = s.next, s.next = null) : t.corkedRequestsFree = new o(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, h = r.callback;
                                    if (v(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === r && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = r, t.bufferProcessing = !1;
                        }
                        function x(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function k(e, t) {
                            e._final(function(r) {
                                t.pendingcb--, r && e.emit("error", r), t.prefinished = !0, e.emit("prefinish"), S(e, t);
                            });
                        }
                        function S(e, t) {
                            var r = x(t);
                            return r && (!function(e, t) {
                                t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, s.nextTick(k, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
                            }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), r;
                        }
                        c.inherits(y, h), g.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(g.prototype, "buffer", {
                                    get: u.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(y, Symbol.hasInstance, {
                            value: function(e) {
                                return !!p.call(this, e) || this === y && e && e._writableState instanceof g;
                            }
                        })) : p = function(e) {
                            return e instanceof this;
                        }, y.prototype.pipe = function() {
                            this.emit("error", new Error("Cannot pipe, not readable"));
                        }, y.prototype.write = function(e, t, r) {
                            var n, i = this._writableState, o = !1, a = !i.objectMode && (n = e, f.isBuffer(n) || n instanceof d);
                            return a && !f.isBuffer(e) && (e = function(e) {
                                return f.from(e);
                            }(e)), "function" == typeof t && (r = t, t = null), a ? t = "buffer" : t || (t = i.defaultEncoding), "function" != typeof r && (r = b), i.ended ? function(e, t) {
                                var r = new Error("write after end");
                                e.emit("error", r), s.nextTick(t, r);
                            }(this, r) : (a || function(e, t, r, n) {
                                var i = !0, o = !1;
                                return null === r ? o = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || t.objectMode || (o = new TypeError("Invalid non-string/buffer chunk")), o && (e.emit("error", o), s.nextTick(n, o), i = !1), i;
                            }(this, i, e, r)) && (i.pendingcb++, o = function(e, t, r, n, i, s) {
                                if (!r) {
                                    var o = function(e, t, r) {
                                        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = f.from(t, r));
                                        return t;
                                    }(t, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var a = t.objectMode ? 1 : n.length;
                                t.length += a;
                                var l = t.length < t.highWaterMark;
                                l || (t.needDrain = !0);
                                if (t.writing || t.corked) {
                                    var c = t.lastBufferedRequest;
                                    t.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: s,
                                        next: null
                                    }, c ? c.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                } else v(e, t, !1, a, n, i, s);
                                return l;
                            }(this, i, a, e, t, r)), o;
                        }, y.prototype.cork = function() {
                            this._writableState.corked++;
                        }, y.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || _(this, e));
                        }, y.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(y.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), y.prototype._write = function(e, t, r) {
                            r(new Error("_write() is not implemented"));
                        }, y.prototype._writev = null, y.prototype.end = function(e, t, r) {
                            var n = this._writableState;
                            "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null != e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || function(e, t, r) {
                                t.ending = !0, S(e, t), r && (t.finished ? s.nextTick(r) : e.once("finish", r));
                                t.ended = !0, e.writable = !1;
                            }(this, n, r);
                        }, Object.defineProperty(y.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), y.prototype.destroy = m.destroy, y.prototype._undestroy = m.undestroy, y.prototype._destroy = function(e, t) {
                            this.end(), t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
            },
            {
                "./_stream_duplex": 508,
                "./internal/streams/destroy": 514,
                "./internal/streams/stream": 515,
                _process: 467,
                "core-util-is": 383,
                inherits: 440,
                "process-nextick-args": 466,
                "safe-buffer": 520,
                timers: 523,
                "util-deprecate": 524
            }
        ],
        513: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("util");
                t.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    return e.prototype.push = function(e) {
                        var t = {
                            data: e,
                            next: null
                        };
                        this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                    }, e.prototype.unshift = function(e) {
                        var t = {
                            data: e,
                            next: this.head
                        };
                        0 === this.length && (this.tail = t), this.head = t, ++this.length;
                    }, e.prototype.shift = function() {
                        if (0 !== this.length) {
                            var e = this.head.data;
                            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                        }
                    }, e.prototype.clear = function() {
                        this.head = this.tail = null, this.length = 0;
                    }, e.prototype.join = function(e) {
                        if (0 === this.length) return "";
                        for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                        return r;
                    }, e.prototype.concat = function(e) {
                        if (0 === this.length) return n.alloc(0);
                        for(var t, r, i, s = n.allocUnsafe(e >>> 0), o = this.head, a = 0; o;)t = o.data, r = s, i = a, t.copy(r, i), a += o.data.length, o = o.next;
                        return s;
                    }, e;
                }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function() {
                    var e = i.inspect({
                        length: this.length
                    });
                    return this.constructor.name + " " + e;
                });
            },
            {
                "safe-buffer": 520,
                util: 188
            }
        ],
        514: [
            function(e, t, r) {
                "use strict";
                var n = e("process-nextick-args");
                function i(e, t) {
                    e.emit("error", t);
                }
                t.exports = {
                    destroy: function(e, t) {
                        var r = this, s = this._readableState && this._readableState.destroyed, o = this._writableState && this._writableState.destroyed;
                        return s || o ? (t ? t(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, n.nextTick(i, this, e)) : n.nextTick(i, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(e) {
                            !t && e ? r._writableState ? r._writableState.errorEmitted || (r._writableState.errorEmitted = !0, n.nextTick(i, r, e)) : n.nextTick(i, r, e) : t && t(e);
                        }), this);
                    },
                    undestroy: function() {
                        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                    }
                };
            },
            {
                "process-nextick-args": 466
            }
        ],
        515: [
            function(e, t, r) {
                arguments[4][490][0].apply(r, arguments);
            },
            {
                dup: 490,
                events: 422
            }
        ],
        516: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./readable").PassThrough;
            },
            {
                "./readable": 517
            }
        ],
        517: [
            function(e, t, r) {
                "use strict";
                (r = t.exports = e("./lib/_stream_readable.js")).Stream = r, r.Readable = r, r.Writable = e("./lib/_stream_writable.js"), r.Duplex = e("./lib/_stream_duplex.js"), r.Transform = e("./lib/_stream_transform.js"), r.PassThrough = e("./lib/_stream_passthrough.js");
            },
            {
                "./lib/_stream_duplex.js": 508,
                "./lib/_stream_passthrough.js": 509,
                "./lib/_stream_readable.js": 510,
                "./lib/_stream_transform.js": 511,
                "./lib/_stream_writable.js": 512
            }
        ],
        518: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./readable").Transform;
            },
            {
                "./readable": 517
            }
        ],
        519: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./lib/_stream_writable.js");
            },
            {
                "./lib/_stream_writable.js": 512
            }
        ],
        520: [
            function(e, t, r) {
                arguments[4][217][0].apply(r, arguments);
            },
            {
                buffer: 220,
                dup: 217
            }
        ],
        521: [
            function(e, t, r) {
                arguments[4][218][0].apply(r, arguments);
            },
            {
                dup: 218,
                "safe-buffer": 520
            }
        ],
        522: [
            function(e, t, r) {
                arguments[4][218][0].apply(r, arguments);
            },
            {
                dup: 218,
                "safe-buffer": 494
            }
        ],
        523: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        var i = e("process/browser.js").nextTick, s = Function.prototype.apply, o = Array.prototype.slice, a = {}, l = 0;
                        function c(e, t) {
                            this._id = e, this._clearFn = t;
                        }
                        r.setTimeout = function() {
                            return new c(s.call(setTimeout, window, arguments), clearTimeout);
                        }, r.setInterval = function() {
                            return new c(s.call(setInterval, window, arguments), clearInterval);
                        }, r.clearTimeout = r.clearInterval = function(e) {
                            e.close();
                        }, c.prototype.unref = c.prototype.ref = function() {}, c.prototype.close = function() {
                            this._clearFn.call(window, this._id);
                        }, r.enroll = function(e, t) {
                            clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
                        }, r.unenroll = function(e) {
                            clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
                        }, r._unrefActive = r.active = function(e) {
                            clearTimeout(e._idleTimeoutId);
                            var t = e._idleTimeout;
                            t >= 0 && (e._idleTimeoutId = setTimeout(function() {
                                e._onTimeout && e._onTimeout();
                            }, t));
                        }, r.setImmediate = "function" == typeof t ? t : function(e) {
                            var t = l++, n = !(arguments.length < 2) && o.call(arguments, 1);
                            return a[t] = !0, i(function() {
                                a[t] && (n ? e.apply(null, n) : e.call(null), r.clearImmediate(t));
                            }), t;
                        }, r.clearImmediate = "function" == typeof n ? n : function(e) {
                            delete a[e];
                        };
                    }).call(this);
                }).call(this, e("timers").setImmediate, e("timers").clearImmediate);
            },
            {
                "process/browser.js": 467,
                timers: 523
            }
        ],
        524: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        function r(t) {
                            try {
                                if (!e.localStorage) return !1;
                            } catch (e) {
                                return !1;
                            }
                            var r = e.localStorage[t];
                            return null != r && "true" === String(r).toLowerCase();
                        }
                        t.exports = function(e, t) {
                            if (r("noDeprecation")) return e;
                            var n = !1;
                            return function() {
                                if (!n) {
                                    if (r("throwDeprecation")) throw new Error(t);
                                    r("traceDeprecation") ? console.trace(t) : console.warn(t), n = !0;
                                }
                                return e.apply(this, arguments);
                            };
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        525: [
            function(e, t, r) {
                "use strict";
                "function" == typeof Object.create ? t.exports = function(e, t) {
                    e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    });
                } : t.exports = function(e, t) {
                    e.super_ = t;
                    var r = function() {};
                    r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                };
            },
            {}
        ],
        526: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
                };
            },
            {}
        ],
        527: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        var i = /%[sdj%]/g;
                        r.format = function(e) {
                            if (!g(e)) {
                                for(var t = [], r = 0; r < arguments.length; r++)t.push(a(arguments[r]));
                                return t.join(" ");
                            }
                            r = 1;
                            for(var n = arguments, s = n.length, o = String(e).replace(i, function(e) {
                                if ("%%" === e) return "%";
                                if (r >= s) return e;
                                switch(e){
                                    case "%s":
                                        return String(n[r++]);
                                    case "%d":
                                        return Number(n[r++]);
                                    case "%j":
                                        try {
                                            return JSON.stringify(n[r++]);
                                        } catch (e) {
                                            return "[Circular]";
                                        }
                                    default:
                                        return e;
                                }
                            }), l = n[r]; r < s; l = n[++r])m(l) || !w(l) ? o += " " + l : o += " " + a(l);
                            return o;
                        }, r.deprecate = function(e, i) {
                            if (y(n.process)) return function() {
                                return r.deprecate(e, i).apply(this, arguments);
                            };
                            if (!0 === t.noDeprecation) return e;
                            var s = !1;
                            return function() {
                                if (!s) {
                                    if (t.throwDeprecation) throw new Error(i);
                                    t.traceDeprecation ? console.trace(i) : console.error(i), s = !0;
                                }
                                return e.apply(this, arguments);
                            };
                        };
                        var s, o = {};
                        function a(e, t) {
                            var n = {
                                seen: [],
                                stylize: c
                            };
                            return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), p(t) ? n.showHidden = t : t && r._extend(n, t), y(n.showHidden) && (n.showHidden = !1), y(n.depth) && (n.depth = 2), y(n.colors) && (n.colors = !1), y(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = l), u(n, e, n.depth);
                        }
                        function l(e, t) {
                            var r = a.styles[t];
                            return r ? "\x1b[" + a.colors[r][0] + "m" + e + "\x1b[" + a.colors[r][1] + "m" : e;
                        }
                        function c(e, t) {
                            return e;
                        }
                        function u(e, t, n) {
                            if (e.customInspect && t && k(t.inspect) && t.inspect !== r.inspect && (!t.constructor || t.constructor.prototype !== t)) {
                                var i = t.inspect(n, e);
                                return g(i) || (i = u(e, i, n)), i;
                            }
                            var s = function(e, t) {
                                if (y(t)) return e.stylize("undefined", "undefined");
                                if (g(t)) {
                                    var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                                    return e.stylize(r, "string");
                                }
                                if (b(t)) return e.stylize("" + t, "number");
                                if (p(t)) return e.stylize("" + t, "boolean");
                                if (m(t)) return e.stylize("null", "null");
                            }(e, t);
                            if (s) return s;
                            var o = Object.keys(t), a = function(e) {
                                var t = {};
                                return e.forEach(function(e, r) {
                                    t[e] = !0;
                                }), t;
                            }(o);
                            if (e.showHidden && (o = Object.getOwnPropertyNames(t)), x(t) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return h(t);
                            if (0 === o.length) {
                                if (k(t)) {
                                    var l = t.name ? ": " + t.name : "";
                                    return e.stylize("[Function" + l + "]", "special");
                                }
                                if (v(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
                                if (_(t)) return e.stylize(Date.prototype.toString.call(t), "date");
                                if (x(t)) return h(t);
                            }
                            var c, w = "", S = !1, M = [
                                "{",
                                "}"
                            ];
                            (d(t) && (S = !0, M = [
                                "[",
                                "]"
                            ]), k(t)) && (w = " [Function" + (t.name ? ": " + t.name : "") + "]");
                            return v(t) && (w = " " + RegExp.prototype.toString.call(t)), _(t) && (w = " " + Date.prototype.toUTCString.call(t)), x(t) && (w = " " + h(t)), 0 !== o.length || S && 0 != t.length ? n < 0 ? v(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(t), c = S ? function(e, t, r, n, i) {
                                for(var s = [], o = 0, a = t.length; o < a; ++o)E(t, String(o)) ? s.push(f(e, t, r, n, String(o), !0)) : s.push("");
                                return i.forEach(function(i) {
                                    i.match(/^\d+$/) || s.push(f(e, t, r, n, i, !0));
                                }), s;
                            }(e, t, n, a, o) : o.map(function(r) {
                                return f(e, t, n, a, r, S);
                            }), e.seen.pop(), function(e, t, r) {
                                if (e.reduce(function(e, t) {
                                    return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                                }, 0) > 60) return r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1];
                                return r[0] + t + " " + e.join(", ") + " " + r[1];
                            }(c, w, M)) : M[0] + w + M[1];
                        }
                        function h(e) {
                            return "[" + Error.prototype.toString.call(e) + "]";
                        }
                        function f(e, t, r, n, i, s) {
                            var o, a, l;
                            if ((l = Object.getOwnPropertyDescriptor(t, i) || {
                                value: t[i]
                            }).get ? a = l.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : l.set && (a = e.stylize("[Setter]", "special")), E(n, i) || (o = "[" + i + "]"), a || (e.seen.indexOf(l.value) < 0 ? (a = m(r) ? u(e, l.value, null) : u(e, l.value, r - 1)).indexOf("\n") > -1 && (a = s ? a.split("\n").map(function(e) {
                                return "  " + e;
                            }).join("\n").substr(2) : "\n" + a.split("\n").map(function(e) {
                                return "   " + e;
                            }).join("\n")) : a = e.stylize("[Circular]", "special")), y(o)) {
                                if (s && i.match(/^\d+$/)) return a;
                                (o = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
                            }
                            return o + ": " + a;
                        }
                        function d(e) {
                            return Array.isArray(e);
                        }
                        function p(e) {
                            return "boolean" == typeof e;
                        }
                        function m(e) {
                            return null === e;
                        }
                        function b(e) {
                            return "number" == typeof e;
                        }
                        function g(e) {
                            return "string" == typeof e;
                        }
                        function y(e) {
                            return void 0 === e;
                        }
                        function v(e) {
                            return w(e) && "[object RegExp]" === S(e);
                        }
                        function w(e) {
                            return "object" == typeof e && null !== e;
                        }
                        function _(e) {
                            return w(e) && "[object Date]" === S(e);
                        }
                        function x(e) {
                            return w(e) && ("[object Error]" === S(e) || e instanceof Error);
                        }
                        function k(e) {
                            return "function" == typeof e;
                        }
                        function S(e) {
                            return Object.prototype.toString.call(e);
                        }
                        function M(e) {
                            return e < 10 ? "0" + e.toString(10) : e.toString(10);
                        }
                        r.debuglog = function(e) {
                            if (y(s) && (s = t.env.NODE_DEBUG || ""), e = e.toUpperCase(), !o[e]) {
                                if (new RegExp("\\b" + e + "\\b", "i").test(s)) {
                                    var n = t.pid;
                                    o[e] = function() {
                                        var t = r.format.apply(r, arguments);
                                        console.error("%s %d: %s", e, n, t);
                                    };
                                } else o[e] = function() {};
                            }
                            return o[e];
                        }, r.inspect = a, a.colors = {
                            bold: [
                                1,
                                22
                            ],
                            italic: [
                                3,
                                23
                            ],
                            underline: [
                                4,
                                24
                            ],
                            inverse: [
                                7,
                                27
                            ],
                            white: [
                                37,
                                39
                            ],
                            grey: [
                                90,
                                39
                            ],
                            black: [
                                30,
                                39
                            ],
                            blue: [
                                34,
                                39
                            ],
                            cyan: [
                                36,
                                39
                            ],
                            green: [
                                32,
                                39
                            ],
                            magenta: [
                                35,
                                39
                            ],
                            red: [
                                31,
                                39
                            ],
                            yellow: [
                                33,
                                39
                            ]
                        }, a.styles = {
                            special: "cyan",
                            number: "yellow",
                            boolean: "yellow",
                            undefined: "grey",
                            null: "bold",
                            string: "green",
                            date: "magenta",
                            regexp: "red"
                        }, r.isArray = d, r.isBoolean = p, r.isNull = m, r.isNullOrUndefined = function(e) {
                            return null == e;
                        }, r.isNumber = b, r.isString = g, r.isSymbol = function(e) {
                            return "symbol" == typeof e;
                        }, r.isUndefined = y, r.isRegExp = v, r.isObject = w, r.isDate = _, r.isError = x, r.isFunction = k, r.isPrimitive = function(e) {
                            return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                        }, r.isBuffer = e("./support/isBuffer");
                        var C = [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ];
                        function T() {
                            var e = new Date, t = [
                                M(e.getHours()),
                                M(e.getMinutes()),
                                M(e.getSeconds())
                            ].join(":");
                            return [
                                e.getDate(),
                                C[e.getMonth()],
                                t
                            ].join(" ");
                        }
                        function E(e, t) {
                            return Object.prototype.hasOwnProperty.call(e, t);
                        }
                        r.log = function() {
                            console.log("%s - %s", T(), r.format.apply(r, arguments));
                        }, r.inherits = e("inherits"), r._extend = function(e, t) {
                            if (!t || !w(t)) return e;
                            for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                            return e;
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./support/isBuffer": 526,
                _process: 467,
                inherits: 525
            }
        ],
        528: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), Object.defineProperty(r, "v1", {
                    enumerable: !0,
                    get: function() {
                        return n.default;
                    }
                }), Object.defineProperty(r, "v3", {
                    enumerable: !0,
                    get: function() {
                        return i.default;
                    }
                }), Object.defineProperty(r, "v4", {
                    enumerable: !0,
                    get: function() {
                        return s.default;
                    }
                }), Object.defineProperty(r, "v5", {
                    enumerable: !0,
                    get: function() {
                        return o.default;
                    }
                }), Object.defineProperty(r, "NIL", {
                    enumerable: !0,
                    get: function() {
                        return a.default;
                    }
                }), Object.defineProperty(r, "version", {
                    enumerable: !0,
                    get: function() {
                        return l.default;
                    }
                }), Object.defineProperty(r, "validate", {
                    enumerable: !0,
                    get: function() {
                        return c.default;
                    }
                }), Object.defineProperty(r, "stringify", {
                    enumerable: !0,
                    get: function() {
                        return u.default;
                    }
                }), Object.defineProperty(r, "parse", {
                    enumerable: !0,
                    get: function() {
                        return h.default;
                    }
                });
                var n = f(e("./v1.js")), i = f(e("./v3.js")), s = f(e("./v4.js")), o = f(e("./v5.js")), a = f(e("./nil.js")), l = f(e("./version.js")), c = f(e("./validate.js")), u = f(e("./stringify.js")), h = f(e("./parse.js"));
                function f(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
            },
            {
                "./nil.js": 530,
                "./parse.js": 531,
                "./stringify.js": 535,
                "./v1.js": 536,
                "./v3.js": 537,
                "./v4.js": 539,
                "./v5.js": 540,
                "./validate.js": 541,
                "./version.js": 542
            }
        ],
        529: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    return 14 + (e + 64 >>> 9 << 4) + 1;
                }
                function i(e, t) {
                    const r = (65535 & e) + (65535 & t);
                    return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
                }
                function s(e, t, r, n, s, o) {
                    var a, l;
                    return i((a = i(i(t, e), i(n, o))) << (l = s) | a >>> 32 - l, r);
                }
                function o(e, t, r, n, i, o, a) {
                    return s(t & r | ~t & n, e, t, i, o, a);
                }
                function a(e, t, r, n, i, o, a) {
                    return s(t & n | r & ~n, e, t, i, o, a);
                }
                function l(e, t, r, n, i, o, a) {
                    return s(t ^ r ^ n, e, t, i, o, a);
                }
                function c(e, t, r, n, i, o, a) {
                    return s(r ^ (t | ~n), e, t, i, o, a);
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var u = function(e) {
                    if ("string" == typeof e) {
                        const t = unescape(encodeURIComponent(e));
                        e = new Uint8Array(t.length);
                        for(let r = 0; r < t.length; ++r)e[r] = t.charCodeAt(r);
                    }
                    return function(e) {
                        const t = [], r = 32 * e.length;
                        for(let n = 0; n < r; n += 8){
                            const r = e[n >> 5] >>> n % 32 & 255, i = parseInt("0123456789abcdef".charAt(r >>> 4 & 15) + "0123456789abcdef".charAt(15 & r), 16);
                            t.push(i);
                        }
                        return t;
                    }(function(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[n(t) - 1] = t;
                        let r = 1732584193, s = -271733879, u = -1732584194, h = 271733878;
                        for(let t = 0; t < e.length; t += 16){
                            const n = r, f = s, d = u, p = h;
                            r = o(r, s, u, h, e[t], 7, -680876936), h = o(h, r, s, u, e[t + 1], 12, -389564586), u = o(u, h, r, s, e[t + 2], 17, 606105819), s = o(s, u, h, r, e[t + 3], 22, -1044525330), r = o(r, s, u, h, e[t + 4], 7, -176418897), h = o(h, r, s, u, e[t + 5], 12, 1200080426), u = o(u, h, r, s, e[t + 6], 17, -1473231341), s = o(s, u, h, r, e[t + 7], 22, -45705983), r = o(r, s, u, h, e[t + 8], 7, 1770035416), h = o(h, r, s, u, e[t + 9], 12, -1958414417), u = o(u, h, r, s, e[t + 10], 17, -42063), s = o(s, u, h, r, e[t + 11], 22, -1990404162), r = o(r, s, u, h, e[t + 12], 7, 1804603682), h = o(h, r, s, u, e[t + 13], 12, -40341101), u = o(u, h, r, s, e[t + 14], 17, -1502002290), s = o(s, u, h, r, e[t + 15], 22, 1236535329), r = a(r, s, u, h, e[t + 1], 5, -165796510), h = a(h, r, s, u, e[t + 6], 9, -1069501632), u = a(u, h, r, s, e[t + 11], 14, 643717713), s = a(s, u, h, r, e[t], 20, -373897302), r = a(r, s, u, h, e[t + 5], 5, -701558691), h = a(h, r, s, u, e[t + 10], 9, 38016083), u = a(u, h, r, s, e[t + 15], 14, -660478335), s = a(s, u, h, r, e[t + 4], 20, -405537848), r = a(r, s, u, h, e[t + 9], 5, 568446438), h = a(h, r, s, u, e[t + 14], 9, -1019803690), u = a(u, h, r, s, e[t + 3], 14, -187363961), s = a(s, u, h, r, e[t + 8], 20, 1163531501), r = a(r, s, u, h, e[t + 13], 5, -1444681467), h = a(h, r, s, u, e[t + 2], 9, -51403784), u = a(u, h, r, s, e[t + 7], 14, 1735328473), s = a(s, u, h, r, e[t + 12], 20, -1926607734), r = l(r, s, u, h, e[t + 5], 4, -378558), h = l(h, r, s, u, e[t + 8], 11, -2022574463), u = l(u, h, r, s, e[t + 11], 16, 1839030562), s = l(s, u, h, r, e[t + 14], 23, -35309556), r = l(r, s, u, h, e[t + 1], 4, -1530992060), h = l(h, r, s, u, e[t + 4], 11, 1272893353), u = l(u, h, r, s, e[t + 7], 16, -155497632), s = l(s, u, h, r, e[t + 10], 23, -1094730640), r = l(r, s, u, h, e[t + 13], 4, 681279174), h = l(h, r, s, u, e[t], 11, -358537222), u = l(u, h, r, s, e[t + 3], 16, -722521979), s = l(s, u, h, r, e[t + 6], 23, 76029189), r = l(r, s, u, h, e[t + 9], 4, -640364487), h = l(h, r, s, u, e[t + 12], 11, -421815835), u = l(u, h, r, s, e[t + 15], 16, 530742520), s = l(s, u, h, r, e[t + 2], 23, -995338651), r = c(r, s, u, h, e[t], 6, -198630844), h = c(h, r, s, u, e[t + 7], 10, 1126891415), u = c(u, h, r, s, e[t + 14], 15, -1416354905), s = c(s, u, h, r, e[t + 5], 21, -57434055), r = c(r, s, u, h, e[t + 12], 6, 1700485571), h = c(h, r, s, u, e[t + 3], 10, -1894986606), u = c(u, h, r, s, e[t + 10], 15, -1051523), s = c(s, u, h, r, e[t + 1], 21, -2054922799), r = c(r, s, u, h, e[t + 8], 6, 1873313359), h = c(h, r, s, u, e[t + 15], 10, -30611744), u = c(u, h, r, s, e[t + 6], 15, -1560198380), s = c(s, u, h, r, e[t + 13], 21, 1309151649), r = c(r, s, u, h, e[t + 4], 6, -145523070), h = c(h, r, s, u, e[t + 11], 10, -1120210379), u = c(u, h, r, s, e[t + 2], 15, 718787259), s = c(s, u, h, r, e[t + 9], 21, -343485551), r = i(r, n), s = i(s, f), u = i(u, d), h = i(h, p);
                        }
                        return [
                            r,
                            s,
                            u,
                            h
                        ];
                    }(function(e) {
                        if (0 === e.length) return [];
                        const t = 8 * e.length, r = new Uint32Array(n(t));
                        for(let n = 0; n < t; n += 8)r[n >> 5] |= (255 & e[n / 8]) << n % 32;
                        return r;
                    }(e), 8 * e.length));
                };
                r.default = u;
            },
            {}
        ],
        530: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                r.default = "00000000-0000-0000-0000-000000000000";
            },
            {}
        ],
        531: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    let t;
                    const r = new Uint8Array(16);
                    return r[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, r[1] = t >>> 16 & 255, r[2] = t >>> 8 & 255, r[3] = 255 & t, r[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, r[5] = 255 & t, r[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, r[7] = 255 & t, r[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, r[9] = 255 & t, r[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = t / 4294967296 & 255, r[12] = t >>> 24 & 255, r[13] = t >>> 16 & 255, r[14] = t >>> 8 & 255, r[15] = 255 & t, r;
                };
                r.default = s;
            },
            {
                "./validate.js": 541
            }
        ],
        532: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                r.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
            },
            {}
        ],
        533: [
            function(e, t, r) {
                "use strict";
                let n;
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = function() {
                    if (!n && (n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto), !n)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                    return n(i);
                };
                const i = new Uint8Array(16);
            },
            {}
        ],
        534: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r, n) {
                    switch(e){
                        case 0:
                            return t & r ^ ~t & n;
                        case 1:
                            return t ^ r ^ n;
                        case 2:
                            return t & r ^ t & n ^ r & n;
                        case 3:
                            return t ^ r ^ n;
                    }
                }
                function i(e, t) {
                    return e << t | e >>> 32 - t;
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = function(e) {
                    const t = [
                        1518500249,
                        1859775393,
                        2400959708,
                        3395469782
                    ], r = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ];
                    if ("string" == typeof e) {
                        const t = unescape(encodeURIComponent(e));
                        e = [];
                        for(let r = 0; r < t.length; ++r)e.push(t.charCodeAt(r));
                    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
                    e.push(128);
                    const s = e.length / 4 + 2, o = Math.ceil(s / 16), a = new Array(o);
                    for(let t = 0; t < o; ++t){
                        const r = new Uint32Array(16);
                        for(let n = 0; n < 16; ++n)r[n] = e[64 * t + 4 * n] << 24 | e[64 * t + 4 * n + 1] << 16 | e[64 * t + 4 * n + 2] << 8 | e[64 * t + 4 * n + 3];
                        a[t] = r;
                    }
                    a[o - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), a[o - 1][14] = Math.floor(a[o - 1][14]), a[o - 1][15] = 8 * (e.length - 1) & 4294967295;
                    for(let e = 0; e < o; ++e){
                        const s = new Uint32Array(80);
                        for(let t = 0; t < 16; ++t)s[t] = a[e][t];
                        for(let e = 16; e < 80; ++e)s[e] = i(s[e - 3] ^ s[e - 8] ^ s[e - 14] ^ s[e - 16], 1);
                        let o = r[0], l = r[1], c = r[2], u = r[3], h = r[4];
                        for(let e = 0; e < 80; ++e){
                            const r = Math.floor(e / 20), a = i(o, 5) + n(r, l, c, u) + h + t[r] + s[e] >>> 0;
                            h = u, u = c, c = i(l, 30) >>> 0, l = o, o = a;
                        }
                        r[0] = r[0] + o >>> 0, r[1] = r[1] + l >>> 0, r[2] = r[2] + c >>> 0, r[3] = r[3] + u >>> 0, r[4] = r[4] + h >>> 0;
                    }
                    return [
                        r[0] >> 24 & 255,
                        r[0] >> 16 & 255,
                        r[0] >> 8 & 255,
                        255 & r[0],
                        r[1] >> 24 & 255,
                        r[1] >> 16 & 255,
                        r[1] >> 8 & 255,
                        255 & r[1],
                        r[2] >> 24 & 255,
                        r[2] >> 16 & 255,
                        r[2] >> 8 & 255,
                        255 & r[2],
                        r[3] >> 24 & 255,
                        r[3] >> 16 & 255,
                        r[3] >> 8 & 255,
                        255 & r[3],
                        r[4] >> 24 & 255,
                        r[4] >> 16 & 255,
                        r[4] >> 8 & 255,
                        255 & r[4]
                    ];
                };
                r.default = s;
            },
            {}
        ],
        535: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                const s = [];
                for(let e = 0; e < 256; ++e)s.push((e + 256).toString(16).substr(1));
                var o = function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    const r = (s[e[t + 0]] + s[e[t + 1]] + s[e[t + 2]] + s[e[t + 3]] + "-" + s[e[t + 4]] + s[e[t + 5]] + "-" + s[e[t + 6]] + s[e[t + 7]] + "-" + s[e[t + 8]] + s[e[t + 9]] + "-" + s[e[t + 10]] + s[e[t + 11]] + s[e[t + 12]] + s[e[t + 13]] + s[e[t + 14]] + s[e[t + 15]]).toLowerCase();
                    if (!(0, i.default)(r)) throw TypeError("Stringified UUID is invalid");
                    return r;
                };
                r.default = o;
            },
            {
                "./validate.js": 541
            }
        ],
        536: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./rng.js")), i = s(e("./stringify.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                let o, a, l = 0, c = 0;
                var u = function(e, t, r) {
                    let s = t && r || 0;
                    const u = t || new Array(16);
                    let h = (e = e || {}).node || o, f = void 0 !== e.clockseq ? e.clockseq : a;
                    if (null == h || null == f) {
                        const t = e.random || (e.rng || n.default)();
                        null == h && (h = o = [
                            1 | t[0],
                            t[1],
                            t[2],
                            t[3],
                            t[4],
                            t[5]
                        ]), null == f && (f = a = 16383 & (t[6] << 8 | t[7]));
                    }
                    let d = void 0 !== e.msecs ? e.msecs : Date.now(), p = void 0 !== e.nsecs ? e.nsecs : c + 1;
                    const m = d - l + (p - c) / 1e4;
                    if (m < 0 && void 0 === e.clockseq && (f = f + 1 & 16383), (m < 0 || d > l) && void 0 === e.nsecs && (p = 0), p >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                    l = d, c = p, a = f, d += 122192928e5;
                    const b = (1e4 * (268435455 & d) + p) % 4294967296;
                    u[s++] = b >>> 24 & 255, u[s++] = b >>> 16 & 255, u[s++] = b >>> 8 & 255, u[s++] = 255 & b;
                    const g = d / 4294967296 * 1e4 & 268435455;
                    u[s++] = g >>> 8 & 255, u[s++] = 255 & g, u[s++] = g >>> 24 & 15 | 16, u[s++] = g >>> 16 & 255, u[s++] = f >>> 8 | 128, u[s++] = 255 & f;
                    for(let e = 0; e < 6; ++e)u[s + e] = h[e];
                    return t || (0, i.default)(u);
                };
                r.default = u;
            },
            {
                "./rng.js": 533,
                "./stringify.js": 535
            }
        ],
        537: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./v35.js")), i = s(e("./md5.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = (0, n.default)("v3", 48, i.default);
                r.default = o;
            },
            {
                "./md5.js": 529,
                "./v35.js": 538
            }
        ],
        538: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = function(e, t, r) {
                    function s(e, s, o, a) {
                        if ("string" == typeof e && (e = function(e) {
                            e = unescape(encodeURIComponent(e));
                            const t = [];
                            for(let r = 0; r < e.length; ++r)t.push(e.charCodeAt(r));
                            return t;
                        }(e)), "string" == typeof s && (s = (0, i.default)(s)), 16 !== s.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                        let l = new Uint8Array(16 + e.length);
                        if (l.set(s), l.set(e, s.length), l = r(l), l[6] = 15 & l[6] | t, l[8] = 63 & l[8] | 128, o) {
                            a = a || 0;
                            for(let e = 0; e < 16; ++e)o[a + e] = l[e];
                            return o;
                        }
                        return (0, n.default)(l);
                    }
                    try {
                        s.name = e;
                    } catch (e) {}
                    return s.DNS = o, s.URL = a, s;
                }, r.URL = r.DNS = void 0;
                var n = s(e("./stringify.js")), i = s(e("./parse.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                const o = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
                r.DNS = o;
                const a = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
                r.URL = a;
            },
            {
                "./parse.js": 531,
                "./stringify.js": 535
            }
        ],
        539: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./rng.js")), i = s(e("./stringify.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = function(e, t, r) {
                    const s = (e = e || {}).random || (e.rng || n.default)();
                    if (s[6] = 15 & s[6] | 64, s[8] = 63 & s[8] | 128, t) {
                        r = r || 0;
                        for(let e = 0; e < 16; ++e)t[r + e] = s[e];
                        return t;
                    }
                    return (0, i.default)(s);
                };
                r.default = o;
            },
            {
                "./rng.js": 533,
                "./stringify.js": 535
            }
        ],
        540: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./v35.js")), i = s(e("./sha1.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = (0, n.default)("v5", 80, i.default);
                r.default = o;
            },
            {
                "./sha1.js": 534,
                "./v35.js": 538
            }
        ],
        541: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./regex.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    return "string" == typeof e && i.default.test(e);
                };
                r.default = s;
            },
            {
                "./regex.js": 532
            }
        ],
        542: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    return parseInt(e.substr(14, 1), 16);
                };
                r.default = s;
            },
            {
                "./validate.js": 541
            }
        ],
        543: [
            function(e, t, r) {
                "use strict";
                /**
 * Character classes and associated utilities for the 5th edition of XML 1.0.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CHAR = "\t\n\r -\ud7ff\ue000-\ufffd\ud800\udc00-\udbff\udfff", r.S = " \t\r\n", r.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NAME_CHAR = "-" + r.NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.CHAR_RE = new RegExp("^[" + r.CHAR + "]$", "u"), r.S_RE = new RegExp("^[" + r.S + "]+$", "u"), r.NAME_START_CHAR_RE = new RegExp("^[" + r.NAME_START_CHAR + "]$", "u"), r.NAME_CHAR_RE = new RegExp("^[" + r.NAME_CHAR + "]$", "u"), r.NAME_RE = new RegExp("^[" + r.NAME_START_CHAR + "][" + r.NAME_CHAR + "]*$", "u"), r.NMTOKEN_RE = new RegExp("^[" + r.NAME_CHAR + "]+$", "u");
                function n(e) {
                    return e >= 65 && e <= 90 || e >= 97 && e <= 122 || 58 === e || 95 === e || 8204 === e || 8205 === e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                r.S_LIST = [
                    32,
                    10,
                    13,
                    9
                ], r.isChar = function(e) {
                    return e >= 32 && e <= 55295 || 10 === e || 13 === e || 9 === e || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isS = function(e) {
                    return 32 === e || 10 === e || 13 === e || 9 === e;
                }, r.isNameStartChar = n, r.isNameChar = function(e) {
                    return n(e) || e >= 48 && e <= 57 || 45 === e || 46 === e || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ],
        544: [
            function(e, t, r) {
                "use strict";
                /**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CHAR = "\x01-\ud7ff\ue000-\ufffd\ud800\udc00-\udbff\udfff", r.RESTRICTED_CHAR = "\x01-\b\v\f\x0e-\x1f\x7f-\x84\x86-\x9f", r.S = " \t\r\n", r.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NAME_CHAR = "-" + r.NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.CHAR_RE = new RegExp("^[" + r.CHAR + "]$", "u"), r.RESTRICTED_CHAR_RE = new RegExp("^[" + r.RESTRICTED_CHAR + "]$", "u"), r.S_RE = new RegExp("^[" + r.S + "]+$", "u"), r.NAME_START_CHAR_RE = new RegExp("^[" + r.NAME_START_CHAR + "]$", "u"), r.NAME_CHAR_RE = new RegExp("^[" + r.NAME_CHAR + "]$", "u"), r.NAME_RE = new RegExp("^[" + r.NAME_START_CHAR + "][" + r.NAME_CHAR + "]*$", "u"), r.NMTOKEN_RE = new RegExp("^[" + r.NAME_CHAR + "]+$", "u");
                function n(e) {
                    return e >= 65 && e <= 90 || e >= 97 && e <= 122 || 58 === e || 95 === e || 8204 === e || 8205 === e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                r.S_LIST = [
                    32,
                    10,
                    13,
                    9
                ], r.isChar = function(e) {
                    return e >= 1 && e <= 55295 || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isRestrictedChar = function(e) {
                    return e >= 1 && e <= 8 || 11 === e || 12 === e || e >= 14 && e <= 31 || e >= 127 && e <= 132 || e >= 134 && e <= 159;
                }, r.isCharAndNotRestricted = function(e) {
                    return 9 === e || 10 === e || 13 === e || e > 31 && e < 127 || 133 === e || e > 159 && e <= 55295 || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isS = function(e) {
                    return 32 === e || 10 === e || 13 === e || 9 === e;
                }, r.isNameStartChar = n, r.isNameChar = function(e) {
                    return n(e) || e >= 48 && e <= 57 || 45 === e || 46 === e || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ],
        545: [
            function(e, t, r) {
                "use strict";
                /**
 * Character class utilities for XML NS 1.0 edition 3.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ function n(e) {
                    return e >= 65 && e <= 90 || 95 === e || e >= 97 && e <= 122 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.NC_NAME_START_CHAR = "A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c-\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NC_NAME_CHAR = "-" + r.NC_NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.NC_NAME_START_CHAR_RE = new RegExp("^[" + r.NC_NAME_START_CHAR + "]$", "u"), r.NC_NAME_CHAR_RE = new RegExp("^[" + r.NC_NAME_CHAR + "]$", "u"), r.NC_NAME_RE = new RegExp("^[" + r.NC_NAME_START_CHAR + "][" + r.NC_NAME_CHAR + "]*$", "u"), r.isNCNameStartChar = n, r.isNCNameChar = function(e) {
                    return n(e) || 45 === e || 46 === e || e >= 48 && e <= 57 || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ]
    }, {}, [
        15
    ])(15);
});


var $c81b9af5835f71db$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($c81b9af5835f71db$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $c81b9af5835f71db$exports = g;
});




function $7b85387a947c68c6$export$d16b159e2fcc1c52(apiParams) {
    const { mutate: queryAssumption, data: scenarioAssumption } = (0, $d5a0a75b5a6b57e1$export$609860bf8b0084c)([
        "getScenarioAssumptions"
    ], {
        mutationFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)(apiParams);
        }
    });
    return {
        queryAssumption: queryAssumption,
        scenarioAssumption: scenarioAssumption
    };
}


// noinspection GraphQLUnresolvedReference

const $8797ca29702eee23$export$fce0c275a3a7fa5d = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetScenarioProjectList (
        $inScenarioID: UUID!
        $inEdited: Int
    ){
        executeGetScenarioProjectList(
            inScenarioID: $inScenarioID
            inEdited: $inEdited
        ) {
            ScenarioID
            SourceID
            ScenarioProjID
            ProjID
            ProjectName
            State
            Source
            Investment
            RawProjectType
            ProjectStage
            StartDateConstruction
            EndDateConstruction
            FundingMode
            LocationID
            PeriodStartYear
            PeriodEndYear
            km
            MW
            M2
            RemoveProjectFromModel
            EditedProject
            ReadonlyProject
            ProcessingPath
        }
    }
`;
const $8797ca29702eee23$export$fe625b59cac3a1cc = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteUpsertScenarioProject (
        $inScenarioID: UUID!
        $inScenarioProjID: Int!
        $inRemoveProjectFromModel: Int!
        $inEditedProject: Int!
        $inProjID: Int
        $inSourceID: String
        $inProjectName: String!
        $inLocationID: String!
        $inState: String!
        $inSource: String!
        $inInvestment: String!
        $inRawProjectType: String!
        $inProjectStage: String
        $inStartDateConstruction: DateTime!
        $inEndDateConstruction: DateTime!
        $inFundingMode: String
        $inStartYear: Int
        $inEndYear: Int
        $inKM: String
        $inMW: String
        $inM2: String
        $inProcessingPath: Int
    ) {
        executeUpsertScenarioProject(
            inSourceID: $inSourceID
            inScenarioID: $inScenarioID
            inRemoveProjectFromModel: $inRemoveProjectFromModel
            inEditedProject: $inEditedProject
            inScenarioProjID: $inScenarioProjID
            inProjID: $inProjID
            inProjectName: $inProjectName
            inLocationID: $inLocationID
            inState: $inState
            inSource: $inSource
            inInvestment: $inInvestment
            inRawProjectType: $inRawProjectType
            inProjectStage: $inProjectStage
            inStartDateConstruction: $inStartDateConstruction
            inEndDateConstruction: $inEndDateConstruction
            inFundingMode: $inFundingMode
            inStartYear: $inStartYear
            inEndYear: $inEndYear
            inKM: $inKM
            inMW: $inMW
            inM2: $inM2
            inProcessingPath: $inProcessingPath
        ) {
            ScenarioProjID
        }
    }

`;
const $8797ca29702eee23$export$4466af79468173b7 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetLastUploadedProjectList(
        $inJurisdiction: String!,
        $inScenarioID: String
    ) {
        executeGetLastUploadedProjectList(
             inJurisdiction: $inJurisdiction
        ) {
            Source
            ProjectID
            ProjectName
            State
            typeCast
            Investment
            MW
            KM
            M2
            ProjectStage
            DeliveryAgency
            ContractingModel
            StartDateConstruction
            EndDateConstruction
            project_location
            Latitude
            Longitude
            FundingMode
            sa4_code
            sa4_name
            CommonwealthFunding
            ProjectStatus
            PeriodStartYear
            PeriodEndYear
        }
        executeGetState(inJurisdiction: $inJurisdiction) {
            State
        }
        executeGetSourceList(inJurisdiction: $inJurisdiction, inScenarioID: $inScenarioID) {
            Source
        }
        executeGetRawProjectTypes(inJurisdiction: $inJurisdiction) {
            RawProjectTypeID
            RawProjectType
            ProjectType
        }
        executeGetLocationList(inJurisdiction: $inJurisdiction) {
            LocationID
            LocationName
            State
        }
    }
`;
const $8797ca29702eee23$export$3865fbe071399085 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetPriorYearProjectList(
        $inJurisdiction: String!,
        $inScenarioID: String
    ) {
        executeGetPriorYearProjectList(
            inJurisdiction: $inJurisdiction
        ) {
            Source
            ProjectID
            ProjectName
            State
            typeCast
            Investment
            MW
            KM
            M2
            ProjectStage
            DeliveryAgency
            ContractingModel
            StartDateConstruction
            EndDateConstruction
            project_location
            Latitude
            Longitude
            FundingMode
            sa4_code
            sa4_name
            CommonwealthFunding
            ProjectStatus
            PeriodStartYear
            PeriodEndYear
        }
        executeGetState(inJurisdiction: $inJurisdiction) {
            State
        }
        executeGetSourceList(inJurisdiction: $inJurisdiction, inScenarioID: $inScenarioID) {
            Source
        }
        executeGetRawProjectTypes(inJurisdiction: $inJurisdiction) {
            RawProjectTypeID
            RawProjectType
            ProjectType
        }
        executeGetLocationList(inJurisdiction: $inJurisdiction) {
            LocationID
            LocationName
            State
        }
    }
`;
const $8797ca29702eee23$export$1b04b6a0193d537 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteRunScenario(
        $inScenarioID: UUID!
    ) {
        executeRunScenario(inScenarioID: $inScenarioID) {
            result
        }
    }
`;
const $8797ca29702eee23$export$b9bf64b597697c8a = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetALLList($inJurisdiction: String!, $inScenarioID: String) {
        executeGetState(inJurisdiction: $inJurisdiction) {
            State
        }
        executeGetSourceList(inJurisdiction: $inJurisdiction, inScenarioID: $inScenarioID) {
            Source
        }
        executeGetPLEMTypesList(inJurisdiction: $inJurisdiction) {
            PLEMGroup
            PLEMGroupID
        }
        executeGetSuperSectorsList(inJurisdiction: $inJurisdiction) {
            SuperSectorID
            SuperSector
        }
        executeGetMasterTypesList(inJurisdiction: $inJurisdiction) {
            MasterTypeID
            MasterType
        }
        executeGetInfraFlagsList(inJurisdiction: $inJurisdiction) {
            InfraFlag
        }
        executeGetRawProjectTypes(inJurisdiction: $inJurisdiction) {
            RawProjectTypeID
            RawProjectType
            ProjectType
        }
        executeGetProjectTypesList(inJurisdiction: $inJurisdiction) {
            ProjectTypeID
            ProjectType
        }
        executeGetResourceGroupsList(inJurisdiction: $inJurisdiction) {
            ResourceGroupID
            ResourceGroup
        }
        executeGetLocationList(inJurisdiction: $inJurisdiction) {
            LocationID
            LocationName
            State
        }
        executeGetL1GroupList(inJurisdiction: $inJurisdiction) {
            Lvl1GroupID
            Lvl1Group
        }
        executeGetL2GroupList(inJurisdiction: $inJurisdiction) {
            Lvl1GroupID
            Lvl2GroupID
            Lvl2Group
        }
        executeGetPriorYearProjectList(
          inJurisdiction: $inJurisdiction
        ) {
            Source
            ProjectID
            ProjectName
            State
            typeCast
            Investment
            MW
            KM
            M2
            ProjectStage
            DeliveryAgency
            ContractingModel
            StartDateConstruction
            EndDateConstruction
            project_location
            Latitude
            Longitude
            FundingMode
            sa4_code
            sa4_name
            CommonwealthFunding
            ProjectStatus
            PeriodStartYear
            PeriodEndYear
        }
    }
`;
const $8797ca29702eee23$export$fe54a84b24b90c03 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteCreateProjectUploadBatch(
        $inUserSID: UUID!
    ) {
        executeCreateProjectUploadBatch(
            inUserSID: $inUserSID
        ) {
            BatchID
            LastUploadedBy
            LastUploadedDate
            ProjectsUploaded
        }
    }
`;
const $8797ca29702eee23$export$2d00f14ac930abf6 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetProjectBatchUpload(
        $inUserSID: UUID!
    ) {
        executeGetProjectBatchUpload(
            inUserSID: $inUserSID
        ) {
            BatchID
            LastUploadedBy
            LastUploadedDate
            ProjectsUploaded
        }
    }
`;
const $8797ca29702eee23$export$dae312c2d972beb5 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteAppendProjectBatchUpload(
       $inProjectBatchID: UUID!
       $inProjectJSON: String!
    ) {
        executeAppendProjectBatchUpload(
          inProjectBatchID: $inProjectBatchID
          inProjectJSON: $inProjectJSON
        ) {
            result
        }
    }
`;
const $8797ca29702eee23$export$afb32896ebbc451d = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteCloseProjectUploadBatch(
        $inProjectBatchID: UUID!
    ) {
        executeCloseProjectUploadBatch(
            inProjectBatchID: $inProjectBatchID
        ) {
            result
        }
    }
`;



var $bHJbJ = parcelRequire("bHJbJ");
parcelRequire("i5lfL");


var $140cb3ce1e3b378a$exports = {};
!function(t, i) {
    $140cb3ce1e3b378a$exports = i();
}($140cb3ce1e3b378a$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});





function $658384a585644311$export$d4d7078c61c5de16(AllLists) {
    return AllLists?.executeGetRawProjectTypes.map((type)=>({
            value: type.RawProjectType,
            text: type.RawProjectType
        })) ?? [];
}
function $658384a585644311$export$b396c7cd9d5abae7(AllLists) {
    return AllLists?.executeGetRawProjectTypes.filter((type)=>[
            ...(0, $243a1246ea7835d9$export$ad98f2e8c6fd720d),
            ...(0, $243a1246ea7835d9$export$5be856edc6a7f539),
            ...(0, $243a1246ea7835d9$export$9bcd006cd4d2d851)
        ].indexOf(type.RawProjectType) === -1).map((type)=>{
        return {
            value: type.RawProjectType,
            text: type.RawProjectType
        };
    }) ?? [];
}
const $658384a585644311$export$45902cc189596eef = /^\d*$/;
const $658384a585644311$export$dc0451bacb093840 = /^-?\d*(\.\d?)?$/;


(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($140cb3ce1e3b378a$exports))));

function $6bf25bc007efe8a9$export$85de6c5fd2d85dc0(AllLists, getCommonEditTextFieldProps) {
    const customParseFormat = (parcelRequire("kx1Sf"));
    (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend(customParseFormat);
    const minConstructionDate = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))('2015', 'YYYY');
    const maxConstructionDate = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))('2040', 'YYYY');
    return [
        {
            accessorKey: "Errors",
            header: "Errors",
            size: 200,
            filterFn: "contains",
            Cell: ({ cell: cell })=>{
                const cellValue = cell.getValue();
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%",
                        backgroundColor: cellValue ? "orange" : ""
                    },
                    children: // @ts-ignore
                    cellValue
                });
            }
        },
        {
            accessorKey: "SourceID",
            header: "Original project ID",
            size: 200,
            filterFn: "contains"
        },
        {
            accessorKey: "ProjectName",
            header: "Project name",
            size: 200,
            filterFn: "contains",
            muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                    ...getCommonEditTextFieldProps(cell)
                })
        },
        {
            accessorKey: "State",
            header: "State",
            size: 100,
            filterVariant: "multi-select",
            editVariant: "select",
            // @ts-ignore
            editSelectOptions: AllLists?.executeGetState.map((state)=>({
                    value: state.State,
                    text: state.State
                })) ?? []
        },
        {
            accessorKey: "Source",
            header: "Source",
            size: 150,
            filterVariant: "multi-select",
            editVariant: "select",
            enableEditing: false,
            // @ts-ignore
            editSelectOptions: AllLists?.executeGetSourceList.map((type)=>({
                    value: type.Source,
                    text: type.Source
                })) ?? []
        },
        {
            id: "Investment",
            accessorFn: (row)=>Number(row.Investment),
            filterFn: "betweenInclusive",
            filterVariant: "range",
            header: "Investment ($million)",
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue().toLocaleString()
                });
            },
            size: 200,
            muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                    ...getCommonEditTextFieldProps(cell)
                })
        },
        {
            accessorKey: "RawProjectType",
            header: "Project type",
            size: 200,
            filterVariant: "multi-select",
            editVariant: "select",
            // @ts-ignore
            editSelectOptions: (0, $658384a585644311$export$d4d7078c61c5de16)(AllLists),
            muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                    ...getCommonEditTextFieldProps(cell)
                })
        },
        {
            accessorKey: "ProjectStage",
            header: "Project latest status",
            size: 250,
            filterVariant: "multi-select",
            editVariant: "select",
            editSelectOptions: (0, $243a1246ea7835d9$export$2425b41e18ec8805)
        },
        {
            id: "StartDateConstruction",
            accessorFn: (row)=>row.StartDateConstruction ? (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).utc(row.StartDateConstruction, "DD/MM/YYYY") : "",
            header: "Construction start date",
            size: 300,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            sortingFn: "datetime",
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue() ? cell.getValue().format('DD/MM/YYYY') : ""
                });
            },
            Filter: ({ column: column, rangeFilterIndex: rangeFilterIndex })=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a27ecd42a8eaf0a0$export$5109c6dd95d8fb00), {
                    onChange: (newValue)=>{
                        column.setFilterValue((oldValues)=>{
                            // Update the correct index of the filter value
                            const newValues = oldValues ?? [
                                "",
                                ""
                            ];
                            newValues[rangeFilterIndex.toString()] = newValue;
                            return newValues;
                        });
                    },
                    slotProps: {
                        textField: {
                            sx: {
                                minWidth: "120px"
                            },
                            variant: "standard"
                        }
                    },
                    format: "DD/MM/YYYY",
                    minDate: minConstructionDate,
                    maxDate: maxConstructionDate,
                    value: column.getFilterValue()?.[rangeFilterIndex] || null
                }),
            Edit: ({ cell: cell, row: row })=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a27ecd42a8eaf0a0$export$5109c6dd95d8fb00), {
                    slotProps: {
                        textField: {
                            sx: {
                                minWidth: "120px"
                            },
                            variant: "standard"
                        }
                    },
                    onChange: (startDateValue)=>{
                        // @ts-ignore
                        row._valuesCache.StartDateConstruction = startDateValue;
                    },
                    format: "DD/MM/YYYY",
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cell.getValue()),
                    minDate: minConstructionDate,
                    maxDate: maxConstructionDate
                })
        },
        {
            id: "EndDateConstruction",
            accessorFn: (row)=>row.EndDateConstruction ? (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).utc(row.EndDateConstruction, "DD/MM/YYYY") : "",
            header: "Construction end date",
            size: 300,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            sortingFn: "datetime",
            // @ts-ignore
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue() ? cell.getValue().format('DD/MM/YYYY') : ""
                });
            },
            //Custom Date Picker Filter from @mui/x-date-pickers
            Filter: ({ column: column, rangeFilterIndex: rangeFilterIndex })=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a27ecd42a8eaf0a0$export$5109c6dd95d8fb00), {
                    onChange: (newValue)=>{
                        column.setFilterValue((oldValues)=>{
                            // Update the correct index of the filter value
                            const newValues = oldValues ?? [
                                "",
                                ""
                            ];
                            newValues[rangeFilterIndex] = newValue;
                            return newValues;
                        });
                    },
                    slotProps: {
                        textField: {
                            sx: {
                                minWidth: "120px"
                            },
                            variant: "standard"
                        }
                    },
                    format: "DD/MM/YYYY",
                    minDate: minConstructionDate,
                    maxDate: maxConstructionDate,
                    value: column.getFilterValue()?.[rangeFilterIndex] || null
                }),
            Edit: ({ cell: cell, row: row })=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a27ecd42a8eaf0a0$export$5109c6dd95d8fb00), {
                    slotProps: {
                        textField: {
                            sx: {
                                minWidth: "120px"
                            },
                            variant: "standard"
                        }
                    },
                    onChange: (endDateValue)=>{
                        // @ts-ignore
                        row._valuesCache.EndDateConstruction = endDateValue;
                    },
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cell.getValue()),
                    format: "DD/MM/YYYY",
                    minDate: minConstructionDate,
                    maxDate: maxConstructionDate
                })
        },
        {
            accessorKey: "FundingMode",
            header: "Funding mode",
            size: 150,
            filterVariant: "multi-select",
            editVariant: "select",
            editSelectOptions: (0, $243a1246ea7835d9$export$14085c2a147de944),
            enableEditing: (row)=>(0, $243a1246ea7835d9$export$5b013b72cff28011).includes(row.getValue("ProcessingPath")) ? false : true
        },
        {
            id: "LocationID",
            accessorFn: (row)=>row.LocationID ?? "",
            header: "Location",
            size: 300,
            filterVariant: "multi-select",
            editVariant: "select",
            Cell: ({ cell: cell })=>{
                return(// @ts-ignore
                // if location not found, set to state unknown
                AllLists?.executeGetLocationList.find((item)=>item.LocationID == cell.getValue())?.LocationName ?? `${cell.row.getValue("State")} - Unknown`);
            },
            filterSelectOptions: AllLists?.executeGetLocationList.map((location)=>({
                    value: location.LocationID,
                    text: location.LocationName
                })) ?? [],
            // @ts-ignore
            editSelectOptions: AllLists?.executeGetLocationList.map((location)=>({
                    value: location.LocationID,
                    text: location.LocationName
                })) ?? []
        },
        {
            id: "MW",
            accessorFn: (row)=>Number(row.MW),
            filterFn: "betweenInclusive",
            filterVariant: "range",
            header: "MW",
            enableEditing: (row)=>(0, $243a1246ea7835d9$export$ad98f2e8c6fd720d).includes(row.getValue("RawProjectType")) ? true : false,
            size: 250,
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue().toLocaleString()
                });
            },
            muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                    ...getCommonEditTextFieldProps(cell)
                })
        },
        {
            id: "km",
            accessorFn: (row)=>Number(row.km),
            header: "KM",
            filterVariant: "range",
            filterFn: "betweenInclusive",
            size: 250,
            enableEditing: (row)=>[
                    (0, $243a1246ea7835d9$export$5be856edc6a7f539)[1],
                    (0, $243a1246ea7835d9$export$5be856edc6a7f539)[2]
                ].includes(row.getValue("RawProjectType")) ? true : false,
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue().toLocaleString()
                });
            },
            muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                    ...getCommonEditTextFieldProps(cell)
                })
        },
        {
            id: "M2",
            accessorFn: (row)=>Number(row.M2),
            filterFn: "betweenInclusive",
            filterVariant: "range",
            header: "M2",
            enableEditing: (row)=>(0, $243a1246ea7835d9$export$9bcd006cd4d2d851).includes(row.getValue("RawProjectType")) ? true : false,
            size: 250,
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue().toLocaleString()
                });
            },
            muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                    ...getCommonEditTextFieldProps(cell)
                })
        },
        {
            id: "PeriodStartYear",
            accessorFn: (row)=>row.PeriodStartYear ? (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).utc(row.PeriodStartYear, "DD/MM/YYYY") : "",
            header: "Period Start Year",
            size: 300,
            enableEditing: false,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            sortingFn: "datetime",
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue() ? cell.getValue().format('DD/MM/YYYY') : ""
                });
            },
            Filter: ({ column: column, rangeFilterIndex: rangeFilterIndex })=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a27ecd42a8eaf0a0$export$5109c6dd95d8fb00), {
                    timezone: "UTC",
                    onChange: (newValue)=>{
                        column.setFilterValue((oldValues)=>{
                            // Update the correct index of the filter value
                            const newValues = oldValues ?? [
                                "",
                                ""
                            ];
                            newValues[rangeFilterIndex.toString()] = newValue;
                            return newValues;
                        });
                    },
                    slotProps: {
                        textField: {
                            sx: {
                                minWidth: "120px"
                            },
                            variant: "standard"
                        }
                    },
                    format: "DD/MM/YYYY",
                    minDate: minConstructionDate,
                    maxDate: maxConstructionDate,
                    value: column.getFilterValue()?.[rangeFilterIndex] || null
                }),
            Edit: ({ cell: cell, row: row })=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a27ecd42a8eaf0a0$export$5109c6dd95d8fb00), {
                    timezone: "UTC",
                    slotProps: {
                        textField: {
                            sx: {
                                minWidth: "120px"
                            },
                            variant: "standard"
                        }
                    },
                    onChange: (startDateValue)=>{
                        // @ts-ignore
                        row._valuesCache.PeriodStartYear = startDateValue;
                    },
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cell.getValue()),
                    format: "DD/MM/YYYY",
                    minDate: minConstructionDate,
                    maxDate: maxConstructionDate
                })
        },
        {
            id: "PeriodEndYear",
            accessorFn: (row)=>row.PeriodEndYear ? (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).utc(row.PeriodEndYear, "DD/MM/YYYY") : "",
            header: "Period End Year",
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue() ? cell.getValue().format('DD/MM/YYYY') : ""
                });
            },
            size: 300,
            enableEditing: false,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            sortingFn: "datetime",
            Filter: ({ column: column, rangeFilterIndex: rangeFilterIndex })=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a27ecd42a8eaf0a0$export$5109c6dd95d8fb00), {
                    timezone: "UTC",
                    onChange: (newValue)=>{
                        column.setFilterValue((oldValues)=>{
                            // Update the correct index of the filter value
                            const newValues = oldValues ?? [
                                "",
                                ""
                            ];
                            newValues[rangeFilterIndex.toString()] = newValue;
                            return newValues;
                        });
                    },
                    slotProps: {
                        textField: {
                            sx: {
                                minWidth: "120px"
                            },
                            variant: "standard"
                        }
                    },
                    format: "DD/MM/YYYY",
                    minDate: minConstructionDate,
                    maxDate: maxConstructionDate,
                    value: column.getFilterValue()?.[rangeFilterIndex] || null
                }),
            Edit: ({ cell: cell, row: row })=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a27ecd42a8eaf0a0$export$5109c6dd95d8fb00), {
                    timezone: "UTC",
                    slotProps: {
                        textField: {
                            sx: {
                                minWidth: "120px"
                            },
                            variant: "standard"
                        }
                    },
                    onChange: (startDateValue)=>{
                        // @ts-ignore
                        row._valuesCache.PeriodEndYear = startDateValue;
                    },
                    format: "DD/MM/YYYY",
                    minDate: minConstructionDate,
                    maxDate: maxConstructionDate,
                    value: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cell.getValue())
                })
        },
        {
            id: "ProcessingPath",
            accessorFn: (row)=>Number(row.ProcessingPath),
            header: "Processing Path",
            filterVariant: "range",
            filterFn: "betweenInclusive",
            size: 250,
            enableEditing: false,
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue().toLocaleString()
                });
            }
        }
    ];
}






function $4364962cd37ab450$export$ca5e8b966f3b4152(inputValue, max) {
    if (inputValue > max) inputValue = 100;
    else if (inputValue < 0) inputValue = 0;
    return inputValue;
}
function $4364962cd37ab450$export$a22fff68bec8f2b8(startDate, processingPath, optimistic = false) {
    if ((0, $243a1246ea7835d9$export$5b013b72cff28011).indexOf(processingPath) !== -1) {
        const startDateConstruction = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(startDate);
        const FYStartDate = optimistic ? startDateConstruction.year() + '-07-01' : startDateConstruction.year() + '-07-02';
        return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(FYStartDate);
    }
    return startDate;
}
function $4364962cd37ab450$export$4a2be59dbba42469(endState, processingPath, optimistic = false) {
    if ((0, $243a1246ea7835d9$export$5b013b72cff28011).indexOf(processingPath) !== -1) {
        const endDateConstruction = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(endState);
        const FYEndDate = optimistic ? endDateConstruction.year() + '-06-30' : endDateConstruction.year() + '-07-01';
        return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(FYEndDate);
    }
    return endState;
}


(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($140cb3ce1e3b378a$exports))));

function $20853d91ad35cc65$export$233596b476311f4b(scenarioID, mode, values, projectData) {
    const customParseFormat = (parcelRequire("kx1Sf"));
    (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend(customParseFormat);
    if (mode == 'editing') return {
        // editing scenario project
        inSourceID: values.SourceID,
        inScenarioID: scenarioID,
        inEditedProject: 1,
        inScenarioProjID: projectData.ScenarioProjID ?? 0,
        inRemoveProjectFromModel: projectData.RemoveProjectFromModel ?? 0,
        inProjID: projectData.ProjID,
        inProjectName: values.ProjectName,
        inLocationID: values.LocationID ?? "",
        inState: values.State,
        inSource: values.Source,
        inInvestment: Number(values.Investment).toString(10),
        inRawProjectType: values.RawProjectType,
        inProjectStage: values.ProjectStage,
        inStartDateConstruction: (0, $4364962cd37ab450$export$a22fff68bec8f2b8)(values.StartDateConstruction, values.ProcessingPath),
        inEndDateConstruction: (0, $4364962cd37ab450$export$4a2be59dbba42469)(values.EndDateConstruction, values.ProcessingPath),
        inFundingMode: values.FundingMode,
        inStartYear: Number(projectData.PeriodStartYear),
        inEndYear: Number(projectData.PeriodEndYear),
        inKM: (values.km ? values.km : projectData.km ?? 0).toString(),
        inMW: (values.MW ? values.MW : projectData.MW ?? 0).toString(),
        inM2: (values.M2 ? values.M2 : projectData.M2 ?? 0).toString(),
        inProcessingPath: values.ProcessingPath
    };
    else if (mode == 'deleting') return {
        // deleting scenario project
        inSourceID: values.SourceID,
        inScenarioID: scenarioID,
        inEditedProject: 1,
        inScenarioProjID: values.ScenarioProjID ?? 0,
        inRemoveProjectFromModel: 1,
        inProjID: values.ProjID,
        inProjectName: values.ProjectName,
        inState: values.State,
        inSource: values.Source,
        inLocationID: values.LocationID ?? "",
        inInvestment: Number(values.Investment).toString(10),
        inRawProjectType: values.RawProjectType,
        inProjectStage: values.ProjectStage,
        inStartDateConstruction: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).utc(values.StartDateConstruction, "DD/MM/YYYY"),
        inEndDateConstruction: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).utc(values.EndDateConstruction, "DD/MM/YYYY"),
        inFundingMode: values.FundingMode,
        inStartYear: Number((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.PeriodStartYear, "DD/MM/YYYY").year()),
        inEndYear: Number((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.PeriodEndYear, "DD/MM/YYYY").year()),
        inKM: (values.km ?? 0).toString(),
        inMW: (values.MW ?? 0).toString(),
        inM2: (values.M2 ?? 0).toString(),
        inProcessingPath: values.ProcessingPath
    };
    else if (mode == 'restoring') return {
        // deleting scenario project
        inSourceID: values.SourceID,
        inScenarioID: scenarioID,
        inEditedProject: 1,
        inScenarioProjID: values.ScenarioProjID ?? 0,
        inRemoveProjectFromModel: 0,
        inProjID: values.ProjID,
        inProjectName: values.ProjectName,
        inState: values.State,
        inSource: values.Source,
        inLocationID: values.LocationID ?? "",
        inInvestment: Number(values.Investment).toString(10),
        inRawProjectType: values.RawProjectType,
        inProjectStage: values.ProjectStage,
        inStartDateConstruction: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).utc(values.StartDateConstruction, "DD/MM/YYYY"),
        inEndDateConstruction: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).utc(values.EndDateConstruction, "DD/MM/YYYY"),
        inFundingMode: values.FundingMode,
        inStartYear: Number((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.PeriodStartYear, "DD/MM/YYYY").year()),
        inEndYear: Number((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.PeriodEndYear, "DD/MM/YYYY").year()),
        inKM: (values.km ?? 0).toString(),
        inMW: (values.MW ?? 0).toString(),
        inM2: (values.M2 ?? 0).toString(),
        inProcessingPath: values.ProcessingPath
    };
    else return {
        // creating scenario project
        inSourceID: values.SourceID,
        inScenarioID: scenarioID,
        inEditedProject: 1,
        inScenarioProjID: 0,
        inRemoveProjectFromModel: 0,
        inProjID: 0,
        inProjectName: values.ProjectName,
        inState: values.State,
        inSource: values.Source,
        inLocationID: values.LocationID ?? "",
        inInvestment: Number(values.Investment).toString(10),
        inRawProjectType: values.RawProjectType,
        inProjectStage: values.ProjectStage,
        inStartDateConstruction: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).utc(values.StartDateConstruction),
        inEndDateConstruction: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).utc(values.EndDateConstruction),
        inFundingMode: values.FundingMode,
        inStartYear: null,
        inEndYear: null,
        inKM: (values.km ?? 0).toString(),
        inMW: (values.MW ?? 0).toString(),
        inM2: (values.M2 ?? 0).toString(),
        inProcessingPath: values.ProcessingPath
    };
}







// noinspection GraphQLUnresolvedReference

const $fccb6b07536ae7aa$export$b2f29a8379db78c2 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetScenarioCustomAssumption(
        $inScenarioID: UUID!,
        $inProjectTypeID: Int!,
    ) {
        executeGetScenarioCustomAssumption(
            inScenarioID: $inScenarioID,
            inProjectTypeID: $inProjectTypeID
        ) {
            ScenarioID
            ProjectTypeID
            InvestmentPlanning
            InvestmentConstruction
            InvestmentCommissioning
            TimePlanning
            TimeConstruction
            TimeCommissioning
        }
    }
`;
const $fccb6b07536ae7aa$export$63760899b05c78d9 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteCreateScenarioCustomAssumption(
        $inScenarioID: UUID!,
        $inProjectTypeID: Int!,
        $inInvestmentPlanning: String!,
        $inInvestmentConstruction: String!,
        $inInvestmentCommissioning: String!,
        $inTimePlanning: String!,
        $inTimeConstruction: String!,
        $inTimeCommissioning: String!
    ) {
        executeCreateScenarioCustomAssumption(
            inScenarioID: $inScenarioID
            inProjectTypeID: $inProjectTypeID
            inInvestmentPlanning: $inInvestmentPlanning
            inInvestmentConstruction: $inInvestmentConstruction
            inInvestmentCommissioning: $inInvestmentCommissioning
            inTimePlanning: $inTimePlanning
            inTimeConstruction: $inTimeConstruction
            inTimeCommissioning: $inTimeCommissioning
        ) {
            result
        }
    }
`;
const $fccb6b07536ae7aa$export$ce9a057adbccc69a = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteDeleteScenarioCustomAssumption(
        $inScenarioID: UUID!,
        $inProjectTypeID: Int!,
    ) {
        executeDeleteScenarioCustomAssumption(
            inScenarioID: $inScenarioID,
            inProjectTypeID: $inProjectTypeID
        ) {
            result
        }
    }
`;
const $fccb6b07536ae7aa$export$1b04b6a0193d537 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteRunScenario(
        $inScenarioID: UUID!
    ) {
        executeRunScenario(inScenarioID: $inScenarioID) {
            result
        }
    }
`;




// noinspection GraphQLUnresolvedReference

const $97b2fb033105cd13$export$868189023811d906 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetScenarioAssumption(
        $inScenarioID: UUID!,
        $inDefaultValue: Int
    ) {
        executeGetScenarioAssumption(
            inScenarioID: $inScenarioID,
            inDefaultValue: $inDefaultValue
        ) {
            ScenarioID
            PlanningCostPercentage
            ConstructionCostPercentage
            CommissioningCostPercentage
            Planning
            Construction
            Commissioning
        }
    }
`;
const $97b2fb033105cd13$export$3b49b40f590d47c6 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteCreateScenarioAssumption(
        $inScenarioID: UUID!,
        $inPlanningCostPercentage: Decimal!,
        $inConstructionCostPercentage: Decimal!,
        $inCommissioningCostPercentage: Decimal!,
        $inPlanning: Decimal!,
        $inConstruction: Decimal!,
        $inCommissioning: Decimal!
    ) {
        executeCreateScenarioAssumption(
            inScenarioID: $inScenarioID
            inPlanningCostPercentage: $inPlanningCostPercentage
            inConstructionCostPercentage: $inConstructionCostPercentage
            inCommissioningCostPercentage: $inCommissioningCostPercentage
            inPlanning: $inPlanning
            inConstruction: $inConstruction
            inCommissioning: $inCommissioning
        ) {
            result
        }
    }
`;
const $97b2fb033105cd13$export$1b04b6a0193d537 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteRunScenario(
        $inScenarioID: UUID!
    ) {
        executeRunScenario(inScenarioID: $inScenarioID) {
            result
        }
    }
`;


const $6db69764eaf5cc18$var$useBaseLineAssumption = ({ scenarioID: scenarioID, instance: instance, accounts: accounts })=>{
    const { data: baseLineAssumption, isSuccess: isBaseLineAssumptionSuccess } = (0, $45631327982d6a29$export$dd0a697e1782aedd)([
        "getBaselineAssumption"
    ], {
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $97b2fb033105cd13$export$868189023811d906),
                variables: {
                    inScenarioID: scenarioID,
                    inDefaultValue: 0
                },
                instance: instance,
                accounts: accounts
            });
        }
    });
    return {
        baseLineAssumption: baseLineAssumption,
        isBaseLineAssumptionSuccess: isBaseLineAssumptionSuccess
    };
};
var $6db69764eaf5cc18$export$2e2bcd8739ae039 = $6db69764eaf5cc18$var$useBaseLineAssumption;






var $kx1Sf = parcelRequire("kx1Sf");
(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend($kx1Sf);
function $4a0b61caf523d116$export$2e2bcd8739ae039(props) {
    const { setTabIndex: setTabIndex, scenarioID: scenarioID, runModel: runModel } = props;
    const client = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)();
    const { data: userInfo } = (0, $8aac0537827a6bae$export$801fe16824f675f7)();
    const tableInstanceRef = (0, $i5lfL.useRef)(null);
    const rerender = (0, $i5lfL.useReducer)(()=>({}), {})[1];
    const [showColumnFilters, setShowColumnFilters] = (0, $i5lfL.useState)(false);
    const [columnFilters, setColumnFilters] = (0, $i5lfL.useState)([]);
    const [showEdited, setShowEdited] = (0, $i5lfL.useState)(0);
    const [createModalOpen, setCreateModalOpen] = (0, $i5lfL.useState)(false);
    const [columnVisibility, setColumnVisibility] = (0, $i5lfL.useState)({
        ProjectID: false,
        PeriodStartYear: false,
        PeriodEndYear: false,
        km: false,
        MW: false,
        M2: false,
        ProcessingPath: false,
        Errors: false
    });
    const [validationErrors, setValidationErrors] = (0, $i5lfL.useState)({});
    const [dateError, setDateError] = (0, $i5lfL.useState)("");
    const [downloading, setDownloading] = (0, $i5lfL.useState)(false);
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const [scenarioTitle, setScenarioTitle] = (0, $i5lfL.useState)("");
    const { baseLineAssumption: baseLineAssumption } = (0, $6db69764eaf5cc18$export$2e2bcd8739ae039)({
        scenarioID: scenarioID,
        instance: instance,
        accounts: accounts
    });
    const fileInputRef = (0, $i5lfL.useRef)(null);
    const [previewFlag, setPreviewFlag] = (0, $i5lfL.useState)(false);
    const [previewData, setPreviewData] = (0, $i5lfL.useState)([]);
    const [uploadError, setUploadError] = (0, $i5lfL.useState)(false);
    const clearPreview = ()=>{
        setPreviewFlag(false);
        setUploadError(false);
        setColumnVisibility({
            ...columnVisibility,
            Errors: false
        });
        setPreviewData([]);
    };
    const handleConfirmSubmit = ()=>{
        if (!uploadError && previewData.length > 0) uploadScenarioProjects.mutate({
            inScenarioID: scenarioID,
            inProjectJSON: JSON.stringify(previewData)
        });
        clearPreview();
    };
    const handleFileChange = (event)=>{
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = async (event)=>{
                if (event.target && event.target.result) {
                    const workbook = new $1cb7ac08e18fc2ca$exports.Workbook();
                    await workbook.xlsx.load(event.target.result);
                    const worksheet = workbook.worksheets[0];
                    const jsonData = [];
                    let headers = [];
                    //validation should happen here
                    worksheet.eachRow((row, rowNumber)=>{
                        const rowValues = row.values;
                        const rowErrors = [];
                        // Row 4 is the header row
                        if (rowNumber === (0, $243a1246ea7835d9$export$83b379386136b34b).length + 1) headers = rowValues.slice(1); // Remove first empty cell
                        else if (rowNumber > (0, $243a1246ea7835d9$export$83b379386136b34b).length + 1) {
                            const rowObject = {};
                            headers.forEach((header, index)=>{
                                let cellValue = rowValues[index + 1];
                                const columnName = Object.keys((0, $243a1246ea7835d9$export$68acbc4d2f93adde)).find((key)=>(0, $243a1246ea7835d9$export$68acbc4d2f93adde)[key] === header);
                                if (columnName) {
                                    // change null or undefined to empty string
                                    if (!cellValue || cellValue === "null" || cellValue === "undefined" || cellValue == null) cellValue = "";
                                    //ProjectName must not be null
                                    if (columnName === "ProjectName" && cellValue === "") rowErrors.push("ProjectName must not be null");
                                    //State must be in the state list
                                    if (columnName === "State" && !(0, $61689dee2f6ff4fb$export$35029cc0a320e78a)(AllLists).includes(cellValue)) rowErrors.push("State must be in the state list");
                                    //Investment must be a number
                                    if (columnName === "Investment" && isNaN(cellValue)) rowErrors.push("Investment must be a number");
                                    //ProjectType must be in the project type list
                                    if (columnName === "RawProjectType" && !(0, $61689dee2f6ff4fb$export$afc921ba20c7eb49)(AllLists).includes(cellValue)) rowErrors.push("Project Type must be in the project type list");
                                    //Construction Start Date need to be in the correct format
                                    if (columnName === "StartDateConstruction" && cellValue !== "") {
                                        // if typeof cellValue is string, then use cellvalue.tostring
                                        if (typeof cellValue === "object") cellValue = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cellValue).format("DD/MM/YYYY") === "Invalid Date" ? cellValue : (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cellValue).format("DD/MM/YYYY");
                                        else cellValue = cellValue.toString();
                                    }
                                    //Construction End Date need to be in the correct format
                                    if (columnName === "EndDateConstruction" && cellValue !== "") {
                                        if (typeof cellValue === "object") cellValue = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cellValue).format("DD/MM/YYYY") === "Invalid Date" ? cellValue : (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cellValue).format("DD/MM/YYYY");
                                        else cellValue = cellValue.toString();
                                    }
                                    if (columnName === "PeriodStartYear" && cellValue !== "") {
                                        if (typeof cellValue === "object") cellValue = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cellValue).format("DD/MM/YYYY") === "Invalid Date" ? cellValue : (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cellValue).format("DD/MM/YYYY");
                                        else cellValue = cellValue.toString();
                                    }
                                    if (columnName === "PeriodEndYear" && cellValue !== "") {
                                        if (typeof cellValue === "object") cellValue = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cellValue).format("DD/MM/YYYY") === "Invalid Date" ? cellValue : (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cellValue).format("DD/MM/YYYY");
                                        else cellValue = cellValue.toString();
                                    }
                                    //Fund Mode must be in the funding list
                                    if (columnName === "FundingMode" && !(0, $61689dee2f6ff4fb$export$af91cc7b93ecc074)((0, $243a1246ea7835d9$export$14085c2a147de944)).includes(cellValue)) rowErrors.push("Funding Mode must be in the funding list");
                                    //The flags are handled in the backend
                                    if (columnName === "OperateStatus") {
                                        rowObject["RemoveProjectFromModel"] = 0;
                                        rowObject["EditedProject"] = 0;
                                    }
                                    rowObject[columnName] = cellValue;
                                }
                            });
                            // Construction start date cannot be null for anything other than forecast projects
                            // if (rowObject["StartDateConstruction"] === "" && rowObject["Forecast"] !== "yes") {
                            // 	rowErrors.push("Construction Start Date cannot be null for anything other than forecast projects");
                            // }
                            // Construction start date cannot be after the end date
                            if ((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(rowObject["StartDateConstruction"], "DD/MM/YYYY").isAfter((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(rowObject["EndDateConstruction"], "DD/MM/YYYY"))) rowErrors.push("Construction Start Date cannot be after the end date");
                            // Construction end date cannot be null for anything other than forecast projects
                            // if (rowObject["EndDateConstruction"] === "" && rowObject["Forecast"] !== "yes") {
                            // 	rowErrors.push("Construction End Date cannot be null for anything other than forecast projects");
                            // }
                            // Construction end date cannot be before the start date
                            if ((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(rowObject["EndDateConstruction"], "DD/MM/YYYY").isBefore((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(rowObject["StartDateConstruction"], "DD/MM/YYYY"))) rowErrors.push("Construction End Date cannot be before the start date");
                            //Period Start Year is required for forecast projects
                            if (rowObject["PeriodStartYear"] === "" && rowObject["Forecast"] === "yes") rowErrors.push("Period Start Year is required for forecast projects");
                            //Period End Year is required for forecast projects
                            if (rowObject["PeriodEndYear"] === "" && rowObject["Forecast"] === "yes") rowErrors.push("Period End Year is required for forecast projects");
                            //KM must be a number
                            //can be null for non-transmission projects
                            if (rowObject["km"] !== "" && isNaN(rowObject["km"])) rowErrors.push("KM must be a number");
                            //KM can not be null for transmission projects apart from UTS_Transmission
                            if (rowObject["km"] === "" && [
                                (0, $243a1246ea7835d9$export$5be856edc6a7f539)[1],
                                (0, $243a1246ea7835d9$export$5be856edc6a7f539)[2]
                            ].includes(rowObject["RawProjectType"]) && rowObject["Source"] !== "UTS_Transmission") rowErrors.push("KM can not be null for transmission projects");
                            //MW must be a number
                            //can be null for non-energy projects
                            if (rowObject["MW"] !== "" && isNaN(rowObject["MW"])) rowErrors.push("MW must be a number");
                            //MW can not be null for energy projects
                            if (rowObject["MW"] === "" && (0, $243a1246ea7835d9$export$ad98f2e8c6fd720d).includes(rowObject["RawProjectType"])) rowErrors.push("MW can not be null for energy projects");
                            //M2 must be a number
                            //can be null for non-detached house projects
                            if (rowObject["M2"] !== "" && isNaN(rowObject["M2"])) rowErrors.push("M2 must be a number");
                            //M2 can not be null for detached house projects
                            if (rowObject["M2"] === "" && (0, $243a1246ea7835d9$export$9bcd006cd4d2d851).includes(rowObject["RawProjectType"])) rowErrors.push("M2 can not be null for detached house projects");
                            // calculate processing path
                            const processingPath = (0, $61689dee2f6ff4fb$export$c8f03a4db3d99335)(rowObject["Forecast"], rowObject["Ongoing"], rowObject);
                            rowObject["ProcessingPath"] = processingPath;
                            // add error column
                            rowObject["Errors"] = rowErrors.join(", ");
                            // change LocationID to real LocationID
                            // @ts-ignore
                            const location = AllLists?.executeGetLocationList.find((item)=>item.LocationName == rowObject["LocationID"]);
                            if (location) rowObject["LocationID"] = location.LocationID;
                            // construction start date should not be null for only processing path is 1, 2,7
                            if (rowObject["StartDateConstruction"] === "" && [
                                1,
                                2,
                                7
                            ].includes(processingPath)) rowErrors.push("Construction Start Date cannot be null");
                            // construction end date should not be null for only processing path is 1, 2,7
                            if (rowObject["EndDateConstruction"] === "" && [
                                1,
                                2,
                                7
                            ].includes(processingPath)) rowErrors.push("Construction End Date cannot be null");
                            jsonData.push(rowObject);
                        }
                    });
                    // sort data based on errors
                    jsonData.sort((a, b)=>{
                        if (a["Errors"] === "" && b["Errors"] !== "") return 1;
                        if (a["Errors"] !== "" && b["Errors"] === "") return -1;
                        return 0;
                    });
                    //set up preview flag, data
                    setPreviewFlag(true);
                    setPreviewData(jsonData);
                    setColumnVisibility({
                        ...columnVisibility,
                        Errors: true
                    });
                    //set up upload error
                    setUploadError(jsonData.filter((item)=>item["Errors"] !== "").length > 0);
                }
            };
            reader.readAsArrayBuffer(file);
        } else console.log('No file selected');
        if (fileInputRef.current) fileInputRef.current.value = "";
    };
    (0, $i5lfL.useEffect)(()=>{
        // @ts-ignore
        client.getQueryData([
            "scenarioList"
        ])?.executeGetScenarioList.map((item)=>{
            if (item.ScenarioID == scenarioID) setScenarioTitle(item.ScenarioTitle);
        });
    }, [
        client.getQueryData([
            "scenarioList"
        ])
    ]);
    // Download excel file
    (0, $i5lfL.useEffect)(()=>{
        const states = (0, $61689dee2f6ff4fb$export$35029cc0a320e78a)(AllLists);
        const projectTypes = (0, $61689dee2f6ff4fb$export$afc921ba20c7eb49)(AllLists);
        const source = (0, $61689dee2f6ff4fb$export$dd2b6e807fb37ba3)(AllLists);
        const locations = (0, $61689dee2f6ff4fb$export$c07c686062478869)(AllLists);
        const projectLatestStatusList = (0, $61689dee2f6ff4fb$export$bb3c376502d994d1)((0, $243a1246ea7835d9$export$2425b41e18ec8805));
        const funding = (0, $61689dee2f6ff4fb$export$af91cc7b93ecc074)((0, $243a1246ea7835d9$export$14085c2a147de944));
        function addDataToWorksheet(worksheet, data, startRow, validation) {
            // helper function definitions
            function formatHeader(headerList) {
                return headerList.map((item)=>(0, $243a1246ea7835d9$export$68acbc4d2f93adde)[item]);
            }
            const addHeaderRow = (data, worksheet)=>{
                const headerRow = formatHeader(Object.keys(data[0]));
                const row = worksheet.addRow(headerRow);
                // Highlight specific columns
                row.eachCell((cell, colNumber)=>{
                    const colName = Object.keys(data[0])[colNumber - 1];
                    if ([
                        "Errors"
                    ].includes(colName)) cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {
                            argb: 'FFFF0000'
                        } // Red color
                    };
                });
            };
            const processCell = (cell, colNumber, header)=>{
                // Helper variables and functions
                const getColumnLetter = (col)=>String.fromCharCode(64 + col);
                const cellRange = `${getColumnLetter(colNumber)}1:${getColumnLetter(colNumber)}${(0, $243a1246ea7835d9$export$741e1112e38a63ea)}`;
                const applyDataValidation = (range, formulae)=>{
                    worksheet.dataValidations.add(range, {
                        type: 'list',
                        allowBlank: false,
                        formulae: formulae
                    });
                };
                if (header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["MW"] || header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["km"] || header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["M2"]) cell.value = Number(cell.value);
                else if (header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["StartDateConstruction"] || header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["EndDateConstruction"] || header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["PeriodStartYear"] || header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["PeriodEndYear"]) cell.numFmt = "dd/mm/yyyy";
                else if (header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["Investment"]) {
                    cell.value = Number(cell.value);
                    cell.numFmt = '"$"#,##0.00';
                } else cell.value = String(cell.value);
                if (header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["RawProjectType"]) applyDataValidation(cellRange, [
                    `'Project Types'!$A$1:$A$${projectTypes.length}`
                ]);
                if (header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["LocationID"]) {
                    const stateValue = cell._row._cells[3]?.value; // state column
                    const columnIndex = states.indexOf(stateValue.toUpperCase());
                    if (columnIndex !== -1) // INDIRECT will consider the note row and header row
                    applyDataValidation(cellRange, [
                        `INDIRECT(D1)`
                    ]);
                }
                if (header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["State"]) applyDataValidation(cellRange, [
                    `'States'!$A$1:$A$${states.length}`
                ]);
                if (header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["Source"]) applyDataValidation(cellRange, [
                    `'Source'!$A$1:$A$${source.length}`
                ]);
                if (header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["ProjectStage"]) applyDataValidation(cellRange, [
                    `'Status'!$A$1:$A$${projectLatestStatusList.length}`
                ]);
                if (header === (0, $243a1246ea7835d9$export$68acbc4d2f93adde)["FundingMode"]) applyDataValidation(cellRange, [
                    `'Funding'!$A$1:$A$${funding.length}`
                ]);
                // change null to empty string
                if (cell.value === null || cell.value === undefined || cell.value === "null") cell.value = "";
            };
            const processRow = (row, startRow)=>{
                const newRow = worksheet.addRow(Object.values(row));
                newRow.eachCell({
                    includeEmpty: true
                }, (cell, colNumber)=>{
                    const header = worksheet.getRow(startRow).getCell(colNumber).value;
                    processCell(cell, colNumber, header);
                });
            };
            // validation
            if (validation || worksheet.name === "Assumptions") {
                addHeaderRow(data, worksheet);
                data.forEach((row)=>processRow(row, startRow));
            } else if (worksheet.name === "Locations") {
                worksheet.addRow(states);
                data.forEach((location, rowIndex)=>{
                    const columnIndex = states.indexOf(location.state.toUpperCase()) + 1;
                    for(let i = 2; i <= rowIndex + 2; i++){
                        let found = false;
                        const row = worksheet.getRow(i);
                        if (!row.getCell(columnIndex).value && !found) {
                            row.getCell(columnIndex).value = location.locationName;
                            found = true;
                            break;
                        }
                    }
                });
            } else data.forEach((item)=>worksheet.addRow([
                    item
                ]));
        }
        // @ts-ignore
        if (downloading && scenarioAssumption?.executeGetScenarioCustomAssumption) {
            // @ts-ignore
            const project_data = (projectList?.executeGetScenarioProjectList).map((ListItem)=>{
                // @ts-ignore
                const locationName = AllLists?.executeGetLocationList.find((item)=>item.LocationID === ListItem.LocationID)?.LocationName;
                const newItem = {
                    ...ListItem,
                    LocationID: locationName,
                    Forecast: (0, $61689dee2f6ff4fb$export$c1e906046b5de973)(ListItem.ProcessingPath),
                    Ongoing: (0, $61689dee2f6ff4fb$export$6a6007f0d011e292)(ListItem.ProcessingPath),
                    OperateStatus: ListItem.RemoveProjectFromModel === 1 ? "Deleted" : ListItem.EditedProject === 1 ? "Edited" : "Unchanged"
                };
                delete newItem.RemoveProjectFromModel;
                delete newItem.EditedProject;
                delete newItem.ReadonlyProject;
                delete newItem.ProcessingPath;
                delete newItem.ScenarioID;
                delete newItem.ScenarioProjID;
                return newItem;
            }) ?? [];
            const preview_project_data = previewData.map((ListItem)=>{
                // @ts-ignore
                const locationName = AllLists?.executeGetLocationList.find((item)=>item.LocationID === ListItem.LocationID)?.LocationName;
                const newItem = {
                    ...ListItem,
                    LocationID: locationName,
                    Forecast: (0, $61689dee2f6ff4fb$export$c1e906046b5de973)(ListItem.ProcessingPath),
                    Ongoing: (0, $61689dee2f6ff4fb$export$6a6007f0d011e292)(ListItem.ProcessingPath),
                    OperateStatus: ListItem.RemoveProjectFromModel === 1 ? "Deleted" : ListItem.EditedProject === 1 ? "Edited" : "Unchanged"
                };
                // move errors of the new item to the end
                const errors = newItem.Errors;
                delete newItem.Errors;
                newItem.Errors = errors;
                delete newItem.RemoveProjectFromModel;
                delete newItem.EditedProject;
                delete newItem.ReadonlyProject;
                delete newItem.ProcessingPath;
                return newItem;
            }) ?? [];
            // @ts-ignore
            const assumptions_data = scenarioAssumption?.executeGetScenarioCustomAssumption.map((item)=>{
                //@ts-ignore
                const projectType = AllLists?.executeGetRawProjectTypes.find((type)=>type.RawProjectTypeID == item.ProjectTypeID)?.RawProjectType;
                return {
                    scenarioID: scenarioID,
                    ProjectTypeID: projectType,
                    TimePlanning: item.TimePlanning,
                    TimeConstruction: item.TimeConstruction,
                    TimeCommissioning: item.TimeCommissioning,
                    InvestmentPlanning: item.InvestmentPlanning,
                    InvestmentConstruction: item.InvestmentConstruction,
                    InvestmentCommissioning: item.InvestmentCommissioning
                };
            });
            // @ts-ignore
            const tempBaseLineAssumption = baseLineAssumption?.executeGetScenarioAssumption.map((assumption)=>{
                return {
                    scenarioID: scenarioID,
                    ProjectTypeID: "Baseline",
                    TimePlanning: assumption.Planning,
                    TimeConstruction: assumption.Construction,
                    TimeCommissioning: assumption.Commissioning,
                    InvestmentPlanning: assumption.PlanningCostPercentage,
                    InvestmentConstruction: assumption.ConstructionCostPercentage,
                    InvestmentCommissioning: assumption.CommissioningCostPercentage
                };
            });
            const new_assumption_data = [
                {
                    ...tempBaseLineAssumption[0]
                },
                ...assumptions_data
            ];
            const workbook = new $1cb7ac08e18fc2ca$exports.Workbook();
            workbook["creator"] = "Infrastructure Australia";
            const worksheetProjectData = workbook.addWorksheet("Project data");
            const worksheetAssumptions = workbook.addWorksheet("Assumptions");
            const worksheetProjectTypes = workbook.addWorksheet("Project Types");
            const worksheetLocations = workbook.addWorksheet("Locations");
            const worksheetStates = workbook.addWorksheet("States");
            const worksheetSource = workbook.addWorksheet("Source");
            const worksheetStatus = workbook.addWorksheet("Status");
            const worksheetFunding = workbook.addWorksheet("Funding");
            (0, $243a1246ea7835d9$export$83b379386136b34b).forEach((line, index)=>{
                const noteRow = worksheetProjectData.addRow([
                    line
                ]);
                noteRow.font = {
                    bold: true
                };
            });
            addDataToWorksheet(worksheetProjectData, previewFlag ? preview_project_data : project_data, (0, $243a1246ea7835d9$export$83b379386136b34b).length + 1, true);
            addDataToWorksheet(worksheetAssumptions, new_assumption_data, 1, false);
            addDataToWorksheet(worksheetProjectTypes, projectTypes, 1, false);
            addDataToWorksheet(worksheetLocations, locations, 1, false);
            addDataToWorksheet(worksheetStates, states, 1, false);
            addDataToWorksheet(worksheetSource, source, 1, false);
            addDataToWorksheet(worksheetStatus, projectLatestStatusList, 1, false);
            addDataToWorksheet(worksheetFunding, funding, 1, false);
            const sortedLocationsByState = (0, $61689dee2f6ff4fb$export$960c8c4fe218647d)(locations, states);
            // Create named ranges for each state in 'locations' worksheet
            Object.keys(sortedLocationsByState).forEach((state, colIndex)=>{
                const colLetter = String.fromCharCode(65 + colIndex); // Convert column index to letter
                const range = `${colLetter}2:${colLetter}${sortedLocationsByState[state].length + 1}`;
                workbook.definedNames.add(`Locations!${range}`, state);
            });
            workbook.xlsx.writeBuffer().then(function(buffer) {
                const blob = new Blob([
                    buffer
                ], {
                    type: "application/xlsx"
                });
                (0, $c81b9af5835f71db$exports.saveAs)(blob, scenarioTitle + ".xlsx");
            });
            setDownloading(false);
            setPreviewFlag(false);
            setUploadError(false);
        }
    }, [
        downloading,
        previewFlag
    ]);
    (0, $i5lfL.useEffect)(()=>{
        queryAssumption();
    }, []);
    const uploadScenarioProjects = (0, $d5a0a75b5a6b57e1$export$609860bf8b0084c)([
        "uploadScenarioProject"
    ], {
        mutationFn: (variables)=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $3d952ec70ff3acd2$export$76260284c78e0f4d),
                variables: variables,
                instance: instance,
                accounts: accounts
            });
        },
        onSuccess: ()=>{
            client.invalidateQueries([
                "projectList"
            ]);
            clearPreview();
        }
    });
    const { queryAssumption: queryAssumption, scenarioAssumption: scenarioAssumption } = (0, $7b85387a947c68c6$export$d16b159e2fcc1c52)({
        query: (0, $fccb6b07536ae7aa$export$b2f29a8379db78c2),
        variables: {
            inScenarioID: scenarioID,
            inProjectTypeID: 0
        },
        instance: instance,
        accounts: accounts
    });
    const { data: AllLists, isFetching: isFetching } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "Lists"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$b9bf64b597697c8a),
                variables: {
                    // @ts-ignore
                    inJurisdiction: userInfo?.executeGetUser[0].Jurisdiction ?? "",
                    inScenarioID: ""
                },
                instance: instance,
                accounts: accounts
            });
        },
        refetchOnWindowFocus: false,
        cacheTime: Infinity,
        enabled: !!userInfo
    });
    const { data: projectList, isLoading: isLoading } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "projectList",
            showEdited
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$fce0c275a3a7fa5d),
                variables: {
                    inScenarioID: scenarioID,
                    inEdited: showEdited
                },
                instance: instance,
                accounts: accounts
            });
        },
        refetchOnWindowFocus: false
    });
    //@ts-ignore
    const editableProj = !Object.keys(validationErrors).length > 0;
    const upsertScenario = (0, $d5a0a75b5a6b57e1$export$609860bf8b0084c)([
        "upsertScenario"
    ], {
        mutationFn: (variables)=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$fe625b59cac3a1cc),
                variables: variables,
                instance: instance,
                accounts: accounts
            });
        },
        onSuccess: ()=>{
            client.invalidateQueries([
                "projectList"
            ]);
        }
    });
    const [rowSelection, setRowSelection] = (0, $i5lfL.useState)({});
    const handleSaveRow = async ({ exitEditingMode: exitEditingMode, row: row, values: values })=>{
        //send/receive api updates here
        if (!Object.keys(validationErrors).length) {
            if (validateDatetime(values)) {
                setDateError("");
                upsertScenario.mutate((0, $20853d91ad35cc65$export$233596b476311f4b)(scenarioID, "editing", values, // @ts-ignore
                projectList?.executeGetScenarioProjectList[row.index]));
                // optimistic update
                values.StartDateConstruction = (0, $4364962cd37ab450$export$a22fff68bec8f2b8)(values.StartDateConstruction, values.ProcessingPath, true);
                values.EndDateConstruction = (0, $4364962cd37ab450$export$4a2be59dbba42469)(values.EndDateConstruction, values.ProcessingPath, true);
                row[row.index] = values;
                exitEditingMode(); //required to exit editing mode
            }
        }
    };
    const validateRequired = (value)=>!value.length ? "is required" : "";
    const validateDatetime = (values)=>{
        if (!values.EndDateConstruction || !values.StartDateConstruction) {
            setDateError("Invalid construction date range, Construction Dates can not be empty");
            return false;
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.EndDateConstruction).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(values.StartDateConstruction))) {
            setDateError("Invalid construction date range, Construction Start Date should be before Construction End Date.");
            return false;
        }
        return true;
    };
    const validateProjectName = (projectName, cell)=>{
        // @ts-ignore
        if (projectList?.executeGetScenarioProjectList.filter((item)=>item['ProjectName'] == projectName).length > 0 && projectName != cell.getValue()) return "Project name need to be unique";
        return "";
    };
    const validateInvestment = (investment)=>Number(investment) < 0 ? "Investment is invalid" : "";
    const validateProjectType = (projectType, cell)=>{
        const tempProcessingPath = cell.row.getAllCells().find((item)=>item.column.id === "ProcessingPath").getValue();
        const preProjectType = cell.getValue();
        const isErrorProjectType = !(0, $243a1246ea7835d9$export$714a25c0e9cde501)[tempProcessingPath](preProjectType, projectType)[0];
        const errorMessage = (0, $243a1246ea7835d9$export$714a25c0e9cde501)[tempProcessingPath](preProjectType, projectType)[1];
        if (isErrorProjectType) return errorMessage;
        // TODO: add housing project types validation once m2 field is build
        return "";
    };
    const validateMegawatt = (megawatt, cell)=>{
        const currentProjectType = cell.row.getAllCells().find((item)=>item.column.id === "RawProjectType").getValue();
        if ((0, $243a1246ea7835d9$export$ad98f2e8c6fd720d).indexOf(currentProjectType) === -1 && megawatt != 0) return "MW only exist in energy project";
        // Check empty string
        if (megawatt == 0) return "Please enter non empty MW";
        return "";
    };
    const validateM2 = (m2, cell)=>{
        const currentProjectType = cell.row.getAllCells().find((item)=>item.column.id === "RawProjectType").getValue();
        if ((0, $243a1246ea7835d9$export$9bcd006cd4d2d851).indexOf(currentProjectType) === -1 && m2 != 0) return "M2 only exist in detached house project";
        // Check empty string
        if (m2 == 0) return "Please enter non empty M2";
        return "";
    };
    const validateKm = (km, cell)=>{
        if (km == 0) return "Please enter non empty KM";
        return "";
    };
    //  define validation rules for each cell
    const validateCellValue = (cell, value)=>{
        if (cell.column.id === 'ProjectName') return validateProjectName(value.toString(), cell);
        else if (cell.column.id === 'Investment') return validateInvestment(+value);
        else if (cell.column.id === "RawProjectType") return validateProjectType(value, cell);
        else if (cell.column.id === "MW") return validateMegawatt(value, cell);
        else if (cell.column.id === "M2") return validateM2(value, cell);
        else if (cell.column.id === "km") return validateKm(value, cell);
        else return validateRequired(value.toString());
    };
    const getCommonEditTextFieldProps = (0, $i5lfL.useCallback)((cell)=>{
        return {
            error: !!validationErrors[cell.id],
            helperText: validationErrors[cell.id],
            onBlur: (event)=>{
                const ErrorMessage = validateCellValue(cell, event.target.value);
                if (ErrorMessage) //set validation error for cell if invalid
                setValidationErrors({
                    ...validationErrors,
                    [cell.id]: `${ErrorMessage}`
                });
                else {
                    //remove validation error for cell if valid
                    delete validationErrors[cell.id];
                    setValidationErrors({
                        ...validationErrors
                    });
                }
            }
        };
    }, [
        validationErrors
    ]);
    const handleCreateNewRowModal = (values)=>{
        //send/receive api updates here
        upsertScenario.mutate((0, $20853d91ad35cc65$export$233596b476311f4b)(scenarioID, "creating", values));
    };
    function handleUpdateTab(index) {
        setTabIndex(index);
    }
    const handleShowEditedChange = (event)=>{
        if (event.target.value != null) setShowEdited(Number(event.target.value));
    };
    const columns = (0, $i5lfL.useMemo)(()=>(0, $6bf25bc007efe8a9$export$85de6c5fd2d85dc0)(AllLists, getCommonEditTextFieldProps), [
        AllLists,
        getCommonEditTextFieldProps
    ]);
    function handleDeleteProject(row) {
        upsertScenario.mutate((0, $20853d91ad35cc65$export$233596b476311f4b)(scenarioID, "deleting", // @ts-ignore
        projectList?.executeGetScenarioProjectList[row.index]));
    }
    function handleRestoreProject(row) {
        upsertScenario.mutate((0, $20853d91ad35cc65$export$233596b476311f4b)(scenarioID, "restoring", // @ts-ignore
        projectList?.executeGetScenarioProjectList[row.index]));
    }
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        sx: {
            zIndex: "1000"
        },
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $7e3df3c636b0fe42$export$2e2bcd8739ae039), {
                sx: ()=>({
                        borderRadius: "4px",
                        display: "flex",
                        flexDirection: {
                            xs: "column",
                            lg: "row"
                        },
                        gap: "1rem",
                        justifyContent: "space-between",
                        p: "1.5rem 0"
                    }),
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                        onClick: ()=>setCreateModalOpen(true),
                                        variant: "outlined",
                                        sx: {
                                            borderRadius: "35px"
                                        },
                                        disabled: !editableProj,
                                        children: [
                                            "Add a project",
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f7454d0d2ff8e9f6$exports))), {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                                        arrow: true,
                                        title: "Filter Edited Item",
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $5a88d895317a42d5$export$2e2bcd8739ae039), {
                                            value: showEdited,
                                            exclusive: true,
                                            onChange: handleShowEditedChange,
                                            "aria-label": "Edited Filter",
                                            size: "small",
                                            children: [
                                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $4956857b2b444fde$export$2e2bcd8739ae039), {
                                                    value: 1,
                                                    children: "Edited"
                                                }),
                                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $4956857b2b444fde$export$2e2bcd8739ae039), {
                                                    value: 0,
                                                    children: "All"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                        variant: "h5",
                        children: [
                            "Scenario name: ",
                            scenarioTitle
                        ]
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                            onClick: ()=>handleUpdateTab(2),
                            variant: "contained",
                            children: [
                                "Assumptions",
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f156b218576f4e73$exports))), {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30615b8e57e39efe$export$2506d3bf41f97512), {
                // @ts-ignore
                columns: columns,
                // @ts-ignore
                data: previewFlag ? previewData ?? [] : projectList?.executeGetScenarioProjectList ?? [],
                enableRowActions: true,
                enableRowVirtualization: true,
                rowVirtualizerProps: {
                    overscan: 10
                },
                enablePagination: false,
                // Issue with Material table conditional editing (v1 1.14), dummy condition need to be in here
                // so the editing row state is managed properly internally
                enableEditing: (row)=>row.index % 1 === 0,
                onEditingRowCancel: ()=>{
                    setValidationErrors({});
                },
                enableSorting: true,
                globalFilterFn: "includesString",
                editingMode: "row",
                enableFacetedValues: true,
                enableClickToCopy: true,
                enableColumnResizing: true,
                enableTopToolbar: true,
                positionGlobalFilter: "left",
                onEditingRowSave: handleSaveRow,
                enableStickyHeader: true,
                muiTableContainerProps: {
                    sx: {
                        maxHeight: "40vh"
                    }
                },
                onShowColumnFiltersChange: (updater)=>{
                    setShowColumnFilters((prev)=>updater instanceof Function ? updater(prev) : updater);
                    setColumnFilters([]);
                    queueMicrotask(rerender); //hack to rerender after state update
                },
                onColumnFiltersChange: (updater)=>{
                    setColumnFilters((prev)=>updater instanceof Function ? updater(prev) : updater);
                    queueMicrotask(rerender); //hack to rerender after state update
                },
                onColumnVisibilityChange: (updater)=>{
                    setColumnVisibility((prev)=>updater instanceof Function ? updater(prev) : updater);
                    queueMicrotask(rerender); //hack to rerender after state update
                },
                onRowSelectionChange: (updater)=>{
                    setRowSelection((prev)=>updater instanceof Function ? updater(prev) : updater);
                    queueMicrotask(rerender); //hack to rerender after state update
                },
                initialState: {
                    showGlobalFilter: true,
                    density: "compact"
                },
                state: {
                    columnVisibility: columnVisibility,
                    rowSelection: rowSelection,
                    columnFilters: columnFilters,
                    showColumnFilters: showColumnFilters,
                    isLoading: isLoading,
                    showAlertBanner: !!dateError || !!previewFlag,
                    showProgressBars: isFetching,
                    columnPinning: {
                        right: [],
                        left: [
                            'mrt-row-actions'
                        ]
                    }
                },
                tableInstanceRef: tableInstanceRef,
                displayColumnDefOptions: {
                    "mrt-row-actions": {
                        Header: "",
                        size: 100
                    }
                },
                positionToolbarAlertBanner: "top",
                muiTableBodyProps: {
                    sx: ()=>({
                            "& tr:nth-of-type(odd)": {
                                backgroundColor: "#8578741A"
                            }
                        })
                },
                muiToolbarAlertBannerProps: !!dateError ? {
                    color: 'error',
                    children: dateError
                } : !!previewFlag ? uploadError ? {
                    color: 'error',
                    children: "Please download the spreadsheet with errors column and fix the errors in the error column before submitting"
                } : {
                    color: 'warning',
                    children: "There are no errors in the uploaded spreadsheet. You can submit the pipeline now"
                } : undefined,
                muiTableBodyRowProps: (table)=>{
                    return {
                        sx: ()=>({
                                // @ts-ignore
                                "textDecoration": previewFlag ? previewData[table.row.index]?.RemoveProjectFromModel ? "line-through" : "none" : projectList?.executeGetScenarioProjectList[table.row.index]?.RemoveProjectFromModel ? "line-through" : "none"
                            })
                    };
                },
                positionActionsColumn: "first",
                renderRowActionMenuItems: ({ closeMenu: closeMenu, row: row, table: table })=>[
                        /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                table.setEditingRow(row);
                                closeMenu();
                            },
                            sx: {
                                m: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($da94f4c5a02c6653$exports))), {})
                                }),
                                "Edit"
                            ]
                        }, 0),
                        /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                handleDeleteProject(row);
                                closeMenu();
                            },
                            sx: {
                                m: 0
                            },
                            disabled: !!row.original.RemoveProjectFromModel,
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ca6909be4938645f$exports))), {})
                                }),
                                "Delete"
                            ]
                        }, 1),
                        /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                handleRestoreProject(row);
                                closeMenu();
                            },
                            sx: {
                                m: 0
                            },
                            disabled: !row.original.RemoveProjectFromModel,
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c3532d91f35b9323$exports))), {})
                                }),
                                "Restore"
                            ]
                        }, 2)
                    ],
                renderBottomToolbarCustomActions: ({})=>{
                    const handleGenerateScenario = ()=>{
                        setTabIndex(3);
                        runModel();
                    };
                    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            gap: "0.5rem",
                            p: 2,
                            justifyContent: "flex-end",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                sx: {
                                    fontStyle: "italic",
                                    fontWeight: 700,
                                    mt: 2,
                                    justifyContent: "flex-end",
                                    fontFamily: "ProximaNova-Bold",
                                    marginRight: "auto"
                                },
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                                    children: (0, $d29d6d1034e01aa1$export$f68e326d679cfc85)
                                })
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                onClick: ()=>handleUpdateTab(0),
                                variant: "contained",
                                startIcon: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($188d7627f9b29063$exports))), {}),
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                variant: "contained",
                                onClick: handleConfirmSubmit,
                                disabled: isFetching || uploadError,
                                children: "Submit"
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                onClick: handleGenerateScenario,
                                variant: "contained",
                                disabled: previewFlag,
                                children: "Generate scenario"
                            })
                        ]
                    });
                },
                renderToolbarInternalActions: ({ table: table })=>// render an empty action are to disable the duplicated actions(full screen etc.)
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30615b8e57e39efe$export$d9eac406b7d9b19a), {
                                table: table
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30615b8e57e39efe$export$df5f5becfc7dc5e7), {
                                table: table
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30615b8e57e39efe$export$292cb709c1b05af0), {
                                table: table
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                                arrow: true,
                                title: "Export All Data",
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)("label", {
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        disabled: downloading || isFetching,
                                        onClick: ()=>{
                                            setDownloading(true);
                                        },
                                        endIcon: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9bc9c4f93103a0b3$exports))), {}),
                                        children: "DOWNLOAD"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)("input", {
                                ref: fileInputRef,
                                id: "file-input",
                                type: "file",
                                style: {
                                    display: "none"
                                },
                                onChange: handleFileChange,
                                accept: ".xls,.xlsx,.csv"
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                                arrow: true,
                                title: "Import All Data",
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)("label", {
                                    htmlFor: "file-input",
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                        sx: {
                                            ml: 1
                                        },
                                        variant: "outlined",
                                        component: "span",
                                        disabled: isFetching,
                                        endIcon: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78e40c7d7e50d5ff$exports))), {}),
                                        children: "UPLOAD"
                                    })
                                })
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $416e4400d63bb0bb$export$a5a5f67a7efd7c08), {
                // @ts-ignore
                columns: columns,
                open: createModalOpen,
                onClose: ()=>setCreateModalOpen(false),
                onSubmit: handleCreateNewRowModal,
                AllLists: AllLists,
                projectList: projectList,
                // @ts-ignore
                Juri: userInfo?.executeGetUser[0].Jurisdiction ?? ""
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039), {
                open: uploadScenarioProjects.isLoading,
                "aria-describedby": "upload-progress",
                maxWidth: "xs",
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $48d8f4c3325a9037$export$2e2bcd8739ae039), {
                        children: "The file is uploading..."
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $422502a3833a93e2$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $2fce601e44012509$export$2e2bcd8739ae039), {
                            id: "upload-progress"
                        })
                    })
                ]
            })
        ]
    });
}


/*
 * Copyright (c) 2023. RoZetta Technology Pty Ltd. All rights reserved.
 */ 
var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");





var $bHJbJ = parcelRequire("bHJbJ");


var $i5lfL = parcelRequire("i5lfL");










var $bHJbJ = parcelRequire("bHJbJ");

parcelRequire("i5lfL");

function $95e6a231d10c272f$export$810668902254eec0(AllLists, getCommonEditTextFieldProps) {
    return [
        {
            accessorKey: "RawProjectType",
            header: "Project type",
            size: 200,
            filterVariant: "multi-select",
            editVariant: "select",
            editSelectOptions: (0, $658384a585644311$export$b396c7cd9d5abae7)(AllLists)
        },
        {
            id: "TimeAllocation",
            header: "Time Allocation",
            columns: [
                {
                    id: "PlanningTimePercentage",
                    accessorFn: (row)=>parseInt(row.PlanningTimePercentage),
                    filterFn: "betweenInclusive",
                    filterVariant: "range",
                    header: "Planning",
                    size: 100,
                    Cell: ({ cell: cell })=>{
                        return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                display: "flex",
                                justifyContent: "flex-end",
                                width: "100%"
                            },
                            children: // @ts-ignore
                            cell.getValue().toLocaleString() + " %"
                        });
                    },
                    muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                            ...getCommonEditTextFieldProps(cell)
                        })
                },
                {
                    id: "ConstructionTimePercentage",
                    accessorFn: (row)=>parseInt(row.ConstructionTimePercentage),
                    filterFn: "betweenInclusive",
                    filterVariant: "range",
                    header: "Construction",
                    size: 120,
                    Cell: ({ cell: cell })=>{
                        return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                display: "flex",
                                justifyContent: "flex-end",
                                width: "100%"
                            },
                            children: // @ts-ignore
                            cell.getValue().toLocaleString() + " %"
                        });
                    },
                    muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                            ...getCommonEditTextFieldProps(cell)
                        })
                },
                {
                    id: "CommissioningTimePercentage",
                    accessorFn: (row)=>parseInt(row.CommissioningTimePercentage),
                    filterFn: "betweenInclusive",
                    filterVariant: "range",
                    header: "Commission",
                    size: 120,
                    Cell: ({ cell: cell })=>{
                        return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                display: "flex",
                                justifyContent: "flex-end",
                                width: "100%"
                            },
                            children: // @ts-ignore
                            cell.getValue().toLocaleString() + " %"
                        });
                    },
                    muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                            ...getCommonEditTextFieldProps(cell)
                        })
                },
                {
                    id: "TimeTotal",
                    filterFn: "betweenInclusive",
                    filterVariant: "range",
                    header: "Total",
                    size: 100,
                    enableEditing: false,
                    Cell: ({ row: row, table: table })=>{
                        const editingRow = table.getState().editingRow;
                        const editingRowIndex = editingRow?.index;
                        const valuesCache = row.index === editingRowIndex ? editingRow._valuesCache : row._valuesCache;
                        const totalTime = parseInt(valuesCache["PlanningTimePercentage"]) + parseInt(valuesCache["ConstructionTimePercentage"]) + parseInt(valuesCache["CommissioningTimePercentage"]);
                        const totalColor = totalTime === 100 ? "" : "error.main";
                        return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                display: "flex",
                                justifyContent: "flex-end",
                                width: "100%",
                                color: totalColor
                            },
                            children: [
                                totalTime,
                                " %"
                            ]
                        });
                    }
                }
            ]
        },
        {
            id: "CostAllocation",
            header: "Investment Allocation",
            columns: [
                {
                    id: "PlanningCostPercentage",
                    accessorFn: (row)=>parseInt(row.PlanningCostPercentage),
                    filterFn: "betweenInclusive",
                    filterVariant: "range",
                    header: "Planning",
                    size: 100,
                    Cell: ({ cell: cell })=>{
                        return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                display: "flex",
                                justifyContent: "flex-end",
                                width: "100%"
                            },
                            children: // @ts-ignore
                            cell.getValue().toLocaleString() + " %"
                        });
                    },
                    muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                            ...getCommonEditTextFieldProps(cell)
                        })
                },
                {
                    id: "ConstructionCostPercentage",
                    accessorFn: (row)=>parseInt(row.ConstructionCostPercentage),
                    filterFn: "betweenInclusive",
                    filterVariant: "range",
                    header: "Construction",
                    size: 120,
                    Cell: ({ cell: cell })=>{
                        return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                display: "flex",
                                justifyContent: "flex-end",
                                width: "100%"
                            },
                            children: // @ts-ignore
                            cell.getValue().toLocaleString() + " %"
                        });
                    },
                    muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                            ...getCommonEditTextFieldProps(cell)
                        })
                },
                {
                    id: "CommissioningCostPercentage",
                    accessorFn: (row)=>parseInt(row.CommissioningCostPercentage),
                    filterFn: "betweenInclusive",
                    filterVariant: "range",
                    header: "Commission",
                    size: 120,
                    Cell: ({ cell: cell })=>{
                        return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                display: "flex",
                                justifyContent: "flex-end",
                                width: "100%"
                            },
                            children: // @ts-ignore
                            cell.getValue().toLocaleString() + " %"
                        });
                    },
                    muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                            ...getCommonEditTextFieldProps(cell)
                        })
                },
                {
                    id: "CostTotal",
                    filterFn: "betweenInclusive",
                    filterVariant: "range",
                    header: "Total",
                    size: 100,
                    enableEditing: false,
                    Cell: ({ row: row, table: table })=>{
                        const editingRow = table.getState().editingRow;
                        const editingRowIndex = editingRow?.index;
                        const valuesCache = row.index === editingRowIndex ? editingRow._valuesCache : row._valuesCache;
                        const totalTime = parseInt(valuesCache["PlanningCostPercentage"]) + parseInt(valuesCache["ConstructionCostPercentage"]) + parseInt(valuesCache["CommissioningCostPercentage"]);
                        const totalColor = totalTime === 100 ? "" : "error.main";
                        return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            sx: {
                                display: "flex",
                                justifyContent: "flex-end",
                                width: "100%",
                                color: totalColor
                            },
                            children: [
                                totalTime,
                                " %"
                            ]
                        });
                    }
                }
            ]
        }
    ];
}




var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");



const $cb5da3f6a29dba2f$var$CreateNewAssumptionModal = ({ open: open, onClose: onClose, onSubmit: onSubmit, AllLists: AllLists })=>{
    // state
    const [values, setValues] = (0, $i5lfL.useState)({
        RawProjectType: "",
        PlanningTimePercentage: 0,
        ConstructionTimePercentage: 0,
        CommissioningTimePercentage: 0,
        PlanningCostPercentage: 0,
        ConstructionCostPercentage: 0,
        CommissioningCostPercentage: 0
    });
    const [isAlertOpen, setIsAlertOpen] = (0, $i5lfL.useState)(false);
    const timeTotal = Number(values.PlanningTimePercentage) + Number(values.ConstructionTimePercentage) + Number(values.CommissioningTimePercentage);
    const investmentTotal = Number(values.PlanningCostPercentage) + Number(values.ConstructionCostPercentage) + Number(values.CommissioningCostPercentage);
    const validateTimeInvestmentTotal = ()=>{
        if (timeTotal !== 100) return "Time allocation must sum to 100%";
        if (investmentTotal !== 100) return "Investment allocation must sum to 100%";
        return "";
    };
    const handleChange = (e)=>{
        if (e.target.name === "RawProjectType") setValues({
            ...values,
            [e.target.name]: e.target.value
        });
        else // Regular expression to match valid number with up to one decimal place
        if ((0, $658384a585644311$export$45902cc189596eef).test(e.target.value) && e.target.value.indexOf(".") === -1 && e.target.value.length <= 3) setValues({
            ...values,
            [e.target.name]: e.target.value
        });
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
        if (!validateTimeInvestmentTotal()) {
            AllLists?.executeGetRawProjectTypes.forEach((type)=>{
                if (type.RawProjectType === values.RawProjectType) onSubmit({
                    ...values,
                    ProjectTypeID: type.RawProjectTypeID
                });
            });
            setValues({
                ...(0, $243a1246ea7835d9$export$429689afd7ea514a)
            }) // clear the form
            ;
            setIsAlertOpen(false);
            onClose();
        } else setIsAlertOpen(true);
    };
    (0, $i5lfL.useEffect)(()=>{
        if (investmentTotal === 100 && timeTotal === 100) setIsAlertOpen(false);
    }, [
        investmentTotal,
        timeTotal
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039), {
        open: open,
        fullWidth: true,
        maxWidth: "lg",
        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $48d8f4c3325a9037$export$2e2bcd8739ae039), {
                    id: "create-dialog-title",
                    children: "Create New Assumption"
                }),
                /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $422502a3833a93e2$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            p: 2,
                            className: "hide-asterisk",
                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                container: true,
                                spacing: 2,
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 3,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        name: "RawProjectType",
                                        label: "Project type",
                                        select: true,
                                        value: values.RawProjectType,
                                        required: true,
                                        onChange: handleChange,
                                        children: AllLists?.executeGetRawProjectTypes.map((option)=>{
                                            if ([
                                                ...(0, $243a1246ea7835d9$export$ad98f2e8c6fd720d),
                                                ...(0, $243a1246ea7835d9$export$5be856edc6a7f539)
                                            ].indexOf(option.RawProjectType) === -1) return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                value: option.RawProjectType,
                                                children: option.RawProjectType
                                            }, option.RawProjectType);
                                        })
                                    }, "RawProjectType")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $48d8f4c3325a9037$export$2e2bcd8739ae039), {
                            id: "time-allocation-title",
                            children: "Time allocation"
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            p: 2,
                            className: "hide-asterisk",
                            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                container: true,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 3,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            name: "PlanningTimePercentage",
                                            label: "Planning Percentage",
                                            required: true,
                                            type: "number",
                                            value: values.PlanningTimePercentage,
                                            onChange: handleChange
                                        }, "PlanningTimePercentage")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 3,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            name: "ConstructionTimePercentage",
                                            label: "Construction Percentage",
                                            required: true,
                                            type: "number",
                                            value: values.ConstructionTimePercentage,
                                            onChange: handleChange
                                        }, "ConstructionTimePercentage")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 3,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            name: "CommissioningTimePercentage",
                                            label: "Commissioning Percentage",
                                            required: true,
                                            value: values.CommissioningTimePercentage,
                                            type: "number",
                                            onChange: handleChange
                                        }, "CommissioningTimePercentage")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 3,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Total",
                                            required: true,
                                            error: isNaN(timeTotal) || timeTotal !== 100,
                                            value: timeTotal + "%",
                                            disabled: true
                                        }, "TimeTotal")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $48d8f4c3325a9037$export$2e2bcd8739ae039), {
                            id: "investment-allocation-title",
                            children: "Investment allocation"
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                            p: 2,
                            className: "hide-asterisk",
                            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                container: true,
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 3,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            name: "PlanningCostPercentage",
                                            label: "Planning Percentage",
                                            type: "number",
                                            required: true,
                                            value: values.PlanningCostPercentage,
                                            onChange: handleChange
                                        }, "PlanningCostPercentage")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 3,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            name: "ConstructionCostPercentage",
                                            label: "Construction Percentage",
                                            type: "number",
                                            required: true,
                                            value: values.ConstructionCostPercentage,
                                            onChange: handleChange
                                        }, "ConstructionCostPercentage")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 3,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            name: "CommissioningCostPercentage",
                                            label: "Commissioning Percentage",
                                            type: "number",
                                            required: true,
                                            value: values.CommissioningCostPercentage,
                                            onChange: handleChange
                                        }, "CommissioningCostPercentage")
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        xs: 3,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Total",
                                            required: true,
                                            disabled: true,
                                            error: isNaN(investmentTotal) || investmentTotal !== 100,
                                            value: investmentTotal + "%"
                                        }, "CostTotal")
                                    })
                                ]
                            })
                        })
                    ]
                }),
                isAlertOpen && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $097160938072b98e$export$2e2bcd8739ae039), {
                    severity: "error",
                    children: validateTimeInvestmentTotal()
                }),
                /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $0d4f9b05ed57077c$export$2e2bcd8739ae039), {
                    sx: {
                        p: "1.25rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                setValues({
                                    ...(0, $243a1246ea7835d9$export$429689afd7ea514a)
                                }) // clear the form
                                ;
                                setIsAlertOpen(false);
                                onClose();
                            },
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                            color: "secondary",
                            variant: "contained",
                            type: "submit",
                            children: "Create"
                        })
                    ]
                })
            ]
        })
    });
};
var $cb5da3f6a29dba2f$export$2e2bcd8739ae039 = $cb5da3f6a29dba2f$var$CreateNewAssumptionModal;



function $3f6d11e40c5bf4ae$export$6ba823b57a6ac27d(scenarioID, mode, values) {
    const formatPercentage = (value)=>{
        return ((value ?? 0) / 100).toFixed(2).toString();
    };
    if (mode === "editing") return {
        // editing assumption record
        inScenarioID: scenarioID,
        inProjectTypeID: values.ProjectTypeID,
        inTimePlanning: formatPercentage(values.PlanningTimePercentage),
        inTimeConstruction: formatPercentage(values.ConstructionTimePercentage),
        inTimeCommissioning: formatPercentage(values.CommissioningTimePercentage),
        inInvestmentPlanning: formatPercentage(values.PlanningCostPercentage),
        inInvestmentConstruction: formatPercentage(values.ConstructionCostPercentage),
        inInvestmentCommissioning: formatPercentage(values.CommissioningCostPercentage)
    };
    else if (mode === "deleting") return {
        // deleting assumption record
        inScenarioID: scenarioID,
        inProjectTypeID: values.ProjectTypeID
    };
    else return {
        // creating assumption record
        inScenarioID: scenarioID,
        inProjectTypeID: values.ProjectTypeID,
        inTimePlanning: formatPercentage(values.PlanningTimePercentage),
        inTimeConstruction: formatPercentage(values.ConstructionTimePercentage),
        inTimeCommissioning: formatPercentage(values.CommissioningTimePercentage),
        inInvestmentPlanning: formatPercentage(values.PlanningCostPercentage),
        inInvestmentConstruction: formatPercentage(values.ConstructionCostPercentage),
        inInvestmentCommissioning: formatPercentage(values.CommissioningCostPercentage)
    };
}




const $ebb8bf80ce283ad5$var$ProjectPhasingV2 = (props)=>{
    const { scenarioID: scenarioID, onTabChange: onTabChange } = props;
    const client = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)();
    const { data: userInfo } = (0, $8aac0537827a6bae$export$801fe16824f675f7)();
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const rerender = (0, $i5lfL.useReducer)(()=>({}), {})[1];
    // State
    const [phasingData, setPhasingData] = (0, $i5lfL.useState)([
        {
            ProjectTypeID: "",
            RawProjectType: "Baseline",
            PlanningTimePercentage: 15,
            ConstructionTimePercentage: 80,
            CommissioningTimePercentage: 5,
            PlanningCostPercentage: 31,
            ConstructionCostPercentage: 59,
            CommissioningCostPercentage: 10
        }
    ]);
    const [reset, setReset] = (0, $i5lfL.useState)(0);
    const [rowSelection, setRowSelection] = (0, $i5lfL.useState)({});
    const tableInstanceRef = (0, $i5lfL.useRef)(null);
    const [validationErrors, setValidationErrors] = (0, $i5lfL.useState)({});
    const [isAddAssumptionModalOpen, setIsAddAssumptionModalOpen] = (0, $i5lfL.useState)(false);
    // React Query
    const { baseLineAssumption: baseLineAssumption, isBaseLineAssumptionSuccess: isBaseLineAssumptionSuccess } = (0, $6db69764eaf5cc18$export$2e2bcd8739ae039)({
        scenarioID: scenarioID,
        instance: instance,
        accounts: accounts
    });
    const { data: AllLists } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "Lists"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$b9bf64b597697c8a),
                variables: {
                    // @ts-ignore
                    inJurisdiction: userInfo?.executeGetUser[0].Jurisdiction ?? "",
                    inScenarioID: ""
                },
                instance: instance,
                accounts: accounts
            });
        },
        cacheTime: Infinity,
        enabled: !!userInfo
    });
    const { data: scenarioAssumption, isLoading: isLoading, isFetching: isFetching, isSuccess: isSuccess } = (0, $45631327982d6a29$export$dd0a697e1782aedd)([
        "getScenarioAssumptions"
    ], {
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $fccb6b07536ae7aa$export$b2f29a8379db78c2),
                variables: {
                    inScenarioID: scenarioID,
                    inProjectTypeID: 0
                },
                instance: instance,
                accounts: accounts
            });
        }
    });
    const updateScenarioAssumptions = (0, $d5a0a75b5a6b57e1$export$609860bf8b0084c)([
        "updateScenarioAssumptions"
    ], {
        mutationFn: (variables)=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $fccb6b07536ae7aa$export$63760899b05c78d9),
                variables: variables,
                instance: instance,
                accounts: accounts
            });
        },
        onSuccess: (data)=>{
            setReset(0);
            client.invalidateQueries([
                "getScenarioAssumptions"
            ]);
        }
    });
    const deleteScenarioAssumptions = (0, $d5a0a75b5a6b57e1$export$609860bf8b0084c)([
        "deleteScenarioAssumptions"
    ], {
        mutationFn: (variables)=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $fccb6b07536ae7aa$export$ce9a057adbccc69a),
                variables: variables,
                instance: instance,
                accounts: accounts
            });
        },
        onSuccess: (data)=>{
            setReset(0);
            client.invalidateQueries([
                "getScenarioAssumptions"
            ]);
        }
    });
    // Event Handler
    const handleSaveRow = async ({ exitEditingMode: exitEditingMode, row: row, values: values })=>{
        const timeTotalCellId = row._getAllCellsByColumnId()["TimeTotal"].id;
        const costTotalCellId = row._getAllCellsByColumnId()["CostTotal"].id;
        const timeTotalValue = parseInt(values["PlanningTimePercentage"]) + parseInt(values["ConstructionTimePercentage"]) + parseInt(values["CommissioningTimePercentage"]);
        const costTotalValue = parseInt(values["PlanningCostPercentage"]) + parseInt(values["ConstructionCostPercentage"]) + parseInt(values["CommissioningCostPercentage"]);
        //send/receive api updates here
        // validation
        if (timeTotalValue !== 100) {
            setValidationErrors({
                ...validationErrors,
                [timeTotalCellId]: "Total time percentage must be equal to 100%"
            });
            return;
        } else if (timeTotalValue === 100) {
            //remove validation error for cell if valid
            delete validationErrors[timeTotalCellId];
            setValidationErrors({
                ...validationErrors
            });
        }
        if (costTotalValue !== 100) {
            setValidationErrors({
                ...validationErrors,
                [costTotalCellId]: "Total Investment percentage must be equal to 100%"
            });
            return;
        } else if (costTotalValue === 100) {
            //remove validation error for cell if valid
            delete validationErrors[costTotalCellId];
            setValidationErrors({
                ...validationErrors
            });
        }
        // optimistic update
        values.ProjectTypeID = row.original.ProjectTypeID;
        phasingData[row.index] = values;
        setPhasingData([
            ...phasingData
        ]);
        // send api request to update assumption
        updateScenarioAssumptions.mutate((0, $3f6d11e40c5bf4ae$export$6ba823b57a6ac27d)(scenarioID, "editing", values));
        exitEditingMode();
    };
    const handleCreateNewRowModal = (values)=>{
        // send api request to create new assumption
        updateScenarioAssumptions.mutate((0, $3f6d11e40c5bf4ae$export$6ba823b57a6ac27d)(scenarioID, "creating", values));
    };
    // Side effect code
    (0, $i5lfL.useEffect)(()=>{
        if (isSuccess && isBaseLineAssumptionSuccess) {
            // @ts-ignore
            const tempBaseLineAssumption = baseLineAssumption?.executeGetScenarioAssumption.map((assumption)=>{
                return {
                    ProjectTypeID: assumption.ProjectTypeID || "",
                    // @ts-ignore
                    RawProjectType: "Baseline",
                    PlanningTimePercentage: assumption.Planning * 100,
                    ConstructionTimePercentage: assumption.Construction * 100,
                    CommissioningTimePercentage: assumption.Commissioning * 100,
                    PlanningCostPercentage: assumption.PlanningCostPercentage * 100,
                    ConstructionCostPercentage: assumption.ConstructionCostPercentage * 100,
                    CommissioningCostPercentage: assumption.CommissioningCostPercentage * 100
                };
            });
            // @ts-ignore
            const tempPhasingData = scenarioAssumption?.executeGetScenarioCustomAssumption.map((assumption)=>{
                return {
                    ProjectTypeID: assumption.ProjectTypeID || "",
                    // @ts-ignore
                    RawProjectType: AllLists?.executeGetRawProjectTypes.find((project)=>project.RawProjectTypeID === assumption.ProjectTypeID)?.RawProjectType || "",
                    PlanningTimePercentage: assumption.TimePlanning * 100,
                    ConstructionTimePercentage: assumption.TimeConstruction * 100,
                    CommissioningTimePercentage: assumption.TimeCommissioning * 100,
                    PlanningCostPercentage: assumption.InvestmentPlanning * 100,
                    ConstructionCostPercentage: assumption.InvestmentConstruction * 100,
                    CommissioningCostPercentage: assumption.InvestmentCommissioning * 100
                };
            });
            setPhasingData([
                ...tempBaseLineAssumption,
                ...tempPhasingData
            ]);
        }
    }, [
        isSuccess,
        scenarioAssumption,
        reset,
        baseLineAssumption
    ]);
    const getCommonEditTextFieldProps = (0, $i5lfL.useCallback)((cell)=>{
        return {
            error: !!validationErrors[cell.id],
            helperText: validationErrors[cell.id]
        };
    }, [
        validationErrors
    ]);
    const assumptionColumns = (0, $i5lfL.useMemo)(()=>(0, $95e6a231d10c272f$export$810668902254eec0)(AllLists, getCommonEditTextFieldProps), [
        AllLists,
        getCommonEditTextFieldProps
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                p: 1,
                children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: (0, $d29d6d1034e01aa1$export$c5207a560bbcb1de)
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            item: true,
                            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    setIsAddAssumptionModalOpen(true);
                                },
                                variant: "outlined",
                                sx: {
                                    borderRadius: "35px"
                                },
                                children: [
                                    "Add an assumption",
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f7454d0d2ff8e9f6$exports))), {})
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30615b8e57e39efe$export$2506d3bf41f97512), {
                // @ts-ignore
                columns: assumptionColumns,
                data: phasingData ?? [],
                enableRowActions: true,
                enableRowVirtualization: true,
                rowVirtualizerProps: {
                    overscan: 10
                },
                enablePagination: false,
                // Issue with Material table conditional editing (v1 1.14), dummy condition need to be in here
                // so the editing row state is managed properly internally
                enableEditing: (row)=>row.index % 1 === 0 && row.index !== 0,
                onEditingRowCancel: ()=>{
                    setValidationErrors({});
                },
                enableSorting: true,
                globalFilterFn: "includesString",
                editingMode: "row",
                enableFacetedValues: true,
                enableClickToCopy: true,
                enableColumnResizing: true,
                enableColumnActions: false,
                enableTopToolbar: true,
                positionGlobalFilter: "left",
                onEditingRowSave: handleSaveRow,
                enableStickyHeader: true,
                muiTableContainerProps: {
                    sx: {
                        maxHeight: "40vh"
                    }
                },
                onRowSelectionChange: (updater)=>{
                    setRowSelection((prev)=>updater instanceof Function ? updater(prev) : updater);
                    queueMicrotask(rerender); //hack to rerender after state update
                },
                initialState: {
                    showGlobalFilter: true,
                    density: "compact"
                },
                state: {
                    rowSelection: rowSelection,
                    isLoading: isLoading,
                    showProgressBars: isFetching,
                    columnPinning: {
                        right: [],
                        left: [
                            'mrt-row-actions'
                        ]
                    }
                },
                tableInstanceRef: tableInstanceRef,
                displayColumnDefOptions: {
                    "mrt-row-actions": {
                        Header: "",
                        size: 100
                    }
                },
                positionToolbarAlertBanner: "top",
                muiTableBodyProps: {
                    sx: ()=>({
                            "& tr:nth-of-type(odd)": {
                                backgroundColor: "#8578741A"
                            }
                        })
                },
                positionActionsColumn: "first",
                renderRowActionMenuItems: ({ closeMenu: closeMenu, row: row, table: table })=>{
                    if (row.index !== 0) return [
                        // Removed the "Edit" MenuItem
                        /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                // TODO: Implement delete assumption
                                deleteScenarioAssumptions.mutate((0, $3f6d11e40c5bf4ae$export$6ba823b57a6ac27d)(scenarioID, "deleting", {
                                    ProjectTypeID: row.original.ProjectTypeID
                                }));
                                closeMenu();
                            },
                            sx: {
                                m: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ca6909be4938645f$exports))), {})
                                }),
                                "Delete"
                            ]
                        }, 1),
                        /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                // TODO: Implement restore assumption
                                closeMenu();
                            },
                            sx: {
                                m: 0
                            },
                            disabled: true,
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $285566490a7f0efe$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c3532d91f35b9323$exports))), {})
                                }),
                                "Restore"
                            ]
                        }, 2)
                    ];
                    else {
                        closeMenu();
                        return [];
                    }
                },
                renderToolbarInternalActions: ({ table: table })=>// render an empty action are to disable the duplicated actions(full screen etc.)
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30615b8e57e39efe$export$292cb709c1b05af0), {
                            table: table
                        })
                    }),
                renderBottomToolbarCustomActions: ({})=>{
                    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            gap: "0.5rem",
                            p: 2,
                            justifyContent: "flex-end",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                onClick: ()=>onTabChange(1),
                                variant: "contained",
                                startIcon: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($188d7627f9b29063$exports))), {}),
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                onClick: ()=>onTabChange(3),
                                variant: "contained",
                                children: "Generate scenario"
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $cb5da3f6a29dba2f$export$2e2bcd8739ae039), {
                // @ts-ignore
                open: isAddAssumptionModalOpen,
                onClose: ()=>setIsAddAssumptionModalOpen(false),
                onSubmit: handleCreateNewRowModal,
                AllLists: AllLists
            })
        ]
    });
};
var $ebb8bf80ce283ad5$export$2e2bcd8739ae039 = $ebb8bf80ce283ad5$var$ProjectPhasingV2;



var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");




const $1216c409b323533b$export$a36e869317470581 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetEscalation (
        $inScenarioID: UUID!
    ){
        executeGetEscalation(
            inScenarioID: $inScenarioID
        ) {
            AnnualEscalation
        }
    }
`;
const $1216c409b323533b$export$cd4486fddd99b766 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteUpdateEscalation (
        $inScenarioID: UUID!
        $inEscalation: String!
    ){
        executeUpdateEscalation(
            inScenarioID: $inScenarioID
            inEscalation: $inEscalation
        ) {
            result
        }
    }
`;





const $3a5bf28a94785a8b$var$EscalationRate = ({ onTabChange: onTabChange, scenarioID: scenarioID })=>{
    const [escalationRate, setEscalationRate] = (0, $i5lfL.useState)("");
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const client = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)();
    const handleEscalationRateChange = (event)=>{
        if ((0, $658384a585644311$export$dc0451bacb093840).test(event.target.value)) setEscalationRate(event.target.value);
    };
    const handleGenerateScenario = ()=>{
        // save escalation rate
        updateEscalation.mutate({
            inScenarioID: scenarioID,
            inEscalation: escalationRate
        });
        onTabChange(3);
    };
    // react-query to fetch escalation rate
    const { data: data, isFetching: isFetching } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "escalationRate"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $1216c409b323533b$export$a36e869317470581),
                variables: {
                    inScenarioID: scenarioID
                },
                instance: instance,
                accounts: accounts
            });
        },
        cacheTime: Infinity,
        onSuccess: (data)=>{
            //@ts-ignore
            if (data.executeGetEscalation.length > 0 && data.executeGetEscalation[0].AnnualEscalation) //@ts-ignore
            setEscalationRate(data.executeGetEscalation[0].AnnualEscalation);
        }
    });
    const updateEscalation = (0, $d5a0a75b5a6b57e1$export$609860bf8b0084c)([
        "updateEscalation"
    ], {
        mutationFn: (variables)=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $1216c409b323533b$export$cd4486fddd99b766),
                variables: variables,
                instance: instance,
                accounts: accounts
            });
        },
        onSuccess: ()=>{
            client.invalidateQueries([
                "escalationRate"
            ]);
        }
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                p: 1,
                sx: {
                    minHeight: "50vh"
                },
                children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: [
                                (0, $d29d6d1034e01aa1$export$44e44024e31d74b),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                                (0, $d29d6d1034e01aa1$export$b1dd8533582027e5)
                            ]
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            item: true,
                            children: "Delta Escalation"
                        }),
                        !isFetching ? /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            item: true,
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                    id: "escalation-input",
                                    value: escalationRate,
                                    onChange: handleEscalationRateChange,
                                    sx: {
                                        width: 70,
                                        height: '30px',
                                        // Adjust the height as needed
                                        '& .MuiInputBase-root': {
                                            height: '30px',
                                            fontSize: '0.875rem'
                                        },
                                        mr: 1
                                    },
                                    size: "small"
                                }),
                                "%"
                            ]
                        }) : /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            item: true,
                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $7b73eaf87a610891$export$2e2bcd8739ae039), {
                                variant: "text",
                                width: 70,
                                height: "30px"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    justifyContent: "flex-end"
                },
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                    variant: "contained",
                    onClick: handleGenerateScenario,
                    children: "Generate scenario"
                })
            })
        ]
    });
};
var $3a5bf28a94785a8b$export$2e2bcd8739ae039 = $3a5bf28a94785a8b$var$EscalationRate;


function $cf890d33f84e8055$var$TabPanel(props) {
    const { children: children, value: value, index: index, ...other } = props;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        role: "tabpanel",
        className: "tabPanelBox",
        hidden: value !== index,
        id: `simple-tabpanel-${index}`,
        "aria-labelledby": `simple-tab-${index}`,
        ...other,
        children: value === index && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
            className: "tabBox",
            sx: {
                p: 3
            },
            children: children
        })
    });
}
function $cf890d33f84e8055$var$a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`
    };
}
function $cf890d33f84e8055$export$2e2bcd8739ae039(props) {
    const { setTabIndex: setTabIndex, scenarioID: scenarioID, runModel: runModel } = props;
    const [subTabIndex, setSubTabIndex] = $i5lfL.useState(0);
    const handleChange = (event, newValue)=>{
        setSubTabIndex(newValue);
    };
    function handleUpdateTab(index) {
        runModel();
        setTabIndex(index);
    }
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                className: "tabSelectorBox",
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $bd3cee31033a2ffb$export$2e2bcd8739ae039), {
                    value: subTabIndex,
                    onChange: handleChange,
                    indicatorColor: "secondary",
                    textColor: "inherit",
                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                        label: "Project Phase",
                        ...$cf890d33f84e8055$var$a11yProps(0)
                    })
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)($cf890d33f84e8055$var$TabPanel, {
                value: subTabIndex,
                index: 0,
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $ebb8bf80ce283ad5$export$2e2bcd8739ae039), {
                    scenarioID: scenarioID,
                    onTabChange: handleUpdateTab
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)($cf890d33f84e8055$var$TabPanel, {
                value: subTabIndex,
                index: 1,
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3a5bf28a94785a8b$export$2e2bcd8739ae039), {
                    onTabChange: handleUpdateTab,
                    scenarioID: scenarioID
                })
            })
        ]
    });
}


// noinspection GraphQLUnresolvedReference
/*
 * Copyright (c) 2023. RoZetta Technology Pty Ltd. All rights reserved.
 */ 
var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");




/*!
 * Chart.js v4.4.6
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.4.6
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */ function $049f27524fb0d7ff$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $049f27524fb0d7ff$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $049f27524fb0d7ff$export$bcc6e673dfa14d36(v) {
    return $049f27524fb0d7ff$export$837ba5c449269406($049f27524fb0d7ff$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $049f27524fb0d7ff$export$869b26d4e1bbdb63(v) {
    return $049f27524fb0d7ff$export$837ba5c449269406($049f27524fb0d7ff$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $049f27524fb0d7ff$export$ed9bd8dcaeba14f6(v) {
    return $049f27524fb0d7ff$export$837ba5c449269406($049f27524fb0d7ff$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $049f27524fb0d7ff$export$dbf961a8d278dbef(v) {
    return $049f27524fb0d7ff$export$837ba5c449269406($049f27524fb0d7ff$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $049f27524fb0d7ff$export$aa35ef1f24408ab9(v) {
    return $049f27524fb0d7ff$export$837ba5c449269406($049f27524fb0d7ff$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $049f27524fb0d7ff$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $049f27524fb0d7ff$var$hex = [
    ...'0123456789ABCDEF'
];
const $049f27524fb0d7ff$var$h1 = (b)=>$049f27524fb0d7ff$var$hex[b & 0xF];
const $049f27524fb0d7ff$var$h2 = (b)=>$049f27524fb0d7ff$var$hex[(b & 0xF0) >> 4] + $049f27524fb0d7ff$var$hex[b & 0xF];
const $049f27524fb0d7ff$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $049f27524fb0d7ff$var$isShort = (v)=>$049f27524fb0d7ff$var$eq(v.r) && $049f27524fb0d7ff$var$eq(v.g) && $049f27524fb0d7ff$var$eq(v.b) && $049f27524fb0d7ff$var$eq(v.a);
function $049f27524fb0d7ff$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $049f27524fb0d7ff$var$map$1[str[1]] * 17,
            g: 255 & $049f27524fb0d7ff$var$map$1[str[2]] * 17,
            b: 255 & $049f27524fb0d7ff$var$map$1[str[3]] * 17,
            a: len === 5 ? $049f27524fb0d7ff$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $049f27524fb0d7ff$var$map$1[str[1]] << 4 | $049f27524fb0d7ff$var$map$1[str[2]],
            g: $049f27524fb0d7ff$var$map$1[str[3]] << 4 | $049f27524fb0d7ff$var$map$1[str[4]],
            b: $049f27524fb0d7ff$var$map$1[str[5]] << 4 | $049f27524fb0d7ff$var$map$1[str[6]],
            a: len === 9 ? $049f27524fb0d7ff$var$map$1[str[7]] << 4 | $049f27524fb0d7ff$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $049f27524fb0d7ff$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $049f27524fb0d7ff$export$1b06654353ef9f67(v) {
    var f = $049f27524fb0d7ff$var$isShort(v) ? $049f27524fb0d7ff$var$h1 : $049f27524fb0d7ff$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $049f27524fb0d7ff$var$alpha(v.a, f) : undefined;
}
const $049f27524fb0d7ff$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $049f27524fb0d7ff$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $049f27524fb0d7ff$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $049f27524fb0d7ff$var$hwb2rgbn(h, w, b) {
    const rgb = $049f27524fb0d7ff$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $049f27524fb0d7ff$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $049f27524fb0d7ff$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $049f27524fb0d7ff$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $049f27524fb0d7ff$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($049f27524fb0d7ff$export$ed9bd8dcaeba14f6);
}
function $049f27524fb0d7ff$export$4c15bd42559b811d(h, s, l) {
    return $049f27524fb0d7ff$var$calln($049f27524fb0d7ff$var$hsl2rgbn, h, s, l);
}
function $049f27524fb0d7ff$export$e2710022c70fc9ee(h, w, b) {
    return $049f27524fb0d7ff$var$calln($049f27524fb0d7ff$var$hwb2rgbn, h, w, b);
}
function $049f27524fb0d7ff$export$b785a357c84e4a04(h, s, v) {
    return $049f27524fb0d7ff$var$calln($049f27524fb0d7ff$var$hsv2rgbn, h, s, v);
}
function $049f27524fb0d7ff$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $049f27524fb0d7ff$export$5e91288c399be4f9(str) {
    const m = $049f27524fb0d7ff$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $049f27524fb0d7ff$export$bcc6e673dfa14d36(+m[5]) : $049f27524fb0d7ff$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $049f27524fb0d7ff$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $049f27524fb0d7ff$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $049f27524fb0d7ff$export$b785a357c84e4a04(h, p1, p2);
    else v = $049f27524fb0d7ff$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $049f27524fb0d7ff$export$bb628a54ab399bc9(v, deg) {
    var h = $049f27524fb0d7ff$export$b5ba70b240f8f7f(v);
    h[0] = $049f27524fb0d7ff$var$hue(h[0] + deg);
    h = $049f27524fb0d7ff$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $049f27524fb0d7ff$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $049f27524fb0d7ff$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $049f27524fb0d7ff$export$aa35ef1f24408ab9(a[1]);
    const l = $049f27524fb0d7ff$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$049f27524fb0d7ff$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $049f27524fb0d7ff$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $049f27524fb0d7ff$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $049f27524fb0d7ff$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($049f27524fb0d7ff$var$names$1);
    const tkeys = Object.keys($049f27524fb0d7ff$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $049f27524fb0d7ff$var$map[k]);
        }
        k = parseInt($049f27524fb0d7ff$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $049f27524fb0d7ff$var$names;
function $049f27524fb0d7ff$export$b2f06b640faad956(str) {
    if (!$049f27524fb0d7ff$var$names) {
        $049f27524fb0d7ff$var$names = $049f27524fb0d7ff$var$unpack();
        $049f27524fb0d7ff$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $049f27524fb0d7ff$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $049f27524fb0d7ff$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $049f27524fb0d7ff$export$91aedb20f296e541(str) {
    const m = $049f27524fb0d7ff$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $049f27524fb0d7ff$export$bcc6e673dfa14d36(v) : $049f27524fb0d7ff$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $049f27524fb0d7ff$export$bcc6e673dfa14d36(r) : $049f27524fb0d7ff$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $049f27524fb0d7ff$export$bcc6e673dfa14d36(g) : $049f27524fb0d7ff$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $049f27524fb0d7ff$export$bcc6e673dfa14d36(b) : $049f27524fb0d7ff$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $049f27524fb0d7ff$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$049f27524fb0d7ff$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $049f27524fb0d7ff$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $049f27524fb0d7ff$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $049f27524fb0d7ff$var$interpolate(rgb1, rgb2, t) {
    const r = $049f27524fb0d7ff$var$from($049f27524fb0d7ff$export$dbf961a8d278dbef(rgb1.r));
    const g = $049f27524fb0d7ff$var$from($049f27524fb0d7ff$export$dbf961a8d278dbef(rgb1.g));
    const b = $049f27524fb0d7ff$var$from($049f27524fb0d7ff$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $049f27524fb0d7ff$export$ed9bd8dcaeba14f6($049f27524fb0d7ff$var$to(r + t * ($049f27524fb0d7ff$var$from($049f27524fb0d7ff$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $049f27524fb0d7ff$export$ed9bd8dcaeba14f6($049f27524fb0d7ff$var$to(g + t * ($049f27524fb0d7ff$var$from($049f27524fb0d7ff$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $049f27524fb0d7ff$export$ed9bd8dcaeba14f6($049f27524fb0d7ff$var$to(b + t * ($049f27524fb0d7ff$var$from($049f27524fb0d7ff$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $049f27524fb0d7ff$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $049f27524fb0d7ff$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $049f27524fb0d7ff$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $049f27524fb0d7ff$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $049f27524fb0d7ff$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $049f27524fb0d7ff$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $049f27524fb0d7ff$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $049f27524fb0d7ff$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $049f27524fb0d7ff$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $049f27524fb0d7ff$export$91aedb20f296e541(str);
    return $049f27524fb0d7ff$export$5e91288c399be4f9(str);
}
class $049f27524fb0d7ff$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $049f27524fb0d7ff$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $049f27524fb0d7ff$var$fromObject(input);
        else if (type === 'string') v = $049f27524fb0d7ff$export$625a38b961e8b5e9(input) || $049f27524fb0d7ff$export$b2f06b640faad956(input) || $049f27524fb0d7ff$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $049f27524fb0d7ff$var$clone(this._rgb);
        if (v) v.a = $049f27524fb0d7ff$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $049f27524fb0d7ff$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $049f27524fb0d7ff$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $049f27524fb0d7ff$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $049f27524fb0d7ff$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $049f27524fb0d7ff$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $049f27524fb0d7ff$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $049f27524fb0d7ff$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $049f27524fb0d7ff$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $049f27524fb0d7ff$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $049f27524fb0d7ff$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $049f27524fb0d7ff$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $049f27524fb0d7ff$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $049f27524fb0d7ff$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $049f27524fb0d7ff$export$2e2bcd8739ae039(input) {
    return new $049f27524fb0d7ff$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $054bf7af52f034b6$export$cf2f7c5792f80b46() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $054bf7af52f034b6$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $054bf7af52f034b6$export$342063e11d6c3cad(value) {
    return value === null || typeof value === 'undefined';
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $054bf7af52f034b6$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $054bf7af52f034b6$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $054bf7af52f034b6$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $054bf7af52f034b6$export$c4ce752e73470fba(value, defaultValue) {
    return $054bf7af52f034b6$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $054bf7af52f034b6$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $054bf7af52f034b6$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $054bf7af52f034b6$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $054bf7af52f034b6$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $054bf7af52f034b6$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($054bf7af52f034b6$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($054bf7af52f034b6$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $054bf7af52f034b6$export$995eb9fca571757(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $054bf7af52f034b6$export$d377dcb2b61d6c4e(source) {
    if ($054bf7af52f034b6$export$8b22cf2602fb60ce(source)) return source.map($054bf7af52f034b6$export$d377dcb2b61d6c4e);
    if ($054bf7af52f034b6$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $054bf7af52f034b6$export$d377dcb2b61d6c4e(source[keys[k]]);
        return target;
    }
    return source;
}
function $054bf7af52f034b6$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $054bf7af52f034b6$export$667d3bf0c5f83305(key, target, source, options) {
    if (!$054bf7af52f034b6$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($054bf7af52f034b6$export$23f2a1d2818174ef(tval) && $054bf7af52f034b6$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $054bf7af52f034b6$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $054bf7af52f034b6$export$d377dcb2b61d6c4e(sval);
}
function $054bf7af52f034b6$export$efca4cbe5dd06740(target, source, options) {
    const sources = $054bf7af52f034b6$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$054bf7af52f034b6$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $054bf7af52f034b6$export$667d3bf0c5f83305;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$054bf7af52f034b6$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $054bf7af52f034b6$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $054bf7af52f034b6$export$efca4cbe5dd06740(target, source, {
        merger: $054bf7af52f034b6$export$317a3d46287192d8
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $054bf7af52f034b6$export$317a3d46287192d8(key, target, source) {
    if (!$054bf7af52f034b6$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($054bf7af52f034b6$export$23f2a1d2818174ef(tval) && $054bf7af52f034b6$export$23f2a1d2818174ef(sval)) $054bf7af52f034b6$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $054bf7af52f034b6$export$d377dcb2b61d6c4e(sval);
}
/**
 * @private
 */ function $054bf7af52f034b6$export$1ee57be6f6687d2c(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $054bf7af52f034b6$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $054bf7af52f034b6$export$9d0e2d13d04f7070(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $054bf7af52f034b6$var$_getKeyResolver(key) {
    const keys = $054bf7af52f034b6$export$9d0e2d13d04f7070(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $054bf7af52f034b6$export$2d1720544b23b823(obj, key) {
    const resolver = $054bf7af52f034b6$var$keyResolvers[key] || ($054bf7af52f034b6$var$keyResolvers[key] = $054bf7af52f034b6$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $054bf7af52f034b6$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $054bf7af52f034b6$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $054bf7af52f034b6$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $054bf7af52f034b6$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $054bf7af52f034b6$export$f38c853ae54ed474(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $054bf7af52f034b6$export$56c0d5a1e737357d = Math.PI;
const $054bf7af52f034b6$export$971d5caa766a69d7 = 2 * $054bf7af52f034b6$export$56c0d5a1e737357d;
const $054bf7af52f034b6$export$d29e374196577086 = $054bf7af52f034b6$export$971d5caa766a69d7 + $054bf7af52f034b6$export$56c0d5a1e737357d;
const $054bf7af52f034b6$export$2ec5befb9e6c97d4 = Number.POSITIVE_INFINITY;
const $054bf7af52f034b6$export$53c86fa97d611818 = $054bf7af52f034b6$export$56c0d5a1e737357d / 180;
const $054bf7af52f034b6$export$7f8ddf7c7c20b3cd = $054bf7af52f034b6$export$56c0d5a1e737357d / 2;
const $054bf7af52f034b6$export$39c1cc7c062529d4 = $054bf7af52f034b6$export$56c0d5a1e737357d / 4;
const $054bf7af52f034b6$export$7a0bdf7d4a91ea88 = $054bf7af52f034b6$export$56c0d5a1e737357d * 2 / 3;
const $054bf7af52f034b6$export$9f4f30ee63539e24 = Math.log10;
const $054bf7af52f034b6$export$2408f22a0fab9ae5 = Math.sign;
function $054bf7af52f034b6$export$a05254e7c3aeba6e(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $054bf7af52f034b6$export$a33b77bbdbb8366c(range) {
    const roundedRange = Math.round(range);
    range = $054bf7af52f034b6$export$a05254e7c3aeba6e(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($054bf7af52f034b6$export$9f4f30ee63539e24(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $054bf7af52f034b6$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $054bf7af52f034b6$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $054bf7af52f034b6$export$b9a6b53f9be3734(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $054bf7af52f034b6$export$53a70dd1ebbae346(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $054bf7af52f034b6$export$625550452a3fa3ec(degrees) {
    return degrees * ($054bf7af52f034b6$export$56c0d5a1e737357d / 180);
}
function $054bf7af52f034b6$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $054bf7af52f034b6$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $054bf7af52f034b6$export$23ebac1979863676(x) {
    if (!$054bf7af52f034b6$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $054bf7af52f034b6$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $054bf7af52f034b6$export$56c0d5a1e737357d) angle += $054bf7af52f034b6$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $054bf7af52f034b6$export$158acd800e1ef08b(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $054bf7af52f034b6$export$c18d01048907ea92(a, b) {
    return (a - b + $054bf7af52f034b6$export$d29e374196577086) % $054bf7af52f034b6$export$971d5caa766a69d7 - $054bf7af52f034b6$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $054bf7af52f034b6$export$28f7fcd39efa255(a) {
    return (a % $054bf7af52f034b6$export$971d5caa766a69d7 + $054bf7af52f034b6$export$971d5caa766a69d7) % $054bf7af52f034b6$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $054bf7af52f034b6$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $054bf7af52f034b6$export$28f7fcd39efa255(angle);
    const s = $054bf7af52f034b6$export$28f7fcd39efa255(start);
    const e = $054bf7af52f034b6$export$28f7fcd39efa255(end);
    const angleToStart = $054bf7af52f034b6$export$28f7fcd39efa255(s - a);
    const angleToEnd = $054bf7af52f034b6$export$28f7fcd39efa255(e - a);
    const startToAngle = $054bf7af52f034b6$export$28f7fcd39efa255(a - s);
    const endToAngle = $054bf7af52f034b6$export$28f7fcd39efa255(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $054bf7af52f034b6$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $054bf7af52f034b6$export$71cec2538cb2c617(value) {
    return $054bf7af52f034b6$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $054bf7af52f034b6$export$3b513254972cfc9c(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $054bf7af52f034b6$export$2ed0fc6709e59212(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $054bf7af52f034b6$export$ef35774e6d314e91 = (table, key, value, last)=>$054bf7af52f034b6$export$2ed0fc6709e59212(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $054bf7af52f034b6$export$ebd11618f299a286 = (table, key, value)=>$054bf7af52f034b6$export$2ed0fc6709e59212(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $054bf7af52f034b6$export$c03999cb2f36933f(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $054bf7af52f034b6$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $054bf7af52f034b6$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $054bf7af52f034b6$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $054bf7af52f034b6$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $054bf7af52f034b6$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $054bf7af52f034b6$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $054bf7af52f034b6$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $054bf7af52f034b6$export$fef3dfd9bad05307(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $054bf7af52f034b6$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $054bf7af52f034b6$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $054bf7af52f034b6$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $054bf7af52f034b6$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $054bf7af52f034b6$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $054bf7af52f034b6$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $054bf7af52f034b6$export$9d398bebfec1c039 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $054bf7af52f034b6$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $054bf7af52f034b6$export$25ce5a424b770e84(Math.min($054bf7af52f034b6$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $054bf7af52f034b6$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $054bf7af52f034b6$export$25ce5a424b770e84(Math.max($054bf7af52f034b6$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $054bf7af52f034b6$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $054bf7af52f034b6$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $054bf7af52f034b6$var$atEdge = (t)=>t === 0 || t === 1;
const $054bf7af52f034b6$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $054bf7af52f034b6$export$971d5caa766a69d7 / p));
const $054bf7af52f034b6$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $054bf7af52f034b6$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $054bf7af52f034b6$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $054bf7af52f034b6$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $054bf7af52f034b6$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($054bf7af52f034b6$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$054bf7af52f034b6$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$054bf7af52f034b6$var$atEdge(t) ? t : $054bf7af52f034b6$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$054bf7af52f034b6$var$atEdge(t) ? t : $054bf7af52f034b6$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $054bf7af52f034b6$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $054bf7af52f034b6$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $054bf7af52f034b6$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $054bf7af52f034b6$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $054bf7af52f034b6$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $054bf7af52f034b6$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $054bf7af52f034b6$export$f96d196f7728bb5(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $054bf7af52f034b6$export$db3b6bfb95261072(value) {
    return $054bf7af52f034b6$export$f96d196f7728bb5(value) ? value : new (0, $049f27524fb0d7ff$export$892596cec99bc70e)(value);
}
function $054bf7af52f034b6$export$738ab4df8bf92ae9(value) {
    return $054bf7af52f034b6$export$f96d196f7728bb5(value) ? value : new (0, $049f27524fb0d7ff$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $054bf7af52f034b6$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $054bf7af52f034b6$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $054bf7af52f034b6$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $054bf7af52f034b6$var$colors
        },
        numbers: {
            type: 'number',
            properties: $054bf7af52f034b6$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $054bf7af52f034b6$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $054bf7af52f034b6$var$intlCache = new Map();
function $054bf7af52f034b6$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $054bf7af52f034b6$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $054bf7af52f034b6$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $054bf7af52f034b6$export$ae1af26003f05816(num, locale, options) {
    return $054bf7af52f034b6$var$getNumberFormat(locale, options).format(num);
}
const $054bf7af52f034b6$var$formatters = {
    values (value) {
        return $054bf7af52f034b6$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $054bf7af52f034b6$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $054bf7af52f034b6$export$9f4f30ee63539e24(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $054bf7af52f034b6$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($054bf7af52f034b6$export$9f4f30ee63539e24(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $054bf7af52f034b6$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $054bf7af52f034b6$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $054bf7af52f034b6$export$91477dc880baac21 = {
    formatters: $054bf7af52f034b6$var$formatters
};
function $054bf7af52f034b6$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $054bf7af52f034b6$export$91477dc880baac21.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $054bf7af52f034b6$export$6559d589eb85fbb6 = Object.create(null);
const $054bf7af52f034b6$export$2e2af4578d910ddf = Object.create(null);
function $054bf7af52f034b6$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $054bf7af52f034b6$var$set(root, scope, values) {
    if (typeof scope === 'string') return $054bf7af52f034b6$export$efca4cbe5dd06740($054bf7af52f034b6$var$getScope$1(root, scope), values);
    return $054bf7af52f034b6$export$efca4cbe5dd06740($054bf7af52f034b6$var$getScope$1(root, ''), scope);
}
class $054bf7af52f034b6$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$054bf7af52f034b6$export$738ab4df8bf92ae9(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$054bf7af52f034b6$export$738ab4df8bf92ae9(options.borderColor);
        this.hoverColor = (ctx, options)=>$054bf7af52f034b6$export$738ab4df8bf92ae9(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $054bf7af52f034b6$var$set(this, scope, values);
    }
    get(scope) {
        return $054bf7af52f034b6$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $054bf7af52f034b6$var$set($054bf7af52f034b6$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $054bf7af52f034b6$var$set($054bf7af52f034b6$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $054bf7af52f034b6$var$getScope$1(this, scope);
        const targetScopeObject = $054bf7af52f034b6$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($054bf7af52f034b6$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $054bf7af52f034b6$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $054bf7af52f034b6$export$4368d992c4eafac0 = /* #__PURE__ */ new $054bf7af52f034b6$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $054bf7af52f034b6$var$applyAnimationsDefaults,
    $054bf7af52f034b6$var$applyLayoutsDefaults,
    $054bf7af52f034b6$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $054bf7af52f034b6$export$1a8f5705751d8277(font) {
    if (!font || $054bf7af52f034b6$export$342063e11d6c3cad(font.size) || $054bf7af52f034b6$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $054bf7af52f034b6$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $054bf7af52f034b6$export$faec65b429be379(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$054bf7af52f034b6$export$8b22cf2602fb60ce(thing)) longest = $054bf7af52f034b6$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($054bf7af52f034b6$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$054bf7af52f034b6$export$8b22cf2602fb60ce(nestedThing)) longest = $054bf7af52f034b6$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $054bf7af52f034b6$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $054bf7af52f034b6$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $054bf7af52f034b6$export$493d36ec626b6698(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $054bf7af52f034b6$export$24baa2b76016ce0e(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $054bf7af52f034b6$export$24baa2b76016ce0e(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $054bf7af52f034b6$export$53c86fa97d611818;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $054bf7af52f034b6$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $054bf7af52f034b6$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $054bf7af52f034b6$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $054bf7af52f034b6$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $054bf7af52f034b6$export$39c1cc7c062529d4) * size;
            xOffsetW = Math.cos(rad + $054bf7af52f034b6$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $054bf7af52f034b6$export$39c1cc7c062529d4) * size;
            yOffsetW = Math.sin(rad + $054bf7af52f034b6$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $054bf7af52f034b6$export$56c0d5a1e737357d, rad - $054bf7af52f034b6$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $054bf7af52f034b6$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $054bf7af52f034b6$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $054bf7af52f034b6$export$7f8ddf7c7c20b3cd, rad + $054bf7af52f034b6$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $054bf7af52f034b6$export$39c1cc7c062529d4;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $054bf7af52f034b6$export$39c1cc7c062529d4;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $054bf7af52f034b6$export$39c1cc7c062529d4;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $054bf7af52f034b6$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $054bf7af52f034b6$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $054bf7af52f034b6$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $054bf7af52f034b6$export$d24c54395ce0c509(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $054bf7af52f034b6$export$6554612db691658e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $054bf7af52f034b6$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$054bf7af52f034b6$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $054bf7af52f034b6$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $054bf7af52f034b6$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $054bf7af52f034b6$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $054bf7af52f034b6$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $054bf7af52f034b6$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $054bf7af52f034b6$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$054bf7af52f034b6$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $054bf7af52f034b6$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $054bf7af52f034b6$export$1fbe638ecf81657e(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $054bf7af52f034b6$export$56c0d5a1e737357d, $054bf7af52f034b6$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $054bf7af52f034b6$export$56c0d5a1e737357d, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$054bf7af52f034b6$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $054bf7af52f034b6$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $054bf7af52f034b6$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $054bf7af52f034b6$export$8c78c7c36408ea29(value, size) {
    const matches = ('' + value).match($054bf7af52f034b6$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $054bf7af52f034b6$var$numberOrZero = (v)=>+v || 0;
function $054bf7af52f034b6$export$21579262ef46735b(value, props) {
    const ret = {};
    const objProps = $054bf7af52f034b6$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $054bf7af52f034b6$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$054bf7af52f034b6$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $054bf7af52f034b6$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $054bf7af52f034b6$export$d66dc83d8cfc8dd(value) {
    return $054bf7af52f034b6$export$21579262ef46735b(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $054bf7af52f034b6$export$92108d983e8ee699(value) {
    return $054bf7af52f034b6$export$21579262ef46735b(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $054bf7af52f034b6$export$a9c23c6ac3fc3eca(value) {
    const obj = $054bf7af52f034b6$export$d66dc83d8cfc8dd(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $054bf7af52f034b6$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $054bf7af52f034b6$export$4368d992c4eafac0.font;
    let size = $054bf7af52f034b6$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $054bf7af52f034b6$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($054bf7af52f034b6$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $054bf7af52f034b6$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $054bf7af52f034b6$export$8c78c7c36408ea29($054bf7af52f034b6$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $054bf7af52f034b6$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $054bf7af52f034b6$export$1a8f5705751d8277(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $054bf7af52f034b6$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $054bf7af52f034b6$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $054bf7af52f034b6$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $054bf7af52f034b6$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $054bf7af52f034b6$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $054bf7af52f034b6$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $054bf7af52f034b6$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$054bf7af52f034b6$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $054bf7af52f034b6$var$_cached(target, prop, ()=>$054bf7af52f034b6$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $054bf7af52f034b6$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $054bf7af52f034b6$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $054bf7af52f034b6$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $054bf7af52f034b6$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$054bf7af52f034b6$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$054bf7af52f034b6$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $054bf7af52f034b6$var$_cached(target, prop, ()=>$054bf7af52f034b6$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $054bf7af52f034b6$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $054bf7af52f034b6$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $054bf7af52f034b6$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $054bf7af52f034b6$var$readKey = (prefix, name)=>prefix ? prefix + $054bf7af52f034b6$export$a8550f7dbe79f93a(name) : name;
const $054bf7af52f034b6$var$needsSubResolver = (prop, value)=>$054bf7af52f034b6$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $054bf7af52f034b6$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $054bf7af52f034b6$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($054bf7af52f034b6$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $054bf7af52f034b6$var$_resolveScriptable(prop, value, target, receiver);
    if ($054bf7af52f034b6$export$8b22cf2602fb60ce(value) && value.length) value = $054bf7af52f034b6$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($054bf7af52f034b6$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $054bf7af52f034b6$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $054bf7af52f034b6$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($054bf7af52f034b6$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $054bf7af52f034b6$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $054bf7af52f034b6$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($054bf7af52f034b6$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $054bf7af52f034b6$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($054bf7af52f034b6$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $054bf7af52f034b6$var$resolveFallback(fallback, prop, value) {
    return $054bf7af52f034b6$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $054bf7af52f034b6$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $054bf7af52f034b6$export$2d1720544b23b823(parent, key) : undefined;
function $054bf7af52f034b6$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $054bf7af52f034b6$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $054bf7af52f034b6$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $054bf7af52f034b6$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $054bf7af52f034b6$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $054bf7af52f034b6$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $054bf7af52f034b6$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $054bf7af52f034b6$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$054bf7af52f034b6$var$subGetTarget(resolver, prop, value));
}
function $054bf7af52f034b6$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $054bf7af52f034b6$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $054bf7af52f034b6$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($054bf7af52f034b6$export$8b22cf2602fb60ce(target) && $054bf7af52f034b6$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $054bf7af52f034b6$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $054bf7af52f034b6$var$_resolve($054bf7af52f034b6$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $054bf7af52f034b6$var$needsSubResolver(prop, value) ? $054bf7af52f034b6$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $054bf7af52f034b6$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $054bf7af52f034b6$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $054bf7af52f034b6$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $054bf7af52f034b6$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $054bf7af52f034b6$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($054bf7af52f034b6$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $054bf7af52f034b6$var$EPSILON = Number.EPSILON || 1e-14;
const $054bf7af52f034b6$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $054bf7af52f034b6$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $054bf7af52f034b6$export$e171bab687b50e0(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $054bf7af52f034b6$export$158acd800e1ef08b(current, previous);
    const d12 = $054bf7af52f034b6$export$158acd800e1ef08b(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $054bf7af52f034b6$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $054bf7af52f034b6$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $054bf7af52f034b6$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($054bf7af52f034b6$export$a05254e7c3aeba6e(deltaK[i], 0, $054bf7af52f034b6$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $054bf7af52f034b6$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $054bf7af52f034b6$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $054bf7af52f034b6$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $054bf7af52f034b6$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $054bf7af52f034b6$export$527e9aa3390079e9(points, indexAxis = 'x') {
    const valueAxis = $054bf7af52f034b6$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $054bf7af52f034b6$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $054bf7af52f034b6$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $054bf7af52f034b6$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $054bf7af52f034b6$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $054bf7af52f034b6$var$monotoneAdjust(points, deltaK, mK);
    $054bf7af52f034b6$var$monotoneCompute(points, mK, indexAxis);
}
function $054bf7af52f034b6$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $054bf7af52f034b6$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $054bf7af52f034b6$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $054bf7af52f034b6$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $054bf7af52f034b6$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $054bf7af52f034b6$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $054bf7af52f034b6$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $054bf7af52f034b6$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $054bf7af52f034b6$export$ab83b03e4111b1d0(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $054bf7af52f034b6$export$527e9aa3390079e9(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $054bf7af52f034b6$export$e171bab687b50e0(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $054bf7af52f034b6$var$capBezierPoints(points, area);
}
/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
 * @private
 */ function $054bf7af52f034b6$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $054bf7af52f034b6$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $054bf7af52f034b6$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $054bf7af52f034b6$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $054bf7af52f034b6$export$a17c37559e1db147(el, property) {
    return $054bf7af52f034b6$var$getComputedStyle(el).getPropertyValue(property);
}
const $054bf7af52f034b6$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $054bf7af52f034b6$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $054bf7af52f034b6$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $054bf7af52f034b6$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $054bf7af52f034b6$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($054bf7af52f034b6$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $054bf7af52f034b6$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $054bf7af52f034b6$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $054bf7af52f034b6$var$getPositionedStyle(style, 'padding');
    const borders = $054bf7af52f034b6$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $054bf7af52f034b6$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $054bf7af52f034b6$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $054bf7af52f034b6$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $054bf7af52f034b6$var$getComputedStyle(container);
            const containerBorder = $054bf7af52f034b6$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $054bf7af52f034b6$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $054bf7af52f034b6$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $054bf7af52f034b6$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $054bf7af52f034b6$export$2ec5befb9e6c97d4,
        maxHeight: maxHeight || $054bf7af52f034b6$export$2ec5befb9e6c97d4
    };
}
const $054bf7af52f034b6$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $054bf7af52f034b6$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $054bf7af52f034b6$var$getComputedStyle(canvas);
    const margins = $054bf7af52f034b6$var$getPositionedStyle(style, 'margin');
    const maxWidth = $054bf7af52f034b6$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $054bf7af52f034b6$export$2ec5befb9e6c97d4;
    const maxHeight = $054bf7af52f034b6$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $054bf7af52f034b6$export$2ec5befb9e6c97d4;
    const containerSize = $054bf7af52f034b6$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $054bf7af52f034b6$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $054bf7af52f034b6$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $054bf7af52f034b6$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $054bf7af52f034b6$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $054bf7af52f034b6$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $054bf7af52f034b6$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $054bf7af52f034b6$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $054bf7af52f034b6$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($054bf7af52f034b6$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $054bf7af52f034b6$export$b4171a6734a65d42(element, property) {
    const value = $054bf7af52f034b6$export$a17c37559e1db147(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $054bf7af52f034b6$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $054bf7af52f034b6$export$7a38258bbe170828(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $054bf7af52f034b6$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $054bf7af52f034b6$export$8a5498727ef6be21(p1, cp1, t);
    const b = $054bf7af52f034b6$export$8a5498727ef6be21(cp1, cp2, t);
    const c = $054bf7af52f034b6$export$8a5498727ef6be21(cp2, p2, t);
    const d = $054bf7af52f034b6$export$8a5498727ef6be21(a, b, t);
    const e = $054bf7af52f034b6$export$8a5498727ef6be21(b, c, t);
    return $054bf7af52f034b6$export$8a5498727ef6be21(d, e, t);
}
const $054bf7af52f034b6$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $054bf7af52f034b6$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $054bf7af52f034b6$export$3d12bd131bb975d1(rtl, rectX, width) {
    return rtl ? $054bf7af52f034b6$var$getRightToLeftAdapter(rectX, width) : $054bf7af52f034b6$var$getLeftToRightAdapter();
}
function $054bf7af52f034b6$export$91c6e00c14e7e6fd(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $054bf7af52f034b6$export$890c4ad488842ce7(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $054bf7af52f034b6$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $054bf7af52f034b6$export$ffb5f4729a158638,
        compare: $054bf7af52f034b6$export$c18d01048907ea92,
        normalize: $054bf7af52f034b6$export$28f7fcd39efa255
    };
    return {
        between: $054bf7af52f034b6$export$3b513254972cfc9c,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $054bf7af52f034b6$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $054bf7af52f034b6$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $054bf7af52f034b6$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $054bf7af52f034b6$export$9fa96a7d116ea3ce(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $054bf7af52f034b6$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $054bf7af52f034b6$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($054bf7af52f034b6$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($054bf7af52f034b6$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $054bf7af52f034b6$export$306ddfe3a8403e2(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $054bf7af52f034b6$export$9fa96a7d116ea3ce(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $054bf7af52f034b6$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $054bf7af52f034b6$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $054bf7af52f034b6$export$1a82df3d29112e01(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $054bf7af52f034b6$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $054bf7af52f034b6$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $054bf7af52f034b6$var$splitByStyles(line, $054bf7af52f034b6$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $054bf7af52f034b6$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $054bf7af52f034b6$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $054bf7af52f034b6$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $054bf7af52f034b6$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $054bf7af52f034b6$var$readStyle(segmentOptions.setContext($054bf7af52f034b6$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($054bf7af52f034b6$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $054bf7af52f034b6$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $054bf7af52f034b6$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$054bf7af52f034b6$export$f96d196f7728bb5(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}



class $352a79de3bee5462$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $054bf7af52f034b6$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $352a79de3bee5462$export$a424a0aa8f687495 = /* #__PURE__ */ new $352a79de3bee5462$var$Animator();
const $352a79de3bee5462$var$transparent = 'transparent';
const $352a79de3bee5462$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $054bf7af52f034b6$export$db3b6bfb95261072)(from || $352a79de3bee5462$var$transparent);
        const c1 = c0.valid && (0, $054bf7af52f034b6$export$db3b6bfb95261072)(to || $352a79de3bee5462$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $352a79de3bee5462$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $054bf7af52f034b6$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $054bf7af52f034b6$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $352a79de3bee5462$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $054bf7af52f034b6$export$f1e1789686576879)[cfg.easing] || (0, $054bf7af52f034b6$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $352a79de3bee5462$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $054bf7af52f034b6$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $054bf7af52f034b6$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $054bf7af52f034b6$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $352a79de3bee5462$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $352a79de3bee5462$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $352a79de3bee5462$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $352a79de3bee5462$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $352a79de3bee5462$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $352a79de3bee5462$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $352a79de3bee5462$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $352a79de3bee5462$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $352a79de3bee5462$var$scaleClip(xScale, allowedOverflow);
    const y = $352a79de3bee5462$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $352a79de3bee5462$var$toClip(value) {
    let t, r, b, l;
    if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $352a79de3bee5462$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $352a79de3bee5462$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $054bf7af52f034b6$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $054bf7af52f034b6$export$2408f22a0fab9ae5)(value) === (0, $054bf7af52f034b6$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $352a79de3bee5462$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $352a79de3bee5462$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $352a79de3bee5462$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $352a79de3bee5462$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $352a79de3bee5462$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $352a79de3bee5462$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $352a79de3bee5462$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $352a79de3bee5462$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $352a79de3bee5462$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $352a79de3bee5462$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $352a79de3bee5462$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $352a79de3bee5462$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $352a79de3bee5462$var$createDatasetContext(parent, index) {
    return (0, $054bf7af52f034b6$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $352a79de3bee5462$var$createDataContext(parent, index, element) {
    return (0, $054bf7af52f034b6$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $352a79de3bee5462$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $352a79de3bee5462$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $352a79de3bee5462$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $352a79de3bee5462$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $352a79de3bee5462$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $352a79de3bee5462$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $352a79de3bee5462$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $352a79de3bee5462$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(dataset.xAxisID, $352a79de3bee5462$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(dataset.yAxisID, $352a79de3bee5462$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(dataset.rAxisID, $352a79de3bee5462$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $054bf7af52f034b6$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $352a79de3bee5462$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $352a79de3bee5462$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $054bf7af52f034b6$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $352a79de3bee5462$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $054bf7af52f034b6$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $352a79de3bee5462$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $352a79de3bee5462$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $352a79de3bee5462$var$updateStacks(this, meta._parsed);
            meta._stacked = $352a79de3bee5462$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $352a79de3bee5462$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $054bf7af52f034b6$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $054bf7af52f034b6$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $352a79de3bee5462$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $352a79de3bee5462$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $352a79de3bee5462$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $352a79de3bee5462$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $352a79de3bee5462$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $054bf7af52f034b6$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $054bf7af52f034b6$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $352a79de3bee5462$var$toClip((0, $054bf7af52f034b6$export$90a7f3efeed30595)(this.options.clip, $352a79de3bee5462$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $352a79de3bee5462$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $352a79de3bee5462$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(index);
        if (cached) return $352a79de3bee5462$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $054bf7af52f034b6$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($352a79de3bee5462$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $352a79de3bee5462$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $352a79de3bee5462$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($352a79de3bee5462$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$352a79de3bee5462$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $352a79de3bee5462$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $352a79de3bee5462$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $054bf7af52f034b6$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $352a79de3bee5462$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $352a79de3bee5462$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $352a79de3bee5462$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $054bf7af52f034b6$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $352a79de3bee5462$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $352a79de3bee5462$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $352a79de3bee5462$var$parseValue(entry, item, vScale, i) {
    if ((0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(entry)) $352a79de3bee5462$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $352a79de3bee5462$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($352a79de3bee5462$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $352a79de3bee5462$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $352a79de3bee5462$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $054bf7af52f034b6$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $352a79de3bee5462$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $352a79de3bee5462$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $352a79de3bee5462$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$352a79de3bee5462$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$352a79de3bee5462$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $352a79de3bee5462$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $352a79de3bee5462$var$swap(edge, a, b);
        edge = $352a79de3bee5462$var$startEnd(edge, b, a);
    } else edge = $352a79de3bee5462$var$startEnd(edge, a, b);
    return edge;
}
function $352a79de3bee5462$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $352a79de3bee5462$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $352a79de3bee5462$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $352a79de3bee5462$export$e97d5dc64e999004 extends $352a79de3bee5462$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $352a79de3bee5462$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $352a79de3bee5462$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $054bf7af52f034b6$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($352a79de3bee5462$var$parseValue((0, $054bf7af52f034b6$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $352a79de3bee5462$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $054bf7af52f034b6$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $352a79de3bee5462$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $352a79de3bee5462$var$setBorderSkipped(properties, options, stack, index);
            $352a79de3bee5462$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $054bf7af52f034b6$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $352a79de3bee5462$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $352a79de3bee5462$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $054bf7af52f034b6$export$2408f22a0fab9ae5)(value) !== (0, $054bf7af52f034b6$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $054bf7af52f034b6$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $352a79de3bee5462$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $054bf7af52f034b6$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $352a79de3bee5462$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $352a79de3bee5462$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $352a79de3bee5462$export$19b5c4773f17abe extends $352a79de3bee5462$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $054bf7af52f034b6$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $352a79de3bee5462$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $054bf7af52f034b6$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $054bf7af52f034b6$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $054bf7af52f034b6$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $054bf7af52f034b6$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $054bf7af52f034b6$export$56c0d5a1e737357d) + (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $352a79de3bee5462$export$e04603e7d8b77172 extends $352a79de3bee5462$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $054bf7af52f034b6$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $054bf7af52f034b6$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $054bf7af52f034b6$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $054bf7af52f034b6$export$971d5caa766a69d7);
        let max = -(0, $054bf7af52f034b6$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $054bf7af52f034b6$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $352a79de3bee5462$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $054bf7af52f034b6$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $054bf7af52f034b6$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $054bf7af52f034b6$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $054bf7af52f034b6$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $054bf7af52f034b6$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $352a79de3bee5462$export$3c9b5d28c11cbfd0 extends $352a79de3bee5462$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $054bf7af52f034b6$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $054bf7af52f034b6$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $054bf7af52f034b6$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $054bf7af52f034b6$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $352a79de3bee5462$export$2a270b3a0d973c85 extends $352a79de3bee5462$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $054bf7af52f034b6$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $054bf7af52f034b6$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $054bf7af52f034b6$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $054bf7af52f034b6$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $352a79de3bee5462$export$b21a3f1286706191 extends $352a79de3bee5462$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $352a79de3bee5462$export$48dbc6ac651bf8be extends $352a79de3bee5462$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $054bf7af52f034b6$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $352a79de3bee5462$export$b2f2bae6713db87 extends $352a79de3bee5462$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $054bf7af52f034b6$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $054bf7af52f034b6$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $054bf7af52f034b6$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $054bf7af52f034b6$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $352a79de3bee5462$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $352a79de3bee5462$export$e97d5dc64e999004,
    BubbleController: $352a79de3bee5462$export$19b5c4773f17abe,
    DoughnutController: $352a79de3bee5462$export$e04603e7d8b77172,
    LineController: $352a79de3bee5462$export$3c9b5d28c11cbfd0,
    PieController: $352a79de3bee5462$export$b21a3f1286706191,
    PolarAreaController: $352a79de3bee5462$export$2a270b3a0d973c85,
    RadarController: $352a79de3bee5462$export$48dbc6ac651bf8be,
    ScatterController: $352a79de3bee5462$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $352a79de3bee5462$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $352a79de3bee5462$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($352a79de3bee5462$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $352a79de3bee5462$var$abstract();
    }
    parse() {
        return $352a79de3bee5462$var$abstract();
    }
    format() {
        return $352a79de3bee5462$var$abstract();
    }
    add() {
        return $352a79de3bee5462$var$abstract();
    }
    diff() {
        return $352a79de3bee5462$var$abstract();
    }
    startOf() {
        return $352a79de3bee5462$var$abstract();
    }
    endOf() {
        return $352a79de3bee5462$var$abstract();
    }
}
var $352a79de3bee5462$export$f32766ea09ec8bc4 = {
    _date: $352a79de3bee5462$var$DateAdapterBase
};
function $352a79de3bee5462$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $054bf7af52f034b6$export$ebd11618f299a286) : (0, $054bf7af52f034b6$export$ef35774e6d314e91);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $352a79de3bee5462$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $352a79de3bee5462$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $352a79de3bee5462$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $352a79de3bee5462$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $054bf7af52f034b6$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $352a79de3bee5462$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $352a79de3bee5462$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $054bf7af52f034b6$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $054bf7af52f034b6$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $352a79de3bee5462$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $352a79de3bee5462$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $352a79de3bee5462$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $352a79de3bee5462$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $352a79de3bee5462$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $352a79de3bee5462$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $352a79de3bee5462$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $352a79de3bee5462$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $352a79de3bee5462$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $352a79de3bee5462$export$a13296960cae0384 = {
    evaluateInteractionItems: $352a79de3bee5462$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $054bf7af52f034b6$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $352a79de3bee5462$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $352a79de3bee5462$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $054bf7af52f034b6$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $352a79de3bee5462$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $352a79de3bee5462$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $054bf7af52f034b6$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $352a79de3bee5462$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $054bf7af52f034b6$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $352a79de3bee5462$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $054bf7af52f034b6$export$df995fae86a55f06)(e, chart);
            return $352a79de3bee5462$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $054bf7af52f034b6$export$df995fae86a55f06)(e, chart);
            return $352a79de3bee5462$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $352a79de3bee5462$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $352a79de3bee5462$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $352a79de3bee5462$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$352a79de3bee5462$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $352a79de3bee5462$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $352a79de3bee5462$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $352a79de3bee5462$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$352a79de3bee5462$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $352a79de3bee5462$var$setLayoutDims(layouts, params) {
    const stacks = $352a79de3bee5462$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $352a79de3bee5462$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $352a79de3bee5462$var$wrapBoxes(boxes);
    const fullSize = $352a79de3bee5462$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $352a79de3bee5462$var$sortByWeight($352a79de3bee5462$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $352a79de3bee5462$var$sortByWeight($352a79de3bee5462$var$filterByPosition(layoutBoxes, 'right'));
    const top = $352a79de3bee5462$var$sortByWeight($352a79de3bee5462$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $352a79de3bee5462$var$sortByWeight($352a79de3bee5462$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $352a79de3bee5462$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $352a79de3bee5462$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $352a79de3bee5462$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $352a79de3bee5462$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $352a79de3bee5462$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $352a79de3bee5462$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $054bf7af52f034b6$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $352a79de3bee5462$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $352a79de3bee5462$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $352a79de3bee5462$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $352a79de3bee5462$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $352a79de3bee5462$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $352a79de3bee5462$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $352a79de3bee5462$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $352a79de3bee5462$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $352a79de3bee5462$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $352a79de3bee5462$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $352a79de3bee5462$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $352a79de3bee5462$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $352a79de3bee5462$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $352a79de3bee5462$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $352a79de3bee5462$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $352a79de3bee5462$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $352a79de3bee5462$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $054bf7af52f034b6$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $352a79de3bee5462$var$updateMaxPadding(maxPadding, (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $352a79de3bee5462$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $352a79de3bee5462$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $352a79de3bee5462$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($352a79de3bee5462$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $352a79de3bee5462$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $352a79de3bee5462$var$handleMaxPadding(chartArea);
        $352a79de3bee5462$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $352a79de3bee5462$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $054bf7af52f034b6$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $352a79de3bee5462$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $352a79de3bee5462$export$a40a96b24b46cf35 extends $352a79de3bee5462$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $352a79de3bee5462$var$EXPANDO_KEY = '$chartjs';
const $352a79de3bee5462$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $352a79de3bee5462$var$isNullOrEmpty = (value)=>value === null || value === '';
function $352a79de3bee5462$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$352a79de3bee5462$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($352a79de3bee5462$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $054bf7af52f034b6$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($352a79de3bee5462$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $054bf7af52f034b6$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $352a79de3bee5462$var$eventListenerOptions = (0, $054bf7af52f034b6$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $352a79de3bee5462$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $352a79de3bee5462$var$eventListenerOptions);
}
function $352a79de3bee5462$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $352a79de3bee5462$var$eventListenerOptions);
}
function $352a79de3bee5462$var$fromNativeEvent(event, chart) {
    const type = $352a79de3bee5462$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $054bf7af52f034b6$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $352a79de3bee5462$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $352a79de3bee5462$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $352a79de3bee5462$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$352a79de3bee5462$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $352a79de3bee5462$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $352a79de3bee5462$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$352a79de3bee5462$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $352a79de3bee5462$var$drpListeningCharts = new Map();
let $352a79de3bee5462$var$oldDevicePixelRatio = 0;
function $352a79de3bee5462$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $352a79de3bee5462$var$oldDevicePixelRatio) return;
    $352a79de3bee5462$var$oldDevicePixelRatio = dpr;
    $352a79de3bee5462$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $352a79de3bee5462$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$352a79de3bee5462$var$drpListeningCharts.size) window.addEventListener('resize', $352a79de3bee5462$var$onWindowResize);
    $352a79de3bee5462$var$drpListeningCharts.set(chart, resize);
}
function $352a79de3bee5462$var$unlistenDevicePixelRatioChanges(chart) {
    $352a79de3bee5462$var$drpListeningCharts.delete(chart);
    if (!$352a79de3bee5462$var$drpListeningCharts.size) window.removeEventListener('resize', $352a79de3bee5462$var$onWindowResize);
}
function $352a79de3bee5462$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $054bf7af52f034b6$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $054bf7af52f034b6$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $352a79de3bee5462$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $352a79de3bee5462$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $352a79de3bee5462$var$unlistenDevicePixelRatioChanges(chart);
}
function $352a79de3bee5462$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $054bf7af52f034b6$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($352a79de3bee5462$var$fromNativeEvent(event, chart));
    }, chart);
    $352a79de3bee5462$var$addListener(canvas, type, proxy);
    return proxy;
}
class $352a79de3bee5462$export$f02da7f882cf6b2e extends $352a79de3bee5462$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $352a79de3bee5462$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$352a79de3bee5462$var$EXPANDO_KEY]) return false;
        const initial = canvas[$352a79de3bee5462$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $054bf7af52f034b6$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$352a79de3bee5462$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $352a79de3bee5462$var$createAttachObserver,
            detach: $352a79de3bee5462$var$createDetachObserver,
            resize: $352a79de3bee5462$var$createResizeObserver
        };
        const handler = handlers[type] || $352a79de3bee5462$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $352a79de3bee5462$var$releaseObserver,
            detach: $352a79de3bee5462$var$releaseObserver,
            resize: $352a79de3bee5462$var$releaseObserver
        };
        const handler = handlers[type] || $352a79de3bee5462$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $054bf7af52f034b6$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $054bf7af52f034b6$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $352a79de3bee5462$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $054bf7af52f034b6$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $352a79de3bee5462$export$a40a96b24b46cf35;
    return $352a79de3bee5462$export$f02da7f882cf6b2e;
}
class $352a79de3bee5462$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $054bf7af52f034b6$export$d141bba7fdc215a3)(this.x) && (0, $054bf7af52f034b6$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $352a79de3bee5462$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $352a79de3bee5462$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $352a79de3bee5462$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $352a79de3bee5462$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $352a79de3bee5462$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $352a79de3bee5462$var$skip(ticks, newTicks, spacing, (0, $054bf7af52f034b6$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$352a79de3bee5462$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $352a79de3bee5462$var$skip(ticks, newTicks, spacing, last, (0, $054bf7af52f034b6$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $352a79de3bee5462$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $352a79de3bee5462$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $352a79de3bee5462$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $352a79de3bee5462$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $054bf7af52f034b6$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $352a79de3bee5462$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $352a79de3bee5462$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $352a79de3bee5462$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $054bf7af52f034b6$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $352a79de3bee5462$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $352a79de3bee5462$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $352a79de3bee5462$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $352a79de3bee5462$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $352a79de3bee5462$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $352a79de3bee5462$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $352a79de3bee5462$var$garbageCollect(caches, length) {
    (0, $054bf7af52f034b6$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $352a79de3bee5462$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $352a79de3bee5462$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $054bf7af52f034b6$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $352a79de3bee5462$var$createScaleContext(parent, scale) {
    return (0, $054bf7af52f034b6$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $352a79de3bee5462$var$createTickContext(parent, index, tick) {
    return (0, $054bf7af52f034b6$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $352a79de3bee5462$var$titleAlign(align, position, reverse) {
    let ret = (0, $054bf7af52f034b6$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $352a79de3bee5462$var$reverseAlign(ret);
    return ret;
}
function $352a79de3bee5462$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $352a79de3bee5462$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $352a79de3bee5462$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd) : (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $352a79de3bee5462$export$d60cfc58d3c358b6 extends $352a79de3bee5462$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $054bf7af52f034b6$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $054bf7af52f034b6$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $054bf7af52f034b6$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $054bf7af52f034b6$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $054bf7af52f034b6$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $054bf7af52f034b6$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $054bf7af52f034b6$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $054bf7af52f034b6$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $054bf7af52f034b6$export$c4ce752e73470fba)(min, (0, $054bf7af52f034b6$export$c4ce752e73470fba)(max, min)),
            max: (0, $054bf7af52f034b6$export$c4ce752e73470fba)(max, (0, $054bf7af52f034b6$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $054bf7af52f034b6$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $352a79de3bee5462$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $352a79de3bee5462$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $352a79de3bee5462$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $054bf7af52f034b6$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $352a79de3bee5462$var$getTickMarkLength(options.grid) - tickOpts.padding - $352a79de3bee5462$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $054bf7af52f034b6$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $054bf7af52f034b6$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $054bf7af52f034b6$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $054bf7af52f034b6$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $352a79de3bee5462$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $352a79de3bee5462$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $352a79de3bee5462$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $054bf7af52f034b6$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $054bf7af52f034b6$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $352a79de3bee5462$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $352a79de3bee5462$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $054bf7af52f034b6$export$342063e11d6c3cad)(label) && !(0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(label)) {
                width = (0, $054bf7af52f034b6$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $054bf7af52f034b6$export$342063e11d6c3cad)(nestedLabel) && !(0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $054bf7af52f034b6$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $352a79de3bee5462$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $054bf7af52f034b6$export$71cec2538cb2c617)(this._alignToPixels ? (0, $054bf7af52f034b6$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $352a79de3bee5462$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $352a79de3bee5462$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $054bf7af52f034b6$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $352a79de3bee5462$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $054bf7af52f034b6$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $352a79de3bee5462$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $054bf7af52f034b6$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $352a79de3bee5462$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $054bf7af52f034b6$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $054bf7af52f034b6$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $054bf7af52f034b6$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $054bf7af52f034b6$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $054bf7af52f034b6$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $054bf7af52f034b6$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $054bf7af52f034b6$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $054bf7af52f034b6$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $054bf7af52f034b6$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $054bf7af52f034b6$export$34aec0b863436764)(title.font);
        const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $054bf7af52f034b6$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $352a79de3bee5462$var$titleArgs(this, offset, position, align);
        (0, $054bf7af52f034b6$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $352a79de3bee5462$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $352a79de3bee5462$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $054bf7af52f034b6$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $352a79de3bee5462$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($352a79de3bee5462$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $352a79de3bee5462$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $054bf7af52f034b6$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $054bf7af52f034b6$export$4368d992c4eafac0)[scope]) {
            delete (0, $054bf7af52f034b6$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $054bf7af52f034b6$export$6559d589eb85fbb6)[id];
        }
    }
}
function $352a79de3bee5462$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $054bf7af52f034b6$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $054bf7af52f034b6$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $054bf7af52f034b6$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $054bf7af52f034b6$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $352a79de3bee5462$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $054bf7af52f034b6$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $352a79de3bee5462$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $054bf7af52f034b6$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $352a79de3bee5462$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $352a79de3bee5462$var$Registry {
    constructor(){
        this.controllers = new $352a79de3bee5462$var$TypedRegistry($352a79de3bee5462$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $352a79de3bee5462$var$TypedRegistry($352a79de3bee5462$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $352a79de3bee5462$var$TypedRegistry(Object, 'plugins');
        this.scales = new $352a79de3bee5462$var$TypedRegistry($352a79de3bee5462$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $054bf7af52f034b6$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $054bf7af52f034b6$export$a8550f7dbe79f93a)(method);
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $352a79de3bee5462$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $352a79de3bee5462$var$Registry();
class $352a79de3bee5462$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $054bf7af52f034b6$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $054bf7af52f034b6$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $352a79de3bee5462$var$allPlugins(config);
        return options === false && !all ? [] : $352a79de3bee5462$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $352a79de3bee5462$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($352a79de3bee5462$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($352a79de3bee5462$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $352a79de3bee5462$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $352a79de3bee5462$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $352a79de3bee5462$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $352a79de3bee5462$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $352a79de3bee5462$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $352a79de3bee5462$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $054bf7af52f034b6$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $352a79de3bee5462$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $352a79de3bee5462$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $352a79de3bee5462$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $352a79de3bee5462$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $352a79de3bee5462$var$determineAxis(id, ...scaleOptions) {
    if ($352a79de3bee5462$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $352a79de3bee5462$var$axisFromPosition(opts.position) || id.length > 1 && $352a79de3bee5462$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $352a79de3bee5462$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $352a79de3bee5462$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $352a79de3bee5462$var$getAxisFromDataset(id, 'x', boundDs[0]) || $352a79de3bee5462$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $352a79de3bee5462$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $054bf7af52f034b6$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $352a79de3bee5462$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $054bf7af52f034b6$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $352a79de3bee5462$var$determineAxis(id, scaleConf, $352a79de3bee5462$var$retrieveAxisFromDatasets(id, config), (0, $054bf7af52f034b6$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $352a79de3bee5462$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $054bf7af52f034b6$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $352a79de3bee5462$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $054bf7af52f034b6$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $352a79de3bee5462$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $054bf7af52f034b6$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $054bf7af52f034b6$export$555508cbc6add439)(scale, [
            (0, $054bf7af52f034b6$export$4368d992c4eafac0).scales[scale.type],
            (0, $054bf7af52f034b6$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $352a79de3bee5462$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $352a79de3bee5462$var$mergeScaleConfig(config, options);
}
function $352a79de3bee5462$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $352a79de3bee5462$var$initConfig(config) {
    config = config || {};
    config.data = $352a79de3bee5462$var$initData(config.data);
    $352a79de3bee5462$var$initOptions(config);
    return config;
}
const $352a79de3bee5462$var$keyCache = new Map();
const $352a79de3bee5462$var$keysCached = new Set();
function $352a79de3bee5462$var$cachedKeys(cacheKey, generate) {
    let keys = $352a79de3bee5462$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $352a79de3bee5462$var$keyCache.set(cacheKey, keys);
        $352a79de3bee5462$var$keysCached.add(keys);
    }
    return keys;
}
const $352a79de3bee5462$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $054bf7af52f034b6$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $352a79de3bee5462$var$Config {
    constructor(config){
        this._config = $352a79de3bee5462$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $352a79de3bee5462$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $352a79de3bee5462$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $352a79de3bee5462$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $352a79de3bee5462$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $352a79de3bee5462$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $352a79de3bee5462$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$352a79de3bee5462$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$352a79de3bee5462$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$352a79de3bee5462$var$addIfFound(scopes, (0, $054bf7af52f034b6$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$352a79de3bee5462$var$addIfFound(scopes, (0, $054bf7af52f034b6$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$352a79de3bee5462$var$addIfFound(scopes, (0, $054bf7af52f034b6$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($352a79de3bee5462$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $054bf7af52f034b6$export$6559d589eb85fbb6)[type] || {},
            (0, $054bf7af52f034b6$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $054bf7af52f034b6$export$4368d992c4eafac0),
            (0, $054bf7af52f034b6$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $352a79de3bee5462$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($352a79de3bee5462$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $054bf7af52f034b6$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $054bf7af52f034b6$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $352a79de3bee5462$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $054bf7af52f034b6$export$23f2a1d2818174ef)(context) ? (0, $054bf7af52f034b6$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $352a79de3bee5462$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $054bf7af52f034b6$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $352a79de3bee5462$var$hasFunction = (value)=>(0, $054bf7af52f034b6$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $054bf7af52f034b6$export$a93c5207d687da10)(value[key]));
function $352a79de3bee5462$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $054bf7af52f034b6$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $054bf7af52f034b6$export$a93c5207d687da10)(value) || $352a79de3bee5462$var$hasFunction(value)) || indexable && (0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $352a79de3bee5462$var$version = "4.4.6";
const $352a79de3bee5462$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $352a79de3bee5462$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $352a79de3bee5462$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $352a79de3bee5462$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $352a79de3bee5462$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $352a79de3bee5462$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $352a79de3bee5462$var$getCanvas(item) {
    if ((0, $054bf7af52f034b6$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $352a79de3bee5462$var$instances = {};
const $352a79de3bee5462$var$getChart = (key)=>{
    const canvas = $352a79de3bee5462$var$getCanvas(key);
    return Object.values($352a79de3bee5462$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $352a79de3bee5462$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $352a79de3bee5462$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
function $352a79de3bee5462$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $352a79de3bee5462$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $352a79de3bee5462$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $352a79de3bee5462$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $352a79de3bee5462$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $352a79de3bee5462$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
class $352a79de3bee5462$export$acaa6426d77a227e {
    static defaults = (0, $054bf7af52f034b6$export$4368d992c4eafac0);
    static instances = $352a79de3bee5462$var$instances;
    static overrides = (0, $054bf7af52f034b6$export$6559d589eb85fbb6);
    static registry = $352a79de3bee5462$export$4bb7493d241fd8a5;
    static version = $352a79de3bee5462$var$version;
    static getChart = $352a79de3bee5462$var$getChart;
    static register(...items) {
        $352a79de3bee5462$export$4bb7493d241fd8a5.add(...items);
        $352a79de3bee5462$var$invalidatePlugins();
    }
    static unregister(...items) {
        $352a79de3bee5462$export$4bb7493d241fd8a5.remove(...items);
        $352a79de3bee5462$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $352a79de3bee5462$var$Config(userConfig);
        const initialCanvas = $352a79de3bee5462$var$getCanvas(item);
        const existingChart = $352a79de3bee5462$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $352a79de3bee5462$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $054bf7af52f034b6$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $352a79de3bee5462$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $054bf7af52f034b6$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $352a79de3bee5462$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $352a79de3bee5462$export$a424a0aa8f687495.listen(this, 'complete', $352a79de3bee5462$var$onAnimationsComplete);
        $352a79de3bee5462$export$a424a0aa8f687495.listen(this, 'progress', $352a79de3bee5462$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $054bf7af52f034b6$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $352a79de3bee5462$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $054bf7af52f034b6$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $054bf7af52f034b6$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $352a79de3bee5462$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$352a79de3bee5462$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $054bf7af52f034b6$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $054bf7af52f034b6$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $352a79de3bee5462$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $054bf7af52f034b6$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $352a79de3bee5462$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $352a79de3bee5462$var$positionIsHorizontal(scaleOptions.position, axis) !== $352a79de3bee5462$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $352a79de3bee5462$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $054bf7af52f034b6$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $054bf7af52f034b6$export$d66501df72047452)(scales, (scale)=>{
            $352a79de3bee5462$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $352a79de3bee5462$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($352a79de3bee5462$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $352a79de3bee5462$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $352a79de3bee5462$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $054bf7af52f034b6$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $352a79de3bee5462$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $352a79de3bee5462$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $054bf7af52f034b6$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $054bf7af52f034b6$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($352a79de3bee5462$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $054bf7af52f034b6$export$d66501df72047452)(this.scales, (scale)=>{
            $352a79de3bee5462$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $054bf7af52f034b6$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $352a79de3bee5462$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $054bf7af52f034b6$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $352a79de3bee5462$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $054bf7af52f034b6$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $054bf7af52f034b6$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($352a79de3bee5462$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$352a79de3bee5462$export$a424a0aa8f687495.running(this)) $352a79de3bee5462$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $352a79de3bee5462$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = $352a79de3bee5462$var$getDatasetArea(meta, this.chartArea);
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (useClip) (0, $054bf7af52f034b6$export$8743009a87fcb00f)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $054bf7af52f034b6$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $054bf7af52f034b6$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $352a79de3bee5462$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $054bf7af52f034b6$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $352a79de3bee5462$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $054bf7af52f034b6$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $352a79de3bee5462$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $054bf7af52f034b6$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $054bf7af52f034b6$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $054bf7af52f034b6$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $054bf7af52f034b6$export$995eb9fca571757)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $054bf7af52f034b6$export$f38c853ae54ed474)(e);
        const lastEvent = $352a79de3bee5462$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $054bf7af52f034b6$export$995eb9fca571757)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $352a79de3bee5462$var$invalidatePlugins() {
    return (0, $054bf7af52f034b6$export$d66501df72047452)($352a79de3bee5462$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $352a79de3bee5462$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd), startAngle - (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $352a79de3bee5462$var$toRadiusCorners(value) {
    return (0, $054bf7af52f034b6$export$21579262ef46735b)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $352a79de3bee5462$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $352a79de3bee5462$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $054bf7af52f034b6$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $054bf7af52f034b6$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $054bf7af52f034b6$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $352a79de3bee5462$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $352a79de3bee5462$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $054bf7af52f034b6$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $352a79de3bee5462$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $352a79de3bee5462$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $352a79de3bee5462$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $352a79de3bee5462$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $352a79de3bee5462$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $352a79de3bee5462$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $352a79de3bee5462$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $352a79de3bee5462$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $352a79de3bee5462$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $054bf7af52f034b6$export$971d5caa766a69d7) || (0, $054bf7af52f034b6$export$971d5caa766a69d7));
    }
    $352a79de3bee5462$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $352a79de3bee5462$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $352a79de3bee5462$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $054bf7af52f034b6$export$971d5caa766a69d7) || (0, $054bf7af52f034b6$export$971d5caa766a69d7));
    }
    if (inner) $352a79de3bee5462$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $352a79de3bee5462$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $352a79de3bee5462$export$d48203c759d6a1fc extends $352a79de3bee5462$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $054bf7af52f034b6$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $054bf7af52f034b6$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $054bf7af52f034b6$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $054bf7af52f034b6$export$3b513254972cfc9c)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $054bf7af52f034b6$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $054bf7af52f034b6$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $054bf7af52f034b6$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $352a79de3bee5462$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $352a79de3bee5462$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $352a79de3bee5462$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $054bf7af52f034b6$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $352a79de3bee5462$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $352a79de3bee5462$var$getLineMethod(options) {
    if (options.stepped) return 0, $054bf7af52f034b6$export$d24c54395ce0c509;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $054bf7af52f034b6$export$6554612db691658e;
    return $352a79de3bee5462$var$lineTo;
}
function $352a79de3bee5462$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $352a79de3bee5462$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $352a79de3bee5462$var$pathVars(points, segment, params);
    const lineMethod = $352a79de3bee5462$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $352a79de3bee5462$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $352a79de3bee5462$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $352a79de3bee5462$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $352a79de3bee5462$var$fastPathSegment : $352a79de3bee5462$var$pathSegment;
}
function $352a79de3bee5462$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $054bf7af52f034b6$export$7a38258bbe170828;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $054bf7af52f034b6$export$2f6ca3d3b1f80bf5;
    return 0, $054bf7af52f034b6$export$8a5498727ef6be21;
}
function $352a79de3bee5462$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $352a79de3bee5462$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $352a79de3bee5462$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $352a79de3bee5462$var$_getSegmentMethod(line);
    for (const segment of segments){
        $352a79de3bee5462$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $352a79de3bee5462$var$usePath2D = typeof Path2D === 'function';
function $352a79de3bee5462$var$draw(ctx, line, start, count) {
    if ($352a79de3bee5462$var$usePath2D && !line.options.segment) $352a79de3bee5462$var$strokePathWithCache(ctx, line, start, count);
    else $352a79de3bee5462$var$strokePathDirect(ctx, line, start, count);
}
class $352a79de3bee5462$export$55e463fa7bcd3469 extends $352a79de3bee5462$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $054bf7af52f034b6$export$ab83b03e4111b1d0)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $054bf7af52f034b6$export$1a82df3d29112e01)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $054bf7af52f034b6$export$306ddfe3a8403e2)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $352a79de3bee5462$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $352a79de3bee5462$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $352a79de3bee5462$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $352a79de3bee5462$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $352a79de3bee5462$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $352a79de3bee5462$export$bd159b522b230b7a extends $352a79de3bee5462$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $352a79de3bee5462$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $352a79de3bee5462$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $054bf7af52f034b6$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $054bf7af52f034b6$export$493d36ec626b6698)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $352a79de3bee5462$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $352a79de3bee5462$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $054bf7af52f034b6$export$25ce5a424b770e84)(value, min, max);
}
function $352a79de3bee5462$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $054bf7af52f034b6$export$d66dc83d8cfc8dd)(value);
    return {
        t: $352a79de3bee5462$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $352a79de3bee5462$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $352a79de3bee5462$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $352a79de3bee5462$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $352a79de3bee5462$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $054bf7af52f034b6$export$92108d983e8ee699)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $054bf7af52f034b6$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $352a79de3bee5462$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $352a79de3bee5462$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $352a79de3bee5462$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $352a79de3bee5462$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $352a79de3bee5462$var$boundingRects(bar) {
    const bounds = $352a79de3bee5462$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $352a79de3bee5462$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $352a79de3bee5462$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $352a79de3bee5462$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $352a79de3bee5462$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $054bf7af52f034b6$export$3b513254972cfc9c)(x, bounds.left, bounds.right)) && (skipY || (0, $054bf7af52f034b6$export$3b513254972cfc9c)(y, bounds.top, bounds.bottom));
}
function $352a79de3bee5462$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $352a79de3bee5462$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $352a79de3bee5462$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $352a79de3bee5462$export$a16ed71bf4b07672 extends $352a79de3bee5462$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $352a79de3bee5462$var$boundingRects(this);
        const addRectPath = $352a79de3bee5462$var$hasRadius(outer.radius) ? (0, $054bf7af52f034b6$export$1fbe638ecf81657e) : $352a79de3bee5462$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $352a79de3bee5462$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $352a79de3bee5462$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $352a79de3bee5462$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $352a79de3bee5462$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $352a79de3bee5462$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $352a79de3bee5462$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $352a79de3bee5462$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $352a79de3bee5462$export$d48203c759d6a1fc,
    BarElement: $352a79de3bee5462$export$a16ed71bf4b07672,
    LineElement: $352a79de3bee5462$export$55e463fa7bcd3469,
    PointElement: $352a79de3bee5462$export$bd159b522b230b7a
});
const $352a79de3bee5462$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $352a79de3bee5462$var$BACKGROUND_COLORS = /* #__PURE__ */ $352a79de3bee5462$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $352a79de3bee5462$var$getBorderColor(i) {
    return $352a79de3bee5462$var$BORDER_COLORS[i % $352a79de3bee5462$var$BORDER_COLORS.length];
}
function $352a79de3bee5462$var$getBackgroundColor(i) {
    return $352a79de3bee5462$var$BACKGROUND_COLORS[i % $352a79de3bee5462$var$BACKGROUND_COLORS.length];
}
function $352a79de3bee5462$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $352a79de3bee5462$var$getBorderColor(i);
    dataset.backgroundColor = $352a79de3bee5462$var$getBackgroundColor(i);
    return ++i;
}
function $352a79de3bee5462$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$352a79de3bee5462$var$getBorderColor(i++));
    return i;
}
function $352a79de3bee5462$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$352a79de3bee5462$var$getBackgroundColor(i++));
    return i;
}
function $352a79de3bee5462$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $352a79de3bee5462$export$e04603e7d8b77172) i = $352a79de3bee5462$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $352a79de3bee5462$export$2a270b3a0d973c85) i = $352a79de3bee5462$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $352a79de3bee5462$var$colorizeDefaultDataset(dataset, i);
    };
}
function $352a79de3bee5462$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $352a79de3bee5462$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $352a79de3bee5462$var$containsDefaultColorsDefenitions() {
    return (0, $054bf7af52f034b6$export$4368d992c4eafac0).borderColor !== 'rgba(0,0,0,0.1)' || (0, $054bf7af52f034b6$export$4368d992c4eafac0).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $352a79de3bee5462$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $352a79de3bee5462$var$containsColorsDefinitions(datasets) || $352a79de3bee5462$var$containsColorsDefinition(chartOptions) || elements && $352a79de3bee5462$var$containsColorsDefinitions(elements) || $352a79de3bee5462$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $352a79de3bee5462$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $352a79de3bee5462$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $352a79de3bee5462$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $054bf7af52f034b6$export$342063e11d6c3cad)(minIndex) && !(0, $054bf7af52f034b6$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $352a79de3bee5462$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $352a79de3bee5462$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $352a79de3bee5462$var$cleanDecimatedDataset(dataset);
    });
}
function $352a79de3bee5462$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $054bf7af52f034b6$export$25ce5a424b770e84)((0, $054bf7af52f034b6$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $054bf7af52f034b6$export$25ce5a424b770e84)((0, $054bf7af52f034b6$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $352a79de3bee5462$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $352a79de3bee5462$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $054bf7af52f034b6$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $352a79de3bee5462$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $352a79de3bee5462$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $054bf7af52f034b6$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $352a79de3bee5462$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $352a79de3bee5462$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $352a79de3bee5462$var$cleanDecimatedData(chart);
    }
};
function $352a79de3bee5462$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $352a79de3bee5462$var$_findSegmentEnd(start, end, points);
        const bounds = $352a79de3bee5462$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $054bf7af52f034b6$export$306ddfe3a8403e2)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $352a79de3bee5462$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $054bf7af52f034b6$export$9fa96a7d116ea3ce)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $352a79de3bee5462$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $352a79de3bee5462$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $352a79de3bee5462$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $054bf7af52f034b6$export$28f7fcd39efa255)(start);
        end = (0, $054bf7af52f034b6$export$28f7fcd39efa255)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $352a79de3bee5462$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $352a79de3bee5462$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $352a79de3bee5462$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $352a79de3bee5462$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $352a79de3bee5462$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $352a79de3bee5462$var$_pointsFromSegments(boundary, line);
    return points.length ? new $352a79de3bee5462$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $352a79de3bee5462$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $352a79de3bee5462$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $054bf7af52f034b6$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $352a79de3bee5462$var$_decodeFill(line, index, count) {
    const fill = $352a79de3bee5462$var$parseFillOption(line);
    if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $054bf7af52f034b6$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $352a79de3bee5462$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $352a79de3bee5462$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $352a79de3bee5462$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $352a79de3bee5462$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $352a79de3bee5462$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $352a79de3bee5462$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $352a79de3bee5462$var$getLinesBelow(scale, index);
    linesBelow.push($352a79de3bee5462$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$352a79de3bee5462$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $352a79de3bee5462$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $352a79de3bee5462$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $352a79de3bee5462$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $352a79de3bee5462$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $352a79de3bee5462$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $054bf7af52f034b6$export$3b513254972cfc9c)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $352a79de3bee5462$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $054bf7af52f034b6$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $352a79de3bee5462$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $054bf7af52f034b6$export$39b482c5e57630a8)(fill)) return $352a79de3bee5462$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $352a79de3bee5462$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $352a79de3bee5462$var$computeBoundary(source);
    if (boundary instanceof $352a79de3bee5462$var$simpleArc) return boundary;
    return $352a79de3bee5462$var$_createBoundaryLine(boundary, line);
}
function $352a79de3bee5462$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $352a79de3bee5462$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $352a79de3bee5462$var$computeCircularBoundary(source);
    return $352a79de3bee5462$var$computeLinearBoundary(source);
}
function $352a79de3bee5462$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $352a79de3bee5462$var$_getTargetPixel(fill, scale);
    if ((0, $054bf7af52f034b6$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $352a79de3bee5462$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $352a79de3bee5462$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $352a79de3bee5462$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $352a79de3bee5462$var$_drawfill(ctx, source, area) {
    const target = $352a79de3bee5462$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $054bf7af52f034b6$export$8743009a87fcb00f)(ctx, area);
        $352a79de3bee5462$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $054bf7af52f034b6$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $352a79de3bee5462$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        $352a79de3bee5462$var$clipVertical(ctx, target, area.top);
        $352a79de3bee5462$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $352a79de3bee5462$var$clipVertical(ctx, target, area.bottom);
    }
    $352a79de3bee5462$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $352a79de3bee5462$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$352a79de3bee5462$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $352a79de3bee5462$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $352a79de3bee5462$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $352a79de3bee5462$var$clipBounds(ctx, scale, notShape && $352a79de3bee5462$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $352a79de3bee5462$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $352a79de3bee5462$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $352a79de3bee5462$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x') {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $352a79de3bee5462$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $352a79de3bee5462$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $352a79de3bee5462$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $352a79de3bee5462$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $352a79de3bee5462$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $352a79de3bee5462$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($352a79de3bee5462$var$_shouldApplyFill(source)) $352a79de3bee5462$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$352a79de3bee5462$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $352a79de3bee5462$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $352a79de3bee5462$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $352a79de3bee5462$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $352a79de3bee5462$var$Legend extends $352a79de3bee5462$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $352a79de3bee5462$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $352a79de3bee5462$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $054bf7af52f034b6$export$3d12bd131bb975d1)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $054bf7af52f034b6$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $054bf7af52f034b6$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $054bf7af52f034b6$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $054bf7af52f034b6$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const labelFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $352a79de3bee5462$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $054bf7af52f034b6$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $054bf7af52f034b6$export$24baa2b76016ce0e)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $054bf7af52f034b6$export$92108d983e8ee699)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $054bf7af52f034b6$export$1fbe638ecf81657e)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $054bf7af52f034b6$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $054bf7af52f034b6$export$91c6e00c14e7e6fd)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $054bf7af52f034b6$export$9d398bebfec1c039)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $352a79de3bee5462$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $054bf7af52f034b6$export$890c4ad488842ce7)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $054bf7af52f034b6$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $054bf7af52f034b6$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $054bf7af52f034b6$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $054bf7af52f034b6$export$3b513254972cfc9c)(x, this.left, this.right) && (0, $054bf7af52f034b6$export$3b513254972cfc9c)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $054bf7af52f034b6$export$3b513254972cfc9c)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $054bf7af52f034b6$export$3b513254972cfc9c)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$352a79de3bee5462$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $352a79de3bee5462$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $352a79de3bee5462$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $352a79de3bee5462$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $352a79de3bee5462$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $352a79de3bee5462$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $352a79de3bee5462$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $352a79de3bee5462$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $352a79de3bee5462$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $352a79de3bee5462$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $352a79de3bee5462$export$ed247974535929c7 = {
    id: 'legend',
    _element: $352a79de3bee5462$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $352a79de3bee5462$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $352a79de3bee5462$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $352a79de3bee5462$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $352a79de3bee5462$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $352a79de3bee5462$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $352a79de3bee5462$var$Title extends $352a79de3bee5462$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $054bf7af52f034b6$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $054bf7af52f034b6$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $054bf7af52f034b6$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $054bf7af52f034b6$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $054bf7af52f034b6$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $054bf7af52f034b6$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $054bf7af52f034b6$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $352a79de3bee5462$var$createTitle(chart, titleOpts) {
    const title = new $352a79de3bee5462$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $352a79de3bee5462$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $352a79de3bee5462$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $352a79de3bee5462$export$f99233281efd08a0 = {
    id: 'title',
    _element: $352a79de3bee5462$var$Title,
    start (chart, _args, options) {
        $352a79de3bee5462$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $352a79de3bee5462$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $352a79de3bee5462$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $352a79de3bee5462$var$map = new WeakMap();
var $352a79de3bee5462$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $352a79de3bee5462$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $352a79de3bee5462$export$1ecca0613f5e56d2.configure(chart, title, options);
        $352a79de3bee5462$export$1ecca0613f5e56d2.addBox(chart, title);
        $352a79de3bee5462$var$map.set(chart, title);
    },
    stop (chart) {
        $352a79de3bee5462$export$1ecca0613f5e56d2.removeBox(chart, $352a79de3bee5462$var$map.get(chart));
        $352a79de3bee5462$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $352a79de3bee5462$var$map.get(chart);
        $352a79de3bee5462$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $352a79de3bee5462$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $054bf7af52f034b6$export$158acd800e1ef08b)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $352a79de3bee5462$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $352a79de3bee5462$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $352a79de3bee5462$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $352a79de3bee5462$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $054bf7af52f034b6$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $054bf7af52f034b6$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $054bf7af52f034b6$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $054bf7af52f034b6$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $054bf7af52f034b6$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $054bf7af52f034b6$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $054bf7af52f034b6$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $352a79de3bee5462$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $352a79de3bee5462$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $352a79de3bee5462$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($352a79de3bee5462$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $352a79de3bee5462$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $352a79de3bee5462$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $352a79de3bee5462$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $352a79de3bee5462$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $352a79de3bee5462$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $352a79de3bee5462$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $054bf7af52f034b6$export$92108d983e8ee699)(cornerRadius);
    let x = $352a79de3bee5462$var$alignX(size, xAlign);
    const y = $352a79de3bee5462$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $054bf7af52f034b6$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $054bf7af52f034b6$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $352a79de3bee5462$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $352a79de3bee5462$var$getBeforeAfterBodyLines(callback) {
    return $352a79de3bee5462$var$pushOrConcat([], $352a79de3bee5462$var$splitNewlines(callback));
}
function $352a79de3bee5462$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $054bf7af52f034b6$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $352a79de3bee5462$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $352a79de3bee5462$var$defaultCallbacks = {
    beforeTitle: (0, $054bf7af52f034b6$export$cf2f7c5792f80b46),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $054bf7af52f034b6$export$cf2f7c5792f80b46),
    beforeBody: (0, $054bf7af52f034b6$export$cf2f7c5792f80b46),
    beforeLabel: (0, $054bf7af52f034b6$export$cf2f7c5792f80b46),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $054bf7af52f034b6$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $054bf7af52f034b6$export$cf2f7c5792f80b46),
    afterBody: (0, $054bf7af52f034b6$export$cf2f7c5792f80b46),
    beforeFooter: (0, $054bf7af52f034b6$export$cf2f7c5792f80b46),
    footer: (0, $054bf7af52f034b6$export$cf2f7c5792f80b46),
    afterFooter: (0, $054bf7af52f034b6$export$cf2f7c5792f80b46)
};
function $352a79de3bee5462$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $352a79de3bee5462$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $352a79de3bee5462$var$Tooltip extends $352a79de3bee5462$export$db77ccec0bb4ccac {
    static positioners = $352a79de3bee5462$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $352a79de3bee5462$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $352a79de3bee5462$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $352a79de3bee5462$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $352a79de3bee5462$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $352a79de3bee5462$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $352a79de3bee5462$var$pushOrConcat(lines, $352a79de3bee5462$var$splitNewlines(beforeTitle));
        lines = $352a79de3bee5462$var$pushOrConcat(lines, $352a79de3bee5462$var$splitNewlines(title));
        lines = $352a79de3bee5462$var$pushOrConcat(lines, $352a79de3bee5462$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $352a79de3bee5462$var$getBeforeAfterBodyLines($352a79de3bee5462$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $054bf7af52f034b6$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $352a79de3bee5462$var$overrideCallbacks(callbacks, context);
            $352a79de3bee5462$var$pushOrConcat(bodyItem.before, $352a79de3bee5462$var$splitNewlines($352a79de3bee5462$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $352a79de3bee5462$var$pushOrConcat(bodyItem.lines, $352a79de3bee5462$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $352a79de3bee5462$var$pushOrConcat(bodyItem.after, $352a79de3bee5462$var$splitNewlines($352a79de3bee5462$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $352a79de3bee5462$var$getBeforeAfterBodyLines($352a79de3bee5462$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $352a79de3bee5462$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $352a79de3bee5462$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $352a79de3bee5462$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $352a79de3bee5462$var$pushOrConcat(lines, $352a79de3bee5462$var$splitNewlines(beforeFooter));
        lines = $352a79de3bee5462$var$pushOrConcat(lines, $352a79de3bee5462$var$splitNewlines(footer));
        lines = $352a79de3bee5462$var$pushOrConcat(lines, $352a79de3bee5462$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($352a79de3bee5462$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $054bf7af52f034b6$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $352a79de3bee5462$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($352a79de3bee5462$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($352a79de3bee5462$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($352a79de3bee5462$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $352a79de3bee5462$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $352a79de3bee5462$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $352a79de3bee5462$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $352a79de3bee5462$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $054bf7af52f034b6$export$92108d983e8ee699)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $054bf7af52f034b6$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $352a79de3bee5462$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(options.bodyFont);
        const colorX = $352a79de3bee5462$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $054bf7af52f034b6$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $054bf7af52f034b6$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $054bf7af52f034b6$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $054bf7af52f034b6$export$92108d983e8ee699)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $054bf7af52f034b6$export$1fbe638ecf81657e)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $054bf7af52f034b6$export$1fbe638ecf81657e)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $054bf7af52f034b6$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $352a79de3bee5462$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $054bf7af52f034b6$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $054bf7af52f034b6$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $054bf7af52f034b6$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $054bf7af52f034b6$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $054bf7af52f034b6$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $352a79de3bee5462$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $054bf7af52f034b6$export$92108d983e8ee699)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $352a79de3bee5462$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $352a79de3bee5462$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $352a79de3bee5462$var$determineAlignment(chart, options, positionAndSize);
            const point = $352a79de3bee5462$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $054bf7af52f034b6$export$91c6e00c14e7e6fd)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $054bf7af52f034b6$export$890c4ad488842ce7)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $054bf7af52f034b6$export$995eb9fca571757)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $054bf7af52f034b6$export$995eb9fca571757)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $352a79de3bee5462$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $352a79de3bee5462$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $352a79de3bee5462$var$Tooltip,
    positioners: $352a79de3bee5462$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $352a79de3bee5462$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $352a79de3bee5462$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $352a79de3bee5462$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $352a79de3bee5462$export$c537fa0d021d010b,
    Decimation: $352a79de3bee5462$export$be17f937e9aa7533,
    Filler: $352a79de3bee5462$export$d19ba4d812bed757,
    Legend: $352a79de3bee5462$export$ed247974535929c7,
    SubTitle: $352a79de3bee5462$export$d5c56664638992a4,
    Title: $352a79de3bee5462$export$f99233281efd08a0,
    Tooltip: $352a79de3bee5462$export$28c660c63b792dea
});
const $352a79de3bee5462$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $352a79de3bee5462$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $352a79de3bee5462$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $352a79de3bee5462$var$validIndex = (index, max)=>index === null ? null : (0, $054bf7af52f034b6$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $352a79de3bee5462$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $352a79de3bee5462$export$29e663ba4d09fe7 extends $352a79de3bee5462$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $352a79de3bee5462$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $054bf7af52f034b6$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $352a79de3bee5462$var$findOrAddLabel(labels, raw, (0, $054bf7af52f034b6$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $352a79de3bee5462$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $352a79de3bee5462$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $352a79de3bee5462$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $054bf7af52f034b6$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $054bf7af52f034b6$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $054bf7af52f034b6$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $054bf7af52f034b6$export$a33b77bbdbb8366c)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $054bf7af52f034b6$export$a33b77bbdbb8366c)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $054bf7af52f034b6$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $054bf7af52f034b6$export$b9a6b53f9be3734)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $054bf7af52f034b6$export$a05254e7c3aeba6e)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $054bf7af52f034b6$export$23ebac1979863676)(spacing), (0, $054bf7af52f034b6$export$23ebac1979863676)(niceMin));
    factor = Math.pow(10, (0, $054bf7af52f034b6$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $054bf7af52f034b6$export$a05254e7c3aeba6e)(Math.round((niceMin + j * spacing) * factor) / factor, min, $352a79de3bee5462$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $054bf7af52f034b6$export$a05254e7c3aeba6e)(ticks[ticks.length - 1].value, max, $352a79de3bee5462$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $352a79de3bee5462$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $054bf7af52f034b6$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $352a79de3bee5462$var$LinearScaleBase extends $352a79de3bee5462$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $054bf7af52f034b6$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $054bf7af52f034b6$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $054bf7af52f034b6$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $352a79de3bee5462$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $054bf7af52f034b6$export$53a70dd1ebbae346)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $054bf7af52f034b6$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $352a79de3bee5462$export$e7f4e5e8656f0b93 extends $352a79de3bee5462$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $054bf7af52f034b6$export$91477dc880baac21).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $054bf7af52f034b6$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $054bf7af52f034b6$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $054bf7af52f034b6$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $352a79de3bee5462$var$log10Floor = (v)=>Math.floor((0, $054bf7af52f034b6$export$9f4f30ee63539e24)(v));
const $352a79de3bee5462$var$changeExponent = (v, m)=>Math.pow(10, $352a79de3bee5462$var$log10Floor(v) + m);
function $352a79de3bee5462$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $352a79de3bee5462$var$log10Floor(tickVal));
    return remain === 1;
}
function $352a79de3bee5462$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $352a79de3bee5462$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $352a79de3bee5462$var$log10Floor(range);
    while($352a79de3bee5462$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($352a79de3bee5462$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $352a79de3bee5462$var$log10Floor(min));
}
function $352a79de3bee5462$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $054bf7af52f034b6$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $352a79de3bee5462$var$log10Floor(min);
    let exp = $352a79de3bee5462$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $054bf7af52f034b6$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $352a79de3bee5462$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $054bf7af52f034b6$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $352a79de3bee5462$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $352a79de3bee5462$export$85295eaf7cb3ac3e extends $352a79de3bee5462$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $054bf7af52f034b6$export$91477dc880baac21).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $352a79de3bee5462$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $054bf7af52f034b6$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $054bf7af52f034b6$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $054bf7af52f034b6$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $054bf7af52f034b6$export$39b482c5e57630a8)(this._userMin)) this.min = min === $352a79de3bee5462$var$changeExponent(this.min, 0) ? $352a79de3bee5462$var$changeExponent(this.min, -1) : $352a79de3bee5462$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($352a79de3bee5462$var$changeExponent(min, -1));
                setMax($352a79de3bee5462$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($352a79de3bee5462$var$changeExponent(max, -1));
        if (max <= 0) setMax($352a79de3bee5462$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $352a79de3bee5462$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $054bf7af52f034b6$export$53a70dd1ebbae346)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $054bf7af52f034b6$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $054bf7af52f034b6$export$9f4f30ee63539e24)(start);
        this._valueRange = (0, $054bf7af52f034b6$export$9f4f30ee63539e24)(this.max) - (0, $054bf7af52f034b6$export$9f4f30ee63539e24)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $054bf7af52f034b6$export$9f4f30ee63539e24)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $352a79de3bee5462$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $054bf7af52f034b6$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $054bf7af52f034b6$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $352a79de3bee5462$var$measureLabelSize(ctx, font, label) {
    label = (0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $054bf7af52f034b6$export$faec65b429be379)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $352a79de3bee5462$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $352a79de3bee5462$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $054bf7af52f034b6$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(opts.font);
        const textSize = $352a79de3bee5462$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $054bf7af52f034b6$export$28f7fcd39efa255)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $054bf7af52f034b6$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $352a79de3bee5462$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $352a79de3bee5462$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $352a79de3bee5462$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $352a79de3bee5462$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $352a79de3bee5462$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $352a79de3bee5462$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $054bf7af52f034b6$export$3a6d5c9ae78a2c08)((0, $054bf7af52f034b6$export$28f7fcd39efa255)(pointLabelPosition.angle + (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd))));
    const y = $352a79de3bee5462$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $352a79de3bee5462$var$getTextAlignForAngle(angle);
    const left = $352a79de3bee5462$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $352a79de3bee5462$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $054bf7af52f034b6$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $054bf7af52f034b6$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $054bf7af52f034b6$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $054bf7af52f034b6$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $352a79de3bee5462$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $352a79de3bee5462$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $054bf7af52f034b6$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $352a79de3bee5462$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $352a79de3bee5462$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $352a79de3bee5462$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $352a79de3bee5462$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $352a79de3bee5462$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $352a79de3bee5462$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $054bf7af52f034b6$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $054bf7af52f034b6$export$92108d983e8ee699)(opts.borderRadius);
        const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $054bf7af52f034b6$export$1fbe638ecf81657e)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $352a79de3bee5462$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $352a79de3bee5462$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $054bf7af52f034b6$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $352a79de3bee5462$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $054bf7af52f034b6$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $352a79de3bee5462$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $352a79de3bee5462$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $352a79de3bee5462$var$createPointLabelContext(parent, index, label) {
    return (0, $054bf7af52f034b6$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $352a79de3bee5462$export$cfafc36d95386d38 extends $352a79de3bee5462$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $054bf7af52f034b6$export$91477dc880baac21).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)($352a79de3bee5462$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $054bf7af52f034b6$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $054bf7af52f034b6$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $352a79de3bee5462$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $352a79de3bee5462$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $352a79de3bee5462$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $054bf7af52f034b6$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $054bf7af52f034b6$export$28f7fcd39efa255)(index * angleMultiplier + (0, $054bf7af52f034b6$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $054bf7af52f034b6$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $054bf7af52f034b6$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $352a79de3bee5462$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $352a79de3bee5462$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $352a79de3bee5462$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $352a79de3bee5462$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $054bf7af52f034b6$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $054bf7af52f034b6$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $352a79de3bee5462$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $352a79de3bee5462$var$UNITS = /* #__PURE__ */ Object.keys($352a79de3bee5462$var$INTERVALS);
function $352a79de3bee5462$var$sorter(a, b) {
    return a - b;
}
function $352a79de3bee5462$var$parse(scale, input) {
    if ((0, $054bf7af52f034b6$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $054bf7af52f034b6$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $054bf7af52f034b6$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $352a79de3bee5462$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $352a79de3bee5462$var$UNITS.length;
    for(let i = $352a79de3bee5462$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $352a79de3bee5462$var$INTERVALS[$352a79de3bee5462$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $352a79de3bee5462$var$UNITS[i];
    }
    return $352a79de3bee5462$var$UNITS[ilen - 1];
}
function $352a79de3bee5462$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $352a79de3bee5462$var$UNITS.length - 1; i >= $352a79de3bee5462$var$UNITS.indexOf(minUnit); i--){
        const unit = $352a79de3bee5462$var$UNITS[i];
        if ($352a79de3bee5462$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $352a79de3bee5462$var$UNITS[minUnit ? $352a79de3bee5462$var$UNITS.indexOf(minUnit) : 0];
}
function $352a79de3bee5462$var$determineMajorUnit(unit) {
    for(let i = $352a79de3bee5462$var$UNITS.indexOf(unit) + 1, ilen = $352a79de3bee5462$var$UNITS.length; i < ilen; ++i){
        if ($352a79de3bee5462$var$INTERVALS[$352a79de3bee5462$var$UNITS[i]].common) return $352a79de3bee5462$var$UNITS[i];
    }
}
function $352a79de3bee5462$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $054bf7af52f034b6$export$2ed0fc6709e59212)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $352a79de3bee5462$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $352a79de3bee5462$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $352a79de3bee5462$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $352a79de3bee5462$export$a894c72689ff3ec extends $352a79de3bee5462$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $352a79de3bee5462$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $054bf7af52f034b6$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $352a79de3bee5462$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $054bf7af52f034b6$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $054bf7af52f034b6$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $054bf7af52f034b6$export$c03999cb2f36933f)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $352a79de3bee5462$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $352a79de3bee5462$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $352a79de3bee5462$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $352a79de3bee5462$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $054bf7af52f034b6$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $054bf7af52f034b6$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $352a79de3bee5462$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $054bf7af52f034b6$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$352a79de3bee5462$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $352a79de3bee5462$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($352a79de3bee5462$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $054bf7af52f034b6$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $352a79de3bee5462$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($352a79de3bee5462$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $054bf7af52f034b6$export$71511d61b312f219)(values.sort($352a79de3bee5462$var$sorter));
    }
}
function $352a79de3bee5462$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $054bf7af52f034b6$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $054bf7af52f034b6$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $352a79de3bee5462$export$85df64a8eb6dc986 extends $352a79de3bee5462$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $352a79de3bee5462$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $352a79de3bee5462$var$interpolate(table, this.min);
        this._tableRange = $352a79de3bee5462$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($352a79de3bee5462$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $352a79de3bee5462$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $352a79de3bee5462$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $352a79de3bee5462$export$29e663ba4d09fe7,
    LinearScale: $352a79de3bee5462$export$e7f4e5e8656f0b93,
    LogarithmicScale: $352a79de3bee5462$export$85295eaf7cb3ac3e,
    RadialLinearScale: $352a79de3bee5462$export$cfafc36d95386d38,
    TimeScale: $352a79de3bee5462$export$a894c72689ff3ec,
    TimeSeriesScale: $352a79de3bee5462$export$85df64a8eb6dc986
});
const $352a79de3bee5462$export$e8959e79e3af550f = [
    $352a79de3bee5462$export$a6506504f799c5d5,
    $352a79de3bee5462$export$7a5d735b2ab6389d,
    $352a79de3bee5462$export$8b3ca321c77fdea6,
    $352a79de3bee5462$export$bcac1c16f1530ec2
];



var $i5lfL = parcelRequire("i5lfL");

const $30e31766597ec5b3$var$defaultDatasetIdKey = "label";
function $30e31766597ec5b3$var$reforwardRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $30e31766597ec5b3$var$setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function $30e31766597ec5b3$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $30e31766597ec5b3$var$setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $30e31766597ec5b3$var$defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $30e31766597ec5b3$var$cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $30e31766597ec5b3$var$defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    $30e31766597ec5b3$var$setLabels(nextData, data.labels);
    $30e31766597ec5b3$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $30e31766597ec5b3$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $30e31766597ec5b3$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $30e31766597ec5b3$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}
function $30e31766597ec5b3$var$ChartComponent(props, ref) {
    const { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode, ...canvasProps } = props;
    const canvasRef = (0, $i5lfL.useRef)(null);
    const chartRef = (0, $i5lfL.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $352a79de3bee5462$export$acaa6426d77a227e)(canvasRef.current, {
            type: type,
            data: $30e31766597ec5b3$var$cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins: plugins
        });
        $30e31766597ec5b3$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $30e31766597ec5b3$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $i5lfL.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $30e31766597ec5b3$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (!redraw && chartRef.current) $30e31766597ec5b3$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $30e31766597ec5b3$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $i5lfL.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, canvasProps), fallbackContent);
}
const $30e31766597ec5b3$export$acaa6426d77a227e = /*#__PURE__*/ (0, $i5lfL.forwardRef)($30e31766597ec5b3$var$ChartComponent);
function $30e31766597ec5b3$var$createTypedChart(type, registerables) {
    (0, $352a79de3bee5462$export$acaa6426d77a227e).register(registerables);
    return /*#__PURE__*/ (0, $i5lfL.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement($30e31766597ec5b3$export$acaa6426d77a227e, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const $30e31766597ec5b3$export$17d680238e50603e = /* #__PURE__ */ $30e31766597ec5b3$var$createTypedChart("line", (0, $352a79de3bee5462$export$3c9b5d28c11cbfd0));
const $30e31766597ec5b3$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $30e31766597ec5b3$var$createTypedChart("bar", (0, $352a79de3bee5462$export$e97d5dc64e999004));
const $30e31766597ec5b3$export$bace472c466fdd25 = /* #__PURE__ */ $30e31766597ec5b3$var$createTypedChart("radar", (0, $352a79de3bee5462$export$48dbc6ac651bf8be));
const $30e31766597ec5b3$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $30e31766597ec5b3$var$createTypedChart("doughnut", (0, $352a79de3bee5462$export$e04603e7d8b77172));
const $30e31766597ec5b3$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $30e31766597ec5b3$var$createTypedChart("polarArea", (0, $352a79de3bee5462$export$2a270b3a0d973c85));
const $30e31766597ec5b3$export$646feb54fbadbe06 = /* #__PURE__ */ $30e31766597ec5b3$var$createTypedChart("bubble", (0, $352a79de3bee5462$export$19b5c4773f17abe));
const $30e31766597ec5b3$export$2ae8800cf67c848c = /* #__PURE__ */ $30e31766597ec5b3$var$createTypedChart("pie", (0, $352a79de3bee5462$export$b21a3f1286706191));
const $30e31766597ec5b3$export$1c460fb4285edadc = /* #__PURE__ */ $30e31766597ec5b3$var$createTypedChart("scatter", (0, $352a79de3bee5462$export$b2f2bae6713db87));


// noinspection GraphQLUnresolvedReference

const $ac579d0a261cef6d$export$3ec344e6b7ada092 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetScenarioResult(
        $inScenarioID: UUID!
        $inState: String,
        $inInfraFlag: String,
        $inSource: String,
        $inResourceGroupID: String,
        $inSuperSectorID: Int,
        $inProjectTypeID: String,
        $inPLEMGroupID: Int,
        $inMasterTypeID: Int
        $inLocationID: String
    ) {
        executeGetScenarioResult(
            inScenarioID: $inScenarioID
            inState: $inState
            inInfraFlag: $inInfraFlag
            inSource: $inSource
            inResourceGroupID: $inResourceGroupID
            inSuperSectorID: $inSuperSectorID
            inProjectTypeID: $inProjectTypeID
            inPLEMGroupID: $inPLEMGroupID
            inMasterTypeID: $inMasterTypeID
            inLocationID: $inLocationID
        ) {
            Month
            Sum_Value
            Sum_Unit
            Scenario_Value
            Scenario_Unit
        }
    }
`;
const $ac579d0a261cef6d$export$147e16abb2a8c6e4 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetScenarioDetailResult(
        $inScenarioID: UUID!
        $inState: String,
        $inInfraFlag: String,
        $inSource: String,
        $inResourceGroupID: String,
        $inSuperSectorID: Int,
        $inProjectTypeID: String,
        $inPLEMGroupID: Int,
        $inMasterTypeID: Int,
        $inDateStart: DateTime,
        $inDateEnd: DateTime
        $inLocationID: String
    ) {
        executeGetScenarioDetailResult(
            inScenarioID: $inScenarioID
            inState: $inState
            inInfraFlag: $inInfraFlag
            inSource: $inSource
            inResourceGroupID: $inResourceGroupID
            inSuperSectorID: $inSuperSectorID
            inProjectTypeID: $inProjectTypeID
            inPLEMGroupID: $inPLEMGroupID
            inMasterTypeID: $inMasterTypeID
            inDateStart: $inDateStart
            inDateEnd: $inDateEnd
            inLocationID: $inLocationID
        ) {
            Year
            Quarter
            QuarterYear
            Project1
            Project2
            Project3
            Project4
            Project5
            Project6
            Project7
            Project8
            Project9
            Project10
            Project11
            Project12
            Project13
            Project14
            Project15
            Project16
            Project17
            Project18
            Project19
            Project20
            RemainingProjects
            Baseline
        }
    }
`;
const $ac579d0a261cef6d$export$6ff65749cbc292f1 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetScenarioProjectDetailResult(
        $inScenarioID: UUID!
        $inMonth: DateTime,
        $inState: String,
        $inInfraFlag: String,
        $inSource: String,
        $inResourceGroupID: String,
        $inSuperSectorID: Int,
        $inProjectTypeID: String,
        $inPLEMGroupID: Int,
        $inMasterTypeID: Int,
        $inLocationID: String
    ) {
        executeGetScenarioProjectDetailResult(
            inScenarioID: $inScenarioID
            inMonth: $inMonth
            inState: $inState
            inInfraFlag: $inInfraFlag
            inSource: $inSource
            inResourceGroupID: $inResourceGroupID
            inSuperSectorID: $inSuperSectorID
            inProjectTypeID: $inProjectTypeID
            inPLEMGroupID: $inPLEMGroupID
            inMasterTypeID: $inMasterTypeID
            inLocationID: $inLocationID
        ) {
            Month
            ProjectName
            Source
            InfraFlag
            State
            LocationName
            Investment
            SuperSector
            MasterType
            RawProjectType
            StartDateConstruction
            EndDateConstruction
            StartDatePlanning
            EndDatePlanning
            StartDateCommissioning
            EndDateCommissioning
            PhaseType
            PLEMGroup
            Lvl1Group
            ResourceGroup
            Sum_Value
            Sum_Unit
            Unit
        }
    }
`;
const $ac579d0a261cef6d$export$f2c0f1e4286f9453 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecutePollScenarioModelProgress(
        $inScenarioID: UUID!
    ) {
        executePollScenarioModelProgress(
            inScenarioID: $inScenarioID
        ) {
            ScenarioID
            IsProcessing
            ScenarioModelRunStatus
        }
    }
`;



const $1ead8ab57e475865$export$af0c0ceddc5967da = (plotQueryProps)=>{
    return {
        responsive: true,
        elements: {
            point: {
                radius: 1
            }
        },
        plugins: {
            legend: {
                position: "right"
            },
            title: {
                display: true,
                text: "Overall trend between baseline and scenario",
                font: {
                    size: 20
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    callback: function(value) {
                        // "this" is accessing the chart context when it gets applied
                        // @ts-ignore
                        let label = $fce7f459a03976d5$exports(this.getLabelForValue(value), "DD/MM/YYYY").month();
                        if (label == 0) // For each month of the year we get a callback. This check will  only plot the single month per year
                        // @ts-ignore
                        return $fce7f459a03976d5$exports(this.getLabelForValue(value)).format("YYYY");
                    }
                },
                grid: {
                    display: false,
                    drawTicks: false
                }
            },
            y: {
                ticks: {
                    maxTicksLimit: 5,
                    callback: function(value) {
                        return (plotQueryProps.unit === 'value' ? '' : '$') + (value / 1000000).toLocaleString() + "M";
                    // The .toLocaleString() method adds a comma separator for thousands.
                    }
                }
            }
        }
    };
};
const $1ead8ab57e475865$export$71c5ef94694b3f88 = [
    {
        name: "State",
        propID: "inState",
        listName: "executeGetState",
        valueKey: "State",
        valueName: "State",
        multiple: true,
        defaultValue: "ALL" //default value to be used for the filter
    },
    {
        name: "Location",
        propID: "inLocationID",
        listName: "executeGetLocationList",
        valueKey: "LocationID",
        valueName: "LocationName",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Source",
        propID: "inSource",
        listName: "executeGetSourceList",
        valueKey: "Source",
        valueName: "Source",
        defaultValue: "ALL"
    },
    {
        name: "Super sector",
        propID: "inSuperSectorID",
        listName: "executeGetSuperSectorsList",
        valueKey: "SuperSectorID",
        valueName: "SuperSector",
        defaultValue: 0
    },
    {
        name: "Master type",
        propID: "inMasterTypeID",
        listName: "executeGetMasterTypesList",
        valueKey: "MasterTypeID",
        valueName: "MasterType",
        defaultValue: 0
    },
    {
        name: "Project type",
        propID: "inProjectTypeID",
        listName: "executeGetRawProjectTypes",
        valueKey: "RawProjectTypeID",
        valueName: "RawProjectType",
        multiple: true,
        defaultValue: 0
    },
    {
        name: "Infra-flag",
        propID: "inInfraFlag",
        listName: "executeGetInfraFlagsList",
        valueKey: "InfraFlag",
        valueName: "InfraFlag",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Plant/Labour/Equipment/Material",
        propID: "inPLEMGroupID",
        listName: "executeGetPLEMTypesList",
        valueKey: "PLEMGroupID",
        valueName: "PLEMGroup",
        defaultValue: 0
    },
    {
        name: "Resource group",
        propID: "inResourceGroupID",
        listName: "executeGetResourceGroupsList",
        valueKey: "ResourceGroupID",
        valueName: "ResourceGroup",
        multiple: true,
        defaultValue: 0
    }
];



var $bHJbJ = parcelRequire("bHJbJ");
parcelRequire("i5lfL");

function $3da0b51f836cadba$export$2e2bcd8739ae039(props) {
    const { AllLists: AllLists, plotQueryProps: plotQueryProps, setPlotQueryProps: setPlotQueryProps, filterConfigList: filterConfigList } = props;
    return filterConfigList.map((item, index)=>{
        return(// eslint-disable-next-line react/jsx-key
        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
            item: true,
            xs: 1,
            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                label: item.name,
                name: item.propID,
                onChange: (e)=>{
                    let result;
                    if (typeof e.target.value === 'object') {
                        if (plotQueryProps[e.target.name].indexOf(item.defaultValue) < 0) // @ts-ignore
                        {
                            if (e.target.value.indexOf(item.defaultValue) >= 0) result = [
                                item.defaultValue
                            ];
                        } else // @ts-ignore
                        result = e.target.value.filter((i)=>i != item.defaultValue);
                    }
                    setPlotQueryProps({
                        ...plotQueryProps,
                        [e.target.name]: result ?? e.target.value
                    });
                },
                select: true,
                required: true,
                fullWidth: true,
                value: plotQueryProps[item.propID],
                variant: "filled",
                defaultValue: item.defaultValue,
                size: "small",
                SelectProps: {
                    multiple: item.multiple
                },
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                        value: item.defaultValue,
                        children: "ALL"
                    }, "ALL"),
                    $3da0b51f836cadba$var$updateFilter(AllLists, item, plotQueryProps)?.map((option)=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                            value: option[item.valueKey],
                            children: option[item.valueName]
                        }, option[item.valueKey]))
                ]
            }, index)
        }, index));
    });
}
function $3da0b51f836cadba$var$updateFilter(AllList, filterConfigItem, plotQueryProps) {
    switch(filterConfigItem.listName){
        case 'executeGetLocationList':
            if (plotQueryProps["inState"] == 'ALL') return AllList?.[filterConfigItem.listName];
            else return AllList?.[filterConfigItem.listName].filter((item)=>item.State == plotQueryProps["inState"]);
        default:
            return AllList?.[filterConfigItem.listName];
    }
}




function $3ea34f33e6953e05$export$2e2bcd8739ae039(params) {
    let result = {};
    Object.keys(params).map((item)=>{
        if (typeof params[item] == 'object') {
            if (params[item].indexOf('ALL') < 0 && params[item].indexOf(0) < 0) result[item] = params[item].map((item)=>{
                return "'" + item + "'";
            }).toString();
            else // when 'ALL' filter is selected, neglect other selections
            result[item] = params[item].indexOf('ALL') >= 0 ? 'ALL' : '0';
        } else result[item] = params[item];
    });
    return result;
}








var $bHJbJ = parcelRequire("bHJbJ");
parcelRequire("i5lfL");

var $7qXFD = parcelRequire("7qXFD");

var $1CWiu = parcelRequire("1CWiu");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");


var $2ktY3 = parcelRequire("2ktY3");

var $d8Gg3 = parcelRequire("d8Gg3");

var $VEXgj = parcelRequire("VEXgj");

var $kp44S = parcelRequire("kp44S");

var $j7y1Z = parcelRequire("j7y1Z");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $9a338c977ad6f781$export$29cad1383b3f235d(slot) {
    return (0, $6bbZp.default)('MuiCircularProgress', slot);
}
const $9a338c977ad6f781$var$circularProgressClasses = (0, $47i1c.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $9a338c977ad6f781$export$2e2bcd8739ae039 = $9a338c977ad6f781$var$circularProgressClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $a031c40c249160f5$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $a031c40c249160f5$var$_ = (t)=>t, $a031c40c249160f5$var$_t, $a031c40c249160f5$var$_t2, $a031c40c249160f5$var$_t3, $a031c40c249160f5$var$_t4;
const $a031c40c249160f5$var$SIZE = 44;
const $a031c40c249160f5$var$circularRotateKeyframe = (0, $d8Gg3.keyframes)($a031c40c249160f5$var$_t || ($a031c40c249160f5$var$_t = $a031c40c249160f5$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $a031c40c249160f5$var$circularDashKeyframe = (0, $d8Gg3.keyframes)($a031c40c249160f5$var$_t2 || ($a031c40c249160f5$var$_t2 = $a031c40c249160f5$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $a031c40c249160f5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $VEXgj.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $VEXgj.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $9a338c977ad6f781$export$29cad1383b3f235d), classes);
};
const $a031c40c249160f5$var$CircularProgressRoot = (0, $j7y1Z.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $VEXgj.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $1CWiu.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $d8Gg3.css)($a031c40c249160f5$var$_t3 || ($a031c40c249160f5$var$_t3 = $a031c40c249160f5$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $a031c40c249160f5$var$circularRotateKeyframe));
const $a031c40c249160f5$var$CircularProgressSVG = (0, $j7y1Z.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $a031c40c249160f5$var$CircularProgressCircle = (0, $j7y1Z.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $VEXgj.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $1CWiu.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $d8Gg3.css)($a031c40c249160f5$var$_t4 || ($a031c40c249160f5$var$_t4 = $a031c40c249160f5$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $a031c40c249160f5$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $a031c40c249160f5$var$CircularProgress = /*#__PURE__*/ $i5lfL.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $7qXFD.default)(props, $a031c40c249160f5$var$_excluded);
    const ownerState = (0, $1CWiu.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $a031c40c249160f5$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($a031c40c249160f5$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($a031c40c249160f5$var$CircularProgressRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        style: (0, $1CWiu.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)($a031c40c249160f5$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$a031c40c249160f5$var$SIZE / 2} ${$a031c40c249160f5$var$SIZE / 2} ${$a031c40c249160f5$var$SIZE} ${$a031c40c249160f5$var$SIZE}`,
            children: /*#__PURE__*/ (0, $bHJbJ.jsx)($a031c40c249160f5$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $a031c40c249160f5$var$SIZE,
                cy: $a031c40c249160f5$var$SIZE,
                r: ($a031c40c249160f5$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $a031c40c249160f5$export$2e2bcd8739ae039 = $a031c40c249160f5$var$CircularProgress;


const $61279aa0c0336861$var$ProcessExecutionDialog = ({ open: open, title: title })=>{
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039), {
        open: open,
        "aria-describedby": "scenario-generation-progress",
        maxWidth: "xs",
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $48d8f4c3325a9037$export$2e2bcd8739ae039), {
                id: "scenario-generation-progress",
                children: title
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '60px'
                },
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a031c40c249160f5$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $61279aa0c0336861$export$2e2bcd8739ae039 = $61279aa0c0336861$var$ProcessExecutionDialog;
function $61279aa0c0336861$export$ec05a79d47b373aa(arr, item, index) {
    if (arr.indexOf(item) != index) return item + index.toString();
    return item;
}



var $bHJbJ = parcelRequire("bHJbJ");
parcelRequire("i5lfL");


const $236f55c7b4d72fa4$var$ExportDialogs = ({ showExportWarning: showExportWarning, onCloseExportWarning: onCloseExportWarning, showExportConfirmation: showExportConfirmation, onCloseExportConfirmation: onCloseExportConfirmation, startExport: startExport, isExporting: isExporting, plotQueryProps: plotQueryProps, monthLabels: monthLabels, totalMonths: totalMonths, exportProgress: exportProgress })=>{
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
        children: [
            showExportWarning && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $097160938072b98e$export$2e2bcd8739ae039), {
                severity: "warning",
                onClose: onCloseExportWarning,
                children: "Exporting data for all states is not supported. Please select a specific state."
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039), {
                open: showExportConfirmation,
                onClose: onCloseExportConfirmation,
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $48d8f4c3325a9037$export$2e2bcd8739ae039), {
                        children: "Confirm Export"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $422502a3833a93e2$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                            children: [
                                "You are about to output scenario data for state: ",
                                plotQueryProps.inState.join(', '),
                                " from ",
                                monthLabels?.[0] ? (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(monthLabels[0], 'DD/MM/YYYY').format('MMM YYYY') : '',
                                " to ",
                                monthLabels?.[monthLabels.length - 1] ? (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(monthLabels[monthLabels.length - 1], 'DD/MM/YYYY').format('MMM YYYY') : '',
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $0d4f9b05ed57077c$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                onClick: onCloseExportConfirmation,
                                children: "No"
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                onClick: startExport,
                                children: "Yes"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039), {
                open: isExporting,
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $48d8f4c3325a9037$export$2e2bcd8739ae039), {
                        children: "Exporting to CSV"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a031c40c249160f5$export$2e2bcd8739ae039), {
                                sx: {
                                    mb: 2
                                }
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                children: "Preparing your file. This may take a moment..."
                            }),
                            totalMonths > 0 && /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '100%',
                                    mt: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $2fce601e44012509$export$2e2bcd8739ae039), {
                                        variant: "determinate",
                                        value: exportProgress / totalMonths * 100
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        color: "text.secondary",
                                        sx: {
                                            mt: 1
                                        },
                                        align: "center",
                                        children: [
                                            exportProgress,
                                            " of ",
                                            totalMonths,
                                            " months processed."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $236f55c7b4d72fa4$export$2e2bcd8739ae039 = $236f55c7b4d72fa4$var$ExportDialogs;


(0, $352a79de3bee5462$export$acaa6426d77a227e).register((0, $352a79de3bee5462$export$c537fa0d021d010b), (0, $352a79de3bee5462$export$29e663ba4d09fe7), (0, $352a79de3bee5462$export$e7f4e5e8656f0b93), (0, $352a79de3bee5462$export$a16ed71bf4b07672), (0, $352a79de3bee5462$export$bd159b522b230b7a), (0, $352a79de3bee5462$export$55e463fa7bcd3469), (0, $352a79de3bee5462$export$f99233281efd08a0), (0, $352a79de3bee5462$export$28c660c63b792dea), (0, $352a79de3bee5462$export$ed247974535929c7), (0, $352a79de3bee5462$export$3c9b5d28c11cbfd0), (0, $352a79de3bee5462$export$e97d5dc64e999004));
function $b162db26bb447b0f$var$TabPanel(props) {
    const { children: children, value: value, index: index, ...other } = props;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        role: "tabpanel",
        className: "tabPanelBox",
        hidden: value !== index,
        id: `simple-tabpanel-${index}`,
        "aria-labelledby": `simple-tab-${index}`,
        ...other,
        sx: {
            border: 2
        },
        children: value === index && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
            className: "tabBox",
            sx: {
                p: 1
            },
            children: children
        })
    });
}
function $b162db26bb447b0f$var$a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`
    };
}
function $b162db26bb447b0f$export$2e2bcd8739ae039(props) {
    const { setTabIndex: setTabIndex, scenarioID: scenarioID, modelFlag: modelFlag } = props;
    const client = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)();
    const { data: userInfo } = (0, $8aac0537827a6bae$export$801fe16824f675f7)();
    function handleUpdateTab(index) {
        setTabIndex(index);
    }
    const [dashTabIndex, setDashTabIndex] = (0, $i5lfL.useState)(0);
    const [pollScenarioProgress, setPollScenarioProgress] = (0, $i5lfL.useState)({
        isProcessing: true,
        scenarioModelRunStatus: (0, $243a1246ea7835d9$export$e14144b8dabac519)
    });
    const [isExporting, setIsExporting] = (0, $i5lfL.useState)(false);
    const [exportProgress, setExportProgress] = (0, $i5lfL.useState)(0);
    const [totalMonths, setTotalMonths] = (0, $i5lfL.useState)(0);
    const [shouldRefetch, setShouldRefetch] = (0, $i5lfL.useState)(false);
    const [showExportWarning, setShowExportWarning] = (0, $i5lfL.useState)(false);
    const [showExportConfirmation, setShowExportConfirmation] = (0, $i5lfL.useState)(false);
    const [plotRange, setPlotRange] = (0, $i5lfL.useState)([
        new Date().getFullYear(),
        new Date().getFullYear() + 16
    ]);
    const handleDashTabChange = (event, newValue)=>{
        setDashTabIndex(newValue);
    };
    // Fix the issue pollProgress is called before the runModel
    (0, $i5lfL.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setShouldRefetch(true);
        }, 2000); // Set the delay in milliseconds (2000 ms = 2 seconds)
        return ()=>clearTimeout(timer); // Clean up the timer on component unmount
    }, []);
    const { data: AllLists } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "Lists"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$b9bf64b597697c8a),
                variables: {
                    // @ts-ignore
                    inJurisdiction: userInfo?.executeGetUser[0].Jurisdiction ?? "",
                    inScenarioID: scenarioID
                },
                instance: instance,
                accounts: accounts
            });
        },
        enabled: !!userInfo
    });
    // react query to get progress
    const { data: scenarioProgress } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "ScenarioProgress"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $ac579d0a261cef6d$export$f2c0f1e4286f9453),
                variables: {
                    inScenarioID: scenarioID
                },
                instance: instance,
                accounts: accounts
            });
        },
        refetchInterval: shouldRefetch ? 2000 : false,
        enabled: shouldRefetch,
        onSuccess: (data)=>{
            //@ts-ignore
            const scenarioModelProgress = data?.executePollScenarioModelProgress;
            if (scenarioModelProgress) {
                setPollScenarioProgress({
                    isProcessing: scenarioModelProgress[0].IsProcessing === 0 ? false : true,
                    scenarioModelRunStatus: scenarioModelProgress[0].ScenarioModelRunStatus ? scenarioModelProgress[0].ScenarioModelRunStatus : (0, $243a1246ea7835d9$export$e14144b8dabac519)
                });
                if (scenarioModelProgress[0].IsProcessing === 0) // Stop refetching when processing is done
                setShouldRefetch(false);
            }
        }
    });
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    let scenarioTitle = "";
    // @ts-ignore
    client.getQueryData([
        "scenarioList"
    ])?.executeGetScenarioList.map((item)=>{
        if (item.ScenarioID == scenarioID) scenarioTitle = item.ScenarioTitle;
    });
    const [plotQueryProps, setPlotQueryProps] = (0, $i5lfL.useState)({
        inScenarioID: scenarioID,
        // @ts-ignore
        inState: userInfo?.executeGetUser[0].Jurisdiction !== "IA" ? [
            userInfo?.executeGetUser[0].Jurisdiction
        ] : [
            "ALL"
        ],
        inInfraFlag: [
            "ALL"
        ],
        inSource: "ALL",
        inLocationID: [
            "ALL"
        ],
        inResourceGroupID: [
            0
        ],
        inSuperSectorID: 0,
        inProjectTypeID: [
            0
        ],
        inPLEMGroupID: 0,
        inMasterTypeID: 0,
        unit: 0,
        inDateStart: new Date().getFullYear() + "-07-01"
    });
    const { data: scenarioResult, isFetching: isScenarioFetching } = (0, $45631327982d6a29$export$dd0a697e1782aedd)([
        "scenarioResult",
        'plot',
        plotQueryProps
    ], {
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $ac579d0a261cef6d$export$3ec344e6b7ada092),
                variables: (0, $3ea34f33e6953e05$export$2e2bcd8739ae039)({
                    ...plotQueryProps,
                    inDateEnd: new Date().getFullYear() + 16 + "-06-01"
                }),
                instance: instance,
                accounts: accounts
            });
        },
        enabled: !pollScenarioProgress.isProcessing,
        refetchOnWindowFocus: false
    });
    const { data: scenarioDetailedResult, isFetching: isScenarioDetailedResultFetching } = (0, $45631327982d6a29$export$dd0a697e1782aedd)([
        'scenarioDetailedResult',
        'plot',
        plotQueryProps
    ], {
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $ac579d0a261cef6d$export$147e16abb2a8c6e4),
                variables: (0, $3ea34f33e6953e05$export$2e2bcd8739ae039)({
                    ...plotQueryProps,
                    inDateEnd: new Date().getFullYear() + 5 + "-06-01"
                }),
                instance: instance,
                accounts: accounts
            });
        },
        enabled: !pollScenarioProgress.isProcessing,
        refetchOnWindowFocus: false
    });
    // @ts-ignore
    const years = scenarioResult?.executeGetScenarioResult.map((item)=>(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(item.Month).year());
    const minPlotRange = years?.[0] ?? new Date().getFullYear();
    const maxPlotRange = years?.[years.length - 1] ?? new Date().getFullYear() + 16;
    const minRange = 1;
    (0, $i5lfL.useEffect)(()=>{
        if (years && years.length > 0) setPlotRange([
            years[0],
            years[years.length - 1]
        ]);
    }, [
        scenarioResult
    ]);
    const handleSliderChange = (event, newValue, activeThumb)=>{
        if (!Array.isArray(newValue)) return;
        if (newValue[1] - newValue[0] < minRange) {
            if (activeThumb === 0) {
                const clamped = Math.min(newValue[0], maxPlotRange - minRange);
                setPlotRange([
                    clamped,
                    clamped + minRange
                ]);
            } else {
                const clamped = Math.max(newValue[1], minRange);
                setPlotRange([
                    clamped - minRange,
                    clamped
                ]);
            }
        } else setPlotRange(newValue);
    };
    const plotStartIndex = years?.indexOf(plotRange[0]);
    const plotEndIndex = years?.lastIndexOf(plotRange[1]);
    // @ts-ignore
    const slicedResult = scenarioResult?.executeGetScenarioResult.slice(plotStartIndex === -1 ? 0 : plotStartIndex, plotEndIndex === -1 ? undefined : plotEndIndex + 1);
    const monthLabels = slicedResult?.map((item)=>(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(item.Month).format("DD/MM/YYYY"));
    const dataset1 = slicedResult?.map((item)=>plotQueryProps.unit ? item.Sum_Unit : item.Sum_Value);
    const dataset2 = slicedResult?.map((item)=>plotQueryProps.unit ? item.Scenario_Unit : item.Scenario_Value);
    // @ts-ignore
    const datasetHeaders = Object.keys(scenarioDetailedResult?.executeGetScenarioDetailResult[0] ?? []);
    // @ts-ignore
    let baselineSum = 0;
    // @ts-ignore
    const projectSet = datasetHeaders.map((key)=>scenarioDetailedResult?.executeGetScenarioDetailResult.map((item)=>item[key]));
    const [scenarioSum, setScenarioSum] = (0, $i5lfL.useState)(0);
    (0, $i5lfL.useEffect)(()=>setScenarioSum(projectSet.slice(3, 24).reduce((sum, item)=>sum + item.slice(1).reduce((partialSum, a)=>partialSum + (Number(a) ? Number(a) : 0), 0), 0)), [
        scenarioDetailedResult
    ]);
    const labelList = projectSet.slice(3, 25).map((item)=>item[0]);
    const detailedPlotDataset = projectSet.slice(3, 25).map((item, index)=>{
        if (projectSet.slice(3)[index][0] != 'Baseline') {
            if (projectSet.slice(3)[index][0]) return {
                type: 'bar',
                label: (0, $61279aa0c0336861$export$ec05a79d47b373aa)(labelList, projectSet.slice(3)[index][0], index),
                data: projectSet.slice(3)[index].slice(1),
                backgroundColor: (0, $243a1246ea7835d9$export$64b7d035b35e2190)[index % (0, $243a1246ea7835d9$export$64b7d035b35e2190).length]
            };
        } else {
            baselineSum = projectSet.slice(3)[index].reduce((partialSum, a)=>partialSum + (Number(a) ? Number(a) : 0), 0);
            return {
                type: 'line',
                label: projectSet.slice(3)[index][0],
                data: projectSet.slice(3)[index].slice(1),
                backgroundColor: (0, $243a1246ea7835d9$export$64b7d035b35e2190)[index % (0, $243a1246ea7835d9$export$64b7d035b35e2190).length]
            };
        }
    }).filter((elem)=>{
        return elem !== undefined && elem?.data.reduce((partialSum, a)=>partialSum + (Number(a) ? Number(a) : 0), 0) > 0;
    });
    const DetailedData = {
        labels: projectSet[2]?.slice(1),
        datasets: detailedPlotDataset.reverse() ?? []
    };
    const data = {
        labels: monthLabels,
        datasets: [
            {
                type: "line",
                label: "Baseline Trend",
                data: dataset1,
                borderColor: "#253746",
                backgroundColor: "#253746"
            },
            {
                type: "line",
                label: "Scenario Trend",
                data: dataset2,
                borderColor: "#7e2d40",
                backgroundColor: "#7e2d40"
            }
        ]
    };
    // Plot config for detailed stack plot
    const detailTrendOptions = {
        animation: false,
        elements: {
            point: {
                radius: 1
            },
            line: {
                borderColor: '#000000',
                borderWidth: 1,
                fill: false
            }
        },
        plugins: {
            legend: {
                position: "right",
                reverse: true
            },
            title: {
                display: true,
                text: "Five-year view between baseline and scenario",
                font: {
                    size: 20
                }
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        let label = context.dataset.label || '';
                        if (label) label += ': ';
                        if (context.parsed.y !== null) label += (context.parsed.y / 1000000000).toFixed(2) + "Billion";
                        return label;
                    },
                    afterBody: function(context) {
                        let body = Number(Object.values(context[0].parsed._stacks.y).reduce((partialSum, a)=>partialSum + (Number(a) ? Number(a) : 0), 0));
                        return "Quarter total: " + (body / 1000000000).toFixed(2) + "Billion";
                    }
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: false,
                    drawTicks: false
                }
            },
            y: {
                ticks: {
                    count: 5,
                    callback: function(value) {
                        // Checking if the unit is 0 to decide whether to prepend '$'
                        var prefix = plotQueryProps.unit === 0 ? '$ ' : '';
                        // Formatting the value and adding commas
                        var formattedValue = (value / 1000000).toLocaleString();
                        // Concatenating the prefix and formatted value with 'M' suffix
                        return prefix + formattedValue + "M";
                    }
                },
                stacked: true
            }
        }
    };
    const chartRef = (0, $i5lfL.useRef)(null);
    (0, $i5lfL.useEffect)(()=>{
        if (chartRef.current) setScenarioSum(chartRef.current.getSortedVisibleDatasetMetas().slice(1).reduce(// @ts-ignore
        (sum, item)=>sum + item._parsed.reduce(// @ts-ignore
            (partialSum, item)=>partialSum + (Number(item.y) ? Number(item.y) : 0), 0), 0));
    }, [
        chartRef.current?.getSortedVisibleDatasetMetas()
    ]);
    async function startExport() {
        setShowExportConfirmation(false);
        setIsExporting(true);
        setExportProgress(0);
        setTotalMonths(0);
        try {
            const months = monthLabels.map((label)=>(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(label, 'DD/MM/YYYY').format('YYYY-MM-01'));
            setTotalMonths(months.length);
            console.log(plotQueryProps.inState);
            if (plotQueryProps.inState.includes("ALL")) {
                setShowExportWarning(true);
                setIsExporting(false);
                return;
            }
            const results = [];
            for(let i = 0; i < months.length; i++){
                const month = months[i];
                const variables = {
                    ...plotQueryProps,
                    inMonth: month
                };
                const result = await (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                    query: (0, $ac579d0a261cef6d$export$6ff65749cbc292f1),
                    variables: (0, $3ea34f33e6953e05$export$2e2bcd8739ae039)(variables),
                    instance: instance,
                    accounts: accounts
                });
                // @ts-ignore
                results.push(result);
                setExportProgress(i + 1);
            }
            // @ts-ignore
            const combinedData = results.flatMap((result)=>result?.executeGetScenarioProjectDetailResult || []);
            if (combinedData.length === 0) {
                console.warn("No data available for the selected criteria to export.");
                // Optionally, show a message to the user
                return;
            }
            const workbook = new $1cb7ac08e18fc2ca$exports.Workbook();
            const worksheet = workbook.addWorksheet("Detailed Project Data");
            worksheet.columns = Object.keys(combinedData[0]).map((key)=>({
                    header: key,
                    key: key,
                    width: 20
                }));
            worksheet.addRows(combinedData);
            const buffer = await workbook.csv.writeBuffer();
            const blob = new Blob([
                buffer
            ], {
                type: "text/csv;charset=utf-8;"
            });
            (0, $c81b9af5835f71db$exports.saveAs)(blob, "ScenarioDetailedProjectResult.csv");
        } catch (error) {
            console.error("Error exporting data:", error);
        // Optionally, inform the user about the error
        } finally{
            setIsExporting(false);
        }
    }
    function handleOutputResult() {
        setShowExportConfirmation(true);
    }
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $236f55c7b4d72fa4$export$2e2bcd8739ae039), {
                showExportWarning: showExportWarning,
                onCloseExportWarning: ()=>setShowExportWarning(false),
                showExportConfirmation: showExportConfirmation,
                onCloseExportConfirmation: ()=>setShowExportConfirmation(false),
                startExport: startExport,
                isExporting: isExporting,
                plotQueryProps: plotQueryProps,
                monthLabels: monthLabels,
                totalMonths: totalMonths,
                exportProgress: exportProgress
            }),
            !pollScenarioProgress.isProcessing && !isScenarioFetching && /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                alignItems: 'center',
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 10,
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                className: "tabSelectorBox",
                                children: [
                                    modelFlag && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $2fce601e44012509$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $bd3cee31033a2ffb$export$2e2bcd8739ae039), {
                                        value: dashTabIndex,
                                        onChange: handleDashTabChange,
                                        indicatorColor: "secondary",
                                        textColor: "inherit",
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                                                label: "Overall trend",
                                                ...$b162db26bb447b0f$var$a11yProps(0)
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                                                label: "Five-year view",
                                                ...$b162db26bb447b0f$var$a11yProps(1)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)($b162db26bb447b0f$var$TabPanel, {
                                value: dashTabIndex,
                                index: 0,
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30e31766597ec5b3$export$acaa6426d77a227e), {
                                        type: "bar",
                                        options: (0, $1ead8ab57e475865$export$af0c0ceddc5967da)(plotQueryProps),
                                        data: data
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $36fe94807ea896b0$export$2e2bcd8739ae039), {
                                        getAriaLabel: ()=>"Plot Range",
                                        value: plotRange,
                                        onChange: handleSliderChange,
                                        valueLabelDisplay: "on",
                                        disableSwap: true,
                                        step: 1,
                                        marks: true,
                                        min: minPlotRange,
                                        max: maxPlotRange
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)($b162db26bb447b0f$var$TabPanel, {
                                value: dashTabIndex,
                                index: 1,
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 2,
                                        justifyContent: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                                item: true,
                                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $fa105ed17f31a2c8$export$2e2bcd8739ae039), {
                                                    elevation: 3,
                                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                                        variant: "h3",
                                                        p: 1,
                                                        children: [
                                                            "Baseline total: $ ",
                                                            (baselineSum / 1000000000).toFixed(2),
                                                            " Billion"
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                                item: true,
                                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $fa105ed17f31a2c8$export$2e2bcd8739ae039), {
                                                    elevation: 3,
                                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                                        variant: "h3",
                                                        p: 1,
                                                        children: [
                                                            "Scenario total: $ ",
                                                            (scenarioSum / 1000000000).toFixed(2),
                                                            " Billion"
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    // @ts-ignore
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30e31766597ec5b3$export$acaa6426d77a227e), {
                                        type: "bar",
                                        ref: chartRef,
                                        options: detailTrendOptions,
                                        data: DetailedData
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 2,
                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 1,
                            columns: 1,
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 1,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                        variant: "h3",
                                        align: "center",
                                        children: scenarioTitle.toUpperCase()
                                    })
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3da0b51f836cadba$export$2e2bcd8739ae039), {
                                    AllLists: AllLists,
                                    plotQueryProps: plotQueryProps,
                                    setPlotQueryProps: setPlotQueryProps,
                                    filterConfigList: (0, $1ead8ab57e475865$export$71c5ef94694b3f88)
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 1,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                                        title: "Display Unit Filter",
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $5a88d895317a42d5$export$2e2bcd8739ae039), {
                                            value: plotQueryProps.unit,
                                            exclusive: true,
                                            onChange: (event, value)=>{
                                                if (value != null) setPlotQueryProps({
                                                    ...plotQueryProps,
                                                    unit: value
                                                });
                                            },
                                            "aria-label": "Display Unit Filter",
                                            fullWidth: true,
                                            size: "small"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 1,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            justifyContent: 'center'
                                        },
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                            onClick: handleOutputResult,
                                            variant: "contained",
                                            children: [
                                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($188d7627f9b29063$exports))), {}),
                                                "Export scenario results"
                                            ]
                                        }, "outputbutton")
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $61279aa0c0336861$export$2e2bcd8739ae039), {
                open: pollScenarioProgress.isProcessing,
                title: pollScenarioProgress.scenarioModelRunStatus
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $61279aa0c0336861$export$2e2bcd8739ae039), {
                open: !pollScenarioProgress.isProcessing && isScenarioFetching,
                title: (0, $243a1246ea7835d9$export$26b866ce2249164d)
            })
        ]
    });
}



var $bHJbJ = parcelRequire("bHJbJ");

parcelRequire("i5lfL");
function $d05942294bd40f71$var$TabPanel(props) {
    const { children: children, value: value, index: index, ...other } = props;
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        role: "tabpanel",
        className: "tabPanelBox",
        hidden: value !== index,
        id: `simple-tabpanel-${index}`,
        "aria-labelledby": `simple-tab-${index}`,
        ...other,
        children: value === index && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
            className: "tabBox",
            sx: {
                p: 2
            },
            children: children
        })
    });
}
var $d05942294bd40f71$export$2e2bcd8739ae039 = $d05942294bd40f71$var$TabPanel;







function $2844868c7047587e$var$a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`
    };
}
function $2844868c7047587e$export$2e2bcd8739ae039() {
    const [tabIndex, setTabIndex] = $i5lfL.useState(0);
    const [scenarioID, setScenarioID] = $i5lfL.useState("");
    const handleChange = (event, newValue)=>{
        setTabIndex(newValue);
    };
    const client = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)();
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const { mutate: runScenarioModel, error: error, isLoading: isLoading } = (0, $d5a0a75b5a6b57e1$export$609860bf8b0084c)([
        "RunModel"
    ], {
        mutationFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $97b2fb033105cd13$export$1b04b6a0193d537),
                variables: {
                    inScenarioID: scenarioID
                },
                instance: instance,
                accounts: accounts
            });
        },
        onSuccess: ()=>{
            client.invalidateQueries([
                "plot"
            ]).then();
        }
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        className: "tabBox-root",
        sx: {
            Height: "80%"
        },
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                className: "tabSelectorBox",
                children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $bd3cee31033a2ffb$export$2e2bcd8739ae039), {
                    value: tabIndex,
                    onChange: handleChange,
                    indicatorColor: "secondary",
                    textColor: "inherit",
                    children: [
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                            label: "Start",
                            ...$2844868c7047587e$var$a11yProps(0),
                            disabled: tabIndex == 0
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                            label: "Projects",
                            ...$2844868c7047587e$var$a11yProps(1),
                            disabled: tabIndex == 0
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                            label: "Assumptions",
                            ...$2844868c7047587e$var$a11yProps(2),
                            disabled: tabIndex == 0
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                            label: "Output",
                            ...$2844868c7047587e$var$a11yProps(3),
                            disabled: tabIndex == 0
                        })
                    ]
                })
            }),
            !!error && !isLoading && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $097160938072b98e$export$2e2bcd8739ae039), {
                severity: "warning",
                children: "Unable to retrieve updated model result now. Please try again later"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d05942294bd40f71$export$2e2bcd8739ae039), {
                value: tabIndex,
                index: 0,
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1405e9d2372e4666$export$2e2bcd8739ae039), {
                    setTabIndex: setTabIndex,
                    setScenarioID: setScenarioID
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d05942294bd40f71$export$2e2bcd8739ae039), {
                value: tabIndex,
                index: 1,
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $4a0b61caf523d116$export$2e2bcd8739ae039), {
                    setTabIndex: setTabIndex,
                    scenarioID: scenarioID,
                    runModel: runScenarioModel
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d05942294bd40f71$export$2e2bcd8739ae039), {
                value: tabIndex,
                index: 2,
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $cf890d33f84e8055$export$2e2bcd8739ae039), {
                    setTabIndex: setTabIndex,
                    scenarioID: scenarioID,
                    runModel: runScenarioModel
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $d05942294bd40f71$export$2e2bcd8739ae039), {
                value: tabIndex,
                index: 3,
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b162db26bb447b0f$export$2e2bcd8739ae039), {
                        setTabIndex: setTabIndex,
                        scenarioID: scenarioID,
                        modelFlag: isLoading
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            fontStyle: "italic",
                            fontWeight: 700,
                            mt: 2,
                            fontFamily: "ProximaNova-Bold"
                        },
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                            children: (0, $d29d6d1034e01aa1$export$f68e326d679cfc85)
                        })
                    })
                ]
            })
        ]
    });
}



var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");





// noinspection GraphQLUnresolvedReference

const $8e9c3aa7483f6f4a$export$c610b2b5a1144b7 = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetNationalModelPlot (
        $inInfraFlag: String,
        $inSource: String,
        $inResourceGroupID: String,
        $inSuperSectorID: Int,
        $inProjectTypeID: String,
        $inPLEMGroupID: Int,
        $inMasterTypeID: Int,
        $inLevel1GroupID: Int,
        $inLevel2GroupID: Int,
        $inFundingMode: String
        $inUserSID: UUID!
    ) {
        executeGetNationalModelPlot(
            inInfraFlag: $inInfraFlag
            inSource: $inSource
            inResourceGroupID: $inResourceGroupID
            inSuperSectorID: $inSuperSectorID
            inProjectTypeID: $inProjectTypeID
            inPLEMGroupID: $inPLEMGroupID
            inMasterTypeID: $inMasterTypeID
            inLevel1GroupID: $inLevel1GroupID
            inLevel2GroupID: $inLevel2GroupID
            inFundingMode: $inFundingMode
            inUserSID: $inUserSID
        ) {
            Month
            PlantValue
            PlantUnit
            LabourValue
            LabourUnit
            EquipmentValue
            EquipmentUnit
            MaterialValue
            MaterialUnit
            Sum_Unit
            Sum_Value
        }
    }
`;




parcelRequire("i5lfL");

const $2c31cf03aa363fe5$export$9923a1559b8378b = (plotQueryProps)=>{
    return {
        type: 'line',
        responsive: true,
        elements: {
            point: {
                radius: 1
            }
        },
        plugins: {
            legend: {
                position: "right"
            },
            title: {
                fullSize: true,
                font: {
                    size: 20
                },
                display: true,
                text: "Infrastructure Australia - Market Capacity Report (Plant/Labour/Equipment/Material view)"
            }
        },
        scales: {
            x: {
                ticks: {
                    callback: function(value) {
                        // "this" is accessing the chart context when it gets applied
                        // @ts-ignore
                        let label = $fce7f459a03976d5$exports(this.getLabelForValue(value), "DD/MM/YYYY").month();
                        if (label == 0) // For each month of the year we get a callback. This check will  only plot the single month per year
                        // @ts-ignore
                        return $fce7f459a03976d5$exports(this.getLabelForValue(value)).format("YYYY");
                    }
                },
                grid: {
                    display: false,
                    drawTicks: false
                }
            },
            y: {
                stacked: true,
                ticks: {
                    maxTicksLimit: 5,
                    callback: function(value) {
                        return (plotQueryProps.unit == 'Value' ? '$' : '') + (value / 1000000).toLocaleString() + "M";
                    // The .toLocaleString() method adds a comma separator for thousands.
                    }
                }
            }
        }
    };
};
const $2c31cf03aa363fe5$export$b7a63542bd740eaa = [
    {
        name: "Super sector",
        propID: "inSuperSectorID",
        listName: "executeGetSuperSectorsList",
        valueKey: "SuperSectorID",
        valueName: "SuperSector",
        defaultValue: 0
    },
    {
        name: "Master type",
        propID: "inMasterTypeID",
        listName: "executeGetMasterTypesList",
        valueKey: "MasterTypeID",
        valueName: "MasterType",
        defaultValue: 0
    },
    {
        name: "Project type",
        propID: "inProjectTypeID",
        listName: "executeGetRawProjectTypes",
        valueKey: "RawProjectTypeID",
        valueName: "RawProjectType",
        multiple: true,
        defaultValue: 0
    },
    {
        name: "MPIP",
        propID: "inInfraFlag",
        listName: "executeGetInfraFlagsList",
        valueKey: "InfraFlag",
        valueName: "InfraFlag",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Plant/Labour/Equipment/Material",
        propID: "inPLEMGroupID",
        listName: "executeGetPLEMTypesList",
        valueKey: "PLEMGroupID",
        valueName: "PLEMGroup",
        defaultValue: 0
    },
    {
        name: "Level 1 group",
        propID: "inLevel1GroupID",
        listName: "executeGetL1GroupList",
        valueKey: "Lvl1GroupID",
        valueName: "Lvl1Group",
        defaultValue: 0
    },
    {
        name: "Resource group",
        propID: "inResourceGroupID",
        listName: "executeGetResourceGroupsList",
        valueKey: "ResourceGroupID",
        valueName: "ResourceGroup",
        multiple: true,
        defaultValue: 0
    }
];








(0, $352a79de3bee5462$export$acaa6426d77a227e).register((0, $352a79de3bee5462$export$29e663ba4d09fe7), (0, $352a79de3bee5462$export$e7f4e5e8656f0b93), (0, $352a79de3bee5462$export$a16ed71bf4b07672), (0, $352a79de3bee5462$export$bd159b522b230b7a), (0, $352a79de3bee5462$export$55e463fa7bcd3469), (0, $352a79de3bee5462$export$f99233281efd08a0), (0, $352a79de3bee5462$export$28c660c63b792dea), (0, $352a79de3bee5462$export$ed247974535929c7), (0, $352a79de3bee5462$export$3c9b5d28c11cbfd0), (0, $352a79de3bee5462$export$e97d5dc64e999004), (0, $352a79de3bee5462$export$d19ba4d812bed757));
// minimum plot range in year
const $89c65c8973f0037d$var$minRange = 1;
function $89c65c8973f0037d$export$2e2bcd8739ae039() {
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const client = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)();
    const { data: userInfo } = (0, $8aac0537827a6bae$export$801fe16824f675f7)();
    const [plotQueryProps, setPlotQueryProps] = (0, $i5lfL.useState)({
        // @ts-ignore
        inJurisdiction: userInfo?.executeGetUser[0].Jurisdiction ?? "",
        inInfraFlag: [
            "ALL"
        ],
        inSource: "ALL",
        inResourceGroupID: [
            0
        ],
        inSuperSectorID: 0,
        inProjectTypeID: [
            0
        ],
        inPLEMGroupID: 0,
        inMasterTypeID: 0,
        inLevel1GroupID: 0,
        inLevel2GroupID: 0,
        inFundingMode: "ALL",
        unit: "Value"
    });
    const { data: nationalResult, isFetching: isFetching } = (0, $45631327982d6a29$export$dd0a697e1782aedd)([
        "nationalResult",
        plotQueryProps
    ], {
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8e9c3aa7483f6f4a$export$c610b2b5a1144b7),
                variables: (0, $3ea34f33e6953e05$export$2e2bcd8739ae039)(plotQueryProps),
                instance: instance,
                accounts: accounts
            });
        }
    });
    const { data: AllLists } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "Lists"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$b9bf64b597697c8a),
                // @ts-ignore
                variables: {
                    inJurisdiction: userInfo?.executeGetUser[0].Jurisdiction ?? "",
                    inScenarioID: ""
                },
                instance: instance,
                accounts: accounts
            });
        },
        cacheTime: Infinity,
        enabled: !!userInfo
    });
    // @ts-ignore
    const Labels = nationalResult?.executeGetNationalModelPlot.map((item)=>new Date(item.Month).getFullYear());
    // to be used as x-axis label
    // @ts-ignore
    const formatLabels = nationalResult?.executeGetNationalModelPlot.map((item)=>$fce7f459a03976d5$exports(item.Month).format("DD/MM/YYYY"));
    const [plotRange, setPlotRange] = (0, $i5lfL.useState)([
        Labels ? Labels[0] : Number(new Date().getFullYear() - 10),
        Labels ? Labels[Labels.length - 1] : Number(new Date().getFullYear() + 10)
    ]);
    const plotStart = Labels?.indexOf(plotRange[0]) > 0 ? Labels.indexOf(plotRange[0]) : 0;
    const plotEnd = Labels?.lastIndexOf(plotRange[1]) > 0 ? Labels.lastIndexOf(plotRange[1]) : Labels?.length;
    // @ts-ignore
    const DetailedData = {
        labels: formatLabels?.slice(plotStart, plotEnd),
        datasets: $89c65c8973f0037d$export$339c4be33ff0485a(// @ts-ignore
        AllLists?.executeGetPLEMTypesList, // trim result according to plot range
        // @ts-ignore
        nationalResult?.executeGetNationalModelPlot.slice(plotStart, plotEnd), plotQueryProps)
    };
    const maxPlotRange = Labels ? Labels[Labels.length - 1] : Number(new Date().getFullYear() + 10);
    const minPlotRange = Labels ? Labels[0] : Number(new Date().getFullYear() - 10);
    const handleSliderChange = (event, newValue, activeThumb)=>{
        if (!Array.isArray(newValue)) return;
        if (newValue[1] - newValue[0] < $89c65c8973f0037d$var$minRange) {
            if (activeThumb === 0) {
                const clamped = Math.min(newValue[0], maxPlotRange - $89c65c8973f0037d$var$minRange);
                setPlotRange([
                    clamped,
                    clamped + $89c65c8973f0037d$var$minRange
                ]);
            } else {
                const clamped = Math.max(newValue[1], $89c65c8973f0037d$var$minRange);
                setPlotRange([
                    clamped - $89c65c8973f0037d$var$minRange,
                    clamped
                ]);
            }
        } else setPlotRange(newValue);
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                container: true,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 10,
                        children: [
                            isFetching && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $2fce601e44012509$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30e31766597ec5b3$export$acaa6426d77a227e), {
                                type: "line",
                                options: (0, $2c31cf03aa363fe5$export$9923a1559b8378b)(plotQueryProps),
                                data: DetailedData
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 2,
                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 1,
                            columns: 1,
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3da0b51f836cadba$export$2e2bcd8739ae039), {
                                    AllLists: AllLists,
                                    plotQueryProps: plotQueryProps,
                                    setPlotQueryProps: setPlotQueryProps,
                                    filterConfigList: (0, $2c31cf03aa363fe5$export$b7a63542bd740eaa)
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 1,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                        label: "Funding mode",
                                        name: "inFundingMode",
                                        onChange: (e)=>setPlotQueryProps({
                                                ...plotQueryProps,
                                                [e.target.name]: e.target.value
                                            }),
                                        select: true,
                                        required: true,
                                        fullWidth: true,
                                        value: plotQueryProps["inFundingMode"],
                                        variant: "filled",
                                        defaultValue: "ALL",
                                        size: "small",
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                value: "ALL",
                                                children: "ALL"
                                            }, "ALL"),
                                            (0, $243a1246ea7835d9$export$14085c2a147de944).map((option)=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                    value: option.value,
                                                    children: option.text
                                                }, option.value))
                                        ]
                                    }, "fundingMode")
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 1,
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                                        title: "Display Unit Filter",
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $5a88d895317a42d5$export$2e2bcd8739ae039), {
                                            value: plotQueryProps.unit,
                                            exclusive: true,
                                            onChange: (event, value)=>{
                                                if (value != null) setPlotQueryProps({
                                                    ...plotQueryProps,
                                                    unit: value
                                                });
                                            },
                                            "aria-label": "Display Unit Filter",
                                            fullWidth: true,
                                            size: "small"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    pt: 5
                },
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                        id: "input-slider",
                        gutterBottom: true,
                        children: "Fiscal Year"
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $36fe94807ea896b0$export$2e2bcd8739ae039), {
                        getAriaLabel: ()=>"Plot Range",
                        value: plotRange,
                        onChange: handleSliderChange,
                        valueLabelDisplay: "on",
                        disableSwap: true,
                        step: 1,
                        marks: true,
                        min: minPlotRange,
                        max: maxPlotRange
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                sx: {
                    fontStyle: "italic",
                    fontWeight: 700,
                    mt: 2,
                    fontFamily: "ProximaNova-Bold"
                },
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                    children: (0, $d29d6d1034e01aa1$export$f68e326d679cfc85)
                })
            })
        ]
    });
}
function $89c65c8973f0037d$export$339c4be33ff0485a(plemList, resultList, plotQueryProps) {
    const dataset = {};
    const mode = plotQueryProps.unit;
    plemList?.map((item)=>dataset[item.PLEMGroup + mode] = []);
    resultList?.map((item)=>{
        plemList?.map((key)=>dataset[key.PLEMGroup + mode].push(item[key.PLEMGroup + mode]));
    });
    if (plotQueryProps.inPLEMGroupID == 0) return plemList?.map((item, index)=>{
        return {
            type: "line",
            label: item.PLEMGroup,
            data: dataset[item.PLEMGroup + mode] ?? [],
            fill: true,
            backgroundColor: (0, $243a1246ea7835d9$export$64b7d035b35e2190)[index % (0, $243a1246ea7835d9$export$64b7d035b35e2190).length]
        };
    }) ?? [];
    else {
        const PLEMGroup = plemList.filter((item)=>item.PLEMGroupID == plotQueryProps.inPLEMGroupID)[0].PLEMGroup;
        return [
            {
                type: "line",
                label: PLEMGroup,
                data: dataset[PLEMGroup + mode],
                fill: true,
                backgroundColor: (0, $243a1246ea7835d9$export$64b7d035b35e2190)[plotQueryProps.inPLEMGroupID % (0, $243a1246ea7835d9$export$64b7d035b35e2190).length]
            }
        ];
    }
}



var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");








// noinspection GraphQLUnresolvedReference

const $f145f89002b4d55b$export$a33ec0b6740d319e = (0, $e9ab2d34d0380c8f$exports.gql)`
    mutation ExecuteGetStateModelPlot (
        $inInfraFlag: String,
        $inState: String
        $inSource: String,
        $inResourceGroupID: String,
        $inSuperSectorID: Int,
        $inProjectTypeID: String,
        $inPLEMGroupID: Int,
        $inMasterTypeID: Int,
        $inLevel1GroupID: Int,
        $inLevel2GroupID: Int,
        $inFundingMode: String
        $inUserSID: UUID
    ) {
        executeGetStateModelPlot(
            inInfraFlag: $inInfraFlag
            inState: $inState
            inSource: $inSource
            inResourceGroupID: $inResourceGroupID
            inSuperSectorID: $inSuperSectorID
            inProjectTypeID: $inProjectTypeID
            inPLEMGroupID: $inPLEMGroupID
            inMasterTypeID: $inMasterTypeID
            inLevel1GroupID: $inLevel1GroupID
            inLevel2GroupID: $inLevel2GroupID
            inFundingMode: $inFundingMode
            inUserSID: $inUserSID
        ) {
            Month
            ResourceGroupID
            ResourceGroup
            sum_value
            sum_unit
        }
    }
`;


parcelRequire("i5lfL");

const $5f903a59899d8702$export$9ddeaa9e19f67d3e = (plotQueryProps)=>{
    return {
        responsive: true,
        elements: {
            point: {
                radius: 1
            }
        },
        plugins: {
            legend: {
                position: "bottom",
                align: "start",
                labels: {
                    usePointStyle: true
                }
            },
            title: {
                fullSize: true,
                font: {
                    size: 20
                },
                display: true,
                text: "Infrastructure Australia - Market Capacity Report (Resource view)"
            }
        },
        scales: {
            x: {
                ticks: {
                    callback: function(value) {
                        // "this" is accessing the chart context when it gets applied
                        // @ts-ignore
                        let label = $fce7f459a03976d5$exports(this.getLabelForValue(value), "DD/MM/YYYY").month();
                        if (label == 0) // There is a callback for each month. This check will only plot the single month for each year
                        // @ts-ignore
                        return $fce7f459a03976d5$exports(this.getLabelForValue(value)).format("YYYY");
                    }
                },
                grid: {
                    display: false,
                    drawTicks: false
                }
            },
            y: {
                stacked: true,
                ticks: {
                    maxTicksLimit: 5,
                    callback: function(value) {
                        return (plotQueryProps.unit == 'value' ? '$' : '') + (value / 1000000).toLocaleString() + "M";
                    // The .toLocaleString() method adds a comma separator for thousands.
                    }
                }
            }
        }
    };
};
const $5f903a59899d8702$export$a2add78d6ffe0431 = [
    {
        name: "State",
        propID: "inState",
        listName: "executeGetState",
        valueKey: "State",
        valueName: "State",
        multiple: true,
        defaultValue: "ALL" //default value to be used for the filter
    },
    {
        name: "Super sector",
        propID: "inSuperSectorID",
        listName: "executeGetSuperSectorsList",
        valueKey: "SuperSectorID",
        valueName: "SuperSector",
        multiple: false,
        defaultValue: 0
    },
    {
        name: "Master type",
        propID: "inMasterTypeID",
        listName: "executeGetMasterTypesList",
        valueKey: "MasterTypeID",
        valueName: "MasterType",
        multiple: false,
        defaultValue: 0
    },
    {
        name: "Project type",
        propID: "inProjectTypeID",
        listName: "executeGetRawProjectTypes",
        valueKey: "RawProjectTypeID",
        valueName: "RawProjectType",
        multiple: true,
        defaultValue: 0
    },
    {
        name: "Infra-flag",
        propID: "inInfraFlag",
        listName: "executeGetInfraFlagsList",
        valueKey: "InfraFlag",
        valueName: "InfraFlag",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Plant/Labour/Equipment/Material",
        propID: "inPLEMGroupID",
        listName: "executeGetPLEMTypesList",
        valueKey: "PLEMGroupID",
        valueName: "PLEMGroup",
        multiple: false,
        defaultValue: 0
    },
    {
        name: "Level 1 group",
        propID: "inLevel1GroupID",
        listName: "executeGetL1GroupList",
        valueKey: "Lvl1GroupID",
        valueName: "Lvl1Group",
        multiple: false,
        defaultValue: 0
    },
    {
        name: "Resource group",
        propID: "inResourceGroupID",
        listName: "executeGetResourceGroupsList",
        valueKey: "ResourceGroupID",
        valueName: "ResourceGroup",
        multiple: true,
        defaultValue: 0
    }
];








var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");








var $bHJbJ = parcelRequire("bHJbJ");
parcelRequire("i5lfL");




(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($140cb3ce1e3b378a$exports))));
function $3deeed44302b479d$var$getProjectTypeSelectOptions(AllLists) {
    return AllLists?.executeGetRawProjectTypes.map((type)=>({
            value: type.RawProjectType,
            text: type.RawProjectType
        })) ?? [];
}

function $3deeed44302b479d$export$4e9833d5b137c5f4(AllLists, getCommonEditTextFieldProps) {
    const customParseFormat = (parcelRequire("kx1Sf"));
    (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend(customParseFormat);
    const minConstructionDate = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))('2015', 'YYYY');
    const maxConstructionDate = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))('2040', 'YYYY');
    return [
        {
            accessorKey: "ProjectID",
            header: "Original Project ID",
            size: 200,
            filterFn: "contains"
        },
        {
            accessorKey: "ProjectName",
            header: "Project name",
            size: 200,
            filterFn: "contains",
            muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                    ...getCommonEditTextFieldProps(cell)
                }),
            Cell: ({ cell: cell })=>{
                const cellValue = cell.getValue();
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%",
                        backgroundColor: !cellValue ? "orange" : ""
                    },
                    children: // @ts-ignore
                    !cellValue ? "Please enter non-empty project name" : cellValue
                });
            }
        },
        {
            accessorKey: "State",
            header: "State",
            size: 100,
            filterVariant: "multi-select",
            editVariant: "select",
            // @ts-ignore
            editSelectOptions: AllLists?.executeGetState.map((state)=>({
                    value: state.State,
                    text: state.State
                })) ?? []
        },
        {
            accessorKey: "Source",
            header: "Source",
            size: 150,
            filterVariant: "multi-select",
            editVariant: "select",
            enableEditing: false,
            // @ts-ignore
            editSelectOptions: AllLists?.executeGetSourceList.map((type)=>({
                    value: type.Source,
                    text: type.Source
                })) ?? []
        },
        {
            id: "MW",
            accessorFn: (row)=>Number(row.MW),
            filterFn: "betweenInclusive",
            filterVariant: "range",
            header: "MW",
            enableEditing: (row)=>(0, $243a1246ea7835d9$export$ad98f2e8c6fd720d).includes(row.getValue("typeCast")) ? true : false,
            size: 150,
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue().toLocaleString()
                });
            },
            muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                    ...getCommonEditTextFieldProps(cell)
                })
        },
        {
            id: "KM",
            accessorFn: (row)=>Number(row.KM),
            header: "KM",
            filterVariant: "range",
            filterFn: "betweenInclusive",
            size: 150,
            enableEditing: (row)=>[
                    (0, $243a1246ea7835d9$export$5be856edc6a7f539)[1],
                    (0, $243a1246ea7835d9$export$5be856edc6a7f539)[2]
                ].includes(row.getValue("typeCast")) ? true : false,
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue().toLocaleString()
                });
            }
        },
        {
            id: "M2",
            accessorFn: (row)=>Number(row.M2),
            header: "M2",
            filterVariant: "range",
            filterFn: "betweenInclusive",
            size: 150,
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue().toLocaleString()
                });
            }
        },
        {
            id: "Investment",
            accessorFn: (row)=>row.Investment,
            filterFn: "betweenInclusive",
            filterVariant: "range",
            header: "Investment ($)",
            Cell: ({ cell: cell })=>{
                const cellValue = cell.getValue();
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%",
                        backgroundColor: !cellValue ? "orange" : ""
                    },
                    children: // @ts-ignore
                    cellValue ? cellValue : "Please enter non-empty investment value"
                });
            },
            size: 200,
            muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                    ...getCommonEditTextFieldProps(cell)
                })
        },
        {
            accessorKey: "typeCast",
            header: "Project type",
            size: 200,
            filterVariant: "multi-select",
            editVariant: "select",
            // @ts-ignore
            editSelectOptions: $3deeed44302b479d$var$getProjectTypeSelectOptions(AllLists),
            muiTableBodyCellEditTextFieldProps: ({ cell: cell })=>({
                    ...getCommonEditTextFieldProps(cell)
                }),
            Cell: ({ cell: cell })=>{
                const cellValue = cell.getValue();
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%",
                        background: !cellValue ? "orange" : ""
                    },
                    children: // @ts-ignore
                    !cellValue ? "Please enter non-empty project type" : cellValue
                });
            }
        },
        {
            accessorKey: "ProjectStage",
            header: "Project latest status",
            size: 250,
            filterVariant: "multi-select",
            editVariant: "select",
            editSelectOptions: (0, $243a1246ea7835d9$export$2425b41e18ec8805)
        },
        {
            accessorKey: "DeliveryAgency",
            header: "Delivery agency",
            size: 150,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            enableEditing: true
        },
        {
            accessorKey: "ContractingModel",
            header: "Contracting model",
            size: 150,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            enableEditing: true
        },
        {
            accessorKey: "Latitude",
            header: "Latitude",
            size: 150,
            filterFn: "betweenInclusive",
            filterVariant: "range",
            enableEditing: true
        },
        {
            accessorKey: "Longitude",
            header: "Longitude",
            size: 150,
            filterFn: "betweenInclusive",
            filterVariant: "range",
            enableEditing: true
        },
        {
            accessorKey: "sa4_code",
            header: "sa4_Code",
            size: 150,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            enableEditing: true
        },
        {
            accessorKey: "sa4_name",
            header: "sa4_Name",
            size: 150,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            enableEditing: true
        },
        {
            id: "PeriodStartYear",
            accessorFn: (row)=>row.PeriodStartYear,
            header: "Period Start Year",
            size: 300,
            enableEditing: false,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            sortingFn: "datetime",
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue()
                });
            }
        },
        {
            id: "PeriodEndYear",
            accessorFn: (row)=>row.PeriodEndYear,
            header: "Period End Year",
            Cell: ({ cell: cell })=>{
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%"
                    },
                    children: // @ts-ignore
                    cell.getValue()
                });
            },
            size: 300,
            enableEditing: false,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            sortingFn: "datetime"
        },
        {
            id: "StartDateConstruction",
            accessorFn: (row)=>row.StartDateConstruction,
            header: "Construction start date",
            size: 300,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            sortingFn: "datetime",
            Cell: ({ cell: cell })=>{
                const cellValue = cell.getValue();
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%",
                        backgroundColor: cellValue === "" ? "orange" : ""
                    },
                    children: // @ts-ignore
                    cellValue === "" ? "Please enter non-empty start date" : cellValue
                });
            }
        },
        {
            id: "EndDateConstruction",
            accessorFn: (row)=>row.EndDateConstruction,
            header: "Construction end date",
            size: 300,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            sortingFn: "datetime",
            // @ts-ignore
            Cell: ({ cell: cell })=>{
                const cellValue = cell.getValue();
                return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%",
                        backgroundColor: cellValue === "" ? "orange" : ""
                    },
                    children: // @ts-ignore
                    cellValue === "" ? "Please enter non-empty end date" : cellValue
                });
            }
        },
        {
            accessorKey: "FundingMode",
            header: "Funding mode",
            size: 150,
            editVariant: "select",
            editSelectOptions: (0, $243a1246ea7835d9$export$14085c2a147de944),
            enableEditing: true
        },
        {
            accessorKey: "CommonwealthFunding",
            header: "Commonwealth funding",
            size: 200,
            editVariant: "select"
        },
        {
            id: "LocationID",
            accessKey: "project_location",
            header: "Location",
            size: 300,
            filterVariant: "multi-select",
            editVariant: "select",
            Cell: ({ cell: cell })=>{
                return(// @ts-ignore
                AllLists?.executeGetLocationList.find((item)=>item.LocationID == cell.getValue())?.LocationName);
            },
            filterSelectOptions: AllLists?.executeGetLocationList.map((location)=>({
                    value: location.LocationID,
                    text: location.LocationName
                })) ?? [],
            // @ts-ignore
            editSelectOptions: AllLists?.executeGetLocationList.map((location)=>({
                    value: location.LocationID,
                    text: location.LocationName
                })) ?? []
        }
    ];
}







const $c4ee132c2828f077$export$3dc27271f5d5c629 = (value)=>{
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: value % 1 === 0 ? 0 : 2
    }).format(value);
};
const $c4ee132c2828f077$export$19d284f31ec1f4c0 = (currentInvestment)=>{
    if (typeof currentInvestment === "string" && currentInvestment.includes("$") && currentInvestment.includes("M")) return parseFloat(currentInvestment.slice(1, -1));
    else if (typeof currentInvestment === "number") return currentInvestment / 1e6;
    else if (typeof currentInvestment === "string" && currentInvestment !== "") return parseInt(currentInvestment) / 1e6;
    else return 0;
};





const $31a2e9aed63ca5a2$var$StatePriorYearBaseline = ()=>{
    const client = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)();
    const { data: userInfo } = (0, $8aac0537827a6bae$export$801fe16824f675f7)();
    const [downloading, setDownloading] = (0, $i5lfL.useState)(false);
    const [upLoadInfo, setUpLoadInfo] = (0, $i5lfL.useState)({
        totalRecords: 0,
        totalInvestment: "",
        totalMissingProjectNameValue: "",
        totalMissingProjectTypeValue: "",
        totalMissingConstructionStartDateValue: "",
        totalMissingConstructionEndDateValue: ""
    });
    const [preViewData, setPreViewData] = (0, $i5lfL.useState)([]);
    const [statePipelineData, setStatePipelineData] = (0, $i5lfL.useState)([]);
    const [callLastUploadedProjectList, setCallLastUploadedProjectList] = (0, $i5lfL.useState)(false);
    const [preViewFlag, setPreViewFlag] = (0, $i5lfL.useState)(false);
    const [closeBatchFlag, setCloseBatchFlag] = (0, $i5lfL.useState)(false);
    const [projectUploadBatchID, setProjectUploadBatchID] = (0, $i5lfL.useState)("");
    const [lastUploadedDate, setLastUploadedDate] = (0, $i5lfL.useState)("");
    const [lastUpdatedUser, setLastUpdatedUser] = (0, $i5lfL.useState)("");
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const fileInputRef = (0, $i5lfL.useRef)(null);
    const [submitPopupOpen, setSubmitPopupOpen] = (0, $i5lfL.useState)(false);
    const rerender = (0, $i5lfL.useReducer)(()=>({}), {})[1];
    // table settings
    const [showColumnFilters, setShowColumnFilters] = (0, $i5lfL.useState)(false);
    const tableInstanceRef = (0, $i5lfL.useRef)(null);
    const [columnFilters, setColumnFilters] = (0, $i5lfL.useState)([]);
    const [columnVisibility, setColumnVisibility] = (0, $i5lfL.useState)({
        PeriodStartYear: false,
        PeriodEndYear: false,
        KM: false,
        MW: false,
        M2: false,
        sa4_code: false,
        sa4_name: false,
        CommonwealthFunding: false
    });
    const [rowSelection, setRowSelection] = (0, $i5lfL.useState)({});
    const [validationErrors, setValidationErrors] = (0, $i5lfL.useState)({});
    const { data: priorYearProjectList, isLoading: isPriorYearProjectListLoading, isFetching: isFetching } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "priorYearProjectList"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$3865fbe071399085),
                variables: {
                    // @ts-ignore
                    inJurisdiction: userInfo?.executeGetUser[0].Jurisdiction,
                    inScenarioID: ""
                },
                instance: instance,
                accounts: accounts
            });
        },
        refetchOnWindowFocus: false,
        // @ts-ignore
        enabled: !callLastUploadedProjectList && !!userInfo?.executeGetUser[0].Jurisdiction,
        onSuccess: (data)=>{
            //@ts-ignore
            const priorYearData = data?.executeGetPriorYearProjectList;
            if (priorYearData && !callLastUploadedProjectList) setStatePipelineData(priorYearData.map((project)=>{
                return {
                    ...project,
                    "LastUploadedDate": "No upload data"
                };
            }));
        }
    });
    // react query - get last uploaded project list
    const { data: lastUploadedProjectList, isLoading: isLastUploadedProjectListLoading } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "lastUploadedProjectList"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$4466af79468173b7),
                variables: {
                    // @ts-ignore
                    inJurisdiction: userInfo?.executeGetUser[0].Jurisdiction,
                    inScenarioID: ""
                },
                instance: instance,
                accounts: accounts
            });
        },
        // @ts-ignore
        enabled: callLastUploadedProjectList && !!userInfo?.executeGetUser[0].Jurisdiction,
        onSuccess: (data)=>{
            //@ts-ignore
            const lastUploadedData = data?.executeGetLastUploadedProjectList;
            if (lastUploadedData && callLastUploadedProjectList) setStatePipelineData(lastUploadedData.map((project)=>{
                return {
                    ...project,
                    "LastUploadedDate": (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(lastUploadedDate).format('DD/MM/YYYY HH:mm:ss')
                };
            }));
        }
    });
    const { data: getProjectBatchHeader, isLoading: isGetProjectBatchHeaderLoading } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "getStateUploadBatchHeader"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$2d00f14ac930abf6),
                variables: {
                    // @ts-ignore
                    inUserSID: userInfo?.executeGetUser[0].UserSID
                },
                instance: instance,
                accounts: accounts
            });
        },
        // @ts-ignore
        enabled: !!userInfo?.executeGetUser[0].UserSID,
        onSuccess: (data)=>{
            //@ts-ignore
            const lastUploadedDate = data?.executeGetProjectBatchUpload[0]?.LastUploadedDate || "";
            //@ts-ignore
            const lastUpdatedUser = data?.executeGetProjectBatchUpload[0]?.LastUploadedBy || "";
            //@ts-ignore
            const projectsUploaded = data?.executeGetProjectBatchUpload[0]?.ProjectsUploaded || 0;
            setLastUploadedDate((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(lastUploadedDate).format('DD/MM/YYYY HH:mm:ss'));
            setLastUpdatedUser(lastUpdatedUser);
            if (projectsUploaded !== 0) setCallLastUploadedProjectList(true);
        }
    });
    const { mutate: createProjectUpload, data: uploadBatchHeader, isSuccess: isUploadBatchHeaderSuccess } = (0, $d5a0a75b5a6b57e1$export$609860bf8b0084c)({
        mutationFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$fe54a84b24b90c03),
                variables: {
                    // @ts-ignore
                    inUserSID: userInfo?.executeGetUser[0].UserSID
                },
                instance: instance,
                accounts: accounts
            });
        },
        onSuccess: (data)=>{
            //@ts-ignore
            const batchID = data?.executeCreateProjectUploadBatch[0]?.BatchID || 0;
            //@ts-ignore
            const lastUploadedDate = data?.executeCreateProjectUploadBatch[0]?.LastUploadedDate || "";
            //@ts-ignore
            const lastUpdatedUser = data?.executeCreateProjectUploadBatch[0]?.LastUploadedBy || "";
            //@ts-ignore
            const projectsUploaded = data?.executeCreateProjectUploadBatch[0]?.ProjectsUploaded;
            setProjectUploadBatchID(batchID);
            setLastUploadedDate((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(lastUploadedDate).format('DD/MM/YYYY HH:mm:ss'));
            setLastUpdatedUser(lastUpdatedUser);
            if (projectsUploaded !== 0) setCallLastUploadedProjectList(true);
            validateUploadProjects.mutate({
                inProjectBatchID: batchID,
                inProjectJSON: JSON.stringify(preViewData)
            });
        }
    });
    const { data: uploadBatchClose, isLoading: isUploadBatchCloseLoading } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "stateUploadBatchClose"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$afb32896ebbc451d),
                variables: {
                    inProjectBatchID: projectUploadBatchID
                },
                instance: instance,
                accounts: accounts
            });
        },
        enabled: closeBatchFlag && !!projectUploadBatchID,
        onSuccess: ()=>{
            // Close the batch and reset the state
            client.invalidateQueries([
                "getStateUploadBatchHeader"
            ]);
            setProjectUploadBatchID("");
            setCloseBatchFlag(false);
            setPreViewFlag(false);
            setPreViewData([]);
            setUpLoadInfo({
                totalRecords: 0,
                totalInvestment: "",
                totalMissingProjectNameValue: "",
                totalMissingProjectTypeValue: "",
                totalMissingConstructionStartDateValue: "",
                totalMissingConstructionEndDateValue: ""
            });
        }
    });
    const validateUploadProjects = (0, $d5a0a75b5a6b57e1$export$609860bf8b0084c)([
        "validateUploadProjects"
    ], {
        mutationFn: (variables)=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$dae312c2d972beb5),
                variables: variables,
                instance: instance,
                accounts: accounts
            });
        },
        onSuccess: ()=>{
            setCloseBatchFlag(true);
            client.invalidateQueries([
                "lastUploadedProjectList"
            ]);
        }
    });
    //@ts-ignore
    const statePipelineListData = callLastUploadedProjectList ? lastUploadedProjectList?.executeGetLastUploadedProjectList ?? [
        (0, $243a1246ea7835d9$export$b29a7c763ae8219)
    ] : priorYearProjectList?.executeGetPriorYearProjectList ?? [
        (0, $243a1246ea7835d9$export$b29a7c763ae8219)
    ];
    const tempData = callLastUploadedProjectList ? lastUploadedProjectList : priorYearProjectList;
    const projectTypes = (0, $61689dee2f6ff4fb$export$afc921ba20c7eb49)(tempData);
    const locations = (0, $61689dee2f6ff4fb$export$c07c686062478869)(tempData);
    const states = (0, $61689dee2f6ff4fb$export$35029cc0a320e78a)(tempData);
    const source = (0, $61689dee2f6ff4fb$export$dd2b6e807fb37ba3)(tempData);
    const handleDownload = ()=>{
        setDownloading(true);
    };
    // submit uploaded data
    const handleUpload = async ()=>{
        setSubmitPopupOpen(true);
    };
    const handleConfirmSubmit = ()=>{
        // upload project creation
        createProjectUpload();
        // if (preViewFlag && !!projectUploadBatchID) {
        //     validateUploadProjects.mutate({
        //         inProjectBatchID: projectUploadBatchID,
        //         inProjectJSON: JSON.stringify(preViewData)
        //     });
        // }
        setSubmitPopupOpen(false);
    };
    const handleCancelSubmit = ()=>{
        setSubmitPopupOpen(false);
        setPreViewFlag(false);
    };
    // Upload Excel but not submit
    const handleFileChange = (event)=>{
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = async (event)=>{
                if (event.target && event.target.result) {
                    const workbook = new $1cb7ac08e18fc2ca$exports.Workbook();
                    await workbook.xlsx.load(event.target.result);
                    const worksheet = workbook.worksheets[0];
                    const jsonData = [];
                    let headers = [];
                    let totalInvestment = 0;
                    let totalMissingProjectNameValue = 0;
                    let totalMissingProjectTypeValue = 0;
                    let totalMissingConstructionStartDateValue = 0;
                    let totalMissingConstructionEndDateValue = 0;
                    worksheet.eachRow((row, rowNumber)=>{
                        const rowValues = row.values;
                        // Row 5 is the header row
                        if (rowNumber === (0, $243a1246ea7835d9$export$87edd524e90cb499).length + 1) headers = rowValues.slice(1); // Remove first empty element
                        else if (rowNumber > (0, $243a1246ea7835d9$export$87edd524e90cb499).length + 1) {
                            const rowObject = {};
                            const investmentColumnIndex = headers.indexOf("Investment ($)") + 1;
                            headers.forEach((header, index)=>{
                                let currentInvestment = (0, $c4ee132c2828f077$export$19d284f31ec1f4c0)(rowValues[investmentColumnIndex]);
                                let cellValue = rowValues[index + 1];
                                const columnName = Object.keys((0, $243a1246ea7835d9$export$685bf383464b857b)).find((key)=>(0, $243a1246ea7835d9$export$685bf383464b857b)[key] === header);
                                if (columnName) {
                                    if (columnName === 'Investment') totalInvestment += (0, $c4ee132c2828f077$export$19d284f31ec1f4c0)(cellValue);
                                    if (columnName === 'ProjectName') // calculate missing project name value based
                                    {
                                        if (!cellValue) totalMissingProjectNameValue += currentInvestment;
                                    }
                                    if (columnName === 'typeCast') {
                                        if (!cellValue) totalMissingProjectTypeValue += currentInvestment;
                                    }
                                    if (columnName === 'StartDateConstruction' || columnName === 'EndDateConstruction' || columnName === "PeriodStartYear" || columnName === "PeriodEndYear") {
                                        // convert date to string with format DD/MM/YYYY
                                        // the excel upload will give us the date object
                                        if (cellValue instanceof Date) cellValue = (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(cellValue).format('DD/MM/YYYY');
                                        // calculate missing start dates value
                                        if (!cellValue && columnName === 'StartDateConstruction') totalMissingConstructionStartDateValue += currentInvestment;
                                        // calculate missing end dates
                                        if (!cellValue && columnName === 'EndDateConstruction') totalMissingConstructionEndDateValue += currentInvestment;
                                    }
                                    // change null or undefined to empty string
                                    if (!cellValue || cellValue === "null" || cellValue === "undefined") cellValue = "";
                                    rowObject[columnName] = cellValue;
                                }
                            });
                            jsonData.push(rowObject);
                        }
                    });
                    const sortedData = jsonData.sort((a, b)=>{
                        // Sort based on empty string fields
                        const keysToSort = [
                            'ProjectName',
                            'typeCast',
                            'StartDateConstruction',
                            'EndDateConstruction'
                        ];
                        for (let key of keysToSort){
                            if (a[key] === '' && b[key] !== '') return -1;
                            else if (a[key] !== '' && b[key] === '') return 1;
                        }
                        return 0;
                    });
                    setPreViewData(sortedData.map((project)=>{
                        return {
                            ...project,
                            LastUploadedDate: (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(lastUploadedDate).format('DD/MM/YYYY HH:mm:ss')
                        };
                    }));
                    setUpLoadInfo({
                        totalRecords: jsonData.length,
                        totalInvestment: (0, $c4ee132c2828f077$export$3dc27271f5d5c629)(totalInvestment),
                        totalMissingProjectNameValue: (0, $c4ee132c2828f077$export$3dc27271f5d5c629)(totalMissingProjectNameValue),
                        totalMissingProjectTypeValue: (0, $c4ee132c2828f077$export$3dc27271f5d5c629)(totalMissingProjectTypeValue),
                        totalMissingConstructionStartDateValue: (0, $c4ee132c2828f077$export$3dc27271f5d5c629)(totalMissingConstructionStartDateValue),
                        totalMissingConstructionEndDateValue: (0, $c4ee132c2828f077$export$3dc27271f5d5c629)(totalMissingConstructionEndDateValue)
                    });
                    setCloseBatchFlag(false);
                    setPreViewFlag(true);
                }
            };
            reader.readAsArrayBuffer(file);
        } else console.log('No file selected');
        if (fileInputRef.current) fileInputRef.current.value = "";
    };
    const getCommonEditTextFieldProps = (0, $i5lfL.useCallback)((cell)=>{
        return {
            error: !!validationErrors[cell.id],
            helperText: validationErrors[cell.id]
        };
    }, [
        validationErrors
    ]);
    const columns = (0, $i5lfL.useMemo)(()=>(0, $3deeed44302b479d$export$4e9833d5b137c5f4)(priorYearProjectList, getCommonEditTextFieldProps), [
        priorYearProjectList,
        getCommonEditTextFieldProps
    ]);
    // Download Excel
    (0, $i5lfL.useEffect)(()=>{
        function addDataToWorksheet(worksheet, data, startRow, validation = false) {
            function formatHeader(headerList) {
                return headerList.map((item)=>(0, $243a1246ea7835d9$export$685bf383464b857b)[item]);
            }
            const processCell = (cell, colNumber, header)=>{
                // Helper variables and functions
                const getColumnLetter = (col)=>String.fromCharCode(64 + col);
                const cellRange = `${getColumnLetter(colNumber)}1:${getColumnLetter(colNumber)}${(0, $243a1246ea7835d9$export$741e1112e38a63ea)}`;
                const applyDataValidation = (range, formulae)=>{
                    worksheet.dataValidations.add(range, {
                        type: 'list',
                        allowBlank: false,
                        formulae: formulae
                    });
                };
                if (header === "KM" || header === "MW" || header === "M2") cell.value = Number(cell.value);
                else if (header === "Construction Start Date" || header === "Construction End Date" || header === "Period Start Year" || header === "Period End Year") ;
                else if (header === "Investment ($)" || header === "Commonwealth Funding") ;
                else cell.value = String(cell.value);
                if (header === "Project Type") applyDataValidation(cellRange, [
                    `'Project Types'!$A$1:$A$${projectTypes.length}`
                ]);
                if (header === "Location") // INDIRECT will consider the note row and header row
                applyDataValidation(cellRange, [
                    `INDIRECT(D1)`
                ]);
                if (header === "State") applyDataValidation(cellRange, [
                    `'States'!$A$1:$A$${states.length}`
                ]);
                // change null or undefined to empty string
                if (!cell.value && typeof cell.value !== "number" || cell.value === "null" || cell.value === "undefined") cell.value = "";
            };
            const processRow = (row, startRow)=>{
                const newRow = worksheet.addRow(Object.values(row));
                newRow.eachCell({
                    includeEmpty: true
                }, (cell, colNumber)=>{
                    const header = worksheet.getRow(startRow).getCell(colNumber).value;
                    processCell(cell, colNumber, header);
                });
            };
            const addHeaderRow = (data)=>{
                worksheet.addRow(formatHeader(Object.keys(data[0])));
            };
            if (validation) {
                addHeaderRow(data);
                data.forEach((row)=>processRow(row, startRow));
            } else if (worksheet.name === "Locations") {
                worksheet.addRow(states);
                data.forEach((location, rowIndex)=>{
                    const columnIndex = states.indexOf(location.state.toUpperCase()) + 1;
                    for(let i = 2; i <= rowIndex + 2; i++){
                        let found = false;
                        const row = worksheet.getRow(i);
                        if (!row.getCell(columnIndex).value && !found) {
                            row.getCell(columnIndex).value = location.locationName;
                            found = true;
                            break;
                        }
                    }
                });
            } else data.forEach((item)=>worksheet.addRow([
                    item
                ]));
        }
        //@ts-ignore
        if (downloading && projectTypes.length !== 0 && locations.length !== 0) {
            //@ts-ignore
            const workbook = new $1cb7ac08e18fc2ca$exports.Workbook();
            workbook.creator = "Infrastructure Australia";
            const worksheet = workbook.addWorksheet("State pipeline Project List");
            const worksheetProjectTypes = workbook.addWorksheet("Project Types");
            const worksheetLocations = workbook.addWorksheet("Locations");
            const worksheetStates = workbook.addWorksheet("States");
            (0, $243a1246ea7835d9$export$87edd524e90cb499).forEach((line, index)=>{
                const noteRow = worksheet.addRow([
                    line
                ]);
                noteRow.font = {
                    bold: true
                };
            });
            if (statePipelineListData.length !== 0) addDataToWorksheet(worksheet, statePipelineListData, (0, $243a1246ea7835d9$export$87edd524e90cb499).length + 1, true);
            else {
                const header_row_obj = [
                    {
                        "Source": "",
                        "ProjectID": "",
                        "ProjectName": "",
                        "State": "",
                        "typeCast": "",
                        "Investment": "",
                        "MW": "",
                        "KM": "",
                        "M2": "",
                        "ProjectStage": "",
                        "DeliveryAgency": "",
                        "ContractingModel": "",
                        "StartDateConstruction": "",
                        "EndDateConstruction": "",
                        "project_location": "",
                        "Latitude": "",
                        "Longitude": "",
                        "FundingMode": "",
                        "sa4_code": "",
                        "sa4_name": "",
                        "CommonwealthFunding": "",
                        "ProjectStatus": "",
                        "PeriodStartYear": "",
                        "PeriodEndYear": ""
                    }
                ];
                addDataToWorksheet(worksheet, header_row_obj, (0, $243a1246ea7835d9$export$87edd524e90cb499).length + 1, true);
            }
            addDataToWorksheet(worksheetProjectTypes, projectTypes, 1, false);
            addDataToWorksheet(worksheetLocations, locations, 1, false);
            addDataToWorksheet(worksheetStates, states, 1, false);
            const sortedLocationsByState = (0, $61689dee2f6ff4fb$export$960c8c4fe218647d)(locations, states);
            // Create named ranges for each state in 'locations' worksheet
            Object.keys(sortedLocationsByState).forEach((state, colIndex)=>{
                const colLetter = String.fromCharCode(65 + colIndex); // Convert column index to letter
                const range = `${colLetter}2:${colLetter}${sortedLocationsByState[state].length + 1}`;
                workbook.definedNames.add(`Locations!${range}`, state);
            });
            workbook.xlsx.writeBuffer().then((buffer)=>{
                const blob = new Blob([
                    buffer
                ], {
                    type: "application/xlsx"
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($c81b9af5835f71db$exports)))(blob, "State Baseline.xlsx");
            });
            setDownloading(false);
        }
    }, [
        downloading
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        sx: {
            zIndex: "1000"
        },
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30615b8e57e39efe$export$2506d3bf41f97512), {
                columns: columns,
                data: preViewFlag ? preViewData : statePipelineData ?? [],
                enableRowActions: true,
                enableRowVirtualization: true,
                rowVirtualizerProps: {
                    overscan: 10
                },
                enablePagination: false,
                enableEditing: false,
                onEditingRowCancel: ()=>{
                    setValidationErrors({});
                },
                enableSorting: true,
                globalFilterFn: "includesString",
                enableFacetedValues: true,
                enableClickToCopy: true,
                enableColumnResizing: true,
                enableTopToolbar: true,
                positionGlobalFilter: "left",
                enableStickyHeader: true,
                muiTableContainerProps: {
                    sx: {
                        maxHeight: "50vh"
                    }
                },
                onShowColumnFiltersChange: (updater)=>{
                    setShowColumnFilters((prev)=>updater instanceof Function ? updater(prev) : updater);
                    setColumnFilters([]);
                    queueMicrotask(rerender); //hack to rerender after state update
                },
                onColumnFiltersChange: (updater)=>{
                    setColumnFilters((prev)=>updater instanceof Function ? updater(prev) : updater);
                    queueMicrotask(rerender); //hack to rerender after state update
                },
                onColumnVisibilityChange: (updater)=>{
                    setColumnVisibility((prev)=>updater instanceof Function ? updater(prev) : updater);
                    queueMicrotask(rerender); //hack to rerender after state update
                },
                onRowSelectionChange: (updater)=>{
                    setRowSelection((prev)=>updater instanceof Function ? updater(prev) : updater);
                    queueMicrotask(rerender); //hack to rerender after state update
                },
                initialState: {
                    showGlobalFilter: true,
                    density: "compact"
                },
                state: {
                    columnVisibility: columnVisibility,
                    rowSelection: rowSelection,
                    columnFilters: columnFilters,
                    showColumnFilters: showColumnFilters,
                    isLoading: callLastUploadedProjectList ? isLastUploadedProjectListLoading : isPriorYearProjectListLoading,
                    showAlertBanner: !!preViewFlag,
                    showProgressBars: isFetching,
                    columnPinning: {
                        right: [],
                        left: [
                            'mrt-row-actions'
                        ]
                    }
                },
                muiToolbarAlertBannerProps: !!preViewFlag ? {
                    color: "warning",
                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $bHJbJ.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)("div", {
                                children: `You have uploaded ${upLoadInfo.totalRecords} records, total ${upLoadInfo.totalInvestment}M investment, ${upLoadInfo.totalMissingProjectNameValue}M missing project name, ${upLoadInfo.totalMissingProjectTypeValue}M missing project type, ${upLoadInfo.totalMissingConstructionStartDateValue}M missing construction start date, ${upLoadInfo.totalMissingConstructionEndDateValue}M missing construction end date`
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)("div", {
                                children: "Note: Projects with missing fields might be dropped from baseline"
                            })
                        ]
                    })
                } : undefined,
                displayColumnDefOptions: {
                    "mrt-row-actions": {
                        Header: "",
                        size: 50
                    }
                },
                positionToolbarAlertBanner: "top",
                tableInstanceRef: tableInstanceRef,
                muiTableBodyProps: {
                    sx: ()=>({
                            "& tr:nth-of-type(odd)": {
                                backgroundColor: "#8578741A"
                            }
                        })
                },
                positionActionsColumn: "first",
                renderToolbarInternalActions: ({ table: table })=>// render an empty action are to disable the duplicated actions(full screen etc.)
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        flexWrap: "nowrap",
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30615b8e57e39efe$export$d9eac406b7d9b19a), {
                                table: table
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30615b8e57e39efe$export$df5f5becfc7dc5e7), {
                                table: table
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30615b8e57e39efe$export$292cb709c1b05af0), {
                                table: table
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                                arrow: true,
                                title: "Export All Data",
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)("label", {
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                        disabled: downloading || isFetching,
                                        onClick: handleDownload,
                                        variant: "outlined",
                                        endIcon: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9bc9c4f93103a0b3$exports))), {}),
                                        children: "DOWNLOAD"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)("input", {
                                ref: fileInputRef,
                                id: "file-input",
                                type: "file",
                                style: {
                                    display: "none"
                                },
                                onChange: handleFileChange,
                                accept: ".xls,.xlsx,.csv"
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                                arrow: true,
                                title: "Import All Data",
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)("label", {
                                    htmlFor: "file-input",
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                        sx: {
                                            ml: 1
                                        },
                                        variant: "outlined",
                                        component: "span",
                                        disabled: isFetching,
                                        endIcon: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($78e40c7d7e50d5ff$exports))), {}),
                                        children: "UPLOAD"
                                    })
                                })
                            })
                        ]
                    }),
                renderBottomToolbarCustomActions: ({})=>{
                    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            gap: "0.5rem",
                            p: 2,
                            justifyContent: "flex-end",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                sx: {
                                    fontStyle: "italic",
                                    fontWeight: 700,
                                    mt: 2,
                                    justifyContent: "flex-end",
                                    fontFamily: "ProximaNova-Bold",
                                    marginRight: "auto"
                                },
                                children: !!lastUploadedDate && /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                                    children: `Data last update ${lastUploadedDate} by ${lastUpdatedUser}`
                                })
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                    variant: "contained",
                                    onClick: handleUpload,
                                    disabled: isFetching || !preViewFlag,
                                    children: "Submit"
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039), {
                open: validateUploadProjects.isLoading,
                "aria-describedby": "upload-progress",
                maxWidth: "xs",
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $48d8f4c3325a9037$export$2e2bcd8739ae039), {
                        children: "The file is uploading..."
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $422502a3833a93e2$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $2fce601e44012509$export$2e2bcd8739ae039), {
                            id: "upload-progress"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $9bb0dd9cdb8ee136$export$2e2bcd8739ae039), {
                open: submitPopupOpen,
                onClose: ()=>setSubmitPopupOpen(false),
                "aria-describedby": "alert-submit-description",
                maxWidth: "xs",
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $422502a3833a93e2$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $a63770281394464a$export$2e2bcd8739ae039), {
                            id: "alert-submit-description",
                            children: `You last uploaded a baseline at ${lastUploadedDate}. Upon submitting the pipeline, this will be subject to data quality and assurance process by IA. We will get in touch with you if there are any questions, and to confirm that it is replaced in the tool. Please confirm you are ready to submit your change? Yes/No`
                        })
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $0d4f9b05ed57077c$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                onClick: handleCancelSubmit,
                                children: "No"
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                onClick: handleConfirmSubmit,
                                autoFocus: true,
                                children: "Yes"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $31a2e9aed63ca5a2$export$2e2bcd8739ae039 = $31a2e9aed63ca5a2$var$StatePriorYearBaseline;



(0, $352a79de3bee5462$export$acaa6426d77a227e).register((0, $352a79de3bee5462$export$29e663ba4d09fe7), (0, $352a79de3bee5462$export$e7f4e5e8656f0b93), (0, $352a79de3bee5462$export$a16ed71bf4b07672), (0, $352a79de3bee5462$export$bd159b522b230b7a), (0, $352a79de3bee5462$export$55e463fa7bcd3469), (0, $352a79de3bee5462$export$f99233281efd08a0), (0, $352a79de3bee5462$export$28c660c63b792dea), (0, $352a79de3bee5462$export$ed247974535929c7), (0, $352a79de3bee5462$export$3c9b5d28c11cbfd0), (0, $352a79de3bee5462$export$e97d5dc64e999004), (0, $352a79de3bee5462$export$d19ba4d812bed757));
// minimum plot range in year
const $084d11a9a67aa7fe$var$minRange = 1;
function $084d11a9a67aa7fe$var$a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`
    };
}
function $084d11a9a67aa7fe$export$2e2bcd8739ae039() {
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const [plotQueryProps, setPlotQueryProps] = (0, $i5lfL.useState)({
        inState: [
            "ALL"
        ],
        inInfraFlag: [
            "ALL"
        ],
        inSource: "ALL",
        inResourceGroupID: [
            0
        ],
        inSuperSectorID: 0,
        inProjectTypeID: [
            0
        ],
        // Default PLEM to Plant(2) for readability
        inPLEMGroupID: 2,
        inMasterTypeID: 0,
        inLevel1GroupID: 0,
        inLevel2GroupID: 0,
        inFundingMode: "ALL",
        unit: "value"
    });
    const [tabIndex, setTabIndex] = (0, $i5lfL.useState)(0);
    const client = (0, $09a29e98c9dccb10$export$22e77b9572c4fded)();
    const { data: userInfo } = (0, $8aac0537827a6bae$export$801fe16824f675f7)();
    console.log("User info", userInfo);
    const { data: stateResult, isFetching: isFetching } = (0, $45631327982d6a29$export$dd0a697e1782aedd)([
        "stateResult",
        plotQueryProps
    ], {
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $f145f89002b4d55b$export$a33ec0b6740d319e),
                variables: (0, $3ea34f33e6953e05$export$2e2bcd8739ae039)(plotQueryProps),
                instance: instance,
                accounts: accounts
            });
        },
        // @ts-ignore
        enabled: !!userInfo?.executeGetUser[0]?.Jurisdiction
    });
    const { data: AllLists } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "Lists"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $8797ca29702eee23$export$b9bf64b597697c8a),
                variables: {
                    // @ts-ignore
                    inJurisdiction: userInfo?.executeGetUser[0]?.Jurisdiction,
                    inScenarioID: ""
                },
                instance: instance,
                accounts: accounts
            });
        },
        // @ts-ignore
        enabled: !!userInfo?.executeGetUser[0]?.Jurisdiction,
        cacheTime: Infinity
    });
    let LabelList = [];
    let stateData = {};
    // @ts-ignore
    AllLists?.executeGetResourceGroupsList.map((item)=>stateData[item.ResourceGroup] = []);
    // @ts-ignore
    stateResult?.executeGetStateModelPlot.map((item)=>{
        // @ts-ignore
        if (LabelList.indexOf(item.Month) == -1) // @ts-ignore
        LabelList.push(item.Month);
        stateData[item.ResourceGroup]?.push(item["sum_" + plotQueryProps.unit]);
    });
    let Labels = LabelList.map((item)=>new Date(item).getFullYear());
    // to be used as x-axis label
    const formatLabels = LabelList.map((item)=>(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(item).format("DD/MM/YYYY"));
    const [plotRange, setPlotRange] = (0, $i5lfL.useState)([
        Labels[0] ?? Number(new Date().getFullYear() - 10),
        Labels[Labels.length - 1] ?? Number(new Date().getFullYear() + 10)
    ]);
    const maxPlotRange = Labels ? Labels[Labels.length - 1] : Number(new Date().getFullYear() + 10);
    const minPlotRange = Labels ? Labels[0] : Number(new Date().getFullYear() - 10);
    const plotStart = Labels.indexOf(plotRange[0]) > 0 ? Labels.indexOf(plotRange[0]) : 0;
    const plotEnd = Labels.lastIndexOf(plotRange[1]) > 0 ? Labels.lastIndexOf(plotRange[1]) : Labels.length;
    // @ts-ignore
    const DetailedData = {
        labels: formatLabels.slice(plotStart, plotEnd),
        datasets: Object.keys(stateData).map((item, index)=>{
            return {
                type: 'line',
                label: item,
                data: stateData[item].slice(plotStart, plotEnd),
                fill: true,
                backgroundColor: (0, $243a1246ea7835d9$export$64b7d035b35e2190)[index % (0, $243a1246ea7835d9$export$64b7d035b35e2190).length]
            };
        }).filter((item)=>item.data.length)
    };
    const handleChange = (event, newValue)=>{
        setTabIndex(newValue);
    };
    const handleSliderChange = (event, newValue, activeThumb)=>{
        if (!Array.isArray(newValue)) return;
        if (newValue[1] - newValue[0] < $084d11a9a67aa7fe$var$minRange) {
            if (activeThumb === 0) {
                const clamped = Math.min(newValue[0], maxPlotRange - $084d11a9a67aa7fe$var$minRange);
                setPlotRange([
                    clamped,
                    clamped + $084d11a9a67aa7fe$var$minRange
                ]);
            } else {
                const clamped = Math.max(newValue[1], $084d11a9a67aa7fe$var$minRange);
                setPlotRange([
                    clamped - $084d11a9a67aa7fe$var$minRange,
                    clamped
                ]);
            }
        } else setPlotRange(newValue);
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                className: "tabSelectorBox",
                children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $bd3cee31033a2ffb$export$2e2bcd8739ae039), {
                    value: tabIndex,
                    onChange: handleChange,
                    indicatorColor: "secondary",
                    textColor: "inherit",
                    children: [
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                            label: "Data upload",
                            ...$084d11a9a67aa7fe$var$a11yProps(0)
                        }),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                            label: "Pipeline",
                            ...$084d11a9a67aa7fe$var$a11yProps(1)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $d05942294bd40f71$export$2e2bcd8739ae039), {
                value: tabIndex,
                index: 1,
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        container: true,
                        alignItems: 'center',
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 10,
                                children: [
                                    isFetching && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $2fce601e44012509$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30e31766597ec5b3$export$acaa6426d77a227e), {
                                        type: "line",
                                        options: (0, $5f903a59899d8702$export$9ddeaa9e19f67d3e)(plotQueryProps),
                                        data: DetailedData
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 2,
                                children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                    container: true,
                                    spacing: 1,
                                    columns: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3da0b51f836cadba$export$2e2bcd8739ae039), {
                                            AllLists: AllLists,
                                            plotQueryProps: plotQueryProps,
                                            setPlotQueryProps: setPlotQueryProps,
                                            filterConfigList: (0, $5f903a59899d8702$export$a2add78d6ffe0431)
                                        }),
                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 1,
                                            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $1817a2bcf8f12485$export$2e2bcd8739ae039), {
                                                label: "Funding mode",
                                                name: "inFundingMode",
                                                onChange: (e)=>setPlotQueryProps({
                                                        ...plotQueryProps,
                                                        [e.target.name]: e.target.value
                                                    }),
                                                select: true,
                                                required: true,
                                                fullWidth: true,
                                                value: plotQueryProps["inFundingMode"],
                                                variant: "filled",
                                                defaultValue: "ALL",
                                                size: "small",
                                                children: [
                                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                        value: "ALL",
                                                        children: "ALL"
                                                    }, "ALL"),
                                                    (0, $243a1246ea7835d9$export$14085c2a147de944).map((option)=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                            value: option.value,
                                                            children: option.text
                                                        }, option.value))
                                                ]
                                            }, "fundingMode")
                                        }),
                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 1,
                                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1b3e290cec22a366$export$2e2bcd8739ae039), {
                                                title: "Display Unit Filter",
                                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $5a88d895317a42d5$export$2e2bcd8739ae039), {
                                                    value: plotQueryProps.unit,
                                                    exclusive: true,
                                                    onChange: (event, value)=>{
                                                        if (value != null) setPlotQueryProps({
                                                            ...plotQueryProps,
                                                            unit: value
                                                        });
                                                    },
                                                    "aria-label": "Display Unit Filter",
                                                    fullWidth: true,
                                                    size: "small"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            pt: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                id: "input-slider",
                                gutterBottom: true,
                                children: "Fiscal Year"
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $36fe94807ea896b0$export$2e2bcd8739ae039), {
                                getAriaLabel: ()=>'Plot Range',
                                value: plotRange,
                                onChange: handleSliderChange,
                                valueLabelDisplay: "on",
                                disableSwap: true,
                                step: 1,
                                marks: true,
                                min: minPlotRange,
                                max: maxPlotRange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            fontStyle: "italic",
                            fontWeight: 700,
                            mt: 2,
                            fontFamily: "ProximaNova-Bold"
                        },
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                            children: (0, $d29d6d1034e01aa1$export$f68e326d679cfc85)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d05942294bd40f71$export$2e2bcd8739ae039), {
                value: tabIndex,
                index: 0,
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $31a2e9aed63ca5a2$export$2e2bcd8739ae039), {})
            })
        ]
    });
}



var $bHJbJ = parcelRequire("bHJbJ");
parcelRequire("i5lfL");

function $ea3a0d8f8c59965d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        sx: {
            px: 15,
            py: 8
        },
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                variant: "h2",
                component: "h2",
                children: "Glossary"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                sx: {
                    py: 3
                },
                children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                    variant: "body1",
                    component: "div",
                    children: [
                        "Pipeline definition",
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                            children: "Major Public Infrastructure Pipeline (MPIP):"
                        }),
                        " Publicly funded infrastructure projects valued over $100 million in New South Wales, Victoria, Queensland and Western Australia, and over $50 million in South Australia, the Australian Capital Territory, the Northern Territory and Tasmania.",
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                            children: "Small Capital Public Infrastructure Pipeline (SCPIP):"
                        }),
                        " Publicly funded infrastructure projects valued $100 million and under in New South Wales, Victoria, Queensland and Western Australia, and $50 million and under in South Australia, the Australian Capital Territory, the Northern Territory and Tasmania.",
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                            children: "Private Infrastructure Pipeline:"
                        }),
                        " Privately funded public infrastructure such as a wind farm that is funded, delivered, and operated by the private sector.",
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                            children: "Private construction:"
                        }),
                        " Residential and non-residential buildings projects.",
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                            children: "Road maintenance:"
                        }),
                        " Resource demands for road maintenance projects.",
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        "Project type definition",
                        /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bHJbJ.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                                            children: "Buildings:"
                                        }),
                                        " non-residential buildings for health, education, sport, justice, transport buildings (e.g., parking facility and warehouse), other buildings (art facilities, civic/convention centres, and offices), limited coverage of detached and semi-detached residential buildings."
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                                /*#__PURE__*/ (0, $bHJbJ.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                                            children: "Transport:"
                                        }),
                                        " roads, railways, level crossings and other transport projects such as airport runways."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                                /*#__PURE__*/ (0, $bHJbJ.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                                            children: "Utilities:"
                                        }),
                                        " water and sewerage, energy and fuels, gas and water pipelines, and telecommunications."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $bHJbJ = parcelRequire("bHJbJ");
parcelRequire("i5lfL");


var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");

var $j7y1Z = parcelRequire("j7y1Z");

var $1f0fbfad19195021$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($1f0fbfad19195021$exports, "__esModule", {
    value: true
});
$1f0fbfad19195021$exports.default = void 0;

var $1f0fbfad19195021$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $1f0fbfad19195021$var$_default = $1f0fbfad19195021$exports.default = (0, $1f0fbfad19195021$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M19 13H5v-2h14z"
}), 'Remove');



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");
parcelRequire("67Wr0");


var $kRbLW = parcelRequire("kRbLW");


var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");



var $i5lfL = parcelRequire("i5lfL");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $290e1bb8f21c9444$var$AccordionContext = /*#__PURE__*/ $i5lfL.createContext({});
var $290e1bb8f21c9444$export$2e2bcd8739ae039 = $290e1bb8f21c9444$var$AccordionContext;





var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $8310759a27f7af3c$export$80fb6a2cb3f13b8b(slot) {
    return (0, $6bbZp.default)('MuiAccordion', slot);
}
const $8310759a27f7af3c$var$accordionClasses = (0, $47i1c.default)('MuiAccordion', [
    'root',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $8310759a27f7af3c$export$2e2bcd8739ae039 = $8310759a27f7af3c$var$accordionClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $70e2c25f86c4e2e7$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "slots",
    "slotProps",
    "TransitionComponent",
    "TransitionProps"
];
const $70e2c25f86c4e2e7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        region: [
            'region'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $8310759a27f7af3c$export$80fb6a2cb3f13b8b), classes);
};
const $70e2c25f86c4e2e7$var$AccordionRoot = (0, $j7y1Z.default)((0, $fa105ed17f31a2c8$export$2e2bcd8739ae039), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8310759a27f7af3c$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $8310759a27f7af3c$export$2e2bcd8739ae039).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $8310759a27f7af3c$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $8310759a27f7af3c$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    }));
const $70e2c25f86c4e2e7$var$Accordion = /*#__PURE__*/ $i5lfL.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp } = props, other = (0, $7qXFD.default)(props, $70e2c25f86c4e2e7$var$_excluded);
    const [expanded, setExpandedState] = (0, $84df25be484a0877$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $i5lfL.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $i5lfL.Children.toArray(childrenProp);
    const contextValue = $i5lfL.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $1CWiu.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $70e2c25f86c4e2e7$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, $1CWiu.default)({
        transition: TransitionComponentProp
    }, slots);
    const backwardCompatibleSlotProps = (0, $1CWiu.default)({
        transition: TransitionPropsProp
    }, slotProps);
    const [TransitionSlot, transitionProps] = (0, $8782b9214add240b$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $8d561c5085503182$export$2e2bcd8739ae039),
        externalForwardedProps: {
            slots: backwardCompatibleSlots,
            slotProps: backwardCompatibleSlotProps
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($70e2c25f86c4e2e7$var$AccordionRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $290e1bb8f21c9444$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)(TransitionSlot, (0, $1CWiu.default)({
                in: expanded,
                timeout: "auto"
            }, transitionProps, {
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
var $70e2c25f86c4e2e7$export$2e2bcd8739ae039 = $70e2c25f86c4e2e7$var$Accordion;



var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");

var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $a133f1a4d7546958$export$a6afb527becfac26(slot) {
    return (0, $6bbZp.default)('MuiAccordionDetails', slot);
}
const $a133f1a4d7546958$var$accordionDetailsClasses = (0, $47i1c.default)('MuiAccordionDetails', [
    'root'
]);
var $a133f1a4d7546958$export$2e2bcd8739ae039 = $a133f1a4d7546958$var$accordionDetailsClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $ccca2522d19a5229$var$_excluded = [
    "className"
];
const $ccca2522d19a5229$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $a133f1a4d7546958$export$a6afb527becfac26), classes);
};
const $ccca2522d19a5229$var$AccordionDetailsRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $ccca2522d19a5229$var$AccordionDetails = /*#__PURE__*/ $i5lfL.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className } = props, other = (0, $7qXFD.default)(props, $ccca2522d19a5229$var$_excluded);
    const ownerState = props;
    const classes = $ccca2522d19a5229$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($ccca2522d19a5229$var$AccordionDetailsRoot, (0, $1CWiu.default)({
        className: (0, $kRbLW.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $ccca2522d19a5229$export$2e2bcd8739ae039 = $ccca2522d19a5229$var$AccordionDetails;


var $1CWiu = parcelRequire("1CWiu");

var $7qXFD = parcelRequire("7qXFD");

var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $2ktY3 = parcelRequire("2ktY3");

var $j7y1Z = parcelRequire("j7y1Z");

var $kp44S = parcelRequire("kp44S");



var $47i1c = parcelRequire("47i1c");

var $6bbZp = parcelRequire("6bbZp");
function $736f5576f85e5fa6$export$282216ad123d6580(slot) {
    return (0, $6bbZp.default)('MuiAccordionSummary', slot);
}
const $736f5576f85e5fa6$var$accordionSummaryClasses = (0, $47i1c.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $736f5576f85e5fa6$export$2e2bcd8739ae039 = $736f5576f85e5fa6$var$accordionSummaryClasses;



var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $12ee177d584c903f$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $12ee177d584c903f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $2ktY3.default)(slots, (0, $736f5576f85e5fa6$export$282216ad123d6580), classes);
};
const $12ee177d584c903f$var$AccordionSummaryRoot = (0, $j7y1Z.default)((0, $07a3ed667acb77f6$export$2e2bcd8739ae039), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $736f5576f85e5fa6$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $736f5576f85e5fa6$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $736f5576f85e5fa6$export$2e2bcd8739ae039).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $736f5576f85e5fa6$export$2e2bcd8739ae039).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
});
const $12ee177d584c903f$var$AccordionSummaryContent = (0, $j7y1Z.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $736f5576f85e5fa6$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    }));
const $12ee177d584c903f$var$AccordionSummaryExpandIconWrapper = (0, $j7y1Z.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $736f5576f85e5fa6$export$2e2bcd8739ae039).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $12ee177d584c903f$var$AccordionSummary = /*#__PURE__*/ $i5lfL.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $kp44S.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $7qXFD.default)(props, $12ee177d584c903f$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $i5lfL.useContext((0, $290e1bb8f21c9444$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $1CWiu.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $12ee177d584c903f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($12ee177d584c903f$var$AccordionSummaryRoot, (0, $1CWiu.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $kRbLW.default)(classes.root, className),
        focusVisibleClassName: (0, $kRbLW.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)($12ee177d584c903f$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $bHJbJ.jsx)($12ee177d584c903f$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
var $12ee177d584c903f$export$2e2bcd8739ae039 = $12ee177d584c903f$var$AccordionSummary;


const $d9b071dcb7f4023d$var$Accordion = (0, $j7y1Z.default)((props)=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $70e2c25f86c4e2e7$export$2e2bcd8739ae039), {
        disableGutters: true,
        elevation: 0,
        square: true,
        ...props
    }))(({ theme: theme })=>({
        border: `1px solid #000`,
        '&:not(:last-child)': {
            borderBottom: 0
        },
        '&:before': {
            display: 'none'
        }
    }));
function $d9b071dcb7f4023d$export$2e2bcd8739ae039(props) {
    const [expanded, setExpanded] = (0, $i5lfL.useState)(false);
    const handleAccordionChange = ()=>{
        setExpanded(!expanded);
    };
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)($d9b071dcb7f4023d$var$Accordion, {
        expanded: expanded,
        onChange: handleAccordionChange,
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $12ee177d584c903f$export$2e2bcd8739ae039), {
                expandIcon: expanded ? /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1f0fbfad19195021$exports))), {
                    fontSize: "small"
                }) : /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f7454d0d2ff8e9f6$exports))), {
                    fontSize: "small"
                }),
                "aria-controls": "panel1a-content",
                id: "panel1a-header",
                sx: {
                    backgroundColor: expanded ? "#E0E7EC" : "#fff"
                },
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                    variant: "h4",
                    children: `Q. ${props.question}`
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $ccca2522d19a5229$export$2e2bcd8739ae039), {
                sx: {
                    backgroundColor: expanded ? "#E0E7EC" : "#fff"
                },
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                    children: `A: ${props.answer}`
                })
            })
        ]
    });
}


var $cffdc567678e67aa$exports = {};
$cffdc567678e67aa$exports = JSON.parse('[{"id":1,"question":"What is the Infrastructure Scenario Modelling Tool?","answer":"The Infrastructure Scenario Modelling Tool is an interactive platform built by Infrastructure Australia. It allows users to test \u201Cwhat if\u201D scenarios by adjusting project data variables such as timelines, phases, and project mix. By exploring multiple scenarios, users can observe and compare the cascading impacts of differing alternatives on baselines and forecasts, leading to better investment decisions and outcomes."},{"id":2,"question":"What data and assumptions support the Infrastructure Scenario Modelling Tool?","answer":"The scenario modelling tool is using the same assumptions used in our Market Capacity Report. You can find the detailed methodology in appendix"},{"id":3,"question":"Does everyone have the same view/access?","answer":"No. The Scenario Modelling platform currently support 3 user categories. Internal Infrastructure Australia users have the capability to view all data provided to IA or accumulated by IA. Federal users will have access to federal supplied data as well as data collected by IA. Jurisdiction user are granted access to data provided by their respective jurisdictions, federal data pertinent to their state, and IA collected relevant to their state."},{"id":4,"question":"What types of scenarios can I create?","answer":"You can create any scenario by removing/ modifying existing pipeline or adding new projects into pipeline. The tool will forecast demand based your revised pipeline compare that to the current baseline."},{"id":5,"question":"What is the output format/content for a scenario?","answer":"The output of a scenario is displayed as graphs and is located within the Output Tab of the platform."},{"id":6,"question":"Can I share scenarios/outputs with unregistered /non-government users?","answer":"The platform is currently not supporting sharing of scenario. However, that is on our development roadmap."},{"id":7,"question":"What are the Terms of Use that apply?","answer":"The Deed of Agreement between IA and each State / Territory covers the terms under which use of this site is agreed."}]');


function $1af3446558d19db6$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
        sx: {
            px: 15,
            py: 8
        },
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                variant: "h2",
                component: "h2",
                children: "FAQs"
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                sx: {
                    py: 3
                },
                children: (0, (/*@__PURE__*/$parcel$interopDefault($cffdc567678e67aa$exports))).map((faq, index)=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                        sx: {
                            pt: 3
                        },
                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d9b071dcb7f4023d$export$2e2bcd8739ae039), {
                            question: faq.question,
                            answer: faq.answer
                        })
                    }, index))
            })
        ]
    });
}



var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");


var $i5lfL = parcelRequire("i5lfL");
function $f876fbaaf30f9e9a$export$8a8216c44337cd5(key, value) {
    try {
        sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error('Error saving to sessionStorage', error);
    }
}
function $f876fbaaf30f9e9a$export$f92dfeb71e9bb569(key) {
    try {
        const item = sessionStorage.getItem(key);
        return item ? JSON.parse(item) : undefined;
    } catch (error) {
        console.error('Error reading from sessionStorage', error);
    }
}


function $15fcb3e9846e132a$var$usePersistedState(key, initialValue) {
    const [state, setState] = (0, $i5lfL.useState)(()=>{
        return (0, $f876fbaaf30f9e9a$export$f92dfeb71e9bb569)(key) ?? initialValue;
    });
    (0, $i5lfL.useEffect)(()=>{
        (0, $f876fbaaf30f9e9a$export$8a8216c44337cd5)(key, state);
    }, [
        key,
        state
    ]);
    return [
        state,
        setState
    ];
}
var $15fcb3e9846e132a$export$2e2bcd8739ae039 = $15fcb3e9846e132a$var$usePersistedState;




var $i5lfL = parcelRequire("i5lfL");


var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $5540d48de058653b$var$Context = /*#__PURE__*/ $i5lfL.createContext(null);
function $5540d48de058653b$var$useUniquePrefix() {
    const [id, setId] = $i5lfL.useState(null);
    $i5lfL.useEffect(()=>{
        setId(`mui-p-${Math.round(Math.random() * 1e5)}`);
    }, []);
    return id;
}
function $5540d48de058653b$export$2e2bcd8739ae039(props) {
    const { children: children, value: value } = props;
    const idPrefix = $5540d48de058653b$var$useUniquePrefix();
    const context = $i5lfL.useMemo(()=>{
        return {
            idPrefix: idPrefix,
            value: value
        };
    }, [
        idPrefix,
        value
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($5540d48de058653b$var$Context.Provider, {
        value: context,
        children: children
    });
}
function $5540d48de058653b$export$5a3bad273ac578e0() {
    return $i5lfL.useContext($5540d48de058653b$var$Context);
}
function $5540d48de058653b$export$629f80328afcade5(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-P-${value}`;
}
function $5540d48de058653b$export$46f6d19d28231cb8(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-T-${value}`;
}


var $i5lfL = parcelRequire("i5lfL");




var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $2201f6503942c9ea$var$TabList = /*#__PURE__*/ $i5lfL.forwardRef(function TabList(props, ref) {
    const { children: childrenProp, ...other } = props;
    const context = (0, $5540d48de058653b$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError('No TabContext provided');
    const children = $i5lfL.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $i5lfL.isValidElement(child)) return null;
        return /*#__PURE__*/ $i5lfL.cloneElement(child, {
            // SOMEDAY: `Tabs` will set those themselves
            'aria-controls': (0, $5540d48de058653b$export$629f80328afcade5)(context, child.props.value),
            id: (0, $5540d48de058653b$export$46f6d19d28231cb8)(context, child.props.value)
        });
    });
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $bd3cee31033a2ffb$export$2e2bcd8739ae039), {
        ...other,
        ref: ref,
        value: context.value,
        children: children
    });
});
var $2201f6503942c9ea$export$2e2bcd8739ae039 = $2201f6503942c9ea$var$TabList;


var $i5lfL = parcelRequire("i5lfL");


var $kRbLW = parcelRequire("kRbLW");

var $j7y1Z = parcelRequire("j7y1Z");
var $4e974d2f6c119df0$exports = {};
"use strict";

var $kHfzc = parcelRequire("kHfzc");
var $4e974d2f6c119df0$require$_interopRequireDefault = $kHfzc.default;
Object.defineProperty($4e974d2f6c119df0$exports, "__esModule", {
    value: true
});
Object.defineProperty($4e974d2f6c119df0$exports, "default", {
    enumerable: true,
    get: function() {
        return $4e974d2f6c119df0$var$_composeClasses.default;
    }
});

var $4e974d2f6c119df0$var$_composeClasses = $4e974d2f6c119df0$require$_interopRequireDefault((parcelRequire("jifDs")));



var $2NceQ = parcelRequire("2NceQ");
var $beab75e1145298c8$exports = {};
"use strict";

var $kHfzc = parcelRequire("kHfzc");
var $beab75e1145298c8$require$_interopRequireDefault = $kHfzc.default;
Object.defineProperty($beab75e1145298c8$exports, "__esModule", {
    value: true
});
Object.defineProperty($beab75e1145298c8$exports, "default", {
    enumerable: true,
    get: function() {
        return $beab75e1145298c8$var$_generateUtilityClasses.default;
    }
});

var $beab75e1145298c8$var$_generateUtilityClasses = $beab75e1145298c8$require$_interopRequireDefault((parcelRequire("dep9Y")));


function $c85b2baa721b0327$export$cfb3da2e74936ec(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2NceQ)))('MuiTabPanel', slot);
}
const $c85b2baa721b0327$var$tabPanelClasses = (0, (/*@__PURE__*/$parcel$interopDefault($beab75e1145298c8$exports)))('MuiTabPanel', [
    'root',
    'hidden'
]);
var $c85b2baa721b0327$export$2e2bcd8739ae039 = $c85b2baa721b0327$var$tabPanelClasses;




var $bHJbJ = parcelRequire("bHJbJ");
'use client';
const $ad3ecd37a4df4d13$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, hidden: hidden } = ownerState;
    const slots = {
        root: [
            'root',
            hidden && 'hidden'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($4e974d2f6c119df0$exports)))(slots, (0, $c85b2baa721b0327$export$cfb3da2e74936ec), classes);
};
const $ad3ecd37a4df4d13$var$TabPanelRoot = (0, $j7y1Z.default)('div', {
    name: 'MuiTabPanel',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(3)
    }));
const $ad3ecd37a4df4d13$var$TabPanel = /*#__PURE__*/ $i5lfL.forwardRef(function TabPanel(inProps, ref) {
    const props = (0, $ff0701065e7e2ab2$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTabPanel'
    });
    const { children: children, className: className, value: value, keepMounted: keepMounted = false, ...other } = props;
    const ownerState = {
        ...props
    };
    const classes = $ad3ecd37a4df4d13$var$useUtilityClasses(ownerState);
    const context = (0, $5540d48de058653b$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError('No TabContext provided');
    const id = (0, $5540d48de058653b$export$629f80328afcade5)(context, value);
    const tabId = (0, $5540d48de058653b$export$46f6d19d28231cb8)(context, value);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)($ad3ecd37a4df4d13$var$TabPanelRoot, {
        "aria-labelledby": tabId,
        className: (0, $kRbLW.default)(classes.root, className),
        hidden: value !== context.value,
        id: id,
        ref: ref,
        role: "tabpanel",
        ownerState: ownerState,
        ...other,
        children: (keepMounted || value === context.value) && children
    });
});
var $ad3ecd37a4df4d13$export$2e2bcd8739ae039 = $ad3ecd37a4df4d13$var$TabPanel;



var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $cee8e56dfb19339c$var$extendStatics = function(d, b) {
    $cee8e56dfb19339c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $cee8e56dfb19339c$var$extendStatics(d, b);
};
function $cee8e56dfb19339c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $cee8e56dfb19339c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $cee8e56dfb19339c$export$18ce0697a983be9b = function() {
    $cee8e56dfb19339c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cee8e56dfb19339c$export$18ce0697a983be9b.apply(this, arguments);
};
function $cee8e56dfb19339c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $cee8e56dfb19339c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $cee8e56dfb19339c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $cee8e56dfb19339c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $cee8e56dfb19339c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $cee8e56dfb19339c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $cee8e56dfb19339c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $cee8e56dfb19339c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $cee8e56dfb19339c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $cee8e56dfb19339c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $cee8e56dfb19339c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $cee8e56dfb19339c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $cee8e56dfb19339c$export$45d3717a4c69092e(o, m, p);
}
function $cee8e56dfb19339c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $cee8e56dfb19339c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $cee8e56dfb19339c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($cee8e56dfb19339c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $cee8e56dfb19339c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $cee8e56dfb19339c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $cee8e56dfb19339c$export$10c90e4f7922046c(v) {
    return this instanceof $cee8e56dfb19339c$export$10c90e4f7922046c ? (this.v = v, this) : new $cee8e56dfb19339c$export$10c90e4f7922046c(v);
}
function $cee8e56dfb19339c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $cee8e56dfb19339c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $cee8e56dfb19339c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $cee8e56dfb19339c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $cee8e56dfb19339c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $cee8e56dfb19339c$export$19a8beecd37a4c45 === "function" ? $cee8e56dfb19339c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $cee8e56dfb19339c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $cee8e56dfb19339c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $cee8e56dfb19339c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cee8e56dfb19339c$export$45d3717a4c69092e(result, mod, k);
    }
    $cee8e56dfb19339c$var$__setModuleDefault(result, mod);
    return result;
}
function $cee8e56dfb19339c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $cee8e56dfb19339c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $cee8e56dfb19339c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $cee8e56dfb19339c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $cee8e56dfb19339c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $cee8e56dfb19339c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $cee8e56dfb19339c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $cee8e56dfb19339c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $cee8e56dfb19339c$export$2e2bcd8739ae039 = {
    __extends: $cee8e56dfb19339c$export$a8ba968b8961cb8a,
    __assign: $cee8e56dfb19339c$export$18ce0697a983be9b,
    __rest: $cee8e56dfb19339c$export$3c9a16f847548506,
    __decorate: $cee8e56dfb19339c$export$29e00dfd3077644b,
    __param: $cee8e56dfb19339c$export$d5ad3fd78186038f,
    __metadata: $cee8e56dfb19339c$export$f1db080c865becb9,
    __awaiter: $cee8e56dfb19339c$export$1050f835b63b671e,
    __generator: $cee8e56dfb19339c$export$67ebef60e6f28a6,
    __createBinding: $cee8e56dfb19339c$export$45d3717a4c69092e,
    __exportStar: $cee8e56dfb19339c$export$f33643c0debef087,
    __values: $cee8e56dfb19339c$export$19a8beecd37a4c45,
    __read: $cee8e56dfb19339c$export$8d051b38c9118094,
    __spread: $cee8e56dfb19339c$export$afc72e2116322959,
    __spreadArrays: $cee8e56dfb19339c$export$6388937ca91ccae8,
    __spreadArray: $cee8e56dfb19339c$export$1216008129fb82ed,
    __await: $cee8e56dfb19339c$export$10c90e4f7922046c,
    __asyncGenerator: $cee8e56dfb19339c$export$e427f37a30a4de9b,
    __asyncDelegator: $cee8e56dfb19339c$export$bbd80228419bb833,
    __asyncValues: $cee8e56dfb19339c$export$e3b29a3d6162315f,
    __makeTemplateObject: $cee8e56dfb19339c$export$4fb47efe1390b86f,
    __importStar: $cee8e56dfb19339c$export$c21735bcef00d192,
    __importDefault: $cee8e56dfb19339c$export$da59b14a69baef04,
    __classPrivateFieldGet: $cee8e56dfb19339c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $cee8e56dfb19339c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $cee8e56dfb19339c$export$81fdc39f203e4e04,
    __addDisposableResource: $cee8e56dfb19339c$export$88ac25d8e944e405,
    __disposeResources: $cee8e56dfb19339c$export$8f076105dc360e92
};


function $679059fe0e08fd58$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $2fb517cfa88e9b6d$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $2fb517cfa88e9b6d$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $679059fe0e08fd58$export$2e2bcd8739ae039)(function(prop) {
    return $2fb517cfa88e9b6d$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $i5lfL = parcelRequire("i5lfL");
var $951e6a2a0940873a$exports = {};
//
$951e6a2a0940873a$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $8ff58f4ad977389a$export$71ad59f2e432cfe8 = "-ms-";
var $8ff58f4ad977389a$export$2c0f367103c8d01c = "-moz-";
var $8ff58f4ad977389a$export$39dfd62a25e0fe93 = "-webkit-";
var $8ff58f4ad977389a$export$a29989082612d0d9 = "comm";
var $8ff58f4ad977389a$export$aa3a2e812ca8570d = "rule";
var $8ff58f4ad977389a$export$527d108ccf083c2b = "decl";
var $8ff58f4ad977389a$export$d3d35020fa5b54f0 = "@page";
var $8ff58f4ad977389a$export$500415a86c544f73 = "@media";
var $8ff58f4ad977389a$export$a763edbf796b780a = "@import";
var $8ff58f4ad977389a$export$2790aeb8b4e5c826 = "@charset";
var $8ff58f4ad977389a$export$1cc683e23b84b133 = "@viewport";
var $8ff58f4ad977389a$export$9447a5efea57e862 = "@supports";
var $8ff58f4ad977389a$export$ef011b4e114b1fba = "@document";
var $8ff58f4ad977389a$export$6aad947bda0f3f46 = "@namespace";
var $8ff58f4ad977389a$export$b44a8529a35fcb60 = "@keyframes";
var $8ff58f4ad977389a$export$2c16de31893252e6 = "@font-face";
var $8ff58f4ad977389a$export$3d846dd52e150c6f = "@counter-style";
var $8ff58f4ad977389a$export$22314bfbb57653fe = "@font-feature-values";
var $8ff58f4ad977389a$export$d773506282b3cfe6 = "@layer";
var $8ff58f4ad977389a$export$1c5a554c78c0cd12 = "@scope";
var $8ff58f4ad977389a$export$2335f513bbd82c6d = Math.abs;
var $8ff58f4ad977389a$export$6788812c4e6611e6 = String.fromCharCode;
var $8ff58f4ad977389a$export$e6e34fd1f2686227 = Object.assign;
function $8ff58f4ad977389a$export$d6af199866bfb566(e, r) {
    return $8ff58f4ad977389a$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $8ff58f4ad977389a$export$a9db5e087081082d(e, 0)) << 2 ^ $8ff58f4ad977389a$export$a9db5e087081082d(e, 1)) << 2 ^ $8ff58f4ad977389a$export$a9db5e087081082d(e, 2)) << 2 ^ $8ff58f4ad977389a$export$a9db5e087081082d(e, 3) : 0;
}
function $8ff58f4ad977389a$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $8ff58f4ad977389a$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $8ff58f4ad977389a$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $8ff58f4ad977389a$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $8ff58f4ad977389a$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $8ff58f4ad977389a$export$36776f635604f274(e) {
    return e.length;
}
function $8ff58f4ad977389a$export$f9084667e487ed46(e) {
    return e.length;
}
function $8ff58f4ad977389a$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $8ff58f4ad977389a$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $8ff58f4ad977389a$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$8ff58f4ad977389a$export$4659b591c19bdf3d(e, r);
    });
}
var $8ff58f4ad977389a$export$53f1d5ea8de3d7c = 1;
var $8ff58f4ad977389a$export$4e0c71f277ca26b3 = 1;
var $8ff58f4ad977389a$export$f24224f1c91d8156 = 0;
var $8ff58f4ad977389a$export$5880b8b5730aff45 = 0;
var $8ff58f4ad977389a$export$c0306caf338ac095 = 0;
var $8ff58f4ad977389a$export$30a86d91af8ff6e6 = "";
function $8ff58f4ad977389a$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $8ff58f4ad977389a$export$53f1d5ea8de3d7c,
        column: $8ff58f4ad977389a$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $8ff58f4ad977389a$export$784d13d8ee351f07(e, r) {
    return $8ff58f4ad977389a$export$e6e34fd1f2686227($8ff58f4ad977389a$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $8ff58f4ad977389a$export$590e8b2c435046d9(e) {
    while(e.root)e = $8ff58f4ad977389a$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $8ff58f4ad977389a$export$10d8903dec122b9d(e, e.siblings);
}
function $8ff58f4ad977389a$export$eba6f6f03b0a92e7() {
    return $8ff58f4ad977389a$export$c0306caf338ac095;
}
function $8ff58f4ad977389a$export$232faf9add678146() {
    $8ff58f4ad977389a$export$c0306caf338ac095 = $8ff58f4ad977389a$export$5880b8b5730aff45 > 0 ? $8ff58f4ad977389a$export$a9db5e087081082d($8ff58f4ad977389a$export$30a86d91af8ff6e6, --$8ff58f4ad977389a$export$5880b8b5730aff45) : 0;
    if ($8ff58f4ad977389a$export$4e0c71f277ca26b3--, $8ff58f4ad977389a$export$c0306caf338ac095 === 10) $8ff58f4ad977389a$export$4e0c71f277ca26b3 = 1, $8ff58f4ad977389a$export$53f1d5ea8de3d7c--;
    return $8ff58f4ad977389a$export$c0306caf338ac095;
}
function $8ff58f4ad977389a$export$48cfd1e771a65c4f() {
    $8ff58f4ad977389a$export$c0306caf338ac095 = $8ff58f4ad977389a$export$5880b8b5730aff45 < $8ff58f4ad977389a$export$f24224f1c91d8156 ? $8ff58f4ad977389a$export$a9db5e087081082d($8ff58f4ad977389a$export$30a86d91af8ff6e6, $8ff58f4ad977389a$export$5880b8b5730aff45++) : 0;
    if ($8ff58f4ad977389a$export$4e0c71f277ca26b3++, $8ff58f4ad977389a$export$c0306caf338ac095 === 10) $8ff58f4ad977389a$export$4e0c71f277ca26b3 = 1, $8ff58f4ad977389a$export$53f1d5ea8de3d7c++;
    return $8ff58f4ad977389a$export$c0306caf338ac095;
}
function $8ff58f4ad977389a$export$4d3fb11e950abb9e() {
    return $8ff58f4ad977389a$export$a9db5e087081082d($8ff58f4ad977389a$export$30a86d91af8ff6e6, $8ff58f4ad977389a$export$5880b8b5730aff45);
}
function $8ff58f4ad977389a$export$e88cb2efb12ae807() {
    return $8ff58f4ad977389a$export$5880b8b5730aff45;
}
function $8ff58f4ad977389a$export$58adb3bec8346d0f(e, r) {
    return $8ff58f4ad977389a$export$2f35ab04d2335697($8ff58f4ad977389a$export$30a86d91af8ff6e6, e, r);
}
function $8ff58f4ad977389a$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $8ff58f4ad977389a$export$2de70f21292aac9e(e) {
    return $8ff58f4ad977389a$export$53f1d5ea8de3d7c = $8ff58f4ad977389a$export$4e0c71f277ca26b3 = 1, $8ff58f4ad977389a$export$f24224f1c91d8156 = $8ff58f4ad977389a$export$36776f635604f274($8ff58f4ad977389a$export$30a86d91af8ff6e6 = e), $8ff58f4ad977389a$export$5880b8b5730aff45 = 0, [];
}
function $8ff58f4ad977389a$export$45918ac1574455b1(e) {
    return $8ff58f4ad977389a$export$30a86d91af8ff6e6 = "", e;
}
function $8ff58f4ad977389a$export$410ac95b9ec204b8(e) {
    return $8ff58f4ad977389a$export$87c2784dc9fc4ab($8ff58f4ad977389a$export$58adb3bec8346d0f($8ff58f4ad977389a$export$5880b8b5730aff45 - 1, $8ff58f4ad977389a$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $8ff58f4ad977389a$export$660b2ee2d4fb4eff(e) {
    return $8ff58f4ad977389a$export$45918ac1574455b1($8ff58f4ad977389a$export$5f8c09e3ae6f64e1($8ff58f4ad977389a$export$2de70f21292aac9e(e)));
}
function $8ff58f4ad977389a$export$7af1228ff777d175(e) {
    while($8ff58f4ad977389a$export$c0306caf338ac095 = $8ff58f4ad977389a$export$4d3fb11e950abb9e())if ($8ff58f4ad977389a$export$c0306caf338ac095 < 33) $8ff58f4ad977389a$export$48cfd1e771a65c4f();
    else break;
    return $8ff58f4ad977389a$export$9e1725a4cfeada27(e) > 2 || $8ff58f4ad977389a$export$9e1725a4cfeada27($8ff58f4ad977389a$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $8ff58f4ad977389a$export$5f8c09e3ae6f64e1(e) {
    while($8ff58f4ad977389a$export$48cfd1e771a65c4f())switch($8ff58f4ad977389a$export$9e1725a4cfeada27($8ff58f4ad977389a$export$c0306caf338ac095)){
        case 0:
            $8ff58f4ad977389a$export$10d8903dec122b9d($8ff58f4ad977389a$export$c2ab62c7bf24634($8ff58f4ad977389a$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $8ff58f4ad977389a$export$10d8903dec122b9d($8ff58f4ad977389a$export$410ac95b9ec204b8($8ff58f4ad977389a$export$c0306caf338ac095), e);
            break;
        default:
            $8ff58f4ad977389a$export$10d8903dec122b9d($8ff58f4ad977389a$export$6788812c4e6611e6($8ff58f4ad977389a$export$c0306caf338ac095), e);
    }
    return e;
}
function $8ff58f4ad977389a$export$955ba06d119e085e(e, r) {
    while(--r && $8ff58f4ad977389a$export$48cfd1e771a65c4f())if ($8ff58f4ad977389a$export$c0306caf338ac095 < 48 || $8ff58f4ad977389a$export$c0306caf338ac095 > 102 || $8ff58f4ad977389a$export$c0306caf338ac095 > 57 && $8ff58f4ad977389a$export$c0306caf338ac095 < 65 || $8ff58f4ad977389a$export$c0306caf338ac095 > 70 && $8ff58f4ad977389a$export$c0306caf338ac095 < 97) break;
    return $8ff58f4ad977389a$export$58adb3bec8346d0f(e, $8ff58f4ad977389a$export$e88cb2efb12ae807() + (r < 6 && $8ff58f4ad977389a$export$4d3fb11e950abb9e() == 32 && $8ff58f4ad977389a$export$48cfd1e771a65c4f() == 32));
}
function $8ff58f4ad977389a$export$c889f2fcc19dbf12(e) {
    while($8ff58f4ad977389a$export$48cfd1e771a65c4f())switch($8ff58f4ad977389a$export$c0306caf338ac095){
        case e:
            return $8ff58f4ad977389a$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $8ff58f4ad977389a$export$c889f2fcc19dbf12($8ff58f4ad977389a$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $8ff58f4ad977389a$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $8ff58f4ad977389a$export$48cfd1e771a65c4f();
            break;
    }
    return $8ff58f4ad977389a$export$5880b8b5730aff45;
}
function $8ff58f4ad977389a$export$4254d4e2b3745c4c(e, r) {
    while($8ff58f4ad977389a$export$48cfd1e771a65c4f())if (e + $8ff58f4ad977389a$export$c0306caf338ac095 === 57) break;
    else if (e + $8ff58f4ad977389a$export$c0306caf338ac095 === 84 && $8ff58f4ad977389a$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $8ff58f4ad977389a$export$58adb3bec8346d0f(r, $8ff58f4ad977389a$export$5880b8b5730aff45 - 1) + "*" + $8ff58f4ad977389a$export$6788812c4e6611e6(e === 47 ? e : $8ff58f4ad977389a$export$48cfd1e771a65c4f());
}
function $8ff58f4ad977389a$export$c2ab62c7bf24634(e) {
    while(!$8ff58f4ad977389a$export$9e1725a4cfeada27($8ff58f4ad977389a$export$4d3fb11e950abb9e()))$8ff58f4ad977389a$export$48cfd1e771a65c4f();
    return $8ff58f4ad977389a$export$58adb3bec8346d0f(e, $8ff58f4ad977389a$export$5880b8b5730aff45);
}
function $8ff58f4ad977389a$export$ef7acd7185315e22(e) {
    return $8ff58f4ad977389a$export$45918ac1574455b1($8ff58f4ad977389a$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $8ff58f4ad977389a$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $8ff58f4ad977389a$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $8ff58f4ad977389a$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $8ff58f4ad977389a$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($8ff58f4ad977389a$export$f8e21b1e77979a08(z += $8ff58f4ad977389a$export$77ad94ebf1c2b9ed($8ff58f4ad977389a$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $8ff58f4ad977389a$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $8ff58f4ad977389a$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $8ff58f4ad977389a$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $8ff58f4ad977389a$export$955ba06d119e085e($8ff58f4ad977389a$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($8ff58f4ad977389a$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $8ff58f4ad977389a$export$10d8903dec122b9d($8ff58f4ad977389a$export$4a34f930e789283c($8ff58f4ad977389a$export$4254d4e2b3745c4c($8ff58f4ad977389a$export$48cfd1e771a65c4f(), $8ff58f4ad977389a$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $8ff58f4ad977389a$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $8ff58f4ad977389a$export$36776f635604f274(z) - l) $8ff58f4ad977389a$export$10d8903dec122b9d(p > 32 ? $8ff58f4ad977389a$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $8ff58f4ad977389a$export$f8483753829ec8f3($8ff58f4ad977389a$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $8ff58f4ad977389a$export$10d8903dec122b9d(j = $8ff58f4ad977389a$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $8ff58f4ad977389a$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $8ff58f4ad977389a$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $8ff58f4ad977389a$export$98e6a39c04603d36(e, j, j, n && $8ff58f4ad977389a$export$10d8903dec122b9d($8ff58f4ad977389a$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $8ff58f4ad977389a$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $8ff58f4ad977389a$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $8ff58f4ad977389a$export$232faf9add678146() == 125) continue;
            }
            switch(z += $8ff58f4ad977389a$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($8ff58f4ad977389a$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($8ff58f4ad977389a$export$4d3fb11e950abb9e() === 45) z += $8ff58f4ad977389a$export$410ac95b9ec204b8($8ff58f4ad977389a$export$48cfd1e771a65c4f());
                    v = $8ff58f4ad977389a$export$4d3fb11e950abb9e(), o = l = $8ff58f4ad977389a$export$36776f635604f274(k = z += $8ff58f4ad977389a$export$c2ab62c7bf24634($8ff58f4ad977389a$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $8ff58f4ad977389a$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $8ff58f4ad977389a$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $8ff58f4ad977389a$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $8ff58f4ad977389a$export$2f35ab04d2335697(e, p + 1, p = $8ff58f4ad977389a$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $8ff58f4ad977389a$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $8ff58f4ad977389a$export$35059013cd4a06db(e, r, a, s === 0 ? $8ff58f4ad977389a$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $8ff58f4ad977389a$export$4a34f930e789283c(e, r, a, c) {
    return $8ff58f4ad977389a$export$35059013cd4a06db(e, r, a, $8ff58f4ad977389a$export$a29989082612d0d9, $8ff58f4ad977389a$export$6788812c4e6611e6($8ff58f4ad977389a$export$eba6f6f03b0a92e7()), $8ff58f4ad977389a$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $8ff58f4ad977389a$export$f8483753829ec8f3(e, r, a, n, c) {
    return $8ff58f4ad977389a$export$35059013cd4a06db(e, r, a, $8ff58f4ad977389a$export$527d108ccf083c2b, $8ff58f4ad977389a$export$2f35ab04d2335697(e, 0, n), $8ff58f4ad977389a$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $8ff58f4ad977389a$export$82e9f45cca5ba907(n, c, s) {
    switch($8ff58f4ad977389a$export$d6af199866bfb566(n, c)){
        case 5103:
            return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $8ff58f4ad977389a$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + $8ff58f4ad977389a$export$2c0f367103c8d01c + n + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($8ff58f4ad977389a$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $8ff58f4ad977389a$export$39dfd62a25e0fe93 + "box-$1$2" + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + "flex-item-" + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$8ff58f4ad977389a$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $8ff58f4ad977389a$export$71ad59f2e432cfe8 + "grid-row-" + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + "flex-line-pack" + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + "box-" + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, "-grow", "") + $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $8ff58f4ad977389a$export$39dfd62a25e0fe93 + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $8ff58f4ad977389a$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $8ff58f4ad977389a$export$77ad94ebf1c2b9ed($8ff58f4ad977389a$export$77ad94ebf1c2b9ed($8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $8ff58f4ad977389a$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $8ff58f4ad977389a$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $8ff58f4ad977389a$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $8ff58f4ad977389a$export$77ad94ebf1c2b9ed($8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $8ff58f4ad977389a$export$39dfd62a25e0fe93 + "box-pack:$3" + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $8ff58f4ad977389a$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$8ff58f4ad977389a$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $8ff58f4ad977389a$export$71ad59f2e432cfe8 + "grid-column-align" + $8ff58f4ad977389a$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $8ff58f4ad977389a$export$71ad59f2e432cfe8 + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $8ff58f4ad977389a$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$8ff58f4ad977389a$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $8ff58f4ad977389a$export$71ad59f2e432cfe8 + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$8ff58f4ad977389a$export$f8e21b1e77979a08(s, "span", 0) ? $8ff58f4ad977389a$export$4659b591c19bdf3d(s, /\d+/) : +$8ff58f4ad977389a$export$4659b591c19bdf3d(s, /\d+/) - +$8ff58f4ad977389a$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $8ff58f4ad977389a$export$71ad59f2e432cfe8 + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $8ff58f4ad977389a$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $8ff58f4ad977389a$export$71ad59f2e432cfe8 + $8ff58f4ad977389a$export$77ad94ebf1c2b9ed($8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $8ff58f4ad977389a$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($8ff58f4ad977389a$export$36776f635604f274(n) - 1 - c > 6) switch($8ff58f4ad977389a$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($8ff58f4ad977389a$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $8ff58f4ad977389a$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $8ff58f4ad977389a$export$2c0f367103c8d01c + ($8ff58f4ad977389a$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$8ff58f4ad977389a$export$f8e21b1e77979a08(n, "stretch", 0) ? $8ff58f4ad977389a$export$82e9f45cca5ba907($8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $8ff58f4ad977389a$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $8ff58f4ad977389a$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($8ff58f4ad977389a$export$a9db5e087081082d(n, c + 6) === 121) return $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, ":", ":" + $8ff58f4ad977389a$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($8ff58f4ad977389a$export$a9db5e087081082d(n, $8ff58f4ad977389a$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $8ff58f4ad977389a$export$39dfd62a25e0fe93 + ($8ff58f4ad977389a$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $8ff58f4ad977389a$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $8ff58f4ad977389a$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, ":", ":" + $8ff58f4ad977389a$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $8ff58f4ad977389a$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $8ff58f4ad977389a$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $8ff58f4ad977389a$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $8ff58f4ad977389a$export$a763edbf796b780a:
        case $8ff58f4ad977389a$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $8ff58f4ad977389a$export$a29989082612d0d9:
            return "";
        case $8ff58f4ad977389a$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $8ff58f4ad977389a$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $8ff58f4ad977389a$export$aa3a2e812ca8570d:
            if (!$8ff58f4ad977389a$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $8ff58f4ad977389a$export$36776f635604f274(a = $8ff58f4ad977389a$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $8ff58f4ad977389a$export$5a7767152ae0305f(e) {
    var r = $8ff58f4ad977389a$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $8ff58f4ad977389a$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $8ff58f4ad977389a$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $8ff58f4ad977389a$export$527d108ccf083c2b:
                n.return = $8ff58f4ad977389a$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $8ff58f4ad977389a$export$b44a8529a35fcb60:
                return $8ff58f4ad977389a$export$dfdc1655ccc5b9cb([
                    $8ff58f4ad977389a$export$784d13d8ee351f07(n, {
                        value: $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $8ff58f4ad977389a$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $8ff58f4ad977389a$export$aa3a2e812ca8570d:
                if (n.length) return $8ff58f4ad977389a$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($8ff58f4ad977389a$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $8ff58f4ad977389a$export$590e8b2c435046d9($8ff58f4ad977389a$export$784d13d8ee351f07(n, {
                                props: [
                                    $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $8ff58f4ad977389a$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $8ff58f4ad977389a$export$590e8b2c435046d9($8ff58f4ad977389a$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $8ff58f4ad977389a$export$e6e34fd1f2686227(n, {
                                props: $8ff58f4ad977389a$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $8ff58f4ad977389a$export$590e8b2c435046d9($8ff58f4ad977389a$export$784d13d8ee351f07(n, {
                                props: [
                                    $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $8ff58f4ad977389a$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $8ff58f4ad977389a$export$590e8b2c435046d9($8ff58f4ad977389a$export$784d13d8ee351f07(n, {
                                props: [
                                    $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $8ff58f4ad977389a$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $8ff58f4ad977389a$export$590e8b2c435046d9($8ff58f4ad977389a$export$784d13d8ee351f07(n, {
                                props: [
                                    $8ff58f4ad977389a$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $8ff58f4ad977389a$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $8ff58f4ad977389a$export$590e8b2c435046d9($8ff58f4ad977389a$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $8ff58f4ad977389a$export$e6e34fd1f2686227(n, {
                                props: $8ff58f4ad977389a$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $8ff58f4ad977389a$export$76a88f7de6507443(e) {
    switch(e.type){
        case $8ff58f4ad977389a$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $8ff58f4ad977389a$export$1be1fc439b849fdf($8ff58f4ad977389a$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($8ff58f4ad977389a$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $8ff58f4ad977389a$export$2f35ab04d2335697(r, 1, $8ff58f4ad977389a$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $8ff58f4ad977389a$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $8ff58f4ad977389a$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $8ff58f4ad977389a$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $e7ad882415a1fb13$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $d32f4b9bbd96f4f5$exports = {};
// shim for using process in browser
var $d32f4b9bbd96f4f5$var$process = $d32f4b9bbd96f4f5$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d32f4b9bbd96f4f5$var$cachedSetTimeout;
var $d32f4b9bbd96f4f5$var$cachedClearTimeout;
function $d32f4b9bbd96f4f5$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d32f4b9bbd96f4f5$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d32f4b9bbd96f4f5$var$cachedSetTimeout = setTimeout;
        else $d32f4b9bbd96f4f5$var$cachedSetTimeout = $d32f4b9bbd96f4f5$var$defaultSetTimout;
    } catch (e) {
        $d32f4b9bbd96f4f5$var$cachedSetTimeout = $d32f4b9bbd96f4f5$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d32f4b9bbd96f4f5$var$cachedClearTimeout = clearTimeout;
        else $d32f4b9bbd96f4f5$var$cachedClearTimeout = $d32f4b9bbd96f4f5$var$defaultClearTimeout;
    } catch (e) {
        $d32f4b9bbd96f4f5$var$cachedClearTimeout = $d32f4b9bbd96f4f5$var$defaultClearTimeout;
    }
})();
function $d32f4b9bbd96f4f5$var$runTimeout(fun) {
    if ($d32f4b9bbd96f4f5$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d32f4b9bbd96f4f5$var$cachedSetTimeout === $d32f4b9bbd96f4f5$var$defaultSetTimout || !$d32f4b9bbd96f4f5$var$cachedSetTimeout) && setTimeout) {
        $d32f4b9bbd96f4f5$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d32f4b9bbd96f4f5$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d32f4b9bbd96f4f5$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d32f4b9bbd96f4f5$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d32f4b9bbd96f4f5$var$runClearTimeout(marker) {
    if ($d32f4b9bbd96f4f5$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d32f4b9bbd96f4f5$var$cachedClearTimeout === $d32f4b9bbd96f4f5$var$defaultClearTimeout || !$d32f4b9bbd96f4f5$var$cachedClearTimeout) && clearTimeout) {
        $d32f4b9bbd96f4f5$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d32f4b9bbd96f4f5$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d32f4b9bbd96f4f5$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d32f4b9bbd96f4f5$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d32f4b9bbd96f4f5$var$queue = [];
var $d32f4b9bbd96f4f5$var$draining = false;
var $d32f4b9bbd96f4f5$var$currentQueue;
var $d32f4b9bbd96f4f5$var$queueIndex = -1;
function $d32f4b9bbd96f4f5$var$cleanUpNextTick() {
    if (!$d32f4b9bbd96f4f5$var$draining || !$d32f4b9bbd96f4f5$var$currentQueue) return;
    $d32f4b9bbd96f4f5$var$draining = false;
    if ($d32f4b9bbd96f4f5$var$currentQueue.length) $d32f4b9bbd96f4f5$var$queue = $d32f4b9bbd96f4f5$var$currentQueue.concat($d32f4b9bbd96f4f5$var$queue);
    else $d32f4b9bbd96f4f5$var$queueIndex = -1;
    if ($d32f4b9bbd96f4f5$var$queue.length) $d32f4b9bbd96f4f5$var$drainQueue();
}
function $d32f4b9bbd96f4f5$var$drainQueue() {
    if ($d32f4b9bbd96f4f5$var$draining) return;
    var timeout = $d32f4b9bbd96f4f5$var$runTimeout($d32f4b9bbd96f4f5$var$cleanUpNextTick);
    $d32f4b9bbd96f4f5$var$draining = true;
    var len = $d32f4b9bbd96f4f5$var$queue.length;
    while(len){
        $d32f4b9bbd96f4f5$var$currentQueue = $d32f4b9bbd96f4f5$var$queue;
        $d32f4b9bbd96f4f5$var$queue = [];
        while(++$d32f4b9bbd96f4f5$var$queueIndex < len)if ($d32f4b9bbd96f4f5$var$currentQueue) $d32f4b9bbd96f4f5$var$currentQueue[$d32f4b9bbd96f4f5$var$queueIndex].run();
        $d32f4b9bbd96f4f5$var$queueIndex = -1;
        len = $d32f4b9bbd96f4f5$var$queue.length;
    }
    $d32f4b9bbd96f4f5$var$currentQueue = null;
    $d32f4b9bbd96f4f5$var$draining = false;
    $d32f4b9bbd96f4f5$var$runClearTimeout(timeout);
}
$d32f4b9bbd96f4f5$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d32f4b9bbd96f4f5$var$queue.push(new $d32f4b9bbd96f4f5$var$Item(fun, args));
    if ($d32f4b9bbd96f4f5$var$queue.length === 1 && !$d32f4b9bbd96f4f5$var$draining) $d32f4b9bbd96f4f5$var$runTimeout($d32f4b9bbd96f4f5$var$drainQueue);
};
// v8 likes predictible objects
function $d32f4b9bbd96f4f5$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d32f4b9bbd96f4f5$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d32f4b9bbd96f4f5$var$process.title = 'browser';
$d32f4b9bbd96f4f5$var$process.browser = true;
$d32f4b9bbd96f4f5$var$process.env = {};
$d32f4b9bbd96f4f5$var$process.argv = [];
$d32f4b9bbd96f4f5$var$process.version = ''; // empty string to avoid regexp issues
$d32f4b9bbd96f4f5$var$process.versions = {};
function $d32f4b9bbd96f4f5$var$noop() {}
$d32f4b9bbd96f4f5$var$process.on = $d32f4b9bbd96f4f5$var$noop;
$d32f4b9bbd96f4f5$var$process.addListener = $d32f4b9bbd96f4f5$var$noop;
$d32f4b9bbd96f4f5$var$process.once = $d32f4b9bbd96f4f5$var$noop;
$d32f4b9bbd96f4f5$var$process.off = $d32f4b9bbd96f4f5$var$noop;
$d32f4b9bbd96f4f5$var$process.removeListener = $d32f4b9bbd96f4f5$var$noop;
$d32f4b9bbd96f4f5$var$process.removeAllListeners = $d32f4b9bbd96f4f5$var$noop;
$d32f4b9bbd96f4f5$var$process.emit = $d32f4b9bbd96f4f5$var$noop;
$d32f4b9bbd96f4f5$var$process.prependListener = $d32f4b9bbd96f4f5$var$noop;
$d32f4b9bbd96f4f5$var$process.prependOnceListener = $d32f4b9bbd96f4f5$var$noop;
$d32f4b9bbd96f4f5$var$process.listeners = function(name) {
    return [];
};
$d32f4b9bbd96f4f5$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d32f4b9bbd96f4f5$var$process.cwd = function() {
    return '/';
};
$d32f4b9bbd96f4f5$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d32f4b9bbd96f4f5$var$process.umask = function() {
    return 0;
};


var $2351587dc5656e18$var$f = ("undefined" != typeof $d32f4b9bbd96f4f5$exports && void 0 !== $d32f4b9bbd96f4f5$exports.env && undefined, "data-styled"), $2351587dc5656e18$var$m = "active", $2351587dc5656e18$var$y = "data-styled-version", $2351587dc5656e18$export$83d89fbfd8236492 = "6.1.17", $2351587dc5656e18$var$g = "/*!sc*/\n", $2351587dc5656e18$var$S = "undefined" != typeof window && "HTMLElement" in window, $2351587dc5656e18$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $d32f4b9bbd96f4f5$exports && $d32f4b9bbd96f4f5$exports.env, "undefined" != typeof $d32f4b9bbd96f4f5$exports && $d32f4b9bbd96f4f5$exports.env, false)), $2351587dc5656e18$var$b = {}, $2351587dc5656e18$var$E = /invalid hook call/i, $2351587dc5656e18$var$N = new Set, $2351587dc5656e18$var$P = function(t, n) {
    var o, s, i, a, e;
}, $2351587dc5656e18$var$_ = Object.freeze([]), $2351587dc5656e18$var$C = Object.freeze({});
function $2351587dc5656e18$var$I(e, t, n) {
    return void 0 === n && (n = $2351587dc5656e18$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $2351587dc5656e18$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $2351587dc5656e18$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $2351587dc5656e18$var$D = /(^-|-$)/g;
function $2351587dc5656e18$var$R(e) {
    return e.replace($2351587dc5656e18$var$O, "-").replace($2351587dc5656e18$var$D, "");
}
var $2351587dc5656e18$var$T = /(a)(d)/gi, $2351587dc5656e18$var$k = 52, $2351587dc5656e18$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $2351587dc5656e18$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $2351587dc5656e18$var$k; t = t / $2351587dc5656e18$var$k | 0)n = $2351587dc5656e18$var$j(t % $2351587dc5656e18$var$k) + n;
    return ($2351587dc5656e18$var$j(t % $2351587dc5656e18$var$k) + n).replace($2351587dc5656e18$var$T, "$1-$2");
}
var $2351587dc5656e18$var$V, $2351587dc5656e18$var$F = 5381, $2351587dc5656e18$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $2351587dc5656e18$var$z = function(e) {
    return $2351587dc5656e18$var$M($2351587dc5656e18$var$F, e);
};
function $2351587dc5656e18$var$$(e) {
    return $2351587dc5656e18$var$x($2351587dc5656e18$var$z(e) >>> 0);
}
function $2351587dc5656e18$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $2351587dc5656e18$var$L(e) {
    return "string" == typeof e && true;
}
var $2351587dc5656e18$var$G = "function" == typeof Symbol && Symbol.for, $2351587dc5656e18$var$Y = $2351587dc5656e18$var$G ? Symbol.for("react.memo") : 60115, $2351587dc5656e18$var$W = $2351587dc5656e18$var$G ? Symbol.for("react.forward_ref") : 60112, $2351587dc5656e18$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $2351587dc5656e18$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $2351587dc5656e18$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $2351587dc5656e18$var$J = (($2351587dc5656e18$var$V = {})[$2351587dc5656e18$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $2351587dc5656e18$var$V[$2351587dc5656e18$var$Y] = $2351587dc5656e18$var$U, $2351587dc5656e18$var$V);
function $2351587dc5656e18$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $2351587dc5656e18$var$Y ? $2351587dc5656e18$var$U : "$$typeof" in e ? $2351587dc5656e18$var$J[e.$$typeof] : $2351587dc5656e18$var$q;
}
var $2351587dc5656e18$var$Z = Object.defineProperty, $2351587dc5656e18$var$K = Object.getOwnPropertyNames, $2351587dc5656e18$var$Q = Object.getOwnPropertySymbols, $2351587dc5656e18$var$ee = Object.getOwnPropertyDescriptor, $2351587dc5656e18$var$te = Object.getPrototypeOf, $2351587dc5656e18$var$ne = Object.prototype;
function $2351587dc5656e18$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($2351587dc5656e18$var$ne) {
            var o = $2351587dc5656e18$var$te(t);
            o && o !== $2351587dc5656e18$var$ne && $2351587dc5656e18$var$oe(e, o, n);
        }
        var r = $2351587dc5656e18$var$K(t);
        $2351587dc5656e18$var$Q && (r = r.concat($2351587dc5656e18$var$Q(t)));
        for(var s = $2351587dc5656e18$var$X(e), i = $2351587dc5656e18$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $2351587dc5656e18$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $2351587dc5656e18$var$ee(t, c);
                try {
                    $2351587dc5656e18$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $2351587dc5656e18$var$re(e) {
    return "function" == typeof e;
}
function $2351587dc5656e18$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $2351587dc5656e18$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $2351587dc5656e18$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $2351587dc5656e18$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $2351587dc5656e18$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$2351587dc5656e18$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $2351587dc5656e18$var$le(e[o], t[o]);
    else if ($2351587dc5656e18$var$ce(t)) for(var o in t)e[o] = $2351587dc5656e18$var$le(e[o], t[o]);
    return e;
}
function $2351587dc5656e18$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $2351587dc5656e18$var$pe = {};
function $2351587dc5656e18$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $2351587dc5656e18$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $2351587dc5656e18$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $2351587dc5656e18$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($2351587dc5656e18$var$g);
        return t;
    }, e;
}(), $2351587dc5656e18$var$me = 1073741824, $2351587dc5656e18$var$ye = new Map, $2351587dc5656e18$var$ve = new Map, $2351587dc5656e18$var$ge = 1, $2351587dc5656e18$var$Se = function(e) {
    if ($2351587dc5656e18$var$ye.has(e)) return $2351587dc5656e18$var$ye.get(e);
    for(; $2351587dc5656e18$var$ve.has($2351587dc5656e18$var$ge);)$2351587dc5656e18$var$ge++;
    var t = $2351587dc5656e18$var$ge++;
    return $2351587dc5656e18$var$ye.set(e, t), $2351587dc5656e18$var$ve.set(t, e), t;
}, $2351587dc5656e18$var$we = function(e, t) {
    $2351587dc5656e18$var$ge = t + 1, $2351587dc5656e18$var$ye.set(e, t), $2351587dc5656e18$var$ve.set(t, e);
}, $2351587dc5656e18$var$be = "style[".concat($2351587dc5656e18$var$f, "][").concat($2351587dc5656e18$var$y, '="').concat($2351587dc5656e18$export$83d89fbfd8236492, '"]'), $2351587dc5656e18$var$Ee = new RegExp("^".concat($2351587dc5656e18$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $2351587dc5656e18$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $2351587dc5656e18$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($2351587dc5656e18$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($2351587dc5656e18$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($2351587dc5656e18$var$we(u, l), $2351587dc5656e18$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $2351587dc5656e18$var$_e = function(e) {
    for(var t = document.querySelectorAll($2351587dc5656e18$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($2351587dc5656e18$var$f) !== $2351587dc5656e18$var$m && ($2351587dc5656e18$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $2351587dc5656e18$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $2351587dc5656e18$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($2351587dc5656e18$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($2351587dc5656e18$var$f, $2351587dc5656e18$var$m), o.setAttribute($2351587dc5656e18$var$y, $2351587dc5656e18$export$83d89fbfd8236492);
    var i = $2351587dc5656e18$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $2351587dc5656e18$var$Ae = function() {
    function e(e) {
        this.element = $2351587dc5656e18$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $2351587dc5656e18$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $2351587dc5656e18$var$Oe = function() {
    function e(e) {
        this.element = $2351587dc5656e18$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $2351587dc5656e18$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $2351587dc5656e18$var$Re = $2351587dc5656e18$var$S, $2351587dc5656e18$var$Te = {
    isServer: !$2351587dc5656e18$var$S,
    useCSSOMInjection: !$2351587dc5656e18$var$w
}, $2351587dc5656e18$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $2351587dc5656e18$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $cee8e56dfb19339c$export$18ce0697a983be9b)((0, $cee8e56dfb19339c$export$18ce0697a983be9b)({}, $2351587dc5656e18$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $2351587dc5656e18$var$S && $2351587dc5656e18$var$Re && ($2351587dc5656e18$var$Re = !1, $2351587dc5656e18$var$_e(this)), $2351587dc5656e18$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $2351587dc5656e18$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($2351587dc5656e18$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($2351587dc5656e18$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $2351587dc5656e18$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $2351587dc5656e18$var$S && $2351587dc5656e18$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $cee8e56dfb19339c$export$18ce0697a983be9b)((0, $cee8e56dfb19339c$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $2351587dc5656e18$var$De(n) : t ? new $2351587dc5656e18$var$Ae(n) : new $2351587dc5656e18$var$Oe(n);
        }(this.options), new $2351587dc5656e18$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($2351587dc5656e18$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($2351587dc5656e18$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($2351587dc5656e18$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $2351587dc5656e18$var$je = /&/g, $2351587dc5656e18$var$xe = /^\s*\/\/.*$/gm;
function $2351587dc5656e18$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $2351587dc5656e18$var$Ve(e.children, t)), e;
    });
}
function $2351587dc5656e18$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $2351587dc5656e18$var$C : e, s = r.options, i = void 0 === s ? $2351587dc5656e18$var$C : s, a = r.plugins, c = void 0 === a ? $2351587dc5656e18$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $8ff58f4ad977389a$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($2351587dc5656e18$var$je, n).replace(o, l));
    }), i.prefix && u.push($8ff58f4ad977389a$export$e08c7d021b829b7a), u.push($8ff58f4ad977389a$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($2351587dc5656e18$var$xe, ""), l = $8ff58f4ad977389a$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $2351587dc5656e18$var$Ve(l, i.namespace));
        var p = [];
        return $8ff58f4ad977389a$export$dfdc1655ccc5b9cb(l, $8ff58f4ad977389a$export$5a7767152ae0305f(u.concat($8ff58f4ad977389a$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $2351587dc5656e18$var$he(15), $2351587dc5656e18$var$M(e, t.name);
    }, $2351587dc5656e18$var$F).toString() : "", p;
}
var $2351587dc5656e18$var$Me = new $2351587dc5656e18$var$ke, $2351587dc5656e18$var$ze = $2351587dc5656e18$var$Fe(), $2351587dc5656e18$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $2351587dc5656e18$var$Me,
    stylis: $2351587dc5656e18$var$ze
}), $2351587dc5656e18$export$91317688fc694efa = $2351587dc5656e18$export$8c190ef828af4c86.Consumer, $2351587dc5656e18$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createContext(void 0);
function $2351587dc5656e18$var$Ge() {
    return (0, $i5lfL.useContext)($2351587dc5656e18$export$8c190ef828af4c86);
}
function $2351587dc5656e18$export$a473771da2f0ff7c(e) {
    var t = (0, $i5lfL.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $2351587dc5656e18$var$Ge().styleSheet, l = (0, $i5lfL.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $i5lfL.useMemo)(function() {
        return $2351587dc5656e18$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $i5lfL.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($951e6a2a0940873a$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $i5lfL.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement($2351587dc5656e18$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement($2351587dc5656e18$var$Le.Provider, {
        value: u
    }, e.children));
}
var $2351587dc5656e18$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $2351587dc5656e18$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $2351587dc5656e18$var$ue(this, function() {
            throw $2351587dc5656e18$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $2351587dc5656e18$var$ze), this.name + e.hash;
    }, e;
}(), $2351587dc5656e18$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $2351587dc5656e18$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $2351587dc5656e18$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $2351587dc5656e18$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $2351587dc5656e18$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$2351587dc5656e18$var$Ue(i) && (Array.isArray(i) && i.isCss || $2351587dc5656e18$var$re(i) ? r.push("".concat($2351587dc5656e18$var$He(s), ":"), i, ";") : $2351587dc5656e18$var$ce(i) ? r.push.apply(r, (0, $cee8e56dfb19339c$export$1216008129fb82ed)((0, $cee8e56dfb19339c$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $2351587dc5656e18$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($2351587dc5656e18$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $e7ad882415a1fb13$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $2351587dc5656e18$var$Xe(e, t, n, o) {
    if ($2351587dc5656e18$var$Ue(e)) return [];
    if ($2351587dc5656e18$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($2351587dc5656e18$var$re(e)) {
        if (!$2351587dc5656e18$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $2351587dc5656e18$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $2351587dc5656e18$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $2351587dc5656e18$var$ce(e) ? $2351587dc5656e18$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($2351587dc5656e18$var$_, e.map(function(e) {
        return $2351587dc5656e18$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $2351587dc5656e18$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($2351587dc5656e18$var$re(n) && !$2351587dc5656e18$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $2351587dc5656e18$var$Ke = $2351587dc5656e18$var$z($2351587dc5656e18$export$83d89fbfd8236492), $2351587dc5656e18$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $2351587dc5656e18$var$Ze(e), this.componentId = t, this.baseHash = $2351587dc5656e18$var$M($2351587dc5656e18$var$Ke, t), this.baseStyle = n, $2351587dc5656e18$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $2351587dc5656e18$var$ie(o, this.staticRulesId);
            else {
                var r = $2351587dc5656e18$var$ae($2351587dc5656e18$var$Xe(this.rules, e, t, n)), s = $2351587dc5656e18$var$x($2351587dc5656e18$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $2351587dc5656e18$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $2351587dc5656e18$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $2351587dc5656e18$var$ae($2351587dc5656e18$var$Xe(u, e, t, n));
                    a = $2351587dc5656e18$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $2351587dc5656e18$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $2351587dc5656e18$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $2351587dc5656e18$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createContext(void 0), $2351587dc5656e18$export$b631efc24e9d5e2f = $2351587dc5656e18$export$2c657da244d00bd6.Consumer;
function $2351587dc5656e18$export$93d4e7f90805808f() {
    var e = (0, $i5lfL.useContext)($2351587dc5656e18$export$2c657da244d00bd6);
    if (!e) throw $2351587dc5656e18$var$he(18);
    return e;
}
function $2351587dc5656e18$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).useContext($2351587dc5656e18$export$2c657da244d00bd6), r = (0, $i5lfL.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $2351587dc5656e18$var$he(14);
            if ($2351587dc5656e18$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $2351587dc5656e18$var$he(8);
            return n ? (0, $cee8e56dfb19339c$export$18ce0697a983be9b)((0, $cee8e56dfb19339c$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement($2351587dc5656e18$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $2351587dc5656e18$var$rt = {}, $2351587dc5656e18$var$st = new Set;
function $2351587dc5656e18$var$it(e, r, s) {
    var i = $2351587dc5656e18$export$7ba318d8d2f06c76(e), a = e, c = !$2351587dc5656e18$var$L(e), p = r.attrs, d = void 0 === p ? $2351587dc5656e18$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $2351587dc5656e18$var$R(e);
        $2351587dc5656e18$var$rt[n] = ($2351587dc5656e18$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($2351587dc5656e18$var$$($2351587dc5656e18$export$83d89fbfd8236492 + n + $2351587dc5656e18$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $2351587dc5656e18$var$L(e) ? "styled.".concat(e) : "Styled(".concat($2351587dc5656e18$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($2351587dc5656e18$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $2351587dc5656e18$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).useContext($2351587dc5656e18$export$2c657da244d00bd6), m = $2351587dc5656e18$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $2351587dc5656e18$var$I(r, f, c) || $2351587dc5656e18$var$C, g = function(e, n, o) {
                for(var r, s = (0, $cee8e56dfb19339c$export$18ce0697a983be9b)((0, $cee8e56dfb19339c$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $2351587dc5656e18$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $2351587dc5656e18$var$ie(s[c], a[c]) : "style" === c ? (0, $cee8e56dfb19339c$export$18ce0697a983be9b)((0, $cee8e56dfb19339c$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $2351587dc5656e18$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $2351587dc5656e18$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $2351587dc5656e18$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$2351587dc5656e18$var$L(S) && !$2351587dc5656e18$var$A.has(S) ? "class" : "className"] = N, s && (w.ref = s), (0, $i5lfL.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $2351587dc5656e18$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$2351587dc5656e18$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $2351587dc5656e18$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $2351587dc5656e18$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $2351587dc5656e18$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $2351587dc5656e18$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $2351587dc5656e18$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($2351587dc5656e18$var$re(t) || $2351587dc5656e18$var$ce(t)) return $2351587dc5656e18$var$ct($2351587dc5656e18$var$Xe($2351587dc5656e18$var$at($2351587dc5656e18$var$_, (0, $cee8e56dfb19339c$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $2351587dc5656e18$var$Xe(r) : $2351587dc5656e18$var$ct($2351587dc5656e18$var$Xe($2351587dc5656e18$var$at(r, n)));
}
function $2351587dc5656e18$var$ut(n, o, r) {
    if (void 0 === r && (r = $2351587dc5656e18$var$C), !o) throw $2351587dc5656e18$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $2351587dc5656e18$export$dbf350e5966cf602.apply(void 0, (0, $cee8e56dfb19339c$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $2351587dc5656e18$var$ut(n, o, (0, $cee8e56dfb19339c$export$18ce0697a983be9b)((0, $cee8e56dfb19339c$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $2351587dc5656e18$var$ut(n, o, (0, $cee8e56dfb19339c$export$18ce0697a983be9b)((0, $cee8e56dfb19339c$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $2351587dc5656e18$var$pt = function(e) {
    return $2351587dc5656e18$var$ut($2351587dc5656e18$var$it, e);
}, $2351587dc5656e18$export$2e2bcd8739ae039 = $2351587dc5656e18$var$pt;
$2351587dc5656e18$var$A.forEach(function(e) {
    $2351587dc5656e18$export$2e2bcd8739ae039[e] = $2351587dc5656e18$var$pt(e);
});
var $2351587dc5656e18$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $2351587dc5656e18$var$Ze(e), $2351587dc5656e18$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($2351587dc5656e18$var$ae($2351587dc5656e18$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $2351587dc5656e18$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $2351587dc5656e18$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $2351587dc5656e18$export$dbf350e5966cf602.apply(void 0, (0, $cee8e56dfb19339c$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($2351587dc5656e18$var$$(JSON.stringify(i))), c = new $2351587dc5656e18$var$ht(i, a);
    var l = function(e) {
        var t = $2351587dc5656e18$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).useContext($2351587dc5656e18$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $2351587dc5656e18$var$b, o, s);
        else {
            var i = (0, $cee8e56dfb19339c$export$18ce0697a983be9b)((0, $cee8e56dfb19339c$export$18ce0697a983be9b)({}, n), {
                theme: $2351587dc5656e18$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).memo(l);
}
function $2351587dc5656e18$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $2351587dc5656e18$var$ae($2351587dc5656e18$export$dbf350e5966cf602.apply(void 0, (0, $cee8e56dfb19339c$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $2351587dc5656e18$var$$(r);
    return new $2351587dc5656e18$var$We(s, r);
}
function $2351587dc5656e18$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).forwardRef(function(n, r) {
        var s = $2351587dc5656e18$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).useContext($2351587dc5656e18$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement(e, (0, $cee8e56dfb19339c$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($2351587dc5656e18$var$B(e), ")"), $2351587dc5656e18$var$oe(n, e);
}
var $2351587dc5656e18$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $2351587dc5656e18$var$Ce(), o = $2351587dc5656e18$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($2351587dc5656e18$var$f, '="true"'),
                "".concat($2351587dc5656e18$var$y, '="').concat($2351587dc5656e18$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $2351587dc5656e18$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $2351587dc5656e18$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$2351587dc5656e18$var$f] = "", n[$2351587dc5656e18$var$y] = $2351587dc5656e18$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $2351587dc5656e18$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement("style", (0, $cee8e56dfb19339c$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $2351587dc5656e18$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $2351587dc5656e18$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($i5lfL))).createElement($2351587dc5656e18$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $2351587dc5656e18$var$he(3);
    }, e;
}(), $2351587dc5656e18$export$5c87cfe6c475f500 = {
    StyleSheet: $2351587dc5656e18$var$ke,
    mainSheet: $2351587dc5656e18$var$Me
};
var $2351587dc5656e18$var$St = "__sc-".concat($2351587dc5656e18$var$f, "__");


// Such export is called Tree Shaking. It allows to import only the components
// that are needed while webpack will remove the rest of the code from the bundle.
const $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c = "#4fa94d";
const $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18 = {
    "aria-busy": true,
    role: "progressbar"
};
const $753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56 = (0, $2351587dc5656e18$export$2e2bcd8739ae039).div`
  display: ${(props)=>props.$visible ? "flex" : "none"};
`;
const $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c = "http://www.w3.org/2000/svg";
const $753bfae0ab95f468$export$153755f98d9861de = ({ height: height = "100", width: width = "100", color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "audio-loading", wrapperStyle: wrapperStyle = {}, wrapperClass: wrapperClass, visible: visible = true })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "audio-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            height: `${height}`,
            width: `${width}`,
            fill: color,
            viewBox: "0 0 55 80",
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "audio-svg",
            children: [
                (0, $bHJbJ.jsx)("title", {
                    children: "Audio Visualization"
                }),
                (0, $bHJbJ.jsx)("desc", {
                    children: "Animated representation of audio data"
                }),
                (0, $bHJbJ.jsxs)("g", {
                    transform: "matrix(1 0 0 -1 0 80)",
                    children: [
                        (0, $bHJbJ.jsx)("rect", {
                            width: "10",
                            height: "20",
                            rx: "3",
                            children: (0, $bHJbJ.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "4.3s",
                                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $bHJbJ.jsx)("rect", {
                            x: "15",
                            width: "10",
                            height: "80",
                            rx: "3",
                            children: (0, $bHJbJ.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $bHJbJ.jsx)("rect", {
                            x: "30",
                            width: "10",
                            height: "50",
                            rx: "3",
                            children: (0, $bHJbJ.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "1.4s",
                                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $bHJbJ.jsx)("rect", {
                            x: "45",
                            width: "10",
                            height: "30",
                            rx: "3",
                            children: (0, $bHJbJ.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            ]
        })
    });
const $753bfae0ab95f468$export$68949ad0373623af = ({ height: height = 100, width: width = 100, radius: radius = 5, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "ball-triangle-loading", wrapperClass: wrapperClass, wrapperStyle: wrapperStyle, visible: visible = true })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: {
            ...wrapperStyle
        },
        $visible: visible,
        className: wrapperClass,
        "data-testid": "ball-triangle-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            height: height,
            width: width,
            stroke: color,
            viewBox: "0 0 57 57",
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "ball-triangle-svg",
            children: [
                (0, $bHJbJ.jsx)("title", {
                    children: "Ball Triangle"
                }),
                (0, $bHJbJ.jsx)("desc", {
                    children: "Animated representation of three balls"
                }),
                (0, $bHJbJ.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $bHJbJ.jsxs)("g", {
                        transform: "translate(1 1)",
                        strokeWidth: "2",
                        children: [
                            (0, $bHJbJ.jsxs)("circle", {
                                cx: "5",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $bHJbJ.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;5;50;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $bHJbJ.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "5;27;49;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $bHJbJ.jsxs)("circle", {
                                cx: "27",
                                cy: "5",
                                r: radius,
                                children: [
                                    (0, $bHJbJ.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "5",
                                        to: "5",
                                        values: "5;50;50;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $bHJbJ.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "27",
                                        to: "27",
                                        values: "27;49;5;27",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $bHJbJ.jsxs)("circle", {
                                cx: "49",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $bHJbJ.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;50;5;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $bHJbJ.jsx)("animate", {
                                        attributeName: "cx",
                                        from: "49",
                                        to: "49",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "49;5;27;49",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
const $753bfae0ab95f468$export$fbc7d6f7dd821b47 = ({ height: height = 80, width: width = 80, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "bars-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "bars-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            width: width,
            height: height,
            fill: color,
            viewBox: "0 0 135 140",
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "bars-svg",
            children: [
                (0, $bHJbJ.jsxs)("rect", {
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $bHJbJ.jsxs)("rect", {
                    x: "30",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $bHJbJ.jsxs)("rect", {
                    x: "60",
                    width: "15",
                    height: "140",
                    rx: "6",
                    children: [
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "height",
                            begin: "0s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "y",
                            begin: "0s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $bHJbJ.jsxs)("rect", {
                    x: "90",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $bHJbJ.jsxs)("rect", {
                    x: "120",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $753bfae0ab95f468$export$765808835a2dc0a2 = ({ height: height = 80, width: width = 80, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "circles-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "circles-loading",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 135 135",
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "circles-svg",
            children: [
                (0, $bHJbJ.jsx)("title", {
                    children: "circles-loading"
                }),
                (0, $bHJbJ.jsx)("desc", {
                    children: "Animated representation of circles"
                }),
                (0, $bHJbJ.jsx)("path", {
                    d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z",
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "-360 67 67",
                        dur: "2.5s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("path", {
                    d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z",
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "360 67 67",
                        dur: "8s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $753bfae0ab95f468$export$17c11650828d97e = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, barColor: barColor, ariaLabel: ariaLabel = "circles-with-bar-loading" })=>{
    return (0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        "data-testid": "circles-with-bar-wrapper",
        children: (0, $bHJbJ.jsxs)("svg", {
            version: "1.1",
            id: "L1",
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            height: `${height}`,
            width: `${width}`,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "circles-with-bar-svg",
            children: [
                (0, $bHJbJ.jsx)("title", {
                    children: "circles-with-bar-loading"
                }),
                (0, $bHJbJ.jsx)("desc", {
                    children: "Animated representation of circles with bar"
                }),
                (0, $bHJbJ.jsx)("circle", {
                    fill: "none",
                    stroke: `${outerCircleColor || color}`,
                    strokeWidth: "6",
                    strokeMiterlimit: "15",
                    strokeDasharray: "14.2472,14.2472",
                    cx: "50",
                    cy: "50",
                    r: "47",
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("circle", {
                    fill: "none",
                    stroke: `${innerCircleColor || color}`,
                    strokeWidth: "1",
                    strokeMiterlimit: "10",
                    strokeDasharray: "10,10",
                    cx: "50",
                    cy: "50",
                    r: "39",
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsxs)("g", {
                    fill: `${barColor || color}`,
                    "data-testid": "circles-with-bar-svg-bar",
                    children: [
                        (0, $bHJbJ.jsx)("rect", {
                            x: "30",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $bHJbJ.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        (0, $bHJbJ.jsx)("rect", {
                            x: "40",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $bHJbJ.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        (0, $bHJbJ.jsx)("rect", {
                            x: "50",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $bHJbJ.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        }),
                        (0, $bHJbJ.jsx)("rect", {
                            x: "60",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $bHJbJ.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.4"
                            })
                        }),
                        (0, $bHJbJ.jsx)("rect", {
                            x: "70",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $bHJbJ.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.5"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $753bfae0ab95f468$export$ef2184bd89960b14 = ({ height: height = 80, width: width = 80, radius: radius = 12.5, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "grid-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "grid-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 105 105",
            fill: color,
            "data-testid": "grid-svg",
            children: [
                (0, $bHJbJ.jsx)("circle", {
                    cx: "12.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("circle", {
                    cx: "12.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "100ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("circle", {
                    cx: "52.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "300ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("circle", {
                    cx: "52.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "600ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("circle", {
                    cx: "92.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "800ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("circle", {
                    cx: "92.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "400ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("circle", {
                    cx: "12.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "700ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("circle", {
                    cx: "52.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "500ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("circle", {
                    cx: "92.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "200ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $753bfae0ab95f468$export$2da2f0c7403af3ce = ({ height: height = 80, width: width = 80, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "hearts-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "hearts-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 140 64",
            xmlns: "http://www.w3.org/2000/svg",
            fill: color,
            "data-testid": "hearts-svg",
            children: [
                (0, $bHJbJ.jsx)("path", {
                    d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("path", {
                    d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0.7s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("path", {
                    d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
                })
            ]
        })
    });
const $753bfae0ab95f468$var$$ad60b992c945fdb5$var$len = 242.776657104492;
const $753bfae0ab95f468$var$$ad60b992c945fdb5$var$time = 1.6;
const $753bfae0ab95f468$var$$ad60b992c945fdb5$var$anim = (0, $2351587dc5656e18$export$d25ddfdf17c3ad3e)`
12.5% {
  stroke-dasharray: ${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$len * 0.14}px, ${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$len * 0.11}px;
}
43.75% {
  stroke-dasharray: ${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$len * 0.35}px, ${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$len * 0.35}px;
}
100% {
  stroke-dasharray: ${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$len * 0.99}px;
}
`;
const $753bfae0ab95f468$var$$ad60b992c945fdb5$var$Path = (0, $2351587dc5656e18$export$2e2bcd8739ae039).path`
  stroke-dasharray: ${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$len};
  stroke-dashoffset: 0;
  animation: ${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$anim} ${$753bfae0ab95f468$var$$ad60b992c945fdb5$var$time}s linear infinite;
`;
const $753bfae0ab95f468$export$8009d4483dfda42 = ({ color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "200" })=>{
    return (0, $bHJbJ.jsxs)("svg", {
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: `${width}`,
        height: `${Number(width) * 0.5}`,
        viewBox: `0 0 ${width} ${Number(100)}`,
        "data-testid": "infinity-spin",
        children: [
            (0, $bHJbJ.jsx)($753bfae0ab95f468$var$$ad60b992c945fdb5$var$Path, {
                "data-testid": "infinity-spin-path-1",
                stroke: color,
                fill: "none",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            }),
            (0, $bHJbJ.jsx)("path", {
                "data-testid": "infinity-spin-path-2",
                opacity: "0.07",
                fill: "none",
                stroke: color,
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            })
        ]
    });
};
const $753bfae0ab95f468$export$d2101d81f63866ab = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "line-wave-loading", firstLineColor: firstLineColor, middleLineColor: middleLineColor, lastLineColor: lastLineColor })=>{
    return (0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "line-wave-wrapper",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 0 0",
            xmlSpace: "preserve",
            "data-testid": "line-wave-svg",
            children: [
                (0, $bHJbJ.jsx)("rect", {
                    x: "20",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: firstLineColor || color,
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("rect", {
                    x: "30",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: middleLineColor || color,
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.2s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("rect", {
                    x: "40",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: lastLineColor || color,
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.4s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $753bfae0ab95f468$export$64ea884904791f4 = ({ height: height = 90, width: width = 80, radius: radius = 12.5, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "mutating-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "mutating-dots-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            id: "goo-loader",
            width: width,
            height: height,
            "data-testid": "mutating-dots-svg",
            children: [
                (0, $bHJbJ.jsxs)("filter", {
                    id: "fancy-goo",
                    children: [
                        (0, $bHJbJ.jsx)("feGaussianBlur", {
                            in: "SourceGraphic",
                            stdDeviation: "6",
                            result: "blur"
                        }),
                        (0, $bHJbJ.jsx)("feColorMatrix", {
                            in: "blur",
                            mode: "matrix",
                            values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
                            result: "goo"
                        }),
                        (0, $bHJbJ.jsx)("feComposite", {
                            in: "SourceGraphic",
                            in2: "goo",
                            operator: "atop"
                        })
                    ]
                }),
                (0, $bHJbJ.jsxs)("g", {
                    filter: "url(#fancy-goo)",
                    children: [
                        (0, $bHJbJ.jsx)("animateTransform", {
                            id: "mainAnim",
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            from: "0 50 50",
                            to: "359 50 50",
                            dur: "1.2s",
                            repeatCount: "indefinite"
                        }),
                        (0, $bHJbJ.jsx)("circle", {
                            cx: "50%",
                            cy: "40",
                            r: radius,
                            fill: color,
                            children: (0, $bHJbJ.jsx)("animate", {
                                id: "cAnim1",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0;cAnim1.end+0.2s",
                                calcMode: "spline",
                                values: "40;20;40",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        }),
                        (0, $bHJbJ.jsx)("circle", {
                            cx: "50%",
                            cy: "60",
                            r: radius,
                            fill: secondaryColor,
                            children: (0, $bHJbJ.jsx)("animate", {
                                id: "cAnim2",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0.4s;cAnim2.end+0.2s",
                                calcMode: "spline",
                                values: "60;80;60",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        })
                    ]
                })
            ]
        })
    });
/**
 * The radius of the circle
 * The Loader size is set with the width and height of the SVG
 * @type {number}
 */ const $753bfae0ab95f468$var$$a5fa864d4dd36deb$var$RADIUS = 20;
/**
 * Compute Path depending on circle radius
 * The structure with radius 20 is "M20 0c0-9.94-8.06-20-20-20"
 * @param radius of the circle radius default 20
 * @returns {string}
 */ const $753bfae0ab95f468$var$$a5fa864d4dd36deb$var$getPath = (radius)=>{
    return [
        "M" + radius + " 0c0-9.94-8.06",
        radius,
        radius,
        radius
    ].join("-");
};
/**
 * Compute the size of the view box depending on the radius and Stroke-Width
 * @param strokeWidth Stroke-Width of the full circle
 * @param secondaryStrokeWidth Stroke-Width of the 1/4 circle
 * @param radius radius of the circle
 * @returns {string}
 */ const $753bfae0ab95f468$var$$a5fa864d4dd36deb$var$getViewBoxSize = (strokeWidth, secondaryStrokeWidth, radius)=>{
    const maxStrokeWidth = Math.max(strokeWidth, secondaryStrokeWidth);
    const startingPoint = -radius - maxStrokeWidth / 2 + 1;
    const endpoint = radius * 2 + maxStrokeWidth;
    return [
        startingPoint,
        startingPoint,
        endpoint,
        endpoint
    ].join(" ");
};
const $753bfae0ab95f468$export$67ad50c48ca3ede4 = ({ height: height = 80, width: width = 80, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "oval-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true, strokeWidth: strokeWidth = 2, strokeWidthSecondary: strokeWidthSecondary })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "oval-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsx)("svg", {
            width: width,
            height: height,
            viewBox: $753bfae0ab95f468$var$$a5fa864d4dd36deb$var$getViewBoxSize(Number(strokeWidth), Number(strokeWidthSecondary || strokeWidth), $753bfae0ab95f468$var$$a5fa864d4dd36deb$var$RADIUS),
            xmlns: "http://www.w3.org/2000/svg",
            stroke: color,
            "data-testid": "oval-svg",
            children: (0, $bHJbJ.jsx)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: (0, $bHJbJ.jsxs)("g", {
                    transform: "translate(1 1)",
                    strokeWidth: Number(strokeWidthSecondary || strokeWidth),
                    "data-testid": "oval-secondary-group",
                    children: [
                        (0, $bHJbJ.jsx)("circle", {
                            strokeOpacity: ".5",
                            cx: "0",
                            cy: "0",
                            r: $753bfae0ab95f468$var$$a5fa864d4dd36deb$var$RADIUS,
                            stroke: secondaryColor,
                            strokeWidth: strokeWidth
                        }),
                        (0, $bHJbJ.jsx)("path", {
                            d: $753bfae0ab95f468$var$$a5fa864d4dd36deb$var$getPath($753bfae0ab95f468$var$$a5fa864d4dd36deb$var$RADIUS),
                            children: (0, $bHJbJ.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                from: "0 0 0",
                                to: "360 0 0",
                                dur: "1s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
const $753bfae0ab95f468$export$83d2259ec538613b = ({ height: height = 80, width: width = 80, radius: radius = 1, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "puff-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "puff-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 44 44",
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "puff-svg",
            children: (0, $bHJbJ.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                strokeWidth: "2",
                children: [
                    (0, $bHJbJ.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "r",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $bHJbJ.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "r",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        })
    });
const $753bfae0ab95f468$export$8e22e563e5362f75 = ({ radius: radius = 45, strokeWidth: strokeWidth = 5, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor, ariaLabel: ariaLabel = "revolving-dot-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "revolving-dot-loading",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            version: "1.1",
            width: `calc(${radius} * 2.5)`,
            height: `calc(${radius} * 2.5)`,
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            "data-testid": "revolving-dot-svg",
            children: [
                (0, $bHJbJ.jsx)("circle", {
                    fill: "none",
                    stroke: secondaryColor || color,
                    strokeWidth: strokeWidth,
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} * 1.28)`,
                    r: radius,
                    style: {
                        opacity: 0.5
                    }
                }),
                (0, $bHJbJ.jsx)("circle", {
                    fill: color,
                    stroke: color,
                    strokeWidth: "3",
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} / 3.5)`,
                    r: `calc(${radius} / 5)`,
                    style: {
                        transformOrigin: "50% 50%"
                    },
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0",
                        to: "360",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $753bfae0ab95f468$export$fdd9e2f491a77de7 = ({ height: height = 80, width: width = 80, radius: radius = 6, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "rings-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rings-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 45 45",
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "rings-svg",
            children: (0, $bHJbJ.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(1 1)",
                strokeWidth: "2",
                children: [
                    (0, $bHJbJ.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "r",
                                begin: "1.5s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "stroke-opacity",
                                begin: "1.5s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "stroke-width",
                                begin: "1.5s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $bHJbJ.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "r",
                                begin: "3s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "3s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "strokeWidth",
                                begin: "3s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $bHJbJ.jsx)("circle", {
                        cx: "22",
                        cy: "22",
                        r: Number(radius) + 2,
                        children: (0, $bHJbJ.jsx)("animate", {
                            attributeName: "r",
                            begin: "0s",
                            dur: "1.5s",
                            values: "6;1;2;3;4;5;6",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        })
    });
const $753bfae0ab95f468$export$bb511942ded86554 = ({ wrapperClass: wrapperClass = "", color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, height: height = 100, width: width = 100, strokeWidth: strokeWidth = 4, ariaLabel: ariaLabel = "rotating-square-loading", wrapperStyle: wrapperStyle = {}, visible: visible = true })=>{
    return (0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rotating-square-wrapper",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            version: "1.1",
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            height: `${height}`,
            width: `${width}`,
            "data-testid": "rotating-square-svg",
            xmlSpace: "preserve",
            children: [
                (0, $bHJbJ.jsx)("rect", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: strokeWidth,
                    x: "25",
                    y: "25",
                    width: "50",
                    height: "50",
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "0.5s",
                        from: "0 50 50",
                        to: "180 50 50",
                        type: "rotate",
                        id: "strokeBox",
                        attributeType: "XML",
                        begin: "rectBox.end"
                    })
                }),
                (0, $bHJbJ.jsx)("rect", {
                    x: "27",
                    y: "27",
                    fill: color,
                    width: "46",
                    height: "50",
                    children: (0, $bHJbJ.jsx)("animate", {
                        attributeName: "height",
                        dur: "1.3s",
                        attributeType: "XML",
                        from: "50",
                        to: "0",
                        id: "rectBox",
                        fill: "freeze",
                        begin: "0s;strokeBox.end"
                    })
                })
            ]
        })
    });
};
const $753bfae0ab95f468$var$$5819da83a926266a$var$POINTS = [
    0,
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330
];
const $753bfae0ab95f468$var$$5819da83a926266a$var$spin = (0, $2351587dc5656e18$export$d25ddfdf17c3ad3e)`
to {
   transform: rotate(360deg);
 }
`;
const $753bfae0ab95f468$var$$5819da83a926266a$var$Svg = (0, $2351587dc5656e18$export$2e2bcd8739ae039).svg`
  animation: ${$753bfae0ab95f468$var$$5819da83a926266a$var$spin} 0.75s steps(12, end) infinite;
  animation-duration: 0.75s;
`;
const $753bfae0ab95f468$var$$5819da83a926266a$var$Polyline = (0, $2351587dc5656e18$export$2e2bcd8739ae039).polyline`
  stroke-width: ${(props)=>props.width}px;
  stroke-linecap: round;

  &:nth-child(12n + 0) {
    stroke-opacity: 0.08;
  }

  &:nth-child(12n + 1) {
    stroke-opacity: 0.17;
  }

  &:nth-child(12n + 2) {
    stroke-opacity: 0.25;
  }

  &:nth-child(12n + 3) {
    stroke-opacity: 0.33;
  }

  &:nth-child(12n + 4) {
    stroke-opacity: 0.42;
  }

  &:nth-child(12n + 5) {
    stroke-opacity: 0.5;
  }

  &:nth-child(12n + 6) {
    stroke-opacity: 0.58;
  }

  &:nth-child(12n + 7) {
    stroke-opacity: 0.66;
  }

  &:nth-child(12n + 8) {
    stroke-opacity: 0.75;
  }

  &:nth-child(12n + 9) {
    stroke-opacity: 0.83;
  }

  &:nth-child(12n + 11) {
    stroke-opacity: 0.92;
  }
`;
const $753bfae0ab95f468$export$d20df8773b6b77b5 = ({ strokeColor: strokeColor = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, strokeWidth: strokeWidth = "5", animationDuration: animationDuration = "0.75", width: width = "96", visible: visible = true, ariaLabel: ariaLabel = "rotating-lines-loading" })=>{
    const lines = (0, $i5lfL.useCallback)(()=>$753bfae0ab95f468$var$$5819da83a926266a$var$POINTS.map((point)=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$5819da83a926266a$var$Polyline, {
                points: "24,12 24,4",
                width: strokeWidth,
                transform: `rotate(${point}, 24, 24)`
            }, point)), [
        strokeWidth
    ]);
    return !visible ? null : (0, $bHJbJ.jsx)($753bfae0ab95f468$var$$5819da83a926266a$var$Svg, {
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 48 48",
        width: width,
        stroke: strokeColor,
        speed: animationDuration,
        "data-testid": "rotating-lines-svg",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: lines()
    });
};
const $753bfae0ab95f468$export$f8e5ae7506d65b32 = ({ height: height = 80, width: width = 80, strokeWidth: strokeWidth = 2, radius: radius = 1, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "tail-spin-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    const strokeWidthNum = parseInt(String(strokeWidth));
    const viewBoxValue = strokeWidthNum + 36;
    const halfStrokeWidth = strokeWidthNum / 2;
    const processedRadius = halfStrokeWidth + parseInt(String(radius)) - 1;
    return (0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "tail-spin-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: `0 0 ${viewBoxValue} ${viewBoxValue}`,
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "tail-spin-svg",
            children: [
                (0, $bHJbJ.jsx)("defs", {
                    children: (0, $bHJbJ.jsxs)("linearGradient", {
                        x1: "8.042%",
                        y1: "0%",
                        x2: "65.682%",
                        y2: "23.865%",
                        id: "a",
                        children: [
                            (0, $bHJbJ.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: "0",
                                offset: "0%"
                            }),
                            (0, $bHJbJ.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: ".631",
                                offset: "63.146%"
                            }),
                            (0, $bHJbJ.jsx)("stop", {
                                stopColor: color,
                                offset: "100%"
                            })
                        ]
                    })
                }),
                (0, $bHJbJ.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $bHJbJ.jsxs)("g", {
                        transform: `translate(${halfStrokeWidth} ${halfStrokeWidth})`,
                        children: [
                            (0, $bHJbJ.jsx)("path", {
                                d: "M36 18c0-9.94-8.06-18-18-18",
                                id: "Oval-2",
                                stroke: color,
                                strokeWidth: strokeWidth,
                                children: (0, $bHJbJ.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            }),
                            (0, $bHJbJ.jsx)("circle", {
                                fill: "#fff",
                                cx: "36",
                                cy: "18",
                                r: processedRadius,
                                children: (0, $bHJbJ.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $753bfae0ab95f468$export$e21573137ccb7f5d = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-circles-loading", outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, middleCircleColor: middleCircleColor })=>{
    return (0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-circles-wrapper",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "three-circles-svg",
            children: [
                (0, $bHJbJ.jsx)("path", {
                    fill: outerCircleColor || color,
                    d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z",
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("path", {
                    fill: middleCircleColor || color,
                    d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7 c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z",
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "1s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("path", {
                    fill: innerCircleColor || color,
                    d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5 L82,35.7z",
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $753bfae0ab95f468$export$4bf83b24a11cff0b = ({ height: height = 80, width: width = 80, radius: radius = 9, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-dots-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 120 30",
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "three-dots-svg",
            children: [
                (0, $bHJbJ.jsxs)("circle", {
                    cx: "15",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $bHJbJ.jsxs)("circle", {
                    cx: "60",
                    cy: "15",
                    r: radius,
                    attributeName: "fill-opacity",
                    from: "1",
                    to: "0.3",
                    children: [
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "r",
                            from: "9",
                            to: "9",
                            begin: "0s",
                            dur: "0.8s",
                            values: "9;15;9",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "0.5",
                            to: "0.5",
                            begin: "0s",
                            dur: "0.8s",
                            values: ".5;1;.5",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $bHJbJ.jsxs)("circle", {
                    cx: "105",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $bHJbJ.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $753bfae0ab95f468$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES = "-3 -4 39 39";
const $753bfae0ab95f468$var$$afa12dd3e98f740f$var$POLYGON_POINTS = "16,0 32,32 0,32";
/** Styles */ const $753bfae0ab95f468$var$$afa12dd3e98f740f$var$dash = (0, $2351587dc5656e18$export$d25ddfdf17c3ad3e)`
to {
   stroke-dashoffset: 136;
 }
`;
const $753bfae0ab95f468$var$$afa12dd3e98f740f$var$Polygon = (0, $2351587dc5656e18$export$2e2bcd8739ae039).polygon`
  stroke-dasharray: 17;
  animation: ${$753bfae0ab95f468$var$$afa12dd3e98f740f$var$dash} 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;
`;
const $753bfae0ab95f468$var$$afa12dd3e98f740f$var$SVG = (0, $2351587dc5656e18$export$2e2bcd8739ae039).svg`
  transform-origin: 50% 65%;
`;
const $753bfae0ab95f468$export$5a465592bfe74b48 = ({ height: height = 80, width: width = 80, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "triangle-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    return (0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: `${wrapperClass}`,
        "data-testid": "triangle-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsx)($753bfae0ab95f468$var$$afa12dd3e98f740f$var$SVG, {
            id: "triangle",
            width: width,
            height: height,
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: $753bfae0ab95f468$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES,
            "data-testid": "triangle-svg",
            children: (0, $bHJbJ.jsx)($753bfae0ab95f468$var$$afa12dd3e98f740f$var$Polygon, {
                fill: "transparent",
                stroke: color,
                strokeWidth: "1",
                points: $753bfae0ab95f468$var$$afa12dd3e98f740f$var$POLYGON_POINTS
            })
        })
    });
};
const $753bfae0ab95f468$export$4c68f1a79f88778c = ({ height: height = 80, width: width = 80, radius: radius = 48, color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "watch-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $bHJbJ.jsx)($753bfae0ab95f468$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "watch-loading",
        "aria-label": ariaLabel,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("svg", {
            width: width,
            height: height,
            version: "1.1",
            id: "L2",
            xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "watch-svg",
            children: [
                (0, $bHJbJ.jsx)("circle", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    cx: "50",
                    cy: "50",
                    r: radius
                }),
                (0, $bHJbJ.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "85",
                    y2: "50.5",
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $bHJbJ.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "49.5",
                    y2: "74",
                    children: (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "15s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $753bfae0ab95f468$export$1ed1943372cc63a9 = ({ color: color = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "100", visible: visible = true })=>{
    return visible ? (0, $bHJbJ.jsxs)("svg", {
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: width,
        viewBox: "0 0 100 100",
        "data-testid": "falling-lines",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $bHJbJ.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-1",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-2",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $bHJbJ.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    }) : null;
};
const $753bfae0ab95f468$export$d25f4198d7ad6c78 = ({ visible: visible = true, height: height = "80", width: width = "80", ariaLabel: ariaLabel = "vortex-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461",
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $bHJbJ.jsx)("svg", {
        height: height,
        width: width,
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "data-testid": "vortex-svg",
        "aria-label": ariaLabel,
        style: wrapperStyle,
        className: wrapperClass,
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $bHJbJ.jsx)("g", {
                transform: "scale(0.7)",
                children: (0, $bHJbJ.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $bHJbJ.jsxs)("g", {
                        transform: "rotate(137.831 50 50)",
                        children: [
                            (0, $bHJbJ.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                repeatCount: "indefinite",
                                values: "360 50 50;0 50 50",
                                keyTimes: "0;1",
                                dur: "1",
                                keySplines: "0.5 0.5 0.5 0.5",
                                calcMode: "spline"
                            }),
                            (0, $bHJbJ.jsx)("path", {
                                fill: colors[0],
                                d: "M30.4,9.7c-7.4,10.9-11.8,23.8-12.3,37.9c0.2,1,0.5,1.9,0.7,2.8c1.4-5.2,3.4-10.3,6.2-15.1 c2.6-4.4,5.6-8.4,9-12c0.7-0.7,1.4-1.4,2.1-2.1c7.4-7,16.4-12,26-14.6C51.5,3.6,40.2,4.9,30.4,9.7z"
                            }),
                            (0, $bHJbJ.jsx)("path", {
                                fill: colors[1],
                                d: "M24.8,64.2c-2.6-4.4-4.5-9.1-5.9-13.8c-0.3-0.9-0.5-1.9-0.7-2.8c-2.4-9.9-2.2-20.2,0.4-29.8 C10.6,25.5,6,36,5.3,46.8C11,58.6,20,68.9,31.9,76.3c0.9,0.3,1.9,0.5,2.8,0.8C31,73.3,27.6,69,24.8,64.2z"
                            }),
                            (0, $bHJbJ.jsx)("path", {
                                fill: colors[2],
                                d: "M49.6,78.9c-5.1,0-10.1-0.6-14.9-1.8c-1-0.2-1.9-0.5-2.8-0.8c-9.8-2.9-18.5-8.2-25.6-15.2 c2.8,10.8,9.5,20,18.5,26c13.1,0.9,26.6-1.7,38.9-8.3c0.7-0.7,1.4-1.4,2.1-2.1C60.7,78.2,55.3,78.9,49.6,78.9z"
                            }),
                            (0, $bHJbJ.jsx)("path", {
                                fill: colors[3],
                                d: "M81.1,49.6c-1.4,5.2-3.4,10.3-6.2,15.1c-2.6,4.4-5.6,8.4-9,12c-0.7,0.7-1.4,1.4-2.1,2.1 c-7.4,7-16.4,12-26,14.6c10.7,3,22.1,1.7,31.8-3.1c7.4-10.9,11.8-23.8,12.3-37.9C81.6,51.5,81.4,50.6,81.1,49.6z"
                            }),
                            (0, $bHJbJ.jsx)("path", {
                                fill: colors[4],
                                d: "M75.2,12.9c-13.1-0.9-26.6,1.7-38.9,8.3c-0.7,0.7-1.4,1.4-2.1,2.1c5.2-1.4,10.6-2.2,16.2-2.2 c5.1,0,10.1,0.6,14.9,1.8c1,0.2,1.9,0.5,2.8,0.8c9.8,2.9,18.5,8.2,25.6,15.2C90.9,28.1,84.2,18.9,75.2,12.9z"
                            }),
                            (0, $bHJbJ.jsx)("path", {
                                fill: colors[5],
                                d: "M94.7,53.2C89,41.4,80,31.1,68.1,23.7c-0.9-0.3-1.9-0.5-2.8-0.8c3.8,3.8,7.2,8.1,10,13 c2.6,4.4,4.5,9.1,5.9,13.8c0.3,0.9,0.5,1.9,0.7,2.8c2.4,9.9,2.2,20.2-0.4,29.8C89.4,74.5,94,64,94.7,53.2z"
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $753bfae0ab95f468$export$f64f16a115ce395d = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "rotating-triangle-loading", colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $bHJbJ.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "rotating-triangle-svg",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsx)("g", {
            transform: "translate(50,42)",
            children: (0, $bHJbJ.jsx)("g", {
                transform: "scale(0.8)",
                children: (0, $bHJbJ.jsxs)("g", {
                    transform: "translate(-50,-50)",
                    children: [
                        (0, $bHJbJ.jsx)("polygon", {
                            points: "72.5,50 50,11 27.5,50 50,50",
                            fill: colors[0],
                            transform: "rotate(186 50 38.5)",
                            children: (0, $bHJbJ.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 50 38.5;360 50 38.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $bHJbJ.jsx)("polygon", {
                            points: "5,89 50,89 27.5,50",
                            fill: colors[1],
                            transform: "rotate(186 27.5 77.5)",
                            children: (0, $bHJbJ.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 27.5 77.5;360 27.5 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $bHJbJ.jsx)("polygon", {
                            points: "72.5,50 50,89 95,89",
                            fill: colors[2],
                            transform: "rotate(186 72.2417 77.5)",
                            children: (0, $bHJbJ.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 72.5 77.5;360 72 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $753bfae0ab95f468$export$d7b12c4107be0d61 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "radio-loading", colors: colors = [
    $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c
] })=>{
    return !visible ? null : (0, $bHJbJ.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "radio-bar-svg",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $bHJbJ.jsx)("circle", {
                cx: "28",
                cy: "75",
                r: "11",
                fill: colors[0],
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "fill-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $bHJbJ.jsx)("path", {
                d: "M28 47A28 28 0 0 1 56 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[1],
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.1s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $bHJbJ.jsx)("path", {
                d: "M28 25A50 50 0 0 1 78 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[2],
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.2s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $753bfae0ab95f468$export$c17561cb55d4db30 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "progress-bar-loading", borderColor: borderColor = "#F4442E", barColor: barColor = "#51E5FF" })=>{
    return !visible ? null : (0, $bHJbJ.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "progress-bar-svg",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $bHJbJ.jsx)("defs", {
                children: (0, $bHJbJ.jsx)("clipPath", {
                    x: "0",
                    y: "0",
                    width: "100",
                    height: "100",
                    id: "lds-progress-cpid-5009611b8a418",
                    children: (0, $bHJbJ.jsxs)("rect", {
                        x: "0",
                        y: "0",
                        width: "66.6667",
                        height: "100",
                        children: [
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "width",
                                calcMode: "linear",
                                values: "0;100;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "x",
                                calcMode: "linear",
                                values: "0;0;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                })
            }),
            (0, $bHJbJ.jsx)("path", {
                fill: "none",
                strokeWidth: "2.7928",
                d: "M82,63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z",
                stroke: borderColor
            }),
            (0, $bHJbJ.jsx)("path", {
                d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z",
                fill: barColor,
                clipPath: "url(#lds-progress-cpid-5009611b8a418)"
            })
        ]
    });
};
const $753bfae0ab95f468$export$bdf537af43a20db5 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "magnifying-glass-loading", glassColor: glassColor = "#c0efff", color: color = "#e15b64" })=>{
    return !visible ? null : (0, $bHJbJ.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "magnifying-glass-svg",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $bHJbJ.jsx)("g", {
                transform: "scale(0.82)",
                children: (0, $bHJbJ.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $bHJbJ.jsxs)("g", {
                        transform: "translate(16.3636 -20)",
                        children: [
                            (0, $bHJbJ.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "translate",
                                calcMode: "linear",
                                values: "-20 -20;20 -20;0 20;-20 -20",
                                keyTimes: "0;0.33;0.66;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $bHJbJ.jsx)("path", {
                                d: "M44.19,26.158c-4.817,0-9.345,1.876-12.751,5.282c-3.406,3.406-5.282,7.934-5.282,12.751 c0,4.817,1.876,9.345,5.282,12.751c3.406,3.406,7.934,5.282,12.751,5.282s9.345-1.876,12.751-5.282 c3.406-3.406,5.282-7.934,5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536,28.033,49.007,26.158,44.19,26.158z",
                                fill: glassColor
                            }),
                            (0, $bHJbJ.jsx)("path", {
                                d: "M78.712,72.492L67.593,61.373l-3.475-3.475c1.621-2.352,2.779-4.926,3.475-7.596c1.044-4.008,1.044-8.23,0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572,22.362,50.381,20,44.19,20C38,20,31.809,22.362,27.085,27.085 c-9.447,9.447-9.447,24.763,0,34.21C31.809,66.019,38,68.381,44.19,68.381c4.798,0,9.593-1.425,13.708-4.262l9.695,9.695 l4.899,4.899C73.351,79.571,74.476,80,75.602,80s2.251-0.429,3.11-1.288C80.429,76.994,80.429,74.209,78.712,72.492z M56.942,56.942 c-3.406,3.406-7.934,5.282-12.751,5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817,1.876-9.345,5.282-12.751c3.406-3.406,7.934-5.282,12.751-5.282c4.817,0,9.345,1.876,12.751,5.282 c3.406,3.406,5.282,7.934,5.282,12.751C62.223,49.007,60.347,53.536,56.942,56.942z",
                                fill: color
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $753bfae0ab95f468$export$8e3fad5cade57efa = ({ width: width = "80", height: height = "80", backgroundColor: backgroundColor = $753bfae0ab95f468$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ballColors: ballColors = [
    "#fc636b",
    "#6a67ce",
    "#ffb900"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "fidget-spinner-loader", visible: visible = true })=>{
    return !visible ? null : (0, $bHJbJ.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "fidget-spinner-svg",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $bHJbJ.jsxs)("g", {
            transform: "rotate(6 50 50)",
            children: [
                (0, $bHJbJ.jsx)("g", {
                    transform: "translate(50 50)",
                    children: (0, $bHJbJ.jsx)("g", {
                        transform: "scale(0.9)",
                        children: (0, $bHJbJ.jsxs)("g", {
                            transform: "translate(-50 -58)",
                            children: [
                                (0, $bHJbJ.jsx)("path", {
                                    d: "M27.1,79.4c-1.1,0.6-2.4,1-3.7,1c-2.6,0-5.1-1.4-6.4-3.7c-2-3.5-0.8-8,2.7-10.1c1.1-0.6,2.4-1,3.7-1c2.6,0,5.1,1.4,6.4,3.7 C31.8,72.9,30.6,77.4,27.1,79.4z",
                                    fill: ballColors[0]
                                }),
                                (0, $bHJbJ.jsx)("path", {
                                    d: "M72.9,79.4c1.1,0.6,2.4,1,3.7,1c2.6,0,5.1-1.4,6.4-3.7c2-3.5,0.8-8-2.7-10.1c-1.1-0.6-2.4-1-3.7-1c-2.6,0-5.1,1.4-6.4,3.7 C68.2,72.9,69.4,77.4,72.9,79.4z",
                                    fill: ballColors[1]
                                }),
                                (0, $bHJbJ.jsx)("circle", {
                                    cx: "50",
                                    cy: "27",
                                    r: "7.4",
                                    fill: ballColors[2]
                                }),
                                (0, $bHJbJ.jsx)("path", {
                                    d: "M86.5,57.5c-3.1-1.9-6.4-2.8-9.8-2.8c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.1,0c-2.1,0-4.2-0.4-6.2-1.2 c-0.8-3.6-2.8-6.9-5.4-9.3c0.4-2.5,1.3-4.8,2.7-6.9c2-2.9,3.2-6.5,3.2-10.4c0-10.2-8.2-18.4-18.4-18.4c-0.3,0-0.6,0-0.9,0 C39.7,9,32,16.8,31.6,26.2c-0.2,4.1,1,7.9,3.2,11c1.4,2.1,2.3,4.5,2.7,6.9c-2.6,2.5-4.6,5.7-5.4,9.3c-1.9,0.7-4,1.1-6.1,1.1 c-0.4,0-0.8,0-1.2,0c-0.5,0-0.9-0.1-1.4-0.1c-3.1,0-6.3,0.8-9.2,2.5c-9.1,5.2-12,17-6.3,25.9c3.5,5.4,9.5,8.4,15.6,8.4 c2.9,0,5.8-0.7,8.5-2.1c3.6-1.9,6.3-4.9,8-8.3c1.1-2.3,2.7-4.2,4.6-5.8c1.7,0.5,3.5,0.8,5.4,0.8c1.9,0,3.7-0.3,5.4-0.8 c1.9,1.6,3.5,3.5,4.6,5.7c1.5,3.2,4,6,7.4,8c2.9,1.7,6.1,2.5,9.2,2.5c6.6,0,13.1-3.6,16.4-10C97.3,73.1,94.4,62.5,86.5,57.5z M29.6,83.7c-1.9,1.1-4,1.6-6.1,1.6c-4.2,0-8.4-2.2-10.6-6.1c-3.4-5.9-1.4-13.4,4.5-16.8c1.9-1.1,4-1.6,6.1-1.6 c4.2,0,8.4,2.2,10.6,6.1C37.5,72.8,35.4,80.3,29.6,83.7z M50,39.3c-6.8,0-12.3-5.5-12.3-12.3S43.2,14.7,50,14.7 c6.8,0,12.3,5.5,12.3,12.3S56.8,39.3,50,39.3z M87.2,79.2c-2.3,3.9-6.4,6.1-10.6,6.1c-2.1,0-4.2-0.5-6.1-1.6 c-5.9-3.4-7.9-10.9-4.5-16.8c2.3-3.9,6.4-6.1,10.6-6.1c2.1,0,4.2,0.5,6.1,1.6C88.6,65.8,90.6,73.3,87.2,79.2z",
                                    fill: backgroundColor
                                })
                            ]
                        })
                    })
                }),
                (0, $bHJbJ.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            ]
        })
    });
};
const $753bfae0ab95f468$export$bee07fdc425df572 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "dna-loading" })=>{
    return !visible ? null : (0, $bHJbJ.jsxs)("svg", {
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "dna-svg",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $bHJbJ.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "60.6229",
                r: "3.41988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "0s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "39.3771",
                r: "2.58012",
                fill: "#46dff0",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "68.1552",
                r: "3.17988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "31.8448",
                r: "2.82012",
                fill: "#46dff0",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "69.3634",
                r: "2.93988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "30.6366",
                r: "3.06012",
                fill: "#46dff0",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "65.3666",
                r: "2.69988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "34.6334",
                r: "3.30012",
                fill: "#46dff0",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "53.8474",
                r: "2.45988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "46.1526",
                r: "3.54012",
                fill: "#46dff0",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "39.3771",
                r: "2.58012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "60.6229",
                r: "3.41988",
                fill: "#46dff0",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.5s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "31.8448",
                r: "2.82012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "68.1552",
                r: "3.17988",
                fill: "#46dff0",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.7s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "30.6366",
                r: "3.06012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "69.3634",
                r: "2.93988",
                fill: "#46dff0",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.9s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "34.6334",
                r: "3.30012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "65.3666",
                r: "2.69988",
                fill: "#46dff0",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.1s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "46.1526",
                r: "3.54012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            }),
            (0, $bHJbJ.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "53.8474",
                r: "2.45988",
                fill: "#46dff0",
                children: [
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.3s"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $bHJbJ.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            })
        ]
    });
};
const $753bfae0ab95f468$export$f93420b62a5bdffa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "discuss-loading", colors: colors = [
    "#ff727d",
    "#ff727d"
] })=>{
    return !visible ? null : (0, $bHJbJ.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "discuss-svg",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $bHJbJ.jsx)("path", {
                fill: "none",
                d: "M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50",
                strokeWidth: "5",
                stroke: colors[0]
            }),
            (0, $bHJbJ.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                strokeLinecap: "round",
                r: "20",
                strokeWidth: "5",
                stroke: colors[1],
                strokeDasharray: "31.41592653589793 31.41592653589793",
                transform: "rotate(96 50 50)",
                children: (0, $bHJbJ.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $753bfae0ab95f468$export$dc036a5afb9ca26f = ({ visible: visible = true, width: width = "80", height: height = "80", colors: colors = [
    "#e15b64",
    "#f47e60",
    "#f8b26a",
    "#abbd81",
    "#849b87"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "color-ring-loading" })=>{
    return !visible ? null : (0, $bHJbJ.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "color-ring-svg",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $bHJbJ.jsx)("defs", {
                children: (0, $bHJbJ.jsx)("mask", {
                    id: "ldio-4offds5dlws-mask",
                    children: (0, $bHJbJ.jsx)("circle", {
                        cx: "50",
                        cy: "50",
                        r: "26",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeDasharray: "122.52211349000194 40.840704496667314",
                        strokeWidth: "9",
                        transform: "rotate(198.018 50 50)",
                        children: (0, $bHJbJ.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            values: "0 50 50;360 50 50",
                            keyTimes: "0;1",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    })
                })
            }),
            (0, $bHJbJ.jsxs)("g", {
                mask: "url(#ldio-4offds5dlws-mask)",
                children: [
                    (0, $bHJbJ.jsx)("rect", {
                        x: "14.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[0],
                        children: (0, $bHJbJ.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.8s"
                        })
                    }),
                    (0, $bHJbJ.jsx)("rect", {
                        x: "28.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[1],
                        children: (0, $bHJbJ.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.6s"
                        })
                    }),
                    (0, $bHJbJ.jsx)("rect", {
                        x: "42.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[2],
                        children: (0, $bHJbJ.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.4s"
                        })
                    }),
                    (0, $bHJbJ.jsx)("rect", {
                        x: "56.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[3],
                        children: (0, $bHJbJ.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.2s"
                        })
                    }),
                    (0, $bHJbJ.jsx)("rect", {
                        x: "70.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[4],
                        children: (0, $bHJbJ.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "0s"
                        })
                    })
                ]
            })
        ]
    });
};
const $753bfae0ab95f468$export$4d299b491347818a = ({ visible: visible = true, width: width = "80", height: height = "80", backgroundColor: backgroundColor = "#ff6d00", color: color = "#fff", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "comment-loading" })=>{
    return !visible ? null : (0, $bHJbJ.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "comment-svg",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $bHJbJ.jsx)("path", {
                d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
                fill: backgroundColor
            }),
            (0, $bHJbJ.jsx)("circle", {
                cx: "30",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $bHJbJ.jsx)("circle", {
                cx: "50",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.2;0.4;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $bHJbJ.jsx)("circle", {
                cx: "70",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.4;0.6;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $753bfae0ab95f468$export$2ba1b65b747a57aa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "blocks-loading" })=>{
    return !visible ? null : (0, $bHJbJ.jsxs)("svg", {
        width: width,
        height: height,
        className: wrapperClass,
        style: wrapperStyle,
        xmlns: $753bfae0ab95f468$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "aria-label": ariaLabel,
        "data-testid": "blocks-svg",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $bHJbJ.jsx)("title", {
                children: "Blocks"
            }),
            (0, $bHJbJ.jsx)("desc", {
                children: "Animated representation of blocks"
            }),
            (0, $bHJbJ.jsx)("rect", {
                x: "17",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s",
                    calcMode: "discrete"
                })
            }),
            (0, $bHJbJ.jsx)("rect", {
                x: "40",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.125s",
                    calcMode: "discrete"
                })
            }),
            (0, $bHJbJ.jsx)("rect", {
                x: "63",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.25s",
                    calcMode: "discrete"
                })
            }),
            (0, $bHJbJ.jsx)("rect", {
                x: "17",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.875s",
                    calcMode: "discrete"
                })
            }),
            (0, $bHJbJ.jsx)("rect", {
                x: "63",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.375s",
                    calcMode: "discrete"
                })
            }),
            (0, $bHJbJ.jsx)("rect", {
                x: "17",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.75s",
                    calcMode: "discrete"
                })
            }),
            (0, $bHJbJ.jsx)("rect", {
                x: "40",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.625s",
                    calcMode: "discrete"
                })
            }),
            (0, $bHJbJ.jsx)("rect", {
                x: "63",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $bHJbJ.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.5s",
                    calcMode: "discrete"
                })
            })
        ]
    });
};
const $753bfae0ab95f468$export$f3c41beb83007357 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "hourglass-loading", colors: colors = [
    "#306cce",
    "#72a1ed"
] })=>{
    return !visible ? null : (0, $bHJbJ.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 350 350",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "hourglass-svg",
        ...$753bfae0ab95f468$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $bHJbJ.jsx)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                values: "0; 0; -30; 360; 360",
                keyTimes: "0; 0.40; 0.55; 0.65; 1",
                dur: "3s",
                begin: "0s",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $bHJbJ.jsxs)("g", {
                children: [
                    (0, $bHJbJ.jsx)("path", {
                        fill: colors[0],
                        stroke: colors[0],
                        d: "M324.658,20.572v-2.938C324.658,7.935,316.724,0,307.025,0H40.313c-9.699,0-17.635,7.935-17.635,17.634v2.938     c0,9.699,7.935,17.634,17.635,17.634h6.814c3.5,0,3.223,3.267,3.223,4.937c0,19.588,8.031,42.231,14.186,56.698     c12.344,29.012,40.447,52.813,63.516,69.619c4.211,3.068,3.201,5.916,0.756,7.875c-22.375,17.924-51.793,40.832-64.271,70.16     c-6.059,14.239-13.934,36.4-14.18,55.772c-0.025,1.987,0.771,5.862-3.979,5.862h-6.064c-9.699,0-17.635,7.936-17.635,17.634v2.94     c0,9.698,7.935,17.634,17.635,17.634h266.713c9.699,0,17.633-7.936,17.633-17.634v-2.94c0-9.698-7.934-17.634-17.633-17.634     h-3.816c-7,0-6.326-5.241-6.254-7.958c0.488-18.094-4.832-38.673-12.617-54.135c-17.318-34.389-44.629-56.261-61.449-68.915     c-3.65-2.745-4.018-6.143,0-8.906c17.342-11.929,44.131-34.526,61.449-68.916c8.289-16.464,13.785-38.732,12.447-57.621     c-0.105-1.514-0.211-4.472,3.758-4.472h6.482C316.725,38.206,324.658,30.272,324.658,20.572z M270.271,93.216     c-16.113,31.998-41.967,54.881-64.455,68.67c-1.354,0.831-3.936,2.881-3.936,8.602v6.838c0,6.066,2.752,7.397,4.199,8.286     c22.486,13.806,48.143,36.636,64.191,68.508c7.414,14.727,11.266,32.532,10.885,46.702c-0.078,2.947,1.053,8.308-6.613,8.308     H72.627c-6.75,0-6.475-3.37-6.459-5.213c0.117-12.895,4.563-30.757,12.859-50.255c14.404-33.854,44.629-54.988,64.75-67.577     c0.896-0.561,2.629-1.567,2.629-6.922v-10.236c0-5.534-2.656-7.688-4.057-8.57c-20.098-12.688-49.256-33.618-63.322-66.681     c-8.383-19.702-12.834-37.732-12.861-50.657c-0.002-1.694,0.211-4.812,3.961-4.812h206.582c4.168,0,4.127,3.15,4.264,4.829     C282.156,57.681,278.307,77.257,270.271,93.216z"
                    }),
                    (0, $bHJbJ.jsxs)("g", {
                        children: [
                            (0, $bHJbJ.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M169.541,196.2l-68.748,86.03c-2.27,2.842-1.152,5.166,2.484,5.166h140.781c3.637,0,4.756-2.324,2.484-5.166     l-68.746-86.03C175.525,193.358,171.811,193.358,169.541,196.2z"
                            }),
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "opacity",
                                values: "0; 0; 1; 1; 0; 0",
                                keyTimes: "0; 0.1; 0.4; 0.6; 0.61; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $bHJbJ.jsxs)("g", {
                        children: [
                            (0, $bHJbJ.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M168.986,156.219c2.576,2.568,6.789,2.568,9.363,0l34.576-34.489c2.574-2.568,1.707-4.67-1.932-4.67H136.34     c-3.637,0-4.506,2.102-1.932,4.67L168.986,156.219z"
                            }),
                            (0, $bHJbJ.jsx)("animate", {
                                attributeName: "opacity",
                                values: "1; 1; 0; 0; 1; 1",
                                keyTimes: "0; 0.1; 0.4; 0.65; 0.66; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


var $bf0e914ba5baf361$exports = {};
"use strict";
"use client";

var $gpjDn = parcelRequire("gpjDn");
Object.defineProperty($bf0e914ba5baf361$exports, "__esModule", {
    value: true
});
$bf0e914ba5baf361$exports.default = void 0;

var $bf0e914ba5baf361$var$_createSvgIcon = $gpjDn((parcelRequire("bCY9l")));

var $bHJbJ = parcelRequire("bHJbJ");
var $bf0e914ba5baf361$var$_default = $bf0e914ba5baf361$exports.default = (0, $bf0e914ba5baf361$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bHJbJ.jsx)("path", {
    d: "M19 9.3V4h-3v2.6L12 3 2 12h3v8h5v-6h4v6h5v-8h3zm-9 .7c0-1.1.9-2 2-2s2 .9 2 2z"
}), 'House');



/**
 * @module ol/Map
 */ /**
 * @module ol/Collection
 */ /**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $1febc2967664bf62$export$2e2bcd8739ae039 = {
    /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */ ADD: 'add',
    /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */ REMOVE: 'remove'
};


/**
 * @module ol/Object
 */ /**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $2a15c8802c911fe7$export$2e2bcd8739ae039 /**
 * @typedef {'propertychange'} Types
 */  = {
    /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */ PROPERTYCHANGE: 'propertychange'
};


/**
 * @module ol/Observable
 */ /**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039 = {
    /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */ CHANGE: 'change',
    /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */ ERROR: 'error',
    BLUR: 'blur',
    CLEAR: 'clear',
    CONTEXTMENU: 'contextmenu',
    CLICK: 'click',
    DBLCLICK: 'dblclick',
    DRAGENTER: 'dragenter',
    DRAGOVER: 'dragover',
    DROP: 'drop',
    FOCUS: 'focus',
    KEYDOWN: 'keydown',
    KEYPRESS: 'keypress',
    LOAD: 'load',
    RESIZE: 'resize',
    TOUCHMOVE: 'touchmove',
    WHEEL: 'wheel'
};


/**
 * @module ol/events/Target
 */ /**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ class $07a23b3d5e0afc2c$var$Disposable {
    constructor(){
        /**
     * The object has already been disposed.
     * @type {boolean}
     * @protected
     */ this.disposed = false;
    }
    /**
   * Clean up.
   */ dispose() {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    }
    /**
   * Extension point for disposable objects.
   * @protected
   */ disposeInternal() {}
}
var $07a23b3d5e0afc2c$export$2e2bcd8739ae039 = $07a23b3d5e0afc2c$var$Disposable;


/**
 * @module ol/functions
 */ /**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $9d07dd9052c3de0c$export$2e0ae67339d5f1ac(haystack, needle, comparator) {
    let mid, cmp;
    comparator = comparator || $9d07dd9052c3de0c$export$fcb633242ef15540;
    let low = 0;
    let high = haystack.length;
    let found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $9d07dd9052c3de0c$export$fcb633242ef15540(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $9d07dd9052c3de0c$export$4fa3190a997c3d8f(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function $9d07dd9052c3de0c$export$8a3786cc03fdb777(arr, target, direction) {
    if (arr[0] <= target) return 0;
    const n = arr.length;
    if (target <= arr[n - 1]) return n - 1;
    if (typeof direction === 'function') {
        for(let i = 1; i < n; ++i){
            const candidate = arr[i];
            if (candidate === target) return i;
            if (candidate < target) {
                if (direction(target, arr[i - 1], candidate) > 0) return i - 1;
                return i;
            }
        }
        return n - 1;
    }
    if (direction > 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        return n - 1;
    }
    if (direction < 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        return n - 1;
    }
    for(let i = 1; i < n; ++i){
        if (arr[i] == target) return i;
        if (arr[i] < target) {
            if (arr[i - 1] - target < target - arr[i]) return i - 1;
            return i;
        }
    }
    return n - 1;
}
function $9d07dd9052c3de0c$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        const tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $9d07dd9052c3de0c$export$8b58be045bf06082(arr, data) {
    const extension = Array.isArray(data) ? data : [
        data
    ];
    const length = extension.length;
    for(let i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $9d07dd9052c3de0c$export$cd7f480d6b8286c3(arr, obj) {
    const i = arr.indexOf(obj);
    const found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $9d07dd9052c3de0c$export$e9bab7fafb253603(arr1, arr2) {
    const len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(let i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $9d07dd9052c3de0c$export$c7d3d1f96a700512(arr, compareFnc) {
    const length = arr.length;
    const tmp = Array(arr.length);
    let i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $9d07dd9052c3de0c$export$efa610630f9e181(arr, func, strict) {
    const compare = func || $9d07dd9052c3de0c$export$fcb633242ef15540;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        const res = compare(arr[index - 1], currentVal);
        return !(res > 0 || strict && res === 0);
    });
}


function $1a39c7df251dabdd$export$22e23a2304399231() {
    return true;
}
function $1a39c7df251dabdd$export$8f11cee4bdc7e668() {
    return false;
}
function $1a39c7df251dabdd$export$1cd1943b3a73bbe8() {}
function $1a39c7df251dabdd$export$ff83df6f9971435f(fn) {
    /** @type {ReturnType} */ let lastResult;
    /** @type {Array<any>|undefined} */ let lastArgs;
    let lastThis;
    /**
   * @this {*} Only need to know if `this` changed, don't care what type
   * @return {ReturnType} Memoized value
   */ return function() {
        const nextArgs = Array.prototype.slice.call(arguments);
        if (!lastArgs || this !== lastThis || !(0, $9d07dd9052c3de0c$export$e9bab7fafb253603)(nextArgs, lastArgs)) {
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
function $1a39c7df251dabdd$export$4dbaaf6c79705e6c(getter) {
    function promiseGetter() {
        let value;
        try {
            value = getter();
        } catch (err) {
            return Promise.reject(err);
        }
        if (value instanceof Promise) return value;
        return Promise.resolve(value);
    }
    return promiseGetter();
}


/**
 * @module ol/obj
 */ /**
 * Removes all properties from an object.
 * @param {Object<string, unknown>} object The object to clear.
 */ function $0364d4893e3f1129$export$42ffd38884aecdac(object) {
    for(const property in object)delete object[property];
}
function $0364d4893e3f1129$export$dd1bc94b04021eeb(object) {
    let property;
    for(property in object)return false;
    return !property;
}


/**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ class $5ede4ff5599f8860$var$BaseEvent {
    /**
   * @param {string} type Type.
   */ constructor(type){
        /**
     * @type {boolean}
     */ this.propagationStopped;
        /**
     * @type {boolean}
     */ this.defaultPrevented;
        /**
     * The event type.
     * @type {string}
     * @api
     */ this.type = type;
        /**
     * The event target.
     * @type {Object}
     * @api
     */ this.target = null;
    }
    /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */ preventDefault() {
        this.defaultPrevented = true;
    }
    /**
   * Stop event propagation.
   * @api
   */ stopPropagation() {
        this.propagationStopped = true;
    }
}
function $5ede4ff5599f8860$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $5ede4ff5599f8860$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $5ede4ff5599f8860$export$2e2bcd8739ae039 = $5ede4ff5599f8860$var$BaseEvent;


/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ class $dc972e87e0b45224$var$Target extends (0, $07a23b3d5e0afc2c$export$2e2bcd8739ae039) {
    /**
   * @param {*} [target] Default event target for dispatched events.
   */ constructor(target){
        super();
        /**
     * @private
     * @type {*}
     */ this.eventTarget_ = target;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.pendingRemovals_ = null;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.dispatching_ = null;
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").Listener>>|null}
     */ this.listeners_ = null;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ addEventListener(type, listener) {
        if (!type || !listener) return;
        const listeners = this.listeners_ || (this.listeners_ = {});
        const listenersForType = listeners[type] || (listeners[type] = []);
        if (!listenersForType.includes(listener)) listenersForType.push(listener);
    }
    /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */ dispatchEvent(event) {
        const isString = typeof event === 'string';
        const type = isString ? event : event.type;
        const listeners = this.listeners_ && this.listeners_[type];
        if (!listeners) return;
        const evt = isString ? new (0, $5ede4ff5599f8860$export$2e2bcd8739ae039)(event) : /** @type {Event} */ event;
        if (!evt.target) evt.target = this.eventTarget_ || this;
        const dispatching = this.dispatching_ || (this.dispatching_ = {});
        const pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
        if (!(type in dispatching)) {
            dispatching[type] = 0;
            pendingRemovals[type] = 0;
        }
        ++dispatching[type];
        let propagate;
        for(let i = 0, ii = listeners.length; i < ii; ++i){
            if ('handleEvent' in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
            else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
            if (propagate === false || evt.propagationStopped) {
                propagate = false;
                break;
            }
        }
        if (--dispatching[type] === 0) {
            let pr = pendingRemovals[type];
            delete pendingRemovals[type];
            while(pr--)this.removeEventListener(type, (0, $1a39c7df251dabdd$export$1cd1943b3a73bbe8));
            delete dispatching[type];
        }
        return propagate;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.listeners_ && (0, $0364d4893e3f1129$export$42ffd38884aecdac)(this.listeners_);
    }
    /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */ getListeners(type) {
        return this.listeners_ && this.listeners_[type] || undefined;
    }
    /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */ hasListener(type) {
        if (!this.listeners_) return false;
        return type ? type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ removeEventListener(type, listener) {
        if (!this.listeners_) return;
        const listeners = this.listeners_[type];
        if (!listeners) return;
        const index = listeners.indexOf(listener);
        if (index !== -1) {
            if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                // make listener a no-op, and remove later in #dispatchEvent()
                listeners[index] = (0, $1a39c7df251dabdd$export$1cd1943b3a73bbe8);
                ++this.pendingRemovals_[type];
            } else {
                listeners.splice(index, 1);
                if (listeners.length === 0) delete this.listeners_[type];
            }
        }
    }
}
var $dc972e87e0b45224$export$2e2bcd8739ae039 = $dc972e87e0b45224$var$Target;


/**
 * @module ol/events
 */ 
function $7d7dee7854c96264$export$63174c828edd6ff8(target, type, listener, thisArg, once) {
    if (once) {
        const originalListener = listener;
        /**
     * @param {Event|import('./events/Event.js').default} event The event
     * @return {void|boolean} When the function returns `false`, event propagation will stop.
     * @this {typeof target}
     */ listener = function(event) {
            target.removeEventListener(type, listener);
            return originalListener.call(thisArg ?? this, event);
        };
    } else if (thisArg && thisArg !== target) listener = listener.bind(thisArg);
    const eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function $7d7dee7854c96264$export$8d2a95bc11b44725(target, type, listener, thisArg) {
    return $7d7dee7854c96264$export$63174c828edd6ff8(target, type, listener, thisArg, true);
}
function $7d7dee7854c96264$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, $0364d4893e3f1129$export$42ffd38884aecdac)(key);
    }
}


/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */ /***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */ /**
 * @typedef {'change'|'error'} EventTypes
 */ /***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ class $bf9d9249f08e327f$var$Observable extends (0, $dc972e87e0b45224$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.on = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onInternal;
        this.once = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onceInternal;
        this.un = /** @type {ObservableOnSignature<void>} */ this.unInternal;
        /**
     * @private
     * @type {number}
     */ this.revision_ = 0;
    }
    /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */ changed() {
        ++this.revision_;
        this.dispatchEvent((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */ getRevision() {
        return this.revision_;
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onInternal(type, listener) {
        if (Array.isArray(type)) {
            const len = type.length;
            const keys = new Array(len);
            for(let i = 0; i < len; ++i)keys[i] = (0, $7d7dee7854c96264$export$63174c828edd6ff8)(this, type[i], listener);
            return keys;
        }
        return (0, $7d7dee7854c96264$export$63174c828edd6ff8)(this, /** @type {string} */ type, listener);
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onceInternal(type, listener) {
        let key;
        if (Array.isArray(type)) {
            const len = type.length;
            key = new Array(len);
            for(let i = 0; i < len; ++i)key[i] = (0, $7d7dee7854c96264$export$8d2a95bc11b44725)(this, type[i], listener);
        } else key = (0, $7d7dee7854c96264$export$8d2a95bc11b44725)(this, /** @type {string} */ type, listener);
        /** @type {Object} */ listener.ol_key = key;
        return key;
    }
    /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @protected
   */ unInternal(type, listener) {
        const key = /** @type {Object} */ listener.ol_key;
        if (key) $bf9d9249f08e327f$export$b7ef3f8527533384(key);
        else if (Array.isArray(type)) for(let i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
        else this.removeEventListener(type, listener);
    }
}
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $bf9d9249f08e327f$var$Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $bf9d9249f08e327f$var$Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @api
 */ $bf9d9249f08e327f$var$Observable.prototype.un;
function $bf9d9249f08e327f$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(let i = 0, ii = key.length; i < ii; ++i)(0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(key[i]);
    else (0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(/** @type {import("./events.js").EventsKey} */ key);
}
var $bf9d9249f08e327f$export$2e2bcd8739ae039 = $bf9d9249f08e327f$var$Observable;




/**
 * @module ol/util
 */ /**
 * @return {never} Any return.
 */ function $9f65e6f92d33bc27$export$817eb92a8194bab0() {
    throw new Error('Unimplemented abstract method.');
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ let $9f65e6f92d33bc27$var$uidCounter_ = 0;
function $9f65e6f92d33bc27$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$9f65e6f92d33bc27$var$uidCounter_));
}
const $9f65e6f92d33bc27$export$a4ad2735b021c132 = '10.5.0';


class $32070d44509bac34$export$cf395d7c4a2d5a17 extends (0, $5ede4ff5599f8860$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */ constructor(type, key, oldValue){
        super(type);
        /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */ this.key = key;
        /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */ this.oldValue = oldValue;
    }
}
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<import("./ObjectEventType").Types, ObjectEvent, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types, Return>} ObjectOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @api
 */ class $32070d44509bac34$var$BaseObject extends (0, $bf9d9249f08e327f$export$2e2bcd8739ae039) {
    /**
   * @param {Object<string, *>} [values] An object with key-value pairs.
   */ constructor(values){
        super();
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ObjectOnSignature<void>}
     */ this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(this);
        /**
     * @private
     * @type {Object<string, *>|null}
     */ this.values_ = null;
        if (values !== undefined) this.setProperties(values);
    }
    /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */ get(key) {
        let value;
        if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    }
    /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */ getKeys() {
        return this.values_ && Object.keys(this.values_) || [];
    }
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>} Object.
   * @api
   */ getProperties() {
        return this.values_ && Object.assign({}, this.values_) || {};
    }
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.values_;
    }
    /**
   * @return {boolean} The object has properties.
   */ hasProperties() {
        return !!this.values_;
    }
    /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */ notify(key, oldValue) {
        let eventType;
        eventType = `change:${key}`;
        if (this.hasListener(eventType)) this.dispatchEvent(new $32070d44509bac34$export$cf395d7c4a2d5a17(eventType, key, oldValue));
        eventType = (0, $2a15c8802c911fe7$export$2e2bcd8739ae039).PROPERTYCHANGE;
        if (this.hasListener(eventType)) this.dispatchEvent(new $32070d44509bac34$export$cf395d7c4a2d5a17(eventType, key, oldValue));
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ addChangeListener(key, listener) {
        this.addEventListener(`change:${key}`, listener);
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ removeChangeListener(key, listener) {
        this.removeEventListener(`change:${key}`, listener);
    }
    /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ set(key, value, silent) {
        const values = this.values_ || (this.values_ = {});
        if (silent) values[key] = value;
        else {
            const oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    }
    /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Object<string, *>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ setProperties(values, silent) {
        for(const key in values)this.set(key, values[key], silent);
    }
    /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */ applyProperties(source) {
        if (!source.values_) return;
        Object.assign(this.values_ || (this.values_ = {}), source.values_);
    }
    /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */ unset(key, silent) {
        if (this.values_ && key in this.values_) {
            const oldValue = this.values_[key];
            delete this.values_[key];
            if ((0, $0364d4893e3f1129$export$dd1bc94b04021eeb)(this.values_)) this.values_ = null;
            if (!silent) this.notify(key, oldValue);
        }
    }
}
var $32070d44509bac34$export$2e2bcd8739ae039 = $32070d44509bac34$var$BaseObject;



/**
 * @enum {string}
 * @private
 */ const $9ac53bee919957f3$var$Property = {
    LENGTH: 'length'
};
class $9ac53bee919957f3$export$a87ae6eb2761ec6d extends (0, $5ede4ff5599f8860$export$2e2bcd8739ae039) {
    /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {T} element Element.
   * @param {number} index The index of the added or removed element.
   */ constructor(type, element, index){
        super(type);
        /**
     * The element that is added to or removed from the collection.
     * @type {T}
     * @api
     */ this.element = element;
        /**
     * The index of the added or removed element.
     * @type {number}
     * @api
     */ this.index = index;
    }
}
/***
 * @template T
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:length', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'add'|'remove', CollectionEvent<T>, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ class $9ac53bee919957f3$var$Collection extends (0, $32070d44509bac34$export$2e2bcd8739ae039) {
    /**
   * @param {Array<T>} [array] Array.
   * @param {Options} [options] Collection options.
   */ constructor(array, options){
        super();
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {CollectionOnSignature<T, void>}
     */ this.un;
        options = options || {};
        /**
     * @private
     * @type {boolean}
     */ this.unique_ = !!options.unique;
        /**
     * @private
     * @type {!Array<T>}
     */ this.array_ = array ? array : [];
        if (this.unique_) for(let i = 0, ii = this.array_.length; i < ii; ++i)this.assertUnique_(this.array_[i], i);
        this.updateLength_();
    }
    /**
   * Remove all elements from the collection.
   * @api
   */ clear() {
        while(this.getLength() > 0)this.pop();
    }
    /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */ extend(arr) {
        for(let i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    }
    /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */ forEach(f) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    }
    /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */ getArray() {
        return this.array_;
    }
    /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */ item(index) {
        return this.array_[index];
    }
    /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */ getLength() {
        return this.get($9ac53bee919957f3$var$Property.LENGTH);
    }
    /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ insertAt(index, elem) {
        if (index < 0 || index > this.getLength()) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new $9ac53bee919957f3$export$a87ae6eb2761ec6d((0, $1febc2967664bf62$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */ pop() {
        return this.removeAt(this.getLength() - 1);
    }
    /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */ push(elem) {
        if (this.unique_) this.assertUnique_(elem);
        const n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    }
    /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */ remove(elem) {
        const arr = this.array_;
        for(let i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    }
    /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */ removeAt(index) {
        if (index < 0 || index >= this.getLength()) return undefined;
        const prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $9ac53bee919957f3$export$a87ae6eb2761ec6d((0, $1febc2967664bf62$export$2e2bcd8739ae039).REMOVE, prev, index));
        return prev;
    }
    /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ setAt(index, elem) {
        const n = this.getLength();
        if (index >= n) {
            this.insertAt(index, elem);
            return;
        }
        if (index < 0) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem, index);
        const prev = this.array_[index];
        this.array_[index] = elem;
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $9ac53bee919957f3$export$a87ae6eb2761ec6d((0, $1febc2967664bf62$export$2e2bcd8739ae039).REMOVE, prev, index));
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $9ac53bee919957f3$export$a87ae6eb2761ec6d((0, $1febc2967664bf62$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * @private
   */ updateLength_() {
        this.set($9ac53bee919957f3$var$Property.LENGTH, this.array_.length);
    }
    /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */ assertUnique_(elem, except) {
        for(let i = 0, ii = this.array_.length; i < ii; ++i){
            if (this.array_[i] === elem && i !== except) throw new Error('Duplicate item added to a unique collection');
        }
    }
}
var $9ac53bee919957f3$export$2e2bcd8739ae039 = $9ac53bee919957f3$var$Collection;



/**
 * @module ol/MapBrowserEvent
 */ /**
 * @module ol/MapEvent
 */ 
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map event.
 */ class $30ce67d00d8a722e$var$MapEvent extends (0, $5ede4ff5599f8860$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {?import("./Map.js").FrameState} [frameState] Frame state.
   */ constructor(type, map, frameState){
        super(type);
        /**
     * The map where the event occurred.
     * @type {import("./Map.js").default}
     * @api
     */ this.map = map;
        /**
     * The frame state at the time of the event.
     * @type {?import("./Map.js").FrameState}
     * @api
     */ this.frameState = frameState !== undefined ? frameState : null;
    }
}
var $30ce67d00d8a722e$export$2e2bcd8739ae039 = $30ce67d00d8a722e$var$MapEvent;


/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map browser event.
 * @template {PointerEvent|KeyboardEvent|WheelEvent} [EVENT=PointerEvent|KeyboardEvent|WheelEvent]
 */ class $873b1fab144826d1$var$MapBrowserEvent extends (0, $30ce67d00d8a722e$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */ constructor(type, map, originalEvent, dragging, frameState, activePointers){
        super(type, map, frameState);
        /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */ this.originalEvent = originalEvent;
        /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     * @private
     */ this.pixel_ = null;
        /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     * @private
     */ this.coordinate_ = null;
        /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */ this.dragging = dragging !== undefined ? dragging : false;
        /**
     * @type {Array<PointerEvent>|undefined}
     */ this.activePointers = activePointers;
    }
    /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */ get pixel() {
        if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
        return this.pixel_;
    }
    set pixel(pixel) {
        this.pixel_ = pixel;
    }
    /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */ get coordinate() {
        if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
        return this.coordinate_;
    }
    set coordinate(coordinate) {
        this.coordinate_ = coordinate;
    }
    /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   * @override
   */ preventDefault() {
        super.preventDefault();
        if ('preventDefault' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.preventDefault();
    }
    /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   * @override
   */ stopPropagation() {
        super.stopPropagation();
        if ('stopPropagation' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.stopPropagation();
    }
}
var $873b1fab144826d1$export$2e2bcd8739ae039 = $873b1fab144826d1$var$MapBrowserEvent;


/**
 * @module ol/MapBrowserEventHandler
 */ 
/**
 * @module ol/MapBrowserEventType
 */ 
var /**
 * Constants for event names.
 * @enum {string}
 */ $cf09cedd5e4115ce$export$2e2bcd8739ae039 /***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */  = {
    /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */ SINGLECLICK: 'singleclick',
    /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */ CLICK: (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CLICK,
    /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */ DBLCLICK: (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).DBLCLICK,
    /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */ POINTERDRAG: 'pointerdrag',
    /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */ POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};





/**
 * @module ol/has
 */ const $6f9f9040ddfdc3ac$var$ua = typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
const $6f9f9040ddfdc3ac$export$3227bfbdaa9275de = $6f9f9040ddfdc3ac$var$ua.includes('safari') && !$6f9f9040ddfdc3ac$var$ua.includes('chrom');
const $6f9f9040ddfdc3ac$export$b23eed0e325a206a = $6f9f9040ddfdc3ac$export$3227bfbdaa9275de && ($6f9f9040ddfdc3ac$var$ua.includes('version/15.4') || /cpu (os|iphone os) 15_4 like mac os x/.test($6f9f9040ddfdc3ac$var$ua));
const $6f9f9040ddfdc3ac$export$39dfd62a25e0fe93 = $6f9f9040ddfdc3ac$var$ua.includes('webkit') && !$6f9f9040ddfdc3ac$var$ua.includes('edge');
const $6f9f9040ddfdc3ac$export$76c0a3b101d93136 = $6f9f9040ddfdc3ac$var$ua.includes('macintosh');
const $6f9f9040ddfdc3ac$export$6b83a0446fc26f94 = typeof devicePixelRatio !== 'undefined' ? devicePixelRatio : 1;
const $6f9f9040ddfdc3ac$export$98fcef3dc9973292 = typeof WorkerGlobalScope !== 'undefined' && typeof OffscreenCanvas !== 'undefined' && self instanceof WorkerGlobalScope; //eslint-disable-line
const $6f9f9040ddfdc3ac$export$716f8695eedb9bad = typeof Image !== 'undefined' && Image.prototype.decode;
const $6f9f9040ddfdc3ac$export$7478563940788376 = typeof createImageBitmap === 'function';
const $6f9f9040ddfdc3ac$export$f751ce96c6c4e4fc = function() {
    let passive = false;
    try {
        const options = Object.defineProperty({}, 'passive', {
            get: function() {
                passive = true;
            }
        });
        // @ts-ignore Ignore invalid event type '_'
        window.addEventListener('_', null, options);
        // @ts-ignore Ignore invalid event type '_'
        window.removeEventListener('_', null, options);
    } catch  {
    // passive not supported
    }
    return passive;
}();


/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $ebfbe553a923ec9c$export$2e2bcd8739ae039 = {
    POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};


class $01d3ad28990ebd10$var$MapBrowserEventHandler extends (0, $dc972e87e0b45224$export$2e2bcd8739ae039) {
    /**
   * @param {import("./Map.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */ constructor(map, moveTolerance){
        super(map);
        /**
     * This is the element that we will listen to the real events on.
     * @type {import("./Map.js").default}
     * @private
     */ this.map_ = map;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.clickTimeoutId_;
        /**
     * Emulate dblclick and singleclick. Will be true when only one pointer is active.
     * @type {boolean}
     */ this.emulateClicks_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.dragging_ = false;
        /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */ this.dragListenerKeys_ = [];
        /**
     * @type {number}
     * @private
     */ this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {PointerEvent|null}
     * @private
     */ this.down_ = null;
        const element = this.map_.getViewport();
        /**
     * @type {Array<PointerEvent>}
     * @private
     */ this.activePointers_ = [];
        /**
     * @type {!Object<number, Event>}
     * @private
     */ this.trackedTouches_ = {};
        /**
     * @private
     */ this.element_ = element;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.pointerdownListenerKey_ = (0, $7d7dee7854c96264$export$63174c828edd6ff8)(element, (0, $ebfbe553a923ec9c$export$2e2bcd8739ae039).POINTERDOWN, this.handlePointerDown_, this);
        /**
     * @type {PointerEvent}
     * @private
     */ this.originalPointerMoveEvent_;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.relayedListenerKey_ = (0, $7d7dee7854c96264$export$63174c828edd6ff8)(element, (0, $ebfbe553a923ec9c$export$2e2bcd8739ae039).POINTERMOVE, this.relayMoveEvent_, this);
        /**
     * @private
     */ this.boundHandleTouchMove_ = this.handleTouchMove_.bind(this);
        this.element_.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_, (0, $6f9f9040ddfdc3ac$export$f751ce96c6c4e4fc) ? {
            passive: false
        } : false);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ emulateClick_(pointerEvent) {
        let newEvent = new (0, $873b1fab144826d1$export$2e2bcd8739ae039)((0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, $873b1fab144826d1$export$2e2bcd8739ae039)((0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout(()=>{
            this.clickTimeoutId_ = undefined;
            const newEvent = new (0, $873b1fab144826d1$export$2e2bcd8739ae039)((0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }, 250);
    }
    /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ updateActivePointers_(pointerEvent) {
        const event = pointerEvent;
        const id = event.pointerId;
        if (event.type == (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERUP || event.type == (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERCANCEL) {
            delete this.trackedTouches_[id];
            for(const pointerId in this.trackedTouches_)if (this.trackedTouches_[pointerId].target !== event.target) {
                // Some platforms assign a new pointerId when the target changes.
                // If this happens, delete one tracked pointer. If there is more
                // than one tracked pointer for the old target, it will be cleared
                // by subsequent POINTERUP events from other pointers.
                delete this.trackedTouches_[pointerId];
                break;
            }
        } else if (event.type == (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERDOWN || event.type == (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERMOVE) this.trackedTouches_[id] = event;
        this.activePointers_ = Object.values(this.trackedTouches_);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerUp_(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $873b1fab144826d1$export$2e2bcd8739ae039)((0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERUP, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.preventDefault().
        if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_.length === 0) {
            this.dragListenerKeys_.forEach((0, $7d7dee7854c96264$export$b0a21c8b3c1c921));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */ isMouseActionButton_(pointerEvent) {
        return pointerEvent.button === 0;
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerDown_(pointerEvent) {
        this.emulateClicks_ = this.activePointers_.length === 0;
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $873b1fab144826d1$export$2e2bcd8739ae039)((0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERDOWN, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        this.down_ = new PointerEvent(pointerEvent.type, pointerEvent);
        Object.defineProperty(this.down_, 'target', {
            writable: false,
            value: pointerEvent.target
        });
        if (this.dragListenerKeys_.length === 0) {
            const doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push((0, $7d7dee7854c96264$export$63174c828edd6ff8)(doc, (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERMOVE, this.handlePointerMove_, this), (0, $7d7dee7854c96264$export$63174c828edd6ff8)(doc, (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */ (0, $7d7dee7854c96264$export$63174c828edd6ff8)(this.element_, (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, $7d7dee7854c96264$export$63174c828edd6ff8)(this.element_.getRootNode(), (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this));
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerMove_(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.updateActivePointers_(pointerEvent);
            this.dragging_ = true;
            const newEvent = new (0, $873b1fab144826d1$export$2e2bcd8739ae039)((0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERDRAG, this.map_, pointerEvent, this.dragging_, undefined, this.activePointers_);
            this.dispatchEvent(newEvent);
        }
    }
    /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ relayMoveEvent_(pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        const dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, $873b1fab144826d1$export$2e2bcd8739ae039)((0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERMOVE, this.map_, pointerEvent, dragging));
    }
    /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */ handleTouchMove_(event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events,
        // when elm-pep is used as pointer events polyfill.
        const originalEvent = this.originalPointerMoveEvent_;
        if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== 'boolean' || event.cancelable === true)) event.preventDefault();
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */ isMoving_(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.relayedListenerKey_) {
            (0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            (0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, $7d7dee7854c96264$export$b0a21c8b3c1c921));
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        super.disposeInternal();
    }
}
var $01d3ad28990ebd10$export$2e2bcd8739ae039 = $01d3ad28990ebd10$var$MapBrowserEventHandler;




/**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $9806dbcaf2b91f44$export$2e2bcd8739ae039 /***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */  = {
    /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */ MOVESTART: 'movestart',
    /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */ MOVEEND: 'moveend',
    /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */ LOADSTART: 'loadstart',
    /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */ LOADEND: 'loadend'
};


/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $7f2e61d938db36e0$export$2e2bcd8739ae039 = {
    LAYERGROUP: 'layergroup',
    SIZE: 'size',
    TARGET: 'target',
    VIEW: 'view'
};




/**
 * @module ol/TileQueue
 */ /**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $34f0277fe2789b80$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
   * Indicates that tile loading failed
   * @type {number}
   */ ERROR: 3,
    EMPTY: 4
};



/**
 * @module ol/structs/PriorityQueue
 */ /**
 * @module ol/asserts
 */ /**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {string} errorMessage Error message.
 */ function $4b57691230be0bd5$export$a7a9523472993e97(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}



const $0e2e61429cd64dd6$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ class $0e2e61429cd64dd6$var$PriorityQueue {
    /**
   * @param {function(T): number} priorityFunction Priority function.
   * @param {function(T): string} keyFunction Key function.
   */ constructor(priorityFunction, keyFunction){
        /**
     * @type {function(T): number}
     * @private
     */ this.priorityFunction_ = priorityFunction;
        /**
     * @type {function(T): string}
     * @private
     */ this.keyFunction_ = keyFunction;
        /**
     * @type {Array<T>}
     * @private
     */ this.elements_ = [];
        /**
     * @type {Array<number>}
     * @private
     */ this.priorities_ = [];
        /**
     * @type {!Object<string, boolean>}
     * @private
     */ this.queuedElements_ = {};
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        (0, $0364d4893e3f1129$export$42ffd38884aecdac)(this.queuedElements_);
    }
    /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */ dequeue() {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        } else {
            elements[0] = /** @type {T} */ elements.pop();
            priorities[0] = /** @type {number} */ priorities.pop();
            this.siftUp_(0);
        }
        const elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    }
    /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */ enqueue(element) {
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(!(this.keyFunction_(element) in this.queuedElements_), 'Tried to enqueue an `element` that was already added to the queue');
        const priority = this.priorityFunction_(element);
        if (priority != $0e2e61429cd64dd6$export$b4af72c40fd57063) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.elements_.length;
    }
    /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */ getLeftChildIndex_(index) {
        return index * 2 + 1;
    }
    /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */ getRightChildIndex_(index) {
        return index * 2 + 2;
    }
    /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */ getParentIndex_(index) {
        return index - 1 >> 1;
    }
    /**
   * Make this a heap. O(N).
   * @private
   */ heapify_() {
        let i;
        for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.elements_.length === 0;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */ isKeyQueued(key) {
        return key in this.queuedElements_;
    }
    /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */ isQueued(element) {
        return this.isKeyQueued(this.keyFunction_(element));
    }
    /**
   * @param {number} index The index of the node to move down.
   * @private
   */ siftUp_(index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const count = elements.length;
        const element = elements[index];
        const priority = priorities[index];
        const startIndex = index;
        while(index < count >> 1){
            const lIndex = this.getLeftChildIndex_(index);
            const rIndex = this.getRightChildIndex_(index);
            const smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    }
    /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */ siftDown_(startIndex, index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[index];
        const priority = priorities[index];
        while(index > startIndex){
            const parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            } else break;
        }
        elements[index] = element;
        priorities[index] = priority;
    }
    /**
   * FIXME empty description for jsdoc
   */ reprioritize() {
        const priorityFunction = this.priorityFunction_;
        const elements = this.elements_;
        const priorities = this.priorities_;
        let index = 0;
        const n = elements.length;
        let element, i, priority;
        for(i = 0; i < n; ++i){
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == $0e2e61429cd64dd6$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    }
}
var $0e2e61429cd64dd6$export$2e2bcd8739ae039 = $0e2e61429cd64dd6$var$PriorityQueue;


/**
 * @typedef {function(import("./Tile.js").default, string, import('./tilecoord.js').TileCoord, number): number} PriorityFunction
 */ /**
 * @typedef {[import('./Tile.js').default, string, import('./tilecoord.js').TileCoord, number]} TileQueueElement
 */ /**
 * @extends PriorityQueue<TileQueueElement>}
 */ class $b1b92775009e47d7$var$TileQueue extends (0, $0e2e61429cd64dd6$export$2e2bcd8739ae039) {
    /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */ constructor(tilePriorityFunction, tileChangeCallback){
        super((element)=>tilePriorityFunction.apply(null, element), (element)=>element[0].getKey());
        /** @private */ this.boundHandleTileChange_ = this.handleTileChange.bind(this);
        /**
     * @private
     * @type {function(): ?}
     */ this.tileChangeCallback_ = tileChangeCallback;
        /**
     * @private
     * @type {number}
     */ this.tilesLoading_ = 0;
        /**
     * @private
     * @type {!Object<string,boolean>}
     */ this.tilesLoadingKeys_ = {};
    }
    /**
   * @param {TileQueueElement} element Element.
   * @return {boolean} The element was added to the queue.
   * @override
   */ enqueue(element) {
        const added = super.enqueue(element);
        if (added) {
            const tile = element[0];
            tile.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
        }
        return added;
    }
    /**
   * @return {number} Number of tiles loading.
   */ getTilesLoading() {
        return this.tilesLoading_;
    }
    /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("./Tile.js").default} */ event.target;
        const state = tile.getState();
        if (state === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED || state === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR || state === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY) {
            if (state !== (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR) tile.removeEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
            const tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    }
    /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */ loadMoreTiles(maxTotalLoading, maxNewLoads) {
        let newLoads = 0;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            const tile = this.dequeue()[0];
            const tileKey = tile.getKey();
            const state = tile.getState();
            if (state === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    }
}
var $b1b92775009e47d7$export$2e2bcd8739ae039 = $b1b92775009e47d7$var$TileQueue;
function $b1b92775009e47d7$export$f08ad5eceeff5d45(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $0e2e61429cd64dd6$export$b4af72c40fd57063;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $0e2e61429cd64dd6$export$b4af72c40fd57063;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    const center = frameState.viewState.center;
    const deltaX = tileCenter[0] - center[0];
    const deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}


/**
 * @module ol/View
 */ 
/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $73b497f172b1a497$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};


/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $2058179c7d78e530$export$2e2bcd8739ae039 = {
    CENTER: 'center',
    RESOLUTION: 'resolution',
    ROTATION: 'rotation'
};




/**
 * @module ol/centerconstraint
 */ /**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ function $91ceb5420a5c8360$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $91ceb5420a5c8360$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $91ceb5420a5c8360$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $91ceb5420a5c8360$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $91ceb5420a5c8360$export$8240f01c446270e6(mat) {
    const n = mat.length;
    for(let i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        let maxRow = i;
        let maxEl = Math.abs(mat[i][i]);
        for(let r = i + 1; r < n; r++){
            const absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        const tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(let j = i + 1; j < n; j++){
            const coef = -mat[j][i] / mat[i][i];
            for(let k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    const x = new Array(n);
    for(let l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(let m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $91ceb5420a5c8360$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $91ceb5420a5c8360$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $91ceb5420a5c8360$export$ba467bec01d66def(a, b) {
    const r = a % b;
    return r * b < 0 ? r + b : r;
}
function $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}
function $91ceb5420a5c8360$export$a81f732198733497(n, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.round(n * factor) / factor;
}
function $91ceb5420a5c8360$export$2077e0241d6afd3c(n, decimals) {
    return Math.round($91ceb5420a5c8360$export$a81f732198733497(n, decimals));
}
function $91ceb5420a5c8360$export$a3fe094919f356fd(n, decimals) {
    return Math.floor($91ceb5420a5c8360$export$a81f732198733497(n, decimals));
}
function $91ceb5420a5c8360$export$803ce6b71a0a94b2(n, decimals) {
    return Math.ceil($91ceb5420a5c8360$export$a81f732198733497(n, decimals));
}
function $91ceb5420a5c8360$export$4997ffc0176396a6(n, min, max) {
    if (n >= min && n < max) return n;
    const range = max - min;
    return ((n - min) % range + range) % range + min;
}


function $6ceef04f6bff0869$export$c2f0af2c946f6897(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, isMoving, centerShift) {
        if (!center) return undefined;
        if (!resolution && !onlyCenter) return center;
        const viewWidth = onlyCenter ? 0 : size[0] * resolution;
        const viewHeight = onlyCenter ? 0 : size[1] * resolution;
        const shiftX = centerShift ? centerShift[0] : 0;
        const shiftY = centerShift ? centerShift[1] : 0;
        let minX = extent[0] + viewWidth / 2 + shiftX;
        let maxX = extent[2] - viewWidth / 2 + shiftX;
        let minY = extent[1] + viewHeight / 2 + shiftY;
        let maxY = extent[3] - viewHeight / 2 + shiftY;
        // note: when zooming out of bounds, min and max values for x and y may
        // end up inverted (min > max); this has to be accounted for
        if (minX > maxX) {
            minX = (maxX + minX) / 2;
            maxX = minX;
        }
        if (minY > maxY) {
            minY = (maxY + minY) / 2;
            maxY = minY;
        }
        let x = (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(center[0], minX, maxX);
        let y = (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(center[1], minY, maxY);
        // during an interaction, allow some overscroll
        if (isMoving && smooth && resolution) {
            const ratio = 30 * resolution;
            x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
            y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
        }
        return [
            x,
            y
        ];
    });
}
function $6ceef04f6bff0869$export$f883a24d5edde77c(center) {
    return center;
}


/**
 * @module ol/coordinate
 */ /**
 * @module ol/extent
 */ /**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $6fc5fe9336d27a2c$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};


function $110ceb23457e07e7$export$8aceca7c77505534(coordinates) {
    const extent = $110ceb23457e07e7$export$fe201bb3bbe031e9();
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$110ceb23457e07e7$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [dest] Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $110ceb23457e07e7$var$_boundingExtentXYs(xs, ys, dest) {
    const minX = Math.min.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxX = Math.max.apply(null, xs);
    const maxY = Math.max.apply(null, ys);
    return $110ceb23457e07e7$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest);
}
function $110ceb23457e07e7$export$ab1029bcae9ddb4a(extent, value, dest) {
    if (dest) {
        dest[0] = extent[0] - value;
        dest[1] = extent[1] - value;
        dest[2] = extent[2] + value;
        dest[3] = extent[3] + value;
        return dest;
    }
    return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $110ceb23457e07e7$export$9cd59f9826255e47(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent.slice();
}
function $110ceb23457e07e7$export$cbe64c389534206f(extent, x, y) {
    let dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $110ceb23457e07e7$export$ac68c24d37ca240f(extent, coordinate) {
    return $110ceb23457e07e7$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $110ceb23457e07e7$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $110ceb23457e07e7$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $110ceb23457e07e7$export$f97905ead28c61a8(extent, coordinate) {
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const x = coordinate[0];
    const y = coordinate[1];
    let relationship = (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).LEFT;
    else if (x > maxX) relationship = relationship | (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).RIGHT;
    if (y < minY) relationship = relationship | (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).BELOW;
    else if (y > maxY) relationship = relationship | (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).ABOVE;
    if (relationship === (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).UNKNOWN) relationship = (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).INTERSECTING;
    return relationship;
}
function $110ceb23457e07e7$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $110ceb23457e07e7$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest) {
    if (dest) {
        dest[0] = minX;
        dest[1] = minY;
        dest[2] = maxX;
        dest[3] = maxY;
        return dest;
    }
    return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $110ceb23457e07e7$export$3e2152b047719fa1(dest) {
    return $110ceb23457e07e7$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, dest);
}
function $110ceb23457e07e7$export$4838bf78d04a9440(coordinate, dest) {
    const x = coordinate[0];
    const y = coordinate[1];
    return $110ceb23457e07e7$export$958e3e1a02eac4b6(x, y, x, y, dest);
}
function $110ceb23457e07e7$export$29e3ad4dbd0cb863(coordinates, dest) {
    const extent = $110ceb23457e07e7$export$3e2152b047719fa1(dest);
    return $110ceb23457e07e7$export$795cd48be4d5f252(extent, coordinates);
}
function $110ceb23457e07e7$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, dest) {
    const extent = $110ceb23457e07e7$export$3e2152b047719fa1(dest);
    return $110ceb23457e07e7$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $110ceb23457e07e7$export$73b4897e93bc5c83(rings, dest) {
    const extent = $110ceb23457e07e7$export$3e2152b047719fa1(dest);
    return $110ceb23457e07e7$export$9b319549574402d7(extent, rings);
}
function $110ceb23457e07e7$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $110ceb23457e07e7$export$998afeab28643bd6(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function $110ceb23457e07e7$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $110ceb23457e07e7$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $110ceb23457e07e7$export$795cd48be4d5f252(extent, coordinates) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$110ceb23457e07e7$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $110ceb23457e07e7$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$110ceb23457e07e7$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $110ceb23457e07e7$export$9b319549574402d7(extent, rings) {
    for(let i = 0, ii = rings.length; i < ii; ++i)$110ceb23457e07e7$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $110ceb23457e07e7$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $110ceb23457e07e7$export$f9ed8a3d123a08e2(extent, callback) {
    let val;
    val = callback($110ceb23457e07e7$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback($110ceb23457e07e7$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback($110ceb23457e07e7$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback($110ceb23457e07e7$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $110ceb23457e07e7$export$520c40045967cb15(extent) {
    let area = 0;
    if (!$110ceb23457e07e7$export$dd1bc94b04021eeb(extent)) area = $110ceb23457e07e7$export$3c49c185de0c2bfc(extent) * $110ceb23457e07e7$export$c08559766941f856(extent);
    return area;
}
function $110ceb23457e07e7$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $110ceb23457e07e7$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $110ceb23457e07e7$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $110ceb23457e07e7$export$a1cfd206661d0801(extent, corner) {
    let coordinate;
    if (corner === 'bottom-left') coordinate = $110ceb23457e07e7$export$8d09f5e2e1bf560d(extent);
    else if (corner === 'bottom-right') coordinate = $110ceb23457e07e7$export$e77c1cf70445e168(extent);
    else if (corner === 'top-left') coordinate = $110ceb23457e07e7$export$cb1538b07e6964ff(extent);
    else if (corner === 'top-right') coordinate = $110ceb23457e07e7$export$b84fa077c8b05295(extent);
    else throw new Error('Invalid corner');
    return coordinate;
}
function $110ceb23457e07e7$export$7d6fa884b32a3751(extent1, extent2) {
    const minX = Math.min(extent1[0], extent2[0]);
    const minY = Math.min(extent1[1], extent2[1]);
    const maxX = Math.max(extent1[2], extent2[2]);
    const maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $110ceb23457e07e7$export$13ba650faf8308(center, resolution, rotation, size, dest) {
    const [x0, y0, x1, y1, x2, y2, x3, y3] = $110ceb23457e07e7$export$4b7a6fb4002cd6ac(center, resolution, rotation, size);
    return $110ceb23457e07e7$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), dest);
}
function $110ceb23457e07e7$export$4b7a6fb4002cd6ac(center, resolution, rotation, size) {
    const dx = resolution * size[0] / 2;
    const dy = resolution * size[1] / 2;
    const cosRotation = Math.cos(rotation);
    const sinRotation = Math.sin(rotation);
    const xCos = dx * cosRotation;
    const xSin = dx * sinRotation;
    const yCos = dy * cosRotation;
    const ySin = dy * sinRotation;
    const x = center[0];
    const y = center[1];
    return [
        x - xCos + ySin,
        y - xSin - yCos,
        x - xCos - ySin,
        y - xSin + yCos,
        x + xCos - ySin,
        y + xSin + yCos,
        x + xCos + ySin,
        y + xSin - yCos,
        x - xCos + ySin,
        y - xSin - yCos
    ];
}
function $110ceb23457e07e7$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $110ceb23457e07e7$export$f3fe0e9a60cde324(extent1, extent2) {
    const intersection = $110ceb23457e07e7$export$72209efa88586d42(extent1, extent2);
    return $110ceb23457e07e7$export$520c40045967cb15(intersection);
}
function $110ceb23457e07e7$export$72209efa88586d42(extent1, extent2, dest) {
    const intersection = dest ? dest : $110ceb23457e07e7$export$fe201bb3bbe031e9();
    if ($110ceb23457e07e7$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $110ceb23457e07e7$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $110ceb23457e07e7$export$1bc603050bd777b1(extent) {
    return $110ceb23457e07e7$export$3c49c185de0c2bfc(extent) + $110ceb23457e07e7$export$c08559766941f856(extent);
}
function $110ceb23457e07e7$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $110ceb23457e07e7$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $110ceb23457e07e7$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $110ceb23457e07e7$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $110ceb23457e07e7$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $110ceb23457e07e7$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $110ceb23457e07e7$export$6a4fe494c558c238(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent;
}
function $110ceb23457e07e7$export$80cbab86674143b6(extent, value) {
    const deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    const deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $110ceb23457e07e7$export$a6a5a7a461419425(extent, start, end) {
    let intersects = false;
    const startRel = $110ceb23457e07e7$export$f97905ead28c61a8(extent, start);
    const endRel = $110ceb23457e07e7$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).INTERSECTING || endRel === (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).INTERSECTING) intersects = true;
    else {
        const minX = extent[0];
        const minY = extent[1];
        const maxX = extent[2];
        const maxY = extent[3];
        const startX = start[0];
        const startY = start[1];
        const endX = end[0];
        const endY = end[1];
        const slope = (endY - startY) / (endX - startX);
        let x, y;
        if (!!(endRel & (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).ABOVE) && !(startRel & (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).RIGHT) && !(startRel & (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).BELOW) && !(startRel & (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).LEFT) && !(startRel & (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $110ceb23457e07e7$export$9f9dcb98c894b623(extent, transformFn, dest, stops) {
    if ($110ceb23457e07e7$export$dd1bc94b04021eeb(extent)) return $110ceb23457e07e7$export$3e2152b047719fa1(dest);
    let coordinates = [];
    if (stops > 1) {
        const width = extent[2] - extent[0];
        const height = extent[3] - extent[1];
        for(let i = 0; i < stops; ++i)coordinates.push(extent[0] + width * i / stops, extent[1], extent[2], extent[1] + height * i / stops, extent[2] - width * i / stops, extent[3], extent[0], extent[3] - height * i / stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    const xs = [];
    const ys = [];
    for(let i = 0, l = coordinates.length; i < l; i += 2){
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return $110ceb23457e07e7$var$_boundingExtentXYs(xs, ys, dest);
}
function $110ceb23457e07e7$export$39a9ce3624977b84(extent, projection) {
    const projectionExtent = projection.getExtent();
    const center = $110ceb23457e07e7$export$c91255cadecfe081(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        const worldWidth = $110ceb23457e07e7$export$3c49c185de0c2bfc(projectionExtent);
        const worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        const offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
function $110ceb23457e07e7$export$9031237f01de0947(extent, projection, multiWorld) {
    if (projection.canWrapX()) {
        const projectionExtent = projection.getExtent();
        if (!isFinite(extent[0]) || !isFinite(extent[2])) return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        $110ceb23457e07e7$export$39a9ce3624977b84(extent, projection);
        const worldWidth = $110ceb23457e07e7$export$3c49c185de0c2bfc(projectionExtent);
        if ($110ceb23457e07e7$export$3c49c185de0c2bfc(extent) > worldWidth && !multiWorld) // the extent wraps around on itself
        return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        if (extent[0] < projectionExtent[0]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0] + worldWidth,
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2],
                extent[3]
            ]
        ];
        if (extent[2] > projectionExtent[2]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2] - worldWidth,
                extent[3]
            ]
        ];
    }
    return [
        extent
    ];
}



/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */ function $9fd184ea0ccac476$export$24be126cb0a7bbeb(number, width, precision) {
    const numberString = precision !== undefined ? number.toFixed(precision) : '' + number;
    let decimal = numberString.indexOf('.');
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join('0') + numberString;
}
function $9fd184ea0ccac476$export$66e1c0999abad646(v1, v2) {
    const s1 = ('' + v1).split('.');
    const s2 = ('' + v2).split('.');
    for(let i = 0; i < Math.max(s1.length, s2.length); i++){
        const n1 = parseInt(s1[i] || '0', 10);
        const n2 = parseInt(s2[i] || '0', 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}


function $188aedb30bca6ae8$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function $188aedb30bca6ae8$export$cbe80a3fcd2b99b7(coordinate, circle) {
    const r = circle.getRadius();
    const center = circle.getCenter();
    const x0 = center[0];
    const y0 = center[1];
    const x1 = coordinate[0];
    const y1 = coordinate[1];
    let dx = x1 - x0;
    const dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    const d = Math.sqrt(dx * dx + dy * dy);
    const x = x0 + r * dx / d;
    const y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $188aedb30bca6ae8$export$18cdd31d17f97131(coordinate, segment) {
    const x0 = coordinate[0];
    const y0 = coordinate[1];
    const start = segment[0];
    const end = segment[1];
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    let x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $188aedb30bca6ae8$export$35ad6765fe262b6(fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $188aedb30bca6ae8$export$9ff8f16060979e0a(coordinate, fractionDigits);
    });
}
function $188aedb30bca6ae8$export$6eb0ac5f024d8590(hemispheres, degrees, fractionDigits) {
    const normalizedDegrees = (0, $91ceb5420a5c8360$export$ba467bec01d66def)(degrees + 180, 360) - 180;
    const x = Math.abs(3600 * normalizedDegrees);
    const decimals = fractionDigits || 0;
    let deg = Math.floor(x / 3600);
    let min = Math.floor((x - deg * 3600) / 60);
    let sec = (0, $91ceb5420a5c8360$export$a81f732198733497)(x - deg * 3600 - min * 60, decimals);
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    let hdms = deg + '\u00b0';
    if (min !== 0 || sec !== 0) hdms += ' ' + (0, $9fd184ea0ccac476$export$24be126cb0a7bbeb)(min, 2) + '\u2032';
    if (sec !== 0) hdms += ' ' + (0, $9fd184ea0ccac476$export$24be126cb0a7bbeb)(sec, 2, decimals) + '\u2033';
    if (normalizedDegrees !== 0) hdms += ' ' + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0);
    return hdms;
}
function $188aedb30bca6ae8$export$d9468344d3651243(coordinate, template, fractionDigits) {
    if (coordinate) return template.replace('{x}', coordinate[0].toFixed(fractionDigits)).replace('{y}', coordinate[1].toFixed(fractionDigits));
    return '';
}
function $188aedb30bca6ae8$export$e9bab7fafb253603(coordinate1, coordinate2) {
    let equals = true;
    for(let i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $188aedb30bca6ae8$export$bb628a54ab399bc9(coordinate, angle) {
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    const y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $188aedb30bca6ae8$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $188aedb30bca6ae8$export$88e6ebb4fe54f538(coord1, coord2) {
    const dx = coord1[0] - coord2[0];
    const dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $188aedb30bca6ae8$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($188aedb30bca6ae8$export$88e6ebb4fe54f538(coord1, coord2));
}
function $188aedb30bca6ae8$export$6985570514055196(coordinate, segment) {
    return $188aedb30bca6ae8$export$88e6ebb4fe54f538(coordinate, $188aedb30bca6ae8$export$18cdd31d17f97131(coordinate, segment));
}
function $188aedb30bca6ae8$export$c883fd238161f841(coordinate, fractionDigits) {
    if (coordinate) return $188aedb30bca6ae8$export$6eb0ac5f024d8590('NS', coordinate[1], fractionDigits) + ' ' + $188aedb30bca6ae8$export$6eb0ac5f024d8590('EW', coordinate[0], fractionDigits);
    return '';
}
function $188aedb30bca6ae8$export$9ff8f16060979e0a(coordinate, fractionDigits) {
    return $188aedb30bca6ae8$export$d9468344d3651243(coordinate, '{x}, {y}', fractionDigits);
}
function $188aedb30bca6ae8$export$39a9ce3624977b84(coordinate, projection) {
    if (projection.canWrapX()) {
        const worldWidth = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(projection.getExtent());
        const worldsAway = $188aedb30bca6ae8$export$24e2b27d1ff0c1d5(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function $188aedb30bca6ae8$export$24e2b27d1ff0c1d5(coordinate, projection, sourceExtentWidth) {
    const projectionExtent = projection.getExtent();
    let worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        sourceExtentWidth = sourceExtentWidth || (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}


/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $5354ee427f82b926$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $5354ee427f82b926$export$57636bb43b1ccbb0(t) {
    return 1 - $5354ee427f82b926$export$929e5a82286172a6(1 - t);
}
function $5354ee427f82b926$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $5354ee427f82b926$export$45db2fc2f15997e7(t) {
    return t;
}
function $5354ee427f82b926$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $5354ee427f82b926$export$9b47139b511b56e4(2 * t);
    return 1 - $5354ee427f82b926$export$9b47139b511b56e4(2 * (t - 0.5));
}




/**
 * @module ol/geom/Polygon
 */ 


/**
 * @module ol/sphere
 */ 
const $9ab761a4e8878546$export$63f2df7bd7371262 = 6371008.8;
function $9ab761a4e8878546$export$79376507b09a66f(c1, c2, radius) {
    radius = radius || $9ab761a4e8878546$export$63f2df7bd7371262;
    const lat1 = (0, $91ceb5420a5c8360$export$cba01ba138429a1d)(c1[1]);
    const lat2 = (0, $91ceb5420a5c8360$export$cba01ba138429a1d)(c2[1]);
    const deltaLatBy2 = (lat2 - lat1) / 2;
    const deltaLonBy2 = (0, $91ceb5420a5c8360$export$cba01ba138429a1d)(c2[0] - c1[0]) / 2;
    const a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $9ab761a4e8878546$var$getLengthInternal(coordinates, radius) {
    let length = 0;
    for(let i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $9ab761a4e8878546$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $9ab761a4e8878546$export$f0d11c074a923179(geometry, options) {
    options = options || {};
    const radius = options.radius || $9ab761a4e8878546$export$63f2df7bd7371262;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let length = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
            break;
        case 'LineString':
        case 'LinearRing':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $9ab761a4e8878546$var$getLengthInternal(coordinates, radius);
            break;
        case 'MultiLineString':
        case 'Polygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $9ab761a4e8878546$var$getLengthInternal(coordinates[i], radius);
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $9ab761a4e8878546$var$getLengthInternal(coords[j], radius);
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)length += $9ab761a4e8878546$export$f0d11c074a923179(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $9ab761a4e8878546$var$getAreaInternal(coordinates, radius) {
    let area = 0;
    const len = coordinates.length;
    let x1 = coordinates[len - 1][0];
    let y1 = coordinates[len - 1][1];
    for(let i = 0; i < len; i++){
        const x2 = coordinates[i][0];
        const y2 = coordinates[i][1];
        area += (0, $91ceb5420a5c8360$export$cba01ba138429a1d)(x2 - x1) * (2 + Math.sin((0, $91ceb5420a5c8360$export$cba01ba138429a1d)(y1)) + Math.sin((0, $91ceb5420a5c8360$export$cba01ba138429a1d)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $9ab761a4e8878546$export$520c40045967cb15(geometry, options) {
    options = options || {};
    const radius = options.radius || $9ab761a4e8878546$export$63f2df7bd7371262;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let area = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
        case 'LineString':
        case 'MultiLineString':
        case 'LinearRing':
            break;
        case 'Polygon':
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($9ab761a4e8878546$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($9ab761a4e8878546$var$getAreaInternal(coordinates[i], radius));
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($9ab761a4e8878546$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($9ab761a4e8878546$var$getAreaInternal(coords[j], radius));
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)area += $9ab761a4e8878546$export$520c40045967cb15(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return area;
}
function $9ab761a4e8878546$export$cc800923e997bb8(c1, distance, bearing, radius) {
    radius = radius || $9ab761a4e8878546$export$63f2df7bd7371262;
    const lat1 = (0, $91ceb5420a5c8360$export$cba01ba138429a1d)(c1[1]);
    const lon1 = (0, $91ceb5420a5c8360$export$cba01ba138429a1d)(c1[0]);
    const dByR = distance / radius;
    const lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    const lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $91ceb5420a5c8360$export$56cb859c01fa134d)(lon),
        (0, $91ceb5420a5c8360$export$56cb859c01fa134d)(lat)
    ];
}


/**
 * @module ol/geom/LinearRing
 */ 
/**
 * @module ol/geom/SimpleGeometry
 */ 

/**
 * @module ol/geom/Geometry
 */ 


/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://epsg.io/, and are a JS function, so can be loaded in a script
 * tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ /**
 * @module ol/console
 */ /**
 * @typedef {'info'|'warn'|'error'|'none'} Level
 */ /**
 * @type {Object<Level, number>}
 */ const $87184501dfc6591a$var$levels = {
    info: 1,
    warn: 2,
    error: 3,
    none: 4
};
/**
 * @type {number}
 */ let $87184501dfc6591a$var$level = $87184501dfc6591a$var$levels.info;
function $87184501dfc6591a$export$2c97a59140dbf245(l) {
    $87184501dfc6591a$var$level = $87184501dfc6591a$var$levels[l];
}
function $87184501dfc6591a$export$bef1f36f5486a6a3(...args) {
    if ($87184501dfc6591a$var$level > $87184501dfc6591a$var$levels.info) return;
    console.log(...args); // eslint-disable-line no-console
}
function $87184501dfc6591a$export$c106dd0671a0fc2d(...args) {
    if ($87184501dfc6591a$var$level > $87184501dfc6591a$var$levels.warn) return;
    console.warn(...args); // eslint-disable-line no-console
}
function $87184501dfc6591a$export$a3bc9b8ed74fc(...args) {
    if ($87184501dfc6591a$var$level > $87184501dfc6591a$var$levels.error) return;
    console.error(...args); // eslint-disable-line no-console
}






/**
 * @module ol/proj/Units
 */ /**
 * @typedef {'radians' | 'degrees' | 'ft' | 'm' | 'pixels' | 'tile-pixels' | 'us-ft'} Units
 * Projection units.
 */ /**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */ const $66a0959185f94b5b$var$unitByCode = {
    '9001': 'm',
    '9002': 'ft',
    '9003': 'us-ft',
    '9101': 'radians',
    '9102': 'degrees'
};
function $66a0959185f94b5b$export$7f58726df3255edc(code) {
    return $66a0959185f94b5b$var$unitByCode[code];
}
const $66a0959185f94b5b$export$1482081eec883108 = {
    // use the radius of the Normal sphere
    'radians': 6370997 / (2 * Math.PI),
    'degrees': 2 * Math.PI * 6370997 / 360,
    'ft': 0.3048,
    'm': 1,
    'us-ft': 1200 / 3937
};


/**
 * @module ol/proj/epsg3857
 */ /**
 * @module ol/proj/Projection
 */ 
/**
 * The function is called with a `number` view resolution and a
 * {@link module:ol/coordinate~Coordinate} as arguments, and returns the `number` resolution
 * in projection units at the passed coordinate.
 * @typedef {function(number, import("../coordinate.js").Coordinate):number} GetPointResolution
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").Units} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {GetPointResolution} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution} function will be used.
 */ /**
 * @classdesc
 * In most cases, you should not need to create instances of this class.
 * Instead, where projection information is required, you can use a string
 * projection code or identifier (e.g. `EPSG:4326`) instead of a projection
 * instance.
 *
 * The library includes support for transforming coordinates between the following
 * projections:
 *
 *  WGS 84 / Geographic - Using codes `EPSG:4326`, `CRS:84`, `urn:ogc:def:crs:EPSG:6.6:4326`,
 *    `urn:ogc:def:crs:OGC:1.3:CRS84`, `urn:ogc:def:crs:OGC:2:84`, `http://www.opengis.net/gml/srs/epsg.xml#4326`,
 *    or `urn:x-ogc:def:crs:EPSG:4326`
 *  WGS 84 / Spherical Mercator - Using codes `EPSG:3857`, `EPSG:102100`, `EPSG:102113`, `EPSG:900913`,
 *    `urn:ogc:def:crs:EPSG:6.18:3:3857`, or `http://www.opengis.net/gml/srs/epsg.xml#3857`
 *  WGS 84 / UTM zones - Using codes `EPSG:32601` through `EPSG:32660` for northern zones
 *    and `EPSG:32701` through `EPSG:32760` for southern zones. Note that the built-in UTM transforms
 *    are lower accuracy (with errors on the order of 0.1 m) than those that you might get in a
 *    library like [proj4js](https://github.com/proj4js/proj4js).
 *
 * For additional projection support, or to use higher accuracy transforms than the built-in ones, you can use
 * the [proj4js](https://github.com/proj4js/proj4js) library. With `proj4js`, after adding any new projection
 * definitions, call the {@link module:ol/proj/proj4.register} function.
 *
 * You can use the {@link module:ol/proj.get} function to retrieve a projection instance
 * for one of the registered projections.
 *
 * @api
 */ class $53feab4ae1012f80$var$Projection {
    /**
   * @param {Options} options Projection options.
   */ constructor(options){
        /**
     * @private
     * @type {string}
     */ this.code_ = options.code;
        /**
     * Units of projected coordinates. When set to `TILE_PIXELS`, a
     * `this.extent_` and `this.worldExtent_` must be configured properly for each
     * tile.
     * @private
     * @type {import("./Units.js").Units}
     */ this.units_ = /** @type {import("./Units.js").Units} */ options.units;
        /**
     * Validity extent of the projection in projected coordinates. For projections
     * with `TILE_PIXELS` units, this is the extent of the tile in
     * tile pixel space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
     * Extent of the world in EPSG:4326. For projections with
     * `TILE_PIXELS` units, this is the extent of the tile in
     * projected coordinate space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
     * @private
     * @type {string}
     */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : 'enu';
        /**
     * @private
     * @type {boolean}
     */ this.global_ = options.global !== undefined ? options.global : false;
        /**
     * @private
     * @type {boolean}
     */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
     * @private
     * @type {GetPointResolution|undefined}
     */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.defaultTileGrid_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */ canWrapX() {
        return this.canWrapX_;
    }
    /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */ getCode() {
        return this.code_;
    }
    /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */ getUnits() {
        return this.units_;
    }
    /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */ getMetersPerUnit() {
        return this.metersPerUnit_ || (0, $66a0959185f94b5b$export$1482081eec883108)[this.units_];
    }
    /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getWorldExtent() {
        return this.worldExtent_;
    }
    /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */ getAxisOrientation() {
        return this.axisOrientation_;
    }
    /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */ isGlobal() {
        return this.global_;
    }
    /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */ setGlobal(global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    }
    /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */ getDefaultTileGrid() {
        return this.defaultTileGrid_;
    }
    /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */ setDefaultTileGrid(tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    }
    /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ setExtent(extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    }
    /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */ setWorldExtent(worldExtent) {
        this.worldExtent_ = worldExtent;
    }
    /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */ setGetPointResolution(func) {
        this.getPointResolutionFunc_ = func;
    }
    /**
   * Get the custom point resolution function for this projection (if set).
   * @return {GetPointResolution|undefined} The custom point
   * resolution function (if set).
   */ getPointResolutionFunc() {
        return this.getPointResolutionFunc_;
    }
}
var $53feab4ae1012f80$export$2e2bcd8739ae039 = $53feab4ae1012f80$var$Projection;


const $a42a16faf38b9d3a$export$2d2c9be8b5b863f = 6378137;
const $a42a16faf38b9d3a$export$f3928063e5e96d35 = Math.PI * $a42a16faf38b9d3a$export$2d2c9be8b5b863f;
const $a42a16faf38b9d3a$export$21e6da8a7375dfe8 = [
    -$a42a16faf38b9d3a$export$f3928063e5e96d35,
    -$a42a16faf38b9d3a$export$f3928063e5e96d35,
    $a42a16faf38b9d3a$export$f3928063e5e96d35,
    $a42a16faf38b9d3a$export$f3928063e5e96d35
];
const $a42a16faf38b9d3a$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
const $a42a16faf38b9d3a$export$d26945d1ad52feeb = $a42a16faf38b9d3a$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ class $a42a16faf38b9d3a$var$EPSG3857Projection extends (0, $53feab4ae1012f80$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   */ constructor(code){
        super({
            code: code,
            units: 'm',
            extent: $a42a16faf38b9d3a$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $a42a16faf38b9d3a$export$ae9d6ed80df710e5,
            getPointResolution: function(resolution, point) {
                return resolution / Math.cosh(point[1] / $a42a16faf38b9d3a$export$2d2c9be8b5b863f);
            }
        });
    }
}
const $a42a16faf38b9d3a$export$b508d7ad9a891c1b = [
    new $a42a16faf38b9d3a$var$EPSG3857Projection('EPSG:3857'),
    new $a42a16faf38b9d3a$var$EPSG3857Projection('EPSG:102100'),
    new $a42a16faf38b9d3a$var$EPSG3857Projection('EPSG:102113'),
    new $a42a16faf38b9d3a$var$EPSG3857Projection('EPSG:900913'),
    new $a42a16faf38b9d3a$var$EPSG3857Projection('http://www.opengis.net/def/crs/EPSG/0/3857'),
    new $a42a16faf38b9d3a$var$EPSG3857Projection('http://www.opengis.net/gml/srs/epsg.xml#3857')
];
function $a42a16faf38b9d3a$export$1ff8bb36c0983070(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = $a42a16faf38b9d3a$export$f3928063e5e96d35 * input[i] / 180;
        let y = $a42a16faf38b9d3a$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > $a42a16faf38b9d3a$export$d26945d1ad52feeb) y = $a42a16faf38b9d3a$export$d26945d1ad52feeb;
        else if (y < -$a42a16faf38b9d3a$export$d26945d1ad52feeb) y = -$a42a16faf38b9d3a$export$d26945d1ad52feeb;
        output[i + 1] = y;
    }
    return output;
}
function $a42a16faf38b9d3a$export$8c71322ec28ed6b4(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = 180 * input[i] / $a42a16faf38b9d3a$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $a42a16faf38b9d3a$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}


/**
 * @module ol/proj/epsg4326
 */ 
const $810bb55e3b29d55f$export$2d2c9be8b5b863f = 6378137;
const $810bb55e3b29d55f$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
const $810bb55e3b29d55f$export$1482081eec883108 = Math.PI * $810bb55e3b29d55f$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ class $810bb55e3b29d55f$var$EPSG4326Projection extends (0, $53feab4ae1012f80$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   * @param {string} [axisOrientation] Axis orientation.
   */ constructor(code, axisOrientation){
        super({
            code: code,
            units: 'degrees',
            extent: $810bb55e3b29d55f$export$21e6da8a7375dfe8,
            axisOrientation: axisOrientation,
            global: true,
            metersPerUnit: $810bb55e3b29d55f$export$1482081eec883108,
            worldExtent: $810bb55e3b29d55f$export$21e6da8a7375dfe8
        });
    }
}
const $810bb55e3b29d55f$export$b508d7ad9a891c1b = [
    new $810bb55e3b29d55f$var$EPSG4326Projection('CRS:84'),
    new $810bb55e3b29d55f$var$EPSG4326Projection('EPSG:4326', 'neu'),
    new $810bb55e3b29d55f$var$EPSG4326Projection('urn:ogc:def:crs:OGC:1.3:CRS84'),
    new $810bb55e3b29d55f$var$EPSG4326Projection('urn:ogc:def:crs:OGC:2:84'),
    new $810bb55e3b29d55f$var$EPSG4326Projection('http://www.opengis.net/def/crs/OGC/1.3/CRS84'),
    new $810bb55e3b29d55f$var$EPSG4326Projection('http://www.opengis.net/gml/srs/epsg.xml#4326', 'neu'),
    new $810bb55e3b29d55f$var$EPSG4326Projection('http://www.opengis.net/def/crs/EPSG/0/4326', 'neu')
];


/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ let $448ab100ab4c166e$var$cache = {};
function $448ab100ab4c166e$export$42ffd38884aecdac() {
    $448ab100ab4c166e$var$cache = {};
}
function $448ab100ab4c166e$export$3988ae62b71be9a3(code) {
    return $448ab100ab4c166e$var$cache[code] || $448ab100ab4c166e$var$cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, 'EPSG:$3')] || null;
}
function $448ab100ab4c166e$export$e16d8520af44a096(code, projection) {
    $448ab100ab4c166e$var$cache[code] = projection;
}


/**
 * @module ol/proj/transforms
 */ 
/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ let $1d595c8db60822f1$var$transforms = {};
function $1d595c8db60822f1$export$42ffd38884aecdac() {
    $1d595c8db60822f1$var$transforms = {};
}
function $1d595c8db60822f1$export$e16d8520af44a096(source, destination, transformFn) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    if (!(sourceCode in $1d595c8db60822f1$var$transforms)) $1d595c8db60822f1$var$transforms[sourceCode] = {};
    $1d595c8db60822f1$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $1d595c8db60822f1$export$cd7f480d6b8286c3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    const transform = $1d595c8db60822f1$var$transforms[sourceCode][destinationCode];
    delete $1d595c8db60822f1$var$transforms[sourceCode][destinationCode];
    if ((0, $0364d4893e3f1129$export$dd1bc94b04021eeb)($1d595c8db60822f1$var$transforms[sourceCode])) delete $1d595c8db60822f1$var$transforms[sourceCode];
    return transform;
}
function $1d595c8db60822f1$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    if (sourceCode in $1d595c8db60822f1$var$transforms && destinationCode in $1d595c8db60822f1$var$transforms[sourceCode]) return $1d595c8db60822f1$var$transforms[sourceCode][destinationCode];
    return null;
}


/**
 * @module ol/proj/utm
 */ /**
 * Adapted from https://github.com/Turbo87/utm
 * Copyright (c) 2012-2017 Tobias Bieniek
 *
 * The functions here provide approximate transforms to and from UTM.
 * They are not appropriate for use beyond the validity extend of a UTM
 * zone, and the accuracy of the transform decreases toward the zone
 * edges.
 */ 

/**
 * @typedef {Object} UTMZone
 * @property {number} number The zone number (1 - 60).
 * @property {boolean} north The northern hemisphere.
 */ const $b28be2ba8a4b34ee$var$K0 = 0.9996;
const $b28be2ba8a4b34ee$var$E = 0.00669438;
const $b28be2ba8a4b34ee$var$E2 = $b28be2ba8a4b34ee$var$E * $b28be2ba8a4b34ee$var$E;
const $b28be2ba8a4b34ee$var$E3 = $b28be2ba8a4b34ee$var$E2 * $b28be2ba8a4b34ee$var$E;
const $b28be2ba8a4b34ee$var$E_P2 = $b28be2ba8a4b34ee$var$E / (1 - $b28be2ba8a4b34ee$var$E);
const $b28be2ba8a4b34ee$var$SQRT_E = Math.sqrt(1 - $b28be2ba8a4b34ee$var$E);
const $b28be2ba8a4b34ee$var$_E = (1 - $b28be2ba8a4b34ee$var$SQRT_E) / (1 + $b28be2ba8a4b34ee$var$SQRT_E);
const $b28be2ba8a4b34ee$var$_E2 = $b28be2ba8a4b34ee$var$_E * $b28be2ba8a4b34ee$var$_E;
const $b28be2ba8a4b34ee$var$_E3 = $b28be2ba8a4b34ee$var$_E2 * $b28be2ba8a4b34ee$var$_E;
const $b28be2ba8a4b34ee$var$_E4 = $b28be2ba8a4b34ee$var$_E3 * $b28be2ba8a4b34ee$var$_E;
const $b28be2ba8a4b34ee$var$_E5 = $b28be2ba8a4b34ee$var$_E4 * $b28be2ba8a4b34ee$var$_E;
const $b28be2ba8a4b34ee$var$M1 = 1 - $b28be2ba8a4b34ee$var$E / 4 - 3 * $b28be2ba8a4b34ee$var$E2 / 64 - 5 * $b28be2ba8a4b34ee$var$E3 / 256;
const $b28be2ba8a4b34ee$var$M2 = 3 * $b28be2ba8a4b34ee$var$E / 8 + 3 * $b28be2ba8a4b34ee$var$E2 / 32 + 45 * $b28be2ba8a4b34ee$var$E3 / 1024;
const $b28be2ba8a4b34ee$var$M3 = 15 * $b28be2ba8a4b34ee$var$E2 / 256 + 45 * $b28be2ba8a4b34ee$var$E3 / 1024;
const $b28be2ba8a4b34ee$var$M4 = 35 * $b28be2ba8a4b34ee$var$E3 / 3072;
const $b28be2ba8a4b34ee$var$P2 = 1.5 * $b28be2ba8a4b34ee$var$_E - 27 / 32 * $b28be2ba8a4b34ee$var$_E3 + 269 / 512 * $b28be2ba8a4b34ee$var$_E5;
const $b28be2ba8a4b34ee$var$P3 = 21 / 16 * $b28be2ba8a4b34ee$var$_E2 - 55 / 32 * $b28be2ba8a4b34ee$var$_E4;
const $b28be2ba8a4b34ee$var$P4 = 151 / 96 * $b28be2ba8a4b34ee$var$_E3 - 417 / 128 * $b28be2ba8a4b34ee$var$_E5;
const $b28be2ba8a4b34ee$var$P5 = 1097 / 512 * $b28be2ba8a4b34ee$var$_E4;
const $b28be2ba8a4b34ee$var$R = 6378137;
/**
 * @param {number} easting Easting value of coordinate.
 * @param {number} northing Northing value of coordinate.
 * @param {UTMZone} zone The UTM zone.
 * @return {import("../coordinate.js").Coordinate} The transformed coordinate.
 */ function $b28be2ba8a4b34ee$var$toLonLat(easting, northing, zone) {
    const x = easting - 500000;
    const y = zone.north ? northing : northing - 10000000;
    const m = y / $b28be2ba8a4b34ee$var$K0;
    const mu = m / ($b28be2ba8a4b34ee$var$R * $b28be2ba8a4b34ee$var$M1);
    const pRad = mu + $b28be2ba8a4b34ee$var$P2 * Math.sin(2 * mu) + $b28be2ba8a4b34ee$var$P3 * Math.sin(4 * mu) + $b28be2ba8a4b34ee$var$P4 * Math.sin(6 * mu) + $b28be2ba8a4b34ee$var$P5 * Math.sin(8 * mu);
    const pSin = Math.sin(pRad);
    const pSin2 = pSin * pSin;
    const pCos = Math.cos(pRad);
    const pTan = pSin / pCos;
    const pTan2 = pTan * pTan;
    const pTan4 = pTan2 * pTan2;
    const epSin = 1 - $b28be2ba8a4b34ee$var$E * pSin2;
    const epSinSqrt = Math.sqrt(1 - $b28be2ba8a4b34ee$var$E * pSin2);
    const n = $b28be2ba8a4b34ee$var$R / epSinSqrt;
    const r = (1 - $b28be2ba8a4b34ee$var$E) / epSin;
    const c = $b28be2ba8a4b34ee$var$E_P2 * pCos ** 2;
    const c2 = c * c;
    const d = x / (n * $b28be2ba8a4b34ee$var$K0);
    const d2 = d * d;
    const d3 = d2 * d;
    const d4 = d3 * d;
    const d5 = d4 * d;
    const d6 = d5 * d;
    const latitude = pRad - pTan / r * (d2 / 2 - d4 / 24 * (5 + 3 * pTan2 + 10 * c - 4 * c2 - 9 * $b28be2ba8a4b34ee$var$E_P2)) + d6 / 720 * (61 + 90 * pTan2 + 298 * c + 45 * pTan4 - 252 * $b28be2ba8a4b34ee$var$E_P2 - 3 * c2);
    let longitude = (d - d3 / 6 * (1 + 2 * pTan2 + c) + d5 / 120 * (5 - 2 * c + 28 * pTan2 - 3 * c2 + 8 * $b28be2ba8a4b34ee$var$E_P2 + 24 * pTan4)) / pCos;
    longitude = (0, $91ceb5420a5c8360$export$4997ffc0176396a6)(longitude + (0, $91ceb5420a5c8360$export$cba01ba138429a1d)($b28be2ba8a4b34ee$var$zoneToCentralLongitude(zone.number)), -Math.PI, Math.PI);
    return [
        (0, $91ceb5420a5c8360$export$56cb859c01fa134d)(longitude),
        (0, $91ceb5420a5c8360$export$56cb859c01fa134d)(latitude)
    ];
}
const $b28be2ba8a4b34ee$var$MIN_LATITUDE = -80;
const $b28be2ba8a4b34ee$var$MAX_LATITUDE = 84;
const $b28be2ba8a4b34ee$var$MIN_LONGITUDE = -180;
const $b28be2ba8a4b34ee$var$MAX_LONGITUDE = 180;
/**
 * @param {number} longitude The longitude.
 * @param {number} latitude The latitude.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../coordinate.js').Coordinate} The UTM coordinate.
 */ function $b28be2ba8a4b34ee$var$fromLonLat(longitude, latitude, zone) {
    longitude = (0, $91ceb5420a5c8360$export$4997ffc0176396a6)(longitude, $b28be2ba8a4b34ee$var$MIN_LONGITUDE, $b28be2ba8a4b34ee$var$MAX_LONGITUDE);
    if (latitude < $b28be2ba8a4b34ee$var$MIN_LATITUDE) latitude = $b28be2ba8a4b34ee$var$MIN_LATITUDE;
    else if (latitude > $b28be2ba8a4b34ee$var$MAX_LATITUDE) latitude = $b28be2ba8a4b34ee$var$MAX_LATITUDE;
    const latRad = (0, $91ceb5420a5c8360$export$cba01ba138429a1d)(latitude);
    const latSin = Math.sin(latRad);
    const latCos = Math.cos(latRad);
    const latTan = latSin / latCos;
    const latTan2 = latTan * latTan;
    const latTan4 = latTan2 * latTan2;
    const lonRad = (0, $91ceb5420a5c8360$export$cba01ba138429a1d)(longitude);
    const centralLon = $b28be2ba8a4b34ee$var$zoneToCentralLongitude(zone.number);
    const centralLonRad = (0, $91ceb5420a5c8360$export$cba01ba138429a1d)(centralLon);
    const n = $b28be2ba8a4b34ee$var$R / Math.sqrt(1 - $b28be2ba8a4b34ee$var$E * latSin ** 2);
    const c = $b28be2ba8a4b34ee$var$E_P2 * latCos ** 2;
    const a = latCos * (0, $91ceb5420a5c8360$export$4997ffc0176396a6)(lonRad - centralLonRad, -Math.PI, Math.PI);
    const a2 = a * a;
    const a3 = a2 * a;
    const a4 = a3 * a;
    const a5 = a4 * a;
    const a6 = a5 * a;
    const m = $b28be2ba8a4b34ee$var$R * ($b28be2ba8a4b34ee$var$M1 * latRad - $b28be2ba8a4b34ee$var$M2 * Math.sin(2 * latRad) + $b28be2ba8a4b34ee$var$M3 * Math.sin(4 * latRad) - $b28be2ba8a4b34ee$var$M4 * Math.sin(6 * latRad));
    const easting = $b28be2ba8a4b34ee$var$K0 * n * (a + a3 / 6 * (1 - latTan2 + c) + a5 / 120 * (5 - 18 * latTan2 + latTan4 + 72 * c - 58 * $b28be2ba8a4b34ee$var$E_P2)) + 500000;
    let northing = $b28be2ba8a4b34ee$var$K0 * (m + n * latTan * (a2 / 2 + a4 / 24 * (5 - latTan2 + 9 * c + 4 * c ** 2) + a6 / 720 * (61 - 58 * latTan2 + latTan4 + 600 * c - 330 * $b28be2ba8a4b34ee$var$E_P2)));
    if (!zone.north) northing += 10000000;
    return [
        easting,
        northing
    ];
}
/**
 * @param {number} zone The zone number.
 * @return {number} The central longitude in degrees.
 */ function $b28be2ba8a4b34ee$var$zoneToCentralLongitude(zone) {
    return (zone - 1) * 6 - 180 + 3;
}
/**
 * @type {Array<RegExp>}
 */ const $b28be2ba8a4b34ee$var$epsgRegExes = [
    /^EPSG:(\d+)$/,
    /^urn:ogc:def:crs:EPSG::(\d+)$/,
    /^http:\/\/www\.opengis\.net\/def\/crs\/EPSG\/0\/(\d+)$/
];
function $b28be2ba8a4b34ee$export$bb54dc52a08ed170(code) {
    let epsgId = 0;
    for (const re of $b28be2ba8a4b34ee$var$epsgRegExes){
        const match = code.match(re);
        if (match) {
            epsgId = parseInt(match[1]);
            break;
        }
    }
    if (!epsgId) return null;
    let number = 0;
    let north = false;
    if (epsgId > 32700 && epsgId < 32761) number = epsgId - 32700;
    else if (epsgId > 32600 && epsgId < 32661) {
        north = true;
        number = epsgId - 32600;
    }
    if (!number) return null;
    return {
        number: number,
        north: north
    };
}
/**
 * @param {function(number, number, UTMZone): import('../coordinate.js').Coordinate} transformer The transformer.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../proj.js').TransformFunction} The transform function.
 */ function $b28be2ba8a4b34ee$var$makeTransformFunction(transformer, zone) {
    return function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension > 1 ? dimension : 2;
        stride = stride ?? dimension;
        if (!output) {
            if (dimension > 2) output = input.slice();
            else output = new Array(length);
        }
        for(let i = 0; i < length; i += stride){
            const x = input[i];
            const y = input[i + 1];
            const coord = transformer(x, y, zone);
            output[i] = coord[0];
            output[i + 1] = coord[1];
        }
        return output;
    };
}
function $b28be2ba8a4b34ee$export$3277980d225b59be(code) {
    const zone = $b28be2ba8a4b34ee$export$bb54dc52a08ed170(code);
    if (!zone) return null;
    return new (0, $53feab4ae1012f80$export$2e2bcd8739ae039)({
        code: code,
        units: 'm'
    });
}
function $b28be2ba8a4b34ee$export$f94509e55523febf(projection) {
    const zone = $b28be2ba8a4b34ee$export$bb54dc52a08ed170(projection.getCode());
    if (!zone) return null;
    return {
        forward: $b28be2ba8a4b34ee$var$makeTransformFunction($b28be2ba8a4b34ee$var$fromLonLat, zone),
        inverse: $b28be2ba8a4b34ee$var$makeTransformFunction($b28be2ba8a4b34ee$var$toLonLat, zone)
    };
}



/**
 * A projection as {@link module:ol/proj/Projection~Projection}, SRS identifier
 * string or undefined.
 * @typedef {Projection|string|undefined} ProjectionLike
 * @api
 */ /**
 * @typedef {Object} Transforms
 * @property {TransformFunction} forward The forward transform (from geographic).
 * @property {TransformFunction} inverse The inverse transform (to geographic).
 */ /**
 * @type {Array<function(Projection): Transforms|null>}
 */ const $d447c151baf41c8c$var$transformFactories = [
    (0, $b28be2ba8a4b34ee$export$f94509e55523febf)
];
/**
 * @type {Array<function(string): Projection|null>}
 */ const $d447c151baf41c8c$var$projectionFactories = [
    (0, $b28be2ba8a4b34ee$export$3277980d225b59be)
];
let $d447c151baf41c8c$var$showCoordinateWarning = true;
function $d447c151baf41c8c$export$ed949affbc7c4223(disable) {
    const hide = disable === undefined ? true : disable;
    $d447c151baf41c8c$var$showCoordinateWarning = !hide;
}
function $d447c151baf41c8c$export$dd516654c5f598fb(input, output) {
    if (output !== undefined) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        output;
    } else output = input.slice();
    return output;
}
function $d447c151baf41c8c$export$83e8ab53904f8022(input, output) {
    if (output !== undefined && input !== output) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        input = output;
    }
    return input;
}
function $d447c151baf41c8c$export$59ae956cd3e343f7(projection) {
    (0, $448ab100ab4c166e$export$e16d8520af44a096)(projection.getCode(), projection);
    (0, $1d595c8db60822f1$export$e16d8520af44a096)(projection, projection, $d447c151baf41c8c$export$dd516654c5f598fb);
}
function $d447c151baf41c8c$export$638ad73f7aafb913(projections) {
    projections.forEach($d447c151baf41c8c$export$59ae956cd3e343f7);
}
function $d447c151baf41c8c$export$3988ae62b71be9a3(projectionLike) {
    if (!(typeof projectionLike === 'string')) return projectionLike;
    const projection = (0, $448ab100ab4c166e$export$3988ae62b71be9a3)(projectionLike);
    if (projection) return projection;
    for (const makeProjection of $d447c151baf41c8c$var$projectionFactories){
        const projection = makeProjection(projectionLike);
        if (projection) return projection;
    }
    return null;
}
function $d447c151baf41c8c$export$2d8f7b4eec383d44(projection, resolution, point, units) {
    projection = $d447c151baf41c8c$export$3988ae62b71be9a3(projection);
    let pointResolution;
    const getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (units && units !== projection.getUnits()) {
            const metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, $66a0959185f94b5b$export$1482081eec883108)[units];
        }
    } else {
        const projUnits = projection.getUnits();
        if (projUnits == 'degrees' && !units || units == 'degrees') pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            const toEPSG4326 = $d447c151baf41c8c$export$e3c4995a701c26a3(projection, $d447c151baf41c8c$export$3988ae62b71be9a3('EPSG:4326'));
            if (!toEPSG4326 && projUnits !== 'degrees') // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                let vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326(vertices, vertices, 2);
                const width = (0, $9ab761a4e8878546$export$79376507b09a66f)(vertices.slice(0, 2), vertices.slice(2, 4));
                const height = (0, $9ab761a4e8878546$export$79376507b09a66f)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            const metersPerUnit = units ? (0, $66a0959185f94b5b$export$1482081eec883108)[units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function $d447c151baf41c8c$export$eeb8392580a05a37(projections) {
    $d447c151baf41c8c$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $1d595c8db60822f1$export$e16d8520af44a096)(source, destination, $d447c151baf41c8c$export$dd516654c5f598fb);
        });
    });
}
function $d447c151baf41c8c$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $1d595c8db60822f1$export$e16d8520af44a096)(projection1, projection2, forwardTransform);
            (0, $1d595c8db60822f1$export$e16d8520af44a096)(projection2, projection1, inverseTransform);
        });
    });
}
function $d447c151baf41c8c$export$4860237d10380594() {
    (0, $448ab100ab4c166e$export$42ffd38884aecdac)();
    (0, $1d595c8db60822f1$export$42ffd38884aecdac)();
}
function $d447c151baf41c8c$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $d447c151baf41c8c$export$3988ae62b71be9a3(defaultCode);
    if (typeof projection === 'string') return $d447c151baf41c8c$export$3988ae62b71be9a3(projection);
    return /** @type {Projection} */ projection;
}
function $d447c151baf41c8c$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [output] Output.
     * @param {number} [dimension] Dimensions that should be transformed.
     * @param {number} [stride] Stride.
     * @return {Array<number>} Output.
     */ function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension !== undefined ? dimension : 2;
        stride = stride ?? dimension;
        output = output !== undefined ? output : new Array(length);
        for(let i = 0; i < length; i += stride){
            const point = coordTransform(input.slice(i, i + dimension));
            const pointLength = point.length;
            for(let j = 0, jj = stride; j < jj; ++j)output[i + j] = j >= pointLength ? input[i + j] : point[j];
        }
        return output;
    });
}
function $d447c151baf41c8c$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    const sourceProj = $d447c151baf41c8c$export$3988ae62b71be9a3(source);
    const destProj = $d447c151baf41c8c$export$3988ae62b71be9a3(destination);
    (0, $1d595c8db60822f1$export$e16d8520af44a096)(sourceProj, destProj, $d447c151baf41c8c$export$6b4aafd331159e0d(forward));
    (0, $1d595c8db60822f1$export$e16d8520af44a096)(destProj, sourceProj, $d447c151baf41c8c$export$6b4aafd331159e0d(inverse));
}
function $d447c151baf41c8c$export$b15d9668511529b9(coordinate, projection) {
    $d447c151baf41c8c$export$ed949affbc7c4223();
    return $d447c151baf41c8c$export$51186ad6e864892a(coordinate, 'EPSG:4326', projection !== undefined ? projection : 'EPSG:3857');
}
function $d447c151baf41c8c$export$3fb495868742d370(coordinate, projection) {
    const lonLat = $d447c151baf41c8c$export$51186ad6e864892a(coordinate, projection !== undefined ? projection : 'EPSG:3857', 'EPSG:4326');
    const lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $91ceb5420a5c8360$export$ba467bec01d66def)(lon + 180, 360) - 180;
    return lonLat;
}
function $d447c151baf41c8c$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    const equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    const transformFunc = $d447c151baf41c8c$export$e3c4995a701c26a3(projection1, projection2);
    return transformFunc === $d447c151baf41c8c$export$dd516654c5f598fb && equalUnits;
}
function $d447c151baf41c8c$export$e3c4995a701c26a3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    let transformFunc = (0, $1d595c8db60822f1$export$3988ae62b71be9a3)(sourceCode, destinationCode);
    if (transformFunc) return transformFunc;
    /**
   * @type {Transforms|null}
   */ let sourceTransforms = null;
    /**
   * @type {Transforms|null}
   */ let destinationTransforms = null;
    // lazily add projections if we have supported transforms
    for (const makeTransforms of $d447c151baf41c8c$var$transformFactories){
        if (!sourceTransforms) sourceTransforms = makeTransforms(source);
        if (!destinationTransforms) destinationTransforms = makeTransforms(destination);
    }
    if (!sourceTransforms && !destinationTransforms) return null;
    const intermediateCode = 'EPSG:4326';
    if (!destinationTransforms) {
        const toDestination = (0, $1d595c8db60822f1$export$3988ae62b71be9a3)(intermediateCode, destinationCode);
        if (toDestination) transformFunc = $d447c151baf41c8c$var$composeTransformFuncs(sourceTransforms.inverse, toDestination);
    } else if (!sourceTransforms) {
        const fromSource = (0, $1d595c8db60822f1$export$3988ae62b71be9a3)(sourceCode, intermediateCode);
        if (fromSource) transformFunc = $d447c151baf41c8c$var$composeTransformFuncs(fromSource, destinationTransforms.forward);
    } else transformFunc = $d447c151baf41c8c$var$composeTransformFuncs(sourceTransforms.inverse, destinationTransforms.forward);
    if (transformFunc) {
        $d447c151baf41c8c$export$59ae956cd3e343f7(source);
        $d447c151baf41c8c$export$59ae956cd3e343f7(destination);
        (0, $1d595c8db60822f1$export$e16d8520af44a096)(source, destination, transformFunc);
    }
    return transformFunc;
}
/**
 * @param {TransformFunction} t1 The first transform function.
 * @param {TransformFunction} t2 The second transform function.
 * @return {TransformFunction} The composed transform function.
 */ function $d447c151baf41c8c$var$composeTransformFuncs(t1, t2) {
    return function(input, output, dimensions, stride) {
        output = t1(input, output, dimensions, stride);
        return t2(output, output, dimensions, stride);
    };
}
function $d447c151baf41c8c$export$fce0c6cfca85ed96(source, destination) {
    const sourceProjection = $d447c151baf41c8c$export$3988ae62b71be9a3(source);
    const destinationProjection = $d447c151baf41c8c$export$3988ae62b71be9a3(destination);
    return $d447c151baf41c8c$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $d447c151baf41c8c$export$51186ad6e864892a(coordinate, source, destination) {
    const transformFunc = $d447c151baf41c8c$export$fce0c6cfca85ed96(source, destination);
    if (!transformFunc) {
        const sourceCode = $d447c151baf41c8c$export$3988ae62b71be9a3(source).getCode();
        const destinationCode = $d447c151baf41c8c$export$3988ae62b71be9a3(destination).getCode();
        throw new Error(`No transform available between ${sourceCode} and ${destinationCode}`);
    }
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $d447c151baf41c8c$export$751c68e0e0efff79(extent, source, destination, stops) {
    const transformFunc = $d447c151baf41c8c$export$fce0c6cfca85ed96(source, destination);
    return (0, $110ceb23457e07e7$export$9f9dcb98c894b623)(extent, transformFunc, undefined, stops);
}
function $d447c151baf41c8c$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    const transformFunc = $d447c151baf41c8c$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {Projection|null}
 */ let $d447c151baf41c8c$var$userProjection = null;
function $d447c151baf41c8c$export$d0aeadbeac54116e(projection) {
    $d447c151baf41c8c$var$userProjection = $d447c151baf41c8c$export$3988ae62b71be9a3(projection);
}
function $d447c151baf41c8c$export$1ae11279759d4e8f() {
    $d447c151baf41c8c$var$userProjection = null;
}
function $d447c151baf41c8c$export$3973b77d5f6f2790() {
    return $d447c151baf41c8c$var$userProjection;
}
function $d447c151baf41c8c$export$aa7494edfbe36197() {
    $d447c151baf41c8c$export$d0aeadbeac54116e('EPSG:4326');
}
function $d447c151baf41c8c$export$698f563af1ba02a5(coordinate, sourceProjection) {
    if (!$d447c151baf41c8c$var$userProjection) return coordinate;
    return $d447c151baf41c8c$export$51186ad6e864892a(coordinate, sourceProjection, $d447c151baf41c8c$var$userProjection);
}
function $d447c151baf41c8c$export$d4b8ec0b96db1ee2(coordinate, destProjection) {
    if (!$d447c151baf41c8c$var$userProjection) {
        if ($d447c151baf41c8c$var$showCoordinateWarning && !(0, $188aedb30bca6ae8$export$e9bab7fafb253603)(coordinate, [
            0,
            0
        ]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
            $d447c151baf41c8c$var$showCoordinateWarning = false;
            (0, $87184501dfc6591a$export$c106dd0671a0fc2d)('Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.');
        }
        return coordinate;
    }
    return $d447c151baf41c8c$export$51186ad6e864892a(coordinate, $d447c151baf41c8c$var$userProjection, destProjection);
}
function $d447c151baf41c8c$export$96bfd09e2cffb006(extent, sourceProjection) {
    if (!$d447c151baf41c8c$var$userProjection) return extent;
    return $d447c151baf41c8c$export$751c68e0e0efff79(extent, sourceProjection, $d447c151baf41c8c$var$userProjection);
}
function $d447c151baf41c8c$export$494be3a3a25689ca(extent, destProjection) {
    if (!$d447c151baf41c8c$var$userProjection) return extent;
    return $d447c151baf41c8c$export$751c68e0e0efff79(extent, $d447c151baf41c8c$var$userProjection, destProjection);
}
function $d447c151baf41c8c$export$b56bb8ad8b3a00e9(resolution, sourceProjection) {
    if (!$d447c151baf41c8c$var$userProjection) return resolution;
    const sourceMetersPerUnit = $d447c151baf41c8c$export$3988ae62b71be9a3(sourceProjection).getMetersPerUnit();
    const userMetersPerUnit = $d447c151baf41c8c$var$userProjection.getMetersPerUnit();
    return sourceMetersPerUnit && userMetersPerUnit ? resolution * sourceMetersPerUnit / userMetersPerUnit : resolution;
}
function $d447c151baf41c8c$export$bd1cd3b88140b906(resolution, destProjection) {
    if (!$d447c151baf41c8c$var$userProjection) return resolution;
    const destMetersPerUnit = $d447c151baf41c8c$export$3988ae62b71be9a3(destProjection).getMetersPerUnit();
    const userMetersPerUnit = $d447c151baf41c8c$var$userProjection.getMetersPerUnit();
    return destMetersPerUnit && userMetersPerUnit ? resolution * userMetersPerUnit / destMetersPerUnit : resolution;
}
function $d447c151baf41c8c$export$1873f9cfeb8bd1d6(sourceProj, destProj, transform) {
    return function(coord) {
        let transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            const sourceExtent = sourceProj.getExtent();
            const sourceExtentWidth = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(sourceExtent);
            coord = coord.slice(0);
            worldsAway = (0, $188aedb30bca6ae8$export$24e2b27d1ff0c1d5)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            coord[0] = coord[0] - worldsAway * sourceExtentWidth;
            coord[0] = (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(coord[0], sourceExtent[0], sourceExtent[2]);
            coord[1] = (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(coord[1], sourceExtent[1], sourceExtent[3]);
            transformed = transform(coord);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(destProj.getExtent());
        return transformed;
    };
}
function $d447c151baf41c8c$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $d447c151baf41c8c$export$eeb8392580a05a37((0, $a42a16faf38b9d3a$export$b508d7ad9a891c1b));
    $d447c151baf41c8c$export$eeb8392580a05a37((0, $810bb55e3b29d55f$export$b508d7ad9a891c1b));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $d447c151baf41c8c$export$4856f21c2f184f24((0, $810bb55e3b29d55f$export$b508d7ad9a891c1b), (0, $a42a16faf38b9d3a$export$b508d7ad9a891c1b), (0, $a42a16faf38b9d3a$export$1ff8bb36c0983070), (0, $a42a16faf38b9d3a$export$8c71322ec28ed6b4));
}
$d447c151baf41c8c$export$86eed449eb2dcac4();


/**
 * @module ol/transform
 */ 
/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ const $a684e03243281d90$var$tmp_ = new Array(6);
function $a684e03243281d90$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $a684e03243281d90$export$aad8462122ac592b(transform) {
    return $a684e03243281d90$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $a684e03243281d90$export$2060d2db72cce88f(transform1, transform2) {
    const a1 = transform1[0];
    const b1 = transform1[1];
    const c1 = transform1[2];
    const d1 = transform1[3];
    const e1 = transform1[4];
    const f1 = transform1[5];
    const a2 = transform2[0];
    const b2 = transform2[1];
    const c2 = transform2[2];
    const d2 = transform2[3];
    const e2 = transform2[4];
    const f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $a684e03243281d90$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $a684e03243281d90$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $a684e03243281d90$export$5635d7ef4b8fee1c(transform, coordinate) {
    const x = coordinate[0];
    const y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $a684e03243281d90$export$bb628a54ab399bc9(transform, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return $a684e03243281d90$export$2060d2db72cce88f(transform, $a684e03243281d90$export$adaa4cf7ef1b65be($a684e03243281d90$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $a684e03243281d90$export$dcdf75081b88279d(transform, x, y) {
    return $a684e03243281d90$export$2060d2db72cce88f(transform, $a684e03243281d90$export$adaa4cf7ef1b65be($a684e03243281d90$var$tmp_, x, 0, 0, y, 0, 0));
}
function $a684e03243281d90$export$3e4e33ea14aeb531(target, x, y) {
    return $a684e03243281d90$export$adaa4cf7ef1b65be(target, x, 0, 0, y, 0, 0);
}
function $a684e03243281d90$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $a684e03243281d90$export$2060d2db72cce88f(transform, $a684e03243281d90$export$adaa4cf7ef1b65be($a684e03243281d90$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $a684e03243281d90$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $a684e03243281d90$export$12a96a1aaf5558e3(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return $a684e03243281d90$export$f84e8e69fd4488a5($a684e03243281d90$export$f672e0b6f7222cd7($a684e03243281d90$export$185802fd694ee1f5(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function $a684e03243281d90$export$6897c284b6f9f4dc(source) {
    return $a684e03243281d90$export$bd70ea2a93c0fa4(source, source);
}
function $a684e03243281d90$export$bd70ea2a93c0fa4(target, source) {
    const det = $a684e03243281d90$export$a04698f914c55ed9(source);
    (0, $4b57691230be0bd5$export$a7a9523472993e97)(det !== 0, 'Transformation matrix cannot be inverted');
    const a = source[0];
    const b = source[1];
    const c = source[2];
    const d = source[3];
    const e = source[4];
    const f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function $a684e03243281d90$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {Array}
 */ const $a684e03243281d90$var$matrixPrecision = [
    1e5,
    1e5,
    1e5,
    1e5,
    2,
    2
];
function $a684e03243281d90$export$f84e8e69fd4488a5(mat) {
    const transformString = 'matrix(' + mat.join(', ') + ')';
    return transformString;
}
/**
 * Create a transform from a CSS transform matrix string.
 * @param {string} cssTransform The CSS string to parse.
 * @return {!Transform} The transform.
 */ function $a684e03243281d90$var$fromString(cssTransform) {
    const values = cssTransform.substring(7, cssTransform.length - 1).split(',');
    return values.map(parseFloat);
}
function $a684e03243281d90$export$fe091d73a555748b(cssTransform1, cssTransform2) {
    const mat1 = $a684e03243281d90$var$fromString(cssTransform1);
    const mat2 = $a684e03243281d90$var$fromString(cssTransform2);
    for(let i = 0; i < 6; ++i){
        if (Math.round((mat1[i] - mat2[i]) * $a684e03243281d90$var$matrixPrecision[i]) !== 0) return false;
    }
    return true;
}



/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [dest] Destination.
 * @param {number} [destinationStride] Stride of destination coordinates; if unspecified, assumed to be 2.
 * @return {Array<number>} Transformed coordinates.
 */ function $437d3763a798775b$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, dest, destinationStride) {
    dest = dest ? dest : [];
    destinationStride = destinationStride ? destinationStride : 2;
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const x = flatCoordinates[j];
        const y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
        for(let k = 2; k < destinationStride; k++)dest[i++] = flatCoordinates[j + k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $437d3763a798775b$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, dest) {
    dest = dest ? dest : [];
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $437d3763a798775b$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, dest) {
    dest = dest ? dest : [];
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $437d3763a798775b$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, dest) {
    dest = dest ? dest : [];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}


/**
 * @typedef {'XY' | 'XYZ' | 'XYM' | 'XYZM'} GeometryLayout
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available.
 */ /**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, or `'Circle'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $e122192de230fc8c$var$tmpTransform = (0, $a684e03243281d90$export$185802fd694ee1f5)();
/** @type {import('../coordinate.js').Coordinate} */ const $e122192de230fc8c$var$tmpPoint = [
    NaN,
    NaN
];
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ class $e122192de230fc8c$var$Geometry extends (0, $32070d44509bac34$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = (0, $110ceb23457e07e7$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.extentRevision_ = -1;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryRevision = 0;
        /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} revision The geometry revision.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ this.simplifyTransformedInternal = (0, $1a39c7df251dabdd$export$ff83df6f9971435f)((revision, squaredTolerance, transform)=>{
            if (!transform) return this.getSimplifiedGeometry(squaredTolerance);
            const clone = this.clone();
            clone.applyTransform(transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, transform);
    }
    /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */ clone() {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        return this.closestPointXY(x, y, $e122192de230fc8c$var$tmpPoint, Number.MIN_VALUE) === 0;
    }
    /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */ getClosestPoint(point, closestPoint) {
        closestPoint = closestPoint ? closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    }
    /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */ intersectsCoordinate(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */ getExtent(extent) {
        if (this.extentRevision_ != this.getRevision()) {
            const extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) (0, $110ceb23457e07e7$export$3e2152b047719fa1)(extent);
            this.extentRevision_ = this.getRevision();
        }
        return (0, $110ceb23457e07e7$export$6a4fe494c558c238)(this.extent_, extent);
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */ simplify(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */ getType() {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */ applyTransform(transformFn) {
        (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */ intersectsExtent(extent) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {this} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */ transform(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ const sourceProj = (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(source);
        const transformFn = sourceProj.getUnits() == 'tile-pixels' ? function(inCoordinates, outCoordinates, stride) {
            const pixelExtent = sourceProj.getExtent();
            const projectedExtent = sourceProj.getWorldExtent();
            const scale = (0, $110ceb23457e07e7$export$c08559766941f856)(projectedExtent) / (0, $110ceb23457e07e7$export$c08559766941f856)(pixelExtent);
            (0, $a684e03243281d90$export$f672e0b6f7222cd7)($e122192de230fc8c$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            const transformed = (0, $437d3763a798775b$export$b92b2dedcfff79de)(inCoordinates, 0, inCoordinates.length, stride, $e122192de230fc8c$var$tmpTransform, outCoordinates);
            const projTransform = (0, $d447c151baf41c8c$export$fce0c6cfca85ed96)(sourceProj, destination);
            if (projTransform) return projTransform(transformed, transformed, stride);
            return transformed;
        } : (0, $d447c151baf41c8c$export$fce0c6cfca85ed96)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    }
}
var $e122192de230fc8c$export$2e2bcd8739ae039 = $e122192de230fc8c$var$Geometry;



/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ class $2d119a5aa713a216$var$SimpleGeometry extends (0, $e122192de230fc8c$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @protected
     * @type {import("./Geometry.js").GeometryLayout}
     */ this.layout = 'XY';
        /**
     * @protected
     * @type {number}
     */ this.stride = 2;
        /**
     * @protected
     * @type {Array<number>}
     */ this.flatCoordinates;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $110ceb23457e07e7$export$be0ab0bf96ca59ca)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */ getCoordinates() {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */ getFirstCoordinate() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getFlatCoordinates() {
        return this.flatCoordinates;
    }
    /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */ getLastCoordinate() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    }
    /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */ getLayout() {
        return this.layout;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        const simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
        // Simplification did not actually remove any coordinates.  We now know
        // that any calls to getSimplifiedGeometry with a squaredTolerance less
        // than or equal to the current squaredTolerance will also not have any
        // effect.  This allows us to short circuit simplification (saving CPU
        // cycles) and prevents the cache of simplified geometries from filling
        // up with useless identical copies of this geometry (saving memory).
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        return this;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride;
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */ setFlatCoordinates(layout, flatCoordinates) {
        this.stride = $2d119a5aa713a216$export$6af0c1b4a8549a43(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    }
    /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ setCoordinates(coordinates, layout) {
        (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */ setLayout(layout, coordinates, nesting) {
        let stride;
        if (layout) stride = $2d119a5aa713a216$export$6af0c1b4a8549a43(layout);
        else {
            for(let i = 0; i < nesting; ++i){
                if (coordinates.length === 0) {
                    this.layout = 'XY';
                    this.stride = 2;
                    return;
                }
                coordinates = /** @type {Array<unknown>} */ coordinates[0];
            }
            stride = coordinates.length;
            layout = $2d119a5aa713a216$export$61bb6938093db2c8(stride);
        }
        this.layout = layout;
        this.stride = stride;
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.layout.startsWith('XYZ') ? 3 : 2, this.stride);
            this.changed();
        }
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $437d3763a798775b$export$bb628a54ab399bc9)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (sy === undefined) sy = sx;
        if (!anchor) anchor = (0, $110ceb23457e07e7$export$c91255cadecfe081)(this.getExtent());
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $437d3763a798775b$export$dcdf75081b88279d)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $437d3763a798775b$export$d73ee8ef04f5226a)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    }
}
function $2d119a5aa713a216$export$61bb6938093db2c8(stride) {
    let layout;
    if (stride == 2) layout = 'XY';
    else if (stride == 3) layout = 'XYZ';
    else if (stride == 4) layout = 'XYZM';
    return /** @type {import("./Geometry.js").GeometryLayout} */ layout;
}
function $2d119a5aa713a216$export$6af0c1b4a8549a43(layout) {
    let stride;
    if (layout == 'XY') stride = 2;
    else if (layout == 'XYZ' || layout == 'XYM') stride = 3;
    else if (layout == 'XYZM') stride = 4;
    return /** @type {number} */ stride;
}
function $2d119a5aa713a216$export$a3767472617c7861(simpleGeometry, transform, dest) {
    const flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    const stride = simpleGeometry.getStride();
    return (0, $437d3763a798775b$export$b92b2dedcfff79de)(flatCoordinates, 0, flatCoordinates.length, stride, transform, dest);
}
var $2d119a5aa713a216$export$2e2bcd8739ae039 = $2d119a5aa713a216$var$SimpleGeometry;


/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $284a9b995eb47f84$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    let twiceArea = 0;
    const x0 = flatCoordinates[end - stride];
    const y0 = flatCoordinates[end - stride + 1];
    let dx1 = 0;
    let dy1 = 0;
    for(; offset < end; offset += stride){
        const dx2 = flatCoordinates[offset] - x0;
        const dy2 = flatCoordinates[offset + 1] - y0;
        twiceArea += dy1 * dx2 - dx1 * dy2;
        dx1 = dx2;
        dy1 = dy2;
    }
    return twiceArea / 2;
}
function $284a9b995eb47f84$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    let area = 0;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        area += $284a9b995eb47f84$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $284a9b995eb47f84$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    let area = 0;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        area += $284a9b995eb47f84$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}


/**
 * @module ol/geom/flat/closest
 */ 
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $51142fc8a680af11$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    const x1 = flatCoordinates[offset1];
    const y1 = flatCoordinates[offset1 + 1];
    const dx = flatCoordinates[offset2] - x1;
    const dy = flatCoordinates[offset2 + 1] - y1;
    let offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(let i = 0; i < stride; ++i)closestPoint[i] = (0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
    closestPoint.length = stride;
}
function $51142fc8a680af11$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        const squaredDelta = (0, $91ceb5420a5c8360$export$88e6ebb4fe54f538)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $51142fc8a680af11$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        max = $51142fc8a680af11$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $51142fc8a680af11$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        max = $51142fc8a680af11$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $51142fc8a680af11$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    if (offset == end) return minSquaredDistance;
    let i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $91ceb5420a5c8360$export$88e6ebb4fe54f538)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    let index = offset + stride;
    while(index < end){
        $51142fc8a680af11$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $91ceb5420a5c8360$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $51142fc8a680af11$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $91ceb5420a5c8360$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $51142fc8a680af11$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        minSquaredDistance = $51142fc8a680af11$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $51142fc8a680af11$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        minSquaredDistance = $51142fc8a680af11$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}


/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $46dd16ae2ee5c902$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(let i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $46dd16ae2ee5c902$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i){
        const coordinate = coordinates[i];
        for(let j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $46dd16ae2ee5c902$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, ends) {
    ends = ends ? ends : [];
    let i = 0;
    for(let j = 0, jj = coordinatess.length; j < jj; ++j){
        const end = $46dd16ae2ee5c902$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $46dd16ae2ee5c902$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, endss) {
    endss = endss ? endss : [];
    let i = 0;
    for(let j = 0, jj = coordinatesss.length; j < jj; ++j){
        const ends = $46dd16ae2ee5c902$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        if (ends.length === 0) ends[0] = offset;
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}


/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $2a6a9b7fa6b84967$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinates) {
    coordinates = coordinates !== undefined ? coordinates : [];
    let i = 0;
    for(let j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $2a6a9b7fa6b84967$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatess) {
    coordinatess = coordinatess !== undefined ? coordinatess : [];
    let i = 0;
    for(let j = 0, jj = ends.length; j < jj; ++j){
        const end = ends[j];
        coordinatess[i++] = $2a6a9b7fa6b84967$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $2a6a9b7fa6b84967$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, coordinatesss) {
    coordinatesss = coordinatesss !== undefined ? coordinatesss : [];
    let i = 0;
    for(let j = 0, jj = endss.length; j < jj; ++j){
        const ends = endss[j];
        coordinatesss[i++] = ends.length === 1 && ends[0] === offset ? [] : $2a6a9b7fa6b84967$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}


/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

function $91af87e7f153f420$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, simplifiedFlatCoordinates) {
    simplifiedFlatCoordinates = simplifiedFlatCoordinates !== undefined ? simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $91af87e7f153f420$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $91af87e7f153f420$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $91af87e7f153f420$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    const n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ const markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ const stack = [
        offset,
        end - stride
    ];
    let index = 0;
    while(stack.length > 0){
        const last = stack.pop();
        const first = stack.pop();
        let maxSquaredDistance = 0;
        const x1 = flatCoordinates[first];
        const y1 = flatCoordinates[first + 1];
        const x2 = flatCoordinates[last];
        const y2 = flatCoordinates[last + 1];
        for(let i = first + stride; i < last; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            const squaredDistance = (0, $91ceb5420a5c8360$export$251bb0a9cef172e6)(x, y, x1, y1, x2, y2);
            if (squaredDistance > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(let i = 0; i < n; ++i)if (markers[i]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride + 1];
    }
    return simplifiedOffset;
}
function $91af87e7f153f420$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $91af87e7f153f420$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $91af87e7f153f420$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $91af87e7f153f420$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $91af87e7f153f420$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    let x2 = x1;
    let y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $91ceb5420a5c8360$export$88e6ebb4fe54f538)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $91af87e7f153f420$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $91af87e7f153f420$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    let x1 = $91af87e7f153f420$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    let y1 = $91af87e7f153f420$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    let x2, y2;
    do {
        x2 = $91af87e7f153f420$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $91af87e7f153f420$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        const x3 = $91af87e7f153f420$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        const y3 = $91af87e7f153f420$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        const dx1 = x2 - x1;
        const dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        const dx2 = x3 - x1;
        const dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $91af87e7f153f420$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $91af87e7f153f420$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $91af87e7f153f420$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $91af87e7f153f420$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}


/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ class $65a0e98c50aee763$var$LinearRing extends (0, $2d119a5aa713a216$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   * @override
   */ clone() {
        return new $65a0e98c50aee763$var$LinearRing(this.flatCoordinates.slice(), this.layout);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $110ceb23457e07e7$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $51142fc8a680af11$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $51142fc8a680af11$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $284a9b995eb47f84$export$3c5e1905f889266e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $2a6a9b7fa6b84967$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $91af87e7f153f420$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $65a0e98c50aee763$var$LinearRing(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LinearRing';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return false;
    }
    /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $46dd16ae2ee5c902$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $65a0e98c50aee763$export$2e2bcd8739ae039 = $65a0e98c50aee763$var$LinearRing;


/**
 * @module ol/geom/Point
 */ 



/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ class $6d7bc2de9d52ca58$var$Point extends (0, $2d119a5aa713a216$export$2e2bcd8739ae039) {
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        this.setCoordinates(coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   * @override
   */ clone() {
        const point = new $6d7bc2de9d52ca58$var$Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const squaredDistance = (0, $91ceb5420a5c8360$export$88e6ebb4fe54f538)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            const stride = this.stride;
            for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return this.flatCoordinates.slice();
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $110ceb23457e07e7$export$4838bf78d04a9440)(this.flatCoordinates, extent);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Point';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $110ceb23457e07e7$export$805bdfd6d6690e97)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    }
    /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $46dd16ae2ee5c902$export$60815ead40ec79ab)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $6d7bc2de9d52ca58$export$2e2bcd8739ae039 = $6d7bc2de9d52ca58$var$Point;





/**
 * @module ol/geom/flat/contains
 */ 
function $c26bd518b1a628ec$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    const outside = (0, $110ceb23457e07e7$export$f9ed8a3d123a08e2)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$c26bd518b1a628ec$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $c26bd518b1a628ec$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // https://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    let wn = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $c26bd518b1a628ec$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$c26bd518b1a628ec$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(let i = 1, ii = ends.length; i < ii; ++i){
        if ($c26bd518b1a628ec$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $c26bd518b1a628ec$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($c26bd518b1a628ec$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}




/**
 * @module ol/geom/flat/interiorpoint
 */ 

function $96ebab432ff2aabb$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, dest) {
    let i, ii, x, x1, x2, y1, y2;
    const y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ const intersections = [];
    // Calculate intersections with the horizontal line
    for(let r = 0, rr = ends.length; r < rr; ++r){
        const end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    let pointX = NaN;
    let maxSegmentLength = -Infinity;
    intersections.sort((0, $9d07dd9052c3de0c$export$fcb633242ef15540));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        const segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $c26bd518b1a628ec$export$ae868c0f6acc3355)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (dest) {
        dest.push(pointX, y, maxSegmentLength);
        return dest;
    }
    return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $96ebab432ff2aabb$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    /** @type {Array<number>} */ let interiorPoints = [];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        interiorPoints = $96ebab432ff2aabb$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}


/**
 * @module ol/geom/flat/intersectsextent
 */ 

/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ function $ddb0e9c06f77a946$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback) {
    let ret;
    offset += stride;
    for(; offset < end; offset += stride){
        ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));
        if (ret) return ret;
    }
    return false;
}
function $ddb0e9c06f77a946$export$3f024338373820dc(segment1, segment2) {
    const [a, b] = segment1;
    const [c, d] = segment2;
    const t = ((a[0] - c[0]) * (c[1] - d[1]) - (a[1] - c[1]) * (c[0] - d[0])) / ((a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]));
    const u = ((a[0] - c[0]) * (a[1] - b[1]) - (a[1] - c[1]) * (a[0] - b[0])) / ((a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]));
    // Check if lines actually intersect
    if (0 <= t && t <= 1 && 0 <= u && u <= 1) return [
        a[0] + t * (b[0] - a[0]),
        a[1] + t * (b[1] - a[1])
    ];
    return undefined;
}


function $fff493cc9a5ff53b$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent, coordinatesExtent) {
    coordinatesExtent = coordinatesExtent ?? (0, $110ceb23457e07e7$export$30570204156ffd18)((0, $110ceb23457e07e7$export$fe201bb3bbe031e9)(), flatCoordinates, offset, end, stride);
    if (!(0, $110ceb23457e07e7$export$7b0a31e10bbff018)(extent, coordinatesExtent)) return false;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2] || coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $ddb0e9c06f77a946$export$4b80e395e36b5a56)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $110ceb23457e07e7$export$a6a5a7a461419425)(extent, point1, point2);
    });
}
function $fff493cc9a5ff53b$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        if ($fff493cc9a5ff53b$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $fff493cc9a5ff53b$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($fff493cc9a5ff53b$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $c26bd518b1a628ec$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $c26bd518b1a628ec$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $c26bd518b1a628ec$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $c26bd518b1a628ec$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $fff493cc9a5ff53b$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$fff493cc9a5ff53b$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(let i = 1, ii = ends.length; i < ii; ++i)if ((0, $c26bd518b1a628ec$export$cedabedc7ac0e138)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$fff493cc9a5ff53b$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $fff493cc9a5ff53b$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($fff493cc9a5ff53b$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


/**
 * @module ol/geom/flat/orient
 */ /**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $2a797b5a1ca725c7$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(let i = 0; i < stride; ++i){
            const tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}


function $5639f71071079d61$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    let edge = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function $5639f71071079d61$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $5639f71071079d61$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $5639f71071079d61$export$a1d138f4bd85f4b4(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if (!$5639f71071079d61$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function $5639f71071079d61$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $5639f71071079d61$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        const reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $2a797b5a1ca725c7$export$741858880c96b18c)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $5639f71071079d61$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i)offset = $5639f71071079d61$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, right);
    return offset;
}
function $5639f71071079d61$export$cb72ae403d6e78e6(flatCoordinates, ends) {
    const endss = [];
    let offset = 0;
    let prevEndIndex = 0;
    let startOrientation;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        // classifies an array of rings into polygons with outer rings and holes
        const orientation = $5639f71071079d61$export$318f2842ed17e094(flatCoordinates, offset, end, 2);
        if (startOrientation === undefined) startOrientation = orientation;
        if (orientation === startOrientation) endss.push(ends.slice(prevEndIndex, i + 1));
        else {
            if (endss.length === 0) continue;
            endss[endss.length - 1].push(ends[prevEndIndex]);
        }
        prevEndIndex = i + 1;
        offset = end;
    }
    return endss;
}



/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ class $9549b42604551fb5$var$Polygon extends (0, $2d119a5aa713a216$export$2e2bcd8739ae039) {
    /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Ends (for internal use with flat coordinates).
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointRevision_ = -1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatInteriorPoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
    }
    /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */ appendLinearRing(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, $9d07dd9052c3de0c$export$8b58be045bf06082)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   * @override
   */ clone() {
        const polygon = new $9549b42604551fb5$var$Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $110ceb23457e07e7$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $51142fc8a680af11$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $51142fc8a680af11$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $c26bd518b1a628ec$export$ae868c0f6acc3355)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    }
    /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $284a9b995eb47f84$export$7a8ee541dfdf2ed5)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $5639f71071079d61$export$b71b604ddfc778c7)(flatCoordinates, 0, this.ends_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $2a6a9b7fa6b84967$export$cbb9596fc0f40db2)(flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * @return {Array<number>} Interior point.
   */ getFlatInteriorPoint() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            const flatCenter = (0, $110ceb23457e07e7$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoint_ = (0, $96ebab432ff2aabb$export$50e3b25928a5e892)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return /** @type {import("../coordinate.js").Coordinate} */ this.flatInteriorPoint_;
    }
    /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoint() {
        return new (0, $6d7bc2de9d52ca58$export$2e2bcd8739ae039)(this.getFlatInteriorPoint(), 'XYM');
    }
    /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */ getLinearRingCount() {
        return this.ends_.length;
    }
    /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */ getLinearRing(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $65a0e98c50aee763$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */ getLinearRings() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const linearRings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const linearRing = new (0, $65a0e98c50aee763$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $5639f71071079d61$export$f27cd06e85f4ba28)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $5639f71071079d61$export$b71b604ddfc778c7)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $91af87e7f153f420$export$60a9904b67f8d51b)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $9549b42604551fb5$var$Polygon(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Polygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $fff493cc9a5ff53b$export$76dcd8f8f83b6ddb)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $46dd16ae2ee5c902$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $9549b42604551fb5$export$2e2bcd8739ae039 = $9549b42604551fb5$var$Polygon;
function $9549b42604551fb5$export$f99d756c6d81ae3f(center, radius, n, sphereRadius) {
    n = n ? n : 32;
    /** @type {Array<number>} */ const flatCoordinates = [];
    for(let i = 0; i < n; ++i)(0, $9d07dd9052c3de0c$export$8b58be045bf06082)(flatCoordinates, (0, $9ab761a4e8878546$export$cc800923e997bb8)(center, radius, 2 * Math.PI * i / n, sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $9549b42604551fb5$var$Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function $9549b42604551fb5$export$c16b671815801c75(extent) {
    if ((0, $110ceb23457e07e7$export$dd1bc94b04021eeb)(extent)) throw new Error('Cannot create polygon from empty extent');
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $9549b42604551fb5$var$Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function $9549b42604551fb5$export$2451009d645fb8c2(circle, sides, angle) {
    sides = sides ? sides : 32;
    const stride = circle.getStride();
    const layout = circle.getLayout();
    const center = circle.getCenter();
    const arrayLength = stride * (sides + 1);
    const flatCoordinates = new Array(arrayLength);
    for(let i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(let j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    const ends = [
        flatCoordinates.length
    ];
    const polygon = new $9549b42604551fb5$var$Polygon(flatCoordinates, layout, ends);
    $9549b42604551fb5$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), angle);
    return polygon;
}
function $9549b42604551fb5$export$87d6a1539a56e47f(polygon, center, radius, angle) {
    const flatCoordinates = polygon.getFlatCoordinates();
    const stride = polygon.getStride();
    const sides = flatCoordinates.length / stride - 1;
    const startAngle = angle ? angle : 0;
    for(let i = 0; i <= sides; ++i){
        const offset = i * stride;
        const angle = startAngle + (0, $91ceb5420a5c8360$export$ba467bec01d66def)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}




/**
 * @module ol/resolutionconstraint
 */ 


/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function $ab6ff539591a2c7c$var$getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    const xResolution = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(maxExtent) / viewportSize[0];
    const yResolution = (0, $110ceb23457e07e7$export$c08559766941f856)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function $ab6ff539591a2c7c$var$getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    let result = Math.min(resolution, maxResolution);
    const ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(result, minResolution / 2, maxResolution * 2);
}
function $ab6ff539591a2c7c$export$d65a517690fc4385(resolutions, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const maxResolution = resolutions[0];
            const minResolution = resolutions[resolutions.length - 1];
            const cappedMaxRes = maxExtent ? $ab6ff539591a2c7c$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $ab6ff539591a2c7c$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const capped = Math.min(cappedMaxRes, resolution);
            const z = Math.floor((0, $9d07dd9052c3de0c$export$8a3786cc03fdb777)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        }
        return undefined;
    });
}
function $ab6ff539591a2c7c$export$22ac0f6b219de91a(power, maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    minResolution = minResolution !== undefined ? minResolution : 0;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $ab6ff539591a2c7c$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $ab6ff539591a2c7c$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const tolerance = 1e-9;
            const minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            const offset = -direction * (0.5 - tolerance) + 0.5;
            const capped = Math.min(cappedMaxRes, resolution);
            const cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            const zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            const newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(newResolution, minResolution, cappedMaxRes);
        }
        return undefined;
    });
}
function $ab6ff539591a2c7c$export$1c4e6da9b4b066fe(maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $ab6ff539591a2c7c$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            if (!smooth || !isMoving) return (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
            return $ab6ff539591a2c7c$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        }
        return undefined;
    });
}


/**
 * @module ol/rotationconstraint
 */ 
function $22904180715f9e42$export$e20fbacbb41798b(rotation) {
    if (rotation !== undefined) return 0;
    return undefined;
}
function $22904180715f9e42$export$f883a24d5edde77c(rotation) {
    if (rotation !== undefined) return rotation;
    return undefined;
}
function $22904180715f9e42$export$9ba78806de831083(n) {
    const theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        }
        return undefined;
    });
}
function $22904180715f9e42$export$17a6e6f3448b17e8(tolerance) {
    const t = tolerance === undefined ? (0, $91ceb5420a5c8360$export$cba01ba138429a1d)(5) : tolerance;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving || rotation === undefined) return rotation;
        if (Math.abs(rotation) <= t) return 0;
        return rotation;
    });
}


/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ const $70f6cba5b5336314$export$e98a216cdcc847dc = 42;
const $70f6cba5b5336314$export$6b8cb5cd370bd90c = 256;


/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to
 * fit the extent into. Defaults to the size of the map the view is associated with.
 * If no map or multiple maps are connected to the view, provide the desired box size
 * (e.g. `map.getSize()`).
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center (in view projection coordinates).
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {import("./coordinate.js").Coordinate} [nextCenter] The next center during an animation series.
 * @property {number} [nextResolution] The next resolution during an animation series.
 * @property {number} [nextRotation] The next rotation during an animation series.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */ /**
 * Like {@link import("./Map.js").FrameState}, but just `viewState` and `extent`.
 * @typedef {Object} ViewStateLayerStateExtent
 * @property {State} viewState View state.
 * @property {import("./extent.js").Extent} extent Extent (in user projection coordinates).
 * @property {Array<import("./layer/Layer.js").State>} [layerStatesArray] Layer states.
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ const $6d96d03cab85bf06$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<ViewObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */ /**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Web Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 */ class $6d96d03cab85bf06$var$View extends (0, $32070d44509bac34$export$2e2bcd8739ae039) {
    /**
   * @param {ViewOptions} [options] View options.
   */ constructor(options){
        super();
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ViewOnSignature<void>}
     */ this.un;
        options = Object.assign({}, options);
        /**
     * @private
     * @type {Array<number>}
     */ this.hints_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {Array<Array<Animation>>}
     */ this.animations_ = [];
        /**
     * @private
     * @type {number|undefined}
     */ this.updateAnimationKey_;
        /**
     * @private
     * @const
     * @type {import("./proj/Projection.js").default}
     */ this.projection_ = (0, $d447c151baf41c8c$export$549167224996a0fb)(options.projection, 'EPSG:3857');
        /**
     * @private
     * @type {import("./size.js").Size}
     */ this.viewportSize_ = [
            100,
            100
        ];
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.targetCenter_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetResolution_;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate}
     */ this.nextCenter_ = null;
        /**
     * @private
     * @type {number}
     */ this.nextResolution_;
        /**
     * @private
     * @type {number}
     */ this.nextRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.cancelAnchor_ = undefined;
        if (options.projection) (0, $d447c151baf41c8c$export$ed949affbc7c4223)();
        if (options.center) options.center = (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(options.center, this.projection_);
        if (options.extent) options.extent = (0, $d447c151baf41c8c$export$494be3a3a25689ca)(options.extent, this.projection_);
        this.applyOptions_(options);
    }
    /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */ applyOptions_(options) {
        const properties = Object.assign({}, options);
        for(const key in 0, $2058179c7d78e530$export$2e2bcd8739ae039)delete properties[key];
        this.setProperties(properties, true);
        const resolutionConstraintInfo = $6d96d03cab85bf06$export$c68d65f9148da196(options);
        /**
     * @private
     * @type {number}
     */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
     * @private
     * @type {number}
     */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
     * @private
     * @type {number}
     */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
     * @private
     * @type {Array<number>|undefined}
     */ this.resolutions_ = options.resolutions;
        /**
     * @type {Array<number>|undefined}
     * @private
     */ this.padding_ = options.padding;
        /**
     * @private
     * @type {number}
     */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        const centerConstraint = $6d96d03cab85bf06$export$964345001ee9ac52(options);
        const resolutionConstraint = resolutionConstraintInfo.constraint;
        const rotationConstraint = $6d96d03cab85bf06$export$4eeaa08dd550e3c0(options);
        /**
     * @private
     * @type {Constraints}
     */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) this.setResolution(options.resolution);
        else if (options.zoom !== undefined) this.setZoom(options.zoom);
    }
    /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */ get padding() {
        return this.padding_;
    }
    set padding(padding) {
        let oldPadding = this.padding_;
        this.padding_ = padding;
        const center = this.getCenterInternal();
        if (center) {
            const newPadding = padding || [
                0,
                0,
                0,
                0
            ];
            oldPadding = oldPadding || [
                0,
                0,
                0,
                0
            ];
            const resolution = this.getResolution();
            const offsetX = resolution / 2 * (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
            const offsetY = resolution / 2 * (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
            this.setCenterInternal([
                center[0] + offsetX,
                center[1] - offsetY
            ]);
        }
    }
    /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */ getUpdatedOptions_(newOptions) {
        const options = this.getProperties();
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return Object.assign({}, options, newOptions);
    }
    /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */ animate(var_args) {
        if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
        const args = new Array(arguments.length);
        for(let i = 0; i < args.length; ++i){
            let options = arguments[i];
            if (options.center) {
                options = Object.assign({}, options);
                options.center = (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = Object.assign({}, options);
                options.anchor = (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    }
    /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */ animateInternal(var_args) {
        let animationCount = arguments.length;
        let callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === 'function') {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        let i = 0;
        for(; i < animationCount && !this.isDef(); ++i){
            // if view properties are not yet set, shortcut to the final state
            const state = arguments[i];
            if (state.center) this.setCenterInternal(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            else if (state.resolution) this.setResolution(state.resolution);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
        }
        if (i === animationCount) {
            if (callback) $6d96d03cab85bf06$var$animationCallback(callback, true);
            return;
        }
        let start = Date.now();
        let center = this.targetCenter_.slice();
        let resolution = this.targetResolution_;
        let rotation = this.targetRotation_;
        const series = [];
        for(; i < animationCount; ++i){
            const options = /** @type {AnimationOptions} */ arguments[i];
            const animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, $5354ee427f82b926$export$9b47139b511b56e4),
                callback: callback
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                const delta = (0, $91ceb5420a5c8360$export$ba467bec01d66def)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if ($6d96d03cab85bf06$export$ee75376562060184(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, $73b497f172b1a497$export$2e2bcd8739ae039).ANIMATING, 1);
        this.updateAnimations_();
    }
    /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */ getAnimating() {
        return this.hints_[(0, $73b497f172b1a497$export$2e2bcd8739ae039).ANIMATING] > 0;
    }
    /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */ getInteracting() {
        return this.hints_[(0, $73b497f172b1a497$export$2e2bcd8739ae039).INTERACTING] > 0;
    }
    /**
   * Cancel any ongoing animations.
   * @api
   */ cancelAnimations() {
        this.setHint((0, $73b497f172b1a497$export$2e2bcd8739ae039).ANIMATING, -this.hints_[(0, $73b497f172b1a497$export$2e2bcd8739ae039).ANIMATING]);
        let anchor;
        for(let i = 0, ii = this.animations_.length; i < ii; ++i){
            const series = this.animations_[i];
            if (series[0].callback) $6d96d03cab85bf06$var$animationCallback(series[0].callback, false);
            if (!anchor) for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (!animation.complete) {
                    anchor = animation.anchor;
                    break;
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
        this.nextCenter_ = null;
        this.nextResolution_ = NaN;
        this.nextRotation_ = NaN;
    }
    /**
   * Update all animations.
   */ updateAnimations_() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        const now = Date.now();
        let more = false;
        for(let i = this.animations_.length - 1; i >= 0; --i){
            const series = this.animations_[i];
            let seriesComplete = true;
            for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (animation.complete) continue;
                const elapsed = now - animation.start;
                let fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                const progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    const x0 = animation.sourceCenter[0];
                    const y0 = animation.sourceCenter[1];
                    const x1 = animation.targetCenter[0];
                    const y1 = animation.targetCenter[1];
                    this.nextCenter_ = animation.targetCenter;
                    const x = x0 + progress * (x1 - x0);
                    const y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [
                        x,
                        y
                    ];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    const resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        const size = this.getViewportSize_(this.getRotation());
                        const constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.nextResolution_ = animation.targetResolution;
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    const rotation = progress === 1 ? (0, $91ceb5420a5c8360$export$ba467bec01d66def)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        const constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.nextRotation_ = animation.targetRotation;
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, $73b497f172b1a497$export$2e2bcd8739ae039).ANIMATING, -1);
                this.nextCenter_ = null;
                this.nextResolution_ = NaN;
                this.nextRotation_ = NaN;
                const callback = series[0].callback;
                if (callback) $6d96d03cab85bf06$var$animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
    }
    /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */ calculateCenterRotate(rotation, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, $188aedb30bca6ae8$export$bb628a54ab399bc9)(center, rotation - this.getRotation());
            (0, $188aedb30bca6ae8$export$e16d8520af44a096)(center, anchor);
        }
        return center;
    }
    /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */ calculateCenterZoom(resolution, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        const currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            const x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            const y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    }
    /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */ getViewportSize_(rotation) {
        const size = this.viewportSize_;
        if (rotation) {
            const w = size[0];
            const h = size[1];
            return [
                Math.abs(w * Math.cos(rotation)) + Math.abs(h * Math.sin(rotation)),
                Math.abs(w * Math.sin(rotation)) + Math.abs(h * Math.cos(rotation))
            ];
        }
        return size;
    }
    /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */ setViewportSize(size) {
        this.viewportSize_ = Array.isArray(size) ? size.slice() : [
            100,
            100
        ];
        if (!this.getAnimating()) this.resolveConstraints(0);
    }
    /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */ getCenter() {
        const center = this.getCenterInternal();
        if (!center) return center;
        return (0, $d447c151baf41c8c$export$698f563af1ba02a5)(center, this.getProjection());
    }
    /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */ getCenterInternal() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $2058179c7d78e530$export$2e2bcd8739ae039).CENTER);
    }
    /**
   * @return {Constraints} Constraints.
   */ getConstraints() {
        return this.constraints_;
    }
    /**
   * @return {boolean} Resolution constraint is set
   */ getConstrainResolution() {
        return this.get('constrainResolution');
    }
    /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */ getHints(hints) {
        if (hints !== undefined) {
            hints[0] = this.hints_[0];
            hints[1] = this.hints_[1];
            return hints;
        }
        return this.hints_.slice();
    }
    /**
   * Calculate the extent for the current view state and the passed box size.
   * @param {import("./size.js").Size} [size] The pixel dimensions of the box
   * into which the calculated extent should fit. Defaults to the size of the
   * map the view is associated with.
   * If no map or multiple maps are connected to the view, provide the desired
   * box size (e.g. `map.getSize()`).
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */ calculateExtent(size) {
        const extent = this.calculateExtentInternal(size);
        return (0, $d447c151baf41c8c$export$96bfd09e2cffb006)(extent, this.getProjection());
    }
    /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */ calculateExtentInternal(size) {
        size = size || this.getViewportSizeMinusPadding_();
        const center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(center, 'The view center is not defined');
        const resolution = /** @type {!number} */ this.getResolution();
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(resolution !== undefined, 'The view resolution is not defined');
        const rotation = /** @type {!number} */ this.getRotation();
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(rotation !== undefined, 'The view rotation is not defined');
        return (0, $110ceb23457e07e7$export$13ba650faf8308)(center, resolution, rotation, size);
    }
    /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */ getMaxResolution() {
        return this.maxResolution_;
    }
    /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */ getMinResolution() {
        return this.minResolution_;
    }
    /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    }
    /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */ setMaxZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    }
    /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    }
    /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */ setMinZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    }
    /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */ setConstrainResolution(enabled) {
        this.applyOptions_(this.getUpdatedOptions_({
            constrainResolution: enabled
        }));
    }
    /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */ getProjection() {
        return this.projection_;
    }
    /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */ getResolution() {
        return /** @type {number|undefined} */ this.get((0, $2058179c7d78e530$export$2e2bcd8739ae039).RESOLUTION);
    }
    /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */ getResolutionForExtent(extent, size) {
        return this.getResolutionForExtentInternal((0, $d447c151baf41c8c$export$494be3a3a25689ca)(extent, this.getProjection()), size);
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */ getResolutionForExtentInternal(extent, size) {
        size = size || this.getViewportSizeMinusPadding_();
        const xResolution = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(extent) / size[0];
        const yResolution = (0, $110ceb23457e07e7$export$c08559766941f856)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    }
    /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */ getResolutionForValueFunction(power) {
        power = power || 2;
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
       * @param {number} value Value.
       * @return {number} Resolution.
       */ function(value) {
            const resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    }
    /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */ getRotation() {
        return /** @type {number} */ this.get((0, $2058179c7d78e530$export$2e2bcd8739ae039).ROTATION);
    }
    /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */ getValueForResolutionFunction(power) {
        const logPower = Math.log(power || 2);
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / logPower;
        return(/**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */ function(resolution) {
            const value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    }
    /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */ getViewportSizeMinusPadding_(rotation) {
        let size = this.getViewportSize_(rotation);
        const padding = this.padding_;
        if (padding) size = [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ];
        return size;
    }
    /**
   * @return {State} View state.
   */ getState() {
        const projection = this.getProjection();
        const resolution = this.getResolution();
        const rotation = this.getRotation();
        let center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        const padding = this.padding_;
        if (padding) {
            const reducedSize = this.getViewportSizeMinusPadding_();
            center = $6d96d03cab85bf06$var$calculateCenterOn(center, this.getViewportSize_(), [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            nextCenter: this.nextCenter_,
            nextResolution: this.nextResolution_,
            nextRotation: this.nextRotation_,
            rotation: rotation,
            zoom: this.getZoom()
        };
    }
    /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */ getViewStateAndExtent() {
        return {
            viewState: this.getState(),
            extent: this.calculateExtent()
        };
    }
    /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */ getZoom() {
        let zoom;
        const resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    }
    /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */ getZoomForResolution(resolution) {
        let offset = this.minZoom_ || 0;
        let max, zoomFactor;
        if (this.resolutions_) {
            const nearest = (0, $9d07dd9052c3de0c$export$8a3786cc03fdb777)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    }
    /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */ getResolutionForZoom(zoom) {
        if (this.resolutions_?.length) {
            if (this.resolutions_.length === 1) return this.resolutions_[0];
            const baseLevel = (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(Math.floor(zoom), 0, this.resolutions_.length - 2);
            const zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(zoom - baseLevel, 0, 1));
        }
        return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
    }
    /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */ fit(geometryOrExtent, options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */ let geometry;
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === 'function', 'Invalid extent or geometry provided as `geometry`');
        if (Array.isArray(geometryOrExtent)) {
            (0, $4b57691230be0bd5$export$a7a9523472993e97)(!(0, $110ceb23457e07e7$export$dd1bc94b04021eeb)(geometryOrExtent), 'Cannot fit empty extent provided as `geometry`');
            const extent = (0, $d447c151baf41c8c$export$494be3a3a25689ca)(geometryOrExtent, this.getProjection());
            geometry = (0, $9549b42604551fb5$export$c16b671815801c75)(extent);
        } else if (geometryOrExtent.getType() === 'Circle') {
            const extent = (0, $d447c151baf41c8c$export$494be3a3a25689ca)(geometryOrExtent.getExtent(), this.getProjection());
            geometry = (0, $9549b42604551fb5$export$c16b671815801c75)(extent);
            geometry.rotate(this.getRotation(), (0, $110ceb23457e07e7$export$c91255cadecfe081)(extent));
        } else {
            const userProjection = (0, $d447c151baf41c8c$export$3973b77d5f6f2790)();
            if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
            else geometry = geometryOrExtent;
        }
        this.fitInternal(geometry, options);
    }
    /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent").Extent} The rotated extent for the geometry.
   */ rotatedExtentForGeometry(geometry) {
        const rotation = this.getRotation();
        const cosAngle = Math.cos(rotation);
        const sinAngle = Math.sin(-rotation);
        const coords = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        let minRotX = Infinity;
        let minRotY = Infinity;
        let maxRotX = -Infinity;
        let maxRotY = -Infinity;
        for(let i = 0, ii = coords.length; i < ii; i += stride){
            const rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            const rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        return [
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ];
    }
    /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */ fitInternal(geometry, options) {
        options = options || {};
        let size = options.size;
        if (!size) size = this.getViewportSizeMinusPadding_();
        const padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        const nearest = options.nearest !== undefined ? options.nearest : false;
        let minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
        else minResolution = 0;
        const rotatedExtent = this.rotatedExtentForGeometry(geometry);
        // calculate resolution
        let resolution = this.getResolutionForExtentInternal(rotatedExtent, [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        const rotation = this.getRotation();
        const sinAngle = Math.sin(rotation);
        const cosAngle = Math.cos(rotation);
        const centerRot = (0, $110ceb23457e07e7$export$c91255cadecfe081)(rotatedExtent);
        centerRot[0] += (padding[1] - padding[3]) / 2 * resolution;
        centerRot[1] += (padding[0] - padding[2]) / 2 * resolution;
        const centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
        const centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
        const center = this.getConstrainedCenter([
            centerX,
            centerY
        ], resolution);
        const callback = options.callback ? options.callback : (0, $1a39c7df251dabdd$export$1cd1943b3a73bbe8);
        if (options.duration !== undefined) this.animateInternal({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            $6d96d03cab85bf06$var$animationCallback(callback, true);
        }
    }
    /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */ centerOn(coordinate, size, position) {
        this.centerOnInternal((0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(coordinate, this.getProjection()), size, position);
    }
    /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */ centerOnInternal(coordinate, size, position) {
        this.setCenterInternal($6d96d03cab85bf06$var$calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    }
    /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */ calculateCenterShift(center, resolution, rotation, size) {
        let centerShift;
        const padding = this.padding_;
        if (padding && center) {
            const reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            const shiftedCenter = $6d96d03cab85bf06$var$calculateCenterOn(center, size, [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1]
            ];
        }
        return centerShift;
    }
    /**
   * @return {boolean} Is defined.
   */ isDef() {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */ adjustCenter(deltaCoordinates) {
        const center = (0, $d447c151baf41c8c$export$698f563af1ba02a5)(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */ adjustCenterInternal(deltaCoordinates) {
        const center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustResolution(ratio, anchor) {
        anchor = anchor && (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ adjustResolutionInternal(ratio, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const size = this.getViewportSize_(this.getRotation());
        const newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, anchor);
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    }
    /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustZoom(delta, anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), anchor);
    }
    /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */ adjustRotation(delta, anchor) {
        if (anchor) anchor = (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustRotationInternal(delta, anchor);
    }
    /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */ adjustRotationInternal(delta, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, anchor);
        this.targetRotation_ += delta;
        this.applyTargetState_();
    }
    /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */ setCenter(center) {
        this.setCenterInternal(center ? (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(center, this.getProjection()) : center);
    }
    /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */ setCenterInternal(center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    }
    /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */ setHint(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    }
    /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */ setResolution(resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    }
    /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */ setRotation(rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    }
    /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */ setZoom(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    }
    /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */ applyTargetState_(doNotCancelAnims, forceMoving) {
        const isMoving = this.getAnimating() || this.getInteracting() || forceMoving;
        // compute rotation
        const newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get((0, $2058179c7d78e530$export$2e2bcd8739ae039).ROTATION) !== newRotation) this.set((0, $2058179c7d78e530$export$2e2bcd8739ae039).ROTATION, newRotation);
        if (this.get((0, $2058179c7d78e530$export$2e2bcd8739ae039).RESOLUTION) !== newResolution) {
            this.set((0, $2058179c7d78e530$export$2e2bcd8739ae039).RESOLUTION, newResolution);
            this.set('zoom', this.getZoom(), true);
        }
        if (!newCenter || !this.get((0, $2058179c7d78e530$export$2e2bcd8739ae039).CENTER) || !(0, $188aedb30bca6ae8$export$e9bab7fafb253603)(this.get((0, $2058179c7d78e530$export$2e2bcd8739ae039).CENTER), newCenter)) this.set((0, $2058179c7d78e530$export$2e2bcd8739ae039).CENTER, newCenter);
        if (this.getAnimating() && !doNotCancelAnims) this.cancelAnimations();
        this.cancelAnchor_ = undefined;
    }
    /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ resolveConstraints(duration, resolutionDirection, anchor) {
        duration = duration !== undefined ? duration : 200;
        const direction = resolutionDirection || 0;
        const newRotation = this.constraints_.rotation(this.targetRotation_);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        anchor = anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, $188aedb30bca6ae8$export$e9bab7fafb253603)(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) this.cancelAnimations();
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: (0, $5354ee427f82b926$export$57636bb43b1ccbb0),
                anchor: anchor
            });
        }
    }
    /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */ beginInteraction() {
        this.resolveConstraints(0);
        this.setHint((0, $73b497f172b1a497$export$2e2bcd8739ae039).INTERACTING, 1);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ endInteraction(duration, resolutionDirection, anchor) {
        anchor = anchor && (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.endInteractionInternal(duration, resolutionDirection, anchor);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ endInteractionInternal(duration, resolutionDirection, anchor) {
        if (!this.getInteracting()) return;
        this.setHint((0, $73b497f172b1a497$export$2e2bcd8739ae039).INTERACTING, -1);
        this.resolveConstraints(duration, resolutionDirection, anchor);
    }
    /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */ getConstrainedCenter(targetCenter, targetResolution) {
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, targetResolution || this.getResolution(), size);
    }
    /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */ getConstrainedZoom(targetZoom, direction) {
        const targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, direction));
    }
    /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */ getConstrainedResolution(targetResolution, direction) {
        direction = direction || 0;
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    }
}
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $6d96d03cab85bf06$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $6d96d03cab85bf06$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) {
        const smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, $6ceef04f6bff0869$export$c2f0af2c946f6897)(options.extent, options.constrainOnlyCenter, smooth);
    }
    const projection = (0, $d447c151baf41c8c$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    if (options.multiWorld !== true && projection.isGlobal()) {
        const extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, $6ceef04f6bff0869$export$c2f0af2c946f6897)(extent, false, false);
    }
    return 0, $6ceef04f6bff0869$export$f883a24d5edde77c;
}
function $6d96d03cab85bf06$export$c68d65f9148da196(options) {
    let resolutionConstraint;
    let maxResolution;
    let minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    const defaultMaxZoom = 28;
    const defaultZoomFactor = 2;
    let minZoom = options.minZoom !== undefined ? options.minZoom : $6d96d03cab85bf06$var$DEFAULT_MIN_ZOOM;
    let maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    const zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    const multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    const smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    const showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    const projection = (0, $d447c151baf41c8c$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    const projExtent = projection.getExtent();
    let constrainOnlyCenter = options.constrainOnlyCenter;
    let extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        const resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, $ab6ff539591a2c7c$export$d65a517690fc4385)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $ab6ff539591a2c7c$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        const size = !projExtent ? 360 * (0, $66a0959185f94b5b$export$1482081eec883108).degrees / projection.getMetersPerUnit() : Math.max((0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(projExtent), (0, $110ceb23457e07e7$export$c08559766941f856)(projExtent));
        const defaultMaxResolution = size / (0, $70f6cba5b5336314$export$6b8cb5cd370bd90c) / Math.pow(defaultZoomFactor, $6d96d03cab85bf06$var$DEFAULT_MIN_ZOOM);
        const defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $6d96d03cab85bf06$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, $ab6ff539591a2c7c$export$22ac0f6b219de91a)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $ab6ff539591a2c7c$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $6d96d03cab85bf06$export$4eeaa08dd550e3c0(options) {
    const enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        const constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $22904180715f9e42$export$17a6e6f3448b17e8)();
        if (constrainRotation === false) return 0, $22904180715f9e42$export$f883a24d5edde77c;
        if (typeof constrainRotation === 'number') return (0, $22904180715f9e42$export$9ba78806de831083)(constrainRotation);
        return 0, $22904180715f9e42$export$f883a24d5edde77c;
    }
    return 0, $22904180715f9e42$export$e20fbacbb41798b;
}
function $6d96d03cab85bf06$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $188aedb30bca6ae8$export$e9bab7fafb253603)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function $6d96d03cab85bf06$var$calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    const cosAngle = Math.cos(-rotation);
    let sinAngle = Math.sin(-rotation);
    let rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    let rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    const centerX = rotX * cosAngle - rotY * sinAngle;
    const centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
var $6d96d03cab85bf06$export$2e2bcd8739ae039 = $6d96d03cab85bf06$var$View;






/**
 * @module ol/control/defaults
 */ 
/**
 * @module ol/control/Attribution
 */ 
/**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ const $499ab6056ba431ad$export$981241db82723ce2 = 'ol-hidden';
const $499ab6056ba431ad$export$99b49471b0394319 = 'ol-selectable';
const $499ab6056ba431ad$export$1afde3d6e16a7b29 = 'ol-unselectable';
const $499ab6056ba431ad$export$68eede0dd8c6c1da = 'ol-unsupported';
const $499ab6056ba431ad$export$4d4f8be70b656192 = 'ol-control';
const $499ab6056ba431ad$export$e16017ac68d14492 = 'ol-collapsed';
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ const $499ab6056ba431ad$var$fontRegEx = new RegExp([
    '^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)',
    '(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?',
    '(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))',
    '(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))',
    '?\\s*([-,\\"\\\'\\sa-z0-9]+?)\\s*$'
].join(''), 'i');
/** @type {Array<'style'|'variant'|'weight'|'size'|'lineHeight'|'family'>} */ const $499ab6056ba431ad$var$fontRegExMatchIndex = [
    'style',
    'variant',
    'weight',
    'size',
    'lineHeight',
    'family'
];
const $499ab6056ba431ad$export$5abde8a6aec4a131 = function(fontSpec) {
    const match = fontSpec.match($499ab6056ba431ad$var$fontRegEx);
    if (!match) return null;
    const style = /** @type {FontParameters} */ {
        lineHeight: 'normal',
        size: '1.2em',
        style: 'normal',
        weight: 'normal',
        variant: 'normal'
    };
    for(let i = 0, ii = $499ab6056ba431ad$var$fontRegExMatchIndex.length; i < ii; ++i){
        const value = match[i + 1];
        if (value !== undefined) style[$499ab6056ba431ad$var$fontRegExMatchIndex[i]] = value;
    }
    style.families = style.family.split(/,\s?/);
    return style;
};



function $32c8adb5331a7848$export$9e05d10eae75c464(width, height, canvasPool, settings) {
    /** @type {HTMLCanvasElement|OffscreenCanvas} */ let canvas;
    if (canvasPool && canvasPool.length) canvas = /** @type {HTMLCanvasElement} */ canvasPool.shift();
    else if (0, $6f9f9040ddfdc3ac$export$98fcef3dc9973292) canvas = new OffscreenCanvas(width || 300, height || 300);
    else canvas = document.createElement('canvas');
    if (width) canvas.width = width;
    if (height) canvas.height = height;
    //FIXME Allow OffscreenCanvasRenderingContext2D as return type
    return /** @type {CanvasRenderingContext2D} */ canvas.getContext('2d', settings);
}
/** @type {CanvasRenderingContext2D} */ let $32c8adb5331a7848$var$sharedCanvasContext;
function $32c8adb5331a7848$export$fcb72ce088a6632c() {
    if (!$32c8adb5331a7848$var$sharedCanvasContext) $32c8adb5331a7848$var$sharedCanvasContext = $32c8adb5331a7848$export$9e05d10eae75c464(1, 1);
    return $32c8adb5331a7848$var$sharedCanvasContext;
}
function $32c8adb5331a7848$export$e918ac6a1026a12a(context) {
    const canvas = context.canvas;
    canvas.width = 1;
    canvas.height = 1;
    context.clearRect(0, 0, 1, 1);
}
function $32c8adb5331a7848$export$e823f88e4111159a(element) {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $32c8adb5331a7848$export$fc5b8aac72846d1e(element) {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $32c8adb5331a7848$export$5542201de9311ab2(newNode, oldNode) {
    const parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $32c8adb5331a7848$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.lastChild.remove();
}
function $32c8adb5331a7848$export$caeacfe04f52533a(node, children) {
    const oldChildren = node.childNodes;
    for(let i = 0;; ++i){
        const oldChild = oldChildren[i];
        const newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}




/**
 * @module ol/control/Control
 */ 



/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * const myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ class $4b86871676ed8daa$var$Control extends (0, $32070d44509bac34$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Control options.
   */ constructor(options){
        super();
        const element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = 'auto';
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = element ? element : null;
        /**
     * @private
     * @type {HTMLElement}
     */ this.target_ = null;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */ this.listenerKeys = [];
        if (options.render) this.render = options.render;
        if (options.target) this.setTarget(options.target);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.element?.remove();
        super.disposeInternal();
    }
    /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.map_) this.element?.remove();
        for(let i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (map) {
            const target = this.target_ ?? map.getOverlayContainerStopEvent();
            if (this.element) target.appendChild(this.element);
            if (this.render !== (0, $1a39c7df251dabdd$export$1cd1943b3a73bbe8)) this.listenerKeys.push((0, $7d7dee7854c96264$export$63174c828edd6ff8)(map, (0, $9806dbcaf2b91f44$export$2e2bcd8739ae039).POSTRENDER, this.render, this));
            map.render();
        }
    }
    /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */ render(mapEvent) {}
    /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */ setTarget(target) {
        this.target_ = typeof target === 'string' ? document.getElementById(target) : target;
    }
}
var $4b86871676ed8daa$export$2e2bcd8739ae039 = $4b86871676ed8daa$var$Control;


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {string|Array<string>|undefined} [attributions] Optional attribution(s) that will always be
 * displayed regardless of the layers rendered
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ class $f4b2c411ea29c23c$var$Attribution extends (0, $4b86871676ed8daa$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Attribution options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        /**
     * @private
     * @type {HTMLElement}
     */ this.ulElement_ = document.createElement('ul');
        /**
     * @private
     * @type {boolean}
     */ this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ this.userCollapsed_ = this.collapsed_;
        /**
     * @private
     * @type {boolean}
     */ this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
     * @private
     * @type {boolean}
     */ this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!this.collapsible_) this.collapsed_ = false;
        /**
     * @private
     * @type {string | Array<string> | undefined}
     */ this.attributions_ = options.attributions;
        const className = options.className !== undefined ? options.className : 'ol-attribution';
        const tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Attributions';
        const expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + '-expand';
        const collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u203A';
        const collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + '-collapse';
        if (typeof collapseLabel === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.collapseLabel_ = document.createElement('span');
            this.collapseLabel_.textContent = collapseLabel;
            this.collapseLabel_.className = collapseClassName;
        } else this.collapseLabel_ = collapseLabel;
        const label = options.label !== undefined ? options.label : 'i';
        if (typeof label === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.label_ = document.createElement('span');
            this.label_.textContent = label;
            this.label_.className = expandClassName;
        } else this.label_ = label;
        const activeLabel = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
        /**
     * @private
     * @type {HTMLElement}
     */ this.toggleButton_ = document.createElement('button');
        this.toggleButton_.setAttribute('type', 'button');
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
        this.toggleButton_.title = tipLabel;
        this.toggleButton_.appendChild(activeLabel);
        this.toggleButton_.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, $499ab6056ba431ad$export$1afde3d6e16a7b29) + ' ' + (0, $499ab6056ba431ad$export$4d4f8be70b656192) + (this.collapsed_ && this.collapsible_ ? ' ' + (0, $499ab6056ba431ad$export$e16017ac68d14492) : '') + (this.collapsible_ ? '' : ' ol-uncollapsible');
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(this.toggleButton_);
        element.appendChild(this.ulElement_);
        /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */ this.renderedAttributions_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */ collectSourceAttributions_(frameState) {
        const layers = this.getMap().getAllLayers();
        const visibleAttributions = new Set(layers.flatMap((layer)=>layer.getAttributions(frameState)));
        if (this.attributions_ !== undefined) Array.isArray(this.attributions_) ? this.attributions_.forEach((item)=>visibleAttributions.add(item)) : visibleAttributions.add(this.attributions_);
        if (!this.overrideCollapsible_) {
            const collapsible = !layers.some((layer)=>layer.getSource()?.getAttributionsCollapsible() === false);
            this.setCollapsible(collapsible);
        }
        return Array.from(visibleAttributions);
    }
    /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ async updateElement_(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        const attributions = await Promise.all(this.collectSourceAttributions_(frameState).map((attribution)=>(0, $1a39c7df251dabdd$export$4dbaaf6c79705e6c)(()=>attribution)));
        const visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? '' : 'none';
            this.renderedVisible_ = visible;
        }
        if ((0, $9d07dd9052c3de0c$export$e9bab7fafb253603)(attributions, this.renderedAttributions_)) return;
        (0, $32c8adb5331a7848$export$1e1c9bf5a4ffe0d1)(this.ulElement_);
        // append the attributions
        for(let i = 0, ii = attributions.length; i < ii; ++i){
            const element = document.createElement('li');
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    }
    /**
   * @private
   */ handleToggle_() {
        this.element.classList.toggle((0, $499ab6056ba431ad$export$e16017ac68d14492));
        if (this.collapsed_) (0, $32c8adb5331a7848$export$5542201de9311ab2)(this.collapseLabel_, this.label_);
        else (0, $32c8adb5331a7848$export$5542201de9311ab2)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
    }
    /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ getCollapsible() {
        return this.collapsible_;
    }
    /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ setCollapsible(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle('ol-uncollapsible');
        if (this.userCollapsed_) this.handleToggle_();
    }
    /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ setCollapsed(collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    }
    /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */ getCollapsed() {
        return this.collapsed_;
    }
    /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        this.updateElement_(mapEvent.frameState);
    }
}
var $f4b2c411ea29c23c$export$2e2bcd8739ae039 = $f4b2c411ea29c23c$var$Attribution;


/**
 * @module ol/control/Rotate
 */ 



/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ class $430718c2ab6c421c$var$Rotate extends (0, $4b86871676ed8daa$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Rotate options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-rotate';
        const label = options.label !== undefined ? options.label : '\u21E7';
        const compassClassName = options.compassClassName !== undefined ? options.compassClassName : 'ol-compass';
        /**
     * @type {HTMLElement}
     * @private
     */ this.label_ = null;
        if (typeof label === 'string') {
            this.label_ = document.createElement('span');
            this.label_.className = compassClassName;
            this.label_.textContent = label;
        } else {
            this.label_ = label;
            this.label_.classList.add(compassClassName);
        }
        const tipLabel = options.tipLabel ? options.tipLabel : 'Reset rotation';
        const button = document.createElement('button');
        button.className = className + '-reset';
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(this.label_);
        button.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, $499ab6056ba431ad$export$1afde3d6e16a7b29) + ' ' + (0, $499ab6056ba431ad$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(button);
        /**
     * @private
     */ this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @type {boolean}
     * @private
     */ this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        if (this.autoHide_) this.element.classList.add((0, $499ab6056ba431ad$export$981241db82723ce2));
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    }
    /**
   * @private
   */ resetNorth_() {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, $5354ee427f82b926$export$57636bb43b1ccbb0)
            });
            else view.setRotation(0);
        }
    }
    /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) return;
        const rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            const transform = 'rotate(' + rotation + 'rad)';
            if (this.autoHide_) {
                const contains = this.element.classList.contains((0, $499ab6056ba431ad$export$981241db82723ce2));
                if (!contains && rotation === 0) this.element.classList.add((0, $499ab6056ba431ad$export$981241db82723ce2));
                else if (contains && rotation !== 0) this.element.classList.remove((0, $499ab6056ba431ad$export$981241db82723ce2));
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    }
}
var $430718c2ab6c421c$export$2e2bcd8739ae039 = $430718c2ab6c421c$var$Rotate;


/**
 * @module ol/control/Zoom
 */ 



/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ class $374cb62cf22f0ad5$var$Zoom extends (0, $4b86871676ed8daa$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Zoom options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-zoom';
        const delta = options.delta !== undefined ? options.delta : 1;
        const zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + '-in';
        const zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + '-out';
        const zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : '+';
        const zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : '\u2013';
        const zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : 'Zoom in';
        const zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : 'Zoom out';
        const inElement = document.createElement('button');
        inElement.className = zoomInClassName;
        inElement.setAttribute('type', 'button');
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === 'string' ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, delta), false);
        const outElement = document.createElement('button');
        outElement.className = zoomOutClassName;
        outElement.setAttribute('type', 'button');
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === 'string' ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, -delta), false);
        const cssClasses = className + ' ' + (0, $499ab6056ba431ad$export$1afde3d6e16a7b29) + ' ' + (0, $499ab6056ba431ad$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    }
    /**
   * @param {number} delta Zoom delta.
   * @private
   */ zoomByDelta_(delta) {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            const newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: (0, $5354ee427f82b926$export$57636bb43b1ccbb0)
                });
            } else view.setZoom(newZoom);
        }
    }
}
var $374cb62cf22f0ad5$export$2e2bcd8739ae039 = $374cb62cf22f0ad5$var$Zoom;


function $1117f7f39083091c$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Control.js").default>} */ const controls = new (0, $9ac53bee919957f3$export$2e2bcd8739ae039)();
    const zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $374cb62cf22f0ad5$export$2e2bcd8739ae039)(options.zoomOptions));
    const rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $430718c2ab6c421c$export$2e2bcd8739ae039)(options.rotateOptions));
    const attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $f4b2c411ea29c23c$export$2e2bcd8739ae039)(options.attributionOptions));
    return controls;
}







/**
 * @module ol/interaction/defaults
 */ 
/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ class $2aa2bc78c05a2236$var$Kinetic {
    /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */ constructor(decay, minVelocity, delay){
        /**
     * @private
     * @type {number}
     */ this.decay_ = decay;
        /**
     * @private
     * @type {number}
     */ this.minVelocity_ = minVelocity;
        /**
     * @private
     * @type {number}
     */ this.delay_ = delay;
        /**
     * @private
     * @type {Array<number>}
     */ this.points_ = [];
        /**
     * @private
     * @type {number}
     */ this.angle_ = 0;
        /**
     * @private
     * @type {number}
     */ this.initialVelocity_ = 0;
    }
    /**
   * FIXME empty description for jsdoc
   */ begin() {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   */ update(x, y) {
        this.points_.push(x, y, Date.now());
    }
    /**
   * @return {boolean} Whether we should do kinetic animation.
   */ end() {
        if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
        // in the array)
        return false;
        const delay = Date.now() - this.delay_;
        const lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
        // panning before releasing the map
        return false;
        // get the first point which still falls into the delay time
        let firstIndex = lastIndex - 3;
        while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
        const duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) return false;
        const dx = this.points_[lastIndex] - this.points_[firstIndex];
        const dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    }
    /**
   * @return {number} Total distance travelled (pixels).
   */ getDistance() {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    }
    /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */ getAngle() {
        return this.angle_;
    }
}
var $2aa2bc78c05a2236$export$2e2bcd8739ae039 = $2aa2bc78c05a2236$var$Kinetic;


/**
 * @module ol/interaction/DoubleClickZoom
 */ 
/**
 * @module ol/interaction/Interaction
 */ 

/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $2e65a39ba17e537d$export$2e2bcd8739ae039 = {
    ACTIVE: 'active'
};


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active', Return>} InteractionOnSignature
 */ /**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ class $b5a30cb710806ff3$var$Interaction extends (0, $32070d44509bac34$export$2e2bcd8739ae039) {
    /**
   * @param {InteractionOptions} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {InteractionOnSignature<void>}
     */ this.un;
        if (options && options.handleEvent) this.handleEvent = options.handleEvent;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        this.setActive(true);
    }
    /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */ getActive() {
        return /** @type {boolean} */ this.get((0, $2e65a39ba17e537d$export$2e2bcd8739ae039).ACTIVE);
    }
    /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ handleEvent(mapBrowserEvent) {
        return true;
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        this.set((0, $2e65a39ba17e537d$export$2e2bcd8739ae039).ACTIVE, active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        this.map_ = map;
    }
}
function $b5a30cb710806ff3$export$4c486572e961a974(view, delta, duration) {
    const currentCenter = view.getCenterInternal();
    if (currentCenter) {
        const center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: duration !== undefined ? duration : 250,
            easing: (0, $5354ee427f82b926$export$45db2fc2f15997e7),
            center: view.getConstrainedCenter(center)
        });
    }
}
function $b5a30cb710806ff3$export$ace321ff2a8016ef(view, delta, anchor, duration) {
    const currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    const newZoom = view.getConstrainedZoom(currentZoom + delta);
    const newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: anchor,
        duration: duration !== undefined ? duration : 250,
        easing: (0, $5354ee427f82b926$export$57636bb43b1ccbb0)
    });
}
var $b5a30cb710806ff3$export$2e2bcd8739ae039 = $b5a30cb710806ff3$var$Interaction;


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ class $556a8ab9f91ecc6d$var$DoubleClickZoom extends (0, $b5a30cb710806ff3$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).DBLCLICK) {
            const browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
            const map = mapBrowserEvent.map;
            const anchor = mapBrowserEvent.coordinate;
            const delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            const view = map.getView();
            (0, $b5a30cb710806ff3$export$ace321ff2a8016ef)(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    }
}
var $556a8ab9f91ecc6d$export$2e2bcd8739ae039 = $556a8ab9f91ecc6d$var$DoubleClickZoom;


/**
 * @module ol/interaction/DragPan
 */ 

/**
 * @module ol/events/condition
 */ 


function $7c36e8c1969503b1$export$84bf76cd7afc7469(var_args) {
    const conditions = arguments;
    /**
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} All conditions passed.
   */ return function(event) {
        let pass = true;
        for(let i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
const $7c36e8c1969503b1$export$573409992e89967e = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $7c36e8c1969503b1$export$4e5f01653f9f1f82 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $7c36e8c1969503b1$export$d7ddd398f22d79ef = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const activeElement = event.map.getOwnerDocument().activeElement;
    return rootNode instanceof ShadowRoot ? rootNode.host.contains(activeElement) : targetElement.contains(activeElement);
};
const $7c36e8c1969503b1$export$ae2cdf064e3b0c55 = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const tabIndexCandidate = rootNode instanceof ShadowRoot ? rootNode.host : targetElement;
    return tabIndexCandidate.hasAttribute('tabindex') ? $7c36e8c1969503b1$export$d7ddd398f22d79ef(event) : true;
};
const $7c36e8c1969503b1$export$ba9e5d519bc326ca = (0, $1a39c7df251dabdd$export$22e23a2304399231);
const $7c36e8c1969503b1$export$64ef1bee2b9504c1 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).CLICK;
};
const $7c36e8c1969503b1$export$1238ad6b5e7fff70 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return originalEvent instanceof PointerEvent && originalEvent.button == 0 && !((0, $6f9f9040ddfdc3ac$export$39dfd62a25e0fe93) && (0, $6f9f9040ddfdc3ac$export$76c0a3b101d93136) && originalEvent.ctrlKey);
};
const $7c36e8c1969503b1$export$b3e22bcfd64c1022 = (0, $1a39c7df251dabdd$export$8f11cee4bdc7e668);
const $7c36e8c1969503b1$export$71eac0963f2c2f01 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == 'pointermove';
};
const $7c36e8c1969503b1$export$194df8bad091b401 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).SINGLECLICK;
};
const $7c36e8c1969503b1$export$c59d944dd10b3dc7 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).DBLCLICK;
};
const $7c36e8c1969503b1$export$fdc892d0d8fe3bfb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $7c36e8c1969503b1$export$f3100d8d6292d638 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $6f9f9040ddfdc3ac$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $7c36e8c1969503b1$export$32603ad571dd22b5 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return (0, $6f9f9040ddfdc3ac$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey;
};
const $7c36e8c1969503b1$export$5d31fe68a477cfbb = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $7c36e8c1969503b1$export$e5570ca80cd8fd54 = function(mapBrowserEvent) {
    const originalEvent = mapBrowserEvent.originalEvent;
    const tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== 'INPUT' && tagName !== 'SELECT' && tagName !== 'TEXTAREA' && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
    // different type like `SVGElement`.
    // @ts-ignore
    !originalEvent.target.isContentEditable;
};
const $7c36e8c1969503b1$export$abb7acbfa76bf3c4 = function(mapBrowserEvent) {
    const pointerEvent = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvent instanceof PointerEvent && pointerEvent.pointerType == 'mouse';
};
const $7c36e8c1969503b1$export$e74de664a571d084 = function(mapBrowserEvent) {
    const pointerEvt = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt instanceof PointerEvent && pointerEvt.pointerType === 'touch';
};
const $7c36e8c1969503b1$export$cd1707283a23f059 = function(mapBrowserEvent) {
    const pointerEvt = mapBrowserEvent.originalEvent;
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt instanceof PointerEvent && pointerEvt.pointerType === 'pen';
};
const $7c36e8c1969503b1$export$189f0d593022b199 = function(mapBrowserEvent) {
    const pointerEvent = mapBrowserEvent.originalEvent;
    return pointerEvent instanceof PointerEvent && pointerEvent.isPrimary && pointerEvent.button === 0;
};



/**
 * @module ol/interaction/Pointer
 */ 

/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ class $63cf7a649237d091$var$PointerInteraction extends (0, $b5a30cb710806ff3$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        if (options.handleDownEvent) this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) this.stopDown = options.stopDown;
        /**
     * @type {boolean}
     * @protected
     */ this.handlingDownUpSequence = false;
        /**
     * @type {Array<PointerEvent>}
     * @protected
     */ this.targetPointers = [];
    }
    /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */ getPointerCount() {
        return this.targetPointers.length;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleDownEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleDragEvent(mapBrowserEvent) {}
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        let stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            } else if (mapBrowserEvent.type == (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERUP) {
                const handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERDOWN) {
                const handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleMoveEvent(mapBrowserEvent) {}
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleUpEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */ stopDown(handled) {
        return handled;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */ updateTrackedPointers_(mapBrowserEvent) {
        if (mapBrowserEvent.activePointers) this.targetPointers = mapBrowserEvent.activePointers;
    }
}
function $63cf7a649237d091$export$e2a20c553f6c85ce(pointerEvents) {
    const length = pointerEvents.length;
    let clientX = 0;
    let clientY = 0;
    for(let i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return {
        clientX: clientX / length,
        clientY: clientY / length
    };
}
var $63cf7a649237d091$export$2e2bcd8739ae039 = $63cf7a649237d091$var$PointerInteraction;


/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ class $110394851c7b8524$var$DragPan extends (0, $63cf7a649237d091$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super({
            stopDown: (0, $1a39c7df251dabdd$export$8f11cee4bdc7e668)
        });
        options = options ? options : {};
        /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */ this.kinetic_ = options.kinetic;
        /**
     * @type {import("../pixel.js").Pixel}
     */ this.lastCentroid = null;
        /**
     * @type {number}
     * @private
     */ this.lastPointersCount_;
        /**
     * @type {boolean}
     * @private
     */ this.panning_ = false;
        const condition = options.condition ? options.condition : (0, $7c36e8c1969503b1$export$84bf76cd7afc7469)((0, $7c36e8c1969503b1$export$fdc892d0d8fe3bfb), (0, $7c36e8c1969503b1$export$189f0d593022b199));
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $7c36e8c1969503b1$export$84bf76cd7afc7469)((0, $7c36e8c1969503b1$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {boolean}
     */ this.noKinetic_ = false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        if (!this.panning_) {
            this.panning_ = true;
            map.getView().beginInteraction();
        }
        const targetPointers = this.targetPointers;
        const centroid = map.getEventPixel((0, $63cf7a649237d091$export$e2a20c553f6c85ce)(targetPointers));
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                const delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1]
                ];
                const map = mapBrowserEvent.map;
                const view = map.getView();
                (0, $188aedb30bca6ae8$export$dcdf75081b88279d)(delta, view.getResolution());
                (0, $188aedb30bca6ae8$export$bb628a54ab399bc9)(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                const distance = this.kinetic_.getDistance();
                const angle = this.kinetic_.getAngle();
                const center = view.getCenterInternal();
                const centerpx = map.getPixelFromCoordinateInternal(center);
                const dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: (0, $5354ee427f82b926$export$57636bb43b1ccbb0)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        }
        if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger up, tiny drag, second finger up
        this.kinetic_.begin();
        this.lastCentroid = null;
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.cancelAnimations();
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        }
        return false;
    }
}
var $110394851c7b8524$export$2e2bcd8739ae039 = $110394851c7b8524$var$DragPan;


/**
 * @module ol/interaction/DragRotate
 */ 



/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ class $bbb9c64d8f3f8c9e$var$DragRotate extends (0, $63cf7a649237d091$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            stopDown: (0, $1a39c7df251dabdd$export$8f11cee4bdc7e668)
        });
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $7c36e8c1969503b1$export$4e5f01653f9f1f82);
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!(0, $7c36e8c1969503b1$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $22904180715f9e42$export$e20fbacbb41798b)) return;
        const size = map.getSize();
        const offset = mapBrowserEvent.pixel;
        const theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            const delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!(0, $7c36e8c1969503b1$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (!(0, $7c36e8c1969503b1$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
        if ((0, $7c36e8c1969503b1$export$1238ad6b5e7fff70)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        }
        return false;
    }
}
var $bbb9c64d8f3f8c9e$export$2e2bcd8739ae039 = $bbb9c64d8f3f8c9e$var$DragRotate;


/**
 * @module ol/interaction/DragZoom
 */ 

/**
 * @module ol/interaction/DragBox
 */ // FIXME draw drag box


/**
 * @module ol/render/Box
 */ 

class $57619f200a910fec$var$RenderBox extends (0, $07a23b3d5e0afc2c$export$2e2bcd8739ae039) {
    /**
   * @param {string} className CSS class name.
   */ constructor(className){
        super();
        /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */ this.geometry_ = null;
        /**
     * @type {HTMLDivElement}
     * @private
     */ this.element_ = document.createElement('div');
        this.element_.style.position = 'absolute';
        this.element_.style.pointerEvents = 'auto';
        this.element_.className = 'ol-box ' + className;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.endPixel_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.setMap(null);
    }
    /**
   * @private
   */ render_() {
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const px = 'px';
        const style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            const style = this.element_.style;
            style.left = 'inherit';
            style.top = 'inherit';
            style.width = 'inherit';
            style.height = 'inherit';
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    }
    /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */ setPixels(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    }
    /**
   * Creates or updates the cached geometry.
   */ createOrUpdateGeometry() {
        if (!this.map_) return;
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        const coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, $9549b42604551fb5$export$2e2bcd8739ae039)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    }
    /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */ getGeometry() {
        return this.geometry_;
    }
}
var $57619f200a910fec$export$2e2bcd8739ae039 = $57619f200a910fec$var$RenderBox;



/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ const $a5340a3cf8c239bc$var$DragBoxEventType = {
    /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */ BOXSTART: 'boxstart',
    /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */ BOXDRAG: 'boxdrag',
    /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */ BOXEND: 'boxend',
    /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */ BOXCANCEL: 'boxcancel'
};
class $a5340a3cf8c239bc$export$7053c33c051365ea extends (0, $5ede4ff5599f8860$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */ constructor(type, coordinate, mapBrowserEvent){
        super(type);
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */ /**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ class $a5340a3cf8c239bc$var$DragBox extends (0, $63cf7a649237d091$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DragBoxOnSignature<void>}
     */ this.un;
        options = options ?? {};
        /**
     * @type {import("../render/Box.js").default}
     * @private
     */ this.box_ = new (0, $57619f200a910fec$export$2e2bcd8739ae039)(options.className || 'ol-dragbox');
        /**
     * @type {number}
     * @private
     */ this.minArea_ = options.minArea ?? 64;
        if (options.onBoxEnd) this.onBoxEnd = options.onBoxEnd;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ?? (0, $7c36e8c1969503b1$export$1238ad6b5e7fff70);
        /**
     * @private
     * @type {EndCondition}
     */ this.boxEndCondition_ = options.boxEndCondition ?? this.defaultBoxEndCondition;
    }
    /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */ defaultBoxEndCondition(mapBrowserEvent, startPixel, endPixel) {
        const width = endPixel[0] - startPixel[0];
        const height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    }
    /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */ getGeometry() {
        return this.box_.getGeometry();
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!this.startPixel_) return;
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new $a5340a3cf8c239bc$export$7053c33c051365ea($a5340a3cf8c239bc$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!this.startPixel_) return false;
        const completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) this.onBoxEnd(mapBrowserEvent);
        this.dispatchEvent(new $a5340a3cf8c239bc$export$7053c33c051365ea(completeBox ? $a5340a3cf8c239bc$var$DragBoxEventType.BOXEND : $a5340a3cf8c239bc$var$DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        this.box_.setMap(null);
        this.startPixel_ = null;
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new $a5340a3cf8c239bc$export$7053c33c051365ea($a5340a3cf8c239bc$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        }
        return false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ onBoxEnd(event) {}
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   * @override
   */ setActive(active) {
        if (!active) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $a5340a3cf8c239bc$export$7053c33c051365ea($a5340a3cf8c239bc$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setActive(active);
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        if (oldMap) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $a5340a3cf8c239bc$export$7053c33c051365ea($a5340a3cf8c239bc$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setMap(map);
    }
}
var $a5340a3cf8c239bc$export$2e2bcd8739ae039 = $a5340a3cf8c239bc$var$DragBox;


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ class $ee598de66766c3e5$var$DragZoom extends (0, $a5340a3cf8c239bc$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const condition = options.condition ? options.condition : (0, $7c36e8c1969503b1$export$5d31fe68a477cfbb);
        super({
            condition: condition,
            className: options.className || 'ol-dragzoom',
            minArea: options.minArea
        });
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
     * @private
     * @type {boolean}
     */ this.out_ = options.out !== undefined ? options.out : false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ onBoxEnd(event) {
        const map = this.getMap();
        const view = /** @type {!import("../View.js").default} */ map.getView();
        let geometry = this.getGeometry();
        if (this.out_) {
            const rotatedExtent = view.rotatedExtentForGeometry(geometry);
            const resolution = view.getResolutionForExtentInternal(rotatedExtent);
            const factor = view.getResolution() / resolution;
            geometry = geometry.clone();
            geometry.scale(factor * factor);
        }
        view.fitInternal(geometry, {
            duration: this.duration_,
            easing: (0, $5354ee427f82b926$export$57636bb43b1ccbb0)
        });
    }
}
var $ee598de66766c3e5$export$2e2bcd8739ae039 = $ee598de66766c3e5$var$DragZoom;


/**
 * @module ol/interaction/KeyboardPan
 */ 

/**
 * @module ol/events/Key
 */ /**
 * @enum {string}
 * @const
 */ var $427b862807fe6404$export$2e2bcd8739ae039 = {
    LEFT: 'ArrowLeft',
    UP: 'ArrowUp',
    RIGHT: 'ArrowRight',
    DOWN: 'ArrowDown'
};




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ class $24da72aa87d2e4dc$var$KeyboardPan extends (0, $b5a30cb710806ff3$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options || {};
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $7c36e8c1969503b1$export$fdc892d0d8fe3bfb)(mapBrowserEvent) && (0, $7c36e8c1969503b1$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition !== undefined ? options.condition : this.defaultCondition_;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
     * @private
     * @type {number}
     */ this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).KEYDOWN) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key == (0, $427b862807fe6404$export$2e2bcd8739ae039).DOWN || key == (0, $427b862807fe6404$export$2e2bcd8739ae039).LEFT || key == (0, $427b862807fe6404$export$2e2bcd8739ae039).RIGHT || key == (0, $427b862807fe6404$export$2e2bcd8739ae039).UP)) {
                const map = mapBrowserEvent.map;
                const view = map.getView();
                const mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                let deltaX = 0, deltaY = 0;
                if (key == (0, $427b862807fe6404$export$2e2bcd8739ae039).DOWN) deltaY = -mapUnitsDelta;
                else if (key == (0, $427b862807fe6404$export$2e2bcd8739ae039).LEFT) deltaX = -mapUnitsDelta;
                else if (key == (0, $427b862807fe6404$export$2e2bcd8739ae039).RIGHT) deltaX = mapUnitsDelta;
                else deltaY = mapUnitsDelta;
                const delta = [
                    deltaX,
                    deltaY
                ];
                (0, $188aedb30bca6ae8$export$bb628a54ab399bc9)(delta, view.getRotation());
                (0, $b5a30cb710806ff3$export$4c486572e961a974)(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $24da72aa87d2e4dc$export$2e2bcd8739ae039 = $24da72aa87d2e4dc$var$KeyboardPan;


/**
 * @module ol/interaction/KeyboardZoom
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. The default condition is
 * that {@link module:ol/events/condition.targetNotEditable} is fulfilled and that
 * the platform modifier key isn't pressed
 * (!{@link module:ol/events/condition.platformModifierKey}).
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ class $e801ba53816706b2$var$KeyboardZoom extends (0, $b5a30cb710806ff3$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : function(mapBrowserEvent) {
            return !(0, $7c36e8c1969503b1$export$32603ad571dd22b5)(mapBrowserEvent) && (0, $7c36e8c1969503b1$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).KEYDOWN || mapBrowserEvent.type == (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).KEYPRESS) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key === '+' || key === '-')) {
                const map = mapBrowserEvent.map;
                const delta = key === '+' ? this.delta_ : -this.delta_;
                const view = map.getView();
                (0, $b5a30cb710806ff3$export$ace321ff2a8016ef)(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $e801ba53816706b2$export$2e2bcd8739ae039 = $e801ba53816706b2$var$KeyboardZoom;


/**
 * @module ol/interaction/MouseWheelZoom
 */ 



/**
 * @typedef {'trackpad' | 'wheel'} Mode
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ class $60bcc067bccc1a2f$var$MouseWheelZoom extends (0, $b5a30cb710806ff3$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        /**
     * @private
     * @type {number}
     */ this.totalDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.lastDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @private
     * @type {number}
     */ this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
     * @private
     * @type {boolean}
     */ this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
     * @private
     * @type {boolean}
     */ this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        const condition = options.condition ? options.condition : (0, $7c36e8c1969503b1$export$ba9e5d519bc326ca);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $7c36e8c1969503b1$export$84bf76cd7afc7469)((0, $7c36e8c1969503b1$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {?import("../pixel.js").Pixel}
     */ this.lastAnchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.startTime_ = undefined;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.timeoutId_;
        /**
     * @private
     * @type {Mode|undefined}
     */ this.mode_ = undefined;
        /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @private
     * @type {number}
     */ this.trackpadEventGap_ = 400;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.trackpadTimeoutId_;
        /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */ this.deltaPerZoom_ = 300;
    }
    /**
   * @private
   */ endInteraction_() {
        this.trackpadTimeoutId_ = undefined;
        const map = this.getMap();
        if (!map) return;
        const view = map.getView();
        view.endInteraction(undefined, this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const type = mapBrowserEvent.type;
        if (type !== (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).WHEEL) return true;
        const map = mapBrowserEvent.map;
        const wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        wheelEvent.preventDefault();
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.pixel;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        let delta;
        if (mapBrowserEvent.type == (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).WHEEL) {
            delta = wheelEvent.deltaY;
            if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) delta *= 40;
        }
        if (delta === 0) return false;
        this.lastDelta_ = delta;
        const now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? 'trackpad' : 'wheel';
        const view = map.getView();
        if (this.mode_ === 'trackpad' && !(view.getConstrainResolution() || this.constrainResolution_)) {
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else {
                if (view.getAnimating()) view.cancelAnimations();
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        const timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    }
    /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */ handleWheelZoom_(map) {
        const view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        let delta = -(0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
        delta = delta ? delta > 0 ? 1 : -1 : 0;
        (0, $b5a30cb710806ff3$export$ace321ff2a8016ef)(view, delta, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    }
    /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */ setMouseAnchor(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    }
}
var $60bcc067bccc1a2f$export$2e2bcd8739ae039 = $60bcc067bccc1a2f$var$MouseWheelZoom;


/**
 * @module ol/interaction/PinchRotate
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ class $998dbece9e8e61c6$var$PinchRotate extends (0, $63cf7a649237d091$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $1a39c7df251dabdd$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {boolean}
     */ this.rotating_ = false;
        /**
     * @private
     * @type {number}
     */ this.rotationDelta_ = 0.0;
        /**
     * @private
     * @type {number}
     */ this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let rotationDelta = 0.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        // angle between touches
        const angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            const delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $22904180715f9e42$export$e20fbacbb41798b)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $63cf7a649237d091$export$e2a20c553f6c85ce)(this.targetPointers)));
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $998dbece9e8e61c6$export$2e2bcd8739ae039 = $998dbece9e8e61c6$var$PinchRotate;


/**
 * @module ol/interaction/PinchZoom
 */ 

/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ class $d87858589acea6de$var$PinchZoom extends (0, $63cf7a649237d091$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $1a39c7df251dabdd$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastDistance_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.lastScaleDelta_ = 1;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let scaleDelta = 1.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        const dx = touch0.clientX - touch1.clientX;
        const dy = touch0.clientY - touch1.clientY;
        // distance between touches
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $63cf7a649237d091$export$e2a20c553f6c85ce)(this.targetPointers)));
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            const direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $d87858589acea6de$export$2e2bcd8739ae039 = $d87858589acea6de$var$PinchZoom;


function $9bdc14d4619c3a06$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Interaction.js").default>} */ const interactions = new (0, $9ac53bee919957f3$export$2e2bcd8739ae039)();
    const kinetic = new (0, $2aa2bc78c05a2236$export$2e2bcd8739ae039)(-0.005, 0.05, 100);
    const altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $bbb9c64d8f3f8c9e$export$2e2bcd8739ae039)());
    const doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $556a8ab9f91ecc6d$export$2e2bcd8739ae039)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    const dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $110394851c7b8524$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    const pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $998dbece9e8e61c6$export$2e2bcd8739ae039)());
    const pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $d87858589acea6de$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    const keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $24da72aa87d2e4dc$export$2e2bcd8739ae039)());
        interactions.push(new (0, $e801ba53816706b2$export$2e2bcd8739ae039)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    const mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $60bcc067bccc1a2f$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    const shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $ee598de66766c3e5$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    return interactions;
}


/**
 * @module ol/layer/Group
 */ 









/**
 * @module ol/layer/Base
 */ 



/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $113b83fdb709ae46$export$2e2bcd8739ae039 = {
    OPACITY: 'opacity',
    VISIBLE: 'visible',
    EXTENT: 'extent',
    Z_INDEX: 'zIndex',
    MAX_RESOLUTION: 'maxResolution',
    MIN_RESOLUTION: 'minResolution',
    MAX_ZOOM: 'maxZoom',
    MIN_ZOOM: 'minZoom',
    SOURCE: 'source',
    MAP: 'map'
};


/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */ /**
 * @typedef {import("../ObjectEventType").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<BaseLayerObjectEventTypes, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number | undefined} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 */ class $841d98dd859bdd86$var$BaseLayer extends (0, $32070d44509bac34$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Layer options.
   */ constructor(options){
        super();
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {BackgroundColor|false}
     * @private
     */ this.background_ = options.background;
        /**
     * @type {Object<string, *>}
     */ const properties = Object.assign({}, options);
        if (typeof options.properties === 'object') {
            delete properties.properties;
            Object.assign(properties, options.properties);
        }
        properties[(0, $113b83fdb709ae46$export$2e2bcd8739ae039).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(typeof properties[(0, $113b83fdb709ae46$export$2e2bcd8739ae039).OPACITY] === 'number', 'Layer opacity must be a number');
        properties[(0, $113b83fdb709ae46$export$2e2bcd8739ae039).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $113b83fdb709ae46$export$2e2bcd8739ae039).Z_INDEX] = options.zIndex;
        properties[(0, $113b83fdb709ae46$export$2e2bcd8739ae039).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $113b83fdb709ae46$export$2e2bcd8739ae039).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, $113b83fdb709ae46$export$2e2bcd8739ae039).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, $113b83fdb709ae46$export$2e2bcd8739ae039).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
     * @type {string}
     * @private
     */ this.className_ = properties.className !== undefined ? properties.className : 'ol-layer';
        delete properties.className;
        this.setProperties(properties);
        /**
     * @type {import("./Layer.js").State}
     * @private
     */ this.state_ = null;
    }
    /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */ getBackground() {
        return this.background_;
    }
    /**
   * @return {string} CSS class name.
   */ getClassName() {
        return this.className_;
    }
    /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */ getLayerState(managed) {
        /** @type {import("./Layer.js").State} */ const state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: managed === undefined ? true : managed
        };
        const zIndex = this.getZIndex();
        state.opacity = (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(states) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */ getExtent() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $113b83fdb709ae46$export$2e2bcd8739ae039).EXTENT);
    }
    /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */ getMaxResolution() {
        return /** @type {number} */ this.get((0, $113b83fdb709ae46$export$2e2bcd8739ae039).MAX_RESOLUTION);
    }
    /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */ getMinResolution() {
        return /** @type {number} */ this.get((0, $113b83fdb709ae46$export$2e2bcd8739ae039).MIN_RESOLUTION);
    }
    /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.get((0, $113b83fdb709ae46$export$2e2bcd8739ae039).MIN_ZOOM);
    }
    /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.get((0, $113b83fdb709ae46$export$2e2bcd8739ae039).MAX_ZOOM);
    }
    /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */ getOpacity() {
        return /** @type {number} */ this.get((0, $113b83fdb709ae46$export$2e2bcd8739ae039).OPACITY);
    }
    /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */ getVisible() {
        return /** @type {boolean} */ this.get((0, $113b83fdb709ae46$export$2e2bcd8739ae039).VISIBLE);
    }
    /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */ getZIndex() {
        return /** @type {number|undefined} */ this.get((0, $113b83fdb709ae46$export$2e2bcd8739ae039).Z_INDEX);
    }
    /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */ setBackground(background) {
        this.background_ = background;
        this.changed();
    }
    /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */ setExtent(extent) {
        this.set((0, $113b83fdb709ae46$export$2e2bcd8739ae039).EXTENT, extent);
    }
    /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */ setMaxResolution(maxResolution) {
        this.set((0, $113b83fdb709ae46$export$2e2bcd8739ae039).MAX_RESOLUTION, maxResolution);
    }
    /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */ setMinResolution(minResolution) {
        this.set((0, $113b83fdb709ae46$export$2e2bcd8739ae039).MIN_RESOLUTION, minResolution);
    }
    /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */ setMaxZoom(maxZoom) {
        this.set((0, $113b83fdb709ae46$export$2e2bcd8739ae039).MAX_ZOOM, maxZoom);
    }
    /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */ setMinZoom(minZoom) {
        this.set((0, $113b83fdb709ae46$export$2e2bcd8739ae039).MIN_ZOOM, minZoom);
    }
    /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */ setOpacity(opacity) {
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(typeof opacity === 'number', 'Layer opacity must be a number');
        this.set((0, $113b83fdb709ae46$export$2e2bcd8739ae039).OPACITY, opacity);
    }
    /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */ setVisible(visible) {
        this.set((0, $113b83fdb709ae46$export$2e2bcd8739ae039).VISIBLE, visible);
    }
    /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */ setZIndex(zindex) {
        this.set((0, $113b83fdb709ae46$export$2e2bcd8739ae039).Z_INDEX, zindex);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        super.disposeInternal();
    }
}
var $841d98dd859bdd86$export$2e2bcd8739ae039 = $841d98dd859bdd86$var$BaseLayer;


class $9c4d32c43cd2911b$export$2f5ff21d758d25a7 extends (0, $5ede4ff5599f8860$export$2e2bcd8739ae039) {
    /**
   * @param {GroupEventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */ constructor(type, layer){
        super(type);
        /**
     * The added or removed layer.
     * @type {BaseLayer}
     * @api
     */ this.layer = layer;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'change:layers', Return>} GroupOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|Collection<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $9c4d32c43cd2911b$var$Property = {
    LAYERS: 'layers'
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @api
 */ class $9c4d32c43cd2911b$var$LayerGroup extends (0, $841d98dd859bdd86$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Layer options.
   */ constructor(options){
        options = options || {};
        const baseOptions = /** @type {Options} */ Object.assign({}, options);
        delete baseOptions.layers;
        let layers = options.layers;
        super(baseOptions);
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {GroupOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.layersListenerKeys_ = [];
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.listenerKeys_ = {};
        this.addChangeListener($9c4d32c43cd2911b$var$Property.LAYERS, this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $9ac53bee919957f3$export$2e2bcd8739ae039)(layers.slice(), {
                unique: true
            });
            else (0, $4b57691230be0bd5$export$a7a9523472993e97)(typeof /** @type {?} */ layers.getArray === 'function', 'Expected `layers` to be an array or a `Collection`');
        } else layers = new (0, $9ac53bee919957f3$export$2e2bcd8739ae039)(undefined, {
            unique: true
        });
        this.setLayers(layers);
    }
    /**
   * @private
   */ handleLayerChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleLayersChanged_() {
        this.layersListenerKeys_.forEach((0, $7d7dee7854c96264$export$b0a21c8b3c1c921));
        this.layersListenerKeys_.length = 0;
        const layers = this.getLayers();
        this.layersListenerKeys_.push((0, $7d7dee7854c96264$export$63174c828edd6ff8)(layers, (0, $1febc2967664bf62$export$2e2bcd8739ae039).ADD, this.handleLayersAdd_, this), (0, $7d7dee7854c96264$export$63174c828edd6ff8)(layers, (0, $1febc2967664bf62$export$2e2bcd8739ae039).REMOVE, this.handleLayersRemove_, this));
        for(const id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $7d7dee7854c96264$export$b0a21c8b3c1c921));
        (0, $0364d4893e3f1129$export$42ffd38884aecdac)(this.listenerKeys_);
        const layersArray = layers.getArray();
        for(let i = 0, ii = layersArray.length; i < ii; i++){
            const layer = layersArray[i];
            this.registerLayerListeners_(layer);
            this.dispatchEvent(new $9c4d32c43cd2911b$export$2f5ff21d758d25a7('addlayer', layer));
        }
        this.changed();
    }
    /**
   * @param {BaseLayer} layer The layer.
   */ registerLayerListeners_(layer) {
        const listenerKeys = [
            (0, $7d7dee7854c96264$export$63174c828edd6ff8)(layer, (0, $2a15c8802c911fe7$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, $7d7dee7854c96264$export$63174c828edd6ff8)(layer, (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, this.handleLayerChange_, this)
        ];
        if (layer instanceof $9c4d32c43cd2911b$var$LayerGroup) listenerKeys.push((0, $7d7dee7854c96264$export$63174c828edd6ff8)(layer, 'addlayer', this.handleLayerGroupAdd_, this), (0, $7d7dee7854c96264$export$63174c828edd6ff8)(layer, 'removelayer', this.handleLayerGroupRemove_, this));
        this.listenerKeys_[(0, $9f65e6f92d33bc27$export$5e82334337e0f204)(layer)] = listenerKeys;
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupAdd_(event) {
        this.dispatchEvent(new $9c4d32c43cd2911b$export$2f5ff21d758d25a7('addlayer', event.layer));
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupRemove_(event) {
        this.dispatchEvent(new $9c4d32c43cd2911b$export$2f5ff21d758d25a7('removelayer', event.layer));
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersAdd_(collectionEvent) {
        const layer = collectionEvent.element;
        this.registerLayerListeners_(layer);
        this.dispatchEvent(new $9c4d32c43cd2911b$export$2f5ff21d758d25a7('addlayer', layer));
        this.changed();
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersRemove_(collectionEvent) {
        const layer = collectionEvent.element;
        const key = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(layer);
        this.listenerKeys_[key].forEach((0, $7d7dee7854c96264$export$b0a21c8b3c1c921));
        delete this.listenerKeys_[key];
        this.dispatchEvent(new $9c4d32c43cd2911b$export$2f5ff21d758d25a7('removelayer', layer));
        this.changed();
    }
    /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ getLayers() {
        return /** @type {!Collection<import("./Base.js").default>} */ this.get($9c4d32c43cd2911b$var$Property.LAYERS);
    }
    /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ setLayers(layers) {
        const collection = this.getLayers();
        if (collection) {
            const currentLayers = collection.getArray();
            for(let i = 0, ii = currentLayers.length; i < ii; ++i)this.dispatchEvent(new $9c4d32c43cd2911b$export$2f5ff21d758d25a7('removelayer', currentLayers[i]));
        }
        this.set($9c4d32c43cd2911b$var$Property.LAYERS, layers);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array !== undefined ? array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    }
    /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(dest) {
        const states = dest !== undefined ? dest : [];
        const pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        const ownLayerState = this.getLayerState();
        let defaultZIndex = ownLayerState.zIndex;
        if (!dest && ownLayerState.zIndex === undefined) defaultZIndex = 0;
        for(let i = pos, ii = states.length; i < ii; i++){
            const layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, $110ceb23457e07e7$export$72209efa88586d42)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
            if (layerState.zIndex === undefined) layerState.zIndex = defaultZIndex;
        }
        return states;
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        return 'ready';
    }
}
var $9c4d32c43cd2911b$export$2e2bcd8739ae039 = $9c4d32c43cd2911b$var$LayerGroup;


/**
 * @module ol/layer/Layer
 */ 




/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $b899a48a5b03178b$export$2e2bcd8739ae039 /**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */  /**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */  = {
    /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */ PRERENDER: 'prerender',
    /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */ PRECOMPOSE: 'precompose',
    /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */ POSTCOMPOSE: 'postcompose',
    /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */ RENDERCOMPLETE: 'rendercomplete'
};




/**
 * @typedef {function(import("../Map.js").FrameState):HTMLElement} RenderFunction
 */ /**
 * @typedef {'sourceready'|'change:source'} LayerEventType
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     LayerEventType, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|LayerEventType|
 *     import("../render/EventType").LayerRenderEventTypes, Return>} LayerOnSignature
 */ /**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../Map.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * Components like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * [layer.setMap()]{@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 * A `sourceready` event is fired when the layer's source is ready.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 * @fires import("../events/Event.js").BaseEvent#sourceready
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @api
 */ class $3a63648a58cbd426$var$Layer extends (0, $841d98dd859bdd86$export$2e2bcd8739ae039) {
    /**
   * @param {Options<SourceType>} options Layer options.
   */ constructor(options){
        const baseOptions = Object.assign({}, options);
        delete baseOptions.source;
        super(baseOptions);
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {LayerOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapPrecomposeKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapRenderKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceChangeKey_ = null;
        /**
     * @private
     * @type {RendererType}
     */ this.renderer_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.sourceReady_ = false;
        /**
     * @protected
     * @type {boolean}
     */ this.rendered = false;
        // Overwrite default render method with a custom one
        if (options.render) this.render = options.render;
        if (options.map) this.setMap(options.map);
        this.addChangeListener((0, $113b83fdb709ae46$export$2e2bcd8739ae039).SOURCE, this.handleSourcePropertyChange_);
        const source = options.source ? /** @type {SourceType} */ options.source : null;
        this.setSource(source);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array ? array : [];
        array.push(this);
        return array;
    }
    /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(states) {
        states = states ? states : [];
        states.push(this.getLayerState());
        return states;
    }
    /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */ getSource() {
        return /** @type {SourceType} */ this.get((0, $113b83fdb709ae46$export$2e2bcd8739ae039).SOURCE) || null;
    }
    /**
   * @return {SourceType|null} The source being rendered.
   */ getRenderSource() {
        return this.getSource();
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        const source = this.getSource();
        return !source ? 'undefined' : source.getState();
    }
    /**
   * @private
   */ handleSourceChange_() {
        this.changed();
        if (this.sourceReady_ || this.getSource().getState() !== 'ready') return;
        this.sourceReady_ = true;
        this.dispatchEvent('sourceready');
    }
    /**
   * @private
   */ handleSourcePropertyChange_() {
        if (this.sourceChangeKey_) {
            (0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        this.sourceReady_ = false;
        const source = this.getSource();
        if (source) {
            this.sourceChangeKey_ = (0, $7d7dee7854c96264$export$63174c828edd6ff8)(source, (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, this.handleSourceChange_, this);
            if (source.getState() === 'ready') {
                this.sourceReady_ = true;
                setTimeout(()=>{
                    this.dispatchEvent('sourceready');
                }, 0);
            }
            this.clearRenderer();
        }
        this.changed();
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        if (!this.renderer_) return Promise.resolve([]);
        return this.renderer_.getFeatures(pixel);
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        if (!this.renderer_ || !this.rendered) return null;
        return this.renderer_.getData(pixel);
    }
    /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */ isVisible(view) {
        let frameState;
        const map = this.getMapInternal();
        if (!view && map) view = map.getView();
        if (view instanceof (0, $6d96d03cab85bf06$export$2e2bcd8739ae039)) frameState = {
            viewState: view.getState(),
            extent: view.calculateExtent()
        };
        else frameState = view;
        if (!frameState.layerStatesArray && map) frameState.layerStatesArray = map.getLayerGroup().getLayerStatesArray();
        let layerState;
        if (frameState.layerStatesArray) {
            layerState = frameState.layerStatesArray.find((layerState)=>layerState.layer === this);
            if (!layerState) return false;
        } else layerState = this.getLayerState();
        const layerExtent = this.getExtent();
        return $3a63648a58cbd426$export$acb1e9cb9ce4ca56(layerState, frameState.viewState) && (!layerExtent || (0, $110ceb23457e07e7$export$7b0a31e10bbff018)(layerExtent, frameState.extent));
    }
    /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */ getAttributions(view) {
        if (!this.isVisible(view)) return [];
        const getAttributions = this.getSource()?.getAttributions();
        if (!getAttributions) return [];
        const frameState = view instanceof (0, $6d96d03cab85bf06$export$2e2bcd8739ae039) ? view.getViewStateAndExtent() : view;
        let attributions = getAttributions(frameState);
        if (!Array.isArray(attributions)) attributions = [
            attributions
        ];
        return attributions;
    }
    /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */ render(frameState, target) {
        const layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) {
            this.rendered = true;
            return layerRenderer.renderFrame(frameState, target);
        }
        return null;
    }
    /**
   * Called when a layer is not visible during a map render.
   */ unrender() {
        this.rendered = false;
    }
    /** @return {string} Declutter */ getDeclutter() {
        return undefined;
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {}
    /**
   * When the renderer follows a layout -> render approach, do the final rendering here.
   * @param {import('../Map.js').FrameState} frameState Frame state
   */ renderDeferred(frameState) {
        const layerRenderer = this.getRenderer();
        if (!layerRenderer) return;
        layerRenderer.renderDeferred(frameState);
    }
    /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */ setMapInternal(map) {
        if (!map) this.unrender();
        this.set((0, $113b83fdb709ae46$export$2e2bcd8739ae039).MAP, map);
    }
    /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */ getMapInternal() {
        return this.get((0, $113b83fdb709ae46$export$2e2bcd8739ae039).MAP);
    }
    /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.mapPrecomposeKey_) {
            (0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, $7d7dee7854c96264$export$63174c828edd6ff8)(map, (0, $b899a48a5b03178b$export$2e2bcd8739ae039).PRECOMPOSE, this.handlePrecompose_, this);
            this.mapRenderKey_ = (0, $7d7dee7854c96264$export$63174c828edd6ff8)(this, (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, map.render, map);
            this.changed();
        }
    }
    /**
   * @param {import("../events/Event.js").default} renderEvent Render event
   * @private
   */ handlePrecompose_(renderEvent) {
        const layerStatesArray = /** @type {import("../render/Event.js").default} */ renderEvent.frameState.layerStatesArray;
        const layerState = this.getLayerState(false);
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(!layerStatesArray.some((arrayLayerState)=>arrayLayerState.layer === layerState.layer), 'A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.');
        layerStatesArray.push(layerState);
    }
    /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */ setSource(source) {
        this.set((0, $113b83fdb709ae46$export$2e2bcd8739ae039).SOURCE, source);
    }
    /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */ getRenderer() {
        if (!this.renderer_) this.renderer_ = this.createRenderer();
        return this.renderer_;
    }
    /**
   * @return {boolean} The layer has a renderer.
   */ hasRenderer() {
        return !!this.renderer_;
    }
    /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */ createRenderer() {
        return null;
    }
    /**
   * This will clear the renderer so that a new one can be created next time it is needed
   */ clearRenderer() {
        if (this.renderer_) {
            this.renderer_.dispose();
            delete this.renderer_;
        }
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.clearRenderer();
        this.setSource(null);
        super.disposeInternal();
    }
}
function $3a63648a58cbd426$export$acb1e9cb9ce4ca56(layerState, viewState) {
    if (!layerState.visible) return false;
    const resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    const zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
var $3a63648a58cbd426$export$2e2bcd8739ae039 = $3a63648a58cbd426$var$Layer;





/**
 * @module ol/renderer/Composite
 */ 



/**
 * @module ol/layer/BaseVector
 */ var $2c1acb459bfbe860$exports = {};
!function(t, i) {
    $2c1acb459bfbe860$exports = i();
}($2c1acb459bfbe860$exports, function() {
    "use strict";
    function t(e, h, r = 0, s = e.length - 1, a = n) {
        for(; s > r;){
            if (s - r > 600) {
                const i = s - r + 1, n = h - r + 1, o = Math.log(i), l = .5 * Math.exp(2 * o / 3), c = .5 * Math.sqrt(o * l * (i - l) / i) * (n - i / 2 < 0 ? -1 : 1);
                t(e, h, Math.max(r, Math.floor(h - n * l / i + c)), Math.min(s, Math.floor(h + (i - n) * l / i + c)), a);
            }
            const n = e[h];
            let o = r, l = s;
            for(i(e, r, h), a(e[s], n) > 0 && i(e, r, s); o < l;){
                for(i(e, o, l), o++, l--; a(e[o], n) < 0;)o++;
                for(; a(e[l], n) > 0;)l--;
            }
            0 === a(e[r], n) ? i(e, r, l) : (l++, i(e, l, s)), l <= h && (r = l + 1), h <= l && (s = l - 1);
        }
    }
    function i(t, i, n) {
        const e = t[i];
        t[i] = t[n], t[n] = e;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(let e = 0; e < i.length; e++)if (n(t, i[e])) return e;
        return -1;
    }
    function h(t, i) {
        r(t, 0, t.children.length, i, t);
    }
    function r(t, i, n, e, h) {
        h || (h = d(null)), h.minX = 1 / 0, h.minY = 1 / 0, h.maxX = -1 / 0, h.maxY = -1 / 0;
        for(let r = i; r < n; r++){
            const i = t.children[r];
            s(h, t.leaf ? e(i) : i);
        }
        return h;
    }
    function s(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function a(t, i) {
        return t.minX - i.minX;
    }
    function o(t, i) {
        return t.minY - i.minY;
    }
    function l(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function c(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        const n = Math.max(t.minX, i.minX), e = Math.max(t.minY, i.minY), h = Math.min(t.maxX, i.maxX), r = Math.min(t.maxY, i.maxY);
        return Math.max(0, h - n) * Math.max(0, r - e);
    }
    function f(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function u(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function d(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function x(i, n, e, h, r) {
        const s = [
            n,
            e
        ];
        for(; s.length;){
            if ((e = s.pop()) - (n = s.pop()) <= h) continue;
            const a = n + Math.ceil((e - n) / h / 2) * h;
            t(i, a, n, e, r), s.push(n, a, a, e);
        }
    }
    return class {
        constructor(t = 9){
            this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
        }
        all() {
            return this._all(this.data, []);
        }
        search(t) {
            let i = this.data;
            const n = [];
            if (!u(t, i)) return n;
            const e = this.toBBox, h = [];
            for(; i;){
                for(let r = 0; r < i.children.length; r++){
                    const s = i.children[r], a = i.leaf ? e(s) : s;
                    u(t, a) && (i.leaf ? n.push(s) : f(t, a) ? this._all(s, n) : h.push(s));
                }
                i = h.pop();
            }
            return n;
        }
        collides(t) {
            let i = this.data;
            if (!u(t, i)) return !1;
            const n = [];
            for(; i;){
                for(let e = 0; e < i.children.length; e++){
                    const h = i.children[e], r = i.leaf ? this.toBBox(h) : h;
                    if (u(t, r)) {
                        if (i.leaf || f(t, r)) return !0;
                        n.push(h);
                    }
                }
                i = n.pop();
            }
            return !1;
        }
        load(t) {
            if (!t || !t.length) return this;
            if (t.length < this._minEntries) {
                for(let i = 0; i < t.length; i++)this.insert(t[i]);
                return this;
            }
            let i = this._build(t.slice(), 0, t.length - 1, 0);
            if (this.data.children.length) {
                if (this.data.height === i.height) this._splitRoot(this.data, i);
                else {
                    if (this.data.height < i.height) {
                        const t = this.data;
                        this.data = i, i = t;
                    }
                    this._insert(i, this.data.height - i.height - 1, !0);
                }
            } else this.data = i;
            return this;
        }
        insert(t) {
            return t && this._insert(t, this.data.height - 1), this;
        }
        clear() {
            return this.data = d([]), this;
        }
        remove(t, i) {
            if (!t) return this;
            let n = this.data;
            const h = this.toBBox(t), r = [], s = [];
            let a, o, l;
            for(; n || r.length;){
                if (n || (n = r.pop(), o = r[r.length - 1], a = s.pop(), l = !0), n.leaf) {
                    const h = e(t, n.children, i);
                    if (-1 !== h) return n.children.splice(h, 1), r.push(n), this._condense(r), this;
                }
                l || n.leaf || !f(n, h) ? o ? (a++, n = o.children[a], l = !1) : n = null : (r.push(n), s.push(a), a = 0, o = n, n = n.children[0]);
            }
            return this;
        }
        toBBox(t) {
            return t;
        }
        compareMinX(t, i) {
            return t.minX - i.minX;
        }
        compareMinY(t, i) {
            return t.minY - i.minY;
        }
        toJSON() {
            return this.data;
        }
        fromJSON(t) {
            return this.data = t, this;
        }
        _all(t, i) {
            const n = [];
            for(; t;)t.leaf ? i.push(...t.children) : n.push(...t.children), t = n.pop();
            return i;
        }
        _build(t, i, n, e) {
            const r = n - i + 1;
            let s, a = this._maxEntries;
            if (r <= a) return s = d(t.slice(i, n + 1)), h(s, this.toBBox), s;
            e || (e = Math.ceil(Math.log(r) / Math.log(a)), a = Math.ceil(r / Math.pow(a, e - 1))), s = d([]), s.leaf = !1, s.height = e;
            const o = Math.ceil(r / a), l = o * Math.ceil(Math.sqrt(a));
            x(t, i, n, l, this.compareMinX);
            for(let h = i; h <= n; h += l){
                const i = Math.min(h + l - 1, n);
                x(t, h, i, o, this.compareMinY);
                for(let n = h; n <= i; n += o){
                    const h = Math.min(n + o - 1, i);
                    s.children.push(this._build(t, n, h, e - 1));
                }
            }
            return h(s, this.toBBox), s;
        }
        _chooseSubtree(t, i, n, e) {
            for(; e.push(i), !i.leaf && e.length - 1 !== n;){
                let n, e = 1 / 0, s = 1 / 0;
                for(let a = 0; a < i.children.length; a++){
                    const o = i.children[a], c = l(o), m = (h = t, r = o, (Math.max(r.maxX, h.maxX) - Math.min(r.minX, h.minX)) * (Math.max(r.maxY, h.maxY) - Math.min(r.minY, h.minY)) - c);
                    m < s ? (s = m, e = c < e ? c : e, n = o) : m === s && c < e && (e = c, n = o);
                }
                i = n || i.children[0];
            }
            var h, r;
            return i;
        }
        _insert(t, i, n) {
            const e = n ? t : this.toBBox(t), h = [], r = this._chooseSubtree(e, this.data, i, h);
            for(r.children.push(t), s(r, e); i >= 0 && h[i].children.length > this._maxEntries;)this._split(h, i), i--;
            this._adjustParentBBoxes(e, h, i);
        }
        _split(t, i) {
            const n = t[i], e = n.children.length, r = this._minEntries;
            this._chooseSplitAxis(n, r, e);
            const s = this._chooseSplitIndex(n, r, e), a = d(n.children.splice(s, n.children.length - s));
            a.height = n.height, a.leaf = n.leaf, h(n, this.toBBox), h(a, this.toBBox), i ? t[i - 1].children.push(a) : this._splitRoot(n, a);
        }
        _splitRoot(t, i) {
            this.data = d([
                t,
                i
            ]), this.data.height = t.height + 1, this.data.leaf = !1, h(this.data, this.toBBox);
        }
        _chooseSplitIndex(t, i, n) {
            let e, h = 1 / 0, s = 1 / 0;
            for(let a = i; a <= n - i; a++){
                const i = r(t, 0, a, this.toBBox), o = r(t, a, n, this.toBBox), c = m(i, o), f = l(i) + l(o);
                c < h ? (h = c, e = a, s = f < s ? f : s) : c === h && f < s && (s = f, e = a);
            }
            return e || n - i;
        }
        _chooseSplitAxis(t, i, n) {
            const e = t.leaf ? this.compareMinX : a, h = t.leaf ? this.compareMinY : o;
            this._allDistMargin(t, i, n, e) < this._allDistMargin(t, i, n, h) && t.children.sort(e);
        }
        _allDistMargin(t, i, n, e) {
            t.children.sort(e);
            const h = this.toBBox, a = r(t, 0, i, h), o = r(t, n - i, n, h);
            let l = c(a) + c(o);
            for(let e = i; e < n - i; e++){
                const i = t.children[e];
                s(a, t.leaf ? h(i) : i), l += c(a);
            }
            for(let e = n - i - 1; e >= i; e--){
                const i = t.children[e];
                s(o, t.leaf ? h(i) : i), l += c(o);
            }
            return l;
        }
        _adjustParentBBoxes(t, i, n) {
            for(let e = n; e >= 0; e--)s(i[e], t);
        }
        _condense(t) {
            for(let i, n = t.length - 1; n >= 0; n--)0 === t[n].children.length ? n > 0 ? (i = t[n - 1].children, i.splice(i.indexOf(t[n]), 1)) : this.clear() : h(t[n], this.toBBox);
        }
    };
});


/**
 * @module ol/render/canvas/style
 */ /**
 * @module ol/color
 */ 

const $4693a670e5985dc9$export$6c844c64a5efe1ee = [
    NaN,
    NaN,
    NaN,
    0
];
let $4693a670e5985dc9$var$colorParseContext;
/**
 * @return {CanvasRenderingContext2D} The color parse context
 */ function $4693a670e5985dc9$var$getColorParseContext() {
    if (!$4693a670e5985dc9$var$colorParseContext) $4693a670e5985dc9$var$colorParseContext = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(1, 1, undefined, {
        willReadFrequently: true,
        desynchronized: true
    });
    return $4693a670e5985dc9$var$colorParseContext;
}
const $4693a670e5985dc9$var$rgbModernRegEx = /^rgba?\(\s*(\d+%?)\s+(\d+%?)\s+(\d+%?)(?:\s*\/\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $4693a670e5985dc9$var$rgbLegacyAbsoluteRegEx = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $4693a670e5985dc9$var$rgbLegacyPercentageRegEx = /^rgba?\(\s*(\d+%)\s*,\s*(\d+%)\s*,\s*(\d+%)(?:\s*,\s*(\d+%|\d*\.\d+|[01]))?\s*\)$/i;
const $4693a670e5985dc9$var$hexRegEx = /^#([\da-f]{3,4}|[\da-f]{6}|[\da-f]{8})$/i;
/**
 * @param {string} s Color component as number or percentage.
 * @param {number} divider Divider for percentage.
 * @return {number} Color component.
 */ function $4693a670e5985dc9$var$toColorComponent(s, divider) {
    return s.endsWith('%') ? Number(s.substring(0, s.length - 1)) / divider : Number(s);
}
/**
 * @param {string} color Color string.
 */ function $4693a670e5985dc9$var$throwInvalidColor(color) {
    throw new Error('failed to parse "' + color + '" as color');
}
/**
 * @param {string} color Color string.
 * @return {Color} RGBa color array.
 */ function $4693a670e5985dc9$var$parseRgba(color) {
    // Fast lane for rgb(a) colors
    if (color.toLowerCase().startsWith('rgb')) {
        const rgb = color.match($4693a670e5985dc9$var$rgbLegacyAbsoluteRegEx) || color.match($4693a670e5985dc9$var$rgbModernRegEx) || color.match($4693a670e5985dc9$var$rgbLegacyPercentageRegEx);
        if (rgb) {
            const alpha = rgb[4];
            const rgbDivider = 100 / 255;
            return [
                (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)($4693a670e5985dc9$var$toColorComponent(rgb[1], rgbDivider) + 0.5 | 0, 0, 255),
                (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)($4693a670e5985dc9$var$toColorComponent(rgb[2], rgbDivider) + 0.5 | 0, 0, 255),
                (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)($4693a670e5985dc9$var$toColorComponent(rgb[3], rgbDivider) + 0.5 | 0, 0, 255),
                alpha !== undefined ? (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)($4693a670e5985dc9$var$toColorComponent(alpha, 100), 0, 1) : 1
            ];
        }
        $4693a670e5985dc9$var$throwInvalidColor(color);
    }
    // Fast lane for hex colors (also with alpha)
    if (color.startsWith('#')) {
        if ($4693a670e5985dc9$var$hexRegEx.test(color)) {
            const hex = color.substring(1);
            const step = hex.length <= 4 ? 1 : 2;
            const colorFromHex = [
                0,
                0,
                0,
                255
            ];
            for(let i = 0, ii = hex.length; i < ii; i += step){
                let colorComponent = parseInt(hex.substring(i, i + step), 16);
                if (step === 1) colorComponent += colorComponent << 4;
                colorFromHex[i / step] = colorComponent;
            }
            colorFromHex[3] = colorFromHex[3] / 255;
            return colorFromHex;
        }
        $4693a670e5985dc9$var$throwInvalidColor(color);
    }
    // Use canvas color serialization to parse the color into hex or rgba
    // See https://www.w3.org/TR/2021/SPSD-2dcontext-20210128/#serialization-of-a-color
    const context = $4693a670e5985dc9$var$getColorParseContext();
    context.fillStyle = '#abcdef';
    let invalidCheckFillStyle = context.fillStyle;
    context.fillStyle = color;
    if (context.fillStyle === invalidCheckFillStyle) {
        context.fillStyle = '#fedcba';
        invalidCheckFillStyle = context.fillStyle;
        context.fillStyle = color;
        if (context.fillStyle === invalidCheckFillStyle) $4693a670e5985dc9$var$throwInvalidColor(color);
    }
    const colorString = context.fillStyle;
    if (colorString.startsWith('#') || colorString.startsWith('rgba')) return $4693a670e5985dc9$var$parseRgba(colorString);
    context.clearRect(0, 0, 1, 1);
    context.fillRect(0, 0, 1, 1);
    const colorFromImage = Array.from(context.getImageData(0, 0, 1, 1).data);
    colorFromImage[3] = (0, $91ceb5420a5c8360$export$a81f732198733497)(colorFromImage[3] / 255, 3);
    return colorFromImage;
}
function $4693a670e5985dc9$export$590567be997858b6(color) {
    if (typeof color === 'string') return color;
    return $4693a670e5985dc9$export$f84e8e69fd4488a5(color);
}
/**
 * @type {number}
 */ const $4693a670e5985dc9$var$MAX_CACHE_SIZE = 1024;
/**
 * We maintain a small cache of parsed strings.  Whenever the cache grows too large,
 * we delete an arbitrary set of the entries.
 *
 * @type {Object<string, Color>}
 */ const $4693a670e5985dc9$var$cache = {};
/**
 * @type {number}
 */ let $4693a670e5985dc9$var$cacheSize = 0;
function $4693a670e5985dc9$export$138c09bdd6bd797c(color) {
    if (color.length === 4) return color;
    const output = color.slice();
    output[3] = 1;
    return output;
}
// The functions b1, b2, a1, a2, rgbaToLcha and lchaToRgba below are adapted from
// https://stackoverflow.com/a/67219995/2389327
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $4693a670e5985dc9$var$b1(v) {
    return v > 0.0031308 ? Math.pow(v, 1 / 2.4) * 269.025 - 14.025 : v * 3294.6;
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $4693a670e5985dc9$var$b2(v) {
    return v > 0.2068965 ? Math.pow(v, 3) : (v - 4 / 29) * (108 / 841);
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $4693a670e5985dc9$var$a1(v) {
    return v > 10.314724 ? Math.pow((v + 14.025) / 269.025, 2.4) : v / 3294.6;
}
/**
 * @param {number} v Input value.
 * @return {number} Output value.
 */ function $4693a670e5985dc9$var$a2(v) {
    return v > 0.0088564 ? Math.pow(v, 1 / 3) : v / (108 / 841) + 4 / 29;
}
function $4693a670e5985dc9$export$44fb54fa2e0c0d4(color) {
    const r = $4693a670e5985dc9$var$a1(color[0]);
    const g = $4693a670e5985dc9$var$a1(color[1]);
    const b = $4693a670e5985dc9$var$a1(color[2]);
    const y = $4693a670e5985dc9$var$a2(r * 0.222488403 + g * 0.716873169 + b * 0.06060791);
    const l = 500 * ($4693a670e5985dc9$var$a2(r * 0.452247074 + g * 0.399439023 + b * 0.148375274) - y);
    const q = 200 * (y - $4693a670e5985dc9$var$a2(r * 0.016863605 + g * 0.117638439 + b * 0.865350722));
    const h = Math.atan2(q, l) * (180 / Math.PI);
    return [
        116 * y - 16,
        Math.sqrt(l * l + q * q),
        h < 0 ? h + 360 : h,
        color[3]
    ];
}
function $4693a670e5985dc9$export$27cc94530c050f00(color) {
    const l = (color[0] + 16) / 116;
    const c = color[1];
    const h = color[2] * Math.PI / 180;
    const y = $4693a670e5985dc9$var$b2(l);
    const x = $4693a670e5985dc9$var$b2(l + c / 500 * Math.cos(h));
    const z = $4693a670e5985dc9$var$b2(l - c / 200 * Math.sin(h));
    const r = $4693a670e5985dc9$var$b1(x * 3.021973625 - y * 1.617392459 - z * 0.404875592);
    const g = $4693a670e5985dc9$var$b1(x * -0.943766287 + y * 1.916279586 + z * 0.027607165);
    const b = $4693a670e5985dc9$var$b1(x * 0.069407491 - y * 0.22898585 + z * 1.159737864);
    return [
        (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(r + 0.5 | 0, 0, 255),
        (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(g + 0.5 | 0, 0, 255),
        (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(b + 0.5 | 0, 0, 255),
        color[3]
    ];
}
function $4693a670e5985dc9$export$3004f64547af360e(s) {
    if (s === 'none') return $4693a670e5985dc9$export$6c844c64a5efe1ee;
    if ($4693a670e5985dc9$var$cache.hasOwnProperty(s)) return $4693a670e5985dc9$var$cache[s];
    if ($4693a670e5985dc9$var$cacheSize >= $4693a670e5985dc9$var$MAX_CACHE_SIZE) {
        let i = 0;
        for(const key in $4693a670e5985dc9$var$cache)if ((i++ & 3) === 0) {
            delete $4693a670e5985dc9$var$cache[key];
            --$4693a670e5985dc9$var$cacheSize;
        }
    }
    const color = $4693a670e5985dc9$var$parseRgba(s);
    if (color.length !== 4) $4693a670e5985dc9$var$throwInvalidColor(s);
    for (const c of color)if (isNaN(c)) $4693a670e5985dc9$var$throwInvalidColor(s);
    $4693a670e5985dc9$var$cache[s] = color;
    ++$4693a670e5985dc9$var$cacheSize;
    return color;
}
function $4693a670e5985dc9$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    return $4693a670e5985dc9$export$3004f64547af360e(color);
}
function $4693a670e5985dc9$export$f84e8e69fd4488a5(color) {
    let r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    let g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    let b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    const a = color[3] === undefined ? 1 : Math.round(color[3] * 1000) / 1000;
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
}
function $4693a670e5985dc9$export$40dd713d7775a0b1(s) {
    try {
        $4693a670e5985dc9$export$3004f64547af360e(s);
        return true;
    } catch  {
        return false;
    }
}


/**
 * @module ol/expr/cpu
 */ 
/**
 * @module ol/expr/expression
 */ 

/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $090e4507b3b63c57$export$ab1029bcae9ddb4a(size, num, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] + 2 * num;
    dest[1] = size[1] + 2 * num;
    return dest;
}
function $090e4507b3b63c57$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $090e4507b3b63c57$export$dcdf75081b88279d(size, ratio, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] * ratio + 0.5 | 0;
    dest[1] = size[1] * ratio + 0.5 | 0;
    return dest;
}
function $090e4507b3b63c57$export$a71a825ff42fb8e1(size, dest) {
    if (Array.isArray(size)) return size;
    if (dest === undefined) dest = [
        size,
        size
    ];
    else {
        dest[0] = size;
        dest[1] = size;
    }
    return dest;
}


/**
 * @fileoverview This module includes types and functions for parsing array encoded expressions.
 * The result of parsing an encoded expression is one of the specific expression classes.
 * During parsing, information is added to the parsing context about the data accessed by the
 * expression.
 */ /**
 * Base type used for literal style parameters; can be a number literal or the output of an operator,
 * which in turns takes {@link import("./expression.js").ExpressionValue} arguments.
 *
 * See below for details on the available operators (with notes for those that are WebGL or Canvas only).
 *
 * Reading operators:
 *   `['band', bandIndex, xOffset, yOffset]` For tile layers only. Fetches pixel values from band
 *     `bandIndex` of the source's data. The first `bandIndex` of the source data is `1`. Fetched values
 *     are in the 0..1 range. {@link import("../source/TileImage.js").default} sources have 4 bands: red,
 *     green, blue and alpha. {@link import("../source/DataTile.js").default} sources can have any number
 *     of bands, depending on the underlying data source and
 *     {@link import("../source/GeoTIFF.js").Options configuration}. `xOffset` and `yOffset` are optional
 *     and allow specifying pixel offsets for x and y. This is used for sampling data from neighboring pixels (WebGL only).
 *   `['get', attributeName]` fetches a feature property value, similar to `feature.get('attributeName')`.
 *   `['get', attributeName, keyOrArrayIndex, ...]` (Canvas only) Access nested properties and array items of a
 *     feature property. The result is `undefined` when there is nothing at the specified key or index.
 *   `['geometry-type']` returns a feature's geometry type as string, either: 'LineString', 'Point' or 'Polygon'
 *     `Multi*` values are returned as their singular equivalent
 *     `Circle` geometries are returned as 'Polygon'
 *     `GeometryCollection` geometries are returned as the type of the first geometry found in the collection (WebGL only).
 *   `['resolution']` returns the current resolution
 *   `['time']` The time in seconds since the creation of the layer (WebGL only).
 *   `['var', 'varName']` fetches a value from the style variables; will throw an error if that variable is undefined
 *   `['zoom']` The current zoom level (WebGL only).
 *   `['line-metric']` returns the M component of the current point on a line (WebGL only); in case where the geometry layout of the line
 *      does not contain an M component (e.g. XY or XYZ), 0 is returned; 0 is also returned for geometries other than lines.
 *      Please note that the M component will be linearly interpolated between the two points composing a segment.
 *
 * Math operators:
 *   `['*', value1, value2, ...]` multiplies the values (either numbers or colors)
 *   `['/', value1, value2]` divides `value1` by `value2`
 *   `['+', value1, value2, ...]` adds the values
 *   `['-', value1, value2]` subtracts `value2` from `value1`
 *   `['clamp', value, low, high]` clamps `value` between `low` and `high`
 *   `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 *   `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 *   `['abs', value1]` returns the absolute value of `value1`
 *   `['floor', value1]` returns the nearest integer less than or equal to `value1`
 *   * `['round', value1]` returns the nearest integer to `value1`
 *   * `['ceil', value1]` returns the nearest integer greater than or equal to `value1`
 *   * `['sin', value1]` returns the sine of `value1`
 *   * `['cos', value1]` returns the cosine of `value1`
 *   * `['atan', value1, value2]` returns `atan2(value1, value2)`. If `value2` is not provided, returns `atan(value1)`
 *   * `['sqrt', value1]` returns the square root of `value1`
 *
 * * Transform operators:
 *   * `['case', condition1, output1, ...conditionN, outputN, fallback]` selects the first output whose corresponding
 *     condition evaluates to `true`. If no match is found, returns the `fallback` value.
 *     All conditions should be `boolean`, output and fallback can be any kind.
 *   * `['match', input, match1, output1, ...matchN, outputN, fallback]` compares the `input` value against all
 *     provided `matchX` values, returning the output associated with the first valid match. If no match is found,
 *     returns the `fallback` value.
 *     `input` and `matchX` values must all be of the same type, and can be `number` or `string`. `outputX` and
 *     `fallback` values must be of the same type, and can be of any kind.
 *   * `['interpolate', interpolation, input, stop1, output1, ...stopN, outputN]` returns a value by interpolating between
 *     pairs of inputs and outputs; `interpolation` can either be `['linear']` or `['exponential', base]` where `base` is
 *     the rate of increase from stop A to stop B (i.e. power to which the interpolation ratio is raised); a value
 *     of 1 is equivalent to `['linear']`.
 *     `input` and `stopX` values must all be of type `number`. `outputX` values can be `number` or `color` values.
 *     Note: `input` will be clamped between `stop1` and `stopN`, meaning that all output values will be comprised
 *     between `output1` and `outputN`.
 *   * `['string', value1, value2, ...]` returns the first value in the list that evaluates to a string.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 'default value']]`
 *     (Canvas only).
 *   * `['number', value1, value2, ...]` returns the first value in the list that evaluates to a number.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 42]]`
 *     (Canvas only).
 *   * `['coalesce', value1, value2, ...]` returns the first value in the list which is not null or undefined.
 *     An example would be to provide a default value for get: `['coalesce', ['get','propertyname'], 'default value']]`
 *     (Canvas only).
 *
 * * Logical operators:
 *   * `['<', value1, value2]` returns `true` if `value1` is strictly lower than `value2`, or `false` otherwise.
 *   * `['<=', value1, value2]` returns `true` if `value1` is lower than or equals `value2`, or `false` otherwise.
 *   * `['>', value1, value2]` returns `true` if `value1` is strictly greater than `value2`, or `false` otherwise.
 *   * `['>=', value1, value2]` returns `true` if `value1` is greater than or equals `value2`, or `false` otherwise.
 *   * `['==', value1, value2]` returns `true` if `value1` equals `value2`, or `false` otherwise.
 *   * `['!=', value1, value2]` returns `true` if `value1` does not equal `value2`, or `false` otherwise.
 *   * `['!', value1]` returns `false` if `value1` is `true` or greater than `0`, or `true` otherwise.
 *   * `['all', value1, value2, ...]` returns `true` if all the inputs are `true`, `false` otherwise.
 *   * `['any', value1, value2, ...]` returns `true` if any of the inputs are `true`, `false` otherwise.
 *   * `['has', attributeName, keyOrArrayIndex, ...]` returns `true` if feature properties include the (nested) key `attributeName`,
 *     `false` otherwise.
 *     Note that for WebGL layers, the hardcoded value `-9999999` is used to distinguish when a property is not defined.
 *   * `['between', value1, value2, value3]` returns `true` if `value1` is contained between `value2` and `value3`
 *     (inclusively), or `false` otherwise.
 *   * `['in', needle, haystack]` returns `true` if `needle` is found in `haystack`, and
 *     `false` otherwise.
 *     This operator has the following limitations:
 *     * `haystack` has to be an array of numbers or strings (searching for a substring in a string is not supported yet)
 *     * Only literal arrays are supported as `haystack` for now; this means that `haystack` cannot be the result of an
 *     expression. If `haystack` is an array of strings, use the `literal` operator to disambiguate from an expression:
 *     `['literal', ['abc', 'def', 'ghi']]`
 *
 * * Conversion operators:
 *   * `['array', value1, ...valueN]` creates a numerical array from `number` values; please note that the amount of
 *     values can currently only be 2, 3 or 4 (WebGL only).
 *   * `['color', red, green, blue, alpha]` or `['color', shade, alpha]` creates a `color` value from `number` values;
 *     the `alpha` parameter is optional; if not specified, it will be set to 1 (WebGL only).
 *     Note: `red`, `green` and `blue` or `shade` components must be values between 0 and 255; `alpha` between 0 and 1.
 *   * `['palette', index, colors]` picks a `color` value from an array of colors using the given index; the `index`
 *     expression must evaluate to a number; the items in the `colors` array must be strings with hex colors
 *     (e.g. `'#86A136'`), colors using the rgba[a] functional notation (e.g. `'rgb(134, 161, 54)'` or `'rgba(134, 161, 54, 1)'`),
 *     named colors (e.g. `'red'`), or array literals with 3 ([r, g, b]) or 4 ([r, g, b, a]) values (with r, g, and b
 *     in the 0-255 range and a in the 0-1 range) (WebGL only).
 *   * `['to-string', value]` converts the input value to a string. If the input is a boolean, the result is "true" or "false".
 *     If the input is a number, it is converted to a string as specified by the "NumberToString" algorithm of the ECMAScript
 *     Language Specification. If the input is a color, it is converted to a string of the form "rgba(r,g,b,a)". (Canvas only)
 *
 * Values can either be literals or another operator, as they will be evaluated recursively.
 * Literal values can be of the following types:
 * * `boolean`
 * * `number`
 * * `number[]` (number arrays can only have a length of 2, 3 or 4)
 * * `string`
 * * {@link module:ol/color~Color}
 *
 * @typedef {Array<*>|import("../color.js").Color|string|number|boolean} ExpressionValue
 * @api
 */ let $63c8696b1aaf99a7$var$numTypes = 0;
const $63c8696b1aaf99a7$export$267d7ad6fa96ffaf = 0;
const $63c8696b1aaf99a7$export$240f7fffab1b25a0 = 1 << $63c8696b1aaf99a7$var$numTypes++;
const $63c8696b1aaf99a7$export$86a7aca748b1e260 = 1 << $63c8696b1aaf99a7$var$numTypes++;
const $63c8696b1aaf99a7$export$2b93044cbf134323 = 1 << $63c8696b1aaf99a7$var$numTypes++;
const $63c8696b1aaf99a7$export$2cd82751acc0e609 = 1 << $63c8696b1aaf99a7$var$numTypes++;
const $63c8696b1aaf99a7$export$d701d0e49f4bcb39 = 1 << $63c8696b1aaf99a7$var$numTypes++;
const $63c8696b1aaf99a7$export$52725c8a6d4c61d1 = 1 << $63c8696b1aaf99a7$var$numTypes++;
const $63c8696b1aaf99a7$export$ec4c9a150bae86cd = Math.pow(2, $63c8696b1aaf99a7$var$numTypes) - 1;
const $63c8696b1aaf99a7$var$typeNames = {
    [$63c8696b1aaf99a7$export$240f7fffab1b25a0]: 'boolean',
    [$63c8696b1aaf99a7$export$86a7aca748b1e260]: 'number',
    [$63c8696b1aaf99a7$export$2b93044cbf134323]: 'string',
    [$63c8696b1aaf99a7$export$2cd82751acc0e609]: 'color',
    [$63c8696b1aaf99a7$export$d701d0e49f4bcb39]: 'number[]',
    [$63c8696b1aaf99a7$export$52725c8a6d4c61d1]: 'size'
};
const $63c8696b1aaf99a7$var$namedTypes = Object.keys($63c8696b1aaf99a7$var$typeNames).map(Number).sort((0, $9d07dd9052c3de0c$export$fcb633242ef15540));
/**
 * @param {number} type The type.
 * @return {boolean} The type is one of the specific types (not any or a union type).
 */ function $63c8696b1aaf99a7$var$isSpecific(type) {
    return type in $63c8696b1aaf99a7$var$typeNames;
}
function $63c8696b1aaf99a7$export$b2afc7c96b2b4a45(type) {
    const names = [];
    for (const namedType of $63c8696b1aaf99a7$var$namedTypes)if ($63c8696b1aaf99a7$export$9fdcb8b441c4f2b4(type, namedType)) names.push($63c8696b1aaf99a7$var$typeNames[namedType]);
    if (names.length === 0) return 'untyped';
    if (names.length < 3) return names.join(' or ');
    return names.slice(0, -1).join(', ') + ', or ' + names[names.length - 1];
}
function $63c8696b1aaf99a7$export$9fdcb8b441c4f2b4(broad, specific) {
    return (broad & specific) === specific;
}
function $63c8696b1aaf99a7$export$3252d368d784c970(oneType, otherType) {
    return !!(oneType & otherType);
}
function $63c8696b1aaf99a7$export$26b9f946b448f23e(type, expected) {
    return type === expected;
}
class $63c8696b1aaf99a7$export$eb63e96e0913dda4 {
    /**
   * @param {number} type The value type.
   * @param {LiteralValue} value The literal value.
   */ constructor(type, value){
        if (!$63c8696b1aaf99a7$var$isSpecific(type)) throw new Error(`literal expressions must have a specific type, got ${$63c8696b1aaf99a7$export$b2afc7c96b2b4a45(type)}`);
        this.type = type;
        this.value = value;
    }
}
class $63c8696b1aaf99a7$export$6f3d80189eb72cd4 {
    /**
   * @param {number} type The return type.
   * @param {string} operator The operator.
   * @param {...Expression} args The arguments.
   */ constructor(type, operator, ...args){
        this.type = type;
        this.operator = operator;
        this.args = args;
    }
}
function $63c8696b1aaf99a7$export$1c8b4c1584800354() {
    return {
        variables: new Set(),
        properties: new Set(),
        featureId: false,
        geometryType: false,
        mapState: false
    };
}
function $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded, expectedType, context) {
    switch(typeof encoded){
        case 'boolean':
            if ($63c8696b1aaf99a7$export$26b9f946b448f23e(expectedType, $63c8696b1aaf99a7$export$2b93044cbf134323)) return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$2b93044cbf134323, encoded ? 'true' : 'false');
            if (!$63c8696b1aaf99a7$export$9fdcb8b441c4f2b4(expectedType, $63c8696b1aaf99a7$export$240f7fffab1b25a0)) throw new Error(`got a boolean, but expected ${$63c8696b1aaf99a7$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$240f7fffab1b25a0, encoded);
        case 'number':
            if ($63c8696b1aaf99a7$export$26b9f946b448f23e(expectedType, $63c8696b1aaf99a7$export$52725c8a6d4c61d1)) return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$52725c8a6d4c61d1, (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(encoded));
            if ($63c8696b1aaf99a7$export$26b9f946b448f23e(expectedType, $63c8696b1aaf99a7$export$240f7fffab1b25a0)) return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$240f7fffab1b25a0, !!encoded);
            if ($63c8696b1aaf99a7$export$26b9f946b448f23e(expectedType, $63c8696b1aaf99a7$export$2b93044cbf134323)) return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$2b93044cbf134323, encoded.toString());
            if (!$63c8696b1aaf99a7$export$9fdcb8b441c4f2b4(expectedType, $63c8696b1aaf99a7$export$86a7aca748b1e260)) throw new Error(`got a number, but expected ${$63c8696b1aaf99a7$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$86a7aca748b1e260, encoded);
        case 'string':
            if ($63c8696b1aaf99a7$export$26b9f946b448f23e(expectedType, $63c8696b1aaf99a7$export$2cd82751acc0e609)) return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$2cd82751acc0e609, (0, $4693a670e5985dc9$export$3004f64547af360e)(encoded));
            if ($63c8696b1aaf99a7$export$26b9f946b448f23e(expectedType, $63c8696b1aaf99a7$export$240f7fffab1b25a0)) return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$240f7fffab1b25a0, !!encoded);
            if (!$63c8696b1aaf99a7$export$9fdcb8b441c4f2b4(expectedType, $63c8696b1aaf99a7$export$2b93044cbf134323)) throw new Error(`got a string, but expected ${$63c8696b1aaf99a7$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$2b93044cbf134323, encoded);
        default:
    }
    if (!Array.isArray(encoded)) throw new Error('expression must be an array or a primitive value');
    if (encoded.length === 0) throw new Error('empty expression');
    if (typeof encoded[0] === 'string') return $63c8696b1aaf99a7$var$parseCallExpression(encoded, expectedType, context);
    for (const item of encoded){
        if (typeof item !== 'number') throw new Error('expected an array of numbers');
    }
    if ($63c8696b1aaf99a7$export$26b9f946b448f23e(expectedType, $63c8696b1aaf99a7$export$52725c8a6d4c61d1)) {
        if (encoded.length !== 2) throw new Error(`expected an array of two values for a size, got ${encoded.length}`);
        return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$52725c8a6d4c61d1, encoded);
    }
    if ($63c8696b1aaf99a7$export$26b9f946b448f23e(expectedType, $63c8696b1aaf99a7$export$2cd82751acc0e609)) {
        if (encoded.length === 3) return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$2cd82751acc0e609, [
            ...encoded,
            1
        ]);
        if (encoded.length === 4) return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$2cd82751acc0e609, encoded);
        throw new Error(`expected an array of 3 or 4 values for a color, got ${encoded.length}`);
    }
    if (!$63c8696b1aaf99a7$export$9fdcb8b441c4f2b4(expectedType, $63c8696b1aaf99a7$export$d701d0e49f4bcb39)) throw new Error(`got an array of numbers, but expected ${$63c8696b1aaf99a7$export$b2afc7c96b2b4a45(expectedType)}`);
    return new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$d701d0e49f4bcb39, encoded);
}
const $63c8696b1aaf99a7$export$2655e45458bc48f3 = {
    Get: 'get',
    Var: 'var',
    Concat: 'concat',
    GeometryType: 'geometry-type',
    LineMetric: 'line-metric',
    Any: 'any',
    All: 'all',
    Not: '!',
    Resolution: 'resolution',
    Zoom: 'zoom',
    Time: 'time',
    Equal: '==',
    NotEqual: '!=',
    GreaterThan: '>',
    GreaterThanOrEqualTo: '>=',
    LessThan: '<',
    LessThanOrEqualTo: '<=',
    Multiply: '*',
    Divide: '/',
    Add: '+',
    Subtract: '-',
    Clamp: 'clamp',
    Mod: '%',
    Pow: '^',
    Abs: 'abs',
    Floor: 'floor',
    Ceil: 'ceil',
    Round: 'round',
    Sin: 'sin',
    Cos: 'cos',
    Atan: 'atan',
    Sqrt: 'sqrt',
    Match: 'match',
    Between: 'between',
    Interpolate: 'interpolate',
    Coalesce: 'coalesce',
    Case: 'case',
    In: 'in',
    Number: 'number',
    String: 'string',
    Array: 'array',
    Color: 'color',
    Id: 'id',
    Band: 'band',
    Palette: 'palette',
    ToString: 'to-string',
    Has: 'has'
};
/**
 * @typedef {function(Array, number, ParsingContext):Expression} Parser
 *
 * Second argument is the expected type.
 */ /**
 * @type {Object<string, Parser>}
 */ const $63c8696b1aaf99a7$var$parsers = {
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Get]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, Infinity), $63c8696b1aaf99a7$var$withGetArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Var]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 1), $63c8696b1aaf99a7$var$withVarArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Has]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, Infinity), $63c8696b1aaf99a7$var$withGetArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Id]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$usesFeatureId, $63c8696b1aaf99a7$var$withNoArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Concat]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, Infinity), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$2b93044cbf134323)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.GeometryType]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$usesGeometryType, $63c8696b1aaf99a7$var$withNoArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.LineMetric]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$withNoArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Resolution]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$usesMapState, $63c8696b1aaf99a7$var$withNoArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Zoom]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$usesMapState, $63c8696b1aaf99a7$var$withNoArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Time]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$usesMapState, $63c8696b1aaf99a7$var$withNoArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Any]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, Infinity), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$240f7fffab1b25a0)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.All]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, Infinity), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$240f7fffab1b25a0)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Not]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 1), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$240f7fffab1b25a0)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Equal]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, 2), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$ec4c9a150bae86cd)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.NotEqual]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, 2), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$ec4c9a150bae86cd)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.GreaterThan]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, 2), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.GreaterThanOrEqualTo]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, 2), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.LessThan]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, 2), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.LessThanOrEqualTo]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, 2), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Multiply]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, Infinity), $63c8696b1aaf99a7$var$withArgsOfReturnType),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Coalesce]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, Infinity), $63c8696b1aaf99a7$var$withArgsOfReturnType),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Divide]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, 2), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Add]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, Infinity), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Subtract]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, 2), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Clamp]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(3, 3), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Mod]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, 2), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Pow]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, 2), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Abs]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 1), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Floor]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 1), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Ceil]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 1), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Round]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 1), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Sin]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 1), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Cos]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 1), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Atan]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 2), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Sqrt]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 1), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Match]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(4, Infinity), $63c8696b1aaf99a7$var$hasEvenArgs, $63c8696b1aaf99a7$var$withMatchArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Between]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(3, 3), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Interpolate]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(6, Infinity), $63c8696b1aaf99a7$var$hasEvenArgs, $63c8696b1aaf99a7$var$withInterpolateArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Case]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(3, Infinity), $63c8696b1aaf99a7$var$hasOddArgs, $63c8696b1aaf99a7$var$withCaseArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.In]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, 2), $63c8696b1aaf99a7$var$withInArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Number]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, Infinity), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$ec4c9a150bae86cd)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.String]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, Infinity), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$ec4c9a150bae86cd)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Array]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, Infinity), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Color]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 4), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Band]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 3), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$86a7aca748b1e260)),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.Palette]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(2, 2), $63c8696b1aaf99a7$var$withPaletteArgs),
    [$63c8696b1aaf99a7$export$2655e45458bc48f3.ToString]: $63c8696b1aaf99a7$var$createCallExpressionParser($63c8696b1aaf99a7$var$hasArgsCount(1, 1), $63c8696b1aaf99a7$var$withArgsOfType($63c8696b1aaf99a7$export$240f7fffab1b25a0 | $63c8696b1aaf99a7$export$86a7aca748b1e260 | $63c8696b1aaf99a7$export$2b93044cbf134323 | $63c8696b1aaf99a7$export$2cd82751acc0e609))
};
/**
 * @typedef {function(Array<EncodedExpression>, number, ParsingContext):Array<Expression>|void} ArgValidator
 *
 * An argument validator applies various checks to an encoded expression arguments and
 * returns the parsed arguments if any.  The second argument is the return type of the call expression.
 */ /**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$withGetArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const args = new Array(argsCount);
    for(let i = 0; i < argsCount; ++i){
        const key = encoded[i + 1];
        switch(typeof key){
            case 'number':
                args[i] = new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$86a7aca748b1e260, key);
                break;
            case 'string':
                args[i] = new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$2b93044cbf134323, key);
                break;
            default:
                throw new Error(`expected a string key or numeric array index for a get operation, got ${key}`);
        }
        if (i === 0) context.properties.add(String(key));
    }
    return args;
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$withVarArgs(encoded, returnType, context) {
    const name = encoded[1];
    if (typeof name !== 'string') throw new Error('expected a string argument for var operation');
    context.variables.add(name);
    return [
        new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$2b93044cbf134323, name)
    ];
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$usesFeatureId(encoded, returnType, context) {
    context.featureId = true;
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$usesGeometryType(encoded, returnType, context) {
    context.geometryType = true;
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$usesMapState(encoded, returnType, context) {
    context.mapState = true;
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$withNoArgs(encoded, returnType, context) {
    const operation = encoded[0];
    if (encoded.length !== 1) throw new Error(`expected no arguments for ${operation} operation`);
    return [];
}
/**
 * @param {number} minArgs The minimum number of arguments.
 * @param {number} maxArgs The maximum number of arguments.
 * @return {ArgValidator} The argument validator
 */ function $63c8696b1aaf99a7$var$hasArgsCount(minArgs, maxArgs) {
    return function(encoded, returnType, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        if (minArgs === maxArgs) {
            if (argCount !== minArgs) {
                const plural = minArgs === 1 ? '' : 's';
                throw new Error(`expected ${minArgs} argument${plural} for ${operation}, got ${argCount}`);
            }
        } else if (argCount < minArgs || argCount > maxArgs) {
            const range = maxArgs === Infinity ? `${minArgs} or more` : `${minArgs} to ${maxArgs}`;
            throw new Error(`expected ${range} arguments for ${operation}, got ${argCount}`);
        }
    };
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$withArgsOfReturnType(encoded, returnType, context) {
    const argCount = encoded.length - 1;
    /**
   * @type {Array<Expression>}
   */ const args = new Array(argCount);
    for(let i = 0; i < argCount; ++i){
        const expression = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[i + 1], returnType, context);
        args[i] = expression;
    }
    return args;
}
/**
 * @param {number} argType The argument type.
 * @return {ArgValidator} The argument validator
 */ function $63c8696b1aaf99a7$var$withArgsOfType(argType) {
    return function(encoded, returnType, context) {
        const argCount = encoded.length - 1;
        /**
     * @type {Array<Expression>}
     */ const args = new Array(argCount);
        for(let i = 0; i < argCount; ++i){
            const expression = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[i + 1], argType, context);
            args[i] = expression;
        }
        return args;
    };
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$hasOddArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 0) throw new Error(`expected an odd number of arguments for ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$hasEvenArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 1) throw new Error(`expected an even number of arguments for operation ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$withMatchArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const inputType = $63c8696b1aaf99a7$export$2b93044cbf134323 | $63c8696b1aaf99a7$export$86a7aca748b1e260 | $63c8696b1aaf99a7$export$240f7fffab1b25a0;
    const input = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[1], inputType, context);
    const fallback = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(argsCount - 2);
    for(let i = 0; i < argsCount - 2; i += 2){
        try {
            const match = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[i + 2], input.type, context);
            args[i] = match;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of match expression: ${err.message}`);
        }
        try {
            const output = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[i + 3], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} of match expression: ${err.message}`);
        }
    }
    return [
        input,
        ...args,
        fallback
    ];
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$withInterpolateArgs(encoded, returnType, context) {
    const interpolationType = encoded[1];
    /**
   * @type {number}
   */ let base;
    switch(interpolationType[0]){
        case 'linear':
            base = 1;
            break;
        case 'exponential':
            const b = interpolationType[1];
            if (typeof b !== 'number' || b <= 0) throw new Error(`expected a number base for exponential interpolation` + `, got ${JSON.stringify(b)} instead`);
            base = b;
            break;
        default:
            throw new Error(`invalid interpolation type: ${JSON.stringify(interpolationType)}`);
    }
    const interpolation = new $63c8696b1aaf99a7$export$eb63e96e0913dda4($63c8696b1aaf99a7$export$86a7aca748b1e260, base);
    let input;
    try {
        input = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[2], $63c8696b1aaf99a7$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse argument 1 in interpolate expression: ${err.message}`);
    }
    const args = new Array(encoded.length - 3);
    for(let i = 0; i < args.length; i += 2){
        try {
            const stop = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[i + 3], $63c8696b1aaf99a7$export$86a7aca748b1e260, context);
            args[i] = stop;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} for interpolate expression: ${err.message}`);
        }
        try {
            const output = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[i + 4], returnType, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 3} for interpolate expression: ${err.message}`);
        }
    }
    return [
        interpolation,
        input,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$withCaseArgs(encoded, returnType, context) {
    const fallback = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(encoded.length - 1);
    for(let i = 0; i < args.length - 1; i += 2){
        try {
            const condition = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[i + 1], $63c8696b1aaf99a7$export$240f7fffab1b25a0, context);
            args[i] = condition;
        } catch (err) {
            throw new Error(`failed to parse argument ${i} of case expression: ${err.message}`);
        }
        try {
            const output = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[i + 2], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of case expression: ${err.message}`);
        }
    }
    args[args.length - 1] = fallback;
    return args;
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$withInArgs(encoded, returnType, context) {
    let haystack = encoded[2];
    if (!Array.isArray(haystack)) throw new Error(`the second argument for the "in" operator must be an array`);
    /**
   * @type {number}
   */ let needleType;
    if (typeof haystack[0] === 'string') {
        if (haystack[0] !== 'literal') throw new Error(`for the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions`);
        if (!Array.isArray(haystack[1])) throw new Error(`failed to parse "in" expression: the literal operator must be followed by an array`);
        haystack = haystack[1];
        needleType = $63c8696b1aaf99a7$export$2b93044cbf134323;
    } else needleType = $63c8696b1aaf99a7$export$86a7aca748b1e260;
    const args = new Array(haystack.length);
    for(let i = 0; i < args.length; i++)try {
        const arg = $63c8696b1aaf99a7$export$98e6a39c04603d36(haystack[i], needleType, context);
        args[i] = arg;
    } catch (err) {
        throw new Error(`failed to parse haystack item ${i} for "in" expression: ${err.message}`);
    }
    const needle = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[1], needleType, context);
    return [
        needle,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function $63c8696b1aaf99a7$var$withPaletteArgs(encoded, returnType, context) {
    let index;
    try {
        index = $63c8696b1aaf99a7$export$98e6a39c04603d36(encoded[1], $63c8696b1aaf99a7$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse first argument in palette expression: ${err.message}`);
    }
    const colors = encoded[2];
    if (!Array.isArray(colors)) throw new Error('the second argument of palette must be an array');
    const parsedColors = new Array(colors.length);
    for(let i = 0; i < parsedColors.length; i++){
        let color;
        try {
            color = $63c8696b1aaf99a7$export$98e6a39c04603d36(colors[i], $63c8696b1aaf99a7$export$2cd82751acc0e609, context);
        } catch (err) {
            throw new Error(`failed to parse color at index ${i} in palette expression: ${err.message}`);
        }
        if (!(color instanceof $63c8696b1aaf99a7$export$eb63e96e0913dda4)) throw new Error(`the palette color at index ${i} must be a literal value`);
        parsedColors[i] = color;
    }
    return [
        index,
        ...parsedColors
    ];
}
/**
 * @param {Array<ArgValidator>} validators A chain of argument validators.  The last validator is expected
 * to return the parsed arguments.
 * @return {Parser} The parser.
 */ function $63c8696b1aaf99a7$var$createCallExpressionParser(...validators) {
    return function(encoded, returnType, context) {
        const operator = encoded[0];
        /**
     * @type {Array<Expression>}
     */ let args;
        for(let i = 0; i < validators.length; i++){
            const parsed = validators[i](encoded, returnType, context);
            if (i == validators.length - 1) {
                if (!parsed) throw new Error('expected last argument validator to return the parsed args');
                args = parsed;
            }
        }
        return new $63c8696b1aaf99a7$export$6f3d80189eb72cd4(returnType, operator, ...args);
    };
}
/**
 * @param {Array} encoded The encoded expression.
 * @param {number} returnType The expected return type of the call expression.
 * @param {ParsingContext} context The parsing context.
 * @return {Expression} The parsed expression.
 */ function $63c8696b1aaf99a7$var$parseCallExpression(encoded, returnType, context) {
    const operator = encoded[0];
    const parser = $63c8696b1aaf99a7$var$parsers[operator];
    if (!parser) throw new Error(`unknown operator: ${operator}`);
    return parser(encoded, returnType, context);
}
function $63c8696b1aaf99a7$export$8da88d86d10c1295(geometry) {
    if (!geometry) return '';
    const type = geometry.getType();
    switch(type){
        case 'Point':
        case 'LineString':
        case 'Polygon':
            return type;
        case 'MultiPoint':
        case 'MultiLineString':
        case 'MultiPolygon':
            return /** @type {'Point'|'LineString'|'Polygon'} */ type.substring(5);
        case 'Circle':
            return 'Polygon';
        case 'GeometryCollection':
            return $63c8696b1aaf99a7$export$8da88d86d10c1295(/** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries()[0]);
        default:
            return '';
    }
}


function $42abb865eb659ee5$export$c18f39f0e136c26() {
    return {
        variables: {},
        properties: {},
        resolution: NaN,
        featureId: null,
        geometryType: ''
    };
}
function $42abb865eb659ee5$export$b5f535122a9211f0(encoded, type, context) {
    const expression = (0, $63c8696b1aaf99a7$export$98e6a39c04603d36)(encoded, type, context);
    return $42abb865eb659ee5$var$compileExpression(expression, context);
}
/**
 * @param {import("./expression.js").Expression} expression The expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $42abb865eb659ee5$var$compileExpression(expression, context) {
    if (expression instanceof (0, $63c8696b1aaf99a7$export$eb63e96e0913dda4)) {
        // convert colors to array if possible
        if (expression.type === (0, $63c8696b1aaf99a7$export$2cd82751acc0e609) && typeof expression.value === 'string') {
            const colorValue = (0, $4693a670e5985dc9$export$3004f64547af360e)(expression.value);
            return function() {
                return colorValue;
            };
        }
        return function() {
            return expression.value;
        };
    }
    const operator = expression.operator;
    switch(operator){
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Number:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).String:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Coalesce:
            return $42abb865eb659ee5$var$compileAssertionExpression(expression, context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Get:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Var:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Has:
            return $42abb865eb659ee5$var$compileAccessorExpression(expression, context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Id:
            return (context)=>context.featureId;
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).GeometryType:
            return (context)=>context.geometryType;
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Concat:
            {
                const args = expression.args.map((e)=>$42abb865eb659ee5$var$compileExpression(e, context));
                return (context)=>''.concat(...args.map((arg)=>arg(context).toString()));
            }
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Resolution:
            return (context)=>context.resolution;
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Any:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).All:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Between:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).In:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Not:
            return $42abb865eb659ee5$var$compileLogicalExpression(expression, context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Equal:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).NotEqual:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).LessThan:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).LessThanOrEqualTo:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).GreaterThan:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return $42abb865eb659ee5$var$compileComparisonExpression(expression, context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Multiply:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Divide:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Add:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Subtract:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Clamp:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Mod:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Pow:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Abs:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Floor:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Ceil:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Round:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Sin:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Cos:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Atan:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Sqrt:
            return $42abb865eb659ee5$var$compileNumericExpression(expression, context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Case:
            return $42abb865eb659ee5$var$compileCaseExpression(expression, context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Match:
            return $42abb865eb659ee5$var$compileMatchExpression(expression, context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Interpolate:
            return $42abb865eb659ee5$var$compileInterpolateExpression(expression, context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).ToString:
            return $42abb865eb659ee5$var$compileConvertExpression(expression, context);
        default:
            throw new Error(`Unsupported operator ${operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $42abb865eb659ee5$var$compileAssertionExpression(expression, context) {
    const type = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $42abb865eb659ee5$var$compileExpression(expression.args[i], context);
    switch(type){
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Coalesce:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value !== 'undefined' && value !== null) return value;
                }
                throw new Error('Expected one of the values to be non-null');
            };
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Number:
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).String:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value === type) return value;
                }
                throw new Error(`Expected one of the values to be a ${type}`);
            };
        default:
            throw new Error(`Unsupported assertion operator ${type}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $42abb865eb659ee5$var$compileAccessorExpression(expression, context) {
    const nameExpression = /** @type {LiteralExpression} */ expression.args[0];
    const name = /** @type {string} */ nameExpression.value;
    switch(expression.operator){
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Get:
            return (context)=>{
                const args = expression.args;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    value = value[key];
                }
                return value;
            };
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Var:
            return (context)=>context.variables[name];
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Has:
            return (context)=>{
                const args = expression.args;
                if (!(name in context.properties)) return false;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    if (!value || !Object.hasOwn(value, key)) return false;
                    value = value[key];
                }
                return true;
            };
        default:
            throw new Error(`Unsupported accessor operator ${expression.operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $42abb865eb659ee5$var$compileComparisonExpression(expression, context) {
    const op = expression.operator;
    const left = $42abb865eb659ee5$var$compileExpression(expression.args[0], context);
    const right = $42abb865eb659ee5$var$compileExpression(expression.args[1], context);
    switch(op){
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Equal:
            return (context)=>left(context) === right(context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).NotEqual:
            return (context)=>left(context) !== right(context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).LessThan:
            return (context)=>left(context) < right(context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).LessThanOrEqualTo:
            return (context)=>left(context) <= right(context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).GreaterThan:
            return (context)=>left(context) > right(context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return (context)=>left(context) >= right(context);
        default:
            throw new Error(`Unsupported comparison operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $42abb865eb659ee5$var$compileLogicalExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $42abb865eb659ee5$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Any:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (args[i](context)) return true;
                }
                return false;
            };
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).All:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (!args[i](context)) return false;
                }
                return true;
            };
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Between:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                const max = args[2](context);
                return value >= min && value <= max;
            };
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).In:
            return (context)=>{
                const value = args[0](context);
                for(let i = 1; i < length; ++i){
                    if (value === args[i](context)) return true;
                }
                return false;
            };
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Not:
            return (context)=>!args[0](context);
        default:
            throw new Error(`Unsupported logical operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {NumberEvaluator} The evaluator function.
 */ function $42abb865eb659ee5$var$compileNumericExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $42abb865eb659ee5$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Multiply:
            return (context)=>{
                let value = 1;
                for(let i = 0; i < length; ++i)value *= args[i](context);
                return value;
            };
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Divide:
            return (context)=>args[0](context) / args[1](context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Add:
            return (context)=>{
                let value = 0;
                for(let i = 0; i < length; ++i)value += args[i](context);
                return value;
            };
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Subtract:
            return (context)=>args[0](context) - args[1](context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Clamp:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                if (value < min) return min;
                const max = args[2](context);
                if (value > max) return max;
                return value;
            };
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Mod:
            return (context)=>args[0](context) % args[1](context);
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Pow:
            return (context)=>Math.pow(args[0](context), args[1](context));
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Abs:
            return (context)=>Math.abs(args[0](context));
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Floor:
            return (context)=>Math.floor(args[0](context));
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Ceil:
            return (context)=>Math.ceil(args[0](context));
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Round:
            return (context)=>Math.round(args[0](context));
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Sin:
            return (context)=>Math.sin(args[0](context));
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Cos:
            return (context)=>Math.cos(args[0](context));
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Atan:
            if (length === 2) return (context)=>Math.atan2(args[0](context), args[1](context));
            return (context)=>Math.atan(args[0](context));
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).Sqrt:
            return (context)=>Math.sqrt(args[0](context));
        default:
            throw new Error(`Unsupported numeric operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $42abb865eb659ee5$var$compileCaseExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $42abb865eb659ee5$var$compileExpression(expression.args[i], context);
    return (context)=>{
        for(let i = 0; i < length - 1; i += 2){
            const condition = args[i](context);
            if (condition) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $42abb865eb659ee5$var$compileMatchExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $42abb865eb659ee5$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const value = args[0](context);
        for(let i = 1; i < length - 1; i += 2){
            if (value === args[i](context)) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $42abb865eb659ee5$var$compileInterpolateExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $42abb865eb659ee5$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const base = args[0](context);
        const value = args[1](context);
        let previousInput;
        let previousOutput;
        for(let i = 2; i < length; i += 2){
            const input = args[i](context);
            let output = args[i + 1](context);
            const isColor = Array.isArray(output);
            if (isColor) output = (0, $4693a670e5985dc9$export$138c09bdd6bd797c)(output);
            if (input >= value) {
                if (i === 2) return output;
                if (isColor) return $42abb865eb659ee5$var$interpolateColor(base, value, previousInput, previousOutput, input, output);
                return $42abb865eb659ee5$var$interpolateNumber(base, value, previousInput, previousOutput, input, output);
            }
            previousInput = input;
            previousOutput = output;
        }
        return previousOutput;
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $42abb865eb659ee5$var$compileConvertExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $42abb865eb659ee5$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $63c8696b1aaf99a7$export$2655e45458bc48f3).ToString:
            return (context)=>{
                const value = args[0](context);
                if (expression.args[0].type === (0, $63c8696b1aaf99a7$export$2cd82751acc0e609)) return (0, $4693a670e5985dc9$export$f84e8e69fd4488a5)(value);
                return value.toString();
            };
        default:
            throw new Error(`Unsupported convert operator ${op}`);
    }
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {number} output1 The first output value.
 * @param {number} input2 The second input value.
 * @param {number} output2 The second output value.
 * @return {number} The interpolated value.
 */ function $42abb865eb659ee5$var$interpolateNumber(base, value, input1, output1, input2, output2) {
    const delta = input2 - input1;
    if (delta === 0) return output1;
    const along = value - input1;
    const factor = base === 1 ? along / delta : (Math.pow(base, along) - 1) / (Math.pow(base, delta) - 1);
    return output1 + factor * (output2 - output1);
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {import('../color.js').Color} rgba1 The first output value.
 * @param {number} input2 The second input value.
 * @param {import('../color.js').Color} rgba2 The second output value.
 * @return {import('../color.js').Color} The interpolated color.
 */ function $42abb865eb659ee5$var$interpolateColor(base, value, input1, rgba1, input2, rgba2) {
    const delta = input2 - input1;
    if (delta === 0) return rgba1;
    const lcha1 = (0, $4693a670e5985dc9$export$44fb54fa2e0c0d4)(rgba1);
    const lcha2 = (0, $4693a670e5985dc9$export$44fb54fa2e0c0d4)(rgba2);
    let deltaHue = lcha2[2] - lcha1[2];
    if (deltaHue > 180) deltaHue -= 360;
    else if (deltaHue < -180) deltaHue += 360;
    const lcha = [
        $42abb865eb659ee5$var$interpolateNumber(base, value, input1, lcha1[0], input2, lcha2[0]),
        $42abb865eb659ee5$var$interpolateNumber(base, value, input1, lcha1[1], input2, lcha2[1]),
        lcha1[2] + $42abb865eb659ee5$var$interpolateNumber(base, value, input1, 0, input2, deltaHue),
        $42abb865eb659ee5$var$interpolateNumber(base, value, input1, rgba1[3], input2, rgba2[3])
    ];
    return (0, $4693a670e5985dc9$export$27cc94530c050f00)(lcha);
}





/**
 * @module ol/style/Circle
 */ /**
 * @module ol/style/RegularShape
 */ /**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $ab3525cfdb664b81$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};



/**
 * @module ol/colorlike
 */ 


/**
 * @module ol/style/IconImage
 */ /**
 * @module ol/Image
 */ 





/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(import("./Image.js").default, string): void} LoadFunction
 * @api
 */ /**
 * @typedef {Object} ImageObject
 * @property {import("./extent.js").Extent} [extent] Extent, if different from the requested one.
 * @property {import("./resolution.js").ResolutionLike} [resolution] Resolution, if different from the requested one.
 * When x and y resolution are different, use the array type (`[xResolution, yResolution]`).
 * @property {number} [pixelRatio] Pixel ratio, if different from the requested one.
 * @property {import('./DataTile.js').ImageLike} image Image.
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * For images that cover any extent and resolution (static images), the loader function should not accept
 * any arguments. The function returns an {@link import("./DataTile.js").ImageLike image}, an
 * {@link import("./Image.js").ImageObject image object}, or a promise for the same.
 * For loaders that generate images, the promise should not resolve until the image is loaded.
 * If the returned image does not match the extent, resolution or pixel ratio passed to the loader,
 * it has to return an {@link import("./Image.js").ImageObject image object} with the `image` and the
 * correct `extent`, `resolution` and `pixelRatio`.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} Loader
 * @api
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * The function returns a promise for an  {@link import("./Image.js").ImageObject image object}.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): Promise<import("./DataTile.js").ImageLike|ImageObject>} ImageObjectPromiseLoader
 */ class $ed625c77f0e14437$var$ImageWrapper extends (0, $dc972e87e0b45224$export$2e2bcd8739ae039) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|Array<number>|undefined} resolution Resolution. If provided as array, x and y
   * resolution will be assumed.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("./ImageState.js").default|Loader} stateOrLoader State.
   */ constructor(extent, resolution, pixelRatio, stateOrLoader){
        super();
        /**
     * @protected
     * @type {import("./extent.js").Extent}
     */ this.extent = extent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @protected
     * @type {number|Array<number>|undefined}
     */ this.resolution = resolution;
        /**
     * @protected
     * @type {import("./ImageState.js").default}
     */ this.state = typeof stateOrLoader === 'function' ? (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).IDLE : stateOrLoader;
        /**
     * @private
     * @type {import('./DataTile.js').ImageLike|null}
     */ this.image_ = null;
        /**
     * @protected
     * @type {Loader|null}
     */ this.loader = typeof stateOrLoader === 'function' ? stateOrLoader : null;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @return {import("./extent.js").Extent} Extent.
   */ getExtent() {
        return this.extent;
    }
    /**
   * @return {import('./DataTile.js').ImageLike} Image.
   */ getImage() {
        return this.image_;
    }
    /**
   * @return {number} PixelRatio.
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * @return {number|Array<number>} Resolution.
   */ getResolution() {
        return /** @type {number} */ this.resolution;
    }
    /**
   * @return {import("./ImageState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).IDLE) {
            if (this.loader) {
                this.state = (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADING;
                this.changed();
                const resolution = this.getResolution();
                const requestResolution = Array.isArray(resolution) ? resolution[0] : resolution;
                (0, $1a39c7df251dabdd$export$4dbaaf6c79705e6c)(()=>this.loader(this.getExtent(), requestResolution, this.getPixelRatio())).then((image)=>{
                    if ('image' in image) this.image_ = image.image;
                    if ('extent' in image) this.extent = image.extent;
                    if ('resolution' in image) this.resolution = image.resolution;
                    if ('pixelRatio' in image) this.pixelRatio_ = image.pixelRatio;
                    if (image instanceof HTMLImageElement || (0, $6f9f9040ddfdc3ac$export$7478563940788376) && image instanceof ImageBitmap || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement) this.image_ = image;
                    this.state = (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED;
                }).catch((error)=>{
                    this.state = (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).ERROR;
                    console.error(error); // eslint-disable-line no-console
                }).finally(()=>this.changed());
            }
        }
    }
    /**
   * @param {import('./DataTile.js').ImageLike} image The image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number|Array<number>} resolution Resolution.
   */ setResolution(resolution) {
        this.resolution = resolution;
    }
}
function $ed625c77f0e14437$export$bc96ecc7c2a50764(image, loadHandler, errorHandler) {
    const img = /** @type {HTMLImageElement} */ image;
    let listening = true;
    let decoding = false;
    let loaded = false;
    const listenerKeys = [
        (0, $7d7dee7854c96264$export$8d2a95bc11b44725)(img, (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).LOAD, function() {
            loaded = true;
            if (!decoding) loadHandler();
        })
    ];
    if (img.src && (0, $6f9f9040ddfdc3ac$export$716f8695eedb9bad)) {
        decoding = true;
        img.decode().then(function() {
            if (listening) loadHandler();
        }).catch(function(error) {
            if (listening) {
                if (loaded) loadHandler();
                else errorHandler();
            }
        });
    } else listenerKeys.push((0, $7d7dee7854c96264$export$8d2a95bc11b44725)(img, (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).ERROR, errorHandler));
    return function unlisten() {
        listening = false;
        listenerKeys.forEach((0, $7d7dee7854c96264$export$b0a21c8b3c1c921));
    };
}
function $ed625c77f0e14437$export$11e63f7b0f3d9900(image, src) {
    return new Promise((resolve, reject)=>{
        function handleLoad() {
            unlisten();
            resolve(image);
        }
        function handleError() {
            unlisten();
            reject(new Error('Image load error'));
        }
        function unlisten() {
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
        }
        image.addEventListener('load', handleLoad);
        image.addEventListener('error', handleError);
        if (src) image.src = src;
    });
}
function $ed625c77f0e14437$export$a9e5af241c1bd389(image, src) {
    if (src) image.src = src;
    return image.src && (0, $6f9f9040ddfdc3ac$export$716f8695eedb9bad) ? new Promise((resolve, reject)=>image.decode().then(()=>resolve(image)).catch((e)=>image.complete && image.width ? resolve(image) : reject(e))) : $ed625c77f0e14437$export$11e63f7b0f3d9900(image);
}
function $ed625c77f0e14437$export$2f872c0f2117be69(image, src) {
    if (src) image.src = src;
    return image.src && (0, $6f9f9040ddfdc3ac$export$716f8695eedb9bad) && (0, $6f9f9040ddfdc3ac$export$7478563940788376) ? image.decode().then(()=>createImageBitmap(image)).catch((e)=>{
        if (image.complete && image.width) return image;
        throw e;
    }) : $ed625c77f0e14437$export$a9e5af241c1bd389(image);
}
var $ed625c77f0e14437$export$2e2bcd8739ae039 = $ed625c77f0e14437$var$ImageWrapper;







/**
 * @module ol/style/IconImageCache
 */ 


/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */ class $0c4a599876c09f47$var$IconImageCache {
    constructor(){
        /**
     * @type {!Object<string, import("./IconImage.js").default>}
     * @private
     */ this.cache_ = {};
        /**
     * @type {!Object<string, CanvasPattern>}
     * @private
     */ this.patternCache_ = {};
        /**
     * @type {number}
     * @private
     */ this.cacheSize_ = 0;
        /**
     * @type {number}
     * @private
     */ this.maxCacheSize_ = 1024;
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.cache_ = {};
        this.patternCache_ = {};
        this.cacheSize_ = 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.cacheSize_ > this.maxCacheSize_;
    }
    /**
   * FIXME empty description for jsdoc
   */ expire() {
        if (this.canExpireCache()) {
            let i = 0;
            for(const key in this.cache_){
                const iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    delete this.patternCache_[key];
                    --this.cacheSize_;
                }
            }
        }
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */ get(src, crossOrigin, color) {
        const key = $0c4a599876c09f47$export$611736262b635f8d(src, crossOrigin, color);
        return key in this.cache_ ? this.cache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {CanvasPattern} Icon image.
   */ getPattern(src, crossOrigin, color) {
        const key = $0c4a599876c09f47$export$611736262b635f8d(src, crossOrigin, color);
        return key in this.patternCache_ ? this.patternCache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @param {import("./IconImage.js").default|null} iconImage Icon image.
   * @param {boolean} [pattern] Also cache a `'repeat'` pattern with this `iconImage`.
   */ set(src, crossOrigin, color, iconImage, pattern) {
        const key = $0c4a599876c09f47$export$611736262b635f8d(src, crossOrigin, color);
        const update = key in this.cache_;
        this.cache_[key] = iconImage;
        if (pattern) {
            if (iconImage.getImageState() === (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).IDLE) iconImage.load();
            if (iconImage.getImageState() === (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADING) iconImage.ready().then(()=>{
                this.patternCache_[key] = (0, $32c8adb5331a7848$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), 'repeat');
            });
            else this.patternCache_[key] = (0, $32c8adb5331a7848$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), 'repeat');
        }
        if (!update) ++this.cacheSize_;
    }
    /**
   * Set the cache size of the icon cache. Default is `1024`. Change this value when
   * your map uses more than 1024 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */ setSize(maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    }
}
function $0c4a599876c09f47$export$611736262b635f8d(src, crossOrigin, color) {
    const colorString = color ? (0, $4693a670e5985dc9$export$75093a47a9fa838d)(color) : 'null';
    return crossOrigin + ':' + src + ':' + colorString;
}
var $0c4a599876c09f47$export$2e2bcd8739ae039 = $0c4a599876c09f47$var$IconImageCache;
const $0c4a599876c09f47$export$747ccdf771a87ab8 = new $0c4a599876c09f47$var$IconImageCache();


/**
 * @type {CanvasRenderingContext2D}
 */ let $d3964cb6e3bba2e9$var$taintedTestContext = null;
class $d3964cb6e3bba2e9$var$IconImage extends (0, $dc972e87e0b45224$export$2e2bcd8739ae039) {
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null} image Image.
   * @param {string|undefined} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../ImageState.js").default|undefined} imageState Image state.
   * @param {import("../color.js").Color|string|null} color Color.
   */ constructor(image, src, crossOrigin, imageState, color){
        super();
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null}
     */ this.image_ = image;
        /**
     * @private
     * @type {string|null}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */ this.canvas_ = {};
        /**
     * @private
     * @type {import("../color.js").Color|string|null}
     */ this.color_ = color;
        /**
     * @private
     * @type {import("../ImageState.js").default}
     */ this.imageState_ = imageState === undefined ? (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).IDLE : imageState;
        /**
     * @private
     * @type {import("../size.js").Size|null}
     */ this.size_ = image && image.width && image.height ? [
            image.width,
            image.height
        ] : null;
        /**
     * @private
     * @type {string|undefined}
     */ this.src_ = src;
        /**
     * @private
     */ this.tainted_;
        /**
     * @private
     * @type {Promise<void>|null}
     */ this.ready_ = null;
    }
    /**
   * @private
   */ initializeImage_() {
        this.image_ = new Image();
        if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
    }
    /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */ isTainted_() {
        if (this.tainted_ === undefined && this.imageState_ === (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED) {
            if (!$d3964cb6e3bba2e9$var$taintedTestContext) $d3964cb6e3bba2e9$var$taintedTestContext = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(1, 1, undefined, {
                willReadFrequently: true
            });
            $d3964cb6e3bba2e9$var$taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                $d3964cb6e3bba2e9$var$taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            } catch  {
                $d3964cb6e3bba2e9$var$taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    }
    /**
   * @private
   */ dispatchChangeEvent_() {
        this.dispatchEvent((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @private
   */ handleImageError_() {
        this.imageState_ = (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).ERROR;
        this.dispatchChangeEvent_();
    }
    /**
   * @private
   */ handleImageLoad_() {
        this.imageState_ = (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED;
        this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.dispatchChangeEvent_();
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element or image bitmap.
   */ getImage(pixelRatio) {
        if (!this.image_) this.initializeImage_();
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */ getPixelRatio(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */ getHitDetectionImage() {
        if (!this.image_) this.initializeImage_();
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                const width = this.size_[0];
                const height = this.size_[1];
                const context = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */ getSize() {
        return this.size_;
    }
    /**
   * @return {string|undefined} Image src.
   */ getSrc() {
        return this.src_;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.imageState_ !== (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).IDLE) return;
        if (!this.image_) this.initializeImage_();
        this.imageState_ = (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADING;
        try {
            if (this.src_ !== undefined) /** @type {HTMLImageElement} */ this.image_.src = this.src_;
        } catch  {
            this.handleImageError_();
        }
        if (this.image_ instanceof HTMLImageElement) (0, $ed625c77f0e14437$export$a9e5af241c1bd389)(this.image_, this.src_).then((image)=>{
            this.image_ = image;
            this.handleImageLoad_();
        }).catch(this.handleImageError_.bind(this));
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */ replaceColor_(pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED) return;
        const image = this.image_;
        const ctx = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(Math.ceil(image.width * pixelRatio), Math.ceil(image.height * pixelRatio));
        const canvas = ctx.canvas;
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(image, 0, 0);
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = (0, $4693a670e5985dc9$export$590567be997858b6)(this.color_);
        ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
        ctx.globalCompositeOperation = 'destination-in';
        ctx.drawImage(image, 0, 0);
        this.canvas_[pixelRatio] = canvas;
    }
    /**
   * @return {Promise<void>} Promise that resolves when the image is loaded.
   */ ready() {
        if (!this.ready_) this.ready_ = new Promise((resolve)=>{
            if (this.imageState_ === (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).ERROR) resolve();
            else {
                const onChange = ()=>{
                    if (this.imageState_ === (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).ERROR) {
                        this.removeEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, onChange);
                        resolve();
                    }
                };
                this.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, onChange);
            }
        });
        return this.ready_;
    }
}
function $d3964cb6e3bba2e9$export$3988ae62b71be9a3(image, cacheKey, crossOrigin, imageState, color, pattern) {
    let iconImage = cacheKey === undefined ? undefined : (0, $0c4a599876c09f47$export$747ccdf771a87ab8).get(cacheKey, crossOrigin, color);
    if (!iconImage) {
        iconImage = new $d3964cb6e3bba2e9$var$IconImage(image, image && 'src' in image ? image.src || undefined : cacheKey, crossOrigin, imageState, color);
        (0, $0c4a599876c09f47$export$747ccdf771a87ab8).set(cacheKey, crossOrigin, color, iconImage, pattern);
    }
    if (pattern && iconImage && !(0, $0c4a599876c09f47$export$747ccdf771a87ab8).getPattern(cacheKey, crossOrigin, color)) (0, $0c4a599876c09f47$export$747ccdf771a87ab8).set(cacheKey, crossOrigin, color, iconImage, pattern);
    return iconImage;
}
var $d3964cb6e3bba2e9$export$2e2bcd8739ae039 = $d3964cb6e3bba2e9$var$IconImage;



function $f23531dbd6538933$export$dc5b1400ac3a10a8(color) {
    if (!color) return null;
    if (Array.isArray(color)) return (0, $4693a670e5985dc9$export$f84e8e69fd4488a5)(color);
    if (typeof color === 'object' && 'src' in color) return $f23531dbd6538933$var$asCanvasPattern(color);
    return color;
}
/**
 * @param {PatternDescriptor} pattern Pattern descriptor.
 * @return {CanvasPattern|null} Canvas pattern or null if the pattern referenced in the
 * PatternDescriptor was not found in the icon image cache.
 */ function $f23531dbd6538933$var$asCanvasPattern(pattern) {
    if (!pattern.offset || !pattern.size) return (0, $0c4a599876c09f47$export$747ccdf771a87ab8).getPattern(pattern.src, 'anonymous', pattern.color);
    const cacheKey = pattern.src + ':' + pattern.offset;
    const canvasPattern = (0, $0c4a599876c09f47$export$747ccdf771a87ab8).getPattern(cacheKey, undefined, pattern.color);
    if (canvasPattern) return canvasPattern;
    const iconImage = (0, $0c4a599876c09f47$export$747ccdf771a87ab8).get(pattern.src, 'anonymous', null);
    if (iconImage.getImageState() !== (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED) return null;
    const patternCanvasContext = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(pattern.size[0], pattern.size[1]);
    patternCanvasContext.drawImage(iconImage.getImage(1), pattern.offset[0], pattern.offset[1], pattern.size[0], pattern.size[1], 0, 0, pattern.size[0], pattern.size[1]);
    (0, $d3964cb6e3bba2e9$export$3988ae62b71be9a3)(patternCanvasContext.canvas, cacheKey, undefined, (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED, pattern.color, true);
    return (0, $0c4a599876c09f47$export$747ccdf771a87ab8).getPattern(cacheKey, undefined, pattern.color);
}



/**
 * @module ol/render/canvas
 */ 




const $56d5de32f563e6ab$export$3847dfea4f8d4dfa = '10px sans-serif';
const $56d5de32f563e6ab$export$c495d52ee3fd74b2 = '#000';
const $56d5de32f563e6ab$export$17bd0c38d6ae694e = 'round';
const $56d5de32f563e6ab$export$e21b4112fdc612fc = [];
const $56d5de32f563e6ab$export$e06efc2409049f76 = 0;
const $56d5de32f563e6ab$export$365eb9648cf19bd0 = 'round';
const $56d5de32f563e6ab$export$80c1c01844597b7b = 10;
const $56d5de32f563e6ab$export$1eb2eaecacf2031e = '#000';
const $56d5de32f563e6ab$export$94d53b95641b5766 = 'center';
const $56d5de32f563e6ab$export$cf2279a1bff62eb = 'middle';
const $56d5de32f563e6ab$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
const $56d5de32f563e6ab$export$79661f132c62010e = 1;
const $56d5de32f563e6ab$export$1d36981fcadac93b = new (0, $32070d44509bac34$export$2e2bcd8739ae039)();
/**
 * @type {CanvasRenderingContext2D}
 */ let $56d5de32f563e6ab$var$measureContext = null;
/**
 * @type {string}
 */ let $56d5de32f563e6ab$var$measureFont;
const $56d5de32f563e6ab$export$7fdcec604f0b1fa7 = {};
const $56d5de32f563e6ab$export$a534074a28fa87ff = function() {
    const retries = 100;
    const size = '32px ';
    const referenceFonts = [
        'monospace',
        'serif'
    ];
    const len = referenceFonts.length;
    const text = 'wmytzilWMYTZIL@#/&?$%10\uF013';
    let interval, referenceWidth;
    /**
   * @param {string} fontStyle Css font-style
   * @param {string} fontWeight Css font-weight
   * @param {*} fontFamily Css font-family
   * @return {boolean} Font with style and weight is available
   */ function isAvailable(fontStyle, fontWeight, fontFamily) {
        let available = true;
        for(let i = 0; i < len; ++i){
            const referenceFont = referenceFonts[i];
            referenceWidth = $56d5de32f563e6ab$export$4ea92329b673abd1(fontStyle + ' ' + fontWeight + ' ' + size + referenceFont, text);
            if (fontFamily != referenceFont) {
                const width = $56d5de32f563e6ab$export$4ea92329b673abd1(fontStyle + ' ' + fontWeight + ' ' + size + fontFamily + ',' + referenceFont, text);
                // If width and referenceWidth are the same, then the fallback was used
                // instead of the font we wanted, so the font is not available.
                available = available && width != referenceWidth;
            }
        }
        if (available) return true;
        return false;
    }
    function check() {
        let done = true;
        const fonts = $56d5de32f563e6ab$export$1d36981fcadac93b.getKeys();
        for(let i = 0, ii = fonts.length; i < ii; ++i){
            const font = fonts[i];
            if ($56d5de32f563e6ab$export$1d36981fcadac93b.get(font) < retries) {
                const [style, weight, family] = font.split('\n');
                if (isAvailable(style, weight, family)) {
                    (0, $0364d4893e3f1129$export$42ffd38884aecdac)($56d5de32f563e6ab$export$7fdcec604f0b1fa7);
                    // Make sure that loaded fonts are picked up by Safari
                    $56d5de32f563e6ab$var$measureContext = null;
                    $56d5de32f563e6ab$var$measureFont = undefined;
                    $56d5de32f563e6ab$export$1d36981fcadac93b.set(font, retries);
                } else {
                    $56d5de32f563e6ab$export$1d36981fcadac93b.set(font, $56d5de32f563e6ab$export$1d36981fcadac93b.get(font) + 1, true);
                    done = false;
                }
            }
        }
        if (done) {
            clearInterval(interval);
            interval = undefined;
        }
    }
    return function(fontSpec) {
        const font = (0, $499ab6056ba431ad$export$5abde8a6aec4a131)(fontSpec);
        if (!font) return;
        const families = font.families;
        for(let i = 0, ii = families.length; i < ii; ++i){
            const family = families[i];
            const key = font.style + '\n' + font.weight + '\n' + family;
            if ($56d5de32f563e6ab$export$1d36981fcadac93b.get(key) === undefined) {
                $56d5de32f563e6ab$export$1d36981fcadac93b.set(key, retries, true);
                if (!isAvailable(font.style, font.weight, family)) {
                    $56d5de32f563e6ab$export$1d36981fcadac93b.set(key, 0, true);
                    if (interval === undefined) interval = setInterval(check, 32);
                }
            }
        }
    };
}();
const $56d5de32f563e6ab$export$4feaf6852ff92513 = function() {
    /**
   * @type {HTMLDivElement}
   */ let measureElement;
    return function(fontSpec) {
        let height = $56d5de32f563e6ab$export$7fdcec604f0b1fa7[fontSpec];
        if (height == undefined) {
            if (0, $6f9f9040ddfdc3ac$export$98fcef3dc9973292) {
                const font = (0, $499ab6056ba431ad$export$5abde8a6aec4a131)(fontSpec);
                const metrics = $56d5de32f563e6ab$var$measureText(fontSpec, "\u017Dg");
                const lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!measureElement) {
                    measureElement = document.createElement('div');
                    measureElement.innerHTML = 'M';
                    measureElement.style.minHeight = '0';
                    measureElement.style.maxHeight = 'none';
                    measureElement.style.height = 'auto';
                    measureElement.style.padding = '0';
                    measureElement.style.border = 'none';
                    measureElement.style.position = 'absolute';
                    measureElement.style.display = 'block';
                    measureElement.style.left = '-99999px';
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            $56d5de32f563e6ab$export$7fdcec604f0b1fa7[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function $56d5de32f563e6ab$var$measureText(font, text) {
    if (!$56d5de32f563e6ab$var$measureContext) $56d5de32f563e6ab$var$measureContext = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(1, 1);
    if (font != $56d5de32f563e6ab$var$measureFont) {
        $56d5de32f563e6ab$var$measureContext.font = font;
        $56d5de32f563e6ab$var$measureFont = $56d5de32f563e6ab$var$measureContext.font;
    }
    return $56d5de32f563e6ab$var$measureContext.measureText(text);
}
function $56d5de32f563e6ab$export$4ea92329b673abd1(font, text) {
    return $56d5de32f563e6ab$var$measureText(font, text).width;
}
function $56d5de32f563e6ab$export$915c7ba51467308f(font, text, cache) {
    if (text in cache) return cache[text];
    const width = text.split('\n').reduce((prev, curr)=>Math.max(prev, $56d5de32f563e6ab$export$4ea92329b673abd1(font, curr)), 0);
    cache[text] = width;
    return width;
}
function $56d5de32f563e6ab$export$7d7c13020df1e791(baseStyle, chunks) {
    const widths = [];
    const heights = [];
    const lineWidths = [];
    let width = 0;
    let lineWidth = 0;
    let height = 0;
    let lineHeight = 0;
    for(let i = 0, ii = chunks.length; i <= ii; i += 2){
        const text = chunks[i];
        if (text === '\n' || i === ii) {
            width = Math.max(width, lineWidth);
            lineWidths.push(lineWidth);
            lineWidth = 0;
            height += lineHeight;
            lineHeight = 0;
            continue;
        }
        const font = chunks[i + 1] || baseStyle.font;
        const currentWidth = $56d5de32f563e6ab$export$4ea92329b673abd1(font, text);
        widths.push(currentWidth);
        lineWidth += currentWidth;
        const currentHeight = $56d5de32f563e6ab$export$4feaf6852ff92513(font);
        heights.push(currentHeight);
        lineHeight = Math.max(lineHeight, currentHeight);
    }
    return {
        width: width,
        height: height,
        widths: widths,
        heights: heights,
        lineWidths: lineWidths
    };
}
function $56d5de32f563e6ab$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function $56d5de32f563e6ab$export$3cb6f3a6e49cc0ee(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) {
        if (context.globalAlpha === undefined) context.globalAlpha = (context)=>context.globalAlpha *= opacity;
        else context.globalAlpha *= opacity;
    }
    if (transform) context.transform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        $56d5de32f563e6ab$var$executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D} context Context.
 */ function $56d5de32f563e6ab$var$executeLabelInstructions(label, context) {
    const contextInstructions = label.contextInstructions;
    for(let i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}




/**
 * @module ol/style/Image
 */ 

/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 * @property {import('../style/Style.js').DeclutterMode} declutterMode Declutter mode: `declutter`, `obstacle`, `none`.
 */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ class $2f3f31e5de474dab$var$ImageStyle {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        /**
     * @private
     * @type {number}
     */ this.opacity_ = options.opacity;
        /**
     * @private
     * @type {boolean}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(options.scale);
        /**
     * @private
     * @type {Array<number>}
     */ this.displacement_ = options.displacement;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $2f3f31e5de474dab$var$ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */ getOpacity() {
        return this.opacity_;
    }
    /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */ getDisplacement() {
        return this.displacement_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */ getAnchor() {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getImage(pixelRatio) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getHitDetectionImage() {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ getPixelRatio(pixelRatio) {
        return 1;
    }
    /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */ getOrigin() {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */ getSize() {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */ setDisplacement(displacement) {
        this.displacement_ = displacement;
    }
    /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */ setOpacity(opacity) {
        this.opacity_ = opacity;
    }
    /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(scale);
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {
        (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Load not yet loaded URI.
   * @abstract
   */ load() {
        (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {
        (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @return {Promise<void>} `false` or Promise that resolves when the style is ready to use.
   */ ready() {
        return Promise.resolve();
    }
}
var $2f3f31e5de474dab$export$2e2bcd8739ae039 = $2f3f31e5de474dab$var$ImageStyle;


/**
 * Specify radius for regular polygons, or both radius and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} radius Radius of a regular polygon.
 * @property {number} [radius2] Second radius to make a star instead of a regular polygon.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's points facing up.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the shape in pixels.
 * Positive values will shift the shape right and up.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius` and `radius2`.
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike|undefined} strokeStyle StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>|null} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when both `radius` and
 * `radius2` are provided.
 * @api
 */ class $e039cc6cefab1c3f$var$RegularShape extends (0, $2f3f31e5de474dab$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super({
            opacity: 1,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {HTMLCanvasElement|null}
     */ this.hitDetectionCanvas_ = null;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.points_ = options.points;
        /**
     * @protected
     * @type {number}
     */ this.radius = options.radius;
        /**
     * @private
     * @type {number|undefined}
     */ this.radius2_ = options.radius2;
        /**
     * @private
     * @type {number}
     */ this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_;
        /**
     * @private
     * @type {RenderOptions}
     */ this.renderOptions_;
        /**
     * @private
     */ this.imageState_ = this.fill_ && this.fill_.loading() ? (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADING : (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED;
        if (this.imageState_ === (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADING) this.ready().then(()=>this.imageState_ = (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED);
        this.render();
    }
    /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $e039cc6cefab1c3f$var$RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        const size = this.size_;
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            size[0] / 2 - displacement[0] / scale[0],
            size[1] / 2 + displacement[1] / scale[1]
        ];
    }
    /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */ getAngle() {
        return this.angle_;
    }
    /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
        this.render();
    }
    /**
   * @return {HTMLCanvasElement} Image element.
   * @override
   */ getHitDetectionImage() {
        if (!this.hitDetectionCanvas_) this.hitDetectionCanvas_ = this.createHitDetectionCanvas_(this.renderOptions_);
        return this.hitDetectionCanvas_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement} Image or Canvas element.
   * @api
   * @override
   */ getImage(pixelRatio) {
        const fillKey = this.fill_?.getKey();
        const cacheKey = `${pixelRatio},${this.angle_},${this.radius},${this.radius2_},${this.points_},${fillKey}` + Object.values(this.renderOptions_).join(',');
        let image = /** @type {HTMLCanvasElement} */ (0, $0c4a599876c09f47$export$747ccdf771a87ab8).get(cacheKey, null, null)?.getImage(1);
        if (!image) {
            const renderOptions = this.renderOptions_;
            const size = Math.ceil(renderOptions.size * pixelRatio);
            const context = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(size, size);
            this.draw_(renderOptions, context, pixelRatio);
            image = context.canvas;
            (0, $0c4a599876c09f47$export$747ccdf771a87ab8).set(cacheKey, null, null, new (0, $d3964cb6e3bba2e9$export$2e2bcd8739ae039)(image, undefined, null, (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED, null));
        }
        return image;
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   * @override
   */ getPixelRatio(pixelRatio) {
        return pixelRatio;
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.size_;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        return this.origin_;
    }
    /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */ getPoints() {
        return this.points_;
    }
    /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return this.radius;
    }
    /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */ getRadius2() {
        return this.radius2_;
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   * @override
   */ getSize() {
        return this.size_;
    }
    /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
        this.render();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {}
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {}
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {}
    /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */ calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit) {
        if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== 'bevel' && lineJoin !== 'miter') return strokeWidth;
        // m  | ^
        // i  | |\                  .
        // t >|  #\
        // e  | |\ \              .
        // r      \s\
        //      |  \t\          .                 .
        //          \r\                      .   .
        //      |    \o\      .          .  . . .
        //          e \k\            .  .    . .
        //      |      \e\  .    .  .       . .
        //       d      \ \  .  .          . .
        //      | _ _a_ _\#  .            . .
        //   r1          / `             . .
        //      |                       . .
        //       b     /               . .
        //      |                     . .
        //           / r2            . .
        //      |                        .   .
        //         /                           .   .
        //      |α                                   .   .
        //       /                                         .   .
        //      ° center
        let r1 = this.radius;
        let r2 = this.radius2_ === undefined ? r1 : this.radius2_;
        if (r1 < r2) {
            const tmp = r1;
            r1 = r2;
            r2 = tmp;
        }
        const points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
        const alpha = 2 * Math.PI / points;
        const a = r2 * Math.sin(alpha);
        const b = Math.sqrt(r2 * r2 - a * a);
        const d = r1 - b;
        const e = Math.sqrt(a * a + d * d);
        const miterRatio = e / a;
        if (lineJoin === 'miter' && miterRatio <= miterLimit) return miterRatio * strokeWidth;
        // Calculate the distance from center to the stroke corner where
        // it was cut short because of the miter limit.
        //              l
        //        ----+---- <= distance from center to here is maxr
        //       /####|k ##\
        //      /#####^#####\
        //     /#### /+\# s #\
        //    /### h/+++\# t #\
        //   /### t/+++++\# r #\
        //  /### a/+++++++\# o #\
        // /### p/++ fill +\# k #\
        ///#### /+++++^+++++\# e #\
        //#####/+++++/+\+++++\#####\
        const k = strokeWidth / 2 / miterRatio;
        const l = strokeWidth / 2 * (d / e);
        const maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
        const bevelAdd = maxr - r1;
        if (this.radius2_ === undefined || lineJoin === 'bevel') return bevelAdd * 2;
        // If outer miter is over the miter limit the inner miter may reach through the
        // center and be longer than the bevel, same calculation as above but swap r1 / r2.
        const aa = r1 * Math.sin(alpha);
        const bb = Math.sqrt(r1 * r1 - aa * aa);
        const dd = r2 - bb;
        const ee = Math.sqrt(aa * aa + dd * dd);
        const innerMiterRatio = ee / aa;
        if (innerMiterRatio <= miterLimit) {
            const innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
            return 2 * Math.max(bevelAdd, innerLength);
        }
        return bevelAdd * 2;
    }
    /**
   * @return {RenderOptions}  The render options
   * @protected
   */ createRenderOptions() {
        let lineCap = (0, $56d5de32f563e6ab$export$17bd0c38d6ae694e);
        let lineJoin = (0, $56d5de32f563e6ab$export$365eb9648cf19bd0);
        let miterLimit = 0;
        let lineDash = null;
        let lineDashOffset = 0;
        let strokeStyle;
        let strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = (0, $f23531dbd6538933$export$dc5b1400ac3a10a8)(this.stroke_.getColor() ?? (0, $56d5de32f563e6ab$export$1eb2eaecacf2031e));
            strokeWidth = this.stroke_.getWidth() ?? (0, $56d5de32f563e6ab$export$79661f132c62010e);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset() ?? 0;
            lineJoin = this.stroke_.getLineJoin() ?? (0, $56d5de32f563e6ab$export$365eb9648cf19bd0);
            lineCap = this.stroke_.getLineCap() ?? (0, $56d5de32f563e6ab$export$17bd0c38d6ae694e);
            miterLimit = this.stroke_.getMiterLimit() ?? (0, $56d5de32f563e6ab$export$80c1c01844597b7b);
        }
        const add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
        const maxRadius = Math.max(this.radius, this.radius2_ || 0);
        const size = Math.ceil(2 * maxRadius + add);
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
    }
    /**
   * @protected
   */ render() {
        this.renderOptions_ = this.createRenderOptions();
        const size = this.renderOptions_.size;
        this.hitDetectionCanvas_ = null;
        this.size_ = [
            size,
            size
        ];
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */ draw_(renderOptions, context, pixelRatio) {
        context.scale(pixelRatio, pixelRatio);
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        if (this.fill_) {
            let color = this.fill_.getColor();
            if (color === null) color = (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2);
            context.fillStyle = (0, $f23531dbd6538933$export$dc5b1400ac3a10a8)(color);
            context.fill();
        }
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @return {HTMLCanvasElement} Canvas containing the icon
   */ createHitDetectionCanvas_(renderOptions) {
        let context;
        if (this.fill_) {
            let color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            let opacity = 0;
            if (typeof color === 'string') color = (0, $4693a670e5985dc9$export$75093a47a9fa838d)(color);
            if (color === null) opacity = 1;
            else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                context = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(renderOptions.size, renderOptions.size);
                this.drawHitDetectionCanvas_(renderOptions, context);
            }
        }
        return context ? context.canvas : this.getImage(1);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context The context to draw in.
   */ createPath_(context) {
        let points = this.points_;
        const radius = this.radius;
        if (points === Infinity) context.arc(0, 0, radius, 0, 2 * Math.PI);
        else {
            const radius2 = this.radius2_ === undefined ? radius : this.radius2_;
            if (this.radius2_ !== undefined) points *= 2;
            const startAngle = this.angle_ - Math.PI / 2;
            const step = 2 * Math.PI / points;
            for(let i = 0; i < points; i++){
                const angle0 = startAngle + i * step;
                const radiusC = i % 2 === 0 ? radius : radius2;
                context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
            }
            context.closePath();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The context.
   */ drawHitDetectionCanvas_(renderOptions, context) {
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        context.fillStyle = (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2);
        context.fill();
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @override
   */ ready() {
        return this.fill_ ? this.fill_.ready() : Promise.resolve();
    }
}
var $e039cc6cefab1c3f$export$2e2bcd8739ae039 = $e039cc6cefab1c3f$var$RegularShape;


/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ class $defdf327ea9989ab$var$CircleStyle extends (0, $e039cc6cefab1c3f$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {
            radius: 5
        };
        super({
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
    }
    /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $defdf327ea9989ab$var$CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Set the circle radius.
   *
   * @param {number} radius Circle radius.
   * @api
   */ setRadius(radius) {
        this.radius = radius;
        this.render();
    }
}
var $defdf327ea9989ab$export$2e2bcd8739ae039 = $defdf327ea9989ab$var$CircleStyle;


/**
 * @module ol/style/Fill
 */ 



/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} [color=null] A color,
 * gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats. For polygon fills (not for {@link import("./RegularShape.js").default} fills),
 * a pattern can also be provided as {@link module:ol/colorlike~PatternDescriptor}.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ class $138441ca74a86349$var$Fill {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("./IconImage.js").default|null}
     */ this.patternImage_ = null;
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null}
     */ this.color_ = null;
        if (options.color !== undefined) this.setColor(options.color);
    }
    /**
   * Clones the style. The color is not cloned if it is a {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $138441ca74a86349$var$Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined
        });
    }
    /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} color Color.
   * @api
   */ setColor(color) {
        if (color !== null && typeof color === 'object' && 'src' in color) {
            const patternImage = (0, $d3964cb6e3bba2e9$export$3988ae62b71be9a3)(null, color.src, 'anonymous', undefined, color.offset ? null : color.color ? color.color : null, !(color.offset && color.size));
            patternImage.ready().then(()=>{
                this.patternImage_ = null;
            });
            if (patternImage.getImageState() === (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).IDLE) patternImage.load();
            if (patternImage.getImageState() === (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADING) this.patternImage_ = patternImage;
        }
        this.color_ = color;
    }
    /**
   * @return {string} Key of the fill for cache lookup.
   */ getKey() {
        const fill = this.getColor();
        if (!fill) return '';
        return fill instanceof CanvasPattern || fill instanceof CanvasGradient ? (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(fill) : typeof fill === 'object' && 'src' in fill ? fill.src + ':' + fill.offset : (0, $4693a670e5985dc9$export$75093a47a9fa838d)(fill).toString();
    }
    /**
   * @return {boolean} The fill style is loading an image pattern.
   */ loading() {
        return !!this.patternImage_;
    }
    /**
   * @return {Promise<void>} `false` or a promise that resolves when the style is ready to use.
   */ ready() {
        return this.patternImage_ ? this.patternImage_.ready() : Promise.resolve();
    }
}
var $138441ca74a86349$export$2e2bcd8739ae039 = $138441ca74a86349$var$Fill;


/**
 * @module ol/style/Icon
 */ 






/**
 * @typedef {'fraction' | 'pixels'} IconAnchorUnits
 * Anchor unit can be either a fraction of the icon size or in pixels.
 */ /**
 * @typedef {'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'} IconOrigin
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 */ /**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {IconOrigin} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {IconAnchorUnits} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {IconAnchorUnits} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {HTMLImageElement|HTMLCanvasElement|ImageBitmap} [img] Image object for the icon.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the icon in pixels.
 * Positive values will shift the icon right and up.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number} [width] The width of the icon in pixels. This can't be used together with `scale`.
 * @property {number} [height] The height of the icon in pixels. This can't be used together with `scale`.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {Array<number>} [offset=[0, 0]] Offset which, together with `size` and `offsetOrigin`, defines the
 * sub-rectangle to use from the original (sprite) image.
 * @property {IconOrigin} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("../size.js").Size} [size] Icon size in pixels. Used together with `offset` to define the
 * sub-rectangle to use from the original (sprite) image.
 * @property {string} [src] Image source URI.
 * @property {import("./Style.js").DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @param {number} width The width.
 * @param {number} height The height.
 * @param {number|undefined} wantedWidth The wanted width.
 * @param {number|undefined} wantedHeight The wanted height.
 * @return {number|Array<number>} The scale.
 */ function $39bb2f212514d9f6$var$calculateScale(width, height, wantedWidth, wantedHeight) {
    if (wantedWidth !== undefined && wantedHeight !== undefined) return [
        wantedWidth / width,
        wantedHeight / height
    ];
    if (wantedWidth !== undefined) return wantedWidth / width;
    if (wantedHeight !== undefined) return wantedHeight / height;
    return 1;
}
/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ class $39bb2f212514d9f6$var$Icon extends (0, $2f3f31e5de474dab$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @type {number}
     */ const opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
     * @type {number}
     */ const rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
     * @type {number|import("../size.js").Size}
     */ const scale = options.scale !== undefined ? options.scale : 1;
        /**
     * @type {boolean}
     */ const rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        super({
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView,
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Array<number>}
     */ this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
     * @private
     * @type {Array<number>}
     */ this.normalizedAnchor_ = null;
        /**
     * @private
     * @type {IconOrigin}
     */ this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : 'top-left';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : 'fraction';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : 'fraction';
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        const image = options.img !== undefined ? options.img : null;
        let cacheKey = options.src;
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(!(cacheKey !== undefined && image), '`image` and `src` cannot be provided at the same time');
        if ((cacheKey === undefined || cacheKey.length === 0) && image) cacheKey = /** @type {HTMLImageElement} */ image.src || (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(image);
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(cacheKey !== undefined && cacheKey.length > 0, 'A defined and non-empty `src` or `image` must be provided');
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(!((options.width !== undefined || options.height !== undefined) && options.scale !== undefined), '`width` or `height` cannot be provided together with `scale`');
        let imageState;
        if (options.src !== undefined) imageState = (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).IDLE;
        else if (image !== undefined) {
            if ('complete' in image) {
                if (image.complete) imageState = image.src ? (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED : (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).IDLE;
                else imageState = (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADING;
            } else imageState = (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED;
        }
        /**
     * @private
     * @type {import("../color.js").Color}
     */ this.color_ = options.color !== undefined ? (0, $4693a670e5985dc9$export$75093a47a9fa838d)(options.color) : null;
        /**
     * @private
     * @type {import("./IconImage.js").default}
     */ this.iconImage_ = (0, $d3964cb6e3bba2e9$export$3988ae62b71be9a3)(image, /** @type {string} */ cacheKey, this.crossOrigin_, imageState, this.color_);
        /**
     * @private
     * @type {Array<number>}
     */ this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
     * @private
     * @type {IconOrigin}
     */ this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : 'top-left';
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = options.size !== undefined ? options.size : null;
        /**
     * @private
     */ this.initialOptions_;
        /**
     * Calculate the scale if width or height were given.
     */ if (options.width !== undefined || options.height !== undefined) {
            let width, height;
            if (options.size) [width, height] = options.size;
            else {
                const image = this.getImage(1);
                if (image.width && image.height) {
                    width = image.width;
                    height = image.height;
                } else if (image instanceof HTMLImageElement) {
                    this.initialOptions_ = options;
                    const onload = ()=>{
                        this.unlistenImageChange(onload);
                        if (!this.initialOptions_) return;
                        const imageSize = this.iconImage_.getSize();
                        this.setScale($39bb2f212514d9f6$var$calculateScale(imageSize[0], imageSize[1], options.width, options.height));
                    };
                    this.listenImageChange(onload);
                    return;
                }
            }
            if (width !== undefined) this.setScale($39bb2f212514d9f6$var$calculateScale(width, height, options.width, options.height));
        }
    }
    /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   * @override
   */ clone() {
        let scale, width, height;
        if (this.initialOptions_) {
            width = this.initialOptions_.width;
            height = this.initialOptions_.height;
        } else {
            scale = this.getScale();
            scale = Array.isArray(scale) ? scale.slice() : scale;
        }
        return new $39bb2f212514d9f6$var$Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            crossOrigin: this.crossOrigin_,
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            opacity: this.getOpacity(),
            rotateWithView: this.getRotateWithView(),
            rotation: this.getRotation(),
            scale: scale,
            width: width,
            height: height,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            src: this.getSrc(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        let anchor = this.normalizedAnchor_;
        if (!anchor) {
            anchor = this.anchor_;
            const size = this.getSize();
            if (this.anchorXUnits_ == 'fraction' || this.anchorYUnits_ == 'fraction') {
                if (!size) return null;
                anchor = this.anchor_.slice();
                if (this.anchorXUnits_ == 'fraction') anchor[0] *= size[0];
                if (this.anchorYUnits_ == 'fraction') anchor[1] *= size[1];
            }
            if (this.anchorOrigin_ != 'top-left') {
                if (!size) return null;
                if (anchor === this.anchor_) anchor = this.anchor_.slice();
                if (this.anchorOrigin_ == 'top-right' || this.anchorOrigin_ == 'bottom-right') anchor[0] = -anchor[0] + size[0];
                if (this.anchorOrigin_ == 'bottom-left' || this.anchorOrigin_ == 'bottom-right') anchor[1] = -anchor[1] + size[1];
            }
            this.normalizedAnchor_ = anchor;
        }
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            anchor[0] - displacement[0] / scale[0],
            anchor[1] + displacement[1] / scale[1]
        ];
    }
    /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */ setAnchor(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    }
    /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   * @override
   */ getImage(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    }
    /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   * @override
   */ getPixelRatio(pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.iconImage_.getSize();
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.iconImage_.getImageState();
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   * @override
   */ getHitDetectionImage() {
        return this.iconImage_.getHitDetectionImage();
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        if (this.origin_) return this.origin_;
        let offset = this.offset_;
        if (this.offsetOrigin_ != 'top-left') {
            const size = this.getSize();
            const iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == 'top-right' || this.offsetOrigin_ == 'bottom-right') offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == 'bottom-left' || this.offsetOrigin_ == 'bottom-right') offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        this.origin_ = offset;
        return this.origin_;
    }
    /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */ getSrc() {
        return this.iconImage_.getSrc();
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   * @override
   */ getSize() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    }
    /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */ getWidth() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[0] * scale[0];
        if (this.iconImage_.getImageState() == (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[0] * scale[0];
        return undefined;
    }
    /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */ getHeight() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[1] * scale[1];
        if (this.iconImage_.getImageState() == (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[1] * scale[1];
        return undefined;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   * @override
   */ setScale(scale) {
        delete this.initialOptions_;
        super.setScale(scale);
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {
        this.iconImage_.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   * @override
   */ load() {
        this.iconImage_.load();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {
        this.iconImage_.removeEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * @override
   */ ready() {
        return this.iconImage_.ready();
    }
}
var $39bb2f212514d9f6$export$2e2bcd8739ae039 = $39bb2f212514d9f6$var$Icon;



/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ class $f461fc147fe0b606$var$Stroke {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
     */ this.color_ = options.color !== undefined ? options.color : null;
        /**
     * @private
     * @type {CanvasLineCap|undefined}
     */ this.lineCap_ = options.lineCap;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lineDashOffset_ = options.lineDashOffset;
        /**
     * @private
     * @type {CanvasLineJoin|undefined}
     */ this.lineJoin_ = options.lineJoin;
        /**
     * @private
     * @type {number|undefined}
     */ this.miterLimit_ = options.miterLimit;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = options.width;
    }
    /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $f461fc147fe0b606$var$Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            width: this.getWidth()
        });
    }
    /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */ getLineCap() {
        return this.lineCap_;
    }
    /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */ getLineDash() {
        return this.lineDash_;
    }
    /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */ getLineDashOffset() {
        return this.lineDashOffset_;
    }
    /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */ getLineJoin() {
        return this.lineJoin_;
    }
    /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */ getMiterLimit() {
        return this.miterLimit_;
    }
    /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */ getWidth() {
        return this.width_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */ setColor(color) {
        this.color_ = color;
    }
    /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */ setLineCap(lineCap) {
        this.lineCap_ = lineCap;
    }
    /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */ setLineDash(lineDash) {
        this.lineDash_ = lineDash;
    }
    /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */ setLineDashOffset(lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    }
    /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */ setLineJoin(lineJoin) {
        this.lineJoin_ = lineJoin;
    }
    /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */ setMiterLimit(miterLimit) {
        this.miterLimit_ = miterLimit;
    }
    /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */ setWidth(width) {
        this.width_ = width;
    }
}
var $f461fc147fe0b606$export$2e2bcd8739ae039 = $f461fc147fe0b606$var$Stroke;


/**
 * @module ol/style/Style
 */ 



/**
 * Defines how symbols and text are decluttered on layers ith `declutter` set to `true`
 * **declutter**: Overlapping symbols and text are decluttered.
 * **obstacle**: Symbols and text are rendered, but serve as obstacle for subsequent attempts
 *   to place a symbol or text at the same location.
 * **none**: No decluttering is done.
 *
 * @typedef {"declutter"|"obstacle"|"none"} DeclutterMode
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style~Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} as argument and returns an
 * {@link module:ol/geom/Geometry~Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>|Array<Array<Array<import("../coordinate.js").Coordinate>>>),import("../render.js").State): void} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {RenderFunction} [hitDetectionRenderer] Custom renderer for hit detection. If provided will be used
 * in hit detection rendering.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)',
 *  });
 *  const stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25,
 *  });
 *  const styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5,
 *      }),
 *      fill: fill,
 *      stroke: stroke,
 *    }),
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const styles = {};
 *  const white = [255, 255, 255, 1];
 *  const blue = [0, 153, 255, 1];
 *  const width = 3;
 *  styles['Polygon'] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5],
 *      }),
 *    }),
 *  ];
 *  styles['MultiPolygon'] =
 *      styles['Polygon'];
 *  styles['LineString'] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2,
 *      }),
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width,
 *      }),
 *    }),
 *  ];
 *  styles['MultiLineString'] = styles['LineString'];
 *
 *  styles['Circle'] = styles['Polygon'].concat(
 *    styles['LineString']
 *  );
 *
 *  styles['Point'] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue,
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2,
 *        }),
 *      }),
 *      zIndex: Infinity,
 *    }),
 *  ];
 *  styles['MultiPoint'] =
 *      styles['Point'];
 *  styles['GeometryCollection'] =
 *      styles['Polygon'].concat(
 *          styles['LineString'],
 *          styles['Point']
 *      );
 * ```
 *
 * @api
 */ class $e22912a5c91750c8$var$Style {
    /**
   * @param {Options} [options] Style options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|import("../geom/Geometry.js").default|GeometryFunction|null}
     */ this.geometry_ = null;
        /**
     * @private
     * @type {!GeometryFunction}
     */ this.geometryFunction_ = $e22912a5c91750c8$var$defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {import("./Image.js").default|null}
     */ this.image_ = options.image !== undefined ? options.image : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.hitDetectionRenderer_ = options.hitDetectionRenderer !== undefined ? options.hitDetectionRenderer : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("./Text.js").default|null}
     */ this.text_ = options.text !== undefined ? options.text : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.zIndex_ = options.zIndex;
    }
    /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */ clone() {
        let geometry = this.getGeometry();
        if (geometry && typeof geometry === 'object') geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
        return new $e22912a5c91750c8$var$Style({
            geometry: geometry ?? undefined,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            renderer: this.getRenderer() ?? undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex()
        });
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setRenderer(renderer) {
        this.renderer_ = renderer;
    }
    /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setHitDetectionRenderer(renderer) {
        this.hitDetectionRenderer_ = renderer;
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getHitDetectionRenderer() {
        return this.hitDetectionRenderer_;
    }
    /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction|null}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */ getGeometry() {
        return this.geometry_;
    }
    /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */ getGeometryFunction() {
        return this.geometryFunction_;
    }
    /**
   * Get the fill style.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Get the image style.
   * @return {import("./Image.js").default|null} Image style.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Get the text style.
   * @return {import("./Text.js").default|null} Text style.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */ getZIndex() {
        return this.zIndex_;
    }
    /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction|null} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */ setGeometry(geometry) {
        if (typeof geometry === 'function') this.geometryFunction_ = geometry;
        else if (typeof geometry === 'string') this.geometryFunction_ = function(feature) {
            return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
        };
        else if (!geometry) this.geometryFunction_ = $e22912a5c91750c8$var$defaultGeometryFunction;
        else if (geometry !== undefined) this.geometryFunction_ = function() {
            return /** @type {import("../geom/Geometry.js").default} */ geometry;
        };
        this.geometry_ = geometry;
    }
    /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */ setZIndex(zIndex) {
        this.zIndex_ = zIndex;
    }
}
function $e22912a5c91750c8$export$c314ea3f6b164147(obj) {
    let styleFunction;
    if (typeof obj === 'function') styleFunction = obj;
    else {
        /**
     * @type {Array<Style>}
     */ let styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, $4b57691230be0bd5$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `Style` or an array of `Style`');
            const style = /** @type {Style} */ obj;
            styles = [
                style
            ];
        }
        styleFunction = function() {
            return styles;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>|null}
 */ let $e22912a5c91750c8$var$defaultStyles = null;
function $e22912a5c91750c8$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$e22912a5c91750c8$var$defaultStyles) {
        const fill = new (0, $138441ca74a86349$export$2e2bcd8739ae039)({
            color: 'rgba(255,255,255,0.4)'
        });
        const stroke = new (0, $f461fc147fe0b606$export$2e2bcd8739ae039)({
            color: '#3399CC',
            width: 1.25
        });
        $e22912a5c91750c8$var$defaultStyles = [
            new $e22912a5c91750c8$var$Style({
                image: new (0, $defdf327ea9989ab$export$2e2bcd8739ae039)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $e22912a5c91750c8$var$defaultStyles;
}
function $e22912a5c91750c8$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/Geometry.js").Type, Array<Style>>} */ const styles = {};
    const white = [
        255,
        255,
        255,
        1
    ];
    const blue = [
        0,
        153,
        255,
        1
    ];
    const width = 3;
    styles['Polygon'] = [
        new $e22912a5c91750c8$var$Style({
            fill: new (0, $138441ca74a86349$export$2e2bcd8739ae039)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles['MultiPolygon'] = styles['Polygon'];
    styles['LineString'] = [
        new $e22912a5c91750c8$var$Style({
            stroke: new (0, $f461fc147fe0b606$export$2e2bcd8739ae039)({
                color: white,
                width: width + 2
            })
        }),
        new $e22912a5c91750c8$var$Style({
            stroke: new (0, $f461fc147fe0b606$export$2e2bcd8739ae039)({
                color: blue,
                width: width
            })
        })
    ];
    styles['MultiLineString'] = styles['LineString'];
    styles['Circle'] = styles['Polygon'].concat(styles['LineString']);
    styles['Point'] = [
        new $e22912a5c91750c8$var$Style({
            image: new (0, $defdf327ea9989ab$export$2e2bcd8739ae039)({
                radius: width * 2,
                fill: new (0, $138441ca74a86349$export$2e2bcd8739ae039)({
                    color: blue
                }),
                stroke: new (0, $f461fc147fe0b606$export$2e2bcd8739ae039)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles['MultiPoint'] = styles['Point'];
    styles['GeometryCollection'] = styles['Polygon'].concat(styles['LineString'], styles['Point']);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $e22912a5c91750c8$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $e22912a5c91750c8$export$2e2bcd8739ae039 = $e22912a5c91750c8$var$Style;


/**
 * @module ol/style/Text
 */ 

/**
 * @typedef {'point' | 'line'} TextPlacement
 * Default text placement is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 */ /**
 * @typedef {'left' | 'center' | 'right'} TextJustify
 */ /**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */ const $90ceb034f1fe1e9f$var$DEFAULT_FILL_COLOR = '#333';
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS `font` value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is `'10px sans-serif'`
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {TextPlacement} [placement='point'] Text placement.
 * @property {number} [repeat] Repeat interval. When set, the text will be repeated at this interval, which specifies
 * the distance between two text anchors in pixels. Only available when `placement` is set to `'line'`. Overrides 'textAlign'.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {boolean} [keepUpright=true] Whether the text can be rotated 180° to prevent being rendered upside down.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string|Array<string>} [text] Text content or rich text content. For plain text provide a string, which can
 * contain line breaks (`\n`). For rich text provide an array of text/font tuples. A tuple consists of the text to
 * render and the font to use (or `''` to use the text style's font). A line break has to be a separate tuple (i.e. `'\n', ''`).
 * **Example:** `['foo', 'bold 10px sans-serif', ' bar', 'italic 10px sans-serif', ' baz', '']` will yield "**foo** *bar* baz".
 * **Note:** Rich text is not supported for `placement: 'line'` or the immediate rendering API.
 * @property {CanvasTextAlign} [textAlign] Text alignment. Possible values: `'left'`, `'right'`, `'center'`, `'end'` or `'start'`.
 * Default is `'center'` for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {TextJustify} [justify] Text justification within the text box.
 * If not set, text is justified towards the `textAlign` anchor.
 * Otherwise, use options `'left'`, `'center'`, or `'right'` to justify the text within the text box.
 * **Note:** `justify` is ignored for immediate rendering and also for `placement: 'line'`.
 * @property {CanvasTextBaseline} [textBaseline='middle'] Text base line. Possible values: `'bottom'`, `'top'`, `'middle'`, `'alphabetic'`,
 * `'hanging'`, `'ideographic'`.
 * @property {import("./Fill.js").default|null} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333). Specify `null` for no fill.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 * @property {import('../style/Style.js').DeclutterMode} [declutterMode] Declutter mode: `declutter`, `obstacle`, `none`
 */ /**
 * @classdesc
 * Set text style for vector features.
 * @api
 */ class $90ceb034f1fe1e9f$var$Text {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|undefined}
     */ this.font_ = options.font;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.keepUpright_ = options.keepUpright;
        /**
     * @private
     * @type {number|import("../size.js").Size|undefined}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(options.scale !== undefined ? options.scale : 1);
        /**
     * @private
     * @type {string|Array<string>|undefined}
     */ this.text_ = options.text;
        /**
     * @private
     * @type {CanvasTextAlign|undefined}
     */ this.textAlign_ = options.textAlign;
        /**
     * @private
     * @type {TextJustify|undefined}
     */ this.justify_ = options.justify;
        /**
     * @private
     * @type {number|undefined}
     */ this.repeat_ = options.repeat;
        /**
     * @private
     * @type {CanvasTextBaseline|undefined}
     */ this.textBaseline_ = options.textBaseline;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : new (0, $138441ca74a86349$export$2e2bcd8739ae039)({
            color: $90ceb034f1fe1e9f$var$DEFAULT_FILL_COLOR
        });
        /**
     * @private
     * @type {number}
     */ this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
     * @private
     * @type {TextPlacement}
     */ this.placement_ = options.placement !== undefined ? options.placement : 'point';
        /**
     * @private
     * @type {boolean}
     */ this.overflow_ = !!options.overflow;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {number}
     */ this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
     * @private
     * @type {number}
     */ this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.padding_ = options.padding === undefined ? null : options.padding;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $90ceb034f1fe1e9f$var$Text({
            font: this.getFont(),
            placement: this.getPlacement(),
            repeat: this.getRepeat(),
            maxAngle: this.getMaxAngle(),
            overflow: this.getOverflow(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            keepUpright: this.getKeepUpright(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            text: this.getText(),
            textAlign: this.getTextAlign(),
            justify: this.getJustify(),
            textBaseline: this.getTextBaseline(),
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            offsetX: this.getOffsetX(),
            offsetY: this.getOffsetY(),
            backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
            backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
            padding: this.getPadding() || undefined,
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */ getOverflow() {
        return this.overflow_;
    }
    /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */ getFont() {
        return this.font_;
    }
    /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */ getMaxAngle() {
        return this.maxAngle_;
    }
    /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */ getPlacement() {
        return this.placement_;
    }
    /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */ getRepeat() {
        return this.repeat_;
    }
    /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */ getOffsetX() {
        return this.offsetX_;
    }
    /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */ getOffsetY() {
        return this.offsetY_;
    }
    /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Determine whether the text can be rendered upside down.
   * @return {boolean|undefined} Keep text upright.
   * @api
   */ getKeepUpright() {
        return this.keepUpright_;
    }
    /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */ getTextAlign() {
        return this.textAlign_;
    }
    /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */ getJustify() {
        return this.justify_;
    }
    /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */ getTextBaseline() {
        return this.textBaseline_;
    }
    /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getBackgroundFill() {
        return this.backgroundFill_;
    }
    /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getBackgroundStroke() {
        return this.backgroundStroke_;
    }
    /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */ getPadding() {
        return this.padding_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */ setOverflow(overflow) {
        this.overflow_ = overflow;
    }
    /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */ setFont(font) {
        this.font_ = font;
    }
    /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */ setMaxAngle(maxAngle) {
        this.maxAngle_ = maxAngle;
    }
    /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */ setOffsetX(offsetX) {
        this.offsetX_ = offsetX;
    }
    /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */ setOffsetY(offsetY) {
        this.offsetY_ = offsetY;
    }
    /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */ setPlacement(placement) {
        this.placement_ = placement;
    }
    /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */ setRepeat(repeat) {
        this.repeat_ = repeat;
    }
    /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set whether the text can be rendered upside down.
   *
   * @param {boolean} keepUpright Keep text upright.
   * @api
   */ setKeepUpright(keepUpright) {
        this.keepUpright_ = keepUpright;
    }
    /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(scale !== undefined ? scale : 1);
    }
    /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */ setTextAlign(textAlign) {
        this.textAlign_ = textAlign;
    }
    /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */ setJustify(justify) {
        this.justify_ = justify;
    }
    /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */ setTextBaseline(textBaseline) {
        this.textBaseline_ = textBaseline;
    }
    /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setBackgroundFill(fill) {
        this.backgroundFill_ = fill;
    }
    /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setBackgroundStroke(stroke) {
        this.backgroundStroke_ = stroke;
    }
    /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */ setPadding(padding) {
        this.padding_ = padding;
    }
}
var $90ceb034f1fe1e9f$export$2e2bcd8739ae039 = $90ceb034f1fe1e9f$var$Text;


/**
 * @fileoverview This module includes functions to build styles for the canvas renderer.  Building
 * is composed of two steps: parsing and compiling.  The parsing step takes an encoded expression
 * and returns an instance of one of the expression classes.  The compiling step takes the
 * expression instance and returns a function that can be evaluated to return a literal value.  The
 * evaluator function should do as little allocation and work as possible.
 */ /**
 * @typedef {import("../../style/flat.js").FlatStyle} FlatStyle
 */ /**
 * @typedef {import("../../expr/expression.js").EncodedExpression} EncodedExpression
 */ /**
 * @typedef {import("../../expr/expression.js").ParsingContext} ParsingContext
 */ /**
 * @typedef {import("../../expr/expression.js").CallExpression} CallExpression
 */ /**
 * @typedef {import("../../expr/cpu.js").EvaluationContext} EvaluationContext
 */ /**
 * @typedef {import("../../expr/cpu.js").ExpressionEvaluator} ExpressionEvaluator
 */ /**
 * @param {EvaluationContext} context The evaluation context.
 * @return {boolean} Always true.
 */ function $c9dfa8bd33618670$var$always(context) {
    return true;
}
function $c9dfa8bd33618670$export$fc6a94152b1b05a8(rules) {
    const parsingContext = (0, $63c8696b1aaf99a7$export$1c8b4c1584800354)();
    const evaluator = $c9dfa8bd33618670$export$d6ae6a4799989976(rules, parsingContext);
    const evaluationContext = (0, $42abb865eb659ee5$export$c18f39f0e136c26)();
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        if (parsingContext.geometryType) evaluationContext.geometryType = (0, $63c8696b1aaf99a7$export$8da88d86d10c1295)(feature.getGeometry());
        return evaluator(evaluationContext);
    };
}
function $c9dfa8bd33618670$export$5a130bc4f0a0420b(flatStyles) {
    const parsingContext = (0, $63c8696b1aaf99a7$export$1c8b4c1584800354)();
    const length = flatStyles.length;
    /**
   * @type {Array<StyleEvaluator>}
   */ const evaluators = new Array(length);
    for(let i = 0; i < length; ++i)evaluators[i] = $c9dfa8bd33618670$export$a6e5f510497b7388(flatStyles[i], parsingContext);
    const evaluationContext = (0, $42abb865eb659ee5$export$c18f39f0e136c26)();
    /**
   * @type {Array<Style>}
   */ const styles = new Array(length);
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        let nonNullCount = 0;
        for(let i = 0; i < length; ++i){
            const style = evaluators[i](evaluationContext);
            if (style) {
                styles[nonNullCount] = style;
                nonNullCount += 1;
            }
        }
        styles.length = nonNullCount;
        return styles;
    };
}
function $c9dfa8bd33618670$export$d6ae6a4799989976(rules, context) {
    const length = rules.length;
    /**
   * @type {Array<CompiledRule>}
   */ const compiledRules = new Array(length);
    for(let i = 0; i < length; ++i){
        const rule = rules[i];
        const filter = 'filter' in rule ? (0, $42abb865eb659ee5$export$b5f535122a9211f0)(rule.filter, (0, $63c8696b1aaf99a7$export$240f7fffab1b25a0), context) : $c9dfa8bd33618670$var$always;
        /**
     * @type {Array<StyleEvaluator>}
     */ let styles;
        if (Array.isArray(rule.style)) {
            const styleLength = rule.style.length;
            styles = new Array(styleLength);
            for(let j = 0; j < styleLength; ++j)styles[j] = $c9dfa8bd33618670$export$a6e5f510497b7388(rule.style[j], context);
        } else styles = [
            $c9dfa8bd33618670$export$a6e5f510497b7388(rule.style, context)
        ];
        compiledRules[i] = {
            filter: filter,
            styles: styles
        };
    }
    return function(context) {
        /**
     * @type {Array<Style>}
     */ const styles = [];
        let someMatched = false;
        for(let i = 0; i < length; ++i){
            const filterEvaluator = compiledRules[i].filter;
            if (!filterEvaluator(context)) continue;
            if (rules[i].else && someMatched) continue;
            someMatched = true;
            for (const styleEvaluator of compiledRules[i].styles){
                const style = styleEvaluator(context);
                if (!style) continue;
                styles.push(style);
            }
        }
        return styles;
    };
}
function $c9dfa8bd33618670$export$a6e5f510497b7388(flatStyle, context) {
    const evaluateFill = $c9dfa8bd33618670$var$buildFill(flatStyle, '', context);
    const evaluateStroke = $c9dfa8bd33618670$var$buildStroke(flatStyle, '', context);
    const evaluateText = $c9dfa8bd33618670$var$buildText(flatStyle, context);
    const evaluateImage = $c9dfa8bd33618670$var$buildImage(flatStyle, context);
    const evaluateZIndex = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, 'z-index', context);
    if (!evaluateFill && !evaluateStroke && !evaluateText && !evaluateImage && !(0, $0364d4893e3f1129$export$dd1bc94b04021eeb)(flatStyle)) // assume this is a user error
    // would be nice to check the properties and suggest "did you mean..."
    throw new Error('No fill, stroke, point, or text symbolizer properties in style: ' + JSON.stringify(flatStyle));
    const style = new (0, $e22912a5c91750c8$export$2e2bcd8739ae039)();
    return function(context) {
        let empty = true;
        if (evaluateFill) {
            const fill = evaluateFill(context);
            if (fill) empty = false;
            style.setFill(fill);
        }
        if (evaluateStroke) {
            const stroke = evaluateStroke(context);
            if (stroke) empty = false;
            style.setStroke(stroke);
        }
        if (evaluateText) {
            const text = evaluateText(context);
            if (text) empty = false;
            style.setText(text);
        }
        if (evaluateImage) {
            const image = evaluateImage(context);
            if (image) empty = false;
            style.setImage(image);
        }
        if (evaluateZIndex) style.setZIndex(evaluateZIndex(context));
        if (empty) return null;
        return style;
    };
}
/**
 * @typedef {function(EvaluationContext):Fill|null} FillEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {FillEvaluator?} A function that evaluates to a fill.
 */ function $c9dfa8bd33618670$var$buildFill(flatStyle, prefix, context) {
    let evaluateColor;
    if (prefix + 'fill-pattern-src' in flatStyle) evaluateColor = $c9dfa8bd33618670$var$patternEvaluator(flatStyle, prefix + 'fill-', context);
    else {
        if (flatStyle[prefix + 'fill-color'] === 'none') // avoids hit detection
        return (context)=>null;
        evaluateColor = $c9dfa8bd33618670$var$colorLikeEvaluator(flatStyle, prefix + 'fill-color', context);
    }
    if (!evaluateColor) return null;
    const fill = new (0, $138441ca74a86349$export$2e2bcd8739ae039)();
    return function(context) {
        const color = evaluateColor(context);
        if (color === (0, $4693a670e5985dc9$export$6c844c64a5efe1ee)) return null;
        fill.setColor(color);
        return fill;
    };
}
/**
 * @typedef {function(EvaluationContext):Stroke|null} StrokeEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {StrokeEvaluator?} A function the evaluates to a stroke.
 */ function $c9dfa8bd33618670$var$buildStroke(flatStyle, prefix, context) {
    const evaluateWidth = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'stroke-width', context);
    const evaluateColor = $c9dfa8bd33618670$var$colorLikeEvaluator(flatStyle, prefix + 'stroke-color', context);
    if (!evaluateWidth && !evaluateColor) return null;
    const evaluateLineCap = $c9dfa8bd33618670$var$stringEvaluator(flatStyle, prefix + 'stroke-line-cap', context);
    const evaluateLineJoin = $c9dfa8bd33618670$var$stringEvaluator(flatStyle, prefix + 'stroke-line-join', context);
    const evaluateLineDash = $c9dfa8bd33618670$var$numberArrayEvaluator(flatStyle, prefix + 'stroke-line-dash', context);
    const evaluateLineDashOffset = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'stroke-line-dash-offset', context);
    const evaluateMiterLimit = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'stroke-miter-limit', context);
    const stroke = new (0, $f461fc147fe0b606$export$2e2bcd8739ae039)();
    return function(context) {
        if (evaluateColor) {
            const color = evaluateColor(context);
            if (color === (0, $4693a670e5985dc9$export$6c844c64a5efe1ee)) return null;
            stroke.setColor(color);
        }
        if (evaluateWidth) stroke.setWidth(evaluateWidth(context));
        if (evaluateLineCap) {
            const lineCap = evaluateLineCap(context);
            if (lineCap !== 'butt' && lineCap !== 'round' && lineCap !== 'square') throw new Error('Expected butt, round, or square line cap');
            stroke.setLineCap(lineCap);
        }
        if (evaluateLineJoin) {
            const lineJoin = evaluateLineJoin(context);
            if (lineJoin !== 'bevel' && lineJoin !== 'round' && lineJoin !== 'miter') throw new Error('Expected bevel, round, or miter line join');
            stroke.setLineJoin(lineJoin);
        }
        if (evaluateLineDash) stroke.setLineDash(evaluateLineDash(context));
        if (evaluateLineDashOffset) stroke.setLineDashOffset(evaluateLineDashOffset(context));
        if (evaluateMiterLimit) stroke.setMiterLimit(evaluateMiterLimit(context));
        return stroke;
    };
}
/**
 * @typedef {function(EvaluationContext):Text} TextEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {TextEvaluator?} A function that evaluates to a text symbolizer.
 */ function $c9dfa8bd33618670$var$buildText(flatStyle, context) {
    const prefix = 'text-';
    // Currently, an Array<string> may be used for rich text support.  This doesn't
    // work with our expression syntax where arrays of strings are interpreted as
    // call expressions.  To support rich text, we could add a 'strings' operator
    // where all the following arguments would be string values.
    const evaluateValue = $c9dfa8bd33618670$var$stringEvaluator(flatStyle, prefix + 'value', context);
    if (!evaluateValue) return null;
    const evaluateFill = $c9dfa8bd33618670$var$buildFill(flatStyle, prefix, context);
    const evaluateBackgroundFill = $c9dfa8bd33618670$var$buildFill(flatStyle, prefix + 'background-', context);
    const evaluateStroke = $c9dfa8bd33618670$var$buildStroke(flatStyle, prefix, context);
    const evaluateBackgroundStroke = $c9dfa8bd33618670$var$buildStroke(flatStyle, prefix + 'background-', context);
    const evaluateFont = $c9dfa8bd33618670$var$stringEvaluator(flatStyle, prefix + 'font', context);
    const evaluateMaxAngle = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'max-angle', context);
    const evaluateOffsetX = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'offset-x', context);
    const evaluateOffsetY = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'offset-y', context);
    const evaluateOverflow = $c9dfa8bd33618670$var$booleanEvaluator(flatStyle, prefix + 'overflow', context);
    const evaluatePlacement = $c9dfa8bd33618670$var$stringEvaluator(flatStyle, prefix + 'placement', context);
    const evaluateRepeat = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'repeat', context);
    const evaluateScale = $c9dfa8bd33618670$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateRotateWithView = $c9dfa8bd33618670$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    const evaluateRotation = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateAlign = $c9dfa8bd33618670$var$stringEvaluator(flatStyle, prefix + 'align', context);
    const evaluateJustify = $c9dfa8bd33618670$var$stringEvaluator(flatStyle, prefix + 'justify', context);
    const evaluateBaseline = $c9dfa8bd33618670$var$stringEvaluator(flatStyle, prefix + 'baseline', context);
    const evaluateKeepUpright = $c9dfa8bd33618670$var$booleanEvaluator(flatStyle, prefix + 'keep-upright', context);
    const evaluatePadding = $c9dfa8bd33618670$var$numberArrayEvaluator(flatStyle, prefix + 'padding', context);
    // The following properties are not currently settable
    const declutterMode = $c9dfa8bd33618670$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const text = new (0, $90ceb034f1fe1e9f$export$2e2bcd8739ae039)({
        declutterMode: declutterMode
    });
    return function(context) {
        text.setText(evaluateValue(context));
        if (evaluateFill) text.setFill(evaluateFill(context));
        if (evaluateBackgroundFill) text.setBackgroundFill(evaluateBackgroundFill(context));
        if (evaluateStroke) text.setStroke(evaluateStroke(context));
        if (evaluateBackgroundStroke) text.setBackgroundStroke(evaluateBackgroundStroke(context));
        if (evaluateFont) text.setFont(evaluateFont(context));
        if (evaluateMaxAngle) text.setMaxAngle(evaluateMaxAngle(context));
        if (evaluateOffsetX) text.setOffsetX(evaluateOffsetX(context));
        if (evaluateOffsetY) text.setOffsetY(evaluateOffsetY(context));
        if (evaluateOverflow) text.setOverflow(evaluateOverflow(context));
        if (evaluatePlacement) {
            const placement = evaluatePlacement(context);
            if (placement !== 'point' && placement !== 'line') throw new Error('Expected point or line for text-placement');
            text.setPlacement(placement);
        }
        if (evaluateRepeat) text.setRepeat(evaluateRepeat(context));
        if (evaluateScale) text.setScale(evaluateScale(context));
        if (evaluateRotateWithView) text.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateRotation) text.setRotation(evaluateRotation(context));
        if (evaluateAlign) {
            const textAlign = evaluateAlign(context);
            if (textAlign !== 'left' && textAlign !== 'center' && textAlign !== 'right' && textAlign !== 'end' && textAlign !== 'start') throw new Error('Expected left, right, center, start, or end for text-align');
            text.setTextAlign(textAlign);
        }
        if (evaluateJustify) {
            const justify = evaluateJustify(context);
            if (justify !== 'left' && justify !== 'right' && justify !== 'center') throw new Error('Expected left, right, or center for text-justify');
            text.setJustify(justify);
        }
        if (evaluateBaseline) {
            const textBaseline = evaluateBaseline(context);
            if (textBaseline !== 'bottom' && textBaseline !== 'top' && textBaseline !== 'middle' && textBaseline !== 'alphabetic' && textBaseline !== 'hanging') throw new Error('Expected bottom, top, middle, alphabetic, or hanging for text-baseline');
            text.setTextBaseline(textBaseline);
        }
        if (evaluatePadding) text.setPadding(evaluatePadding(context));
        if (evaluateKeepUpright) text.setKeepUpright(evaluateKeepUpright(context));
        return text;
    };
}
/**
 * @typedef {function(EvaluationContext):import("../../style/Image.js").default} ImageEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator?} A function that evaluates to an image symbolizer.
 */ function $c9dfa8bd33618670$var$buildImage(flatStyle, context) {
    if ('icon-src' in flatStyle) return $c9dfa8bd33618670$var$buildIcon(flatStyle, context);
    if ('shape-points' in flatStyle) return $c9dfa8bd33618670$var$buildShape(flatStyle, context);
    if ('circle-radius' in flatStyle) return $c9dfa8bd33618670$var$buildCircle(flatStyle, context);
    return null;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an image symbolizer.
 */ function $c9dfa8bd33618670$var$buildIcon(flatStyle, context) {
    const prefix = 'icon-';
    // required property
    const srcName = prefix + 'src';
    const src = $c9dfa8bd33618670$var$requireString(flatStyle[srcName], srcName);
    // settable properties
    const evaluateAnchor = $c9dfa8bd33618670$var$coordinateEvaluator(flatStyle, prefix + 'anchor', context);
    const evaluateScale = $c9dfa8bd33618670$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateOpacity = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'opacity', context);
    const evaluateDisplacement = $c9dfa8bd33618670$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $c9dfa8bd33618670$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining symbolizer properties are not currently settable
    const anchorOrigin = $c9dfa8bd33618670$var$optionalIconOrigin(flatStyle, prefix + 'anchor-origin');
    const anchorXUnits = $c9dfa8bd33618670$var$optionalIconAnchorUnits(flatStyle, prefix + 'anchor-x-units');
    const anchorYUnits = $c9dfa8bd33618670$var$optionalIconAnchorUnits(flatStyle, prefix + 'anchor-y-units');
    const color = $c9dfa8bd33618670$var$optionalColorLike(flatStyle, prefix + 'color');
    const crossOrigin = $c9dfa8bd33618670$var$optionalString(flatStyle, prefix + 'cross-origin');
    const offset = $c9dfa8bd33618670$var$optionalNumberArray(flatStyle, prefix + 'offset');
    const offsetOrigin = $c9dfa8bd33618670$var$optionalIconOrigin(flatStyle, prefix + 'offset-origin');
    const width = $c9dfa8bd33618670$var$optionalNumber(flatStyle, prefix + 'width');
    const height = $c9dfa8bd33618670$var$optionalNumber(flatStyle, prefix + 'height');
    const size = $c9dfa8bd33618670$var$optionalSize(flatStyle, prefix + 'size');
    const declutterMode = $c9dfa8bd33618670$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const icon = new (0, $39bb2f212514d9f6$export$2e2bcd8739ae039)({
        src: src,
        anchorOrigin: anchorOrigin,
        anchorXUnits: anchorXUnits,
        anchorYUnits: anchorYUnits,
        color: color,
        crossOrigin: crossOrigin,
        offset: offset,
        offsetOrigin: offsetOrigin,
        height: height,
        width: width,
        size: size,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateOpacity) icon.setOpacity(evaluateOpacity(context));
        if (evaluateDisplacement) icon.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) icon.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) icon.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) icon.setScale(evaluateScale(context));
        if (evaluateAnchor) icon.setAnchor(evaluateAnchor(context));
        return icon;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an icon symbolizer.
 */ function $c9dfa8bd33618670$var$buildShape(flatStyle, context) {
    const prefix = 'shape-';
    // required property
    const pointsName = prefix + 'points';
    const radiusName = prefix + 'radius';
    const points = $c9dfa8bd33618670$var$requireNumber(flatStyle[pointsName], pointsName);
    const radius = $c9dfa8bd33618670$var$requireNumber(flatStyle[radiusName], radiusName);
    // settable properties
    const evaluateFill = $c9dfa8bd33618670$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $c9dfa8bd33618670$var$buildStroke(flatStyle, prefix, context);
    const evaluateScale = $c9dfa8bd33618670$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = $c9dfa8bd33618670$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $c9dfa8bd33618670$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const radius2 = $c9dfa8bd33618670$var$optionalNumber(flatStyle, prefix + 'radius2');
    const angle = $c9dfa8bd33618670$var$optionalNumber(flatStyle, prefix + 'angle');
    const declutterMode = $c9dfa8bd33618670$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const shape = new (0, $e039cc6cefab1c3f$export$2e2bcd8739ae039)({
        points: points,
        radius: radius,
        radius2: radius2,
        angle: angle,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateFill) shape.setFill(evaluateFill(context));
        if (evaluateStroke) shape.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) shape.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) shape.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) shape.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) shape.setScale(evaluateScale(context));
        return shape;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to a circle symbolizer.
 */ function $c9dfa8bd33618670$var$buildCircle(flatStyle, context) {
    const prefix = 'circle-';
    // settable properties
    const evaluateFill = $c9dfa8bd33618670$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $c9dfa8bd33618670$var$buildStroke(flatStyle, prefix, context);
    const evaluateRadius = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'radius', context);
    const evaluateScale = $c9dfa8bd33618670$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = $c9dfa8bd33618670$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $c9dfa8bd33618670$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $c9dfa8bd33618670$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const declutterMode = $c9dfa8bd33618670$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const circle = new (0, $defdf327ea9989ab$export$2e2bcd8739ae039)({
        radius: 5,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) circle.setRadius(evaluateRadius(context));
        if (evaluateFill) circle.setFill(evaluateFill(context));
        if (evaluateStroke) circle.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) circle.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) circle.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) circle.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) circle.setScale(evaluateScale(context));
        return circle;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberEvaluator|undefined} The expression evaluator or undefined.
 */ function $c9dfa8bd33618670$var$numberEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return undefined;
    const evaluator = (0, $42abb865eb659ee5$export$b5f535122a9211f0)(flatStyle[name], (0, $63c8696b1aaf99a7$export$86a7aca748b1e260), context);
    return function(context) {
        return $c9dfa8bd33618670$var$requireNumber(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').StringEvaluator?} The expression evaluator.
 */ function $c9dfa8bd33618670$var$stringEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $42abb865eb659ee5$export$b5f535122a9211f0)(flatStyle[name], (0, $63c8696b1aaf99a7$export$2b93044cbf134323), context);
    return function(context) {
        return $c9dfa8bd33618670$var$requireString(evaluator(context), name);
    };
}
function $c9dfa8bd33618670$var$patternEvaluator(flatStyle, prefix, context) {
    const srcEvaluator = $c9dfa8bd33618670$var$stringEvaluator(flatStyle, prefix + 'pattern-src', context);
    const offsetEvaluator = $c9dfa8bd33618670$var$sizeEvaluator(flatStyle, prefix + 'pattern-offset', context);
    const patternSizeEvaluator = $c9dfa8bd33618670$var$sizeEvaluator(flatStyle, prefix + 'pattern-size', context);
    const colorEvaluator = $c9dfa8bd33618670$var$colorLikeEvaluator(flatStyle, prefix + 'color', context);
    return function(context) {
        return {
            src: srcEvaluator(context),
            offset: offsetEvaluator && offsetEvaluator(context),
            size: patternSizeEvaluator && patternSizeEvaluator(context),
            color: colorEvaluator && colorEvaluator(context)
        };
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').BooleanEvaluator?} The expression evaluator.
 */ function $c9dfa8bd33618670$var$booleanEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $42abb865eb659ee5$export$b5f535122a9211f0)(flatStyle[name], (0, $63c8696b1aaf99a7$export$240f7fffab1b25a0), context);
    return function(context) {
        const value = evaluator(context);
        if (typeof value !== 'boolean') throw new Error(`Expected a boolean for ${name}`);
        return value;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').ColorLikeEvaluator?} The expression evaluator.
 */ function $c9dfa8bd33618670$var$colorLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $42abb865eb659ee5$export$b5f535122a9211f0)(flatStyle[name], (0, $63c8696b1aaf99a7$export$2cd82751acc0e609), context);
    return function(context) {
        return $c9dfa8bd33618670$var$requireColorLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberArrayEvaluator?} The expression evaluator.
 */ function $c9dfa8bd33618670$var$numberArrayEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $42abb865eb659ee5$export$b5f535122a9211f0)(flatStyle[name], (0, $63c8696b1aaf99a7$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $c9dfa8bd33618670$var$requireNumberArray(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').CoordinateEvaluator?} The expression evaluator.
 */ function $c9dfa8bd33618670$var$coordinateEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $42abb865eb659ee5$export$b5f535122a9211f0)(flatStyle[name], (0, $63c8696b1aaf99a7$export$d701d0e49f4bcb39), context);
    return function(context) {
        const array = $c9dfa8bd33618670$var$requireNumberArray(evaluator(context), name);
        if (array.length !== 2) throw new Error(`Expected two numbers for ${name}`);
        return array;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeEvaluator?} The expression evaluator.
 */ function $c9dfa8bd33618670$var$sizeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $42abb865eb659ee5$export$b5f535122a9211f0)(flatStyle[name], (0, $63c8696b1aaf99a7$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $c9dfa8bd33618670$var$requireSize(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeLikeEvaluator?} The expression evaluator.
 */ function $c9dfa8bd33618670$var$sizeLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $42abb865eb659ee5$export$b5f535122a9211f0)(flatStyle[name], (0, $63c8696b1aaf99a7$export$d701d0e49f4bcb39) | (0, $63c8696b1aaf99a7$export$86a7aca748b1e260), context);
    return function(context) {
        return $c9dfa8bd33618670$var$requireSizeLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {number|undefined} A number or undefined.
 */ function $c9dfa8bd33618670$var$optionalNumber(flatStyle, property) {
    const value = flatStyle[property];
    if (value === undefined) return undefined;
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../size.js").Size|undefined} A size or undefined.
 */ function $c9dfa8bd33618670$var$optionalSize(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded === 'number') return (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(encoded);
    if (!Array.isArray(encoded)) throw new Error(`Expected a number or size array for ${property}`);
    if (encoded.length !== 2 || typeof encoded[0] !== 'number' || typeof encoded[1] !== 'number') throw new Error(`Expected a number or size array for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|undefined} A string or undefined.
 */ function $c9dfa8bd33618670$var$optionalString(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconOrigin|undefined} An icon origin or undefined.
 */ function $c9dfa8bd33618670$var$optionalIconOrigin(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'bottom-left' && encoded !== 'bottom-right' && encoded !== 'top-left' && encoded !== 'top-right') throw new Error(`Expected bottom-left, bottom-right, top-left, or top-right for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconAnchorUnits|undefined} Icon anchor units or undefined.
 */ function $c9dfa8bd33618670$var$optionalIconAnchorUnits(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'pixels' && encoded !== 'fraction') throw new Error(`Expected pixels or fraction for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {Array<number>|undefined} An array of numbers or undefined.
 */ function $c9dfa8bd33618670$var$optionalNumberArray(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $c9dfa8bd33618670$var$requireNumberArray(encoded, property);
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import('../../style/Style.js').DeclutterMode} Icon declutter mode.
 */ function $c9dfa8bd33618670$var$optionalDeclutterMode(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    if (encoded !== 'declutter' && encoded !== 'obstacle' && encoded !== 'none') throw new Error(`Expected declutter, obstacle, or none for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|Array<number>|undefined} A string or an array of color values or undefined.
 */ function $c9dfa8bd33618670$var$optionalColorLike(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $c9dfa8bd33618670$var$requireColorLike(encoded, property);
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} An array of numbers.
 */ function $c9dfa8bd33618670$var$requireNumberArray(value, property) {
    if (!Array.isArray(value)) throw new Error(`Expected an array for ${property}`);
    const length = value.length;
    for(let i = 0; i < length; ++i){
        if (typeof value[i] !== 'number') throw new Error(`Expected an array of numbers for ${property}`);
    }
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {string} A string.
 */ function $c9dfa8bd33618670$var$requireString(value, property) {
    if (typeof value !== 'string') throw new Error(`Expected a string for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number} A number.
 */ function $c9dfa8bd33618670$var$requireNumber(value, property) {
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>|string} A color.
 */ function $c9dfa8bd33618670$var$requireColorLike(value, property) {
    if (typeof value === 'string') return value;
    const array = $c9dfa8bd33618670$var$requireNumberArray(value, property);
    const length = array.length;
    if (length < 3 || length > 4) throw new Error(`Expected a color with 3 or 4 values for ${property}`);
    return array;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} A number or an array of two numbers.
 */ function $c9dfa8bd33618670$var$requireSize(value, property) {
    const size = $c9dfa8bd33618670$var$requireNumberArray(value, property);
    if (size.length !== 2) throw new Error(`Expected an array of two numbers for ${property}`);
    return size;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number|Array<number>} A number or an array of two numbers.
 */ function $c9dfa8bd33618670$var$requireSizeLike(value, property) {
    if (typeof value === 'number') return value;
    return $c9dfa8bd33618670$var$requireSize(value, property);
}




/***
 * @template T
 * @typedef {T extends import("../source/Vector.js").default<infer U extends import("../Feature.js").FeatureLike> ? U : never} ExtractedFeatureType
 */ /**
 * @template {import('../Feature').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $c0ed643b13f1acbb$var$Property = {
    RENDER_ORDER: 'renderOrder'
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import('../Feature').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @extends {Layer<VectorSourceType, RendererType>}
 * @template {import("../renderer/canvas/VectorLayer.js").default|import("../renderer/canvas/VectorTileLayer.js").default|import("../renderer/canvas/VectorImageLayer.js").default|import("../renderer/webgl/VectorLayer.js").default|import("../renderer/webgl/PointsLayer.js").default} RendererType
 * @api
 */ class $c0ed643b13f1acbb$var$BaseVectorLayer extends (0, $3a63648a58cbd426$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType, VectorSourceType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        super(baseOptions);
        /**
     * @private
     * @type {string}
     */ this.declutter_ = options.declutter ? String(options.declutter) : undefined;
        /**
     * @type {number}
     * @private
     */ this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
     * User provided style.
     * @type {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike}
     * @private
     */ this.style_ = null;
        /**
     * Style function for use within the library.
     * @type {import("../style/Style.js").StyleFunction|undefined}
     * @private
     */ this.styleFunction_ = undefined;
        this.setStyle(options.style);
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
    }
    /**
   * @return {string} Declutter group.
   * @override
   */ getDeclutter() {
        return this.declutter_;
    }
    /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   * @override
   */ getFeatures(pixel) {
        return super.getFeatures(pixel);
    }
    /**
   * @return {number|undefined} Render buffer.
   */ getRenderBuffer() {
        return this.renderBuffer_;
    }
    /**
   * @return {import("../render.js").OrderFunction|null|undefined} Render order.
   */ getRenderOrder() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($c0ed643b13f1acbb$var$Property.RENDER_ORDER);
    }
    /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null|undefined} Layer style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */ getUpdateWhileAnimating() {
        return this.updateWhileAnimating_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */ getUpdateWhileInteracting() {
        return this.updateWhileInteracting_;
    }
    /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   * @override
   */ renderDeclutter(frameState, layerState) {
        const declutterGroup = this.getDeclutter();
        if (declutterGroup in frameState.declutter === false) frameState.declutter[declutterGroup] = new (0, (/*@__PURE__*/$parcel$interopDefault($2c1acb459bfbe860$exports)))(9);
        this.getRenderer().renderDeclutter(frameState, layerState);
    }
    /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */ setRenderOrder(renderOrder) {
        this.set($c0ed643b13f1acbb$var$Property.RENDER_ORDER, renderOrder);
    }
    /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */ setStyle(style) {
        this.style_ = style === undefined ? (0, $e22912a5c91750c8$export$6865c5ac2f5ce8b6) : style;
        const styleLike = $c0ed643b13f1acbb$var$toStyleLike(style);
        this.styleFunction_ = style === null ? undefined : (0, $e22912a5c91750c8$export$c314ea3f6b164147)(styleLike);
        this.changed();
    }
    /**
   * @param {boolean|string|number} declutter Declutter images and text.
   * @api
   */ setDeclutter(declutter) {
        this.declutter_ = declutter ? String(declutter) : undefined;
        this.changed();
    }
}
/**
 * Coerce the allowed style types into a shorter list of types.  Flat styles, arrays of flat
 * styles, and arrays of rules are converted into style functions.
 *
 * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
 * @return {import("../style/Style.js").StyleLike|null} The style.
 */ function $c0ed643b13f1acbb$var$toStyleLike(style) {
    if (style === undefined) return 0, $e22912a5c91750c8$export$6865c5ac2f5ce8b6;
    if (!style) return null;
    if (typeof style === 'function') return style;
    if (style instanceof (0, $e22912a5c91750c8$export$2e2bcd8739ae039)) return style;
    if (!Array.isArray(style)) return (0, $c9dfa8bd33618670$export$5a130bc4f0a0420b)([
        style
    ]);
    if (style.length === 0) return [];
    const length = style.length;
    const first = style[0];
    if (first instanceof (0, $e22912a5c91750c8$export$2e2bcd8739ae039)) {
        /**
     * @type {Array<Style>}
     */ const styles = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!(candidate instanceof (0, $e22912a5c91750c8$export$2e2bcd8739ae039))) throw new Error('Expected a list of style instances');
            styles[i] = candidate;
        }
        return styles;
    }
    if ('style' in first) {
        /**
     * @type {Array<import("../style/flat.js").Rule>}
     */ const rules = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!('style' in candidate)) throw new Error('Expected a list of rules with a style property');
            rules[i] = candidate;
        }
        return (0, $c9dfa8bd33618670$export$fc6a94152b1b05a8)(rules);
    }
    const flatStyles = /** @type {Array<import("../style/flat.js").FlatStyle>} */ style;
    return (0, $c9dfa8bd33618670$export$5a130bc4f0a0420b)(flatStyles);
}
var $c0ed643b13f1acbb$export$2e2bcd8739ae039 = $c0ed643b13f1acbb$var$BaseVectorLayer;



/**
 * @module ol/render/Event
 */ 
class $96765f144db3e978$var$RenderEvent extends (0, $5ede4ff5599f8860$export$2e2bcd8739ae039) {
    /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */ constructor(type, inversePixelTransform, frameState, context){
        super(type);
        /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */ this.inversePixelTransform = inversePixelTransform;
        /**
     * An object representing the current render frame state.
     * @type {import("../Map.js").FrameState|undefined}
     * @api
     */ this.frameState = frameState;
        /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */ this.context = context;
    }
}
var $96765f144db3e978$export$2e2bcd8739ae039 = $96765f144db3e978$var$RenderEvent;




/**
 * @module ol/renderer/Map
 */ 







/**
 * @template T
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 */ /**
 * @abstract
 */ class $cf502e70c709b487$var$MapRenderer extends (0, $07a23b3d5e0afc2c$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super();
        /**
     * @private
     * @type {import("../Map.js").default}
     */ this.map_ = map;
    }
    /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ dispatchRenderEvent(type, frameState) {
        (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */ calculateMatrices2D(frameState) {
        const viewState = frameState.viewState;
        const coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        const pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, $a684e03243281d90$export$f672e0b6f7222cd7)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, $a684e03243281d90$export$bd70ea2a93c0fa4)(pixelToCoordinateTransform, coordinateToPixelTransform);
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        let result;
        const viewState = frameState.viewState;
        /**
     * @param {boolean} managed Managed layer.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        const projection = viewState.projection;
        const translatedCoordinate = (0, $188aedb30bca6ae8$export$39a9ce3624977b84)(coordinate.slice(), projection);
        const offsets = [
            [
                0,
                0
            ]
        ];
        if (projection.canWrapX() && checkWrapped) {
            const projectionExtent = projection.getExtent();
            const worldWidth = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(projectionExtent);
            offsets.push([
                -worldWidth,
                0
            ], [
                worldWidth,
                0
            ]);
        }
        const layerStates = frameState.layerStatesArray;
        const numLayers = layerStates.length;
        const matches = /** @type {Array<HitMatch<T>>} */ [];
        const tmpCoord = [];
        for(let i = 0; i < offsets.length; i++)for(let j = numLayers - 1; j >= 0; --j){
            const layerState = layerStates[j];
            const layer = layerState.layer;
            if (layer.hasRenderer() && (0, $3a63648a58cbd426$export$acb1e9cb9ce4ca56)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                const layerRenderer = layer.getRenderer();
                const source = layer.getSource();
                if (layerRenderer && source) {
                    const coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                    const callback = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                    tmpCoord[0] = coordinates[0] + offsets[i][0];
                    tmpCoord[1] = coordinates[1] + offsets[i][1];
                    result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback, matches);
                }
                if (result) return result;
            }
        }
        if (matches.length === 0) return undefined;
        const order = 1 / matches.length;
        matches.forEach((m, i)=>m.distanceSq += i * order);
        matches.sort((a, b)=>a.distanceSq - b.distanceSq);
        matches.some((m)=>{
            return result = m.callback(m.feature, m.layer, m.geometry);
        });
        return result;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */ hasFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        const hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, $1a39c7df251dabdd$export$22e23a2304399231), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    }
    /**
   * @return {import("../Map.js").default} Map.
   */ getMap() {
        return this.map_;
    }
    /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ renderFrame(frameState) {
        (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */ scheduleExpireIconCache(frameState) {
        if ((0, $0c4a599876c09f47$export$747ccdf771a87ab8).canExpireCache()) frameState.postRenderFunctions.push($cf502e70c709b487$var$expireIconCache);
    }
}
/**
 * @param {import("../Map.js").default} map Map.
 * @param {import("../Map.js").FrameState} frameState Frame state.
 */ function $cf502e70c709b487$var$expireIconCache(map, frameState) {
    (0, $0c4a599876c09f47$export$747ccdf771a87ab8).expire();
}
var $cf502e70c709b487$export$2e2bcd8739ae039 = $cf502e70c709b487$var$MapRenderer;


/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ class $3986a6620ede77ea$var$CompositeMapRenderer extends (0, $cf502e70c709b487$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super(map);
        /**
     * @private
     * @type {import("../events.js").EventsKey}
     */ this.fontChangeListenerKey_ = (0, $7d7dee7854c96264$export$63174c828edd6ff8)((0, $56d5de32f563e6ab$export$1d36981fcadac93b), (0, $2a15c8802c911fe7$export$2e2bcd8739ae039).PROPERTYCHANGE, map.redrawText, map);
        /**
     * @private
     * @type {HTMLDivElement}
     */ this.element_ = document.createElement('div');
        const style = this.element_.style;
        style.position = 'absolute';
        style.width = '100%';
        style.height = '100%';
        style.zIndex = '0';
        this.element_.className = (0, $499ab6056ba431ad$export$1afde3d6e16a7b29) + ' ol-layers';
        const container = map.getViewport();
        container.insertBefore(this.element_, container.firstChild || null);
        /**
     * @private
     * @type {Array<HTMLElement>}
     */ this.children_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ dispatchRenderEvent(type, frameState) {
        const map = this.getMap();
        if (map.hasListener(type)) {
            const event = new (0, $96765f144db3e978$export$2e2bcd8739ae039)(type, undefined, frameState);
            map.dispatchEvent(event);
        }
    }
    /**
   * @override
   */ disposeInternal() {
        (0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(this.fontChangeListenerKey_);
        this.element_.remove();
        super.disposeInternal();
    }
    /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderFrame(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, $b899a48a5b03178b$export$2e2bcd8739ae039).PRECOMPOSE, frameState);
        const layerStatesArray = frameState.layerStatesArray.sort((a, b)=>a.zIndex - b.zIndex);
        const declutter = layerStatesArray.some((layerState)=>layerState.layer instanceof (0, $c0ed643b13f1acbb$export$2e2bcd8739ae039) && layerState.layer.getDeclutter());
        if (declutter) // Some layers need decluttering, turn on deferred rendering hint
        frameState.declutter = {};
        const viewState = frameState.viewState;
        this.children_.length = 0;
        const renderedLayerStates = [];
        let previousElement = null;
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            const layer = layerState.layer;
            const sourceState = layer.getSourceState();
            if (!(0, $3a63648a58cbd426$export$acb1e9cb9ce4ca56)(layerState, viewState) || sourceState != 'ready' && sourceState != 'undefined') {
                layer.unrender();
                continue;
            }
            const element = layer.render(frameState, previousElement);
            if (!element) continue;
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            renderedLayerStates.push(layerState);
        }
        this.declutter(frameState, renderedLayerStates);
        (0, $32c8adb5331a7848$export$caeacfe04f52533a)(this.element_, this.children_);
        this.dispatchRenderEvent((0, $b899a48a5b03178b$export$2e2bcd8739ae039).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = '';
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {Array<import('../layer/Layer.js').State>} layerStates Layers.
   */ declutter(frameState, layerStates) {
        if (!frameState.declutter) return;
        for(let i = layerStates.length - 1; i >= 0; --i){
            const layerState = layerStates[i];
            const layer = layerState.layer;
            if (layer.getDeclutter()) layer.renderDeclutter(frameState, layerState);
        }
        layerStates.forEach((layerState)=>layerState.layer.renderDeferred(frameState));
    }
}
var $3986a6620ede77ea$export$2e2bcd8739ae039 = $3986a6620ede77ea$var$CompositeMapRenderer;





/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {Object<string, import("rbush").default<import('./render/canvas/Executor.js').DeclutterEntry>>|null} declutter
 * Declutter trees by declutter group.
 * When null, no decluttering is needed because no layers have decluttering enabled.
 * @property {null|import("./extent.js").Extent} extent Extent (in view projection coordinates).
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */ /**
 * @typedef {function(Map, FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */ /**
 * @typedef {import("./ObjectEventType").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<MapObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *    import("./Observable").OnSignature<import("./MapBrowserEventType").Types, import("./MapBrowserEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./MapEventType").Types, import("./MapEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./render/EventType").MapRenderEventTypes, import("./render/Event").default, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType").Types|import("./MapEventType").Types|
 *      import("./render/EventType").MapRenderEventTypes, Return>} MapEventHandler
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control/defaults.defaults} is used.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction/defaults.defaults} is used.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
 *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
 *  `tabindex` atribute must be set on the custom element's host element.
 * **Note:** CSS `transform` support for the target element is limited to `scale`.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @param {import("./layer/Base.js").default} layer Layer.
 */ function $81f11cc9e2668eea$var$removeLayerMapProperty(layer) {
    if (layer instanceof (0, $3a63648a58cbd426$export$2e2bcd8739ae039)) {
        layer.setMapInternal(null);
        return;
    }
    if (layer instanceof (0, $9c4d32c43cd2911b$export$2e2bcd8739ae039)) layer.getLayers().forEach($81f11cc9e2668eea$var$removeLayerMapProperty);
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {Map} map Map.
 */ function $81f11cc9e2668eea$var$setLayerMapProperty(layer, map) {
    if (layer instanceof (0, $3a63648a58cbd426$export$2e2bcd8739ae039)) {
        layer.setMapInternal(map);
        return;
    }
    if (layer instanceof (0, $9c4d32c43cd2911b$export$2e2bcd8739ae039)) {
        const layers = layer.getLayers().getArray();
        for(let i = 0, ii = layers.length; i < ii; ++i)$81f11cc9e2668eea$var$setLayerMapProperty(layers[i], map);
    }
}
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map.js';
 *     import View from 'ol/View.js';
 *     import TileLayer from 'ol/layer/Tile.js';
 *     import OSM from 'ol/source/OSM.js';
 *
 *     const map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1,
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM(),
 *         }),
 *       ],
 *       target: 'map',
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ class $81f11cc9e2668eea$var$Map extends (0, $32070d44509bac34$export$2e2bcd8739ae039) {
    /**
   * @param {MapOptions} [options] Map options.
   */ constructor(options){
        super();
        options = options || {};
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {MapEventHandler<void>}
     */ this.un;
        const optionsInternal = $81f11cc9e2668eea$var$createOptionsInternal(options);
        /**
     * @private
     * @type {boolean}
     */ this.renderComplete_ = false;
        /**
     * @private
     * @type {boolean}
     */ this.loaded_ = true;
        /** @private */ this.boundHandleBrowserEvent_ = this.handleBrowserEvent.bind(this);
        /**
     * @type {number}
     * @private
     */ this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $6f9f9040ddfdc3ac$export$6b83a0446fc26f94);
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.postRenderTimeoutHandle_;
        /**
     * @private
     * @type {number|undefined}
     */ this.animationDelayKey_;
        /**
     * @private
     */ this.animationDelay_ = this.animationDelay_.bind(this);
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.coordinateToPixelTransform_ = (0, $a684e03243281d90$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.pixelToCoordinateTransform_ = (0, $a684e03243281d90$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {number}
     */ this.frameIndex_ = 0;
        /**
     * @private
     * @type {?FrameState}
     */ this.frameState_ = null;
        /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */ this.previousExtent_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewPropertyListenerKey_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewChangeListenerKey_ = null;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.layerGroupPropertyListenerKeys_ = null;
        /**
     * @private
     * @type {!HTMLElement}
     */ this.viewport_ = document.createElement('div');
        this.viewport_.className = 'ol-viewport' + ('ontouchstart' in window ? ' ol-touch' : '');
        this.viewport_.style.position = 'relative';
        this.viewport_.style.overflow = 'hidden';
        this.viewport_.style.width = '100%';
        this.viewport_.style.height = '100%';
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainer_ = document.createElement('div');
        this.overlayContainer_.style.position = 'absolute';
        this.overlayContainer_.style.zIndex = '0';
        this.overlayContainer_.style.width = '100%';
        this.overlayContainer_.style.height = '100%';
        this.overlayContainer_.style.pointerEvents = 'none';
        this.overlayContainer_.className = 'ol-overlaycontainer';
        this.viewport_.appendChild(this.overlayContainer_);
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainerStopEvent_ = document.createElement('div');
        this.overlayContainerStopEvent_.style.position = 'absolute';
        this.overlayContainerStopEvent_.style.zIndex = '0';
        this.overlayContainerStopEvent_.style.width = '100%';
        this.overlayContainerStopEvent_.style.height = '100%';
        this.overlayContainerStopEvent_.style.pointerEvents = 'none';
        this.overlayContainerStopEvent_.className = 'ol-overlaycontainer-stopevent';
        this.viewport_.appendChild(this.overlayContainerStopEvent_);
        /**
     * @private
     * @type {MapBrowserEventHandler}
     */ this.mapBrowserEventHandler_ = null;
        /**
     * @private
     * @type {number}
     */ this.moveTolerance_ = options.moveTolerance;
        /**
     * @private
     * @type {HTMLElement|Document}
     */ this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.targetChangeHandlerKeys_ = null;
        /**
     * @private
     * @type {HTMLElement|null}
     */ this.targetElement_ = null;
        /**
     * @private
     * @type {ResizeObserver}
     */ this.resizeObserver_ = new ResizeObserver(()=>this.updateSize());
        /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */ this.controls = optionsInternal.controls || (0, $1117f7f39083091c$export$ebe90cb607ad99e)();
        /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */ this.interactions = optionsInternal.interactions || (0, $9bdc14d4619c3a06$export$ebe90cb607ad99e)({
            onFocusOnly: true
        });
        /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */ this.overlays_ = optionsInternal.overlays;
        /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */ this.overlayIdIndex_ = {};
        /**
     * @type {import("./renderer/Map.js").default|null}
     * @private
     */ this.renderer_ = null;
        /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */ this.postRenderFunctions_ = [];
        /**
     * @private
     * @type {TileQueue}
     */ this.tileQueue_ = new (0, $b1b92775009e47d7$export$2e2bcd8739ae039)(this.getTilePriority.bind(this), this.handleTileChange_.bind(this));
        this.addChangeListener((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).LAYERGROUP, this.handleLayerGroupChanged_);
        this.addChangeListener((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).VIEW, this.handleViewChanged_);
        this.addChangeListener((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).SIZE, this.handleSizeChanged_);
        this.addChangeListener((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).TARGET, this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        this.setProperties(optionsInternal.values);
        const map = this;
        if (options.view && !(options.view instanceof (0, $6d96d03cab85bf06$export$2e2bcd8739ae039))) options.view.then(function(viewOptions) {
            map.setView(new (0, $6d96d03cab85bf06$export$2e2bcd8739ae039)(viewOptions));
        });
        this.controls.addEventListener((0, $1febc2967664bf62$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */ (event)=>{
            event.element.setMap(this);
        });
        this.controls.addEventListener((0, $1febc2967664bf62$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.interactions.addEventListener((0, $1febc2967664bf62$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(this);
        });
        this.interactions.addEventListener((0, $1febc2967664bf62$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.overlays_.addEventListener((0, $1febc2967664bf62$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            this.addOverlayInternal_(event.element);
        });
        this.overlays_.addEventListener((0, $1febc2967664bf62$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            const id = event.element.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        });
        this.controls.forEach(/**
       * @param {import("./control/Control.js").default} control Control.
       */ (control)=>{
            control.setMap(this);
        });
        this.interactions.forEach(/**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */ (interaction)=>{
            interaction.setMap(this);
        });
        this.overlays_.forEach(this.addOverlayInternal_.bind(this));
    }
    /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */ addControl(control) {
        this.getControls().push(control);
    }
    /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */ addInteraction(interaction) {
        this.getInteractions().push(interaction);
    }
    /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */ addLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */ handleLayerAdd_(event) {
        $81f11cc9e2668eea$var$setLayerMapProperty(event.layer, this);
    }
    /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */ addOverlay(overlay) {
        this.getOverlays().push(overlay);
    }
    /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */ addOverlayInternal_(overlay) {
        const id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    }
    /**
   *
   * Clean up.
   * @override
   */ disposeInternal() {
        this.controls.clear();
        this.interactions.clear();
        this.overlays_.clear();
        this.resizeObserver_.disconnect();
        this.setTarget(null);
        super.disposeInternal();
    }
    /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */ forEachFeatureAtPixel(pixel, callback, options) {
        if (!this.frameState_ || !this.renderer_) return;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $1a39c7df251dabdd$export$22e23a2304399231);
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    }
    /**
   * Get all features that intersect a pixel on the viewport.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */ getFeaturesAtPixel(pixel, options) {
        const features = [];
        this.forEachFeatureAtPixel(pixel, function(feature) {
            features.push(feature);
        }, options);
        return features;
    }
    /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */ getAllLayers() {
        const layers = [];
        function addLayersFrom(layerGroup) {
            layerGroup.forEach(function(layer) {
                if (layer instanceof (0, $9c4d32c43cd2911b$export$2e2bcd8739ae039)) addLayersFrom(layer.getLayers());
                else layers.push(layer);
            });
        }
        addLayersFrom(this.getLayers());
        return layers;
    }
    /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * For polygons without a fill, only the stroke will be used for hit detection.
   * Polygons must have a fill style applied to ensure that pixels inside a polygon are detected.
   * The fill can be transparent.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */ hasFeatureAtPixel(pixel, options) {
        if (!this.frameState_ || !this.renderer_) return false;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $1a39c7df251dabdd$export$22e23a2304399231);
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    }
    /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */ getEventCoordinate(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    }
    /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */ getEventCoordinateInternal(event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    }
    /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */ getEventPixel(event) {
        const viewport = this.viewport_;
        const viewportPosition = viewport.getBoundingClientRect();
        const viewportSize = this.getSize();
        const scaleX = viewportPosition.width / viewportSize[0];
        const scaleY = viewportPosition.height / viewportSize[1];
        const eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
        'changedTouches' in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            (eventPosition.clientX - viewportPosition.left) / scaleX,
            (eventPosition.clientY - viewportPosition.top) / scaleY
        ];
    }
    /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */ getTarget() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).TARGET);
    }
    /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */ getTargetElement() {
        return this.targetElement_;
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */ getCoordinateFromPixel(pixel) {
        return (0, $d447c151baf41c8c$export$698f563af1ba02a5)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */ getCoordinateFromPixelInternal(pixel) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
    }
    /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */ getControls() {
        return this.controls;
    }
    /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */ getOverlays() {
        return this.overlays_;
    }
    /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default|null} Overlay.
   * @api
   */ getOverlayById(id) {
        const overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    }
    /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */ getInteractions() {
        return this.interactions;
    }
    /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */ getLayerGroup() {
        return /** @type {LayerGroup} */ this.get((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).LAYERGROUP);
    }
    /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */ setLayers(layers) {
        const group = this.getLayerGroup();
        if (layers instanceof (0, $9ac53bee919957f3$export$2e2bcd8739ae039)) {
            group.setLayers(layers);
            return;
        }
        const collection = group.getLayers();
        collection.clear();
        collection.extend(layers);
    }
    /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */ getLayers() {
        const layers = this.getLayerGroup().getLayers();
        return layers;
    }
    /**
   * @return {boolean} Layers have sources that are still loading.
   */ getLoadingOrNotReady() {
        const layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const state = layerStatesArray[i];
            if (!state.visible) continue;
            const renderer = state.layer.getRenderer();
            if (renderer && !renderer.ready) return true;
            const source = state.layer.getSource();
            if (source && source.loading) return true;
        }
        return false;
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */ getPixelFromCoordinate(coordinate) {
        const viewCoordinate = (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */ getPixelFromCoordinateInternal(coordinate) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    }
    /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ getSize() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).SIZE);
    }
    /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */ getView() {
        return /** @type {View} */ this.get((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).VIEW);
    }
    /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */ getViewport() {
        return this.viewport_;
    }
    /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */ getOverlayContainer() {
        return this.overlayContainer_;
    }
    /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */ getOverlayContainerStopEvent() {
        return this.overlayContainerStopEvent_;
    }
    /**
   * @return {!Document} The document where the map is displayed.
   */ getOwnerDocument() {
        const targetElement = this.getTargetElement();
        return targetElement ? targetElement.ownerDocument : document;
    }
    /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */ getTilePriority(tile, tileSourceKey, tileCenter, tileResolution) {
        return (0, $b1b92775009e47d7$export$f08ad5eceeff5d45)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    }
    /**
   * @param {PointerEvent|KeyboardEvent|WheelEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */ handleBrowserEvent(browserEvent, type) {
        type = type || browserEvent.type;
        const mapBrowserEvent = new (0, $873b1fab144826d1$export$2e2bcd8739ae039)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    }
    /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */ handleMapBrowserEvent(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        const originalEvent = mapBrowserEvent.originalEvent;
        const eventType = originalEvent.type;
        if (eventType === (0, $ebfbe553a923ec9c$export$2e2bcd8739ae039).POINTERDOWN || eventType === (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).WHEEL || eventType === (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).KEYDOWN) {
            const doc = this.getOwnerDocument();
            const rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
            const target = /** @type {Node} */ originalEvent.target;
            const currentDoc = rootNode instanceof ShadowRoot ? rootNode.host === target ? rootNode.host.ownerDocument : rootNode : rootNode === doc ? doc.documentElement : rootNode;
            if (// Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
            // It's possible for the target to no longer be in the page if it has been removed in an
            // event listener, this might happen in a Control that recreates it's content based on
            // user interaction either manually or via a render in something like https://reactjs.org/
            !currentDoc.contains(target)) return;
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            const interactionsArray = this.getInteractions().getArray().slice();
            for(let i = interactionsArray.length - 1; i >= 0; i--){
                const interaction = interactionsArray[i];
                if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                const cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) break;
            }
        }
    }
    /**
   * @protected
   */ handlePostRender() {
        const frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        const tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            let maxTotalLoading = this.maxTilesLoading_;
            let maxNewLoads = maxTotalLoading;
            if (frameState) {
                const hints = frameState.viewHints;
                if (hints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).ANIMATING] || hints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).INTERACTING]) {
                    const lowOnFrameBudget = Date.now() - frameState.time > 8;
                    maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                    maxNewLoads = lowOnFrameBudget ? 0 : 2;
                }
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                tileQueue.reprioritize(); // FIXME only call if view has changed
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.renderer_ && !frameState.animate) {
            if (this.renderComplete_) {
                if (this.hasListener((0, $b899a48a5b03178b$export$2e2bcd8739ae039).RENDERCOMPLETE)) this.renderer_.dispatchRenderEvent((0, $b899a48a5b03178b$export$2e2bcd8739ae039).RENDERCOMPLETE, frameState);
                if (this.loaded_ === false) {
                    this.loaded_ = true;
                    this.dispatchEvent(new (0, $30ce67d00d8a722e$export$2e2bcd8739ae039)((0, $9806dbcaf2b91f44$export$2e2bcd8739ae039).LOADEND, this, frameState));
                }
            } else if (this.loaded_ === true) {
                this.loaded_ = false;
                this.dispatchEvent(new (0, $30ce67d00d8a722e$export$2e2bcd8739ae039)((0, $9806dbcaf2b91f44$export$2e2bcd8739ae039).LOADSTART, this, frameState));
            }
        }
        const postRenderFunctions = this.postRenderFunctions_;
        if (frameState) for(let i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    }
    /**
   * @private
   */ handleSizeChanged_() {
        if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
        this.render();
    }
    /**
   * @private
   */ handleTargetChanged_() {
        if (this.mapBrowserEventHandler_) {
            for(let i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i)(0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(this.targetChangeHandlerKeys_[i]);
            this.targetChangeHandlerKeys_ = null;
            this.viewport_.removeEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_);
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            this.viewport_.remove();
        }
        if (this.targetElement_) {
            this.resizeObserver_.unobserve(this.targetElement_);
            const rootNode = this.targetElement_.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.unobserve(rootNode.host);
            this.setSize(undefined);
        }
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        const target = this.getTarget();
        const targetElement = typeof target === 'string' ? document.getElementById(target) : target;
        this.targetElement_ = targetElement;
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        } else {
            targetElement.appendChild(this.viewport_);
            if (!this.renderer_) this.renderer_ = new (0, $3986a6620ede77ea$export$2e2bcd8739ae039)(this);
            this.mapBrowserEventHandler_ = new (0, $01d3ad28990ebd10$export$2e2bcd8739ae039)(this, this.moveTolerance_);
            for(const key in 0, $cf09cedd5e4115ce$export$2e2bcd8739ae039)this.mapBrowserEventHandler_.addEventListener((0, $cf09cedd5e4115ce$export$2e2bcd8739ae039)[key], this.handleMapBrowserEvent.bind(this));
            this.viewport_.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
            this.viewport_.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_, (0, $6f9f9040ddfdc3ac$export$f751ce96c6c4e4fc) ? {
                passive: false
            } : false);
            let keyboardEventTarget;
            if (!this.keyboardEventTarget_) {
                // check if map target is in shadowDOM, if yes use host element as target
                const targetRoot = targetElement.getRootNode();
                const targetCandidate = targetRoot instanceof ShadowRoot ? targetRoot.host : targetElement;
                keyboardEventTarget = targetCandidate;
            } else keyboardEventTarget = this.keyboardEventTarget_;
            this.targetChangeHandlerKeys_ = [
                (0, $7d7dee7854c96264$export$63174c828edd6ff8)(keyboardEventTarget, (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).KEYDOWN, this.handleBrowserEvent, this),
                (0, $7d7dee7854c96264$export$63174c828edd6ff8)(keyboardEventTarget, (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).KEYPRESS, this.handleBrowserEvent, this)
            ];
            const rootNode = targetElement.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.observe(rootNode.host);
            this.resizeObserver_.observe(targetElement);
        }
        this.updateSize();
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    }
    /**
   * @private
   */ handleTileChange_() {
        this.render();
    }
    /**
   * @private
   */ handleViewPropertyChanged_() {
        this.render();
    }
    /**
   * @private
   */ handleViewChanged_() {
        if (this.viewPropertyListenerKey_) {
            (0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        const view = this.getView();
        if (view) {
            this.updateViewportSize_(this.getSize());
            this.viewPropertyListenerKey_ = (0, $7d7dee7854c96264$export$63174c828edd6ff8)(view, (0, $2a15c8802c911fe7$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, $7d7dee7854c96264$export$63174c828edd6ff8)(view, (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    }
    /**
   * @private
   */ handleLayerGroupChanged_() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, $7d7dee7854c96264$export$b0a21c8b3c1c921));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        const layerGroup = this.getLayerGroup();
        if (layerGroup) {
            this.handleLayerAdd_(new (0, $9c4d32c43cd2911b$export$2f5ff21d758d25a7)('addlayer', layerGroup));
            this.layerGroupPropertyListenerKeys_ = [
                (0, $7d7dee7854c96264$export$63174c828edd6ff8)(layerGroup, (0, $2a15c8802c911fe7$export$2e2bcd8739ae039).PROPERTYCHANGE, this.render, this),
                (0, $7d7dee7854c96264$export$63174c828edd6ff8)(layerGroup, (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, this.render, this),
                (0, $7d7dee7854c96264$export$63174c828edd6ff8)(layerGroup, 'addlayer', this.handleLayerAdd_, this),
                (0, $7d7dee7854c96264$export$63174c828edd6ff8)(layerGroup, 'removelayer', this.handleLayerRemove_, this)
            ];
        }
        this.render();
    }
    /**
   * @return {boolean} Is rendered.
   */ isRendered() {
        return !!this.frameState_;
    }
    /**
   * @private
   */ animationDelay_() {
        this.animationDelayKey_ = undefined;
        this.renderFrame_(Date.now());
    }
    /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */ renderSync() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    }
    /**
   * Redraws all text after new fonts have loaded
   */ redrawText() {
        const layerStates = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStates.length; i < ii; ++i){
            const layer = layerStates[i].layer;
            if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
        }
    }
    /**
   * Request a map rendering (at the next animation frame).
   * @api
   */ render() {
        if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    }
    /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */ removeControl(control) {
        return this.getControls().remove(control);
    }
    /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */ removeInteraction(interaction) {
        return this.getInteractions().remove(interaction);
    }
    /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */ removeLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */ handleLayerRemove_(event) {
        $81f11cc9e2668eea$var$removeLayerMapProperty(event.layer);
    }
    /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */ removeOverlay(overlay) {
        return this.getOverlays().remove(overlay);
    }
    /**
   * @param {number} time Time.
   * @private
   */ renderFrame_(time) {
        const size = this.getSize();
        const view = this.getView();
        const previousFrameState = this.frameState_;
        /** @type {?FrameState} */ let frameState = null;
        if (size !== undefined && (0, $090e4507b3b63c57$export$622c471beb1693c7)(size) && view && view.isDef()) {
            const viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            const viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutter: null,
                extent: (0, $110ceb23457e07e7$export$13ba650faf8308)(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {},
                mapId: (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(this),
                renderTargets: {}
            };
            if (viewState.nextCenter && viewState.nextResolution) {
                const rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
                frameState.nextExtent = (0, $110ceb23457e07e7$export$13ba650faf8308)(viewState.nextCenter, viewState.nextResolution, rotation, size);
            }
        }
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                const moveStart = !this.previousExtent_ || !(0, $110ceb23457e07e7$export$dd1bc94b04021eeb)(this.previousExtent_) && !(0, $110ceb23457e07e7$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, $30ce67d00d8a722e$export$2e2bcd8739ae039)((0, $9806dbcaf2b91f44$export$2e2bcd8739ae039).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, $110ceb23457e07e7$export$3e2152b047719fa1)(this.previousExtent_);
                }
            }
            const idle = this.previousExtent_ && !frameState.viewHints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).ANIMATING] && !frameState.viewHints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).INTERACTING] && !(0, $110ceb23457e07e7$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, $30ce67d00d8a722e$export$2e2bcd8739ae039)((0, $9806dbcaf2b91f44$export$2e2bcd8739ae039).MOVEEND, this, frameState));
                (0, $110ceb23457e07e7$export$9cd59f9826255e47)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, $30ce67d00d8a722e$export$2e2bcd8739ae039)((0, $9806dbcaf2b91f44$export$2e2bcd8739ae039).POSTRENDER, this, frameState));
        this.renderComplete_ = (this.hasListener((0, $9806dbcaf2b91f44$export$2e2bcd8739ae039).LOADSTART) || this.hasListener((0, $9806dbcaf2b91f44$export$2e2bcd8739ae039).LOADEND) || this.hasListener((0, $b899a48a5b03178b$export$2e2bcd8739ae039).RENDERCOMPLETE)) && !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady();
        if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(()=>{
            this.postRenderTimeoutHandle_ = undefined;
            this.handlePostRender();
        }, 0);
    }
    /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */ setLayerGroup(layerGroup) {
        const oldLayerGroup = this.getLayerGroup();
        if (oldLayerGroup) this.handleLayerRemove_(new (0, $9c4d32c43cd2911b$export$2f5ff21d758d25a7)('removelayer', oldLayerGroup));
        this.set((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).LAYERGROUP, layerGroup);
    }
    /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ setSize(size) {
        this.set((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).SIZE, size);
    }
    /**
   * Set the target element to render this map into.
   * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
   *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
   *  `tabindex` atribute must be set on the custom element's host element.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */ setTarget(target) {
        this.set((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).TARGET, target);
    }
    /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>|null} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */ setView(view) {
        if (!view || view instanceof (0, $6d96d03cab85bf06$export$2e2bcd8739ae039)) {
            this.set((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).VIEW, view);
            return;
        }
        this.set((0, $7f2e61d938db36e0$export$2e2bcd8739ae039).VIEW, new (0, $6d96d03cab85bf06$export$2e2bcd8739ae039)());
        const map = this;
        view.then(function(viewOptions) {
            map.setView(new (0, $6d96d03cab85bf06$export$2e2bcd8739ae039)(viewOptions));
        });
    }
    /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */ updateSize() {
        const targetElement = this.getTargetElement();
        let size = undefined;
        if (targetElement) {
            const computedStyle = getComputedStyle(targetElement);
            const width = targetElement.offsetWidth - parseFloat(computedStyle['borderLeftWidth']) - parseFloat(computedStyle['paddingLeft']) - parseFloat(computedStyle['paddingRight']) - parseFloat(computedStyle['borderRightWidth']);
            const height = targetElement.offsetHeight - parseFloat(computedStyle['borderTopWidth']) - parseFloat(computedStyle['paddingTop']) - parseFloat(computedStyle['paddingBottom']) - parseFloat(computedStyle['borderBottomWidth']);
            if (!isNaN(width) && !isNaN(height)) {
                size = [
                    Math.max(0, width),
                    Math.max(0, height)
                ];
                if (!(0, $090e4507b3b63c57$export$622c471beb1693c7)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) (0, $87184501dfc6591a$export$c106dd0671a0fc2d)("No map visible because the map container's width or height are 0.");
            }
        }
        const oldSize = this.getSize();
        if (size && (!oldSize || !(0, $9d07dd9052c3de0c$export$e9bab7fafb253603)(size, oldSize))) {
            this.setSize(size);
            this.updateViewportSize_(size);
        }
    }
    /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @param {import("./size.js").Size|undefined} size The size.
   * @private
   */ updateViewportSize_(size) {
        const view = this.getView();
        if (view) view.setViewportSize(size);
    }
}
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $81f11cc9e2668eea$var$createOptionsInternal(options) {
    /**
   * @type {HTMLElement|Document}
   */ let keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === 'string' ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
   * @type {Object<string, *>}
   */ const values = {};
    const layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === 'function' ? /** @type {LayerGroup} */ options.layers : new (0, $9c4d32c43cd2911b$export$2e2bcd8739ae039)({
        layers: /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */ options.layers
    });
    values[(0, $7f2e61d938db36e0$export$2e2bcd8739ae039).LAYERGROUP] = layerGroup;
    values[(0, $7f2e61d938db36e0$export$2e2bcd8739ae039).TARGET] = options.target;
    values[(0, $7f2e61d938db36e0$export$2e2bcd8739ae039).VIEW] = options.view instanceof (0, $6d96d03cab85bf06$export$2e2bcd8739ae039) ? options.view : new (0, $6d96d03cab85bf06$export$2e2bcd8739ae039)();
    /** @type {Collection<import("./control/Control.js").default>} */ let controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $9ac53bee919957f3$export$2e2bcd8739ae039)(options.controls.slice());
        else {
            (0, $4b57691230be0bd5$export$a7a9523472993e97)(typeof /** @type {?} */ options.controls.getArray === 'function', 'Expected `controls` to be an array or an `ol/Collection.js`');
            controls = options.controls;
        }
    }
    /** @type {Collection<import("./interaction/Interaction").default>} */ let interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $9ac53bee919957f3$export$2e2bcd8739ae039)(options.interactions.slice());
        else {
            (0, $4b57691230be0bd5$export$a7a9523472993e97)(typeof /** @type {?} */ options.interactions.getArray === 'function', 'Expected `interactions` to be an array or an `ol/Collection.js`');
            interactions = options.interactions;
        }
    }
    /** @type {Collection<import("./Overlay.js").default>} */ let overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $9ac53bee919957f3$export$2e2bcd8739ae039)(options.overlays.slice());
        else {
            (0, $4b57691230be0bd5$export$a7a9523472993e97)(typeof /** @type {?} */ options.overlays.getArray === 'function', 'Expected `overlays` to be an array or an `ol/Collection.js`');
            overlays = options.overlays;
        }
    } else overlays = new (0, $9ac53bee919957f3$export$2e2bcd8739ae039)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $81f11cc9e2668eea$export$2e2bcd8739ae039 = $81f11cc9e2668eea$var$Map;



/**
 * @module ol/layer/Tile
 */ /**
 * @module ol/renderer/canvas/TileLayer
 */ /**
 * @module ol/DataTile
 */ /**
 * @module ol/Tile
 */ 




/**
 * A function that takes a {@link module:ol/Tile~Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState.js';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   const xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     const data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~TileSource} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes a {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection~Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ class $83a24df5588a4450$var$Tile extends (0, $dc972e87e0b45224$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {Options} [options] Tile options.
   */ constructor(tileCoord, state, options){
        super();
        options = options ? options : {};
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.tileCoord = tileCoord;
        /**
     * @protected
     * @type {import("./TileState.js").default}
     */ this.state = state;
        /**
     * A key assigned to the tile. This is used in conjunction with a source key
     * to determine if a cached version of this tile may be used by the renderer.
     * @type {string}
     */ this.key = '';
        /**
     * The duration for the opacity transition.
     * @private
     * @type {number}
     */ this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
     * Lookup of start times for rendering transitions.  If the start time is
     * equal to -1, the transition is complete.
     * @private
     * @type {Object<string, number>}
     */ this.transitionStarts_ = {};
        /**
     * @type {boolean}
     */ this.interpolate = !!options.interpolate;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */ release() {
        // to remove the `change` listener on this tile in `ol/TileQueue#handleTileChange`
        this.setState((0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY);
    }
    /**
   * @return {string} Key.
   */ getKey() {
        return this.key + '/' + this.tileCoord;
    }
    /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */ getTileCoord() {
        return this.tileCoord;
    }
    /**
   * @return {import("./TileState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */ setState(state) {
        if (this.state === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY) // no more state changes
        return;
        if (this.state !== (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR && this.state > state) throw new Error('Tile load sequence violation');
        this.state = state;
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */ load() {
        (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */ getAlpha(id, time) {
        if (!this.transition_) return 1;
        let start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        const delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, $5354ee427f82b926$export$929e5a82286172a6)(delta / this.transition_);
    }
    /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */ inTransition(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    }
    /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */ endTransition(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    }
    /**
   * @override
   */ disposeInternal() {
        this.release();
        super.disposeInternal();
    }
}
var $83a24df5588a4450$export$2e2bcd8739ae039 = $83a24df5588a4450$var$Tile;




function $92d24567a9854da1$export$3a7c913cb40dcb7d(data) {
    return data instanceof Image || data instanceof HTMLCanvasElement || data instanceof HTMLVideoElement || data instanceof ImageBitmap ? data : null;
}
function $92d24567a9854da1$export$7386cb0413f6b283(data) {
    return data instanceof Uint8Array || data instanceof Uint8ClampedArray || data instanceof Float32Array || data instanceof DataView ? data : null;
}
const $92d24567a9854da1$export$df4c617b86128e3e = new Error('disposed');
/**
 * @type {CanvasRenderingContext2D|null}
 */ let $92d24567a9854da1$var$sharedContext = null;
function $92d24567a9854da1$export$45b10814cc054894(image) {
    if (!$92d24567a9854da1$var$sharedContext) $92d24567a9854da1$var$sharedContext = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(image.width, image.height, undefined, {
        willReadFrequently: true
    });
    const canvas = $92d24567a9854da1$var$sharedContext.canvas;
    const width = image.width;
    if (canvas.width !== width) canvas.width = width;
    const height = image.height;
    if (canvas.height !== height) canvas.height = height;
    $92d24567a9854da1$var$sharedContext.clearRect(0, 0, width, height);
    $92d24567a9854da1$var$sharedContext.drawImage(image, 0, 0);
    return $92d24567a9854da1$var$sharedContext.getImageData(0, 0, width, height).data;
}
/**
 * @type {import('./size.js').Size}
 */ const $92d24567a9854da1$var$defaultSize = [
    256,
    256
];
/**
 * @typedef {Object} Options
 * @property {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @property {function(): Promise<Data>} loader Data loader.  For loaders that generate images,
 * the promise should not resolve until the image is loaded.
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @property {import('./size.js').Size} [size=[256, 256]] Tile size.
 * @property {AbortController} [controller] An abort controller.
 * @api
 */ class $92d24567a9854da1$var$DataTile extends (0, $83a24df5588a4450$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Tile options.
   */ constructor(options){
        const state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE;
        super(options.tileCoord, state, {
            transition: options.transition,
            interpolate: options.interpolate
        });
        /**
     * @type {function(): Promise<Data>}
     * @private
     */ this.loader_ = options.loader;
        /**
     * @type {Data}
     * @private
     */ this.data_ = null;
        /**
     * @type {Error}
     * @private
     */ this.error_ = null;
        /**
     * @type {import('./size.js').Size|null}
     * @private
     */ this.size_ = options.size || null;
        /**
     * @type {AbortController|null}
     * @private
     */ this.controller_ = options.controller || null;
    }
    /**
   * Get the tile size.
   * @return {import('./size.js').Size} Tile size.
   */ getSize() {
        if (this.size_) return this.size_;
        const imageData = $92d24567a9854da1$export$3a7c913cb40dcb7d(this.data_);
        if (imageData) return [
            imageData.width,
            imageData.height
        ];
        return $92d24567a9854da1$var$defaultSize;
    }
    /**
   * Get the data for the tile.
   * @return {Data} Tile data.
   * @api
   */ getData() {
        return this.data_;
    }
    /**
   * Get any loading error.
   * @return {Error} Loading error.
   * @api
   */ getError() {
        return this.error_;
    }
    /**
   * Load the tile data.
   * @api
   * @override
   */ load() {
        if (this.state !== (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE && this.state !== (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR) return;
        this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADING;
        this.changed();
        const self = this;
        this.loader_().then(function(data) {
            self.data_ = data;
            self.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED;
            self.changed();
        }).catch(function(error) {
            self.error_ = error;
            self.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR;
            self.changed();
        });
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.controller_) {
            this.controller_.abort($92d24567a9854da1$export$df4c617b86128e3e);
            this.controller_ = null;
        }
        super.disposeInternal();
    }
}
var $92d24567a9854da1$export$2e2bcd8739ae039 = $92d24567a9854da1$var$DataTile;


/**
 * @module ol/ImageTile
 */ 



class $ae0d8a38ddc9cf8f$var$ImageTile extends (0, $83a24df5588a4450$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */ constructor(tileCoord, state, src, crossOrigin, tileLoadFunction, options){
        super(tileCoord, state, options);
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * Image URI
     *
     * @private
     * @type {string}
     */ this.src_ = src;
        this.key = src;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */ this.image_ = new Image();
        if (crossOrigin !== null) this.image_.crossOrigin = crossOrigin;
        /**
     * @private
     * @type {?function():void}
     */ this.unlisten_ = null;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
    }
    /**
   * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|HTMLImageElement} element Element.
   */ setImage(element) {
        this.image_ = element;
        this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Tracks loading or read errors.
   *
   * @private
   */ handleImageError_() {
        this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.image_ = $ae0d8a38ddc9cf8f$var$getBlankImage();
        this.changed();
    }
    /**
   * Tracks successful image load.
   *
   * @private
   */ handleImageLoad_() {
        const image = /** @type {HTMLImageElement} */ this.image_;
        if (image.naturalWidth && image.naturalHeight) this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED;
        else this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   * @api
   * @override
   */ load() {
        if (this.state == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR) {
            this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        }
        if (this.state == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = (0, $ed625c77f0e14437$export$bc96ecc7c2a50764)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    }
    /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ unlistenImage_() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    }
    /**
   * @override
   */ disposeInternal() {
        this.unlistenImage_();
        this.image_ = null;
        super.disposeInternal();
    }
}
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement} Blank image.
 */ function $ae0d8a38ddc9cf8f$var$getBlankImage() {
    const ctx = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(1, 1);
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $ae0d8a38ddc9cf8f$export$2e2bcd8739ae039 = $ae0d8a38ddc9cf8f$var$ImageTile;


/**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ class $99c318de9bdac32c$var$TileRange {
    /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */ constructor(minX, maxX, minY, maxY){
        /**
     * @type {number}
     */ this.minX = minX;
        /**
     * @type {number}
     */ this.maxX = maxX;
        /**
     * @type {number}
     */ this.minY = minY;
        /**
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */ contains(tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */ containsTileRange(tileRange) {
        return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
    }
    /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */ containsXY(x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */ equals(tileRange) {
        return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   */ extend(tileRange) {
        if (tileRange.minX < this.minX) this.minX = tileRange.minX;
        if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
        if (tileRange.minY < this.minY) this.minY = tileRange.minY;
        if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
    }
    /**
   * @return {number} Height.
   */ getHeight() {
        return this.maxY - this.minY + 1;
    }
    /**
   * @return {import("./size.js").Size} Size.
   */ getSize() {
        return [
            this.getWidth(),
            this.getHeight()
        ];
    }
    /**
   * @return {number} Width.
   */ getWidth() {
        return this.maxX - this.minX + 1;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */ intersects(tileRange) {
        return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
    }
}
function $99c318de9bdac32c$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    }
    return new $99c318de9bdac32c$var$TileRange(minX, maxX, minY, maxY);
}
var $99c318de9bdac32c$export$2e2bcd8739ae039 = $99c318de9bdac32c$var$TileRange;






/**
 * @module ol/reproj/Tile
 */ 






/**
 * @module ol/reproj
 */ 



let $bacfb5046880f5ad$var$brokenDiagonalRendering_;
const $bacfb5046880f5ad$export$a166f0857c555517 = [];
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function $bacfb5046880f5ad$var$drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function $bacfb5046880f5ad$var$verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function $bacfb5046880f5ad$var$isBrokenDiagonalRendering() {
    if ($bacfb5046880f5ad$var$brokenDiagonalRendering_ === undefined) {
        const ctx = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(6, 6, $bacfb5046880f5ad$export$a166f0857c555517);
        ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = 'rgba(210, 0, 0, 0.75)';
        $bacfb5046880f5ad$var$drawTestTriangle(ctx, 4, 5, 4, 0);
        $bacfb5046880f5ad$var$drawTestTriangle(ctx, 4, 5, 0, 5);
        const data = ctx.getImageData(0, 0, 3, 3).data;
        $bacfb5046880f5ad$var$brokenDiagonalRendering_ = $bacfb5046880f5ad$var$verifyBrokenDiagonalRendering(data, 0) || $bacfb5046880f5ad$var$verifyBrokenDiagonalRendering(data, 4) || $bacfb5046880f5ad$var$verifyBrokenDiagonalRendering(data, 8);
        (0, $32c8adb5331a7848$export$e918ac6a1026a12a)(ctx);
        $bacfb5046880f5ad$export$a166f0857c555517.push(ctx.canvas);
    }
    return $bacfb5046880f5ad$var$brokenDiagonalRendering_;
}
function $bacfb5046880f5ad$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    const sourceCenter = (0, $d447c151baf41c8c$export$51186ad6e864892a)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    let sourceResolution = (0, $d447c151baf41c8c$export$2d8f7b4eec383d44)(targetProj, targetResolution, targetCenter);
    const targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    const sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    const sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $110ceb23457e07e7$export$ac68c24d37ca240f)(sourceExtent, sourceCenter)) {
        const compensationFactor = (0, $d447c151baf41c8c$export$2d8f7b4eec383d44)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function $bacfb5046880f5ad$export$16d356211d01f1cc(sourceProj, targetProj, targetExtent, targetResolution) {
    const targetCenter = (0, $110ceb23457e07e7$export$c91255cadecfe081)(targetExtent);
    let sourceResolution = $bacfb5046880f5ad$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, $110ceb23457e07e7$export$f9ed8a3d123a08e2)(targetExtent, function(corner) {
        sourceResolution = $bacfb5046880f5ad$export$5fbb958059b7e71f(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function $bacfb5046880f5ad$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, renderEdges, interpolate, drawSingle, clipExtent) {
    const context = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(Math.round(pixelRatio * width), Math.round(pixelRatio * height), $bacfb5046880f5ad$export$a166f0857c555517);
    if (!interpolate) context.imageSmoothingEnabled = false;
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = 'lighter';
    const sourceDataExtent = (0, $110ceb23457e07e7$export$fe201bb3bbe031e9)();
    sources.forEach(function(src, i, arr) {
        (0, $110ceb23457e07e7$export$8b58be045bf06082)(sourceDataExtent, src.extent);
    });
    let stitchContext;
    const stitchScale = pixelRatio / sourceResolution;
    // Round up Float32 scale values to prevent interpolation in Firefox.
    const inverseScale = (interpolate ? 1 : 1 + Math.pow(2, -24)) / stitchScale;
    if (!drawSingle || sources.length !== 1 || gutter !== 0) {
        stitchContext = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(Math.round((0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(sourceDataExtent) * stitchScale), Math.round((0, $110ceb23457e07e7$export$c08559766941f856)(sourceDataExtent) * stitchScale), $bacfb5046880f5ad$export$a166f0857c555517);
        if (!interpolate) stitchContext.imageSmoothingEnabled = false;
        if (sourceExtent && clipExtent) {
            const xPos = (sourceExtent[0] - sourceDataExtent[0]) * stitchScale;
            const yPos = -(sourceExtent[3] - sourceDataExtent[3]) * stitchScale;
            const width = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(sourceExtent) * stitchScale;
            const height = (0, $110ceb23457e07e7$export$c08559766941f856)(sourceExtent) * stitchScale;
            stitchContext.rect(xPos, yPos, width, height);
            stitchContext.clip();
        }
        sources.forEach(function(src, i, arr) {
            // This test should never fail -- but it does. Need to find a fix the upstream condition
            if (src.image.width > 0 && src.image.height > 0) {
                if (src.clipExtent) {
                    stitchContext.save();
                    const xPos = (src.clipExtent[0] - sourceDataExtent[0]) * stitchScale;
                    const yPos = -(src.clipExtent[3] - sourceDataExtent[3]) * stitchScale;
                    const width = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(src.clipExtent) * stitchScale;
                    const height = (0, $110ceb23457e07e7$export$c08559766941f856)(src.clipExtent) * stitchScale;
                    stitchContext.rect(interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? width : Math.round(xPos + width) - Math.round(xPos), interpolate ? height : Math.round(yPos + height) - Math.round(yPos));
                    stitchContext.clip();
                }
                const xPos = (src.extent[0] - sourceDataExtent[0]) * stitchScale;
                const yPos = -(src.extent[3] - sourceDataExtent[3]) * stitchScale;
                const srcWidth = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(src.extent) * stitchScale;
                const srcHeight = (0, $110ceb23457e07e7$export$c08559766941f856)(src.extent) * stitchScale;
                stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? srcWidth : Math.round(xPos + srcWidth) - Math.round(xPos), interpolate ? srcHeight : Math.round(yPos + srcHeight) - Math.round(yPos));
                if (src.clipExtent) stitchContext.restore();
            }
        });
    }
    const targetTopLeft = (0, $110ceb23457e07e7$export$cb1538b07e6964ff)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
     * Resulting matrix can be used to transform coordinate
     * from `sourceProjection` to destination pixels.
     *
     * To optimize number of context calls and increase numerical stability,
     * we also do the following operations:
     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
     * here before solving the linear system so [ui, vi] are pixel coordinates.
     *
     * Src points: xi, yi
     * Dst points: ui, vi
     * Affine coefficients: aij
     *
     * | x0 y0 1  0  0 0 |   |a00|   |u0|
     * | x1 y1 1  0  0 0 |   |a01|   |u1|
     * | x2 y2 1  0  0 0 | x |a02| = |u2|
     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
     */ const source = triangle.source;
        const target = triangle.target;
        let x0 = source[0][0], y0 = source[0][1];
        let x1 = source[1][0], y1 = source[1][1];
        let x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        const u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        const v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        const u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        const v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        const u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        const v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        const sourceNumericalShiftX = x0;
        const sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        const augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        const affineCoefs = (0, $91ceb5420a5c8360$export$8240f01c446270e6)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if ($bacfb5046880f5ad$var$isBrokenDiagonalRendering() || !interpolate) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            const steps = 4;
            const ud = u0 - u1;
            const vd = v0 - v1;
            for(let step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        let image;
        if (stitchContext) {
            image = stitchContext.canvas;
            context.scale(inverseScale, -inverseScale);
        } else {
            const source = sources[0];
            const extent = source.extent;
            image = source.image;
            context.scale((0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(extent) / image.width, -(0, $110ceb23457e07e7$export$c08559766941f856)(extent) / image.height);
        }
        context.drawImage(image, 0, 0);
        context.restore();
    });
    if (stitchContext) {
        (0, $32c8adb5331a7848$export$e918ac6a1026a12a)(stitchContext);
        $bacfb5046880f5ad$export$a166f0857c555517.push(stitchContext.canvas);
    }
    if (renderEdges) {
        context.save();
        context.globalCompositeOperation = 'source-over';
        context.strokeStyle = 'black';
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            const target = triangle.target;
            const u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            const v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            const u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            const v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            const u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            const v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}


/**
 * @module ol/reproj/Triangulation
 */ 



/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ const $e2d24862fbb0e724$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ const $e2d24862fbb0e724$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ class $e2d24862fbb0e724$var$Triangulation {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
   * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
   * @param {number} errorThreshold Acceptable error (in source units).
   * @param {?number} destinationResolution The (optional) resolution of the destination.
   * @param {import("../transform.js").Transform} [sourceMatrix] Source transform matrix.
   */ constructor(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, destinationResolution, sourceMatrix){
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.sourceProj_ = sourceProj;
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ let transformInvCache = {};
        const transformInv = sourceMatrix ? (0, $d447c151baf41c8c$export$6b4aafd331159e0d)((input)=>(0, $a684e03243281d90$export$5635d7ef4b8fee1c)(sourceMatrix, (0, $d447c151baf41c8c$export$51186ad6e864892a)(input, this.targetProj_, this.sourceProj_))) : (0, $d447c151baf41c8c$export$fce0c6cfca85ed96)(this.targetProj_, this.sourceProj_);
        /**
     * @param {import("../coordinate.js").Coordinate} c A coordinate.
     * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
     * @private
     */ this.transformInv_ = function(c) {
            const key = c[0] + '/' + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
     * @type {import("../extent.js").Extent}
     * @private
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @type {number}
     * @private
     */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
     * @type {Array<Triangle>}
     * @private
     */ this.triangles_ = [];
        /**
     * Indicates that the triangulation crosses edge of the source projection.
     * @type {boolean}
     * @private
     */ this.wrapsXInSource_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(maxSourceExtent) >= (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent());
        /**
     * @type {?number}
     * @private
     */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent()) : null;
        /**
     * @type {?number}
     * @private
     */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(this.targetProj_.getExtent()) : null;
        const destinationTopLeft = (0, $110ceb23457e07e7$export$cb1538b07e6964ff)(targetExtent);
        const destinationTopRight = (0, $110ceb23457e07e7$export$b84fa077c8b05295)(targetExtent);
        const destinationBottomRight = (0, $110ceb23457e07e7$export$e77c1cf70445e168)(targetExtent);
        const destinationBottomLeft = (0, $110ceb23457e07e7$export$8d09f5e2e1bf560d)(targetExtent);
        const sourceTopLeft = this.transformInv_(destinationTopLeft);
        const sourceTopRight = this.transformInv_(destinationTopRight);
        const sourceBottomRight = this.transformInv_(destinationBottomRight);
        const sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
     * The maxSubdivision controls how many splittings of the target area can
     * be done. The idea here is to do a linear mapping of the target areas
     * but the actual overall reprojection (can be) extremely non-linear. The
     * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
     * tile size. However this function is also called to remap canvas rendered
     * layers which can be much larger. This calculation increases the maxSubdivision
     * value by the right factor so that each 256x256 pixel area has
     * MAX_SUBDIVISION divisions.
     */ const maxSubdivision = $e2d24862fbb0e724$var$MAX_SUBDIVISION + (destinationResolution ? Math.max(0, Math.ceil(Math.log2((0, $110ceb23457e07e7$export$520c40045967cb15)(targetExtent) / (destinationResolution * destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            let leftBound = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound = Math.min(leftBound, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach((triangle)=>{
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound > this.sourceWorldWidth_ / 2) {
                    const newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    const minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    const maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            });
        }
        transformInvCache = {};
    }
    /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */ addTriangle_(a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [
                aSrc,
                bSrc,
                cSrc
            ],
            target: [
                a,
                b,
                c
            ]
        });
    }
    /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */ addQuad_(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        const sourceQuadExtent = (0, $110ceb23457e07e7$export$8aceca7c77505534)([
            aSrc,
            bSrc,
            cSrc,
            dSrc
        ]);
        const sourceCoverageX = this.sourceWorldWidth_ ? (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
        const sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        const wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
        let needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                const targetQuadExtent = (0, $110ceb23457e07e7$export$8aceca7c77505534)([
                    a,
                    b,
                    c,
                    d
                ]);
                const targetCoverageX = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision = targetCoverageX > $e2d24862fbb0e724$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $e2d24862fbb0e724$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                if (!(0, $110ceb23457e07e7$export$7b0a31e10bbff018)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                return;
            }
        }
        let isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) needsSubdivision = true;
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                const center = [
                    (a[0] + c[0]) / 2,
                    (a[1] + c[1]) / 2
                ];
                const centerSrc = this.transformInv_(center);
                let dx;
                if (wrapsX) {
                    const centerSrcEstimX = ((0, $91ceb5420a5c8360$export$ba467bec01d66def)(aSrc[0], sourceWorldWidth) + (0, $91ceb5420a5c8360$export$ba467bec01d66def)(cSrc[0], sourceWorldWidth)) / 2;
                    dx = centerSrcEstimX - (0, $91ceb5420a5c8360$export$ba467bec01d66def)(centerSrc[0], sourceWorldWidth);
                } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                const dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                const centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    const bc = [
                        (b[0] + c[0]) / 2,
                        (b[1] + c[1]) / 2
                    ];
                    const bcSrc = this.transformInv_(bc);
                    const da = [
                        (d[0] + a[0]) / 2,
                        (d[1] + a[1]) / 2
                    ];
                    const daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                } else {
                    // split vertically (left & right)
                    const ab = [
                        (a[0] + b[0]) / 2,
                        (a[1] + b[1]) / 2
                    ];
                    const abSrc = this.transformInv_(ab);
                    const cd = [
                        (c[0] + d[0]) / 2,
                        (c[1] + d[1]) / 2
                    ];
                    const cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) return;
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
        }
    }
    /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */ calculateSourceExtent() {
        const extent = (0, $110ceb23457e07e7$export$fe201bb3bbe031e9)();
        this.triangles_.forEach(function(triangle, i, arr) {
            const src = triangle.source;
            (0, $110ceb23457e07e7$export$1f820e3920fa5715)(extent, src[0]);
            (0, $110ceb23457e07e7$export$1f820e3920fa5715)(extent, src[1]);
            (0, $110ceb23457e07e7$export$1f820e3920fa5715)(extent, src[2]);
        });
        return extent;
    }
    /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */ getTriangles() {
        return this.triangles_;
    }
}
var $e2d24862fbb0e724$export$2e2bcd8739ae039 = $e2d24862fbb0e724$var$Triangulation;


/**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ const $d6da87e23c11b61c$export$3ecb4bcfa5aae855 = 0.5;


/**
 * @typedef {function(number, number, number, number) : (import("../ImageTile.js").default)} FunctionType
 */ /**
 * @typedef {Object} TileOffset
 * @property {import("../ImageTile.js").default} tile Tile.
 * @property {number} offset Offset.
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ class $99cafc0f9d5ff6b5$var$ReprojTile extends (0, $83a24df5588a4450$export$2e2bcd8739ae039) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
   * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} gutter Gutter of the source tiles.
   * @param {FunctionType} getTileFunction
   *     Function returning source tiles (z, x, y, pixelRatio).
   * @param {number} [errorThreshold] Acceptable reprojection error (in px).
   * @param {boolean} [renderEdges] Render reprojection edges.
   * @param {import("../Tile.js").Options} [options] Tile options.
   */ constructor(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, errorThreshold, renderEdges, options){
        super(tileCoord, (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE, options);
        /**
     * @private
     * @type {boolean}
     */ this.renderEdges_ = renderEdges !== undefined ? renderEdges : false;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.gutter_ = gutter;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.sourceTileGrid_ = sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.targetTileGrid_ = targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
     * @private
     * @type {!Array<TileOffset>}
     */ this.sourceTiles_ = [];
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ this.sourceZ_ = 0;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.clipExtent_ = sourceProj.canWrapX() ? sourceProj.getExtent() : undefined;
        const targetExtent = targetTileGrid.getTileCoordExtent(this.wrappedTileCoord_);
        const maxTargetExtent = this.targetTileGrid_.getExtent();
        let maxSourceExtent = this.sourceTileGrid_.getExtent();
        const limitedTargetExtent = maxTargetExtent ? (0, $110ceb23457e07e7$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $110ceb23457e07e7$export$520c40045967cb15)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $110ceb23457e07e7$export$72209efa88586d42)(maxSourceExtent, sourceProjExtent);
        }
        const targetResolution = targetTileGrid.getResolution(this.wrappedTileCoord_[0]);
        const sourceResolution = (0, $bacfb5046880f5ad$export$16d356211d01f1cc)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const errorThresholdInPixels = errorThreshold !== undefined ? errorThreshold : (0, $d6da87e23c11b61c$export$3ecb4bcfa5aae855);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = new (0, $e2d24862fbb0e724$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        let sourceExtent = this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $110ceb23457e07e7$export$72209efa88586d42)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $110ceb23457e07e7$export$520c40045967cb15)(sourceExtent)) this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY;
        else {
            let worldWidth = 0;
            let worldsAway = 0;
            if (sourceProj.canWrapX()) {
                worldWidth = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(sourceProjExtent);
                worldsAway = Math.floor((sourceExtent[0] - sourceProjExtent[0]) / worldWidth);
            }
            const sourceExtents = (0, $110ceb23457e07e7$export$9031237f01de0947)(sourceExtent.slice(), sourceProj, true);
            sourceExtents.forEach((extent)=>{
                const sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(extent, this.sourceZ_);
                for(let srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(let srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                    const tile = getTileFunction(this.sourceZ_, srcX, srcY, pixelRatio);
                    if (tile) {
                        const offset = worldsAway * worldWidth;
                        this.sourceTiles_.push({
                            tile: tile,
                            offset: offset
                        });
                    }
                }
                ++worldsAway;
            });
            if (this.sourceTiles_.length === 0) this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY;
        }
    }
    /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement} Canvas.
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @private
   */ reproject_() {
        const sources = [];
        this.sourceTiles_.forEach((source)=>{
            const tile = source.tile;
            if (tile && tile.getState() == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED) {
                const extent = this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord);
                extent[0] += source.offset;
                extent[2] += source.offset;
                const clipExtent = this.clipExtent_?.slice();
                if (clipExtent) {
                    clipExtent[0] += source.offset;
                    clipExtent[2] += source.offset;
                }
                sources.push({
                    extent: extent,
                    clipExtent: clipExtent,
                    image: tile.getImage()
                });
            }
        });
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR;
        else {
            const z = this.wrappedTileCoord_[0];
            const size = this.targetTileGrid_.getTileSize(z);
            const width = typeof size === 'number' ? size : size[0];
            const height = typeof size === 'number' ? size : size[1];
            const targetResolution = this.targetTileGrid_.getResolution(z);
            const sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            const targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, $bacfb5046880f5ad$export$b3890eb0ae9dca99)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.interpolate);
            this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED;
        }
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADING;
            this.changed();
            let leftToLoad = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach(({ tile: tile })=>{
                const state = tile.getState();
                if (state == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE || state == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADING) {
                    leftToLoad++;
                    const sourceListenKey = (0, $7d7dee7854c96264$export$63174c828edd6ff8)(tile, (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, (e)=>{
                        const state = tile.getState();
                        if (state == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED || state == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR || state == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY) {
                            (0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(sourceListenKey);
                            leftToLoad--;
                            if (leftToLoad === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    });
                    this.sourcesListenerKeys_.push(sourceListenKey);
                }
            });
            if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
            else this.sourceTiles_.forEach(function({ tile: tile }, i, arr) {
                const state = tile.getState();
                if (state == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE) tile.load();
            });
        }
    }
    /**
   * @private
   */ unlistenSources_() {
        this.sourcesListenerKeys_.forEach((0, $7d7dee7854c96264$export$b0a21c8b3c1c921));
        this.sourcesListenerKeys_ = null;
    }
    /**
   * Remove from the cache due to expiry
   * @override
   */ release() {
        if (this.canvas_) {
            (0, $32c8adb5331a7848$export$e918ac6a1026a12a)(this.canvas_.getContext('2d'));
            (0, $bacfb5046880f5ad$export$a166f0857c555517).push(this.canvas_);
            this.canvas_ = null;
        }
        super.release();
    }
}
var $99cafc0f9d5ff6b5$export$2e2bcd8739ae039 = $99cafc0f9d5ff6b5$var$ReprojTile;



/**
 * @module ol/structs/LRUCache
 */ 

/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Entry|null} newer Newer.
 * @property {Entry|null} older Older.
 * @property {*} value_ Value.
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ class $023793903ee4c283$var$LRUCache {
    /**
   * @param {number} [highWaterMark] High water mark.
   */ constructor(highWaterMark){
        /**
     * Desired max cache size after expireCache(). If set to 0, no cache entries
     * will be pruned at all.
     * @type {number}
     */ this.highWaterMark = highWaterMark !== undefined ? highWaterMark : 2048;
        /**
     * @private
     * @type {number}
     */ this.count_ = 0;
        /**
     * @private
     * @type {!Object<string, Entry>}
     */ this.entries_ = {};
        /**
     * @private
     * @type {?Entry}
     */ this.oldest_ = null;
        /**
     * @private
     * @type {?Entry}
     */ this.newest_ = null;
    }
    deleteOldest() {
        const entry = this.pop();
        if (entry instanceof (0, $07a23b3d5e0afc2c$export$2e2bcd8739ae039)) entry.dispose();
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    }
    /**
   * Expire the cache. When the cache entry is a {@link module:ol/Disposable~Disposable},
   * the entry will be disposed.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */ expireCache(keep) {
        while(this.canExpireCache())this.deleteOldest();
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        while(this.oldest_)this.deleteOldest();
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */ containsKey(key) {
        return this.entries_.hasOwnProperty(key);
    }
    /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */ forEach(f) {
        let entry = this.oldest_;
        while(entry){
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    }
    /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */ get(key, options) {
        const entry = this.entries_[key];
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) return entry.value_;
        if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    }
    /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */ remove(key) {
        const entry = this.entries_[key];
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.count_;
    }
    /**
   * @return {Array<string>} Keys.
   */ getKeys() {
        const keys = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    }
    /**
   * @return {Array<T>} Values.
   */ getValues() {
        const values = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    }
    /**
   * @return {T} Last value.
   */ peekLast() {
        return this.oldest_.value_;
    }
    /**
   * @return {string} Last key.
   */ peekLastKey() {
        return this.oldest_.key_;
    }
    /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */ peekFirstKey() {
        return this.newest_.key_;
    }
    /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T|undefined} Value.
   */ peek(key) {
        return this.entries_[key]?.value_;
    }
    /**
   * @return {T} value Value.
   */ pop() {
        const entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ replace(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ set(key, value) {
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(!(key in this.entries_), 'Tried to set a value for a key that is used already');
        const entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    }
    /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */ setSize(size) {
        this.highWaterMark = size;
    }
}
var $023793903ee4c283$export$2e2bcd8739ae039 = $023793903ee4c283$var$LRUCache;


/**
 * @module ol/tilecoord
 */ /**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z` (zoom level), `x` (column), and `y` (row).
 * @typedef {Array<number>} TileCoord
 * @api
 */ /**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord} [tileCoord] Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */ function $39b331b237eeed77$export$958e3e1a02eac4b6(z, x, y, tileCoord) {
    if (tileCoord !== undefined) {
        tileCoord[0] = z;
        tileCoord[1] = x;
        tileCoord[2] = y;
        return tileCoord;
    }
    return [
        z,
        x,
        y
    ];
}
function $39b331b237eeed77$export$92d0df0f1d25c63c(z, x, y) {
    return z + '/' + x + '/' + y;
}
function $39b331b237eeed77$export$a47fb462a08de82f(tileCoord) {
    return $39b331b237eeed77$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $39b331b237eeed77$export$7f760414a8e3d2b5(tileKey) {
    const [z, x, y] = tileKey.substring(tileKey.lastIndexOf('/') + 1, tileKey.length).split(',').map(Number);
    return $39b331b237eeed77$export$92d0df0f1d25c63c(z, x, y);
}
function $39b331b237eeed77$export$a807b7874eb66454(key) {
    return key.split('/').map(Number);
}
function $39b331b237eeed77$export$d6af199866bfb566(tileCoord) {
    return $39b331b237eeed77$export$731f79419750ccf7(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $39b331b237eeed77$export$731f79419750ccf7(z, x, y) {
    return (x << z) + y;
}
function $39b331b237eeed77$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    const z = tileCoord[0];
    const x = tileCoord[1];
    const y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    const tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    return tileRange.containsXY(x, y);
}




/**
 * @module ol/renderer/canvas/Layer
 */ 





/**
 * @module ol/render/canvas/ZIndexContext
 */ 
/** @typedef {CanvasRenderingContext2D & {globalAlpha: any}} ZIndexContextProxy */ /**
 * @extends {CanvasRenderingContext2D}
 */ class $5ae37123888c860e$var$ZIndexContext {
    constructor(){
        /**
     * @private
     * @type {Array<Array<*>>}
     */ this.instructions_ = [];
        /**
     * @type {number}
     */ this.zIndex = 0;
        /**
     * @private
     * @type {number}
     */ this.offset_ = 0;
        /**
     * @private
     * @type {ZIndexContextProxy}
     */ this.context_ = /** @type {ZIndexContextProxy} */ new Proxy((0, $32c8adb5331a7848$export$fcb72ce088a6632c)(), {
            get: (target, property)=>{
                if (typeof /** @type {*} */ (0, $32c8adb5331a7848$export$fcb72ce088a6632c)()[property] !== 'function') // we only accept calling functions on the proxy, not accessing properties
                return undefined;
                this.push_(property);
                return this.pushMethodArgs_;
            },
            set: (target, property, value)=>{
                this.push_(property, value);
                return true;
            }
        });
    }
    /**
   * @param {...*} args Arguments to push to the instructions array.
   * @private
   */ push_(...args) {
        const instructions = this.instructions_;
        const index = this.zIndex + this.offset_;
        if (!instructions[index]) instructions[index] = [];
        instructions[index].push(...args);
    }
    /**
   * @private
   * @param {...*} args Args.
   * @return {ZIndexContext} This.
   */ pushMethodArgs_ = (...args)=>{
        this.push_(args);
        return this;
    };
    /**
   * Push a function that renders to the context directly.
   * @param {function(CanvasRenderingContext2D): void} render Function.
   */ pushFunction(render) {
        this.push_(render);
    }
    /**
   * Get a proxy for CanvasRenderingContext2D which does not support getting state
   * (e.g. `context.globalAlpha`, which will return `undefined`). To set state, if it relies on a
   * previous state (e.g. `context.globalAlpha = context.globalAlpha / 2`), set a function,
   * e.g. `context.globalAlpha = (context) => context.globalAlpha / 2`.
   * @return {ZIndexContextProxy} Context.
   */ getContext() {
        return this.context_;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   */ draw(context) {
        this.instructions_.forEach((instructionsAtIndex)=>{
            for(let i = 0, ii = instructionsAtIndex.length; i < ii; ++i){
                const property = instructionsAtIndex[i];
                if (typeof property === 'function') {
                    property(context);
                    continue;
                }
                const instructionAtIndex = instructionsAtIndex[++i];
                if (typeof /** @type {*} */ context[property] === 'function') /** @type {*} */ context[property](...instructionAtIndex);
                else {
                    if (typeof instructionAtIndex === 'function') {
                        /** @type {*} */ context[property] = instructionAtIndex(context);
                        continue;
                    }
                    /** @type {*} */ context[property] = instructionAtIndex;
                }
            }
        });
    }
    clear() {
        this.instructions_.length = 0;
        this.zIndex = 0;
        this.offset_ = 0;
    }
    /**
   * Offsets the zIndex by the highest current zIndex. Useful for rendering multiple worlds or tiles, to
   * avoid conflicting context.clip() or context.save()/restore() calls.
   */ offset() {
        this.offset_ = this.instructions_.length;
        this.zIndex = 0;
    }
}
var $5ae37123888c860e$export$2e2bcd8739ae039 = $5ae37123888c860e$var$ZIndexContext;



/**
 * @module ol/renderer/Layer
 */ 



const $3958de819b49c310$var$maxStaleKeys = 5;
/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ class $3958de819b49c310$var$LayerRenderer extends (0, $bf9d9249f08e327f$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super();
        /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */ this.ready = true;
        /** @private */ this.boundHandleImageChange_ = this.handleImageChange_.bind(this);
        /**
     * @private
     * @type {LayerType}
     */ this.layer_ = layer;
        /**
     * @type {Array<string>}
     * @private
     */ this.staleKeys_ = new Array();
        /**
     * @type {number}
     * @protected
     */ this.maxStaleKeys = $3958de819b49c310$var$maxStaleKeys;
    }
    /**
   * @return {Array<string>} Get the list of stale keys.
   */ getStaleKeys() {
        return this.staleKeys_;
    }
    /**
   * @param {string} key The new stale key.
   */ prependStaleKey(key) {
        this.staleKeys_.unshift(key);
        if (this.staleKeys_.length > this.maxStaleKeys) this.staleKeys_.length = this.maxStaleKeys;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        return null;
    }
    /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   */ renderFrame(frameState, target) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    }
    /**
   * @return {LayerType} Layer.
   */ getLayer() {
        return this.layer_;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */ handleFontsChanged() {}
    /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */ handleImageChange_(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED || image.getState() === (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).ERROR) this.renderIfReadyAndVisible();
    }
    /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */ loadImage(image) {
        let imageState = image.getState();
        if (imageState != (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED && imageState != (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).ERROR) image.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, this.boundHandleImageChange_);
        if (imageState == (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED;
    }
    /**
   * @protected
   */ renderIfReadyAndVisible() {
        const layer = this.getLayer();
        if (layer && layer.getVisible() && layer.getSourceState() === 'ready') layer.changed();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ renderDeferred(frameState) {}
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.layer_;
        super.disposeInternal();
    }
}
var $3958de819b49c310$export$2e2bcd8739ae039 = $3958de819b49c310$var$LayerRenderer;


const $dc24fa3944657194$export$a166f0857c555517 = [];
/**
 * @type {CanvasRenderingContext2D}
 */ let $dc24fa3944657194$var$pixelContext = null;
function $dc24fa3944657194$var$createPixelContext() {
    $dc24fa3944657194$var$pixelContext = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(1, 1, undefined, {
        willReadFrequently: true
    });
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */ class $dc24fa3944657194$var$CanvasLayerRenderer extends (0, $3958de819b49c310$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super(layer);
        /**
     * @protected
     * @type {HTMLElement}
     */ this.container = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedResolution;
        /**
     * A temporary transform.  The values in this transform should only be used in a
     * function that sets the values.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.tempTransform = (0, $a684e03243281d90$export$185802fd694ee1f5)();
        /**
     * The transform for rendered pixels to viewport CSS pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.pixelTransform = (0, $a684e03243281d90$export$185802fd694ee1f5)();
        /**
     * The transform for viewport CSS pixels to rendered pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.inversePixelTransform = (0, $a684e03243281d90$export$185802fd694ee1f5)();
        /**
     * @type {CanvasRenderingContext2D}
     */ this.context = null;
        /**
     * @private
     * @type {ZIndexContext}
     */ this.deferredContext_ = null;
        /**
     * @type {boolean}
     */ this.containerReused = false;
        /**
     * @protected
     * @type {import("../../Map.js").FrameState|null}
     */ this.frameState = null;
    }
    /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */ getImageData(image, col, row) {
        if (!$dc24fa3944657194$var$pixelContext) $dc24fa3944657194$var$createPixelContext();
        $dc24fa3944657194$var$pixelContext.clearRect(0, 0, 1, 1);
        let data;
        try {
            $dc24fa3944657194$var$pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
            data = $dc24fa3944657194$var$pixelContext.getImageData(0, 0, 1, 1).data;
        } catch  {
            $dc24fa3944657194$var$pixelContext = null;
            return null;
        }
        return data;
    }
    /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */ getBackground(frameState) {
        const layer = this.getLayer();
        let background = layer.getBackground();
        if (typeof background === 'function') background = background(frameState.viewState.resolution);
        return background || undefined;
    }
    /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS transform matrix.
   * @param {string} [backgroundColor] Background color.
   */ useContainer(target, transform, backgroundColor) {
        const layerClassName = this.getLayer().getClassName();
        let container, context;
        if (target && target.className === layerClassName && (!backgroundColor || target && target.style.backgroundColor && (0, $9d07dd9052c3de0c$export$e9bab7fafb253603)((0, $4693a670e5985dc9$export$75093a47a9fa838d)(target.style.backgroundColor), (0, $4693a670e5985dc9$export$75093a47a9fa838d)(backgroundColor)))) {
            const canvas = target.firstElementChild;
            if (canvas instanceof HTMLCanvasElement) context = canvas.getContext('2d');
        }
        if (context && (0, $a684e03243281d90$export$fe091d73a555748b)(context.canvas.style.transform, transform)) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        } else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        } else if (this.container) this.container.style.backgroundColor = null;
        if (!this.container) {
            container = document.createElement('div');
            container.className = layerClassName;
            let style = container.style;
            style.position = 'absolute';
            style.width = '100%';
            style.height = '100%';
            context = (0, $32c8adb5331a7848$export$9e05d10eae75c464)();
            const canvas = context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = 'absolute';
            style.left = '0';
            style.transformOrigin = 'top left';
            this.container = container;
            this.context = context;
        }
        if (!this.containerReused && backgroundColor && !this.container.style.backgroundColor) this.container.style.backgroundColor = backgroundColor;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */ clipUnrotated(context, frameState, extent) {
        const topLeft = (0, $110ceb23457e07e7$export$cb1538b07e6964ff)(extent);
        const topRight = (0, $110ceb23457e07e7$export$b84fa077c8b05295)(extent);
        const bottomRight = (0, $110ceb23457e07e7$export$e77c1cf70445e168)(extent);
        const bottomLeft = (0, $110ceb23457e07e7$export$8d09f5e2e1bf560d)(extent);
        (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topLeft);
        (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topRight);
        (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomLeft);
        const inverted = this.inversePixelTransform;
        (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(inverted, topLeft);
        (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(inverted, topRight);
        (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(inverted, bottomRight);
        (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @protected
   */ prepareContainer(frameState, target) {
        const extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const pixelRatio = frameState.pixelRatio;
        const width = Math.round((0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $110ceb23457e07e7$export$c08559766941f856)(extent) / resolution * pixelRatio);
        // set forward and inverse pixel transforms
        (0, $a684e03243281d90$export$f672e0b6f7222cd7)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
        (0, $a684e03243281d90$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
        const canvasTransform = (0, $a684e03243281d90$export$f84e8e69fd4488a5)(this.pixelTransform);
        this.useContainer(target, canvasTransform, this.getBackground(frameState));
        if (!this.containerReused) {
            const canvas = this.context.canvas;
            if (canvas.width != width || canvas.height != height) {
                canvas.width = width;
                canvas.height = height;
            } else this.context.clearRect(0, 0, width, height);
            if (canvasTransform !== canvas.style.transform) canvas.style.transform = canvasTransform;
        }
    }
    /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */ dispatchRenderEvent_(type, context, frameState) {
        const layer = this.getLayer();
        if (layer.hasListener(type)) {
            const event = new (0, $96765f144db3e978$export$2e2bcd8739ae039)(type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event);
        }
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ preRender(context, frameState) {
        this.frameState = frameState;
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $b899a48a5b03178b$export$2e2bcd8739ae039).PRERENDER, context, frameState);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ postRender(context, frameState) {
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $b899a48a5b03178b$export$2e2bcd8739ae039).POSTRENDER, context, frameState);
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeferredInternal(frameState) {}
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import('../../render/canvas/ZIndexContext.js').ZIndexContextProxy} Context.
   */ getRenderContext(frameState) {
        if (frameState.declutter && !this.deferredContext_) this.deferredContext_ = new (0, $5ae37123888c860e$export$2e2bcd8739ae039)();
        return frameState.declutter ? this.deferredContext_.getContext() : this.context;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferred(frameState) {
        if (!frameState.declutter) return;
        this.dispatchRenderEvent_((0, $b899a48a5b03178b$export$2e2bcd8739ae039).PRERENDER, this.context, frameState);
        if (frameState.declutter && this.deferredContext_) {
            this.deferredContext_.draw(this.context);
            this.deferredContext_.clear();
        }
        this.renderDeferredInternal(frameState);
        this.dispatchRenderEvent_((0, $b899a48a5b03178b$export$2e2bcd8739ae039).POSTRENDER, this.context, frameState);
    }
    /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ getRenderTransform(center, resolution, rotation, pixelRatio, width, height, offsetX) {
        const dx1 = width / 2;
        const dy1 = height / 2;
        const sx = pixelRatio / resolution;
        const sy = -sx;
        const dx2 = -center[0] + offsetX;
        const dy2 = -center[1];
        return (0, $a684e03243281d90$export$f672e0b6f7222cd7)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.frameState;
        super.disposeInternal();
    }
}
var $dc24fa3944657194$export$2e2bcd8739ae039 = $dc24fa3944657194$var$CanvasLayerRenderer;


/**
 * @param {string} sourceKey The source key.
 * @param {number} z The tile z level.
 * @param {number} x The tile x level.
 * @param {number} y The tile y level.
 * @return {string} The cache key.
 */ function $2d0ed4848f0a5327$var$getCacheKey(sourceKey, z, x, y) {
    return `${sourceKey},${(0, $39b331b237eeed77$export$92d0df0f1d25c63c)(z, x, y)}`;
}
/**
 * @typedef {Object<number, Set<import("../../Tile.js").default>>} TileLookup
 */ /**
 * Add a tile to the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was added to the lookup.
 */ function $2d0ed4848f0a5327$var$addTileToLookup(tilesByZ, tile, z) {
    if (!(z in tilesByZ)) {
        tilesByZ[z] = new Set([
            tile
        ]);
        return true;
    }
    const set = tilesByZ[z];
    const existing = set.has(tile);
    if (!existing) set.add(tile);
    return !existing;
}
/**
 * Remove a tile from the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was removed from the lookup.
 */ function $2d0ed4848f0a5327$var$removeTileFromLookup(tilesByZ, tile, z) {
    const set = tilesByZ[z];
    if (set) return set.delete(tile);
    return false;
}
/**
 * @param {import("../../Map.js").FrameState} frameState Frame state.
 * @param {import("../../extent.js").Extent} extent The frame extent.
 * @return {import("../../extent.js").Extent} Frame extent intersected with layer extents.
 */ function $2d0ed4848f0a5327$var$getRenderExtent(frameState, extent) {
    const layerState = frameState.layerStatesArray[frameState.layerIndex];
    if (layerState.extent) extent = (0, $110ceb23457e07e7$export$72209efa88586d42)(extent, (0, $d447c151baf41c8c$export$494be3a3a25689ca)(layerState.extent, frameState.viewState.projection));
    const source = /** @type {import("../../source/Tile.js").default} */ layerState.layer.getRenderSource();
    if (!source.getWrapX()) {
        const gridExtent = source.getTileGridForProjection(frameState.viewState.projection).getExtent();
        if (gridExtent) extent = (0, $110ceb23457e07e7$export$72209efa88586d42)(extent, gridExtent);
    }
    return extent;
}
/**
 * @typedef {Object} Options
 * @property {number} [cacheSize=512] The cache size.
 */ /**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */ class $2d0ed4848f0a5327$var$CanvasTileLayerRenderer extends (0, $dc24fa3944657194$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} tileLayer Tile layer.
   * @param {Options} [options] Options.
   */ constructor(tileLayer, options){
        super(tileLayer);
        options = options || {};
        /**
     * Rendered extent has changed since the previous `renderFrame()` call
     * @type {boolean}
     */ this.extentChanged = true;
        /**
     * The last call to `renderFrame` was completed with all tiles loaded
     * @type {boolean}
     */ this.renderComplete = false;
        /**
     * @private
     * @type {?import("../../extent.js").Extent}
     */ this.renderedExtent_ = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedPixelRatio;
        /**
     * @protected
     * @type {import("../../proj/Projection.js").default|null}
     */ this.renderedProjection = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_;
        /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */ this.renderedTiles = [];
        /**
     * @private
     * @type {string}
     */ this.renderedSourceKey_;
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_;
        /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */ this.tempExtent = (0, $110ceb23457e07e7$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../TileRange.js").default}
     */ this.tempTileRange_ = new (0, $99c318de9bdac32c$export$2e2bcd8739ae039)(0, 0, 0, 0);
        /**
     * @type {import("../../tilecoord.js").TileCoord}
     * @private
     */ this.tempTileCoord_ = (0, $39b331b237eeed77$export$958e3e1a02eac4b6)(0, 0, 0);
        const cacheSize = options.cacheSize !== undefined ? options.cacheSize : 512;
        /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default>}
     * @private
     */ this.tileCache_ = new (0, $023793903ee4c283$export$2e2bcd8739ae039)(cacheSize);
        this.maxStaleKeys = cacheSize * 0.5;
    }
    /**
   * @return {LRUCache} Tile cache.
   */ getTileCache() {
        return this.tileCache_;
    }
    /**
   * Get a tile from the cache or create one if needed.
   *
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getOrCreateTile(z, x, y, frameState) {
        const tileCache = this.tileCache_;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const cacheKey = $2d0ed4848f0a5327$var$getCacheKey(tileSource.getKey(), z, x, y);
        /** @type {import("../../Tile.js").default} */ let tile;
        if (tileCache.containsKey(cacheKey)) tile = tileCache.get(cacheKey);
        else {
            tile = tileSource.getTile(z, x, y, frameState.pixelRatio, frameState.viewState.projection);
            if (!tile) return null;
            tileCache.set(cacheKey, tile);
        }
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getTile(z, x, y, frameState) {
        const tile = this.getOrCreateTile(z, x, y, frameState);
        if (!tile) return null;
        return tile;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $110ceb23457e07e7$export$ac68c24d37ca240f)(layerExtent, coordinate)) return null;
        }
        const viewState = frameState.viewState;
        const source = layer.getRenderSource();
        const tileGrid = source.getTileGridForProjection(viewState.projection);
        const tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);
        for(let z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z){
            const tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
            const tile = this.getTile(z, tileCoord[1], tileCoord[2], frameState);
            if (!tile || tile.getState() !== (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED) continue;
            const tileOrigin = tileGrid.getOrigin(z);
            const tileSize = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z));
            const tileResolution = tileGrid.getResolution(z);
            /**
       * @type {import('../../DataTile.js').ImageLike}
       */ let image;
            if (tile instanceof (0, $ae0d8a38ddc9cf8f$export$2e2bcd8739ae039) || tile instanceof (0, $99cafc0f9d5ff6b5$export$2e2bcd8739ae039)) image = tile.getImage();
            else if (tile instanceof (0, $92d24567a9854da1$export$2e2bcd8739ae039)) {
                image = (0, $92d24567a9854da1$export$3a7c913cb40dcb7d)(tile.getData());
                if (!image) continue;
            } else continue;
            const col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
            const row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
            const gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
            return this.getImageData(image, col + gutter, row + gutter);
        }
        return null;
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        if (!this.renderedProjection) this.renderedProjection = frameState.viewState.projection;
        else if (frameState.viewState.projection !== this.renderedProjection) {
            this.tileCache_.clear();
            this.renderedProjection = frameState.viewState.projection;
        }
        const source = this.getLayer().getSource();
        if (!source) return false;
        const sourceRevision = source.getRevision();
        if (!this.renderedRevision_) this.renderedRevision_ = sourceRevision;
        else if (this.renderedRevision_ !== sourceRevision) {
            this.renderedRevision_ = sourceRevision;
            if (this.renderedSourceKey_ === source.getKey()) this.tileCache_.clear();
        }
        return true;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent The extent to be rendered.
   * @param {number} initialZ The zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @param {number} preload Number of additional levels to load.
   */ enqueueTiles(frameState, extent, initialZ, tilesByZ, preload) {
        const viewState = frameState.viewState;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getRenderSource();
        const tileGrid = tileSource.getTileGridForProjection(viewState.projection);
        const tileSourceKey = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        const wantedTiles = frameState.wantedTiles[tileSourceKey];
        const map = tileLayer.getMapInternal();
        const minZ = Math.max(initialZ - preload, tileGrid.getMinZoom(), tileGrid.getZForResolution(Math.min(tileLayer.getMaxResolution(), map ? map.getView().getResolutionForZoom(Math.max(tileLayer.getMinZoom(), 0)) : tileGrid.getResolution(0)), tileSource.zDirection));
        const rotation = viewState.rotation;
        const viewport = rotation ? (0, $110ceb23457e07e7$export$4b7a6fb4002cd6ac)(viewState.center, viewState.resolution, rotation, frameState.size) : undefined;
        for(let z = initialZ; z >= minZ; --z){
            const tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, this.tempTileRange_);
            const tileResolution = tileGrid.getResolution(z);
            for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
                if (rotation && !tileGrid.tileCoordIntersectsViewport([
                    z,
                    x,
                    y
                ], viewport)) continue;
                const tile = this.getTile(z, x, y, frameState);
                if (!tile) continue;
                const added = $2d0ed4848f0a5327$var$addTileToLookup(tilesByZ, tile, z);
                if (!added) continue;
                const tileQueueKey = tile.getKey();
                wantedTiles[tileQueueKey] = true;
                if (tile.getState() === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE) {
                    if (!frameState.tileQueue.isKeyQueued(tileQueueKey)) {
                        const tileCoord = (0, $39b331b237eeed77$export$958e3e1a02eac4b6)(z, x, y, this.tempTileCoord_);
                        frameState.tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tileCoord),
                            tileResolution
                        ]);
                    }
                }
            }
        }
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findStaleTile_(tileCoord, tilesByZ) {
        const tileCache = this.tileCache_;
        const z = tileCoord[0];
        const x = tileCoord[1];
        const y = tileCoord[2];
        const staleKeys = this.getStaleKeys();
        for(let i = 0; i < staleKeys.length; ++i){
            const cacheKey = $2d0ed4848f0a5327$var$getCacheKey(staleKeys[i], z, x, y);
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED) {
                    tile.endTransition((0, $9f65e6f92d33bc27$export$5e82334337e0f204)(this));
                    $2d0ed4848f0a5327$var$addTileToLookup(tilesByZ, tile, z);
                    return true;
                }
            }
        }
        return false;
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid The tile grid.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {number} altZ The alternate zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findAltTiles_(tileGrid, tileCoord, altZ, tilesByZ) {
        const tileRange = tileGrid.getTileRangeForTileCoordAndZ(tileCoord, altZ, this.tempTileRange_);
        if (!tileRange) return false;
        let covered = true;
        const tileCache = this.tileCache_;
        const source = this.getLayer().getRenderSource();
        const sourceKey = source.getKey();
        for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
            const cacheKey = $2d0ed4848f0a5327$var$getCacheKey(sourceKey, altZ, x, y);
            let loaded = false;
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED) {
                    $2d0ed4848f0a5327$var$addTileToLookup(tilesByZ, tile, altZ);
                    loaded = true;
                }
            }
            if (!loaded) covered = false;
        }
        return covered;
    }
    /**
   * Render the layer.
   *
   * The frame rendering logic has three parts:
   *
   *  1. Enqueue tiles
   *  2. Find alt tiles for those that are not yet loaded
   *  3. Render loaded tiles
   *
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        this.renderComplete = true;
        /**
     * TODO:
     *  maybe skip transition when not fully opaque
     *  decide if this.renderComplete is useful
     */ const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const viewResolution = viewState.resolution;
        const viewCenter = viewState.center;
        const pixelRatio = frameState.pixelRatio;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const tileGrid = tileSource.getTileGridForProjection(projection);
        const z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        const sourceKey = tileSource.getKey();
        if (!this.renderedSourceKey_) this.renderedSourceKey_ = sourceKey;
        else if (this.renderedSourceKey_ !== sourceKey) {
            this.prependStaleKey(this.renderedSourceKey_);
            this.renderedSourceKey_ = sourceKey;
        }
        let frameExtent = frameState.extent;
        const tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const layerExtent = layerState.extent && (0, $d447c151baf41c8c$export$494be3a3a25689ca)(layerState.extent, projection);
        if (layerExtent) frameExtent = (0, $110ceb23457e07e7$export$72209efa88586d42)(frameExtent, (0, $d447c151baf41c8c$export$494be3a3a25689ca)(layerState.extent, projection));
        const dx = tileResolution * width / 2 / tilePixelRatio;
        const dy = tileResolution * height / 2 / tilePixelRatio;
        const canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy
        ];
        /**
     * @type {TileLookup}
     */ const tilesByZ = {};
        this.renderedTiles.length = 0;
        /**
     * Part 1: Enqueue tiles
     */ const preload = tileLayer.getPreload();
        if (frameState.nextExtent) {
            const targetZ = tileGrid.getZForResolution(viewState.nextResolution, tileSource.zDirection);
            const nextExtent = $2d0ed4848f0a5327$var$getRenderExtent(frameState, frameState.nextExtent);
            this.enqueueTiles(frameState, nextExtent, targetZ, tilesByZ, preload);
        }
        const renderExtent = $2d0ed4848f0a5327$var$getRenderExtent(frameState, frameExtent);
        this.enqueueTiles(frameState, renderExtent, z, tilesByZ, 0);
        if (preload > 0) setTimeout(()=>{
            this.enqueueTiles(frameState, renderExtent, z - 1, tilesByZ, preload - 1);
        }, 0);
        if (!(z in tilesByZ)) return this.container;
        /**
     * Part 2: Find alt tiles for those that are not yet loaded
     */ const uid = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(this);
        const time = frameState.time;
        // look for cached tiles to use if a target tile is not ready
        for (const tile of tilesByZ[z]){
            const tileState = tile.getState();
            if (tileState === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY) continue;
            const tileCoord = tile.tileCoord;
            if (tileState === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED) {
                const alpha = tile.getAlpha(uid, time);
                if (alpha === 1) {
                    // no need to look for alt tiles
                    tile.endTransition(uid);
                    continue;
                }
            }
            if (tileState !== (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR) this.renderComplete = false;
            const hasStaleTile = this.findStaleTile_(tileCoord, tilesByZ);
            if (hasStaleTile) {
                // use the stale tile before the new tile's transition has completed
                $2d0ed4848f0a5327$var$removeTileFromLookup(tilesByZ, tile, z);
                frameState.animate = true;
                continue;
            }
            // first look for child tiles (at z + 1)
            const coveredByChildren = this.findAltTiles_(tileGrid, tileCoord, z + 1, tilesByZ);
            if (coveredByChildren) continue;
            // next look for parent tiles
            const minZoom = tileGrid.getMinZoom();
            for(let parentZ = z - 1; parentZ >= minZoom; --parentZ){
                const coveredByParent = this.findAltTiles_(tileGrid, tileCoord, parentZ, tilesByZ);
                if (coveredByParent) break;
            }
        }
        /**
     * Part 3: Render loaded tiles
     */ const canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
        const context = this.getRenderContext(frameState);
        // set scale transform for calculating tile positions on the canvas
        (0, $a684e03243281d90$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (layerState.extent) this.clipUnrotated(context, frameState, layerExtent);
        if (!tileSource.getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        /** @type {Array<number>} */ const zs = Object.keys(tilesByZ).map(Number);
        zs.sort((0, $9d07dd9052c3de0c$export$fcb633242ef15540));
        let currentClip;
        const clips = [];
        const clipZs = [];
        for(let i = zs.length - 1; i >= 0; --i){
            const currentZ = zs[i];
            const currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            const currentResolution = tileGrid.getResolution(currentZ);
            const currentScale = currentResolution / tileResolution;
            const dx = currentTilePixelSize[0] * currentScale * canvasScale;
            const dy = currentTilePixelSize[1] * currentScale * canvasScale;
            const originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, $110ceb23457e07e7$export$cb1538b07e6964ff)(canvasExtent), currentZ);
            const originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            const origin = (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(this.tempTransform, [
                tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
            ]);
            const tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            for (const tile of tilesByZ[currentZ]){
                if (tile.getState() !== (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED) continue;
                const tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                const xIndex = originTileCoord[1] - tileCoord[1];
                const nextX = Math.round(origin[0] - (xIndex - 1) * dx);
                const yIndex = originTileCoord[2] - tileCoord[2];
                const nextY = Math.round(origin[1] - (yIndex - 1) * dy);
                const x = Math.round(origin[0] - xIndex * dx);
                const y = Math.round(origin[1] - yIndex * dy);
                const w = nextX - x;
                const h = nextY - y;
                const transition = zs.length === 1;
                let contextSaved = false;
                // Clip mask for regions in this tile that already filled by a higher z tile
                currentClip = [
                    x,
                    y,
                    x + w,
                    y,
                    x + w,
                    y + h,
                    x,
                    y + h
                ];
                for(let i = 0, ii = clips.length; i < ii; ++i)if (!transition && currentZ < clipZs[i]) {
                    const clip = clips[i];
                    if ((0, $110ceb23457e07e7$export$7b0a31e10bbff018)([
                        x,
                        y,
                        x + w,
                        y + h
                    ], [
                        clip[0],
                        clip[3],
                        clip[4],
                        clip[7]
                    ])) {
                        if (!contextSaved) {
                            context.save();
                            contextSaved = true;
                        }
                        context.beginPath();
                        // counter-clockwise (outer ring) for current tile
                        context.moveTo(currentClip[0], currentClip[1]);
                        context.lineTo(currentClip[2], currentClip[3]);
                        context.lineTo(currentClip[4], currentClip[5]);
                        context.lineTo(currentClip[6], currentClip[7]);
                        // clockwise (inner ring) for higher z tile
                        context.moveTo(clip[6], clip[7]);
                        context.lineTo(clip[4], clip[5]);
                        context.lineTo(clip[2], clip[3]);
                        context.lineTo(clip[0], clip[1]);
                        context.clip();
                    }
                }
                clips.push(currentClip);
                clipZs.push(currentZ);
                this.drawTile(tile, frameState, x, y, w, h, tileGutter, transition);
                if (contextSaved) context.restore();
                this.renderedTiles.unshift(tile);
                // TODO: decide if this is necessary
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        this.renderedResolution = tileResolution;
        this.extentChanged = !this.renderedExtent_ || !(0, $110ceb23457e07e7$export$e9bab7fafb253603)(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.postRender(this.context, frameState);
        if (layerState.extent) context.restore();
        context.imageSmoothingEnabled = true;
        if (this.renderComplete) {
            /**
       * @param {import("../../Map.js").default} map Map.
       * @param {import("../../Map.js").FrameState} frameState Frame state.
       */ const postRenderFunction = (map, frameState)=>{
                const tileSourceKey = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(tileSource);
                const wantedTiles = frameState.wantedTiles[tileSourceKey];
                const tilesCount = wantedTiles ? Object.keys(wantedTiles).length : 0;
                this.updateCacheSize(tilesCount);
                this.tileCache_.expireCache();
            };
            frameState.postRenderFunctions.push(postRenderFunction);
        }
        return this.container;
    }
    /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   */ updateCacheSize(tileCount) {
        this.tileCache_.highWaterMark = Math.max(this.tileCache_.highWaterMark, tileCount * 2);
    }
    /**
   * @param {import("../../Tile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   * @protected
   */ drawTile(tile, frameState, x, y, w, h, gutter, transition) {
        let image;
        if (tile instanceof (0, $92d24567a9854da1$export$2e2bcd8739ae039)) {
            image = (0, $92d24567a9854da1$export$3a7c913cb40dcb7d)(tile.getData());
            if (!image) throw new Error('Rendering array data is not yet supported');
        } else image = this.getTileImage(/** @type {import("../../ImageTile.js").default} */ tile);
        if (!image) return;
        const context = this.getRenderContext(frameState);
        const uid = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(this);
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
        const alphaChanged = alpha !== context.globalAlpha;
        if (alphaChanged) {
            context.save();
            context.globalAlpha = alpha;
        }
        context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) context.restore();
        if (alpha !== layerState.opacity) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    }
    /**
   * @return {HTMLCanvasElement} Image
   */ getImage() {
        const context = this.context;
        return context ? context.canvas : null;
    }
    /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */ getTileImage(tile) {
        return tile.getImage();
    }
    /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */ updateUsedTiles(usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        const tileSourceKey = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
        usedTiles[tileSourceKey][tile.getKey()] = true;
    }
}
var $2d0ed4848f0a5327$export$2e2bcd8739ae039 = $2d0ed4848f0a5327$var$CanvasTileLayerRenderer;


/**
 * @module ol/layer/BaseTile
 */ 
/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $fff454ff0e19acd9$export$2e2bcd8739ae039 = {
    PRELOAD: 'preload',
    USE_INTERIM_TILES_ON_ERROR: 'useInterimTilesOnError'
};


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *   import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */ /**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [useInterimTilesOnError=true] Deprecated.  Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 * @property {number} [cacheSize=512] The internal tile cache size.  This needs to be large enough to render
 * two zoom levels worth of tiles.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<TileSourceType, RendererType>}
 * @api
 */ class $a4de8d1d696af8bb$var$BaseTileLayer extends (0, $3a63648a58cbd426$export$2e2bcd8739ae039) {
    /**
   * @param {Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        const cacheSize = options.cacheSize;
        delete options.cacheSize;
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        super(baseOptions);
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseTileLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {number|undefined}
     * @private
     */ this.cacheSize_ = cacheSize;
        this.setPreload(options.preload !== undefined ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
    }
    /**
   * @return {number|undefined} The suggested cache size
   * @protected
   */ getCacheSize() {
        return this.cacheSize_;
    }
    /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ getPreload() {
        return /** @type {number} */ this.get((0, $fff454ff0e19acd9$export$2e2bcd8739ae039).PRELOAD);
    }
    /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ setPreload(preload) {
        this.set((0, $fff454ff0e19acd9$export$2e2bcd8739ae039).PRELOAD, preload);
    }
    /**
   * Deprecated.  Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, $fff454ff0e19acd9$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
    }
    /**
   * Deprecated.  Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, $fff454ff0e19acd9$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    }
    /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $a4de8d1d696af8bb$export$2e2bcd8739ae039 = $a4de8d1d696af8bb$var$BaseTileLayer;


/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} [TileSourceType=import("../source/Tile.js").default]
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */ class $5ffc94e8de19e6f3$var$TileLayer extends (0, $a4de8d1d696af8bb$export$2e2bcd8739ae039) {
    /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $2d0ed4848f0a5327$export$2e2bcd8739ae039)(this, {
            cacheSize: this.getCacheSize()
        });
    }
}
var $5ffc94e8de19e6f3$export$2e2bcd8739ae039 = $5ffc94e8de19e6f3$var$TileLayer;


/**
 * @module ol/source/XYZ
 */ /**
 * @module ol/tilegrid
 */ 


/**
 * @module ol/tilegrid/TileGrid
 */ 








/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ const $9265c7f0d03c6a23$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */ const $9265c7f0d03c6a23$var$DECIMALS = 5;
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile~TileSource} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ class $9265c7f0d03c6a23$var$TileGrid {
    /**
   * @param {Options} options Tile grid options.
   */ constructor(options){
        /**
     * @protected
     * @type {number}
     */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
     * @private
     * @type {!Array<number>}
     */ this.resolutions_ = options.resolutions;
        (0, $4b57691230be0bd5$export$a7a9523472993e97)((0, $9d07dd9052c3de0c$export$efa610630f9e181)(this.resolutions_, /**
         * @param {number} a First resolution
         * @param {number} b Second resolution
         * @return {number} Comparison result
         */ (a, b)=>b - a, true), '`resolutions` must be sorted in descending order');
        // check if we've got a consistent zoom factor and origin
        let zoomFactor;
        if (!options.origins) for(let i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
     * @private
     * @type {number|undefined}
     */ this.zoomFactor_ = zoomFactor;
        /**
     * @protected
     * @type {number}
     */ this.maxZoom = this.resolutions_.length - 1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
     * @private
     * @type {Array<import("../coordinate.js").Coordinate>}
     */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, $4b57691230be0bd5$export$a7a9523472993e97)(this.origins_.length == this.resolutions_.length, 'Number of `origins` and `resolutions` must be equal');
        }
        const extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $110ceb23457e07e7$export$cb1538b07e6964ff)(extent);
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, 'Either `origin` or `origins` must be configured, never both');
        /**
     * @private
     * @type {Array<number|import("../size.js").Size>}
     */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, $4b57691230be0bd5$export$a7a9523472993e97)(this.tileSizes_.length == this.resolutions_.length, 'Number of `tileSizes` and `resolutions` must be equal');
        }
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $70f6cba5b5336314$export$6b8cb5cd370bd90c) : null;
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, 'Either `tileSize` or `tileSizes` must be configured, never both');
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = extent !== undefined ? extent : null;
        /**
     * @private
     * @type {Array<import("../TileRange.js").default>}
     */ this.fullTileRanges_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.tmpSize_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = [
            0,
            0,
            0,
            0
        ];
        if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map((size, z)=>{
            const tileRange = new (0, $99c318de9bdac32c$export$2e2bcd8739ae039)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                const restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        });
        else if (extent) this.calculateTileRanges_(extent);
    }
    /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */ forEachTileCoord(extent, zoom, callback) {
        const tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for(let i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(let j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
            zoom,
            i,
            j
        ]);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */ forEachTileCoordParentTileRange(tileCoord, callback, tempTileRange, tempExtent) {
        let tileRange, x, y;
        let tileCoordExtent = null;
        let z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        } else tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent);
        while(z >= this.minZoom){
            if (x !== undefined && y !== undefined) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = (0, $99c318de9bdac32c$export$958e3e1a02eac4b6)(x, x, y, y, tempTileRange);
            } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
            if (callback(z, tileRange)) return true;
            --z;
        }
        return false;
    }
    /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */ getMaxZoom() {
        return this.maxZoom;
    }
    /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */ getMinZoom() {
        return this.minZoom;
    }
    /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */ getOrigin(z) {
        if (this.origin_) return this.origin_;
        return this.origins_[z];
    }
    /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */ getResolution(z) {
        return this.resolutions_[z];
    }
    /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileCoordChildTileRange(tileCoord, tempTileRange, tempExtent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                const minX = tileCoord[1] * 2;
                const minY = tileCoord[2] * 2;
                return (0, $99c318de9bdac32c$export$958e3e1a02eac4b6)(minX, minX + 1, minY, minY + 1, tempTileRange);
            }
            const tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent || this.tmpExtent_);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, tempTileRange);
        }
        return null;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileRangeForTileCoordAndZ(tileCoord, z, tempTileRange) {
        if (z > this.maxZoom || z < this.minZoom) return null;
        const tileCoordZ = tileCoord[0];
        const tileCoordX = tileCoord[1];
        const tileCoordY = tileCoord[2];
        if (z === tileCoordZ) return (0, $99c318de9bdac32c$export$958e3e1a02eac4b6)(tileCoordX, tileCoordY, tileCoordX, tileCoordY, tempTileRange);
        if (this.zoomFactor_) {
            const factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
            const minX = Math.floor(tileCoordX * factor);
            const minY = Math.floor(tileCoordY * factor);
            if (z < tileCoordZ) return (0, $99c318de9bdac32c$export$958e3e1a02eac4b6)(minX, minX, minY, minY, tempTileRange);
            const maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
            const maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
            return (0, $99c318de9bdac32c$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
        }
        const tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
    }
    /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */ getTileRangeForExtentAndZ(extent, z, tempTileRange) {
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, $9265c7f0d03c6a23$var$tmpTileCoord);
        const minX = $9265c7f0d03c6a23$var$tmpTileCoord[1];
        const minY = $9265c7f0d03c6a23$var$tmpTileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, $9265c7f0d03c6a23$var$tmpTileCoord);
        const maxX = $9265c7f0d03c6a23$var$tmpTileCoord[1];
        const maxY = $9265c7f0d03c6a23$var$tmpTileCoord[2];
        return (0, $99c318de9bdac32c$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */ getTileCoordCenter(tileCoord) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
        ];
    }
    /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getTileCoordExtent(tileCoord, tempExtent) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        const minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        const minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        const maxX = minX + tileSize[0] * resolution;
        const maxY = minY + tileSize[1] * resolution;
        return (0, $110ceb23457e07e7$export$958e3e1a02eac4b6)(minX, minY, maxX, maxY, tempExtent);
    }
    /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndResolution(coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    }
    /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndResolution_(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        const z = this.getZForResolution(resolution);
        const scale = resolution / this.getResolution(z);
        const origin = this.getOrigin(z);
        const tileSize = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = scale * (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = scale * (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $91ceb5420a5c8360$export$803ce6b71a0a94b2)(tileCoordX, $9265c7f0d03c6a23$var$DECIMALS) - 1;
            tileCoordY = (0, $91ceb5420a5c8360$export$803ce6b71a0a94b2)(tileCoordY, $9265c7f0d03c6a23$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $91ceb5420a5c8360$export$a3fe094919f356fd)(tileCoordX, $9265c7f0d03c6a23$var$DECIMALS);
            tileCoordY = (0, $91ceb5420a5c8360$export$a3fe094919f356fd)(tileCoordY, $9265c7f0d03c6a23$var$DECIMALS);
        }
        return (0, $39b331b237eeed77$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndZ_(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        const origin = this.getOrigin(z);
        const resolution = this.getResolution(z);
        const tileSize = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $91ceb5420a5c8360$export$803ce6b71a0a94b2)(tileCoordX, $9265c7f0d03c6a23$var$DECIMALS) - 1;
            tileCoordY = (0, $91ceb5420a5c8360$export$803ce6b71a0a94b2)(tileCoordY, $9265c7f0d03c6a23$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $91ceb5420a5c8360$export$a3fe094919f356fd)(tileCoordX, $9265c7f0d03c6a23$var$DECIMALS);
            tileCoordY = (0, $91ceb5420a5c8360$export$a3fe094919f356fd)(tileCoordY, $9265c7f0d03c6a23$var$DECIMALS);
        }
        return (0, $39b331b237eeed77$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Integer zoom level, e.g. the result of a `getZForResolution()` method call
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndZ(coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */ getTileCoordResolution(tileCoord) {
        return this.resolutions_[tileCoord[0]];
    }
    /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */ getTileSize(z) {
        if (this.tileSize_) return this.tileSize_;
        return this.tileSizes_[z];
    }
    /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default|null} Extent tile range for the specified zoom level.
   */ getFullTileRange(z) {
        if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
        return this.fullTileRanges_[z];
    }
    /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */ getZForResolution(resolution, opt_direction) {
        const z = (0, $9d07dd9052c3de0c$export$8a3786cc03fdb777)(this.resolutions_, resolution, opt_direction || 0);
        return (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(z, this.minZoom, this.maxZoom);
    }
    /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */ tileCoordIntersectsViewport(tileCoord, viewport) {
        return (0, $fff493cc9a5ff53b$export$830a0dafbb2ef1c5)(viewport, 0, viewport.length, 2, this.getTileCoordExtent(tileCoord));
    }
    /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */ calculateTileRanges_(extent) {
        const length = this.resolutions_.length;
        const fullTileRanges = new Array(length);
        for(let z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        this.fullTileRanges_ = fullTileRanges;
    }
}
var $9265c7f0d03c6a23$export$2e2bcd8739ae039 = $9265c7f0d03c6a23$var$TileGrid;




function $4d180c4e74ac3a0c$export$1f4812384df8a9c5(projection) {
    let tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $4d180c4e74ac3a0c$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $4d180c4e74ac3a0c$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    const z = tileCoord[0];
    const center = tileGrid.getTileCoordCenter(tileCoord);
    const projectionExtent = $4d180c4e74ac3a0c$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $110ceb23457e07e7$export$ac68c24d37ca240f)(projectionExtent, center)) {
        const worldWidth = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(projectionExtent);
        const worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    }
    return tileCoord;
}
function $4d180c4e74ac3a0c$export$ce88871416242df8(extent, maxZoom, tileSize, corner) {
    corner = corner !== undefined ? corner : 'top-left';
    const resolutions = $4d180c4e74ac3a0c$var$resolutionsFromExtent(extent, maxZoom, tileSize);
    return new (0, $9265c7f0d03c6a23$export$2e2bcd8739ae039)({
        extent: extent,
        origin: (0, $110ceb23457e07e7$export$a1cfd206661d0801)(extent, corner),
        resolutions: resolutions,
        tileSize: tileSize
    });
}
function $4d180c4e74ac3a0c$export$38500bbeccc864ff(options) {
    const xyzOptions = options || {};
    const extent = xyzOptions.extent || (0, $d447c151baf41c8c$export$3988ae62b71be9a3)('EPSG:3857').getExtent();
    const gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $4d180c4e74ac3a0c$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, $9265c7f0d03c6a23$export$2e2bcd8739ae039)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function $4d180c4e74ac3a0c$var$resolutionsFromExtent(extent, maxZoom, tileSize, maxResolution) {
    maxZoom = maxZoom !== undefined ? maxZoom : (0, $70f6cba5b5336314$export$e98a216cdcc847dc);
    tileSize = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(tileSize !== undefined ? tileSize : (0, $70f6cba5b5336314$export$6b8cb5cd370bd90c));
    const height = (0, $110ceb23457e07e7$export$c08559766941f856)(extent);
    const width = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(extent);
    maxResolution = maxResolution > 0 ? maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    const length = maxZoom + 1;
    const resolutions = new Array(length);
    for(let z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $4d180c4e74ac3a0c$export$a251b12f5601c16f(projection, maxZoom, tileSize, corner) {
    const extent = $4d180c4e74ac3a0c$export$7b5b6ef8fd55fac4(projection);
    return $4d180c4e74ac3a0c$export$ce88871416242df8(extent, maxZoom, tileSize, corner);
}
function $4d180c4e74ac3a0c$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(projection);
    let extent = projection.getExtent();
    if (!extent) {
        const half = 180 * (0, $66a0959185f94b5b$export$1482081eec883108).degrees / projection.getMetersPerUnit();
        extent = (0, $110ceb23457e07e7$export$958e3e1a02eac4b6)(-half, -half, half, half);
    }
    return extent;
}


/**
 * @module ol/source/TileImage
 */ 






/**
 * @module ol/source/UrlTile
 */ 
/**
 * @module ol/tileurlfunction
 */ 

/**
 * @module ol/uri
 */ 

function $d1f99f6e9f4cea0f$export$c202e3cb8db99a95(uri, params) {
    /** @type {Array<string>} */ const keyParams = [];
    // Skip any null or undefined parameter values
    Object.keys(params).forEach(function(k) {
        if (params[k] !== null && params[k] !== undefined) keyParams.push(k + '=' + encodeURIComponent(params[k]));
    });
    const qs = keyParams.join('&');
    // remove any trailing ? or &
    uri = uri.replace(/[?&]$/, '');
    // append ? or & depending on whether uri has existing parameters
    uri += uri.includes('?') ? '&' : '?';
    return uri + qs;
}
const $d1f99f6e9f4cea0f$var$zRegEx = /\{z\}/g;
const $d1f99f6e9f4cea0f$var$xRegEx = /\{x\}/g;
const $d1f99f6e9f4cea0f$var$yRegEx = /\{y\}/g;
const $d1f99f6e9f4cea0f$var$dashYRegEx = /\{-y\}/g;
function $d1f99f6e9f4cea0f$export$df1e52f1b5b1c86f(template, z, x, y, maxY) {
    return template.replace($d1f99f6e9f4cea0f$var$zRegEx, z.toString()).replace($d1f99f6e9f4cea0f$var$xRegEx, x.toString()).replace($d1f99f6e9f4cea0f$var$yRegEx, y.toString()).replace($d1f99f6e9f4cea0f$var$dashYRegEx, function() {
        if (maxY === undefined) throw new Error('If the URL template has a {-y} placeholder, the grid extent must be known');
        return (maxY - y).toString();
    });
}
function $d1f99f6e9f4cea0f$export$83e87e683240b2e8(urls, z, x, y) {
    const hash = (0, $39b331b237eeed77$export$731f79419750ccf7)(z, x, y);
    const index = (0, $91ceb5420a5c8360$export$ba467bec01d66def)(hash, urls.length);
    return urls[index];
}
function $d1f99f6e9f4cea0f$export$2a1fa079bfd73dde(url) {
    const urls = [];
    let match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        const startCharCode = match[1].charCodeAt(0);
        const stopCharCode = match[2].charCodeAt(0);
        let charCode;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        const stop = parseInt(match[2], 10);
        for(let i = parseInt(match[1], 10); i <= stop; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}


function $05012cc3f9c861f5$export$f0ecb46e90798741(template, tileGrid) {
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        let maxY;
        const z = tileCoord[0];
        if (tileGrid) {
            // The `{-y}` placeholder only works for sources that have a tile grid at construction
            const range = tileGrid.getFullTileRange(z);
            if (range) maxY = range.getHeight() - 1;
        }
        return (0, $d1f99f6e9f4cea0f$export$df1e52f1b5b1c86f)(template, z, tileCoord[1], tileCoord[2], maxY);
    });
}
function $05012cc3f9c861f5$export$436f44dbcc31fea3(templates, tileGrid) {
    const len = templates.length;
    const tileUrlFunctions = new Array(len);
    for(let i = 0; i < len; ++i)tileUrlFunctions[i] = $05012cc3f9c861f5$export$f0ecb46e90798741(templates[i], tileGrid);
    return $05012cc3f9c861f5$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $05012cc3f9c861f5$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        const h = (0, $39b331b237eeed77$export$d6af199866bfb566)(tileCoord);
        const index = (0, $91ceb5420a5c8360$export$ba467bec01d66def)(h, tileUrlFunctions.length);
        return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
    });
}
function $05012cc3f9c861f5$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}




/**
 * @module ol/source/Tile
 */ 




/**
 * @module ol/source/Source
 */ 

/**
 * @typedef {'undefined' | 'loading' | 'ready' | 'error'} State
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ /**
 * A function that takes a {@link import("../View.js").ViewStateLayerStateExtent} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../View.js").ViewStateLayerStateExtent): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * a simple string (e.g. `'© Acme Inc.'`)
 * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./Source.js").State} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ class $f49cf02121669501$var$Source extends (0, $32070d44509bac34$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Source options.
   */ constructor(options){
        super();
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|null}
     */ this.projection = (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(options.projection);
        /**
     * @private
     * @type {?Attribution}
     */ this.attributions_ = $f49cf02121669501$var$adaptAttributions(options.attributions);
        /**
     * @private
     * @type {boolean}
     */ this.attributionsCollapsible_ = options.attributionsCollapsible ?? true;
        /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to `true`.
     * @type {boolean}
     */ this.loading = false;
        /**
     * @private
     * @type {import("./Source.js").State}
     */ this.state_ = options.state !== undefined ? options.state : 'ready';
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = !!options.interpolate;
        /**
     * @protected
     * @type {function(import("../View.js").ViewOptions):void}
     */ this.viewResolver = null;
        /**
     * @protected
     * @type {function(Error):void}
     */ this.viewRejector = null;
        const self = this;
        /**
     * @private
     * @type {Promise<import("../View.js").ViewOptions>}
     */ this.viewPromise_ = new Promise(function(resolve, reject) {
            self.viewResolver = resolve;
            self.viewRejector = reject;
        });
    }
    /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */ getAttributions() {
        return this.attributions_;
    }
    /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */ getAttributionsCollapsible() {
        return this.attributionsCollapsible_;
    }
    /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */ getProjection() {
        return this.projection;
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ getResolutions(projection) {
        return null;
    }
    /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */ getView() {
        return this.viewPromise_;
    }
    /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */ getState() {
        return this.state_;
    }
    /**
   * @return {boolean|undefined} Wrap X.
   */ getWrapX() {
        return this.wrapX_;
    }
    /**
   * @return {boolean} Use linear interpolation when resampling.
   */ getInterpolate() {
        return this.interpolate_;
    }
    /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */ refresh() {
        this.changed();
    }
    /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */ setAttributions(attributions) {
        this.attributions_ = $f49cf02121669501$var$adaptAttributions(attributions);
        this.changed();
    }
    /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */ setState(state) {
        this.state_ = state;
        this.changed();
    }
}
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */ function $f49cf02121669501$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (typeof attributionLike === 'function') return attributionLike;
    if (!Array.isArray(attributionLike)) attributionLike = [
        attributionLike
    ];
    return (frameState)=>attributionLike;
}
var $f49cf02121669501$export$2e2bcd8739ae039 = $f49cf02121669501$var$Source;


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./TileEventType").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./TileEventType").TileSourceEventTypes, Return>} TileSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 *
 * @template {import("../Tile.js").default} [TileType=import("../Tile.js").default]
 * @abstract
 * @api
 */ class $5b558bee34fffad8$var$TileSource extends (0, $f49cf02121669501$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options SourceTile source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
            interpolate: options.interpolate
        });
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {TileSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number}
     */ this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
     * @type {import("../tilegrid/TileGrid.js").default|null}
     * @protected
     */ this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        const tileSize = [
            256,
            256
        ];
        if (this.tileGrid) (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(this.tileGrid.getTileSize(this.tileGrid.getMinZoom()), tileSize);
        /**
     * @protected
     * @type {import("../size.js").Size}
     */ this.tmpSize = [
            0,
            0
        ];
        /**
     * @private
     * @type {string}
     */ this.key_ = options.key || (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(this);
        /**
     * @protected
     * @type {import("../Tile.js").Options}
     */ this.tileOptions = {
            transition: options.transition,
            interpolate: options.interpolate
        };
        /**
     * zDirection hint, read by the renderer. Indicates which resolution should be used
     * by a renderer if the views resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @type {number|import("../array.js").NearestDirectionFunction}
     */ this.zDirection = options.zDirection ? options.zDirection : 0;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ getGutterForProjection(projection) {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ getKey() {
        return this.key_;
    }
    /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */ setKey(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions(projection) {
        const tileGrid = projection ? this.getTileGridForProjection(projection) : this.tileGrid;
        if (!tileGrid) return null;
        return tileGrid.getResolutions();
    }
    /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {TileType|null} Tile.
   */ getTile(z, x, y, pixelRatio, projection) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */ getTileGrid() {
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ getTileGridForProjection(projection) {
        if (!this.tileGrid) return (0, $4d180c4e74ac3a0c$export$1f4812384df8a9c5)(projection);
        return this.tileGrid;
    }
    /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ getTilePixelRatio(pixelRatio) {
        return this.tilePixelRatio_;
    }
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */ getTilePixelSize(z, pixelRatio, projection) {
        const tileGrid = this.getTileGridForProjection(projection);
        const tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        const tileSize = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        return (0, $090e4507b3b63c57$export$dcdf75081b88279d)(tileSize, tilePixelRatio, this.tmpSize);
    }
    /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */ getTileCoordForTileUrlFunction(tileCoord, projection) {
        const gridProjection = projection !== undefined ? projection : this.getProjection();
        const tileGrid = projection !== undefined ? this.getTileGridForProjection(gridProjection) : this.tileGrid || this.getTileGridForProjection(gridProjection);
        if (this.getWrapX() && gridProjection.isGlobal()) tileCoord = (0, $4d180c4e74ac3a0c$export$39a9ce3624977b84)(tileGrid, tileCoord, gridProjection);
        return (0, $39b331b237eeed77$export$60bedf8e3e3c3dbe)(tileCoord, tileGrid) ? tileCoord : null;
    }
    /**
   * Remove all cached reprojected tiles from the source. The next render cycle will create new tiles.
   * @api
   */ clear() {}
    /**
   * @override
   */ refresh() {
        this.clear();
        super.refresh();
    }
}
class $5b558bee34fffad8$export$c571855c51e6c4b6 extends (0, $5ede4ff5599f8860$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Tile.js").default} tile The tile.
   */ constructor(type, tile){
        super(type);
        /**
     * The tile related to the event.
     * @type {import("../Tile.js").default}
     * @api
     */ this.tile = tile;
    }
}
var $5b558bee34fffad8$export$2e2bcd8739ae039 = $5b558bee34fffad8$var$TileSource;


/**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $bfdc6e4d21ae4cbe$export$2e2bcd8739ae039 /**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */  = {
    /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */ TILELOADSTART: 'tileloadstart',
    /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */ TILELOADEND: 'tileloadend',
    /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */ TILELOADERROR: 'tileloaderror'
};


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ class $118b60936f97bd19$var$UrlTile extends (0, $5b558bee34fffad8$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {boolean}
     */ this.generateTileUrlFunction_ = this.tileUrlFunction === $118b60936f97bd19$var$UrlTile.prototype.tileUrlFunction;
        /**
     * @protected
     * @type {import("../Tile.js").LoadFunction}
     */ this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) this.tileUrlFunction = options.tileUrlFunction;
        /**
     * @protected
     * @type {!Array<string>|null}
     */ this.urls = null;
        if (options.urls) this.setUrls(options.urls);
        else if (options.url) this.setUrl(options.url);
        /**
     * @private
     * @type {!Object<string, boolean>}
     */ this.tileLoadingKeys_ = {};
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */ getTileLoadFunction() {
        return this.tileLoadFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */ getTileUrlFunction() {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */ getUrls() {
        return this.urls;
    }
    /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("../Tile.js").default} */ event.target;
        const uid = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(tile);
        const tileState = tile.getState();
        let type;
        if (tileState == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, $bfdc6e4d21ae4cbe$export$2e2bcd8739ae039).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR ? (0, $bfdc6e4d21ae4cbe$export$2e2bcd8739ae039).TILELOADERROR : tileState == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED ? (0, $bfdc6e4d21ae4cbe$export$2e2bcd8739ae039).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, $5b558bee34fffad8$export$c571855c51e6c4b6)(type, tile));
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */ setTileLoadFunction(tileLoadFunction) {
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */ setTileUrlFunction(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        if (typeof key !== 'undefined') this.setKey(key);
        else this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */ setUrl(url) {
        const urls = (0, $d1f99f6e9f4cea0f$export$2a1fa079bfd73dde)(url);
        this.urls = urls;
        this.setUrls(urls);
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */ setUrls(urls) {
        this.urls = urls;
        const key = urls.join('\n');
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $05012cc3f9c861f5$export$436f44dbcc31fea3)(urls, this.tileGrid), key);
        else this.setKey(key);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        return undefined;
    }
}
var $118b60936f97bd19$export$2e2bcd8739ae039 = $118b60936f97bd19$var$UrlTile;


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ class $c424a67598ada7c4$var$TileImage extends (0, $118b60936f97bd19$export$2e2bcd8739ae039) {
    /**
   * @param {!Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $c424a67598ada7c4$var$defaultTileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate !== undefined ? options.interpolate : true,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @protected
     * @type {?string}
     */ this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @protected
     * @type {typeof ImageTile}
     */ this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $ae0d8a38ddc9cf8f$export$2e2bcd8739ae039);
        /**
     * @protected
     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGridForProjection = {};
        /**
     * @private
     * @type {number|undefined}
     */ this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
     * @private
     * @type {boolean}
     */ this.renderReprojectionEdges_ = false;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   * @override
   */ getGutterForProjection(projection) {
        if (this.getProjection() && projection && !(0, $d447c151baf41c8c$export$fe091d73a555748b)(this.getProjection(), projection)) return 0;
        return this.getGutter();
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   * @override
   */ getKey() {
        let key = super.getKey();
        if (!this.getInterpolate()) key += ':disable-interpolation';
        return key;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   * @override
   */ getTileGridForProjection(projection) {
        const thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, $d447c151baf41c8c$export$fe091d73a555748b)(thisProj, projection))) return this.tileGrid;
        const projKey = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(projection);
        if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $4d180c4e74ac3a0c$export$1f4812384df8a9c5)(projection);
        return this.tileGridForProjection[projKey];
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */ createTile_(z, x, y, pixelRatio, projection, key) {
        const tileCoord = [
            z,
            x,
            y
        ];
        const urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        const tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE : (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY, tileUrl !== undefined ? tileUrl : '', this.crossOrigin, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, this.handleTileChange.bind(this));
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!(ImageTile|ReprojTile)} Tile.
   * @override
   */ getTile(z, x, y, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $d447c151baf41c8c$export$fe091d73a555748b)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        const tileCoord = [
            z,
            x,
            y
        ];
        const key = this.getKey();
        const sourceTileGrid = this.getTileGridForProjection(sourceProjection);
        const targetTileGrid = this.getTileGridForProjection(projection);
        const wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tile = new (0, $99cafc0f9d5ff6b5$export$2e2bcd8739ae039)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (z, x, y, pixelRatio)=>this.getTileInternal(z, x, y, pixelRatio, sourceProjection), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.tileOptions);
        tile.key = key;
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @return {!ImageTile} Tile.
   * @protected
   */ getTileInternal(z, x, y, pixelRatio, projection) {
        const key = this.getKey();
        return this.createTile_(z, x, y, pixelRatio, projection, key);
    }
    /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */ setRenderReprojectionEdges(render) {
        if (this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        this.changed();
    }
    /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */ setTileGridForProjection(projection, tilegrid) {
        const proj = (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(projection);
        if (proj) {
            const projKey = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(proj);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
        }
    }
}
/**
 * @param {ImageTile} imageTile Image tile.
 * @param {string} src Source.
 */ function $c424a67598ada7c4$var$defaultTileLoadFunction(imageTile, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $c424a67598ada7c4$export$2e2bcd8739ae039 = $c424a67598ada7c4$var$TileImage;


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=42] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom=0] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Deprecated.  Use an ImageTile source with a loader
 * instead.  Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Not used if `tileGrid` is provided.
 * @property {number} [gutter=0] The size in pixels of the gutter around image tiles to ignore.
 * This allows artifacts of rendering at tile edges to be ignored.
 * Supported images should be wider and taller than the tile size by a value of `2 x gutter`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] Deprecated.  Use an ImageTile source and provide an array of URLs for the
 * url option instead.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case
 * a `tileUrlFunction` can be used, such as:
 * ```js
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *      coordinate[1] + '/' + (-coordinate[2] - 1) + '.png';
 *  }
 * ```
 * @api
 */ class $1c54370c97223651$var$XYZ extends (0, $c424a67598ada7c4$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] XYZ options.
   */ constructor(options){
        options = options || {};
        const projection = options.projection !== undefined ? options.projection : 'EPSG:3857';
        const tileGrid = options.tileGrid !== undefined ? options.tileGrid : (0, $4d180c4e74ac3a0c$export$38500bbeccc864ff)({
            extent: (0, $4d180c4e74ac3a0c$export$7b5b6ef8fd55fac4)(projection),
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom,
            minZoom: options.minZoom,
            tileSize: options.tileSize
        });
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
    }
    /**
   * @return {number} Gutter.
   * @override
   */ getGutter() {
        return this.gutter_;
    }
}
var $1c54370c97223651$export$2e2bcd8739ae039 = $1c54370c97223651$var$XYZ;


/**
 * @module ol/layer/VectorTile
 */ 
/**
 * @module ol/renderer/canvas/VectorTileLayer
 */ 




/**
 * @module ol/render/canvas/BuilderGroup
 */ /**
 * @module ol/render/canvas/Builder
 */ 




/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ class $5d8b19280979766d$var$VectorContext {
    /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {}
    /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */ drawGeometry(geometry) {}
    /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */ setStyle(style) {}
    /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawCircle(circleGeometry, feature, index) {}
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   * @param {number} [index] Render order index.
   */ drawFeature(feature, style, index) {}
    /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawGeometryCollection(geometryCollectionGeometry, feature, index) {}
    /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawLineString(lineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPoint(multiPointGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPoint(pointGeometry, feature, index) {}
    /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPolygon(polygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawText(geometry, feature, index) {}
    /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {}
    /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */ setImageStyle(imageStyle, declutterImageWithText) {}
    /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */ setTextStyle(textStyle, declutterImageWithText) {}
}
var $5d8b19280979766d$export$2e2bcd8739ae039 = $5d8b19280979766d$var$VectorContext;



/**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ const $85fee81af64d076c$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
const $85fee81af64d076c$export$f21891651e408226 = [
    $85fee81af64d076c$var$Instruction.FILL
];
const $85fee81af64d076c$export$7a98aa5364d62ba8 = [
    $85fee81af64d076c$var$Instruction.STROKE
];
const $85fee81af64d076c$export$9f746cc58a899a00 = [
    $85fee81af64d076c$var$Instruction.BEGIN_PATH
];
const $85fee81af64d076c$export$89b10f327e413e71 = [
    $85fee81af64d076c$var$Instruction.CLOSE_PATH
];
var $85fee81af64d076c$export$2e2bcd8739ae039 = $85fee81af64d076c$var$Instruction;


class $1902c50a9e942aa9$var$CanvasBuilder extends (0, $5d8b19280979766d$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super();
        /**
     * @protected
     * @type {number}
     */ this.tolerance = tolerance;
        /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent = maxExtent;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @type {number}
     */ this.maxLineWidth = 0;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction1_ = null;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction2_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.bufferedMaxExtent_ = null;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = [];
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = [];
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ this.tmpCoordinate_ = [];
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = [];
        /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */ this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
    }
    /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */ applyPixelRatio(dashArray) {
        const pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */ appendFlatPointCoordinates(flatCoordinates, stride) {
        const extent = this.getBufferedMaxExtent();
        const tmpCoord = this.tmpCoordinate_;
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if ((0, $110ceb23457e07e7$export$ac68c24d37ca240f)(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */ appendFlatLineCoordinates(flatCoordinates, offset, end, stride, closed, skipFirst) {
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        const extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        let lastXCoord = flatCoordinates[offset];
        let lastYCoord = flatCoordinates[offset + 1];
        const nextCoord = this.tmpCoordinate_;
        let skipped = true;
        let i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, $110ceb23457e07e7$export$f97905ead28c61a8)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            } else if (nextRel === (0, $6fc5fe9336d27a2c$export$2e2bcd8739ae039).INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */ drawCustomCoordinates_(flatCoordinates, offset, ends, stride, builderEnds) {
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   * @override
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {
        this.beginGeometry(geometry, feature, index);
        const type = geometry.getType();
        const stride = geometry.getStride();
        const builderBegin = this.coordinates.length;
        let flatCoordinates, builderEnd, builderEnds, builderEndss;
        let offset;
        switch(type){
            case 'MultiPolygon':
                flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
                builderEndss = [];
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                offset = 0;
                for(let i = 0, ii = endss.length; i < ii; ++i){
                    const myEnds = [];
                    offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                    builderEndss.push(myEnds);
                }
                this.instructions.push([
                    (0, $85fee81af64d076c$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    renderer,
                    (0, $2a6a9b7fa6b84967$export$915c7058aeb4dfeb),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $85fee81af64d076c$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $2a6a9b7fa6b84967$export$915c7058aeb4dfeb),
                    index
                ]);
                break;
            case 'Polygon':
            case 'MultiLineString':
                builderEnds = [];
                flatCoordinates = type == 'Polygon' ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
                offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
                this.instructions.push([
                    (0, $85fee81af64d076c$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    renderer,
                    (0, $2a6a9b7fa6b84967$export$cbb9596fc0f40db2),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $85fee81af64d076c$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $2a6a9b7fa6b84967$export$cbb9596fc0f40db2),
                    index
                ]);
                break;
            case 'LineString':
            case 'Circle':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                this.instructions.push([
                    (0, $85fee81af64d076c$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    (0, $2a6a9b7fa6b84967$export$9c0934e4e9c3f61e),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $85fee81af64d076c$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $2a6a9b7fa6b84967$export$9c0934e4e9c3f61e),
                    index
                ]);
                break;
            case 'MultiPoint':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                if (builderEnd > builderBegin) {
                    this.instructions.push([
                        (0, $85fee81af64d076c$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        renderer,
                        (0, $2a6a9b7fa6b84967$export$9c0934e4e9c3f61e),
                        index
                    ]);
                    this.hitDetectionInstructions.push([
                        (0, $85fee81af64d076c$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        hitDetectionRenderer || renderer,
                        (0, $2a6a9b7fa6b84967$export$9c0934e4e9c3f61e),
                        index
                    ]);
                }
                break;
            case 'Point':
                flatCoordinates = geometry.getFlatCoordinates();
                this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
                builderEnd = this.coordinates.length;
                this.instructions.push([
                    (0, $85fee81af64d076c$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    undefined,
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $85fee81af64d076c$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    undefined,
                    index
                ]);
                break;
            default:
        }
        this.endGeometry(feature);
    }
    /**
   * @protected
   * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} index Render order index
   */ beginGeometry(geometry, feature, index) {
        this.beginGeometryInstruction1_ = [
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates
        };
    }
    /**
   * Reverse the hit detection instructions.
   */ reverseHitDetectionInstructions() {
        const hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        let i;
        const n = hitDetectionInstructions.length;
        let instruction;
        let type;
        let begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ instruction[0];
            if (type == (0, $85fee81af64d076c$export$2e2bcd8739ae039).END_GEOMETRY) begin = i;
            else if (type == (0, $85fee81af64d076c$export$2e2bcd8739ae039).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, $9d07dd9052c3de0c$export$292cfa960964f0e0)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import('../canvas.js').FillStrokeState} [state] State.
   * @return {import('../canvas.js').FillStrokeState} State.
   */ fillStyleToState(fillStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (fillStyle) {
            const fillStyleColor = fillStyle.getColor();
            state.fillPatternScale = fillStyleColor && typeof fillStyleColor === 'object' && 'src' in fillStyleColor ? this.pixelRatio : 1;
            state.fillStyle = (0, $f23531dbd6538933$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2));
        } else state.fillStyle = undefined;
        return state;
    }
    /**
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {import("../canvas.js").FillStrokeState} State.
   */ strokeStyleToState(strokeStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (strokeStyle) {
            const strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, $f23531dbd6538933$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $56d5de32f563e6ab$export$1eb2eaecacf2031e));
            const strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $56d5de32f563e6ab$export$17bd0c38d6ae694e);
            const strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $56d5de32f563e6ab$export$e21b4112fdc612fc);
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $56d5de32f563e6ab$export$e06efc2409049f76);
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $56d5de32f563e6ab$export$365eb9648cf19bd0);
            const strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $56d5de32f563e6ab$export$79661f132c62010e);
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $56d5de32f563e6ab$export$80c1c01844597b7b);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
        }
        return state;
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        const state = this.state;
        this.fillStyleToState(fillStyle, state);
        this.strokeStyleToState(strokeStyle, state);
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */ createFill(state) {
        const fillStyle = state.fillStyle;
        /** @type {Array<*>} */ const fillInstruction = [
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== 'string') // Fill is a pattern or gradient - align and scale it!
        fillInstruction.push(state.fillPatternScale);
        return fillInstruction;
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ applyStroke(state) {
        this.instructions.push(this.createStroke(state));
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */ createStroke(state) {
        return [
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash ? this.applyPixelRatio(state.lineDash) : null,
            state.lineDashOffset * this.pixelRatio
        ];
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */ updateFillStyle(state, createFill) {
        const fillStyle = state.fillStyle;
        if (typeof fillStyle !== 'string' || state.currentFillStyle != fillStyle) {
            if (fillStyle !== undefined) this.instructions.push(createFill.call(this, state));
            state.currentFillStyle = fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */ updateStrokeStyle(state, applyStroke) {
        const strokeStyle = state.strokeStyle;
        const lineCap = state.lineCap;
        const lineDash = state.lineDash;
        const lineDashOffset = state.lineDashOffset;
        const lineJoin = state.lineJoin;
        const lineWidth = state.lineWidth;
        const miterLimit = state.miterLimit;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $9d07dd9052c3de0c$export$e9bab7fafb253603)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit) {
            if (strokeStyle !== undefined) applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
        }
    }
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ endGeometry(feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        const endGeometryInstruction = [
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    }
    /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */ getBufferedMaxExtent() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, $110ceb23457e07e7$export$9cd59f9826255e47)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                const width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, $110ceb23457e07e7$export$ab1029bcae9ddb4a)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    }
}
var $1902c50a9e942aa9$export$2e2bcd8739ae039 = $1902c50a9e942aa9$var$CanvasBuilder;


/**
 * @module ol/render/canvas/ImageBuilder
 */ 


class $0183db6fb2a0b745$var$CanvasImageBuilder extends (0, $1902c50a9e942aa9$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.imagePixelRatio_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorY_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.height_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.opacity_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originY_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        /**
     * @private
     * @type {import("../../size.js").Size|undefined}
     */ this.scale_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = undefined;
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with a text builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPoint(pointGeometry, feature, index) {
        if (!this.image_ || this.maxExtent && !(0, $110ceb23457e07e7$export$ac68c24d37ca240f)(this.maxExtent, pointGeometry.getFlatCoordinates())) return;
        this.beginGeometry(pointGeometry, feature, index);
        const flatCoordinates = pointGeometry.getFlatCoordinates();
        const stride = pointGeometry.getStride();
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPoint(multiPointGeometry, feature, index) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature, index);
        const flatCoordinates = multiPointGeometry.getFlatCoordinates();
        const filteredFlatCoordinates = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += multiPointGeometry.getStride())if (!this.maxExtent || (0, $110ceb23457e07e7$export$ac68c24d37ca240f)(this.maxExtent, flatCoordinates.slice(i, i + 2))) filteredFlatCoordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(filteredFlatCoordinates, 2);
        this.instructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return super.finish();
    }
    /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setImageStyle(imageStyle, sharedData) {
        const anchor = imageStyle.getAnchor();
        const size = imageStyle.getSize();
        const origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = imageStyle.getHitDetectionImage();
        this.image_ = imageStyle.getImage(this.pixelRatio);
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterMode_ = imageStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $0183db6fb2a0b745$export$2e2bcd8739ae039 = $0183db6fb2a0b745$var$CanvasImageBuilder;


/**
 * @module ol/render/canvas/LineStringBuilder
 */ 


class $06f222f508042c61$var$CanvasLineStringBuilder extends (0, $1902c50a9e942aa9$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   * @return {number} end.
   */ drawFlatCoordinates_(flatCoordinates, offset, end, stride) {
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        const moveToLineToInstruction = [
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
            myBegin,
            myEnd
        ];
        this.instructions.push(moveToLineToInstruction);
        this.hitDetectionInstructions.push(moveToLineToInstruction);
        return end;
    }
    /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawLineString(lineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $56d5de32f563e6ab$export$e21b4112fdc612fc),
            (0, $56d5de32f563e6ab$export$e06efc2409049f76)
        ], (0, $85fee81af64d076c$export$9f746cc58a899a00));
        const flatCoordinates = lineStringGeometry.getFlatCoordinates();
        const stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
        this.hitDetectionInstructions.push((0, $85fee81af64d076c$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $56d5de32f563e6ab$export$e21b4112fdc612fc),
            (0, $56d5de32f563e6ab$export$e06efc2409049f76)
        ], (0, $85fee81af64d076c$export$9f746cc58a899a00));
        const ends = multiLineStringGeometry.getEnds();
        const flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        const stride = multiLineStringGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride);
        this.hitDetectionInstructions.push((0, $85fee81af64d076c$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $85fee81af64d076c$export$7a98aa5364d62ba8));
        this.reverseHitDetectionInstructions();
        this.state = null;
        return super.finish();
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @override
   */ applyStroke(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, $85fee81af64d076c$export$7a98aa5364d62ba8));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        super.applyStroke(state);
        this.instructions.push((0, $85fee81af64d076c$export$9f746cc58a899a00));
    }
}
var $06f222f508042c61$export$2e2bcd8739ae039 = $06f222f508042c61$var$CanvasLineStringBuilder;


/**
 * @module ol/render/canvas/PolygonBuilder
 */ 



class $7881f606c7c570a3$var$CanvasPolygonBuilder extends (0, $1902c50a9e942aa9$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ drawFlatCoordinatess_(flatCoordinates, offset, ends, stride) {
        const state = this.state;
        const fill = state.fillStyle !== undefined;
        const stroke = state.strokeStyle !== undefined;
        const numEnds = ends.length;
        this.instructions.push((0, $85fee81af64d076c$export$9f746cc58a899a00));
        this.hitDetectionInstructions.push((0, $85fee81af64d076c$export$9f746cc58a899a00));
        for(let i = 0; i < numEnds; ++i){
            const end = ends[i];
            const myBegin = this.coordinates.length;
            const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            const moveToLineToInstruction = [
                (0, $85fee81af64d076c$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                myBegin,
                myEnd
            ];
            this.instructions.push(moveToLineToInstruction);
            this.hitDetectionInstructions.push(moveToLineToInstruction);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push((0, $85fee81af64d076c$export$89b10f327e413e71));
                this.hitDetectionInstructions.push((0, $85fee81af64d076c$export$89b10f327e413e71));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, $85fee81af64d076c$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $85fee81af64d076c$export$f21891651e408226));
        }
        if (stroke) {
            this.instructions.push((0, $85fee81af64d076c$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $85fee81af64d076c$export$7a98aa5364d62ba8));
        }
        return offset;
    }
    /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawCircle(circleGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $56d5de32f563e6ab$export$e21b4112fdc612fc),
            (0, $56d5de32f563e6ab$export$e06efc2409049f76)
        ]);
        const flatCoordinates = circleGeometry.getFlatCoordinates();
        const stride = circleGeometry.getStride();
        const myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        const circleInstruction = [
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).CIRCLE,
            myBegin
        ];
        this.instructions.push((0, $85fee81af64d076c$export$9f746cc58a899a00), circleInstruction);
        this.hitDetectionInstructions.push((0, $85fee81af64d076c$export$9f746cc58a899a00), circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push((0, $85fee81af64d076c$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $85fee81af64d076c$export$f21891651e408226));
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, $85fee81af64d076c$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $85fee81af64d076c$export$7a98aa5364d62ba8));
        }
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPolygon(polygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $56d5de32f563e6ab$export$e21b4112fdc612fc),
            (0, $56d5de32f563e6ab$export$e06efc2409049f76)
        ]);
        const ends = polygonGeometry.getEnds();
        const flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        const stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $56d5de32f563e6ab$export$e21b4112fdc612fc),
            (0, $56d5de32f563e6ab$export$e06efc2409049f76)
        ]);
        const endss = multiPolygonGeometry.getEndss();
        const flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        const stride = multiPolygonGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        const tolerance = this.tolerance;
        if (tolerance !== 0) {
            const coordinates = this.coordinates;
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $91af87e7f153f420$export$51a0620f7a28532b)(coordinates[i], tolerance);
        }
        return super.finish();
    }
    /**
   * @private
   */ setFillStrokeStyles_() {
        const state = this.state;
        const fillStyle = state.fillStyle;
        if (fillStyle !== undefined) this.updateFillStyle(state, this.createFill);
        if (state.strokeStyle !== undefined) this.updateStrokeStyle(state, this.applyStroke);
    }
}
var $7881f606c7c570a3$export$2e2bcd8739ae039 = $7881f606c7c570a3$var$CanvasPolygonBuilder;


/**
 * @module ol/render/canvas/TextBuilder
 */ 


function $6ac064a0b3b3f3fa$export$f08272c6ff321e57(chunkLength, flatCoordinates, offset, end, stride) {
    const chunks = [];
    let cursor = offset;
    let chunkM = 0;
    let currentChunk = flatCoordinates.slice(offset, 2);
    while(chunkM < chunkLength && cursor + stride < end){
        const [x1, y1] = currentChunk.slice(-2);
        const x2 = flatCoordinates[cursor + stride];
        const y2 = flatCoordinates[cursor + stride + 1];
        const segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        chunkM += segmentLength;
        if (chunkM >= chunkLength) {
            const m = (chunkLength - chunkM + segmentLength) / segmentLength;
            const x = (0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(x1, x2, m);
            const y = (0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(y1, y2, m);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            if (chunkM == chunkLength) cursor += stride;
            chunkM = 0;
        } else if (chunkM < chunkLength) {
            currentChunk.push(flatCoordinates[cursor + stride], flatCoordinates[cursor + stride + 1]);
            cursor += stride;
        } else {
            const missing = segmentLength - chunkM;
            const x = (0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(x1, x2, missing / segmentLength);
            const y = (0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(y1, y2, missing / segmentLength);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            chunkM = 0;
            cursor += stride;
        }
    }
    if (chunkM > 0) chunks.push(currentChunk);
    return chunks;
}


/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $3c7f1a54e89db05a$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    let chunkStart = offset;
    let chunkEnd = offset;
    let chunkM = 0;
    let m = 0;
    let start = offset;
    let acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}






const $9a4fd6d4219c35cc$export$91a016276e4aee96 = {
    'left': 0,
    'center': 0.5,
    'right': 1,
    'top': 0,
    'middle': 0.5,
    'hanging': 0.2,
    'alphabetic': 0.8,
    'ideographic': 0.8,
    'bottom': 1
};
class $9a4fd6d4219c35cc$var$CanvasTextBuilder extends (0, $1902c50a9e942aa9$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */ this.labels_ = null;
        /**
     * @private
     * @type {string|Array<string>}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textRotateWithView_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textKeepUpright_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = {};
        this.fillStates[0, $56d5de32f563e6ab$export$c495d52ee3fd74b2] = {
            fillStyle: (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2)
        };
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = {};
        /**
     * @private
     * @type {import("../canvas.js").TextState}
     */ this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = {};
        /**
     * @private
     * @type {string}
     */ this.textKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.fillKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.strokeKey_ = '';
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with an image builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const instructions = super.finish();
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawText(geometry, feature, index) {
        const fillState = this.textFillState_;
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        if (this.text_ === '' || !textState || !fillState && !strokeState) return;
        const coordinates = this.coordinates;
        let begin = coordinates.length;
        const geometryType = geometry.getType();
        let flatCoordinates = null;
        let stride = geometry.getStride();
        if (textState.placement === 'line' && (geometryType == 'LineString' || geometryType == 'MultiLineString' || geometryType == 'Polygon' || geometryType == 'MultiPolygon')) {
            if (!(0, $110ceb23457e07e7$export$7b0a31e10bbff018)(this.maxExtent, geometry.getExtent())) return;
            let ends;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == 'LineString') ends = [
                flatCoordinates.length
            ];
            else if (geometryType == 'MultiLineString') ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
            else if (geometryType == 'Polygon') ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
            else if (geometryType == 'MultiPolygon') {
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                ends = [];
                for(let i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            this.beginGeometry(geometry, feature, index);
            const repeat = textState.repeat;
            const textAlign = repeat ? undefined : textState.textAlign;
            // No `justify` support for line placement.
            let flatOffset = 0;
            for(let o = 0, oo = ends.length; o < oo; ++o){
                let chunks;
                if (repeat) chunks = (0, $6ac064a0b3b3f3fa$export$f08272c6ff321e57)(repeat * this.resolution, flatCoordinates, flatOffset, ends[o], stride);
                else chunks = [
                    flatCoordinates.slice(flatOffset, ends[o])
                ];
                for(let c = 0, cc = chunks.length; c < cc; ++c){
                    const chunk = chunks[c];
                    let chunkBegin = 0;
                    let chunkEnd = chunk.length;
                    if (textAlign == undefined) {
                        const range = (0, $3c7f1a54e89db05a$export$ed6c897eea07a254)(textState.maxAngle, chunk, 0, chunk.length, 2);
                        chunkBegin = range[0];
                        chunkEnd = range[1];
                    }
                    for(let i = chunkBegin; i < chunkEnd; i += stride)coordinates.push(chunk[i], chunk[i + 1]);
                    const end = coordinates.length;
                    flatOffset = ends[o];
                    this.drawChars_(begin, end);
                    begin = end;
                }
            }
            this.endGeometry(feature);
        } else {
            let geometryWidths = textState.overflow ? null : [];
            switch(geometryType){
                case 'Point':
                case 'MultiPoint':
                    flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                    break;
                case 'LineString':
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case 'Circle':
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case 'MultiLineString':
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    stride = 2;
                    break;
                case 'Polygon':
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                    stride = 3;
                    break;
                case 'MultiPolygon':
                    const interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(let i = 0, ii = interiorPoints.length; i < ii; i += 3){
                        if (!textState.overflow) geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) return;
                    stride = 2;
                    break;
                default:
            }
            const end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) return;
            if (geometryWidths && (end - begin) / 2 !== flatCoordinates.length / stride) {
                let beg = begin / 2;
                geometryWidths = geometryWidths.filter((w, i)=>{
                    const keep = coordinates[(beg + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                    if (!keep) --beg;
                    return keep;
                });
            }
            this.saveTextStates_();
            const backgroundFill = textState.backgroundFill ? this.createFill(this.fillStyleToState(textState.backgroundFill)) : null;
            const backgroundStroke = textState.backgroundStroke ? this.createStroke(this.strokeStyleToState(textState.backgroundStroke)) : null;
            this.beginGeometry(geometry, feature, index);
            // adjust padding for negative scale
            let padding = textState.padding;
            if (padding != (0, $56d5de32f563e6ab$export$40a9eeef55665a40) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                let p0 = textState.padding[0];
                let p1 = textState.padding[1];
                let p2 = textState.padding[2];
                let p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [
                    p0,
                    p1,
                    p2,
                    p3
                ];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            const pixelRatio = this.pixelRatio;
            this.instructions.push([
                (0, $85fee81af64d076c$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    1,
                    1
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding == (0, $56d5de32f563e6ab$export$40a9eeef55665a40) ? (0, $56d5de32f563e6ab$export$40a9eeef55665a40) : padding.map(function(p) {
                    return p * pixelRatio;
                }),
                backgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            const scale = 1 / pixelRatio;
            // Set default fill for hit detection background
            const hitDetectionBackgroundFill = backgroundFill ? backgroundFill.slice(0) : null;
            if (hitDetectionBackgroundFill) hitDetectionBackgroundFill[1] = (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2);
            this.hitDetectionInstructions.push([
                (0, $85fee81af64d076c$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    scale,
                    scale
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding,
                hitDetectionBackgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_ ? (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2) : this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            this.endGeometry(feature);
        }
    }
    /**
   * @private
   */ saveTextStates_() {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const fillState = this.textFillState_;
        const strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        const textKey = this.textKey_;
        if (!(textKey in this.textStates)) this.textStates[textKey] = {
            font: textState.font,
            textAlign: textState.textAlign || (0, $56d5de32f563e6ab$export$94d53b95641b5766),
            justify: textState.justify,
            textBaseline: textState.textBaseline || (0, $56d5de32f563e6ab$export$cf2279a1bff62eb),
            scale: textState.scale
        };
        const fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                fillStyle: fillState.fillStyle
            };
        }
    }
    /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */ drawChars_(begin, end) {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const strokeKey = this.strokeKey_;
        const textKey = this.textKey_;
        const fillKey = this.fillKey_;
        this.saveTextStates_();
        const pixelRatio = this.pixelRatio;
        const baseline = $9a4fd6d4219c35cc$export$91a016276e4aee96[textState.textBaseline];
        const offsetY = this.textOffsetY_ * pixelRatio;
        const text = this.text_;
        const strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
        this.instructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1,
            this.declutterMode_,
            this.textKeepUpright_
        ]);
        this.hitDetectionInstructions.push([
            (0, $85fee81af64d076c$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey ? (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2) : fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1 / pixelRatio,
            this.declutterMode_,
            this.textKeepUpright_
        ]);
    }
    /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setTextStyle(textStyle, sharedData) {
        let textState, fillState, strokeState;
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            } else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ {};
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = (0, $f23531dbd6538933$export$dc5b1400ac3a10a8)(textFillStyle.getColor() || (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2));
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            } else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                    this.textStrokeState_ = strokeState;
                }
                const lineDash = textStrokeStyle.getLineDash();
                const lineDashOffset = textStrokeStyle.getLineDashOffset();
                const lineWidth = textStrokeStyle.getWidth();
                const miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $56d5de32f563e6ab$export$17bd0c38d6ae694e);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, $56d5de32f563e6ab$export$e21b4112fdc612fc);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $56d5de32f563e6ab$export$e06efc2409049f76) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $56d5de32f563e6ab$export$365eb9648cf19bd0);
                strokeState.lineWidth = lineWidth === undefined ? (0, $56d5de32f563e6ab$export$79661f132c62010e) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, $56d5de32f563e6ab$export$80c1c01844597b7b) : miterLimit;
                strokeState.strokeStyle = (0, $f23531dbd6538933$export$dc5b1400ac3a10a8)(textStrokeStyle.getColor() || (0, $56d5de32f563e6ab$export$1eb2eaecacf2031e));
            }
            textState = this.textState_;
            const font = textStyle.getFont() || (0, $56d5de32f563e6ab$export$3847dfea4f8d4dfa);
            (0, $56d5de32f563e6ab$export$a534074a28fa87ff)(font);
            const textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.repeat = textStyle.getRepeat();
            textState.justify = textStyle.getJustify();
            textState.textBaseline = textStyle.getTextBaseline() || (0, $56d5de32f563e6ab$export$cf2279a1bff62eb);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, $56d5de32f563e6ab$export$40a9eeef55665a40);
            textState.scale = textScale === undefined ? [
                1,
                1
            ] : textScale;
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textKeepUpright = textStyle.getKeepUpright();
            const textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || '';
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textKeepUpright_ = textKeepUpright === undefined ? true : textKeepUpright;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' : '';
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?') + (textState.repeat || '?') + (textState.justify || '?') + (textState.textBaseline || '?');
            this.fillKey_ = fillState && fillState.fillStyle ? typeof fillState.fillStyle == 'string' ? fillState.fillStyle : '|' + (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(fillState.fillStyle) : '';
        }
        this.declutterMode_ = textStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $9a4fd6d4219c35cc$export$2e2bcd8739ae039 = $9a4fd6d4219c35cc$var$CanvasTextBuilder;


/**
 * @type {Object<import("../canvas.js").BuilderType, typeof Builder>}
 */ const $4af8752efda127f4$var$BATCH_CONSTRUCTORS = {
    'Circle': (0, $7881f606c7c570a3$export$2e2bcd8739ae039),
    'Default': (0, $1902c50a9e942aa9$export$2e2bcd8739ae039),
    'Image': (0, $0183db6fb2a0b745$export$2e2bcd8739ae039),
    'LineString': (0, $06f222f508042c61$export$2e2bcd8739ae039),
    'Polygon': (0, $7881f606c7c570a3$export$2e2bcd8739ae039),
    'Text': (0, $9a4fd6d4219c35cc$export$2e2bcd8739ae039)
};
class $4af8752efda127f4$var$BuilderGroup {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        /**
     * @private
     * @type {number}
     */ this.tolerance_ = tolerance;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {!Object<string, !Object<import("../canvas.js").BuilderType, Builder>>}
     */ this.buildersByZIndex_ = {};
    }
    /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */ finish() {
        const builderInstructions = {};
        for(const zKey in this.buildersByZIndex_){
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            const builders = this.buildersByZIndex_[zKey];
            for(const builderKey in builders){
                const builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    }
    /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */ getBuilder(zIndex, builderType) {
        const zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
        let replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        let replay = replays[builderType];
        if (replay === undefined) {
            const Constructor = $4af8752efda127f4$var$BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    }
}
var $4af8752efda127f4$export$2e2bcd8739ae039 = $4af8752efda127f4$var$BuilderGroup;


/**
 * @module ol/render/canvas/ExecutorGroup
 */ 





/**
 * @module ol/render/canvas/Executor
 */ 

/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $c8b5172932bfde43$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    let length = 0;
    for(let i = offset + stride; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $c8b5172932bfde43$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    let perimeter = $c8b5172932bfde43$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    const dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    const dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}


/**
 * @module ol/geom/flat/textpath
 */ 

function $66fb2c2c950cc14d$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation, keepUpright = true) {
    let x2 = flatCoordinates[offset];
    let y2 = flatCoordinates[offset + 1];
    let x1 = 0;
    let y1 = 0;
    let segmentLength = 0;
    let segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    let interpolate = segmentLength === 0 ? 0 : (startM - segmentM) / segmentLength;
    const beginX = (0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const beginY = (0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    const startOffset = offset - stride;
    const startLength = segmentM;
    const endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = segmentLength === 0 ? 0 : (endM - segmentM) / segmentLength;
    const endX = (0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const endY = (0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    // Keep text upright if the option is selected
    let reverse = false;
    if (keepUpright) {
        if (rotation) {
            const flat = [
                beginX,
                beginY,
                endX,
                endY
            ];
            (0, $437d3763a798775b$export$bb628a54ab399bc9)(flat, 0, 4, 2, rotation, flat, flat);
            reverse = flat[0] > flat[2];
        } else reverse = beginX > endX;
    }
    const PI = Math.PI;
    const result = [];
    const singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    let previousAngle;
    // All on the same segment
    if (singleSegment) {
        advance();
        previousAngle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle += previousAngle > 0 ? -PI : PI;
        const x = (endX + beginX) / 2;
        const y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle,
            text
        ];
        return result;
    }
    // rendering across line segments
    text = text.replace(/\n/g, ' '); // ensure rendering in single-line as all calculations below don't handle multi-lines
    for(let i = 0, ii = text.length; i < ii;){
        advance();
        let angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            let delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        const iStart = i;
        let charLength = 0;
        for(; i < ii; ++i){
            const index = reverse ? ii - i - 1 : i;
            const len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        const chars = reverse ? text.substring(ii - iStart, ii - i) : text.substring(iStart, i);
        interpolate = segmentLength === 0 ? 0 : (startM + charLength / 2 - segmentM) / segmentLength;
        const x = (0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
        const y = (0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
        result.push([
            x,
            y,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}








/**
 * @typedef {import('../../structs/RBush.js').Entry<import('../../Feature.js').FeatureLike>} DeclutterEntry
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {DeclutterEntry} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */ /**
 * @typedef {{0: CanvasRenderingContext2D, 1: import('../../size.js').Size, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, import("../../style/Style.js").DeclutterMode): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ const $c8039ff3843f13d6$var$tmpExtent = (0, $110ceb23457e07e7$export$fe201bb3bbe031e9)();
/** @type {import("../../coordinate.js").Coordinate} */ const $c8039ff3843f13d6$var$p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $c8039ff3843f13d6$var$p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $c8039ff3843f13d6$var$p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $c8039ff3843f13d6$var$p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {DeclutterEntry} Declutter rbush entry.
 */ function $c8039ff3843f13d6$var$getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
const $c8039ff3843f13d6$var$rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ '[' + String.fromCharCode(0x00591) + '-' + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + '-' + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + '-' + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + '-' + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + '-' + String.fromCharCode(0x1efff) + ']');
/**
 * @param {string} text Text.
 * @param {CanvasTextAlign} align Alignment.
 * @return {number} Text alignment.
 */ function $c8039ff3843f13d6$var$horizontalTextAlign(text, align) {
    if (align === 'start') align = $c8039ff3843f13d6$var$rtlRegEx.test(text) ? 'right' : 'left';
    else if (align === 'end') align = $c8039ff3843f13d6$var$rtlRegEx.test(text) ? 'left' : 'right';
    return (0, $9a4fd6d4219c35cc$export$91a016276e4aee96)[align];
}
/**
 * @param {Array<string>} acc Accumulator.
 * @param {string} line Line of text.
 * @param {number} i Index
 * @return {Array<string>} Accumulator.
 */ function $c8039ff3843f13d6$var$createTextChunks(acc, line, i) {
    if (i > 0) acc.push('\n', '');
    acc.push(line, '');
    return acc;
}
/**
 * Converts rich text to plain text for text along lines.
 * @param {string} result The resulting plain text.
 * @param {string} part Item of the rich text array.
 * @param {number} index Index of the item in the rich text array.
 * @return {string} The resulting plain text.
 */ function $c8039ff3843f13d6$var$richTextToPlainText(result, part, index) {
    if (index % 2 === 0) result += part;
    return result;
}
class $c8039ff3843f13d6$var$Executor {
    /**
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The replay can have overlapping geometries.
   * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions.
   * @param {boolean} [deferredRendering] Enable deferred rendering.
   */ constructor(resolution, pixelRatio, overlaps, instructions, deferredRendering){
        /**
     * @protected
     * @type {boolean}
     */ this.overlaps = overlaps;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {number}
     */ this.alignAndScaleFill_;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = instructions.instructions;
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = instructions.coordinates;
        /**
     * @private
     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
     */ this.coordinateCache_ = {};
        /**
     * @private
     * @type {!import("../../transform.js").Transform}
     */ this.renderedTransform_ = (0, $a684e03243281d90$export$185802fd694ee1f5)();
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = null;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = 0;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = instructions.fillStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = instructions.strokeStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = instructions.textStates || {};
        /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */ this.widths_ = {};
        /**
     * @private
     * @type {Object<string, import("../canvas.js").Label>}
     */ this.labels_ = {};
        /**
     * @private
     * @type {import("../canvas/ZIndexContext.js").default}
     */ this.zIndexContext_ = deferredRendering ? new (0, $5ae37123888c860e$export$2e2bcd8739ae039)() : null;
    }
    /**
   * @return {ZIndexContext} ZIndex context.
   */ getZIndexContext() {
        return this.zIndexContext_;
    }
    /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */ createLabel(text, textKey, fillKey, strokeKey) {
        const key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) return this.labels_[key];
        const strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        const fillState = fillKey ? this.fillStates[fillKey] : null;
        const textState = this.textStates[textKey];
        const pixelRatio = this.pixelRatio;
        const scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio
        ];
        const align = textState.justify ? (0, $9a4fd6d4219c35cc$export$91a016276e4aee96)[textState.justify] : $c8039ff3843f13d6$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $56d5de32f563e6ab$export$94d53b95641b5766));
        const strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        const chunks = Array.isArray(text) ? text : String(text).split('\n').reduce($c8039ff3843f13d6$var$createTextChunks, []);
        const { width: width, height: height, widths: widths, heights: heights, lineWidths: lineWidths } = (0, $56d5de32f563e6ab$export$7d7c13020df1e791)(textState, chunks);
        const renderWidth = width + strokeWidth;
        const contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        const w = (renderWidth + 2) * scale[0];
        const h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */ const label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions
        };
        if (scale[0] != 1 || scale[1] != 1) contextInstructions.push('scale', scale);
        if (strokeKey) {
            contextInstructions.push('strokeStyle', strokeState.strokeStyle);
            contextInstructions.push('lineWidth', strokeWidth);
            contextInstructions.push('lineCap', strokeState.lineCap);
            contextInstructions.push('lineJoin', strokeState.lineJoin);
            contextInstructions.push('miterLimit', strokeState.miterLimit);
            contextInstructions.push('setLineDash', [
                strokeState.lineDash
            ]);
            contextInstructions.push('lineDashOffset', strokeState.lineDashOffset);
        }
        if (fillKey) contextInstructions.push('fillStyle', fillState.fillStyle);
        contextInstructions.push('textBaseline', 'middle');
        contextInstructions.push('textAlign', 'center');
        const leftRight = 0.5 - align;
        let x = align * renderWidth + leftRight * strokeWidth;
        const strokeInstructions = [];
        const fillInstructions = [];
        let lineHeight = 0;
        let lineOffset = 0;
        let widthHeightIndex = 0;
        let lineWidthIndex = 0;
        let previousFont;
        for(let i = 0, ii = chunks.length; i < ii; i += 2){
            const text = chunks[i];
            if (text === '\n') {
                lineOffset += lineHeight;
                lineHeight = 0;
                x = align * renderWidth + leftRight * strokeWidth;
                ++lineWidthIndex;
                continue;
            }
            const font = chunks[i + 1] || textState.font;
            if (font !== previousFont) {
                if (strokeKey) strokeInstructions.push('font', font);
                if (fillKey) fillInstructions.push('font', font);
                previousFont = font;
            }
            lineHeight = Math.max(lineHeight, heights[widthHeightIndex]);
            const fillStrokeArgs = [
                text,
                x + leftRight * widths[widthHeightIndex] + align * (widths[widthHeightIndex] - lineWidths[lineWidthIndex]),
                0.5 * (strokeWidth + lineHeight) + lineOffset
            ];
            x += widths[widthHeightIndex];
            if (strokeKey) strokeInstructions.push('strokeText', fillStrokeArgs);
            if (fillKey) fillInstructions.push('fillText', fillStrokeArgs);
            ++widthHeightIndex;
        }
        Array.prototype.push.apply(contextInstructions, strokeInstructions);
        Array.prototype.push.apply(contextInstructions, fillInstructions);
        this.labels_[key] = label;
        return label;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ replayTextBackground_(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignAndScaleFill_ = /** @type {number} */ fillInstruction[2];
            context.fillStyle = /** @type {string} */ fillInstruction[1];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    }
    /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */ calculateImageOrLabelDimensions_(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        let x = centerX - anchorX;
        let y = centerY - anchorY;
        const w = width + originX > sheetWidth ? sheetWidth - originX : width;
        const h = height + originY > sheetHeight ? sheetHeight - originY : height;
        const boxW = padding[3] + w * scale[0] + padding[1];
        const boxH = padding[0] + h * scale[1] + padding[2];
        const boxX = x - padding[3];
        const boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            $c8039ff3843f13d6$var$p1[0] = boxX;
            $c8039ff3843f13d6$var$p4[0] = boxX;
            $c8039ff3843f13d6$var$p1[1] = boxY;
            $c8039ff3843f13d6$var$p2[1] = boxY;
            $c8039ff3843f13d6$var$p2[0] = boxX + boxW;
            $c8039ff3843f13d6$var$p3[0] = $c8039ff3843f13d6$var$p2[0];
            $c8039ff3843f13d6$var$p3[1] = boxY + boxH;
            $c8039ff3843f13d6$var$p4[1] = $c8039ff3843f13d6$var$p3[1];
        }
        let transform;
        if (rotation !== 0) {
            transform = (0, $a684e03243281d90$export$f672e0b6f7222cd7)((0, $a684e03243281d90$export$185802fd694ee1f5)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(transform, $c8039ff3843f13d6$var$p1);
            (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(transform, $c8039ff3843f13d6$var$p2);
            (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(transform, $c8039ff3843f13d6$var$p3);
            (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(transform, $c8039ff3843f13d6$var$p4);
            (0, $110ceb23457e07e7$export$958e3e1a02eac4b6)(Math.min($c8039ff3843f13d6$var$p1[0], $c8039ff3843f13d6$var$p2[0], $c8039ff3843f13d6$var$p3[0], $c8039ff3843f13d6$var$p4[0]), Math.min($c8039ff3843f13d6$var$p1[1], $c8039ff3843f13d6$var$p2[1], $c8039ff3843f13d6$var$p3[1], $c8039ff3843f13d6$var$p4[1]), Math.max($c8039ff3843f13d6$var$p1[0], $c8039ff3843f13d6$var$p2[0], $c8039ff3843f13d6$var$p3[0], $c8039ff3843f13d6$var$p4[0]), Math.max($c8039ff3843f13d6$var$p1[1], $c8039ff3843f13d6$var$p2[1], $c8039ff3843f13d6$var$p3[1], $c8039ff3843f13d6$var$p4[1]), $c8039ff3843f13d6$var$tmpExtent);
        } else (0, $110ceb23457e07e7$export$958e3e1a02eac4b6)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), $c8039ff3843f13d6$var$tmpExtent);
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: $c8039ff3843f13d6$var$tmpExtent[0],
                minY: $c8039ff3843f13d6$var$tmpExtent[1],
                maxX: $c8039ff3843f13d6$var$tmpExtent[2],
                maxY: $c8039ff3843f13d6$var$tmpExtent[3],
                value: feature
            },
            canvasTransform: transform,
            scale: scale
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */ replayImageOrLabel_(context, scaledCanvasSize, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        const fillStroke = !!(fillInstruction || strokeInstruction);
        const box = dimensions.declutterBox;
        const strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
        const intersects = box.minX - strokePadding <= scaledCanvasSize[0] && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= scaledCanvasSize[1] && box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, $c8039ff3843f13d6$var$p1, $c8039ff3843f13d6$var$p2, $c8039ff3843f13d6$var$p3, $c8039ff3843f13d6$var$p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, $56d5de32f563e6ab$export$3cb6f3a6e49cc0ee)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   */ fill_(context) {
        const alignAndScale = this.alignAndScaleFill_;
        if (alignAndScale) {
            const origin = (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(this.renderedTransform_, [
                0,
                0
            ]);
            const repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
            if (alignAndScale !== 1) context.scale(alignAndScale, alignAndScale);
            context.rotate(this.viewRotation_);
        }
        context.fill();
        if (alignAndScale) context.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */ setStrokeStyle_(context, instruction) {
        context.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        context.lineDashOffset = /** @type {number} */ instruction[7];
        context.setLineDash(/** @type {Array<number>} */ instruction[6]);
    }
    /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */ drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey) {
        const textState = this.textStates[textKey];
        const label = this.createLabel(text, textKey, fillKey, strokeKey);
        const strokeState = this.strokeStates[strokeKey];
        const pixelRatio = this.pixelRatio;
        const align = $c8039ff3843f13d6$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $56d5de32f563e6ab$export$94d53b95641b5766));
        const baseline = (0, $9a4fd6d4219c35cc$export$91a016276e4aee96)[textState.textBaseline || (0, $56d5de32f563e6ab$export$cf2279a1bff62eb)];
        const strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        const width = label.width / pixelRatio - 2 * textState.scale[0];
        const anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        const anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */ execute_(context, scaledCanvasSize, transform, instructions, snapToPixel, featureCallback, hitExtent, declutterTree) {
        const zIndexContext = this.zIndexContext_;
        /** @type {Array<number>} */ let pixelCoordinates;
        if (this.pixelCoordinates_ && (0, $9d07dd9052c3de0c$export$e9bab7fafb253603)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, $437d3763a798775b$export$b92b2dedcfff79de)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, $a684e03243281d90$export$42b4187a82d80ed0)(this.renderedTransform_, transform);
        }
        let i = 0; // instruction index
        const ii = instructions.length; // end of instructions
        let d = 0; // data index
        let dd; // end of per-instruction data
        let anchorX, anchorY, /** @type {import('../../style/Style.js').DeclutterMode} */ declutterMode, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        let pendingFill = 0;
        let pendingStroke = 0;
        const coordinateCache = this.coordinateCache_;
        const viewRotation = this.viewRotation_;
        const viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        const state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        const batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        let /** @type {import("../../Feature.js").FeatureLike} */ feature;
        let x, y, currentGeometry;
        while(i < ii){
            const instruction = instructions[i];
            const type = /** @type {import("./Instruction.js").default} */ instruction[0];
            switch(type){
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (hitExtent !== undefined && !(0, $110ceb23457e07e7$export$7b0a31e10bbff018)(hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    if (zIndexContext) zIndexContext.zIndex = instruction[4];
                    break;
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    const x1 = pixelCoordinates[d];
                    const y1 = pixelCoordinates[d + 1];
                    const x2 = pixelCoordinates[d + 2];
                    const y2 = pixelCoordinates[d + 3];
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    const r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    const geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    const renderer = instruction[4];
                    const fn = instruction[5];
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    const coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    if (zIndexContext) zIndexContext.zIndex = instruction[6];
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    let height = /** @type {number} */ instruction[6];
                    const opacity = /** @type {number} */ instruction[7];
                    const originX = /** @type {number} */ instruction[8];
                    const originY = /** @type {number} */ instruction[9];
                    const rotateWithView = /** @type {boolean} */ instruction[10];
                    let rotation = /** @type {number} */ instruction[11];
                    const scale = /** @type {import("../../size.js").Size} */ instruction[12];
                    let width = /** @type {number} */ instruction[13];
                    declutterMode = instruction[14] || 'declutter';
                    const declutterImageWithText = /** @type {{args: import("../canvas.js").DeclutterImageWithText, declutterMode: import('../../style/Style.js').DeclutterMode}} */ instruction[15];
                    if (!image && instruction.length >= 20) {
                        // create label images
                        text = /** @type {string} */ instruction[19];
                        textKey = /** @type {string} */ instruction[20];
                        strokeKey = /** @type {string} */ instruction[21];
                        fillKey = /** @type {string} */ instruction[22];
                        const labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        const textOffsetX = /** @type {number} */ instruction[23];
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        const textOffsetY = /** @type {number} */ instruction[24];
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    let geometryWidths;
                    if (instruction.length > 25) geometryWidths = /** @type {number} */ instruction[25];
                    let padding, backgroundFillInstruction, backgroundStrokeInstruction;
                    if (instruction.length > 17) {
                        padding = /** @type {Array<number>} */ instruction[16];
                        backgroundFillInstruction = /** @type {Array<*>} */ instruction[17];
                        backgroundStrokeInstruction = /** @type {Array<*>} */ instruction[18];
                    } else {
                        padding = (0, $56d5de32f563e6ab$export$40a9eeef55665a40);
                        backgroundFillInstruction = null;
                        backgroundStrokeInstruction = null;
                    }
                    if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                    rotation += viewRotation;
                    else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                    rotation -= viewRotation;
                    let widthIndex = 0;
                    for(; d < dd; d += 2){
                        if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                        const dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, !!backgroundFillInstruction || !!backgroundStrokeInstruction, feature);
                        /** @type {ReplayImageOrLabelArgs} */ const args = [
                            context,
                            scaledCanvasSize,
                            image,
                            dimensions,
                            opacity,
                            backgroundFillInstruction,
                            backgroundStrokeInstruction
                        ];
                        if (declutterTree) {
                            let imageArgs, imageDeclutterMode, imageDeclutterBox;
                            if (declutterImageWithText) {
                                const index = dd - d;
                                if (!declutterImageWithText[index]) {
                                    // We now have the image for an image+text combination.
                                    declutterImageWithText[index] = {
                                        args: args,
                                        declutterMode: declutterMode
                                    };
                                    continue;
                                }
                                const imageDeclutter = declutterImageWithText[index];
                                imageArgs = imageDeclutter.args;
                                imageDeclutterMode = imageDeclutter.declutterMode;
                                delete declutterImageWithText[index];
                                imageDeclutterBox = $c8039ff3843f13d6$var$getDeclutterBox(imageArgs);
                            }
                            // We now have image and text for an image+text combination.
                            let renderImage, renderText;
                            if (imageArgs && (imageDeclutterMode !== 'declutter' || !declutterTree.collides(imageDeclutterBox))) renderImage = true;
                            if (declutterMode !== 'declutter' || !declutterTree.collides(dimensions.declutterBox)) renderText = true;
                            if (imageDeclutterMode === 'declutter' && declutterMode === 'declutter') {
                                const render = renderImage && renderText;
                                renderImage = render;
                                renderText = render;
                            }
                            if (renderImage) {
                                if (imageDeclutterMode !== 'none') declutterTree.insert(imageDeclutterBox);
                                this.replayImageOrLabel_.apply(this, imageArgs);
                            }
                            if (renderText) {
                                if (declutterMode !== 'none') declutterTree.insert(dimensions.declutterBox);
                                this.replayImageOrLabel_.apply(this, args);
                            }
                        } else this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).DRAW_CHARS:
                    const begin = /** @type {number} */ instruction[1];
                    const end = /** @type {number} */ instruction[2];
                    const baseline = /** @type {number} */ instruction[3];
                    const overflow = /** @type {number} */ instruction[4];
                    fillKey = /** @type {string} */ instruction[5];
                    const maxAngle = /** @type {number} */ instruction[6];
                    const measurePixelRatio = /** @type {number} */ instruction[7];
                    const offsetY = /** @type {number} */ instruction[8];
                    strokeKey = /** @type {string} */ instruction[9];
                    const strokeWidth = /** @type {number} */ instruction[10];
                    text = /** @type {string|Array<string>} */ instruction[11];
                    if (Array.isArray(text)) //FIXME Add support for rich text along lines
                    text = text.reduce($c8039ff3843f13d6$var$richTextToPlainText, '');
                    textKey = /** @type {string} */ instruction[12];
                    const pixelRatioScale = [
                        /** @type {number} */ instruction[13],
                        /** @type {number} */ instruction[13]
                    ];
                    declutterMode = instruction[14] || 'declutter';
                    const textKeepUpright = /** @type {boolean} */ instruction[15];
                    const textState = this.textStates[textKey];
                    const font = textState.font;
                    const textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio
                    ];
                    let cachedWidths;
                    if (font in this.widths_) cachedWidths = this.widths_[font];
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    const pathLength = (0, $c8b5172932bfde43$export$153f8c6b4d8caebc)(pixelCoordinates, begin, end, 2);
                    const textLength = Math.abs(textScale[0]) * (0, $56d5de32f563e6ab$export$915c7ba51467308f)(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        const textAlign = this.textStates[textKey].textAlign;
                        const startM = (pathLength - textLength) * $c8039ff3843f13d6$var$horizontalTextAlign(text, textAlign);
                        const parts = (0, $66fb2c2c950cc14d$export$153a9a17ab3e949f)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, $56d5de32f563e6ab$export$915c7ba51467308f), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_, textKeepUpright);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */ const replayImageOrLabelArgs = [];
                            let c, cc, chars, label, part;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, '', strokeKey);
                                anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $56d5de32f563e6ab$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, fillKey, '');
                                anchorX = /** @type {number} */ part[2];
                                anchorY = baseline * label.height - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $56d5de32f563e6ab$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (declutterTree && declutterMode !== 'none') declutterTree.load(replayImageOrLabelArgs.map($c8039ff3843f13d6$var$getDeclutterBox));
                            for(let i = 0, ii = replayImageOrLabelArgs.length; i < ii; ++i)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i]);
                        }
                    }
                    ++i;
                    break;
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                        const result = featureCallback(feature, currentGeometry, declutterMode);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    context.moveTo(x, y);
                    prevX = x + 0.5 | 0;
                    prevY = y + 0.5 | 0;
                    for(d += 2; d < dd; d += 2){
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).SET_FILL_STYLE:
                    this.alignAndScaleFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }
                    /** @type {import("../../colorlike.js").ColorLike} */ context.fillStyle = instruction[1];
                    ++i;
                    break;
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).SET_STROKE_STYLE:
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, $85fee81af64d076c$export$2e2bcd8739ae039).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i;
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   */ execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, scaledCanvasSize, transform, this.instructions, snapToPixel, undefined, undefined, declutterTree);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ executeHitDetection(context, transform, viewRotation, featureCallback, hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, [
            context.canvas.width,
            context.canvas.height
        ], transform, this.hitDetectionInstructions, true, featureCallback, hitExtent);
    }
}
var $c8039ff3843f13d6$export$2e2bcd8739ae039 = $c8039ff3843f13d6$var$Executor;


const $e8088b2dfa7545b9$export$61b49a5ae59d663 = [
    'Polygon',
    'Circle',
    'LineString',
    'Image',
    'Text',
    'Default'
];
const $e8088b2dfa7545b9$export$6195a93a6c97ce02 = [
    'Image',
    'Text'
];
const $e8088b2dfa7545b9$export$d0fe61ccfaa1ca87 = $e8088b2dfa7545b9$export$61b49a5ae59d663.filter((builderType)=>!$e8088b2dfa7545b9$export$6195a93a6c97ce02.includes(builderType));
class $e8088b2dfa7545b9$var$ExecutorGroup {
    /**
   * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
   * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
   * should be set here, unless the target context does not exceed that extent (which
   * can be the case when rendering to tiles).
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The executor group can have overlapping geometries.
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
   * The serializable instructions.
   * @param {number} [renderBuffer] Optional rendering buffer.
   * @param {boolean} [deferredRendering] Enable deferred rendering with renderDeferred().
   */ constructor(maxExtent, resolution, pixelRatio, overlaps, allInstructions, renderBuffer, deferredRendering){
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = overlaps;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderBuffer_ = renderBuffer;
        /**
     * @private
     * @type {!Object<string, !Object<string, import("./Executor").default>>}
     */ this.executorsByZIndex_ = {};
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.hitDetectionContext_ = null;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.hitDetectionTransform_ = (0, $a684e03243281d90$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.renderedContext_ = null;
        /**
     * @private
     * @type {Object<number, Array<import("./ZIndexContext.js").default>>}
     */ this.deferredZIndexContexts_ = {};
        this.createExecutors_(allInstructions, deferredRendering);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */ clip(context, transform) {
        const flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    }
    /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<string, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   * @param {boolean} deferredRendering Enable deferred rendering.
   */ createExecutors_(allInstructions, deferredRendering) {
        for(const zIndex in allInstructions){
            let executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            const instructionByZindex = allInstructions[zIndex];
            for(const builderType in instructionByZindex){
                const instructions = instructionByZindex[builderType];
                executors[builderType] = new (0, $c8039ff3843f13d6$export$2e2bcd8739ae039)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions, deferredRendering);
            }
        }
    }
    /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */ hasExecutors(executors) {
        for(const zIndex in this.executorsByZIndex_){
            const candidates = this.executorsByZIndex_[zIndex];
            for(let i = 0, ii = executors.length; i < ii; ++i){
                if (executors[i] in candidates) return true;
            }
        }
        return false;
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        hitTolerance = Math.round(hitTolerance);
        const contextSize = hitTolerance * 2 + 1;
        const transform = (0, $a684e03243281d90$export$f672e0b6f7222cd7)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        const newContext = !this.hitDetectionContext_;
        if (newContext) this.hitDetectionContext_ = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(contextSize, contextSize);
        const context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
        /** @type {import("../../extent.js").Extent|undefined} */ let hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, $110ceb23457e07e7$export$fe201bb3bbe031e9)();
            (0, $110ceb23457e07e7$export$1f820e3920fa5715)(hitExtent, coordinate);
            (0, $110ceb23457e07e7$export$ab1029bcae9ddb4a)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        const indexes = $e8088b2dfa7545b9$export$96fc84ea21b8269f(hitTolerance);
        /** @type {import("../canvas.js").BuilderType} */ let builderType;
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import('../../style/Style.js').DeclutterMode} declutterMode Declutter mode.
     * @return {T|undefined} Callback result.
     */ function featureCallback(feature, geometry, declutterMode) {
            const imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(let i = 0, ii = indexes.length; i < ii; i++)if (imageData[indexes[i]] > 0) {
                if (!declutteredFeatures || declutterMode === 'none' || builderType !== 'Image' && builderType !== 'Text' || declutteredFeatures.includes(feature)) {
                    const idx = (indexes[i] - 3) / 4;
                    const x = hitTolerance - idx % contextSize;
                    const y = hitTolerance - (idx / contextSize | 0);
                    const result = callback(feature, geometry, x * x + y * y);
                    if (result) return result;
                }
                context.clearRect(0, 0, contextSize, contextSize);
                break;
            }
            return undefined;
        }
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $9d07dd9052c3de0c$export$fcb633242ef15540));
        let i, j, executors, executor, result;
        for(i = zs.length - 1; i >= 0; --i){
            const zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for(j = $e8088b2dfa7545b9$export$61b49a5ae59d663.length - 1; j >= 0; --j){
                builderType = $e8088b2dfa7545b9$export$61b49a5ae59d663[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) return result;
                }
            }
        }
        return undefined;
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */ getClipCoords(transform) {
        const maxExtent = this.maxExtent_;
        if (!maxExtent) return null;
        const minX = maxExtent[0];
        const minY = maxExtent[1];
        const maxX = maxExtent[2];
        const maxY = maxExtent[3];
        const flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, $437d3763a798775b$export$b92b2dedcfff79de)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $0364d4893e3f1129$export$dd1bc94b04021eeb)(this.executorsByZIndex_);
    }
    /**
   * @param {CanvasRenderingContext2D} targetContext Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ALL}
   * @param {import("rbush").default<import('./Executor.js').DeclutterEntry>|null} [declutterTree] Declutter tree.
   *     When set to null, no decluttering is done, even when the executor group has a `ZIndexContext`.
   */ execute(targetContext, scaledCanvasSize, transform, viewRotation, snapToPixel, builderTypes, declutterTree) {
        const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort(declutterTree ? (0, $9d07dd9052c3de0c$export$4fa3190a997c3d8f) : (0, $9d07dd9052c3de0c$export$fcb633242ef15540));
        builderTypes = builderTypes ? builderTypes : $e8088b2dfa7545b9$export$61b49a5ae59d663;
        const maxBuilderTypes = $e8088b2dfa7545b9$export$61b49a5ae59d663.length;
        for(let i = 0, ii = zs.length; i < ii; ++i){
            const zIndexKey = zs[i].toString();
            const replays = this.executorsByZIndex_[zIndexKey];
            for(let j = 0, jj = builderTypes.length; j < jj; ++j){
                const builderType = builderTypes[j];
                const replay = replays[builderType];
                if (replay !== undefined) {
                    const zIndexContext = declutterTree === null ? undefined : replay.getZIndexContext();
                    const context = zIndexContext ? zIndexContext.getContext() : targetContext;
                    const requireClip = this.maxExtent_ && builderType !== 'Image' && builderType !== 'Text';
                    if (requireClip) {
                        context.save();
                        // setup clipping so that the parts of over-simplified geometries are not
                        // visible outside the current extent when panning
                        this.clip(context, transform);
                    }
                    if (!zIndexContext || builderType === 'Text' || builderType === 'Image') replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree);
                    else zIndexContext.pushFunction((context)=>replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree));
                    if (requireClip) context.restore();
                    if (zIndexContext) {
                        zIndexContext.offset();
                        const index = zs[i] * maxBuilderTypes + j;
                        if (!this.deferredZIndexContexts_[index]) this.deferredZIndexContexts_[index] = [];
                        this.deferredZIndexContexts_[index].push(zIndexContext);
                    }
                }
            }
        }
        this.renderedContext_ = targetContext;
    }
    getDeferredZIndexContexts() {
        return this.deferredZIndexContexts_;
    }
    getRenderedContext() {
        return this.renderedContext_;
    }
    renderDeferred() {
        const deferredZIndexContexts = this.deferredZIndexContexts_;
        const zs = Object.keys(deferredZIndexContexts).map(Number).sort((0, $9d07dd9052c3de0c$export$fcb633242ef15540));
        for(let i = 0, ii = zs.length; i < ii; ++i){
            deferredZIndexContexts[zs[i]].forEach((zIndexContext)=>{
                zIndexContext.draw(this.renderedContext_); // FIXME Pass clip to replay for temporarily enabling clip
                zIndexContext.clear();
            });
            deferredZIndexContexts[zs[i]].length = 0;
        }
    }
}
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ const $e8088b2dfa7545b9$var$circlePixelIndexArrayCache = {};
function $e8088b2dfa7545b9$export$96fc84ea21b8269f(radius) {
    if ($e8088b2dfa7545b9$var$circlePixelIndexArrayCache[radius] !== undefined) return $e8088b2dfa7545b9$var$circlePixelIndexArrayCache[radius];
    const size = radius * 2 + 1;
    const maxDistanceSq = radius * radius;
    const distances = new Array(maxDistanceSq + 1);
    for(let i = 0; i <= radius; ++i)for(let j = 0; j <= radius; ++j){
        const distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        let distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    const pixelIndex = [];
    for(let i = 0, ii = distances.length; i < ii; ++i)if (distances[i]) pixelIndex.push(...distances[i]);
    $e8088b2dfa7545b9$var$circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
var $e8088b2dfa7545b9$export$2e2bcd8739ae039 = $e8088b2dfa7545b9$var$ExecutorGroup;



/**
 * @module ol/render/canvas/hitdetect
 */ 





/**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?









/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ class $97d00c7889291dab$var$CanvasImmediateRenderer extends (0, $5d8b19280979766d$export$2e2bcd8739ae039) {
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [userTransform] Transform from user to view projection.
   */ constructor(context, pixelRatio, extent, transform, viewRotation, squaredTolerance, userTransform){
        super();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.context_ = context;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.extent_ = extent;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = transform;
        /**
     * @private
     * @type {number}
     */ this.transformRotation_ = transform ? (0, $91ceb5420a5c8360$export$a81f732198733497)(Math.atan2(transform[1], transform[0]), 10) : 0;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = viewRotation;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_ = squaredTolerance;
        /**
     * @private
     * @type {import("../../proj.js").TransformFunction}
     */ this.userTransform_ = userTransform;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.contextFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.contextStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.contextTextState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.fillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.strokeState_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorY_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageHeight_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOpacity_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.imageRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.imageRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.imageScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.imageWidth_ = 0;
        /**
     * @private
     * @type {string}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.textRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.textScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.textState_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = [];
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpLocalTransform_ = (0, $a684e03243281d90$export$185802fd694ee1f5)();
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawImages_(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        const pixelCoordinates = (0, $437d3763a798775b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        const localTransform = this.tmpLocalTransform_;
        const alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        let rotation = this.imageRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(let i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            const x = pixelCoordinates[i] - this.imageAnchorX_;
            const y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                const centerX = x + this.imageAnchorX_;
                const centerY = y + this.imageAnchorY_;
                (0, $a684e03243281d90$export$f672e0b6f7222cd7)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.save();
                context.transform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.restore();
            } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawText_(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === '') return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        const pixelCoordinates = (0, $437d3763a798775b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        let rotation = this.textRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            const x = pixelCoordinates[offset] + this.textOffsetX_;
            const y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                context.save();
                context.translate(x - this.textOffsetX_, y - this.textOffsetY_);
                context.rotate(rotation);
                context.translate(this.textOffsetX_, this.textOffsetY_);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                if (this.textFillState_) context.fillText(this.text_, 0, 0);
                context.restore();
            } else {
                if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                if (this.textFillState_) context.fillText(this.text_, x, y);
            }
        }
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @private
   * @return {number} end End.
   */ moveToLineTo_(flatCoordinates, offset, end, stride, close) {
        const context = this.context_;
        const pixelCoordinates = (0, $437d3763a798775b$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        let length = pixelCoordinates.length;
        if (close) length -= 2;
        for(let i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ drawRings_(flatCoordinates, offset, ends, stride) {
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
        return offset;
    }
    /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   * @override
   */ drawCircle(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Circle.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $110ceb23457e07e7$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const pixelCoordinates = (0, $2d119a5aa713a216$export$a3767472617c7861)(geometry, this.transform_, this.pixelCoordinates_);
            const dx = pixelCoordinates[2] - pixelCoordinates[0];
            const dy = pixelCoordinates[3] - pixelCoordinates[1];
            const radius = Math.sqrt(dx * dx + dy * dy);
            const context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') this.drawText_(geometry.getCenter(), 0, 2, 2);
    }
    /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   * @override
   */ setStyle(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */ setTransform(transform) {
        this.transform_ = transform;
    }
    /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   * @override
   */ drawGeometry(geometry) {
        const type = geometry.getType();
        switch(type){
            case 'Point':
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case 'LineString':
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case 'Polygon':
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case 'MultiPoint':
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case 'MultiLineString':
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case 'MultiPolygon':
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case 'GeometryCollection':
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case 'Circle':
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    }
    /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   * @override
   */ drawFeature(feature, style) {
        const geometry = style.getGeometryFunction()(feature);
        if (!geometry) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    }
    /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   * @override
   */ drawGeometryCollection(geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    }
    /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   * @override
   */ drawPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   * @override
   */ drawMultiPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   * @override
   */ drawLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $110ceb23457e07e7$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    }
    /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   * @override
   */ drawMultiLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const geometryExtent = geometry.getExtent();
        if (!(0, $110ceb23457e07e7$export$7b0a31e10bbff018)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            let offset = 0;
            const ends = /** @type {Array<number>} */ geometry.getEnds();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    }
    /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   * @override
   */ drawPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $110ceb23457e07e7$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride());
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    }
    /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   * @override
   */ drawMultiPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $110ceb23457e07e7$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getOrientedFlatCoordinates();
            let offset = 0;
            const endss = geometry.getEndss();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = endss.length; i < ii; ++i){
                const ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    }
    /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */ setContextFillState_(fillState) {
        const context = this.context_;
        const contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) {
            contextFillState.fillStyle = fillState.fillStyle;
            context.fillStyle = fillState.fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */ setContextStrokeState_(strokeState) {
        const context = this.context_;
        const contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            context.setLineDash(strokeState.lineDash);
            context.lineDashOffset = strokeState.lineDashOffset;
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (!(0, $9d07dd9052c3de0c$export$e9bab7fafb253603)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
            if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    }
    /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */ setContextTextState_(textState) {
        const context = this.context_;
        const contextTextState = this.contextTextState_;
        const textAlign = textState.textAlign ? textState.textAlign : (0, $56d5de32f563e6ab$export$94d53b95641b5766);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = textAlign;
            context.textBaseline = textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = textAlign;
                context.textAlign = textAlign;
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = textState.textBaseline;
                context.textBaseline = textState.textBaseline;
            }
        }
    }
    /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        if (!fillStyle) this.fillState_ = null;
        else {
            const fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, $f23531dbd6538933$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            const strokeStyleColor = strokeStyle.getColor();
            const strokeStyleLineCap = strokeStyle.getLineCap();
            const strokeStyleLineDash = strokeStyle.getLineDash();
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            const strokeStyleWidth = strokeStyle.getWidth();
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            const lineDash = strokeStyleLineDash ? strokeStyleLineDash : (0, $56d5de32f563e6ab$export$e21b4112fdc612fc);
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $56d5de32f563e6ab$export$17bd0c38d6ae694e),
                lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map((n)=>n * this.pixelRatio_),
                lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $56d5de32f563e6ab$export$e06efc2409049f76)) * this.pixelRatio_,
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $56d5de32f563e6ab$export$365eb9648cf19bd0),
                lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $56d5de32f563e6ab$export$79661f132c62010e)) * this.pixelRatio_,
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $56d5de32f563e6ab$export$80c1c01844597b7b),
                strokeStyle: (0, $f23531dbd6538933$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $56d5de32f563e6ab$export$1eb2eaecacf2031e))
            };
        }
    }
    /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @override
   */ setImageStyle(imageStyle) {
        let imageSize;
        if (!imageStyle || !(imageSize = imageStyle.getSize())) {
            this.image_ = null;
            return;
        }
        const imagePixelRatio = imageStyle.getPixelRatio(this.pixelRatio_);
        const imageAnchor = imageStyle.getAnchor();
        const imageOrigin = imageStyle.getOrigin();
        this.image_ = imageStyle.getImage(this.pixelRatio_);
        this.imageAnchorX_ = imageAnchor[0] * imagePixelRatio;
        this.imageAnchorY_ = imageAnchor[1] * imagePixelRatio;
        this.imageHeight_ = imageSize[1] * imagePixelRatio;
        this.imageOpacity_ = imageStyle.getOpacity();
        this.imageOriginX_ = imageOrigin[0];
        this.imageOriginY_ = imageOrigin[1];
        this.imageRotateWithView_ = imageStyle.getRotateWithView();
        this.imageRotation_ = imageStyle.getRotation();
        const imageScale = imageStyle.getScaleArray();
        this.imageScale_ = [
            imageScale[0] * this.pixelRatio_ / imagePixelRatio,
            imageScale[1] * this.pixelRatio_ / imagePixelRatio
        ];
        this.imageWidth_ = imageSize[0] * imagePixelRatio;
    }
    /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @override
   */ setTextStyle(textStyle) {
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                const textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, $f23531dbd6538933$export$dc5b1400ac3a10a8)(textFillStyleColor ? textFillStyleColor : (0, $56d5de32f563e6ab$export$c495d52ee3fd74b2))
                };
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                const textStrokeStyleColor = textStrokeStyle.getColor();
                const textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                const textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                const textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                const textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                const textStrokeStyleWidth = textStrokeStyle.getWidth();
                const textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $56d5de32f563e6ab$export$17bd0c38d6ae694e),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $56d5de32f563e6ab$export$e21b4112fdc612fc),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $56d5de32f563e6ab$export$e06efc2409049f76),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $56d5de32f563e6ab$export$365eb9648cf19bd0),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $56d5de32f563e6ab$export$79661f132c62010e),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $56d5de32f563e6ab$export$80c1c01844597b7b),
                    strokeStyle: (0, $f23531dbd6538933$export$dc5b1400ac3a10a8)(textStrokeStyleColor ? textStrokeStyleColor : (0, $56d5de32f563e6ab$export$1eb2eaecacf2031e))
                };
            }
            const textFont = textStyle.getFont();
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            const textScale = textStyle.getScaleArray();
            const textText = textStyle.getText();
            const textTextAlign = textStyle.getTextAlign();
            const textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, $56d5de32f563e6ab$export$3847dfea4f8d4dfa),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, $56d5de32f563e6ab$export$94d53b95641b5766),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $56d5de32f563e6ab$export$cf2279a1bff62eb)
            };
            this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce((acc, t, i)=>acc += i % 2 ? ' ' : t, '') : textText : '';
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1]
            ];
        }
    }
}
var $97d00c7889291dab$export$2e2bcd8739ae039 = $97d00c7889291dab$var$CanvasImmediateRenderer;


const $e4a1dc4cab3ca6fc$export$ab51038298418f25 = 0.5;
function $e4a1dc4cab3ca6fc$export$bd05e394339d469(size, transforms, features, styleFunction, extent, resolution, rotation, squaredTolerance, projection) {
    const userExtent = projection ? (0, $d447c151baf41c8c$export$96bfd09e2cffb006)(extent, projection) : extent;
    const width = size[0] * $e4a1dc4cab3ca6fc$export$ab51038298418f25;
    const height = size[1] * $e4a1dc4cab3ca6fc$export$ab51038298418f25;
    const context = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(width, height);
    context.imageSmoothingEnabled = false;
    const canvas = context.canvas;
    const renderer = new (0, $97d00c7889291dab$export$2e2bcd8739ae039)(context, $e4a1dc4cab3ca6fc$export$ab51038298418f25, extent, null, rotation, squaredTolerance, projection ? (0, $d447c151baf41c8c$export$e3c4995a701c26a3)((0, $d447c151baf41c8c$export$3973b77d5f6f2790)(), projection) : null);
    const featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    const indexFactor = Math.floor(16777215 / featureCount);
    const featuresByZIndex = {};
    for(let i = 1; i <= featureCount; ++i){
        const feature = features[i - 1];
        const featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!featureStyleFunction) continue;
        let styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        const index = i * indexFactor;
        const color = index.toString(16).padStart(7, '#00000');
        for(let j = 0, jj = styles.length; j < jj; ++j){
            const originalStyle = styles[j];
            const geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !(0, $110ceb23457e07e7$export$7b0a31e10bbff018)(userExtent, geometry.getExtent())) continue;
            const style = originalStyle.clone();
            const fill = style.getFill();
            if (fill) fill.setColor(color);
            const stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            const image = originalStyle.getImage();
            if (image) {
                const imgSize = image.getImageSize();
                if (!imgSize) continue;
                const imgContext = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(imgSize[0], imgSize[1], undefined, {
                    alpha: false
                });
                const img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new (0, $39bb2f212514d9f6$export$2e2bcd8739ae039)({
                    img: img,
                    anchor: image.getAnchor(),
                    anchorXUnits: 'pixels',
                    anchorYUnits: 'pixels',
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            const zIndex = style.getZIndex() || 0;
            let byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType['Polygon'] = [];
                byGeometryType['Circle'] = [];
                byGeometryType['LineString'] = [];
                byGeometryType['Point'] = [];
            }
            const type = geometry.getType();
            if (type === 'GeometryCollection') {
                const geometries = /** @type {import("../../geom/GeometryCollection.js").default} */ geometry.getGeometriesArrayRecursive();
                for(let i = 0, ii = geometries.length; i < ii; ++i){
                    const geometry = geometries[i];
                    byGeometryType[geometry.getType().replace('Multi', '')].push(geometry, style);
                }
            } else byGeometryType[type.replace('Multi', '')].push(geometry, style);
        }
    }
    const zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, $9d07dd9052c3de0c$export$fcb633242ef15540));
    for(let i = 0, ii = zIndexKeys.length; i < ii; ++i){
        const byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for(const type in byGeometryType){
            const geomAndStyle = byGeometryType[type];
            for(let j = 0, jj = geomAndStyle.length; j < jj; j += 2){
                renderer.setStyle(geomAndStyle[j + 1]);
                for(let k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function $e4a1dc4cab3ca6fc$export$6d4d555ddbfffa32(pixel, features, imageData) {
    /** @type {Array<F>} */ const resultFeatures = [];
    if (imageData) {
        const x = Math.floor(Math.round(pixel[0]) * $e4a1dc4cab3ca6fc$export$ab51038298418f25);
        const y = Math.floor(Math.round(pixel[1]) * $e4a1dc4cab3ca6fc$export$ab51038298418f25);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        const index = ((0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(x, 0, imageData.width - 1) + (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(y, 0, imageData.height - 1) * imageData.width) * 4;
        const r = imageData.data[index];
        const g = imageData.data[index + 1];
        const b = imageData.data[index + 2];
        const i = b + 256 * (g + 256 * r);
        const indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}





/**
 * @module ol/renderer/vector
 */ 

/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature~Feature feature} or {@link module:ol/render/Feature~RenderFeature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry~SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source").default>, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ const $4dc93cc3f41d6e2c$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/Geometry.js").Type,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ const $4dc93cc3f41d6e2c$var$GEOMETRY_RENDERERS = {
    'Point': $4dc93cc3f41d6e2c$var$renderPointGeometry,
    'LineString': $4dc93cc3f41d6e2c$var$renderLineStringGeometry,
    'Polygon': $4dc93cc3f41d6e2c$var$renderPolygonGeometry,
    'MultiPoint': $4dc93cc3f41d6e2c$var$renderMultiPointGeometry,
    'MultiLineString': $4dc93cc3f41d6e2c$var$renderMultiLineStringGeometry,
    'MultiPolygon': $4dc93cc3f41d6e2c$var$renderMultiPolygonGeometry,
    'GeometryCollection': $4dc93cc3f41d6e2c$var$renderGeometryCollectionGeometry,
    'Circle': $4dc93cc3f41d6e2c$var$renderCircleGeometry
};
function $4dc93cc3f41d6e2c$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $9f65e6f92d33bc27$export$5e82334337e0f204)(feature1), 10) - parseInt((0, $9f65e6f92d33bc27$export$5e82334337e0f204)(feature2), 10);
}
function $4dc93cc3f41d6e2c$export$75084a70d324c1e6(resolution, pixelRatio) {
    const tolerance = $4dc93cc3f41d6e2c$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $4dc93cc3f41d6e2c$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $4dc93cc3f41d6e2c$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4dc93cc3f41d6e2c$var$renderCircleGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const circleReplay = builderGroup.getBuilder(style.getZIndex(), 'Circle');
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
function $4dc93cc3f41d6e2c$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, transform, declutter, index) {
    const loadingPromises = [];
    const imageStyle = style.getImage();
    if (imageStyle) {
        let loading = true;
        const imageState = imageStyle.getImageState();
        if (imageState == (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED || imageState == (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).ERROR) loading = false;
        else if (imageState == (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).IDLE) imageStyle.load();
        if (loading) loadingPromises.push(imageStyle.ready());
    }
    const fillStyle = style.getFill();
    if (fillStyle && fillStyle.loading()) loadingPromises.push(fillStyle.ready());
    const loading = loadingPromises.length > 0;
    if (loading) Promise.all(loadingPromises).then(()=>listener(null));
    $4dc93cc3f41d6e2c$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
 * @param {boolean} [declutter] Enable decluttering.
 * @param {number} [index] Render order index..
 */ function $4dc93cc3f41d6e2c$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index) {
    const geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    const simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, transform);
    const renderer = style.getRenderer();
    if (renderer) $4dc93cc3f41d6e2c$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature, index);
    else {
        const geometryRenderer = $4dc93cc3f41d6e2c$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, index, declutter);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4dc93cc3f41d6e2c$var$renderGeometry(replayGroup, geometry, style, feature, index) {
    if (geometry.getType() == 'GeometryCollection') {
        const geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(let i = 0, ii = geometries.length; i < ii; ++i)$4dc93cc3f41d6e2c$var$renderGeometry(replayGroup, geometries[i], style, feature, index);
        return;
    }
    const replay = replayGroup.getBuilder(style.getZIndex(), 'Default');
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer(), style.getHitDetectionRenderer(), index);
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 * @param {number} [index] Render order index.
 */ function $4dc93cc3f41d6e2c$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, declutterBuilderGroup, index) {
    const geometries = geometry.getGeometriesArray();
    let i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        const geometryRenderer = $4dc93cc3f41d6e2c$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, declutterBuilderGroup, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4dc93cc3f41d6e2c$var$renderLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4dc93cc3f41d6e2c$var$renderMultiLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4dc93cc3f41d6e2c$var$renderMultiPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $4dc93cc3f41d6e2c$var$renderPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && imageStyle && hasText ? {} : undefined;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $4dc93cc3f41d6e2c$var$renderMultiPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const hasImage = imageStyle && imageStyle.getOpacity() !== 0;
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && hasImage && hasText ? {} : undefined;
    if (hasImage) {
        if (imageStyle.getImageState() != (0, $ab3525cfdb664b81$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $4dc93cc3f41d6e2c$var$renderPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}



/**
 * @type {!Object<string, Array<import("../../render/canvas.js").BuilderType>>}
 */ const $d9d97bf49326e7db$var$IMAGE_REPLAYS = {
    'image': [
        'Polygon',
        'Circle',
        'LineString',
        'Image',
        'Text'
    ],
    'hybrid': [
        'Polygon',
        'LineString'
    ],
    'vector': []
};
/**
 * @type {!Object<string, Array<import("../../render/canvas.js").BuilderType>>}
 */ const $d9d97bf49326e7db$var$VECTOR_REPLAYS = {
    'hybrid': [
        'Image',
        'Text',
        'Default'
    ],
    'vector': [
        'Polygon',
        'Circle',
        'LineString',
        'Image',
        'Text',
        'Default'
    ]
};
/**
 * @classdesc
 * Canvas renderer for vector tile layers.
 * @api
 * @extends {CanvasTileLayerRenderer<import("../../layer/VectorTile.js").default<import('../../source/VectorTile.js').default<import('../../Feature.js').FeatureLike>>>}
 */ class $d9d97bf49326e7db$var$CanvasVectorTileLayerRenderer extends (0, $2d0ed4848f0a5327$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/VectorTile.js").default} layer VectorTile layer.
   * @param {import("./TileLayer.js").Options} options Options.
   */ constructor(layer, options){
        super(layer, options);
        /** @private */ this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this);
        /**
     * @private
     * @type {number}
     */ this.renderedLayerRevision_;
        /**
     * @private
     * @type {import("../../transform").Transform}
     */ this.renderedPixelToCoordinateTransform_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRotation_;
        /**
     * @private
     * @type {number}
     */ this.renderedOpacity_ = 1;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpTransform_ = (0, $a684e03243281d90$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {Array<ZIndexContext>}
     */ this.tileClipContexts_ = null;
    }
    /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   * @override
   */ drawTile(tile, frameState, x, y, w, h, gutter, transition) {
        this.updateExecutorGroup_(tile, frameState.pixelRatio, frameState.viewState.projection);
        if (this.tileImageNeedsRender_(tile)) this.renderTileImage_(tile, frameState);
        super.drawTile(tile, frameState, x, y, w, h, gutter, transition);
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @override
   */ getTile(z, x, y, frameState) {
        const tile = /** @type {import("../../VectorRenderTile.js").default} */ this.getOrCreateTile(z, x, y, frameState);
        if (!tile) return null;
        const viewState = frameState.viewState;
        const resolution = viewState.resolution;
        const viewHints = frameState.viewHints;
        const hifi = !(viewHints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).INTERACTING]);
        if (hifi || !tile.wantedResolution) tile.wantedResolution = resolution;
        return tile;
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const layerRevision = this.getLayer().getRevision();
        if (this.renderedLayerRevision_ !== layerRevision) {
            this.renderedLayerRevision_ = layerRevision;
            this.renderedTiles.length = 0;
        }
        return super.prepareFrame(frameState);
    }
    /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../proj/Projection.js").default} projection Projection.
   * @private
   */ updateExecutorGroup_(tile, pixelRatio, projection) {
        const layer = /** @type {import("../../layer/VectorTile.js").default} */ this.getLayer();
        const revision = layer.getRevision();
        const renderOrder = layer.getRenderOrder() || null;
        const resolution = tile.wantedResolution;
        const builderState = tile.getReplayState(layer);
        if (!builderState.dirty && builderState.renderedResolution === resolution && builderState.renderedRevision == revision && builderState.renderedRenderOrder == renderOrder) return;
        const source = layer.getSource();
        const declutter = !!layer.getDeclutter();
        const sourceTileGrid = source.getTileGrid();
        const tileGrid = source.getTileGridForProjection(projection);
        const tileExtent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
        const sourceTiles = source.getSourceTiles(pixelRatio, projection, tile);
        const layerUid = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(layer);
        delete tile.hitDetectionImageData[layerUid];
        tile.executorGroups[layerUid] = [];
        builderState.dirty = false;
        for(let t = 0, tt = sourceTiles.length; t < tt; ++t){
            const sourceTile = sourceTiles[t];
            if (sourceTile.getState() != (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED) continue;
            const sourceTileCoord = sourceTile.tileCoord;
            const sourceTileExtent = sourceTileGrid.getTileCoordExtent(sourceTileCoord);
            const sharedExtent = (0, $110ceb23457e07e7$export$72209efa88586d42)(tileExtent, sourceTileExtent);
            const builderExtent = (0, $110ceb23457e07e7$export$ab1029bcae9ddb4a)(sharedExtent, layer.getRenderBuffer() * resolution, this.tempExtent);
            const bufferedExtent = (0, $110ceb23457e07e7$export$e9bab7fafb253603)(sourceTileExtent, sharedExtent) ? null : builderExtent;
            const builderGroup = new (0, $4af8752efda127f4$export$2e2bcd8739ae039)(0, sharedExtent, resolution, pixelRatio);
            const squaredTolerance = (0, $4dc93cc3f41d6e2c$export$75084a70d324c1e6)(resolution, pixelRatio);
            /**
       * @param {import("../../Feature.js").FeatureLike} feature Feature.
       * @param {number} [index] Render order index.
       * @this {CanvasVectorTileLayerRenderer}
       */ const render = function(feature, index) {
                let styles;
                const styleFunction = feature.getStyleFunction() || layer.getStyleFunction();
                if (styleFunction) styles = styleFunction(feature, resolution);
                if (styles) {
                    const dirty = this.renderFeature(feature, squaredTolerance, styles, builderGroup, declutter, index);
                    builderState.dirty = builderState.dirty || dirty;
                }
            };
            const features = sourceTile.getFeatures();
            if (renderOrder && renderOrder !== builderState.renderedRenderOrder) features.sort(renderOrder);
            for(let i = 0, ii = features.length; i < ii; ++i){
                const feature = features[i];
                if (!bufferedExtent || (0, $110ceb23457e07e7$export$7b0a31e10bbff018)(bufferedExtent, feature.getGeometry().getExtent())) render.call(this, feature, i);
            }
            const executorGroupInstructions = builderGroup.finish();
            // no need to clip when the render tile is covered by a single source tile
            const replayExtent = layer.getRenderMode() !== 'vector' && declutter && sourceTiles.length === 1 ? null : sharedExtent;
            const renderingReplayGroup = new (0, $e8088b2dfa7545b9$export$2e2bcd8739ae039)(replayExtent, resolution, pixelRatio, source.getOverlaps(), executorGroupInstructions, layer.getRenderBuffer(), true);
            tile.executorGroups[layerUid].push(renderingReplayGroup);
        }
        builderState.renderedRevision = revision;
        builderState.renderedRenderOrder = renderOrder;
        builderState.renderedResolution = resolution;
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   * @override
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        hitTolerance = hitTolerance == undefined ? 0 : hitTolerance;
        const layer = this.getLayer();
        const source = layer.getSource();
        const tileGrid = source.getTileGridForProjection(frameState.viewState.projection);
        const hitExtent = (0, $110ceb23457e07e7$export$8aceca7c77505534)([
            coordinate
        ]);
        (0, $110ceb23457e07e7$export$ab1029bcae9ddb4a)(hitExtent, resolution * hitTolerance, hitExtent);
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ const features = {};
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position.
     * @return {T|undefined} Callback result.
     */ const featureCallback = function(feature, geometry, distanceSq) {
            let key = feature.getId();
            if (key === undefined) key = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(feature);
            const match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        const renderedTiles = /** @type {Array<import("../../VectorRenderTile.js").default>} */ this.renderedTiles;
        const layerUid = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(layer);
        const declutter = layer.getDeclutter();
        const declutteredFeatures = declutter ? frameState.declutter?.[declutter]?.all().map((item)=>item.value) : null;
        let found;
        foundFeature: for(let i = 0, ii = renderedTiles.length; i < ii; ++i){
            const tile = renderedTiles[i];
            const tileExtent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
            if (!(0, $110ceb23457e07e7$export$7b0a31e10bbff018)(tileExtent, hitExtent)) continue;
            const executorGroups = tile.executorGroups[layerUid];
            for(let t = 0, tt = executorGroups.length; t < tt; ++t){
                found = executorGroups[t].forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutteredFeatures);
                if (found) break foundFeature;
            }
        }
        return found;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature.js").FeatureLike>>} Promise that resolves with an array of features.
   * @override
   */ getFeatures(pixel) {
        if (this.renderedTiles.length === 0) return Promise.resolve([]);
        return new Promise((resolve, reject)=>{
            const layer = this.getLayer();
            const source = layer.getSource();
            const projection = this.renderedProjection;
            const projectionExtent = projection.getExtent();
            const resolution = this.renderedResolution;
            const tileGrid = source.getTileGridForProjection(projection);
            const coordinate = (0, $a684e03243281d90$export$5635d7ef4b8fee1c)(this.renderedPixelToCoordinateTransform_, pixel.slice());
            const tileCoordString = tileGrid.getTileCoordForCoordAndResolution(coordinate, resolution).toString();
            const tile = /** @type {Array<import("../../VectorRenderTile.js").default>} */ this.renderedTiles.find((tile)=>tile.tileCoord.toString() === tileCoordString && tile.getState() === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED);
            if (!tile || tile.loadingSourceTiles > 0) {
                resolve([]);
                return;
            }
            if (source.getWrapX() && projection.canWrapX() && !(0, $110ceb23457e07e7$export$be866b1e0809b17e)(projectionExtent, tileGrid.getTileCoordExtent(tile.tileCoord))) (0, $188aedb30bca6ae8$export$39a9ce3624977b84)(coordinate, projection);
            const layerUid = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(layer);
            const extent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
            const corner = (0, $110ceb23457e07e7$export$cb1538b07e6964ff)(extent);
            const tilePixel = [
                (coordinate[0] - corner[0]) / resolution,
                (corner[1] - coordinate[1]) / resolution
            ];
            const features = tile.getSourceTiles().reduce((accumulator, sourceTile)=>accumulator.concat(sourceTile.getFeatures()), /** @type {Array<import("../../Feature.js").FeatureLike>} */ []);
            let hitDetectionImageData = tile.hitDetectionImageData[layerUid];
            if (!hitDetectionImageData) {
                const tileSize = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(tileGrid.getTileSize(tileGrid.getZForResolution(resolution, source.zDirection)));
                const rotation = this.renderedRotation_;
                const transforms = [
                    this.getRenderTransform(tileGrid.getTileCoordCenter(tile.wrappedTileCoord), resolution, 0, (0, $e4a1dc4cab3ca6fc$export$ab51038298418f25), tileSize[0] * (0, $e4a1dc4cab3ca6fc$export$ab51038298418f25), tileSize[1] * (0, $e4a1dc4cab3ca6fc$export$ab51038298418f25), 0)
                ];
                hitDetectionImageData = (0, $e4a1dc4cab3ca6fc$export$bd05e394339d469)(tileSize, transforms, features, layer.getStyleFunction(), tileGrid.getTileCoordExtent(tile.wrappedTileCoord), tile.getReplayState(layer).renderedResolution, rotation);
                tile.hitDetectionImageData[layerUid] = hitDetectionImageData;
            }
            resolve((0, $e4a1dc4cab3ca6fc$export$6d4d555ddbfffa32)(tilePixel, features, hitDetectionImageData));
        });
    }
    /**
   * @param {import("../../extent.js").Extent} extent Extent.
   * @return {Array<import('../../Feature.js').FeatureLike>} Features.
   */ getFeaturesInExtent(extent) {
        /** @type {Array<import('../../Feature.js').FeatureLike>} */ const features = [];
        const tileCache = this.getTileCache();
        if (tileCache.getCount() === 0) return features;
        const source = this.getLayer().getSource();
        const tileGrid = source.getTileGridForProjection(this.frameState.viewState.projection);
        const z = tileGrid.getZForResolution(this.renderedResolution);
        /** @type {Object<string, true>} */ const visitedSourceTiles = {};
        tileCache.forEach((tile)=>{
            if (tile.tileCoord[0] !== z || tile.getState() !== (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED) return;
            const sourceTiles = tile.getSourceTiles();
            for(let i = 0, ii = sourceTiles.length; i < ii; ++i){
                const sourceTile = sourceTiles[i];
                const key = sourceTile.getKey();
                if (key in visitedSourceTiles) continue;
                visitedSourceTiles[key] = true;
                const tileCoord = sourceTile.tileCoord;
                if ((0, $110ceb23457e07e7$export$7b0a31e10bbff018)(extent, tileGrid.getTileCoordExtent(tileCoord))) {
                    const tileFeatures = sourceTile.getFeatures();
                    if (tileFeatures) for(let j = 0, jj = tileFeatures.length; j < jj; ++j){
                        const candidate = tileFeatures[j];
                        const geometry = candidate.getGeometry();
                        if ((0, $110ceb23457e07e7$export$7b0a31e10bbff018)(extent, geometry.getExtent())) features.push(candidate);
                    }
                }
            }
        });
        return features;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @override
   */ handleFontsChanged() {
        const layer = this.getLayer();
        if (layer.getVisible() && this.renderedLayerRevision_ !== undefined) layer.changed();
    }
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    }
    /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {
        const context = this.context;
        const alpha = context.globalAlpha;
        context.globalAlpha = layerState.opacity;
        const viewHints = frameState.viewHints;
        const hifi = !(viewHints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).INTERACTING]);
        const scaledCanvasSize = [
            this.context.canvas.width,
            this.context.canvas.height
        ];
        const declutter = this.getLayer().getDeclutter();
        const declutterTree = declutter ? frameState.declutter?.[declutter] : undefined;
        const layerUid = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(this.getLayer());
        const tiles = /** @type {Array<import("../../VectorRenderTile.js").default>} */ this.renderedTiles;
        for(let i = 0, ii = tiles.length; i < ii; ++i){
            const tile = tiles[i];
            const executorGroups = tile.executorGroups[layerUid];
            if (executorGroups) for(let j = executorGroups.length - 1; j >= 0; --j)executorGroups[j].execute(this.context, scaledCanvasSize, this.getTileRenderTransform(tile, frameState), frameState.viewState.rotation, hifi, (0, $e8088b2dfa7545b9$export$6195a93a6c97ce02), declutterTree);
        }
        context.globalAlpha = alpha;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferredInternal(frameState) {
        const tiles = /** @type {Array<import("../../VectorRenderTile.js").default>} */ this.renderedTiles;
        const layerUid = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(this.getLayer());
        const executorGroups = tiles.reduce((acc, tile, index)=>{
            tile.executorGroups[layerUid].forEach((executorGroup)=>acc.push({
                    executorGroup: executorGroup,
                    index: index
                }));
            return acc;
        }, /** @type {Array<{executorGroup: CanvasExecutorGroup, index: number}>} */ []);
        const executorGroupZIndexContexts = executorGroups.map(({ executorGroup: executorGroup })=>executorGroup.getDeferredZIndexContexts());
        /** @type {Object<number, true>} */ const usedZIndices = {};
        for(let i = 0, ii = executorGroups.length; i < ii; ++i){
            const executorGroupZindexContext = executorGroups[i].executorGroup.getDeferredZIndexContexts();
            for(const key in executorGroupZindexContext)usedZIndices[key] = true;
        }
        const zIndexKeys = Object.keys(usedZIndices).map(Number).sort((0, $9d07dd9052c3de0c$export$fcb633242ef15540));
        zIndexKeys.forEach((zIndex)=>{
            executorGroupZIndexContexts.forEach((zIndexContexts, i)=>{
                if (!zIndexContexts[zIndex]) return;
                zIndexContexts[zIndex].forEach((zIndexContext)=>{
                    const { executorGroup: executorGroup, index: index } = executorGroups[i];
                    const context = executorGroup.getRenderedContext();
                    const alpha = context.globalAlpha;
                    context.globalAlpha = this.renderedOpacity_;
                    const tileClipContext = this.tileClipContexts_[index];
                    if (tileClipContext) tileClipContext.draw(context);
                    zIndexContext.draw(context);
                    if (tileClipContext) context.restore();
                    context.globalAlpha = alpha;
                    zIndexContext.clear();
                });
                zIndexContexts[zIndex].length = 0;
            });
        });
    }
    /**
   * @param {import("../../VectorRenderTile.js").default} tile The tile
   * @param {import('../../Map.js').FrameState} frameState Current frame state
   * @return {import('../../transform.js').Transform} Transform to use to render this tile
   */ getTileRenderTransform(tile, frameState) {
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const center = viewState.center;
        const resolution = viewState.resolution;
        const rotation = viewState.rotation;
        const size = frameState.size;
        const width = Math.round(size[0] * pixelRatio);
        const height = Math.round(size[1] * pixelRatio);
        const source = this.getLayer().getSource();
        const tileGrid = source.getTileGridForProjection(frameState.viewState.projection);
        const tileCoord = tile.tileCoord;
        const tileExtent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
        const worldOffset = tileGrid.getTileCoordExtent(tileCoord, this.tempExtent)[0] - tileExtent[0];
        const transform = (0, $a684e03243281d90$export$2060d2db72cce88f)((0, $a684e03243281d90$export$dcdf75081b88279d)(this.inversePixelTransform.slice(), 1 / pixelRatio, 1 / pixelRatio), this.getRenderTransform(center, resolution, rotation, pixelRatio, width, height, worldOffset));
        return transform;
    }
    /**
   * Render the vectors for this layer.
   * @param {CanvasRenderingContext2D} context Target context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ postRender(context, frameState) {
        const viewHints = frameState.viewHints;
        const hifi = !(viewHints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).INTERACTING]);
        this.renderedPixelToCoordinateTransform_ = frameState.pixelToCoordinateTransform.slice();
        this.renderedRotation_ = frameState.viewState.rotation;
        this.renderedOpacity_ = frameState.layerStatesArray[frameState.layerIndex].opacity;
        const layer = /** @type {import("../../layer/VectorTile.js").default} */ this.getLayer();
        const renderMode = layer.getRenderMode();
        const alpha = context.globalAlpha;
        context.globalAlpha = this.renderedOpacity_;
        const declutter = layer.getDeclutter();
        const replayTypes = declutter ? $d9d97bf49326e7db$var$VECTOR_REPLAYS[renderMode].filter((type)=>!(0, $e8088b2dfa7545b9$export$6195a93a6c97ce02).includes(type)) : $d9d97bf49326e7db$var$VECTOR_REPLAYS[renderMode];
        const viewState = frameState.viewState;
        const rotation = viewState.rotation;
        const tileSource = layer.getSource();
        const tileGrid = tileSource.getTileGridForProjection(viewState.projection);
        const z = tileGrid.getZForResolution(viewState.resolution, tileSource.zDirection);
        const tiles = /** @type {Array<import("../../VectorRenderTile.js").default>} */ this.renderedTiles;
        const clips = [];
        const clipZs = [];
        const tileClipContexts = [];
        const layerUid = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(layer);
        let ready = true;
        for(let i = tiles.length - 1; i >= 0; --i){
            const tile = tiles[i];
            ready = ready && !tile.getReplayState(layer).dirty;
            const executorGroups = tile.executorGroups[layerUid].filter((group)=>group.hasExecutors(replayTypes));
            if (executorGroups.length === 0) continue;
            const transform = this.getTileRenderTransform(tile, frameState);
            const currentZ = tile.tileCoord[0];
            let contextSaved = false;
            // Clip mask for regions in this tile that already filled by a higher z tile
            const currentClip = executorGroups[0].getClipCoords(transform);
            let clipContext = context;
            let tileClipContext;
            if (currentClip) {
                tileClipContext = new (0, $5ae37123888c860e$export$2e2bcd8739ae039)();
                clipContext = tileClipContext.getContext();
                for(let j = 0, jj = clips.length; j < jj; ++j)if (z !== currentZ && currentZ < clipZs[j]) {
                    const clip = clips[j];
                    if ((0, $110ceb23457e07e7$export$7b0a31e10bbff018)([
                        currentClip[0],
                        currentClip[3],
                        currentClip[4],
                        currentClip[7]
                    ], [
                        clip[0],
                        clip[3],
                        clip[4],
                        clip[7]
                    ])) {
                        if (!contextSaved) {
                            clipContext.save();
                            contextSaved = true;
                        }
                        clipContext.beginPath();
                        // counter-clockwise (outer ring) for current tile
                        clipContext.moveTo(currentClip[0], currentClip[1]);
                        clipContext.lineTo(currentClip[2], currentClip[3]);
                        clipContext.lineTo(currentClip[4], currentClip[5]);
                        clipContext.lineTo(currentClip[6], currentClip[7]);
                        // clockwise (inner ring) for higher z tile
                        clipContext.moveTo(clip[6], clip[7]);
                        clipContext.lineTo(clip[4], clip[5]);
                        clipContext.lineTo(clip[2], clip[3]);
                        clipContext.lineTo(clip[0], clip[1]);
                        clipContext.clip();
                    }
                }
                clips.push(currentClip);
                clipZs.push(currentZ);
            }
            for(let t = 0, tt = executorGroups.length; t < tt; ++t){
                const executorGroup = executorGroups[t];
                executorGroup.execute(context, [
                    context.canvas.width,
                    context.canvas.height
                ], transform, rotation, hifi, replayTypes, frameState.declutter?.[declutter]);
            }
            if (contextSaved) {
                if (clipContext === context) clipContext.restore();
                else tileClipContexts[i] = tileClipContext;
            }
        }
        context.globalAlpha = alpha;
        this.ready = ready;
        this.tileClipContexts_ = tileClipContexts;
        if (!frameState.declutter) this.renderDeferredInternal(frameState);
        super.postRender(context, frameState);
    }
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */ renderFeature(feature, squaredTolerance, styles, builderGroup, declutter, index) {
        if (!styles) return false;
        let loading = false;
        if (Array.isArray(styles)) for(let i = 0, ii = styles.length; i < ii; ++i)loading = (0, $4dc93cc3f41d6e2c$export$36f470a33a42f413)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, undefined, declutter, index) || loading;
        else loading = (0, $4dc93cc3f41d6e2c$export$36f470a33a42f413)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, undefined, declutter, index);
        return loading;
    }
    /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @return {boolean} A new tile image was rendered.
   * @private
   */ tileImageNeedsRender_(tile) {
        const layer = /** @type {import("../../layer/VectorTile.js").default} */ this.getLayer();
        if (layer.getRenderMode() === 'vector') return false;
        const replayState = tile.getReplayState(layer);
        const revision = layer.getRevision();
        const resolution = tile.wantedResolution;
        return replayState.renderedTileResolution !== resolution || replayState.renderedTileRevision !== revision;
    }
    /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @param {import("../../Map").FrameState} frameState Frame state.
   * @private
   */ renderTileImage_(tile, frameState) {
        const layer = /** @type {import("../../layer/VectorTile.js").default} */ this.getLayer();
        const replayState = tile.getReplayState(layer);
        const revision = layer.getRevision();
        const executorGroups = tile.executorGroups[(0, $9f65e6f92d33bc27$export$5e82334337e0f204)(layer)];
        replayState.renderedTileRevision = revision;
        const tileCoord = tile.wrappedTileCoord;
        const z = tileCoord[0];
        const source = layer.getSource();
        let pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const tileGrid = source.getTileGridForProjection(projection);
        const tileResolution = tileGrid.getResolution(tile.tileCoord[0]);
        const renderPixelRatio = frameState.pixelRatio / tile.wantedResolution * tileResolution;
        const resolution = tileGrid.getResolution(z);
        const context = tile.getContext();
        // Increase tile size when overzooming for low pixel ratio, to avoid blurry tiles
        pixelRatio = Math.round(Math.max(pixelRatio, renderPixelRatio / pixelRatio));
        const size = source.getTilePixelSize(z, pixelRatio, projection);
        context.canvas.width = size[0];
        context.canvas.height = size[1];
        const renderScale = pixelRatio / renderPixelRatio;
        if (renderScale !== 1) {
            const canvasTransform = (0, $a684e03243281d90$export$aad8462122ac592b)(this.tmpTransform_);
            (0, $a684e03243281d90$export$dcdf75081b88279d)(canvasTransform, renderScale, renderScale);
            context.setTransform.apply(context, canvasTransform);
        }
        const tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tempExtent);
        const pixelScale = renderPixelRatio / resolution;
        const transform = (0, $a684e03243281d90$export$aad8462122ac592b)(this.tmpTransform_);
        (0, $a684e03243281d90$export$dcdf75081b88279d)(transform, pixelScale, -pixelScale);
        (0, $a684e03243281d90$export$d73ee8ef04f5226a)(transform, -tileExtent[0], -tileExtent[3]);
        for(let i = 0, ii = executorGroups.length; i < ii; ++i){
            const executorGroup = executorGroups[i];
            executorGroup.execute(context, [
                context.canvas.width * renderScale,
                context.canvas.height * renderScale
            ], transform, 0, true, $d9d97bf49326e7db$var$IMAGE_REPLAYS[layer.getRenderMode()], null);
        }
        replayState.renderedTileResolution = tile.wantedResolution;
    }
}
var $d9d97bf49326e7db$export$2e2bcd8739ae039 = $d9d97bf49326e7db$var$CanvasVectorTileLayerRenderer;




/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} VectorTileLayerOnSignature
 */ /**
 * @typedef {'hybrid' | 'vector'} VectorTileRenderType
 */ /***
 * @template T
 * @typedef {T extends import("../source/VectorTile.js").default<infer U extends import("../Feature.js").FeatureLike> ? U : never} ExtractedFeatureType
 */ /**
 * @template {import("../source/VectorTile.js").default<FeatureType>} [VectorTileSourceType=import("../source/VectorTile.js").default<*>]
 * @template {import("../Feature").FeatureLike} [FeatureType=ExtractedFeatureType<VectorTileSourceType>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the tile extent used by the
 * renderer when getting features from the vector tile for the rendering or hit-detection.
 * Recommended value: Vector tiles are usually generated with a buffer, so this value should match
 * the largest possible buffer of the used tiles. It should be at least the size of the largest
 * point symbol or line width.
 * @property {VectorTileRenderType} [renderMode='hybrid'] Render mode for vector tiles:
 *  `'hybrid'`: Polygon and line elements are rendered as images, so pixels are scaled during zoom
 *    animations. Point symbols and texts are accurately rendered as vectors and can stay upright on
 *    rotated views, but get lifted above all polygon and line elements.
 *  `'vector'`: Everything is rendered as vectors and the original render order is maintained. Use
 *    this mode for improved performance and visual epxerience on vector tile layers with not too many
 *    rendered features (e.g. for highlighting a subset of features of another layer with the same
 *    source).
 * @property {VectorTileSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer
 * style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no
 * background will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will be
 * recreated during animations. This means that no vectors will be shown clipped, but the setting
 * will have a performance impact for large amounts of vector data. When set to `false`, batches
 * will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will be
 * recreated during interactions. See also `updateWhileAnimating`.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {boolean} [useInterimTilesOnError=true] Deprecated.  Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 * @property {number} [cacheSize=0] The internal tile cache size.  If too small, this will auto-grow to hold
 * two zoom levels worth of tiles.
 */ /**
 * @classdesc
 * Layer for vector tile data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/VectorTile.js").default<FeatureType>} [VectorTileSourceType=import("../source/VectorTile.js").default<*>]
 * @template {import("../Feature.js").FeatureLike} [FeatureType=ExtractedFeatureType<VectorTileSourceType>]
 * @extends {BaseVectorLayer<FeatureType, VectorTileSourceType, CanvasVectorTileLayerRenderer>}
 * @api
 */ class $9db2244bb47aea68$var$VectorTileLayer extends (0, $c0ed643b13f1acbb$export$2e2bcd8739ae039) {
    /**
   * @param {Options<VectorTileSourceType, FeatureType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.preload;
        const cacheSize = options.cacheSize === undefined ? 0 : options.cacheSize;
        delete options.cacheSize;
        delete baseOptions.useInterimTilesOnError;
        super(baseOptions);
        /***
     * @type {VectorTileLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {VectorTileLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {VectorTileLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {number|undefined}
     * @private
     */ this.cacheSize_ = cacheSize;
        const renderMode = options.renderMode || 'hybrid';
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(renderMode == 'hybrid' || renderMode == 'vector', "`renderMode` must be `'hybrid'` or `'vector'`");
        /**
     * @private
     * @type {VectorTileRenderType}
     */ this.renderMode_ = renderMode;
        this.setPreload(options.preload ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
        /**
     * @return {import("./Base.js").BackgroundColor} Background color.
     * @function
     * @api
     */ this.getBackground;
        /**
     * @param {import("./Base.js").BackgroundColor} background Background color.
     * @function
     * @api
     */ this.setBackground;
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $d9d97bf49326e7db$export$2e2bcd8739ae039)(this, {
            cacheSize: this.cacheSize_
        });
    }
    /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   * @override
   */ getFeatures(pixel) {
        return super.getFeatures(pixel);
    }
    /**
   * Get features whose bounding box intersects the provided extent. Only features for cached
   * tiles for the last rendered zoom level are available in the source. So this method is only
   * suitable for requesting tiles for extents that are currently rendered.
   *
   * Features are returned in random tile order and as they are included in the tiles. This means
   * they can be clipped, duplicated across tiles, and simplified to the render resolution.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesInExtent(extent) {
        return /** @type {*} */ this.getRenderer().getFeaturesInExtent(extent);
    }
    /**
   * @return {VectorTileRenderType} The render mode.
   */ getRenderMode() {
        return this.renderMode_;
    }
    /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ getPreload() {
        return /** @type {number} */ this.get((0, $fff454ff0e19acd9$export$2e2bcd8739ae039).PRELOAD);
    }
    /**
   * Deprecated.  Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, $fff454ff0e19acd9$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
    }
    /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ setPreload(preload) {
        this.set((0, $fff454ff0e19acd9$export$2e2bcd8739ae039).PRELOAD, preload);
    }
    /**
   * Deprecated.  Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, $fff454ff0e19acd9$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    }
}
var $9db2244bb47aea68$export$2e2bcd8739ae039 = $9db2244bb47aea68$var$VectorTileLayer;


/**
 * @module ol/source/VectorTile
 */ 
/**
 * @module ol/VectorRenderTile
 */ 


/**
 * @typedef {Object} ReplayState
 * @property {boolean} dirty Dirty.
 * @property {null|import("./render.js").OrderFunction} renderedRenderOrder RenderedRenderOrder.
 * @property {number} renderedTileRevision RenderedTileRevision.
 * @property {number} renderedResolution RenderedResolution.
 * @property {number} renderedRevision RenderedRevision.
 * @property {number} renderedTileResolution RenderedTileResolution.
 * @property {number} renderedTileZ RenderedTileZ.
 */ /**
 * @type {Array<HTMLCanvasElement>}
 */ const $690a7d006ee12010$var$canvasPool = [];
class $690a7d006ee12010$var$VectorRenderTile extends (0, $83a24df5588a4450$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {import("./tilecoord.js").TileCoord} urlTileCoord Wrapped tile coordinate for source urls.
   * @param {function(VectorRenderTile):Array<import("./VectorTile").default>} getSourceTiles Function.
   * @param {function(VectorRenderTile):void} removeSourceTiles Function.
   */ constructor(tileCoord, state, urlTileCoord, getSourceTiles, removeSourceTiles){
        super(tileCoord, state, {
            transition: 0
        });
        /**
     * @private
     * @type {CanvasRenderingContext2D|null}
     */ this.context_ = null;
        /**
     * Executor groups. Read/written by the renderer.
     * @type {Object<string, Array<import("./render/canvas/ExecutorGroup.js").default>>}
     */ this.executorGroups = {};
        /**
     * Number of loading source tiles. Read/written by the source.
     * @type {number}
     */ this.loadingSourceTiles = 0;
        /**
     * @type {Object<string, ImageData>}
     */ this.hitDetectionImageData = {};
        /**
     * @private
     * @type {!Object<string, ReplayState>}
     */ this.replayState_ = {};
        /**
     * @type {Array<import("./VectorTile.js").default>}
     */ this.sourceTiles = [];
        /**
     * @type {Object<string, boolean>}
     */ this.errorTileKeys = {};
        /**
     * @type {number}
     */ this.wantedResolution;
        /**
     * @type {!function():Array<import("./VectorTile.js").default>}
     */ this.getSourceTiles = getSourceTiles.bind(undefined, this);
        /**
     * @type {!function(VectorRenderTile):void}
     * @private
     */ this.removeSourceTiles_ = removeSourceTiles;
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.wrappedTileCoord = urlTileCoord;
    }
    /**
   * @return {CanvasRenderingContext2D} The rendering context.
   */ getContext() {
        if (!this.context_) this.context_ = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(1, 1, $690a7d006ee12010$var$canvasPool);
        return this.context_;
    }
    /**
   * @return {boolean} Tile has a rendering context.
   */ hasContext() {
        return !!this.context_;
    }
    /**
   * Get the Canvas for this tile.
   * @return {HTMLCanvasElement} Canvas.
   */ getImage() {
        return this.hasContext() ? this.getContext().canvas : null;
    }
    /**
   * @param {import("./layer/Layer.js").default} layer Layer.
   * @return {ReplayState} The replay state.
   */ getReplayState(layer) {
        const key = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(layer);
        if (!(key in this.replayState_)) this.replayState_[key] = {
            dirty: false,
            renderedRenderOrder: null,
            renderedResolution: NaN,
            renderedRevision: -1,
            renderedTileResolution: NaN,
            renderedTileRevision: -1,
            renderedTileZ: -1
        };
        return this.replayState_[key];
    }
    /**
   * Load the tile.
   * @override
   */ load() {
        this.getSourceTiles();
    }
    /**
   * Remove from the cache due to expiry
   * @override
   */ release() {
        if (this.context_) {
            (0, $32c8adb5331a7848$export$e918ac6a1026a12a)(this.context_);
            $690a7d006ee12010$var$canvasPool.push(this.context_.canvas);
            this.context_ = null;
        }
        this.removeSourceTiles_(this);
        this.sourceTiles.length = 0;
        super.release();
    }
}
var $690a7d006ee12010$export$2e2bcd8739ae039 = $690a7d006ee12010$var$VectorRenderTile;


/**
 * @module ol/VectorTile
 */ 

/**
 * @template {import('./Feature.js').FeatureLike} FeatureType
 */ class $688768c34fe9543b$var$VectorTile extends (0, $83a24df5588a4450$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Data source url.
   * @param {import("./format/Feature.js").default<FeatureType>} format Feature format.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */ constructor(tileCoord, state, src, format, tileLoadFunction, options){
        super(tileCoord, state, options);
        /**
     * Extent of this tile; set by the source.
     * @type {import("./extent.js").Extent}
     */ this.extent = null;
        /**
     * @private
     * @type {import("./format/Feature.js").default<FeatureType>}
     */ this.format_ = format;
        /**
     * @private
     * @type {Array<FeatureType>}
     */ this.features_ = null;
        /**
     * @private
     * @type {import("./featureloader.js").FeatureLoader}
     */ this.loader_;
        /**
     * Feature projection of this tile; set by the source.
     * @type {import("./proj/Projection.js").default}
     */ this.projection = null;
        /**
     * Resolution of this tile; set by the source.
     * @type {number}
     */ this.resolution;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
        /**
     * @private
     * @type {string}
     */ this.url_ = src;
        this.key = src;
    }
    /**
   * @return {string} Tile url.
   */ getTileUrl() {
        return this.url_;
    }
    /**
   * Get the feature format assigned for reading this tile's features.
   * @return {import("./format/Feature.js").default<FeatureType>} Feature format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * Get the features for this tile. Geometries will be in the view projection.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeatures() {
        return this.features_;
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE) {
            this.setState((0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADING);
            this.tileLoadFunction_(this, this.url_);
            if (this.loader_) this.loader_(this.extent, this.resolution, this.projection);
        }
    }
    /**
   * Handler for successful tile load.
   * @param {Array<FeatureType>} features The loaded features.
   * @param {import("./proj/Projection.js").default} dataProjection Data projection.
   */ onLoad(features, dataProjection) {
        this.setFeatures(features);
    }
    /**
   * Handler for tile load errors.
   */ onError() {
        this.setState((0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR);
    }
    /**
   * Function for use in a {@link module:ol/source/VectorTile~VectorTile}'s `tileLoadFunction`.
   * Sets the features for the tile.
   * @param {Array<FeatureType>} features Features.
   * @api
   */ setFeatures(features) {
        this.features_ = features;
        this.setState((0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED);
    }
    /**
   * Set the feature loader for reading this tile's features.
   * @param {import("./featureloader.js").FeatureLoader<FeatureType>} loader Feature loader.
   * @api
   */ setLoader(loader) {
        this.loader_ = loader;
    }
}
var $688768c34fe9543b$export$2e2bcd8739ae039 = $688768c34fe9543b$var$VectorTile;





/**
 * @module ol/featureloader
 */ /**
 *
 * @type {boolean}
 * @private
 */ let $4fbf60f1e6dcbc40$var$withCredentials = false;
function $4fbf60f1e6dcbc40$export$441d7b57adab24d0(url, format, extent, resolution, projection, success, failure) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', typeof url === 'function' ? url(extent, resolution, projection) : url, true);
    if (format.getType() == 'arraybuffer') xhr.responseType = 'arraybuffer';
    xhr.withCredentials = $4fbf60f1e6dcbc40$var$withCredentials;
    /**
   * @param {Event} event Event.
   * @private
   */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            const type = format.getType();
            try {
                /** @type {Document|Node|Object|string|undefined} */ let source;
                if (type == 'text' || type == 'json') source = xhr.responseText;
                else if (type == 'xml') source = xhr.responseXML || xhr.responseText;
                else if (type == 'arraybuffer') source = /** @type {ArrayBuffer} */ xhr.response;
                if (source) success(/** @type {Array<FeatureType>} */ format.readFeatures(source, {
                    extent: extent,
                    featureProjection: projection
                }), format.readProjection(source));
                else failure();
            } catch  {
                failure();
            }
        } else failure();
    };
    /**
   * @private
   */ xhr.onerror = failure;
    xhr.send();
}
function $4fbf60f1e6dcbc40$export$14cc81df70b6707e(url, format) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("./proj/Projection.js").default} projection Projection.
   * @param {function(Array<FeatureType>): void} [success] Success
   *      Function called when loading succeeded.
   * @param {function(): void} [failure] Failure
   *      Function called when loading failed.
   * @this {import("./source/Vector.js").default<FeatureType>}
   */ return function(extent, resolution, projection, success, failure) {
        $4fbf60f1e6dcbc40$export$441d7b57adab24d0(url, format, extent, resolution, projection, /**
       * @param {Array<FeatureType>} features The loaded features.
       * @param {import("./proj/Projection.js").default} dataProjection Data
       * projection.
       */ (features, dataProjection)=>{
            this.addFeatures(features);
            if (success !== undefined) success(features);
        }, ()=>{
            this.changed();
            if (failure !== undefined) failure();
        });
    };
}
function $4fbf60f1e6dcbc40$export$36fa6977a6d0d8fe(xhrWithCredentials) {
    $4fbf60f1e6dcbc40$var$withCredentials = xhrWithCredentials;
}









/**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../render/Feature.js").default]
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least twice the number of tiles in the viewport.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {import("../format/Feature.js").default<FeatureType>} [format] Feature format for tiles. Used and required by the default.
 * @property {boolean} [overlaps=true] This source may have overlapping geometries. Setting this
 * to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection of the tile grid.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../VectorTile.js").default} [tileClass] Class used to instantiate tiles.
 * Default is {@link module:ol/VectorTile~VectorTile}.
 * @property {number} [maxZoom=22] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number|import("../size.js").Size} [tileSize=512] Optional tile size. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction]
 * Optional function to load a tile given a URL. Could look like this for pbf tiles:
 * ```js
 * function(tile, url) {
 *   tile.setLoader(function(extent, resolution, projection) {
 *     fetch(url).then(function(response) {
 *       response.arrayBuffer().then(function(data) {
 *         const format = tile.getFormat() // ol/format/MVT configured as source format
 *         const features = format.readFeatures(data, {
 *           extent: extent,
 *           featureProjection: projection
 *         });
 *         tile.setFeatures(features);
 *       });
 *     });
 *   });
 * }
 * ```
 * If you do not need extent, resolution and projection to get the features for a tile (e.g.
 * for GeoJSON tiles), your `tileLoadFunction` does not need a `setLoader()` call. Only make sure
 * to call `setFeatures()` on the tile:
 * ```js
 * const format = new GeoJSON({featureProjection: map.getView().getProjection()});
 * async function tileLoadFunction(tile, url) {
 *   const response = await fetch(url);
 *   const data = await response.json();
 *   tile.setFeatures(format.readFeatures(data));
 * }
 * ```
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get tile URL given a tile coordinate and the projection.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {number} [transition] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * When set to `false`, only one world
 * will be rendered. When set to `true`, tiles will be wrapped horizontally to
 * render multiple worlds.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=1]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Class for layer sources providing vector data divided into a tile grid, to be
 * used with {@link module:ol/layer/VectorTile~VectorTileLayer}. Although this source receives tiles
 * with vector features from the server, it is not meant for feature editing.
 * Features are optimized for rendering, their geometries are clipped at or near
 * tile boundaries and simplified for a view resolution. See
 * {@link module:ol/source/Vector~VectorSource} for vector sources that are suitable for feature
 * editing.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../render/Feature.js").default]
 */ class $429d8626291b2422$var$VectorTile extends (0, $118b60936f97bd19$export$2e2bcd8739ae039) {
    /**
   * @param {!Options<FeatureType>} options Vector tile options.
   */ constructor(options){
        const projection = options.projection || 'EPSG:3857';
        const extent = options.extent || (0, $4d180c4e74ac3a0c$export$7b5b6ef8fd55fac4)(projection);
        const tileGrid = options.tileGrid || (0, $4d180c4e74ac3a0c$export$38500bbeccc864ff)({
            extent: extent,
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 22,
            minZoom: options.minZoom,
            tileSize: options.tileSize || 512
        });
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            cacheSize: options.cacheSize,
            interpolate: true,
            projection: projection,
            state: options.state,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $429d8626291b2422$export$7a0df80a606b730e,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX === undefined ? true : options.wrapX,
            transition: options.transition,
            zDirection: options.zDirection === undefined ? 1 : options.zDirection
        });
        /**
     * @private
     * @type {import("../format/Feature.js").default<FeatureType>|null}
     */ this.format_ = options.format ? options.format : null;
        /**
     * @type {Object<string, Array<string>>}
     * @private
     */ this.tileKeysBySourceTileUrl_ = {};
        /**
     @type {Object<string, Tile<FeatureType>>}
     */ this.sourceTiles_ = {};
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps == undefined ? true : options.overlaps;
        /**
     * @protected
     * @type {typeof import("../VectorTile.js").default}
     */ this.tileClass = options.tileClass ? options.tileClass : (0, $688768c34fe9543b$export$2e2bcd8739ae039);
        /**
     * @private
     * @type {Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGrids_ = {};
    }
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ getOverlaps() {
        return this.overlaps_;
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection").default} projection Projection.
   * @param {VectorRenderTile} tile Vector render tile.
   * @return {Array<import("../VectorTile").default>} Tile keys.
   */ getSourceTiles(pixelRatio, projection, tile) {
        if (tile.getState() === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE) {
            tile.setState((0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADING);
            const urlTileCoord = tile.wrappedTileCoord;
            const tileGrid = this.getTileGridForProjection(projection);
            const extent = tileGrid.getTileCoordExtent(urlTileCoord);
            const z = urlTileCoord[0];
            const resolution = tileGrid.getResolution(z);
            // make extent 1 pixel smaller so we don't load tiles for < 0.5 pixel render space
            (0, $110ceb23457e07e7$export$ab1029bcae9ddb4a)(extent, -resolution, extent);
            const sourceTileGrid = this.tileGrid;
            const sourceExtent = sourceTileGrid.getExtent();
            if (sourceExtent) (0, $110ceb23457e07e7$export$72209efa88586d42)(extent, sourceExtent, extent);
            const sourceZ = sourceTileGrid.getZForResolution(resolution, this.zDirection);
            sourceTileGrid.forEachTileCoord(extent, sourceZ, (sourceTileCoord)=>{
                const tileUrl = this.tileUrlFunction(sourceTileCoord, pixelRatio, projection);
                if (!this.sourceTiles_[tileUrl]) this.sourceTiles_[tileUrl] = new this.tileClass(sourceTileCoord, tileUrl ? (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE : (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY, tileUrl, this.format_, this.tileLoadFunction);
                const sourceTile = this.sourceTiles_[tileUrl];
                tile.sourceTiles.push(sourceTile);
                if (!this.tileKeysBySourceTileUrl_[tileUrl]) this.tileKeysBySourceTileUrl_[tileUrl] = [];
                this.tileKeysBySourceTileUrl_[tileUrl].push(tile.getKey());
                const sourceTileState = sourceTile.getState();
                if (sourceTileState < (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED) {
                    const listenChange = (event)=>{
                        this.handleTileChange(event);
                        const state = sourceTile.getState();
                        if (state === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED || state === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR) {
                            const sourceTileKey = sourceTile.getKey();
                            if (sourceTileKey in tile.errorTileKeys) {
                                if (sourceTile.getState() === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED) delete tile.errorTileKeys[sourceTileKey];
                            } else tile.loadingSourceTiles--;
                            if (state === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR) tile.errorTileKeys[sourceTileKey] = true;
                            else sourceTile.removeEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, listenChange);
                            if (tile.loadingSourceTiles === 0) tile.setState((0, $0364d4893e3f1129$export$dd1bc94b04021eeb)(tile.errorTileKeys) ? (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED : (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR);
                        }
                    };
                    sourceTile.addEventListener((0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, listenChange);
                    tile.loadingSourceTiles++;
                }
                if (sourceTileState === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE) {
                    sourceTile.extent = sourceTileGrid.getTileCoordExtent(sourceTileCoord);
                    sourceTile.projection = projection;
                    sourceTile.resolution = sourceTileGrid.getResolution(sourceTileCoord[0]);
                    sourceTile.load();
                }
            });
            if (!tile.loadingSourceTiles) tile.setState(tile.sourceTiles.some((sourceTile)=>sourceTile.getState() === (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR) ? (0, $34f0277fe2789b80$export$2e2bcd8739ae039).ERROR : (0, $34f0277fe2789b80$export$2e2bcd8739ae039).LOADED);
        }
        return tile.sourceTiles;
    }
    /**
   * @param {VectorRenderTile} tile Vector render tile.
   */ removeSourceTiles(tile) {
        const tileKey = tile.getKey();
        const sourceTiles = tile.sourceTiles;
        for(let i = 0, ii = sourceTiles.length; i < ii; ++i){
            const sourceTileUrl = sourceTiles[i].getTileUrl();
            if (!this.tileKeysBySourceTileUrl_[sourceTileUrl]) return;
            const index = this.tileKeysBySourceTileUrl_[sourceTileUrl].indexOf(tileKey);
            if (index === -1) continue;
            this.tileKeysBySourceTileUrl_[sourceTileUrl].splice(index, 1);
            if (this.tileKeysBySourceTileUrl_[sourceTileUrl].length === 0) {
                delete this.tileKeysBySourceTileUrl_[sourceTileUrl];
                delete this.sourceTiles_[sourceTileUrl];
            }
        }
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!VectorRenderTile} Tile.
   * @override
   */ getTile(z, x, y, pixelRatio, projection) {
        const tileCoord = [
            z,
            x,
            y
        ];
        let urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const sourceExtent = this.getTileGrid().getExtent();
        const tileGrid = this.getTileGridForProjection(projection);
        if (urlTileCoord && sourceExtent) {
            const tileExtent = tileGrid.getTileCoordExtent(urlTileCoord);
            // make extent 1 pixel smaller so we don't load tiles for < 0.5 pixel render space
            (0, $110ceb23457e07e7$export$ab1029bcae9ddb4a)(tileExtent, -tileGrid.getResolution(z), tileExtent);
            if (!(0, $110ceb23457e07e7$export$7b0a31e10bbff018)(sourceExtent, tileExtent)) urlTileCoord = null;
        }
        let empty = true;
        if (urlTileCoord !== null) {
            const sourceTileGrid = this.tileGrid;
            const resolution = tileGrid.getResolution(z);
            const sourceZ = sourceTileGrid.getZForResolution(resolution, 1);
            // make extent 1 pixel smaller so we don't load tiles for < 0.5 pixel render space
            const extent = tileGrid.getTileCoordExtent(urlTileCoord);
            (0, $110ceb23457e07e7$export$ab1029bcae9ddb4a)(extent, -resolution, extent);
            sourceTileGrid.forEachTileCoord(extent, sourceZ, (sourceTileCoord)=>{
                empty = empty && !this.tileUrlFunction(sourceTileCoord, pixelRatio, projection);
            });
        }
        const newTile = new (0, $690a7d006ee12010$export$2e2bcd8739ae039)(tileCoord, empty ? (0, $34f0277fe2789b80$export$2e2bcd8739ae039).EMPTY : (0, $34f0277fe2789b80$export$2e2bcd8739ae039).IDLE, urlTileCoord, this.getSourceTiles.bind(this, pixelRatio, projection), this.removeSourceTiles.bind(this));
        newTile.key = this.getKey();
        return newTile;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   * @override
   */ getTileGridForProjection(projection) {
        const code = projection.getCode();
        let tileGrid = this.tileGrids_[code];
        if (!tileGrid) {
            const sourceProjection = this.getProjection();
            (0, $4b57691230be0bd5$export$a7a9523472993e97)(sourceProjection === null || (0, $d447c151baf41c8c$export$fe091d73a555748b)(sourceProjection, projection), 'A VectorTile source can only be rendered if it has a projection compatible with the view projection.');
            // A tile grid that matches the tile size of the source tile grid is more
            // likely to have 1:1 relationships between source tiles and rendered tiles.
            const sourceTileGrid = this.tileGrid;
            const resolutions = sourceTileGrid.getResolutions().slice();
            const origins = resolutions.map(function(resolution, z) {
                return sourceTileGrid.getOrigin(z);
            });
            const tileSizes = resolutions.map(function(resolution, z) {
                return sourceTileGrid.getTileSize(z);
            });
            const length = (0, $70f6cba5b5336314$export$e98a216cdcc847dc) + 1;
            for(let z = resolutions.length; z < length; ++z){
                resolutions.push(resolutions[z - 1] / 2);
                origins.push(origins[z - 1]);
                tileSizes.push(tileSizes[z - 1]);
            }
            tileGrid = new (0, $9265c7f0d03c6a23$export$2e2bcd8739ae039)({
                extent: sourceTileGrid.getExtent(),
                origins: origins,
                resolutions: resolutions,
                tileSizes: tileSizes
            });
            this.tileGrids_[code] = tileGrid;
        }
        return tileGrid;
    }
    /**
   * Get the tile pixel ratio for this source.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   * @override
   */ getTilePixelRatio(pixelRatio) {
        return pixelRatio;
    }
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   * @override
   */ getTilePixelSize(z, pixelRatio, projection) {
        const tileGrid = this.getTileGridForProjection(projection);
        const tileSize = (0, $090e4507b3b63c57$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
        return [
            Math.round(tileSize[0] * pixelRatio),
            Math.round(tileSize[1] * pixelRatio)
        ];
    }
    /**
   * @param {boolean} overlaps The source has overlapping geometries.
   */ setOverlaps(overlaps) {
        this.overlaps_ = overlaps;
        this.changed();
    }
}
var $429d8626291b2422$export$2e2bcd8739ae039 = $429d8626291b2422$var$VectorTile;
function $429d8626291b2422$export$7a0df80a606b730e(tile, url) {
    tile.setLoader(/**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */ function(extent, resolution, projection) {
        (0, $4fbf60f1e6dcbc40$export$441d7b57adab24d0)(url, tile.getFormat(), extent, resolution, projection, tile.onLoad.bind(tile), tile.onError.bind(tile));
    });
}


/**
 * @module ol/format/MVT
 */ //FIXME Implement projection handling
const $5d55e842ce873226$var$SHIFT_LEFT_32 = 4294967296;
const $5d55e842ce873226$var$SHIFT_RIGHT_32 = 1 / $5d55e842ce873226$var$SHIFT_LEFT_32;
// Threshold chosen based on both benchmarking and knowledge about browser string
// data structures (which currently switch structure types at 12 bytes or more)
const $5d55e842ce873226$var$TEXT_DECODER_MIN_LENGTH = 12;
const $5d55e842ce873226$var$utf8TextDecoder = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8');
const $5d55e842ce873226$var$PBF_VARINT = 0; // varint: int32, int64, uint32, uint64, sint32, sint64, bool, enum
const $5d55e842ce873226$var$PBF_FIXED64 = 1; // 64-bit: double, fixed64, sfixed64
const $5d55e842ce873226$var$PBF_BYTES = 2; // length-delimited: string, bytes, embedded messages, packed repeated fields
const $5d55e842ce873226$var$PBF_FIXED32 = 5; // 32-bit: float, fixed32, sfixed32
class $5d55e842ce873226$export$2e2bcd8739ae039 {
    /**
     * @param {Uint8Array | ArrayBuffer} [buf]
     */ constructor(buf = new Uint8Array(16)){
        this.buf = ArrayBuffer.isView(buf) ? buf : new Uint8Array(buf);
        this.dataView = new DataView(this.buf.buffer);
        this.pos = 0;
        this.type = 0;
        this.length = this.buf.length;
    }
    // === READING =================================================================
    /**
     * @template T
     * @param {(tag: number, result: T, pbf: Pbf) => void} readField
     * @param {T} result
     * @param {number} [end]
     */ readFields(readField, result, end = this.length) {
        while(this.pos < end){
            const val = this.readVarint(), tag = val >> 3, startPos = this.pos;
            this.type = val & 0x7;
            readField(tag, result, this);
            if (this.pos === startPos) this.skip(val);
        }
        return result;
    }
    /**
     * @template T
     * @param {(tag: number, result: T, pbf: Pbf) => void} readField
     * @param {T} result
     */ readMessage(readField, result) {
        return this.readFields(readField, result, this.readVarint() + this.pos);
    }
    readFixed32() {
        const val = this.dataView.getUint32(this.pos, true);
        this.pos += 4;
        return val;
    }
    readSFixed32() {
        const val = this.dataView.getInt32(this.pos, true);
        this.pos += 4;
        return val;
    }
    // 64-bit int handling is based on github.com/dpw/node-buffer-more-ints (MIT-licensed)
    readFixed64() {
        const val = this.dataView.getUint32(this.pos, true) + this.dataView.getUint32(this.pos + 4, true) * $5d55e842ce873226$var$SHIFT_LEFT_32;
        this.pos += 8;
        return val;
    }
    readSFixed64() {
        const val = this.dataView.getUint32(this.pos, true) + this.dataView.getInt32(this.pos + 4, true) * $5d55e842ce873226$var$SHIFT_LEFT_32;
        this.pos += 8;
        return val;
    }
    readFloat() {
        const val = this.dataView.getFloat32(this.pos, true);
        this.pos += 4;
        return val;
    }
    readDouble() {
        const val = this.dataView.getFloat64(this.pos, true);
        this.pos += 8;
        return val;
    }
    /**
     * @param {boolean} [isSigned]
     */ readVarint(isSigned) {
        const buf = this.buf;
        let val, b;
        b = buf[this.pos++];
        val = b & 0x7f;
        if (b < 0x80) return val;
        b = buf[this.pos++];
        val |= (b & 0x7f) << 7;
        if (b < 0x80) return val;
        b = buf[this.pos++];
        val |= (b & 0x7f) << 14;
        if (b < 0x80) return val;
        b = buf[this.pos++];
        val |= (b & 0x7f) << 21;
        if (b < 0x80) return val;
        b = buf[this.pos];
        val |= (b & 0x0f) << 28;
        return $5d55e842ce873226$var$readVarintRemainder(val, isSigned, this);
    }
    readVarint64() {
        return this.readVarint(true);
    }
    readSVarint() {
        const num = this.readVarint();
        return num % 2 === 1 ? (num + 1) / -2 : num / 2; // zigzag encoding
    }
    readBoolean() {
        return Boolean(this.readVarint());
    }
    readString() {
        const end = this.readVarint() + this.pos;
        const pos = this.pos;
        this.pos = end;
        if (end - pos >= $5d55e842ce873226$var$TEXT_DECODER_MIN_LENGTH && $5d55e842ce873226$var$utf8TextDecoder) // longer strings are fast with the built-in browser TextDecoder API
        return $5d55e842ce873226$var$utf8TextDecoder.decode(this.buf.subarray(pos, end));
        // short strings are fast with our custom implementation
        return $5d55e842ce873226$var$readUtf8(this.buf, pos, end);
    }
    readBytes() {
        const end = this.readVarint() + this.pos, buffer = this.buf.subarray(this.pos, end);
        this.pos = end;
        return buffer;
    }
    // verbose for performance reasons; doesn't affect gzipped size
    /**
     * @param {number[]} [arr]
     * @param {boolean} [isSigned]
     */ readPackedVarint(arr = [], isSigned) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readVarint(isSigned));
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedSVarint(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readSVarint());
        return arr;
    }
    /** @param {boolean[]} [arr] */ readPackedBoolean(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readBoolean());
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedFloat(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readFloat());
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedDouble(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readDouble());
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedFixed32(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readFixed32());
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedSFixed32(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readSFixed32());
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedFixed64(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readFixed64());
        return arr;
    }
    /** @param {number[]} [arr] */ readPackedSFixed64(arr = []) {
        const end = this.readPackedEnd();
        while(this.pos < end)arr.push(this.readSFixed64());
        return arr;
    }
    readPackedEnd() {
        return this.type === $5d55e842ce873226$var$PBF_BYTES ? this.readVarint() + this.pos : this.pos + 1;
    }
    /** @param {number} val */ skip(val) {
        const type = val & 0x7;
        if (type === $5d55e842ce873226$var$PBF_VARINT) while(this.buf[this.pos++] > 0x7f);
        else if (type === $5d55e842ce873226$var$PBF_BYTES) this.pos = this.readVarint() + this.pos;
        else if (type === $5d55e842ce873226$var$PBF_FIXED32) this.pos += 4;
        else if (type === $5d55e842ce873226$var$PBF_FIXED64) this.pos += 8;
        else throw new Error(`Unimplemented type: ${type}`);
    }
    // === WRITING =================================================================
    /**
     * @param {number} tag
     * @param {number} type
     */ writeTag(tag, type) {
        this.writeVarint(tag << 3 | type);
    }
    /** @param {number} min */ realloc(min) {
        let length = this.length || 16;
        while(length < this.pos + min)length *= 2;
        if (length !== this.length) {
            const buf = new Uint8Array(length);
            buf.set(this.buf);
            this.buf = buf;
            this.dataView = new DataView(buf.buffer);
            this.length = length;
        }
    }
    finish() {
        this.length = this.pos;
        this.pos = 0;
        return this.buf.subarray(0, this.length);
    }
    /** @param {number} val */ writeFixed32(val) {
        this.realloc(4);
        this.dataView.setInt32(this.pos, val, true);
        this.pos += 4;
    }
    /** @param {number} val */ writeSFixed32(val) {
        this.realloc(4);
        this.dataView.setInt32(this.pos, val, true);
        this.pos += 4;
    }
    /** @param {number} val */ writeFixed64(val) {
        this.realloc(8);
        this.dataView.setInt32(this.pos, val & -1, true);
        this.dataView.setInt32(this.pos + 4, Math.floor(val * $5d55e842ce873226$var$SHIFT_RIGHT_32), true);
        this.pos += 8;
    }
    /** @param {number} val */ writeSFixed64(val) {
        this.realloc(8);
        this.dataView.setInt32(this.pos, val & -1, true);
        this.dataView.setInt32(this.pos + 4, Math.floor(val * $5d55e842ce873226$var$SHIFT_RIGHT_32), true);
        this.pos += 8;
    }
    /** @param {number} val */ writeVarint(val) {
        val = +val || 0;
        if (val > 0xfffffff || val < 0) {
            $5d55e842ce873226$var$writeBigVarint(val, this);
            return;
        }
        this.realloc(4);
        this.buf[this.pos++] = val & 0x7f | (val > 0x7f ? 0x80 : 0);
        if (val <= 0x7f) return;
        this.buf[this.pos++] = (val >>>= 7) & 0x7f | (val > 0x7f ? 0x80 : 0);
        if (val <= 0x7f) return;
        this.buf[this.pos++] = (val >>>= 7) & 0x7f | (val > 0x7f ? 0x80 : 0);
        if (val <= 0x7f) return;
        this.buf[this.pos++] = val >>> 7 & 0x7f;
    }
    /** @param {number} val */ writeSVarint(val) {
        this.writeVarint(val < 0 ? -val * 2 - 1 : val * 2);
    }
    /** @param {boolean} val */ writeBoolean(val) {
        this.writeVarint(+val);
    }
    /** @param {string} str */ writeString(str) {
        str = String(str);
        this.realloc(str.length * 4);
        this.pos++; // reserve 1 byte for short string length
        const startPos = this.pos;
        // write the string directly to the buffer and see how much was written
        this.pos = $5d55e842ce873226$var$writeUtf8(this.buf, str, this.pos);
        const len = this.pos - startPos;
        if (len >= 0x80) $5d55e842ce873226$var$makeRoomForExtraLength(startPos, len, this);
        // finally, write the message length in the reserved place and restore the position
        this.pos = startPos - 1;
        this.writeVarint(len);
        this.pos += len;
    }
    /** @param {number} val */ writeFloat(val) {
        this.realloc(4);
        this.dataView.setFloat32(this.pos, val, true);
        this.pos += 4;
    }
    /** @param {number} val */ writeDouble(val) {
        this.realloc(8);
        this.dataView.setFloat64(this.pos, val, true);
        this.pos += 8;
    }
    /** @param {Uint8Array} buffer */ writeBytes(buffer) {
        const len = buffer.length;
        this.writeVarint(len);
        this.realloc(len);
        for(let i = 0; i < len; i++)this.buf[this.pos++] = buffer[i];
    }
    /**
     * @template T
     * @param {(obj: T, pbf: Pbf) => void} fn
     * @param {T} obj
     */ writeRawMessage(fn, obj) {
        this.pos++; // reserve 1 byte for short message length
        // write the message directly to the buffer and see how much was written
        const startPos = this.pos;
        fn(obj, this);
        const len = this.pos - startPos;
        if (len >= 0x80) $5d55e842ce873226$var$makeRoomForExtraLength(startPos, len, this);
        // finally, write the message length in the reserved place and restore the position
        this.pos = startPos - 1;
        this.writeVarint(len);
        this.pos += len;
    }
    /**
     * @template T
     * @param {number} tag
     * @param {(obj: T, pbf: Pbf) => void} fn
     * @param {T} obj
     */ writeMessage(tag, fn, obj) {
        this.writeTag(tag, $5d55e842ce873226$var$PBF_BYTES);
        this.writeRawMessage(fn, obj);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedVarint(tag, arr) {
        if (arr.length) this.writeMessage(tag, $5d55e842ce873226$var$writePackedVarint, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedSVarint(tag, arr) {
        if (arr.length) this.writeMessage(tag, $5d55e842ce873226$var$writePackedSVarint, arr);
    }
    /**
     * @param {number} tag
     * @param {boolean[]} arr
     */ writePackedBoolean(tag, arr) {
        if (arr.length) this.writeMessage(tag, $5d55e842ce873226$var$writePackedBoolean, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedFloat(tag, arr) {
        if (arr.length) this.writeMessage(tag, $5d55e842ce873226$var$writePackedFloat, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedDouble(tag, arr) {
        if (arr.length) this.writeMessage(tag, $5d55e842ce873226$var$writePackedDouble, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedFixed32(tag, arr) {
        if (arr.length) this.writeMessage(tag, $5d55e842ce873226$var$writePackedFixed32, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedSFixed32(tag, arr) {
        if (arr.length) this.writeMessage(tag, $5d55e842ce873226$var$writePackedSFixed32, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedFixed64(tag, arr) {
        if (arr.length) this.writeMessage(tag, $5d55e842ce873226$var$writePackedFixed64, arr);
    }
    /**
     * @param {number} tag
     * @param {number[]} arr
     */ writePackedSFixed64(tag, arr) {
        if (arr.length) this.writeMessage(tag, $5d55e842ce873226$var$writePackedSFixed64, arr);
    }
    /**
     * @param {number} tag
     * @param {Uint8Array} buffer
     */ writeBytesField(tag, buffer) {
        this.writeTag(tag, $5d55e842ce873226$var$PBF_BYTES);
        this.writeBytes(buffer);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeFixed32Field(tag, val) {
        this.writeTag(tag, $5d55e842ce873226$var$PBF_FIXED32);
        this.writeFixed32(val);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeSFixed32Field(tag, val) {
        this.writeTag(tag, $5d55e842ce873226$var$PBF_FIXED32);
        this.writeSFixed32(val);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeFixed64Field(tag, val) {
        this.writeTag(tag, $5d55e842ce873226$var$PBF_FIXED64);
        this.writeFixed64(val);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeSFixed64Field(tag, val) {
        this.writeTag(tag, $5d55e842ce873226$var$PBF_FIXED64);
        this.writeSFixed64(val);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeVarintField(tag, val) {
        this.writeTag(tag, $5d55e842ce873226$var$PBF_VARINT);
        this.writeVarint(val);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeSVarintField(tag, val) {
        this.writeTag(tag, $5d55e842ce873226$var$PBF_VARINT);
        this.writeSVarint(val);
    }
    /**
     * @param {number} tag
     * @param {string} str
     */ writeStringField(tag, str) {
        this.writeTag(tag, $5d55e842ce873226$var$PBF_BYTES);
        this.writeString(str);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeFloatField(tag, val) {
        this.writeTag(tag, $5d55e842ce873226$var$PBF_FIXED32);
        this.writeFloat(val);
    }
    /**
     * @param {number} tag
     * @param {number} val
     */ writeDoubleField(tag, val) {
        this.writeTag(tag, $5d55e842ce873226$var$PBF_FIXED64);
        this.writeDouble(val);
    }
    /**
     * @param {number} tag
     * @param {boolean} val
     */ writeBooleanField(tag, val) {
        this.writeVarintField(tag, +val);
    }
}
/**
 * @param {number} l
 * @param {boolean | undefined} s
 * @param {Pbf} p
 */ function $5d55e842ce873226$var$readVarintRemainder(l, s, p) {
    const buf = p.buf;
    let h, b;
    b = buf[p.pos++];
    h = (b & 0x70) >> 4;
    if (b < 0x80) return $5d55e842ce873226$var$toNum(l, h, s);
    b = buf[p.pos++];
    h |= (b & 0x7f) << 3;
    if (b < 0x80) return $5d55e842ce873226$var$toNum(l, h, s);
    b = buf[p.pos++];
    h |= (b & 0x7f) << 10;
    if (b < 0x80) return $5d55e842ce873226$var$toNum(l, h, s);
    b = buf[p.pos++];
    h |= (b & 0x7f) << 17;
    if (b < 0x80) return $5d55e842ce873226$var$toNum(l, h, s);
    b = buf[p.pos++];
    h |= (b & 0x7f) << 24;
    if (b < 0x80) return $5d55e842ce873226$var$toNum(l, h, s);
    b = buf[p.pos++];
    h |= (b & 0x01) << 31;
    if (b < 0x80) return $5d55e842ce873226$var$toNum(l, h, s);
    throw new Error('Expected varint not more than 10 bytes');
}
/**
 * @param {number} low
 * @param {number} high
 * @param {boolean} [isSigned]
 */ function $5d55e842ce873226$var$toNum(low, high, isSigned) {
    return isSigned ? high * 0x100000000 + (low >>> 0) : (high >>> 0) * 0x100000000 + (low >>> 0);
}
/**
 * @param {number} val
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$writeBigVarint(val, pbf) {
    let low, high;
    if (val >= 0) {
        low = val % 0x100000000 | 0;
        high = val / 0x100000000 | 0;
    } else {
        low = ~(-val % 0x100000000);
        high = ~(-val / 0x100000000);
        if (low ^ 0xffffffff) low = low + 1 | 0;
        else {
            low = 0;
            high = high + 1 | 0;
        }
    }
    if (val >= 0x10000000000000000 || val < -18446744073709552000) throw new Error('Given varint doesn\'t fit into 10 bytes');
    pbf.realloc(10);
    $5d55e842ce873226$var$writeBigVarintLow(low, high, pbf);
    $5d55e842ce873226$var$writeBigVarintHigh(high, pbf);
}
/**
 * @param {number} high
 * @param {number} low
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$writeBigVarintLow(low, high, pbf) {
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80;
    low >>>= 7;
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80;
    low >>>= 7;
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80;
    low >>>= 7;
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80;
    low >>>= 7;
    pbf.buf[pbf.pos] = low & 0x7f;
}
/**
 * @param {number} high
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$writeBigVarintHigh(high, pbf) {
    const lsb = (high & 0x07) << 4;
    pbf.buf[pbf.pos++] |= lsb | ((high >>>= 3) ? 0x80 : 0);
    if (!high) return;
    pbf.buf[pbf.pos++] = high & 0x7f | ((high >>>= 7) ? 0x80 : 0);
    if (!high) return;
    pbf.buf[pbf.pos++] = high & 0x7f | ((high >>>= 7) ? 0x80 : 0);
    if (!high) return;
    pbf.buf[pbf.pos++] = high & 0x7f | ((high >>>= 7) ? 0x80 : 0);
    if (!high) return;
    pbf.buf[pbf.pos++] = high & 0x7f | ((high >>>= 7) ? 0x80 : 0);
    if (!high) return;
    pbf.buf[pbf.pos++] = high & 0x7f;
}
/**
 * @param {number} startPos
 * @param {number} len
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$makeRoomForExtraLength(startPos, len, pbf) {
    const extraLen = len <= 0x3fff ? 1 : len <= 0x1fffff ? 2 : len <= 0xfffffff ? 3 : Math.floor(Math.log(len) / (Math.LN2 * 7));
    // if 1 byte isn't enough for encoding message length, shift the data to the right
    pbf.realloc(extraLen);
    for(let i = pbf.pos - 1; i >= startPos; i--)pbf.buf[i + extraLen] = pbf.buf[i];
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$writePackedVarint(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeVarint(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$writePackedSVarint(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeSVarint(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$writePackedFloat(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeFloat(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$writePackedDouble(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeDouble(arr[i]);
}
/**
 * @param {boolean[]} arr
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$writePackedBoolean(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeBoolean(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$writePackedFixed32(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeFixed32(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$writePackedSFixed32(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeSFixed32(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$writePackedFixed64(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeFixed64(arr[i]);
}
/**
 * @param {number[]} arr
 * @param {Pbf} pbf
 */ function $5d55e842ce873226$var$writePackedSFixed64(arr, pbf) {
    for(let i = 0; i < arr.length; i++)pbf.writeSFixed64(arr[i]);
}
// Buffer code below from https://github.com/feross/buffer, MIT-licensed
/**
 * @param {Uint8Array} buf
 * @param {number} pos
 * @param {number} end
 */ function $5d55e842ce873226$var$readUtf8(buf, pos, end) {
    let str = '';
    let i = pos;
    while(i < end){
        const b0 = buf[i];
        let c = null; // codepoint
        let bytesPerSequence = b0 > 0xEF ? 4 : b0 > 0xDF ? 3 : b0 > 0xBF ? 2 : 1;
        if (i + bytesPerSequence > end) break;
        let b1, b2, b3;
        if (bytesPerSequence === 1) {
            if (b0 < 0x80) c = b0;
        } else if (bytesPerSequence === 2) {
            b1 = buf[i + 1];
            if ((b1 & 0xC0) === 0x80) {
                c = (b0 & 0x1F) << 0x6 | b1 & 0x3F;
                if (c <= 0x7F) c = null;
            }
        } else if (bytesPerSequence === 3) {
            b1 = buf[i + 1];
            b2 = buf[i + 2];
            if ((b1 & 0xC0) === 0x80 && (b2 & 0xC0) === 0x80) {
                c = (b0 & 0xF) << 0xC | (b1 & 0x3F) << 0x6 | b2 & 0x3F;
                if (c <= 0x7FF || c >= 0xD800 && c <= 0xDFFF) c = null;
            }
        } else if (bytesPerSequence === 4) {
            b1 = buf[i + 1];
            b2 = buf[i + 2];
            b3 = buf[i + 3];
            if ((b1 & 0xC0) === 0x80 && (b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                c = (b0 & 0xF) << 0x12 | (b1 & 0x3F) << 0xC | (b2 & 0x3F) << 0x6 | b3 & 0x3F;
                if (c <= 0xFFFF || c >= 0x110000) c = null;
            }
        }
        if (c === null) {
            c = 0xFFFD;
            bytesPerSequence = 1;
        } else if (c > 0xFFFF) {
            c -= 0x10000;
            str += String.fromCharCode(c >>> 10 & 0x3FF | 0xD800);
            c = 0xDC00 | c & 0x3FF;
        }
        str += String.fromCharCode(c);
        i += bytesPerSequence;
    }
    return str;
}
/**
 * @param {Uint8Array} buf
 * @param {string} str
 * @param {number} pos
 */ function $5d55e842ce873226$var$writeUtf8(buf, str, pos) {
    for(let i = 0, c, lead; i < str.length; i++){
        c = str.charCodeAt(i); // code point
        if (c > 0xD7FF && c < 0xE000) {
            if (lead) {
                if (c < 0xDC00) {
                    buf[pos++] = 0xEF;
                    buf[pos++] = 0xBF;
                    buf[pos++] = 0xBD;
                    lead = c;
                    continue;
                } else {
                    c = lead - 0xD800 << 10 | c - 0xDC00 | 0x10000;
                    lead = null;
                }
            } else {
                if (c > 0xDBFF || i + 1 === str.length) {
                    buf[pos++] = 0xEF;
                    buf[pos++] = 0xBF;
                    buf[pos++] = 0xBD;
                } else lead = c;
                continue;
            }
        } else if (lead) {
            buf[pos++] = 0xEF;
            buf[pos++] = 0xBF;
            buf[pos++] = 0xBD;
            lead = null;
        }
        if (c < 0x80) buf[pos++] = c;
        else {
            if (c < 0x800) buf[pos++] = c >> 0x6 | 0xC0;
            else {
                if (c < 0x10000) buf[pos++] = c >> 0xC | 0xE0;
                else {
                    buf[pos++] = c >> 0x12 | 0xF0;
                    buf[pos++] = c >> 0xC & 0x3F | 0x80;
                }
                buf[pos++] = c >> 0x6 & 0x3F | 0x80;
            }
            buf[pos++] = c & 0x3F | 0x80;
        }
    }
    return pos;
}


/**
 * @module ol/geom/LineString
 */ 





/**
 * @module ol/geom/flat/interpolate
 */ 

function $9a3c3f6952b8cb4a$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, dest, dimension) {
    let o, t;
    const n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        let x1 = flatCoordinates[offset];
        let y1 = flatCoordinates[offset + 1];
        let length = 0;
        const cumulativeLengths = [
            0
        ];
        for(let i = offset + stride; i < end; i += stride){
            const x2 = flatCoordinates[i];
            const y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length);
            x1 = x2;
            y1 = y2;
        }
        const target = fraction * length;
        const index = (0, $9d07dd9052c3de0c$export$2e0ae67339d5f1ac)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    dimension = dimension > 1 ? dimension : 2;
    dest = dest ? dest : new Array(dimension);
    for(let i = 0; i < dimension; ++i)dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    return dest;
}
function $9a3c3f6952b8cb4a$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    let coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    let lo = offset / stride;
    let hi = end / stride;
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    const m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    const m1 = flatCoordinates[(lo + 1) * stride - 1];
    const t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(let i = 0; i < stride - 1; ++i)coordinate.push((0, $91ceb5420a5c8360$export$3a89f8d6f6bf6c9f)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $9a3c3f6952b8cb4a$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $9a3c3f6952b8cb4a$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    let coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        if (m <= flatCoordinates[end - 1]) return $9a3c3f6952b8cb4a$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}






/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ class $0b7dcb8925c7efc9$var$LineString extends (0, $2d119a5aa713a216$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatMidpoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.flatMidpointRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */ appendCoordinate(coordinate) {
        (0, $9d07dd9052c3de0c$export$8b58be045bf06082)(this.flatCoordinates, coordinate);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   * @override
   */ clone() {
        const lineString = new $0b7dcb8925c7efc9$var$LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $110ceb23457e07e7$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $51142fc8a680af11$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $51142fc8a680af11$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */ forEachSegment(callback) {
        return (0, $ddb0e9c06f77a946$export$4b80e395e36b5a56)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM') return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        return (0, $9a3c3f6952b8cb4a$export$8f44c3c220ef6f09)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    }
    /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $2a6a9b7fa6b84967$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */ getCoordinateAt(fraction, dest) {
        return (0, $9a3c3f6952b8cb4a$export$687ff82efd78795b)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, dest, this.stride);
    }
    /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        return (0, $c8b5172932bfde43$export$153f8c6b4d8caebc)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_ ?? undefined);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatMidpoint_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $91af87e7f153f420$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $0b7dcb8925c7efc9$var$LineString(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $fff493cc9a5ff53b$export$40d8d71841a3d779)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent, this.getExtent());
    }
    /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $46dd16ae2ee5c902$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $0b7dcb8925c7efc9$export$2e2bcd8739ae039 = $0b7dcb8925c7efc9$var$LineString;


/**
 * @module ol/geom/MultiLineString
 */ 










/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ class $b66089af173c4ae0$var$MultiLineString extends (0, $2d119a5aa713a216$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Flat coordinate ends for internal use.
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
        else if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else {
            const lineStrings = /** @type {Array<LineString>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const ends = [];
            for(let i = 0, ii = lineStrings.length; i < ii; ++i){
                const lineString = lineStrings[i];
                (0, $9d07dd9052c3de0c$export$8b58be045bf06082)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            const layout = lineStrings.length === 0 ? this.getLayout() : lineStrings[0].getLayout();
            this.setFlatCoordinates(layout, flatCoordinates);
            this.ends_ = ends;
        }
    }
    /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */ appendLineString(lineString) {
        (0, $9d07dd9052c3de0c$export$8b58be045bf06082)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   * @override
   */ clone() {
        const multiLineString = new $b66089af173c4ae0$var$MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $110ceb23457e07e7$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $51142fc8a680af11$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $51142fc8a680af11$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate, interpolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM' || this.flatCoordinates.length === 0) return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        interpolate = interpolate !== undefined ? interpolate : false;
        return (0, $9a3c3f6952b8cb4a$export$6a3300857e9ef453)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    }
    /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $2a6a9b7fa6b84967$export$cbb9596fc0f40db2)(this.flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */ getLineString(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $0b7dcb8925c7efc9$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */ getLineStrings() {
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const layout = this.layout;
        /** @type {Array<LineString>} */ const lineStrings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const lineString = new (0, $0b7dcb8925c7efc9$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    }
    /**
   * Return the sum of all line string lengths
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        const ends = this.ends_;
        let start = 0;
        let length = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            length += (0, $c8b5172932bfde43$export$153f8c6b4d8caebc)(this.flatCoordinates, start, ends[i], this.stride);
            start = ends[i];
        }
        return length;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        /** @type {Array<number>} */ const midpoints = [];
        const flatCoordinates = this.flatCoordinates;
        let offset = 0;
        const ends = this.ends_;
        const stride = this.stride;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const midpoint = (0, $9a3c3f6952b8cb4a$export$687ff82efd78795b)(flatCoordinates, offset, end, stride, 0.5);
            (0, $9d07dd9052c3de0c$export$8b58be045bf06082)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $91af87e7f153f420$export$cedb9900c0b225c2)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $b66089af173c4ae0$var$MultiLineString(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiLineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $fff493cc9a5ff53b$export$fdb1d8e850bf7937)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $46dd16ae2ee5c902$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $b66089af173c4ae0$export$2e2bcd8739ae039 = $b66089af173c4ae0$var$MultiLineString;


/**
 * @module ol/geom/MultiPoint
 */ 






/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ class $dc589d5f6ce8c14b$var$MultiPoint extends (0, $2d119a5aa713a216$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        if (layout && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */ appendPoint(point) {
        (0, $9d07dd9052c3de0c$export$8b58be045bf06082)(this.flatCoordinates, point.getFlatCoordinates());
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   * @override
   */ clone() {
        const multiPoint = new $dc589d5f6ce8c14b$var$MultiPoint(this.flatCoordinates.slice(), this.layout);
        multiPoint.applyProperties(this);
        return multiPoint;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $110ceb23457e07e7$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const squaredDistance = (0, $91ceb5420a5c8360$export$88e6ebb4fe54f538)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for(let j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $2a6a9b7fa6b84967$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */ getPoint(index) {
        const n = this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) return null;
        return new (0, $6d7bc2de9d52ca58$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    }
    /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */ getPoints() {
        const flatCoordinates = this.flatCoordinates;
        const layout = this.layout;
        const stride = this.stride;
        /** @type {Array<Point>} */ const points = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const point = new (0, $6d7bc2de9d52ca58$export$2e2bcd8739ae039)(flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPoint';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            if ((0, $110ceb23457e07e7$export$805bdfd6d6690e97)(extent, x, y)) return true;
        }
        return false;
    }
    /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $46dd16ae2ee5c902$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $dc589d5f6ce8c14b$export$2e2bcd8739ae039 = $dc589d5f6ce8c14b$var$MultiPoint;


/**
 * @module ol/geom/MultiPolygon
 */ 





/**
 * @module ol/geom/flat/center
 */ 
function $37f2de4a59589468$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    const flatCenters = [];
    let extent = (0, $110ceb23457e07e7$export$fe201bb3bbe031e9)();
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        extent = (0, $110ceb23457e07e7$export$be0ab0bf96ca59ca)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}










/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ class $be4913079f931a6a$var$MultiPolygon extends (0, $2d119a5aa713a216$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` and `endss` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<Array<number>>} [endss] Array of ends for internal use with flat coordinates.
   */ constructor(coordinates, layout, endss){
        super();
        /**
     * @type {Array<Array<number>>}
     * @private
     */ this.endss_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointsRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (!endss && !Array.isArray(coordinates[0])) {
            const polygons = /** @type {Array<Polygon>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const thisEndss = [];
            for(let i = 0, ii = polygons.length; i < ii; ++i){
                const polygon = polygons[i];
                const offset = flatCoordinates.length;
                const ends = polygon.getEnds();
                for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, $9d07dd9052c3de0c$export$8b58be045bf06082)(flatCoordinates, polygon.getFlatCoordinates());
                thisEndss.push(ends);
            }
            layout = polygons.length === 0 ? this.getLayout() : polygons[0].getLayout();
            coordinates = flatCoordinates;
            endss = thisEndss;
        }
        if (layout !== undefined && endss) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.endss_ = endss;
        } else this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, layout);
    }
    /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */ appendPolygon(polygon) {
        /** @type {Array<number>} */ let ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        } else {
            const offset = this.flatCoordinates.length;
            (0, $9d07dd9052c3de0c$export$8b58be045bf06082)(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
        }
        this.endss_.push(ends);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   * @override
   */ clone() {
        const len = this.endss_.length;
        const newEndss = new Array(len);
        for(let i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
        const multiPolygon = new $be4913079f931a6a$var$MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
        multiPolygon.applyProperties(this);
        return multiPolygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $110ceb23457e07e7$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $51142fc8a680af11$export$37c18e6e7d50501a)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $51142fc8a680af11$export$60e067685eb8f9c4)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $c26bd518b1a628ec$export$c760d9d16cf92043)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    }
    /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $284a9b995eb47f84$export$78e139679ca7205)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $5639f71071079d61$export$ea9ed55fc2a85010)(flatCoordinates, 0, this.endss_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $2a6a9b7fa6b84967$export$915c7058aeb4dfeb)(flatCoordinates, 0, this.endss_, this.stride);
    }
    /**
   * @return {Array<Array<number>>} Endss.
   */ getEndss() {
        return this.endss_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            const flatCenters = (0, $37f2de4a59589468$export$78e139679ca7205)(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = (0, $96ebab432ff2aabb$export$11463803eda8a372)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatInteriorPoints_;
    }
    /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoints() {
        return new (0, $dc589d5f6ce8c14b$export$2e2bcd8739ae039)(this.getFlatInteriorPoints().slice(), 'XYM');
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $5639f71071079d61$export$a1d138f4bd85f4b4)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $5639f71071079d61$export$ea9ed55fc2a85010)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<Array<number>>} */ const simplifiedEndss = [];
        simplifiedFlatCoordinates.length = (0, $91af87e7f153f420$export$b9acf67ef05cd17c)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new $be4913079f931a6a$var$MultiPolygon(simplifiedFlatCoordinates, 'XY', simplifiedEndss);
    }
    /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */ getPolygon(index) {
        if (index < 0 || this.endss_.length <= index) return null;
        let offset;
        if (index === 0) offset = 0;
        else {
            const prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        const ends = this.endss_[index].slice();
        const end = ends[ends.length - 1];
        if (offset !== 0) for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
        return new (0, $9549b42604551fb5$export$2e2bcd8739ae039)(this.flatCoordinates.slice(offset, end), this.layout, ends);
    }
    /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */ getPolygons() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const endss = this.endss_;
        const polygons = [];
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i){
            const ends = endss[i].slice();
            const end = ends[ends.length - 1];
            if (offset !== 0) for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
            const polygon = new (0, $9549b42604551fb5$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPolygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $fff493cc9a5ff53b$export$77b72fa3792f5bf0)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 3);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const endss = (0, $46dd16ae2ee5c902$export$f9f2bb59da4accd3)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) this.flatCoordinates.length = 0;
        else {
            const lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    }
}
var $be4913079f931a6a$export$2e2bcd8739ae039 = $be4913079f931a6a$var$MultiPolygon;







/**
 * @module ol/render/Feature
 */ /**
 * @module ol/Feature
 */ 



/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:geometry', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */ /***
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @typedef {Object<string, *> & { geometry?: Geometry }} ObjectWithGeometry
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature.js';
 * import Polygon from 'ol/geom/Polygon.js';
 * import Point from 'ol/geom/Point.js';
 *
 * const feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon',
 * });
 *
 * // get the polygon geometry
 * const poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * const point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 */ class $b9e33cd4bf1ba8a3$var$Feature extends (0, $32070d44509bac34$export$2e2bcd8739ae039) {
    /**
   * @param {Geometry|ObjectWithGeometry<Geometry>} [geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */ constructor(geometryOrProperties){
        super();
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {FeatureOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = undefined;
        /**
     * @type {string}
     * @private
     */ this.geometryName_ = 'geometry';
        /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */ this.style_ = null;
        /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */ this.styleFunction_ = undefined;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.geometryChangeKey_ = null;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        if (geometryOrProperties) {
            if (typeof /** @type {?} */ geometryOrProperties.getSimplifiedGeometry === 'function') {
                const geometry = /** @type {Geometry} */ geometryOrProperties;
                this.setGeometry(geometry);
            } else {
                /** @type {Object<string, *>} */ const properties = geometryOrProperties;
                this.setProperties(properties);
            }
        }
    }
    /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */ clone() {
        const clone = /** @type {Feature<Geometry>} */ new $b9e33cd4bf1ba8a3$var$Feature(this.hasProperties() ? this.getProperties() : null);
        clone.setGeometryName(this.getGeometryName());
        const geometry = this.getGeometry();
        if (geometry) clone.setGeometry(/** @type {Geometry} */ geometry.clone());
        const style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    }
    /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */ getGeometry() {
        return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */ getGeometryName() {
        return this.geometryName_;
    }
    /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @private
   */ handleGeometryChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleGeometryChanged_() {
        if (this.geometryChangeKey_) {
            (0, $7d7dee7854c96264$export$b0a21c8b3c1c921)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        const geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, $7d7dee7854c96264$export$63174c828edd6ff8)(geometry, (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    }
    /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */ setGeometry(geometry) {
        this.set(this.geometryName_, geometry);
    }
    /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setStyle(style) {
        this.style_ = style;
        this.styleFunction_ = !style ? undefined : $b9e33cd4bf1ba8a3$export$bb06ddfd5d66e02e(style);
        this.changed();
    }
    /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setId(id) {
        this.id_ = id;
        this.changed();
    }
    /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */ setGeometryName(name) {
        this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    }
}
function $b9e33cd4bf1ba8a3$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === 'function') return obj;
    /**
   * @type {Array<import("./style/Style.js").default>}
   */ let styles;
    if (Array.isArray(obj)) styles = obj;
    else {
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `ol/style/Style` or an array of `ol/style/Style.js`');
        const style = /** @type {import("./style/Style.js").default} */ obj;
        styles = [
            style
        ];
    }
    return function() {
        return styles;
    };
}
var $b9e33cd4bf1ba8a3$export$2e2bcd8739ae039 = $b9e33cd4bf1ba8a3$var$Feature;














/**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'` or 'MultiLineString'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $e450b21b255017c3$var$tmpTransform = (0, $a684e03243281d90$export$185802fd694ee1f5)();
/**
 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
 * structure, optimized for vector tile rendering and styling. Geometry access
 * through the API is limited to getting the type and extent of the geometry.
 */ class $e450b21b255017c3$var$RenderFeature {
    /**
   * @param {Type} type Geometry type.
   * @param {Array<number>} flatCoordinates Flat coordinates. These always need
   *     to be right-handed for polygons.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Object<string, *>} properties Properties.
   * @param {number|string|undefined} id Feature id.
   */ constructor(type, flatCoordinates, ends, stride, properties, id){
        /**
     * @type {import("../style/Style.js").StyleFunction|undefined}
     */ this.styleFunction;
        /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */ this.extent_;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = id;
        /**
     * @private
     * @type {Type}
     */ this.type_ = type;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatCoordinates_ = flatCoordinates;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatMidpoints_ = null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.ends_ = ends || null;
        /**
     * @private
     * @type {Object<string, *>}
     */ this.properties_ = properties;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_;
        /**
     * @private
     * @type {number}
     */ this.stride_ = stride;
        /**
     * @private
     * @type {RenderFeature}
     */ this.simplifiedGeometry_;
    }
    /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */ get(key) {
        return this.properties_[key];
    }
    /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        if (!this.extent_) this.extent_ = this.type_ === 'Point' ? (0, $110ceb23457e07e7$export$4838bf78d04a9440)(this.flatCoordinates_) : (0, $110ceb23457e07e7$export$be0ab0bf96ca59ca)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2);
        return this.extent_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoint() {
        if (!this.flatInteriorPoints_) {
            const flatCenter = (0, $110ceb23457e07e7$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoints_ = (0, $96ebab432ff2aabb$export$50e3b25928a5e892)(this.flatCoordinates_, 0, this.ends_, 2, flatCenter, 0);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (!this.flatInteriorPoints_) {
            const ends = (0, $5639f71071079d61$export$cb72ae403d6e78e6)(this.flatCoordinates_, this.ends_);
            const flatCenters = (0, $37f2de4a59589468$export$78e139679ca7205)(this.flatCoordinates_, 0, ends, 2);
            this.flatInteriorPoints_ = (0, $96ebab432ff2aabb$export$11463803eda8a372)(this.flatCoordinates_, 0, ends, 2, flatCenters);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (!this.flatMidpoints_) this.flatMidpoints_ = (0, $9a3c3f6952b8cb4a$export$687ff82efd78795b)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, 0.5);
        return this.flatMidpoints_;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        if (!this.flatMidpoints_) {
            this.flatMidpoints_ = [];
            const flatCoordinates = this.flatCoordinates_;
            let offset = 0;
            const ends = /** @type {Array<number>} */ this.ends_;
            for(let i = 0, ii = ends.length; i < ii; ++i){
                const end = ends[i];
                const midpoint = (0, $9a3c3f6952b8cb4a$export$687ff82efd78795b)(flatCoordinates, offset, end, 2, 0.5);
                (0, $9d07dd9052c3de0c$export$8b58be045bf06082)(this.flatMidpoints_, midpoint);
                offset = end;
            }
        }
        return this.flatMidpoints_;
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getOrientedFlatCoordinates() {
        return this.flatCoordinates_;
    }
    /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */ getGeometry() {
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return this;
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this;
    }
    /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */ getProperties() {
        return this.properties_;
    }
    /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.properties_;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride_;
    }
    /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */ getStyleFunction() {
        return this.styleFunction;
    }
    /**
   * Get the type of this feature's geometry.
   * @return {Type} Geometry type.
   * @api
   */ getType() {
        return this.type_;
    }
    /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */ transform(projection) {
        projection = (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(projection);
        const pixelExtent = projection.getExtent();
        const projectedExtent = projection.getWorldExtent();
        if (pixelExtent && projectedExtent) {
            const scale = (0, $110ceb23457e07e7$export$c08559766941f856)(projectedExtent) / (0, $110ceb23457e07e7$export$c08559766941f856)(pixelExtent);
            (0, $a684e03243281d90$export$f672e0b6f7222cd7)($e450b21b255017c3$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $437d3763a798775b$export$b92b2dedcfff79de)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, $e450b21b255017c3$var$tmpTransform, this.flatCoordinates_);
        }
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   */ applyTransform(transformFn) {
        transformFn(this.flatCoordinates_, this.flatCoordinates_, this.stride_);
    }
    /**
   * @return {RenderFeature} A cloned render feature.
   */ clone() {
        return new $e450b21b255017c3$var$RenderFeature(this.type_, this.flatCoordinates_.slice(), this.ends_?.slice(), this.stride_, Object.assign({}, this.properties_), this.id_);
    }
    /**
   * @return {Array<number>|null} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Add transform and resolution based geometry simplification to this instance.
   * @return {RenderFeature} This render feature.
   */ enableSimplifyTransformed() {
        this.simplifyTransformed = (0, $1a39c7df251dabdd$export$ff83df6f9971435f)((squaredTolerance, transform)=>{
            if (squaredTolerance === this.squaredTolerance_) return this.simplifiedGeometry_;
            this.simplifiedGeometry_ = this.clone();
            if (transform) this.simplifiedGeometry_.applyTransform(transform);
            const simplifiedFlatCoordinates = this.simplifiedGeometry_.getFlatCoordinates();
            let simplifiedEnds;
            switch(this.type_){
                case 'LineString':
                    simplifiedFlatCoordinates.length = (0, $91af87e7f153f420$export$ef693d1572e64fb8)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.flatCoordinates_.length, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0);
                    simplifiedEnds = [
                        simplifiedFlatCoordinates.length
                    ];
                    break;
                case 'MultiLineString':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $91af87e7f153f420$export$cedb9900c0b225c2)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                case 'Polygon':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $91af87e7f153f420$export$60a9904b67f8d51b)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                default:
            }
            if (simplifiedEnds) this.simplifiedGeometry_ = new $e450b21b255017c3$var$RenderFeature(this.type_, simplifiedFlatCoordinates, simplifiedEnds, 2, this.properties_, this.id_);
            this.squaredTolerance_ = squaredTolerance;
            return this.simplifiedGeometry_;
        });
        return this;
    }
}
/**
 * @return {Array<number>} Flat coordinates.
 */ $e450b21b255017c3$var$RenderFeature.prototype.getFlatCoordinates = $e450b21b255017c3$var$RenderFeature.prototype.getOrientedFlatCoordinates;
function $e450b21b255017c3$export$b89ab3d1d30dec84(renderFeature) {
    const geometryType = renderFeature.getType();
    switch(geometryType){
        case 'Point':
            return new (0, $6d7bc2de9d52ca58$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates());
        case 'MultiPoint':
            return new (0, $dc589d5f6ce8c14b$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY');
        case 'LineString':
            return new (0, $0b7dcb8925c7efc9$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY');
        case 'MultiLineString':
            return new (0, $b66089af173c4ae0$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY', /** @type {Array<number>} */ renderFeature.getEnds());
        case 'Polygon':
            const flatCoordinates = renderFeature.getFlatCoordinates();
            const ends = renderFeature.getEnds();
            const endss = (0, $5639f71071079d61$export$cb72ae403d6e78e6)(flatCoordinates, ends);
            return endss.length > 1 ? new (0, $be4913079f931a6a$export$2e2bcd8739ae039)(flatCoordinates, 'XY', endss) : new (0, $9549b42604551fb5$export$2e2bcd8739ae039)(flatCoordinates, 'XY', ends);
        default:
            throw new Error('Invalid geometry type:' + geometryType);
    }
}
function $e450b21b255017c3$export$ab19ba60efd1c4b5(renderFeature, geometryName) {
    const id = renderFeature.getId();
    const geometry = $e450b21b255017c3$export$b89ab3d1d30dec84(renderFeature);
    const properties = renderFeature.getProperties();
    const feature = new (0, $b9e33cd4bf1ba8a3$export$2e2bcd8739ae039)();
    if (geometryName !== undefined) feature.setGeometryName(geometryName);
    feature.setGeometry(geometry);
    if (id !== undefined) feature.setId(id);
    feature.setProperties(properties, true);
    return feature;
}
var $e450b21b255017c3$export$2e2bcd8739ae039 = $e450b21b255017c3$var$RenderFeature;


/**
 * @module ol/format/Feature
 */ 

/**
 * @module ol/geom/GeometryCollection
 */ 



/**
 * @classdesc
 * An array of {@link module:ol/geom/Geometry~Geometry} objects.
 *
 * @api
 */ class $6b0a4ecd8d587c30$var$GeometryCollection extends (0, $e122192de230fc8c$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ constructor(geometries){
        super();
        /**
     * @private
     * @type {Array<Geometry>}
     */ this.geometries_ = geometries;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.changeEventsKeys_ = [];
        this.listenGeometriesChange_();
    }
    /**
   * @private
   */ unlistenGeometriesChange_() {
        this.changeEventsKeys_.forEach((0, $7d7dee7854c96264$export$b0a21c8b3c1c921));
        this.changeEventsKeys_.length = 0;
    }
    /**
   * @private
   */ listenGeometriesChange_() {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.changeEventsKeys_.push((0, $7d7dee7854c96264$export$63174c828edd6ff8)(geometries[i], (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, this.changed, this));
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!GeometryCollection} Clone.
   * @api
   * @override
   */ clone() {
        const geometryCollection = new $6b0a4ecd8d587c30$var$GeometryCollection($6b0a4ecd8d587c30$var$cloneGeometries(this.geometries_));
        geometryCollection.applyProperties(this);
        return geometryCollection;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $110ceb23457e07e7$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)minSquaredDistance = geometries[i].closestPointXY(x, y, closestPoint, minSquaredDistance);
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].containsXY(x, y)) return true;
        }
        return false;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        (0, $110ceb23457e07e7$export$3e2152b047719fa1)(extent);
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)(0, $110ceb23457e07e7$export$8b58be045bf06082)(extent, geometries[i].getExtent());
        return extent;
    }
    /**
   * Return the geometries that make up this geometry collection.
   * @return {Array<Geometry>} Geometries.
   * @api
   */ getGeometries() {
        return $6b0a4ecd8d587c30$var$cloneGeometries(this.geometries_);
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArray() {
        return this.geometries_;
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArrayRecursive() {
        /** @type {Array<Geometry>} */ let geometriesArray = [];
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)if (geometries[i].getType() === this.getType()) geometriesArray = geometriesArray.concat(/** @type {GeometryCollection} */ geometries[i].getGeometriesArrayRecursive());
        else geometriesArray.push(geometries[i]);
        return geometriesArray;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {GeometryCollection} Simplified GeometryCollection.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance < this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometries = [];
        const geometries = this.geometries_;
        let simplified = false;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            const geometry = geometries[i];
            const simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
            simplifiedGeometries.push(simplifiedGeometry);
            if (simplifiedGeometry !== geometry) simplified = true;
        }
        if (simplified) {
            const simplifiedGeometryCollection = new $6b0a4ecd8d587c30$var$GeometryCollection(simplifiedGeometries);
            return simplifiedGeometryCollection;
        }
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'GeometryCollection';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].intersectsExtent(extent)) return true;
        }
        return false;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.geometries_.length === 0;
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].rotate(angle, anchor);
        this.changed();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (!anchor) anchor = (0, $110ceb23457e07e7$export$c91255cadecfe081)(this.getExtent());
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].scale(sx, sy, anchor);
        this.changed();
    }
    /**
   * Set the geometries that make up this geometry collection.
   * @param {Array<Geometry>} geometries Geometries.
   * @api
   */ setGeometries(geometries) {
        this.setGeometriesArray($6b0a4ecd8d587c30$var$cloneGeometries(geometries));
    }
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ setGeometriesArray(geometries) {
        this.unlistenGeometriesChange_();
        this.geometries_ = geometries;
        this.listenGeometriesChange_();
        this.changed();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].applyTransform(transformFn);
        this.changed();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].translate(deltaX, deltaY);
        this.changed();
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.unlistenGeometriesChange_();
        super.disposeInternal();
    }
}
/**
 * @param {Array<Geometry>} geometries Geometries.
 * @return {Array<Geometry>} Cloned geometries.
 */ function $6b0a4ecd8d587c30$var$cloneGeometries(geometries) {
    return geometries.map((geometry)=>geometry.clone());
}
var $6b0a4ecd8d587c30$export$2e2bcd8739ae039 = $6b0a4ecd8d587c30$var$GeometryCollection;





/**
 * @typedef {Object} ReadOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
 * If not provided, the projection will be derived from the data (where possible) or
 * the `dataProjection` of the format is assigned (where set). If the projection
 * can not be derived from the data and if no `dataProjection` is set for a format,
 * the features will not be reprojected.
 * @property {import("../extent.js").Extent} [extent] Tile extent in map units of the tile being read.
 * This is only required when reading data with tile pixels as geometry units. When configured,
 * a `dataProjection` with `TILE_PIXELS` as `units` and the tile's pixel extent as `extent` needs to be
 * provided.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * created by the format reader. If not provided, features will be returned in the
 * `dataProjection`.
 */ /**
 * @typedef {Object} WriteOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
 * If not provided, the `dataProjection` of the format is assigned (where set).
 * If no `dataProjection` is set for a format, the features will be returned
 * in the `featureProjection`.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * that will be serialized by the format writer. If not provided, geometries are assumed
 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
 * as they are provided at construction.  If `true`, the right-hand rule will
 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
 * exterior and counter-clockwise for interior rings).  Note that not all
 * formats support this.  The GeoJSON format does use this property when writing
 * geometries.
 * @property {number} [decimals] Maximum number of decimal places for coordinates.
 * Coordinates are stored internally as floats, but floating-point arithmetic can create
 * coordinates with a large number of decimal places, not generally wanted on output.
 * Set a number here to round coordinates. Can also be used to ensure that
 * coordinates read in can be written back out with the same number of decimals.
 * Default is no rounding.
 */ /**
 * @typedef {'arraybuffer' | 'json' | 'text' | 'xml'} Type
 */ /**
 * @typedef {Object} SimpleGeometryObject
 * @property {import('../geom/Geometry.js').Type} type Type.
 * @property {Array<number>} flatCoordinates Flat coordinates.
 * @property {Array<number>|Array<Array<number>>} [ends] Ends or endss.
 * @property {import('../geom/Geometry.js').GeometryLayout} [layout] Layout.
 */ /**
 * @typedef {Array<GeometryObject>} GeometryCollectionObject
 */ /**
 * @typedef {SimpleGeometryObject|GeometryCollectionObject} GeometryObject
 */ /**
 * @typedef {Object} FeatureObject
 * @property {string|number} [id] Id.
 * @property {GeometryObject} [geometry] Geometry.
 * @property {Object<string, *>} [properties] Properties.
 */ /***
 * @template {import('../Feature.js').FeatureLike} T
 * @typedef {T extends RenderFeature ? typeof RenderFeature : typeof Feature} FeatureToFeatureClass
 */ /***
 * @template {import("../Feature.js").FeatureClass} T
 * @typedef {T[keyof T] extends RenderFeature ? RenderFeature : Feature} FeatureClassToFeature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for feature formats.
 * {@link module:ol/format/Feature~FeatureFormat} subclasses provide the ability to decode and encode
 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
 * file formats.  See the documentation for each format for more details.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @abstract
 * @api
 */ class $9ac77a234e054865$var$FeatureFormat {
    constructor(){
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.dataProjection = undefined;
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.defaultFeatureProjection = undefined;
        /**
     * @protected
     * @type {FeatureToFeatureClass<FeatureType>}
     */ this.featureClass = /** @type {FeatureToFeatureClass<FeatureType>} */ (0, $b9e33cd4bf1ba8a3$export$2e2bcd8739ae039);
        /**
     * A list media types supported by the format in descending order of preference.
     * @type {Array<string>}
     */ this.supportedMediaTypes = null;
    }
    /**
   * Adds the data projection to the read options.
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Options.
   * @return {ReadOptions|undefined} Options.
   * @protected
   */ getReadOptions(source, options) {
        if (options) {
            let dataProjection = options.dataProjection ? (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(options.dataProjection) : this.readProjection(source);
            if (options.extent && dataProjection && dataProjection.getUnits() === 'tile-pixels') {
                dataProjection = (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(dataProjection);
                dataProjection.setWorldExtent(options.extent);
            }
            options = {
                dataProjection: dataProjection,
                featureProjection: options.featureProjection
            };
        }
        return this.adaptOptions(options);
    }
    /**
   * Sets the `dataProjection` on the options, if no `dataProjection`
   * is set.
   * @param {WriteOptions|ReadOptions|undefined} options
   *     Options.
   * @protected
   * @return {WriteOptions|ReadOptions|undefined}
   *     Updated options.
   */ adaptOptions(options) {
        return Object.assign({
            dataProjection: this.dataProjection,
            featureProjection: this.defaultFeatureProjection,
            featureClass: this.featureClass
        }, options);
    }
    /**
   * @abstract
   * @return {Type} The format type.
   */ getType() {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Read a single feature from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeature(source, options) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Read all features from a source.
   *
   * @abstract
   * @param {Document|Element|ArrayBuffer|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   */ readFeatures(source, options) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Read a single geometry from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometry(source, options) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */ readProjection(source) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature in this format.
   *
   * @abstract
   * @param {Feature} feature Feature.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeature(feature, options) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features in this format.
   *
   * @abstract
   * @param {Array<Feature>} features Features.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeatures(features, options) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Write a single geometry in this format.
   *
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeGeometry(geometry, options) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
}
var $9ac77a234e054865$export$2e2bcd8739ae039 = $9ac77a234e054865$var$FeatureFormat;
function $9ac77a234e054865$export$7beeea566b560d4(geometry, write, options) {
    const featureProjection = options ? (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(options.dataProjection) : null;
    let transformed = geometry;
    if (featureProjection && dataProjection && !(0, $d447c151baf41c8c$export$fe091d73a555748b)(featureProjection, dataProjection)) {
        if (write) transformed = /** @type {T} */ geometry.clone();
        const fromProjection = write ? featureProjection : dataProjection;
        const toProjection = write ? dataProjection : featureProjection;
        if (fromProjection.getUnits() === 'tile-pixels') transformed.transform(fromProjection, toProjection);
        else transformed.applyTransform((0, $d447c151baf41c8c$export$fce0c6cfca85ed96)(fromProjection, toProjection));
    }
    if (write && options && /** @type {WriteOptions} */ options.decimals !== undefined) {
        const power = Math.pow(10, /** @type {WriteOptions} */ options.decimals);
        // if decimals option on write, round each coordinate appropriately
        /**
     * @param {Array<number>} coordinates Coordinates.
     * @return {Array<number>} Transformed coordinates.
     */ const transform = function(coordinates) {
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = Math.round(coordinates[i] * power) / power;
            return coordinates;
        };
        if (transformed === geometry) transformed = /** @type {T} */ geometry.clone();
        transformed.applyTransform(transform);
    }
    return transformed;
}
function $9ac77a234e054865$export$d3e9e4b1c7f2405c(extent, options) {
    const featureProjection = options ? (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(options.dataProjection) : null;
    if (featureProjection && dataProjection && !(0, $d447c151baf41c8c$export$fe091d73a555748b)(featureProjection, dataProjection)) return (0, $d447c151baf41c8c$export$751c68e0e0efff79)(extent, dataProjection, featureProjection);
    return extent;
}
const $9ac77a234e054865$var$GeometryConstructor = {
    Point: (0, $6d7bc2de9d52ca58$export$2e2bcd8739ae039),
    LineString: (0, $0b7dcb8925c7efc9$export$2e2bcd8739ae039),
    Polygon: (0, $9549b42604551fb5$export$2e2bcd8739ae039),
    MultiPoint: (0, $dc589d5f6ce8c14b$export$2e2bcd8739ae039),
    MultiLineString: (0, $b66089af173c4ae0$export$2e2bcd8739ae039),
    MultiPolygon: (0, $be4913079f931a6a$export$2e2bcd8739ae039)
};
function $9ac77a234e054865$var$orientFlatCoordinates(flatCoordinates, ends, stride) {
    if (Array.isArray(ends[0])) {
        // MultiPolagon
        if (!(0, $5639f71071079d61$export$a1d138f4bd85f4b4)(flatCoordinates, 0, ends, stride)) {
            flatCoordinates = flatCoordinates.slice();
            (0, $5639f71071079d61$export$ea9ed55fc2a85010)(flatCoordinates, 0, ends, stride);
        }
        return flatCoordinates;
    }
    if (!(0, $5639f71071079d61$export$f27cd06e85f4ba28)(flatCoordinates, 0, ends, stride)) {
        flatCoordinates = flatCoordinates.slice();
        (0, $5639f71071079d61$export$b71b604ddfc778c7)(flatCoordinates, 0, ends, stride);
    }
    return flatCoordinates;
}
function $9ac77a234e054865$export$f935e77582b330a(object, options) {
    const geometry = object.geometry;
    if (!geometry) return [];
    if (Array.isArray(geometry)) return geometry.map((geometry)=>$9ac77a234e054865$export$f935e77582b330a({
            ...object,
            geometry: geometry
        })).flat();
    const geometryType = geometry.type === 'MultiPolygon' ? 'Polygon' : geometry.type;
    if (geometryType === 'GeometryCollection' || geometryType === 'Circle') throw new Error('Unsupported geometry type: ' + geometryType);
    const stride = geometry.layout.length;
    return $9ac77a234e054865$export$7beeea566b560d4(new (0, $e450b21b255017c3$export$2e2bcd8739ae039)(geometryType, geometryType === 'Polygon' ? $9ac77a234e054865$var$orientFlatCoordinates(geometry.flatCoordinates, geometry.ends, stride) : geometry.flatCoordinates, geometry.ends?.flat(), stride, object.properties || {}, object.id).enableSimplifyTransformed(), false, options);
}
function $9ac77a234e054865$export$322c9678d8c47bf(object, options) {
    if (!object) return null;
    if (Array.isArray(object)) {
        const geometries = object.map((geometry)=>$9ac77a234e054865$export$322c9678d8c47bf(geometry, options));
        return new (0, $6b0a4ecd8d587c30$export$2e2bcd8739ae039)(geometries);
    }
    const Geometry = $9ac77a234e054865$var$GeometryConstructor[object.type];
    return $9ac77a234e054865$export$7beeea566b560d4(new Geometry(object.flatCoordinates, object.layout || 'XY', object.ends), false, options);
}


/**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../render/Feature.js").default]
 * @typedef {Object} Options
 * @property {import('./Feature.js').FeatureToFeatureClass<FeatureType>} [featureClass] Class for features returned by
 * {@link module:ol/format/MVT~MVT#readFeatures}. Set to {@link module:ol/Feature~Feature} to get full editing and geometry
 * support at the cost of decreased rendering performance. The default is
 * {@link module:ol/render/Feature~RenderFeature}, which is optimized for rendering and hit detection.
 * @property {string} [geometryName='geometry'] Geometry name to use when creating features.
 * @property {string} [layerName='layer'] Name of the feature attribute that holds the layer name.
 * @property {Array<string>} [layers] Layers to read features from. If not provided, features will be read from all
 * @property {string} [idProperty] Optional property that will be assigned as the feature id and removed from the properties.
 * layers.
 */ /**
 * @classdesc
 * Feature format for reading data in the Mapbox MVT format.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=RenderFeature]
 * @extends {FeatureFormat<FeatureType>}
 * @api
 */ class $6a9883a56e5ed579$var$MVT extends (0, $9ac77a234e054865$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @type {Projection}
     */ this.dataProjection = new (0, $53feab4ae1012f80$export$2e2bcd8739ae039)({
            code: '',
            units: 'tile-pixels'
        });
        this.featureClass = options.featureClass ? options.featureClass : /** @type {import('./Feature.js').FeatureToFeatureClass<FeatureType>} */ (0, $e450b21b255017c3$export$2e2bcd8739ae039);
        /**
     * @private
     * @type {string|undefined}
     */ this.geometryName_ = options.geometryName;
        /**
     * @private
     * @type {string}
     */ this.layerName_ = options.layerName ? options.layerName : 'layer';
        /**
     * @private
     * @type {Array<string>|null}
     */ this.layers_ = options.layers ? options.layers : null;
        /**
     * @private
     * @type {string}
     */ this.idProperty_ = options.idProperty;
        this.supportedMediaTypes = [
            'application/vnd.mapbox-vector-tile',
            'application/x-protobuf'
        ];
    }
    /**
   * Read the raw geometry from the pbf offset stored in a raw feature's geometry
   * property.
   * @param {PBF} pbf PBF.
   * @param {Object} feature Raw feature.
   * @param {Array<number>} flatCoordinates Array to store flat coordinates in.
   * @param {Array<number>} ends Array to store ends in.
   * @private
   */ readRawGeometry_(pbf, feature, flatCoordinates, ends) {
        pbf.pos = feature.geometry;
        const end = pbf.readVarint() + pbf.pos;
        let cmd = 1;
        let length = 0;
        let x = 0;
        let y = 0;
        let coordsLen = 0;
        let currentEnd = 0;
        while(pbf.pos < end){
            if (!length) {
                const cmdLen = pbf.readVarint();
                cmd = cmdLen & 0x7;
                length = cmdLen >> 3;
            }
            length--;
            if (cmd === 1 || cmd === 2) {
                x += pbf.readSVarint();
                y += pbf.readSVarint();
                if (cmd === 1) // moveTo
                {
                    if (coordsLen > currentEnd) {
                        ends.push(coordsLen);
                        currentEnd = coordsLen;
                    }
                }
                flatCoordinates.push(x, y);
                coordsLen += 2;
            } else if (cmd === 7) {
                if (coordsLen > currentEnd) {
                    // close polygon
                    flatCoordinates.push(flatCoordinates[currentEnd], flatCoordinates[currentEnd + 1]);
                    coordsLen += 2;
                }
            } else throw new Error('Invalid command found in the PBF');
        }
        if (coordsLen > currentEnd) {
            ends.push(coordsLen);
            currentEnd = coordsLen;
        }
    }
    /**
   * @private
   * @param {PBF} pbf PBF
   * @param {Object} rawFeature Raw Mapbox feature.
   * @param {import("./Feature.js").ReadOptions} options Read options.
   * @return {FeatureType|null} Feature.
   */ createFeature_(pbf, rawFeature, options) {
        const type = rawFeature.type;
        if (type === 0) return null;
        let feature;
        const values = rawFeature.properties;
        let id;
        if (!this.idProperty_) id = rawFeature.id;
        else {
            id = values[this.idProperty_];
            delete values[this.idProperty_];
        }
        values[this.layerName_] = rawFeature.layer.name;
        const flatCoordinates = /** @type {Array<number>} */ [];
        const ends = /** @type {Array<number>} */ [];
        this.readRawGeometry_(pbf, rawFeature, flatCoordinates, ends);
        const geometryType = $6a9883a56e5ed579$var$getGeometryType(type, ends.length);
        if (this.featureClass === (0, $e450b21b255017c3$export$2e2bcd8739ae039)) {
            feature = new /** @type {import('./Feature.js').FeatureToFeatureClass<RenderFeature>} */ this.featureClass(geometryType, flatCoordinates, ends, 2, values, id);
            feature.transform(options.dataProjection);
        } else {
            let geom;
            if (geometryType == 'Polygon') {
                const endss = (0, $5639f71071079d61$export$cb72ae403d6e78e6)(flatCoordinates, ends);
                geom = endss.length > 1 ? new (0, $be4913079f931a6a$export$2e2bcd8739ae039)(flatCoordinates, 'XY', endss) : new (0, $9549b42604551fb5$export$2e2bcd8739ae039)(flatCoordinates, 'XY', ends);
            } else geom = geometryType === 'Point' ? new (0, $6d7bc2de9d52ca58$export$2e2bcd8739ae039)(flatCoordinates, 'XY') : geometryType === 'LineString' ? new (0, $0b7dcb8925c7efc9$export$2e2bcd8739ae039)(flatCoordinates, 'XY') : geometryType === 'MultiPoint' ? new (0, $dc589d5f6ce8c14b$export$2e2bcd8739ae039)(flatCoordinates, 'XY') : geometryType === 'MultiLineString' ? new (0, $b66089af173c4ae0$export$2e2bcd8739ae039)(flatCoordinates, 'XY', ends) : null;
            const ctor = /** @type {typeof import("../Feature.js").default} */ this.featureClass;
            feature = new ctor();
            if (this.geometryName_) feature.setGeometryName(this.geometryName_);
            const geometry = (0, $9ac77a234e054865$export$7beeea566b560d4)(geom, false, options);
            feature.setGeometry(geometry);
            if (id !== undefined) feature.setId(id);
            feature.setProperties(values, true);
        }
        return /** @type {FeatureType} */ feature;
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */ getType() {
        return 'arraybuffer';
    }
    /**
   * Read all features.
   *
   * @param {ArrayBuffer} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   * @api
   * @override
   */ readFeatures(source, options) {
        const layers = this.layers_;
        options = this.adaptOptions(options);
        const dataProjection = (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(options.dataProjection);
        dataProjection.setWorldExtent(options.extent);
        options.dataProjection = dataProjection;
        const pbf = new (0, $5d55e842ce873226$export$2e2bcd8739ae039)(/** @type {ArrayBuffer} */ source);
        const pbfLayers = pbf.readFields($6a9883a56e5ed579$var$layersPBFReader, {});
        const features = [];
        for(const name in pbfLayers){
            if (layers && !layers.includes(name)) continue;
            const pbfLayer = pbfLayers[name];
            const extent = pbfLayer ? [
                0,
                0,
                pbfLayer.extent,
                pbfLayer.extent
            ] : null;
            dataProjection.setExtent(extent);
            for(let i = 0, ii = pbfLayer.length; i < ii; ++i){
                const rawFeature = $6a9883a56e5ed579$var$readRawFeature(pbf, pbfLayer, i);
                const feature = this.createFeature_(pbf, rawFeature, options);
                if (feature !== null) features.push(feature);
            }
        }
        return /** @type {Array<FeatureType>} */ features;
    }
    /**
   * Read the projection from the source.
   *
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   * @override
   */ readProjection(source) {
        return this.dataProjection;
    }
    /**
   * Sets the layers that features will be read from.
   * @param {Array<string>} layers Layers.
   * @api
   */ setLayers(layers) {
        this.layers_ = layers;
    }
}
/**
 * Reader callback for parsing layers.
 * @param {number} tag The tag.
 * @param {Object} layers The layers object.
 * @param {PBF} pbf The PBF.
 */ function $6a9883a56e5ed579$var$layersPBFReader(tag, layers, pbf) {
    if (tag === 3) {
        const layer = {
            keys: [],
            values: [],
            features: []
        };
        const end = pbf.readVarint() + pbf.pos;
        pbf.readFields($6a9883a56e5ed579$var$layerPBFReader, layer, end);
        layer.length = layer.features.length;
        if (layer.length) layers[layer.name] = layer;
    }
}
/**
 * Reader callback for parsing layer.
 * @param {number} tag The tag.
 * @param {Object} layer The layer object.
 * @param {PBF} pbf The PBF.
 */ function $6a9883a56e5ed579$var$layerPBFReader(tag, layer, pbf) {
    if (tag === 15) layer.version = pbf.readVarint();
    else if (tag === 1) layer.name = pbf.readString();
    else if (tag === 5) layer.extent = pbf.readVarint();
    else if (tag === 2) layer.features.push(pbf.pos);
    else if (tag === 3) layer.keys.push(pbf.readString());
    else if (tag === 4) {
        let value = null;
        const end = pbf.readVarint() + pbf.pos;
        while(pbf.pos < end){
            tag = pbf.readVarint() >> 3;
            value = tag === 1 ? pbf.readString() : tag === 2 ? pbf.readFloat() : tag === 3 ? pbf.readDouble() : tag === 4 ? pbf.readVarint64() : tag === 5 ? pbf.readVarint() : tag === 6 ? pbf.readSVarint() : tag === 7 ? pbf.readBoolean() : null;
        }
        layer.values.push(value);
    }
}
/**
 * Reader callback for parsing feature.
 * @param {number} tag The tag.
 * @param {Object} feature The feature object.
 * @param {PBF} pbf The PBF.
 */ function $6a9883a56e5ed579$var$featurePBFReader(tag, feature, pbf) {
    if (tag == 1) feature.id = pbf.readVarint();
    else if (tag == 2) {
        const end = pbf.readVarint() + pbf.pos;
        while(pbf.pos < end){
            const key = feature.layer.keys[pbf.readVarint()];
            const value = feature.layer.values[pbf.readVarint()];
            feature.properties[key] = value;
        }
    } else if (tag == 3) feature.type = pbf.readVarint();
    else if (tag == 4) feature.geometry = pbf.pos;
}
/**
 * Read a raw feature from the pbf offset stored at index `i` in the raw layer.
 * @param {PBF} pbf PBF.
 * @param {Object} layer Raw layer.
 * @param {number} i Index of the feature in the raw layer's `features` array.
 * @return {Object} Raw feature.
 */ function $6a9883a56e5ed579$var$readRawFeature(pbf, layer, i) {
    pbf.pos = layer.features[i];
    const end = pbf.readVarint() + pbf.pos;
    const feature = {
        layer: layer,
        type: 0,
        properties: {}
    };
    pbf.readFields($6a9883a56e5ed579$var$featurePBFReader, feature, end);
    return feature;
}
/**
 * @param {number} type The raw feature's geometry type
 * @param {number} numEnds Number of ends of the flat coordinates of the
 * geometry.
 * @return {import("../render/Feature.js").Type} The geometry type.
 */ function $6a9883a56e5ed579$var$getGeometryType(type, numEnds) {
    /** @type {import("../render/Feature.js").Type} */ let geometryType;
    if (type === 1) geometryType = numEnds === 1 ? 'Point' : 'MultiPoint';
    else if (type === 2) geometryType = numEnds === 1 ? 'LineString' : 'MultiLineString';
    else if (type === 3) geometryType = 'Polygon';
    return geometryType;
}
var $6a9883a56e5ed579$export$2e2bcd8739ae039 = $6a9883a56e5ed579$var$MVT;



/**
 * @module ol/interaction/Draw
 */ 








/**
 * @module ol/geom/Circle
 */ 



/**
 * @classdesc
 * Circle geometry.
 *
 * @api
 */ class $ffa845aee0567855$var$Circle extends (0, $2d119a5aa713a216$export$2e2bcd8739ae039) {
    /**
   * @param {!import("../coordinate.js").Coordinate} center Center.
   *     For internal use, flat coordinates in combination with `layout` and no
   *     `radius` are also accepted.
   * @param {number} [radius] Radius in units of the projection.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(center, radius, layout){
        super();
        if (layout !== undefined && radius === undefined) this.setFlatCoordinates(layout, center);
        else {
            radius = radius ? radius : 0;
            this.setCenterAndRadius(center, radius, layout);
        }
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Circle} Clone.
   * @api
   * @override
   */ clone() {
        const circle = new $ffa845aee0567855$var$Circle(this.flatCoordinates.slice(), undefined, this.layout);
        circle.applyProperties(this);
        return circle;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        const squaredDistance = dx * dx + dy * dy;
        if (squaredDistance < minSquaredDistance) {
            if (squaredDistance === 0) for(let i = 0; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            else {
                const delta = this.getRadius() / Math.sqrt(squaredDistance);
                closestPoint[0] = flatCoordinates[0] + delta * dx;
                closestPoint[1] = flatCoordinates[1] + delta * dy;
                for(let i = 2; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            }
            closestPoint.length = this.stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        return dx * dx + dy * dy <= this.getRadiusSquared_();
    }
    /**
   * Return the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @return {import("../coordinate.js").Coordinate} Center.
   * @api
   */ getCenter() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const radius = flatCoordinates[this.stride] - flatCoordinates[0];
        return (0, $110ceb23457e07e7$export$958e3e1a02eac4b6)(flatCoordinates[0] - radius, flatCoordinates[1] - radius, flatCoordinates[0] + radius, flatCoordinates[1] + radius, extent);
    }
    /**
   * Return the radius of the circle.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return Math.sqrt(this.getRadiusSquared_());
    }
    /**
   * @private
   * @return {number} Radius squared.
   */ getRadiusSquared_() {
        const dx = this.flatCoordinates[this.stride] - this.flatCoordinates[0];
        const dy = this.flatCoordinates[this.stride + 1] - this.flatCoordinates[1];
        return dx * dx + dy * dy;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Circle';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const circleExtent = this.getExtent();
        if ((0, $110ceb23457e07e7$export$7b0a31e10bbff018)(extent, circleExtent)) {
            const center = this.getCenter();
            if (extent[0] <= center[0] && extent[2] >= center[0]) return true;
            if (extent[1] <= center[1] && extent[3] >= center[1]) return true;
            return (0, $110ceb23457e07e7$export$f9ed8a3d123a08e2)(extent, this.intersectsCoordinate.bind(this));
        }
        return false;
    }
    /**
   * Set the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} center Center.
   * @api
   */ setCenter(center) {
        const stride = this.stride;
        const radius = this.flatCoordinates[stride] - this.flatCoordinates[0];
        const flatCoordinates = center.slice();
        flatCoordinates[stride] = flatCoordinates[0] + radius;
        for(let i = 1; i < stride; ++i)flatCoordinates[stride + i] = center[i];
        this.setFlatCoordinates(this.layout, flatCoordinates);
        this.changed();
    }
    /**
   * Set the center (as {@link module:ol/coordinate~Coordinate coordinate}) and the radius (as
   * number) of the circle.
   * @param {!import("../coordinate.js").Coordinate} center Center.
   * @param {number} radius Radius.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCenterAndRadius(center, radius, layout) {
        this.setLayout(layout, center, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        /** @type {Array<number>} */ const flatCoordinates = this.flatCoordinates;
        let offset = (0, $46dd16ae2ee5c902$export$60815ead40ec79ab)(flatCoordinates, 0, center, this.stride);
        flatCoordinates[offset++] = flatCoordinates[0] + radius;
        for(let i = 1, ii = this.stride; i < ii; ++i)flatCoordinates[offset++] = flatCoordinates[i];
        flatCoordinates.length = offset;
        this.changed();
    }
    /**
   * @override
   */ getCoordinates() {
        return null;
    }
    /**
   * @override
   */ setCoordinates(coordinates, layout) {}
    /**
   * Set the radius of the circle. The radius is in the units of the projection.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        this.flatCoordinates[this.stride] = this.flatCoordinates[0] + radius;
        this.changed();
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const center = this.getCenter();
        const stride = this.getStride();
        this.setCenter((0, $437d3763a798775b$export$bb628a54ab399bc9)(center, 0, center.length, stride, angle, anchor, center));
        this.changed();
    }
}
/**
 * Transform each coordinate of the circle from one coordinate reference system
 * to another. The geometry is modified in place.
 * If you do not want the geometry modified in place, first clone() it and
 * then use this function on the clone.
 *
 * Internally a circle is currently represented by two points: the center of
 * the circle `[cx, cy]`, and the point to the right of the circle
 * `[cx + r, cy]`. This `transform` function just transforms these two points.
 * So the resulting geometry is also a circle, and that circle does not
 * correspond to the shape that would be obtained by transforming every point
 * of the original circle.
 *
 * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @return {Circle} This geometry.  Note that original geometry is
 *     modified in place.
 * @function
 * @api
 */ $ffa845aee0567855$var$Circle.prototype.transform;
var $ffa845aee0567855$export$2e2bcd8739ae039 = $ffa845aee0567855$var$Circle;










/**
 * @module ol/layer/Vector
 */ /**
 * @module ol/renderer/canvas/VectorLayer
 */ 












/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ class $54ee753c0e50347f$var$CanvasVectorLayerRenderer extends (0, $dc24fa3944657194$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
   */ constructor(vectorLayer){
        super(vectorLayer);
        /** @private */ this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this);
        /**
     * @private
     * @type {boolean}
     */ this.animatingOrInteracting_;
        /**
     * @private
     * @type {ImageData|null}
     */ this.hitDetectionImageData_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.clipped_ = false;
        /**
     * @private
     * @type {Array<import("../../Feature.js").default>}
     */ this.renderedFeatures_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.renderedResolution_ = NaN;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.renderedExtent_ = (0, $110ceb23457e07e7$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.wrappedRenderedExtent_ = (0, $110ceb23457e07e7$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.renderedRotation_;
        /**
     * @private
     * @type {import("../../coordinate").Coordinate}
     */ this.renderedCenter_ = null;
        /**
     * @private
     * @type {import("../../proj/Projection").default}
     */ this.renderedProjection_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedPixelRatio_ = 1;
        /**
     * @private
     * @type {import("../../render.js").OrderFunction|null}
     */ this.renderedRenderOrder_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.renderedFrameDeclutter_;
        /**
     * @private
     * @type {import("../../render/canvas/ExecutorGroup").default}
     */ this.replayGroup_ = null;
        /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */ this.replayGroupChanged = true;
        /**
     * Clipping to be performed by `renderFrame()`
     * @type {boolean}
     */ this.clipping = true;
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.targetContext_ = null;
        /**
     * @private
     * @type {number}
     */ this.opacity_ = 1;
    }
    /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {boolean} [declutterable] `true` to only render declutterable items,
   *     `false` to only render non-declutterable items, `undefined` to render all.
   */ renderWorlds(executorGroup, frameState, declutterable) {
        const extent = frameState.extent;
        const viewState = frameState.viewState;
        const center = viewState.center;
        const resolution = viewState.resolution;
        const projection = viewState.projection;
        const rotation = viewState.rotation;
        const projectionExtent = projection.getExtent();
        const vectorSource = this.getLayer().getSource();
        const declutter = this.getLayer().getDeclutter();
        const pixelRatio = frameState.pixelRatio;
        const viewHints = frameState.viewHints;
        const snapToPixel = !(viewHints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).INTERACTING]);
        const context = this.context;
        const width = Math.round((0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $110ceb23457e07e7$export$c08559766941f856)(extent) / resolution * pixelRatio);
        const multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        const worldWidth = multiWorld ? (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(projectionExtent) : null;
        const endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + 1 : 1;
        let world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) : 0;
        do {
            let transform = this.getRenderTransform(center, resolution, 0, pixelRatio, width, height, world * worldWidth);
            if (frameState.declutter) transform = transform.slice(0);
            executorGroup.execute(context, [
                context.canvas.width,
                context.canvas.height
            ], transform, rotation, snapToPixel, declutterable === undefined ? (0, $e8088b2dfa7545b9$export$61b49a5ae59d663) : declutterable ? (0, $e8088b2dfa7545b9$export$6195a93a6c97ce02) : (0, $e8088b2dfa7545b9$export$d0fe61ccfaa1ca87), declutterable ? declutter && frameState.declutter[declutter] : undefined);
        }while (++world < endWorld);
    }
    /**
   * @private
   */ setDrawContext_() {
        if (this.opacity_ !== 1) {
            this.targetContext_ = this.context;
            this.context = (0, $32c8adb5331a7848$export$9e05d10eae75c464)(this.context.canvas.width, this.context.canvas.height, (0, $dc24fa3944657194$export$a166f0857c555517));
        }
    }
    /**
   * @private
   */ resetDrawContext_() {
        if (this.opacity_ !== 1) {
            const alpha = this.targetContext_.globalAlpha;
            this.targetContext_.globalAlpha = this.opacity_;
            this.targetContext_.drawImage(this.context.canvas, 0, 0);
            this.targetContext_.globalAlpha = alpha;
            (0, $32c8adb5331a7848$export$e918ac6a1026a12a)(this.context);
            (0, $dc24fa3944657194$export$a166f0857c555517).push(this.context.canvas);
            this.context = this.targetContext_;
            this.targetContext_ = null;
        }
    }
    /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeclutter(frameState) {
        if (!this.replayGroup_ || !this.getLayer().getDeclutter()) return;
        this.renderWorlds(this.replayGroup_, frameState, true);
    }
    /**
   * Render deferred instructions.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferredInternal(frameState) {
        if (!this.replayGroup_) return;
        this.replayGroup_.renderDeferred();
        if (this.clipped_) this.context.restore();
        this.resetDrawContext_();
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        this.opacity_ = layerState.opacity;
        const viewState = frameState.viewState;
        this.prepareContainer(frameState, target);
        const context = this.context;
        const replayGroup = this.replayGroup_;
        let render = replayGroup && !replayGroup.isEmpty();
        if (!render) {
            const hasRenderListeners = this.getLayer().hasListener((0, $b899a48a5b03178b$export$2e2bcd8739ae039).PRERENDER) || this.getLayer().hasListener((0, $b899a48a5b03178b$export$2e2bcd8739ae039).POSTRENDER);
            if (!hasRenderListeners) return this.container;
        }
        this.setDrawContext_();
        this.preRender(context, frameState);
        const projection = viewState.projection;
        // clipped rendering if layer extent is set
        this.clipped_ = false;
        if (render && layerState.extent && this.clipping) {
            const layerExtent = (0, $d447c151baf41c8c$export$494be3a3a25689ca)(layerState.extent, projection);
            render = (0, $110ceb23457e07e7$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
            this.clipped_ = render && !(0, $110ceb23457e07e7$export$be866b1e0809b17e)(layerExtent, frameState.extent);
            if (this.clipped_) this.clipUnrotated(context, frameState, layerExtent);
        }
        if (render) this.renderWorlds(replayGroup, frameState, this.getLayer().getDeclutter() ? false : undefined);
        if (!frameState.declutter && this.clipped_) context.restore();
        this.postRender(context, frameState);
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        if (!frameState.declutter) this.resetDrawContext_();
        return this.container;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature").default>>} Promise
   * that resolves with an array of features.
   * @override
   */ getFeatures(pixel) {
        return new Promise((resolve)=>{
            if (this.frameState && !this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                const size = this.frameState.size.slice();
                const center = this.renderedCenter_;
                const resolution = this.renderedResolution_;
                const rotation = this.renderedRotation_;
                const projection = this.renderedProjection_;
                const extent = this.wrappedRenderedExtent_;
                const layer = this.getLayer();
                const transforms = [];
                const width = size[0] * (0, $e4a1dc4cab3ca6fc$export$ab51038298418f25);
                const height = size[1] * (0, $e4a1dc4cab3ca6fc$export$ab51038298418f25);
                transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $e4a1dc4cab3ca6fc$export$ab51038298418f25), width, height, 0).slice());
                const source = layer.getSource();
                const projectionExtent = projection.getExtent();
                if (source.getWrapX() && projection.canWrapX() && !(0, $110ceb23457e07e7$export$be866b1e0809b17e)(projectionExtent, extent)) {
                    let startX = extent[0];
                    const worldWidth = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(projectionExtent);
                    let world = 0;
                    let offsetX;
                    while(startX < projectionExtent[0]){
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $e4a1dc4cab3ca6fc$export$ab51038298418f25), width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while(startX > projectionExtent[2]){
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $e4a1dc4cab3ca6fc$export$ab51038298418f25), width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                const userProjection = (0, $d447c151baf41c8c$export$3973b77d5f6f2790)();
                this.hitDetectionImageData_ = (0, $e4a1dc4cab3ca6fc$export$bd05e394339d469)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation, (0, $4dc93cc3f41d6e2c$export$75084a70d324c1e6)(resolution, this.renderedPixelRatio_), userProjection ? projection : null);
            }
            resolve((0, $e4a1dc4cab3ca6fc$export$6d4d555ddbfffa32)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        });
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   * @override
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        if (!this.replayGroup_) return undefined;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ const features = {};
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position
     * @return {T|undefined} Callback result.
     */ const featureCallback = function(feature, geometry, distanceSq) {
            const key = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(feature);
            const match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        const declutter = this.getLayer().getDeclutter();
        return this.replayGroup_.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutter ? frameState.declutter?.[declutter]?.all().map((item)=>item.value) : null);
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @override
   */ handleFontsChanged() {
        const layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    }
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const vectorLayer = this.getLayer();
        const vectorSource = vectorLayer.getSource();
        if (!vectorSource) return false;
        const animating = frameState.viewHints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).ANIMATING];
        const interacting = frameState.viewHints[(0, $73b497f172b1a497$export$2e2bcd8739ae039).INTERACTING];
        const updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        const updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (this.ready && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        const frameStateExtent = frameState.extent;
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const resolution = viewState.resolution;
        const pixelRatio = frameState.pixelRatio;
        const vectorLayerRevision = vectorLayer.getRevision();
        const vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        let vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $4dc93cc3f41d6e2c$export$531ddd8416d52dfc);
        const center = viewState.center.slice();
        const extent = (0, $110ceb23457e07e7$export$ab1029bcae9ddb4a)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        const renderedExtent = extent.slice();
        const loadExtents = [
            extent.slice()
        ];
        const projectionExtent = projection.getExtent();
        if (vectorSource.getWrapX() && projection.canWrapX() && !(0, $110ceb23457e07e7$export$be866b1e0809b17e)(projectionExtent, frameState.extent)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            const worldWidth = (0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(projectionExtent);
            const gutter = Math.max((0, $110ceb23457e07e7$export$3c49c185de0c2bfc)(extent) / 2, worldWidth);
            extent[0] = projectionExtent[0] - gutter;
            extent[2] = projectionExtent[2] + gutter;
            (0, $188aedb30bca6ae8$export$39a9ce3624977b84)(center, projection);
            const loadExtent = (0, $110ceb23457e07e7$export$39a9ce3624977b84)(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                loadExtent[0] + worldWidth,
                loadExtent[1],
                loadExtent[2] + worldWidth,
                loadExtent[3]
            ]);
            else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                loadExtent[0] - worldWidth,
                loadExtent[1],
                loadExtent[2] - worldWidth,
                loadExtent[3]
            ]);
        }
        if (this.ready && this.renderedResolution_ == resolution && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && this.renderedFrameDeclutter_ === !!frameState.declutter && (0, $110ceb23457e07e7$export$be866b1e0809b17e)(this.wrappedRenderedExtent_, extent)) {
            if (!(0, $9d07dd9052c3de0c$export$e9bab7fafb253603)(this.renderedExtent_, renderedExtent)) {
                this.hitDetectionImageData_ = null;
                this.renderedExtent_ = renderedExtent;
            }
            this.renderedCenter_ = center;
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        const replayGroup = new (0, $4af8752efda127f4$export$2e2bcd8739ae039)((0, $4dc93cc3f41d6e2c$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
        const userProjection = (0, $d447c151baf41c8c$export$3973b77d5f6f2790)();
        let userTransform;
        if (userProjection) {
            for(let i = 0, ii = loadExtents.length; i < ii; ++i){
                const extent = loadExtents[i];
                const userExtent = (0, $d447c151baf41c8c$export$96bfd09e2cffb006)(extent, projection);
                vectorSource.loadFeatures(userExtent, (0, $d447c151baf41c8c$export$b56bb8ad8b3a00e9)(resolution, projection), userProjection);
            }
            userTransform = (0, $d447c151baf41c8c$export$e3c4995a701c26a3)(userProjection, projection);
        } else for(let i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures(loadExtents[i], resolution, projection);
        const squaredTolerance = (0, $4dc93cc3f41d6e2c$export$75084a70d324c1e6)(resolution, pixelRatio);
        let ready = true;
        const render = /**
       * @param {import("../../Feature.js").default} feature Feature.
       * @param {number} index Index.
       */ (feature, index)=>{
            let styles;
            const styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                const dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, this.getLayer().getDeclutter(), index);
                ready = ready && !dirty;
            }
        };
        const userExtent = (0, $d447c151baf41c8c$export$96bfd09e2cffb006)(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */ const features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
        for(let i = 0, ii = features.length; i < ii; ++i)render(features[i], i);
        this.renderedFeatures_ = features;
        this.ready = ready;
        const replayGroupInstructions = replayGroup.finish();
        const executorGroup = new (0, $e8088b2dfa7545b9$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer(), !!frameState.declutter);
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedFrameDeclutter_ = !!frameState.declutter;
        this.renderedExtent_ = renderedExtent;
        this.wrappedRenderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.renderedPixelRatio_ = pixelRatio;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    }
    /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [transform] Transform from user to view projection.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */ renderFeature(feature, squaredTolerance, styles, builderGroup, transform, declutter, index) {
        if (!styles) return false;
        let loading = false;
        if (Array.isArray(styles)) for(let i = 0, ii = styles.length; i < ii; ++i)loading = (0, $4dc93cc3f41d6e2c$export$36f470a33a42f413)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index) || loading;
        else loading = (0, $4dc93cc3f41d6e2c$export$36f470a33a42f413)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index);
        return loading;
    }
}
var $54ee753c0e50347f$export$2e2bcd8739ae039 = $54ee753c0e50347f$var$CanvasVectorLayerRenderer;



/**
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @extends {BaseVectorLayer<FeatureType, VectorSourceType, CanvasVectorLayerRenderer>}
 * @api
 */ class $b68d2b880a7192c0$var$VectorLayer extends (0, $c0ed643b13f1acbb$export$2e2bcd8739ae039) {
    /**
   * @param {Options<VectorSourceType, FeatureType>} [options] Options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $54ee753c0e50347f$export$2e2bcd8739ae039)(this);
    }
}
var $b68d2b880a7192c0$export$2e2bcd8739ae039 = $b68d2b880a7192c0$var$VectorLayer;




/**
 * @module ol/source/Vector
 */ 










/**
 * @module ol/loadingstrategy
 */ 
function $4fd454b9cb88836f$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $4fd454b9cb88836f$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $4fd454b9cb88836f$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution, projection) {
        const z = tileGrid.getZForResolution((0, $d447c151baf41c8c$export$bd1cd3b88140b906)(resolution, projection));
        const tileRange = tileGrid.getTileRangeForExtentAndZ((0, $d447c151baf41c8c$export$494be3a3a25689ca)(extent, projection), z);
        /** @type {Array<import("./extent.js").Extent>} */ const extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ const tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push((0, $d447c151baf41c8c$export$96bfd09e2cffb006)(tileGrid.getTileCoordExtent(tileCoord), projection));
        return extents;
    });
}




/**
 * @module ol/structs/RBush
 */ 



/**
 * @typedef {import("rbush").BBox & {value: T}} Entry
 * @template T
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template {Object} T
 */ class $a02af6d3107593df$var$RBush {
    /**
   * @param {number} [maxEntries] Max entries.
   */ constructor(maxEntries){
        /**
     * @private
     * @type {RBush_<Entry<T>>}
     */ this.rbush_ = new (0, (/*@__PURE__*/$parcel$interopDefault($2c1acb459bfbe860$exports)))(maxEntries);
        /**
     * A mapping between the objects added to this rbush wrapper
     * and the objects that are actually added to the internal rbush.
     * @private
     * @type {Object<string, Entry<T>>}
     */ this.items_ = {};
    }
    /**
   * Insert a value into the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ insert(extent, value) {
        /** @type {Entry<T>} */ const item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        this.rbush_.insert(item);
        this.items_[(0, $9f65e6f92d33bc27$export$5e82334337e0f204)(value)] = item;
    }
    /**
   * Bulk-insert values into the RBush.
   * @param {Array<import("../extent.js").Extent>} extents Extents.
   * @param {Array<T>} values Values.
   */ load(extents, values) {
        const items = new Array(values.length);
        for(let i = 0, l = values.length; i < l; i++){
            const extent = extents[i];
            const value = values[i];
            /** @type {Entry<T>} */ const item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value
            };
            items[i] = item;
            this.items_[(0, $9f65e6f92d33bc27$export$5e82334337e0f204)(value)] = item;
        }
        this.rbush_.load(items);
    }
    /**
   * Remove a value from the RBush.
   * @param {T} value Value.
   * @return {boolean} Removed.
   */ remove(value) {
        const uid = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        const item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    }
    /**
   * Update the extent of a value in the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ update(extent, value) {
        const item = this.items_[(0, $9f65e6f92d33bc27$export$5e82334337e0f204)(value)];
        const bbox = [
            item.minX,
            item.minY,
            item.maxX,
            item.maxY
        ];
        if (!(0, $110ceb23457e07e7$export$e9bab7fafb253603)(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    }
    /**
   * Return all values in the RBush.
   * @return {Array<T>} All.
   */ getAll() {
        const items = this.rbush_.all();
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Return all values in the given extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<T>} All in extent.
   */ getInExtent(extent) {
        /** @type {import("rbush").BBox} */ const bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3]
        };
        const items = this.rbush_.search(bbox);
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Calls a callback function with each value in the tree.
   * If the callback returns a truthy value, this value is returned without
   * checking the rest of the tree.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEach(callback) {
        return this.forEach_(this.getAll(), callback);
    }
    /**
   * Calls a callback function with each value in the provided extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEachInExtent(extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    }
    /**
   * @param {Array<T>} values Values.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   * @private
   */ forEach_(values, callback) {
        let result;
        for(let i = 0, l = values.length; i < l; i++){
            result = callback(values[i]);
            if (result) return result;
        }
        return result;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $0364d4893e3f1129$export$dd1bc94b04021eeb)(this.items_);
    }
    /**
   * Remove all values from the RBush.
   */ clear() {
        this.rbush_.clear();
        this.items_ = {};
    }
    /**
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} Extent.
   */ getExtent(extent) {
        const data = this.rbush_.toJSON();
        return (0, $110ceb23457e07e7$export$958e3e1a02eac4b6)(data.minX, data.minY, data.maxX, data.maxY, extent);
    }
    /**
   * @param {RBush<T>} rbush R-Tree.
   */ concat(rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for(const i in rbush.items_)this.items_[i] = rbush.items_[i];
    }
}
var $a02af6d3107593df$export$2e2bcd8739ae039 = $a02af6d3107593df$var$RBush;




/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $53b6a3c728017621$export$2e2bcd8739ae039 /**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */  = {
    /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */ ADDFEATURE: 'addfeature',
    /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */ CHANGEFEATURE: 'changefeature',
    /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */ CLEAR: 'clear',
    /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */ REMOVEFEATURE: 'removefeature',
    /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */ FEATURESLOADSTART: 'featuresloadstart',
    /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */ FEATURESLOADEND: 'featuresloadend',
    /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */ FEATURESLOADERROR: 'featuresloaderror'
};


class $694a6d81ae8728a9$export$d402fd02dc2b661c extends (0, $5ede4ff5599f8860$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {FeatureType} [feature] Feature.
   * @param {Array<FeatureType>} [features] Features.
   */ constructor(type, feature, features){
        super(type);
        /**
     * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
     * @type {FeatureType|undefined}
     * @api
     */ this.feature = feature;
        /**
     * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
     * @type {Array<FeatureType>|undefined}
     * @api
     */ this.features = features;
    }
}
/***
 * @template {import("../Feature.js").FeatureLike} [T=import("../Feature.js").default]
 * @typedef {T extends RenderFeature ? T|Array<T> : T} FeatureClassOrArrayOfRenderFeatures
 */ /***
 * @template Return
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./VectorEventType").VectorSourceEventTypes, VectorSourceEvent<FeatureType>, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./VectorEventType").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<FeatureType>|Collection<FeatureType>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default<FeatureType>} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader<FeatureType>} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import Vector from 'ol/source/Vector.js';
 * import GeoJSON from 'ol/format/GeoJSON.js';
 * import {bbox} from 'ol/loadingstrategy.js';
 *
 * const vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection, success, failure) {
 *      const proj = projection.getCode();
 *      const url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      const xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      const onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *        failure();
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          const features = vectorSource.getFormat().readFeatures(xhr.responseText);
 *          vectorSource.addFeatures(features);
 *          success(features);
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox,
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 */ class $694a6d81ae8728a9$var$VectorSource extends (0, $f49cf02121669501$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Vector source options.
   */ constructor(options){
        options = options || {};
        super({
            attributions: options.attributions,
            interpolate: true,
            projection: undefined,
            state: 'ready',
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        });
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.on;
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.once;
        /***
     * @type {VectorSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader<import("../Feature.js").FeatureLike>}
     */ this.loader_ = (0, $1a39c7df251dabdd$export$1cd1943b3a73bbe8);
        /**
     * @private
     * @type {import("../format/Feature.js").default<FeatureType>|null}
     */ this.format_ = options.format || null;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */ this.url_ = options.url;
        if (options.loader !== undefined) this.loader_ = options.loader;
        else if (this.url_ !== undefined) {
            (0, $4b57691230be0bd5$export$a7a9523472993e97)(this.format_, '`format` must be set when `url` is set');
            // create a XHR feature loader for "url" and "format"
            this.loader_ = (0, $4fbf60f1e6dcbc40$export$14cc81df70b6707e)(this.url_, this.format_);
        }
        /**
     * @private
     * @type {LoadingStrategy}
     */ this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $4fd454b9cb88836f$export$84bf76cd7afc7469);
        const useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
     * @private
     * @type {RBush<FeatureType>}
     */ this.featuresRtree_ = useSpatialIndex ? new (0, $a02af6d3107593df$export$2e2bcd8739ae039)() : null;
        /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */ this.loadedExtentsRtree_ = new (0, $a02af6d3107593df$export$2e2bcd8739ae039)();
        /**
     * @type {number}
     * @private
     */ this.loadingExtentsCount_ = 0;
        /**
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.nullGeometryFeatures_ = {};
        /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, import('../Feature.js').FeatureLike|Array<import('../Feature.js').FeatureLike>>}
     */ this.idIndex_ = {};
        /**
     * A lookup of features by uid (using getUid(feature)).
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.uidIndex_ = {};
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.featureChangeKeys_ = {};
        /**
     * @private
     * @type {Collection<FeatureType>|null}
     */ this.featuresCollection_ = null;
        /** @type {Collection<FeatureType>} */ let collection;
        /** @type {Array<FeatureType>} */ let features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $9ac53bee919957f3$export$2e2bcd8739ae039)(features);
        if (features !== undefined) this.addFeaturesInternal(features);
        if (collection !== undefined) this.bindFeaturesCollection_(collection);
    }
    /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if a {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {FeatureType} feature Feature to add.
   * @api
   */ addFeature(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    }
    /**
   * Add a feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @protected
   */ addFeatureInternal(feature) {
        const featureKey = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) this.featuresCollection_.remove(feature);
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        const geometry = feature.getGeometry();
        if (geometry) {
            const extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new $694a6d81ae8728a9$export$d402fd02dc2b661c((0, $53b6a3c728017621$export$2e2bcd8739ae039).ADDFEATURE, feature));
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @private
   */ setupChangeEvents_(featureKey, feature) {
        if (feature instanceof (0, $e450b21b255017c3$export$2e2bcd8739ae039)) return;
        this.featureChangeKeys_[featureKey] = [
            (0, $7d7dee7854c96264$export$63174c828edd6ff8)(feature, (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_, this),
            (0, $7d7dee7854c96264$export$63174c828edd6ff8)(feature, (0, $2a15c8802c911fe7$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */ addToIndex_(featureKey, feature) {
        let valid = true;
        if (feature.getId() !== undefined) {
            const id = String(feature.getId());
            if (!(id in this.idIndex_)) this.idIndex_[id] = feature;
            else if (feature instanceof (0, $e450b21b255017c3$export$2e2bcd8739ae039)) {
                const indexedFeature = this.idIndex_[id];
                if (!(indexedFeature instanceof (0, $e450b21b255017c3$export$2e2bcd8739ae039))) valid = false;
                else if (!Array.isArray(indexedFeature)) this.idIndex_[id] = [
                    indexedFeature,
                    feature
                ];
                else indexedFeature.push(feature);
            } else valid = false;
        }
        if (valid) {
            (0, $4b57691230be0bd5$export$a7a9523472993e97)(!(featureKey in this.uidIndex_), 'The passed `feature` was already added to the source');
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    }
    /**
   * Add a batch of features to the source.
   * @param {Array<FeatureType>} features Features to add.
   * @api
   */ addFeatures(features) {
        this.addFeaturesInternal(features);
        this.changed();
    }
    /**
   * Add features without firing a `change` event.
   * @param {Array<FeatureType>} features Features.
   * @protected
   */ addFeaturesInternal(features) {
        const extents = [];
        /** @type {Array<FeatureType>} */ const newFeatures = [];
        /** @type {Array<FeatureType>} */ const geometryFeatures = [];
        for(let i = 0, length = features.length; i < length; i++){
            const feature = features[i];
            const featureKey = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(let i = 0, length = newFeatures.length; i < length; i++){
            const feature = newFeatures[i];
            const featureKey = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(feature);
            this.setupChangeEvents_(featureKey, feature);
            const geometry = feature.getGeometry();
            if (geometry) {
                const extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            } else this.nullGeometryFeatures_[featureKey] = feature;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        if (this.hasListener((0, $53b6a3c728017621$export$2e2bcd8739ae039).ADDFEATURE)) for(let i = 0, length = newFeatures.length; i < length; i++)this.dispatchEvent(new $694a6d81ae8728a9$export$d402fd02dc2b661c((0, $53b6a3c728017621$export$2e2bcd8739ae039).ADDFEATURE, newFeatures[i]));
    }
    /**
   * @param {!Collection<FeatureType>} collection Collection.
   * @private
   */ bindFeaturesCollection_(collection) {
        let modifyingCollection = false;
        this.addEventListener((0, $53b6a3c728017621$export$2e2bcd8739ae039).ADDFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener((0, $53b6a3c728017621$export$2e2bcd8739ae039).REMOVEFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $1febc2967664bf62$export$2e2bcd8739ae039).ADD, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(evt.element);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $1febc2967664bf62$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(evt.element);
                modifyingCollection = false;
            }
        });
        this.featuresCollection_ = collection;
    }
    /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature} events.
   * @api
   */ clear(fast) {
        if (fast) {
            for(const featureId in this.featureChangeKeys_){
                const keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, $7d7dee7854c96264$export$b0a21c8b3c1c921));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            this.featuresRtree_.forEach((feature)=>{
                this.removeFeatureInternal(feature);
            });
            for(const id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.nullGeometryFeatures_ = {};
        const clearEvent = new $694a6d81ae8728a9$export$d402fd02dc2b661c((0, $53b6a3c728017621$export$2e2bcd8739ae039).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    }
    /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(FeatureType): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeature(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * For {@link module:ol/render/Feature~RenderFeature} features, the callback will be
   * called for all features.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */ forEachFeatureAtCoordinateDirect(coordinate, callback) {
        const extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $e450b21b255017c3$export$2e2bcd8739ae039) || geometry.intersectsCoordinate(coordinate)) return callback(feature);
            return undefined;
        });
    }
    /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureInExtent(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureIntersectingExtent(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */ function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $e450b21b255017c3$export$2e2bcd8739ae039) || geometry.intersectsExtent(extent)) {
                const result = callback(feature);
                if (result) return result;
            }
        });
    }
    /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with a {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<FeatureType>|null} The collection of features.
   * @api
   */ getFeaturesCollection() {
        return this.featuresCollection_;
    }
    /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeatures() {
        let features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray().slice(0);
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, $0364d4893e3f1129$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_)) (0, $9d07dd9052c3de0c$export$8b58be045bf06082)(features, Object.values(this.nullGeometryFeatures_));
        }
        return features;
    }
    /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesAtCoordinate(coordinate) {
        /** @type {Array<FeatureType>} */ const features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    }
    /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../proj/Projection.js").default} [projection] Include features
   * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesInExtent(extent, projection) {
        if (this.featuresRtree_) {
            const multiWorld = projection && projection.canWrapX() && this.getWrapX();
            if (!multiWorld) return this.featuresRtree_.getInExtent(extent);
            const extents = (0, $110ceb23457e07e7$export$9031237f01de0947)(extent, projection);
            return [].concat(...extents.map((anExtent)=>this.featuresRtree_.getInExtent(anExtent)));
        }
        if (this.featuresCollection_) return this.featuresCollection_.getArray().slice(0);
        return [];
    }
    /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false` and the features in this source are of type
   * {@link module:ol/Feature~Feature}.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType):boolean} [filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {FeatureType} Closest feature.
   * @api
   */ getClosestFeatureToCoordinate(coordinate, filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        const x = coordinate[0];
        const y = coordinate[1];
        let closestFeature = null;
        const closestPoint = [
            NaN,
            NaN
        ];
        let minSquaredDistance = Infinity;
        const extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        filter = filter ? filter : (0, $1a39c7df251dabdd$export$22e23a2304399231);
        this.featuresRtree_.forEachInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       */ function(feature) {
            if (filter(feature)) {
                const geometry = feature.getGeometry();
                const previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry instanceof (0, $e450b21b255017c3$export$2e2bcd8739ae039) ? 0 : geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    const minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    }
    /**
   * Get the extent of the features currently in the source.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent(extent) {
        return this.featuresRtree_.getExtent(extent);
    }
    /**
   * Get a feature by its identifier (the value returned by feature.getId()). When `RenderFeature`s
   * are used, `getFeatureById()` can return an array of `RenderFeature`s. This allows for handling
   * of `GeometryCollection` geometries, where format readers create one `RenderFeature` per
   * `GeometryCollection` member.
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {FeatureClassOrArrayOfRenderFeatures<FeatureType>|null} The feature (or `null` if not found).
   * @api
   */ getFeatureById(id) {
        const feature = this.idIndex_[id.toString()];
        return feature !== undefined ? /** @type {FeatureClassOrArrayOfRenderFeatures<FeatureType>} */ feature : null;
    }
    /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {FeatureType|null} The feature (or `null` if not found).
   */ getFeatureByUid(uid) {
        const feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    }
    /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default<FeatureType>|null}} The feature format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ getOverlaps() {
        return this.overlaps_;
    }
    /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * @param {Event} event Event.
   * @private
   */ handleFeatureChange_(event) {
        const feature = /** @type {FeatureType} */ event.target;
        const featureKey = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(feature);
        const geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            const extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        const id = feature.getId();
        if (id !== undefined) {
            const sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new $694a6d81ae8728a9$export$d402fd02dc2b661c((0, $53b6a3c728017621$export$2e2bcd8739ae039).CHANGEFEATURE, feature));
    }
    /**
   * Returns true if the feature is contained within the source.
   * @param {FeatureType} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */ hasFeature(feature) {
        const id = feature.getId();
        if (id !== undefined) return id in this.idIndex_;
        return (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(feature) in this.uidIndex_;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        if (this.featuresRtree_) return this.featuresRtree_.isEmpty() && (0, $0364d4893e3f1129$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_);
        if (this.featuresCollection_) return this.featuresCollection_.getLength() === 0;
        return true;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ loadFeatures(extent, resolution, projection) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const extentsToLoad = this.strategy_(extent, resolution, projection);
        for(let i = 0, ii = extentsToLoad.length; i < ii; ++i){
            const extentToLoad = extentsToLoad[i];
            const alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */ function(object) {
                return (0, $110ceb23457e07e7$export$be866b1e0809b17e)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                ++this.loadingExtentsCount_;
                this.dispatchEvent(new $694a6d81ae8728a9$export$d402fd02dc2b661c((0, $53b6a3c728017621$export$2e2bcd8739ae039).FEATURESLOADSTART));
                this.loader_.call(this, extentToLoad, resolution, projection, /**
           * @param {Array<FeatureType>} features Loaded features
           */ (features)=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $694a6d81ae8728a9$export$d402fd02dc2b661c((0, $53b6a3c728017621$export$2e2bcd8739ae039).FEATURESLOADEND, undefined, features));
                }, ()=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $694a6d81ae8728a9$export$d402fd02dc2b661c((0, $53b6a3c728017621$export$2e2bcd8739ae039).FEATURESLOADERROR));
                });
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
            }
        }
        this.loading = this.loader_.length < 4 ? false : this.loadingExtentsCount_ > 0;
    }
    /**
   * @override
   */ refresh() {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        super.refresh();
    }
    /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ removeLoadedExtent(extent) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const obj = loadedExtentsRtree.forEachInExtent(extent, function(object) {
            if ((0, $110ceb23457e07e7$export$e9bab7fafb253603)(object.extent, extent)) return object;
        });
        if (obj) loadedExtentsRtree.remove(obj);
    }
    /**
   * Batch remove features from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {Array<FeatureType>} features Features to remove.
   * @api
   */ removeFeatures(features) {
        let removed = false;
        for(let i = 0, ii = features.length; i < ii; ++i)removed = this.removeFeatureInternal(features[i]) || removed;
        if (removed) this.changed();
    }
    /**
   * Remove a single feature from the source. If you want to batch remove
   * features, use the {@link module:ol/source/Vector~VectorSource#removeFeatures #removeFeatures()} method
   * instead.
   * @param {FeatureType} feature Feature to remove.
   * @api
   */ removeFeature(feature) {
        if (!feature) return;
        const removed = this.removeFeatureInternal(feature);
        if (removed) this.changed();
    }
    /**
   * Remove feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @return {boolean} True if the feature was removed, false if it was not found.
   * @protected
   */ removeFeatureInternal(feature) {
        const featureKey = (0, $9f65e6f92d33bc27$export$5e82334337e0f204)(feature);
        if (!(featureKey in this.uidIndex_)) return false;
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        const featureChangeKeys = this.featureChangeKeys_[featureKey];
        featureChangeKeys?.forEach((0, $7d7dee7854c96264$export$b0a21c8b3c1c921));
        delete this.featureChangeKeys_[featureKey];
        const id = feature.getId();
        if (id !== undefined) {
            const idString = id.toString();
            const indexedFeature = this.idIndex_[idString];
            if (indexedFeature === feature) delete this.idIndex_[idString];
            else if (Array.isArray(indexedFeature)) {
                indexedFeature.splice(indexedFeature.indexOf(feature), 1);
                if (indexedFeature.length === 1) this.idIndex_[idString] = indexedFeature[0];
            }
        }
        delete this.uidIndex_[featureKey];
        if (this.hasListener((0, $53b6a3c728017621$export$2e2bcd8739ae039).REMOVEFEATURE)) this.dispatchEvent(new $694a6d81ae8728a9$export$d402fd02dc2b661c((0, $53b6a3c728017621$export$2e2bcd8739ae039).REMOVEFEATURE, feature));
        return true;
    }
    /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {FeatureType} feature The feature.
   * @private
   */ removeFromIdIndex_(feature) {
        for(const id in this.idIndex_)if (this.idIndex_[id] === feature) {
            delete this.idIndex_[id];
            break;
        }
    }
    /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
   * @api
   */ setLoader(loader) {
        this.loader_ = loader;
    }
    /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */ setUrl(url) {
        (0, $4b57691230be0bd5$export$a7a9523472993e97)(this.format_, '`format` must be set when `url` is set');
        this.url_ = url;
        this.setLoader((0, $4fbf60f1e6dcbc40$export$14cc81df70b6707e)(url, this.format_));
    }
    /**
   * @param {boolean} overlaps The source can have overlapping geometries.
   */ setOverlaps(overlaps) {
        this.overlaps_ = overlaps;
        this.changed();
    }
}
var $694a6d81ae8728a9$export$2e2bcd8739ae039 = $694a6d81ae8728a9$var$VectorSource;





/**
 * @typedef {Object} Options
 * @property {import("../geom/Geometry.js").Type} type Geometry type of
 * the geometries being drawn with this instance.
 * @property {number} [clickTolerance=6] The maximum distance in pixels between
 * "down" and "up" for a "up" event to be considered a "click" event and
 * actually add a point/vertex to the geometry being drawn.  The default of `6`
 * was chosen for the draw interaction to behave correctly on mouse as well as
 * on touch devices.
 * @property {import("../Collection.js").default<Feature>} [features]
 * Destination collection for the drawn features.
 * @property {VectorSource} [source] Destination source for
 * the drawn features.
 * @property {number} [dragVertexDelay=500] Delay in milliseconds after pointerdown
 * before the current vertex can be dragged to its exact position.
 * @property {number} [snapTolerance=12] Pixel distance for snapping to the
 * drawing finish. Must be greater than `0`.
 * @property {boolean} [stopClick=false] Stop click, singleclick, and
 * doubleclick events from firing during drawing.
 * @property {number} [maxPoints] The number of points that can be drawn before
 * a polygon ring or line string is finished. By default there is no
 * restriction.
 * @property {number} [minPoints] The number of points that must be drawn
 * before a polygon ring or line string can be finished. Default is `3` for
 * polygon rings and `2` for line strings.
 * @property {import("../events/condition.js").Condition} [finishCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether the drawing can be finished. Not used when drawing
 * POINT or MULTI_POINT geometries.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike} [style]
 * Style for sketch features. The draw interaction can have up to three sketch features, depending on the mode.
 * It will always contain a feature with a `Point` geometry that corresponds to the current cursor position.
 * If the mode is `LineString` or `Polygon`, and there is at least one drawn point, it will also contain a feature with
 * a `LineString` geometry that corresponds to the line between the already drawn points and the current cursor position.
 * If the mode is `Polygon`, and there is at least one drawn point, it will also contain a feature with a `Polygon`
 * geometry that corresponds to the polygon between the already drawn points and the current cursor position
 * (note that this polygon has only two points if only one point is drawn).
 * If the mode is `Circle`, and there is one point drawn, it will also contain a feature with a `Circle` geometry whose
 * center is the drawn point and the radius is determined by the distance between the drawn point and the cursor.
 * @property {GeometryFunction} [geometryFunction]
 * Function that is called when a geometry's coordinates are updated.
 * @property {string} [geometryName] Geometry name to use for features created
 * by the draw interaction.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default {@link module:ol/events/condition.noModifierKeys}, i.e. a click,
 * adds a vertex or deactivates freehand drawing.
 * @property {boolean} [freehand=false] Operate in freehand mode for lines,
 * polygons, and circles.  This makes the interaction always operate in freehand
 * mode and takes precedence over any `freehandCondition` option.
 * @property {import("../events/condition.js").Condition} [freehandCondition]
 * Condition that activates freehand drawing for lines and polygons. This
 * function takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
 * returns a boolean to indicate whether that event should be handled. The
 * default is {@link module:ol/events/condition.shiftKeyOnly}, meaning that the
 * Shift key activates freehand drawing.
 * @property {boolean|import("../events/condition.js").Condition} [trace=false] Trace a portion of another geometry.
 * Ignored when in freehand mode.
 * @property {VectorSource} [traceSource] Source for features to trace.  If tracing is active and a `traceSource` is
 * not provided, the interaction's `source` will be used.  Tracing requires that the interaction is configured with
 * either a `traceSource` or a `source`.
 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
 * overlay.
 * @property {import("../geom/Geometry.js").GeometryLayout} [geometryLayout='XY'] Layout of the
 * feature geometries created by the draw interaction.
 */ /**
 * Coordinate type when drawing points.
 * @typedef {import("../coordinate.js").Coordinate} PointCoordType
 */ /**
 * Coordinate type when drawing lines.
 * @typedef {Array<import("../coordinate.js").Coordinate>} LineCoordType
 */ /**
 * Coordinate type when drawing polygons.
 * @typedef {Array<Array<import("../coordinate.js").Coordinate>>} PolyCoordType
 */ /**
 * Types used for drawing coordinates.
 * @typedef {PointCoordType|LineCoordType|PolyCoordType} SketchCoordType
 */ /**
 * @typedef {Object} TraceState
 * @property {boolean} active Tracing active.
 * @property {import("../pixel.js").Pixel} [startPx] The initially clicked pixel location.
 * @property {Array<TraceTarget>} [targets] Targets available for tracing.
 * @property {number} [targetIndex] The index of the currently traced target.  A value of -1 indicates
 * that no trace target is active.
 */ /**
 * @typedef {Object} TraceTarget
 * @property {Array<import("../coordinate.js").Coordinate>} coordinates Target coordinates.
 * @property {boolean} ring The target coordinates are a linear ring.
 * @property {number} startIndex The index of first traced coordinate.  A fractional index represents an
 * edge intersection.  Index values for rings will wrap (may be negative or larger than coordinates length).
 * @property {number} endIndex The index of last traced coordinate.  Details from startIndex also apply here.
 */ /**
 * Function that takes an array of coordinates and an optional existing geometry
 * and a projection as arguments, and returns a geometry. The optional existing
 * geometry is the geometry that is returned when the function is called without
 * a second argument.
 * @typedef {function(!SketchCoordType, import("../geom/SimpleGeometry.js").default,
 *     import("../proj/Projection.js").default):
 *     import("../geom/SimpleGeometry.js").default} GeometryFunction
 */ /**
 * @typedef {'Point' | 'LineString' | 'Polygon' | 'Circle'} Mode
 * Draw mode.  This collapses multi-part geometry types with their single-part
 * cousins.
 */ /**
 * @enum {string}
 */ const $4074cae391b7ea9d$var$DrawEventType = {
    /**
   * Triggered upon feature draw start
   * @event DrawEvent#drawstart
   * @api
   */ DRAWSTART: 'drawstart',
    /**
   * Triggered upon feature draw end
   * @event DrawEvent#drawend
   * @api
   */ DRAWEND: 'drawend',
    /**
   * Triggered upon feature draw abortion
   * @event DrawEvent#drawabort
   * @api
   */ DRAWABORT: 'drawabort'
};
class $4074cae391b7ea9d$export$85a4910380d251a7 extends (0, $5ede4ff5599f8860$export$2e2bcd8739ae039) {
    /**
   * @param {DrawEventType} type Type.
   * @param {Feature} feature The feature drawn.
   */ constructor(type, feature){
        super(type);
        /**
     * The feature being drawn.
     * @type {Feature}
     * @api
     */ this.feature = feature;
    }
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {Array<Feature>} features The candidate features.
 * @return {Array<TraceTarget>} The trace targets.
 */ function $4074cae391b7ea9d$var$getTraceTargets(coordinate, features) {
    /**
   * @type {Array<TraceTarget>}
   */ const targets = [];
    for(let i = 0; i < features.length; ++i){
        const feature = features[i];
        const geometry = feature.getGeometry();
        $4074cae391b7ea9d$var$appendGeometryTraceTargets(coordinate, geometry, targets);
    }
    return targets;
}
/**
 * @param {import("../coordinate.js").Coordinate} a One coordinate.
 * @param {import("../coordinate.js").Coordinate} b Another coordinate.
 * @return {number} The squared distance between the two coordinates.
 */ function $4074cae391b7ea9d$var$getSquaredDistance(a, b) {
    return (0, $91ceb5420a5c8360$export$88e6ebb4fe54f538)(a[0], a[1], b[0], b[1]);
}
/**
 * @param {LineCoordType} coordinates The ring coordinates.
 * @param {number} index The index.  May be wrapped.
 * @return {import("../coordinate.js").Coordinate} The coordinate.
 */ function $4074cae391b7ea9d$var$getCoordinate(coordinates, index) {
    const count = coordinates.length;
    if (index < 0) return coordinates[index + count];
    if (index >= count) return coordinates[index - count];
    return coordinates[index];
}
/**
 * Get the cumulative squared distance along a ring path.  The end index index may be "wrapped" and it may
 * be less than the start index to indicate the direction of travel.  The start and end index may have
 * a fractional part to indicate a point between two coordinates.
 * @param {LineCoordType} coordinates Ring coordinates.
 * @param {number} startIndex The start index.
 * @param {number} endIndex The end index.
 * @return {number} The cumulative squared distance along the ring path.
 */ function $4074cae391b7ea9d$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex) {
    let lowIndex, highIndex;
    if (startIndex < endIndex) {
        lowIndex = startIndex;
        highIndex = endIndex;
    } else {
        lowIndex = endIndex;
        highIndex = startIndex;
    }
    const lowWholeIndex = Math.ceil(lowIndex);
    const highWholeIndex = Math.floor(highIndex);
    if (lowWholeIndex > highWholeIndex) {
        // both start and end are on the same segment
        const start = $4074cae391b7ea9d$var$interpolateCoordinate(coordinates, lowIndex);
        const end = $4074cae391b7ea9d$var$interpolateCoordinate(coordinates, highIndex);
        return $4074cae391b7ea9d$var$getSquaredDistance(start, end);
    }
    let sd = 0;
    if (lowIndex < lowWholeIndex) {
        const start = $4074cae391b7ea9d$var$interpolateCoordinate(coordinates, lowIndex);
        const end = $4074cae391b7ea9d$var$getCoordinate(coordinates, lowWholeIndex);
        sd += $4074cae391b7ea9d$var$getSquaredDistance(start, end);
    }
    if (highWholeIndex < highIndex) {
        const start = $4074cae391b7ea9d$var$getCoordinate(coordinates, highWholeIndex);
        const end = $4074cae391b7ea9d$var$interpolateCoordinate(coordinates, highIndex);
        sd += $4074cae391b7ea9d$var$getSquaredDistance(start, end);
    }
    for(let i = lowWholeIndex; i < highWholeIndex - 1; ++i){
        const start = $4074cae391b7ea9d$var$getCoordinate(coordinates, i);
        const end = $4074cae391b7ea9d$var$getCoordinate(coordinates, i + 1);
        sd += $4074cae391b7ea9d$var$getSquaredDistance(start, end);
    }
    return sd;
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {import("../geom/Geometry.js").default} geometry The candidate geometry.
 * @param {Array<TraceTarget>} targets The trace targets.
 */ function $4074cae391b7ea9d$var$appendGeometryTraceTargets(coordinate, geometry, targets) {
    if (geometry instanceof (0, $0b7dcb8925c7efc9$export$2e2bcd8739ae039)) {
        $4074cae391b7ea9d$var$appendTraceTarget(coordinate, geometry.getCoordinates(), false, targets);
        return;
    }
    if (geometry instanceof (0, $b66089af173c4ae0$export$2e2bcd8739ae039)) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length; i < ii; ++i)$4074cae391b7ea9d$var$appendTraceTarget(coordinate, coordinates[i], false, targets);
        return;
    }
    if (geometry instanceof (0, $9549b42604551fb5$export$2e2bcd8739ae039)) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length; i < ii; ++i)$4074cae391b7ea9d$var$appendTraceTarget(coordinate, coordinates[i], true, targets);
        return;
    }
    if (geometry instanceof (0, $be4913079f931a6a$export$2e2bcd8739ae039)) {
        const polys = geometry.getCoordinates();
        for(let i = 0, ii = polys.length; i < ii; ++i){
            const coordinates = polys[i];
            for(let j = 0, jj = coordinates.length; j < jj; ++j)$4074cae391b7ea9d$var$appendTraceTarget(coordinate, coordinates[j], true, targets);
        }
        return;
    }
    if (geometry instanceof (0, $6b0a4ecd8d587c30$export$2e2bcd8739ae039)) {
        const geometries = geometry.getGeometries();
        for(let i = 0; i < geometries.length; ++i)$4074cae391b7ea9d$var$appendGeometryTraceTargets(coordinate, geometries[i], targets);
        return;
    }
// other types cannot be traced
}
/**
 * @typedef {Object} TraceTargetUpdateInfo
 * @property {number} index The new target index.
 * @property {number} endIndex The new segment end index.
 */ /**
 * @type {TraceTargetUpdateInfo}
 */ const $4074cae391b7ea9d$var$sharedUpdateInfo = {
    index: -1,
    endIndex: NaN
};
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {TraceState} traceState The trace state.
 * @param {import("../Map.js").default} map The map.
 * @param {number} snapTolerance The snap tolerance.
 * @return {TraceTargetUpdateInfo} Information about the new trace target.  The returned
 * object is reused between calls and must not be modified by the caller.
 */ function $4074cae391b7ea9d$var$getTraceTargetUpdate(coordinate, traceState, map, snapTolerance) {
    const x = coordinate[0];
    const y = coordinate[1];
    let closestTargetDistance = Infinity;
    let newTargetIndex = -1;
    let newEndIndex = NaN;
    for(let targetIndex = 0; targetIndex < traceState.targets.length; ++targetIndex){
        const target = traceState.targets[targetIndex];
        const coordinates = target.coordinates;
        let minSegmentDistance = Infinity;
        let endIndex;
        for(let coordinateIndex = 0; coordinateIndex < coordinates.length - 1; ++coordinateIndex){
            const start = coordinates[coordinateIndex];
            const end = coordinates[coordinateIndex + 1];
            const rel = $4074cae391b7ea9d$var$getPointSegmentRelationship(x, y, start, end);
            if (rel.squaredDistance < minSegmentDistance) {
                minSegmentDistance = rel.squaredDistance;
                endIndex = coordinateIndex + rel.along;
            }
        }
        if (minSegmentDistance < closestTargetDistance) {
            closestTargetDistance = minSegmentDistance;
            if (target.ring && traceState.targetIndex === targetIndex) {
                // same target, maintain the same trace direction
                if (target.endIndex > target.startIndex) // forward trace
                {
                    if (endIndex < target.startIndex) endIndex += coordinates.length;
                } else if (target.endIndex < target.startIndex) // reverse trace
                {
                    if (endIndex > target.startIndex) endIndex -= coordinates.length;
                }
            }
            newEndIndex = endIndex;
            newTargetIndex = targetIndex;
        }
    }
    const newTarget = traceState.targets[newTargetIndex];
    let considerBothDirections = newTarget.ring;
    if (traceState.targetIndex === newTargetIndex && considerBothDirections) {
        // only consider switching trace direction if close to the start
        const newCoordinate = $4074cae391b7ea9d$var$interpolateCoordinate(newTarget.coordinates, newEndIndex);
        const pixel = map.getPixelFromCoordinate(newCoordinate);
        if ((0, $188aedb30bca6ae8$export$9f17032d917177de)(pixel, traceState.startPx) > snapTolerance) considerBothDirections = false;
    }
    if (considerBothDirections) {
        const coordinates = newTarget.coordinates;
        const count = coordinates.length;
        const startIndex = newTarget.startIndex;
        const endIndex = newEndIndex;
        if (startIndex < endIndex) {
            const forwardDistance = $4074cae391b7ea9d$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex);
            const reverseDistance = $4074cae391b7ea9d$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex - count);
            if (reverseDistance < forwardDistance) newEndIndex -= count;
        } else {
            const reverseDistance = $4074cae391b7ea9d$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex);
            const forwardDistance = $4074cae391b7ea9d$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex + count);
            if (forwardDistance < reverseDistance) newEndIndex += count;
        }
    }
    $4074cae391b7ea9d$var$sharedUpdateInfo.index = newTargetIndex;
    $4074cae391b7ea9d$var$sharedUpdateInfo.endIndex = newEndIndex;
    return $4074cae391b7ea9d$var$sharedUpdateInfo;
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The clicked coordinate.
 * @param {Array<import("../coordinate.js").Coordinate>} coordinates The geometry component coordinates.
 * @param {boolean} ring The coordinates represent a linear ring.
 * @param {Array<TraceTarget>} targets The trace targets.
 */ function $4074cae391b7ea9d$var$appendTraceTarget(coordinate, coordinates, ring, targets) {
    const x = coordinate[0];
    const y = coordinate[1];
    for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
        const start = coordinates[i];
        const end = coordinates[i + 1];
        const rel = $4074cae391b7ea9d$var$getPointSegmentRelationship(x, y, start, end);
        if (rel.squaredDistance === 0) {
            const index = i + rel.along;
            targets.push({
                coordinates: coordinates,
                ring: ring,
                startIndex: index,
                endIndex: index
            });
            return;
        }
    }
}
/**
 * @typedef {Object} PointSegmentRelationship
 * @property {number} along The closest point expressed as a fraction along the segment length.
 * @property {number} squaredDistance The squared distance of the point to the segment.
 */ /**
 * @type {PointSegmentRelationship}
 */ const $4074cae391b7ea9d$var$sharedRel = {
    along: 0,
    squaredDistance: 0
};
/**
 * @param {number} x The point x.
 * @param {number} y The point y.
 * @param {import("../coordinate.js").Coordinate} start The segment start.
 * @param {import("../coordinate.js").Coordinate} end The segment end.
 * @return {PointSegmentRelationship} The point segment relationship.  The returned object is
 * shared between calls and must not be modified by the caller.
 */ function $4074cae391b7ea9d$var$getPointSegmentRelationship(x, y, start, end) {
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    let along = 0;
    let px = x1;
    let py = y1;
    if (dx !== 0 || dy !== 0) {
        along = (0, $91ceb5420a5c8360$export$7d15b64cf5a3a4c4)(((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy), 0, 1);
        px += dx * along;
        py += dy * along;
    }
    $4074cae391b7ea9d$var$sharedRel.along = along;
    $4074cae391b7ea9d$var$sharedRel.squaredDistance = (0, $91ceb5420a5c8360$export$a81f732198733497)((0, $91ceb5420a5c8360$export$88e6ebb4fe54f538)(x, y, px, py), 10);
    return $4074cae391b7ea9d$var$sharedRel;
}
/**
 * @param {LineCoordType} coordinates The coordinates.
 * @param {number} index The index.  May be fractional and may wrap.
 * @return {import("../coordinate.js").Coordinate} The interpolated coordinate.
 */ function $4074cae391b7ea9d$var$interpolateCoordinate(coordinates, index) {
    const count = coordinates.length;
    let startIndex = Math.floor(index);
    const along = index - startIndex;
    if (startIndex >= count) startIndex -= count;
    else if (startIndex < 0) startIndex += count;
    let endIndex = startIndex + 1;
    if (endIndex >= count) endIndex -= count;
    const start = coordinates[startIndex];
    const x0 = start[0];
    const y0 = start[1];
    const end = coordinates[endIndex];
    const dx = end[0] - x0;
    const dy = end[1] - y0;
    return [
        x0 + dx * along,
        y0 + dy * along
    ];
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'drawabort'|'drawend'|'drawstart', DrawEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'drawabort'|'drawend'|'drawstart', Return>} DrawOnSignature
 */ /**
 * @classdesc
 * Interaction for drawing feature geometries.
 *
 * @fires DrawEvent
 * @api
 */ class $4074cae391b7ea9d$var$Draw extends (0, $63cf7a649237d091$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $1a39c7df251dabdd$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /***
     * @type {DrawOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DrawOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DrawOnSignature<void>}
     */ this.un;
        /**
     * @type {boolean}
     * @private
     */ this.shouldHandle_ = false;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.downPx_ = null;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.downTimeout_;
        /**
     * @type {number|undefined}
     * @private
     */ this.lastDragTime_;
        /**
     * Pointer type of the last pointermove event
     * @type {string}
     * @private
     */ this.pointerType_;
        /**
     * @type {boolean}
     * @private
     */ this.freehand_ = false;
        /**
     * Target source for drawn features.
     * @type {VectorSource|null}
     * @private
     */ this.source_ = options.source ? options.source : null;
        /**
     * Target collection for drawn features.
     * @type {import("../Collection.js").default<Feature>|null}
     * @private
     */ this.features_ = options.features ? options.features : null;
        /**
     * Pixel distance for snapping.
     * @type {number}
     * @private
     */ this.snapTolerance_ = options.snapTolerance ? options.snapTolerance : 12;
        /**
     * Geometry type.
     * @type {import("../geom/Geometry.js").Type}
     * @private
     */ this.type_ = /** @type {import("../geom/Geometry.js").Type} */ options.type;
        /**
     * Drawing mode (derived from geometry type.
     * @type {Mode}
     * @private
     */ this.mode_ = $4074cae391b7ea9d$var$getMode(this.type_);
        /**
     * Stop click, singleclick, and doubleclick events from firing during drawing.
     * Default is `false`.
     * @type {boolean}
     * @private
     */ this.stopClick_ = !!options.stopClick;
        /**
     * The number of points that must be drawn before a polygon ring or line
     * string can be finished.  The default is 3 for polygon rings and 2 for
     * line strings.
     * @type {number}
     * @private
     */ this.minPoints_ = options.minPoints ? options.minPoints : this.mode_ === 'Polygon' ? 3 : 2;
        /**
     * The number of points that can be drawn before a polygon ring or line string
     * is finished. The default is no restriction.
     * @type {number}
     * @private
     */ this.maxPoints_ = this.mode_ === 'Circle' ? 2 : options.maxPoints ? options.maxPoints : Infinity;
        /**
     * A function to decide if a potential finish coordinate is permissible
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.finishCondition_ = options.finishCondition ? options.finishCondition : (0, $1a39c7df251dabdd$export$22e23a2304399231);
        /**
     * @private
     * @type {import("../geom/Geometry.js").GeometryLayout}
     */ this.geometryLayout_ = options.geometryLayout ? options.geometryLayout : 'XY';
        let geometryFunction = options.geometryFunction;
        if (!geometryFunction) {
            const mode = this.mode_;
            if (mode === 'Circle') /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */ geometryFunction = (coordinates, geometry, projection)=>{
                const circle = geometry ? /** @type {Circle} */ geometry : new (0, $ffa845aee0567855$export$2e2bcd8739ae039)([
                    NaN,
                    NaN
                ]);
                const center = (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(coordinates[0], projection);
                const squaredLength = (0, $188aedb30bca6ae8$export$88e6ebb4fe54f538)(center, (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(coordinates[coordinates.length - 1], projection));
                circle.setCenterAndRadius(center, Math.sqrt(squaredLength), this.geometryLayout_);
                const userProjection = (0, $d447c151baf41c8c$export$3973b77d5f6f2790)();
                if (userProjection) circle.transform(projection, userProjection);
                return circle;
            };
            else {
                let Constructor;
                if (mode === 'Point') Constructor = (0, $6d7bc2de9d52ca58$export$2e2bcd8739ae039);
                else if (mode === 'LineString') Constructor = (0, $0b7dcb8925c7efc9$export$2e2bcd8739ae039);
                else if (mode === 'Polygon') Constructor = (0, $9549b42604551fb5$export$2e2bcd8739ae039);
                /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */ geometryFunction = (coordinates, geometry, projection)=>{
                    if (geometry) {
                        if (mode === 'Polygon') {
                            if (coordinates[0].length) // Add a closing coordinate to match the first
                            geometry.setCoordinates([
                                coordinates[0].concat([
                                    coordinates[0][0]
                                ])
                            ], this.geometryLayout_);
                            else geometry.setCoordinates([], this.geometryLayout_);
                        } else geometry.setCoordinates(coordinates, this.geometryLayout_);
                    } else geometry = new Constructor(coordinates, this.geometryLayout_);
                    return geometry;
                };
            }
        }
        /**
     * @type {GeometryFunction}
     * @private
     */ this.geometryFunction_ = geometryFunction;
        /**
     * @type {number}
     * @private
     */ this.dragVertexDelay_ = options.dragVertexDelay !== undefined ? options.dragVertexDelay : 500;
        /**
     * Finish coordinate for the feature (first point for polygons, last point for
     * linestrings).
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.finishCoordinate_ = null;
        /**
     * Sketch feature.
     * @type {Feature<import('../geom/SimpleGeometry.js').default>}
     * @private
     */ this.sketchFeature_ = null;
        /**
     * Sketch point.
     * @type {Feature<Point>}
     * @private
     */ this.sketchPoint_ = null;
        /**
     * Sketch coordinates. Used when drawing a line or polygon.
     * @type {SketchCoordType}
     * @private
     */ this.sketchCoords_ = null;
        /**
     * Sketch line. Used when drawing polygon.
     * @type {Feature<LineString>}
     * @private
     */ this.sketchLine_ = null;
        /**
     * Sketch line coordinates. Used when drawing a polygon or circle.
     * @type {LineCoordType}
     * @private
     */ this.sketchLineCoords_ = null;
        /**
     * Squared tolerance for handling up events.  If the squared distance
     * between a down and up event is greater than this tolerance, up events
     * will not be handled.
     * @type {number}
     * @private
     */ this.squaredClickTolerance_ = options.clickTolerance ? options.clickTolerance * options.clickTolerance : 36;
        /**
     * Draw overlay where our sketch features are drawn.
     * @type {VectorLayer}
     * @private
     */ this.overlay_ = new (0, $b68d2b880a7192c0$export$2e2bcd8739ae039)({
            source: new (0, $694a6d81ae8728a9$export$2e2bcd8739ae039)({
                useSpatialIndex: false,
                wrapX: options.wrapX ? options.wrapX : false
            }),
            style: options.style ? options.style : $4074cae391b7ea9d$var$getDefaultStyleFunction(),
            updateWhileInteracting: true
        });
        /**
     * Name of the geometry attribute for newly created features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $7c36e8c1969503b1$export$fdc892d0d8fe3bfb);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.freehandCondition_;
        if (options.freehand) this.freehandCondition_ = (0, $7c36e8c1969503b1$export$ba9e5d519bc326ca);
        else this.freehandCondition_ = options.freehandCondition ? options.freehandCondition : (0, $7c36e8c1969503b1$export$5d31fe68a477cfbb);
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.traceCondition_;
        this.setTrace(options.trace || false);
        /**
     * @type {TraceState}
     * @private
     */ this.traceState_ = {
            active: false
        };
        /**
     * @type {VectorSource|null}
     * @private
     */ this.traceSource_ = options.traceSource || options.source || null;
        this.addChangeListener((0, $2e65a39ba17e537d$export$2e2bcd8739ae039).ACTIVE, this.updateState_);
    }
    /**
   * Toggle tracing mode or set a tracing condition.
   *
   * @param {boolean|import("../events/condition.js").Condition} trace A boolean to toggle tracing mode or an event
   *     condition that will be checked when a feature is clicked to determine if tracing should be active.
   */ setTrace(trace) {
        let condition;
        if (!trace) condition = (0, $7c36e8c1969503b1$export$b3e22bcfd64c1022);
        else if (trace === true) condition = (0, $7c36e8c1969503b1$export$ba9e5d519bc326ca);
        else condition = trace;
        this.traceCondition_ = condition;
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        super.setMap(map);
        this.updateState_();
    }
    /**
   * Get the overlay layer that this interaction renders sketch features to.
   * @return {VectorLayer} Overlay layer.
   * @api
   */ getOverlay() {
        return this.overlay_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may actually draw or finish the drawing.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(event) {
        if (event.originalEvent.type === (0, $bf06bd4bb8c9dc9a$export$2e2bcd8739ae039).CONTEXTMENU) // Avoid context menu for long taps when drawing on mobile
        event.originalEvent.preventDefault();
        this.freehand_ = this.mode_ !== 'Point' && this.freehandCondition_(event);
        let move = event.type === (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERMOVE;
        let pass = true;
        if (!this.freehand_ && this.lastDragTime_ && event.type === (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERDRAG) {
            const now = Date.now();
            if (now - this.lastDragTime_ >= this.dragVertexDelay_) {
                this.downPx_ = event.pixel;
                this.shouldHandle_ = !this.freehand_;
                move = true;
            } else this.lastDragTime_ = undefined;
            if (this.shouldHandle_ && this.downTimeout_ !== undefined) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
        }
        if (this.freehand_ && event.type === (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERDRAG && this.sketchFeature_ !== null) {
            this.addToDrawing_(event.coordinate);
            pass = false;
        } else if (this.freehand_ && event.type === (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERDOWN) pass = false;
        else if (move && this.getPointerCount() < 2) {
            pass = event.type === (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERMOVE;
            if (pass && this.freehand_) {
                this.handlePointerMove_(event);
                if (this.shouldHandle_) // Avoid page scrolling when freehand drawing on mobile
                event.originalEvent.preventDefault();
            } else if (event.originalEvent.pointerType === 'mouse' || event.type === (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERDRAG && this.downTimeout_ === undefined) this.handlePointerMove_(event);
        } else if (event.type === (0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).DBLCLICK) pass = false;
        return super.handleEvent(event) && pass;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(event) {
        this.shouldHandle_ = !this.freehand_;
        if (this.freehand_) {
            this.downPx_ = event.pixel;
            if (!this.finishCoordinate_) this.startDrawing_(event.coordinate);
            return true;
        }
        if (!this.condition_(event)) {
            this.lastDragTime_ = undefined;
            return false;
        }
        this.lastDragTime_ = Date.now();
        this.downTimeout_ = setTimeout(()=>{
            this.handlePointerMove_(new (0, $873b1fab144826d1$export$2e2bcd8739ae039)((0, $cf09cedd5e4115ce$export$2e2bcd8739ae039).POINTERMOVE, event.map, event.originalEvent, false, event.frameState));
        }, this.dragVertexDelay_);
        this.downPx_ = event.pixel;
        return true;
    }
    /**
   * @private
   */ deactivateTrace_() {
        this.traceState_ = {
            active: false
        };
    }
    /**
   * Activate or deactivate trace state based on a browser event.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ toggleTraceState_(event) {
        if (!this.traceSource_ || !this.traceCondition_(event)) return;
        if (this.traceState_.active) {
            this.deactivateTrace_();
            return;
        }
        const map = this.getMap();
        const lowerLeft = map.getCoordinateFromPixel([
            event.pixel[0] - this.snapTolerance_,
            event.pixel[1] + this.snapTolerance_
        ]);
        const upperRight = map.getCoordinateFromPixel([
            event.pixel[0] + this.snapTolerance_,
            event.pixel[1] - this.snapTolerance_
        ]);
        const extent = (0, $110ceb23457e07e7$export$8aceca7c77505534)([
            lowerLeft,
            upperRight
        ]);
        const features = this.traceSource_.getFeaturesInExtent(extent);
        if (features.length === 0) return;
        const targets = $4074cae391b7ea9d$var$getTraceTargets(event.coordinate, features);
        if (targets.length) this.traceState_ = {
            active: true,
            startPx: event.pixel.slice(),
            targets: targets,
            targetIndex: -1
        };
    }
    /**
   * @param {TraceTarget} target The trace target.
   * @param {number} endIndex The new end index of the trace.
   * @private
   */ addOrRemoveTracedCoordinates_(target, endIndex) {
        // three cases to handle:
        //  1. traced in the same direction and points need adding
        //  2. traced in the same direction and points need removing
        //  3. traced in a new direction
        const previouslyForward = target.startIndex <= target.endIndex;
        const currentlyForward = target.startIndex <= endIndex;
        if (previouslyForward === currentlyForward) {
            // same direction
            if (previouslyForward && endIndex > target.endIndex || !previouslyForward && endIndex < target.endIndex) // case 1 - add new points
            this.addTracedCoordinates_(target, target.endIndex, endIndex);
            else if (previouslyForward && endIndex < target.endIndex || !previouslyForward && endIndex > target.endIndex) // case 2 - remove old points
            this.removeTracedCoordinates_(endIndex, target.endIndex);
        } else {
            // case 3 - remove old points, add new points
            this.removeTracedCoordinates_(target.startIndex, target.endIndex);
            this.addTracedCoordinates_(target, target.startIndex, endIndex);
        }
    }
    /**
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ removeTracedCoordinates_(fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        let remove = 0;
        if (fromIndex < toIndex) {
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) end -= 1;
            remove = end - start + 1;
        } else {
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            remove = start - end + 1;
        }
        if (remove > 0) this.removeLastPoints_(remove);
    }
    /**
   * @param {TraceTarget} target The trace target.
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ addTracedCoordinates_(target, fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        const coordinates = [];
        if (fromIndex < toIndex) {
            // forward trace
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) // if end is snapped to a vertex, it will be added later
            end -= 1;
            for(let i = start; i <= end; ++i)coordinates.push($4074cae391b7ea9d$var$getCoordinate(target.coordinates, i));
        } else {
            // reverse trace
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            for(let i = start; i >= end; --i)coordinates.push($4074cae391b7ea9d$var$getCoordinate(target.coordinates, i));
        }
        if (coordinates.length) this.appendCoordinates(coordinates);
    }
    /**
   * Update the trace.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ updateTrace_(event) {
        const traceState = this.traceState_;
        if (!traceState.active) return;
        if (traceState.targetIndex === -1) {
            // check if we are ready to pick a target
            if ((0, $188aedb30bca6ae8$export$9f17032d917177de)(traceState.startPx, event.pixel) < this.snapTolerance_) return;
        }
        const updatedTraceTarget = $4074cae391b7ea9d$var$getTraceTargetUpdate(event.coordinate, traceState, this.getMap(), this.snapTolerance_);
        if (traceState.targetIndex !== updatedTraceTarget.index) {
            // target changed
            if (traceState.targetIndex !== -1) {
                // remove points added during previous trace
                const oldTarget = traceState.targets[traceState.targetIndex];
                this.removeTracedCoordinates_(oldTarget.startIndex, oldTarget.endIndex);
            }
            // add points for the new target
            const newTarget = traceState.targets[updatedTraceTarget.index];
            this.addTracedCoordinates_(newTarget, newTarget.startIndex, updatedTraceTarget.endIndex);
        } else {
            // target stayed the same
            const target = traceState.targets[traceState.targetIndex];
            this.addOrRemoveTracedCoordinates_(target, updatedTraceTarget.endIndex);
        }
        // modify the state with updated info
        traceState.targetIndex = updatedTraceTarget.index;
        const target = traceState.targets[traceState.targetIndex];
        target.endIndex = updatedTraceTarget.endIndex;
        // update event coordinate and pixel to match end point of final segment
        const coordinate = $4074cae391b7ea9d$var$interpolateCoordinate(target.coordinates, target.endIndex);
        const pixel = this.getMap().getPixelFromCoordinate(coordinate);
        event.coordinate = coordinate;
        event.pixel = [
            Math.round(pixel[0]),
            Math.round(pixel[1])
        ];
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(event) {
        let pass = true;
        if (this.getPointerCount() === 0) {
            if (this.downTimeout_) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
            this.handlePointerMove_(event);
            const tracing = this.traceState_.active;
            this.toggleTraceState_(event);
            if (this.shouldHandle_) {
                const startingToDraw = !this.finishCoordinate_;
                if (startingToDraw) this.startDrawing_(event.coordinate);
                if (!startingToDraw && this.freehand_) this.finishDrawing();
                else if (!this.freehand_ && (!startingToDraw || this.mode_ === 'Point')) {
                    if (this.atFinish_(event.pixel, tracing)) {
                        if (this.finishCondition_(event)) this.finishDrawing();
                    } else this.addToDrawing_(event.coordinate);
                }
                pass = false;
            } else if (this.freehand_) this.abortDrawing();
        }
        if (!pass && this.stopClick_) event.preventDefault();
        return pass;
    }
    /**
   * Handle move events.
   * @param {import("../MapBrowserEvent.js").default<PointerEvent>} event A move event.
   * @private
   */ handlePointerMove_(event) {
        this.pointerType_ = event.originalEvent.pointerType;
        if (this.downPx_ && (!this.freehand_ && this.shouldHandle_ || this.freehand_ && !this.shouldHandle_)) {
            const downPx = this.downPx_;
            const clickPx = event.pixel;
            const dx = downPx[0] - clickPx[0];
            const dy = downPx[1] - clickPx[1];
            const squaredDistance = dx * dx + dy * dy;
            this.shouldHandle_ = this.freehand_ ? squaredDistance > this.squaredClickTolerance_ : squaredDistance <= this.squaredClickTolerance_;
            if (!this.shouldHandle_) return;
        }
        if (!this.finishCoordinate_) {
            this.createOrUpdateSketchPoint_(event.coordinate.slice());
            return;
        }
        this.updateTrace_(event);
        this.modifyDrawing_(event.coordinate);
    }
    /**
   * Determine if an event is within the snapping tolerance of the start coord.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @param {boolean} [tracing] Drawing in trace mode (only stop if at the starting point).
   * @return {boolean} The event is within the snapping tolerance of the start.
   * @private
   */ atFinish_(pixel, tracing) {
        let at = false;
        if (this.sketchFeature_) {
            let potentiallyDone = false;
            let potentiallyFinishCoordinates = [
                this.finishCoordinate_
            ];
            const mode = this.mode_;
            if (mode === 'Point') at = true;
            else if (mode === 'Circle') at = this.sketchCoords_.length === 2;
            else if (mode === 'LineString') potentiallyDone = !tracing && this.sketchCoords_.length > this.minPoints_;
            else if (mode === 'Polygon') {
                const sketchCoords = /** @type {PolyCoordType} */ this.sketchCoords_;
                potentiallyDone = sketchCoords[0].length > this.minPoints_;
                potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2]
                ];
                if (tracing) potentiallyFinishCoordinates = [
                    sketchCoords[0][0]
                ];
                else potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2]
                ];
            }
            if (potentiallyDone) {
                const map = this.getMap();
                for(let i = 0, ii = potentiallyFinishCoordinates.length; i < ii; i++){
                    const finishCoordinate = potentiallyFinishCoordinates[i];
                    const finishPixel = map.getPixelFromCoordinate(finishCoordinate);
                    const dx = pixel[0] - finishPixel[0];
                    const dy = pixel[1] - finishPixel[1];
                    const snapTolerance = this.freehand_ ? 1 : this.snapTolerance_;
                    at = Math.sqrt(dx * dx + dy * dy) <= snapTolerance;
                    if (at) {
                        this.finishCoordinate_ = finishCoordinate;
                        break;
                    }
                }
            }
        }
        return at;
    }
    /**
   * @param {import("../coordinate").Coordinate} coordinates Coordinate.
   * @private
   */ createOrUpdateSketchPoint_(coordinates) {
        if (!this.sketchPoint_) {
            this.sketchPoint_ = new (0, $b9e33cd4bf1ba8a3$export$2e2bcd8739ae039)(new (0, $6d7bc2de9d52ca58$export$2e2bcd8739ae039)(coordinates));
            this.updateSketchFeatures_();
        } else {
            const sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinates);
        }
    }
    /**
   * @param {import("../geom/Polygon.js").default} geometry Polygon geometry.
   * @private
   */ createOrUpdateCustomSketchLine_(geometry) {
        if (!this.sketchLine_) this.sketchLine_ = new (0, $b9e33cd4bf1ba8a3$export$2e2bcd8739ae039)();
        const ring = geometry.getLinearRing(0);
        let sketchLineGeom = this.sketchLine_.getGeometry();
        if (!sketchLineGeom) {
            sketchLineGeom = new (0, $0b7dcb8925c7efc9$export$2e2bcd8739ae039)(ring.getFlatCoordinates(), ring.getLayout());
            this.sketchLine_.setGeometry(sketchLineGeom);
        } else {
            sketchLineGeom.setFlatCoordinates(ring.getLayout(), ring.getFlatCoordinates());
            sketchLineGeom.changed();
        }
    }
    /**
   * Start the drawing.
   * @param {import("../coordinate.js").Coordinate} start Start coordinate.
   * @private
   */ startDrawing_(start) {
        const projection = this.getMap().getView().getProjection();
        const stride = (0, $2d119a5aa713a216$export$6af0c1b4a8549a43)(this.geometryLayout_);
        while(start.length < stride)start.push(0);
        this.finishCoordinate_ = start;
        if (this.mode_ === 'Point') this.sketchCoords_ = start.slice();
        else if (this.mode_ === 'Polygon') {
            this.sketchCoords_ = [
                [
                    start.slice(),
                    start.slice()
                ]
            ];
            this.sketchLineCoords_ = this.sketchCoords_[0];
        } else this.sketchCoords_ = [
            start.slice(),
            start.slice()
        ];
        if (this.sketchLineCoords_) this.sketchLine_ = new (0, $b9e33cd4bf1ba8a3$export$2e2bcd8739ae039)(new (0, $0b7dcb8925c7efc9$export$2e2bcd8739ae039)(this.sketchLineCoords_));
        const geometry = this.geometryFunction_(this.sketchCoords_, undefined, projection);
        this.sketchFeature_ = new (0, $b9e33cd4bf1ba8a3$export$2e2bcd8739ae039)();
        if (this.geometryName_) this.sketchFeature_.setGeometryName(this.geometryName_);
        this.sketchFeature_.setGeometry(geometry);
        this.updateSketchFeatures_();
        this.dispatchEvent(new $4074cae391b7ea9d$export$85a4910380d251a7($4074cae391b7ea9d$var$DrawEventType.DRAWSTART, this.sketchFeature_));
    }
    /**
   * Modify the drawing.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @private
   */ modifyDrawing_(coordinate) {
        const map = this.getMap();
        const geometry = this.sketchFeature_.getGeometry();
        const projection = map.getView().getProjection();
        const stride = (0, $2d119a5aa713a216$export$6af0c1b4a8549a43)(this.geometryLayout_);
        let coordinates, last;
        while(coordinate.length < stride)coordinate.push(0);
        if (this.mode_ === 'Point') last = this.sketchCoords_;
        else if (this.mode_ === 'Polygon') {
            coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
            last = coordinates[coordinates.length - 1];
            if (this.atFinish_(map.getPixelFromCoordinate(coordinate))) // snap to finish
            coordinate = this.finishCoordinate_.slice();
        } else {
            coordinates = this.sketchCoords_;
            last = coordinates[coordinates.length - 1];
        }
        last[0] = coordinate[0];
        last[1] = coordinate[1];
        this.geometryFunction_(/** @type {!LineCoordType} */ this.sketchCoords_, geometry, projection);
        if (this.sketchPoint_) {
            const sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinate);
        }
        if (geometry.getType() === 'Polygon' && this.mode_ !== 'Polygon') this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ geometry);
        else if (this.sketchLineCoords_) {
            const sketchLineGeom = this.sketchLine_.getGeometry();
            sketchLineGeom.setCoordinates(this.sketchLineCoords_);
        }
        this.updateSketchFeatures_();
    }
    /**
   * Add a new coordinate to the drawing.
   * @param {!PointCoordType} coordinate Coordinate
   * @return {Feature<import("../geom/SimpleGeometry.js").default>} The sketch feature.
   * @private
   */ addToDrawing_(coordinate) {
        const geometry = this.sketchFeature_.getGeometry();
        const projection = this.getMap().getView().getProjection();
        let done;
        let coordinates;
        const mode = this.mode_;
        if (mode === 'LineString' || mode === 'Circle') {
            this.finishCoordinate_ = coordinate.slice();
            coordinates = /** @type {LineCoordType} */ this.sketchCoords_;
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) coordinates.pop();
                else done = true;
            }
            coordinates.push(coordinate.slice());
            this.geometryFunction_(coordinates, geometry, projection);
        } else if (mode === 'Polygon') {
            coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) coordinates.pop();
                else done = true;
            }
            coordinates.push(coordinate.slice());
            if (done) this.finishCoordinate_ = coordinates[0];
            this.geometryFunction_(this.sketchCoords_, geometry, projection);
        }
        this.createOrUpdateSketchPoint_(coordinate.slice());
        this.updateSketchFeatures_();
        if (done) return this.finishDrawing();
        return this.sketchFeature_;
    }
    /**
   * @param {number} n The number of points to remove.
   */ removeLastPoints_(n) {
        if (!this.sketchFeature_) return;
        const geometry = this.sketchFeature_.getGeometry();
        const projection = this.getMap().getView().getProjection();
        const mode = this.mode_;
        for(let i = 0; i < n; ++i){
            let coordinates;
            if (mode === 'LineString' || mode === 'Circle') {
                coordinates = /** @type {LineCoordType} */ this.sketchCoords_;
                coordinates.splice(-2, 1);
                if (coordinates.length >= 2) {
                    this.finishCoordinate_ = coordinates[coordinates.length - 2].slice();
                    const finishCoordinate = this.finishCoordinate_.slice();
                    coordinates[coordinates.length - 1] = finishCoordinate;
                    this.createOrUpdateSketchPoint_(finishCoordinate);
                }
                this.geometryFunction_(coordinates, geometry, projection);
                if (geometry.getType() === 'Polygon' && this.sketchLine_) this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ geometry);
            } else if (mode === 'Polygon') {
                coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
                coordinates.splice(-2, 1);
                const sketchLineGeom = this.sketchLine_.getGeometry();
                if (coordinates.length >= 2) {
                    const finishCoordinate = coordinates[coordinates.length - 2].slice();
                    coordinates[coordinates.length - 1] = finishCoordinate;
                    this.createOrUpdateSketchPoint_(finishCoordinate);
                }
                sketchLineGeom.setCoordinates(coordinates);
                this.geometryFunction_(this.sketchCoords_, geometry, projection);
            }
            if (coordinates.length === 1) {
                this.abortDrawing();
                break;
            }
        }
        this.updateSketchFeatures_();
    }
    /**
   * Remove last point of the feature currently being drawn. Does not do anything when
   * drawing POINT or MULTI_POINT geometries.
   * @api
   */ removeLastPoint() {
        this.removeLastPoints_(1);
    }
    /**
   * Stop drawing and add the sketch feature to the target layer.
   * The {@link module:ol/interaction/Draw~DrawEventType.DRAWEND} event is
   * dispatched before inserting the feature.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The drawn feature.
   * @api
   */ finishDrawing() {
        const sketchFeature = this.abortDrawing_();
        if (!sketchFeature) return null;
        let coordinates = this.sketchCoords_;
        const geometry = sketchFeature.getGeometry();
        const projection = this.getMap().getView().getProjection();
        if (this.mode_ === 'LineString') {
            // remove the redundant last point
            coordinates.pop();
            this.geometryFunction_(coordinates, geometry, projection);
        } else if (this.mode_ === 'Polygon') {
            // remove the redundant last point in ring
            /** @type {PolyCoordType} */ coordinates[0].pop();
            this.geometryFunction_(coordinates, geometry, projection);
            coordinates = geometry.getCoordinates();
        }
        // cast multi-part geometries
        if (this.type_ === 'MultiPoint') sketchFeature.setGeometry(new (0, $dc589d5f6ce8c14b$export$2e2bcd8739ae039)([
            /** @type {PointCoordType} */ coordinates
        ]));
        else if (this.type_ === 'MultiLineString') sketchFeature.setGeometry(new (0, $b66089af173c4ae0$export$2e2bcd8739ae039)([
            /** @type {LineCoordType} */ coordinates
        ]));
        else if (this.type_ === 'MultiPolygon') sketchFeature.setGeometry(new (0, $be4913079f931a6a$export$2e2bcd8739ae039)([
            /** @type {PolyCoordType} */ coordinates
        ]));
        // First dispatch event to allow full set up of feature
        this.dispatchEvent(new $4074cae391b7ea9d$export$85a4910380d251a7($4074cae391b7ea9d$var$DrawEventType.DRAWEND, sketchFeature));
        // Then insert feature
        if (this.features_) this.features_.push(sketchFeature);
        if (this.source_) this.source_.addFeature(sketchFeature);
        return sketchFeature;
    }
    /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The sketch feature (or null if none).
   * @private
   */ abortDrawing_() {
        this.finishCoordinate_ = null;
        const sketchFeature = this.sketchFeature_;
        this.sketchFeature_ = null;
        this.sketchPoint_ = null;
        this.sketchLine_ = null;
        this.overlay_.getSource().clear(true);
        this.deactivateTrace_();
        return sketchFeature;
    }
    /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @api
   */ abortDrawing() {
        const sketchFeature = this.abortDrawing_();
        if (sketchFeature) this.dispatchEvent(new $4074cae391b7ea9d$export$85a4910380d251a7($4074cae391b7ea9d$var$DrawEventType.DRAWABORT, sketchFeature));
    }
    /**
   * Append coordinates to the end of the geometry that is currently being drawn.
   * This can be used when drawing LineStrings or Polygons. Coordinates will
   * either be appended to the current LineString or the outer ring of the current
   * Polygon. If no geometry is being drawn, a new one will be created.
   * @param {!LineCoordType} coordinates Linear coordinates to be appended to
   * the coordinate array.
   * @api
   */ appendCoordinates(coordinates) {
        const mode = this.mode_;
        const newDrawing = !this.sketchFeature_;
        if (newDrawing) this.startDrawing_(coordinates[0]);
        /** @type {LineCoordType} */ let sketchCoords;
        if (mode === 'LineString' || mode === 'Circle') sketchCoords = /** @type {LineCoordType} */ this.sketchCoords_;
        else if (mode === 'Polygon') sketchCoords = this.sketchCoords_ && this.sketchCoords_.length ? /** @type {PolyCoordType} */ this.sketchCoords_[0] : [];
        else return;
        if (newDrawing) sketchCoords.shift();
        // Remove last coordinate from sketch drawing (this coordinate follows cursor position)
        sketchCoords.pop();
        // Append coordinate list
        for(let i = 0; i < coordinates.length; i++)this.addToDrawing_(coordinates[i]);
        const ending = coordinates[coordinates.length - 1];
        // Duplicate last coordinate for sketch drawing (cursor position)
        this.sketchFeature_ = this.addToDrawing_(ending);
        this.modifyDrawing_(ending);
    }
    /**
   * Initiate draw mode by starting from an existing geometry which will
   * receive new additional points. This only works on features with
   * `LineString` geometries, where the interaction will extend lines by adding
   * points to the end of the coordinates array.
   * This will change the original feature, instead of drawing a copy.
   *
   * The function will dispatch a `drawstart` event.
   *
   * @param {!Feature<LineString>} feature Feature to be extended.
   * @api
   */ extend(feature) {
        const geometry = feature.getGeometry();
        const lineString = geometry;
        this.sketchFeature_ = feature;
        this.sketchCoords_ = lineString.getCoordinates();
        const last = this.sketchCoords_[this.sketchCoords_.length - 1];
        this.finishCoordinate_ = last.slice();
        this.sketchCoords_.push(last.slice());
        this.sketchPoint_ = new (0, $b9e33cd4bf1ba8a3$export$2e2bcd8739ae039)(new (0, $6d7bc2de9d52ca58$export$2e2bcd8739ae039)(last));
        this.updateSketchFeatures_();
        this.dispatchEvent(new $4074cae391b7ea9d$export$85a4910380d251a7($4074cae391b7ea9d$var$DrawEventType.DRAWSTART, this.sketchFeature_));
    }
    /**
   * Redraw the sketch features.
   * @private
   */ updateSketchFeatures_() {
        const sketchFeatures = [];
        if (this.sketchFeature_) sketchFeatures.push(this.sketchFeature_);
        if (this.sketchLine_) sketchFeatures.push(this.sketchLine_);
        if (this.sketchPoint_) sketchFeatures.push(this.sketchPoint_);
        const overlaySource = this.overlay_.getSource();
        overlaySource.clear(true);
        overlaySource.addFeatures(sketchFeatures);
    }
    /**
   * @private
   */ updateState_() {
        const map = this.getMap();
        const active = this.getActive();
        if (!map || !active) this.abortDrawing();
        this.overlay_.setMap(active ? map : null);
    }
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function $4074cae391b7ea9d$var$getDefaultStyleFunction() {
    const styles = (0, $e22912a5c91750c8$export$ed1eaede5d0e77ac)();
    return function(feature, resolution) {
        return styles[feature.getGeometry().getType()];
    };
}
function $4074cae391b7ea9d$export$e636e17021965266(sides, angle) {
    return function(coordinates, geometry, projection) {
        const center = (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(/** @type {LineCoordType} */ coordinates[0], projection);
        const end = (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(/** @type {LineCoordType} */ coordinates[coordinates.length - 1], projection);
        const radius = Math.sqrt((0, $188aedb30bca6ae8$export$88e6ebb4fe54f538)(center, end));
        geometry = geometry || (0, $9549b42604551fb5$export$2451009d645fb8c2)(new (0, $ffa845aee0567855$export$2e2bcd8739ae039)(center), sides);
        let internalAngle = angle;
        if (!angle && angle !== 0) {
            const x = end[0] - center[0];
            const y = end[1] - center[1];
            internalAngle = Math.atan2(y, x);
        }
        (0, $9549b42604551fb5$export$87d6a1539a56e47f)(/** @type {Polygon} */ geometry, center, radius, internalAngle);
        const userProjection = (0, $d447c151baf41c8c$export$3973b77d5f6f2790)();
        if (userProjection) geometry.transform(projection, userProjection);
        return geometry;
    };
}
function $4074cae391b7ea9d$export$6459fc9e86be362e() {
    return function(coordinates, geometry, projection) {
        const extent = (0, $110ceb23457e07e7$export$8aceca7c77505534)(/** @type {LineCoordType} */ [
            coordinates[0],
            coordinates[coordinates.length - 1]
        ].map(function(coordinate) {
            return (0, $d447c151baf41c8c$export$d4b8ec0b96db1ee2)(coordinate, projection);
        }));
        const boxCoordinates = [
            [
                (0, $110ceb23457e07e7$export$8d09f5e2e1bf560d)(extent),
                (0, $110ceb23457e07e7$export$e77c1cf70445e168)(extent),
                (0, $110ceb23457e07e7$export$b84fa077c8b05295)(extent),
                (0, $110ceb23457e07e7$export$cb1538b07e6964ff)(extent),
                (0, $110ceb23457e07e7$export$8d09f5e2e1bf560d)(extent)
            ]
        ];
        if (geometry) geometry.setCoordinates(boxCoordinates);
        else geometry = new (0, $9549b42604551fb5$export$2e2bcd8739ae039)(boxCoordinates);
        const userProjection = (0, $d447c151baf41c8c$export$3973b77d5f6f2790)();
        if (userProjection) geometry.transform(projection, userProjection);
        return geometry;
    };
}
/**
 * Get the drawing mode.  The mode for multi-part geometries is the same as for
 * their single-part cousins.
 * @param {import("../geom/Geometry.js").Type} type Geometry type.
 * @return {Mode} Drawing mode.
 */ function $4074cae391b7ea9d$var$getMode(type) {
    switch(type){
        case 'Point':
        case 'MultiPoint':
            return 'Point';
        case 'LineString':
        case 'MultiLineString':
            return 'LineString';
        case 'Polygon':
        case 'MultiPolygon':
            return 'Polygon';
        case 'Circle':
            return 'Circle';
        default:
            throw new Error('Invalid type: ' + type);
    }
}
var $4074cae391b7ea9d$export$2e2bcd8739ae039 = $4074cae391b7ea9d$var$Draw;



/**
 * @module ol/format/GeoJSON
 */ 






/**
 * @module ol/format/JSONFeature
 */ 

/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for JSON feature formats.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {FeatureFormat<FeatureType>}
 * @abstract
 */ class $712bafe4552d4ea4$var$JSONFeature extends (0, $9ac77a234e054865$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */ getType() {
        return 'json';
    }
    /**
   * Read a feature.  Only works for a single feature. Use `readFeatures` to
   * read a feature collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @api
   * @override
   */ readFeature(source, options) {
        return this.readFeatureFromObject($712bafe4552d4ea4$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * Read all features.  Works with both a single feature and a feature
   * collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   * @api
   * @override
   */ readFeatures(source, options) {
        return this.readFeaturesFromObject($712bafe4552d4ea4$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeatureFromObject(object, options) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   */ readFeaturesFromObject(object, options) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Read a geometry.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   * @override
   */ readGeometry(source, options) {
        return this.readGeometryFromObject($712bafe4552d4ea4$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromObject(object, options) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   * @override
   */ readProjection(source) {
        return this.readProjectionFromObject($712bafe4552d4ea4$var$getObject(source));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromObject(object) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   * @override
   */ writeFeature(feature, options) {
        return JSON.stringify(this.writeFeatureObject(feature, options));
    }
    /**
   * @abstract
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeatureObject(feature, options) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   * @override
   */ writeFeatures(features, options) {
        return JSON.stringify(this.writeFeaturesObject(features, options));
    }
    /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeaturesObject(features, options) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
    /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded geometry.
   * @api
   * @override
   */ writeGeometry(geometry, options) {
        return JSON.stringify(this.writeGeometryObject(geometry, options));
    }
    /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeGeometryObject(geometry, options) {
        return (0, $9f65e6f92d33bc27$export$817eb92a8194bab0)();
    }
}
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {Object} Object.
 */ function $712bafe4552d4ea4$var$getObject(source) {
    if (typeof source === 'string') {
        const object = JSON.parse(source);
        return object ? /** @type {Object} */ object : null;
    }
    if (source !== null) return source;
    return null;
}
var $712bafe4552d4ea4$export$2e2bcd8739ae039 = $712bafe4552d4ea4$var$JSONFeature;


/**
 * @typedef {import("geojson").GeoJSON} GeoJSONObject
 * @typedef {import("geojson").Feature} GeoJSONFeature
 * @typedef {import("geojson").FeatureCollection} GeoJSONFeatureCollection
 * @typedef {import("geojson").Geometry} GeoJSONGeometry
 * @typedef {import("geojson").Point} GeoJSONPoint
 * @typedef {import("geojson").LineString} GeoJSONLineString
 * @typedef {import("geojson").Polygon} GeoJSONPolygon
 * @typedef {import("geojson").MultiPoint} GeoJSONMultiPoint
 * @typedef {import("geojson").MultiLineString} GeoJSONMultiLineString
 * @typedef {import("geojson").MultiPolygon} GeoJSONMultiPolygon
 * @typedef {import("geojson").GeometryCollection} GeoJSONGeometryCollection
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 *
 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection for features read or
 * written by the format.  Options passed to read or write methods will take precedence.
 * @property {string} [geometryName] Geometry name to use when creating features.
 * @property {boolean} [extractGeometryName=false] Certain GeoJSON providers include
 * the geometry_name field in the feature GeoJSON. If set to `true` the GeoJSON reader
 * will look for that field to set the geometry name. If both this field is set to `true`
 * and a `geometryName` is provided, the `geometryName` will take precedence.
 * @property {import('./Feature.js').FeatureToFeatureClass<FeatureType>} [featureClass] Feature class
 * to be used when reading features. The default is {@link module:ol/Feature~Feature}. If performance is
 * the primary concern, and features are not going to be modified or round-tripped through the format,
 * consider using {@link module:ol/render/Feature~RenderFeature}
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the GeoJSON format.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {JSONFeature<FeatureType>}
 * @api
 */ class $c6f7374fc2e125d0$var$GeoJSON extends (0, $712bafe4552d4ea4$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super();
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(options.dataProjection ? options.dataProjection : 'EPSG:4326');
        if (options.featureProjection) /**
       * @type {import("../proj/Projection.js").default}
       */ this.defaultFeatureProjection = (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(options.featureProjection);
        if (options.featureClass) this.featureClass = options.featureClass;
        /**
     * Name of the geometry attribute for features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * Look for the `geometry_name` in the feature GeoJSON
     * @type {boolean|undefined}
     * @private
     */ this.extractGeometryName_ = options.extractGeometryName;
        this.supportedMediaTypes = [
            'application/geo+json',
            'application/vnd.geo+json'
        ];
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @override
   */ readFeatureFromObject(object, options) {
        /**
     * @type {GeoJSONFeature}
     */ let geoJSONFeature = null;
        if (object['type'] === 'Feature') geoJSONFeature = /** @type {GeoJSONFeature} */ object;
        else geoJSONFeature = {
            'type': 'Feature',
            'geometry': /** @type {GeoJSONGeometry} */ object,
            'properties': null
        };
        const geometry = $c6f7374fc2e125d0$var$readGeometryInternal(geoJSONFeature['geometry'], options);
        if (this.featureClass === (0, $e450b21b255017c3$export$2e2bcd8739ae039)) return /** @type {FeatureType|Array<FeatureType>} */ (0, $9ac77a234e054865$export$f935e77582b330a)({
            geometry: geometry,
            id: geoJSONFeature['id'],
            properties: geoJSONFeature['properties']
        }, options);
        const feature = new (0, $b9e33cd4bf1ba8a3$export$2e2bcd8739ae039)();
        if (this.geometryName_) feature.setGeometryName(this.geometryName_);
        else if (this.extractGeometryName_ && geoJSONFeature['geometry_name']) feature.setGeometryName(geoJSONFeature['geometry_name']);
        feature.setGeometry((0, $9ac77a234e054865$export$322c9678d8c47bf)(geometry, options));
        if ('id' in geoJSONFeature) feature.setId(geoJSONFeature['id']);
        if (geoJSONFeature['properties']) feature.setProperties(geoJSONFeature['properties'], true);
        return /** @type {FeatureType|Array<FeatureType>} */ feature;
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   * @override
   */ readFeaturesFromObject(object, options) {
        const geoJSONObject = /** @type {GeoJSONObject} */ object;
        let features = null;
        if (geoJSONObject['type'] === 'FeatureCollection') {
            const geoJSONFeatureCollection = /** @type {GeoJSONFeatureCollection} */ object;
            features = [];
            const geoJSONFeatures = geoJSONFeatureCollection['features'];
            for(let i = 0, ii = geoJSONFeatures.length; i < ii; ++i){
                const featureObject = this.readFeatureFromObject(geoJSONFeatures[i], options);
                if (!featureObject) continue;
                features.push(featureObject);
            }
        } else features = [
            this.readFeatureFromObject(object, options)
        ];
        return /** @type {Array<FeatureType>} */ features.flat();
    }
    /**
   * @param {GeoJSONGeometry} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @override
   */ readGeometryFromObject(object, options) {
        return $c6f7374fc2e125d0$var$readGeometry(object, options);
    }
    /**
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   * @override
   */ readProjectionFromObject(object) {
        const crs = object['crs'];
        let projection;
        if (crs) {
            if (crs['type'] == 'name') projection = (0, $d447c151baf41c8c$export$3988ae62b71be9a3)(crs['properties']['name']);
            else if (crs['type'] === 'EPSG') projection = (0, $d447c151baf41c8c$export$3988ae62b71be9a3)('EPSG:' + crs['properties']['code']);
            else throw new Error('Unknown SRS type');
        } else projection = this.dataProjection;
        return /** @type {import("../proj/Projection.js").default} */ projection;
    }
    /**
   * Encode a feature as a GeoJSON Feature object.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeature} Object.
   * @api
   * @override
   */ writeFeatureObject(feature, options) {
        options = this.adaptOptions(options);
        /** @type {GeoJSONFeature} */ const object = {
            'type': 'Feature',
            geometry: null,
            properties: null
        };
        const id = feature.getId();
        if (id !== undefined) object.id = id;
        if (!feature.hasProperties()) return object;
        const properties = feature.getProperties();
        const geometry = feature.getGeometry();
        if (geometry) {
            object.geometry = $c6f7374fc2e125d0$var$writeGeometry(geometry, options);
            delete properties[feature.getGeometryName()];
        }
        if (!(0, $0364d4893e3f1129$export$dd1bc94b04021eeb)(properties)) object.properties = properties;
        return object;
    }
    /**
   * Encode an array of features as a GeoJSON object.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeatureCollection} GeoJSON Object.
   * @api
   * @override
   */ writeFeaturesObject(features, options) {
        options = this.adaptOptions(options);
        const objects = [];
        for(let i = 0, ii = features.length; i < ii; ++i)objects.push(this.writeFeatureObject(features[i], options));
        return {
            type: 'FeatureCollection',
            features: objects
        };
    }
    /**
   * Encode a geometry as a GeoJSON object.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
   * @api
   * @override
   */ writeGeometryObject(geometry, options) {
        return $c6f7374fc2e125d0$var$writeGeometry(geometry, this.adaptOptions(options));
    }
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryObject} Geometry.
 */ function $c6f7374fc2e125d0$var$readGeometryInternal(object, options) {
    if (!object) return null;
    /** @type {import("./Feature.js").GeometryObject} */ let geometry;
    switch(object['type']){
        case 'Point':
            geometry = $c6f7374fc2e125d0$var$readPointGeometry(/** @type {GeoJSONPoint} */ object);
            break;
        case 'LineString':
            geometry = $c6f7374fc2e125d0$var$readLineStringGeometry(/** @type {GeoJSONLineString} */ object);
            break;
        case 'Polygon':
            geometry = $c6f7374fc2e125d0$var$readPolygonGeometry(/** @type {GeoJSONPolygon} */ object);
            break;
        case 'MultiPoint':
            geometry = $c6f7374fc2e125d0$var$readMultiPointGeometry(/** @type {GeoJSONMultiPoint} */ object);
            break;
        case 'MultiLineString':
            geometry = $c6f7374fc2e125d0$var$readMultiLineStringGeometry(/** @type {GeoJSONMultiLineString} */ object);
            break;
        case 'MultiPolygon':
            geometry = $c6f7374fc2e125d0$var$readMultiPolygonGeometry(/** @type {GeoJSONMultiPolygon} */ object);
            break;
        case 'GeometryCollection':
            geometry = $c6f7374fc2e125d0$var$readGeometryCollectionGeometry(/** @type {GeoJSONGeometryCollection} */ object);
            break;
        default:
            throw new Error('Unsupported GeoJSON type: ' + object['type']);
    }
    return geometry;
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ function $c6f7374fc2e125d0$var$readGeometry(object, options) {
    const geometryObject = $c6f7374fc2e125d0$var$readGeometryInternal(object, options);
    return (0, $9ac77a234e054865$export$322c9678d8c47bf)(geometryObject, options);
}
/**
 * @param {GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryCollectionObject} Geometry collection.
 */ function $c6f7374fc2e125d0$var$readGeometryCollectionGeometry(object, options) {
    const geometries = object['geometries'].map(/**
     * @param {GeoJSONGeometry} geometry Geometry.
     * @return {import("./Feature.js").GeometryObject} geometry Geometry.
     */ function(geometry) {
        return $c6f7374fc2e125d0$var$readGeometryInternal(geometry, options);
    });
    return geometries;
}
/**
 * @param {GeoJSONPoint} object Input object.
 * @return {import("./Feature.js").GeometryObject} Point geometry.
 */ function $c6f7374fc2e125d0$var$readPointGeometry(object) {
    const flatCoordinates = object['coordinates'];
    return {
        type: 'Point',
        flatCoordinates: flatCoordinates,
        layout: (0, $2d119a5aa713a216$export$61bb6938093db2c8)(flatCoordinates.length)
    };
}
/**
 * @param {GeoJSONLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} LineString geometry.
 */ function $c6f7374fc2e125d0$var$readLineStringGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = coordinates.flat();
    return {
        type: 'LineString',
        flatCoordinates: flatCoordinates,
        ends: [
            flatCoordinates.length
        ],
        layout: (0, $2d119a5aa713a216$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiLineString geometry.
 */ function $c6f7374fc2e125d0$var$readMultiLineStringGeometry(object) {
    const coordinates = object['coordinates'];
    const stride = coordinates[0]?.[0]?.length || 2;
    const flatCoordinates = [];
    const ends = (0, $46dd16ae2ee5c902$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'MultiLineString',
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $2d119a5aa713a216$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONMultiPoint} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPoint geometry.
 */ function $c6f7374fc2e125d0$var$readMultiPointGeometry(object) {
    const coordinates = object['coordinates'];
    return {
        type: 'MultiPoint',
        flatCoordinates: coordinates.flat(),
        layout: (0, $2d119a5aa713a216$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPolygon geometry.
 */ function $c6f7374fc2e125d0$var$readMultiPolygonGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.[0].length || 2;
    const endss = (0, $46dd16ae2ee5c902$export$f9f2bb59da4accd3)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'MultiPolygon',
        flatCoordinates: flatCoordinates,
        ends: endss,
        layout: (0, $2d119a5aa713a216$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} Polygon.
 */ function $c6f7374fc2e125d0$var$readPolygonGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.length;
    const ends = (0, $46dd16ae2ee5c902$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'Polygon',
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $2d119a5aa713a216$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $c6f7374fc2e125d0$var$writeGeometry(geometry, options) {
    geometry = (0, $9ac77a234e054865$export$7beeea566b560d4)(geometry, true, options);
    const type = geometry.getType();
    /** @type {GeoJSONGeometry} */ let geoJSON;
    switch(type){
        case 'Point':
            geoJSON = $c6f7374fc2e125d0$var$writePointGeometry(/** @type {import("../geom/Point.js").default} */ geometry, options);
            break;
        case 'LineString':
            geoJSON = $c6f7374fc2e125d0$var$writeLineStringGeometry(/** @type {import("../geom/LineString.js").default} */ geometry, options);
            break;
        case 'Polygon':
            geoJSON = $c6f7374fc2e125d0$var$writePolygonGeometry(/** @type {import("../geom/Polygon.js").default} */ geometry, options);
            break;
        case 'MultiPoint':
            geoJSON = $c6f7374fc2e125d0$var$writeMultiPointGeometry(/** @type {import("../geom/MultiPoint.js").default} */ geometry, options);
            break;
        case 'MultiLineString':
            geoJSON = $c6f7374fc2e125d0$var$writeMultiLineStringGeometry(/** @type {import("../geom/MultiLineString.js").default} */ geometry, options);
            break;
        case 'MultiPolygon':
            geoJSON = $c6f7374fc2e125d0$var$writeMultiPolygonGeometry(/** @type {import("../geom/MultiPolygon.js").default} */ geometry, options);
            break;
        case 'GeometryCollection':
            geoJSON = $c6f7374fc2e125d0$var$writeGeometryCollectionGeometry(/** @type {import("../geom/GeometryCollection.js").default} */ geometry, options);
            break;
        case 'Circle':
            geoJSON = {
                type: 'GeometryCollection',
                geometries: []
            };
            break;
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return geoJSON;
}
/**
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometryCollection} GeoJSON geometry collection.
 */ function $c6f7374fc2e125d0$var$writeGeometryCollectionGeometry(geometry, options) {
    options = Object.assign({}, options);
    delete options.featureProjection;
    const geometries = geometry.getGeometriesArray().map(function(geometry) {
        return $c6f7374fc2e125d0$var$writeGeometry(geometry, options);
    });
    return {
        type: 'GeometryCollection',
        geometries: geometries
    };
}
/**
 * @param {import("../geom/LineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $c6f7374fc2e125d0$var$writeLineStringGeometry(geometry, options) {
    return {
        type: 'LineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $c6f7374fc2e125d0$var$writeMultiLineStringGeometry(geometry, options) {
    return {
        type: 'MultiLineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $c6f7374fc2e125d0$var$writeMultiPointGeometry(geometry, options) {
    return {
        type: 'MultiPoint',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $c6f7374fc2e125d0$var$writeMultiPolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: 'MultiPolygon',
        coordinates: geometry.getCoordinates(right)
    };
}
/**
 * @param {import("../geom/Point.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $c6f7374fc2e125d0$var$writePointGeometry(geometry, options) {
    return {
        type: 'Point',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/Polygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $c6f7374fc2e125d0$var$writePolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: 'Polygon',
        coordinates: geometry.getCoordinates(right)
    };
}
var $c6f7374fc2e125d0$export$2e2bcd8739ae039 = $c6f7374fc2e125d0$var$GeoJSON;


// index.ts
// index.ts
var $931c651fe1932ecc$export$e3a1ee0e9945697f = 63710088e-1;
var $931c651fe1932ecc$export$f929e47acbed771a = {
    centimeters: $931c651fe1932ecc$export$e3a1ee0e9945697f * 100,
    centimetres: $931c651fe1932ecc$export$e3a1ee0e9945697f * 100,
    degrees: 360 / (2 * Math.PI),
    feet: $931c651fe1932ecc$export$e3a1ee0e9945697f * 3.28084,
    inches: $931c651fe1932ecc$export$e3a1ee0e9945697f * 39.37,
    kilometers: $931c651fe1932ecc$export$e3a1ee0e9945697f / 1e3,
    kilometres: $931c651fe1932ecc$export$e3a1ee0e9945697f / 1e3,
    meters: $931c651fe1932ecc$export$e3a1ee0e9945697f,
    metres: $931c651fe1932ecc$export$e3a1ee0e9945697f,
    miles: $931c651fe1932ecc$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $931c651fe1932ecc$export$e3a1ee0e9945697f * 1e3,
    millimetres: $931c651fe1932ecc$export$e3a1ee0e9945697f * 1e3,
    nauticalmiles: $931c651fe1932ecc$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $931c651fe1932ecc$export$e3a1ee0e9945697f * 1.0936
};
var $931c651fe1932ecc$export$44665ce4f7f4c82b = {
    acres: 247105e-9,
    centimeters: 1e4,
    centimetres: 1e4,
    feet: 10.763910417,
    hectares: 1e-4,
    inches: 1550.003100006,
    kilometers: 1e-6,
    kilometres: 1e-6,
    meters: 1,
    metres: 1,
    miles: 386e-9,
    nauticalmiles: 29155334959812285e-23,
    millimeters: 1e6,
    millimetres: 1e6,
    yards: 1.195990046
};
function $931c651fe1932ecc$export$ced6ed16dfd6a264(geom, properties, options = {}) {
    const feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $931c651fe1932ecc$export$42a7622cbf932bb(type, coordinates, _options = {}) {
    switch(type){
        case "Point":
            return $931c651fe1932ecc$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $931c651fe1932ecc$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $931c651fe1932ecc$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $931c651fe1932ecc$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $931c651fe1932ecc$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $931c651fe1932ecc$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $931c651fe1932ecc$export$105684a3041cb6f3(coordinates, properties, options = {}) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$931c651fe1932ecc$export$7e4aa119212bc614(coordinates[0]) || !$931c651fe1932ecc$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    const geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $931c651fe1932ecc$export$ced6ed16dfd6a264(geom, properties, options);
}
function $931c651fe1932ecc$export$9f048bf86ee2e9d2(coordinates, properties, options = {}) {
    return $931c651fe1932ecc$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $931c651fe1932ecc$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $931c651fe1932ecc$export$b7b19aa0ee06c73(coordinates, properties, options = {}) {
    for (const ring of coordinates){
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        if (ring[ring.length - 1].length !== ring[0].length) throw new Error("First and last Position are not equivalent.");
        for(let j = 0; j < ring[ring.length - 1].length; j++){
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    const geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $931c651fe1932ecc$export$ced6ed16dfd6a264(geom, properties, options);
}
function $931c651fe1932ecc$export$8869eb68a940f9c2(coordinates, properties, options = {}) {
    return $931c651fe1932ecc$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $931c651fe1932ecc$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $931c651fe1932ecc$export$98ec381bb06902c3(coordinates, properties, options = {}) {
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    const geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $931c651fe1932ecc$export$ced6ed16dfd6a264(geom, properties, options);
}
function $931c651fe1932ecc$export$74f7306c35db993f(coordinates, properties, options = {}) {
    return $931c651fe1932ecc$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $931c651fe1932ecc$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $931c651fe1932ecc$export$4717c67ac3e5e04d(features, options = {}) {
    const fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $931c651fe1932ecc$export$bd735230309493da(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $931c651fe1932ecc$export$ced6ed16dfd6a264(geom, properties, options);
}
function $931c651fe1932ecc$export$335fc20ed6b6dbb6(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $931c651fe1932ecc$export$ced6ed16dfd6a264(geom, properties, options);
}
function $931c651fe1932ecc$export$79bd594da96638d3(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $931c651fe1932ecc$export$ced6ed16dfd6a264(geom, properties, options);
}
function $931c651fe1932ecc$export$9242f1e18250422a(geometries, properties, options = {}) {
    const geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $931c651fe1932ecc$export$ced6ed16dfd6a264(geom, properties, options);
}
function $931c651fe1932ecc$export$2077e0241d6afd3c(num, precision = 0) {
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $931c651fe1932ecc$export$f234631d6a2eedf8(radians, units = "kilometers") {
    const factor = $931c651fe1932ecc$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $931c651fe1932ecc$export$a2280f7debae8f10(distance, units = "kilometers") {
    const factor = $931c651fe1932ecc$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $931c651fe1932ecc$export$c7a138e00a89bd01(distance, units) {
    return $931c651fe1932ecc$export$c41dd2a8460d3196($931c651fe1932ecc$export$a2280f7debae8f10(distance, units));
}
function $931c651fe1932ecc$export$f2077d29c73b33ec(bearing) {
    let angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $931c651fe1932ecc$export$b4c4eb04cfe49fab(angle) {
    angle = angle % 360;
    if (angle > 180) return angle - 360;
    else if (angle < -180) return angle + 360;
    return angle;
}
function $931c651fe1932ecc$export$c41dd2a8460d3196(radians) {
    const normalisedRadians = radians % (2 * Math.PI);
    return normalisedRadians * 180 / Math.PI;
}
function $931c651fe1932ecc$export$c9fcf1a7df975d78(degrees) {
    const normalisedDegrees = degrees % 360;
    return normalisedDegrees * Math.PI / 180;
}
function $931c651fe1932ecc$export$ea1536a749e80563(length, originalUnit = "kilometers", finalUnit = "kilometers") {
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $931c651fe1932ecc$export$f234631d6a2eedf8($931c651fe1932ecc$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $931c651fe1932ecc$export$2e65e2c759f7e341(area, originalUnit = "meters", finalUnit = "kilometers") {
    if (!(area >= 0)) throw new Error("area must be a positive number");
    const startFactor = $931c651fe1932ecc$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    const finalFactor = $931c651fe1932ecc$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $931c651fe1932ecc$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $931c651fe1932ecc$export$a6cdc56e425d0d0a(input) {
    return input !== null && typeof input === "object" && !Array.isArray(input);
}
function $931c651fe1932ecc$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach((num)=>{
        if (!$931c651fe1932ecc$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $931c651fe1932ecc$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}


// index.js

function $8903379e6c9d9624$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($8903379e6c9d9624$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
function $8903379e6c9d9624$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $8903379e6c9d9624$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === void 0) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
function $8903379e6c9d9624$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
function $8903379e6c9d9624$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $8903379e6c9d9624$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
function $8903379e6c9d9624$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
function $8903379e6c9d9624$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $8903379e6c9d9624$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
function $8903379e6c9d9624$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $8903379e6c9d9624$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
function $8903379e6c9d9624$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : void 0;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : void 0;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        featureIndex++;
    }
}
function $8903379e6c9d9624$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $8903379e6c9d9624$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
function $8903379e6c9d9624$export$12cba8b31beb353b(geojson, callback) {
    $8903379e6c9d9624$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $931c651fe1932ecc$export$ced6ed16dfd6a264)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $931c651fe1932ecc$export$ced6ed16dfd6a264)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
function $8903379e6c9d9624$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $8903379e6c9d9624$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
function $8903379e6c9d9624$export$d3ecc1efb2be121e(geojson, callback) {
    $8903379e6c9d9624$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        if (!feature2.geometry) return;
        var type = feature2.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if ($8903379e6c9d9624$export$6e011439fde007ae(feature2, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            if (previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = (0, $931c651fe1932ecc$export$98ec381bb06902c3)([
                previousCoords,
                currentCoord
            ], feature2.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
function $8903379e6c9d9624$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $8903379e6c9d9624$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === void 0) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
function $8903379e6c9d9624$export$985a91771cfc783d(geojson, callback) {
    if (!geojson) throw new Error("geojson is required");
    $8903379e6c9d9624$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        if (feature2.geometry === null) return;
        var type = feature2.geometry.type;
        var coords = feature2.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature2, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $931c651fe1932ecc$export$98ec381bb06902c3)(coords[geometryIndex], feature2.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
function $8903379e6c9d9624$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $8903379e6c9d9624$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
function $8903379e6c9d9624$export$2b6ba91fd8680d67(geojson, options) {
    options = options || {};
    if (!(0, $931c651fe1932ecc$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $931c651fe1932ecc$export$98ec381bb06902c3)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $931c651fe1932ecc$export$98ec381bb06902c3)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $931c651fe1932ecc$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $931c651fe1932ecc$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
function $8903379e6c9d9624$export$ed60ae5df1bac687(geojson, options) {
    options = options || {};
    if (!(0, $931c651fe1932ecc$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $931c651fe1932ecc$export$105684a3041cb6f3)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $931c651fe1932ecc$export$105684a3041cb6f3)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $931c651fe1932ecc$export$105684a3041cb6f3)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $931c651fe1932ecc$export$105684a3041cb6f3)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $931c651fe1932ecc$export$105684a3041cb6f3)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $931c651fe1932ecc$export$105684a3041cb6f3)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}


// src/geom-in.ts
var $50d1568665d9bb17$exports = {};
(function(globalObject) {
    'use strict';
    /*
 *      bignumber.js v9.3.0
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = '[BigNumber Error] ', tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ', BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: '',
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ',',
            decimalSeparator: '.',
            fractionGroupSize: 0,
            fractionGroupSeparator: '\xA0',
            suffix: ''
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz', alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == 'number') && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, 'Base');
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == 'number') {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == '.') // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += '0');
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == 'object') {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = 'RANGE')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + ' cannot be zero: ' + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = 'CRYPTO')) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + 'crypto unavailable');
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + ' not true or false: ' + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = 'FORMAT')) {
                        v = obj[p];
                        if (typeof v == 'object') FORMAT = v;
                        else throw Error(bignumberError + p + ' not an object: ' + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = 'ALPHABET')) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + ' invalid: ' + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + 'Object expected: ' + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == '[object Array]') {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + 'Invalid BigNumber: ' + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + 'crypto unavailable');
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = '0123456789';
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf('.'), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace('.', '');
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // The index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, '0');
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += '0', len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, '0');
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += '.'; i--; str += '0');
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += '.';
                            for(; i--; str += '0');
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? '-' + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, '');
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, '0');
            return n.s < 0 ? '-' + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + 'Exponent not an integer: ' + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times('1e' + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber('0.5');
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += '0';
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = '5e' + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf('e') + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + '');
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == '9999' || !rep && n == '4999') {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == 'object') {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == 'object') {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != 'object') throw Error(bignumberError + 'Argument not an object: ' + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split('.'), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || '', intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = '-' + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'), '$&' + (format.fractionGroupSeparator || '')) : fractionPart) : intPart;
            }
            return (format.prefix || '') + str + (format.suffix || '');
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + 'Argument ' + (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = 'Infinity';
                    if (s < 0) str = '-' + str;
                } else str = 'NaN';
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, '0');
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, '0');
                } else {
                    intCheck(b, 2, ALPHABET.length, 'Base');
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = '-' + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + '';
        for(; i < j;){
            s = a[i++] + '';
            z = LOG_BASE - s.length;
            for(; z--; s = '0' + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || 'Argument') + (typeof n == 'number' ? n < min || n > max ? ' out of range: ' : ' not an integer: ' : ' not a primitive number: ') + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) + (e < 0 ? 'e' : 'e+') + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + '.'; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber['default'] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, $50d1568665d9bb17$exports) $50d1568665d9bb17$exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != 'undefined' && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})($50d1568665d9bb17$exports);


// src/index.ts
var $fa5ed71bfae61f09$var$SplayTreeNode = class {
    key;
    left = null;
    right = null;
    constructor(key){
        this.key = key;
    }
};
var $fa5ed71bfae61f09$var$SplayTreeSetNode = class extends $fa5ed71bfae61f09$var$SplayTreeNode {
    constructor(key){
        super(key);
    }
};
var $fa5ed71bfae61f09$var$SplayTreeMapNode = class _SplayTreeMapNode extends $fa5ed71bfae61f09$var$SplayTreeNode {
    value;
    constructor(key, value){
        super(key);
        this.value = value;
    }
    replaceValue(value) {
        const node = new _SplayTreeMapNode(this.key, value);
        node.left = this.left;
        node.right = this.right;
        return node;
    }
};
var $fa5ed71bfae61f09$var$SplayTree = class {
    size = 0;
    modificationCount = 0;
    splayCount = 0;
    splay(key) {
        const root = this.root;
        if (root == null) {
            this.compare(key, key);
            return -1;
        }
        let right = null;
        let newTreeRight = null;
        let left = null;
        let newTreeLeft = null;
        let current = root;
        const compare = this.compare;
        let comp;
        while(true){
            comp = compare(current.key, key);
            if (comp > 0) {
                let currentLeft = current.left;
                if (currentLeft == null) break;
                comp = compare(currentLeft.key, key);
                if (comp > 0) {
                    current.left = currentLeft.right;
                    currentLeft.right = current;
                    current = currentLeft;
                    currentLeft = current.left;
                    if (currentLeft == null) break;
                }
                if (right == null) newTreeRight = current;
                else right.left = current;
                right = current;
                current = currentLeft;
            } else if (comp < 0) {
                let currentRight = current.right;
                if (currentRight == null) break;
                comp = compare(currentRight.key, key);
                if (comp < 0) {
                    current.right = currentRight.left;
                    currentRight.left = current;
                    current = currentRight;
                    currentRight = current.right;
                    if (currentRight == null) break;
                }
                if (left == null) newTreeLeft = current;
                else left.right = current;
                left = current;
                current = currentRight;
            } else break;
        }
        if (left != null) {
            left.right = current.left;
            current.left = newTreeLeft;
        }
        if (right != null) {
            right.left = current.right;
            current.right = newTreeRight;
        }
        if (this.root !== current) {
            this.root = current;
            this.splayCount++;
        }
        return comp;
    }
    splayMin(node) {
        let current = node;
        let nextLeft = current.left;
        while(nextLeft != null){
            const left = nextLeft;
            current.left = left.right;
            left.right = current;
            current = left;
            nextLeft = current.left;
        }
        return current;
    }
    splayMax(node) {
        let current = node;
        let nextRight = current.right;
        while(nextRight != null){
            const right = nextRight;
            current.right = right.left;
            right.left = current;
            current = right;
            nextRight = current.right;
        }
        return current;
    }
    _delete(key) {
        if (this.root == null) return null;
        const comp = this.splay(key);
        if (comp != 0) return null;
        let root = this.root;
        const result = root;
        const left = root.left;
        this.size--;
        if (left == null) this.root = root.right;
        else {
            const right = root.right;
            root = this.splayMax(left);
            root.right = right;
            this.root = root;
        }
        this.modificationCount++;
        return result;
    }
    addNewRoot(node, comp) {
        this.size++;
        this.modificationCount++;
        const root = this.root;
        if (root == null) {
            this.root = node;
            return;
        }
        if (comp < 0) {
            node.left = root;
            node.right = root.right;
            root.right = null;
        } else {
            node.right = root;
            node.left = root.left;
            root.left = null;
        }
        this.root = node;
    }
    _first() {
        const root = this.root;
        if (root == null) return null;
        this.root = this.splayMin(root);
        return this.root;
    }
    _last() {
        const root = this.root;
        if (root == null) return null;
        this.root = this.splayMax(root);
        return this.root;
    }
    clear() {
        this.root = null;
        this.size = 0;
        this.modificationCount++;
    }
    has(key) {
        return this.validKey(key) && this.splay(key) == 0;
    }
    defaultCompare() {
        return (a, b)=>a < b ? -1 : a > b ? 1 : 0;
    }
    wrap() {
        return {
            getRoot: ()=>{
                return this.root;
            },
            setRoot: (root)=>{
                this.root = root;
            },
            getSize: ()=>{
                return this.size;
            },
            getModificationCount: ()=>{
                return this.modificationCount;
            },
            getSplayCount: ()=>{
                return this.splayCount;
            },
            setSplayCount: (count)=>{
                this.splayCount = count;
            },
            splay: (key)=>{
                return this.splay(key);
            },
            has: (key)=>{
                return this.has(key);
            }
        };
    }
};
var $fa5ed71bfae61f09$export$63207fedc0254bf6 = class extends $fa5ed71bfae61f09$var$SplayTree {
    root = null;
    compare;
    validKey;
    constructor(compare, isValidKey){
        super();
        this.compare = compare ?? this.defaultCompare();
        this.validKey = isValidKey ?? ((a)=>a != null && a != void 0);
    }
    delete(key) {
        if (!this.validKey(key)) return false;
        return this._delete(key) != null;
    }
    forEach(f) {
        const nodes = new $fa5ed71bfae61f09$var$SplayTreeMapEntryIterableIterator(this.wrap());
        let result;
        while(result = nodes.next(), !result.done)f(result.value[1], result.value[0], this);
    }
    get(key) {
        if (!this.validKey(key)) return void 0;
        if (this.root != null) {
            const comp = this.splay(key);
            if (comp == 0) return this.root.value;
        }
        return void 0;
    }
    hasValue(value) {
        const initialSplayCount = this.splayCount;
        const visit = (node)=>{
            while(node != null){
                if (node.value == value) return true;
                if (initialSplayCount != this.splayCount) throw "Concurrent modification during iteration.";
                if (node.right != null && visit(node.right)) return true;
                node = node.left;
            }
            return false;
        };
        return visit(this.root);
    }
    set(key, value) {
        const comp = this.splay(key);
        if (comp == 0) {
            this.root = this.root.replaceValue(value);
            this.splayCount += 1;
            return this;
        }
        this.addNewRoot(new $fa5ed71bfae61f09$var$SplayTreeMapNode(key, value), comp);
        return this;
    }
    setAll(other) {
        other.forEach((value, key)=>{
            this.set(key, value);
        });
    }
    setIfAbsent(key, ifAbsent) {
        let comp = this.splay(key);
        if (comp == 0) return this.root.value;
        const modificationCount = this.modificationCount;
        const splayCount = this.splayCount;
        const value = ifAbsent();
        if (modificationCount != this.modificationCount) throw "Concurrent modification during iteration.";
        if (splayCount != this.splayCount) comp = this.splay(key);
        this.addNewRoot(new $fa5ed71bfae61f09$var$SplayTreeMapNode(key, value), comp);
        return value;
    }
    isEmpty() {
        return this.root == null;
    }
    isNotEmpty() {
        return !this.isEmpty();
    }
    firstKey() {
        if (this.root == null) return null;
        return this._first().key;
    }
    lastKey() {
        if (this.root == null) return null;
        return this._last().key;
    }
    lastKeyBefore(key) {
        if (key == null) throw "Invalid arguments(s)";
        if (this.root == null) return null;
        const comp = this.splay(key);
        if (comp < 0) return this.root.key;
        let node = this.root.left;
        if (node == null) return null;
        let nodeRight = node.right;
        while(nodeRight != null){
            node = nodeRight;
            nodeRight = node.right;
        }
        return node.key;
    }
    firstKeyAfter(key) {
        if (key == null) throw "Invalid arguments(s)";
        if (this.root == null) return null;
        const comp = this.splay(key);
        if (comp > 0) return this.root.key;
        let node = this.root.right;
        if (node == null) return null;
        let nodeLeft = node.left;
        while(nodeLeft != null){
            node = nodeLeft;
            nodeLeft = node.left;
        }
        return node.key;
    }
    update(key, update, ifAbsent) {
        let comp = this.splay(key);
        if (comp == 0) {
            const modificationCount = this.modificationCount;
            const splayCount = this.splayCount;
            const newValue = update(this.root.value);
            if (modificationCount != this.modificationCount) throw "Concurrent modification during iteration.";
            if (splayCount != this.splayCount) this.splay(key);
            this.root = this.root.replaceValue(newValue);
            this.splayCount += 1;
            return newValue;
        }
        if (ifAbsent != null) {
            const modificationCount = this.modificationCount;
            const splayCount = this.splayCount;
            const newValue = ifAbsent();
            if (modificationCount != this.modificationCount) throw "Concurrent modification during iteration.";
            if (splayCount != this.splayCount) comp = this.splay(key);
            this.addNewRoot(new $fa5ed71bfae61f09$var$SplayTreeMapNode(key, newValue), comp);
            return newValue;
        }
        throw "Invalid argument (key): Key not in map.";
    }
    updateAll(update) {
        const root = this.root;
        if (root == null) return;
        const iterator = new $fa5ed71bfae61f09$var$SplayTreeMapEntryIterableIterator(this.wrap());
        let node;
        while(node = iterator.next(), !node.done){
            const newValue = update(...node.value);
            iterator.replaceValue(newValue);
        }
    }
    keys() {
        return new $fa5ed71bfae61f09$var$SplayTreeKeyIterableIterator(this.wrap());
    }
    values() {
        return new $fa5ed71bfae61f09$var$SplayTreeValueIterableIterator(this.wrap());
    }
    entries() {
        return this[Symbol.iterator]();
    }
    [Symbol.iterator]() {
        return new $fa5ed71bfae61f09$var$SplayTreeMapEntryIterableIterator(this.wrap());
    }
    [Symbol.toStringTag] = "[object Map]";
};
var $fa5ed71bfae61f09$export$67cc753ed1a46d8f = class _SplayTreeSet extends $fa5ed71bfae61f09$var$SplayTree {
    root = null;
    compare;
    validKey;
    constructor(compare, isValidKey){
        super();
        this.compare = compare ?? this.defaultCompare();
        this.validKey = isValidKey ?? ((v)=>v != null && v != void 0);
    }
    delete(element) {
        if (!this.validKey(element)) return false;
        return this._delete(element) != null;
    }
    deleteAll(elements) {
        for (const element of elements)this.delete(element);
    }
    forEach(f) {
        const nodes = this[Symbol.iterator]();
        let result;
        while(result = nodes.next(), !result.done)f(result.value, result.value, this);
    }
    add(element) {
        const compare = this.splay(element);
        if (compare != 0) this.addNewRoot(new $fa5ed71bfae61f09$var$SplayTreeSetNode(element), compare);
        return this;
    }
    addAndReturn(element) {
        const compare = this.splay(element);
        if (compare != 0) this.addNewRoot(new $fa5ed71bfae61f09$var$SplayTreeSetNode(element), compare);
        return this.root.key;
    }
    addAll(elements) {
        for (const element of elements)this.add(element);
    }
    isEmpty() {
        return this.root == null;
    }
    isNotEmpty() {
        return this.root != null;
    }
    single() {
        if (this.size == 0) throw "Bad state: No element";
        if (this.size > 1) throw "Bad state: Too many element";
        return this.root.key;
    }
    first() {
        if (this.size == 0) throw "Bad state: No element";
        return this._first().key;
    }
    last() {
        if (this.size == 0) throw "Bad state: No element";
        return this._last().key;
    }
    lastBefore(element) {
        if (element == null) throw "Invalid arguments(s)";
        if (this.root == null) return null;
        const comp = this.splay(element);
        if (comp < 0) return this.root.key;
        let node = this.root.left;
        if (node == null) return null;
        let nodeRight = node.right;
        while(nodeRight != null){
            node = nodeRight;
            nodeRight = node.right;
        }
        return node.key;
    }
    firstAfter(element) {
        if (element == null) throw "Invalid arguments(s)";
        if (this.root == null) return null;
        const comp = this.splay(element);
        if (comp > 0) return this.root.key;
        let node = this.root.right;
        if (node == null) return null;
        let nodeLeft = node.left;
        while(nodeLeft != null){
            node = nodeLeft;
            nodeLeft = node.left;
        }
        return node.key;
    }
    retainAll(elements) {
        const retainSet = new _SplayTreeSet(this.compare, this.validKey);
        const modificationCount = this.modificationCount;
        for (const object of elements){
            if (modificationCount != this.modificationCount) throw "Concurrent modification during iteration.";
            if (this.validKey(object) && this.splay(object) == 0) retainSet.add(this.root.key);
        }
        if (retainSet.size != this.size) {
            this.root = retainSet.root;
            this.size = retainSet.size;
            this.modificationCount++;
        }
    }
    lookup(object) {
        if (!this.validKey(object)) return null;
        const comp = this.splay(object);
        if (comp != 0) return null;
        return this.root.key;
    }
    intersection(other) {
        const result = new _SplayTreeSet(this.compare, this.validKey);
        for (const element of this)if (other.has(element)) result.add(element);
        return result;
    }
    difference(other) {
        const result = new _SplayTreeSet(this.compare, this.validKey);
        for (const element of this)if (!other.has(element)) result.add(element);
        return result;
    }
    union(other) {
        const u = this.clone();
        u.addAll(other);
        return u;
    }
    clone() {
        const set = new _SplayTreeSet(this.compare, this.validKey);
        set.size = this.size;
        set.root = this.copyNode(this.root);
        return set;
    }
    copyNode(node) {
        if (node == null) return null;
        function copyChildren(node2, dest) {
            let left;
            let right;
            do {
                left = node2.left;
                right = node2.right;
                if (left != null) {
                    const newLeft = new $fa5ed71bfae61f09$var$SplayTreeSetNode(left.key);
                    dest.left = newLeft;
                    copyChildren(left, newLeft);
                }
                if (right != null) {
                    const newRight = new $fa5ed71bfae61f09$var$SplayTreeSetNode(right.key);
                    dest.right = newRight;
                    node2 = right;
                    dest = newRight;
                }
            }while (right != null);
        }
        const result = new $fa5ed71bfae61f09$var$SplayTreeSetNode(node.key);
        copyChildren(node, result);
        return result;
    }
    toSet() {
        return this.clone();
    }
    entries() {
        return new $fa5ed71bfae61f09$var$SplayTreeSetEntryIterableIterator(this.wrap());
    }
    keys() {
        return this[Symbol.iterator]();
    }
    values() {
        return this[Symbol.iterator]();
    }
    [Symbol.iterator]() {
        return new $fa5ed71bfae61f09$var$SplayTreeKeyIterableIterator(this.wrap());
    }
    [Symbol.toStringTag] = "[object Set]";
};
var $fa5ed71bfae61f09$var$SplayTreeIterableIterator = class {
    tree;
    path = new Array();
    modificationCount = null;
    splayCount;
    constructor(tree){
        this.tree = tree;
        this.splayCount = tree.getSplayCount();
    }
    [Symbol.iterator]() {
        return this;
    }
    next() {
        if (this.moveNext()) return {
            done: false,
            value: this.current()
        };
        return {
            done: true,
            value: null
        };
    }
    current() {
        if (!this.path.length) return null;
        const node = this.path[this.path.length - 1];
        return this.getValue(node);
    }
    rebuildPath(key) {
        this.path.splice(0, this.path.length);
        this.tree.splay(key);
        this.path.push(this.tree.getRoot());
        this.splayCount = this.tree.getSplayCount();
    }
    findLeftMostDescendent(node) {
        while(node != null){
            this.path.push(node);
            node = node.left;
        }
    }
    moveNext() {
        if (this.modificationCount != this.tree.getModificationCount()) {
            if (this.modificationCount == null) {
                this.modificationCount = this.tree.getModificationCount();
                let node2 = this.tree.getRoot();
                while(node2 != null){
                    this.path.push(node2);
                    node2 = node2.left;
                }
                return this.path.length > 0;
            }
            throw "Concurrent modification during iteration.";
        }
        if (!this.path.length) return false;
        if (this.splayCount != this.tree.getSplayCount()) this.rebuildPath(this.path[this.path.length - 1].key);
        let node = this.path[this.path.length - 1];
        let next = node.right;
        if (next != null) {
            while(next != null){
                this.path.push(next);
                next = next.left;
            }
            return true;
        }
        this.path.pop();
        while(this.path.length && this.path[this.path.length - 1].right === node)node = this.path.pop();
        return this.path.length > 0;
    }
};
var $fa5ed71bfae61f09$var$SplayTreeKeyIterableIterator = class extends $fa5ed71bfae61f09$var$SplayTreeIterableIterator {
    getValue(node) {
        return node.key;
    }
};
var $fa5ed71bfae61f09$var$SplayTreeSetEntryIterableIterator = class extends $fa5ed71bfae61f09$var$SplayTreeIterableIterator {
    getValue(node) {
        return [
            node.key,
            node.key
        ];
    }
};
var $fa5ed71bfae61f09$var$SplayTreeValueIterableIterator = class extends $fa5ed71bfae61f09$var$SplayTreeIterableIterator {
    constructor(map){
        super(map);
    }
    getValue(node) {
        return node.value;
    }
};
var $fa5ed71bfae61f09$var$SplayTreeMapEntryIterableIterator = class extends $fa5ed71bfae61f09$var$SplayTreeIterableIterator {
    constructor(map){
        super(map);
    }
    getValue(node) {
        return [
            node.key,
            node.value
        ];
    }
    replaceValue(value) {
        if (this.modificationCount != this.tree.getModificationCount()) throw "Concurrent modification during iteration.";
        if (this.splayCount != this.tree.getSplayCount()) this.rebuildPath(this.path[this.path.length - 1].key);
        const last = this.path.pop();
        const newLast = last.replaceValue(value);
        if (!this.path.length) this.tree.setRoot(newLast);
        else {
            const parent = this.path[this.path.length - 1];
            if (last === parent.left) parent.left = newLast;
            else parent.right = newLast;
        }
        this.path.push(newLast);
        const count = this.tree.getSplayCount() + 1;
        this.tree.setSplayCount(count);
        this.splayCount = count;
    }
};


// src/constant.ts
var $a9fbb6eb78ee9455$var$constant_default = (x)=>{
    return ()=>{
        return x;
    };
};
// src/compare.ts
var $a9fbb6eb78ee9455$var$compare_default = (eps)=>{
    const almostEqual = eps ? (a, b)=>b.minus(a).abs().isLessThanOrEqualTo(eps) : $a9fbb6eb78ee9455$var$constant_default(false);
    return (a, b)=>{
        if (almostEqual(a, b)) return 0;
        return a.comparedTo(b);
    };
};
// src/orient.ts
function $a9fbb6eb78ee9455$var$orient_default(eps) {
    const almostCollinear = eps ? (area2, ax, ay, cx, cy)=>area2.exponentiatedBy(2).isLessThanOrEqualTo(cx.minus(ax).exponentiatedBy(2).plus(cy.minus(ay).exponentiatedBy(2)).times(eps)) : $a9fbb6eb78ee9455$var$constant_default(false);
    return (a, b, c)=>{
        const ax = a.x, ay = a.y, cx = c.x, cy = c.y;
        const area2 = ay.minus(cy).times(b.x.minus(cx)).minus(ax.minus(cx).times(b.y.minus(cy)));
        if (almostCollinear(area2, ax, ay, cx, cy)) return 0;
        return area2.comparedTo(0);
    };
}
// src/identity.ts
var $a9fbb6eb78ee9455$var$identity_default = (x)=>{
    return x;
};
// src/snap.ts
var $a9fbb6eb78ee9455$var$snap_default = (eps)=>{
    if (eps) {
        const xTree = new (0, $fa5ed71bfae61f09$export$67cc753ed1a46d8f)($a9fbb6eb78ee9455$var$compare_default(eps));
        const yTree = new (0, $fa5ed71bfae61f09$export$67cc753ed1a46d8f)($a9fbb6eb78ee9455$var$compare_default(eps));
        const snapCoord = (coord, tree)=>{
            return tree.addAndReturn(coord);
        };
        const snap = (v)=>{
            return {
                x: snapCoord(v.x, xTree),
                y: snapCoord(v.y, yTree)
            };
        };
        snap({
            x: new (0, (/*@__PURE__*/$parcel$interopDefault($50d1568665d9bb17$exports)))(0),
            y: new (0, (/*@__PURE__*/$parcel$interopDefault($50d1568665d9bb17$exports)))(0)
        });
        return snap;
    }
    return $a9fbb6eb78ee9455$var$identity_default;
};
// src/precision.ts
var $a9fbb6eb78ee9455$var$set = (eps)=>{
    return {
        set: (eps2)=>{
            $a9fbb6eb78ee9455$var$precision = $a9fbb6eb78ee9455$var$set(eps2);
        },
        reset: ()=>$a9fbb6eb78ee9455$var$set(eps),
        compare: $a9fbb6eb78ee9455$var$compare_default(eps),
        snap: $a9fbb6eb78ee9455$var$snap_default(eps),
        orient: $a9fbb6eb78ee9455$var$orient_default(eps)
    };
};
var $a9fbb6eb78ee9455$var$precision = $a9fbb6eb78ee9455$var$set();
// src/bbox.ts
var $a9fbb6eb78ee9455$var$isInBbox = (bbox, point)=>{
    return bbox.ll.x.isLessThanOrEqualTo(point.x) && point.x.isLessThanOrEqualTo(bbox.ur.x) && bbox.ll.y.isLessThanOrEqualTo(point.y) && point.y.isLessThanOrEqualTo(bbox.ur.y);
};
var $a9fbb6eb78ee9455$var$getBboxOverlap = (b1, b2)=>{
    if (b2.ur.x.isLessThan(b1.ll.x) || b1.ur.x.isLessThan(b2.ll.x) || b2.ur.y.isLessThan(b1.ll.y) || b1.ur.y.isLessThan(b2.ll.y)) return null;
    const lowerX = b1.ll.x.isLessThan(b2.ll.x) ? b2.ll.x : b1.ll.x;
    const upperX = b1.ur.x.isLessThan(b2.ur.x) ? b1.ur.x : b2.ur.x;
    const lowerY = b1.ll.y.isLessThan(b2.ll.y) ? b2.ll.y : b1.ll.y;
    const upperY = b1.ur.y.isLessThan(b2.ur.y) ? b1.ur.y : b2.ur.y;
    return {
        ll: {
            x: lowerX,
            y: lowerY
        },
        ur: {
            x: upperX,
            y: upperY
        }
    };
};
// src/vector.ts
var $a9fbb6eb78ee9455$var$crossProduct = (a, b)=>a.x.times(b.y).minus(a.y.times(b.x));
var $a9fbb6eb78ee9455$var$dotProduct = (a, b)=>a.x.times(b.x).plus(a.y.times(b.y));
var $a9fbb6eb78ee9455$var$length = (v)=>$a9fbb6eb78ee9455$var$dotProduct(v, v).sqrt();
var $a9fbb6eb78ee9455$var$sineOfAngle = (pShared, pBase, pAngle)=>{
    const vBase = {
        x: pBase.x.minus(pShared.x),
        y: pBase.y.minus(pShared.y)
    };
    const vAngle = {
        x: pAngle.x.minus(pShared.x),
        y: pAngle.y.minus(pShared.y)
    };
    return $a9fbb6eb78ee9455$var$crossProduct(vAngle, vBase).div($a9fbb6eb78ee9455$var$length(vAngle)).div($a9fbb6eb78ee9455$var$length(vBase));
};
var $a9fbb6eb78ee9455$var$cosineOfAngle = (pShared, pBase, pAngle)=>{
    const vBase = {
        x: pBase.x.minus(pShared.x),
        y: pBase.y.minus(pShared.y)
    };
    const vAngle = {
        x: pAngle.x.minus(pShared.x),
        y: pAngle.y.minus(pShared.y)
    };
    return $a9fbb6eb78ee9455$var$dotProduct(vAngle, vBase).div($a9fbb6eb78ee9455$var$length(vAngle)).div($a9fbb6eb78ee9455$var$length(vBase));
};
var $a9fbb6eb78ee9455$var$horizontalIntersection = (pt, v, y)=>{
    if (v.y.isZero()) return null;
    return {
        x: pt.x.plus(v.x.div(v.y).times(y.minus(pt.y))),
        y: y
    };
};
var $a9fbb6eb78ee9455$var$verticalIntersection = (pt, v, x)=>{
    if (v.x.isZero()) return null;
    return {
        x: x,
        y: pt.y.plus(v.y.div(v.x).times(x.minus(pt.x)))
    };
};
var $a9fbb6eb78ee9455$var$intersection = (pt1, v1, pt2, v2)=>{
    if (v1.x.isZero()) return $a9fbb6eb78ee9455$var$verticalIntersection(pt2, v2, pt1.x);
    if (v2.x.isZero()) return $a9fbb6eb78ee9455$var$verticalIntersection(pt1, v1, pt2.x);
    if (v1.y.isZero()) return $a9fbb6eb78ee9455$var$horizontalIntersection(pt2, v2, pt1.y);
    if (v2.y.isZero()) return $a9fbb6eb78ee9455$var$horizontalIntersection(pt1, v1, pt2.y);
    const kross = $a9fbb6eb78ee9455$var$crossProduct(v1, v2);
    if (kross.isZero()) return null;
    const ve = {
        x: pt2.x.minus(pt1.x),
        y: pt2.y.minus(pt1.y)
    };
    const d1 = $a9fbb6eb78ee9455$var$crossProduct(ve, v1).div(kross);
    const d2 = $a9fbb6eb78ee9455$var$crossProduct(ve, v2).div(kross);
    const x1 = pt1.x.plus(d2.times(v1.x)), x2 = pt2.x.plus(d1.times(v2.x));
    const y1 = pt1.y.plus(d2.times(v1.y)), y2 = pt2.y.plus(d1.times(v2.y));
    const x = x1.plus(x2).div(2);
    const y = y1.plus(y2).div(2);
    return {
        x: x,
        y: y
    };
};
// src/sweep-event.ts
var $a9fbb6eb78ee9455$var$SweepEvent = class _SweepEvent {
    point;
    isLeft;
    segment;
    otherSE;
    consumedBy;
    // for ordering sweep events in the sweep event queue
    static compare(a, b) {
        const ptCmp = _SweepEvent.comparePoints(a.point, b.point);
        if (ptCmp !== 0) return ptCmp;
        if (a.point !== b.point) a.link(b);
        if (a.isLeft !== b.isLeft) return a.isLeft ? 1 : -1;
        return $a9fbb6eb78ee9455$var$Segment.compare(a.segment, b.segment);
    }
    // for ordering points in sweep line order
    static comparePoints(aPt, bPt) {
        if (aPt.x.isLessThan(bPt.x)) return -1;
        if (aPt.x.isGreaterThan(bPt.x)) return 1;
        if (aPt.y.isLessThan(bPt.y)) return -1;
        if (aPt.y.isGreaterThan(bPt.y)) return 1;
        return 0;
    }
    // Warning: 'point' input will be modified and re-used (for performance)
    constructor(point, isLeft){
        if (point.events === void 0) point.events = [
            this
        ];
        else point.events.push(this);
        this.point = point;
        this.isLeft = isLeft;
    }
    link(other) {
        if (other.point === this.point) throw new Error("Tried to link already linked events");
        const otherEvents = other.point.events;
        for(let i = 0, iMax = otherEvents.length; i < iMax; i++){
            const evt = otherEvents[i];
            this.point.events.push(evt);
            evt.point = this.point;
        }
        this.checkForConsuming();
    }
    /* Do a pass over our linked events and check to see if any pair
   * of segments match, and should be consumed. */ checkForConsuming() {
        const numEvents = this.point.events.length;
        for(let i = 0; i < numEvents; i++){
            const evt1 = this.point.events[i];
            if (evt1.segment.consumedBy !== void 0) continue;
            for(let j = i + 1; j < numEvents; j++){
                const evt2 = this.point.events[j];
                if (evt2.consumedBy !== void 0) continue;
                if (evt1.otherSE.point.events !== evt2.otherSE.point.events) continue;
                evt1.segment.consume(evt2.segment);
            }
        }
    }
    getAvailableLinkedEvents() {
        const events = [];
        for(let i = 0, iMax = this.point.events.length; i < iMax; i++){
            const evt = this.point.events[i];
            if (evt !== this && !evt.segment.ringOut && evt.segment.isInResult()) events.push(evt);
        }
        return events;
    }
    /**
   * Returns a comparator function for sorting linked events that will
   * favor the event that will give us the smallest left-side angle.
   * All ring construction starts as low as possible heading to the right,
   * so by always turning left as sharp as possible we'll get polygons
   * without uncessary loops & holes.
   *
   * The comparator function has a compute cache such that it avoids
   * re-computing already-computed values.
   */ getLeftmostComparator(baseEvent) {
        const cache = /* @__PURE__ */ new Map();
        const fillCache = (linkedEvent)=>{
            const nextEvent = linkedEvent.otherSE;
            cache.set(linkedEvent, {
                sine: $a9fbb6eb78ee9455$var$sineOfAngle(this.point, baseEvent.point, nextEvent.point),
                cosine: $a9fbb6eb78ee9455$var$cosineOfAngle(this.point, baseEvent.point, nextEvent.point)
            });
        };
        return (a, b)=>{
            if (!cache.has(a)) fillCache(a);
            if (!cache.has(b)) fillCache(b);
            const { sine: asine, cosine: acosine } = cache.get(a);
            const { sine: bsine, cosine: bcosine } = cache.get(b);
            if (asine.isGreaterThanOrEqualTo(0) && bsine.isGreaterThanOrEqualTo(0)) {
                if (acosine.isLessThan(bcosine)) return 1;
                if (acosine.isGreaterThan(bcosine)) return -1;
                return 0;
            }
            if (asine.isLessThan(0) && bsine.isLessThan(0)) {
                if (acosine.isLessThan(bcosine)) return -1;
                if (acosine.isGreaterThan(bcosine)) return 1;
                return 0;
            }
            if (bsine.isLessThan(asine)) return -1;
            if (bsine.isGreaterThan(asine)) return 1;
            return 0;
        };
    }
};
// src/geom-out.ts
var $a9fbb6eb78ee9455$var$RingOut = class _RingOut {
    events;
    poly;
    _isExteriorRing;
    _enclosingRing;
    /* Given the segments from the sweep line pass, compute & return a series
   * of closed rings from all the segments marked to be part of the result */ static factory(allSegments) {
        const ringsOut = [];
        for(let i = 0, iMax = allSegments.length; i < iMax; i++){
            const segment = allSegments[i];
            if (!segment.isInResult() || segment.ringOut) continue;
            let prevEvent = null;
            let event = segment.leftSE;
            let nextEvent = segment.rightSE;
            const events = [
                event
            ];
            const startingPoint = event.point;
            const intersectionLEs = [];
            while(true){
                prevEvent = event;
                event = nextEvent;
                events.push(event);
                if (event.point === startingPoint) break;
                while(true){
                    const availableLEs = event.getAvailableLinkedEvents();
                    if (availableLEs.length === 0) {
                        const firstPt = events[0].point;
                        const lastPt = events[events.length - 1].point;
                        throw new Error(`Unable to complete output ring starting at [${firstPt.x}, ${firstPt.y}]. Last matching segment found ends at [${lastPt.x}, ${lastPt.y}].`);
                    }
                    if (availableLEs.length === 1) {
                        nextEvent = availableLEs[0].otherSE;
                        break;
                    }
                    let indexLE = null;
                    for(let j = 0, jMax = intersectionLEs.length; j < jMax; j++)if (intersectionLEs[j].point === event.point) {
                        indexLE = j;
                        break;
                    }
                    if (indexLE !== null) {
                        const intersectionLE = intersectionLEs.splice(indexLE)[0];
                        const ringEvents = events.splice(intersectionLE.index);
                        ringEvents.unshift(ringEvents[0].otherSE);
                        ringsOut.push(new _RingOut(ringEvents.reverse()));
                        continue;
                    }
                    intersectionLEs.push({
                        index: events.length,
                        point: event.point
                    });
                    const comparator = event.getLeftmostComparator(prevEvent);
                    nextEvent = availableLEs.sort(comparator)[0].otherSE;
                    break;
                }
            }
            ringsOut.push(new _RingOut(events));
        }
        return ringsOut;
    }
    constructor(events){
        this.events = events;
        for(let i = 0, iMax = events.length; i < iMax; i++)events[i].segment.ringOut = this;
        this.poly = null;
    }
    getGeom() {
        let prevPt = this.events[0].point;
        const points = [
            prevPt
        ];
        for(let i = 1, iMax = this.events.length - 1; i < iMax; i++){
            const pt2 = this.events[i].point;
            const nextPt2 = this.events[i + 1].point;
            if ($a9fbb6eb78ee9455$var$precision.orient(pt2, prevPt, nextPt2) === 0) continue;
            points.push(pt2);
            prevPt = pt2;
        }
        if (points.length === 1) return null;
        const pt = points[0];
        const nextPt = points[1];
        if ($a9fbb6eb78ee9455$var$precision.orient(pt, prevPt, nextPt) === 0) points.shift();
        points.push(points[0]);
        const step = this.isExteriorRing() ? 1 : -1;
        const iStart = this.isExteriorRing() ? 0 : points.length - 1;
        const iEnd = this.isExteriorRing() ? points.length : -1;
        const orderedPoints = [];
        for(let i = iStart; i != iEnd; i += step)orderedPoints.push([
            points[i].x.toNumber(),
            points[i].y.toNumber()
        ]);
        return orderedPoints;
    }
    isExteriorRing() {
        if (this._isExteriorRing === void 0) {
            const enclosing = this.enclosingRing();
            this._isExteriorRing = enclosing ? !enclosing.isExteriorRing() : true;
        }
        return this._isExteriorRing;
    }
    enclosingRing() {
        if (this._enclosingRing === void 0) this._enclosingRing = this._calcEnclosingRing();
        return this._enclosingRing;
    }
    /* Returns the ring that encloses this one, if any */ _calcEnclosingRing() {
        let leftMostEvt = this.events[0];
        for(let i = 1, iMax = this.events.length; i < iMax; i++){
            const evt = this.events[i];
            if ($a9fbb6eb78ee9455$var$SweepEvent.compare(leftMostEvt, evt) > 0) leftMostEvt = evt;
        }
        let prevSeg = leftMostEvt.segment.prevInResult();
        let prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
        while(true){
            if (!prevSeg) return null;
            if (!prevPrevSeg) return prevSeg.ringOut;
            if (prevPrevSeg.ringOut !== prevSeg.ringOut) {
                if (prevPrevSeg.ringOut?.enclosingRing() !== prevSeg.ringOut) return prevSeg.ringOut;
                else return prevSeg.ringOut?.enclosingRing();
            }
            prevSeg = prevPrevSeg.prevInResult();
            prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
        }
    }
};
var $a9fbb6eb78ee9455$var$PolyOut = class {
    exteriorRing;
    interiorRings;
    constructor(exteriorRing){
        this.exteriorRing = exteriorRing;
        exteriorRing.poly = this;
        this.interiorRings = [];
    }
    addInterior(ring) {
        this.interiorRings.push(ring);
        ring.poly = this;
    }
    getGeom() {
        const geom0 = this.exteriorRing.getGeom();
        if (geom0 === null) return null;
        const geom = [
            geom0
        ];
        for(let i = 0, iMax = this.interiorRings.length; i < iMax; i++){
            const ringGeom = this.interiorRings[i].getGeom();
            if (ringGeom === null) continue;
            geom.push(ringGeom);
        }
        return geom;
    }
};
var $a9fbb6eb78ee9455$var$MultiPolyOut = class {
    rings;
    polys;
    constructor(rings){
        this.rings = rings;
        this.polys = this._composePolys(rings);
    }
    getGeom() {
        const geom = [];
        for(let i = 0, iMax = this.polys.length; i < iMax; i++){
            const polyGeom = this.polys[i].getGeom();
            if (polyGeom === null) continue;
            geom.push(polyGeom);
        }
        return geom;
    }
    _composePolys(rings) {
        const polys = [];
        for(let i = 0, iMax = rings.length; i < iMax; i++){
            const ring = rings[i];
            if (ring.poly) continue;
            if (ring.isExteriorRing()) polys.push(new $a9fbb6eb78ee9455$var$PolyOut(ring));
            else {
                const enclosingRing = ring.enclosingRing();
                if (!enclosingRing?.poly) polys.push(new $a9fbb6eb78ee9455$var$PolyOut(enclosingRing));
                enclosingRing?.poly?.addInterior(ring);
            }
        }
        return polys;
    }
};
var $a9fbb6eb78ee9455$var$SweepLine = class {
    queue;
    tree;
    segments;
    constructor(queue, comparator = $a9fbb6eb78ee9455$var$Segment.compare){
        this.queue = queue;
        this.tree = new (0, $fa5ed71bfae61f09$export$67cc753ed1a46d8f)(comparator);
        this.segments = [];
    }
    process(event) {
        const segment = event.segment;
        const newEvents = [];
        if (event.consumedBy) {
            if (event.isLeft) this.queue.delete(event.otherSE);
            else this.tree.delete(segment);
            return newEvents;
        }
        if (event.isLeft) this.tree.add(segment);
        let prevSeg = segment;
        let nextSeg = segment;
        do prevSeg = this.tree.lastBefore(prevSeg);
        while (prevSeg != null && prevSeg.consumedBy != void 0);
        do nextSeg = this.tree.firstAfter(nextSeg);
        while (nextSeg != null && nextSeg.consumedBy != void 0);
        if (event.isLeft) {
            let prevMySplitter = null;
            if (prevSeg) {
                const prevInter = prevSeg.getIntersection(segment);
                if (prevInter !== null) {
                    if (!segment.isAnEndpoint(prevInter)) prevMySplitter = prevInter;
                    if (!prevSeg.isAnEndpoint(prevInter)) {
                        const newEventsFromSplit = this._splitSafely(prevSeg, prevInter);
                        for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                    }
                }
            }
            let nextMySplitter = null;
            if (nextSeg) {
                const nextInter = nextSeg.getIntersection(segment);
                if (nextInter !== null) {
                    if (!segment.isAnEndpoint(nextInter)) nextMySplitter = nextInter;
                    if (!nextSeg.isAnEndpoint(nextInter)) {
                        const newEventsFromSplit = this._splitSafely(nextSeg, nextInter);
                        for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                    }
                }
            }
            if (prevMySplitter !== null || nextMySplitter !== null) {
                let mySplitter = null;
                if (prevMySplitter === null) mySplitter = nextMySplitter;
                else if (nextMySplitter === null) mySplitter = prevMySplitter;
                else {
                    const cmpSplitters = $a9fbb6eb78ee9455$var$SweepEvent.comparePoints(prevMySplitter, nextMySplitter);
                    mySplitter = cmpSplitters <= 0 ? prevMySplitter : nextMySplitter;
                }
                this.queue.delete(segment.rightSE);
                newEvents.push(segment.rightSE);
                const newEventsFromSplit = segment.split(mySplitter);
                for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
            }
            if (newEvents.length > 0) {
                this.tree.delete(segment);
                newEvents.push(event);
            } else {
                this.segments.push(segment);
                segment.prev = prevSeg;
            }
        } else {
            if (prevSeg && nextSeg) {
                const inter = prevSeg.getIntersection(nextSeg);
                if (inter !== null) {
                    if (!prevSeg.isAnEndpoint(inter)) {
                        const newEventsFromSplit = this._splitSafely(prevSeg, inter);
                        for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                    }
                    if (!nextSeg.isAnEndpoint(inter)) {
                        const newEventsFromSplit = this._splitSafely(nextSeg, inter);
                        for(let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                    }
                }
            }
            this.tree.delete(segment);
        }
        return newEvents;
    }
    /* Safely split a segment that is currently in the datastructures
   * IE - a segment other than the one that is currently being processed. */ _splitSafely(seg, pt) {
        this.tree.delete(seg);
        const rightSE = seg.rightSE;
        this.queue.delete(rightSE);
        const newEvents = seg.split(pt);
        newEvents.push(rightSE);
        if (seg.consumedBy === void 0) this.tree.add(seg);
        return newEvents;
    }
};
// src/operation.ts
var $a9fbb6eb78ee9455$var$Operation = class {
    type;
    numMultiPolys;
    run(type, geom, moreGeoms) {
        $a9fbb6eb78ee9455$var$operation.type = type;
        const multipolys = [
            new $a9fbb6eb78ee9455$var$MultiPolyIn(geom, true)
        ];
        for(let i = 0, iMax = moreGeoms.length; i < iMax; i++)multipolys.push(new $a9fbb6eb78ee9455$var$MultiPolyIn(moreGeoms[i], false));
        $a9fbb6eb78ee9455$var$operation.numMultiPolys = multipolys.length;
        if ($a9fbb6eb78ee9455$var$operation.type === "difference") {
            const subject = multipolys[0];
            let i = 1;
            while(i < multipolys.length)if ($a9fbb6eb78ee9455$var$getBboxOverlap(multipolys[i].bbox, subject.bbox) !== null) i++;
            else multipolys.splice(i, 1);
        }
        if ($a9fbb6eb78ee9455$var$operation.type === "intersection") for(let i = 0, iMax = multipolys.length; i < iMax; i++){
            const mpA = multipolys[i];
            for(let j = i + 1, jMax = multipolys.length; j < jMax; j++){
                if ($a9fbb6eb78ee9455$var$getBboxOverlap(mpA.bbox, multipolys[j].bbox) === null) return [];
            }
        }
        const queue = new (0, $fa5ed71bfae61f09$export$67cc753ed1a46d8f)($a9fbb6eb78ee9455$var$SweepEvent.compare);
        for(let i = 0, iMax = multipolys.length; i < iMax; i++){
            const sweepEvents = multipolys[i].getSweepEvents();
            for(let j = 0, jMax = sweepEvents.length; j < jMax; j++)queue.add(sweepEvents[j]);
        }
        const sweepLine = new $a9fbb6eb78ee9455$var$SweepLine(queue);
        let evt = null;
        if (queue.size != 0) {
            evt = queue.first();
            queue.delete(evt);
        }
        while(evt){
            const newEvents = sweepLine.process(evt);
            for(let i = 0, iMax = newEvents.length; i < iMax; i++){
                const evt2 = newEvents[i];
                if (evt2.consumedBy === void 0) queue.add(evt2);
            }
            if (queue.size != 0) {
                evt = queue.first();
                queue.delete(evt);
            } else evt = null;
        }
        $a9fbb6eb78ee9455$var$precision.reset();
        const ringsOut = $a9fbb6eb78ee9455$var$RingOut.factory(sweepLine.segments);
        const result = new $a9fbb6eb78ee9455$var$MultiPolyOut(ringsOut);
        return result.getGeom();
    }
};
var $a9fbb6eb78ee9455$var$operation = new $a9fbb6eb78ee9455$var$Operation();
var $a9fbb6eb78ee9455$var$operation_default = $a9fbb6eb78ee9455$var$operation;
// src/segment.ts
var $a9fbb6eb78ee9455$var$segmentId = 0;
var $a9fbb6eb78ee9455$var$Segment = class _Segment {
    id;
    leftSE;
    rightSE;
    rings;
    windings;
    ringOut;
    consumedBy;
    prev;
    _prevInResult;
    _beforeState;
    _afterState;
    _isInResult;
    /* This compare() function is for ordering segments in the sweep
   * line tree, and does so according to the following criteria:
   *
   * Consider the vertical line that lies an infinestimal step to the
   * right of the right-more of the two left endpoints of the input
   * segments. Imagine slowly moving a point up from negative infinity
   * in the increasing y direction. Which of the two segments will that
   * point intersect first? That segment comes 'before' the other one.
   *
   * If neither segment would be intersected by such a line, (if one
   * or more of the segments are vertical) then the line to be considered
   * is directly on the right-more of the two left inputs.
   */ static compare(a, b) {
        const alx = a.leftSE.point.x;
        const blx = b.leftSE.point.x;
        const arx = a.rightSE.point.x;
        const brx = b.rightSE.point.x;
        if (brx.isLessThan(alx)) return 1;
        if (arx.isLessThan(blx)) return -1;
        const aly = a.leftSE.point.y;
        const bly = b.leftSE.point.y;
        const ary = a.rightSE.point.y;
        const bry = b.rightSE.point.y;
        if (alx.isLessThan(blx)) {
            if (bly.isLessThan(aly) && bly.isLessThan(ary)) return 1;
            if (bly.isGreaterThan(aly) && bly.isGreaterThan(ary)) return -1;
            const aCmpBLeft = a.comparePoint(b.leftSE.point);
            if (aCmpBLeft < 0) return 1;
            if (aCmpBLeft > 0) return -1;
            const bCmpARight = b.comparePoint(a.rightSE.point);
            if (bCmpARight !== 0) return bCmpARight;
            return -1;
        }
        if (alx.isGreaterThan(blx)) {
            if (aly.isLessThan(bly) && aly.isLessThan(bry)) return -1;
            if (aly.isGreaterThan(bly) && aly.isGreaterThan(bry)) return 1;
            const bCmpALeft = b.comparePoint(a.leftSE.point);
            if (bCmpALeft !== 0) return bCmpALeft;
            const aCmpBRight = a.comparePoint(b.rightSE.point);
            if (aCmpBRight < 0) return 1;
            if (aCmpBRight > 0) return -1;
            return 1;
        }
        if (aly.isLessThan(bly)) return -1;
        if (aly.isGreaterThan(bly)) return 1;
        if (arx.isLessThan(brx)) {
            const bCmpARight = b.comparePoint(a.rightSE.point);
            if (bCmpARight !== 0) return bCmpARight;
        }
        if (arx.isGreaterThan(brx)) {
            const aCmpBRight = a.comparePoint(b.rightSE.point);
            if (aCmpBRight < 0) return 1;
            if (aCmpBRight > 0) return -1;
        }
        if (!arx.eq(brx)) {
            const ay = ary.minus(aly);
            const ax = arx.minus(alx);
            const by = bry.minus(bly);
            const bx = brx.minus(blx);
            if (ay.isGreaterThan(ax) && by.isLessThan(bx)) return 1;
            if (ay.isLessThan(ax) && by.isGreaterThan(bx)) return -1;
        }
        if (arx.isGreaterThan(brx)) return 1;
        if (arx.isLessThan(brx)) return -1;
        if (ary.isLessThan(bry)) return -1;
        if (ary.isGreaterThan(bry)) return 1;
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
    }
    /* Warning: a reference to ringWindings input will be stored,
   *  and possibly will be later modified */ constructor(leftSE, rightSE, rings, windings){
        this.id = ++$a9fbb6eb78ee9455$var$segmentId;
        this.leftSE = leftSE;
        leftSE.segment = this;
        leftSE.otherSE = rightSE;
        this.rightSE = rightSE;
        rightSE.segment = this;
        rightSE.otherSE = leftSE;
        this.rings = rings;
        this.windings = windings;
    }
    static fromRing(pt1, pt2, ring) {
        let leftPt, rightPt, winding;
        const cmpPts = $a9fbb6eb78ee9455$var$SweepEvent.comparePoints(pt1, pt2);
        if (cmpPts < 0) {
            leftPt = pt1;
            rightPt = pt2;
            winding = 1;
        } else if (cmpPts > 0) {
            leftPt = pt2;
            rightPt = pt1;
            winding = -1;
        } else throw new Error(`Tried to create degenerate segment at [${pt1.x}, ${pt1.y}]`);
        const leftSE = new $a9fbb6eb78ee9455$var$SweepEvent(leftPt, true);
        const rightSE = new $a9fbb6eb78ee9455$var$SweepEvent(rightPt, false);
        return new _Segment(leftSE, rightSE, [
            ring
        ], [
            winding
        ]);
    }
    /* When a segment is split, the rightSE is replaced with a new sweep event */ replaceRightSE(newRightSE) {
        this.rightSE = newRightSE;
        this.rightSE.segment = this;
        this.rightSE.otherSE = this.leftSE;
        this.leftSE.otherSE = this.rightSE;
    }
    bbox() {
        const y1 = this.leftSE.point.y;
        const y2 = this.rightSE.point.y;
        return {
            ll: {
                x: this.leftSE.point.x,
                y: y1.isLessThan(y2) ? y1 : y2
            },
            ur: {
                x: this.rightSE.point.x,
                y: y1.isGreaterThan(y2) ? y1 : y2
            }
        };
    }
    /* A vector from the left point to the right */ vector() {
        return {
            x: this.rightSE.point.x.minus(this.leftSE.point.x),
            y: this.rightSE.point.y.minus(this.leftSE.point.y)
        };
    }
    isAnEndpoint(pt) {
        return pt.x.eq(this.leftSE.point.x) && pt.y.eq(this.leftSE.point.y) || pt.x.eq(this.rightSE.point.x) && pt.y.eq(this.rightSE.point.y);
    }
    /* Compare this segment with a point.
   *
   * A point P is considered to be colinear to a segment if there
   * exists a distance D such that if we travel along the segment
   * from one * endpoint towards the other a distance D, we find
   * ourselves at point P.
   *
   * Return value indicates:
   *
   *   1: point lies above the segment (to the left of vertical)
   *   0: point is colinear to segment
   *  -1: point lies below the segment (to the right of vertical)
   */ comparePoint(point) {
        return $a9fbb6eb78ee9455$var$precision.orient(this.leftSE.point, point, this.rightSE.point);
    }
    /**
   * Given another segment, returns the first non-trivial intersection
   * between the two segments (in terms of sweep line ordering), if it exists.
   *
   * A 'non-trivial' intersection is one that will cause one or both of the
   * segments to be split(). As such, 'trivial' vs. 'non-trivial' intersection:
   *
   *   * endpoint of segA with endpoint of segB --> trivial
   *   * endpoint of segA with point along segB --> non-trivial
   *   * endpoint of segB with point along segA --> non-trivial
   *   * point along segA with point along segB --> non-trivial
   *
   * If no non-trivial intersection exists, return null
   * Else, return null.
   */ getIntersection(other) {
        const tBbox = this.bbox();
        const oBbox = other.bbox();
        const bboxOverlap = $a9fbb6eb78ee9455$var$getBboxOverlap(tBbox, oBbox);
        if (bboxOverlap === null) return null;
        const tlp = this.leftSE.point;
        const trp = this.rightSE.point;
        const olp = other.leftSE.point;
        const orp = other.rightSE.point;
        const touchesOtherLSE = $a9fbb6eb78ee9455$var$isInBbox(tBbox, olp) && this.comparePoint(olp) === 0;
        const touchesThisLSE = $a9fbb6eb78ee9455$var$isInBbox(oBbox, tlp) && other.comparePoint(tlp) === 0;
        const touchesOtherRSE = $a9fbb6eb78ee9455$var$isInBbox(tBbox, orp) && this.comparePoint(orp) === 0;
        const touchesThisRSE = $a9fbb6eb78ee9455$var$isInBbox(oBbox, trp) && other.comparePoint(trp) === 0;
        if (touchesThisLSE && touchesOtherLSE) {
            if (touchesThisRSE && !touchesOtherRSE) return trp;
            if (!touchesThisRSE && touchesOtherRSE) return orp;
            return null;
        }
        if (touchesThisLSE) {
            if (touchesOtherRSE) {
                if (tlp.x.eq(orp.x) && tlp.y.eq(orp.y)) return null;
            }
            return tlp;
        }
        if (touchesOtherLSE) {
            if (touchesThisRSE) {
                if (trp.x.eq(olp.x) && trp.y.eq(olp.y)) return null;
            }
            return olp;
        }
        if (touchesThisRSE && touchesOtherRSE) return null;
        if (touchesThisRSE) return trp;
        if (touchesOtherRSE) return orp;
        const pt = $a9fbb6eb78ee9455$var$intersection(tlp, this.vector(), olp, other.vector());
        if (pt === null) return null;
        if (!$a9fbb6eb78ee9455$var$isInBbox(bboxOverlap, pt)) return null;
        return $a9fbb6eb78ee9455$var$precision.snap(pt);
    }
    /**
   * Split the given segment into multiple segments on the given points.
   *  * Each existing segment will retain its leftSE and a new rightSE will be
   *    generated for it.
   *  * A new segment will be generated which will adopt the original segment's
   *    rightSE, and a new leftSE will be generated for it.
   *  * If there are more than two points given to split on, new segments
   *    in the middle will be generated with new leftSE and rightSE's.
   *  * An array of the newly generated SweepEvents will be returned.
   *
   * Warning: input array of points is modified
   */ split(point) {
        const newEvents = [];
        const alreadyLinked = point.events !== void 0;
        const newLeftSE = new $a9fbb6eb78ee9455$var$SweepEvent(point, true);
        const newRightSE = new $a9fbb6eb78ee9455$var$SweepEvent(point, false);
        const oldRightSE = this.rightSE;
        this.replaceRightSE(newRightSE);
        newEvents.push(newRightSE);
        newEvents.push(newLeftSE);
        const newSeg = new _Segment(newLeftSE, oldRightSE, this.rings.slice(), this.windings.slice());
        if ($a9fbb6eb78ee9455$var$SweepEvent.comparePoints(newSeg.leftSE.point, newSeg.rightSE.point) > 0) newSeg.swapEvents();
        if ($a9fbb6eb78ee9455$var$SweepEvent.comparePoints(this.leftSE.point, this.rightSE.point) > 0) this.swapEvents();
        if (alreadyLinked) {
            newLeftSE.checkForConsuming();
            newRightSE.checkForConsuming();
        }
        return newEvents;
    }
    /* Swap which event is left and right */ swapEvents() {
        const tmpEvt = this.rightSE;
        this.rightSE = this.leftSE;
        this.leftSE = tmpEvt;
        this.leftSE.isLeft = true;
        this.rightSE.isLeft = false;
        for(let i = 0, iMax = this.windings.length; i < iMax; i++)this.windings[i] *= -1;
    }
    /* Consume another segment. We take their rings under our wing
   * and mark them as consumed. Use for perfectly overlapping segments */ consume(other) {
        let consumer = this;
        let consumee = other;
        while(consumer.consumedBy)consumer = consumer.consumedBy;
        while(consumee.consumedBy)consumee = consumee.consumedBy;
        const cmp = _Segment.compare(consumer, consumee);
        if (cmp === 0) return;
        if (cmp > 0) {
            const tmp = consumer;
            consumer = consumee;
            consumee = tmp;
        }
        if (consumer.prev === consumee) {
            const tmp = consumer;
            consumer = consumee;
            consumee = tmp;
        }
        for(let i = 0, iMax = consumee.rings.length; i < iMax; i++){
            const ring = consumee.rings[i];
            const winding = consumee.windings[i];
            const index = consumer.rings.indexOf(ring);
            if (index === -1) {
                consumer.rings.push(ring);
                consumer.windings.push(winding);
            } else consumer.windings[index] += winding;
        }
        consumee.rings = null;
        consumee.windings = null;
        consumee.consumedBy = consumer;
        consumee.leftSE.consumedBy = consumer.leftSE;
        consumee.rightSE.consumedBy = consumer.rightSE;
    }
    /* The first segment previous segment chain that is in the result */ prevInResult() {
        if (this._prevInResult !== void 0) return this._prevInResult;
        if (!this.prev) this._prevInResult = null;
        else if (this.prev.isInResult()) this._prevInResult = this.prev;
        else this._prevInResult = this.prev.prevInResult();
        return this._prevInResult;
    }
    beforeState() {
        if (this._beforeState !== void 0) return this._beforeState;
        if (!this.prev) this._beforeState = {
            rings: [],
            windings: [],
            multiPolys: []
        };
        else {
            const seg = this.prev.consumedBy || this.prev;
            this._beforeState = seg.afterState();
        }
        return this._beforeState;
    }
    afterState() {
        if (this._afterState !== void 0) return this._afterState;
        const beforeState = this.beforeState();
        this._afterState = {
            rings: beforeState.rings.slice(0),
            windings: beforeState.windings.slice(0),
            multiPolys: []
        };
        const ringsAfter = this._afterState.rings;
        const windingsAfter = this._afterState.windings;
        const mpsAfter = this._afterState.multiPolys;
        for(let i = 0, iMax = this.rings.length; i < iMax; i++){
            const ring = this.rings[i];
            const winding = this.windings[i];
            const index = ringsAfter.indexOf(ring);
            if (index === -1) {
                ringsAfter.push(ring);
                windingsAfter.push(winding);
            } else windingsAfter[index] += winding;
        }
        const polysAfter = [];
        const polysExclude = [];
        for(let i = 0, iMax = ringsAfter.length; i < iMax; i++){
            if (windingsAfter[i] === 0) continue;
            const ring = ringsAfter[i];
            const poly = ring.poly;
            if (polysExclude.indexOf(poly) !== -1) continue;
            if (ring.isExterior) polysAfter.push(poly);
            else {
                if (polysExclude.indexOf(poly) === -1) polysExclude.push(poly);
                const index = polysAfter.indexOf(ring.poly);
                if (index !== -1) polysAfter.splice(index, 1);
            }
        }
        for(let i = 0, iMax = polysAfter.length; i < iMax; i++){
            const mp = polysAfter[i].multiPoly;
            if (mpsAfter.indexOf(mp) === -1) mpsAfter.push(mp);
        }
        return this._afterState;
    }
    /* Is this segment part of the final result? */ isInResult() {
        if (this.consumedBy) return false;
        if (this._isInResult !== void 0) return this._isInResult;
        const mpsBefore = this.beforeState().multiPolys;
        const mpsAfter = this.afterState().multiPolys;
        switch($a9fbb6eb78ee9455$var$operation_default.type){
            case "union":
                {
                    const noBefores = mpsBefore.length === 0;
                    const noAfters = mpsAfter.length === 0;
                    this._isInResult = noBefores !== noAfters;
                    break;
                }
            case "intersection":
                {
                    let least;
                    let most;
                    if (mpsBefore.length < mpsAfter.length) {
                        least = mpsBefore.length;
                        most = mpsAfter.length;
                    } else {
                        least = mpsAfter.length;
                        most = mpsBefore.length;
                    }
                    this._isInResult = most === $a9fbb6eb78ee9455$var$operation_default.numMultiPolys && least < most;
                    break;
                }
            case "xor":
                {
                    const diff = Math.abs(mpsBefore.length - mpsAfter.length);
                    this._isInResult = diff % 2 === 1;
                    break;
                }
            case "difference":
                {
                    const isJustSubject = (mps)=>mps.length === 1 && mps[0].isSubject;
                    this._isInResult = isJustSubject(mpsBefore) !== isJustSubject(mpsAfter);
                    break;
                }
        }
        return this._isInResult;
    }
};
// src/geom-in.ts
var $a9fbb6eb78ee9455$var$RingIn = class {
    poly;
    isExterior;
    segments;
    bbox;
    constructor(geomRing, poly, isExterior){
        if (!Array.isArray(geomRing) || geomRing.length === 0) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        this.poly = poly;
        this.isExterior = isExterior;
        this.segments = [];
        if (typeof geomRing[0][0] !== "number" || typeof geomRing[0][1] !== "number") throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        const firstPoint = $a9fbb6eb78ee9455$var$precision.snap({
            x: new (0, (/*@__PURE__*/$parcel$interopDefault($50d1568665d9bb17$exports)))(geomRing[0][0]),
            y: new (0, (/*@__PURE__*/$parcel$interopDefault($50d1568665d9bb17$exports)))(geomRing[0][1])
        });
        this.bbox = {
            ll: {
                x: firstPoint.x,
                y: firstPoint.y
            },
            ur: {
                x: firstPoint.x,
                y: firstPoint.y
            }
        };
        let prevPoint = firstPoint;
        for(let i = 1, iMax = geomRing.length; i < iMax; i++){
            if (typeof geomRing[i][0] !== "number" || typeof geomRing[i][1] !== "number") throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            const point = $a9fbb6eb78ee9455$var$precision.snap({
                x: new (0, (/*@__PURE__*/$parcel$interopDefault($50d1568665d9bb17$exports)))(geomRing[i][0]),
                y: new (0, (/*@__PURE__*/$parcel$interopDefault($50d1568665d9bb17$exports)))(geomRing[i][1])
            });
            if (point.x.eq(prevPoint.x) && point.y.eq(prevPoint.y)) continue;
            this.segments.push($a9fbb6eb78ee9455$var$Segment.fromRing(prevPoint, point, this));
            if (point.x.isLessThan(this.bbox.ll.x)) this.bbox.ll.x = point.x;
            if (point.y.isLessThan(this.bbox.ll.y)) this.bbox.ll.y = point.y;
            if (point.x.isGreaterThan(this.bbox.ur.x)) this.bbox.ur.x = point.x;
            if (point.y.isGreaterThan(this.bbox.ur.y)) this.bbox.ur.y = point.y;
            prevPoint = point;
        }
        if (!firstPoint.x.eq(prevPoint.x) || !firstPoint.y.eq(prevPoint.y)) this.segments.push($a9fbb6eb78ee9455$var$Segment.fromRing(prevPoint, firstPoint, this));
    }
    getSweepEvents() {
        const sweepEvents = [];
        for(let i = 0, iMax = this.segments.length; i < iMax; i++){
            const segment = this.segments[i];
            sweepEvents.push(segment.leftSE);
            sweepEvents.push(segment.rightSE);
        }
        return sweepEvents;
    }
};
var $a9fbb6eb78ee9455$var$PolyIn = class {
    multiPoly;
    exteriorRing;
    interiorRings;
    bbox;
    constructor(geomPoly, multiPoly){
        if (!Array.isArray(geomPoly)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        this.exteriorRing = new $a9fbb6eb78ee9455$var$RingIn(geomPoly[0], this, true);
        this.bbox = {
            ll: {
                x: this.exteriorRing.bbox.ll.x,
                y: this.exteriorRing.bbox.ll.y
            },
            ur: {
                x: this.exteriorRing.bbox.ur.x,
                y: this.exteriorRing.bbox.ur.y
            }
        };
        this.interiorRings = [];
        for(let i = 1, iMax = geomPoly.length; i < iMax; i++){
            const ring = new $a9fbb6eb78ee9455$var$RingIn(geomPoly[i], this, false);
            if (ring.bbox.ll.x.isLessThan(this.bbox.ll.x)) this.bbox.ll.x = ring.bbox.ll.x;
            if (ring.bbox.ll.y.isLessThan(this.bbox.ll.y)) this.bbox.ll.y = ring.bbox.ll.y;
            if (ring.bbox.ur.x.isGreaterThan(this.bbox.ur.x)) this.bbox.ur.x = ring.bbox.ur.x;
            if (ring.bbox.ur.y.isGreaterThan(this.bbox.ur.y)) this.bbox.ur.y = ring.bbox.ur.y;
            this.interiorRings.push(ring);
        }
        this.multiPoly = multiPoly;
    }
    getSweepEvents() {
        const sweepEvents = this.exteriorRing.getSweepEvents();
        for(let i = 0, iMax = this.interiorRings.length; i < iMax; i++){
            const ringSweepEvents = this.interiorRings[i].getSweepEvents();
            for(let j = 0, jMax = ringSweepEvents.length; j < jMax; j++)sweepEvents.push(ringSweepEvents[j]);
        }
        return sweepEvents;
    }
};
var $a9fbb6eb78ee9455$var$MultiPolyIn = class {
    isSubject;
    polys;
    bbox;
    constructor(geom, isSubject){
        if (!Array.isArray(geom)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
        try {
            if (typeof geom[0][0][0] === "number") geom = [
                geom
            ];
        } catch (ex) {}
        this.polys = [];
        this.bbox = {
            ll: {
                x: new (0, (/*@__PURE__*/$parcel$interopDefault($50d1568665d9bb17$exports)))(Number.POSITIVE_INFINITY),
                y: new (0, (/*@__PURE__*/$parcel$interopDefault($50d1568665d9bb17$exports)))(Number.POSITIVE_INFINITY)
            },
            ur: {
                x: new (0, (/*@__PURE__*/$parcel$interopDefault($50d1568665d9bb17$exports)))(Number.NEGATIVE_INFINITY),
                y: new (0, (/*@__PURE__*/$parcel$interopDefault($50d1568665d9bb17$exports)))(Number.NEGATIVE_INFINITY)
            }
        };
        for(let i = 0, iMax = geom.length; i < iMax; i++){
            const poly = new $a9fbb6eb78ee9455$var$PolyIn(geom[i], this);
            if (poly.bbox.ll.x.isLessThan(this.bbox.ll.x)) this.bbox.ll.x = poly.bbox.ll.x;
            if (poly.bbox.ll.y.isLessThan(this.bbox.ll.y)) this.bbox.ll.y = poly.bbox.ll.y;
            if (poly.bbox.ur.x.isGreaterThan(this.bbox.ur.x)) this.bbox.ur.x = poly.bbox.ur.x;
            if (poly.bbox.ur.y.isGreaterThan(this.bbox.ur.y)) this.bbox.ur.y = poly.bbox.ur.y;
            this.polys.push(poly);
        }
        this.isSubject = isSubject;
    }
    getSweepEvents() {
        const sweepEvents = [];
        for(let i = 0, iMax = this.polys.length; i < iMax; i++){
            const polySweepEvents = this.polys[i].getSweepEvents();
            for(let j = 0, jMax = polySweepEvents.length; j < jMax; j++)sweepEvents.push(polySweepEvents[j]);
        }
        return sweepEvents;
    }
};
// src/index.ts
var $a9fbb6eb78ee9455$export$971dd5b0dfd021b6 = (geom, ...moreGeoms)=>$a9fbb6eb78ee9455$var$operation_default.run("union", geom, moreGeoms);
var $a9fbb6eb78ee9455$export$bc86dfbf7795668c = (geom, ...moreGeoms)=>$a9fbb6eb78ee9455$var$operation_default.run("intersection", geom, moreGeoms);
var $a9fbb6eb78ee9455$export$6444ef5cd411280c = (geom, ...moreGeoms)=>$a9fbb6eb78ee9455$var$operation_default.run("xor", geom, moreGeoms);
var $a9fbb6eb78ee9455$export$acaf96a27438246b = (geom, ...moreGeoms)=>$a9fbb6eb78ee9455$var$operation_default.run("difference", geom, moreGeoms);
var $a9fbb6eb78ee9455$export$c4b85a3b3361e135 = $a9fbb6eb78ee9455$var$precision.set;


function $534dcdb527369628$export$1f4807a235930d45(features, options = {}) {
    const geoms = [];
    (0, $8903379e6c9d9624$export$d2d248a56672ab3d)(features, (geom)=>{
        geoms.push(geom.coordinates);
    });
    if (geoms.length < 2) throw new Error("Must specify at least 2 geometries");
    const intersection2 = $a9fbb6eb78ee9455$export$bc86dfbf7795668c(geoms[0], ...geoms.slice(1));
    if (intersection2.length === 0) return null;
    if (intersection2.length === 1) return (0, $931c651fe1932ecc$export$b7b19aa0ee06c73)(intersection2[0], options.properties);
    return (0, $931c651fe1932ecc$export$79bd594da96638d3)(intersection2, options.properties);
}
var $534dcdb527369628$export$2e2bcd8739ae039 = $534dcdb527369628$export$1f4807a235930d45;



var $3eff9652561f20fb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3eff9652561f20fb$export$230ee785e544bec2 = /** @class */ function(_super) {
    $3eff9652561f20fb$var$__extends(NumberClassError, _super);
    function NumberClassError(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, NumberClassError.prototype);
        return _this;
    }
    return NumberClassError;
}(Error);
var $3eff9652561f20fb$export$11424d9aec8c4988 = /** @class */ function(_super) {
    $3eff9652561f20fb$var$__extends(DataArrayError, _super);
    function DataArrayError(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, DataArrayError.prototype);
        return _this;
    }
    return DataArrayError;
}(Error);


var $86c562e1c1f378d1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $86c562e1c1f378d1$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $86c562e1c1f378d1$export$96cf761aee92177b = function(numberClasses, arrayLength) {
    if (!Number.isInteger(numberClasses)) throw TypeError("Number classes must be an integer");
    if (numberClasses > arrayLength) throw new (0, $3eff9652561f20fb$export$230ee785e544bec2)("Number classes must be less than array length");
    if (numberClasses <= 0) throw new (0, $3eff9652561f20fb$export$230ee785e544bec2)("Number classes must be greater than zero");
};
var $86c562e1c1f378d1$export$5478ef8ca0079094 = function(arrayLength) {
    if (arrayLength <= 0) throw new (0, $3eff9652561f20fb$export$11424d9aec8c4988)("Array length must be bigger than one");
};
var $86c562e1c1f378d1$export$83e5d6efcd37c846 = function(data) {
    return $86c562e1c1f378d1$var$__awaiter(void 0, void 0, void 0, function() {
        var n, mean;
        return $86c562e1c1f378d1$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    n = data.length;
                    return [
                        4 /*yield*/ ,
                        $86c562e1c1f378d1$export$3d89038a2822b673(data)
                    ];
                case 1:
                    mean = _a.sent();
                    return [
                        2 /*return*/ ,
                        Math.sqrt(data.map(function(x) {
                            return Math.pow(x - mean, 2);
                        }).reduce(function(a, b) {
                            return a + b;
                        }) / n)
                    ];
            }
        });
    });
};
var $86c562e1c1f378d1$export$3d89038a2822b673 = function(data) {
    return $86c562e1c1f378d1$var$__awaiter(void 0, void 0, void 0, function() {
        var n;
        return $86c562e1c1f378d1$var$__generator(this, function(_a) {
            n = data.length;
            return [
                2 /*return*/ ,
                data.reduce(function(a, b) {
                    return a + b;
                }) / n
            ];
        });
    });
};


var $e44636839abf76b8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e44636839abf76b8$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e44636839abf76b8$export$78036ece324eb044 = function(data, numberClasses) {
    return $e44636839abf76b8$var$__awaiter(void 0, void 0, void 0, function() {
        var denominator, idx, bucketMin, bucketMax, interval, buckets, idx;
        return $e44636839abf76b8$var$__generator(this, function(_a) {
            (0, $86c562e1c1f378d1$export$5478ef8ca0079094)(data.length);
            (0, $86c562e1c1f378d1$export$96cf761aee92177b)(numberClasses, data.length);
            denominator = 0;
            for(idx = 1; idx <= numberClasses; idx++)denominator += idx;
            bucketMin = Math.min.apply(Math, data);
            bucketMax = Math.max.apply(Math, data);
            interval = (bucketMax - bucketMin) / denominator;
            buckets = [];
            for(idx = 0; idx <= numberClasses; idx++){
                if (idx === 0) buckets[idx] = bucketMin;
                else if (idx === numberClasses) buckets[idx] = bucketMax;
                else buckets[idx] = buckets[idx - 1] + idx * interval;
            }
            return [
                2 /*return*/ ,
                buckets
            ];
        });
    });
};



var $ca7c541f1fde0096$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ca7c541f1fde0096$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ca7c541f1fde0096$export$55f23f970b62ac7f = function(data, numberClasses, classMin, classMax) {
    return $ca7c541f1fde0096$var$__awaiter(void 0, void 0, void 0, function() {
        var bucketMin, bucketMax, buckets, interval, bucketModifier, idx;
        return $ca7c541f1fde0096$var$__generator(this, function(_a) {
            (0, $86c562e1c1f378d1$export$5478ef8ca0079094)(data.length);
            (0, $86c562e1c1f378d1$export$96cf761aee92177b)(numberClasses, data.length);
            bucketMin = classMin || Math.min.apply(Math, data);
            bucketMax = classMax || Math.max.apply(Math, data);
            buckets = [];
            interval = (bucketMax - bucketMin) / numberClasses;
            bucketModifier = bucketMin;
            for(idx = 0; idx <= numberClasses; idx++){
                buckets[idx] = bucketModifier;
                bucketModifier += interval;
            }
            buckets[numberClasses] = bucketMax;
            return [
                2 /*return*/ ,
                buckets
            ];
        });
    });
};




var $7689fe3f5d588ecb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7689fe3f5d588ecb$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7689fe3f5d588ecb$export$a539828d561bdbfd = function(data, numberClasses) {
    return $7689fe3f5d588ecb$var$__awaiter(void 0, void 0, void 0, function() {
        var bucketMin, bucketMax, logMax, logMin, interval, initialBuckets, idx, buckets;
        return $7689fe3f5d588ecb$var$__generator(this, function(_a) {
            (0, $86c562e1c1f378d1$export$5478ef8ca0079094)(data.length);
            (0, $86c562e1c1f378d1$export$96cf761aee92177b)(numberClasses, data.length);
            if (!data.every(function(el) {
                return el > 0;
            })) throw new (0, $3eff9652561f20fb$export$11424d9aec8c4988)("Array values must be positive for geometric progression");
            bucketMin = Math.min.apply(Math, data);
            bucketMax = Math.max.apply(Math, data);
            logMax = Math.log(bucketMax) / Math.LN10;
            logMin = Math.log(bucketMin) / Math.LN10;
            interval = (logMax - logMin) / numberClasses;
            initialBuckets = [];
            for(idx = 0; idx < numberClasses; idx++)idx === 0 ? initialBuckets[idx] = logMin : initialBuckets[idx] = initialBuckets[idx - 1] + interval;
            buckets = initialBuckets.map(function(el) {
                return Math.pow(10, el);
            });
            buckets.push(bucketMax);
            return [
                2 /*return*/ ,
                buckets
            ];
        });
    });
};



var $248993dc987b2c43$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $248993dc987b2c43$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $248993dc987b2c43$export$a3df6badc90a5f4e = function(data, numberClasses) {
    return $248993dc987b2c43$var$__awaiter(void 0, void 0, void 0, function() {
        var mat1, mat2, v, y, yl, t, tl, l, ll, s1, s2, w, m, ml, i3, val, i4, p, pl, k, buckets, countNum, id, idxVal;
        return $248993dc987b2c43$var$__generator(this, function(_a) {
            (0, $86c562e1c1f378d1$export$5478ef8ca0079094)(data.length);
            (0, $86c562e1c1f378d1$export$96cf761aee92177b)(numberClasses, data.length);
            data.sort(function(a, b) {
                return a - b;
            });
            mat1 = Array.from(Array(data.length + 1)).map(function(el) {
                return el = Array(numberClasses + 1);
            });
            mat2 = Array.from(Array(data.length + 1)).map(function(el) {
                return el = Array(numberClasses + 1);
            });
            v = 0.0;
            for(y = 1, yl = numberClasses + 1; y < yl; y++){
                mat1[0][y] = 1;
                mat2[0][y] = 0;
                for(t = 1, tl = data.length + 1; t < tl; t++)mat2[t][y] = Infinity;
                v = 0.0;
            }
            for(l = 2, ll = data.length + 1; l < ll; l++){
                s1 = 0.0;
                s2 = 0.0;
                w = 0.0;
                for(m = 1, ml = l + 1; m < ml; m++){
                    i3 = l - m + 1;
                    val = data[i3 - 1];
                    s2 += val * val;
                    s1 += val;
                    w += 1;
                    v = s2 - s1 * s1 / w;
                    i4 = i3 - 1;
                    if (i4 != 0) {
                        for(p = 2, pl = numberClasses + 1; p < pl; p++)if (mat2[l][p] >= v + mat2[i4][p - 1]) {
                            mat1[l][p] = i3;
                            mat2[l][p] = v + mat2[i4][p - 1];
                        }
                    }
                }
                mat1[l][1] = 1;
                mat2[l][1] = v;
            }
            k = data.length;
            buckets = Array.from(Array(numberClasses + 1)).fill(0);
            buckets[numberClasses] = data[data.length - 1];
            buckets[0] = data[0];
            countNum = numberClasses;
            while(countNum >= 2){
                id = mat1[k][countNum] - 2;
                buckets[countNum - 1] = data[id];
                idxVal = mat1[k][countNum];
                k = idxVal - 1;
                countNum -= 1;
            }
            if (buckets[0] == buckets[1]) buckets[0] = 0;
            return [
                2 /*return*/ ,
                buckets
            ];
        });
    });
};



var $d163031c0511da6d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d163031c0511da6d$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d163031c0511da6d$export$f1b6a0ead5b4878c = function(data, numberClasses) {
    return $d163031c0511da6d$var$__awaiter(void 0, void 0, void 0, function() {
        var quartiles, step, idx, quartileIdx;
        return $d163031c0511da6d$var$__generator(this, function(_a) {
            (0, $86c562e1c1f378d1$export$5478ef8ca0079094)(data.length);
            (0, $86c562e1c1f378d1$export$96cf761aee92177b)(numberClasses, data.length);
            data.sort(function(a, b) {
                return a - b;
            });
            quartiles = [];
            step = data.length / numberClasses;
            for(idx = 1; idx <= numberClasses; idx++){
                quartileIdx = Math.round(idx * step + 0.49);
                quartiles.push(data[quartileIdx - 1]);
            }
            quartiles.unshift(data[0]);
            return [
                2 /*return*/ ,
                quartiles
            ];
        });
    });
};



var $df0226e588d12deb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $df0226e588d12deb$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $df0226e588d12deb$export$8b53ee37c6e18463 = function(data, numberClasses, matchDataBounds) {
    if (matchDataBounds === void 0) matchDataBounds = true;
    return $df0226e588d12deb$var$__awaiter(void 0, void 0, void 0, function() {
        var bucketMin, bucketMax, standardDeviation, mean, buckets, meanBound, idx_1, idx_2, infBound, supBound, idx_3, idx;
        return $df0226e588d12deb$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    (0, $86c562e1c1f378d1$export$5478ef8ca0079094)(data.length);
                    (0, $86c562e1c1f378d1$export$96cf761aee92177b)(numberClasses, data.length);
                    bucketMin = Math.min.apply(Math, data);
                    bucketMax = Math.max.apply(Math, data);
                    return [
                        4 /*yield*/ ,
                        (0, $86c562e1c1f378d1$export$83e5d6efcd37c846)(data)
                    ];
                case 1:
                    standardDeviation = _a.sent();
                    return [
                        4 /*yield*/ ,
                        (0, $86c562e1c1f378d1$export$3d89038a2822b673)(data)
                    ];
                case 2:
                    mean = _a.sent();
                    buckets = [];
                    switch(numberClasses % 2){
                        case 0:
                            meanBound = numberClasses / 2;
                            buckets[meanBound] = mean;
                            for(idx_1 = meanBound - 1; idx_1 > 0; idx_1--)buckets[idx_1] = buckets[idx_1 + 1] - standardDeviation;
                            for(idx_2 = meanBound + 1; idx_2 < numberClasses; idx_2++)buckets[idx_2] = buckets[idx_2 - 1] + standardDeviation;
                            break;
                        case 1:
                            infBound = Math.floor(numberClasses / 2);
                            supBound = infBound + 1;
                            buckets[infBound] = mean - standardDeviation / 2;
                            buckets[supBound] = mean + standardDeviation / 2;
                            for(idx_3 = infBound - 1; idx_3 > 0; idx_3--)buckets[idx_3] = buckets[idx_3 + 1] - standardDeviation;
                            for(idx = supBound + 1; idx < numberClasses; idx++)buckets[idx] = buckets[idx - 1] + standardDeviation;
                            break;
                    }
                    buckets[0] = matchDataBounds ? buckets[1] - standardDeviation : bucketMin;
                    buckets[numberClasses] = matchDataBounds ? buckets[numberClasses - 1] + standardDeviation : bucketMax;
                    return [
                        2 /*return*/ ,
                        buckets
                    ];
            }
        });
    });
};


var $644061faee1c560e$export$a0aa81a0d2b3d5f1;
(function(BucketTypes) {
    BucketTypes["EQI"] = "EQI";
    BucketTypes["QNT"] = "QNT";
    BucketTypes["STD"] = "STD";
    BucketTypes["GPG"] = "GPG";
    BucketTypes["APG"] = "APG";
    BucketTypes["JNK"] = "JNK";
})($644061faee1c560e$export$a0aa81a0d2b3d5f1 || ($644061faee1c560e$export$a0aa81a0d2b3d5f1 = {}));



var $0a5780c656d4062e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0a5780c656d4062e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0a5780c656d4062e$export$f102267d51b1fa39 = function(name, data, numberClasses) {
    return $0a5780c656d4062e$var$__awaiter(void 0, void 0, void 0, function() {
        var buckets, _a;
        return $0a5780c656d4062e$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!Object.keys((0, $644061faee1c560e$export$a0aa81a0d2b3d5f1)).includes(name) && !Object.values((0, $644061faee1c560e$export$a0aa81a0d2b3d5f1)).includes(name)) throw Error("".concat(name, " not supported"));
                    _a = name;
                    switch(_a){
                        case (0, $644061faee1c560e$export$a0aa81a0d2b3d5f1).EQI:
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case (0, $644061faee1c560e$export$a0aa81a0d2b3d5f1).QNT:
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case (0, $644061faee1c560e$export$a0aa81a0d2b3d5f1).STD:
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case (0, $644061faee1c560e$export$a0aa81a0d2b3d5f1).GPG:
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case (0, $644061faee1c560e$export$a0aa81a0d2b3d5f1).APG:
                            return [
                                3 /*break*/ ,
                                9
                            ];
                        case (0, $644061faee1c560e$export$a0aa81a0d2b3d5f1).JNK:
                            return [
                                3 /*break*/ ,
                                11
                            ];
                    }
                    return [
                        3 /*break*/ ,
                        13
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        (0, $ca7c541f1fde0096$export$55f23f970b62ac7f)(data, numberClasses)
                    ];
                case 2:
                    buckets = _b.sent();
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 3:
                    return [
                        4 /*yield*/ ,
                        (0, $d163031c0511da6d$export$f1b6a0ead5b4878c)(data, numberClasses)
                    ];
                case 4:
                    buckets = _b.sent();
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 5:
                    return [
                        4 /*yield*/ ,
                        (0, $df0226e588d12deb$export$8b53ee37c6e18463)(data, numberClasses)
                    ];
                case 6:
                    buckets = _b.sent();
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 7:
                    return [
                        4 /*yield*/ ,
                        (0, $7689fe3f5d588ecb$export$a539828d561bdbfd)(data, numberClasses)
                    ];
                case 8:
                    buckets = _b.sent();
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 9:
                    return [
                        4 /*yield*/ ,
                        (0, $e44636839abf76b8$export$78036ece324eb044)(data, numberClasses)
                    ];
                case 10:
                    buckets = _b.sent();
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 11:
                    return [
                        4 /*yield*/ ,
                        (0, $248993dc987b2c43$export$a3df6badc90a5f4e)(data, numberClasses)
                    ];
                case 12:
                    buckets = _b.sent();
                    return [
                        3 /*break*/ ,
                        14
                    ];
                case 13:
                    throw Error("".concat(name, " not supported"));
                case 14:
                    return [
                        2 /*return*/ ,
                        buckets
                    ];
            }
        });
    });
};





// noinspection GraphQLUnresolvedReference

const $98dbd14a43c62e7a$export$4b25886ba9aee002 = (0, $e9ab2d34d0380c8f$exports.gql)`
    query ExecuteRetrieveALLMapList(
        $inState: String
        $inLocationType: String
        $inInvestmentTier: String
	    $inCommonwealthFunded: String
	    $inPipeline: String
	    $inProjectPhase: String
	    $inSuperSector: String
	    $inMasterType: String
	    $inProjectType: String
        $inLvl1Group: String
        $inPLEMGroup: String
        $inResourceGroup: String
    ) {
        executeRetrieveState(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            State
        }
        executeRetrieveLocationType(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            LocationType
        }
        executeRetrieveInvestmentTier(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            InvestmentTier
        }
        executeRetrieveCommonwealthFunded(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            CommonwealthFunding
        }
        executeRetrievePipeline(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            InfraFlag
        }
        executeRetrieveProjectPhase(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            PhaseType
        }
        executeRetrieveSuperSector(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            SuperSector
        }
        executeRetrieveMasterType(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            MasterType
        }
        executeRetrieveProjectType(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            RawProjectType
        }
        executeRetrieveLvl1Group(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            PLEMGroup
            Lvl1Group
        }
         executeRetrievePLEMGroup(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            PLEMGroup
        }
        executeRetrieveResourceGroup(
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            PLEMGroup
            ResourceGroup
        }
    }
`;
const $98dbd14a43c62e7a$export$df3c6e1deb699fea = (0, $e9ab2d34d0380c8f$exports.gql)`    
    query ExecuteRetrieveFiscalYears ()
    {
        executeRetrieveFiscalYears() {
            Type
            Min
            Max
        }
    }
`;
const $98dbd14a43c62e7a$export$be9511b49d625296 = (0, $e9ab2d34d0380c8f$exports.gql)`
    query ExecuteRetrieveStateSA4MapInvestment (
        $inState: String
        $inLocationType: String
        $inInvestmentTier: String
	    $inCommonwealthFunded: String
	    $inPipeline: String
	    $inProjectPhase: String
	    $inSuperSector: String
	    $inMasterType: String
	    $inProjectType: String
        $inLvl1Group: String
        $inPLEMGroup: String
        $inResourceGroup: String
        $inStartYear: Int
        $inEndYear: Int
    ) {
        executeRetrieveStateSA4MapInvestment (
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
            inStartYear: $inStartYear
            inEndYear: $inEndYear
        ) {
            State
            LocationType
            Value
        }
    }
`;
const $98dbd14a43c62e7a$export$e024bd25e1be54c1 = (0, $e9ab2d34d0380c8f$exports.gql)`
    query ExecuteRetrieveSA4OverTimeMapInvestment (
        $inState: String
        $inLocationType: String
        $inInvestmentTier: String
	    $inCommonwealthFunded: String
	    $inPipeline: String
	    $inProjectPhase: String
	    $inSuperSector: String
	    $inMasterType: String
	    $inProjectType: String
        $inLvl1Group: String
        $inPLEMGroup: String
        $inResourceGroup: String
    ) {
        executeRetrieveSA4OverTimeMapInvestment (
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
        ) {
            LocationType
            Total_Prev
            Total_Next
        }
    }
`;
const $98dbd14a43c62e7a$export$8ea94a021e0d96df = (0, $e9ab2d34d0380c8f$exports.gql)`
    query ExecuteRetrieveSA4PerCapitaMapInvestment (
        $inState: String
        $inLocationType: String
        $inInvestmentTier: String
	    $inCommonwealthFunded: String
	    $inPipeline: String
	    $inProjectPhase: String
	    $inSuperSector: String
	    $inMasterType: String
	    $inProjectType: String
        $inLvl1Group: String
        $inPLEMGroup: String
        $inResourceGroup: String
        $inCalendarYear: Int
    ) {
        executeRetrieveSA4PerCapitaMapInvestment (
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
            inCalendarYear: $inCalendarYear
        ) {
            LocationType
            Value
            Population
        }
    }
`;
const $98dbd14a43c62e7a$export$d4c4a9d73d541266 = (0, $e9ab2d34d0380c8f$exports.gql)`
    query ExecuteRetrieveStateSA4SuperSectorInvestment (
        $inState: String
        $inLocationType: String
        $inInvestmentTier: String
	    $inCommonwealthFunded: String
	    $inPipeline: String
	    $inProjectPhase: String
	    $inSuperSector: String
	    $inMasterType: String
	    $inProjectType: String
        $inLvl1Group: String
        $inPLEMGroup: String
        $inResourceGroup: String
        $inStartYear: Int
        $inEndYear: Int
    ) {
        executeRetrieveStateSA4SuperSectorInvestment (
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inLvl1Group: $inLvl1Group
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
            inStartYear: $inStartYear
            inEndYear: $inEndYear
        ) {
            State
            LocationType
            SuperSector
            Value
            Year
        }
    }
`;
const $98dbd14a43c62e7a$export$537b2500673c977 = (0, $e9ab2d34d0380c8f$exports.gql)`
    query ExecuteRetrieveLabourSupplyDemand (
        $inState: String
        $inLocationType: String
	    $inLvl1Group: String
	    $inResourceGroup: String
        $inStartYear: Int
        $inEndYear: Int
    ) {
        executeRetrieveLabourSupplyDemand (
            inState: $inState
            inLocationType: $inLocationType
	        inLvl1Group: $inLvl1Group
	        inResourceGroup: $inResourceGroup
            inStartYear: $inStartYear
            inEndYear: $inEndYear
        ) {
            ObservationDate
            Demand
            Supply
            Difference
        }
    }
`;
const $98dbd14a43c62e7a$export$41264fbadc2ced35 = (0, $e9ab2d34d0380c8f$exports.gql)`
    query ExecuteRetrieveLabourOccupation (
        $inState: String
        $inLocationType: String
        $inLvl1Group: String
	    $inResourceGroup: String
        $inYear: Int
        $inMonth: Int
    ) {
        executeRetrieveLabourOccupation (
            inState: $inState
            inLocationType: $inLocationType
            inLvl1Group: $inLvl1Group
	        inResourceGroup: $inResourceGroup
            inYear: $inYear
            inMonth: $inMonth
        ) {
            Lvl1Group
            ResourceGroup
            Demand
            Supply
            Difference
        }
    }
`;
const $98dbd14a43c62e7a$export$e3b2c9669a66eaf9 = (0, $e9ab2d34d0380c8f$exports.gql)`
    query ExecuteRetrieveNonLabourValueTonnage (
        $inState: String
        $inLocationType: String
        $inInvestmentTier: String
	    $inCommonwealthFunded: String
	    $inPipeline: String
	    $inProjectPhase: String
	    $inSuperSector: String
	    $inMasterType: String
	    $inProjectType: String
        $inPLEMGroup: String
        $inResourceGroup: String
        $inStartYear: Int
        $inEndYear: Int
    ) {
        executeRetrieveNonLabourValueTonnage (
            inState: $inState
            inLocationType: $inLocationType
            inInvestmentTier: $inInvestmentTier
	        inCommonwealthFunded: $inCommonwealthFunded
	        inPipeline: $inPipeline
	        inProjectPhase: $inProjectPhase
	        inSuperSector: $inSuperSector
	        inMasterType: $inMasterType
	        inProjectType: $inProjectType
            inPLEMGroup: $inPLEMGroup
            inResourceGroup: $inResourceGroup
            inStartYear: $inStartYear
            inEndYear: $inEndYear
        ) {
            PLEMGroup
            ResourceGroup
            Value
            Unit
            Year
        }
    }
`;



// @ts-nocheck

var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");


/*!
 * chartjs-plugin-datalabels v2.2.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2022 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */ 



var $93fbc20a8fadecf2$var$devicePixelRatio = function() {
    if (typeof window !== 'undefined') {
        if (window.devicePixelRatio) return window.devicePixelRatio;
        // devicePixelRatio is undefined on IE10
        // https://stackoverflow.com/a/20204180/8837887
        // https://github.com/chartjs/chartjs-plugin-datalabels/issues/85
        var screen = window.screen;
        if (screen) return (screen.deviceXDPI || 1) / (screen.logicalXDPI || 1);
    }
    return 1;
}();
var $93fbc20a8fadecf2$var$utils = {
    // @todo move this in Chart.helpers.toTextLines
    toTextLines: function(inputs) {
        var lines = [];
        var input;
        inputs = [].concat(inputs);
        while(inputs.length){
            input = inputs.pop();
            if (typeof input === 'string') lines.unshift.apply(lines, input.split('\n'));
            else if (Array.isArray(input)) inputs.push.apply(inputs, input);
            else if (!(0, $054bf7af52f034b6$export$342063e11d6c3cad)(inputs)) lines.unshift('' + input);
        }
        return lines;
    },
    // @todo move this in Chart.helpers.canvas.textSize
    // @todo cache calls of measureText if font doesn't change?!
    textSize: function(ctx, lines, font) {
        var items = [].concat(lines);
        var ilen = items.length;
        var prev = ctx.font;
        var width = 0;
        var i;
        ctx.font = font.string;
        for(i = 0; i < ilen; ++i)width = Math.max(ctx.measureText(items[i]).width, width);
        ctx.font = prev;
        return {
            height: ilen * font.lineHeight,
            width: width
        };
    },
    /**
   * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
   * @todo move this method in Chart.helpers.bound
   * https://doc.qt.io/qt-5/qtglobal.html#qBound
   */ bound: function(min, value, max) {
        return Math.max(min, Math.min(value, max));
    },
    /**
   * Returns an array of pair [value, state] where state is:
   * * -1: value is only in a0 (removed)
   * *  1: value is only in a1 (added)
   */ arrayDiff: function(a0, a1) {
        var prev = a0.slice();
        var updates = [];
        var i, j, ilen, v;
        for(i = 0, ilen = a1.length; i < ilen; ++i){
            v = a1[i];
            j = prev.indexOf(v);
            if (j === -1) updates.push([
                v,
                1
            ]);
            else prev.splice(j, 1);
        }
        for(i = 0, ilen = prev.length; i < ilen; ++i)updates.push([
            prev[i],
            -1
        ]);
        return updates;
    },
    /**
   * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
   */ rasterize: function(v) {
        return Math.round(v * $93fbc20a8fadecf2$var$devicePixelRatio) / $93fbc20a8fadecf2$var$devicePixelRatio;
    }
};
function $93fbc20a8fadecf2$var$orient(point, origin) {
    var x0 = origin.x;
    var y0 = origin.y;
    if (x0 === null) return {
        x: 0,
        y: -1
    };
    if (y0 === null) return {
        x: 1,
        y: 0
    };
    var dx = point.x - x0;
    var dy = point.y - y0;
    var ln = Math.sqrt(dx * dx + dy * dy);
    return {
        x: ln ? dx / ln : 0,
        y: ln ? dy / ln : -1
    };
}
function $93fbc20a8fadecf2$var$aligned(x, y, vx, vy, align) {
    switch(align){
        case 'center':
            vx = vy = 0;
            break;
        case 'bottom':
            vx = 0;
            vy = 1;
            break;
        case 'right':
            vx = 1;
            vy = 0;
            break;
        case 'left':
            vx = -1;
            vy = 0;
            break;
        case 'top':
            vx = 0;
            vy = -1;
            break;
        case 'start':
            vx = -vx;
            vy = -vy;
            break;
        case 'end':
            break;
        default:
            // clockwise rotation (in degree)
            align *= Math.PI / 180;
            vx = Math.cos(align);
            vy = Math.sin(align);
            break;
    }
    return {
        x: x,
        y: y,
        vx: vx,
        vy: vy
    };
}
// Line clipping (Cohen–Sutherland algorithm)
// https://en.wikipedia.org/wiki/Cohen–Sutherland_algorithm
var $93fbc20a8fadecf2$var$R_INSIDE = 0;
var $93fbc20a8fadecf2$var$R_LEFT = 1;
var $93fbc20a8fadecf2$var$R_RIGHT = 2;
var $93fbc20a8fadecf2$var$R_BOTTOM = 4;
var $93fbc20a8fadecf2$var$R_TOP = 8;
function $93fbc20a8fadecf2$var$region(x, y, rect) {
    var res = $93fbc20a8fadecf2$var$R_INSIDE;
    if (x < rect.left) res |= $93fbc20a8fadecf2$var$R_LEFT;
    else if (x > rect.right) res |= $93fbc20a8fadecf2$var$R_RIGHT;
    if (y < rect.top) res |= $93fbc20a8fadecf2$var$R_TOP;
    else if (y > rect.bottom) res |= $93fbc20a8fadecf2$var$R_BOTTOM;
    return res;
}
function $93fbc20a8fadecf2$var$clipped(segment, area) {
    var x0 = segment.x0;
    var y0 = segment.y0;
    var x1 = segment.x1;
    var y1 = segment.y1;
    var r0 = $93fbc20a8fadecf2$var$region(x0, y0, area);
    var r1 = $93fbc20a8fadecf2$var$region(x1, y1, area);
    var r, x, y;
    // eslint-disable-next-line no-constant-condition
    while(true){
        if (!(r0 | r1) || r0 & r1) break;
        // at least one point is outside
        r = r0 || r1;
        if (r & $93fbc20a8fadecf2$var$R_TOP) {
            x = x0 + (x1 - x0) * (area.top - y0) / (y1 - y0);
            y = area.top;
        } else if (r & $93fbc20a8fadecf2$var$R_BOTTOM) {
            x = x0 + (x1 - x0) * (area.bottom - y0) / (y1 - y0);
            y = area.bottom;
        } else if (r & $93fbc20a8fadecf2$var$R_RIGHT) {
            y = y0 + (y1 - y0) * (area.right - x0) / (x1 - x0);
            x = area.right;
        } else if (r & $93fbc20a8fadecf2$var$R_LEFT) {
            y = y0 + (y1 - y0) * (area.left - x0) / (x1 - x0);
            x = area.left;
        }
        if (r === r0) {
            x0 = x;
            y0 = y;
            r0 = $93fbc20a8fadecf2$var$region(x0, y0, area);
        } else {
            x1 = x;
            y1 = y;
            r1 = $93fbc20a8fadecf2$var$region(x1, y1, area);
        }
    }
    return {
        x0: x0,
        x1: x1,
        y0: y0,
        y1: y1
    };
}
function $93fbc20a8fadecf2$var$compute$1(range, config) {
    var anchor = config.anchor;
    var segment = range;
    var x, y;
    if (config.clamp) segment = $93fbc20a8fadecf2$var$clipped(segment, config.area);
    if (anchor === 'start') {
        x = segment.x0;
        y = segment.y0;
    } else if (anchor === 'end') {
        x = segment.x1;
        y = segment.y1;
    } else {
        x = (segment.x0 + segment.x1) / 2;
        y = (segment.y0 + segment.y1) / 2;
    }
    return $93fbc20a8fadecf2$var$aligned(x, y, range.vx, range.vy, config.align);
}
var $93fbc20a8fadecf2$var$positioners = {
    arc: function(el, config) {
        var angle = (el.startAngle + el.endAngle) / 2;
        var vx = Math.cos(angle);
        var vy = Math.sin(angle);
        var r0 = el.innerRadius;
        var r1 = el.outerRadius;
        return $93fbc20a8fadecf2$var$compute$1({
            x0: el.x + vx * r0,
            y0: el.y + vy * r0,
            x1: el.x + vx * r1,
            y1: el.y + vy * r1,
            vx: vx,
            vy: vy
        }, config);
    },
    point: function(el, config) {
        var v = $93fbc20a8fadecf2$var$orient(el, config.origin);
        var rx = v.x * el.options.radius;
        var ry = v.y * el.options.radius;
        return $93fbc20a8fadecf2$var$compute$1({
            x0: el.x - rx,
            y0: el.y - ry,
            x1: el.x + rx,
            y1: el.y + ry,
            vx: v.x,
            vy: v.y
        }, config);
    },
    bar: function(el, config) {
        var v = $93fbc20a8fadecf2$var$orient(el, config.origin);
        var x = el.x;
        var y = el.y;
        var sx = 0;
        var sy = 0;
        if (el.horizontal) {
            x = Math.min(el.x, el.base);
            sx = Math.abs(el.base - el.x);
        } else {
            y = Math.min(el.y, el.base);
            sy = Math.abs(el.base - el.y);
        }
        return $93fbc20a8fadecf2$var$compute$1({
            x0: x,
            y0: y + sy,
            x1: x + sx,
            y1: y,
            vx: v.x,
            vy: v.y
        }, config);
    },
    fallback: function(el, config) {
        var v = $93fbc20a8fadecf2$var$orient(el, config.origin);
        return $93fbc20a8fadecf2$var$compute$1({
            x0: el.x,
            y0: el.y,
            x1: el.x + (el.width || 0),
            y1: el.y + (el.height || 0),
            vx: v.x,
            vy: v.y
        }, config);
    }
};
var $93fbc20a8fadecf2$var$rasterize = $93fbc20a8fadecf2$var$utils.rasterize;
function $93fbc20a8fadecf2$var$boundingRects(model) {
    var borderWidth = model.borderWidth || 0;
    var padding = model.padding;
    var th = model.size.height;
    var tw = model.size.width;
    var tx = -tw / 2;
    var ty = -th / 2;
    return {
        frame: {
            x: tx - padding.left - borderWidth,
            y: ty - padding.top - borderWidth,
            w: tw + padding.width + borderWidth * 2,
            h: th + padding.height + borderWidth * 2
        },
        text: {
            x: tx,
            y: ty,
            w: tw,
            h: th
        }
    };
}
function $93fbc20a8fadecf2$var$getScaleOrigin(el, context) {
    var scale = context.chart.getDatasetMeta(context.datasetIndex).vScale;
    if (!scale) return null;
    if (scale.xCenter !== undefined && scale.yCenter !== undefined) return {
        x: scale.xCenter,
        y: scale.yCenter
    };
    var pixel = scale.getBasePixel();
    return el.horizontal ? {
        x: pixel,
        y: null
    } : {
        x: null,
        y: pixel
    };
}
function $93fbc20a8fadecf2$var$getPositioner(el) {
    if (el instanceof (0, $352a79de3bee5462$export$d48203c759d6a1fc)) return $93fbc20a8fadecf2$var$positioners.arc;
    if (el instanceof (0, $352a79de3bee5462$export$bd159b522b230b7a)) return $93fbc20a8fadecf2$var$positioners.point;
    if (el instanceof (0, $352a79de3bee5462$export$a16ed71bf4b07672)) return $93fbc20a8fadecf2$var$positioners.bar;
    return $93fbc20a8fadecf2$var$positioners.fallback;
}
function $93fbc20a8fadecf2$var$drawRoundedRect(ctx, x, y, w, h, radius) {
    var HALF_PI = Math.PI / 2;
    if (radius) {
        var r = Math.min(radius, h / 2, w / 2);
        var left = x + r;
        var top = y + r;
        var right = x + w - r;
        var bottom = y + h - r;
        ctx.moveTo(x, top);
        if (left < right && top < bottom) {
            ctx.arc(left, top, r, -Math.PI, -HALF_PI);
            ctx.arc(right, top, r, -HALF_PI, 0);
            ctx.arc(right, bottom, r, 0, HALF_PI);
            ctx.arc(left, bottom, r, HALF_PI, Math.PI);
        } else if (left < right) {
            ctx.moveTo(left, y);
            ctx.arc(right, top, r, -HALF_PI, HALF_PI);
            ctx.arc(left, top, r, HALF_PI, Math.PI + HALF_PI);
        } else if (top < bottom) {
            ctx.arc(left, top, r, -Math.PI, 0);
            ctx.arc(left, bottom, r, 0, Math.PI);
        } else ctx.arc(left, top, r, -Math.PI, Math.PI);
        ctx.closePath();
        ctx.moveTo(x, y);
    } else ctx.rect(x, y, w, h);
}
function $93fbc20a8fadecf2$var$drawFrame(ctx, rect, model) {
    var bgColor = model.backgroundColor;
    var borderColor = model.borderColor;
    var borderWidth = model.borderWidth;
    if (!bgColor && (!borderColor || !borderWidth)) return;
    ctx.beginPath();
    $93fbc20a8fadecf2$var$drawRoundedRect(ctx, $93fbc20a8fadecf2$var$rasterize(rect.x) + borderWidth / 2, $93fbc20a8fadecf2$var$rasterize(rect.y) + borderWidth / 2, $93fbc20a8fadecf2$var$rasterize(rect.w) - borderWidth, $93fbc20a8fadecf2$var$rasterize(rect.h) - borderWidth, model.borderRadius);
    ctx.closePath();
    if (bgColor) {
        ctx.fillStyle = bgColor;
        ctx.fill();
    }
    if (borderColor && borderWidth) {
        ctx.strokeStyle = borderColor;
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = 'miter';
        ctx.stroke();
    }
}
function $93fbc20a8fadecf2$var$textGeometry(rect, align, font) {
    var h = font.lineHeight;
    var w = rect.w;
    var x = rect.x;
    var y = rect.y + h / 2;
    if (align === 'center') x += w / 2;
    else if (align === 'end' || align === 'right') x += w;
    return {
        h: h,
        w: w,
        x: x,
        y: y
    };
}
function $93fbc20a8fadecf2$var$drawTextLine(ctx, text, cfg) {
    var shadow = ctx.shadowBlur;
    var stroked = cfg.stroked;
    var x = $93fbc20a8fadecf2$var$rasterize(cfg.x);
    var y = $93fbc20a8fadecf2$var$rasterize(cfg.y);
    var w = $93fbc20a8fadecf2$var$rasterize(cfg.w);
    if (stroked) ctx.strokeText(text, x, y, w);
    if (cfg.filled) {
        if (shadow && stroked) // Prevent drawing shadow on both the text stroke and fill, so
        // if the text is stroked, remove the shadow for the text fill.
        ctx.shadowBlur = 0;
        ctx.fillText(text, x, y, w);
        if (shadow && stroked) ctx.shadowBlur = shadow;
    }
}
function $93fbc20a8fadecf2$var$drawText(ctx, lines, rect, model) {
    var align = model.textAlign;
    var color = model.color;
    var filled = !!color;
    var font = model.font;
    var ilen = lines.length;
    var strokeColor = model.textStrokeColor;
    var strokeWidth = model.textStrokeWidth;
    var stroked = strokeColor && strokeWidth;
    var i;
    if (!ilen || !filled && !stroked) return;
    // Adjust coordinates based on text alignment and line height
    rect = $93fbc20a8fadecf2$var$textGeometry(rect, align, font);
    ctx.font = font.string;
    ctx.textAlign = align;
    ctx.textBaseline = 'middle';
    ctx.shadowBlur = model.textShadowBlur;
    ctx.shadowColor = model.textShadowColor;
    if (filled) ctx.fillStyle = color;
    if (stroked) {
        ctx.lineJoin = 'round';
        ctx.lineWidth = strokeWidth;
        ctx.strokeStyle = strokeColor;
    }
    for(i = 0, ilen = lines.length; i < ilen; ++i)$93fbc20a8fadecf2$var$drawTextLine(ctx, lines[i], {
        stroked: stroked,
        filled: filled,
        w: rect.w,
        x: rect.x,
        y: rect.y + rect.h * i
    });
}
var $93fbc20a8fadecf2$var$Label = function(config, ctx, el, index) {
    var me = this;
    me._config = config;
    me._index = index;
    me._model = null;
    me._rects = null;
    me._ctx = ctx;
    me._el = el;
};
(0, $054bf7af52f034b6$export$efca4cbe5dd06740)($93fbc20a8fadecf2$var$Label.prototype, {
    /**
   * @private
   */ _modelize: function(display, lines, config, context) {
        var me = this;
        var index = me._index;
        var font = (0, $054bf7af52f034b6$export$34aec0b863436764)((0, $054bf7af52f034b6$export$407448d2b89b1813)([
            config.font,
            {}
        ], context, index));
        var color = (0, $054bf7af52f034b6$export$407448d2b89b1813)([
            config.color,
            (0, $054bf7af52f034b6$export$4368d992c4eafac0).color
        ], context, index);
        return {
            align: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.align,
                'center'
            ], context, index),
            anchor: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.anchor,
                'center'
            ], context, index),
            area: context.chart.chartArea,
            backgroundColor: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.backgroundColor,
                null
            ], context, index),
            borderColor: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.borderColor,
                null
            ], context, index),
            borderRadius: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.borderRadius,
                0
            ], context, index),
            borderWidth: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.borderWidth,
                0
            ], context, index),
            clamp: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.clamp,
                false
            ], context, index),
            clip: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.clip,
                false
            ], context, index),
            color: color,
            display: display,
            font: font,
            lines: lines,
            offset: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.offset,
                4
            ], context, index),
            opacity: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.opacity,
                1
            ], context, index),
            origin: $93fbc20a8fadecf2$var$getScaleOrigin(me._el, context),
            padding: (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)((0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.padding,
                4
            ], context, index)),
            positioner: $93fbc20a8fadecf2$var$getPositioner(me._el),
            rotation: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.rotation,
                0
            ], context, index) * (Math.PI / 180),
            size: $93fbc20a8fadecf2$var$utils.textSize(me._ctx, lines, font),
            textAlign: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.textAlign,
                'start'
            ], context, index),
            textShadowBlur: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.textShadowBlur,
                0
            ], context, index),
            textShadowColor: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.textShadowColor,
                color
            ], context, index),
            textStrokeColor: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.textStrokeColor,
                color
            ], context, index),
            textStrokeWidth: (0, $054bf7af52f034b6$export$407448d2b89b1813)([
                config.textStrokeWidth,
                0
            ], context, index)
        };
    },
    update: function(context) {
        var me = this;
        var model = null;
        var rects = null;
        var index = me._index;
        var config = me._config;
        var value, label, lines;
        // We first resolve the display option (separately) to avoid computing
        // other options in case the label is hidden (i.e. display: false).
        var display = (0, $054bf7af52f034b6$export$407448d2b89b1813)([
            config.display,
            true
        ], context, index);
        if (display) {
            value = context.dataset.data[index];
            label = (0, $054bf7af52f034b6$export$90a7f3efeed30595)((0, $054bf7af52f034b6$export$3722cfe417b6ed86)(config.formatter, [
                value,
                context
            ]), value);
            lines = (0, $054bf7af52f034b6$export$342063e11d6c3cad)(label) ? [] : $93fbc20a8fadecf2$var$utils.toTextLines(label);
            if (lines.length) {
                model = me._modelize(display, lines, config, context);
                rects = $93fbc20a8fadecf2$var$boundingRects(model);
            }
        }
        me._model = model;
        me._rects = rects;
    },
    geometry: function() {
        return this._rects ? this._rects.frame : {};
    },
    rotation: function() {
        return this._model ? this._model.rotation : 0;
    },
    visible: function() {
        return this._model && this._model.opacity;
    },
    model: function() {
        return this._model;
    },
    draw: function(chart, center) {
        var me = this;
        var ctx = chart.ctx;
        var model = me._model;
        var rects = me._rects;
        var area;
        if (!this.visible()) return;
        ctx.save();
        if (model.clip) {
            area = model.area;
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        }
        ctx.globalAlpha = $93fbc20a8fadecf2$var$utils.bound(0, model.opacity, 1);
        ctx.translate($93fbc20a8fadecf2$var$rasterize(center.x), $93fbc20a8fadecf2$var$rasterize(center.y));
        ctx.rotate(model.rotation);
        $93fbc20a8fadecf2$var$drawFrame(ctx, rects.frame, model);
        $93fbc20a8fadecf2$var$drawText(ctx, model.lines, rects.text, model);
        ctx.restore();
    }
});
var $93fbc20a8fadecf2$var$MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991; // eslint-disable-line es/no-number-minsafeinteger
var $93fbc20a8fadecf2$var$MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991; // eslint-disable-line es/no-number-maxsafeinteger
function $93fbc20a8fadecf2$var$rotated(point, center, angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var cx = center.x;
    var cy = center.y;
    return {
        x: cx + cos * (point.x - cx) - sin * (point.y - cy),
        y: cy + sin * (point.x - cx) + cos * (point.y - cy)
    };
}
function $93fbc20a8fadecf2$var$projected(points, axis) {
    var min = $93fbc20a8fadecf2$var$MAX_INTEGER;
    var max = $93fbc20a8fadecf2$var$MIN_INTEGER;
    var origin = axis.origin;
    var i, pt, vx, vy, dp;
    for(i = 0; i < points.length; ++i){
        pt = points[i];
        vx = pt.x - origin.x;
        vy = pt.y - origin.y;
        dp = axis.vx * vx + axis.vy * vy;
        min = Math.min(min, dp);
        max = Math.max(max, dp);
    }
    return {
        min: min,
        max: max
    };
}
function $93fbc20a8fadecf2$var$toAxis(p0, p1) {
    var vx = p1.x - p0.x;
    var vy = p1.y - p0.y;
    var ln = Math.sqrt(vx * vx + vy * vy);
    return {
        vx: (p1.x - p0.x) / ln,
        vy: (p1.y - p0.y) / ln,
        origin: p0,
        ln: ln
    };
}
var $93fbc20a8fadecf2$var$HitBox = function() {
    this._rotation = 0;
    this._rect = {
        x: 0,
        y: 0,
        w: 0,
        h: 0
    };
};
(0, $054bf7af52f034b6$export$efca4cbe5dd06740)($93fbc20a8fadecf2$var$HitBox.prototype, {
    center: function() {
        var r = this._rect;
        return {
            x: r.x + r.w / 2,
            y: r.y + r.h / 2
        };
    },
    update: function(center, rect, rotation) {
        this._rotation = rotation;
        this._rect = {
            x: rect.x + center.x,
            y: rect.y + center.y,
            w: rect.w,
            h: rect.h
        };
    },
    contains: function(point) {
        var me = this;
        var margin = 1;
        var rect = me._rect;
        point = $93fbc20a8fadecf2$var$rotated(point, me.center(), -me._rotation);
        return !(point.x < rect.x - margin || point.y < rect.y - margin || point.x > rect.x + rect.w + margin * 2 || point.y > rect.y + rect.h + margin * 2);
    },
    // Separating Axis Theorem
    // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
    intersects: function(other) {
        var r0 = this._points();
        var r1 = other._points();
        var axes = [
            $93fbc20a8fadecf2$var$toAxis(r0[0], r0[1]),
            $93fbc20a8fadecf2$var$toAxis(r0[0], r0[3])
        ];
        var i, pr0, pr1;
        if (this._rotation !== other._rotation) // Only separate with r1 axis if the rotation is different,
        // else it's enough to separate r0 and r1 with r0 axis only!
        axes.push($93fbc20a8fadecf2$var$toAxis(r1[0], r1[1]), $93fbc20a8fadecf2$var$toAxis(r1[0], r1[3]));
        for(i = 0; i < axes.length; ++i){
            pr0 = $93fbc20a8fadecf2$var$projected(r0, axes[i]);
            pr1 = $93fbc20a8fadecf2$var$projected(r1, axes[i]);
            if (pr0.max < pr1.min || pr1.max < pr0.min) return false;
        }
        return true;
    },
    /**
   * @private
   */ _points: function() {
        var me = this;
        var rect = me._rect;
        var angle = me._rotation;
        var center = me.center();
        return [
            $93fbc20a8fadecf2$var$rotated({
                x: rect.x,
                y: rect.y
            }, center, angle),
            $93fbc20a8fadecf2$var$rotated({
                x: rect.x + rect.w,
                y: rect.y
            }, center, angle),
            $93fbc20a8fadecf2$var$rotated({
                x: rect.x + rect.w,
                y: rect.y + rect.h
            }, center, angle),
            $93fbc20a8fadecf2$var$rotated({
                x: rect.x,
                y: rect.y + rect.h
            }, center, angle)
        ];
    }
});
function $93fbc20a8fadecf2$var$coordinates(el, model, geometry) {
    var point = model.positioner(el, model);
    var vx = point.vx;
    var vy = point.vy;
    if (!vx && !vy) // if aligned center, we don't want to offset the center point
    return {
        x: point.x,
        y: point.y
    };
    var w = geometry.w;
    var h = geometry.h;
    // take in account the label rotation
    var rotation = model.rotation;
    var dx = Math.abs(w / 2 * Math.cos(rotation)) + Math.abs(h / 2 * Math.sin(rotation));
    var dy = Math.abs(w / 2 * Math.sin(rotation)) + Math.abs(h / 2 * Math.cos(rotation));
    // scale the unit vector (vx, vy) to get at least dx or dy equal to
    // w or h respectively (else we would calculate the distance to the
    // ellipse inscribed in the bounding rect)
    var vs = 1 / Math.max(Math.abs(vx), Math.abs(vy));
    dx *= vx * vs;
    dy *= vy * vs;
    // finally, include the explicit offset
    dx += model.offset * vx;
    dy += model.offset * vy;
    return {
        x: point.x + dx,
        y: point.y + dy
    };
}
function $93fbc20a8fadecf2$var$collide(labels, collider) {
    var i, j, s0, s1;
    // IMPORTANT Iterate in the reverse order since items at the end of the
    // list have an higher weight/priority and thus should be less impacted
    // by the overlapping strategy.
    for(i = labels.length - 1; i >= 0; --i){
        s0 = labels[i].$layout;
        for(j = i - 1; j >= 0 && s0._visible; --j){
            s1 = labels[j].$layout;
            if (s1._visible && s0._box.intersects(s1._box)) collider(s0, s1);
        }
    }
    return labels;
}
function $93fbc20a8fadecf2$var$compute(labels) {
    var i, ilen, label, state, geometry, center, proxy;
    // Initialize labels for overlap detection
    for(i = 0, ilen = labels.length; i < ilen; ++i){
        label = labels[i];
        state = label.$layout;
        if (state._visible) {
            // Chart.js 3 removed el._model in favor of getProps(), making harder to
            // abstract reading values in positioners. Also, using string arrays to
            // read values (i.e. var {a,b,c} = el.getProps(["a","b","c"])) would make
            // positioners inefficient in the normal case (i.e. not the final values)
            // and the code a bit ugly, so let's use a Proxy instead.
            proxy = new Proxy(label._el, {
                get: (el, p)=>el.getProps([
                        p
                    ], true)[p]
            });
            geometry = label.geometry();
            center = $93fbc20a8fadecf2$var$coordinates(proxy, label.model(), geometry);
            state._box.update(center, geometry, label.rotation());
        }
    }
    // Auto hide overlapping labels
    return $93fbc20a8fadecf2$var$collide(labels, function(s0, s1) {
        var h0 = s0._hidable;
        var h1 = s1._hidable;
        if (h0 && h1 || h1) s1._visible = false;
        else if (h0) s0._visible = false;
    });
}
var $93fbc20a8fadecf2$var$layout = {
    prepare: function(datasets) {
        var labels = [];
        var i, j, ilen, jlen, label;
        for(i = 0, ilen = datasets.length; i < ilen; ++i)for(j = 0, jlen = datasets[i].length; j < jlen; ++j){
            label = datasets[i][j];
            labels.push(label);
            label.$layout = {
                _box: new $93fbc20a8fadecf2$var$HitBox(),
                _hidable: false,
                _visible: true,
                _set: i,
                _idx: label._index
            };
        }
        // TODO New `z` option: labels with a higher z-index are drawn
        // of top of the ones with a lower index. Lowest z-index labels
        // are also discarded first when hiding overlapping labels.
        labels.sort(function(a, b) {
            var sa = a.$layout;
            var sb = b.$layout;
            return sa._idx === sb._idx ? sb._set - sa._set : sb._idx - sa._idx;
        });
        this.update(labels);
        return labels;
    },
    update: function(labels) {
        var dirty = false;
        var i, ilen, label, model, state;
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            label = labels[i];
            model = label.model();
            state = label.$layout;
            state._hidable = model && model.display === 'auto';
            state._visible = label.visible();
            dirty |= state._hidable;
        }
        if (dirty) $93fbc20a8fadecf2$var$compute(labels);
    },
    lookup: function(labels, point) {
        var i, state;
        // IMPORTANT Iterate in the reverse order since items at the end of
        // the list have an higher z-index, thus should be picked first.
        for(i = labels.length - 1; i >= 0; --i){
            state = labels[i].$layout;
            if (state && state._visible && state._box.contains(point)) return labels[i];
        }
        return null;
    },
    draw: function(chart, labels) {
        var i, ilen, label, state, geometry, center;
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            label = labels[i];
            state = label.$layout;
            if (state._visible) {
                geometry = label.geometry();
                center = $93fbc20a8fadecf2$var$coordinates(label._el, label.model(), geometry);
                state._box.update(center, geometry, label.rotation());
                label.draw(chart, center);
            }
        }
    }
};
var $93fbc20a8fadecf2$var$formatter = function(value) {
    if ((0, $054bf7af52f034b6$export$342063e11d6c3cad)(value)) return null;
    var label = value;
    var keys, klen, k;
    if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(value)) {
        if (!(0, $054bf7af52f034b6$export$342063e11d6c3cad)(value.label)) label = value.label;
        else if (!(0, $054bf7af52f034b6$export$342063e11d6c3cad)(value.r)) label = value.r;
        else {
            label = '';
            keys = Object.keys(value);
            for(k = 0, klen = keys.length; k < klen; ++k)label += (k !== 0 ? ', ' : '') + keys[k] + ': ' + value[keys[k]];
        }
    }
    return '' + label;
};
/**
 * IMPORTANT: make sure to also update tests and TypeScript definition
 * files (`/test/specs/defaults.spec.js` and `/types/options.d.ts`)
 */ var $93fbc20a8fadecf2$var$defaults = {
    align: 'center',
    anchor: 'center',
    backgroundColor: null,
    borderColor: null,
    borderRadius: 0,
    borderWidth: 0,
    clamp: false,
    clip: false,
    color: undefined,
    display: true,
    font: {
        family: undefined,
        lineHeight: 1.2,
        size: undefined,
        style: undefined,
        weight: null
    },
    formatter: $93fbc20a8fadecf2$var$formatter,
    labels: undefined,
    listeners: {},
    offset: 4,
    opacity: 1,
    padding: {
        top: 4,
        right: 4,
        bottom: 4,
        left: 4
    },
    rotation: 0,
    textAlign: 'start',
    textStrokeColor: undefined,
    textStrokeWidth: 0,
    textShadowBlur: 0,
    textShadowColor: undefined
};
/**
 * @see https://github.com/chartjs/Chart.js/issues/4176
 */ var $93fbc20a8fadecf2$var$EXPANDO_KEY = '$datalabels';
var $93fbc20a8fadecf2$var$DEFAULT_KEY = '$default';
function $93fbc20a8fadecf2$var$configure(dataset, options) {
    var override = dataset.datalabels;
    var listeners = {};
    var configs = [];
    var labels, keys;
    if (override === false) return null;
    if (override === true) override = {};
    options = (0, $054bf7af52f034b6$export$efca4cbe5dd06740)({}, [
        options,
        override
    ]);
    labels = options.labels || {};
    keys = Object.keys(labels);
    delete options.labels;
    if (keys.length) keys.forEach(function(key) {
        if (labels[key]) configs.push((0, $054bf7af52f034b6$export$efca4cbe5dd06740)({}, [
            options,
            labels[key],
            {
                _key: key
            }
        ]));
    });
    else // Default label if no "named" label defined.
    configs.push(options);
    // listeners: {<event-type>: {<label-key>: <fn>}}
    listeners = configs.reduce(function(target, config) {
        (0, $054bf7af52f034b6$export$d66501df72047452)(config.listeners || {}, function(fn, event) {
            target[event] = target[event] || {};
            target[event][config._key || $93fbc20a8fadecf2$var$DEFAULT_KEY] = fn;
        });
        delete config.listeners;
        return target;
    }, {});
    return {
        labels: configs,
        listeners: listeners
    };
}
function $93fbc20a8fadecf2$var$dispatchEvent(chart, listeners, label, event) {
    if (!listeners) return;
    var context = label.$context;
    var groups = label.$groups;
    var callback$1;
    if (!listeners[groups._set]) return;
    callback$1 = listeners[groups._set][groups._key];
    if (!callback$1) return;
    if ((0, $054bf7af52f034b6$export$3722cfe417b6ed86)(callback$1, [
        context,
        event
    ]) === true) {
        // Users are allowed to tweak the given context by injecting values that can be
        // used in scriptable options to display labels differently based on the current
        // event (e.g. highlight an hovered label). That's why we update the label with
        // the output context and schedule a new chart render by setting it dirty.
        chart[$93fbc20a8fadecf2$var$EXPANDO_KEY]._dirty = true;
        label.update(context);
    }
}
function $93fbc20a8fadecf2$var$dispatchMoveEvents(chart, listeners, previous, label, event) {
    var enter, leave;
    if (!previous && !label) return;
    if (!previous) enter = true;
    else if (!label) leave = true;
    else if (previous !== label) leave = enter = true;
    if (leave) $93fbc20a8fadecf2$var$dispatchEvent(chart, listeners.leave, previous, event);
    if (enter) $93fbc20a8fadecf2$var$dispatchEvent(chart, listeners.enter, label, event);
}
function $93fbc20a8fadecf2$var$handleMoveEvents(chart, event) {
    var expando = chart[$93fbc20a8fadecf2$var$EXPANDO_KEY];
    var listeners = expando._listeners;
    var previous, label;
    if (!listeners.enter && !listeners.leave) return;
    if (event.type === 'mousemove') label = $93fbc20a8fadecf2$var$layout.lookup(expando._labels, event);
    else if (event.type !== 'mouseout') return;
    previous = expando._hovered;
    expando._hovered = label;
    $93fbc20a8fadecf2$var$dispatchMoveEvents(chart, listeners, previous, label, event);
}
function $93fbc20a8fadecf2$var$handleClickEvents(chart, event) {
    var expando = chart[$93fbc20a8fadecf2$var$EXPANDO_KEY];
    var handlers = expando._listeners.click;
    var label = handlers && $93fbc20a8fadecf2$var$layout.lookup(expando._labels, event);
    if (label) $93fbc20a8fadecf2$var$dispatchEvent(chart, handlers, label, event);
}
var $93fbc20a8fadecf2$export$2e2bcd8739ae039 = {
    id: 'datalabels',
    defaults: $93fbc20a8fadecf2$var$defaults,
    beforeInit: function(chart) {
        chart[$93fbc20a8fadecf2$var$EXPANDO_KEY] = {
            _actives: []
        };
    },
    beforeUpdate: function(chart) {
        var expando = chart[$93fbc20a8fadecf2$var$EXPANDO_KEY];
        expando._listened = false;
        expando._listeners = {}; // {<event-type>: {<dataset-index>: {<label-key>: <fn>}}}
        expando._datasets = []; // per dataset labels: [Label[]]
        expando._labels = []; // layouted labels: Label[]
    },
    afterDatasetUpdate: function(chart, args, options) {
        var datasetIndex = args.index;
        var expando = chart[$93fbc20a8fadecf2$var$EXPANDO_KEY];
        var labels = expando._datasets[datasetIndex] = [];
        var visible = chart.isDatasetVisible(datasetIndex);
        var dataset = chart.data.datasets[datasetIndex];
        var config = $93fbc20a8fadecf2$var$configure(dataset, options);
        var elements = args.meta.data || [];
        var ctx = chart.ctx;
        var i, j, ilen, jlen, cfg, key, el, label;
        ctx.save();
        for(i = 0, ilen = elements.length; i < ilen; ++i){
            el = elements[i];
            el[$93fbc20a8fadecf2$var$EXPANDO_KEY] = [];
            if (visible && el && chart.getDataVisibility(i) && !el.skip) for(j = 0, jlen = config.labels.length; j < jlen; ++j){
                cfg = config.labels[j];
                key = cfg._key;
                label = new $93fbc20a8fadecf2$var$Label(cfg, ctx, el, i);
                label.$groups = {
                    _set: datasetIndex,
                    _key: key || $93fbc20a8fadecf2$var$DEFAULT_KEY
                };
                label.$context = {
                    active: false,
                    chart: chart,
                    dataIndex: i,
                    dataset: dataset,
                    datasetIndex: datasetIndex
                };
                label.update(label.$context);
                el[$93fbc20a8fadecf2$var$EXPANDO_KEY].push(label);
                labels.push(label);
            }
        }
        ctx.restore();
        // Store listeners at the chart level and per event type to optimize
        // cases where no listeners are registered for a specific event.
        (0, $054bf7af52f034b6$export$efca4cbe5dd06740)(expando._listeners, config.listeners, {
            merger: function(event, target, source) {
                target[event] = target[event] || {};
                target[event][args.index] = source[event];
                expando._listened = true;
            }
        });
    },
    afterUpdate: function(chart) {
        chart[$93fbc20a8fadecf2$var$EXPANDO_KEY]._labels = $93fbc20a8fadecf2$var$layout.prepare(chart[$93fbc20a8fadecf2$var$EXPANDO_KEY]._datasets);
    },
    // Draw labels on top of all dataset elements
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
    // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
    afterDatasetsDraw: function(chart) {
        $93fbc20a8fadecf2$var$layout.draw(chart, chart[$93fbc20a8fadecf2$var$EXPANDO_KEY]._labels);
    },
    beforeEvent: function(chart, args) {
        // If there is no listener registered for this chart, `listened` will be false,
        // meaning we can immediately ignore the incoming event and avoid useless extra
        // computation for users who don't implement label interactions.
        if (chart[$93fbc20a8fadecf2$var$EXPANDO_KEY]._listened) {
            var event = args.event;
            switch(event.type){
                case 'mousemove':
                case 'mouseout':
                    $93fbc20a8fadecf2$var$handleMoveEvents(chart, event);
                    break;
                case 'click':
                    $93fbc20a8fadecf2$var$handleClickEvents(chart, event);
                    break;
            }
        }
    },
    afterEvent: function(chart) {
        var expando = chart[$93fbc20a8fadecf2$var$EXPANDO_KEY];
        var previous = expando._actives;
        var actives = expando._actives = chart.getActiveElements();
        var updates = $93fbc20a8fadecf2$var$utils.arrayDiff(previous, actives);
        var i, ilen, j, jlen, update, label, labels;
        for(i = 0, ilen = updates.length; i < ilen; ++i){
            update = updates[i];
            if (update[1]) {
                labels = update[0].element[$93fbc20a8fadecf2$var$EXPANDO_KEY] || [];
                for(j = 0, jlen = labels.length; j < jlen; ++j){
                    label = labels[j];
                    label.$context.active = update[1] === 1;
                    label.update(label.$context);
                }
            }
        }
        if (expando._dirty || updates.length) {
            $93fbc20a8fadecf2$var$layout.update(expando._labels);
            chart.render();
        }
        delete expando._dirty;
    }
};







const $08e074ffb9935151$var$totaliser = {
    id: 'totaliser',
    beforeUpdate: (chart)=>{
        let totals = {};
        let utmost = 0;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            if (chart.isDatasetVisible(datasetIndex)) {
                utmost = datasetIndex;
                dataset.data.forEach((value, index)=>{
                    totals[index] = (totals[index] || 0) + value;
                });
            }
        });
        chart.$totalizer = {
            totals: totals,
            utmost: utmost
        };
    }
};
var $08e074ffb9935151$export$2e2bcd8739ae039 = $08e074ffb9935151$var$totaliser;



function $8f345cc468d6558e$export$2e2bcd8739ae039({ queryVariables: queryVariables, setInvestmentTab: setInvestmentTab, updateInvestmentCharts: updateInvestmentCharts, updateAlert: updateAlert }) {
    // Authentication
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const { data: userInfo } = (0, $8aac0537827a6bae$export$801fe16824f675f7)();
    // Chart component references
    const investmentChartLoader = (0, $i5lfL.useRef)();
    // Chart colours
    const state_colours = [
        {
            "state": "ACT",
            "colour": "#7e2d40"
        },
        {
            "state": "NSW",
            "colour": "#253746"
        },
        {
            "state": "NT",
            "colour": "#73b469"
        },
        {
            "state": "QLD",
            "colour": "#e7b78a"
        },
        {
            "state": "SA",
            "colour": "#ece81a"
        },
        {
            "state": "TAS",
            "colour": "#ce6c45"
        },
        {
            "state": "VIC",
            "colour": "#8c4799"
        },
        {
            "state": "WA",
            "colour": "#abc7ca"
        }
    ];
    const supersector_colours = [
        {
            "supersector": "Buildings",
            "colour": "#e15759"
        },
        {
            "supersector": "Transport",
            "colour": "#f28e2b"
        },
        {
            "supersector": "Utilities",
            "colour": "#4e79a7"
        },
        {
            "supersector": "Resources",
            "colour": "#C98BB9"
        }
    ];
    // Chart data references
    const stateInvestmentValuesRef = (0, $i5lfL.useRef)([]);
    const sa4InvestmentValuesRef = (0, $i5lfL.useRef)([]);
    const superSectorInvestmentValuesRef = (0, $i5lfL.useRef)([]);
    const { data: stateSa4SuperSectorInvestmentValues, status: stateSa4SuperSectorInvestmentStatus, fetchStatus: stateSa4SuperSectorInvestmentFetchStatus, error: stateSa4SuperSectorInvestmentError, refetch: refetchStateSa4SuperSectorInvestmentValues } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "StateSA4SuperSectorInvestmentValues"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $98dbd14a43c62e7a$export$d4c4a9d73d541266),
                variables: queryVariables,
                instance: instance,
                accounts: accounts
            });
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        cacheTime: Infinity,
        enabled: !!userInfo
    });
    const formatValue = (value)=>{
        return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
            currencyDisplay: "narrowSymbol",
            notation: "compact",
            compactDisplay: "short"
        }).format(value);
    };
    // Start - State investment chart
    // Set the state chart options
    const state_options = {
        layout: {
            padding: {
                top: 20
            }
        },
        plugins: {
            title: {
                display: false,
                text: 'Total investment per state ($)'
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem)=>{
                        let label = tooltipItem.dataset.label;
                        return label + ': ' + formatValue(tooltipItem.parsed.y);
                    }
                }
            },
            legend: {
                position: "bottom",
                onClick: (e, legendItem, legend)=>{
                    let index = legendItem.datasetIndex;
                    let ci = legend.chart;
                    var alreadyHidden = ci.getDatasetMeta(index).hidden === null ? false : ci.getDatasetMeta(index).hidden;
                    ci.data.datasets.forEach((e, i)=>{
                        var meta = ci.getDatasetMeta(i);
                        if (i !== index) {
                            if (!alreadyHidden) meta.hidden = meta.hidden === null ? !meta.hidden : null;
                            else if (meta.hidden === null) meta.hidden = true;
                        } else if (i === index) meta.hidden = null;
                    });
                    ci.update();
                }
            },
            datalabels: {
                anchor: 'end',
                align: 'end',
                offset: 0,
                formatter: (value, ctx)=>{
                    const total = ctx.chart.$totalizer.totals[ctx.dataIndex];
                    return formatValue(total);
                },
                display: function(ctx) {
                    return ctx.datasetIndex === ctx.chart.$totalizer.utmost;
                }
            }
        },
        responsive: false,
        aspectRatio: 1,
        scales: {
            x: {
                stacked: true
            },
            y: {
                stacked: true,
                ticks: {
                    callback: (value, index, ticks)=>{
                        return formatValue(value);
                    }
                }
            }
        }
    };
    // Build the chart datasets dynamically
    const states = [
        ...new Set(stateInvestmentValuesRef.current.map((item)=>item.State))
    ];
    const years = [
        ...new Set(stateInvestmentValuesRef.current.map((item)=>item.Year))
    ];
    // Not sure if there is a cleaner way to
    // write the following code. Essentially it
    // is adding missing Year/ResourceGroup data.
    // The chart will fail to render correctly if
    // the missing data is not there.
    // Note: this code solution only applies to 
    // stacked bar chart.
    years.forEach((year)=>{
        states.forEach((state)=>{
            const exists = stateInvestmentValuesRef.current.find((i)=>i.Year === year && i.State === state);
            if (!exists) stateInvestmentValuesRef.current.push({
                State: state,
                Year: year,
                Value: 0
            });
        });
    });
    // Sort the results from the above
    stateInvestmentValuesRef.current.sort((a, b)=>{
        return a.Year - b.Year || a.State.localeCompare(b.State);
    });
    // Build the datasets
    const state_datasets = [
        ...new Set(states.map((state)=>{
            return {
                label: state,
                data: stateInvestmentValuesRef.current.filter((obj)=>obj.State === state).map((filObj)=>filObj.Value),
                backgroundColor: state_colours.find((x)=>x.state === state)?.colour
            };
        }))
    ];
    // Sort the data by the investment amount
    // and create the unique years array
    state_datasets.sort((a, b)=>Math.max(...b.data) - Math.max(...a.data));
    const state_chart = {
        labels: years,
        datasets: state_datasets
    };
    // End - State investment chart
    // Start - SA4 investment chart
    const sa4_options = {
        indexAxis: 'y',
        layout: {
            padding: {
                right: 20
            }
        },
        plugins: {
            title: {
                display: false,
                text: 'Total investment per SA4 region ($)'
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem)=>{
                        return formatValue(tooltipItem.parsed.x);
                    }
                }
            },
            legend: {
                display: false
            }
        },
        responsive: false,
        aspectRatio: 1,
        scales: {
            x: {
                position: "top",
                ticks: {
                    callback: (value, index, ticks)=>{
                        return formatValue(value);
                    }
                }
            },
            y: {
                stacked: true
            }
        }
    };
    // Build the chart properties dynamically
    sa4InvestmentValuesRef.current.sort((a, b)=>a.State.localeCompare(b.State) || b.Value - a.Value);
    const total = sa4InvestmentValuesRef.current.reduce((n, { Value: Value })=>n + Value, 0);
    const sa4_proportions = [
        ...new Set(sa4InvestmentValuesRef.current.map((item)=>item.Value / total))
    ];
    const sa4_regions = [
        ...new Set(sa4InvestmentValuesRef.current.map((item)=>item.LocationType))
    ];
    const sa4_values = [
        ...new Set(sa4InvestmentValuesRef.current.map((item)=>item.Value))
    ];
    const sa4_colours = sa4InvestmentValuesRef.current.map((item)=>state_colours.find((x)=>x.state === item.State)?.colour);
    // Set the chart labels and dataset
    const sa4_chart = {
        labels: sa4_regions,
        proportions: sa4_proportions,
        datasets: [
            {
                data: sa4_values,
                backgroundColor: sa4_colours,
                datalabels: {
                    anchor: 'end',
                    align: 'end',
                    offset: 0,
                    formatter: function(value, context) {
                        return new Intl.NumberFormat("en-AU", {
                            style: "percent",
                            maximumFractionDigits: 2
                        }).format(sa4_proportions[context.dataIndex]);
                    }
                }
            }
        ]
    };
    // End - SA4 investment chart
    // Start - Super sector investment chart
    // Set the super sector chart options
    const supersector_options = {
        layout: {
            padding: {
                top: 20
            }
        },
        plugins: {
            title: {
                display: false,
                text: 'Total investment per sector ($)'
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem)=>{
                        let label = tooltipItem.dataset.label;
                        return label + ': ' + formatValue(tooltipItem.parsed.y);
                    }
                }
            },
            legend: {
                position: "bottom",
                onClick: (e, legendItem, legend)=>{
                    let index = legendItem.datasetIndex;
                    let ci = legend.chart;
                    var alreadyHidden = ci.getDatasetMeta(index).hidden === null ? false : ci.getDatasetMeta(index).hidden;
                    ci.data.datasets.forEach((e, i)=>{
                        var meta = ci.getDatasetMeta(i);
                        if (i !== index) {
                            if (!alreadyHidden) meta.hidden = meta.hidden === null ? !meta.hidden : null;
                            else if (meta.hidden === null) meta.hidden = true;
                        } else if (i === index) meta.hidden = null;
                    });
                    ci.update();
                }
            },
            datalabels: {
                anchor: 'end',
                align: 'end',
                offset: 0,
                formatter: (value, ctx)=>{
                    const total = ctx.chart.$totalizer.totals[ctx.dataIndex];
                    return formatValue(total);
                },
                display: function(ctx) {
                    return ctx.datasetIndex === ctx.chart.$totalizer.utmost;
                }
            }
        },
        responsive: false,
        aspectRatio: 1,
        scales: {
            x: {
                stacked: true
            },
            y: {
                stacked: true,
                ticks: {
                    callback: (value, index, ticks)=>{
                        return formatValue(value);
                    }
                }
            }
        }
    };
    // Build the chart datasets dynamically
    const supersectors = [
        ...new Set(superSectorInvestmentValuesRef.current.map((item)=>item.SuperSector))
    ];
    const supersector_years = [
        ...new Set(superSectorInvestmentValuesRef.current.map((item)=>item.Year))
    ];
    // Not sure if there is a cleaner way to
    // write the following code. Essentially it
    // is adding missing Year/ResourceGroup data.
    // The chart will fail to render correctly if
    // the missing data is not there.
    // Note: this code solution only applies to 
    // stacked bar chart.
    supersector_years.forEach((year)=>{
        supersectors.forEach((supersector)=>{
            const exists = superSectorInvestmentValuesRef.current.find((i)=>i.Year === year && i.SuperSector === supersector);
            if (!exists) superSectorInvestmentValuesRef.current.push({
                SuperSector: supersector,
                Year: year,
                Value: 0
            });
        });
    });
    // Sort the results from the above
    superSectorInvestmentValuesRef.current.sort((a, b)=>{
        return a.Year - b.Year || a.SuperSector.localeCompare(b.SuperSector);
    });
    // Build the datasets
    const supersector_datasets = [
        ...new Set(supersectors.map((supersector)=>{
            return {
                label: supersector,
                data: superSectorInvestmentValuesRef.current.filter((obj)=>obj.SuperSector === supersector).map((filObj)=>filObj.Value),
                backgroundColor: supersector_colours.find((x)=>x.supersector === supersector)?.colour
            };
        }))
    ];
    // Sort the data by the investment amount
    // and create the unique years array
    supersector_datasets.sort((a, b)=>Math.max(...b.data) - Math.max(...a.data));
    const supersector_chart = {
        labels: supersector_years,
        datasets: supersector_datasets
    };
    // End - State investment chart
    (0, $i5lfL.useEffect)(()=>{
        if (stateSa4SuperSectorInvestmentStatus == 'error') console.log(stateSa4SuperSectorInvestmentError);
        else if (stateSa4SuperSectorInvestmentStatus == 'success' && stateSa4SuperSectorInvestmentFetchStatus == 'idle') {
            const records = stateSa4SuperSectorInvestmentValues.executeRetrieveStateSA4SuperSectorInvestment;
            stateInvestmentValuesRef.current = [];
            records.reduce((res, value)=>{
                if (!res[value.State + '-' + value.Year]) {
                    res[value.State + '-' + value.Year] = {
                        State: value.State,
                        Value: 0,
                        Year: value.Year
                    };
                    stateInvestmentValuesRef.current.push(res[value.State + '-' + value.Year]);
                }
                res[value.State + '-' + value.Year].Value += value.Value;
                return res;
            }, {});
            sa4InvestmentValuesRef.current = [];
            records.reduce((res, value)=>{
                if (value.LocationType !== 'Unknown') {
                    if (!res[value.LocationType]) {
                        res[value.LocationType] = {
                            State: value.State,
                            LocationType: value.LocationType,
                            Value: 0
                        };
                        sa4InvestmentValuesRef.current.push(res[value.LocationType]);
                    }
                    res[value.LocationType].Value += value.Value;
                }
                return res;
            }, {});
            superSectorInvestmentValuesRef.current = [];
            records.reduce((res, value)=>{
                if (!res[value.SuperSector + '-' + value.Year]) {
                    res[value.SuperSector + '-' + value.Year] = {
                        SuperSector: value.SuperSector,
                        Value: 0,
                        Year: value.Year
                    };
                    superSectorInvestmentValuesRef.current.push(res[value.SuperSector + '-' + value.Year]);
                }
                res[value.SuperSector + '-' + value.Year].Value += value.Value;
                return res;
            }, {});
            investmentChartLoader.current.style.display = 'none';
            setInvestmentTab(false);
        }
    }, [
        stateSa4SuperSectorInvestmentValues,
        stateSa4SuperSectorInvestmentStatus,
        stateSa4SuperSectorInvestmentFetchStatus,
        stateSa4SuperSectorInvestmentError
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (updateInvestmentCharts) {
            investmentChartLoader.current.style.display = 'flex';
            refetchStateSa4SuperSectorInvestmentValues();
        }
    }, [
        updateInvestmentCharts
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                ref: investmentChartLoader,
                style: {
                    position: "absolute",
                    display: "flex",
                    zIndex: "200",
                    width: 1000,
                    height: 1800,
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(51, 51, 51, 0.4)"
                },
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $753bfae0ab95f468$export$67ad50c48ca3ede4), {
                    visible: true,
                    height: "80",
                    width: "80",
                    color: "#005670",
                    secondaryColor: "#005670",
                    ariaLabel: "oval-loading",
                    wrapperStyle: {},
                    wrapperClass: ""
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                container: true,
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                style: {
                                    display: "flex",
                                    width: 1000,
                                    height: 48,
                                    paddingBottom: 2,
                                    backgroundColor: "rgb(0, 86, 112)",
                                    color: "#FFF",
                                    fontWeight: 600,
                                    fontSize: "1.25rem",
                                    fontFamily: "ProximaNova",
                                    justifyContent: "flex-start",
                                    alignItems: "center"
                                },
                                children: "Total investment per state ($)"
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                style: {
                                    position: "relative",
                                    width: 1000,
                                    height: 550
                                },
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30e31766597ec5b3$export$bbc6c6369b38e3d1), {
                                    options: state_options,
                                    data: state_chart,
                                    plugins: [
                                        (0, $93fbc20a8fadecf2$export$2e2bcd8739ae039),
                                        (0, $08e074ffb9935151$export$2e2bcd8739ae039)
                                    ],
                                    width: "1000",
                                    height: "550"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                style: {
                                    display: "flex",
                                    width: 1000,
                                    height: 48,
                                    padding: 2,
                                    backgroundColor: "rgb(0, 86, 112)",
                                    color: "#FFF",
                                    fontWeight: 600,
                                    fontSize: "1.25rem",
                                    fontFamily: "ProximaNova",
                                    justifyContent: "flex-start",
                                    alignItems: "center"
                                },
                                children: "Total investment per SA4 region ($)"
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                style: {
                                    position: "relative",
                                    width: 1000,
                                    height: 550,
                                    overflow: "auto"
                                },
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30e31766597ec5b3$export$bbc6c6369b38e3d1), {
                                    options: sa4_options,
                                    data: sa4_chart,
                                    plugins: [
                                        (0, $93fbc20a8fadecf2$export$2e2bcd8739ae039)
                                    ],
                                    height: "1000",
                                    width: "980"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                style: {
                                    display: "flex",
                                    width: 1000,
                                    height: 48,
                                    padding: 2,
                                    backgroundColor: "rgb(0, 86, 112)",
                                    color: "#FFF",
                                    fontWeight: 600,
                                    fontSize: "1.25rem",
                                    fontFamily: "ProximaNova",
                                    justifyContent: "flex-start",
                                    alignItems: "center"
                                },
                                children: "Total investment per sector ($)"
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                style: {
                                    position: "relative",
                                    width: 1000,
                                    height: 550
                                },
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30e31766597ec5b3$export$bbc6c6369b38e3d1), {
                                    options: supersector_options,
                                    data: supersector_chart,
                                    plugins: [
                                        (0, $93fbc20a8fadecf2$export$2e2bcd8739ae039),
                                        (0, $08e074ffb9935151$export$2e2bcd8739ae039)
                                    ],
                                    width: "1000",
                                    height: "550"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


// @ts-nocheck

var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");








/*!
* chartjs-plugin-annotation v3.1.0
* https://www.chartjs.org/chartjs-plugin-annotation/index
 * (c) 2024 chartjs-plugin-annotation Contributors
 * Released under the MIT License
 */ 

/**
 * @typedef { import("chart.js").ChartEvent } ChartEvent
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 */ const $0fa34b70ef8520fb$var$interaction = {
    modes: {
        /**
     * Point mode returns all elements that hit test based on the event position
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @return {AnnotationElement[]} - elements that are found
     */ point (visibleElements, event) {
            return $0fa34b70ef8520fb$var$filterElements(visibleElements, event, {
                intersect: true
            });
        },
        /**
     * Nearest mode returns the element closest to the event position
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found (only 1 element)
     */ nearest (visibleElements, event, options) {
            return $0fa34b70ef8520fb$var$getNearestItem(visibleElements, event, options);
        },
        /**
     * x mode returns the elements that hit-test at the current x coordinate
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */ x (visibleElements, event, options) {
            return $0fa34b70ef8520fb$var$filterElements(visibleElements, event, {
                intersect: options.intersect,
                axis: 'x'
            });
        },
        /**
     * y mode returns the elements that hit-test at the current y coordinate
     * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */ y (visibleElements, event, options) {
            return $0fa34b70ef8520fb$var$filterElements(visibleElements, event, {
                intersect: options.intersect,
                axis: 'y'
            });
        }
    }
};
/**
 * Returns all elements that hit test based on the event position
 * @param {AnnotationElement[]} visibleElements - annotation elements which are visible
 * @param {ChartEvent} event - the event we are find things at
 * @param {Object} options - interaction options to use
 * @return {AnnotationElement[]} - elements that are found
 */ function $0fa34b70ef8520fb$var$getElements(visibleElements, event, options) {
    const mode = $0fa34b70ef8520fb$var$interaction.modes[options.mode] || $0fa34b70ef8520fb$var$interaction.modes.nearest;
    return mode(visibleElements, event, options);
}
function $0fa34b70ef8520fb$var$inRangeByAxis(element, event, axis) {
    if (axis !== 'x' && axis !== 'y') return element.inRange(event.x, event.y, 'x', true) || element.inRange(event.x, event.y, 'y', true);
    return element.inRange(event.x, event.y, axis, true);
}
function $0fa34b70ef8520fb$var$getPointByAxis(event, center, axis) {
    if (axis === 'x') return {
        x: event.x,
        y: center.y
    };
    else if (axis === 'y') return {
        x: center.x,
        y: event.y
    };
    return center;
}
function $0fa34b70ef8520fb$var$filterElements(visibleElements, event, options) {
    return visibleElements.filter((element)=>options.intersect ? element.inRange(event.x, event.y) : $0fa34b70ef8520fb$var$inRangeByAxis(element, event, options.axis));
}
function $0fa34b70ef8520fb$var$getNearestItem(visibleElements, event, options) {
    let minDistance = Number.POSITIVE_INFINITY;
    return $0fa34b70ef8520fb$var$filterElements(visibleElements, event, options).reduce((nearestItems, element)=>{
        const center = element.getCenterPoint();
        const evenPoint = $0fa34b70ef8520fb$var$getPointByAxis(event, center, options.axis);
        const distance = (0, $054bf7af52f034b6$export$158acd800e1ef08b)(event, evenPoint);
        if (distance < minDistance) {
            nearestItems = [
                element
            ];
            minDistance = distance;
        } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
        nearestItems.push(element);
        return nearestItems;
    }, []).sort((a, b)=>a._index - b._index).slice(0, 1); // return only the top item;
}
/**
 * @typedef {import('chart.js').Point} Point
 */ /**
 * Rotate a `point` relative to `center` point by `angle`
 * @param {Point} point - the point to rotate
 * @param {Point} center - center point for rotation
 * @param {number} angle - angle for rotation, in radians
 * @returns {Point} rotated point
 */ function $0fa34b70ef8520fb$var$rotated(point, center, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const cx = center.x;
    const cy = center.y;
    return {
        x: cx + cos * (point.x - cx) - sin * (point.y - cy),
        y: cy + sin * (point.x - cx) + cos * (point.y - cy)
    };
}
const $0fa34b70ef8520fb$var$isOlderPart = (act, req)=>req > act || act.length > req.length && act.slice(0, req.length) === req;
/**
 * @typedef { import('chart.js').Point } Point
 * @typedef { import('chart.js').InteractionAxis } InteractionAxis
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 */ const $0fa34b70ef8520fb$var$EPSILON = 0.001;
const $0fa34b70ef8520fb$var$clamp = (x, from, to)=>Math.min(to, Math.max(from, x));
/**
 * @param {{value: number, start: number, end: number}} limit
 * @param {number} hitSize
 * @returns {boolean}
 */ const $0fa34b70ef8520fb$var$inLimit = (limit, hitSize)=>limit.value >= limit.start - hitSize && limit.value <= limit.end + hitSize;
/**
 * @param {Object} obj
 * @param {number} from
 * @param {number} to
 * @returns {Object}
 */ function $0fa34b70ef8520fb$var$clampAll(obj, from, to) {
    for (const key of Object.keys(obj))obj[key] = $0fa34b70ef8520fb$var$clamp(obj[key], from, to);
    return obj;
}
/**
 * @param {Point} point
 * @param {Point} center
 * @param {number} radius
 * @param {number} hitSize
 * @returns {boolean}
 */ function $0fa34b70ef8520fb$var$inPointRange(point, center, radius, hitSize) {
    if (!point || !center || radius <= 0) return false;
    return Math.pow(point.x - center.x, 2) + Math.pow(point.y - center.y, 2) <= Math.pow(radius + hitSize, 2);
}
/**
 * @param {Point} point
 * @param {{x: number, y: number, x2: number, y2: number}} rect
 * @param {InteractionAxis} axis
 * @param {{borderWidth: number, hitTolerance: number}} hitsize
 * @returns {boolean}
 */ function $0fa34b70ef8520fb$var$inBoxRange(point, { x: x, y: y, x2: x2, y2: y2 }, axis, { borderWidth: borderWidth, hitTolerance: hitTolerance }) {
    const hitSize = (borderWidth + hitTolerance) / 2;
    const inRangeX = point.x >= x - hitSize - $0fa34b70ef8520fb$var$EPSILON && point.x <= x2 + hitSize + $0fa34b70ef8520fb$var$EPSILON;
    const inRangeY = point.y >= y - hitSize - $0fa34b70ef8520fb$var$EPSILON && point.y <= y2 + hitSize + $0fa34b70ef8520fb$var$EPSILON;
    if (axis === 'x') return inRangeX;
    else if (axis === 'y') return inRangeY;
    return inRangeX && inRangeY;
}
/**
 * @param {Point} point
 * @param {rect: {x: number, y: number, x2: number, y2: number}, center: {x: number, y: number}} element
 * @param {InteractionAxis} axis
 * @param {{rotation: number, borderWidth: number, hitTolerance: number}}
 * @returns {boolean}
 */ function $0fa34b70ef8520fb$var$inLabelRange(point, { rect: rect, center: center }, axis, { rotation: rotation, borderWidth: borderWidth, hitTolerance: hitTolerance }) {
    const rotPoint = $0fa34b70ef8520fb$var$rotated(point, center, (0, $054bf7af52f034b6$export$625550452a3fa3ec)(-rotation));
    return $0fa34b70ef8520fb$var$inBoxRange(rotPoint, rect, axis, {
        borderWidth: borderWidth,
        hitTolerance: hitTolerance
    });
}
/**
 * @param {AnnotationElement} element
 * @param {boolean} useFinalPosition
 * @returns {Point}
 */ function $0fa34b70ef8520fb$var$getElementCenterPoint(element, useFinalPosition) {
    const { centerX: centerX, centerY: centerY } = element.getProps([
        'centerX',
        'centerY'
    ], useFinalPosition);
    return {
        x: centerX,
        y: centerY
    };
}
/**
 * @param {string} pkg
 * @param {string} min
 * @param {string} ver
 * @param {boolean} [strict=true]
 * @returns {boolean}
 */ function $0fa34b70ef8520fb$var$requireVersion(pkg, min, ver, strict = true) {
    const parts = ver.split('.');
    let i = 0;
    for (const req of min.split('.')){
        const act = parts[i++];
        if (parseInt(req, 10) < parseInt(act, 10)) break;
        if ($0fa34b70ef8520fb$var$isOlderPart(act, req)) {
            if (strict) throw new Error(`${pkg} v${ver} is not supported. v${min} or newer is required.`);
            else return false;
        }
    }
    return true;
}
const $0fa34b70ef8520fb$var$isPercentString = (s)=>typeof s === 'string' && s.endsWith('%');
const $0fa34b70ef8520fb$var$toPercent = (s)=>parseFloat(s) / 100;
const $0fa34b70ef8520fb$var$toPositivePercent = (s)=>$0fa34b70ef8520fb$var$clamp($0fa34b70ef8520fb$var$toPercent(s), 0, 1);
const $0fa34b70ef8520fb$var$boxAppering = (x, y)=>({
        x: x,
        y: y,
        x2: x,
        y2: y,
        width: 0,
        height: 0
    });
const $0fa34b70ef8520fb$var$defaultInitAnimation = {
    box: (properties)=>$0fa34b70ef8520fb$var$boxAppering(properties.centerX, properties.centerY),
    doughnutLabel: (properties)=>$0fa34b70ef8520fb$var$boxAppering(properties.centerX, properties.centerY),
    ellipse: (properties)=>({
            centerX: properties.centerX,
            centerY: properties.centerX,
            radius: 0,
            width: 0,
            height: 0
        }),
    label: (properties)=>$0fa34b70ef8520fb$var$boxAppering(properties.centerX, properties.centerY),
    line: (properties)=>$0fa34b70ef8520fb$var$boxAppering(properties.x, properties.y),
    point: (properties)=>({
            centerX: properties.centerX,
            centerY: properties.centerY,
            radius: 0,
            width: 0,
            height: 0
        }),
    polygon: (properties)=>$0fa34b70ef8520fb$var$boxAppering(properties.centerX, properties.centerY)
};
/**
 * @typedef { import('chart.js').FontSpec } FontSpec
 * @typedef { import('chart.js').Point } Point
 * @typedef { import('chart.js').Padding } Padding
 * @typedef { import('../../types/element').AnnotationBoxModel } AnnotationBoxModel
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 * @typedef { import('../../types/options').AnnotationPointCoordinates } AnnotationPointCoordinates
 * @typedef { import('../../types/label').CoreLabelOptions } CoreLabelOptions
 * @typedef { import('../../types/label').LabelPositionObject } LabelPositionObject
 */ /**
 * @param {number} size
 * @param {number|string} position
 * @returns {number}
 */ function $0fa34b70ef8520fb$var$getRelativePosition(size, position) {
    if (position === 'start') return 0;
    if (position === 'end') return size;
    if ($0fa34b70ef8520fb$var$isPercentString(position)) return $0fa34b70ef8520fb$var$toPositivePercent(position) * size;
    return size / 2;
}
/**
 * @param {number} size
 * @param {number|string} value
 * @param {boolean} [positivePercent=true]
 * @returns {number}
 */ function $0fa34b70ef8520fb$var$getSize(size, value, positivePercent = true) {
    if (typeof value === 'number') return value;
    else if ($0fa34b70ef8520fb$var$isPercentString(value)) return (positivePercent ? $0fa34b70ef8520fb$var$toPositivePercent(value) : $0fa34b70ef8520fb$var$toPercent(value)) * size;
    return size;
}
/**
 * @param {{x: number, width: number}} size
 * @param {CoreLabelOptions} options
 * @returns {number}
 */ function $0fa34b70ef8520fb$var$calculateTextAlignment(size, options) {
    const { x: x, width: width } = size;
    const textAlign = options.textAlign;
    if (textAlign === 'center') return x + width / 2;
    else if (textAlign === 'end' || textAlign === 'right') return x + width;
    return x;
}
/**
 * @param {Point} point
 * @param {{height: number, width: number}} labelSize
 * @param {{borderWidth: number, position: {LabelPositionObject|string}, xAdjust: number, yAdjust: number}} options
 * @param {Padding|undefined} padding
 * @returns {{x: number, y: number, x2: number, y2: number, height: number, width: number, centerX: number, centerY: number}}
 */ function $0fa34b70ef8520fb$var$measureLabelRectangle(point, labelSize, { borderWidth: borderWidth, position: position, xAdjust: xAdjust, yAdjust: yAdjust }, padding) {
    const hasPadding = (0, $054bf7af52f034b6$export$23f2a1d2818174ef)(padding);
    const width = labelSize.width + (hasPadding ? padding.width : 0) + borderWidth;
    const height = labelSize.height + (hasPadding ? padding.height : 0) + borderWidth;
    const positionObj = $0fa34b70ef8520fb$var$toPosition(position);
    const x = $0fa34b70ef8520fb$var$calculateLabelPosition$1(point.x, width, xAdjust, positionObj.x);
    const y = $0fa34b70ef8520fb$var$calculateLabelPosition$1(point.y, height, yAdjust, positionObj.y);
    return {
        x: x,
        y: y,
        x2: x + width,
        y2: y + height,
        width: width,
        height: height,
        centerX: x + width / 2,
        centerY: y + height / 2
    };
}
/**
 * @param {LabelPositionObject|string} value
 * @param {string|number} defaultValue
 * @returns {LabelPositionObject}
 */ function $0fa34b70ef8520fb$var$toPosition(value, defaultValue = 'center') {
    if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(value)) return {
        x: (0, $054bf7af52f034b6$export$90a7f3efeed30595)(value.x, defaultValue),
        y: (0, $054bf7af52f034b6$export$90a7f3efeed30595)(value.y, defaultValue)
    };
    value = (0, $054bf7af52f034b6$export$90a7f3efeed30595)(value, defaultValue);
    return {
        x: value,
        y: value
    };
}
/**
 * @param {CoreLabelOptions} options
 * @param {number} fitRatio
 * @returns {boolean}
 */ const $0fa34b70ef8520fb$var$shouldFit = (options, fitRatio)=>options && options.autoFit && fitRatio < 1;
/**
 * @param {CoreLabelOptions} options
 * @param {number} fitRatio
 * @returns {FontSpec[]}
 */ function $0fa34b70ef8520fb$var$toFonts(options, fitRatio) {
    const optFont = options.font;
    const fonts = (0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(optFont) ? optFont : [
        optFont
    ];
    if ($0fa34b70ef8520fb$var$shouldFit(options, fitRatio)) return fonts.map(function(f) {
        const font = (0, $054bf7af52f034b6$export$34aec0b863436764)(f);
        font.size = Math.floor(f.size * fitRatio);
        font.lineHeight = f.lineHeight;
        return (0, $054bf7af52f034b6$export$34aec0b863436764)(font);
    });
    return fonts.map((f)=>(0, $054bf7af52f034b6$export$34aec0b863436764)(f));
}
/**
 * @param {AnnotationPointCoordinates} options
 * @returns {boolean}
 */ function $0fa34b70ef8520fb$var$isBoundToPoint(options) {
    return options && ((0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(options.xValue) || (0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(options.yValue));
}
function $0fa34b70ef8520fb$var$calculateLabelPosition$1(start, size, adjust = 0, position) {
    return start - $0fa34b70ef8520fb$var$getRelativePosition(size, position) + adjust;
}
/**
 * @param {Chart} chart
 * @param {AnnotationBoxModel} properties
 * @param {CoreAnnotationOptions} options
 * @returns {AnnotationElement}
 */ function $0fa34b70ef8520fb$var$initAnimationProperties(chart, properties, options) {
    const initAnim = options.init;
    if (!initAnim) return;
    else if (initAnim === true) return $0fa34b70ef8520fb$var$applyDefault(properties, options);
    return $0fa34b70ef8520fb$var$execCallback(chart, properties, options);
}
/**
 * @param {Object} options
 * @param {Array} hooks
 * @param {Object} hooksContainer
 * @returns {boolean}
 */ function $0fa34b70ef8520fb$var$loadHooks(options, hooks, hooksContainer) {
    let activated = false;
    hooks.forEach((hook)=>{
        if ((0, $054bf7af52f034b6$export$a93c5207d687da10)(options[hook])) {
            activated = true;
            hooksContainer[hook] = options[hook];
        } else if ((0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(hooksContainer[hook])) delete hooksContainer[hook];
    });
    return activated;
}
function $0fa34b70ef8520fb$var$applyDefault(properties, options) {
    const type = options.type || 'line';
    return $0fa34b70ef8520fb$var$defaultInitAnimation[type](properties);
}
function $0fa34b70ef8520fb$var$execCallback(chart, properties, options) {
    const result = (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(options.init, [
        {
            chart: chart,
            properties: properties,
            options: options
        }
    ]);
    if (result === true) return $0fa34b70ef8520fb$var$applyDefault(properties, options);
    else if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(result)) return result;
}
const $0fa34b70ef8520fb$var$widthCache = new Map();
const $0fa34b70ef8520fb$var$notRadius = (radius)=>isNaN(radius) || radius <= 0;
const $0fa34b70ef8520fb$var$fontsKey = (fonts)=>fonts.reduce(function(prev, item) {
        prev += item.string;
        return prev;
    }, '');
/**
 * @typedef { import('chart.js').Point } Point
 * @typedef { import('../../types/label').CoreLabelOptions } CoreLabelOptions
 * @typedef { import('../../types/options').PointAnnotationOptions } PointAnnotationOptions
 */ /**
 * Determine if content is an image or a canvas.
 * @param {*} content
 * @returns boolean|undefined
 * @todo move this function to chart.js helpers
 */ function $0fa34b70ef8520fb$var$isImageOrCanvas(content) {
    if (content && typeof content === 'object') {
        const type = content.toString();
        return type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]';
    }
}
/**
 * Set the translation on the canvas if the rotation must be applied.
 * @param {CanvasRenderingContext2D} ctx - chart canvas context
 * @param {Point} point - the point of translation
 * @param {number} rotation - rotation (in degrees) to apply
 */ function $0fa34b70ef8520fb$var$translate(ctx, { x: x, y: y }, rotation) {
    if (rotation) {
        ctx.translate(x, y);
        ctx.rotate((0, $054bf7af52f034b6$export$625550452a3fa3ec)(rotation));
        ctx.translate(-x, -y);
    }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} options
 * @returns {boolean|undefined}
 */ function $0fa34b70ef8520fb$var$setBorderStyle(ctx, options) {
    if (options && options.borderWidth) {
        ctx.lineCap = options.borderCapStyle || 'butt';
        ctx.setLineDash(options.borderDash);
        ctx.lineDashOffset = options.borderDashOffset;
        ctx.lineJoin = options.borderJoinStyle || 'miter';
        ctx.lineWidth = options.borderWidth;
        ctx.strokeStyle = options.borderColor;
        return true;
    }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} options
 */ function $0fa34b70ef8520fb$var$setShadowStyle(ctx, options) {
    ctx.shadowColor = options.backgroundShadowColor;
    ctx.shadowBlur = options.shadowBlur;
    ctx.shadowOffsetX = options.shadowOffsetX;
    ctx.shadowOffsetY = options.shadowOffsetY;
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {CoreLabelOptions} options
 * @returns {{width: number, height: number}}
 */ function $0fa34b70ef8520fb$var$measureLabelSize(ctx, options) {
    const content = options.content;
    if ($0fa34b70ef8520fb$var$isImageOrCanvas(content)) {
        const size = {
            width: $0fa34b70ef8520fb$var$getSize(content.width, options.width),
            height: $0fa34b70ef8520fb$var$getSize(content.height, options.height)
        };
        return size;
    }
    const fonts = $0fa34b70ef8520fb$var$toFonts(options);
    const strokeWidth = options.textStrokeWidth;
    const lines = (0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(content) ? content : [
        content
    ];
    const mapKey = lines.join() + $0fa34b70ef8520fb$var$fontsKey(fonts) + strokeWidth + (ctx._measureText ? '-spriting' : '');
    if (!$0fa34b70ef8520fb$var$widthCache.has(mapKey)) $0fa34b70ef8520fb$var$widthCache.set(mapKey, $0fa34b70ef8520fb$var$calculateLabelSize(ctx, lines, fonts, strokeWidth));
    return $0fa34b70ef8520fb$var$widthCache.get(mapKey);
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {{x: number, y: number, width: number, height: number}} rect
 * @param {Object} options
 */ function $0fa34b70ef8520fb$var$drawBox(ctx, rect, options) {
    const { x: x, y: y, width: width, height: height } = rect;
    ctx.save();
    $0fa34b70ef8520fb$var$setShadowStyle(ctx, options);
    const stroke = $0fa34b70ef8520fb$var$setBorderStyle(ctx, options);
    ctx.fillStyle = options.backgroundColor;
    ctx.beginPath();
    (0, $054bf7af52f034b6$export$1fbe638ecf81657e)(ctx, {
        x: x,
        y: y,
        w: width,
        h: height,
        radius: $0fa34b70ef8520fb$var$clampAll((0, $054bf7af52f034b6$export$92108d983e8ee699)(options.borderRadius), 0, Math.min(width, height) / 2)
    });
    ctx.closePath();
    ctx.fill();
    if (stroke) {
        ctx.shadowColor = options.borderShadowColor;
        ctx.stroke();
    }
    ctx.restore();
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {{x: number, y: number, width: number, height: number}} rect
 * @param {CoreLabelOptions} options
 * @param {number} fitRatio
 */ function $0fa34b70ef8520fb$var$drawLabel(ctx, rect, options, fitRatio) {
    const content = options.content;
    if ($0fa34b70ef8520fb$var$isImageOrCanvas(content)) {
        ctx.save();
        ctx.globalAlpha = $0fa34b70ef8520fb$var$getOpacity(options.opacity, content.style.opacity);
        ctx.drawImage(content, rect.x, rect.y, rect.width, rect.height);
        ctx.restore();
        return;
    }
    const labels = (0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(content) ? content : [
        content
    ];
    const fonts = $0fa34b70ef8520fb$var$toFonts(options, fitRatio);
    const optColor = options.color;
    const colors = (0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(optColor) ? optColor : [
        optColor
    ];
    const x = $0fa34b70ef8520fb$var$calculateTextAlignment(rect, options);
    const y = rect.y + options.textStrokeWidth / 2;
    ctx.save();
    ctx.textBaseline = 'middle';
    ctx.textAlign = options.textAlign;
    if ($0fa34b70ef8520fb$var$setTextStrokeStyle(ctx, options)) $0fa34b70ef8520fb$var$applyLabelDecoration(ctx, {
        x: x,
        y: y
    }, labels, fonts);
    $0fa34b70ef8520fb$var$applyLabelContent(ctx, {
        x: x,
        y: y
    }, labels, {
        fonts: fonts,
        colors: colors
    });
    ctx.restore();
}
function $0fa34b70ef8520fb$var$setTextStrokeStyle(ctx, options) {
    if (options.textStrokeWidth > 0) {
        // https://stackoverflow.com/questions/13627111/drawing-text-with-an-outer-stroke-with-html5s-canvas
        ctx.lineJoin = 'round';
        ctx.miterLimit = 2;
        ctx.lineWidth = options.textStrokeWidth;
        ctx.strokeStyle = options.textStrokeColor;
        return true;
    }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {{radius: number, options: PointAnnotationOptions}} element
 * @param {number} x
 * @param {number} y
 */ function $0fa34b70ef8520fb$var$drawPoint(ctx, element, x, y) {
    const { radius: radius, options: options } = element;
    const style = options.pointStyle;
    const rotation = options.rotation;
    let rad = (rotation || 0) * (0, $054bf7af52f034b6$export$53c86fa97d611818);
    if ($0fa34b70ef8520fb$var$isImageOrCanvas(style)) {
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(rad);
        ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
        ctx.restore();
        return;
    }
    if ($0fa34b70ef8520fb$var$notRadius(radius)) return;
    $0fa34b70ef8520fb$var$drawPointStyle(ctx, {
        x: x,
        y: y,
        radius: radius,
        rotation: rotation,
        style: style,
        rad: rad
    });
}
function $0fa34b70ef8520fb$var$drawPointStyle(ctx, { x: x, y: y, radius: radius, rotation: rotation, style: style, rad: rad }) {
    let xOffset, yOffset, size, cornerRadius;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            ctx.arc(x, y, radius, 0, (0, $054bf7af52f034b6$export$971d5caa766a69d7));
            ctx.closePath();
            break;
        case 'triangle':
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += (0, $054bf7af52f034b6$export$7a0bdf7d4a91ea88);
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += (0, $054bf7af52f034b6$export$7a0bdf7d4a91ea88);
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + (0, $054bf7af52f034b6$export$39c1cc7c062529d4)) * size;
            yOffset = Math.sin(rad + (0, $054bf7af52f034b6$export$39c1cc7c062529d4)) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - (0, $054bf7af52f034b6$export$56c0d5a1e737357d), rad - (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd));
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd), rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd));
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + (0, $054bf7af52f034b6$export$7f8ddf7c7c20b3cd), rad + (0, $054bf7af52f034b6$export$56c0d5a1e737357d));
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                ctx.rect(x - size, y - size, 2 * size, 2 * size);
                break;
            }
            rad += (0, $054bf7af52f034b6$export$39c1cc7c062529d4);
        /* falls through */ case 'rectRot':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += (0, $054bf7af52f034b6$export$39c1cc7c062529d4);
        /* falls through */ case 'cross':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case 'star':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += (0, $054bf7af52f034b6$export$39c1cc7c062529d4);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
        case 'line':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
    }
    ctx.fill();
}
function $0fa34b70ef8520fb$var$calculateLabelSize(ctx, lines, fonts, strokeWidth) {
    ctx.save();
    const count = lines.length;
    let width = 0;
    let height = strokeWidth;
    for(let i = 0; i < count; i++){
        const font = fonts[Math.min(i, fonts.length - 1)];
        ctx.font = font.string;
        const text = lines[i];
        width = Math.max(width, ctx.measureText(text).width + strokeWidth);
        height += font.lineHeight;
    }
    ctx.restore();
    return {
        width: width,
        height: height
    };
}
function $0fa34b70ef8520fb$var$applyLabelDecoration(ctx, { x: x, y: y }, labels, fonts) {
    ctx.beginPath();
    let lhs = 0;
    labels.forEach(function(l, i) {
        const f = fonts[Math.min(i, fonts.length - 1)];
        const lh = f.lineHeight;
        ctx.font = f.string;
        ctx.strokeText(l, x, y + lh / 2 + lhs);
        lhs += lh;
    });
    ctx.stroke();
}
function $0fa34b70ef8520fb$var$applyLabelContent(ctx, { x: x, y: y }, labels, { fonts: fonts, colors: colors }) {
    let lhs = 0;
    labels.forEach(function(l, i) {
        const c = colors[Math.min(i, colors.length - 1)];
        const f = fonts[Math.min(i, fonts.length - 1)];
        const lh = f.lineHeight;
        ctx.beginPath();
        ctx.font = f.string;
        ctx.fillStyle = c;
        ctx.fillText(l, x, y + lh / 2 + lhs);
        lhs += lh;
        ctx.fill();
    });
}
function $0fa34b70ef8520fb$var$getOpacity(value, elementValue) {
    const opacity = (0, $054bf7af52f034b6$export$d141bba7fdc215a3)(value) ? value : elementValue;
    return (0, $054bf7af52f034b6$export$d141bba7fdc215a3)(opacity) ? $0fa34b70ef8520fb$var$clamp(opacity, 0, 1) : 1;
}
const $0fa34b70ef8520fb$var$positions = [
    'left',
    'bottom',
    'top',
    'right'
];
/**
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 */ /**
 * Drawa the callout component for labels.
 * @param {CanvasRenderingContext2D} ctx - chart canvas context
 * @param {AnnotationElement} element - the label element
 */ function $0fa34b70ef8520fb$var$drawCallout(ctx, element) {
    const { pointX: pointX, pointY: pointY, options: options } = element;
    const callout = options.callout;
    const calloutPosition = callout && callout.display && $0fa34b70ef8520fb$var$resolveCalloutPosition(element, callout);
    if (!calloutPosition || $0fa34b70ef8520fb$var$isPointInRange(element, callout, calloutPosition)) return;
    ctx.save();
    ctx.beginPath();
    const stroke = $0fa34b70ef8520fb$var$setBorderStyle(ctx, callout);
    if (!stroke) return ctx.restore();
    const { separatorStart: separatorStart, separatorEnd: separatorEnd } = $0fa34b70ef8520fb$var$getCalloutSeparatorCoord(element, calloutPosition);
    const { sideStart: sideStart, sideEnd: sideEnd } = $0fa34b70ef8520fb$var$getCalloutSideCoord(element, calloutPosition, separatorStart);
    if (callout.margin > 0 || options.borderWidth === 0) {
        ctx.moveTo(separatorStart.x, separatorStart.y);
        ctx.lineTo(separatorEnd.x, separatorEnd.y);
    }
    ctx.moveTo(sideStart.x, sideStart.y);
    ctx.lineTo(sideEnd.x, sideEnd.y);
    const rotatedPoint = $0fa34b70ef8520fb$var$rotated({
        x: pointX,
        y: pointY
    }, element.getCenterPoint(), (0, $054bf7af52f034b6$export$625550452a3fa3ec)(-element.rotation));
    ctx.lineTo(rotatedPoint.x, rotatedPoint.y);
    ctx.stroke();
    ctx.restore();
}
function $0fa34b70ef8520fb$var$getCalloutSeparatorCoord(element, position) {
    const { x: x, y: y, x2: x2, y2: y2 } = element;
    const adjust = $0fa34b70ef8520fb$var$getCalloutSeparatorAdjust(element, position);
    let separatorStart, separatorEnd;
    if (position === 'left' || position === 'right') {
        separatorStart = {
            x: x + adjust,
            y: y
        };
        separatorEnd = {
            x: separatorStart.x,
            y: y2
        };
    } else {
        //  position 'top' or 'bottom'
        separatorStart = {
            x: x,
            y: y + adjust
        };
        separatorEnd = {
            x: x2,
            y: separatorStart.y
        };
    }
    return {
        separatorStart: separatorStart,
        separatorEnd: separatorEnd
    };
}
function $0fa34b70ef8520fb$var$getCalloutSeparatorAdjust(element, position) {
    const { width: width, height: height, options: options } = element;
    const adjust = options.callout.margin + options.borderWidth / 2;
    if (position === 'right') return width + adjust;
    else if (position === 'bottom') return height + adjust;
    return -adjust;
}
function $0fa34b70ef8520fb$var$getCalloutSideCoord(element, position, separatorStart) {
    const { y: y, width: width, height: height, options: options } = element;
    const start = options.callout.start;
    const side = $0fa34b70ef8520fb$var$getCalloutSideAdjust(position, options.callout);
    let sideStart, sideEnd;
    if (position === 'left' || position === 'right') {
        sideStart = {
            x: separatorStart.x,
            y: y + $0fa34b70ef8520fb$var$getSize(height, start)
        };
        sideEnd = {
            x: sideStart.x + side,
            y: sideStart.y
        };
    } else {
        //  position 'top' or 'bottom'
        sideStart = {
            x: separatorStart.x + $0fa34b70ef8520fb$var$getSize(width, start),
            y: separatorStart.y
        };
        sideEnd = {
            x: sideStart.x,
            y: sideStart.y + side
        };
    }
    return {
        sideStart: sideStart,
        sideEnd: sideEnd
    };
}
function $0fa34b70ef8520fb$var$getCalloutSideAdjust(position, options) {
    const side = options.side;
    if (position === 'left' || position === 'top') return -side;
    return side;
}
function $0fa34b70ef8520fb$var$resolveCalloutPosition(element, options) {
    const position = options.position;
    if ($0fa34b70ef8520fb$var$positions.includes(position)) return position;
    return $0fa34b70ef8520fb$var$resolveCalloutAutoPosition(element, options);
}
function $0fa34b70ef8520fb$var$resolveCalloutAutoPosition(element, options) {
    const { x: x, y: y, x2: x2, y2: y2, width: width, height: height, pointX: pointX, pointY: pointY, centerX: centerX, centerY: centerY, rotation: rotation } = element;
    const center = {
        x: centerX,
        y: centerY
    };
    const start = options.start;
    const xAdjust = $0fa34b70ef8520fb$var$getSize(width, start);
    const yAdjust = $0fa34b70ef8520fb$var$getSize(height, start);
    const xPoints = [
        x,
        x + xAdjust,
        x + xAdjust,
        x2
    ];
    const yPoints = [
        y + yAdjust,
        y2,
        y,
        y2
    ];
    const result = [];
    for(let index = 0; index < 4; index++){
        const rotatedPoint = $0fa34b70ef8520fb$var$rotated({
            x: xPoints[index],
            y: yPoints[index]
        }, center, (0, $054bf7af52f034b6$export$625550452a3fa3ec)(rotation));
        result.push({
            position: $0fa34b70ef8520fb$var$positions[index],
            distance: (0, $054bf7af52f034b6$export$158acd800e1ef08b)(rotatedPoint, {
                x: pointX,
                y: pointY
            })
        });
    }
    return result.sort((a, b)=>a.distance - b.distance)[0].position;
}
function $0fa34b70ef8520fb$var$isPointInRange(element, callout, position) {
    const { pointX: pointX, pointY: pointY } = element;
    const margin = callout.margin;
    let x = pointX;
    let y = pointY;
    if (position === 'left') x += margin;
    else if (position === 'right') x -= margin;
    else if (position === 'top') y += margin;
    else if (position === 'bottom') y -= margin;
    return element.inRange(x, y);
}
const $0fa34b70ef8520fb$var$limitedLineScale = {
    xScaleID: {
        min: 'xMin',
        max: 'xMax',
        start: 'left',
        end: 'right',
        startProp: 'x',
        endProp: 'x2'
    },
    yScaleID: {
        min: 'yMin',
        max: 'yMax',
        start: 'bottom',
        end: 'top',
        startProp: 'y',
        endProp: 'y2'
    }
};
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import("chart.js").Scale } Scale
 * @typedef { import("chart.js").Point } Point
 * @typedef { import('../../types/element').AnnotationBoxModel } AnnotationBoxModel
 * @typedef { import('../../types/options').CoreAnnotationOptions } CoreAnnotationOptions
 * @typedef { import('../../types/options').LineAnnotationOptions } LineAnnotationOptions
 * @typedef { import('../../types/options').PointAnnotationOptions } PointAnnotationOptions
 * @typedef { import('../../types/options').PolygonAnnotationOptions } PolygonAnnotationOptions
 */ /**
 * @param {Scale} scale
 * @param {number|string} value
 * @param {number} fallback
 * @returns {number}
 */ function $0fa34b70ef8520fb$var$scaleValue(scale, value, fallback) {
    value = typeof value === 'number' ? value : scale.parse(value);
    return (0, $054bf7af52f034b6$export$39b482c5e57630a8)(value) ? scale.getPixelForValue(value) : fallback;
}
/**
 * Search the scale defined in chartjs by the axis related to the annotation options key.
 * @param {{ [key: string]: Scale }} scales
 * @param {CoreAnnotationOptions} options
 * @param {string} key
 * @returns {string}
 */ function $0fa34b70ef8520fb$var$retrieveScaleID(scales, options, key) {
    const scaleID = options[key];
    if (scaleID || key === 'scaleID') return scaleID;
    const axis = key.charAt(0);
    const axes = Object.values(scales).filter((scale)=>scale.axis && scale.axis === axis);
    if (axes.length) return axes[0].id;
    return axis;
}
/**
 * @param {Scale} scale
 * @param {{min: number, max: number, start: number, end: number}} options
 * @returns {{start: number, end: number}|undefined}
 */ function $0fa34b70ef8520fb$var$getDimensionByScale(scale, options) {
    if (scale) {
        const reverse = scale.options.reverse;
        const start = $0fa34b70ef8520fb$var$scaleValue(scale, options.min, reverse ? options.end : options.start);
        const end = $0fa34b70ef8520fb$var$scaleValue(scale, options.max, reverse ? options.start : options.end);
        return {
            start: start,
            end: end
        };
    }
}
/**
 * @param {Chart} chart
 * @param {CoreAnnotationOptions} options
 * @returns {Point}
 */ function $0fa34b70ef8520fb$var$getChartPoint(chart, options) {
    const { chartArea: chartArea, scales: scales } = chart;
    const xScale = scales[$0fa34b70ef8520fb$var$retrieveScaleID(scales, options, 'xScaleID')];
    const yScale = scales[$0fa34b70ef8520fb$var$retrieveScaleID(scales, options, 'yScaleID')];
    let x = chartArea.width / 2;
    let y = chartArea.height / 2;
    if (xScale) x = $0fa34b70ef8520fb$var$scaleValue(xScale, options.xValue, xScale.left + xScale.width / 2);
    if (yScale) y = $0fa34b70ef8520fb$var$scaleValue(yScale, options.yValue, yScale.top + yScale.height / 2);
    return {
        x: x,
        y: y
    };
}
/**
 * @param {Chart} chart
 * @param {CoreAnnotationOptions} options
 * @returns {AnnotationBoxModel}
 */ function $0fa34b70ef8520fb$var$resolveBoxProperties(chart, options) {
    const scales = chart.scales;
    const xScale = scales[$0fa34b70ef8520fb$var$retrieveScaleID(scales, options, 'xScaleID')];
    const yScale = scales[$0fa34b70ef8520fb$var$retrieveScaleID(scales, options, 'yScaleID')];
    if (!xScale && !yScale) return {};
    let { left: x, right: x2 } = xScale || chart.chartArea;
    let { top: y, bottom: y2 } = yScale || chart.chartArea;
    const xDim = $0fa34b70ef8520fb$var$getChartDimensionByScale(xScale, {
        min: options.xMin,
        max: options.xMax,
        start: x,
        end: x2
    });
    x = xDim.start;
    x2 = xDim.end;
    const yDim = $0fa34b70ef8520fb$var$getChartDimensionByScale(yScale, {
        min: options.yMin,
        max: options.yMax,
        start: y2,
        end: y
    });
    y = yDim.start;
    y2 = yDim.end;
    return {
        x: x,
        y: y,
        x2: x2,
        y2: y2,
        width: x2 - x,
        height: y2 - y,
        centerX: x + (x2 - x) / 2,
        centerY: y + (y2 - y) / 2
    };
}
/**
 * @param {Chart} chart
 * @param {PointAnnotationOptions|PolygonAnnotationOptions} options
 * @returns {AnnotationBoxModel}
 */ function $0fa34b70ef8520fb$var$resolvePointProperties(chart, options) {
    if (!$0fa34b70ef8520fb$var$isBoundToPoint(options)) {
        const box = $0fa34b70ef8520fb$var$resolveBoxProperties(chart, options);
        let radius = options.radius;
        if (!radius || isNaN(radius)) {
            radius = Math.min(box.width, box.height) / 2;
            options.radius = radius;
        }
        const size = radius * 2;
        const adjustCenterX = box.centerX + options.xAdjust;
        const adjustCenterY = box.centerY + options.yAdjust;
        return {
            x: adjustCenterX - radius,
            y: adjustCenterY - radius,
            x2: adjustCenterX + radius,
            y2: adjustCenterY + radius,
            centerX: adjustCenterX,
            centerY: adjustCenterY,
            width: size,
            height: size,
            radius: radius
        };
    }
    return $0fa34b70ef8520fb$var$getChartCircle(chart, options);
}
/**
 * @param {Chart} chart
 * @param {LineAnnotationOptions} options
 * @returns {AnnotationBoxModel}
 */ function $0fa34b70ef8520fb$var$resolveLineProperties(chart, options) {
    const { scales: scales, chartArea: chartArea } = chart;
    const scale = scales[options.scaleID];
    const area = {
        x: chartArea.left,
        y: chartArea.top,
        x2: chartArea.right,
        y2: chartArea.bottom
    };
    if (scale) $0fa34b70ef8520fb$var$resolveFullLineProperties(scale, area, options);
    else $0fa34b70ef8520fb$var$resolveLimitedLineProperties(scales, area, options);
    return area;
}
/**
 * @param {Chart} chart
 * @param {CoreAnnotationOptions} options
 * @param {boolean} [centerBased=false]
 * @returns {AnnotationBoxModel}
 */ function $0fa34b70ef8520fb$var$resolveBoxAndLabelProperties(chart, options) {
    const properties = $0fa34b70ef8520fb$var$resolveBoxProperties(chart, options);
    properties.initProperties = $0fa34b70ef8520fb$var$initAnimationProperties(chart, properties, options);
    properties.elements = [
        {
            type: 'label',
            optionScope: 'label',
            properties: $0fa34b70ef8520fb$var$resolveLabelElementProperties$1(chart, properties, options),
            initProperties: properties.initProperties
        }
    ];
    return properties;
}
function $0fa34b70ef8520fb$var$getChartCircle(chart, options) {
    const point = $0fa34b70ef8520fb$var$getChartPoint(chart, options);
    const size = options.radius * 2;
    return {
        x: point.x - options.radius + options.xAdjust,
        y: point.y - options.radius + options.yAdjust,
        x2: point.x + options.radius + options.xAdjust,
        y2: point.y + options.radius + options.yAdjust,
        centerX: point.x + options.xAdjust,
        centerY: point.y + options.yAdjust,
        radius: options.radius,
        width: size,
        height: size
    };
}
function $0fa34b70ef8520fb$var$getChartDimensionByScale(scale, options) {
    const result = $0fa34b70ef8520fb$var$getDimensionByScale(scale, options) || options;
    return {
        start: Math.min(result.start, result.end),
        end: Math.max(result.start, result.end)
    };
}
function $0fa34b70ef8520fb$var$resolveFullLineProperties(scale, area, options) {
    const min = $0fa34b70ef8520fb$var$scaleValue(scale, options.value, NaN);
    const max = $0fa34b70ef8520fb$var$scaleValue(scale, options.endValue, min);
    if (scale.isHorizontal()) {
        area.x = min;
        area.x2 = max;
    } else {
        area.y = min;
        area.y2 = max;
    }
}
function $0fa34b70ef8520fb$var$resolveLimitedLineProperties(scales, area, options) {
    for (const scaleId of Object.keys($0fa34b70ef8520fb$var$limitedLineScale)){
        const scale = scales[$0fa34b70ef8520fb$var$retrieveScaleID(scales, options, scaleId)];
        if (scale) {
            const { min: min, max: max, start: start, end: end, startProp: startProp, endProp: endProp } = $0fa34b70ef8520fb$var$limitedLineScale[scaleId];
            const dim = $0fa34b70ef8520fb$var$getDimensionByScale(scale, {
                min: options[min],
                max: options[max],
                start: scale[start],
                end: scale[end]
            });
            area[startProp] = dim.start;
            area[endProp] = dim.end;
        }
    }
}
function $0fa34b70ef8520fb$var$calculateX({ properties: properties, options: options }, labelSize, position, padding) {
    const { x: start, x2: end, width: size } = properties;
    return $0fa34b70ef8520fb$var$calculatePosition({
        start: start,
        end: end,
        size: size,
        borderWidth: options.borderWidth
    }, {
        position: position.x,
        padding: {
            start: padding.left,
            end: padding.right
        },
        adjust: options.label.xAdjust,
        size: labelSize.width
    });
}
function $0fa34b70ef8520fb$var$calculateY({ properties: properties, options: options }, labelSize, position, padding) {
    const { y: start, y2: end, height: size } = properties;
    return $0fa34b70ef8520fb$var$calculatePosition({
        start: start,
        end: end,
        size: size,
        borderWidth: options.borderWidth
    }, {
        position: position.y,
        padding: {
            start: padding.top,
            end: padding.bottom
        },
        adjust: options.label.yAdjust,
        size: labelSize.height
    });
}
function $0fa34b70ef8520fb$var$calculatePosition(boxOpts, labelOpts) {
    const { start: start, end: end, borderWidth: borderWidth } = boxOpts;
    const { position: position, padding: { start: padStart, end: padEnd }, adjust: adjust } = labelOpts;
    const availableSize = end - borderWidth - start - padStart - padEnd - labelOpts.size;
    return start + borderWidth / 2 + adjust + $0fa34b70ef8520fb$var$getRelativePosition(availableSize, position);
}
function $0fa34b70ef8520fb$var$resolveLabelElementProperties$1(chart, properties, options) {
    const label = options.label;
    label.backgroundColor = 'transparent';
    label.callout.display = false;
    const position = $0fa34b70ef8520fb$var$toPosition(label.position);
    const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(label.padding);
    const labelSize = $0fa34b70ef8520fb$var$measureLabelSize(chart.ctx, label);
    const x = $0fa34b70ef8520fb$var$calculateX({
        properties: properties,
        options: options
    }, labelSize, position, padding);
    const y = $0fa34b70ef8520fb$var$calculateY({
        properties: properties,
        options: options
    }, labelSize, position, padding);
    const width = labelSize.width + padding.width;
    const height = labelSize.height + padding.height;
    return {
        x: x,
        y: y,
        x2: x + width,
        y2: y + height,
        width: width,
        height: height,
        centerX: x + width / 2,
        centerY: y + height / 2,
        rotation: label.rotation
    };
}
const $0fa34b70ef8520fb$var$moveHooks = [
    'enter',
    'leave'
];
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import('../../types/options').AnnotationPluginOptions } AnnotationPluginOptions
 */ const $0fa34b70ef8520fb$var$eventHooks = $0fa34b70ef8520fb$var$moveHooks.concat('click');
/**
 * @param {Chart} chart
 * @param {Object} state
 * @param {AnnotationPluginOptions} options
 */ function $0fa34b70ef8520fb$var$updateListeners(chart, state, options) {
    state.listened = $0fa34b70ef8520fb$var$loadHooks(options, $0fa34b70ef8520fb$var$eventHooks, state.listeners);
    state.moveListened = false;
    $0fa34b70ef8520fb$var$moveHooks.forEach((hook)=>{
        if ((0, $054bf7af52f034b6$export$a93c5207d687da10)(options[hook])) state.moveListened = true;
    });
    if (!state.listened || !state.moveListened) state.annotations.forEach((scope)=>{
        if (!state.listened && (0, $054bf7af52f034b6$export$a93c5207d687da10)(scope.click)) state.listened = true;
        if (!state.moveListened) $0fa34b70ef8520fb$var$moveHooks.forEach((hook)=>{
            if ((0, $054bf7af52f034b6$export$a93c5207d687da10)(scope[hook])) {
                state.listened = true;
                state.moveListened = true;
            }
        });
    });
}
/**
 * @param {Object} state
 * @param {ChartEvent} event
 * @param {AnnotationPluginOptions} options
 * @return {boolean|undefined}
 */ function $0fa34b70ef8520fb$var$handleEvent(state, event, options) {
    if (state.listened) switch(event.type){
        case 'mousemove':
        case 'mouseout':
            return $0fa34b70ef8520fb$var$handleMoveEvents(state, event, options);
        case 'click':
            return $0fa34b70ef8520fb$var$handleClickEvents(state, event, options);
    }
}
function $0fa34b70ef8520fb$var$handleMoveEvents(state, event, options) {
    if (!state.moveListened) return;
    let elements;
    if (event.type === 'mousemove') elements = $0fa34b70ef8520fb$var$getElements(state.visibleElements, event, options.interaction);
    else elements = [];
    const previous = state.hovered;
    state.hovered = elements;
    const context = {
        state: state,
        event: event
    };
    let changed = $0fa34b70ef8520fb$var$dispatchMoveEvents(context, 'leave', previous, elements);
    return $0fa34b70ef8520fb$var$dispatchMoveEvents(context, 'enter', elements, previous) || changed;
}
function $0fa34b70ef8520fb$var$dispatchMoveEvents({ state: state, event: event }, hook, elements, checkElements) {
    let changed;
    for (const element of elements)if (checkElements.indexOf(element) < 0) changed = $0fa34b70ef8520fb$var$dispatchEvent(element.options[hook] || state.listeners[hook], element, event) || changed;
    return changed;
}
function $0fa34b70ef8520fb$var$handleClickEvents(state, event, options) {
    const listeners = state.listeners;
    const elements = $0fa34b70ef8520fb$var$getElements(state.visibleElements, event, options.interaction);
    let changed;
    for (const element of elements)changed = $0fa34b70ef8520fb$var$dispatchEvent(element.options.click || listeners.click, element, event) || changed;
    return changed;
}
function $0fa34b70ef8520fb$var$dispatchEvent(handler, element, event) {
    return (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(handler, [
        element.$context,
        event
    ]) === true;
}
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import('../../types/options').AnnotationPluginOptions } AnnotationPluginOptions
 * @typedef { import('../../types/element').AnnotationElement } AnnotationElement
 */ const $0fa34b70ef8520fb$var$elementHooks = [
    'afterDraw',
    'beforeDraw'
];
/**
 * @param {Chart} chart
 * @param {Object} state
 * @param {AnnotationPluginOptions} options
 */ function $0fa34b70ef8520fb$var$updateHooks(chart, state, options) {
    const visibleElements = state.visibleElements;
    state.hooked = $0fa34b70ef8520fb$var$loadHooks(options, $0fa34b70ef8520fb$var$elementHooks, state.hooks);
    if (!state.hooked) visibleElements.forEach((scope)=>{
        if (!state.hooked) $0fa34b70ef8520fb$var$elementHooks.forEach((hook)=>{
            if ((0, $054bf7af52f034b6$export$a93c5207d687da10)(scope.options[hook])) state.hooked = true;
        });
    });
}
/**
 * @param {Object} state
 * @param {AnnotationElement} element
 * @param {string} hook
 */ function $0fa34b70ef8520fb$var$invokeHook(state, element, hook) {
    if (state.hooked) {
        const callbackHook = element.options[hook] || state.hooks[hook];
        return (0, $054bf7af52f034b6$export$3722cfe417b6ed86)(callbackHook, [
            element.$context
        ]);
    }
}
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import("chart.js").Scale } Scale
 * @typedef { import('../../types/options').CoreAnnotationOptions } CoreAnnotationOptions
 */ /**
 * @param {Chart} chart
 * @param {Scale} scale
 * @param {CoreAnnotationOptions[]} annotations
 */ function $0fa34b70ef8520fb$var$adjustScaleRange(chart, scale, annotations) {
    const range = $0fa34b70ef8520fb$var$getScaleLimits(chart.scales, scale, annotations);
    let changed = $0fa34b70ef8520fb$var$changeScaleLimit(scale, range, 'min', 'suggestedMin');
    changed = $0fa34b70ef8520fb$var$changeScaleLimit(scale, range, 'max', 'suggestedMax') || changed;
    if (changed && (0, $054bf7af52f034b6$export$a93c5207d687da10)(scale.handleTickRangeOptions)) scale.handleTickRangeOptions();
}
/**
 * @param {CoreAnnotationOptions[]} annotations
 * @param {{ [key: string]: Scale }} scales
 */ function $0fa34b70ef8520fb$var$verifyScaleOptions(annotations, scales) {
    for (const annotation of annotations)$0fa34b70ef8520fb$var$verifyScaleIDs(annotation, scales);
}
function $0fa34b70ef8520fb$var$changeScaleLimit(scale, range, limit, suggestedLimit) {
    if ((0, $054bf7af52f034b6$export$39b482c5e57630a8)(range[limit]) && !$0fa34b70ef8520fb$var$scaleLimitDefined(scale.options, limit, suggestedLimit)) {
        const changed = scale[limit] !== range[limit];
        scale[limit] = range[limit];
        return changed;
    }
}
function $0fa34b70ef8520fb$var$scaleLimitDefined(scaleOptions, limit, suggestedLimit) {
    return (0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(scaleOptions[limit]) || (0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(scaleOptions[suggestedLimit]);
}
function $0fa34b70ef8520fb$var$verifyScaleIDs(annotation, scales) {
    for (const key of [
        'scaleID',
        'xScaleID',
        'yScaleID'
    ]){
        const scaleID = $0fa34b70ef8520fb$var$retrieveScaleID(scales, annotation, key);
        if (scaleID && !scales[scaleID] && $0fa34b70ef8520fb$var$verifyProperties(annotation, key)) console.warn(`No scale found with id '${scaleID}' for annotation '${annotation.id}'`);
    }
}
function $0fa34b70ef8520fb$var$verifyProperties(annotation, key) {
    if (key === 'scaleID') return true;
    const axis = key.charAt(0);
    for (const prop of [
        'Min',
        'Max',
        'Value'
    ]){
        if ((0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(annotation[axis + prop])) return true;
    }
    return false;
}
function $0fa34b70ef8520fb$var$getScaleLimits(scales, scale, annotations) {
    const axis = scale.axis;
    const scaleID = scale.id;
    const scaleIDOption = axis + 'ScaleID';
    const limits = {
        min: (0, $054bf7af52f034b6$export$90a7f3efeed30595)(scale.min, Number.NEGATIVE_INFINITY),
        max: (0, $054bf7af52f034b6$export$90a7f3efeed30595)(scale.max, Number.POSITIVE_INFINITY)
    };
    for (const annotation of annotations){
        if (annotation.scaleID === scaleID) $0fa34b70ef8520fb$var$updateLimits(annotation, scale, [
            'value',
            'endValue'
        ], limits);
        else if ($0fa34b70ef8520fb$var$retrieveScaleID(scales, annotation, scaleIDOption) === scaleID) $0fa34b70ef8520fb$var$updateLimits(annotation, scale, [
            axis + 'Min',
            axis + 'Max',
            axis + 'Value'
        ], limits);
    }
    return limits;
}
function $0fa34b70ef8520fb$var$updateLimits(annotation, scale, props, limits) {
    for (const prop of props){
        const raw = annotation[prop];
        if ((0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(raw)) {
            const value = scale.parse(raw);
            limits.min = Math.min(limits.min, value);
            limits.max = Math.max(limits.max, value);
        }
    }
}
class $0fa34b70ef8520fb$var$BoxAnnotation extends (0, $352a79de3bee5462$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const { x: x, y: y } = $0fa34b70ef8520fb$var$rotated({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), (0, $054bf7af52f034b6$export$625550452a3fa3ec)(-this.options.rotation));
        return $0fa34b70ef8520fb$var$inBoxRange({
            x: x,
            y: y
        }, this.getProps([
            'x',
            'y',
            'x2',
            'y2'
        ], useFinalPosition), axis, this.options);
    }
    getCenterPoint(useFinalPosition) {
        return $0fa34b70ef8520fb$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        ctx.save();
        $0fa34b70ef8520fb$var$translate(ctx, this.getCenterPoint(), this.options.rotation);
        $0fa34b70ef8520fb$var$drawBox(ctx, this, this.options);
        ctx.restore();
    }
    get label() {
        return this.elements && this.elements[0];
    }
    resolveElementProperties(chart, options) {
        return $0fa34b70ef8520fb$var$resolveBoxAndLabelProperties(chart, options);
    }
}
$0fa34b70ef8520fb$var$BoxAnnotation.id = 'boxAnnotation';
$0fa34b70ef8520fb$var$BoxAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundShadowColor: 'transparent',
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderRadius: 0,
    borderShadowColor: 'transparent',
    borderWidth: 1,
    display: true,
    init: undefined,
    hitTolerance: 0,
    label: {
        backgroundColor: 'transparent',
        borderWidth: 0,
        callout: {
            display: false
        },
        color: 'black',
        content: null,
        display: false,
        drawTime: undefined,
        font: {
            family: undefined,
            lineHeight: undefined,
            size: undefined,
            style: undefined,
            weight: 'bold'
        },
        height: undefined,
        hitTolerance: undefined,
        opacity: undefined,
        padding: 6,
        position: 'center',
        rotation: undefined,
        textAlign: 'start',
        textStrokeColor: undefined,
        textStrokeWidth: 0,
        width: undefined,
        xAdjust: 0,
        yAdjust: 0,
        z: undefined
    },
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    z: 0
};
$0fa34b70ef8520fb$var$BoxAnnotation.defaultRoutes = {
    borderColor: 'color',
    backgroundColor: 'color'
};
$0fa34b70ef8520fb$var$BoxAnnotation.descriptors = {
    label: {
        _fallback: true
    }
};
class $0fa34b70ef8520fb$var$DoughnutLabelAnnotation extends (0, $352a79de3bee5462$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        return $0fa34b70ef8520fb$var$inLabelRange({
            x: mouseX,
            y: mouseY
        }, {
            rect: this.getProps([
                'x',
                'y',
                'x2',
                'y2'
            ], useFinalPosition),
            center: this.getCenterPoint(useFinalPosition)
        }, axis, {
            rotation: this.rotation,
            borderWidth: 0,
            hitTolerance: this.options.hitTolerance
        });
    }
    getCenterPoint(useFinalPosition) {
        return $0fa34b70ef8520fb$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const options = this.options;
        if (!options.display || !options.content) return;
        $0fa34b70ef8520fb$var$drawBackground(ctx, this);
        ctx.save();
        $0fa34b70ef8520fb$var$translate(ctx, this.getCenterPoint(), this.rotation);
        $0fa34b70ef8520fb$var$drawLabel(ctx, this, options, this._fitRatio);
        ctx.restore();
    }
    resolveElementProperties(chart, options) {
        const meta = $0fa34b70ef8520fb$var$getDatasetMeta(chart, options);
        if (!meta) return {};
        const { controllerMeta: controllerMeta, point: point, radius: radius } = $0fa34b70ef8520fb$var$getControllerMeta(chart, options, meta);
        let labelSize = $0fa34b70ef8520fb$var$measureLabelSize(chart.ctx, options);
        const _fitRatio = $0fa34b70ef8520fb$var$getFitRatio(labelSize, radius);
        if ($0fa34b70ef8520fb$var$shouldFit(options, _fitRatio)) labelSize = {
            width: labelSize.width * _fitRatio,
            height: labelSize.height * _fitRatio
        };
        const { position: position, xAdjust: xAdjust, yAdjust: yAdjust } = options;
        const boxSize = $0fa34b70ef8520fb$var$measureLabelRectangle(point, labelSize, {
            borderWidth: 0,
            position: position,
            xAdjust: xAdjust,
            yAdjust: yAdjust
        });
        return {
            initProperties: $0fa34b70ef8520fb$var$initAnimationProperties(chart, boxSize, options),
            ...boxSize,
            ...controllerMeta,
            rotation: options.rotation,
            _fitRatio: _fitRatio
        };
    }
}
$0fa34b70ef8520fb$var$DoughnutLabelAnnotation.id = 'doughnutLabelAnnotation';
$0fa34b70ef8520fb$var$DoughnutLabelAnnotation.defaults = {
    autoFit: true,
    autoHide: true,
    backgroundColor: 'transparent',
    backgroundShadowColor: 'transparent',
    borderColor: 'transparent',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderShadowColor: 'transparent',
    borderWidth: 0,
    color: 'black',
    content: null,
    display: true,
    font: {
        family: undefined,
        lineHeight: undefined,
        size: undefined,
        style: undefined,
        weight: undefined
    },
    height: undefined,
    hitTolerance: 0,
    init: undefined,
    opacity: undefined,
    position: 'center',
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    spacing: 1,
    textAlign: 'center',
    textStrokeColor: undefined,
    textStrokeWidth: 0,
    width: undefined,
    xAdjust: 0,
    yAdjust: 0
};
$0fa34b70ef8520fb$var$DoughnutLabelAnnotation.defaultRoutes = {};
function $0fa34b70ef8520fb$var$getDatasetMeta(chart, options) {
    return chart.getSortedVisibleDatasetMetas().reduce(function(result, value) {
        const controller = value.controller;
        if (controller instanceof (0, $352a79de3bee5462$export$e04603e7d8b77172) && $0fa34b70ef8520fb$var$isControllerVisible(chart, options, value.data) && (!result || controller.innerRadius < result.controller.innerRadius) && controller.options.circumference >= 90) return value;
        return result;
    }, undefined);
}
function $0fa34b70ef8520fb$var$isControllerVisible(chart, options, elements) {
    if (!options.autoHide) return true;
    for(let i = 0; i < elements.length; i++){
        if (!elements[i].hidden && chart.getDataVisibility(i)) return true;
    }
}
function $0fa34b70ef8520fb$var$getControllerMeta({ chartArea: chartArea }, options, meta) {
    const { left: left, top: top, right: right, bottom: bottom } = chartArea;
    const { innerRadius: innerRadius, offsetX: offsetX, offsetY: offsetY } = meta.controller;
    const x = (left + right) / 2 + offsetX;
    const y = (top + bottom) / 2 + offsetY;
    const square = {
        left: Math.max(x - innerRadius, left),
        right: Math.min(x + innerRadius, right),
        top: Math.max(y - innerRadius, top),
        bottom: Math.min(y + innerRadius, bottom)
    };
    const point = {
        x: (square.left + square.right) / 2,
        y: (square.top + square.bottom) / 2
    };
    const space = options.spacing + options.borderWidth / 2;
    const _radius = innerRadius - space;
    const _counterclockwise = point.y > y;
    const side = _counterclockwise ? top + space : bottom - space;
    const angles = $0fa34b70ef8520fb$var$getAngles(side, x, y, _radius);
    const controllerMeta = {
        _centerX: x,
        _centerY: y,
        _radius: _radius,
        _counterclockwise: _counterclockwise,
        ...angles
    };
    return {
        controllerMeta: controllerMeta,
        point: point,
        radius: Math.min(innerRadius, Math.min(square.right - square.left, square.bottom - square.top) / 2)
    };
}
function $0fa34b70ef8520fb$var$getFitRatio({ width: width, height: height }, radius) {
    const hypo = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
    return radius * 2 / hypo;
}
function $0fa34b70ef8520fb$var$getAngles(y, centerX, centerY, radius) {
    const yk2 = Math.pow(centerY - y, 2);
    const r2 = Math.pow(radius, 2);
    const b = centerX * -2;
    const c = Math.pow(centerX, 2) + yk2 - r2;
    const delta = Math.pow(b, 2) - 4 * c;
    if (delta <= 0) return {
        _startAngle: 0,
        _endAngle: (0, $054bf7af52f034b6$export$971d5caa766a69d7)
    };
    const start = (-b - Math.sqrt(delta)) / 2;
    const end = (-b + Math.sqrt(delta)) / 2;
    return {
        _startAngle: (0, $054bf7af52f034b6$export$96f57966bedc81b4)({
            x: centerX,
            y: centerY
        }, {
            x: start,
            y: y
        }).angle,
        _endAngle: (0, $054bf7af52f034b6$export$96f57966bedc81b4)({
            x: centerX,
            y: centerY
        }, {
            x: end,
            y: y
        }).angle
    };
}
function $0fa34b70ef8520fb$var$drawBackground(ctx, element) {
    const { _centerX: _centerX, _centerY: _centerY, _radius: _radius, _startAngle: _startAngle, _endAngle: _endAngle, _counterclockwise: _counterclockwise, options: options } = element;
    ctx.save();
    const stroke = $0fa34b70ef8520fb$var$setBorderStyle(ctx, options);
    ctx.fillStyle = options.backgroundColor;
    ctx.beginPath();
    ctx.arc(_centerX, _centerY, _radius, _startAngle, _endAngle, _counterclockwise);
    ctx.closePath();
    ctx.fill();
    if (stroke) ctx.stroke();
    ctx.restore();
}
class $0fa34b70ef8520fb$var$LabelAnnotation extends (0, $352a79de3bee5462$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        return $0fa34b70ef8520fb$var$inLabelRange({
            x: mouseX,
            y: mouseY
        }, {
            rect: this.getProps([
                'x',
                'y',
                'x2',
                'y2'
            ], useFinalPosition),
            center: this.getCenterPoint(useFinalPosition)
        }, axis, {
            rotation: this.rotation,
            borderWidth: this.options.borderWidth,
            hitTolerance: this.options.hitTolerance
        });
    }
    getCenterPoint(useFinalPosition) {
        return $0fa34b70ef8520fb$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const options = this.options;
        const visible = !(0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(this._visible) || this._visible;
        if (!options.display || !options.content || !visible) return;
        ctx.save();
        $0fa34b70ef8520fb$var$translate(ctx, this.getCenterPoint(), this.rotation);
        $0fa34b70ef8520fb$var$drawCallout(ctx, this);
        $0fa34b70ef8520fb$var$drawBox(ctx, this, options);
        $0fa34b70ef8520fb$var$drawLabel(ctx, $0fa34b70ef8520fb$var$getLabelSize(this), options);
        ctx.restore();
    }
    resolveElementProperties(chart, options) {
        let point;
        if (!$0fa34b70ef8520fb$var$isBoundToPoint(options)) {
            const { centerX: centerX, centerY: centerY } = $0fa34b70ef8520fb$var$resolveBoxProperties(chart, options);
            point = {
                x: centerX,
                y: centerY
            };
        } else point = $0fa34b70ef8520fb$var$getChartPoint(chart, options);
        const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(options.padding);
        const labelSize = $0fa34b70ef8520fb$var$measureLabelSize(chart.ctx, options);
        const boxSize = $0fa34b70ef8520fb$var$measureLabelRectangle(point, labelSize, options, padding);
        return {
            initProperties: $0fa34b70ef8520fb$var$initAnimationProperties(chart, boxSize, options),
            pointX: point.x,
            pointY: point.y,
            ...boxSize,
            rotation: options.rotation
        };
    }
}
$0fa34b70ef8520fb$var$LabelAnnotation.id = 'labelAnnotation';
$0fa34b70ef8520fb$var$LabelAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundColor: 'transparent',
    backgroundShadowColor: 'transparent',
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderRadius: 0,
    borderShadowColor: 'transparent',
    borderWidth: 0,
    callout: {
        borderCapStyle: 'butt',
        borderColor: undefined,
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 1,
        display: false,
        margin: 5,
        position: 'auto',
        side: 5,
        start: '50%'
    },
    color: 'black',
    content: null,
    display: true,
    font: {
        family: undefined,
        lineHeight: undefined,
        size: undefined,
        style: undefined,
        weight: undefined
    },
    height: undefined,
    hitTolerance: 0,
    init: undefined,
    opacity: undefined,
    padding: 6,
    position: 'center',
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    textAlign: 'center',
    textStrokeColor: undefined,
    textStrokeWidth: 0,
    width: undefined,
    xAdjust: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    xValue: undefined,
    yAdjust: 0,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    yValue: undefined,
    z: 0
};
$0fa34b70ef8520fb$var$LabelAnnotation.defaultRoutes = {
    borderColor: 'color'
};
function $0fa34b70ef8520fb$var$getLabelSize({ x: x, y: y, width: width, height: height, options: options }) {
    const hBorderWidth = options.borderWidth / 2;
    const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(options.padding);
    return {
        x: x + padding.left + hBorderWidth,
        y: y + padding.top + hBorderWidth,
        width: width - padding.left - padding.right - options.borderWidth,
        height: height - padding.top - padding.bottom - options.borderWidth
    };
}
const $0fa34b70ef8520fb$var$pointInLine = (p1, p2, t)=>({
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    });
const $0fa34b70ef8520fb$var$interpolateX = (y, p1, p2)=>$0fa34b70ef8520fb$var$pointInLine(p1, p2, Math.abs((y - p1.y) / (p2.y - p1.y))).x;
const $0fa34b70ef8520fb$var$interpolateY = (x, p1, p2)=>$0fa34b70ef8520fb$var$pointInLine(p1, p2, Math.abs((x - p1.x) / (p2.x - p1.x))).y;
const $0fa34b70ef8520fb$var$sqr = (v)=>v * v;
const $0fa34b70ef8520fb$var$rangeLimit = (mouseX, mouseY, { x: x, y: y, x2: x2, y2: y2 }, axis)=>axis === 'y' ? {
        start: Math.min(y, y2),
        end: Math.max(y, y2),
        value: mouseY
    } : {
        start: Math.min(x, x2),
        end: Math.max(x, x2),
        value: mouseX
    };
// http://www.independent-software.com/determining-coordinates-on-a-html-canvas-bezier-curve.html
const $0fa34b70ef8520fb$var$coordInCurve = (start, cp, end, t)=>(1 - t) * (1 - t) * start + 2 * (1 - t) * t * cp + t * t * end;
const $0fa34b70ef8520fb$var$pointInCurve = (start, cp, end, t)=>({
        x: $0fa34b70ef8520fb$var$coordInCurve(start.x, cp.x, end.x, t),
        y: $0fa34b70ef8520fb$var$coordInCurve(start.y, cp.y, end.y, t)
    });
const $0fa34b70ef8520fb$var$coordAngleInCurve = (start, cp, end, t)=>2 * (1 - t) * (cp - start) + 2 * t * (end - cp);
const $0fa34b70ef8520fb$var$angleInCurve = (start, cp, end, t)=>-Math.atan2($0fa34b70ef8520fb$var$coordAngleInCurve(start.x, cp.x, end.x, t), $0fa34b70ef8520fb$var$coordAngleInCurve(start.y, cp.y, end.y, t)) + 0.5 * (0, $054bf7af52f034b6$export$56c0d5a1e737357d);
class $0fa34b70ef8520fb$var$LineAnnotation extends (0, $352a79de3bee5462$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const hitSize = (this.options.borderWidth + this.options.hitTolerance) / 2;
        if (axis !== 'x' && axis !== 'y') {
            const point = {
                mouseX: mouseX,
                mouseY: mouseY
            };
            const { path: path, ctx: ctx } = this;
            if (path) {
                $0fa34b70ef8520fb$var$setBorderStyle(ctx, this.options);
                ctx.lineWidth += this.options.hitTolerance;
                const { chart: chart } = this.$context;
                const mx = mouseX * chart.currentDevicePixelRatio;
                const my = mouseY * chart.currentDevicePixelRatio;
                const result = ctx.isPointInStroke(path, mx, my) || $0fa34b70ef8520fb$var$isOnLabel(this, point, useFinalPosition);
                ctx.restore();
                return result;
            }
            const epsilon = $0fa34b70ef8520fb$var$sqr(hitSize);
            return $0fa34b70ef8520fb$var$intersects(this, point, epsilon, useFinalPosition) || $0fa34b70ef8520fb$var$isOnLabel(this, point, useFinalPosition);
        }
        return $0fa34b70ef8520fb$var$inAxisRange(this, {
            mouseX: mouseX,
            mouseY: mouseY
        }, axis, {
            hitSize: hitSize,
            useFinalPosition: useFinalPosition
        });
    }
    getCenterPoint(useFinalPosition) {
        return $0fa34b70ef8520fb$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const { x: x, y: y, x2: x2, y2: y2, cp: cp, options: options } = this;
        ctx.save();
        if (!$0fa34b70ef8520fb$var$setBorderStyle(ctx, options)) // no border width, then line is not drawn
        return ctx.restore();
        $0fa34b70ef8520fb$var$setShadowStyle(ctx, options);
        const length = Math.sqrt(Math.pow(x2 - x, 2) + Math.pow(y2 - y, 2));
        if (options.curve && cp) {
            $0fa34b70ef8520fb$var$drawCurve(ctx, this, cp, length);
            return ctx.restore();
        }
        const { startOpts: startOpts, endOpts: endOpts, startAdjust: startAdjust, endAdjust: endAdjust } = $0fa34b70ef8520fb$var$getArrowHeads(this);
        const angle = Math.atan2(y2 - y, x2 - x);
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.beginPath();
        ctx.moveTo(0 + startAdjust, 0);
        ctx.lineTo(length - endAdjust, 0);
        ctx.shadowColor = options.borderShadowColor;
        ctx.stroke();
        $0fa34b70ef8520fb$var$drawArrowHead(ctx, 0, startAdjust, startOpts);
        $0fa34b70ef8520fb$var$drawArrowHead(ctx, length, -endAdjust, endOpts);
        ctx.restore();
    }
    get label() {
        return this.elements && this.elements[0];
    }
    resolveElementProperties(chart, options) {
        const area = $0fa34b70ef8520fb$var$resolveLineProperties(chart, options);
        const { x: x, y: y, x2: x2, y2: y2 } = area;
        const inside = $0fa34b70ef8520fb$var$isLineInArea(area, chart.chartArea);
        const properties = inside ? $0fa34b70ef8520fb$var$limitLineToArea({
            x: x,
            y: y
        }, {
            x: x2,
            y: y2
        }, chart.chartArea) : {
            x: x,
            y: y,
            x2: x2,
            y2: y2,
            width: Math.abs(x2 - x),
            height: Math.abs(y2 - y)
        };
        properties.centerX = (x2 + x) / 2;
        properties.centerY = (y2 + y) / 2;
        properties.initProperties = $0fa34b70ef8520fb$var$initAnimationProperties(chart, properties, options);
        if (options.curve) {
            const p1 = {
                x: properties.x,
                y: properties.y
            };
            const p2 = {
                x: properties.x2,
                y: properties.y2
            };
            properties.cp = $0fa34b70ef8520fb$var$getControlPoint(properties, options, (0, $054bf7af52f034b6$export$158acd800e1ef08b)(p1, p2));
        }
        const labelProperties = $0fa34b70ef8520fb$var$resolveLabelElementProperties(chart, properties, options.label);
        // additonal prop to manage zoom/pan
        labelProperties._visible = inside;
        properties.elements = [
            {
                type: 'label',
                optionScope: 'label',
                properties: labelProperties,
                initProperties: properties.initProperties
            }
        ];
        return properties;
    }
}
$0fa34b70ef8520fb$var$LineAnnotation.id = 'lineAnnotation';
const $0fa34b70ef8520fb$var$arrowHeadsDefaults = {
    backgroundColor: undefined,
    backgroundShadowColor: undefined,
    borderColor: undefined,
    borderDash: undefined,
    borderDashOffset: undefined,
    borderShadowColor: undefined,
    borderWidth: undefined,
    display: undefined,
    fill: undefined,
    length: undefined,
    shadowBlur: undefined,
    shadowOffsetX: undefined,
    shadowOffsetY: undefined,
    width: undefined
};
$0fa34b70ef8520fb$var$LineAnnotation.defaults = {
    adjustScaleRange: true,
    arrowHeads: {
        display: false,
        end: Object.assign({}, $0fa34b70ef8520fb$var$arrowHeadsDefaults),
        fill: false,
        length: 12,
        start: Object.assign({}, $0fa34b70ef8520fb$var$arrowHeadsDefaults),
        width: 6
    },
    borderDash: [],
    borderDashOffset: 0,
    borderShadowColor: 'transparent',
    borderWidth: 2,
    curve: false,
    controlPoint: {
        y: '-50%'
    },
    display: true,
    endValue: undefined,
    init: undefined,
    hitTolerance: 0,
    label: {
        backgroundColor: 'rgba(0,0,0,0.8)',
        backgroundShadowColor: 'transparent',
        borderCapStyle: 'butt',
        borderColor: 'black',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderRadius: 6,
        borderShadowColor: 'transparent',
        borderWidth: 0,
        callout: Object.assign({}, $0fa34b70ef8520fb$var$LabelAnnotation.defaults.callout),
        color: '#fff',
        content: null,
        display: false,
        drawTime: undefined,
        font: {
            family: undefined,
            lineHeight: undefined,
            size: undefined,
            style: undefined,
            weight: 'bold'
        },
        height: undefined,
        hitTolerance: undefined,
        opacity: undefined,
        padding: 6,
        position: 'center',
        rotation: 0,
        shadowBlur: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        textAlign: 'center',
        textStrokeColor: undefined,
        textStrokeWidth: 0,
        width: undefined,
        xAdjust: 0,
        yAdjust: 0,
        z: undefined
    },
    scaleID: undefined,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    value: undefined,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    z: 0
};
$0fa34b70ef8520fb$var$LineAnnotation.descriptors = {
    arrowHeads: {
        start: {
            _fallback: true
        },
        end: {
            _fallback: true
        },
        _fallback: true
    }
};
$0fa34b70ef8520fb$var$LineAnnotation.defaultRoutes = {
    borderColor: 'color'
};
function $0fa34b70ef8520fb$var$inAxisRange(element, { mouseX: mouseX, mouseY: mouseY }, axis, { hitSize: hitSize, useFinalPosition: useFinalPosition }) {
    const limit = $0fa34b70ef8520fb$var$rangeLimit(mouseX, mouseY, element.getProps([
        'x',
        'y',
        'x2',
        'y2'
    ], useFinalPosition), axis);
    return $0fa34b70ef8520fb$var$inLimit(limit, hitSize) || $0fa34b70ef8520fb$var$isOnLabel(element, {
        mouseX: mouseX,
        mouseY: mouseY
    }, useFinalPosition, axis);
}
function $0fa34b70ef8520fb$var$isLineInArea({ x: x, y: y, x2: x2, y2: y2 }, { top: top, right: right, bottom: bottom, left: left }) {
    return !(x < left && x2 < left || x > right && x2 > right || y < top && y2 < top || y > bottom && y2 > bottom);
}
function $0fa34b70ef8520fb$var$limitPointToArea({ x: x, y: y }, p2, { top: top, right: right, bottom: bottom, left: left }) {
    if (x < left) {
        y = $0fa34b70ef8520fb$var$interpolateY(left, {
            x: x,
            y: y
        }, p2);
        x = left;
    }
    if (x > right) {
        y = $0fa34b70ef8520fb$var$interpolateY(right, {
            x: x,
            y: y
        }, p2);
        x = right;
    }
    if (y < top) {
        x = $0fa34b70ef8520fb$var$interpolateX(top, {
            x: x,
            y: y
        }, p2);
        y = top;
    }
    if (y > bottom) {
        x = $0fa34b70ef8520fb$var$interpolateX(bottom, {
            x: x,
            y: y
        }, p2);
        y = bottom;
    }
    return {
        x: x,
        y: y
    };
}
function $0fa34b70ef8520fb$var$limitLineToArea(p1, p2, area) {
    const { x: x, y: y } = $0fa34b70ef8520fb$var$limitPointToArea(p1, p2, area);
    const { x: x2, y: y2 } = $0fa34b70ef8520fb$var$limitPointToArea(p2, p1, area);
    return {
        x: x,
        y: y,
        x2: x2,
        y2: y2,
        width: Math.abs(x2 - x),
        height: Math.abs(y2 - y)
    };
}
function $0fa34b70ef8520fb$var$intersects(element, { mouseX: mouseX, mouseY: mouseY }, epsilon = $0fa34b70ef8520fb$var$EPSILON, useFinalPosition) {
    // Adapted from https://stackoverflow.com/a/6853926/25507
    const { x: x1, y: y1, x2: x2, y2: y2 } = element.getProps([
        'x',
        'y',
        'x2',
        'y2'
    ], useFinalPosition);
    const dx = x2 - x1;
    const dy = y2 - y1;
    const lenSq = $0fa34b70ef8520fb$var$sqr(dx) + $0fa34b70ef8520fb$var$sqr(dy);
    const t = lenSq === 0 ? -1 : ((mouseX - x1) * dx + (mouseY - y1) * dy) / lenSq;
    let xx, yy;
    if (t < 0) {
        xx = x1;
        yy = y1;
    } else if (t > 1) {
        xx = x2;
        yy = y2;
    } else {
        xx = x1 + t * dx;
        yy = y1 + t * dy;
    }
    return $0fa34b70ef8520fb$var$sqr(mouseX - xx) + $0fa34b70ef8520fb$var$sqr(mouseY - yy) <= epsilon;
}
function $0fa34b70ef8520fb$var$isOnLabel(element, { mouseX: mouseX, mouseY: mouseY }, useFinalPosition, axis) {
    const label = element.label;
    return label.options.display && label.inRange(mouseX, mouseY, axis, useFinalPosition);
}
function $0fa34b70ef8520fb$var$resolveLabelElementProperties(chart, properties, options) {
    const borderWidth = options.borderWidth;
    const padding = (0, $054bf7af52f034b6$export$a9c23c6ac3fc3eca)(options.padding);
    const textSize = $0fa34b70ef8520fb$var$measureLabelSize(chart.ctx, options);
    const width = textSize.width + padding.width + borderWidth;
    const height = textSize.height + padding.height + borderWidth;
    return $0fa34b70ef8520fb$var$calculateLabelPosition(properties, options, {
        width: width,
        height: height,
        padding: padding
    }, chart.chartArea);
}
function $0fa34b70ef8520fb$var$calculateAutoRotation(properties) {
    const { x: x, y: y, x2: x2, y2: y2 } = properties;
    const rotation = Math.atan2(y2 - y, x2 - x);
    // Flip the rotation if it goes > PI/2 or < -PI/2, so label stays upright
    return rotation > (0, $054bf7af52f034b6$export$56c0d5a1e737357d) / 2 ? rotation - (0, $054bf7af52f034b6$export$56c0d5a1e737357d) : rotation < (0, $054bf7af52f034b6$export$56c0d5a1e737357d) / -2 ? rotation + (0, $054bf7af52f034b6$export$56c0d5a1e737357d) : rotation;
}
function $0fa34b70ef8520fb$var$calculateLabelPosition(properties, label, sizes, chartArea) {
    const { width: width, height: height, padding: padding } = sizes;
    const { xAdjust: xAdjust, yAdjust: yAdjust } = label;
    const p1 = {
        x: properties.x,
        y: properties.y
    };
    const p2 = {
        x: properties.x2,
        y: properties.y2
    };
    const rotation = label.rotation === 'auto' ? $0fa34b70ef8520fb$var$calculateAutoRotation(properties) : (0, $054bf7af52f034b6$export$625550452a3fa3ec)(label.rotation);
    const size = $0fa34b70ef8520fb$var$rotatedSize(width, height, rotation);
    const t = $0fa34b70ef8520fb$var$calculateT(properties, label, {
        labelSize: size,
        padding: padding
    }, chartArea);
    const pt = properties.cp ? $0fa34b70ef8520fb$var$pointInCurve(p1, properties.cp, p2, t) : $0fa34b70ef8520fb$var$pointInLine(p1, p2, t);
    const xCoordinateSizes = {
        size: size.w,
        min: chartArea.left,
        max: chartArea.right,
        padding: padding.left
    };
    const yCoordinateSizes = {
        size: size.h,
        min: chartArea.top,
        max: chartArea.bottom,
        padding: padding.top
    };
    const centerX = $0fa34b70ef8520fb$var$adjustLabelCoordinate(pt.x, xCoordinateSizes) + xAdjust;
    const centerY = $0fa34b70ef8520fb$var$adjustLabelCoordinate(pt.y, yCoordinateSizes) + yAdjust;
    return {
        x: centerX - width / 2,
        y: centerY - height / 2,
        x2: centerX + width / 2,
        y2: centerY + height / 2,
        centerX: centerX,
        centerY: centerY,
        pointX: pt.x,
        pointY: pt.y,
        width: width,
        height: height,
        rotation: (0, $054bf7af52f034b6$export$3a6d5c9ae78a2c08)(rotation)
    };
}
function $0fa34b70ef8520fb$var$rotatedSize(width, height, rotation) {
    const cos = Math.cos(rotation);
    const sin = Math.sin(rotation);
    return {
        w: Math.abs(width * cos) + Math.abs(height * sin),
        h: Math.abs(width * sin) + Math.abs(height * cos)
    };
}
function $0fa34b70ef8520fb$var$calculateT(properties, label, sizes, chartArea) {
    let t;
    const space = $0fa34b70ef8520fb$var$spaceAround(properties, chartArea);
    if (label.position === 'start') t = $0fa34b70ef8520fb$var$calculateTAdjust({
        w: properties.x2 - properties.x,
        h: properties.y2 - properties.y
    }, sizes, label, space);
    else if (label.position === 'end') t = 1 - $0fa34b70ef8520fb$var$calculateTAdjust({
        w: properties.x - properties.x2,
        h: properties.y - properties.y2
    }, sizes, label, space);
    else t = $0fa34b70ef8520fb$var$getRelativePosition(1, label.position);
    return t;
}
function $0fa34b70ef8520fb$var$calculateTAdjust(lineSize, sizes, label, space) {
    const { labelSize: labelSize, padding: padding } = sizes;
    const lineW = lineSize.w * space.dx;
    const lineH = lineSize.h * space.dy;
    const x = lineW > 0 && (labelSize.w / 2 + padding.left - space.x) / lineW;
    const y = lineH > 0 && (labelSize.h / 2 + padding.top - space.y) / lineH;
    return $0fa34b70ef8520fb$var$clamp(Math.max(x, y), 0, 0.25);
}
function $0fa34b70ef8520fb$var$spaceAround(properties, chartArea) {
    const { x: x, x2: x2, y: y, y2: y2 } = properties;
    const t = Math.min(y, y2) - chartArea.top;
    const l = Math.min(x, x2) - chartArea.left;
    const b = chartArea.bottom - Math.max(y, y2);
    const r = chartArea.right - Math.max(x, x2);
    return {
        x: Math.min(l, r),
        y: Math.min(t, b),
        dx: l <= r ? 1 : -1,
        dy: t <= b ? 1 : -1
    };
}
function $0fa34b70ef8520fb$var$adjustLabelCoordinate(coordinate, labelSizes) {
    const { size: size, min: min, max: max, padding: padding } = labelSizes;
    const halfSize = size / 2;
    if (size > max - min) // if it does not fit, display as much as possible
    return (max + min) / 2;
    if (min >= coordinate - padding - halfSize) coordinate = min + padding + halfSize;
    if (max <= coordinate + padding + halfSize) coordinate = max - padding - halfSize;
    return coordinate;
}
function $0fa34b70ef8520fb$var$getArrowHeads(line) {
    const options = line.options;
    const arrowStartOpts = options.arrowHeads && options.arrowHeads.start;
    const arrowEndOpts = options.arrowHeads && options.arrowHeads.end;
    return {
        startOpts: arrowStartOpts,
        endOpts: arrowEndOpts,
        startAdjust: $0fa34b70ef8520fb$var$getLineAdjust(line, arrowStartOpts),
        endAdjust: $0fa34b70ef8520fb$var$getLineAdjust(line, arrowEndOpts)
    };
}
function $0fa34b70ef8520fb$var$getLineAdjust(line, arrowOpts) {
    if (!arrowOpts || !arrowOpts.display) return 0;
    const { length: length, width: width } = arrowOpts;
    const adjust = line.options.borderWidth / 2;
    const p1 = {
        x: length,
        y: width + adjust
    };
    const p2 = {
        x: 0,
        y: adjust
    };
    return Math.abs($0fa34b70ef8520fb$var$interpolateX(0, p1, p2));
}
function $0fa34b70ef8520fb$var$drawArrowHead(ctx, offset, adjust, arrowOpts) {
    if (!arrowOpts || !arrowOpts.display) return;
    const { length: length, width: width, fill: fill, backgroundColor: backgroundColor, borderColor: borderColor } = arrowOpts;
    const arrowOffsetX = Math.abs(offset - length) + adjust;
    ctx.beginPath();
    $0fa34b70ef8520fb$var$setShadowStyle(ctx, arrowOpts);
    $0fa34b70ef8520fb$var$setBorderStyle(ctx, arrowOpts);
    ctx.moveTo(arrowOffsetX, -width);
    ctx.lineTo(offset + adjust, 0);
    ctx.lineTo(arrowOffsetX, width);
    if (fill === true) {
        ctx.fillStyle = backgroundColor || borderColor;
        ctx.closePath();
        ctx.fill();
        ctx.shadowColor = 'transparent';
    } else ctx.shadowColor = arrowOpts.borderShadowColor;
    ctx.stroke();
}
function $0fa34b70ef8520fb$var$getControlPoint(properties, options, distance) {
    const { x: x, y: y, x2: x2, y2: y2, centerX: centerX, centerY: centerY } = properties;
    const angle = Math.atan2(y2 - y, x2 - x);
    const cp = $0fa34b70ef8520fb$var$toPosition(options.controlPoint, 0);
    const point = {
        x: centerX + $0fa34b70ef8520fb$var$getSize(distance, cp.x, false),
        y: centerY + $0fa34b70ef8520fb$var$getSize(distance, cp.y, false)
    };
    return $0fa34b70ef8520fb$var$rotated(point, {
        x: centerX,
        y: centerY
    }, angle);
}
function $0fa34b70ef8520fb$var$drawArrowHeadOnCurve(ctx, { x: x, y: y }, { angle: angle, adjust: adjust }, arrowOpts) {
    if (!arrowOpts || !arrowOpts.display) return;
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angle);
    $0fa34b70ef8520fb$var$drawArrowHead(ctx, 0, -adjust, arrowOpts);
    ctx.restore();
}
function $0fa34b70ef8520fb$var$drawCurve(ctx, element, cp, length) {
    const { x: x, y: y, x2: x2, y2: y2, options: options } = element;
    const { startOpts: startOpts, endOpts: endOpts, startAdjust: startAdjust, endAdjust: endAdjust } = $0fa34b70ef8520fb$var$getArrowHeads(element);
    const p1 = {
        x: x,
        y: y
    };
    const p2 = {
        x: x2,
        y: y2
    };
    const startAngle = $0fa34b70ef8520fb$var$angleInCurve(p1, cp, p2, 0);
    const endAngle = $0fa34b70ef8520fb$var$angleInCurve(p1, cp, p2, 1) - (0, $054bf7af52f034b6$export$56c0d5a1e737357d);
    const ps = $0fa34b70ef8520fb$var$pointInCurve(p1, cp, p2, startAdjust / length);
    const pe = $0fa34b70ef8520fb$var$pointInCurve(p1, cp, p2, 1 - endAdjust / length);
    const path = new Path2D();
    ctx.beginPath();
    path.moveTo(ps.x, ps.y);
    path.quadraticCurveTo(cp.x, cp.y, pe.x, pe.y);
    ctx.shadowColor = options.borderShadowColor;
    ctx.stroke(path);
    element.path = path;
    element.ctx = ctx;
    $0fa34b70ef8520fb$var$drawArrowHeadOnCurve(ctx, ps, {
        angle: startAngle,
        adjust: startAdjust
    }, startOpts);
    $0fa34b70ef8520fb$var$drawArrowHeadOnCurve(ctx, pe, {
        angle: endAngle,
        adjust: endAdjust
    }, endOpts);
}
class $0fa34b70ef8520fb$var$EllipseAnnotation extends (0, $352a79de3bee5462$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const rotation = this.options.rotation;
        const hitSize = (this.options.borderWidth + this.options.hitTolerance) / 2;
        if (axis !== 'x' && axis !== 'y') return $0fa34b70ef8520fb$var$pointInEllipse({
            x: mouseX,
            y: mouseY
        }, this.getProps([
            'width',
            'height',
            'centerX',
            'centerY'
        ], useFinalPosition), rotation, hitSize);
        const { x: x, y: y, x2: x2, y2: y2 } = this.getProps([
            'x',
            'y',
            'x2',
            'y2'
        ], useFinalPosition);
        const limit = axis === 'y' ? {
            start: y,
            end: y2
        } : {
            start: x,
            end: x2
        };
        const rotatedPoint = $0fa34b70ef8520fb$var$rotated({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), (0, $054bf7af52f034b6$export$625550452a3fa3ec)(-rotation));
        return rotatedPoint[axis] >= limit.start - hitSize - $0fa34b70ef8520fb$var$EPSILON && rotatedPoint[axis] <= limit.end + hitSize + $0fa34b70ef8520fb$var$EPSILON;
    }
    getCenterPoint(useFinalPosition) {
        return $0fa34b70ef8520fb$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const { width: width, height: height, centerX: centerX, centerY: centerY, options: options } = this;
        ctx.save();
        $0fa34b70ef8520fb$var$translate(ctx, this.getCenterPoint(), options.rotation);
        $0fa34b70ef8520fb$var$setShadowStyle(ctx, this.options);
        ctx.beginPath();
        ctx.fillStyle = options.backgroundColor;
        const stroke = $0fa34b70ef8520fb$var$setBorderStyle(ctx, options);
        ctx.ellipse(centerX, centerY, height / 2, width / 2, (0, $054bf7af52f034b6$export$56c0d5a1e737357d) / 2, 0, 2 * (0, $054bf7af52f034b6$export$56c0d5a1e737357d));
        ctx.fill();
        if (stroke) {
            ctx.shadowColor = options.borderShadowColor;
            ctx.stroke();
        }
        ctx.restore();
    }
    get label() {
        return this.elements && this.elements[0];
    }
    resolveElementProperties(chart, options) {
        return $0fa34b70ef8520fb$var$resolveBoxAndLabelProperties(chart, options);
    }
}
$0fa34b70ef8520fb$var$EllipseAnnotation.id = 'ellipseAnnotation';
$0fa34b70ef8520fb$var$EllipseAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundShadowColor: 'transparent',
    borderDash: [],
    borderDashOffset: 0,
    borderShadowColor: 'transparent',
    borderWidth: 1,
    display: true,
    hitTolerance: 0,
    init: undefined,
    label: Object.assign({}, $0fa34b70ef8520fb$var$BoxAnnotation.defaults.label),
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    z: 0
};
$0fa34b70ef8520fb$var$EllipseAnnotation.defaultRoutes = {
    borderColor: 'color',
    backgroundColor: 'color'
};
$0fa34b70ef8520fb$var$EllipseAnnotation.descriptors = {
    label: {
        _fallback: true
    }
};
function $0fa34b70ef8520fb$var$pointInEllipse(p, ellipse, rotation, hitSize) {
    const { width: width, height: height, centerX: centerX, centerY: centerY } = ellipse;
    const xRadius = width / 2;
    const yRadius = height / 2;
    if (xRadius <= 0 || yRadius <= 0) return false;
    // https://stackoverflow.com/questions/7946187/point-and-ellipse-rotated-position-test-algorithm
    const angle = (0, $054bf7af52f034b6$export$625550452a3fa3ec)(rotation || 0);
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const a = Math.pow(cosAngle * (p.x - centerX) + sinAngle * (p.y - centerY), 2);
    const b = Math.pow(sinAngle * (p.x - centerX) - cosAngle * (p.y - centerY), 2);
    return a / Math.pow(xRadius + hitSize, 2) + b / Math.pow(yRadius + hitSize, 2) <= 1.0001;
}
class $0fa34b70ef8520fb$var$PointAnnotation extends (0, $352a79de3bee5462$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        const { x: x, y: y, x2: x2, y2: y2, width: width } = this.getProps([
            'x',
            'y',
            'x2',
            'y2',
            'width'
        ], useFinalPosition);
        const hitSize = (this.options.borderWidth + this.options.hitTolerance) / 2;
        if (axis !== 'x' && axis !== 'y') return $0fa34b70ef8520fb$var$inPointRange({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), width / 2, hitSize);
        const limit = axis === 'y' ? {
            start: y,
            end: y2,
            value: mouseY
        } : {
            start: x,
            end: x2,
            value: mouseX
        };
        return $0fa34b70ef8520fb$var$inLimit(limit, hitSize);
    }
    getCenterPoint(useFinalPosition) {
        return $0fa34b70ef8520fb$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const options = this.options;
        const borderWidth = options.borderWidth;
        if (options.radius < 0.1) return;
        ctx.save();
        ctx.fillStyle = options.backgroundColor;
        $0fa34b70ef8520fb$var$setShadowStyle(ctx, options);
        const stroke = $0fa34b70ef8520fb$var$setBorderStyle(ctx, options);
        $0fa34b70ef8520fb$var$drawPoint(ctx, this, this.centerX, this.centerY);
        if (stroke && !$0fa34b70ef8520fb$var$isImageOrCanvas(options.pointStyle)) {
            ctx.shadowColor = options.borderShadowColor;
            ctx.stroke();
        }
        ctx.restore();
        options.borderWidth = borderWidth;
    }
    resolveElementProperties(chart, options) {
        const properties = $0fa34b70ef8520fb$var$resolvePointProperties(chart, options);
        properties.initProperties = $0fa34b70ef8520fb$var$initAnimationProperties(chart, properties, options);
        return properties;
    }
}
$0fa34b70ef8520fb$var$PointAnnotation.id = 'pointAnnotation';
$0fa34b70ef8520fb$var$PointAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundShadowColor: 'transparent',
    borderDash: [],
    borderDashOffset: 0,
    borderShadowColor: 'transparent',
    borderWidth: 1,
    display: true,
    hitTolerance: 0,
    init: undefined,
    pointStyle: 'circle',
    radius: 10,
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    xAdjust: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    xValue: undefined,
    yAdjust: 0,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    yValue: undefined,
    z: 0
};
$0fa34b70ef8520fb$var$PointAnnotation.defaultRoutes = {
    borderColor: 'color',
    backgroundColor: 'color'
};
class $0fa34b70ef8520fb$var$PolygonAnnotation extends (0, $352a79de3bee5462$export$db77ccec0bb4ccac) {
    inRange(mouseX, mouseY, axis, useFinalPosition) {
        if (axis !== 'x' && axis !== 'y') return this.options.radius >= 0.1 && this.elements.length > 1 && $0fa34b70ef8520fb$var$pointIsInPolygon(this.elements, mouseX, mouseY, useFinalPosition);
        const rotatedPoint = $0fa34b70ef8520fb$var$rotated({
            x: mouseX,
            y: mouseY
        }, this.getCenterPoint(useFinalPosition), (0, $054bf7af52f034b6$export$625550452a3fa3ec)(-this.options.rotation));
        const axisPoints = this.elements.map((point)=>axis === 'y' ? point.bY : point.bX);
        const start = Math.min(...axisPoints);
        const end = Math.max(...axisPoints);
        return rotatedPoint[axis] >= start && rotatedPoint[axis] <= end;
    }
    getCenterPoint(useFinalPosition) {
        return $0fa34b70ef8520fb$var$getElementCenterPoint(this, useFinalPosition);
    }
    draw(ctx) {
        const { elements: elements, options: options } = this;
        ctx.save();
        ctx.beginPath();
        ctx.fillStyle = options.backgroundColor;
        $0fa34b70ef8520fb$var$setShadowStyle(ctx, options);
        const stroke = $0fa34b70ef8520fb$var$setBorderStyle(ctx, options);
        let first = true;
        for (const el of elements)if (first) {
            ctx.moveTo(el.x, el.y);
            first = false;
        } else ctx.lineTo(el.x, el.y);
        ctx.closePath();
        ctx.fill();
        // If no border, don't draw it
        if (stroke) {
            ctx.shadowColor = options.borderShadowColor;
            ctx.stroke();
        }
        ctx.restore();
    }
    resolveElementProperties(chart, options) {
        const properties = $0fa34b70ef8520fb$var$resolvePointProperties(chart, options);
        const { sides: sides, rotation: rotation } = options;
        const elements = [];
        const angle = 2 * (0, $054bf7af52f034b6$export$56c0d5a1e737357d) / sides;
        let rad = rotation * (0, $054bf7af52f034b6$export$53c86fa97d611818);
        for(let i = 0; i < sides; i++, rad += angle){
            const elProps = $0fa34b70ef8520fb$var$buildPointElement(properties, options, rad);
            elProps.initProperties = $0fa34b70ef8520fb$var$initAnimationProperties(chart, properties, options);
            elements.push(elProps);
        }
        properties.elements = elements;
        return properties;
    }
}
$0fa34b70ef8520fb$var$PolygonAnnotation.id = 'polygonAnnotation';
$0fa34b70ef8520fb$var$PolygonAnnotation.defaults = {
    adjustScaleRange: true,
    backgroundShadowColor: 'transparent',
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderShadowColor: 'transparent',
    borderWidth: 1,
    display: true,
    hitTolerance: 0,
    init: undefined,
    point: {
        radius: 0
    },
    radius: 10,
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    sides: 3,
    xAdjust: 0,
    xMax: undefined,
    xMin: undefined,
    xScaleID: undefined,
    xValue: undefined,
    yAdjust: 0,
    yMax: undefined,
    yMin: undefined,
    yScaleID: undefined,
    yValue: undefined,
    z: 0
};
$0fa34b70ef8520fb$var$PolygonAnnotation.defaultRoutes = {
    borderColor: 'color',
    backgroundColor: 'color'
};
function $0fa34b70ef8520fb$var$buildPointElement({ centerX: centerX, centerY: centerY }, { radius: radius, borderWidth: borderWidth, hitTolerance: hitTolerance }, rad) {
    const hitSize = (borderWidth + hitTolerance) / 2;
    const sin = Math.sin(rad);
    const cos = Math.cos(rad);
    const point = {
        x: centerX + sin * radius,
        y: centerY - cos * radius
    };
    return {
        type: 'point',
        optionScope: 'point',
        properties: {
            x: point.x,
            y: point.y,
            centerX: point.x,
            centerY: point.y,
            bX: centerX + sin * (radius + hitSize),
            bY: centerY - cos * (radius + hitSize)
        }
    };
}
function $0fa34b70ef8520fb$var$pointIsInPolygon(points, x, y, useFinalPosition) {
    let isInside = false;
    let A = points[points.length - 1].getProps([
        'bX',
        'bY'
    ], useFinalPosition);
    for (const point of points){
        const B = point.getProps([
            'bX',
            'bY'
        ], useFinalPosition);
        if (B.bY > y !== A.bY > y && x < (A.bX - B.bX) * (y - B.bY) / (A.bY - B.bY) + B.bX) isInside = !isInside;
        A = B;
    }
    return isInside;
}
const $0fa34b70ef8520fb$var$annotationTypes = {
    box: $0fa34b70ef8520fb$var$BoxAnnotation,
    doughnutLabel: $0fa34b70ef8520fb$var$DoughnutLabelAnnotation,
    ellipse: $0fa34b70ef8520fb$var$EllipseAnnotation,
    label: $0fa34b70ef8520fb$var$LabelAnnotation,
    line: $0fa34b70ef8520fb$var$LineAnnotation,
    point: $0fa34b70ef8520fb$var$PointAnnotation,
    polygon: $0fa34b70ef8520fb$var$PolygonAnnotation
};
/**
 * Register fallback for annotation elements
 * For example lineAnnotation options would be looked through:
 * - the annotation object (options.plugins.annotation.annotations[id])
 * - element options (options.elements.lineAnnotation)
 * - element defaults (defaults.elements.lineAnnotation)
 * - annotation plugin defaults (defaults.plugins.annotation, this is what we are registering here)
 */ Object.keys($0fa34b70ef8520fb$var$annotationTypes).forEach((key)=>{
    (0, $054bf7af52f034b6$export$4368d992c4eafac0).describe(`elements.${$0fa34b70ef8520fb$var$annotationTypes[key].id}`, {
        _fallback: 'plugins.annotation.common'
    });
});
const $0fa34b70ef8520fb$var$directUpdater = {
    update: Object.assign
};
const $0fa34b70ef8520fb$var$hooks$1 = $0fa34b70ef8520fb$var$eventHooks.concat($0fa34b70ef8520fb$var$elementHooks);
const $0fa34b70ef8520fb$var$resolve = (value, optDefs)=>(0, $054bf7af52f034b6$export$23f2a1d2818174ef)(optDefs) ? $0fa34b70ef8520fb$var$resolveObj(value, optDefs) : value;
/**
 * @typedef { import("chart.js").Chart } Chart
 * @typedef { import("chart.js").UpdateMode } UpdateMode
 * @typedef { import('../../types/options').AnnotationPluginOptions } AnnotationPluginOptions
 */ /**
 * @param {string} prop
 * @returns {boolean}
 */ const $0fa34b70ef8520fb$var$isIndexable = (prop)=>prop === 'color' || prop === 'font';
/**
 * Resolve the annotation type, checking if is supported.
 * @param {string} [type=line] - annotation type
 * @returns {string} resolved annotation type
 */ function $0fa34b70ef8520fb$var$resolveType(type = 'line') {
    if ($0fa34b70ef8520fb$var$annotationTypes[type]) return type;
    console.warn(`Unknown annotation type: '${type}', defaulting to 'line'`);
    return 'line';
}
/**
 * @param {Chart} chart
 * @param {Object} state
 * @param {AnnotationPluginOptions} options
 * @param {UpdateMode} mode
 */ function $0fa34b70ef8520fb$var$updateElements(chart, state, options, mode) {
    const animations = $0fa34b70ef8520fb$var$resolveAnimations(chart, options.animations, mode);
    const annotations = state.annotations;
    const elements = $0fa34b70ef8520fb$var$resyncElements(state.elements, annotations);
    for(let i = 0; i < annotations.length; i++){
        const annotationOptions = annotations[i];
        const element = $0fa34b70ef8520fb$var$getOrCreateElement(elements, i, annotationOptions.type);
        const resolver = annotationOptions.setContext($0fa34b70ef8520fb$var$getContext(chart, element, elements, annotationOptions));
        const properties = element.resolveElementProperties(chart, resolver);
        properties.skip = $0fa34b70ef8520fb$var$toSkip(properties);
        if ('elements' in properties) {
            $0fa34b70ef8520fb$var$updateSubElements(element, properties.elements, resolver, animations);
            // Remove the sub-element definitions from properties, so the actual elements
            // are not overwritten by their definitions
            delete properties.elements;
        }
        if (!(0, $054bf7af52f034b6$export$dda1d9f60106f0e9)(element.x)) // If the element is newly created, assing the properties directly - to
        // make them readily awailable to any scriptable options. If we do not do this,
        // the properties retruned by `resolveElementProperties` are available only
        // after options resolution.
        Object.assign(element, properties);
        Object.assign(element, properties.initProperties);
        properties.options = $0fa34b70ef8520fb$var$resolveAnnotationOptions(resolver);
        animations.update(element, properties);
    }
}
function $0fa34b70ef8520fb$var$toSkip(properties) {
    return isNaN(properties.x) || isNaN(properties.y);
}
function $0fa34b70ef8520fb$var$resolveAnimations(chart, animOpts, mode) {
    if (mode === 'reset' || mode === 'none' || mode === 'resize') return $0fa34b70ef8520fb$var$directUpdater;
    return new (0, $352a79de3bee5462$export$8ab227dac26677d)(chart, animOpts);
}
function $0fa34b70ef8520fb$var$updateSubElements(mainElement, elements, resolver, animations) {
    const subElements = mainElement.elements || (mainElement.elements = []);
    subElements.length = elements.length;
    for(let i = 0; i < elements.length; i++){
        const definition = elements[i];
        const properties = definition.properties;
        const subElement = $0fa34b70ef8520fb$var$getOrCreateElement(subElements, i, definition.type, definition.initProperties);
        const subResolver = resolver[definition.optionScope].override(definition);
        properties.options = $0fa34b70ef8520fb$var$resolveAnnotationOptions(subResolver);
        animations.update(subElement, properties);
    }
}
function $0fa34b70ef8520fb$var$getOrCreateElement(elements, index, type, initProperties) {
    const elementClass = $0fa34b70ef8520fb$var$annotationTypes[$0fa34b70ef8520fb$var$resolveType(type)];
    let element = elements[index];
    if (!element || !(element instanceof elementClass)) {
        element = elements[index] = new elementClass();
        Object.assign(element, initProperties);
    }
    return element;
}
function $0fa34b70ef8520fb$var$resolveAnnotationOptions(resolver) {
    const elementClass = $0fa34b70ef8520fb$var$annotationTypes[$0fa34b70ef8520fb$var$resolveType(resolver.type)];
    const result = {};
    result.id = resolver.id;
    result.type = resolver.type;
    result.drawTime = resolver.drawTime;
    Object.assign(result, $0fa34b70ef8520fb$var$resolveObj(resolver, elementClass.defaults), $0fa34b70ef8520fb$var$resolveObj(resolver, elementClass.defaultRoutes));
    for (const hook of $0fa34b70ef8520fb$var$hooks$1)result[hook] = resolver[hook];
    return result;
}
function $0fa34b70ef8520fb$var$resolveObj(resolver, defs) {
    const result = {};
    for (const prop of Object.keys(defs)){
        const optDefs = defs[prop];
        const value = resolver[prop];
        if ($0fa34b70ef8520fb$var$isIndexable(prop) && (0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(value)) result[prop] = value.map((item)=>$0fa34b70ef8520fb$var$resolve(item, optDefs));
        else result[prop] = $0fa34b70ef8520fb$var$resolve(value, optDefs);
    }
    return result;
}
function $0fa34b70ef8520fb$var$getContext(chart, element, elements, annotation) {
    return element.$context || (element.$context = Object.assign(Object.create(chart.getContext()), {
        element: element,
        get elements () {
            return elements.filter((el)=>el && el.options);
        },
        id: annotation.id,
        type: 'annotation'
    }));
}
function $0fa34b70ef8520fb$var$resyncElements(elements, annotations) {
    const count = annotations.length;
    const start = elements.length;
    if (start < count) {
        const add = count - start;
        elements.splice(start, 0, ...new Array(add));
    } else if (start > count) elements.splice(count, start - count);
    return elements;
}
var $0fa34b70ef8520fb$var$version = "3.1.0";
const $0fa34b70ef8520fb$var$chartStates = new Map();
const $0fa34b70ef8520fb$var$isNotDoughnutLabel = (annotation)=>annotation.type !== 'doughnutLabel';
const $0fa34b70ef8520fb$var$hooks = $0fa34b70ef8520fb$var$eventHooks.concat($0fa34b70ef8520fb$var$elementHooks);
var $0fa34b70ef8520fb$export$2e2bcd8739ae039 = {
    id: 'annotation',
    version: $0fa34b70ef8520fb$var$version,
    beforeRegister () {
        $0fa34b70ef8520fb$var$requireVersion('chart.js', '4.0', (0, $352a79de3bee5462$export$acaa6426d77a227e).version);
    },
    afterRegister () {
        (0, $352a79de3bee5462$export$acaa6426d77a227e).register($0fa34b70ef8520fb$var$annotationTypes);
    },
    afterUnregister () {
        (0, $352a79de3bee5462$export$acaa6426d77a227e).unregister($0fa34b70ef8520fb$var$annotationTypes);
    },
    beforeInit (chart) {
        $0fa34b70ef8520fb$var$chartStates.set(chart, {
            annotations: [],
            elements: [],
            visibleElements: [],
            listeners: {},
            listened: false,
            moveListened: false,
            hooks: {},
            hooked: false,
            hovered: []
        });
    },
    beforeUpdate (chart, args, options) {
        const state = $0fa34b70ef8520fb$var$chartStates.get(chart);
        const annotations = state.annotations = [];
        let annotationOptions = options.annotations;
        if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(annotationOptions)) Object.keys(annotationOptions).forEach((key)=>{
            const value = annotationOptions[key];
            if ((0, $054bf7af52f034b6$export$23f2a1d2818174ef)(value)) {
                value.id = key;
                annotations.push(value);
            }
        });
        else if ((0, $054bf7af52f034b6$export$8b22cf2602fb60ce)(annotationOptions)) annotations.push(...annotationOptions);
        $0fa34b70ef8520fb$var$verifyScaleOptions(annotations.filter($0fa34b70ef8520fb$var$isNotDoughnutLabel), chart.scales);
    },
    afterDataLimits (chart, args) {
        const state = $0fa34b70ef8520fb$var$chartStates.get(chart);
        $0fa34b70ef8520fb$var$adjustScaleRange(chart, args.scale, state.annotations.filter($0fa34b70ef8520fb$var$isNotDoughnutLabel).filter((a)=>a.display && a.adjustScaleRange));
    },
    afterUpdate (chart, args, options) {
        const state = $0fa34b70ef8520fb$var$chartStates.get(chart);
        $0fa34b70ef8520fb$var$updateListeners(chart, state, options);
        $0fa34b70ef8520fb$var$updateElements(chart, state, options, args.mode);
        state.visibleElements = state.elements.filter((el)=>!el.skip && el.options.display);
        $0fa34b70ef8520fb$var$updateHooks(chart, state, options);
    },
    beforeDatasetsDraw (chart, _args, options) {
        $0fa34b70ef8520fb$var$draw(chart, 'beforeDatasetsDraw', options.clip);
    },
    afterDatasetsDraw (chart, _args, options) {
        $0fa34b70ef8520fb$var$draw(chart, 'afterDatasetsDraw', options.clip);
    },
    beforeDatasetDraw (chart, _args, options) {
        $0fa34b70ef8520fb$var$draw(chart, _args.index, options.clip);
    },
    beforeDraw (chart, _args, options) {
        $0fa34b70ef8520fb$var$draw(chart, 'beforeDraw', options.clip);
    },
    afterDraw (chart, _args, options) {
        $0fa34b70ef8520fb$var$draw(chart, 'afterDraw', options.clip);
    },
    beforeEvent (chart, args, options) {
        const state = $0fa34b70ef8520fb$var$chartStates.get(chart);
        if ($0fa34b70ef8520fb$var$handleEvent(state, args.event, options)) args.changed = true;
    },
    afterDestroy (chart) {
        $0fa34b70ef8520fb$var$chartStates.delete(chart);
    },
    getAnnotations (chart) {
        const state = $0fa34b70ef8520fb$var$chartStates.get(chart);
        return state ? state.elements : [];
    },
    // only for testing
    _getAnnotationElementsAtEventForMode (visibleElements, event, options) {
        return $0fa34b70ef8520fb$var$getElements(visibleElements, event, options);
    },
    defaults: {
        animations: {
            numbers: {
                properties: [
                    'x',
                    'y',
                    'x2',
                    'y2',
                    'width',
                    'height',
                    'centerX',
                    'centerY',
                    'pointX',
                    'pointY',
                    'radius'
                ],
                type: 'number'
            },
            colors: {
                properties: [
                    'backgroundColor',
                    'borderColor'
                ],
                type: 'color'
            }
        },
        clip: true,
        interaction: {
            mode: undefined,
            axis: undefined,
            intersect: undefined
        },
        common: {
            drawTime: 'afterDatasetsDraw',
            init: false,
            label: {}
        }
    },
    descriptors: {
        _indexable: false,
        _scriptable: (prop)=>!$0fa34b70ef8520fb$var$hooks.includes(prop) && prop !== 'init',
        annotations: {
            _allKeys: false,
            _fallback: (prop, opts)=>`elements.${$0fa34b70ef8520fb$var$annotationTypes[$0fa34b70ef8520fb$var$resolveType(opts.type)].id}`
        },
        interaction: {
            _fallback: true
        },
        common: {
            label: {
                _indexable: $0fa34b70ef8520fb$var$isIndexable,
                _fallback: true
            },
            _indexable: $0fa34b70ef8520fb$var$isIndexable
        }
    },
    additionalOptionScopes: [
        ''
    ]
};
function $0fa34b70ef8520fb$var$draw(chart, caller, clip) {
    const { ctx: ctx, chartArea: chartArea } = chart;
    const state = $0fa34b70ef8520fb$var$chartStates.get(chart);
    if (clip) (0, $054bf7af52f034b6$export$8743009a87fcb00f)(ctx, chartArea);
    const drawableElements = $0fa34b70ef8520fb$var$getDrawableElements(state.visibleElements, caller).sort((a, b)=>a.element.options.z - b.element.options.z);
    for (const item of drawableElements)$0fa34b70ef8520fb$var$drawElement(ctx, chartArea, state, item);
    if (clip) (0, $054bf7af52f034b6$export$3d8c2f653ac9d0b9)(ctx);
}
function $0fa34b70ef8520fb$var$getDrawableElements(elements, caller) {
    const drawableElements = [];
    for (const el of elements){
        if (el.options.drawTime === caller) drawableElements.push({
            element: el,
            main: true
        });
        if (el.elements && el.elements.length) {
            for (const sub of el.elements)if (sub.options.display && sub.options.drawTime === caller) drawableElements.push({
                element: sub
            });
        }
    }
    return drawableElements;
}
function $0fa34b70ef8520fb$var$drawElement(ctx, chartArea, state, item) {
    const el = item.element;
    if (item.main) {
        $0fa34b70ef8520fb$var$invokeHook(state, el, 'beforeDraw');
        el.draw(ctx, chartArea);
        $0fa34b70ef8520fb$var$invokeHook(state, el, 'afterDraw');
    } else el.draw(ctx, chartArea);
}





var $kx1Sf = parcelRequire("kx1Sf");
var $069d175a9e868756$exports = {};
!function(e, t) {
    $069d175a9e868756$exports = t();
}($069d175a9e868756$exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});


var $b0cae5e73a6e7d91$exports = {};
!function(t, n) {
    $b0cae5e73a6e7d91$exports = n();
}($b0cae5e73a6e7d91$exports, function() {
    "use strict";
    var t = "month", n = "quarter";
    return function(e, i) {
        var r = i.prototype;
        r.quarter = function(t) {
            return this.$utils().u(t) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (t - 1));
        };
        var s = r.add;
        r.add = function(e, i) {
            return e = Number(e), this.$utils().p(i) === n ? this.add(3 * e, t) : s.bind(this)(e, i);
        };
        var u = r.startOf;
        r.startOf = function(e, i) {
            var r = this.$utils(), s = !!r.u(i) || i;
            if (r.p(e) === n) {
                var o = this.quarter() - 1;
                return s ? this.month(3 * o).startOf(t).startOf("day") : this.month(3 * o + 2).endOf(t).endOf("day");
            }
            return u.bind(this)(e, i);
        };
    };
});



var $24fee1d3226a015f$exports = {};
!function(e, t) {
    $24fee1d3226a015f$exports = t();
}($24fee1d3226a015f$exports, function() {
    "use strict";
    var e = "day";
    return function(t, i, s) {
        var a = function(t) {
            return t.add(4 - t.isoWeekday(), e);
        }, d = i.prototype;
        d.isoWeekYear = function() {
            return a(this).year();
        }, d.isoWeek = function(t) {
            if (!this.$utils().u(t)) return this.add(7 * (t - this.isoWeek()), e);
            var i, d, n, o, r = a(this), u = (i = this.isoWeekYear(), d = this.$u, n = (d ? s.utc : s)().year(i).startOf("year"), o = 4 - n.isoWeekday(), n.isoWeekday() > 4 && (o += 7), n.add(o, e));
            return r.diff(u, "week") + 1;
        }, d.isoWeekday = function(e) {
            return this.$utils().u(e) ? this.day() || 7 : this.day(this.day() % 7 ? e : e - 7);
        };
        var n = d.startOf;
        d.startOf = function(e, t) {
            var i = this.$utils(), s = !!i.u(t) || t;
            return "isoweek" === i.p(e) ? s ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : n.bind(this)(e, t);
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($069d175a9e868756$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($b0cae5e73a6e7d91$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($a036f20b7ab42e01$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($kx1Sf))));
(0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($24fee1d3226a015f$exports))));
var $829a12ace8724656$var$FORMATS = {
    datetime: 'MMM D, YYYY, h:mm:ss a',
    millisecond: 'h:mm:ss.SSS a',
    second: 'h:mm:ss a',
    minute: 'h:mm a',
    hour: 'hA',
    day: 'MMM D',
    week: 'll',
    month: 'MMM YYYY',
    quarter: '[Q]Q - YYYY',
    year: 'YYYY'
};
(0, $352a79de3bee5462$export$f32766ea09ec8bc4)._date.override({
    //_id: 'dayjs', //DEBUG,
    formats: function formats() {
        return $829a12ace8724656$var$FORMATS;
    },
    parse: function parse(value, format) {
        var valueType = typeof value;
        if (value === null || valueType === 'undefined') return null;
        if (valueType === 'string' && typeof format === 'string') return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(value, format).isValid() ? (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(value, format).valueOf() : null;
        else if (!(value instanceof (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports))))) return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(value).isValid() ? (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(value).valueOf() : null;
        return null;
    },
    format: function format(time, _format) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(time).format(_format);
    },
    add: function add(time, amount, unit) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(time).add(amount, unit).valueOf();
    },
    diff: function diff(max, min, unit) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(max).diff((0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(min), unit);
    },
    startOf: function startOf(time, unit, weekday) {
        if (unit === 'isoWeek') {
            // Ensure that weekday has a valid format
            //const formattedWeekday
            var validatedWeekday = typeof weekday === 'number' && weekday > 0 && weekday < 7 ? weekday : 1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(time).isoWeekday(validatedWeekday).startOf('day').valueOf();
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(time).startOf(unit).valueOf();
    },
    endOf: function endOf(time, unit) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fce7f459a03976d5$exports)))(time).endOf(unit).valueOf();
    }
});



const $9173345d62a70250$var$hexToRgb = (hex, opacity)=>{
    opacity = opacity ? opacity : 0.0;
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, '');
    // Parse the hex values
    let bigint = parseInt(hex, 16);
    let r = bigint >> 16 & 255;
    let g = bigint >> 8 & 255;
    let b = bigint & 255;
    return `rgb(${r}, ${g}, ${b}, ${opacity})`;
};
var $9173345d62a70250$export$2e2bcd8739ae039 = $9173345d62a70250$var$hexToRgb;




var $bHJbJ = parcelRequire("bHJbJ");
parcelRequire("i5lfL");

function $3e2b651951504e8a$export$2e2bcd8739ae039(props) {
    const { AllMapLists: AllMapLists, plotQueryProps: plotQueryProps, setPlotQueryProps: setPlotQueryProps, filterConfigList: filterConfigList, listsDisabled: listsDisabled, applyUpdates: applyUpdates } = props;
    return filterConfigList.map((item, index)=>{
        return(// eslint-disable-next-line react/jsx-key
        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
            item: true,
            xs: 1,
            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $3b3376bc3ccaa047$export$2e2bcd8739ae039), {
                variant: "filled",
                sx: {
                    width: 200,
                    maxWidth: 200
                },
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1e5dd5d1f3980790$export$2e2bcd8739ae039), {
                        id: "demo-simple-select-filled-label",
                        children: item.name
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $f25919672eb20630$export$2e2bcd8739ae039), {
                        label: item.name,
                        name: item.propID,
                        onChange: (e)=>{
                            let result;
                            if (typeof e.target.value === 'object') {
                                if (plotQueryProps[e.target.name].indexOf(item.defaultValue) < 0) // @ts-ignore
                                {
                                    if (e.target.value.indexOf(item.defaultValue) >= 0) result = [
                                        item.defaultValue
                                    ];
                                } else // @ts-ignore                                        
                                result = e.target.value.filter((i)=>i !== item.defaultValue);
                            }
                            setPlotQueryProps({
                                ...plotQueryProps,
                                [e.target.name]: result ?? e.target.value
                            });
                        },
                        multiple: true,
                        value: plotQueryProps[item.propID],
                        variant: "filled",
                        defaultValue: item.defaultValue,
                        size: "small",
                        disabled: listsDisabled,
                        renderValue: (selected)=>{
                            selected = selected.filter((item)=>{
                                return item !== undefined && item !== null;
                            });
                            if (selected.length > 1) return 'Multiple';
                            else return selected;
                        },
                        children: [
                            $3e2b651951504e8a$var$updateFilter(AllMapLists, item)?.length > 10 && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                style: {
                                    padding: 0,
                                    margin: "5px 5px 5px 5px"
                                },
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                    variant: "contained",
                                    style: {
                                        width: "100%"
                                    },
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        applyUpdates(item.propID, plotQueryProps[item.propID]);
                                    },
                                    children: "Apply"
                                })
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                value: item.defaultValue,
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $842f67eebadd25d0$export$2e2bcd8739ae039), {
                                        checked: plotQueryProps[item.propID].indexOf(item.defaultValue) >= 0,
                                        style: {
                                            padding: "0 5px 0 0"
                                        }
                                    }),
                                    item.defaultValue
                                ]
                            }, item.defaultValue),
                            $3e2b651951504e8a$var$updateFilter(AllMapLists, item)?.map((option)=>/*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                    value: option[item.valueKey],
                                    children: [
                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $842f67eebadd25d0$export$2e2bcd8739ae039), {
                                            checked: plotQueryProps[item.propID].indexOf(option[item.valueKey]) >= 0,
                                            style: {
                                                padding: "0 5px 0 0"
                                            }
                                        }),
                                        option[item.valueName]
                                    ]
                                }, option[item.valueKey])),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                style: {
                                    padding: 0,
                                    margin: "5px 5px 5px 5px"
                                },
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                    variant: "contained",
                                    style: {
                                        width: "100%"
                                    },
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        applyUpdates(item.propID, plotQueryProps[item.propID]);
                                    },
                                    children: "Apply"
                                })
                            })
                        ]
                    })
                ]
            })
        }, index));
    });
}
function $3e2b651951504e8a$var$updateFilter(AllMapLists, filterConfigItem) {
    const options = AllMapLists?.[filterConfigItem.listName];
    if (options && filterConfigItem.filters) {
        // Currently only 1 filter supported
        const key = Object.keys(filterConfigItem.filters)[0];
        const values = filterConfigItem.filters[key];
        return options.filter((item)=>values.includes(item[key]));
    } else return options;
}


//Configuration list for National map filters
const $53fcf24220e283f8$export$338399e40cd7ee5e = [
    {
        name: "State",
        propID: "inState",
        listName: "executeRetrieveState",
        valueKey: "State",
        valueName: "State",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "SA4 Region",
        propID: "inLocationType",
        listName: "executeRetrieveLocationType",
        valueKey: "LocationType",
        valueName: "LocationType",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Investment Tier",
        propID: "inInvestmentTier",
        listName: "executeRetrieveInvestmentTier",
        valueKey: "InvestmentTier",
        valueName: "InvestmentTier",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Commonwealth Funded",
        propID: "inCommonwealthFunded",
        listName: "executeRetrieveCommonwealthFunded",
        valueKey: "CommonwealthFunding",
        valueName: "CommonwealthFunding",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Pipeline",
        propID: "inPipeline",
        listName: "executeRetrievePipeline",
        valueKey: "InfraFlag",
        valueName: "InfraFlag",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Project Phase",
        propID: "inProjectPhase",
        listName: "executeRetrieveProjectPhase",
        valueKey: "PhaseType",
        valueName: "PhaseType",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Super Sector",
        propID: "inSuperSector",
        listName: "executeRetrieveSuperSector",
        valueKey: "SuperSector",
        valueName: "SuperSector",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Master Type",
        propID: "inMasterType",
        listName: "executeRetrieveMasterType",
        valueKey: "MasterType",
        valueName: "MasterType",
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Project Type",
        propID: "inProjectType",
        listName: "executeRetrieveProjectType",
        valueKey: "RawProjectType",
        valueName: "RawProjectType",
        multiple: true,
        defaultValue: "ALL"
    }
];
const $53fcf24220e283f8$export$8f1f7580876c993b = [
    {
        name: "Group",
        propID: "inLvl1Group",
        listName: "executeRetrieveLvl1Group",
        valueKey: "Lvl1Group",
        valueName: "Lvl1Group",
        filters: {
            "PLEMGroup": [
                "Labour"
            ]
        },
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Occupation",
        propID: "inResourceGroup",
        listName: "executeRetrieveResourceGroup",
        valueKey: "ResourceGroup",
        valueName: "ResourceGroup",
        filters: {
            "PLEMGroup": [
                "Labour"
            ]
        },
        multiple: true,
        defaultValue: "ALL"
    }
];
const $53fcf24220e283f8$export$bb3f8fd74a16c1d1 = [
    {
        name: "PLEM Group",
        propID: "inPLEMGroup",
        listName: "executeRetrievePLEMGroup",
        valueKey: "PLEMGroup",
        valueName: "PLEMGroup",
        filters: {
            "PLEMGroup": [
                "Equipment",
                "Material",
                "Plant"
            ]
        },
        multiple: true,
        defaultValue: "ALL"
    },
    {
        name: "Resource Group",
        propID: "inResourceGroup",
        listName: "executeRetrieveResourceGroup",
        valueKey: "ResourceGroup",
        valueName: "ResourceGroup",
        filters: {
            "PLEMGroup": [
                "Equipment",
                "Material",
                "Plant"
            ]
        },
        multiple: true,
        defaultValue: "ALL"
    }
];
const $53fcf24220e283f8$export$3c744f943c267ae3 = [
    {
        name: "Resource Group",
        propID: "inResourceGroup",
        listName: "executeRetrieveResourceGroup",
        valueKey: "ResourceGroup",
        valueName: "ResourceGroup",
        filters: {
            "PLEMGroup": [
                "Material"
            ]
        },
        multiple: true,
        defaultValue: "ALL"
    }
];



(0, $352a79de3bee5462$export$acaa6426d77a227e).register((0, $352a79de3bee5462$export$a894c72689ff3ec), (0, $0fa34b70ef8520fb$export$2e2bcd8739ae039));
function $d498d22ffbb912e8$export$2e2bcd8739ae039({ queryVariables: queryVariables, allMapLists: allMapLists, setLabourPlotQueryProps: setLabourPlotQueryProps, labourPlotQueryProps: labourPlotQueryProps, applyUpdates: applyUpdates, setLabourTab: setLabourTab, updateLabourCharts: updateLabourCharts, updateAlert: updateAlert }) {
    // Authentication
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const { data: userInfo } = (0, $8aac0537827a6bae$export$801fe16824f675f7)();
    const labourChartLoader = (0, $i5lfL.useRef)();
    const labour_colours = [
        {
            "labour": "demand",
            "colour": "#253746"
        },
        {
            "labour": "supply",
            "colour": "#73b469"
        },
        {
            "labour": "difference",
            "colour": "#7e2d40"
        }
    ];
    const labourSupplyDemandValuesRef = (0, $i5lfL.useRef)([]);
    const labourOccupationValuesRef = (0, $i5lfL.useRef)([]);
    const [completed, setCompleted] = (0, $i5lfL.useState)(0);
    const [month, setMonth] = (0, $15fcb3e9846e132a$export$2e2bcd8739ae039)('month', {
        inMonth: queryVariables.inMonth,
        inYear: queryVariables.inYear
    });
    const { data: labourSupplyDemandValues, status: labourSupplyDemandStatus, fetchStatus: labourSupplyDemandFetchStatus, error: labourSupplyDemandError, refetch: refetchLabourSupplyDemandValues } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "LabourSupplyDemandValues"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $98dbd14a43c62e7a$export$537b2500673c977),
                variables: queryVariables,
                instance: instance,
                accounts: accounts
            });
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        cacheTime: Infinity,
        enabled: !!userInfo
    });
    const { data: labourOccuptionValues, status: labourOccupationStatus, fetchStatus: labourOccupationFetchStatus, error: labourOccupationError, refetch: refetchLabourOccupationValues } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "LabourOccupationValues"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $98dbd14a43c62e7a$export$41264fbadc2ced35),
                variables: queryVariables,
                instance: instance,
                accounts: accounts
            });
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        cacheTime: Infinity,
        enabled: !!userInfo
    });
    // Start - labour demand/supply chart
    // Set the labour demand/supply chart options
    const labour_monthly_options = {
        plugins: {
            title: {
                display: false,
                text: 'Supply vs demand over time (FTE per month)'
            },
            tooltip: {
                callbacks: {
                    labelColor: (tooltipItem)=>{
                        return {
                            borderColor: tooltipItem.dataset.borderColor,
                            backgroundColor: tooltipItem.dataset.backgroundColor
                        };
                    }
                }
            },
            legend: {
                position: "bottom",
                onClick: null
            },
            annotation: {
                drawTime: 'afterDatasetsDraw',
                annotations: [
                    {
                        display: (context, opts)=>{
                            const date = new Date(new Date(`${month.inYear}-${month.inMonth}-01`).toDateString());
                            const startFiscalDate = new Date(new Date(`${queryVariables.inStartYear - 1}-07-01`).toDateString());
                            const endFiscalDate = new Date(new Date(`${queryVariables.inEndYear}-06-30`).toDateString());
                            return (queryVariables.inStartYear === 0 || date >= startFiscalDate) && (queryVariables.inEndYear === 0 || date <= endFiscalDate) ? true : false;
                        },
                        scaleID: 'x',
                        mode: 'vertical',
                        type: 'line',
                        value: `${month.inYear}-${month.inMonth >= 10 ? month.inMonth : '0' + month.inMonth}-01T00:00:00.000Z`,
                        borderColor: '#555555',
                        borderDash: [
                            5,
                            5
                        ],
                        borderWidth: 2,
                        label: {
                            display: true,
                            backgroundColor: 'rgba(51, 51, 51, 0.6)',
                            position: 'end',
                            content: new Date(`${month.inYear}-${month.inMonth}`).toLocaleDateString("en-AU", {
                                year: "numeric",
                                month: "long"
                            })
                        }
                    }
                ]
            }
        },
        interaction: {
            mode: 'index',
            intersect: false
        },
        responsive: false,
        aspectRatio: 1,
        scales: {
            x: {
                type: 'time',
                time: {
                    unit: 'month',
                    tooltipFormat: 'MMMM, YYYY'
                }
            }
        }
    };
    // Build the chart datasets dynamically
    const labour_value_datasets = [
        {
            type: 'line',
            label: 'Demand',
            data: labourSupplyDemandValuesRef.current.map((obj)=>obj.Demand),
            backgroundColor: labour_colours.find((x)=>x.labour === 'demand')?.colour,
            borderColor: labour_colours.find((x)=>x.labour === 'demand')?.colour,
            pointBorderColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: 'rgba(0, 0, 0, 0)',
            pointHoverBackgroundColor: labour_colours.find((x)=>x.labour === 'demand')?.colour,
            pointHoverBorderColor: labour_colours.find((x)=>x.labour === 'demand')?.colour
        },
        {
            type: 'line',
            label: 'Supply',
            data: labourSupplyDemandValuesRef.current.map((obj)=>obj.Supply),
            backgroundColor: labour_colours.find((x)=>x.labour === 'supply')?.colour,
            borderColor: labour_colours.find((x)=>x.labour === 'supply')?.colour,
            pointBorderColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: 'rgba(0, 0, 0, 0)',
            pointHoverBackgroundColor: labour_colours.find((x)=>x.labour === 'supply')?.colour,
            pointHoverBorderColor: labour_colours.find((x)=>x.labour === 'supply')?.colour
        },
        {
            type: 'line',
            label: 'Net Difference',
            data: labourSupplyDemandValuesRef.current.map((obj)=>obj.Difference),
            fill: true,
            backgroundColor: (0, $9173345d62a70250$export$2e2bcd8739ae039)(labour_colours.find((x)=>x.labour === 'difference')?.colour, 0.5),
            borderColor: labour_colours.find((x)=>x.labour === 'difference')?.colour,
            pointBorderColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: 'rgba(0, 0, 0, 0)',
            pointHoverBackgroundColor: labour_colours.find((x)=>x.labour === 'difference')?.colour,
            pointHoverBorderColor: labour_colours.find((x)=>x.labour === 'difference')?.colour
        }
    ];
    // Create the unique dates array
    const dates = [
        ...new Set(labourSupplyDemandValuesRef.current.map((item)=>item.ObservationDate))
    ];
    const labour_value_chart = {
        labels: dates,
        datasets: labour_value_datasets
    };
    // End - labour demand/supply chart
    // Start - labour occupation chart
    const labour_occupation_options = {
        indexAxis: 'y',
        plugins: {
            title: {
                display: false,
                text: 'Supply vs demand by occupation (FTE per month)'
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem)=>{
                        if (tooltipItem.datasetIndex === 0) return 'Demand: ' + tooltipItem.parsed.x;
                        else if (tooltipItem.datasetIndex === 1) return 'Supply: ' + tooltipItem.parsed.x;
                        else if (tooltipItem.datasetIndex === 2) return 'Net Difference: ' + tooltipItem.parsed.x;
                    }
                }
            },
            legend: {
                display: false
            }
        },
        interaction: {
            mode: 'index',
            axis: 'y'
        },
        responsive: false,
        aspectRatio: 1,
        scales: {
            x: {
                position: "top"
            }
        }
    };
    // Build the chart properties dynamically
    labourOccupationValuesRef.current.sort((a, b)=>a.Difference - b.Difference);
    // const groups = [...new Set(labour_occupation_test_data.map(item => item.Lvl1group))];
    const occupations = [
        ...new Set(labourOccupationValuesRef.current.map((item)=>item.ResourceGroup))
    ];
    // Set the chart labels and dataset
    const labour_occupation_chart = {
        labels: occupations,
        datasets: [
            {
                type: 'line',
                data: labourOccupationValuesRef.current.map((item)=>item.Demand),
                backgroundColor: labour_colours.find((x)=>x.labour === 'demand')?.colour,
                borderColor: 'rgba(0, 0, 0, 0)',
                pointRadius: 4
            },
            {
                type: 'line',
                data: labourOccupationValuesRef.current.map((item)=>item.Supply),
                backgroundColor: labour_colours.find((x)=>x.labour === 'supply')?.colour,
                borderColor: 'rgba(0, 0, 0, 0)',
                pointRadius: 4
            },
            {
                type: 'bar',
                data: labourOccupationValuesRef.current.map((item)=>item.Difference),
                backgroundColor: labour_colours.find((x)=>x.labour === 'difference')?.colour
            }
        ]
    };
    // End - labour occupation chart
    (0, $i5lfL.useEffect)(()=>{
        if (labourSupplyDemandStatus == 'error') console.log(labourSupplyDemandError);
        else if (labourSupplyDemandStatus == 'success' && labourSupplyDemandFetchStatus == 'idle') {
            labourSupplyDemandValuesRef.current = labourSupplyDemandValues.executeRetrieveLabourSupplyDemand;
            setCompleted((prev)=>++prev);
        }
    }, [
        labourSupplyDemandValues,
        labourSupplyDemandStatus,
        labourSupplyDemandFetchStatus,
        labourSupplyDemandError
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (labourOccupationStatus == 'error') console.log(labourOccupationError);
        else if (labourOccupationStatus == 'success' && labourOccupationFetchStatus == 'idle') {
            labourOccupationValuesRef.current = labourOccuptionValues.executeRetrieveLabourOccupation;
            setCompleted((prev)=>++prev);
        }
    }, [
        labourOccuptionValues,
        labourOccupationStatus,
        labourOccupationFetchStatus,
        labourOccupationError
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (updateLabourCharts) {
            labourChartLoader.current.style.display = 'flex';
            // The code related to setting the month/year
            // is a bit convoluted due to the fiscal year 
            // slider and the reset filter function.
            if (queryVariables.inStartYear !== 0 && queryVariables.inEndYear !== 0) {
                const date = new Date(`${month.inYear}-${month.inMonth}`);
                const startDate = new Date(`${queryVariables.inStartYear - 1}-07`);
                const endDate = new Date(`${queryVariables.inEndYear}-06`);
                if (date < startDate || date > endDate) {
                    const midDate = new Date((startDate.getTime() + endDate.getTime()) / 2);
                    queryVariables.inMonth = midDate.getMonth() + 1;
                    queryVariables.inYear = midDate.getFullYear();
                }
            }
            setMonth({
                inMonth: queryVariables.inMonth,
                inYear: queryVariables.inYear
            });
            refetchLabourSupplyDemandValues();
            refetchLabourOccupationValues();
        }
    }, [
        updateLabourCharts
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (completed >= 2) {
            setCompleted(0);
            labourChartLoader.current.style.display = 'none';
            setLabourTab(false);
        }
    }, [
        completed
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                ref: labourChartLoader,
                style: {
                    position: "absolute",
                    display: "flex",
                    zIndex: "200",
                    width: 1000,
                    height: 1270,
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(51, 51, 51, 0.4)"
                },
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $753bfae0ab95f468$export$67ad50c48ca3ede4), {
                    visible: true,
                    height: "80",
                    width: "80",
                    color: "#005670",
                    secondaryColor: "#005670",
                    ariaLabel: "oval-loading",
                    wrapperStyle: {},
                    wrapperClass: ""
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                container: true,
                direction: "column",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                sx: {
                                    width: 1000,
                                    fontStyle: "italic",
                                    fontWeight: 700,
                                    mt: 2,
                                    fontFamily: "ProximaNova-Bold",
                                    paddingBottom: "5px",
                                    margin: 0
                                },
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                                    children: (0, $d29d6d1034e01aa1$export$257faa611f4a6c22)
                                })
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                style: {
                                    display: "flex",
                                    width: 1000,
                                    backgroundColor: "rgb(0, 86, 112)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                        style: {
                                            display: "flex",
                                            width: 600,
                                            padding: 2,
                                            color: "#FFF",
                                            fontWeight: 600,
                                            fontSize: "1.25rem",
                                            fontFamily: "ProximaNova",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        },
                                        children: "Supply vs demand over time (FTE per month)"
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 1,
                                        columns: 2,
                                        sx: {
                                            width: 400,
                                            flexGrow: 1,
                                            justifyContent: "flex-end",
                                            backgroundColor: "white"
                                        },
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3e2b651951504e8a$export$2e2bcd8739ae039), {
                                            AllMapLists: allMapLists,
                                            plotQueryProps: labourPlotQueryProps,
                                            setPlotQueryProps: setLabourPlotQueryProps,
                                            filterConfigList: (0, $53fcf24220e283f8$export$8f1f7580876c993b),
                                            listsDisabled: false,
                                            applyUpdates: applyUpdates
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                style: {
                                    display: "relative",
                                    width: 1000,
                                    height: 550
                                },
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30e31766597ec5b3$export$acaa6426d77a227e), {
                                    options: labour_monthly_options,
                                    data: labour_value_chart,
                                    width: "1000",
                                    height: "550"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                style: {
                                    display: "flex",
                                    width: 1000,
                                    backgroundColor: "rgb(0, 86, 112)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                        style: {
                                            display: "flex",
                                            width: 800,
                                            color: "#FFF",
                                            fontWeight: 600,
                                            fontSize: "1.25rem",
                                            fontFamily: "ProximaNova",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        },
                                        children: "Supply vs demand by occupation (FTE per month)"
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 1,
                                        columns: 1,
                                        sx: {
                                            width: 200,
                                            flexGrow: 1,
                                            justifyContent: "flex-end",
                                            backgroundColor: "white"
                                        },
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                            item: true,
                                            xs: 1,
                                            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $3b3376bc3ccaa047$export$2e2bcd8739ae039), {
                                                variant: "filled",
                                                sx: {
                                                    width: "100%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1e5dd5d1f3980790$export$2e2bcd8739ae039), {
                                                        id: "demo-simple-select-filled-label",
                                                        children: "Month"
                                                    }),
                                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $f25919672eb20630$export$2e2bcd8739ae039), {
                                                        label: "Month",
                                                        name: "inMonth",
                                                        fullWidth: true,
                                                        value: `${month.inYear}-${month.inMonth >= 10 ? month.inMonth : '0' + month.inMonth}-01T00:00:00.000Z`,
                                                        variant: "filled",
                                                        size: "small",
                                                        disabled: false,
                                                        onChange: (e)=>{
                                                            const date = new Date(e.target.value);
                                                            queryVariables.inMonth = date.getMonth() + 1;
                                                            queryVariables.inYear = date.getFullYear();
                                                            setMonth({
                                                                inMonth: queryVariables.inMonth,
                                                                inYear: queryVariables.inYear
                                                            });
                                                            refetchLabourOccupationValues();
                                                        },
                                                        children: labourSupplyDemandValuesRef.current.map((item)=>/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $233ec4675cd9b906$export$2e2bcd8739ae039), {
                                                                value: item.ObservationDate,
                                                                children: new Date(item.ObservationDate).toLocaleDateString("en-AU", {
                                                                    year: "numeric",
                                                                    month: "long"
                                                                })
                                                            }, item.ObservationDate))
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                style: {
                                    display: "relative",
                                    width: 1000,
                                    height: 550,
                                    overflow: "auto"
                                },
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30e31766597ec5b3$export$acaa6426d77a227e), {
                                    options: labour_occupation_options,
                                    data: labour_occupation_chart,
                                    height: "1000",
                                    width: "980"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


// @ts-nocheck

var $bHJbJ = parcelRequire("bHJbJ");

var $i5lfL = parcelRequire("i5lfL");









const $7c70d3c39411cd95$var$getOrCreateLegendList = (container)=>{
    let listContainer = container.querySelector('ul');
    if (!listContainer) {
        listContainer = document.createElement('ul');
        listContainer.style.display = 'flex';
        listContainer.style.flexDirection = 'column';
        listContainer.style.margin = 0;
        listContainer.style.padding = 0;
        container.appendChild(listContainer);
    }
    return listContainer;
};
const $7c70d3c39411cd95$var$htmlLegend = {
    id: 'htmlLegend',
    afterUpdate (chart, args, options) {
        const ul = $7c70d3c39411cd95$var$getOrCreateLegendList(options.container.current);
        while(ul.firstChild)ul.firstChild.remove();
        const items = chart.options.plugins.legend.labels.generateLabels(chart);
        items.sort((a, b)=>a.text.localeCompare(b.text));
        items.forEach((item)=>{
            const li = document.createElement('li');
            li.style.alignItems = 'left';
            li.style.cursor = 'pointer';
            li.style.display = 'flex';
            li.style.flexDirection = 'row';
            li.style.marginTop = '5px';
            li.style.marginLeft = '5px';
            li.style.marginBottom = '0';
            li.style.whiteSpace = 'nowrap';
            li.style.height = '20px';
            li.onclick = (e)=>{
                let index = item.datasetIndex;
                var alreadyHidden = chart.getDatasetMeta(index).hidden === null ? false : chart.getDatasetMeta(index).hidden;
                chart.data.datasets.forEach((e, i)=>{
                    var meta = chart.getDatasetMeta(i);
                    if (i !== index) {
                        if (!alreadyHidden) meta.hidden = meta.hidden === null ? !meta.hidden : null;
                        else if (meta.hidden === null) meta.hidden = true;
                    } else if (i === index) meta.hidden = null;
                });
                chart.update();
            };
            const boxSpan = document.createElement('span');
            boxSpan.style.background = item.fillStyle;
            boxSpan.style.border = "0.7px solid black";
            boxSpan.style.display = 'inline-block';
            boxSpan.style.flexShrink = '0';
            boxSpan.style.height = '20px';
            boxSpan.style.marginRight = '5px';
            boxSpan.style.width = '20px';
            const textContainer = document.createElement('p');
            textContainer.style.color = item.fontColor;
            textContainer.style.fontFamily = "ProximaNova";
            textContainer.style.fontSize = "0.875rem";
            textContainer.style.margin = '0';
            textContainer.style.padding = '0';
            textContainer.style.textDecoration = item.hidden ? 'line-through' : '';
            const text = document.createTextNode(item.text);
            textContainer.appendChild(text);
            li.appendChild(boxSpan);
            li.appendChild(textContainer);
            ul.appendChild(li);
        });
    }
};
var $7c70d3c39411cd95$export$2e2bcd8739ae039 = $7c70d3c39411cd95$var$htmlLegend;





function $e1c12463111ca8ed$export$2e2bcd8739ae039({ queryVariables: queryVariables, allMapLists: allMapLists, setNonLabourPlotQueryProps: setNonLabourPlotQueryProps, nonLabourPlotQueryProps: nonLabourPlotQueryProps, applyUpdates: applyUpdates, setNonLabourTab: setNonLabourTab, updateNonLabourCharts: updateNonLabourCharts, updateAlert: updateAlert }) {
    // Authentication
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const { data: userInfo } = (0, $8aac0537827a6bae$export$801fe16824f675f7)();
    const valueLegendContainer = (0, $i5lfL.useRef)();
    const tonnageLegendContainer = (0, $i5lfL.useRef)();
    const nonLabourChartLoader = (0, $i5lfL.useRef)();
    // const [nonLabourPlotQueryProps, setNonLabourPlotQueryProps] = usePersistedState<any>('nonLabourPlotQueryProps', {
    //     inPLEMGroup: ["ALL"],
    //     inResourceGroup: ["ALL"]
    // });
    const nonlabour_colours = [
        {
            "resourcegroup": "Aggregate",
            "colour": "#4e79a7"
        },
        {
            "resourcegroup": "Aluminium",
            "colour": "#a0cbe8"
        },
        {
            "resourcegroup": "Asphalt",
            "colour": "#f28e2b"
        },
        {
            "resourcegroup": "Bitumen Binders",
            "colour": "#ffbe7d"
        },
        {
            "resourcegroup": "Bricks ",
            "colour": "#59a14f"
        },
        {
            "resourcegroup": "Building Services - electrical equipment",
            "colour": "#8cd17d"
        },
        {
            "resourcegroup": "Building Services - machanical equipment",
            "colour": "#b6992d"
        },
        {
            "resourcegroup": "Bulldozers",
            "colour": "#f1ce63"
        },
        {
            "resourcegroup": "Cement",
            "colour": "#8cd17d"
        },
        {
            "resourcegroup": "Compactor",
            "colour": "#86bcb6"
        },
        {
            "resourcegroup": "Control Equipment",
            "colour": "#e15759"
        },
        {
            "resourcegroup": "Copper",
            "colour": "#b6992d"
        },
        {
            "resourcegroup": "Electrical Bulk",
            "colour": "#f1ce63"
        },
        {
            "resourcegroup": "Electrical Equipment",
            "colour": "#bab0ac"
        },
        {
            "resourcegroup": "Excavators",
            "colour": "#d37295"
        },
        {
            "resourcegroup": "Fiberglass",
            "colour": "#499894"
        },
        {
            "resourcegroup": "Girders",
            "colour": "#86bcb6"
        },
        {
            "resourcegroup": "Graders",
            "colour": "#d4a6c8"
        },
        {
            "resourcegroup": "Kitchen Fitout - electrical equipment",
            "colour": "#9d7660"
        },
        {
            "resourcegroup": "Linemarking & Road Furnitures",
            "colour": "#e15759"
        },
        {
            "resourcegroup": "Mechanical Equipment",
            "colour": "#4e79a7"
        },
        {
            "resourcegroup": "Mobile Cranes",
            "colour": "#a0cbe8"
        },
        {
            "resourcegroup": "Plasterboard",
            "colour": "#ff9d9a"
        },
        {
            "resourcegroup": "Plastics and Polymeric materials",
            "colour": "#79706e"
        },
        {
            "resourcegroup": "PV Panels",
            "colour": "#bab0ac"
        },
        {
            "resourcegroup": "Rail Track",
            "colour": "#d37295"
        },
        {
            "resourcegroup": "Rock/Bluestone",
            "colour": "#fabfd2"
        },
        {
            "resourcegroup": "Sand",
            "colour": "#b07aa1"
        },
        {
            "resourcegroup": "Scaffold (tubular)",
            "colour": "#499894"
        },
        {
            "resourcegroup": "Scissor Lifts",
            "colour": "#ff9d9a"
        },
        {
            "resourcegroup": "Site Offices, Lunchrooms",
            "colour": "#79706e"
        },
        {
            "resourcegroup": "Speciality Plant",
            "colour": "#fabfd2"
        },
        {
            "resourcegroup": "Steel Re-inforcement",
            "colour": "#d4a6c8"
        },
        {
            "resourcegroup": "Steel - Structural Elements",
            "colour": "#9d7660"
        },
        {
            "resourcegroup": "Street Sweeper",
            "colour": "#b07aa1"
        },
        {
            "resourcegroup": "Timber",
            "colour": "#d7b5a6"
        },
        {
            "resourcegroup": "Tower Cranes",
            "colour": "#d7c5af"
        },
        {
            "resourcegroup": "WC",
            "colour": "#f28e2b"
        }
    ];
    const nonLabourValuesRef = (0, $i5lfL.useRef)([]);
    const nonLabourTonnageRef = (0, $i5lfL.useRef)([]);
    const { data: nonLabourValuesTonnage, status: nonLabourStatus, fetchStatus: nonLabourFetchStatus, error: nonLabourError, refetch: refetchNonLabourValuesTonnage } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "NonLabourValuesTonnage"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $98dbd14a43c62e7a$export$e3b2c9669a66eaf9),
                variables: queryVariables,
                instance: instance,
                accounts: accounts
            });
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        cacheTime: Infinity,
        enabled: !!userInfo
    });
    // Start - non labour value chart
    // Set the non labour value chart options
    const nonlabour_value_options = {
        layout: {
            padding: {
                top: 20
            }
        },
        plugins: {
            htmlLegend: {
                container: valueLegendContainer
            },
            title: {
                display: false,
                text: 'Non-labour demand in value ($)'
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem)=>{
                        let label = tooltipItem.dataset.label;
                        return label + ': ' + new Intl.NumberFormat("en-AU", {
                            style: "currency",
                            currency: "AUD",
                            currencyDisplay: "narrowSymbol",
                            notation: "compact",
                            compactDisplay: "short"
                        }).format(tooltipItem.parsed.y);
                    }
                }
            },
            legend: {
                display: false
            },
            datalabels: {
                anchor: 'end',
                align: 'end',
                offset: 0,
                formatter: (value, ctx)=>{
                    const total = ctx.chart.$totalizer.totals[ctx.dataIndex];
                    return new Intl.NumberFormat("en-AU", {
                        style: "currency",
                        currency: "AUD",
                        currencyDisplay: "narrowSymbol",
                        notation: "compact",
                        compactDisplay: "short"
                    }).format(total);
                },
                display: function(ctx) {
                    return ctx.datasetIndex === ctx.chart.$totalizer.utmost;
                }
            }
        },
        responsive: false,
        aspectRatio: 1,
        scales: {
            x: {
                stacked: true
            },
            y: {
                stacked: true,
                ticks: {
                    callback: (value, index, ticks)=>{
                        return new Intl.NumberFormat("en-AU", {
                            style: "currency",
                            currency: "AUD",
                            currencyDisplay: "narrowSymbol",
                            notation: "compact",
                            compactDisplay: "short"
                        }).format(value);
                    }
                }
            }
        }
    };
    // Build the chart datasets dynamically
    const value_resource_groups = [
        ...new Set(nonLabourValuesRef.current.map((item)=>item.ResourceGroup))
    ];
    const years = [
        ...new Set(nonLabourValuesRef.current.map((item)=>item.Year))
    ];
    // Not sure if there is a cleaner way to
    // write the following code. Essentially it
    // is adding missing Year/ResourceGroup data.
    // The chart will fail to render correctly if
    // the missing data is not there.
    // Note: this code solution only applies to 
    // stacked bar chart.
    years.forEach((year)=>{
        value_resource_groups.forEach((resource)=>{
            const exists = nonLabourValuesRef.current.find((i)=>i.Year === year && i.ResourceGroup === resource);
            if (!exists) nonLabourValuesRef.current.push({
                ResourceGroup: resource,
                Year: year,
                Value: 0
            });
        });
    });
    // Sort the results from the above
    nonLabourValuesRef.current.sort((a, b)=>{
        return a.Year - b.Year || a.ResourceGroup.localeCompare(b.ResourceGroup);
    });
    // Build the datasets
    const nonlabour_value_datasets = [
        ...new Set(value_resource_groups.map((resource_group)=>{
            return {
                label: resource_group,
                data: nonLabourValuesRef.current.filter((obj)=>obj.ResourceGroup === resource_group).map((filObj)=>filObj.Value),
                backgroundColor: nonlabour_colours.find((x)=>x.resourcegroup === resource_group)?.colour
            };
        }))
    ];
    // Sort the data by the value amount
    // and create the unique years array
    nonlabour_value_datasets.sort((a, b)=>Math.max(...b.data) - Math.max(...a.data));
    const nonlabour_value_chart = {
        labels: years,
        datasets: nonlabour_value_datasets
    };
    // End - non labour value chart
    // Start - non labour tonnage chart
    // Set the non labour tonnage chart options
    const nonlabour_tonnage_options = {
        layout: {
            padding: {
                top: 20
            }
        },
        plugins: {
            htmlLegend: {
                container: tonnageLegendContainer
            },
            title: {
                display: false,
                text: 'Non-labour demand in tonnage'
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem)=>{
                        let label = tooltipItem.dataset.label;
                        return label + ': ' + new Intl.NumberFormat("en-AU", {
                            notation: "compact",
                            compactDisplay: "short"
                        }).format(tooltipItem.parsed.y);
                    }
                }
            },
            legend: {
                display: false
            },
            datalabels: {
                anchor: 'end',
                align: 'end',
                offset: 0,
                formatter: (value, ctx)=>{
                    const total = ctx.chart.$totalizer.totals[ctx.dataIndex];
                    return new Intl.NumberFormat("en-AU", {
                        notation: "compact",
                        compactDisplay: "short"
                    }).format(total);
                },
                display: function(ctx) {
                    return ctx.datasetIndex === ctx.chart.$totalizer.utmost;
                }
            }
        },
        responsive: false,
        aspectRatio: 1,
        scales: {
            x: {
                stacked: true
            },
            y: {
                stacked: true,
                ticks: {
                    callback: (value, index, ticks)=>{
                        return new Intl.NumberFormat("en-AU", {
                            notation: "compact",
                            compactDisplay: "short"
                        }).format(value);
                    }
                }
            }
        }
    };
    // Build the chart datasets dynamically
    const tonnage_resource_groups = [
        ...new Set(nonLabourTonnageRef.current.map((item)=>item.ResourceGroup))
    ];
    const tonnage_years = [
        ...new Set(nonLabourTonnageRef.current.map((item)=>item.Year))
    ];
    // Not sure if there is a cleaner way to
    // write the following code. Essentially it
    // is adding missing Year/ResourceGroup data.
    // The chart will fail to render correctly if
    // the missing data is not there.
    // Note: this code solution only applies to 
    // stacked bar chart.
    tonnage_years.forEach((year)=>{
        tonnage_resource_groups.forEach((resource)=>{
            const exists = nonLabourTonnageRef.current.find((i)=>i.Year === year && i.ResourceGroup === resource);
            if (!exists) nonLabourTonnageRef.current.push({
                ResourceGroup: resource,
                Year: year,
                Unit: 0
            });
        });
    });
    // Sort the results from the above
    nonLabourTonnageRef.current.sort((a, b)=>{
        return a.Year - b.Year || a.ResourceGroup.localeCompare(b.ResourceGroup);
    });
    // Build the datasets
    const nonlabour_tonnage_datasets = [
        ...new Set(tonnage_resource_groups.map((resource_group)=>{
            return {
                label: resource_group,
                data: nonLabourTonnageRef.current.filter((obj)=>obj.ResourceGroup === resource_group).map((filObj)=>filObj.Unit),
                backgroundColor: nonlabour_colours.find((x)=>x.resourcegroup === resource_group)?.colour
            };
        }))
    ];
    // Sort the data by the tonnage amount
    // and create the unique years array
    nonlabour_tonnage_datasets.sort((a, b)=>Math.max(...b.data) - Math.max(...a.data));
    const nonlabour_tonnage_chart = {
        labels: tonnage_years,
        datasets: nonlabour_tonnage_datasets
    };
    // End - non labour tonnage chart
    (0, $i5lfL.useEffect)(()=>{
        if (nonLabourStatus == 'error') console.log(nonLabourError);
        else if (nonLabourStatus == 'success' && nonLabourFetchStatus == 'idle') {
            const records = nonLabourValuesTonnage.executeRetrieveNonLabourValueTonnage;
            nonLabourValuesRef.current = [];
            records.reduce((res, value)=>{
                if (!res[value.ResourceGroup + '-' + value.Year]) {
                    res[value.ResourceGroup + '-' + value.Year] = {
                        ResourceGroup: value.ResourceGroup,
                        Value: 0,
                        Year: value.Year
                    };
                    nonLabourValuesRef.current.push(res[value.ResourceGroup + '-' + value.Year]);
                }
                res[value.ResourceGroup + '-' + value.Year].Value += value.Value;
                return res;
            }, {});
            nonLabourTonnageRef.current = [];
            records.reduce((res, value)=>{
                if (value.PLEMGroup === 'Material') {
                    if (!res[value.ResourceGroup + '-' + value.Year]) {
                        res[value.ResourceGroup + '-' + value.Year] = {
                            ResourceGroup: value.ResourceGroup,
                            Unit: 0,
                            Year: value.Year
                        };
                        nonLabourTonnageRef.current.push(res[value.ResourceGroup + '-' + value.Year]);
                    }
                    res[value.ResourceGroup + '-' + value.Year].Unit += value.Unit;
                }
                return res;
            }, {});
            nonLabourChartLoader.current.style.display = 'none';
            setNonLabourTab(false);
        }
    }, [
        nonLabourValuesTonnage,
        nonLabourStatus,
        nonLabourFetchStatus,
        nonLabourError
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (updateNonLabourCharts) {
            nonLabourChartLoader.current.style.display = 'flex';
            refetchNonLabourValuesTonnage();
        }
    }, [
        updateNonLabourCharts
    ]);
    return /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                ref: nonLabourChartLoader,
                style: {
                    position: "absolute",
                    display: "flex",
                    zIndex: "200",
                    width: 1000,
                    height: 1210,
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(51, 51, 51, 0.4)"
                },
                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $753bfae0ab95f468$export$67ad50c48ca3ede4), {
                    visible: true,
                    height: "80",
                    width: "80",
                    color: "#005670",
                    secondaryColor: "#005670",
                    ariaLabel: "oval-loading",
                    wrapperStyle: {},
                    wrapperClass: ""
                })
            }),
            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                container: true,
                direction: "column",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                style: {
                                    display: "flex",
                                    width: 1000,
                                    backgroundColor: "rgb(0, 86, 112)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                        style: {
                                            display: "flex",
                                            width: 600,
                                            color: "#FFF",
                                            fontWeight: 600,
                                            fontSize: "1.25rem",
                                            fontFamily: "ProximaNova",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        },
                                        children: "Non-labour demand in value ($)"
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 1,
                                        columns: 2,
                                        sx: {
                                            width: 400,
                                            flexGrow: 1,
                                            justifyContent: "flex-end",
                                            backgroundColor: "white"
                                        },
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3e2b651951504e8a$export$2e2bcd8739ae039), {
                                            AllMapLists: allMapLists,
                                            plotQueryProps: nonLabourPlotQueryProps,
                                            setPlotQueryProps: setNonLabourPlotQueryProps,
                                            filterConfigList: (0, $53fcf24220e283f8$export$bb3f8fd74a16c1d1),
                                            listsDisabled: false,
                                            applyUpdates: applyUpdates
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                            style: {
                                                display: "relative",
                                                width: 800,
                                                height: 550
                                            },
                                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30e31766597ec5b3$export$bbc6c6369b38e3d1), {
                                                options: nonlabour_value_options,
                                                data: nonlabour_value_chart,
                                                plugins: [
                                                    (0, $7c70d3c39411cd95$export$2e2bcd8739ae039),
                                                    (0, $93fbc20a8fadecf2$export$2e2bcd8739ae039),
                                                    (0, $08e074ffb9935151$export$2e2bcd8739ae039)
                                                ],
                                                width: "800",
                                                height: "550"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                            ref: valueLegendContainer,
                                            style: {
                                                width: 195,
                                                height: 550,
                                                overflow: "auto",
                                                border: "0.7px solid #e0e0e0"
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                style: {
                                    display: "flex",
                                    width: 1000,
                                    backgroundColor: "rgb(0, 86, 112)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                        style: {
                                            display: "flex",
                                            width: 800,
                                            color: "#FFF",
                                            fontWeight: 600,
                                            fontSize: "1.25rem",
                                            fontFamily: "ProximaNova",
                                            justifyContent: "flex-start",
                                            alignItems: "center"
                                        },
                                        children: "Non-labour demand in tonnage"
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 1,
                                        columns: 1,
                                        sx: {
                                            width: 200,
                                            flexGrow: 1,
                                            justifyContent: "flex-end",
                                            backgroundColor: "white"
                                        },
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3e2b651951504e8a$export$2e2bcd8739ae039), {
                                            AllMapLists: allMapLists,
                                            plotQueryProps: nonLabourPlotQueryProps,
                                            setPlotQueryProps: setNonLabourPlotQueryProps,
                                            filterConfigList: (0, $53fcf24220e283f8$export$3c744f943c267ae3),
                                            listsDisabled: false,
                                            applyUpdates: applyUpdates
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                            style: {
                                                display: "relative",
                                                width: 800,
                                                height: 550
                                            },
                                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $30e31766597ec5b3$export$bbc6c6369b38e3d1), {
                                                options: nonlabour_tonnage_options,
                                                data: nonlabour_tonnage_chart,
                                                plugins: [
                                                    (0, $7c70d3c39411cd95$export$2e2bcd8739ae039),
                                                    (0, $93fbc20a8fadecf2$export$2e2bcd8739ae039),
                                                    (0, $08e074ffb9935151$export$2e2bcd8739ae039)
                                                ],
                                                width: "800",
                                                height: "550"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                            ref: tonnageLegendContainer,
                                            style: {
                                                width: 195,
                                                height: 550,
                                                overflow: "auto",
                                                border: "0.7px solid #e0e0e0"
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}





function $06c18325cdfd5569$export$2e2bcd8739ae039() {
    // Dates
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    // GeoJSON object
    const geojson = new (0, $c6f7374fc2e125d0$export$2e2bcd8739ae039)();
    // Authentication
    const { instance: instance, accounts: accounts } = (0, $3f0c670b43f101ac$export$f41558044a1dd55)();
    const { data: userInfo } = (0, $8aac0537827a6bae$export$801fe16824f675f7)();
    const isMounted = (0, $i5lfL.useRef)(false);
    // References to html components
    const mapContainer = (0, $i5lfL.useRef)();
    const legendContainer = (0, $i5lfL.useRef)();
    const infoContainer = (0, $i5lfL.useRef)();
    const fiscalYearRangeContainer = (0, $i5lfL.useRef)();
    const fiscalYearRangeRef = (0, $i5lfL.useRef)();
    const calendarYearContainer = (0, $i5lfL.useRef)();
    const calendarYearRef = (0, $i5lfL.useRef)();
    const emptyYearContainer = (0, $i5lfL.useRef)();
    const mapLoader = (0, $i5lfL.useRef)();
    const alertContainer = (0, $i5lfL.useRef)();
    // Disable/Enable components
    const [sa4MapTab, setSa4MapTab] = (0, $i5lfL.useState)(true);
    const [stateMapTab, setStateMapTab] = (0, $i5lfL.useState)(true);
    const [overTimeMapTab, setOverTimeMapTab] = (0, $i5lfL.useState)(true);
    const [perCapitaMapTab, setPerCapitaMapTab] = (0, $i5lfL.useState)(true);
    const [investmentTab, setInvestmentTab] = (0, $i5lfL.useState)(true);
    const [labourTab, setLabourTab] = (0, $i5lfL.useState)(true);
    const [nonLabourTab, setNonLabourTab] = (0, $i5lfL.useState)(true);
    const [fiscalYearsSlider, setFiscalYearsSlider] = (0, $i5lfL.useState)(true);
    const [calendarYearsSlider, setCalendarYearsSlider] = (0, $i5lfL.useState)(true);
    const [caveat, setCaveat] = (0, $i5lfL.useState)('');
    // Map values refs
    const sa4MapInvestmentValuesRef = (0, $i5lfL.useRef)([]);
    const stateMapInvestmentValuesRef = (0, $i5lfL.useRef)([]);
    const sa4OverTimeValuesRef = (0, $i5lfL.useRef)([]);
    const sa4PerCapitaValuesRef = (0, $i5lfL.useRef)([]);
    // Extent state
    // const [tileCount, setTileCount] = useState(0);
    // const [updateExtent, setUpdateExtent] = useState(false);
    // const [currentExtent, setCurrentExtent] = usePersistedState<number[]>('currentExtent', []);
    // Attribute lists state
    const [listsDisabled, setListsDisabled] = (0, $i5lfL.useState)(true);
    const [mapPlotQueryProps, setMapPlotQueryProps] = (0, $15fcb3e9846e132a$export$2e2bcd8739ae039)('mapPlotQueryProps', {
        inState: [
            "ALL"
        ],
        inLocationType: [
            "ALL"
        ],
        inInvestmentTier: [
            "ALL"
        ],
        inCommonwealthFunded: [
            "ALL"
        ],
        inPipeline: [
            "ALL"
        ],
        inProjectPhase: [
            "ALL"
        ],
        inSuperSector: [
            "ALL"
        ],
        inMasterType: [
            "ALL"
        ],
        inProjectType: [
            "ALL"
        ]
    });
    const [labourPlotQueryProps, setLabourPlotQueryProps] = (0, $15fcb3e9846e132a$export$2e2bcd8739ae039)('labourPlotQueryProps', {
        inLvl1Group: [
            "ALL"
        ],
        inResourceGroup: [
            "ALL"
        ]
    });
    const [nonLabourPlotQueryProps, setNonLabourPlotQueryProps] = (0, $15fcb3e9846e132a$export$2e2bcd8739ae039)('nonLabourPlotQueryProps', {
        inPLEMGroup: [
            "ALL"
        ],
        inResourceGroup: [
            "ALL"
        ]
    });
    // Query values state
    const [queryVariables, setQueryVariables] = (0, $15fcb3e9846e132a$export$2e2bcd8739ae039)('queryVariables', {
        inState: "",
        inLocationType: "",
        inInvestmentTier: "",
        inCommonwealthFunded: "",
        inPipeline: "",
        inProjectPhase: "",
        inSuperSector: "",
        inMasterType: "",
        inProjectType: "",
        inPLEMGroup: "",
        inLvl1Group: "",
        inResourceGroup: "",
        inStartYear: 0,
        inEndYear: 0,
        inCalendarYear: currentYear,
        inYear: currentYear,
        inMonth: currentMonth
    });
    // Set component updates
    const [updates, setUpdates] = (0, $i5lfL.useState)({
        isFiscalYears: false,
        isCalendarYear: false,
        isRegion: false,
        isOther: false,
        isLabour: false,
        isNonLabour: false
    });
    // Update charts state
    const [updateInvestmentCharts, setUpdateInvestmentCharts] = (0, $i5lfL.useState)(0);
    const [updateLabourCharts, setUpdateLabourCharts] = (0, $i5lfL.useState)(0);
    const [updateNonLabourCharts, setUpdateNonLabourCharts] = (0, $i5lfL.useState)(0);
    // State to manage Alert properties
    const [alertOptions, setAlertOptions] = (0, $i5lfL.useState)({
        show: false,
        type: 'info',
        content: ''
    });
    // Legend/Map colours
    const map_colours = [
        "#b3e0a6",
        "#ffdf8e",
        "#eeab26",
        "#ff3b29",
        "#aa0f40"
    ];
    const { data: allMapLists, status: allMapListsStatus, fetchStatus: allMapListsFetchStatus, error: allMapListsError, refetch: refetchAllMapLists } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "ALLMapLists"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $98dbd14a43c62e7a$export$4b25886ba9aee002),
                variables: queryVariables,
                instance: instance,
                accounts: accounts
            });
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        cacheTime: Infinity,
        enabled: !!userInfo
    });
    const { data: fiscalYears, status: fiscalYearsStatus, fetchStatus: fiscalYearsFetchStatus, error: fiscalYearsError } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "FiscalYears"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $98dbd14a43c62e7a$export$df3c6e1deb699fea),
                instance: instance,
                accounts: accounts
            });
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        cacheTime: Infinity,
        enabled: !!userInfo
    });
    const { data: stateSa4MapInvestmentValues, status: stateSa4MapInvestmentStatus, fetchStatus: stateSa4MapInvestmentFetchStatus, error: stateSa4MapInvestmentError, refetch: refetchStateSa4MapInvestmentValues } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "StateSA4MapInvestmentValues"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $98dbd14a43c62e7a$export$be9511b49d625296),
                variables: queryVariables,
                instance: instance,
                accounts: accounts
            });
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        cacheTime: Infinity,
        enabled: !!userInfo
    });
    const { data: sa4OverTimeValues, status: sa4OverTimeStatus, fetchStatus: sa4OverTimeFetchStatus, error: sa4OverTimeError, refetch: refetchSA4OverTimeValues } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "SA4OverTimeValues"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $98dbd14a43c62e7a$export$e024bd25e1be54c1),
                variables: queryVariables,
                instance: instance,
                accounts: accounts
            });
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        cacheTime: Infinity,
        enabled: !!userInfo
    });
    const { data: sa4PerCapitaValues, status: sa4PerCapitaStatus, fetchStatus: sa4PerCapitaFetchStatus, error: sa4PerCapitaError, refetch: refetchSA4PerCapitaValues } = (0, $45631327982d6a29$export$dd0a697e1782aedd)({
        queryKey: [
            "SA4PerCapitaValues"
        ],
        queryFn: ()=>{
            return (0, $5d270fced5bbffdf$export$52e83573e7782585)({
                query: (0, $98dbd14a43c62e7a$export$8ea94a021e0d96df),
                variables: queryVariables,
                instance: instance,
                accounts: accounts
            });
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        cacheTime: Infinity,
        enabled: !!userInfo
    });
    const updateAlert = (visibility, type, content)=>{
        setAlertOptions({
            show: visibility === 'visible',
            type: type,
            content: content
        });
    };
    // Map style updater
    const updateStyle = async (values)=>{
        if (mapTabIndex.current === 2) // Over time map
        return (f)=>{
            let colour;
            if (f.get('value') >= 0 && f.get('value') <= 1) colour = map_colours[0];
            else if (f.get('value') > 1 && f.get('value') <= 2) colour = map_colours[1];
            else if (f.get('value') > 2 && f.get('value') <= 3) colour = map_colours[2];
            else if (f.get('value') > 3) colour = map_colours[3];
            if (colour) return new (0, $e22912a5c91750c8$export$2e2bcd8739ae039)({
                stroke: new (0, $f461fc147fe0b606$export$2e2bcd8739ae039)({
                    color: 'black',
                    width: 0.7
                }),
                fill: new (0, $138441ca74a86349$export$2e2bcd8739ae039)({
                    color: colour
                })
            });
        };
        else {
            const results = await classify(values);
            if (results.length <= 5) return (f)=>{
                let colour;
                results.forEach((r, i)=>{
                    if (r === f.get('value')) colour = map_colours[i];
                });
                if (colour) return new (0, $e22912a5c91750c8$export$2e2bcd8739ae039)({
                    stroke: new (0, $f461fc147fe0b606$export$2e2bcd8739ae039)({
                        color: 'black',
                        width: 0.7
                    }),
                    fill: new (0, $138441ca74a86349$export$2e2bcd8739ae039)({
                        color: colour
                    })
                });
            };
            else return (f)=>{
                let colour;
                for(let i = 0; i < 5; i++)if (f.get('value') >= results[i] && f.get('value') <= results[i + 1]) colour = map_colours[i];
                if (colour) return new (0, $e22912a5c91750c8$export$2e2bcd8739ae039)({
                    stroke: new (0, $f461fc147fe0b606$export$2e2bcd8739ae039)({
                        color: 'black',
                        width: 0.7
                    }),
                    fill: new (0, $138441ca74a86349$export$2e2bcd8739ae039)({
                        color: colour
                    })
                });
            };
        }
    };
    const formatValue = (value, type)=>{
        if (type === 'percent') return new Intl.NumberFormat("en-AU", {
            style: "percent",
            maximumFractionDigits: 0
        }).format(value);
        else if (type === 'currency') return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
            currencyDisplay: "narrowSymbol",
            notation: "compact",
            compactDisplay: "short"
        }).format(value);
        else return value;
    };
    // Legend style updater
    const [legendHeading, setLegendHeading] = (0, $i5lfL.useState)("");
    const [bins, setBins] = (0, $i5lfL.useState)(Array);
    const updateLegend = async (values)=>{
        if (mapTabIndex.current === 2) // Over time map
        setBins([
            '0% - 100%',
            '100% - 200%',
            '200% - 300%',
            '> 300%'
        ]);
        else {
            const results = await classify(values);
            let binArr = [];
            if (results.length <= 5) results.forEach((r)=>{
                binArr.push(formatValue(r, 'currency'));
            });
            else for(let i = 0; i < 5; i++)binArr.push(formatValue(results[i], 'currency') + " - " + formatValue(results[i + 1], 'currency'));
            setBins(binArr);
        }
    };
    const classify = async (values)=>{
        let results = [];
        if (values.length > 5) {
            if (mapTabIndex.current === 3) // Per capita map
            results = await (0, $0a5780c656d4062e$export$f102267d51b1fa39)((0, $644061faee1c560e$export$a0aa81a0d2b3d5f1).JNK, values, 5);
            else results = await (0, $0a5780c656d4062e$export$f102267d51b1fa39)((0, $644061faee1c560e$export$a0aa81a0d2b3d5f1).GPG, values, 5);
        } else results = values.sort((a, b)=>{
            return a - b;
        });
        // Due to the classification producing
        // numbers with a large precision, 
        // need to make sure that
        // the smallest/largest values are used at
        // the beginning/end of results array.
        results[0] = Math.min(...values);
        results[results.length - 1] = Math.max(...values);
        return results;
    };
    // SA4 map feature styler
    const setSa4Style = (values)=>{
        updateStyle(values).then((s)=>{
            map.getLayers().item(1).setStyle(s);
        });
    };
    // SA4 map layer
    const sa4Layer = new (0, $9db2244bb47aea68$export$2e2bcd8739ae039)({
        visible: false,
        zIndex: 0,
        source: new (0, $429d8626291b2422$export$2e2bcd8739ae039)({
            format: new (0, $6a9883a56e5ed579$export$2e2bcd8739ae039)({
                idProperty: 'oid',
                featureClass: (0, $b9e33cd4bf1ba8a3$export$2e2bcd8739ae039)
            }),
            url: (0, $24846570078166ea$export$a9064eafcaf8348e)
        }),
        style: null
    });
    // SA4 map source data updater
    const sa4Source = sa4Layer.getSource();
    // sa4Source?.on('tileloadstart', (e) => {
    //   setTileCount((count) => count + 1);
    // });
    // sa4Source?.on('tileloaderror', (e) => {
    //   setTileCount((count) => count + 1);
    // });
    sa4Source?.on('tileloadend', (e)=>{
        // @ts-ignore
        const features = e.tile.getFeatures();
        // let bounds: number[] = [];
        features.forEach((f)=>{
            f.set('value', 0, true);
            if (mapTabIndex.current === 0) {
                const found = sa4MapInvestmentValuesRef.current.find((e)=>e['LocationType'] === f.get('sa4_name21'));
                if (found) f.set('value', found['Value'], true);
            } else if (mapTabIndex.current === 2) {
                const found = sa4OverTimeValuesRef.current.find((e)=>e['LocationType'] === f.get('sa4_name21'));
                if (found) {
                    f.set('value', found['Total_Next'] / found['Total_Prev'], true);
                    f.set('prev', found['Total_Prev'], true);
                    f.set('next', found['Total_Next'], true);
                // bounds.length > 0 ? bounds = extend(bounds, f.getGeometry().getExtent()) : bounds = f.getGeometry().getExtent();
                } else f.set('value', -1.0, true);
            } else if (mapTabIndex.current === 3) {
                const found = sa4PerCapitaValuesRef.current.find((e)=>e['LocationType'] === f.get('sa4_name21'));
                if (found) {
                    f.set('value', found['Value'] / found['Population'], true);
                    f.set('inv', found['Value'], true);
                    f.set('pop', found['Population'], true);
                // bounds.length > 0 ? bounds = extend(bounds, f.getGeometry().getExtent()) : bounds = f.getGeometry().getExtent();
                }
            }
        });
    // setCurrentExtent(bounds);
    // setTileCount((count) => count + 1);
    });
    // State map feature styler
    const setStateStyle = (values)=>{
        updateStyle(values).then((s)=>{
            map.getLayers().item(2).setStyle(s);
        });
    };
    // State map layer
    const stateLayer = new (0, $9db2244bb47aea68$export$2e2bcd8739ae039)({
        visible: false,
        zIndex: 1,
        source: new (0, $429d8626291b2422$export$2e2bcd8739ae039)({
            format: new (0, $6a9883a56e5ed579$export$2e2bcd8739ae039)({
                idProperty: 'oid',
                featureClass: (0, $b9e33cd4bf1ba8a3$export$2e2bcd8739ae039)
            }),
            url: (0, $24846570078166ea$export$4a4279851f111273)
        }),
        style: null
    });
    // State map source data updater
    const stateSource = stateLayer.getSource();
    // stateSource?.on('tileloadstart', (e) => {
    //   setTileCount((count) => count + 1);
    // });
    // stateSource?.on('tileloaderror', (e) => {
    //   setTileCount((count) => count + 1);
    // });
    stateSource?.on('tileloadend', (e)=>{
        // @ts-ignore
        const features = e.tile.getFeatures();
        // let bounds: number[] = [];
        features.forEach((f)=>{
            const found = stateMapInvestmentValuesRef.current.find((e)=>e['State'] === f.get('ste_abbr'));
            if (found) f.set('value', found['Value'], true);
        });
    // setCurrentExtent(bounds);
    // setTileCount((count) => count + 1);
    });
    // const getTileCount = (source) => {
    //   const size = map.getSize();
    //   const view = map.getView();
    //   const extent = view.calculateExtent(size);
    //   const zoom = view.getZoom();
    //   let count = 0;
    //   console.log(source.getTileGrid());
    //   source.getTileGrid().forEachTileCoord(extent, zoom, () => {
    //     console.log('count');
    //     ++count;
    //  });
    //   return count
    // }
    // SA4 map hover feature layer
    const sa4Hover = new (0, $9db2244bb47aea68$export$2e2bcd8739ae039)({
        visible: false,
        zIndex: 3,
        renderMode: 'vector',
        // @ts-ignore
        source: sa4Source,
        style: (f)=>{
            // @ts-ignore
            if (f.getId() in sa4Selection) return hoverStyle;
        }
    });
    // State map hover feature layer
    const stateHover = new (0, $9db2244bb47aea68$export$2e2bcd8739ae039)({
        visible: false,
        zIndex: 4,
        renderMode: 'vector',
        // @ts-ignore
        source: stateSource,
        style: (f)=>{
            // @ts-ignore
            if (f.getId() in stateSelection) return hoverStyle;
        }
    });
    // Polygon map selection interaction
    const drawPolygon = new (0, $4074cae391b7ea9d$export$2e2bcd8739ae039)({
        type: 'Polygon',
        style: {
            'stroke-color': '#6666FF',
            'stroke-width': 1.5,
            'fill-color': 'rgba(102, 102, 255, 0.25)'
        }
    });
    // On drawing completion, select the
    // state or sa4 features
    drawPolygon.on('drawend', (e)=>{
        const polygon1 = geojson.writeFeatureObject(e.feature);
        if (polygon1) {
            // Filter either the SA4 and State layer
            if ([
                0,
                2,
                3
            ].indexOf(mapTabIndex.current) >= 0) {
                let locationTypes = '';
                const extent = sa4Source.getTileGrid().getExtent();
                sa4Layer.getFeaturesInExtent(extent).forEach((feature)=>{
                    const polygon2 = geojson.writeFeatureObject(feature);
                    const intersects = (0, $534dcdb527369628$export$1f4807a235930d45)((0, $931c651fe1932ecc$export$4717c67ac3e5e04d)([
                        polygon2,
                        polygon1
                    ]));
                    if (intersects) {
                        const sa4Region = feature.get('sa4_name21');
                        if (!locationTypes.includes(sa4Region)) locationTypes = locationTypes == '' ? sa4Region : locationTypes + '|' + sa4Region;
                    }
                });
                setQueryVariables((queryVariables)=>({
                        ...queryVariables,
                        inLocationType: locationTypes
                    }));
            } else if (mapTabIndex.current == 1) {
                let states = '';
                const extent = stateSource.getTileGrid().getExtent();
                stateLayer.getFeaturesInExtent(extent).forEach((feature)=>{
                    const polygon2 = geojson.writeFeatureObject(feature);
                    const intersects = (0, $534dcdb527369628$export$1f4807a235930d45)((0, $931c651fe1932ecc$export$4717c67ac3e5e04d)([
                        polygon2,
                        polygon1
                    ]));
                    if (intersects) {
                        const state = feature.get('ste_abbr');
                        if (!queryVariables.inState.includes(state)) states = states == '' ? state : states + '|' + state;
                    }
                });
                setQueryVariables((queryVariables)=>({
                        ...queryVariables,
                        inState: states
                    }));
            }
            setUpdates({
                isFiscalYears: false,
                isCalendarYear: false,
                isRegion: true,
                isOther: false,
                isLabour: false,
                isNonLabour: false
            });
        }
    });
    // The map object
    const [map] = (0, $i5lfL.useState)(new (0, $81f11cc9e2668eea$export$2e2bcd8739ae039)({
        view: new (0, $6d96d03cab85bf06$export$2e2bcd8739ae039)({
            enableRotation: false,
            center: [
                14983933,
                -3027317
            ],
            zoom: 4,
            extent: [
                10825600,
                -5717800,
                19142200,
                -336800
            ],
            minZoom: 4,
            maxZoom: 10
        }),
        layers: [
            new (0, $5ffc94e8de19e6f3$export$2e2bcd8739ae039)({
                source: new (0, $1c54370c97223651$export$2e2bcd8739ae039)({
                    url: 'https://{1-4}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png?key=cb1_2ed4_1_c07d3ea1e423045fc646ca1d'
                })
            }),
            sa4Layer,
            stateLayer,
            sa4Hover,
            stateHover
        ],
        interactions: (0, $9bdc14d4619c3a06$export$ebe90cb607ad99e)().extend([
            drawPolygon
        ])
    }));
    // Map layer visibility toggle
    const setLayerVisibility = ()=>{
        const layers = map.getLayers();
        if ([
            0,
            2,
            3
        ].indexOf(mapTabIndex.current) >= 0) {
            if (mapTabIndex.current === 0) {
                setLegendHeading("Total investment per SA4");
                setCaveat((0, $d29d6d1034e01aa1$export$de196134d038efd2));
                const values = sa4MapInvestmentValuesRef.current.map((a)=>a.Value);
                setSa4Style(values);
                updateLegend(values);
            } else if (mapTabIndex.current === 2) {
                setLegendHeading("Investment over time");
                setCaveat((0, $d29d6d1034e01aa1$export$de196134d038efd2));
                const values = sa4OverTimeValuesRef.current.map((a)=>a.Total_Next / a.Total_Prev);
                setSa4Style(values);
                updateLegend(values);
            } else if (mapTabIndex.current === 3) {
                setLegendHeading("Investment per capita");
                // setCaveat(perCapitaCaveat);
                const values = sa4PerCapitaValuesRef.current.map((a)=>a.Value / a.Population);
                setSa4Style(values);
                updateLegend(values);
            }
            // Update layer visibility
            layers.item(2).setVisible(false);
            layers.item(1).setVisible(true);
            layers.item(4).setVisible(false);
            layers.item(3).setVisible(true);
            layers.item(1).getSource().changed();
            layers.item(3).changed();
        } else if (mapTabIndex.current == 1) {
            setLegendHeading("Total investment per State");
            setCaveat((0, $d29d6d1034e01aa1$export$a8f1b1ece045a3c4));
            const values = stateMapInvestmentValuesRef.current.map((a)=>a.Value);
            setStateStyle(values);
            updateLegend(values);
            // Update layer visibility
            layers.item(1).setVisible(false);
            layers.item(2).setVisible(true);
            layers.item(3).setVisible(false);
            layers.item(4).setVisible(true);
            layers.item(2).getSource().changed();
            layers.item(4).changed();
        }
        mapLoader.current.style.display = 'none';
        displayTimeSlider();
    };
    const displayTimeSlider = ()=>{
        if ([
            0,
            1
        ].indexOf(mapTabIndex.current) >= 0) {
            calendarYearContainer.current.style.display = 'none';
            emptyYearContainer.current.style.display = 'none';
            fiscalYearRangeContainer.current.style.display = 'flex';
        } else if (mapTabIndex.current == 2) {
            calendarYearContainer.current.style.display = 'none';
            fiscalYearRangeContainer.current.style.display = 'none';
            emptyYearContainer.current.style.display = 'flex';
        } else if (mapTabIndex.current == 3) {
            fiscalYearRangeContainer.current.style.display = 'none';
            emptyYearContainer.current.style.display = 'none';
            calendarYearContainer.current.style.display = 'flex';
        }
    };
    const setDefaultView = ()=>{
        map.getView().animate({
            zoom: 4
        }, {
            center: [
                14983933,
                -3027317
            ]
        }, {
            duration: 1000
        });
    };
    const resetComponents = ()=>{
        // setTileCount(0);
        // setUpdateExtent(false);
        // setCurrentExtent([]);
        setMapPlotQueryProps({
            inState: [
                "ALL"
            ],
            inLocationType: [
                "ALL"
            ],
            inInvestmentTier: [
                "ALL"
            ],
            inCommonwealthFunded: [
                "ALL"
            ],
            inPipeline: [
                "ALL"
            ],
            inProjectPhase: [
                "ALL"
            ],
            inSuperSector: [
                "ALL"
            ],
            inMasterType: [
                "ALL"
            ],
            inProjectType: [
                "ALL"
            ]
        });
        setLabourPlotQueryProps({
            inLvl1Group: [
                "ALL"
            ],
            inResourceGroup: [
                "ALL"
            ]
        });
        setNonLabourPlotQueryProps({
            inPLEMGroup: [
                "ALL"
            ],
            inResourceGroup: [
                "ALL"
            ]
        });
        setQueryVariables({
            inState: "",
            inLocationType: "",
            inInvestmentTier: "",
            inCommonwealthFunded: "",
            inPipeline: "",
            inProjectPhase: "",
            inSuperSector: "",
            inMasterType: "",
            inProjectType: "",
            inPLEMGroup: "",
            inLvl1Group: "",
            inResourceGroup: "",
            inStartYear: 0,
            inEndYear: 0,
            inCalendarYear: currentYear,
            inYear: currentYear,
            inMonth: currentMonth
        });
        setDefaultView();
        setFiscalYearsSlider(true);
        setFiscalYearRange([
            fiscalYrs[0],
            fiscalYrs[fiscalYrs.length - 1]
        ]);
        setCalendarYearsSlider(true);
        setCalendarYear(currentYear);
        setUpdates({
            isFiscalYears: false,
            isCalendarYear: false,
            isRegion: false,
            isOther: false,
            isLabour: false,
            isNonLabour: false
        });
    };
    const updateComponents = ()=>{
        const isAll = Object.values(updates).every((i)=>i === false);
        mapLoader.current.style.display = 'flex';
        // isAll ? setUpdateExtent(false) : setUpdateExtent(true);
        if (isAll || updates.isRegion || updates.isOther) {
            setListsDisabled(true);
            refetchAllMapLists();
            setOverTimeMapTab(true);
            refetchSA4OverTimeValues();
        }
        if (isAll || updates.isFiscalYears || updates.isRegion || updates.isOther) {
            setSa4MapTab(true);
            setStateMapTab(true);
            refetchStateSa4MapInvestmentValues();
            setInvestmentTab(true);
            setUpdateInvestmentCharts((updateInvestmentCharts)=>updateInvestmentCharts + 1);
        }
        if (isAll || updates.isCalendarYear || updates.isRegion || updates.isOther) {
            setPerCapitaMapTab(true);
            refetchSA4PerCapitaValues();
        }
        if ((isAll || updates.isFiscalYears || updates.isRegion || updates.isLabour) && !updates.isNonLabour) {
            setLabourTab(true);
            setUpdateLabourCharts((updateLabourCharts)=>updateLabourCharts + 1);
        }
        if ((isAll || updates.isFiscalYears || updates.isRegion || updates.isOther || updates.isNonLabour) && !updates.isLabour) {
            setNonLabourTab(true);
            setUpdateNonLabourCharts((updateNonLabourCharts)=>updateNonLabourCharts + 1);
        }
    };
    // Tab state updater
    const [tabMapIndex, setTabMapIndex] = (0, $15fcb3e9846e132a$export$2e2bcd8739ae039)('tabMapIndex', 0);
    const mapTabIndex = (0, $i5lfL.useRef)(tabMapIndex);
    const handleMapChange = (event, newValue)=>{
        setTabMapIndex(newValue);
        mapTabIndex.current = newValue;
        setLayerVisibility();
    };
    const [tabChartIndex, setTabChartIndex] = (0, $15fcb3e9846e132a$export$2e2bcd8739ae039)('tabChartIndex', 0);
    const handleChartChange = (event, newValue)=>{
        setTabChartIndex(newValue);
    };
    // Fix for removing the hover popup
    // when the mouse leaves the map component
    const handleMapLeave = ()=>{
        // @ts-ignore
        map.dispatchEvent({
            type: 'pointermove',
            pixel: []
        });
    };
    // Prevent mouse events on the legend
    // container.
    const handleLegendHover = (event)=>{
        event.stopPropagation();
    };
    // Fiscal year time slider
    const minRange = 1;
    const [fiscalYrs, setFiscalYrs] = (0, $i5lfL.useState)([]);
    const [fiscalYearRange, setFiscalYearRange] = (0, $15fcb3e9846e132a$export$2e2bcd8739ae039)('fiscalYearRange', []);
    const handleYearRangeChange = (event, newValue, activeThumb)=>{
        if (!Array.isArray(newValue)) return;
        if (newValue[1] - newValue[0] < minRange) {
            if (activeThumb === 0) {
                const clamped = Math.min(newValue[0], fiscalYrs[fiscalYrs.length - 1] - minRange);
                setFiscalYearRange([
                    clamped,
                    clamped + minRange
                ]);
            } else {
                const clamped = Math.max(newValue[1], minRange);
                setFiscalYearRange([
                    clamped - minRange,
                    clamped
                ]);
            }
        } else setFiscalYearRange(newValue);
    };
    const handleYearRangeSet = (event, value)=>{
        setQueryVariables((queryVariables)=>({
                ...queryVariables,
                inStartYear: fiscalYearRange[0],
                inEndYear: fiscalYearRange[fiscalYearRange.length - 1]
            }));
        // The fiscal year slider does not
        // apply to the over time and per
        // capita maps.
        setUpdates({
            isFiscalYears: true,
            isCalendarYear: false,
            isRegion: false,
            isOther: false,
            isLabour: false,
            isNonLabour: false
        });
    };
    // Calendar year time slider
    const [calendarYrs, setCalendarYrs] = (0, $i5lfL.useState)([]);
    const [calendarYear, setCalendarYear] = (0, $15fcb3e9846e132a$export$2e2bcd8739ae039)('calendarYear', currentYear);
    const handleYearChange = (event, newValue, activeThumb)=>{
        setCalendarYear(newValue);
    };
    const handleYearSet = (event, value)=>{
        setQueryVariables((queryVariables)=>({
                ...queryVariables,
                inCalendarYear: calendarYear
            }));
        // The calendar year slider only
        // applies to the per capita map
        setUpdates({
            isFiscalYears: false,
            isCalendarYear: true,
            isRegion: false,
            isOther: false,
            isLabour: false,
            isNonLabour: false
        });
    };
    // SA4/State map feature hover style
    const hoverStyle = new (0, $e22912a5c91750c8$export$2e2bcd8739ae039)({
        stroke: new (0, $f461fc147fe0b606$export$2e2bcd8739ae039)({
            color: '#6666FF',
            width: 2
        }),
        fill: new (0, $138441ca74a86349$export$2e2bcd8739ae039)({
            color: 'rgba(255, 255, 255, 0.0)'
        })
    });
    // Sa4/State map layer hover feature popup
    let sa4Selection = {};
    let stateSelection = {};
    map.on('pointermove', (e)=>{
        const layers = map.getLayers();
        if ([
            0,
            2,
            3
        ].indexOf(mapTabIndex.current) >= 0) {
            stateSelection = {};
            layers.item(4).changed();
            layers.item(1).getFeatures(e.pixel).then((features)=>{
                if (!features.length) {
                    infoContainer.current.style.visibility = 'hidden';
                    sa4Selection = {};
                    layers.item(3).changed();
                    return;
                }
                const feature = features[0];
                if (!feature) return;
                else {
                    infoContainer.current.style.left = e.pixel[0] + 'px';
                    infoContainer.current.style.top = e.pixel[1] + 'px';
                    infoContainer.current.style.visibility = 'visible';
                    if (mapTabIndex.current === 0) infoContainer.current.innerText = `SA4 region: ${feature.get('sa4_name21')}\nInvestment: ${formatValue(feature.get('value'), 'currency')}`;
                    else if (mapTabIndex.current === 2) infoContainer.current.innerText = `SA4 region: ${feature.get('sa4_name21')}\nChange in investment: ${formatValue(feature.get('value'), 'percent')}\n4 years to June ${currentYear}: ${formatValue(feature.get('prev'), 'currency')}\n4 years from July ${currentYear}: ${formatValue(feature.get('next'), 'currency')}`;
                    else if (mapTabIndex.current === 3) infoContainer.current.innerText = `SA4 region: ${feature.get('sa4_name21')}\nYear: ${queryVariables.inCalendarYear}\nPopulation: ${feature.get('pop')}\nInvestment: ${formatValue(feature.get('inv'), 'currency')}\nInvestment per capita: ${formatValue(feature.get('value'), 'currency')}`;
                }
                sa4Selection = {};
                const fid = feature.getId();
                // @ts-ignore
                sa4Selection[fid] = feature;
                layers.item(3).changed();
            });
        } else if (mapTabIndex.current == 1) {
            sa4Selection = {};
            layers.item(3).changed();
            layers.item(2).getFeatures(e.pixel).then((features)=>{
                if (!features.length) {
                    infoContainer.current.style.visibility = 'hidden';
                    stateSelection = {};
                    layers.item(4).changed();
                    return;
                }
                const feature = features[0];
                if (!feature) return;
                else {
                    infoContainer.current.style.left = e.pixel[0] + 'px';
                    infoContainer.current.style.top = e.pixel[1] + 'px';
                    infoContainer.current.style.visibility = 'visible';
                    infoContainer.current.innerText = `State: ${feature.get('ste_abbr')}\nInvestment: ${formatValue(feature.get('value'), 'currency')}`;
                }
                stateSelection = {};
                const fid = feature.getId();
                // @ts-ignore
                stateSelection[fid] = feature;
                layers.item(4).changed();
            });
        }
    });
    // When the apply button is clicked,
    // update all the components
    const applyUpdates = (id, values)=>{
        let value;
        if (values[0] === 'ALL') value = '';
        else value = values.join('|');
        setQueryVariables((queryVariables)=>({
                ...queryVariables,
                [id]: value
            }));
        // The region filters apply to
        // all maps and charts. The other 
        // filters do not apply to the 
        // labour charts.
        setUpdates({
            isFiscalYears: false,
            isCalendarYear: false,
            isRegion: id === 'inState' || id === 'inLocationType' ? true : false,
            isOther: id !== 'inState' && id !== 'inLocationType' ? true : false,
            isLabour: (id === 'inLvl1Group' || id === 'inResourceGroup') && tabChartIndex === 1 ? true : false,
            isNonLabour: (id === 'inPLEMGroup' || id === 'inResourceGroup') && tabChartIndex === 2 ? true : false
        });
    };
    (0, $i5lfL.useEffect)(()=>{
        map.setTarget(mapContainer.current);
    }, []);
    (0, $i5lfL.useEffect)(()=>{
        if (allMapListsStatus == 'error') console.log(allMapListsError);
        else if (allMapListsStatus == 'success' && allMapListsFetchStatus == 'idle') setListsDisabled(false);
    }, [
        allMapLists,
        allMapListsStatus,
        allMapListsFetchStatus,
        allMapListsError
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (fiscalYearsStatus == 'error') console.log(fiscalYearsError);
        else if (fiscalYearsStatus == 'success' && fiscalYearsFetchStatus == 'idle') {
            // @ts-ignore
            const records = fiscalYears.executeRetrieveFiscalYears;
            const calendarYrs = [];
            var calendarYear = records.find((item)=>{
                return item.Type === 'calendar_year';
            });
            for(let yr = calendarYear.Min; yr <= calendarYear.Max; yr++)calendarYrs.push(yr);
            setCalendarYrs(calendarYrs);
            const fiscalYrs = [];
            var fiscalYear = records.find((item)=>{
                return item.Type === 'fiscal_year';
            });
            for(let yr = fiscalYear.Min; yr <= fiscalYear.Max; yr++)fiscalYrs.push(yr);
            setFiscalYrs(fiscalYrs);
            if (fiscalYearRange.length === 0) setFiscalYearRange([
                fiscalYrs[0],
                fiscalYrs[fiscalYrs.length - 1]
            ]);
        }
    }, [
        fiscalYears,
        fiscalYearsStatus,
        fiscalYearsFetchStatus,
        fiscalYearsError
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (stateSa4MapInvestmentStatus == 'error') console.log(stateSa4MapInvestmentError);
        else if (stateSa4MapInvestmentStatus == 'success' && stateSa4MapInvestmentFetchStatus == 'idle') {
            // @ts-ignore
            const records = stateSa4MapInvestmentValues.executeRetrieveStateSA4MapInvestment;
            stateMapInvestmentValuesRef.current = [];
            records.reduce((res, value)=>{
                if (!res[value.State]) {
                    res[value.State] = {
                        State: value.State,
                        Value: 0
                    };
                    stateMapInvestmentValuesRef.current.push(res[value.State]);
                }
                res[value.State].Value += value.Value;
                return res;
            }, {});
            sa4MapInvestmentValuesRef.current = [];
            records.reduce((res, value)=>{
                if (value.LocationType !== 'Unknown') {
                    if (!res[value.LocationType]) {
                        res[value.LocationType] = {
                            LocationType: value.LocationType,
                            Value: 0
                        };
                        sa4MapInvestmentValuesRef.current.push(res[value.LocationType]);
                    }
                    res[value.LocationType].Value += value.Value;
                }
                return res;
            }, {});
            if (mapTabIndex.current == 0 || mapTabIndex.current == 1) setLayerVisibility();
            setSa4MapTab(false);
            setStateMapTab(false);
        }
    }, [
        stateSa4MapInvestmentValues,
        stateSa4MapInvestmentStatus,
        stateSa4MapInvestmentFetchStatus,
        stateSa4MapInvestmentError
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (sa4OverTimeStatus == 'error') console.log(sa4OverTimeError);
        else if (sa4OverTimeStatus == 'success' && sa4OverTimeFetchStatus == 'idle') {
            // @ts-ignore
            sa4OverTimeValuesRef.current = sa4OverTimeValues.executeRetrieveSA4OverTimeMapInvestment;
            if (mapTabIndex.current == 2) setLayerVisibility();
            setOverTimeMapTab(false);
        }
    }, [
        sa4OverTimeValues,
        sa4OverTimeStatus,
        sa4OverTimeFetchStatus,
        sa4OverTimeError
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (sa4PerCapitaStatus == 'error') console.log(sa4PerCapitaError);
        else if (sa4PerCapitaStatus == 'success' && sa4PerCapitaFetchStatus == 'idle') {
            // @ts-ignore
            sa4PerCapitaValuesRef.current = sa4PerCapitaValues.executeRetrieveSA4PerCapitaMapInvestment;
            if (mapTabIndex.current == 3) setLayerVisibility();
            setPerCapitaMapTab(false);
        }
    }, [
        sa4PerCapitaValues,
        sa4PerCapitaStatus,
        sa4PerCapitaFetchStatus,
        sa4PerCapitaError
    ]);
    (0, $i5lfL.useEffect)(()=>{
        !sa4MapTab && !stateMapTab && fiscalYrs.length > 0 ? setFiscalYearsSlider(false) : setFiscalYearsSlider(true);
        !perCapitaMapTab && calendarYrs.length > 0 ? setCalendarYearsSlider(false) : setCalendarYearsSlider(true);
    }, [
        sa4MapTab,
        stateMapTab,
        perCapitaMapTab,
        fiscalYrs,
        calendarYrs
    ]);
    (0, $i5lfL.useEffect)(()=>{
        if (queryVariables && updates && isMounted.current) updateComponents();
    }, [
        queryVariables,
        updates
    ]);
    (0, $i5lfL.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $94fa2bcc16896cac$export$2e2bcd8739ae039), {
        style: {
            position: "relative",
            width: 1020,
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
            className: "tabBox-root",
            children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                container: true,
                direction: "column",
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $5540d48de058653b$export$2e2bcd8739ae039), {
                            value: tabMapIndex,
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                    className: "tabSelectorBox",
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $2201f6503942c9ea$export$2e2bcd8739ae039), {
                                        onChange: handleMapChange,
                                        indicatorColor: "secondary",
                                        textColor: "inherit",
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                                                label: "SA4 investment",
                                                value: 0,
                                                disabled: sa4MapTab
                                            }, 0),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                                                label: "State investment",
                                                value: 1,
                                                disabled: stateMapTab
                                            }, 1),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                                                label: "SA4 investment over time",
                                                value: 2,
                                                disabled: overTimeMapTab
                                            }, 2),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                                                label: "SA4 investment per capita",
                                                value: 3,
                                                disabled: perCapitaMapTab
                                            }, 3)
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $ad3ecd37a4df4d13$export$2e2bcd8739ae039), {
                                    value: tabMapIndex,
                                    keepMounted: true,
                                    style: {
                                        padding: '5px'
                                    },
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                        container: true,
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                                item: true,
                                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                    style: {
                                                        display: "flex",
                                                        width: 200,
                                                        height: 560
                                                    },
                                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                                        container: true,
                                                        spacing: 1,
                                                        direction: "column",
                                                        children: [
                                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $3e2b651951504e8a$export$2e2bcd8739ae039), {
                                                                AllMapLists: allMapLists,
                                                                plotQueryProps: mapPlotQueryProps,
                                                                setPlotQueryProps: setMapPlotQueryProps,
                                                                filterConfigList: (0, $53fcf24220e283f8$export$338399e40cd7ee5e),
                                                                listsDisabled: listsDisabled,
                                                                applyUpdates: applyUpdates
                                                            }),
                                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                                                item: true,
                                                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $304ed6cd037ae0e7$export$2e2bcd8739ae039), {
                                                                    variant: "contained",
                                                                    style: {
                                                                        width: "100%"
                                                                    },
                                                                    onClick: resetComponents,
                                                                    children: "Clear Filters"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                                                item: true,
                                                children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                    ref: mapContainer,
                                                    style: {
                                                        position: "relative",
                                                        width: 800,
                                                        height: 560
                                                    },
                                                    onMouseLeave: handleMapLeave,
                                                    children: [
                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                            ref: mapLoader,
                                                            style: {
                                                                position: "absolute",
                                                                display: "flex",
                                                                zIndex: "200",
                                                                width: "100%",
                                                                height: "100%",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                backgroundColor: "rgba(51, 51, 51, 0.4)"
                                                            },
                                                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $753bfae0ab95f468$export$67ad50c48ca3ede4), {
                                                                visible: true,
                                                                height: "80",
                                                                width: "80",
                                                                color: "#005670",
                                                                secondaryColor: "#005670",
                                                                ariaLabel: "oval-loading",
                                                                wrapperStyle: {},
                                                                wrapperClass: ""
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                            className: "ol-control",
                                                            style: {
                                                                zIndex: "100",
                                                                top: "3.5em",
                                                                left: "0.5em"
                                                            },
                                                            children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $600c8be2a4008660$export$2e2bcd8739ae039), {
                                                                "aria-label": "house",
                                                                size: "small",
                                                                onClick: setDefaultView,
                                                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bf0e914ba5baf361$exports))), {
                                                                    fontSize: "inherit"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                            ref: legendContainer,
                                                            onMouseOver: handleLegendHover,
                                                            style: {
                                                                position: "absolute",
                                                                zIndex: "101",
                                                                top: "5px",
                                                                right: "5px",
                                                                width: "auto",
                                                                height: "auto",
                                                                display: "inline-block",
                                                                backgroundColor: "rgba(51, 51, 51, 0.6)",
                                                                color: "#fff",
                                                                borderRadius: "4px",
                                                                padding: "5px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                    style: {
                                                                        display: "flex",
                                                                        gap: "5px",
                                                                        fontWeight: 500,
                                                                        fontSize: "0.875rem",
                                                                        fontFamily: "ProximaNova"
                                                                    },
                                                                    children: legendHeading
                                                                }),
                                                                /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                    style: {
                                                                        display: bins[0] ? 'flex' : 'none',
                                                                        gap: "5px",
                                                                        fontWeight: 500,
                                                                        fontSize: "0.875rem",
                                                                        fontFamily: "ProximaNova"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 20,
                                                                                height: 20,
                                                                                backgroundColor: "#b3e0a6",
                                                                                border: "0.7px solid black"
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                            children: bins[0]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                    style: {
                                                                        display: bins[1] ? 'flex' : 'none',
                                                                        gap: "5px",
                                                                        fontWeight: 500,
                                                                        fontSize: "0.875rem",
                                                                        fontFamily: "ProximaNova"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 20,
                                                                                height: 20,
                                                                                backgroundColor: "#ffdf8e",
                                                                                border: "0.7px solid black"
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                            children: bins[1]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                    style: {
                                                                        display: bins[2] ? 'flex' : 'none',
                                                                        gap: "5px",
                                                                        fontWeight: 500,
                                                                        fontSize: "0.875rem",
                                                                        fontFamily: "ProximaNova"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 20,
                                                                                height: 20,
                                                                                backgroundColor: "#eeab26",
                                                                                border: "0.7px solid black"
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                            children: bins[2]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                    style: {
                                                                        display: bins[3] ? 'flex' : 'none',
                                                                        gap: "5px",
                                                                        fontWeight: 500,
                                                                        fontSize: "0.875rem",
                                                                        fontFamily: "ProximaNova"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 20,
                                                                                height: 20,
                                                                                backgroundColor: "#ff3b29",
                                                                                border: "0.7px solid black"
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                            children: bins[3]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                    style: {
                                                                        display: bins[4] ? 'flex' : 'none',
                                                                        gap: "5px",
                                                                        fontWeight: 500,
                                                                        fontSize: "0.875rem",
                                                                        fontFamily: "ProximaNova"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                width: 20,
                                                                                height: 20,
                                                                                backgroundColor: "#aa0f40",
                                                                                border: "0.7px solid black"
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                                            children: bins[4]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                            ref: infoContainer,
                                                            style: {
                                                                position: "absolute",
                                                                zIndex: "102",
                                                                width: "auto",
                                                                height: "auto",
                                                                display: "inline-block",
                                                                visibility: "hidden",
                                                                pointerEvents: "none",
                                                                backgroundColor: "#333",
                                                                color: "#fff",
                                                                borderRadius: "4px",
                                                                padding: "5px",
                                                                left: "50%",
                                                                transform: "translateX(3%)",
                                                                fontWeight: 500,
                                                                fontSize: "0.875rem",
                                                                fontFamily: "ProximaNova"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                                            style: {
                                                                position: "absolute",
                                                                zIndex: "103",
                                                                top: "5px",
                                                                left: "50%",
                                                                transform: "translateX(-50%)",
                                                                width: "auto",
                                                                height: "auto",
                                                                display: "inline-block"
                                                            },
                                                            children: alertOptions.show && /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $097160938072b98e$export$2e2bcd8739ae039), {
                                                                severity: alertOptions.type,
                                                                children: alertOptions.content
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                ref: fiscalYearRangeContainer,
                                sx: {
                                    display: "flex",
                                    width: 1000,
                                    pt: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                        id: "input-slider",
                                        gutterBottom: true,
                                        noWrap: true,
                                        sx: {
                                            width: 100
                                        },
                                        children: "Fiscal Year"
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $36fe94807ea896b0$export$2e2bcd8739ae039), {
                                        ref: fiscalYearRangeRef,
                                        getAriaLabel: ()=>"Fiscal Year Range",
                                        value: fiscalYearRange,
                                        onChange: handleYearRangeChange,
                                        onChangeCommitted: handleYearRangeSet,
                                        valueLabelDisplay: "on",
                                        disableSwap: true,
                                        step: 1,
                                        marks: true,
                                        min: fiscalYrs[0],
                                        max: fiscalYrs[fiscalYrs.length - 1],
                                        disabled: fiscalYearsSlider
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                ref: calendarYearContainer,
                                sx: {
                                    display: "none",
                                    width: 1000,
                                    pt: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $652f32fce481a679$export$2e2bcd8739ae039), {
                                        id: "input-slider",
                                        gutterBottom: true,
                                        noWrap: true,
                                        sx: {
                                            width: 130
                                        },
                                        children: "Calendar Year"
                                    }),
                                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $36fe94807ea896b0$export$2e2bcd8739ae039), {
                                        ref: calendarYearRef,
                                        getAriaLabel: ()=>"Calendar Year",
                                        value: calendarYear,
                                        onChange: handleYearChange,
                                        onChangeCommitted: handleYearSet,
                                        valueLabelDisplay: "on",
                                        disableSwap: true,
                                        step: 1,
                                        marks: true,
                                        min: calendarYrs[0],
                                        max: calendarYrs[calendarYrs.length - 1],
                                        disabled: calendarYearsSlider,
                                        track: false
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                ref: emptyYearContainer,
                                sx: {
                                    display: "none",
                                    width: 1000,
                                    height: 0
                                }
                            }),
                            /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                sx: {
                                    fontStyle: "italic",
                                    fontWeight: 700,
                                    mt: 2,
                                    fontFamily: "ProximaNova-Bold"
                                },
                                children: [
                                    [
                                        0,
                                        1,
                                        2
                                    ].indexOf(mapTabIndex.current) > -1 && /*#__PURE__*/ (0, $bHJbJ.jsx)("strong", {
                                        children: caveat
                                    }),
                                    mapTabIndex.current === 3 && /*#__PURE__*/ (0, $bHJbJ.jsxs)("strong", {
                                        children: [
                                            "Baseline pipeline based on data collected as of Q3 2025 excl unknown SA4 projects. Next data refresh: Q2 2026.",
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)("a", {
                                                target: "_blank",
                                                href: "https://cepar.edu.au/projections-australias-regional-and-remote-populations",
                                                children: "Population calculated based on Projections for Australia's regional and remote population | CEPAR 2022."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $b9012d0e7442d60a$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $5540d48de058653b$export$2e2bcd8739ae039), {
                            value: tabChartIndex,
                            children: [
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $af701d274f0d01b0$export$2e2bcd8739ae039), {
                                    className: "tabSelectorBox",
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $2201f6503942c9ea$export$2e2bcd8739ae039), {
                                        onChange: handleChartChange,
                                        indicatorColor: "secondary",
                                        textColor: "inherit",
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                                                label: "Investment",
                                                value: 0,
                                                disabled: investmentTab
                                            }, 0),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                                                label: "Labour shortage",
                                                value: 1,
                                                disabled: labourTab
                                            }, 1),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d4b11b3a23282916$export$2e2bcd8739ae039), {
                                                label: "Non-labour demand",
                                                value: 2,
                                                disabled: nonLabourTab
                                            }, 2)
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $ad3ecd37a4df4d13$export$2e2bcd8739ae039), {
                                    value: 0,
                                    keepMounted: true,
                                    style: {
                                        padding: '5px'
                                    },
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $8f345cc468d6558e$export$2e2bcd8739ae039), {
                                        queryVariables: queryVariables,
                                        setInvestmentTab: setInvestmentTab,
                                        updateInvestmentCharts: updateInvestmentCharts,
                                        updateAlert: updateAlert
                                    })
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $ad3ecd37a4df4d13$export$2e2bcd8739ae039), {
                                    value: 1,
                                    keepMounted: true,
                                    style: {
                                        padding: '5px'
                                    },
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $d498d22ffbb912e8$export$2e2bcd8739ae039), {
                                        queryVariables: queryVariables,
                                        allMapLists: allMapLists,
                                        setLabourPlotQueryProps: setLabourPlotQueryProps,
                                        labourPlotQueryProps: labourPlotQueryProps,
                                        applyUpdates: applyUpdates,
                                        setLabourTab: setLabourTab,
                                        updateLabourCharts: updateLabourCharts,
                                        updateAlert: updateAlert
                                    })
                                }),
                                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $ad3ecd37a4df4d13$export$2e2bcd8739ae039), {
                                    value: 2,
                                    keepMounted: true,
                                    style: {
                                        padding: '5px'
                                    },
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $e1c12463111ca8ed$export$2e2bcd8739ae039), {
                                        queryVariables: queryVariables,
                                        allMapLists: allMapLists,
                                        setNonLabourPlotQueryProps: setNonLabourPlotQueryProps,
                                        nonLabourPlotQueryProps: nonLabourPlotQueryProps,
                                        applyUpdates: applyUpdates,
                                        setNonLabourTab: setNonLabourTab,
                                        updateNonLabourCharts: updateNonLabourCharts,
                                        updateAlert: updateAlert
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}




function $072df471fa573ff3$var$PageViewTracker() {
    const location = (0, $63d2ce7e33220fc9$export$45d76561a5302f2b)();
    (0, $i5lfL.useEffect)(()=>{
        (0, $eb92e6806ef5b566$export$92ab14d0aa42e41e)(location.pathname + location.search);
    }, [
        location.pathname,
        location.search
    ]);
    return null;
}
function $072df471fa573ff3$export$2e2bcd8739ae039() {
    const isAuthenticated = (0, $91b77ab8667707a4$export$7e9c60d6d1836c84)();
    console.log("isAuthenticated: ", isAuthenticated);
    if (isAuthenticated) return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $e4400acf80ba3bb9$export$3f7734c901feade6), {
        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $0def10581bd2a82b$export$9ba4e89fdfa1fc54), {
            future: {
                v7_startTransition: true,
                v7_relativeSplatPath: true
            },
            children: [
                /*#__PURE__*/ (0, $bHJbJ.jsx)($072df471fa573ff3$var$PageViewTracker, {}),
                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $4a39B.default), {
                    injectFirst: true,
                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $75d54cca41f8f11d$export$2e2bcd8739ae039), {
                        theme: (0, $f78e542a41fde46b$export$2e2bcd8739ae039),
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1b9724080349944a$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $295315439c6d861c$export$dc45bdc734ce6f1e), {
                                dateAdapter: (0, $4ed4d5da8fc9d26b$export$33545c6a80bae043),
                                children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $f7b695d16b75ee9b$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $63d2ce7e33220fc9$export$3565eb3d00ca5a74), {
                                        children: [
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $63d2ce7e33220fc9$export$e7b0ac011bb776c6), {
                                                path: "/",
                                                element: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $e65131909847bbe5$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $63d2ce7e33220fc9$export$e7b0ac011bb776c6), {
                                                path: "/scenario-modelling",
                                                element: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $2844868c7047587e$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $63d2ce7e33220fc9$export$e7b0ac011bb776c6), {
                                                path: "/national-modelling",
                                                element: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $89c65c8973f0037d$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $63d2ce7e33220fc9$export$e7b0ac011bb776c6), {
                                                path: "/state-modelling",
                                                element: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $084d11a9a67aa7fe$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $63d2ce7e33220fc9$export$e7b0ac011bb776c6), {
                                                path: "/national-map",
                                                element: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $06c18325cdfd5569$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $63d2ce7e33220fc9$export$e7b0ac011bb776c6), {
                                                path: "/Glossary",
                                                element: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $ea3a0d8f8c59965d$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $63d2ce7e33220fc9$export$e7b0ac011bb776c6), {
                                                path: "/FAQ",
                                                element: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1af3446558d19db6$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $c566e1b6d61241ec$export$8285a35799c5812b), {
        children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $0def10581bd2a82b$export$9ba4e89fdfa1fc54), {
            future: {
                v7_startTransition: true,
                v7_relativeSplatPath: true
            },
            children: [
                /*#__PURE__*/ (0, $bHJbJ.jsx)($072df471fa573ff3$var$PageViewTracker, {}),
                /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $4a39B.default), {
                    injectFirst: true,
                    children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $75d54cca41f8f11d$export$2e2bcd8739ae039), {
                        theme: (0, $f78e542a41fde46b$export$2e2bcd8739ae039),
                        children: [
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $1b9724080349944a$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $f7b695d16b75ee9b$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $bHJbJ.jsxs)((0, $63d2ce7e33220fc9$export$3565eb3d00ca5a74), {
                                    children: [
                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $63d2ce7e33220fc9$export$e7b0ac011bb776c6), {
                                            path: "/",
                                            element: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $104bbaa82939068f$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $63d2ce7e33220fc9$export$e7b0ac011bb776c6), {
                                            path: "/request-access",
                                            element: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $6fcac87cfa7b43de$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}



/*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-browser v3.27.0 2024-11-05 */ 
/*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $ff3347e9d8dd5c27$export$4cda21933050d9ec = {
    // AzureCloudInstance is not specified.
    None: "none",
    // Microsoft Azure public cloud
    AzurePublic: "https://login.microsoftonline.com",
    // Microsoft PPE
    AzurePpe: "https://login.windows-ppe.net",
    // Microsoft Chinese national/regional cloud
    AzureChina: "https://login.chinacloudapi.cn",
    // Microsoft German national/regional cloud ("Black Forest")
    AzureGermany: "https://login.microsoftonline.de",
    // US Government cloud
    AzureUsGovernment: "https://login.microsoftonline.us"
};

var $7431d2e4a345031a$exports = {};

$parcel$export($7431d2e4a345031a$exports, "redirectUriEmpty", function () { return $7431d2e4a345031a$export$7a02f9bdce79dd4e; });
$parcel$export($7431d2e4a345031a$exports, "claimsRequestParsingError", function () { return $7431d2e4a345031a$export$561c97672a478709; });
$parcel$export($7431d2e4a345031a$exports, "authorityUriInsecure", function () { return $7431d2e4a345031a$export$f77c6af656c8444b; });
$parcel$export($7431d2e4a345031a$exports, "urlParseError", function () { return $7431d2e4a345031a$export$ee2a1a3389f75508; });
$parcel$export($7431d2e4a345031a$exports, "urlEmptyError", function () { return $7431d2e4a345031a$export$859df485a5e0f239; });
$parcel$export($7431d2e4a345031a$exports, "emptyInputScopesError", function () { return $7431d2e4a345031a$export$6ac27379c42383f; });
$parcel$export($7431d2e4a345031a$exports, "invalidPromptValue", function () { return $7431d2e4a345031a$export$ccbe5d2d7c960c35; });
$parcel$export($7431d2e4a345031a$exports, "invalidClaims", function () { return $7431d2e4a345031a$export$96e755c70e0d0e34; });
$parcel$export($7431d2e4a345031a$exports, "tokenRequestEmpty", function () { return $7431d2e4a345031a$export$eca67ff7a91fed9d; });
$parcel$export($7431d2e4a345031a$exports, "logoutRequestEmpty", function () { return $7431d2e4a345031a$export$9eb2eeb401492d88; });
$parcel$export($7431d2e4a345031a$exports, "invalidCodeChallengeMethod", function () { return $7431d2e4a345031a$export$b8d8b332f17376dc; });
$parcel$export($7431d2e4a345031a$exports, "pkceParamsMissing", function () { return $7431d2e4a345031a$export$2da3866b327f1753; });
$parcel$export($7431d2e4a345031a$exports, "invalidCloudDiscoveryMetadata", function () { return $7431d2e4a345031a$export$92a2985751150ca5; });
$parcel$export($7431d2e4a345031a$exports, "invalidAuthorityMetadata", function () { return $7431d2e4a345031a$export$edb4d5942bc8ccff; });
$parcel$export($7431d2e4a345031a$exports, "untrustedAuthority", function () { return $7431d2e4a345031a$export$50c3162fda5f57; });
$parcel$export($7431d2e4a345031a$exports, "missingSshJwk", function () { return $7431d2e4a345031a$export$8fbed44b22d9136f; });
$parcel$export($7431d2e4a345031a$exports, "missingSshKid", function () { return $7431d2e4a345031a$export$b728bd8a588956c; });
$parcel$export($7431d2e4a345031a$exports, "missingNonceAuthenticationHeader", function () { return $7431d2e4a345031a$export$4f88b4462bcef15f; });
$parcel$export($7431d2e4a345031a$exports, "invalidAuthenticationHeader", function () { return $7431d2e4a345031a$export$bea58e1a2e503b59; });
$parcel$export($7431d2e4a345031a$exports, "cannotSetOIDCOptions", function () { return $7431d2e4a345031a$export$a5c9fbb90473dca2; });
$parcel$export($7431d2e4a345031a$exports, "cannotAllowNativeBroker", function () { return $7431d2e4a345031a$export$26a4f4cbf9747475; });
$parcel$export($7431d2e4a345031a$exports, "authorityMismatch", function () { return $7431d2e4a345031a$export$91415fb6baea5d09; });
/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $7431d2e4a345031a$export$7a02f9bdce79dd4e = "redirect_uri_empty";
const $7431d2e4a345031a$export$561c97672a478709 = "claims_request_parsing_error";
const $7431d2e4a345031a$export$f77c6af656c8444b = "authority_uri_insecure";
const $7431d2e4a345031a$export$ee2a1a3389f75508 = "url_parse_error";
const $7431d2e4a345031a$export$859df485a5e0f239 = "empty_url_error";
const $7431d2e4a345031a$export$6ac27379c42383f = "empty_input_scopes_error";
const $7431d2e4a345031a$export$ccbe5d2d7c960c35 = "invalid_prompt_value";
const $7431d2e4a345031a$export$96e755c70e0d0e34 = "invalid_claims";
const $7431d2e4a345031a$export$eca67ff7a91fed9d = "token_request_empty";
const $7431d2e4a345031a$export$9eb2eeb401492d88 = "logout_request_empty";
const $7431d2e4a345031a$export$b8d8b332f17376dc = "invalid_code_challenge_method";
const $7431d2e4a345031a$export$2da3866b327f1753 = "pkce_params_missing";
const $7431d2e4a345031a$export$92a2985751150ca5 = "invalid_cloud_discovery_metadata";
const $7431d2e4a345031a$export$edb4d5942bc8ccff = "invalid_authority_metadata";
const $7431d2e4a345031a$export$50c3162fda5f57 = "untrusted_authority";
const $7431d2e4a345031a$export$8fbed44b22d9136f = "missing_ssh_jwk";
const $7431d2e4a345031a$export$b728bd8a588956c = "missing_ssh_kid";
const $7431d2e4a345031a$export$4f88b4462bcef15f = "missing_nonce_authentication_header";
const $7431d2e4a345031a$export$bea58e1a2e503b59 = "invalid_authentication_header";
const $7431d2e4a345031a$export$a5c9fbb90473dca2 = "cannot_set_OIDCOptions";
const $7431d2e4a345031a$export$26a4f4cbf9747475 = "cannot_allow_native_broker";
const $7431d2e4a345031a$export$91415fb6baea5d09 = "authority_mismatch";

/*! @azure/msal-common v14.16.0 2024-11-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $4bd7ca1d74a0da48$export$45752b5111a13710 = {
    [(0, $7431d2e4a345031a$export$7a02f9bdce79dd4e)]: "A redirect URI is required for all calls, and none has been set.",
    [(0, $7431d2e4a345031a$export$561c97672a478709)]: "Could not parse the given claims request object.",
    [(0, $7431d2e4a345031a$export$f77c6af656c8444b)]: "Authority URIs must use https.  Please see here for valid authority configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options",
    [(0, $7431d2e4a345031a$export$ee2a1a3389f75508)]: "URL could not be parsed into appropriate segments.",
    [(0, $7431d2e4a345031a$export$859df485a5e0f239)]: "URL was empty or null.",
    [(0, $7431d2e4a345031a$export$6ac27379c42383f)]: "Scopes cannot be passed as null, undefined or empty array because they are required to obtain an access token.",
    [(0, $7431d2e4a345031a$export$ccbe5d2d7c960c35)]: "Please see here for valid configuration options: https://azuread.github.io/microsoft-authentication-library-for-js/ref/modules/_azure_msal_common.html#commonauthorizationurlrequest",
    [(0, $7431d2e4a345031a$export$96e755c70e0d0e34)]: "Given claims parameter must be a stringified JSON object.",
    [(0, $7431d2e4a345031a$export$eca67ff7a91fed9d)]: "Token request was empty and not found in cache.",
    [(0, $7431d2e4a345031a$export$9eb2eeb401492d88)]: "The logout request was null or undefined.",
    [(0, $7431d2e4a345031a$export$b8d8b332f17376dc)]: 'code_challenge_method passed is invalid. Valid values are "plain" and "S256".',
    [(0, $7431d2e4a345031a$export$2da3866b327f1753)]: "Both params: code_challenge and code_challenge_method are to be passed if to be sent in the request",
    [(0, $7431d2e4a345031a$export$92a2985751150ca5)]: "Invalid cloudDiscoveryMetadata provided. Must be a stringified JSON object containing tenant_discovery_endpoint and metadata fields",
    [(0, $7431d2e4a345031a$export$edb4d5942bc8ccff)]: "Invalid authorityMetadata provided. Must by a stringified JSON object containing authorization_endpoint, token_endpoint, issuer fields.",
    [(0, $7431d2e4a345031a$export$50c3162fda5f57)]: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter.",
    [(0, $7431d2e4a345031a$export$8fbed44b22d9136f)]: "Missing sshJwk in SSH certificate request. A stringified JSON Web Key is required when using the SSH authentication scheme.",
    [(0, $7431d2e4a345031a$export$b728bd8a588956c)]: "Missing sshKid in SSH certificate request. A string that uniquely identifies the public SSH key is required when using the SSH authentication scheme.",
    [(0, $7431d2e4a345031a$export$4f88b4462bcef15f)]: "Unable to find an authentication header containing server nonce. Either the Authentication-Info or WWW-Authenticate headers must be present in order to obtain a server nonce.",
    [(0, $7431d2e4a345031a$export$bea58e1a2e503b59)]: "Invalid authentication header provided",
    [(0, $7431d2e4a345031a$export$a5c9fbb90473dca2)]: "Cannot set OIDCOptions parameter. Please change the protocol mode to OIDC or use a non-Microsoft authority.",
    [(0, $7431d2e4a345031a$export$26a4f4cbf9747475)]: "Cannot set allowNativeBroker parameter to true when not in AAD protocol mode.",
    [(0, $7431d2e4a345031a$export$91415fb6baea5d09)]: "Authority mismatch error. Authority provided in login request or PublicClientApplication config does not match the environment of the provided account. Please use a matching account or make an interactive request to login to this authority."
};
/**
 * ClientConfigurationErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use ClientConfigurationErrorCodes instead
 */ const $4bd7ca1d74a0da48$export$8a1024301e8298df = {
    redirectUriNotSet: {
        code: (0, $7431d2e4a345031a$export$7a02f9bdce79dd4e),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$7a02f9bdce79dd4e]
    },
    claimsRequestParsingError: {
        code: (0, $7431d2e4a345031a$export$561c97672a478709),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$561c97672a478709]
    },
    authorityUriInsecure: {
        code: (0, $7431d2e4a345031a$export$f77c6af656c8444b),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$f77c6af656c8444b]
    },
    urlParseError: {
        code: (0, $7431d2e4a345031a$export$ee2a1a3389f75508),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$ee2a1a3389f75508]
    },
    urlEmptyError: {
        code: (0, $7431d2e4a345031a$export$859df485a5e0f239),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$859df485a5e0f239]
    },
    emptyScopesError: {
        code: (0, $7431d2e4a345031a$export$6ac27379c42383f),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$6ac27379c42383f]
    },
    invalidPrompt: {
        code: (0, $7431d2e4a345031a$export$ccbe5d2d7c960c35),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$ccbe5d2d7c960c35]
    },
    invalidClaimsRequest: {
        code: (0, $7431d2e4a345031a$export$96e755c70e0d0e34),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$96e755c70e0d0e34]
    },
    tokenRequestEmptyError: {
        code: (0, $7431d2e4a345031a$export$eca67ff7a91fed9d),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$eca67ff7a91fed9d]
    },
    logoutRequestEmptyError: {
        code: (0, $7431d2e4a345031a$export$9eb2eeb401492d88),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$9eb2eeb401492d88]
    },
    invalidCodeChallengeMethod: {
        code: (0, $7431d2e4a345031a$export$b8d8b332f17376dc),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$b8d8b332f17376dc]
    },
    invalidCodeChallengeParams: {
        code: (0, $7431d2e4a345031a$export$2da3866b327f1753),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$2da3866b327f1753]
    },
    invalidCloudDiscoveryMetadata: {
        code: (0, $7431d2e4a345031a$export$92a2985751150ca5),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$92a2985751150ca5]
    },
    invalidAuthorityMetadata: {
        code: (0, $7431d2e4a345031a$export$edb4d5942bc8ccff),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$edb4d5942bc8ccff]
    },
    untrustedAuthority: {
        code: (0, $7431d2e4a345031a$export$50c3162fda5f57),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$50c3162fda5f57]
    },
    missingSshJwk: {
        code: (0, $7431d2e4a345031a$export$8fbed44b22d9136f),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$8fbed44b22d9136f]
    },
    missingSshKid: {
        code: (0, $7431d2e4a345031a$export$b728bd8a588956c),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$b728bd8a588956c]
    },
    missingNonceAuthenticationHeader: {
        code: (0, $7431d2e4a345031a$export$4f88b4462bcef15f),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$4f88b4462bcef15f]
    },
    invalidAuthenticationHeader: {
        code: (0, $7431d2e4a345031a$export$bea58e1a2e503b59),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$bea58e1a2e503b59]
    },
    cannotSetOIDCOptions: {
        code: (0, $7431d2e4a345031a$export$a5c9fbb90473dca2),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$a5c9fbb90473dca2]
    },
    cannotAllowNativeBroker: {
        code: (0, $7431d2e4a345031a$export$26a4f4cbf9747475),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$26a4f4cbf9747475]
    },
    authorityMismatch: {
        code: (0, $7431d2e4a345031a$export$91415fb6baea5d09),
        desc: $4bd7ca1d74a0da48$export$45752b5111a13710[0, $7431d2e4a345031a$export$91415fb6baea5d09]
    }
};
/**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ class $4bd7ca1d74a0da48$export$ac9d9d20c2327339 extends (0, $40da14d5d49dd285$export$145273558d58e0ac) {
    constructor(errorCode){
        super(errorCode, $4bd7ca1d74a0da48$export$45752b5111a13710[errorCode]);
        this.name = "ClientConfigurationError";
        Object.setPrototypeOf(this, $4bd7ca1d74a0da48$export$ac9d9d20c2327339.prototype);
    }
}
function $4bd7ca1d74a0da48$export$5d63d098f4f130a1(errorCode) {
    return new $4bd7ca1d74a0da48$export$ac9d9d20c2327339(errorCode);
}

/*! @azure/msal-common v14.16.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $90930effaee4b5bc$export$865f57d401606752 = {
    createNewGuid: ()=>{
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    },
    base64Decode: ()=>{
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    },
    base64Encode: ()=>{
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    },
    base64UrlEncode: ()=>{
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    },
    encodeKid: ()=>{
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    },
    async getPublicKeyThumbprint () {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    },
    async removeTokenBindingKey () {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    },
    async clearKeystore () {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    },
    async signJwt () {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    },
    async hashString () {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
};




/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/* eslint-disable header/header */ const $c9cf9f06071f7708$export$a8ff84c12d48cfa6 = "@azure/msal-common";
const $c9cf9f06071f7708$export$83d89fbfd8236492 = "14.16.0";



/*! @azure/msal-common v14.16.0 2024-11-05 */ 
var $d6bc4864bb049bc4$exports = {};

$parcel$export($d6bc4864bb049bc4$exports, "generateCredentialKey", function () { return $d6bc4864bb049bc4$export$1aaa1362083ec7a3; });
$parcel$export($d6bc4864bb049bc4$exports, "createIdTokenEntity", function () { return $d6bc4864bb049bc4$export$d8a173a23f325769; });
$parcel$export($d6bc4864bb049bc4$exports, "createAccessTokenEntity", function () { return $d6bc4864bb049bc4$export$fa005e75d915b6db; });
$parcel$export($d6bc4864bb049bc4$exports, "createRefreshTokenEntity", function () { return $d6bc4864bb049bc4$export$9095b5885dfa55cc; });
$parcel$export($d6bc4864bb049bc4$exports, "isCredentialEntity", function () { return $d6bc4864bb049bc4$export$b8fc93e8af17dc04; });
$parcel$export($d6bc4864bb049bc4$exports, "isAccessTokenEntity", function () { return $d6bc4864bb049bc4$export$d7e6bcc84cf680df; });
$parcel$export($d6bc4864bb049bc4$exports, "isIdTokenEntity", function () { return $d6bc4864bb049bc4$export$71eec93d11c94dfc; });
$parcel$export($d6bc4864bb049bc4$exports, "isRefreshTokenEntity", function () { return $d6bc4864bb049bc4$export$f1bb3af43d5b8bc7; });
$parcel$export($d6bc4864bb049bc4$exports, "isServerTelemetryEntity", function () { return $d6bc4864bb049bc4$export$7ad16989078344e5; });
$parcel$export($d6bc4864bb049bc4$exports, "isThrottlingEntity", function () { return $d6bc4864bb049bc4$export$7e43cc7efaf4bec2; });
$parcel$export($d6bc4864bb049bc4$exports, "generateAppMetadataKey", function () { return $d6bc4864bb049bc4$export$ddbc6773ab812685; });
$parcel$export($d6bc4864bb049bc4$exports, "isAppMetadataEntity", function () { return $d6bc4864bb049bc4$export$bb2a01b66d0b3486; });
$parcel$export($d6bc4864bb049bc4$exports, "isAuthorityMetadataEntity", function () { return $d6bc4864bb049bc4$export$6231cab310116b3c; });
$parcel$export($d6bc4864bb049bc4$exports, "generateAuthorityMetadataExpiresAt", function () { return $d6bc4864bb049bc4$export$90f464c4238c27e5; });
$parcel$export($d6bc4864bb049bc4$exports, "updateAuthorityEndpointMetadata", function () { return $d6bc4864bb049bc4$export$ef87e8fbd8af5f96; });
$parcel$export($d6bc4864bb049bc4$exports, "updateCloudDiscoveryMetadata", function () { return $d6bc4864bb049bc4$export$6d4972e1d88c8518; });
$parcel$export($d6bc4864bb049bc4$exports, "isAuthorityMetadataExpired", function () { return $d6bc4864bb049bc4$export$b96839cf63a15b0f; });
/*! @azure/msal-common v14.16.0 2024-11-05 */ var $dbb12b3851d257af$exports = {};

$parcel$export($dbb12b3851d257af$exports, "extractTokenClaims", function () { return $dbb12b3851d257af$export$8a59e6f35fb00518; });
$parcel$export($dbb12b3851d257af$exports, "getJWSPayload", function () { return $dbb12b3851d257af$export$b9f318d6daf53c97; });
$parcel$export($dbb12b3851d257af$exports, "checkMaxAge", function () { return $dbb12b3851d257af$export$ee7a34ea7880144c; });
/*! @azure/msal-common v14.16.0 2024-11-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extract token by decoding the rawToken
 *
 * @param encodedToken
 */ function $dbb12b3851d257af$export$8a59e6f35fb00518(encodedToken, base64Decode) {
    const jswPayload = $dbb12b3851d257af$export$b9f318d6daf53c97(encodedToken);
    // token will be decoded to get the username
    try {
        // base64Decode() should throw an error if there is an issue
        const base64Decoded = base64Decode(jswPayload);
        return JSON.parse(base64Decoded);
    } catch (err) {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$ad362b2e3a260143));
    }
}
/**
 * decode a JWT
 *
 * @param authToken
 */ function $dbb12b3851d257af$export$b9f318d6daf53c97(authToken) {
    if (!authToken) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$78d01e29cb494be2));
    const tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
    const matches = tokenPartsRegex.exec(authToken);
    if (!matches || matches.length < 4) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$ad362b2e3a260143));
    /**
     * const crackedToken = {
     *  header: matches[1],
     *  JWSPayload: matches[2],
     *  JWSSig: matches[3],
     * };
     */ return matches[2];
}
/**
 * Determine if the token's max_age has transpired
 */ function $dbb12b3851d257af$export$ee7a34ea7880144c(authTime, maxAge) {
    /*
     * per https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * To force an immediate re-authentication: If an app requires that a user re-authenticate prior to access,
     * provide a value of 0 for the max_age parameter and the AS will force a fresh login.
     */ const fiveMinuteSkew = 300000; // five minutes in milliseconds
    if (maxAge === 0 || Date.now() - fiveMinuteSkew > authTime + maxAge) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$f95fb86904f89749));
}




var $ac7fb5ae1cae46f5$exports = {};

$parcel$export($ac7fb5ae1cae46f5$exports, "nowSeconds", function () { return $ac7fb5ae1cae46f5$export$ae62599a119ac50a; });
$parcel$export($ac7fb5ae1cae46f5$exports, "isTokenExpired", function () { return $ac7fb5ae1cae46f5$export$b007d77a962aa175; });
$parcel$export($ac7fb5ae1cae46f5$exports, "wasClockTurnedBack", function () { return $ac7fb5ae1cae46f5$export$8961be72dcbc368e; });
$parcel$export($ac7fb5ae1cae46f5$exports, "delay", function () { return $ac7fb5ae1cae46f5$export$1391212d75b2ee65; });
/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility functions for managing date and time operations.
 */ /**
 * return the current time in Unix time (seconds).
 */ function $ac7fb5ae1cae46f5$export$ae62599a119ac50a() {
    // Date.getTime() returns in milliseconds.
    return Math.round(new Date().getTime() / 1000.0);
}
/**
 * check if a token is expired based on given UTC time in seconds.
 * @param expiresOn
 */ function $ac7fb5ae1cae46f5$export$b007d77a962aa175(expiresOn, offset) {
    // check for access token expiry
    const expirationSec = Number(expiresOn) || 0;
    const offsetCurrentTimeSec = $ac7fb5ae1cae46f5$export$ae62599a119ac50a() + offset;
    // If current time + offset is greater than token expiration time, then token is expired.
    return offsetCurrentTimeSec > expirationSec;
}
/**
 * If the current time is earlier than the time that a token was cached at, we must discard the token
 * i.e. The system clock was turned back after acquiring the cached token
 * @param cachedAt
 * @param offset
 */ function $ac7fb5ae1cae46f5$export$8961be72dcbc368e(cachedAt) {
    const cachedAtSec = Number(cachedAt);
    return cachedAtSec > $ac7fb5ae1cae46f5$export$ae62599a119ac50a();
}
/**
 * Waits for t number of milliseconds
 * @param t number
 * @param value T
 */ function $ac7fb5ae1cae46f5$export$1391212d75b2ee65(t, value) {
    return new Promise((resolve)=>setTimeout(()=>resolve(value), t));
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Cache Key: <home_account_id>-<environment>-<credential_type>-<client_id or familyId>-<realm>-<scopes>-<claims hash>-<scheme>
 * IdToken Example: uid.utid-login.microsoftonline.com-idtoken-app_client_id-contoso.com
 * AccessToken Example: uid.utid-login.microsoftonline.com-accesstoken-app_client_id-contoso.com-scope1 scope2--pop
 * RefreshToken Example: uid.utid-login.microsoftonline.com-refreshtoken-1-contoso.com
 * @param credentialEntity
 * @returns
 */ function $d6bc4864bb049bc4$export$1aaa1362083ec7a3(credentialEntity) {
    const credentialKey = [
        $d6bc4864bb049bc4$var$generateAccountId(credentialEntity),
        $d6bc4864bb049bc4$var$generateCredentialId(credentialEntity),
        $d6bc4864bb049bc4$var$generateTarget(credentialEntity),
        $d6bc4864bb049bc4$var$generateClaimsHash(credentialEntity),
        $d6bc4864bb049bc4$var$generateScheme(credentialEntity)
    ];
    return credentialKey.join((0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Create IdTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $d6bc4864bb049bc4$export$d8a173a23f325769(homeAccountId, environment, idToken, clientId, tenantId) {
    const idTokenEntity = {
        credentialType: (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ID_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: idToken,
        realm: tenantId
    };
    return idTokenEntity;
}
/**
 * Create AccessTokenEntity
 * @param homeAccountId
 * @param environment
 * @param accessToken
 * @param clientId
 * @param tenantId
 * @param scopes
 * @param expiresOn
 * @param extExpiresOn
 */ function $d6bc4864bb049bc4$export$fa005e75d915b6db(homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, base64Decode, refreshOn, tokenType, userAssertionHash, keyId, requestedClaims, requestedClaimsHash) {
    const atEntity = {
        homeAccountId: homeAccountId,
        credentialType: (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN,
        secret: accessToken,
        cachedAt: (0, $ac7fb5ae1cae46f5$export$ae62599a119ac50a)().toString(),
        expiresOn: expiresOn.toString(),
        extendedExpiresOn: extExpiresOn.toString(),
        environment: environment,
        clientId: clientId,
        realm: tenantId,
        target: scopes,
        tokenType: tokenType || (0, $e6f7ad11e10d0573$export$901491a717da2ba5).BEARER
    };
    if (userAssertionHash) atEntity.userAssertionHash = userAssertionHash;
    if (refreshOn) atEntity.refreshOn = refreshOn.toString();
    if (requestedClaims) {
        atEntity.requestedClaims = requestedClaims;
        atEntity.requestedClaimsHash = requestedClaimsHash;
    }
    /*
     * Create Access Token With Auth Scheme instead of regular access token
     * Cast to lower to handle "bearer" from ADFS
     */ if (atEntity.tokenType?.toLowerCase() !== (0, $e6f7ad11e10d0573$export$901491a717da2ba5).BEARER.toLowerCase()) {
        atEntity.credentialType = (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        switch(atEntity.tokenType){
            case (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP:
                // Make sure keyId is present and add it to credential
                const tokenClaims = (0, $dbb12b3851d257af$export$8a59e6f35fb00518)(accessToken, base64Decode);
                if (!tokenClaims?.cnf?.kid) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$6f89b8a7d491b526));
                atEntity.keyId = tokenClaims.cnf.kid;
                break;
            case (0, $e6f7ad11e10d0573$export$901491a717da2ba5).SSH:
                atEntity.keyId = keyId;
        }
    }
    return atEntity;
}
/**
 * Create RefreshTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $d6bc4864bb049bc4$export$9095b5885dfa55cc(homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash, expiresOn) {
    const rtEntity = {
        credentialType: (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: refreshToken
    };
    if (userAssertionHash) rtEntity.userAssertionHash = userAssertionHash;
    if (familyId) rtEntity.familyId = familyId;
    if (expiresOn) rtEntity.expiresOn = expiresOn.toString();
    return rtEntity;
}
function $d6bc4864bb049bc4$export$b8fc93e8af17dc04(entity) {
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $d6bc4864bb049bc4$export$d7e6bcc84cf680df(entity) {
    if (!entity) return false;
    return $d6bc4864bb049bc4$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity.hasOwnProperty("target") && (entity["credentialType"] === (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN || entity["credentialType"] === (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME);
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $d6bc4864bb049bc4$export$71eec93d11c94dfc(entity) {
    if (!entity) return false;
    return $d6bc4864bb049bc4$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity["credentialType"] === (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ID_TOKEN;
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $d6bc4864bb049bc4$export$f1bb3af43d5b8bc7(entity) {
    if (!entity) return false;
    return $d6bc4864bb049bc4$export$b8fc93e8af17dc04(entity) && entity["credentialType"] === (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN;
}
/**
 * Generate Account Id key component as per the schema: <home_account_id>-<environment>
 */ function $d6bc4864bb049bc4$var$generateAccountId(credentialEntity) {
    const accountId = [
        credentialEntity.homeAccountId,
        credentialEntity.environment
    ];
    return accountId.join((0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Generate Credential Id key component as per the schema: <credential_type>-<client_id>-<realm>
 */ function $d6bc4864bb049bc4$var$generateCredentialId(credentialEntity) {
    const clientOrFamilyId = credentialEntity.credentialType === (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN ? credentialEntity.familyId || credentialEntity.clientId : credentialEntity.clientId;
    const credentialId = [
        credentialEntity.credentialType,
        clientOrFamilyId,
        credentialEntity.realm || ""
    ];
    return credentialId.join((0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Generate target key component as per schema: <target>
 */ function $d6bc4864bb049bc4$var$generateTarget(credentialEntity) {
    return (credentialEntity.target || "").toLowerCase();
}
/**
 * Generate requested claims key component as per schema: <requestedClaims>
 */ function $d6bc4864bb049bc4$var$generateClaimsHash(credentialEntity) {
    return (credentialEntity.requestedClaimsHash || "").toLowerCase();
}
/**
 * Generate scheme key componenet as per schema: <scheme>
 */ function $d6bc4864bb049bc4$var$generateScheme(credentialEntity) {
    /*
     * PoP Tokens and SSH certs include scheme in cache key
     * Cast to lowercase to handle "bearer" from ADFS
     */ return credentialEntity.tokenType && credentialEntity.tokenType.toLowerCase() !== (0, $e6f7ad11e10d0573$export$901491a717da2ba5).BEARER.toLowerCase() ? credentialEntity.tokenType.toLowerCase() : "";
}
/**
 * validates if a given cache entry is "Telemetry", parses <key,value>
 * @param key
 * @param entity
 */ function $d6bc4864bb049bc4$export$7ad16989078344e5(key, entity) {
    const validateKey = key.indexOf((0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).CACHE_KEY) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
    return validateKey && validateEntity;
}
/**
 * validates if a given cache entry is "Throttling", parses <key,value>
 * @param key
 * @param entity
 */ function $d6bc4864bb049bc4$export$7e43cc7efaf4bec2(key, entity) {
    let validateKey = false;
    if (key) validateKey = key.indexOf((0, $e6f7ad11e10d0573$export$a2330d6808e6d893).THROTTLING_PREFIX) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("throttleTime");
    return validateKey && validateEntity;
}
/**
 * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
 */ function $d6bc4864bb049bc4$export$ddbc6773ab812685({ environment: environment, clientId: clientId }) {
    const appMetaDataKeyArray = [
        (0, $e6f7ad11e10d0573$export$7e1bea6dc1b6b32e),
        environment,
        clientId
    ];
    return appMetaDataKeyArray.join((0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/*
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $d6bc4864bb049bc4$export$bb2a01b66d0b3486(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $e6f7ad11e10d0573$export$7e1bea6dc1b6b32e)) === 0 && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("environment");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $d6bc4864bb049bc4$export$6231cab310116b3c(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $e6f7ad11e10d0573$export$d483f966e66f4db5).CACHE_KEY) === 0 && entity.hasOwnProperty("aliases") && entity.hasOwnProperty("preferred_cache") && entity.hasOwnProperty("preferred_network") && entity.hasOwnProperty("canonical_authority") && entity.hasOwnProperty("authorization_endpoint") && entity.hasOwnProperty("token_endpoint") && entity.hasOwnProperty("issuer") && entity.hasOwnProperty("aliasesFromNetwork") && entity.hasOwnProperty("endpointsFromNetwork") && entity.hasOwnProperty("expiresAt") && entity.hasOwnProperty("jwks_uri");
}
/**
 * Reset the exiresAt value
 */ function $d6bc4864bb049bc4$export$90f464c4238c27e5() {
    return (0, $ac7fb5ae1cae46f5$export$ae62599a119ac50a)() + (0, $e6f7ad11e10d0573$export$d483f966e66f4db5).REFRESH_TIME_SECONDS;
}
function $d6bc4864bb049bc4$export$ef87e8fbd8af5f96(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.authorization_endpoint = updatedValues.authorization_endpoint;
    authorityMetadata.token_endpoint = updatedValues.token_endpoint;
    authorityMetadata.end_session_endpoint = updatedValues.end_session_endpoint;
    authorityMetadata.issuer = updatedValues.issuer;
    authorityMetadata.endpointsFromNetwork = fromNetwork;
    authorityMetadata.jwks_uri = updatedValues.jwks_uri;
}
function $d6bc4864bb049bc4$export$6d4972e1d88c8518(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.aliases = updatedValues.aliases;
    authorityMetadata.preferred_cache = updatedValues.preferred_cache;
    authorityMetadata.preferred_network = updatedValues.preferred_network;
    authorityMetadata.aliasesFromNetwork = fromNetwork;
}
/**
 * Returns whether or not the data needs to be refreshed
 */ function $d6bc4864bb049bc4$export$b96839cf63a15b0f(metadata) {
    return metadata.expiresAt <= (0, $ac7fb5ae1cae46f5$export$ae62599a119ac50a)();
}


/*! @azure/msal-common v14.16.0 2024-11-05 */ 
/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ class $2b520034dd7719a3$export$ecc754f99843e759 {
    /**
     * Check if stringified object is empty
     * @param strObj
     */ static isEmptyObj(strObj) {
        if (strObj) try {
            const obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    }
    static startsWith(str, search) {
        return str.indexOf(search) === 0;
    }
    static endsWith(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    }
    /**
     * Parses string into an object.
     *
     * @param query
     */ static queryStringToObject(query) {
        const obj = {};
        const params = query.split("&");
        const decode = (s)=>decodeURIComponent(s.replace(/\+/g, " "));
        params.forEach((pair)=>{
            if (pair.trim()) {
                const [key, value] = pair.split(/=(.+)/g, 2); // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    }
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ static trimArrayEntries(arr) {
        return arr.map((entry)=>entry.trim());
    }
    /**
     * Removes empty strings from array
     * @param arr
     */ static removeEmptyStringsFromArray(arr) {
        return arr.filter((entry)=>{
            return !!entry;
        });
    }
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ static jsonParseHelper(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }
    /**
     * Tests if a given string matches a given pattern, with support for wildcards and queries.
     * @param pattern Wildcard pattern to string match. Supports "*" for wildcards and "?" for queries
     * @param input String to match against
     */ static matchPattern(pattern, input) {
        /**
         * Wildcard support: https://stackoverflow.com/a/3117248/4888559
         * Queries: replaces "?" in string with escaped "\?" for regex test
         */ // eslint-disable-next-line security/detect-non-literal-regexp
        const regex = new RegExp(pattern.replace(/\\/g, "\\\\").replace(/\*/g, "[^ ]*").replace(/\?/g, "\\?"));
        return regex.test(input);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */ class $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99 {
    constructor(inputScopes){
        // Filter empty string and null/undefined array items
        const scopeArr = inputScopes ? (0, $2b520034dd7719a3$export$ecc754f99843e759).trimArrayEntries([
            ...inputScopes
        ]) : [];
        const filteredInput = scopeArr ? (0, $2b520034dd7719a3$export$ecc754f99843e759).removeEmptyStringsFromArray(scopeArr) : [];
        // Validate and filter scopes (validate function throws if validation fails)
        this.validateInputScopes(filteredInput);
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach((scope)=>this.scopes.add(scope));
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */ static fromString(inputScopeString) {
        const scopeString = inputScopeString || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        const inputScopes = scopeString.split(" ");
        return new $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99(inputScopes);
    }
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */ static createSearchScopes(inputScopeString) {
        const scopeSet = new $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99(inputScopeString);
        if (!scopeSet.containsOnlyOIDCScopes()) scopeSet.removeOIDCScopes();
        else scopeSet.removeScope((0, $e6f7ad11e10d0573$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE);
        return scopeSet;
    }
    /**
     * Used to validate the scopes input parameter requested  by the developer.
     * @param {Array<string>} inputScopes - Developer requested permissions. Not all scopes are guaranteed to be included in the access token returned.
     * @param {boolean} scopesRequired - Boolean indicating whether the scopes array is required or not
     */ validateInputScopes(inputScopes) {
        // Check if scopes are required but not given or is an empty array
        if (!inputScopes || inputScopes.length < 1) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$6ac27379c42383f));
    }
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */ containsScope(scope) {
        const lowerCaseScopes = this.printScopesLowerCase().split(" ");
        const lowerCaseScopesSet = new $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99(lowerCaseScopes);
        // compare lowercase scopes
        return scope ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    }
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */ containsScopeSet(scopeSet) {
        if (!scopeSet || scopeSet.scopes.size <= 0) return false;
        return this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every((scope)=>this.containsScope(scope));
    }
    /**
     * Check if set of scopes contains only the defaults
     */ containsOnlyOIDCScopes() {
        let defaultScopeCount = 0;
        (0, $e6f7ad11e10d0573$export$268e88275f5afab2).forEach((defaultScope)=>{
            if (this.containsScope(defaultScope)) defaultScopeCount += 1;
        });
        return this.scopes.size === defaultScopeCount;
    }
    /**
     * Appends single scope if passed
     * @param newScope
     */ appendScope(newScope) {
        if (newScope) this.scopes.add(newScope.trim());
    }
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */ appendScopes(newScopes) {
        try {
            newScopes.forEach((newScope)=>this.appendScope(newScope));
        } catch (e) {
            throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$93883786cf4a4a27));
        }
    }
    /**
     * Removes element from set of scopes.
     * @param scope
     */ removeScope(scope) {
        if (!scope) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$f7a276c01beb068a));
        this.scopes.delete(scope.trim());
    }
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */ removeOIDCScopes() {
        (0, $e6f7ad11e10d0573$export$268e88275f5afab2).forEach((defaultScope)=>{
            this.scopes.delete(defaultScope);
        });
    }
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */ unionScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$41e2ce5958c42c83));
        const unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        this.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        return unionScopes;
    }
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */ intersectingScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$41e2ce5958c42c83));
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) otherScopes.removeOIDCScopes();
        const unionScopes = this.unionScopeSets(otherScopes);
        const sizeOtherScopes = otherScopes.getScopeCount();
        const sizeThisScopes = this.getScopeCount();
        const sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < sizeThisScopes + sizeOtherScopes;
    }
    /**
     * Returns size of set of scopes.
     */ getScopeCount() {
        return this.scopes.size;
    }
    /**
     * Returns the scopes as an array of string values
     */ asArray() {
        const array = [];
        this.scopes.forEach((val)=>array.push(val));
        return array;
    }
    /**
     * Prints scopes into a space-delimited string
     */ printScopes() {
        if (this.scopes) {
            const scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
    }
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */ printScopesLowerCase() {
        return this.printScopes().toLowerCase();
    }
}







/*! @azure/msal-common v14.16.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 


var $734d5def052f4ce7$exports = {};

$parcel$export($734d5def052f4ce7$exports, "stripLeadingHashOrQuery", function () { return $734d5def052f4ce7$export$fe89dd256736a6b3; });
$parcel$export($734d5def052f4ce7$exports, "getDeserializedResponse", function () { return $734d5def052f4ce7$export$f98e0976781b1204; });
/*! @azure/msal-common v14.16.0 2024-11-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Parses hash string from given string. Returns empty string if no hash symbol is found.
 * @param hashString
 */ function $734d5def052f4ce7$export$fe89dd256736a6b3(responseString) {
    if (responseString.startsWith("#/")) return responseString.substring(2);
    else if (responseString.startsWith("#") || responseString.startsWith("?")) return responseString.substring(1);
    return responseString;
}
/**
 * Returns URL hash as server auth code response object.
 */ function $734d5def052f4ce7$export$f98e0976781b1204(responseString) {
    // Check if given hash is empty
    if (!responseString || responseString.indexOf("=") < 0) return null;
    try {
        // Strip the # or ? symbol if present
        const normalizedResponse = $734d5def052f4ce7$export$fe89dd256736a6b3(responseString);
        // If # symbol was not present, above will return empty string, so give original hash value
        const deserializedHash = Object.fromEntries(new URLSearchParams(normalizedResponse));
        // Check for known response properties
        if (deserializedHash.code || deserializedHash.error || deserializedHash.error_description || deserializedHash.state) return deserializedHash;
    } catch (e) {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$14c4d54a8414667f));
    }
    return null;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ class $5f4178fddc0d4f8b$export$3abcdca7229e54f2 {
    get urlString() {
        return this._urlString;
    }
    constructor(url){
        this._urlString = url;
        if (!this._urlString) // Throws error if url is empty
        throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$859df485a5e0f239));
        if (!url.includes("#")) this._urlString = $5f4178fddc0d4f8b$export$3abcdca7229e54f2.canonicalizeUri(url);
    }
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ static canonicalizeUri(url) {
        if (url) {
            let lowerCaseUrl = url.toLowerCase();
            if ((0, $2b520034dd7719a3$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ((0, $2b520034dd7719a3$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!(0, $2b520034dd7719a3$export$ecc754f99843e759).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    }
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ validateAsUri() {
        // Attempts to parse url for uri components
        let components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$ee2a1a3389f75508));
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$ee2a1a3389f75508));
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$f77c6af656c8444b));
    }
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ static appendQueryString(url, queryString) {
        if (!queryString) return url;
        return url.indexOf("?") < 0 ? `${url}?${queryString}` : `${url}&${queryString}`;
    }
    /**
     * Returns a url with the hash removed
     * @param url
     */ static removeHashFromUrl(url) {
        return $5f4178fddc0d4f8b$export$3abcdca7229e54f2.canonicalizeUri(url.split("#")[0]);
    }
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ replaceTenantPath(tenantId) {
        const urlObject = this.getUrlComponents();
        const pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === (0, $e6f7ad11e10d0573$export$e18ac120172ed505).COMMON || pathArray[0] === (0, $e6f7ad11e10d0573$export$e18ac120172ed505).ORGANIZATIONS)) pathArray[0] = tenantId;
        return $5f4178fddc0d4f8b$export$3abcdca7229e54f2.constructAuthorityUriFromObject(urlObject);
    }
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ getUrlComponents() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        const regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        const match = this.urlString.match(regEx);
        if (!match) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$ee2a1a3389f75508));
        // Url component object
        const urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        let pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter((val)=>val && val.length > 0); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (urlComponents.QueryString && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    }
    static getDomainFromUrl(url) {
        const regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        const match = url.match(regEx);
        if (!match) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$ee2a1a3389f75508));
        return match[2];
    }
    static getAbsoluteUrl(relativeUrl, baseUrl) {
        if (relativeUrl[0] === (0, $e6f7ad11e10d0573$export$a002182e51710d39).FORWARD_SLASH) {
            const url = new $5f4178fddc0d4f8b$export$3abcdca7229e54f2(baseUrl);
            const baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    }
    static constructAuthorityUriFromObject(urlObject) {
        return new $5f4178fddc0d4f8b$export$3abcdca7229e54f2(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"));
    }
    /**
     * Check if the hash of the URL string contains known properties
     * @deprecated This API will be removed in a future version
     */ static hashContainsKnownProperties(response) {
        return !!(0, $734d5def052f4ce7$export$f98e0976781b1204)(response);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $0e21b55efe440ffb$export$223f43dfec89cb87 = {
    endpointMetadata: {
        "login.microsoftonline.com": {
            token_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.microsoftonline.com/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.microsoftonline.com/{tenantid}/v2.0",
            authorization_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/logout"
        },
        "login.chinacloudapi.cn": {
            token_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.chinacloudapi.cn/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.partner.microsoftonline.cn/{tenantid}/v2.0",
            authorization_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/logout"
        },
        "login.microsoftonline.us": {
            token_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.microsoftonline.us/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.microsoftonline.us/{tenantid}/v2.0",
            authorization_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/logout"
        }
    },
    instanceDiscoveryMetadata: {
        tenant_discovery_endpoint: "https://{canonicalAuthority}/v2.0/.well-known/openid-configuration",
        metadata: [
            {
                preferred_network: "login.microsoftonline.com",
                preferred_cache: "login.windows.net",
                aliases: [
                    "login.microsoftonline.com",
                    "login.windows.net",
                    "login.microsoft.com",
                    "sts.windows.net"
                ]
            },
            {
                preferred_network: "login.partner.microsoftonline.cn",
                preferred_cache: "login.partner.microsoftonline.cn",
                aliases: [
                    "login.partner.microsoftonline.cn",
                    "login.chinacloudapi.cn"
                ]
            },
            {
                preferred_network: "login.microsoftonline.de",
                preferred_cache: "login.microsoftonline.de",
                aliases: [
                    "login.microsoftonline.de"
                ]
            },
            {
                preferred_network: "login.microsoftonline.us",
                preferred_cache: "login.microsoftonline.us",
                aliases: [
                    "login.microsoftonline.us",
                    "login.usgovcloudapi.net"
                ]
            },
            {
                preferred_network: "login-us.microsoftonline.com",
                preferred_cache: "login-us.microsoftonline.com",
                aliases: [
                    "login-us.microsoftonline.com"
                ]
            }
        ]
    }
};
const $0e21b55efe440ffb$export$f612854287391207 = $0e21b55efe440ffb$export$223f43dfec89cb87.endpointMetadata;
const $0e21b55efe440ffb$export$a21acafc3b6f5582 = $0e21b55efe440ffb$export$223f43dfec89cb87.instanceDiscoveryMetadata;
const $0e21b55efe440ffb$export$7d026f079148cd31 = new Set();
$0e21b55efe440ffb$export$a21acafc3b6f5582.metadata.forEach((metadataEntry)=>{
    metadataEntry.aliases.forEach((alias)=>{
        $0e21b55efe440ffb$export$7d026f079148cd31.add(alias);
    });
});
/**
 * Attempts to get an aliases array from the static authority metadata sources based on the canonical authority host
 * @param staticAuthorityOptions
 * @param logger
 * @returns
 */ function $0e21b55efe440ffb$export$2c21adf4b4d4efc0(staticAuthorityOptions, logger) {
    let staticAliases;
    const canonicalAuthority = staticAuthorityOptions.canonicalAuthority;
    if (canonicalAuthority) {
        const authorityHost = new (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2)(canonicalAuthority).getUrlComponents().HostNameAndPort;
        staticAliases = $0e21b55efe440ffb$export$d195904946de56a1(authorityHost, staticAuthorityOptions.cloudDiscoveryMetadata?.metadata, (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).CONFIG, logger) || $0e21b55efe440ffb$export$d195904946de56a1(authorityHost, $0e21b55efe440ffb$export$a21acafc3b6f5582.metadata, (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).HARDCODED_VALUES, logger) || staticAuthorityOptions.knownAuthorities;
    }
    return staticAliases || [];
}
/**
 * Returns aliases for from the raw cloud discovery metadata passed in
 * @param authorityHost
 * @param rawCloudDiscoveryMetadata
 * @returns
 */ function $0e21b55efe440ffb$export$d195904946de56a1(authorityHost, cloudDiscoveryMetadata, source, logger) {
    logger?.trace(`getAliasesFromMetadata called with source: ${source}`);
    if (authorityHost && cloudDiscoveryMetadata) {
        const metadata = $0e21b55efe440ffb$export$6e21098ea6e60dc(cloudDiscoveryMetadata, authorityHost);
        if (metadata) {
            logger?.trace(`getAliasesFromMetadata: found cloud discovery metadata in ${source}, returning aliases`);
            return metadata.aliases;
        } else logger?.trace(`getAliasesFromMetadata: did not find cloud discovery metadata in ${source}`);
    }
    return null;
}
/**
 * Get cloud discovery metadata for common authorities
 */ function $0e21b55efe440ffb$export$1b1433f93c9873f(authorityHost) {
    const metadata = $0e21b55efe440ffb$export$6e21098ea6e60dc($0e21b55efe440ffb$export$a21acafc3b6f5582.metadata, authorityHost);
    return metadata;
}
/**
 * Searches instance discovery network response for the entry that contains the host in the aliases list
 * @param response
 * @param authority
 */ function $0e21b55efe440ffb$export$6e21098ea6e60dc(response, authorityHost) {
    for(let i = 0; i < response.length; i++){
        const metadata = response[i];
        if (metadata.aliases.includes(authorityHost)) return metadata;
    }
    return null;
}


/*! @azure/msal-common v14.16.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d6b183dca11cc9a2$export$4b5a0d15123a80af = "cache_quota_exceeded";
const $d6b183dca11cc9a2$export$ede5ac6f832527a1 = "cache_error_unknown";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $c58e2101f5d58d45$export$7ab11f0b2c87dadd = {
    [(0, $d6b183dca11cc9a2$export$4b5a0d15123a80af)]: "Exceeded cache storage capacity.",
    [(0, $d6b183dca11cc9a2$export$ede5ac6f832527a1)]: "Unexpected error occurred when using cache storage."
};
/**
 * Error thrown when there is an error with the cache
 */ class $c58e2101f5d58d45$export$78ff06e91c3de382 extends Error {
    constructor(errorCode, errorMessage){
        const message = errorMessage || ($c58e2101f5d58d45$export$7ab11f0b2c87dadd[errorCode] ? $c58e2101f5d58d45$export$7ab11f0b2c87dadd[errorCode] : $c58e2101f5d58d45$export$7ab11f0b2c87dadd[0, $d6b183dca11cc9a2$export$ede5ac6f832527a1]);
        super(`${errorCode}: ${message}`);
        Object.setPrototypeOf(this, $c58e2101f5d58d45$export$78ff06e91c3de382.prototype);
        this.name = "CacheError";
        this.errorCode = errorCode;
        this.errorMessage = message;
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 * @internal
 */ class $4d3b9129094dcedd$export$996e3ea69314b5c6 {
    constructor(clientId, cryptoImpl, logger, staticAuthorityOptions){
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.commonLogger = logger.clone((0, $c9cf9f06071f7708$export$a8ff84c12d48cfa6), (0, $c9cf9f06071f7708$export$83d89fbfd8236492));
        this.staticAuthorityOptions = staticAuthorityOptions;
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return this.buildTenantProfiles(this.getAccountsFilteredBy(accountFilter || {}), accountFilter);
    }
    /**
     * Gets first tenanted AccountInfo object found based on provided filters
     */ getAccountInfoFilteredBy(accountFilter) {
        const allAccounts = this.getAllAccounts(accountFilter);
        if (allAccounts.length > 1) {
            // If one or more accounts are found, prioritize accounts that have an ID token
            const sortedAccounts = allAccounts.sort((account)=>{
                return account.idTokenClaims ? -1 : 1;
            });
            return sortedAccounts[0];
        } else if (allAccounts.length === 1) // If only one account is found, return it regardless of whether a matching ID token was found
        return allAccounts[0];
        else return null;
    }
    /**
     * Returns a single matching
     * @param accountFilter
     * @returns
     */ getBaseAccountInfo(accountFilter) {
        const accountEntities = this.getAccountsFilteredBy(accountFilter);
        if (accountEntities.length > 0) return accountEntities[0].getAccountInfo();
        else return null;
    }
    /**
     * Matches filtered account entities with cached ID tokens that match the tenant profile-specific account filters
     * and builds the account info objects from the matching ID token's claims
     * @param cachedAccounts
     * @param accountFilter
     * @returns Array of AccountInfo objects that match account and tenant profile filters
     */ buildTenantProfiles(cachedAccounts, accountFilter) {
        return cachedAccounts.flatMap((accountEntity)=>{
            return this.getTenantProfilesFromAccountEntity(accountEntity, accountFilter?.tenantId, accountFilter);
        });
    }
    getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, tenantProfileFilter) {
        let tenantedAccountInfo = null;
        let idTokenClaims;
        if (tenantProfileFilter) {
            if (!this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter)) return null;
        }
        const idToken = this.getIdToken(accountInfo, tokenKeys, tenantProfile.tenantId);
        if (idToken) {
            idTokenClaims = (0, $dbb12b3851d257af$export$8a59e6f35fb00518)(idToken.secret, this.cryptoImpl.base64Decode);
            if (!this.idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter)) // ID token sourced claims don't match so this tenant profile is not a match
            return null;
        }
        // Expand tenant profile into account info based on matching tenant profile and if available matching ID token claims
        tenantedAccountInfo = (0, $11db744279a82a57$export$452a054c78b83dad)(accountInfo, tenantProfile, idTokenClaims, idToken?.secret);
        return tenantedAccountInfo;
    }
    getTenantProfilesFromAccountEntity(accountEntity, targetTenantId, tenantProfileFilter) {
        const accountInfo = accountEntity.getAccountInfo();
        let searchTenantProfiles = accountInfo.tenantProfiles || new Map();
        const tokenKeys = this.getTokenKeys();
        // If a tenant ID was provided, only return the tenant profile for that tenant ID if it exists
        if (targetTenantId) {
            const tenantProfile = searchTenantProfiles.get(targetTenantId);
            if (tenantProfile) // Reduce search field to just this tenant profile
            searchTenantProfiles = new Map([
                [
                    targetTenantId,
                    tenantProfile
                ]
            ]);
            else // No tenant profile for search tenant ID, return empty array
            return [];
        }
        const matchingTenantProfiles = [];
        searchTenantProfiles.forEach((tenantProfile)=>{
            const tenantedAccountInfo = this.getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, tenantProfileFilter);
            if (tenantedAccountInfo) matchingTenantProfiles.push(tenantedAccountInfo);
        });
        return matchingTenantProfiles;
    }
    tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter) {
        if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTenantProfile(tenantProfile, tenantProfileFilter.localAccountId)) return false;
        if (!!tenantProfileFilter.name && !(tenantProfile.name === tenantProfileFilter.name)) return false;
        if (tenantProfileFilter.isHomeTenant !== undefined && !(tenantProfile.isHomeTenant === tenantProfileFilter.isHomeTenant)) return false;
        return true;
    }
    idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter) {
        // Tenant Profile filtering
        if (tenantProfileFilter) {
            if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTokenClaims(idTokenClaims, tenantProfileFilter.localAccountId)) return false;
            if (!!tenantProfileFilter.loginHint && !this.matchLoginHintFromTokenClaims(idTokenClaims, tenantProfileFilter.loginHint)) return false;
            if (!!tenantProfileFilter.username && !this.matchUsername(idTokenClaims.preferred_username, tenantProfileFilter.username)) return false;
            if (!!tenantProfileFilter.name && !this.matchName(idTokenClaims, tenantProfileFilter.name)) return false;
            if (!!tenantProfileFilter.sid && !this.matchSid(idTokenClaims, tenantProfileFilter.sid)) return false;
        }
        return true;
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, storeInCache, correlationId) {
        if (!cacheRecord) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$d396103576f879cc));
        try {
            if (!!cacheRecord.account) this.setAccount(cacheRecord.account);
            if (!!cacheRecord.idToken && storeInCache?.idToken !== false) this.setIdTokenCredential(cacheRecord.idToken);
            if (!!cacheRecord.accessToken && storeInCache?.accessToken !== false) await this.saveAccessToken(cacheRecord.accessToken);
            if (!!cacheRecord.refreshToken && storeInCache?.refreshToken !== false) this.setRefreshTokenCredential(cacheRecord.refreshToken);
            if (!!cacheRecord.appMetadata) this.setAppMetadata(cacheRecord.appMetadata);
        } catch (e) {
            this.commonLogger?.error(`CacheManager.saveCacheRecord: failed`);
            if (e instanceof Error) {
                this.commonLogger?.errorPii(`CacheManager.saveCacheRecord: ${e.message}`, correlationId);
                if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.message.includes("exceeded the quota")) {
                    this.commonLogger?.error(`CacheManager.saveCacheRecord: exceeded storage quota`, correlationId);
                    throw new (0, $c58e2101f5d58d45$export$78ff06e91c3de382)((0, $d6b183dca11cc9a2$export$4b5a0d15123a80af));
                } else throw new (0, $c58e2101f5d58d45$export$78ff06e91c3de382)(e.name, e.message);
            } else {
                this.commonLogger?.errorPii(`CacheManager.saveCacheRecord: ${e}`, correlationId);
                throw new (0, $c58e2101f5d58d45$export$78ff06e91c3de382)((0, $d6b183dca11cc9a2$export$ede5ac6f832527a1));
            }
        }
    }
    /**
     * saves access token credential
     * @param credential
     */ async saveAccessToken(credential) {
        const accessTokenFilter = {
            clientId: credential.clientId,
            credentialType: credential.credentialType,
            environment: credential.environment,
            homeAccountId: credential.homeAccountId,
            realm: credential.realm,
            tokenType: credential.tokenType,
            requestedClaimsHash: credential.requestedClaimsHash
        };
        const tokenKeys = this.getTokenKeys();
        const currentScopes = (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).fromString(credential.target);
        const removedAccessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) return;
            const tokenEntity = this.getAccessTokenCredential(key);
            if (tokenEntity && this.credentialMatchesFilter(tokenEntity, accessTokenFilter)) {
                const tokenScopeSet = (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).fromString(tokenEntity.target);
                if (tokenScopeSet.intersectingScopeSets(currentScopes)) removedAccessTokens.push(this.removeAccessToken(key));
            }
        });
        await Promise.all(removedAccessTokens);
        this.setAccessTokenCredential(credential);
    }
    /**
     * Retrieve account entities matching all provided tenant-agnostic filters; if no filter is set, get all account entities in the cache
     * Not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param accountFilter - An object containing Account properties to filter by
     */ getAccountsFilteredBy(accountFilter) {
        const allAccountKeys = this.getAccountKeys();
        const matchingAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            if (!this.isAccountKey(cacheKey, accountFilter.homeAccountId)) // Don't parse value if the key doesn't match the account filters
            return;
            const entity = this.getAccount(cacheKey, this.commonLogger);
            // Match base account fields
            if (!entity) return;
            if (!!accountFilter.homeAccountId && !this.matchHomeAccountId(entity, accountFilter.homeAccountId)) return;
            if (!!accountFilter.username && !this.matchUsername(entity.username, accountFilter.username)) return;
            if (!!accountFilter.environment && !this.matchEnvironment(entity, accountFilter.environment)) return;
            if (!!accountFilter.realm && !this.matchRealm(entity, accountFilter.realm)) return;
            if (!!accountFilter.nativeAccountId && !this.matchNativeAccountId(entity, accountFilter.nativeAccountId)) return;
            if (!!accountFilter.authorityType && !this.matchAuthorityType(entity, accountFilter.authorityType)) return;
            // If at least one tenant profile matches the tenant profile filter, add the account to the list of matching accounts
            const tenantProfileFilter = {
                localAccountId: accountFilter?.localAccountId,
                name: accountFilter?.name
            };
            const matchingTenantProfiles = entity.tenantProfiles?.filter((tenantProfile)=>{
                return this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter);
            });
            if (matchingTenantProfiles && matchingTenantProfiles.length === 0) // No tenant profile for this account matches filter, don't add to list of matching accounts
            return;
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    }
    /**
     * Returns true if the given key matches our account key schema. Also matches homeAccountId and/or tenantId if provided
     * @param key
     * @param homeAccountId
     * @param tenantId
     * @returns
     */ isAccountKey(key, homeAccountId, tenantId) {
        if (key.split((0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).length < 3) // Account cache keys contain 3 items separated by '-' (each item may also contain '-')
        return false;
        if (homeAccountId && !key.toLowerCase().includes(homeAccountId.toLowerCase())) return false;
        if (tenantId && !key.toLowerCase().includes(tenantId.toLowerCase())) return false;
        // Do not check environment as aliasing can cause false negatives
        return true;
    }
    /**
     * Returns true if the given key matches our credential key schema.
     * @param key
     */ isCredentialKey(key) {
        if (key.split((0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).length < 6) // Credential cache keys contain 6 items separated by '-' (each item may also contain '-')
        return false;
        const lowerCaseKey = key.toLowerCase();
        // Credential keys must indicate what credential type they represent
        if (lowerCaseKey.indexOf((0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ID_TOKEN.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN.toLowerCase()) === -1) return false;
        if (lowerCaseKey.indexOf((0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN.toLowerCase()) > -1) {
            // Refresh tokens must contain the client id or family id
            const clientIdValidation = `${(0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN}${(0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}${this.clientId}${(0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}`;
            const familyIdValidation = `${(0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN}${(0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}${(0, $e6f7ad11e10d0573$export$978fe7ab5e74b539)}${(0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}`;
            if (lowerCaseKey.indexOf(clientIdValidation.toLowerCase()) === -1 && lowerCaseKey.indexOf(familyIdValidation.toLowerCase()) === -1) return false;
        } else if (lowerCaseKey.indexOf(this.clientId.toLowerCase()) === -1) // Tokens must contain the clientId
        return false;
        return true;
    }
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @returns
     */ credentialMatchesFilter(entity, filter) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return false;
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) return false;
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */ if (typeof filter.homeAccountId === "string" && !this.matchHomeAccountId(entity, filter.homeAccountId)) return false;
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return false;
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) return false;
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) return false;
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) return false;
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */ if (!!filter.target && !this.matchTarget(entity, filter.target)) return false;
        // If request OR cached entity has requested Claims Hash, check if they match
        if (filter.requestedClaimsHash || entity.requestedClaimsHash) {
            // Don't match if either is undefined or they are different
            if (entity.requestedClaimsHash !== filter.requestedClaimsHash) return false;
        }
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) return false;
            // KeyId (sshKid) in request must match cached SSH certificate keyId because SSH cert is bound to a specific key
            if (filter.tokenType === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).SSH) {
                if (filter.keyId && !this.matchKeyId(entity, filter.keyId)) return false;
            }
        }
        return true;
    }
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     */ getAppMetadataFilteredBy(filter) {
        const allCacheKeys = this.getKeys();
        const matchingAppMetadata = {};
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-appMetadata type cache entities
            if (!this.isAppMetadata(cacheKey)) return;
            // Attempt retrieval
            const entity = this.getAppMetadata(cacheKey);
            if (!entity) return;
            if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return;
            if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return;
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    }
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param filter
     */ getAuthorityMetadataByAlias(host) {
        const allCacheKeys = this.getAuthorityMetadataKeys();
        let matchedEntity = null;
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-authorityMetadata type cache entities
            if (!this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(this.clientId) === -1) return;
            // Attempt retrieval
            const entity = this.getAuthorityMetadata(cacheKey);
            if (!entity) return;
            if (entity.aliases.indexOf(host) === -1) return;
            matchedEntity = entity;
        });
        return matchedEntity;
    }
    /**
     * Removes all accounts and related tokens from cache.
     */ async removeAllAccounts() {
        const allAccountKeys = this.getAccountKeys();
        const removedAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            removedAccounts.push(this.removeAccount(cacheKey));
        });
        await Promise.all(removedAccounts);
    }
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */ async removeAccount(accountKey) {
        const account = this.getAccount(accountKey, this.commonLogger);
        if (!account) return;
        await this.removeAccountContext(account);
        this.removeItem(accountKey);
    }
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ async removeAccountContext(account) {
        const allTokenKeys = this.getTokenKeys();
        const accountId = account.generateAccountId();
        const removedCredentials = [];
        allTokenKeys.idToken.forEach((key)=>{
            if (key.indexOf(accountId) === 0) this.removeIdToken(key);
        });
        allTokenKeys.accessToken.forEach((key)=>{
            if (key.indexOf(accountId) === 0) removedCredentials.push(this.removeAccessToken(key));
        });
        allTokenKeys.refreshToken.forEach((key)=>{
            if (key.indexOf(accountId) === 0) this.removeRefreshToken(key);
        });
        await Promise.all(removedCredentials);
    }
    /**
     * Migrates a single-tenant account and all it's associated alternate cross-tenant account objects in the
     * cache into a condensed multi-tenant account object with tenant profiles.
     * @param accountKey
     * @param accountEntity
     * @param logger
     * @returns
     */ updateOutdatedCachedAccount(accountKey, accountEntity, logger) {
        // Only update if account entity is defined and has no tenantProfiles object (is outdated)
        if (accountEntity && accountEntity.isSingleTenant()) {
            this.commonLogger?.verbose("updateOutdatedCachedAccount: Found a single-tenant (outdated) account entity in the cache, migrating to multi-tenant account entity");
            // Get keys of all accounts belonging to user
            const matchingAccountKeys = this.getAccountKeys().filter((key)=>{
                return key.startsWith(accountEntity.homeAccountId);
            });
            // Get all account entities belonging to user
            const accountsToMerge = [];
            matchingAccountKeys.forEach((key)=>{
                const account = this.getCachedAccountEntity(key);
                if (account) accountsToMerge.push(account);
            });
            // Set base account to home account if available, any account if not
            const baseAccount = accountsToMerge.find((account)=>{
                return (0, $11db744279a82a57$export$bc62fd222eddc2d7)(account.realm, account.homeAccountId);
            }) || accountsToMerge[0];
            // Populate tenant profiles built from each account entity belonging to the user
            baseAccount.tenantProfiles = accountsToMerge.map((account)=>{
                return {
                    tenantId: account.realm,
                    localAccountId: account.localAccountId,
                    name: account.name,
                    isHomeTenant: (0, $11db744279a82a57$export$bc62fd222eddc2d7)(account.realm, account.homeAccountId)
                };
            });
            const updatedAccount = $4d3b9129094dcedd$export$996e3ea69314b5c6.toObject(new (0, $cdcf39a9eb0ff797$export$680160523e6bfa6a)(), {
                ...baseAccount
            });
            const newAccountKey = updatedAccount.generateAccountKey();
            // Clear cache of legacy account objects that have been collpsed into tenant profiles
            matchingAccountKeys.forEach((key)=>{
                if (key !== newAccountKey) this.removeOutdatedAccount(accountKey);
            });
            // Cache updated account object
            this.setAccount(updatedAccount);
            logger?.verbose("Updated an outdated account entity in the cache");
            return updatedAccount;
        }
        // No update is necessary
        return accountEntity;
    }
    /**
     * returns a boolean if the given credential is removed
     * @param credential
     */ async removeAccessToken(key) {
        const credential = this.getAccessTokenCredential(key);
        if (!credential) return;
        // Remove Token Binding Key from key store for PoP Tokens Credentials
        if (credential.credentialType.toLowerCase() === (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) {
            if (credential.tokenType === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP) {
                const accessTokenWithAuthSchemeEntity = credential;
                const kid = accessTokenWithAuthSchemeEntity.keyId;
                if (kid) try {
                    await this.cryptoImpl.removeTokenBindingKey(kid);
                } catch (error) {
                    throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$5765db5d84418d29));
                }
            }
        }
        return this.removeItem(key);
    }
    /**
     * Removes all app metadata objects from cache.
     */ removeAppMetadata() {
        const allCacheKeys = this.getKeys();
        allCacheKeys.forEach((cacheKey)=>{
            if (this.isAppMetadata(cacheKey)) this.removeItem(cacheKey);
        });
        return true;
    }
    /**
     * Retrieve AccountEntity from cache
     * @param account
     */ readAccountFromCache(account) {
        const accountKey = (0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).generateAccountCacheKey(account);
        return this.getAccount(accountKey, this.commonLogger);
    }
    /**
     * Retrieve IdTokenEntity from cache
     * @param account {AccountInfo}
     * @param tokenKeys {?TokenKeys}
     * @param targetRealm {?string}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getIdToken(account, tokenKeys, targetRealm, performanceClient, correlationId) {
        this.commonLogger.trace("CacheManager - getIdToken called");
        const idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ID_TOKEN,
            clientId: this.clientId,
            realm: targetRealm
        };
        const idTokenMap = this.getIdTokensByFilter(idTokenFilter, tokenKeys);
        const numIdTokens = idTokenMap.size;
        if (numIdTokens < 1) {
            this.commonLogger.info("CacheManager:getIdToken - No token found");
            return null;
        } else if (numIdTokens > 1) {
            let tokensToBeRemoved = idTokenMap;
            // Multiple tenant profiles and no tenant specified, pick home account
            if (!targetRealm) {
                const homeIdTokenMap = new Map();
                idTokenMap.forEach((idToken, key)=>{
                    if (idToken.realm === account.tenantId) homeIdTokenMap.set(key, idToken);
                });
                const numHomeIdTokens = homeIdTokenMap.size;
                if (numHomeIdTokens < 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account but none match account entity tenant id, returning first result");
                    return idTokenMap.values().next().value;
                } else if (numHomeIdTokens === 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account, defaulting to home tenant profile");
                    return homeIdTokenMap.values().next().value;
                } else // Multiple ID tokens for home tenant profile, remove all and return null
                tokensToBeRemoved = homeIdTokenMap;
            }
            // Multiple tokens for a single tenant profile, remove all and return null
            this.commonLogger.info("CacheManager:getIdToken - Multiple matching ID tokens found, clearing them");
            tokensToBeRemoved.forEach((idToken, key)=>{
                this.removeIdToken(key);
            });
            if (performanceClient && correlationId) performanceClient.addFields({
                multiMatchedID: idTokenMap.size
            }, correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getIdToken - Returning ID token");
        return idTokenMap.values().next().value;
    }
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */ getIdTokensByFilter(filter, tokenKeys) {
        const idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        const idTokens = new Map();
        idTokenKeys.forEach((key)=>{
            if (!this.idTokenKeyMatchesFilter(key, {
                clientId: this.clientId,
                ...filter
            })) return;
            const idToken = this.getIdTokenCredential(key);
            if (idToken && this.credentialMatchesFilter(idToken, filter)) idTokens.set(key, idToken);
        });
        return idTokens;
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */ idTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Removes idToken from the cache
     * @param key
     */ removeIdToken(key) {
        this.removeItem(key);
    }
    /**
     * Removes refresh token from the cache
     * @param key
     */ removeRefreshToken(key) {
        this.removeItem(key);
    }
    /**
     * Retrieve AccessTokenEntity from cache
     * @param account {AccountInfo}
     * @param request {BaseAuthRequest}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getAccessToken(account, request, tokenKeys, targetRealm, performanceClient, correlationId) {
        this.commonLogger.trace("CacheManager - getAccessToken called");
        const scopes = (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).createSearchScopes(request.scopes);
        const authScheme = request.authenticationScheme || (0, $e6f7ad11e10d0573$export$901491a717da2ba5).BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */ const credentialType = authScheme && authScheme.toLowerCase() !== (0, $e6f7ad11e10d0573$export$901491a717da2ba5).BEARER.toLowerCase() ? (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME : (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN;
        const accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: targetRealm || account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: request.sshKid,
            requestedClaimsHash: request.requestedClaimsHash
        };
        const accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        const accessTokens = [];
        accessTokenKeys.forEach((key)=>{
            // Validate key
            if (this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                const accessToken = this.getAccessTokenCredential(key);
                // Validate value
                if (accessToken && this.credentialMatchesFilter(accessToken, accessTokenFilter)) accessTokens.push(accessToken);
            }
        });
        const numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            this.commonLogger.info("CacheManager:getAccessToken - No token found");
            return null;
        } else if (numAccessTokens > 1) {
            this.commonLogger.info("CacheManager:getAccessToken - Multiple access tokens found, clearing them");
            accessTokens.forEach((accessToken)=>{
                this.removeAccessToken((0, $d6bc4864bb049bc4$export$1aaa1362083ec7a3)(accessToken));
            });
            if (performanceClient && correlationId) performanceClient.addFields({
                multiMatchedAT: accessTokens.length
            }, correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getAccessToken - Returning access token");
        return accessTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */ accessTokenKeyMatchesFilter(inputKey, filter, keyMustContainAllScopes) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) return false;
        if (filter.requestedClaimsHash && key.indexOf(filter.requestedClaimsHash.toLowerCase()) === -1) return false;
        if (filter.target) {
            const scopes = filter.target.asArray();
            for(let i = 0; i < scopes.length; i++){
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) // When performing a cache lookup a missing scope would be a cache miss
                return false;
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) // When performing a cache write, any token with a subset of requested scopes should be replaced
                return true;
            }
        }
        return true;
    }
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */ getAccessTokensByFilter(filter) {
        const tokenKeys = this.getTokenKeys();
        const accessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, filter, true)) return;
            const accessToken = this.getAccessTokenCredential(key);
            if (accessToken && this.credentialMatchesFilter(accessToken, filter)) accessTokens.push(accessToken);
        });
        return accessTokens;
    }
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param account {AccountInfo}
     * @param familyRT {boolean}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getRefreshToken(account, familyRT, tokenKeys, performanceClient, correlationId) {
        this.commonLogger.trace("CacheManager - getRefreshToken called");
        const id = familyRT ? (0, $e6f7ad11e10d0573$export$978fe7ab5e74b539) : undefined;
        const refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id
        };
        const refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        const refreshTokens = [];
        refreshTokenKeys.forEach((key)=>{
            // Validate key
            if (this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                const refreshToken = this.getRefreshTokenCredential(key);
                // Validate value
                if (refreshToken && this.credentialMatchesFilter(refreshToken, refreshTokenFilter)) refreshTokens.push(refreshToken);
            }
        });
        const numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("CacheManager:getRefreshToken - No refresh token found.");
            return null;
        }
        // address the else case after remove functions address environment aliases
        if (numRefreshTokens > 1 && performanceClient && correlationId) performanceClient.addFields({
            multiMatchedRT: numRefreshTokens
        }, correlationId);
        this.commonLogger.info("CacheManager:getRefreshToken - returning refresh token");
        return refreshTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */ refreshTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) return false;
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Retrieve AppMetadataEntity from cache
     */ readAppMetadataFromCache(environment) {
        const appMetadataFilter = {
            environment: environment,
            clientId: this.clientId
        };
        const appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter);
        const appMetadataEntries = Object.keys(appMetadata).map((key)=>appMetadata[key]);
        const numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) return null;
        else if (numAppMetadata > 1) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$575bb2924bcd0084));
        return appMetadataEntries[0];
    }
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */ isAppMetadataFOCI(environment) {
        const appMetadata = this.readAppMetadataFromCache(environment);
        return !!(appMetadata && appMetadata.familyId === (0, $e6f7ad11e10d0573$export$978fe7ab5e74b539));
    }
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */ matchHomeAccountId(entity, homeAccountId) {
        return !!(typeof entity.homeAccountId === "string" && homeAccountId === entity.homeAccountId);
    }
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */ matchLocalAccountIdFromTokenClaims(tokenClaims, localAccountId) {
        const idTokenLocalAccountId = tokenClaims.oid || tokenClaims.sub;
        return localAccountId === idTokenLocalAccountId;
    }
    matchLocalAccountIdFromTenantProfile(tenantProfile, localAccountId) {
        return tenantProfile.localAccountId === localAccountId;
    }
    /**
     * helper to match names
     * @param entity
     * @param name
     * @returns true if the downcased name properties are present and match in the filter and the entity
     */ matchName(claims, name) {
        return !!(name.toLowerCase() === claims.name?.toLowerCase());
    }
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */ matchUsername(cachedUsername, filterUsername) {
        return !!(cachedUsername && typeof cachedUsername === "string" && filterUsername?.toLowerCase() === cachedUsername.toLowerCase());
    }
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */ matchUserAssertionHash(entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    }
    /**
     * helper to match environment
     * @param value
     * @param environment
     */ matchEnvironment(entity, environment) {
        // Check static authority options first for cases where authority metadata has not been resolved and cached yet
        if (this.staticAuthorityOptions) {
            const staticAliases = (0, $0e21b55efe440ffb$export$2c21adf4b4d4efc0)(this.staticAuthorityOptions, this.commonLogger);
            if (staticAliases.includes(environment) && staticAliases.includes(entity.environment)) return true;
        }
        // Query metadata cache if no static authority configuration has aliases that match enviroment
        const cloudMetadata = this.getAuthorityMetadataByAlias(environment);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) return true;
        return false;
    }
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */ matchCredentialType(entity, credentialType) {
        return entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase();
    }
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */ matchClientId(entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    }
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */ matchFamilyId(entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    }
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */ matchRealm(entity, realm) {
        return !!(entity.realm?.toLowerCase() === realm.toLowerCase());
    }
    /**
     * helper to match nativeAccountId
     * @param entity
     * @param nativeAccountId
     * @returns boolean indicating the match result
     */ matchNativeAccountId(entity, nativeAccountId) {
        return !!(entity.nativeAccountId && nativeAccountId === entity.nativeAccountId);
    }
    /**
     * helper to match loginHint which can be either:
     * 1. login_hint ID token claim
     * 2. username in cached account object
     * 3. upn in ID token claims
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintFromTokenClaims(tokenClaims, loginHint) {
        if (tokenClaims.login_hint === loginHint) return true;
        if (tokenClaims.preferred_username === loginHint) return true;
        if (tokenClaims.upn === loginHint) return true;
        return false;
    }
    /**
     * Helper to match sid
     * @param entity
     * @param sid
     * @returns true if the sid claim is present and matches the filter
     */ matchSid(idTokenClaims, sid) {
        return idTokenClaims.sid === sid;
    }
    matchAuthorityType(entity, authorityType) {
        return !!(entity.authorityType && authorityType.toLowerCase() === entity.authorityType.toLowerCase());
    }
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */ matchTarget(entity, target) {
        const isNotAccessTokenCredential = entity.credentialType !== (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN && entity.credentialType !== (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        if (isNotAccessTokenCredential || !entity.target) return false;
        const entityScopeSet = (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).fromString(entity.target);
        return entityScopeSet.containsScopeSet(target);
    }
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ matchTokenType(entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType === tokenType);
    }
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param keyId
     */ matchKeyId(entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    }
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */ isAppMetadata(key) {
        return key.indexOf((0, $e6f7ad11e10d0573$export$7e1bea6dc1b6b32e)) !== -1;
    }
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */ isAuthorityMetadata(key) {
        return key.indexOf((0, $e6f7ad11e10d0573$export$d483f966e66f4db5).CACHE_KEY) !== -1;
    }
    /**
     * returns cache key used for cloud instance metadata
     */ generateAuthorityMetadataCacheKey(authority) {
        return `${(0, $e6f7ad11e10d0573$export$d483f966e66f4db5).CACHE_KEY}-${this.clientId}-${authority}`;
    }
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */ static toObject(obj, json) {
        for(const propertyName in json)obj[propertyName] = json[propertyName];
        return obj;
    }
}
/** @internal */ class $4d3b9129094dcedd$export$b7254d304b3004b6 extends $4d3b9129094dcedd$export$996e3ea69314b5c6 {
    setAccount() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getAccount() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getCachedAccountEntity() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    setIdTokenCredential() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getIdTokenCredential() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    setAccessTokenCredential() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getAccessTokenCredential() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    setRefreshTokenCredential() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getRefreshTokenCredential() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    setAppMetadata() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getAppMetadata() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    setServerTelemetry() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getServerTelemetry() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    setAuthorityMetadata() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getAuthorityMetadata() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getAuthorityMetadataKeys() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    setThrottlingCache() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getThrottlingCache() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    removeItem() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getKeys() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getAccountKeys() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    getTokenKeys() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    updateCredentialCacheKey() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
    removeOutdatedAccount() {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $daec59b36bfd07ff$export$f7a7dd6bfc156d75 = {
    tokenRenewalOffsetSeconds: (0, $e6f7ad11e10d0573$export$8d50f42618161d1a),
    preventCorsPreflight: false
};
const $daec59b36bfd07ff$var$DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: ()=>{
    // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: (0, $bf1c529f0722dfeb$export$243e62d78d3b544d).Info,
    correlationId: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
};
const $daec59b36bfd07ff$var$DEFAULT_CACHE_OPTIONS = {
    claimsBasedCachingEnabled: false
};
const $daec59b36bfd07ff$var$DEFAULT_NETWORK_IMPLEMENTATION = {
    async sendGetRequestAsync () {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    },
    async sendPostRequestAsync () {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22));
    }
};
const $daec59b36bfd07ff$var$DEFAULT_LIBRARY_INFO = {
    sku: (0, $e6f7ad11e10d0573$export$a002182e51710d39).SKU,
    version: (0, $c9cf9f06071f7708$export$83d89fbfd8236492),
    cpu: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
    os: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
};
const $daec59b36bfd07ff$var$DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
    clientAssertion: undefined
};
const $daec59b36bfd07ff$var$DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: (0, $ff3347e9d8dd5c27$export$4cda21933050d9ec).None,
    tenant: `${(0, $e6f7ad11e10d0573$export$a002182e51710d39).DEFAULT_COMMON_TENANT}`
};
const $daec59b36bfd07ff$var$DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 */ function $daec59b36bfd07ff$export$57a091701dcdabb2({ authOptions: userAuthOptions, systemOptions: userSystemOptions, loggerOptions: userLoggerOption, cacheOptions: userCacheOptions, storageInterface: storageImplementation, networkInterface: networkImplementation, cryptoInterface: cryptoImplementation, clientCredentials: clientCredentials, libraryInfo: libraryInfo, telemetry: telemetry, serverTelemetryManager: serverTelemetryManager, persistencePlugin: persistencePlugin, serializableCache: serializableCache }) {
    const loggerOptions = {
        ...$daec59b36bfd07ff$var$DEFAULT_LOGGER_IMPLEMENTATION,
        ...userLoggerOption
    };
    return {
        authOptions: $daec59b36bfd07ff$var$buildAuthOptions(userAuthOptions),
        systemOptions: {
            ...$daec59b36bfd07ff$export$f7a7dd6bfc156d75,
            ...userSystemOptions
        },
        loggerOptions: loggerOptions,
        cacheOptions: {
            ...$daec59b36bfd07ff$var$DEFAULT_CACHE_OPTIONS,
            ...userCacheOptions
        },
        storageInterface: storageImplementation || new (0, $4d3b9129094dcedd$export$b7254d304b3004b6)(userAuthOptions.clientId, (0, $90930effaee4b5bc$export$865f57d401606752), new (0, $bf1c529f0722dfeb$export$efa9a398d6368992)(loggerOptions)),
        networkInterface: networkImplementation || $daec59b36bfd07ff$var$DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || (0, $90930effaee4b5bc$export$865f57d401606752),
        clientCredentials: clientCredentials || $daec59b36bfd07ff$var$DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: {
            ...$daec59b36bfd07ff$var$DEFAULT_LIBRARY_INFO,
            ...libraryInfo
        },
        telemetry: {
            ...$daec59b36bfd07ff$var$DEFAULT_TELEMETRY_OPTIONS,
            ...telemetry
        },
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */ function $daec59b36bfd07ff$var$buildAuthOptions(authOptions) {
    return {
        clientCapabilities: [],
        azureCloudOptions: $daec59b36bfd07ff$var$DEFAULT_AZURE_CLOUD_OPTIONS,
        skipAuthorityMetadataCache: false,
        instanceAware: false,
        ...authOptions
    };
}
/**
 * Returns true if config has protocolMode set to ProtocolMode.OIDC, false otherwise
 * @param ClientConfiguration
 */ function $daec59b36bfd07ff$export$25afa7198c2ed9b9(config) {
    return config.authOptions.authority.options.protocolMode === (0, $340831fc14c31b77$export$73a3e3dedd37150d).OIDC;
}

/*! @azure/msal-common v14.16.0 2024-11-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $942aa7cf4c34a387$export$6d95060a8ed7155a = {
    sendGetRequestAsync: ()=>{
        return Promise.reject((0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22)));
    },
    sendPostRequestAsync: ()=>{
        return Promise.reject((0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$24176fc1f15eea22)));
    }
};

/*! @azure/msal-common v14.16.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Enumeration of operations that are instrumented by have their performance measured by the PerformanceClient.
 *
 * @export
 * @enum {number}
 */ const $e68ee78dfc615f65$export$2f2811a3e1b21823 = {
    /**
     * acquireTokenByCode API (msal-browser and msal-node).
     * Used to acquire tokens by trading an authorization code against the token endpoint.
     */ AcquireTokenByCode: "acquireTokenByCode",
    /**
     * acquireTokenByRefreshToken API (msal-browser and msal-node).
     * Used to renew an access token using a refresh token against the token endpoint.
     */ AcquireTokenByRefreshToken: "acquireTokenByRefreshToken",
    /**
     * acquireTokenSilent API (msal-browser and msal-node).
     * Used to silently acquire a new access token (from the cache or the network).
     */ AcquireTokenSilent: "acquireTokenSilent",
    /**
     * acquireTokenSilentAsync (msal-browser).
     * Internal API for acquireTokenSilent.
     */ AcquireTokenSilentAsync: "acquireTokenSilentAsync",
    /**
     * acquireTokenPopup (msal-browser).
     * Used to acquire a new access token interactively through pop ups
     */ AcquireTokenPopup: "acquireTokenPopup",
    /**
     * acquireTokenPreRedirect (msal-browser).
     * First part of the redirect flow.
     * Used to acquire a new access token interactively through redirects.
     */ AcquireTokenPreRedirect: "acquireTokenPreRedirect",
    /**
     * acquireTokenRedirect (msal-browser).
     * Second part of the redirect flow.
     * Used to acquire a new access token interactively through redirects.
     */ AcquireTokenRedirect: "acquireTokenRedirect",
    /**
     * getPublicKeyThumbprint API in CryptoOpts class (msal-browser).
     * Used to generate a public/private keypair and generate a public key thumbprint for pop requests.
     */ CryptoOptsGetPublicKeyThumbprint: "cryptoOptsGetPublicKeyThumbprint",
    /**
     * signJwt API in CryptoOpts class (msal-browser).
     * Used to signed a pop token.
     */ CryptoOptsSignJwt: "cryptoOptsSignJwt",
    /**
     * acquireToken API in the SilentCacheClient class (msal-browser).
     * Used to read access tokens from the cache.
     */ SilentCacheClientAcquireToken: "silentCacheClientAcquireToken",
    /**
     * acquireToken API in the SilentIframeClient class (msal-browser).
     * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
     */ SilentIframeClientAcquireToken: "silentIframeClientAcquireToken",
    AwaitConcurrentIframe: "awaitConcurrentIframe",
    /**
     * acquireToken API in SilentRereshClient (msal-browser).
     * Used to acquire a new set of tokens from the token endpoint using a refresh token.
     */ SilentRefreshClientAcquireToken: "silentRefreshClientAcquireToken",
    /**
     * ssoSilent API (msal-browser).
     * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
     */ SsoSilent: "ssoSilent",
    /**
     * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
     * Used to load authority metadata for a request.
     */ StandardInteractionClientGetDiscoveredAuthority: "standardInteractionClientGetDiscoveredAuthority",
    /**
     * acquireToken APIs in msal-browser.
     * Used to make an /authorize endpoint call with native brokering enabled.
     */ FetchAccountIdWithNativeBroker: "fetchAccountIdWithNativeBroker",
    /**
     * acquireToken API in NativeInteractionClient class (msal-browser).
     * Used to acquire a token from Native component when native brokering is enabled.
     */ NativeInteractionClientAcquireToken: "nativeInteractionClientAcquireToken",
    /**
     * Time spent creating default headers for requests to token endpoint
     */ BaseClientCreateTokenRequestHeaders: "baseClientCreateTokenRequestHeaders",
    /**
     * Time spent sending/waiting for the response of a request to the token endpoint
     */ NetworkClientSendPostRequestAsync: "networkClientSendPostRequestAsync",
    RefreshTokenClientExecutePostToTokenEndpoint: "refreshTokenClientExecutePostToTokenEndpoint",
    AuthorizationCodeClientExecutePostToTokenEndpoint: "authorizationCodeClientExecutePostToTokenEndpoint",
    /**
     * Used to measure the time taken for completing embedded-broker handshake (PW-Broker).
     */ BrokerHandhshake: "brokerHandshake",
    /**
     * acquireTokenByRefreshToken API in BrokerClientApplication (PW-Broker) .
     */ AcquireTokenByRefreshTokenInBroker: "acquireTokenByRefreshTokenInBroker",
    /**
     * Time taken for token acquisition by broker
     */ AcquireTokenByBroker: "acquireTokenByBroker",
    /**
     * Time spent on the network for refresh token acquisition
     */ RefreshTokenClientExecuteTokenRequest: "refreshTokenClientExecuteTokenRequest",
    /**
     * Time taken for acquiring refresh token , records RT size
     */ RefreshTokenClientAcquireToken: "refreshTokenClientAcquireToken",
    /**
     * Time taken for acquiring cached refresh token
     */ RefreshTokenClientAcquireTokenWithCachedRefreshToken: "refreshTokenClientAcquireTokenWithCachedRefreshToken",
    /**
     * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
     */ RefreshTokenClientAcquireTokenByRefreshToken: "refreshTokenClientAcquireTokenByRefreshToken",
    /**
     * Helper function to create token request body in RefreshTokenClient (msal-common).
     */ RefreshTokenClientCreateTokenRequestBody: "refreshTokenClientCreateTokenRequestBody",
    /**
     * acquireTokenFromCache (msal-browser).
     * Internal API for acquiring token from cache
     */ AcquireTokenFromCache: "acquireTokenFromCache",
    SilentFlowClientAcquireCachedToken: "silentFlowClientAcquireCachedToken",
    SilentFlowClientGenerateResultFromCacheRecord: "silentFlowClientGenerateResultFromCacheRecord",
    /**
     * acquireTokenBySilentIframe (msal-browser).
     * Internal API for acquiring token by silent Iframe
     */ AcquireTokenBySilentIframe: "acquireTokenBySilentIframe",
    /**
     * Internal API for initializing base request in BaseInteractionClient (msal-browser)
     */ InitializeBaseRequest: "initializeBaseRequest",
    /**
     * Internal API for initializing silent request in SilentCacheClient (msal-browser)
     */ InitializeSilentRequest: "initializeSilentRequest",
    InitializeClientApplication: "initializeClientApplication",
    /**
     * Helper function in SilentIframeClient class (msal-browser).
     */ SilentIframeClientTokenHelper: "silentIframeClientTokenHelper",
    /**
     * SilentHandler
     */ SilentHandlerInitiateAuthRequest: "silentHandlerInitiateAuthRequest",
    SilentHandlerMonitorIframeForHash: "silentHandlerMonitorIframeForHash",
    SilentHandlerLoadFrame: "silentHandlerLoadFrame",
    SilentHandlerLoadFrameSync: "silentHandlerLoadFrameSync",
    /**
     * Helper functions in StandardInteractionClient class (msal-browser)
     */ StandardInteractionClientCreateAuthCodeClient: "standardInteractionClientCreateAuthCodeClient",
    StandardInteractionClientGetClientConfiguration: "standardInteractionClientGetClientConfiguration",
    StandardInteractionClientInitializeAuthorizationRequest: "standardInteractionClientInitializeAuthorizationRequest",
    StandardInteractionClientInitializeAuthorizationCodeRequest: "standardInteractionClientInitializeAuthorizationCodeRequest",
    /**
     * getAuthCodeUrl API (msal-browser and msal-node).
     */ GetAuthCodeUrl: "getAuthCodeUrl",
    /**
     * Functions from InteractionHandler (msal-browser)
     */ HandleCodeResponseFromServer: "handleCodeResponseFromServer",
    HandleCodeResponse: "handleCodeResponse",
    UpdateTokenEndpointAuthority: "updateTokenEndpointAuthority",
    /**
     * APIs in Authorization Code Client (msal-common)
     */ AuthClientAcquireToken: "authClientAcquireToken",
    AuthClientExecuteTokenRequest: "authClientExecuteTokenRequest",
    AuthClientCreateTokenRequestBody: "authClientCreateTokenRequestBody",
    AuthClientCreateQueryString: "authClientCreateQueryString",
    /**
     * Generate functions in PopTokenGenerator (msal-common)
     */ PopTokenGenerateCnf: "popTokenGenerateCnf",
    PopTokenGenerateKid: "popTokenGenerateKid",
    /**
     * handleServerTokenResponse API in ResponseHandler (msal-common)
     */ HandleServerTokenResponse: "handleServerTokenResponse",
    DeserializeResponse: "deserializeResponse",
    /**
     * Authority functions
     */ AuthorityFactoryCreateDiscoveredInstance: "authorityFactoryCreateDiscoveredInstance",
    AuthorityResolveEndpointsAsync: "authorityResolveEndpointsAsync",
    AuthorityResolveEndpointsFromLocalSources: "authorityResolveEndpointsFromLocalSources",
    AuthorityGetCloudDiscoveryMetadataFromNetwork: "authorityGetCloudDiscoveryMetadataFromNetwork",
    AuthorityUpdateCloudDiscoveryMetadata: "authorityUpdateCloudDiscoveryMetadata",
    AuthorityGetEndpointMetadataFromNetwork: "authorityGetEndpointMetadataFromNetwork",
    AuthorityUpdateEndpointMetadata: "authorityUpdateEndpointMetadata",
    AuthorityUpdateMetadataWithRegionalInformation: "authorityUpdateMetadataWithRegionalInformation",
    /**
     * Region Discovery functions
     */ RegionDiscoveryDetectRegion: "regionDiscoveryDetectRegion",
    RegionDiscoveryGetRegionFromIMDS: "regionDiscoveryGetRegionFromIMDS",
    RegionDiscoveryGetCurrentVersion: "regionDiscoveryGetCurrentVersion",
    AcquireTokenByCodeAsync: "acquireTokenByCodeAsync",
    GetEndpointMetadataFromNetwork: "getEndpointMetadataFromNetwork",
    GetCloudDiscoveryMetadataFromNetworkMeasurement: "getCloudDiscoveryMetadataFromNetworkMeasurement",
    HandleRedirectPromiseMeasurement: "handleRedirectPromise",
    HandleNativeRedirectPromiseMeasurement: "handleNativeRedirectPromise",
    UpdateCloudDiscoveryMetadataMeasurement: "updateCloudDiscoveryMetadataMeasurement",
    UsernamePasswordClientAcquireToken: "usernamePasswordClientAcquireToken",
    NativeMessageHandlerHandshake: "nativeMessageHandlerHandshake",
    NativeGenerateAuthResult: "nativeGenerateAuthResult",
    RemoveHiddenIframe: "removeHiddenIframe",
    /**
     * Cache operations
     */ ClearTokensAndKeysWithClaims: "clearTokensAndKeysWithClaims",
    CacheManagerGetRefreshToken: "cacheManagerGetRefreshToken",
    /**
     * Crypto Operations
     */ GeneratePkceCodes: "generatePkceCodes",
    GenerateCodeVerifier: "generateCodeVerifier",
    GenerateCodeChallengeFromVerifier: "generateCodeChallengeFromVerifier",
    Sha256Digest: "sha256Digest",
    GetRandomValues: "getRandomValues"
};
const $e68ee78dfc615f65$export$8dc198b6eb7c4c72 = new Map([
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AcquireTokenByCode,
        "ATByCode"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AcquireTokenByRefreshToken,
        "ATByRT"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AcquireTokenSilent,
        "ATS"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AcquireTokenSilentAsync,
        "ATSAsync"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AcquireTokenPopup,
        "ATPopup"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AcquireTokenRedirect,
        "ATRedirect"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.CryptoOptsGetPublicKeyThumbprint,
        "CryptoGetPKThumb"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.CryptoOptsSignJwt,
        "CryptoSignJwt"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.SilentCacheClientAcquireToken,
        "SltCacheClientAT"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.SilentIframeClientAcquireToken,
        "SltIframeClientAT"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.SilentRefreshClientAcquireToken,
        "SltRClientAT"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.SsoSilent,
        "SsoSlt"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.StandardInteractionClientGetDiscoveredAuthority,
        "StdIntClientGetDiscAuth"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.FetchAccountIdWithNativeBroker,
        "FetchAccIdWithNtvBroker"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.NativeInteractionClientAcquireToken,
        "NtvIntClientAT"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.BaseClientCreateTokenRequestHeaders,
        "BaseClientCreateTReqHead"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.NetworkClientSendPostRequestAsync,
        "NetClientSendPost"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.RefreshTokenClientExecutePostToTokenEndpoint,
        "RTClientExecPost"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthorizationCodeClientExecutePostToTokenEndpoint,
        "AuthCodeClientExecPost"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.BrokerHandhshake,
        "BrokerHandshake"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AcquireTokenByRefreshTokenInBroker,
        "ATByRTInBroker"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AcquireTokenByBroker,
        "ATByBroker"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.RefreshTokenClientExecuteTokenRequest,
        "RTClientExecTReq"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.RefreshTokenClientAcquireToken,
        "RTClientAT"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.RefreshTokenClientAcquireTokenWithCachedRefreshToken,
        "RTClientATWithCachedRT"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.RefreshTokenClientAcquireTokenByRefreshToken,
        "RTClientATByRT"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.RefreshTokenClientCreateTokenRequestBody,
        "RTClientCreateTReqBody"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AcquireTokenFromCache,
        "ATFromCache"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.SilentFlowClientAcquireCachedToken,
        "SltFlowClientATCached"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.SilentFlowClientGenerateResultFromCacheRecord,
        "SltFlowClientGenResFromCache"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AcquireTokenBySilentIframe,
        "ATBySltIframe"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.InitializeBaseRequest,
        "InitBaseReq"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.InitializeSilentRequest,
        "InitSltReq"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.InitializeClientApplication,
        "InitClientApplication"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.SilentIframeClientTokenHelper,
        "SIClientTHelper"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.SilentHandlerInitiateAuthRequest,
        "SHandlerInitAuthReq"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.SilentHandlerMonitorIframeForHash,
        "SltHandlerMonitorIframeForHash"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.SilentHandlerLoadFrame,
        "SHandlerLoadFrame"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.SilentHandlerLoadFrameSync,
        "SHandlerLoadFrameSync"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.StandardInteractionClientCreateAuthCodeClient,
        "StdIntClientCreateAuthCodeClient"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.StandardInteractionClientGetClientConfiguration,
        "StdIntClientGetClientConf"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.StandardInteractionClientInitializeAuthorizationRequest,
        "StdIntClientInitAuthReq"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.StandardInteractionClientInitializeAuthorizationCodeRequest,
        "StdIntClientInitAuthCodeReq"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.GetAuthCodeUrl,
        "GetAuthCodeUrl"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.HandleCodeResponseFromServer,
        "HandleCodeResFromServer"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.HandleCodeResponse,
        "HandleCodeResp"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.UpdateTokenEndpointAuthority,
        "UpdTEndpointAuth"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthClientAcquireToken,
        "AuthClientAT"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthClientExecuteTokenRequest,
        "AuthClientExecTReq"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthClientCreateTokenRequestBody,
        "AuthClientCreateTReqBody"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthClientCreateQueryString,
        "AuthClientCreateQueryStr"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.PopTokenGenerateCnf,
        "PopTGenCnf"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.PopTokenGenerateKid,
        "PopTGenKid"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.HandleServerTokenResponse,
        "HandleServerTRes"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.DeserializeResponse,
        "DeserializeRes"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthorityFactoryCreateDiscoveredInstance,
        "AuthFactCreateDiscInst"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthorityResolveEndpointsAsync,
        "AuthResolveEndpointsAsync"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthorityResolveEndpointsFromLocalSources,
        "AuthResolveEndpointsFromLocal"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthorityGetCloudDiscoveryMetadataFromNetwork,
        "AuthGetCDMetaFromNet"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthorityUpdateCloudDiscoveryMetadata,
        "AuthUpdCDMeta"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthorityGetEndpointMetadataFromNetwork,
        "AuthUpdCDMetaFromNet"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthorityUpdateEndpointMetadata,
        "AuthUpdEndpointMeta"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AuthorityUpdateMetadataWithRegionalInformation,
        "AuthUpdMetaWithRegInfo"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.RegionDiscoveryDetectRegion,
        "RegDiscDetectReg"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.RegionDiscoveryGetRegionFromIMDS,
        "RegDiscGetRegFromIMDS"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.RegionDiscoveryGetCurrentVersion,
        "RegDiscGetCurrentVer"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.AcquireTokenByCodeAsync,
        "ATByCodeAsync"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.GetEndpointMetadataFromNetwork,
        "GetEndpointMetaFromNet"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.GetCloudDiscoveryMetadataFromNetworkMeasurement,
        "GetCDMetaFromNet"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.HandleRedirectPromiseMeasurement,
        "HandleRedirectPromise"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.HandleNativeRedirectPromiseMeasurement,
        "HandleNtvRedirectPromise"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.UpdateCloudDiscoveryMetadataMeasurement,
        "UpdateCDMeta"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.UsernamePasswordClientAcquireToken,
        "UserPassClientAT"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.NativeMessageHandlerHandshake,
        "NtvMsgHandlerHandshake"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.NativeGenerateAuthResult,
        "NtvGenAuthRes"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.RemoveHiddenIframe,
        "RemoveHiddenIframe"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.ClearTokensAndKeysWithClaims,
        "ClearTAndKeysWithClaims"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.CacheManagerGetRefreshToken,
        "CacheManagerGetRT"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.GeneratePkceCodes,
        "GenPkceCodes"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.GenerateCodeVerifier,
        "GenCodeVerifier"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.GenerateCodeChallengeFromVerifier,
        "GenCodeChallengeFromVerifier"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.Sha256Digest,
        "Sha256Digest"
    ],
    [
        $e68ee78dfc615f65$export$2f2811a3e1b21823.GetRandomValues,
        "GetRandomValues"
    ]
]);
/**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */ const $e68ee78dfc615f65$export$bc3547c8ae7b1db = {
    NotStarted: 0,
    InProgress: 1,
    Completed: 2
};
const $e68ee78dfc615f65$export$f16d39729f4b7302 = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "queuedTimeMs",
    "startTimeMs",
    "status",
    "multiMatchedAT",
    "multiMatchedID",
    "multiMatchedRT"
]);


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $f01d9bf996083ee0$export$647004217f4122f0 {
    startMeasurement() {
        return;
    }
    endMeasurement() {
        return;
    }
    flushMeasurement() {
        return null;
    }
}
class $f01d9bf996083ee0$export$c70f2989a65fda3e {
    generateId() {
        return "callback-id";
    }
    startMeasurement(measureName, correlationId) {
        return {
            end: ()=>null,
            discard: ()=>{},
            add: ()=>{},
            increment: ()=>{},
            event: {
                eventId: this.generateId(),
                status: (0, $e68ee78dfc615f65$export$bc3547c8ae7b1db).InProgress,
                authority: "",
                libraryName: "",
                libraryVersion: "",
                clientId: "",
                name: measureName,
                startTimeMs: Date.now(),
                correlationId: correlationId || ""
            },
            measurement: new $f01d9bf996083ee0$export$647004217f4122f0()
        };
    }
    startPerformanceMeasurement() {
        return new $f01d9bf996083ee0$export$647004217f4122f0();
    }
    calculateQueuedTime() {
        return 0;
    }
    addQueueMeasurement() {
        return;
    }
    setPreQueueTime() {
        return;
    }
    endMeasurement() {
        return null;
    }
    discardMeasurements() {
        return;
    }
    removePerformanceCallback() {
        return true;
    }
    addPerformanceCallback() {
        return "";
    }
    emitEvents() {
        return;
    }
    addFields() {
        return;
    }
    incrementFields() {
        return;
    }
    cacheEventByCorrelationId() {
        return;
    }
}



/*! @azure/msal-browser v3.27.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $cbc634d616499355$export$d0d362a73d466c9b {
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */ navigateInternal(url, options) {
        return $cbc634d616499355$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */ navigateExternal(url, options) {
        return $cbc634d616499355$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */ static defaultNavigateWindow(url, options) {
        if (options.noHistory) window.location.replace(url);
        else window.location.assign(url);
        return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve(true);
            }, options.timeout);
        });
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Represents network related errors
 */ class $64fab191b4af9ef5$export$bae979e68e4dc802 extends (0, $40da14d5d49dd285$export$145273558d58e0ac) {
    constructor(error, httpStatus, responseHeaders){
        super(error.errorCode, error.errorMessage, error.subError);
        Object.setPrototypeOf(this, $64fab191b4af9ef5$export$bae979e68e4dc802.prototype);
        this.name = "NetworkError";
        this.error = error;
        this.httpStatus = httpStatus;
        this.responseHeaders = responseHeaders;
    }
}
/**
 * Creates NetworkError object for a failed network request
 * @param error - Error to be thrown back to the caller
 * @param httpStatus - Status code of the network request
 * @param responseHeaders - Response headers of the network request, when available
 * @returns NetworkError object
 */ function $64fab191b4af9ef5$export$262c4a35fb53be19(error, httpStatus, responseHeaders) {
    return new $64fab191b4af9ef5$export$bae979e68e4dc802(error, httpStatus, responseHeaders);
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 
/*! @azure/msal-browser v3.27.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $8e6ba27e37631a08$export$ee549107fa376fc1 = "pkce_not_created";
const $8e6ba27e37631a08$export$6319761d10f0cc4c = "crypto_nonexistent";
const $8e6ba27e37631a08$export$be9285c64f247822 = "empty_navigate_uri";
const $8e6ba27e37631a08$export$a29c42a1dd414317 = "hash_empty_error";
const $8e6ba27e37631a08$export$211c8e8843a8d278 = "no_state_in_hash";
const $8e6ba27e37631a08$export$5743873a5ba5d124 = "hash_does_not_contain_known_properties";
const $8e6ba27e37631a08$export$237bdd0b913cb30c = "unable_to_parse_state";
const $8e6ba27e37631a08$export$499b1b95c97a1c75 = "state_interaction_type_mismatch";
const $8e6ba27e37631a08$export$2700dc1c133d227e = "interaction_in_progress";
const $8e6ba27e37631a08$export$f1b7091ee48d0b3e = "popup_window_error";
const $8e6ba27e37631a08$export$5e827e513523a576 = "empty_window_error";
const $8e6ba27e37631a08$export$6bae303c5e922702 = "user_cancelled";
const $8e6ba27e37631a08$export$e2e3374c08b8ef2a = "monitor_popup_timeout";
const $8e6ba27e37631a08$export$c8b6efb19551013d = "monitor_window_timeout";
const $8e6ba27e37631a08$export$9cc12eb574ceee30 = "redirect_in_iframe";
const $8e6ba27e37631a08$export$71bafc2814e56c09 = "block_iframe_reload";
const $8e6ba27e37631a08$export$c4a80c97d7b48f72 = "block_nested_popups";
const $8e6ba27e37631a08$export$6a76760db525f402 = "iframe_closed_prematurely";
const $8e6ba27e37631a08$export$78523a40be105a03 = "silent_logout_unsupported";
const $8e6ba27e37631a08$export$87933d7d4116cb12 = "no_account_error";
const $8e6ba27e37631a08$export$24dae796d0958d3 = "silent_prompt_value_error";
const $8e6ba27e37631a08$export$8b51939fb2aab3d7 = "no_token_request_cache_error";
const $8e6ba27e37631a08$export$f3ae24cdfaab4488 = "unable_to_parse_token_request_cache_error";
const $8e6ba27e37631a08$export$3a2c83e7753553b = "no_cached_authority_error";
const $8e6ba27e37631a08$export$c47649cf6408c7b2 = "auth_request_not_set_error";
const $8e6ba27e37631a08$export$ff7164a2aeeff392 = "invalid_cache_type";
const $8e6ba27e37631a08$export$932e0f52d657f7fb = "non_browser_environment";
const $8e6ba27e37631a08$export$4752ced1a1a262f = "database_not_open";
const $8e6ba27e37631a08$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $8e6ba27e37631a08$export$7a1e28a7b60ca602 = "post_request_failed";
const $8e6ba27e37631a08$export$45e7eaaecd19d31e = "get_request_failed";
const $8e6ba27e37631a08$export$96735047beea85a0 = "failed_to_parse_response";
const $8e6ba27e37631a08$export$6acf650331eb5f5f = "unable_to_load_token";
const $8e6ba27e37631a08$export$a416b0eceb5c15df = "crypto_key_not_found";
const $8e6ba27e37631a08$export$e502d98cd8d2da43 = "auth_code_required";
const $8e6ba27e37631a08$export$8bea68053103eaeb = "auth_code_or_nativeAccountId_required";
const $8e6ba27e37631a08$export$1efb009e9d75bbe4 = "spa_code_and_nativeAccountId_present";
const $8e6ba27e37631a08$export$c1110692d2978b8 = "database_unavailable";
const $8e6ba27e37631a08$export$b897bbe2c683def2 = "unable_to_acquire_token_from_native_platform";
const $8e6ba27e37631a08$export$4747c302ef0117fd = "native_handshake_timeout";
const $8e6ba27e37631a08$export$59080ea2398ee306 = "native_extension_not_installed";
const $8e6ba27e37631a08$export$7b7357e3538624aa = "native_connection_not_established";
const $8e6ba27e37631a08$export$436657cdcd7fe2be = "uninitialized_public_client_application";
const $8e6ba27e37631a08$export$62fdd8848aa75547 = "native_prompt_not_supported";
const $8e6ba27e37631a08$export$fcc6790b5d12da63 = "invalid_base64_string";
const $8e6ba27e37631a08$export$f6f43ae33ad04b91 = "invalid_pop_token_request";
const $8e6ba27e37631a08$export$df9e6aae71bd84f = "failed_to_build_headers";
const $8e6ba27e37631a08$export$487fe7232a90003c = "failed_to_parse_headers";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $1eca0489e18862c6$var$ErrorLink = "For more visit: aka.ms/msaljs/browser-errors";
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $1eca0489e18862c6$export$16ffff3fb076c606 = {
    [(0, $8e6ba27e37631a08$export$ee549107fa376fc1)]: "The PKCE code challenge and verifier could not be generated.",
    [(0, $8e6ba27e37631a08$export$6319761d10f0cc4c)]: "The crypto object or function is not available.",
    [(0, $8e6ba27e37631a08$export$be9285c64f247822)]: "Navigation URI is empty. Please check stack trace for more info.",
    [(0, $8e6ba27e37631a08$export$a29c42a1dd414317)]: `Hash value cannot be processed because it is empty. Please verify that your redirectUri is not clearing the hash. ${$1eca0489e18862c6$var$ErrorLink}`,
    [(0, $8e6ba27e37631a08$export$211c8e8843a8d278)]: "Hash does not contain state. Please verify that the request originated from msal.",
    [(0, $8e6ba27e37631a08$export$5743873a5ba5d124)]: `Hash does not contain known properites. Please verify that your redirectUri is not changing the hash.  ${$1eca0489e18862c6$var$ErrorLink}`,
    [(0, $8e6ba27e37631a08$export$237bdd0b913cb30c)]: "Unable to parse state. Please verify that the request originated from msal.",
    [(0, $8e6ba27e37631a08$export$499b1b95c97a1c75)]: "Hash contains state but the interaction type does not match the caller.",
    [(0, $8e6ba27e37631a08$export$2700dc1c133d227e)]: `Interaction is currently in progress. Please ensure that this interaction has been completed before calling an interactive API.   ${$1eca0489e18862c6$var$ErrorLink}`,
    [(0, $8e6ba27e37631a08$export$f1b7091ee48d0b3e)]: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser.",
    [(0, $8e6ba27e37631a08$export$5e827e513523a576)]: "window.open returned null or undefined window object.",
    [(0, $8e6ba27e37631a08$export$6bae303c5e922702)]: "User cancelled the flow.",
    [(0, $8e6ba27e37631a08$export$e2e3374c08b8ef2a)]: `Token acquisition in popup failed due to timeout.  ${$1eca0489e18862c6$var$ErrorLink}`,
    [(0, $8e6ba27e37631a08$export$c8b6efb19551013d)]: `Token acquisition in iframe failed due to timeout.  ${$1eca0489e18862c6$var$ErrorLink}`,
    [(0, $8e6ba27e37631a08$export$9cc12eb574ceee30)]: "Redirects are not supported for iframed or brokered applications. Please ensure you are using MSAL.js in a top frame of the window if using the redirect APIs, or use the popup APIs.",
    [(0, $8e6ba27e37631a08$export$71bafc2814e56c09)]: `Request was blocked inside an iframe because MSAL detected an authentication response.  ${$1eca0489e18862c6$var$ErrorLink}`,
    [(0, $8e6ba27e37631a08$export$c4a80c97d7b48f72)]: "Request was blocked inside a popup because MSAL detected it was running in a popup.",
    [(0, $8e6ba27e37631a08$export$6a76760db525f402)]: "The iframe being monitored was closed prematurely.",
    [(0, $8e6ba27e37631a08$export$78523a40be105a03)]: "Silent logout not supported. Please call logoutRedirect or logoutPopup instead.",
    [(0, $8e6ba27e37631a08$export$87933d7d4116cb12)]: "No account object provided to acquireTokenSilent and no active account has been set. Please call setActiveAccount or provide an account on the request.",
    [(0, $8e6ba27e37631a08$export$24dae796d0958d3)]: "The value given for the prompt value is not valid for silent requests - must be set to 'none' or 'no_session'.",
    [(0, $8e6ba27e37631a08$export$8b51939fb2aab3d7)]: "No token request found in cache.",
    [(0, $8e6ba27e37631a08$export$f3ae24cdfaab4488)]: "The cached token request could not be parsed.",
    [(0, $8e6ba27e37631a08$export$3a2c83e7753553b)]: "No cached authority found.",
    [(0, $8e6ba27e37631a08$export$c47649cf6408c7b2)]: "Auth Request not set. Please ensure initiateAuthRequest was called from the InteractionHandler",
    [(0, $8e6ba27e37631a08$export$ff7164a2aeeff392)]: "Invalid cache type",
    [(0, $8e6ba27e37631a08$export$932e0f52d657f7fb)]: "Login and token requests are not supported in non-browser environments.",
    [(0, $8e6ba27e37631a08$export$4752ced1a1a262f)]: "Database is not open!",
    [(0, $8e6ba27e37631a08$export$31ae862f18c3b2b7)]: "No network connectivity. Check your internet connection.",
    [(0, $8e6ba27e37631a08$export$7a1e28a7b60ca602)]: "Network request failed: If the browser threw a CORS error, check that the redirectUri is registered in the Azure App Portal as type 'SPA'",
    [(0, $8e6ba27e37631a08$export$45e7eaaecd19d31e)]: "Network request failed. Please check the network trace to determine root cause.",
    [(0, $8e6ba27e37631a08$export$96735047beea85a0)]: "Failed to parse network response. Check network trace.",
    [(0, $8e6ba27e37631a08$export$6acf650331eb5f5f)]: "Error loading token to cache.",
    [(0, $8e6ba27e37631a08$export$a416b0eceb5c15df)]: "Cryptographic Key or Keypair not found in browser storage.",
    [(0, $8e6ba27e37631a08$export$e502d98cd8d2da43)]: "An authorization code must be provided (as the `code` property on the request) to this flow.",
    [(0, $8e6ba27e37631a08$export$8bea68053103eaeb)]: "An authorization code or nativeAccountId must be provided to this flow.",
    [(0, $8e6ba27e37631a08$export$1efb009e9d75bbe4)]: "Request cannot contain both spa code and native account id.",
    [(0, $8e6ba27e37631a08$export$c1110692d2978b8)]: "IndexedDB, which is required for persistent cryptographic key storage, is unavailable. This may be caused by browser privacy features which block persistent storage in third-party contexts.",
    [(0, $8e6ba27e37631a08$export$b897bbe2c683def2)]: `Unable to acquire token from native platform.  ${$1eca0489e18862c6$var$ErrorLink}`,
    [(0, $8e6ba27e37631a08$export$4747c302ef0117fd)]: "Timed out while attempting to establish connection to browser extension",
    [(0, $8e6ba27e37631a08$export$59080ea2398ee306)]: "Native extension is not installed. If you think this is a mistake call the initialize function.",
    [(0, $8e6ba27e37631a08$export$7b7357e3538624aa)]: `Connection to native platform has not been established. Please install a compatible browser extension and run initialize().  ${$1eca0489e18862c6$var$ErrorLink}`,
    [(0, $8e6ba27e37631a08$export$436657cdcd7fe2be)]: `You must call and await the initialize function before attempting to call any other MSAL API.  ${$1eca0489e18862c6$var$ErrorLink}`,
    [(0, $8e6ba27e37631a08$export$62fdd8848aa75547)]: "The provided prompt is not supported by the native platform. This request should be routed to the web based flow.",
    [(0, $8e6ba27e37631a08$export$fcc6790b5d12da63)]: "Invalid base64 encoded string.",
    [(0, $8e6ba27e37631a08$export$f6f43ae33ad04b91)]: "Invalid PoP token request. The request should not have both a popKid value and signPopToken set to true.",
    [(0, $8e6ba27e37631a08$export$df9e6aae71bd84f)]: "Failed to build request headers object.",
    [(0, $8e6ba27e37631a08$export$487fe7232a90003c)]: "Failed to parse response headers"
};
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use exported BrowserAuthErrorCodes instead.
 * In your app you can do :
 * ```
 * import { BrowserAuthErrorCodes } from "@azure/msal-browser";
 * ```
 */ const $1eca0489e18862c6$export$6deffaef56f0bd5a = {
    pkceNotGenerated: {
        code: (0, $8e6ba27e37631a08$export$ee549107fa376fc1),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$ee549107fa376fc1]
    },
    cryptoDoesNotExist: {
        code: (0, $8e6ba27e37631a08$export$6319761d10f0cc4c),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$6319761d10f0cc4c]
    },
    emptyNavigateUriError: {
        code: (0, $8e6ba27e37631a08$export$be9285c64f247822),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$be9285c64f247822]
    },
    hashEmptyError: {
        code: (0, $8e6ba27e37631a08$export$a29c42a1dd414317),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$a29c42a1dd414317]
    },
    hashDoesNotContainStateError: {
        code: (0, $8e6ba27e37631a08$export$211c8e8843a8d278),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$211c8e8843a8d278]
    },
    hashDoesNotContainKnownPropertiesError: {
        code: (0, $8e6ba27e37631a08$export$5743873a5ba5d124),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$5743873a5ba5d124]
    },
    unableToParseStateError: {
        code: (0, $8e6ba27e37631a08$export$237bdd0b913cb30c),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$237bdd0b913cb30c]
    },
    stateInteractionTypeMismatchError: {
        code: (0, $8e6ba27e37631a08$export$499b1b95c97a1c75),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$499b1b95c97a1c75]
    },
    interactionInProgress: {
        code: (0, $8e6ba27e37631a08$export$2700dc1c133d227e),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$2700dc1c133d227e]
    },
    popupWindowError: {
        code: (0, $8e6ba27e37631a08$export$f1b7091ee48d0b3e),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$f1b7091ee48d0b3e]
    },
    emptyWindowError: {
        code: (0, $8e6ba27e37631a08$export$5e827e513523a576),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$5e827e513523a576]
    },
    userCancelledError: {
        code: (0, $8e6ba27e37631a08$export$6bae303c5e922702),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$6bae303c5e922702]
    },
    monitorPopupTimeoutError: {
        code: (0, $8e6ba27e37631a08$export$e2e3374c08b8ef2a),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$e2e3374c08b8ef2a]
    },
    monitorIframeTimeoutError: {
        code: (0, $8e6ba27e37631a08$export$c8b6efb19551013d),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$c8b6efb19551013d]
    },
    redirectInIframeError: {
        code: (0, $8e6ba27e37631a08$export$9cc12eb574ceee30),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$9cc12eb574ceee30]
    },
    blockTokenRequestsInHiddenIframeError: {
        code: (0, $8e6ba27e37631a08$export$71bafc2814e56c09),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$71bafc2814e56c09]
    },
    blockAcquireTokenInPopupsError: {
        code: (0, $8e6ba27e37631a08$export$c4a80c97d7b48f72),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$c4a80c97d7b48f72]
    },
    iframeClosedPrematurelyError: {
        code: (0, $8e6ba27e37631a08$export$6a76760db525f402),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$6a76760db525f402]
    },
    silentLogoutUnsupportedError: {
        code: (0, $8e6ba27e37631a08$export$78523a40be105a03),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$78523a40be105a03]
    },
    noAccountError: {
        code: (0, $8e6ba27e37631a08$export$87933d7d4116cb12),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$87933d7d4116cb12]
    },
    silentPromptValueError: {
        code: (0, $8e6ba27e37631a08$export$24dae796d0958d3),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$24dae796d0958d3]
    },
    noTokenRequestCacheError: {
        code: (0, $8e6ba27e37631a08$export$8b51939fb2aab3d7),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$8b51939fb2aab3d7]
    },
    unableToParseTokenRequestCacheError: {
        code: (0, $8e6ba27e37631a08$export$f3ae24cdfaab4488),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$f3ae24cdfaab4488]
    },
    noCachedAuthorityError: {
        code: (0, $8e6ba27e37631a08$export$3a2c83e7753553b),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$3a2c83e7753553b]
    },
    authRequestNotSet: {
        code: (0, $8e6ba27e37631a08$export$c47649cf6408c7b2),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$c47649cf6408c7b2]
    },
    invalidCacheType: {
        code: (0, $8e6ba27e37631a08$export$ff7164a2aeeff392),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$ff7164a2aeeff392]
    },
    notInBrowserEnvironment: {
        code: (0, $8e6ba27e37631a08$export$932e0f52d657f7fb),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$932e0f52d657f7fb]
    },
    databaseNotOpen: {
        code: (0, $8e6ba27e37631a08$export$4752ced1a1a262f),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$4752ced1a1a262f]
    },
    noNetworkConnectivity: {
        code: (0, $8e6ba27e37631a08$export$31ae862f18c3b2b7),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$31ae862f18c3b2b7]
    },
    postRequestFailed: {
        code: (0, $8e6ba27e37631a08$export$7a1e28a7b60ca602),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$7a1e28a7b60ca602]
    },
    getRequestFailed: {
        code: (0, $8e6ba27e37631a08$export$45e7eaaecd19d31e),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$45e7eaaecd19d31e]
    },
    failedToParseNetworkResponse: {
        code: (0, $8e6ba27e37631a08$export$96735047beea85a0),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$96735047beea85a0]
    },
    unableToLoadTokenError: {
        code: (0, $8e6ba27e37631a08$export$6acf650331eb5f5f),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$6acf650331eb5f5f]
    },
    signingKeyNotFoundInStorage: {
        code: (0, $8e6ba27e37631a08$export$a416b0eceb5c15df),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$a416b0eceb5c15df]
    },
    authCodeRequired: {
        code: (0, $8e6ba27e37631a08$export$e502d98cd8d2da43),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$e502d98cd8d2da43]
    },
    authCodeOrNativeAccountRequired: {
        code: (0, $8e6ba27e37631a08$export$8bea68053103eaeb),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$8bea68053103eaeb]
    },
    spaCodeAndNativeAccountPresent: {
        code: (0, $8e6ba27e37631a08$export$1efb009e9d75bbe4),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$1efb009e9d75bbe4]
    },
    databaseUnavailable: {
        code: (0, $8e6ba27e37631a08$export$c1110692d2978b8),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$c1110692d2978b8]
    },
    unableToAcquireTokenFromNativePlatform: {
        code: (0, $8e6ba27e37631a08$export$b897bbe2c683def2),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$b897bbe2c683def2]
    },
    nativeHandshakeTimeout: {
        code: (0, $8e6ba27e37631a08$export$4747c302ef0117fd),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$4747c302ef0117fd]
    },
    nativeExtensionNotInstalled: {
        code: (0, $8e6ba27e37631a08$export$59080ea2398ee306),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$59080ea2398ee306]
    },
    nativeConnectionNotEstablished: {
        code: (0, $8e6ba27e37631a08$export$7b7357e3538624aa),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$7b7357e3538624aa]
    },
    uninitializedPublicClientApplication: {
        code: (0, $8e6ba27e37631a08$export$436657cdcd7fe2be),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$436657cdcd7fe2be]
    },
    nativePromptNotSupported: {
        code: (0, $8e6ba27e37631a08$export$62fdd8848aa75547),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$62fdd8848aa75547]
    },
    invalidBase64StringError: {
        code: (0, $8e6ba27e37631a08$export$fcc6790b5d12da63),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$fcc6790b5d12da63]
    },
    invalidPopTokenRequest: {
        code: (0, $8e6ba27e37631a08$export$f6f43ae33ad04b91),
        desc: $1eca0489e18862c6$export$16ffff3fb076c606[0, $8e6ba27e37631a08$export$f6f43ae33ad04b91]
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $1eca0489e18862c6$export$f8eb6760ca13876a extends (0, $40da14d5d49dd285$export$145273558d58e0ac) {
    constructor(errorCode, subError){
        super(errorCode, $1eca0489e18862c6$export$16ffff3fb076c606[errorCode], subError);
        Object.setPrototypeOf(this, $1eca0489e18862c6$export$f8eb6760ca13876a.prototype);
        this.name = "BrowserAuthError";
    }
}
function $1eca0489e18862c6$export$72f7b48f3bc1d4cb(errorCode, subError) {
    return new $1eca0489e18862c6$export$f8eb6760ca13876a(errorCode, subError);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */ class $359918e926b328bb$export$4c206ef5be879972 {
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ async sendGetRequestAsync(url, options) {
        let response;
        let responseHeaders = {};
        let responseStatus = 0;
        const reqHeaders = $359918e926b328bb$var$getFetchHeaders(options);
        try {
            response = await fetch(url, {
                method: (0, $e195f599725a9f25$export$c774c31b4c31da8).GET,
                headers: reqHeaders
            });
        } catch (e) {
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $8e6ba27e37631a08$export$45e7eaaecd19d31e) : (0, $8e6ba27e37631a08$export$31ae862f18c3b2b7));
        }
        responseHeaders = $359918e926b328bb$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $64fab191b4af9ef5$export$262c4a35fb53be19)((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$96735047beea85a0)), responseStatus, responseHeaders);
        }
    }
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ async sendPostRequestAsync(url, options) {
        const reqBody = options && options.body || "";
        const reqHeaders = $359918e926b328bb$var$getFetchHeaders(options);
        let response;
        let responseStatus = 0;
        let responseHeaders = {};
        try {
            response = await fetch(url, {
                method: (0, $e195f599725a9f25$export$c774c31b4c31da8).POST,
                headers: reqHeaders,
                body: reqBody
            });
        } catch (e) {
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $8e6ba27e37631a08$export$7a1e28a7b60ca602) : (0, $8e6ba27e37631a08$export$31ae862f18c3b2b7));
        }
        responseHeaders = $359918e926b328bb$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $64fab191b4af9ef5$export$262c4a35fb53be19)((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$96735047beea85a0)), responseStatus, responseHeaders);
        }
    }
}
/**
 * Get Fetch API Headers object from string map
 * @param inputHeaders
 */ function $359918e926b328bb$var$getFetchHeaders(options) {
    try {
        const headers = new Headers();
        if (!(options && options.headers)) return headers;
        const optionsHeaders = options.headers;
        Object.entries(optionsHeaders).forEach(([key, value])=>{
            headers.append(key, value);
        });
        return headers;
    } catch (e) {
        throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$df9e6aae71bd84f));
    }
}
/**
 * Returns object representing response headers
 * @param headers
 * @returns
 */ function $359918e926b328bb$var$getHeaderDict(headers) {
    try {
        const headerDict = {};
        headers.forEach((value, key)=>{
            headerDict[key] = value;
        });
        return headerDict;
    } catch (e) {
        throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$487fe7232a90003c));
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ /**
 * Returns URL Safe b64 encoded string from a plaintext string.
 * @param input
 */ function $be65c31a50210a3d$export$9ef804feabbcbaf1(input) {
    return encodeURIComponent($be65c31a50210a3d$export$e510a73ee562749(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"));
}
/**
 * Returns URL Safe b64 encoded string from an int8Array.
 * @param inputArr
 */ function $be65c31a50210a3d$export$84f5a428c7153a69(inputArr) {
    return $be65c31a50210a3d$var$base64EncArr(inputArr).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * Returns b64 encoded string from plaintext string.
 * @param input
 */ function $be65c31a50210a3d$export$e510a73ee562749(input) {
    return $be65c31a50210a3d$var$base64EncArr(new TextEncoder().encode(input));
}
/**
 * Base64 encode byte array
 * @param aBytes
 */ function $be65c31a50210a3d$var$base64EncArr(aBytes) {
    const binString = Array.from(aBytes, (x)=>String.fromCodePoint(x)).join("");
    return btoa(binString);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This file defines functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */ /**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */ // RSA KeyGen Algorithm
const $a65ce7794137937d$var$PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
// SHA-256 hashing algorithm
const $a65ce7794137937d$var$S256_HASH_ALG = "SHA-256";
// MOD length for PoP tokens
const $a65ce7794137937d$var$MODULUS_LENGTH = 2048;
// Public Exponent
const $a65ce7794137937d$var$PUBLIC_EXPONENT = new Uint8Array([
    0x01,
    0x00,
    0x01
]);
// UUID hex digits
const $a65ce7794137937d$var$UUID_CHARS = "0123456789abcdef";
// Array to store UINT32 random value
const $a65ce7794137937d$var$UINT32_ARR = new Uint32Array(1);
const $a65ce7794137937d$var$SUBTLE_SUBERROR = "crypto_subtle_undefined";
const $a65ce7794137937d$var$keygenAlgorithmOptions = {
    name: $a65ce7794137937d$var$PKCS1_V15_KEYGEN_ALG,
    hash: $a65ce7794137937d$var$S256_HASH_ALG,
    modulusLength: $a65ce7794137937d$var$MODULUS_LENGTH,
    publicExponent: $a65ce7794137937d$var$PUBLIC_EXPONENT
};
/**
 * Check whether browser crypto is available.
 */ function $a65ce7794137937d$export$1ddcc6bab2bf2314() {
    if (!window) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$932e0f52d657f7fb));
    if (!window.crypto) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$6319761d10f0cc4c));
    if (!window.crypto.subtle) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$6319761d10f0cc4c), $a65ce7794137937d$var$SUBTLE_SUBERROR);
}
/**
 * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
 * @param dataString {string} data string
 * @param performanceClient {?IPerformanceClient}
 * @param correlationId {?string} correlation id
 */ async function $a65ce7794137937d$export$52caff7bddbaf316(dataString, performanceClient, correlationId) {
    performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).Sha256Digest, correlationId);
    const encoder = new TextEncoder();
    const data = encoder.encode(dataString);
    return window.crypto.subtle.digest($a65ce7794137937d$var$S256_HASH_ALG, data);
}
/**
 * Populates buffer with cryptographically random values.
 * @param dataBuffer
 */ function $a65ce7794137937d$export$960b9ff25e7d4257(dataBuffer) {
    return window.crypto.getRandomValues(dataBuffer);
}
/**
 * Returns random Uint32 value.
 * @returns {number}
 */ function $a65ce7794137937d$var$getRandomUint32() {
    window.crypto.getRandomValues($a65ce7794137937d$var$UINT32_ARR);
    return $a65ce7794137937d$var$UINT32_ARR[0];
}
/**
 * Creates a UUID v7 from the current timestamp.
 * Implementation relies on the system clock to guarantee increasing order of generated identifiers.
 * @returns {number}
 */ function $a65ce7794137937d$export$6ef0355fa80a5278() {
    const currentTimestamp = Date.now();
    const baseRand = $a65ce7794137937d$var$getRandomUint32() * 0x400 + ($a65ce7794137937d$var$getRandomUint32() & 0x3ff);
    // Result byte array
    const bytes = new Uint8Array(16);
    // A 12-bit `rand_a` field value
    const randA = Math.trunc(baseRand / 2 ** 30);
    // The higher 30 bits of 62-bit `rand_b` field value
    const randBHi = baseRand & 2 ** 30 - 1;
    // The lower 32 bits of 62-bit `rand_b` field value
    const randBLo = $a65ce7794137937d$var$getRandomUint32();
    bytes[0] = currentTimestamp / 2 ** 40;
    bytes[1] = currentTimestamp / 2 ** 32;
    bytes[2] = currentTimestamp / 2 ** 24;
    bytes[3] = currentTimestamp / 2 ** 16;
    bytes[4] = currentTimestamp / 256;
    bytes[5] = currentTimestamp;
    bytes[6] = 0x70 | randA >>> 8;
    bytes[7] = randA;
    bytes[8] = 0x80 | randBHi >>> 24;
    bytes[9] = randBHi >>> 16;
    bytes[10] = randBHi >>> 8;
    bytes[11] = randBHi;
    bytes[12] = randBLo >>> 24;
    bytes[13] = randBLo >>> 16;
    bytes[14] = randBLo >>> 8;
    bytes[15] = randBLo;
    let text = "";
    for(let i = 0; i < bytes.length; i++){
        text += $a65ce7794137937d$var$UUID_CHARS.charAt(bytes[i] >>> 4);
        text += $a65ce7794137937d$var$UUID_CHARS.charAt(bytes[i] & 0xf);
        if (i === 3 || i === 5 || i === 7 || i === 9) text += "-";
    }
    return text;
}
/**
 * Generates a keypair based on current keygen algorithm config.
 * @param extractable
 * @param usages
 */ async function $a65ce7794137937d$export$a949d36eab55b41f(extractable, usages) {
    return window.crypto.subtle.generateKey($a65ce7794137937d$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Export key as Json Web Key (JWK)
 * @param key
 */ async function $a65ce7794137937d$export$88781b8595a7d2ff(key) {
    return window.crypto.subtle.exportKey((0, $e195f599725a9f25$export$1294c3e3f84694cd), key);
}
/**
 * Imports key as Json Web Key (JWK), can set extractable and usages.
 * @param key
 * @param extractable
 * @param usages
 */ async function $a65ce7794137937d$export$8bdea4e2e3f593c9(key, extractable, usages) {
    return window.crypto.subtle.importKey((0, $e195f599725a9f25$export$1294c3e3f84694cd), key, $a65ce7794137937d$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Signs given data with given key
 * @param key
 * @param data
 */ async function $a65ce7794137937d$export$c5552dfdbc7cec71(key, data) {
    return window.crypto.subtle.sign($a65ce7794137937d$var$keygenAlgorithmOptions, key, data);
}
/**
 * Returns the SHA-256 hash of an input string
 * @param plainText
 */ async function $a65ce7794137937d$export$9169be2e06c9c165(plainText) {
    const hashBuffer = await $a65ce7794137937d$export$52caff7bddbaf316(plainText);
    const hashBytes = new Uint8Array(hashBuffer);
    return (0, $be65c31a50210a3d$export$84f5a428c7153a69)(hashBytes);
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Clears hash from window url.
 */ function $d618406b813d26cc$export$a20c3032ba81d6aa(contentWindow) {
    // Office.js sets history.replaceState to null
    contentWindow.location.hash = "";
    if (typeof contentWindow.history.replaceState === "function") // Full removes "#" from url
    contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}${contentWindow.location.search}`);
}
/**
 * Replaces current hash with hash from provided url
 */ function $d618406b813d26cc$export$9bf2691bda54425c(url) {
    const urlParts = url.split("#");
    urlParts.shift(); // Remove part before the hash
    window.location.hash = urlParts.length > 0 ? urlParts.join("#") : "";
}
/**
 * Returns boolean of whether the current window is in an iframe or not.
 */ function $d618406b813d26cc$export$9f140ed41af5108c() {
    return window.parent !== window;
}
/**
 * Returns boolean of whether or not the current window is a popup opened by msal
 */ function $d618406b813d26cc$export$722fdce8786cc28b() {
    return typeof window !== "undefined" && !!window.opener && window.opener !== window && typeof window.name === "string" && window.name.indexOf(`${(0, $e195f599725a9f25$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.`) === 0;
}
// #endregion
/**
 * Returns current window URL as redirect uri
 */ function $d618406b813d26cc$export$1204531fbbf6ecde() {
    return window.location.href.split("?")[0].split("#")[0];
}
/**
 * Gets the homepage url for the current window location.
 */ function $d618406b813d26cc$export$60785768478b4ffc() {
    const currentUrl = new (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2)(window.location.href);
    const urlComponents = currentUrl.getUrlComponents();
    return `${urlComponents.Protocol}//${urlComponents.HostNameAndPort}/`;
}
/**
 * Throws error if we have completed an auth and are
 * attempting another auth request inside an iframe.
 */ function $d618406b813d26cc$export$8fdba407d8e31f54() {
    const isResponseHash = (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).hashContainsKnownProperties(window.location.hash);
    // return an error if called from the hidden iframe created by the msal js silent calls
    if (isResponseHash && $d618406b813d26cc$export$9f140ed41af5108c()) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$71bafc2814e56c09));
}
/**
 * Block redirect operations in iframes unless explicitly allowed
 * @param interactionType Interaction type for the request
 * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
 */ function $d618406b813d26cc$export$5ae6b09f947c8a9e(allowRedirectInIframe) {
    if ($d618406b813d26cc$export$9f140ed41af5108c() && !allowRedirectInIframe) // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
    throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$9cc12eb574ceee30));
}
/**
 * Block redirectUri loaded in popup from calling AcquireToken APIs
 */ function $d618406b813d26cc$export$dc99b653c8cd2cd7() {
    // Popups opened by msal popup APIs are given a name that starts with "msal."
    if ($d618406b813d26cc$export$722fdce8786cc28b()) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$c4a80c97d7b48f72));
}
/**
 * Throws error if token requests are made in non-browser environment
 * @param isBrowserEnvironment Flag indicating if environment is a browser.
 */ function $d618406b813d26cc$export$c7939bfe92ae2787() {
    if (typeof window === "undefined") throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$932e0f52d657f7fb));
}
/**
 * Throws error if initialize hasn't been called
 * @param initialized
 */ function $d618406b813d26cc$export$630119c5db8b5529(initialized) {
    if (!initialized) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$436657cdcd7fe2be));
}
/**
 * Helper to validate app environment before making an auth request
 * @param initialized
 */ function $d618406b813d26cc$export$4dd091cbdc98b52e(initialized) {
    // Block request if not in browser environment
    $d618406b813d26cc$export$c7939bfe92ae2787();
    // Block auth requests inside a hidden iframe
    $d618406b813d26cc$export$8fdba407d8e31f54();
    // Block redirectUri opened in a popup from calling MSAL APIs
    $d618406b813d26cc$export$dc99b653c8cd2cd7();
    // Block token acquisition before initialize has been called
    $d618406b813d26cc$export$630119c5db8b5529(initialized);
}
/**
 * Helper to validate app enviornment before making redirect request
 * @param initialized
 * @param config
 */ function $d618406b813d26cc$export$62c8f4fdca4df60f(initialized, config) {
    $d618406b813d26cc$export$4dd091cbdc98b52e(initialized);
    $d618406b813d26cc$export$5ae6b09f947c8a9e(config.system.allowRedirectInIframe);
    // Block redirects if memory storage is enabled but storeAuthStateInCookie is not
    if (config.cache.cacheLocation === (0, $e195f599725a9f25$export$573384e47a12d835).MemoryStorage && !config.cache.storeAuthStateInCookie) throw (0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$37486e3b6bed61c6));
}
/**
 * Adds a preconnect link element to the header which begins DNS resolution and SSL connection in anticipation of the /token request
 * @param loginDomain Authority domain, including https protocol e.g. https://login.microsoftonline.com
 * @returns
 */ function $d618406b813d26cc$export$a0816fa17a9e79be(authority) {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = new URL(authority).origin;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
    // The browser will close connection if not used within a few seconds, remove element from the header after 10s
    window.setTimeout(()=>{
        try {
            document.head.removeChild(link);
        } catch  {}
    }, 10000); // 10s Timeout
}
/**
 * Wrapper function that creates a UUID v7 from the current timestamp.
 * @returns {string}
 */ function $d618406b813d26cc$export$7571c350ed9fec74() {
    return (0, $a65ce7794137937d$export$6ef0355fa80a5278)();
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Default timeout for popup windows and iframes in milliseconds
const $0808630523d62b54$export$a5835ee54399d410 = 60000;
const $0808630523d62b54$export$f3ffe700be354b19 = 10000;
const $0808630523d62b54$export$293647e7865520c6 = 30000;
const $0808630523d62b54$export$73d1d87a8b7ddb57 = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */ function $0808630523d62b54$export$f8352245bee68086({ auth: userInputAuth, cache: userInputCache, system: userInputSystem, telemetry: userInputTelemetry }, isBrowserEnvironment) {
    // Default auth options for browser
    const DEFAULT_AUTH_OPTIONS = {
        clientId: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
        authority: `${(0, $e6f7ad11e10d0573$export$a002182e51710d39).DEFAULT_AUTHORITY}`,
        knownAuthorities: [],
        cloudDiscoveryMetadata: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
        authorityMetadata: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
        redirectUri: typeof window !== "undefined" ? (0, $d618406b813d26cc$export$1204531fbbf6ecde)() : "",
        postLogoutRedirectUri: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
        navigateToLoginRequestUrl: true,
        clientCapabilities: [],
        protocolMode: (0, $340831fc14c31b77$export$73a3e3dedd37150d).AAD,
        OIDCOptions: {
            serverResponseType: (0, $e6f7ad11e10d0573$export$b34cb6fbea2adc44).FRAGMENT,
            defaultScopes: [
                (0, $e6f7ad11e10d0573$export$a002182e51710d39).OPENID_SCOPE,
                (0, $e6f7ad11e10d0573$export$a002182e51710d39).PROFILE_SCOPE,
                (0, $e6f7ad11e10d0573$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE
            ]
        },
        azureCloudOptions: {
            azureCloudInstance: (0, $ff3347e9d8dd5c27$export$4cda21933050d9ec).None,
            tenant: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
        },
        skipAuthorityMetadataCache: false,
        supportsNestedAppAuth: false,
        instanceAware: false
    };
    // Default cache options for browser
    const DEFAULT_CACHE_OPTIONS = {
        cacheLocation: (0, $e195f599725a9f25$export$573384e47a12d835).SessionStorage,
        temporaryCacheLocation: (0, $e195f599725a9f25$export$573384e47a12d835).SessionStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        // Default cache migration to true if cache location is localStorage since entries are preserved across tabs/windows. Migration has little to no benefit in sessionStorage and memoryStorage
        cacheMigrationEnabled: userInputCache && userInputCache.cacheLocation === (0, $e195f599725a9f25$export$573384e47a12d835).LocalStorage ? true : false,
        claimsBasedCachingEnabled: false
    };
    // Default logger options for browser
    const DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: ()=>{
        // allow users to not set logger call back
        },
        logLevel: (0, $bf1c529f0722dfeb$export$243e62d78d3b544d).Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    const DEFAULT_BROWSER_SYSTEM_OPTIONS = {
        ...(0, $daec59b36bfd07ff$export$f7a7dd6bfc156d75),
        loggerOptions: DEFAULT_LOGGER_OPTIONS,
        networkClient: isBrowserEnvironment ? new (0, $359918e926b328bb$export$4c206ef5be879972)() : (0, $942aa7cf4c34a387$export$6d95060a8ed7155a),
        navigationClient: new (0, $cbc634d616499355$export$d0d362a73d466c9b)(),
        loadFrameTimeout: 0,
        // If loadFrameTimeout is provided, use that as default.
        windowHashTimeout: userInputSystem?.loadFrameTimeout || $0808630523d62b54$export$a5835ee54399d410,
        iframeHashTimeout: userInputSystem?.loadFrameTimeout || $0808630523d62b54$export$f3ffe700be354b19,
        navigateFrameWait: 0,
        redirectNavigationTimeout: $0808630523d62b54$export$293647e7865520c6,
        asyncPopups: false,
        allowRedirectInIframe: false,
        allowNativeBroker: false,
        nativeBrokerHandshakeTimeout: userInputSystem?.nativeBrokerHandshakeTimeout || $0808630523d62b54$export$73d1d87a8b7ddb57,
        pollIntervalMilliseconds: (0, $e195f599725a9f25$export$a0a689e4294b9880).DEFAULT_POLL_INTERVAL_MS
    };
    const providedSystemOptions = {
        ...DEFAULT_BROWSER_SYSTEM_OPTIONS,
        ...userInputSystem,
        loggerOptions: userInputSystem?.loggerOptions || DEFAULT_LOGGER_OPTIONS
    };
    const DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
            appVersion: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
        },
        client: new (0, $f01d9bf996083ee0$export$c70f2989a65fda3e)()
    };
    // Throw an error if user has set OIDCOptions without being in OIDC protocol mode
    if (userInputAuth?.protocolMode !== (0, $340831fc14c31b77$export$73a3e3dedd37150d).OIDC && userInputAuth?.OIDCOptions) {
        const logger = new (0, $bf1c529f0722dfeb$export$efa9a398d6368992)(providedSystemOptions.loggerOptions);
        logger.warning(JSON.stringify((0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$exports).cannotSetOIDCOptions)));
    }
    // Throw an error if user has set allowNativeBroker to true without being in AAD protocol mode
    if (userInputAuth?.protocolMode && userInputAuth.protocolMode !== (0, $340831fc14c31b77$export$73a3e3dedd37150d).AAD && providedSystemOptions?.allowNativeBroker) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$exports).cannotAllowNativeBroker);
    const overlayedConfig = {
        auth: {
            ...DEFAULT_AUTH_OPTIONS,
            ...userInputAuth,
            OIDCOptions: {
                ...DEFAULT_AUTH_OPTIONS.OIDCOptions,
                ...userInputAuth?.OIDCOptions
            }
        },
        cache: {
            ...DEFAULT_CACHE_OPTIONS,
            ...userInputCache
        },
        system: providedSystemOptions,
        telemetry: {
            ...DEFAULT_TELEMETRY_OPTIONS,
            ...userInputTelemetry
        }
    };
    return overlayedConfig;
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 'use strict';
/* eslint-disable header/header */ const $d287cb496a16a30d$export$a8ff84c12d48cfa6 = "@azure/msal-browser";
const $d287cb496a16a30d$export$83d89fbfd8236492 = "3.27.0";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base class for operating context
 * Operating contexts are contexts in which MSAL.js is being run
 * More than one operating context may be available at a time
 * It's important from a logging and telemetry point of view for us to be able to identify the operating context.
 * For example: Some operating contexts will pre-cache tokens impacting performance telemetry
 */ class $067993367301e153$export$3aea257f46651b2b {
    static loggerCallback(level, message) {
        switch(level){
            case (0, $bf1c529f0722dfeb$export$243e62d78d3b544d).Error:
                // eslint-disable-next-line no-console
                console.error(message);
                return;
            case (0, $bf1c529f0722dfeb$export$243e62d78d3b544d).Info:
                // eslint-disable-next-line no-console
                console.info(message);
                return;
            case (0, $bf1c529f0722dfeb$export$243e62d78d3b544d).Verbose:
                // eslint-disable-next-line no-console
                console.debug(message);
                return;
            case (0, $bf1c529f0722dfeb$export$243e62d78d3b544d).Warning:
                // eslint-disable-next-line no-console
                console.warn(message);
                return;
            default:
                // eslint-disable-next-line no-console
                console.log(message);
                return;
        }
    }
    constructor(config){
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */ this.browserEnvironment = typeof window !== "undefined";
        this.config = (0, $0808630523d62b54$export$f8352245bee68086)(config, this.browserEnvironment);
        let sessionStorage;
        try {
            sessionStorage = window[(0, $e195f599725a9f25$export$573384e47a12d835).SessionStorage];
        // Mute errors if it's a non-browser environment or cookies are blocked.
        } catch (e) {}
        const logLevelKey = sessionStorage?.getItem((0, $e195f599725a9f25$export$b28668d53eb57e63));
        const piiLoggingKey = sessionStorage?.getItem((0, $e195f599725a9f25$export$d9bc1c202a3825f1))?.toLowerCase();
        const piiLoggingEnabled = piiLoggingKey === "true" ? true : piiLoggingKey === "false" ? false : undefined;
        const loggerOptions = {
            ...this.config.system.loggerOptions
        };
        const logLevel = logLevelKey && Object.keys((0, $bf1c529f0722dfeb$export$243e62d78d3b544d)).includes(logLevelKey) ? (0, $bf1c529f0722dfeb$export$243e62d78d3b544d)[logLevelKey] : undefined;
        if (logLevel) {
            loggerOptions.loggerCallback = $067993367301e153$export$3aea257f46651b2b.loggerCallback;
            loggerOptions.logLevel = logLevel;
        }
        if (piiLoggingEnabled !== undefined) loggerOptions.piiLoggingEnabled = piiLoggingEnabled;
        this.logger = new (0, $bf1c529f0722dfeb$export$efa9a398d6368992)(loggerOptions, (0, $d287cb496a16a30d$export$a8ff84c12d48cfa6), (0, $d287cb496a16a30d$export$83d89fbfd8236492));
        this.available = false;
    }
    /**
     * Return the MSAL config
     * @returns BrowserConfiguration
     */ getConfig() {
        return this.config;
    }
    /**
     * Returns the MSAL Logger
     * @returns Logger
     */ getLogger() {
        return this.logger;
    }
    isAvailable() {
        return this.available;
    }
    isBrowserEnvironment() {
        return this.browserEnvironment;
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-browser v3.27.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $c0438d21313a8fee$export$6d05f68c12a46a00 = {
    UserInteractionRequired: "USER_INTERACTION_REQUIRED",
    UserCancel: "USER_CANCEL",
    NoNetwork: "NO_NETWORK",
    TransientError: "TRANSIENT_ERROR",
    PersistentError: "PERSISTENT_ERROR",
    Disabled: "DISABLED",
    AccountUnavailable: "ACCOUNT_UNAVAILABLE",
    NestedAppAuthUnavailable: "NESTED_APP_AUTH_UNAVAILABLE"
};





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BridgeProxy
 * Provides a proxy for accessing a bridge to a host app and/or
 * platform broker
 */ class $3dd2157439507fd9$export$d974b2d5dad1979e {
    /**
     * initializeNestedAppAuthBridge - Initializes the bridge to the host app
     * @returns a promise that resolves to an InitializeBridgeResponse or rejects with an Error
     * @remarks This method will be called by the create factory method
     * @remarks If the bridge is not available, this method will throw an error
     */ static async initializeNestedAppAuthBridge() {
        if (window === undefined) throw new Error("window is undefined");
        if (window.nestedAppAuthBridge === undefined) throw new Error("window.nestedAppAuthBridge is undefined");
        try {
            window.nestedAppAuthBridge.addEventListener("message", (response)=>{
                const responsePayload = typeof response === "string" ? response : response.data;
                const responseEnvelope = JSON.parse(responsePayload);
                const request = $3dd2157439507fd9$export$d974b2d5dad1979e.bridgeRequests.find((element)=>element.requestId === responseEnvelope.requestId);
                if (request !== undefined) {
                    $3dd2157439507fd9$export$d974b2d5dad1979e.bridgeRequests.splice($3dd2157439507fd9$export$d974b2d5dad1979e.bridgeRequests.indexOf(request), 1);
                    if (responseEnvelope.success) request.resolve(responseEnvelope);
                    else request.reject(responseEnvelope.error);
                }
            });
            const bridgeResponse = await new Promise((resolve, reject)=>{
                const message = $3dd2157439507fd9$export$d974b2d5dad1979e.buildRequest("GetInitContext");
                const request = {
                    requestId: message.requestId,
                    method: message.method,
                    resolve: resolve,
                    reject: reject
                };
                $3dd2157439507fd9$export$d974b2d5dad1979e.bridgeRequests.push(request);
                window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
            });
            return $3dd2157439507fd9$export$d974b2d5dad1979e.validateBridgeResultOrThrow(bridgeResponse.initContext);
        } catch (error) {
            window.console.log(error);
            throw error;
        }
    }
    /**
     * getTokenInteractive - Attempts to get a token interactively from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenInteractive(request) {
        return this.getToken("GetTokenPopup", request);
    }
    /**
     * getTokenSilent Attempts to get a token silently from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenSilent(request) {
        return this.getToken("GetToken", request);
    }
    async getToken(requestType, request) {
        const result = await this.sendRequest(requestType, {
            tokenParams: request
        });
        return {
            token: $3dd2157439507fd9$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.token),
            account: $3dd2157439507fd9$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.account)
        };
    }
    getHostCapabilities() {
        return this.capabilities ?? null;
    }
    getAccountContext() {
        return this.accountContext ? this.accountContext : null;
    }
    static buildRequest(method, requestParams) {
        return {
            messageType: "NestedAppAuthRequest",
            method: method,
            requestId: (0, $a65ce7794137937d$export$6ef0355fa80a5278)(),
            sendTime: Date.now(),
            clientLibrary: (0, $e195f599725a9f25$export$a0a689e4294b9880).MSAL_SKU,
            clientLibraryVersion: (0, $d287cb496a16a30d$export$83d89fbfd8236492),
            ...requestParams
        };
    }
    /**
     * A method used to send a request to the bridge
     * @param request A token request
     * @returns a promise that resolves to a response of provided type or rejects with a BridgeError
     */ sendRequest(method, requestParams) {
        const message = $3dd2157439507fd9$export$d974b2d5dad1979e.buildRequest(method, requestParams);
        const promise = new Promise((resolve, reject)=>{
            const request = {
                requestId: message.requestId,
                method: message.method,
                resolve: resolve,
                reject: reject
            };
            $3dd2157439507fd9$export$d974b2d5dad1979e.bridgeRequests.push(request);
            window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
        });
        return promise;
    }
    static validateBridgeResultOrThrow(input) {
        if (input === undefined) {
            const bridgeError = {
                status: (0, $c0438d21313a8fee$export$6d05f68c12a46a00).NestedAppAuthUnavailable
            };
            throw bridgeError;
        }
        return input;
    }
    /**
     * Private constructor for BridgeProxy
     * @param sdkName The name of the SDK being used to make requests on behalf of the app
     * @param sdkVersion The version of the SDK being used to make requests on behalf of the app
     * @param capabilities The capabilities of the bridge / SDK / platform broker
     */ constructor(sdkName, sdkVersion, accountContext, capabilities){
        this.sdkName = sdkName;
        this.sdkVersion = sdkVersion;
        this.accountContext = accountContext;
        this.capabilities = capabilities;
    }
    /**
     * Factory method for creating an implementation of IBridgeProxy
     * @returns A promise that resolves to a BridgeProxy implementation
     */ static async create() {
        const response = await $3dd2157439507fd9$export$d974b2d5dad1979e.initializeNestedAppAuthBridge();
        return new $3dd2157439507fd9$export$d974b2d5dad1979e(response.sdkName, response.sdkVersion, response.accountContext, response.capabilities);
    }
}
$3dd2157439507fd9$export$d974b2d5dad1979e.bridgeRequests = [];


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $75a4a94a21a3562a$export$a2170d4e3f010950 extends (0, $067993367301e153$export$3aea257f46651b2b) {
    constructor(){
        super(...arguments);
        this.bridgeProxy = undefined;
        this.accountContext = null;
    }
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $75a4a94a21a3562a$export$a2170d4e3f010950.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $75a4a94a21a3562a$export$a2170d4e3f010950.ID;
    }
    /**
     * Returns the current BridgeProxy
     * @returns IBridgeProxy | undefined
     */ getBridgeProxy() {
        return this.bridgeProxy;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize() {
        try {
            if (typeof window !== "undefined") {
                if (typeof window.__initializeNestedAppAuth === "function") await window.__initializeNestedAppAuth();
                const bridgeProxy = await (0, $3dd2157439507fd9$export$d974b2d5dad1979e).create();
                /*
                 * Because we want single sign on we expect the host app to provide the account context
                 * with a min set of params that can be used to identify the account
                 * this.account = nestedApp.getAccountByFilter(bridgeProxy.getAccountContext());
                 */ this.accountContext = bridgeProxy.getAccountContext();
                this.bridgeProxy = bridgeProxy;
                this.available = bridgeProxy !== undefined;
            }
        } catch (ex) {
            this.logger.infoPii(`Could not initialize Nested App Auth bridge (${ex})`);
        }
        this.logger.info(`Nested App Auth Bridge available: ${this.available}`);
        return this.available;
    }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $75a4a94a21a3562a$export$a2170d4e3f010950.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $75a4a94a21a3562a$export$a2170d4e3f010950.ID = "NestedAppOperatingContext";


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $471b8a333094f1b0$export$f39c23bbfed89e6e extends (0, $067993367301e153$export$3aea257f46651b2b) {
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $471b8a333094f1b0$export$f39c23bbfed89e6e.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $471b8a333094f1b0$export$f39c23bbfed89e6e.ID;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize() {
        this.available = typeof window !== "undefined";
        return this.available;
    /*
         * NOTE: The standard context is available as long as there is a window.  If/when we split out WAM from Browser
         * We can move the current contents of the initialize method to here and verify that the WAM extension is available
         */ }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $471b8a333094f1b0$export$f39c23bbfed89e6e.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $471b8a333094f1b0$export$f39c23bbfed89e6e.ID = "StandardOperatingContext";


/*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 
/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $4056c455e6d83b21$export$e2ac717a196f20ed = "missing_kid_error";
const $4056c455e6d83b21$export$de67390d0a514010 = "missing_alg_error";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $85bb6e7796adcfd2$export$ce96a12d056376ad = {
    [(0, $4056c455e6d83b21$export$e2ac717a196f20ed)]: "The JOSE Header for the requested JWT, JWS or JWK object requires a keyId to be configured as the 'kid' header claim. No 'kid' value was provided.",
    [(0, $4056c455e6d83b21$export$de67390d0a514010)]: "The JOSE Header for the requested JWT, JWS or JWK object requires an algorithm to be specified as the 'alg' header claim. No 'alg' value was provided."
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $85bb6e7796adcfd2$export$980ad46b7a115fad extends (0, $40da14d5d49dd285$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        this.name = "JoseHeaderError";
        Object.setPrototypeOf(this, $85bb6e7796adcfd2$export$980ad46b7a115fad.prototype);
    }
}
/** Returns JoseHeaderError object */ function $85bb6e7796adcfd2$export$3ef463ea134172ed(code) {
    return new $85bb6e7796adcfd2$export$980ad46b7a115fad(code, $85bb6e7796adcfd2$export$ce96a12d056376ad[code]);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $25f98e85c46ee615$export$91748d132e6cb9b3 {
    constructor(options){
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object and returns
     * the stringified header object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @returns
     */ static getShrHeaderString(shrHeaderOptions) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) throw (0, $85bb6e7796adcfd2$export$3ef463ea134172ed)((0, $4056c455e6d83b21$export$e2ac717a196f20ed));
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) throw (0, $85bb6e7796adcfd2$export$3ef463ea134172ed)((0, $4056c455e6d83b21$export$de67390d0a514010));
        const shrHeader = new $25f98e85c46ee615$export$91748d132e6cb9b3({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || (0, $e6f7ad11e10d0573$export$fe5c42ed17efe603).Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        });
        return JSON.stringify(shrHeader);
    }
}



/*! @azure/msal-browser v3.27.0 2024-11-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */ /**
 * Returns a URL-safe plaintext decoded string from b64 encoded input.
 * @param input
 */ function $bb6fd55178ea2979$export$c62426fdd000a97e(input) {
    return new TextDecoder().decode($bb6fd55178ea2979$var$base64DecToArr(input));
}
/**
 * Decodes base64 into Uint8Array
 * @param base64String
 */ function $bb6fd55178ea2979$var$base64DecToArr(base64String) {
    let encodedString = base64String.replace(/-/g, "+").replace(/_/g, "/");
    switch(encodedString.length % 4){
        case 0:
            break;
        case 2:
            encodedString += "==";
            break;
        case 3:
            encodedString += "=";
            break;
        default:
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$fcc6790b5d12da63));
    }
    const binString = atob(encodedString);
    return Uint8Array.from(binString, (m)=>m.codePointAt(0) || 0);
}




/*! @azure/msal-browser v3.27.0 2024-11-05 */ 
/*! @azure/msal-browser v3.27.0 2024-11-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */ class $240f4c05c5df70b8$export$286b0f3b569e5f16 {
    constructor(){
        this.dbName = (0, $e195f599725a9f25$export$3c22ff8b64b8f565);
        this.version = (0, $e195f599725a9f25$export$6a9022b4c5fcea02);
        this.tableName = (0, $e195f599725a9f25$export$9d785db034fb436f);
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */ async open() {
        return new Promise((resolve, reject)=>{
            const openDB = window.indexedDB.open(this.dbName, this.version);
            openDB.addEventListener("upgradeneeded", (e)=>{
                const event = e;
                event.target.result.createObjectStore(this.tableName);
            });
            openDB.addEventListener("success", (e)=>{
                const event = e;
                this.db = event.target.result;
                this.dbOpen = true;
                resolve();
            });
            openDB.addEventListener("error", ()=>reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$c1110692d2978b8))));
        });
    }
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */ closeConnection() {
        const db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    }
    /**
     * Opens database if it's not already open
     */ async validateDbIsOpen() {
        if (!this.dbOpen) return this.open();
    }
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */ async getItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGet = objectStore.get(key);
            dbGet.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGet.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */ async setItem(key, payload) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbPut = objectStore.put(payload, key);
            dbPut.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbPut.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */ async removeItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbDelete = objectStore.delete(key);
            dbDelete.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbDelete.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */ async getKeys() {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGetKeys = objectStore.getAllKeys();
            dbGetKeys.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGetKeys.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */ async containsKey(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbContainsKey = objectStore.count(key);
            dbContainsKey.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result === 1);
            });
            dbContainsKey.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */ async deleteDatabase() {
        // Check if database being deleted exists
        if (this.db && this.dbOpen) this.closeConnection();
        return new Promise((resolve, reject)=>{
            const deleteDbRequest = window.indexedDB.deleteDatabase((0, $e195f599725a9f25$export$3c22ff8b64b8f565));
            const id = setTimeout(()=>reject(false), 200); // Reject if events aren't raised within 200ms
            deleteDbRequest.addEventListener("success", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("blocked", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("error", ()=>{
                clearTimeout(id);
                return reject(false);
            });
        });
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $5c8b15c6432b04fe$export$d7392285c701ecf5 {
    constructor(){
        this.cache = new Map();
    }
    getItem(key) {
        return this.cache.get(key) || null;
    }
    setItem(key, value) {
        this.cache.set(key, value);
    }
    removeItem(key) {
        this.cache.delete(key);
    }
    getKeys() {
        const cacheKeys = [];
        this.cache.forEach((value, key)=>{
            cacheKeys.push(key);
        });
        return cacheKeys;
    }
    containsKey(key) {
        return this.cache.has(key);
    }
    clear() {
        this.cache.clear();
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */ class $0926b97267f5b606$export$b38f35aab37afcde {
    constructor(logger){
        this.inMemoryCache = new (0, $5c8b15c6432b04fe$export$d7392285c701ecf5)();
        this.indexedDBCache = new (0, $240f4c05c5df70b8$export$286b0f3b569e5f16)();
        this.logger = logger;
    }
    handleDatabaseAccessError(error) {
        if (error instanceof (0, $1eca0489e18862c6$export$f8eb6760ca13876a) && error.errorCode === (0, $8e6ba27e37631a08$export$c1110692d2978b8)) this.logger.error("Could not access persistent storage. This may be caused by browser privacy features which block persistent storage in third-party contexts.");
        else throw error;
    }
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     */ async getItem(key) {
        const item = this.inMemoryCache.getItem(key);
        if (!item) try {
            this.logger.verbose("Queried item not found in in-memory cache, now querying persistent storage.");
            return await this.indexedDBCache.getItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return item;
    }
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     */ async setItem(key, value) {
        this.inMemoryCache.setItem(key, value);
        try {
            await this.indexedDBCache.setItem(key, value);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
    }
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     */ async removeItem(key) {
        this.inMemoryCache.removeItem(key);
        try {
            await this.indexedDBCache.removeItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
    }
    /**
     * Get all the keys from the in-memory cache as an iterable array of strings. If no keys are found, query the keys in the
     * asynchronous storage object.
     */ async getKeys() {
        const cacheKeys = this.inMemoryCache.getKeys();
        if (cacheKeys.length === 0) try {
            this.logger.verbose("In-memory cache is empty, now querying persistent storage.");
            return await this.indexedDBCache.getKeys();
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return cacheKeys;
    }
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     */ async containsKey(key) {
        const containsKey = this.inMemoryCache.containsKey(key);
        if (!containsKey) try {
            this.logger.verbose("Key not found in in-memory cache, now querying persistent storage.");
            return await this.indexedDBCache.containsKey(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return containsKey;
    }
    /**
     * Clears in-memory Map
     */ clearInMemory() {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose(`Deleting in-memory keystore`);
        this.inMemoryCache.clear();
        this.logger.verbose(`In-memory keystore deleted`);
    }
    /**
     * Tries to delete the IndexedDB database
     * @returns
     */ async clearPersistent() {
        try {
            this.logger.verbose("Deleting persistent keystore");
            const dbDeleted = await this.indexedDBCache.deleteDatabase();
            if (dbDeleted) this.logger.verbose("Persistent keystore deleted");
            return dbDeleted;
        } catch (e) {
            this.handleDatabaseAccessError(e);
            return false;
        }
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */ class $e9cd6ef4fe15cd8f$export$c274a7f0ebd24b14 {
    constructor(logger, performanceClient){
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        (0, $a65ce7794137937d$export$1ddcc6bab2bf2314)();
        this.cache = new (0, $0926b97267f5b606$export$b38f35aab37afcde)(this.logger);
        this.performanceClient = performanceClient;
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */ createNewGuid() {
        return (0, $a65ce7794137937d$export$6ef0355fa80a5278)();
    }
    /**
     * Encodes input string to base64.
     * @param input
     */ base64Encode(input) {
        return (0, $be65c31a50210a3d$export$e510a73ee562749)(input);
    }
    /**
     * Decodes input string from base64.
     * @param input
     */ base64Decode(input) {
        return (0, $bb6fd55178ea2979$export$c62426fdd000a97e)(input);
    }
    /**
     * Encodes input string to base64 URL safe string.
     * @param input
     */ base64UrlEncode(input) {
        return (0, $be65c31a50210a3d$export$9ef804feabbcbaf1)(input);
    }
    /**
     * Stringifies and base64Url encodes input public key
     * @param inputKid
     * @returns Base64Url encoded public key
     */ encodeKid(inputKid) {
        return this.base64UrlEncode(JSON.stringify({
            kid: inputKid
        }));
    }
    /**
     * Generates a keypair, stores it and returns a thumbprint
     * @param request
     */ async getPublicKeyThumbprint(request) {
        const publicKeyThumbMeasurement = this.performanceClient?.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).CryptoOptsGetPublicKeyThumbprint, request.correlationId);
        // Generate Keypair
        const keyPair = await (0, $a65ce7794137937d$export$a949d36eab55b41f)($e9cd6ef4fe15cd8f$export$c274a7f0ebd24b14.EXTRACTABLE, $e9cd6ef4fe15cd8f$export$c274a7f0ebd24b14.POP_KEY_USAGES);
        // Generate Thumbprint for Public Key
        const publicKeyJwk = await (0, $a65ce7794137937d$export$88781b8595a7d2ff)(keyPair.publicKey);
        const pubKeyThumprintObj = {
            e: publicKeyJwk.e,
            kty: publicKeyJwk.kty,
            n: publicKeyJwk.n
        };
        const publicJwkString = $e9cd6ef4fe15cd8f$var$getSortedObjectString(pubKeyThumprintObj);
        const publicJwkHash = await this.hashString(publicJwkString);
        // Generate Thumbprint for Private Key
        const privateKeyJwk = await (0, $a65ce7794137937d$export$88781b8595a7d2ff)(keyPair.privateKey);
        // Re-import private key to make it unextractable
        const unextractablePrivateKey = await (0, $a65ce7794137937d$export$8bdea4e2e3f593c9)(privateKeyJwk, false, [
            "sign"
        ]);
        // Store Keypair data in keystore
        await this.cache.setItem(publicJwkHash, {
            privateKey: unextractablePrivateKey,
            publicKey: keyPair.publicKey,
            requestMethod: request.resourceRequestMethod,
            requestUri: request.resourceRequestUri
        });
        if (publicKeyThumbMeasurement) publicKeyThumbMeasurement.end({
            success: true
        });
        return publicJwkHash;
    }
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     */ async removeTokenBindingKey(kid) {
        await this.cache.removeItem(kid);
        const keyFound = await this.cache.containsKey(kid);
        return !keyFound;
    }
    /**
     * Removes all cryptographic keys from IndexedDB storage
     */ async clearKeystore() {
        // Delete in-memory keystores
        this.cache.clearInMemory();
        /**
         * There is only one database, so calling clearPersistent on asymmetric keystore takes care of
         * every persistent keystore
         */ try {
            await this.cache.clearPersistent();
            return true;
        } catch (e) {
            if (e instanceof Error) this.logger.error(`Clearing keystore failed with error: ${e.message}`);
            else this.logger.error("Clearing keystore failed with unknown error");
            return false;
        }
    }
    /**
     * Signs the given object as a jwt payload with private key retrieved by given kid.
     * @param payload
     * @param kid
     */ async signJwt(payload, kid, shrOptions, correlationId) {
        const signJwtMeasurement = this.performanceClient?.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).CryptoOptsSignJwt, correlationId);
        const cachedKeyPair = await this.cache.getItem(kid);
        if (!cachedKeyPair) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$a416b0eceb5c15df));
        // Get public key as JWK
        const publicKeyJwk = await (0, $a65ce7794137937d$export$88781b8595a7d2ff)(cachedKeyPair.publicKey);
        const publicKeyJwkString = $e9cd6ef4fe15cd8f$var$getSortedObjectString(publicKeyJwk);
        // Base64URL encode public key thumbprint with keyId only: BASE64URL({ kid: "FULL_PUBLIC_KEY_HASH" })
        const encodedKeyIdThumbprint = (0, $be65c31a50210a3d$export$9ef804feabbcbaf1)(JSON.stringify({
            kid: kid
        }));
        // Generate header
        const shrHeader = (0, $25f98e85c46ee615$export$91748d132e6cb9b3).getShrHeaderString({
            ...shrOptions?.header,
            alg: publicKeyJwk.alg,
            kid: encodedKeyIdThumbprint
        });
        const encodedShrHeader = (0, $be65c31a50210a3d$export$9ef804feabbcbaf1)(shrHeader);
        // Generate payload
        payload.cnf = {
            jwk: JSON.parse(publicKeyJwkString)
        };
        const encodedPayload = (0, $be65c31a50210a3d$export$9ef804feabbcbaf1)(JSON.stringify(payload));
        // Form token string
        const tokenString = `${encodedShrHeader}.${encodedPayload}`;
        // Sign token
        const encoder = new TextEncoder();
        const tokenBuffer = encoder.encode(tokenString);
        const signatureBuffer = await (0, $a65ce7794137937d$export$c5552dfdbc7cec71)(cachedKeyPair.privateKey, tokenBuffer);
        const encodedSignature = (0, $be65c31a50210a3d$export$84f5a428c7153a69)(new Uint8Array(signatureBuffer));
        const signedJwt = `${tokenString}.${encodedSignature}`;
        if (signJwtMeasurement) signJwtMeasurement.end({
            success: true
        });
        return signedJwt;
    }
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */ async hashString(plainText) {
        return (0, $a65ce7794137937d$export$9169be2e06c9c165)(plainText);
    }
}
$e9cd6ef4fe15cd8f$export$c274a7f0ebd24b14.POP_KEY_USAGES = [
    "sign",
    "verify"
];
$e9cd6ef4fe15cd8f$export$c274a7f0ebd24b14.EXTRACTABLE = true;
function $e9cd6ef4fe15cd8f$var$getSortedObjectString(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}


/*! @azure/msal-common v14.16.0 2024-11-05 */ 
/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $6a93ee145666d8e0$export$aab44dc88900a3b(response) {
    return response.hasOwnProperty("authorization_endpoint") && response.hasOwnProperty("token_endpoint") && response.hasOwnProperty("issuer") && response.hasOwnProperty("jwks_uri");
}









/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $fd4202a23e62f58e$export$b288ea4a1e969e42(response) {
    return response.hasOwnProperty("tenant_discovery_endpoint") && response.hasOwnProperty("metadata");
}


/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $74b9fb871dcae12c$export$6716273459d383f8(response) {
    return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}


/*! @azure/msal-common v14.16.0 2024-11-05 */ 

/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Wraps a function with a performance measurement.
 * Usage: invoke(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ae433257996980ce$export$468cda29b159ee5d = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function ${eventName}`);
        const inProgressEvent = telemetryClient?.startMeasurement(eventName, correlationId);
        if (correlationId) {
            // Track number of times this API is called in a single request
            const eventCount = eventName + "CallCount";
            telemetryClient?.incrementFields({
                [eventCount]: 1
            }, correlationId);
        }
        try {
            const result = callback(...args);
            inProgressEvent?.end({
                success: true
            });
            logger.trace(`Returning result from ${eventName}`);
            return result;
        } catch (e) {
            logger.trace(`Error occurred in ${eventName}`);
            try {
                logger.trace(JSON.stringify(e));
            } catch (e) {
                logger.trace("Unable to print error message.");
            }
            inProgressEvent?.end({
                success: false
            }, e);
            throw e;
        }
    };
};
/**
 * Wraps an async function with a performance measurement.
 * Usage: invokeAsync(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 *
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ae433257996980ce$export$e4feded94d9adb18 = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function ${eventName}`);
        const inProgressEvent = telemetryClient?.startMeasurement(eventName, correlationId);
        if (correlationId) {
            // Track number of times this API is called in a single request
            const eventCount = eventName + "CallCount";
            telemetryClient?.incrementFields({
                [eventCount]: 1
            }, correlationId);
        }
        telemetryClient?.setPreQueueTime(eventName, correlationId);
        return callback(...args).then((response)=>{
            logger.trace(`Returning result from ${eventName}`);
            inProgressEvent?.end({
                success: true
            });
            return response;
        }).catch((e)=>{
            logger.trace(`Error occurred in ${eventName}`);
            try {
                logger.trace(JSON.stringify(e));
            } catch (e) {
                logger.trace("Unable to print error message.");
            }
            inProgressEvent?.end({
                success: false
            }, e);
            throw e;
        });
    };
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $ae0777567c29b926$export$1afa9d0f261ebb47 {
    constructor(networkInterface, logger, performanceClient, correlationId){
        this.networkInterface = networkInterface;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */ async detectRegion(environmentRegion, regionDiscoveryMetadata) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.correlationId);
        // Initialize auto detected region with the region from the envrionment
        let autodetectedRegionName = environmentRegion;
        // Check if a region was detected from the environment, if not, attempt to get the region from IMDS
        if (!autodetectedRegionName) {
            const options = $ae0777567c29b926$export$1afa9d0f261ebb47.IMDS_OPTIONS;
            try {
                const localIMDSVersionResponse = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)((0, $e6f7ad11e10d0573$export$a002182e51710d39).IMDS_VERSION, options);
                if (localIMDSVersionResponse.status === (0, $e6f7ad11e10d0573$export$20ba0879771a17be).httpSuccess) {
                    autodetectedRegionName = localIMDSVersionResponse.body;
                    regionDiscoveryMetadata.region_source = (0, $e6f7ad11e10d0573$export$3d4a3e11df589b40).IMDS;
                }
                // If the response using the local IMDS version failed, try to fetch the current version of IMDS and retry.
                if (localIMDSVersionResponse.status === (0, $e6f7ad11e10d0573$export$20ba0879771a17be).httpBadRequest) {
                    const currentIMDSVersion = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.getCurrentVersion.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.logger, this.performanceClient, this.correlationId)(options);
                    if (!currentIMDSVersion) {
                        regionDiscoveryMetadata.region_source = (0, $e6f7ad11e10d0573$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                        return null;
                    }
                    const currentIMDSVersionResponse = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)(currentIMDSVersion, options);
                    if (currentIMDSVersionResponse.status === (0, $e6f7ad11e10d0573$export$20ba0879771a17be).httpSuccess) {
                        autodetectedRegionName = currentIMDSVersionResponse.body;
                        regionDiscoveryMetadata.region_source = (0, $e6f7ad11e10d0573$export$3d4a3e11df589b40).IMDS;
                    }
                }
            } catch (e) {
                regionDiscoveryMetadata.region_source = (0, $e6f7ad11e10d0573$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                return null;
            }
        } else regionDiscoveryMetadata.region_source = (0, $e6f7ad11e10d0573$export$3d4a3e11df589b40).ENVIRONMENT_VARIABLE;
        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
        if (!autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, $e6f7ad11e10d0573$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
        return autodetectedRegionName || null;
    }
    /**
     * Make the call to the IMDS endpoint
     *
     * @param imdsEndpointUrl
     * @returns Promise<NetworkResponse<string>>
     */ async getRegionFromIMDS(version, options) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.correlationId);
        return this.networkInterface.sendGetRequestAsync(`${(0, $e6f7ad11e10d0573$export$a002182e51710d39).IMDS_ENDPOINT}?api-version=${version}&format=text`, options, (0, $e6f7ad11e10d0573$export$a002182e51710d39).IMDS_TIMEOUT);
    }
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */ async getCurrentVersion(options) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.correlationId);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(`${(0, $e6f7ad11e10d0573$export$a002182e51710d39).IMDS_ENDPOINT}?format=json`, options);
            // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
            if (response.status === (0, $e6f7ad11e10d0573$export$20ba0879771a17be).httpBadRequest && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) return response.body["newest-versions"][0];
            return null;
        } catch (e) {
            return null;
        }
    }
}
// Options for the IMDS endpoint request
$ae0777567c29b926$export$1afa9d0f261ebb47.IMDS_OPTIONS = {
    headers: {
        Metadata: "true"
    }
};








'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 * @internal
 */ class $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c {
    constructor(authority, networkInterface, cacheManager, authorityOptions, logger, correlationId, performanceClient, managedIdentity){
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = {
            region_used: undefined,
            region_source: undefined,
            region_outcome: undefined
        };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.managedIdentity = managedIdentity || false;
        this.regionDiscovery = new (0, $ae0777567c29b926$export$1afa9d0f261ebb47)(networkInterface, this.logger, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType}
     * @param authorityUri {@link IUri}
     * @private
     */ getAuthorityType(authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith((0, $e6f7ad11e10d0573$export$a002182e51710d39).CIAM_AUTH_URL)) return (0, $1075494641e42ac7$export$cd82032b224a3839).Ciam;
        const pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) switch(pathSegments[0].toLowerCase()){
            case (0, $e6f7ad11e10d0573$export$a002182e51710d39).ADFS:
                return (0, $1075494641e42ac7$export$cd82032b224a3839).Adfs;
            case (0, $e6f7ad11e10d0573$export$a002182e51710d39).DSTS:
                return (0, $1075494641e42ac7$export$cd82032b224a3839).Dsts;
        }
        return (0, $1075494641e42ac7$export$cd82032b224a3839).Default;
    }
    // See above for AuthorityType
    get authorityType() {
        return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
    }
    /**
     * ProtocolMode enum representing the way endpoints are constructed.
     */ get protocolMode() {
        return this.authorityOptions.protocolMode;
    }
    /**
     * Returns authorityOptions which can be used to reinstantiate a new authority instance
     */ get options() {
        return this.authorityOptions;
    }
    /**
     * A URL that is the authority set by the developer
     */ get canonicalAuthority() {
        return this._canonicalAuthority.urlString;
    }
    /**
     * Sets canonical authority.
     */ set canonicalAuthority(url) {
        this._canonicalAuthority = new (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2)(url);
        this._canonicalAuthority.validateAsUri();
        this._canonicalAuthorityUrlComponents = null;
    }
    /**
     * Get authority components.
     */ get canonicalAuthorityUrlComponents() {
        if (!this._canonicalAuthorityUrlComponents) this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
        return this._canonicalAuthorityUrlComponents;
    }
    /**
     * Get hostname and port i.e. login.microsoftonline.com
     */ get hostnameAndPort() {
        return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
    }
    /**
     * Get tenant for authority.
     */ get tenant() {
        return this.canonicalAuthorityUrlComponents.PathSegments[0];
    }
    /**
     * OAuth /authorize endpoint for requests
     */ get authorizationEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
        else throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth /token endpoint for requests
     */ get tokenEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
        else throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3));
    }
    get deviceCodeEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
        else throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth logout endpoint for requests
     */ get endSessionEndpoint() {
        if (this.discoveryComplete()) {
            // ROPC policies may not have end_session_endpoint set
            if (!this.metadata.end_session_endpoint) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$c3bd741c16a889f3));
            return this.replacePath(this.metadata.end_session_endpoint);
        } else throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth issuer for requests
     */ get selfSignedJwtAudience() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
        else throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3));
    }
    /**
     * Jwks_uri for token signing keys
     */ get jwksUri() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
        else throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3));
    }
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */ canReplaceTenant(authorityUri) {
        return authorityUri.PathSegments.length === 1 && !$2d706f1a340b3c1d$export$f1c6ec2e6d68c49c.reservedTenantDomains.has(authorityUri.PathSegments[0]) && this.getAuthorityType(authorityUri) === (0, $1075494641e42ac7$export$cd82032b224a3839).Default && this.protocolMode === (0, $340831fc14c31b77$export$73a3e3dedd37150d).AAD;
    }
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */ replaceTenant(urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    }
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */ replacePath(urlString) {
        let endpoint = urlString;
        const cachedAuthorityUrl = new (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2)(this.metadata.canonical_authority);
        const cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        const cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        const currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach((currentPart, index)=>{
            let cachedPart = cachedAuthorityParts[index];
            if (index === 0 && this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                const tenantId = new (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2)(this.metadata.authorization_endpoint).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */ if (cachedPart !== tenantId) {
                    this.logger.verbose(`Replacing tenant domain name ${cachedPart} with id ${tenantId}`);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) endpoint = endpoint.replace(`/${cachedPart}/`, `/${currentPart}/`);
        });
        return this.replaceTenant(endpoint);
    }
    /**
     * The default open id configuration endpoint for any canonical authority.
     */ get defaultOpenIdConfigurationEndpoint() {
        const canonicalAuthorityHost = this.hostnameAndPort;
        if (this.canonicalAuthority.endsWith("v2.0/") || this.authorityType === (0, $1075494641e42ac7$export$cd82032b224a3839).Adfs || this.protocolMode !== (0, $340831fc14c31b77$export$73a3e3dedd37150d).AAD && !this.isAliasOfKnownMicrosoftAuthority(canonicalAuthorityHost)) return `${this.canonicalAuthority}.well-known/openid-configuration`;
        return `${this.canonicalAuthority}v2.0/.well-known/openid-configuration`;
    }
    /**
     * Boolean that returns whether or not tenant discovery has been completed.
     */ discoveryComplete() {
        return !!this.metadata;
    }
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */ async resolveEndpointsAsync() {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, this.correlationId);
        const metadataEntity = this.getCurrentMetadataEntity();
        const cloudDiscoverySource = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.updateCloudDiscoveryMetadata.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
        const endpointSource = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.updateEndpointMetadata.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.updateCachedMetadata(metadataEntity, cloudDiscoverySource, {
            source: endpointSource
        });
        this.performanceClient?.addFields({
            cloudDiscoverySource: cloudDiscoverySource,
            authorityEndpointSource: endpointSource
        }, this.correlationId);
    }
    /**
     * Returns metadata entity from cache if it exists, otherwiser returns a new metadata entity built
     * from the configured canonical authority
     * @returns
     */ getCurrentMetadataEntity() {
        let metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort);
        if (!metadataEntity) metadataEntity = {
            aliases: [],
            preferred_cache: this.hostnameAndPort,
            preferred_network: this.hostnameAndPort,
            canonical_authority: this.canonicalAuthority,
            authorization_endpoint: "",
            token_endpoint: "",
            end_session_endpoint: "",
            issuer: "",
            aliasesFromNetwork: false,
            endpointsFromNetwork: false,
            expiresAt: (0, $d6bc4864bb049bc4$export$90f464c4238c27e5)(),
            jwks_uri: ""
        };
        return metadataEntity;
    }
    /**
     * Updates cached metadata based on metadata source and sets the instance's metadata
     * property to the same value
     * @param metadataEntity
     * @param cloudDiscoverySource
     * @param endpointMetadataResult
     */ updateCachedMetadata(metadataEntity, cloudDiscoverySource, endpointMetadataResult) {
        if (cloudDiscoverySource !== (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).CACHE && endpointMetadataResult?.source !== (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).CACHE) {
            // Reset the expiration time unless both values came from a successful cache lookup
            metadataEntity.expiresAt = (0, $d6bc4864bb049bc4$export$90f464c4238c27e5)();
            metadataEntity.canonical_authority = this.canonicalAuthority;
        }
        const cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache);
        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity);
        this.metadata = metadataEntity;
    }
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */ async updateEndpointMetadata(metadataEntity) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.correlationId);
        const localMetadata = this.updateEndpointMetadataFromLocalSources(metadataEntity);
        // Further update may be required for hardcoded metadata if regional metadata is preferred
        if (localMetadata) {
            if (localMetadata.source === (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).HARDCODED_VALUES) {
                // If the user prefers to use an azure region replace the global endpoints with regional information.
                if (this.authorityOptions.azureRegionConfiguration?.azureRegion) {
                    if (localMetadata.metadata) {
                        const hardcodedMetadata = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(localMetadata.metadata);
                        (0, $d6bc4864bb049bc4$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                        metadataEntity.canonical_authority = this.canonicalAuthority;
                    }
                }
            }
            return localMetadata.source;
        }
        // Get metadata from network if local sources aren't available
        let metadata = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.getEndpointMetadataFromNetwork.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            // If the user prefers to use an azure region replace the global endpoints with regional information.
            if (this.authorityOptions.azureRegionConfiguration?.azureRegion) metadata = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(metadata);
            (0, $d6bc4864bb049bc4$export$ef87e8fbd8af5f96)(metadataEntity, metadata, true);
            return (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).NETWORK;
        } else // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$73566da29bc073eb), this.defaultOpenIdConfigurationEndpoint);
    }
    /**
     * Updates endpoint metadata from local sources and returns where the information was retrieved from and the metadata config
     * response if the source is hardcoded metadata
     * @param metadataEntity
     * @returns
     */ updateEndpointMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get endpoint metadata from authority configuration");
        const configMetadata = this.getEndpointMetadataFromConfig();
        if (configMetadata) {
            this.logger.verbose("Found endpoint metadata in authority configuration");
            (0, $d6bc4864bb049bc4$export$ef87e8fbd8af5f96)(metadataEntity, configMetadata, false);
            return {
                source: (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).CONFIG
            };
        }
        this.logger.verbose("Did not find endpoint metadata in the config... Attempting to get endpoint metadata from the hardcoded values.");
        // skipAuthorityMetadataCache is used to bypass hardcoded authority metadata and force a network metadata cache lookup and network metadata request if no cached response is available.
        if (this.authorityOptions.skipAuthorityMetadataCache) this.logger.verbose("Skipping hardcoded metadata cache since skipAuthorityMetadataCache is set to true. Attempting to get endpoint metadata from the network metadata cache.");
        else {
            const hardcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
            if (hardcodedMetadata) {
                (0, $d6bc4864bb049bc4$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                return {
                    source: (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).HARDCODED_VALUES,
                    metadata: hardcodedMetadata
                };
            } else this.logger.verbose("Did not find endpoint metadata in hardcoded values... Attempting to get endpoint metadata from the network metadata cache.");
        }
        // Check cached metadata entity expiration status
        const metadataEntityExpired = (0, $d6bc4864bb049bc4$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntityExpired) {
            // No need to update
            this.logger.verbose("Found endpoint metadata in the cache.");
            return {
                source: (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).CACHE
            };
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
        return null;
    }
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */ isAuthoritySameType(metadataEntity) {
        const cachedAuthorityUrl = new (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2)(metadataEntity.canonical_authority);
        const cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    }
    /**
     * Parse authorityMetadata config option
     */ getEndpointMetadataFromConfig() {
        if (this.authorityOptions.authorityMetadata) try {
            return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch (e) {
            throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$edb4d5942bc8ccff));
        }
        return null;
    }
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */ async getEndpointMetadataFromNetwork() {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.correlationId);
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ const openIdConfigurationEndpoint = this.defaultOpenIdConfigurationEndpoint;
        this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: attempting to retrieve OAuth endpoints from ${openIdConfigurationEndpoint}`);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(openIdConfigurationEndpoint, options);
            const isValidResponse = (0, $6a93ee145666d8e0$export$aab44dc88900a3b)(response.body);
            if (isValidResponse) return response.body;
            else {
                this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: could not parse response as OpenID configuration`);
                return null;
            }
        } catch (e) {
            this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: ${e}`);
            return null;
        }
    }
    /**
     * Get OAuth endpoints for common authorities.
     */ getEndpointMetadataFromHardcodedValues() {
        if (this.hostnameAndPort in (0, $0e21b55efe440ffb$export$f612854287391207)) return (0, $0e21b55efe440ffb$export$f612854287391207)[this.hostnameAndPort];
        return null;
    }
    /**
     * Update the retrieved metadata with regional information.
     * User selected Azure region will be used if configured.
     */ async updateMetadataWithRegionalInformation(metadata) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
        const userConfiguredAzureRegion = this.authorityOptions.azureRegionConfiguration?.azureRegion;
        if (userConfiguredAzureRegion) {
            if (userConfiguredAzureRegion !== (0, $e6f7ad11e10d0573$export$a002182e51710d39).AZURE_REGION_AUTO_DISCOVER_FLAG) {
                this.regionDiscoveryMetadata.region_outcome = (0, $e6f7ad11e10d0573$export$92a685f9218422bd).CONFIGURED_NO_AUTO_DETECTION;
                this.regionDiscoveryMetadata.region_used = userConfiguredAzureRegion;
                return $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, userConfiguredAzureRegion);
            }
            const autodetectedRegionName = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.regionDiscovery.detectRegion.bind(this.regionDiscovery), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.logger, this.performanceClient, this.correlationId)(this.authorityOptions.azureRegionConfiguration?.environmentRegion, this.regionDiscoveryMetadata);
            if (autodetectedRegionName) {
                this.regionDiscoveryMetadata.region_outcome = (0, $e6f7ad11e10d0573$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_SUCCESSFUL;
                this.regionDiscoveryMetadata.region_used = autodetectedRegionName;
                return $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, autodetectedRegionName);
            }
            this.regionDiscoveryMetadata.region_outcome = (0, $e6f7ad11e10d0573$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_FAILED;
        }
        return metadata;
    }
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */ async updateCloudDiscoveryMetadata(metadataEntity) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.correlationId);
        const localMetadataSource = this.updateCloudDiscoveryMetadataFromLocalSources(metadataEntity);
        if (localMetadataSource) return localMetadataSource;
        // Fallback to network as metadata source
        const metadata = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.getCloudDiscoveryMetadataFromNetwork.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            (0, $d6bc4864bb049bc4$export$6d4972e1d88c8518)(metadataEntity, metadata, true);
            return (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).NETWORK;
        }
        // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$50c3162fda5f57));
    }
    updateCloudDiscoveryMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get cloud discovery metadata  from authority configuration");
        this.logger.verbosePii(`Known Authorities: ${this.authorityOptions.knownAuthorities || (0, $e6f7ad11e10d0573$export$a002182e51710d39).NOT_APPLICABLE}`);
        this.logger.verbosePii(`Authority Metadata: ${this.authorityOptions.authorityMetadata || (0, $e6f7ad11e10d0573$export$a002182e51710d39).NOT_APPLICABLE}`);
        this.logger.verbosePii(`Canonical Authority: ${metadataEntity.canonical_authority || (0, $e6f7ad11e10d0573$export$a002182e51710d39).NOT_APPLICABLE}`);
        const metadata = this.getCloudDiscoveryMetadataFromConfig();
        if (metadata) {
            this.logger.verbose("Found cloud discovery metadata in authority configuration");
            (0, $d6bc4864bb049bc4$export$6d4972e1d88c8518)(metadataEntity, metadata, false);
            return (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).CONFIG;
        }
        // If the cached metadata came from config but that config was not passed to this instance, we must go to hardcoded values
        this.logger.verbose("Did not find cloud discovery metadata in the config... Attempting to get cloud discovery metadata from the hardcoded values.");
        if (this.options.skipAuthorityMetadataCache) this.logger.verbose("Skipping hardcoded cloud discovery metadata cache since skipAuthorityMetadataCache is set to true. Attempting to get cloud discovery metadata from the network metadata cache.");
        else {
            const hardcodedMetadata = (0, $0e21b55efe440ffb$export$1b1433f93c9873f)(this.hostnameAndPort);
            if (hardcodedMetadata) {
                this.logger.verbose("Found cloud discovery metadata from hardcoded values.");
                (0, $d6bc4864bb049bc4$export$6d4972e1d88c8518)(metadataEntity, hardcodedMetadata, false);
                return (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).HARDCODED_VALUES;
            }
            this.logger.verbose("Did not find cloud discovery metadata in hardcoded values... Attempting to get cloud discovery metadata from the network metadata cache.");
        }
        const metadataEntityExpired = (0, $d6bc4864bb049bc4$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
            this.logger.verbose("Found cloud discovery metadata in the cache.");
            // No need to update
            return (0, $e6f7ad11e10d0573$export$5d365d77acfcb55d).CACHE;
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
        return null;
    }
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */ getCloudDiscoveryMetadataFromConfig() {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === (0, $1075494641e42ac7$export$cd82032b224a3839).Ciam) {
            this.logger.verbose("CIAM authorities do not support cloud discovery metadata, generate the aliases from authority host.");
            return $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("The cloud discovery metadata has been provided as a network response, in the config.");
            try {
                this.logger.verbose("Attempting to parse the cloud discovery metadata.");
                const parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                const metadata = (0, $0e21b55efe440ffb$export$6e21098ea6e60dc)(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("Parsed the cloud discovery metadata.");
                if (metadata) {
                    this.logger.verbose("There is returnable metadata attached to the parsed cloud discovery metadata.");
                    return metadata;
                } else this.logger.verbose("There is no metadata attached to the parsed cloud discovery metadata.");
            } catch (e) {
                this.logger.verbose("Unable to parse the cloud discovery metadata. Throwing Invalid Cloud Discovery Metadata Error.");
                throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$92a2985751150ca5));
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities()) {
            this.logger.verbose("The host is included in knownAuthorities. Creating new cloud discovery metadata from the host.");
            return $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    }
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */ async getCloudDiscoveryMetadataFromNetwork() {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.correlationId);
        const instanceDiscoveryEndpoint = `${(0, $e6f7ad11e10d0573$export$a002182e51710d39).AAD_INSTANCE_DISCOVERY_ENDPT}${this.canonicalAuthority}oauth2/v2.0/authorize`;
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ let match = null;
        try {
            const response = await this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options);
            let typedResponseBody;
            let metadata;
            if ((0, $fd4202a23e62f58e$export$b288ea4a1e969e42)(response.body)) {
                typedResponseBody = response.body;
                metadata = typedResponseBody.metadata;
                this.logger.verbosePii(`tenant_discovery_endpoint is: ${typedResponseBody.tenant_discovery_endpoint}`);
            } else if ((0, $74b9fb871dcae12c$export$6716273459d383f8)(response.body)) {
                this.logger.warning(`A CloudInstanceDiscoveryErrorResponse was returned. The cloud instance discovery network request's status code is: ${response.status}`);
                typedResponseBody = response.body;
                if (typedResponseBody.error === (0, $e6f7ad11e10d0573$export$a002182e51710d39).INVALID_INSTANCE) {
                    this.logger.error("The CloudInstanceDiscoveryErrorResponse error is invalid_instance.");
                    return null;
                }
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error is ${typedResponseBody.error}`);
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error description is ${typedResponseBody.error_description}`);
                this.logger.warning("Setting the value of the CloudInstanceDiscoveryMetadata (returned from the network) to []");
                metadata = [];
            } else {
                this.logger.error("AAD did not return a CloudInstanceDiscoveryResponse or CloudInstanceDiscoveryErrorResponse");
                return null;
            }
            this.logger.verbose("Attempting to find a match between the developer's authority and the CloudInstanceDiscoveryMetadata returned from the network request.");
            match = (0, $0e21b55efe440ffb$export$6e21098ea6e60dc)(metadata, this.hostnameAndPort);
        } catch (error) {
            if (error instanceof (0, $40da14d5d49dd285$export$145273558d58e0ac)) this.logger.error(`There was a network error while attempting to get the cloud discovery instance metadata.\nError: ${error.errorCode}\nError Description: ${error.errorMessage}`);
            else {
                const typedError = error;
                this.logger.error(`A non-MSALJS error was thrown while attempting to get the cloud instance discovery metadata.\nError: ${typedError.name}\nError Description: ${typedError.message}`);
            }
            return null;
        }
        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
        if (!match) {
            this.logger.warning("The developer's authority was not found within the CloudInstanceDiscoveryMetadata returned from the network request.");
            this.logger.verbose("Creating custom Authority for custom domain scenario.");
            match = $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return match;
    }
    /**
     * Helper function to determine if this host is included in the knownAuthorities config option
     */ isInKnownAuthorities() {
        const matches = this.authorityOptions.knownAuthorities.filter((authority)=>{
            return authority && (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).getDomainFromUrl(authority).toLowerCase() === this.hostnameAndPort;
        });
        return matches.length > 0;
    }
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */ static generateAuthority(authorityString, azureCloudOptions) {
        let authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== (0, $ff3347e9d8dd5c27$export$4cda21933050d9ec).None) {
            const tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : (0, $e6f7ad11e10d0573$export$a002182e51710d39).DEFAULT_COMMON_TENANT;
            authorityAzureCloudInstance = `${azureCloudOptions.azureCloudInstance}/${tenant}/`;
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    }
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */ static createCloudDiscoveryMetadataFromHost(host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [
                host
            ]
        };
    }
    /**
     * helper function to generate environment from authority object
     */ getPreferredCache() {
        if (this.managedIdentity) return (0, $e6f7ad11e10d0573$export$a002182e51710d39).DEFAULT_AUTHORITY_HOST;
        else if (this.discoveryComplete()) return this.metadata.preferred_cache;
        else throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3));
    }
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */ isAlias(host) {
        return this.metadata.aliases.indexOf(host) > -1;
    }
    /**
     * Returns whether or not the provided host is an alias of a known Microsoft authority for purposes of endpoint discovery
     * @param host
     */ isAliasOfKnownMicrosoftAuthority(host) {
        return (0, $0e21b55efe440ffb$export$7d026f079148cd31).has(host);
    }
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */ static isPublicCloudAuthority(host) {
        return (0, $e6f7ad11e10d0573$export$a002182e51710d39).KNOWN_PUBLIC_CLOUDS.indexOf(host) >= 0;
    }
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */ static buildRegionalAuthorityString(host, region, queryString) {
        // Create and validate a Url string object with the initial authority string
        const authorityUrlInstance = new (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2)(host);
        authorityUrlInstance.validateAsUri();
        const authorityUrlParts = authorityUrlInstance.getUrlComponents();
        let hostNameAndPort = `${region}.${authorityUrlParts.HostNameAndPort}`;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) hostNameAndPort = `${region}.${(0, $e6f7ad11e10d0573$export$a002182e51710d39).REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX}`;
        // Include the query string portion of the url
        const url = (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).constructAuthorityUriFromObject({
            ...authorityUrlInstance.getUrlComponents(),
            HostNameAndPort: hostNameAndPort
        }).urlString;
        // Add the query string if a query string was provided
        if (queryString) return `${url}?${queryString}`;
        return url;
    }
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */ static replaceWithRegionalInformation(metadata, azureRegion) {
        const regionalMetadata = {
            ...metadata
        };
        regionalMetadata.authorization_endpoint = $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.authorization_endpoint, azureRegion);
        regionalMetadata.token_endpoint = $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.token_endpoint, azureRegion);
        if (regionalMetadata.end_session_endpoint) regionalMetadata.end_session_endpoint = $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.end_session_endpoint, azureRegion);
        return regionalMetadata;
    }
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */ static transformCIAMAuthority(authority) {
        let ciamAuthority = authority;
        const authorityUrl = new (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2)(authority);
        const authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && authorityUrlComponents.HostNameAndPort.endsWith((0, $e6f7ad11e10d0573$export$a002182e51710d39).CIAM_AUTH_URL)) {
            const tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = `${ciamAuthority}${tenantIdOrDomain}${(0, $e6f7ad11e10d0573$export$a002182e51710d39).AAD_TENANT_DOMAIN_SUFFIX}`;
        }
        return ciamAuthority;
    }
}
// Reserved tenant domain names that will not be replaced with tenant id
$2d706f1a340b3c1d$export$f1c6ec2e6d68c49c.reservedTenantDomains = new Set([
    "{tenant}",
    "{tenantid}",
    (0, $e6f7ad11e10d0573$export$e18ac120172ed505).COMMON,
    (0, $e6f7ad11e10d0573$export$e18ac120172ed505).CONSUMERS,
    (0, $e6f7ad11e10d0573$export$e18ac120172ed505).ORGANIZATIONS
]);
/**
 * Extract tenantId from authority
 */ function $2d706f1a340b3c1d$export$6ed5af33d279fbc7(authority) {
    const authorityUrl = new (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2)(authority);
    const authorityUrlComponents = authorityUrl.getUrlComponents();
    /**
     * For credential matching purposes, tenantId is the last path segment of the authority URL:
     *  AAD Authority - domain/tenantId -> Credentials are cached with realm = tenantId
     *  B2C Authority - domain/{tenantId}?/.../policy -> Credentials are cached with realm = policy
     *  tenantId is downcased because B2C policies can have mixed case but tfp claim is downcased
     *
     * Note that we may not have any path segments in certain OIDC scenarios.
     */ const tenantId = authorityUrlComponents.PathSegments.slice(-1)[0]?.toLowerCase();
    switch(tenantId){
        case (0, $e6f7ad11e10d0573$export$e18ac120172ed505).COMMON:
        case (0, $e6f7ad11e10d0573$export$e18ac120172ed505).ORGANIZATIONS:
        case (0, $e6f7ad11e10d0573$export$e18ac120172ed505).CONSUMERS:
            return undefined;
        default:
            return tenantId;
    }
}
function $2d706f1a340b3c1d$export$4030f3538167cb9e(authorityUri) {
    return authorityUri.endsWith((0, $e6f7ad11e10d0573$export$a002182e51710d39).FORWARD_SLASH) ? authorityUri : `${authorityUri}${(0, $e6f7ad11e10d0573$export$a002182e51710d39).FORWARD_SLASH}`;
}
function $2d706f1a340b3c1d$export$2b9ebf6f25078cc0(authOptions) {
    const rawCloudDiscoveryMetadata = authOptions.cloudDiscoveryMetadata;
    let cloudDiscoveryMetadata = undefined;
    if (rawCloudDiscoveryMetadata) try {
        cloudDiscoveryMetadata = JSON.parse(rawCloudDiscoveryMetadata);
    } catch (e) {
        throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$92a2985751150ca5));
    }
    return {
        canonicalAuthority: authOptions.authority ? $2d706f1a340b3c1d$export$4030f3538167cb9e(authOptions.authority) : undefined,
        knownAuthorities: authOptions.knownAuthorities,
        cloudDiscoveryMetadata: cloudDiscoveryMetadata
    };
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $7b999f5c91b4e529$export$17b7b3ac1abef49f = {
    HOME_ACCOUNT_ID: "home_account_id",
    UPN: "UPN"
};

/*! @azure/msal-common v14.16.0 2024-11-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which provides helpers for OAuth 2.0 protocol specific values
 */ class $9523def209bc6e1a$export$871e33217042c65e {
    /**
     * Appends user state with random guid, or returns random guid.
     * @param userState
     * @param randomGuid
     */ static setRequestState(cryptoObj, userState, meta) {
        const libraryState = $9523def209bc6e1a$export$871e33217042c65e.generateLibraryState(cryptoObj, meta);
        return userState ? `${libraryState}${(0, $e6f7ad11e10d0573$export$a002182e51710d39).RESOURCE_DELIM}${userState}` : libraryState;
    }
    /**
     * Generates the state value used by the common library.
     * @param randomGuid
     * @param cryptoObj
     */ static generateLibraryState(cryptoObj, meta) {
        if (!cryptoObj) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$c39e501a22cba395));
        // Create a state object containing a unique id and the timestamp of the request creation
        const stateObj = {
            id: cryptoObj.createNewGuid()
        };
        if (meta) stateObj.meta = meta;
        const stateString = JSON.stringify(stateObj);
        return cryptoObj.base64Encode(stateString);
    }
    /**
     * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
     * @param state
     * @param cryptoObj
     */ static parseRequestState(cryptoObj, state) {
        if (!cryptoObj) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$c39e501a22cba395));
        if (!state) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$72a77317632c052b));
        try {
            // Split the state between library state and user passed state and decode them separately
            const splitState = state.split((0, $e6f7ad11e10d0573$export$a002182e51710d39).RESOURCE_DELIM);
            const libraryState = splitState[0];
            const userState = splitState.length > 1 ? splitState.slice(1).join((0, $e6f7ad11e10d0573$export$a002182e51710d39).RESOURCE_DELIM) : (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
            const libraryStateString = cryptoObj.base64Decode(libraryState);
            const libraryStateObj = JSON.parse(libraryStateString);
            return {
                userRequestState: userState || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
                libraryState: libraryStateObj
            };
        } catch (e) {
            throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$72a77317632c052b));
        }
    }
}




/*! @azure/msal-browser v3.27.0 2024-11-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $1779dfa0ed589c68$export$2baa60fa09b100be {
    constructor(cacheLocation){
        this.validateWindowStorage(cacheLocation);
        this.windowStorage = window[cacheLocation];
    }
    validateWindowStorage(cacheLocation) {
        if (cacheLocation !== (0, $e195f599725a9f25$export$573384e47a12d835).LocalStorage && cacheLocation !== (0, $e195f599725a9f25$export$573384e47a12d835).SessionStorage || !window[cacheLocation]) throw (0, $4688392e2970a328$export$176bd5050947ba0c)((0, $da4c47c78c7b210e$export$41d7a3d4e14d6113));
    }
    getItem(key) {
        return this.windowStorage.getItem(key);
    }
    setItem(key, value) {
        this.windowStorage.setItem(key, value);
    }
    removeItem(key) {
        this.windowStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(this.windowStorage);
    }
    containsKey(key) {
        return this.windowStorage.hasOwnProperty(key);
    }
}



/*! @azure/msal-browser v3.27.0 2024-11-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts the BrowserStateObject from the state string.
 * @param browserCrypto
 * @param state
 */ function $6dd4a8fd50fdac35$export$68ec87f530f5f536(browserCrypto, state) {
    if (!state) return null;
    try {
        const requestStateObj = (0, $9523def209bc6e1a$export$871e33217042c65e).parseRequestState(browserCrypto, state);
        return requestStateObj.libraryState.meta;
    } catch (e) {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$exports).invalidState);
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 * Cookies are only used if storeAuthStateInCookie is true, and are only used for
 * parameters such as state and nonce, generally.
 */ class $da45ac276c7992ff$export$44d7291b5c8cc149 extends (0, $4d3b9129094dcedd$export$996e3ea69314b5c6) {
    constructor(clientId, cacheConfig, cryptoImpl, logger, staticAuthorityOptions, performanceClient){
        super(clientId, cryptoImpl, logger, staticAuthorityOptions);
        // Cookie life calculation (hours * minutes * seconds * ms)
        this.COOKIE_LIFE_MULTIPLIER = 86400000;
        this.cacheConfig = cacheConfig;
        this.logger = logger;
        this.internalStorage = new (0, $5c8b15c6432b04fe$export$d7392285c701ecf5)();
        this.browserStorage = this.setupBrowserStorage(this.cacheConfig.cacheLocation);
        this.temporaryCacheStorage = this.setupTemporaryCacheStorage(this.cacheConfig.temporaryCacheLocation, this.cacheConfig.cacheLocation);
        // Migrate cache entries from older versions of MSAL.
        if (cacheConfig.cacheMigrationEnabled) {
            this.migrateCacheEntries();
            this.createKeyMaps();
        }
        this.performanceClient = performanceClient;
    }
    /**
     * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
     * @param cacheLocation
     */ setupBrowserStorage(cacheLocation) {
        switch(cacheLocation){
            case (0, $e195f599725a9f25$export$573384e47a12d835).LocalStorage:
            case (0, $e195f599725a9f25$export$573384e47a12d835).SessionStorage:
                try {
                    return new (0, $1779dfa0ed589c68$export$2baa60fa09b100be)(cacheLocation);
                } catch (e) {
                    this.logger.verbose(e);
                    break;
                }
        }
        this.cacheConfig.cacheLocation = (0, $e195f599725a9f25$export$573384e47a12d835).MemoryStorage;
        return new (0, $5c8b15c6432b04fe$export$d7392285c701ecf5)();
    }
    /**
     * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured temporaryCacheLocation.
     * @param temporaryCacheLocation
     * @param cacheLocation
     */ setupTemporaryCacheStorage(temporaryCacheLocation, cacheLocation) {
        switch(cacheLocation){
            case (0, $e195f599725a9f25$export$573384e47a12d835).LocalStorage:
            case (0, $e195f599725a9f25$export$573384e47a12d835).SessionStorage:
                try {
                    // Temporary cache items will always be stored in session storage to mitigate problems caused by multiple tabs
                    return new (0, $1779dfa0ed589c68$export$2baa60fa09b100be)(temporaryCacheLocation || (0, $e195f599725a9f25$export$573384e47a12d835).SessionStorage);
                } catch (e) {
                    this.logger.verbose(e);
                    return this.internalStorage;
                }
            case (0, $e195f599725a9f25$export$573384e47a12d835).MemoryStorage:
            default:
                return this.internalStorage;
        }
    }
    /**
     * Migrate all old cache entries to new schema. No rollback supported.
     * @param storeAuthStateInCookie
     */ migrateCacheEntries() {
        const idTokenKey = `${(0, $e6f7ad11e10d0573$export$a002182e51710d39).CACHE_PREFIX}.${(0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ID_TOKEN}`;
        const clientInfoKey = `${(0, $e6f7ad11e10d0573$export$a002182e51710d39).CACHE_PREFIX}.${(0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).CLIENT_INFO}`;
        const errorKey = `${(0, $e6f7ad11e10d0573$export$a002182e51710d39).CACHE_PREFIX}.${(0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ERROR}`;
        const errorDescKey = `${(0, $e6f7ad11e10d0573$export$a002182e51710d39).CACHE_PREFIX}.${(0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ERROR_DESC}`;
        const idTokenValue = this.browserStorage.getItem(idTokenKey);
        const clientInfoValue = this.browserStorage.getItem(clientInfoKey);
        const errorValue = this.browserStorage.getItem(errorKey);
        const errorDescValue = this.browserStorage.getItem(errorDescKey);
        const values = [
            idTokenValue,
            clientInfoValue,
            errorValue,
            errorDescValue
        ];
        const keysToMigrate = [
            (0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ID_TOKEN,
            (0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).CLIENT_INFO,
            (0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ERROR,
            (0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ERROR_DESC
        ];
        keysToMigrate.forEach((cacheKey, index)=>{
            const value = values[index];
            if (value) this.setTemporaryCache(cacheKey, value, true);
        });
    }
    /**
     * Searches all cache entries for MSAL accounts and creates the account key map
     * This is used to migrate users from older versions of MSAL which did not create the map.
     * @returns
     */ createKeyMaps() {
        this.logger.trace("BrowserCacheManager - createKeyMaps called.");
        const accountKeys = this.getItem((0, $e195f599725a9f25$export$f6ce23cce692699f).ACCOUNT_KEYS);
        const tokenKeys = this.getItem(`${(0, $e195f599725a9f25$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`);
        if (accountKeys && tokenKeys) {
            this.logger.verbose("BrowserCacheManager:createKeyMaps - account and token key maps already exist, skipping migration.");
            // Key maps already exist, no need to iterate through cache
            return;
        }
        const allKeys = this.browserStorage.getKeys();
        allKeys.forEach((key)=>{
            if (this.isCredentialKey(key)) {
                // Get item, parse, validate and write key to map
                const value = this.getItem(key);
                if (value) {
                    const credObj = this.validateAndParseJson(value);
                    if (credObj && credObj.hasOwnProperty("credentialType")) switch(credObj["credentialType"]){
                        case (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ID_TOKEN:
                            if ((0, $d6bc4864bb049bc4$exports).isIdTokenEntity(credObj)) {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - idToken found, saving key to token key map");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - idToken with key: ${key} found, saving key to token key map`);
                                const idTokenEntity = credObj;
                                const newKey = this.updateCredentialCacheKey(key, idTokenEntity);
                                this.addTokenKey(newKey, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ID_TOKEN);
                                return;
                            } else {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching idToken schema with value containing idToken credentialType field but value failed IdTokenEntity validation, skipping.");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - failed idToken validation on key: ${key}`);
                            }
                            break;
                        case (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                        case (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME:
                            if ((0, $d6bc4864bb049bc4$exports).isAccessTokenEntity(credObj)) {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - accessToken found, saving key to token key map");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - accessToken with key: ${key} found, saving key to token key map`);
                                const accessTokenEntity = credObj;
                                const newKey = this.updateCredentialCacheKey(key, accessTokenEntity);
                                this.addTokenKey(newKey, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN);
                                return;
                            } else {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching accessToken schema with value containing accessToken credentialType field but value failed AccessTokenEntity validation, skipping.");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - failed accessToken validation on key: ${key}`);
                            }
                            break;
                        case (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                            if ((0, $d6bc4864bb049bc4$exports).isRefreshTokenEntity(credObj)) {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - refreshToken found, saving key to token key map");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - refreshToken with key: ${key} found, saving key to token key map`);
                                const refreshTokenEntity = credObj;
                                const newKey = this.updateCredentialCacheKey(key, refreshTokenEntity);
                                this.addTokenKey(newKey, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN);
                                return;
                            } else {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching refreshToken schema with value containing refreshToken credentialType field but value failed RefreshTokenEntity validation, skipping.");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - failed refreshToken validation on key: ${key}`);
                            }
                            break;
                    }
                }
            }
            if (this.isAccountKey(key)) {
                const value = this.getItem(key);
                if (value) {
                    const accountObj = this.validateAndParseJson(value);
                    if (accountObj && (0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).isAccountEntity(accountObj)) {
                        this.logger.trace("BrowserCacheManager:createKeyMaps - account found, saving key to account key map");
                        this.logger.tracePii(`BrowserCacheManager:createKeyMaps - account with key: ${key} found, saving key to account key map`);
                        this.addAccountKeyToMap(key);
                    }
                }
            }
        });
    }
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */ validateAndParseJson(jsonValue) {
        try {
            const parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */ return parsedJson && typeof parsedJson === "object" ? parsedJson : null;
        } catch (error) {
            return null;
        }
    }
    /**
     * fetches the entry from the browser storage based off the key
     * @param key
     */ getItem(key) {
        return this.browserStorage.getItem(key);
    }
    /**
     * sets the entry in the browser storage
     * @param key
     * @param value
     */ setItem(key, value) {
        this.browserStorage.setItem(key, value);
    }
    /**
     * fetch the account entity from the platform cache
     * @param accountKey
     */ getAccount(accountKey, logger) {
        this.logger.trace("BrowserCacheManager.getAccount called");
        const accountEntity = this.getCachedAccountEntity(accountKey);
        return this.updateOutdatedCachedAccount(accountKey, accountEntity, logger);
    }
    /**
     * Reads account from cache, deserializes it into an account entity and returns it.
     * If account is not found from the key, returns null and removes key from map.
     * @param accountKey
     * @returns
     */ getCachedAccountEntity(accountKey) {
        const serializedAccount = this.getItem(accountKey);
        if (!serializedAccount) {
            this.removeAccountKeyFromMap(accountKey);
            return null;
        }
        const parsedAccount = this.validateAndParseJson(serializedAccount);
        if (!parsedAccount || !(0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).isAccountEntity(parsedAccount)) {
            this.removeAccountKeyFromMap(accountKey);
            return null;
        }
        return (0, $4d3b9129094dcedd$export$996e3ea69314b5c6).toObject(new (0, $cdcf39a9eb0ff797$export$680160523e6bfa6a)(), parsedAccount);
    }
    /**
     * set account entity in the platform cache
     * @param account
     */ setAccount(account) {
        this.logger.trace("BrowserCacheManager.setAccount called");
        const key = account.generateAccountKey();
        this.setItem(key, JSON.stringify(account));
        this.addAccountKeyToMap(key);
    }
    /**
     * Returns the array of account keys currently cached
     * @returns
     */ getAccountKeys() {
        this.logger.trace("BrowserCacheManager.getAccountKeys called");
        const accountKeys = this.getItem((0, $e195f599725a9f25$export$f6ce23cce692699f).ACCOUNT_KEYS);
        if (accountKeys) return JSON.parse(accountKeys);
        this.logger.verbose("BrowserCacheManager.getAccountKeys - No account keys found");
        return [];
    }
    /**
     * Add a new account to the key map
     * @param key
     */ addAccountKeyToMap(key) {
        this.logger.trace("BrowserCacheManager.addAccountKeyToMap called");
        this.logger.tracePii(`BrowserCacheManager.addAccountKeyToMap called with key: ${key}`);
        const accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.setItem((0, $e195f599725a9f25$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys));
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key added");
        } else this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key already exists in map");
    }
    /**
     * Remove an account from the key map
     * @param key
     */ removeAccountKeyFromMap(key) {
        this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap called");
        this.logger.tracePii(`BrowserCacheManager.removeAccountKeyFromMap called with key: ${key}`);
        const accountKeys = this.getAccountKeys();
        const removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            this.setItem((0, $e195f599725a9f25$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys));
            this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap account key removed");
        } else this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap key not found in existing map");
    }
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */ async removeAccount(key) {
        super.removeAccount(key);
        this.removeAccountKeyFromMap(key);
    }
    /**
     * Remove account entity from the platform cache if it's outdated
     * @param accountKey
     */ removeOutdatedAccount(accountKey) {
        this.removeItem(accountKey);
        this.removeAccountKeyFromMap(accountKey);
    }
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */ removeIdToken(key) {
        super.removeIdToken(key);
        this.removeTokenKey(key, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ID_TOKEN);
    }
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */ async removeAccessToken(key) {
        super.removeAccessToken(key);
        this.removeTokenKey(key, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN);
    }
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */ removeRefreshToken(key) {
        super.removeRefreshToken(key);
        this.removeTokenKey(key, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN);
    }
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */ getTokenKeys() {
        this.logger.trace("BrowserCacheManager.getTokenKeys called");
        const item = this.getItem(`${(0, $e195f599725a9f25$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`);
        if (item) {
            const tokenKeys = this.validateAndParseJson(item);
            if (tokenKeys && tokenKeys.hasOwnProperty("idToken") && tokenKeys.hasOwnProperty("accessToken") && tokenKeys.hasOwnProperty("refreshToken")) return tokenKeys;
            else this.logger.error("BrowserCacheManager.getTokenKeys - Token keys found but in an unknown format. Returning empty key map.");
        } else this.logger.verbose("BrowserCacheManager.getTokenKeys - No token keys found");
        return {
            idToken: [],
            accessToken: [],
            refreshToken: []
        };
    }
    /**
     * Adds the given key to the token key map
     * @param key
     * @param type
     */ addTokenKey(key, type) {
        this.logger.trace("BrowserCacheManager addTokenKey called");
        const tokenKeys = this.getTokenKeys();
        switch(type){
            case (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ID_TOKEN:
                if (tokenKeys.idToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - idToken added to map");
                    tokenKeys.idToken.push(key);
                }
                break;
            case (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                if (tokenKeys.accessToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - accessToken added to map");
                    tokenKeys.accessToken.push(key);
                }
                break;
            case (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                if (tokenKeys.refreshToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - refreshToken added to map");
                    tokenKeys.refreshToken.push(key);
                }
                break;
            default:
                this.logger.error(`BrowserCacheManager:addTokenKey - CredentialType provided invalid. CredentialType: ${type}`);
                throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$exports).unexpectedCredentialType);
        }
        this.setItem(`${(0, $e195f599725a9f25$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`, JSON.stringify(tokenKeys));
    }
    /**
     * Removes the given key from the token key map
     * @param key
     * @param type
     */ removeTokenKey(key, type) {
        this.logger.trace("BrowserCacheManager removeTokenKey called");
        const tokenKeys = this.getTokenKeys();
        switch(type){
            case (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ID_TOKEN:
                this.logger.infoPii(`BrowserCacheManager: removeTokenKey - attempting to remove idToken with key: ${key} from map`);
                const idRemoval = tokenKeys.idToken.indexOf(key);
                if (idRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - idToken removed from map");
                    tokenKeys.idToken.splice(idRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - idToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            case (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                this.logger.infoPii(`BrowserCacheManager: removeTokenKey - attempting to remove accessToken with key: ${key} from map`);
                const accessRemoval = tokenKeys.accessToken.indexOf(key);
                if (accessRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - accessToken removed from map");
                    tokenKeys.accessToken.splice(accessRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - accessToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            case (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                this.logger.infoPii(`BrowserCacheManager: removeTokenKey - attempting to remove refreshToken with key: ${key} from map`);
                const refreshRemoval = tokenKeys.refreshToken.indexOf(key);
                if (refreshRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken removed from map");
                    tokenKeys.refreshToken.splice(refreshRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            default:
                this.logger.error(`BrowserCacheManager:removeTokenKey - CredentialType provided invalid. CredentialType: ${type}`);
                throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$exports).unexpectedCredentialType);
        }
        this.setItem(`${(0, $e195f599725a9f25$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`, JSON.stringify(tokenKeys));
    }
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */ getIdTokenCredential(idTokenKey) {
        const value = this.getItem(idTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeTokenKey(idTokenKey, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ID_TOKEN);
            return null;
        }
        const parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !(0, $d6bc4864bb049bc4$exports).isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeTokenKey(idTokenKey, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ID_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getIdTokenCredential: cache hit");
        return parsedIdToken;
    }
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */ setIdTokenCredential(idToken) {
        this.logger.trace("BrowserCacheManager.setIdTokenCredential called");
        const idTokenKey = (0, $d6bc4864bb049bc4$exports).generateCredentialKey(idToken);
        this.setItem(idTokenKey, JSON.stringify(idToken));
        this.addTokenKey(idTokenKey, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ID_TOKEN);
    }
    /**
     * generates accessToken entity from a string
     * @param key
     */ getAccessTokenCredential(accessTokenKey) {
        const value = this.getItem(accessTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeTokenKey(accessTokenKey, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN);
            return null;
        }
        const parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !(0, $d6bc4864bb049bc4$exports).isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeTokenKey(accessTokenKey, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAccessTokenCredential: cache hit");
        return parsedAccessToken;
    }
    /**
     * set accessToken credential to the platform cache
     * @param accessToken
     */ setAccessTokenCredential(accessToken) {
        this.logger.trace("BrowserCacheManager.setAccessTokenCredential called");
        const accessTokenKey = (0, $d6bc4864bb049bc4$exports).generateCredentialKey(accessToken);
        this.setItem(accessTokenKey, JSON.stringify(accessToken));
        this.addTokenKey(accessTokenKey, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).ACCESS_TOKEN);
    }
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */ getRefreshTokenCredential(refreshTokenKey) {
        const value = this.getItem(refreshTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeTokenKey(refreshTokenKey, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN);
            return null;
        }
        const parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !(0, $d6bc4864bb049bc4$exports).isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeTokenKey(refreshTokenKey, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: cache hit");
        return parsedRefreshToken;
    }
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */ setRefreshTokenCredential(refreshToken) {
        this.logger.trace("BrowserCacheManager.setRefreshTokenCredential called");
        const refreshTokenKey = (0, $d6bc4864bb049bc4$exports).generateCredentialKey(refreshToken);
        this.setItem(refreshTokenKey, JSON.stringify(refreshToken));
        this.addTokenKey(refreshTokenKey, (0, $e6f7ad11e10d0573$export$eca2dc7e6e608a68).REFRESH_TOKEN);
    }
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     */ getAppMetadata(appMetadataKey) {
        const value = this.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !(0, $d6bc4864bb049bc4$exports).isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAppMetadata: cache hit");
        return parsedMetadata;
    }
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     */ setAppMetadata(appMetadata) {
        this.logger.trace("BrowserCacheManager.setAppMetadata called");
        const appMetadataKey = (0, $d6bc4864bb049bc4$exports).generateAppMetadataKey(appMetadata);
        this.setItem(appMetadataKey, JSON.stringify(appMetadata));
    }
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     */ getServerTelemetry(serverTelemetryKey) {
        const value = this.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        const parsedEntity = this.validateAndParseJson(value);
        if (!parsedEntity || !(0, $d6bc4864bb049bc4$exports).isServerTelemetryEntity(serverTelemetryKey, parsedEntity)) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getServerTelemetry: cache hit");
        return parsedEntity;
    }
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */ setServerTelemetry(serverTelemetryKey, serverTelemetry) {
        this.logger.trace("BrowserCacheManager.setServerTelemetry called");
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry));
    }
    /**
     *
     */ getAuthorityMetadata(key) {
        const value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: called, no cache hit");
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && (0, $d6bc4864bb049bc4$exports).isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: cache hit");
            return parsedMetadata;
        }
        return null;
    }
    /**
     *
     */ getAuthorityMetadataKeys() {
        const allKeys = this.internalStorage.getKeys();
        return allKeys.filter((key)=>{
            return this.isAuthorityMetadata(key);
        });
    }
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */ setWrapperMetadata(wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem((0, $e195f599725a9f25$export$8f546f90896bcfa9).WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem((0, $e195f599725a9f25$export$8f546f90896bcfa9).WRAPPER_VER, wrapperVersion);
    }
    /**
     * Returns wrapper metadata from in-memory storage
     */ getWrapperMetadata() {
        const sku = this.internalStorage.getItem((0, $e195f599725a9f25$export$8f546f90896bcfa9).WRAPPER_SKU) || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        const version = this.internalStorage.getItem((0, $e195f599725a9f25$export$8f546f90896bcfa9).WRAPPER_VER) || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        return [
            sku,
            version
        ];
    }
    /**
     *
     * @param entity
     */ setAuthorityMetadata(key, entity) {
        this.logger.trace("BrowserCacheManager.setAuthorityMetadata called");
        this.internalStorage.setItem(key, JSON.stringify(entity));
    }
    /**
     * Gets the active account
     */ getActiveAccount() {
        const activeAccountKeyFilters = this.generateCacheKey((0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        const activeAccountValueFilters = this.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            // if new active account cache type isn't found, it's an old version, so look for that instead
            this.logger.trace("BrowserCacheManager.getActiveAccount: No active account filters cache schema found, looking for legacy schema");
            const activeAccountKeyLocal = this.generateCacheKey((0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT);
            const activeAccountValueLocal = this.getItem(activeAccountKeyLocal);
            if (!activeAccountValueLocal) {
                this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
                return null;
            }
            const activeAccount = this.getAccountInfoFilteredBy({
                localAccountId: activeAccountValueLocal
            });
            if (activeAccount) {
                this.logger.trace("BrowserCacheManager.getActiveAccount: Legacy active account cache schema found");
                this.logger.trace("BrowserCacheManager.getActiveAccount: Adding active account filters cache schema");
                this.setActiveAccount(activeAccount);
                return activeAccount;
            }
            return null;
        }
        const activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("BrowserCacheManager.getActiveAccount: Active account filters schema found");
            return this.getAccountInfoFilteredBy({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId,
                tenantId: activeAccountValueObj.tenantId
            });
        }
        this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
        return null;
    }
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */ setActiveAccount(account) {
        const activeAccountKey = this.generateCacheKey((0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        const activeAccountKeyLocal = this.generateCacheKey((0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT);
        if (account) {
            this.logger.verbose("setActiveAccount: Active account set");
            const activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId,
                tenantId: account.tenantId
            };
            this.browserStorage.setItem(activeAccountKey, JSON.stringify(activeAccountValue));
            this.browserStorage.setItem(activeAccountKeyLocal, account.localAccountId);
        } else {
            this.logger.verbose("setActiveAccount: No account passed, active account not set");
            this.browserStorage.removeItem(activeAccountKey);
            this.browserStorage.removeItem(activeAccountKeyLocal);
        }
    }
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     */ getThrottlingCache(throttlingCacheKey) {
        const value = this.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        const parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !(0, $d6bc4864bb049bc4$exports).isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getThrottlingCache: cache hit");
        return parsedThrottlingCache;
    }
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */ setThrottlingCache(throttlingCacheKey, throttlingCache) {
        this.logger.trace("BrowserCacheManager.setThrottlingCache called");
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache));
    }
    /**
     * Gets cache item with given key.
     * Will retrieve from cookies if storeAuthStateInCookie is set to true.
     * @param key
     */ getTemporaryCache(cacheKey, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        if (this.cacheConfig.storeAuthStateInCookie) {
            const itemCookie = this.getItemCookie(key);
            if (itemCookie) {
                this.logger.trace("BrowserCacheManager.getTemporaryCache: storeAuthStateInCookies set to true, retrieving from cookies");
                return itemCookie;
            }
        }
        const value = this.temporaryCacheStorage.getItem(key);
        if (!value) {
            // If temp cache item not found in session/memory, check local storage for items set by old versions
            if (this.cacheConfig.cacheLocation === (0, $e195f599725a9f25$export$573384e47a12d835).LocalStorage) {
                const item = this.browserStorage.getItem(key);
                if (item) {
                    this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item found in local storage");
                    return item;
                }
            }
            this.logger.trace("BrowserCacheManager.getTemporaryCache: No cache item found in local storage");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item returned");
        return value;
    }
    /**
     * Sets the cache item with the key and value given.
     * Stores in cookie if storeAuthStateInCookie is set to true.
     * This can cause cookie overflow if used incorrectly.
     * @param key
     * @param value
     */ setTemporaryCache(cacheKey, value, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.setTemporaryCache: storeAuthStateInCookie set to true, setting item cookie");
            this.setItemCookie(key, value);
        }
    }
    /**
     * Removes the cache item with the given key.
     * @param key
     */ removeItem(key) {
        this.browserStorage.removeItem(key);
    }
    /**
     * Removes the temporary cache item with the given key.
     * Will also clear the cookie item if storeAuthStateInCookie is set to true.
     * @param key
     */ removeTemporaryItem(key) {
        this.temporaryCacheStorage.removeItem(key);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.removeItem: storeAuthStateInCookie is true, clearing item cookie");
            this.clearItemCookie(key);
        }
    }
    /**
     * Gets all keys in window.
     */ getKeys() {
        return this.browserStorage.getKeys();
    }
    /**
     * Clears all cache entries created by MSAL.
     */ async clear() {
        // Removes all accounts and their credentials
        await this.removeAllAccounts();
        this.removeAppMetadata();
        // Remove temp storage first to make sure any cookies are cleared
        this.temporaryCacheStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $e6f7ad11e10d0573$export$a002182e51710d39).CACHE_PREFIX) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.removeTemporaryItem(cacheKey);
        });
        // Removes all remaining MSAL cache items
        this.browserStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $e6f7ad11e10d0573$export$a002182e51710d39).CACHE_PREFIX) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.browserStorage.removeItem(cacheKey);
        });
        this.internalStorage.clear();
    }
    /**
     * Clears all access tokes that have claims prior to saving the current one
     * @param performanceClient {IPerformanceClient}
     * @param correlationId {string} correlation id
     * @returns
     */ async clearTokensAndKeysWithClaims(performanceClient, correlationId) {
        performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims, correlationId);
        const tokenKeys = this.getTokenKeys();
        const removedAccessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            // if the access token has claims in its key, remove the token key and the token
            const credential = this.getAccessTokenCredential(key);
            if (credential?.requestedClaimsHash && key.includes(credential.requestedClaimsHash.toLowerCase())) removedAccessTokens.push(this.removeAccessToken(key));
        });
        await Promise.all(removedAccessTokens);
        // warn if any access tokens are removed
        if (removedAccessTokens.length > 0) this.logger.warning(`${removedAccessTokens.length} access tokens with claims in the cache keys have been removed from the cache.`);
    }
    /**
     * Add value to cookies
     * @param cookieName
     * @param cookieValue
     * @param expires
     * @deprecated
     */ setItemCookie(cookieName, cookieValue, expires) {
        let cookieStr = `${encodeURIComponent(cookieName)}=${encodeURIComponent(cookieValue)};path=/;SameSite=Lax;`;
        if (expires) {
            const expireTime = this.getCookieExpirationTime(expires);
            cookieStr += `expires=${expireTime};`;
        }
        if (this.cacheConfig.secureCookies) cookieStr += "Secure;";
        document.cookie = cookieStr;
    }
    /**
     * Get one item by key from cookies
     * @param cookieName
     * @deprecated
     */ getItemCookie(cookieName) {
        const name = `${encodeURIComponent(cookieName)}=`;
        const cookieList = document.cookie.split(";");
        for(let i = 0; i < cookieList.length; i++){
            let cookie = cookieList[i];
            while(cookie.charAt(0) === " ")cookie = cookie.substring(1);
            if (cookie.indexOf(name) === 0) return decodeURIComponent(cookie.substring(name.length, cookie.length));
        }
        return (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
    }
    /**
     * Clear all msal-related cookies currently set in the browser. Should only be used to clear temporary cache items.
     * @deprecated
     */ clearMsalCookies() {
        const cookiePrefix = `${(0, $e6f7ad11e10d0573$export$a002182e51710d39).CACHE_PREFIX}.${this.clientId}`;
        const cookieList = document.cookie.split(";");
        cookieList.forEach((cookie)=>{
            while(cookie.charAt(0) === " ")// eslint-disable-next-line no-param-reassign
            cookie = cookie.substring(1);
            if (cookie.indexOf(cookiePrefix) === 0) {
                const cookieKey = cookie.split("=")[0];
                this.clearItemCookie(cookieKey);
            }
        });
    }
    /**
     * Clear an item in the cookies by key
     * @param cookieName
     * @deprecated
     */ clearItemCookie(cookieName) {
        this.setItemCookie(cookieName, (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING, -1);
    }
    /**
     * Get cookie expiration time
     * @param cookieLifeDays
     * @deprecated
     */ getCookieExpirationTime(cookieLifeDays) {
        const today = new Date();
        const expr = new Date(today.getTime() + cookieLifeDays * this.COOKIE_LIFE_MULTIPLIER);
        return expr.toUTCString();
    }
    /**
     * Prepend msal.<client-id> to each key; Skip for any JSON object as Key (defined schemas do not need the key appended: AccessToken Keys or the upcoming schema)
     * @param key
     * @param addInstanceId
     */ generateCacheKey(key) {
        const generatedKey = this.validateAndParseJson(key);
        if (!generatedKey) {
            if ((0, $2b520034dd7719a3$export$ecc754f99843e759).startsWith(key, (0, $e6f7ad11e10d0573$export$a002182e51710d39).CACHE_PREFIX) || (0, $2b520034dd7719a3$export$ecc754f99843e759).startsWith(key, (0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ADAL_ID_TOKEN)) return key;
            return `${(0, $e6f7ad11e10d0573$export$a002182e51710d39).CACHE_PREFIX}.${this.clientId}.${key}`;
        }
        return JSON.stringify(key);
    }
    /**
     * Create authorityKey to cache authority
     * @param state
     */ generateAuthorityKey(stateString) {
        const { libraryState: { id: stateId } } = (0, $9523def209bc6e1a$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString);
        return this.generateCacheKey(`${(0, $e195f599725a9f25$export$21d55bedf0d269fb).AUTHORITY}.${stateId}`);
    }
    /**
     * Create Nonce key to cache nonce
     * @param state
     */ generateNonceKey(stateString) {
        const { libraryState: { id: stateId } } = (0, $9523def209bc6e1a$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString);
        return this.generateCacheKey(`${(0, $e195f599725a9f25$export$21d55bedf0d269fb).NONCE_IDTOKEN}.${stateId}`);
    }
    /**
     * Creates full cache key for the request state
     * @param stateString State string for the request
     */ generateStateKey(stateString) {
        // Use the library state id to key temp storage for uniqueness for multiple concurrent requests
        const { libraryState: { id: stateId } } = (0, $9523def209bc6e1a$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString);
        return this.generateCacheKey(`${(0, $e195f599725a9f25$export$21d55bedf0d269fb).REQUEST_STATE}.${stateId}`);
    }
    /**
     * Gets the cached authority based on the cached state. Returns empty if no cached state found.
     */ getCachedAuthority(cachedState) {
        const stateCacheKey = this.generateStateKey(cachedState);
        const state = this.getTemporaryCache(stateCacheKey);
        if (!state) return null;
        const authorityCacheKey = this.generateAuthorityKey(state);
        return this.getTemporaryCache(authorityCacheKey);
    }
    /**
     * Updates account, authority, and state in cache
     * @param serverAuthenticationRequest
     * @param account
     */ updateCacheEntries(state, nonce, authorityInstance, loginHint, account) {
        this.logger.trace("BrowserCacheManager.updateCacheEntries called");
        // Cache the request state
        const stateCacheKey = this.generateStateKey(state);
        this.setTemporaryCache(stateCacheKey, state, false);
        // Cache the nonce
        const nonceCacheKey = this.generateNonceKey(state);
        this.setTemporaryCache(nonceCacheKey, nonce, false);
        // Cache authorityKey
        const authorityCacheKey = this.generateAuthorityKey(state);
        this.setTemporaryCache(authorityCacheKey, authorityInstance, false);
        if (account) {
            const ccsCredential = {
                credential: account.homeAccountId,
                type: (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
            this.setTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        } else if (loginHint) {
            const ccsCredential = {
                credential: loginHint,
                type: (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).UPN
            };
            this.setTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        }
    }
    /**
     * Reset all temporary cache items
     * @param state
     */ resetRequestCache(state) {
        this.logger.trace("BrowserCacheManager.resetRequestCache called");
        // check state and remove associated cache items
        if (state) {
            this.temporaryCacheStorage.getKeys().forEach((key)=>{
                if (key.indexOf(state) !== -1) this.removeTemporaryItem(key);
            });
            // delete generic interactive request parameters
            this.removeTemporaryItem(this.generateStateKey(state));
            this.removeTemporaryItem(this.generateNonceKey(state));
            this.removeTemporaryItem(this.generateAuthorityKey(state));
        }
        this.removeTemporaryItem(this.generateCacheKey((0, $e195f599725a9f25$export$21d55bedf0d269fb).REQUEST_PARAMS));
        this.removeTemporaryItem(this.generateCacheKey((0, $e195f599725a9f25$export$21d55bedf0d269fb).ORIGIN_URI));
        this.removeTemporaryItem(this.generateCacheKey((0, $e195f599725a9f25$export$21d55bedf0d269fb).URL_HASH));
        this.removeTemporaryItem(this.generateCacheKey((0, $e195f599725a9f25$export$21d55bedf0d269fb).CORRELATION_ID));
        this.removeTemporaryItem(this.generateCacheKey((0, $e195f599725a9f25$export$21d55bedf0d269fb).CCS_CREDENTIAL));
        this.removeTemporaryItem(this.generateCacheKey((0, $e195f599725a9f25$export$21d55bedf0d269fb).NATIVE_REQUEST));
        this.setInteractionInProgress(false);
    }
    /**
     * Removes temporary cache for the provided state
     * @param stateString
     */ cleanRequestByState(stateString) {
        this.logger.trace("BrowserCacheManager.cleanRequestByState called");
        // Interaction is completed - remove interaction status.
        if (stateString) {
            const stateKey = this.generateStateKey(stateString);
            const cachedState = this.temporaryCacheStorage.getItem(stateKey);
            this.logger.infoPii(`BrowserCacheManager.cleanRequestByState: Removing temporary cache items for state: ${cachedState}`);
            this.resetRequestCache(cachedState || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING);
        }
        this.clearMsalCookies();
    }
    /**
     * Looks in temporary cache for any state values with the provided interactionType and removes all temporary cache items for that state
     * Used in scenarios where temp cache needs to be cleaned but state is not known, such as clicking browser back button.
     * @param interactionType
     */ cleanRequestByInteractionType(interactionType) {
        this.logger.trace("BrowserCacheManager.cleanRequestByInteractionType called");
        // Loop through all keys to find state key
        this.temporaryCacheStorage.getKeys().forEach((key)=>{
            // If this key is not the state key, move on
            if (key.indexOf((0, $e195f599725a9f25$export$21d55bedf0d269fb).REQUEST_STATE) === -1) return;
            // Retrieve state value, return if not a valid value
            const stateValue = this.temporaryCacheStorage.getItem(key);
            if (!stateValue) return;
            // Extract state and ensure it matches given InteractionType, then clean request cache
            const parsedState = (0, $6dd4a8fd50fdac35$export$68ec87f530f5f536)(this.cryptoImpl, stateValue);
            if (parsedState && parsedState.interactionType === interactionType) {
                this.logger.infoPii(`BrowserCacheManager.cleanRequestByInteractionType: Removing temporary cache items for state: ${stateValue}`);
                this.resetRequestCache(stateValue);
            }
        });
        this.clearMsalCookies();
        this.setInteractionInProgress(false);
    }
    cacheCodeRequest(authCodeRequest) {
        this.logger.trace("BrowserCacheManager.cacheCodeRequest called");
        const encodedValue = (0, $be65c31a50210a3d$export$e510a73ee562749)(JSON.stringify(authCodeRequest));
        this.setTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).REQUEST_PARAMS, encodedValue, true);
    }
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     */ getCachedRequest(state) {
        this.logger.trace("BrowserCacheManager.getCachedRequest called");
        // Get token request from cache and parse as TokenExchangeParameters.
        const encodedTokenRequest = this.getTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).REQUEST_PARAMS, true);
        if (!encodedTokenRequest) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$8b51939fb2aab3d7));
        let parsedRequest;
        try {
            parsedRequest = JSON.parse((0, $bb6fd55178ea2979$export$c62426fdd000a97e)(encodedTokenRequest));
        } catch (e) {
            this.logger.errorPii(`Attempted to parse: ${encodedTokenRequest}`);
            this.logger.error(`Parsing cached token request threw with error: ${e}`);
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$f3ae24cdfaab4488));
        }
        this.removeTemporaryItem(this.generateCacheKey((0, $e195f599725a9f25$export$21d55bedf0d269fb).REQUEST_PARAMS));
        // Get cached authority and use if no authority is cached with request.
        if (!parsedRequest.authority) {
            const authorityCacheKey = this.generateAuthorityKey(state);
            const cachedAuthority = this.getTemporaryCache(authorityCacheKey);
            if (!cachedAuthority) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$3a2c83e7753553b));
            parsedRequest.authority = cachedAuthority;
        }
        return parsedRequest;
    }
    /**
     * Gets cached native request for redirect flows
     */ getCachedNativeRequest() {
        this.logger.trace("BrowserCacheManager.getCachedNativeRequest called");
        const cachedRequest = this.getTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).NATIVE_REQUEST, true);
        if (!cachedRequest) {
            this.logger.trace("BrowserCacheManager.getCachedNativeRequest: No cached native request found");
            return null;
        }
        const parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("BrowserCacheManager.getCachedNativeRequest: Unable to parse native request");
            return null;
        }
        return parsedRequest;
    }
    isInteractionInProgress(matchClientId) {
        const clientId = this.getInteractionInProgress();
        if (matchClientId) return clientId === this.clientId;
        else return !!clientId;
    }
    getInteractionInProgress() {
        const key = `${(0, $e6f7ad11e10d0573$export$a002182e51710d39).CACHE_PREFIX}.${(0, $e195f599725a9f25$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        return this.getTemporaryCache(key, false);
    }
    setInteractionInProgress(inProgress) {
        // Ensure we don't overwrite interaction in progress for a different clientId
        const key = `${(0, $e6f7ad11e10d0573$export$a002182e51710d39).CACHE_PREFIX}.${(0, $e195f599725a9f25$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        if (inProgress) {
            if (this.getInteractionInProgress()) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$2700dc1c133d227e));
            else // No interaction is in progress
            this.setTemporaryCache(key, this.clientId, false);
        } else if (!inProgress && this.getInteractionInProgress() === this.clientId) this.removeTemporaryItem(key);
    }
    /**
     * Returns username retrieved from ADAL or MSAL v1 idToken
     * @deprecated
     */ getLegacyLoginHint() {
        // Only check for adal/msal token if no SSO params are being used
        const adalIdTokenString = this.getTemporaryCache((0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ADAL_ID_TOKEN);
        if (adalIdTokenString) {
            this.browserStorage.removeItem((0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ADAL_ID_TOKEN);
            this.logger.verbose("Cached ADAL id token retrieved.");
        }
        // Check for cached MSAL v1 id token
        const msalIdTokenString = this.getTemporaryCache((0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ID_TOKEN, true);
        if (msalIdTokenString) {
            this.browserStorage.removeItem(this.generateCacheKey((0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ID_TOKEN));
            this.logger.verbose("Cached MSAL.js v1 id token retrieved");
        }
        const cachedIdTokenString = msalIdTokenString || adalIdTokenString;
        if (cachedIdTokenString) {
            const idTokenClaims = (0, $dbb12b3851d257af$exports).extractTokenClaims(cachedIdTokenString, (0, $bb6fd55178ea2979$export$c62426fdd000a97e));
            if (idTokenClaims.preferred_username) {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 preferred_username as loginHint");
                return idTokenClaims.preferred_username;
            } else if (idTokenClaims.upn) {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 upn as loginHint");
                return idTokenClaims.upn;
            } else this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, however, no account hint claim found. Enable preferred_username or upn id token claim to get SSO.");
        }
        return null;
    }
    /**
     * Updates a credential's cache key if the current cache key is outdated
     */ updateCredentialCacheKey(currentCacheKey, credential) {
        const updatedCacheKey = (0, $d6bc4864bb049bc4$exports).generateCredentialKey(credential);
        if (currentCacheKey !== updatedCacheKey) {
            const cacheItem = this.getItem(currentCacheKey);
            if (cacheItem) {
                this.browserStorage.removeItem(currentCacheKey);
                this.setItem(updatedCacheKey, cacheItem);
                this.logger.verbose(`Updated an outdated ${credential.credentialType} cache key`);
                return updatedCacheKey;
            } else this.logger.error(`Attempted to update an outdated ${credential.credentialType} cache key but no item matching the outdated key was found in storage`);
        }
        return currentCacheKey;
    }
    /**
     * Builds credential entities from AuthenticationResult object and saves the resulting credentials to the cache
     * @param result
     * @param request
     */ async hydrateCache(result, request) {
        const idTokenEntity = (0, $d6bc4864bb049bc4$exports).createIdTokenEntity(result.account?.homeAccountId, result.account?.environment, result.idToken, this.clientId, result.tenantId);
        let claimsHash;
        if (request.claims) claimsHash = await this.cryptoImpl.hashString(request.claims);
        /**
         * meta data for cache stores time in seconds from epoch
         * AuthenticationResult returns expiresOn and extExpiresOn in milliseconds (as a Date object which is in ms)
         * We need to map these for the cache when building tokens from AuthenticationResult
         *
         * The next MSAL VFuture should map these both to same value if possible
         */ const accessTokenEntity = (0, $d6bc4864bb049bc4$exports).createAccessTokenEntity(result.account?.homeAccountId, result.account.environment, result.accessToken, this.clientId, result.tenantId, result.scopes.join(" "), result.expiresOn ? result.expiresOn.getTime() / 1000 : 0, result.extExpiresOn ? result.extExpiresOn.getTime() / 1000 : 0, (0, $bb6fd55178ea2979$export$c62426fdd000a97e), undefined, result.tokenType, undefined, request.sshKid, request.claims, claimsHash);
        const cacheRecord = {
            idToken: idTokenEntity,
            accessToken: accessTokenEntity
        };
        return this.saveCacheRecord(cacheRecord);
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, storeInCache, correlationId) {
        try {
            await super.saveCacheRecord(cacheRecord, storeInCache, correlationId);
        } catch (e) {
            if (e instanceof (0, $c58e2101f5d58d45$export$78ff06e91c3de382) && this.performanceClient && correlationId) try {
                const tokenKeys = this.getTokenKeys();
                this.performanceClient.addFields({
                    cacheRtCount: tokenKeys.refreshToken.length,
                    cacheIdCount: tokenKeys.idToken.length,
                    cacheAtCount: tokenKeys.accessToken.length
                }, correlationId);
            } catch (e) {}
            throw e;
        }
    }
}
const $da45ac276c7992ff$export$8e2d54002f8f6e5d = (clientId, logger)=>{
    const cacheOptions = {
        cacheLocation: (0, $e195f599725a9f25$export$573384e47a12d835).MemoryStorage,
        temporaryCacheLocation: (0, $e195f599725a9f25$export$573384e47a12d835).MemoryStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        cacheMigrationEnabled: false,
        claimsBasedCachingEnabled: false
    };
    return new $da45ac276c7992ff$export$44d7291b5c8cc149(clientId, cacheOptions, (0, $90930effaee4b5bc$export$865f57d401606752), logger);
};


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
 * @param accountFilter - (Optional) filter to narrow down the accounts returned
 * @returns Array of AccountInfo objects in cache
 */ function $4c2e647a07f06969$export$a4fc43c2a99143cd(logger, browserStorage, isInBrowser, accountFilter) {
    logger.verbose("getAllAccounts called");
    return isInBrowser ? browserStorage.getAllAccounts(accountFilter) : [];
}
/**
 * Returns the first account found in the cache that matches the account filter passed in.
 * @param accountFilter
 * @returns The first account found in the cache matching the provided filter or null if no account could be found.
 */ function $4c2e647a07f06969$export$4f9234baf34abd0(accountFilter, logger, browserStorage) {
    logger.trace("getAccount called");
    if (Object.keys(accountFilter).length === 0) {
        logger.warning("getAccount: No accountFilter provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy(accountFilter);
    if (account) {
        logger.verbose("getAccount: Account matching provided filter found, returning");
        return account;
    } else {
        logger.verbose("getAccount: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching username.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found.
 * This API is provided for convenience but getAccountById should be used for best reliability
 * @param username
 * @returns The account object stored in MSAL
 */ function $4c2e647a07f06969$export$d915baf55d86927d(username, logger, browserStorage) {
    logger.trace("getAccountByUsername called");
    if (!username) {
        logger.warning("getAccountByUsername: No username provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        username: username
    });
    if (account) {
        logger.verbose("getAccountByUsername: Account matching username found, returning");
        logger.verbosePii(`getAccountByUsername: Returning signed-in accounts matching username: ${username}`);
        return account;
    } else {
        logger.verbose("getAccountByUsername: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching homeAccountId.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found
 * @param homeAccountId
 * @returns The account object stored in MSAL
 */ function $4c2e647a07f06969$export$d6fa7d1e8099998e(homeAccountId, logger, browserStorage) {
    logger.trace("getAccountByHomeId called");
    if (!homeAccountId) {
        logger.warning("getAccountByHomeId: No homeAccountId provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        homeAccountId: homeAccountId
    });
    if (account) {
        logger.verbose("getAccountByHomeId: Account matching homeAccountId found, returning");
        logger.verbosePii(`getAccountByHomeId: Returning signed-in accounts matching homeAccountId: ${homeAccountId}`);
        return account;
    } else {
        logger.verbose("getAccountByHomeId: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching localAccountId.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found
 * @param localAccountId
 * @returns The account object stored in MSAL
 */ function $4c2e647a07f06969$export$7ac8aa09fdf78340(localAccountId, logger, browserStorage) {
    logger.trace("getAccountByLocalId called");
    if (!localAccountId) {
        logger.warning("getAccountByLocalId: No localAccountId provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        localAccountId: localAccountId
    });
    if (account) {
        logger.verbose("getAccountByLocalId: Account matching localAccountId found, returning");
        logger.verbosePii(`getAccountByLocalId: Returning signed-in accounts matching localAccountId: ${localAccountId}`);
        return account;
    } else {
        logger.verbose("getAccountByLocalId: No matching account found, returning null");
        return null;
    }
}
/**
 * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
 * @param account
 */ function $4c2e647a07f06969$export$c55c3d25cf1bcd99(account, browserStorage) {
    browserStorage.setActiveAccount(account);
}
/**
 * Gets the currently active account
 */ function $4c2e647a07f06969$export$13dd2e33a23839ad(browserStorage) {
    return browserStorage.getActiveAccount();
}





/*! @azure/msal-browser v3.27.0 2024-11-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $6e3e6e48bbae04d4$export$ce0ba2422a1c7815 {
    constructor(logger){
        this.eventCallbacks = new Map();
        this.logger = logger || new (0, $bf1c529f0722dfeb$export$efa9a398d6368992)({});
    }
    /**
     * Adds event callbacks to array
     * @param callback - callback to be invoked when an event is raised
     * @param eventTypes - list of events that this callback will be invoked for, if not provided callback will be invoked for all events
     * @param callbackId - Identifier for the callback, used to locate and remove the callback when no longer required
     */ addEventCallback(callback, eventTypes, callbackId) {
        if (typeof window !== "undefined") {
            const id = callbackId || (0, $d618406b813d26cc$export$7571c350ed9fec74)();
            if (this.eventCallbacks.has(id)) {
                this.logger.error(`Event callback with id: ${id} is already registered. Please provide a unique id or remove the existing callback and try again.`);
                return null;
            }
            this.eventCallbacks.set(id, [
                callback,
                eventTypes || []
            ]);
            this.logger.verbose(`Event callback registered with id: ${id}`);
            return id;
        }
        return null;
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose(`Event callback ${callbackId} removed.`);
    }
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */ emitEvent(eventType, interactionType, payload, error) {
        if (typeof window !== "undefined") {
            const message = {
                eventType: eventType,
                interactionType: interactionType || null,
                payload: payload || null,
                error: error || null,
                timestamp: Date.now()
            };
            this.eventCallbacks.forEach(([callback, eventTypes], callbackId)=>{
                if (eventTypes.length === 0 || eventTypes.includes(eventType)) {
                    this.logger.verbose(`Emitting event to callback ${callbackId}: ${eventType}`);
                    callback.apply(null, [
                        message
                    ]);
                }
            });
        }
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 
/*! @azure/msal-common v14.16.0 2024-11-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */ class $0463942371f4715f$export$ea52035eac03daf0 extends (0, $40da14d5d49dd285$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage, subError, errorNo, status){
        super(errorCode, errorMessage, subError);
        this.name = "ServerError";
        this.errorNo = errorNo;
        this.status = status;
        Object.setPrototypeOf(this, $0463942371f4715f$export$ea52035eac03daf0.prototype);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $8868e8edc76d69b4$export$c060a619741dd765 {
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */ static generateThrottlingStorageKey(thumbprint) {
        return `${(0, $e6f7ad11e10d0573$export$a2330d6808e6d893).THROTTLING_PREFIX}.${JSON.stringify(thumbprint)}`;
    }
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */ static preProcess(cacheManager, thumbprint) {
        const key = $8868e8edc76d69b4$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint);
        const value = cacheManager.getThrottlingCache(key);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key);
                return;
            }
            throw new (0, $0463942371f4715f$export$ea52035eac03daf0)(value.errorCodes?.join(" ") || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING, value.errorMessage, value.subError);
        }
    }
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */ static postProcess(cacheManager, thumbprint, response) {
        if ($8868e8edc76d69b4$export$c060a619741dd765.checkResponseStatus(response) || $8868e8edc76d69b4$export$c060a619741dd765.checkResponseForRetryAfter(response)) {
            const thumbprintValue = {
                throttleTime: $8868e8edc76d69b4$export$c060a619741dd765.calculateThrottleTime(parseInt(response.headers[(0, $e6f7ad11e10d0573$export$28d77f87efed1d88).RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache($8868e8edc76d69b4$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint), thumbprintValue);
        }
    }
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */ static checkResponseStatus(response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    }
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */ static checkResponseForRetryAfter(response) {
        if (response.headers) return response.headers.hasOwnProperty((0, $e6f7ad11e10d0573$export$28d77f87efed1d88).RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        return false;
    }
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */ static calculateThrottleTime(throttleTime) {
        const time = throttleTime <= 0 ? 0 : throttleTime;
        const currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || (0, $e6f7ad11e10d0573$export$a2330d6808e6d893).DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + (0, $e6f7ad11e10d0573$export$a2330d6808e6d893).DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
    }
    static removeThrottle(cacheManager, clientId, request, homeAccountIdentifier) {
        const thumbprint = {
            clientId: clientId,
            authority: request.authority,
            scopes: request.scopes,
            homeAccountIdentifier: homeAccountIdentifier,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid
        };
        const key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key);
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 





/*! @azure/msal-common v14.16.0 2024-11-05 */ 
var $77544fccca6f740d$exports = {};

$parcel$export($77544fccca6f740d$exports, "CLIENT_ID", function () { return $77544fccca6f740d$export$c7b1b63f5b60f8e; });
$parcel$export($77544fccca6f740d$exports, "REDIRECT_URI", function () { return $77544fccca6f740d$export$89711068e98820c5; });
$parcel$export($77544fccca6f740d$exports, "RESPONSE_TYPE", function () { return $77544fccca6f740d$export$af70b7209f1c7f6e; });
$parcel$export($77544fccca6f740d$exports, "RESPONSE_MODE", function () { return $77544fccca6f740d$export$2ae8b352eb8edff7; });
$parcel$export($77544fccca6f740d$exports, "GRANT_TYPE", function () { return $77544fccca6f740d$export$47f09697d0642170; });
$parcel$export($77544fccca6f740d$exports, "CLAIMS", function () { return $77544fccca6f740d$export$c9b29cc9615296dd; });
$parcel$export($77544fccca6f740d$exports, "SCOPE", function () { return $77544fccca6f740d$export$1c5a554c78c0cd12; });
$parcel$export($77544fccca6f740d$exports, "ERROR", function () { return $77544fccca6f740d$export$103bedf43ba882db; });
$parcel$export($77544fccca6f740d$exports, "ERROR_DESCRIPTION", function () { return $77544fccca6f740d$export$a9d2d02ea6b73527; });
$parcel$export($77544fccca6f740d$exports, "ACCESS_TOKEN", function () { return $77544fccca6f740d$export$cdbdf26448f9da5b; });
$parcel$export($77544fccca6f740d$exports, "ID_TOKEN", function () { return $77544fccca6f740d$export$9e690c458f1b1eda; });
$parcel$export($77544fccca6f740d$exports, "REFRESH_TOKEN", function () { return $77544fccca6f740d$export$2a2261c5a58ac0; });
$parcel$export($77544fccca6f740d$exports, "EXPIRES_IN", function () { return $77544fccca6f740d$export$a9f2539254087dfb; });
$parcel$export($77544fccca6f740d$exports, "REFRESH_TOKEN_EXPIRES_IN", function () { return $77544fccca6f740d$export$97e3ac17371277; });
$parcel$export($77544fccca6f740d$exports, "STATE", function () { return $77544fccca6f740d$export$63b4527a2777036f; });
$parcel$export($77544fccca6f740d$exports, "NONCE", function () { return $77544fccca6f740d$export$8646168ae3eb91e1; });
$parcel$export($77544fccca6f740d$exports, "PROMPT", function () { return $77544fccca6f740d$export$19855bb42e55939d; });
$parcel$export($77544fccca6f740d$exports, "SESSION_STATE", function () { return $77544fccca6f740d$export$3edd0f3d0bfcddba; });
$parcel$export($77544fccca6f740d$exports, "CLIENT_INFO", function () { return $77544fccca6f740d$export$476989d62bcb4c85; });
$parcel$export($77544fccca6f740d$exports, "CODE", function () { return $77544fccca6f740d$export$ec5856072852bd7f; });
$parcel$export($77544fccca6f740d$exports, "CODE_CHALLENGE", function () { return $77544fccca6f740d$export$58d2be3216991fee; });
$parcel$export($77544fccca6f740d$exports, "CODE_CHALLENGE_METHOD", function () { return $77544fccca6f740d$export$129e6f0601e36303; });
$parcel$export($77544fccca6f740d$exports, "CODE_VERIFIER", function () { return $77544fccca6f740d$export$a5a34ec10c757281; });
$parcel$export($77544fccca6f740d$exports, "CLIENT_REQUEST_ID", function () { return $77544fccca6f740d$export$633c8d7cd18ad9a9; });
$parcel$export($77544fccca6f740d$exports, "X_CLIENT_SKU", function () { return $77544fccca6f740d$export$fe2f04d04881f19d; });
$parcel$export($77544fccca6f740d$exports, "X_CLIENT_VER", function () { return $77544fccca6f740d$export$d0d0201281a553c0; });
$parcel$export($77544fccca6f740d$exports, "X_CLIENT_OS", function () { return $77544fccca6f740d$export$35497983a44f9406; });
$parcel$export($77544fccca6f740d$exports, "X_CLIENT_CPU", function () { return $77544fccca6f740d$export$d14a6ca469cd1d2b; });
$parcel$export($77544fccca6f740d$exports, "X_CLIENT_CURR_TELEM", function () { return $77544fccca6f740d$export$770dc090fda61e98; });
$parcel$export($77544fccca6f740d$exports, "X_CLIENT_LAST_TELEM", function () { return $77544fccca6f740d$export$99d6087ff3bfb0d3; });
$parcel$export($77544fccca6f740d$exports, "X_MS_LIB_CAPABILITY", function () { return $77544fccca6f740d$export$c5cd103a582a276; });
$parcel$export($77544fccca6f740d$exports, "X_APP_NAME", function () { return $77544fccca6f740d$export$6101af169595a2ae; });
$parcel$export($77544fccca6f740d$exports, "X_APP_VER", function () { return $77544fccca6f740d$export$a8707209cc4254a; });
$parcel$export($77544fccca6f740d$exports, "POST_LOGOUT_URI", function () { return $77544fccca6f740d$export$965624bb436bcb2; });
$parcel$export($77544fccca6f740d$exports, "ID_TOKEN_HINT", function () { return $77544fccca6f740d$export$8d6737236a319b56; });
$parcel$export($77544fccca6f740d$exports, "DEVICE_CODE", function () { return $77544fccca6f740d$export$a575303545717aec; });
$parcel$export($77544fccca6f740d$exports, "CLIENT_SECRET", function () { return $77544fccca6f740d$export$69f7aececf3ea5d7; });
$parcel$export($77544fccca6f740d$exports, "CLIENT_ASSERTION", function () { return $77544fccca6f740d$export$cddd1d85c78cca51; });
$parcel$export($77544fccca6f740d$exports, "CLIENT_ASSERTION_TYPE", function () { return $77544fccca6f740d$export$21aecb34d0e7d9c0; });
$parcel$export($77544fccca6f740d$exports, "TOKEN_TYPE", function () { return $77544fccca6f740d$export$5706a68daf4f000a; });
$parcel$export($77544fccca6f740d$exports, "REQ_CNF", function () { return $77544fccca6f740d$export$427afb3f9eefe31e; });
$parcel$export($77544fccca6f740d$exports, "OBO_ASSERTION", function () { return $77544fccca6f740d$export$3529b31b0ae94ae0; });
$parcel$export($77544fccca6f740d$exports, "REQUESTED_TOKEN_USE", function () { return $77544fccca6f740d$export$97bc1bf63f077c4a; });
$parcel$export($77544fccca6f740d$exports, "ON_BEHALF_OF", function () { return $77544fccca6f740d$export$4aca5741d44e318e; });
$parcel$export($77544fccca6f740d$exports, "FOCI", function () { return $77544fccca6f740d$export$a03331b9d99609d6; });
$parcel$export($77544fccca6f740d$exports, "CCS_HEADER", function () { return $77544fccca6f740d$export$773357fabf610b1f; });
$parcel$export($77544fccca6f740d$exports, "RETURN_SPA_CODE", function () { return $77544fccca6f740d$export$f58b98a40c1faa68; });
$parcel$export($77544fccca6f740d$exports, "NATIVE_BROKER", function () { return $77544fccca6f740d$export$830ff7e6cf071f86; });
$parcel$export($77544fccca6f740d$exports, "LOGOUT_HINT", function () { return $77544fccca6f740d$export$a96ff88ff08babe2; });
$parcel$export($77544fccca6f740d$exports, "SID", function () { return $77544fccca6f740d$export$e9405f9e95799b52; });
$parcel$export($77544fccca6f740d$exports, "LOGIN_HINT", function () { return $77544fccca6f740d$export$defd6be6e02aaeb3; });
$parcel$export($77544fccca6f740d$exports, "DOMAIN_HINT", function () { return $77544fccca6f740d$export$41459bac1e74ba19; });
$parcel$export($77544fccca6f740d$exports, "X_CLIENT_EXTRA_SKU", function () { return $77544fccca6f740d$export$493429868d5ba9bc; });
$parcel$export($77544fccca6f740d$exports, "BROKER_CLIENT_ID", function () { return $77544fccca6f740d$export$3f910906fd5fe047; });
$parcel$export($77544fccca6f740d$exports, "BROKER_REDIRECT_URI", function () { return $77544fccca6f740d$export$c3ecf58e7e228261; });
/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $77544fccca6f740d$export$c7b1b63f5b60f8e = "client_id";
const $77544fccca6f740d$export$89711068e98820c5 = "redirect_uri";
const $77544fccca6f740d$export$af70b7209f1c7f6e = "response_type";
const $77544fccca6f740d$export$2ae8b352eb8edff7 = "response_mode";
const $77544fccca6f740d$export$47f09697d0642170 = "grant_type";
const $77544fccca6f740d$export$c9b29cc9615296dd = "claims";
const $77544fccca6f740d$export$1c5a554c78c0cd12 = "scope";
const $77544fccca6f740d$export$103bedf43ba882db = "error";
const $77544fccca6f740d$export$a9d2d02ea6b73527 = "error_description";
const $77544fccca6f740d$export$cdbdf26448f9da5b = "access_token";
const $77544fccca6f740d$export$9e690c458f1b1eda = "id_token";
const $77544fccca6f740d$export$2a2261c5a58ac0 = "refresh_token";
const $77544fccca6f740d$export$a9f2539254087dfb = "expires_in";
const $77544fccca6f740d$export$97e3ac17371277 = "refresh_token_expires_in";
const $77544fccca6f740d$export$63b4527a2777036f = "state";
const $77544fccca6f740d$export$8646168ae3eb91e1 = "nonce";
const $77544fccca6f740d$export$19855bb42e55939d = "prompt";
const $77544fccca6f740d$export$3edd0f3d0bfcddba = "session_state";
const $77544fccca6f740d$export$476989d62bcb4c85 = "client_info";
const $77544fccca6f740d$export$ec5856072852bd7f = "code";
const $77544fccca6f740d$export$58d2be3216991fee = "code_challenge";
const $77544fccca6f740d$export$129e6f0601e36303 = "code_challenge_method";
const $77544fccca6f740d$export$a5a34ec10c757281 = "code_verifier";
const $77544fccca6f740d$export$633c8d7cd18ad9a9 = "client-request-id";
const $77544fccca6f740d$export$fe2f04d04881f19d = "x-client-SKU";
const $77544fccca6f740d$export$d0d0201281a553c0 = "x-client-VER";
const $77544fccca6f740d$export$35497983a44f9406 = "x-client-OS";
const $77544fccca6f740d$export$d14a6ca469cd1d2b = "x-client-CPU";
const $77544fccca6f740d$export$770dc090fda61e98 = "x-client-current-telemetry";
const $77544fccca6f740d$export$99d6087ff3bfb0d3 = "x-client-last-telemetry";
const $77544fccca6f740d$export$c5cd103a582a276 = "x-ms-lib-capability";
const $77544fccca6f740d$export$6101af169595a2ae = "x-app-name";
const $77544fccca6f740d$export$a8707209cc4254a = "x-app-ver";
const $77544fccca6f740d$export$965624bb436bcb2 = "post_logout_redirect_uri";
const $77544fccca6f740d$export$8d6737236a319b56 = "id_token_hint";
const $77544fccca6f740d$export$a575303545717aec = "device_code";
const $77544fccca6f740d$export$69f7aececf3ea5d7 = "client_secret";
const $77544fccca6f740d$export$cddd1d85c78cca51 = "client_assertion";
const $77544fccca6f740d$export$21aecb34d0e7d9c0 = "client_assertion_type";
const $77544fccca6f740d$export$5706a68daf4f000a = "token_type";
const $77544fccca6f740d$export$427afb3f9eefe31e = "req_cnf";
const $77544fccca6f740d$export$3529b31b0ae94ae0 = "assertion";
const $77544fccca6f740d$export$97bc1bf63f077c4a = "requested_token_use";
const $77544fccca6f740d$export$4aca5741d44e318e = "on_behalf_of";
const $77544fccca6f740d$export$a03331b9d99609d6 = "foci";
const $77544fccca6f740d$export$773357fabf610b1f = "X-AnchorMailbox";
const $77544fccca6f740d$export$f58b98a40c1faa68 = "return_spa_code";
const $77544fccca6f740d$export$830ff7e6cf071f86 = "nativebroker";
const $77544fccca6f740d$export$a96ff88ff08babe2 = "logout_hint";
const $77544fccca6f740d$export$e9405f9e95799b52 = "sid";
const $77544fccca6f740d$export$defd6be6e02aaeb3 = "login_hint";
const $77544fccca6f740d$export$41459bac1e74ba19 = "domain_hint";
const $77544fccca6f740d$export$493429868d5ba9bc = "x-client-xtra-sku";
const $77544fccca6f740d$export$3f910906fd5fe047 = "brk_client_id";
const $77544fccca6f740d$export$c3ecf58e7e228261 = "brk_redirect_uri";




/*! @azure/msal-common v14.16.0 2024-11-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Validates server consumable params from the "request" objects
 */ class $4e2861e8184d6622$export$9800b929b6984365 {
    /**
     * Utility to check if the `redirectUri` in the request is a non-null value
     * @param redirectUri
     */ static validateRedirectUri(redirectUri) {
        if (!redirectUri) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$7a02f9bdce79dd4e));
    }
    /**
     * Utility to validate prompt sent by the user in the request
     * @param prompt
     */ static validatePrompt(prompt) {
        const promptValues = [];
        for(const value in 0, $e6f7ad11e10d0573$export$49a06cbda5acaa5)promptValues.push((0, $e6f7ad11e10d0573$export$49a06cbda5acaa5)[value]);
        if (promptValues.indexOf(prompt) < 0) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$ccbe5d2d7c960c35));
    }
    static validateClaims(claims) {
        try {
            JSON.parse(claims);
        } catch (e) {
            throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$96e755c70e0d0e34));
        }
    }
    /**
     * Utility to validate code_challenge and code_challenge_method
     * @param codeChallenge
     * @param codeChallengeMethod
     */ static validateCodeChallengeParams(codeChallenge, codeChallengeMethod) {
        if (!codeChallenge || !codeChallengeMethod) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$2da3866b327f1753));
        else this.validateCodeChallengeMethod(codeChallengeMethod);
    }
    /**
     * Utility to validate code_challenge_method
     * @param codeChallengeMethod
     */ static validateCodeChallengeMethod(codeChallengeMethod) {
        if ([
            (0, $e6f7ad11e10d0573$export$a1fe36237c1cc863).PLAIN,
            (0, $e6f7ad11e10d0573$export$a1fe36237c1cc863).S256
        ].indexOf(codeChallengeMethod) < 0) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$b8d8b332f17376dc));
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $e395f42fea42ad84$var$instrumentBrokerParams(parameters, correlationId, performanceClient) {
    if (!correlationId) return;
    const clientId = parameters.get((0, $77544fccca6f740d$export$c7b1b63f5b60f8e));
    if (clientId && parameters.has((0, $77544fccca6f740d$export$3f910906fd5fe047))) performanceClient?.addFields({
        embeddedClientId: clientId,
        embeddedRedirectUri: parameters.get((0, $77544fccca6f740d$export$89711068e98820c5))
    }, correlationId);
}
/** @internal */ class $e395f42fea42ad84$export$882078dd8a9e0bfa {
    constructor(correlationId, performanceClient){
        this.parameters = new Map();
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * add response_type = code
     */ addResponseTypeCode() {
        this.parameters.set((0, $77544fccca6f740d$export$af70b7209f1c7f6e), encodeURIComponent((0, $e6f7ad11e10d0573$export$a002182e51710d39).CODE_RESPONSE_TYPE));
    }
    /**
     * add response_type = token id_token
     */ addResponseTypeForTokenAndIdToken() {
        this.parameters.set((0, $77544fccca6f740d$export$af70b7209f1c7f6e), encodeURIComponent(`${(0, $e6f7ad11e10d0573$export$a002182e51710d39).TOKEN_RESPONSE_TYPE} ${(0, $e6f7ad11e10d0573$export$a002182e51710d39).ID_TOKEN_RESPONSE_TYPE}`));
    }
    /**
     * add response_mode. defaults to query.
     * @param responseMode
     */ addResponseMode(responseMode) {
        this.parameters.set((0, $77544fccca6f740d$export$2ae8b352eb8edff7), encodeURIComponent(responseMode ? responseMode : (0, $e6f7ad11e10d0573$export$f990a5bae1260b8c).QUERY));
    }
    /**
     * Add flag to indicate STS should attempt to use WAM if available
     */ addNativeBroker() {
        this.parameters.set((0, $77544fccca6f740d$export$830ff7e6cf071f86), encodeURIComponent("1"));
    }
    /**
     * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
     * @param scopeSet
     * @param addOidcScopes
     */ addScopes(scopes, addOidcScopes = true, defaultScopes = (0, $e6f7ad11e10d0573$export$893b1b5b686d84ef)) {
        // Always add openid to the scopes when adding OIDC scopes
        if (addOidcScopes && !defaultScopes.includes("openid") && !scopes.includes("openid")) defaultScopes.push("openid");
        const requestScopes = addOidcScopes ? [
            ...scopes || [],
            ...defaultScopes
        ] : scopes || [];
        const scopeSet = new (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99)(requestScopes);
        this.parameters.set((0, $77544fccca6f740d$export$1c5a554c78c0cd12), encodeURIComponent(scopeSet.printScopes()));
    }
    /**
     * add clientId
     * @param clientId
     */ addClientId(clientId) {
        this.parameters.set((0, $77544fccca6f740d$export$c7b1b63f5b60f8e), encodeURIComponent(clientId));
    }
    /**
     * add redirect_uri
     * @param redirectUri
     */ addRedirectUri(redirectUri) {
        (0, $4e2861e8184d6622$export$9800b929b6984365).validateRedirectUri(redirectUri);
        this.parameters.set((0, $77544fccca6f740d$export$89711068e98820c5), encodeURIComponent(redirectUri));
    }
    /**
     * add post logout redirectUri
     * @param redirectUri
     */ addPostLogoutRedirectUri(redirectUri) {
        (0, $4e2861e8184d6622$export$9800b929b6984365).validateRedirectUri(redirectUri);
        this.parameters.set((0, $77544fccca6f740d$export$965624bb436bcb2), encodeURIComponent(redirectUri));
    }
    /**
     * add id_token_hint to logout request
     * @param idTokenHint
     */ addIdTokenHint(idTokenHint) {
        this.parameters.set((0, $77544fccca6f740d$export$8d6737236a319b56), encodeURIComponent(idTokenHint));
    }
    /**
     * add domain_hint
     * @param domainHint
     */ addDomainHint(domainHint) {
        this.parameters.set((0, $77544fccca6f740d$export$41459bac1e74ba19), encodeURIComponent(domainHint));
    }
    /**
     * add login_hint
     * @param loginHint
     */ addLoginHint(loginHint) {
        this.parameters.set((0, $77544fccca6f740d$export$defd6be6e02aaeb3), encodeURIComponent(loginHint));
    }
    /**
     * Adds the CCS (Cache Credential Service) query parameter for login_hint
     * @param loginHint
     */ addCcsUpn(loginHint) {
        this.parameters.set((0, $e6f7ad11e10d0573$export$28d77f87efed1d88).CCS_HEADER, encodeURIComponent(`UPN:${loginHint}`));
    }
    /**
     * Adds the CCS (Cache Credential Service) query parameter for account object
     * @param loginHint
     */ addCcsOid(clientInfo) {
        this.parameters.set((0, $e6f7ad11e10d0573$export$28d77f87efed1d88).CCS_HEADER, encodeURIComponent(`Oid:${clientInfo.uid}@${clientInfo.utid}`));
    }
    /**
     * add sid
     * @param sid
     */ addSid(sid) {
        this.parameters.set((0, $77544fccca6f740d$export$e9405f9e95799b52), encodeURIComponent(sid));
    }
    /**
     * add claims
     * @param claims
     */ addClaims(claims, clientCapabilities) {
        const mergedClaims = this.addClientCapabilitiesToClaims(claims, clientCapabilities);
        (0, $4e2861e8184d6622$export$9800b929b6984365).validateClaims(mergedClaims);
        this.parameters.set((0, $77544fccca6f740d$export$c9b29cc9615296dd), encodeURIComponent(mergedClaims));
    }
    /**
     * add correlationId
     * @param correlationId
     */ addCorrelationId(correlationId) {
        this.parameters.set((0, $77544fccca6f740d$export$633c8d7cd18ad9a9), encodeURIComponent(correlationId));
    }
    /**
     * add library info query params
     * @param libraryInfo
     */ addLibraryInfo(libraryInfo) {
        // Telemetry Info
        this.parameters.set((0, $77544fccca6f740d$export$fe2f04d04881f19d), libraryInfo.sku);
        this.parameters.set((0, $77544fccca6f740d$export$d0d0201281a553c0), libraryInfo.version);
        if (libraryInfo.os) this.parameters.set((0, $77544fccca6f740d$export$35497983a44f9406), libraryInfo.os);
        if (libraryInfo.cpu) this.parameters.set((0, $77544fccca6f740d$export$d14a6ca469cd1d2b), libraryInfo.cpu);
    }
    /**
     * Add client telemetry parameters
     * @param appTelemetry
     */ addApplicationTelemetry(appTelemetry) {
        if (appTelemetry?.appName) this.parameters.set((0, $77544fccca6f740d$export$6101af169595a2ae), appTelemetry.appName);
        if (appTelemetry?.appVersion) this.parameters.set((0, $77544fccca6f740d$export$a8707209cc4254a), appTelemetry.appVersion);
    }
    /**
     * add prompt
     * @param prompt
     */ addPrompt(prompt) {
        (0, $4e2861e8184d6622$export$9800b929b6984365).validatePrompt(prompt);
        this.parameters.set(`${(0, $77544fccca6f740d$export$19855bb42e55939d)}`, encodeURIComponent(prompt));
    }
    /**
     * add state
     * @param state
     */ addState(state) {
        if (state) this.parameters.set((0, $77544fccca6f740d$export$63b4527a2777036f), encodeURIComponent(state));
    }
    /**
     * add nonce
     * @param nonce
     */ addNonce(nonce) {
        this.parameters.set((0, $77544fccca6f740d$export$8646168ae3eb91e1), encodeURIComponent(nonce));
    }
    /**
     * add code_challenge and code_challenge_method
     * - throw if either of them are not passed
     * @param codeChallenge
     * @param codeChallengeMethod
     */ addCodeChallengeParams(codeChallenge, codeChallengeMethod) {
        (0, $4e2861e8184d6622$export$9800b929b6984365).validateCodeChallengeParams(codeChallenge, codeChallengeMethod);
        if (codeChallenge && codeChallengeMethod) {
            this.parameters.set((0, $77544fccca6f740d$export$58d2be3216991fee), encodeURIComponent(codeChallenge));
            this.parameters.set((0, $77544fccca6f740d$export$129e6f0601e36303), encodeURIComponent(codeChallengeMethod));
        } else throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$2da3866b327f1753));
    }
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */ addAuthorizationCode(code) {
        this.parameters.set((0, $77544fccca6f740d$export$ec5856072852bd7f), encodeURIComponent(code));
    }
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */ addDeviceCode(code) {
        this.parameters.set((0, $77544fccca6f740d$export$a575303545717aec), encodeURIComponent(code));
    }
    /**
     * add the `refreshToken` passed by the user
     * @param refreshToken
     */ addRefreshToken(refreshToken) {
        this.parameters.set((0, $77544fccca6f740d$export$2a2261c5a58ac0), encodeURIComponent(refreshToken));
    }
    /**
     * add the `code_verifier` passed by the user to exchange for a token
     * @param codeVerifier
     */ addCodeVerifier(codeVerifier) {
        this.parameters.set((0, $77544fccca6f740d$export$a5a34ec10c757281), encodeURIComponent(codeVerifier));
    }
    /**
     * add client_secret
     * @param clientSecret
     */ addClientSecret(clientSecret) {
        this.parameters.set((0, $77544fccca6f740d$export$69f7aececf3ea5d7), encodeURIComponent(clientSecret));
    }
    /**
     * add clientAssertion for confidential client flows
     * @param clientAssertion
     */ addClientAssertion(clientAssertion) {
        if (clientAssertion) this.parameters.set((0, $77544fccca6f740d$export$cddd1d85c78cca51), encodeURIComponent(clientAssertion));
    }
    /**
     * add clientAssertionType for confidential client flows
     * @param clientAssertionType
     */ addClientAssertionType(clientAssertionType) {
        if (clientAssertionType) this.parameters.set((0, $77544fccca6f740d$export$21aecb34d0e7d9c0), encodeURIComponent(clientAssertionType));
    }
    /**
     * add OBO assertion for confidential client flows
     * @param clientAssertion
     */ addOboAssertion(oboAssertion) {
        this.parameters.set((0, $77544fccca6f740d$export$3529b31b0ae94ae0), encodeURIComponent(oboAssertion));
    }
    /**
     * add grant type
     * @param grantType
     */ addRequestTokenUse(tokenUse) {
        this.parameters.set((0, $77544fccca6f740d$export$97bc1bf63f077c4a), encodeURIComponent(tokenUse));
    }
    /**
     * add grant type
     * @param grantType
     */ addGrantType(grantType) {
        this.parameters.set((0, $77544fccca6f740d$export$47f09697d0642170), encodeURIComponent(grantType));
    }
    /**
     * add client info
     *
     */ addClientInfo() {
        this.parameters.set((0, $e6f7ad11e10d0573$export$476989d62bcb4c85), "1");
    }
    /**
     * add extraQueryParams
     * @param eQParams
     */ addExtraQueryParameters(eQParams) {
        Object.entries(eQParams).forEach(([key, value])=>{
            if (!this.parameters.has(key) && value) this.parameters.set(key, value);
        });
    }
    addClientCapabilitiesToClaims(claims, clientCapabilities) {
        let mergedClaims;
        // Parse provided claims into JSON object or initialize empty object
        if (!claims) mergedClaims = {};
        else try {
            mergedClaims = JSON.parse(claims);
        } catch (e) {
            throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$96e755c70e0d0e34));
        }
        if (clientCapabilities && clientCapabilities.length > 0) {
            if (!mergedClaims.hasOwnProperty((0, $e6f7ad11e10d0573$export$c125cda26c71ef54).ACCESS_TOKEN)) // Add access_token key to claims object
            mergedClaims[(0, $e6f7ad11e10d0573$export$c125cda26c71ef54).ACCESS_TOKEN] = {};
            // Add xms_cc claim with provided clientCapabilities to access_token key
            mergedClaims[(0, $e6f7ad11e10d0573$export$c125cda26c71ef54).ACCESS_TOKEN][(0, $e6f7ad11e10d0573$export$c125cda26c71ef54).XMS_CC] = {
                values: clientCapabilities
            };
        }
        return JSON.stringify(mergedClaims);
    }
    /**
     * adds `username` for Password Grant flow
     * @param username
     */ addUsername(username) {
        this.parameters.set((0, $e6f7ad11e10d0573$export$fa8b29062cab1da).username, encodeURIComponent(username));
    }
    /**
     * adds `password` for Password Grant flow
     * @param password
     */ addPassword(password) {
        this.parameters.set((0, $e6f7ad11e10d0573$export$fa8b29062cab1da).password, encodeURIComponent(password));
    }
    /**
     * add pop_jwk to query params
     * @param cnfString
     */ addPopToken(cnfString) {
        if (cnfString) {
            this.parameters.set((0, $77544fccca6f740d$export$5706a68daf4f000a), (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP);
            this.parameters.set((0, $77544fccca6f740d$export$427afb3f9eefe31e), encodeURIComponent(cnfString));
        }
    }
    /**
     * add SSH JWK and key ID to query params
     */ addSshJwk(sshJwkString) {
        if (sshJwkString) {
            this.parameters.set((0, $77544fccca6f740d$export$5706a68daf4f000a), (0, $e6f7ad11e10d0573$export$901491a717da2ba5).SSH);
            this.parameters.set((0, $77544fccca6f740d$export$427afb3f9eefe31e), encodeURIComponent(sshJwkString));
        }
    }
    /**
     * add server telemetry fields
     * @param serverTelemetryManager
     */ addServerTelemetry(serverTelemetryManager) {
        this.parameters.set((0, $77544fccca6f740d$export$770dc090fda61e98), serverTelemetryManager.generateCurrentRequestHeaderValue());
        this.parameters.set((0, $77544fccca6f740d$export$99d6087ff3bfb0d3), serverTelemetryManager.generateLastRequestHeaderValue());
    }
    /**
     * Adds parameter that indicates to the server that throttling is supported
     */ addThrottling() {
        this.parameters.set((0, $77544fccca6f740d$export$c5cd103a582a276), (0, $e6f7ad11e10d0573$export$a2330d6808e6d893).X_MS_LIB_CAPABILITY_VALUE);
    }
    /**
     * Adds logout_hint parameter for "silent" logout which prevent server account picker
     */ addLogoutHint(logoutHint) {
        this.parameters.set((0, $77544fccca6f740d$export$a96ff88ff08babe2), encodeURIComponent(logoutHint));
    }
    addBrokerParameters(params) {
        const brokerParams = {};
        brokerParams[0, $77544fccca6f740d$export$3f910906fd5fe047] = params.brokerClientId;
        brokerParams[0, $77544fccca6f740d$export$c3ecf58e7e228261] = params.brokerRedirectUri;
        this.addExtraQueryParameters(brokerParams);
    }
    /**
     * Utility to create a URL from the params map
     */ createQueryString() {
        const queryParameterArray = new Array();
        this.parameters.forEach((value, key)=>{
            queryParameterArray.push(`${key}=${value}`);
        });
        $e395f42fea42ad84$var$instrumentBrokerParams(this.parameters, this.correlationId, this.performanceClient);
        return queryParameterArray.join("&");
    }
}


var $761e45da09259d0f$exports = {};

$parcel$export($761e45da09259d0f$exports, "createDiscoveredInstance", function () { return $761e45da09259d0f$export$ab9db5e7e572e7da; });
/*! @azure/msal-common v14.16.0 2024-11-05 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create an authority object of the correct type based on the url
 * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
 *
 * Also performs endpoint discovery.
 *
 * @param authorityUri
 * @param networkClient
 * @param protocolMode
 * @internal
 */ async function $761e45da09259d0f$export$ab9db5e7e572e7da(authorityUri, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient) {
    performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, correlationId);
    const authorityUriFinal = (0, $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c).transformCIAMAuthority((0, $2d706f1a340b3c1d$export$4030f3538167cb9e)(authorityUri));
    // Initialize authority and perform discovery endpoint check.
    const acquireTokenAuthority = new (0, $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c)(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient);
    try {
        await (0, $ae433257996980ce$export$e4feded94d9adb18)(acquireTokenAuthority.resolveEndpointsAsync.bind(acquireTokenAuthority), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, logger, performanceClient, correlationId)();
        return acquireTokenAuthority;
    } catch (e) {
        throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$c9fcc93738cc2bc3));
    }
}









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base application class which will construct requests to send to and handle responses from the Microsoft STS using the authorization code flow.
 * @internal
 */ class $74fe0f6fcfa66614$export$4f22f74eddb7716a {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = (0, $daec59b36bfd07ff$export$57a091701dcdabb2)(configuration);
        // Initialize the logger
        this.logger = new (0, $bf1c529f0722dfeb$export$efa9a398d6368992)(this.config.loggerOptions, (0, $c9cf9f06071f7708$export$a8ff84c12d48cfa6), (0, $c9cf9f06071f7708$export$83d89fbfd8236492));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Creates default headers for requests to token endpoint
     */ createTokenRequestHeaders(ccsCred) {
        const headers = {};
        headers[(0, $e6f7ad11e10d0573$export$28d77f87efed1d88).CONTENT_TYPE] = (0, $e6f7ad11e10d0573$export$a002182e51710d39).URL_FORM_CONTENT_TYPE;
        if (!this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $40ea3b2fe13bb092$export$63508a6d6b7dbe07)(ccsCred.credential);
                    headers[(0, $e6f7ad11e10d0573$export$28d77f87efed1d88).CCS_HEADER] = `Oid:${clientInfo.uid}@${clientInfo.utid}`;
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).UPN:
                headers[(0, $e6f7ad11e10d0573$export$28d77f87efed1d88).CCS_HEADER] = `UPN: ${ccsCred.credential}`;
                break;
        }
        return headers;
    }
    /**
     * Http post to token endpoint
     * @param tokenEndpoint
     * @param queryString
     * @param headers
     * @param thumbprint
     */ async executePostToTokenEndpoint(tokenEndpoint, queryString, headers, thumbprint, correlationId, queuedEvent) {
        if (queuedEvent) this.performanceClient?.addQueueMeasurement(queuedEvent, correlationId);
        const response = await this.sendPostRequest(thumbprint, tokenEndpoint, {
            body: queryString,
            headers: headers
        }, correlationId);
        if (this.config.serverTelemetryManager && response.status < 500 && response.status !== 429) // Telemetry data successfully logged by server, clear Telemetry cache
        this.config.serverTelemetryManager.clearTelemetryCache();
        return response;
    }
    /**
     * Wraps sendPostRequestAsync with necessary preflight and postflight logic
     * @param thumbprint - Request thumbprint for throttling
     * @param tokenEndpoint - Endpoint to make the POST to
     * @param options - Body and Headers to include on the POST request
     * @param correlationId - CorrelationId for telemetry
     */ async sendPostRequest(thumbprint, tokenEndpoint, options, correlationId) {
        (0, $8868e8edc76d69b4$export$c060a619741dd765).preProcess(this.cacheManager, thumbprint);
        let response;
        try {
            response = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.networkClient.sendPostRequestAsync.bind(this.networkClient), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).NetworkClientSendPostRequestAsync, this.logger, this.performanceClient, correlationId)(tokenEndpoint, options);
            const responseHeaders = response.headers || {};
            this.performanceClient?.addFields({
                refreshTokenSize: response.body.refresh_token?.length || 0,
                httpVerToken: responseHeaders[(0, $e6f7ad11e10d0573$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                requestId: responseHeaders[(0, $e6f7ad11e10d0573$export$28d77f87efed1d88).X_MS_REQUEST_ID] || ""
            }, correlationId);
        } catch (e) {
            if (e instanceof (0, $64fab191b4af9ef5$export$bae979e68e4dc802)) {
                const responseHeaders = e.responseHeaders;
                if (responseHeaders) this.performanceClient?.addFields({
                    httpVerToken: responseHeaders[(0, $e6f7ad11e10d0573$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                    requestId: responseHeaders[(0, $e6f7ad11e10d0573$export$28d77f87efed1d88).X_MS_REQUEST_ID] || "",
                    contentTypeHeader: responseHeaders[(0, $e6f7ad11e10d0573$export$28d77f87efed1d88).CONTENT_TYPE] || undefined,
                    contentLengthHeader: responseHeaders[(0, $e6f7ad11e10d0573$export$28d77f87efed1d88).CONTENT_LENGTH] || undefined,
                    httpStatus: e.httpStatus
                }, correlationId);
                throw e.error;
            }
            if (e instanceof (0, $40da14d5d49dd285$export$145273558d58e0ac)) throw e;
            else throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$4358cbadf08aa73));
        }
        (0, $8868e8edc76d69b4$export$c060a619741dd765).postProcess(this.cacheManager, thumbprint, response);
        return response;
    }
    /**
     * Updates the authority object of the client. Endpoint discovery must be completed.
     * @param updatedAuthority
     */ async updateAuthority(cloudInstanceHostname, correlationId) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, correlationId);
        const cloudInstanceAuthorityUri = `https://${cloudInstanceHostname}/${this.authority.tenant}/`;
        const cloudInstanceAuthority = await (0, $761e45da09259d0f$export$ab9db5e7e572e7da)(cloudInstanceAuthorityUri, this.networkClient, this.cacheManager, this.authority.options, this.logger, correlationId, this.performanceClient);
        this.authority = cloudInstanceAuthority;
    }
    /**
     * Creates query string for the /token request
     * @param request
     */ createTokenQueryParameters(request) {
        const parameterBuilder = new (0, $e395f42fea42ad84$export$882078dd8a9e0bfa)(request.correlationId, this.performanceClient);
        if (request.embeddedClientId) parameterBuilder.addBrokerParameters({
            brokerClientId: this.config.authOptions.clientId,
            brokerRedirectUri: this.config.authOptions.redirectUri
        });
        if (request.tokenQueryParameters) parameterBuilder.addExtraQueryParameters(request.tokenQueryParameters);
        parameterBuilder.addCorrelationId(request.correlationId);
        return parameterBuilder.createQueryString();
    }
}






/*! @azure/msal-common v14.16.0 2024-11-05 */ 






/*! @azure/msal-common v14.16.0 2024-11-05 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $ad4a320e462faf03$var$KeyLocation = {
    SW: "sw",
    UHW: "uhw"
};
/** @internal */ class $ad4a320e462faf03$export$3dd8467151c83e3e {
    constructor(cryptoUtils, performanceClient){
        this.cryptoUtils = cryptoUtils;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */ async generateCnf(request, logger) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).PopTokenGenerateCnf, request.correlationId);
        const reqCnf = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.generateKid.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).PopTokenGenerateCnf, logger, this.performanceClient, request.correlationId)(request);
        const reqCnfString = this.cryptoUtils.base64UrlEncode(JSON.stringify(reqCnf));
        return {
            kid: reqCnf.kid,
            reqCnfString: reqCnfString
        };
    }
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */ async generateKid(request) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).PopTokenGenerateKid, request.correlationId);
        const kidThumbprint = await this.cryptoUtils.getPublicKeyThumbprint(request);
        return {
            kid: kidThumbprint,
            xms_ksl: $ad4a320e462faf03$var$KeyLocation.SW
        };
    }
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */ async signPopToken(accessToken, keyId, request) {
        return this.signPayload(accessToken, keyId, request);
    }
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */ async signPayload(payload, keyId, request, claims) {
        // Deconstruct request to extract SHR parameters
        const { resourceRequestMethod: resourceRequestMethod, resourceRequestUri: resourceRequestUri, shrClaims: shrClaims, shrNonce: shrNonce, shrOptions: shrOptions } = request;
        const resourceUrlString = resourceRequestUri ? new (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2)(resourceRequestUri) : undefined;
        const resourceUrlComponents = resourceUrlString?.getUrlComponents();
        return this.cryptoUtils.signJwt({
            at: payload,
            ts: (0, $ac7fb5ae1cae46f5$export$ae62599a119ac50a)(),
            m: resourceRequestMethod?.toUpperCase(),
            u: resourceUrlComponents?.HostNameAndPort,
            nonce: shrNonce || this.cryptoUtils.createNewGuid(),
            p: resourceUrlComponents?.AbsolutePath,
            q: resourceUrlComponents?.QueryString ? [
                [],
                resourceUrlComponents.QueryString
            ] : undefined,
            client_claims: shrClaims || undefined,
            ...claims
        }, keyId, shrOptions, request.correlationId);
    }
}


/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ class $31105d51611f2e54$export$500ab620f6bcc747 {
    constructor(tokenCache, hasChanged){
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    /**
     * boolean which indicates the changes in cache
     */ get cacheHasChanged() {
        return this.hasChanged;
    }
    /**
     * function to retrieve the token cache
     */ get tokenCache() {
        return this.cache;
    }
}








'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $7b0e3b4066211abb$var$parseServerErrorNo(serverResponse) {
    const errorCodePrefix = "code=";
    const errorCodePrefixIndex = serverResponse.error_uri?.lastIndexOf(errorCodePrefix);
    return errorCodePrefixIndex && errorCodePrefixIndex >= 0 ? serverResponse.error_uri?.substring(errorCodePrefixIndex + errorCodePrefix.length) : undefined;
}
/**
 * Class that handles response parsing.
 * @internal
 */ class $7b0e3b4066211abb$export$f456c9835cc63582 {
    constructor(clientId, cacheStorage, cryptoObj, logger, serializableCache, persistencePlugin, performanceClient){
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.logger = logger;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
        this.performanceClient = performanceClient;
    }
    /**
     * Function which validates server authorization code response.
     * @param serverResponseHash
     * @param requestState
     * @param cryptoObj
     */ validateServerAuthorizationCodeResponse(serverResponse, requestState) {
        if (!serverResponse.state || !requestState) throw serverResponse.state ? (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$ef9214cfa5960fc), "Cached State") : (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$ef9214cfa5960fc), "Server State");
        let decodedServerResponseState;
        let decodedRequestState;
        try {
            decodedServerResponseState = decodeURIComponent(serverResponse.state);
        } catch (e) {
            throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$72a77317632c052b), serverResponse.state);
        }
        try {
            decodedRequestState = decodeURIComponent(requestState);
        } catch (e) {
            throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$72a77317632c052b), serverResponse.state);
        }
        if (decodedServerResponseState !== decodedRequestState) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$6a56d8f882843cd8));
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const serverErrorNo = $7b0e3b4066211abb$var$parseServerErrorNo(serverResponse);
            if ((0, $b3acdb9c5805a543$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $b3acdb9c5805a543$export$6ba3e818c6bc76ba)(serverResponse.error || "", serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.correlation_id || "", serverResponse.claims || "", serverErrorNo);
            throw new (0, $0463942371f4715f$export$ea52035eac03daf0)(serverResponse.error || "", serverResponse.error_description, serverResponse.suberror, serverErrorNo);
        }
    }
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     * @param refreshAccessToken
     */ validateTokenResponse(serverResponse, refreshAccessToken) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const errString = `Error(s): ${serverResponse.error_codes || (0, $e6f7ad11e10d0573$export$a002182e51710d39).NOT_AVAILABLE} - Timestamp: ${serverResponse.timestamp || (0, $e6f7ad11e10d0573$export$a002182e51710d39).NOT_AVAILABLE} - Description: ${serverResponse.error_description || (0, $e6f7ad11e10d0573$export$a002182e51710d39).NOT_AVAILABLE} - Correlation ID: ${serverResponse.correlation_id || (0, $e6f7ad11e10d0573$export$a002182e51710d39).NOT_AVAILABLE} - Trace ID: ${serverResponse.trace_id || (0, $e6f7ad11e10d0573$export$a002182e51710d39).NOT_AVAILABLE}`;
            const serverErrorNo = serverResponse.error_codes?.length ? serverResponse.error_codes[0] : undefined;
            const serverError = new (0, $0463942371f4715f$export$ea52035eac03daf0)(serverResponse.error, errString, serverResponse.suberror, serverErrorNo, serverResponse.status);
            // check if 500 error
            if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $e6f7ad11e10d0573$export$2b71909294c66558).SERVER_ERROR_RANGE_START && serverResponse.status <= (0, $e6f7ad11e10d0573$export$2b71909294c66558).SERVER_ERROR_RANGE_END) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently unavailable and the access token is unable to be refreshed.\n${serverError}`);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            // check if 400 error
            } else if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $e6f7ad11e10d0573$export$2b71909294c66558).CLIENT_ERROR_RANGE_START && serverResponse.status <= (0, $e6f7ad11e10d0573$export$2b71909294c66558).CLIENT_ERROR_RANGE_END) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently available but is unable to refresh the access token.\n${serverError}`);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            }
            if ((0, $b3acdb9c5805a543$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $b3acdb9c5805a543$export$6ba3e818c6bc76ba)(serverResponse.error, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING, serverResponse.trace_id || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING, serverResponse.correlation_id || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING, serverResponse.claims || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING, serverErrorNo);
            throw serverError;
        }
    }
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */ async handleServerTokenResponse(serverTokenResponse, authority, reqTimestamp, request, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).HandleServerTokenResponse, serverTokenResponse.correlation_id);
        // create an idToken object (not entity)
        let idTokenClaims;
        if (serverTokenResponse.id_token) {
            idTokenClaims = (0, $dbb12b3851d257af$export$8a59e6f35fb00518)(serverTokenResponse.id_token || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING, this.cryptoObj.base64Decode);
            // token nonce check (TODO: Add a warning if no nonce is given?)
            if (authCodePayload && authCodePayload.nonce) {
                if (idTokenClaims.nonce !== authCodePayload.nonce) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$edd0491c2c280be7));
            }
            // token max_age check
            if (request.maxAge || request.maxAge === 0) {
                const authTime = idTokenClaims.auth_time;
                if (!authTime) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$43356944266c945e));
                (0, $dbb12b3851d257af$export$ee7a34ea7880144c)(authTime, request.maxAge);
            }
        }
        // generate homeAccountId
        this.homeAccountIdentifier = (0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).generateHomeAccountId(serverTokenResponse.client_info || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING, authority.authorityType, this.logger, this.cryptoObj, idTokenClaims);
        // save the response tokens
        let requestStateObj;
        if (!!authCodePayload && !!authCodePayload.state) requestStateObj = (0, $9523def209bc6e1a$export$871e33217042c65e).parseRequestState(this.cryptoObj, authCodePayload.state);
        // Add keyId from request to serverTokenResponse if defined
        serverTokenResponse.key_id = serverTokenResponse.key_id || request.sshKid || undefined;
        const cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload);
        let cacheContext;
        try {
            if (this.persistencePlugin && this.serializableCache) {
                this.logger.verbose("Persistence enabled, calling beforeCacheAccess");
                cacheContext = new (0, $31105d51611f2e54$export$500ab620f6bcc747)(this.serializableCache, true);
                await this.persistencePlugin.beforeCacheAccess(cacheContext);
            }
            /*
             * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
             * If not present, we should return null, as it's the case that another application called removeAccount in between
             * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
             * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
             */ if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                const key = cacheRecord.account.generateAccountKey();
                const account = this.cacheStorage.getAccount(key, this.logger);
                if (!account) {
                    this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache");
                    return await $7b0e3b4066211abb$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenClaims, requestStateObj, undefined, serverRequestId);
                }
            }
            await this.cacheStorage.saveCacheRecord(cacheRecord, request.storeInCache, request.correlationId);
        } finally{
            if (this.persistencePlugin && this.serializableCache && cacheContext) {
                this.logger.verbose("Persistence enabled, calling afterCacheAccess");
                await this.persistencePlugin.afterCacheAccess(cacheContext);
            }
        }
        return $7b0e3b4066211abb$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenClaims, requestStateObj, serverTokenResponse, serverRequestId);
    }
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */ generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload) {
        const env = authority.getPreferredCache();
        if (!env) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$dedc648643245fa1));
        const claimsTenantId = (0, $01ccbb432865d121$export$8e1decb9a5e2932)(idTokenClaims);
        // IdToken: non AAD scenarios can have empty realm
        let cachedIdToken;
        let cachedAccount;
        if (serverTokenResponse.id_token && !!idTokenClaims) {
            cachedIdToken = (0, $d6bc4864bb049bc4$export$d8a173a23f325769)(this.homeAccountIdentifier, env, serverTokenResponse.id_token, this.clientId, claimsTenantId || "");
            cachedAccount = $7b0e3b4066211abb$export$73b84062d58a1307(this.cacheStorage, authority, this.homeAccountIdentifier, this.cryptoObj.base64Decode, idTokenClaims, serverTokenResponse.client_info, env, claimsTenantId, authCodePayload, undefined, this.logger);
        }
        // AccessToken
        let cachedAccessToken = null;
        if (serverTokenResponse.access_token) {
            // If scopes not returned in server response, use request scopes
            const responseScopes = serverTokenResponse.scope ? (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).fromString(serverTokenResponse.scope) : new (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99)(request.scopes || []);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */ const expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            const extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            const refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            const tokenExpirationSeconds = reqTimestamp + expiresIn;
            const extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            const refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = (0, $d6bc4864bb049bc4$export$fa005e75d915b6db)(this.homeAccountIdentifier, env, serverTokenResponse.access_token, this.clientId, claimsTenantId || authority.tenant || "", responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj.base64Decode, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, request.claims, request.requestedClaimsHash);
        }
        // refreshToken
        let cachedRefreshToken = null;
        if (serverTokenResponse.refresh_token) {
            let rtExpiresOn;
            if (serverTokenResponse.refresh_token_expires_in) {
                const rtExpiresIn = typeof serverTokenResponse.refresh_token_expires_in === "string" ? parseInt(serverTokenResponse.refresh_token_expires_in, 10) : serverTokenResponse.refresh_token_expires_in;
                rtExpiresOn = reqTimestamp + rtExpiresIn;
            }
            cachedRefreshToken = (0, $d6bc4864bb049bc4$export$9095b5885dfa55cc)(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token, this.clientId, serverTokenResponse.foci, userAssertionHash, rtExpiresOn);
        }
        // appMetadata
        let cachedAppMetadata = null;
        if (serverTokenResponse.foci) cachedAppMetadata = {
            clientId: this.clientId,
            environment: env,
            familyId: serverTokenResponse.foci
        };
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata
        };
    }
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */ static async generateAuthenticationResult(cryptoObj, authority, cacheRecord, fromTokenCache, request, idTokenClaims, requestState, serverTokenResponse, requestId) {
        let accessToken = (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        let refreshOn;
        let familyId = (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        if (cacheRecord.accessToken) {
            /*
             * if the request object has `popKid` property, `signPopToken` will be set to false and
             * the token will be returned unsigned
             */ if (cacheRecord.accessToken.tokenType === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP && !request.popKid) {
                const popTokenGenerator = new (0, $ad4a320e462faf03$export$3dd8467151c83e3e)(cryptoObj);
                const { secret: secret, keyId: keyId } = cacheRecord.accessToken;
                if (!keyId) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$3c9338a50e294d1));
                accessToken = await popTokenGenerator.signPopToken(secret, keyId, request);
            } else accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
            extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
            if (cacheRecord.accessToken.refreshOn) refreshOn = new Date(Number(cacheRecord.accessToken.refreshOn) * 1000);
        }
        if (cacheRecord.appMetadata) familyId = cacheRecord.appMetadata.familyId === (0, $e6f7ad11e10d0573$export$978fe7ab5e74b539) ? (0, $e6f7ad11e10d0573$export$978fe7ab5e74b539) : "";
        const uid = idTokenClaims?.oid || idTokenClaims?.sub || "";
        const tid = idTokenClaims?.tid || "";
        // for hybrid + native bridge enablement, send back the native account Id
        if (serverTokenResponse?.spa_accountid && !!cacheRecord.account) cacheRecord.account.nativeAccountId = serverTokenResponse?.spa_accountid;
        const accountInfo = cacheRecord.account ? (0, $11db744279a82a57$export$452a054c78b83dad)(cacheRecord.account.getAccountInfo(), undefined, idTokenClaims, cacheRecord.idToken?.secret) : null;
        return {
            authority: authority.canonicalAuthority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: accountInfo,
            idToken: cacheRecord?.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: fromTokenCache,
            expiresOn: expiresOn,
            extExpiresOn: extExpiresOn,
            refreshOn: refreshOn,
            correlationId: request.correlationId,
            requestId: requestId || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
            familyId: familyId,
            tokenType: cacheRecord.accessToken?.tokenType || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
            state: requestState ? requestState.userRequestState : (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
            cloudGraphHostName: cacheRecord.account?.cloudGraphHostName || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
            msGraphHost: cacheRecord.account?.msGraphHost || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
            code: serverTokenResponse?.spa_code,
            fromNativeBroker: false
        };
    }
}
function $7b0e3b4066211abb$export$73b84062d58a1307(cacheStorage, authority, homeAccountId, base64Decode, idTokenClaims, clientInfo, environment, claimsTenantId, authCodePayload, nativeAccountId, logger) {
    logger?.verbose("setCachedAccount called");
    // Check if base account is already cached
    const accountKeys = cacheStorage.getAccountKeys();
    const baseAccountKey = accountKeys.find((accountKey)=>{
        return accountKey.startsWith(homeAccountId);
    });
    let cachedAccount = null;
    if (baseAccountKey) cachedAccount = cacheStorage.getAccount(baseAccountKey, logger);
    const baseAccount = cachedAccount || (0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).createAccount({
        homeAccountId: homeAccountId,
        idTokenClaims: idTokenClaims,
        clientInfo: clientInfo,
        environment: environment,
        cloudGraphHostName: authCodePayload?.cloud_graph_host_name,
        msGraphHost: authCodePayload?.msgraph_host,
        nativeAccountId: nativeAccountId
    }, authority, base64Decode);
    const tenantProfiles = baseAccount.tenantProfiles || [];
    const tenantId = claimsTenantId || baseAccount.realm;
    if (tenantId && !tenantProfiles.find((tenantProfile)=>{
        return tenantProfile.tenantId === tenantId;
    })) {
        const newTenantProfile = (0, $11db744279a82a57$export$924857724cb21ba4)(homeAccountId, baseAccount.localAccountId, tenantId, idTokenClaims);
        tenantProfiles.push(newTenantProfile);
    }
    baseAccount.tenantProfiles = tenantProfiles;
    return baseAccount;
}













/*! @azure/msal-common v14.16.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $4943b2aa5fffb8eb$export$620d3a93bf8b59fb(clientAssertion, clientId, tokenEndpoint) {
    if (typeof clientAssertion === "string") return clientAssertion;
    else {
        const config = {
            clientId: clientId,
            tokenEndpoint: tokenEndpoint
        };
        return clientAssertion(config);
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Oauth2.0 Authorization Code client
 * @internal
 */ class $746b08a1f35844e9$export$8538731fd397fb90 extends (0, $74fe0f6fcfa66614$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
        // Flag to indicate if client is for hybrid spa auth code redemption
        this.includeRedirectUri = true;
        this.oidcDefaultScopes = this.config.authOptions.authority.options.OIDCOptions?.defaultScopes;
    }
    /**
     * Creates the URL of the authorization request letting the user input credentials and consent to the
     * application. The URL target the /authorize endpoint of the authority configured in the
     * application object.
     *
     * Once the user inputs their credentials and consents, the authority will send a response to the redirect URI
     * sent in the request and should contain an authorization code, which can then be used to acquire tokens via
     * acquireToken(AuthorizationCodeRequest)
     * @param request
     */ async getAuthCodeUrl(request) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).GetAuthCodeUrl, request.correlationId);
        const queryString = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.createAuthCodeUrlQueryString.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthClientCreateQueryString, this.logger, this.performanceClient, request.correlationId)(request);
        return (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).appendQueryString(this.authority.authorizationEndpoint, queryString);
    }
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */ async acquireToken(request, authCodePayload) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthClientAcquireToken, request.correlationId);
        if (!request.code) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$4ac9fb1f531eded7));
        const reqTimestamp = (0, $ac7fb5ae1cae46f5$export$ae62599a119ac50a)();
        const response = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(this.authority, request);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $e6f7ad11e10d0573$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $7b0e3b4066211abb$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin, this.performanceClient);
        // Validate response. This function throws a server error if an error is returned by the server.
        responseHandler.validateTokenResponse(response.body);
        return (0, $ae433257996980ce$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, authCodePayload, undefined, undefined, undefined, requestId);
    }
    /**
     * Handles the hash fragment response from public client code request. Returns a code response used by
     * the client to exchange for a token in acquireToken.
     * @param hashFragment
     */ handleFragmentResponse(serverParams, cachedState) {
        // Handle responses.
        const responseHandler = new (0, $7b0e3b4066211abb$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, null, null);
        // Get code response
        responseHandler.validateServerAuthorizationCodeResponse(serverParams, cachedState);
        // throw when there is no auth code in the response
        if (!serverParams.code) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$93625fc864d26bba));
        return serverParams;
    }
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */ getLogoutUri(logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$9eb2eeb401492d88));
        const queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).appendQueryString(this.authority.endSessionEndpoint, queryString);
    }
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */ async executeTokenRequest(authority, request) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, request.correlationId);
        const queryParametersString = this.createTokenQueryParameters(request);
        const endpoint = (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        let ccsCredential = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $40ea3b2fe13bb092$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCredential = {
                credential: `${clientInfo.uid}${(0, $e6f7ad11e10d0573$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose("Could not parse client info for CCS Header: " + e);
        }
        const headers = this.createTokenRequestHeaders(ccsCredential || request.ccsCredential);
        const thumbprint = {
            clientId: request.tokenBodyParameters?.clientId || this.config.authOptions.clientId,
            authority: authority.canonicalAuthority,
            scopes: request.scopes,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid
        };
        return (0, $ae433257996980ce$export$e4feded94d9adb18)(this.executePostToTokenEndpoint.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorizationCodeClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorizationCodeClientExecutePostToTokenEndpoint);
    }
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */ async createTokenRequestBody(request) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, request.correlationId);
        const parameterBuilder = new (0, $e395f42fea42ad84$export$882078dd8a9e0bfa)(request.correlationId, this.performanceClient);
        parameterBuilder.addClientId(request.embeddedClientId || request.tokenBodyParameters?.[0, $77544fccca6f740d$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        /*
         * For hybrid spa flow, there will be a code but no verifier
         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
         */ if (!this.includeRedirectUri) // Just validate
        (0, $4e2861e8184d6622$export$9800b929b6984365).validateRedirectUri(request.redirectUri);
        else // Validate and include redirect uri
        parameterBuilder.addRedirectUri(request.redirectUri);
        // Add scope array, parameter builder will add default scopes and dedupe
        parameterBuilder.addScopes(request.scopes, true, this.oidcDefaultScopes);
        // add code: user set, not validated
        parameterBuilder.addAuthorizationCode(request.code);
        // Add library metadata
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
        parameterBuilder.addThrottling();
        if (this.serverTelemetryManager && !(0, $daec59b36bfd07ff$export$25afa7198c2ed9b9)(this.config)) parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
        // add code_verifier if passed
        if (request.codeVerifier) parameterBuilder.addCodeVerifier(request.codeVerifier);
        if (this.config.clientCredentials.clientSecret) parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            parameterBuilder.addClientAssertion(await (0, $4943b2aa5fffb8eb$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
        }
        parameterBuilder.addGrantType((0, $e6f7ad11e10d0573$export$ce68f19b50b39c0b).AUTHORIZATION_CODE_GRANT);
        parameterBuilder.addClientInfo();
        if (request.authenticationScheme === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $ad4a320e462faf03$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $ae433257996980ce$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            parameterBuilder.addPopToken(reqCnfData);
        } else if (request.authenticationScheme === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) parameterBuilder.addSshJwk(request.sshJwk);
            else throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$8fbed44b22d9136f));
        }
        if (!(0, $2b520034dd7719a3$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        let ccsCred = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $40ea3b2fe13bb092$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCred = {
                credential: `${clientInfo.uid}${(0, $e6f7ad11e10d0573$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose("Could not parse client info for CCS Header: " + e);
        }
        else ccsCred = request.ccsCredential;
        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
        if (this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $40ea3b2fe13bb092$export$63508a6d6b7dbe07)(ccsCred.credential);
                    parameterBuilder.addCcsOid(clientInfo);
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).UPN:
                parameterBuilder.addCcsUpn(ccsCred.credential);
                break;
        }
        if (request.embeddedClientId) parameterBuilder.addBrokerParameters({
            brokerClientId: this.config.authOptions.clientId,
            brokerRedirectUri: this.config.authOptions.redirectUri
        });
        if (request.tokenBodyParameters) parameterBuilder.addExtraQueryParameters(request.tokenBodyParameters);
        // Add hybrid spa parameters if not already provided
        if (request.enableSpaAuthorizationCode && (!request.tokenBodyParameters || !request.tokenBodyParameters[0, $77544fccca6f740d$export$f58b98a40c1faa68])) parameterBuilder.addExtraQueryParameters({
            [(0, $77544fccca6f740d$export$f58b98a40c1faa68)]: "1"
        });
        return parameterBuilder.createQueryString();
    }
    /**
     * This API validates the `AuthorizationCodeUrlRequest` and creates a URL
     * @param request
     */ async createAuthCodeUrlQueryString(request) {
        // generate the correlationId if not set by the user and add
        const correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthClientCreateQueryString, correlationId);
        const parameterBuilder = new (0, $e395f42fea42ad84$export$882078dd8a9e0bfa)(correlationId, this.performanceClient);
        parameterBuilder.addClientId(request.embeddedClientId || request.extraQueryParameters?.[0, $77544fccca6f740d$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        const requestScopes = [
            ...request.scopes || [],
            ...request.extraScopesToConsent || []
        ];
        parameterBuilder.addScopes(requestScopes, true, this.oidcDefaultScopes);
        // validate the redirectUri (to be a non null value)
        parameterBuilder.addRedirectUri(request.redirectUri);
        parameterBuilder.addCorrelationId(correlationId);
        // add response_mode. If not passed in it defaults to query.
        parameterBuilder.addResponseMode(request.responseMode);
        // add response_type = code
        parameterBuilder.addResponseTypeCode();
        // add library info parameters
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        if (!(0, $daec59b36bfd07ff$export$25afa7198c2ed9b9)(this.config)) parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
        // add client_info=1
        parameterBuilder.addClientInfo();
        if (request.codeChallenge && request.codeChallengeMethod) parameterBuilder.addCodeChallengeParams(request.codeChallenge, request.codeChallengeMethod);
        if (request.prompt) parameterBuilder.addPrompt(request.prompt);
        if (request.domainHint) parameterBuilder.addDomainHint(request.domainHint);
        // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
        if (request.prompt !== (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).SELECT_ACCOUNT) {
            // AAD will throw if prompt=select_account is passed with an account hint
            if (request.sid && request.prompt === (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).NONE) {
                // SessionID is only used in silent calls
                this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from request");
                parameterBuilder.addSid(request.sid);
            } else if (request.account) {
                const accountSid = this.extractAccountSid(request.account);
                let accountLoginHintClaim = this.extractLoginHint(request.account);
                if (accountLoginHintClaim && request.domainHint) {
                    this.logger.warning(`AuthorizationCodeClient.createAuthCodeUrlQueryString: "domainHint" param is set, skipping opaque "login_hint" claim. Please consider not passing domainHint`);
                    accountLoginHintClaim = null;
                }
                // If login_hint claim is present, use it over sid/username
                if (accountLoginHintClaim) {
                    this.logger.verbose("createAuthCodeUrlQueryString: login_hint claim present on account");
                    parameterBuilder.addLoginHint(accountLoginHintClaim);
                    try {
                        const clientInfo = (0, $40ea3b2fe13bb092$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                        parameterBuilder.addCcsOid(clientInfo);
                    } catch (e) {
                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                    }
                } else if (accountSid && request.prompt === (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).NONE) {
                    /*
                     * If account and loginHint are provided, we will check account first for sid before adding loginHint
                     * SessionId is only used in silent calls
                     */ this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from account");
                    parameterBuilder.addSid(accountSid);
                    try {
                        const clientInfo = (0, $40ea3b2fe13bb092$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                        parameterBuilder.addCcsOid(clientInfo);
                    } catch (e) {
                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                    }
                } else if (request.loginHint) {
                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from request");
                    parameterBuilder.addLoginHint(request.loginHint);
                    parameterBuilder.addCcsUpn(request.loginHint);
                } else if (request.account.username) {
                    // Fallback to account username if provided
                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from account");
                    parameterBuilder.addLoginHint(request.account.username);
                    try {
                        const clientInfo = (0, $40ea3b2fe13bb092$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                        parameterBuilder.addCcsOid(clientInfo);
                    } catch (e) {
                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                    }
                }
            } else if (request.loginHint) {
                this.logger.verbose("createAuthCodeUrlQueryString: No account, adding login_hint from request");
                parameterBuilder.addLoginHint(request.loginHint);
                parameterBuilder.addCcsUpn(request.loginHint);
            }
        } else this.logger.verbose("createAuthCodeUrlQueryString: Prompt is select_account, ignoring account hints");
        if (request.nonce) parameterBuilder.addNonce(request.nonce);
        if (request.state) parameterBuilder.addState(request.state);
        if (request.claims || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        if (request.embeddedClientId) parameterBuilder.addBrokerParameters({
            brokerClientId: this.config.authOptions.clientId,
            brokerRedirectUri: this.config.authOptions.redirectUri
        });
        this.addExtraQueryParams(request, parameterBuilder);
        if (request.nativeBroker) {
            // signal ests that this is a WAM call
            parameterBuilder.addNativeBroker();
            // pass the req_cnf for POP
            if (request.authenticationScheme === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP) {
                const popTokenGenerator = new (0, $ad4a320e462faf03$export$3dd8467151c83e3e)(this.cryptoUtils);
                // req_cnf is always sent as a string for SPAs
                let reqCnfData;
                if (!request.popKid) {
                    const generatedReqCnfData = await (0, $ae433257996980ce$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                    reqCnfData = generatedReqCnfData.reqCnfString;
                } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
                parameterBuilder.addPopToken(reqCnfData);
            }
        }
        return parameterBuilder.createQueryString();
    }
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */ createLogoutUrlQueryString(request) {
        const parameterBuilder = new (0, $e395f42fea42ad84$export$882078dd8a9e0bfa)(request.correlationId, this.performanceClient);
        if (request.postLogoutRedirectUri) parameterBuilder.addPostLogoutRedirectUri(request.postLogoutRedirectUri);
        if (request.correlationId) parameterBuilder.addCorrelationId(request.correlationId);
        if (request.idTokenHint) parameterBuilder.addIdTokenHint(request.idTokenHint);
        if (request.state) parameterBuilder.addState(request.state);
        if (request.logoutHint) parameterBuilder.addLogoutHint(request.logoutHint);
        this.addExtraQueryParams(request, parameterBuilder);
        return parameterBuilder.createQueryString();
    }
    addExtraQueryParams(request, parameterBuilder) {
        const hasRequestInstanceAware = request.extraQueryParameters && request.extraQueryParameters.hasOwnProperty("instance_aware");
        // Set instance_aware flag if config auth param is set
        if (!hasRequestInstanceAware && this.config.authOptions.instanceAware) {
            request.extraQueryParameters = request.extraQueryParameters || {};
            request.extraQueryParameters["instance_aware"] = "true";
        }
        if (request.extraQueryParameters) parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
    }
    /**
     * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
     * @param account
     */ extractAccountSid(account) {
        return account.idTokenClaims?.sid || null;
    }
    extractLoginHint(account) {
        return account.idTokenClaims?.login_hint || null;
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ /*! @azure/msal-common v14.16.0 2024-11-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $579e3708bb5512e2$var$skuGroupSeparator = ",";
const $579e3708bb5512e2$var$skuValueSeparator = "|";
function $579e3708bb5512e2$var$makeExtraSkuString(params) {
    const { skus: skus, libraryName: libraryName, libraryVersion: libraryVersion, extensionName: extensionName, extensionVersion: extensionVersion } = params;
    const skuMap = new Map([
        [
            0,
            [
                libraryName,
                libraryVersion
            ]
        ],
        [
            2,
            [
                extensionName,
                extensionVersion
            ]
        ]
    ]);
    let skuArr = [];
    if (skus?.length) {
        skuArr = skus.split($579e3708bb5512e2$var$skuGroupSeparator);
        // Ignore invalid input sku param
        if (skuArr.length < 4) return skus;
    } else skuArr = Array.from({
        length: 4
    }, ()=>$579e3708bb5512e2$var$skuValueSeparator);
    skuMap.forEach((value, key)=>{
        if (value.length === 2 && value[0]?.length && value[1]?.length) $579e3708bb5512e2$var$setSku({
            skuArr: skuArr,
            index: key,
            skuName: value[0],
            skuVersion: value[1]
        });
    });
    return skuArr.join($579e3708bb5512e2$var$skuGroupSeparator);
}
function $579e3708bb5512e2$var$setSku(params) {
    const { skuArr: skuArr, index: index, skuName: skuName, skuVersion: skuVersion } = params;
    if (index >= skuArr.length) return;
    skuArr[index] = [
        skuName,
        skuVersion
    ].join($579e3708bb5512e2$var$skuValueSeparator);
}
/** @internal */ class $579e3708bb5512e2$export$bddbbc43a3ca9c53 {
    constructor(telemetryRequest, cacheManager){
        this.cacheOutcome = (0, $e6f7ad11e10d0573$export$aa4af185ea049f6b).NOT_APPLICABLE;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        this.wrapperVer = telemetryRequest.wrapperVer || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        this.telemetryCacheKey = (0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).CACHE_KEY + (0, $e6f7ad11e10d0573$export$520854da2ba5d734).CACHE_KEY_SEPARATOR + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */ generateCurrentRequestHeaderValue() {
        const request = `${this.apiId}${(0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).VALUE_SEPARATOR}${this.cacheOutcome}`;
        const platformFieldsArr = [
            this.wrapperSKU,
            this.wrapperVer
        ];
        const nativeBrokerErrorCode = this.getNativeBrokerErrorCode();
        if (nativeBrokerErrorCode?.length) platformFieldsArr.push(`broker_error=${nativeBrokerErrorCode}`);
        const platformFields = platformFieldsArr.join((0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const regionDiscoveryFields = this.getRegionDiscoveryFields();
        const requestWithRegionDiscoveryFields = [
            request,
            regionDiscoveryFields
        ].join((0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            requestWithRegionDiscoveryFields,
            platformFields
        ].join((0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    }
    /**
     * API to add MSER Telemetry for the last failed request
     */ generateLastRequestHeaderValue() {
        const lastRequests = this.getLastRequests();
        const maxErrors = $579e3708bb5512e2$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join((0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const errors = lastRequests.errors.slice(0, maxErrors).join((0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        const overflow = maxErrors < errorCount ? (0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).OVERFLOW_TRUE : (0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).OVERFLOW_FALSE;
        const platformFields = [
            errorCount,
            overflow
        ].join((0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            lastRequests.cacheHits,
            failedRequests,
            errors,
            platformFields
        ].join((0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    }
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */ cacheFailedRequest(error) {
        const lastRequests = this.getLastRequests();
        if (lastRequests.errors.length >= (0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).MAX_CACHED_ERRORS) {
            // Remove a cached error to make room, first in first out
            lastRequests.failedRequests.shift(); // apiId
            lastRequests.failedRequests.shift(); // correlationId
            lastRequests.errors.shift();
        }
        lastRequests.failedRequests.push(this.apiId, this.correlationId);
        if (error instanceof Error && !!error && error.toString()) {
            if (error instanceof (0, $40da14d5d49dd285$export$145273558d58e0ac)) {
                if (error.subError) lastRequests.errors.push(error.subError);
                else if (error.errorCode) lastRequests.errors.push(error.errorCode);
                else lastRequests.errors.push(error.toString());
            } else lastRequests.errors.push(error.toString());
        } else lastRequests.errors.push((0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).UNKNOWN_ERROR);
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
        return;
    }
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */ incrementCacheHits() {
        const lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
        return lastRequests.cacheHits;
    }
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */ getLastRequests() {
        const initialValue = {
            failedRequests: [],
            errors: [],
            cacheHits: 0
        };
        const lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey);
        return lastRequests || initialValue;
    }
    /**
     * Remove server telemetry cache entry
     */ clearTelemetryCache() {
        const lastRequests = this.getLastRequests();
        const numErrorsFlushed = $579e3708bb5512e2$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) // All errors were sent on last request, clear Telemetry cache
        this.cacheManager.removeItem(this.telemetryCacheKey);
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            const serverTelemEntity = {
                failedRequests: lastRequests.failedRequests.slice(numErrorsFlushed * 2),
                errors: lastRequests.errors.slice(numErrorsFlushed),
                cacheHits: 0
            };
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity);
        }
    }
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */ static maxErrorsToSend(serverTelemetryEntity) {
        let i;
        let maxErrors = 0;
        let dataSize = 0;
        const errorCount = serverTelemetryEntity.errors.length;
        for(i = 0; i < errorCount; i++){
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            const apiId = serverTelemetryEntity.failedRequests[2 * i] || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
            const correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
            const errorCode = serverTelemetryEntity.errors[i] || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < (0, $e6f7ad11e10d0573$export$30fa4ad28fb9feeb).MAX_LAST_HEADER_BYTES) // Adding this entry to the header would still keep header size below the limit
            maxErrors += 1;
            else break;
        }
        return maxErrors;
    }
    /**
     * Get the region discovery fields
     *
     * @returns string
     */ getRegionDiscoveryFields() {
        const regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionSource || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionOutcome || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING);
        return regionDiscoveryFields.join(",");
    }
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */ updateRegionDiscoveryMetadata(regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    }
    /**
     * Set cache outcome
     */ setCacheOutcome(cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    }
    setNativeBrokerErrorCode(errorCode) {
        const lastRequests = this.getLastRequests();
        lastRequests.nativeBrokerErrorCode = errorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
    }
    getNativeBrokerErrorCode() {
        return this.getLastRequests().nativeBrokerErrorCode;
    }
    clearNativeBrokerErrorCode() {
        const lastRequests = this.getLastRequests();
        delete lastRequests.nativeBrokerErrorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
    }
    static makeExtraSkuString(params) {
        return $579e3708bb5512e2$var$makeExtraSkuString(params);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $256b2ddbb48bee4b$export$d858565f81c03f1f {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId){
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.nativeMessageHandler = nativeMessageHandler;
        this.correlationId = correlationId || (0, $a65ce7794137937d$export$6ef0355fa80a5278)();
        this.logger = logger.clone((0, $e195f599725a9f25$export$a0a689e4294b9880).MSAL_SKU, (0, $d287cb496a16a30d$export$83d89fbfd8236492), this.correlationId);
        this.performanceClient = performanceClient;
    }
    async clearCacheOnLogout(account) {
        if (account) {
            if ((0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).accountInfoIsEqual(account, this.browserStorage.getActiveAccount(), false)) {
                this.logger.verbose("Setting active account to null");
                this.browserStorage.setActiveAccount(null);
            }
            // Clear given account.
            try {
                await this.browserStorage.removeAccount((0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).generateAccountCacheKey(account));
                this.logger.verbose("Cleared cache items belonging to the account provided in the logout request.");
            } catch (error) {
                this.logger.error("Account provided in logout request was not found. Local cache unchanged.");
            }
        } else try {
            this.logger.verbose("No account provided in logout request, clearing all cache items.", this.correlationId);
            // Clear all accounts and tokens
            await this.browserStorage.clear();
            // Clear any stray keys from IndexedDB
            await this.browserCrypto.clearKeystore();
        } catch (e) {
            this.logger.error("Attempted to clear all MSAL cache items and failed. Local cache unchanged.");
        }
    }
    /**
     *
     * Use to get the redirect uri configured in MSAL or null.
     * @param requestRedirectUri
     * @returns Redirect URL
     *
     */ getRedirectUri(requestRedirectUri) {
        this.logger.verbose("getRedirectUri called");
        const redirectUri = requestRedirectUri || this.config.auth.redirectUri;
        return (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).getAbsoluteUrl(redirectUri, (0, $d618406b813d26cc$export$1204531fbbf6ecde)());
    }
    /**
     *
     * @param apiId
     * @param correlationId
     * @param forceRefresh
     */ initializeServerTelemetryManager(apiId, forceRefresh) {
        this.logger.verbose("initializeServerTelemetryManager called");
        const telemetryPayload = {
            clientId: this.config.auth.clientId,
            correlationId: this.correlationId,
            apiId: apiId,
            forceRefresh: forceRefresh || false,
            wrapperSKU: this.browserStorage.getWrapperMetadata()[0],
            wrapperVer: this.browserStorage.getWrapperMetadata()[1]
        };
        return new (0, $579e3708bb5512e2$export$bddbbc43a3ca9c53)(telemetryPayload, this.browserStorage);
    }
    /**
     * Used to get a discovered version of the default authority.
     * @param params {
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async getDiscoveredAuthority(params) {
        const { account: account } = params;
        const instanceAwareEQ = params.requestExtraQueryParameters && params.requestExtraQueryParameters.hasOwnProperty("instance_aware") ? params.requestExtraQueryParameters["instance_aware"] : undefined;
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
        const authorityOptions = {
            protocolMode: this.config.auth.protocolMode,
            OIDCOptions: this.config.auth.OIDCOptions,
            knownAuthorities: this.config.auth.knownAuthorities,
            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
            authorityMetadata: this.config.auth.authorityMetadata,
            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
        };
        // build authority string based on auth params, precedence - azureCloudInstance + tenant >> authority
        const resolvedAuthority = params.requestAuthority || this.config.auth.authority;
        const resolvedInstanceAware = instanceAwareEQ?.length ? instanceAwareEQ === "true" : this.config.auth.instanceAware;
        const userAuthority = account && resolvedInstanceAware ? this.config.auth.authority.replace((0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).getDomainFromUrl(resolvedAuthority), account.environment) : resolvedAuthority;
        // fall back to the authority from config
        const builtAuthority = (0, $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c).generateAuthority(userAuthority, params.requestAzureCloudOptions || this.config.auth.azureCloudOptions);
        const discoveredAuthority = await (0, $ae433257996980ce$export$e4feded94d9adb18)((0, $761e45da09259d0f$exports).createDiscoveredInstance, (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, this.logger, this.performanceClient, this.correlationId)(builtAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger, this.correlationId, this.performanceClient);
        if (account && !discoveredAuthority.isAlias(account.environment)) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$exports).authorityMismatch);
        return discoveredAuthority;
    }
}





/*! @azure/msal-browser v3.27.0 2024-11-05 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Constant byte array length
const $d3f16216f8414ced$var$RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * This file defines APIs to generate PKCE codes and code verifiers.
 */ /**
 * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
 */ async function $d3f16216f8414ced$export$91d5e5a023803853(performanceClient, logger, correlationId) {
    performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).GeneratePkceCodes, correlationId);
    const codeVerifier = (0, $ae433257996980ce$export$468cda29b159ee5d)($d3f16216f8414ced$var$generateCodeVerifier, (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).GenerateCodeVerifier, logger, performanceClient, correlationId)(performanceClient, logger, correlationId);
    const codeChallenge = await (0, $ae433257996980ce$export$e4feded94d9adb18)($d3f16216f8414ced$var$generateCodeChallengeFromVerifier, (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).GenerateCodeChallengeFromVerifier, logger, performanceClient, correlationId)(codeVerifier, performanceClient, logger, correlationId);
    return {
        verifier: codeVerifier,
        challenge: codeChallenge
    };
}
/**
 * Generates a random 32 byte buffer and returns the base64
 * encoded string to be used as a PKCE Code Verifier
 */ function $d3f16216f8414ced$var$generateCodeVerifier(performanceClient, logger, correlationId) {
    try {
        // Generate random values as utf-8
        const buffer = new Uint8Array($d3f16216f8414ced$var$RANDOM_BYTE_ARR_LENGTH);
        (0, $ae433257996980ce$export$468cda29b159ee5d)((0, $a65ce7794137937d$export$960b9ff25e7d4257), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).GetRandomValues, logger, performanceClient, correlationId)(buffer);
        // encode verifier as base64
        const pkceCodeVerifierB64 = (0, $be65c31a50210a3d$export$84f5a428c7153a69)(buffer);
        return pkceCodeVerifierB64;
    } catch (e) {
        throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$ee549107fa376fc1));
    }
}
/**
 * Creates a base64 encoded PKCE Code Challenge string from the
 * hash created from the PKCE Code Verifier supplied
 */ async function $d3f16216f8414ced$var$generateCodeChallengeFromVerifier(pkceCodeVerifier, performanceClient, logger, correlationId) {
    performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).GenerateCodeChallengeFromVerifier, correlationId);
    try {
        // hashed verifier
        const pkceHashedCodeVerifier = await (0, $ae433257996980ce$export$e4feded94d9adb18)((0, $a65ce7794137937d$export$52caff7bddbaf316), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).Sha256Digest, logger, performanceClient, correlationId)(pkceCodeVerifier, performanceClient, correlationId);
        // encode hash as base64
        return (0, $be65c31a50210a3d$export$84f5a428c7153a69)(new Uint8Array(pkceHashedCodeVerifier));
    } catch (e) {
        throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$ee549107fa376fc1));
    }
}



/*! @azure/msal-browser v3.27.0 2024-11-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Initializer function for all request APIs
 * @param request
 */ async function $5f86e728968c03f1$export$8e461fcf1fd6910b(request, config, performanceClient, logger) {
    performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).InitializeBaseRequest, request.correlationId);
    const authority = request.authority || config.auth.authority;
    const scopes = [
        ...request && request.scopes || []
    ];
    const validatedRequest = {
        ...request,
        correlationId: request.correlationId,
        authority: authority,
        scopes: scopes
    };
    // Set authenticationScheme to BEARER if not explicitly set in the request
    if (!validatedRequest.authenticationScheme) {
        validatedRequest.authenticationScheme = (0, $e6f7ad11e10d0573$export$901491a717da2ba5).BEARER;
        logger.verbose('Authentication Scheme wasn\'t explicitly set in request, defaulting to "Bearer" request');
    } else {
        if (validatedRequest.authenticationScheme === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).SSH) {
            if (!request.sshJwk) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$exports).missingSshJwk);
            if (!request.sshKid) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$exports).missingSshKid);
        }
        logger.verbose(`Authentication Scheme set to "${validatedRequest.authenticationScheme}" as configured in Auth request`);
    }
    // Set requested claims hash if claims-based caching is enabled and claims were requested
    if (config.cache.claimsBasedCachingEnabled && request.claims && // Checks for empty stringified object "{}" which doesn't qualify as requested claims
    !(0, $2b520034dd7719a3$export$ecc754f99843e759).isEmptyObj(request.claims)) validatedRequest.requestedClaimsHash = await (0, $a65ce7794137937d$export$9169be2e06c9c165)(request.claims);
    return validatedRequest;
}
async function $5f86e728968c03f1$export$4c8aa78c426811d4(request, account, config, performanceClient, logger) {
    performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).InitializeSilentRequest, request.correlationId);
    const baseRequest = await (0, $ae433257996980ce$export$e4feded94d9adb18)($5f86e728968c03f1$export$8e461fcf1fd6910b, (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).InitializeBaseRequest, logger, performanceClient, request.correlationId)(request, config, performanceClient, logger);
    return {
        ...request,
        ...baseRequest,
        account: account,
        forceRefresh: request.forceRefresh || false
    };
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */ class $aed111b4f4b5e49c$export$fa9179cade3eb05a extends (0, $256b2ddbb48bee4b$export$d858565f81c03f1f) {
    /**
     * Generates an auth code request tied to the url request.
     * @param request
     */ async initializeAuthorizationCodeRequest(request) {
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, this.correlationId);
        const generatedPkceParams = await (0, $ae433257996980ce$export$e4feded94d9adb18)((0, $d3f16216f8414ced$export$91d5e5a023803853), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, this.correlationId)(this.performanceClient, this.logger, this.correlationId);
        const authCodeRequest = {
            ...request,
            redirectUri: request.redirectUri,
            code: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
            codeVerifier: generatedPkceParams.verifier
        };
        request.codeChallenge = generatedPkceParams.challenge;
        request.codeChallengeMethod = (0, $e6f7ad11e10d0573$export$a002182e51710d39).S256_CODE_CHALLENGE_METHOD;
        return authCodeRequest;
    }
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */ initializeLogoutRequest(logoutRequest) {
        this.logger.verbose("initializeLogoutRequest called", logoutRequest?.correlationId);
        const validLogoutRequest = {
            correlationId: this.correlationId || (0, $a65ce7794137937d$export$6ef0355fa80a5278)(),
            ...logoutRequest
        };
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */ if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    const logoutHint = this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("Setting logoutHint to login_hint ID Token Claim value for the account provided");
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                } else this.logger.verbose("logoutHint was not set and account was not passed into logout request, logoutHint will not be set");
            } else this.logger.verbose("logoutHint has already been set in logoutRequest");
        } else this.logger.verbose("logoutHint will not be set since no logout request was configured");
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */ if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to uri set on logout request", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, (0, $d618406b813d26cc$export$1204531fbbf6ecde)());
            } else if (this.config.auth.postLogoutRedirectUri === null) this.logger.verbose("postLogoutRedirectUri configured as null and no uri set on request, not passing post logout redirect", validLogoutRequest.correlationId);
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to configured uri", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, (0, $d618406b813d26cc$export$1204531fbbf6ecde)());
            } else {
                this.logger.verbose("Setting postLogoutRedirectUri to current page", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).getAbsoluteUrl((0, $d618406b813d26cc$export$1204531fbbf6ecde)(), (0, $d618406b813d26cc$export$1204531fbbf6ecde)());
            }
        } else this.logger.verbose("postLogoutRedirectUri passed as null, not setting post logout redirect uri", validLogoutRequest.correlationId);
        return validLogoutRequest;
    }
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */ getLogoutHintFromIdTokenClaims(account) {
        const idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) return idTokenClaims.login_hint;
            else this.logger.verbose("The ID Token Claims tied to the provided account do not contain a login_hint claim, logoutHint will not be added to logout request");
        } else this.logger.verbose("The provided account does not contain ID Token Claims, logoutHint will not be added to logout request");
        return null;
    }
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createAuthCodeClient(params) {
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.correlationId);
        // Create auth module.
        const clientConfig = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)(params);
        return new (0, $746b08a1f35844e9$export$8538731fd397fb90)(clientConfig, this.performanceClient);
    }
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: boolean;
     *         account?: AccountInfo;
     *        }
     */ async getClientConfiguration(params) {
        const { serverTelemetryManager: serverTelemetryManager, requestAuthority: requestAuthority, requestAzureCloudOptions: requestAzureCloudOptions, requestExtraQueryParameters: requestExtraQueryParameters, account: account } = params;
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
        const discoveredAuthority = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, this.correlationId)({
            requestAuthority: requestAuthority,
            requestAzureCloudOptions: requestAzureCloudOptions,
            requestExtraQueryParameters: requestExtraQueryParameters,
            account: account
        });
        const logger = this.config.system.loggerOptions;
        return {
            authOptions: {
                clientId: this.config.auth.clientId,
                authority: discoveredAuthority,
                clientCapabilities: this.config.auth.clientCapabilities,
                redirectUri: this.config.auth.redirectUri
            },
            systemOptions: {
                tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                preventCorsPreflight: true
            },
            loggerOptions: {
                loggerCallback: logger.loggerCallback,
                piiLoggingEnabled: logger.piiLoggingEnabled,
                logLevel: logger.logLevel,
                correlationId: this.correlationId
            },
            cacheOptions: {
                claimsBasedCachingEnabled: this.config.cache.claimsBasedCachingEnabled
            },
            cryptoInterface: this.browserCrypto,
            networkInterface: this.networkClient,
            storageInterface: this.browserStorage,
            serverTelemetryManager: serverTelemetryManager,
            libraryInfo: {
                sku: (0, $e195f599725a9f25$export$a0a689e4294b9880).MSAL_SKU,
                version: (0, $d287cb496a16a30d$export$83d89fbfd8236492),
                cpu: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
                os: (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING
            },
            telemetry: this.config.telemetry
        };
    }
    /**
     * Helper to initialize required request parameters for interactive APIs and ssoSilent()
     * @param request
     * @param interactionType
     */ async initializeAuthorizationRequest(request, interactionType) {
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.correlationId);
        const redirectUri = this.getRedirectUri(request.redirectUri);
        const browserState = {
            interactionType: interactionType
        };
        const state = (0, $9523def209bc6e1a$export$871e33217042c65e).setRequestState(this.browserCrypto, request && request.state || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING, browserState);
        const baseRequest = await (0, $ae433257996980ce$export$e4feded94d9adb18)((0, $5f86e728968c03f1$export$8e461fcf1fd6910b), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).InitializeBaseRequest, this.logger, this.performanceClient, this.correlationId)({
            ...request,
            correlationId: this.correlationId
        }, this.config, this.performanceClient, this.logger);
        const validatedRequest = {
            ...baseRequest,
            redirectUri: redirectUri,
            state: state,
            nonce: request.nonce || (0, $a65ce7794137937d$export$6ef0355fa80a5278)(),
            responseMode: this.config.auth.OIDCOptions.serverResponseType
        };
        const account = request.account || this.browserStorage.getActiveAccount();
        if (account) {
            this.logger.verbose("Setting validated request account", this.correlationId);
            this.logger.verbosePii(`Setting validated request account: ${account.homeAccountId}`, this.correlationId);
            validatedRequest.account = account;
        }
        // Check for ADAL/MSAL v1 SSO
        if (!validatedRequest.loginHint && !account) {
            const legacyLoginHint = this.browserStorage.getLegacyLoginHint();
            if (legacyLoginHint) validatedRequest.loginHint = legacyLoginHint;
        }
        return validatedRequest;
    }
}





/*! @azure/msal-browser v3.27.0 2024-11-05 */ 


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 

/*! @azure/msal-browser v3.27.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $2bb12ad8376a640d$export$fbe5ac8608048ea9 = "ContentError";
const $2bb12ad8376a640d$export$966ec8558e4d7922 = "user_switch";


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Status Codes that can be thrown by WAM
const $e928a4c2a2d5459f$export$e0aac30e542b316c = "USER_INTERACTION_REQUIRED";
const $e928a4c2a2d5459f$export$bec5e49cc27c5c10 = "USER_CANCEL";
const $e928a4c2a2d5459f$export$3c68b4973c91ba = "NO_NETWORK";
const $e928a4c2a2d5459f$export$b17f0b3cc10a2593 = "PERSISTENT_ERROR";
const $e928a4c2a2d5459f$export$8cd212c10b4124d2 = "DISABLED";
const $e928a4c2a2d5459f$export$f4c2bddc98c93ffc = "ACCOUNT_UNAVAILABLE";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $928aa5124c222013$var$INVALID_METHOD_ERROR = -2147186943;
const $928aa5124c222013$export$9a1233b0d52ed7cd = {
    [(0, $2bb12ad8376a640d$export$966ec8558e4d7922)]: "User attempted to switch accounts in the native broker, which is not allowed. All new accounts must sign-in through the standard web flow first, please try again."
};
class $928aa5124c222013$export$4b8a4f6256e840ab extends (0, $40da14d5d49dd285$export$145273558d58e0ac) {
    constructor(errorCode, description, ext){
        super(errorCode, description);
        Object.setPrototypeOf(this, $928aa5124c222013$export$4b8a4f6256e840ab.prototype);
        this.name = "NativeAuthError";
        this.ext = ext;
    }
}
/**
 * These errors should result in a fallback to the 'standard' browser based auth flow.
 */ function $928aa5124c222013$export$f21e42e365baeb50(error) {
    if (error.ext && error.ext.status && (error.ext.status === (0, $e928a4c2a2d5459f$export$b17f0b3cc10a2593) || error.ext.status === (0, $e928a4c2a2d5459f$export$8cd212c10b4124d2))) return true;
    if (error.ext && error.ext.error && error.ext.error === $928aa5124c222013$var$INVALID_METHOD_ERROR) return true;
    switch(error.errorCode){
        case 0, $2bb12ad8376a640d$export$fbe5ac8608048ea9:
            return true;
        default:
            return false;
    }
}
/**
 * Create the appropriate error object based on the WAM status code.
 * @param code
 * @param description
 * @param ext
 * @returns
 */ function $928aa5124c222013$export$9154414ec87d187b(code, description, ext) {
    if (ext && ext.status) switch(ext.status){
        case 0, $e928a4c2a2d5459f$export$f4c2bddc98c93ffc:
            return (0, $b3acdb9c5805a543$export$8f7a741750c16535)((0, $0da9c4dbbd48f7df$exports).nativeAccountUnavailable);
        case 0, $e928a4c2a2d5459f$export$e0aac30e542b316c:
            return new (0, $b3acdb9c5805a543$export$6ba3e818c6bc76ba)(code, description);
        case 0, $e928a4c2a2d5459f$export$bec5e49cc27c5c10:
            return (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$6bae303c5e922702));
        case 0, $e928a4c2a2d5459f$export$3c68b4973c91ba:
            return (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$31ae862f18c3b2b7));
    }
    return new $928aa5124c222013$export$4b8a4f6256e840ab(code, $928aa5124c222013$export$9a1233b0d52ed7cd[code] || description, ext);
}



/*! @azure/msal-browser v3.27.0 2024-11-05 */ 
/*! @azure/msal-common v14.16.0 2024-11-05 */ 

/*! @azure/msal-common v14.16.0 2024-11-05 */ 






















'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $e03fe61a6af8489a$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS = 300; // 5 Minutes
/**
 * OAuth2.0 refresh token client
 * @internal
 */ class $e03fe61a6af8489a$export$9cb096b89b92d8a8 extends (0, $74fe0f6fcfa66614$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
    }
    async acquireToken(request) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, request.correlationId);
        const reqTimestamp = (0, $ac7fb5ae1cae46f5$export$ae62599a119ac50a)();
        const response = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(request, this.authority);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $e6f7ad11e10d0573$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $7b0e3b4066211abb$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
        responseHandler.validateTokenResponse(response.body);
        return (0, $ae433257996980ce$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, undefined, undefined, true, request.forceCache, requestId);
    }
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */ async acquireTokenByRefreshToken(request) {
        // Cannot renew token if no request object is given.
        if (!request) throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$eca67ff7a91fed9d));
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, request.correlationId);
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$5a3c7d1c90ac9220));
        // try checking if FOCI is enabled for the given application
        const isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment);
        // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
        if (isFOCI) try {
            return await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, true);
        } catch (e) {
            const noFamilyRTInCache = e instanceof (0, $b3acdb9c5805a543$export$6ba3e818c6bc76ba) && e.errorCode === (0, $0da9c4dbbd48f7df$export$e408b083cd212696);
            const clientMismatchErrorWithFamilyRT = e instanceof (0, $0463942371f4715f$export$ea52035eac03daf0) && e.errorCode === (0, $e6f7ad11e10d0573$export$b8e9cd941e8016ac).INVALID_GRANT_ERROR && e.subError === (0, $e6f7ad11e10d0573$export$b8e9cd941e8016ac).CLIENT_MISMATCH_ERROR;
            // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
            if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) return (0, $ae433257996980ce$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false);
            else throw e;
        }
        // fall back to application refresh token acquisition
        return (0, $ae433257996980ce$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false);
    }
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */ async acquireTokenWithCachedRefreshToken(request, foci) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
        // fetches family RT or application RT based on FOCI value
        const refreshToken = (0, $ae433257996980ce$export$468cda29b159ee5d)(this.cacheManager.getRefreshToken.bind(this.cacheManager), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).CacheManagerGetRefreshToken, this.logger, this.performanceClient, request.correlationId)(request.account, foci, undefined, this.performanceClient, request.correlationId);
        if (!refreshToken) throw (0, $b3acdb9c5805a543$export$8f7a741750c16535)((0, $0da9c4dbbd48f7df$export$e408b083cd212696));
        if (refreshToken.expiresOn && (0, $ac7fb5ae1cae46f5$export$b007d77a962aa175)(refreshToken.expiresOn, request.refreshTokenExpirationOffsetSeconds || $e03fe61a6af8489a$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS)) throw (0, $b3acdb9c5805a543$export$8f7a741750c16535)((0, $0da9c4dbbd48f7df$export$a90e8b9c10991b49));
        // attach cached RT size to the current measurement
        const refreshTokenRequest = {
            ...request,
            refreshToken: refreshToken.secret,
            authenticationScheme: request.authenticationScheme || (0, $e6f7ad11e10d0573$export$901491a717da2ba5).BEARER,
            ccsCredential: {
                credential: request.account.homeAccountId,
                type: (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            }
        };
        try {
            return await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.acquireToken.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(refreshTokenRequest);
        } catch (e) {
            if (e instanceof (0, $b3acdb9c5805a543$export$6ba3e818c6bc76ba) && e.subError === (0, $0da9c4dbbd48f7df$export$2e3666c77d45a4da)) {
                // Remove bad refresh token from cache
                this.logger.verbose("acquireTokenWithRefreshToken: bad refresh token, removing from cache");
                const badRefreshTokenKey = (0, $d6bc4864bb049bc4$export$1aaa1362083ec7a3)(refreshToken);
                this.cacheManager.removeRefreshToken(badRefreshTokenKey);
            }
            throw e;
        }
    }
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */ async executeTokenRequest(request, authority) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, request.correlationId);
        const queryParametersString = this.createTokenQueryParameters(request);
        const endpoint = (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        const headers = this.createTokenRequestHeaders(request.ccsCredential);
        const thumbprint = {
            clientId: request.tokenBodyParameters?.clientId || this.config.authOptions.clientId,
            authority: authority.canonicalAuthority,
            scopes: request.scopes,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid
        };
        return (0, $ae433257996980ce$export$e4feded94d9adb18)(this.executePostToTokenEndpoint.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientExecutePostToTokenEndpoint);
    }
    /**
     * Helper function to create the token request body
     * @param request
     */ async createTokenRequestBody(request) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, request.correlationId);
        const correlationId = request.correlationId;
        const parameterBuilder = new (0, $e395f42fea42ad84$export$882078dd8a9e0bfa)(correlationId, this.performanceClient);
        parameterBuilder.addClientId(request.embeddedClientId || request.tokenBodyParameters?.[0, $77544fccca6f740d$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        if (request.redirectUri) parameterBuilder.addRedirectUri(request.redirectUri);
        parameterBuilder.addScopes(request.scopes, true, this.config.authOptions.authority.options.OIDCOptions?.defaultScopes);
        parameterBuilder.addGrantType((0, $e6f7ad11e10d0573$export$ce68f19b50b39c0b).REFRESH_TOKEN_GRANT);
        parameterBuilder.addClientInfo();
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
        parameterBuilder.addThrottling();
        if (this.serverTelemetryManager && !(0, $daec59b36bfd07ff$export$25afa7198c2ed9b9)(this.config)) parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
        parameterBuilder.addRefreshToken(request.refreshToken);
        if (this.config.clientCredentials.clientSecret) parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            parameterBuilder.addClientAssertion(await (0, $4943b2aa5fffb8eb$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
        }
        if (request.authenticationScheme === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $ad4a320e462faf03$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $ae433257996980ce$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            parameterBuilder.addPopToken(reqCnfData);
        } else if (request.authenticationScheme === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) parameterBuilder.addSshJwk(request.sshJwk);
            else throw (0, $4bd7ca1d74a0da48$export$5d63d098f4f130a1)((0, $7431d2e4a345031a$export$8fbed44b22d9136f));
        }
        if (!(0, $2b520034dd7719a3$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) switch(request.ccsCredential.type){
            case (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $40ea3b2fe13bb092$export$63508a6d6b7dbe07)(request.ccsCredential.credential);
                    parameterBuilder.addCcsOid(clientInfo);
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).UPN:
                parameterBuilder.addCcsUpn(request.ccsCredential.credential);
                break;
        }
        if (request.embeddedClientId) parameterBuilder.addBrokerParameters({
            brokerClientId: this.config.authOptions.clientId,
            brokerRedirectUri: this.config.authOptions.redirectUri
        });
        if (request.tokenBodyParameters) parameterBuilder.addExtraQueryParameters(request.tokenBodyParameters);
        return parameterBuilder.createQueryString();
    }
}











'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $462a74f1cec41a56$export$e344f5b12c464597 extends (0, $74fe0f6fcfa66614$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
    }
    /**
     * Retrieves a token from cache if it is still valid, or uses the cached refresh token to renew
     * the given token and returns the renewed token
     * @param request
     */ async acquireToken(request) {
        try {
            const [authResponse, cacheOutcome] = await this.acquireCachedToken({
                ...request,
                scopes: request.scopes?.length ? request.scopes : [
                    ...(0, $e6f7ad11e10d0573$export$893b1b5b686d84ef)
                ]
            });
            // if the token is not expired but must be refreshed; get a new one in the background
            if (cacheOutcome === (0, $e6f7ad11e10d0573$export$aa4af185ea049f6b).PROACTIVELY_REFRESHED) {
                this.logger.info("SilentFlowClient:acquireCachedToken - Cached access token's refreshOn property has been exceeded'. It's not expired, but must be refreshed.");
                // refresh the access token in the background
                const refreshTokenClient = new (0, $e03fe61a6af8489a$export$9cb096b89b92d8a8)(this.config, this.performanceClient);
                refreshTokenClient.acquireTokenByRefreshToken(request).catch(()=>{
                // do nothing, this is running in the background and no action is to be taken upon success or failure
                });
            }
            // return the cached token
            return authResponse;
        } catch (e) {
            if (e instanceof (0, $054a0a060cbfdbdc$export$a839ff85a7957561) && e.errorCode === (0, $e3d0d7a1f8aeb2d2$export$e23b692cce0c7779)) {
                const refreshTokenClient = new (0, $e03fe61a6af8489a$export$9cb096b89b92d8a8)(this.config, this.performanceClient);
                return refreshTokenClient.acquireTokenByRefreshToken(request);
            } else throw e;
        }
    }
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */ async acquireCachedToken(request) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentFlowClientAcquireCachedToken, request.correlationId);
        let lastCacheOutcome = (0, $e6f7ad11e10d0573$export$aa4af185ea049f6b).NOT_APPLICABLE;
        if (request.forceRefresh || !this.config.cacheOptions.claimsBasedCachingEnabled && !(0, $2b520034dd7719a3$export$ecc754f99843e759).isEmptyObj(request.claims)) {
            // Must refresh due to present force_refresh flag.
            this.setCacheOutcome((0, $e6f7ad11e10d0573$export$aa4af185ea049f6b).FORCE_REFRESH_OR_CLAIMS, request.correlationId);
            throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$e23b692cce0c7779));
        }
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$5a3c7d1c90ac9220));
        const requestTenantId = request.account.tenantId || (0, $2d706f1a340b3c1d$export$6ed5af33d279fbc7)(request.authority);
        const tokenKeys = this.cacheManager.getTokenKeys();
        const cachedAccessToken = this.cacheManager.getAccessToken(request.account, request, tokenKeys, requestTenantId, this.performanceClient, request.correlationId);
        if (!cachedAccessToken) {
            // must refresh due to non-existent access_token
            this.setCacheOutcome((0, $e6f7ad11e10d0573$export$aa4af185ea049f6b).NO_CACHED_ACCESS_TOKEN, request.correlationId);
            throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$e23b692cce0c7779));
        } else if ((0, $ac7fb5ae1cae46f5$export$8961be72dcbc368e)(cachedAccessToken.cachedAt) || (0, $ac7fb5ae1cae46f5$export$b007d77a962aa175)(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
            // must refresh due to the expires_in value
            this.setCacheOutcome((0, $e6f7ad11e10d0573$export$aa4af185ea049f6b).CACHED_ACCESS_TOKEN_EXPIRED, request.correlationId);
            throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$e23b692cce0c7779));
        } else if (cachedAccessToken.refreshOn && (0, $ac7fb5ae1cae46f5$export$b007d77a962aa175)(cachedAccessToken.refreshOn, 0)) // must refresh (in the background) due to the refresh_in value
        lastCacheOutcome = (0, $e6f7ad11e10d0573$export$aa4af185ea049f6b).PROACTIVELY_REFRESHED;
        const environment = request.authority || this.authority.getPreferredCache();
        const cacheRecord = {
            account: this.cacheManager.readAccountFromCache(request.account),
            accessToken: cachedAccessToken,
            idToken: this.cacheManager.getIdToken(request.account, tokenKeys, requestTenantId, this.performanceClient, request.correlationId),
            refreshToken: null,
            appMetadata: this.cacheManager.readAppMetadataFromCache(environment)
        };
        this.setCacheOutcome(lastCacheOutcome, request.correlationId);
        if (this.config.serverTelemetryManager) this.config.serverTelemetryManager.incrementCacheHits();
        return [
            await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.generateResultFromCacheRecord.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentFlowClientGenerateResultFromCacheRecord, this.logger, this.performanceClient, request.correlationId)(cacheRecord, request),
            lastCacheOutcome
        ];
    }
    setCacheOutcome(cacheOutcome, correlationId) {
        this.serverTelemetryManager?.setCacheOutcome(cacheOutcome);
        this.performanceClient?.addFields({
            cacheOutcome: cacheOutcome
        }, correlationId);
        if (cacheOutcome !== (0, $e6f7ad11e10d0573$export$aa4af185ea049f6b).NOT_APPLICABLE) this.logger.info(`Token refresh is required due to cache outcome: ${cacheOutcome}`);
    }
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */ async generateResultFromCacheRecord(cacheRecord, request) {
        this.performanceClient?.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentFlowClientGenerateResultFromCacheRecord, request.correlationId);
        let idTokenClaims;
        if (cacheRecord.idToken) idTokenClaims = (0, $dbb12b3851d257af$export$8a59e6f35fb00518)(cacheRecord.idToken.secret, this.config.cryptoInterface.base64Decode);
        // token max_age check
        if (request.maxAge || request.maxAge === 0) {
            const authTime = idTokenClaims?.auth_time;
            if (!authTime) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$export$43356944266c945e));
            (0, $dbb12b3851d257af$export$ee7a34ea7880144c)(authTime, request.maxAge);
        }
        return (0, $7b0e3b4066211abb$export$f456c9835cc63582).generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, idTokenClaims);
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $4194ab35f2873fab$export$59d4f873ee62d01e extends (0, $aed111b4f4b5e49c$export$fa9179cade3eb05a) {
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */ async acquireToken(silentRequest) {
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, silentRequest.correlationId);
        // Telemetry manager only used to increment cacheHits here
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
        const clientConfig = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        const silentAuthClient = new (0, $462a74f1cec41a56$export$e344f5b12c464597)(clientConfig, this.performanceClient);
        this.logger.verbose("Silent auth client created");
        try {
            const response = await (0, $ae433257996980ce$export$e4feded94d9adb18)(silentAuthClient.acquireCachedToken.bind(silentAuthClient), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentFlowClientAcquireCachedToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
            const authResponse = response[0];
            this.performanceClient.addFields({
                fromCache: true
            }, silentRequest.correlationId);
            return authResponse;
        } catch (error) {
            if (error instanceof (0, $1eca0489e18862c6$export$f8eb6760ca13876a) && error.errorCode === (0, $8e6ba27e37631a08$export$a416b0eceb5c15df)) this.logger.verbose("Signing keypair for bound access token not found. Refreshing bound access token and generating a new crypto keypair.");
            throw error;
        }
    }
    /**
     * API to silenty clear the browser cache.
     * @param logoutRequest
     */ logout(logoutRequest) {
        this.logger.verbose("logoutRedirect called");
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        return this.clearCacheOnLogout(validLogoutRequest?.account);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $97e72655060ed469$export$38af86d4cb90fd61 extends (0, $256b2ddbb48bee4b$export$d858565f81c03f1f) {
    constructor(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId){
        super(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        this.apiId = apiId;
        this.accountId = accountId;
        this.nativeMessageHandler = provider;
        this.nativeStorageManager = nativeStorageImpl;
        this.silentCacheClient = new (0, $4194ab35f2873fab$export$59d4f873ee62d01e)(config, this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        this.serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        const extensionName = this.nativeMessageHandler.getExtensionId() === (0, $e195f599725a9f25$export$fec113838800867f).PREFERRED_EXTENSION_ID ? "chrome" : this.nativeMessageHandler.getExtensionId()?.length ? "unknown" : undefined;
        this.skus = (0, $579e3708bb5512e2$export$bddbbc43a3ca9c53).makeExtraSkuString({
            libraryName: (0, $e195f599725a9f25$export$a0a689e4294b9880).MSAL_SKU,
            libraryVersion: (0, $d287cb496a16a30d$export$83d89fbfd8236492),
            extensionName: extensionName,
            extensionVersion: this.nativeMessageHandler.getExtensionVersion()
        });
    }
    /**
     * Adds SKUs to request extra query parameters
     * @param request {NativeTokenRequest}
     * @private
     */ addRequestSKUs(request) {
        request.extraParameters = {
            ...request.extraParameters,
            [(0, $77544fccca6f740d$exports).X_CLIENT_EXTRA_SKU]: this.skus
        };
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, request.correlationId);
        this.logger.trace("NativeInteractionClient - acquireToken called.");
        // start the perf measurement
        const nativeATMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, request.correlationId);
        const reqTimestamp = (0, $ac7fb5ae1cae46f5$exports).nowSeconds();
        try {
            // initialize native request
            const nativeRequest = await this.initializeNativeRequest(request);
            // check if the tokens can be retrieved from internal cache
            try {
                const result = await this.acquireTokensFromCache(this.accountId, nativeRequest);
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: false,
                    fromCache: true
                });
                return result;
            } catch (e) {
                // continue with a native call for any and all errors
                this.logger.info("MSAL internal Cache does not contain tokens, proceed to make a native call");
            }
            const { ...nativeTokenRequest } = nativeRequest;
            // fall back to native calls
            const messageBody = {
                method: (0, $e195f599725a9f25$export$3536098be6c7dadb).GetToken,
                request: nativeTokenRequest
            };
            const response = await this.nativeMessageHandler.sendMessage(messageBody);
            const validatedResponse = this.validateNativeResponse(response);
            return await this.handleNativeResponse(validatedResponse, nativeRequest, reqTimestamp).then((result)=>{
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: true,
                    requestId: result.requestId
                });
                this.serverTelemetryManager.clearNativeBrokerErrorCode();
                return result;
            }).catch((error)=>{
                nativeATMeasurement.end({
                    success: false,
                    errorCode: error.errorCode,
                    subErrorCode: error.subError,
                    isNativeBroker: true
                });
                throw error;
            });
        } catch (e) {
            if (e instanceof (0, $928aa5124c222013$export$4b8a4f6256e840ab)) this.serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
            throw e;
        }
    }
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */ createSilentCacheRequest(request, cachedAccount) {
        return {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).fromString(request.scope).asArray(),
            account: cachedAccount,
            forceRefresh: false
        };
    }
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */ async acquireTokensFromCache(nativeAccountId, request) {
        if (!nativeAccountId) {
            this.logger.warning("NativeInteractionClient:acquireTokensFromCache - No nativeAccountId provided");
            throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$exports).noAccountFound);
        }
        // fetch the account from browser cache
        const account = this.browserStorage.getBaseAccountInfo({
            nativeAccountId: nativeAccountId
        });
        if (!account) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$exports).noAccountFound);
        // leverage silent flow for cached tokens retrieval
        try {
            const silentRequest = this.createSilentCacheRequest(request, account);
            const result = await this.silentCacheClient.acquireToken(silentRequest);
            const fullAccount = {
                ...account,
                idTokenClaims: result?.idTokenClaims,
                idToken: result?.idToken
            };
            return {
                ...result,
                account: fullAccount
            };
        } catch (e) {
            throw e;
        }
    }
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param {RedirectRequest} request
     * @param {InProgressPerformanceEvent} rootMeasurement
     */ async acquireTokenRedirect(request, rootMeasurement) {
        this.logger.trace("NativeInteractionClient - acquireTokenRedirect called.");
        const { ...remainingParameters } = request;
        delete remainingParameters.onRedirectNavigate;
        const nativeRequest = await this.initializeNativeRequest(remainingParameters);
        const messageBody = {
            method: (0, $e195f599725a9f25$export$3536098be6c7dadb).GetToken,
            request: nativeRequest
        };
        try {
            const response = await this.nativeMessageHandler.sendMessage(messageBody);
            this.validateNativeResponse(response);
        } catch (e) {
            // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
            if (e instanceof (0, $928aa5124c222013$export$4b8a4f6256e840ab)) {
                this.serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
                if ((0, $928aa5124c222013$export$f21e42e365baeb50)(e)) throw e;
            }
        }
        this.browserStorage.setTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).NATIVE_REQUEST, JSON.stringify(nativeRequest), true);
        const navigationOptions = {
            apiId: (0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenRedirect,
            timeout: this.config.system.redirectNavigationTimeout,
            noHistory: false
        };
        const redirectUri = this.config.auth.navigateToLoginRequestUrl ? window.location.href : this.getRedirectUri(request.redirectUri);
        rootMeasurement.end({
            success: true
        });
        await this.navigationClient.navigateExternal(redirectUri, navigationOptions); // Need to treat this as external to ensure handleRedirectPromise is run again
    }
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     * @param performanceClient {IPerformanceClient?}
     * @param correlationId {string?} correlation identifier
     */ async handleRedirectPromise(performanceClient, correlationId) {
        this.logger.trace("NativeInteractionClient - handleRedirectPromise called.");
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
            return null;
        }
        // remove prompt from the request to prevent WAM from prompting twice
        const cachedRequest = this.browserStorage.getCachedNativeRequest();
        if (!cachedRequest) {
            this.logger.verbose("NativeInteractionClient - handleRedirectPromise called but there is no cached request, returning null.");
            if (performanceClient && correlationId) performanceClient?.addFields({
                errorCode: "no_cached_request"
            }, correlationId);
            return null;
        }
        const { prompt: prompt, ...request } = cachedRequest;
        if (prompt) this.logger.verbose("NativeInteractionClient - handleRedirectPromise called and prompt was included in the original request, removing prompt from cached request to prevent second interaction with native broker window.");
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $e195f599725a9f25$export$21d55bedf0d269fb).NATIVE_REQUEST));
        const messageBody = {
            method: (0, $e195f599725a9f25$export$3536098be6c7dadb).GetToken,
            request: request
        };
        const reqTimestamp = (0, $ac7fb5ae1cae46f5$exports).nowSeconds();
        try {
            this.logger.verbose("NativeInteractionClient - handleRedirectPromise sending message to native broker.");
            const response = await this.nativeMessageHandler.sendMessage(messageBody);
            this.validateNativeResponse(response);
            const result = this.handleNativeResponse(response, request, reqTimestamp);
            this.browserStorage.setInteractionInProgress(false);
            const res = await result;
            this.serverTelemetryManager.clearNativeBrokerErrorCode();
            return res;
        } catch (e) {
            this.browserStorage.setInteractionInProgress(false);
            throw e;
        }
    }
    /**
     * Logout from native platform via browser extension
     * @param request
     */ logout() {
        this.logger.trace("NativeInteractionClient - logout called.");
        return Promise.reject("Logout not implemented yet");
    }
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */ async handleNativeResponse(response, request, reqTimestamp) {
        this.logger.trace("NativeInteractionClient - handleNativeResponse called.");
        // generate identifiers
        const idTokenClaims = (0, $dbb12b3851d257af$exports).extractTokenClaims(response.id_token, (0, $bb6fd55178ea2979$export$c62426fdd000a97e));
        const homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenClaims);
        const cachedhomeAccountId = this.browserStorage.getAccountInfoFilteredBy({
            nativeAccountId: request.accountId
        })?.homeAccountId;
        if (homeAccountIdentifier !== cachedhomeAccountId && response.account.id !== request.accountId) // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
        throw (0, $928aa5124c222013$export$9154414ec87d187b)((0, $2bb12ad8376a640d$export$966ec8558e4d7922));
        // Get the preferred_cache domain for the given authority
        const authority = await this.getDiscoveredAuthority({
            requestAuthority: request.authority
        });
        const baseAccount = (0, $7b0e3b4066211abb$export$73b84062d58a1307)(this.browserStorage, authority, homeAccountIdentifier, (0, $bb6fd55178ea2979$export$c62426fdd000a97e), idTokenClaims, response.client_info, undefined, idTokenClaims.tid, undefined, response.account.id, this.logger);
        // generate authenticationResult
        const result = await this.generateAuthenticationResult(response, request, idTokenClaims, baseAccount, authority.canonicalAuthority, reqTimestamp);
        // cache accounts and tokens in the appropriate storage
        this.cacheAccount(baseAccount);
        this.cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, response.access_token, result.tenantId, reqTimestamp);
        return result;
    }
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */ createHomeAccountIdentifier(response, idTokenClaims) {
        // Save account in browser storage
        const homeAccountIdentifier = (0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).generateHomeAccountId(response.client_info || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING, (0, $1075494641e42ac7$export$cd82032b224a3839).Default, this.logger, this.browserCrypto, idTokenClaims);
        return homeAccountIdentifier;
    }
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */ generateScopes(response, request) {
        return response.scope ? (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).fromString(response.scope) : (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).fromString(request.scope);
    }
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */ async generatePopAccessToken(response, request) {
        if (request.tokenType === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP && request.signPopToken) {
            /**
             * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
             * is still received, SHR is calculated locally
             */ // Check if native layer returned an SHR token
            if (response.shr) {
                this.logger.trace("handleNativeServerResponse: SHR is enabled in native layer");
                return response.shr;
            }
            // Generate SHR in msal js if WAM does not compute it when POP is enabled
            const popTokenGenerator = new (0, $ad4a320e462faf03$export$3dd8467151c83e3e)(this.browserCrypto);
            const shrParameters = {
                resourceRequestMethod: request.resourceRequestMethod,
                resourceRequestUri: request.resourceRequestUri,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce
            };
            /**
             * KeyID must be present in the native request from when the PoP key was generated in order for
             * PopTokenGenerator to query the full key for signing
             */ if (!request.keyId) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$exports).keyIdMissing);
            return popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters);
        } else return response.access_token;
    }
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */ async generateAuthenticationResult(response, request, idTokenClaims, accountEntity, authority, reqTimestamp) {
        // Add Native Broker fields to Telemetry
        const mats = this.addTelemetryFromNativeResponse(response);
        // If scopes not returned in server response, use request scopes
        const responseScopes = response.scope ? (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).fromString(response.scope) : (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).fromString(request.scope);
        const accountProperties = response.account.properties || {};
        const uid = accountProperties["UID"] || idTokenClaims.oid || idTokenClaims.sub || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        const tid = accountProperties["TenantId"] || idTokenClaims.tid || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
        const accountInfo = (0, $11db744279a82a57$export$452a054c78b83dad)(accountEntity.getAccountInfo(), undefined, idTokenClaims, response.id_token);
        /**
         * In pairwise broker flows, this check prevents the broker's native account id
         * from being returned over the embedded app's account id.
         */ if (accountInfo.nativeAccountId !== response.account.id) accountInfo.nativeAccountId = response.account.id;
        // generate PoP token as needed
        const responseAccessToken = await this.generatePopAccessToken(response, request);
        const tokenType = request.tokenType === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP ? (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP : (0, $e6f7ad11e10d0573$export$901491a717da2ba5).BEARER;
        const result = {
            authority: authority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes.asArray(),
            account: accountInfo,
            idToken: response.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: responseAccessToken,
            fromCache: mats ? this.isResponseFromCache(mats) : false,
            expiresOn: new Date(Number(reqTimestamp + response.expires_in) * 1000),
            tokenType: tokenType,
            correlationId: this.correlationId,
            state: response.state,
            fromNativeBroker: true
        };
        return result;
    }
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */ cacheAccount(accountEntity) {
        // Store the account info and hence `nativeAccountId` in browser cache
        this.browserStorage.setAccount(accountEntity);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext(accountEntity).catch((e)=>{
            this.logger.error(`Error occurred while removing account context from browser storage. ${e}`);
        });
    }
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */ cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, responseAccessToken, tenantId, reqTimestamp) {
        const cachedIdToken = (0, $d6bc4864bb049bc4$exports).createIdTokenEntity(homeAccountIdentifier, request.authority, response.id_token || "", request.clientId, idTokenClaims.tid || "");
        // cache accessToken in inmemory storage
        const expiresIn = request.tokenType === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP ? (0, $e6f7ad11e10d0573$export$a002182e51710d39).SHR_NONCE_VALIDITY : (typeof response.expires_in === "string" ? parseInt(response.expires_in, 10) : response.expires_in) || 0;
        const tokenExpirationSeconds = reqTimestamp + expiresIn;
        const responseScopes = this.generateScopes(response, request);
        const cachedAccessToken = (0, $d6bc4864bb049bc4$exports).createAccessTokenEntity(homeAccountIdentifier, request.authority, responseAccessToken, request.clientId, idTokenClaims.tid || tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, (0, $bb6fd55178ea2979$export$c62426fdd000a97e), undefined, request.tokenType, undefined, request.keyId);
        const nativeCacheRecord = {
            idToken: cachedIdToken,
            accessToken: cachedAccessToken
        };
        this.nativeStorageManager.saveCacheRecord(nativeCacheRecord, request.storeInCache);
    }
    addTelemetryFromNativeResponse(response) {
        const mats = this.getMATSFromResponse(response);
        if (!mats) return null;
        this.performanceClient.addFields({
            extensionId: this.nativeMessageHandler.getExtensionId(),
            extensionVersion: this.nativeMessageHandler.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    }
    /**
     * Validates native platform response before processing
     * @param response
     */ validateNativeResponse(response) {
        if (response.hasOwnProperty("access_token") && response.hasOwnProperty("id_token") && response.hasOwnProperty("client_info") && response.hasOwnProperty("account") && response.hasOwnProperty("scope") && response.hasOwnProperty("expires_in")) return response;
        else throw (0, $40da14d5d49dd285$export$eb157f7636c79bd2)((0, $acfff9ca9e4267b8$exports).unexpectedError, "Response missing expected properties.");
    }
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */ getMATSFromResponse(response) {
        if (response.properties.MATS) try {
            return JSON.parse(response.properties.MATS);
        } catch (e) {
            this.logger.error("NativeInteractionClient - Error parsing MATS telemetry, returning null instead");
        }
        return null;
    }
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */ isResponseFromCache(mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("NativeInteractionClient - MATS telemetry does not contain field indicating if response was served from cache. Returning false.");
            return false;
        }
        return !!mats.is_cached;
    }
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */ async initializeNativeRequest(request) {
        this.logger.trace("NativeInteractionClient - initializeNativeRequest called");
        const requestAuthority = request.authority || this.config.auth.authority;
        if (request.account) // validate authority
        await this.getDiscoveredAuthority({
            requestAuthority: requestAuthority,
            requestAzureCloudOptions: request.azureCloudOptions,
            account: request.account
        });
        const canonicalAuthority = new (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2)(requestAuthority);
        canonicalAuthority.validateAsUri();
        // scopes are expected to be received by the native broker as "scope" and will be added to the request below. Other properties that should be dropped from the request to the native broker can be included in the object destructuring here.
        const { scopes: scopes, ...remainingProperties } = request;
        const scopeSet = new (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99)(scopes || []);
        scopeSet.appendScopes((0, $e6f7ad11e10d0573$export$893b1b5b686d84ef));
        const getPrompt = ()=>{
            // If request is silent, prompt is always none
            switch(this.apiId){
                case (0, $e195f599725a9f25$export$192d74ad69b40705).ssoSilent:
                case (0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenSilent_silentFlow:
                    this.logger.trace("initializeNativeRequest: silent request sets prompt to none");
                    return (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).NONE;
            }
            // Prompt not provided, request may proceed and native broker decides if it needs to prompt
            if (!request.prompt) {
                this.logger.trace("initializeNativeRequest: prompt was not provided");
                return undefined;
            }
            // If request is interactive, check if prompt provided is allowed to go directly to native broker
            switch(request.prompt){
                case (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).NONE:
                case (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).CONSENT:
                case (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).LOGIN:
                    this.logger.trace("initializeNativeRequest: prompt is compatible with native flow");
                    return request.prompt;
                default:
                    this.logger.trace(`initializeNativeRequest: prompt = ${request.prompt} is not compatible with native flow`);
                    throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$62fdd8848aa75547));
            }
        };
        const validatedRequest = {
            ...remainingProperties,
            accountId: this.accountId,
            clientId: this.config.auth.clientId,
            authority: canonicalAuthority.urlString,
            scope: scopeSet.printScopes(),
            redirectUri: this.getRedirectUri(request.redirectUri),
            prompt: getPrompt(),
            correlationId: this.correlationId,
            tokenType: request.authenticationScheme,
            windowTitleSubstring: document.title,
            extraParameters: {
                ...request.extraQueryParameters,
                ...request.tokenQueryParameters
            },
            extendedExpiryToken: false,
            keyId: request.popKid
        };
        // Check for PoP token requests: signPopToken should only be set to true if popKid is not set
        if (validatedRequest.signPopToken && !!request.popKid) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$f6f43ae33ad04b91));
        this.handleExtraBrokerParams(validatedRequest);
        validatedRequest.extraParameters = validatedRequest.extraParameters || {};
        validatedRequest.extraParameters.telemetry = (0, $e195f599725a9f25$export$fec113838800867f).MATS_TELEMETRY;
        if (request.authenticationScheme === (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP) {
            // add POP request type
            const shrParameters = {
                resourceRequestUri: request.resourceRequestUri,
                resourceRequestMethod: request.resourceRequestMethod,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce
            };
            const popTokenGenerator = new (0, $ad4a320e462faf03$export$3dd8467151c83e3e)(this.browserCrypto);
            // generate reqCnf if not provided in the request
            let reqCnfData;
            if (!validatedRequest.keyId) {
                const generatedReqCnfData = await (0, $ae433257996980ce$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(shrParameters, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
                validatedRequest.keyId = generatedReqCnfData.kid;
                validatedRequest.signPopToken = true;
            } else {
                reqCnfData = this.browserCrypto.base64UrlEncode(JSON.stringify({
                    kid: validatedRequest.keyId
                }));
                validatedRequest.signPopToken = false;
            }
            // SPAs require whole string to be passed to broker
            validatedRequest.reqCnf = reqCnfData;
        }
        this.addRequestSKUs(validatedRequest);
        return validatedRequest;
    }
    /**
     * Handles extra broker request parameters
     * @param request {NativeTokenRequest}
     * @private
     */ handleExtraBrokerParams(request) {
        const hasExtraBrokerParams = request.extraParameters && request.extraParameters.hasOwnProperty((0, $77544fccca6f740d$exports).BROKER_CLIENT_ID) && request.extraParameters.hasOwnProperty((0, $77544fccca6f740d$exports).BROKER_REDIRECT_URI) && request.extraParameters.hasOwnProperty((0, $77544fccca6f740d$exports).CLIENT_ID);
        if (!request.embeddedClientId && !hasExtraBrokerParams) return;
        let child_client_id = "";
        const child_redirect_uri = request.redirectUri;
        if (request.embeddedClientId) {
            request.redirectUri = this.config.auth.redirectUri;
            child_client_id = request.embeddedClientId;
        } else if (request.extraParameters) {
            request.redirectUri = request.extraParameters[(0, $77544fccca6f740d$exports).BROKER_REDIRECT_URI];
            child_client_id = request.extraParameters[(0, $77544fccca6f740d$exports).CLIENT_ID];
        }
        request.extraParameters = {
            child_client_id: child_client_id,
            child_redirect_uri: child_redirect_uri
        };
        this.performanceClient?.addFields({
            embeddedClientId: child_client_id,
            embeddedRedirectUri: child_redirect_uri
        }, request.correlationId);
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $dd55ff53bd487fbc$export$c98888b8059e2702 {
    constructor(logger, handshakeTimeoutMs, performanceClient, extensionId){
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.handshakeEvent = performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).NativeMessageHandlerHandshake);
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param body
     */ async sendMessage(body) {
        this.logger.trace("NativeMessageHandler - sendMessage called.");
        const req = {
            channel: (0, $e195f599725a9f25$export$fec113838800867f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $a65ce7794137937d$export$6ef0355fa80a5278)(),
            body: body
        };
        this.logger.trace("NativeMessageHandler - Sending request to browser extension");
        this.logger.tracePii(`NativeMessageHandler - Sending request to browser extension: ${JSON.stringify(req)}`);
        this.messageChannel.port1.postMessage(req);
        return new Promise((resolve, reject)=>{
            this.resolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
        });
    }
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     * @param {ICrypto} crypto
     */ static async createProvider(logger, handshakeTimeoutMs, performanceClient) {
        logger.trace("NativeMessageHandler - createProvider called.");
        try {
            const preferredProvider = new $dd55ff53bd487fbc$export$c98888b8059e2702(logger, handshakeTimeoutMs, performanceClient, (0, $e195f599725a9f25$export$fec113838800867f).PREFERRED_EXTENSION_ID);
            await preferredProvider.sendHandshakeRequest();
            return preferredProvider;
        } catch (e) {
            // If preferred extension fails for whatever reason, fallback to using any installed extension
            const backupProvider = new $dd55ff53bd487fbc$export$c98888b8059e2702(logger, handshakeTimeoutMs, performanceClient);
            await backupProvider.sendHandshakeRequest();
            return backupProvider;
        }
    }
    /**
     * Send handshake request helper.
     */ async sendHandshakeRequest() {
        this.logger.trace("NativeMessageHandler - sendHandshakeRequest called.");
        // Register this event listener before sending handshake
        window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
        const req = {
            channel: (0, $e195f599725a9f25$export$fec113838800867f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $a65ce7794137937d$export$6ef0355fa80a5278)(),
            body: {
                method: (0, $e195f599725a9f25$export$3536098be6c7dadb).HandshakeRequest
            }
        };
        this.handshakeEvent.add({
            extensionId: this.extensionId,
            extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
        });
        this.messageChannel.port1.onmessage = (event)=>{
            this.onChannelMessage(event);
        };
        window.postMessage(req, window.origin, [
            this.messageChannel.port2
        ]);
        return new Promise((resolve, reject)=>{
            this.handshakeResolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
            this.timeoutId = window.setTimeout(()=>{
                /*
                 * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                 * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                 */ window.removeEventListener("message", this.windowListener, false);
                this.messageChannel.port1.close();
                this.messageChannel.port2.close();
                this.handshakeEvent.end({
                    extensionHandshakeTimedOut: true,
                    success: false
                });
                reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$4747c302ef0117fd)));
                this.handshakeResolvers.delete(req.responseId);
            }, this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
        });
    }
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */ onWindowMessage(event) {
        this.logger.trace("NativeMessageHandler - onWindowMessage called");
        // We only accept messages from ourselves
        if (event.source !== window) return;
        const request = event.data;
        if (!request.channel || request.channel !== (0, $e195f599725a9f25$export$fec113838800867f).CHANNEL_ID) return;
        if (request.extensionId && request.extensionId !== this.extensionId) return;
        if (request.body.method === (0, $e195f599725a9f25$export$3536098be6c7dadb).HandshakeRequest) {
            const handshakeResolver = this.handshakeResolvers.get(request.responseId);
            /*
             * Filter out responses with no matched resolvers sooner to keep channel ports open while waiting for
             * the proper response.
             */ if (!handshakeResolver) {
                this.logger.trace(`NativeMessageHandler.onWindowMessage - resolver can't be found for request ${request.responseId}`);
                return;
            }
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? `Extension with id: ${request.extensionId} not installed` : "No extension installed");
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            this.handshakeEvent.end({
                success: false,
                extensionInstalled: false
            });
            handshakeResolver.reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$59080ea2398ee306)));
        }
    }
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */ onChannelMessage(event) {
        this.logger.trace("NativeMessageHandler - onChannelMessage called.");
        const request = event.data;
        const resolver = this.resolvers.get(request.responseId);
        const handshakeResolver = this.handshakeResolvers.get(request.responseId);
        try {
            const method = request.body.method;
            if (method === (0, $e195f599725a9f25$export$3536098be6c7dadb).Response) {
                if (!resolver) return;
                const response = request.body.response;
                this.logger.trace("NativeMessageHandler - Received response from browser extension");
                this.logger.tracePii(`NativeMessageHandler - Received response from browser extension: ${JSON.stringify(response)}`);
                if (response.status !== "Success") resolver.reject((0, $928aa5124c222013$export$9154414ec87d187b)(response.code, response.description, response.ext));
                else if (response.result) {
                    if (response.result["code"] && response.result["description"]) resolver.reject((0, $928aa5124c222013$export$9154414ec87d187b)(response.result["code"], response.result["description"], response.result["ext"]));
                    else resolver.resolve(response.result);
                } else throw (0, $40da14d5d49dd285$export$eb157f7636c79bd2)((0, $acfff9ca9e4267b8$exports).unexpectedError, "Event does not contain result.");
                this.resolvers.delete(request.responseId);
            } else if (method === (0, $e195f599725a9f25$export$3536098be6c7dadb).HandshakeResponse) {
                if (!handshakeResolver) {
                    this.logger.trace(`NativeMessageHandler.onChannelMessage - resolver can't be found for request ${request.responseId}`);
                    return;
                }
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version;
                this.logger.verbose(`NativeMessageHandler - Received HandshakeResponse from extension: ${this.extensionId}`);
                this.handshakeEvent.end({
                    extensionInstalled: true,
                    success: true
                });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            }
        // Do nothing if method is not Response or HandshakeResponse
        } catch (err) {
            this.logger.error("Error parsing response from WAM Extension");
            this.logger.errorPii(`Error parsing response from WAM Extension: ${err}`);
            this.logger.errorPii(`Unable to parse ${event}`);
            if (resolver) resolver.reject(err);
            else if (handshakeResolver) handshakeResolver.reject(err);
        }
    }
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return this.extensionId;
    }
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */ getExtensionVersion() {
        return this.extensionVersion;
    }
    /**
     * Returns boolean indicating whether or not the request should attempt to use native broker
     * @param logger
     * @param config
     * @param nativeExtensionProvider
     * @param authenticationScheme
     */ static isNativeAvailable(config, logger, nativeExtensionProvider, authenticationScheme) {
        logger.trace("isNativeAvailable called");
        if (!config.system.allowNativeBroker) {
            logger.trace("isNativeAvailable: allowNativeBroker is not enabled, returning false");
            // Developer disabled WAM
            return false;
        }
        if (!nativeExtensionProvider) {
            logger.trace("isNativeAvailable: WAM extension provider is not initialized, returning false");
            // Extension is not available
            return false;
        }
        if (authenticationScheme) switch(authenticationScheme){
            case (0, $e6f7ad11e10d0573$export$901491a717da2ba5).BEARER:
            case (0, $e6f7ad11e10d0573$export$901491a717da2ba5).POP:
                logger.trace("isNativeAvailable: authenticationScheme is supported, returning true");
                return true;
            default:
                logger.trace("isNativeAvailable: authenticationScheme is not supported, returning false");
                return false;
        }
        return true;
    }
}



/*! @azure/msal-browser v3.27.0 2024-11-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Abstract class which defines operations for a browser interaction handling class.
 */ class $4936d5fa007125a3$export$a30cd982b4e89bdb {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */ async handleCodeResponse(response, request) {
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).HandleCodeResponse, request.correlationId);
        let authCodeResponse;
        try {
            authCodeResponse = this.authModule.handleFragmentResponse(response, request.state);
        } catch (e) {
            if (e instanceof (0, $0463942371f4715f$export$ea52035eac03daf0) && e.subError === (0, $8e6ba27e37631a08$export$6bae303c5e922702)) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$6bae303c5e922702));
            else throw e;
        }
        return (0, $ae433257996980ce$export$e4feded94d9adb18)(this.handleCodeResponseFromServer.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)(authCodeResponse, request);
    }
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param state
     * @param authority
     * @param networkModule
     * @returns
     */ async handleCodeResponseFromServer(authCodeResponse, request, validateNonce = true) {
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).HandleCodeResponseFromServer, request.correlationId);
        this.logger.trace("InteractionHandler.handleCodeResponseFromServer called");
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Check for new cloud instance
        if (authCodeResponse.cloud_instance_host_name) await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.authModule.updateAuthority.bind(this.authModule), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.logger, this.performanceClient, request.correlationId)(authCodeResponse.cloud_instance_host_name, request.correlationId);
        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
        if (validateNonce) // TODO: Assigning "response nonce" to "request nonce" is confusing. Refactor the function doing validation to accept request nonce directly
        authCodeResponse.nonce = request.nonce || undefined;
        authCodeResponse.state = request.state;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const ccsCred = this.createCcsCredentials(request);
            if (ccsCred) this.authCodeRequest.ccsCredential = ccsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.authModule.acquireToken.bind(this.authModule), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AuthClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(this.authCodeRequest, authCodeResponse);
        return tokenResponse;
    }
    /**
     * Build ccs creds if available
     */ createCcsCredentials(request) {
        if (request.account) return {
            credential: request.account.homeAccountId,
            type: (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
        };
        else if (request.loginHint) return {
            credential: request.loginHint,
            type: (0, $7b999f5c91b4e529$export$17b7b3ac1abef49f).UPN
        };
        return null;
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $d1ba9120170867a9$export$e64c1808ed72a7c(responseString, responseLocation, logger) {
    // Deserialize hash fragment response parameters.
    const serverParams = (0, $734d5def052f4ce7$exports).getDeserializedResponse(responseString);
    if (!serverParams) {
        if (!(0, $734d5def052f4ce7$exports).stripLeadingHashOrQuery(responseString)) {
            // Hash or Query string is empty
            logger.error(`The request has returned to the redirectUri but a ${responseLocation} is not present. It's likely that the ${responseLocation} has been removed or the page has been redirected by code running on the redirectUri page.`);
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$a29c42a1dd414317));
        } else {
            logger.error(`A ${responseLocation} is present in the iframe but it does not contain known properties. It's likely that the ${responseLocation} has been replaced by code running on the redirectUri page.`);
            logger.errorPii(`The ${responseLocation} detected is: ${responseString}`);
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$5743873a5ba5d124));
        }
    }
    return serverParams;
}
/**
 * Returns the interaction type that the response object belongs to
 */ function $d1ba9120170867a9$export$af0c72d18284aa0(response, browserCrypto, interactionType) {
    if (!response.state) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$211c8e8843a8d278));
    const platformStateObj = (0, $6dd4a8fd50fdac35$export$68ec87f530f5f536)(browserCrypto, response.state);
    if (!platformStateObj) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$237bdd0b913cb30c));
    if (platformStateObj.interactionType !== interactionType) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$499b1b95c97a1c75));
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $f5521de3a2025a38$export$43b0fce132d066f4 extends (0, $aed111b4f4b5e49c$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId);
        // Properly sets this reference for the unload event.
        this.unloadWindow = this.unloadWindow.bind(this);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     */ acquireToken(request) {
        try {
            const popupName = this.generatePopupName(request.scopes || (0, $e6f7ad11e10d0573$export$893b1b5b686d84ef), request.authority || this.config.auth.authority);
            const popupParams = {
                popupName: popupName,
                popupWindowAttributes: request.popupWindowAttributes || {},
                popupWindowParent: request.popupWindowParent ?? window
            };
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true, acquiring token");
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupParams);
            } else {
                // asyncPopups flag is set to false. Opens popup before acquiring token.
                this.logger.verbose("asyncPopup set to false, opening popup before acquiring token");
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.acquireTokenPopupAsync(request, popupParams);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logout(logoutRequest) {
        try {
            this.logger.verbose("logoutPopup called");
            const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            const popupParams = {
                popupName: this.generateLogoutPopupName(validLogoutRequest),
                popupWindowAttributes: logoutRequest?.popupWindowAttributes || {},
                popupWindowParent: logoutRequest?.popupWindowParent ?? window
            };
            const authority = logoutRequest && logoutRequest.authority;
            const mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true");
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            } else {
                // asyncPopups flag is set to false. Opens popup before logging out.
                this.logger.verbose("asyncPopup set to false, opening popup");
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            }
        } catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param validRequest
     * @param popupName
     * @param popup
     * @param popupWindowAttributes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopupAsync(request, popupParams) {
        this.logger.verbose("acquireTokenPopupAsync called");
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenPopup);
        const validRequest = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup);
        (0, $d618406b813d26cc$export$a0816fa17a9e79be)(validRequest.authority);
        try {
            // Create auth code request and generate PKCE params
            const authCodeRequest = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.initializeAuthorizationCodeRequest.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, this.logger, this.performanceClient, this.correlationId)(validRequest);
            // Initialize the client
            const authClient = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: validRequest.authority,
                requestAzureCloudOptions: validRequest.azureCloudOptions,
                requestExtraQueryParameters: validRequest.extraQueryParameters,
                account: validRequest.account
            });
            const isNativeBroker = (0, $dd55ff53bd487fbc$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, request.authenticationScheme);
            // Start measurement for server calls with native brokering enabled
            let fetchNativeAccountIdMeasurement;
            if (isNativeBroker) fetchNativeAccountIdMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).FetchAccountIdWithNativeBroker, request.correlationId);
            // Create acquire token url.
            const navigateUrl = await authClient.getAuthCodeUrl({
                ...validRequest,
                nativeBroker: isNativeBroker
            });
            // Create popup interaction handler.
            const interactionHandler = new (0, $4936d5fa007125a3$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Show the UI once the url has been created. Get the window handle for the popup.
            const popupWindow = this.initiateAuthRequest(navigateUrl, popupParams);
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).POPUP_OPENED, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, {
                popupWindow: popupWindow
            }, null);
            // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
            const responseString = await this.monitorPopupForHash(popupWindow, popupParams.popupWindowParent);
            const serverParams = (0, $ae433257996980ce$export$468cda29b159ee5d)((0, $d1ba9120170867a9$export$e64c1808ed72a7c), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.serverResponseType, this.logger);
            // Remove throttle if it exists
            (0, $8868e8edc76d69b4$export$c060a619741dd765).removeThrottle(this.browserStorage, this.config.auth.clientId, authCodeRequest);
            if (serverParams.accountId) {
                this.logger.verbose("Account id found in hash, calling WAM for token");
                // end measurement for server call with native brokering enabled
                if (fetchNativeAccountIdMeasurement) fetchNativeAccountIdMeasurement.end({
                    success: true,
                    isNativeBroker: true
                });
                if (!this.nativeMessageHandler) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$7b7357e3538624aa));
                const nativeInteractionClient = new (0, $97e72655060ed469$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.nativeStorage, validRequest.correlationId);
                const { userRequestState: userRequestState } = (0, $9523def209bc6e1a$export$871e33217042c65e).parseRequestState(this.browserCrypto, validRequest.state);
                return await nativeInteractionClient.acquireToken({
                    ...validRequest,
                    state: userRequestState,
                    prompt: undefined
                });
            }
            // Handle response from hash string.
            const result = await interactionHandler.handleCodeResponse(serverParams, validRequest);
            return result;
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $40da14d5d49dd285$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */ async logoutPopupAsync(validRequest, popupParams, requestAuthority, mainWindowRedirectUri) {
        this.logger.verbose("logoutPopupAsync called");
        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, validRequest);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $e195f599725a9f25$export$192d74ad69b40705).logoutPopup);
        try {
            // Clear cache on logout
            await this.clearCacheOnLogout(validRequest.account);
            // Initialize the client
            const authClient = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: requestAuthority,
                account: validRequest.account || undefined
            });
            try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validRequest.account?.homeAccountId && validRequest.postLogoutRedirectUri && authClient.authority.protocolMode === (0, $340831fc14c31b77$export$73a3e3dedd37150d).OIDC) {
                    this.browserStorage.removeAccount(validRequest.account?.homeAccountId);
                    this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, validRequest);
                    if (mainWindowRedirectUri) {
                        const navigationOptions = {
                            apiId: (0, $e195f599725a9f25$export$192d74ad69b40705).logoutPopup,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        const absoluteUrl = (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $d618406b813d26cc$export$1204531fbbf6ecde)());
                        await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                    }
                    popupParams.popup?.close();
                    return;
                }
            }
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validRequest);
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, validRequest);
            // Open the popup window to requestUrl.
            const popupWindow = this.openPopup(logoutUri, popupParams);
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).POPUP_OPENED, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, {
                popupWindow: popupWindow
            }, null);
            await this.monitorPopupForHash(popupWindow, popupParams.popupWindowParent).catch(()=>{
            // Swallow any errors related to monitoring the window. Server logout is best effort
            });
            if (mainWindowRedirectUri) {
                const navigationOptions = {
                    apiId: (0, $e195f599725a9f25$export$192d74ad69b40705).logoutPopup,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: false
                };
                const absoluteUrl = (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $d618406b813d26cc$export$1204531fbbf6ecde)());
                this.logger.verbose("Redirecting main window to url specified in the request");
                this.logger.verbosePii(`Redirecting main window to: ${absoluteUrl}`);
                await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
            } else this.logger.verbose("No main window navigation requested");
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $40da14d5d49dd285$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.browserStorage.setInteractionInProgress(false);
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, null, e);
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_END, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup);
            throw e;
        }
        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_END, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup);
    }
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */ initiateAuthRequest(requestUrl, params) {
        // Check that request url is not empty.
        if (requestUrl) {
            this.logger.infoPii(`Navigate to: ${requestUrl}`);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        } else {
            // Throw error if request URL is empty.
            this.logger.error("Navigate url is empty");
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$be9285c64f247822));
        }
    }
    /**
     * Monitors a window until it loads a url with the same origin.
     * @param popupWindow - window that is being monitored
     * @param timeout - timeout for processing hash once popup is redirected back to application
     */ monitorPopupForHash(popupWindow, popupWindowParent) {
        return new Promise((resolve, reject)=>{
            this.logger.verbose("PopupHandler.monitorPopupForHash - polling started");
            const intervalId = setInterval(()=>{
                // Window is closed
                if (popupWindow.closed) {
                    this.logger.error("PopupHandler.monitorPopupForHash - window closed");
                    clearInterval(intervalId);
                    reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$6bae303c5e922702)));
                    return;
                }
                let href = "";
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */ href = popupWindow.location.href;
                } catch (e) {}
                // Don't process blank pages or cross domain
                if (!href || href === "about:blank") return;
                clearInterval(intervalId);
                let responseString = "";
                const responseType = this.config.auth.OIDCOptions.serverResponseType;
                if (popupWindow) {
                    if (responseType === (0, $e6f7ad11e10d0573$export$b34cb6fbea2adc44).QUERY) responseString = popupWindow.location.search;
                    else responseString = popupWindow.location.hash;
                }
                this.logger.verbose("PopupHandler.monitorPopupForHash - popup window is on same origin as caller");
                resolve(responseString);
            }, this.config.system.pollIntervalMilliseconds);
        }).finally(()=>{
            this.cleanPopup(popupWindow, popupWindowParent);
        });
    }
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */ openPopup(urlNavigate, popupParams) {
        try {
            let popupWindow;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii(`Navigating popup window to: ${urlNavigate}`);
                popupWindow.location.assign(urlNavigate);
            } else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii(`Opening popup window to: ${urlNavigate}`);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$5e827e513523a576));
            if (popupWindow.focus) popupWindow.focus();
            this.currentWindow = popupWindow;
            popupParams.popupWindowParent.addEventListener("beforeunload", this.unloadWindow);
            return popupWindow;
        } catch (e) {
            this.logger.error("error opening popup " + e.message);
            this.browserStorage.setInteractionInProgress(false);
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$f1b7091ee48d0b3e));
        }
    }
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */ openSizedPopup(urlNavigate, { popupName: popupName, popupWindowAttributes: popupWindowAttributes, popupWindowParent: popupWindowParent }) {
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */ const winLeft = popupWindowParent.screenLeft ? popupWindowParent.screenLeft : popupWindowParent.screenX;
        const winTop = popupWindowParent.screenTop ? popupWindowParent.screenTop : popupWindowParent.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */ const winWidth = popupWindowParent.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const winHeight = popupWindowParent.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let width = popupWindowAttributes.popupSize?.width;
        let height = popupWindowAttributes.popupSize?.height;
        let top = popupWindowAttributes.popupPosition?.top;
        let left = popupWindowAttributes.popupPosition?.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("Default popup window width used. Window width not configured or invalid.");
            width = (0, $e195f599725a9f25$export$a0a689e4294b9880).POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("Default popup window height used. Window height not configured or invalid.");
            height = (0, $e195f599725a9f25$export$a0a689e4294b9880).POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("Default popup window top position used. Window top not configured or invalid.");
            top = Math.max(0, winHeight / 2 - (0, $e195f599725a9f25$export$a0a689e4294b9880).POPUP_HEIGHT / 2 + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("Default popup window left position used. Window left not configured or invalid.");
            left = Math.max(0, winWidth / 2 - (0, $e195f599725a9f25$export$a0a689e4294b9880).POPUP_WIDTH / 2 + winLeft);
        }
        return popupWindowParent.open(urlNavigate, popupName, `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=yes`);
    }
    /**
     * Event callback to unload main window.
     */ unloadWindow(e) {
        this.browserStorage.cleanRequestByInteractionType((0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup);
        if (this.currentWindow) this.currentWindow.close();
        // Guarantees browser unload will happen, so no other errors will be thrown.
        e.preventDefault();
    }
    /**
     * Closes popup, removes any state vars created during popup calls.
     * @param popupWindow
     */ cleanPopup(popupWindow, popupWindowParent) {
        // Close window.
        popupWindow.close();
        // Remove window unload function
        popupWindowParent.removeEventListener("beforeunload", this.unloadWindow);
        // Interaction is completed - remove interaction status.
        this.browserStorage.setInteractionInProgress(false);
    }
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */ generatePopupName(scopes, authority) {
        return `${(0, $e195f599725a9f25$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${scopes.join("-")}.${authority}.${this.correlationId}`;
    }
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */ generateLogoutPopupName(request) {
        const homeAccountId = request.account && request.account.homeAccountId;
        return `${(0, $e195f599725a9f25$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${homeAccountId}.${this.correlationId}`;
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $3e80571e2eab2170$export$9af91951fcedc08c {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     */ async initiateAuthRequest(requestUrl, params) {
        this.logger.verbose("RedirectHandler.initiateAuthRequest called");
        // Navigate if valid URL
        if (requestUrl) {
            // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
            if (params.redirectStartPage) {
                this.logger.verbose("RedirectHandler.initiateAuthRequest: redirectStartPage set, caching start page");
                this.browserStorage.setTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).ORIGIN_URI, params.redirectStartPage, true);
            }
            // Set interaction status in the library.
            this.browserStorage.setTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).CORRELATION_ID, this.authCodeRequest.correlationId, true);
            this.browserStorage.cacheCodeRequest(this.authCodeRequest);
            this.logger.infoPii(`RedirectHandler.initiateAuthRequest: Navigate to: ${requestUrl}`);
            const navigationOptions = {
                apiId: (0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenRedirect,
                timeout: params.redirectTimeout,
                noHistory: false
            };
            // If onRedirectNavigate is implemented, invoke it and provide requestUrl
            if (typeof params.onRedirectNavigate === "function") {
                this.logger.verbose("RedirectHandler.initiateAuthRequest: Invoking onRedirectNavigate callback");
                const navigate = params.onRedirectNavigate(requestUrl);
                // Returning false from onRedirectNavigate will stop navigation
                if (navigate !== false) {
                    this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate did not return false, navigating");
                    await params.navigationClient.navigateExternal(requestUrl, navigationOptions);
                    return;
                } else {
                    this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate returned false, stopping navigation");
                    return;
                }
            } else {
                // Navigate window to request URL
                this.logger.verbose("RedirectHandler.initiateAuthRequest: Navigating window to navigate url");
                await params.navigationClient.navigateExternal(requestUrl, navigationOptions);
                return;
            }
        } else {
            // Throw error if request URL is empty.
            this.logger.info("RedirectHandler.initiateAuthRequest: Navigate url is empty");
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$be9285c64f247822));
        }
    }
    /**
     * Handle authorization code response in the window.
     * @param hash
     */ async handleCodeResponse(response, state) {
        this.logger.verbose("RedirectHandler.handleCodeResponse called");
        // Interaction is completed - remove interaction status.
        this.browserStorage.setInteractionInProgress(false);
        // Handle code response.
        const stateKey = this.browserStorage.generateStateKey(state);
        const requestState = this.browserStorage.getTemporaryCache(stateKey);
        if (!requestState) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$exports).stateNotFound, "Cached State");
        let authCodeResponse;
        try {
            authCodeResponse = this.authModule.handleFragmentResponse(response, requestState);
        } catch (e) {
            if (e instanceof (0, $0463942371f4715f$export$ea52035eac03daf0) && e.subError === (0, $8e6ba27e37631a08$export$6bae303c5e922702)) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$6bae303c5e922702));
            else throw e;
        }
        // Get cached items
        const nonceKey = this.browserStorage.generateNonceKey(requestState);
        const cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Check for new cloud instance
        if (authCodeResponse.cloud_instance_host_name) await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.authModule.updateAuthority.bind(this.authModule), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.logger, this.performanceClient, this.authCodeRequest.correlationId)(authCodeResponse.cloud_instance_host_name, this.authCodeRequest.correlationId);
        authCodeResponse.nonce = cachedNonce || undefined;
        authCodeResponse.state = requestState;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const cachedCcsCred = this.checkCcsCredentials();
            if (cachedCcsCred) this.authCodeRequest.ccsCredential = cachedCcsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await this.authModule.acquireToken(this.authCodeRequest, authCodeResponse);
        this.browserStorage.cleanRequestByState(state);
        return tokenResponse;
    }
    /**
     * Looks up ccs creds in the cache
     */ checkCcsCredentials() {
        // Look up ccs credential in temp cache
        const cachedCcsCred = this.browserStorage.getTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).CCS_CREDENTIAL, true);
        if (cachedCcsCred) try {
            return JSON.parse(cachedCcsCred);
        } catch (e) {
            this.authModule.logger.error("Cache credential could not be parsed");
            this.authModule.logger.errorPii(`Cache credential could not be parsed: ${cachedCcsCred}`);
        }
        return null;
    }
}









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $f53e47f571a14d67$var$getNavigationType() {
    if (typeof window === "undefined" || typeof window.performance === "undefined" || typeof window.performance.getEntriesByType !== "function") return undefined;
    const navigationEntries = window.performance.getEntriesByType("navigation");
    const navigation = navigationEntries.length ? navigationEntries[0] : undefined;
    return navigation?.type;
}
class $f53e47f571a14d67$export$a368977effbc1ed6 extends (0, $aed111b4f4b5e49c$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */ async acquireToken(request) {
        const validRequest = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect);
        this.browserStorage.updateCacheEntries(validRequest.state, validRequest.nonce, validRequest.authority, validRequest.loginHint || "", validRequest.account || null);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenRedirect);
        const handleBackButton = (event)=>{
            // Clear temporary cache if the back button is clicked during the redirect flow.
            if (event.persisted) {
                this.logger.verbose("Page was restored from back/forward cache. Clearing temporary cache.");
                this.browserStorage.cleanRequestByState(validRequest.state);
                this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).RESTORE_FROM_BFCACHE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect);
            }
        };
        try {
            // Create auth code request and generate PKCE params
            const authCodeRequest = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.initializeAuthorizationCodeRequest.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, this.logger, this.performanceClient, this.correlationId)(validRequest);
            // Initialize the client
            const authClient = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: validRequest.authority,
                requestAzureCloudOptions: validRequest.azureCloudOptions,
                requestExtraQueryParameters: validRequest.extraQueryParameters,
                account: validRequest.account
            });
            // Create redirect interaction handler.
            const interactionHandler = new (0, $3e80571e2eab2170$export$9af91951fcedc08c)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Create acquire token url.
            const navigateUrl = await authClient.getAuthCodeUrl({
                ...validRequest,
                nativeBroker: (0, $dd55ff53bd487fbc$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, request.authenticationScheme)
            });
            const redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
            this.logger.verbosePii(`Redirect start page: ${redirectStartPage}`);
            // Clear temporary cache if the back button is clicked during the redirect flow.
            window.addEventListener("pageshow", handleBackButton);
            // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
            return await interactionHandler.initiateAuthRequest(navigateUrl, {
                navigationClient: this.navigationClient,
                redirectTimeout: this.config.system.redirectNavigationTimeout,
                redirectStartPage: redirectStartPage,
                onRedirectNavigate: request.onRedirectNavigate || this.config.auth.onRedirectNavigate
            });
        } catch (e) {
            if (e instanceof (0, $40da14d5d49dd285$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            window.removeEventListener("pageshow", handleBackButton);
            this.browserStorage.cleanRequestByState(validRequest.state);
            throw e;
        }
    }
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash {string} url hash
     * @param parentMeasurement {InProgressPerformanceEvent} parent measurement
     */ async handleRedirectPromise(hash = "", parentMeasurement) {
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $e195f599725a9f25$export$192d74ad69b40705).handleRedirectPromise);
        try {
            if (!this.browserStorage.isInteractionInProgress(true)) {
                this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
                return null;
            }
            const [serverParams, responseString] = this.getRedirectResponse(hash || "");
            if (!serverParams) {
                // Not a recognized server response hash or hash not associated with a redirect request
                this.logger.info("handleRedirectPromise did not detect a response as a result of a redirect. Cleaning temporary cache.");
                this.browserStorage.cleanRequestByInteractionType((0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect);
                // Do not instrument "no_server_response" if user clicked back button
                if ($f53e47f571a14d67$var$getNavigationType() !== "back_forward") parentMeasurement.event.errorCode = "no_server_response";
                else this.logger.verbose("Back navigation event detected. Muting no_server_response error");
                return null;
            }
            // If navigateToLoginRequestUrl is true, get the url where the redirect request was initiated
            const loginRequestUrl = this.browserStorage.getTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).ORIGIN_URI, true) || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
            const loginRequestUrlNormalized = (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).removeHashFromUrl(loginRequestUrl);
            const currentUrlNormalized = (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).removeHashFromUrl(window.location.href);
            if (loginRequestUrlNormalized === currentUrlNormalized && this.config.auth.navigateToLoginRequestUrl) {
                // We are on the page we need to navigate to - handle hash
                this.logger.verbose("Current page is loginRequestUrl, handling response");
                if (loginRequestUrl.indexOf("#") > -1) // Replace current hash with non-msal hash, if present
                (0, $d618406b813d26cc$export$9bf2691bda54425c)(loginRequestUrl);
                const handleHashResult = await this.handleResponse(serverParams, serverTelemetryManager);
                return handleHashResult;
            } else if (!this.config.auth.navigateToLoginRequestUrl) {
                this.logger.verbose("NavigateToLoginRequestUrl set to false, handling response");
                return await this.handleResponse(serverParams, serverTelemetryManager);
            } else if (!(0, $d618406b813d26cc$export$9f140ed41af5108c)() || this.config.system.allowRedirectInIframe) {
                /*
                 * Returned from authority using redirect - need to perform navigation before processing response
                 * Cache the hash to be retrieved after the next redirect
                 */ this.browserStorage.setTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).URL_HASH, responseString, true);
                const navigationOptions = {
                    apiId: (0, $e195f599725a9f25$export$192d74ad69b40705).handleRedirectPromise,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: true
                };
                /**
                 * Default behavior is to redirect to the start page and not process the hash now.
                 * The start page is expected to also call handleRedirectPromise which will process the hash in one of the checks above.
                 */ let processHashOnRedirect = true;
                if (!loginRequestUrl || loginRequestUrl === "null") {
                    // Redirect to home page if login request url is null (real null or the string null)
                    const homepage = (0, $d618406b813d26cc$export$60785768478b4ffc)();
                    // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                    this.browserStorage.setTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).ORIGIN_URI, homepage, true);
                    this.logger.warning("Unable to get valid login request url from cache, redirecting to home page");
                    processHashOnRedirect = await this.navigationClient.navigateInternal(homepage, navigationOptions);
                } else {
                    // Navigate to page that initiated the redirect request
                    this.logger.verbose(`Navigating to loginRequestUrl: ${loginRequestUrl}`);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions);
                }
                // If navigateInternal implementation returns false, handle the hash now
                if (!processHashOnRedirect) return await this.handleResponse(serverParams, serverTelemetryManager);
            }
            return null;
        } catch (e) {
            if (e instanceof (0, $40da14d5d49dd285$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.browserStorage.cleanRequestByInteractionType((0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect);
            throw e;
        }
    }
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */ getRedirectResponse(userProvidedResponse) {
        this.logger.verbose("getRedirectResponseHash called");
        // Get current location hash from window or cache.
        let responseString = userProvidedResponse;
        if (!responseString) {
            if (this.config.auth.OIDCOptions.serverResponseType === (0, $e6f7ad11e10d0573$export$b34cb6fbea2adc44).QUERY) responseString = window.location.search;
            else responseString = window.location.hash;
        }
        let response = (0, $734d5def052f4ce7$exports).getDeserializedResponse(responseString);
        if (response) {
            try {
                (0, $d1ba9120170867a9$export$af0c72d18284aa0)(response, this.browserCrypto, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect);
            } catch (e) {
                if (e instanceof (0, $40da14d5d49dd285$export$145273558d58e0ac)) this.logger.error(`Interaction type validation failed due to ${e.errorCode}: ${e.errorMessage}`);
                return [
                    null,
                    ""
                ];
            }
            (0, $d618406b813d26cc$export$a20c3032ba81d6aa)(window);
            this.logger.verbose("Hash contains known properties, returning response hash");
            return [
                response,
                responseString
            ];
        }
        const cachedHash = this.browserStorage.getTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).URL_HASH, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $e195f599725a9f25$export$21d55bedf0d269fb).URL_HASH));
        if (cachedHash) {
            response = (0, $734d5def052f4ce7$exports).getDeserializedResponse(cachedHash);
            if (response) {
                this.logger.verbose("Hash does not contain known properties, returning cached hash");
                return [
                    response,
                    cachedHash
                ];
            }
        }
        return [
            null,
            ""
        ];
    }
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */ async handleResponse(serverParams, serverTelemetryManager) {
        const state = serverParams.state;
        if (!state) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$211c8e8843a8d278));
        const cachedRequest = this.browserStorage.getCachedRequest(state);
        this.logger.verbose("handleResponse called, retrieved cached request");
        if (serverParams.accountId) {
            this.logger.verbose("Account id found in hash, calling WAM for token");
            if (!this.nativeMessageHandler) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$7b7357e3538624aa));
            const nativeInteractionClient = new (0, $97e72655060ed469$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.nativeStorage, cachedRequest.correlationId);
            const { userRequestState: userRequestState } = (0, $9523def209bc6e1a$export$871e33217042c65e).parseRequestState(this.browserCrypto, state);
            return nativeInteractionClient.acquireToken({
                ...cachedRequest,
                state: userRequestState,
                prompt: undefined
            }).finally(()=>{
                this.browserStorage.cleanRequestByState(state);
            });
        }
        // Hash contains known properties - handle and return in callback
        const currentAuthority = this.browserStorage.getCachedAuthority(state);
        if (!currentAuthority) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$3a2c83e7753553b));
        const authClient = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: currentAuthority
        });
        (0, $8868e8edc76d69b4$export$c060a619741dd765).removeThrottle(this.browserStorage, this.config.auth.clientId, cachedRequest);
        const interactionHandler = new (0, $3e80571e2eab2170$export$9af91951fcedc08c)(authClient, this.browserStorage, cachedRequest, this.logger, this.performanceClient);
        return interactionHandler.handleCodeResponse(serverParams, state);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logout(logoutRequest) {
        this.logger.verbose("logoutRedirect called");
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $e195f599725a9f25$export$192d74ad69b40705).logout);
        try {
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect, logoutRequest);
            // Clear cache on logout
            await this.clearCacheOnLogout(validLogoutRequest.account);
            const navigationOptions = {
                apiId: (0, $e195f599725a9f25$export$192d74ad69b40705).logout,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const authClient = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: logoutRequest && logoutRequest.authority,
                requestExtraQueryParameters: logoutRequest?.extraQueryParameters,
                account: logoutRequest && logoutRequest.account || undefined
            });
            if (authClient.authority.protocolMode === (0, $340831fc14c31b77$export$73a3e3dedd37150d).OIDC) try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validLogoutRequest.account?.homeAccountId) {
                    this.browserStorage.removeAccount(validLogoutRequest.account?.homeAccountId);
                    this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
                    return;
                }
            }
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validLogoutRequest);
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
            // Check if onRedirectNavigate is implemented, and invoke it if so
            if (logoutRequest && typeof logoutRequest.onRedirectNavigate === "function") {
                const navigate = logoutRequest.onRedirectNavigate(logoutUri);
                if (navigate !== false) {
                    this.logger.verbose("Logout onRedirectNavigate did not return false, navigating");
                    // Ensure interaction is in progress
                    if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true);
                    await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                    return;
                } else {
                    // Ensure interaction is not in progress
                    this.browserStorage.setInteractionInProgress(false);
                    this.logger.verbose("Logout onRedirectNavigate returned false, stopping navigation");
                }
            } else {
                // Ensure interaction is in progress
                if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true);
                await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                return;
            }
        } catch (e) {
            if (e instanceof (0, $40da14d5d49dd285$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect, null, e);
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_END, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect);
            throw e;
        }
        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGOUT_END, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect);
    }
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */ getRedirectStartPage(requestStartPage) {
        const redirectStartPage = requestStartPage || window.location.href;
        return (0, $5f4178fddc0d4f8b$export$3abcdca7229e54f2).getAbsoluteUrl(redirectStartPage, (0, $d618406b813d26cc$export$1204531fbbf6ecde)());
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 



/*! @azure/msal-browser v3.27.0 2024-11-05 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Creates a hidden iframe to given URL using user-requested scopes as an id.
 * @param urlNavigate
 * @param userRequestScopes
 */ async function $a5dc47386756a313$export$57f8a7967bf66c8e(requestUrl, performanceClient, logger, correlationId, navigateFrameWait) {
    performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, correlationId);
    if (!requestUrl) {
        // Throw error if request URL is empty.
        logger.info("Navigate url is empty");
        throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$be9285c64f247822));
    }
    if (navigateFrameWait) return (0, $ae433257996980ce$export$e4feded94d9adb18)($a5dc47386756a313$var$loadFrame, (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentHandlerLoadFrame, logger, performanceClient, correlationId)(requestUrl, navigateFrameWait, performanceClient, correlationId);
    return (0, $ae433257996980ce$export$468cda29b159ee5d)($a5dc47386756a313$var$loadFrameSync, (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentHandlerLoadFrameSync, logger, performanceClient, correlationId)(requestUrl);
}
/**
 * Monitors an iframe content window until it loads a url with a known hash, or hits a specified timeout.
 * @param iframe
 * @param timeout
 */ async function $a5dc47386756a313$export$9ee275d2f26db8a7(iframe, timeout, pollIntervalMilliseconds, performanceClient, logger, correlationId, responseType) {
    performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, correlationId);
    return new Promise((resolve, reject)=>{
        if (timeout < (0, $0808630523d62b54$export$f3ffe700be354b19)) logger.warning(`system.loadFrameTimeout or system.iframeHashTimeout set to lower (${timeout}ms) than the default (${(0, $0808630523d62b54$export$f3ffe700be354b19)}ms). This may result in timeouts.`);
        /*
         * Polling for iframes can be purely timing based,
         * since we don't need to account for interaction.
         */ const timeoutId = window.setTimeout(()=>{
            window.clearInterval(intervalId);
            reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$c8b6efb19551013d)));
        }, timeout);
        const intervalId = window.setInterval(()=>{
            let href = "";
            const contentWindow = iframe.contentWindow;
            try {
                /*
                 * Will throw if cross origin,
                 * which should be caught and ignored
                 * since we need the interval to keep running while on STS UI.
                 */ href = contentWindow ? contentWindow.location.href : "";
            } catch (e) {}
            if (!href || href === "about:blank") return;
            let responseString = "";
            if (contentWindow) {
                if (responseType === (0, $e6f7ad11e10d0573$export$b34cb6fbea2adc44).QUERY) responseString = contentWindow.location.search;
                else responseString = contentWindow.location.hash;
            }
            window.clearTimeout(timeoutId);
            window.clearInterval(intervalId);
            resolve(responseString);
        }, pollIntervalMilliseconds);
    }).finally(()=>{
        (0, $ae433257996980ce$export$468cda29b159ee5d)($a5dc47386756a313$var$removeHiddenIframe, (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RemoveHiddenIframe, logger, performanceClient, correlationId)(iframe);
    });
}
/**
 * @hidden
 * Loads iframe with authorization endpoint URL
 * @ignore
 * @deprecated
 */ function $a5dc47386756a313$var$loadFrame(urlNavigate, navigateFrameWait, performanceClient, correlationId) {
    performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentHandlerLoadFrame, correlationId);
    /*
     * This trick overcomes iframe navigation in IE
     * IE does not load the page consistently in iframe
     */ return new Promise((resolve, reject)=>{
        const frameHandle = $a5dc47386756a313$var$createHiddenIframe();
        window.setTimeout(()=>{
            if (!frameHandle) {
                reject("Unable to load iframe");
                return;
            }
            frameHandle.src = urlNavigate;
            resolve(frameHandle);
        }, navigateFrameWait);
    });
}
/**
 * @hidden
 * Loads the iframe synchronously when the navigateTimeFrame is set to `0`
 * @param urlNavigate
 * @param frameName
 * @param logger
 */ function $a5dc47386756a313$var$loadFrameSync(urlNavigate) {
    const frameHandle = $a5dc47386756a313$var$createHiddenIframe();
    frameHandle.src = urlNavigate;
    return frameHandle;
}
/**
 * @hidden
 * Creates a new hidden iframe or gets an existing one for silent token renewal.
 * @ignore
 */ function $a5dc47386756a313$var$createHiddenIframe() {
    const authFrame = document.createElement("iframe");
    authFrame.className = "msalSilentIframe";
    authFrame.style.visibility = "hidden";
    authFrame.style.position = "absolute";
    authFrame.style.width = authFrame.style.height = "0";
    authFrame.style.border = "0";
    authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
    document.body.appendChild(authFrame);
    return authFrame;
}
/**
 * @hidden
 * Removes a hidden iframe from the page.
 * @ignore
 */ function $a5dc47386756a313$var$removeHiddenIframe(iframe) {
    if (document.body === iframe.parentNode) document.body.removeChild(iframe);
}








'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $7d014bebb8aad3ae$export$e81c7938bccef977 extends (0, $aed111b4f4b5e49c$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId);
        this.apiId = apiId;
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
        // Check that we have some SSO data
        if (!request.loginHint && !request.sid && (!request.account || !request.account.username)) this.logger.warning("No user hint provided. The authorization server may need more information to complete this request.");
        // Check the prompt value
        const inputRequest = {
            ...request
        };
        if (inputRequest.prompt) {
            if (inputRequest.prompt !== (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).NONE && inputRequest.prompt !== (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).NO_SESSION) {
                this.logger.warning(`SilentIframeClient. Replacing invalid prompt ${inputRequest.prompt} with ${(0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).NONE}`);
                inputRequest.prompt = (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).NONE;
            }
        } else inputRequest.prompt = (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).NONE;
        // Create silent request
        const silentRequest = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(inputRequest, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent);
        (0, $d618406b813d26cc$export$a0816fa17a9e79be)(silentRequest.authority);
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        let authClient;
        try {
            // Initialize the client
            authClient = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            return await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, this.logger, this.performanceClient, request.correlationId)(authClient, silentRequest);
        } catch (e) {
            if (e instanceof (0, $40da14d5d49dd285$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            if (!authClient || !(e instanceof (0, $40da14d5d49dd285$export$145273558d58e0ac)) || e.errorCode !== (0, $e195f599725a9f25$export$a0a689e4294b9880).INVALID_GRANT_ERROR) throw e;
            this.performanceClient.addFields({
                retryError: e.errorCode
            }, this.correlationId);
            const retrySilentRequest = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(inputRequest, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent);
            return await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, this.logger, this.performanceClient, this.correlationId)(authClient, retrySilentRequest);
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$78523a40be105a03)));
    }
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */ async silentTokenHelper(authClient, silentRequest) {
        const correlationId = silentRequest.correlationId;
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, correlationId);
        // Create auth code request and generate PKCE params
        const authCodeRequest = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.initializeAuthorizationCodeRequest.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, this.logger, this.performanceClient, correlationId)(silentRequest);
        // Create authorize request url
        const navigateUrl = await (0, $ae433257996980ce$export$e4feded94d9adb18)(authClient.getAuthCodeUrl.bind(authClient), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)({
            ...silentRequest,
            nativeBroker: (0, $dd55ff53bd487fbc$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, silentRequest.authenticationScheme)
        });
        // Create silent handler
        const interactionHandler = new (0, $4936d5fa007125a3$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
        // Get the frame handle for the silent request
        const msalFrame = await (0, $ae433257996980ce$export$e4feded94d9adb18)((0, $a5dc47386756a313$export$57f8a7967bf66c8e), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(navigateUrl, this.performanceClient, this.logger, correlationId, this.config.system.navigateFrameWait);
        const responseType = this.config.auth.OIDCOptions.serverResponseType;
        // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $ae433257996980ce$export$e4feded94d9adb18)((0, $a5dc47386756a313$export$9ee275d2f26db8a7), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(msalFrame, this.config.system.iframeHashTimeout, this.config.system.pollIntervalMilliseconds, this.performanceClient, this.logger, correlationId, responseType);
        const serverParams = (0, $ae433257996980ce$export$468cda29b159ee5d)((0, $d1ba9120170867a9$export$e64c1808ed72a7c), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, responseType, this.logger);
        if (serverParams.accountId) {
            this.logger.verbose("Account id found in hash, calling WAM for token");
            if (!this.nativeMessageHandler) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$7b7357e3538624aa));
            const nativeInteractionClient = new (0, $97e72655060ed469$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.apiId, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.browserStorage, correlationId);
            const { userRequestState: userRequestState } = (0, $9523def209bc6e1a$export$871e33217042c65e).parseRequestState(this.browserCrypto, silentRequest.state);
            return (0, $ae433257996980ce$export$e4feded94d9adb18)(nativeInteractionClient.acquireToken.bind(nativeInteractionClient), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, this.logger, this.performanceClient, correlationId)({
                ...silentRequest,
                state: userRequestState,
                prompt: silentRequest.prompt || (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).NONE
            });
        }
        // Handle response from hash string
        return (0, $ae433257996980ce$export$e4feded94d9adb18)(interactionHandler.handleCodeResponse.bind(interactionHandler), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).HandleCodeResponse, this.logger, this.performanceClient, correlationId)(serverParams, silentRequest);
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $a3d2e2498f5dacc0$export$b4a36596822a5d2 extends (0, $aed111b4f4b5e49c$export$fa9179cade3eb05a) {
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, request.correlationId);
        const baseRequest = await (0, $ae433257996980ce$export$e4feded94d9adb18)((0, $5f86e728968c03f1$export$8e461fcf1fd6910b), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).InitializeBaseRequest, this.logger, this.performanceClient, request.correlationId)(request, this.config, this.performanceClient, this.logger);
        const silentRequest = {
            ...request,
            ...baseRequest
        };
        if (request.redirectUri) // Make sure any passed redirectUri is converted to an absolute URL - redirectUri is not a required parameter for refresh token redemption so only include if explicitly provided
        silentRequest.redirectUri = this.getRedirectUri(request.redirectUri);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
        const refreshTokenClient = await this.createRefreshTokenClient({
            serverTelemetryManager: serverTelemetryManager,
            authorityUrl: silentRequest.authority,
            azureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
        return (0, $ae433257996980ce$export$e4feded94d9adb18)(refreshTokenClient.acquireTokenByRefreshToken.bind(refreshTokenClient), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, this.logger, this.performanceClient, request.correlationId)(silentRequest).catch((e)=>{
            e.setCorrelationId(this.correlationId);
            serverTelemetryManager.cacheFailedRequest(e);
            throw e;
        });
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$78523a40be105a03)));
    }
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         azureCloudOptions?: AzureCloudOptions;
     *         extraQueryParams?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createRefreshTokenClient(params) {
        // Create auth module.
        const clientConfig = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: params.serverTelemetryManager,
            requestAuthority: params.authorityUrl,
            requestAzureCloudOptions: params.azureCloudOptions,
            requestExtraQueryParameters: params.extraQueryParameters,
            account: params.account
        });
        return new (0, $e03fe61a6af8489a$export$9cb096b89b92d8a8)(clientConfig, this.performanceClient);
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Token cache manager
 */ class $ea3e574c1faff6dc$export$ed5d1a18907a1001 {
    constructor(configuration, storage, logger, cryptoObj){
        this.isBrowserEnvironment = typeof window !== "undefined";
        this.config = configuration;
        this.storage = storage;
        this.logger = logger;
        this.cryptoObj = cryptoObj;
    }
    // Move getAllAccounts here and cache utility APIs
    /**
     * API to load tokens to msal-browser cache.
     * @param request
     * @param response
     * @param options
     * @returns `AuthenticationResult` for the response that was loaded.
     */ loadExternalTokens(request, response, options) {
        if (!this.isBrowserEnvironment) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$932e0f52d657f7fb));
        const idTokenClaims = response.id_token ? (0, $dbb12b3851d257af$exports).extractTokenClaims(response.id_token, (0, $bb6fd55178ea2979$export$c62426fdd000a97e)) : undefined;
        const authorityOptions = {
            protocolMode: this.config.auth.protocolMode,
            knownAuthorities: this.config.auth.knownAuthorities,
            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
            authorityMetadata: this.config.auth.authorityMetadata,
            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
        };
        const authority = request.authority ? new (0, $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c)((0, $2d706f1a340b3c1d$export$f1c6ec2e6d68c49c).generateAuthority(request.authority, request.azureCloudOptions), this.config.system.networkClient, this.storage, authorityOptions, this.logger, request.correlationId || (0, $a65ce7794137937d$export$6ef0355fa80a5278)()) : undefined;
        const cacheRecordAccount = this.loadAccount(request, options.clientInfo || response.client_info || "", idTokenClaims, authority);
        const idToken = this.loadIdToken(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm);
        const accessToken = this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, options);
        const refreshToken = this.loadRefreshToken(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment);
        return this.generateAuthenticationResult(request, {
            account: cacheRecordAccount,
            idToken: idToken,
            accessToken: accessToken,
            refreshToken: refreshToken
        }, idTokenClaims, authority);
    }
    /**
     * Helper function to load account to msal-browser cache
     * @param idToken
     * @param environment
     * @param clientInfo
     * @param authorityType
     * @param requestHomeAccountId
     * @returns `AccountEntity`
     */ loadAccount(request, clientInfo, idTokenClaims, authority) {
        this.logger.verbose("TokenCache - loading account");
        if (request.account) {
            const accountEntity = (0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).createFromAccountInfo(request.account);
            this.storage.setAccount(accountEntity);
            return accountEntity;
        } else if (!authority || !clientInfo && !idTokenClaims) {
            this.logger.error("TokenCache - if an account is not provided on the request, authority and either clientInfo or idToken must be provided instead.");
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$6acf650331eb5f5f));
        }
        const homeAccountId = (0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).generateHomeAccountId(clientInfo, authority.authorityType, this.logger, this.cryptoObj, idTokenClaims);
        const claimsTenantId = idTokenClaims?.tid;
        const cachedAccount = (0, $7b0e3b4066211abb$export$73b84062d58a1307)(this.storage, authority, homeAccountId, (0, $bb6fd55178ea2979$export$c62426fdd000a97e), idTokenClaims, clientInfo, authority.hostnameAndPort, claimsTenantId, undefined, undefined, this.logger);
        this.storage.setAccount(cachedAccount);
        return cachedAccount;
    }
    /**
     * Helper function to load id tokens to msal-browser cache
     * @param idToken
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `IdTokenEntity`
     */ loadIdToken(response, homeAccountId, environment, tenantId) {
        if (!response.id_token) {
            this.logger.verbose("TokenCache - no id token found in response");
            return null;
        }
        this.logger.verbose("TokenCache - loading id token");
        const idTokenEntity = (0, $d6bc4864bb049bc4$exports).createIdTokenEntity(homeAccountId, environment, response.id_token, this.config.auth.clientId, tenantId);
        this.storage.setIdTokenCredential(idTokenEntity);
        return idTokenEntity;
    }
    /**
     * Helper function to load access tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `AccessTokenEntity`
     */ loadAccessToken(request, response, homeAccountId, environment, tenantId, options) {
        if (!response.access_token) {
            this.logger.verbose("TokenCache - no access token found in response");
            return null;
        } else if (!response.expires_in) {
            this.logger.error("TokenCache - no expiration set on the access token. Cannot add it to the cache.");
            return null;
        } else if (!response.scope && (!request.scopes || !request.scopes.length)) {
            this.logger.error("TokenCache - scopes not specified in the request or response. Cannot add token to the cache.");
            return null;
        }
        this.logger.verbose("TokenCache - loading access token");
        const scopes = response.scope ? (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).fromString(response.scope) : new (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99)(request.scopes);
        const expiresOn = options.expiresOn || response.expires_in + new Date().getTime() / 1000;
        const extendedExpiresOn = options.extendedExpiresOn || (response.ext_expires_in || response.expires_in) + new Date().getTime() / 1000;
        const accessTokenEntity = (0, $d6bc4864bb049bc4$exports).createAccessTokenEntity(homeAccountId, environment, response.access_token, this.config.auth.clientId, tenantId, scopes.printScopes(), expiresOn, extendedExpiresOn, (0, $bb6fd55178ea2979$export$c62426fdd000a97e));
        this.storage.setAccessTokenCredential(accessTokenEntity);
        return accessTokenEntity;
    }
    /**
     * Helper function to load refresh tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @returns `RefreshTokenEntity`
     */ loadRefreshToken(response, homeAccountId, environment) {
        if (!response.refresh_token) {
            this.logger.verbose("TokenCache - no refresh token found in response");
            return null;
        }
        this.logger.verbose("TokenCache - loading refresh token");
        const refreshTokenEntity = (0, $d6bc4864bb049bc4$exports).createRefreshTokenEntity(homeAccountId, environment, response.refresh_token, this.config.auth.clientId, response.foci, undefined, response.refresh_token_expires_in);
        this.storage.setRefreshTokenCredential(refreshTokenEntity);
        return refreshTokenEntity;
    }
    /**
     * Helper function to generate an `AuthenticationResult` for the result.
     * @param request
     * @param idTokenObj
     * @param cacheRecord
     * @param authority
     * @returns `AuthenticationResult`
     */ generateAuthenticationResult(request, cacheRecord, idTokenClaims, authority) {
        let accessToken = "";
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        if (cacheRecord?.accessToken) {
            accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $4b6dd2fbafb9509d$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
            extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
        }
        const accountEntity = cacheRecord.account;
        return {
            authority: authority ? authority.canonicalAuthority : "",
            uniqueId: cacheRecord.account.localAccountId,
            tenantId: cacheRecord.account.realm,
            scopes: responseScopes,
            account: accountEntity.getAccountInfo(),
            idToken: cacheRecord.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: true,
            expiresOn: expiresOn,
            correlationId: request.correlationId || "",
            requestId: "",
            extExpiresOn: extExpiresOn,
            familyId: cacheRecord.refreshToken?.familyId || "",
            tokenType: cacheRecord?.accessToken?.tokenType || "",
            state: request.state || "",
            cloudGraphHostName: accountEntity.cloudGraphHostName || "",
            msGraphHost: accountEntity.msGraphHost || "",
            fromNativeBroker: false
        };
    }
}






/*! @azure/msal-browser v3.27.0 2024-11-05 */ 



/*! @azure/msal-browser v3.27.0 2024-11-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $010486793c5b40b6$export$a2dbbd28e9bce542 extends (0, $746b08a1f35844e9$export$8538731fd397fb90) {
    constructor(config){
        super(config);
        this.includeRedirectUri = false;
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $e033d6ae1b81e676$export$d7f5ef311b3e9fca extends (0, $aed111b4f4b5e49c$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeMessageHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId);
        this.apiId = apiId;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */ async acquireToken(request) {
        // Auth code payload is required
        if (!request.code) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$e502d98cd8d2da43));
        // Create silent request
        const silentRequest = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(request, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent);
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        try {
            // Create auth code request (PKCE not needed)
            const authCodeRequest = {
                ...silentRequest,
                code: request.code
            };
            // Initialize the client
            const clientConfig = await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            const authClient = new (0, $010486793c5b40b6$export$a2dbbd28e9bce542)(clientConfig);
            this.logger.verbose("Auth code client created");
            // Create silent handler
            const interactionHandler = new (0, $4936d5fa007125a3$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Handle auth code parameters from request
            return await (0, $ae433257996980ce$export$e4feded94d9adb18)(interactionHandler.handleCodeResponseFromServer.bind(interactionHandler), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)({
                code: request.code,
                msgraph_host: request.msGraphHost,
                cloud_graph_host_name: request.cloudGraphHostName,
                cloud_instance_host_name: request.cloudInstanceHostName
            }, silentRequest, false);
        } catch (e) {
            if (e instanceof (0, $40da14d5d49dd285$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$78523a40be105a03)));
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $cd807d71d92cbc47$var$getAccountType(account) {
    const idTokenClaims = account?.idTokenClaims;
    if (idTokenClaims?.tfp || idTokenClaims?.acr) return "B2C";
    if (!idTokenClaims?.tid) return undefined;
    else if (idTokenClaims?.tid === "9188040d-6c67-4c5b-b112-36a304b66dad") return "MSA";
    return "AAD";
}
function $cd807d71d92cbc47$var$preflightCheck(initialized, performanceEvent) {
    try {
        (0, $d618406b813d26cc$export$4dd091cbdc98b52e)(initialized);
    } catch (e) {
        performanceEvent.end({
            success: false
        }, e);
        throw e;
    }
}
class $cd807d71d92cbc47$export$e9d1ef1cb8705404 {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */ constructor(operatingContext){
        this.operatingContext = operatingContext;
        this.isBrowserEnvironment = this.operatingContext.isBrowserEnvironment();
        // Set the configuration.
        this.config = operatingContext.getConfig();
        this.initialized = false;
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = this.isBrowserEnvironment ? new (0, $e9cd6ef4fe15cd8f$export$c274a7f0ebd24b14)(this.logger, this.performanceClient) : (0, $90930effaee4b5bc$export$865f57d401606752);
        this.eventHandler = new (0, $6e3e6e48bbae04d4$export$ce0ba2422a1c7815)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ? new (0, $da45ac276c7992ff$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, (0, $2d706f1a340b3c1d$export$2b9ebf6f25078cc0)(this.config.auth), this.performanceClient) : (0, $da45ac276c7992ff$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger);
        // initialize in memory storage for native flows
        const nativeCacheOptions = {
            cacheLocation: (0, $e195f599725a9f25$export$573384e47a12d835).MemoryStorage,
            temporaryCacheLocation: (0, $e195f599725a9f25$export$573384e47a12d835).MemoryStorage,
            storeAuthStateInCookie: false,
            secureCookies: false,
            cacheMigrationEnabled: false,
            claimsBasedCachingEnabled: false
        };
        this.nativeInternalStorage = new (0, $da45ac276c7992ff$export$44d7291b5c8cc149)(this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger, undefined, this.performanceClient);
        // Initialize the token cache
        this.tokenCache = new (0, $ea3e574c1faff6dc$export$ed5d1a18907a1001)(this.config, this.browserStorage, this.logger, this.browserCrypto);
        this.activeSilentTokenRequests = new Map();
        // Register listener functions
        this.trackPageVisibility = this.trackPageVisibility.bind(this);
        // Register listener functions
        this.trackPageVisibilityWithMeasurement = this.trackPageVisibilityWithMeasurement.bind(this);
        // account storage events
        this.listeningToStorageEvents = false;
        this.handleAccountCacheChange = this.handleAccountCacheChange.bind(this);
    }
    static async createController(operatingContext, request) {
        const controller = new $cd807d71d92cbc47$export$e9d1ef1cb8705404(operatingContext);
        await controller.initialize(request);
        return controller;
    }
    trackPageVisibility(correlationId) {
        if (!correlationId) return;
        this.logger.info("Perf: Visibility change detected");
        this.performanceClient.incrementFields({
            visibilityChangeCount: 1
        }, correlationId);
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest} correlation id
     */ async initialize(request) {
        this.logger.trace("initialize called");
        if (this.initialized) {
            this.logger.info("initialize has already been called, exiting early.");
            return;
        }
        if (!this.isBrowserEnvironment) {
            this.logger.info("in non-browser environment, exiting early.");
            this.initialized = true;
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).INITIALIZE_END);
            return;
        }
        const initCorrelationId = request?.correlationId || this.getRequestCorrelationId();
        const allowNativeBroker = this.config.system.allowNativeBroker;
        const initMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).InitializeClientApplication, initCorrelationId);
        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).INITIALIZE_START);
        if (allowNativeBroker) try {
            this.nativeExtensionProvider = await (0, $dd55ff53bd487fbc$export$c98888b8059e2702).createProvider(this.logger, this.config.system.nativeBrokerHandshakeTimeout, this.performanceClient);
        } catch (e) {
            this.logger.verbose(e);
        }
        if (!this.config.cache.claimsBasedCachingEnabled) {
            this.logger.verbose("Claims-based caching is disabled. Clearing the previous cache with claims");
            await (0, $ae433257996980ce$export$e4feded94d9adb18)(this.browserStorage.clearTokensAndKeysWithClaims.bind(this.browserStorage), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims, this.logger, this.performanceClient, initCorrelationId)(this.performanceClient, initCorrelationId);
        }
        this.initialized = true;
        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).INITIALIZE_END);
        initMeasurement.end({
            allowNativeBroker: allowNativeBroker,
            success: true
        });
    }
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ async handleRedirectPromise(hash) {
        this.logger.verbose("handleRedirectPromise called");
        // Block token acquisition before initialize has been called
        (0, $d618406b813d26cc$export$630119c5db8b5529)(this.initialized);
        if (this.isBrowserEnvironment) {
            /**
             * Store the promise on the PublicClientApplication instance if this is the first invocation of handleRedirectPromise,
             * otherwise return the promise from the first invocation. Prevents race conditions when handleRedirectPromise is called
             * several times concurrently.
             */ const redirectResponseKey = hash || "";
            let response = this.redirectResponse.get(redirectResponseKey);
            if (typeof response === "undefined") {
                response = this.handleRedirectPromiseInternal(hash);
                this.redirectResponse.set(redirectResponseKey, response);
                this.logger.verbose("handleRedirectPromise has been called for the first time, storing the promise");
            } else this.logger.verbose("handleRedirectPromise has been called previously, returning the result from the first call");
            return response;
        }
        this.logger.verbose("handleRedirectPromise returns null, not browser environment");
        return null;
    }
    /**
     * The internal details of handleRedirectPromise. This is separated out to a helper to allow handleRedirectPromise to memoize requests
     * @param hash
     * @returns
     */ async handleRedirectPromiseInternal(hash) {
        const loggedInAccounts = this.getAllAccounts();
        const request = this.browserStorage.getCachedNativeRequest();
        const useNative = request && (0, $dd55ff53bd487fbc$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider) && this.nativeExtensionProvider && !hash;
        const correlationId = useNative ? request?.correlationId : this.browserStorage.getTemporaryCache((0, $e195f599725a9f25$export$21d55bedf0d269fb).CORRELATION_ID, true) || "";
        const rootMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenRedirect, correlationId);
        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).HANDLE_REDIRECT_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect);
        let redirectResponse;
        if (useNative && this.nativeExtensionProvider) {
            this.logger.trace("handleRedirectPromise - acquiring token from native platform");
            const nativeClient = new (0, $97e72655060ed469$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $e195f599725a9f25$export$192d74ad69b40705).handleRedirectPromise, this.performanceClient, this.nativeExtensionProvider, request.accountId, this.nativeInternalStorage, request.correlationId);
            redirectResponse = (0, $ae433257996980ce$export$e4feded94d9adb18)(nativeClient.handleRedirectPromise.bind(nativeClient), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).HandleNativeRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(this.performanceClient, rootMeasurement.event.correlationId);
        } else {
            this.logger.trace("handleRedirectPromise - acquiring token from web flow");
            const redirectClient = this.createRedirectClient(correlationId);
            redirectResponse = (0, $ae433257996980ce$export$e4feded94d9adb18)(redirectClient.handleRedirectPromise.bind(redirectClient), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).HandleRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(hash, rootMeasurement);
        }
        return redirectResponse.then((result)=>{
            if (result) {
                // Emit login event if number of accounts change
                const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
                if (isLoggingIn) {
                    this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect, result);
                    this.logger.verbose("handleRedirectResponse returned result, login success");
                } else {
                    this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect, result);
                    this.logger.verbose("handleRedirectResponse returned result, acquire token success");
                }
                rootMeasurement.end({
                    success: true,
                    accountType: $cd807d71d92cbc47$var$getAccountType(result.account)
                });
            } else /*
                 * Instrument an event only if an error code is set. Otherwise, discard it when the redirect response
                 * is empty and the error code is missing.
                 */ if (rootMeasurement.event.errorCode) rootMeasurement.end({
                success: false
            });
            else rootMeasurement.discard();
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect);
            return result;
        }).catch((e)=>{
            const eventError = e;
            // Emit login event if there is an account
            if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect, null, eventError);
            else this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGIN_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect, null, eventError);
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect);
            rootMeasurement.end({
                success: false
            }, eventError);
            throw e;
        });
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async acquireTokenRedirect(request) {
        // Preflight request
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("acquireTokenRedirect called", correlationId);
        const atrMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenPreRedirect, correlationId);
        atrMeasurement.add({
            accountType: $cd807d71d92cbc47$var$getAccountType(request.account),
            scenarioId: request.scenarioId
        });
        // Override on request only if set, as onRedirectNavigate field is deprecated
        const onRedirectNavigateCb = request.onRedirectNavigate;
        if (onRedirectNavigateCb) request.onRedirectNavigate = (url)=>{
            const navigate = typeof onRedirectNavigateCb === "function" ? onRedirectNavigateCb(url) : undefined;
            if (navigate !== false) atrMeasurement.end({
                success: true
            });
            else atrMeasurement.discard();
            return navigate;
        };
        else {
            const configOnRedirectNavigateCb = this.config.auth.onRedirectNavigate;
            this.config.auth.onRedirectNavigate = (url)=>{
                const navigate = typeof configOnRedirectNavigateCb === "function" ? configOnRedirectNavigateCb(url) : undefined;
                if (navigate !== false) atrMeasurement.end({
                    success: true
                });
                else atrMeasurement.discard();
                return navigate;
            };
        }
        // If logged in, emit acquire token events
        const isLoggedIn = this.getAllAccounts().length > 0;
        try {
            (0, $d618406b813d26cc$export$62c8f4fdca4df60f)(this.initialized, this.config);
            this.browserStorage.setInteractionInProgress(true);
            if (isLoggedIn) this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect, request);
            else this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGIN_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect, request);
            let result;
            if (this.nativeExtensionProvider && this.canUseNative(request)) {
                const nativeClient = new (0, $97e72655060ed469$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenRedirect, this.performanceClient, this.nativeExtensionProvider, this.getNativeAccountId(request), this.nativeInternalStorage, correlationId);
                result = nativeClient.acquireTokenRedirect(request, atrMeasurement).catch((e)=>{
                    if (e instanceof (0, $928aa5124c222013$export$4b8a4f6256e840ab) && (0, $928aa5124c222013$export$f21e42e365baeb50)(e)) {
                        this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    } else if (e instanceof (0, $b3acdb9c5805a543$export$6ba3e818c6bc76ba)) {
                        this.logger.verbose("acquireTokenRedirect - Resolving interaction required error thrown by native broker by falling back to web flow");
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    }
                    this.browserStorage.setInteractionInProgress(false);
                    throw e;
                });
            } else {
                const redirectClient = this.createRedirectClient(correlationId);
                result = redirectClient.acquireToken(request);
            }
            return await result;
        } catch (e) {
            atrMeasurement.end({
                success: false
            }, e);
            if (isLoggedIn) this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect, null, e);
            else this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGIN_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Redirect, null, e);
            throw e;
        }
    }
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenPopup, correlationId);
        atPopupMeasurement.add({
            scenarioId: request.scenarioId,
            accountType: $cd807d71d92cbc47$var$getAccountType(request.account)
        });
        try {
            this.logger.verbose("acquireTokenPopup called", correlationId);
            $cd807d71d92cbc47$var$preflightCheck(this.initialized, atPopupMeasurement);
            this.browserStorage.setInteractionInProgress(true);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        const loggedInAccounts = this.getAllAccounts();
        if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, request);
        else this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGIN_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, request);
        let result;
        if (this.canUseNative(request)) result = this.acquireTokenNative({
            ...request,
            correlationId: correlationId
        }, (0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenPopup).then((response)=>{
            this.browserStorage.setInteractionInProgress(false);
            atPopupMeasurement.end({
                success: true,
                isNativeBroker: true,
                accountType: $cd807d71d92cbc47$var$getAccountType(response.account)
            });
            return response;
        }).catch((e)=>{
            if (e instanceof (0, $928aa5124c222013$export$4b8a4f6256e840ab) && (0, $928aa5124c222013$export$f21e42e365baeb50)(e)) {
                this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                const popupClient = this.createPopupClient(correlationId);
                return popupClient.acquireToken(request);
            } else if (e instanceof (0, $b3acdb9c5805a543$export$6ba3e818c6bc76ba)) {
                this.logger.verbose("acquireTokenPopup - Resolving interaction required error thrown by native broker by falling back to web flow");
                const popupClient = this.createPopupClient(correlationId);
                return popupClient.acquireToken(request);
            }
            this.browserStorage.setInteractionInProgress(false);
            throw e;
        });
        else {
            const popupClient = this.createPopupClient(correlationId);
            result = popupClient.acquireToken(request);
        }
        return result.then((result)=>{
            /*
             *  If logged in, emit acquire token events
             */ const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            if (isLoggingIn) this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, result);
            else this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.end({
                success: true,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length,
                accountType: $cd807d71d92cbc47$var$getAccountType(result.account)
            });
            return result;
        }).catch((e)=>{
            if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, null, e);
            else this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).LOGIN_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e);
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        });
    }
    trackPageVisibilityWithMeasurement() {
        const measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) return;
        this.logger.info("Perf: Visibility change detected in ", measurement.event.name);
        measurement.increment({
            visibilityChangeCount: 1
        });
    }
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async ssoSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const validRequest = {
            ...request,
            // will be PromptValue.NONE or PromptValue.NO_SESSION
            prompt: request.prompt,
            correlationId: correlationId
        };
        this.ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SsoSilent, correlationId);
        this.ssoSilentMeasurement?.add({
            scenarioId: request.scenarioId,
            accountType: $cd807d71d92cbc47$var$getAccountType(request.account)
        });
        $cd807d71d92cbc47$var$preflightCheck(this.initialized, this.ssoSilentMeasurement);
        this.ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0
        });
        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        this.logger.verbose("ssoSilent called", correlationId);
        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).SSO_SILENT_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, validRequest);
        let result;
        if (this.canUseNative(validRequest)) result = this.acquireTokenNative(validRequest, (0, $e195f599725a9f25$export$192d74ad69b40705).ssoSilent).catch((e)=>{
            // If native token acquisition fails for availability reasons fallback to standard flow
            if (e instanceof (0, $928aa5124c222013$export$4b8a4f6256e840ab) && (0, $928aa5124c222013$export$f21e42e365baeb50)(e)) {
                this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                return silentIframeClient.acquireToken(validRequest);
            }
            throw e;
        });
        else {
            const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
            result = silentIframeClient.acquireToken(validRequest);
        }
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).SSO_SILENT_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, response);
            this.ssoSilentMeasurement?.end({
                success: true,
                isNativeBroker: response.fromNativeBroker,
                accessTokenSize: response.accessToken.length,
                idTokenSize: response.idToken.length,
                accountType: $cd807d71d92cbc47$var$getAccountType(response.account)
            });
            return response;
        }).catch((e)=>{
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).SSO_SILENT_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, null, e);
            this.ssoSilentMeasurement?.end({
                success: false
            }, e);
            throw e;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        });
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenByCode(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("acquireTokenByCode called", correlationId);
        const atbcMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenByCode, correlationId);
        $cd807d71d92cbc47$var$preflightCheck(this.initialized, atbcMeasurement);
        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, request);
        atbcMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            if (request.code && request.nativeAccountId) // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
            throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$1efb009e9d75bbe4));
            else if (request.code) {
                const hybridAuthCode = request.code;
                let response = this.hybridAuthCodeResponses.get(hybridAuthCode);
                if (!response) {
                    this.logger.verbose("Initiating new acquireTokenByCode request", correlationId);
                    response = this.acquireTokenByCodeAsync({
                        ...request,
                        correlationId: correlationId
                    }).then((result)=>{
                        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, result);
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        atbcMeasurement.end({
                            success: true,
                            isNativeBroker: result.fromNativeBroker,
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length,
                            accountType: $cd807d71d92cbc47$var$getAccountType(result.account)
                        });
                        return result;
                    }).catch((error)=>{
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, null, error);
                        atbcMeasurement.end({
                            success: false
                        }, error);
                        throw error;
                    });
                    this.hybridAuthCodeResponses.set(hybridAuthCode, response);
                } else {
                    this.logger.verbose("Existing acquireTokenByCode request found", correlationId);
                    atbcMeasurement.discard();
                }
                return await response;
            } else if (request.nativeAccountId) {
                if (this.canUseNative(request, request.nativeAccountId)) {
                    const result = await this.acquireTokenNative({
                        ...request,
                        correlationId: correlationId
                    }, (0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenByCode, request.nativeAccountId).catch((e)=>{
                        // If native token acquisition fails for availability reasons fallback to standard flow
                        if (e instanceof (0, $928aa5124c222013$export$4b8a4f6256e840ab) && (0, $928aa5124c222013$export$f21e42e365baeb50)(e)) this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        throw e;
                    });
                    atbcMeasurement.end({
                        accountType: $cd807d71d92cbc47$var$getAccountType(result.account),
                        success: true
                    });
                    return result;
                } else throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$b897bbe2c683def2));
            } else throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$8bea68053103eaeb));
        } catch (e) {
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, null, e);
            atbcMeasurement.end({
                success: false
            }, e);
            throw e;
        }
    }
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */ async acquireTokenByCodeAsync(request) {
        this.logger.trace("acquireTokenByCodeAsync called", request.correlationId);
        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenByCodeAsync, request.correlationId);
        this.acquireTokenByCodeAsyncMeasurement?.increment({
            visibilityChangeCount: 0
        });
        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        const silentAuthCodeClient = this.createSilentAuthCodeClient(request.correlationId);
        const silentTokenResult = await silentAuthCodeClient.acquireToken(request).then((response)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: true,
                fromCache: response.fromCache,
                isNativeBroker: response.fromNativeBroker
            });
            return response;
        }).catch((tokenRenewalError)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: false
            }, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        });
        return silentTokenResult;
    }
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenFromCache(commonRequest, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenFromCache, commonRequest.correlationId);
        switch(cacheLookupPolicy){
            case (0, $e195f599725a9f25$export$4394baa7e922d42d).Default:
            case (0, $e195f599725a9f25$export$4394baa7e922d42d).AccessToken:
            case (0, $e195f599725a9f25$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                const silentCacheClient = this.createSilentCacheClient(commonRequest.correlationId);
                return (0, $ae433257996980ce$export$e4feded94d9adb18)(silentCacheClient.acquireToken.bind(silentCacheClient), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$exports).tokenRefreshRequired);
        }
    }
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param cacheLookupPolicy CacheLookupPolicy
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenByRefreshToken(commonRequest, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, commonRequest.correlationId);
        switch(cacheLookupPolicy){
            case (0, $e195f599725a9f25$export$4394baa7e922d42d).Default:
            case (0, $e195f599725a9f25$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
            case (0, $e195f599725a9f25$export$4394baa7e922d42d).RefreshToken:
            case (0, $e195f599725a9f25$export$4394baa7e922d42d).RefreshTokenAndNetwork:
                const silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                return (0, $ae433257996980ce$export$e4feded94d9adb18)(silentRefreshClient.acquireToken.bind(silentRefreshClient), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$exports).tokenRefreshRequired);
        }
    }
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenBySilentIframe(request) {
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, request.correlationId);
        const silentIframeClient = this.createSilentIframeClient(request.correlationId);
        return (0, $ae433257996980ce$export$e4feded94d9adb18)(silentIframeClient.acquireToken.bind(silentIframeClient), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(request);
    }
    // #endregion
    // #region Logout
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ async logout(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        this.logger.warning("logout API is deprecated and will be removed in msal-browser v3.0.0. Use logoutRedirect instead.", correlationId);
        return this.logoutRedirect({
            correlationId: correlationId,
            ...logoutRequest
        });
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logoutRedirect(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        (0, $d618406b813d26cc$export$62c8f4fdca4df60f)(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true);
        const redirectClient = this.createRedirectClient(correlationId);
        return redirectClient.logout(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        try {
            const correlationId = this.getRequestCorrelationId(logoutRequest);
            (0, $d618406b813d26cc$export$4dd091cbdc98b52e)(this.initialized);
            this.browserStorage.setInteractionInProgress(true);
            const popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Creates a cache interaction client to clear broswer cache.
     * @param logoutRequest
     */ async clearCache(logoutRequest) {
        if (!this.isBrowserEnvironment) {
            this.logger.info("in non-browser environment, returning early.");
            return;
        }
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        const cacheClient = this.createSilentCacheClient(correlationId);
        return cacheClient.logout(logoutRequest);
    }
    // #endregion
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return (0, $4c2e647a07f06969$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnvironment, accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return (0, $4c2e647a07f06969$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ getAccountByUsername(username) {
        return (0, $4c2e647a07f06969$export$d915baf55d86927d)(username, this.logger, this.browserStorage);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ getAccountByHomeId(homeAccountId) {
        return (0, $4c2e647a07f06969$export$d6fa7d1e8099998e)(homeAccountId, this.logger, this.browserStorage);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ getAccountByLocalId(localAccountId) {
        return (0, $4c2e647a07f06969$export$7ac8aa09fdf78340)(localAccountId, this.logger, this.browserStorage);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        (0, $4c2e647a07f06969$export$c55c3d25cf1bcd99)(account, this.browserStorage);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return (0, $4c2e647a07f06969$export$13dd2e33a23839ad)(this.browserStorage);
    }
    // #endregion
    /**
     * Hydrates the cache with the tokens from an AuthenticationResult
     * @param result
     * @param request
     * @returns
     */ async hydrateCache(result, request) {
        this.logger.verbose("hydrateCache called");
        // Account gets saved to browser storage regardless of native or not
        const accountEntity = (0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).createFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        this.browserStorage.setAccount(accountEntity);
        if (result.fromNativeBroker) {
            this.logger.verbose("Response was from native broker, storing in-memory");
            // Tokens from native broker are stored in-memory
            return this.nativeInternalStorage.hydrateCache(result, request);
        } else return this.browserStorage.hydrateCache(result, request);
    }
    // #region Helpers
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     */ async acquireTokenNative(request, apiId, accountId) {
        this.logger.trace("acquireTokenNative called");
        if (!this.nativeExtensionProvider) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$7b7357e3538624aa));
        const nativeClient = new (0, $97e72655060ed469$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.nativeExtensionProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, request.correlationId);
        return nativeClient.acquireToken(request);
    }
    /**
     * Returns boolean indicating if this request can use the native broker
     * @param request
     */ canUseNative(request, accountId) {
        this.logger.trace("canUseNative called");
        if (!(0, $dd55ff53bd487fbc$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, request.authenticationScheme)) {
            this.logger.trace("canUseNative: isNativeAvailable returned false, returning false");
            return false;
        }
        if (request.prompt) switch(request.prompt){
            case (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).NONE:
            case (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).CONSENT:
            case (0, $e6f7ad11e10d0573$export$49a06cbda5acaa5).LOGIN:
                this.logger.trace("canUseNative: prompt is compatible with native flow");
                break;
            default:
                this.logger.trace(`canUseNative: prompt = ${request.prompt} is not compatible with native flow, returning false`);
                return false;
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("canUseNative: nativeAccountId is not available, returning false");
            return false;
        }
        return true;
    }
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */ getNativeAccountId(request) {
        const account = request.account || this.getAccount({
            loginHint: request.loginHint,
            sid: request.sid
        }) || this.getActiveAccount();
        return account && account.nativeAccountId || "";
    }
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */ createPopupClient(correlationId) {
        return new (0, $f5521de3a2025a38$export$43b0fce132d066f4)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */ createRedirectClient(correlationId) {
        return new (0, $f53e47f571a14d67$export$a368977effbc1ed6)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */ createSilentIframeClient(correlationId) {
        return new (0, $7d014bebb8aad3ae$export$e81c7938bccef977)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $e195f599725a9f25$export$192d74ad69b40705).ssoSilent, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */ createSilentCacheClient(correlationId) {
        return new (0, $4194ab35f2873fab$export$59d4f873ee62d01e)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */ createSilentRefreshClient(correlationId) {
        return new (0, $a3d2e2498f5dacc0$export$b4a36596822a5d2)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */ createSilentAuthCodeClient(correlationId) {
        return new (0, $e033d6ae1b81e676$export$d7f5ef311b3e9fca)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenByCode, this.performanceClient, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        (0, $d618406b813d26cc$export$c7939bfe92ae2787)();
        return this.performanceClient.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    }
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ enableAccountStorageEvents() {
        if (typeof window === "undefined") return;
        if (!this.listeningToStorageEvents) {
            this.logger.verbose("Adding account storage listener.");
            this.listeningToStorageEvents = true;
            window.addEventListener("storage", this.handleAccountCacheChange);
        } else this.logger.verbose("Account storage listener already registered.");
    }
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ disableAccountStorageEvents() {
        if (typeof window === "undefined") return;
        if (this.listeningToStorageEvents) {
            this.logger.verbose("Removing account storage listener.");
            window.removeEventListener("storage", this.handleAccountCacheChange);
            this.listeningToStorageEvents = false;
        } else this.logger.verbose("No account storage listener registered.");
    }
    /**
     * Emit account added/removed events when cached accounts are changed in a different tab or frame
     */ handleAccountCacheChange(e) {
        try {
            // Handle active account filter change
            if (e.key?.includes((0, $e6f7ad11e10d0573$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS)) // This event has no payload, it only signals cross-tab app instances that the results of calling getActiveAccount() will have changed
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACTIVE_ACCOUNT_CHANGED);
            // Handle account object change
            const cacheValue = e.newValue || e.oldValue;
            if (!cacheValue) return;
            const parsedValue = JSON.parse(cacheValue);
            if (typeof parsedValue !== "object" || !(0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).isAccountEntity(parsedValue)) return;
            const accountEntity = (0, $4d3b9129094dcedd$export$996e3ea69314b5c6).toObject(new (0, $cdcf39a9eb0ff797$export$680160523e6bfa6a)(), parsedValue);
            const accountInfo = accountEntity.getAccountInfo();
            if (!e.oldValue && e.newValue) {
                this.logger.info("Account was added to cache in a different window");
                this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACCOUNT_ADDED, undefined, accountInfo);
            } else if (!e.newValue && e.oldValue) {
                this.logger.info("Account was removed from cache in a different window");
                this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACCOUNT_REMOVED, undefined, accountInfo);
            }
        } catch (e) {
            return;
        }
    }
    /**
     * Gets the token cache for the application.
     */ getTokenCache() {
        return this.tokenCache;
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.navigationClient = navigationClient;
    }
    /**
     * Returns the configuration object
     */ getConfiguration() {
        return this.config;
    }
    /**
     * Returns the performance client
     */ getPerformanceClient() {
        return this.performanceClient;
    }
    /**
     * Returns the browser env indicator
     */ isBrowserEnv() {
        return this.isBrowserEnvironment;
    }
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */ getRequestCorrelationId(request) {
        if (request?.correlationId) return request.correlationId;
        if (this.isBrowserEnvironment) return (0, $a65ce7794137937d$export$6ef0355fa80a5278)();
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */ return (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING;
    }
    // #endregion
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async loginRedirect(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginRedirect called", correlationId);
        return this.acquireTokenRedirect({
            correlationId: correlationId,
            ...request || (0, $e195f599725a9f25$export$7e12949cd6884193)
        });
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginPopup called", correlationId);
        return this.acquireTokenPopup({
            correlationId: correlationId,
            ...request || (0, $e195f599725a9f25$export$7e12949cd6884193)
        });
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */ async acquireTokenSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atsMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenSilent, correlationId);
        atsMeasurement.add({
            cacheLookupPolicy: request.cacheLookupPolicy,
            scenarioId: request.scenarioId
        });
        $cd807d71d92cbc47$var$preflightCheck(this.initialized, atsMeasurement);
        this.logger.verbose("acquireTokenSilent called", correlationId);
        const account = request.account || this.getActiveAccount();
        if (!account) throw (0, $1eca0489e18862c6$export$72f7b48f3bc1d4cb)((0, $8e6ba27e37631a08$export$87933d7d4116cb12));
        atsMeasurement.add({
            accountType: $cd807d71d92cbc47$var$getAccountType(account)
        });
        const thumbprint = {
            clientId: this.config.auth.clientId,
            authority: request.authority || (0, $e6f7ad11e10d0573$export$a002182e51710d39).EMPTY_STRING,
            scopes: request.scopes,
            homeAccountIdentifier: account.homeAccountId,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid,
            shrOptions: request.shrOptions
        };
        const silentRequestKey = JSON.stringify(thumbprint);
        const cachedResponse = this.activeSilentTokenRequests.get(silentRequestKey);
        if (typeof cachedResponse === "undefined") {
            this.logger.verbose("acquireTokenSilent called for the first time, storing active request", correlationId);
            const response = (0, $ae433257996980ce$export$e4feded94d9adb18)(this.acquireTokenSilentAsync.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenSilentAsync, this.logger, this.performanceClient, correlationId)({
                ...request,
                correlationId: correlationId
            }, account).then((result)=>{
                this.activeSilentTokenRequests.delete(silentRequestKey);
                atsMeasurement.end({
                    success: true,
                    fromCache: result.fromCache,
                    isNativeBroker: result.fromNativeBroker,
                    cacheLookupPolicy: request.cacheLookupPolicy,
                    accessTokenSize: result.accessToken.length,
                    idTokenSize: result.idToken.length
                });
                return result;
            }).catch((error)=>{
                this.activeSilentTokenRequests.delete(silentRequestKey);
                atsMeasurement.end({
                    success: false
                }, error);
                throw error;
            });
            this.activeSilentTokenRequests.set(silentRequestKey, response);
            return {
                ...await response,
                state: request.state
            };
        } else {
            this.logger.verbose("acquireTokenSilent has been called previously, returning the result from the first call", correlationId);
            // Discard measurements for memoized calls, as they are usually only a couple of ms and will artificially deflate metrics
            atsMeasurement.discard();
            return {
                ...await cachedResponse,
                state: request.state
            };
        }
    }
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */ async acquireTokenSilentAsync(request, account) {
        const trackPageVisibility = ()=>this.trackPageVisibility(request.correlationId);
        this.performanceClient.addQueueMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenSilentAsync, request.correlationId);
        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, request);
        if (request.correlationId) this.performanceClient.incrementFields({
            visibilityChangeCount: 0
        }, request.correlationId);
        document.addEventListener("visibilitychange", trackPageVisibility);
        const silentRequest = await (0, $ae433257996980ce$export$e4feded94d9adb18)((0, $5f86e728968c03f1$export$4c8aa78c426811d4), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).InitializeSilentRequest, this.logger, this.performanceClient, request.correlationId)(request, account, this.config, this.performanceClient, this.logger);
        const cacheLookupPolicy = request.cacheLookupPolicy || (0, $e195f599725a9f25$export$4394baa7e922d42d).Default;
        const result = this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy).catch(async (refreshTokenError)=>{
            const shouldTryToResolveSilently = $cd807d71d92cbc47$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy);
            if (shouldTryToResolveSilently) {
                if (!this.activeIframeRequest) {
                    let _resolve;
                    // Always set the active request tracker immediately after checking it to prevent races
                    this.activeIframeRequest = [
                        new Promise((resolve)=>{
                            _resolve = resolve;
                        }),
                        silentRequest.correlationId
                    ];
                    this.logger.verbose("Refresh token expired/invalid or CacheLookupPolicy is set to Skip, attempting acquire token by iframe.", silentRequest.correlationId);
                    return (0, $ae433257996980ce$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest).then((iframeResult)=>{
                        _resolve(true);
                        return iframeResult;
                    }).catch((e)=>{
                        _resolve(false);
                        throw e;
                    }).finally(()=>{
                        this.activeIframeRequest = undefined;
                    });
                } else if (cacheLookupPolicy !== (0, $e195f599725a9f25$export$4394baa7e922d42d).Skip) {
                    const [activePromise, activeCorrelationId] = this.activeIframeRequest;
                    this.logger.verbose(`Iframe request is already in progress, awaiting resolution for request with correlationId: ${activeCorrelationId}`, silentRequest.correlationId);
                    const awaitConcurrentIframeMeasure = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AwaitConcurrentIframe, silentRequest.correlationId);
                    awaitConcurrentIframeMeasure.add({
                        awaitIframeCorrelationId: activeCorrelationId
                    });
                    const activePromiseResult = await activePromise;
                    awaitConcurrentIframeMeasure.end({
                        success: activePromiseResult
                    });
                    if (activePromiseResult) {
                        this.logger.verbose(`Parallel iframe request with correlationId: ${activeCorrelationId} succeeded. Retrying cache and/or RT redemption`, silentRequest.correlationId);
                        // Retry cache lookup and/or RT exchange after iframe completes
                        return this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy);
                    } else {
                        this.logger.info(`Iframe request with correlationId: ${activeCorrelationId} failed. Interaction is required.`);
                        // If previous iframe request failed, it's unlikely to succeed this time. Throw original error.
                        throw refreshTokenError;
                    }
                } else {
                    // Cache policy set to skip and another iframe request is already in progress
                    this.logger.warning("Another iframe request is currently in progress and CacheLookupPolicy is set to Skip. This may result in degraded performance and/or reliability for both calls. Please consider changing the CacheLookupPolicy to take advantage of request queuing and token cache.", silentRequest.correlationId);
                    return (0, $ae433257996980ce$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
                }
            } else // Error cannot be silently resolved or iframe renewal is not allowed, interaction required
            throw refreshTokenError;
        });
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, response);
            if (request.correlationId) this.performanceClient.addFields({
                fromCache: response.fromCache,
                isNativeBroker: response.fromNativeBroker
            }, request.correlationId);
            return response;
        }).catch((tokenRenewalError)=>{
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, null, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", trackPageVisibility);
        });
    }
    /**
     * AcquireTokenSilent without the iframe fallback. This is used to enable the correct fallbacks in cases where there's a potential for multiple silent requests to be made in parallel and prevent those requests from making concurrent iframe requests.
     * @param silentRequest
     * @param cacheLookupPolicy
     * @returns
     */ async acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy) {
        if ((0, $dd55ff53bd487fbc$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, silentRequest.authenticationScheme) && silentRequest.account.nativeAccountId) {
            this.logger.verbose("acquireTokenSilent - attempting to acquire token from native platform");
            return this.acquireTokenNative(silentRequest, (0, $e195f599725a9f25$export$192d74ad69b40705).acquireTokenSilent_silentFlow).catch(async (e)=>{
                // If native token acquisition fails for availability reasons fallback to web flow
                if (e instanceof (0, $928aa5124c222013$export$4b8a4f6256e840ab) && (0, $928aa5124c222013$export$f21e42e365baeb50)(e)) {
                    this.logger.verbose("acquireTokenSilent - native platform unavailable, falling back to web flow");
                    this.nativeExtensionProvider = undefined; // Prevent future requests from continuing to attempt
                    // Cache will not contain tokens, given that previous WAM requests succeeded. Skip cache and RT renewal and go straight to iframe renewal
                    throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$exports).tokenRefreshRequired);
                }
                throw e;
            });
        } else {
            this.logger.verbose("acquireTokenSilent - attempting to acquire token from web flow");
            return (0, $ae433257996980ce$export$e4feded94d9adb18)(this.acquireTokenFromCache.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenFromCache, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy).catch((cacheError)=>{
                if (cacheLookupPolicy === (0, $e195f599725a9f25$export$4394baa7e922d42d).AccessToken) throw cacheError;
                this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_NETWORK_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, silentRequest);
                return (0, $ae433257996980ce$export$e4feded94d9adb18)(this.acquireTokenByRefreshToken.bind(this), (0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy);
            });
        }
    }
}
/**
 * Determines whether an error thrown by the refresh token endpoint can be resolved without interaction
 * @param refreshTokenError
 * @param silentRequest
 * @param cacheLookupPolicy
 * @returns
 */ function $cd807d71d92cbc47$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy) {
    const noInteractionRequired = !(refreshTokenError instanceof (0, $b3acdb9c5805a543$export$6ba3e818c6bc76ba) && // For refresh token errors, bad_token does not always require interaction (silently resolvable)
    refreshTokenError.subError !== (0, $0da9c4dbbd48f7df$exports).badToken);
    // Errors that result when the refresh token needs to be replaced
    const refreshTokenRefreshRequired = refreshTokenError.errorCode === (0, $e195f599725a9f25$export$a0a689e4294b9880).INVALID_GRANT_ERROR || refreshTokenError.errorCode === (0, $e3d0d7a1f8aeb2d2$exports).tokenRefreshRequired;
    // Errors that may be resolved before falling back to interaction (through iframe renewal)
    const isSilentlyResolvable = noInteractionRequired && refreshTokenRefreshRequired || refreshTokenError.errorCode === (0, $0da9c4dbbd48f7df$exports).noTokensFound || refreshTokenError.errorCode === (0, $0da9c4dbbd48f7df$exports).refreshTokenExpired;
    // Only these policies allow for an iframe renewal attempt
    const tryIframeRenewal = (0, $e195f599725a9f25$export$736180706fb122ee).includes(cacheLookupPolicy);
    return isSilentlyResolvable && tryIframeRenewal;
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 
/*! @azure/msal-browser v3.27.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $02bb8bdc1d7da072$export$caa3bc10e51dd7ee(error) {
    return error.status !== undefined;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $461b426ab3a2ac42$export$cee94b20506f02aa {
    constructor(clientId, clientCapabilities, crypto, logger){
        this.clientId = clientId;
        this.clientCapabilities = clientCapabilities;
        this.crypto = crypto;
        this.logger = logger;
    }
    toNaaTokenRequest(request) {
        let extraParams;
        if (request.extraQueryParameters === undefined) extraParams = new Map();
        else extraParams = new Map(Object.entries(request.extraQueryParameters));
        const correlationId = request.correlationId || this.crypto.createNewGuid();
        const requestBuilder = new (0, $e395f42fea42ad84$export$882078dd8a9e0bfa)(correlationId);
        const claims = requestBuilder.addClientCapabilitiesToClaims(request.claims, this.clientCapabilities);
        const scopes = request.scopes || (0, $e6f7ad11e10d0573$export$893b1b5b686d84ef);
        const tokenRequest = {
            platformBrokerId: request.account?.homeAccountId,
            clientId: this.clientId,
            authority: request.authority,
            scope: scopes.join(" "),
            correlationId: correlationId,
            claims: !(0, $2b520034dd7719a3$export$ecc754f99843e759).isEmptyObj(claims) ? claims : undefined,
            state: request.state,
            authenticationScheme: request.authenticationScheme || (0, $e6f7ad11e10d0573$export$901491a717da2ba5).BEARER,
            extraParameters: extraParams
        };
        return tokenRequest;
    }
    fromNaaTokenResponse(request, response, reqTimestamp) {
        if (!response.token.id_token || !response.token.access_token) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$exports).nullOrEmptyToken);
        const expiresOn = new Date((reqTimestamp + (response.token.expires_in || 0)) * 1000);
        const idTokenClaims = (0, $dbb12b3851d257af$exports).extractTokenClaims(response.token.id_token, this.crypto.base64Decode);
        const account = this.fromNaaAccountInfo(response.account, response.token.id_token, idTokenClaims);
        const scopes = response.token.scope || request.scope;
        const authenticationResult = {
            authority: response.token.authority || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: response.token.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: response.token.access_token,
            fromCache: false,
            expiresOn: expiresOn,
            tokenType: request.authenticationScheme || (0, $e6f7ad11e10d0573$export$901491a717da2ba5).BEARER,
            correlationId: request.correlationId,
            extExpiresOn: expiresOn,
            state: request.state
        };
        return authenticationResult;
    }
    /*
     *  export type AccountInfo = {
     *     homeAccountId: string;
     *     environment: string;
     *     tenantId: string;
     *     username: string;
     *     localAccountId: string;
     *     name?: string;
     *     idToken?: string;
     *     idTokenClaims?: TokenClaims & {
     *         [key: string]:
     *             | string
     *             | number
     *             | string[]
     *             | object
     *             | undefined
     *             | unknown;
     *     };
     *     nativeAccountId?: string;
     *     authorityType?: string;
     * };
     */ fromNaaAccountInfo(fromAccount, idToken, idTokenClaims) {
        const effectiveIdTokenClaims = idTokenClaims || fromAccount.idTokenClaims;
        const localAccountId = fromAccount.localAccountId || effectiveIdTokenClaims?.oid || effectiveIdTokenClaims?.sub || "";
        const tenantId = fromAccount.tenantId || effectiveIdTokenClaims?.tid || "";
        const homeAccountId = fromAccount.homeAccountId || `${localAccountId}.${tenantId}`;
        const username = fromAccount.username || effectiveIdTokenClaims?.preferred_username || "";
        const name = fromAccount.name || effectiveIdTokenClaims?.name;
        const tenantProfiles = new Map();
        const tenantProfile = (0, $11db744279a82a57$export$924857724cb21ba4)(homeAccountId, localAccountId, tenantId, effectiveIdTokenClaims);
        tenantProfiles.set(tenantId, tenantProfile);
        const account = {
            homeAccountId: homeAccountId,
            environment: fromAccount.environment,
            tenantId: tenantId,
            username: username,
            localAccountId: localAccountId,
            name: name,
            idToken: idToken,
            idTokenClaims: effectiveIdTokenClaims,
            tenantProfiles: tenantProfiles
        };
        return account;
    }
    /**
     *
     * @param error BridgeError
     * @returns AuthError, ClientAuthError, ClientConfigurationError, ServerError, InteractionRequiredError
     */ fromBridgeError(error) {
        if ((0, $02bb8bdc1d7da072$export$caa3bc10e51dd7ee)(error)) switch(error.status){
            case (0, $c0438d21313a8fee$export$6d05f68c12a46a00).UserCancel:
                return new (0, $054a0a060cbfdbdc$export$a839ff85a7957561)((0, $e3d0d7a1f8aeb2d2$exports).userCanceled);
            case (0, $c0438d21313a8fee$export$6d05f68c12a46a00).NoNetwork:
                return new (0, $054a0a060cbfdbdc$export$a839ff85a7957561)((0, $e3d0d7a1f8aeb2d2$exports).noNetworkConnectivity);
            case (0, $c0438d21313a8fee$export$6d05f68c12a46a00).AccountUnavailable:
                return new (0, $054a0a060cbfdbdc$export$a839ff85a7957561)((0, $e3d0d7a1f8aeb2d2$exports).noAccountFound);
            case (0, $c0438d21313a8fee$export$6d05f68c12a46a00).Disabled:
                return new (0, $054a0a060cbfdbdc$export$a839ff85a7957561)((0, $e3d0d7a1f8aeb2d2$exports).nestedAppAuthBridgeDisabled);
            case (0, $c0438d21313a8fee$export$6d05f68c12a46a00).NestedAppAuthUnavailable:
                return new (0, $054a0a060cbfdbdc$export$a839ff85a7957561)(error.code || (0, $e3d0d7a1f8aeb2d2$exports).nestedAppAuthBridgeDisabled, error.description);
            case (0, $c0438d21313a8fee$export$6d05f68c12a46a00).TransientError:
            case (0, $c0438d21313a8fee$export$6d05f68c12a46a00).PersistentError:
                return new (0, $0463942371f4715f$export$ea52035eac03daf0)(error.code, error.description);
            case (0, $c0438d21313a8fee$export$6d05f68c12a46a00).UserInteractionRequired:
                return new (0, $b3acdb9c5805a543$export$6ba3e818c6bc76ba)(error.code, error.description);
            default:
                return new (0, $40da14d5d49dd285$export$145273558d58e0ac)(error.code, error.description);
        }
        else return new (0, $40da14d5d49dd285$export$145273558d58e0ac)("unknown_error", "An unknown error occurred");
    }
    /**
     * Returns an AuthenticationResult from the given cache items
     *
     * @param account
     * @param idToken
     * @param accessToken
     * @param reqTimestamp
     * @returns
     */ toAuthenticationResultFromCache(account, idToken, accessToken, request, correlationId) {
        if (!idToken || !accessToken) throw (0, $054a0a060cbfdbdc$export$ea892ce48f5bb4f3)((0, $e3d0d7a1f8aeb2d2$exports).nullOrEmptyToken);
        const idTokenClaims = (0, $dbb12b3851d257af$exports).extractTokenClaims(idToken.secret, this.crypto.base64Decode);
        const scopes = accessToken.target || request.scopes.join(" ");
        const authenticationResult = {
            authority: accessToken.environment || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: idToken.secret,
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken.secret,
            fromCache: true,
            expiresOn: new Date(Number(accessToken.expiresOn) * 1000),
            tokenType: request.authenticationScheme || (0, $e6f7ad11e10d0573$export$901491a717da2ba5).BEARER,
            correlationId: correlationId,
            extExpiresOn: new Date(Number(accessToken.extendedExpiresOn) * 1000),
            state: request.state
        };
        return authenticationResult;
    }
}


/*! @azure/msal-browser v3.27.0 2024-11-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * NestedAppAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $f91aaeae87653dd3$export$81a70490e660273a = {
    unsupportedMethod: {
        code: "unsupported_method",
        desc: "This method is not supported in nested app environment."
    }
};
class $f91aaeae87653dd3$export$7c79ceb488783308 extends (0, $40da14d5d49dd285$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        Object.setPrototypeOf(this, $f91aaeae87653dd3$export$7c79ceb488783308.prototype);
        this.name = "NestedAppAuthError";
    }
    static createUnsupportedError() {
        return new $f91aaeae87653dd3$export$7c79ceb488783308($f91aaeae87653dd3$export$81a70490e660273a.unsupportedMethod.code, $f91aaeae87653dd3$export$81a70490e660273a.unsupportedMethod.desc);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $aa49789510d7a065$export$2319deb182e38ab3 {
    constructor(operatingContext){
        this.operatingContext = operatingContext;
        const proxy = this.operatingContext.getBridgeProxy();
        if (proxy !== undefined) this.bridgeProxy = proxy;
        else throw new Error("unexpected: bridgeProxy is undefined");
        // Set the configuration.
        this.config = operatingContext.getConfig();
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = operatingContext.isBrowserEnvironment() ? new (0, $e9cd6ef4fe15cd8f$export$c274a7f0ebd24b14)(this.logger, this.performanceClient) : (0, $90930effaee4b5bc$export$865f57d401606752);
        // Initialize the browser storage class.
        this.browserStorage = this.operatingContext.isBrowserEnvironment() ? new (0, $da45ac276c7992ff$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, (0, $2d706f1a340b3c1d$export$2b9ebf6f25078cc0)(this.config.auth)) : (0, $da45ac276c7992ff$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger);
        this.eventHandler = new (0, $6e3e6e48bbae04d4$export$ce0ba2422a1c7815)(this.logger);
        this.nestedAppAuthAdapter = new (0, $461b426ab3a2ac42$export$cee94b20506f02aa)(this.config.auth.clientId, this.config.auth.clientCapabilities, this.browserCrypto, this.logger);
        // Set the active account if available
        const accountContext = this.bridgeProxy.getAccountContext();
        if (accountContext) {
            const cachedAccount = (0, $4c2e647a07f06969$export$4f9234baf34abd0)(accountContext, this.logger, this.browserStorage);
            (0, $4c2e647a07f06969$export$c55c3d25cf1bcd99)(cachedAccount, this.browserStorage);
        }
    }
    /**
     * Factory function to create a new instance of NestedAppAuthController
     * @param operatingContext
     * @returns Promise<IController>
     */ static async createController(operatingContext) {
        const controller = new $aa49789510d7a065$export$2319deb182e38ab3(operatingContext);
        return Promise.resolve(controller);
    }
    /**
     * Specific implementation of initialize function for NestedAppAuthController
     * @returns
     */ initialize() {
        // do nothing not required by this controller
        return Promise.resolve();
    }
    /**
     * Validate the incoming request and add correlationId if not present
     * @param request
     * @returns
     */ ensureValidRequest(request) {
        if (request?.correlationId) return request;
        return {
            ...request,
            correlationId: this.browserCrypto.createNewGuid()
        };
    }
    /**
     * Internal implementation of acquireTokenInteractive flow
     * @param request
     * @returns
     */ async acquireTokenInteractive(request) {
        const validRequest = this.ensureValidRequest(request);
        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, validRequest);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenPopup, validRequest.correlationId);
        atPopupMeasurement?.add({
            nestedAppAuthRequest: true
        });
        try {
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = (0, $ac7fb5ae1cae46f5$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenInteractive(naaRequest);
            const result = {
                ...this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp)
            };
            // cache the tokens in the response
            await this.hydrateCache(result, request);
            this.browserStorage.setActiveAccount(result.account);
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.end({
                success: true,
                requestId: result.requestId
            });
            return result;
        } catch (e) {
            const error = this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e);
            throw error;
        }
    }
    /**
     * Internal implementation of acquireTokenSilent flow
     * @param request
     * @returns
     */ async acquireTokenSilentInternal(request) {
        const validRequest = this.ensureValidRequest(request);
        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, validRequest);
        // Look for tokens in the cache first
        const result = await this.acquireTokenFromCache(validRequest);
        if (result) {
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, result);
            return result;
        }
        // proceed with acquiring tokens via the host
        const ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).SsoSilent, validRequest.correlationId);
        ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0
        });
        ssoSilentMeasurement?.add({
            nestedAppAuthRequest: true
        });
        try {
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = (0, $ac7fb5ae1cae46f5$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenSilent(naaRequest);
            const result = this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp);
            // cache the tokens in the response
            await this.hydrateCache(result, request);
            this.browserStorage.setActiveAccount(result.account);
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, result);
            ssoSilentMeasurement?.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            ssoSilentMeasurement?.end({
                success: true,
                requestId: result.requestId
            });
            return result;
        } catch (e) {
            const error = this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, null, e);
            ssoSilentMeasurement?.end({
                success: false
            }, e);
            throw error;
        }
    }
    /**
     * acquires tokens from cache
     * @param request
     * @returns
     */ async acquireTokenFromCache(request) {
        const atsMeasurement = this.performanceClient.startMeasurement((0, $e68ee78dfc615f65$export$2f2811a3e1b21823).AcquireTokenSilent, request.correlationId);
        atsMeasurement?.add({
            nestedAppAuthRequest: true
        });
        // if the request has claims, we cannot look up in the cache
        if (request.claims) {
            this.logger.verbose("Claims are present in the request, skipping cache lookup");
            return null;
        }
        // respect cache lookup policy
        let result = null;
        switch(request.cacheLookupPolicy){
            case (0, $e195f599725a9f25$export$4394baa7e922d42d).Default:
            case (0, $e195f599725a9f25$export$4394baa7e922d42d).AccessToken:
            case (0, $e195f599725a9f25$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                result = await this.acquireTokenFromCacheInternal(request);
                break;
            default:
                return null;
        }
        if (result) {
            this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, result);
            atsMeasurement?.add({
                accessTokenSize: result?.accessToken.length,
                idTokenSize: result?.idToken.length
            });
            atsMeasurement?.end({
                success: true
            });
            return result;
        }
        this.logger.error("Cached tokens are not found for the account, proceeding with silent token request.");
        this.eventHandler.emitEvent((0, $77ca9fc57e3aa1cd$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $e195f599725a9f25$export$4ec29255e7e7f68f).Silent, null);
        atsMeasurement?.end({
            success: false
        });
        return null;
    }
    /**
     *
     * @param request
     * @returns
     */ async acquireTokenFromCacheInternal(request) {
        const accountContext = this.bridgeProxy.getAccountContext();
        let currentAccount = null;
        if (accountContext) {
            const hubAccount = (0, $4c2e647a07f06969$export$4f9234baf34abd0)(accountContext, this.logger, this.browserStorage);
            // always prioritize for hub account context, the reqirement of `request.account` will be removed soon
            currentAccount = hubAccount || request.account;
        }
        // fall back to brokering if no cached account is found
        if (!currentAccount) {
            this.logger.verbose("No active account found, falling back to the host");
            return Promise.resolve(null);
        }
        this.logger.verbose("active account found, attempting to acquire token silently");
        const authRequest = {
            ...request,
            correlationId: request.correlationId || this.browserCrypto.createNewGuid(),
            authority: request.authority || currentAccount.environment,
            scopes: request.scopes?.length ? request.scopes : [
                ...(0, $e6f7ad11e10d0573$export$893b1b5b686d84ef)
            ]
        };
        // fetch access token and check for expiry
        const tokenKeys = this.browserStorage.getTokenKeys();
        const cachedAccessToken = this.browserStorage.getAccessToken(currentAccount, authRequest, tokenKeys, currentAccount.tenantId, this.performanceClient, authRequest.correlationId);
        // If there is no access token, log it and return null
        if (!cachedAccessToken) {
            this.logger.verbose("No cached access token found");
            return Promise.resolve(null);
        } else if ((0, $ac7fb5ae1cae46f5$exports).wasClockTurnedBack(cachedAccessToken.cachedAt) || (0, $ac7fb5ae1cae46f5$exports).isTokenExpired(cachedAccessToken.expiresOn, this.config.system.tokenRenewalOffsetSeconds)) {
            this.logger.verbose("Cached access token has expired");
            return Promise.resolve(null);
        }
        const cachedIdToken = this.browserStorage.getIdToken(currentAccount, tokenKeys, currentAccount.tenantId, this.performanceClient, authRequest.correlationId);
        if (!cachedIdToken) {
            this.logger.verbose("No cached id token found");
            return Promise.resolve(null);
        }
        return this.nestedAppAuthAdapter.toAuthenticationResultFromCache(currentAccount, cachedIdToken, cachedAccessToken, authRequest, authRequest.correlationId);
    }
    /**
     * acquireTokenPopup flow implementation
     * @param request
     * @returns
     */ async acquireTokenPopup(request) {
        return this.acquireTokenInteractive(request);
    }
    /**
     * acquireTokenRedirect flow is not supported in nested app auth
     * @param request
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    acquireTokenRedirect(request) {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenSilent flow implementation
     * @param silentRequest
     * @returns
     */ async acquireTokenSilent(silentRequest) {
        return this.acquireTokenSilentInternal(silentRequest);
    }
    /**
     * Hybrid flow is not currently supported in nested app auth
     * @param request
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    acquireTokenByCode(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenNative flow is not currently supported in nested app auth
     * @param request
     * @param apiId
     * @param accountId
     */ acquireTokenNative(request, apiId, accountId // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenByRefreshToken flow is not currently supported in nested app auth
     * @param commonRequest
     * @param silentRequest
     */ acquireTokenByRefreshToken(commonRequest, silentRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addPerformanceCallback(callback) {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removePerformanceCallback(callbackId) {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    enableAccountStorageEvents() {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    disableAccountStorageEvents() {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return (0, $4c2e647a07f06969$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnv(), accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return (0, $4c2e647a07f06969$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ getAccountByUsername(username) {
        return (0, $4c2e647a07f06969$export$d915baf55d86927d)(username, this.logger, this.browserStorage);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ getAccountByHomeId(homeAccountId) {
        return (0, $4c2e647a07f06969$export$d6fa7d1e8099998e)(homeAccountId, this.logger, this.browserStorage);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ getAccountByLocalId(localAccountId) {
        return (0, $4c2e647a07f06969$export$7ac8aa09fdf78340)(localAccountId, this.logger, this.browserStorage);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        /*
         * StandardController uses this to allow the developer to set the active account
         * in the nested app auth scenario the active account is controlled by the app hosting the nested app
         */ return (0, $4c2e647a07f06969$export$c55c3d25cf1bcd99)(account, this.browserStorage);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return (0, $4c2e647a07f06969$export$13dd2e33a23839ad)(this.browserStorage);
    }
    // #endregion
    handleRedirectPromise(hash // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return Promise.resolve(null);
    }
    loginPopup(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return this.acquireTokenInteractive(request || (0, $e195f599725a9f25$export$7e12949cd6884193));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loginRedirect(request) {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    logout(logoutRequest) {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    logoutRedirect(logoutRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    logoutPopup(logoutRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    ssoSilent(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    request) {
        return this.acquireTokenSilentInternal(request);
    }
    getTokenCache() {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initializeWrapperLibrary(sku, version) {
        /*
         * Standard controller uses this to set the sku and version of the wrapper library in the storage
         * we do nothing here
         */ return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setNavigationClient(navigationClient) {
        this.logger.warning("setNavigationClient is not supported in nested app auth");
    }
    getConfiguration() {
        return this.config;
    }
    isBrowserEnv() {
        return this.operatingContext.isBrowserEnvironment();
    }
    getBrowserCrypto() {
        return this.browserCrypto;
    }
    getPerformanceClient() {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    getRedirectResponse() {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async clearCache(logoutRequest) {
        throw (0, $f91aaeae87653dd3$export$7c79ceb488783308).createUnsupportedError();
    }
    async hydrateCache(result, request) {
        this.logger.verbose("hydrateCache called");
        const accountEntity = (0, $cdcf39a9eb0ff797$export$680160523e6bfa6a).createFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        this.browserStorage.setAccount(accountEntity);
        return this.browserStorage.hydrateCache(result, request);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $0bc32a0024d552f4$export$414d5e42be8c56db(config, request) {
    const standard = new (0, $471b8a333094f1b0$export$f39c23bbfed89e6e)(config);
    await standard.initialize();
    return (0, $cd807d71d92cbc47$export$e9d1ef1cb8705404).createController(standard, request);
}
async function $0bc32a0024d552f4$export$6a1d744b364856f2(config) {
    const standard = new (0, $471b8a333094f1b0$export$f39c23bbfed89e6e)(config);
    const nestedApp = new (0, $75a4a94a21a3562a$export$a2170d4e3f010950)(config);
    const operatingContexts = [
        standard.initialize(),
        nestedApp.initialize()
    ];
    await Promise.all(operatingContexts);
    if (nestedApp.isAvailable() && config.auth.supportsNestedAppAuth) return (0, $aa49789510d7a065$export$2319deb182e38ab3).createController(nestedApp);
    else if (standard.isAvailable()) return (0, $cd807d71d92cbc47$export$e9d1ef1cb8705404).createController(standard);
    else // Since neither of the actual operating contexts are available keep the UnknownOperatingContextController
    return null;
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */ class $3dfa5970eb2f3b70$export$89f4855ef88b7920 {
    /**
     * Creates StandardController and passes it to the PublicClientApplication
     *
     * @param configuration {Configuration}
     */ static async createPublicClientApplication(configuration) {
        const controller = await (0, $0bc32a0024d552f4$export$414d5e42be8c56db)(configuration);
        const pca = new $3dfa5970eb2f3b70$export$89f4855ef88b7920(configuration, controller);
        return pca;
    }
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     * @param IController Optional parameter to explictly set the controller. (Will be removed when we remove public constructor)
     */ constructor(configuration, controller){
        this.controller = controller || new (0, $cd807d71d92cbc47$export$e9d1ef1cb8705404)(new (0, $471b8a333094f1b0$export$f39c23bbfed89e6e)(configuration));
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest}
     */ async initialize(request) {
        return this.controller.initialize(request);
    }
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopup(request) {
        return this.controller.acquireTokenPopup(request);
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ acquireTokenRedirect(request) {
        return this.controller.acquireTokenRedirect(request);
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthenticationResult} object
     */ acquireTokenSilent(silentRequest) {
        return this.controller.acquireTokenSilent(silentRequest);
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenByCode(request) {
        return this.controller.acquireTokenByCode(request);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.controller.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        return this.controller.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        return this.controller.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.controller.removePerformanceCallback(callbackId);
    }
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ enableAccountStorageEvents() {
        this.controller.enableAccountStorageEvents();
    }
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ disableAccountStorageEvents() {
        this.controller.disableAccountStorageEvents();
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return this.controller.getAccount(accountFilter);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByHomeId(homeAccountId) {
        return this.controller.getAccountByHomeId(homeAccountId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByLocalId(localId) {
        return this.controller.getAccountByLocalId(localId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param userName
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByUsername(userName) {
        return this.controller.getAccountByUsername(userName);
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return this.controller.getAllAccounts(accountFilter);
    }
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ handleRedirectPromise(hash) {
        return this.controller.handleRedirectPromise(hash);
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        return this.controller.loginPopup(request);
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ loginRedirect(request) {
        return this.controller.loginRedirect(request);
    }
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ logout(logoutRequest) {
        return this.controller.logout(logoutRequest);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ logoutRedirect(logoutRequest) {
        return this.controller.logoutRedirect(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        return this.controller.logoutPopup(logoutRequest);
    }
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ssoSilent(request) {
        return this.controller.ssoSilent(request);
    }
    /**
     * Gets the token cache for the application.
     */ getTokenCache() {
        return this.controller.getTokenCache();
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.controller.getLogger();
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.controller.setLogger(logger);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        this.controller.setActiveAccount(account);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return this.controller.getActiveAccount();
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        return this.controller.initializeWrapperLibrary(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.controller.setNavigationClient(navigationClient);
    }
    /**
     * Returns the configuration object
     * @internal
     */ getConfiguration() {
        return this.controller.getConfiguration();
    }
    /**
     * Hydrates cache with the tokens and account in the AuthenticationResult object
     * @param result
     * @param request - The request object that was used to obtain the AuthenticationResult
     * @returns
     */ async hydrateCache(result, request) {
        return this.controller.hydrateCache(result, request);
    }
    /**
     * Clears tokens and account from the browser cache.
     * @param logoutRequest
     */ clearCache(logoutRequest) {
        return this.controller.clearCache(logoutRequest);
    }
}
/**
 * creates NestedAppAuthController and passes it to the PublicClientApplication,
 * falls back to StandardController if NestedAppAuthController is not available
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $3dfa5970eb2f3b70$export$210078d2745a65ac(configuration) {
    const nestedAppAuth = new (0, $75a4a94a21a3562a$export$a2170d4e3f010950)(configuration);
    await nestedAppAuth.initialize();
    if (nestedAppAuth.isAvailable()) {
        const controller = new (0, $aa49789510d7a065$export$2319deb182e38ab3)(nestedAppAuth);
        return new $3dfa5970eb2f3b70$export$89f4855ef88b7920(configuration, controller);
    }
    return $3dfa5970eb2f3b70$export$f28b97cfb2f3098(configuration);
}
/**
 * creates PublicClientApplication using StandardController
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $3dfa5970eb2f3b70$export$f28b97cfb2f3098(configuration) {
    const pca = new $3dfa5970eb2f3b70$export$89f4855ef88b7920(configuration);
    await pca.initialize();
    return pca;
}










// CLASS
class $d8878d388f85091d$export$62297b13309008b2 extends (0, $fb5c76ea4d5e5718$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $8630c9f98862ab2d$export$1cf3d545f2d4635c);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $d8878d388f85091d$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === 'idle') this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $1d7761b76a987a77$export$17619bac5b909b23)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $1d7761b76a987a77$export$8793edee2d425525)).catch((0, $1d7761b76a987a77$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $1d7761b76a987a77$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== 'idle') {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $1d7761b76a987a77$export$382ca5d13a8f252c)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, 'signal', {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $29b83148ec7584f6$export$986cc6445c1d323)(error) && error.silent)) this.dispatch({
                type: 'error',
                error: error
            });
            if (!(0, $29b83148ec7584f6$export$986cc6445c1d323)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $29b83148ec7584f6$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === 'undefined') {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: 'failed',
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: 'pause'
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        fetchStatus: 'paused'
                    };
                case 'continue':
                    return {
                        ...state,
                        fetchStatus: 'fetching'
                    };
                case 'fetch':
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $29b83148ec7584f6$export$61b92f63f30245cf)(this.options.networkMode) ? 'fetching' : 'paused',
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: 'loading'
                        }
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: 'success',
                        ...!action.manual && {
                            fetchStatus: 'idle',
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case 'error':
                    const error = action.error;
                    if ((0, $29b83148ec7584f6$export$986cc6445c1d323)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: 'idle'
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: 'idle',
                        status: 'error'
                    };
                case 'invalidate':
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: 'updated',
                action: action
            });
        });
    }
}
function $d8878d388f85091d$var$getDefaultState(options) {
    const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    const hasData = typeof data !== 'undefined';
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? 'success' : 'loading',
        fetchStatus: 'idle'
    };
}




// CLASS
class $c843a9da9e6d96ad$export$5dde0cd941da8468 extends (0, $eb937378799990eb$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $1d7761b76a987a77$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $d8878d388f85091d$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'added',
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'removed',
                query: query
            });
        }
    }
    clear() {
        (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $1d7761b76a987a77$export$18e8f4b987e6c111)(arg1, arg2);
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find((query)=>(0, $1d7761b76a987a77$export$c5d1efe363797780)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $1d7761b76a987a77$export$18e8f4b987e6c111)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $1d7761b76a987a77$export$c5d1efe363797780)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}






// CLASS
class $602d68800fffd372$export$1fcfd9a244434844 extends (0, $eb937378799990eb$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $df5a92fb88dabce5$export$17b8b19c814bcf56)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: 'added',
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: 'removed',
            mutation: mutation
        });
    }
    clear() {
        (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find((mutation)=>(0, $1d7761b76a987a77$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $1d7761b76a987a77$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $1d7761b76a987a77$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}





function $7157511072373f97$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, 'signal', {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener('abort', ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $7157511072373f97$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $7157511072373f97$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === 'undefined';
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $7157511072373f97$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $7157511072373f97$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $7157511072373f97$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $7157511072373f97$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $7157511072373f97$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $7157511072373f97$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $7157511072373f97$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



// CLASS
class $665c9368969a29d4$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $c843a9da9e6d96ad$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $602d68800fffd372$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $8630c9f98862ab2d$export$1cf3d545f2d4635c);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $6a3ffe6fec644043$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $6a3ffe6fec644043$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $6dfc6da5bc5d426c$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $6dfc6da5bc5d426c$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $1d7761b76a987a77$export$18e8f4b987e6c111)(arg1, arg2);
        filters.fetchStatus = 'fetching';
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $1d7761b76a987a77$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $1d7761b76a987a77$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === 'undefined') return undefined;
        const parsedOptions = (0, $1d7761b76a987a77$export$8a11fbc2c8ea08fd)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $1d7761b76a987a77$export$18e8f4b987e6c111)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $1d7761b76a987a77$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: 'active',
            ...filters
        };
        return (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $1d7761b76a987a77$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        const promises = (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $1d7761b76a987a77$export$8793edee2d425525)).catch((0, $1d7761b76a987a77$export$8793edee2d425525));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $1d7761b76a987a77$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        return (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === 'none') return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $1d7761b76a987a77$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const promises = (0, $fe9d89aed3961bcc$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $1d7761b76a987a77$export$8793edee2d425525));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $1d7761b76a987a77$export$8793edee2d425525));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $1d7761b76a987a77$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $1d7761b76a987a77$export$8793edee2d425525)).catch((0, $1d7761b76a987a77$export$8793edee2d425525));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $1d7761b76a987a77$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $7157511072373f97$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $1d7761b76a987a77$export$8793edee2d425525)).catch((0, $1d7761b76a987a77$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $1d7761b76a987a77$export$5fcb678681417b54)(queryKey) === (0, $1d7761b76a987a77$export$5fcb678681417b54)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $1d7761b76a987a77$export$2f07189bb9fa26a7)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $1d7761b76a987a77$export$5fcb678681417b54)(mutationKey) === (0, $1d7761b76a987a77$export$5fcb678681417b54)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $1d7761b76a987a77$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $1d7761b76a987a77$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === 'undefined') defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
        if (typeof defaultedOptions.useErrorBoundary === 'undefined') defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}


const $aa50afbb95a59241$var$container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const $aa50afbb95a59241$var$root = (0, $c38f6f64706945e9$export$882461b6382ed46c)($aa50afbb95a59241$var$container); // createRoot(container!) if you use TypeScript
const $aa50afbb95a59241$export$a59c2286a7150b12 = new (0, $3dfa5970eb2f3b70$export$89f4855ef88b7920)((0, $6489b9c55d9230bc$export$f6d610d2730cbf1a));
const $aa50afbb95a59241$export$388e0302ca0d9a41 = new (0, $665c9368969a29d4$export$405d0624ed55a03f)();
$aa50afbb95a59241$var$root.render(/*#__PURE__*/ (0, $bHJbJ.jsx)((0, $521e8490c894046d$export$25bac41dc3d78d47), {
    instance: $aa50afbb95a59241$export$a59c2286a7150b12,
    children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $09a29e98c9dccb10$export$45604f0cc8ae667b), {
        client: $aa50afbb95a59241$export$388e0302ca0d9a41,
        children: /*#__PURE__*/ (0, $bHJbJ.jsx)((0, $072df471fa573ff3$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=index.b6885eb2.js.map
